(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5e60"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5e60"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a0wAy", function(module, exports) {
"use strict";
var $74932edc3df00309$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $74932edc3df00309$var$assert_valid_user_options_1 = $74932edc3df00309$var$__importDefault((parcelRequire("cv2oO")));

const $74932edc3df00309$var$suggest_email_1 = $74932edc3df00309$var$__importDefault((parcelRequire("650gw")));

const $74932edc3df00309$var$get_options_1 = $74932edc3df00309$var$__importDefault((parcelRequire("govvj")));
function $74932edc3df00309$var$run(userOptions) {
    const options = $74932edc3df00309$var$get_options_1.default(userOptions);
    $74932edc3df00309$var$assert_valid_user_options_1.default(options || {});
    const email = $74932edc3df00309$var$suggest_email_1.default(options);
    if (!email && userOptions.empty) userOptions.empty();
    if (email && userOptions.suggested) userOptions.suggested(email);
    return email;
}
module.exports.default = $74932edc3df00309$var$run;

});
parcelRegister("cv2oO", function(module, exports) {
"use strict";
var $919a3db2c551336c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $919a3db2c551336c$var$assert_1 = $919a3db2c551336c$var$__importDefault((parcelRequire("7TNnJ")));
function $919a3db2c551336c$var$assertValidUserOptions(options) {
    $919a3db2c551336c$var$assert_1.default(Array.isArray(options.domains), "domains must be an array");
    $919a3db2c551336c$var$assert_1.default(Array.isArray(options.topLevelDomains), "topLevelDomains must be an array");
    $919a3db2c551336c$var$assert_1.default(Array.isArray(options.secondLevelDomains), "secondLevelDomains must be an array");
    $919a3db2c551336c$var$assert_1.default(typeof options.distanceFunction === "function", "distanceFunction must be a function");
}
module.exports.default = $919a3db2c551336c$var$assertValidUserOptions;

});
parcelRegister("7TNnJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $5c03f9a34c88bf60$var$assert(condition, message) {
    if (!condition) throw new Error(message);
}
module.exports.default = $5c03f9a34c88bf60$var$assert;

});


parcelRegister("650gw", function(module, exports) {
"use strict";
var $46d36a6c9036a2cf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $46d36a6c9036a2cf$var$encode_email_1 = $46d36a6c9036a2cf$var$__importDefault((parcelRequire("lmGZP")));

const $46d36a6c9036a2cf$var$find_closest_domain_1 = $46d36a6c9036a2cf$var$__importDefault((parcelRequire("ckyZ3")));

const $46d36a6c9036a2cf$var$parse_email_1 = $46d36a6c9036a2cf$var$__importDefault((parcelRequire("9t1RS")));
function $46d36a6c9036a2cf$var$suggestEmail(opts) {
    const encodedEmail = $46d36a6c9036a2cf$var$encode_email_1.default(opts.email.toLowerCase());
    const email = $46d36a6c9036a2cf$var$parse_email_1.default(encodedEmail);
    if (!email) return undefined;
    const { domains: domains, domainThreshold: domainThreshold, distanceFunction: distanceFunction, secondLevelDomains: secondLevelDomains, topLevelDomains: topLevelDomains } = opts;
    if (secondLevelDomains && topLevelDomains) {
        // If the email is a valid 2nd-level + top-level, do not suggest anything.
        // if (hasValidSecondLevelDomain(email) && hasValidTopLevelDomain(email)) {
        if (secondLevelDomains.indexOf(email.secondLevelDomain) !== -1 && topLevelDomains.indexOf(email.topLevelDomain) !== -1) return undefined;
    }
    let closestDomain = $46d36a6c9036a2cf$var$find_closest_domain_1.default({
        domain: email.domain,
        domains: domains,
        distanceFunction: distanceFunction,
        threshold: domainThreshold
    });
    if (closestDomain) {
        if (closestDomain == email.domain) // The email address exactly matches one of the supplied domains; do not return a suggestion.
        return undefined;
        else // The email address closely matches one of the supplied domains; return a suggestion
        return {
            address: email.address,
            domain: closestDomain,
            full: email.address + "@" + closestDomain
        };
    }
    // The email address does not closely match one of the supplied domains
    const closestSecondLevelDomain = $46d36a6c9036a2cf$var$find_closest_domain_1.default({
        domain: email.secondLevelDomain,
        domains: secondLevelDomains,
        distanceFunction: distanceFunction,
        threshold: opts.secondLevelThreshold
    });
    const closestTopLevelDomain = $46d36a6c9036a2cf$var$find_closest_domain_1.default({
        domain: email.topLevelDomain,
        domains: topLevelDomains,
        distanceFunction: distanceFunction,
        threshold: opts.topLevelThreshold
    });
    if (email.domain) {
        closestDomain = email.domain;
        let rtrn = false;
        if (closestSecondLevelDomain && closestSecondLevelDomain != email.secondLevelDomain) {
            // The email address may have a mispelled second-level domain; return a suggestion
            closestDomain = closestDomain.replace(email.secondLevelDomain, closestSecondLevelDomain);
            rtrn = true;
        }
        if (closestTopLevelDomain && closestTopLevelDomain != email.topLevelDomain && email.secondLevelDomain !== "") {
            // The email address may have a mispelled top-level domain; return a suggestion
            closestDomain = closestDomain.replace(new RegExp(email.topLevelDomain + "$"), closestTopLevelDomain);
            rtrn = true;
        }
        if (rtrn) return {
            address: email.address,
            domain: closestDomain,
            full: email.address + "@" + closestDomain
        };
    }
    /* The email address exactly matches one of the supplied domains, does not closely
     * match any domain and does not appear to simply have a mispelled top-level domain,
     * or is an invalid email address; do not return a suggestion.
     */ return undefined;
}
module.exports.default = $46d36a6c9036a2cf$var$suggestEmail;

});
parcelRegister("lmGZP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Encode the email address to prevent XSS but leave in valid
// characters, following this official spec:
// http://en.wikipedia.org/wiki/Email_address#Syntax
//
// We have to replace all the possible characters.
// that's why we use a regex with a global flag.
function $f8dd0139eedf5d7d$var$encodeEmail(email) {
    const result = encodeURI(email).replace(/%20/g, " ").replace(/%25/g, "%").replace(/%5E/g, "^").replace(/%60/g, "`").replace(/%7B/g, "{").replace(/%7C/g, "|").replace(/%7D/g, "}");
    return result;
}
module.exports.default = $f8dd0139eedf5d7d$var$encodeEmail;

});

parcelRegister("ckyZ3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $8fa27d5525cd8627$var$findClosestDomain(opts) {
    const { domain: domain, domains: domains, distanceFunction: distanceFunction, threshold: threshold } = opts;
    let dist;
    let minDist = Infinity;
    let closestDomain = null;
    if (!domain || !domains) return undefined;
    for(let i = 0; i < domains.length; i++){
        if (domain === domains[i]) return domain;
        dist = distanceFunction(domain, domains[i]);
        if (dist < minDist) {
            minDist = dist;
            closestDomain = domains[i];
        }
    }
    if (minDist <= threshold && closestDomain !== null) return closestDomain;
    else return undefined;
}
module.exports.default = $8fa27d5525cd8627$var$findClosestDomain;

});

parcelRegister("9t1RS", function(module, exports) {
"use strict";
var $6e48456bfcb6797e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $6e48456bfcb6797e$var$trim_1 = $6e48456bfcb6797e$var$__importDefault((parcelRequire("lVMoU")));
const $6e48456bfcb6797e$var$MINIUM_EMAIL_PARTS = 2;
function $6e48456bfcb6797e$var$parseEmail(emailStr) {
    const email = $6e48456bfcb6797e$var$trim_1.default(emailStr);
    const parts = email.split("@");
    if (parts.length < $6e48456bfcb6797e$var$MINIUM_EMAIL_PARTS) return false;
    for(let i = 0; i < parts.length; i++){
        if (parts[i] === "") return false;
    }
    // FYI, in hello@example.com
    // secondLevelDomain -> example
    // topLevelDomain -> com
    let sld = "";
    let tld = "";
    const domain = parts.pop();
    const domainParts = domain.split(".");
    if (domainParts.length === 0) // The address does not have a top-level domain
    return false;
    else if (domainParts.length == 1) // The address has only a top-level domain (valid under RFC)
    tld = domainParts[0];
    else {
        // The address has a domain and a top-level domain
        sld = domainParts[0];
        for(let j = 1; j < domainParts.length; j++)tld += domainParts[j] + ".";
        tld = tld.substring(0, tld.length - 1);
    }
    return {
        topLevelDomain: tld,
        secondLevelDomain: sld,
        domain: domain,
        address: parts.join("@")
    };
}
module.exports.default = $6e48456bfcb6797e$var$parseEmail;

});
parcelRegister("lVMoU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $ff74773f4c6f32fc$var$WHITESPACE_PATTERN = /\s/;
/**
 * Just in case a browser doesn't support .trim
 * Copied from https://github.com/Trott/trim
 * Credits to them
 */ function $ff74773f4c6f32fc$var$trim(str) {
    if (str.trim) return str.trim();
    return $ff74773f4c6f32fc$var$right($ff74773f4c6f32fc$var$left(str));
}
function $ff74773f4c6f32fc$var$left(str) {
    if (str.trimLeft) return str.trimLeft();
    return str.replace(/^\s\s*/, "");
}
function $ff74773f4c6f32fc$var$right(str) {
    if (str.trimRight) return str.trimRight();
    let i = str.length;
    while($ff74773f4c6f32fc$var$WHITESPACE_PATTERN.test(str.charAt(--i)));
    return str.slice(0, i + 1);
}
module.exports.default = $ff74773f4c6f32fc$var$trim;

});



parcelRegister("govvj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fiVNL = parcelRequire("fiVNL");
function $bef7534d9f3ca6b6$var$getOptions(userOptions) {
    return {
        email: userOptions.email,
        domains: userOptions.domains || $fiVNL.DEFAULT_CONFIG.domains,
        topLevelDomains: userOptions.topLevelDomains || $fiVNL.DEFAULT_CONFIG.topLevelDomains,
        secondLevelDomains: userOptions.secondLevelDomains || $fiVNL.DEFAULT_CONFIG.secondLevelDomains,
        distanceFunction: userOptions.distanceFunction || $fiVNL.DEFAULT_CONFIG.distanceFunction,
        domainThreshold: userOptions.domainThreshold || $fiVNL.DEFAULT_CONFIG.domainThreshold,
        secondLevelThreshold: userOptions.secondLevelThreshold || $fiVNL.DEFAULT_CONFIG.secondLevelThreshold,
        topLevelThreshold: userOptions.topLevelThreshold || $fiVNL.DEFAULT_CONFIG.topLevelThreshold,
        suggested: userOptions.suggested || undefined,
        empty: userOptions.suggested || undefined
    };
}
module.exports.default = $bef7534d9f3ca6b6$var$getOptions;

});
parcelRegister("fiVNL", function(module, exports) {
"use strict";
// Default configuration options
var $b2455fa6b1aa8cf7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.POPULAR_TLDS = module.exports.POPULAR_DOMAINS = module.exports.DEFAULT_CONFIG = void 0;

const $b2455fa6b1aa8cf7$var$sift3_distance_1 = $b2455fa6b1aa8cf7$var$__importDefault((parcelRequire("8vprt")));
/***
 * Default list of popular emails for 2022 and onwards.
 * https://www.mailmunch.com/blog/best-email-service-providers
 *
 * If you find a domain you want to add, please submit a PR.
 * Also, notice that this list is not exhaustive.
 * You can always pass your own list of domains.
 */ const $b2455fa6b1aa8cf7$var$POPULAR_DOMAINS = [
    "msn.com",
    "bellsouth.net",
    "telus.net",
    "comcast.net",
    "optusnet.com.au",
    "earthlink.net",
    "qq.com",
    "sky.com",
    "icloud.com",
    "sympatico.ca",
    "googlemail.com",
    "att.net",
    "xtra.co.nz",
    "web.de",
    "cox.net",
    "gmail.com",
    "ymail.com",
    "aim.com",
    "rogers.com",
    "verizon.net",
    "rocketmail.com",
    "optonline.net",
    "sbcglobal.net",
    // aol
    "aol.com",
    "aim.com",
    "me.com",
    "mailw.com",
    "btinternet.com",
    "charter.net",
    "shaw.ca",
    "hey.com",
    // Proton
    "proton.me",
    "pm.com",
    "protonmail.com",
    "zoho.com",
    "yandex.com",
    "titan.email"
];
module.exports.POPULAR_DOMAINS = $b2455fa6b1aa8cf7$var$POPULAR_DOMAINS;
const $b2455fa6b1aa8cf7$var$POPULAR_TLDS = [
    "com",
    "com.au",
    "com.tw",
    "co",
    "ca",
    "co.nz",
    "co.uk",
    "de",
    "fr",
    "it",
    "ru",
    "org",
    "edu",
    "gov",
    "jp",
    "nl",
    "kr",
    "se",
    "eu",
    "ie",
    "co.il",
    "us",
    "at",
    "be",
    "dk",
    "hk",
    "es",
    "gr",
    "ch",
    "no",
    "cz",
    "net",
    "net.au",
    "info",
    "biz",
    "mil",
    "co.jp",
    "sg",
    "hu",
    "uk",
    "sk",
    // Country specific popular domains
    "ar",
    "cf",
    "cl",
    "cn",
    "ga",
    "gq",
    "ir",
    "ml",
    "mx",
    "nu",
    "nz",
    "ph",
    "pl",
    "ro",
    "tk",
    "tw",
    "ua",
    "vg",
    "ws",
    "xn",
    "za",
    // popular TLDs that startup use in 2022
    // https://thewebsiteflip.com/domains/funded-startup-brands-2021/#:~:text=from%20the%20data.-,1.,TLDs%20for%20the%20foreseeable%20future.
    // https://martijnoud.com/most-popular-tld-crypto/
    "app",
    "au",
    "ai",
    "biz",
    "br",
    "blog",
    "cloud",
    "club",
    "cc",
    "de",
    "dev",
    "digital",
    "fi",
    "finance",
    "id",
    "in",
    "io",
    "me",
    "mobi",
    "network",
    "pw",
    "so",
    "xyz",
    "software",
    "to",
    "tech"
];
module.exports.POPULAR_TLDS = $b2455fa6b1aa8cf7$var$POPULAR_TLDS;
const $b2455fa6b1aa8cf7$var$DEFAULT_CONFIG = {
    domainThreshold: 2,
    domains: $b2455fa6b1aa8cf7$var$POPULAR_DOMAINS,
    secondLevelThreshold: 2,
    secondLevelDomains: [
        "yahoo",
        "hotmail",
        "mail",
        "live",
        "outlook"
    ],
    topLevelThreshold: 2,
    topLevelDomains: $b2455fa6b1aa8cf7$var$POPULAR_TLDS,
    distanceFunction: $b2455fa6b1aa8cf7$var$sift3_distance_1.default
};
module.exports.DEFAULT_CONFIG = $b2455fa6b1aa8cf7$var$DEFAULT_CONFIG;

});
parcelRegister("8vprt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $6314f43ef68ca263$var$sift3Distance(s1, s2) {
    // sift3: http://siderite.blogspot.com/2007/04/super-fast-and-accurate-string-distance.html
    if (s1 == null || s1.length === 0) {
        if (s2 == null || s2.length === 0) return 0;
        else return s2.length;
    }
    if (s2 == null || s2.length === 0) return s1.length;
    let c = 0;
    let offset1 = 0;
    let offset2 = 0;
    let lcs = 0;
    const maxOffset = 5;
    while(c + offset1 < s1.length && c + offset2 < s2.length){
        if (s1.charAt(c + offset1) == s2.charAt(c + offset2)) lcs++;
        else {
            offset1 = 0;
            offset2 = 0;
            for(let i = 0; i < maxOffset; i++){
                if (c + i < s1.length && s1.charAt(c + i) == s2.charAt(c)) {
                    offset1 = i;
                    break;
                }
                if (c + i < s2.length && s1.charAt(c) == s2.charAt(c + i)) {
                    offset2 = i;
                    break;
                }
            }
        }
        c++;
    }
    return (s1.length + s2.length) / 2 - lcs;
}
module.exports.default = $6314f43ef68ca263$var$sift3Distance;

});




parcelRegister("eUTzz", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(" ");
        me.s1 = mash(" ");
        me.s2 = mash(" ");
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("21KlZ", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("3fL2A", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("9QBH4", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = "" + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("i2bTx", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + "\0";
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("h3k1Z", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("edxhJ", function(module, exports) {
"use strict";

});

parcelRegister("3uo0s", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $afmCM = parcelRequire("afmCM");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $afmCM.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $afmCM.default)(Rgb, rgb, (0, $afmCM.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $afmCM.default)(Hsl, hsl, (0, $afmCM.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("afmCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $775cdade47c38ea6$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $775cdade47c38ea6$export$8b58be045bf06082; });
function $775cdade47c38ea6$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $775cdade47c38ea6$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


/// <reference types="jquery" />
var $83bde87bc058d127$export$790a66df9dc00390;
(function(Capability) {
    Capability[Capability["ArrayAt"] = 0] = "ArrayAt";
})($83bde87bc058d127$export$790a66df9dc00390 || ($83bde87bc058d127$export$790a66df9dc00390 = {}));
const $83bde87bc058d127$export$23482700b6807ba0 = {
    [0]: {
        is_missing: ()=>typeof Array.prototype.at !== "function",
        init: $83bde87bc058d127$export$3cd71739eee742ce
    }
};
function $83bde87bc058d127$export$3cd71739eee742ce() {
    function at(n) {
        n = Math.trunc(n) || 0;
        if (n < 0) n += this.length;
        if (n < 0 || n >= this.length) return undefined;
        return this[n];
    }
    Object.defineProperty(Array.prototype, "at", {
        value: at,
        writable: true,
        enumerable: false,
        configurable: true
    });
}
function $83bde87bc058d127$export$2cd8252107eb640b(polyfills) {
    for (const polyfill of polyfills)if (polyfill.is_missing()) polyfill.init();
}


var $2066a33cea67b6a1$exports = {};
"use strict";
Object.defineProperty($2066a33cea67b6a1$exports, "__esModule", {
    value: true
});
$2066a33cea67b6a1$exports.mathjax = void 0;
var $4edd4d34496c56c1$exports = {};
"use strict";
Object.defineProperty($4edd4d34496c56c1$exports, "__esModule", {
    value: true
});
$4edd4d34496c56c1$exports.VERSION = void 0;
$4edd4d34496c56c1$exports.VERSION = "3.2.2";


var $6bab0340b34f2245$exports = {};
"use strict";
var $6bab0340b34f2245$var$__extends = $6bab0340b34f2245$exports && $6bab0340b34f2245$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6bab0340b34f2245$var$__values = $6bab0340b34f2245$exports && $6bab0340b34f2245$exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty($6bab0340b34f2245$exports, "__esModule", {
    value: true
});
$6bab0340b34f2245$exports.HandlerList = void 0;
var $b2c05abc84933cd6$exports = {};
"use strict";
Object.defineProperty($b2c05abc84933cd6$exports, "__esModule", {
    value: true
});
$b2c05abc84933cd6$exports.PrioritizedList = void 0;
var $b2c05abc84933cd6$var$PrioritizedList = function() {
    function PrioritizedList() {
        this.items = [];
        this.items = [];
    }
    PrioritizedList.prototype[Symbol.iterator] = function() {
        var i = 0;
        var items = this.items;
        return {
            next: function() {
                return {
                    value: items[i++],
                    done: i > items.length
                };
            }
        };
    };
    PrioritizedList.prototype.add = function(item, priority) {
        if (priority === void 0) priority = PrioritizedList.DEFAULTPRIORITY;
        var i = this.items.length;
        do i--;
        while (i >= 0 && priority < this.items[i].priority);
        this.items.splice(i + 1, 0, {
            item: item,
            priority: priority
        });
        return item;
    };
    PrioritizedList.prototype.remove = function(item) {
        var i = this.items.length;
        do i--;
        while (i >= 0 && this.items[i].item !== item);
        if (i >= 0) this.items.splice(i, 1);
    };
    PrioritizedList.DEFAULTPRIORITY = 5;
    return PrioritizedList;
}();
$b2c05abc84933cd6$exports.PrioritizedList = $b2c05abc84933cd6$var$PrioritizedList;


var $6bab0340b34f2245$var$HandlerList = function(_super) {
    $6bab0340b34f2245$var$__extends(HandlerList, _super);
    function HandlerList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HandlerList.prototype.register = function(handler) {
        return this.add(handler, handler.priority);
    };
    HandlerList.prototype.unregister = function(handler) {
        this.remove(handler);
    };
    HandlerList.prototype.handlesDocument = function(document) {
        var e_1, _a;
        try {
            for(var _b = $6bab0340b34f2245$var$__values(this), _c = _b.next(); !_c.done; _c = _b.next()){
                var item = _c.value;
                var handler = item.item;
                if (handler.handlesDocument(document)) return handler;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        throw new Error("Can't find handler for document");
    };
    HandlerList.prototype.document = function(document, options) {
        if (options === void 0) options = null;
        return this.handlesDocument(document).create(document, options);
    };
    return HandlerList;
}($b2c05abc84933cd6$exports.PrioritizedList);
$6bab0340b34f2245$exports.HandlerList = $6bab0340b34f2245$var$HandlerList;


var $12aa3c00c775e630$exports = {};
"use strict";
Object.defineProperty($12aa3c00c775e630$exports, "__esModule", {
    value: true
});
$12aa3c00c775e630$exports.retryAfter = $12aa3c00c775e630$exports.handleRetriesFor = void 0;
function $12aa3c00c775e630$var$handleRetriesFor(code) {
    return new Promise(function run(ok, fail) {
        try {
            ok(code());
        } catch (err) {
            if (err.retry && err.retry instanceof Promise) err.retry.then(function() {
                return run(ok, fail);
            }).catch(function(perr) {
                return fail(perr);
            });
            else if (err.restart && err.restart.isCallback) MathJax.Callback.After(function() {
                return run(ok, fail);
            }, err.restart);
            else fail(err);
        }
    });
}
$12aa3c00c775e630$exports.handleRetriesFor = $12aa3c00c775e630$var$handleRetriesFor;
function $12aa3c00c775e630$var$retryAfter(promise) {
    var err = new Error("MathJax retry");
    err.retry = promise;
    throw err;
}
$12aa3c00c775e630$exports.retryAfter = $12aa3c00c775e630$var$retryAfter;


$2066a33cea67b6a1$exports.mathjax = {
    version: $4edd4d34496c56c1$exports.VERSION,
    handlers: new $6bab0340b34f2245$exports.HandlerList(),
    document: function(document, options) {
        return $2066a33cea67b6a1$exports.mathjax.handlers.document(document, options);
    },
    handleRetriesFor: $12aa3c00c775e630$exports.handleRetriesFor,
    retryAfter: $12aa3c00c775e630$exports.retryAfter,
    asyncLoad: null
};


class $7923788bad7460a0$export$49a1ecce8d203 extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$49a1ecce8d203.type);
    }
}
$7923788bad7460a0$export$49a1ecce8d203.type = "mist.common.init";
class $7923788bad7460a0$export$496df437b1d8b378 extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$496df437b1d8b378.type);
    }
}
$7923788bad7460a0$export$496df437b1d8b378.type = "mist.common.tick";
class $7923788bad7460a0$export$520d21ef8265dbf2 extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$520d21ef8265dbf2.type);
    }
}
$7923788bad7460a0$export$520d21ef8265dbf2.type = "mist.common.ping";
class $7923788bad7460a0$export$9a0c977f93e56706 extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$9a0c977f93e56706.type);
    }
}
$7923788bad7460a0$export$9a0c977f93e56706.type = "mist.common.next";
class $7923788bad7460a0$export$ab08e41a03656110 extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$ab08e41a03656110.type);
    }
}
$7923788bad7460a0$export$ab08e41a03656110.type = "mist.common.previous";
class $7923788bad7460a0$export$2dd9981939617ffa extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$2dd9981939617ffa.type);
    }
}
$7923788bad7460a0$export$2dd9981939617ffa.type = "mist.practicequestion.finish";
class $7923788bad7460a0$export$f210b93e2bf140a8 extends CustomEvent {
    constructor(itemId){
        super($7923788bad7460a0$export$f210b93e2bf140a8.type, {
            detail: itemId
        });
    }
}
$7923788bad7460a0$export$f210b93e2bf140a8.type = "mist.common.jump";
class $7923788bad7460a0$export$509c5ab4bb810af8 extends CustomEvent {
    constructor(itemId){
        super($7923788bad7460a0$export$509c5ab4bb810af8.type, {
            detail: itemId
        });
    }
}
$7923788bad7460a0$export$509c5ab4bb810af8.type = "mist.common.firstjump";
class $7923788bad7460a0$export$5df3ac09e96c1e8a extends CustomEvent {
    constructor(itemId){
        super($7923788bad7460a0$export$5df3ac09e96c1e8a.type, {
            detail: itemId
        });
    }
}
$7923788bad7460a0$export$5df3ac09e96c1e8a.type = "mist.common.navigate";
class $7923788bad7460a0$export$9c971d3e2e1a3b3b extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$9c971d3e2e1a3b3b.type);
    }
}
$7923788bad7460a0$export$9c971d3e2e1a3b3b.type = "mist.common.reload";
class $7923788bad7460a0$export$60458c85dad92def extends CustomEvent {
    constructor(pause){
        super($7923788bad7460a0$export$60458c85dad92def.type, {
            detail: pause
        });
    }
}
$7923788bad7460a0$export$60458c85dad92def.type = "mist.common.pause";
class $7923788bad7460a0$export$3dd7a8e950550ea4 extends CustomEvent {
    constructor(answer){
        super($7923788bad7460a0$export$3dd7a8e950550ea4.type, {
            detail: answer
        });
    }
}
$7923788bad7460a0$export$3dd7a8e950550ea4.type = "mist.practicequestion.answer";
class $7923788bad7460a0$export$5aedb0666ade7cfe extends CustomEvent {
    constructor(front){
        super($7923788bad7460a0$export$5aedb0666ade7cfe.type, {
            detail: front
        });
    }
}
$7923788bad7460a0$export$5aedb0666ade7cfe.type = "mist.flashcard.flip";
class $7923788bad7460a0$export$fe0b591ac3aa4171 extends CustomEvent {
    constructor(contexts){
        super($7923788bad7460a0$export$fe0b591ac3aa4171.type, {
            detail: contexts
        });
    }
}
$7923788bad7460a0$export$fe0b591ac3aa4171.type = "mist.practicequestion.togglecontext";
class $7923788bad7460a0$export$f39d3f3b9871ec9b extends CustomEvent {
    constructor(id){
        super($7923788bad7460a0$export$f39d3f3b9871ec9b.type, {
            detail: id
        });
    }
}
$7923788bad7460a0$export$f39d3f3b9871ec9b.type = "mist.practicequestion.contextshown";
class $7923788bad7460a0$export$d4ddcefded388801 extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$d4ddcefded388801.type);
    }
}
$7923788bad7460a0$export$d4ddcefded388801.type = "mist.practicequestion.toggletimer";
class $7923788bad7460a0$export$8d75d221682b4901 extends CustomEvent {
    constructor(enabled){
        super($7923788bad7460a0$export$8d75d221682b4901.type, {
            detail: enabled
        });
    }
}
$7923788bad7460a0$export$8d75d221682b4901.type = "mist.common.keyboardshortcuts";
class $7923788bad7460a0$export$b289c91fe03907fc extends CustomEvent {
    constructor(size){
        super($7923788bad7460a0$export$b289c91fe03907fc.type, {
            detail: size
        });
    }
}
$7923788bad7460a0$export$b289c91fe03907fc.type = "mist.common.changefontsize";
class $7923788bad7460a0$export$3e02572c0fd6d3b9 extends CustomEvent {
    constructor(filters){
        super($7923788bad7460a0$export$3e02572c0fd6d3b9.type, {
            detail: filters
        });
    }
}
$7923788bad7460a0$export$3e02572c0fd6d3b9.type = "mist.common.setfilters";
class $7923788bad7460a0$export$e7295f8a101b6f3d extends CustomEvent {
    constructor(filters){
        super($7923788bad7460a0$export$e7295f8a101b6f3d.type, {
            detail: filters
        });
    }
}
$7923788bad7460a0$export$e7295f8a101b6f3d.type = "mist.common.togglefilters";
class $7923788bad7460a0$export$f614d9e2f5671b9b extends CustomEvent {
    constructor(filters){
        super($7923788bad7460a0$export$f614d9e2f5671b9b.type, {
            detail: filters
        });
    }
}
$7923788bad7460a0$export$f614d9e2f5671b9b.type = "mist.common.addfilters";
class $7923788bad7460a0$export$f0a09197511a3838 extends CustomEvent {
    constructor(filters){
        super($7923788bad7460a0$export$f0a09197511a3838.type, {
            detail: filters
        });
    }
}
$7923788bad7460a0$export$f0a09197511a3838.type = "mist.common.removefilters";
class $7923788bad7460a0$export$6b720b50052660b5 extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$6b720b50052660b5.type);
    }
}
$7923788bad7460a0$export$6b720b50052660b5.type = "mist.common.clearfilters";
class $7923788bad7460a0$export$ded2c80848e1b1a extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$ded2c80848e1b1a.type);
    }
}
$7923788bad7460a0$export$ded2c80848e1b1a.type = "mist.common.toggleshortcutmodal";
class $7923788bad7460a0$export$cc4ebe9deb7007ee extends CustomEvent {
    constructor(element){
        super($7923788bad7460a0$export$cc4ebe9deb7007ee.type, {
            detail: element
        });
    }
}
$7923788bad7460a0$export$cc4ebe9deb7007ee.type = "mist.practicequestion.start";
class $7923788bad7460a0$export$8d5d557b23906369 extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$8d5d557b23906369.type);
    }
}
$7923788bad7460a0$export$8d5d557b23906369.type = "mist.common.showreportmodal";
class $7923788bad7460a0$export$e65ec9e9698a1bd7 extends CustomEvent {
    constructor(form){
        super($7923788bad7460a0$export$e65ec9e9698a1bd7.type, {
            detail: form
        });
    }
}
$7923788bad7460a0$export$e65ec9e9698a1bd7.type = "mist.common.reporterror";
class $7923788bad7460a0$export$e149524ebdefa115 extends CustomEvent {
    constructor(email){
        super($7923788bad7460a0$export$e149524ebdefa115.type, {
            detail: email
        });
    }
}
$7923788bad7460a0$export$e149524ebdefa115.type = "mist.common.enteremail";
class $7923788bad7460a0$export$29dc3df1c55e2e49 extends CustomEvent {
    constructor(root, selector, value){
        super($7923788bad7460a0$export$29dc3df1c55e2e49.type, {
            detail: {
                root: root,
                selector: selector,
                value: value
            }
        });
    }
}
$7923788bad7460a0$export$29dc3df1c55e2e49.type = "mist.common.inputoverride";
class $7923788bad7460a0$export$71f5f68be44498fe extends CustomEvent {
    constructor(flagged){
        super($7923788bad7460a0$export$71f5f68be44498fe.type, {
            detail: flagged
        });
    }
}
$7923788bad7460a0$export$71f5f68be44498fe.type = "mist.common.flag";
class $7923788bad7460a0$export$f072eab12773765c extends CustomEvent {
    constructor(enable){
        super($7923788bad7460a0$export$f072eab12773765c.type, {
            detail: enable
        });
    }
}
$7923788bad7460a0$export$f072eab12773765c.type = "mist.flashcard.toggleadvance";
class $7923788bad7460a0$export$23a57784a706597f extends CustomEvent {
    constructor(interval){
        super($7923788bad7460a0$export$23a57784a706597f.type, {
            detail: interval
        });
    }
}
$7923788bad7460a0$export$23a57784a706597f.type = "mist.flashcard.changeadvanceinterval";
class $7923788bad7460a0$export$7ba22761268648c5 extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$7ba22761268648c5.type);
    }
}
$7923788bad7460a0$export$7ba22761268648c5.type = "mist.flashcard.advance";
class $7923788bad7460a0$export$20655a32208d5ee9 extends CustomEvent {
    constructor(){
        super($7923788bad7460a0$export$20655a32208d5ee9.type);
    }
}
$7923788bad7460a0$export$20655a32208d5ee9.type = "mist.flashcard.reset";
class $7923788bad7460a0$export$318fb9566749373b extends CustomEvent {
    constructor(randomize){
        super($7923788bad7460a0$export$318fb9566749373b.type, {
            detail: randomize
        });
    }
}
$7923788bad7460a0$export$318fb9566749373b.type = "mist.common.randomize";
class $7923788bad7460a0$export$806e07265bdb8daf extends CustomEvent {
    constructor(filterLink){
        super($7923788bad7460a0$export$806e07265bdb8daf.type, {
            detail: filterLink
        });
    }
}
$7923788bad7460a0$export$806e07265bdb8daf.type = "mist.common.filterlink";


class $b83c1641700d7d2a$export$2e2bcd8739ae039 {
}


class $c62a415619174070$export$e9ef9bff12694ab8 extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$fe0b591ac3aa4171).type, (event)=>this.toggleContexts(app, event.detail));
        target.addEventListener((0, $7923788bad7460a0$export$f39d3f3b9871ec9b).type, (event)=>this.contextShown(app, event.detail));
    }
    toggleContexts(app, contexts) {
        app.view.item.toggleContexts(contexts);
    }
    contextShown(app, id) {
        app.timer.viewContext(app.current.get(), id);
    }
}




class $124646cec8fbbd34$export$8d640e745b5fefe1 extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$e7295f8a101b6f3d).type, (e)=>this.toggleFilters(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$f614d9e2f5671b9b).type, (e)=>this.addFilters(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$f0a09197511a3838).type, (e)=>this.removeFilters(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$6b720b50052660b5).type, ()=>this.clearFilters(app));
        target.addEventListener((0, $7923788bad7460a0$export$3e02572c0fd6d3b9).type, (e)=>this.setFilters(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$806e07265bdb8daf).type, (e)=>this.setFilterLink(app, e.detail));
    }
    toggleFilters(app, filters) {
        app.filter.toggle(filters);
        app.navigation.updateFilters(app.filter.getIDs());
        this.update(app);
    }
    addFilters(app, filters) {
        app.filter.add(filters);
        app.navigation.updateFilters(app.filter.getIDs());
        this.update(app);
    }
    removeFilters(app, filters) {
        app.filter.remove(filters);
        app.navigation.updateFilters(app.filter.getIDs());
        this.update(app);
    }
    clearFilters(app) {
        app.filter.clear();
        app.navigation.updateFilters(app.filter.getIDs());
        this.update(app);
    }
    setFilters(app, filters) {
        app.filter.set(filters);
        this.update(app);
    }
    setFilterLink(app, element) {
        const url = new URL(element.href);
        url.searchParams.delete("filter");
        for (const filter of app.filter.getIDs())url.searchParams.append("filter", filter);
        element.href = url.toString();
    }
    update(app) {
        const bindTarget = app.view.getBindTarget();
        const activeFilters = app.filter.getValues();
        app.view.list.displayFilters(activeFilters, bindTarget);
        app.model.list.getItemList().then((items)=>app.model.list.getFilteredItems(items, activeFilters)).then((filtered)=>{
            const active = app.current.setActive(filtered);
            app.view.list.displayFiltered(active);
            const current = app.current.get();
            const prevTest = app.current.getAdjacent(-1);
            const nextTest = app.current.getAdjacent(1);
            app.view.header.displayPrevious(prevTest !== current);
            app.view.header.displayNext(nextTest !== current);
            app.view.header.displayPosition(app.current.getPosition(), app.current.getVisible().length);
        });
    }
}




class $04637eb48d465816$export$77cd77b88309b1c9 extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$49a1ecce8d203).type, ()=>this.init(app));
        target.addEventListener((0, $7923788bad7460a0$export$cc4ebe9deb7007ee).type, (e)=>this.start(app, e.detail));
    }
    init(app) {
        app.view.init(app);
        Promise.all([
            app.model.metadata.getProductId(),
            app.model.score.getOverviewScores()
        ]).then((result)=>({
                product: result[0],
                scores: result[1]
            })).then((result)=>{
            app.view.summary.displayTable(app.view.chart.getOverviewSummaryTable(app.getJquery()), result.product);
            app.view.sections.displayOverviewScores(app.view.chart.getOverviewScoreChart(), result.scores);
        });
    }
    start(app, element) {
        app.view.sections.toggleStart(element);
    }
}




class $43dd4374f28efe45$export$ce3e5ea407eb882e {
    static isEqual(a, b) {
        return Object.keys(a).every((key)=>b?.[key] === a[key]);
    }
    constructor(raw){
        const filter = JSON.parse(raw);
        this.id = filter.id;
        this.type = filter.type;
        this.title = filter.title;
        this.key = filter.key;
        this.value = filter.value;
    }
}
class $43dd4374f28efe45$export$2e2bcd8739ae039 {
    init(filters, activeFilters) {
        this.filters = Object.fromEntries(filters.map((filter)=>[
                filter.id,
                filter
            ]));
        this.activeFilters = activeFilters;
    }
    getIDs() {
        return this.activeFilters;
    }
    getValues() {
        return this.activeFilters.map((id)=>this.filters[id]);
    }
    add(filters) {
        this.activeFilters.push(...filters);
        return this.activeFilters.length - 1;
    }
    remove(filters) {
        this.activeFilters = this.activeFilters.filter((f)=>!filters.some((id)=>$43dd4374f28efe45$export$ce3e5ea407eb882e.isEqual(this.filters[f], this.filters[id])));
    }
    toggle(filters) {
        const add = [];
        const remove = [];
        filters.forEach((filter)=>{
            if (this.activeFilters.some((id)=>$43dd4374f28efe45$export$ce3e5ea407eb882e.isEqual(this.filters[filter], this.filters[id]))) remove.push(filter);
            else add.push(filter);
        });
        this.add(add);
        this.remove(remove);
        return filters.map((f)=>add.includes(f));
    }
    clear() {
        this.activeFilters = [];
    }
    set(filters) {
        this.activeFilters = filters;
    }
    constructor(){
        this.filters = {};
        this.activeFilters = [];
    }
}


class $e6d9787dca477675$export$2e2bcd8739ae039 {
    replaceHash(item) {
        const new_hash = `#${item}`;
        if (new_hash !== this.last_hash) {
            history.replaceState(null, document.title, new_hash);
            this.last_hash = new_hash;
        }
    }
    pushHash(item) {
        const new_hash = `#${item}`;
        if (new_hash !== this.last_hash) {
            history.pushState(null, document.title, new_hash);
            this.last_hash = new_hash;
        }
    }
    updateHash(item) {
        this.last_hash = `#${item}`;
    }
    updateFilters(filterIds) {
        const url = new URL(window.location.href);
        url.searchParams.delete("filter");
        for (const id of filterIds)url.searchParams.append("filter", id);
        window.history.pushState(null, null, url);
    }
    static getURLParams() {
        return new URLSearchParams(window.location.search);
    }
    static parseURLFilters() {
        const url_params = $e6d9787dca477675$export$2e2bcd8739ae039.getURLParams();
        if (url_params.size) return url_params.getAll("filter");
        return [];
    }
}


class $8de0aa2da6918f40$export$74d9db856d618e43 extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$49a1ecce8d203).type, ()=>this.init(app));
    }
    init(app) {
        app.view.init(app);
        app.view.item.displayLoading("loading");
        app.model.list.getItemList().then((items)=>Promise.all([
                app.model.metadata.getProductId(),
                app.model.metadata.getAttempt(),
                Promise.resolve(items),
                app.model.list.getItemIdMap(items),
                app.model.list.getItemIndexMap(items),
                app.model.score.getReviewScores(),
                app.model.score.getTotalScores(),
                app.model.state.global.getInitialState(app.config.timer).catch(()=>undefined),
                app.model.state.attempt.getInitialState(app.config.timer).catch(()=>undefined)
            ])).then(([product, attempt, items, ids, indices, section, total, globalState, attemptState])=>{
            const bindTarget = app.view.getBindTarget();
            app.filter.init(Array.from(document.querySelectorAll(".filter input:not(.invisible)")).map((input)=>new (0, $43dd4374f28efe45$export$ce3e5ea407eb882e)(input.dataset.filter)), []);
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3e02572c0fd6d3b9)((0, $e6d9787dca477675$export$2e2bcd8739ae039).parseURLFilters()));
            app.content.init(items, product, app);
            const randomize = app.model.settings.getRandomize();
            app.current.init(items, attemptState?.current, randomize, ids, app.model.list.itemIdSerializer());
            app.userdata.init(product, attempt, items, app);
            app.timer.init(bindTarget, app.config.timer, attemptState?.times, ids);
            const state = app.serialize(indices);
            Promise.all([
                app.model.state.global.setState(state.global),
                app.model.state.attempt.setState(state.attempt)
            ]);
            app.view.header.displayTotalScores(app.view.chart.getReviewTotalScoreChart(), total);
            app.view.scores.displayReviewScores(app.view.chart.getReviewSectionScoreChart(), section);
            const jumpTarget = decodeURIComponent(location.hash.replace(/^#/, "")) || indices[app.current.get()];
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$509c5ab4bb810af8)(jumpTarget));
        });
    }
}






class $748df0be0de871bb$export$e26f6f7e2a1f6c78 extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$49a1ecce8d203).type, ()=>this.init(app));
    }
    init(app) {
        app.view.init(app);
        app.view.item.displayLoading("loading");
        app.model.list.getItemList().then((items)=>Promise.all([
                app.model.metadata.getProductId(),
                app.model.metadata.getAttempt(),
                Promise.resolve(items),
                app.model.list.getItemIdMap(items),
                app.model.list.getItemIndexMap(items),
                app.model.state.global.getInitialState(app.config.timer).catch(()=>undefined),
                app.model.state.attempt.getInitialState(app.config.timer).catch(()=>undefined)
            ])).then(([product, attempt, items, ids, indices, globalState, attemptState])=>{
            const bindTarget = app.view.getBindTarget();
            app.filter.init(Array.from(document.querySelectorAll(".filter input:not(.invisible)")).map((input)=>new (0, $43dd4374f28efe45$export$ce3e5ea407eb882e)(input.dataset.filter)), []);
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3e02572c0fd6d3b9)((0, $e6d9787dca477675$export$2e2bcd8739ae039).parseURLFilters()));
            app.content.init(items, product, app);
            const randomize = app.model.settings.getRandomize();
            app.current.init(items, attemptState?.current, randomize, ids, app.model.list.itemIdSerializer());
            app.userdata.init(product, attempt, items, app);
            app.timer.init(bindTarget, app.config.timer, attemptState?.times, ids);
            const state = app.serialize(indices);
            Promise.all([
                app.model.state.global.setState(state.global),
                app.model.state.attempt.setState(state.attempt)
            ]);
            app.view.header.displayProgress(app.view.chart.getTestProgressChart(), app.userdata.count((u)=>!!u?.answer), app.content.count());
            const jumpTarget = decodeURIComponent(location.hash.replace(/^#/, "")) || indices[app.current.get()];
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$509c5ab4bb810af8)(jumpTarget));
        });
    }
}




class $9b189da8a270b36a$export$b107b7c78aebc69 extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$9a0c977f93e56706).type, ()=>this.next(app));
        target.addEventListener((0, $7923788bad7460a0$export$ab08e41a03656110).type, ()=>this.previous(app));
        target.addEventListener((0, $7923788bad7460a0$export$f210b93e2bf140a8).type, (e)=>this.jump(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$9c971d3e2e1a3b3b).type, ()=>this.reload(app));
        target.addEventListener((0, $7923788bad7460a0$export$509c5ab4bb810af8).type, (e)=>this.firstJump(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$5df3ac09e96c1e8a).type, (e)=>this.navigate(app, e.detail));
    }
    async next(app) {
        const previous = app.current.get();
        const next = app.current.next();
        const nextContent = await app.content.get(next);
        app.navigation.pushHash(app.model.list.itemIdSerializer().toString(nextContent.id));
        this.switch(app, previous, next);
    }
    async previous(app) {
        const previous = app.current.get();
        const next = app.current.previous();
        const nextContent = await app.content.get(next);
        app.navigation.pushHash(app.model.list.itemIdSerializer().toString(nextContent.id));
        this.switch(app, previous, next);
    }
    jump(app, item) {
        const previous = app.current.get();
        const id = app.model.list.itemIdSerializer().parse(item);
        if (!id) {
            const error = new Error(`Invalid item id: ${item}`);
            app.model.settings.appendError(error);
            throw error;
        }
        const next = app.current.jump(id);
        app.navigation.pushHash(item);
        if (next >= 0) this.switch(app, previous, next);
    }
    firstJump(app, item) {
        const previous = app.current.get();
        const id = app.model.list.itemIdSerializer().parse(item);
        if (!id) {
            const error = new Error(`Invalid item id: ${item}`);
            app.model.settings.appendError(error);
            throw error;
        }
        const next = app.current.jump(id);
        app.navigation.replaceHash(item);
        if (next >= 0) this.switch(app, previous, next);
    }
    navigate(app, item) {
        const previous = app.current.get();
        const id = app.model.list.itemIdSerializer().parse(item);
        if (!id) {
            const error = new Error(`Invalid item id: ${item}`);
            app.model.settings.appendError(error);
            throw error;
        }
        const next = app.current.jump(id);
        app.navigation.updateHash(item);
        if (next >= 0) this.switch(app, previous, next);
    }
    switch(app, previous, next) {
        app.view.item.displayLoading("loading");
        app.view.list.displayCurrent(next);
        return Promise.all([
            app.content.get(next),
            app.content.get(previous),
            app.model.list.getItemIndexMap()
        ]).then(([nextContent, prevContent, indices])=>{
            const current = app.current.get();
            const prevTest = app.current.getAdjacent(-1);
            const nextTest = app.current.getAdjacent(1);
            const userData = app.userdata.get(next);
            app.view.header.displayPrevious(prevTest !== current);
            app.view.header.displayNext(nextTest !== current);
            app.view.header.displayFlag(userData?.flagged);
            this._switch(app, previous, next, nextContent, prevContent);
            app.view.header.displayPosition(app.current.getPosition(), app.current.getVisible().length);
            app.model.state.attempt.updateState({
                current: {
                    id: indices[next]
                }
            });
            app.view.item.rebindKeyboard(app, nextContent.type);
            app.view.item.displayLoading("done");
            [
                1,
                -1,
                2,
                -2
            ].map((offset)=>app.current.getAdjacent(offset)).forEach((index)=>app.content.get(index));
        }).catch((error)=>{
            app.model.settings.appendError(error);
            app.view.item.displayLoading("error");
        });
    }
    reload(app) {
        const current = app.current.get();
        return app.content.remove(current).then(()=>this.switch(app, current, current));
    }
}
class $9b189da8a270b36a$export$7ae5aaa1df46fd60 extends $9b189da8a270b36a$export$b107b7c78aebc69 {
    _switch(app, previous, next, nextContent, previousContent) {
        throw new Error("Method not implemented.");
    }
}
class $9b189da8a270b36a$export$b16fba08cef0c11b extends $9b189da8a270b36a$export$b107b7c78aebc69 {
    _switch(app, previous, next, nextContent, previousContent) {
        const bindTarget = app.view.getBindTarget();
        const userData = app.userdata.get(next);
        const sameContexts = previous !== 0 || next !== 0 ? app.model.item.getSameContexts(nextContent, previousContent) : [];
        const sameIds = sameContexts.map((c)=>c.id);
        app.view.header.displayFinish(next == app.current.last());
        app.timer.switch(previous, next, {
            contexts_viewed: nextContent.contexts.reduce((o, c)=>({
                    ...o,
                    [c.id]: !sameIds.includes(c.id)
                }), {})
        });
        app.view.header.displayItem(nextContent);
        app.view.item.displayItemContent(nextContent, bindTarget);
        app.view.item.displayItemSelectedAnswer(nextContent, bindTarget, userData?.answer);
        app.view.item.displayItemSameContext(nextContent, sameContexts);
        app.view.item.displayItemRendered(nextContent, app.getMathJax());
        app.view.item.displayItemAlerts(nextContent);
    }
}
class $9b189da8a270b36a$export$a37f2987b6c01832 extends $9b189da8a270b36a$export$b107b7c78aebc69 {
    _switch(app, previous, next, nextContent, previousContent) {
        const bindTarget = app.view.getBindTarget();
        const total = app.timer.total([
            next
        ]);
        app.timer.switch(previous, next, {
            front: true
        });
        app.current.setAnswerVisible(false);
        app.view.header.displayCurrentTime(total);
        app.view.header.displayItem(nextContent);
        app.view.header.displayFlip(true);
        app.view.item.displayCardFront();
        app.view.item.displayItemContent(nextContent, bindTarget);
        app.view.item.displayItemRendered(nextContent, app.getMathJax());
        app.view.item.displayItemAlerts(nextContent);
    }
}




class $c9673169519ccf3d$export$e85c1bdb90ec603e extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$b289c91fe03907fc).type, (e)=>this.changeFontSize(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$8d75d221682b4901).type, ()=>this.keyboardShortcuts(app));
        target.addEventListener((0, $7923788bad7460a0$export$d4ddcefded388801).type, ()=>this.toggleTimer(app));
        target.addEventListener((0, $7923788bad7460a0$export$ded2c80848e1b1a).type, ()=>this.toggleShortcutModal(app));
        target.addEventListener((0, $7923788bad7460a0$export$8d5d557b23906369).type, ()=>this.showReportModal(app));
        target.addEventListener((0, $7923788bad7460a0$export$e149524ebdefa115).type, (e)=>this.enterEmail(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$29dc3df1c55e2e49).type, (e)=>this.inputOverride(app, e.detail.root, e.detail.selector, e.detail.value));
        target.addEventListener((0, $7923788bad7460a0$export$e65ec9e9698a1bd7).type, (e)=>this.sendErrorReport(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$f072eab12773765c).type, (e)=>this.toggleAutoAdvance(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$23a57784a706597f).type, (e)=>this.changeAdvanceInterval(app, e.detail));
    }
    changeFontSize(app, fontsize) {
        app.model.settings.setFontSize(fontsize);
        app.model.state.global.updateState({
            settings: {
                fontsize: fontsize
            }
        });
        app.view.settings.displayFontSize(fontsize);
        app.view.item.displayFontSize(fontsize);
    }
    keyboardShortcuts(app) {
        const enabled = !app.model.settings.getKeyboardShortcuts();
        app.model.settings.setKeyboardShortcuts(enabled);
        app.view.settings.displayKeyboardShortcuts(enabled);
    }
    toggleTimer(app) {
        const show = app.model.settings.toggleTimer();
        app.view.header.displayTimer(show);
        app.view.settings.displayTimer(show);
    }
    toggleShortcutModal(app) {
        app.view.settings.toggleShortcutModal(app.getJquery());
    }
    sendErrorReport(app, form) {
        app.model.metadata.getProductId().then((product)=>app.model.settings.sendErrorReport(product, form)).then((result)=>{
            if (result.success) {
                app.model.settings.clearErrors();
                return app.view.settings.hideErrorModal(app.getJquery(), result.success, result.reason);
            } else return app.view.settings.displayReportErrorMessage(result.reason);
        });
    }
    showReportModal(app) {
        app.view.settings.displayErrorLoading(true);
        Promise.all([
            app.model.metadata.getUrl(),
            app.content.get(app.current.get()).catch(()=>undefined),
            app.content.meta(app.current.get()),
            app.model.metadata.getScreenshot(),
            app.model.settings.getErrors()
        ]).then(([url, item, meta, screenshot, errors])=>{
            const localStorage = app.model.settings.getLocalStorage();
            app.view.settings.displayErrorModal(app.getJquery(), url, item ?? meta, app.filter.getValues(), screenshot, errors, localStorage);
            app.view.settings.displayErrorLoading(false);
        });
    }
    async enterEmail(app, input) {
        const suggestion = await app.model.settings.getEmailSuggestion(input.value);
        app.view.settings.displayInputSuggestion(input, suggestion);
    }
    inputOverride(app, root, selector, value) {
        const inputs = app.view.settings.updateInputs(root, selector, value);
        for (const input of inputs)app.view.settings.displayInputSuggestion(input, "");
    }
    toggleAutoAdvance(app, enable) {
        const bindTarget = app.view.getBindTarget();
        app.timer.toggleAutoAdvance(enable);
        app.model.state.global.updateState({
            timer: {
                autoAdvance: enable
            }
        });
        app.view.header.displayCountdown(enable);
        app.view.settings.displayAdvance(enable);
        bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$496df437b1d8b378)());
    }
    changeAdvanceInterval(app, interval) {
        const bindTarget = app.view.getBindTarget();
        app.timer.setAdvanceInterval(interval);
        app.model.state.global.updateState({
            timer: {
                advanceRate: interval
            }
        });
        app.view.settings.displayAdvanceInterval(interval);
        bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$496df437b1d8b378)());
    }
}




class $be240fd33780548d$export$a7b06bfba60a8a78 {
    constructor(item, serializer){
        return {
            ...item,
            id: serializer.parse(item.id)
        };
    }
}
class $be240fd33780548d$export$4aae75b7c7d79c7c {
    getItemList() {
        return new Promise((resolve)=>resolve(Array.from(document.querySelectorAll(".item-list .item")).map((element)=>this.makeListItem(element.dataset))));
    }
    makeListItem(dataset) {
        let answer;
        try {
            answer = JSON.parse(dataset.answer);
        } catch  {
            answer = dataset.answer;
        }
        return new $be240fd33780548d$export$a7b06bfba60a8a78({
            ...Object.assign({}, dataset),
            id: dataset.id,
            name: dataset.name,
            answer: answer,
            flagged: dataset.flagged?.toLowerCase() == "true",
            initial: parseInt(dataset.initial)
        }, this.itemIdSerializer);
    }
    getFilteredItems(items, filters) {
        const values = filters.reduce((result, filter)=>{
            if (!(filter.key in result)) result[filter.key] = {
                type: filter.type,
                title: filter.title,
                key: filter.key,
                values: new Set()
            };
            result[filter.key].values.add(filter.value);
            return result;
        }, {});
        // TODO: Determine if type='flag' is necessary, or if it can be handled by type='match'
        return new Promise((resolve)=>resolve(items.filter((item)=>Object.keys(values).every((key)=>values[key].type === "flag" && (values[key].values.has(false) && (!(values[key].key in item) || !item[values[key].key]) || values[key].values.has(true) && values[key].key in item && item[values[key].key]) || values[key].type === "match" && values[key].key in item && values[key].values.has(item[values[key].key])))));
    }
    setAttributes(id, data) {
        const item = document.querySelector(`.item-list .item[data-id='${CSS.escape(this.itemIdSerializer.toString(id))}']`);
        for(const prop in data)item.dataset[prop] = typeof data[prop] === "object" ? JSON.stringify(data[prop]) : data[prop].toString();
    }
    constructor(item){
        this.itemIdSerializer = item;
    }
}
class $be240fd33780548d$export$ae632c642b63b623 extends $be240fd33780548d$export$4aae75b7c7d79c7c {
}


class $176d69903c7f2815$export$fcb28e1a04da1ae2 {
    /**
	 * @param a {ContentItem}
	 * @param b {ContentItem}
	 * @returns {ContentItem["contexts]}
	 */ getSameContexts(a, b) {
        return a.contexts.filter((first)=>b.contexts.some((second)=>first.id === second.id));
    }
}
class $176d69903c7f2815$export$ab09e123e8bceee0 extends $176d69903c7f2815$export$fcb28e1a04da1ae2 {
}
class $176d69903c7f2815$export$44e9ee8eb3ba6e9 extends $176d69903c7f2815$export$fcb28e1a04da1ae2 {
}
class $176d69903c7f2815$export$bf54c4b5936c5b07 extends $176d69903c7f2815$export$fcb28e1a04da1ae2 {
    getItem(product, item, randomize) {
        throw new Error("Method not implemented.");
    }
    setUserData(product, attempt, item, data) {
        throw new Error("Method not implemented.");
    }
    setPing(product, attempt, mode, times) {
        throw new Error("Method not implemented.");
    }
    setFinished(product, attempt) {
        throw new Error("Method not implemented.");
    }
}



var $b8c104080549d3ac$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $b8c104080549d3ac$exports = factory();
})($b8c104080549d3ac$exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = "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";
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: "color",
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === "from") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === "to") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: "image",
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === "none") && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case "no-repeat":
                return 1 /* NO_REPEAT */ ;
            case "repeat-x":
            case "repeat no-repeat":
                return 2 /* REPEAT_X */ ;
            case "repeat-y":
            case "no-repeat repeat":
                return 3 /* REPEAT_Y */ ;
            case "repeat":
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case "none":
                        return 0 /* NONE */ ;
                    case "dashed":
                        return 2 /* DASHED */ ;
                    case "dotted":
                        return 3 /* DOTTED */ ;
                    case "double":
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var direction = {
        name: "direction",
        initialValue: "ltr",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case "rtl":
                    return 1 /* RTL */ ;
                case "ltr":
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case "block":
            case "-webkit-box":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case "left":
                    return 1 /* LEFT */ ;
                case "right":
                    return 2 /* RIGHT */ ;
                case "inline-start":
                    return 3 /* INLINE_START */ ;
                case "inline-end":
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "normal") return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "inside":
                    return 0 /* INSIDE */ ;
                case "outside":
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case "disc":
                    return 0 /* DISC */ ;
                case "circle":
                    return 1 /* CIRCLE */ ;
                case "square":
                    return 2 /* SQUARE */ ;
                case "decimal":
                    return 3 /* DECIMAL */ ;
                case "cjk-decimal":
                    return 4 /* CJK_DECIMAL */ ;
                case "decimal-leading-zero":
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case "lower-roman":
                    return 6 /* LOWER_ROMAN */ ;
                case "upper-roman":
                    return 7 /* UPPER_ROMAN */ ;
                case "lower-greek":
                    return 8 /* LOWER_GREEK */ ;
                case "lower-alpha":
                    return 9 /* LOWER_ALPHA */ ;
                case "upper-alpha":
                    return 10 /* UPPER_ALPHA */ ;
                case "arabic-indic":
                    return 11 /* ARABIC_INDIC */ ;
                case "armenian":
                    return 12 /* ARMENIAN */ ;
                case "bengali":
                    return 13 /* BENGALI */ ;
                case "cambodian":
                    return 14 /* CAMBODIAN */ ;
                case "cjk-earthly-branch":
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case "cjk-heavenly-stem":
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case "cjk-ideographic":
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case "devanagari":
                    return 18 /* DEVANAGARI */ ;
                case "ethiopic-numeric":
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case "georgian":
                    return 20 /* GEORGIAN */ ;
                case "gujarati":
                    return 21 /* GUJARATI */ ;
                case "gurmukhi":
                    return 22 /* GURMUKHI */ ;
                case "hebrew":
                    return 22 /* HEBREW */ ;
                case "hiragana":
                    return 23 /* HIRAGANA */ ;
                case "hiragana-iroha":
                    return 24 /* HIRAGANA_IROHA */ ;
                case "japanese-formal":
                    return 25 /* JAPANESE_FORMAL */ ;
                case "japanese-informal":
                    return 26 /* JAPANESE_INFORMAL */ ;
                case "kannada":
                    return 27 /* KANNADA */ ;
                case "katakana":
                    return 28 /* KATAKANA */ ;
                case "katakana-iroha":
                    return 29 /* KATAKANA_IROHA */ ;
                case "khmer":
                    return 30 /* KHMER */ ;
                case "korean-hangul-formal":
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case "korean-hanja-formal":
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case "korean-hanja-informal":
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case "lao":
                    return 34 /* LAO */ ;
                case "lower-armenian":
                    return 35 /* LOWER_ARMENIAN */ ;
                case "malayalam":
                    return 36 /* MALAYALAM */ ;
                case "mongolian":
                    return 37 /* MONGOLIAN */ ;
                case "myanmar":
                    return 38 /* MYANMAR */ ;
                case "oriya":
                    return 39 /* ORIYA */ ;
                case "persian":
                    return 40 /* PERSIAN */ ;
                case "simp-chinese-formal":
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case "simp-chinese-informal":
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case "tamil":
                    return 43 /* TAMIL */ ;
                case "telugu":
                    return 44 /* TELUGU */ ;
                case "thai":
                    return 45 /* THAI */ ;
                case "tibetan":
                    return 46 /* TIBETAN */ ;
                case "trad-chinese-formal":
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case "trad-chinese-informal":
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case "upper-armenian":
                    return 49 /* UPPER_ARMENIAN */ ;
                case "disclosure-open":
                    return 50 /* DISCLOSURE_OPEN */ ;
                case "disclosure-closed":
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case "none":
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return 1 /* HIDDEN */ ;
                    case "scroll":
                        return 2 /* SCROLL */ ;
                    case "clip":
                        return 3 /* CLIP */ ;
                    case "auto":
                        return 4 /* AUTO */ ;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "break-word":
                    return "break-word" /* BREAK_WORD */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case "right":
                    return 2 /* RIGHT */ ;
                case "center":
                case "justify":
                    return 1 /* CENTER */ ;
                case "left":
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "relative":
                    return 1 /* RELATIVE */ ;
                case "absolute":
                    return 2 /* ABSOLUTE */ ;
                case "fixed":
                    return 3 /* FIXED */ ;
                case "sticky":
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case "uppercase":
                    return 2 /* UPPERCASE */ ;
                case "lowercase":
                    return 1 /* LOWERCASE */ ;
                case "capitalize":
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case "hidden":
                    return 1 /* HIDDEN */ ;
                case "collapse":
                    return 2 /* COLLAPSE */ ;
                case "visible":
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: "time",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(" "));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(" "));
            return results.map(function(result) {
                return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "oblique":
                    return "oblique" /* OBLIQUE */ ;
                case "italic":
                    return "italic" /* ITALIC */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: "paint-order",
        initialValue: "normal",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case "stroke":
                        layers.push(1 /* STROKE */ );
                        break;
                    case "fill":
                        layers.push(0 /* FILL */ );
                        break;
                    case "markers":
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(context, parser.parseComponentValue());
                    case "color":
                        return color$1.parse(context, parser.parseComponentValue());
                    case "image":
                        return image.parse(context, parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "time":
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = "data-html2canvas-debug";
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case "all":
                return 1 /* ALL */ ;
            case "clone":
                return 2 /* CLONE */ ;
            case "parse":
                return 3 /* PARSE */ ;
            case "render":
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = "0s";
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = "none";
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = "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";
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement("boundtest");
        testElement.style.width = "50px";
        testElement.style.display = "block";
        testElement.style.fontSize = "12px";
        testElement.style.letterSpacing = "0px";
        testElement.style.wordSpacing = "0px";
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "grapheme"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "word"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = "";
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = "";
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("\u2022") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function(node) {
        return node.tagName === "CANVAS";
    };
    var isVideoElement = function(node) {
        return node.tagName === "VIDEO";
    };
    var isImageElement = function(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function(node) {
        return node.tagName === "SELECT";
    };
    var isSlotElement = function(node) {
        return node.tagName === "SLOT";
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf("-") > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "\u3001" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn("Unable to restore scroll position for cloned document");
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = "";
                }
                if (clone.loading === "lazy") clone.loading = "eager";
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement("html2canvascustomelement");
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement("canvas");
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext("2d");
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement("canvas");
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ":before");
                var styleAfter = window1.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        "all",
        "d",
        "content" // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = "about:blank";
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            container.style.whiteSpace = "nowrap";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? "rtl" : "ltr";
                    this.ctx.textAlign = "left";
                    this.ctx.textBaseline = "alphabetic";
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = "";
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = "";
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = "miter";
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = "round";
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return "center";
            case 2 /* RIGHT */ :
                return "right";
            case 0 /* LEFT */ :
            default:
                return "left";
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        "-apple-system",
        "system-ui"
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});


class $6d853ffbfbdd7463$export$d12b987aa5384879 {
    /** @returns {Promise<string>} */ getUrl() {
        return new Promise((resolve)=>resolve(window.location.href));
    }
    /**
	 * @returns {Promise<string>}
	 */ getScreenshot() {
        return typeof (0, (/*@__PURE__*/$parcel$interopDefault($b8c104080549d3ac$exports))) === "undefined" ? new Promise((resolve)=>resolve("")) : (0, (/*@__PURE__*/$parcel$interopDefault($b8c104080549d3ac$exports)))(document.querySelector("body")).then((canvas)=>canvas.toDataURL());
    }
}
class $6d853ffbfbdd7463$export$95988b6ca30adf97 extends $6d853ffbfbdd7463$export$d12b987aa5384879 {
    getProductId() {
        throw new Error("Method not implemented.");
    }
    getAttempt() {
        throw new Error("Method not implemented.");
    }
}


class $eb776a821ef0bbbf$export$7c66c0fb5f371cd6 {
    /**
	 * @returns {Promise<{set:{test:{
	 *     answered_count:string,
	 *     complete:boolean,
	 *     correct_count:string,
	 *     finished:boolean,
	 *     id:string,
	 *     incorrect_count:string,
	 *     name:string,
	 *     percent_correct:string,
	 *     quiz_id:string,
	 *     started:string,
	 *     total_count:string,
	 *     total_time:string
	 * }}}>}
	 */ getOverviewScores() {
        // Pulls data from global scores map
        return new Promise((resolve)=>{
            try {
                resolve(scores);
            } catch (e) {
                resolve(undefined);
            }
        });
    }
    /**
	 * @returns {Promise<ReviewScore[]>}
	 */ getTableScores() {
        return new Promise((resolve)=>{
            const columns = Array.from(document.querySelectorAll("table.scores thead tr th")).map((header)=>header.dataset.name);
            const sections = Array.from(document.querySelectorAll("table.scores tbody tr")).map((row)=>Array.from(row.querySelectorAll("td")).map((cell, index)=>({
                        key: columns[index],
                        value: /^[-\d%.\s]+$/.test(cell.textContent) ? parseFloat(cell.textContent) : cell.textContent
                    })).reduce((result, cell)=>{
                    result[cell.key] = cell.value;
                    return result;
                }, {}));
            resolve(sections);
        });
    }
    /**
	 * @returns {Promise<ReviewScore>}
	 */ getTotalScores() {
        return new Promise((resolve)=>{
            const columns = Array.from(document.querySelectorAll("table.scores thead tr th")).map((header)=>header.dataset.name);
            const total = Array.from(document.querySelectorAll("table.scores tfoot tr th")).map((cell, index)=>({
                    key: columns[index],
                    value: /^[-\d%.\s]+$/.test(cell.textContent) ? parseFloat(cell.textContent) : cell.textContent
                })).reduce((result, cell)=>{
                result[cell.key] = cell.value;
                return result;
            }, {});
            resolve(total);
        });
    }
    constructor(quiz){
        this.quizIdSerializer = quiz;
    }
}
class $eb776a821ef0bbbf$export$751df6884de3660e extends $eb776a821ef0bbbf$export$7c66c0fb5f371cd6 {
}


var $f79d55d14cb6ddfe$exports = {};
"use strict";
var $f79d55d14cb6ddfe$var$__importDefault = $f79d55d14cb6ddfe$exports && $f79d55d14cb6ddfe$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f79d55d14cb6ddfe$exports, "__esModule", {
    value: true
});
$f79d55d14cb6ddfe$exports.POPULAR_TLDS = $f79d55d14cb6ddfe$exports.POPULAR_DOMAINS = $f79d55d14cb6ddfe$exports.run = void 0;

const $f79d55d14cb6ddfe$var$run_1 = $f79d55d14cb6ddfe$var$__importDefault((parcelRequire("a0wAy")));
$f79d55d14cb6ddfe$exports.run = $f79d55d14cb6ddfe$var$run_1.default;

var $fiVNL = parcelRequire("fiVNL");
Object.defineProperty($f79d55d14cb6ddfe$exports, "POPULAR_DOMAINS", {
    enumerable: true,
    get: function() {
        return $fiVNL.POPULAR_DOMAINS;
    }
});
Object.defineProperty($f79d55d14cb6ddfe$exports, "POPULAR_TLDS", {
    enumerable: true,
    get: function() {
        return $fiVNL.POPULAR_TLDS;
    }
});
const $f79d55d14cb6ddfe$var$MailSpellChecker = {
    run: $f79d55d14cb6ddfe$var$run_1.default,
    POPULAR_DOMAINS: $fiVNL.POPULAR_DOMAINS,
    POPULAR_TLDS: $fiVNL.POPULAR_TLDS
};
$f79d55d14cb6ddfe$exports.default = $f79d55d14cb6ddfe$var$MailSpellChecker;


class $c1a89ddac7c2b3d8$export$e97855d8604afed8 {
    getKeyboardShortcuts() {
        return this.keyboard;
    }
    setKeyboardShortcuts(enabled) {
        this.keyboard = enabled;
    }
    getFontSize() {
        return this.fontSize;
    }
    setFontSize(size) {
        this.fontSize = size;
    }
    getRandomize() {
        return this.randomize;
    }
    setRandomize(randomize) {
        this.randomize = randomize;
    }
    toggleTimer() {
        this.timer = !this.timer;
        return this.timer;
    }
    getEmailSuggestion(email) {
        const suggestion = (0, (/*@__PURE__*/$parcel$interopDefault($f79d55d14cb6ddfe$exports))).run({
            email: email
        });
        return Promise.resolve(suggestion ? suggestion.full : undefined);
    }
    appendError(error) {
        this.errors.push(error);
    }
    getErrors() {
        return this.errors;
    }
    clearErrors() {
        this.errors = [];
    }
    getLocalStorage(prefix) {
        return Array.from(Array(window.localStorage.length).keys()).map((i)=>window.localStorage.key(i)).filter((key)=>prefix.test(key)).reduce((result, key)=>({
                ...result,
                [key]: ((content)=>{
                    try {
                        return JSON.parse(content);
                    } catch (e) {
                        return content;
                    }
                })(window.localStorage.getItem(key))
            }), {});
    }
    constructor(){
        this.keyboard = true;
        this.timer = true;
        this.fontSize = 1;
        this.randomize = false;
        this.errors = [];
    }
}
class $c1a89ddac7c2b3d8$export$3a813530d8410010 extends $c1a89ddac7c2b3d8$export$e97855d8604afed8 {
    sendErrorReport(product, form) {
        throw new Error("Method not implemented.");
    }
    getLocalStoragePrefix() {
        throw new Error("Method not implemented.");
    }
}


function $434124d31c68176b$export$6969335ea1e4e77c(target, source) {
    function isObject(item) {
        return item && typeof item === "object" && !Array.isArray(item);
    }
    const output = Object.assign({}, target);
    for (let key of Object.keys(source))if (isObject(source[key])) output[key] = $434124d31c68176b$export$6969335ea1e4e77c(target[key], source[key]);
    else Object.assign(output, {
        [key]: source[key]
    });
    return output;
}
class $434124d31c68176b$export$2df7f0b5c09577ab {
    getInitialState(config) {
        try {
            return this.getState().catch((e)=>undefined).then((cache)=>this.initializer.getInitialState(cache, config));
        } catch (e) {
            return Promise.reject(e);
        }
    }
    getState() {
        try {
            const state = JSON.parse(localStorage.getItem(this.getStateKey()) ?? "null");
            return state ? Promise.resolve(state) : Promise.reject({
                reason: "Missing/corrupt cache",
                key: this.getStateKey()
            });
        } catch (e) {
            return Promise.reject(e);
        }
    }
    setState(state) {
        try {
            localStorage.setItem(this.getStateKey(), JSON.stringify({
                ...state,
                timestamp: new Date().toISOString()
            }));
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    }
    updateState(state) {
        return this.getState().then((current_state)=>this.setState($434124d31c68176b$export$6969335ea1e4e77c(current_state, state)));
    }
    constructor(initializer){
        this.initializer = initializer;
    }
}
class $434124d31c68176b$export$392ca719850ca6c extends $434124d31c68176b$export$2df7f0b5c09577ab {
    getStateKey() {
        throw new Error("Method not implemented.");
    }
}


class $64a84e97a08b3b3f$export$4b895f10ad14b88 {
    getInitialState(cache) {
        return {
            version: 2,
            timestamp: new Date().toISOString(),
            ...cache ?? {},
            current: this.getInitialCurrent(cache),
            times: this.getInitialTimes(cache)
        };
    }
}
class $64a84e97a08b3b3f$export$c71c6275427547ae extends $64a84e97a08b3b3f$export$4b895f10ad14b88 {
    getInitialCurrent(cache) {
        return {
            ...cache?.current ?? {},
            ...$64a84e97a08b3b3f$var$getDOMCurrent()
        };
    }
    getInitialTimes(cache) {
        return {
            ...cache?.times ?? {},
            ...$64a84e97a08b3b3f$var$getDOMTimes()
        };
    }
}
class $64a84e97a08b3b3f$export$cff54aa69b8a5414 extends $64a84e97a08b3b3f$export$4b895f10ad14b88 {
    getInitialCurrent(cache) {
        return {
            ...$64a84e97a08b3b3f$var$getDOMCurrent(),
            ...cache?.current ?? {}
        };
    }
    getInitialTimes(cache) {
        return {
            ...$64a84e97a08b3b3f$var$getDOMTimes(),
            ...cache?.times ?? {}
        };
    }
}
class $64a84e97a08b3b3f$export$c765021851b015c1 extends $64a84e97a08b3b3f$export$4b895f10ad14b88 {
    getInitialCurrent(cache) {
        throw new Error("Method not implemented.");
    }
    getInitialTimes(cache) {
        throw new Error("Method not implemented.");
    }
}
class $64a84e97a08b3b3f$export$eac5cc7c756f6526 {
    getInitialState(cache, config) {
        return {
            version: 2,
            timestamp: new Date().toISOString(),
            timer: {
                advanceRate: config?.advanceRate ?? 30000,
                autoAdvance: config?.autoAdvance ?? false,
                timed: config?.timed ?? false
            },
            settings: {
                fontsize: 1,
                randomize: false
            },
            ...cache ?? {}
        };
    }
}
class $64a84e97a08b3b3f$export$d47831b07ee709a2 {
    getInitialState(cache) {
        throw new Error("Method not implemented.");
    }
}
function $64a84e97a08b3b3f$var$getDOMCurrent() {
    const list = Array.from(document.querySelectorAll(".item-list .item"));
    return list?.length ? {
        id: list.at(0).dataset.id,
        order: list.reduce((order, item, index)=>({
                ...order,
                [item.dataset.id]: index
            }), {})
    } : undefined;
}
function $64a84e97a08b3b3f$var$getDOMTimes() {
    return Array.from(document.querySelectorAll(".item-list .item")).reduce((times, item)=>({
            ...times,
            [item.dataset.id]: parseInt(item.dataset.initial)
        }), {});
}


class $1464aabbdbd5323e$export$ef852775387a0be7 {
    toString(val) {
        return (typeof val == "object" ? JSON.stringify(val) : val).toString();
    }
    parse(text) {
        if (text === undefined) return undefined;
        if (/^\d+\.\d+$/.test(text)) return text;
        try {
            return JSON.parse(text) ?? undefined;
        } catch (e) {
            return text;
        }
    }
}
class $1464aabbdbd5323e$export$2d674d9c0f16876f {
}
class $1464aabbdbd5323e$export$2c32508fceb0b7d7 extends $1464aabbdbd5323e$export$2d674d9c0f16876f {
    productSerializer() {
        return new $1464aabbdbd5323e$export$ef852775387a0be7();
    }
    attemptSerializer() {
        return new $1464aabbdbd5323e$export$ef852775387a0be7();
    }
    quizSerializer() {
        return new $1464aabbdbd5323e$export$ef852775387a0be7();
    }
    itemSerializer() {
        return new $1464aabbdbd5323e$export$ef852775387a0be7();
    }
    constructor(){
        super();
    }
}
class $1464aabbdbd5323e$export$d62b1df74ba6e622 {
    globalStateInitializer() {
        return undefined;
    }
    attemptStateInitializer() {
        return undefined;
    }
}
class $1464aabbdbd5323e$export$5280b677eac0c76a extends $1464aabbdbd5323e$export$d62b1df74ba6e622 {
}
class $1464aabbdbd5323e$export$38b278769d00aab0 extends $1464aabbdbd5323e$export$d62b1df74ba6e622 {
}


class $5eb91562a72e7d98$export$36e5777a1ba4b7c3 {
    constructor(datasource){
        this.datasource = datasource ?? new (0, $be240fd33780548d$export$ae632c642b63b623)(new (0, $1464aabbdbd5323e$export$ef852775387a0be7)());
    }
}
class $5eb91562a72e7d98$export$72ef117007f4001a {
    itemIdSerializer() {
        throw new Error("Method not implemented.");
    }
    getItemList() {
        throw new Error("Method not implemented.");
    }
    getItemIdMap(items) {
        throw new Error("Method not implemented.");
    }
    getItemIndexMap(items) {
        throw new Error("Method not implemented.");
    }
    getFilteredItems(items, filters) {
        throw new Error("Method not implemented.");
    }
    setAttributes(id, data) {
        throw new Error("Method not implemented.");
    }
}



class $fd94f3d84008c02d$export$3e1dbb683a4d88c6 {
    constructor(datasource){
        this.datasource = datasource ?? new (0, $6d853ffbfbdd7463$export$95988b6ca30adf97)();
    }
}
class $fd94f3d84008c02d$export$33ae4e2ef38782b3 {
    getProductId() {
        throw new Error("Method not implemented.");
    }
    getAttempt() {
        throw new Error("Method not implemented.");
    }
    getUrl() {
        throw new Error("Method not implemented.");
    }
    getScreenshot() {
        throw new Error("Method not implemented.");
    }
}



class $5910a18df0888d73$export$a8921d56ff297fe8 {
    constructor(datasource){
        this.datasource = datasource ?? new (0, $176d69903c7f2815$export$bf54c4b5936c5b07)();
    }
}
class $5910a18df0888d73$export$edaf4238104c4f64 {
    getItem(product, id, randomize) {
        throw new Error("Method not implemented.");
    }
    getSameContexts(a, b) {
        throw new Error("Method not implemented.");
    }
    setUserData(product, attempt, item, data) {
        throw new Error("Method not implemented.");
    }
    setPing(product, attempt, times) {
        throw new Error("Method not implemented.");
    }
    setFinished(product, attempt) {
        throw new Error("Method not implemented.");
    }
}




class $101491ae16521a44$export$408de2e5b2acd098 {
    constructor(datasource){
        this.datasource = datasource ?? new (0, $eb776a821ef0bbbf$export$751df6884de3660e)(new (0, $1464aabbdbd5323e$export$ef852775387a0be7)());
    }
}
class $101491ae16521a44$export$513441d6e4420a8e {
    getOverviewScores() {
        throw new Error("Method not implemented.");
    }
    getReviewScores() {
        throw new Error("Method not implemented.");
    }
    getTotalScores() {
        throw new Error("Method not implemented.");
    }
}



class $2599da8a0112b4f5$export$90d6e7d0a021328f {
    constructor(datasource){
        this.datasource = datasource ?? new (0, $c1a89ddac7c2b3d8$export$3a813530d8410010)();
    }
}
class $2599da8a0112b4f5$export$e1450684f5bce58a {
    getKeyboardShortcuts() {
        throw new Error("Method not implemented.");
    }
    setKeyboardShortcuts(enabled) {
        throw new Error("Method not implemented.");
    }
    getFontSize() {
        throw new Error("Method not implemented.");
    }
    setFontSize(size) {
        throw new Error("Method not implemented.");
    }
    getRandomize() {
        throw new Error("Method not implemented.");
    }
    setRandomize(randomize) {
        throw new Error("Method not implemented.");
    }
    toggleTimer() {
        throw new Error("Method not implemented.");
    }
    getEmailSuggestion(email) {
        throw new Error("Method not implemented.");
    }
    sendErrorReport(product, form) {
        throw new Error("Method not implemented.");
    }
    appendError(error) {
        throw new Error("Method not implemented.");
    }
    getErrors() {
        throw new Error("Method not implemented.");
    }
    clearErrors() {
        throw new Error("Method not implemented.");
    }
    getLocalStorage() {
        throw new Error("Method not implemented.");
    }
}




class $9fc514620fc133ee$export$49ca3e4dd873795e {
    constructor(datasource){
        this.datasource = datasource ?? new (0, $434124d31c68176b$export$392ca719850ca6c)(new (0, $64a84e97a08b3b3f$export$d47831b07ee709a2)());
    }
}
class $9fc514620fc133ee$export$18e6dfbbcae9b8e5 {
    getInitialState(config) {
        throw new Error("Method not implemented.");
    }
    setState(state) {
        throw new Error("Method not implemented.");
    }
    updateState(state) {
        throw new Error("Method not implemented.");
    }
}








class $7da36b87c3d781bf$export$2e2bcd8739ae039 {
    static retryPromise(promiseFunction, catchHandler, retries = 3) {
        return retries > 0 ? promiseFunction().catch((error)=>{
            catchHandler && catchHandler();
            return Promise.resolve(this.retryPromise(promiseFunction, catchHandler, retries - 1));
        }) : Promise.reject();
    }
    constructor({ metadata: metadata, list: list, item: item, score: score, settings: settings, state: state }){
        this.metadata = metadata ?? new (0, $fd94f3d84008c02d$export$33ae4e2ef38782b3)();
        this.list = list ?? new (0, $5eb91562a72e7d98$export$72ef117007f4001a)();
        this.item = item ?? new (0, $5910a18df0888d73$export$edaf4238104c4f64)();
        this.score = score ?? new (0, $101491ae16521a44$export$513441d6e4420a8e)();
        this.settings = settings ?? new (0, $2599da8a0112b4f5$export$e1450684f5bce58a)();
        this.state = state ?? {
            global: new (0, $9fc514620fc133ee$export$18e6dfbbcae9b8e5)(),
            attempt: new (0, $9fc514620fc133ee$export$18e6dfbbcae9b8e5)()
        };
    }
}


var $a1ce5267824943fb$export$2e2bcd8739ae039 = (0, $7da36b87c3d781bf$export$2e2bcd8739ae039);


class $db239e2e31b1c306$export$eddf153237ef6277 extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$3dd7a8e950550ea4).type, (e)=>this.answer(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$2dd9981939617ffa).type, ()=>this.finish(app));
    }
    answer(app, answer) {
        const current = app.current.get();
        let item;
        Promise.all([
            app.model.metadata.getProductId(),
            app.model.metadata.getAttempt(),
            app.content.get(current).catch(()=>undefined),
            app.content.meta(current)
        ]).then(([product, attempt, content, meta])=>{
            item = content?.id ?? meta.id;
            app.view.list.displaySelectedAnswer(item, answer, "loading");
            const userdata = app.userdata.set(current, item, {
                answer: answer
            });
            return (0, $a1ce5267824943fb$export$2e2bcd8739ae039).retryPromise(()=>app.model.item.setUserData(product, attempt, item, userdata)).then(()=>({
                    item: item,
                    userdata: userdata,
                    type: content?.type
                }));
        }).then(({ item: item, userdata: userdata, type: type })=>{
            app.model.list.setAttributes(item, userdata);
            if (type) {
                if (current === app.current.get()) app.view.item.displaySelectedAnswer(type, answer);
                app.view.header.displayProgress(app.view.chart.getTestProgressChart(), app.userdata.count((u)=>!!u?.answer), app.content.count());
                app.view.list.displaySelectedAnswer(item, answer);
            }
        }).catch((err)=>{
            if (item) app.view.list.displaySelectedAnswer(item, answer, "error");
        });
    }
    finish(app) {
        app.view.item.displayFinishing("loading");
        Promise.all([
            app.model.metadata.getProductId(),
            app.model.metadata.getAttempt()
        ]).then((record)=>({
                product: record[0],
                attempt: record[1]
            })).then((record)=>app.model.item.setFinished(record.product, record.attempt)).then((url)=>{
            app.view.item.displayResults(url);
        }).catch(()=>{
            app.view.item.displayFinishing("error");
        });
    }
}




class $5752384e8bfe6d9b$export$dd9fa483d192d6fb extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$496df437b1d8b378).type, ()=>this.tick(app));
        target.addEventListener((0, $7923788bad7460a0$export$520d21ef8265dbf2).type, ()=>this.ping(app));
        target.addEventListener((0, $7923788bad7460a0$export$60458c85dad92def).type, (e)=>this.pause(app, e.detail));
    }
    tick(app) {
        const total = app.timer.total();
        app.view.header.displayTotalTime(total);
        if (app.timer.config.autoAdvance) {
            const now = new Date().getTime();
            app.view.header.displayCountdownTime(app.timer.config.advanceRate - (now - app.timer.lastAdvance));
        }
    }
    ping(app) {
        Promise.all([
            app.model.metadata.getProductId(),
            app.model.metadata.getAttempt(),
            app.model.list.getItemIndexMap(),
            Promise.all(app.timer.recent().map(({ index: index, time: time })=>app.content.meta(index).then((item)=>({
                        item: item,
                        time: time
                    }))))
        ]).then(([product, attempt, indices, times])=>Promise.all([
                app.model.item.setPing(product, attempt, times),
                app.model.state.attempt.updateState({
                    times: app.timer.serializeTimes(indices)
                })
            ]));
    }
    pause(app, pause) {
        if (pause) app.timer.pause(app.current.get());
        else app.timer.unpause(app.current.get());
        app.model.state.global.updateState({
            timer: {
                timed: app.timer.config.timed
            }
        });
        app.view.item.displayPauseModal(app.getJquery(), pause);
        app.view.settings.displayTimed(!pause);
    }
}




class $f92fdaceb3176414$export$9d0ff824ea846a5 extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$5aedb0666ade7cfe).type, (e)=>this.flip(app, e.detail));
        target.addEventListener((0, $7923788bad7460a0$export$7ba22761268648c5).type, ()=>this.advance(app));
        target.addEventListener((0, $7923788bad7460a0$export$496df437b1d8b378).type, ()=>this.tick(app));
        target.addEventListener((0, $7923788bad7460a0$export$20655a32208d5ee9).type, ()=>this.reset(app));
        target.addEventListener((0, $7923788bad7460a0$export$318fb9566749373b).type, (e)=>this.randomize(app, e.detail));
    }
    tick(app) {
        const current = app.current.get();
        const total = app.timer.total([
            current
        ]);
        app.view.header.displayCurrentTime(total);
    }
    advance(app) {
        const bindTarget = app.view.getBindTarget();
        const answer_visible = app.current.getAnswerVisible();
        if (answer_visible) {
            const current = app.current.get();
            const nextTest = app.current.getAdjacent(1);
            if (nextTest === current) bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$f072eab12773765c)(false));
            else bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$9a0c977f93e56706)());
        } else bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$5aedb0666ade7cfe)(false));
    }
    flip(app, front) {
        const current = app.current.get();
        app.timer.switch(current, current, {
            front: front
        });
        app.current.setAnswerVisible(!front);
        app.view.header.displayFlip(front);
        if (front) app.view.item.displayCardFront();
        else app.view.item.displayCardBack();
    }
    reset(app) {
        const bindTarget = app.view.getBindTarget();
        return app.model.list.getItemList().then((items)=>{
            const update = app.model.state.attempt.updateState({
                times: {}
            });
            items.forEach((item)=>app.model.list.setAttributes(item.id, {
                    initial: 0
                }));
            app.timer.reset(app.current.get());
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$496df437b1d8b378)());
            return update;
        });
    }
    randomize(app, randomize) {
        const bindTarget = app.view.getBindTarget();
        const order = app.current.randomize(randomize);
        app.model.settings.setRandomize(randomize);
        app.view.header.displayRandomize(randomize);
        app.view.list.displaySorted(order);
        const current = app.current.get();
        app.model.list.getItemIndexMap().then((map)=>{
            Promise.all([
                app.model.state.global.updateState({
                    settings: {
                        randomize: randomize
                    }
                }),
                app.model.state.attempt.updateState({
                    current: app.current.serialize(map)
                })
            ]);
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$f210b93e2bf140a8)(map[current]));
        });
    }
}





class $c8fe73d8254dc161$export$f82952fa730e5523 extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$71f5f68be44498fe).type, (e)=>this.flag(app, e.detail));
    }
    flag(app, flagged) {
        const current = app.current.get();
        let item;
        Promise.all([
            app.model.metadata.getProductId(),
            app.model.metadata.getAttempt(),
            app.content.get(current).catch(()=>undefined),
            app.content.meta(current)
        ]).then(([product, attempt, content, meta])=>{
            item = content?.id ?? meta.id;
            app.view.list.displayFlagged(item, flagged, "loading");
            const userdata = app.userdata.set(current, item, {
                flagged: flagged
            });
            return (0, $a1ce5267824943fb$export$2e2bcd8739ae039).retryPromise(()=>app.model.item.setUserData(product, attempt, item, userdata)).then(()=>({
                    item: item,
                    flagged: flagged,
                    userdata: userdata
                }));
        }).then(({ item: item, flagged: flagged, userdata: userdata })=>{
            app.model.list.setAttributes(item, userdata);
            if (app.current.get() === current) app.view.header.displayFlag(flagged);
            app.view.list.displayFlagged(item, flagged);
        }).catch((err)=>{
            if (item) app.view.list.displayFlagged(item, flagged, "error");
        });
    }
}






class $659eb18cb7f7e0eb$export$301814721d6367cd extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$49a1ecce8d203).type, ()=>this.init(app));
    }
    init(app) {
        app.view.init(app);
        app.view.item.displayLoading("loading");
        app.model.list.getItemList().then((items)=>Promise.all([
                app.model.metadata.getProductId(),
                app.model.metadata.getAttempt(),
                Promise.resolve(items),
                app.model.list.getItemIdMap(items),
                app.model.list.getItemIndexMap(items),
                app.model.state.global.getInitialState(app.config.timer).catch(()=>undefined),
                app.model.state.attempt.getInitialState(app.config.timer).catch(()=>undefined)
            ])).then(([product, attempt, items, ids, indices, globalState, attemptState])=>{
            const bindTarget = app.view.getBindTarget();
            if (globalState) {
                bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$b289c91fe03907fc)(globalState.settings.fontsize));
                app.model.settings.setRandomize(globalState.settings.randomize);
            }
            app.content.init(items, product, app);
            const randomize = app.model.settings.getRandomize();
            app.current.init(items, attemptState?.current, randomize, ids, app.model.list.itemIdSerializer());
            app.filter.init(Array.from(document.querySelectorAll(".filter input:not(.invisible)")).map((input)=>new (0, $43dd4374f28efe45$export$ce3e5ea407eb882e)(input.dataset.filter)), []);
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3e02572c0fd6d3b9)((0, $e6d9787dca477675$export$2e2bcd8739ae039).parseURLFilters()));
            app.userdata.init(product, attempt, items, app);
            app.timer.init(bindTarget, {
                ...app.config.timer,
                ...globalState?.timer
            }, attemptState?.times, ids);
            const state = app.serialize(indices);
            Promise.all([
                app.model.state.global.setState(state.global),
                app.model.state.attempt.setState(state.attempt)
            ]);
            app.view.header.displayRandomize(randomize);
            app.view.list.displaySorted(app.current.getOrder());
            const jumpTarget = decodeURIComponent(location.hash.replace(/^#/, "")) || indices[app.current.get()];
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$509c5ab4bb810af8)(jumpTarget));
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$60458c85dad92def)(!app.timer.getTimed()));
        });
    }
}






class $0a82fcbcced4b81d$export$adeb52c9baa7df67 extends (0, $b83c1641700d7d2a$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$49a1ecce8d203).type, ()=>this.init(app));
    }
    init(app) {
        app.view.init(app);
        app.model.list.getItemList().then((items)=>Promise.all([
                app.model.metadata.getProductId(),
                app.model.metadata.getAttempt(),
                Promise.resolve(items),
                app.model.list.getItemIdMap(items),
                app.model.list.getItemIndexMap(items),
                app.model.state.global.getInitialState(app.config.timer).catch(()=>undefined),
                app.model.state.attempt.getInitialState(app.config.timer).catch(()=>undefined)
            ])).then(([product, attempt, items, ids, indices, globalState, attemptState])=>{
            const randomize = app.model.settings.getRandomize();
            app.current.init(items, attemptState?.current, randomize, ids, app.model.list.itemIdSerializer());
            app.filter.init(Array.from(document.querySelectorAll(".filter input:not(.invisible)")).map((input)=>new (0, $43dd4374f28efe45$export$ce3e5ea407eb882e)(input.dataset.filter)), []);
            app.view.getBindTarget().dispatchEvent(new (0, $7923788bad7460a0$export$3e02572c0fd6d3b9)((0, $e6d9787dca477675$export$2e2bcd8739ae039).parseURLFilters()));
            app.userdata.init(product, attempt, items, app);
            const state = app.serialize(indices);
            Promise.all([
                app.model.state.global.setState(state.global),
                app.model.state.attempt.setState(state.attempt)
            ]);
            app.view.list.displaySorted(app.current.getOrder());
        });
    }
}



var $71dcbf4eb844fc85$export$2e2bcd8739ae039 = (0, $b83c1641700d7d2a$export$2e2bcd8739ae039);




class $6bbf0661748359c7$export$2e2bcd8739ae039 {
    init(items, product, app) {
        this.product = product;
        this.list = items;
        this.app = app;
    }
    fetch(index) {
        this.queued[index] = (0, $a1ce5267824943fb$export$2e2bcd8739ae039).retryPromise(()=>this.app.model.item.getItem(this.product, this.list[index].id, this.app.config.randomizeAnswers)).then((content)=>{
            content.name = this.list[index].name;
            this.items[index] = content;
            return content;
        });
        return this.queued[index];
    }
    get(index) {
        if (index in this.items) return Promise.resolve(this.items[index]);
        else if (index in this.queued) return this.queued[index];
        else return this.fetch(index);
    }
    meta(index) {
        if (index in this.list) return Promise.resolve(this.list[index]);
        else return Promise.reject();
    }
    remove(index) {
        let item = index in this.queued ? this.queued[index] : index in this.items ? Promise.resolve(this.items[index]) : Promise.resolve(undefined);
        if (index in this.queued) delete this.queued[index];
        if (index in this.items) delete this.items[index];
        return item;
    }
    count() {
        return this.list.length;
    }
    constructor(){
        this.list = [];
        this.items = {};
        this.queued = {};
    }
}



class $8d9015e5a183dade$export$2e2bcd8739ae039 {
    init(items, state, randomize, map, serializer) {
        const keys = Array.from(items.keys());
        this.items = items;
        this.index = state?.id ? map?.[state.id] ?? 0 : 0;
        this.active = keys;
        this.order = Object.entries(randomize ? state?.order ?? {} : {}).reduce((result, [id, order])=>{
            result[order] = map[id];
            return result;
        }, keys);
        if (randomize) {
            this.order = this.order.filter((_, i)=>Object.values(state?.order ?? {}).includes(i)).filter((v)=>v !== undefined);
            Object.entries(map).filter(([id])=>!Object.keys(state?.order ?? {}).includes(id)).forEach(([, order])=>{
                this.order.splice(Math.floor(Math.random() * (this.order.length + 1)), 0, order);
            });
        }
        this.ordered_active = keys;
        this.serializer = serializer;
        this.update();
    }
    get() {
        return this.index;
    }
    getOrder() {
        return this.order;
    }
    getPosition() {
        const i = this.ordered_active.findIndex((index)=>index === this.index);
        return i >= 0 ? i : 0;
    }
    getVisible() {
        return this.ordered_active;
    }
    getAdjacent(offset) {
        if (offset === 0) return this.index;
        const i = this.ordered_active.findIndex((a)=>a === this.index);
        if (i >= 0) {
            if (offset < 0 && i + offset >= 0 || offset > 0 && i + offset < this.ordered_active.length) return this.ordered_active[i + offset];
            return this.index;
        } else return this.ordered_active.at(0) ?? this.index;
    }
    last() {
        return this.items.length - 1;
    }
    set(index) {
        this.index = index;
        return this.index;
    }
    jump(item) {
        const found = this.items.findIndex((i)=>this.compare(i.id, item));
        this.index = found < 0 ? this.index : found;
        return found;
    }
    next() {
        this.index = this.getAdjacent(1);
        return this.index;
    }
    previous() {
        this.index = this.getAdjacent(-1);
        return this.index;
    }
    setActive(filtered) {
        this.active = this.items.map((item)=>filtered.some((filter)=>this.compare(filter.id, item.id))).map((match, index)=>match ? index : -1).filter((index)=>index >= 0);
        this.update();
        return this.active;
    }
    getAnswerVisible() {
        return this.answer_visible;
    }
    setAnswerVisible(visible) {
        this.answer_visible = visible;
        return this.answer_visible;
    }
    randomize(randomize) {
        if (randomize) $8d9015e5a183dade$export$2e2bcd8739ae039.shuffle(this.order);
        else this.order.sort((a, b)=>a - b);
        this.update();
        this.index = this.ordered_active.at(0) ?? this.index;
        return this.order;
    }
    update() {
        this.ordered_active = Array.from(this.order.values()).filter((i)=>this.active.includes(i));
        return this.ordered_active;
    }
    serialize(map) {
        return {
            id: map[this.index],
            order: this.order.reduce((result, index, order)=>{
                return {
                    ...result,
                    [map[index]]: order
                };
            }, {})
        };
    }
    compare(a, b) {
        return this.serializer.toString(a) === this.serializer.toString(b);
    }
    // Relocated to static class functions for testability. ---
    /**
	 * The `shuffle()` method shuffles the elements of an array in place and
	 * returns the shuffled array. This method adheres to the same conditions
	 * as `Array.sort()` at the time of writing. Note that, like `Array.sort()`,
	 * the array is shuffled in place, and no copy is made. __Unlike__
	 * `Array.sort()`, `shuffle()` does not provide a stable "sort".
	 *
	 * @param array An array to shuffle.
	 * @return The in place shuffled array.
	 */ static shuffle(array) {
        for(let i = array.length - 1; i >= 0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            const temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    }
    constructor(){
        this.index = 0;
        this.items = [];
        this.active = [];
        this.order = [];
        this.ordered_active = [];
        this.serializer = new (0, $1464aabbdbd5323e$export$ef852775387a0be7)();
    }
}





class $93c1294deb7f14f4$export$c57e9b2d8b9e4de {
    init(bindTarget, config, times, map) {
        this.config = config;
        this.target = bindTarget;
        this.lastTick = new Date().getTime();
        this.initial = Object.entries(times ?? {}).reduce((result, [id, time])=>({
                ...result,
                [map[id]]: time
            }), {});
        setInterval(()=>{
            const now = new Date().getTime();
            this.lastTick = this.check(now, this.lastTick, this.config.tickRate, ()=>{
                this.tick();
            });
        }, this.config.resolution);
    }
    tick() {
        const now = new Date().getTime();
        this.lastPing = this.check(now, this.lastPing, this.config.pingRate, ()=>{
            this.target.dispatchEvent(new (0, $7923788bad7460a0$export$520d21ef8265dbf2)());
        });
        if (this.config.autoAdvance) this.lastAdvance = this.check(now, this.lastAdvance, this.config.advanceRate, ()=>{
            this.target.dispatchEvent(new (0, $7923788bad7460a0$export$7ba22761268648c5)());
        }, this.config.resolution);
        this.target.dispatchEvent(new (0, $7923788bad7460a0$export$496df437b1d8b378)());
    }
    check(now, then, rate, event, epsilon = 0) {
        if (now - then >= rate - epsilon) {
            event();
            return then + rate * Math.trunc((now - then + epsilon) / rate);
        } else return then;
    }
    switch(previous, next, extras) {
        const now = new Date().getTime();
        if (previous in this.times && this.times[previous].length > 0 && this.times[previous].at(-1)?.end === undefined) {
            const lastTime = this.times[previous].at(-1);
            lastTime.end = now;
        }
        if (!(next in this.times)) this.times[next] = [];
        this.times[next].push({
            start: now,
            timed: this.config.timed,
            extras: extras
        });
        this.lastAdvance = now;
        this.target.dispatchEvent(new (0, $7923788bad7460a0$export$520d21ef8265dbf2)());
    }
    total(indices) {
        const hasKey = ([index, _])=>indices?.includes(parseInt(index)) ?? true;
        return Object.entries(this.times).filter(hasKey).flatMap(([, times])=>times).filter((time)=>time.timed).reduce((result, time)=>result + ((time.end ?? Date.now()) - time.start), Object.entries(this.initial).filter(hasKey).reduce((result, [, time])=>result + time, 0));
    }
    recent() {
        return Object.keys(this.times).flatMap((index)=>this.times[index].map((time)=>({
                    index: parseInt(index),
                    time: time
                }))).sort((a, b)=>a.time.start - b.time.start).slice(-this.config.recentCount);
    }
    toggleAutoAdvance(enable) {
        const now = new Date().getTime();
        this.config.autoAdvance = enable;
        this.lastAdvance = now;
    }
    setAdvanceInterval(interval) {
        const now = new Date().getTime();
        this.config.advanceRate = interval;
        this.lastAdvance = now;
    }
    serializeTimes(map) {
        return Object.keys(this.times).concat(Object.keys(this.initial)).reduce((result, index)=>({
                ...result,
                [map[index]]: this.total([
                    parseInt(index)
                ])
            }), {});
    }
    serializeSettings() {
        const { advanceRate: advanceRate, autoAdvance: autoAdvance, timed: timed } = this.config;
        return {
            advanceRate: advanceRate,
            autoAdvance: autoAdvance,
            timed: timed
        };
    }
    getTimed() {
        return this.config.timed;
    }
    constructor(){
        this.lastTick = 0;
        this.lastPing = 0;
        this.lastAdvance = 0;
        this.initial = {};
        this.times = {};
    }
}
class $93c1294deb7f14f4$export$b4a7ed2c8d7277a8 extends $93c1294deb7f14f4$export$c57e9b2d8b9e4de {
    viewContext(current, context) {
        throw new Error("Method not implemented.");
    }
    pause(current) {
        throw new Error("Method not implemented.");
    }
    unpause(current) {
        throw new Error("Method not implemented.");
    }
    reset(current) {
        throw new Error("Method not implemented.");
    }
}
class $93c1294deb7f14f4$export$b33320980f57f42d extends $93c1294deb7f14f4$export$c57e9b2d8b9e4de {
    viewContext(current, context) {
        if (current in this.times) {
            const lastTime = this.times[current].at(-1);
            if (lastTime.extras) lastTime.extras.contexts_viewed[context] = true;
        }
    }
    pause(current) {
        if (current in this.times && this.times[current].length > 0 && this.times[current].at(-1).end === undefined) {
            const lastTime = this.times[current].at(-1);
            lastTime.end = new Date().getTime();
        }
    }
    unpause(current) {
        if (!(current in this.times)) this.times[current] = [];
        const lastTime = this.times[current].at(-1);
        const now = Date.now();
        if (lastTime && lastTime.end === undefined) lastTime.end = now;
        this.times[current].push({
            start: now,
            timed: this.config.timed,
            extras: lastTime?.extras
        });
    }
    reset(current) {
        throw new Error("Method not implemented.");
    }
}
class $93c1294deb7f14f4$export$b73fed17745a4293 extends $93c1294deb7f14f4$export$c57e9b2d8b9e4de {
    viewContext(current, context) {
        throw new Error("Method not implemented.");
    }
    pause(current) {
        if (!(current in this.times)) this.times[current] = [];
        const lastTime = this.times[current].at(-1);
        const now = Date.now();
        const timed = this.config.timed = false;
        if (lastTime && lastTime.end === undefined) lastTime.end = now;
        this.times[current].push({
            start: now,
            timed: timed,
            extras: lastTime?.extras
        });
    }
    unpause(current) {
        if (!(current in this.times)) this.times[current] = [];
        const lastTime = this.times[current].at(-1);
        const now = Date.now();
        const timed = this.config.timed = true;
        if (lastTime && lastTime.end === undefined) lastTime.end = now;
        this.times[current].push({
            start: now,
            timed: timed,
            extras: lastTime?.extras
        });
    }
    reset(current) {
        const lastTime = this.times[current].at(-1);
        this.switch(current, current, lastTime.extras);
        this.lastTick = this.lastPing = new Date().getTime();
        this.initial = {};
        this.times = {
            [current]: [
                this.times[current].at(-1)
            ]
        };
    }
}


class $edbffc7b79aebee8$export$2e2bcd8739ae039 {
    init(product, attempt, items, app) {
        this.product = product;
        this.app = app;
        this.attempt = attempt;
        this.userdata = items.reduce((result, item, index)=>{
            const annotations = this._parse(item);
            if (Object.keys(annotations).length) result[index] = annotations;
            return result;
        }, {});
    }
    _parse(item) {
        const annotations = {};
        if (typeof item.answer !== "undefined") annotations.answer = item.answer;
        if (typeof item.flagged !== "undefined") annotations.flagged = item.flagged;
        return annotations;
    }
    get(index) {
        return index in this.userdata ? this.userdata[index] : null;
    }
    set(index, id, data) {
        this.userdata[index] = {
            ...this.get(index) || {},
            ...data
        };
        return this.userdata[index];
    }
    count(filter = ()=>true) {
        return Object.keys(this.userdata).filter((key)=>this.userdata[key]).filter((key)=>filter(this.userdata[key])).length;
    }
    constructor(){
        this.userdata = {};
    }
}



class $acbd43c9906036f0$export$ab7fb13f8d285a70 extends (0, $fd94f3d84008c02d$export$3e1dbb683a4d88c6) {
    getProductId() {
        return this.datasource.getProductId();
    }
    getAttempt() {
        return this.datasource.getAttempt();
    }
    getUrl() {
        return this.datasource.getUrl();
    }
    getScreenshot() {
        return this.datasource.getScreenshot();
    }
    constructor(datasource){
        super(datasource);
    }
}
class $acbd43c9906036f0$export$160d9f4404450dab extends (0, $5910a18df0888d73$export$a8921d56ff297fe8) {
    getItem(product, id, randomize) {
        return this.datasource.getItem(product, id, randomize);
    }
    getSameContexts(a, b) {
        throw new Error("Method not implemented.");
    }
    setUserData(product, attempt, item, data) {
        return this.datasource.setUserData(product, attempt, item, data);
    }
    setPing(product, attempt, times) {
        return this.datasource.setPing(product, attempt, "flash", times);
    }
    setFinished(product, attempt) {
        return this.datasource.setFinished(product, attempt);
    }
    constructor(datasource){
        super(datasource);
    }
}



class $65fd8e9c390e16cf$export$3247fa725e92f7aa extends (0, $5eb91562a72e7d98$export$36e5777a1ba4b7c3) {
    itemIdSerializer() {
        return this.datasource.itemIdSerializer;
    }
    getItemList() {
        return this.datasource.getItemList();
    }
    getItemIdMap(items) {
        return (items ? Promise.resolve(items) : this.datasource.getItemList()).then((items)=>{
            return items.reduce((result, item, index)=>({
                    ...result,
                    [this.itemIdSerializer().toString(item.id)]: index
                }), {});
        });
    }
    getItemIndexMap(items) {
        return (items ? Promise.resolve(items) : this.datasource.getItemList()).then((items)=>{
            return items.map((item)=>this.itemIdSerializer().toString(item.id));
        });
    }
    getFilteredItems(items, filters) {
        return this.datasource.getFilteredItems(items, filters);
    }
    setAttributes(id, data) {
        return this.datasource.setAttributes(id, data);
    }
    constructor(datasource){
        super(datasource);
    }
}
class $65fd8e9c390e16cf$export$1e241e1a557fe85f extends (0, $2599da8a0112b4f5$export$90d6e7d0a021328f) {
    getKeyboardShortcuts() {
        return this.datasource.getKeyboardShortcuts();
    }
    setKeyboardShortcuts(enabled) {
        this.datasource.setKeyboardShortcuts(enabled);
    }
    getFontSize() {
        return this.datasource.getFontSize();
    }
    setFontSize(size) {
        this.datasource.setFontSize(size);
    }
    getRandomize() {
        return this.datasource.getRandomize();
    }
    setRandomize(randomize) {
        this.datasource.setRandomize(randomize);
    }
    toggleTimer() {
        return this.datasource.toggleTimer();
    }
    getEmailSuggestion(email) {
        return this.datasource.getEmailSuggestion(email);
    }
    sendErrorReport(product, form) {
        return this.datasource.sendErrorReport(product, form);
    }
    appendError(error) {
        return this.datasource.appendError(error);
    }
    getErrors() {
        return this.datasource.getErrors();
    }
    clearErrors() {
        return this.datasource.clearErrors();
    }
    getLocalStorage() {
        return this.datasource.getLocalStorage(this.datasource.getLocalStoragePrefix());
    }
    constructor(datasource){
        super(datasource);
    }
}
class $65fd8e9c390e16cf$export$43deca918d12a831 extends (0, $9fc514620fc133ee$export$49ca3e4dd873795e) {
    getInitialState(config) {
        return this.datasource.getInitialState(config);
    }
    setState(state) {
        return this.datasource.setState(state);
    }
    updateState(state) {
        return this.datasource.updateState(state);
    }
    constructor(datasource){
        super(datasource);
    }
}





class $f4437f1565542c94$export$ad4c18518f7b40ba extends (0, $fd94f3d84008c02d$export$3e1dbb683a4d88c6) {
    getProductId() {
        return this.datasource.getProductId();
    }
    getAttempt() {
        throw new Error("Invalid Query: Overview does not have an attempt id");
    }
    getUrl() {
        return this.datasource.getUrl();
    }
    getScreenshot() {
        throw new Error("Method not implemented.");
    }
    constructor(datasource){
        super(datasource);
    }
}
class $f4437f1565542c94$export$6e5c9d23f15a050d extends (0, $101491ae16521a44$export$408de2e5b2acd098) {
    getOverviewScores() {
        return this.datasource.getOverviewScores().then((scores)=>{
            const result = Object.keys(scores).map((index)=>({
                    quiz: this.datasource.quizIdSerializer.parse(index),
                    data: scores[index]
                }));
            return result;
        }).catch((err)=>{
            // TODO: Instrumenting New Relic might help here. Need to
            //  use noticeError().
            console.error(err);
            return [];
        });
    }
    getReviewScores() {
        throw new Error("Method not implemented.");
    }
    getTotalScores() {
        throw new Error("Method not implemented.");
    }
    constructor(datasource){
        super(datasource);
    }
}



class $23ef5a606ebfeae9$export$f23c5d9ea3ade0cf extends (0, $fd94f3d84008c02d$export$3e1dbb683a4d88c6) {
    getProductId() {
        return this.datasource.getProductId();
    }
    getAttempt() {
        return this.datasource.getAttempt();
    }
    getUrl() {
        return this.datasource.getUrl();
    }
    getScreenshot() {
        return this.datasource.getScreenshot();
    }
    constructor(datasource){
        super(datasource);
    }
}
class $23ef5a606ebfeae9$export$8f32e90ddca8b9a1 extends (0, $5910a18df0888d73$export$a8921d56ff297fe8) {
    getItem(product, id, randomize) {
        return this.datasource.getItem(product, id, false);
    }
    getSameContexts(a, b) {
        return this.datasource.getSameContexts(a, b);
    }
    setUserData(product, attempt, item, data) {
        return this.datasource.setUserData(product, attempt, item, data);
    }
    setPing(product, attempt, times) {
        return this.datasource.setPing(product, attempt, "pq_review", times);
    }
    setFinished(product, attempt) {
        throw new Error("Method not implemented.");
    }
    constructor(datasource){
        super(datasource);
    }
}
class $23ef5a606ebfeae9$export$b98861793fb84195 extends (0, $101491ae16521a44$export$408de2e5b2acd098) {
    getOverviewScores() {
        throw new Error("Method not implemented.");
    }
    getReviewScores() {
        return this.datasource.getTableScores();
    }
    getTotalScores() {
        return this.datasource.getTotalScores();
    }
    constructor(datasource){
        super(datasource);
    }
}



class $c9cb9b4370d94384$export$a0007e43b5a1bad3 extends (0, $fd94f3d84008c02d$export$3e1dbb683a4d88c6) {
    getProductId() {
        return this.datasource.getProductId();
    }
    getAttempt() {
        return this.datasource.getAttempt();
    }
    getUrl() {
        return this.datasource.getUrl();
    }
    getScreenshot() {
        return this.datasource.getScreenshot();
    }
    constructor(datasource){
        super(datasource);
    }
}
class $c9cb9b4370d94384$export$5528a70bc0755d5d extends (0, $5910a18df0888d73$export$a8921d56ff297fe8) {
    getItem(product, id, randomize) {
        return this.datasource.getItem(product, id, randomize);
    }
    getSameContexts(a, b) {
        return this.datasource.getSameContexts(a, b);
    }
    setUserData(product, attempt, item, data) {
        return this.datasource.setUserData(product, attempt, item, data);
    }
    setPing(product, attempt, times) {
        return this.datasource.setPing(product, attempt, "pq_test", times);
    }
    setFinished(product, attempt) {
        return this.datasource.setFinished(product, attempt);
    }
    constructor(datasource){
        super(datasource);
    }
}


class $d0140d785b4d4210$export$14914237e9256338 {
    constructor(frontend){
        this.frontend = frontend;
    }
}
class $d0140d785b4d4210$export$4b2610d416869a9a {
    init(app) {}
    displayProgress(chart, complete, total) {
        throw new Error("Method not implemented.");
    }
    displayTotalScores(chart, total) {
        throw new Error("Method not implemented.");
    }
    displayItem(content) {
        throw new Error("Method not implemented.");
    }
    displayTotalTime(time) {
        throw new Error("Method not implemented.");
    }
    displayTimer(show) {
        throw new Error("Method not implemented.");
    }
    displayNext(show) {
        throw new Error("Method not implemented.");
    }
    displayPrevious(show) {
        throw new Error("Method not implemented.");
    }
    displayFinish(show) {
        throw new Error("Method not implemented.");
    }
    displayFlag(flagged) {
        throw new Error("Method not implemented.");
    }
    displayCountdown(show) {
        throw new Error("Method not implemented.");
    }
    displayCurrentTime(time) {
        throw new Error("Method not implemented.");
    }
    displayCountdownTime(time) {
        throw new Error("Method not implemented.");
    }
    displayRandomize(flagged) {
        throw new Error("Method not implemented.");
    }
    displayPosition(index, length) {
        throw new Error("Method not implemented.");
    }
}


class $438ea9632a36718a$export$84d0dd190d551cd1 {
    constructor(frontend){
        this.frontend = frontend;
    }
}
class $438ea9632a36718a$export$3894718be801ae9c {
    init(app) {}
    displaySelectedAnswer(item, answer, status) {
        throw new Error("Method not implemented.");
    }
    displayCurrent(index) {
        throw new Error("Method not implemented.");
    }
    displayFilters(filters, bindTarget) {
        throw new Error("Method not implemented.");
    }
    displayFiltered(filtered) {
        throw new Error("Method not implemented.");
    }
    displayFlagged(item, flagged, status) {
        throw new Error("Method not implemented.");
    }
    displaySorted(order) {
        throw new Error("Method not implemented.");
    }
}


class $f57f2c1271bc31b7$export$1d484b2d5074b6d8 extends CustomEvent {
    constructor(motion){
        super($f57f2c1271bc31b7$export$1d484b2d5074b6d8.type, {
            detail: motion
        });
    }
}
$f57f2c1271bc31b7$export$1d484b2d5074b6d8.type = "swipeup";
class $f57f2c1271bc31b7$export$a7c299767e50a03a extends CustomEvent {
    constructor(motion){
        super($f57f2c1271bc31b7$export$a7c299767e50a03a.type, {
            detail: motion
        });
    }
}
$f57f2c1271bc31b7$export$a7c299767e50a03a.type = "swipedown";
class $f57f2c1271bc31b7$export$c7ad1118445900ce extends CustomEvent {
    constructor(motion){
        super($f57f2c1271bc31b7$export$c7ad1118445900ce.type, {
            detail: motion
        });
    }
}
$f57f2c1271bc31b7$export$c7ad1118445900ce.type = "swipeleft";
class $f57f2c1271bc31b7$export$38dcc7c13021f798 extends CustomEvent {
    constructor(motion){
        super($f57f2c1271bc31b7$export$38dcc7c13021f798.type, {
            detail: motion
        });
    }
}
$f57f2c1271bc31b7$export$38dcc7c13021f798.type = "swiperight";
const $f57f2c1271bc31b7$var$default_config = {
    swipe_delta: 10
};
class $f57f2c1271bc31b7$export$2e2bcd8739ae039 {
    init(targets, config = $f57f2c1271bc31b7$var$default_config) {
        this.targets = targets;
        targets.forEach((target)=>{
            target.addEventListener("touchstart", (e)=>this.start(e));
            target.addEventListener("touchend", (e)=>this.end(e));
            target.addEventListener("touchmove", (e)=>this.swiped(e));
            target.addEventListener("touchcancel", (e)=>this.cancel(e));
        });
        this.config = config;
    }
    start(event) {
        this.history.push($f57f2c1271bc31b7$export$2e2bcd8739ae039.copyTouch(event));
        this.pending = true;
    }
    end(event) {
        if (this.pending) this.emit(this.history, event.target);
        this.cancel(event);
    }
    swiped(event) {
        if (!this.pending) return;
        const new_event = $f57f2c1271bc31b7$export$2e2bcd8739ae039.copyTouch(event);
        const last_event = this.history.at(-1);
        this.history.push(new_event);
        this.emit([
            last_event,
            new_event
        ], event.target);
    }
    cancel(event) {
        this.history = [];
        this.pending = false;
    }
    emit(source, target) {
        if (Array.isArray(source)) {
            const motion = this.diff(source.at(0), source.at(-1));
            if (!motion) return;
            this._emit(motion, target);
        } else this._emit(source, target);
    }
    _emit(motion, target) {
        if (motion.distance >= this.config.swipe_delta) {
            if (motion.horizontal) {
                target.dispatchEvent($f57f2c1271bc31b7$export$2e2bcd8739ae039.toEvent(motion));
                this.pending = false;
            }
        }
    }
    diff(a, b) {
        if (!a || !b) return undefined;
        const dx = b.touch.pageX - a.touch.pageX;
        const dy = b.touch.pageY - a.touch.pageY;
        const horizontal = Math.abs(dx) >= Math.abs(dy);
        const distance = Math.hypot(dx, dy);
        const direction = horizontal ? dx / Math.abs(dx) : dy / Math.abs(dy);
        const duration = b.timeStamp - a.timeStamp;
        return {
            horizontal: horizontal,
            distance: distance,
            dx: dx,
            dy: dy,
            delta: distance * direction,
            duration: duration
        };
    }
    // Relocated to static class functions for testability. ---
    static copyTouch(event) {
        const { touches: touches, timeStamp: timeStamp } = event;
        return {
            touch: touches.item(0),
            timeStamp: timeStamp
        };
    }
    static toEvent(motion) {
        const Swipe = motion.horizontal ? motion.delta >= 0 ? $f57f2c1271bc31b7$export$38dcc7c13021f798 : $f57f2c1271bc31b7$export$c7ad1118445900ce : motion.delta >= 0 ? $f57f2c1271bc31b7$export$a7c299767e50a03a : $f57f2c1271bc31b7$export$1d484b2d5074b6d8;
        return new Swipe(motion);
    }
    constructor(){
        this.history = [];
        this.pending = false;
    }
}


class $ba7ece8b7e297340$export$7e965828e2884d {
    displayItemContent(content, bindTarget) {
        const itemClass = this.displayItemClass(content);
        itemClass.hideItemTypes();
        itemClass.displayItemContent(content, bindTarget);
    }
    constructor(frontend){
        this.frontend = frontend;
        this.swipe = new (0, $f57f2c1271bc31b7$export$2e2bcd8739ae039)();
    }
}
class $ba7ece8b7e297340$export$5be22489d579af11 extends $ba7ece8b7e297340$export$7e965828e2884d {
    init(app) {}
    rebindKeyboard(app, type) {
        throw new Error("Method not implemented.");
    }
    displayLoading(status) {
        throw new Error("Method not implemented.");
    }
    displayFinishing(status) {
        throw new Error("Method not implemented.");
    }
    displaySelectedAnswer(answer) {
        throw new Error("Method not implemented.");
    }
    displayItemClass(content) {
        throw new Error("Method not implemented.");
    }
    displayItem(mathjax, content, bindTarget, answer, sameContext) {
        throw new Error("Method not implemented.");
    }
    toggleContexts(contexts) {
        throw new Error("Method not implemented.");
    }
    displayFontSize(fontSize) {
        throw new Error("Method not implemented.");
    }
    displayResults(url) {
        throw new Error("Method not implemented.");
    }
    displayPauseModal(jQuery, show) {
        throw new Error("Method not implemented.");
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        throw new Error("Method not implemented.");
    }
    displayItemSameContext(content, sameContexts) {
        throw new Error("Method not implemented.");
    }
    displayItemRendered(content, mathjax) {
        throw new Error("Method not implemented.");
    }
    displayItemAlerts(content) {
        throw new Error("Method not implemented.");
    }
    constructor(frontend){
        super(frontend);
    }
}


class $d97321baad67d913$export$b5fd6146180b74ff {
    constructor(frontend){
        this.frontend = frontend;
    }
}
class $d97321baad67d913$export$cfc084126dcdf983 {
    init(app) {}
    displayReviewScores(chart, scores) {
        throw new Error("Method not implemented.");
    }
}


class $0cd70bb5c18f46c5$export$7d05e0deed78c249 {
    constructor(frontend){
        this.frontend = frontend;
    }
}
class $0cd70bb5c18f46c5$export$74ac612000b40f4f {
    init(app) {}
    displayFontSize(size) {
        throw new Error("Method not implemented.");
    }
    displayKeyboardShortcuts(enabled) {
        throw new Error("Method not implemented.");
    }
    displayTimer(show) {
        throw new Error("Method not implemented.");
    }
    toggleShortcutModal(jQuery) {
        throw new Error("Method not implemented.");
    }
    displayErrorLoading(show) {
        throw new Error("Method not implemented.");
    }
    displayErrorModal(jQuery, url, item, filters, screenshot, errors, localStorage) {
        throw new Error("Method not implemented.");
    }
    hideErrorModal(jQuery, success, reason) {
        throw new Error("Method not implemented.");
    }
    displayInputSuggestion(element, suggestion) {
        throw new Error("Method not implemented.");
    }
    updateInputs(root, selector, value) {
        throw new Error("Method not implemented");
    }
    displayReportErrorMessage(message) {
        throw new Error("Method not implemented.");
    }
    displayAdvance(enable) {
        throw new Error("Method not implemented.");
    }
    displayAdvanceInterval(interval) {
        throw new Error("Method not implemented.");
    }
    displayTimed(enable) {
        throw new Error("Method not implemented.");
    }
}


class $3035e28da4cb4cd7$export$cffe4c650c020bcc {
    constructor(frontend){
        this.frontend = frontend;
    }
}
class $3035e28da4cb4cd7$export$c9e90b1df50bef86 {
    init(app) {}
    displayOverviewScores(chart, scores) {
        throw new Error("Method not implemented.");
    }
    toggleStart(element) {
        throw new Error("Method not implemented.");
    }
}


class $1980e00912dde01a$export$bcc1604b0ad6e68b {
    constructor(frontend){
        this.frontend = frontend;
    }
}
class $1980e00912dde01a$export$cac54e59b53e9be8 {
    init(app) {}
    displayTable(table, product) {
        throw new Error("Method not implemented.");
    }
}









class $9764fa64f8e41b70$export$ad29949578474ab2 {
    constructor(frontend){
        this.frontend = frontend;
    }
}
class $9764fa64f8e41b70$export$a385f30e5273fe5d extends $9764fa64f8e41b70$export$ad29949578474ab2 {
    init(app) {}
    getReviewTotalScoreChart() {
        throw new Error("Method not implemented.");
    }
    getReviewSectionScoreChart() {
        throw new Error("Method not implemented.");
    }
    getOverviewScoreChart() {
        throw new Error("Method not implemented.");
    }
    getTestProgressChart() {
        throw new Error("Method not implemented.");
    }
    getOverviewSummaryTable(jQuery) {
        throw new Error("Method not implemented.");
    }
}


const $f988e9e393868e1c$var$currentScript = document.currentScript;
class $f988e9e393868e1c$export$2e2bcd8739ae039 {
    init(app) {
        this.item.init(app);
        this.list.init(app);
        this.header.init(app);
        this.scores.init(app);
        this.settings.init(app);
        this.sections.init(app);
        this.summary.init(app);
        this.chart.init(app);
    }
    getBindTarget() {
        return this.bindTarget;
    }
    loadScript({ src: src, type: type, timeout: timeout = 5000 }) {
        return new Promise((resolve, reject)=>{
            const script = document.createElement("script");
            script.src = src;
            script.type = type ?? "text/javascript";
            $f988e9e393868e1c$var$currentScript.parentNode.insertBefore(script, $f988e9e393868e1c$var$currentScript);
            const resolver = ()=>{
                resolve(script);
            };
            const rejector = (err)=>{
                reject(err);
            };
            script.addEventListener("load", resolver);
            script.addEventListener("error", rejector);
            setTimeout(()=>{
                script.removeEventListener("load", resolver);
                script.removeEventListener("error", rejector);
                reject(new Error(JSON.stringify({
                    message: "Script timeout",
                    src: src,
                    type: type,
                    timeout: timeout
                })));
            }, timeout);
        });
    }
    constructor({ item: item, list: list, header: header, scores: scores, settings: settings, sections: sections, summary: summary, chart: chart }){
        this.item = item ?? new (0, $ba7ece8b7e297340$export$5be22489d579af11)();
        this.list = list ?? new (0, $438ea9632a36718a$export$3894718be801ae9c)();
        this.header = header ?? new (0, $d0140d785b4d4210$export$4b2610d416869a9a)();
        this.scores = scores ?? new (0, $d97321baad67d913$export$cfc084126dcdf983)();
        this.settings = settings ?? new (0, $0cd70bb5c18f46c5$export$74ac612000b40f4f)();
        this.sections = sections ?? new (0, $3035e28da4cb4cd7$export$c9e90b1df50bef86)();
        this.summary = summary ?? new (0, $1980e00912dde01a$export$cac54e59b53e9be8)();
        this.chart = chart ?? new (0, $9764fa64f8e41b70$export$a385f30e5273fe5d)();
        this.bindTarget = document.createElement("div");
        document.querySelector("body").append(this.bindTarget);
    }
}
class $f988e9e393868e1c$export$bce690a38ac79874 extends $f988e9e393868e1c$export$2e2bcd8739ae039 {
}
class $f988e9e393868e1c$export$206899e9c8562846 extends $f988e9e393868e1c$export$2e2bcd8739ae039 {
}


var $d1e98415768ae0f9$export$2e2bcd8739ae039 = (0, $f988e9e393868e1c$export$2e2bcd8739ae039);



class $b0bb53ddd8f5dc88$export$d92cfffd7fee6c42 extends (0, $d0140d785b4d4210$export$14914237e9256338) {
    init(app) {
        const bindTarget = app.view.getBindTarget();
        [
            this.frontend.getBindPause(),
            this.frontend.getBindFlag(),
            this.frontend.getBindRandomize()
        ].forEach((bind)=>bind.bind(bindTarget));
    }
    displayProgress(chart, complete, total) {
        throw new Error("Method not implemented.");
    }
    displayTotalScores(chart, total) {
        throw new Error("Method not implemented.");
    }
    displayItem(content) {
        this.frontend.displayItem(content);
    }
    displayTotalTime(time) {
        this.frontend.displayTotalTime(time);
    }
    displayTimer(show) {
        this.frontend.displayTimer(show);
    }
    displayNext(show) {
        this.frontend.displayNext(show);
    }
    displayPrevious(show) {
        this.frontend.displayPrevious(show);
    }
    displayFinish(show) {
        this.frontend.displayFinish(show);
    }
    displayFlag(flagged) {
        this.frontend.displayFlag(flagged);
    }
    displayFlip(front) {
        this.frontend.displayFlip(front);
    }
    displayCountdown(show) {
        this.frontend.displayCountdown(show);
    }
    displayCurrentTime(time) {
        this.frontend.displayCurrentTime(time);
    }
    displayCountdownTime(time) {
        this.frontend.displayCountdownTime(time);
    }
    displayRandomize(randomize) {
        this.frontend.displayRandomize(randomize);
    }
    displayPosition(index, length) {
        this.frontend.displayPosition(index, length);
    }
    constructor(frontend){
        super(frontend);
    }
}
class $b0bb53ddd8f5dc88$export$3ad32f896a7ad300 extends (0, $ba7ece8b7e297340$export$7e965828e2884d) {
    init(app) {
        const bindTarget = app.view.getBindTarget();
        [
            this.frontend.getBindHashChange(),
            this.frontend.getBindNext(),
            this.frontend.getBindPrevious(),
            ...app.config.swipe ? [
                this.frontend.getBindSwipeLeft(),
                this.frontend.getBindSwipeRight()
            ] : [],
            this.frontend.getBindReload(),
            // TODO:
            //  this.frontend.getBindAnswer(),
            //  this.frontend.getBindFinish(),
            this.frontend.getBindFlipCard(),
            this.frontend.getBindResume(),
            this.frontend.getBindHideTimer()
        ].forEach((bind)=>bind.bind(bindTarget));
        this.swipe.init(this.frontend.getSwipeTarget());
        this.rebindKeyboard(app, "flashcard");
        this.frontend.bindJquery(app.getJquery(), ".modal", "shown.bs.modal");
        this.frontend.bindJquery(app.getJquery(), ".modal", "hidden.bs.modal");
    }
    rebindKeyboard(app, type) {
        const bindTarget = app.view.getBindTarget();
        this.frontend.bindKeyboard([
            this.frontend.getKeyBindNext(),
            this.frontend.getKeyBindPrevious(),
            this.frontend.getKeyBindFlipCard(),
            // TODO: Some sort of "correct" keybind
            //  this.frontend.getKeyBindAnswer(0),
            this.frontend.getKeyBindShortcutModal()
        ], this.frontend.getAnswers(), type, bindTarget, ()=>app.model.settings.getKeyboardShortcuts());
    }
    displayLoading(status) {
        this.frontend.displayLoading(status);
    }
    displayFinishing(status) {
        this.frontend.displayFinishing(status);
    }
    displaySelectedAnswer(answer) {
        throw new Error("Method not implemented.");
    }
    displayItemClass(content) {
        return this.frontend.displayItemClass(content);
    }
    displayCardFront() {
        this.frontend.hideCardSides();
        this.frontend.displayCardFront();
    }
    displayCardBack() {
        this.frontend.hideCardSides();
        this.frontend.displayCardBack();
    }
    toggleContexts(contexts) {
        this.frontend.toggleContexts(contexts);
    }
    displayFontSize(fontSize) {
        this.frontend.displayFontSize(fontSize);
    }
    displayResults(url) {
        this.frontend.displayResults(url);
    }
    displayPauseModal(jQuery, show) {
        // Do nothing.
        return;
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        throw new Error("Method not implemented.");
    }
    displayItemSameContext(content, sameContexts) {
        throw new Error("Method not implemented.");
    }
    displayItemRendered(content, mathjax) {
        this.displayItemClass(content).displayItemRendered(content, mathjax);
    }
    displayItemAlerts(content) {
        this.displayItemClass(content).displayItemAlerts(content);
    }
    constructor(frontend){
        super(frontend);
    }
}
class $b0bb53ddd8f5dc88$export$d0a0937c7833c198 extends (0, $9764fa64f8e41b70$export$ad29949578474ab2) {
    init(app) {}
    getReviewTotalScoreChart() {
        throw new Error("Method not implemented.");
    }
    getReviewSectionScoreChart() {
        throw new Error("Method not implemented.");
    }
    getOverviewScoreChart() {
        throw new Error("Method not implemented.");
    }
    getTestProgressChart() {
        return this.frontend.getTestProgressChart();
    }
    getOverviewSummaryTable(jQuery) {
        throw new Error("Method not implemented.");
    }
}



class $d0a8d7b98af9bc77$export$fb7d762431c8b738 extends (0, $438ea9632a36718a$export$84d0dd190d551cd1) {
    init(app) {
        const bindTarget = app.view.getBindTarget();
        [
            this.frontend.getBindJump(),
            this.frontend.getBindToggleFilter(),
            this.frontend.getBindSetFilter(),
            this.frontend.getBindFilterLinks()
        ].forEach((bind)=>bind.bind(bindTarget));
        this.frontend.bindCollapseIcons();
        this.frontend.bindSectionHighlight();
    }
    displaySelectedAnswer(item, answer, status) {
        this.frontend.displaySelectedAnswer(item, answer, status);
    }
    displayCurrent(index) {
        this.frontend.displayCurrent(index);
    }
    displayFilters(filters, bindTarget) {
        this.frontend.displayFilters(filters, bindTarget);
    }
    displayFiltered(filtered) {
        this.frontend.displayFiltered(filtered);
    }
    displayFlagged(item, flagged, status) {
        this.frontend.displayFlagged(item, flagged, status);
    }
    displaySorted(order) {
        this.frontend.displaySorted(order);
    }
    constructor(frontend){
        super(frontend);
    }
}
class $d0a8d7b98af9bc77$export$f937810bd0e7b396 extends (0, $0cd70bb5c18f46c5$export$7d05e0deed78c249) {
    init(app) {
        const bindTarget = app.view.getBindTarget();
        [
            this.frontend.getBindToggleTimer(),
            this.frontend.getBindKeyboardShortcuts(),
            this.frontend.getBindChangeFontSize(),
            this.frontend.getBindResetFontSize(),
            this.frontend.getBindToggleReport(),
            this.frontend.getBindReportError(),
            this.frontend.getBindToggleAutoAdvance(),
            this.frontend.getBindChangeAdvanceInterval(),
            this.frontend.getBindResetTimer(),
            this.frontend.getBindEnterEmail(),
            this.frontend.getBindOverrideInput()
        ].forEach((bind)=>bind.bind(bindTarget));
    }
    displayFontSize(size) {
        this.frontend.displayFontSize(size);
    }
    displayKeyboardShortcuts(enabled) {
        this.frontend.displayKeyboardShortcuts(enabled);
    }
    displayTimer(show) {
        this.frontend.displayTimer(show);
    }
    toggleShortcutModal(jQuery) {
        this.frontend.toggleShortcutModal(jQuery);
    }
    displayErrorLoading(show) {
        this.frontend.displayErrorLoading(show);
    }
    displayErrorModal(jQuery, url, item, filters, screenshot, errors, localStorage) {
        this.frontend.displayErrorModal(jQuery, url, item, filters, screenshot, errors, localStorage);
    }
    hideErrorModal(jQuery, success, reason) {
        this.frontend.hideErrorModal(jQuery);
        this.frontend.displayErrorResultModal(jQuery, success, reason);
    }
    displayInputSuggestion(element, suggestion) {
        this.frontend.displayInputSuggestion(element, suggestion);
    }
    updateInputs(root, selector, value) {
        return this.frontend.updateInputs(root, selector, value);
    }
    displayReportErrorMessage(message) {
        this.frontend.displayReportErrorMessage(message);
    }
    displayAdvance(enable) {
        this.frontend.displayAdvance(enable);
    }
    displayAdvanceInterval(interval) {
        this.frontend.displayAdvanceInterval(interval);
    }
    displayTimed(enable) {
        this.frontend.displayTimed(enable);
    }
    constructor(frontend){
        super(frontend);
    }
}



class $620a4d731f2c98ac$export$3b63532965f54897 extends (0, $d0140d785b4d4210$export$14914237e9256338) {
    init(app) {
    // Do nothing.
    }
    displayProgress(chart, complete, total) {
        throw new Error("Method not implemented.");
    }
    displayTotalScores(chart, total) {
        throw new Error("Method not implemented.");
    }
    displayItem(content) {
        throw new Error("Method not implemented.");
    }
    displayTotalTime(time) {
        throw new Error("Method not implemented.");
    }
    displayTimer(show) {
        throw new Error("Method not implemented.");
    }
    displayNext(show) {
    // Do nothing.
    }
    displayPrevious(show) {
    // Do nothing.
    }
    displayFinish(show) {
    // Do nothing.
    }
    displayFlag(flagged) {
        this.frontend.displayFlag(flagged);
    }
    displayCountdown(show) {
        throw new Error("Method not implemented.");
    }
    displayCurrentTime(time) {
        throw new Error("Method not implemented.");
    }
    displayCountdownTime(time) {
        throw new Error("Method not implemented.");
    }
    displayRandomize(randomize) {
        throw new Error("Method not implemented.");
    }
    displayPosition(index, length) {
    // Do nothing.
    }
    constructor(frontend){
        super(frontend);
    }
}




class $4c4cd8cc9be28930$export$4816f478639a3147 extends (0, $3035e28da4cb4cd7$export$cffe4c650c020bcc) {
    init(app) {
        const bindTarget = app.view.getBindTarget();
        [
            this.frontend.getBindStart()
        ].forEach((bind)=>bind.bind(bindTarget));
    }
    displayOverviewScores(chart, scores) {
        for (const score of scores){
            const chartElement = this.frontend.getSectionChart(score.quiz);
            if (chartElement) chart.display(chartElement, score.data);
        }
    }
    toggleStart(element) {
        this.frontend.toggleStart(element);
    }
    constructor(frontend){
        super(frontend);
    }
}
class $4c4cd8cc9be28930$export$a3ad6b0349d4f96b extends (0, $1980e00912dde01a$export$bcc1604b0ad6e68b) {
    init(app) {}
    displayTable(table, product) {
        const element = this.frontend.getTable();
        table.display(element, product);
    }
    constructor(frontend){
        super(frontend);
    }
}
class $4c4cd8cc9be28930$export$3d57bb984caea565 extends (0, $9764fa64f8e41b70$export$ad29949578474ab2) {
    init(app) {}
    getReviewTotalScoreChart() {
        throw new Error("Method not implemented.");
    }
    getReviewSectionScoreChart() {
        throw new Error("Method not implemented.");
    }
    getOverviewScoreChart() {
        return this.frontend.getOverviewScoreChart();
    }
    getTestProgressChart() {
        throw new Error("Method not implemented.");
    }
    getOverviewSummaryTable(jQuery) {
        return this.frontend.getOverviewSummaryTable(jQuery);
    }
}




class $f8619edde51811ce$export$d8df626f347bc16 extends (0, $d0140d785b4d4210$export$14914237e9256338) {
    init(app) {
        const bindTarget = app.view.getBindTarget();
        [
            this.frontend.getBindPause(),
            this.frontend.getBindFlag()
        ].forEach((bind)=>bind.bind(bindTarget));
    }
    displayPosition(index, length) {
        this.frontend.displayPosition(index, length);
    }
    displayProgress(chart, complete, total) {
        throw new Error("Method not implemented.");
    }
    displayTotalScores(chart, total) {
        const element = this.frontend.getTotalScoreChart();
        chart.display(element, total);
    }
    displayItem(content) {
        this.frontend.displayItem(content);
    }
    displayTotalTime(time) {}
    displayTimer(show) {
        this.frontend.displayTimer(show);
    }
    displayNext(show) {
        this.frontend.displayNext(show);
    }
    displayPrevious(show) {
        this.frontend.displayPrevious(show);
    }
    displayFinish(show) {}
    displayFlag(flagged) {
        this.frontend.displayFlag(flagged);
    }
    displayCountdown(show) {
        throw new Error("Method not implemented.");
    }
    displayCurrentTime(time) {
        throw new Error("Method not implemented.");
    }
    displayCountdownTime(time) {
        throw new Error("Method not implemented.");
    }
    displayRandomize(randomize) {
        throw new Error("Method not implemented.");
    }
    constructor(frontend){
        super(frontend);
    }
}
class $f8619edde51811ce$export$df8f44f0b3a8b5a4 extends (0, $ba7ece8b7e297340$export$7e965828e2884d) {
    init(app) {
        const bindTarget = app.view.getBindTarget();
        [
            this.frontend.getBindHashChange(),
            this.frontend.getBindNext(),
            this.frontend.getBindPrevious(),
            ...app.config.swipe ? [
                this.frontend.getBindSwipeLeft(),
                this.frontend.getBindSwipeRight()
            ] : [],
            this.frontend.getBindReload(),
            this.frontend.getBindToggleContext(),
            this.frontend.getBindContextShown()
        ].forEach((bind)=>bind.bind(bindTarget));
        this.swipe.init(this.frontend.getSwipeTarget());
        this.frontend.initSortable();
        this.rebindKeyboard(app, "multiplechoice");
        this.frontend.bindJquery(app.getJquery(), ".collapse", "show.bs.collapse");
        this.frontend.bindJquery(app.getJquery(), ".collapse", "shown.bs.collapse");
        this.frontend.bindJquery(app.getJquery(), ".collapse", "hide.bs.collapse");
        this.frontend.bindJquery(app.getJquery(), ".collapse", "hidden.bs.collapse");
    }
    rebindKeyboard(app, type) {
        const bindTarget = app.view.getBindTarget();
        this.frontend.bindKeyboard([
            this.frontend.getKeyBindNext(),
            this.frontend.getKeyBindPrevious(),
            this.frontend.getKeyBindToggleContext(),
            this.frontend.getKeyBindShortcutModal()
        ], this.frontend.getAnswers(), type, bindTarget, ()=>app.model.settings.getKeyboardShortcuts());
    }
    displayLoading(status) {
        this.frontend.displayLoading(status);
    }
    displayFinishing(status) {
        throw new Error("Method not implemented.");
    }
    displaySelectedAnswer(answer) {
        throw new Error("Method not implemented.");
    }
    displayItemClass(content) {
        return this.frontend.displayItemClass(content);
    }
    toggleContexts(contexts) {
        this.frontend.toggleContexts(contexts);
    }
    displayFontSize(fontSize) {
        this.frontend.displayFontSize(fontSize);
    }
    displayResults(url) {
        throw new Error("Method not implemented.");
    }
    displayPauseModal(jQuery, show) {
        throw new Error("Method not implemented.");
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        this.displayItemClass(content).displayItemSelectedAnswer(content, bindTarget, answer);
        this.displayItemClass(content).displayItemReview(content, answer);
    }
    displayItemSameContext(content, sameContexts) {
        const ids = sameContexts.map((c)=>c.id);
        this.frontend.displayContexts(content.contexts.reduce((r, c)=>({
                ...r,
                [c.id]: !ids.includes(c.id)
            }), {}));
    }
    displayItemRendered(content, mathjax) {
        this.displayItemClass(content).displayItemRendered(content, mathjax);
    }
    displayItemAlerts(content) {
        this.displayItemClass(content).displayItemAlerts(content);
    }
    constructor(frontend){
        super(frontend);
    }
}
class $f8619edde51811ce$export$d1d3d31ef366b4f4 extends (0, $d97321baad67d913$export$b5fd6146180b74ff) {
    init(app) {
        const bindTarget = app.view.getBindTarget();
        [
            this.frontend.getBindScoreFilter()
        ].forEach((bind)=>bind.bind(bindTarget));
        this.frontend.bindSummaryCollapse();
    }
    displayReviewScores(chart, scores) {
        const element = this.frontend.getSectionScoreChart();
        chart.display(element, scores);
    }
    constructor(frontend){
        super(frontend);
    }
}
class $f8619edde51811ce$export$7e277bb7a5815 extends (0, $9764fa64f8e41b70$export$ad29949578474ab2) {
    init(app) {}
    getReviewTotalScoreChart() {
        return this.frontend.getReviewTotalScoreChart();
    }
    getReviewSectionScoreChart() {
        return this.frontend.getReviewSectionScoreChart();
    }
    getOverviewScoreChart() {
        throw new Error("Method not implemented.");
    }
    getTestProgressChart() {
        throw new Error("Method not implemented.");
    }
    getOverviewSummaryTable(jQuery) {
        throw new Error("Method not implemented.");
    }
}




class $05c6ae7be4e66a65$export$a22764e79ddcbf19 extends (0, $d0140d785b4d4210$export$14914237e9256338) {
    init(app) {
        const bindTarget = app.view.getBindTarget();
        [
            this.frontend.getBindPause(),
            this.frontend.getBindFlag(),
            this.frontend.getBindRandomize()
        ].forEach((bind)=>bind.bind(bindTarget));
    }
    displayProgress(chart, complete, total) {
        const element = this.frontend.getProgressChart();
        chart.display(element, complete, total);
    }
    displayTotalScores(chart, total) {
        throw new Error("Method not implemented.");
    }
    displayItem(content) {
        this.frontend.displayItem(content);
    }
    displayTotalTime(time) {
        this.frontend.displayTotalTime(time);
    }
    displayTimer(show) {
        this.frontend.displayTimer(show);
    }
    displayNext(show) {
        this.frontend.displayNext(show);
    }
    displayPrevious(show) {
        this.frontend.displayPrevious(show);
    }
    displayFinish(show) {
        this.frontend.displayFinish(show);
    }
    displayFlag(flagged) {
        this.frontend.displayFlag(flagged);
    }
    displayCountdown(show) {
        throw new Error("Method not implemented.");
    }
    displayCurrentTime(time) {
        throw new Error("Method not implemented.");
    }
    displayCountdownTime(time) {
        throw new Error("Method not implemented.");
    }
    displayRandomize(randomize) {
        throw new Error("Method not implemented.");
    }
    displayPosition(index, length) {
        this.frontend.displayPosition(index, length);
    }
    constructor(frontend){
        super(frontend);
    }
}
class $05c6ae7be4e66a65$export$2413a969a84c33cb extends (0, $ba7ece8b7e297340$export$7e965828e2884d) {
    init(app) {
        const bindTarget = app.view.getBindTarget();
        [
            this.frontend.getBindHashChange(),
            this.frontend.getBindNext(),
            this.frontend.getBindPrevious(),
            ...app.config.swipe ? [
                this.frontend.getBindSwipeLeft(),
                this.frontend.getBindSwipeRight()
            ] : [],
            this.frontend.getBindReload(),
            this.frontend.getBindFinish(),
            this.frontend.getBindToggleContext(),
            this.frontend.getBindContextShown(),
            this.frontend.getBindResume(),
            this.frontend.getBindHideTimer()
        ].forEach((bind)=>bind.bind(bindTarget));
        this.swipe.init(this.frontend.getSwipeTarget(), typeof app.config.swipe == "boolean" ? undefined : app.config.swipe);
        this.frontend.initSortable();
        this.rebindKeyboard(app, "multiplechoice");
        this.frontend.bindJquery(app.getJquery(), ".collapse", "show.bs.collapse");
        this.frontend.bindJquery(app.getJquery(), ".collapse", "shown.bs.collapse");
        this.frontend.bindJquery(app.getJquery(), ".collapse", "hide.bs.collapse");
        this.frontend.bindJquery(app.getJquery(), ".collapse", "hidden.bs.collapse");
        this.frontend.bindJquery(app.getJquery(), ".modal", "shown.bs.modal");
        this.frontend.bindJquery(app.getJquery(), ".modal", "hidden.bs.modal");
    }
    rebindKeyboard(app, type) {
        const bindTarget = app.view.getBindTarget();
        this.frontend.bindKeyboard([
            this.frontend.getKeyBindNext(),
            this.frontend.getKeyBindPrevious(),
            this.frontend.getKeyBindToggleContext(),
            this.frontend.getKeyBindAnswer(0),
            this.frontend.getKeyBindAnswer(1),
            this.frontend.getKeyBindAnswer(2),
            this.frontend.getKeyBindAnswer(3),
            this.frontend.getKeyBindAnswer(4),
            this.frontend.getKeyBindAnswer(5),
            this.frontend.getKeyBindAnswer(6),
            this.frontend.getKeyBindAnswer(7),
            this.frontend.getKeyBindAnswer(8),
            this.frontend.getKeyBindAnswer(9),
            this.frontend.getKeyBindShortcutModal()
        ], this.frontend.getAnswers(), type, bindTarget, ()=>app.model.settings.getKeyboardShortcuts());
    }
    displayLoading(status) {
        this.frontend.displayLoading(status);
    }
    displayFinishing(status) {
        this.frontend.displayFinishing(status);
    }
    displaySelectedAnswer(type, answer) {
        if (type === "multiplechoice") this.frontend.displaySelectedAnswerMultipleChoice(answer);
        else if (type === "multiplecorrect") this.frontend.displaySelectedAnswerMultipleCorrect(answer);
    }
    displayItemClass(content) {
        return this.frontend.displayItemClass(content);
    }
    toggleContexts(contexts) {
        this.frontend.toggleContexts(contexts);
    }
    displayFontSize(fontSize) {
        this.frontend.displayFontSize(fontSize);
    }
    displayResults(url) {
        this.frontend.displayResults(url);
    }
    displayPauseModal(jQuery, show) {
        this.frontend.displayPauseModal(jQuery, show ? "show" : "hide");
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        this.displayItemClass(content).displayItemSelectedAnswer(content, bindTarget, answer);
    }
    displayItemSameContext(content, sameContexts) {
        const ids = sameContexts.map((c)=>c.id);
        this.frontend.displayContexts(content.contexts.reduce((r, c)=>({
                ...r,
                [c.id]: !ids.includes(c.id)
            }), {}));
    }
    displayItemRendered(content, mathjax) {
        this.displayItemClass(content).displayItemRendered(content, mathjax);
    }
    displayItemAlerts(content) {
        this.displayItemClass(content).displayItemAlerts(content);
    }
    constructor(frontend){
        super(frontend);
    }
}
class $05c6ae7be4e66a65$export$f3d01a47290c6572 extends (0, $9764fa64f8e41b70$export$ad29949578474ab2) {
    init(app) {}
    getReviewTotalScoreChart() {
        throw new Error("Method not implemented.");
    }
    getReviewSectionScoreChart() {
        throw new Error("Method not implemented.");
    }
    getOverviewScoreChart() {
        throw new Error("Method not implemented.");
    }
    getTestProgressChart() {
        return this.frontend.getTestProgressChart();
    }
    getOverviewSummaryTable(jQuery) {
        throw new Error("Method not implemented.");
    }
}




class $6fbfe6f14c8e4909$export$2e2bcd8739ae039 {
    init() {
        $83bde87bc058d127$export$2cd8252107eb640b(this.config.polyfills);
        const bindTarget = this.view.getBindTarget();
        Promise.allSettled([
            ...this.config.mathjax ? [] : [
                this.loadMathJax()
            ]
        ]).then(()=>{
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$49a1ecce8d203)());
        });
    }
    getJquery() {
        return this.config.jQuery;
    }
    loadMathJax() {
        return this.view.loadScript({
            src: this.config.mathjaxUrl.replace("{version}", (0, $2066a33cea67b6a1$exports.mathjax).version)
        }).catch((error)=>{
            console.log("Failed to load MathJax", {
                error: error
            });
            window.MathJax = {
                typesetPromise: ()=>Promise.resolve()
            };
        }).then(()=>{
            this.config.mathjax = window.MathJax;
            return window.MathJax;
        });
    }
    getMathJax() {
        return this.config.mathjax;
    }
    serialize(indices) {
        return {
            attempt: {
                version: 2,
                timestamp: new Date().toISOString(),
                current: this.current.serialize(indices),
                times: this.timer.serializeTimes(indices)
            },
            global: {
                version: 2,
                timestamp: new Date().toISOString(),
                timer: this.timer.serializeSettings(),
                settings: {
                    fontsize: this.model.settings.getFontSize(),
                    randomize: this.model.settings.getRandomize()
                }
            }
        };
    }
    static mergeControllers(controllers, default_controllers, extra_controllers) {
        return [].concat(Object.values({
            ...default_controllers,
            ...controllers
        }), extra_controllers ?? []);
    }
    constructor({ model: model, view: view, controllers: controllers, content: content, current: current, filter: filter, timer: timer, userdata: userdata, navigation: navigation, config: config }){
        /** @type {Model} */ this.model = model;
        /** @type {View} */ this.view = view;
        /** @type {Controller[]} */ this.controllers = controllers;
        /** @type {Content} */ this.content = content;
        /** @type {Current} */ this.current = current;
        /** @type {Filter} */ this.filter = filter;
        /** @type {Timer} */ this.timer = timer;
        /** @type {UserData} */ this.userdata = userdata;
        /** @type {Navigation} */ this.navigation = navigation;
        const bindTarget = view.getBindTarget();
        for(const key in this.controllers){
            const controller = this.controllers[key];
            controller.bind(bindTarget, this);
        }
        const defaults = {
            jQuery: typeof $j != "undefined" ? $j : undefined,
            mathjax: typeof window.MathJax != "undefined" && window.MathJax.typesetPromise ? window.MathJax : undefined,
            randomizeAnswers: false,
            timer: {
                resolution: 100,
                tickRate: 1000,
                pingRate: 30000,
                advanceRate: 30000,
                recentCount: 3,
                timed: false,
                autoAdvance: false
            },
            swipe: true,
            mathjaxUrl: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/{version}/es5/tex-mml-chtml.min.js",
            polyfills: Object.values($83bde87bc058d127$export$23482700b6807ba0)
        };
        this.config = {
            ...defaults,
            ...config
        };
    }
}
class $6fbfe6f14c8e4909$export$1e02a9be3c7e8753 extends $6fbfe6f14c8e4909$export$2e2bcd8739ae039 {
    static constructOverview(datasource, frontend, config, serializer, controllers, extra_controllers, libs) {
        serializer ??= new (0, $1464aabbdbd5323e$export$2c32508fceb0b7d7)();
        const productSerializer = serializer.productSerializer();
        const quizSerializer = serializer.quizSerializer();
        const itemSerializer = serializer.itemSerializer();
        return new this({
            model: new (0, $a1ce5267824943fb$export$2e2bcd8739ae039)({
                metadata: new (0, $f4437f1565542c94$export$ad4c18518f7b40ba)(datasource.metadataDataSource()),
                score: new (0, $f4437f1565542c94$export$6e5c9d23f15a050d)(datasource.scoreDataSource(quizSerializer))
            }),
            view: new (0, $d1e98415768ae0f9$export$2e2bcd8739ae039)({
                sections: new (0, $4c4cd8cc9be28930$export$4816f478639a3147)(frontend.sectionFrontend(quizSerializer, itemSerializer)),
                summary: new (0, $4c4cd8cc9be28930$export$a3ad6b0349d4f96b)(frontend.summaryFrontend(productSerializer)),
                chart: new (0, $4c4cd8cc9be28930$export$3d57bb984caea565)(frontend.chartFrontend(productSerializer))
            }),
            controllers: this.mergeControllers(controllers, {
                init: new (0, $04637eb48d465816$export$77cd77b88309b1c9)()
            }, extra_controllers),
            content: new (0, $6bbf0661748359c7$export$2e2bcd8739ae039)(),
            current: new (0, $8d9015e5a183dade$export$2e2bcd8739ae039)(),
            filter: new (0, $43dd4374f28efe45$export$2e2bcd8739ae039)(),
            timer: new (0, $93c1294deb7f14f4$export$b33320980f57f42d)(),
            userdata: libs?.userdata ?? new (0, $edbffc7b79aebee8$export$2e2bcd8739ae039)(),
            navigation: new (0, $e6d9787dca477675$export$2e2bcd8739ae039)(),
            config: config
        });
    }
    static constructTest(datasource, frontend, config, serializer, controllers, extra_controllers, libs) {
        serializer ??= new (0, $1464aabbdbd5323e$export$2c32508fceb0b7d7)();
        const itemSerializer = serializer.itemSerializer();
        const productSerializer = serializer.productSerializer();
        return new this({
            model: new (0, $a1ce5267824943fb$export$2e2bcd8739ae039)({
                metadata: new (0, $c9cb9b4370d94384$export$a0007e43b5a1bad3)(datasource.metadataDataSource()),
                list: new (0, $65fd8e9c390e16cf$export$3247fa725e92f7aa)(datasource.listDataSource(itemSerializer)),
                item: new (0, $c9cb9b4370d94384$export$5528a70bc0755d5d)(datasource.itemDataSource()),
                settings: new (0, $65fd8e9c390e16cf$export$1e241e1a557fe85f)(datasource.settingsDataSource()),
                state: {
                    global: new (0, $65fd8e9c390e16cf$export$43deca918d12a831)(datasource.globalStateDataSource(datasource.globalStateInitializer() ?? new (0, $64a84e97a08b3b3f$export$eac5cc7c756f6526)())),
                    attempt: new (0, $65fd8e9c390e16cf$export$43deca918d12a831)(datasource.attemptStateDataSource(datasource.attemptStateInitializer() ?? new (0, $64a84e97a08b3b3f$export$c71c6275427547ae)()))
                }
            }),
            view: new (0, $d1e98415768ae0f9$export$2e2bcd8739ae039)({
                item: new (0, $05c6ae7be4e66a65$export$2413a969a84c33cb)(frontend.itemFrontend(itemSerializer)),
                list: new (0, $d0a8d7b98af9bc77$export$fb7d762431c8b738)(frontend.listFrontend(itemSerializer)),
                header: new (0, $05c6ae7be4e66a65$export$a22764e79ddcbf19)(frontend.headerFrontend(itemSerializer)),
                settings: new (0, $d0a8d7b98af9bc77$export$f937810bd0e7b396)(frontend.settingsFrontend(itemSerializer)),
                chart: new (0, $05c6ae7be4e66a65$export$f3d01a47290c6572)(frontend.chartFrontend(productSerializer))
            }),
            controllers: this.mergeControllers(controllers, {
                init: new (0, $748df0be0de871bb$export$e26f6f7e2a1f6c78)(),
                test: new (0, $db239e2e31b1c306$export$eddf153237ef6277)(),
                navigation: new (0, $9b189da8a270b36a$export$b16fba08cef0c11b)(),
                timer: new (0, $5752384e8bfe6d9b$export$dd9fa483d192d6fb)(),
                context: new (0, $c62a415619174070$export$e9ef9bff12694ab8)(),
                filter: new (0, $124646cec8fbbd34$export$8d640e745b5fefe1)(),
                settings: new (0, $c9673169519ccf3d$export$e85c1bdb90ec603e)(),
                flag: new (0, $c8fe73d8254dc161$export$f82952fa730e5523)()
            }, extra_controllers),
            content: new (0, $6bbf0661748359c7$export$2e2bcd8739ae039)(),
            current: new (0, $8d9015e5a183dade$export$2e2bcd8739ae039)(),
            filter: new (0, $43dd4374f28efe45$export$2e2bcd8739ae039)(),
            timer: new (0, $93c1294deb7f14f4$export$b33320980f57f42d)(),
            userdata: libs?.userdata ?? new (0, $edbffc7b79aebee8$export$2e2bcd8739ae039)(),
            navigation: new (0, $e6d9787dca477675$export$2e2bcd8739ae039)(),
            config: config
        });
    }
    static constructReview(datasource, frontend, config, serializer, controllers, extra_controllers, libs) {
        serializer ??= new (0, $1464aabbdbd5323e$export$2c32508fceb0b7d7)();
        const itemSerializer = serializer.itemSerializer();
        const quizSerializer = serializer.quizSerializer();
        const productSerializer = serializer.productSerializer();
        return new this({
            model: new (0, $a1ce5267824943fb$export$2e2bcd8739ae039)({
                metadata: new (0, $23ef5a606ebfeae9$export$f23c5d9ea3ade0cf)(datasource.metadataDataSource()),
                list: new (0, $65fd8e9c390e16cf$export$3247fa725e92f7aa)(datasource.listDataSource(itemSerializer)),
                item: new (0, $23ef5a606ebfeae9$export$8f32e90ddca8b9a1)(datasource.itemDataSource()),
                score: new (0, $23ef5a606ebfeae9$export$b98861793fb84195)(datasource.scoreDataSource(quizSerializer)),
                settings: new (0, $65fd8e9c390e16cf$export$1e241e1a557fe85f)(datasource.settingsDataSource()),
                state: {
                    global: new (0, $65fd8e9c390e16cf$export$43deca918d12a831)(datasource.globalStateDataSource(datasource.globalStateInitializer() ?? new (0, $64a84e97a08b3b3f$export$eac5cc7c756f6526)())),
                    attempt: new (0, $65fd8e9c390e16cf$export$43deca918d12a831)(datasource.attemptStateDataSource(datasource.attemptStateInitializer() ?? new (0, $64a84e97a08b3b3f$export$c71c6275427547ae)()))
                }
            }),
            view: new (0, $d1e98415768ae0f9$export$2e2bcd8739ae039)({
                item: new (0, $f8619edde51811ce$export$df8f44f0b3a8b5a4)(frontend.itemFrontend(itemSerializer)),
                list: new (0, $d0a8d7b98af9bc77$export$fb7d762431c8b738)(frontend.listFrontend(itemSerializer)),
                header: new (0, $f8619edde51811ce$export$d8df626f347bc16)(frontend.headerFrontend(itemSerializer)),
                scores: new (0, $f8619edde51811ce$export$d1d3d31ef366b4f4)(frontend.scoreFrontend()),
                settings: new (0, $d0a8d7b98af9bc77$export$f937810bd0e7b396)(frontend.settingsFrontend(itemSerializer)),
                chart: new (0, $f8619edde51811ce$export$7e277bb7a5815)(frontend.chartFrontend(productSerializer))
            }),
            controllers: this.mergeControllers(controllers, {
                init: new (0, $8de0aa2da6918f40$export$74d9db856d618e43)(),
                navigation: new (0, $9b189da8a270b36a$export$b16fba08cef0c11b)(),
                timer: new (0, $5752384e8bfe6d9b$export$dd9fa483d192d6fb)(),
                context: new (0, $c62a415619174070$export$e9ef9bff12694ab8)(),
                filter: new (0, $124646cec8fbbd34$export$8d640e745b5fefe1)(),
                settings: new (0, $c9673169519ccf3d$export$e85c1bdb90ec603e)(),
                flag: new (0, $c8fe73d8254dc161$export$f82952fa730e5523)()
            }, extra_controllers),
            content: new (0, $6bbf0661748359c7$export$2e2bcd8739ae039)(),
            current: new (0, $8d9015e5a183dade$export$2e2bcd8739ae039)(),
            filter: new (0, $43dd4374f28efe45$export$2e2bcd8739ae039)(),
            timer: new (0, $93c1294deb7f14f4$export$b33320980f57f42d)(),
            userdata: libs?.userdata ?? new (0, $edbffc7b79aebee8$export$2e2bcd8739ae039)(),
            navigation: new (0, $e6d9787dca477675$export$2e2bcd8739ae039)(),
            config: config
        });
    }
}
class $6fbfe6f14c8e4909$export$5b691ccebe78fe28 extends $6fbfe6f14c8e4909$export$2e2bcd8739ae039 {
    static constructCard(datasource, frontend, config, serializer, controllers, extra_controllers) {
        serializer ??= new (0, $1464aabbdbd5323e$export$2c32508fceb0b7d7)();
        const itemSerializer = serializer.itemSerializer();
        const productSerializer = serializer.productSerializer();
        return new $6fbfe6f14c8e4909$export$5b691ccebe78fe28({
            model: new (0, $a1ce5267824943fb$export$2e2bcd8739ae039)({
                metadata: new (0, $acbd43c9906036f0$export$ab7fb13f8d285a70)(datasource.metadataDataSource()),
                list: new (0, $65fd8e9c390e16cf$export$3247fa725e92f7aa)(datasource.listDataSource(itemSerializer)),
                item: new (0, $acbd43c9906036f0$export$160d9f4404450dab)(datasource.itemDataSource()),
                settings: new (0, $65fd8e9c390e16cf$export$1e241e1a557fe85f)(datasource.settingsDataSource()),
                state: {
                    global: new (0, $65fd8e9c390e16cf$export$43deca918d12a831)(datasource.globalStateDataSource(datasource.globalStateInitializer() ?? new (0, $64a84e97a08b3b3f$export$eac5cc7c756f6526)())),
                    attempt: new (0, $65fd8e9c390e16cf$export$43deca918d12a831)(datasource.attemptStateDataSource(datasource.attemptStateInitializer() ?? new (0, $64a84e97a08b3b3f$export$cff54aa69b8a5414)()))
                }
            }),
            view: new (0, $d1e98415768ae0f9$export$2e2bcd8739ae039)({
                item: new (0, $b0bb53ddd8f5dc88$export$3ad32f896a7ad300)(frontend.itemFrontend(itemSerializer)),
                list: new (0, $d0a8d7b98af9bc77$export$fb7d762431c8b738)(frontend.listFrontend(itemSerializer)),
                header: new (0, $b0bb53ddd8f5dc88$export$d92cfffd7fee6c42)(frontend.headerFrontend(itemSerializer)),
                settings: new (0, $d0a8d7b98af9bc77$export$f937810bd0e7b396)(frontend.settingsFrontend(itemSerializer)),
                chart: new (0, $b0bb53ddd8f5dc88$export$d0a0937c7833c198)(frontend.chartFrontend(productSerializer))
            }),
            controllers: this.mergeControllers(controllers, {
                init: new (0, $659eb18cb7f7e0eb$export$301814721d6367cd)(),
                card: new (0, $f92fdaceb3176414$export$9d0ff824ea846a5)(),
                navigation: new (0, $9b189da8a270b36a$export$a37f2987b6c01832)(),
                timer: new (0, $5752384e8bfe6d9b$export$dd9fa483d192d6fb)(),
                context: new (0, $c62a415619174070$export$e9ef9bff12694ab8)(),
                filter: new (0, $124646cec8fbbd34$export$8d640e745b5fefe1)(),
                settings: new (0, $c9673169519ccf3d$export$e85c1bdb90ec603e)(),
                flag: new (0, $c8fe73d8254dc161$export$f82952fa730e5523)()
            }, extra_controllers),
            content: new (0, $6bbf0661748359c7$export$2e2bcd8739ae039)(),
            current: new (0, $8d9015e5a183dade$export$2e2bcd8739ae039)(),
            filter: new (0, $43dd4374f28efe45$export$2e2bcd8739ae039)(),
            timer: new (0, $93c1294deb7f14f4$export$b73fed17745a4293)(),
            userdata: new (0, $edbffc7b79aebee8$export$2e2bcd8739ae039)(),
            navigation: new (0, $e6d9787dca477675$export$2e2bcd8739ae039)(),
            config: config
        });
    }
    static constructList(datasource, frontend, config, serializer, controllers, extra_controllers) {
        serializer ??= new (0, $1464aabbdbd5323e$export$2c32508fceb0b7d7)();
        const itemSerializer = serializer.itemSerializer();
        return new $6fbfe6f14c8e4909$export$5b691ccebe78fe28({
            model: new (0, $a1ce5267824943fb$export$2e2bcd8739ae039)({
                list: new (0, $65fd8e9c390e16cf$export$3247fa725e92f7aa)(datasource.listDataSource(itemSerializer)),
                metadata: new (0, $acbd43c9906036f0$export$ab7fb13f8d285a70)(datasource.metadataDataSource()),
                state: {
                    global: new (0, $65fd8e9c390e16cf$export$43deca918d12a831)(datasource.globalStateDataSource(datasource.globalStateInitializer() ?? new (0, $64a84e97a08b3b3f$export$eac5cc7c756f6526)())),
                    attempt: new (0, $65fd8e9c390e16cf$export$43deca918d12a831)(datasource.attemptStateDataSource(datasource.attemptStateInitializer() ?? new (0, $64a84e97a08b3b3f$export$cff54aa69b8a5414)()))
                }
            }),
            view: new (0, $d1e98415768ae0f9$export$2e2bcd8739ae039)({
                list: new (0, $d0a8d7b98af9bc77$export$fb7d762431c8b738)(frontend.listFrontend(itemSerializer)),
                header: new (0, $620a4d731f2c98ac$export$3b63532965f54897)(frontend.headerFrontend(itemSerializer))
            }),
            controllers: this.mergeControllers(controllers, {
                init: new (0, $0a82fcbcced4b81d$export$adeb52c9baa7df67)(),
                filter: new (0, $124646cec8fbbd34$export$8d640e745b5fefe1)()
            }, extra_controllers),
            content: null,
            current: new (0, $8d9015e5a183dade$export$2e2bcd8739ae039)(),
            filter: new (0, $43dd4374f28efe45$export$2e2bcd8739ae039)(),
            timer: null,
            userdata: new (0, $edbffc7b79aebee8$export$2e2bcd8739ae039)(),
            navigation: new (0, $e6d9787dca477675$export$2e2bcd8739ae039)(),
            config: config
        });
    }
}




function $c8843a02291a36e7$var$getProductId() {
    const pattern = /practicequestion\/(?<type>products|test|result)\/(?:v\/)?(?<sku>[-\w.~%!$&'()*+,;=:@_]+)(?:\/(?<attempt>\d+))?/;
    const url = new URL(window.location.href);
    const result = pattern.exec(url.pathname);
    return result ? result.groups["sku"] : undefined;
}
function $c8843a02291a36e7$var$getAttemptId() {
    const pattern = /practicequestion\/(?<type>products|test|result)\/(?:v\/)?(?<sku>[-\w.~%!$&'()*+,;=:@_]+)(?:\/(?<attempt>\d+))?/;
    const url = new URL(window.location.href);
    const result = pattern.exec(url.pathname);
    if (result) {
        const value = parseInt(result.groups["attempt"]);
        if (!Number.isNaN(value)) return value;
    }
    return undefined;
}
class $c8843a02291a36e7$export$4f1e0ee9b7a3ff67 extends (0, $6d853ffbfbdd7463$export$d12b987aa5384879) {
    getProductId() {
        return new Promise((resolve, reject)=>{
            const result = $c8843a02291a36e7$var$getProductId();
            if (result) resolve(result);
            else reject();
        });
    }
    getAttempt() {
        return new Promise((resolve, reject)=>{
            const result = $c8843a02291a36e7$var$getAttemptId();
            if (result) resolve(result);
            else reject();
        });
    }
    getInitialTime() {
        return new Promise((resolve)=>{
            const timer = document.querySelector(".timer .input-group-text");
            if (!timer) {
                resolve(0);
                return;
            }
            const time = timer.textContent;
            const match = /(((?<hours>\d+):)?(?<minutes>\d+):)?(?<seconds>[\d.]+)/.exec(time);
            if (match) {
                const hours = parseInt(match.groups.hours || "0");
                const minutes = parseInt(match.groups.minutes || "0");
                const seconds = parseFloat(match.groups.seconds);
                const total = (hours * 3600 + minutes * 60 + seconds) * 1000;
                resolve(total);
            } else resolve(0);
        });
    }
}
class $c8843a02291a36e7$export$8571e238509b9601 extends (0, $be240fd33780548d$export$4aae75b7c7d79c7c) {
}
class $c8843a02291a36e7$export$d63adfee35a5f384 extends (0, $176d69903c7f2815$export$ab09e123e8bceee0) {
    getItem(product, question, randomize) {
        const { cw_sku: cw_sku, set_id: set_id, cw_id: cw_id } = $c8843a02291a36e7$export$c2085e3a87cf30a2(question);
        return fetch(`/practicequestion/question/${product}/${cw_sku}/${set_id}/${cw_id}`).then((response)=>{
            if (!response.ok) return Promise.reject(response);
            return response.json();
        }).then((question)=>{
            if (question.type === "multiplechoice" && randomize) question.multiplechoice.answers = question.multiplechoice.answers.reduce((result, answer)=>{
                result.push(answer);
                const index = Math.trunc(Math.random() * result.length);
                const temp = result[index];
                result[index] = result[result.length - 1];
                result[result.length - 1] = temp;
                return result;
            }, []);
            const { context: context, ...content } = question;
            return {
                ...content,
                section_title: content.sections[content.sections.length - 1].title,
                contexts: context ? [
                    {
                        ...context,
                        id: context.content.content_id.toString()
                    }
                ] : []
            };
        });
    }
    setUserData(product, attempt, question, data) {
        const { cw_sku: cw_sku, set_id: set_id, cw_id: cw_id } = $c8843a02291a36e7$export$c2085e3a87cf30a2(question);
        return fetch(`/practicequestion/answer/${product}/${cw_sku}/${set_id}/${cw_id}/${attempt}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                answer: data.answer
            })
        }).then((response)=>response.json());
    }
    setPing(product, attempt, mode, times) {
        return fetch(`/practicequestion/ping/${product}/${attempt}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                review: mode === "pq_review",
                times: times.map((record)=>{
                    const { cw_sku: cw_sku, set_id: set_id, cw_id: cw_id } = $c8843a02291a36e7$export$c2085e3a87cf30a2(record.item.id);
                    return {
                        start: record.time.start,
                        end: record.time.end,
                        context_viewed: Object.values(record.time.extras.contexts_viewed)[0] ?? false,
                        question_id: cw_id,
                        cw_sku: cw_sku,
                        set_id: set_id
                    };
                })
            })
        }).then(()=>{});
    }
    setFinished(product, attempt) {
        return fetch(`/practicequestion/finish/${product}/${attempt}`, {
            method: "POST",
            redirect: "manual"
        }).then((response)=>response.json()).then((response)=>response.result);
    }
}
function $c8843a02291a36e7$export$c2085e3a87cf30a2(question) {
    const selector = `.item[data-id='${question}']`;
    const element = document.querySelector(selector);
    return {
        cw_sku: element?.dataset.cw_sku,
        set_id: element?.dataset.set,
        cw_id: element?.dataset.cw_id
    };
}
class $c8843a02291a36e7$export$fdef18a6e7ebbbf9 extends (0, $eb776a821ef0bbbf$export$7c66c0fb5f371cd6) {
}
class $c8843a02291a36e7$export$63463c4bda1ea56a extends (0, $c1a89ddac7c2b3d8$export$e97855d8604afed8) {
    sendErrorReport(product, form) {
        return fetch("/report/", {
            method: "POST",
            body: new FormData(form)
        }).then((response)=>response.json()).then((response)=>response).catch((err)=>({
                success: false,
                reason: err
            }));
    }
    getLocalStoragePrefix() {
        return /^elibraryMist/;
    }
}
function $c8843a02291a36e7$var$getCookie() {
    return document.cookie.split(";").map((cookie)=>cookie.split("=").map((part)=>part.trim())).map(([key, value])=>({
            key: key,
            value: value
        })).find((cookie)=>cookie.key == "elibrary-flash")?.value;
}
class $c8843a02291a36e7$export$7b6b126472f9f21c extends (0, $434124d31c68176b$export$2df7f0b5c09577ab) {
    getStateKey() {
        return `elibraryMist.${$c8843a02291a36e7$var$getCookie()}`;
    }
}
class $c8843a02291a36e7$export$94d7ae0124faaa6d extends (0, $434124d31c68176b$export$2df7f0b5c09577ab) {
    getStateKey() {
        return `elibraryMist.${$c8843a02291a36e7$var$getCookie()}.${$c8843a02291a36e7$var$getProductId()}.${$c8843a02291a36e7$var$getAttemptId()}`;
    }
}



class $4afb854d5a7f4d82$export$3b5445cacfccd6cf {
    bind(bindTarget) {
        this.targets.forEach((element)=>{
            element.addEventListener(this.listen, (e)=>{
                if (this.suppress) e.preventDefault();
                const event = this.invoke(element, e);
                if (Array.isArray(event)) event.forEach((e)=>bindTarget.dispatchEvent(e));
                else bindTarget.dispatchEvent(event);
                return false;
            });
        });
    }
    constructor(targets, listen, invoke, suppress){
        this.bindCallback = (html, event)=>[];
        this.targets = targets;
        this.listen = listen;
        this.invoke = invoke;
        this.suppress = suppress || false;
    }
}
class $4afb854d5a7f4d82$export$425d25f1ccf4a6b5 {
    constructor(condition, invoke, suppress){
        this.condition = condition;
        this.invoke = invoke;
        this.suppress = suppress || false;
    }
}


function $3b5206c0221e9546$export$d784918a83e8de76(time) {
    const rounded = Math.round(time / 1000);
    const hours = Math.trunc(rounded / 60 / 60);
    const minutes = Math.trunc(rounded / 60) % 60;
    const seconds = rounded % 60;
    return `${hours ? hours + ":" : ""}${("00" + minutes).slice(-2)}:${("00" + seconds).slice(-2)}`;
}
class $3b5206c0221e9546$export$40a0b21fc5553587 {
    getBindPause() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".pause"), "click", (element)=>new (0, $7923788bad7460a0$export$60458c85dad92def)(true));
    }
    getBindFlag() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll("input.flag"), "change", (element)=>new (0, $7923788bad7460a0$export$71f5f68be44498fe)(element.checked));
    }
    getBindRandomize() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll("input.randomize"), "change", (element)=>new (0, $7923788bad7460a0$export$318fb9566749373b)(element.checked));
    }
    getProgressChart() {
        return document.querySelector(".item-progress");
    }
    getTotalScoreChart() {
        return document.querySelector(".total-score");
    }
    displayTotalTime(time) {
        document.querySelectorAll(".total-timer .input-group-text").forEach((label)=>label.innerHTML = $3b5206c0221e9546$export$d784918a83e8de76(time));
    }
    displayTimer(show) {
        const timer = document.querySelector(".total-timer");
        timer.classList.toggle("invisible", !show);
    }
    displayNext(show) {
        const next = document.querySelectorAll(".next");
        next.forEach((n)=>{
            n.classList.toggle("disabled", !show);
            n.classList.toggle("btn-light", !show);
            n.classList.toggle("btn-primary", show);
        });
    }
    displayPrevious(show) {
        const next = document.querySelectorAll(".prev");
        next.forEach((n)=>n.classList.toggle("disabled", !show));
    }
    displayFinish(show) {
        const finish = document.querySelectorAll('[data-target=".finish-test"]');
        const toggle = document.querySelectorAll('.toggle[data-target=".finish-test"]');
        const next = document.querySelectorAll(".next");
        finish.forEach((f)=>{
            f.classList.toggle("btn-primary", show);
            f.classList.toggle("btn-secondary", !show);
        });
        toggle.forEach((t)=>{
            t.classList.toggle("d-none", !show);
        });
        next.forEach((n)=>{
            n.classList.toggle("d-none", show);
        });
    }
    displayFlag(flagged) {
        const next = document.querySelectorAll("input.flag");
        next.forEach((n)=>n.checked = flagged);
    }
    displayCountdown(show) {
        const advance = document.querySelector(".countdown");
        advance.classList.toggle("invisible", !show);
    }
    displayCurrentTime(time) {
        document.querySelectorAll(".item-timer .input-group-text").forEach((label)=>label.innerHTML = $3b5206c0221e9546$export$d784918a83e8de76(time));
    }
    displayCountdownTime(time) {
        document.querySelectorAll(".countdown-timer .input-group-text").forEach((label)=>label.innerHTML = `${Math.round(time / 1000)} seconds left`);
    }
    displayRandomize(randomize) {
        document.querySelectorAll("input.randomize").forEach((n)=>n.checked = randomize);
    }
    displayPosition(index, length) {
        document.querySelectorAll(".item-position").forEach((n)=>n.textContent = `${index + 1} of ${length}`);
    }
    constructor(item){
        this.itemIdSerializer = item;
    }
}
class $3b5206c0221e9546$export$297f7e0dec408b43 extends $3b5206c0221e9546$export$40a0b21fc5553587 {
    displayItem(content) {
        const title = document.querySelector(".section-title");
        title.innerHTML = `${content.section_title} - Question ${content.name}`;
    }
}
class $3b5206c0221e9546$export$ca6ee2dc24d66f1d extends $3b5206c0221e9546$export$40a0b21fc5553587 {
    displayItem(content) {
        const title = document.querySelector(".section-title");
        title.innerHTML = content.section_title;
    }
    displayFlip(front) {
        document.querySelectorAll(".flip-card").forEach((n)=>{
            n.classList.toggle("show-question", !front);
            n.classList.toggle("show-answer", front);
        });
        document.querySelectorAll([
            "button.flip-card",
            "input[type=button].flip-card"
        ].join(", ")).forEach((n)=>{
            n.textContent = front ? "Show Answer" : "Show Question";
        });
        document.querySelectorAll([
            ".card-type"
        ].join(", ")).forEach((n)=>{
            n.textContent = front ? "Question" : "Answer";
        });
    }
}





class $6f125744f8893ba5$export$94cd813f5440f38d {
    hideItemTypes() {
        [
            document.querySelector(".item .unknown"),
            document.querySelector(".item .multiplechoice"),
            document.querySelector(".item .multiplecorrect"),
            document.querySelector(".item .numeric"),
            document.querySelector(".item .cloze"),
            document.querySelector(".item .matching"),
            document.querySelector(".item .sorting"),
            document.querySelector(".item .constructedresponse"),
            document.querySelector(".item .flashcard")
        ].filter((i)=>i).forEach((element)=>{
            element.classList.add("d-none");
        });
    }
}
class $6f125744f8893ba5$export$1741f5fbb0046105 extends $6f125744f8893ba5$export$94cd813f5440f38d {
    displayItemContent(content, bindTarget) {
        const unknown = document.querySelector(".item .unknown");
        unknown.classList.remove("d-none");
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        // Do nothing.
        return;
    }
    displayItemReview(content, answer) {
        // Do nothing.
        return;
    }
    displayItemRendered(content, mathjax) {
        // Do nothing.
        return;
    }
    displayItemAlerts(content) {
        // Do nothing.
        return;
    }
}


class $bde34c4506ee90eb$export$6fa019cb400783c4 extends (0, $6f125744f8893ba5$export$94cd813f5440f38d) {
    displayItemContent(content, bindTarget) {
        const multipleChoice = document.querySelector(".item .multiplechoice");
        multipleChoice.classList.remove("d-none");
        multipleChoice.classList.add("invisible");
        const name = multipleChoice.querySelector(".name");
        const prompt = multipleChoice.querySelector(".prompt");
        const style = multipleChoice.querySelector("style");
        name.innerHTML = content.name + ".";
        prompt.innerHTML = content.multiplechoice.prompt;
        style.innerText = [].concat(content.multiplechoice.style, content.contexts.map((c)=>c.style)).join("\n\n");
        Array.from(multipleChoice.querySelectorAll(".context-panel")).slice(1).forEach((panel)=>{
            panel.remove();
        });
        const contextPanel = multipleChoice.querySelector(".context-panel");
        const context = contextPanel.querySelector(".context");
        if (content.contexts.length > 0) {
            context.innerHTML = content.contexts[0].content_html;
            context.classList.remove("d-none");
            contextPanel.dataset.context = content.contexts[0].id;
            contextPanel.classList.remove("d-none");
            content.contexts.slice(1).reverse().forEach((_context)=>{
                const panel = contextPanel.cloneNode(true);
                const context = panel.querySelector(".context");
                context.innerHTML = _context.content_html;
                context.classList.remove("d-none");
                panel.dataset.context = _context.id;
                panel.classList.remove("d-none");
                panel.addEventListener("click", (e)=>{
                    bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$fe0b591ac3aa4171)([
                        panel.dataset.context
                    ]));
                });
                contextPanel.after(panel);
            });
        } else {
            context.innerHTML = "";
            context.classList.add("d-none");
            contextPanel.removeAttribute("data-context");
            contextPanel.classList.add("d-none");
        }
        const answers = multipleChoice.querySelector(".answers");
        const answerTemplate = answers.querySelector(".answer").cloneNode(true);
        answers.innerHTML = "";
        content.multiplechoice.answers.forEach((answerContent, index)=>{
            const answerNode = answerTemplate.cloneNode(true);
            const input = answerNode.querySelector("input[name=answer]");
            const label = answerNode.querySelector("label");
            const container = answerNode.querySelector(".content");
            container.innerHTML = answerContent.content;
            input.id = "answer-" + answerContent.name;
            input.value = answerContent.name;
            label.setAttribute("for", "answer-" + answerContent.name);
            answers.appendChild(answerNode);
        });
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        const multipleChoice = document.querySelector(".item .multiplechoice");
        const answers = multipleChoice.querySelector(".answers");
        content.multiplechoice.answers.forEach((answerContent, index)=>{
            const answerNode = answers.children[index];
            const input = answerNode.querySelector("input[name=answer]");
            const label = answerNode.querySelector("label");
            input.addEventListener("change", (e)=>{
                bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3dd7a8e950550ea4)(answerContent.name));
            });
            input.checked = answer === answerContent.name;
            if (answer === answerContent.name) label.classList.add("border", "rounded", "bg-light");
            else label.classList.remove("border", "rounded", "bg-light");
        });
    }
    displayItemReview(content, answer) {
        const multipleChoice = document.querySelector(".item .multiplechoice");
        const explanation = multipleChoice.querySelector(".explanation");
        explanation.innerHTML = content.multiplechoice.explanation;
        const explanationPanel = explanation.closest("div.card");
        const correct = document.querySelector(".correct");
        const correctAnswer = content.multiplechoice.answers.filter((answerContent)=>answerContent.correct)[0];
        if (answer === correctAnswer.name) {
            correct.innerHTML = "Correct";
            correct.classList.remove("alert-danger", "alert-info");
            correct.classList.add("alert-success");
            explanationPanel.classList.remove("border-danger", "border-info");
            explanationPanel.classList.add("border-success");
        } else if (answer) {
            correct.innerHTML = "Incorrect";
            correct.classList.remove("alert-success", "alert-info");
            correct.classList.add("alert-danger");
            explanationPanel.classList.remove("border-success", "border-info");
            explanationPanel.classList.add("border-danger");
        } else {
            correct.innerHTML = "Unanswered";
            correct.classList.remove("alert-success", "alert-danger");
            correct.classList.add("alert-info");
            explanationPanel.classList.remove("border-success", "border-danger");
            explanationPanel.classList.add("border-info");
        }
        const answers = multipleChoice.querySelector(".answers");
        content.multiplechoice.answers.forEach((answerContent, index)=>{
            const answerNode = answers.children[index];
            const label = answerNode.querySelector("label");
            const name = answerNode.querySelector(".name");
            if (name) name.innerHTML = answerContent.name + ".";
            const correct = answerNode.querySelector(".correct");
            if (answerContent.correct) {
                label.classList.remove("border-danger");
                label.classList.add("border-success");
                correct.classList.remove("d-none");
            } else if (answer === answerContent.name) {
                label.classList.remove("border-success");
                label.classList.add("border-danger");
                correct.classList.add("d-none");
            } else {
                label.classList.remove("border-success", "border-danger");
                correct.classList.add("d-none");
            }
        });
    }
    displayItemRendered(content, mathjax) {
        const multipleChoice = document.querySelector(".item .multiplechoice");
        mathjax.typesetPromise().then(()=>{
            multipleChoice.classList.remove("invisible");
        });
    }
    displayItemAlerts(content) {
        // Do nothing.
        return;
    }
}



/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */ var $139b6f51775b1fe4$exports = {};
function $139b6f51775b1fe4$var$_extends() {
    return $139b6f51775b1fe4$exports = $139b6f51775b1fe4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $139b6f51775b1fe4$exports.__esModule = true, $139b6f51775b1fe4$exports["default"] = $139b6f51775b1fe4$exports, $139b6f51775b1fe4$var$_extends.apply(null, arguments);
}
$139b6f51775b1fe4$exports = $139b6f51775b1fe4$var$_extends, $139b6f51775b1fe4$exports.__esModule = true, $139b6f51775b1fe4$exports["default"] = $139b6f51775b1fe4$exports;


var $8cf0f179285be5c8$export$c2f8e0cc249a8d8f = {
    // minimum relative difference between two compared values,
    // used by all comparison functions
    epsilon: 1e-12,
    // type of default matrix output. Choose 'matrix' (default) or 'array'
    matrix: "Matrix",
    // type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
    number: "number",
    // number of significant digits in BigNumbers
    precision: 64,
    // predictable output type of functions. When true, output type depends only
    // on the input types. When false (default), output type can vary depending
    // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
    // predictable is false, and returns `NaN` when true.
    predictable: false,
    // random seed for seeded pseudo random number generation
    // null = randomly seed
    randomSeed: null
};


// type checks for all known types
//
// note that:
//
// - check by duck-typing on a property like `isUnit`, instead of checking instanceof.
//   instanceof cannot be used because that would not allow to pass data from
//   one instance of math.js to another since each has it's own instance of Unit.
// - check the `isUnit` property via the constructor, so there will be no
//   matches for "fake" instances like plain objects with a property `isUnit`.
//   That is important for security reasons.
// - It must not be possible to override the type checks used internally,
//   for security reasons, so these functions are not exposed in the expression
//   parser.
function $2c4f948f17aa2240$export$7e4aa119212bc614(x) {
    return typeof x === "number";
}
function $2c4f948f17aa2240$export$e51d0e7e5c4a03ab(x) {
    if (!x || typeof x !== "object" || typeof x.constructor !== "function") return false;
    if (x.isBigNumber === true && typeof x.constructor.prototype === "object" && x.constructor.prototype.isBigNumber === true) return true;
    if (typeof x.constructor.isDecimal === "function" && x.constructor.isDecimal(x) === true) return true;
    return false;
}
function $2c4f948f17aa2240$export$8849a896711efe0c(x) {
    return x && typeof x === "object" && Object.getPrototypeOf(x).isComplex === true || false;
}
function $2c4f948f17aa2240$export$e312cb8a8e5e7c34(x) {
    return x && typeof x === "object" && Object.getPrototypeOf(x).isFraction === true || false;
}
function $2c4f948f17aa2240$export$8960dc335987b8da(x) {
    return x && x.constructor.prototype.isUnit === true || false;
}
function $2c4f948f17aa2240$export$844ec244b1367d54(x) {
    return typeof x === "string";
}
var $2c4f948f17aa2240$export$43bee75e5e14138e = Array.isArray;
function $2c4f948f17aa2240$export$b22160e0a14f87b7(x) {
    return x && x.constructor.prototype.isMatrix === true || false;
}
function $2c4f948f17aa2240$export$cea7aa84e978eba5(x) {
    return Array.isArray(x) || $2c4f948f17aa2240$export$b22160e0a14f87b7(x);
}
function $2c4f948f17aa2240$export$eb44495df7ba11d(x) {
    return x && x.isDenseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $2c4f948f17aa2240$export$d508368d4da3c38a(x) {
    return x && x.isSparseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $2c4f948f17aa2240$export$e331ccfa6f694c99(x) {
    return x && x.constructor.prototype.isRange === true || false;
}
function $2c4f948f17aa2240$export$ba3dc792055c2f45(x) {
    return x && x.constructor.prototype.isIndex === true || false;
}
function $2c4f948f17aa2240$export$f9ce7b637dfbe238(x) {
    return typeof x === "boolean";
}
function $2c4f948f17aa2240$export$381a1a20e6a63376(x) {
    return x && x.constructor.prototype.isResultSet === true || false;
}
function $2c4f948f17aa2240$export$e5dec9a75b602d6c(x) {
    return x && x.constructor.prototype.isHelp === true || false;
}
function $2c4f948f17aa2240$export$f6e2535fb5126e54(x) {
    return typeof x === "function";
}
function $2c4f948f17aa2240$export$871608497c498473(x) {
    return x instanceof Date;
}
function $2c4f948f17aa2240$export$49841c62b9eff15(x) {
    return x instanceof RegExp;
}
function $2c4f948f17aa2240$export$a6cdc56e425d0d0a(x) {
    return !!(x && typeof x === "object" && x.constructor === Object && !$2c4f948f17aa2240$export$8849a896711efe0c(x) && !$2c4f948f17aa2240$export$e312cb8a8e5e7c34(x));
}
function $2c4f948f17aa2240$export$630801d484da15df(x) {
    return x === null;
}
function $2c4f948f17aa2240$export$fce6876652108ab(x) {
    return x === undefined;
}
function $2c4f948f17aa2240$export$f88fb19d6b9ee5cb(x) {
    return x && x.isAccessorNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$440fa93dcf2757a3(x) {
    return x && x.isArrayNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$64d7d515ec030d5e(x) {
    return x && x.isAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$1665e2275a3d717a(x) {
    return x && x.isBlockNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$e1babefe78c70737(x) {
    return x && x.isConditionalNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$fa9d80731fd8c54b(x) {
    return x && x.isConstantNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$27c05cfffd263d30(x) {
    return x && x.isFunctionAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$6ae03b16e064e6c4(x) {
    return x && x.isFunctionNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$ff90979121a6cabc(x) {
    return x && x.isIndexNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$8ee0fc9ee280b4ee(x) {
    return x && x.isNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$3f18867a334658e9(x) {
    return x && x.isObjectNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$7e624cbaab6cce94(x) {
    return x && x.isOperatorNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$c55e3736c5721220(x) {
    return x && x.isParenthesisNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$92729c5c4ff6fc83(x) {
    return x && x.isRangeNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$87815d550facaed9(x) {
    return x && x.isSymbolNode === true && x.constructor.prototype.isNode === true || false;
}
function $2c4f948f17aa2240$export$dc36953d0b3a4f05(x) {
    return x && x.constructor.prototype.isChain === true || false;
}
function $2c4f948f17aa2240$export$f5bbd400c2f4426f(x) {
    var t = typeof x;
    if (t === "object") {
        // JavaScript types
        if (x === null) return "null";
        if (Array.isArray(x)) return "Array";
        if (x instanceof Date) return "Date";
        if (x instanceof RegExp) return "RegExp"; // math.js types
        if ($2c4f948f17aa2240$export$e51d0e7e5c4a03ab(x)) return "BigNumber";
        if ($2c4f948f17aa2240$export$8849a896711efe0c(x)) return "Complex";
        if ($2c4f948f17aa2240$export$e312cb8a8e5e7c34(x)) return "Fraction";
        if ($2c4f948f17aa2240$export$b22160e0a14f87b7(x)) return "Matrix";
        if ($2c4f948f17aa2240$export$8960dc335987b8da(x)) return "Unit";
        if ($2c4f948f17aa2240$export$ba3dc792055c2f45(x)) return "Index";
        if ($2c4f948f17aa2240$export$e331ccfa6f694c99(x)) return "Range";
        if ($2c4f948f17aa2240$export$381a1a20e6a63376(x)) return "ResultSet";
        if ($2c4f948f17aa2240$export$8ee0fc9ee280b4ee(x)) return x.type;
        if ($2c4f948f17aa2240$export$dc36953d0b3a4f05(x)) return "Chain";
        if ($2c4f948f17aa2240$export$e5dec9a75b602d6c(x)) return "Help";
        return "Object";
    }
    if (t === "function") return "Function";
    return t; // can be 'string', 'number', 'boolean', ...
}


function $33619877a15996ac$export$9cd59f9826255e47(x) {
    var type = typeof x; // immutable primitive types
    if (type === "number" || type === "string" || type === "boolean" || x === null || x === undefined) return x;
     // use clone function of the object when available
    if (typeof x.clone === "function") return x.clone();
     // array
    if (Array.isArray(x)) return x.map(function(value) {
        return $33619877a15996ac$export$9cd59f9826255e47(value);
    });
    if (x instanceof Date) return new Date(x.valueOf());
    if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(x)) return x; // bignumbers are immutable
    if (x instanceof RegExp) throw new TypeError("Cannot clone " + x); // TODO: clone a RegExp
    // object
    return $33619877a15996ac$export$d6051a0f7a227332(x, $33619877a15996ac$export$9cd59f9826255e47);
}
function $33619877a15996ac$export$d6051a0f7a227332(object, callback) {
    var clone = {};
    for(var key in object)if ($33619877a15996ac$export$5a15a386532a5ea4(object, key)) clone[key] = callback(object[key]);
    return clone;
}
function $33619877a15996ac$export$8b58be045bf06082(a, b) {
    for(var prop in b)if ($33619877a15996ac$export$5a15a386532a5ea4(b, prop)) a[prop] = b[prop];
    return a;
}
function $33619877a15996ac$export$54e9fb29908872fa(a, b) {
    // TODO: add support for Arrays to deepExtend
    if (Array.isArray(b)) throw new TypeError("Arrays are not supported by deepExtend");
    for(var prop in b)// We check against prop not being in Object.prototype or Function.prototype
    // to prevent polluting for example Object.__proto__.
    if ($33619877a15996ac$export$5a15a386532a5ea4(b, prop) && !(prop in Object.prototype) && !(prop in Function.prototype)) {
        if (b[prop] && b[prop].constructor === Object) {
            if (a[prop] === undefined) a[prop] = {};
            if (a[prop] && a[prop].constructor === Object) $33619877a15996ac$export$54e9fb29908872fa(a[prop], b[prop]);
            else a[prop] = b[prop];
        } else if (Array.isArray(b[prop])) throw new TypeError("Arrays are not supported by deepExtend");
        else a[prop] = b[prop];
    }
    return a;
}
function $33619877a15996ac$export$6cc798251952180(a, b) {
    var prop, i, len;
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0, len = a.length; i < len; i++){
            if (!$33619877a15996ac$export$6cc798251952180(a[i], b[i])) return false;
        }
        return true;
    } else if (typeof a === "function") return a === b;
    else if (a instanceof Object) {
        if (Array.isArray(b) || !(b instanceof Object)) return false;
        for(prop in a){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in b) || !$33619877a15996ac$export$6cc798251952180(a[prop], b[prop])) return false;
        }
        for(prop in b){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in a)) return false;
        }
        return true;
    } else return a === b;
}
function $33619877a15996ac$export$519b2d75cc54d03b(nestedObject) {
    var flattenedObject = {};
    $33619877a15996ac$var$_deepFlatten(nestedObject, flattenedObject);
    return flattenedObject;
} // helper function used by deepFlatten
function $33619877a15996ac$var$_deepFlatten(nestedObject, flattenedObject) {
    for(var prop in nestedObject)if ($33619877a15996ac$export$5a15a386532a5ea4(nestedObject, prop)) {
        var value = nestedObject[prop];
        if (typeof value === "object" && value !== null) $33619877a15996ac$var$_deepFlatten(value, flattenedObject);
        else flattenedObject[prop] = value;
    }
}
function $33619877a15996ac$export$a73e197d57374bd3() {
    // test needed for broken IE8 implementation
    try {
        if (Object.defineProperty) {
            Object.defineProperty({}, "x", {
                get: function get() {
                    return null;
                }
            });
            return true;
        }
    } catch (e) {}
    return false;
}
function $33619877a15996ac$export$488013bae63b21da(object, prop, valueResolver) {
    var _uninitialized = true;
    var _value;
    Object.defineProperty(object, prop, {
        get: function get() {
            if (_uninitialized) {
                _value = valueResolver();
                _uninitialized = false;
            }
            return _value;
        },
        set: function set(value) {
            _value = value;
            _uninitialized = false;
        },
        configurable: true,
        enumerable: true
    });
}
function $33619877a15996ac$export$df3f009e3d155b20(object, path) {
    if (path && typeof path === "string") return $33619877a15996ac$export$df3f009e3d155b20(object, path.split("."));
    var obj = object;
    if (path) for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (!(key in obj)) obj[key] = {};
        obj = obj[key];
    }
    return obj;
}
function $33619877a15996ac$export$5a15a386532a5ea4(object, property) {
    return object && Object.hasOwnProperty.call(object, property);
}
function $33619877a15996ac$export$1bc2c269dfa97885(object) {
    return object && typeof object.factory === "function";
}
function $33619877a15996ac$export$3988ae62b71be9a3(object, path) {
    if (typeof path === "string") {
        if ($33619877a15996ac$var$isPath(path)) return $33619877a15996ac$export$3988ae62b71be9a3(object, path.split("."));
        else return object[path];
    }
    var child = object;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        child = child ? child[key] : undefined;
    }
    return child;
}
function $33619877a15996ac$export$adaa4cf7ef1b65be(object, path, value) {
    if (typeof path === "string") {
        if ($33619877a15996ac$var$isPath(path)) return $33619877a15996ac$export$adaa4cf7ef1b65be(object, path.split("."), value);
        else {
            object[path] = value;
            return object;
        }
    }
    var child = object;
    for(var i = 0; i < path.length - 1; i++){
        var key = path[i];
        if (child[key] === undefined) child[key] = {};
        child = child[key];
    }
    if (path.length > 0) {
        var lastKey = path[path.length - 1];
        child[lastKey] = value;
    }
    return object;
}
function $33619877a15996ac$export$357523c63a2253b9(object, properties, transform) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = $33619877a15996ac$export$3988ae62b71be9a3(object, key);
        if (value !== undefined) $33619877a15996ac$export$adaa4cf7ef1b65be(copy, key, transform ? transform(value, key) : value);
    }
    return copy;
}
function $33619877a15996ac$export$8cea971c64639ea7(object, properties) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = object[key];
        if (value !== undefined) copy[key] = value;
    }
    return copy;
}
function $33619877a15996ac$export$68c286be0e7e55b7(object) {
    return Object.keys(object).map((key)=>object[key]);
} // helper function to test whether a string contains a path like 'user.name'
function $33619877a15996ac$var$isPath(str) {
    return str.indexOf(".") !== -1;
}



var $fa46642b405ac3fb$export$517ab898194ae9af = [
    "Matrix",
    "Array"
]; // valid values for option matrix
var $fa46642b405ac3fb$export$f4b0a2084fdf2177 = [
    "number",
    "BigNumber",
    "Fraction"
]; // valid values for option number
function $fa46642b405ac3fb$export$3984aa6f7f77f1ae(config, emit) {
    /**
   * Set configuration options for math.js, and get current options.
   * Will emit a 'config' event, with arguments (curr, prev, changes).
   *
   * This function is only available on a mathjs instance created using `create`.
   *
   * Syntax:
   *
   *     math.config(config: Object): Object
   *
   * Examples:
   *
   *
   *     import { create, all } from 'mathjs'
   *
   *     // create a mathjs instance
   *     const math = create(all)
   *
   *     math.config().number                // outputs 'number'
   *     math.evaluate('0.4')                // outputs number 0.4
   *     math.config({number: 'Fraction'})
   *     math.evaluate('0.4')                // outputs Fraction 2/5
   *
   * @param {Object} [options] Available options:
   *                            {number} epsilon
   *                              Minimum relative difference between two
   *                              compared values, used by all comparison functions.
   *                            {string} matrix
   *                              A string 'Matrix' (default) or 'Array'.
   *                            {string} number
   *                              A string 'number' (default), 'BigNumber', or 'Fraction'
   *                            {number} precision
   *                              The number of significant digits for BigNumbers.
   *                              Not applicable for Numbers.
   *                            {string} parenthesis
   *                              How to display parentheses in LaTeX and string
   *                              output.
   *                            {string} randomSeed
   *                              Random seed for seeded pseudo random number generator.
   *                              Set to null to randomly seed.
   * @return {Object} Returns the current configuration
   */ function _config(options) {
        if (options) {
            var prev = (0, $33619877a15996ac$export$d6051a0f7a227332)(config, (0, $33619877a15996ac$export$9cd59f9826255e47)); // validate some of the options
            $fa46642b405ac3fb$var$validateOption(options, "matrix", $fa46642b405ac3fb$export$517ab898194ae9af);
            $fa46642b405ac3fb$var$validateOption(options, "number", $fa46642b405ac3fb$export$f4b0a2084fdf2177); // merge options
            (0, $33619877a15996ac$export$54e9fb29908872fa)(config, options);
            var curr = (0, $33619877a15996ac$export$d6051a0f7a227332)(config, (0, $33619877a15996ac$export$9cd59f9826255e47));
            var changes = (0, $33619877a15996ac$export$d6051a0f7a227332)(options, (0, $33619877a15996ac$export$9cd59f9826255e47)); // emit 'config' event
            emit("config", curr, prev, changes);
            return curr;
        } else return (0, $33619877a15996ac$export$d6051a0f7a227332)(config, (0, $33619877a15996ac$export$9cd59f9826255e47));
    } // attach the valid options to the function so they can be extended
    _config.MATRIX_OPTIONS = $fa46642b405ac3fb$export$517ab898194ae9af;
    _config.NUMBER_OPTIONS = $fa46642b405ac3fb$export$f4b0a2084fdf2177; // attach the config properties as readonly properties to the config function
    Object.keys((0, $8cf0f179285be5c8$export$c2f8e0cc249a8d8f)).forEach((key)=>{
        Object.defineProperty(_config, key, {
            get: ()=>config[key],
            enumerable: true,
            configurable: true
        });
    });
    return _config;
}
/**
 * Test whether an Array contains a specific item.
 * @param {Array.<string>} array
 * @param {string} item
 * @return {boolean}
 */ function $fa46642b405ac3fb$var$contains(array, item) {
    return array.indexOf(item) !== -1;
}
/**
 * Validate an option
 * @param {Object} options         Object with options
 * @param {string} name            Name of the option to validate
 * @param {Array.<string>} values  Array with valid values for this option
 */ function $fa46642b405ac3fb$var$validateOption(options, name, values) {
    if (options[name] !== undefined && !$fa46642b405ac3fb$var$contains(values, options[name])) // unknown value
    console.warn('Warning: Unknown value "' + options[name] + '" for configuration option "' + name + '". ' + "Available options: " + values.map((value)=>JSON.stringify(value)).join(", ") + ".");
}


var $28bb29a4365991c4$export$e506a1d27d1eaa20 = /* #__PURE__ */ function config(options) {
    if (options) throw new Error("The global config is readonly. \nPlease create a mathjs instance if you want to change the default configuration. \nExample:\n\n  import { create, all } from 'mathjs';\n  const mathjs = create(all);\n  mathjs.config({ number: 'BigNumber' });\n");
    return Object.freeze((0, $8cf0f179285be5c8$export$c2f8e0cc249a8d8f));
};
(0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))($28bb29a4365991c4$export$e506a1d27d1eaa20, (0, $8cf0f179285be5c8$export$c2f8e0cc249a8d8f), {
    MATRIX_OPTIONS: $fa46642b405ac3fb$export$517ab898194ae9af,
    NUMBER_OPTIONS: $fa46642b405ac3fb$export$f4b0a2084fdf2177
});



function $a03283b133c3c55b$export$a287f47fed4544b8(value) {
    if (typeof value === "boolean") return true;
    return isFinite(value) ? value === Math.round(value) : false;
}
var $a03283b133c3c55b$export$c5552dfdbc7cec71 = /* #__PURE__ */ Math.sign || function(x) {
    if (x > 0) return 1;
    else if (x < 0) return -1;
    else return 0;
};
var $a03283b133c3c55b$export$b9fae0bba9d9094d = /* #__PURE__ */ Math.log2 || function log2(x) {
    return Math.log(x) / Math.LN2;
};
var $a03283b133c3c55b$export$75e08744a3ff8516 = /* #__PURE__ */ Math.log10 || function log10(x) {
    return Math.log(x) / Math.LN10;
};
var $a03283b133c3c55b$export$144dcf16adfb9698 = /* #__PURE__ */ Math.log1p || function(x) {
    return Math.log(x + 1);
};
var $a03283b133c3c55b$export$841fc4d5a1480b85 = /* #__PURE__ */ Math.cbrt || function cbrt(x) {
    if (x === 0) return x;
    var negate = x < 0;
    var result;
    if (negate) x = -x;
    if (isFinite(x)) {
        result = Math.exp(Math.log(x) / 3); // from https://en.wikipedia.org/wiki/Cube_root#Numerical_methods
        result = (x / (result * result) + 2 * result) / 3;
    } else result = x;
    return negate ? -result : result;
};
var $a03283b133c3c55b$export$b6c0a80d46d3391d = /* #__PURE__ */ Math.expm1 || function expm1(x) {
    return x >= 2e-4 || x <= -0.0002 ? Math.exp(x) - 1 : x + x * x / 2 + x * x * x / 6;
};
/**
 * Formats a number in a given base
 * @param {number} n
 * @param {number} base
 * @param {number} size
 * @returns {string}
 */ function $a03283b133c3c55b$var$formatNumberToBase(n, base, size) {
    var prefixes = {
        2: "0b",
        8: "0o",
        16: "0x"
    };
    var prefix = prefixes[base];
    var suffix = "";
    if (size) {
        if (size < 1) throw new Error("size must be in greater than 0");
        if (!$a03283b133c3c55b$export$a287f47fed4544b8(size)) throw new Error("size must be an integer");
        if (n > 2 ** (size - 1) - 1 || n < -(2 ** (size - 1))) throw new Error("Value must be in range [-2^".concat(size - 1, ", 2^").concat(size - 1, "-1]"));
        if (!$a03283b133c3c55b$export$a287f47fed4544b8(n)) throw new Error("Value must be an integer");
        if (n < 0) n = n + 2 ** size;
        suffix = "i".concat(size);
    }
    var sign = "";
    if (n < 0) {
        n = -n;
        sign = "-";
    }
    return "".concat(sign).concat(prefix).concat(n.toString(base)).concat(suffix);
}
function $a03283b133c3c55b$export$d9468344d3651243(value, options) {
    if (typeof options === "function") // handle format(value, fn)
    return options(value);
     // handle special cases
    if (value === Infinity) return "Infinity";
    else if (value === -Infinity) return "-Infinity";
    else if (isNaN(value)) return "NaN";
     // default values for options
    var notation = "auto";
    var precision;
    var wordSize;
    if (options) {
        // determine notation from options
        if (options.notation) notation = options.notation;
         // determine precision from options
        if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(options)) precision = options;
        else if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(options.precision)) precision = options.precision;
        if (options.wordSize) {
            wordSize = options.wordSize;
            if (typeof wordSize !== "number") throw new Error('Option "wordSize" must be a number');
        }
    } // handle the various notations
    switch(notation){
        case "fixed":
            return $a03283b133c3c55b$export$a81f732198733497(value, precision);
        case "exponential":
            return $a03283b133c3c55b$export$888cb08ddc4765be(value, precision);
        case "engineering":
            return $a03283b133c3c55b$export$9299fe684ed0ee48(value, precision);
        case "bin":
            return $a03283b133c3c55b$var$formatNumberToBase(value, 2, wordSize);
        case "oct":
            return $a03283b133c3c55b$var$formatNumberToBase(value, 8, wordSize);
        case "hex":
            return $a03283b133c3c55b$var$formatNumberToBase(value, 16, wordSize);
        case "auto":
            // remove trailing zeros after the decimal point
            return $a03283b133c3c55b$export$3e91a10e66078270(value, precision, options && options).replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== "." ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
    }
}
function $a03283b133c3c55b$export$feb80e120a50087f(value) {
    // parse the input value
    var match = String(value).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
    if (!match) throw new SyntaxError("Invalid number " + value);
    var sign = match[1];
    var digits = match[2];
    var exponent = parseFloat(match[4] || "0");
    var dot = digits.indexOf(".");
    exponent += dot !== -1 ? dot - 1 : digits.length - 1;
    var coefficients = digits.replace(".", "") // remove the dot (must be removed before removing leading zeros)
    .replace(/^0*/, function(zeros) {
        // remove leading zeros, add their count to the exponent
        exponent -= zeros.length;
        return "";
    }).replace(/0*$/, "") // remove trailing zeros
    .split("").map(function(d) {
        return parseInt(d);
    });
    if (coefficients.length === 0) {
        coefficients.push(0);
        exponent++;
    }
    return {
        sign: sign,
        coefficients: coefficients,
        exponent: exponent
    };
}
function $a03283b133c3c55b$export$9299fe684ed0ee48(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var split = $a03283b133c3c55b$export$feb80e120a50087f(value);
    var rounded = $a03283b133c3c55b$export$e5b32ced877afc7e(split, precision);
    var e = rounded.exponent;
    var c = rounded.coefficients; // find nearest lower multiple of 3 for exponent
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3;
    if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(precision)) // add zeroes to give correct sig figs
    while(precision > c.length || e - newExp + 1 > c.length)c.push(0);
    else {
        // concatenate coefficients with necessary zeros
        // add zeros if necessary (for example: 1e+8 -> 100e+6)
        var missingZeros = Math.abs(e - newExp) - (c.length - 1);
        for(var i = 0; i < missingZeros; i++)c.push(0);
    } // find difference in exponents
    var expDiff = Math.abs(e - newExp);
    var decimalIdx = 1; // push decimal index over by expDiff times
    while(expDiff > 0){
        decimalIdx++;
        expDiff--;
    } // if all coefficient values are zero after the decimal point and precision is unset, don't add a decimal value.
    // otherwise concat with the rest of the coefficients
    var decimals = c.slice(decimalIdx).join("");
    var decimalVal = (0, $2c4f948f17aa2240$export$7e4aa119212bc614)(precision) && decimals.length || decimals.match(/[1-9]/) ? "." + decimals : "";
    var str = c.slice(0, decimalIdx).join("") + decimalVal + "e" + (e >= 0 ? "+" : "") + newExp.toString();
    return rounded.sign + str;
}
function $a03283b133c3c55b$export$a81f732198733497(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var splitValue = $a03283b133c3c55b$export$feb80e120a50087f(value);
    var rounded = typeof precision === "number" ? $a03283b133c3c55b$export$e5b32ced877afc7e(splitValue, splitValue.exponent + 1 + precision) : splitValue;
    var c = rounded.coefficients;
    var p = rounded.exponent + 1; // exponent may have changed
    // append zeros if needed
    var pp = p + (precision || 0);
    if (c.length < pp) c = c.concat($a03283b133c3c55b$var$zeros(pp - c.length));
     // prepend zeros if needed
    if (p < 0) {
        c = $a03283b133c3c55b$var$zeros(-p + 1).concat(c);
        p = 1;
    } // insert a dot if needed
    if (p < c.length) c.splice(p, 0, p === 0 ? "0." : ".");
    return rounded.sign + c.join("");
}
function $a03283b133c3c55b$export$888cb08ddc4765be(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
     // round if needed, else create a clone
    var split = $a03283b133c3c55b$export$feb80e120a50087f(value);
    var rounded = precision ? $a03283b133c3c55b$export$e5b32ced877afc7e(split, precision) : split;
    var c = rounded.coefficients;
    var e = rounded.exponent; // append zeros if needed
    if (c.length < precision) c = c.concat($a03283b133c3c55b$var$zeros(precision - c.length));
     // format as `C.CCCe+EEE` or `C.CCCe-EEE`
    var first = c.shift();
    return rounded.sign + first + (c.length > 0 ? "." + c.join("") : "") + "e" + (e >= 0 ? "+" : "") + e;
}
function $a03283b133c3c55b$export$3e91a10e66078270(value, precision, options) {
    if (isNaN(value) || !isFinite(value)) return String(value);
     // determine lower and upper bound for exponential notation.
    var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
    var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5;
    var split = $a03283b133c3c55b$export$feb80e120a50087f(value);
    var rounded = precision ? $a03283b133c3c55b$export$e5b32ced877afc7e(split, precision) : split;
    if (rounded.exponent < lowerExp || rounded.exponent >= upperExp) // exponential notation
    return $a03283b133c3c55b$export$888cb08ddc4765be(value, precision);
    else {
        var c = rounded.coefficients;
        var e = rounded.exponent; // append trailing zeros
        if (c.length < precision) c = c.concat($a03283b133c3c55b$var$zeros(precision - c.length));
         // append trailing zeros
        // TODO: simplify the next statement
        c = c.concat($a03283b133c3c55b$var$zeros(e - c.length + 1 + (c.length < precision ? precision - c.length : 0))); // prepend zeros
        c = $a03283b133c3c55b$var$zeros(-e).concat(c);
        var dot = e > 0 ? e : 0;
        if (dot < c.length - 1) c.splice(dot + 1, 0, ".");
        return rounded.sign + c.join("");
    }
}
function $a03283b133c3c55b$export$e5b32ced877afc7e(split, precision) {
    // create a clone
    var rounded = {
        sign: split.sign,
        coefficients: split.coefficients,
        exponent: split.exponent
    };
    var c = rounded.coefficients; // prepend zeros if needed
    while(precision <= 0){
        c.unshift(0);
        rounded.exponent++;
        precision++;
    }
    if (c.length > precision) {
        var removed = c.splice(precision, c.length - precision);
        if (removed[0] >= 5) {
            var i = precision - 1;
            c[i]++;
            while(c[i] === 10){
                c.pop();
                if (i === 0) {
                    c.unshift(0);
                    rounded.exponent++;
                    i++;
                }
                i--;
                c[i]++;
            }
        }
    }
    return rounded;
}
/**
 * Create an array filled with zeros.
 * @param {number} length
 * @return {Array}
 */ function $a03283b133c3c55b$var$zeros(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push(0);
    return arr;
}
function $a03283b133c3c55b$export$9c0987062f8f5d89(value) {
    return value.toExponential().replace(/e.*$/, "") // remove exponential notation
    .replace(/^0\.?0*|\./, "") // remove decimal point and leading zeros
    .length;
}
var $a03283b133c3c55b$export$41b54fa1db30dbb5 = Number.EPSILON || 2.2204460492503130808472633361816E-16;
function $a03283b133c3c55b$export$6f3989c6ecc04081(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon === null || epsilon === undefined) return x === y;
    if (x === y) return true;
     // NaN
    if (isNaN(x) || isNaN(y)) return false;
     // at this point x and y should be finite
    if (isFinite(x) && isFinite(y)) {
        // check numbers are very close, needed when comparing numbers near zero
        var diff = Math.abs(x - y);
        if (diff < $a03283b133c3c55b$export$41b54fa1db30dbb5) return true;
        else // use relative error
        return diff <= Math.max(Math.abs(x), Math.abs(y)) * epsilon;
    } // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
}
var $a03283b133c3c55b$export$b26caf0f29211d08 = Math.acosh || function(x) {
    return Math.log(Math.sqrt(x * x - 1) + x);
};
var $a03283b133c3c55b$export$839d8a01b6af4fc0 = Math.asinh || function(x) {
    return Math.log(Math.sqrt(x * x + 1) + x);
};
var $a03283b133c3c55b$export$21ea955025ceb08b = Math.atanh || function(x) {
    return Math.log((1 + x) / (1 - x)) / 2;
};
var $a03283b133c3c55b$export$2e2fd1ad24e4d350 = Math.cosh || function(x) {
    return (Math.exp(x) + Math.exp(-x)) / 2;
};
var $a03283b133c3c55b$export$545004b505d7c555 = Math.sinh || function(x) {
    return (Math.exp(x) - Math.exp(-x)) / 2;
};
var $a03283b133c3c55b$export$7128670e45beef9a = Math.tanh || function(x) {
    var e = Math.exp(2 * x);
    return (e - 1) / (e + 1);
};
function $a03283b133c3c55b$export$fe7b50dc6162f97e(x, y) {
    var signx = x > 0 ? true : x < 0 ? false : 1 / x === Infinity;
    var signy = y > 0 ? true : y < 0 ? false : 1 / y === Infinity;
    return signx ^ signy ? -x : x;
}






/**
 * Formats a BigNumber in a given base
 * @param {BigNumber} n
 * @param {number} base
 * @param {number} size
 * @returns {string}
 */ function $2f8906b03bd99bc0$var$formatBigNumberToBase(n, base, size) {
    var BigNumberCtor = n.constructor;
    var big2 = new BigNumberCtor(2);
    var suffix = "";
    if (size) {
        if (size < 1) throw new Error("size must be in greater than 0");
        if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(size)) throw new Error("size must be an integer");
        if (n.greaterThan(big2.pow(size - 1).sub(1)) || n.lessThan(big2.pow(size - 1).mul(-1))) throw new Error("Value must be in range [-2^".concat(size - 1, ", 2^").concat(size - 1, "-1]"));
        if (!n.isInteger()) throw new Error("Value must be an integer");
        if (n.lessThan(0)) n = n.add(big2.pow(size));
        suffix = "i".concat(size);
    }
    switch(base){
        case 2:
            return "".concat(n.toBinary()).concat(suffix);
        case 8:
            return "".concat(n.toOctal()).concat(suffix);
        case 16:
            return "".concat(n.toHexadecimal()).concat(suffix);
        default:
            throw new Error("Base ".concat(base, " not supported "));
    }
}
function $2f8906b03bd99bc0$export$d9468344d3651243(value, options) {
    if (typeof options === "function") // handle format(value, fn)
    return options(value);
     // handle special cases
    if (!value.isFinite()) return value.isNaN() ? "NaN" : value.gt(0) ? "Infinity" : "-Infinity";
     // default values for options
    var notation = "auto";
    var precision;
    var wordSize;
    if (options !== undefined) {
        // determine notation from options
        if (options.notation) notation = options.notation;
         // determine precision from options
        if (typeof options === "number") precision = options;
        else if (options.precision) precision = options.precision;
        if (options.wordSize) {
            wordSize = options.wordSize;
            if (typeof wordSize !== "number") throw new Error('Option "wordSize" must be a number');
        }
    } // handle the various notations
    switch(notation){
        case "fixed":
            return $2f8906b03bd99bc0$export$a81f732198733497(value, precision);
        case "exponential":
            return $2f8906b03bd99bc0$export$888cb08ddc4765be(value, precision);
        case "engineering":
            return $2f8906b03bd99bc0$export$9299fe684ed0ee48(value, precision);
        case "bin":
            return $2f8906b03bd99bc0$var$formatBigNumberToBase(value, 2, wordSize);
        case "oct":
            return $2f8906b03bd99bc0$var$formatBigNumberToBase(value, 8, wordSize);
        case "hex":
            return $2f8906b03bd99bc0$var$formatBigNumberToBase(value, 16, wordSize);
        case "auto":
            // determine lower and upper bound for exponential notation.
            // TODO: implement support for upper and lower to be BigNumbers themselves
            var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
            var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5; // handle special case zero
            if (value.isZero()) return "0"; // determine whether or not to output exponential notation
            var str;
            var rounded = value.toSignificantDigits(precision);
            var exp = rounded.e;
            if (exp >= lowerExp && exp < upperExp) // normal number notation
            str = rounded.toFixed();
            else // exponential notation
            str = $2f8906b03bd99bc0$export$888cb08ddc4765be(value, precision);
             // remove trailing zeros after the decimal point
            return str.replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== "." ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
    }
}
function $2f8906b03bd99bc0$export$9299fe684ed0ee48(value, precision) {
    // find nearest lower multiple of 3 for exponent
    var e = value.e;
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3; // find difference in exponents, and calculate the value without exponent
    var valueWithoutExp = value.mul(Math.pow(10, -newExp));
    var valueStr = valueWithoutExp.toPrecision(precision);
    if (valueStr.indexOf("e") !== -1) valueStr = valueWithoutExp.toString();
    return valueStr + "e" + (e >= 0 ? "+" : "") + newExp.toString();
}
function $2f8906b03bd99bc0$export$888cb08ddc4765be(value, precision) {
    if (precision !== undefined) return value.toExponential(precision - 1); // Note the offset of one
    else return value.toExponential();
}
function $2f8906b03bd99bc0$export$a81f732198733497(value, precision) {
    return value.toFixed(precision);
}


function $addf7cb66573d3e4$export$10fdab3683b55b22(text, search) {
    var start = text.length - search.length;
    var end = text.length;
    return text.substring(start, end) === search;
}
function $addf7cb66573d3e4$export$d9468344d3651243(value, options) {
    var result = $addf7cb66573d3e4$var$_format(value, options);
    if (options && typeof options === "object" && "truncate" in options && result.length > options.truncate) return result.substring(0, options.truncate - 3) + "...";
    return result;
}
function $addf7cb66573d3e4$var$_format(value, options) {
    if (typeof value === "number") return (0, $a03283b133c3c55b$export$d9468344d3651243)(value, options);
    if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(value)) return (0, $2f8906b03bd99bc0$export$d9468344d3651243)(value, options);
     // note: we use unsafe duck-typing here to check for Fractions, this is
    // ok here since we're only invoking toString or concatenating its values
    if ($addf7cb66573d3e4$var$looksLikeFraction(value)) {
        if (!options || options.fraction !== "decimal") // output as ratio, like '1/3'
        return value.s * value.n + "/" + value.d;
        else // output as decimal, like '0.(3)'
        return value.toString();
    }
    if (Array.isArray(value)) return $addf7cb66573d3e4$var$formatArray(value, options);
    if ((0, $2c4f948f17aa2240$export$844ec244b1367d54)(value)) return '"' + value + '"';
    if (typeof value === "function") return value.syntax ? String(value.syntax) : "function";
    if (value && typeof value === "object") {
        if (typeof value.format === "function") return value.format(options);
        else if (value && value.toString(options) !== ({}).toString()) // this object has a non-native toString method, use that one
        return value.toString(options);
        else {
            var entries = Object.keys(value).map((key)=>{
                return '"' + key + '": ' + $addf7cb66573d3e4$export$d9468344d3651243(value[key], options);
            });
            return "{" + entries.join(", ") + "}";
        }
    }
    return String(value);
}
function $addf7cb66573d3e4$export$fac44ee5b035f737(value) {
    var text = String(value);
    var escaped = "";
    var i = 0;
    while(i < text.length){
        var c = text.charAt(i);
        if (c === "\\") {
            escaped += c;
            i++;
            c = text.charAt(i);
            if (c === "" || '"\\/bfnrtu'.indexOf(c) === -1) escaped += "\\"; // no valid escape character -> escape it
            escaped += c;
        } else if (c === '"') escaped += '\\"';
        else escaped += c;
        i++;
    }
    return '"' + escaped + '"';
}
function $addf7cb66573d3e4$export$4e7f196112fea3c5(value) {
    var text = String(value);
    text = text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return text;
}
/**
 * Recursively format an n-dimensional matrix
 * Example output: "[[1, 2], [3, 4]]"
 * @param {Array} array
 * @param {Object | number | Function} [options]  Formatting options. See
 *                                                lib/utils/number:format for a
 *                                                description of the available
 *                                                options.
 * @returns {string} str
 */ function $addf7cb66573d3e4$var$formatArray(array, options) {
    if (Array.isArray(array)) {
        var str = "[";
        var len = array.length;
        for(var i = 0; i < len; i++){
            if (i !== 0) str += ", ";
            str += $addf7cb66573d3e4$var$formatArray(array[i], options);
        }
        str += "]";
        return str;
    } else return $addf7cb66573d3e4$export$d9468344d3651243(array, options);
}
/**
 * Check whether a value looks like a Fraction (unsafe duck-type check)
 * @param {*} value
 * @return {boolean}
 */ function $addf7cb66573d3e4$var$looksLikeFraction(value) {
    return value && typeof value === "object" && typeof value.s === "number" && typeof value.n === "number" && typeof value.d === "number" || false;
}
function $addf7cb66573d3e4$export$2da9287da10b19e2(x, y) {
    // we don't want to convert numbers to string, only accept string input
    if (!(0, $2c4f948f17aa2240$export$844ec244b1367d54)(x)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(x) + ", index: 0)");
    if (!(0, $2c4f948f17aa2240$export$844ec244b1367d54)(y)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(y) + ", index: 1)");
    return x === y ? 0 : x > y ? 1 : -1;
}


/**
 * Create a range error with the message:
 *     'Dimension mismatch (<actual size> != <expected size>)'
 * @param {number | number[]} actual        The actual size
 * @param {number | number[]} expected      The expected size
 * @param {string} [relation='!=']          Optional relation between actual
 *                                          and expected size: '!=', '<', etc.
 * @extends RangeError
 */ function $99933e18a0d55444$export$ad1391ca020fdd96(actual, expected, relation) {
    if (!(this instanceof $99933e18a0d55444$export$ad1391ca020fdd96)) throw new SyntaxError("Constructor must be called with the new operator");
    this.actual = actual;
    this.expected = expected;
    this.relation = relation;
    this.message = "Dimension mismatch (" + (Array.isArray(actual) ? "[" + actual.join(", ") + "]" : actual) + " " + (this.relation || "!=") + " " + (Array.isArray(expected) ? "[" + expected.join(", ") + "]" : expected) + ")";
    this.stack = new Error().stack;
}
$99933e18a0d55444$export$ad1391ca020fdd96.prototype = new RangeError();
$99933e18a0d55444$export$ad1391ca020fdd96.prototype.constructor = RangeError;
$99933e18a0d55444$export$ad1391ca020fdd96.prototype.name = "DimensionError";
$99933e18a0d55444$export$ad1391ca020fdd96.prototype.isDimensionError = true;


/**
 * Create a range error with the message:
 *     'Index out of range (index < min)'
 *     'Index out of range (index < max)'
 *
 * @param {number} index     The actual index
 * @param {number} [min=0]   Minimum index (included)
 * @param {number} [max]     Maximum index (excluded)
 * @extends RangeError
 */ function $b954584cbe120407$export$efa5eacb1304c464(index, min, max) {
    if (!(this instanceof $b954584cbe120407$export$efa5eacb1304c464)) throw new SyntaxError("Constructor must be called with the new operator");
    this.index = index;
    if (arguments.length < 3) {
        this.min = 0;
        this.max = min;
    } else {
        this.min = min;
        this.max = max;
    }
    if (this.min !== undefined && this.index < this.min) this.message = "Index out of range (" + this.index + " < " + this.min + ")";
    else if (this.max !== undefined && this.index >= this.max) this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")";
    else this.message = "Index out of range (" + this.index + ")";
    this.stack = new Error().stack;
}
$b954584cbe120407$export$efa5eacb1304c464.prototype = new RangeError();
$b954584cbe120407$export$efa5eacb1304c464.prototype.constructor = RangeError;
$b954584cbe120407$export$efa5eacb1304c464.prototype.name = "IndexError";
$b954584cbe120407$export$efa5eacb1304c464.prototype.isIndexError = true;


function $802b18b8c920d4c6$export$51ffaee4afb683a5(x) {
    var s = [];
    while(Array.isArray(x)){
        s.push(x.length);
        x = x[0];
    }
    return s;
}
/**
 * Recursively validate whether each element in a multi dimensional array
 * has a size corresponding to the provided size array.
 * @param {Array} array    Array to be validated
 * @param {number[]} size  Array with the size of each dimension
 * @param {number} dim   Current dimension
 * @throws DimensionError
 * @private
 */ function $802b18b8c920d4c6$var$_validate(array, size, dim) {
    var i;
    var len = array.length;
    if (len !== size[dim]) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(len, size[dim]);
    if (dim < size.length - 1) {
        // recursively validate each child array
        var dimNext = dim + 1;
        for(i = 0; i < len; i++){
            var child = array[i];
            if (!Array.isArray(child)) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(size.length - 1, size.length, "<");
            $802b18b8c920d4c6$var$_validate(array[i], size, dimNext);
        }
    } else // last dimension. none of the childs may be an array
    for(i = 0; i < len; i++){
        if (Array.isArray(array[i])) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(size.length + 1, size.length, ">");
    }
}
function $802b18b8c920d4c6$export$a22775fa5e2eebd9(array, size) {
    var isScalar = size.length === 0;
    if (isScalar) {
        // scalar
        if (Array.isArray(array)) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(array.length, 0);
    } else // array
    $802b18b8c920d4c6$var$_validate(array, size, 0);
}
function $802b18b8c920d4c6$export$3cfe3fbfec03f260(index, length) {
    if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(index) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(index)) throw new TypeError("Index must be an integer (value: " + index + ")");
    if (index < 0 || typeof length === "number" && index >= length) throw new (0, $b954584cbe120407$export$efa5eacb1304c464)(index, length);
}
function $802b18b8c920d4c6$export$4380c87abf28fdf(array, size, defaultValue) {
    // TODO: add support for scalars, having size=[] ?
    // check the type of the arguments
    if (!Array.isArray(array) || !Array.isArray(size)) throw new TypeError("Array expected");
    if (size.length === 0) throw new Error("Resizing to scalar is not supported");
     // check whether size contains positive integers
    size.forEach(function(value) {
        if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(value) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
    }); // recursively resize the array
    var _defaultValue = defaultValue !== undefined ? defaultValue : 0;
    $802b18b8c920d4c6$var$_resize(array, size, 0, _defaultValue);
    return array;
}
/**
 * Recursively resize a multi dimensional array
 * @param {Array} array         Array to be resized
 * @param {number[]} size       Array with the size of each dimension
 * @param {number} dim          Current dimension
 * @param {*} [defaultValue]    Value to be filled in in new entries,
 *                              undefined by default.
 * @private
 */ function $802b18b8c920d4c6$var$_resize(array, size, dim, defaultValue) {
    var i;
    var elem;
    var oldLen = array.length;
    var newLen = size[dim];
    var minLen = Math.min(oldLen, newLen); // apply new length
    array.length = newLen;
    if (dim < size.length - 1) {
        // non-last dimension
        var dimNext = dim + 1; // resize existing child arrays
        for(i = 0; i < minLen; i++){
            // resize child array
            elem = array[i];
            if (!Array.isArray(elem)) {
                elem = [
                    elem
                ]; // add a dimension
                array[i] = elem;
            }
            $802b18b8c920d4c6$var$_resize(elem, size, dimNext, defaultValue);
        } // create new child arrays
        for(i = minLen; i < newLen; i++){
            // get child array
            elem = [];
            array[i] = elem; // resize new child array
            $802b18b8c920d4c6$var$_resize(elem, size, dimNext, defaultValue);
        }
    } else {
        // last dimension
        // remove dimensions of existing values
        for(i = 0; i < minLen; i++)while(Array.isArray(array[i]))array[i] = array[i][0];
         // fill new elements with the default value
        for(i = minLen; i < newLen; i++)array[i] = defaultValue;
    }
}
function $802b18b8c920d4c6$export$9eaad88cf88cee2b(array, sizes) {
    var flatArray = $802b18b8c920d4c6$export$bffa455ba8c619a6(array);
    var currentLength = flatArray.length;
    if (!Array.isArray(array) || !Array.isArray(sizes)) throw new TypeError("Array expected");
    if (sizes.length === 0) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(0, currentLength, "!=");
    sizes = $802b18b8c920d4c6$export$d0efc868ac2c6822(sizes, currentLength);
    var newLength = $802b18b8c920d4c6$var$product(sizes);
    if (currentLength !== newLength) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(newLength, currentLength, "!=");
    try {
        return $802b18b8c920d4c6$var$_reshape(flatArray, sizes);
    } catch (e) {
        if (e instanceof (0, $99933e18a0d55444$export$ad1391ca020fdd96)) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(newLength, currentLength, "!=");
        throw e;
    }
}
function $802b18b8c920d4c6$export$d0efc868ac2c6822(sizes, currentLength) {
    var newLength = $802b18b8c920d4c6$var$product(sizes);
    var processedSizes = sizes.slice();
    var WILDCARD = -1;
    var wildCardIndex = sizes.indexOf(WILDCARD);
    var isMoreThanOneWildcard = sizes.indexOf(WILDCARD, wildCardIndex + 1) >= 0;
    if (isMoreThanOneWildcard) throw new Error("More than one wildcard in sizes");
    var hasWildcard = wildCardIndex >= 0;
    var canReplaceWildcard = currentLength % newLength === 0;
    if (hasWildcard) {
        if (canReplaceWildcard) processedSizes[wildCardIndex] = -currentLength / newLength;
        else throw new Error("Could not replace wildcard, since " + currentLength + " is no multiple of " + -newLength);
    }
    return processedSizes;
}
/**
 * Computes the product of all array elements.
 * @param {Array<number>} array Array of factors
 * @returns {number}            Product of all elements
 */ function $802b18b8c920d4c6$var$product(array) {
    return array.reduce((prev, curr)=>prev * curr, 1);
}
/**
 * Iteratively re-shape a multi dimensional array to fit the specified dimensions
 * @param {Array} array           Array to be reshaped
 * @param {Array.<number>} sizes  List of sizes for each dimension
 * @returns {Array}               Array whose data has been formatted to fit the
 *                                specified dimensions
 */ function $802b18b8c920d4c6$var$_reshape(array, sizes) {
    // testing if there are enough elements for the requested shape
    var tmpArray = array;
    var tmpArray2; // for each dimensions starting by the last one and ignoring the first one
    for(var sizeIndex = sizes.length - 1; sizeIndex > 0; sizeIndex--){
        var size = sizes[sizeIndex];
        tmpArray2 = []; // aggregate the elements of the current tmpArray in elements of the requested size
        var length = tmpArray.length / size;
        for(var i = 0; i < length; i++)tmpArray2.push(tmpArray.slice(i * size, (i + 1) * size));
         // set it as the new tmpArray for the next loop turn or for return
        tmpArray = tmpArray2;
    }
    return tmpArray;
}
function $802b18b8c920d4c6$export$889c931173b77c2f(array, size) {
    var s = size || $802b18b8c920d4c6$export$51ffaee4afb683a5(array); // squeeze outer dimensions
    while(Array.isArray(array) && array.length === 1){
        array = array[0];
        s.shift();
    } // find the first dimension to be squeezed
    var dims = s.length;
    while(s[dims - 1] === 1)dims--;
     // squeeze inner dimensions
    if (dims < s.length) {
        array = $802b18b8c920d4c6$var$_squeeze(array, dims, 0);
        s.length = dims;
    }
    return array;
}
/**
 * Recursively squeeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $802b18b8c920d4c6$var$_squeeze(array, dims, dim) {
    var i, ii;
    if (dim < dims) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $802b18b8c920d4c6$var$_squeeze(array[i], dims, next);
    } else while(Array.isArray(array))array = array[0];
    return array;
}
function $802b18b8c920d4c6$export$5a07c5202d40a604(array, dims, outer, size) {
    var s = size || $802b18b8c920d4c6$export$51ffaee4afb683a5(array); // unsqueeze outer dimensions
    if (outer) for(var i = 0; i < outer; i++){
        array = [
            array
        ];
        s.unshift(1);
    }
     // unsqueeze inner dimensions
    array = $802b18b8c920d4c6$var$_unsqueeze(array, dims, 0);
    while(s.length < dims)s.push(1);
    return array;
}
/**
 * Recursively unsqueeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $802b18b8c920d4c6$var$_unsqueeze(array, dims, dim) {
    var i, ii;
    if (Array.isArray(array)) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $802b18b8c920d4c6$var$_unsqueeze(array[i], dims, next);
    } else for(var d = dim; d < dims; d++)array = [
        array
    ];
    return array;
}
function $802b18b8c920d4c6$export$bffa455ba8c619a6(array) {
    if (!Array.isArray(array)) // if not an array, return as is
    return array;
    var flat = [];
    array.forEach(function callback(value) {
        if (Array.isArray(value)) value.forEach(callback); // traverse through sub-arrays recursively
        else flat.push(value);
    });
    return flat;
}
function $802b18b8c920d4c6$export$871de8747c9eaa88(array, callback) {
    return Array.prototype.map.call(array, callback);
}
function $802b18b8c920d4c6$export$4b80e395e36b5a56(array, callback) {
    Array.prototype.forEach.call(array, callback);
}
function $802b18b8c920d4c6$export$3dea766d36a8935f(array, callback) {
    if ($802b18b8c920d4c6$export$51ffaee4afb683a5(array).length !== 1) throw new Error("Only one dimensional matrices supported");
    return Array.prototype.filter.call(array, callback);
}
function $802b18b8c920d4c6$export$322859471e81229d(array, regexp) {
    if ($802b18b8c920d4c6$export$51ffaee4afb683a5(array).length !== 1) throw new Error("Only one dimensional matrices supported");
    return Array.prototype.filter.call(array, (entry)=>regexp.test(entry));
}
function $802b18b8c920d4c6$export$f7e2c8231c57a8bd(array, separator) {
    return Array.prototype.join.call(array, separator);
}
function $802b18b8c920d4c6$export$65e5b62a4c490288(a) {
    if (!Array.isArray(a)) throw new TypeError("Array input expected");
    if (a.length === 0) return a;
    var b = [];
    var count = 0;
    b[0] = {
        value: a[0],
        identifier: 0
    };
    for(var i = 1; i < a.length; i++){
        if (a[i] === a[i - 1]) count++;
        else count = 0;
        b.push({
            value: a[i],
            identifier: count
        });
    }
    return b;
}
function $802b18b8c920d4c6$export$d57ad8b840ad6a01(a) {
    if (!Array.isArray(a)) throw new TypeError("Array input expected");
    if (a.length === 0) return a;
    var b = [];
    for(var i = 0; i < a.length; i++)b.push(a[i].value);
    return b;
}
function $802b18b8c920d4c6$export$d31e00bf4359ea8b(array, typeOf) {
    var type; // to hold type info
    var length = 0; // to hold length value to ensure it has consistent sizes
    for(var i = 0; i < array.length; i++){
        var item = array[i];
        var isArray = Array.isArray(item); // Saving the target matrix row size
        if (i === 0 && isArray) length = item.length;
         // If the current item is an array but the length does not equal the targetVectorSize
        if (isArray && item.length !== length) return undefined;
        var itemType = isArray ? $802b18b8c920d4c6$export$d31e00bf4359ea8b(item, typeOf) // recurse into a nested array
         : typeOf(item);
        if (type === undefined) type = itemType; // first item
        else if (type !== itemType) return "mixed";
    }
    return type;
}
function $802b18b8c920d4c6$export$4c7897fafd92b108(array) {
    return array[array.length - 1];
}
function $802b18b8c920d4c6$export$59ff82fc918bd7e3(array) {
    return array.slice(0, array.length - 1);
}
function $802b18b8c920d4c6$export$2344b14b097df817(array, item) {
    return array.indexOf(item) !== -1;
}



function $a671619231063c2b$export$e9008f2713103c6c(name, dependencies, create, meta) {
    function assertAndCreate(scope) {
        // we only pass the requested dependencies to the factory function
        // to prevent functions to rely on dependencies that are not explicitly
        // requested.
        var deps = (0, $33619877a15996ac$export$8cea971c64639ea7)(scope, dependencies.map($a671619231063c2b$export$2f4d32a1468e229c));
        $a671619231063c2b$export$19a2c26dad95d6e7(name, dependencies, scope);
        return create(deps);
    }
    assertAndCreate.isFactory = true;
    assertAndCreate.fn = name;
    assertAndCreate.dependencies = dependencies.slice().sort();
    if (meta) assertAndCreate.meta = meta;
    return assertAndCreate;
}
function $a671619231063c2b$export$883f1d394ed355c(factories) {
    var factoriesByName = {};
    factories.forEach((factory)=>{
        factoriesByName[factory.fn] = factory;
    });
    function containsDependency(factory, dependency) {
        // TODO: detect circular references
        if ($a671619231063c2b$export$34763cfbed1075c2(factory)) {
            if ((0, $802b18b8c920d4c6$export$2344b14b097df817)(factory.dependencies, dependency.fn || dependency.name)) return true;
            if (factory.dependencies.some((d)=>containsDependency(factoriesByName[d], dependency))) return true;
        }
        return false;
    }
    var sorted = [];
    function addFactory(factory) {
        var index = 0;
        while(index < sorted.length && !containsDependency(sorted[index], factory))index++;
        sorted.splice(index, 0, factory);
    } // sort regular factory functions
    factories.filter($a671619231063c2b$export$34763cfbed1075c2).forEach(addFactory); // sort legacy factory functions AFTER the regular factory functions
    factories.filter((factory)=>!$a671619231063c2b$export$34763cfbed1075c2(factory)).forEach(addFactory);
    return sorted;
} // TODO: comment or cleanup if unused in the end
function $a671619231063c2b$export$185802fd694ee1f5(factories) {
    var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $a671619231063c2b$export$883f1d394ed355c(factories).forEach((factory)=>factory(scope));
    return scope;
}
function $a671619231063c2b$export$34763cfbed1075c2(obj) {
    return typeof obj === "function" && typeof obj.fn === "string" && Array.isArray(obj.dependencies);
}
function $a671619231063c2b$export$19a2c26dad95d6e7(name, dependencies, scope) {
    var allDefined = dependencies.filter((dependency)=>!$a671619231063c2b$export$1399ac7f45b04b5(dependency)) // filter optionals
    .every((dependency)=>scope[dependency] !== undefined);
    if (!allDefined) {
        var missingDependencies = dependencies.filter((dependency)=>scope[dependency] === undefined); // TODO: create a custom error class for this, a MathjsError or something like that
        throw new Error('Cannot create function "'.concat(name, '", ') + "some dependencies are missing: ".concat(missingDependencies.map((d)=>'"'.concat(d, '"')).join(", "), "."));
    }
}
function $a671619231063c2b$export$1399ac7f45b04b5(dependency) {
    return dependency && dependency[0] === "?";
}
function $a671619231063c2b$export$2f4d32a1468e229c(dependency) {
    return dependency && dependency[0] === "?" ? dependency.slice(1) : dependency;
}





/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $63e2b34a916dc57b$export$424b8b2ab9af2944(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
}


function $cd13353fc76500f7$export$4d8f6a27e2f5bcb2(array) {
    for(var i = 0; i < array.length; i++){
        if ((0, $2c4f948f17aa2240$export$cea7aa84e978eba5)(array[i])) return true;
    }
    return false;
}
function $cd13353fc76500f7$export$519ada94592b97fc(array, callback) {
    if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(array)) array = array.valueOf();
    for(var i = 0, ii = array.length; i < ii; i++){
        var value = array[i];
        if (Array.isArray(value)) $cd13353fc76500f7$export$519ada94592b97fc(value, callback);
        else callback(value);
    }
}
function $cd13353fc76500f7$export$ce7eaaed37329a1b(array, callback, skipZeros) {
    if (array && typeof array.map === "function") // TODO: replace array.map with a for loop to improve performance
    return array.map(function(x) {
        return $cd13353fc76500f7$export$ce7eaaed37329a1b(x, callback, skipZeros);
    });
    else return callback(array);
}
function $cd13353fc76500f7$export$533b26079ad0b4b(mat, dim, callback) {
    var size = Array.isArray(mat) ? (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(mat) : mat.size();
    if (dim < 0 || dim >= size.length) // TODO: would be more clear when throwing a DimensionError here
    throw new (0, $b954584cbe120407$export$efa5eacb1304c464)(dim, size.length);
    if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(mat)) return mat.create($cd13353fc76500f7$var$_reduce(mat.valueOf(), dim, callback));
    else return $cd13353fc76500f7$var$_reduce(mat, dim, callback);
}
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $cd13353fc76500f7$var$_reduce(mat, dim, callback) {
    var i, ret, val, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) {
            val = mat[0];
            for(i = 1; i < mat.length; i++)val = callback(val, mat[i]);
            return val;
        } else {
            tran = (0, $63e2b34a916dc57b$export$424b8b2ab9af2944)(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $cd13353fc76500f7$var$_reduce(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $cd13353fc76500f7$var$_reduce(mat[i], dim - 1, callback);
        return ret;
    }
} // TODO: document function scatter
function $cd13353fc76500f7$export$c97954fff4307550(a, j, w, x, u, mark, cindex, f, inverse, update, value) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr; // vars
    var k, k0, k1, i; // check we need to process values (pattern matrix)
    if (x) // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k]; // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark; // add i to pattern of C
            cindex.push(i); // x(i) = A, check we need to call function this time
            if (update) {
                // copy value to workspace calling callback function
                x[i] = inverse ? f(avalues[k], value) : f(value, avalues[k]); // function was called on current row
                u[i] = mark;
            } else // copy value to workspace
            x[i] = avalues[k];
        } else {
            // i exists in C already
            x[i] = inverse ? f(avalues[k], x[i]) : f(x[i], avalues[k]); // function was called on current row
            u[i] = mark;
        }
    }
    else // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k]; // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark; // add i to pattern of C
            cindex.push(i);
        } else // indicate function was called on current row
        u[i] = mark;
    }
}



var $08ae6b2eb4bd0049$var$n1 = "number";
var $08ae6b2eb4bd0049$var$n2 = "number, number";
function $08ae6b2eb4bd0049$export$59270f717756a93a(a) {
    return Math.abs(a);
}
$08ae6b2eb4bd0049$export$59270f717756a93a.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$d6751d2a3b6da12a(a, b) {
    return a + b;
}
$08ae6b2eb4bd0049$export$d6751d2a3b6da12a.signature = $08ae6b2eb4bd0049$var$n2;
function $08ae6b2eb4bd0049$export$fd8ce9cfca47ace5(a, b) {
    return a - b;
}
$08ae6b2eb4bd0049$export$fd8ce9cfca47ace5.signature = $08ae6b2eb4bd0049$var$n2;
function $08ae6b2eb4bd0049$export$4ad41ac849e391ec(a, b) {
    return a * b;
}
$08ae6b2eb4bd0049$export$4ad41ac849e391ec.signature = $08ae6b2eb4bd0049$var$n2;
function $08ae6b2eb4bd0049$export$58c48a269ab4a155(a, b) {
    return a / b;
}
$08ae6b2eb4bd0049$export$58c48a269ab4a155.signature = $08ae6b2eb4bd0049$var$n2;
function $08ae6b2eb4bd0049$export$339666dc881be46b(x) {
    return -x;
}
$08ae6b2eb4bd0049$export$339666dc881be46b.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$da5b80d388a295fb(x) {
    return x;
}
$08ae6b2eb4bd0049$export$da5b80d388a295fb.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$95c2aecb85f70726(x) {
    return (0, $a03283b133c3c55b$export$841fc4d5a1480b85)(x);
}
$08ae6b2eb4bd0049$export$95c2aecb85f70726.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$9505f0b39acd04c(x) {
    return x * x * x;
}
$08ae6b2eb4bd0049$export$9505f0b39acd04c.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$a33b288b35672fe5(x) {
    return Math.exp(x);
}
$08ae6b2eb4bd0049$export$a33b288b35672fe5.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$756d0c010cecc6c3(x) {
    return (0, $a03283b133c3c55b$export$b6c0a80d46d3391d)(x);
}
$08ae6b2eb4bd0049$export$756d0c010cecc6c3.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$3a8d786b08b3a70c(a, b) {
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(a) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(b)) throw new Error("Parameters in function gcd must be integer numbers");
     // https://en.wikipedia.org/wiki/Euclidean_algorithm
    var r;
    while(b !== 0){
        r = a % b;
        a = b;
        b = r;
    }
    return a < 0 ? -a : a;
}
$08ae6b2eb4bd0049$export$3a8d786b08b3a70c.signature = $08ae6b2eb4bd0049$var$n2;
function $08ae6b2eb4bd0049$export$b55f99ec1f4c5649(a, b) {
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(a) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(b)) throw new Error("Parameters in function lcm must be integer numbers");
    if (a === 0 || b === 0) return 0;
     // https://en.wikipedia.org/wiki/Euclidean_algorithm
    // evaluate lcm here inline to reduce overhead
    var t;
    var prod = a * b;
    while(b !== 0){
        t = b;
        b = a % t;
        a = t;
    }
    return Math.abs(prod / a);
}
$08ae6b2eb4bd0049$export$b55f99ec1f4c5649.signature = $08ae6b2eb4bd0049$var$n2;
function $08ae6b2eb4bd0049$export$4df0e8fcdd5c0927(x, y) {
    if (y) return Math.log(x) / Math.log(y);
    return Math.log(x);
}
function $08ae6b2eb4bd0049$export$e3f8d49574d29dff(x) {
    return (0, $a03283b133c3c55b$export$75e08744a3ff8516)(x);
}
$08ae6b2eb4bd0049$export$e3f8d49574d29dff.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$f9bc93220cfa3c59(x) {
    return (0, $a03283b133c3c55b$export$b9fae0bba9d9094d)(x);
}
$08ae6b2eb4bd0049$export$f9bc93220cfa3c59.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$ae1f56e105ebe4a1(x) {
    return (0, $a03283b133c3c55b$export$144dcf16adfb9698)(x);
}
$08ae6b2eb4bd0049$export$ae1f56e105ebe4a1.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$64b58c5b0372ae95(x, y) {
    if (y > 0) // We don't use JavaScript's % operator here as this doesn't work
    // correctly for x < 0 and x === 0
    // see https://en.wikipedia.org/wiki/Modulo_operation
    return x - y * Math.floor(x / y);
    else if (y === 0) return x;
    else // y < 0
    // TODO: implement mod for a negative divisor
    throw new Error("Cannot calculate mod for a negative divisor");
}
$08ae6b2eb4bd0049$export$64b58c5b0372ae95.signature = $08ae6b2eb4bd0049$var$n2;
function $08ae6b2eb4bd0049$export$9f26f16bd796a7b3(a) {
    var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var inv = root < 0;
    if (inv) root = -root;
    if (root === 0) throw new Error("Root must be non-zero");
    if (a < 0 && Math.abs(root) % 2 !== 1) throw new Error("Root must be odd when a is negative.");
     // edge cases zero and infinity
    if (a === 0) return inv ? Infinity : 0;
    if (!isFinite(a)) return inv ? 0 : a;
    var x = Math.pow(Math.abs(a), 1 / root); // If a < 0, we require that root is an odd integer,
    // so (-1) ^ (1/root) = -1
    x = a < 0 ? -x : x;
    return inv ? 1 / x : x; // Very nice algorithm, but fails with nthRoot(-2, 3).
// Newton's method has some well-known problems at times:
// https://en.wikipedia.org/wiki/Newton%27s_method#Failure_analysis
/*
  let x = 1 // Initial guess
  let xPrev = 1
  let i = 0
  const iMax = 10000
  do {
    const delta = (a / Math.pow(x, root - 1) - x) / root
    xPrev = x
    x = x + delta
    i++
  }
  while (xPrev !== x && i < iMax)
   if (xPrev !== x) {
    throw new Error('Function nthRoot failed to converge')
  }
   return inv ? 1 / x : x
  */ }
function $08ae6b2eb4bd0049$export$af3d9fe43be78285(x) {
    return (0, $a03283b133c3c55b$export$c5552dfdbc7cec71)(x);
}
$08ae6b2eb4bd0049$export$af3d9fe43be78285.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$aacd0ed14e49886d(x) {
    return Math.sqrt(x);
}
$08ae6b2eb4bd0049$export$aacd0ed14e49886d.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$c4094a156ed9ab35(x) {
    return x * x;
}
$08ae6b2eb4bd0049$export$c4094a156ed9ab35.signature = $08ae6b2eb4bd0049$var$n1;
function $08ae6b2eb4bd0049$export$8cb756a23a623229(a, b) {
    // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
    var t; // used to swap two variables
    var q; // quotient
    var r; // remainder
    var x = 0;
    var lastx = 1;
    var y = 1;
    var lasty = 0;
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(a) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(b)) throw new Error("Parameters in function xgcd must be integer numbers");
    while(b){
        q = Math.floor(a / b);
        r = a - q * b;
        t = x;
        x = lastx - q * x;
        lastx = t;
        t = y;
        y = lasty - q * y;
        lasty = t;
        a = b;
        b = r;
    }
    var res;
    if (a < 0) res = [
        -a,
        -lastx,
        -lasty
    ];
    else res = [
        a,
        a ? lastx : 0,
        lasty
    ];
    return res;
}
$08ae6b2eb4bd0049$export$8cb756a23a623229.signature = $08ae6b2eb4bd0049$var$n2;
function $08ae6b2eb4bd0049$export$3f512e7fd4999e01(x, y) {
    // x^Infinity === 0 if -1 < x < 1
    // A real number 0 is returned instead of complex(0)
    if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
    return Math.pow(x, y);
}
$08ae6b2eb4bd0049$export$3f512e7fd4999e01.signature = $08ae6b2eb4bd0049$var$n2;
function $08ae6b2eb4bd0049$export$a3992db8dd0fd9e6(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(decimals) || decimals < 0 || decimals > 15) throw new Error("Number of decimals in function round must be an integer from 0 to 15 inclusive");
    return parseFloat((0, $a03283b133c3c55b$export$a81f732198733497)(value, decimals));
}
function $08ae6b2eb4bd0049$export$d78ecacee56245ec(x) {
    return Math.abs(x);
}
$08ae6b2eb4bd0049$export$d78ecacee56245ec.signature = $08ae6b2eb4bd0049$var$n1;


var $29a83c248ac78edd$var$name = "abs";
var $29a83c248ac78edd$var$dependencies = [
    "typed"
];
var $29a83c248ac78edd$export$dd8a9b3843a4df95 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($29a83c248ac78edd$var$name, $29a83c248ac78edd$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the absolute value of a number. For matrices, the function is
   * evaluated element wise.
   *
   * Syntax:
   *
   *    math.abs(x)
   *
   * Examples:
   *
   *    math.abs(3.5)                // returns number 3.5
   *    math.abs(-4.2)               // returns number 4.2
   *
   *    math.abs([3, -5, -1, 0, 2])  // returns Array [3, 5, 1, 0, 2]
   *
   * See also:
   *
   *    sign
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            A number or matrix for which to get the absolute value
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
   *            Absolute value of `x`
   */ return typed($29a83c248ac78edd$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$59270f717756a93a),
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            return x.abs();
        },
        Fraction: function Fraction(x) {
            return x.abs();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since abs(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        },
        Unit: function Unit(x) {
            return x.abs();
        }
    });
});



var $a70f9f93e05a2084$var$name = "acos";
var $a70f9f93e05a2084$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $a70f9f93e05a2084$export$33da46c5ece67581 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a70f9f93e05a2084$var$name, $a70f9f93e05a2084$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the inverse cosine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acos(x)
   *
   * Examples:
   *
   *    math.acos(0.5)           // returns number 1.0471975511965979
   *    math.acos(math.cos(1.5)) // returns number 1.5
   *
   *    math.acos(2)             // returns Complex 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    cos, atan, asin
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc cosine of x
   */ return typed($a70f9f93e05a2084$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.acos(x);
            else return new Complex(x, 0).acos();
        },
        Complex: function Complex(x) {
            return x.acos();
        },
        BigNumber: function BigNumber(x) {
            return x.acos();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $b54e9ade204c059d$var$n1 = "number";
var $b54e9ade204c059d$var$n2 = "number, number";
function $b54e9ade204c059d$export$99a14685a3a2b607(x) {
    return Math.acos(x);
}
$b54e9ade204c059d$export$99a14685a3a2b607.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$84088556f7d2d0be(x) {
    return (0, $a03283b133c3c55b$export$b26caf0f29211d08)(x);
}
$b54e9ade204c059d$export$84088556f7d2d0be.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$ba80ccbf024897ef(x) {
    return Math.atan(1 / x);
}
$b54e9ade204c059d$export$ba80ccbf024897ef.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$e2be1aa5d5a3f81(x) {
    return isFinite(x) ? (Math.log((x + 1) / x) + Math.log(x / (x - 1))) / 2 : 0;
}
$b54e9ade204c059d$export$e2be1aa5d5a3f81.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$e3b67a6e3df3fd81(x) {
    return Math.asin(1 / x);
}
$b54e9ade204c059d$export$e3b67a6e3df3fd81.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$51cd224337b2c783(x) {
    var xInv = 1 / x;
    return Math.log(xInv + Math.sqrt(xInv * xInv + 1));
}
$b54e9ade204c059d$export$51cd224337b2c783.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$5ec3930177455ade(x) {
    return Math.acos(1 / x);
}
$b54e9ade204c059d$export$5ec3930177455ade.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$cf144300ea173362(x) {
    var xInv = 1 / x;
    var ret = Math.sqrt(xInv * xInv - 1);
    return Math.log(ret + xInv);
}
$b54e9ade204c059d$export$cf144300ea173362.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$444ef2855488a2d5(x) {
    return Math.asin(x);
}
$b54e9ade204c059d$export$444ef2855488a2d5.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$3a027485d3336d8d(x) {
    return (0, $a03283b133c3c55b$export$839d8a01b6af4fc0)(x);
}
$b54e9ade204c059d$export$3a027485d3336d8d.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$c38dcb11df4699c0(x) {
    return Math.atan(x);
}
$b54e9ade204c059d$export$c38dcb11df4699c0.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$a97666a135b540f9(y, x) {
    return Math.atan2(y, x);
}
$b54e9ade204c059d$export$a97666a135b540f9.signature = $b54e9ade204c059d$var$n2;
function $b54e9ade204c059d$export$44a1f653c6513db8(x) {
    return (0, $a03283b133c3c55b$export$21ea955025ceb08b)(x);
}
$b54e9ade204c059d$export$44a1f653c6513db8.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$8d04496be3e647d4(x) {
    return Math.cos(x);
}
$b54e9ade204c059d$export$8d04496be3e647d4.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$7cf8db0cff734545(x) {
    return (0, $a03283b133c3c55b$export$2e2fd1ad24e4d350)(x);
}
$b54e9ade204c059d$export$7cf8db0cff734545.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$515b39f7fd07e09f(x) {
    return 1 / Math.tan(x);
}
$b54e9ade204c059d$export$515b39f7fd07e09f.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$925affe88b2512fc(x) {
    var e = Math.exp(2 * x);
    return (e + 1) / (e - 1);
}
$b54e9ade204c059d$export$925affe88b2512fc.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$5a8409ad16e318b2(x) {
    return 1 / Math.sin(x);
}
$b54e9ade204c059d$export$5a8409ad16e318b2.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$143835b5c1db9790(x) {
    // consider values close to zero (+/-)
    if (x === 0) return Number.POSITIVE_INFINITY;
    else return Math.abs(2 / (Math.exp(x) - Math.exp(-x))) * (0, $a03283b133c3c55b$export$c5552dfdbc7cec71)(x);
}
$b54e9ade204c059d$export$143835b5c1db9790.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$ee1efc70bd8a6d93(x) {
    return 1 / Math.cos(x);
}
$b54e9ade204c059d$export$ee1efc70bd8a6d93.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$b83345d70fe4a871(x) {
    return 2 / (Math.exp(x) + Math.exp(-x));
}
$b54e9ade204c059d$export$b83345d70fe4a871.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$b6e96f13f41c8816(x) {
    return Math.sin(x);
}
$b54e9ade204c059d$export$b6e96f13f41c8816.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$89648c4ce0d79e70(x) {
    return (0, $a03283b133c3c55b$export$545004b505d7c555)(x);
}
$b54e9ade204c059d$export$89648c4ce0d79e70.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$ecbd7b3271ebce16(x) {
    return Math.tan(x);
}
$b54e9ade204c059d$export$ecbd7b3271ebce16.signature = $b54e9ade204c059d$var$n1;
function $b54e9ade204c059d$export$70e2e2cc9c2555e4(x) {
    return (0, $a03283b133c3c55b$export$7128670e45beef9a)(x);
}
$b54e9ade204c059d$export$70e2e2cc9c2555e4.signature = $b54e9ade204c059d$var$n1;


var $79a1e41cdfad09cd$var$name = "acosh";
var $79a1e41cdfad09cd$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $79a1e41cdfad09cd$export$c634796792055579 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($79a1e41cdfad09cd$var$name, $79a1e41cdfad09cd$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the hyperbolic arccos of a value,
   * defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acosh(x)
   *
   * Examples:
   *
   *    math.acosh(1.5)       // returns 0.9624236501192069
   *
   * See also:
   *
   *    cosh, asinh, atanh
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccosine of x
   */ return typed($79a1e41cdfad09cd$var$name, {
        number: function number(x) {
            if (x >= 1 || config.predictable) return (0, $b54e9ade204c059d$export$84088556f7d2d0be)(x);
            if (x <= -1) return new Complex(Math.log(Math.sqrt(x * x - 1) - x), Math.PI);
            return new Complex(x, 0).acosh();
        },
        Complex: function Complex(x) {
            return x.acosh();
        },
        BigNumber: function BigNumber(x) {
            return x.acosh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $9af91d7937791a4a$var$name = "acot";
var $9af91d7937791a4a$var$dependencies = [
    "typed",
    "BigNumber"
];
var $9af91d7937791a4a$export$8a6845771325148e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($9af91d7937791a4a$var$name, $9af91d7937791a4a$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse cotangent of a value, defined as `acot(x) = atan(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acot(x)
   *
   * Examples:
   *
   *    math.acot(0.5)           // returns number 0.4636476090008061
   *    math.acot(math.cot(1.5)) // returns number 1.5
   *
   *    math.acot(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    cot, atan
   *
   * @param {number | Complex | Array | Matrix} x   Function input
   * @return {number | Complex | Array | Matrix} The arc cotangent of x
   */ return typed($9af91d7937791a4a$var$name, {
        number: (0, $b54e9ade204c059d$export$ba80ccbf024897ef),
        Complex: function Complex(x) {
            return x.acot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atan();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $eebe0a93cbf83e73$var$name = "acoth";
var $eebe0a93cbf83e73$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $eebe0a93cbf83e73$export$67e40c7fd8f5703a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($eebe0a93cbf83e73$var$name, $eebe0a93cbf83e73$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arccotangent of a value,
   * defined as `acoth(x) = atanh(1/x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acoth(x)
   *
   * Examples:
   *
   *    math.acoth(0.5)       // returns 0.8047189562170503
   *
   * See also:
   *
   *    acsch, asech
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccotangent of x
   */ return typed($eebe0a93cbf83e73$var$name, {
        number: function number(x) {
            if (x >= 1 || x <= -1 || config.predictable) return (0, $b54e9ade204c059d$export$e2be1aa5d5a3f81)(x);
            return new Complex(x, 0).acoth();
        },
        Complex: function Complex(x) {
            return x.acoth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atanh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $079fcfb5c717dbe5$var$name = "acsc";
var $079fcfb5c717dbe5$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $079fcfb5c717dbe5$export$95580581b134a5bd = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($079fcfb5c717dbe5$var$name, $079fcfb5c717dbe5$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse cosecant of a value, defined as `acsc(x) = asin(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acsc(x)
   *
   * Examples:
   *
   *    math.acsc(0.5)           // returns number 0.5235987755982989
   *    math.acsc(math.csc(1.5)) // returns number ~1.5
   *
   *    math.acsc(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    csc, asin, asec
   *
   * @param {number | Complex | Array | Matrix} x   Function input
   * @return {number | Complex | Array | Matrix} The arc cosecant of x
   */ return typed($079fcfb5c717dbe5$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $b54e9ade204c059d$export$e3b67a6e3df3fd81)(x);
            return new Complex(x, 0).acsc();
        },
        Complex: function Complex(x) {
            return x.acsc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asin();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $57ab0d336c2aa775$var$name = "acsch";
var $57ab0d336c2aa775$var$dependencies = [
    "typed",
    "BigNumber"
];
var $57ab0d336c2aa775$export$d6534043a40dc59 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($57ab0d336c2aa775$var$name, $57ab0d336c2aa775$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arccosecant of a value,
   * defined as `acsch(x) = asinh(1/x) = ln(1/x + sqrt(1/x^2 + 1))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acsch(x)
   *
   * Examples:
   *
   *    math.acsch(0.5)       // returns 1.4436354751788103
   *
   * See also:
   *
   *    asech, acoth
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccosecant of x
   */ return typed($57ab0d336c2aa775$var$name, {
        number: (0, $b54e9ade204c059d$export$51cd224337b2c783),
        Complex: function Complex(x) {
            return x.acsch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asinh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});





var $3feaf9e0b000398a$var$name = "algorithm01";
var $3feaf9e0b000398a$var$dependencies = [
    "typed"
];
var $3feaf9e0b000398a$export$5e6d55d37a917802 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($3feaf9e0b000398a$var$name, $3feaf9e0b000398a$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  Dij          ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm1(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // process data types
        var dt = typeof adt === "string" && adt === bdt ? adt : undefined; // callback function
        var cf = dt ? typed.find(callback, [
            dt,
            dt
        ]) : callback; // vars
        var i, j; // result (DenseMatrix)
        var cdata = []; // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
         // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns in b
        for(j = 0; j < columns; j++){
            // column mark
            var mark = j + 1; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // mark i as updated
                w[i] = mark;
            } // loop rows
            for(i = 0; i < rows; i++)// check row is in workspace
            if (w[i] === mark) // c[i][j] was already calculated
            cdata[i][j] = x[i];
            else // item does not exist in S
            cdata[i][j] = adata[i][j];
        } // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});




var $fd20a4b8c10d9754$var$name = "algorithm04";
var $fd20a4b8c10d9754$var$dependencies = [
    "typed",
    "equalScalar"
];
var $fd20a4b8c10d9754$export$898ea3bef50d41b7 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($fd20a4b8c10d9754$var$name, $fd20a4b8c10d9754$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
   *          └  B(i,j)       ; B(i,j) !== 0
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm04(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspace
        var xa = avalues && bvalues ? [] : undefined;
        var xb = avalues && bvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // vars
        var i, j, k, k0, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // update c
                cindex.push(i); // update workspace
                wa[i] = mark; // check we need to process values
                if (xa) xa[i] = avalues[k];
            } // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // check row exists in A
                if (wa[i] === mark) // update record in xa @ i
                {
                    if (xa) {
                        // invoke callback
                        var v = cf(xa[i], bvalues[k]); // check for zero
                        if (!eq(v, zero)) // update workspace
                        xa[i] = v;
                        else // remove mark (index will be removed later)
                        wa[i] = null;
                    }
                } else {
                    // update c
                    cindex.push(i); // update workspace
                    wb[i] = mark; // check we need to process values
                    if (xb) xb[i] = bvalues[k];
                }
            } // check we need to process values (non pattern matrix)
            if (xa && xb) {
                // initialize first index in j
                k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k]; // check workspace has value @ i
                    if (wa[i] === mark) {
                        // push value (Aij != 0 || (Aij != 0 && Bij != 0))
                        cvalues[k] = xa[i]; // increment pointer
                        k++;
                    } else if (wb[i] === mark) {
                        // push value (bij != 0)
                        cvalues[k] = xb[i]; // increment pointer
                        k++;
                    } else // remove index @ k
                    cindex.splice(k, 1);
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});



var $e9da21a7968d7093$var$name = "algorithm10";
var $e9da21a7968d7093$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $e9da21a7968d7093$export$72a88f2eee9ec1ed = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e9da21a7968d7093$var$name, $e9da21a7968d7093$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  b          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm10(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cdata = []; // workspaces
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k]; // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            } // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                 // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = b;
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});




var $2926213e02b15f73$var$name = "algorithm13";
var $2926213e02b15f73$var$dependencies = [
    "typed"
];
var $2926213e02b15f73$export$fa05124e71a8ffb3 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($2926213e02b15f73$var$name, $2926213e02b15f73$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, Bij..z).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, Bij..z)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Matrix}   b                 The DenseMatrix instance (B)
   * @param {Function} callback          The f(Aij..z,Bij..z) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97658658
   */ return function algorithm13(a, b, callback) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b arrays
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // c arrays
        var csize = []; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // validate each one of the dimension sizes
        for(var s = 0; s < asize.length; s++){
            // must match
            if (asize[s] !== bsize[s]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
             // update dimension in c
            csize[s] = asize[s];
        } // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // populate cdata, iterate through dimensions
        var cdata = csize.length > 0 ? _iterate(cf, 0, csize, csize[0], adata, bdata) : []; // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: csize,
            datatype: dt
        });
    }; // recursive function
    function _iterate(f, level, s, n, av, bv) {
        // initialize array for this level
        var cv = []; // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = f(av[i], bv[i]);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv[j]);
        return cv;
    }
});




var $d667d3eb521eddec$var$name = "algorithm14";
var $d667d3eb521eddec$var$dependencies = [
    "typed"
];
var $d667d3eb521eddec$export$e5afe3bc814ef550 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d667d3eb521eddec$var$name, $d667d3eb521eddec$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, b).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, b)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij..z,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Aij..z)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97659042
   */ return function algorithm14(a, b, callback, inverse) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // populate cdata, iterate through dimensions
        var cdata = asize.length > 0 ? _iterate(cf, 0, asize, asize[0], adata, b, inverse) : []; // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: (0, $33619877a15996ac$export$9cd59f9826255e47)(asize),
            datatype: dt
        });
    }; // recursive function
    function _iterate(f, level, s, n, av, bv, inverse) {
        // initialize array for this level
        var cv = []; // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = inverse ? f(bv, av[i]) : f(av[i], bv);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv, inverse);
        return cv;
    }
});


var $165750d8541756e9$var$name = "add";
var $165750d8541756e9$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "equalScalar",
    "DenseMatrix",
    "SparseMatrix"
];
var $165750d8541756e9$export$c6b51545da64d82f = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($165750d8541756e9$var$name, $165750d8541756e9$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    var algorithm01 = (0, $3feaf9e0b000398a$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm04 = (0, $fd20a4b8c10d9754$export$898ea3bef50d41b7)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $e9da21a7968d7093$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Add two or more values, `x + y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.add(x, y)
   *    math.add(x, y, z, ...)
   *
   * Examples:
   *
   *    math.add(2, 3)               // returns number 5
   *    math.add(2, 3, 4)            // returns number 9
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(-4, 1)
   *    math.add(a, b)               // returns Complex -2 + 4i
   *
   *    math.add([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   *    const c = math.unit('5 cm')
   *    const d = math.unit('2.1 mm')
   *    math.add(c, d)               // returns Unit 52.1 mm
   *
   *    math.add("2.3", "4")         // returns number 6.3
   *
   * See also:
   *
   *    subtract, sum
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to add
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to add
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Sum of `x` and `y`
   */ return typed($165750d8541756e9$var$name, (0, $33619877a15996ac$export$8b58be045bf06082)({
        // we extend the signatures of addScalar with signatures dealing with matrices
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, addScalar);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, addScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, addScalar, true);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, addScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, addScalar, false);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, y, addScalar, false);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, addScalar, true);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, addScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, addScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, addScalar, true).valueOf();
        },
        "any, any": addScalar,
        "any, any, ...any": function anyAnyAny(x, y, rest) {
            var result = this(x, y);
            for(var i = 0; i < rest.length; i++)result = this(result, rest[i]);
            return result;
        }
    }, addScalar.signatures));
});



var $779418672cbd1256$var$name = "addScalar";
var $779418672cbd1256$var$dependencies = [
    "typed"
];
var $779418672cbd1256$export$bbebd809b9ccc50b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($779418672cbd1256$var$name, $779418672cbd1256$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Add two scalar values, `x + y`.
   * This function is meant for internal use: it is used by the public function
   * `add`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to add
   * @param  {number | BigNumber | Fraction | Complex} y          Second value to add
   * @return {number | BigNumber | Fraction | Complex | Unit}     Sum of `x` and `y`
   * @private
   */ return typed($779418672cbd1256$var$name, {
        "number, number": (0, $08ae6b2eb4bd0049$export$d6751d2a3b6da12a),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.add(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.plus(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.add(y);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (x.value === null || x.value === undefined) throw new Error("Parameter x contains a unit with undefined value");
            if (y.value === null || y.value === undefined) throw new Error("Parameter y contains a unit with undefined value");
            if (!x.equalBase(y)) throw new Error("Units do not match");
            var res = x.clone();
            res.value = this(res.value, y.value);
            res.fixPrefix = false;
            return res;
        }
    });
});



var $b6b1cd490ad9f946$var$name = "algorithm02";
var $b6b1cd490ad9f946$var$dependencies = [
    "typed",
    "equalScalar"
];
var $b6b1cd490ad9f946$export$92edb534a8f19a37 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b6b1cd490ad9f946$var$name, $b6b1cd490ad9f946$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm02(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result (SparseMatrix)
        var cvalues = [];
        var cindex = [];
        var cptr = []; // loop columns in b
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k]; // update C(i,j)
                var cij = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // check for nonzero
                if (!eq(cij, zero)) {
                    // push i & v
                    cindex.push(i);
                    cvalues.push(cij);
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return sparseMatrix.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});



var $b3da8e1c46f67c1c$var$name = "algorithm11";
var $b3da8e1c46f67c1c$var$dependencies = [
    "typed",
    "equalScalar"
];
var $b3da8e1c46f67c1c$export$a38279a12199d831 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b3da8e1c46f67c1c$var$name, $b3da8e1c46f67c1c$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm11(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = []; // loop columns
        for(var j = 0; j < columns; j++){
            // initialize ptr
            cptr[j] = cindex.length; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = aindex[k]; // invoke callback
                var v = inverse ? cf(b, avalues[k]) : cf(avalues[k], b); // check value is zero
                if (!eq(v, zero)) {
                    // push index & value
                    cindex.push(i);
                    cvalues.push(v);
                }
            }
        } // update ptr
        cptr[columns] = cindex.length; // return sparse matrix
        return s.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});







var $dcf47e3db09976d1$var$name = "algorithm06";
var $dcf47e3db09976d1$var$dependencies = [
    "typed",
    "equalScalar"
];
var $dcf47e3db09976d1$export$d6f401e6f2a7e54b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($dcf47e3db09976d1$var$name, $dcf47e3db09976d1$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked (Anz U Bnz) times, where Anz and Bnz are the nonzero elements in both matrices.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm06(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var x = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var w = []; // marks indicating value in a given row has been updated
        var u = []; // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // scatter the values of A(:,j) into workspace
            (0, $cd13353fc76500f7$export$c97954fff4307550)(a, j, w, x, u, mark, cindex, cf); // scatter the values of B(:,j) into workspace
            (0, $cd13353fc76500f7$export$c97954fff4307550)(b, j, w, x, u, mark, cindex, cf); // check we need to process values (non pattern matrix)
            if (x) {
                // initialize first index in j
                var k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    var i = cindex[k]; // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[i] === mark) {
                        // value @ i
                        var v = x[i]; // check for zero value
                        if (!eq(v, zero)) {
                            // push value
                            cvalues.push(v); // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    } else // remove value @ i, do not increment pointer
                    cindex.splice(k, 1);
                }
            } else {
                // initialize first index in j
                var p = cptr[j]; // loop index in j
                while(p < cindex.length){
                    // row
                    var r = cindex[p]; // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[r] !== mark) // remove value @ i, do not increment pointer
                    cindex.splice(p, 1);
                    else // increment pointer
                    p++;
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});



var $9ff9fc757fde94e9$var$n1 = "number";
var $9ff9fc757fde94e9$var$n2 = "number, number";
function $9ff9fc757fde94e9$export$5c3e9fce4e8f3d3a(x) {
    return !x;
}
$9ff9fc757fde94e9$export$5c3e9fce4e8f3d3a.signature = $9ff9fc757fde94e9$var$n1;
function $9ff9fc757fde94e9$export$cb9e31d07eec8012(x, y) {
    return !!(x || y);
}
$9ff9fc757fde94e9$export$cb9e31d07eec8012.signature = $9ff9fc757fde94e9$var$n2;
function $9ff9fc757fde94e9$export$17cc7dc3a74df3af(x, y) {
    return !!x !== !!y;
}
$9ff9fc757fde94e9$export$17cc7dc3a74df3af.signature = $9ff9fc757fde94e9$var$n2;
function $9ff9fc757fde94e9$export$11dffb061e00e795(x, y) {
    return !!(x && y);
}
$9ff9fc757fde94e9$export$11dffb061e00e795.signature = $9ff9fc757fde94e9$var$n2;


var $6365a3a8a2647722$var$name = "and";
var $6365a3a8a2647722$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "not"
];
var $6365a3a8a2647722$export$15a698d88cae0eff = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($6365a3a8a2647722$var$name, $6365a3a8a2647722$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, not: not } = _ref;
    var algorithm02 = (0, $b6b1cd490ad9f946$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $dcf47e3db09976d1$export$d6f401e6f2a7e54b)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Logical `and`. Test whether two values are both defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.and(x, y)
   *
   * Examples:
   *
   *    math.and(2, 4)   // returns true
   *
   *    a = [2, 0, 0]
   *    b = [3, 7, 0]
   *    c = 0
   *
   *    math.and(a, b)   // returns [true, false, false]
   *    math.and(a, c)   // returns [false, false, false]
   *
   * See also:
   *
   *    not, or, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when both inputs are defined with a nonzero/nonempty value.
   */ return typed($6365a3a8a2647722$var$name, {
        "number, number": (0, $9ff9fc757fde94e9$export$11dffb061e00e795),
        "Complex, Complex": function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) && (y.re !== 0 || y.im !== 0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return !x.isZero() && !y.isZero() && !x.isNaN() && !y.isNaN();
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return this(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            // check scalar
            if (not(y)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            // check scalar
            if (not(y)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            // check scalar
            if (not(x)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm11(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            // check scalar
            if (not(x)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});





var $87c3e66f3771976e$var$name = "apply";
var $87c3e66f3771976e$var$dependencies = [
    "typed",
    "isInteger"
];
var $87c3e66f3771976e$export$5ccffa1686df7f00 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($87c3e66f3771976e$var$name, $87c3e66f3771976e$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    /**
   * Apply a function that maps an array to a scalar
   * along a given axis of a matrix or array.
   * Returns a new matrix or array with one less dimension than the input.
   *
   * Syntax:
   *
   *     math.apply(A, dim, callback)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [3, 4]]
   *    const sum = math.sum
   *
   *    math.apply(A, 0, sum)             // returns [4, 6]
   *    math.apply(A, 1, sum)             // returns [3, 7]
   *
   * See also:
   *
   *    map, filter, forEach
   *
   * @param {Array | Matrix} array   The input Matrix
   * @param {number} dim             The dimension along which the callback is applied
   * @param {Function} callback      The callback function that is applied. This Function
   *                                 should take an array or 1-d matrix as an input and
   *                                 return a number.
   * @return {Array | Matrix} res    The residual matrix with the function applied over some dimension.
   */ return typed($87c3e66f3771976e$var$name, {
        "Array | Matrix, number | BigNumber, function": function ArrayMatrixNumberBigNumberFunction(mat, dim, callback) {
            if (!isInteger(dim)) throw new TypeError("Integer number expected for dimension");
            var size = Array.isArray(mat) ? (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(mat) : mat.size();
            if (dim < 0 || dim >= size.length) throw new (0, $b954584cbe120407$export$efa5eacb1304c464)(dim, size.length);
            if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(mat)) return mat.create($87c3e66f3771976e$var$_apply(mat.valueOf(), dim, callback));
            else return $87c3e66f3771976e$var$_apply(mat, dim, callback);
        }
    });
});
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $87c3e66f3771976e$var$_apply(mat, dim, callback) {
    var i, ret, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) return callback(mat);
        else {
            tran = $87c3e66f3771976e$var$_switch(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $87c3e66f3771976e$var$_apply(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $87c3e66f3771976e$var$_apply(mat[i], dim - 1, callback);
        return ret;
    }
}
/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $87c3e66f3771976e$var$_switch(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
}



var $550f8f3a9abc709b$var$name = "arg";
var $550f8f3a9abc709b$var$dependencies = [
    "typed"
];
var $550f8f3a9abc709b$export$bde3dabbd4699a93 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($550f8f3a9abc709b$var$name, $550f8f3a9abc709b$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the argument of a complex value.
   * For a complex number `a + bi`, the argument is computed as `atan2(b, a)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.arg(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 2)
   *    math.arg(a) / math.pi          // returns number 0.25
   *
   *    const b = math.complex('2 + 3i')
   *    math.arg(b)                    // returns number 0.982793723247329
   *    math.atan2(3, 2)               // returns number 0.982793723247329
   *
   * See also:
   *
   *    re, im, conj, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The argument of x
   */ return typed($550f8f3a9abc709b$var$name, {
        number: function number(x) {
            return Math.atan2(0, x);
        },
        BigNumber: function BigNumber(x) {
            return x.constructor.atan2(0, x);
        },
        Complex: function Complex(x) {
            return x.arg();
        },
        // TODO: implement BigNumber support for function arg
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $0f27587f75810b19$var$name = "asec";
var $0f27587f75810b19$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $0f27587f75810b19$export$e1f28fc7c94f90b0 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($0f27587f75810b19$var$name, $0f27587f75810b19$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse secant of a value. Defined as `asec(x) = acos(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asec(x)
   *
   * Examples:
   *
   *    math.asec(0.5)           // returns 1.0471975511965979
   *    math.asec(math.sec(1.5)) // returns 1.5
   *
   *    math.asec(2)             // returns 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    acos, acot, acsc
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} The arc secant of x
   */ return typed($0f27587f75810b19$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $b54e9ade204c059d$export$5ec3930177455ade)(x);
            return new Complex(x, 0).asec();
        },
        Complex: function Complex(x) {
            return x.asec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acos();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $d245c0d227af4eb1$var$name = "asech";
var $d245c0d227af4eb1$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $d245c0d227af4eb1$export$8eeff5f09afe95bc = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d245c0d227af4eb1$var$name, $d245c0d227af4eb1$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arcsecant of a value,
   * defined as `asech(x) = acosh(1/x) = ln(sqrt(1/x^2 - 1) + 1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asech(x)
   *
   * Examples:
   *
   *    math.asech(0.5)       // returns 1.3169578969248166
   *
   * See also:
   *
   *    acsch, acoth
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arcsecant of x
   */ return typed($d245c0d227af4eb1$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) {
                var xInv = 1 / x;
                if (xInv > 0 || config.predictable) return (0, $b54e9ade204c059d$export$cf144300ea173362)(x);
                var ret = Math.sqrt(xInv * xInv - 1);
                return new Complex(Math.log(ret - xInv), Math.PI);
            }
            return new Complex(x, 0).asech();
        },
        Complex: function Complex(x) {
            return x.asech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acosh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $2da105de6a9ebe93$var$name = "asin";
var $2da105de6a9ebe93$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $2da105de6a9ebe93$export$5f05d91ddc56bc14 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($2da105de6a9ebe93$var$name, $2da105de6a9ebe93$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the inverse sine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asin(x)
   *
   * Examples:
   *
   *    math.asin(0.5)           // returns number 0.5235987755982989
   *    math.asin(math.sin(1.5)) // returns number ~1.5
   *
   *    math.asin(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    sin, atan, acos
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc sine of x
   */ return typed($2da105de6a9ebe93$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.asin(x);
            else return new Complex(x, 0).asin();
        },
        Complex: function Complex(x) {
            return x.asin();
        },
        BigNumber: function BigNumber(x) {
            return x.asin();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since asin(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});




var $24f33341c424235f$var$name = "asinh";
var $24f33341c424235f$var$dependencies = [
    "typed"
];
var $24f33341c424235f$export$7278bb4e3c84d46a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($24f33341c424235f$var$name, $24f33341c424235f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic arcsine of a value,
   * defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asinh(x)
   *
   * Examples:
   *
   *    math.asinh(0.5)       // returns 0.48121182505960347
   *
   * See also:
   *
   *    acosh, atanh
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arcsine of x
   */ return typed("asinh", {
        number: (0, $b54e9ade204c059d$export$3a027485d3336d8d),
        Complex: function Complex(x) {
            return x.asinh();
        },
        BigNumber: function BigNumber(x) {
            return x.asinh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since asinh(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});



var $849b8afd38dd3092$var$name = "atan";
var $849b8afd38dd3092$var$dependencies = [
    "typed"
];
var $849b8afd38dd3092$export$b87f3a3301a24256 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($849b8afd38dd3092$var$name, $849b8afd38dd3092$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the inverse tangent of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan(x)
   *
   * Examples:
   *
   *    math.atan(0.5)           // returns number 0.4636476090008061
   *    math.atan(math.tan(1.5)) // returns number 1.5
   *
   *    math.atan(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    tan, asin, acos
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc tangent of x
   */ return typed("atan", {
        number: function number(x) {
            return Math.atan(x);
        },
        Complex: function Complex(x) {
            return x.atan();
        },
        BigNumber: function BigNumber(x) {
            return x.atan();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since atan(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});





var $b77d8309a4e59b1f$var$name = "algorithm03";
var $b77d8309a4e59b1f$var$dependencies = [
    "typed"
];
var $b77d8309a4e59b1f$export$486bb900f1a3c833 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b77d8309a4e59b1f$var$name, $b77d8309a4e59b1f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over SparseMatrix items and invokes the callback function f(Dij, Sij).
   * Callback function invoked M*N times.
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(Dij, 0)    ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (C)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm03(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result (DenseMatrix)
        var cdata = []; // initialize dense matrix
        for(var z = 0; z < rows; z++)// initialize row
        cdata[z] = [];
         // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns in b
        for(var j = 0; j < columns; j++){
            // column mark
            var mark = j + 1; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k]; // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
                w[i] = mark;
            } // process workspace
            for(var y = 0; y < rows; y++)// check we have a calculated value for current row
            if (w[y] === mark) // use calculated value
            cdata[y][j] = x[y];
            else // calculate value
            cdata[y][j] = inverse ? cf(zero, adata[y][j]) : cf(adata[y][j], zero);
        } // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});




var $8b36a8a0c418b6d5$var$name = "algorithm09";
var $8b36a8a0c418b6d5$var$dependencies = [
    "typed",
    "equalScalar"
];
var $8b36a8a0c418b6d5$export$c769437575b0fcdd = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8b36a8a0c418b6d5$var$name, $8b36a8a0c418b6d5$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and invokes the callback function f(Aij, Bij).
   * Callback function invoked NZA times, number of nonzero elements in A.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm09(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var x = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var w = []; // vars
        var i, j, k, k0, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // column mark
            var mark = j + 1; // check we need to process values
            if (x) // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // update workspace
                w[i] = mark;
                x[i] = bvalues[k];
            }
             // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // check we need to process values
                if (x) {
                    // b value @ i,j
                    var vb = w[i] === mark ? x[i] : zero; // invoke f
                    var vc = cf(avalues[k], vb); // check zero value
                    if (!eq(vc, zero)) {
                        // push index
                        cindex.push(i); // push value
                        cvalues.push(vc);
                    }
                } else // push index
                cindex.push(i);
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});




var $2c0794088bd09e2c$var$name = "algorithm12";
var $2c0794088bd09e2c$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $2c0794088bd09e2c$export$806772cd23b603dc = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($2c0794088bd09e2c$var$name, $2c0794088bd09e2c$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked MxN times.
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(0, b)    ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm12(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cdata = []; // workspaces
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k]; // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            } // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                 // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = inverse ? cf(b, 0) : cf(0, b);
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});




var $ec0ad837a8ecf196$var$name = "atan2";
var $ec0ad837a8ecf196$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber",
    "DenseMatrix"
];
var $ec0ad837a8ecf196$export$c56716e11a38354e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($ec0ad837a8ecf196$var$name, $ec0ad837a8ecf196$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: BigNumber, DenseMatrix: DenseMatrix } = _ref;
    var algorithm02 = (0, $b6b1cd490ad9f946$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm09 = (0, $8b36a8a0c418b6d5$export$c769437575b0fcdd)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculate the inverse tangent function with two arguments, y/x.
   * By providing two arguments, the right quadrant of the computed angle can be
   * determined.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan2(y, x)
   *
   * Examples:
   *
   *    math.atan2(2, 2) / math.pi       // returns number 0.25
   *
   *    const angle = math.unit(60, 'deg') // returns Unit 60 deg
   *    const x = math.cos(angle)
   *    const y = math.sin(angle)
   *
   *    math.atan(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    tan, atan, sin, cos
   *
   * @param {number | Array | Matrix} y  Second dimension
   * @param {number | Array | Matrix} x  First dimension
   * @return {number | Array | Matrix} Four-quadrant inverse tangent
   */ return typed($ec0ad837a8ecf196$var$name, {
        "number, number": Math.atan2,
        // Complex numbers doesn't seem to have a reasonable implementation of
        // atan2(). Even Matlab removed the support, after they only calculated
        // the atan only on base of the real part of the numbers and ignored the imaginary.
        "BigNumber, BigNumber": function BigNumberBigNumber(y, x) {
            return BigNumber.atan2(y, x);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm09(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            // mind the order of y and x!
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // mind the order of y and x
            return algorithm12(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // mind the order of y and x
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});




var $beb73f9dec69afc9$var$name = "atanh";
var $beb73f9dec69afc9$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $beb73f9dec69afc9$export$c2dbbeab1e5e6195 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($beb73f9dec69afc9$var$name, $beb73f9dec69afc9$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the hyperbolic arctangent of a value,
   * defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atanh(x)
   *
   * Examples:
   *
   *    math.atanh(0.5)       // returns 0.5493061443340549
   *
   * See also:
   *
   *    acosh, asinh
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arctangent of x
   */ return typed($beb73f9dec69afc9$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) return (0, $b54e9ade204c059d$export$44a1f653c6513db8)(x);
            return new Complex(x, 0).atanh();
        },
        Complex: function Complex(x) {
            return x.atanh();
        },
        BigNumber: function BigNumber(x) {
            return x.atanh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since atanh(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});


var $9fad9c9a56db7329$export$ace78258608300fc = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("speedOfLight", "299792458", "m s^-1");
var $9fad9c9a56db7329$export$157e78cb05354391 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2");
var $9fad9c9a56db7329$export$e58ff8150d83ea6a = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("planckConstant", "6.62607015e-34", "J s");
var $9fad9c9a56db7329$export$50bee65ab76b402 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("reducedPlanckConstant", "1.0545718176461565e-34", "J s"); // Electromagnetic constants
var $9fad9c9a56db7329$export$e7fcb8898ecb0703 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("magneticConstant", "1.25663706212e-6", "N A^-2");
var $9fad9c9a56db7329$export$d69030cf93f04407 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("electricConstant", "8.8541878128e-12", "F m^-1");
var $9fad9c9a56db7329$export$c9ff08d282f03cf0 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("vacuumImpedance", "376.730313667", "ohm");
var $9fad9c9a56db7329$export$815f2029cd62d0d6 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("coulomb", "8.987551792261171e9", "N m^2 C^-2");
var $9fad9c9a56db7329$export$542715ad7e3a9798 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("elementaryCharge", "1.602176634e-19", "C");
var $9fad9c9a56db7329$export$f5851397fd1173db = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("bohrMagneton", "9.2740100783e-24", "J T^-1");
var $9fad9c9a56db7329$export$e26bbd27fc291ddf = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("conductanceQuantum", "7.748091729863649e-5", "S");
var $9fad9c9a56db7329$export$f2f136373157165b = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("inverseConductanceQuantum", "12906.403729652257", "ohm");
var $9fad9c9a56db7329$export$fd46b6c8680e4d01 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("magneticFluxQuantum", "2.0678338484619295e-15", "Wb");
var $9fad9c9a56db7329$export$9670d94122b9a81b = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("nuclearMagneton", "5.0507837461e-27", "J T^-1");
var $9fad9c9a56db7329$export$e3f21ac13bee6a0f = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("klitzing", "25812.807459304513", "ohm");
var $9fad9c9a56db7329$export$c090909964c68de4 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("josephson", "4.835978484169836e14 Hz V", "Hz V^-1"); // TODO: support for Hz needed
var $9fad9c9a56db7329$export$19b72356ad84e4ee = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("bohrRadius", "5.29177210903e-11", "m");
var $9fad9c9a56db7329$export$68a9771dccce9a23 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("classicalElectronRadius", "2.8179403262e-15", "m");
var $9fad9c9a56db7329$export$85362d2a7862e209 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("electronMass", "9.1093837015e-31", "kg");
var $9fad9c9a56db7329$export$b6687a2f3911256b = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("fermiCoupling", "1.1663787e-5", "GeV^-2");
var $9fad9c9a56db7329$export$aaddb59a993d3ac4 = $9fad9c9a56db7329$var$numberFactory("fineStructure", 7.2973525693e-3);
var $9fad9c9a56db7329$export$8bb818baeaa40bd6 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("hartreeEnergy", "4.3597447222071e-18", "J");
var $9fad9c9a56db7329$export$f357c1a8d4fccef6 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("protonMass", "1.67262192369e-27", "kg");
var $9fad9c9a56db7329$export$a403f6c5bed71f22 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("deuteronMass", "3.3435830926e-27", "kg");
var $9fad9c9a56db7329$export$676d5ebe8fbeb250 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("neutronMass", "1.6749271613e-27", "kg");
var $9fad9c9a56db7329$export$6840f334b8a5b6b1 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1");
var $9fad9c9a56db7329$export$fd1b48ecb0d5c0ef = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("rydberg", "10973731.568160", "m^-1");
var $9fad9c9a56db7329$export$229739a879741f68 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("thomsonCrossSection", "6.6524587321e-29", "m^2");
var $9fad9c9a56db7329$export$fa2d42c5c25c1883 = $9fad9c9a56db7329$var$numberFactory("weakMixingAngle", 0.22290);
var $9fad9c9a56db7329$export$55fc8769b037d266 = $9fad9c9a56db7329$var$numberFactory("efimovFactor", 22.7); // Physico-chemical constants
var $9fad9c9a56db7329$export$2f8d2da219209d0a = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("atomicMass", "1.66053906660e-27", "kg");
var $9fad9c9a56db7329$export$4924e3d8de6ad850 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("avogadro", "6.02214076e23", "mol^-1");
var $9fad9c9a56db7329$export$221b7a8c9510b6cc = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("boltzmann", "1.380649e-23", "J K^-1");
var $9fad9c9a56db7329$export$17ef8d738c9b0091 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("faraday", "96485.33212331001", "C mol^-1");
var $9fad9c9a56db7329$export$266a9bae8a62fb6e = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("firstRadiation", "3.7417718521927573e-16", "W m^2"); // export const createSpectralRadiance = /* #__PURE__ */ unitFactory('spectralRadiance', '1.1910429723971881e-16', 'W m^2 sr^-1') // TODO spectralRadiance
var $9fad9c9a56db7329$export$c38bce537e0ffddb = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("loschmidt", "2.686780111798444e25", "m^-3");
var $9fad9c9a56db7329$export$85a77a0842c24f74 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("gasConstant", "8.31446261815324", "J K^-1 mol^-1");
var $9fad9c9a56db7329$export$12e2358797b853c9 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1");
var $9fad9c9a56db7329$export$f5e8f56ebfacbaca = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("molarVolume", "0.022413969545014137", "m^3 mol^-1");
var $9fad9c9a56db7329$export$467c65d9dfc3d3a2 = $9fad9c9a56db7329$var$numberFactory("sackurTetrode", -1.16487052358);
var $9fad9c9a56db7329$export$ea93a35a6f35e1b6 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("secondRadiation", "0.014387768775039337", "m K");
var $9fad9c9a56db7329$export$a943525a62f69cd2 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4");
var $9fad9c9a56db7329$export$3c74568e9574d168 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("wienDisplacement", "2.897771955e-3", "m K"); // Adopted values
var $9fad9c9a56db7329$export$85414d775c93e6de = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("molarMass", "0.99999999965e-3", "kg mol^-1");
var $9fad9c9a56db7329$export$d5045cf71611a462 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("molarMassC12", "11.9999999958e-3", "kg mol^-1");
var $9fad9c9a56db7329$export$42b5845f95e0feee = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("gravity", "9.80665", "m s^-2"); // atm is defined in Unit.js
var $9fad9c9a56db7329$export$675ebbcd6bdcebd7 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("planckLength", "1.616255e-35", "m");
var $9fad9c9a56db7329$export$d44b96c94520b20e = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("planckMass", "2.176435e-8", "kg");
var $9fad9c9a56db7329$export$3bf63d7b96fd8541 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("planckTime", "5.391245e-44", "s");
var $9fad9c9a56db7329$export$43e139a6eec1ab59 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("planckCharge", "1.87554603778e-18", "C");
var $9fad9c9a56db7329$export$d21f20fc89fac8c0 = /* #__PURE__ */ $9fad9c9a56db7329$var$unitFactory("planckTemperature", "1.416785e+32", "K"); // helper function to create a factory function which creates a physical constant,
// a Unit with either a number value or a BigNumber value depending on the configuration
function $9fad9c9a56db7329$var$unitFactory(name, valueStr, unitStr) {
    var dependencies = [
        "config",
        "Unit",
        "BigNumber"
    ];
    return (0, $a671619231063c2b$export$e9008f2713103c6c)(name, dependencies, (_ref)=>{
        var { config: config, Unit: Unit, BigNumber: BigNumber } = _ref;
        // Note that we can parse into number or BigNumber.
        // We do not parse into Fractions as that doesn't make sense: we would lose precision of the values
        // Therefore we dont use Unit.parse()
        var value = config.number === "BigNumber" ? new BigNumber(valueStr) : parseFloat(valueStr);
        var unit = new Unit(value, unitStr);
        unit.fixPrefix = true;
        return unit;
    });
} // helper function to create a factory function which creates a numeric constant,
// either a number or BigNumber depending on the configuration
function $9fad9c9a56db7329$var$numberFactory(name, value) {
    var dependencies = [
        "config",
        "BigNumber"
    ];
    return (0, $a671619231063c2b$export$e9008f2713103c6c)(name, dependencies, (_ref2)=>{
        var { config: config, BigNumber: BigNumber } = _ref2;
        return config.number === "BigNumber" ? new BigNumber(value) : value;
    });
}


var $0f0c535893f780a2$var$name = "bellNumbers";
var $0f0c535893f780a2$var$dependencies = [
    "typed",
    "addScalar",
    "isNegative",
    "isInteger",
    "stirlingS2"
];
var $0f0c535893f780a2$export$7b7dc3bd00d38afb = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($0f0c535893f780a2$var$name, $0f0c535893f780a2$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, isNegative: isNegative, isInteger: isInteger, stirlingS2: stirlingS2 } = _ref;
    /**
   * The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S.
   * bellNumbers only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.bellNumbers(n)
   *
   * Examples:
   *
   *    math.bellNumbers(3) // returns 5
   *    math.bellNumbers(8) // returns 4140
   *
   * See also:
   *
   *    stirlingS2
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @return {Number | BigNumber}     B(n)
   */ return typed($0f0c535893f780a2$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError("Non-negative integer value expected in function bellNumbers");
             // Sum (k=0, n) S(n,k).
            var result = 0;
            for(var i = 0; i <= n; i++)result = addScalar(result, stirlingS2(n, i));
            return result;
        }
    });
});



var $f645461b7f19365e$var$name = "bignumber";
var $f645461b7f19365e$var$dependencies = [
    "typed",
    "BigNumber"
];
var $f645461b7f19365e$export$1c955ee1b8a97877 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($f645461b7f19365e$var$name, $f645461b7f19365e$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: BigNumber } = _ref;
    /**
   * Create a BigNumber, which can store numbers with arbitrary precision.
   * When a matrix is provided, all elements will be converted to BigNumber.
   *
   * Syntax:
   *
   *    math.bignumber(x)
   *
   * Examples:
   *
   *    0.1 + 0.2                                  // returns number 0.30000000000000004
   *    math.bignumber(0.1) + math.bignumber(0.2)  // returns BigNumber 0.3
   *
   *
   *    7.2e500                                    // returns number Infinity
   *    math.bignumber('7.2e500')                  // returns BigNumber 7.2e500
   *
   * See also:
   *
   *    boolean, complex, index, matrix, string, unit
   *
   * @param {number | string | Fraction | BigNumber | Array | Matrix | boolean | null} [value]  Value for the big number,
   *                                                    0 by default.
   * @returns {BigNumber} The created bignumber
   */ return typed("bignumber", {
        "": function _() {
            return new BigNumber(0);
        },
        number: function number(x) {
            // convert to string to prevent errors in case of >15 digits
            return new BigNumber(x + "");
        },
        string: function string(x) {
            var wordSizeSuffixMatch = x.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
            if (wordSizeSuffixMatch) {
                // x has a word size suffix
                var size = wordSizeSuffixMatch[2];
                var n = BigNumber(wordSizeSuffixMatch[1]);
                var twoPowSize = new BigNumber(2).pow(Number(size));
                if (n.gt(twoPowSize.sub(1))) throw new SyntaxError('String "'.concat(x, '" is out of range'));
                var twoPowSizeSubOne = new BigNumber(2).pow(Number(size) - 1);
                if (n.gte(twoPowSizeSubOne)) return n.sub(twoPowSize);
                else return n;
            }
            return new BigNumber(x);
        },
        BigNumber: function BigNumber(x) {
            // we assume a BigNumber is immutable
            return x;
        },
        Fraction: function Fraction(x) {
            return new BigNumber(x.n).div(x.d).times(x.s);
        },
        null: function _null(x) {
            return new BigNumber(0);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});

var $22467ec447bdc2ca$exports = {};
(function(globalScope) {
    "use strict";
    /*!
   *  decimal.js v10.4.3
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9, // Base conversion alphabet.
    NUMERALS = "0123456789abcdef", // The natural logarithm of 10 (1025 digits).
    LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", // Pi (1025 digits).
    PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false // true/false
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    Decimal, inexact, noConflict, quadrant, external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, // Decimal.prototype object
    P = {
        toStringTag: tag
    };
    // Decimal prototype methods
    /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s < 0) x.s = 1;
        return finalise(x);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */ P.ceil = function() {
        return finalise(new this.constructor(this), this.e + 1, 2);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ P.clampedTo = P.clamp = function(min, max) {
        var k, x = this, Ctor = x.constructor;
        min = new Ctor(min);
        max = new Ctor(max);
        if (!min.s || !max.s) return new Ctor(NaN);
        if (min.gt(max)) throw Error(invalidArgument + max);
        k = x.cmp(min);
        return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
        // Either NaN or ±Infinity?
        if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
        // Either zero?
        if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
        // Signs differ?
        if (xs !== ys) return xs;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
        xdL = xd.length;
        ydL = yd.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */ P.cosine = P.cos = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.d) return new Ctor(NaN);
        // cos(0) = cos(-0) = 1
        if (!x.d[0]) return new Ctor(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };
    /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */ P.cubeRoot = P.cbrt = function() {
        var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        external = false;
        // Initial estimate.
        s = x.s * mathpow(x.s * x, 1 / 3);
        // Math.cbrt underflow/overflow?
        // Pass x to Math.pow as integer, then adjust the exponent of the result.
        if (!s || Math.abs(s) == 1 / 0) {
            n = digitsToString(x.d);
            e = x.e;
            // Adjust n exponent so it is a multiple of 3 away from x exponent.
            if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? "0" : "00";
            s = mathpow(n, 1 / 3);
            // Rarely, e may be one less than the result exponent value.
            e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
            r.s = x.s;
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Halley's method.
        // TODO? Compare Newton's method.
        for(;;){
            t = r;
            t3 = t.times(t).times(t);
            t3plusx = t3.plus(x);
            r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                // , i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var w, d = this.d, n = NaN;
        if (d) {
            w = d.length - 1;
            n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last word.
            w = d[w];
            if (w) for(; w % 10 == 0; w /= 10)n--;
            if (n < 0) n = 0;
        }
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedToIntegerBy = P.divToInt = function(y) {
        var x = this, Ctor = x.constructor;
        return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */ P.floor = function() {
        return finalise(new this.constructor(this), this.e + 1, 3);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        var k = this.cmp(y);
        return k == 1 || k === 0;
    };
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */ P.hyperbolicCosine = P.cosh = function() {
        var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
        if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
        if (x.isZero()) return one;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
        // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
        // Estimate the optimum number of times to use the argument reduction.
        // TODO? Estimation reused from cosine() and may not be optimal here.
        if (len < 32) {
            k = Math.ceil(len / 3);
            n = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            n = "2.3283064365386962890625e-10";
        }
        x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
        // Reverse argument reduction
        var cosh2_x, i = k, d8 = new Ctor(8);
        for(; i--;){
            cosh2_x = x.times(x);
            x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
        }
        return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */ P.hyperbolicSine = P.sinh = function() {
        var k, pr, rm, len, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        if (len < 3) x = taylorSeries(Ctor, 2, x, x, true);
        else {
            // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
            // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
            // 3 multiplications and 1 addition
            // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
            // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
            // 4 multiplications and 2 additions
            // Estimate the optimum number of times to use the argument reduction.
            k = 1.4 * Math.sqrt(len);
            k = k > 16 ? 16 : k | 0;
            x = x.times(1 / tinyPow(5, k));
            x = taylorSeries(Ctor, 2, x, x, true);
            // Reverse argument reduction
            var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
            for(; k--;){
                sinh2_x = x.times(x);
                x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
            }
        }
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */ P.hyperbolicTangent = P.tanh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(x.s);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 7;
        Ctor.rounding = 1;
        return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */ P.inverseCosine = P.acos = function() {
        var halfPi, x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
        if (k !== -1) return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
        if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
        // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.asin();
        halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return halfPi.minus(x);
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */ P.inverseHyperbolicCosine = P.acosh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
        if (!x.isFinite()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).minus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */ P.inverseHyperbolicSine = P.asinh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).plus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */ P.inverseHyperbolicTangent = P.atanh = function() {
        var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        xsd = x.sd();
        if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
        Ctor.precision = wpr = xsd - x.e;
        x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
        Ctor.precision = pr + 4;
        Ctor.rounding = 1;
        x = x.ln();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(0.5);
    };
    /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */ P.inverseSine = P.asin = function() {
        var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
        if (x.isZero()) return new Ctor(x);
        k = x.abs().cmp(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (k !== -1) {
            // |x| is 1
            if (k === 0) {
                halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                halfPi.s = x.s;
                return halfPi;
            }
            // |x| > 1 or x is NaN
            return new Ctor(NaN);
        }
        // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */ P.inverseTangent = P.atan = function() {
        var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
        if (!x.isFinite()) {
            if (!x.s) return new Ctor(NaN);
            if (pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.5);
                r.s = x.s;
                return r;
            }
        } else if (x.isZero()) return new Ctor(x);
        else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
            r = getPi(Ctor, pr + 4, rm).times(0.25);
            r.s = x.s;
            return r;
        }
        Ctor.precision = wpr = pr + 10;
        Ctor.rounding = 1;
        // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
        // Argument reduction
        // Ensure |x| < 0.42
        // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
        k = Math.min(28, wpr / LOG_BASE + 2 | 0);
        for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
        external = false;
        j = Math.ceil(wpr / LOG_BASE);
        n = 1;
        x2 = x.times(x);
        r = new Ctor(x);
        px = x;
        // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
        for(; i !== -1;){
            px = px.times(x2);
            t = r.minus(px.div(n += 2));
            px = px.times(x2);
            r = t.plus(px.div(n += 2));
            if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
        }
        if (k) r = r.times(2 << k - 1);
        external = true;
        return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */ P.isFinite = function() {
        return !!this.d;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isInt = function() {
        return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isNeg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.isPos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */ P.isZero = function() {
        return !!this.d && this.d[0] === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
        // Default base is 10.
        if (base == null) {
            base = new Ctor(10);
            isBase10 = true;
        } else {
            base = new Ctor(base);
            d = base.d;
            // Return NaN if base is negative, or non-finite, or is 0 or 1.
            if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
            isBase10 = base.eq(10);
        }
        d = arg.d;
        // Is arg negative, non-finite, 0 or 1?
        if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
        // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
        // integer power of 10.
        if (isBase10) {
            if (d.length > 1) inf = true;
            else {
                for(k = d[0]; k % 10 === 0;)k /= 10;
                inf = k !== 1;
            }
        }
        external = false;
        sd = pr + guard;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        // The result will have 5 rounding digits.
        r = divide(num, denominator, sd, 1);
        // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
        // calculate 10 further digits.
        //
        // If the result is known to have an infinite decimal expansion, repeat this until it is clear
        // that the result is above or below the boundary. Otherwise, if after calculating the 10
        // further digits, the last 14 are nines, round up and assume the result is exact.
        // Also assume the result is exact if the last 14 are zero.
        //
        // Example of a result that will be incorrectly rounded:
        // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
        // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
        // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
        // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
        // place is still 2.6.
        if (checkRoundingDigits(r.d, k = pr, rm)) do {
            sd += 10;
            num = naturalLogarithm(arg, sd);
            denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
            r = divide(num, denominator, sd, 1);
            if (!inf) {
                // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
                break;
            }
        }while (checkRoundingDigits(r.d, k += 10, rm));
        external = true;
        return finalise(r, pr, rm);
    };
    /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'lt');
  };
   */ /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'gt');
  };
   */ /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.minus = P.sub = function(y) {
        var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (x.d) y.s = -y.s;
            else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.plus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return y negated if x is zero and y is non-zero.
            if (yd[0]) y.s = -y.s;
            else if (xd[0]) y = new Ctor(x);
            else return new Ctor(rm === 3 ? -0 : 0);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        e = mathfloor(y.e / LOG_BASE);
        xe = mathfloor(x.e / LOG_BASE);
        xd = xd.slice();
        k = xe - e;
        // If base 1e7 exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of
            // zeros needing to be prepended, but this can be avoided while still ensuring correct
            // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to `xd` if shorter.
        // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
        if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
        // Return x if y is ±Infinity or x is ±0.
        if (!y.d || x.d && !x.d[0]) return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
        // Prevent rounding of intermediate calculations.
        external = false;
        if (Ctor.modulo == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // result = x - q * y    where  0 <= result < abs(y)
            q = divide(x, y.abs(), 0, 3, 1);
            q.s *= y.s;
        } else q = divide(x, y, 0, Ctor.modulo, 1);
        q = q.times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.naturalExponential = P.exp = function() {
        return naturalExponential(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return naturalLogarithm(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return finalise(x);
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.plus = P.add = function(y) {
        var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!yd[0]) y = new Ctor(x);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        k = mathfloor(x.e / LOG_BASE);
        e = mathfloor(y.e / LOG_BASE);
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var k, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        if (x.d) {
            k = getPrecision(x.d);
            if (z && x.e + 1 > k) k = x.e + 1;
        } else k = NaN;
        return k;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.round = function() {
        var x = this, Ctor = x.constructor;
        return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };
    /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */ P.sine = P.sin = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = sine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */ P.squareRoot = P.sqrt = function() {
        var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */ P.tangent = P.tan = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 10;
        Ctor.rounding = 1;
        x = x.sin();
        x.s = 1;
        x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        y.s *= x.s;
        // If either is NaN, ±Infinity or ±0...
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
        e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = getBase10Exponent(r, e);
        return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };
    /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toBinary = function(sd, rm) {
        return toStringBinary(this, 2, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.toDP = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return finalise(x, dp + x.e + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), dp + 1, rm);
            str = finiteToString(x, true, dp + 1);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            y = finalise(new Ctor(x), dp + x.e + 1, rm);
            str = finiteToString(y, false, dp + y.e + 1);
        }
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */ P.toFraction = function(maxD) {
        var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
        if (!xd) return new Ctor(x);
        n1 = d0 = new Ctor(1);
        d1 = n0 = new Ctor(0);
        d = new Ctor(d1);
        e = d.e = getPrecision(xd) - x.e - 1;
        k = e % LOG_BASE;
        d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
        if (maxD == null) // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
        else {
            n = new Ctor(maxD);
            if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
            maxD = n.gt(d) ? e > 0 ? d : n1 : n;
        }
        external = false;
        n = new Ctor(digitsToString(xd));
        pr = Ctor.precision;
        Ctor.precision = e = xd.length * LOG_BASE * 2;
        for(;;){
            q = divide(n, d, 0, 1, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.cmp(maxD) == 1) break;
            d0 = d1;
            d1 = d2;
            d2 = n1;
            n1 = n0.plus(q.times(d2));
            n0 = d2;
            d2 = d;
            d = n.minus(q.times(d2));
            n = d2;
        }
        d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        // Determine which fraction is closer to x, n0/d0 or n1/d1?
        r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        Ctor.precision = pr;
        external = true;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toHexadecimal = P.toHex = function(sd, rm) {
        return toStringBinary(this, 16, sd, rm);
    };
    /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */ P.toNearest = function(y, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (y == null) {
            // If x is not finite, return x.
            if (!x.d) return x;
            y = new Ctor(1);
            rm = Ctor.rounding;
        } else {
            y = new Ctor(y);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            // If x is not finite, return x if y is not NaN, else NaN.
            if (!x.d) return y.s ? x : y;
            // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
            if (!y.d) {
                if (y.s) y.s = x.s;
                return y;
            }
        }
        // If y is not zero, calculate the nearest multiple of y to x.
        if (y.d[0]) {
            external = false;
            x = divide(x, y, 0, rm, 1).times(y);
            external = true;
            finalise(x);
        // If y is zero, return zero with the sign of x.
        } else {
            y.s = x.s;
            x = y;
        }
        return x;
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toOctal = function(sd, rm) {
        return toStringBinary(this, 8, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
        // Either ±Infinity, NaN or ±0?
        if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
        x = new Ctor(x);
        if (x.eq(1)) return x;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (y.eq(1)) return finalise(x, pr, rm);
        // y exponent
        e = mathfloor(y.e / LOG_BASE);
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = intPow(Ctor, x, k, pr);
            return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
        }
        s = x.s;
        // if x is negative
        if (s < 0) {
            // if y is not an integer
            if (e < y.d.length - 1) return new Ctor(NaN);
            // Result is positive if x is negative and the last digit of integer y is even.
            if ((y.d[e] & 1) == 0) s = 1;
            // if x.eq(-1)
            if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                x.s = s;
                return x;
            }
        }
        // Estimate result exponent.
        // x^y = 10^e,  where e = y * log10(x)
        // log10(x) = log10(x_significand) + x_exponent
        // log10(x_significand) = ln(x_significand) / ln(10)
        k = mathpow(+x, yn);
        e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log("0." + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + "").e;
        // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
        // Overflow/underflow?
        if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
        external = false;
        Ctor.rounding = x.s = 1;
        // Estimate the extra guard digits needed to ensure five correct rounding digits from
        // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
        // new Decimal(2.32456).pow('2087987436534566.46411')
        // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
        k = Math.min(12, (e + "").length);
        // r = x^y = exp(y*ln(x))
        r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
        // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
        if (r.d) {
            // Truncate to the required precision plus five rounding digits.
            r = finalise(r, pr + 5, 1);
            // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
            // the result.
            if (checkRoundingDigits(r.d, pr, rm)) {
                e = pr + 10;
                // Truncate to the increased precision plus five rounding digits.
                r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
                // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
            }
        }
        r.s = s;
        external = true;
        Ctor.rounding = rm;
        return finalise(r, pr, rm);
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var str, x = this, Ctor = x.constructor;
        if (sd === void 0) str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), sd, rm);
            str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */ P.toSignificantDigits = P.toSD = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return finalise(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */ P.truncated = P.trunc = function() {
        return finalise(new this.constructor(this), this.e + 1, 1);
    };
    /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */ P.valueOf = P.toJSON = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() ? "-" + str : str;
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */ function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */ function checkRoundingDigits(d, i, rm, repeating) {
        var di, k, r, rd;
        // Get the length of the first word of the array d.
        for(k = d[0]; k >= 10; k /= 10)--i;
        // Is the rounding digit in the first word of d?
        if (--i < 0) {
            i += LOG_BASE;
            di = 0;
        } else {
            di = Math.ceil((i + 1) / LOG_BASE);
            i %= LOG_BASE;
        }
        // i is the index (0 - 6) of the rounding digit.
        // E.g. if within the word 3487563 the first rounding digit is 5,
        // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
        k = mathpow(10, LOG_BASE - i);
        rd = d[di] % k | 0;
        if (repeating == null) {
            if (i < 3) {
                if (i == 0) rd = rd / 100 | 0;
                else if (i == 1) rd = rd / 10 | 0;
                r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
            } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        } else if (i < 4) {
            if (i == 0) rd = rd / 1000 | 0;
            else if (i == 1) rd = rd / 100 | 0;
            else if (i == 2) rd = rd / 10 | 0;
            r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        return r;
    }
    // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, strL = str.length;
        for(; i < strL;){
            for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
            arr[0] += NUMERALS.indexOf(str.charAt(i++));
            for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] === void 0) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */ function cosine(Ctor, x) {
        var k, len, y;
        if (x.isZero()) return x;
        // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
        // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
        // Estimate the optimum number of times to use the argument reduction.
        len = x.d.length;
        if (len < 32) {
            k = Math.ceil(len / 3);
            y = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            y = "2.3283064365386962890625e-10";
        }
        Ctor.precision += k;
        x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
        // Reverse argument reduction
        for(var i = k; i--;){
            var cos2x = x.times(x);
            x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
        }
        Ctor.precision -= k;
        return x;
    }
    /*
   * Perform division in the specified base.
   */ var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k, base) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % base | 0;
                carry = temp / base | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, rm, dp, base) {
            var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either NaN, Infinity or 0?
            if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
            if (base) {
                logBase = 1;
                e = x.e - y.e;
            } else {
                base = BASE;
                logBase = LOG_BASE;
                e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
            }
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            // The digit array of a Decimal from toStringBinary may have trailing zeros.
            for(i = 0; yd[i] == (xd[i] || 0); i++);
            if (yd[i] > (xd[i] || 0)) e--;
            if (pr == null) {
                sd = pr = Ctor.precision;
                rm = Ctor.rounding;
            } else if (dp) sd = pr + (x.e - y.e) + 1;
            else sd = pr;
            if (sd < 0) {
                qd.push(1);
                more = true;
            } else {
                // Convert precision in number of base 10 digits to base 1e7 digits.
                sd = sd / logBase + 2 | 0;
                i = 0;
                // divisor < 1e7
                if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++;
                    // k is the carry.
                    for(; (i < xL || k) && sd--; i++){
                        t = k * base + (xd[i] || 0);
                        qd[i] = t / yd | 0;
                        k = t % yd | 0;
                    }
                    more = k || i < xL;
                // divisor >= 1e7
                } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = base / (yd[0] + 1) | 0;
                    if (k > 1) {
                        yd = multiplyInteger(yd, k, base);
                        xd = multiplyInteger(xd, k, base);
                        yL = yd.length;
                        xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL;)rem[remL++] = 0;
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                        k = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, k.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // k will be how many times the divisor goes into the current remainder.
                            k = rem0 / yd0 | 0;
                            //  Algorithm:
                            //  1. product = divisor * trial digit (k)
                            //  2. if product > remainder: product -= divisor, k--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, k++
                            if (k > 1) {
                                if (k >= base) k = base - 1;
                                // product = divisor * trial digit.
                                prod = multiplyInteger(yd, k, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                cmp = compare(prod, rem, prodL, remL);
                                // product > remainder.
                                if (cmp == 1) {
                                    k--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                                }
                            } else {
                                // cmp is -1.
                                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                                if (k == 0) cmp = k = 1;
                                prod = yd.slice();
                            }
                            prodL = prod.length;
                            if (prodL < remL) prod.unshift(0);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            // If product was < previous remainder.
                            if (cmp == -1) {
                                remL = rem.length;
                                // Compare divisor and new remainder.
                                cmp = compare(yd, rem, yL, remL);
                                // If divisor < new remainder, subtract divisor from remainder.
                                if (cmp < 1) {
                                    k++;
                                    // Subtract divisor from remainder.
                                    subtract(rem, yL < remL ? yz : yd, remL, base);
                                }
                            }
                            remL = rem.length;
                        } else if (cmp === 0) {
                            k++;
                            rem = [
                                0
                            ];
                        } // if cmp === 1, k will be 0
                        // Add the next digit, k, to the result array.
                        qd[i++] = k;
                        // Update the remainder.
                        if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                        else {
                            rem = [
                                xd[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                }
                // Leading zero?
                if (!qd[0]) qd.shift();
            }
            // logBase is 1 when divide is being used for base conversion.
            if (logBase == 1) {
                q.e = e;
                inexact = more;
            } else {
                // To calculate q.e, first get the number of digits of qd[0].
                for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
                q.e = i + e * logBase - 1;
                finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
            }
            return q;
        };
    }();
    /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */ function finalise(x, sd, rm, isTruncated) {
        var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
        // Don't round if sd is null or undefined.
        out: if (sd != null) {
            xd = x.d;
            // Infinity/NaN.
            if (!xd) return x;
            // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
            // w: the word of xd containing rd, a base 1e7 number.
            // xdi: the index of w within xd.
            // digits: the number of digits of w.
            // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
            // they had leading zeros)
            // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
            // Get the length of the first word of the digits array xd.
            for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
            i = sd - digits;
            // Is the rounding digit in the first word of xd?
            if (i < 0) {
                i += LOG_BASE;
                j = sd;
                w = xd[xdi = 0];
                // Get the rounding digit at index j of w.
                rd = w / mathpow(10, digits - j - 1) % 10 | 0;
            } else {
                xdi = Math.ceil((i + 1) / LOG_BASE);
                k = xd.length;
                if (xdi >= k) {
                    if (isTruncated) {
                        // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                        for(; k++ <= xdi;)xd.push(0);
                        w = rd = 0;
                        digits = 1;
                        i %= LOG_BASE;
                        j = i - LOG_BASE + 1;
                    } else break out;
                } else {
                    w = k = xd[xdi];
                    // Get the number of digits of w.
                    for(digits = 1; k >= 10; k /= 10)digits++;
                    // Get the index of rd within w.
                    i %= LOG_BASE;
                    // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits;
                    // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
                }
            }
            // Are there any non-zero digits after the rounding digit?
            isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
            // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
            // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
            // will give 714.
            roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
            if (sd < 1 || !xd[0]) {
                xd.length = 0;
                if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1;
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                    x.e = -sd || 0;
                } else // Zero.
                xd[0] = x.e = 0;
                return x;
            }
            // Remove excess digits.
            if (i == 0) {
                xd.length = xdi;
                k = 1;
                xdi--;
            } else {
                xd.length = xdi + 1;
                k = mathpow(10, LOG_BASE - i);
                // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                // j > 0 means i > number of leading zeros of w.
                xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
            }
            if (roundUp) {
                for(;;)// Is the digit to be rounded up in the first word of xd?
                if (xdi == 0) {
                    // i will be the length of xd[0] before k is added.
                    for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                    j = xd[0] += k;
                    for(k = 1; j >= 10; j /= 10)k++;
                    // if i != k the length has increased.
                    if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                    }
                    break;
                } else {
                    xd[xdi] += k;
                    if (xd[xdi] != BASE) break;
                    xd[xdi--] = 0;
                    k = 1;
                }
            }
            // Remove trailing zeros.
            for(i = xd.length; xd[--i] === 0;)xd.pop();
        }
        if (external) {
            // Overflow?
            if (x.e > Ctor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < Ctor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // Ctor.underflow = true;
            } // else Ctor.underflow = false;
        }
        return x;
    }
    function finiteToString(x, isExp, sd) {
        if (!x.isFinite()) return nonFiniteToString(x);
        var k, e = x.e, str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (x.e < 0 ? "e" : "e+") + x.e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return str;
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
        var w = digits[0];
        // Add the number of digits of the first word of the digits array.
        for(e *= LOG_BASE; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > LN10_PRECISION) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(precisionLimitExceeded);
        }
        return finalise(new Ctor(LN10), sd, 1, true);
    }
    function getPi(Ctor, sd, rm) {
        if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
        return finalise(new Ctor(PI), sd, rm, true);
    }
    function getPrecision(digits) {
        var w = digits.length - 1, len = w * LOG_BASE + 1;
        w = digits[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)len--;
            // Add the number of digits of the first word.
            for(w = digits[0]; w >= 10; w /= 10)len++;
        }
        return len;
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */ function intPow(Ctor, x, n, pr) {
        var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);
        external = false;
        for(;;){
            if (n % 2) {
                r = r.times(x);
                if (truncate(r.d, k)) isTruncated = true;
            }
            n = mathfloor(n / 2);
            if (n === 0) {
                // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                n = r.d.length - 1;
                if (isTruncated && r.d[n] === 0) ++r.d[n];
                break;
            }
            x = x.times(x);
            truncate(x.d, k);
        }
        external = true;
        return r;
    }
    function isOdd(n) {
        return n.d[n.d.length - 1] & 1;
    }
    /*
   * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
   */ function maxOrMin(Ctor, args, ltgt) {
        var y, x = new Ctor(args[0]), i = 0;
        for(; ++i < args.length;){
            y = new Ctor(args[i]);
            if (!y.s) {
                x = y;
                break;
            } else if (x[ltgt](y)) x = y;
        }
        return x;
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */ function naturalExponential(x, sd) {
        var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // 0/NaN/Infinity?
        if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        // while abs(x) >= 0.1
        while(x.e > -2){
            // x = x / 2^5
            x = x.times(t);
            k += 5;
        }
        // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
        // necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(1);
        Ctor.precision = wpr;
        for(;;){
            pow = finalise(pow.times(x), wpr, 1);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                j = k;
                while(j--)sum = finalise(sum.times(sum), wpr, 1);
                // Check to see if the first 4 rounding digits are [49]999.
                // If so, repeat the summation with a higher precision, otherwise
                // e.g. with precision: 18, rounding: 1
                // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += 10;
                        denominator = pow = t = new Ctor(1);
                        i = 0;
                        rep++;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
        }
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */ function naturalLogarithm(y, sd) {
        var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // Is x negative or Infinity, NaN, 0 or 1?
        if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        Ctor.precision = wpr += guard;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        if (Math.abs(e = x.e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = x.e;
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = naturalLogarithm(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? finalise(x, pr, rm, external = true) : x;
        }
        // x1 is x reduced to a value near 1.
        x1 = x;
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
        x2 = finalise(x.times(x), wpr, 1);
        denominator = 3;
        for(;;){
            numerator = finalise(numerator.times(x2), wpr, 1);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr, 1);
                // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                // been repeated previously) and the first 4 rounding digits 9999?
                // If so, restart the summation with a higher precision, otherwise
                // e.g. with precision: 12, rounding: 1
                // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += guard;
                        t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                        x2 = finalise(x.times(x), wpr, 1);
                        denominator = rep = 1;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
            denominator += 2;
        }
    }
    // ±Infinity, NaN.
    function nonFiniteToString(x) {
        // Unsigned.
        return String(x.s * x.s / 0);
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
        str = str.slice(i, len);
        if (str) {
            len -= i;
            x.e = e = e - i - 1;
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external) {
                // Overflow?
                if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN;
                // Underflow?
                } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                // x.constructor.underflow = true;
                } // else x.constructor.underflow = false;
            }
        } else {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */ function parseOther(x, str) {
        var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
        if (str.indexOf("_") > -1) {
            str = str.replace(/(\d)_(?=\d)/g, "$1");
            if (isDecimal.test(str)) return parseDecimal(x, str);
        } else if (str === "Infinity" || str === "NaN") {
            if (!+str) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return x;
        }
        if (isHex.test(str)) {
            base = 16;
            str = str.toLowerCase();
        } else if (isBinary.test(str)) base = 2;
        else if (isOctal.test(str)) base = 8;
        else throw Error(invalidArgument + str);
        // Is there a binary exponent part?
        i = str.search(/p/i);
        if (i > 0) {
            p = +str.slice(i + 1);
            str = str.substring(2, i);
        } else str = str.slice(2);
        // Convert `str` as an integer then divide the result by `base` raised to a power such that the
        // fraction part will be restored.
        i = str.indexOf(".");
        isFloat = i >= 0;
        Ctor = x.constructor;
        if (isFloat) {
            str = str.replace(".", "");
            len = str.length;
            i = len - i;
            // log[10](16) = 1.2041... , log[10](88) = 1.9444....
            divisor = intPow(Ctor, new Ctor(base), i, i * 2);
        }
        xd = convertBase(str, base, BASE);
        xe = xd.length - 1;
        // Remove trailing zeros.
        for(i = xe; xd[i] === 0; --i)xd.pop();
        if (i < 0) return new Ctor(x.s * 0);
        x.e = getBase10Exponent(xd, xe);
        x.d = xd;
        external = false;
        // At what precision to perform the division to ensure exact conversion?
        // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
        // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
        // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
        // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
        // Therefore using 4 * the number of digits of str will always be enough.
        if (isFloat) x = divide(x, divisor, len * 4);
        // Multiply by the binary exponent part if present.
        if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
        external = true;
        return x;
    }
    /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */ function sine(Ctor, x) {
        var k, len = x.d.length;
        if (len < 3) return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
        // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
        // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
        // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / tinyPow(5, k));
        x = taylorSeries(Ctor, 2, x, x);
        // Reverse argument reduction
        var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sin2_x = x.times(x);
            x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
        }
        return x;
    }
    // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
        var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
        external = false;
        x2 = x.times(x);
        u = new Ctor(y);
        for(;;){
            t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
            u = isHyperbolic ? y.plus(t) : y.minus(t);
            y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
            t = u.plus(y);
            if (t.d[k] !== void 0) {
                for(j = k; t.d[j] === u.d[j] && j--;);
                if (j == -1) break;
            }
            j = u;
            u = y;
            y = t;
            t = j;
            i++;
        }
        external = true;
        t.d.length = k + 1;
        return t;
    }
    // Exponent e must be positive and non-zero.
    function tinyPow(b, e) {
        var n = b;
        while(--e)n *= b;
        return n;
    }
    // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
        var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
        x = x.abs();
        if (x.lte(halfPi)) {
            quadrant = isNeg ? 4 : 1;
            return x;
        }
        t = x.divToInt(pi);
        if (t.isZero()) quadrant = isNeg ? 3 : 2;
        else {
            x = x.minus(t.times(pi));
            // 0 <= x < pi
            if (x.lte(halfPi)) {
                quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
                return x;
            }
            quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
        }
        return x.minus(pi).abs();
    }
    /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */ function toStringBinary(x, baseOut, sd, rm) {
        var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
        if (isExp) {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        } else {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        }
        if (!x.isFinite()) str = nonFiniteToString(x);
        else {
            str = finiteToString(x);
            i = str.indexOf(".");
            // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
            // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
            // minBinaryExponent = floor(decimalExponent * log[2](10))
            // log[2](10) = 3.321928094887362347870319429489390175864
            if (isExp) {
                base = 2;
                if (baseOut == 16) sd = sd * 4 - 3;
                else if (baseOut == 8) sd = sd * 3 - 2;
            } else base = baseOut;
            // Convert the number as an integer then divide the result by its base raised to a power such
            // that the fraction part will be restored.
            // Non-integer.
            if (i >= 0) {
                str = str.replace(".", "");
                y = new Ctor(1);
                y.e = str.length - i;
                y.d = convertBase(finiteToString(y), 10, base);
                y.e = y.d.length;
            }
            xd = convertBase(str, 10, base);
            e = len = xd.length;
            // Remove trailing zeros.
            for(; xd[--len] == 0;)xd.pop();
            if (!xd[0]) str = isExp ? "0p+0" : "0";
            else {
                if (i < 0) e--;
                else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                }
                // The rounding digit, i.e. the digit after the digit that may be rounded up.
                i = xd[sd];
                k = base / 2;
                roundUp = roundUp || xd[sd + 1] !== void 0;
                roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
                xd.length = sd;
                if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(; ++xd[--sd] > base - 1;){
                    xd[sd] = 0;
                    if (!sd) {
                        ++e;
                        xd.unshift(1);
                    }
                }
                // Determine trailing zeros.
                for(len = xd.length; !xd[len - 1]; --len);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i < len; i++)str += NUMERALS.charAt(xd[i]);
                // Add binary exponent suffix?
                if (isExp) {
                    if (len > 1) {
                        if (baseOut == 16 || baseOut == 8) {
                            i = baseOut == 16 ? 4 : 3;
                            for(--len; len % i; len++)str += "0";
                            xd = convertBase(str, base, baseOut);
                            for(len = xd.length; !xd[len - 1]; --len);
                            // xd[0] will always be be 1
                            for(i = 1, str = "1."; i < len; i++)str += NUMERALS.charAt(xd[i]);
                        } else str = str.charAt(0) + "." + str.slice(1);
                    }
                    str = str + (e < 0 ? "p" : "p+") + e;
                } else if (e < 0) {
                    for(; ++e;)str = "0" + str;
                    str = "0." + str;
                } else {
                    if (++e > len) for(e -= len; e--;)str += "0";
                    else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                }
            }
            str = (baseOut == 16 ? "0x" : baseOut == 2 ? "0b" : baseOut == 8 ? "0o" : "") + str;
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */ /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function abs(x) {
        return new this(x).abs();
    }
    /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function acos(x) {
        return new this(x).acos();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function acosh(x) {
        return new this(x).acosh();
    }
    /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function add(x, y) {
        return new this(x).plus(y);
    }
    /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function asin(x) {
        return new this(x).asin();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function asinh(x) {
        return new this(x).asinh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function atan(x) {
        return new this(x).atan();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function atanh(x) {
        return new this(x).atanh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|Decimal} The y-coordinate.
   * x {number|string|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */ function atan2(y, x) {
        y = new this(y);
        x = new this(x);
        var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
        // Either NaN
        if (!y.s || !x.s) r = new this(NaN);
        else if (!y.d && !x.d) {
            r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
            r.s = y.s;
        // x is ±Infinity or y is ±0
        } else if (!x.d || y.isZero()) {
            r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
            r.s = y.s;
        // y is ±Infinity or x is ±0
        } else if (!y.d || x.isZero()) {
            r = getPi(this, wpr, 1).times(0.5);
            r.s = y.s;
        // Both non-zero and finite
        } else if (x.s < 0) {
            this.precision = wpr;
            this.rounding = 1;
            r = this.atan(divide(y, x, wpr, 1));
            x = getPi(this, wpr, 1);
            this.precision = pr;
            this.rounding = rm;
            r = y.s < 0 ? r.minus(x) : r.plus(x);
        } else r = this.atan(divide(y, x, wpr, 1));
        return r;
    }
    /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function cbrt(x) {
        return new this(x).cbrt();
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|Decimal}
   *
   */ function ceil(x) {
        return finalise(x = new this(x), x.e + 1, 2);
    }
    /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|Decimal}
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ function clamp(x, min, max) {
        return new this(x).clamp(min, max);
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, useDefaults = obj.defaults === true, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -EXP_LIMIT,
            0,
            "toExpPos",
            0,
            EXP_LIMIT,
            "maxE",
            0,
            EXP_LIMIT,
            "minE",
            -EXP_LIMIT,
            0,
            "modulo",
            0,
            9
        ];
        for(i = 0; i < ps.length; i += 3){
            if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
            if ((v = obj[p]) !== void 0) {
                if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
                else throw Error(invalidArgument + p + ": " + v);
            }
        }
        if (p = "crypto", useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if (v === true || v === false || v === 0 || v === 1) {
                if (v) {
                    if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                    else throw Error(cryptoUnavailable);
                } else this[p] = false;
            } else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cos(x) {
        return new this(x).cos();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cosh(x) {
        return new this(x).cosh();
    }
    /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|Decimal} A numeric value.
     *
     */ function Decimal(v) {
            var e, i, t, x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(v);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (isDecimalInstance(v)) {
                x.s = v.s;
                if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                        // Infinity.
                        x.e = NaN;
                        x.d = null;
                    } else if (v.e < Decimal.minE) {
                        // Zero.
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = v.e;
                        x.d = v.d.slice();
                    }
                } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                }
                return;
            }
            t = typeof v;
            if (t === "number") {
                if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                // Fast path for small integers.
                if (v === ~~v && v < 1e7) {
                    for(e = 0, i = v; i >= 10; i /= 10)e++;
                    if (external) {
                        if (e > Decimal.maxE) {
                            x.e = NaN;
                            x.d = null;
                        } else if (e < Decimal.minE) {
                            x.e = 0;
                            x.d = [
                                0
                            ];
                        } else {
                            x.e = e;
                            x.d = [
                                v
                            ];
                        }
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                    return;
                // Infinity, NaN.
                } else if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                }
                return parseDecimal(x, v.toString());
            } else if (t !== "string") throw Error(invalidArgument + v);
            // Minus sign?
            if ((i = v.charCodeAt(0)) === 45) {
                v = v.slice(1);
                x.s = -1;
            } else {
                // Plus sign?
                if (i === 43) v = v.slice(1);
                x.s = 1;
            }
            return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.EUCLID = 9;
        Decimal.config = Decimal.set = config;
        Decimal.clone = clone;
        Decimal.isDecimal = isDecimalInstance;
        Decimal.abs = abs;
        Decimal.acos = acos;
        Decimal.acosh = acosh; // ES6
        Decimal.add = add;
        Decimal.asin = asin;
        Decimal.asinh = asinh; // ES6
        Decimal.atan = atan;
        Decimal.atanh = atanh; // ES6
        Decimal.atan2 = atan2;
        Decimal.cbrt = cbrt; // ES6
        Decimal.ceil = ceil;
        Decimal.clamp = clamp;
        Decimal.cos = cos;
        Decimal.cosh = cosh; // ES6
        Decimal.div = div;
        Decimal.exp = exp;
        Decimal.floor = floor;
        Decimal.hypot = hypot; // ES6
        Decimal.ln = ln;
        Decimal.log = log;
        Decimal.log10 = log10; // ES6
        Decimal.log2 = log2; // ES6
        Decimal.max = max;
        Decimal.min = min;
        Decimal.mod = mod;
        Decimal.mul = mul;
        Decimal.pow = pow;
        Decimal.random = random;
        Decimal.round = round;
        Decimal.sign = sign; // ES6
        Decimal.sin = sin;
        Decimal.sinh = sinh; // ES6
        Decimal.sqrt = sqrt;
        Decimal.sub = sub;
        Decimal.sum = sum;
        Decimal.tan = tan;
        Decimal.tanh = tanh; // ES6
        Decimal.trunc = trunc; // ES6
        if (obj === void 0) obj = {};
        if (obj) {
            if (obj.defaults !== true) {
                ps = [
                    "precision",
                    "rounding",
                    "toExpNeg",
                    "toExpPos",
                    "maxE",
                    "minE",
                    "modulo",
                    "crypto"
                ];
                for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
            }
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function div(x, y) {
        return new this(x).div(y);
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The power to which to raise the base of the natural log.
   *
   */ function exp(x) {
        return new this(x).exp();
    }
    /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|Decimal}
   *
   */ function floor(x) {
        return finalise(x = new this(x), x.e + 1, 3);
    }
    /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|Decimal}
   *
   */ function hypot() {
        var i, n, t = new this(0);
        external = false;
        for(i = 0; i < arguments.length;){
            n = new this(arguments[i++]);
            if (!n.d) {
                if (n.s) {
                    external = true;
                    return new this(1 / 0);
                }
                t = n;
            } else if (t.d) t = t.plus(n.times(n));
        }
        external = true;
        return t.sqrt();
    }
    /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */ function isDecimalInstance(obj) {
        return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function ln(x) {
        return new this(x).ln();
    }
    /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|Decimal} The argument of the logarithm.
   * y {number|string|Decimal} The base of the logarithm.
   *
   */ function log(x, y) {
        return new this(x).log(y);
    }
    /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log2(x) {
        return new this(x).log(2);
    }
    /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log10(x) {
        return new this(x).log(10);
    }
    /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function max() {
        return maxOrMin(this, arguments, "lt");
    }
    /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function min() {
        return maxOrMin(this, arguments, "gt");
    }
    /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mod(x, y) {
        return new this(x).mod(y);
    }
    /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mul(x, y) {
        return new this(x).mul(y);
    }
    /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The base.
   * y {number|string|Decimal} The exponent.
   *
   */ function pow(x, y) {
        return new this(x).pow(y);
    }
    /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */ function random(sd) {
        var d, e, k, n, i = 0, r = new this(1), rd = [];
        if (sd === void 0) sd = this.precision;
        else checkInt32(sd, 1, MAX_DIGITS);
        k = Math.ceil(sd / LOG_BASE);
        if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
        else if (crypto.getRandomValues) {
            d = crypto.getRandomValues(new Uint32Array(k));
            for(; i < k;){
                n = d[i];
                // 0 <= n < 4294967296
                // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                else // 0 <= n <= 4289999999
                // 0 <= (n % 1e7) <= 9999999
                rd[i++] = n % 1e7;
            }
        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {
            // buffer
            d = crypto.randomBytes(k *= 4);
            for(; i < k;){
                // 0 <= n < 2147483648
                n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
                // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
                else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                }
            }
            i = k / 4;
        } else throw Error(cryptoUnavailable);
        k = rd[--i];
        sd %= LOG_BASE;
        // Convert trailing digits to zeros according to sd.
        if (k && sd) {
            n = mathpow(10, LOG_BASE - sd);
            rd[i] = (k / n | 0) * n;
        }
        // Remove trailing words which are zero.
        for(; rd[i] === 0; i--)rd.pop();
        // Zero?
        if (i < 0) {
            e = 0;
            rd = [
                0
            ];
        } else {
            e = -1;
            // Remove leading words which are zero and adjust exponent accordingly.
            for(; rd[0] === 0; e -= LOG_BASE)rd.shift();
            // Count the digits of the first word of rd to determine leading zeros.
            for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
            // Adjust the exponent for leading zeros of the first word of rd.
            if (k < LOG_BASE) e -= LOG_BASE - k;
        }
        r.e = e;
        r.d = rd;
        return r;
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|Decimal}
   *
   */ function round(x) {
        return finalise(x = new this(x), x.e + 1, this.rounding);
    }
    /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|Decimal}
   *
   */ function sign(x) {
        x = new this(x);
        return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
    }
    /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sin(x) {
        return new this(x).sin();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sinh(x) {
        return new this(x).sinh();
    }
    /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function sqrt(x) {
        return new this(x).sqrt();
    }
    /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function sub(x, y) {
        return new this(x).sub(y);
    }
    /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|Decimal}
   *
   */ function sum() {
        var i = 0, args = arguments, x = new this(args[i]);
        external = false;
        for(; x.s && ++i < args.length;)x = x.plus(args[i]);
        external = true;
        return finalise(x, this.precision, this.rounding);
    }
    /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tan(x) {
        return new this(x).tan();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tanh(x) {
        return new this(x).tanh();
    }
    /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|Decimal}
   *
   */ function trunc(x) {
        return finalise(x = new this(x), x.e + 1, 1);
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);
    Decimal.prototype.constructor = Decimal;
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $22467ec447bdc2ca$exports) {
        if (typeof Symbol == "function" && typeof Symbol.iterator == "symbol") {
            P[Symbol["for"]("nodejs.util.inspect.custom")] = P.toString;
            P[Symbol.toStringTag] = "Decimal";
        }
        $22467ec447bdc2ca$exports = Decimal;
    // Browser.
    } else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : window;
        noConflict = globalScope.Decimal;
        Decimal.noConflict = function() {
            globalScope.Decimal = noConflict;
            return Decimal;
        };
        globalScope.Decimal = Decimal;
    }
})($22467ec447bdc2ca$exports);



var $14d0db6ed7dee273$var$name = "BigNumber";
var $14d0db6ed7dee273$var$dependencies = [
    "?on",
    "config"
];
var $14d0db6ed7dee273$export$234de8d4231bfea3 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($14d0db6ed7dee273$var$name, $14d0db6ed7dee273$var$dependencies, (_ref)=>{
    var { on: on, config: config } = _ref;
    var BigNumber = (0, (/*@__PURE__*/$parcel$interopDefault($22467ec447bdc2ca$exports))).clone({
        precision: config.precision,
        modulo: (0, (/*@__PURE__*/$parcel$interopDefault($22467ec447bdc2ca$exports))).EUCLID
    });
    BigNumber.prototype = Object.create(BigNumber.prototype);
    /**
   * Attach type information
   */ BigNumber.prototype.type = "BigNumber";
    BigNumber.prototype.isBigNumber = true;
    /**
   * Get a JSON representation of a BigNumber containing
   * type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "BigNumber", "value": "0.2"}`
   */ BigNumber.prototype.toJSON = function() {
        return {
            mathjs: "BigNumber",
            value: this.toString()
        };
    };
    /**
   * Instantiate a BigNumber from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "BigNumber", "value": "0.2"}`
   * @return {BigNumber}
   */ BigNumber.fromJSON = function(json) {
        return new BigNumber(json.value);
    };
    if (on) // listen for changed in the configuration, automatically apply changed precision
    on("config", function(curr, prev) {
        if (curr.precision !== prev.precision) BigNumber.config({
            precision: curr.precision
        });
    });
    return BigNumber;
}, {
    isClass: true
});


var $82fe4e81579d6b46$var$name = "bin";
var $82fe4e81579d6b46$var$dependencies = [
    "typed",
    "format"
];
var $82fe4e81579d6b46$export$a770ddfd7e536064 = (0, $a671619231063c2b$export$e9008f2713103c6c)($82fe4e81579d6b46$var$name, $82fe4e81579d6b46$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($82fe4e81579d6b46$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            return format(n, {
                notation: "bin"
            });
        },
        "number | BigNumber, number": function numberBigNumberNumber(n, wordSize) {
            return format(n, {
                notation: "bin",
                wordSize: wordSize
            });
        }
    });
});

/**
 * Bitwise and for Bignumbers
 *
 * Special Cases:
 *   N &  n =  N
 *   n &  0 =  0
 *   n & -1 =  n
 *   n &  n =  n
 *   I &  I =  I
 *  -I & -I = -I
 *   I & -I =  0
 *   I &  n =  n
 *   I & -n =  I
 *  -I &  n =  0
 *  -I & -n = -I
 *
 * @param {BigNumber} x
 * @param {BigNumber} y
 * @return {BigNumber} Result of `x` & `y`, is fully precise
 * @private
 */ function $ac43c9464ecff9bd$export$94757ce5cf54fec9(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitAnd");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero() || y.eq(-1) || x.eq(y)) return x;
    if (y.isZero() || x.eq(-1)) return y;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) {
            if (x.isNegative() === y.isNegative()) return x;
            return new BigNumber(0);
        }
        if (!x.isFinite()) {
            if (y.isNegative()) return x;
            if (x.isNegative()) return new BigNumber(0);
            return y;
        }
        if (!y.isFinite()) {
            if (x.isNegative()) return y;
            if (y.isNegative()) return new BigNumber(0);
            return x;
        }
    }
    return $ac43c9464ecff9bd$export$884842863a0853c4(x, y, function(a, b) {
        return a & b;
    });
}
function $ac43c9464ecff9bd$export$2ada53b3c51e9645(x) {
    if (x.isFinite() && !x.isInteger()) throw new Error("Integer expected in function bitNot");
    var BigNumber = x.constructor;
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    var result = x.plus(new BigNumber(1));
    result.s = -result.s || null;
    BigNumber.config({
        precision: prevPrec
    });
    return result;
}
function $ac43c9464ecff9bd$export$e43ec6c4cff46d2c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitOr");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    var negOne = new BigNumber(-1);
    if (x.isZero() || y.eq(negOne) || x.eq(y)) return y;
    if (y.isZero() || x.eq(negOne)) return x;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !x.isNegative() && y.isNegative() || x.isNegative() && !y.isNegative() && !y.isFinite()) return negOne;
        if (x.isNegative() && y.isNegative()) return x.isFinite() ? x : y;
        return x.isFinite() ? y : x;
    }
    return $ac43c9464ecff9bd$export$884842863a0853c4(x, y, function(a, b) {
        return a | b;
    });
}
function $ac43c9464ecff9bd$export$884842863a0853c4(x, y, func) {
    var BigNumber = x.constructor;
    var xBits, yBits;
    var xSign = +(x.s < 0);
    var ySign = +(y.s < 0);
    if (xSign) {
        xBits = $ac43c9464ecff9bd$var$decCoefficientToBinaryString($ac43c9464ecff9bd$export$2ada53b3c51e9645(x));
        for(var i = 0; i < xBits.length; ++i)xBits[i] ^= 1;
    } else xBits = $ac43c9464ecff9bd$var$decCoefficientToBinaryString(x);
    if (ySign) {
        yBits = $ac43c9464ecff9bd$var$decCoefficientToBinaryString($ac43c9464ecff9bd$export$2ada53b3c51e9645(y));
        for(var _i = 0; _i < yBits.length; ++_i)yBits[_i] ^= 1;
    } else yBits = $ac43c9464ecff9bd$var$decCoefficientToBinaryString(y);
    var minBits, maxBits, minSign;
    if (xBits.length <= yBits.length) {
        minBits = xBits;
        maxBits = yBits;
        minSign = xSign;
    } else {
        minBits = yBits;
        maxBits = xBits;
        minSign = ySign;
    }
    var shortLen = minBits.length;
    var longLen = maxBits.length;
    var expFuncVal = func(xSign, ySign) ^ 1;
    var outVal = new BigNumber(expFuncVal ^ 1);
    var twoPower = new BigNumber(1);
    var two = new BigNumber(2);
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    while(shortLen > 0){
        if (func(minBits[--shortLen], maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    while(longLen > 0){
        if (func(minSign, maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    BigNumber.config({
        precision: prevPrec
    });
    if (expFuncVal === 0) outVal.s = -outVal.s;
    return outVal;
}
/* Extracted from decimal.js, and edited to specialize. */ function $ac43c9464ecff9bd$var$decCoefficientToBinaryString(x) {
    // Convert to string
    var a = x.d; // array with digits
    var r = a[0] + "";
    for(var i = 1; i < a.length; ++i){
        var s = a[i] + "";
        for(var z = 7 - s.length; z--;)s = "0" + s;
        r += s;
    }
    var j = r.length;
    while(r.charAt(j) === "0")j--;
    var xe = x.e;
    var str = r.slice(0, j + 1 || 1);
    var strL = str.length;
    if (xe > 0) {
        if (++xe > strL) {
            // Append zeros.
            xe -= strL;
            while(xe--)str += "0";
        } else if (xe < strL) str = str.slice(0, xe) + "." + str.slice(xe);
    } // Convert from base 10 (decimal) to base 2
    var arr = [
        0
    ];
    for(var _i2 = 0; _i2 < str.length;){
        var arrL = arr.length;
        while(arrL--)arr[arrL] *= 10;
        arr[0] += parseInt(str.charAt(_i2++)); // convert to int
        for(var _j = 0; _j < arr.length; ++_j)if (arr[_j] > 1) {
            if (arr[_j + 1] === null || arr[_j + 1] === undefined) arr[_j + 1] = 0;
            arr[_j + 1] += arr[_j] >> 1;
            arr[_j] &= 1;
        }
    }
    return arr.reverse();
}
function $ac43c9464ecff9bd$export$bfcff4501301c191(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitXor");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero()) return y;
    if (y.isZero()) return x;
    if (x.eq(y)) return new BigNumber(0);
    var negOne = new BigNumber(-1);
    if (x.eq(negOne)) return $ac43c9464ecff9bd$export$2ada53b3c51e9645(y);
    if (y.eq(negOne)) return $ac43c9464ecff9bd$export$2ada53b3c51e9645(x);
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) return negOne;
        return new BigNumber(x.isNegative() === y.isNegative() ? Infinity : -Infinity);
    }
    return $ac43c9464ecff9bd$export$884842863a0853c4(x, y, function(a, b) {
        return a ^ b;
    });
}
function $ac43c9464ecff9bd$export$626dff8098a67b4c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function leftShift");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!x.isFinite() && !y.isFinite()) return new BigNumber(NaN);
     // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.times(Math.pow(2, y.toNumber()) + "");
    return x.times(new BigNumber(2).pow(y));
}
function $ac43c9464ecff9bd$export$d489c03691bd4cd(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function rightArithShift");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!y.isFinite()) {
        if (x.isNegative()) return new BigNumber(-1);
        if (!x.isFinite()) return new BigNumber(NaN);
        return new BigNumber(0);
    } // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.div(Math.pow(2, y.toNumber()) + "").floor();
    return x.div(new BigNumber(2).pow(y)).floor();
}









var $8ed95b606c7043f9$var$n1 = "number";
var $8ed95b606c7043f9$var$n2 = "number, number";
function $8ed95b606c7043f9$export$e7607930867bd49a(x, y) {
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(x) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function bitAnd");
    return x & y;
}
$8ed95b606c7043f9$export$e7607930867bd49a.signature = $8ed95b606c7043f9$var$n2;
function $8ed95b606c7043f9$export$22a2b2a0351218e7(x) {
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(x)) throw new Error("Integer expected in function bitNot");
    return ~x;
}
$8ed95b606c7043f9$export$22a2b2a0351218e7.signature = $8ed95b606c7043f9$var$n1;
function $8ed95b606c7043f9$export$9aecb772cb5ad1c7(x, y) {
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(x) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function bitOr");
    return x | y;
}
$8ed95b606c7043f9$export$9aecb772cb5ad1c7.signature = $8ed95b606c7043f9$var$n2;
function $8ed95b606c7043f9$export$2260a44ec1c987dc(x, y) {
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(x) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function bitXor");
    return x ^ y;
}
$8ed95b606c7043f9$export$2260a44ec1c987dc.signature = $8ed95b606c7043f9$var$n2;
function $8ed95b606c7043f9$export$65c07a47901525ba(x, y) {
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(x) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function leftShift");
    return x << y;
}
$8ed95b606c7043f9$export$65c07a47901525ba.signature = $8ed95b606c7043f9$var$n2;
function $8ed95b606c7043f9$export$b6d96f775be90000(x, y) {
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(x) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function rightArithShift");
    return x >> y;
}
$8ed95b606c7043f9$export$b6d96f775be90000.signature = $8ed95b606c7043f9$var$n2;
function $8ed95b606c7043f9$export$2a8d1e3dcede6e47(x, y) {
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(x) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function rightLogShift");
    return x >>> y;
}
$8ed95b606c7043f9$export$2a8d1e3dcede6e47.signature = $8ed95b606c7043f9$var$n2;


var $0eb069adb3ca2bbc$var$name = "bitAnd";
var $0eb069adb3ca2bbc$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar"
];
var $0eb069adb3ca2bbc$export$bea4e06c5befec3b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($0eb069adb3ca2bbc$var$name, $0eb069adb3ca2bbc$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar } = _ref;
    var algorithm02 = (0, $b6b1cd490ad9f946$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $dcf47e3db09976d1$export$d6f401e6f2a7e54b)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise AND two values, `x & y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitAnd(x, y)
   *
   * Examples:
   *
   *    math.bitAnd(53, 131)               // returns number 1
   *
   *    math.bitAnd([1, 12, 31], 42)       // returns Array [0, 8, 10]
   *
   * See also:
   *
   *    bitNot, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to and
   * @param  {number | BigNumber | Array | Matrix} y Second value to and
   * @return {number | BigNumber | Array | Matrix} AND of `x` and `y`
   */ return typed($0eb069adb3ca2bbc$var$name, {
        "number, number": (0, $8ed95b606c7043f9$export$e7607930867bd49a),
        "BigNumber, BigNumber": (0, $ac43c9464ecff9bd$export$94757ce5cf54fec9),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});





var $02a92c0d0a799d87$var$name = "bitNot";
var $02a92c0d0a799d87$var$dependencies = [
    "typed"
];
var $02a92c0d0a799d87$export$9e7f3c72ca8b5aa = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($02a92c0d0a799d87$var$name, $02a92c0d0a799d87$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Bitwise NOT value, `~x`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.bitNot(x)
   *
   * Examples:
   *
   *    math.bitNot(1)               // returns number -2
   *
   *    math.bitNot([2, -3, 4])      // returns Array [-3, 2, 5]
   *
   * See also:
   *
   *    bitAnd, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to not
   * @return {number | BigNumber | Array | Matrix} NOT of `x`
   */ return typed($02a92c0d0a799d87$var$name, {
        number: (0, $8ed95b606c7043f9$export$22a2b2a0351218e7),
        BigNumber: (0, $ac43c9464ecff9bd$export$2ada53b3c51e9645),
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});









var $bcc20db561cde5a8$var$name = "bitOr";
var $bcc20db561cde5a8$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $bcc20db561cde5a8$export$f45a7846535e9b07 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($bcc20db561cde5a8$var$name, $bcc20db561cde5a8$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $3feaf9e0b000398a$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm04 = (0, $fd20a4b8c10d9754$export$898ea3bef50d41b7)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $e9da21a7968d7093$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise OR two values, `x | y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the lowest print base.
   *
   * Syntax:
   *
   *    math.bitOr(x, y)
   *
   * Examples:
   *
   *    math.bitOr(1, 2)               // returns number 3
   *
   *    math.bitOr([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to or
   * @param  {number | BigNumber | Array | Matrix} y Second value to or
   * @return {number | BigNumber | Array | Matrix} OR of `x` and `y`
   */ return typed($bcc20db561cde5a8$var$name, {
        "number, number": (0, $8ed95b606c7043f9$export$9aecb772cb5ad1c7),
        "BigNumber, BigNumber": (0, $ac43c9464ecff9bd$export$e43ec6c4cff46d2c),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});





var $49703efd2d98c69c$var$name = "algorithm07";
var $49703efd2d98c69c$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $49703efd2d98c69c$export$b908fb77c4366999 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($49703efd2d98c69c$var$name, $49703efd2d98c69c$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B items (zero and nonzero) and invokes the callback function f(Aij, Bij).
   * Callback function invoked MxN times.
   *
   * C(i,j) = f(Aij, Bij)
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm07(a, b, callback) {
        // sparse matrix arrays
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // vars
        var i, j; // result arrays
        var cdata = []; // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
         // workspaces
        var xa = [];
        var xb = []; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // loop columns
        for(j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // scatter the values of A(:,j) into workspace
            _scatter(a, j, wa, xa, mark); // scatter the values of B(:,j) into workspace
            _scatter(b, j, wb, xb, mark); // loop rows
            for(i = 0; i < rows; i++){
                // matrix values @ i,j
                var va = wa[i] === mark ? xa[i] : zero;
                var vb = wb[i] === mark ? xb[i] : zero; // invoke callback
                cdata[i][j] = cf(va, vb);
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
    function _scatter(m, j, w, x, mark) {
        // a arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // loop values in column j
        for(var k = ptr[j], k1 = ptr[j + 1]; k < k1; k++){
            // row
            var i = index[k]; // update workspace
            w[i] = mark;
            x[i] = values[k];
        }
    }
});







var $1a25f56a5dfc1822$var$name = "bitXor";
var $1a25f56a5dfc1822$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix"
];
var $1a25f56a5dfc1822$export$1cae728fa8e01928 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1a25f56a5dfc1822$var$name, $1a25f56a5dfc1822$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $49703efd2d98c69c$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise XOR two values, `x ^ y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitXor(x, y)
   *
   * Examples:
   *
   *    math.bitXor(1, 2)               // returns number 3
   *
   *    math.bitXor([2, 3, 4], 4)       // returns Array [6, 7, 0]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to xor
   * @param  {number | BigNumber | Array | Matrix} y Second value to xor
   * @return {number | BigNumber | Array | Matrix} XOR of `x` and `y`
   */ return typed($1a25f56a5dfc1822$var$name, {
        "number, number": (0, $8ed95b606c7043f9$export$2260a44ec1c987dc),
        "BigNumber, BigNumber": (0, $ac43c9464ecff9bd$export$bfcff4501301c191),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});



var $41c3c4abe68f69b8$var$name = "boolean";
var $41c3c4abe68f69b8$var$dependencies = [
    "typed"
];
var $41c3c4abe68f69b8$export$3c82aec2d86a5525 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($41c3c4abe68f69b8$var$name, $41c3c4abe68f69b8$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a boolean or convert a string or number to a boolean.
   * In case of a number, `true` is returned for non-zero numbers, and `false` in
   * case of zero.
   * Strings can be `'true'` or `'false'`, or can contain a number.
   * When value is a matrix, all elements will be converted to boolean.
   *
   * Syntax:
   *
   *    math.boolean(x)
   *
   * Examples:
   *
   *    math.boolean(0)     // returns false
   *    math.boolean(1)     // returns true
   *    math.boolean(-3)     // returns true
   *    math.boolean('true')     // returns true
   *    math.boolean('false')     // returns false
   *    math.boolean([1, 0, 1, 1])     // returns [true, false, true, true]
   *
   * See also:
   *
   *    bignumber, complex, index, matrix, string, unit
   *
   * @param {string | number | boolean | Array | Matrix | null} value  A value of any type
   * @return {boolean | Array | Matrix} The boolean value
   */ return typed($41c3c4abe68f69b8$var$name, {
        "": function _() {
            return false;
        },
        boolean: function boolean(x) {
            return x;
        },
        number: function number(x) {
            return !!x;
        },
        null: function _null(x) {
            return false;
        },
        BigNumber: function BigNumber(x) {
            return !x.isZero();
        },
        string: function string(x) {
            // try case insensitive
            var lcase = x.toLowerCase();
            if (lcase === "true") return true;
            else if (lcase === "false") return false;
             // test whether value is a valid number
            var num = Number(x);
            if (x !== "" && !isNaN(num)) return !!num;
            throw new Error('Cannot convert "' + x + '" to a boolean');
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});


var $6f641cd1741589d4$var$name = "catalan";
var $6f641cd1741589d4$var$dependencies = [
    "typed",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "combinations",
    "isNegative",
    "isInteger"
];
var $6f641cd1741589d4$export$5a3f7692f3d4dd50 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($6f641cd1741589d4$var$name, $6f641cd1741589d4$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, combinations: combinations, isNegative: isNegative, isInteger: isInteger } = _ref;
    /**
   * The Catalan Numbers enumerate combinatorial structures of many different types.
   * catalan only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.catalan(n)
   *
   * Examples:
   *
   *    math.catalan(3) // returns 5
   *    math.catalan(8) // returns 1430
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    nth Catalan number
   * @return {Number | BigNumber}     Cn(n)
   */ return typed($6f641cd1741589d4$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError("Non-negative integer value expected in function catalan");
            return divideScalar(combinations(multiplyScalar(n, 2), n), addScalar(n, 1));
        }
    });
});





var $e70bdb67e3f771ce$var$name = "cbrt";
var $e70bdb67e3f771ce$var$dependencies = [
    "config",
    "typed",
    "isNegative",
    "unaryMinus",
    "matrix",
    "Complex",
    "BigNumber",
    "Fraction"
];
var $e70bdb67e3f771ce$export$2103fed9c34b0004 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e70bdb67e3f771ce$var$name, $e70bdb67e3f771ce$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, isNegative: isNegative, unaryMinus: unaryMinus, matrix: matrix, Complex: Complex, BigNumber: BigNumber, Fraction: Fraction } = _ref;
    /**
   * Calculate the cubic root of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cbrt(x)
   *    math.cbrt(x, allRoots)
   *
   * Examples:
   *
   *    math.cbrt(27)                  // returns 3
   *    math.cube(3)                   // returns 27
   *    math.cbrt(-64)                 // returns -4
   *    math.cbrt(math.unit('27 m^3')) // returns Unit 3 m
   *    math.cbrt([27, 64, 125])       // returns [3, 4, 5]
   *
   *    const x = math.complex('8i')
   *    math.cbrt(x)                   // returns Complex 1.7320508075689 + i
   *    math.cbrt(x, true)             // returns Matrix [
   *                                    //    1.7320508075689 + i
   *                                    //   -1.7320508075689 + i
   *                                    //   -2i
   *                                    // ]
   *
   * See also:
   *
   *    square, sqrt, cube
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x
   *            Value for which to calculate the cubic root.
   * @param {boolean} [allRoots]  Optional, false by default. Only applicable
   *            when `x` is a number or complex number. If true, all complex
   *            roots are returned, if false (default) the principal root is
   *            returned.
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}
   *            Returns the cubic root of `x`
   */ return typed($e70bdb67e3f771ce$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$95c2aecb85f70726),
        // note: signature 'number, boolean' is also supported,
        //       created by typed as it knows how to convert number to Complex
        Complex: _cbrtComplex,
        "Complex, boolean": _cbrtComplex,
        BigNumber: function BigNumber(x) {
            return x.cbrt();
        },
        Unit: _cbrtUnit,
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since cbrt(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
    /**
   * Calculate the cubic root for a complex number
   * @param {Complex} x
   * @param {boolean} [allRoots]   If true, the function will return an array
   *                               with all three roots. If false or undefined,
   *                               the principal root is returned.
   * @returns {Complex | Array.<Complex> | Matrix.<Complex>} Returns the cubic root(s) of x
   * @private
   */ function _cbrtComplex(x, allRoots) {
        // https://www.wikiwand.com/en/Cube_root#/Complex_numbers
        var arg3 = x.arg() / 3;
        var abs = x.abs(); // principal root:
        var principal = new Complex((0, $08ae6b2eb4bd0049$export$95c2aecb85f70726)(abs), 0).mul(new Complex(0, arg3).exp());
        if (allRoots) {
            var all = [
                principal,
                new Complex((0, $08ae6b2eb4bd0049$export$95c2aecb85f70726)(abs), 0).mul(new Complex(0, arg3 + Math.PI * 2 / 3).exp()),
                new Complex((0, $08ae6b2eb4bd0049$export$95c2aecb85f70726)(abs), 0).mul(new Complex(0, arg3 - Math.PI * 2 / 3).exp())
            ];
            return config.matrix === "Array" ? all : matrix(all);
        } else return principal;
    }
    /**
   * Calculate the cubic root for a Unit
   * @param {Unit} x
   * @return {Unit} Returns the cubic root of x
   * @private
   */ function _cbrtUnit(x) {
        if (x.value && (0, $2c4f948f17aa2240$export$8849a896711efe0c)(x.value)) {
            var result = x.clone();
            result.value = 1.0;
            result = result.pow(1.0 / 3); // Compute the units
            result.value = _cbrtComplex(x.value); // Compute the value
            return result;
        } else {
            var negate = isNegative(x.value);
            if (negate) x.value = unaryMinus(x.value);
             // TODO: create a helper function for this
            var third;
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(x.value)) third = new BigNumber(1).div(3);
            else if ((0, $2c4f948f17aa2240$export$e312cb8a8e5e7c34)(x.value)) third = new Fraction(1, 3);
            else third = 1 / 3;
            var _result = x.pow(third);
            if (negate) _result.value = unaryMinus(_result.value);
            return _result;
        }
    }
});





/**
 * Compares two BigNumbers.
 * @param {BigNumber} x       First value to compare
 * @param {BigNumber} y       Second value to compare
 * @param {number} [epsilon]  The maximum relative difference between x and y
 *                            If epsilon is undefined or null, the function will
 *                            test whether x and y are exactly equal.
 * @return {boolean} whether the two numbers are nearly equal
 */ function $cea3608675fc8eba$export$6f3989c6ecc04081(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon === null || epsilon === undefined) return x.eq(y);
     // use "==" operator, handles infinities
    if (x.eq(y)) return true;
     // NaN
    if (x.isNaN() || y.isNaN()) return false;
     // at this point x and y should be finite
    if (x.isFinite() && y.isFinite()) {
        // check numbers are very close, needed when comparing numbers near zero
        var diff = x.minus(y).abs();
        if (diff.isZero()) return true;
        else {
            // use relative error
            var max = x.constructor.max(x.abs(), y.abs());
            return diff.lte(max.times(epsilon));
        }
    } // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
}





var $4a2f381b6ba30e6c$var$name = "ceil";
var $4a2f381b6ba30e6c$var$dependencies = [
    "typed",
    "config",
    "round",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $4a2f381b6ba30e6c$export$7f32b339ed8a324b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($4a2f381b6ba30e6c$var$name, [
    "typed",
    "config",
    "round"
], (_ref)=>{
    var { typed: typed, config: config, round: round } = _ref;
    return typed($4a2f381b6ba30e6c$var$name, {
        number: function number(x) {
            if ((0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, round(x), config.epsilon)) return round(x);
            else return Math.ceil(x);
        },
        "number, number": function numberNumber(x, n) {
            if ((0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, round(x, n), config.epsilon)) return round(x, n);
            else {
                var [number, exponent] = "".concat(x, "e").split("e");
                var result = Math.ceil(Number("".concat(number, "e").concat(Number(exponent) + n)));
                [number, exponent] = "".concat(result, "e").split("e");
                return Number("".concat(number, "e").concat(Number(exponent) - n));
            }
        }
    });
});
var $4a2f381b6ba30e6c$export$bab247d909829ddf = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($4a2f381b6ba30e6c$var$name, $4a2f381b6ba30e6c$var$dependencies, (_ref2)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    var ceilNumber = $4a2f381b6ba30e6c$export$7f32b339ed8a324b({
        typed: typed,
        config: config,
        round: round
    });
    /**
   * Round a value towards plus infinity
   * If `x` is complex, both real and imaginary part are rounded towards plus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.ceil(x)
   *    math.ceil(x, n)
   *
   * Examples:
   *
   *    math.ceil(3.2)               // returns number 4
   *    math.ceil(3.8)               // returns number 4
   *    math.ceil(-4.2)              // returns number -4
   *    math.ceil(-4.7)              // returns number -4
   *
   *    math.ceil(3.212, 2)          // returns number 3.22
   *    math.ceil(3.288, 2)          // returns number 3.29
   *    math.ceil(-4.212, 2)         // returns number -4.21
   *    math.ceil(-4.782, 2)         // returns number -4.78
   *
   *    const c = math.complex(3.24, -2.71)
   *    math.ceil(c)                 // returns Complex 4 - 2i
   *    math.ceil(c, 1)              // returns Complex 3.3 - 2.7i
   *
   *    math.ceil([3.2, 3.8, -4.7])  // returns Array [4, 4, -4]
   *    math.ceil([3.21, 3.82, -4.71], 1)  // returns Array [3.3, 3.9, -4.7]
   *
   * See also:
   *
   *    floor, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed("ceil", {
        number: ceilNumber.signatures.number,
        "number,number": ceilNumber.signatures["number,number"],
        Complex: function Complex(x) {
            return x.ceil();
        },
        "Complex, number": function ComplexNumber(x, n) {
            return x.ceil(n);
        },
        "Complex, BigNumber": function ComplexBigNumber(x, n) {
            return x.ceil(n.toNumber());
        },
        BigNumber: function BigNumber(x) {
            if ((0, $cea3608675fc8eba$export$6f3989c6ecc04081)(x, round(x), config.epsilon)) return round(x);
            else return x.ceil();
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, n) {
            if ((0, $cea3608675fc8eba$export$6f3989c6ecc04081)(x, round(x, n), config.epsilon)) return round(x, n);
            else return x.toDecimalPlaces(n.toNumber(), (0, (/*@__PURE__*/$parcel$interopDefault($22467ec447bdc2ca$exports))).ROUND_CEIL);
        },
        Fraction: function Fraction(x) {
            return x.ceil();
        },
        "Fraction, number": function FractionNumber(x, n) {
            return x.ceil(n);
        },
        "Fraction, BigNumber": function FractionBigNumber(x, n) {
            return x.ceil(n.toNumber());
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since ceil(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, n) {
            // deep map collection, skip zeros since ceil(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, (i)=>this(i, n), true);
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | Complex | Fraction | BigNumber, Array": function numberComplexFractionBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        "number | Complex | Fraction | BigNumber, Matrix": function numberComplexFractionBigNumberMatrix(x, y) {
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            if (y.storage() === "dense") return algorithm14(y, x, this, true);
            return algorithm12(y, x, this, true);
        }
    });
});



var $cb210a377d372289$var$name = "clone";
var $cb210a377d372289$var$dependencies = [
    "typed"
];
var $cb210a377d372289$export$39ad70de4044028a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($cb210a377d372289$var$name, $cb210a377d372289$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Clone an object. Will make a deep copy of the data.
   *
   * Syntax:
   *
   *     math.clone(x)
   *
   * Examples:
   *
   *    math.clone(3.5)                   // returns number 3.5
   *    math.clone(math.complex('2-4i') // returns Complex 2 - 4i
   *    math.clone(math.unit(45, 'deg'))  // returns Unit 45 deg
   *    math.clone([[1, 2], [3, 4]])      // returns Array [[1, 2], [3, 4]]
   *    math.clone("hello world")         // returns string "hello world"
   *
   * @param {*} x   Object to be cloned
   * @return {*} A clone of object x
   */ return typed($cb210a377d372289$var$name, {
        any: (0, $33619877a15996ac$export$9cd59f9826255e47)
    });
});




var $6fe5fc677152824f$var$name = "column";
var $6fe5fc677152824f$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $6fe5fc677152824f$export$1bfa986e9c92c0b5 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($6fe5fc677152824f$var$name, $6fe5fc677152824f$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    /**
   * Return a column from a Matrix.
   *
   * Syntax:
   *
   *     math.column(value, index)
   *
   * Example:
   *
   *     // get a column
   *     const d = [[1, 2], [3, 4]]
   *     math.column(d, 1) // returns [[2], [4]]
   *
   * See also:
   *
   *     row
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} column           The index of the column
   * @return {Array | Matrix}         The retrieved column
   */ return typed($6fe5fc677152824f$var$name, {
        "Matrix, number": _column,
        "Array, number": function ArrayNumber(value, column) {
            return _column(matrix((0, $33619877a15996ac$export$9cd59f9826255e47)(value)), column).valueOf();
        }
    });
    /**
   * Retrieve a column of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} column  The index of the column
   * @return {Matrix}        The retrieved column
   */ function _column(value, column) {
        // check dimensions
        if (value.size().length !== 2) throw new Error("Only two dimensional matrix is supported");
        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(column, value.size()[1]);
        var rowRange = range(0, value.size()[0]);
        var index = new Index(rowRange, column);
        return value.subset(index);
    }
});



/** @param {number} i
 *  @param {number} n
 *  @returns {number} product of i to n
 */ function $38ff2345905e1d13$export$dbd0f18357df1ddd(i, n) {
    if (n < i) return 1;
    if (n === i) return n;
    var half = n + i >> 1; // divide (n + i) by 2 and truncate to integer
    return $38ff2345905e1d13$export$dbd0f18357df1ddd(i, half) * $38ff2345905e1d13$export$dbd0f18357df1ddd(half + 1, n);
}


function $80be47d82b073844$export$2a122d28e37477a2(n, k) {
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(n) || n < 0) throw new TypeError("Positive integer value expected in function combinations");
    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(k) || k < 0) throw new TypeError("Positive integer value expected in function combinations");
    if (k > n) throw new TypeError("k must be less than or equal to n");
    var nMinusk = n - k;
    var answer = 1;
    var firstnumerator = k < nMinusk ? nMinusk + 1 : k + 1;
    var nextdivisor = 2;
    var lastdivisor = k < nMinusk ? k : nMinusk; // balance multiplications and divisions to try to keep intermediate values
    // in exact-integer range as long as possible
    for(var nextnumerator = firstnumerator; nextnumerator <= n; ++nextnumerator){
        answer *= nextnumerator;
        while(nextdivisor <= lastdivisor && answer % nextdivisor === 0){
            answer /= nextdivisor;
            ++nextdivisor;
        }
    } // for big n, k, floating point may have caused weirdness in remainder
    if (nextdivisor <= lastdivisor) answer /= (0, $38ff2345905e1d13$export$dbd0f18357df1ddd)(nextdivisor, lastdivisor);
    return answer;
}
$80be47d82b073844$export$2a122d28e37477a2.signature = "number, number";


var $a25fce9d29b8284e$var$name = "combinations";
var $a25fce9d29b8284e$var$dependencies = [
    "typed"
];
var $a25fce9d29b8284e$export$63e3129a196da23d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a25fce9d29b8284e$var$name, $a25fce9d29b8284e$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities.
   *
   * Combinations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.combinations(n, k)
   *
   * Examples:
   *
   *    math.combinations(7, 5) // returns 21
   *
   * See also:
   *
   *    combinationsWithRep, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations.
   */ return typed($a25fce9d29b8284e$var$name, {
        "number, number": (0, $80be47d82b073844$export$2a122d28e37477a2),
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var nMinusk = n.minus(k);
            var one = new BigNumber(1);
            if (!$a25fce9d29b8284e$var$isPositiveInteger(n) || !$a25fce9d29b8284e$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function combinations");
            if (k.gt(n)) throw new TypeError("k must be less than n in function combinations");
            result = one;
            if (k.lt(nMinusk)) for(i = one; i.lte(nMinusk); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusk.plus(i)).dividedBy(i);
            return result;
        } // TODO: implement support for collection in combinations
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $a25fce9d29b8284e$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}




var $ff11099601f7a485$var$name = "combinationsWithRep";
var $ff11099601f7a485$var$dependencies = [
    "typed"
];
var $ff11099601f7a485$export$4bdc90311ec7c1dd = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($ff11099601f7a485$var$name, $ff11099601f7a485$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities, allowing individual outcomes to be repeated more than once.
   *
   * CombinationsWithRep only takes integer arguments.
   * The following condition must be enforced: k <= n + k -1.
   *
   * Syntax:
   *
   *     math.combinationsWithRep(n, k)
   *
   * Examples:
   *
   *    math.combinationsWithRep(7, 5) // returns 462
   *
   * See also:
   *
   *    combinations, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations with replacement.
   */ return typed($ff11099601f7a485$var$name, {
        "number, number": function numberNumber(n, k) {
            if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(n) || n < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(k) || k < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (n < 1) throw new TypeError("k must be less than or equal to n + k - 1");
            if (k < n - 1) {
                var _prodrange = (0, $38ff2345905e1d13$export$dbd0f18357df1ddd)(n, n + k - 1);
                return _prodrange / (0, $38ff2345905e1d13$export$dbd0f18357df1ddd)(1, k);
            }
            var prodrange = (0, $38ff2345905e1d13$export$dbd0f18357df1ddd)(k + 1, n + k - 1);
            return prodrange / (0, $38ff2345905e1d13$export$dbd0f18357df1ddd)(1, n - 1);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var one = new BigNumber(1);
            var nMinusOne = n.minus(one);
            if (!$ff11099601f7a485$var$isPositiveInteger(n) || !$ff11099601f7a485$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (n.lt(one)) throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
            result = one;
            if (k.lt(nMinusOne)) for(i = one; i.lte(nMinusOne); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusOne.plus(i)).dividedBy(i);
            return result;
        }
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $ff11099601f7a485$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}










var $a7b97f0cac0b5286$var$name = "algorithm05";
var $a7b97f0cac0b5286$var$dependencies = [
    "typed",
    "equalScalar"
];
var $a7b97f0cac0b5286$export$f80c3080566d43b4 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a7b97f0cac0b5286$var$name, $a7b97f0cac0b5286$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 || B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm05(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var xa = cvalues ? [] : undefined;
        var xb = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // vars
        var i, j, k, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop values A(:,j)
            for(k = aptr[j], k1 = aptr[j + 1]; k < k1; k++){
                // row
                i = aindex[k]; // push index
                cindex.push(i); // update workspace
                wa[i] = mark; // check we need to process values
                if (xa) xa[i] = avalues[k];
            } // loop values B(:,j)
            for(k = bptr[j], k1 = bptr[j + 1]; k < k1; k++){
                // row
                i = bindex[k]; // check row existed in A
                if (wa[i] !== mark) // push index
                cindex.push(i);
                 // update workspace
                wb[i] = mark; // check we need to process values
                if (xb) xb[i] = bvalues[k];
            } // check we need to process values (non pattern matrix)
            if (cvalues) {
                // initialize first index in j
                k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k]; // marks
                    var wai = wa[i];
                    var wbi = wb[i]; // check Aij or Bij are nonzero
                    if (wai === mark || wbi === mark) {
                        // matrix values @ i,j
                        var va = wai === mark ? xa[i] : zero;
                        var vb = wbi === mark ? xb[i] : zero; // Cij
                        var vc = cf(va, vb); // check for zero
                        if (!eq(vc, zero)) {
                            // push value
                            cvalues.push(vc); // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    }
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});


var $9c205cf301f4a645$var$name = "compare";
var $9c205cf301f4a645$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "equalScalar",
    "BigNumber",
    "Fraction",
    "DenseMatrix"
];
var $9c205cf301f4a645$export$a6e723c0e3b918d4 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($9c205cf301f4a645$var$name, $9c205cf301f4a645$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, equalScalar: equalScalar, matrix: matrix, BigNumber: BigNumber, Fraction: Fraction, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm05 = (0, $a7b97f0cac0b5286$export$f80c3080566d43b4)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * x and y are considered equal when the relative difference between x and y
   * is smaller than the configured epsilon. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.compare(x, y)
   *
   * Examples:
   *
   *    math.compare(6, 1)           // returns 1
   *    math.compare(2, 3)           // returns -1
   *    math.compare(7, 7)           // returns 0
   *    math.compare('10', '2')      // returns 1
   *    math.compare('1000', '1e3')  // returns 0
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compare(a, b)           // returns 1
   *
   *    math.compare(2, [1, 2, 3])   // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, largerEq, compareNatural, compareText
   *
   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} y Second value to compare
   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the result of the comparison:
   *                                                          1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($9c205cf301f4a645$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x === y ? 0 : x > y ? 1 : -1;
        },
        "number, number": function numberNumber(x, y) {
            return (0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon) ? 0 : x > y ? 1 : -1;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return (0, $cea3608675fc8eba$export$6f3989c6ecc04081)(x, y, config.epsilon) ? new BigNumber(0) : new BigNumber(x.cmp(y));
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return new Fraction(x.compare(y));
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $9c205cf301f4a645$export$e744cf3e2e3d6926 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($9c205cf301f4a645$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($9c205cf301f4a645$var$name, {
        "number, number": function numberNumber(x, y) {
            return (0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon) ? 0 : x > y ? 1 : -1;
        }
    });
});

var $686a00245b7b9b4d$exports = {};
/*
 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
 */ /*jshint unused:false */ $686a00245b7b9b4d$exports = function naturalSort(a, b) {
    "use strict";
    var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, sre = /(^[ ]*|[ ]*$)/g, dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, hre = /^0x[0-9a-f]+$/i, ore = /^0/, i = function(s) {
        return naturalSort.insensitive && ("" + s).toLowerCase() || "" + s;
    }, // convert all to strings strip whitespace
    x = i(a).replace(sre, "") || "", y = i(b).replace(sre, "") || "", // chunk/tokenize
    xN = x.replace(re, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), yN = y.replace(re, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), // numeric, hex or date detection
    xD = parseInt(x.match(hre), 16) || xN.length !== 1 && x.match(dre) && Date.parse(x), yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null, oFxNcL, oFyNcL;
    // first try and sort Hex codes or Dates
    if (yD) {
        if (xD < yD) return -1;
        else if (xD > yD) return 1;
    }
    // natural sorting through split numeric strings and default strings
    for(var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++){
        // find floats not starting with '0', string or 0 if not defined (Clint Priest)
        oFxNcL = !(xN[cLoc] || "").match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
        oFyNcL = !(yN[cLoc] || "").match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
        // handle numeric vs string comparison - number < string - (Kyle Adams)
        if (isNaN(oFxNcL) !== isNaN(oFyNcL)) return isNaN(oFxNcL) ? 1 : -1;
        else if (typeof oFxNcL !== typeof oFyNcL) {
            oFxNcL += "";
            oFyNcL += "";
        }
        if (oFxNcL < oFyNcL) return -1;
        if (oFxNcL > oFyNcL) return 1;
    }
    return 0;
};




var $d7387473996ac08f$var$name = "compareNatural";
var $d7387473996ac08f$var$dependencies = [
    "typed",
    "compare"
];
var $d7387473996ac08f$export$ac9dd39e43534605 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d7387473996ac08f$var$name, $d7387473996ac08f$var$dependencies, (_ref)=>{
    var { typed: typed, compare: compare } = _ref;
    var compareBooleans = compare.signatures["boolean,boolean"];
    /**
   * Compare two values of any type in a deterministic, natural way.
   *
   * For numeric values, the function works the same as `math.compare`.
   * For types of values that can't be compared mathematically,
   * the function compares in a natural way.
   *
   * For numeric values, x and y are considered equal when the relative
   * difference between x and y is smaller than the configured epsilon.
   * The function cannot be used to compare values smaller than
   * approximately 2.22e-16.
   *
   * For Complex numbers, first the real parts are compared. If equal,
   * the imaginary parts are compared.
   *
   * Strings are compared with a natural sorting algorithm, which
   * orders strings in a "logic" way following some heuristics.
   * This differs from the function `compare`, which converts the string
   * into a numeric value and compares that. The function `compareText`
   * on the other hand compares text lexically.
   *
   * Arrays and Matrices are compared value by value until there is an
   * unequal pair of values encountered. Objects are compared by sorted
   * keys until the keys or their values are unequal.
   *
   * Syntax:
   *
   *    math.compareNatural(x, y)
   *
   * Examples:
   *
   *    math.compareNatural(6, 1)              // returns 1
   *    math.compareNatural(2, 3)              // returns -1
   *    math.compareNatural(7, 7)              // returns 0
   *
   *    math.compareNatural('10', '2')         // returns 1
   *    math.compareText('10', '2')            // returns -1
   *    math.compare('10', '2')                // returns 1
   *
   *    math.compareNatural('Answer: 10', 'Answer: 2') // returns 1
   *    math.compareText('Answer: 10', 'Answer: 2')    // returns -1
   *    math.compare('Answer: 10', 'Answer: 2')
   *        // Error: Cannot convert "Answer: 10" to a number
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compareNatural(a, b)              // returns 1
   *
   *    const c = math.complex('2 + 3i')
   *    const d = math.complex('2 + 4i')
   *    math.compareNatural(c, d)              // returns -1
   *
   *    math.compareNatural([1, 2, 4], [1, 2, 3]) // returns 1
   *    math.compareNatural([1, 2, 3], [1, 2])    // returns 1
   *    math.compareNatural([1, 5], [1, 2, 3])    // returns 1
   *    math.compareNatural([1, 2], [1, 2])       // returns 0
   *
   *    math.compareNatural({a: 2}, {a: 4})       // returns -1
   *
   * See also:
   *
   *    compare, compareText
   *
   * @param  {*} x First value to compare
   * @param  {*} y Second value to compare
   * @return {number} Returns the result of the comparison:
   *                  1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($d7387473996ac08f$var$name, {
        "any, any": function anyAny(x, y) {
            var typeX = (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(x);
            var typeY = (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(y);
            var c; // numeric types
            if ((typeX === "number" || typeX === "BigNumber" || typeX === "Fraction") && (typeY === "number" || typeY === "BigNumber" || typeY === "Fraction")) {
                c = compare(x, y);
                if (c.toString() !== "0") // c can be number, BigNumber, or Fraction
                return c > 0 ? 1 : -1; // return a number
                else return (0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports)))(typeX, typeY);
            } // matrix types
            if (typeX === "Array" || typeX === "Matrix" || typeY === "Array" || typeY === "Matrix") {
                c = compareMatricesAndArrays(this, x, y);
                if (c !== 0) return c;
                else return (0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports)))(typeX, typeY);
            } // in case of different types, order by name of type, i.e. 'BigNumber' < 'Complex'
            if (typeX !== typeY) return (0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports)))(typeX, typeY);
            if (typeX === "Complex") return $d7387473996ac08f$var$compareComplexNumbers(x, y);
            if (typeX === "Unit") {
                if (x.equalBase(y)) return this(x.value, y.value);
                 // compare by units
                return compareArrays(this, x.formatUnits(), y.formatUnits());
            }
            if (typeX === "boolean") return compareBooleans(x, y);
            if (typeX === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports)))(x, y);
            if (typeX === "Object") return compareObjects(this, x, y);
            if (typeX === "null") return 0;
            if (typeX === "undefined") return 0;
             // this should not occur...
            throw new TypeError('Unsupported type of value "' + typeX + '"');
        }
    });
    /**
   * Compare mixed matrix/array types, by converting to same-shaped array.
   * This comparator is non-deterministic regarding input types.
   * @param {Array | SparseMatrix | DenseMatrix | *} x
   * @param {Array | SparseMatrix | DenseMatrix | *} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareMatricesAndArrays(compareNatural, x, y) {
        if ((0, $2c4f948f17aa2240$export$d508368d4da3c38a)(x) && (0, $2c4f948f17aa2240$export$d508368d4da3c38a)(y)) return compareArrays(compareNatural, x.toJSON().values, y.toJSON().values);
        if ((0, $2c4f948f17aa2240$export$d508368d4da3c38a)(x)) // note: convert to array is expensive
        return compareMatricesAndArrays(compareNatural, x.toArray(), y);
        if ((0, $2c4f948f17aa2240$export$d508368d4da3c38a)(y)) // note: convert to array is expensive
        return compareMatricesAndArrays(compareNatural, x, y.toArray());
         // convert DenseArray into Array
        if ((0, $2c4f948f17aa2240$export$eb44495df7ba11d)(x)) return compareMatricesAndArrays(compareNatural, x.toJSON().data, y);
        if ((0, $2c4f948f17aa2240$export$eb44495df7ba11d)(y)) return compareMatricesAndArrays(compareNatural, x, y.toJSON().data);
         // convert scalars to array
        if (!Array.isArray(x)) return compareMatricesAndArrays(compareNatural, [
            x
        ], y);
        if (!Array.isArray(y)) return compareMatricesAndArrays(compareNatural, x, [
            y
        ]);
        return compareArrays(compareNatural, x, y);
    }
    /**
   * Compare two Arrays
   *
   * - First, compares value by value
   * - Next, if all corresponding values are equal,
   *   look at the length: longest array will be considered largest
   *
   * @param {Array} x
   * @param {Array} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareArrays(compareNatural, x, y) {
        // compare each value
        for(var i = 0, ii = Math.min(x.length, y.length); i < ii; i++){
            var v = compareNatural(x[i], y[i]);
            if (v !== 0) return v;
        } // compare the size of the arrays
        if (x.length > y.length) return 1;
        if (x.length < y.length) return -1;
         // both Arrays have equal size and content
        return 0;
    }
    /**
   * Compare two objects
   *
   * - First, compare sorted property names
   * - Next, compare the property values
   *
   * @param {Object} x
   * @param {Object} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareObjects(compareNatural, x, y) {
        var keysX = Object.keys(x);
        var keysY = Object.keys(y); // compare keys
        keysX.sort((0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports))));
        keysY.sort((0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports))));
        var c = compareArrays(compareNatural, keysX, keysY);
        if (c !== 0) return c;
         // compare values
        for(var i = 0; i < keysX.length; i++){
            var v = compareNatural(x[keysX[i]], y[keysY[i]]);
            if (v !== 0) return v;
        }
        return 0;
    }
});
/**
 * Compare two complex numbers, `x` and `y`:
 *
 * - First, compare the real values of `x` and `y`
 * - If equal, compare the imaginary values of `x` and `y`
 *
 * @params {Complex} x
 * @params {Complex} y
 * @returns {number} Returns the comparison result: -1, 0, or 1
 */ function $d7387473996ac08f$var$compareComplexNumbers(x, y) {
    if (x.re > y.re) return 1;
    if (x.re < y.re) return -1;
    if (x.im > y.im) return 1;
    if (x.im < y.im) return -1;
    return 0;
}





var $d8f75931f26ea1d2$var$name = "compareText";
var $d8f75931f26ea1d2$var$dependencies = [
    "typed",
    "matrix"
];
var $d8f75931f26ea1d2$export$3e578d0534ab5935 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d8f75931f26ea1d2$var$name, $d8f75931f26ea1d2$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Compare two strings lexically. Comparison is case sensitive.
   * Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.compareText(x, y)
   *
   * Examples:
   *
   *    math.compareText('B', 'A')     // returns 1
   *    math.compareText('2', '10')    // returns 1
   *    math.compare('2', '10')        // returns -1
   *    math.compareNatural('2', '10') // returns -1
   *
   *    math.compareText('B', ['A', 'B', 'C']) // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, equalText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns the result of the comparison:
   *                                        1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($d8f75931f26ea1d2$var$name, {
        "any, any": (0, $addf7cb66573d3e4$export$2da9287da10b19e2),
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, (0, $addf7cb66573d3e4$export$2da9287da10b19e2));
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, (0, $addf7cb66573d3e4$export$2da9287da10b19e2), false);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, (0, $addf7cb66573d3e4$export$2da9287da10b19e2), true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, (0, $addf7cb66573d3e4$export$2da9287da10b19e2), false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, (0, $addf7cb66573d3e4$export$2da9287da10b19e2), true).valueOf();
        }
    });
});
var $d8f75931f26ea1d2$export$1d0ea0d151dafd85 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d8f75931f26ea1d2$var$name, [
    "typed"
], (_ref2)=>{
    var { typed: typed } = _ref2;
    return typed($d8f75931f26ea1d2$var$name, {
        "any, any": (0, $addf7cb66573d3e4$export$2da9287da10b19e2)
    });
});



var $8911afbb0665e63e$var$name = "complex";
var $8911afbb0665e63e$var$dependencies = [
    "typed",
    "Complex"
];
var $8911afbb0665e63e$export$82a905fb6826da0d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8911afbb0665e63e$var$name, $8911afbb0665e63e$var$dependencies, (_ref)=>{
    var { typed: typed, Complex: Complex } = _ref;
    /**
   * Create a complex value or convert a value to a complex value.
   *
   * Syntax:
   *
   *     math.complex()                           // creates a complex value with zero
   *                                              // as real and imaginary part.
   *     math.complex(re : number, im : string)   // creates a complex value with provided
   *                                              // values for real and imaginary part.
   *     math.complex(re : number)                // creates a complex value with provided
   *                                              // real value and zero imaginary part.
   *     math.complex(complex : Complex)          // clones the provided complex value.
   *     math.complex(arg : string)               // parses a string into a complex value.
   *     math.complex(array : Array)              // converts the elements of the array
   *                                              // or matrix element wise into a
   *                                              // complex value.
   *     math.complex({re: number, im: number})   // creates a complex value with provided
   *                                              // values for real an imaginary part.
   *     math.complex({r: number, phi: number})   // creates a complex value with provided
   *                                              // polar coordinates
   *
   * Examples:
   *
   *    const a = math.complex(3, -4)     // a = Complex 3 - 4i
   *    a.re = 5                          // a = Complex 5 - 4i
   *    const i = a.im                    // Number -4
   *    const b = math.complex('2 + 6i')  // Complex 2 + 6i
   *    const c = math.complex()          // Complex 0 + 0i
   *    const d = math.add(a, b)          // Complex 5 + 2i
   *
   * See also:
   *
   *    bignumber, boolean, index, matrix, number, string, unit
   *
   * @param {* | Array | Matrix} [args]
   *            Arguments specifying the real and imaginary part of the complex number
   * @return {Complex | Array | Matrix} Returns a complex value
   */ return typed("complex", {
        "": function _() {
            return Complex.ZERO;
        },
        number: function number(x) {
            return new Complex(x, 0);
        },
        "number, number": function numberNumber(re, im) {
            return new Complex(re, im);
        },
        // TODO: this signature should be redundant
        "BigNumber, BigNumber": function BigNumberBigNumber(re, im) {
            return new Complex(re.toNumber(), im.toNumber());
        },
        Fraction: function Fraction(x) {
            return new Complex(x.valueOf(), 0);
        },
        Complex: function Complex(x) {
            return x.clone();
        },
        string: function string(x) {
            return Complex(x); // for example '2 + 3i'
        },
        null: function _null(x) {
            return Complex(0);
        },
        Object: function Object(x) {
            if ("re" in x && "im" in x) return new Complex(x.re, x.im);
            if ("r" in x && "phi" in x || "abs" in x && "arg" in x) return new Complex(x);
            throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});

var $2e216b23251d121c$exports = {};
/**
 * @license Complex.js v2.1.1 12/05/2020
 *
 * Copyright (c) 2020, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ /**
 *
 * This class allows the manipulation of complex numbers.
 * You can pass a complex number in different formats. Either as object, double, string or two integer parameters.
 *
 * Object form
 * { re: <real>, im: <imaginary> }
 * { arg: <angle>, abs: <radius> }
 * { phi: <angle>, r: <radius> }
 *
 * Array / Vector form
 * [ real, imaginary ]
 *
 * Double form
 * 99.3 - Single double value
 *
 * String form
 * '23.1337' - Simple real number
 * '15+3i' - a simple complex number
 * '3-i' - a simple complex number
 *
 * Example:
 *
 * var c = new Complex('99.3+8i');
 * c.mul({r: 3, i: 9}).div(4.9).sub(3, 2);
 *
 */ (function(root) {
    "use strict";
    var cosh = Math.cosh || function(x) {
        return Math.abs(x) < 1e-9 ? 1 - x : (Math.exp(x) + Math.exp(-x)) * 0.5;
    };
    var sinh = Math.sinh || function(x) {
        return Math.abs(x) < 1e-9 ? x : (Math.exp(x) - Math.exp(-x)) * 0.5;
    };
    /**
   * Calculates cos(x) - 1 using Taylor series if x is small (-¼π ≤ x ≤ ¼π).
   *
   * @param {number} x
   * @returns {number} cos(x) - 1
   */ var cosm1 = function(x) {
        var b = Math.PI / 4;
        if (-b > x || x > b) return Math.cos(x) - 1.0;
        /* Calculate horner form of polynomial of taylor series in Q
    var fac = 1, alt = 1, pol = {};
    for (var i = 0; i <= 16; i++) {
      fac*= i || 1;
      if (i % 2 == 0) {
        pol[i] = new Fraction(1, alt * fac);
        alt = -alt;
      }
    }
    console.log(new Polynomial(pol).toHorner()); // (((((((1/20922789888000x^2-1/87178291200)x^2+1/479001600)x^2-1/3628800)x^2+1/40320)x^2-1/720)x^2+1/24)x^2-1/2)x^2+1
    */ var xx = x * x;
        return xx * (xx * (xx * (xx * (xx * (xx * (xx * (xx / 20922789888000 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 0.5);
    };
    var hypot = function(x, y) {
        var a = Math.abs(x);
        var b = Math.abs(y);
        if (a < 3000 && b < 3000) return Math.sqrt(a * a + b * b);
        if (a < b) {
            a = b;
            b = x / y;
        } else b = y / x;
        return a * Math.sqrt(1 + b * b);
    };
    var parser_exit = function() {
        throw SyntaxError("Invalid Param");
    };
    /**
   * Calculates log(sqrt(a^2+b^2)) in a way to avoid overflows
   *
   * @param {number} a
   * @param {number} b
   * @returns {number}
   */ function logHypot(a, b) {
        var _a = Math.abs(a);
        var _b = Math.abs(b);
        if (a === 0) return Math.log(_b);
        if (b === 0) return Math.log(_a);
        if (_a < 3000 && _b < 3000) return Math.log(a * a + b * b) * 0.5;
        /* I got 4 ideas to compute this property without overflow:
     *
     * Testing 1000000 times with random samples for a,b ∈ [1, 1000000000] against a big decimal library to get an error estimate
     *
     * 1. Only eliminate the square root: (OVERALL ERROR: 3.9122483030951116e-11)

     Math.log(a * a + b * b) / 2

     *
     *
     * 2. Try to use the non-overflowing pythagoras: (OVERALL ERROR: 8.889760039210159e-10)

     var fn = function(a, b) {
     a = Math.abs(a);
     b = Math.abs(b);
     var t = Math.min(a, b);
     a = Math.max(a, b);
     t = t / a;

     return Math.log(a) + Math.log(1 + t * t) / 2;
     };

     * 3. Abuse the identity cos(atan(y/x) = x / sqrt(x^2+y^2): (OVERALL ERROR: 3.4780178737037204e-10)

     Math.log(a / Math.cos(Math.atan2(b, a)))

     * 4. Use 3. and apply log rules: (OVERALL ERROR: 1.2014087502620896e-9)

     Math.log(a) - Math.log(Math.cos(Math.atan2(b, a)))

     */ a = a / 2;
        b = b / 2;
        return 0.5 * Math.log(a * a + b * b) + Math.LN2;
    }
    var parse = function(a, b) {
        var z = {
            "re": 0,
            "im": 0
        };
        if (a === undefined || a === null) z["re"] = z["im"] = 0;
        else if (b !== undefined) {
            z["re"] = a;
            z["im"] = b;
        } else switch(typeof a){
            case "object":
                if ("im" in a && "re" in a) {
                    z["re"] = a["re"];
                    z["im"] = a["im"];
                } else if ("abs" in a && "arg" in a) {
                    if (!Number.isFinite(a["abs"]) && Number.isFinite(a["arg"])) return Complex["INFINITY"];
                    z["re"] = a["abs"] * Math.cos(a["arg"]);
                    z["im"] = a["abs"] * Math.sin(a["arg"]);
                } else if ("r" in a && "phi" in a) {
                    if (!Number.isFinite(a["r"]) && Number.isFinite(a["phi"])) return Complex["INFINITY"];
                    z["re"] = a["r"] * Math.cos(a["phi"]);
                    z["im"] = a["r"] * Math.sin(a["phi"]);
                } else if (a.length === 2) {
                    z["re"] = a[0];
                    z["im"] = a[1];
                } else parser_exit();
                break;
            case "string":
                z["im"] = /* void */ z["re"] = 0;
                var tokens = a.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
                var plus = 1;
                var minus = 0;
                if (tokens === null) parser_exit();
                for(var i = 0; i < tokens.length; i++){
                    var c = tokens[i];
                    if (c === " " || c === "	" || c === "\n") ;
                    else if (c === "+") plus++;
                    else if (c === "-") minus++;
                    else if (c === "i" || c === "I") {
                        if (plus + minus === 0) parser_exit();
                        if (tokens[i + 1] !== " " && !isNaN(tokens[i + 1])) {
                            z["im"] += parseFloat((minus % 2 ? "-" : "") + tokens[i + 1]);
                            i++;
                        } else z["im"] += parseFloat((minus % 2 ? "-" : "") + "1");
                        plus = minus = 0;
                    } else {
                        if (plus + minus === 0 || isNaN(c)) parser_exit();
                        if (tokens[i + 1] === "i" || tokens[i + 1] === "I") {
                            z["im"] += parseFloat((minus % 2 ? "-" : "") + c);
                            i++;
                        } else z["re"] += parseFloat((minus % 2 ? "-" : "") + c);
                        plus = minus = 0;
                    }
                }
                // Still something on the stack
                if (plus + minus > 0) parser_exit();
                break;
            case "number":
                z["im"] = 0;
                z["re"] = a;
                break;
            default:
                parser_exit();
        }
        isNaN(z["re"]) || isNaN(z["im"]);
        return z;
    };
    /**
   * @constructor
   * @returns {Complex}
   */ function Complex(a, b) {
        if (!(this instanceof Complex)) return new Complex(a, b);
        var z = parse(a, b);
        this["re"] = z["re"];
        this["im"] = z["im"];
    }
    Complex.prototype = {
        "re": 0,
        "im": 0,
        /**
     * Calculates the sign of a complex number, which is a normalized complex
     *
     * @returns {Complex}
     */ "sign": function() {
            var abs = this["abs"]();
            return new Complex(this["re"] / abs, this["im"] / abs);
        },
        /**
     * Adds two complex numbers
     *
     * @returns {Complex}
     */ "add": function(a, b) {
            var z = new Complex(a, b);
            // Infinity + Infinity = NaN
            if (this["isInfinite"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity + z = Infinity { where z != Infinity }
            if (this["isInfinite"]() || z["isInfinite"]()) return Complex["INFINITY"];
            return new Complex(this["re"] + z["re"], this["im"] + z["im"]);
        },
        /**
     * Subtracts two complex numbers
     *
     * @returns {Complex}
     */ "sub": function(a, b) {
            var z = new Complex(a, b);
            // Infinity - Infinity = NaN
            if (this["isInfinite"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity - z = Infinity { where z != Infinity }
            if (this["isInfinite"]() || z["isInfinite"]()) return Complex["INFINITY"];
            return new Complex(this["re"] - z["re"], this["im"] - z["im"]);
        },
        /**
     * Multiplies two complex numbers
     *
     * @returns {Complex}
     */ "mul": function(a, b) {
            var z = new Complex(a, b);
            // Infinity * 0 = NaN
            if (this["isInfinite"]() && z["isZero"]() || this["isZero"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity * z = Infinity { where z != 0 }
            if (this["isInfinite"]() || z["isInfinite"]()) return Complex["INFINITY"];
            // Short circuit for real values
            if (z["im"] === 0 && this["im"] === 0) return new Complex(this["re"] * z["re"], 0);
            return new Complex(this["re"] * z["re"] - this["im"] * z["im"], this["re"] * z["im"] + this["im"] * z["re"]);
        },
        /**
     * Divides two complex numbers
     *
     * @returns {Complex}
     */ "div": function(a, b) {
            var z = new Complex(a, b);
            // 0 / 0 = NaN and Infinity / Infinity = NaN
            if (this["isZero"]() && z["isZero"]() || this["isInfinite"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity / 0 = Infinity
            if (this["isInfinite"]() || z["isZero"]()) return Complex["INFINITY"];
            // 0 / Infinity = 0
            if (this["isZero"]() || z["isInfinite"]()) return Complex["ZERO"];
            a = this["re"];
            b = this["im"];
            var c = z["re"];
            var d = z["im"];
            var t, x;
            if (0 === d) // Divisor is real
            return new Complex(a / c, b / c);
            if (Math.abs(c) < Math.abs(d)) {
                x = c / d;
                t = c * x + d;
                return new Complex((a * x + b) / t, (b * x - a) / t);
            } else {
                x = d / c;
                t = d * x + c;
                return new Complex((a + b * x) / t, (b - a * x) / t);
            }
        },
        /**
     * Calculate the power of two complex numbers
     *
     * @returns {Complex}
     */ "pow": function(a, b) {
            var z = new Complex(a, b);
            a = this["re"];
            b = this["im"];
            if (z["isZero"]()) return Complex["ONE"];
            // If the exponent is real
            if (z["im"] === 0) {
                if (b === 0 && a > 0) return new Complex(Math.pow(a, z["re"]), 0);
                else if (a === 0) switch((z["re"] % 4 + 4) % 4){
                    case 0:
                        return new Complex(Math.pow(b, z["re"]), 0);
                    case 1:
                        return new Complex(0, Math.pow(b, z["re"]));
                    case 2:
                        return new Complex(-Math.pow(b, z["re"]), 0);
                    case 3:
                        return new Complex(0, -Math.pow(b, z["re"]));
                }
            }
            /* I couldn't find a good formula, so here is a derivation and optimization
       *
       * z_1^z_2 = (a + bi)^(c + di)
       *         = exp((c + di) * log(a + bi)
       *         = pow(a^2 + b^2, (c + di) / 2) * exp(i(c + di)atan2(b, a))
       * =>...
       * Re = (pow(a^2 + b^2, c / 2) * exp(-d * atan2(b, a))) * cos(d * log(a^2 + b^2) / 2 + c * atan2(b, a))
       * Im = (pow(a^2 + b^2, c / 2) * exp(-d * atan2(b, a))) * sin(d * log(a^2 + b^2) / 2 + c * atan2(b, a))
       *
       * =>...
       * Re = exp(c * log(sqrt(a^2 + b^2)) - d * atan2(b, a)) * cos(d * log(sqrt(a^2 + b^2)) + c * atan2(b, a))
       * Im = exp(c * log(sqrt(a^2 + b^2)) - d * atan2(b, a)) * sin(d * log(sqrt(a^2 + b^2)) + c * atan2(b, a))
       *
       * =>
       * Re = exp(c * logsq2 - d * arg(z_1)) * cos(d * logsq2 + c * arg(z_1))
       * Im = exp(c * logsq2 - d * arg(z_1)) * sin(d * logsq2 + c * arg(z_1))
       *
       */ if (a === 0 && b === 0 && z["re"] > 0 && z["im"] >= 0) return Complex["ZERO"];
            var arg = Math.atan2(b, a);
            var loh = logHypot(a, b);
            a = Math.exp(z["re"] * loh - z["im"] * arg);
            b = z["im"] * loh + z["re"] * arg;
            return new Complex(a * Math.cos(b), a * Math.sin(b));
        },
        /**
     * Calculate the complex square root
     *
     * @returns {Complex}
     */ "sqrt": function() {
            var a = this["re"];
            var b = this["im"];
            var r = this["abs"]();
            var re, im;
            if (a >= 0) {
                if (b === 0) return new Complex(Math.sqrt(a), 0);
                re = 0.5 * Math.sqrt(2.0 * (r + a));
            } else re = Math.abs(b) / Math.sqrt(2 * (r - a));
            if (a <= 0) im = 0.5 * Math.sqrt(2.0 * (r - a));
            else im = Math.abs(b) / Math.sqrt(2 * (r + a));
            return new Complex(re, b < 0 ? -im : im);
        },
        /**
     * Calculate the complex exponent
     *
     * @returns {Complex}
     */ "exp": function() {
            var tmp = Math.exp(this["re"]);
            this["im"];
            return new Complex(tmp * Math.cos(this["im"]), tmp * Math.sin(this["im"]));
        },
        /**
     * Calculate the complex exponent and subtracts one.
     *
     * This may be more accurate than `Complex(x).exp().sub(1)` if
     * `x` is small.
     *
     * @returns {Complex}
     */ "expm1": function() {
            /**
       * exp(a + i*b) - 1
       = exp(a) * (cos(b) + j*sin(b)) - 1
       = expm1(a)*cos(b) + cosm1(b) + j*exp(a)*sin(b)
       */ var a = this["re"];
            var b = this["im"];
            return new Complex(Math.expm1(a) * Math.cos(b) + cosm1(b), Math.exp(a) * Math.sin(b));
        },
        /**
     * Calculate the natural log
     *
     * @returns {Complex}
     */ "log": function() {
            var a = this["re"];
            var b = this["im"];
            b === 0 && a;
            return new Complex(logHypot(a, b), Math.atan2(b, a));
        },
        /**
     * Calculate the magnitude of the complex number
     *
     * @returns {number}
     */ "abs": function() {
            return hypot(this["re"], this["im"]);
        },
        /**
     * Calculate the angle of the complex number
     *
     * @returns {number}
     */ "arg": function() {
            return Math.atan2(this["im"], this["re"]);
        },
        /**
     * Calculate the sine of the complex number
     *
     * @returns {Complex}
     */ "sin": function() {
            // sin(z) = ( e^iz - e^-iz ) / 2i 
            //        = sin(a)cosh(b) + i cos(a)sinh(b)
            var a = this["re"];
            var b = this["im"];
            return new Complex(Math.sin(a) * cosh(b), Math.cos(a) * sinh(b));
        },
        /**
     * Calculate the cosine
     *
     * @returns {Complex}
     */ "cos": function() {
            // cos(z) = ( e^iz + e^-iz ) / 2 
            //        = cos(a)cosh(b) - i sin(a)sinh(b)
            var a = this["re"];
            var b = this["im"];
            return new Complex(Math.cos(a) * cosh(b), -Math.sin(a) * sinh(b));
        },
        /**
     * Calculate the tangent
     *
     * @returns {Complex}
     */ "tan": function() {
            // tan(z) = sin(z) / cos(z) 
            //        = ( e^iz - e^-iz ) / ( i( e^iz + e^-iz ) )
            //        = ( e^2iz - 1 ) / i( e^2iz + 1 )
            //        = ( sin(2a) + i sinh(2b) ) / ( cos(2a) + cosh(2b) )
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = Math.cos(a) + cosh(b);
            return new Complex(Math.sin(a) / d, sinh(b) / d);
        },
        /**
     * Calculate the cotangent
     *
     * @returns {Complex}
     */ "cot": function() {
            // cot(c) = i(e^(ci) + e^(-ci)) / (e^(ci) - e^(-ci))
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = Math.cos(a) - cosh(b);
            return new Complex(-Math.sin(a) / d, sinh(b) / d);
        },
        /**
     * Calculate the secant
     *
     * @returns {Complex}
     */ "sec": function() {
            // sec(c) = 2 / (e^(ci) + e^(-ci))
            var a = this["re"];
            var b = this["im"];
            var d = 0.5 * cosh(2 * b) + 0.5 * Math.cos(2 * a);
            return new Complex(Math.cos(a) * cosh(b) / d, Math.sin(a) * sinh(b) / d);
        },
        /**
     * Calculate the cosecans
     *
     * @returns {Complex}
     */ "csc": function() {
            // csc(c) = 2i / (e^(ci) - e^(-ci))
            var a = this["re"];
            var b = this["im"];
            var d = 0.5 * cosh(2 * b) - 0.5 * Math.cos(2 * a);
            return new Complex(Math.sin(a) * cosh(b) / d, -Math.cos(a) * sinh(b) / d);
        },
        /**
     * Calculate the complex arcus sinus
     *
     * @returns {Complex}
     */ "asin": function() {
            // asin(c) = -i * log(ci + sqrt(1 - c^2))
            var a = this["re"];
            var b = this["im"];
            var t1 = new Complex(b * b - a * a + 1, -2 * a * b)["sqrt"]();
            var t2 = new Complex(t1["re"] - b, t1["im"] + a)["log"]();
            return new Complex(t2["im"], -t2["re"]);
        },
        /**
     * Calculate the complex arcus cosinus
     *
     * @returns {Complex}
     */ "acos": function() {
            // acos(c) = i * log(c - i * sqrt(1 - c^2))
            var a = this["re"];
            var b = this["im"];
            var t1 = new Complex(b * b - a * a + 1, -2 * a * b)["sqrt"]();
            var t2 = new Complex(t1["re"] - b, t1["im"] + a)["log"]();
            return new Complex(Math.PI / 2 - t2["im"], t2["re"]);
        },
        /**
     * Calculate the complex arcus tangent
     *
     * @returns {Complex}
     */ "atan": function() {
            // atan(c) = i / 2 log((i + x) / (i - x))
            var a = this["re"];
            var b = this["im"];
            if (a === 0) {
                if (b === 1) return new Complex(0, Infinity);
                if (b === -1) return new Complex(0, -Infinity);
            }
            var d = a * a + (1.0 - b) * (1.0 - b);
            var t1 = new Complex((1 - b * b - a * a) / d, -2 * a / d).log();
            return new Complex(-0.5 * t1["im"], 0.5 * t1["re"]);
        },
        /**
     * Calculate the complex arcus cotangent
     *
     * @returns {Complex}
     */ "acot": function() {
            // acot(c) = i / 2 log((c - i) / (c + i))
            var a = this["re"];
            var b = this["im"];
            if (b === 0) return new Complex(Math.atan2(1, a), 0);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).atan() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).atan();
        },
        /**
     * Calculate the complex arcus secant
     *
     * @returns {Complex}
     */ "asec": function() {
            // asec(c) = -i * log(1 / c + sqrt(1 - i / c^2))
            var a = this["re"];
            var b = this["im"];
            if (a === 0 && b === 0) return new Complex(0, Infinity);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).acos() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).acos();
        },
        /**
     * Calculate the complex arcus cosecans
     *
     * @returns {Complex}
     */ "acsc": function() {
            // acsc(c) = -i * log(i / c + sqrt(1 - 1 / c^2))
            var a = this["re"];
            var b = this["im"];
            if (a === 0 && b === 0) return new Complex(Math.PI / 2, Infinity);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).asin() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).asin();
        },
        /**
     * Calculate the complex sinh
     *
     * @returns {Complex}
     */ "sinh": function() {
            // sinh(c) = (e^c - e^-c) / 2
            var a = this["re"];
            var b = this["im"];
            return new Complex(sinh(a) * Math.cos(b), cosh(a) * Math.sin(b));
        },
        /**
     * Calculate the complex cosh
     *
     * @returns {Complex}
     */ "cosh": function() {
            // cosh(c) = (e^c + e^-c) / 2
            var a = this["re"];
            var b = this["im"];
            return new Complex(cosh(a) * Math.cos(b), sinh(a) * Math.sin(b));
        },
        /**
     * Calculate the complex tanh
     *
     * @returns {Complex}
     */ "tanh": function() {
            // tanh(c) = (e^c - e^-c) / (e^c + e^-c)
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = cosh(a) + Math.cos(b);
            return new Complex(sinh(a) / d, Math.sin(b) / d);
        },
        /**
     * Calculate the complex coth
     *
     * @returns {Complex}
     */ "coth": function() {
            // coth(c) = (e^c + e^-c) / (e^c - e^-c)
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = cosh(a) - Math.cos(b);
            return new Complex(sinh(a) / d, -Math.sin(b) / d);
        },
        /**
     * Calculate the complex coth
     *
     * @returns {Complex}
     */ "csch": function() {
            // csch(c) = 2 / (e^c - e^-c)
            var a = this["re"];
            var b = this["im"];
            var d = Math.cos(2 * b) - cosh(2 * a);
            return new Complex(-2 * sinh(a) * Math.cos(b) / d, 2 * cosh(a) * Math.sin(b) / d);
        },
        /**
     * Calculate the complex sech
     *
     * @returns {Complex}
     */ "sech": function() {
            // sech(c) = 2 / (e^c + e^-c)
            var a = this["re"];
            var b = this["im"];
            var d = Math.cos(2 * b) + cosh(2 * a);
            return new Complex(2 * cosh(a) * Math.cos(b) / d, -2 * sinh(a) * Math.sin(b) / d);
        },
        /**
     * Calculate the complex asinh
     *
     * @returns {Complex}
     */ "asinh": function() {
            // asinh(c) = log(c + sqrt(c^2 + 1))
            var tmp = this["im"];
            this["im"] = -this["re"];
            this["re"] = tmp;
            var res = this["asin"]();
            this["re"] = -this["im"];
            this["im"] = tmp;
            tmp = res["re"];
            res["re"] = -res["im"];
            res["im"] = tmp;
            return res;
        },
        /**
     * Calculate the complex acosh
     *
     * @returns {Complex}
     */ "acosh": function() {
            // acosh(c) = log(c + sqrt(c^2 - 1))
            var res = this["acos"]();
            if (res["im"] <= 0) {
                var tmp = res["re"];
                res["re"] = -res["im"];
                res["im"] = tmp;
            } else {
                var tmp = res["im"];
                res["im"] = -res["re"];
                res["re"] = tmp;
            }
            return res;
        },
        /**
     * Calculate the complex atanh
     *
     * @returns {Complex}
     */ "atanh": function() {
            // atanh(c) = log((1+c) / (1-c)) / 2
            var a = this["re"];
            var b = this["im"];
            var noIM = a > 1 && b === 0;
            var oneMinus = 1 - a;
            var onePlus = 1 + a;
            var d = oneMinus * oneMinus + b * b;
            var x = d !== 0 ? new Complex((onePlus * oneMinus - b * b) / d, (b * oneMinus + onePlus * b) / d) : new Complex(a !== -1 ? a / 0 : 0, b !== 0 ? b / 0 : 0);
            var temp = x["re"];
            x["re"] = logHypot(x["re"], x["im"]) / 2;
            x["im"] = Math.atan2(x["im"], temp) / 2;
            if (noIM) x["im"] = -x["im"];
            return x;
        },
        /**
     * Calculate the complex acoth
     *
     * @returns {Complex}
     */ "acoth": function() {
            // acoth(c) = log((c+1) / (c-1)) / 2
            var a = this["re"];
            var b = this["im"];
            if (a === 0 && b === 0) return new Complex(0, Math.PI / 2);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).atanh() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).atanh();
        },
        /**
     * Calculate the complex acsch
     *
     * @returns {Complex}
     */ "acsch": function() {
            // acsch(c) = log((1+sqrt(1+c^2))/c)
            var a = this["re"];
            var b = this["im"];
            if (b === 0) return new Complex(a !== 0 ? Math.log(a + Math.sqrt(a * a + 1)) : Infinity, 0);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).asinh() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).asinh();
        },
        /**
     * Calculate the complex asech
     *
     * @returns {Complex}
     */ "asech": function() {
            // asech(c) = log((1+sqrt(1-c^2))/c)
            var a = this["re"];
            var b = this["im"];
            if (this["isZero"]()) return Complex["INFINITY"];
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).acosh() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).acosh();
        },
        /**
     * Calculate the complex inverse 1/z
     *
     * @returns {Complex}
     */ "inverse": function() {
            // 1 / 0 = Infinity and 1 / Infinity = 0
            if (this["isZero"]()) return Complex["INFINITY"];
            if (this["isInfinite"]()) return Complex["ZERO"];
            var a = this["re"];
            var b = this["im"];
            var d = a * a + b * b;
            return new Complex(a / d, -b / d);
        },
        /**
     * Returns the complex conjugate
     *
     * @returns {Complex}
     */ "conjugate": function() {
            return new Complex(this["re"], -this["im"]);
        },
        /**
     * Gets the negated complex number
     *
     * @returns {Complex}
     */ "neg": function() {
            return new Complex(-this["re"], -this["im"]);
        },
        /**
     * Ceils the actual complex number
     *
     * @returns {Complex}
     */ "ceil": function(places) {
            places = Math.pow(10, places || 0);
            return new Complex(Math.ceil(this["re"] * places) / places, Math.ceil(this["im"] * places) / places);
        },
        /**
     * Floors the actual complex number
     *
     * @returns {Complex}
     */ "floor": function(places) {
            places = Math.pow(10, places || 0);
            return new Complex(Math.floor(this["re"] * places) / places, Math.floor(this["im"] * places) / places);
        },
        /**
     * Ceils the actual complex number
     *
     * @returns {Complex}
     */ "round": function(places) {
            places = Math.pow(10, places || 0);
            return new Complex(Math.round(this["re"] * places) / places, Math.round(this["im"] * places) / places);
        },
        /**
     * Compares two complex numbers
     *
     * **Note:** new Complex(Infinity).equals(Infinity) === false
     *
     * @returns {boolean}
     */ "equals": function(a, b) {
            var z = new Complex(a, b);
            return Math.abs(z["re"] - this["re"]) <= Complex["EPSILON"] && Math.abs(z["im"] - this["im"]) <= Complex["EPSILON"];
        },
        /**
     * Clones the actual object
     *
     * @returns {Complex}
     */ "clone": function() {
            return new Complex(this["re"], this["im"]);
        },
        /**
     * Gets a string of the actual complex number
     *
     * @returns {string}
     */ "toString": function() {
            var a = this["re"];
            var b = this["im"];
            var ret = "";
            if (this["isNaN"]()) return "NaN";
            if (this["isInfinite"]()) return "Infinity";
            if (Math.abs(a) < Complex["EPSILON"]) a = 0;
            if (Math.abs(b) < Complex["EPSILON"]) b = 0;
            // If is real number
            if (b === 0) return ret + a;
            if (a !== 0) {
                ret += a;
                ret += " ";
                if (b < 0) {
                    b = -b;
                    ret += "-";
                } else ret += "+";
                ret += " ";
            } else if (b < 0) {
                b = -b;
                ret += "-";
            }
            if (1 !== b) ret += b;
            return ret + "i";
        },
        /**
     * Returns the actual number as a vector
     *
     * @returns {Array}
     */ "toVector": function() {
            return [
                this["re"],
                this["im"]
            ];
        },
        /**
     * Returns the actual real value of the current object
     *
     * @returns {number|null}
     */ "valueOf": function() {
            if (this["im"] === 0) return this["re"];
            return null;
        },
        /**
     * Determines whether a complex number is not on the Riemann sphere.
     *
     * @returns {boolean}
     */ "isNaN": function() {
            return isNaN(this["re"]) || isNaN(this["im"]);
        },
        /**
     * Determines whether or not a complex number is at the zero pole of the
     * Riemann sphere.
     *
     * @returns {boolean}
     */ "isZero": function() {
            return this["im"] === 0 && this["re"] === 0;
        },
        /**
     * Determines whether a complex number is not at the infinity pole of the
     * Riemann sphere.
     *
     * @returns {boolean}
     */ "isFinite": function() {
            return isFinite(this["re"]) && isFinite(this["im"]);
        },
        /**
     * Determines whether or not a complex number is at the infinity pole of the
     * Riemann sphere.
     *
     * @returns {boolean}
     */ "isInfinite": function() {
            return !(this["isNaN"]() || this["isFinite"]());
        }
    };
    Complex["ZERO"] = new Complex(0, 0);
    Complex["ONE"] = new Complex(1, 0);
    Complex["I"] = new Complex(0, 1);
    Complex["PI"] = new Complex(Math.PI, 0);
    Complex["E"] = new Complex(Math.E, 0);
    Complex["INFINITY"] = new Complex(Infinity, Infinity);
    Complex["NAN"] = new Complex(NaN, NaN);
    Complex["EPSILON"] = 1e-15;
    if (typeof define === "function" && define["amd"]) define([], function() {
        return Complex;
    });
    else {
        Object.defineProperty(Complex, "__esModule", {
            "value": true
        });
        Complex["default"] = Complex;
        Complex["Complex"] = Complex;
        $2e216b23251d121c$exports = Complex;
    }
})($2e216b23251d121c$exports);





var $97e857c901ea227e$var$name = "Complex";
var $97e857c901ea227e$var$dependencies = [];
var $97e857c901ea227e$export$24a4be44fc8b6392 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($97e857c901ea227e$var$name, $97e857c901ea227e$var$dependencies, ()=>{
    /**
   * Attach type information
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.type = "Complex";
    (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.isComplex = true;
    /**
   * Get a JSON representation of the complex number
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Complex", "re": 2, "im": 3}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.toJSON = function() {
        return {
            mathjs: "Complex",
            re: this.re,
            im: this.im
        };
    };
    /*
   * Return the value of the complex number in polar notation
   * The angle phi will be set in the interval of [-pi, pi].
   * @return {{r: number, phi: number}} Returns and object with properties r and phi.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.toPolar = function() {
        return {
            r: this.abs(),
            phi: this.arg()
        };
    };
    /**
   * Get a string representation of the complex number,
   * with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string} str
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.format = function(options) {
        var str = "";
        var im = this.im;
        var re = this.re;
        var strRe = (0, $a03283b133c3c55b$export$d9468344d3651243)(this.re, options);
        var strIm = (0, $a03283b133c3c55b$export$d9468344d3651243)(this.im, options); // round either re or im when smaller than the configured precision
        var precision = (0, $2c4f948f17aa2240$export$7e4aa119212bc614)(options) ? options : options ? options.precision : null;
        if (precision !== null) {
            var epsilon = Math.pow(10, -precision);
            if (Math.abs(re / im) < epsilon) re = 0;
            if (Math.abs(im / re) < epsilon) im = 0;
        }
        if (im === 0) // real value
        str = strRe;
        else if (re === 0) {
            // purely complex value
            if (im === 1) str = "i";
            else if (im === -1) str = "-i";
            else str = strIm + "i";
        } else {
            // complex value
            if (im < 0) {
                if (im === -1) str = strRe + " - i";
                else str = strRe + " - " + strIm.substring(1) + "i";
            } else if (im === 1) str = strRe + " + i";
            else str = strRe + " + " + strIm + "i";
        }
        return str;
    };
    /**
   * Create a complex number from polar coordinates
   *
   * Usage:
   *
   *     Complex.fromPolar(r: number, phi: number) : Complex
   *     Complex.fromPolar({r: number, phi: number}) : Complex
   *
   * @param {*} args...
   * @return {Complex}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).fromPolar = function(args) {
        switch(arguments.length){
            case 1:
                var arg = arguments[0];
                if (typeof arg === "object") return (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports)))(arg);
                else throw new TypeError("Input has to be an object with r and phi keys.");
            case 2:
                var r = arguments[0];
                var phi = arguments[1];
                if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(r)) {
                    if ((0, $2c4f948f17aa2240$export$8960dc335987b8da)(phi) && phi.hasBase("ANGLE")) // convert unit to a number in radians
                    phi = phi.toNumber("rad");
                    if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(phi)) return new (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports)))({
                        r: r,
                        phi: phi
                    });
                    throw new TypeError("Phi is not a number nor an angle unit.");
                } else throw new TypeError("Radius r is not a number.");
            default:
                throw new SyntaxError("Wrong number of arguments in function fromPolar");
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.valueOf = (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.toString;
    /**
   * Create a Complex number from a JSON object
   * @param {Object} json  A JSON Object structured as
   *                       {"mathjs": "Complex", "re": 2, "im": 3}
   *                       All properties are optional, default values
   *                       for `re` and `im` are 0.
   * @return {Complex} Returns a new Complex number
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports)))(json);
    };
    /**
   * Compare two complex numbers, `a` and `b`:
   *
   * - Returns 1 when the real part of `a` is larger than the real part of `b`
   * - Returns -1 when the real part of `a` is smaller than the real part of `b`
   * - Returns 1 when the real parts are equal
   *   and the imaginary part of `a` is larger than the imaginary part of `b`
   * - Returns -1 when the real parts are equal
   *   and the imaginary part of `a` is smaller than the imaginary part of `b`
   * - Returns 0 when both real and imaginary parts are equal.
   *
   * @params {Complex} a
   * @params {Complex} b
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).compare = function(a, b) {
        if (a.re > b.re) return 1;
        if (a.re < b.re) return -1;
        if (a.im > b.im) return 1;
        if (a.im < b.im) return -1;
        return 0;
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports));
}, {
    isClass: true
});


var $20d65ad76b85c91d$var$name = "composition";
var $20d65ad76b85c91d$var$dependencies = [
    "typed",
    "addScalar",
    "combinations",
    "isNegative",
    "isPositive",
    "isInteger",
    "larger"
];
var $20d65ad76b85c91d$export$1ddf9cbadd17315f = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($20d65ad76b85c91d$var$name, $20d65ad76b85c91d$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, combinations: combinations, isPositive: isPositive, isNegative: isNegative, isInteger: isInteger, larger: larger } = _ref;
    /**
   * The composition counts of n into k parts.
   *
   * composition only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *   math.composition(n, k)
   *
   * Examples:
   *
   *    math.composition(5, 3) // returns 6
   *
   * See also:
   *
   *    combinations
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     Returns the composition counts of n into k parts.
   */ return typed($20d65ad76b85c91d$var$name, {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || !isPositive(n) || !isInteger(k) || !isPositive(k)) throw new TypeError("Positive integer value expected in function composition");
            else if (larger(k, n)) throw new TypeError("k must be less than or equal to n in function composition");
            return combinations(addScalar(n, -1), addScalar(k, -1));
        }
    });
});







var $a08e4bc6f360edf5$var$name = "concat";
var $a08e4bc6f360edf5$var$dependencies = [
    "typed",
    "matrix",
    "isInteger"
];
var $a08e4bc6f360edf5$export$c36b5511b12560e8 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a08e4bc6f360edf5$var$name, $a08e4bc6f360edf5$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isInteger: isInteger } = _ref;
    /**
   * Concatenate two or more matrices.
   *
   * Syntax:
   *
   *     math.concat(A, B, C, ...)
   *     math.concat(A, B, C, ..., dim)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *   By default the last dimension of the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [5, 6]]
   *    const B = [[3, 4], [7, 8]]
   *
   *    math.concat(A, B)                  // returns [[1, 2, 3, 4], [5, 6, 7, 8]]
   *    math.concat(A, B, 0)               // returns [[1, 2], [5, 6], [3, 4], [7, 8]]
   *    math.concat('hello', ' ', 'world') // returns 'hello world'
   *
   * See also:
   *
   *    size, squeeze, subset, transpose
   *
   * @param {... Array | Matrix} args     Two or more matrices
   * @return {Array | Matrix} Concatenated matrix
   */ return typed($a08e4bc6f360edf5$var$name, {
        // TODO: change signature to '...Array | Matrix, dim?' when supported
        "...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumber(args) {
            var i;
            var len = args.length;
            var dim = -1; // zero-based dimension
            var prevDim;
            var asMatrix = false;
            var matrices = []; // contains multi dimensional arrays
            for(i = 0; i < len; i++){
                var arg = args[i]; // test whether we need to return a Matrix (if not we return an Array)
                if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(arg)) asMatrix = true;
                if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(arg) || (0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(arg)) {
                    if (i !== len - 1) throw new Error("Dimension must be specified as last argument");
                     // last argument contains the dimension on which to concatenate
                    prevDim = dim;
                    dim = arg.valueOf(); // change BigNumber to number
                    if (!isInteger(dim)) throw new TypeError("Integer number expected for dimension");
                    if (dim < 0 || i > 0 && dim > prevDim) // TODO: would be more clear when throwing a DimensionError here
                    throw new (0, $b954584cbe120407$export$efa5eacb1304c464)(dim, prevDim + 1);
                } else {
                    // this is a matrix or array
                    var m = (0, $33619877a15996ac$export$9cd59f9826255e47)(arg).valueOf();
                    var size = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(m);
                    matrices[i] = m;
                    prevDim = dim;
                    dim = size.length - 1; // verify whether each of the matrices has the same number of dimensions
                    if (i > 0 && dim !== prevDim) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(prevDim + 1, dim + 1);
                }
            }
            if (matrices.length === 0) throw new SyntaxError("At least one matrix expected");
            var res = matrices.shift();
            while(matrices.length)res = $a08e4bc6f360edf5$var$_concat(res, matrices.shift(), dim, 0);
            return asMatrix ? matrix(res) : res;
        },
        "...string": function string(args) {
            return args.join("");
        }
    });
});
/**
 * Recursively concatenate two matrices.
 * The contents of the matrices is not cloned.
 * @param {Array} a             Multi dimensional array
 * @param {Array} b             Multi dimensional array
 * @param {number} concatDim    The dimension on which to concatenate (zero-based)
 * @param {number} dim          The current dim (zero-based)
 * @return {Array} c            The concatenated matrix
 * @private
 */ function $a08e4bc6f360edf5$var$_concat(a, b, concatDim, dim) {
    if (dim < concatDim) {
        // recurse into next dimension
        if (a.length !== b.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(a.length, b.length);
        var c = [];
        for(var i = 0; i < a.length; i++)c[i] = $a08e4bc6f360edf5$var$_concat(a[i], b[i], concatDim, dim + 1);
        return c;
    } else // concatenate this dimension
    return a.concat(b);
}



var $15bdb7f2cb5a0211$var$name = "conj";
var $15bdb7f2cb5a0211$var$dependencies = [
    "typed"
];
var $15bdb7f2cb5a0211$export$af5efe8ad97f01a2 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($15bdb7f2cb5a0211$var$name, $15bdb7f2cb5a0211$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the complex conjugate of a complex value.
   * If `x = a+bi`, the complex conjugate of `x` is `a - bi`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.conj(x)
   *
   * Examples:
   *
   *    math.conj(math.complex('2 + 3i'))  // returns Complex 2 - 3i
   *    math.conj(math.complex('2 - 3i'))  // returns Complex 2 + 3i
   *    math.conj(math.complex('-5.2i'))  // returns Complex 5.2i
   *
   * See also:
   *
   *    re, im, arg, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            The complex conjugate of x
   */ return typed($15bdb7f2cb5a0211$var$name, {
        number: function number(x) {
            return x;
        },
        BigNumber: function BigNumber(x) {
            return x;
        },
        Complex: function Complex(x) {
            return x.conjugate();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $dcca3b987b6790eb$var$name = "cos";
var $dcca3b987b6790eb$var$dependencies = [
    "typed"
];
var $dcca3b987b6790eb$export$923b60dfa791c630 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($dcca3b987b6790eb$var$name, $dcca3b987b6790eb$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the cosine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cos(x)
   *
   * Examples:
   *
   *    math.cos(2)                      // returns number -0.4161468365471422
   *    math.cos(math.pi / 4)            // returns number  0.7071067811865475
   *    math.cos(math.unit(180, 'deg'))  // returns number -1
   *    math.cos(math.unit(60, 'deg'))   // returns number  0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Cosine of x
   */ return typed($dcca3b987b6790eb$var$name, {
        number: Math.cos,
        Complex: function Complex(x) {
            return x.cos();
        },
        BigNumber: function BigNumber(x) {
            return x.cos();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cos is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $7722fe2c00afd7b3$var$name = "cosh";
var $7722fe2c00afd7b3$var$dependencies = [
    "typed"
];
var $7722fe2c00afd7b3$export$63d35097da636c02 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($7722fe2c00afd7b3$var$name, $7722fe2c00afd7b3$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic cosine of a value,
   * defined as `cosh(x) = 1/2 * (exp(x) + exp(-x))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cosh(x)
   *
   * Examples:
   *
   *    math.cosh(0.5)       // returns number 1.1276259652063807
   *
   * See also:
   *
   *    sinh, tanh
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic cosine of x
   */ return typed($7722fe2c00afd7b3$var$name, {
        number: (0, $a03283b133c3c55b$export$2e2fd1ad24e4d350),
        Complex: function Complex(x) {
            return x.cosh();
        },
        BigNumber: function BigNumber(x) {
            return x.cosh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cosh is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $b4f24371aeeb165a$var$name = "cot";
var $b4f24371aeeb165a$var$dependencies = [
    "typed",
    "BigNumber"
];
var $b4f24371aeeb165a$export$c5598f542ea1565c = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b4f24371aeeb165a$var$name, $b4f24371aeeb165a$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the cotangent of a value. Defined as `cot(x) = 1 / tan(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cot(x)
   *
   * Examples:
   *
   *    math.cot(2)      // returns number -0.45765755436028577
   *    1 / math.tan(2)  // returns number -0.45765755436028577
   *
   * See also:
   *
   *    tan, sec, csc
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cotangent of x
   */ return typed($b4f24371aeeb165a$var$name, {
        number: (0, $b54e9ade204c059d$export$515b39f7fd07e09f),
        Complex: function Complex(x) {
            return x.cot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.tan());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cot is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $f53b70395c97bef9$var$name = "coth";
var $f53b70395c97bef9$var$dependencies = [
    "typed",
    "BigNumber"
];
var $f53b70395c97bef9$export$3f7f9b5400315e6a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($f53b70395c97bef9$var$name, $f53b70395c97bef9$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic cotangent of a value,
   * defined as `coth(x) = 1 / tanh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.coth(x)
   *
   * Examples:
   *
   *    // coth(x) = 1 / tanh(x)
   *    math.coth(2)         // returns 1.0373147207275482
   *    1 / math.tanh(2)     // returns 1.0373147207275482
   *
   * See also:
   *
   *    sinh, tanh, cosh
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic cotangent of x
   */ return typed($f53b70395c97bef9$var$name, {
        number: (0, $b54e9ade204c059d$export$925affe88b2512fc),
        Complex: function Complex(x) {
            return x.coth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.tanh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function coth is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});


var $1187bcc945cde180$var$name = "count";
var $1187bcc945cde180$var$dependencies = [
    "typed",
    "size",
    "prod"
];
var $1187bcc945cde180$export$decd32c762b504bc = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1187bcc945cde180$var$name, $1187bcc945cde180$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, prod: prod } = _ref;
    /**
   * Count the number of elements of a matrix, array or string.
   *
   * Syntax:
   *
   *     math.count(x)
   *
   * Examples:
   *
   *     math.count('hello world')        // returns 11
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.count(A)                    // returns 6
   *     math.count(math.range(1,6))      // returns 5
   *
   * See also:
   *
   *     size
   *
   * @param {string | Array | Matrix} x  A matrix or string
   * @return {number} An integer with the elements in `x`.
   */ return typed($1187bcc945cde180$var$name, {
        string: function string(x) {
            return x.length;
        },
        "Matrix | Array": function MatrixArray(x) {
            return prod(size(x));
        }
    });
});


var $de2041ace057e0bb$var$name = "createUnit";
var $de2041ace057e0bb$var$dependencies = [
    "typed",
    "Unit"
];
var $de2041ace057e0bb$export$27641941eb5cadbb = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($de2041ace057e0bb$var$name, $de2041ace057e0bb$var$dependencies, (_ref)=>{
    var { typed: typed, Unit: Unit } = _ref;
    /**
   * Create a user-defined unit and register it with the Unit type.
   *
   * Syntax:
   *
   *     math.createUnit({
   *       baseUnit1: {
   *         aliases: [string, ...]
   *         prefixes: object
   *       },
   *       unit2: {
   *         definition: string,
   *         aliases: [string, ...]
   *         prefixes: object,
   *         offset: number
   *       },
   *       unit3: string    // Shortcut
   *     })
   *
   *     // Another shortcut:
   *     math.createUnit(string, unit : string, [object])
   *
   * Examples:
   *
   *     math.createUnit('foo')
   *     math.createUnit('knot', {definition: '0.514444444 m/s', aliases: ['knots', 'kt', 'kts']})
   *     math.createUnit('mph', '1 mile/hour')
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, Unit} definition      Definition of the unit in terms of existing units. For example, '0.514444444 m / s'.
   * @param {Object} options   (optional) An object containing any of the following properties:
   *     - `prefixes {string}` "none", "short", "long", "binary_short", or "binary_long". The default is "none".
   *     - `aliases {Array}` Array of strings. Example: ['knots', 'kt', 'kts']
   *     - `offset {Numeric}` An offset to apply when converting from the unit. For example, the offset for celsius is 273.15. Default is 0.
   *
   * See also:
   *
   *     unit
   *
   * @return {Unit} The new unit
   */ return typed($de2041ace057e0bb$var$name, {
        // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
        "Object, Object": function ObjectObject(obj, options) {
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        Object: function Object(obj) {
            return Unit.createUnit(obj, {});
        },
        // Shortcut method for creating one unit.
        "string, Unit | string | Object, Object": function stringUnitStringObjectObject(name, def, options) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        "string, Unit | string | Object": function stringUnitStringObject(name, def) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, {});
        },
        // Without a definition, creates a base unit.
        string: function string(name) {
            var obj = {};
            obj[name] = {};
            return Unit.createUnit(obj, {});
        }
    });
});



var $5669faf581ad4517$var$name = "cross";
var $5669faf581ad4517$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "multiply"
];
var $5669faf581ad4517$export$bc2585c0ed744c0e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($5669faf581ad4517$var$name, $5669faf581ad4517$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, multiply: multiply } = _ref;
    /**
   * Calculate the cross product for two vectors in three dimensional space.
   * The cross product of `A = [a1, a2, a3]` and `B = [b1, b2, b3]` is defined
   * as:
   *
   *    cross(A, B) = [
   *      a2 * b3 - a3 * b2,
   *      a3 * b1 - a1 * b3,
   *      a1 * b2 - a2 * b1
   *    ]
   *
   * If one of the input vectors has a dimension greater than 1, the output
   * vector will be a 1x3 (2-dimensional) matrix.
   *
   * Syntax:
   *
   *    math.cross(x, y)
   *
   * Examples:
   *
   *    math.cross([1, 1, 0],   [0, 1, 1])       // Returns [1, -1, 1]
   *    math.cross([3, -3, 1],  [4, 9, 2])       // Returns [-15, -2, 39]
   *    math.cross([2, 3, 4],   [5, 6, 7])       // Returns [-3, 6, -3]
   *    math.cross([[1, 2, 3]], [[4], [5], [6]]) // Returns [[-3, 6, -3]]
   *
   * See also:
   *
   *    dot, multiply
   *
   * @param  {Array | Matrix} x   First vector
   * @param  {Array | Matrix} y   Second vector
   * @return {Array | Matrix}     Returns the cross product of `x` and `y`
   */ return typed($5669faf581ad4517$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return matrix(_cross(x.toArray(), y.toArray()));
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return matrix(_cross(x.toArray(), y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return matrix(_cross(x, y.toArray()));
        },
        "Array, Array": _cross
    });
    /**
   * Calculate the cross product for two arrays
   * @param {Array} x  First vector
   * @param {Array} y  Second vector
   * @returns {Array} Returns the cross product of x and y
   * @private
   */ function _cross(x, y) {
        var highestDimension = Math.max((0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x).length, (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(y).length);
        x = (0, $802b18b8c920d4c6$export$889c931173b77c2f)(x);
        y = (0, $802b18b8c920d4c6$export$889c931173b77c2f)(y);
        var xSize = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x);
        var ySize = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(y);
        if (xSize.length !== 1 || ySize.length !== 1 || xSize[0] !== 3 || ySize[0] !== 3) throw new RangeError("Vectors with length 3 expected (Size A = [" + xSize.join(", ") + "], B = [" + ySize.join(", ") + "])");
        var product = [
            subtract(multiply(x[1], y[2]), multiply(x[2], y[1])),
            subtract(multiply(x[2], y[0]), multiply(x[0], y[2])),
            subtract(multiply(x[0], y[1]), multiply(x[1], y[0]))
        ];
        if (highestDimension > 1) return [
            product
        ];
        else return product;
    }
});




var $8573ce3c9ca9115c$var$name = "csc";
var $8573ce3c9ca9115c$var$dependencies = [
    "typed",
    "BigNumber"
];
var $8573ce3c9ca9115c$export$a0beb298aa7a2962 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8573ce3c9ca9115c$var$name, $8573ce3c9ca9115c$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the cosecant of a value, defined as `csc(x) = 1/sin(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.csc(x)
   *
   * Examples:
   *
   *    math.csc(2)      // returns number 1.099750170294617
   *    1 / math.sin(2)  // returns number 1.099750170294617
   *
   * See also:
   *
   *    sin, sec, cot
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cosecant of x
   */ return typed($8573ce3c9ca9115c$var$name, {
        number: (0, $b54e9ade204c059d$export$5a8409ad16e318b2),
        Complex: function Complex(x) {
            return x.csc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.sin());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function csc is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $fae53b9923fcb02b$var$name = "csch";
var $fae53b9923fcb02b$var$dependencies = [
    "typed",
    "BigNumber"
];
var $fae53b9923fcb02b$export$9160aa3a39425fc9 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($fae53b9923fcb02b$var$name, $fae53b9923fcb02b$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic cosecant of a value,
   * defined as `csch(x) = 1 / sinh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.csch(x)
   *
   * Examples:
   *
   *    // csch(x) = 1/ sinh(x)
   *    math.csch(0.5)       // returns 1.9190347513349437
   *    1 / math.sinh(0.5)   // returns 1.9190347513349437
   *
   * See also:
   *
   *    sinh, sech, coth
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic cosecant of x
   */ return typed($fae53b9923fcb02b$var$name, {
        number: (0, $b54e9ade204c059d$export$143835b5c1db9790),
        Complex: function Complex(x) {
            return x.csch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.sinh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function csch is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});


var $0cf9f0bdf47c9467$var$name = "ctranspose";
var $0cf9f0bdf47c9467$var$dependencies = [
    "typed",
    "transpose",
    "conj"
];
var $0cf9f0bdf47c9467$export$5d07146b3894f212 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($0cf9f0bdf47c9467$var$name, $0cf9f0bdf47c9467$var$dependencies, (_ref)=>{
    var { typed: typed, transpose: transpose, conj: conj } = _ref;
    /**
   * Transpose and complex conjugate a matrix. All values of the matrix are
   * reflected over its main diagonal and then the complex conjugate is
   * taken. This is equivalent to complex conjugation for scalars and
   * vectors.
   *
   * Syntax:
   *
   *     math.ctranspose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, math.complex(6,7)]]
   *     math.ctranspose(A)               // returns [[1, 4], [2, 5], [3, {re:6,im:7}]]
   *
   * See also:
   *
   *     transpose, diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be ctransposed
   * @return {Array | Matrix}   The ctransposed matrix
   */ return typed($0cf9f0bdf47c9467$var$name, {
        any: function any(x) {
            return conj(transpose(x));
        }
    });
});




var $08b3f0c1004aaba8$var$name = "cube";
var $08b3f0c1004aaba8$var$dependencies = [
    "typed"
];
var $08b3f0c1004aaba8$export$ce223d612b94804b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($08b3f0c1004aaba8$var$name, $08b3f0c1004aaba8$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the cube of a value, `x * x * x`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cube(x)
   *
   * Examples:
   *
   *    math.cube(2)            // returns number 8
   *    math.pow(2, 3)          // returns number 8
   *    math.cube(4)            // returns number 64
   *    4 * 4 * 4               // returns number 64
   *
   *    math.cube([1, 2, 3, 4]) // returns Array [1, 8, 27, 64]
   *
   * See also:
   *
   *    multiply, square, pow, cbrt
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x  Number for which to calculate the cube
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} Cube of x
   */ return typed($08b3f0c1004aaba8$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$9505f0b39acd04c),
        Complex: function Complex(x) {
            return x.mul(x).mul(x); // Is faster than pow(x, 3)
        },
        BigNumber: function BigNumber(x) {
            return x.times(x).times(x);
        },
        Fraction: function Fraction(x) {
            return x.pow(3); // Is faster than mul()mul()mul()
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since cube(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        },
        Unit: function Unit(x) {
            return x.pow(3);
        }
    });
});





function $a15af65dbad833ab$export$c8994973cec629ae(err, fnName, value) {
    // TODO: add information with the index (also needs transform in expression parser)
    var details;
    if (String(err).indexOf("Unexpected type") !== -1) {
        details = arguments.length > 2 ? " (type: " + (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(value) + ", value: " + JSON.stringify(value) + ")" : " (type: " + err.data.actual + ")";
        return new TypeError("Cannot calculate " + fnName + ", unexpected type of argument" + details);
    }
    if (String(err).indexOf("complex numbers") !== -1) {
        details = arguments.length > 2 ? " (type: " + (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(value) + ", value: " + JSON.stringify(value) + ")" : "";
        return new TypeError("Cannot calculate " + fnName + ", no ordering relation is defined for complex numbers" + details);
    }
    return err;
}




var $1ffc641b3300209d$var$name = "cumsum";
var $1ffc641b3300209d$var$dependencies = [
    "typed",
    "add",
    "unaryPlus"
];
var $1ffc641b3300209d$export$e11ffe2ce577c262 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1ffc641b3300209d$var$name, $1ffc641b3300209d$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, unaryPlus: unaryPlus } = _ref;
    /**
   * Compute the cumulative sum of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the cumulative sums
   * along a specified dimension (defaulting to the first) will be calculated.
   *
   * Syntax:
   *
   *     math.cumsum(a, b, c, ...)
   *     math.cumsum(A)
   *
   * Examples:
   *
   *     math.cumsum(2, 1, 4, 3)               // returns [2, 3, 7, 10]
   *     math.cumsum([2, 1, 4, 3])             // returns [2, 3, 7, 10]
   *     math.cumsum([[1, 2], [3, 4]])         // returns [[1, 2], [4, 6]]
   *     math.cumsum([[1, 2], [3, 4]], 0)      // returns [[1, 2], [4, 6]]
   *     math.cumsum([[1, 2], [3, 4]], 1)      // returns [[1, 3], [3, 7]]
   *     math.cumsum([[2, 5], [4, 3], [1, 7]]) // returns [[2, 5], [6, 8], [7, 15]]
   *
   * See also:
   *
   *    mean, median, min, max, prod, std, variance, sum
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The cumulative sum of all values
   */ return typed($1ffc641b3300209d$var$name, {
        // sum([a, b, c, d, ...])
        Array: _cumsum,
        Matrix: function Matrix(matrix) {
            return matrix.create(_cumsum(matrix.valueOf()));
        },
        // sum([a, b, c, d, ...], dim)
        "Array, number | BigNumber": _ncumSumDim,
        "Matrix, number | BigNumber": function MatrixNumberBigNumber(matrix, dim) {
            return matrix.create(_ncumSumDim(matrix.valueOf(), dim));
        },
        // cumsum(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $cd13353fc76500f7$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("All values expected to be scalar in function cumsum");
            return _cumsum(args);
        }
    });
    /**
     * Recursively calculate the cumulative sum of an n-dimensional array
     * @param {Array} array
     * @return {number} cumsum
     * @private
     */ function _cumsum(array) {
        try {
            return _cumsummap(array);
        } catch (err) {
            throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, $1ffc641b3300209d$var$name);
        }
    }
    function _cumsummap(array) {
        if (array.length === 0) return [];
        var sums = [
            unaryPlus(array[0])
        ]; // unaryPlus converts to number if need be
        for(var i = 1; i < array.length; ++i)// Must use add below and not addScalar for the case of summing a
        // 2+-dimensional array along the 0th dimension (the row vectors,
        // or higher-d analogues, are literally added to each other).
        sums.push(add(sums[i - 1], array[i]));
        return sums;
    }
    function _ncumSumDim(array, dim) {
        var size = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(array);
        if (dim < 0 || dim >= size.length) // TODO: would be more clear when throwing a DimensionError here
        throw new (0, $b954584cbe120407$export$efa5eacb1304c464)(dim, size.length);
        try {
            return _cumsumDimensional(array, dim);
        } catch (err) {
            throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, $1ffc641b3300209d$var$name);
        }
    }
    /* Possible TODO: Refactor _reduce in collection.js to be able to work here as well */ function _cumsumDimensional(mat, dim) {
        var i, ret, tran;
        if (dim <= 0) {
            var initialValue = mat[0][0];
            if (!Array.isArray(initialValue)) return _cumsummap(mat);
            else {
                tran = (0, $63e2b34a916dc57b$export$424b8b2ab9af2944)(mat);
                ret = [];
                for(i = 0; i < tran.length; i++)ret[i] = _cumsumDimensional(tran[i], dim - 1);
                return ret;
            }
        } else {
            ret = [];
            for(i = 0; i < mat.length; i++)ret[i] = _cumsumDimensional(mat[i], dim - 1);
            return ret;
        }
    }
});


var $8cc4e85650e794bb$var$name = "deepEqual";
var $8cc4e85650e794bb$var$dependencies = [
    "typed",
    "equal"
];
var $8cc4e85650e794bb$export$b1b11fc839367b58 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8cc4e85650e794bb$var$name, $8cc4e85650e794bb$var$dependencies, (_ref)=>{
    var { typed: typed, equal: equal } = _ref;
    /**
   * Test element wise whether two matrices are equal.
   * The function accepts both matrices and scalar values.
   *
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.deepEqual(x, y)
   *
   * Examples:
   *
   *    math.deepEqual(2, 4)   // returns false
   *
   *    a = [2, 5, 1]
   *    b = [2, 7, 1]
   *
   *    math.deepEqual(a, b)   // returns false
   *    math.equal(a, b)       // returns [true, false, true]
   *
   * See also:
   *
   *    equal, unequal
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First matrix to compare
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second matrix to compare
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns true when the input matrices have the same size and each of their elements is equal.
   */ return typed($8cc4e85650e794bb$var$name, {
        "any, any": function anyAny(x, y) {
            return _deepEqual(x.valueOf(), y.valueOf());
        }
    });
    /**
   * Test whether two arrays have the same size and all elements are equal
   * @param {Array | *} x
   * @param {Array | *} y
   * @return {boolean} Returns true if both arrays are deep equal
   */ function _deepEqual(x, y) {
        if (Array.isArray(x)) {
            if (Array.isArray(y)) {
                var len = x.length;
                if (len !== y.length) return false;
                for(var i = 0; i < len; i++){
                    if (!_deepEqual(x[i], y[i])) return false;
                }
                return true;
            } else return false;
        } else {
            if (Array.isArray(y)) return false;
            else return equal(x, y);
        }
    }
});








var $cba7468445748363$var$name = "DenseMatrix";
var $cba7468445748363$var$dependencies = [
    "Matrix"
];
var $cba7468445748363$export$1a088ca8dd364cd1 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($cba7468445748363$var$name, $cba7468445748363$var$dependencies, (_ref)=>{
    var { Matrix: Matrix } = _ref;
    /**
   * Dense Matrix implementation. A regular, dense matrix, supporting multi-dimensional matrices. This is the default matrix type.
   * @class DenseMatrix
   * @enum {{ value, index: number[] }}
   */ function DenseMatrix(data, datatype) {
        if (!(this instanceof DenseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $2c4f948f17aa2240$export$844ec244b1367d54)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(data)) {
            // check data is a DenseMatrix
            if (data.type === "DenseMatrix") {
                // clone data & size
                this._data = (0, $33619877a15996ac$export$9cd59f9826255e47)(data._data);
                this._size = (0, $33619877a15996ac$export$9cd59f9826255e47)(data._size);
                this._datatype = datatype || data._datatype;
            } else {
                // build data from existing matrix
                this._data = data.toArray();
                this._size = data.size();
                this._datatype = datatype || data._datatype;
            }
        } else if (data && (0, $2c4f948f17aa2240$export$43bee75e5e14138e)(data.data) && (0, $2c4f948f17aa2240$export$43bee75e5e14138e)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size; // verify the dimensions of the array
            (0, $802b18b8c920d4c6$export$a22775fa5e2eebd9)(this._data, this._size);
            this._datatype = datatype || data.datatype;
        } else if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(data)) {
            // replace nested Matrices with Arrays
            this._data = preprocess(data); // get the dimensions of the array
            this._size = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(this._data); // verify the dimensions of the array, TODO: compute size while processing array
            (0, $802b18b8c920d4c6$export$a22775fa5e2eebd9)(this._data, this._size); // data type unknown
            this._datatype = datatype;
        } else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(data) + ")");
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
        }
    }
    DenseMatrix.prototype = new Matrix();
    /**
   * Create a new DenseMatrix
   */ DenseMatrix.prototype.createDenseMatrix = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ DenseMatrix.prototype.type = "DenseMatrix";
    DenseMatrix.prototype.isDenseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf DenseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ DenseMatrix.prototype.getDataType = function() {
        return (0, $802b18b8c920d4c6$export$d31e00bf4359ea8b)(this._data, (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()  // retrieve storage format
   *
   * @memberof DenseMatrix
   * @return {string}           The storage format.
   */ DenseMatrix.prototype.storage = function() {
        return "dense";
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()   // retrieve matrix datatype
   *
   * @memberof DenseMatrix
   * @return {string}           The datatype.
   */ DenseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new DenseMatrix
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ DenseMatrix.prototype.create = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof DenseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ DenseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        switch(arguments.length){
            case 1:
                return _get(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _set(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    /**
   * Get a single element from the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ DenseMatrix.prototype.get = function(index) {
        if (!(0, $2c4f948f17aa2240$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(index.length, this._size.length);
         // check index
        for(var x = 0; x < index.length; x++)(0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(index[x], this._size[x]);
        var data = this._data;
        for(var i = 0, ii = index.length; i < ii; i++){
            var indexI = index[i];
            (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(indexI, data.length);
            data = data[indexI];
        }
        return data;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {DenseMatrix} self
   */ DenseMatrix.prototype.set = function(index, value, defaultValue) {
        if (!(0, $2c4f948f17aa2240$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length < this._size.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(index.length, this._size.length, "<");
        var i, ii, indexI; // enlarge matrix when needed
        var size = index.map(function(i) {
            return i + 1;
        });
        _fit(this, size, defaultValue); // traverse over the dimensions
        var data = this._data;
        for(i = 0, ii = index.length - 1; i < ii; i++){
            indexI = index[i];
            (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(indexI, data.length);
            data = data[indexI];
        } // set new value
        indexI = index[index.length - 1];
        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(indexI, data.length);
        data[indexI] = value;
        return this;
    };
    /**
   * Get a submatrix of this matrix
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index   Zero-based index
   * @private
   */ function _get(matrix, index) {
        if (!(0, $2c4f948f17aa2240$export$ba3dc792055c2f45)(index)) throw new TypeError("Invalid index");
        var isScalar = index.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(index.min());
        else {
            // validate dimensions
            var size = index.size();
            if (size.length !== matrix._size.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(size.length, matrix._size.length);
             // validate if any of the ranges in the index is out of range
            var min = index.min();
            var max = index.max();
            for(var i = 0, ii = matrix._size.length; i < ii; i++){
                (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(min[i], matrix._size[i]);
                (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(max[i], matrix._size[i]);
            } // retrieve submatrix
            // TODO: more efficient when creating an empty matrix and setting _data and _size manually
            return new DenseMatrix(_getSubmatrix(matrix._data, index, size.length, 0), matrix._datatype);
        }
    }
    /**
   * Recursively get a submatrix of a multi dimensional matrix.
   * Index is not checked for correct number or length of dimensions.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {number} dims   Total number of dimensions
   * @param {number} dim    Current dimension
   * @return {Array} submatrix
   * @private
   */ function _getSubmatrix(data, index, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) return range.map(function(i) {
            (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(i, data.length);
            return data[i];
        }).valueOf();
        else return range.map(function(i) {
            (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(i, data.length);
            var child = data[i];
            return _getSubmatrix(child, index, dims, dim + 1);
        }).valueOf();
    }
    /**
   * Replace a submatrix in this matrix
   * Indexes are zero-based.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index
   * @param {DenseMatrix | Array | *} submatrix
   * @param {*} defaultValue          Default value, filled in on new entries when
   *                                  the matrix is resized.
   * @return {DenseMatrix} matrix
   * @private
   */ function _set(matrix, index, submatrix, defaultValue) {
        if (!index || index.isIndex !== true) throw new TypeError("Invalid index");
         // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(submatrix)) {
            sSize = submatrix.size();
            submatrix = submatrix.valueOf();
        } else sSize = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(submatrix);
        if (isScalar) {
            // set a scalar
            // check whether submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError("Scalar expected");
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // set a submatrix
            // validate dimensions
            if (iSize.length < matrix._size.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(iSize.length, matrix._size.length, "<");
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                } // unsqueeze both outer and inner dimensions
                submatrix = (0, $802b18b8c920d4c6$export$5a07c5202d40a604)(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size
            if (!(0, $33619877a15996ac$export$6cc798251952180)(iSize, sSize)) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(iSize, sSize, ">");
             // enlarge matrix when needed
            var size = index.max().map(function(i) {
                return i + 1;
            });
            _fit(matrix, size, defaultValue); // insert the sub matrix
            var dims = iSize.length;
            var dim = 0;
            _setSubmatrix(matrix._data, index, submatrix, dims, dim);
        }
        return matrix;
    }
    /**
   * Replace a submatrix of a multi dimensional matrix.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {Array} submatrix
   * @param {number} dims   Total number of dimensions
   * @param {number} dim
   * @private
   */ function _setSubmatrix(data, index, submatrix, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) range.forEach(function(dataIndex, subIndex) {
            (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(dataIndex);
            data[dataIndex] = submatrix[subIndex[0]];
        });
        else range.forEach(function(dataIndex, subIndex) {
            (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(dataIndex);
            _setSubmatrix(data[dataIndex], index, submatrix[subIndex[0]], dims, dim + 1);
        });
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof DenseMatrix
   * @param {number[] || Matrix} size The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ DenseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $2c4f948f17aa2240$export$cea7aa84e978eba5)(size)) throw new TypeError("Array or Matrix expected");
         // SparseMatrix input is always 2d, flatten this into 1d if it's indeed a vector
        var sizeArray = size.valueOf().map((value)=>{
            return Array.isArray(value) && value.length === 1 ? value[0] : value;
        }); // matrix to resize
        var m = copy ? this.clone() : this; // resize matrix
        return _resize(m, sizeArray, defaultValue);
    };
    function _resize(matrix, size, defaultValue) {
        // check size
        if (size.length === 0) {
            // first value in matrix
            var v = matrix._data; // go deep
            while((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(v))v = v[0];
            return v;
        } // resize matrix
        matrix._size = size.slice(0); // copy the array
        matrix._data = (0, $802b18b8c920d4c6$export$4380c87abf28fdf)(matrix._data, matrix._size, defaultValue); // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof DenseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ DenseMatrix.prototype.reshape = function(size, copy) {
        var m = copy ? this.clone() : this;
        m._data = (0, $802b18b8c920d4c6$export$9eaad88cf88cee2b)(m._data, size);
        var currentLength = m._size.reduce((length, size)=>length * size);
        m._size = (0, $802b18b8c920d4c6$export$d0efc868ac2c6822)(size, currentLength);
        return m;
    };
    /**
   * Enlarge the matrix when it is smaller than given size.
   * If the matrix is larger or equal sized, nothing is done.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix           The matrix to be resized
   * @param {number[]} size
   * @param {*} defaultValue          Default value, filled in on new entries.
   * @private
   */ function _fit(matrix, size, defaultValue) {
        var newSize = matrix._size.slice(0);
        var changed = false; // add dimensions when needed
        while(newSize.length < size.length){
            newSize.push(0);
            changed = true;
        } // enlarge size when needed
        for(var i = 0, ii = size.length; i < ii; i++)if (size[i] > newSize[i]) {
            newSize[i] = size[i];
            changed = true;
        }
        if (changed) // resize only when size is changed
        _resize(matrix, newSize, defaultValue);
    }
    /**
   * Create a clone of the matrix
   * @memberof DenseMatrix
   * @return {DenseMatrix} clone
   */ DenseMatrix.prototype.clone = function() {
        var m = new DenseMatrix({
            data: (0, $33619877a15996ac$export$9cd59f9826255e47)(this._data),
            size: (0, $33619877a15996ac$export$9cd59f9826255e47)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof DenseMatrix
   * @returns {number[]} size
   */ DenseMatrix.prototype.size = function() {
        return this._size.slice(0); // return a clone of _size
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   *
   * @return {DenseMatrix} matrix
   */ DenseMatrix.prototype.map = function(callback) {
        // matrix instance
        var me = this;
        var recurse = function recurse(value, index) {
            if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(value)) return value.map(function(child, i) {
                return recurse(child, index.concat(i));
            });
            else return callback(value, index, me);
        }; // determine the new datatype when the original matrix has datatype defined
        // TODO: should be done in matrix constructor instead
        var data = recurse(this._data, []);
        var datatype = this._datatype !== undefined ? (0, $802b18b8c920d4c6$export$d31e00bf4359ea8b)(data, (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)) : undefined;
        return new DenseMatrix(data, datatype);
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ DenseMatrix.prototype.forEach = function(callback) {
        // matrix instance
        var me = this;
        var recurse = function recurse(value, index) {
            if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(value)) value.forEach(function(child, i) {
                recurse(child, index.concat(i));
            });
            else callback(value, index, me);
        };
        recurse(this._data, []);
    };
    /**
   * Iterate over the matrix elements
   * @return {Iterable<{ value, index: number[] }>}
   */ DenseMatrix.prototype[Symbol.iterator] = function*() {
        var recurse = function* recurse(value, index) {
            if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(value)) for(var i = 0; i < value.length; i++)yield* recurse(value[i], index.concat(i));
            else yield {
                value: value,
                index: index
            };
        };
        yield* recurse(this._data, []);
    };
    /**
   * Returns an array containing the rows of a 2D matrix
   * @returns {Array<Matrix>}
   */ DenseMatrix.prototype.rows = function() {
        var result = [];
        var s = this.size();
        if (s.length !== 2) throw new TypeError("Rows can only be returned for a 2D matrix.");
        var data = this._data;
        for (var row of data)result.push(new DenseMatrix([
            row
        ], this._datatype));
        return result;
    };
    /**
   * Returns an array containing the columns of a 2D matrix
   * @returns {Array<Matrix>}
   */ DenseMatrix.prototype.columns = function() {
        var _this = this;
        var result = [];
        var s = this.size();
        if (s.length !== 2) throw new TypeError("Rows can only be returned for a 2D matrix.");
        var data = this._data;
        var _loop = function _loop(i) {
            var col = data.map((row)=>[
                    row[i]
                ]);
            result.push(new DenseMatrix(col, _this._datatype));
        };
        for(var i = 0; i < s[1]; i++)_loop(i);
        return result;
    };
    /**
   * Create an Array with a copy of the data of the DenseMatrix
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.toArray = function() {
        return (0, $33619877a15996ac$export$9cd59f9826255e47)(this._data);
    };
    /**
   * Get the primitive value of the DenseMatrix: a multidimensional array
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.valueOf = function() {
        return this._data;
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof DenseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ DenseMatrix.prototype.format = function(options) {
        return (0, $addf7cb66573d3e4$export$d9468344d3651243)(this._data, options);
    };
    /**
   * Get a string representation of the matrix
   * @memberof DenseMatrix
   * @returns {string} str
   */ DenseMatrix.prototype.toString = function() {
        return (0, $addf7cb66573d3e4$export$d9468344d3651243)(this._data);
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof DenseMatrix
   * @returns {Object}
   */ DenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "DenseMatrix",
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof DenseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix with the diagonal values.
   */ DenseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(k) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper); // x is a matrix get diagonal from matrix
        var data = []; // loop rows
        for(var i = 0; i < n; i++)data[i] = this._data[i + kSub][i + kSuper];
         // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                n
            ],
            datatype: this._datatype
        });
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof DenseMatrix
   * @param {Array} size                     The matrix size.
   * @param {number | Matrix | Array } value The values for the diagonal.
   * @param {number | BigNumber} [k=0]       The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]          The default value for non-diagonal
   * @param {string} [datatype]              The datatype for the diagonal
   *
   * @returns {DenseMatrix}
   */ DenseMatrix.diagonal = function(size, value, k, defaultValue) {
        if (!(0, $2c4f948f17aa2240$export$43bee75e5e14138e)(size)) throw new TypeError("Array expected, size parameter");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(s)) // convert it
            s = s.toNumber();
             // validate arguments
            if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(s) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(s) || s < 1) throw new Error("Size values must be positive integers");
            return s;
        }); // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(k) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows and columns
        var rows = size[0];
        var columns = size[1]; // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper); // value extraction function
        var _value; // check value
        if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error("Invalid value array length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(value)) {
            // matrix size
            var ms = value.size(); // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error("Invalid matrix length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
         // discover default value if needed
        if (!defaultValue) // check first value in array
        defaultValue = (0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(_value(0)) ? _value(0).mul(0) // trick to create a BigNumber with value zero
         : 0;
         // empty array
        var data = []; // check we need to resize array
        if (size.length > 0) {
            // resize array
            data = (0, $802b18b8c920d4c6$export$4380c87abf28fdf)(data, size, defaultValue); // fill diagonal
            for(var d = 0; d < n; d++)data[d + kSub][d + kSuper] = _value(d);
        } // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof DenseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "DenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {DenseMatrix}
   */ DenseMatrix.fromJSON = function(json) {
        return new DenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof DenseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ DenseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(i) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(i) || !(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(j) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(j)) throw new Error("Row index must be positive integers");
         // check dimensions
        if (this._size.length !== 2) throw new Error("Only two dimensional matrix is supported");
         // validate index
        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(i, this._size[0]);
        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(j, this._size[0]); // swap rows
        DenseMatrix._swapRows(i, j, this._data); // return current instance
        return this;
    };
    /**
   * Swap rows i and j in Dense Matrix data structure.
   *
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   * @param {Array} data     Matrix data
   */ DenseMatrix._swapRows = function(i, j, data) {
        // swap values i <-> j
        var vi = data[i];
        data[i] = data[j];
        data[j] = vi;
    };
    /**
   * Preprocess data, which can be an Array or DenseMatrix with nested Arrays and
   * Matrices. Replaces all nested Matrices with Arrays
   * @memberof DenseMatrix
   * @param {Array} data
   * @return {Array} data
   */ function preprocess(data) {
        for(var i = 0, ii = data.length; i < ii; i++){
            var elem = data[i];
            if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(elem)) data[i] = preprocess(elem);
            else if (elem && elem.isMatrix === true) data[i] = preprocess(elem.valueOf());
        }
        return data;
    }
    return DenseMatrix;
}, {
    isClass: true
});





var $505fb7024bf95a58$var$name = "det";
var $505fb7024bf95a58$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "multiply",
    "divideScalar",
    "isZero",
    "unaryMinus"
];
var $505fb7024bf95a58$export$93f810683c54b005 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($505fb7024bf95a58$var$name, $505fb7024bf95a58$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, multiply: multiply, divideScalar: divideScalar, isZero: isZero, unaryMinus: unaryMinus } = _ref;
    /**
   * Calculate the determinant of a matrix.
   *
   * Syntax:
   *
   *    math.det(x)
   *
   * Examples:
   *
   *    math.det([[1, 2], [3, 4]]) // returns -2
   *
   *    const A = [
   *      [-2, 2, 3],
   *      [-1, 1, 3],
   *      [2, 0, -1]
   *    ]
   *    math.det(A) // returns 6
   *
   * See also:
   *
   *    inv
   *
   * @param {Array | Matrix} x  A matrix
   * @return {number} The determinant of `x`
   */ return typed($505fb7024bf95a58$var$name, {
        any: function any(x) {
            return (0, $33619877a15996ac$export$9cd59f9826255e47)(x);
        },
        "Array | Matrix": function det(x) {
            var size;
            if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(x)) size = x.size();
            else if (Array.isArray(x)) {
                x = matrix(x);
                size = x.size();
            } else // a scalar
            size = [];
            switch(size.length){
                case 0:
                    // scalar
                    return (0, $33619877a15996ac$export$9cd59f9826255e47)(x);
                case 1:
                    // vector
                    if (size[0] === 1) return (0, $33619877a15996ac$export$9cd59f9826255e47)(x.valueOf()[0]);
                    else throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
                case 2:
                    // two dimensional array
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _det(x.clone().valueOf(), rows, cols);
                    else throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
            }
        }
    });
    /**
   * Calculate the determinant of a matrix
   * @param {Array[]} matrix  A square, two dimensional matrix
   * @param {number} rows     Number of rows of the matrix (zero-based)
   * @param {number} cols     Number of columns of the matrix (zero-based)
   * @returns {number} det
   * @private
   */ function _det(matrix, rows, cols) {
        if (rows === 1) // this is a 1 x 1 matrix
        return (0, $33619877a15996ac$export$9cd59f9826255e47)(matrix[0][0]);
        else if (rows === 2) // this is a 2 x 2 matrix
        // the determinant of [a11,a12;a21,a22] is det = a11*a22-a21*a12
        return subtract(multiply(matrix[0][0], matrix[1][1]), multiply(matrix[1][0], matrix[0][1]));
        else {
            // Bareiss algorithm
            // this algorithm have same complexity as LUP decomposition (O(n^3))
            // but it preserve precision of floating point more relative to the LUP decomposition
            var negated = false;
            var rowIndices = new Array(rows).fill(0).map((_, i)=>i); // matrix index of row i
            for(var k = 0; k < rows; k++){
                var k_ = rowIndices[k];
                if (isZero(matrix[k_][k])) {
                    var _k = void 0;
                    for(_k = k + 1; _k < rows; _k++)if (!isZero(matrix[rowIndices[_k]][k])) {
                        k_ = rowIndices[_k];
                        rowIndices[_k] = rowIndices[k];
                        rowIndices[k] = k_;
                        negated = !negated;
                        break;
                    }
                    if (_k === rows) return matrix[k_][k]; // some zero of the type
                }
                var piv = matrix[k_][k];
                var piv_ = k === 0 ? 1 : matrix[rowIndices[k - 1]][k - 1];
                for(var i = k + 1; i < rows; i++){
                    var i_ = rowIndices[i];
                    for(var j = k + 1; j < rows; j++)matrix[i_][j] = divideScalar(subtract(multiply(matrix[i_][j], piv), multiply(matrix[i_][k], matrix[k_][j])), piv_);
                }
            }
            var det = matrix[rowIndices[rows - 1]][rows - 1];
            return negated ? unaryMinus(det) : det;
        }
    }
});





var $292157f960c71f3f$var$name = "diag";
var $292157f960c71f3f$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix",
    "SparseMatrix"
];
var $292157f960c71f3f$export$743a950f2cd4bacc = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($292157f960c71f3f$var$name, $292157f960c71f3f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a diagonal matrix or retrieve the diagonal of a matrix
   *
   * When `x` is a vector, a matrix with vector `x` on the diagonal will be returned.
   * When `x` is a two dimensional matrix, the matrixes `k`th diagonal will be returned as vector.
   * When k is positive, the values are placed on the super diagonal.
   * When k is negative, the values are placed on the sub diagonal.
   *
   * Syntax:
   *
   *     math.diag(X)
   *     math.diag(X, format)
   *     math.diag(X, k)
   *     math.diag(X, k, format)
   *
   * Examples:
   *
   *     // create a diagonal matrix
   *     math.diag([1, 2, 3])      // returns [[1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *     math.diag([1, 2, 3], 1)   // returns [[0, 1, 0, 0], [0, 0, 2, 0], [0, 0, 0, 3]]
   *     math.diag([1, 2, 3], -1)  // returns [[0, 0, 0], [1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *
   *    // retrieve the diagonal from a matrix
   *    const a = [[1, 2, 3], [4, 5, 6], [7, 8, 9]]
   *    math.diag(a)   // returns [1, 5, 9]
   *
   * See also:
   *
   *     ones, zeros, identity
   *
   * @param {Matrix | Array} x          A two dimensional matrix or a vector
   * @param {number | BigNumber} [k=0]  The diagonal where the vector will be filled
   *                                    in or retrieved.
   * @param {string} [format='dense']   The matrix storage format.
   *
   * @returns {Matrix | Array} Diagonal matrix from input vector, or diagonal from input matrix.
   */ return typed($292157f960c71f3f$var$name, {
        // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
        Array: function Array(x) {
            return _diag(x, 0, (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x), null);
        },
        "Array, number": function ArrayNumber(x, k) {
            return _diag(x, k, (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x), null);
        },
        "Array, BigNumber": function ArrayBigNumber(x, k) {
            return _diag(x, k.toNumber(), (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x), null);
        },
        "Array, string": function ArrayString(x, format) {
            return _diag(x, 0, (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x), format);
        },
        "Array, number, string": function ArrayNumberString(x, k, format) {
            return _diag(x, k, (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x), format);
        },
        "Array, BigNumber, string": function ArrayBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x), format);
        },
        Matrix: function Matrix(x) {
            return _diag(x, 0, x.size(), x.storage());
        },
        "Matrix, number": function MatrixNumber(x, k) {
            return _diag(x, k, x.size(), x.storage());
        },
        "Matrix, BigNumber": function MatrixBigNumber(x, k) {
            return _diag(x, k.toNumber(), x.size(), x.storage());
        },
        "Matrix, string": function MatrixString(x, format) {
            return _diag(x, 0, x.size(), format);
        },
        "Matrix, number, string": function MatrixNumberString(x, k, format) {
            return _diag(x, k, x.size(), format);
        },
        "Matrix, BigNumber, string": function MatrixBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), x.size(), format);
        }
    });
    /**
   * Creeate diagonal matrix from a vector or vice versa
   * @param {Array | Matrix} x
   * @param {number} k
   * @param {string} format Storage format for matrix. If null,
   *                          an Array is returned
   * @returns {Array | Matrix}
   * @private
   */ function _diag(x, k, size, format) {
        if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(k)) throw new TypeError("Second parameter in function diag must be an integer");
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // check dimensions
        switch(size.length){
            case 1:
                return _createDiagonalMatrix(x, k, format, size[0], kSub, kSuper);
            case 2:
                return _getDiagonal(x, k, format, size, kSub, kSuper);
        }
        throw new RangeError("Matrix for function diag must be 2 dimensional");
    }
    function _createDiagonalMatrix(x, k, format, l, kSub, kSuper) {
        // matrix size
        var ms = [
            l + kSub,
            l + kSuper
        ];
        if (format && format !== "sparse" && format !== "dense") throw new TypeError("Unknown matrix type ".concat(format, '"'));
         // create diagonal matrix
        var m = format === "sparse" ? SparseMatrix.diagonal(ms, x, k) : DenseMatrix.diagonal(ms, x, k); // check we need to return a matrix
        return format !== null ? m : m.valueOf();
    }
    function _getDiagonal(x, k, format, s, kSub, kSuper) {
        // check x is a Matrix
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(x)) {
            // get diagonal matrix
            var dm = x.diagonal(k); // check we need to return a matrix
            if (format !== null) {
                // check we need to change matrix format
                if (format !== dm.storage()) return matrix(dm, format);
                return dm;
            }
            return dm.valueOf();
        } // vector size
        var n = Math.min(s[0] - kSub, s[1] - kSuper); // diagonal values
        var vector = []; // loop diagonal
        for(var i = 0; i < n; i++)vector[i] = x[i + kSub][i + kSuper];
         // check we need to return a matrix
        return format !== null ? matrix(vector) : vector;
    }
});




var $54b1b5983775b69c$var$name = "diff";
var $54b1b5983775b69c$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "number"
];
var $54b1b5983775b69c$export$49df08fd121951b4 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($54b1b5983775b69c$var$name, $54b1b5983775b69c$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, number: number } = _ref;
    /**
   * Create a new matrix or array of the difference between elements of the given array
   * The optional dim parameter lets you specify the dimension to evaluate the difference of
   * If no dimension parameter is passed it is assumed as dimension 0
   *
   * Dimension is zero-based in javascript and one-based in the parser and can be a number or bignumber
   * Arrays must be 'rectangular' meaning arrays like [1, 2]
   * If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays
   *
   * Syntax:
   *
   *     math.diff(arr)
   *     math.diff(arr, dim)
   *
   * Examples:
   *
   *     const arr = [1, 2, 4, 7, 0]
   *     math.diff(arr) // returns [1, 2, 3, -7] (no dimension passed so 0 is assumed)
   *     math.diff(math.matrix(arr)) // returns math.matrix([1, 2, 3, -7])
   *
   *     const arr = [[1, 2, 3, 4, 5], [1, 2, 3, 4, 5], [9, 8, 7, 6, 4]]
   *     math.diff(arr) // returns [[0, 0, 0, 0, 0], [8, 6, 4, 2, -1]]
   *     math.diff(arr, 0) // returns [[0, 0, 0, 0, 0], [8, 6, 4, 2, -1]]
   *     math.diff(arr, 1) // returns [[1, 1, 1, 1], [1, 1, 1, 1], [-1, -1, -1, -2]]
   *     math.diff(arr, math.bignumber(1)) // returns [[1, 1, 1, 1], [1, 1, 1, 1], [-1, -1, -1, -2]]
   *
   *     math.diff(arr, 2) // throws RangeError as arr is 2 dimensional not 3
   *     math.diff(arr, -1) // throws RangeError as negative dimensions are not allowed
   *
   *     // These will all produce the same result
   *     math.diff([[1, 2], [3, 4]])
   *     math.diff([math.matrix([1, 2]), math.matrix([3, 4])])
   *     math.diff([[1, 2], math.matrix([3, 4])])
   *     math.diff([math.matrix([1, 2]), [3, 4]])
   *     // They do not produce the same result as  math.diff(math.matrix([[1, 2], [3, 4]])) as this returns a matrix
   *
   * See Also:
   *
   *      sum
   *      subtract
   *      partitionSelect
   *
   * @param {Array | Matrix} arr    An array or matrix
   * @param {number} dim            Dimension
   * @return {Array | Matrix}       Difference between array elements in given dimension
   */ return typed($54b1b5983775b69c$var$name, {
        "Array | Matrix": function ArrayMatrix(arr) {
            // No dimension specified => assume dimension 0
            if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(arr)) return matrix(_diff(arr.toArray()));
            else return _diff(arr);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(arr, dim) {
            if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(dim)) throw new RangeError("Dimension must be a whole number");
            if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(arr)) return matrix(_recursive(arr.toArray(), dim));
            else return _recursive(arr, dim);
        },
        "Array | Matrix, BigNumber": function ArrayMatrixBigNumber(arr, dim) {
            return this(arr, number(dim));
        }
    });
    /**
   * Recursively find the correct dimension in the array/matrix
   * Then Apply _diff to that dimension
   *
   * @param {Array} arr      The array
   * @param {number} dim     Dimension
   * @return {Array}         resulting array
   */ function _recursive(arr, dim) {
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(arr)) arr = arr.toArray(); // Makes sure arrays like [ matrix([0, 1]), matrix([1, 0]) ] are processed properly
        if (!Array.isArray(arr)) throw RangeError("Array/Matrix does not have that many dimensions");
        if (dim > 0) {
            var result = [];
            arr.forEach((element)=>{
                result.push(_recursive(element, dim - 1));
            });
            return result;
        } else if (dim === 0) return _diff(arr);
        else throw RangeError("Cannot have negative dimension");
    }
    /**
   * Difference between elements in the array
   *
   * @param {Array} arr      An array
   * @return {Array}         resulting array
   */ function _diff(arr) {
        var result = [];
        var size = arr.length;
        if (size < 2) return arr;
        for(var i = 1; i < size; i++)result.push(_ElementDiff(arr[i - 1], arr[i]));
        return result;
    }
    /**
   * Difference between 2 objects
   *
   * @param {Object} obj1    First object
   * @param {Object} obj2    Second object
   * @return {Array}         resulting array
   */ function _ElementDiff(obj1, obj2) {
        // Convert matrices to arrays
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(obj1)) obj1 = obj1.toArray();
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(obj2)) obj2 = obj2.toArray();
        var obj1IsArray = Array.isArray(obj1);
        var obj2IsArray = Array.isArray(obj2);
        if (obj1IsArray && obj2IsArray) return _ArrayDiff(obj1, obj2);
        if (!obj1IsArray && !obj2IsArray) return subtract(obj2, obj1); // Difference is (second - first) NOT (first - second)
        throw TypeError("Cannot calculate difference between 1 array and 1 non-array");
    }
    /**
   * Difference of elements in 2 arrays
   *
   * @param {Array} arr1     Array 1
   * @param {Array} arr2     Array 2
   * @return {Array}         resulting array
   */ function _ArrayDiff(arr1, arr2) {
        if (arr1.length !== arr2.length) throw RangeError("Not all sub-arrays have the same length");
        var result = [];
        var size = arr1.length;
        for(var i = 0; i < size; i++)result.push(_ElementDiff(arr1[i], arr2[i]));
        return result;
    }
});



var $012e689cf7e69dcb$var$name = "distance";
var $012e689cf7e69dcb$var$dependencies = [
    "typed",
    "addScalar",
    "subtract",
    "divideScalar",
    "multiplyScalar",
    "unaryMinus",
    "sqrt",
    "abs"
];
var $012e689cf7e69dcb$export$23f482ad1a94fa7e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($012e689cf7e69dcb$var$name, $012e689cf7e69dcb$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, subtract: subtract, multiplyScalar: multiplyScalar, divideScalar: divideScalar, unaryMinus: unaryMinus, sqrt: sqrt, abs: abs } = _ref;
    /**
    * Calculates:
    *    The eucledian distance between two points in N-dimensional spaces.
    *    Distance between point and a line in 2 and 3 dimensional spaces.
    *    Pairwise distance between a set of 2D or 3D points
    * NOTE:
    *    When substituting coefficients of a line(a, b and c), use ax + by + c = 0 instead of ax + by = c
    *    For parametric equation of a 3D line, x0, y0, z0, a, b, c are from: (x−x0, y−y0, z−z0) = t(a, b, c)
    *
    * Syntax:
    *    math.distance([x1, y1], [x2, y2])
    *-   math.distance({pointOneX: 4, pointOneY: 5}, {pointTwoX: 2, pointTwoY: 7})
    *    math.distance([x1, y1, z1], [x2, y2, z2])
    *    math.distance({pointOneX: 4, pointOneY: 5, pointOneZ: 8}, {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})
    *    math.distance([x1, y1, ... , N1], [x2, y2, ... , N2])
    *    math.distance([[A], [B], [C]...])
    *    math.distance([x1, y1], [LinePtX1, LinePtY1], [LinePtX2, LinePtY2])
    *    math.distance({pointX: 1, pointY: 4}, {lineOnePtX: 6, lineOnePtY: 3}, {lineTwoPtX: 2, lineTwoPtY: 8})
    *    math.distance([x1, y1, z1], [LinePtX1, LinePtY1, LinePtZ1], [LinePtX2, LinePtY2, LinePtZ2])
    *    math.distance({pointX: 1, pointY: 4, pointZ: 7}, {lineOnePtX: 6, lineOnePtY: 3, lineOnePtZ: 4}, {lineTwoPtX: 2, lineTwoPtY: 8, lineTwoPtZ: 5})
    *    math.distance([x1, y1], [xCoeffLine, yCoeffLine, constant])
    *    math.distance({pointX: 10, pointY: 10}, {xCoeffLine: 8, yCoeffLine: 1, constant: 3})
    *    math.distance([x1, y1, z1], [x0, y0, z0, a-tCoeff, b-tCoeff, c-tCoeff]) point and parametric equation of 3D line
    *    math.distance([x, y, z], [x0, y0, z0, a, b, c])
    *    math.distance({pointX: 2, pointY: 5, pointZ: 9}, {x0: 4, y0: 6, z0: 3, a: 4, b: 2, c: 0})
    *
    * Examples:
    *    math.distance([0,0], [4,4])                     // Returns 5.6569
    *    math.distance(
    *     {pointOneX: 0, pointOneY: 0},
    *     {pointTwoX: 10, pointTwoY: 10})                // Returns 14.142135623730951
    *    math.distance([1, 0, 1], [4, -2, 2])            // Returns 3.74166
    *    math.distance(
    *     {pointOneX: 4, pointOneY: 5, pointOneZ: 8},
    *     {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})    // Returns 3
    *    math.distance([1, 0, 1, 0], [0, -1, 0, -1])     // Returns 2
    *    math.distance([[1, 2], [1, 2], [1, 3]])         // Returns [0, 1, 1]
    *    math.distance([[1,2,4], [1,2,6], [8,1,3]])      // Returns [2, 7.14142842854285, 7.681145747868608]
    *    math.distance([10, 10], [8, 1, 3])              // Returns 11.535230316796387
    *    math.distance([10, 10], [2, 3], [-8, 0])        // Returns 8.759953130362847
    *    math.distance(
    *     {pointX: 1, pointY: 4},
    *     {lineOnePtX: 6, lineOnePtY: 3},
    *     {lineTwoPtX: 2, lineTwoPtY: 8})                // Returns 2.720549372624744
    *    math.distance([2, 3, 1], [1, 1, 2, 5, 0, 1])    // Returns 2.3204774044612857
    *    math.distance(
    *     {pointX: 2, pointY: 3, pointZ: 1},
    *     {x0: 1, y0: 1, z0: 2, a: 5, b: 0, c: 1}        // Returns 2.3204774044612857
    *
    * @param {Array | Matrix | Object} x    Co-ordinates of first point
    * @param {Array | Matrix | Object} y    Co-ordinates of second point
    * @return {Number | BigNumber} Returns the distance from two/three points
  */ return typed($012e689cf7e69dcb$var$name, {
        "Array, Array, Array": function ArrayArrayArray(x, y, z) {
            // Point to Line 2D (x=Point, y=LinePoint1, z=LinePoint2)
            if (x.length === 2 && y.length === 2 && z.length === 2) {
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_2d(y)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
                if (!_2d(z)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
                var m = divideScalar(subtract(z[1], z[0]), subtract(y[1], y[0]));
                var xCoeff = multiplyScalar(multiplyScalar(m, m), y[0]);
                var yCoeff = unaryMinus(multiplyScalar(m, y[0]));
                var constant = x[1];
                return _distancePointLine2D(x[0], x[1], xCoeff, yCoeff, constant);
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object, Object": function ObjectObjectObject(x, y, z) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 2 && Object.keys(z).length === 2) {
                if (!_2d(x)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                if (!_2d(y)) throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
                if (!_2d(z)) throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "lineOnePtX" in y && "lineOnePtY" in y && "lineTwoPtX" in z && "lineTwoPtY" in z) {
                    var m = divideScalar(subtract(z.lineTwoPtY, z.lineTwoPtX), subtract(y.lineOnePtY, y.lineOnePtX));
                    var xCoeff = multiplyScalar(multiplyScalar(m, m), y.lineOnePtX);
                    var yCoeff = unaryMinus(multiplyScalar(m, y.lineOnePtX));
                    var constant = x.pointX;
                    return _distancePointLine2D(x.pointX, x.pointY, xCoeff, yCoeff, constant);
                } else throw new TypeError("Key names do not match");
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Array, Array": function ArrayArray(x, y) {
            // Point to Line 2D (x=[pointX, pointY], y=[x-coeff, y-coeff, const])
            if (x.length === 2 && y.length === 3) {
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
                return _distancePointLine2D(x[0], x[1], y[0], y[1], y[2]);
            } else if (x.length === 3 && y.length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
                if (!_parametricLine(y)) throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
                return _distancePointLine3D(x[0], x[1], x[2], y[0], y[1], y[2], y[3], y[4], y[5]);
            } else if (x.length === y.length && x.length > 0) {
                // Point to Point N-dimensions
                if (!_containsOnlyNumbers(x)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                if (!_containsOnlyNumbers(y)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                return _euclideanDistance(x, y);
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object": function ObjectObject(x, y) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 3) {
                if (!_2d(x)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                if (!_3d(y)) throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "xCoeffLine" in y && "yCoeffLine" in y && "constant" in y) return _distancePointLine2D(x.pointX, x.pointY, y.xCoeffLine, y.yCoeffLine, y.constant);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
                if (!_parametricLine(y)) throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "x0" in y && "y0" in y && "z0" in y && "a" in y && "b" in y && "c" in y) return _distancePointLine3D(x.pointX, x.pointY, x.pointZ, y.x0, y.y0, y.z0, y.a, y.b, y.c);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 2 && Object.keys(y).length === 2) {
                // Point to Point 2D
                if (!_2d(x)) throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
                if (!_2d(y)) throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
                if ("pointOneX" in x && "pointOneY" in x && "pointTwoX" in y && "pointTwoY" in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY
                ], [
                    y.pointTwoX,
                    y.pointTwoY
                ]);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 3) {
                // Point to Point 3D
                if (!_3d(x)) throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
                if (!_3d(y)) throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
                if ("pointOneX" in x && "pointOneY" in x && "pointOneZ" in x && "pointTwoX" in y && "pointTwoY" in y && "pointTwoZ" in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY,
                    x.pointOneZ
                ], [
                    y.pointTwoX,
                    y.pointTwoY,
                    y.pointTwoZ
                ]);
                else throw new TypeError("Key names do not match");
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        Array: function Array1(arr) {
            if (!_pairwise(arr)) throw new TypeError("Incorrect array format entered for pairwise distance calculation");
            return _distancePairwise(arr);
        }
    });
    function _isNumber(a) {
        // distance supports numbers and bignumbers
        return typeof a === "number" || (0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(a);
    }
    function _2d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]);
    }
    function _3d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]);
    }
    function _containsOnlyNumbers(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (!Array.isArray(a)) a = _objectToArray(a);
        return a.every(_isNumber);
    }
    function _parametricLine(a) {
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]) && _isNumber(a[3]) && _isNumber(a[4]) && _isNumber(a[5]);
    }
    function _objectToArray(o) {
        var keys = Object.keys(o);
        var a = [];
        for(var i = 0; i < keys.length; i++)a.push(o[keys[i]]);
        return a;
    }
    function _pairwise(a) {
        // checks for valid arguments passed to _distancePairwise(Array)
        if (a[0].length === 2 && _isNumber(a[0][0]) && _isNumber(a[0][1])) {
            if (a.some((aI)=>aI.length !== 2 || !_isNumber(aI[0]) || !_isNumber(aI[1]))) return false;
        } else if (a[0].length === 3 && _isNumber(a[0][0]) && _isNumber(a[0][1]) && _isNumber(a[0][2])) {
            if (a.some((aI)=>aI.length !== 3 || !_isNumber(aI[0]) || !_isNumber(aI[1]) || !_isNumber(aI[2]))) return false;
        } else return false;
        return true;
    }
    function _distancePointLine2D(x, y, a, b, c) {
        var num = abs(addScalar(addScalar(multiplyScalar(a, x), multiplyScalar(b, y)), c));
        var den = sqrt(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)));
        return divideScalar(num, den);
    }
    function _distancePointLine3D(x, y, z, x0, y0, z0, a, b, c) {
        var num = [
            subtract(multiplyScalar(subtract(y0, y), c), multiplyScalar(subtract(z0, z), b)),
            subtract(multiplyScalar(subtract(z0, z), a), multiplyScalar(subtract(x0, x), c)),
            subtract(multiplyScalar(subtract(x0, x), b), multiplyScalar(subtract(y0, y), a))
        ];
        num = sqrt(addScalar(addScalar(multiplyScalar(num[0], num[0]), multiplyScalar(num[1], num[1])), multiplyScalar(num[2], num[2])));
        var den = sqrt(addScalar(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)), multiplyScalar(c, c)));
        return divideScalar(num, den);
    }
    function _euclideanDistance(x, y) {
        var vectorSize = x.length;
        var result = 0;
        var diff = 0;
        for(var i = 0; i < vectorSize; i++){
            diff = subtract(x[i], y[i]);
            result = addScalar(multiplyScalar(diff, diff), result);
        }
        return sqrt(result);
    }
    function _distancePairwise(a) {
        var result = [];
        var pointA = [];
        var pointB = [];
        for(var i = 0; i < a.length - 1; i++)for(var j = i + 1; j < a.length; j++){
            if (a[0].length === 2) {
                pointA = [
                    a[i][0],
                    a[i][1]
                ];
                pointB = [
                    a[j][0],
                    a[j][1]
                ];
            } else if (a[0].length === 3) {
                pointA = [
                    a[i][0],
                    a[i][1],
                    a[i][2]
                ];
                pointB = [
                    a[j][0],
                    a[j][1],
                    a[j][2]
                ];
            }
            result.push(_euclideanDistance(pointA, pointB));
        }
        return result;
    }
});





var $f5048ea0a84c29ec$var$name = "divide";
var $f5048ea0a84c29ec$var$dependencies = [
    "typed",
    "matrix",
    "multiply",
    "equalScalar",
    "divideScalar",
    "inv"
];
var $f5048ea0a84c29ec$export$4df5e56bb6d14758 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($f5048ea0a84c29ec$var$name, $f5048ea0a84c29ec$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, multiply: multiply, equalScalar: equalScalar, divideScalar: divideScalar, inv: inv } = _ref;
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Divide two values, `x / y`.
   * To divide matrices, `x` is multiplied with the inverse of `y`: `x * inv(y)`.
   *
   * Syntax:
   *
   *    math.divide(x, y)
   *
   * Examples:
   *
   *    math.divide(2, 3)            // returns number 0.6666666666666666
   *
   *    const a = math.complex(5, 14)
   *    const b = math.complex(4, 1)
   *    math.divide(a, b)            // returns Complex 2 + 3i
   *
   *    const c = [[7, -6], [13, -4]]
   *    const d = [[1, 2], [4, 3]]
   *    math.divide(c, d)            // returns Array [[-9, 4], [-11, 6]]
   *
   *    const e = math.unit('18 km')
   *    math.divide(e, 4.5)          // returns Unit 4 km
   *
   * See also:
   *
   *    multiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x   Numerator
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} y          Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                      Quotient, `x / y`
   */ return typed("divide", (0, $33619877a15996ac$export$8b58be045bf06082)({
        // we extend the signatures of divideScalar with signatures dealing with matrices
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(x, y) {
            // TODO: implement matrix right division using pseudo inverse
            // https://www.mathworks.nl/help/matlab/ref/mrdivide.html
            // https://www.gnu.org/software/octave/doc/interpreter/Arithmetic-Ops.html
            // https://stackoverflow.com/questions/12263932/how-does-gnu-octave-matrix-division-work-getting-unexpected-behaviour
            return multiply(x, inv(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, divideScalar, false);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, divideScalar, false);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, divideScalar, false).valueOf();
        },
        "any, Array | Matrix": function anyArrayMatrix(x, y) {
            return multiply(x, inv(y));
        }
    }, divideScalar.signatures));
});



var $e265b0dea50e77d7$var$name = "divideScalar";
var $e265b0dea50e77d7$var$dependencies = [
    "typed",
    "numeric"
];
var $e265b0dea50e77d7$export$399593177816ff82 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e265b0dea50e77d7$var$name, $e265b0dea50e77d7$var$dependencies, (_ref)=>{
    var { typed: typed, numeric: numeric } = _ref;
    /**
   * Divide two scalar values, `x / y`.
   * This function is meant for internal use: it is used by the public functions
   * `divide` and `inv`.
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   Numerator
   * @param  {number | BigNumber | Fraction | Complex} y          Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit}     Quotient, `x / y`
   * @private
   */ return typed($e265b0dea50e77d7$var$name, {
        "number, number": function numberNumber(x, y) {
            return x / y;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.div(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.div(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.div(y);
        },
        "Unit, number | Fraction | BigNumber": function UnitNumberFractionBigNumber(x, y) {
            var res = x.clone(); // TODO: move the divide function to Unit.js, it uses internals of Unit
            var one = numeric(1, (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(y));
            res.value = this(res.value === null ? res._normalize(one) : res.value, y);
            return res;
        },
        "number | Fraction | BigNumber, Unit": function numberFractionBigNumberUnit(x, y) {
            var res = y.clone();
            res = res.pow(-1); // TODO: move the divide function to Unit.js, it uses internals of Unit
            var one = numeric(1, (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(x));
            res.value = this(x, y.value === null ? y._normalize(one) : y.value);
            return res;
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return x.divide(y);
        }
    });
});



var $dc1481857435092d$var$name = "dot";
var $dc1481857435092d$var$dependencies = [
    "typed",
    "addScalar",
    "multiplyScalar",
    "conj",
    "size"
];
var $dc1481857435092d$export$3dc59ff00984d687 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($dc1481857435092d$var$name, $dc1481857435092d$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, multiplyScalar: multiplyScalar, conj: conj, size: size } = _ref;
    /**
   * Calculate the dot product of two vectors. The dot product of
   * `A = [a1, a2, ..., an]` and `B = [b1, b2, ..., bn]` is defined as:
   *
   *    dot(A, B) = conj(a1) * b1 + conj(a2) * b2 + ... + conj(an) * bn
   *
   * Syntax:
   *
   *    math.dot(x, y)
   *
   * Examples:
   *
   *    math.dot([2, 4, 1], [2, 2, 3])       // returns number 15
   *    math.multiply([2, 4, 1], [2, 2, 3])  // returns number 15
   *
   * See also:
   *
   *    multiply, cross
   *
   * @param  {Array | Matrix} x     First vector
   * @param  {Array | Matrix} y     Second vector
   * @return {number}               Returns the dot product of `x` and `y`
   */ return typed($dc1481857435092d$var$name, {
        "Array | DenseMatrix, Array | DenseMatrix": _denseDot,
        "SparseMatrix, SparseMatrix": _sparseDot
    });
    function _validateDim(x, y) {
        var xSize = _size(x);
        var ySize = _size(y);
        var xLen, yLen;
        if (xSize.length === 1) xLen = xSize[0];
        else if (xSize.length === 2 && xSize[1] === 1) xLen = xSize[0];
        else throw new RangeError("Expected a column vector, instead got a matrix of size (" + xSize.join(", ") + ")");
        if (ySize.length === 1) yLen = ySize[0];
        else if (ySize.length === 2 && ySize[1] === 1) yLen = ySize[0];
        else throw new RangeError("Expected a column vector, instead got a matrix of size (" + ySize.join(", ") + ")");
        if (xLen !== yLen) throw new RangeError("Vectors must have equal length (" + xLen + " != " + yLen + ")");
        if (xLen === 0) throw new RangeError("Cannot calculate the dot product of empty vectors");
        return xLen;
    }
    function _denseDot(a, b) {
        var N = _validateDim(a, b);
        var adata = (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(a) ? a._data : a;
        var adt = (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(a) ? a._datatype : undefined;
        var bdata = (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(b) ? b._data : b;
        var bdt = (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(b) ? b._datatype : undefined; // are these 2-dimensional column vectors? (as opposed to 1-dimensional vectors)
        var aIsColumn = _size(a).length === 2;
        var bIsColumn = _size(b).length === 2;
        var add = addScalar;
        var mul = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            var dt = adt; // find signatures that matches (dt, dt)
            add = typed.find(addScalar, [
                dt,
                dt
            ]);
            mul = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // both vectors 1-dimensional
        if (!aIsColumn && !bIsColumn) {
            var c = mul(conj(adata[0]), bdata[0]);
            for(var i = 1; i < N; i++)c = add(c, mul(conj(adata[i]), bdata[i]));
            return c;
        } // a is 1-dim, b is column
        if (!aIsColumn && bIsColumn) {
            var _c = mul(conj(adata[0]), bdata[0][0]);
            for(var _i = 1; _i < N; _i++)_c = add(_c, mul(conj(adata[_i]), bdata[_i][0]));
            return _c;
        } // a is column, b is 1-dim
        if (aIsColumn && !bIsColumn) {
            var _c2 = mul(conj(adata[0][0]), bdata[0]);
            for(var _i2 = 1; _i2 < N; _i2++)_c2 = add(_c2, mul(conj(adata[_i2][0]), bdata[_i2]));
            return _c2;
        } // both vectors are column
        if (aIsColumn && bIsColumn) {
            var _c3 = mul(conj(adata[0][0]), bdata[0][0]);
            for(var _i3 = 1; _i3 < N; _i3++)_c3 = add(_c3, mul(conj(adata[_i3][0]), bdata[_i3][0]));
            return _c3;
        }
    }
    function _sparseDot(x, y) {
        _validateDim(x, y);
        var xindex = x._index;
        var xvalues = x._values;
        var yindex = y._index;
        var yvalues = y._values; // TODO optimize add & mul using datatype
        var c = 0;
        var add = addScalar;
        var mul = multiplyScalar;
        var i = 0;
        var j = 0;
        while(i < xindex.length && j < yindex.length){
            var I = xindex[i];
            var J = yindex[j];
            if (I < J) {
                i++;
                continue;
            }
            if (I > J) {
                j++;
                continue;
            }
            if (I === J) {
                c = add(c, mul(xvalues[i], yvalues[j]));
                i++;
                j++;
            }
        }
        return c;
    } // TODO remove this once #1771 is fixed
    function _size(x) {
        return (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(x) ? x.size() : size(x);
    }
});









var $2f4f0fc5426630eb$var$name = "dotDivide";
var $2f4f0fc5426630eb$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "divideScalar",
    "DenseMatrix"
];
var $2f4f0fc5426630eb$export$e4930a420a373a24 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($2f4f0fc5426630eb$var$name, $2f4f0fc5426630eb$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, divideScalar: divideScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm02 = (0, $b6b1cd490ad9f946$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $49703efd2d98c69c$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Divide two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotDivide(x, y)
   *
   * Examples:
   *
   *    math.dotDivide(2, 4)   // returns 0.5
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotDivide(a, b)   // returns [[3, 2.5], [1.2, 0.5]]
   *    math.divide(a, b)      // returns [[1.75, 0.75], [-1.75, 2.25]]
   *
   * See also:
   *
   *    divide, multiply, dotMultiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Numerator
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Quotient, `x ./ y`
   */ return typed($2f4f0fc5426630eb$var$name, {
        "any, any": divideScalar,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, divideScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, divideScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, divideScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, divideScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, divideScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, divideScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, divideScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, divideScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, divideScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, divideScalar, true).valueOf();
        }
    });
});







var $3043bfe628ca0380$var$name = "dotMultiply";
var $3043bfe628ca0380$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "multiplyScalar"
];
var $3043bfe628ca0380$export$a4620e84460f321e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($3043bfe628ca0380$var$name, $3043bfe628ca0380$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, multiplyScalar: multiplyScalar } = _ref;
    var algorithm02 = (0, $b6b1cd490ad9f946$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm09 = (0, $8b36a8a0c418b6d5$export$c769437575b0fcdd)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Multiply two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotMultiply(x, y)
   *
   * Examples:
   *
   *    math.dotMultiply(2, 4) // returns 8
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotMultiply(a, b) // returns [[27, 10], [30, 2]]
   *    math.multiply(a, b)    // returns [[52, 28], [23, 14]]
   *
   * See also:
   *
   *    multiply, divide, dotDivide
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Left hand value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Right hand value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Multiplication of `x` and `y`
   */ return typed($3043bfe628ca0380$var$name, {
        "any, any": multiplyScalar,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm09(x, y, multiplyScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, multiplyScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, multiplyScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, multiplyScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, multiplyScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, multiplyScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, multiplyScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, multiplyScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
        }
    });
});








var $2e69e7700ff47253$var$name = "dotPow";
var $2e69e7700ff47253$var$dependencies = [
    "typed",
    "equalScalar",
    "matrix",
    "pow",
    "DenseMatrix"
];
var $2e69e7700ff47253$export$734b49568d8effd6 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($2e69e7700ff47253$var$name, $2e69e7700ff47253$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar, matrix: matrix, pow: pow, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $49703efd2d98c69c$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculates the power of x to y element wise.
   *
   * Syntax:
   *
   *    math.dotPow(x, y)
   *
   * Examples:
   *
   *    math.dotPow(2, 3)            // returns number 8
   *
   *    const a = [[1, 2], [4, 3]]
   *    math.dotPow(a, 2)            // returns Array [[1, 4], [16, 9]]
   *    math.pow(a, 2)               // returns Array [[9, 8], [16, 17]]
   *
   * See also:
   *
   *    pow, sqrt, multiply
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y  The exponent
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}                     The value of `x` to the power `y`
   */ return typed($2e69e7700ff47253$var$name, {
        "any, any": pow,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, pow, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, pow, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, pow, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, pow);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});


var $8a5a8e60ccc10d35$export$83d89fbfd8236492 = "10.6.4"; // Note: This file is automatically generated when building math.js.
 // Changes made in this file will be overwritten.


// function utils
// (c) 2018, Mariusz Nowak
// SPDX-License-Identifier: ISC
// Derived from https://github.com/medikoo/lru-queue
function $27e085738cbadd7f$export$6080faceac22b73a(limit) {
    var size = 0;
    var base = 1;
    var queue = Object.create(null);
    var map = Object.create(null);
    var index = 0;
    var del = function del(id) {
        var oldIndex = map[id];
        if (!oldIndex) return;
        delete queue[oldIndex];
        delete map[id];
        --size;
        if (base !== oldIndex) return;
        if (!size) {
            index = 0;
            base = 1;
            return;
        }
        while(!hasOwnProperty.call(queue, ++base))continue;
    };
    limit = Math.abs(limit);
    return {
        hit: function hit(id) {
            var oldIndex = map[id];
            var nuIndex = ++index;
            queue[nuIndex] = id;
            map[id] = nuIndex;
            if (!oldIndex) {
                ++size;
                if (size <= limit) return undefined;
                id = queue[base];
                del(id);
                return id;
            }
            delete queue[oldIndex];
            if (base !== oldIndex) return undefined;
            while(!hasOwnProperty.call(queue, ++base))continue;
            return undefined;
        },
        delete: del,
        clear: function clear() {
            size = index = 0;
            base = 1;
            queue = Object.create(null);
            map = Object.create(null);
        }
    };
}


function $43b7a970faec5d37$export$fc10aeed3a532e2a(fn) {
    var { hasher: hasher, limit: limit } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    limit = limit == null ? Number.POSITIVE_INFINITY : limit;
    hasher = hasher == null ? JSON.stringify : hasher;
    return function memoize() {
        if (typeof memoize.cache !== "object") memoize.cache = {
            values: new Map(),
            lru: (0, $27e085738cbadd7f$export$6080faceac22b73a)(limit || Number.POSITIVE_INFINITY)
        };
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        var hash = hasher(args);
        if (memoize.cache.values.has(hash)) {
            memoize.cache.lru.hit(hash);
            return memoize.cache.values.get(hash);
        }
        var newVal = fn.apply(fn, args);
        memoize.cache.values.set(hash, newVal);
        memoize.cache.values.delete(memoize.cache.lru.hit(hash));
        return newVal;
    };
}
function $43b7a970faec5d37$export$22992fec26710d5a(fn, isEqual) {
    var memoize = function memoize() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        for(var c = 0; c < memoize.cache.length; c++){
            var cached = memoize.cache[c];
            if (isEqual(args, cached.args)) // TODO: move this cache entry to the top so recently used entries move up?
            return cached.res;
        }
        var res = fn.apply(fn, args);
        memoize.cache.unshift({
            args: args,
            res: res
        });
        return res;
    };
    memoize.cache = [];
    return memoize;
}
function $43b7a970faec5d37$export$6c00fba23f8c91a7(fn) {
    return Object.keys(fn.signatures || {}).reduce(function(args, signature) {
        var count = (signature.match(/,/g) || []).length + 1;
        return Math.max(args, count);
    }, -1);
}


var $49598b72b195f651$export$737cba75de6dfb68 = (0, $43b7a970faec5d37$export$fc10aeed3a532e2a)(function(BigNumber) {
    return new BigNumber(1).exp();
}, {
    hasher: $49598b72b195f651$var$hasher
});
var $49598b72b195f651$export$c7e121b24930c156 = (0, $43b7a970faec5d37$export$fc10aeed3a532e2a)(function(BigNumber) {
    return new BigNumber(1).plus(new BigNumber(5).sqrt()).div(2);
}, {
    hasher: $49598b72b195f651$var$hasher
});
var $49598b72b195f651$export$d0a8190d955e3c5b = (0, $43b7a970faec5d37$export$fc10aeed3a532e2a)(function(BigNumber) {
    return BigNumber.acos(-1);
}, {
    hasher: $49598b72b195f651$var$hasher
});
var $49598b72b195f651$export$83b6ee92a84f32c6 = (0, $43b7a970faec5d37$export$fc10aeed3a532e2a)(function(BigNumber) {
    return $49598b72b195f651$export$d0a8190d955e3c5b(BigNumber).times(2);
}, {
    hasher: $49598b72b195f651$var$hasher
});
/**
 * Create a hash for a BigNumber constructor function. The created has is
 * the configured precision
 * @param {Array} args         Supposed to contain a single entry with
 *                             a BigNumber constructor
 * @return {number} precision
 * @private
 */ function $49598b72b195f651$var$hasher(args) {
    return args[0].precision;
}


var $c0d5047cacd1f1c4$export$18c7bea995a110f = Math.PI;
var $c0d5047cacd1f1c4$export$a4b4b4d4d776fe92 = 2 * Math.PI;
var $c0d5047cacd1f1c4$export$f1e1789686576879 = Math.E;
var $c0d5047cacd1f1c4$export$324943737027944a = 1.6180339887498948; // eslint-disable-line no-loss-of-precision


var $81d79d71cb274b51$export$e13d32722e2756df = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)("true", [], ()=>true);
var $81d79d71cb274b51$export$cb94e3a54c9e99b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)("false", [], ()=>false);
var $81d79d71cb274b51$export$d07c6114481fc17b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)("null", [], ()=>null);
var $81d79d71cb274b51$export$df1313fb6eb44f05 = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("Infinity", [
    "config",
    "?BigNumber"
], (_ref)=>{
    var { config: config, BigNumber: BigNumber } = _ref;
    return config.number === "BigNumber" ? new BigNumber(Infinity) : Infinity;
});
var $81d79d71cb274b51$export$fbdaee11df58c3cc = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("NaN", [
    "config",
    "?BigNumber"
], (_ref2)=>{
    var { config: config, BigNumber: BigNumber } = _ref2;
    return config.number === "BigNumber" ? new BigNumber(NaN) : NaN;
});
var $81d79d71cb274b51$export$2dbe69c48ac7f49c = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("pi", [
    "config",
    "?BigNumber"
], (_ref3)=>{
    var { config: config, BigNumber: BigNumber } = _ref3;
    return config.number === "BigNumber" ? (0, $49598b72b195f651$export$d0a8190d955e3c5b)(BigNumber) : (0, $c0d5047cacd1f1c4$export$18c7bea995a110f);
});
var $81d79d71cb274b51$export$d5973a6d5d95d479 = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("tau", [
    "config",
    "?BigNumber"
], (_ref4)=>{
    var { config: config, BigNumber: BigNumber } = _ref4;
    return config.number === "BigNumber" ? (0, $49598b72b195f651$export$83b6ee92a84f32c6)(BigNumber) : (0, $c0d5047cacd1f1c4$export$a4b4b4d4d776fe92);
});
var $81d79d71cb274b51$export$6dca51ff4d4b257f = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("e", [
    "config",
    "?BigNumber"
], (_ref5)=>{
    var { config: config, BigNumber: BigNumber } = _ref5;
    return config.number === "BigNumber" ? (0, $49598b72b195f651$export$737cba75de6dfb68)(BigNumber) : (0, $c0d5047cacd1f1c4$export$f1e1789686576879);
}); // golden ratio, (1+sqrt(5))/2
var $81d79d71cb274b51$export$f131830080647892 = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("phi", [
    "config",
    "?BigNumber"
], (_ref6)=>{
    var { config: config, BigNumber: BigNumber } = _ref6;
    return config.number === "BigNumber" ? (0, $49598b72b195f651$export$c7e121b24930c156)(BigNumber) : (0, $c0d5047cacd1f1c4$export$324943737027944a);
});
var $81d79d71cb274b51$export$ab67ddb9e8290a2c = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("LN2", [
    "config",
    "?BigNumber"
], (_ref7)=>{
    var { config: config, BigNumber: BigNumber } = _ref7;
    return config.number === "BigNumber" ? new BigNumber(2).ln() : Math.LN2;
});
var $81d79d71cb274b51$export$5365e90aad1235b4 = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("LN10", [
    "config",
    "?BigNumber"
], (_ref8)=>{
    var { config: config, BigNumber: BigNumber } = _ref8;
    return config.number === "BigNumber" ? new BigNumber(10).ln() : Math.LN10;
});
var $81d79d71cb274b51$export$b57f4b4cfc057c2d = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("LOG2E", [
    "config",
    "?BigNumber"
], (_ref9)=>{
    var { config: config, BigNumber: BigNumber } = _ref9;
    return config.number === "BigNumber" ? new BigNumber(1).div(new BigNumber(2).ln()) : Math.LOG2E;
});
var $81d79d71cb274b51$export$57f654bce66ec8ce = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("LOG10E", [
    "config",
    "?BigNumber"
], (_ref10)=>{
    var { config: config, BigNumber: BigNumber } = _ref10;
    return config.number === "BigNumber" ? new BigNumber(1).div(new BigNumber(10).ln()) : Math.LOG10E;
});
var $81d79d71cb274b51$export$e6df2cb14f3e8316 = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("SQRT1_2", [
    "config",
    "?BigNumber"
], (_ref11)=>{
    var { config: config, BigNumber: BigNumber } = _ref11;
    return config.number === "BigNumber" ? new BigNumber("0.5").sqrt() : Math.SQRT1_2;
});
var $81d79d71cb274b51$export$f7a593fe98eba575 = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("SQRT2", [
    "config",
    "?BigNumber"
], (_ref12)=>{
    var { config: config, BigNumber: BigNumber } = _ref12;
    return config.number === "BigNumber" ? new BigNumber(2).sqrt() : Math.SQRT2;
});
var $81d79d71cb274b51$export$7122d2461a6f9b76 = /* #__PURE__ */ $81d79d71cb274b51$var$recreateFactory("i", [
    "Complex"
], (_ref13)=>{
    var { Complex: Complex } = _ref13;
    return Complex.I;
}); // for backward compatibility with v5
var $81d79d71cb274b51$export$5aab935c59859292 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)("PI", [
    "pi"
], (_ref14)=>{
    var { pi: pi } = _ref14;
    return pi;
});
var $81d79d71cb274b51$export$56c791a240a1c942 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)("E", [
    "e"
], (_ref15)=>{
    var { e: e } = _ref15;
    return e;
});
var $81d79d71cb274b51$export$72a91d9326d5a672 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)("version", [], ()=>(0, $8a5a8e60ccc10d35$export$83d89fbfd8236492)); // helper function to create a factory with a flag recreateOnConfigChange
// idea: allow passing optional properties to be attached to the factory function as 4th argument?
function $81d79d71cb274b51$var$recreateFactory(name, dependencies, create) {
    return (0, $a671619231063c2b$export$e9008f2713103c6c)(name, dependencies, create, {
        recreateOnConfigChange: true
    });
}




function $b0e8d428abfa5c16$export$190353ff415180b5(_ref) {
    var { addScalar: addScalar, subtract: subtract, flatten: flatten, multiply: multiply, multiplyScalar: multiplyScalar, divideScalar: divideScalar, sqrt: sqrt, abs: abs, bignumber: bignumber, diag: diag, inv: inv, qr: qr, usolve: usolve, usolveAll: usolveAll, equal: equal, complex: complex, larger: larger, smaller: smaller, matrixFromColumns: matrixFromColumns, dot: dot } = _ref;
    /**
   * @param {number[][]} arr the matrix to find eigenvalues of
   * @param {number} N size of the matrix
   * @param {number|BigNumber} prec precision, anything lower will be considered zero
   * @param {'number'|'BigNumber'|'Complex'} type
   * @param {boolean} findVectors should we find eigenvectors?
   *
   * @returns {{ values: number[], vectors: number[][] }}
   */ function complexEigs(arr, N, prec, type, findVectors) {
        if (findVectors === undefined) findVectors = true;
         // TODO check if any row/col are zero except the diagonal
        // make sure corresponding rows and columns have similar magnitude
        // important because of numerical stability
        // MODIFIES arr by side effect!
        var R = balance(arr, N, prec, type, findVectors); // R is the row transformation matrix
        // arr = A' = R A R⁻¹, A is the original matrix
        // (if findVectors is false, R is undefined)
        // (And so to return to original matrix: A = R⁻¹ arr R)
        // TODO if magnitudes of elements vary over many orders,
        // move greatest elements to the top left corner
        // using similarity transformations, reduce the matrix
        // to Hessenberg form (upper triangular plus one subdiagonal row)
        // updates the transformation matrix R with new row operationsq
        // MODIFIES arr by side effect!
        reduceToHessenberg(arr, N, prec, type, findVectors, R); // still true that original A = R⁻¹ arr R)
        // find eigenvalues
        var { values: values, C: C } = iterateUntilTriangular(arr, N, prec, type, findVectors); // values is the list of eigenvalues, C is the column
        // transformation matrix that transforms arr, the hessenberg
        // matrix, to upper triangular
        // (So U = C⁻¹ arr C and the relationship between current arr
        // and original A is unchanged.)
        var vectors;
        if (findVectors) {
            vectors = findEigenvectors(arr, N, C, R, values, prec, type);
            vectors = matrixFromColumns(...vectors);
        }
        return {
            values: values,
            vectors: vectors
        };
    }
    /**
   * @param {number[][]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {number[][]}
   */ function balance(arr, N, prec, type, findVectors) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var realzero = big ? bignumber(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        var realone = big ? bignumber(1) : 1; // base of the floating-point arithmetic
        var radix = big ? bignumber(10) : 2;
        var radixSq = multiplyScalar(radix, radix); // the diagonal transformation matrix R
        var Rdiag;
        if (findVectors) Rdiag = Array(N).fill(one);
         // this isn't the only time we loop thru the matrix...
        var last = false;
        while(!last){
            // ...haha I'm joking! unless...
            last = true;
            for(var i = 0; i < N; i++){
                // compute the taxicab norm of i-th column and row
                // TODO optimize for complex numbers
                var colNorm = realzero;
                var rowNorm = realzero;
                for(var j = 0; j < N; j++){
                    if (i === j) continue;
                    var c = abs(arr[i][j]); // should be real
                    colNorm = addScalar(colNorm, c);
                    rowNorm = addScalar(rowNorm, c);
                }
                if (!equal(colNorm, 0) && !equal(rowNorm, 0)) {
                    // find integer power closest to balancing the matrix
                    // (we want to scale only by integer powers of radix,
                    // so that we don't lose any precision due to round-off)
                    var f = realone;
                    var _c = colNorm;
                    var rowDivRadix = divideScalar(rowNorm, radix);
                    var rowMulRadix = multiplyScalar(rowNorm, radix);
                    while(smaller(_c, rowDivRadix)){
                        _c = multiplyScalar(_c, radixSq);
                        f = multiplyScalar(f, radix);
                    }
                    while(larger(_c, rowMulRadix)){
                        _c = divideScalar(_c, radixSq);
                        f = divideScalar(f, radix);
                    } // check whether balancing is needed
                    // condition = (c + rowNorm) / f < 0.95 * (colNorm + rowNorm)
                    var condition = smaller(divideScalar(addScalar(_c, rowNorm), f), multiplyScalar(addScalar(colNorm, rowNorm), 0.95)); // apply balancing similarity transformation
                    if (condition) {
                        // we should loop once again to check whether
                        // another rebalancing is needed
                        last = false;
                        var g = divideScalar(1, f);
                        for(var _j = 0; _j < N; _j++){
                            if (i === _j) continue;
                            arr[i][_j] = multiplyScalar(arr[i][_j], f);
                            arr[_j][i] = multiplyScalar(arr[_j][i], g);
                        } // keep track of transformations
                        if (findVectors) Rdiag[i] = multiplyScalar(Rdiag[i], f);
                    }
                }
            }
        } // return the diagonal row transformation matrix
        return diag(Rdiag);
    }
    /**
   * @param {number[][]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number'|'BigNumber'|'Complex'} type
   * @param {boolean} findVectors
   * @param {number[][]} R the row transformation matrix that will be modified
   */ function reduceToHessenberg(arr, N, prec, type, findVectors, R) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        if (big) prec = bignumber(prec);
        for(var i = 0; i < N - 2; i++){
            // Find the largest subdiag element in the i-th col
            var maxIndex = 0;
            var max = zero;
            for(var j = i + 1; j < N; j++){
                var el = arr[j][i];
                if (smaller(abs(max), abs(el))) {
                    max = el;
                    maxIndex = j;
                }
            } // This col is pivoted, no need to do anything
            if (smaller(abs(max), prec)) continue;
            if (maxIndex !== i + 1) {
                // Interchange maxIndex-th and (i+1)-th row
                var tmp1 = arr[maxIndex];
                arr[maxIndex] = arr[i + 1];
                arr[i + 1] = tmp1; // Interchange maxIndex-th and (i+1)-th column
                for(var _j2 = 0; _j2 < N; _j2++){
                    var tmp2 = arr[_j2][maxIndex];
                    arr[_j2][maxIndex] = arr[_j2][i + 1];
                    arr[_j2][i + 1] = tmp2;
                } // keep track of transformations
                if (findVectors) {
                    var tmp3 = R[maxIndex];
                    R[maxIndex] = R[i + 1];
                    R[i + 1] = tmp3;
                }
            } // Reduce following rows and columns
            for(var _j3 = i + 2; _j3 < N; _j3++){
                var n = divideScalar(arr[_j3][i], max);
                if (n === 0) continue;
                 // from j-th row subtract n-times (i+1)th row
                for(var k = 0; k < N; k++)arr[_j3][k] = subtract(arr[_j3][k], multiplyScalar(n, arr[i + 1][k]));
                 // to (i+1)th column add n-times j-th column
                for(var _k = 0; _k < N; _k++)arr[_k][i + 1] = addScalar(arr[_k][i + 1], multiplyScalar(n, arr[_k][_j3]));
                 // keep track of transformations
                if (findVectors) for(var _k2 = 0; _k2 < N; _k2++)R[_j3][_k2] = subtract(R[_j3][_k2], multiplyScalar(n, R[i + 1][_k2]));
            }
        }
        return R;
    }
    /**
   * @returns {{values: values, C: Matrix}}
   * @see Press, Wiliams: Numerical recipes in Fortran 77
   * @see https://en.wikipedia.org/wiki/QR_algorithm
   */ function iterateUntilTriangular(A, N, prec, type, findVectors) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        if (big) prec = bignumber(prec);
         // The Francis Algorithm
        // The core idea of this algorithm is that doing successive
        // A' = Q⁺AQ transformations will eventually converge to block-
        // upper-triangular with diagonal blocks either 1x1 or 2x2.
        // The Q here is the one from the QR decomposition, A = QR.
        // Since the eigenvalues of a block-upper-triangular matrix are
        // the eigenvalues of its diagonal blocks and we know how to find
        // eigenvalues of a 2x2 matrix, we know the eigenvalues of A.
        var arr = (0, $33619877a15996ac$export$9cd59f9826255e47)(A); // the list of converged eigenvalues
        var lambdas = []; // size of arr, which will get smaller as eigenvalues converge
        var n = N; // the diagonal of the block-diagonal matrix that turns
        // converged 2x2 matrices into upper triangular matrices
        var Sdiag = []; // N×N matrix describing the overall transformation done during the QR algorithm
        var Qtotal = findVectors ? diag(Array(N).fill(one)) : undefined; // n×n matrix describing the QR transformations done since last convergence
        var Qpartial = findVectors ? diag(Array(n).fill(one)) : undefined; // last eigenvalue converged before this many steps
        var lastConvergenceBefore = 0;
        while(lastConvergenceBefore <= 100){
            lastConvergenceBefore += 1; // TODO if the convergence is slow, do something clever
            // Perform the factorization
            var k = 0; // TODO set close to an eigenvalue
            for(var i = 0; i < n; i++)arr[i][i] = subtract(arr[i][i], k);
             // TODO do an implicit QR transformation
            var { Q: Q, R: R } = qr(arr);
            arr = multiply(R, Q);
            for(var _i = 0; _i < n; _i++)arr[_i][_i] = addScalar(arr[_i][_i], k);
             // keep track of transformations
            if (findVectors) Qpartial = multiply(Qpartial, Q);
             // The rightmost diagonal element converged to an eigenvalue
            if (n === 1 || smaller(abs(arr[n - 1][n - 2]), prec)) {
                lastConvergenceBefore = 0;
                lambdas.push(arr[n - 1][n - 1]); // keep track of transformations
                if (findVectors) {
                    Sdiag.unshift([
                        [
                            1
                        ]
                    ]);
                    inflateMatrix(Qpartial, N);
                    Qtotal = multiply(Qtotal, Qpartial);
                    if (n > 1) Qpartial = diag(Array(n - 1).fill(one));
                } // reduce the matrix size
                n -= 1;
                arr.pop();
                for(var _i2 = 0; _i2 < n; _i2++)arr[_i2].pop();
                 // The rightmost diagonal 2x2 block converged
            } else if (n === 2 || smaller(abs(arr[n - 2][n - 3]), prec)) {
                lastConvergenceBefore = 0;
                var ll = eigenvalues2x2(arr[n - 2][n - 2], arr[n - 2][n - 1], arr[n - 1][n - 2], arr[n - 1][n - 1]);
                lambdas.push(...ll); // keep track of transformations
                if (findVectors) {
                    Sdiag.unshift(jordanBase2x2(arr[n - 2][n - 2], arr[n - 2][n - 1], arr[n - 1][n - 2], arr[n - 1][n - 1], ll[0], ll[1], prec, type));
                    inflateMatrix(Qpartial, N);
                    Qtotal = multiply(Qtotal, Qpartial);
                    if (n > 2) Qpartial = diag(Array(n - 2).fill(one));
                } // reduce the matrix size
                n -= 2;
                arr.pop();
                arr.pop();
                for(var _i3 = 0; _i3 < n; _i3++){
                    arr[_i3].pop();
                    arr[_i3].pop();
                }
            }
            if (n === 0) break;
        } // standard sorting
        lambdas.sort((a, b)=>+subtract(abs(a), abs(b))); // the algorithm didn't converge
        if (lastConvergenceBefore > 100) {
            var err = Error("The eigenvalues failed to converge. Only found these eigenvalues: " + lambdas.join(", "));
            err.values = lambdas;
            err.vectors = [];
            throw err;
        } // combine the overall QR transformation Qtotal with the subsequent
        // transformation S that turns the diagonal 2x2 blocks to upper triangular
        var C = findVectors ? multiply(Qtotal, blockDiag(Sdiag, N)) : undefined;
        return {
            values: lambdas,
            C: C
        };
    }
    /**
   * @param {Matrix} A hessenberg-form matrix
   * @param {number} N size of A
   * @param {Matrix} C column transformation matrix that turns A into upper triangular
   * @param {Matrix} R similarity that turns original matrix into A
   * @param {number[]} values array of eigenvalues of A
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {number[][]} eigenvalues
   */ function findEigenvectors(A, N, C, R, values, prec, type) {
        var Cinv = inv(C);
        var U = multiply(Cinv, A, C);
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1; // turn values into a kind of "multiset"
        // this way it is easier to find eigenvectors
        var uniqueValues = [];
        var multiplicities = [];
        for (var \u03BB of values){
            var i = indexOf(uniqueValues, \u03BB, equal);
            if (i === -1) {
                uniqueValues.push(\u03BB);
                multiplicities.push(1);
            } else multiplicities[i] += 1;
        } // find eigenvectors by solving U − λE = 0
        // TODO replace with an iterative eigenvector algorithm
        // (this one might fail for imprecise eigenvalues)
        var vectors = [];
        var len = uniqueValues.length;
        var b = Array(N).fill(zero);
        var E = diag(Array(N).fill(one)); // eigenvalues for which usolve failed (due to numerical error)
        var failedLambdas = [];
        var _loop = function _loop(_i4) {
            var \u03BB = uniqueValues[_i4];
            var S = subtract(U, multiply(\u03BB, E)); // the characteristic matrix
            var solutions = usolveAll(S, b);
            solutions.shift(); // ignore the null vector
            // looks like we missed something, try inverse iteration
            while(solutions.length < multiplicities[_i4]){
                var approxVec = inverseIterate(S, N, solutions, prec, type);
                if (approxVec == null) {
                    // no more vectors were found
                    failedLambdas.push(\u03BB);
                    break;
                }
                solutions.push(approxVec);
            } // Transform back into original array coordinates
            var correction = multiply(inv(R), C);
            solutions = solutions.map((v)=>multiply(correction, v));
            vectors.push(...solutions.map((v)=>flatten(v)));
        };
        for(var _i4 = 0; _i4 < len; _i4++)_loop(_i4);
        if (failedLambdas.length !== 0) {
            var err = new Error("Failed to find eigenvectors for the following eigenvalues: " + failedLambdas.join(", "));
            err.values = values;
            err.vectors = vectors;
            throw err;
        }
        return vectors;
    }
    /**
   * Compute the eigenvalues of an 2x2 matrix
   * @return {[number,number]}
   */ function eigenvalues2x2(a, b, c, d) {
        // λ± = ½ trA ± ½ √( tr²A - 4 detA )
        var trA = addScalar(a, d);
        var detA = subtract(multiplyScalar(a, d), multiplyScalar(b, c));
        var x = multiplyScalar(trA, 0.5);
        var y = multiplyScalar(sqrt(subtract(multiplyScalar(trA, trA), multiplyScalar(4, detA))), 0.5);
        return [
            addScalar(x, y),
            subtract(x, y)
        ];
    }
    /**
   * For an 2x2 matrix compute the transformation matrix S,
   * so that SAS⁻¹ is an upper triangular matrix
   * @return {[[number,number],[number,number]]}
   * @see https://math.berkeley.edu/~ogus/old/Math_54-05/webfoils/jordan.pdf
   * @see http://people.math.harvard.edu/~knill/teaching/math21b2004/exhibits/2dmatrices/index.html
   */ function jordanBase2x2(a, b, c, d, l1, l2, prec, type) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1; // matrix is already upper triangular
        // return an identity matrix
        if (smaller(abs(c), prec)) return [
            [
                one,
                zero
            ],
            [
                zero,
                one
            ]
        ];
         // matrix is diagonalizable
        // return its eigenvectors as columns
        if (larger(abs(subtract(l1, l2)), prec)) return [
            [
                subtract(l1, d),
                subtract(l2, d)
            ],
            [
                c,
                c
            ]
        ];
         // matrix is not diagonalizable
        // compute off-diagonal elements of N = A - λI
        // N₁₂ = 0 ⇒ S = ( N⃗₁, I⃗₁ )
        // N₁₂ ≠ 0 ⇒ S = ( N⃗₂, I⃗₂ )
        var na = subtract(a, l1);
        var nb = subtract(b, l1);
        var nc = subtract(c, l1);
        var nd = subtract(d, l1);
        if (smaller(abs(nb), prec)) return [
            [
                na,
                one
            ],
            [
                nc,
                zero
            ]
        ];
        else return [
            [
                nb,
                zero
            ],
            [
                nd,
                one
            ]
        ];
    }
    /**
   * Enlarge the matrix from n×n to N×N, setting the new
   * elements to 1 on diagonal and 0 elsewhere
   */ function inflateMatrix(arr, N) {
        // add columns
        for(var i = 0; i < arr.length; i++)arr[i].push(...Array(N - arr[i].length).fill(0));
         // add rows
        for(var _i5 = arr.length; _i5 < N; _i5++){
            arr.push(Array(N).fill(0));
            arr[_i5][_i5] = 1;
        }
        return arr;
    }
    /**
   * Create a block-diagonal matrix with the given square matrices on the diagonal
   * @param {Matrix[] | number[][][]} arr array of matrices to be placed on the diagonal
   * @param {number} N the size of the resulting matrix
   */ function blockDiag(arr, N) {
        var M = [];
        for(var i = 0; i < N; i++)M[i] = Array(N).fill(0);
        var I = 0;
        for (var sub of arr){
            var n = sub.length;
            for(var _i6 = 0; _i6 < n; _i6++)for(var j = 0; j < n; j++)M[I + _i6][I + j] = sub[_i6][j];
            I += n;
        }
        return M;
    }
    /**
   * Finds the index of an element in an array using a custom equality function
   * @template T
   * @param {Array<T>} arr array in which to search
   * @param {T} el the element to find
   * @param {function(T, T): boolean} fn the equality function, first argument is an element of `arr`, the second is always `el`
   * @returns {number} the index of `el`, or -1 when it's not in `arr`
   */ function indexOf(arr, el, fn) {
        for(var i = 0; i < arr.length; i++){
            if (fn(arr[i], el)) return i;
        }
        return -1;
    }
    /**
   * Provided a near-singular upper-triangular matrix A and a list of vectors,
   * finds an eigenvector of A with the smallest eigenvalue, which is orthogonal
   * to each vector in the list
   * @template T
   * @param {T[][]} A near-singular square matrix
   * @param {number} N dimension
   * @param {T[][]} orthog list of vectors
   * @param {number} prec epsilon
   * @param {'number'|'BigNumber'|'Complex'} type
   * @return {T[] | null} eigenvector
   *
   * @see Numerical Recipes for Fortran 77 – 11.7 Eigenvalues or Eigenvectors by Inverse Iteration
   */ function inverseIterate(A, N, orthog, prec, type) {
        var largeNum = type === "BigNumber" ? bignumber(1000) : 1000;
        var b; // the vector
        // you better choose a random vector before I count to five
        var i = 0;
        while(true){
            b = randomOrthogonalVector(N, orthog, type);
            b = usolve(A, b);
            if (larger(norm(b), largeNum)) break;
            if (++i >= 5) return null;
        } // you better converge before I count to ten
        i = 0;
        while(true){
            var c = usolve(A, b);
            if (smaller(norm(orthogonalComplement(b, [
                c
            ])), prec)) break;
            if (++i >= 10) return null;
            b = normalize(c);
        }
        return b;
    }
    /**
   * Generates a random unit vector of dimension N, orthogonal to each vector in the list
   * @template T
   * @param {number} N dimension
   * @param {T[][]} orthog list of vectors
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {T[]} random vector
   */ function randomOrthogonalVector(N, orthog, type) {
        var big = type === "BigNumber";
        var cplx = type === "Complex"; // generate random vector with the correct type
        var v = Array(N).fill(0).map((_)=>2 * Math.random() - 1);
        if (big) v = v.map((n)=>bignumber(n));
        if (cplx) v = v.map((n)=>complex(n));
         // project to orthogonal complement
        v = orthogonalComplement(v, orthog); // normalize
        return normalize(v, type);
    }
    /**
   * Project vector v to the orthogonal complement of an array of vectors
   */ function orthogonalComplement(v, orthog) {
        for (var w of orthog)// v := v − (w, v)/∥w∥² w
        v = subtract(v, multiply(divideScalar(dot(w, v), dot(w, w)), w));
        return v;
    }
    /**
   * Calculate the norm of a vector.
   * We can't use math.norm because factory can't handle circular dependency.
   * Seriously, I'm really fed up with factory.
   */ function norm(v) {
        return abs(sqrt(dot(v, v)));
    }
    /**
   * Normalize a vector
   * @template T
   * @param {T[]} v
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {T[]} normalized vec
   */ function normalize(v, type) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        return multiply(divideScalar(one, norm(v)), v);
    }
    return complexEigs;
}



function $83ac5a79d61f619f$export$a8f76d83a88e1b99(_ref) {
    var { config: config, addScalar: addScalar, subtract: subtract, abs: abs, atan: atan, cos: cos, sin: sin, multiplyScalar: multiplyScalar, inv: inv, bignumber: bignumber, multiply: multiply, add: add } = _ref;
    /**
   * @param {number[] | BigNumber[]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number' | 'BigNumber'} type
   */ function main(arr, N) {
        var prec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : config.epsilon;
        var type = arguments.length > 3 ? arguments[3] : undefined;
        if (type === "number") return diag(arr, prec);
        if (type === "BigNumber") return diagBig(arr, prec);
        throw TypeError("Unsupported data type: " + type);
    } // diagonalization implementation for number (efficient)
    function diag(x, precision) {
        var N = x.length;
        var e0 = Math.abs(precision / N);
        var psi;
        var Sij = new Array(N); // Sij is Identity Matrix
        for(var i = 0; i < N; i++){
            Sij[i] = createArray(N, 0);
            Sij[i][i] = 1.0;
        } // initial error
        var Vab = getAij(x);
        while(Math.abs(Vab[1]) >= Math.abs(e0)){
            var _i = Vab[0][0];
            var j = Vab[0][1];
            psi = getTheta(x[_i][_i], x[j][j], x[_i][j]);
            x = x1(x, psi, _i, j);
            Sij = Sij1(Sij, psi, _i, j);
            Vab = getAij(x);
        }
        var Ei = createArray(N, 0); // eigenvalues
        for(var _i2 = 0; _i2 < N; _i2++)Ei[_i2] = x[_i2][_i2];
        return sorting((0, $33619877a15996ac$export$9cd59f9826255e47)(Ei), (0, $33619877a15996ac$export$9cd59f9826255e47)(Sij));
    } // diagonalization implementation for bigNumber
    function diagBig(x, precision) {
        var N = x.length;
        var e0 = abs(precision / N);
        var psi;
        var Sij = new Array(N); // Sij is Identity Matrix
        for(var i = 0; i < N; i++){
            Sij[i] = createArray(N, 0);
            Sij[i][i] = 1.0;
        } // initial error
        var Vab = getAijBig(x);
        while(abs(Vab[1]) >= abs(e0)){
            var _i3 = Vab[0][0];
            var j = Vab[0][1];
            psi = getThetaBig(x[_i3][_i3], x[j][j], x[_i3][j]);
            x = x1Big(x, psi, _i3, j);
            Sij = Sij1Big(Sij, psi, _i3, j);
            Vab = getAijBig(x);
        }
        var Ei = createArray(N, 0); // eigenvalues
        for(var _i4 = 0; _i4 < N; _i4++)Ei[_i4] = x[_i4][_i4];
         // return [clone(Ei), clone(Sij)]
        return sorting((0, $33619877a15996ac$export$9cd59f9826255e47)(Ei), (0, $33619877a15996ac$export$9cd59f9826255e47)(Sij));
    } // get angle
    function getTheta(aii, ajj, aij) {
        var denom = ajj - aii;
        if (Math.abs(denom) <= config.epsilon) return Math.PI / 4.0;
        else return 0.5 * Math.atan(2.0 * aij / (ajj - aii));
    } // get angle
    function getThetaBig(aii, ajj, aij) {
        var denom = subtract(ajj, aii);
        if (abs(denom) <= config.epsilon) return bignumber(-1).acos().div(4);
        else return multiplyScalar(0.5, atan(multiply(2.0, aij, inv(denom))));
    } // update eigvec
    function Sij1(Sij, theta, i, j) {
        var N = Sij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var Ski = createArray(N, 0);
        var Skj = createArray(N, 0);
        for(var k = 0; k < N; k++){
            Ski[k] = c * Sij[k][i] - s * Sij[k][j];
            Skj[k] = s * Sij[k][i] + c * Sij[k][j];
        }
        for(var _k = 0; _k < N; _k++){
            Sij[_k][i] = Ski[_k];
            Sij[_k][j] = Skj[_k];
        }
        return Sij;
    } // update eigvec for overlap
    function Sij1Big(Sij, theta, i, j) {
        var N = Sij.length;
        var c = cos(theta);
        var s = sin(theta);
        var Ski = createArray(N, bignumber(0));
        var Skj = createArray(N, bignumber(0));
        for(var k = 0; k < N; k++){
            Ski[k] = subtract(multiplyScalar(c, Sij[k][i]), multiplyScalar(s, Sij[k][j]));
            Skj[k] = addScalar(multiplyScalar(s, Sij[k][i]), multiplyScalar(c, Sij[k][j]));
        }
        for(var _k2 = 0; _k2 < N; _k2++){
            Sij[_k2][i] = Ski[_k2];
            Sij[_k2][j] = Skj[_k2];
        }
        return Sij;
    } // update matrix
    function x1Big(Hij, theta, i, j) {
        var N = Hij.length;
        var c = bignumber(cos(theta));
        var s = bignumber(sin(theta));
        var c2 = multiplyScalar(c, c);
        var s2 = multiplyScalar(s, s);
        var Aki = createArray(N, bignumber(0));
        var Akj = createArray(N, bignumber(0)); // 2cs Hij
        var csHij = multiply(bignumber(2), c, s, Hij[i][j]); //  Aii
        var Aii = addScalar(subtract(multiplyScalar(c2, Hij[i][i]), csHij), multiplyScalar(s2, Hij[j][j]));
        var Ajj = add(multiplyScalar(s2, Hij[i][i]), csHij, multiplyScalar(c2, Hij[j][j])); // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = subtract(multiplyScalar(c, Hij[i][k]), multiplyScalar(s, Hij[j][k]));
            Akj[k] = addScalar(multiplyScalar(s, Hij[i][k]), multiplyScalar(c, Hij[j][k]));
        } // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = bignumber(0);
        Hij[j][i] = bignumber(0); // 0  to i
        for(var _k3 = 0; _k3 < N; _k3++)if (_k3 !== i && _k3 !== j) {
            Hij[i][_k3] = Aki[_k3];
            Hij[_k3][i] = Aki[_k3];
            Hij[j][_k3] = Akj[_k3];
            Hij[_k3][j] = Akj[_k3];
        }
        return Hij;
    } // update matrix
    function x1(Hij, theta, i, j) {
        var N = Hij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var c2 = c * c;
        var s2 = s * s;
        var Aki = createArray(N, 0);
        var Akj = createArray(N, 0); //  Aii
        var Aii = c2 * Hij[i][i] - 2 * c * s * Hij[i][j] + s2 * Hij[j][j];
        var Ajj = s2 * Hij[i][i] + 2 * c * s * Hij[i][j] + c2 * Hij[j][j]; // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = c * Hij[i][k] - s * Hij[j][k];
            Akj[k] = s * Hij[i][k] + c * Hij[j][k];
        } // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = 0;
        Hij[j][i] = 0; // 0  to i
        for(var _k4 = 0; _k4 < N; _k4++)if (_k4 !== i && _k4 !== j) {
            Hij[i][_k4] = Aki[_k4];
            Hij[_k4][i] = Aki[_k4];
            Hij[j][_k4] = Akj[_k4];
            Hij[_k4][j] = Akj[_k4];
        }
        return Hij;
    } // get max off-diagonal value from Upper Diagonal
    function getAij(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (Math.abs(maxMij) < Math.abs(Mij[i][j])) {
                maxMij = Math.abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    } // get max off-diagonal value from Upper Diagonal
    function getAijBig(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (abs(maxMij) < abs(Mij[i][j])) {
                maxMij = abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    } // sort results
    function sorting(E, S) {
        var N = E.length;
        var values = Array(N);
        var vectors = Array(N);
        for(var k = 0; k < N; k++)vectors[k] = Array(N);
        for(var i = 0; i < N; i++){
            var minID = 0;
            var minE = E[0];
            for(var j = 0; j < E.length; j++)if (abs(E[j]) < abs(minE)) {
                minID = j;
                minE = E[minID];
            }
            values[i] = E.splice(minID, 1)[0];
            for(var _k5 = 0; _k5 < N; _k5++){
                vectors[_k5][i] = S[_k5][minID];
                S[_k5].splice(minID, 1);
            }
        }
        return {
            values: values,
            vectors: vectors
        };
    }
    /**
   * Create an array of a certain size and fill all items with an initial value
   * @param {number} size
   * @param {number} value
   * @return {number[]}
   */ function createArray(size, value) {
        // TODO: as soon as all browsers support Array.fill, use that instead (IE doesn't support it)
        var array = new Array(size);
        for(var i = 0; i < size; i++)array[i] = value;
        return array;
    }
    return main;
}



var $00e0ec84f48d888d$var$name = "eigs"; // The absolute state of math.js's dependency system:
var $00e0ec84f48d888d$var$dependencies = [
    "config",
    "typed",
    "matrix",
    "addScalar",
    "equal",
    "subtract",
    "abs",
    "atan",
    "cos",
    "sin",
    "multiplyScalar",
    "divideScalar",
    "inv",
    "bignumber",
    "multiply",
    "add",
    "larger",
    "column",
    "flatten",
    "number",
    "complex",
    "sqrt",
    "diag",
    "qr",
    "usolve",
    "usolveAll",
    "im",
    "re",
    "smaller",
    "matrixFromColumns",
    "dot"
];
var $00e0ec84f48d888d$export$ba9e077a2df092d7 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($00e0ec84f48d888d$var$name, $00e0ec84f48d888d$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, matrix: matrix, addScalar: addScalar, subtract: subtract, equal: equal, abs: abs, atan: atan, cos: cos, sin: sin, multiplyScalar: multiplyScalar, divideScalar: divideScalar, inv: inv, bignumber: bignumber, multiply: multiply, add: add, larger: larger, column: column, flatten: flatten, number: number, complex: complex, sqrt: sqrt, diag: diag, qr: qr, usolve: usolve, usolveAll: usolveAll, im: im, re: re, smaller: smaller, matrixFromColumns: matrixFromColumns, dot: dot } = _ref;
    var doRealSymetric = (0, $83ac5a79d61f619f$export$a8f76d83a88e1b99)({
        config: config,
        addScalar: addScalar,
        subtract: subtract,
        column: column,
        flatten: flatten,
        equal: equal,
        abs: abs,
        atan: atan,
        cos: cos,
        sin: sin,
        multiplyScalar: multiplyScalar,
        inv: inv,
        bignumber: bignumber,
        complex: complex,
        multiply: multiply,
        add: add
    });
    var doComplexEigs = (0, $b0e8d428abfa5c16$export$190353ff415180b5)({
        config: config,
        addScalar: addScalar,
        subtract: subtract,
        multiply: multiply,
        multiplyScalar: multiplyScalar,
        flatten: flatten,
        divideScalar: divideScalar,
        sqrt: sqrt,
        abs: abs,
        bignumber: bignumber,
        diag: diag,
        qr: qr,
        inv: inv,
        usolve: usolve,
        usolveAll: usolveAll,
        equal: equal,
        complex: complex,
        larger: larger,
        smaller: smaller,
        matrixFromColumns: matrixFromColumns,
        dot: dot
    });
    /**
   * Compute eigenvalues and eigenvectors of a matrix. The eigenvalues are sorted by their absolute value, ascending.
   * An eigenvalue with multiplicity k will be listed k times. The eigenvectors are returned as columns of a matrix –
   * the eigenvector that belongs to the j-th eigenvalue in the list (eg. `values[j]`) is the j-th column (eg. `column(vectors, j)`).
   * If the algorithm fails to converge, it will throw an error – in that case, however, you may still find useful information
   * in `err.values` and `err.vectors`.
   *
   * Syntax:
   *
   *     math.eigs(x, [prec])
   *
   * Examples:
   *
   *     const { eigs, multiply, column, transpose } = math
   *     const H = [[5, 2.3], [2.3, 1]]
   *     const ans = eigs(H) // returns {values: [E1,E2...sorted], vectors: [v1,v2.... corresponding vectors as columns]}
   *     const E = ans.values
   *     const U = ans.vectors
   *     multiply(H, column(U, 0)) // returns multiply(E[0], column(U, 0))
   *     const UTxHxU = multiply(transpose(U), H, U) // diagonalizes H
   *     E[0] == UTxHxU[0][0]  // returns true
   *
   * See also:
   *
   *     inv
   *
   * @param {Array | Matrix} x  Matrix to be diagonalized
   *
   * @param {number | BigNumber} [prec] Precision, default value: 1e-15
   * @return {{values: Array|Matrix, vectors: Array|Matrix}} Object containing an array of eigenvalues and a matrix with eigenvectors as columns.
   *
   */ return typed("eigs", {
        Array: function Array(x) {
            var mat = matrix(x);
            return computeValuesAndVectors(mat);
        },
        "Array, number|BigNumber": function ArrayNumberBigNumber(x, prec) {
            var mat = matrix(x);
            return computeValuesAndVectors(mat, prec);
        },
        Matrix: function Matrix(mat) {
            var { values: values, vectors: vectors } = computeValuesAndVectors(mat);
            return {
                values: matrix(values),
                vectors: matrix(vectors)
            };
        },
        "Matrix, number|BigNumber": function MatrixNumberBigNumber(mat, prec) {
            var { values: values, vectors: vectors } = computeValuesAndVectors(mat, prec);
            return {
                values: matrix(values),
                vectors: matrix(vectors)
            };
        }
    });
    function computeValuesAndVectors(mat, prec) {
        if (prec === undefined) prec = config.epsilon;
        var size = mat.size();
        if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
        var arr = mat.toArray();
        var N = size[0];
        if (isReal(arr, N, prec)) {
            coerceReal(arr, N);
            if (isSymmetric(arr, N, prec)) {
                var _type = coerceTypes(mat, arr, N);
                return doRealSymetric(arr, N, prec, _type);
            }
        }
        var type = coerceTypes(mat, arr, N);
        return doComplexEigs(arr, N, prec, type);
    }
    /** @return {boolean} */ function isSymmetric(arr, N, prec) {
        for(var i = 0; i < N; i++)for(var j = i; j < N; j++){
            // TODO proper comparison of bignum and frac
            if (larger(bignumber(abs(subtract(arr[i][j], arr[j][i]))), prec)) return false;
        }
        return true;
    }
    /** @return {boolean} */ function isReal(arr, N, prec) {
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++){
            // TODO proper comparison of bignum and frac
            if (larger(bignumber(abs(im(arr[i][j]))), prec)) return false;
        }
        return true;
    }
    function coerceReal(arr, N) {
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++)arr[i][j] = re(arr[i][j]);
    }
    /** @return {'number' | 'BigNumber' | 'Complex'} */ function coerceTypes(mat, arr, N) {
        /** @type {string} */ var type = mat.datatype();
        if (type === "number" || type === "BigNumber" || type === "Complex") return type;
        var hasNumber = false;
        var hasBig = false;
        var hasComplex = false;
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++){
            var el = arr[i][j];
            if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(el) || (0, $2c4f948f17aa2240$export$e312cb8a8e5e7c34)(el)) hasNumber = true;
            else if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(el)) hasBig = true;
            else if ((0, $2c4f948f17aa2240$export$8849a896711efe0c)(el)) hasComplex = true;
            else throw TypeError("Unsupported type in Matrix: " + (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(el));
        }
        if (hasBig && hasComplex) console.warn("Complex BigNumbers not supported, this operation will lose precission.");
        if (hasComplex) {
            for(var _i = 0; _i < N; _i++)for(var _j = 0; _j < N; _j++)arr[_i][_j] = complex(arr[_i][_j]);
            return "Complex";
        }
        if (hasBig) {
            for(var _i2 = 0; _i2 < N; _i2++)for(var _j2 = 0; _j2 < N; _j2++)arr[_i2][_j2] = bignumber(arr[_i2][_j2]);
            return "BigNumber";
        }
        if (hasNumber) {
            for(var _i3 = 0; _i3 < N; _i3++)for(var _j3 = 0; _j3 < N; _j3++)arr[_i3][_j3] = number(arr[_i3][_j3]);
            return "number";
        } else throw TypeError("Matrix contains unsupported types only.");
    }
});







var $213c875c686f103c$var$name = "equal";
var $213c875c686f103c$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $213c875c686f103c$export$988f37bc1f709b0d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($213c875c686f103c$var$name, $213c875c686f103c$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $49703efd2d98c69c$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether two values are equal.
   *
   * The function tests whether the relative difference between x and y is
   * smaller than the configured epsilon. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must equal y.re, and x.im must equal y.im.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is only
   * equal to `null` and nothing else, and `undefined` is only equal to
   * `undefined` and nothing else. Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.equal(x, y)
   *
   * Examples:
   *
   *    math.equal(2 + 2, 3)         // returns false
   *    math.equal(2 + 2, 4)         // returns true
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.equal(a, b)             // returns true
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.equal(c, d)             // returns [true, false, true]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.equal("1000", "1e3")    // returns true
   *    math.equal(0, null)          // returns false
   *
   * See also:
   *
   *    unequal, smaller, smallerEq, larger, largerEq, compare, deepEqual, equalText
   *
   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are equal, else returns false
   */ return typed($213c875c686f103c$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, equalScalar);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, equalScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, equalScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, equalScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, equalScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, equalScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, equalScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, equalScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, equalScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, equalScalar, true).valueOf();
        }
    });
});
var $213c875c686f103c$export$87c1b92540f5e2ae = (0, $a671619231063c2b$export$e9008f2713103c6c)($213c875c686f103c$var$name, [
    "typed",
    "equalScalar"
], (_ref2)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref2;
    return typed($213c875c686f103c$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        }
    });
});





function $b3704cd6c992d1a3$export$852c8261c9f393e0(x, y, epsilon) {
    return (0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x.re, y.re, epsilon) && (0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x.im, y.im, epsilon);
}


var $f853be7ea7c49bfd$var$name = "equalScalar";
var $f853be7ea7c49bfd$var$dependencies = [
    "typed",
    "config"
];
var $f853be7ea7c49bfd$export$c370bab664a0c9a2 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($f853be7ea7c49bfd$var$name, $f853be7ea7c49bfd$var$dependencies, (_ref)=>{
    var { typed: typed, config: config } = _ref;
    /**
   * Test whether two scalar values are nearly equal.
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit} x   First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex} y          Second value to compare
   * @return {boolean}                                                  Returns true when the compared values are equal, else returns false
   * @private
   */ return typed($f853be7ea7c49bfd$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x === y;
        },
        "number, number": function numberNumber(x, y) {
            return (0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.eq(y) || (0, $cea3608675fc8eba$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.equals(y);
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return (0, $b3704cd6c992d1a3$export$852c8261c9f393e0)(x, y, config.epsilon);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        }
    });
});
var $f853be7ea7c49bfd$export$55f78fcc2979d648 = (0, $a671619231063c2b$export$e9008f2713103c6c)($f853be7ea7c49bfd$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($f853be7ea7c49bfd$var$name, {
        "number, number": function numberNumber(x, y) {
            return (0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon);
        }
    });
});


var $418b3e9d1661e179$var$name = "equalText";
var $418b3e9d1661e179$var$dependencies = [
    "typed",
    "compareText",
    "isZero"
];
var $418b3e9d1661e179$export$1589aaa29568b87 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($418b3e9d1661e179$var$name, $418b3e9d1661e179$var$dependencies, (_ref)=>{
    var { typed: typed, compareText: compareText, isZero: isZero } = _ref;
    /**
   * Check equality of two strings. Comparison is case sensitive.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.equalText(x, y)
   *
   * Examples:
   *
   *    math.equalText('Hello', 'Hello')     // returns true
   *    math.equalText('a', 'A')             // returns false
   *    math.equal('2e3', '2000')            // returns true
   *    math.equalText('2e3', '2000')        // returns false
   *
   *    math.equalText('B', ['A', 'B', 'C']) // returns [false, true, false]
   *
   * See also:
   *
   *    equal, compareText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns true if the values are equal, and false if not.
   */ return typed($418b3e9d1661e179$var$name, {
        "any, any": function anyAny(x, y) {
            return isZero(compareText(x, y));
        }
    });
});

/* eslint-disable no-loss-of-precision */ 


var $65f5cbe23f5ce903$var$name = "erf";
var $65f5cbe23f5ce903$var$dependencies = [
    "typed"
];
var $65f5cbe23f5ce903$export$470dfa326d6cbdf5 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($65f5cbe23f5ce903$var$name, $65f5cbe23f5ce903$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the erf function of a value using a rational Chebyshev
   * approximations for different intervals of x.
   *
   * This is a translation of W. J. Cody's Fortran implementation from 1987
   * ( https://www.netlib.org/specfun/erf ). See the AMS publication
   * "Rational Chebyshev Approximations for the Error Function" by W. J. Cody
   * for an explanation of this process.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.erf(x)
   *
   * Examples:
   *
   *    math.erf(0.2)    // returns 0.22270258921047847
   *    math.erf(-0.5)   // returns -0.5204998778130465
   *    math.erf(4)      // returns 0.9999999845827421
   *
   * @param {number | Array | Matrix} x   A real number
   * @return {number | Array | Matrix}    The erf of `x`
   */ return typed("name", {
        number: function number(x) {
            var y = Math.abs(x);
            if (y >= $65f5cbe23f5ce903$var$MAX_NUM) return (0, $a03283b133c3c55b$export$c5552dfdbc7cec71)(x);
            if (y <= $65f5cbe23f5ce903$var$THRESH) return (0, $a03283b133c3c55b$export$c5552dfdbc7cec71)(x) * erf1(y);
            if (y <= 4.0) return (0, $a03283b133c3c55b$export$c5552dfdbc7cec71)(x) * (1 - erfc2(y));
            return (0, $a03283b133c3c55b$export$c5552dfdbc7cec71)(x) * (1 - erfc3(y));
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(n, this);
        } // TODO: For complex numbers, use the approximation for the Faddeeva function
    });
    /**
   * Approximates the error function erf() for x <= 0.46875 using this function:
   *               n
   * erf(x) = x * sum (p_j * x^(2j)) / (q_j * x^(2j))
   *              j=0
   */ function erf1(y) {
        var ysq = y * y;
        var xnum = $65f5cbe23f5ce903$var$P[0][4] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 3; i += 1){
            xnum = (xnum + $65f5cbe23f5ce903$var$P[0][i]) * ysq;
            xden = (xden + $65f5cbe23f5ce903$var$Q[0][i]) * ysq;
        }
        return y * (xnum + $65f5cbe23f5ce903$var$P[0][3]) / (xden + $65f5cbe23f5ce903$var$Q[0][3]);
    }
    /**
   * Approximates the complement of the error function erfc() for
   * 0.46875 <= x <= 4.0 using this function:
   *                       n
   * erfc(x) = e^(-x^2) * sum (p_j * x^j) / (q_j * x^j)
   *                      j=0
   */ function erfc2(y) {
        var xnum = $65f5cbe23f5ce903$var$P[1][8] * y;
        var xden = y;
        var i;
        for(i = 0; i < 7; i += 1){
            xnum = (xnum + $65f5cbe23f5ce903$var$P[1][i]) * y;
            xden = (xden + $65f5cbe23f5ce903$var$Q[1][i]) * y;
        }
        var result = (xnum + $65f5cbe23f5ce903$var$P[1][7]) / (xden + $65f5cbe23f5ce903$var$Q[1][7]);
        var ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
    /**
   * Approximates the complement of the error function erfc() for x > 4.0 using
   * this function:
   *
   * erfc(x) = (e^(-x^2) / x) * [ 1/sqrt(pi) +
   *               n
   *    1/(x^2) * sum (p_j * x^(-2j)) / (q_j * x^(-2j)) ]
   *              j=0
   */ function erfc3(y) {
        var ysq = 1 / (y * y);
        var xnum = $65f5cbe23f5ce903$var$P[2][5] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 4; i += 1){
            xnum = (xnum + $65f5cbe23f5ce903$var$P[2][i]) * ysq;
            xden = (xden + $65f5cbe23f5ce903$var$Q[2][i]) * ysq;
        }
        var result = ysq * (xnum + $65f5cbe23f5ce903$var$P[2][4]) / (xden + $65f5cbe23f5ce903$var$Q[2][4]);
        result = ($65f5cbe23f5ce903$var$SQRPI - result) / y;
        ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
});
/**
 * Upper bound for the first approximation interval, 0 <= x <= THRESH
 * @constant
 */ var $65f5cbe23f5ce903$var$THRESH = 0.46875;
/**
 * Constant used by W. J. Cody's Fortran77 implementation to denote sqrt(pi)
 * @constant
 */ var $65f5cbe23f5ce903$var$SQRPI = 5.6418958354775628695e-1;
/**
 * Coefficients for each term of the numerator sum (p_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $65f5cbe23f5ce903$var$P = [
    [
        3.16112374387056560e00,
        1.13864154151050156e02,
        3.77485237685302021e02,
        3.20937758913846947e03,
        1.85777706184603153e-1
    ],
    [
        5.64188496988670089e-1,
        8.88314979438837594e00,
        6.61191906371416295e01,
        2.98635138197400131e02,
        8.81952221241769090e02,
        1.71204761263407058e03,
        2.05107837782607147e03,
        1.23033935479799725e03,
        2.15311535474403846e-8
    ],
    [
        3.05326634961232344e-1,
        3.60344899949804439e-1,
        1.25781726111229246e-1,
        1.60837851487422766e-2,
        6.58749161529837803e-4,
        1.63153871373020978e-2
    ]
];
/**
 * Coefficients for each term of the denominator sum (q_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $65f5cbe23f5ce903$var$Q = [
    [
        2.36012909523441209e01,
        2.44024637934444173e02,
        1.28261652607737228e03,
        2.84423683343917062e03
    ],
    [
        1.57449261107098347e01,
        1.17693950891312499e02,
        5.37181101862009858e02,
        1.62138957456669019e03,
        3.29079923573345963e03,
        4.36261909014324716e03,
        3.43936767414372164e03,
        1.23033935480374942e03
    ],
    [
        2.56852019228982242e00,
        1.87295284992346047e00,
        5.27905102951428412e-1,
        6.05183413124413191e-2,
        2.33520497626869185e-3
    ]
];
/**
 * Maximum/minimum safe numbers to input to erf() (in ES6+, this number is
 * Number.[MAX|MIN]_SAFE_INTEGER). erf() for all numbers beyond this limit will
 * return 1
 */ var $65f5cbe23f5ce903$var$MAX_NUM = Math.pow(2, 53);




var $d52e3dd66dea5f0d$var$name = "exp";
var $d52e3dd66dea5f0d$var$dependencies = [
    "typed"
];
var $d52e3dd66dea5f0d$export$95a576617fd015b1 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d52e3dd66dea5f0d$var$name, $d52e3dd66dea5f0d$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the exponent of a value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.exp(x)
   *
   * Examples:
   *
   *    math.exp(2)                  // returns number 7.3890560989306495
   *    math.pow(math.e, 2)          // returns number 7.3890560989306495
   *    math.log(math.exp(2))        // returns number 2
   *
   *    math.exp([1, 2, 3])
   *    // returns Array [
   *    //   2.718281828459045,
   *    //   7.3890560989306495,
   *    //   20.085536923187668
   *    // ]
   *
   * See also:
   *
   *    expm1, log, pow
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to exponentiate
   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
   */ return typed($d52e3dd66dea5f0d$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$a33b288b35672fe5),
        Complex: function Complex(x) {
            return x.exp();
        },
        BigNumber: function BigNumber(x) {
            return x.exp();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // TODO: exp(sparse) should return a dense matrix since exp(0)==1
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $85259d56fb40c4ba$var$name = "expm";
var $85259d56fb40c4ba$var$dependencies = [
    "typed",
    "abs",
    "add",
    "identity",
    "inv",
    "multiply"
];
var $85259d56fb40c4ba$export$f2c0a6357ff6cb4c = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($85259d56fb40c4ba$var$name, $85259d56fb40c4ba$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, identity: identity, inv: inv, multiply: multiply } = _ref;
    /**
   * Compute the matrix exponential, expm(A) = e^A. The matrix must be square.
   * Not to be confused with exp(a), which performs element-wise
   * exponentiation.
   *
   * The exponential is calculated using the Padé approximant with scaling and
   * squaring; see "Nineteen Dubious Ways to Compute the Exponential of a
   * Matrix," by Moler and Van Loan.
   *
   * Syntax:
   *
   *     math.expm(x)
   *
   * Examples:
   *
   *     const A = [[0,2],[0,0]]
   *     math.expm(A)        // returns [[1,2],[0,1]]
   *
   * See also:
   *
   *     exp
   *
   * @param {Matrix} x  A square Matrix
   * @return {Matrix}   The exponential of x
   */ return typed($85259d56fb40c4ba$var$name, {
        Matrix: function Matrix(A) {
            // Check matrix size
            var size = A.size();
            if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
            var n = size[0]; // Desired accuracy of the approximant (The actual accuracy
            // will be affected by round-off error)
            var eps = 1e-15; // The Padé approximant is not so accurate when the values of A
            // are "large", so scale A by powers of two. Then compute the
            // exponential, and square the result repeatedly according to
            // the identity e^A = (e^(A/m))^m
            // Compute infinity-norm of A, ||A||, to see how "big" it is
            var infNorm = infinityNorm(A); // Find the optimal scaling factor and number of terms in the
            // Padé approximant to reach the desired accuracy
            var params = findParams(infNorm, eps);
            var q = params.q;
            var j = params.j; // The Pade approximation to e^A is:
            // Rqq(A) = Dqq(A) ^ -1 * Nqq(A)
            // where
            // Nqq(A) = sum(i=0, q, (2q-i)!p! / [ (2q)!i!(q-i)! ] A^i
            // Dqq(A) = sum(i=0, q, (2q-i)!q! / [ (2q)!i!(q-i)! ] (-A)^i
            // Scale A by 1 / 2^j
            var Apos = multiply(A, Math.pow(2, -j)); // The i=0 term is just the identity matrix
            var N = identity(n);
            var D = identity(n); // Initialization (i=0)
            var factor = 1; // Initialization (i=1)
            var AposToI = Apos; // Cloning not necessary
            var alternate = -1;
            for(var i = 1; i <= q; i++){
                if (i > 1) {
                    AposToI = multiply(AposToI, Apos);
                    alternate = -alternate;
                }
                factor = factor * (q - i + 1) / ((2 * q - i + 1) * i);
                N = add(N, multiply(factor, AposToI));
                D = add(D, multiply(factor * alternate, AposToI));
            }
            var R = multiply(inv(D), N); // Square j times
            for(var _i = 0; _i < j; _i++)R = multiply(R, R);
            return (0, $2c4f948f17aa2240$export$d508368d4da3c38a)(A) ? A.createSparseMatrix(R) : R;
        }
    });
    function infinityNorm(A) {
        var n = A.size()[0];
        var infNorm = 0;
        for(var i = 0; i < n; i++){
            var rowSum = 0;
            for(var j = 0; j < n; j++)rowSum += abs(A.get([
                i,
                j
            ]));
            infNorm = Math.max(rowSum, infNorm);
        }
        return infNorm;
    }
    /**
   * Find the best parameters for the Pade approximant given
   * the matrix norm and desired accuracy. Returns the first acceptable
   * combination in order of increasing computational load.
   */ function findParams(infNorm, eps) {
        var maxSearchSize = 30;
        for(var k = 0; k < maxSearchSize; k++)for(var q = 0; q <= k; q++){
            var j = k - q;
            if (errorEstimate(infNorm, q, j) < eps) return {
                q: q,
                j: j
            };
        }
        throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
    }
    /**
   * Returns the estimated error of the Pade approximant for the given
   * parameters.
   */ function errorEstimate(infNorm, q, j) {
        var qfac = 1;
        for(var i = 2; i <= q; i++)qfac *= i;
        var twoqfac = qfac;
        for(var _i2 = q + 1; _i2 <= 2 * q; _i2++)twoqfac *= _i2;
        var twoqp1fac = twoqfac * (2 * q + 1);
        return 8.0 * Math.pow(infNorm / Math.pow(2, j), 2 * q) * qfac * qfac / (twoqfac * twoqp1fac);
    }
});




var $8c67ccae451ccda3$var$name = "expm1";
var $8c67ccae451ccda3$var$dependencies = [
    "typed",
    "Complex"
];
var $8c67ccae451ccda3$export$2b203b63f664bab3 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8c67ccae451ccda3$var$name, $8c67ccae451ccda3$var$dependencies, (_ref)=>{
    var { typed: typed, Complex: _Complex } = _ref;
    /**
   * Calculate the value of subtracting 1 from the exponential value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.expm1(x)
   *
   * Examples:
   *
   *    math.expm1(2)                      // returns number 6.38905609893065
   *    math.pow(math.e, 2) - 1            // returns number 6.3890560989306495
   *    math.log(math.expm1(2) + 1)        // returns number 2
   *
   *    math.expm1([1, 2, 3])
   *    // returns Array [
   *    //   1.718281828459045,
   *    //   6.3890560989306495,
   *    //   19.085536923187668
   *    // ]
   *
   * See also:
   *
   *    exp, log, pow
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to apply expm1
   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
   */ return typed($8c67ccae451ccda3$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$756d0c010cecc6c3),
        Complex: function Complex(x) {
            var r = Math.exp(x.re);
            return new _Complex(r * Math.cos(x.im) - 1, r * Math.sin(x.im));
        },
        BigNumber: function BigNumber(x) {
            return x.exp().minus(1);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $71f84c34a81f2c01$var$name = "factorial";
var $71f84c34a81f2c01$var$dependencies = [
    "typed",
    "gamma"
];
var $71f84c34a81f2c01$export$92c37ad44e3d0481 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($71f84c34a81f2c01$var$name, $71f84c34a81f2c01$var$dependencies, (_ref)=>{
    var { typed: typed, gamma: gamma } = _ref;
    /**
   * Compute the factorial of a value
   *
   * Factorial only supports an integer value as argument.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.factorial(n)
   *
   * Examples:
   *
   *    math.factorial(5)    // returns 120
   *    math.factorial(3)    // returns 6
   *
   * See also:
   *
   *    combinations, combinationsWithRep, gamma, permutations
   *
   * @param {number | BigNumber | Array | Matrix} n   An integer number
   * @return {number | BigNumber | Array | Matrix}    The factorial of `n`
   */ return typed($71f84c34a81f2c01$var$name, {
        number: function number(n) {
            if (n < 0) throw new Error("Value must be non-negative");
            return gamma(n + 1);
        },
        BigNumber: function BigNumber(n) {
            if (n.isNegative()) throw new Error("Value must be non-negative");
            return gamma(n.plus(1));
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(n, this);
        }
    });
});



var $b822c93efe1e3bd7$var$name = "fft";
var $b822c93efe1e3bd7$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "multiplyScalar",
    "divideScalar",
    "exp",
    "tau",
    "i"
];
var $b822c93efe1e3bd7$export$41ce8d9733cb73c1 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b822c93efe1e3bd7$var$name, $b822c93efe1e3bd7$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, multiplyScalar: multiplyScalar, divideScalar: divideScalar, exp: exp, tau: tau, i: I } = _ref;
    /**
   * Calculate N-dimensional fourier transform
   *
   * Syntax:
   *
   *     math.fft(arr)
   *
   * Examples:
   *
   *    math.fft([[1, 0], [1, 0]]) // returns [[{re:2, im:0}, {re:2, im:0}], [{re:0, im:0}, {re:0, im:0}]]
   *
   *
   * See Also:
   *
   *      ifft
   *
   * @param {Array | Matrix} arr    An array or matrix
   * @return {Array | Matrix}       N-dimensional fourier transformation of the array
   */ return typed($b822c93efe1e3bd7$var$name, {
        Array: _ndFft,
        Matrix: function Matrix(matrix) {
            return matrix.create(_ndFft(matrix.toArray()));
        }
    });
    /**
   * Perform an N-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @return {Array}         resulting array
   */ function _ndFft(arr) {
        var size = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(arr);
        if (size.length === 1) return _fft(arr, size[0]); // ndFft along dimension 1,...,N-1 then 1dFft along dimension 0
        return _1dFft(arr.map((slice)=>_ndFft(slice, size.slice(1))), 0);
    }
    /**
   * Perform an 1-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @param {number} dim     dimension of the array to perform on
   * @return {Array}         resulting array
   */ function _1dFft(arr, dim) {
        var size = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(arr);
        if (dim !== 0) return new Array(size[0]).fill(0).map((_, i)=>_1dFft(arr[i], dim - 1));
        if (size.length === 1) return _fft(arr);
        function _transpose(arr) {
            // Swap first 2 dimensions
            var size = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(arr);
            return new Array(size[1]).fill(0).map((_, j)=>new Array(size[0]).fill(0).map((_, i)=>arr[i][j]));
        }
        return _transpose(_1dFft(_transpose(arr), 1));
    }
    /**
   * Perform an 1-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @return {Array}         resulting array
   */ function _fft(arr) {
        var len = arr.length;
        if (len === 1) return [
            arr[0]
        ];
        if (len % 2 === 0) {
            var ret = [
                ..._fft(arr.filter((_, i)=>i % 2 === 0), len / 2),
                ..._fft(arr.filter((_, i)=>i % 2 === 1), len / 2)
            ];
            for(var k = 0; k < len / 2; k++){
                var p = ret[k];
                var q = multiplyScalar(ret[k + len / 2], exp(multiplyScalar(multiplyScalar(tau, I), divideScalar(-k, len))));
                ret[k] = addScalar(p, q);
                ret[k + len / 2] = addScalar(p, multiplyScalar(-1, q));
            }
            return ret;
        }
        throw new Error("Can only calculate FFT of power-of-two size");
    }
});


var $2ea7a6ca53421abc$var$name = "FibonacciHeap";
var $2ea7a6ca53421abc$var$dependencies = [
    "smaller",
    "larger"
];
var $2ea7a6ca53421abc$export$3143a09e27a84c41 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($2ea7a6ca53421abc$var$name, $2ea7a6ca53421abc$var$dependencies, (_ref)=>{
    var { smaller: smaller, larger: larger } = _ref;
    var oneOverLogPhi = 1.0 / Math.log((1.0 + Math.sqrt(5.0)) / 2.0);
    /**
   * Fibonacci Heap implementation, used interally for Matrix math.
   * @class FibonacciHeap
   * @constructor FibonacciHeap
   */ function FibonacciHeap() {
        if (!(this instanceof FibonacciHeap)) throw new SyntaxError("Constructor must be called with the new operator");
         // initialize fields
        this._minimum = null;
        this._size = 0;
    }
    /**
   * Attach type information
   */ FibonacciHeap.prototype.type = "FibonacciHeap";
    FibonacciHeap.prototype.isFibonacciHeap = true;
    /**
   * Inserts a new data element into the heap. No heap consolidation is
   * performed at this time, the new node is simply inserted into the root
   * list of this heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.insert = function(key, value) {
        // create node
        var node = {
            key: key,
            value: value,
            degree: 0
        }; // check we have a node in the minimum
        if (this._minimum) {
            // minimum node
            var minimum = this._minimum; // update left & right of node
            node.left = minimum;
            node.right = minimum.right;
            minimum.right = node;
            node.right.left = node; // update minimum node in heap if needed
            if (smaller(key, minimum.key)) // node has a smaller key, use it as minimum
            this._minimum = node;
        } else {
            // set left & right
            node.left = node;
            node.right = node; // this is the first node
            this._minimum = node;
        } // increment number of nodes in heap
        this._size++; // return node
        return node;
    };
    /**
   * Returns the number of nodes in heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.size = function() {
        return this._size;
    };
    /**
   * Removes all elements from this heap.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.clear = function() {
        this._minimum = null;
        this._size = 0;
    };
    /**
   * Returns true if the heap is empty, otherwise false.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.isEmpty = function() {
        return this._size === 0;
    };
    /**
   * Extracts the node with minimum key from heap. Amortized running
   * time: O(log n).
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.extractMinimum = function() {
        // node to remove
        var node = this._minimum; // check we have a minimum
        if (node === null) return node;
         // current minimum
        var minimum = this._minimum; // get number of children
        var numberOfChildren = node.degree; // pointer to the first child
        var x = node.child; // for each child of node do...
        while(numberOfChildren > 0){
            // store node in right side
            var tempRight = x.right; // remove x from child list
            x.left.right = x.right;
            x.right.left = x.left; // add x to root list of heap
            x.left = minimum;
            x.right = minimum.right;
            minimum.right = x;
            x.right.left = x; // set Parent[x] to null
            x.parent = null;
            x = tempRight;
            numberOfChildren--;
        } // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left; // update minimum
        if (node === node.right) // empty
        minimum = null;
        else {
            // update minimum
            minimum = node.right; // we need to update the pointer to the root with minimum key
            minimum = _findMinimumNode(minimum, this._size);
        } // decrement size of heap
        this._size--; // update minimum
        this._minimum = minimum; // return node
        return node;
    };
    /**
   * Removes a node from the heap given the reference to the node. The trees
   * in the heap will be consolidated, if necessary. This operation may fail
   * to remove the correct element if there are nodes with key value -Infinity.
   * Running time: O(log n) amortized.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.remove = function(node) {
        // decrease key value
        this._minimum = _decreaseKey(this._minimum, node, -1); // remove the smallest
        this.extractMinimum();
    };
    /**
   * Decreases the key value for a heap node, given the new value to take on.
   * The structure of the heap may be changed and will not be consolidated.
   * Running time: O(1) amortized.
   * @memberof FibonacciHeap
   */ function _decreaseKey(minimum, node, key) {
        // set node key
        node.key = key; // get parent node
        var parent = node.parent;
        if (parent && smaller(node.key, parent.key)) {
            // remove node from parent
            _cut(minimum, node, parent); // remove all nodes from parent to the root parent
            _cascadingCut(minimum, parent);
        } // update minimum node if needed
        if (smaller(node.key, minimum.key)) minimum = node;
         // return minimum
        return minimum;
    }
    /**
   * The reverse of the link operation: removes node from the child list of parent.
   * This method assumes that min is non-null. Running time: O(1).
   * @memberof FibonacciHeap
   */ function _cut(minimum, node, parent) {
        // remove node from parent children and decrement Degree[parent]
        node.left.right = node.right;
        node.right.left = node.left;
        parent.degree--; // reset y.child if necessary
        if (parent.child === node) parent.child = node.right;
         // remove child if degree is 0
        if (parent.degree === 0) parent.child = null;
         // add node to root list of heap
        node.left = minimum;
        node.right = minimum.right;
        minimum.right = node;
        node.right.left = node; // set parent[node] to null
        node.parent = null; // set mark[node] to false
        node.mark = false;
    }
    /**
   * Performs a cascading cut operation. This cuts node from its parent and then
   * does the same for its parent, and so on up the tree.
   * Running time: O(log n); O(1) excluding the recursion.
   * @memberof FibonacciHeap
   */ function _cascadingCut(minimum, node) {
        // store parent node
        var parent = node.parent; // if there's a parent...
        if (!parent) return;
         // if node is unmarked, set it marked
        if (!node.mark) node.mark = true;
        else {
            // it's marked, cut it from parent
            _cut(minimum, node, parent); // cut its parent as well
            _cascadingCut(parent);
        }
    }
    /**
   * Make the first node a child of the second one. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ var _linkNodes = function _linkNodes(node, parent) {
        // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left; // make node a Child of parent
        node.parent = parent;
        if (!parent.child) {
            parent.child = node;
            node.right = node;
            node.left = node;
        } else {
            node.left = parent.child;
            node.right = parent.child.right;
            parent.child.right = node;
            node.right.left = node;
        } // increase degree[parent]
        parent.degree++; // set mark[node] false
        node.mark = false;
    };
    function _findMinimumNode(minimum, size) {
        // to find trees of the same degree efficiently we use an array of length O(log n) in which we keep a pointer to one root of each degree
        var arraySize = Math.floor(Math.log(size) * oneOverLogPhi) + 1; // create list with initial capacity
        var array = new Array(arraySize); // find the number of root nodes.
        var numRoots = 0;
        var x = minimum;
        if (x) {
            numRoots++;
            x = x.right;
            while(x !== minimum){
                numRoots++;
                x = x.right;
            }
        } // vars
        var y; // For each node in root list do...
        while(numRoots > 0){
            // access this node's degree..
            var d = x.degree; // get next node
            var next = x.right; // check if there is a node already in array with the same degree
            while(true){
                // get node with the same degree is any
                y = array[d];
                if (!y) break;
                 // make one node with the same degree a child of the other, do this based on the key value.
                if (larger(x.key, y.key)) {
                    var temp = y;
                    y = x;
                    x = temp;
                } // make y a child of x
                _linkNodes(y, x); // we have handled this degree, go to next one.
                array[d] = null;
                d++;
            } // save this node for later when we might encounter another of the same degree.
            array[d] = x; // move forward through list.
            x = next;
            numRoots--;
        } // Set min to null (effectively losing the root list) and reconstruct the root list from the array entries in array[].
        minimum = null; // loop nodes in array
        for(var i = 0; i < arraySize; i++){
            // get current node
            y = array[i];
            if (!y) continue;
             // check if we have a linked list
            if (minimum) {
                // First remove node from root list.
                y.left.right = y.right;
                y.right.left = y.left; // now add to root list, again.
                y.left = minimum;
                y.right = minimum.right;
                minimum.right = y;
                y.right.left = y; // check if this is a new min.
                if (smaller(y.key, minimum.key)) minimum = y;
            } else minimum = y;
        }
        return minimum;
    }
    return FibonacciHeap;
}, {
    isClass: true
});




var $22ae454ba62fbf56$var$name = "filter";
var $22ae454ba62fbf56$var$dependencies = [
    "typed"
];
var $22ae454ba62fbf56$export$5d81789ff4aeccdf = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($22ae454ba62fbf56$var$name, $22ae454ba62fbf56$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Filter the items in an array or one dimensional matrix.
   *
   * Syntax:
   *
   *    math.filter(x, test)
   *
   * Examples:
   *
   *    function isPositive (x) {
   *      return x > 0
   *    }
   *    math.filter([6, -2, -1, 4, 3], isPositive) // returns [6, 4, 3]
   *
   *    math.filter(["23", "foo", "100", "55", "bar"], /[0-9]+/) // returns ["23", "100", "55"]
   *
   * See also:
   *
   *    forEach, map, sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to filter
   * @param {Function | RegExp} test
   *        A function or regular expression to test items.
   *        All entries for which `test` returns true are returned.
   *        When `test` is a function, it is invoked with three parameters:
   *        the value of the element, the index of the element, and the
   *        matrix/array being traversed. The function must return a boolean.
   * @return {Matrix | Array} Returns the filtered matrix.
   */ return typed("filter", {
        "Array, function": $22ae454ba62fbf56$var$_filterCallback,
        "Matrix, function": function MatrixFunction(x, test) {
            return x.create($22ae454ba62fbf56$var$_filterCallback(x.toArray(), test));
        },
        "Array, RegExp": (0, $802b18b8c920d4c6$export$322859471e81229d),
        "Matrix, RegExp": function MatrixRegExp(x, test) {
            return x.create((0, $802b18b8c920d4c6$export$322859471e81229d)(x.toArray(), test));
        }
    });
});
/**
 * Filter values in a callback given a callback function
 * @param {Array} x
 * @param {Function} callback
 * @return {Array} Returns the filtered array
 * @private
 */ function $22ae454ba62fbf56$var$_filterCallback(x, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $43b7a970faec5d37$export$6c00fba23f8c91a7)(callback);
    return (0, $802b18b8c920d4c6$export$3dea766d36a8935f)(x, function(value, index, array) {
        // invoke the callback function with the right number of arguments
        if (args === 1) return callback(value);
        else if (args === 2) return callback(value, [
            index
        ]);
        else // 3 or -1
        return callback(value, [
            index
        ], array);
    });
}





var $848db03932484735$var$name = "fix";
var $848db03932484735$var$dependencies = [
    "typed",
    "Complex",
    "matrix",
    "ceil",
    "floor",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $848db03932484735$export$595d114466bb5460 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($848db03932484735$var$name, [
    "typed",
    "ceil",
    "floor"
], (_ref)=>{
    var { typed: typed, ceil: ceil, floor: floor } = _ref;
    return typed($848db03932484735$var$name, {
        number: function number(x) {
            return x > 0 ? floor(x) : ceil(x);
        },
        "number, number": function numberNumber(x, n) {
            return x > 0 ? floor(x, n) : ceil(x, n);
        }
    });
});
var $848db03932484735$export$3ed06081b8a4ee6 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($848db03932484735$var$name, $848db03932484735$var$dependencies, (_ref2)=>{
    var { typed: typed, Complex: _Complex, matrix: matrix, ceil: ceil, floor: floor, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    var fixNumber = $848db03932484735$export$595d114466bb5460({
        typed: typed,
        ceil: ceil,
        floor: floor
    });
    /**
   * Round a value towards zero.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.fix(x)
   *    math.fix(x,n)
   *
   * Examples:
   *
   *    math.fix(3.2)                // returns number 3
   *    math.fix(3.8)                // returns number 3
   *    math.fix(-4.2)               // returns number -4
   *    math.fix(-4.7)               // returns number -4
   *
   *    math.fix(3.12, 1)                // returns number 3.1
   *    math.fix(3.18, 1)                // returns number 3.1
   *    math.fix(-4.12, 1)               // returns number -4.1
   *    math.fix(-4.17, 1)               // returns number -4.1
   *
   *    const c = math.complex(3.22, -2.78)
   *    math.fix(c)                  // returns Complex 3 - 2i
   *    math.fix(c, 1)               // returns Complex 3.2 - 2.7i
   *
   *    math.fix([3.2, 3.8, -4.7])      // returns Array [3, 3, -4]
   *    math.fix([3.2, 3.8, -4.7], 1)   // returns Array [3.2, 3.8, -4.7]
   *
   * See also:
   *
   *    ceil, floor, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x    Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                             Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix}     Rounded value
   */ return typed("fix", {
        number: fixNumber.signatures.number,
        "number, number | BigNumber": fixNumber.signatures["number,number"],
        Complex: function Complex(x) {
            return new _Complex(x.re > 0 ? Math.floor(x.re) : Math.ceil(x.re), x.im > 0 ? Math.floor(x.im) : Math.ceil(x.im));
        },
        "Complex, number": function ComplexNumber(x, n) {
            return new _Complex(x.re > 0 ? floor(x.re, n) : ceil(x.re, n), x.im > 0 ? floor(x.im, n) : ceil(x.im, n));
        },
        "Complex, BigNumber": function ComplexBigNumber(x, bn) {
            var n = bn.toNumber();
            return new _Complex(x.re > 0 ? floor(x.re, n) : ceil(x.re, n), x.im > 0 ? floor(x.im, n) : ceil(x.im, n));
        },
        BigNumber: function BigNumber(x) {
            return x.isNegative() ? ceil(x) : floor(x);
        },
        "BigNumber, number | BigNumber": function BigNumberNumberBigNumber(x, n) {
            return x.isNegative() ? ceil(x, n) : floor(x, n);
        },
        Fraction: function Fraction(x) {
            return x.s < 0 ? x.ceil() : x.floor();
        },
        "Fraction, number | BigNumber": function FractionNumberBigNumber(x, n) {
            return x.s < 0 ? ceil(x, n) : floor(x, n);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since fix(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        },
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(x, n) {
            // deep map collection, skip zeros since fix(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, (i)=>this(i, n), true);
        },
        "number | Complex | Fraction | BigNumber, Array": function numberComplexFractionBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        "number | Complex | Fraction | BigNumber, Matrix": function numberComplexFractionBigNumberMatrix(x, y) {
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            if (y.storage() === "dense") return algorithm14(y, x, this, true);
            return algorithm12(y, x, this, true);
        }
    });
});




var $40df0a4579b1d367$var$name = "flatten";
var $40df0a4579b1d367$var$dependencies = [
    "typed",
    "matrix"
];
var $40df0a4579b1d367$export$107988e3ee9f3d12 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($40df0a4579b1d367$var$name, $40df0a4579b1d367$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Flatten a multi dimensional matrix into a single dimensional matrix.
   * It is guaranteed to always return a clone of the argument.
   *
   * Syntax:
   *
   *    math.flatten(x)
   *
   * Examples:
   *
   *    math.flatten([[1,2], [3,4]])   // returns [1, 2, 3, 4]
   *
   * See also:
   *
   *    concat, resize, size, squeeze
   *
   * @param {Matrix | Array} x   Matrix to be flattened
   * @return {Matrix | Array} Returns the flattened matrix
   */ return typed($40df0a4579b1d367$var$name, {
        Array: function Array(x) {
            return (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)((0, $33619877a15996ac$export$9cd59f9826255e47)(x));
        },
        Matrix: function Matrix(x) {
            var flat = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)((0, $33619877a15996ac$export$9cd59f9826255e47)(x.toArray())); // TODO: return the same matrix type as x
            return matrix(flat);
        }
    });
});









var $24c5519c293b10ca$var$name = "floor";
var $24c5519c293b10ca$var$dependencies = [
    "typed",
    "config",
    "round",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $24c5519c293b10ca$export$a13f3226a75ff445 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($24c5519c293b10ca$var$name, [
    "typed",
    "config",
    "round"
], (_ref)=>{
    var { typed: typed, config: config, round: round } = _ref;
    return typed($24c5519c293b10ca$var$name, {
        number: function number(x) {
            if ((0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, round(x), config.epsilon)) return round(x);
            else return Math.floor(x);
        },
        "number, number": function numberNumber(x, n) {
            if ((0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, round(x, n), config.epsilon)) return round(x, n);
            else {
                var [number, exponent] = "".concat(x, "e").split("e");
                var result = Math.floor(Number("".concat(number, "e").concat(Number(exponent) + n)));
                [number, exponent] = "".concat(result, "e").split("e");
                return Number("".concat(number, "e").concat(Number(exponent) - n));
            }
        }
    });
});
var $24c5519c293b10ca$export$e04e4803a9128c9b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($24c5519c293b10ca$var$name, $24c5519c293b10ca$var$dependencies, (_ref2)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    var floorNumber = $24c5519c293b10ca$export$a13f3226a75ff445({
        typed: typed,
        config: config,
        round: round
    });
    /**
   * Round a value towards minus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.floor(x)
   *    math.floor(x, n)
   *
   * Examples:
   *
   *    math.floor(3.2)              // returns number 3
   *    math.floor(3.8)              // returns number 3
   *    math.floor(-4.2)             // returns number -5
   *    math.floor(-4.7)             // returns number -5
   *
   *    math.floor(3.212, 2)          // returns number 3.21
   *    math.floor(3.288, 2)          // returns number 3.28
   *    math.floor(-4.212, 2)         // returns number -4.22
   *    math.floor(-4.782, 2)         // returns number -4.79
   *
   *    const c = math.complex(3.24, -2.71)
   *    math.floor(c)                 // returns Complex 3 - 3i
   *    math.floor(c, 1)              // returns Complex 3.2 - 2.8i
   *
   *    math.floor([3.2, 3.8, -4.7])       // returns Array [3, 3, -5]
   *    math.floor([3.21, 3.82, -4.71], 1)  // returns Array [3.2, 3.8, -4.8]
   *
   *    math.floor(math.tau, [2, 3])  // returns Array [6.28, 6.283]
   *
   *    // Note that floor(array, array) currently not implemented.
   *
   * See also:
   *
   *    ceil, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed("floor", {
        number: floorNumber.signatures.number,
        "number,number": floorNumber.signatures["number,number"],
        Complex: function Complex(x) {
            return x.floor();
        },
        "Complex, number": function ComplexNumber(x, n) {
            return x.floor(n);
        },
        "Complex, BigNumber": function ComplexBigNumber(x, n) {
            return x.floor(n.toNumber());
        },
        BigNumber: function BigNumber(x) {
            if ((0, $cea3608675fc8eba$export$6f3989c6ecc04081)(x, round(x), config.epsilon)) return round(x);
            else return x.floor();
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, n) {
            if ((0, $cea3608675fc8eba$export$6f3989c6ecc04081)(x, round(x, n), config.epsilon)) return round(x, n);
            else return x.toDecimalPlaces(n.toNumber(), (0, (/*@__PURE__*/$parcel$interopDefault($22467ec447bdc2ca$exports))).ROUND_FLOOR);
        },
        Fraction: function Fraction(x) {
            return x.floor();
        },
        "Fraction, number": function FractionNumber(x, n) {
            return x.floor(n);
        },
        "Fraction, BigNumber": function FractionBigNumber(x, n) {
            return x.floor(n.toNumber());
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since floor(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, n) {
            // deep map collection, skip zeros since ceil(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, (i)=>this(i, n), true);
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | Complex | Fraction | BigNumber, Array": function numberComplexFractionBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        "number | Complex | Fraction | BigNumber, Matrix": function numberComplexFractionBigNumberMatrix(x, y) {
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            if (y.storage() === "dense") return algorithm14(y, x, this, true);
            return algorithm12(y, x, this, true);
        }
    });
});




var $0fed3482d31b5817$var$name = "forEach";
var $0fed3482d31b5817$var$dependencies = [
    "typed"
];
var $0fed3482d31b5817$export$a5218987e0811e05 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($0fed3482d31b5817$var$name, $0fed3482d31b5817$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterate over all elements of a matrix/array, and executes the given callback function.
   *
   * Syntax:
   *
   *    math.forEach(x, callback)
   *
   * Examples:
   *
   *    math.forEach([1, 2, 3], function(value) {
   *      console.log(value)
   *    })
   *    // outputs 1, 2, 3
   *
   * See also:
   *
   *    filter, map, sort
   *
   * @param {Matrix | Array} x    The matrix to iterate on.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix/array being traversed.
   */ return typed($0fed3482d31b5817$var$name, {
        "Array, function": $0fed3482d31b5817$var$_forEach,
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.forEach(callback);
        }
    });
});
/**
 * forEach for a multi dimensional array
 * @param {Array} array
 * @param {Function} callback
 * @private
 */ function $0fed3482d31b5817$var$_forEach(array, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $43b7a970faec5d37$export$6c00fba23f8c91a7)(callback);
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) (0, $802b18b8c920d4c6$export$4b80e395e36b5a56)(value, function(child, i) {
            // we create a copy of the index array and append the new index value
            recurse(child, index.concat(i));
        });
        else {
            // invoke the callback function with the right number of arguments
            if (args === 1) callback(value);
            else if (args === 2) callback(value, index);
            else // 3 or -1
            callback(value, index, array);
        }
    };
    recurse(array, []);
}



var $403585168a691256$var$name = "format";
var $403585168a691256$var$dependencies = [
    "typed"
];
var $403585168a691256$export$abf0d9399b60f9bb = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($403585168a691256$var$name, $403585168a691256$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Format a value of any type into a string.
   *
   * Syntax:
   *
   *    math.format(value)
   *    math.format(value, options)
   *    math.format(value, precision)
   *    math.format(value, callback)
   *
   * Where:
   *
   *  - `value: *`
   *    The value to be formatted
   *  - `options: Object`
   *    An object with formatting options. Available options:
   *    - `notation: string`
   *      Number notation. Choose from:
   *      - 'fixed'
   *        Always use regular number notation.
   *        For example '123.40' and '14000000'
   *      - 'exponential'
   *        Always use exponential notation.
   *        For example '1.234e+2' and '1.4e+7'
   *      - 'engineering'
   *        Always use engineering notation: always have exponential notation,
   *        and select the exponent to be a multiple of 3.
   *        For example '123.4e+0' and '14.0e+6'
   *      - 'auto' (default)
   *        Regular number notation for numbers having an absolute value between
   *        `lower` and `upper` bounds, and uses exponential notation elsewhere.
   *        Lower bound is included, upper bound is excluded.
   *        For example '123.4' and '1.4e7'.
   *      - 'bin', 'oct, or 'hex'
   *        Format the number using binary, octal, or hexadecimal notation.
   *        For example '0b1101' and '0x10fe'.
   *    - `wordSize: number`
   *      The word size in bits to use for formatting in binary, octal, or
   *      hexadecimal notation. To be used only with 'bin', 'oct', or 'hex'
   *      values for 'notation' option. When this option is defined the value
   *      is formatted as a signed twos complement integer of the given word
   *      size and the size suffix is appended to the output.
   *      For example format(-1, {notation: 'hex', wordSize: 8}) === '0xffi8'.
   *      Default value is undefined.
   *    - `precision: number`
   *      Limit the number of digits of the formatted value.
   *      For regular numbers, must be a number between 0 and 16.
   *      For bignumbers, the maximum depends on the configured precision,
   *      see function `config()`.
   *      In case of notations 'exponential', 'engineering', and 'auto', `precision`
   *      defines the total number of significant digits returned.
   *      In case of notation 'fixed', `precision` defines the number of
   *      significant digits after the decimal point.
   *      `precision` is undefined by default.
   *    - `lowerExp: number`
   *      Exponent determining the lower boundary for formatting a value with
   *      an exponent when `notation='auto`. Default value is `-3`.
   *    - `upperExp: number`
   *      Exponent determining the upper boundary for formatting a value with
   *      an exponent when `notation='auto`. Default value is `5`.
   *    - `fraction: string`. Available values: 'ratio' (default) or 'decimal'.
   *      For example `format(fraction(1, 3))` will output '1/3' when 'ratio' is
   *      configured, and will output `0.(3)` when 'decimal' is configured.
   *    - `truncate: number`. Specifies the maximum allowed length of the
   *      returned string. If it would have been longer, the excess characters
   *      are deleted and replaced with `'...'`.
   * - `callback: function`
   *   A custom formatting function, invoked for all numeric elements in `value`,
   *   for example all elements of a matrix, or the real and imaginary
   *   parts of a complex number. This callback can be used to override the
   *   built-in numeric notation with any type of formatting. Function `callback`
   *   is called with `value` as parameter and must return a string.
   *
   * When `value` is an Object:
   *
   * - When the object contains a property `format` being a function, this function
   *   is invoked as `value.format(options)` and the result is returned.
   * - When the object has its own `toString` method, this method is invoked
   *   and the result is returned.
   * - In other cases the function will loop over all object properties and
   *   return JSON object notation like '{"a": 2, "b": 3}'.
   *
   * When value is a function:
   *
   * - When the function has a property `syntax`, it returns this
   *   syntax description.
   * - In other cases, a string `'function'` is returned.
   *
   * Examples:
   *
   *    math.format(6.4)                                        // returns '6.4'
   *    math.format(1240000)                                    // returns '1.24e6'
   *    math.format(1/3)                                        // returns '0.3333333333333333'
   *    math.format(1/3, 3)                                     // returns '0.333'
   *    math.format(21385, 2)                                   // returns '21000'
   *    math.format(12e8, {notation: 'fixed'})                  // returns '1200000000'
   *    math.format(2.3,  {notation: 'fixed', precision: 4})    // returns '2.3000'
   *    math.format(52.8, {notation: 'exponential'})            // returns '5.28e+1'
   *    math.format(12400,{notation: 'engineering'})            // returns '12.400e+3'
   *    math.format(2000, {lowerExp: -2, upperExp: 2})          // returns '2e+3'
   *
   *    function formatCurrency(value) {
   *      // return currency notation with two digits:
   *      return '$' + value.toFixed(2)
   *
   *      // you could also use math.format inside the callback:
   *      // return '$' + math.format(value, {notation: 'fixed', precision: 2})
   *    }
   *    math.format([2.1, 3, 0.016], formatCurrency)            // returns '[$2.10, $3.00, $0.02]'
   *
   * See also:
   *
   *    print
   *
   * @param {*} value                               Value to be stringified
   * @param {Object | Function | number} [options]  Formatting options
   * @return {string} The formatted value
   */ return typed($403585168a691256$var$name, {
        any: (0, $addf7cb66573d3e4$export$d9468344d3651243),
        "any, Object | function | number": (0, $addf7cb66573d3e4$export$d9468344d3651243)
    });
});



var $ee5e0aa1b0a5d1a9$var$name = "fraction";
var $ee5e0aa1b0a5d1a9$var$dependencies = [
    "typed",
    "Fraction"
];
var $ee5e0aa1b0a5d1a9$export$de147ca8498e0312 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($ee5e0aa1b0a5d1a9$var$name, $ee5e0aa1b0a5d1a9$var$dependencies, (_ref)=>{
    var { typed: typed, Fraction: Fraction } = _ref;
    /**
   * Create a fraction or convert a value to a fraction.
   *
   * With one numeric argument, produces the closest rational approximation to the
   * input.
   * With two arguments, the first is the numerator and the second is the denominator,
   * and creates the corresponding fraction. Both numerator and denominator must be
   * integers.
   * With one object argument, looks for the integer numerator as the value of property
   * 'n' and the integer denominator as the value of property 'd'.
   * With a matrix argument, creates a matrix of the same shape with entries
   * converted into fractions.
   *
   * Syntax:
   *     math.fraction(value)
   *     math.fraction(numerator, denominator)
   *     math.fraction({n: numerator, d: denominator})
   *     math.fraction(matrix: Array | Matrix)
   *
   * Examples:
   *
   *     math.fraction(6.283)             // returns Fraction 6283/1000
   *     math.fraction(1, 3)              // returns Fraction 1/3
   *     math.fraction('2/3')             // returns Fraction 2/3
   *     math.fraction({n: 2, d: 3})      // returns Fraction 2/3
   *     math.fraction([0.2, 0.25, 1.25]) // returns Array [1/5, 1/4, 5/4]
   *     math.fraction(4, 5.1)            // throws Error: Parameters must be integer
   *
   * See also:
   *
   *    bignumber, number, string, unit
   *
   * @param {number | string | Fraction | BigNumber | Array | Matrix} [args]
   *            Arguments specifying the value, or numerator and denominator of
   *            the fraction
   * @return {Fraction | Array | Matrix} Returns a fraction
   */ return typed("fraction", {
        number: function number(x) {
            if (!isFinite(x) || isNaN(x)) throw new Error(x + " cannot be represented as a fraction");
            return new Fraction(x);
        },
        string: function string(x) {
            return new Fraction(x);
        },
        "number, number": function numberNumber(numerator, denominator) {
            return new Fraction(numerator, denominator);
        },
        null: function _null(x) {
            return new Fraction(0);
        },
        BigNumber: function BigNumber(x) {
            return new Fraction(x.toString());
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Object: function Object(x) {
            return new Fraction(x);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});

var $b70f17e3a20fc795$exports = {};
/**
 * @license Fraction.js v4.3.7 31/08/2023
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2023, Robert Eisele (robert@raw.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ /**
 *
 * This class offers the possibility to calculate fractions.
 * You can pass a fraction in different formats. Either as array, as double, as string or as an integer.
 *
 * Array/Object form
 * [ 0 => <numerator>, 1 => <denominator> ]
 * [ n => <numerator>, d => <denominator> ]
 *
 * Integer form
 * - Single integer value
 *
 * Double form
 * - Single double value
 *
 * String form
 * 123.456 - a simple double
 * 123/456 - a string fraction
 * 123.'456' - a double with repeating decimal places
 * 123.(456) - synonym
 * 123.45'6' - a double with repeating last place
 * 123.45(6) - synonym
 *
 * Example:
 *
 * var f = new Fraction("9.4'31'");
 * f.mul([-4, 3]).div(4.9);
 *
 */ (function(root) {
    "use strict";
    // Maximum search depth for cyclic rational numbers. 2000 should be more than enough.
    // Example: 1/7 = 0.(142857) has 6 repeating decimal places.
    // If MAX_CYCLE_LEN gets reduced, long cycles will not be detected and toString() only gets the first 10 digits
    var MAX_CYCLE_LEN = 2000;
    // Parsed data to avoid calling "new" all the time
    var P = {
        "s": 1,
        "n": 0,
        "d": 1
    };
    function assign(n, s) {
        if (isNaN(n = parseInt(n, 10))) throw InvalidParameter();
        return n * s;
    }
    // Creates a new Fraction internally without the need of the bulky constructor
    function newFraction(n, d) {
        if (d === 0) throw DivisionByZero();
        var f = Object.create(Fraction.prototype);
        f["s"] = n < 0 ? -1 : 1;
        n = n < 0 ? -n : n;
        var a = gcd(n, d);
        f["n"] = n / a;
        f["d"] = d / a;
        return f;
    }
    function factorize(num) {
        var factors = {};
        var n = num;
        var i = 2;
        var s = 4;
        while(s <= n){
            while(n % i === 0){
                n /= i;
                factors[i] = (factors[i] || 0) + 1;
            }
            s += 1 + 2 * i++;
        }
        if (n !== num) {
            if (n > 1) factors[n] = (factors[n] || 0) + 1;
        } else factors[num] = (factors[num] || 0) + 1;
        return factors;
    }
    var parse = function(p1, p2) {
        var n = 0, d = 1, s = 1;
        var v = 0, w = 0, x = 0, y = 1, z = 1;
        var A = 0, B = 1;
        var C = 1, D = 1;
        var N = 10000000;
        var M;
        if (p1 === undefined || p1 === null) ;
        else if (p2 !== undefined) {
            n = p1;
            d = p2;
            s = n * d;
            if (n % 1 !== 0 || d % 1 !== 0) throw NonIntegerParameter();
        } else switch(typeof p1){
            case "object":
                if ("d" in p1 && "n" in p1) {
                    n = p1["n"];
                    d = p1["d"];
                    if ("s" in p1) n *= p1["s"];
                } else if (0 in p1) {
                    n = p1[0];
                    if (1 in p1) d = p1[1];
                } else throw InvalidParameter();
                s = n * d;
                break;
            case "number":
                if (p1 < 0) {
                    s = p1;
                    p1 = -p1;
                }
                if (p1 % 1 === 0) n = p1;
                else if (p1 > 0) {
                    if (p1 >= 1) {
                        z = Math.pow(10, Math.floor(1 + Math.log(p1) / Math.LN10));
                        p1 /= z;
                    }
                    // Using Farey Sequences
                    // http://www.johndcook.com/blog/2010/10/20/best-rational-approximation/
                    while(B <= N && D <= N){
                        M = (A + C) / (B + D);
                        if (p1 === M) {
                            if (B + D <= N) {
                                n = A + C;
                                d = B + D;
                            } else if (D > B) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                            break;
                        } else {
                            if (p1 > M) {
                                A += C;
                                B += D;
                            } else {
                                C += A;
                                D += B;
                            }
                            if (B > N) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                        }
                    }
                    n *= z;
                } else if (isNaN(p1) || isNaN(p2)) d = n = NaN;
                break;
            case "string":
                B = p1.match(/\d+|./g);
                if (B === null) throw InvalidParameter();
                if (B[A] === "-") {
                    s = -1;
                    A++;
                } else if (B[A] === "+") A++;
                if (B.length === A + 1) w = assign(B[A++], s);
                else if (B[A + 1] === "." || B[A] === ".") {
                    if (B[A] !== ".") v = assign(B[A++], s);
                    A++;
                    // Check for decimal places
                    if (A + 1 === B.length || B[A + 1] === "(" && B[A + 3] === ")" || B[A + 1] === "'" && B[A + 3] === "'") {
                        w = assign(B[A], s);
                        y = Math.pow(10, B[A].length);
                        A++;
                    }
                    // Check for repeating places
                    if (B[A] === "(" && B[A + 2] === ")" || B[A] === "'" && B[A + 2] === "'") {
                        x = assign(B[A + 1], s);
                        z = Math.pow(10, B[A + 1].length) - 1;
                        A += 3;
                    }
                } else if (B[A + 1] === "/" || B[A + 1] === ":") {
                    w = assign(B[A], s);
                    y = assign(B[A + 2], 1);
                    A += 3;
                } else if (B[A + 3] === "/" && B[A + 1] === " ") {
                    v = assign(B[A], s);
                    w = assign(B[A + 2], s);
                    y = assign(B[A + 4], 1);
                    A += 5;
                }
                if (B.length <= A) {
                    d = y * z;
                    s = /* void */ n = x + d * v + z * w;
                    break;
                }
            default:
                throw InvalidParameter();
        }
        if (d === 0) throw DivisionByZero();
        P["s"] = s < 0 ? -1 : 1;
        P["n"] = Math.abs(n);
        P["d"] = Math.abs(d);
    };
    function modpow(b, e, m) {
        var r = 1;
        for(; e > 0; b = b * b % m, e >>= 1)if (e & 1) r = r * b % m;
        return r;
    }
    function cycleLen(n, d) {
        for(; d % 2 === 0; d /= 2);
        for(; d % 5 === 0; d /= 5);
        if (d === 1) return 0;
        // If we would like to compute really large numbers quicker, we could make use of Fermat's little theorem:
        // 10^(d-1) % d == 1
        // However, we don't need such large numbers and MAX_CYCLE_LEN should be the capstone,
        // as we want to translate the numbers to strings.
        var rem = 10 % d;
        var t = 1;
        for(; rem !== 1; t++){
            rem = rem * 10 % d;
            if (t > MAX_CYCLE_LEN) return 0; // Returning 0 here means that we don't print it as a cyclic number. It's likely that the answer is `d-1`
        }
        return t;
    }
    function cycleStart(n, d, len) {
        var rem1 = 1;
        var rem2 = modpow(10, len, d);
        for(var t = 0; t < 300; t++){
            // Solve 10^s == 10^(s+t) (mod d)
            if (rem1 === rem2) return t;
            rem1 = rem1 * 10 % d;
            rem2 = rem2 * 10 % d;
        }
        return 0;
    }
    function gcd(a, b) {
        if (!a) return b;
        if (!b) return a;
        while(true){
            a %= b;
            if (!a) return b;
            b %= a;
            if (!b) return a;
        }
    }
    /**
   * Module constructor
   *
   * @constructor
   * @param {number|Fraction=} a
   * @param {number=} b
   */ function Fraction(a, b) {
        parse(a, b);
        if (this instanceof Fraction) {
            a = gcd(P["d"], P["n"]); // Abuse variable a
            this["s"] = P["s"];
            this["n"] = P["n"] / a;
            this["d"] = P["d"] / a;
        } else return newFraction(P["s"] * P["n"], P["d"]);
    }
    var DivisionByZero = function() {
        return new Error("Division by Zero");
    };
    var InvalidParameter = function() {
        return new Error("Invalid argument");
    };
    var NonIntegerParameter = function() {
        return new Error("Parameters must be integer");
    };
    Fraction.prototype = {
        "s": 1,
        "n": 0,
        "d": 1,
        /**
     * Calculates the absolute value
     *
     * Ex: new Fraction(-4).abs() => 4
     **/ "abs": function() {
            return newFraction(this["n"], this["d"]);
        },
        /**
     * Inverts the sign of the current fraction
     *
     * Ex: new Fraction(-4).neg() => 4
     **/ "neg": function() {
            return newFraction(-this["s"] * this["n"], this["d"]);
        },
        /**
     * Adds two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
     **/ "add": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] + P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Subtracts two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
     **/ "sub": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] - P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Multiplies two rational numbers
     *
     * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
     **/ "mul": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Divides two rational numbers
     *
     * Ex: new Fraction("-17.(345)").inverse().div(3)
     **/ "div": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["d"], this["d"] * P["n"]);
        },
        /**
     * Clones the actual object
     *
     * Ex: new Fraction("-17.(345)").clone()
     **/ "clone": function() {
            return newFraction(this["s"] * this["n"], this["d"]);
        },
        /**
     * Calculates the modulo of two rational numbers - a more precise fmod
     *
     * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
     **/ "mod": function(a, b) {
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            if (a === undefined) return newFraction(this["s"] * this["n"] % this["d"], 1);
            parse(a, b);
            if (0 === P["n"] && 0 === this["d"]) throw DivisionByZero();
            /*
       * First silly attempt, kinda slow
       *
       return that["sub"]({
       "n": num["n"] * Math.floor((this.n / this.d) / (num.n / num.d)),
       "d": num["d"],
       "s": this["s"]
       });*/ /*
       * New attempt: a1 / b1 = a2 / b2 * q + r
       * => b2 * a1 = a2 * b1 * q + b1 * b2 * r
       * => (b2 * a1 % a2 * b1) / (b1 * b2)
       */ return newFraction(this["s"] * (P["d"] * this["n"]) % (P["n"] * this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional gcd of two rational numbers
     *
     * Ex: new Fraction(5,8).gcd(3,7) => 1/56
     */ "gcd": function(a, b) {
            parse(a, b);
            // gcd(a / b, c / d) = gcd(a, c) / lcm(b, d)
            return newFraction(gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional lcm of two rational numbers
     *
     * Ex: new Fraction(5,8).lcm(3,7) => 15
     */ "lcm": function(a, b) {
            parse(a, b);
            // lcm(a / b, c / d) = lcm(a, c) / gcd(b, d)
            if (P["n"] === 0 && this["n"] === 0) return newFraction(0, 1);
            return newFraction(P["n"] * this["n"], gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]));
        },
        /**
     * Calculates the ceil of a rational number
     *
     * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
     **/ "ceil": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.ceil(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Calculates the floor of a rational number
     *
     * Ex: new Fraction('4.(3)').floor() => (4 / 1)
     **/ "floor": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.floor(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational numbers
     *
     * Ex: new Fraction('4.(3)').round() => (4 / 1)
     **/ "round": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.round(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational number to a multiple of another rational number
     *
     * Ex: new Fraction('0.9').roundTo("1/8") => 7 / 8
     **/ "roundTo": function(a, b) {
            /*
      k * x/y ≤ a/b < (k+1) * x/y
      ⇔ k ≤ a/b / (x/y) < (k+1)
      ⇔ k = floor(a/b * y/x)
      */ parse(a, b);
            return newFraction(this["s"] * Math.round(this["n"] * P["d"] / (this["d"] * P["n"])) * P["n"], P["d"]);
        },
        /**
     * Gets the inverse of the fraction, means numerator and denominator are exchanged
     *
     * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
     **/ "inverse": function() {
            return newFraction(this["s"] * this["d"], this["n"]);
        },
        /**
     * Calculates the fraction to some rational exponent, if possible
     *
     * Ex: new Fraction(-1,2).pow(-3) => -8
     */ "pow": function(a, b) {
            parse(a, b);
            // Trivial case when exp is an integer
            if (P["d"] === 1) {
                if (P["s"] < 0) return newFraction(Math.pow(this["s"] * this["d"], P["n"]), Math.pow(this["n"], P["n"]));
                else return newFraction(Math.pow(this["s"] * this["n"], P["n"]), Math.pow(this["d"], P["n"]));
            }
            // Negative roots become complex
            //     (-a/b)^(c/d) = x
            // <=> (-1)^(c/d) * (a/b)^(c/d) = x
            // <=> (cos(pi) + i*sin(pi))^(c/d) * (a/b)^(c/d) = x         # rotate 1 by 180°
            // <=> (cos(c*pi/d) + i*sin(c*pi/d)) * (a/b)^(c/d) = x       # DeMoivre's formula in Q ( https://proofwiki.org/wiki/De_Moivre%27s_Formula/Rational_Index )
            // From which follows that only for c=0 the root is non-complex. c/d is a reduced fraction, so that sin(c/dpi)=0 occurs for d=1, which is handled by our trivial case.
            if (this["s"] < 0) return null;
            // Now prime factor n and d
            var N = factorize(this["n"]);
            var D = factorize(this["d"]);
            // Exponentiate and take root for n and d individually
            var n = 1;
            var d = 1;
            for(var k in N){
                if (k === "1") continue;
                if (k === "0") {
                    n = 0;
                    break;
                }
                N[k] *= P["n"];
                if (N[k] % P["d"] === 0) N[k] /= P["d"];
                else return null;
                n *= Math.pow(k, N[k]);
            }
            for(var k in D){
                if (k === "1") continue;
                D[k] *= P["n"];
                if (D[k] % P["d"] === 0) D[k] /= P["d"];
                else return null;
                d *= Math.pow(k, D[k]);
            }
            if (P["s"] < 0) return newFraction(d, n);
            return newFraction(n, d);
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "equals": function(a, b) {
            parse(a, b);
            return this["s"] * this["n"] * P["d"] === P["s"] * P["n"] * this["d"]; // Same as compare() === 0
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "compare": function(a, b) {
            parse(a, b);
            var t = this["s"] * this["n"] * P["d"] - P["s"] * P["n"] * this["d"];
            return (0 < t) - (t < 0);
        },
        "simplify": function(eps) {
            if (isNaN(this["n"]) || isNaN(this["d"])) return this;
            eps = eps || 0.001;
            var thisABS = this["abs"]();
            var cont = thisABS["toContinued"]();
            for(var i = 1; i < cont.length; i++){
                var s = newFraction(cont[i - 1], 1);
                for(var k = i - 2; k >= 0; k--)s = s["inverse"]()["add"](cont[k]);
                if (Math.abs(s["sub"](thisABS).valueOf()) < eps) return s["mul"](this["s"]);
            }
            return this;
        },
        /**
     * Check if two rational numbers are divisible
     *
     * Ex: new Fraction(19.6).divisible(1.5);
     */ "divisible": function(a, b) {
            parse(a, b);
            return !(!(P["n"] * this["d"]) || this["n"] * P["d"] % (P["n"] * this["d"]));
        },
        /**
     * Returns a decimal representation of the fraction
     *
     * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
     **/ "valueOf": function() {
            return this["s"] * this["n"] / this["d"];
        },
        /**
     * Returns a string-fraction representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
     **/ "toFraction": function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += "-";
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    str += " ";
                    n %= d;
                }
                str += n;
                str += "/";
                str += d;
            }
            return str;
        },
        /**
     * Returns a latex representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
     **/ "toLatex": function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += "-";
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    n %= d;
                }
                str += "\\frac{";
                str += n;
                str += "}{";
                str += d;
                str += "}";
            }
            return str;
        },
        /**
     * Returns an array of continued fraction elements
     *
     * Ex: new Fraction("7/8").toContinued() => [0,1,7]
     */ "toContinued": function() {
            var t;
            var a = this["n"];
            var b = this["d"];
            var res = [];
            if (isNaN(a) || isNaN(b)) return res;
            do {
                res.push(Math.floor(a / b));
                t = a % b;
                a = b;
                b = t;
            }while (a !== 1);
            return res;
        },
        /**
     * Creates a string representation of a fraction with all digits
     *
     * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
     **/ "toString": function(dec) {
            var N = this["n"];
            var D = this["d"];
            if (isNaN(N) || isNaN(D)) return "NaN";
            dec = dec || 15; // 15 = decimal places when no repetation
            var cycLen = cycleLen(N, D); // Cycle length
            var cycOff = cycleStart(N, D, cycLen); // Cycle start
            var str = this["s"] < 0 ? "-" : "";
            str += N / D | 0;
            N %= D;
            N *= 10;
            if (N) str += ".";
            if (cycLen) {
                for(var i = cycOff; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += "(";
                for(var i = cycLen; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += ")";
            } else for(var i = dec; N && i--;){
                str += N / D | 0;
                N %= D;
                N *= 10;
            }
            return str;
        }
    };
    Object.defineProperty($b70f17e3a20fc795$exports, "__esModule", {
        "value": true
    });
    $b70f17e3a20fc795$exports["default"] = Fraction;
    $b70f17e3a20fc795$exports = Fraction;
})($b70f17e3a20fc795$exports);



var $8198075b72ba6116$var$name = "Fraction";
var $8198075b72ba6116$var$dependencies = [];
var $8198075b72ba6116$export$c317f082100fca89 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8198075b72ba6116$var$name, $8198075b72ba6116$var$dependencies, ()=>{
    /**
   * Attach type information
   */ (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports))).prototype.type = "Fraction";
    (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports))).prototype.isFraction = true;
    /**
   * Get a JSON representation of a Fraction containing type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Fraction", "n": 3, "d": 8}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports))).prototype.toJSON = function() {
        return {
            mathjs: "Fraction",
            n: this.s * this.n,
            d: this.d
        };
    };
    /**
   * Instantiate a Fraction from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "Fraction", "n": 3, "d": 8}`
   * @return {BigNumber}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports)))(json);
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports));
}, {
    isClass: true
});



/* eslint-disable no-loss-of-precision */ 

function $7e8e0d8af6caaacc$export$da03a9f23c941fae(n) {
    var x;
    if ((0, $a03283b133c3c55b$export$a287f47fed4544b8)(n)) {
        if (n <= 0) return isFinite(n) ? Infinity : NaN;
        if (n > 171) return Infinity; // Will overflow
        return (0, $38ff2345905e1d13$export$dbd0f18357df1ddd)(1, n - 1);
    }
    if (n < 0.5) return Math.PI / (Math.sin(Math.PI * n) * $7e8e0d8af6caaacc$export$da03a9f23c941fae(1 - n));
    if (n >= 171.35) return Infinity; // will overflow
    if (n > 85.0) {
        // Extended Stirling Approx
        var twoN = n * n;
        var threeN = twoN * n;
        var fourN = threeN * n;
        var fiveN = fourN * n;
        return Math.sqrt(2 * Math.PI / n) * Math.pow(n / Math.E, n) * (1 + 1 / (12 * n) + 1 / (288 * twoN) - 139 / (51840 * threeN) - 571 / (2488320 * fourN) + 163879 / (209018880 * fiveN) + 5246819 / (75246796800 * fiveN * n));
    }
    --n;
    x = $7e8e0d8af6caaacc$export$4ef5d09c80bf8d89[0];
    for(var i = 1; i < $7e8e0d8af6caaacc$export$4ef5d09c80bf8d89.length; ++i)x += $7e8e0d8af6caaacc$export$4ef5d09c80bf8d89[i] / (n + i);
    var t = n + $7e8e0d8af6caaacc$export$c1392abb9fefd3b6 + 0.5;
    return Math.sqrt(2 * Math.PI) * Math.pow(t, n + 0.5) * Math.exp(-t) * x;
}
$7e8e0d8af6caaacc$export$da03a9f23c941fae.signature = "number"; // TODO: comment on the variables g and p
var $7e8e0d8af6caaacc$export$c1392abb9fefd3b6 = 4.7421875;
var $7e8e0d8af6caaacc$export$4ef5d09c80bf8d89 = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.59796035547549,
    14.136097974741747174,
    -0.4919138160976202,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.00009837447530487956,
    0.15808870322491248884e-3,
    -0.00021026444172410488,
    0.21743961811521264320e-3,
    -0.0001643181065367639,
    0.84418223983852743293e-4,
    -0.000026190838401581408,
    0.36899182659531622704e-5
]; // lgamma implementation ref: https://mrob.com/pub/ries/lanczos-gamma.html#code
var $7e8e0d8af6caaacc$export$6854df5fcb691251 = 0.91893853320467274178;
var $7e8e0d8af6caaacc$export$ec32a260632ccc98 = 5; // Lanczos parameter "g"
var $7e8e0d8af6caaacc$export$e1cadc5b48a02cef = 7; // Range of coefficients "n"
var $7e8e0d8af6caaacc$export$591d8f773e88a995 = [
    1.000000000190015,
    76.18009172947146,
    -86.50532032941678,
    24.01409824083091,
    -1.231739572450155,
    0.1208650973866179e-2,
    -0.000005395239384953
];
function $7e8e0d8af6caaacc$export$a9c1cdc6d03f0efc(n) {
    if (n < 0) return NaN;
    if (n === 0) return Infinity;
    if (!isFinite(n)) return n;
    if (n < 0.5) // Use Euler's reflection formula:
    // gamma(z) = PI / (sin(PI * z) * gamma(1 - z))
    return Math.log(Math.PI / Math.sin(Math.PI * n)) - $7e8e0d8af6caaacc$export$a9c1cdc6d03f0efc(1 - n);
     // Compute the logarithm of the Gamma function using the Lanczos method
    n = n - 1;
    var base = n + $7e8e0d8af6caaacc$export$ec32a260632ccc98 + 0.5; // Base of the Lanczos exponential
    var sum = $7e8e0d8af6caaacc$export$591d8f773e88a995[0]; // We start with the terms that have the smallest coefficients and largest denominator
    for(var i = $7e8e0d8af6caaacc$export$e1cadc5b48a02cef - 1; i >= 1; i--)sum += $7e8e0d8af6caaacc$export$591d8f773e88a995[i] / (n + i);
    return $7e8e0d8af6caaacc$export$6854df5fcb691251 + (n + 0.5) * Math.log(base) - base + Math.log(sum);
}
$7e8e0d8af6caaacc$export$a9c1cdc6d03f0efc.signature = "number";


var $e2a6f07303f719c0$var$name = "gamma";
var $e2a6f07303f719c0$var$dependencies = [
    "typed",
    "config",
    "multiplyScalar",
    "pow",
    "BigNumber",
    "Complex"
];
var $e2a6f07303f719c0$export$115da31fc3cf3d15 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e2a6f07303f719c0$var$name, $e2a6f07303f719c0$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, pow: pow, BigNumber: _BigNumber, Complex: _Complex } = _ref;
    /**
   * Compute the gamma function of a value using Lanczos approximation for
   * small values, and an extended Stirling approximation for large values.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gamma(n)
   *
   * Examples:
   *
   *    math.gamma(5)       // returns 24
   *    math.gamma(-0.5)    // returns -3.5449077018110335
   *    math.gamma(math.i)  // returns -0.15494982830180973 - 0.49801566811835596i
   *
   * See also:
   *
   *    combinations, factorial, permutations
   *
   * @param {number | Array | Matrix} n   A real or complex number
   * @return {number | Array | Matrix}    The gamma of `n`
   */ return typed($e2a6f07303f719c0$var$name, {
        number: (0, $7e8e0d8af6caaacc$export$da03a9f23c941fae),
        Complex: function Complex(n) {
            if (n.im === 0) return this(n.re);
             // Lanczos approximation doesn't work well with real part lower than 0.5
            // So reflection formula is required
            if (n.re < 0.5) {
                // Euler's reflection formula
                // gamma(1-z) * gamma(z) = PI / sin(PI * z)
                // real part of Z should not be integer [sin(PI) == 0 -> 1/0 - undefined]
                // thanks to imperfect sin implementation sin(PI * n) != 0
                // we can safely use it anyway
                var _t = new _Complex(1 - n.re, -n.im);
                var r = new _Complex(Math.PI * n.re, Math.PI * n.im);
                return new _Complex(Math.PI).div(r.sin()).div(this(_t));
            } // Lanczos approximation
            // z -= 1
            n = new _Complex(n.re - 1, n.im); // x = gammaPval[0]
            var x = new _Complex((0, $7e8e0d8af6caaacc$export$4ef5d09c80bf8d89)[0], 0); // for (i, gammaPval) in enumerate(gammaP):
            for(var i = 1; i < (0, $7e8e0d8af6caaacc$export$4ef5d09c80bf8d89).length; ++i){
                // x += gammaPval / (z + i)
                var gammaPval = new _Complex((0, $7e8e0d8af6caaacc$export$4ef5d09c80bf8d89)[i], 0);
                x = x.add(gammaPval.div(n.add(i)));
            } // t = z + gammaG + 0.5
            var t = new _Complex(n.re + (0, $7e8e0d8af6caaacc$export$c1392abb9fefd3b6) + 0.5, n.im); // y = sqrt(2 * pi) * t ** (z + 0.5) * exp(-t) * x
            var twoPiSqrt = Math.sqrt(2 * Math.PI);
            var tpow = t.pow(n.add(0.5));
            var expt = t.neg().exp(); // y = [x] * [sqrt(2 * pi)] * [t ** (z + 0.5)] * [exp(-t)]
            return x.mul(twoPiSqrt).mul(tpow).mul(expt);
        },
        BigNumber: function BigNumber(n) {
            if (n.isInteger()) return n.isNegative() || n.isZero() ? new _BigNumber(Infinity) : bigFactorial(n.minus(1));
            if (!n.isFinite()) return new _BigNumber(n.isNegative() ? NaN : Infinity);
            throw new Error("Integer BigNumber expected");
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(n, this);
        }
    });
    /**
   * Calculate factorial for a BigNumber
   * @param {BigNumber} n
   * @returns {BigNumber} Returns the factorial of n
   */ function bigFactorial(n) {
        if (n < 8) return new _BigNumber([
            1,
            1,
            2,
            6,
            24,
            120,
            720,
            5040
        ][n]);
        var precision = config.precision + (Math.log(n.toNumber()) | 0);
        var Big = _BigNumber.clone({
            precision: precision
        });
        if (n % 2 === 1) return n.times(bigFactorial(new _BigNumber(n - 1)));
        var p = n;
        var prod = new Big(n);
        var sum = n.toNumber();
        while(p > 2){
            p -= 2;
            sum += p;
            prod = prod.times(sum);
        }
        return new _BigNumber(prod.toPrecision(_BigNumber.precision));
    }
});








var $823068d9c91a7a49$var$name = "gcd";
var $823068d9c91a7a49$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber",
    "DenseMatrix"
];
var $823068d9c91a7a49$export$2eb8acc96c598512 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($823068d9c91a7a49$var$name, $823068d9c91a7a49$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: BigNumber, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $3feaf9e0b000398a$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm04 = (0, $fd20a4b8c10d9754$export$898ea3bef50d41b7)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $e9da21a7968d7093$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculate the greatest common divisor for two or more values or arrays.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gcd(a, b)
   *    math.gcd(a, b, c, ...)
   *
   * Examples:
   *
   *    math.gcd(8, 12)              // returns 4
   *    math.gcd(-4, 6)              // returns 2
   *    math.gcd(25, 15, -10)        // returns 5
   *
   *    math.gcd([8, -4], [12, 6])   // returns [4, 2]
   *
   * See also:
   *
   *    lcm, xgcd
   *
   * @param {... number | BigNumber | Fraction | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Fraction | Array | Matrix}                           The greatest common divisor
   */ return typed($823068d9c91a7a49$var$name, {
        "number, number": (0, $08ae6b2eb4bd0049$export$3a8d786b08b3a70c),
        "BigNumber, BigNumber": _gcdBigNumber,
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.gcd(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm10(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            return algorithm10(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        // TODO: need a smarter notation here
        "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(a, b, args) {
            var res = this(a, b);
            for(var i = 0; i < args.length; i++)res = this(res, args[i]);
            return res;
        }
    });
    /**
   * Calculate gcd for BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns greatest common denominator of a and b
   * @private
   */ function _gcdBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function gcd must be integer numbers");
         // https://en.wikipedia.org/wiki/Euclidean_algorithm
        var zero = new BigNumber(0);
        while(!b.isZero()){
            var r = a.mod(b);
            a = b;
            b = r;
        }
        return a.lt(zero) ? a.neg() : a;
    }
});




var $a25390cd72c3de6b$var$name = "getMatrixDataType";
var $a25390cd72c3de6b$var$dependencies = [
    "typed"
];
var $a25390cd72c3de6b$export$b83055c9a38abe3c = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a25390cd72c3de6b$var$name, $a25390cd72c3de6b$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Find the data type of all elements in a matrix or array,
   * for example 'number' if all items are a number and 'Complex' if all values
   * are complex numbers.
   * If a matrix contains more than one data type, it will return 'mixed'.
   *
   * Syntax:
   *
   *    math.getMatrixDataType(x)
   *
   * Examples:
   *
   *    const x = [ [1, 2, 3], [4, 5, 6] ]
   *    const mixedX = [ [1, true], [2, 3] ]
   *    const fractionX = [ [math.fraction(1, 3)], [math.fraction(1, 3] ]
   *    const unitX = [ [math.unit('5cm')], [math.unit('5cm')] ]
   *    const bigNumberX = [ [math.bignumber(1)], [math.bignumber(0)] ]
   *    const sparse = math.sparse(x)
   *    const dense = math.matrix(x)
   *    math.getMatrixDataType(x)   // returns 'number'
   *    math.getMatrixDataType(sparse)   // returns 'number'
   *    math.getMatrixDataType(dense)   // returns 'number'
   *    math.getMatrixDataType(mixedX) // returns 'mixed'
   *    math.getMatrixDataType(fractionX) // returns 'Fraction'
   *    math.getMatrixDataType(unitX) // returns 'Unit'
   *    math.getMatrixDataType(bigNumberX) // return 'BigNumber'
   *
   * See also:
   *  SparseMatrix, DenseMatrix
   *
   * @param {...Matrix | Array} x   The Matrix with values.
   *
   * @return {string} A string representation of the matrix type
   */ return typed($a25390cd72c3de6b$var$name, {
        Array: function Array(x) {
            return (0, $802b18b8c920d4c6$export$d31e00bf4359ea8b)(x, (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f));
        },
        Matrix: function Matrix(x) {
            return x.getDataType();
        }
    });
});


var $20ef53407c994c0c$var$name = "hasNumericValue";
var $20ef53407c994c0c$var$dependencies = [
    "typed",
    "isNumeric"
];
var $20ef53407c994c0c$export$acff9f91b891ace6 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($20ef53407c994c0c$var$name, $20ef53407c994c0c$var$dependencies, (_ref)=>{
    var { typed: typed, isNumeric: isNumeric } = _ref;
    /**
   * Test whether a value is an numeric value.
   *
   * In case of a string, true is returned if the string contains a numeric value.
   *
   * Syntax:
   *
   *     math.hasNumericValue(x)
   *
   * Examples:
   *
   *    math.hasNumericValue(2)                     // returns true
   *    math.hasNumericValue('2')                   // returns true
   *    math.isNumeric('2')                         // returns false
   *    math.hasNumericValue(0)                     // returns true
   *    math.hasNumericValue(math.bignumber(500))   // returns true
   *    math.hasNumericValue(math.fraction(4))      // returns true
   *    math.hasNumericValue(math.complex('2-4i')   // returns false
   *    math.hasNumericValue([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, isNumeric
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, `Boolean`, or a `String` containing number. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($20ef53407c994c0c$var$name, {
        string: function string(x) {
            return x.trim().length > 0 && !isNaN(Number(x));
        },
        any: function any(x) {
            return isNumeric(x);
        }
    });
});


var $2d0ca931c325139b$var$name = "hex";
var $2d0ca931c325139b$var$dependencies = [
    "typed",
    "format"
];
var $2d0ca931c325139b$export$9cafd9970d25a17c = (0, $a671619231063c2b$export$e9008f2713103c6c)($2d0ca931c325139b$var$name, $2d0ca931c325139b$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($2d0ca931c325139b$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            return format(n, {
                notation: "hex"
            });
        },
        "number | BigNumber, number": function numberBigNumberNumber(n, wordSize) {
            return format(n, {
                notation: "hex",
                wordSize: wordSize
            });
        }
    });
});



var $fdb0409149ca1269$var$name = "hypot";
var $fdb0409149ca1269$var$dependencies = [
    "typed",
    "abs",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "sqrt",
    "smaller",
    "isPositive"
];
var $fdb0409149ca1269$export$87e3687740a09cb = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($fdb0409149ca1269$var$name, $fdb0409149ca1269$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, sqrt: sqrt, smaller: smaller, isPositive: isPositive } = _ref;
    /**
   * Calculate the hypotenusa of a list with values. The hypotenusa is defined as:
   *
   *     hypot(a, b, c, ...) = sqrt(a^2 + b^2 + c^2 + ...)
   *
   * For matrix input, the hypotenusa is calculated for all values in the matrix.
   *
   * Syntax:
   *
   *     math.hypot(a, b, ...)
   *     math.hypot([a, b, c, ...])
   *
   * Examples:
   *
   *     math.hypot(3, 4)      // 5
   *     math.hypot(3, 4, 5)   // 7.0710678118654755
   *     math.hypot([3, 4, 5]) // 7.0710678118654755
   *     math.hypot(-2)        // 2
   *
   * See also:
   *
   *     abs, norm
   *
   * @param {... number | BigNumber | Array | Matrix} args    A list with numeric values or an Array or Matrix.
   *                                                          Matrix and Array input is flattened and returns a
   *                                                          single number for the whole matrix.
   * @return {number | BigNumber} Returns the hypothenusa of the input values.
   */ return typed($fdb0409149ca1269$var$name, {
        "... number | BigNumber": _hypot,
        Array: function Array(x) {
            return this.apply(this, (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(x));
        },
        Matrix: function Matrix(x) {
            return this.apply(this, (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(x.toArray()));
        }
    });
    /**
   * Calculate the hypotenusa for an Array with values
   * @param {Array.<number | BigNumber>} args
   * @return {number | BigNumber} Returns the result
   * @private
   */ function _hypot(args) {
        // code based on `hypot` from es6-shim:
        // https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L1619-L1633
        var result = 0;
        var largest = 0;
        for(var i = 0; i < args.length; i++){
            var value = abs(args[i]);
            if (smaller(largest, value)) {
                result = multiplyScalar(result, multiplyScalar(divideScalar(largest, value), divideScalar(largest, value)));
                result = addScalar(result, 1);
                largest = value;
            } else result = addScalar(result, isPositive(value) ? multiplyScalar(divideScalar(value, largest), divideScalar(value, largest)) : value);
        }
        return multiplyScalar(largest, sqrt(result));
    }
});





var $852c3f8bd303942b$var$name = "identity";
var $852c3f8bd303942b$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber",
    "DenseMatrix",
    "SparseMatrix"
];
var $852c3f8bd303942b$export$2eca89e9ac669625 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($852c3f8bd303942b$var$name, $852c3f8bd303942b$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a 2-dimensional identity matrix with size m x n or n x n.
   * The matrix has ones on the diagonal and zeros elsewhere.
   *
   * Syntax:
   *
   *    math.identity(n)
   *    math.identity(n, format)
   *    math.identity(m, n)
   *    math.identity(m, n, format)
   *    math.identity([m, n])
   *    math.identity([m, n], format)
   *
   * Examples:
   *
   *    math.identity(3)                    // returns [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
   *    math.identity(3, 2)                 // returns [[1, 0], [0, 1], [0, 0]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.identity(math.size(A))         // returns [[1, 0, 0], [0, 1, 0]]
   *
   * See also:
   *
   *    diag, ones, zeros, size, range
   *
   * @param {...number | Matrix | Array} size   The size for the matrix
   * @param {string} [format]                   The Matrix storage format
   *
   * @return {Matrix | Array | number} A matrix with ones on the diagonal.
   */ return typed($852c3f8bd303942b$var$name, {
        "": function _() {
            return config.matrix === "Matrix" ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        "number | BigNumber": function numberBigNumber(rows) {
            return _identity(rows, rows, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber, string": function numberBigNumberString(rows, format) {
            return _identity(rows, rows, format);
        },
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(rows, cols) {
            return _identity(rows, cols, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber, number | BigNumber, string": function numberBigNumberNumberBigNumberString(rows, cols, format) {
            return _identity(rows, cols, format);
        },
        Array: function Array(size) {
            return _identityVector(size);
        },
        "Array, string": function ArrayString(size, format) {
            return _identityVector(size, format);
        },
        Matrix: function Matrix(size) {
            return _identityVector(size.valueOf(), size.storage());
        },
        "Matrix, string": function MatrixString(size, format) {
            return _identityVector(size.valueOf(), format);
        }
    });
    function _identityVector(size, format) {
        switch(size.length){
            case 0:
                return format ? matrix(format) : [];
            case 1:
                return _identity(size[0], size[0], format);
            case 2:
                return _identity(size[0], size[1], format);
            default:
                throw new Error("Vector containing two values expected");
        }
    }
    /**
   * Create an identity matrix
   * @param {number | BigNumber} rows
   * @param {number | BigNumber} cols
   * @param {string} [format]
   * @returns {Matrix}
   * @private
   */ function _identity(rows, cols, format) {
        // BigNumber constructor with the right precision
        var Big = (0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(rows) || (0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(cols) ? BigNumber : null;
        if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(rows)) rows = rows.toNumber();
        if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(cols)) cols = cols.toNumber();
        if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(rows) || rows < 1) throw new Error("Parameters in function identity must be positive integers");
        if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(cols) || cols < 1) throw new Error("Parameters in function identity must be positive integers");
        var one = Big ? new BigNumber(1) : 1;
        var defaultValue = Big ? new Big(0) : 0;
        var size = [
            rows,
            cols
        ]; // check we need to return a matrix
        if (format) {
            // create diagonal matrix (use optimized implementation for storage format)
            if (format === "sparse") return SparseMatrix.diagonal(size, one, 0, defaultValue);
            if (format === "dense") return DenseMatrix.diagonal(size, one, 0, defaultValue);
            throw new TypeError('Unknown matrix type "'.concat(format, '"'));
        } // create and resize array
        var res = (0, $802b18b8c920d4c6$export$4380c87abf28fdf)([], size, defaultValue); // fill in ones on the diagonal
        var minimum = rows < cols ? rows : cols; // fill diagonal
        for(var d = 0; d < minimum; d++)res[d][d] = one;
        return res;
    }
});




var $fd735f13075fb9a0$var$name = "ifft";
var $fd735f13075fb9a0$var$dependencies = [
    "typed",
    "fft",
    "dotDivide",
    "conj"
];
var $fd735f13075fb9a0$export$fb893320704d694a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($fd735f13075fb9a0$var$name, $fd735f13075fb9a0$var$dependencies, (_ref)=>{
    var { typed: typed, fft: fft, dotDivide: dotDivide, conj: conj } = _ref;
    /**
   * Calculate N-dimensional inverse fourier transform
   *
   * Syntax:
   *
   *     math.ifft(arr)
   *
   * Examples:
   *
   *    math.ifft([[2, 2], [0, 0]]) // returns [[{re:1, im:0}, {re:0, im:0}], [{re:1, im:0}, {re:0, im:0}]]
   *
   * See Also:
   *
   *      fft
   *
   * @param {Array | Matrix} arr    An array or matrix
   * @return {Array | Matrix}       N-dimensional fourier transformation of the array
   */ return typed($fd735f13075fb9a0$var$name, {
        "Array | Matrix": function ArrayMatrix(arr) {
            var size = (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(arr) ? arr.size() : (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(arr);
            return dotDivide(conj(fft(conj(arr))), size.reduce((acc, curr)=>acc * curr, 1));
        }
    });
});



var $48d7b93a2bd1bc9f$var$name = "im";
var $48d7b93a2bd1bc9f$var$dependencies = [
    "typed"
];
var $48d7b93a2bd1bc9f$export$47dfdf308b91581 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($48d7b93a2bd1bc9f$var$name, $48d7b93a2bd1bc9f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Get the imaginary part of a complex number.
   * For a complex number `a + bi`, the function returns `b`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.im(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number -5.2
   *    math.re(math.complex(2.4))     // returns number 0
   *
   * See also:
   *
   *    re, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The imaginary part of x
   */ return typed($48d7b93a2bd1bc9f$var$name, {
        number: function number(x) {
            return 0;
        },
        BigNumber: function BigNumber(x) {
            return x.mul(0);
        },
        Fraction: function Fraction(x) {
            return x.mul(0);
        },
        Complex: function Complex(x) {
            return x.im;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $049153ac255ea4af$var$name = "ImmutableDenseMatrix";
var $049153ac255ea4af$var$dependencies = [
    "smaller",
    "DenseMatrix"
];
var $049153ac255ea4af$export$49a565643b9ab608 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($049153ac255ea4af$var$name, $049153ac255ea4af$var$dependencies, (_ref)=>{
    var { smaller: smaller, DenseMatrix: DenseMatrix } = _ref;
    function ImmutableDenseMatrix(data, datatype) {
        if (!(this instanceof ImmutableDenseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $2c4f948f17aa2240$export$844ec244b1367d54)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(data) || (0, $2c4f948f17aa2240$export$43bee75e5e14138e)(data)) {
            // use DenseMatrix implementation
            var matrix = new DenseMatrix(data, datatype); // internal structures
            this._data = matrix._data;
            this._size = matrix._size;
            this._datatype = matrix._datatype;
            this._min = null;
            this._max = null;
        } else if (data && (0, $2c4f948f17aa2240$export$43bee75e5e14138e)(data.data) && (0, $2c4f948f17aa2240$export$43bee75e5e14138e)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size;
            this._datatype = data.datatype;
            this._min = typeof data.min !== "undefined" ? data.min : null;
            this._max = typeof data.max !== "undefined" ? data.max : null;
        } else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(data) + ")");
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
            this._min = null;
            this._max = null;
        }
    }
    ImmutableDenseMatrix.prototype = new DenseMatrix();
    /**
   * Attach type information
   */ ImmutableDenseMatrix.prototype.type = "ImmutableDenseMatrix";
    ImmutableDenseMatrix.prototype.isImmutableDenseMatrix = true;
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | ImmutableDenseMatrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ ImmutableDenseMatrix.prototype.subset = function(index) {
        switch(arguments.length){
            case 1:
                // use base implementation
                var m = DenseMatrix.prototype.subset.call(this, index); // check result is a matrix
                if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(m)) // return immutable matrix
                return new ImmutableDenseMatrix({
                    data: m._data,
                    size: m._size,
                    datatype: m._datatype
                });
                return m;
            // intentional fall through
            case 2:
            case 3:
                throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    /**
   * Replace a single element in the matrix.
   * @param {Number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {ImmutableDenseMatrix} self
   */ ImmutableDenseMatrix.prototype.set = function() {
        throw new Error("Cannot invoke set on an Immutable Matrix instance");
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {Number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ ImmutableDenseMatrix.prototype.resize = function() {
        throw new Error("Cannot invoke resize on an Immutable Matrix instance");
    };
    /**
   * Disallows reshaping in favor of immutability.
   *
   * @throws {Error} Operation not allowed
   */ ImmutableDenseMatrix.prototype.reshape = function() {
        throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
    };
    /**
   * Create a clone of the matrix
   * @return {ImmutableDenseMatrix} clone
   */ ImmutableDenseMatrix.prototype.clone = function() {
        return new ImmutableDenseMatrix({
            data: (0, $33619877a15996ac$export$9cd59f9826255e47)(this._data),
            size: (0, $33619877a15996ac$export$9cd59f9826255e47)(this._size),
            datatype: this._datatype
        });
    };
    /**
   * Get a JSON representation of the matrix
   * @returns {Object}
   */ ImmutableDenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "ImmutableDenseMatrix",
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Generate a matrix from a JSON object
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ImmutableDenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {ImmutableDenseMatrix}
   */ ImmutableDenseMatrix.fromJSON = function(json) {
        return new ImmutableDenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @param {Number} i       Matrix row index 1
   * @param {Number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ ImmutableDenseMatrix.prototype.swapRows = function() {
        throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
    };
    /**
   * Calculate the minimum value in the set
   * @return {Number | undefined} min
   */ ImmutableDenseMatrix.prototype.min = function() {
        // check min has been calculated before
        if (this._min === null) {
            // minimum
            var m = null; // compute min
            this.forEach(function(v) {
                if (m === null || smaller(v, m)) m = v;
            });
            this._min = m !== null ? m : undefined;
        }
        return this._min;
    };
    /**
   * Calculate the maximum value in the set
   * @return {Number | undefined} max
   */ ImmutableDenseMatrix.prototype.max = function() {
        // check max has been calculated before
        if (this._max === null) {
            // maximum
            var m = null; // compute max
            this.forEach(function(v) {
                if (m === null || smaller(m, v)) m = v;
            });
            this._max = m !== null ? m : undefined;
        }
        return this._max;
    };
    return ImmutableDenseMatrix;
}, {
    isClass: true
});



var $f80e0fb9f9e3e794$var$name = "index";
var $f80e0fb9f9e3e794$var$dependencies = [
    "typed",
    "Index"
];
var $f80e0fb9f9e3e794$export$c6d108d7c8095f19 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($f80e0fb9f9e3e794$var$name, $f80e0fb9f9e3e794$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index } = _ref;
    /**
   * Create an index. An Index can store ranges having start, step, and end
   * for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Syntax:
   *
   *     math.index(range1, range2, ...)
   *
   * Where each range can be any of:
   *
   * - A number
   * - A string for getting/setting an object property
   * - An instance of `Range`
   * - A one-dimensional Array or a Matrix with numbers
   *
   * Indexes must be zero-based, integer numbers.
   *
   * Examples:
   *
   *    const b = [1, 2, 3, 4, 5]
   *    math.subset(b, math.index([1, 2, 3]))     // returns [2, 3, 4]
   *
   *    const a = math.matrix([[1, 2], [3, 4]])
   *    a.subset(math.index(0, 1))             // returns 2
   *
   * See also:
   *
   *    bignumber, boolean, complex, matrix, number, string, unit
   *
   * @param {...*} ranges   Zero or more ranges or numbers.
   * @return {Index}        Returns the created index
   */ return typed($f80e0fb9f9e3e794$var$name, {
        "...number | string | BigNumber | Range | Array | Matrix": function numberStringBigNumberRangeArrayMatrix(args) {
            var ranges = args.map(function(arg) {
                if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(arg)) return arg.toNumber(); // convert BigNumber to Number
                else if (Array.isArray(arg) || (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(arg)) return arg.map(function(elem) {
                    // convert BigNumber to Number
                    return (0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(elem) ? elem.toNumber() : elem;
                });
                else return arg;
            });
            var res = new Index();
            Index.apply(res, ranges);
            return res;
        }
    });
});





var $cf7fbbe5a9154dba$var$name = "Index";
var $cf7fbbe5a9154dba$var$dependencies = [
    "ImmutableDenseMatrix"
];
var $cf7fbbe5a9154dba$export$300720b4fe34e62e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($cf7fbbe5a9154dba$var$name, $cf7fbbe5a9154dba$var$dependencies, (_ref)=>{
    var { ImmutableDenseMatrix: ImmutableDenseMatrix } = _ref;
    /**
   * Create an index. An Index can store ranges and sets for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Usage:
   *     const index = new Index(range1, range2, matrix1, array1, ...)
   *
   * Where each parameter can be any of:
   *     A number
   *     A string (containing a name of an object property)
   *     An instance of Range
   *     An Array with the Set values
   *     A Matrix with the Set values
   *
   * The parameters start, end, and step must be integer numbers.
   *
   * @class Index
   * @Constructor Index
   * @param {...*} ranges
   */ function Index(ranges) {
        if (!(this instanceof Index)) throw new SyntaxError("Constructor must be called with the new operator");
        this._dimensions = [];
        this._isScalar = true;
        for(var i = 0, ii = arguments.length; i < ii; i++){
            var arg = arguments[i];
            if ((0, $2c4f948f17aa2240$export$e331ccfa6f694c99)(arg)) {
                this._dimensions.push(arg);
                this._isScalar = false;
            } else if (Array.isArray(arg) || (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(arg)) {
                // create matrix
                var m = _createImmutableMatrix(arg.valueOf());
                this._dimensions.push(m); // size
                var size = m.size(); // scalar
                if (size.length !== 1 || size[0] !== 1) this._isScalar = false;
            } else if (typeof arg === "number") this._dimensions.push(_createImmutableMatrix([
                arg
            ]));
            else if (typeof arg === "string") // object property (arguments.count should be 1)
            this._dimensions.push(arg);
            else throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
             // TODO: implement support for wildcard '*'
        }
    }
    /**
   * Attach type information
   */ Index.prototype.type = "Index";
    Index.prototype.isIndex = true;
    function _createImmutableMatrix(arg) {
        // loop array elements
        for(var i = 0, l = arg.length; i < l; i++){
            if (typeof arg[i] !== "number" || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(arg[i])) throw new TypeError("Index parameters must be positive integer numbers");
        } // create matrix
        return new ImmutableDenseMatrix(arg);
    }
    /**
   * Create a clone of the index
   * @memberof Index
   * @return {Index} clone
   */ Index.prototype.clone = function() {
        var index = new Index();
        index._dimensions = (0, $33619877a15996ac$export$9cd59f9826255e47)(this._dimensions);
        index._isScalar = this._isScalar;
        return index;
    };
    /**
   * Create an index from an array with ranges/numbers
   * @memberof Index
   * @param {Array.<Array | number>} ranges
   * @return {Index} index
   * @private
   */ Index.create = function(ranges) {
        var index = new Index();
        Index.apply(index, ranges);
        return index;
    };
    /**
   * Retrieve the size of the index, the number of elements for each dimension.
   * @memberof Index
   * @returns {number[]} size
   */ Index.prototype.size = function() {
        var size = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var d = this._dimensions[i];
            size[i] = typeof d === "string" ? 1 : d.size()[0];
        }
        return size;
    };
    /**
   * Get the maximum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} max
   */ Index.prototype.max = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === "string" ? range : range.max();
        }
        return values;
    };
    /**
   * Get the minimum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} min
   */ Index.prototype.min = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === "string" ? range : range.min();
        }
        return values;
    };
    /**
   * Loop over each of the ranges of the index
   * @memberof Index
   * @param {Function} callback   Called for each range with a Range as first
   *                              argument, the dimension as second, and the
   *                              index object as third.
   */ Index.prototype.forEach = function(callback) {
        for(var i = 0, ii = this._dimensions.length; i < ii; i++)callback(this._dimensions[i], i, this);
    };
    /**
   * Retrieve the dimension for the given index
   * @memberof Index
   * @param {Number} dim                  Number of the dimension
   * @returns {Range | null} range
   */ Index.prototype.dimension = function(dim) {
        return this._dimensions[dim] || null;
    };
    /**
   * Test whether this index contains an object property
   * @returns {boolean} Returns true if the index is an object property
   */ Index.prototype.isObjectProperty = function() {
        return this._dimensions.length === 1 && typeof this._dimensions[0] === "string";
    };
    /**
   * Returns the object property name when the Index holds a single object property,
   * else returns null
   * @returns {string | null}
   */ Index.prototype.getObjectProperty = function() {
        return this.isObjectProperty() ? this._dimensions[0] : null;
    };
    /**
   * Test whether this index contains only a single value.
   *
   * This is the case when the index is created with only scalar values as ranges,
   * not for ranges resolving into a single value.
   * @memberof Index
   * @return {boolean} isScalar
   */ Index.prototype.isScalar = function() {
        return this._isScalar;
    };
    /**
   * Expand the Index into an array.
   * For example new Index([0,3], [2,7]) returns [[0,1,2], [2,3,4,5,6]]
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.toArray = function() {
        var array = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            array.push(typeof dimension === "string" ? dimension : dimension.toArray());
        }
        return array;
    };
    /**
   * Get the primitive value of the Index, a two dimensional array.
   * Equivalent to Index.toArray().
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.valueOf = Index.prototype.toArray;
    /**
   * Get the string representation of the index, for example '[2:6]' or '[0:2:10, 4:7, [1,2,3]]'
   * @memberof Index
   * @returns {String} str
   */ Index.prototype.toString = function() {
        var strings = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            if (typeof dimension === "string") strings.push(JSON.stringify(dimension));
            else strings.push(dimension.toString());
        }
        return "[" + strings.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the Index
   * @memberof Index
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Index", "ranges": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   */ Index.prototype.toJSON = function() {
        return {
            mathjs: "Index",
            dimensions: this._dimensions
        };
    };
    /**
   * Instantiate an Index from a JSON object
   * @memberof Index
   * @param {Object} json A JSON object structured as:
   *                     `{"mathjs": "Index", "dimensions": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   * @return {Index}
   */ Index.fromJSON = function(json) {
        return Index.create(json.dimensions);
    };
    return Index;
}, {
    isClass: true
});


var $d4d9c54a71d248b2$var$name = "intersect";
var $d4d9c54a71d248b2$var$dependencies = [
    "typed",
    "config",
    "abs",
    "add",
    "addScalar",
    "matrix",
    "multiply",
    "multiplyScalar",
    "divideScalar",
    "subtract",
    "smaller",
    "equalScalar",
    "flatten",
    "isZero",
    "isNumeric"
];
var $d4d9c54a71d248b2$export$e2d92d8f89fdd92d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d4d9c54a71d248b2$var$name, $d4d9c54a71d248b2$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, abs: abs, add: add, addScalar: addScalar, matrix: matrix, multiply: multiply, multiplyScalar: multiplyScalar, divideScalar: divideScalar, subtract: subtract, smaller: smaller, equalScalar: equalScalar, flatten: flatten, isZero: isZero, isNumeric: isNumeric } = _ref;
    /**
   * Calculates the point of intersection of two lines in two or three dimensions
   * and of a line and a plane in three dimensions. The inputs are in the form of
   * arrays or 1 dimensional matrices. The line intersection functions return null
   * if the lines do not meet.
   *
   * Note: Fill the plane coefficients as `x + y + z = c` and not as `x + y + z + c = 0`.
   *
   * Syntax:
   *
   *    math.intersect(endPoint1Line1, endPoint2Line1, endPoint1Line2, endPoint2Line2)
   *    math.intersect(endPoint1, endPoint2, planeCoefficients)
   *
   * Examples:
   *
   *    math.intersect([0, 0], [10, 10], [10, 0], [0, 10])              // Returns [5, 5]
   *    math.intersect([0, 0, 0], [10, 10, 0], [10, 0, 0], [0, 10, 0])  // Returns [5, 5, 0]
   *    math.intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])            // Returns [7, -4, 3]
   *
   * @param  {Array | Matrix} w   Co-ordinates of first end-point of first line
   * @param  {Array | Matrix} x   Co-ordinates of second end-point of first line
   * @param  {Array | Matrix} y   Co-ordinates of first end-point of second line
   *                              OR Co-efficients of the plane's equation
   * @param  {Array | Matrix} z   Co-ordinates of second end-point of second line
   *                              OR undefined if the calculation is for line and plane
   * @return {Array}              Returns the point of intersection of lines/lines-planes
   */ return typed("intersect", {
        "Array, Array, Array": _AAA,
        "Array, Array, Array, Array": _AAAA,
        "Matrix, Matrix, Matrix": function MatrixMatrixMatrix(x, y, plane) {
            var arr = _AAA(x.valueOf(), y.valueOf(), plane.valueOf());
            return arr === null ? null : matrix(arr);
        },
        "Matrix, Matrix, Matrix, Matrix": function MatrixMatrixMatrixMatrix(w, x, y, z) {
            // TODO: output matrix type should match input matrix type
            var arr = _AAAA(w.valueOf(), x.valueOf(), y.valueOf(), z.valueOf());
            return arr === null ? null : matrix(arr);
        }
    });
    function _AAA(x, y, plane) {
        x = _coerceArr(x);
        y = _coerceArr(y);
        plane = _coerceArr(plane);
        if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
        if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
        if (!_4d(plane)) throw new TypeError("Array with 4 numbers expected as third argument");
        return _intersectLinePlane(x[0], x[1], x[2], y[0], y[1], y[2], plane[0], plane[1], plane[2], plane[3]);
    }
    function _AAAA(w, x, y, z) {
        w = _coerceArr(w);
        x = _coerceArr(x);
        y = _coerceArr(y);
        z = _coerceArr(z);
        if (w.length === 2) {
            if (!_2d(w)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
            if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
            if (!_2d(y)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
            if (!_2d(z)) throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
            return _intersect2d(w, x, y, z);
        } else if (w.length === 3) {
            if (!_3d(w)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
            if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
            if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
            if (!_3d(z)) throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
            return _intersect3d(w[0], w[1], w[2], x[0], x[1], x[2], y[0], y[1], y[2], z[0], z[1], z[2]);
        } else throw new TypeError("Arrays with two or thee dimensional points expected");
    }
    /** Coerce row and column 2-dim arrays to 1-dim array */ function _coerceArr(arr) {
        // row matrix
        if (arr.length === 1) return arr[0]; // column matrix
        if (arr.length > 1 && Array.isArray(arr[0])) {
            if (arr.every((el)=>Array.isArray(el) && el.length === 1)) return flatten(arr);
        }
        return arr;
    }
    function _2d(x) {
        return x.length === 2 && isNumeric(x[0]) && isNumeric(x[1]);
    }
    function _3d(x) {
        return x.length === 3 && isNumeric(x[0]) && isNumeric(x[1]) && isNumeric(x[2]);
    }
    function _4d(x) {
        return x.length === 4 && isNumeric(x[0]) && isNumeric(x[1]) && isNumeric(x[2]) && isNumeric(x[3]);
    }
    function _intersect2d(p1a, p1b, p2a, p2b) {
        var o1 = p1a;
        var o2 = p2a;
        var d1 = subtract(o1, p1b);
        var d2 = subtract(o2, p2b);
        var det = subtract(multiplyScalar(d1[0], d2[1]), multiplyScalar(d2[0], d1[1]));
        if (isZero(det)) return null;
        if (smaller(abs(det), config.epsilon)) return null;
        var d20o11 = multiplyScalar(d2[0], o1[1]);
        var d21o10 = multiplyScalar(d2[1], o1[0]);
        var d20o21 = multiplyScalar(d2[0], o2[1]);
        var d21o20 = multiplyScalar(d2[1], o2[0]);
        var t = divideScalar(addScalar(subtract(subtract(d20o11, d21o10), d20o21), d21o20), det);
        return add(multiply(d1, t), o1);
    }
    function _intersect3dHelper(a, b, c, d, e, f, g, h, i, j, k, l) {
        // (a - b)*(c - d) + (e - f)*(g - h) + (i - j)*(k - l)
        var add1 = multiplyScalar(subtract(a, b), subtract(c, d));
        var add2 = multiplyScalar(subtract(e, f), subtract(g, h));
        var add3 = multiplyScalar(subtract(i, j), subtract(k, l));
        return addScalar(addScalar(add1, add2), add3);
    }
    function _intersect3d(x1, y1, z1, x2, y2, z2, x3, y3, z3, x4, y4, z4) {
        var d1343 = _intersect3dHelper(x1, x3, x4, x3, y1, y3, y4, y3, z1, z3, z4, z3);
        var d4321 = _intersect3dHelper(x4, x3, x2, x1, y4, y3, y2, y1, z4, z3, z2, z1);
        var d1321 = _intersect3dHelper(x1, x3, x2, x1, y1, y3, y2, y1, z1, z3, z2, z1);
        var d4343 = _intersect3dHelper(x4, x3, x4, x3, y4, y3, y4, y3, z4, z3, z4, z3);
        var d2121 = _intersect3dHelper(x2, x1, x2, x1, y2, y1, y2, y1, z2, z1, z2, z1);
        var numerator = subtract(multiplyScalar(d1343, d4321), multiplyScalar(d1321, d4343));
        var denominator = subtract(multiplyScalar(d2121, d4343), multiplyScalar(d4321, d4321));
        if (isZero(denominator)) return null;
        var ta = divideScalar(numerator, denominator);
        var tb = divideScalar(addScalar(d1343, multiplyScalar(ta, d4321)), d4343);
        var pax = addScalar(x1, multiplyScalar(ta, subtract(x2, x1)));
        var pay = addScalar(y1, multiplyScalar(ta, subtract(y2, y1)));
        var paz = addScalar(z1, multiplyScalar(ta, subtract(z2, z1)));
        var pbx = addScalar(x3, multiplyScalar(tb, subtract(x4, x3)));
        var pby = addScalar(y3, multiplyScalar(tb, subtract(y4, y3)));
        var pbz = addScalar(z3, multiplyScalar(tb, subtract(z4, z3)));
        if (equalScalar(pax, pbx) && equalScalar(pay, pby) && equalScalar(paz, pbz)) return [
            pax,
            pay,
            paz
        ];
        else return null;
    }
    function _intersectLinePlane(x1, y1, z1, x2, y2, z2, x, y, z, c) {
        var x1x = multiplyScalar(x1, x);
        var x2x = multiplyScalar(x2, x);
        var y1y = multiplyScalar(y1, y);
        var y2y = multiplyScalar(y2, y);
        var z1z = multiplyScalar(z1, z);
        var z2z = multiplyScalar(z2, z);
        var numerator = subtract(subtract(subtract(c, x1x), y1y), z1z);
        var denominator = subtract(subtract(subtract(addScalar(addScalar(x2x, y2y), z2z), x1x), y1y), z1z);
        var t = divideScalar(numerator, denominator);
        var px = addScalar(x1, multiplyScalar(t, subtract(x2, x1)));
        var py = addScalar(y1, multiplyScalar(t, subtract(y2, y1)));
        var pz = addScalar(z1, multiplyScalar(t, subtract(z2, z1)));
        return [
            px,
            py,
            pz
        ]; // TODO: Add cases when line is parallel to the plane:
    //       (a) no intersection,
    //       (b) line contained in plane
    }
});





var $1609836b2ebed995$var$name = "inv";
var $1609836b2ebed995$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "addScalar",
    "multiply",
    "unaryMinus",
    "det",
    "identity",
    "abs"
];
var $1609836b2ebed995$export$ad9771ef9eafe06a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1609836b2ebed995$var$name, $1609836b2ebed995$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, addScalar: addScalar, multiply: multiply, unaryMinus: unaryMinus, det: det, identity: identity, abs: abs } = _ref;
    /**
   * Calculate the inverse of a square matrix.
   *
   * Syntax:
   *
   *     math.inv(x)
   *
   * Examples:
   *
   *     math.inv([[1, 2], [3, 4]])  // returns [[-2, 1], [1.5, -0.5]]
   *     math.inv(4)                 // returns 0.25
   *     1 / 4                       // returns 0.25
   *
   * See also:
   *
   *     det, transpose
   *
   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
   * @return {number | Complex | Array | Matrix} The inverse of `x`.
   */ return typed($1609836b2ebed995$var$name, {
        "Array | Matrix": function ArrayMatrix(x) {
            var size = (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(x) ? x.size() : (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x);
            switch(size.length){
                case 1:
                    // vector
                    if (size[0] === 1) {
                        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(x)) return matrix([
                            divideScalar(1, x.valueOf()[0])
                        ]);
                        else return [
                            divideScalar(1, x[0])
                        ];
                    } else throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
                case 2:
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) {
                        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(x)) return matrix(_inv(x.valueOf(), rows, cols), x.storage());
                        else // return an Array
                        return _inv(x, rows, cols);
                    } else throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
            }
        },
        any: function any(x) {
            // scalar
            return divideScalar(1, x); // FIXME: create a BigNumber one when configured for bignumbers
        }
    });
    /**
   * Calculate the inverse of a square matrix
   * @param {Array[]} mat     A square matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns, must equal rows
   * @return {Array[]} inv    Inverse matrix
   * @private
   */ function _inv(mat, rows, cols) {
        var r, s, f, value, temp;
        if (rows === 1) {
            // this is a 1 x 1 matrix
            value = mat[0][0];
            if (value === 0) throw Error("Cannot calculate inverse, determinant is zero");
            return [
                [
                    divideScalar(1, value)
                ]
            ];
        } else if (rows === 2) {
            // this is a 2 x 2 matrix
            var d = det(mat);
            if (d === 0) throw Error("Cannot calculate inverse, determinant is zero");
            return [
                [
                    divideScalar(mat[1][1], d),
                    divideScalar(unaryMinus(mat[0][1]), d)
                ],
                [
                    divideScalar(unaryMinus(mat[1][0]), d),
                    divideScalar(mat[0][0], d)
                ]
            ];
        } else {
            // this is a matrix of 3 x 3 or larger
            // calculate inverse using gauss-jordan elimination
            //      https://en.wikipedia.org/wiki/Gaussian_elimination
            //      http://mathworld.wolfram.com/MatrixInverse.html
            //      http://math.uww.edu/~mcfarlat/inverse.htm
            // make a copy of the matrix (only the arrays, not of the elements)
            var A = mat.concat();
            for(r = 0; r < rows; r++)A[r] = A[r].concat();
             // create an identity matrix which in the end will contain the
            // matrix inverse
            var B = identity(rows).valueOf(); // loop over all columns, and perform row reductions
            for(var c = 0; c < cols; c++){
                // Pivoting: Swap row c with row r, where row r contains the largest element A[r][c]
                var ABig = abs(A[c][c]);
                var rBig = c;
                r = c + 1;
                while(r < rows){
                    if (abs(A[r][c]) > ABig) {
                        ABig = abs(A[r][c]);
                        rBig = r;
                    }
                    r++;
                }
                if (ABig === 0) throw Error("Cannot calculate inverse, determinant is zero");
                r = rBig;
                if (r !== c) {
                    temp = A[c];
                    A[c] = A[r];
                    A[r] = temp;
                    temp = B[c];
                    B[c] = B[r];
                    B[r] = temp;
                } // eliminate non-zero values on the other rows at column c
                var Ac = A[c];
                var Bc = B[c];
                for(r = 0; r < rows; r++){
                    var Ar = A[r];
                    var Br = B[r];
                    if (r !== c) // eliminate value at column c and row r
                    {
                        if (Ar[c] !== 0) {
                            f = divideScalar(unaryMinus(Ar[c]), Ac[c]); // add (f * row c) to row r to eliminate the value
                            // at column c
                            for(s = c; s < cols; s++)Ar[s] = addScalar(Ar[s], multiply(f, Ac[s]));
                            for(s = 0; s < cols; s++)Br[s] = addScalar(Br[s], multiply(f, Bc[s]));
                        }
                    } else {
                        // normalize value at Acc to 1,
                        // divide each value on row r with the value at Acc
                        f = Ac[c];
                        for(s = c; s < cols; s++)Ar[s] = divideScalar(Ar[s], f);
                        for(s = 0; s < cols; s++)Br[s] = divideScalar(Br[s], f);
                    }
                }
            }
            return B;
        }
    }
});


var $b4606295304ff90e$var$name = "invmod";
var $b4606295304ff90e$var$dependencies = [
    "typed",
    "config",
    "BigNumber",
    "xgcd",
    "equal",
    "smaller",
    "mod",
    "add",
    "isInteger"
];
var $b4606295304ff90e$export$1e04c9355dadf1c8 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b4606295304ff90e$var$name, $b4606295304ff90e$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, BigNumber: BigNumber, xgcd: xgcd, equal: equal, smaller: smaller, mod: mod, add: add, isInteger: isInteger } = _ref;
    /**
   * Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation `ax ≣ 1 (mod b)`
   * See https://en.wikipedia.org/wiki/Modular_multiplicative_inverse.
   *
   * Syntax:
   *
   *    math.invmod(a, b)
   *
   * Examples:
   *
   *    math.invmod(8, 12)             // returns NaN
   *    math.invmod(7, 13)             // return 2
   *    math.invmod(15151, 15122)      // returns 10429
   *
   * See also:
   *
   *    gcd, xgcd
   *
   * @param {number | BigNumber} a  An integer number
   * @param {number | BigNumber} b  An integer number
   * @return {number | BigNumber }  Returns an integer number
   *                              where `invmod(a,b)*a ≣ 1 (mod b)`
   */ return typed($b4606295304ff90e$var$name, {
        "number, number": invmod,
        "BigNumber, BigNumber": invmod
    });
    function invmod(a, b) {
        if (!isInteger(a) || !isInteger(b)) throw new Error("Parameters in function invmod must be integer numbers");
        a = mod(a, b);
        if (equal(b, 0)) throw new Error("Divisor must be non zero");
        var res = xgcd(a, b);
        res = res.valueOf();
        var [gcd, inv] = res;
        if (!equal(gcd, BigNumber(1))) return NaN;
        inv = mod(inv, b);
        if (smaller(inv, BigNumber(0))) inv = add(inv, b);
        return inv;
    }
});




var $1835ca939a9c842a$var$name = "isInteger";
var $1835ca939a9c842a$var$dependencies = [
    "typed"
];
var $1835ca939a9c842a$export$766996d075d5608a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1835ca939a9c842a$var$name, $1835ca939a9c842a$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is an integer number.
   * The function supports `number`, `BigNumber`, and `Fraction`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isInteger(x)
   *
   * Examples:
   *
   *    math.isInteger(2)                     // returns true
   *    math.isInteger(0)                     // returns true
   *    math.isInteger(0.5)                   // returns false
   *    math.isInteger(math.bignumber(500))   // returns true
   *    math.isInteger(math.fraction(4))      // returns true
   *    math.isInteger('3')                   // returns true
   *    math.isInteger([3, 0.5, -2])          // returns [true, false, true]
   *    math.isInteger(math.complex('2-4i')   // throws an error
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isZero
   *
   * @param {number | BigNumber | Fraction | Array | Matrix} x   Value to be tested
   * @return {boolean}  Returns true when `x` contains a numeric, integer value.
   *                    Throws an error in case of an unknown data type.
   */ return typed($1835ca939a9c842a$var$name, {
        number: (0, $a03283b133c3c55b$export$a287f47fed4544b8),
        // TODO: what to do with isInteger(add(0.1, 0.2))  ?
        BigNumber: function BigNumber(x) {
            return x.isInt();
        },
        Fraction: function Fraction(x) {
            return x.d === 1 && isFinite(x.n);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $9d7eb2e9ccc25c8d$var$n1 = "number";
function $9d7eb2e9ccc25c8d$export$312381923ba56895(x) {
    return (0, $a03283b133c3c55b$export$a287f47fed4544b8)(x);
}
$9d7eb2e9ccc25c8d$export$312381923ba56895.signature = $9d7eb2e9ccc25c8d$var$n1;
function $9d7eb2e9ccc25c8d$export$6dbd64961904ec9a(x) {
    return x < 0;
}
$9d7eb2e9ccc25c8d$export$6dbd64961904ec9a.signature = $9d7eb2e9ccc25c8d$var$n1;
function $9d7eb2e9ccc25c8d$export$5374bb854d0e41c8(x) {
    return x > 0;
}
$9d7eb2e9ccc25c8d$export$5374bb854d0e41c8.signature = $9d7eb2e9ccc25c8d$var$n1;
function $9d7eb2e9ccc25c8d$export$83fb4ed1cc9804a(x) {
    return x === 0;
}
$9d7eb2e9ccc25c8d$export$83fb4ed1cc9804a.signature = $9d7eb2e9ccc25c8d$var$n1;
function $9d7eb2e9ccc25c8d$export$9fd08d8371c55110(x) {
    return Number.isNaN(x);
}
$9d7eb2e9ccc25c8d$export$9fd08d8371c55110.signature = $9d7eb2e9ccc25c8d$var$n1;


var $e4bfeeaf868ddf25$var$name = "isNaN";
var $e4bfeeaf868ddf25$var$dependencies = [
    "typed"
];
var $e4bfeeaf868ddf25$export$f85085363cf09711 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e4bfeeaf868ddf25$var$name, $e4bfeeaf868ddf25$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is NaN (not a number).
   * The function supports types `number`, `BigNumber`, `Fraction`, `Unit` and `Complex`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNaN(x)
   *
   * Examples:
   *
   *    math.isNaN(3)                     // returns false
   *    math.isNaN(NaN)                   // returns true
   *    math.isNaN(0)                     // returns false
   *    math.isNaN(math.bignumber(NaN))   // returns true
   *    math.isNaN(math.bignumber(0))     // returns false
   *    math.isNaN(math.fraction(-2, 5))  // returns false
   *    math.isNaN('-2')                  // returns false
   *    math.isNaN([2, 0, -3, NaN]')      // returns [false, false, false, true]
   *
   * See also:
   *
   *    isNumeric, isNegative, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is NaN.
   *                    Throws an error in case of an unknown data type.
   */ return typed($e4bfeeaf868ddf25$var$name, {
        number: (0, $9d7eb2e9ccc25c8d$export$9fd08d8371c55110),
        BigNumber: function BigNumber(x) {
            return x.isNaN();
        },
        Fraction: function Fraction(x) {
            return false;
        },
        Complex: function Complex(x) {
            return x.isNaN();
        },
        Unit: function Unit(x) {
            return Number.isNaN(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, Number.isNaN);
        }
    });
});




var $9ba354edacdac2e9$var$name = "isNegative";
var $9ba354edacdac2e9$var$dependencies = [
    "typed"
];
var $9ba354edacdac2e9$export$159ccd8c63e17c58 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($9ba354edacdac2e9$var$name, $9ba354edacdac2e9$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is negative: smaller than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNegative(x)
   *
   * Examples:
   *
   *    math.isNegative(3)                     // returns false
   *    math.isNegative(-2)                    // returns true
   *    math.isNegative(0)                     // returns false
   *    math.isNegative(-0)                    // returns false
   *    math.isNegative(math.bignumber(2))     // returns false
   *    math.isNegative(math.fraction(-2, 5))  // returns true
   *    math.isNegative('-2')                  // returns true
   *    math.isNegative([2, 0, -3]')           // returns [false, false, true]
   *
   * See also:
   *
   *    isNumeric, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($9ba354edacdac2e9$var$name, {
        number: (0, $9d7eb2e9ccc25c8d$export$6dbd64961904ec9a),
        BigNumber: function BigNumber(x) {
            return x.isNeg() && !x.isZero() && !x.isNaN();
        },
        Fraction: function Fraction(x) {
            return x.s < 0; // It's enough to decide on the sign
        },
        Unit: function Unit(x) {
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $11e94d2787bb4994$var$name = "isNumeric";
var $11e94d2787bb4994$var$dependencies = [
    "typed"
];
var $11e94d2787bb4994$export$85b0631fa122b7f1 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($11e94d2787bb4994$var$name, $11e94d2787bb4994$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is an numeric value.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNumeric(x)
   *
   * Examples:
   *
   *    math.isNumeric(2)                     // returns true
   *    math.isNumeric('2')                   // returns false
   *    math.hasNumericValue('2')             // returns true
   *    math.isNumeric(0)                     // returns true
   *    math.isNumeric(math.bignumber(500))   // returns true
   *    math.isNumeric(math.fraction(4))      // returns true
   *    math.isNumeric(math.complex('2-4i')   // returns false
   *    math.isNumeric([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, hasNumericValue
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, or `boolean`. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($11e94d2787bb4994$var$name, {
        "number | BigNumber | Fraction | boolean": function numberBigNumberFractionBoolean() {
            return true;
        },
        "Complex | Unit | string | null | undefined | Node": function ComplexUnitStringNullUndefinedNode() {
            return false;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $a2e59934015b5265$var$name = "isPositive";
var $a2e59934015b5265$var$dependencies = [
    "typed"
];
var $a2e59934015b5265$export$2d862c12fb537dd9 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a2e59934015b5265$var$name, $a2e59934015b5265$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is positive: larger than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPositive(x)
   *
   * Examples:
   *
   *    math.isPositive(3)                     // returns true
   *    math.isPositive(-2)                    // returns false
   *    math.isPositive(0)                     // returns false
   *    math.isPositive(-0)                    // returns false
   *    math.isPositive(0.5)                   // returns true
   *    math.isPositive(math.bignumber(2))     // returns true
   *    math.isPositive(math.fraction(-2, 5))  // returns false
   *    math.isPositive(math.fraction(1,3))    // returns false
   *    math.isPositive('2')                   // returns true
   *    math.isPositive([2, 0, -3])            // returns [true, false, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($a2e59934015b5265$var$name, {
        number: (0, $9d7eb2e9ccc25c8d$export$5374bb854d0e41c8),
        BigNumber: function BigNumber(x) {
            return !x.isNeg() && !x.isZero() && !x.isNaN();
        },
        Fraction: function Fraction(x) {
            return x.s > 0 && x.n > 0;
        },
        Unit: function Unit(x) {
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $1944a198df7f372f$var$name = "isPrime";
var $1944a198df7f372f$var$dependencies = [
    "typed"
];
var $1944a198df7f372f$export$4e02350f5fb7a050 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1944a198df7f372f$var$name, $1944a198df7f372f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is prime: has no divisors other than itself and one.
   * The function supports type `number`, `bignumber`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPrime(x)
   *
   * Examples:
   *
   *    math.isPrime(3)                     // returns true
   *    math.isPrime(-2)                    // returns false
   *    math.isPrime(0)                     // returns false
   *    math.isPrime(-0)                    // returns false
   *    math.isPrime(0.5)                   // returns false
   *    math.isPrime('2')                   // returns true
   *    math.isPrime([2, 17, 100])           // returns [true, true, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($1944a198df7f372f$var$name, {
        number: function number(x) {
            if (x * 0 !== 0) return false;
            if (x <= 3) return x > 1;
            if (x % 2 === 0 || x % 3 === 0) return false;
            for(var i = 5; i * i <= x; i += 6){
                if (x % i === 0 || x % (i + 2) === 0) return false;
            }
            return true;
        },
        BigNumber: function BigNumber(n) {
            if (n.toNumber() * 0 !== 0) return false;
            if (n.lte(3)) return n.gt(1);
            if (n.mod(2).eq(0) || n.mod(3).eq(0)) return false;
            if (n.lt(Math.pow(2, 32))) {
                var x = n.toNumber();
                for(var i = 5; i * i <= x; i += 6){
                    if (x % i === 0 || x % (i + 2) === 0) return false;
                }
                return true;
            }
            function modPow(base, exponent, modulus) {
                // exponent can be huge, use non-recursive variant
                var accumulator = 1;
                while(!exponent.eq(0))if (exponent.mod(2).eq(0)) {
                    exponent = exponent.div(2);
                    base = base.mul(base).mod(modulus);
                } else {
                    exponent = exponent.sub(1);
                    accumulator = base.mul(accumulator).mod(modulus);
                }
                return accumulator;
            } // https://en.wikipedia.org/wiki/Miller%E2%80%93Rabin_primality_test#Deterministic_variants
            var Decimal = n.constructor.clone({
                precision: n.toFixed(0).length * 2
            });
            n = new Decimal(n);
            var r = 0;
            var d = n.sub(1);
            while(d.mod(2).eq(0)){
                d = d.div(2);
                r += 1;
            }
            var bases = null; // https://en.wikipedia.org/wiki/Miller–Rabin_primality_test#Testing_against_small_sets_of_bases
            if (n.lt("3317044064679887385961981")) bases = [
                2,
                3,
                5,
                7,
                11,
                13,
                17,
                19,
                23,
                29,
                31,
                37,
                41
            ].filter((x)=>x < n);
            else {
                var max = Math.min(n.toNumber() - 2, Math.floor(2 * Math.pow(n.toFixed(0).length * Math.log(10), 2)));
                bases = [];
                for(var _i = 2; _i <= max; _i += 1)bases.push(max);
            }
            for(var _i2 = 0; _i2 < bases.length; _i2 += 1){
                var a = bases[_i2];
                var adn = modPow(n.sub(n).add(a), d, n);
                if (!adn.eq(1)) for(var _i3 = 0, _x = adn; !_x.eq(n.sub(1)); _i3 += 1, _x = _x.mul(_x).mod(n)){
                    if (_i3 === r - 1) return false;
                }
            }
            return true;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $3c8f82201186a392$var$name = "isZero";
var $3c8f82201186a392$var$dependencies = [
    "typed"
];
var $3c8f82201186a392$export$ea90652d00dab06e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($3c8f82201186a392$var$name, $3c8f82201186a392$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is zero.
   * The function can check for zero for types `number`, `BigNumber`, `Fraction`,
   * `Complex`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isZero(x)
   *
   * Examples:
   *
   *    math.isZero(0)                     // returns true
   *    math.isZero(2)                     // returns false
   *    math.isZero(0.5)                   // returns false
   *    math.isZero(math.bignumber(0))     // returns true
   *    math.isZero(math.fraction(0))      // returns true
   *    math.isZero(math.fraction(1,3))    // returns false
   *    math.isZero(math.complex('2 - 4i') // returns false
   *    math.isZero(math.complex('0i')     // returns true
   *    math.isZero('0')                   // returns true
   *    math.isZero('2')                   // returns false
   *    math.isZero([2, 0, -3]')           // returns [false, true, false]
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isInteger
   *
   * @param {number | BigNumber | Complex | Fraction | Unit | Array | Matrix} x       Value to be tested
   * @return {boolean}  Returns true when `x` is zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($3c8f82201186a392$var$name, {
        number: (0, $9d7eb2e9ccc25c8d$export$83fb4ed1cc9804a),
        BigNumber: function BigNumber(x) {
            return x.isZero();
        },
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        Fraction: function Fraction(x) {
            return x.d === 1 && x.n === 0;
        },
        Unit: function Unit(x) {
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});


var $a420a2ea03e61460$var$name = "kldivergence";
var $a420a2ea03e61460$var$dependencies = [
    "typed",
    "matrix",
    "divide",
    "sum",
    "multiply",
    "dotDivide",
    "log",
    "isNumeric"
];
var $a420a2ea03e61460$export$eaa5cb8fd86b8d43 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a420a2ea03e61460$var$name, $a420a2ea03e61460$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divide: divide, sum: sum, multiply: multiply, dotDivide: dotDivide, log: log, isNumeric: isNumeric } = _ref;
    /**
     * Calculate the Kullback-Leibler (KL) divergence  between two distributions
     *
     * Syntax:
     *
     *     math.kldivergence(x, y)
     *
     * Examples:
     *
     *     math.kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])   //returns 0.24376698773121153
     *
     *
     * @param  {Array | Matrix} q    First vector
     * @param  {Array | Matrix} p    Second vector
     * @return {number}              Returns distance between q and p
     */ return typed($a420a2ea03e61460$var$name, {
        "Array, Array": function ArrayArray(q, p) {
            return _kldiv(matrix(q), matrix(p));
        },
        "Matrix, Array": function MatrixArray(q, p) {
            return _kldiv(q, matrix(p));
        },
        "Array, Matrix": function ArrayMatrix(q, p) {
            return _kldiv(matrix(q), p);
        },
        "Matrix, Matrix": function MatrixMatrix(q, p) {
            return _kldiv(q, p);
        }
    });
    function _kldiv(q, p) {
        var plength = p.size().length;
        var qlength = q.size().length;
        if (plength > 1) throw new Error("first object must be one dimensional");
        if (qlength > 1) throw new Error("second object must be one dimensional");
        if (plength !== qlength) throw new Error("Length of two vectors must be equal");
         // Before calculation, apply normalization
        var sumq = sum(q);
        if (sumq === 0) throw new Error("Sum of elements in first object must be non zero");
        var sump = sum(p);
        if (sump === 0) throw new Error("Sum of elements in second object must be non zero");
        var qnorm = divide(q, sum(q));
        var pnorm = divide(p, sum(p));
        var result = sum(multiply(qnorm, log(dotDivide(qnorm, pnorm))));
        if (isNumeric(result)) return result;
        else return Number.NaN;
    }
});



var $e1c5b87aee7e3853$var$name = "kron";
var $e1c5b87aee7e3853$var$dependencies = [
    "typed",
    "matrix",
    "multiplyScalar"
];
var $e1c5b87aee7e3853$export$cee275bf38ddc295 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e1c5b87aee7e3853$var$name, $e1c5b87aee7e3853$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, multiplyScalar: multiplyScalar } = _ref;
    /**
     * Calculates the kronecker product of 2 matrices or vectors.
     *
     * NOTE: If a one dimensional vector / matrix is given, it will be
     * wrapped so its two dimensions.
     * See the examples.
     *
     * Syntax:
     *
     *    math.kron(x, y)
     *
     * Examples:
     *
     *    math.kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])
     *    // returns [ [ 1, 2, 0, 0 ], [ 3, 4, 0, 0 ], [ 0, 0, 1, 2 ], [ 0, 0, 3, 4 ] ]
     *
     *    math.kron([1,1], [2,3,4])
     *    // returns [ [ 2, 3, 4, 2, 3, 4 ] ]
     *
     * See also:
     *
     *    multiply, dot, cross
     *
     * @param  {Array | Matrix} x     First vector
     * @param  {Array | Matrix} y     Second vector
     * @return {Array | Matrix}       Returns the kronecker product of `x` and `y`
     */ return typed($e1c5b87aee7e3853$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return matrix(_kron(x.toArray(), y.toArray()));
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return matrix(_kron(x.toArray(), y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return matrix(_kron(x, y.toArray()));
        },
        "Array, Array": _kron
    });
    /**
     * Calculate the kronecker product of two matrices / vectors
     * @param {Array} a  First vector
     * @param {Array} b  Second vector
     * @returns {Array} Returns the kronecker product of x and y
     * @private
     */ function _kron(a, b) {
        // Deal with the dimensions of the matricies.
        if ((0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(a).length === 1) // Wrap it in a 2D Matrix
        a = [
            a
        ];
        if ((0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(b).length === 1) // Wrap it in a 2D Matrix
        b = [
            b
        ];
        if ((0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(a).length > 2 || (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(b).length > 2) throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(a.length) + ", y = " + JSON.stringify(b.length) + ")");
        var t = [];
        var r = [];
        return a.map(function(a) {
            return b.map(function(b) {
                r = [];
                t.push(r);
                return a.map(function(y) {
                    return b.map(function(x) {
                        return r.push(multiplyScalar(y, x));
                    });
                });
            });
        }) && t;
    }
});









var $6b7b92b9e5bcba58$var$name = "larger";
var $6b7b92b9e5bcba58$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $6b7b92b9e5bcba58$export$af9bc16ae70e9aa8 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($6b7b92b9e5bcba58$var$name, $6b7b92b9e5bcba58$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $49703efd2d98c69c$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether value x is larger than y.
   *
   * The function returns true when x is larger than y and the relative
   * difference between x and y is larger than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.larger(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 3)             // returns false
   *    math.larger(5, 2 + 2)         // returns true
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.larger(a, b)             // returns false
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger than y, else returns false
   */ return typed($6b7b92b9e5bcba58$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x > y;
        },
        "number, number": function numberNumber(x, y) {
            return x > y && !(0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.gt(y) && !(0, $cea3608675fc8eba$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) === 1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $6b7b92b9e5bcba58$export$36e0507f86788708 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($6b7b92b9e5bcba58$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($6b7b92b9e5bcba58$var$name, {
        "number, number": function numberNumber(x, y) {
            return x > y && !(0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon);
        }
    });
});









var $8b0fee74312464cb$var$name = "largerEq";
var $8b0fee74312464cb$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $8b0fee74312464cb$export$26aa7f5b5fee1150 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8b0fee74312464cb$var$name, $8b0fee74312464cb$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $49703efd2d98c69c$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether value x is larger or equal to y.
   *
   * The function returns true when x is larger than y or the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.largerEq(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 1 + 1)         // returns false
   *    math.largerEq(2, 1 + 1)       // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger or equal to y, else returns false
   */ return typed($8b0fee74312464cb$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x >= y;
        },
        "number, number": function numberNumber(x, y) {
            return x >= y || (0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.gte(y) || (0, $cea3608675fc8eba$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) !== -1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $8b0fee74312464cb$export$494ed93834104475 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8b0fee74312464cb$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($8b0fee74312464cb$var$name, {
        "number, number": function numberNumber(x, y) {
            return x >= y || (0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon);
        }
    });
});








var $a3045b8800fd0820$var$name = "lcm";
var $a3045b8800fd0820$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar"
];
var $a3045b8800fd0820$export$5d3af1956d9bb33b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a3045b8800fd0820$var$name, $a3045b8800fd0820$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar } = _ref;
    var algorithm02 = (0, $b6b1cd490ad9f946$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $dcf47e3db09976d1$export$d6f401e6f2a7e54b)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculate the least common multiple for two or more values or arrays.
   *
   * lcm is defined as:
   *
   *     lcm(a, b) = abs(a * b) / gcd(a, b)
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.lcm(a, b)
   *    math.lcm(a, b, c, ...)
   *
   * Examples:
   *
   *    math.lcm(4, 6)               // returns 12
   *    math.lcm(6, 21)              // returns 42
   *    math.lcm(6, 21, 5)           // returns 210
   *
   *    math.lcm([4, 6], [6, 21])    // returns [12, 42]
   *
   * See also:
   *
   *    gcd, xgcd
   *
   * @param {... number | BigNumber | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Array | Matrix}                           The least common multiple
   */ return typed($a3045b8800fd0820$var$name, {
        "number, number": (0, $08ae6b2eb4bd0049$export$b55f99ec1f4c5649),
        "BigNumber, BigNumber": _lcmBigNumber,
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.lcm(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            return algorithm11(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        // TODO: need a smarter notation here
        "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(a, b, args) {
            var res = this(a, b);
            for(var i = 0; i < args.length; i++)res = this(res, args[i]);
            return res;
        }
    });
    /**
   * Calculate lcm for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns the least common multiple of a and b
   * @private
   */ function _lcmBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function lcm must be integer numbers");
        if (a.isZero()) return a;
        if (b.isZero()) return b;
         // https://en.wikipedia.org/wiki/Euclidean_algorithm
        // evaluate lcm here inline to reduce overhead
        var prod = a.times(b);
        while(!b.isZero()){
            var t = b;
            b = a.mod(t);
            a = t;
        }
        return prod.div(a).abs();
    }
});









var $f96cb799bd51ff34$var$name = "algorithm08";
var $f96cb799bd51ff34$var$dependencies = [
    "typed",
    "equalScalar"
];
var $f96cb799bd51ff34$export$59a068f853cfbf8 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($f96cb799bd51ff34$var$name, $f96cb799bd51ff34$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm08(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!avalues || !bvalues) throw new Error("Cannot perform operation on Pattern Sparse Matrices");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = []; // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // vars
        var k, k0, k1, i; // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop values in a
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // mark workspace
                w[i] = mark; // set value
                x[i] = avalues[k]; // add index
                cindex.push(i);
            } // loop values in b
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // check value exists in workspace
                if (w[i] === mark) // evaluate callback
                x[i] = cf(x[i], bvalues[k]);
            } // initialize first index in j
            k = cptr[j]; // loop index in j
            while(k < cindex.length){
                // row
                i = cindex[k]; // value @ i
                var v = x[i]; // check for zero value
                if (!eq(v, zero)) {
                    // push value
                    cvalues.push(v); // increment pointer
                    k++;
                } else // remove value @ i, do not increment pointer
                cindex.splice(k, 1);
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});





var $9a14c9a977308573$var$name = "leftShift";
var $9a14c9a977308573$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $9a14c9a977308573$export$ce15600b23f5e78 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($9a14c9a977308573$var$name, $9a14c9a977308573$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $3feaf9e0b000398a$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm02 = (0, $b6b1cd490ad9f946$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $f96cb799bd51ff34$export$59a068f853cfbf8)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $e9da21a7968d7093$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise left logical shift of a value x by y number of bits, `x << y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.leftShift(x, y)
   *
   * Examples:
   *
   *    math.leftShift(1, 2)               // returns number 4
   *
   *    math.leftShift([1, 2, 3], 4)       // returns Array [16, 32, 64]
   *
   * See also:
   *
   *    leftShift, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber} y Amount of shifts
   * @return {number | BigNumber | Array | Matrix} `x` shifted left `y` times
   */ return typed($9a14c9a977308573$var$name, {
        "number, number": (0, $8ed95b606c7043f9$export$65c07a47901525ba),
        "BigNumber, BigNumber": (0, $ac43c9464ecff9bd$export$626dff8098a67b4c),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});

/* eslint-disable no-loss-of-precision */ // References
// ----------
// [1] Hare, "Computing the Principal Branch of log-Gamma", Journal of Algorithms, 1997.
// [2] https://math.stackexchange.com/questions/1338753/how-do-i-calculate-values-for-gamma-function-with-complex-arguments



var $c473a94c8d441725$var$name = "lgamma";
var $c473a94c8d441725$var$dependencies = [
    "Complex",
    "typed"
];
var $c473a94c8d441725$export$bc3a6f6286e9085a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c473a94c8d441725$var$name, $c473a94c8d441725$var$dependencies, (_ref)=>{
    var { Complex: _Complex, typed: typed } = _ref;
    // Stirling series is non-convergent, we need to use the recurrence `lgamma(z) = lgamma(z+1) - log z` to get
    // sufficient accuracy.
    //
    // These two values are copied from Scipy implementation:
    // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L37
    var SMALL_RE = 7;
    var SMALL_IM = 7;
    /**
   * The coefficients are B[2*n]/(2*n*(2*n - 1)) where B[2*n] is the (2*n)th Bernoulli number. See (1.1) in [1].
   *
   * If you cannot access the paper, can also get these values from the formula in [2].
   *
   *    1 /     12 = 0.00833333333333333333333333333333
   *    1 /    360 = 0.00277777777777777777777777777778
   * ...
   * 3617 / 133400 = 0.02955065359477124183006535947712
   */ var coeffs = [
        -0.029550653594771242,
        6.4102564102564102564e-3,
        -0.0019175269175269176,
        8.4175084175084175084e-4,
        -0.0005952380952380953,
        7.9365079365079365079e-4,
        -0.002777777777777778,
        8.3333333333333333333e-2
    ];
    /**
   * Logarithm of the gamma function for real, positive numbers and complex numbers,
   * using Lanczos approximation for numbers and Stirling series for complex numbers.
   *
   * Syntax:
   *
   *    math.lgamma(n)
   *
   * Examples:
   *
   *    math.lgamma(5)       // returns 3.178053830347945
   *    math.lgamma(0)       // returns Infinity
   *    math.lgamma(-0.5)    // returns NaN
   *    math.lgamma(math.i)  // returns -0.6509231993018536 - 1.8724366472624294i
   *
   * See also:
   *
   *    gamma
   *
   * @param {number | Complex} n   A real or complex number
   * @return {number | Complex}    The log gamma of `n`
   */ return typed($c473a94c8d441725$var$name, {
        number: (0, $7e8e0d8af6caaacc$export$a9c1cdc6d03f0efc),
        Complex: function Complex(n) {
            var TWOPI = 6.2831853071795864769252842; // 2*pi
            var LOGPI = 1.1447298858494001741434262; // log(pi)
            var REFLECTION = 0.1;
            if (n.isNaN()) return new _Complex(NaN, NaN);
            else if (n.im === 0) return new _Complex((0, $7e8e0d8af6caaacc$export$a9c1cdc6d03f0efc)(n.re), 0);
            else if (n.re >= SMALL_RE || Math.abs(n.im) >= SMALL_IM) return lgammaStirling(n);
            else if (n.re <= REFLECTION) {
                // Reflection formula. see Proposition 3.1 in [1]
                var tmp = (0, $a03283b133c3c55b$export$fe7b50dc6162f97e)(TWOPI, n.im) * Math.floor(0.5 * n.re + 0.25); // TODO: `complex.js sin` doesn't have extremely high precision, so this value `a` may lose a little precision,
                // causing the computation results to be less accurate than the lgamma of real numbers
                var a = n.mul(Math.PI).sin().log();
                var b = this(new _Complex(1 - n.re, -n.im));
                return new _Complex(LOGPI, tmp).sub(a).sub(b);
            } else if (n.im >= 0) return lgammaRecurrence(n);
            else return lgammaRecurrence(n.conjugate()).conjugate();
        },
        BigNumber: function BigNumber() {
            throw new Error("mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber");
        }
    });
    function lgammaStirling(z) {
        // formula ref in [2]
        // computation ref:
        // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L101
        // left part
        // x (log(x) - 1) + 1/2 (log(2PI) - log(x))
        // => (x - 0.5) * log(x) - x + log(2PI) / 2
        var leftPart = z.sub(0.5).mul(z.log()).sub(z).add((0, $7e8e0d8af6caaacc$export$6854df5fcb691251)); // right part
        var rz = new _Complex(1, 0).div(z);
        var rzz = rz.div(z);
        var a = coeffs[0];
        var b = coeffs[1];
        var r = 2 * rzz.re;
        var s = rzz.re * rzz.re + rzz.im * rzz.im;
        for(var i = 2; i < 8; i++){
            var tmp = b;
            b = -s * a + coeffs[i];
            a = r * a + tmp;
        }
        var rightPart = rz.mul(rzz.mul(a).add(b)); // plus left and right
        return leftPart.add(rightPart);
    }
    function lgammaRecurrence(z) {
        // computation ref:
        // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L78
        var signflips = 0;
        var sb = 0;
        var shiftprod = z;
        z = z.add(1);
        while(z.re <= SMALL_RE){
            shiftprod = shiftprod.mul(z);
            var nsb = shiftprod.im < 0 ? 1 : 0;
            if (nsb !== 0 && sb === 0) signflips++;
            sb = nsb;
            z = z.add(1);
        }
        return lgammaStirling(z).sub(shiftprod.log()).sub(new _Complex(0, signflips * 2 * Math.PI * 1));
    }
});




var $471dd5220326217f$var$name = "log";
var $471dd5220326217f$var$dependencies = [
    "config",
    "typed",
    "divideScalar",
    "Complex"
];
var $471dd5220326217f$export$aea8a16d5c9d1b93 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($471dd5220326217f$var$name, $471dd5220326217f$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, Complex: Complex } = _ref;
    /**
   * Calculate the logarithm of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log(x)
   *    math.log(x, base)
   *
   * Examples:
   *
   *    math.log(3.5)                  // returns 1.252762968495368
   *    math.exp(math.log(2.4))        // returns 2.4
   *
   *    math.pow(10, 4)                // returns 10000
   *    math.log(10000, 10)            // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *
   *    math.log(1024, 2)              // returns 10
   *    math.pow(2, 10)                // returns 1024
   *
   * See also:
   *
   *    exp, log2, log10, log1p
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x`
   */ return typed($471dd5220326217f$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $08ae6b2eb4bd0049$export$4df0e8fcdd5c0927)(x);
            else // negative value -> complex value computation
            return new Complex(x, 0).log();
        },
        Complex: function Complex(x) {
            return x.log();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.ln();
            else // downgrade to number, return Complex valued result
            return new Complex(x.toNumber(), 0).log();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        },
        "any, any": function anyAny(x, base) {
            // calculate logarithm for a specified base, log(x, base)
            return divideScalar(this(x), this(base));
        }
    });
});




var $2366a456b37decda$var$name = "log10";
var $2366a456b37decda$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $2366a456b37decda$export$dea4efeb24d4590d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($2366a456b37decda$var$name, $2366a456b37decda$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: _Complex } = _ref;
    /**
   * Calculate the 10-base logarithm of a value. This is the same as calculating `log(x, 10)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log10(x)
   *
   * Examples:
   *
   *    math.log10(0.00001)            // returns -5
   *    math.log10(10000)              // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *    math.pow(10, 4)                // returns 10000
   *
   * See also:
   *
   *    exp, log, log1p, log2
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 10-base logarithm of `x`
   */ return typed($2366a456b37decda$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $08ae6b2eb4bd0049$export$e3f8d49574d29dff)(x);
            else // negative value -> complex value computation
            return new _Complex(x, 0).log().div(Math.LN10);
        },
        Complex: function Complex(x) {
            return new _Complex(x).log().div(Math.LN10);
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log();
            else // downgrade to number, return Complex valued result
            return new _Complex(x.toNumber(), 0).log().div(Math.LN10);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $e9f88e29ad122b34$var$name = "log1p";
var $e9f88e29ad122b34$var$dependencies = [
    "typed",
    "config",
    "divideScalar",
    "log",
    "Complex"
];
var $e9f88e29ad122b34$export$93da279859a704f0 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e9f88e29ad122b34$var$name, $e9f88e29ad122b34$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, log: log, Complex: Complex } = _ref;
    /**
   * Calculate the logarithm of a `value+1`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log1p(x)
   *    math.log1p(x, base)
   *
   * Examples:
   *
   *    math.log1p(2.5)                 // returns 1.252762968495368
   *    math.exp(math.log1p(1.4))       // returns 2.4
   *
   *    math.pow(10, 4)                 // returns 10000
   *    math.log1p(9999, 10)            // returns 4
   *    math.log1p(9999) / math.log(10) // returns 4
   *
   * See also:
   *
   *    exp, log, log2, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm of `x+1`.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x+1` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x+1`
   */ return typed($e9f88e29ad122b34$var$name, {
        number: function number(x) {
            if (x >= -1 || config.predictable) return (0, $a03283b133c3c55b$export$144dcf16adfb9698)(x);
            else // negative value -> complex value computation
            return _log1pComplex(new Complex(x, 0));
        },
        Complex: _log1pComplex,
        BigNumber: function BigNumber(x) {
            var y = x.plus(1);
            if (!y.isNegative() || config.predictable) return y.ln();
            else // downgrade to number, return Complex valued result
            return _log1pComplex(new Complex(x.toNumber(), 0));
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        },
        "any, any": function anyAny(x, base) {
            // calculate logarithm for a specified base, log1p(x, base)
            return divideScalar(this(x), log(base));
        }
    });
    /**
   * Calculate the natural logarithm of a complex number + 1
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log1pComplex(x) {
        var xRe1p = x.re + 1;
        return new Complex(Math.log(Math.sqrt(xRe1p * xRe1p + x.im * x.im)), Math.atan2(x.im, xRe1p));
    }
});




var $983791d280b8931b$var$name = "log2";
var $983791d280b8931b$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $983791d280b8931b$export$a993dae3988e0f19 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($983791d280b8931b$var$name, $983791d280b8931b$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log2(x)
   *
   * Examples:
   *
   *    math.log2(0.03125)           // returns -5
   *    math.log2(16)                // returns 4
   *    math.log2(16) / math.log2(2) // returns 4
   *    math.pow(2, 4)               // returns 16
   *
   * See also:
   *
   *    exp, log, log1p, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 2-base logarithm of `x`
   */ return typed($983791d280b8931b$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $08ae6b2eb4bd0049$export$f9bc93220cfa3c59)(x);
            else // negative value -> complex value computation
            return _log2Complex(new Complex(x, 0));
        },
        Complex: _log2Complex,
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log(2);
            else // downgrade to number, return Complex valued result
            return _log2Complex(new Complex(x.toNumber(), 0));
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
    /**
   * Calculate log2 for a complex value
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log2Complex(x) {
        var newX = Math.sqrt(x.re * x.re + x.im * x.im);
        return new Complex(Math.log2 ? Math.log2(newX) : Math.log(newX) / Math.LN2, Math.atan2(x.im, x.re) / Math.LN2);
    }
});





function $00dc5b12f1db226b$export$6accbcba5dda801d(_ref) {
    var { DenseMatrix: DenseMatrix } = _ref;
    /**
   * Validates matrix and column vector b for backward/forward substitution algorithms.
   *
   * @param {Matrix} m            An N x N matrix
   * @param {Array | Matrix} b    A column vector
   * @param {Boolean} copy        Return a copy of vector b
   *
   * @return {DenseMatrix}        Dense column vector b
   */ return function solveValidation(m, b, copy) {
        var mSize = m.size();
        if (mSize.length !== 2) throw new RangeError("Matrix must be two dimensional (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(mSize) + ")");
        var rows = mSize[0];
        var columns = mSize[1];
        if (rows !== columns) throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(mSize) + ")");
        var data = [];
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(b)) {
            var bSize = b.size();
            var bdata = b._data; // 1-dim vector
            if (bSize.length === 1) {
                if (bSize[0] !== rows) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                for(var i = 0; i < rows; i++)data[i] = [
                    bdata[i]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ],
                    datatype: b._datatype
                });
            } // 2-dim column
            if (bSize.length === 2) {
                if (bSize[0] !== rows || bSize[1] !== 1) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                if ((0, $2c4f948f17aa2240$export$eb44495df7ba11d)(b)) {
                    if (copy) {
                        data = [];
                        for(var _i = 0; _i < rows; _i++)data[_i] = [
                            bdata[_i][0]
                        ];
                        return new DenseMatrix({
                            data: data,
                            size: [
                                rows,
                                1
                            ],
                            datatype: b._datatype
                        });
                    }
                    return b;
                }
                if ((0, $2c4f948f17aa2240$export$d508368d4da3c38a)(b)) {
                    for(var _i2 = 0; _i2 < rows; _i2++)data[_i2] = [
                        0
                    ];
                    var values = b._values;
                    var index = b._index;
                    var ptr = b._ptr;
                    for(var k1 = ptr[1], k = ptr[0]; k < k1; k++){
                        var _i3 = index[k];
                        data[_i3][0] = values[k];
                    }
                    return new DenseMatrix({
                        data: data,
                        size: [
                            rows,
                            1
                        ],
                        datatype: b._datatype
                    });
                }
            }
            throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
        }
        if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(b)) {
            var bsize = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(b);
            if (bsize.length === 1) {
                if (bsize[0] !== rows) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                for(var _i4 = 0; _i4 < rows; _i4++)data[_i4] = [
                    b[_i4]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            if (bsize.length === 2) {
                if (bsize[0] !== rows || bsize[1] !== 1) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                for(var _i5 = 0; _i5 < rows; _i5++)data[_i5] = [
                    b[_i5][0]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
        }
    };
}


var $6da940a9c2b9be9a$var$name = "lsolve";
var $6da940a9c2b9be9a$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $6da940a9c2b9be9a$export$1b88d04961967a10 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($6da940a9c2b9be9a$var$name, $6da940a9c2b9be9a$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $00dc5b12f1db226b$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds one solution of a linear equation system by forwards substitution. Matrix must be a lower triangular matrix. Throws an error if there's no solution.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolve(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolve(a, b)  // [[-5.5], [20]]
   *
   * See also:
   *
   *    lsolveAll, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($6da940a9c2b9be9a$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseForwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseForwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var r = _denseForwardSubstitution(m, b);
            return r.valueOf();
        }
    });
    function _denseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1]; // result
        var x = [];
        var mdata = m._data; // loop columns
        for(var j = 0; j < columns; j++){
            var bj = bdata[j][0] || 0;
            var xj = void 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = mdata[j][j];
                if (equalScalar(vjj, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                xj = divideScalar(bj, vjj); // loop rows
                for(var i = j + 1; i < rows; i++)bdata[i] = [
                    subtract(bdata[i][0] || 0, multiplyScalar(xj, mdata[i][j]))
                ];
            } else // degenerate row, we can choose any value
            xj = 0;
            x[j] = [
                xj
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // result
        var x = []; // loop columns
        for(var j = 0; j < columns; j++){
            var bj = bdata[j][0] || 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = 0; // matrix values & indices (column j)
                var jValues = [];
                var jIndices = []; // first and last index in the column
                var firstIndex = ptr[j];
                var lastIndex = ptr[j + 1]; // values in column, find value at [j, j]
                for(var k = firstIndex; k < lastIndex; k++){
                    var i = index[k]; // check row (rows are not sorted!)
                    if (i === j) vjj = values[k];
                    else if (i > j) {
                        // store lower triangular
                        jValues.push(values[k]);
                        jIndices.push(i);
                    }
                } // at this point we must have a value in vjj
                if (equalScalar(vjj, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                var xj = divideScalar(bj, vjj);
                for(var _k = 0, l = jIndices.length; _k < l; _k++){
                    var _i = jIndices[_k];
                    bdata[_i] = [
                        subtract(bdata[_i][0] || 0, multiplyScalar(xj, jValues[_k]))
                    ];
                }
                x[j] = [
                    xj
                ];
            } else // degenerate row, we can choose any value
            x[j] = [
                0
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});



var $9634d31bbd877a55$var$name = "lsolveAll";
var $9634d31bbd877a55$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $9634d31bbd877a55$export$70743fd0ad1f42d7 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($9634d31bbd877a55$var$name, $9634d31bbd877a55$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $00dc5b12f1db226b$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds all solutions of a linear equation system by forwards substitution. Matrix must be a lower triangular matrix.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolveAll(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolveAll(a, b)  // [ [[-5.5], [20]] ]
   *
   * See also:
   *
   *    lsolve, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix[] | Array[]}  An array of affine-independent column vectors (x) that solve the linear system
   */ return typed($9634d31bbd877a55$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseForwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseForwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var R = _denseForwardSubstitution(m, b);
            return R.map((r)=>r.valueOf());
        }
    });
    function _denseForwardSubstitution(m, b_) {
        // the algorithm is derived from
        // https://www.overleaf.com/read/csvgqdxggyjv
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var M = m._data;
        var rows = m._size[0];
        var columns = m._size[1]; // loop columns
        for(var i = 0; i < columns; i++){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                if (!equalScalar(M[i][i], 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], M[i][i]);
                    for(var j = i + 1; j < columns; j++)// b[j] -= b[i] * M[j,i]
                    b[j] = subtract(b[j], multiplyScalar(b[i], M[j][i]));
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j = i + 1; _j < columns; _j++)bNew[_j] = subtract(bNew[_j], M[_j][i]);
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
    function _sparseForwardSubstitution(m, b_) {
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // loop columns
        for(var i = 0; i < columns; i++){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k]; // values & indices (column i)
                var iValues = [];
                var iIndices = []; // first & last indeces in column
                var firstIndex = ptr[i];
                var lastIndex = ptr[i + 1]; // find the value at [i, i]
                var Mii = 0;
                for(var j = firstIndex; j < lastIndex; j++){
                    var J = index[j]; // check row
                    if (J === i) Mii = values[j];
                    else if (J > i) {
                        // store lower triangular
                        iValues.push(values[j]);
                        iIndices.push(J);
                    }
                }
                if (!equalScalar(Mii, 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], Mii);
                    for(var _j2 = 0, _lastIndex = iIndices.length; _j2 < _lastIndex; _j2++){
                        var _J = iIndices[_j2];
                        b[_J] = subtract(b[_J], multiplyScalar(b[i], iValues[_j2]));
                    }
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j3 = 0, _lastIndex2 = iIndices.length; _j3 < _lastIndex2; _j3++){
                        var _J2 = iIndices[_j3];
                        bNew[_J2] = subtract(bNew[_J2], iValues[_j3]);
                    }
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
});



var $5e1d678989975f92$var$name = "lup";
var $5e1d678989975f92$var$dependencies = [
    "typed",
    "matrix",
    "abs",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "larger",
    "equalScalar",
    "unaryMinus",
    "DenseMatrix",
    "SparseMatrix",
    "Spa"
];
var $5e1d678989975f92$export$86ddf344397699d5 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($5e1d678989975f92$var$name, $5e1d678989975f92$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, abs: abs, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, larger: larger, equalScalar: equalScalar, unaryMinus: unaryMinus, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, Spa: Spa } = _ref;
    /**
   * Calculate the Matrix LU decomposition with partial pivoting. Matrix `A` is decomposed in two matrices (`L`, `U`) and a
   * row permutation vector `p` where `A[p,:] = L * U`
   *
   * Syntax:
   *
   *    math.lup(A)
   *
   * Example:
   *
   *    const m = [[2, 1], [1, 4]]
   *    const r = math.lup(m)
   *    // r = {
   *    //   L: [[1, 0], [0.5, 1]],
   *    //   U: [[2, 1], [0, 3.5]],
   *    //   P: [0, 1]
   *    // }
   *
   * See also:
   *
   *    slu, lsolve, lusolve, usolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array for which to get the LUP decomposition.
   *
   * @return {{L: Array | Matrix, U: Array | Matrix, P: Array.<number>}} The lower triangular matrix, the upper triangular matrix and the permutation matrix.
   */ return typed($5e1d678989975f92$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseLUP(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseLUP(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a); // lup, use matrix implementation
            var r = _denseLUP(m); // result
            return {
                L: r.L.valueOf(),
                U: r.U.valueOf(),
                p: r.p
            };
        }
    });
    function _denseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // minimum rows and columns
        var n = Math.min(rows, columns); // matrix array, clone original data
        var data = (0, $33619877a15996ac$export$9cd59f9826255e47)(m._data); // l matrix arrays
        var ldata = [];
        var lsize = [
            rows,
            n
        ]; // u matrix arrays
        var udata = [];
        var usize = [
            n,
            columns
        ]; // vars
        var i, j, k; // permutation vector
        var p = [];
        for(i = 0; i < rows; i++)p[i] = i;
         // loop columns
        for(j = 0; j < columns; j++){
            // skip first column in upper triangular matrix
            if (j > 0) // loop rows
            for(i = 0; i < rows; i++){
                // min i,j
                var min = Math.min(i, j); // v[i, j]
                var s = 0; // loop up to min
                for(k = 0; k < min; k++)// s = l[i, k] - data[k, j]
                s = addScalar(s, multiplyScalar(data[i][k], data[k][j]));
                data[i][j] = subtract(data[i][j], s);
            }
             // row with larger value in cvector, row >= j
            var pi = j;
            var pabsv = 0;
            var vjj = 0; // loop rows
            for(i = j; i < rows; i++){
                // data @ i, j
                var v = data[i][j]; // absolute value
                var absv = abs(v); // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = i; // update max value
                    pabsv = absv; // value @ [j, j]
                    vjj = v;
                }
            } // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in p
                p[j] = [
                    p[pi],
                    p[pi] = p[j]
                ][0]; // swap j <-> pi in data
                DenseMatrix._swapRows(j, pi, data);
            } // check column is in lower triangular matrix
            if (j < rows) // loop rows (lower triangular matrix)
            for(i = j + 1; i < rows; i++){
                // value @ i, j
                var vij = data[i][j];
                if (!equalScalar(vij, 0)) // update data
                data[i][j] = divideScalar(data[i][j], vjj);
            }
        } // loop columns
        for(j = 0; j < columns; j++)// loop rows
        for(i = 0; i < rows; i++){
            // initialize row in arrays
            if (j === 0) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i] = [];
                 // L
                ldata[i] = [];
            } // check we are in the upper triangular matrix
            if (i < j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                 // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 0;
                continue;
            } // diagonal value
            if (i === j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                 // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 1;
                continue;
            } // check row exists in upper triangular matrix
            if (i < columns) // U
            udata[i][j] = 0;
             // check column exists in lower triangular matrix
            if (j < rows) // L
            ldata[i][j] = data[i][j];
        }
         // l matrix
        var l = new DenseMatrix({
            data: ldata,
            size: lsize
        }); // u matrix
        var u = new DenseMatrix({
            data: udata,
            size: usize
        }); // p vector
        var pv = [];
        for(i = 0, n = p.length; i < n; i++)pv[p[i]] = i;
         // return matrices
        return {
            L: l,
            U: u,
            p: pv,
            toString: function toString() {
                return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
            }
        };
    }
    function _sparseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // minimum rows and columns
        var n = Math.min(rows, columns); // matrix arrays (will not be modified, thanks to permutation vector)
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // l matrix arrays
        var lvalues = [];
        var lindex = [];
        var lptr = [];
        var lsize = [
            rows,
            n
        ]; // u matrix arrays
        var uvalues = [];
        var uindex = [];
        var uptr = [];
        var usize = [
            n,
            columns
        ]; // vars
        var i, j, k; // permutation vectors, (current index -> original index) and (original index -> current index)
        var pvCo = [];
        var pvOc = [];
        for(i = 0; i < rows; i++){
            pvCo[i] = i;
            pvOc[i] = i;
        } // swap indices in permutation vectors (condition x < y)!
        var swapIndeces = function swapIndeces(x, y) {
            // find pv indeces getting data from x and y
            var kx = pvOc[x];
            var ky = pvOc[y]; // update permutation vector current -> original
            pvCo[kx] = y;
            pvCo[ky] = x; // update permutation vector original -> current
            pvOc[x] = ky;
            pvOc[y] = kx;
        }; // loop columns
        var _loop = function _loop() {
            // sparse accumulator
            var spa = new Spa(); // check lower triangular matrix has a value @ column j
            if (j < rows) {
                // update ptr
                lptr.push(lvalues.length); // first value in j column for lower triangular matrix
                lvalues.push(1);
                lindex.push(j);
            } // update ptr
            uptr.push(uvalues.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // copy column j into sparse accumulator
            for(k = k0; k < k1; k++){
                // row
                i = index[k]; // copy column values into sparse accumulator (use permutation vector)
                spa.set(pvCo[i], values[k]);
            } // skip first column in upper triangular matrix
            if (j > 0) // loop rows in column j (above diagonal)
            spa.forEach(0, j - 1, function(k, vkj) {
                // loop rows in column k (L)
                SparseMatrix._forEachRow(k, lvalues, lindex, lptr, function(i, vik) {
                    // check row is below k
                    if (i > k) // update spa value
                    spa.accumulate(i, unaryMinus(multiplyScalar(vik, vkj)));
                });
            });
             // row with larger value in spa, row >= j
            var pi = j;
            var vjj = spa.get(j);
            var pabsv = abs(vjj); // loop values in spa (order by row, below diagonal)
            spa.forEach(j + 1, rows - 1, function(x, v) {
                // absolute value
                var absv = abs(v); // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = x; // update max value
                    pabsv = absv; // value @ [j, j]
                    vjj = v;
                }
            }); // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in L
                SparseMatrix._swapRows(j, pi, lsize[1], lvalues, lindex, lptr); // swap values j <-> pi in U
                SparseMatrix._swapRows(j, pi, usize[1], uvalues, uindex, uptr); // swap values in spa
                spa.swap(j, pi); // update permutation vector (swap values @ j, pi)
                swapIndeces(j, pi);
            } // loop values in spa (order by row)
            spa.forEach(0, rows - 1, function(x, v) {
                // check we are above diagonal
                if (x <= j) {
                    // update upper triangular matrix
                    uvalues.push(v);
                    uindex.push(x);
                } else {
                    // update value
                    v = divideScalar(v, vjj); // check value is non zero
                    if (!equalScalar(v, 0)) {
                        // update lower triangular matrix
                        lvalues.push(v);
                        lindex.push(x);
                    }
                }
            });
        };
        for(j = 0; j < columns; j++)_loop();
         // update ptrs
        uptr.push(uvalues.length);
        lptr.push(lvalues.length); // return matrices
        return {
            L: new SparseMatrix({
                values: lvalues,
                index: lindex,
                ptr: lptr,
                size: lsize
            }),
            U: new SparseMatrix({
                values: uvalues,
                index: uindex,
                ptr: uptr,
                size: usize
            }),
            p: pvCo,
            toString: function toString() {
                return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
            }
        };
    }
});




/**
 * Permutes a vector; x = P'b. In MATLAB notation, x(p)=b.
 *
 * @param {Array} p           The permutation vector of length n. null value denotes identity
 * @param {Array} b           The input vector
 *
 * @return {Array}            The output vector x = P'b
 */ function $f290a1dcf61c518e$export$29cc81cfd083fd62(p, b) {
    // vars
    var k;
    var n = b.length;
    var x = []; // check permutation vector was provided, p = null denotes identity
    if (p) // loop vector
    for(k = 0; k < n; k++)// apply permutation
    x[p[k]] = b[k];
    else // loop vector
    for(k = 0; k < n; k++)// x[i] = b[i]
    x[k] = b[k];
    return x;
}


var $cdf4478490d5b2ea$var$name = "lusolve";
var $cdf4478490d5b2ea$var$dependencies = [
    "typed",
    "matrix",
    "lup",
    "slu",
    "usolve",
    "lsolve",
    "DenseMatrix"
];
var $cdf4478490d5b2ea$export$a3f0777edf21dcd5 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($cdf4478490d5b2ea$var$name, $cdf4478490d5b2ea$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, lup: lup, slu: slu, usolve: usolve, lsolve: lsolve, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $00dc5b12f1db226b$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Solves the linear system `A * x = b` where `A` is an [n x n] matrix and `b` is a [n] column vector.
   *
   * Syntax:
   *
   *    math.lusolve(A, b)     // returns column vector with the solution to the linear system A * x = b
   *    math.lusolve(lup, b)   // returns column vector with the solution to the linear system A * x = b, lup = math.lup(A)
   *
   * Examples:
   *
   *    const m = [[1, 0, 0, 0], [0, 2, 0, 0], [0, 0, 3, 0], [0, 0, 0, 4]]
   *
   *    const x = math.lusolve(m, [-1, -1, -1, -1])        // x = [[-1], [-0.5], [-1/3], [-0.25]]
   *
   *    const f = math.lup(m)
   *    const x1 = math.lusolve(f, [-1, -1, -1, -1])       // x1 = [[-1], [-0.5], [-1/3], [-0.25]]
   *    const x2 = math.lusolve(f, [1, 2, 1, -1])          // x2 = [[1], [1], [1/3], [-0.25]]
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = math.lusolve(a, b)  // [[2], [5]]
   *
   * See also:
   *
   *    lup, slu, lsolve, usolve
   *
   * @param {Matrix | Array | Object} A      Invertible Matrix or the Matrix LU decomposition
   * @param {Matrix | Array} b               Column Vector
   * @param {number} [order]                 The Symbolic Ordering and Analysis order, see slu for details. Matrix must be a SparseMatrix
   * @param {Number} [threshold]             Partial pivoting threshold (1 for partial pivoting), see slu for details. Matrix must be a SparseMatrix.
   *
   * @return {DenseMatrix | Array}           Column vector with the solution to the linear system A * x = b
   */ return typed($cdf4478490d5b2ea$var$name, {
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            a = matrix(a);
            var d = lup(a);
            var x = _lusolve(d.L, d.U, d.p, null, b);
            return x.valueOf();
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(a, b) {
            var d = lup(a);
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(a, b) {
            var d = lup(a);
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        "SparseMatrix, Array | Matrix, number, number": function SparseMatrixArrayMatrixNumberNumber(a, b, order, threshold) {
            var d = slu(a, order, threshold);
            return _lusolve(d.L, d.U, d.p, d.q, b);
        },
        "Object, Array | Matrix": function ObjectArrayMatrix(d, b) {
            return _lusolve(d.L, d.U, d.p, d.q, b);
        }
    });
    function _toMatrix(a) {
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(a)) return a;
        if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(a)) return matrix(a);
        throw new TypeError("Invalid Matrix LU decomposition");
    }
    function _lusolve(l, u, p, q, b) {
        // verify decomposition
        l = _toMatrix(l);
        u = _toMatrix(u); // apply row permutations if needed (b is a DenseMatrix)
        if (p) {
            b = solveValidation(l, b, true);
            b._data = (0, $f290a1dcf61c518e$export$29cc81cfd083fd62)(p, b._data);
        } // use forward substitution to resolve L * y = b
        var y = lsolve(l, b); // use backward substitution to resolve U * x = y
        var x = usolve(u, y); // apply column permutations if needed (x is a DenseMatrix)
        if (q) x._data = (0, $f290a1dcf61c518e$export$29cc81cfd083fd62)(q, x._data);
        return x;
    }
});




var $0856b6f5f0c05256$var$name = "mad";
var $0856b6f5f0c05256$var$dependencies = [
    "typed",
    "abs",
    "map",
    "median",
    "subtract"
];
var $0856b6f5f0c05256$export$7b17fbe41c88575a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($0856b6f5f0c05256$var$name, $0856b6f5f0c05256$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, map: map, median: median, subtract: subtract } = _ref;
    /**
   * Compute the median absolute deviation of a matrix or a list with values.
   * The median absolute deviation is defined as the median of the absolute
   * deviations from the median.
   *
   * Syntax:
   *
   *     math.mad(a, b, c, ...)
   *     math.mad(A)
   *
   * Examples:
   *
   *     math.mad(10, 20, 30)             // returns 10
   *     math.mad([1, 2, 3])              // returns 1
   *     math.mad([[1, 2, 3], [4, 5, 6]]) // returns 1.5
   *
   * See also:
   *
   *     median, mean, std, abs
   *
   * @param {Array | Matrix} array
   *                        A single matrix or multiple scalar values.
   * @return {*} The median absolute deviation.
   */ return typed($0856b6f5f0c05256$var$name, {
        // mad([a, b, c, d, ...])
        "Array | Matrix": _mad,
        // mad(a, b, c, d, ...)
        "...": function _(args) {
            return _mad(args);
        }
    });
    function _mad(array) {
        array = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(array.valueOf());
        if (array.length === 0) throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
        try {
            var med = median(array);
            return median(map(array, function(value) {
                return abs(subtract(value, med));
            }));
        } catch (err) {
            if (err instanceof TypeError && err.message.indexOf("median") !== -1) throw new TypeError(err.message.replace("median", "mad"));
            else throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "mad");
        }
    }
});



var $5b257b6b328906b9$var$name = "map";
var $5b257b6b328906b9$var$dependencies = [
    "typed"
];
var $5b257b6b328906b9$export$d49c9aa30b771d59 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($5b257b6b328906b9$var$name, $5b257b6b328906b9$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a new matrix or array with the results of a callback function executed on
   * each entry of a given matrix/array.
   *
   * For each entry of the input, the callback is invoked with three arguments:
   * the value of the entry, the index at which that entry occurs, and the full
   * matrix/array being traversed. Note that because the matrix/array might be
   * multidimensional, the "index" argument is always an array of numbers giving
   * the index in each dimension. This is true even for vectors: the "index"
   * argument is an array of length 1, rather than simply a number.
   *
   * Syntax:
   *
   *    math.map(x, callback)
   *
   * Examples:
   *
   *    math.map([1, 2, 3], function(value) {
   *      return value * value
   *    })  // returns [1, 4, 9]
   *
   *    // The calling convention for the callback can cause subtleties:
   *    math.map([1, 2, 3], math.format)
   *    // throws TypeError: map attempted to call 'format(1,[0])' but argument 2 of type Array does not match expected type number or function or Object or string or boolean
   *    // [This happens because `format` _can_ take a second argument,
   *    // but its semantics don't match that of the 2nd argument `map` provides]
   *
   *    // To avoid this error, use a function that takes exactly the
   *    // desired arguments:
   *    math.map([1, 2, 3], x => math.format(x)) // returns ['1', '2', '3']
   *
   * See also:
   *
   *    filter, forEach, sort
   *
   * @param {Matrix | Array} x    The input to iterate on.
   * @param {Function} callback
   *     The function to call (as described above) on each entry of the input
   * @return {Matrix | array}
   *     Transformed map of x; always has the same type and shape as x
   */ return typed($5b257b6b328906b9$var$name, {
        "Array, function": $5b257b6b328906b9$var$_map,
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.map(callback);
        }
    });
});
/**
 * Map for a multi dimensional array
 * @param {Array} array
 * @param {Function} callback
 * @return {Array}
 * @private
 */ function $5b257b6b328906b9$var$_map(array, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $43b7a970faec5d37$export$6c00fba23f8c91a7)(callback);
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) return value.map(function(child, i) {
            // we create a copy of the index array and append the new index value
            return recurse(child, index.concat(i));
        });
        else try {
            // invoke the callback function with the right number of arguments
            if (args === 1) return callback(value);
            else if (args === 2) return callback(value, index);
            else // 3 or -1
            return callback(value, index, array);
        } catch (err) {
            // But maybe the arguments still weren't right
            if (err instanceof TypeError && "data" in err && err.data.category === "wrongType") {
                var newmsg = "map attempted to call '".concat(err.data.fn, "(").concat(value);
                var indexString = JSON.stringify(index);
                if (args === 2) newmsg += "," + indexString;
                else if (args !== 1) newmsg += ",".concat(indexString, ",").concat(array);
                newmsg += ")' but argument ".concat(err.data.index + 1, " of type ");
                newmsg += "".concat(err.data.actual, " does not match expected type ");
                newmsg += err.data.expected.join(" or ");
                throw new TypeError(newmsg);
            }
            throw err;
        }
    };
    return recurse(array, []);
}


var $199f1076ce182c10$var$name = "matrix";
var $199f1076ce182c10$var$dependencies = [
    "typed",
    "Matrix",
    "DenseMatrix",
    "SparseMatrix"
];
var $199f1076ce182c10$export$f3cf8b510f9cb8ab = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($199f1076ce182c10$var$name, $199f1076ce182c10$var$dependencies, (_ref)=>{
    var { typed: typed, Matrix: Matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   * Supported storage formats are 'dense' and 'sparse'.
   *
   * Syntax:
   *
   *    math.matrix()                         // creates an empty matrix using default storage format (dense).
   *    math.matrix(data)                     // creates a matrix with initial data using default storage format (dense).
   *    math.matrix('dense')                  // creates an empty matrix using the given storage format.
   *    math.matrix(data, 'dense')            // creates a matrix with initial data using the given storage format.
   *    math.matrix(data, 'sparse')           // creates a sparse matrix with initial data.
   *    math.matrix(data, 'sparse', 'number') // creates a sparse matrix with initial data, number data type.
   *
   * Examples:
   *
   *    let m = math.matrix([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, sparse
   *
   * @param {Array | Matrix} [data]    A multi dimensional array
   * @param {string} [format]          The Matrix storage format, either `'dense'` or `'sparse'`
   * @param {string} [datatype]        Type of the values
   *
   * @return {Matrix} The created matrix
   */ return typed($199f1076ce182c10$var$name, {
        "": function _() {
            return _create([]);
        },
        string: function string(format) {
            return _create([], format);
        },
        "string, string": function stringString(format, datatype) {
            return _create([], format, datatype);
        },
        Array: function Array(data) {
            return _create(data);
        },
        Matrix: function Matrix(data) {
            return _create(data, data.storage());
        },
        "Array | Matrix, string": _create,
        "Array | Matrix, string, string": _create
    });
    /**
   * Create a new Matrix with given storage format
   * @param {Array} data
   * @param {string} [format]
   * @param {string} [datatype]
   * @returns {Matrix} Returns a new Matrix
   * @private
   */ function _create(data, format, datatype) {
        // get storage format constructor
        if (format === "dense" || format === "default" || format === undefined) return new DenseMatrix(data, datatype);
        if (format === "sparse") return new SparseMatrix(data, datatype);
        throw new TypeError("Unknown matrix type " + JSON.stringify(format) + ".");
    }
});


var $93edf6af35216078$var$name = "Matrix";
var $93edf6af35216078$var$dependencies = [];
var $93edf6af35216078$export$72d485cc3ed6a97a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($93edf6af35216078$var$name, $93edf6af35216078$var$dependencies, ()=>{
    /**
   * @constructor Matrix
   *
   * A Matrix is a wrapper around an Array. A matrix can hold a multi dimensional
   * array. A matrix can be constructed as:
   *
   *     let matrix = math.matrix(data)
   *
   * Matrix contains the functions to resize, get and set values, get the size,
   * clone the matrix and to convert the matrix to a vector, array, or scalar.
   * Furthermore, one can iterate over the matrix using map and forEach.
   * The internal Array of the Matrix can be accessed using the function valueOf.
   *
   * Example usage:
   *
   *     let matrix = math.matrix([[1, 2], [3, 4]])
   *     matix.size()              // [2, 2]
   *     matrix.resize([3, 2], 5)
   *     matrix.valueOf()          // [[1, 2], [3, 4], [5, 5]]
   *     matrix.subset([1,2])       // 3 (indexes are zero-based)
   *
   */ function Matrix() {
        if (!(this instanceof Matrix)) throw new SyntaxError("Constructor must be called with the new operator");
    }
    /**
   * Attach type information
   */ Matrix.prototype.type = "Matrix";
    Matrix.prototype.isMatrix = true;
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @return {string}           The storage format.
   */ Matrix.prototype.storage = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke storage on a Matrix interface");
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @return {string}           The datatype.
   */ Matrix.prototype.datatype = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke datatype on a Matrix interface");
    };
    /**
   * Create a new Matrix With the type of the current matrix instance
   * @param {Array | Object} data
   * @param {string} [datatype]
   */ Matrix.prototype.create = function(data, datatype) {
        throw new Error("Cannot invoke create on a Matrix interface");
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ Matrix.prototype.subset = function(index, replacement, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke subset on a Matrix interface");
    };
    /**
   * Get a single element from the matrix.
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ Matrix.prototype.get = function(index) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke get on a Matrix interface");
    };
    /**
   * Replace a single element in the matrix.
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {Matrix} self
   */ Matrix.prototype.set = function(index, value, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke set on a Matrix interface");
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ Matrix.prototype.resize = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke resize on a Matrix interface");
    };
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ Matrix.prototype.reshape = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke reshape on a Matrix interface");
    };
    /**
   * Create a clone of the matrix
   * @return {Matrix} clone
   */ Matrix.prototype.clone = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke clone on a Matrix interface");
    };
    /**
   * Retrieve the size of the matrix.
   * @returns {number[]} size
   */ Matrix.prototype.size = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke size on a Matrix interface");
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {Matrix} matrix
   */ Matrix.prototype.map = function(callback, skipZeros) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke map on a Matrix interface");
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ Matrix.prototype.forEach = function(callback) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke forEach on a Matrix interface");
    };
    /**
   * Iterate over the matrix elements
   * @return {Iterable<{ value, index: number[] }>}
   */ Matrix.prototype[Symbol.iterator] = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot iterate a Matrix interface");
    };
    /**
   * Create an Array with a copy of the data of the Matrix
   * @returns {Array} array
   */ Matrix.prototype.toArray = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke toArray on a Matrix interface");
    };
    /**
   * Get the primitive value of the Matrix: a multidimensional array
   * @returns {Array} array
   */ Matrix.prototype.valueOf = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke valueOf on a Matrix interface");
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Matrix.prototype.format = function(options) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke format on a Matrix interface");
    };
    /**
   * Get a string representation of the matrix
   * @returns {string} str
   */ Matrix.prototype.toString = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke toString on a Matrix interface");
    };
    return Matrix;
}, {
    isClass: true
});


var $08e848efca6908c4$var$name = "matrixFromColumns";
var $08e848efca6908c4$var$dependencies = [
    "typed",
    "matrix",
    "flatten",
    "size"
];
var $08e848efca6908c4$export$65fefc9f63da4d13 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($08e848efca6908c4$var$name, $08e848efca6908c4$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, flatten: flatten, size: size } = _ref;
    /**
   * Create a dense matrix from vectors as individual columns.
   * If you pass row vectors, they will be transposed (but not conjugated!)
   *
   * Syntax:
   *
   *    math.matrixFromColumns(...arr)
   *    math.matrixFromColumns(col1, col2)
   *    math.matrixFromColumns(col1, col2, col3)
   *
   * Examples:
   *
   *    math.matrixFromColumns([1, 2, 3], [[4],[5],[6]])
   *    math.matrixFromColumns(...vectors)
   *
   * See also:
   *
   *    matrix, matrixFromRows, matrixFromFunction, zeros
   *
   * @param {... Array | Matrix} cols Multiple columns
   * @return { number[][] | Matrix } if at least one of the arguments is an array, an array will be returned
   */ return typed($08e848efca6908c4$var$name, {
        "...Array": function Array(arr) {
            return _createArray(arr);
        },
        "...Matrix": function Matrix(arr) {
            return matrix(_createArray(arr.map((m)=>m.toArray())));
        } // TODO implement this properly for SparseMatrix
    });
    function _createArray(arr) {
        if (arr.length === 0) throw new TypeError("At least one column is needed to construct a matrix.");
        var N = checkVectorTypeAndReturnLength(arr[0]); // create an array with empty rows
        var result = [];
        for(var i = 0; i < N; i++)result[i] = [];
         // loop columns
        for (var col of arr){
            var colLength = checkVectorTypeAndReturnLength(col);
            if (colLength !== N) throw new TypeError("The vectors had different length: " + (N | 0) + " \u2260 " + (colLength | 0));
            var f = flatten(col); // push a value to each row
            for(var _i = 0; _i < N; _i++)result[_i].push(f[_i]);
        }
        return result;
    }
    function checkVectorTypeAndReturnLength(vec) {
        var s = size(vec);
        if (s.length === 1) // 1D vector
        return s[0];
        else if (s.length === 2) {
            // 2D vector
            if (s[0] === 1) // row vector
            return s[1];
            else if (s[1] === 1) // col vector
            return s[0];
            else throw new TypeError("At least one of the arguments is not a vector.");
        } else throw new TypeError("Only one- or two-dimensional vectors are supported.");
    }
});


var $9c8650853386b120$var$name = "matrixFromFunction";
var $9c8650853386b120$var$dependencies = [
    "typed",
    "matrix",
    "isZero"
];
var $9c8650853386b120$export$983d2c97138363e0 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($9c8650853386b120$var$name, $9c8650853386b120$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isZero: isZero } = _ref;
    /**
   * Create a matrix by evaluating a generating function at each index.
   * The simplest overload returns a multi-dimensional array as long as `size` is an array.
   * Passing `size` as a Matrix or specifying a `format` will result in returning a Matrix.
   *
   * Syntax:
   *
   *    math.matrixFromFunction(size, fn)
   *    math.matrixFromFunction(size, fn, format)
   *    math.matrixFromFunction(size, fn, format, datatype)
   *    math.matrixFromFunction(size, format, fn)
   *    math.matrixFromFunction(size, format, datatype, fn)
   *
   * Examples:
   *
   *    math.matrixFromFunction([3,3], i => i[0] - i[1]) // an antisymmetric matrix
   *    math.matrixFromFunction([100, 100], 'sparse', i => i[0] - i[1] === 1 ? 4 : 0) // a sparse subdiagonal matrix
   *    math.matrixFromFunction([5], i => math.random()) // a random vector
   *
   * See also:
   *
   *    matrix, zeros
   *
   * @param {Array | Matrix} size   The size of the matrix to be created
   * @param {function} fn           Callback function invoked for every entry in the matrix
   * @param {string} [format]       The Matrix storage format, either `'dense'` or `'sparse'`
   * @param {string} [datatype]     Type of the values
   * @return {Array | Matrix} Returns the created matrix
   */ return typed($9c8650853386b120$var$name, {
        "Array | Matrix, function, string, string": function ArrayMatrixFunctionStringString(size, fn, format, datatype) {
            return _create(size, fn, format, datatype);
        },
        "Array | Matrix, function, string": function ArrayMatrixFunctionString(size, fn, format) {
            return _create(size, fn, format);
        },
        "Matrix, function": function MatrixFunction(size, fn) {
            return _create(size, fn, "dense");
        },
        "Array, function": function ArrayFunction(size, fn) {
            return _create(size, fn, "dense").toArray();
        },
        "Array | Matrix, string, function": function ArrayMatrixStringFunction(size, format, fn) {
            return _create(size, fn, format);
        },
        "Array | Matrix, string, string, function": function ArrayMatrixStringStringFunction(size, format, datatype, fn) {
            return _create(size, fn, format, datatype);
        }
    });
    function _create(size, fn, format, datatype) {
        var m;
        if (datatype !== undefined) m = matrix(format, datatype);
        else m = matrix(format);
        m.resize(size);
        m.forEach(function(_, index) {
            var val = fn(index);
            if (isZero(val)) return;
            m.set(index, val);
        });
        return m;
    }
});


var $684d6e0dd088a86f$var$name = "matrixFromRows";
var $684d6e0dd088a86f$var$dependencies = [
    "typed",
    "matrix",
    "flatten",
    "size"
];
var $684d6e0dd088a86f$export$b72d61f960d7c36b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($684d6e0dd088a86f$var$name, $684d6e0dd088a86f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, flatten: flatten, size: size } = _ref;
    /**
   * Create a dense matrix from vectors as individual rows.
   * If you pass column vectors, they will be transposed (but not conjugated!)
   *
   * Syntax:
   *
   *    math.matrixFromRows(...arr)
   *    math.matrixFromRows(row1, row2)
   *    math.matrixFromRows(row1, row2, row3)
   *
   * Examples:
   *
   *    math.matrixFromRows([1, 2, 3], [[4],[5],[6]])
   *    math.matrixFromRows(...vectors)
   *
   * See also:
   *
   *    matrix, matrixFromColumns, matrixFromFunction, zeros
   *
   * @param {... Array | Matrix} rows  Multiple rows
   * @return { number[][] | Matrix } if at least one of the arguments is an array, an array will be returned
   */ return typed($684d6e0dd088a86f$var$name, {
        "...Array": function Array(arr) {
            return _createArray(arr);
        },
        "...Matrix": function Matrix(arr) {
            return matrix(_createArray(arr.map((m)=>m.toArray())));
        } // TODO implement this properly for SparseMatrix
    });
    function _createArray(arr) {
        if (arr.length === 0) throw new TypeError("At least one row is needed to construct a matrix.");
        var N = checkVectorTypeAndReturnLength(arr[0]);
        var result = [];
        for (var row of arr){
            var rowLength = checkVectorTypeAndReturnLength(row);
            if (rowLength !== N) throw new TypeError("The vectors had different length: " + (N | 0) + " \u2260 " + (rowLength | 0));
            result.push(flatten(row));
        }
        return result;
    }
    function checkVectorTypeAndReturnLength(vec) {
        var s = size(vec);
        if (s.length === 1) // 1D vector
        return s[0];
        else if (s.length === 2) {
            // 2D vector
            if (s[0] === 1) // row vector
            return s[1];
            else if (s[1] === 1) // col vector
            return s[0];
            else throw new TypeError("At least one of the arguments is not a vector.");
        } else throw new TypeError("Only one- or two-dimensional vectors are supported.");
    }
});




var $cba3fdd1ff2350ea$var$name = "max";
var $cba3fdd1ff2350ea$var$dependencies = [
    "typed",
    "config",
    "numeric",
    "larger"
];
var $cba3fdd1ff2350ea$export$b18a1b0c26c000ee = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($cba3fdd1ff2350ea$var$name, $cba3fdd1ff2350ea$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, larger: larger } = _ref;
    /**
   * Compute the maximum value of a matrix or a  list with values.
   * In case of a multi dimensional array, the maximum of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.max(a, b, c, ...)
   *     math.max(A)
   *     math.max(A, dim)
   *
   * Examples:
   *
   *     math.max(2, 1, 4, 3)                  // returns 4
   *     math.max([2, 1, 4, 3])                // returns 4
   *
   *     // maximum over a specified dimension (zero-based)
   *     math.max([[2, 5], [4, 3], [1, 7]], 0) // returns [4, 7]
   *     math.max([[2, 5], [4, 3]], [1, 7], 1) // returns [5, 4, 7]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, min, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The maximum value
   */ return typed($cba3fdd1ff2350ea$var$name, {
        // max([a, b, c, d, ...])
        "Array | Matrix": _max,
        // max([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $cd13353fc76500f7$export$533b26079ad0b4b)(array, dim.valueOf(), _largest);
        },
        // max(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $cd13353fc76500f7$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function max");
            return _max(args);
        }
    });
    /**
   * Return the largest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is largest, or y when y is largest
   * @private
   */ function _largest(x, y) {
        try {
            return larger(x, y) ? x : y;
        } catch (err) {
            throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "max", y);
        }
    }
    /**
   * Recursively calculate the maximum value in an n-dimensional array
   * @param {Array} array
   * @return {number} max
   * @private
   */ function _max(array) {
        var res;
        (0, $cd13353fc76500f7$export$519ada94592b97fc)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === "number") res = NaN;
                else if (res === undefined || larger(value, res)) res = value;
            } catch (err) {
                throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "max", value);
            }
        });
        if (res === undefined) throw new Error("Cannot calculate max of an empty array");
         // make sure returning numeric value: parse a string into a numeric value
        if (typeof res === "string") res = numeric(res, config.number);
        return res;
    }
});





var $10a1e69809a3890c$var$name = "mean";
var $10a1e69809a3890c$var$dependencies = [
    "typed",
    "add",
    "divide"
];
var $10a1e69809a3890c$export$301ef7ca1de6782c = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($10a1e69809a3890c$var$name, $10a1e69809a3890c$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide } = _ref;
    /**
   * Compute the mean value of matrix or a list with values.
   * In case of a multi dimensional array, the mean of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.mean(a, b, c, ...)
   *     math.mean(A)
   *     math.mean(A, dim)
   *
   * Examples:
   *
   *     math.mean(2, 1, 4, 3)                     // returns 2.5
   *     math.mean([1, 2.7, 3.2, 4])               // returns 2.725
   *
   *     math.mean([[2, 5], [6, 3], [1, 7]], 0)    // returns [3, 5]
   *     math.mean([[2, 5], [6, 3], [1, 7]], 1)    // returns [3.5, 4.5, 4]
   *
   * See also:
   *
   *     median, min, max, sum, prod, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The mean of all values
   */ return typed($10a1e69809a3890c$var$name, {
        // mean([a, b, c, d, ...])
        "Array | Matrix": _mean,
        // mean([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": _nmeanDim,
        // mean(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $cd13353fc76500f7$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function mean");
            return _mean(args);
        }
    });
    /**
   * Calculate the mean value in an n-dimensional array, returning a
   * n-1 dimensional array
   * @param {Array} array
   * @param {number} dim
   * @return {number} mean
   * @private
   */ function _nmeanDim(array, dim) {
        try {
            var sum = (0, $cd13353fc76500f7$export$533b26079ad0b4b)(array, dim, add);
            var s = Array.isArray(array) ? (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(array) : array.size();
            return divide(sum, s[dim]);
        } catch (err) {
            throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "mean");
        }
    }
    /**
   * Recursively calculate the mean value in an n-dimensional array
   * @param {Array} array
   * @return {number} mean
   * @private
   */ function _mean(array) {
        var sum;
        var num = 0;
        (0, $cd13353fc76500f7$export$519ada94592b97fc)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "mean", value);
            }
        });
        if (num === 0) throw new Error("Cannot calculate the mean of an empty array");
        return divide(sum, num);
    }
});





var $41f4212f7361dbfc$var$name = "median";
var $41f4212f7361dbfc$var$dependencies = [
    "typed",
    "add",
    "divide",
    "compare",
    "partitionSelect"
];
var $41f4212f7361dbfc$export$cdebf3fc89add777 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($41f4212f7361dbfc$var$name, $41f4212f7361dbfc$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide, compare: compare, partitionSelect: partitionSelect } = _ref;
    /**
   * Recursively calculate the median of an n-dimensional array
   * @param {Array} array
   * @return {Number} median
   * @private
   */ function _median(array) {
        try {
            array = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(array.valueOf());
            var num = array.length;
            if (num === 0) throw new Error("Cannot calculate median of an empty array");
            if (num % 2 === 0) {
                // even: return the average of the two middle values
                var mid = num / 2 - 1;
                var right = partitionSelect(array, mid + 1); // array now partitioned at mid + 1, take max of left part
                var left = array[mid];
                for(var i = 0; i < mid; ++i)if (compare(array[i], left) > 0) left = array[i];
                return middle2(left, right);
            } else {
                // odd: return the middle value
                var m = partitionSelect(array, (num - 1) / 2);
                return middle(m);
            }
        } catch (err) {
            throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "median");
        }
    } // helper function to type check the middle value of the array
    var middle = typed({
        "number | BigNumber | Complex | Unit": function numberBigNumberComplexUnit(value) {
            return value;
        }
    }); // helper function to type check the two middle value of the array
    var middle2 = typed({
        "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function numberBigNumberComplexUnitNumberBigNumberComplexUnit(left, right) {
            return divide(add(left, right), 2);
        }
    });
    /**
   * Compute the median of a matrix or a list with values. The values are
   * sorted and the middle value is returned. In case of an even number of
   * values, the average of the two middle values is returned.
   * Supported types of values are: Number, BigNumber, Unit
   *
   * In case of a (multi dimensional) array or matrix, the median of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.median(a, b, c, ...)
   *     math.median(A)
   *
   * Examples:
   *
   *     math.median(5, 2, 7)        // returns 5
   *     math.median([3, -1, 5, 7])  // returns 4
   *
   * See also:
   *
   *     mean, min, max, sum, prod, std, variance, quantileSeq
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The median
   */ return typed($41f4212f7361dbfc$var$name, {
        // median([a, b, c, d, ...])
        "Array | Matrix": _median,
        // median([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement median(A, dim)
            throw new Error("median(A, dim) is not yet supported"); // return reduce(arguments[0], arguments[1], ...)
        },
        // median(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $cd13353fc76500f7$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function median");
            return _median(args);
        }
    });
});




var $6c5d3a7a97f7f6e5$var$name = "min";
var $6c5d3a7a97f7f6e5$var$dependencies = [
    "typed",
    "config",
    "numeric",
    "smaller"
];
var $6c5d3a7a97f7f6e5$export$b795f47e2b99170 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($6c5d3a7a97f7f6e5$var$name, $6c5d3a7a97f7f6e5$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, smaller: smaller } = _ref;
    /**
   * Compute the minimum value of a matrix or a  list of values.
   * In case of a multi dimensional array, the minimum of the flattened array
   * will be calculated. When `dim` is provided, the minimum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.min(a, b, c, ...)
   *     math.min(A)
   *     math.min(A, dim)
   *
   * Examples:
   *
   *     math.min(2, 1, 4, 3)                  // returns 1
   *     math.min([2, 1, 4, 3])                // returns 1
   *
   *     // minimum over a specified dimension (zero-based)
   *     math.min([[2, 5], [4, 3], [1, 7]], 0) // returns [1, 3]
   *     math.min([[2, 5], [4, 3], [1, 7]], 1) // returns [2, 3, 1]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, max, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The minimum value
   */ return typed($6c5d3a7a97f7f6e5$var$name, {
        // min([a, b, c, d, ...])
        "Array | Matrix": _min,
        // min([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $cd13353fc76500f7$export$533b26079ad0b4b)(array, dim.valueOf(), _smallest);
        },
        // min(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $cd13353fc76500f7$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function min");
            return _min(args);
        }
    });
    /**
   * Return the smallest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is smallest, or y when y is smallest
   * @private
   */ function _smallest(x, y) {
        try {
            return smaller(x, y) ? x : y;
        } catch (err) {
            throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "min", y);
        }
    }
    /**
   * Recursively calculate the minimum value in an n-dimensional array
   * @param {Array} array
   * @return {number} min
   * @private
   */ function _min(array) {
        var min;
        (0, $cd13353fc76500f7$export$519ada94592b97fc)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === "number") min = NaN;
                else if (min === undefined || smaller(value, min)) min = value;
            } catch (err) {
                throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "min", value);
            }
        });
        if (min === undefined) throw new Error("Cannot calculate min of an empty array");
         // make sure returning numeric value: parse a string into a numeric value
        if (typeof min === "string") min = numeric(min, config.number);
        return min;
    }
});










var $fa3529761d10d542$var$name = "mod";
var $fa3529761d10d542$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $fa3529761d10d542$export$735bb6c30160c058 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($fa3529761d10d542$var$name, $fa3529761d10d542$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm02 = (0, $b6b1cd490ad9f946$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm05 = (0, $a7b97f0cac0b5286$export$f80c3080566d43b4)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculates the modulus, the remainder of an integer division.
   *
   * For matrices, the function is evaluated element wise.
   *
   * The modulus is defined as:
   *
   *     x - y * floor(x / y)
   *
   * See https://en.wikipedia.org/wiki/Modulo_operation.
   *
   * Syntax:
   *
   *    math.mod(x, y)
   *
   * Examples:
   *
   *    math.mod(8, 3)                // returns 2
   *    math.mod(11, 2)               // returns 1
   *
   *    function isOdd(x) {
   *      return math.mod(x, 2) != 0
   *    }
   *
   *    isOdd(2)                      // returns false
   *    isOdd(3)                      // returns true
   *
   * See also:
   *
   *    divide
   *
   * @param  {number | BigNumber | Fraction | Array | Matrix} x Dividend
   * @param  {number | BigNumber | Fraction | Array | Matrix} y Divisor
   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the remainder of `x` divided by `y`.
   */ return typed($fa3529761d10d542$var$name, {
        "number, number": (0, $08ae6b2eb4bd0049$export$64b58c5b0372ae95),
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            if (y.isNeg()) throw new Error("Cannot calculate mod for a negative divisor");
            return y.isZero() ? x : x.mod(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            if (y.compare(0) < 0) throw new Error("Cannot calculate mod for a negative divisor");
             // Workaround suggested in Fraction.js library to calculate correct modulo for negative dividend
            return x.compare(0) >= 0 ? x.mod(y) : x.mod(y).add(y).mod(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});



var $bea4d437980b171e$var$name = "mode";
var $bea4d437980b171e$var$dependencies = [
    "typed",
    "isNaN",
    "isNumeric"
];
var $bea4d437980b171e$export$822530980ba269d9 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($bea4d437980b171e$var$name, $bea4d437980b171e$var$dependencies, (_ref)=>{
    var { typed: typed, isNaN: isNaN, isNumeric: isNumeric } = _ref;
    /**
  * Computes the mode of a set of numbers or a list with values(numbers or characters).
  * If there are more than one modes, it returns a list of those values.
  *
  * Syntax:
  *
  *     math.mode(a, b, c, ...)
  *     math.mode(A)
  *
  * Examples:
  *
  *     math.mode(2, 1, 4, 3, 1)                            // returns [1]
  *     math.mode([1, 2.7, 3.2, 4, 2.7])                    // returns [2.7]
  *     math.mode(1, 4, 6, 1, 6)                             // returns [1, 6]
  *     math.mode('a','a','b','c')                           // returns ["a"]
  *     math.mode(1, 1.5, 'abc')                             // returns [1, 1.5, "abc"]
  *
  * See also:
  *
  *     median,
  *     mean
  *
  * @param {... *} args  A single matrix
  * @return {*} The mode of all values
  */ return typed($bea4d437980b171e$var$name, {
        "Array | Matrix": _mode,
        "...": function _(args) {
            return _mode(args);
        }
    });
    /**
   * Calculates the mode in an 1-dimensional array
   * @param {Array} values
   * @return {Array} mode
   * @private
   */ function _mode(values) {
        values = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(values.valueOf());
        var num = values.length;
        if (num === 0) throw new Error("Cannot calculate mode of an empty array");
        var count = {};
        var mode = [];
        var max = 0;
        for(var i = 0; i < values.length; i++){
            var value = values[i];
            if (isNumeric(value) && isNaN(value)) throw new Error("Cannot calculate mode of an array containing NaN values");
            if (!(value in count)) count[value] = 0;
            count[value]++;
            if (count[value] === max) mode.push(value);
            else if (count[value] > max) {
                max = count[value];
                mode = [
                    value
                ];
            }
        }
        return mode;
    }
});



var $4f976f0e5fcf1860$var$name = "multinomial";
var $4f976f0e5fcf1860$var$dependencies = [
    "typed",
    "add",
    "divide",
    "multiply",
    "factorial",
    "isInteger",
    "isPositive"
];
var $4f976f0e5fcf1860$export$b15aee1001d110 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($4f976f0e5fcf1860$var$name, $4f976f0e5fcf1860$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide, multiply: multiply, factorial: factorial, isInteger: isInteger, isPositive: isPositive } = _ref;
    /**
   * Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities.
   *
   * multinomial takes one array of integers as an argument.
   * The following condition must be enforced: every ai <= 0
   *
   * Syntax:
   *
   *     math.multinomial(a) // a is an array type
   *
   * Examples:
   *
   *    math.multinomial([1,2,1]) // returns 12
   *
   * See also:
   *
   *    combinations, factorial
   *
   * @param {number[] | BigNumber[]} a    Integer numbers of objects in the subset
   * @return {Number | BigNumber}         Multinomial coefficient.
   */ return typed($4f976f0e5fcf1860$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            var sum = 0;
            var denom = 1;
            (0, $cd13353fc76500f7$export$519ada94592b97fc)(a, function(ai) {
                if (!isInteger(ai) || !isPositive(ai)) throw new TypeError("Positive integer value expected in function multinomial");
                sum = add(sum, ai);
                denom = multiply(denom, factorial(ai));
            });
            return divide(factorial(sum), denom);
        }
    });
});







var $039c29510f5f4675$var$name = "multiply";
var $039c29510f5f4675$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "multiplyScalar",
    "equalScalar",
    "dot"
];
var $039c29510f5f4675$export$86d08fd318fa07c8 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($039c29510f5f4675$var$name, $039c29510f5f4675$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, multiplyScalar: multiplyScalar, equalScalar: equalScalar, dot: dot } = _ref;
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    function _validateMatrixDimensions(size1, size2) {
        // check left operand dimensions
        switch(size1.length){
            case 1:
                // check size2
                switch(size2.length){
                    case 1:
                        // Vector x Vector
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
                        break;
                    case 2:
                        // Vector x Matrix
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Vector length (" + size1[0] + ") must match Matrix rows (" + size2[0] + ")");
                        break;
                    default:
                        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + size2.length + " dimensions)");
                }
                break;
            case 2:
                // check size2
                switch(size2.length){
                    case 1:
                        // Matrix x Vector
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + size1[1] + ") must match Vector length (" + size2[0] + ")");
                        break;
                    case 2:
                        // Matrix x Matrix
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + size1[1] + ") must match Matrix B rows (" + size2[0] + ")");
                        break;
                    default:
                        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + size2.length + " dimensions)");
                }
                break;
            default:
                throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + size1.length + " dimensions)");
        }
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (N)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {number}             Scalar value
   */ function _multiplyVectorVector(a, b, n) {
        // check empty vector
        if (n === 0) throw new Error("Cannot multiply two empty vectors");
        return dot(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Matrix         (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorMatrix(a, b) {
        // process storage
        if (b.storage() !== "dense") throw new Error("Support for SparseMatrix not implemented");
        return _multiplyVectorDenseMatrix(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Dense Matrix   (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // rows & columns
        var alength = asize[0];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix columns
        for(var j = 0; j < bcolumns; j++){
            // sum (do not initialize it with zero)
            var sum = mf(adata[0], bdata[0][j]); // loop vector
            for(var i = 1; i < alength; i++)// multiply & accumulate
            sum = af(sum, mf(adata[i], bdata[i][j]));
            c[j] = sum;
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                bcolumns
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {Matrix}             Dense Vector   (M)
   */ var _multiplyMatrixVector = typed("_multiplyMatrixVector", {
        "DenseMatrix, any": _multiplyDenseMatrixVector,
        "SparseMatrix, any": _multiplySparseMatrixVector
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Matrix         (NxC)
   *
   * @return {Matrix}             Matrix         (MxC)
   */ var _multiplyMatrixMatrix = typed("_multiplyMatrixMatrix", {
        "DenseMatrix, DenseMatrix": _multiplyDenseMatrixDenseMatrix,
        "DenseMatrix, SparseMatrix": _multiplyDenseMatrixSparseMatrix,
        "SparseMatrix, DenseMatrix": _multiplySparseMatrixDenseMatrix,
        "SparseMatrix, SparseMatrix": _multiplySparseMatrixSparseMatrix
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix  (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             Dense Vector (M)
   */ function _multiplyDenseMatrixVector(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = asize[0];
        var acolumns = asize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i]; // sum (do not initialize it with zero)
            var sum = mf(row[0], bdata[0]); // loop matrix a columns
            for(var j = 1; j < acolumns; j++)// multiply & accumulate
            sum = af(sum, mf(row[j], bdata[j]));
            c[i] = sum;
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            DenseMatrix    (NxC)
   *
   * @return {Matrix}             DenseMatrix    (MxC)
   */ function _multiplyDenseMatrixDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // rows & columns
        var arows = asize[0];
        var acolumns = asize[1];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i]; // initialize row array
            c[i] = []; // loop matrix b columns
            for(var j = 0; j < bcolumns; j++){
                // sum (avoid initializing sum to zero)
                var sum = mf(row[0], bdata[0][j]); // loop matrix a columns
                for(var x = 1; x < acolumns; x++)// multiply & accumulate
                sum = af(sum, mf(row[x], bdata[x][j]));
                c[i][j] = sum;
            }
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            SparseMatrix   (NxC)
   *
   * @return {Matrix}             SparseMatrix   (MxC)
   */ function _multiplyDenseMatrixSparseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate b matrix
        if (!bvalues) throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
         // rows & columns
        var arows = asize[0];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // c matrix
        var c = b.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // indeces in column jb
            var kb0 = bptr[jb];
            var kb1 = bptr[jb + 1]; // do not process column jb if no data exists
            if (kb1 > kb0) {
                // last row mark processed
                var last = 0; // loop a rows
                for(var i = 0; i < arows; i++){
                    // column mark
                    var mark = i + 1; // C[i, jb]
                    var cij = void 0; // values in b column j
                    for(var kb = kb0; kb < kb1; kb++){
                        // row
                        var ib = bindex[kb]; // check value has been initialized
                        if (last !== mark) {
                            // first value in column jb
                            cij = mf(adata[i][ib], bvalues[kb]); // update mark
                            last = mark;
                        } else // accumulate value
                        cij = af(cij, mf(adata[i][ib], bvalues[kb]));
                    } // check column has been processed and value != 0
                    if (last === mark && !eq(cij, zero)) {
                        // push row & value
                        cindex.push(i);
                        cvalues.push(cij);
                    }
                }
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix    (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             SparseMatrix    (M, 1)
   */ function _multiplySparseMatrixVector(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // validate a matrix
        if (!avalues) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
         // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var brows = b._size[0]; // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // workspace
        var x = []; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // update ptr
        cptr[0] = 0; // rows in b
        for(var ib = 0; ib < brows; ib++){
            // b[ib]
            var vbi = bdata[ib]; // check b[ib] != 0, avoid loops
            if (!eq(vbi, zero)) // A values & index in ib column
            for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                // a row
                var ia = aindex[ka]; // check value exists in current j
                if (!w[ia]) {
                    // ia is new entry in j
                    w[ia] = true; // add i to pattern of C
                    cindex.push(ia); // x(ia) = A
                    x[ia] = mf(vbi, avalues[ka]);
                } else // i exists in C already
                x[ia] = af(x[ia], mf(vbi, avalues[ka]));
            }
        } // copy values from x to column jb of c
        for(var p1 = cindex.length, p = 0; p < p1; p++){
            // row
            var ic = cindex[p]; // copy value
            cvalues[p] = x[ic];
        } // update ptr
        cptr[1] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                1
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            DenseMatrix       (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixDenseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // validate a matrix
        if (!avalues) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
         // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var brows = b._size[0];
        var bcolumns = b._size[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // workspace
        var x = []; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column
            var mark = jb + 1; // rows in jb
            for(var ib = 0; ib < brows; ib++){
                // b[ib, jb]
                var vbij = bdata[ib][jb]; // check b[ib, jb] != 0, avoid loops
                if (!eq(vbij, zero)) // A values & index in ib column
                for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // a row
                    var ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia); // x(ia) = A
                        x[ia] = mf(vbij, avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(vbij, avalues[ka]));
                }
            } // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p]; // copy value
                cvalues[p] = x[ic];
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            SparseMatrix      (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixSparseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var bcolumns = b._size[1]; // flag indicating both matrices (a & b) contain data
        var values = avalues && bvalues; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = []; // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // workspace
        var x = values ? [] : undefined; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // variables
        var ka, ka0, ka1, kb, kb0, kb1, ia, ib; // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column
            var mark = jb + 1; // B values & index in j
            for(kb0 = bptr[jb], kb1 = bptr[jb + 1], kb = kb0; kb < kb1; kb++){
                // b row
                ib = bindex[kb]; // check we need to process values
                if (values) // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia); // x(ia) = A
                        x[ia] = mf(bvalues[kb], avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(bvalues[kb], avalues[ka]));
                }
                else // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia);
                    }
                }
            } // check we need to process matrix values (pattern matrix)
            if (values) // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p]; // copy value
                cvalues[p] = x[ic];
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * Multiply two or more values, `x * y`.
   * For matrices, the matrix product is calculated.
   *
   * Syntax:
   *
   *    math.multiply(x, y)
   *    math.multiply(x, y, z, ...)
   *
   * Examples:
   *
   *    math.multiply(4, 5.2)        // returns number 20.8
   *    math.multiply(2, 3, 4)       // returns number 24
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.multiply(a, b)          // returns Complex 5 + 14i
   *
   *    const c = [[1, 2], [4, 3]]
   *    const d = [[1, 2, 3], [3, -4, 7]]
   *    math.multiply(c, d)          // returns Array [[7, -6, 17], [13, -4, 33]]
   *
   *    const e = math.unit('2.1 km')
   *    math.multiply(3, e)          // returns Unit 6.3 km
   *
   * See also:
   *
   *    divide, prod, cross, dot
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to multiply
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to multiply
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Multiplication of `x` and `y`
   */ return typed($039c29510f5f4675$var$name, (0, $33619877a15996ac$export$8b58be045bf06082)({
        // we extend the signatures of multiplyScalar with signatures dealing with matrices
        "Array, Array": function ArrayArray(x, y) {
            // check dimensions
            _validateMatrixDimensions((0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x), (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(y)); // use dense matrix implementation
            var m = this(matrix(x), matrix(y)); // return array or scalar
            return (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(m) ? m.valueOf() : m;
        },
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            // dimensions
            var xsize = x.size();
            var ysize = y.size(); // check dimensions
            _validateMatrixDimensions(xsize, ysize); // process dimensions
            if (xsize.length === 1) {
                // process y dimensions
                if (ysize.length === 1) // Vector * Vector
                return _multiplyVectorVector(x, y, xsize[0]);
                 // Vector * Matrix
                return _multiplyVectorMatrix(x, y);
            } // process y dimensions
            if (ysize.length === 1) // Matrix * Vector
            return _multiplyMatrixVector(x, y);
             // Matrix * Matrix
            return _multiplyMatrixMatrix(x, y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use Matrix * Matrix implementation
            return this(x, matrix(y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use Matrix * Matrix implementation
            return this(matrix(x, y.storage()), y);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, multiplyScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, multiplyScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, multiplyScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, multiplyScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
        },
        "any, any": multiplyScalar,
        "any, any, ...any": function anyAnyAny(x, y, rest) {
            var result = this(x, y);
            for(var i = 0; i < rest.length; i++)result = this(result, rest[i]);
            return result;
        }
    }, multiplyScalar.signatures));
});



var $536449042aed6cc4$var$name = "multiplyScalar";
var $536449042aed6cc4$var$dependencies = [
    "typed"
];
var $536449042aed6cc4$export$37dc64d7e8361b32 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($536449042aed6cc4$var$name, $536449042aed6cc4$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Multiply two scalar values, `x * y`.
   * This function is meant for internal use: it is used by the public function
   * `multiply`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to multiply
   * @param  {number | BigNumber | Fraction | Complex} y          Second value to multiply
   * @return {number | BigNumber | Fraction | Complex | Unit}     Multiplication of `x` and `y`
   * @private
   */ return typed("multiplyScalar", {
        "number, number": (0, $08ae6b2eb4bd0049$export$4ad41ac849e391ec),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.mul(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.times(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.mul(y);
        },
        "number | Fraction | BigNumber | Complex, Unit": function numberFractionBigNumberComplexUnit(x, y) {
            var res = y.clone();
            res.value = res.value === null ? res._normalize(x) : this(res.value, x);
            return res;
        },
        "Unit, number | Fraction | BigNumber | Complex": function UnitNumberFractionBigNumberComplex(x, y) {
            var res = x.clone();
            res.value = res.value === null ? res._normalize(y) : this(res.value, y);
            return res;
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return x.multiply(y);
        }
    });
});


var $e94b67d2301140bc$var$name = "norm";
var $e94b67d2301140bc$var$dependencies = [
    "typed",
    "abs",
    "add",
    "pow",
    "conj",
    "sqrt",
    "multiply",
    "equalScalar",
    "larger",
    "smaller",
    "matrix",
    "ctranspose",
    "eigs"
];
var $e94b67d2301140bc$export$ce85a9d2952c2966 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e94b67d2301140bc$var$name, $e94b67d2301140bc$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, pow: pow, conj: conj, sqrt: sqrt, multiply: multiply, equalScalar: equalScalar, larger: larger, smaller: smaller, matrix: matrix, ctranspose: ctranspose, eigs: eigs } = _ref;
    /**
   * Calculate the norm of a number, vector or matrix.
   *
   * The second parameter p is optional. If not provided, it defaults to 2.
   *
   * Syntax:
   *
   *    math.norm(x)
   *    math.norm(x, p)
   *
   * Examples:
   *
   *    math.abs(-3.5)                         // returns 3.5
   *    math.norm(-3.5)                        // returns 3.5
   *
   *    math.norm(math.complex(3, -4))         // returns 5
   *
   *    math.norm([1, 2, -3], Infinity)        // returns 3
   *    math.norm([1, 2, -3], -Infinity)       // returns 1
   *
   *    math.norm([3, 4], 2)                   // returns 5
   *
   *    math.norm([[1, 2], [3, 4]], 1)          // returns 6
   *    math.norm([[1, 2], [3, 4]], 'inf')     // returns 7
   *    math.norm([[1, 2], [3, 4]], 'fro')     // returns 5.477225575051661
   *
   * See also:
   *
   *    abs, hypot
   *
   * @param  {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the norm
   * @param  {number | BigNumber | string} [p=2]
   *            Vector space.
   *            Supported numbers include Infinity and -Infinity.
   *            Supported strings are: 'inf', '-inf', and 'fro' (The Frobenius norm)
   * @return {number | BigNumber} the p-norm
   */ return typed($e94b67d2301140bc$var$name, {
        number: Math.abs,
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            // norm(x) = abs(x)
            return x.abs();
        },
        boolean: function boolean(x) {
            // norm(x) = abs(x)
            return Math.abs(x);
        },
        Array: function Array(x) {
            return _norm(matrix(x), 2);
        },
        Matrix: function Matrix(x) {
            return _norm(x, 2);
        },
        "number | Complex | BigNumber | boolean, number | BigNumber | string": function numberComplexBigNumberBooleanNumberBigNumberString(x) {
            // ignore second parameter, TODO: remove the option of second parameter for these types
            return this(x);
        },
        "Array, number | BigNumber | string": function ArrayNumberBigNumberString(x, p) {
            return _norm(matrix(x), p);
        },
        "Matrix, number | BigNumber | string": function MatrixNumberBigNumberString(x, p) {
            return _norm(x, p);
        }
    });
    /**
   * Calculate the plus infinity norm for a vector
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNormPlusInfinity(x) {
        // norm(x, Infinity) = max(abs(x))
        var pinf = 0; // skip zeros since abs(0) === 0
        x.forEach(function(value) {
            var v = abs(value);
            if (larger(v, pinf)) pinf = v;
        }, true);
        return pinf;
    }
    /**
   * Calculate the minus infinity norm for a vector
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNormMinusInfinity(x) {
        // norm(x, -Infinity) = min(abs(x))
        var ninf; // skip zeros since abs(0) === 0
        x.forEach(function(value) {
            var v = abs(value);
            if (!ninf || smaller(v, ninf)) ninf = v;
        }, true);
        return ninf || 0;
    }
    /**
   * Calculate the norm for a vector
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNorm(x, p) {
        // check p
        if (p === Number.POSITIVE_INFINITY || p === "inf") return _vectorNormPlusInfinity(x);
        if (p === Number.NEGATIVE_INFINITY || p === "-inf") return _vectorNormMinusInfinity(x);
        if (p === "fro") return _norm(x, 2);
        if (typeof p === "number" && !isNaN(p)) {
            // check p != 0
            if (!equalScalar(p, 0)) {
                // norm(x, p) = sum(abs(xi) ^ p) ^ 1/p
                var n = 0; // skip zeros since abs(0) === 0
                x.forEach(function(value) {
                    n = add(pow(abs(value), p), n);
                }, true);
                return pow(n, 1 / p);
            }
            return Number.POSITIVE_INFINITY;
        } // invalid parameter value
        throw new Error("Unsupported parameter value");
    }
    /**
   * Calculate the Frobenius norm for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormFrobenius(x) {
        // norm(x) = sqrt(sum(diag(x'x)))
        var fro = 0;
        x.forEach(function(value, index) {
            fro = add(fro, multiply(value, conj(value)));
        });
        return abs(sqrt(fro));
    }
    /**
   * Calculate the norm L1 for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormOne(x) {
        // norm(x) = the largest column sum
        var c = []; // result
        var maxc = 0; // skip zeros since abs(0) == 0
        x.forEach(function(value, index) {
            var j = index[1];
            var cj = add(c[j] || 0, abs(value));
            if (larger(cj, maxc)) maxc = cj;
            c[j] = cj;
        }, true);
        return maxc;
    }
    /**
   * Calculate the norm L2 for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormTwo(x) {
        // norm(x) = sqrt( max eigenvalue of A*.A)
        var sizeX = x.size();
        if (sizeX[0] !== sizeX[1]) throw new RangeError("Invalid matrix dimensions");
        var tx = ctranspose(x);
        var squaredX = multiply(tx, x);
        var eigenVals = eigs(squaredX).values.toArray();
        var rho = eigenVals[eigenVals.length - 1];
        return abs(sqrt(rho));
    }
    /**
   * Calculate the infinity norm for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormInfinity(x) {
        // norm(x) = the largest row sum
        var r = []; // result
        var maxr = 0; // skip zeros since abs(0) == 0
        x.forEach(function(value, index) {
            var i = index[0];
            var ri = add(r[i] || 0, abs(value));
            if (larger(ri, maxr)) maxr = ri;
            r[i] = ri;
        }, true);
        return maxr;
    }
    /**
   * Calculate the norm for a 2D Matrix (M*N)
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNorm(x, p) {
        // check p
        if (p === 1) return _matrixNormOne(x);
        if (p === Number.POSITIVE_INFINITY || p === "inf") return _matrixNormInfinity(x);
        if (p === "fro") return _matrixNormFrobenius(x);
        if (p === 2) return _matrixNormTwo(x);
         // invalid parameter value
        throw new Error("Unsupported parameter value " + p);
    }
    /**
   * Calculate the norm for an array
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _norm(x, p) {
        // size
        var sizeX = x.size(); // check if it is a vector
        if (sizeX.length === 1) return _vectorNorm(x, p);
         // MxN matrix
        if (sizeX.length === 2) {
            if (sizeX[0] && sizeX[1]) return _matrixNorm(x, p);
            else throw new RangeError("Invalid matrix dimensions");
        }
    }
});




var $4ef43ceaf9cd3ad7$var$name = "not";
var $4ef43ceaf9cd3ad7$var$dependencies = [
    "typed"
];
var $4ef43ceaf9cd3ad7$export$8dbfb388cd6a8853 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($4ef43ceaf9cd3ad7$var$name, $4ef43ceaf9cd3ad7$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Logical `not`. Flips boolean value of a given parameter.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.not(x)
   *
   * Examples:
   *
   *    math.not(2)      // returns false
   *    math.not(0)      // returns true
   *    math.not(true)   // returns false
   *
   *    a = [2, -7, 0]
   *    math.not(a)      // returns [false, false, true]
   *
   * See also:
   *
   *    and, or, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when input is a zero or empty value.
   */ return typed($4ef43ceaf9cd3ad7$var$name, {
        number: (0, $9ff9fc757fde94e9$export$5c3e9fce4e8f3d3a),
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        BigNumber: function BigNumber(x) {
            return x.isZero() || x.isNaN();
        },
        Unit: function Unit(x) {
            return x.value !== null ? this(x.value) : true;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});









var $a128cb85fc14281f$var$name = "nthRoot";
var $a128cb85fc14281f$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber"
];
var $a128cb85fc14281f$export$964e38ef60b1ac68 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a128cb85fc14281f$var$name, $a128cb85fc14281f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: _BigNumber } = _ref;
    var algorithm01 = (0, $3feaf9e0b000398a$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm02 = (0, $b6b1cd490ad9f946$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $dcf47e3db09976d1$export$d6f401e6f2a7e54b)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculate the nth root of a value.
   * The principal nth root of a positive real number A, is the positive real
   * solution of the equation
   *
   *     x^root = A
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *     math.nthRoot(a)
   *     math.nthRoot(a, root)
   *
   * Examples:
   *
   *     math.nthRoot(9, 2)    // returns 3, as 3^2 == 9
   *     math.sqrt(9)          // returns 3, as 3^2 == 9
   *     math.nthRoot(64, 3)   // returns 4, as 4^3 == 64
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param {number | BigNumber | Array | Matrix | Complex} a
   *              Value for which to calculate the nth root
   * @param {number | BigNumber} [root=2]    The root.
   * @return {number | Complex | Array | Matrix} Returns the nth root of `a`
   */ var complexErr = "Complex number not supported in function nthRoot. Use nthRoots instead.";
    return typed($a128cb85fc14281f$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$9f26f16bd796a7b3),
        "number, number": (0, $08ae6b2eb4bd0049$export$9f26f16bd796a7b3),
        BigNumber: function BigNumber(x) {
            return _bigNthRoot(x, new _BigNumber(2));
        },
        Complex: function Complex(x) {
            throw new Error(complexErr);
        },
        "Complex, number": function ComplexNumber(x, y) {
            throw new Error(complexErr);
        },
        "BigNumber, BigNumber": _bigNthRoot,
        "Array | Matrix": function ArrayMatrix(x) {
            return this(x, 2);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // sparse + sparse
            return algorithm06(x, y, this);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // dense + sparse
            return algorithm01(x, y, this, false);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // sparse - scalar
            return algorithm11(y, x, this, true);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
    /**
   * Calculate the nth root of a for BigNumbers, solve x^root == a
   * https://rosettacode.org/wiki/Nth_root#JavaScript
   * @param {BigNumber} a
   * @param {BigNumber} root
   * @private
   */ function _bigNthRoot(a, root) {
        var precision = _BigNumber.precision;
        var Big = _BigNumber.clone({
            precision: precision + 2
        });
        var zero = new _BigNumber(0);
        var one = new Big(1);
        var inv = root.isNegative();
        if (inv) root = root.neg();
        if (root.isZero()) throw new Error("Root must be non-zero");
        if (a.isNegative() && !root.abs().mod(2).equals(1)) throw new Error("Root must be odd when a is negative.");
         // edge cases zero and infinity
        if (a.isZero()) return inv ? new Big(Infinity) : 0;
        if (!a.isFinite()) return inv ? zero : a;
        var x = a.abs().pow(one.div(root)); // If a < 0, we require that root is an odd integer,
        // so (-1) ^ (1/root) = -1
        x = a.isNeg() ? x.neg() : x;
        return new _BigNumber((inv ? one.div(x) : x).toPrecision(precision));
    }
});
var $a128cb85fc14281f$export$f098cf3c4ef0f7ef = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a128cb85fc14281f$var$name, [
    "typed"
], (_ref2)=>{
    var { typed: typed } = _ref2;
    return typed($a128cb85fc14281f$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$9f26f16bd796a7b3),
        "number, number": (0, $08ae6b2eb4bd0049$export$9f26f16bd796a7b3)
    });
});


var $bae3d9c8768a3833$var$name = "nthRoots";
var $bae3d9c8768a3833$var$dependencies = [
    "config",
    "typed",
    "divideScalar",
    "Complex"
];
var $bae3d9c8768a3833$export$36e27b45d2aa738c = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($bae3d9c8768a3833$var$name, $bae3d9c8768a3833$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, Complex: Complex } = _ref;
    /**
   * Each function here returns a real multiple of i as a Complex value.
   * @param  {number} val
   * @return {Complex} val, i*val, -val or -i*val for index 0, 1, 2, 3
   */ // This is used to fix float artifacts for zero-valued components.
    var _calculateExactResult = [
        function realPos(val) {
            return new Complex(val, 0);
        },
        function imagPos(val) {
            return new Complex(0, val);
        },
        function realNeg(val) {
            return new Complex(-val, 0);
        },
        function imagNeg(val) {
            return new Complex(0, -val);
        }
    ];
    /**
   * Calculate the nth root of a Complex Number a using De Movire's Theorem.
   * @param  {Complex} a
   * @param  {number} root
   * @return {Array} array of n Complex Roots
   */ function _nthComplexRoots(a, root) {
        if (root < 0) throw new Error("Root must be greater than zero");
        if (root === 0) throw new Error("Root must be non-zero");
        if (root % 1 !== 0) throw new Error("Root must be an integer");
        if (a === 0 || a.abs() === 0) return [
            new Complex(0, 0)
        ];
        var aIsNumeric = typeof a === "number";
        var offset; // determine the offset (argument of a)/(pi/2)
        if (aIsNumeric || a.re === 0 || a.im === 0) {
            if (aIsNumeric) offset = 2 * +(a < 0); // numeric value on the real axis
            else if (a.im === 0) offset = 2 * +(a.re < 0); // complex value on the real axis
            else offset = 2 * +(a.im < 0) + 1; // complex value on the imaginary axis
        }
        var arg = a.arg();
        var abs = a.abs();
        var roots = [];
        var r = Math.pow(abs, 1 / root);
        for(var k = 0; k < root; k++){
            var halfPiFactor = (offset + 4 * k) / root;
            /**
       * If (offset + 4*k)/root is an integral multiple of pi/2
       * then we can produce a more exact result.
       */ if (halfPiFactor === Math.round(halfPiFactor)) {
                roots.push(_calculateExactResult[halfPiFactor % 4](r));
                continue;
            }
            roots.push(new Complex({
                r: r,
                phi: (arg + 2 * Math.PI * k) / root
            }));
        }
        return roots;
    }
    /**
   * Calculate the nth roots of a value.
   * An nth root of a positive real number A,
   * is a positive real solution of the equation "x^root = A".
   * This function returns an array of complex values.
   *
   * Syntax:
   *
   *    math.nthRoots(x)
   *    math.nthRoots(x, root)
   *
   * Examples:
   *
   *    math.nthRoots(1)
   *    // returns [
   *    //   {re: 1, im: 0},
   *    //   {re: -1, im: 0}
   *    // ]
   *    nthRoots(1, 3)
   *    // returns [
   *    //   { re: 1, im: 0 },
   *    //   { re: -0.4999999999999998, im: 0.8660254037844387 },
   *    //   { re: -0.5000000000000004, im: -0.8660254037844385 }
   *    ]
   *
   * See also:
   *
   *    nthRoot, pow, sqrt
   *
   * @param {number | BigNumber | Fraction | Complex} x Number to be rounded
   * @return {number | BigNumber | Fraction | Complex}            Rounded value
   */ return typed($bae3d9c8768a3833$var$name, {
        Complex: function Complex(x) {
            return _nthComplexRoots(x, 2);
        },
        "Complex, number": _nthComplexRoots
    });
});



var $e00338ee98cc80c1$var$name = "number";
var $e00338ee98cc80c1$var$dependencies = [
    "typed"
];
/**
 * Separates the radix, integer part, and fractional part of a non decimal number string
 * @param {string} input string to parse
 * @returns {object} the parts of the string or null if not a valid input
 */ function $e00338ee98cc80c1$var$getNonDecimalNumberParts(input) {
    var nonDecimalWithRadixMatch = input.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
    if (nonDecimalWithRadixMatch) {
        var radix = {
            "0b": 2,
            "0o": 8,
            "0x": 16
        }[nonDecimalWithRadixMatch[1]];
        var integerPart = nonDecimalWithRadixMatch[2];
        var fractionalPart = nonDecimalWithRadixMatch[3];
        return {
            input: input,
            radix: radix,
            integerPart: integerPart,
            fractionalPart: fractionalPart
        };
    } else return null;
}
/**
 * Makes a number from a radix, and integer part, and a fractional part
 * @param {parts} [x] parts of the number string (from getNonDecimalNumberParts)
 * @returns {number} the number
 */ function $e00338ee98cc80c1$var$makeNumberFromNonDecimalParts(parts) {
    var n = parseInt(parts.integerPart, parts.radix);
    var f = 0;
    for(var i = 0; i < parts.fractionalPart.length; i++){
        var digitValue = parseInt(parts.fractionalPart[i], parts.radix);
        f += digitValue / Math.pow(parts.radix, i + 1);
    }
    var result = n + f;
    if (isNaN(result)) throw new SyntaxError('String "' + parts.input + '" is no valid number');
    return result;
}
var $e00338ee98cc80c1$export$763ee9f6477981ab = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e00338ee98cc80c1$var$name, $e00338ee98cc80c1$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a number or convert a string, boolean, or unit to a number.
   * When value is a matrix, all elements will be converted to number.
   *
   * Syntax:
   *
   *    math.number(value)
   *    math.number(unit, valuelessUnit)
   *
   * Examples:
   *
   *    math.number(2)                         // returns number 2
   *    math.number('7.2')                     // returns number 7.2
   *    math.number(true)                      // returns number 1
   *    math.number([true, false, true, true]) // returns [1, 0, 1, 1]
   *    math.number(math.unit('52cm'), 'm')    // returns 0.52
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, string, unit
   *
   * @param {string | number | BigNumber | Fraction | boolean | Array | Matrix | Unit | null} [value]  Value to be converted
   * @param {Unit | string} [valuelessUnit] A valueless unit, used to convert a unit to a number
   * @return {number | Array | Matrix} The created number
   */ var number = typed("number", {
        "": function _() {
            return 0;
        },
        number: function number(x) {
            return x;
        },
        string: function string(x) {
            if (x === "NaN") return NaN;
            var nonDecimalNumberParts = $e00338ee98cc80c1$var$getNonDecimalNumberParts(x);
            if (nonDecimalNumberParts) return $e00338ee98cc80c1$var$makeNumberFromNonDecimalParts(nonDecimalNumberParts);
            var size = 0;
            var wordSizeSuffixMatch = x.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
            if (wordSizeSuffixMatch) {
                // x includes a size suffix like 0xffffi32, so we extract
                // the suffix and remove it from x
                size = Number(wordSizeSuffixMatch[2]);
                x = wordSizeSuffixMatch[1];
            }
            var num = Number(x);
            if (isNaN(num)) throw new SyntaxError('String "' + x + '" is no valid number');
            if (wordSizeSuffixMatch) {
                // x is a signed bin, oct, or hex literal
                // num is the value of string x if x is interpreted as unsigned
                if (num > 2 ** size - 1) // literal is too large for size suffix
                throw new SyntaxError('String "'.concat(x, '" is out of range'));
                 // check if the bit at index size - 1 is set and if so do the twos complement
                if (num >= 2 ** (size - 1)) num = num - 2 ** size;
            }
            return num;
        },
        BigNumber: function BigNumber(x) {
            return x.toNumber();
        },
        Fraction: function Fraction(x) {
            return x.valueOf();
        },
        Unit: function Unit(x) {
            throw new Error("Second argument with valueless unit expected");
        },
        null: function _null(x) {
            return 0;
        },
        "Unit, string | Unit": function UnitStringUnit(unit, valuelessUnit) {
            return unit.toNumber(valuelessUnit);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    }); // reviver function to parse a JSON object like:
    //
    //     {"mathjs":"number","value":"2.3"}
    //
    // into a number 2.3
    number.fromJSON = function(json) {
        return parseFloat(json.value);
    };
    return number;
});



function $59e7e238555a97e6$export$f0829713dc162a8() {
    throw new Error('No "bignumber" implementation available');
}
function $59e7e238555a97e6$export$9978fd42ef220ba0() {
    throw new Error('No "fraction" implementation available');
}
function $59e7e238555a97e6$export$b81416cb7ecca475() {
    throw new Error('No "matrix" implementation available');
}
function $59e7e238555a97e6$export$a38f8cf2e48f2bd() {
    throw new Error('No "index" implementation available');
}
function $59e7e238555a97e6$export$32411ef9704d5eea() {
    throw new Error('No "matrix" implementation available');
}


var $a7ac5e97e6c87c05$var$name = "numeric";
var $a7ac5e97e6c87c05$var$dependencies = [
    "number",
    "?bignumber",
    "?fraction"
];
var $a7ac5e97e6c87c05$export$e3cf2d123164e554 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a7ac5e97e6c87c05$var$name, $a7ac5e97e6c87c05$var$dependencies, (_ref)=>{
    var { number: _number, bignumber: bignumber, fraction: fraction } = _ref;
    var validInputTypes = {
        string: true,
        number: true,
        BigNumber: true,
        Fraction: true
    }; // Load the conversion functions for each output type
    var validOutputTypes = {
        number: (x)=>_number(x),
        BigNumber: bignumber ? (x)=>bignumber(x) : (0, $59e7e238555a97e6$export$f0829713dc162a8),
        Fraction: fraction ? (x)=>fraction(x) : (0, $59e7e238555a97e6$export$9978fd42ef220ba0)
    };
    /**
   * Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.
   *
   * Syntax:
   *
   *    math.numeric(x)
   *
   * Examples:
   *
   *    math.numeric('4')                           // returns number 4
   *    math.numeric('4', 'number')                 // returns number 4
   *    math.numeric('4', 'BigNumber')              // returns BigNumber 4
   *    math.numeric('4', 'Fraction')               // returns Fraction 4
   *    math.numeric(4, 'Fraction')                 // returns Fraction 4
   *    math.numeric(math.fraction(2, 5), 'number') // returns number 0.4
   *
   * See also:
   *
   *    number, fraction, bignumber, string, format
   *
   * @param {string | number | BigNumber | Fraction } value
   *              A numeric value or a string containing a numeric value
   * @param {string} outputType
   *              Desired numeric output type.
   *              Available values: 'number', 'BigNumber', or 'Fraction'
   * @return {number | BigNumber | Fraction}
   *              Returns an instance of the numeric in the requested type
   */ return function numeric(value, outputType) {
        var inputType = (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(value);
        if (!(inputType in validInputTypes)) throw new TypeError("Cannot convert " + value + ' of type "' + inputType + '"; valid input types are ' + Object.keys(validInputTypes).join(", "));
        if (!(outputType in validOutputTypes)) throw new TypeError("Cannot convert " + value + ' to type "' + outputType + '"; valid output types are ' + Object.keys(validOutputTypes).join(", "));
        if (outputType === inputType) return value;
        else return validOutputTypes[outputType](value);
    };
});


var $a0d9f7d0ac5f7acd$var$name = "oct";
var $a0d9f7d0ac5f7acd$var$dependencies = [
    "typed",
    "format"
];
var $a0d9f7d0ac5f7acd$export$6692788ef49c21c9 = (0, $a671619231063c2b$export$e9008f2713103c6c)($a0d9f7d0ac5f7acd$var$name, $a0d9f7d0ac5f7acd$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($a0d9f7d0ac5f7acd$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            return format(n, {
                notation: "oct"
            });
        },
        "number | BigNumber, number": function numberBigNumberNumber(n, wordSize) {
            return format(n, {
                notation: "oct",
                wordSize: wordSize
            });
        }
    });
});





var $f8bd29f490666f55$var$name = "ones";
var $f8bd29f490666f55$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $f8bd29f490666f55$export$f524a435b9c16a90 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($f8bd29f490666f55$var$name, $f8bd29f490666f55$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Create a matrix filled with ones. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.ones(m)
   *    math.ones(m, format)
   *    math.ones(m, n)
   *    math.ones(m, n, format)
   *    math.ones([m, n])
   *    math.ones([m, n], format)
   *    math.ones([m, n, p, ...])
   *    math.ones([m, n, p, ...], format)
   *
   * Examples:
   *
   *    math.ones(3)                   // returns [1, 1, 1]
   *    math.ones(3, 2)                // returns [[1, 1], [1, 1], [1, 1]]
   *    math.ones(3, 2, 'dense')       // returns Dense Matrix [[1, 1], [1, 1], [1, 1]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.ones(math.size(A))       // returns [[1, 1, 1], [1, 1, 1]]
   *
   * See also:
   *
   *    zeros, identity, size, range
   *
   * @param {...number | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix | number}  A matrix filled with ones
   */ return typed("ones", {
        "": function _() {
            return config.matrix === "Array" ? _ones([]) : _ones([], "default");
        },
        // math.ones(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        "...number | BigNumber | string": function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === "string") {
                var format = size.pop();
                return _ones(size, format);
            } else if (config.matrix === "Array") return _ones(size);
            else return _ones(size, "default");
        },
        Array: _ones,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _ones(size.valueOf(), format);
        },
        "Array | Matrix, string": function ArrayMatrixString(size, format) {
            return _ones(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with ones
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _ones(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(1) : 1;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $802b18b8c920d4c6$export$4380c87abf28fdf)(arr, size, defaultValue);
            return arr;
        }
    } // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    } // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== "number" || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(value) || value < 0) throw new Error("Parameters in function ones must be positive integers");
        });
    }
});








var $cc0486a759f71602$var$name = "or";
var $cc0486a759f71602$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $cc0486a759f71602$export$3d19b09907d6fd4a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($cc0486a759f71602$var$name, $cc0486a759f71602$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm05 = (0, $a7b97f0cac0b5286$export$f80c3080566d43b4)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Logical `or`. Test if at least one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.or(x, y)
   *
   * Examples:
   *
   *    math.or(2, 4)   // returns true
   *
   *    a = [2, 5, 0]
   *    b = [0, 22, 0]
   *    c = 0
   *
   *    math.or(a, b)   // returns [true, true, false]
   *    math.or(b, c)   // returns [false, true, false]
   *
   * See also:
   *
   *    and, not, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one of the inputs is defined with a nonzero/nonempty value.
   */ return typed($cc0486a759f71602$var$name, {
        "number, number": (0, $9ff9fc757fde94e9$export$cb9e31d07eec8012),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.re !== 0 || x.im !== 0 || y.re !== 0 || y.im !== 0;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return !x.isZero() && !x.isNaN() || !y.isZero() && !y.isNaN();
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return this(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});




var $4940426141ad1d0d$var$name = "partitionSelect";
var $4940426141ad1d0d$var$dependencies = [
    "typed",
    "isNumeric",
    "isNaN",
    "compare"
];
var $4940426141ad1d0d$export$47c1a746705f5c42 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($4940426141ad1d0d$var$name, $4940426141ad1d0d$var$dependencies, (_ref)=>{
    var { typed: typed, isNumeric: isNumeric, isNaN: isNaN, compare: compare } = _ref;
    var asc = compare;
    var desc = (a, b)=>-compare(a, b);
    /**
   * Partition-based selection of an array or 1D matrix.
   * Will find the kth smallest value, and mutates the input array.
   * Uses Quickselect.
   *
   * Syntax:
   *
   *    math.partitionSelect(x, k)
   *    math.partitionSelect(x, k, compare)
   *
   * Examples:
   *
   *    math.partitionSelect([5, 10, 1], 2)           // returns 10
   *    math.partitionSelect(['C', 'B', 'A', 'D'], 1) // returns 'B'
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.partitionSelect(['Langdon', 'Tom', 'Sara'], 2, sortByLength) // returns 'Langdon'
   *
   * See also:
   *
   *    sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Number} k            The kth smallest value to be retrieved zero-based index
   * @param {Function | 'asc' | 'desc'} [compare='asc']
   *        An optional comparator function. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {*} Returns the kth lowest value.
   */ return typed($4940426141ad1d0d$var$name, {
        "Array | Matrix, number": function ArrayMatrixNumber(x, k) {
            return _partitionSelect(x, k, asc);
        },
        "Array | Matrix, number, string": function ArrayMatrixNumberString(x, k, compare) {
            if (compare === "asc") return _partitionSelect(x, k, asc);
            else if (compare === "desc") return _partitionSelect(x, k, desc);
            else throw new Error('Compare string must be "asc" or "desc"');
        },
        "Array | Matrix, number, function": _partitionSelect
    });
    function _partitionSelect(x, k, compare) {
        if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(k) || k < 0) throw new Error("k must be a non-negative integer");
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(x)) {
            var size = x.size();
            if (size.length > 1) throw new Error("Only one dimensional matrices supported");
            return quickSelect(x.valueOf(), k, compare);
        }
        if (Array.isArray(x)) return quickSelect(x, k, compare);
    }
    /**
   * Quickselect algorithm.
   * Code adapted from:
   * https://blog.teamleadnet.com/2012/07/quick-select-algorithm-find-kth-element.html
   *
   * @param {Array} arr
   * @param {Number} k
   * @param {Function} compare
   * @private
   */ function quickSelect(arr, k, compare) {
        if (k >= arr.length) throw new Error("k out of bounds");
         // check for NaN values since these can cause an infinite while loop
        for(var i = 0; i < arr.length; i++){
            if (isNumeric(arr[i]) && isNaN(arr[i])) return arr[i]; // return NaN
        }
        var from = 0;
        var to = arr.length - 1; // if from == to we reached the kth element
        while(from < to){
            var r = from;
            var w = to;
            var pivot = arr[Math.floor(Math.random() * (to - from + 1)) + from]; // stop if the reader and writer meets
            while(r < w)// arr[r] >= pivot
            if (compare(arr[r], pivot) >= 0) {
                // put the large values at the end
                var tmp = arr[w];
                arr[w] = arr[r];
                arr[r] = tmp;
                --w;
            } else // the value is smaller than the pivot, skip
            ++r;
             // if we stepped up (r++) we need to step one down (arr[r] > pivot)
            if (compare(arr[r], pivot) > 0) --r;
             // the r pointer is on the end of the first k elements
            if (k <= r) to = r;
            else from = r + 1;
        }
        return arr[k];
    }
});




var $ffd61eaf80563e5a$var$name = "permutations";
var $ffd61eaf80563e5a$var$dependencies = [
    "typed",
    "factorial"
];
var $ffd61eaf80563e5a$export$1d58d7915914cc9c = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($ffd61eaf80563e5a$var$name, $ffd61eaf80563e5a$var$dependencies, (_ref)=>{
    var { typed: typed, factorial: factorial } = _ref;
    /**
   * Compute the number of ways of obtaining an ordered subset of `k` elements
   * from a set of `n` elements.
   *
   * Permutations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.permutations(n)
   *     math.permutations(n, k)
   *
   * Examples:
   *
   *    math.permutations(5)     // 120
   *    math.permutations(5, 3)  // 60
   *
   * See also:
   *
   *    combinations, combinationsWithRep, factorial
   *
   * @param {number | BigNumber} n   The number of objects in total
   * @param {number | BigNumber} [k] The number of objects in the subset
   * @return {number | BigNumber}    The number of permutations
   */ return typed($ffd61eaf80563e5a$var$name, {
        "number | BigNumber": factorial,
        "number, number": function numberNumber(n, k) {
            if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(n) || n < 0) throw new TypeError("Positive integer value expected in function permutations");
            if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(k) || k < 0) throw new TypeError("Positive integer value expected in function permutations");
            if (k > n) throw new TypeError("second argument k must be less than or equal to first argument n");
             // Permute n objects, k at a time
            return (0, $38ff2345905e1d13$export$dbd0f18357df1ddd)(n - k + 1, n);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var result, i;
            if (!$ffd61eaf80563e5a$var$isPositiveInteger(n) || !$ffd61eaf80563e5a$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function permutations");
            if (k.gt(n)) throw new TypeError("second argument k must be less than or equal to first argument n");
            var one = n.mul(0).add(1);
            result = one;
            for(i = n.minus(k).plus(1); i.lte(n); i = i.plus(1))result = result.times(i);
            return result;
        } // TODO: implement support for collection in permutations
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $ffd61eaf80563e5a$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}




var $922020686b51a817$exports = {};
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $eUTzz = parcelRequire("eUTzz");

var $21KlZ = parcelRequire("21KlZ");

var $3fL2A = parcelRequire("3fL2A");

var $9QBH4 = parcelRequire("9QBH4");

var $i2bTx = parcelRequire("i2bTx");

var $h3k1Z = parcelRequire("h3k1Z");
var $8ad1cbcac45104fa$exports = {};

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = "random", startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, "global" in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == "object") {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == "string" ? obj : obj + "\0";
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + "", smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if (0, $8ad1cbcac45104fa$exports) {
        $8ad1cbcac45104fa$exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("edxhJ"));
        } catch (ex) {}
    } else if (typeof define == "function" && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math["seed" + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== "undefined" ? self : $8ad1cbcac45104fa$exports, [], Math // math: package containing random, pow, and seedrandom
);


$8ad1cbcac45104fa$exports.alea = $eUTzz;
$8ad1cbcac45104fa$exports.xor128 = $21KlZ;
$8ad1cbcac45104fa$exports.xorwow = $3fL2A;
$8ad1cbcac45104fa$exports.xorshift7 = $9QBH4;
$8ad1cbcac45104fa$exports.xor4096 = $i2bTx;
$8ad1cbcac45104fa$exports.tychei = $h3k1Z;
$922020686b51a817$exports = $8ad1cbcac45104fa$exports;


var $bbaf640e8205db18$var$singletonRandom = /* #__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($922020686b51a817$exports)))(Date.now());
function $bbaf640e8205db18$export$eaf9227667332084(randomSeed) {
    var random; // create a new random generator with given seed
    function setSeed(seed) {
        random = seed === null ? $bbaf640e8205db18$var$singletonRandom : (0, (/*@__PURE__*/$parcel$interopDefault($922020686b51a817$exports)))(String(seed));
    } // initialize a seeded pseudo random number generator with config's random seed
    setSeed(randomSeed); // wrapper function so the rng can be updated via generator
    function rng() {
        return random();
    }
    return rng;
}


var $c0c64b43e676705a$var$name = "pickRandom";
var $c0c64b43e676705a$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $c0c64b43e676705a$export$fbe25b9f25feec34 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c0c64b43e676705a$var$name, $c0c64b43e676705a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $bbaf640e8205db18$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $bbaf640e8205db18$export$eaf9227667332084)(curr.randomSeed);
    });
    /**
   * Random pick one or more values from a one dimensional array.
   * Array elements are picked using a random function with uniform or weighted distribution.
   *
   * Syntax:
   *
   *     math.pickRandom(array)
   *     math.pickRandom(array, number)
   *     math.pickRandom(array, weights)
   *     math.pickRandom(array, number, weights)
   *     math.pickRandom(array, weights, number)
   *     math.pickRandom(array, { weights, number, elementWise })
   *
   * Examples:
   *
   *     math.pickRandom([3, 6, 12, 2])                  // returns one of the values in the array
   *     math.pickRandom([3, 6, 12, 2], 2)               // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], { number: 2 })   // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1])    // returns one of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], 2, [1, 3, 2, 1]) // returns an array of two of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1], 2) // returns an array of two of the values in the array with weighted distribution
   *
   *     math.pickRandom([{x: 1.0, y: 2.0}, {x: 1.1, y: 2.0}], { elementWise: false })
   *         // returns one of the items in the array
   *
   * See also:
   *
   *     random, randomInt
   *
   * @param {Array | Matrix} array     A one dimensional array
   * @param {Int} number               An int or float
   * @param {Array | Matrix} weights   An array of ints or floats
   * @return {number | Array}          Returns a single random value from array when number is 1 or undefined.
   *                                   Returns an array with the configured number of elements when number is > 1.
   */ return typed($c0c64b43e676705a$var$name, {
        "Array | Matrix": function ArrayMatrix(possibles) {
            return _pickRandom(possibles, {});
        },
        "Array | Matrix, Object": function ArrayMatrixObject(possibles, options) {
            return _pickRandom(possibles, options);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(possibles, number) {
            return _pickRandom(possibles, {
                number: number
            });
        },
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(possibles, weights) {
            return _pickRandom(possibles, {
                weights: weights
            });
        },
        "Array | Matrix, Array | Matrix, number": function ArrayMatrixArrayMatrixNumber(possibles, weights, number) {
            return _pickRandom(possibles, {
                number: number,
                weights: weights
            });
        },
        "Array | Matrix, number, Array | Matrix": function ArrayMatrixNumberArrayMatrix(possibles, number, weights) {
            return _pickRandom(possibles, {
                number: number,
                weights: weights
            });
        }
    });
    /**
   * @param {Array | Matrix} possibles
   * @param {{
   *   number?: number,
   *   weights?: Array | Matrix,
   *   elementWise: boolean
   * }} options
   * @returns {number | Array}
   * @private
   */ function _pickRandom(possibles, _ref2) {
        var { number: number, weights: weights, elementWise: elementWise = true } = _ref2;
        var single = typeof number === "undefined";
        if (single) number = 1;
        var createMatrix = (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(possibles) ? possibles.create : (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(weights) ? weights.create : null;
        possibles = possibles.valueOf(); // get Array
        if (weights) weights = weights.valueOf(); // get Array
        if (elementWise === true) {
            possibles = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(possibles);
            weights = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(weights);
        }
        var totalWeights = 0;
        if (typeof weights !== "undefined") {
            if (weights.length !== possibles.length) throw new Error("Weights must have the same length as possibles");
            for(var i = 0, len = weights.length; i < len; i++){
                if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(weights[i]) || weights[i] < 0) throw new Error("Weights must be an array of positive numbers");
                totalWeights += weights[i];
            }
        }
        var length = possibles.length;
        var result = [];
        var pick;
        while(result.length < number){
            if (typeof weights === "undefined") pick = possibles[Math.floor(rng() * length)];
            else {
                var randKey = rng() * totalWeights;
                for(var _i = 0, _len = possibles.length; _i < _len; _i++){
                    randKey -= weights[_i];
                    if (randKey < 0) {
                        pick = possibles[_i];
                        break;
                    }
                }
            }
            result.push(pick);
        }
        return single ? result[0] : createMatrix ? createMatrix(result) : result;
    }
});






var $b170176d7e0038ab$var$name = "pinv";
var $b170176d7e0038ab$var$dependencies = [
    "typed",
    "matrix",
    "inv",
    "deepEqual",
    "equal",
    "dotDivide",
    "dot",
    "ctranspose",
    "divideScalar",
    "multiply",
    "add",
    "Complex"
];
var $b170176d7e0038ab$export$1456c5eaeee6aa07 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b170176d7e0038ab$var$name, $b170176d7e0038ab$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, inv: inv, deepEqual: deepEqual, equal: equal, dotDivide: dotDivide, dot: dot, ctranspose: ctranspose, divideScalar: divideScalar, multiply: multiply, add: add, Complex: Complex } = _ref;
    /**
   * Calculate the Moore–Penrose inverse of a matrix.
   *
   * Syntax:
   *
   *     math.pinv(x)
   *
   * Examples:
   *
   *     math.pinv([[1, 2], [3, 4]])          // returns [[-2, 1], [1.5, -0.5]]
   *     math.pinv([[1, 0], [0, 1], [0, 1]])  // returns [[1, 0, 0], [0, 0.5, 0.5]]
   *     math.pinv(4)                         // returns 0.25
   *
   * See also:
   *
   *     inv
   *
   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
   * @return {number | Complex | Array | Matrix} The inverse of `x`.
   */ return typed($b170176d7e0038ab$var$name, {
        "Array | Matrix": function ArrayMatrix(x) {
            var size = (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(x) ? x.size() : (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x);
            switch(size.length){
                case 1:
                    // vector
                    if (_isZeros(x)) return ctranspose(x); // null vector
                    if (size[0] === 1) return inv(x); // invertible matrix
                    else return dotDivide(ctranspose(x), dot(x, x));
                case 2:
                    if (_isZeros(x)) return ctranspose(x); // zero matrixx
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) try {
                        return inv(x); // invertible matrix
                    } catch (err) {
                        if (err instanceof Error && err.message.match(/Cannot calculate inverse, determinant is zero/)) ;
                        else throw err;
                    }
                    if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(x)) return matrix(_pinv(x.valueOf(), rows, cols), x.storage());
                    else // return an Array
                    return _pinv(x, rows, cols);
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
            }
        },
        any: function any(x) {
            // scalar
            if (equal(x, 0)) return (0, $33619877a15996ac$export$9cd59f9826255e47)(x); // zero
            return divideScalar(1, x);
        }
    });
    /**
   * Calculate the Moore–Penrose inverse of a matrix
   * @param {Array[]} mat     A matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns
   * @return {Array[]} pinv    Pseudoinverse matrix
   * @private
   */ function _pinv(mat, rows, cols) {
        var { C: C, F: F } = _rankFact(mat, rows, cols); // TODO: Use SVD instead (may improve precision)
        var Cpinv = multiply(inv(multiply(ctranspose(C), C)), ctranspose(C));
        var Fpinv = multiply(ctranspose(F), inv(multiply(F, ctranspose(F))));
        return multiply(Fpinv, Cpinv);
    }
    /**
   * Calculate the reduced row echelon form of a matrix
   *
   * Modified from https://rosettacode.org/wiki/Reduced_row_echelon_form
   *
   * @param {Array[]} mat     A matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns
   * @return {Array[]}        Reduced row echelon form
   * @private
   */ function _rref(mat, rows, cols) {
        var M = (0, $33619877a15996ac$export$9cd59f9826255e47)(mat);
        var lead = 0;
        for(var r = 0; r < rows; r++){
            if (cols <= lead) return M;
            var i = r;
            while(_isZero(M[i][lead])){
                i++;
                if (rows === i) {
                    i = r;
                    lead++;
                    if (cols === lead) return M;
                }
            }
            [M[i], M[r]] = [
                M[r],
                M[i]
            ];
            var val = M[r][lead];
            for(var j = 0; j < cols; j++)M[r][j] = dotDivide(M[r][j], val);
            for(var _i = 0; _i < rows; _i++){
                if (_i === r) continue;
                val = M[_i][lead];
                for(var _j = 0; _j < cols; _j++)M[_i][_j] = add(M[_i][_j], multiply(-1, multiply(val, M[r][_j])));
            }
            lead++;
        }
        return M;
    }
    /**
   * Calculate the rank factorization of a matrix
   *
   * @param {Array[]} mat                  A matrix (M)
   * @param {number} rows                  Number of rows
   * @param {number} cols                  Number of columns
   * @return {{C: Array, F: Array}}        rank factorization where M = C F
   * @private
   */ function _rankFact(mat, rows, cols) {
        var rref = _rref(mat, rows, cols);
        var C = mat.map((_, i)=>_.filter((_, j)=>j < rows && !_isZero(dot(rref[j], rref[j]))));
        var F = rref.filter((_, i)=>!_isZero(dot(rref[i], rref[i])));
        return {
            C: C,
            F: F
        };
    }
    function _isZero(x) {
        return equal(add(x, Complex(1, 1)), add(0, Complex(1, 1)));
    }
    function _isZeros(arr) {
        return deepEqual(add(arr, Complex(1, 1)), add(multiply(arr, 0), Complex(1, 1)));
    }
});





var $15bf360b0492d6be$var$name = "pow";
var $15bf360b0492d6be$var$dependencies = [
    "typed",
    "config",
    "identity",
    "multiply",
    "matrix",
    "inv",
    "fraction",
    "number",
    "Complex"
];
var $15bf360b0492d6be$export$9c94d2d08a8d8146 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($15bf360b0492d6be$var$name, $15bf360b0492d6be$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, identity: identity, multiply: multiply, matrix: matrix, inv: inv, number: number, fraction: fraction, Complex: Complex } = _ref;
    /**
   * Calculates the power of x to y, `x ^ y`.
   *
   * Matrix exponentiation is supported for square matrices `x` and integers `y`:
   * when `y` is nonnegative, `x` may be any square matrix; and when `y` is
   * negative, `x` must be invertible, and then this function returns
   * inv(x)^(-y).
   *
   * For cubic roots of negative numbers, the function returns the principal
   * root by default. In order to let the function return the real root,
   * math.js can be configured with `math.config({predictable: true})`.
   * To retrieve all cubic roots of a value, use `math.cbrt(x, true)`.
   *
   * Syntax:
   *
   *    math.pow(x, y)
   *
   * Examples:
   *
   *    math.pow(2, 3)               // returns number 8
   *
   *    const a = math.complex(2, 3)
   *    math.pow(a, 2)                // returns Complex -5 + 12i
   *
   *    const b = [[1, 2], [4, 3]]
   *    math.pow(b, 2)               // returns Array [[9, 8], [16, 17]]
   *
   *    const c = [[1, 2], [4, 3]]
   *    math.pow(c, -1)               // returns Array [[-0.6, 0.4], [0.8, -0.2]]
   *
   * See also:
   *
   *    multiply, sqrt, cbrt, nthRoot
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex} y                          The exponent
   * @return {number | BigNumber | Complex | Array | Matrix} The value of `x` to the power `y`
   */ return typed($15bf360b0492d6be$var$name, {
        "number, number": _pow,
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.pow(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            if (y.isInteger() || x >= 0 || config.predictable) return x.pow(y);
            else return new Complex(x.toNumber(), 0).pow(y.toNumber(), 0);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            var result = x.pow(y);
            if (result != null) return result;
            if (config.predictable) throw new Error("Result of pow is non-rational and cannot be expressed as a fraction");
            else return _pow(x.valueOf(), y.valueOf());
        },
        "Array, number": _powArray,
        "Array, BigNumber": function ArrayBigNumber(x, y) {
            return _powArray(x, y.toNumber());
        },
        "Matrix, number": _powMatrix,
        "Matrix, BigNumber": function MatrixBigNumber(x, y) {
            return _powMatrix(x, y.toNumber());
        },
        "Unit, number | BigNumber": function UnitNumberBigNumber(x, y) {
            return x.pow(y);
        }
    });
    /**
   * Calculates the power of x to y, x^y, for two numbers.
   * @param {number} x
   * @param {number} y
   * @return {number | Complex} res
   * @private
   */ function _pow(x, y) {
        // Alternatively could define a 'realmode' config option or something, but
        // 'predictable' will work for now
        if (config.predictable && !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(y) && x < 0) // Check to see if y can be represented as a fraction
        try {
            var yFrac = fraction(y);
            var yNum = number(yFrac);
            if (y === yNum || Math.abs((y - yNum) / y) < 1e-14) {
                if (yFrac.d % 2 === 1) return (yFrac.n % 2 === 0 ? 1 : -1) * Math.pow(-x, y);
            }
        } catch (ex) {} // Unable to express y as a fraction, so continue on
         // **for predictable mode** x^Infinity === NaN if x < -1
        // N.B. this behavour is different from `Math.pow` which gives
        // (-2)^Infinity === Infinity
        if (config.predictable && (x < -1 && y === Infinity || x > -1 && x < 0 && y === -Infinity)) return NaN;
        if ((0, $a03283b133c3c55b$export$a287f47fed4544b8)(y) || x >= 0 || config.predictable) return (0, $08ae6b2eb4bd0049$export$3f512e7fd4999e01)(x, y);
        else {
            // TODO: the following infinity checks are duplicated from powNumber. Deduplicate this somehow
            // x^Infinity === 0 if -1 < x < 1
            // A real number 0 is returned instead of complex(0)
            if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
            return new Complex(x, 0).pow(y, 0);
        }
    }
    /**
   * Calculate the power of a 2d array
   * @param {Array} x     must be a 2 dimensional, square matrix
   * @param {number} y    a integer value (positive if `x` is not invertible)
   * @returns {Array}
   * @private
   */ function _powArray(x, y) {
        if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(y)) throw new TypeError("For A^b, b must be an integer (value is " + y + ")");
         // verify that A is a 2 dimensional square matrix
        var s = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(x);
        if (s.length !== 2) throw new Error("For A^b, A must be 2 dimensional (A has " + s.length + " dimensions)");
        if (s[0] !== s[1]) throw new Error("For A^b, A must be square (size is " + s[0] + "x" + s[1] + ")");
        if (y < 0) try {
            return _powArray(inv(x), -y);
        } catch (error) {
            if (error.message === "Cannot calculate inverse, determinant is zero") throw new TypeError("For A^b, when A is not invertible, b must be a positive integer (value is " + y + ")");
            throw error;
        }
        var res = identity(s[0]).valueOf();
        var px = x;
        while(y >= 1){
            if ((y & 1) === 1) res = multiply(px, res);
            y >>= 1;
            px = multiply(px, px);
        }
        return res;
    }
    /**
   * Calculate the power of a 2d matrix
   * @param {Matrix} x     must be a 2 dimensional, square matrix
   * @param {number} y    a positive, integer value
   * @returns {Matrix}
   * @private
   */ function _powMatrix(x, y) {
        return matrix(_powArray(x.valueOf(), y));
    }
});




var $d1a9199bb0046643$var$name = "print";
var $d1a9199bb0046643$var$dependencies = [
    "typed"
];
var $d1a9199bb0046643$export$ea4b9d9569ff81cc = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d1a9199bb0046643$var$name, $d1a9199bb0046643$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Interpolate values into a string template.
   *
   * Syntax:
   *
   *     math.print(template, values)
   *     math.print(template, values, precision)
   *     math.print(template, values, options)
   *
   * Example usage:
   *
   *     // the following outputs: 'Lucy is 5 years old'
   *     math.print('Lucy is $age years old', {age: 5})
   *
   *     // the following outputs: 'The value of pi is 3.141592654'
   *     math.print('The value of pi is $pi', {pi: math.pi}, 10)
   *
   *     // the following outputs: 'hello Mary! The date is 2013-03-23'
   *     math.print('Hello $user.name! The date is $date', {
   *       user: {
   *         name: 'Mary',
   *       },
   *       date: new Date(2013, 2, 23).toISOString().substring(0, 10)
   *     })
   *
   *     // the following outputs: 'My favorite fruits are apples and bananas !'
   *     math.print('My favorite fruits are $0 and $1 !', [
   *       'apples',
   *       'bananas'
   *     ])
   *
   * See also:
   *
   *     format
   *
   * @param {string} template           A string containing variable placeholders.
   * @param {Object | Array | Matrix}   values An object or array containing variables
   *                                    which will be filled in in the template.
   * @param {number | Object} [options] Formatting options,
   *                                    or the number of digits to format numbers.
   *                                    See function math.format for a description
   *                                    of all options.
   * @return {string} Interpolated string
   */ return typed($d1a9199bb0046643$var$name, {
        // note: Matrix will be converted automatically to an Array
        "string, Object | Array": $d1a9199bb0046643$var$_print,
        "string, Object | Array, number | Object": $d1a9199bb0046643$var$_print
    });
});
/**
 * Interpolate values into a string template.
 * @param {string} template
 * @param {Object} values
 * @param {number | Object} [options]
 * @returns {string} Interpolated string
 * @private
 */ function $d1a9199bb0046643$var$_print(template, values, options) {
    return template.replace(/\$([\w.]+)/g, function(original, key) {
        var keys = key.split(".");
        var value = values[keys.shift()];
        while(keys.length && value !== undefined){
            var k = keys.shift();
            value = k ? value[k] : value + ".";
        }
        if (value !== undefined) {
            if (!(0, $2c4f948f17aa2240$export$844ec244b1367d54)(value)) return (0, $addf7cb66573d3e4$export$d9468344d3651243)(value, options);
            else return value;
        }
        return original;
    });
}




var $5c3ba90b076e82c1$var$name = "prod";
var $5c3ba90b076e82c1$var$dependencies = [
    "typed",
    "config",
    "multiplyScalar",
    "numeric"
];
var $5c3ba90b076e82c1$export$60310f756e9cfd41 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($5c3ba90b076e82c1$var$name, $5c3ba90b076e82c1$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, numeric: numeric } = _ref;
    /**
   * Compute the product of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.prod(a, b, c, ...)
   *     math.prod(A)
   *
   * Examples:
   *
   *     math.multiply(2, 3)           // returns 6
   *     math.prod(2, 3)               // returns 6
   *     math.prod(2, 3, 4)            // returns 24
   *     math.prod([2, 3, 4])          // returns 24
   *     math.prod([[2, 5], [4, 3]])   // returns 120
   *
   * See also:
   *
   *    mean, median, min, max, sum, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The product of all values
   */ return typed($5c3ba90b076e82c1$var$name, {
        // prod([a, b, c, d, ...])
        "Array | Matrix": _prod,
        // prod([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement prod(A, dim)
            throw new Error("prod(A, dim) is not yet supported"); // return reduce(arguments[0], arguments[1], math.prod)
        },
        // prod(a, b, c, d, ...)
        "...": function _(args) {
            return _prod(args);
        }
    });
    /**
   * Recursively calculate the product of an n-dimensional array
   * @param {Array} array
   * @return {number} prod
   * @private
   */ function _prod(array) {
        var prod;
        (0, $cd13353fc76500f7$export$519ada94592b97fc)(array, function(value) {
            try {
                prod = prod === undefined ? value : multiplyScalar(prod, value);
            } catch (err) {
                throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "prod", value);
            }
        }); // make sure returning numeric value: parse a string into a numeric value
        if (typeof prod === "string") prod = numeric(prod, config.number);
        if (prod === undefined) throw new Error("Cannot calculate prod of an empty array");
        return prod;
    }
});



var $c0e7843ca654b723$var$name = "qr";
var $c0e7843ca654b723$var$dependencies = [
    "typed",
    "matrix",
    "zeros",
    "identity",
    "isZero",
    "equal",
    "sign",
    "sqrt",
    "conj",
    "unaryMinus",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "complex"
];
var $c0e7843ca654b723$export$39b52312ba2c4d03 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c0e7843ca654b723$var$name, $c0e7843ca654b723$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, zeros: zeros, identity: identity, isZero: isZero, equal: equal, sign: sign, sqrt: sqrt, conj: conj, unaryMinus: unaryMinus, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, complex: complex } = _ref;
    /**
   * Calculate the Matrix QR decomposition. Matrix `A` is decomposed in
   * two matrices (`Q`, `R`) where `Q` is an
   * orthogonal matrix and `R` is an upper triangular matrix.
   *
   * Syntax:
   *
   *    math.qr(A)
   *
   * Example:
   *
   *    const m = [
   *      [1, -1,  4],
   *      [1,  4, -2],
   *      [1,  4,  2],
   *      [1,  -1, 0]
   *    ]
   *    const result = math.qr(m)
   *    // r = {
   *    //   Q: [
   *    //     [0.5, -0.5,   0.5],
   *    //     [0.5,  0.5,  -0.5],
   *    //     [0.5,  0.5,   0.5],
   *    //     [0.5, -0.5,  -0.5],
   *    //   ],
   *    //   R: [
   *    //     [2, 3,  2],
   *    //     [0, 5, -2],
   *    //     [0, 0,  4],
   *    //     [0, 0,  0]
   *    //   ]
   *    // }
   *
   * See also:
   *
   *    lup, lusolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array
   * for which to get the QR decomposition.
   *
   * @return {{Q: Array | Matrix, R: Array | Matrix}} Q: the orthogonal
   * matrix and R: the upper triangular matrix
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))(typed($c0e7843ca654b723$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseQR(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseQR(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a); // lup, use matrix implementation
            var r = _denseQR(m); // result
            return {
                Q: r.Q.valueOf(),
                R: r.R.valueOf()
            };
        }
    }), {
        _denseQRimpl: _denseQRimpl
    });
    function _denseQRimpl(m) {
        // rows & columns (m x n)
        var rows = m._size[0]; // m
        var cols = m._size[1]; // n
        var Q = identity([
            rows
        ], "dense");
        var Qdata = Q._data;
        var R = m.clone();
        var Rdata = R._data; // vars
        var i, j, k;
        var w = zeros([
            rows
        ], "");
        for(k = 0; k < Math.min(cols, rows); ++k){
            /*
       * **k-th Household matrix**
       *
       * The matrix I - 2*v*transpose(v)
       * x     = first column of A
       * x1    = first element of x
       * alpha = x1 / |x1| * |x|
       * e1    = tranpose([1, 0, 0, ...])
       * u     = x - alpha * e1
       * v     = u / |u|
       *
       * Household matrix = I - 2 * v * tranpose(v)
       *
       *  * Initially Q = I and R = A.
       *  * Household matrix is a reflection in a plane normal to v which
       *    will zero out all but the top right element in R.
       *  * Appplying reflection to both Q and R will not change product.
       *  * Repeat this process on the (1,1) minor to get R as an upper
       *    triangular matrix.
       *  * Reflections leave the magnitude of the columns of Q unchanged
       *    so Q remains othoganal.
       *
       */ var pivot = Rdata[k][k];
            var sgn = unaryMinus(equal(pivot, 0) ? 1 : sign(pivot));
            var conjSgn = conj(sgn);
            var alphaSquared = 0;
            for(i = k; i < rows; i++)alphaSquared = addScalar(alphaSquared, multiplyScalar(Rdata[i][k], conj(Rdata[i][k])));
            var alpha = multiplyScalar(sgn, sqrt(alphaSquared));
            if (!isZero(alpha)) {
                // first element in vector u
                var u1 = subtract(pivot, alpha); // w = v * u1 / |u|    (only elements k to (rows-1) are used)
                w[k] = 1;
                for(i = k + 1; i < rows; i++)w[i] = divideScalar(Rdata[i][k], u1);
                 // tau = - conj(u1 / alpha)
                var tau = unaryMinus(conj(divideScalar(u1, alpha)));
                var s = void 0;
                /*
         * tau and w have been choosen so that
         *
         * 2 * v * tranpose(v) = tau * w * tranpose(w)
         */ /*
         * -- calculate R = R - tau * w * tranpose(w) * R --
         * Only do calculation with rows k to (rows-1)
         * Additionally columns 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(j = k; j < cols; j++){
                    s = 0.0; // calculate jth element of [tranpose(w) * R]
                    for(i = k; i < rows; i++)s = addScalar(s, multiplyScalar(conj(w[i]), Rdata[i][j]));
                     // calculate the jth element of [tau * transpose(w) * R]
                    s = multiplyScalar(s, tau);
                    for(i = k; i < rows; i++)Rdata[i][j] = multiplyScalar(subtract(Rdata[i][j], multiplyScalar(w[i], s)), conjSgn);
                }
                /*
         * -- calculate Q = Q - tau * Q * w * transpose(w) --
         * Q is a square matrix (rows x rows)
         * Only do calculation with columns k to (rows-1)
         * Additionally rows 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(i = 0; i < rows; i++){
                    s = 0.0; // calculate ith element of [Q * w]
                    for(j = k; j < rows; j++)s = addScalar(s, multiplyScalar(Qdata[i][j], w[j]));
                     // calculate the ith element of [tau * Q * w]
                    s = multiplyScalar(s, tau);
                    for(j = k; j < rows; ++j)Qdata[i][j] = divideScalar(subtract(Qdata[i][j], multiplyScalar(s, conj(w[j]))), conjSgn);
                }
            }
        } // return matrices
        return {
            Q: Q,
            R: R,
            toString: function toString() {
                return "Q: " + this.Q.toString() + "\nR: " + this.R.toString();
            }
        };
    }
    function _denseQR(m) {
        var ret = _denseQRimpl(m);
        var Rdata = ret.R._data;
        if (m._data.length > 0) {
            var zero = Rdata[0][0].type === "Complex" ? complex(0) : 0;
            for(var i = 0; i < Rdata.length; ++i)for(var j = 0; j < i && j < (Rdata[0] || []).length; ++j)Rdata[i][j] = zero;
        }
        return ret;
    }
    function _sparseQR(m) {
        throw new Error("qr not implemented for sparse matrices yet");
    }
});





var $fc8c3b9f19fe3038$var$name = "quantileSeq";
var $fc8c3b9f19fe3038$var$dependencies = [
    "typed",
    "add",
    "multiply",
    "partitionSelect",
    "compare"
];
var $fc8c3b9f19fe3038$export$524607d17ea053e9 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($fc8c3b9f19fe3038$var$name, $fc8c3b9f19fe3038$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, multiply: multiply, partitionSelect: partitionSelect, compare: compare } = _ref;
    /**
   * Compute the prob order quantile of a matrix or a list with values.
   * The sequence is sorted and the middle value is returned.
   * Supported types of sequence values are: Number, BigNumber, Unit
   * Supported types of probability are: Number, BigNumber
   *
   * In case of a (multi dimensional) array or matrix, the prob order quantile
   * of all elements will be calculated.
   *
   * Syntax:
   *
   *     math.quantileSeq(A, prob[, sorted])
   *     math.quantileSeq(A, [prob1, prob2, ...][, sorted])
   *     math.quantileSeq(A, N[, sorted])
   *
   * Examples:
   *
   *     math.quantileSeq([3, -1, 5, 7], 0.5)         // returns 4
   *     math.quantileSeq([3, -1, 5, 7], [1/3, 2/3])  // returns [3, 5]
   *     math.quantileSeq([3, -1, 5, 7], 2)           // returns [3, 5]
   *     math.quantileSeq([-1, 3, 5, 7], 0.5, true)   // returns 4
   *
   * See also:
   *
   *     median, mean, min, max, sum, prod, std, variance
   *
   * @param {Array, Matrix} data                A single matrix or Array
   * @param {Number, BigNumber, Array} probOrN  prob is the order of the quantile, while N is
   *                                            the amount of evenly distributed steps of
   *                                            probabilities; only one of these options can
   *                                            be provided
   * @param {Boolean} sorted=false              is data sorted in ascending order
   * @return {Number, BigNumber, Unit, Array}   Quantile(s)
   */ function quantileSeq(data, probOrN, sorted) {
        var probArr, dataArr, one;
        if (arguments.length < 2 || arguments.length > 3) throw new SyntaxError("Function quantileSeq requires two or three parameters");
        if ((0, $2c4f948f17aa2240$export$cea7aa84e978eba5)(data)) {
            sorted = sorted || false;
            if (typeof sorted === "boolean") {
                dataArr = data.valueOf();
                if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(probOrN)) {
                    if (probOrN < 0) throw new Error("N/prob must be non-negative");
                    if (probOrN <= 1) // quantileSeq([a, b, c, d, ...], prob[,sorted])
                    return _quantileSeq(dataArr, probOrN, sorted);
                    if (probOrN > 1) {
                        // quantileSeq([a, b, c, d, ...], N[,sorted])
                        if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(probOrN)) throw new Error("N must be a positive integer");
                        var nPlusOne = probOrN + 1;
                        probArr = new Array(probOrN);
                        for(var i = 0; i < probOrN;)probArr[i] = _quantileSeq(dataArr, ++i / nPlusOne, sorted);
                        return probArr;
                    }
                }
                if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(probOrN)) {
                    var BigNumber = probOrN.constructor;
                    if (probOrN.isNegative()) throw new Error("N/prob must be non-negative");
                    one = new BigNumber(1);
                    if (probOrN.lte(one)) // quantileSeq([a, b, c, d, ...], prob[,sorted])
                    return new BigNumber(_quantileSeq(dataArr, probOrN, sorted));
                    if (probOrN.gt(one)) {
                        // quantileSeq([a, b, c, d, ...], N[,sorted])
                        if (!probOrN.isInteger()) throw new Error("N must be a positive integer");
                         // largest possible Array length is 2^32-1
                        // 2^32 < 10^15, thus safe conversion guaranteed
                        var intN = probOrN.toNumber();
                        if (intN > 4294967295) throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
                        var _nPlusOne = new BigNumber(intN + 1);
                        probArr = new Array(intN);
                        for(var _i = 0; _i < intN;)probArr[_i] = new BigNumber(_quantileSeq(dataArr, new BigNumber(++_i).div(_nPlusOne), sorted));
                        return probArr;
                    }
                }
                if (Array.isArray(probOrN)) {
                    // quantileSeq([a, b, c, d, ...], [prob1, prob2, ...][,sorted])
                    probArr = new Array(probOrN.length);
                    for(var _i2 = 0; _i2 < probArr.length; ++_i2){
                        var currProb = probOrN[_i2];
                        if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(currProb)) {
                            if (currProb < 0 || currProb > 1) throw new Error("Probability must be between 0 and 1, inclusive");
                        } else if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(currProb)) {
                            one = new currProb.constructor(1);
                            if (currProb.isNegative() || currProb.gt(one)) throw new Error("Probability must be between 0 and 1, inclusive");
                        } else throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
                        probArr[_i2] = _quantileSeq(dataArr, currProb, sorted);
                    }
                    return probArr;
                }
                throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
            }
            throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
        }
        throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
    }
    /**
   * Calculate the prob order quantile of an n-dimensional array.
   *
   * @param {Array} array
   * @param {Number, BigNumber} prob
   * @param {Boolean} sorted
   * @return {Number, BigNumber, Unit} prob order quantile
   * @private
   */ function _quantileSeq(array, prob, sorted) {
        var flat = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(array);
        var len = flat.length;
        if (len === 0) throw new Error("Cannot calculate quantile of an empty sequence");
        if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(prob)) {
            var _index = prob * (len - 1);
            var _fracPart = _index % 1;
            if (_fracPart === 0) {
                var value = sorted ? flat[_index] : partitionSelect(flat, _index);
                validate(value);
                return value;
            }
            var _integerPart = Math.floor(_index);
            var _left;
            var _right;
            if (sorted) {
                _left = flat[_integerPart];
                _right = flat[_integerPart + 1];
            } else {
                _right = partitionSelect(flat, _integerPart + 1); // max of partition is kth largest
                _left = flat[_integerPart];
                for(var i = 0; i < _integerPart; ++i)if (compare(flat[i], _left) > 0) _left = flat[i];
            }
            validate(_left);
            validate(_right); // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
            return add(multiply(_left, 1 - _fracPart), multiply(_right, _fracPart));
        } // If prob is a BigNumber
        var index = prob.times(len - 1);
        if (index.isInteger()) {
            index = index.toNumber();
            var _value = sorted ? flat[index] : partitionSelect(flat, index);
            validate(_value);
            return _value;
        }
        var integerPart = index.floor();
        var fracPart = index.minus(integerPart);
        var integerPartNumber = integerPart.toNumber();
        var left;
        var right;
        if (sorted) {
            left = flat[integerPartNumber];
            right = flat[integerPartNumber + 1];
        } else {
            right = partitionSelect(flat, integerPartNumber + 1); // max of partition is kth largest
            left = flat[integerPartNumber];
            for(var _i3 = 0; _i3 < integerPartNumber; ++_i3)if (compare(flat[_i3], left) > 0) left = flat[_i3];
        }
        validate(left);
        validate(right); // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
        var one = new fracPart.constructor(1);
        return add(multiply(left, one.minus(fracPart)), multiply(right, fracPart));
    }
    /**
   * Check if array value types are valid, throw error otherwise.
   * @param {number | BigNumber | Unit} x
   * @param {number | BigNumber | Unit} x
   * @private
   */ var validate = typed({
        "number | BigNumber | Unit": function numberBigNumberUnit(x) {
            return x;
        }
    });
    return quantileSeq;
});




/**
 * This is a util function for generating a random matrix recursively.
 * @param {number[]} size
 * @param {function} random
 * @returns {Array}
 */ function $726f6d7ecb32dc78$export$6549281d357a44ec(size, random) {
    var data = [];
    size = size.slice(0);
    if (size.length > 1) for(var i = 0, length = size.shift(); i < length; i++)data.push($726f6d7ecb32dc78$export$6549281d357a44ec(size, random));
    else for(var _i = 0, _length = size.shift(); _i < _length; _i++)data.push(random());
    return data;
}


var $b01d6fe4f5379b79$var$name = "random";
var $b01d6fe4f5379b79$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $b01d6fe4f5379b79$export$5c03d20f483e909a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b01d6fe4f5379b79$var$name, $b01d6fe4f5379b79$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $bbaf640e8205db18$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $bbaf640e8205db18$export$eaf9227667332084)(curr.randomSeed);
    });
    /**
   * Return a random number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.random()                // generate a random number between 0 and 1
   *     math.random(max)             // generate a random number between 0 and max
   *     math.random(min, max)        // generate a random number between min and max
   *     math.random(size)            // generate a matrix with random numbers between 0 and 1
   *     math.random(size, max)       // generate a matrix with random numbers between 0 and max
   *     math.random(size, min, max)  // generate a matrix with random numbers between min and max
   *
   * Examples:
   *
   *     math.random()       // returns a random number between 0 and 1
   *     math.random(100)    // returns a random number between 0 and 100
   *     math.random(30, 40) // returns a random number between 30 and 40
   *     math.random([2, 3]) // returns a 2x3 matrix with random numbers between 0 and 1
   *
   * See also:
   *
   *     randomInt, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random number
   */ return typed($b01d6fe4f5379b79$var$name, {
        "": ()=>_random(0, 1),
        number: (max)=>_random(0, max),
        "number, number": (min, max)=>_random(min, max),
        "Array | Matrix": (size)=>_randomMatrix(size, 0, 1),
        "Array | Matrix, number": (size, max)=>_randomMatrix(size, 0, max),
        "Array | Matrix, number, number": (size, min, max)=>_randomMatrix(size, min, max)
    });
    function _randomMatrix(size, min, max) {
        var res = (0, $726f6d7ecb32dc78$export$6549281d357a44ec)(size.valueOf(), ()=>_random(min, max));
        return (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(size) ? size.create(res) : res;
    }
    function _random(min, max) {
        return min + rng() * (max - min);
    }
}); // number only implementation of random, no matrix support
var $b01d6fe4f5379b79$export$267a132af241f602 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b01d6fe4f5379b79$var$name, [
    "typed",
    "config",
    "?on"
], (_ref2)=>{
    var { typed: typed, config: config, on: on, matrix: matrix } = _ref2;
    // seeded pseudo random number generator1
    var rng = (0, $bbaf640e8205db18$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $bbaf640e8205db18$export$eaf9227667332084)(curr.randomSeed);
    });
    return typed($b01d6fe4f5379b79$var$name, {
        "": ()=>_random(0, 1),
        number: (max)=>_random(0, max),
        "number, number": (min, max)=>_random(min, max)
    });
    function _random(min, max) {
        return min + rng() * (max - min);
    }
});





var $c59a322413f08e7c$var$name = "randomInt";
var $c59a322413f08e7c$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $c59a322413f08e7c$export$e158da47ae479dd4 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c59a322413f08e7c$var$name, $c59a322413f08e7c$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $bbaf640e8205db18$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $bbaf640e8205db18$export$eaf9227667332084)(curr.randomSeed);
    });
    /**
   * Return a random integer number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.randomInt()                // generate a random integer between 0 and 1
   *     math.randomInt(max)             // generate a random integer between 0 and max
   *     math.randomInt(min, max)        // generate a random integer between min and max
   *     math.randomInt(size)            // generate a matrix with random integer between 0 and 1
   *     math.randomInt(size, max)       // generate a matrix with random integer between 0 and max
   *     math.randomInt(size, min, max)  // generate a matrix with random integer between min and max
   *
   * Examples:
   *
   *     math.randomInt(100)    // returns a random integer between 0 and 100
   *     math.randomInt(30, 40) // returns a random integer between 30 and 40
   *     math.randomInt([2, 3]) // returns a 2x3 matrix with random integers between 0 and 1
   *
   * See also:
   *
   *     random, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random integer value
   */ return typed($c59a322413f08e7c$var$name, {
        "": ()=>_randomInt(0, 1),
        number: (max)=>_randomInt(0, max),
        "number, number": (min, max)=>_randomInt(min, max),
        "Array | Matrix": (size)=>_randomIntMatrix(size, 0, 1),
        "Array | Matrix, number": (size, max)=>_randomIntMatrix(size, 0, max),
        "Array | Matrix, number, number": (size, min, max)=>_randomIntMatrix(size, min, max)
    });
    function _randomIntMatrix(size, min, max) {
        var res = (0, $726f6d7ecb32dc78$export$6549281d357a44ec)(size.valueOf(), ()=>_randomInt(min, max));
        return (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(size) ? size.create(res) : res;
    }
    function _randomInt(min, max) {
        return Math.floor(min + rng() * (max - min));
    }
});



var $1f3643faa6d2156c$var$name = "range";
var $1f3643faa6d2156c$var$dependencies = [
    "typed",
    "config",
    "?matrix",
    "?bignumber",
    "smaller",
    "smallerEq",
    "larger",
    "largerEq"
];
var $1f3643faa6d2156c$export$d372f2f3c4d1b8e5 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1f3643faa6d2156c$var$name, $1f3643faa6d2156c$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, bignumber: bignumber, smaller: smaller, smallerEq: smallerEq, larger: larger, largerEq: largerEq } = _ref;
    /**
   * Create an array from a range.
   * By default, the range end is excluded. This can be customized by providing
   * an extra parameter `includeEnd`.
   *
   * Syntax:
   *
   *     math.range(str [, includeEnd])               // Create a range from a string,
   *                                                  // where the string contains the
   *                                                  // start, optional step, and end,
   *                                                  // separated by a colon.
   *     math.range(start, end [, includeEnd])        // Create a range with start and
   *                                                  // end and a step size of 1.
   *     math.range(start, end, step [, includeEnd])  // Create a range with start, step,
   *                                                  // and end.
   *
   * Where:
   *
   * - `str: string`
   *   A string 'start:end' or 'start:step:end'
   * - `start: {number | BigNumber}`
   *   Start of the range
   * - `end: number | BigNumber`
   *   End of the range, excluded by default, included when parameter includeEnd=true
   * - `step: number | BigNumber`
   *   Step size. Default value is 1.
   * - `includeEnd: boolean`
   *   Option to specify whether to include the end or not. False by default.
   *
   * Examples:
   *
   *     math.range(2, 6)        // [2, 3, 4, 5]
   *     math.range(2, -3, -1)   // [2, 1, 0, -1, -2]
   *     math.range('2:1:6')     // [2, 3, 4, 5]
   *     math.range(2, 6, true)  // [2, 3, 4, 5, 6]
   *
   * See also:
   *
   *     ones, zeros, size, subset
   *
   * @param {*} args   Parameters describing the ranges `start`, `end`, and optional `step`.
   * @return {Array | Matrix} range
   */ return typed($1f3643faa6d2156c$var$name, {
        // TODO: simplify signatures when typed-function supports default values and optional arguments
        // TODO: a number or boolean should not be converted to string here
        string: _strRange,
        "string, boolean": _strRange,
        "number, number": function numberNumber(start, end) {
            return _out(_rangeEx(start, end, 1));
        },
        "number, number, number": function numberNumberNumber(start, end, step) {
            return _out(_rangeEx(start, end, step));
        },
        "number, number, boolean": function numberNumberBoolean(start, end, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, 1)) : _out(_rangeEx(start, end, 1));
        },
        "number, number, number, boolean": function numberNumberNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, step)) : _out(_rangeEx(start, end, step));
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(start, end) {
            var BigNumber = start.constructor;
            return _out(_bigRangeEx(start, end, new BigNumber(1)));
        },
        "BigNumber, BigNumber, BigNumber": function BigNumberBigNumberBigNumber(start, end, step) {
            return _out(_bigRangeEx(start, end, step));
        },
        "BigNumber, BigNumber, boolean": function BigNumberBigNumberBoolean(start, end, includeEnd) {
            var BigNumber = start.constructor;
            return includeEnd ? _out(_bigRangeInc(start, end, new BigNumber(1))) : _out(_bigRangeEx(start, end, new BigNumber(1)));
        },
        "BigNumber, BigNumber, BigNumber, boolean": function BigNumberBigNumberBigNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_bigRangeInc(start, end, step)) : _out(_bigRangeEx(start, end, step));
        }
    });
    function _out(arr) {
        if (config.matrix === "Matrix") return matrix ? matrix(arr) : (0, $59e7e238555a97e6$export$b81416cb7ecca475)();
        return arr;
    }
    function _strRange(str, includeEnd) {
        var r = _parse(str);
        if (!r) throw new SyntaxError('String "' + str + '" is no valid range');
        var fn;
        if (config.number === "BigNumber") {
            if (bignumber === undefined) (0, $59e7e238555a97e6$export$f0829713dc162a8)();
            fn = includeEnd ? _bigRangeInc : _bigRangeEx;
            return _out(fn(bignumber(r.start), bignumber(r.end), bignumber(r.step)));
        } else {
            fn = includeEnd ? _rangeInc : _rangeEx;
            return _out(fn(r.start, r.end, r.step));
        }
    }
    /**
   * Create a range with numbers. End is excluded
   * @param {number} start
   * @param {number} end
   * @param {number} step
   * @returns {Array} range
   * @private
   */ function _rangeEx(start, end, step) {
        var array = [];
        var x = start;
        if (step > 0) while(smaller(x, end)){
            array.push(x);
            x += step;
        }
        else if (step < 0) while(larger(x, end)){
            array.push(x);
            x += step;
        }
        return array;
    }
    /**
   * Create a range with numbers. End is included
   * @param {number} start
   * @param {number} end
   * @param {number} step
   * @returns {Array} range
   * @private
   */ function _rangeInc(start, end, step) {
        var array = [];
        var x = start;
        if (step > 0) while(smallerEq(x, end)){
            array.push(x);
            x += step;
        }
        else if (step < 0) while(largerEq(x, end)){
            array.push(x);
            x += step;
        }
        return array;
    }
    /**
   * Create a range with big numbers. End is excluded
   * @param {BigNumber} start
   * @param {BigNumber} end
   * @param {BigNumber} step
   * @returns {Array} range
   * @private
   */ function _bigRangeEx(start, end, step) {
        var zero = bignumber(0);
        var array = [];
        var x = start;
        if (step.gt(zero)) while(smaller(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        else if (step.lt(zero)) while(larger(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        return array;
    }
    /**
   * Create a range with big numbers. End is included
   * @param {BigNumber} start
   * @param {BigNumber} end
   * @param {BigNumber} step
   * @returns {Array} range
   * @private
   */ function _bigRangeInc(start, end, step) {
        var zero = bignumber(0);
        var array = [];
        var x = start;
        if (step.gt(zero)) while(smallerEq(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        else if (step.lt(zero)) while(largerEq(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        return array;
    }
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @param {string} str
   * @return {{start: number, end: number, step: number} | null} range Object containing properties start, end, step
   * @private
   */ function _parse(str) {
        var args = str.split(":"); // number
        var nums = args.map(function(arg) {
            // use Number and not parseFloat as Number returns NaN on invalid garbage in the string
            return Number(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return {
                    start: nums[0],
                    end: nums[1],
                    step: 1
                };
            case 3:
                return {
                    start: nums[0],
                    end: nums[2],
                    step: nums[1]
                };
            default:
                return null;
        }
    }
});




var $8bf602457c875317$var$name = "Range";
var $8bf602457c875317$var$dependencies = [];
var $8bf602457c875317$export$e87cc8d3f29c5e1b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8bf602457c875317$var$name, $8bf602457c875317$var$dependencies, ()=>{
    /**
   * Create a range. A range has a start, step, and end, and contains functions
   * to iterate over the range.
   *
   * A range can be constructed as:
   *
   *     const range = new Range(start, end)
   *     const range = new Range(start, end, step)
   *
   * To get the result of the range:
   *     range.forEach(function (x) {
   *         console.log(x)
   *     })
   *     range.map(function (x) {
   *         return math.sin(x)
   *     })
   *     range.toArray()
   *
   * Example usage:
   *
   *     const c = new Range(2, 6)       // 2:1:5
   *     c.toArray()                     // [2, 3, 4, 5]
   *     const d = new Range(2, -3, -1)  // 2:-1:-2
   *     d.toArray()                     // [2, 1, 0, -1, -2]
   *
   * @class Range
   * @constructor Range
   * @param {number} start  included lower bound
   * @param {number} end    excluded upper bound
   * @param {number} [step] step size, default value is 1
   */ function Range(start, end, step) {
        if (!(this instanceof Range)) throw new SyntaxError("Constructor must be called with the new operator");
        var hasStart = start !== null && start !== undefined;
        var hasEnd = end !== null && end !== undefined;
        var hasStep = step !== null && step !== undefined;
        if (hasStart) {
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(start)) start = start.toNumber();
            else if (typeof start !== "number") throw new TypeError("Parameter start must be a number");
        }
        if (hasEnd) {
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(end)) end = end.toNumber();
            else if (typeof end !== "number") throw new TypeError("Parameter end must be a number");
        }
        if (hasStep) {
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(step)) step = step.toNumber();
            else if (typeof step !== "number") throw new TypeError("Parameter step must be a number");
        }
        this.start = hasStart ? parseFloat(start) : 0;
        this.end = hasEnd ? parseFloat(end) : 0;
        this.step = hasStep ? parseFloat(step) : 1;
    }
    /**
   * Attach type information
   */ Range.prototype.type = "Range";
    Range.prototype.isRange = true;
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @memberof Range
   * @param {string} str
   * @return {Range | null} range
   */ Range.parse = function(str) {
        if (typeof str !== "string") return null;
        var args = str.split(":");
        var nums = args.map(function(arg) {
            return parseFloat(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return new Range(nums[0], nums[1]);
            case 3:
                return new Range(nums[0], nums[2], nums[1]);
            default:
                return null;
        }
    };
    /**
   * Create a clone of the range
   * @return {Range} clone
   */ Range.prototype.clone = function() {
        return new Range(this.start, this.end, this.step);
    };
    /**
   * Retrieve the size of the range.
   * Returns an array containing one number, the number of elements in the range.
   * @memberof Range
   * @returns {number[]} size
   */ Range.prototype.size = function() {
        var len = 0;
        var start = this.start;
        var step = this.step;
        var end = this.end;
        var diff = end - start;
        if ((0, $a03283b133c3c55b$export$c5552dfdbc7cec71)(step) === (0, $a03283b133c3c55b$export$c5552dfdbc7cec71)(diff)) len = Math.ceil(diff / step);
        else if (diff === 0) len = 0;
        if (isNaN(len)) len = 0;
        return [
            len
        ];
    };
    /**
   * Calculate the minimum value in the range
   * @memberof Range
   * @return {number | undefined} min
   */ Range.prototype.min = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start;
            else // negative step
            return this.start + (size - 1) * this.step;
        } else return undefined;
    };
    /**
   * Calculate the maximum value in the range
   * @memberof Range
   * @return {number | undefined} max
   */ Range.prototype.max = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start + (size - 1) * this.step;
            else // negative step
            return this.start;
        } else return undefined;
    };
    /**
   * Execute a callback function for each value in the range.
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Range being traversed.
   */ Range.prototype.forEach = function(callback) {
        var x = this.start;
        var step = this.step;
        var end = this.end;
        var i = 0;
        if (step > 0) while(x < end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
        else if (step < 0) while(x > end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
    };
    /**
   * Execute a callback function for each value in the Range, and return the
   * results as an array
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @returns {Array} array
   */ Range.prototype.map = function(callback) {
        var array = [];
        this.forEach(function(value, index, obj) {
            array[index[0]] = callback(value, index, obj);
        });
        return array;
    };
    /**
   * Create an Array with a copy of the Ranges data
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.toArray = function() {
        var array = [];
        this.forEach(function(value, index) {
            array[index[0]] = value;
        });
        return array;
    };
    /**
   * Get the primitive value of the Range, a one dimensional array
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.valueOf = function() {
        // TODO: implement a caching mechanism for range.valueOf()
        return this.toArray();
    };
    /**
   * Get a string representation of the range, with optional formatting options.
   * Output is formatted as 'start:step:end', for example '2:6' or '0:0.2:11'
   * @memberof Range
   * @param {Object | number | function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Range.prototype.format = function(options) {
        var str = (0, $a03283b133c3c55b$export$d9468344d3651243)(this.start, options);
        if (this.step !== 1) str += ":" + (0, $a03283b133c3c55b$export$d9468344d3651243)(this.step, options);
        str += ":" + (0, $a03283b133c3c55b$export$d9468344d3651243)(this.end, options);
        return str;
    };
    /**
   * Get a string representation of the range.
   * @memberof Range
   * @returns {string}
   */ Range.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the range
   * @memberof Range
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   */ Range.prototype.toJSON = function() {
        return {
            mathjs: "Range",
            start: this.start,
            end: this.end,
            step: this.step
        };
    };
    /**
   * Instantiate a Range from a JSON object
   * @memberof Range
   * @param {Object} json A JSON object structured as:
   *                      `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   * @return {Range}
   */ Range.fromJSON = function(json) {
        return new Range(json.start, json.end, json.step);
    };
    return Range;
}, {
    isClass: true
});



var $e295fdb9427861e0$var$name = "re";
var $e295fdb9427861e0$var$dependencies = [
    "typed"
];
var $e295fdb9427861e0$export$803e46d0de790dbf = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e295fdb9427861e0$var$name, $e295fdb9427861e0$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Get the real part of a complex number.
   * For a complex number `a + bi`, the function returns `a`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.re(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number 0
   *    math.re(math.complex(2.4))     // returns number 2.4
   *
   * See also:
   *
   *    im, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The real part of x
   */ return typed($e295fdb9427861e0$var$name, {
        number: function number(x) {
            return x;
        },
        BigNumber: function BigNumber(x) {
            return x;
        },
        Fraction: function Fraction(x) {
            return x;
        },
        Complex: function Complex(x) {
            return x.re;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});


var $51a943c5fd7f2a04$var$name = "replacer";
var $51a943c5fd7f2a04$var$dependencies = [];
var $51a943c5fd7f2a04$export$481a522c866104eb = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($51a943c5fd7f2a04$var$name, $51a943c5fd7f2a04$var$dependencies, ()=>{
    /**
   * Stringify data types into their JSON representation.
   * Most data types can be serialized using their `.toJSON` method,
   * but not all, for example the number `Infinity`. For these cases you have
   * to use the replacer. Example usage:
   *
   *     JSON.stringify([2, Infinity], math.replacer)
   *
   * @param {string} key
   * @param {*} value
   * @returns {*} Returns the replaced object
   */ return function replacer(key, value) {
        // the numeric values Infinitiy, -Infinity, and NaN cannot be serialized to JSON
        if (typeof value === "number" && (!isFinite(value) || isNaN(value))) return {
            mathjs: "number",
            value: String(value)
        };
        return value;
    };
});



var $b2013f42cf679ffd$var$name = "reshape";
var $b2013f42cf679ffd$var$dependencies = [
    "typed",
    "isInteger",
    "matrix"
];
var $b2013f42cf679ffd$export$76c9752f34fb3440 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b2013f42cf679ffd$var$name, $b2013f42cf679ffd$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    /**
   * Reshape a multi dimensional array to fit the specified dimensions
   *
   * Syntax:
   *
   *     math.reshape(x, sizes)
   *
   * Examples:
   *
   *     math.reshape([1, 2, 3, 4, 5, 6], [2, 3])
   *     // returns Array  [[1, 2, 3], [4, 5, 6]]
   *
   *     math.reshape([[1, 2], [3, 4]], [1, 4])
   *     // returns Array  [[1, 2, 3, 4]]
   *
   *     math.reshape([[1, 2], [3, 4]], [4])
   *     // returns Array [1, 2, 3, 4]
   *
   *     const x = math.matrix([1, 2, 3, 4, 5, 6, 7, 8])
   *     math.reshape(x, [2, 2, 2])
   *     // returns Matrix [[[1, 2], [3, 4]], [[5, 6], [7, 8]]]
   *
   *    math.reshape([1, 2, 3, 4], [-1, 2])
   *    // returns Matrix [[1, 2], [3, 4]]
   *
   * See also:
   *
   *     size, squeeze, resize
   *
   * @param {Array | Matrix | *} x  Matrix to be reshaped
   * @param {number[]} sizes        One dimensional array with integral sizes for
   *                                each dimension. One -1 is allowed as wildcard,
   *                                which calculates this dimension automatically.
   *
   * @return {* | Array | Matrix}   A reshaped clone of matrix `x`
   *
   * @throws {TypeError}            If `sizes` does not contain solely integers
   * @throws {DimensionError}       If the product of the new dimension sizes does
   *                                not equal that of the old ones
   */ return typed($b2013f42cf679ffd$var$name, {
        "Matrix, Array": function MatrixArray(x, sizes) {
            return x.reshape(sizes);
        },
        "Array, Array": function ArrayArray(x, sizes) {
            sizes.forEach(function(size) {
                if (!isInteger(size)) throw new TypeError("Invalid size for dimension: " + size);
            });
            return (0, $802b18b8c920d4c6$export$9eaad88cf88cee2b)(x, sizes);
        }
    });
});



/**
 * Create a syntax error with the message:
 *     'Wrong number of arguments in function <fn> (<count> provided, <min>-<max> expected)'
 * @param {string} fn     Function name
 * @param {number} count  Actual argument count
 * @param {number} min    Minimum required argument count
 * @param {number} [max]  Maximum required argument count
 * @extends Error
 */ function $6c3dff7ae027b870$export$f27c2c74ddc37d80(fn, count, min, max) {
    if (!(this instanceof $6c3dff7ae027b870$export$f27c2c74ddc37d80)) throw new SyntaxError("Constructor must be called with the new operator");
    this.fn = fn;
    this.count = count;
    this.min = min;
    this.max = max;
    this.message = "Wrong number of arguments in function " + fn + " (" + count + " provided, " + min + (max !== undefined && max !== null ? "-" + max : "") + " expected)";
    this.stack = new Error().stack;
}
$6c3dff7ae027b870$export$f27c2c74ddc37d80.prototype = new Error();
$6c3dff7ae027b870$export$f27c2c74ddc37d80.prototype.constructor = Error;
$6c3dff7ae027b870$export$f27c2c74ddc37d80.prototype.name = "ArgumentsError";
$6c3dff7ae027b870$export$f27c2c74ddc37d80.prototype.isArgumentsError = true;







var $c5c8833e96575b06$var$name = "resize";
var $c5c8833e96575b06$var$dependencies = [
    "config",
    "matrix"
];
var $c5c8833e96575b06$export$58909557046ca413 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c5c8833e96575b06$var$name, $c5c8833e96575b06$var$dependencies, (_ref)=>{
    var { config: config, matrix: matrix } = _ref;
    /**
   * Resize a matrix
   *
   * Syntax:
   *
   *     math.resize(x, size)
   *     math.resize(x, size, defaultValue)
   *
   * Examples:
   *
   *     math.resize([1, 2, 3, 4, 5], [3]) // returns Array  [1, 2, 3]
   *     math.resize([1, 2, 3], [5], 0)    // returns Array  [1, 2, 3, 0, 0]
   *     math.resize(2, [2, 3], 0)         // returns Matrix [[2, 0, 0], [0, 0, 0]]
   *     math.resize("hello", [8], "!")    // returns string 'hello!!!'
   *
   * See also:
   *
   *     size, squeeze, subset, reshape
   *
   * @param {Array | Matrix | *} x             Matrix to be resized
   * @param {Array | Matrix} size              One dimensional array with numbers
   * @param {number | string} [defaultValue=0] Zero by default, except in
   *                                           case of a string, in that case
   *                                           defaultValue = ' '
   * @return {* | Array | Matrix} A resized clone of matrix `x`
   */ // TODO: rework resize to a typed-function
    return function resize(x, size, defaultValue) {
        if (arguments.length !== 2 && arguments.length !== 3) throw new (0, $6c3dff7ae027b870$export$f27c2c74ddc37d80)("resize", arguments.length, 2, 3);
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(size)) size = size.valueOf(); // get Array
        if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(size[0])) // convert bignumbers to numbers
        size = size.map(function(value) {
            return !(0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(value) ? value : value.toNumber();
        });
         // check x is a Matrix
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(x)) // use optimized matrix implementation, return copy
        return x.resize(size, defaultValue, true);
        if (typeof x === "string") // resize string
        return _resizeString(x, size, defaultValue);
         // check result should be a matrix
        var asMatrix = Array.isArray(x) ? false : config.matrix !== "Array";
        if (size.length === 0) {
            // output a scalar
            while(Array.isArray(x))x = x[0];
            return (0, $33619877a15996ac$export$9cd59f9826255e47)(x);
        } else {
            // output an array/matrix
            if (!Array.isArray(x)) x = [
                x
            ];
            x = (0, $33619877a15996ac$export$9cd59f9826255e47)(x);
            var res = (0, $802b18b8c920d4c6$export$4380c87abf28fdf)(x, size, defaultValue);
            return asMatrix ? matrix(res) : res;
        }
    };
    /**
   * Resize a string
   * @param {string} str
   * @param {number[]} size
   * @param {string} [defaultChar=' ']
   * @private
   */ function _resizeString(str, size, defaultChar) {
        if (defaultChar !== undefined) {
            if (typeof defaultChar !== "string" || defaultChar.length !== 1) throw new TypeError("Single character expected as defaultValue");
        } else defaultChar = " ";
        if (size.length !== 1) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(size.length, 1);
        var len = size[0];
        if (typeof len !== "number" || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(len)) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
        if (str.length > len) return str.substring(0, len);
        else if (str.length < len) {
            var res = str;
            for(var i = 0, ii = len - str.length; i < ii; i++)res += defaultChar;
            return res;
        } else return str;
    }
});


var $198c48d4ca2741b6$var$name = "ResultSet";
var $198c48d4ca2741b6$var$dependencies = [];
var $198c48d4ca2741b6$export$dfb3187f1c4e3bbe = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($198c48d4ca2741b6$var$name, $198c48d4ca2741b6$var$dependencies, ()=>{
    /**
   * A ResultSet contains a list or results
   * @class ResultSet
   * @param {Array} entries
   * @constructor ResultSet
   */ function ResultSet(entries) {
        if (!(this instanceof ResultSet)) throw new SyntaxError("Constructor must be called with the new operator");
        this.entries = entries || [];
    }
    /**
   * Attach type information
   */ ResultSet.prototype.type = "ResultSet";
    ResultSet.prototype.isResultSet = true;
    /**
   * Returns the array with results hold by this ResultSet
   * @memberof ResultSet
   * @returns {Array} entries
   */ ResultSet.prototype.valueOf = function() {
        return this.entries;
    };
    /**
   * Returns the stringified results of the ResultSet
   * @memberof ResultSet
   * @returns {string} string
   */ ResultSet.prototype.toString = function() {
        return "[" + this.entries.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the ResultSet
   * @memberof ResultSet
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "ResultSet", "entries": [...]}`
   */ ResultSet.prototype.toJSON = function() {
        return {
            mathjs: "ResultSet",
            entries: this.entries
        };
    };
    /**
   * Instantiate a ResultSet from a JSON object
   * @memberof ResultSet
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "ResultSet", "entries": [...]}`
   * @return {ResultSet}
   */ ResultSet.fromJSON = function(json) {
        return new ResultSet(json.entries);
    };
    return ResultSet;
}, {
    isClass: true
});











var $c66aa75ad1eb6247$var$name = "rightArithShift";
var $c66aa75ad1eb6247$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $c66aa75ad1eb6247$export$ef742376390cbf7 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c66aa75ad1eb6247$var$name, $c66aa75ad1eb6247$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $3feaf9e0b000398a$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm02 = (0, $b6b1cd490ad9f946$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $f96cb799bd51ff34$export$59a068f853cfbf8)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $e9da21a7968d7093$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise right arithmetic shift of a value x by y number of bits, `x >> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightArithShift(x, y)
   *
   * Examples:
   *
   *    math.rightArithShift(4, 2)               // returns number 1
   *
   *    math.rightArithShift([16, -32, 64], 4)   // returns Array [1, -2, 3]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber} y Amount of shifts
   * @return {number | BigNumber | Array | Matrix} `x` sign-filled shifted right `y` times
   */ return typed($c66aa75ad1eb6247$var$name, {
        "number, number": (0, $8ed95b606c7043f9$export$b6d96f775be90000),
        "BigNumber, BigNumber": (0, $ac43c9464ecff9bd$export$d489c03691bd4cd),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});










var $cc5bb041bccab06e$var$name = "rightLogShift";
var $cc5bb041bccab06e$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $cc5bb041bccab06e$export$2dd001e9fd66adcd = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($cc5bb041bccab06e$var$name, $cc5bb041bccab06e$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $3feaf9e0b000398a$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm02 = (0, $b6b1cd490ad9f946$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $f96cb799bd51ff34$export$59a068f853cfbf8)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $e9da21a7968d7093$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise right logical shift of value x by y number of bits, `x >>> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightLogShift(x, y)
   *
   * Examples:
   *
   *    math.rightLogShift(4, 2)               // returns number 1
   *
   *    math.rightLogShift([16, -32, 64], 4)   // returns Array [1, 2, 3]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, leftShift, rightLogShift
   *
   * @param  {number | Array | Matrix} x Value to be shifted
   * @param  {number} y Amount of shifts
   * @return {number | Array | Matrix} `x` zero-filled shifted right `y` times
   */ return typed($cc5bb041bccab06e$var$name, {
        "number, number": (0, $8ed95b606c7043f9$export$2a8d1e3dcede6e47),
        // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});



var $4d0319c78e460cc0$var$name = "rotate";
var $4d0319c78e460cc0$var$dependencies = [
    "typed",
    "multiply",
    "rotationMatrix"
];
var $4d0319c78e460cc0$export$484058214789ee04 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($4d0319c78e460cc0$var$name, $4d0319c78e460cc0$var$dependencies, (_ref)=>{
    var { typed: typed, multiply: multiply, rotationMatrix: rotationMatrix } = _ref;
    /**
     * Rotate a vector of size 1x2 counter-clockwise by a given angle
     * Rotate a vector of size 1x3 counter-clockwise by a given angle around the given axis
     *
     * Syntax:
     *
     *    math.rotate(w, theta)
     *    math.rotate(w, theta, v)
     *
     * Examples:
     *
     *    math.rotate([11, 12], math.pi / 2)                           // returns matrix([-12, 11])
     *    math.rotate(matrix([11, 12]), math.pi / 2)                   // returns matrix([-12, 11])
     *
     *    math.rotate([1, 0, 0], unit('90deg'), [0, 0, 1])             // returns matrix([0, 1, 0])
     *    math.rotate(matrix([1, 0, 0]), unit('90deg'), [0, 0, 1])     // returns matrix([0, 1, 0])
     *
     *    math.rotate([1, 0], math.complex(1 + i))                     // returns matrix([cos(1 + i) - sin(1 + i), sin(1 + i) + cos(1 + i)])
     *
     * See also:
     *
     *    matrix, rotationMatrix
     *
     * @param {Array | Matrix} w                             Vector to rotate
     * @param {number | BigNumber | Complex | Unit} theta    Rotation angle
     * @param {Array | Matrix} [v]                           Rotation axis
     * @return {Array | Matrix}                              Multiplication of the rotation matrix and w
     */ return typed($4d0319c78e460cc0$var$name, {
        "Array , number | BigNumber | Complex | Unit": function ArrayNumberBigNumberComplexUnit(w, theta) {
            _validateSize(w, 2);
            var matrixRes = multiply(rotationMatrix(theta), w);
            return matrixRes.toArray();
        },
        "Matrix , number | BigNumber | Complex | Unit": function MatrixNumberBigNumberComplexUnit(w, theta) {
            _validateSize(w, 2);
            return multiply(rotationMatrix(theta), w);
        },
        "Array, number | BigNumber | Complex | Unit, Array | Matrix": function ArrayNumberBigNumberComplexUnitArrayMatrix(w, theta, v) {
            _validateSize(w, 3);
            var matrixRes = multiply(rotationMatrix(theta, v), w);
            return matrixRes;
        },
        "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function MatrixNumberBigNumberComplexUnitArrayMatrix(w, theta, v) {
            _validateSize(w, 3);
            return multiply(rotationMatrix(theta, v), w);
        }
    });
    function _validateSize(v, expectedSize) {
        var actualSize = Array.isArray(v) ? (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(v) : v.size();
        if (actualSize.length > 2) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
        if (actualSize.length === 2 && actualSize[1] !== 1) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
        if (actualSize[0] !== expectedSize) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
    }
});



var $8f6b2496cc590404$var$name = "rotationMatrix";
var $8f6b2496cc590404$var$dependencies = [
    "typed",
    "config",
    "multiplyScalar",
    "addScalar",
    "unaryMinus",
    "norm",
    "matrix",
    "BigNumber",
    "DenseMatrix",
    "SparseMatrix",
    "cos",
    "sin"
];
var $8f6b2496cc590404$export$7c79514a80dc15a2 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8f6b2496cc590404$var$name, $8f6b2496cc590404$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, addScalar: addScalar, unaryMinus: unaryMinus, norm: norm, BigNumber: BigNumber, matrix: matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, cos: cos, sin: sin } = _ref;
    /**
   * Create a 2-dimensional counter-clockwise rotation matrix (2x2) for a given angle (expressed in radians).
   * Create a 2-dimensional counter-clockwise rotation matrix (3x3) by a given angle (expressed in radians) around a given axis (1x3).
   *
   * Syntax:
   *
   *    math.rotationMatrix(theta)
   *    math.rotationMatrix(theta, format)
   *    math.rotationMatrix(theta, [v])
   *    math.rotationMatrix(theta, [v], format)
   *
   * Examples:
   *
   *    math.rotationMatrix(math.pi / 2)                      // returns [[0, -1], [1, 0]]
   *    math.rotationMatrix(math.bignumber(1))                // returns [[bignumber(cos(1)), bignumber(-sin(1))], [bignumber(sin(1)), bignumber(cos(1))]]
   *    math.rotationMatrix(math.complex(1 + i))              // returns [[cos(1 + i), -sin(1 + i)], [sin(1 + i), cos(1 + i)]]
   *    math.rotationMatrix(math.unit('1rad'))                // returns [[cos(1), -sin(1)], [sin(1), cos(1)]]
   *
   *    math.rotationMatrix(math.pi / 2, [0, 1, 0])           // returns [[0, 0, 1], [0, 1, 0], [-1, 0, 0]]
   *    math.rotationMatrix(math.pi / 2, matrix([0, 1, 0]))   // returns matrix([[0, 0, 1], [0, 1, 0], [-1, 0, 0]])
   *
   *
   * See also:
   *
   *    matrix, cos, sin
   *
   *
   * @param {number | BigNumber | Complex | Unit} theta    Rotation angle
   * @param {Array | Matrix} [v]                           Rotation axis
   * @param {string} [format]                              Result Matrix storage format
   * @return {Array | Matrix}                              Rotation matrix
   */ return typed($8f6b2496cc590404$var$name, {
        "": function _() {
            return config.matrix === "Matrix" ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        "number | BigNumber | Complex | Unit": function numberBigNumberComplexUnit(theta) {
            return _rotationMatrix2x2(theta, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber | Complex | Unit, string": function numberBigNumberComplexUnitString(theta, format) {
            return _rotationMatrix2x2(theta, format);
        },
        "number | BigNumber | Complex | Unit, Array": function numberBigNumberComplexUnitArray(theta, v) {
            var matrixV = matrix(v);
            _validateVector(matrixV);
            return _rotationMatrix3x3(theta, matrixV, undefined);
        },
        "number | BigNumber | Complex | Unit, Matrix": function numberBigNumberComplexUnitMatrix(theta, v) {
            _validateVector(v);
            var storageType = v.storage() || (config.matrix === "Matrix" ? "dense" : undefined);
            return _rotationMatrix3x3(theta, v, storageType);
        },
        "number | BigNumber | Complex | Unit, Array, string": function numberBigNumberComplexUnitArrayString(theta, v, format) {
            var matrixV = matrix(v);
            _validateVector(matrixV);
            return _rotationMatrix3x3(theta, matrixV, format);
        },
        "number | BigNumber | Complex | Unit, Matrix, string": function numberBigNumberComplexUnitMatrixString(theta, v, format) {
            _validateVector(v);
            return _rotationMatrix3x3(theta, v, format);
        }
    });
    /**
   * Returns 2x2 matrix of 2D rotation of angle theta
   *
   * @param {number | BigNumber | Complex | Unit} theta  The rotation angle
   * @param {string} format                              The result Matrix storage format
   * @returns {Matrix}
   * @private
   */ function _rotationMatrix2x2(theta, format) {
        var Big = (0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(theta);
        var minusOne = Big ? new BigNumber(-1) : -1;
        var cosTheta = cos(theta);
        var sinTheta = sin(theta);
        var data = [
            [
                cosTheta,
                multiplyScalar(minusOne, sinTheta)
            ],
            [
                sinTheta,
                cosTheta
            ]
        ];
        return _convertToFormat(data, format);
    }
    function _validateVector(v) {
        var size = v.size();
        if (size.length < 1 || size[0] !== 3) throw new RangeError("Vector must be of dimensions 1x3");
    }
    function _mul(array) {
        return array.reduce((p, curr)=>multiplyScalar(p, curr));
    }
    function _convertToFormat(data, format) {
        if (format) {
            if (format === "sparse") return new SparseMatrix(data);
            if (format === "dense") return new DenseMatrix(data);
            throw new TypeError('Unknown matrix type "'.concat(format, '"'));
        }
        return data;
    }
    /**
   * Returns a 3x3 matrix of rotation of angle theta around vector v
   *
   * @param {number | BigNumber | Complex | Unit} theta The rotation angle
   * @param {Matrix} v                                  The rotation axis vector
   * @param {string} format                             The storage format of the resulting matrix
   * @returns {Matrix}
   * @private
   */ function _rotationMatrix3x3(theta, v, format) {
        var normV = norm(v);
        if (normV === 0) throw new RangeError("Rotation around zero vector");
        var Big = (0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(theta) ? BigNumber : null;
        var one = Big ? new Big(1) : 1;
        var minusOne = Big ? new Big(-1) : -1;
        var vx = Big ? new Big(v.get([
            0
        ]) / normV) : v.get([
            0
        ]) / normV;
        var vy = Big ? new Big(v.get([
            1
        ]) / normV) : v.get([
            1
        ]) / normV;
        var vz = Big ? new Big(v.get([
            2
        ]) / normV) : v.get([
            2
        ]) / normV;
        var c = cos(theta);
        var oneMinusC = addScalar(one, unaryMinus(c));
        var s = sin(theta);
        var r11 = addScalar(c, _mul([
            vx,
            vx,
            oneMinusC
        ]));
        var r12 = addScalar(_mul([
            vx,
            vy,
            oneMinusC
        ]), _mul([
            minusOne,
            vz,
            s
        ]));
        var r13 = addScalar(_mul([
            vx,
            vz,
            oneMinusC
        ]), _mul([
            vy,
            s
        ]));
        var r21 = addScalar(_mul([
            vx,
            vy,
            oneMinusC
        ]), _mul([
            vz,
            s
        ]));
        var r22 = addScalar(c, _mul([
            vy,
            vy,
            oneMinusC
        ]));
        var r23 = addScalar(_mul([
            vy,
            vz,
            oneMinusC
        ]), _mul([
            minusOne,
            vx,
            s
        ]));
        var r31 = addScalar(_mul([
            vx,
            vz,
            oneMinusC
        ]), _mul([
            minusOne,
            vy,
            s
        ]));
        var r32 = addScalar(_mul([
            vy,
            vz,
            oneMinusC
        ]), _mul([
            vx,
            s
        ]));
        var r33 = addScalar(c, _mul([
            vz,
            vz,
            oneMinusC
        ]));
        var data = [
            [
                r11,
                r12,
                r13
            ],
            [
                r21,
                r22,
                r23
            ],
            [
                r31,
                r32,
                r33
            ]
        ];
        return _convertToFormat(data, format);
    }
});







var $dc81f66c0e39e53a$var$NO_INT = "Number of decimals in function round must be an integer";
var $dc81f66c0e39e53a$var$name = "round";
var $dc81f66c0e39e53a$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "BigNumber",
    "DenseMatrix"
];
var $dc81f66c0e39e53a$export$c41ddfead54b1fbc = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($dc81f66c0e39e53a$var$name, $dc81f66c0e39e53a$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, BigNumber: BigNumber, DenseMatrix: DenseMatrix } = _ref;
    var algorithm11 = (0, $b3da8e1c46f67c1c$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Round a value towards the nearest integer.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.round(x)
   *    math.round(x, n)
   *
   * Examples:
   *
   *    math.round(3.22)             // returns number 3
   *    math.round(3.82)             // returns number 4
   *    math.round(-4.2)             // returns number -4
   *    math.round(-4.7)             // returns number -5
   *    math.round(3.22, 1)          // returns number 3.2
   *    math.round(3.88, 1)          // returns number 3.9
   *    math.round(-4.21, 1)         // returns number -4.2
   *    math.round(-4.71, 1)         // returns number -4.7
   *    math.round(math.pi, 3)       // returns number 3.142
   *    math.round(123.45678, 2)     // returns number 123.46
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.round(c)                // returns Complex 3 - 3i
   *
   *    math.round([3.2, 3.8, -4.7]) // returns Array [3, 4, -5]
   *
   * See also:
   *
   *    ceil, fix, floor
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed($dc81f66c0e39e53a$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$a3992db8dd0fd9e6),
        "number, number": (0, $08ae6b2eb4bd0049$export$a3992db8dd0fd9e6),
        "number, BigNumber": function numberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($dc81f66c0e39e53a$var$NO_INT);
            return new BigNumber(x).toDecimalPlaces(n.toNumber());
        },
        Complex: function Complex(x) {
            return x.round();
        },
        "Complex, number": function ComplexNumber(x, n) {
            if (n % 1) throw new TypeError($dc81f66c0e39e53a$var$NO_INT);
            return x.round(n);
        },
        "Complex, BigNumber": function ComplexBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($dc81f66c0e39e53a$var$NO_INT);
            var _n = n.toNumber();
            return x.round(_n);
        },
        BigNumber: function BigNumber(x) {
            return x.toDecimalPlaces(0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($dc81f66c0e39e53a$var$NO_INT);
            return x.toDecimalPlaces(n.toNumber());
        },
        Fraction: function Fraction(x) {
            return x.round();
        },
        "Fraction, number": function FractionNumber(x, n) {
            if (n % 1) throw new TypeError($dc81f66c0e39e53a$var$NO_INT);
            return x.round(n);
        },
        "Fraction, BigNumber": function FractionBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($dc81f66c0e39e53a$var$NO_INT);
            return x.round(n.toNumber());
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since round(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "number | Complex | BigNumber | Fraction, SparseMatrix": function numberComplexBigNumberFractionSparseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
            return zeros(y.size(), y.storage());
            return algorithm12(y, x, this, true);
        },
        "number | Complex | BigNumber | Fraction, DenseMatrix": function numberComplexBigNumberFractionDenseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
            return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        "number | Complex | BigNumber | Fraction, Array": function numberComplexBigNumberFractionArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});




var $1d936a877a324b9b$var$name = "row";
var $1d936a877a324b9b$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $1d936a877a324b9b$export$3442c5d213434705 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1d936a877a324b9b$var$name, $1d936a877a324b9b$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    /**
   * Return a row from a Matrix.
   *
   * Syntax:
   *
   *     math.row(value, index)
   *
   * Example:
   *
   *     // get a row
   *     const d = [[1, 2], [3, 4]]
   *     math.row(d, 1) // returns [[3, 4]]
   *
   * See also:
   *
   *     column
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} row              The index of the row
   * @return {Array | Matrix}         The retrieved row
   */ return typed($1d936a877a324b9b$var$name, {
        "Matrix, number": _row,
        "Array, number": function ArrayNumber(value, row) {
            return _row(matrix((0, $33619877a15996ac$export$9cd59f9826255e47)(value)), row).valueOf();
        }
    });
    /**
   * Retrieve a row of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} row     The index of the row
   * @return {Matrix}        The retrieved row
   */ function _row(value, row) {
        // check dimensions
        if (value.size().length !== 2) throw new Error("Only two dimensional matrix is supported");
        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(row, value.size()[0]);
        var columnRange = range(0, value.size()[1]);
        var index = new Index(row, columnRange);
        return value.subset(index);
    }
});




var $16523ae6cb9d15c0$var$name = "sec";
var $16523ae6cb9d15c0$var$dependencies = [
    "typed",
    "BigNumber"
];
var $16523ae6cb9d15c0$export$5c169ecd5c25a09e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($16523ae6cb9d15c0$var$name, $16523ae6cb9d15c0$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the secant of a value, defined as `sec(x) = 1/cos(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sec(x)
   *
   * Examples:
   *
   *    math.sec(2)      // returns number -2.4029979617223822
   *    1 / math.cos(2)  // returns number -2.4029979617223822
   *
   * See also:
   *
   *    cos, csc, cot
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Secant of x
   */ return typed($16523ae6cb9d15c0$var$name, {
        number: (0, $b54e9ade204c059d$export$ee1efc70bd8a6d93),
        Complex: function Complex(x) {
            return x.sec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.cos());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sec is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $306076fad9180d2e$var$name = "sech";
var $306076fad9180d2e$var$dependencies = [
    "typed",
    "BigNumber"
];
var $306076fad9180d2e$export$97a0cf2b7d31f38b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($306076fad9180d2e$var$name, $306076fad9180d2e$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic secant of a value,
   * defined as `sech(x) = 1 / cosh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sech(x)
   *
   * Examples:
   *
   *    // sech(x) = 1/ cosh(x)
   *    math.sech(0.5)       // returns 0.886818883970074
   *    1 / math.cosh(0.5)   // returns 0.886818883970074
   *
   * See also:
   *
   *    cosh, csch, coth
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic secant of x
   */ return typed($306076fad9180d2e$var$name, {
        number: (0, $b54e9ade204c059d$export$b83345d70fe4a871),
        Complex: function Complex(x) {
            return x.sech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.cosh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sech is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $ec2116155f4a3747$var$name = "setCartesian";
var $ec2116155f4a3747$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $ec2116155f4a3747$export$9fa12a9d198718c8 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($ec2116155f4a3747$var$name, $ec2116155f4a3747$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the cartesian product of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays
   * and the values will be sorted in ascending order before the operation.
   *
   * Syntax:
   *
   *    math.setCartesian(set1, set2)
   *
   * Examples:
   *
   *    math.setCartesian([1, 2], [3, 4])        // returns [[1, 3], [1, 4], [2, 3], [2, 4]]
   *    math.setCartesian([4, 3], [2, 1])        // returns [[3, 1], [3, 2], [4, 1], [4, 2]]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference, setPowerset
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The cartesian product of two (multi)sets
   */ return typed($ec2116155f4a3747$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result = [];
            if (subset(size(a1), new Index(0)) !== 0 && subset(size(a2), new Index(0)) !== 0) {
                // if any of them is empty, return empty
                var b1 = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural);
                var b2 = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural);
                result = [];
                for(var i = 0; i < b1.length; i++)for(var j = 0; j < b2.length; j++)result.push([
                    b1[i],
                    b2[j]
                ]);
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return result;
             // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});



var $a57af78f1a255d75$var$name = "setDifference";
var $a57af78f1a255d75$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $a57af78f1a255d75$export$d81c0f9dab86d854 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a57af78f1a255d75$var$name, $a57af78f1a255d75$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the difference of two (multi)sets: every element of set1, that is not the element of set2.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2]
   *    math.setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2]
   *
   * See also:
   *
   *    setUnion, setIntersect, setSymDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The difference of two (multi)sets
   */ return typed($a57af78f1a255d75$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0) // empty-anything=empty
            result = [];
            else if (subset(size(a2), new Index(0)) === 0) // anything-empty=anything
            return (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a1.toArray());
            else {
                var b1 = (0, $802b18b8c920d4c6$export$65e5b62a4c490288)((0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $802b18b8c920d4c6$export$65e5b62a4c490288)((0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                var inb2;
                for(var i = 0; i < b1.length; i++){
                    inb2 = false;
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        inb2 = true;
                        break;
                    }
                    if (!inb2) result.push(b1[i]);
                }
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $802b18b8c920d4c6$export$d57ad8b840ad6a01)(result);
             // return a matrix otherwise
            return new DenseMatrix((0, $802b18b8c920d4c6$export$d57ad8b840ad6a01)(result));
        }
    });
});



var $23c9218fe295927f$var$name = "setDistinct";
var $23c9218fe295927f$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $23c9218fe295927f$export$c149680b9d8f2963 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($23c9218fe295927f$var$name, $23c9218fe295927f$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Collect the distinct elements of a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setDistinct(set)
   *
   * Examples:
   *
   *    math.setDistinct([1, 1, 1, 2, 2, 3])        // returns [1, 2, 3]
   *
   * See also:
   *
   *    setMultiplicity
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {Array | Matrix}    A set containing the distinc elements of the multiset
   */ return typed($23c9218fe295927f$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            var result;
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            result = [];
            else {
                var b = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                result = [];
                result.push(b[0]);
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) result.push(b[i]);
            } // return an array, if the input was an array
            if (Array.isArray(a)) return result;
             // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});



var $054e972ee136ed95$var$name = "setIntersect";
var $054e972ee136ed95$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $054e972ee136ed95$export$b20ee2bdfbf6defd = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($054e972ee136ed95$var$name, $054e972ee136ed95$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the intersection of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIntersect(set1, set2)
   *
   * Examples:
   *
   *    math.setIntersect([1, 2, 3, 4], [3, 4, 5, 6])            // returns [3, 4]
   *    math.setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [3, 4]
   *
   * See also:
   *
   *    setUnion, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The intersection of two (multi)sets
   */ return typed($054e972ee136ed95$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0 || subset(size(a2), new Index(0)) === 0) // of any of them is empty, return empty
            result = [];
            else {
                var b1 = (0, $802b18b8c920d4c6$export$65e5b62a4c490288)((0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $802b18b8c920d4c6$export$65e5b62a4c490288)((0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                for(var i = 0; i < b1.length; i++){
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        result.push(b1[i]);
                        break;
                    }
                }
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $802b18b8c920d4c6$export$d57ad8b840ad6a01)(result);
             // return a matrix otherwise
            return new DenseMatrix((0, $802b18b8c920d4c6$export$d57ad8b840ad6a01)(result));
        }
    });
});



var $d7cd54c960d47b27$var$name = "setIsSubset";
var $d7cd54c960d47b27$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $d7cd54c960d47b27$export$40ad73493b9f8712 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d7cd54c960d47b27$var$name, $d7cd54c960d47b27$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Check whether a (multi)set is a subset of another (multi)set. (Every element of set1 is the element of set2.)
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIsSubset(set1, set2)
   *
   * Examples:
   *
   *    math.setIsSubset([1, 2], [3, 4, 5, 6])        // returns false
   *    math.setIsSubset([3, 4], [3, 4, 5, 6])        // returns true
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {boolean}            true | false
   */ return typed($d7cd54c960d47b27$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // empty is a subset of anything
            return true;
            else if (subset(size(a2), new Index(0)) === 0) // anything is not a subset of empty
            return false;
            var b1 = (0, $802b18b8c920d4c6$export$65e5b62a4c490288)((0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
            var b2 = (0, $802b18b8c920d4c6$export$65e5b62a4c490288)((0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
            var inb2;
            for(var i = 0; i < b1.length; i++){
                inb2 = false;
                for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                    // the identifier is always a decimal int
                    inb2 = true;
                    break;
                }
                if (inb2 === false) return false;
            }
            return true;
        }
    });
});



var $8cf2a7f50d42faf7$var$name = "setMultiplicity";
var $8cf2a7f50d42faf7$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $8cf2a7f50d42faf7$export$d1f961d649e525df = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8cf2a7f50d42faf7$var$name, $8cf2a7f50d42faf7$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Count the multiplicity of an element in a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setMultiplicity(element, set)
   *
   * Examples:
   *
   *    math.setMultiplicity(1, [1, 2, 2, 4])    // returns 1
   *    math.setMultiplicity(2, [1, 2, 2, 4])    // returns 2
   *
   * See also:
   *
   *    setDistinct, setSize
   *
   * @param {number | BigNumber | Fraction | Complex} e  An element in the multiset
   * @param {Array | Matrix}     a  A multiset
   * @return {number}            The number of how many times the multiset contains the element
   */ return typed($8cf2a7f50d42faf7$var$name, {
        "number | BigNumber | Fraction | Complex, Array | Matrix": function numberBigNumberFractionComplexArrayMatrix(e, a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return 0
            return 0;
            var b = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray());
            var count = 0;
            for(var i = 0; i < b.length; i++)if (compareNatural(b[i], e) === 0) count++;
            return count;
        }
    });
});



var $09c13ea186f3bb8d$var$name = "setPowerset";
var $09c13ea186f3bb8d$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $09c13ea186f3bb8d$export$55c6b5cb0b0637db = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($09c13ea186f3bb8d$var$name, $09c13ea186f3bb8d$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Create the powerset of a (multi)set. (The powerset contains very possible subsets of a (multi)set.)
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setPowerset(set)
   *
   * Examples:
   *
   *    math.setPowerset([1, 2, 3])        // returns [[], [1], [2], [3], [1, 2], [1, 3], [2, 3], [1, 2, 3]]
   *
   * See also:
   *
   *    setCartesian
   *
   * @param {Array | Matrix}    a  A (multi)set
   * @return {Array}    The powerset of the (multi)set
   */ return typed($09c13ea186f3bb8d$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            return [];
            var b = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
            var result = [];
            var number = 0;
            while(number.toString(2).length <= b.length){
                result.push(_subset(b, number.toString(2).split("").reverse()));
                number++;
            } // can not return a matrix, because of the different size of the subarrays
            return _sort(result);
        }
    }); // create subset
    function _subset(array, bitarray) {
        var result = [];
        for(var i = 0; i < bitarray.length; i++)if (bitarray[i] === "1") result.push(array[i]);
        return result;
    } // sort subsests by length
    function _sort(array) {
        var temp = [];
        for(var i = array.length - 1; i > 0; i--){
            for(var j = 0; j < i; j++)if (array[j].length > array[j + 1].length) {
                temp = array[j];
                array[j] = array[j + 1];
                array[j + 1] = temp;
            }
        }
        return array;
    }
});



var $9188e7c34789cc6e$var$name = "setSize";
var $9188e7c34789cc6e$var$dependencies = [
    "typed",
    "compareNatural"
];
var $9188e7c34789cc6e$export$55134310fc79366a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($9188e7c34789cc6e$var$name, $9188e7c34789cc6e$var$dependencies, (_ref)=>{
    var { typed: typed, compareNatural: compareNatural } = _ref;
    /**
   * Count the number of elements of a (multi)set. When a second parameter is 'true', count only the unique values.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setSize(set)
   *    math.setSize(set, unique)
   *
   * Examples:
   *
   *    math.setSize([1, 2, 2, 4])          // returns 4
   *    math.setSize([1, 2, 2, 4], true)    // returns 3
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {number}            The number of elements of the (multi)set
   */ return typed($9188e7c34789cc6e$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            return Array.isArray(a) ? (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a).length : (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a.toArray()).length;
        },
        "Array | Matrix, boolean": function ArrayMatrixBoolean(a, unique) {
            if (unique === false || a.length === 0) return Array.isArray(a) ? (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a).length : (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a.toArray()).length;
            else {
                var b = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                var count = 1;
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) count++;
                return count;
            }
        }
    });
});



var $5eab92963756711c$var$name = "setSymDifference";
var $5eab92963756711c$var$dependencies = [
    "typed",
    "size",
    "concat",
    "subset",
    "setDifference",
    "Index"
];
var $5eab92963756711c$export$4a9a0ead2012bfc4 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($5eab92963756711c$var$name, $5eab92963756711c$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, concat: concat, subset: subset, setDifference: setDifference, Index: Index } = _ref;
    /**
   * Create the symmetric difference of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setSymDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 5, 6]
   *    math.setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 5, 6]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The symmetric difference of two (multi)sets
   */ return typed($5eab92963756711c$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a1);
            var b1 = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a1);
            var b2 = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a2);
            return concat(setDifference(b1, b2), setDifference(b2, b1));
        }
    });
});



var $24a7bcebd15554ea$var$name = "setUnion";
var $24a7bcebd15554ea$var$dependencies = [
    "typed",
    "size",
    "concat",
    "subset",
    "setIntersect",
    "setSymDifference",
    "Index"
];
var $24a7bcebd15554ea$export$fbdfd2054d37f888 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($24a7bcebd15554ea$var$name, $24a7bcebd15554ea$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, concat: concat, subset: subset, setIntersect: setIntersect, setSymDifference: setSymDifference, Index: Index } = _ref;
    /**
   * Create the union of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setUnion(set1, set2)
   *
   * Examples:
   *
   *    math.setUnion([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 3, 4, 5, 6]
   *    math.setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 3, 4, 5, 6]
   *
   * See also:
   *
   *    setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The union of two (multi)sets
   */ return typed($24a7bcebd15554ea$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a1);
            var b1 = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a1);
            var b2 = (0, $802b18b8c920d4c6$export$bffa455ba8c619a6)(a2);
            return concat(setSymDifference(b1, b2), setIntersect(b1, b2));
        }
    });
});




var $1e1fccc801ebe958$var$name = "sign";
var $1e1fccc801ebe958$var$dependencies = [
    "typed",
    "BigNumber",
    "Fraction",
    "complex"
];
var $1e1fccc801ebe958$export$45df7cae684751af = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1e1fccc801ebe958$var$name, $1e1fccc801ebe958$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber, complex: complex, Fraction: _Fraction } = _ref;
    /**
   * Compute the sign of a value. The sign of a value x is:
   *
   * -  1 when x > 0
   * - -1 when x < 0
   * -  0 when x == 0
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sign(x)
   *
   * Examples:
   *
   *    math.sign(3.5)               // returns 1
   *    math.sign(-4.2)              // returns -1
   *    math.sign(0)                 // returns 0
   *
   *    math.sign([3, 5, -2, 0, 2])  // returns [1, 1, -1, 0, 1]
   *
   * See also:
   *
   *    abs
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            The number for which to determine the sign
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}e
   *            The sign of `x`
   */ return typed($1e1fccc801ebe958$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$af3d9fe43be78285),
        Complex: function Complex(x) {
            return x.im === 0 ? complex((0, $08ae6b2eb4bd0049$export$af3d9fe43be78285)(x.re)) : x.sign();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x.cmp(0));
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x.s, 1);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sign(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        },
        Unit: function Unit(x) {
            if (!x._isDerived() && x.units[0].unit.offset !== 0) throw new TypeError("sign is ambiguous for units with offset");
            return this(x.value);
        }
    });
});



var $de45d2b722729ea6$var$name = "sin";
var $de45d2b722729ea6$var$dependencies = [
    "typed"
];
var $de45d2b722729ea6$export$4b4fac44ef379cae = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($de45d2b722729ea6$var$name, $de45d2b722729ea6$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the sine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sin(x)
   *
   * Examples:
   *
   *    math.sin(2)                      // returns number 0.9092974268256813
   *    math.sin(math.pi / 4)            // returns number 0.7071067811865475
   *    math.sin(math.unit(90, 'deg'))   // returns number 1
   *    math.sin(math.unit(30, 'deg'))   // returns number 0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Sine of x
   */ return typed($de45d2b722729ea6$var$name, {
        number: Math.sin,
        Complex: function Complex(x) {
            return x.sin();
        },
        BigNumber: function BigNumber(x) {
            return x.sin();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sin is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sin(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});




var $8e14d9c263a8a0f8$var$name = "sinh";
var $8e14d9c263a8a0f8$var$dependencies = [
    "typed"
];
var $8e14d9c263a8a0f8$export$c3a62182c56878d5 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8e14d9c263a8a0f8$var$name, $8e14d9c263a8a0f8$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic sine of a value,
   * defined as `sinh(x) = 1/2 * (exp(x) - exp(-x))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sinh(x)
   *
   * Examples:
   *
   *    math.sinh(0.5)       // returns number 0.5210953054937474
   *
   * See also:
   *
   *    cosh, tanh
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic sine of x
   */ return typed($8e14d9c263a8a0f8$var$name, {
        number: (0, $b54e9ade204c059d$export$89648c4ce0d79e70),
        Complex: function Complex(x) {
            return x.sinh();
        },
        BigNumber: function BigNumber(x) {
            return x.sinh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sinh is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sinh(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});




var $c9f4857e58101d5d$var$name = "size";
var $c9f4857e58101d5d$var$dependencies = [
    "typed",
    "config",
    "?matrix"
];
var $c9f4857e58101d5d$export$9151c23a59ce3fb6 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c9f4857e58101d5d$var$name, $c9f4857e58101d5d$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix } = _ref;
    /**
   * Calculate the size of a matrix or scalar.
   *
   * Syntax:
   *
   *     math.size(x)
   *
   * Examples:
   *
   *     math.size(2.3)                  // returns []
   *     math.size('hello world')        // returns [11]
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.size(A)                    // returns [2, 3]
   *     math.size(math.range(1,6))      // returns [5]
   *
   * See also:
   *
   *     count, resize, squeeze, subset
   *
   * @param {boolean | number | Complex | Unit | string | Array | Matrix} x  A matrix
   * @return {Array | Matrix} A vector with size of `x`.
   */ return typed($c9f4857e58101d5d$var$name, {
        Matrix: function Matrix(x) {
            return x.create(x.size());
        },
        Array: (0, $802b18b8c920d4c6$export$51ffaee4afb683a5),
        string: function string(x) {
            return config.matrix === "Array" ? [
                x.length
            ] : matrix([
                x.length
            ]);
        },
        "number | Complex | BigNumber | Unit | boolean | null": function numberComplexBigNumberUnitBooleanNull(x) {
            // scalar
            return config.matrix === "Array" ? [] : matrix ? matrix([]) : (0, $59e7e238555a97e6$export$b81416cb7ecca475)();
        }
    });
});



/**
 * Permutes a sparse matrix C = P * A * Q
 *
 * @param {SparseMatrix}  a         The Matrix A
 * @param {Array}   pinv            The row permutation vector
 * @param {Array}   q               The column permutation vector
 * @param {boolean} values          Create a pattern matrix (false), values and pattern otherwise
 *
 * @return {Matrix}                 C = P * A * Q, null on error
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $dca56a61055f1e45$export$76070a0ecffd0bb2(a, pinv, q, values) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size;
    var adt = a._datatype; // rows & columns
    var m = asize[0];
    var n = asize[1]; // c arrays
    var cvalues = values && a._values ? [] : null;
    var cindex = []; // (aptr[n])
    var cptr = []; // (n + 1)
    // initialize vars
    var nz = 0; // loop columns
    for(var k = 0; k < n; k++){
        // column k of C is column q[k] of A
        cptr[k] = nz; // apply column permutation
        var j = q ? q[k] : k; // loop values in column j of A
        for(var t0 = aptr[j], t1 = aptr[j + 1], t = t0; t < t1; t++){
            // row i of A is row pinv[i] of C
            var r = pinv ? pinv[aindex[t]] : aindex[t]; // index
            cindex[nz] = r; // check we need to populate values
            if (cvalues) cvalues[nz] = avalues[t];
             // increment number of nonzero elements
            nz++;
        }
    } // finalize the last column of C
    cptr[n] = nz; // return C matrix
    return a.createSparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [
            m,
            n
        ],
        datatype: adt
    });
}


/**
 * Depth-first search and postorder of a tree rooted at node j
 *
 * @param {Number}  j               The tree node
 * @param {Number}  k
 * @param {Array}   w               The workspace array
 * @param {Number}  head            The index offset within the workspace for the head array
 * @param {Number}  next            The index offset within the workspace for the next array
 * @param {Array}   post            The post ordering array
 * @param {Number}  stack           The index offset within the workspace for the stack array
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $29876d633c2a2514$export$18e42241aee7902a(j, k, w, head, next, post, stack) {
    // variables
    var top = 0; // place j on the stack
    w[stack] = j; // while (stack is not empty)
    while(top >= 0){
        // p = top of stack
        var p = w[stack + top]; // i = youngest child of p
        var i = w[head + p];
        if (i === -1) {
            // p has no unordered children left
            top--; // node p is the kth postordered node
            post[k++] = p;
        } else {
            // remove i from children of p
            w[head + p] = w[next + i]; // increment top
            ++top; // start dfs on child node i
            w[stack + top] = i;
        }
    }
    return k;
}


function $60036bd6dd0efc7f$export$90626b0a5705891a(parent, n) {
    // check inputs
    if (!parent) return null;
     // vars
    var k = 0;
    var j; // allocate result
    var post = []; // (n)
    // workspace, head: first n entries, next: next n entries, stack: last n entries
    var w = []; // (3 * n)
    var head = 0;
    var next = n;
    var stack = 2 * n; // initialize workspace
    for(j = 0; j < n; j++)// empty linked lists
    w[head + j] = -1;
     // traverse nodes in reverse order
    for(j = n - 1; j >= 0; j--){
        // check j is a root
        if (parent[j] === -1) continue;
         // add j to list of its parent
        w[next + j] = w[head + parent[j]];
        w[head + parent[j]] = j;
    } // loop nodes
    for(j = 0; j < n; j++){
        // skip j if it is not a root
        if (parent[j] !== -1) continue;
         // depth-first search
        k = (0, $29876d633c2a2514$export$18e42241aee7902a)(j, k, w, head, next, post, stack);
    }
    return post;
}


/**
 * Computes the elimination tree of Matrix A (using triu(A)) or the
 * elimination tree of A'A without forming A'A.
 *
 * @param {Matrix}  a               The A Matrix
 * @param {boolean} ata             A value of true the function computes the etree of A'A
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $736e5a4730723aeb$export$720e2a9a0fdebf8c(a, ata) {
    // check inputs
    if (!a) return null;
     // a arrays
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size; // rows & columns
    var m = asize[0];
    var n = asize[1]; // allocate result
    var parent = []; // (n)
    // allocate workspace
    var w = []; // (n + (ata ? m : 0))
    var ancestor = 0; // first n entries in w
    var prev = n; // last m entries (ata = true)
    var i, inext; // check we are calculating A'A
    if (ata) // initialize workspace
    for(i = 0; i < m; i++)w[prev + i] = -1;
     // loop columns
    for(var k = 0; k < n; k++){
        // node k has no parent yet
        parent[k] = -1; // nor does k have an ancestor
        w[ancestor + k] = -1; // values in column k
        for(var p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++){
            // row
            var r = aindex[p]; // node
            i = ata ? w[prev + r] : r; // traverse from i to k
            for(; i !== -1 && i < k; i = inext){
                // inext = ancestor of i
                inext = w[ancestor + i]; // path compression
                w[ancestor + i] = k; // check no anc., parent is k
                if (inext === -1) parent[i] = k;
            }
            if (ata) w[prev + r] = k;
        }
    }
    return parent;
}



/**
 * Keeps entries in the matrix when the callback function returns true, removes the entry otherwise
 *
 * @param {Matrix}   a              The sparse matrix
 * @param {function} callback       The callback function, function will be invoked with the following args:
 *                                    - The entry row
 *                                    - The entry column
 *                                    - The entry value
 *                                    - The state parameter
 * @param {any}      other          The state
 *
 * @return                          The number of nonzero elements in the matrix
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $a31cb9e52c94606e$export$9453433d9395b8cb(a, callback, other) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size; // columns
    var n = asize[1]; // nonzero items
    var nz = 0; // loop columns
    for(var j = 0; j < n; j++){
        // get current location of col j
        var p = aptr[j]; // record new location of col j
        aptr[j] = nz;
        for(; p < aptr[j + 1]; p++)// check we need to keep this item
        if (callback(aindex[p], j, avalues ? avalues[p] : 1, other)) {
            // keep A(i,j)
            aindex[nz] = aindex[p]; // check we need to process values (pattern only)
            if (avalues) avalues[nz] = avalues[p];
             // increment nonzero items
            nz++;
        }
    } // finalize A
    aptr[n] = nz; // trim arrays
    aindex.splice(nz, aindex.length - nz); // check we need to process values (pattern only)
    if (avalues) avalues.splice(nz, avalues.length - nz);
     // return number of nonzero items
    return nz;
}


/**
 * This function "flips" its input about the integer -1.
 *
 * @param {Number}  i               The value to flip
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $d5d21ffdbc06b94e$export$d405b3d9168b83fa(i) {
    // flip the value
    return -i - 2;
}



var $7dd2fdb070f85aa8$var$name = "csAmd";
var $7dd2fdb070f85aa8$var$dependencies = [
    "add",
    "multiply",
    "transpose"
];
var $7dd2fdb070f85aa8$export$485230eb48878637 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($7dd2fdb070f85aa8$var$name, $7dd2fdb070f85aa8$var$dependencies, (_ref)=>{
    var { add: add, multiply: multiply, transpose: transpose } = _ref;
    /**
   * Approximate minimum degree ordering. The minimum degree algorithm is a widely used
   * heuristic for finding a permutation P so that P*A*P' has fewer nonzeros in its factorization
   * than A. It is a gready method that selects the sparsest pivot row and column during the course
   * of a right looking sparse Cholesky factorization.
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   *
   * @param {Number} order    0: Natural, 1: Cholesky, 2: LU, 3: QR
   * @param {Matrix} m        Sparse Matrix
   */ return function csAmd(order, a) {
        // check input parameters
        if (!a || order <= 0 || order > 3) return null;
         // a matrix arrays
        var asize = a._size; // rows and columns
        var m = asize[0];
        var n = asize[1]; // initialize vars
        var lemax = 0; // dense threshold
        var dense = Math.max(16, 10 * Math.sqrt(n));
        dense = Math.min(n - 2, dense); // create target matrix C
        var cm = _createTargetMatrix(order, a, m, n, dense); // drop diagonal entries
        (0, $a31cb9e52c94606e$export$9453433d9395b8cb)(cm, _diag, null); // C matrix arrays
        var cindex = cm._index;
        var cptr = cm._ptr; // number of nonzero elements in C
        var cnz = cptr[n]; // allocate result (n+1)
        var P = []; // create workspace (8 * (n + 1))
        var W = [];
        var len = 0; // first n + 1 entries
        var nv = n + 1; // next n + 1 entries
        var next = 2 * (n + 1); // next n + 1 entries
        var head = 3 * (n + 1); // next n + 1 entries
        var elen = 4 * (n + 1); // next n + 1 entries
        var degree = 5 * (n + 1); // next n + 1 entries
        var w = 6 * (n + 1); // next n + 1 entries
        var hhead = 7 * (n + 1); // last n + 1 entries
        // use P as workspace for last
        var last = P; // initialize quotient graph
        var mark = _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree); // initialize degree lists
        var nel = _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next); // minimum degree node
        var mindeg = 0; // vars
        var i, j, k, k1, k2, e, pj, ln, nvi, pk, eln, p1, p2, pn, h, d; // while (selecting pivots) do
        while(nel < n){
            // select node of minimum approximate degree. amd() is now ready to start eliminating the graph. It first
            // finds a node k of minimum degree and removes it from its degree list. The variable nel keeps track of thow
            // many nodes have been eliminated.
            for(k = -1; mindeg < n && (k = W[head + mindeg]) === -1; mindeg++);
            if (W[next + k] !== -1) last[W[next + k]] = -1;
             // remove k from degree list
            W[head + mindeg] = W[next + k]; // elenk = |Ek|
            var elenk = W[elen + k]; // # of nodes k represents
            var nvk = W[nv + k]; // W[nv + k] nodes of A eliminated
            nel += nvk; // Construct a new element. The new element Lk is constructed in place if |Ek| = 0. nv[i] is
            // negated for all nodes i in Lk to flag them as members of this set. Each node i is removed from the
            // degree lists. All elements e in Ek are absorved into element k.
            var dk = 0; // flag k as in Lk
            W[nv + k] = -nvk;
            var p = cptr[k]; // do in place if W[elen + k] === 0
            var pk1 = elenk === 0 ? p : cnz;
            var pk2 = pk1;
            for(k1 = 1; k1 <= elenk + 1; k1++){
                if (k1 > elenk) {
                    // search the nodes in k
                    e = k; // list of nodes starts at cindex[pj]
                    pj = p; // length of list of nodes in k
                    ln = W[len + k] - elenk;
                } else {
                    // search the nodes in e
                    e = cindex[p++];
                    pj = cptr[e]; // length of list of nodes in e
                    ln = W[len + e];
                }
                for(k2 = 1; k2 <= ln; k2++){
                    i = cindex[pj++]; // check  node i dead, or seen
                    if ((nvi = W[nv + i]) <= 0) continue;
                     // W[degree + Lk] += size of node i
                    dk += nvi; // negate W[nv + i] to denote i in Lk
                    W[nv + i] = -nvi; // place i in Lk
                    cindex[pk2++] = i;
                    if (W[next + i] !== -1) last[W[next + i]] = last[i];
                     // check we need to remove i from degree list
                    if (last[i] !== -1) W[next + last[i]] = W[next + i];
                    else W[head + W[degree + i]] = W[next + i];
                }
                if (e !== k) {
                    // absorb e into k
                    cptr[e] = (0, $d5d21ffdbc06b94e$export$d405b3d9168b83fa)(k); // e is now a dead element
                    W[w + e] = 0;
                }
            } // cindex[cnz...nzmax] is free
            if (elenk !== 0) cnz = pk2;
             // external degree of k - |Lk\i|
            W[degree + k] = dk; // element k is in cindex[pk1..pk2-1]
            cptr[k] = pk1;
            W[len + k] = pk2 - pk1; // k is now an element
            W[elen + k] = -2; // Find set differences. The scan1 function now computes the set differences |Le \ Lk| for all elements e. At the start of the
            // scan, no entry in the w array is greater than or equal to mark.
            // clear w if necessary
            mark = _wclear(mark, lemax, W, w, n); // scan 1: find |Le\Lk|
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check if W[elen + i] empty, skip it
                if ((eln = W[elen + i]) <= 0) continue;
                 // W[nv + i] was negated
                nvi = -W[nv + i];
                var wnvi = mark - nvi; // scan Ei
                for(p = cptr[i], p1 = cptr[i] + eln - 1; p <= p1; p++){
                    e = cindex[p];
                    if (W[w + e] >= mark) // decrement |Le\Lk|
                    W[w + e] -= nvi;
                    else if (W[w + e] !== 0) // ensure e is a live element, 1st time e seen in scan 1
                    W[w + e] = W[degree + e] + wnvi;
                }
            } // degree update
            // The second pass computes the approximate degree di, prunes the sets Ei and Ai, and computes a hash
            // function h(i) for all nodes in Lk.
            // scan2: degree update
            for(pk = pk1; pk < pk2; pk++){
                // consider node i in Lk
                i = cindex[pk];
                p1 = cptr[i];
                p2 = p1 + W[elen + i] - 1;
                pn = p1; // scan Ei
                for(h = 0, d = 0, p = p1; p <= p2; p++){
                    e = cindex[p]; // check e is an unabsorbed element
                    if (W[w + e] !== 0) {
                        // dext = |Le\Lk|
                        var dext = W[w + e] - mark;
                        if (dext > 0) {
                            // sum up the set differences
                            d += dext; // keep e in Ei
                            cindex[pn++] = e; // compute the hash of node i
                            h += e;
                        } else {
                            // aggressive absorb. e->k
                            cptr[e] = (0, $d5d21ffdbc06b94e$export$d405b3d9168b83fa)(k); // e is a dead element
                            W[w + e] = 0;
                        }
                    }
                } // W[elen + i] = |Ei|
                W[elen + i] = pn - p1 + 1;
                var p3 = pn;
                var p4 = p1 + W[len + i]; // prune edges in Ai
                for(p = p2 + 1; p < p4; p++){
                    j = cindex[p]; // check node j dead or in Lk
                    var nvj = W[nv + j];
                    if (nvj <= 0) continue;
                     // degree(i) += |j|
                    d += nvj; // place j in node list of i
                    cindex[pn++] = j; // compute hash for node i
                    h += j;
                } // check for mass elimination
                if (d === 0) {
                    // absorb i into k
                    cptr[i] = (0, $d5d21ffdbc06b94e$export$d405b3d9168b83fa)(k);
                    nvi = -W[nv + i]; // |Lk| -= |i|
                    dk -= nvi; // |k| += W[nv + i]
                    nvk += nvi;
                    nel += nvi;
                    W[nv + i] = 0; // node i is dead
                    W[elen + i] = -1;
                } else {
                    // update degree(i)
                    W[degree + i] = Math.min(W[degree + i], d); // move first node to end
                    cindex[pn] = cindex[p3]; // move 1st el. to end of Ei
                    cindex[p3] = cindex[p1]; // add k as 1st element in of Ei
                    cindex[p1] = k; // new len of adj. list of node i
                    W[len + i] = pn - p1 + 1; // finalize hash of i
                    h = (h < 0 ? -h : h) % n; // place i in hash bucket
                    W[next + i] = W[hhead + h];
                    W[hhead + h] = i; // save hash of i in last[i]
                    last[i] = h;
                }
            } // finalize |Lk|
            W[degree + k] = dk;
            lemax = Math.max(lemax, dk); // clear w
            mark = _wclear(mark + lemax, lemax, W, w, n); // Supernode detection. Supernode detection relies on the hash function h(i) computed for each node i.
            // If two nodes have identical adjacency lists, their hash functions wil be identical.
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check i is dead, skip it
                if (W[nv + i] >= 0) continue;
                 // scan hash bucket of node i
                h = last[i];
                i = W[hhead + h]; // hash bucket will be empty
                W[hhead + h] = -1;
                for(; i !== -1 && W[next + i] !== -1; i = W[next + i], mark++){
                    ln = W[len + i];
                    eln = W[elen + i];
                    for(p = cptr[i] + 1; p <= cptr[i] + ln - 1; p++)W[w + cindex[p]] = mark;
                    var jlast = i; // compare i with all j
                    for(j = W[next + i]; j !== -1;){
                        var ok = W[len + j] === ln && W[elen + j] === eln;
                        for(p = cptr[j] + 1; ok && p <= cptr[j] + ln - 1; p++)// compare i and j
                        if (W[w + cindex[p]] !== mark) ok = 0;
                         // check i and j are identical
                        if (ok) {
                            // absorb j into i
                            cptr[j] = (0, $d5d21ffdbc06b94e$export$d405b3d9168b83fa)(i);
                            W[nv + i] += W[nv + j];
                            W[nv + j] = 0; // node j is dead
                            W[elen + j] = -1; // delete j from hash bucket
                            j = W[next + j];
                            W[next + jlast] = j;
                        } else {
                            // j and i are different
                            jlast = j;
                            j = W[next + j];
                        }
                    }
                }
            } // Finalize new element. The elimination of node k is nearly complete. All nodes i in Lk are scanned one last time.
            // Node i is removed from Lk if it is dead. The flagged status of nv[i] is cleared.
            for(p = pk1, pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check  i is dead, skip it
                if ((nvi = -W[nv + i]) <= 0) continue;
                 // restore W[nv + i]
                W[nv + i] = nvi; // compute external degree(i)
                d = W[degree + i] + dk - nvi;
                d = Math.min(d, n - nel - nvi);
                if (W[head + d] !== -1) last[W[head + d]] = i;
                 // put i back in degree list
                W[next + i] = W[head + d];
                last[i] = -1;
                W[head + d] = i; // find new minimum degree
                mindeg = Math.min(mindeg, d);
                W[degree + i] = d; // place i in Lk
                cindex[p++] = i;
            } // # nodes absorbed into k
            W[nv + k] = nvk; // length of adj list of element k
            if ((W[len + k] = p - pk1) === 0) {
                // k is a root of the tree
                cptr[k] = -1; // k is now a dead element
                W[w + k] = 0;
            }
            if (elenk !== 0) // free unused space in Lk
            cnz = p;
        } // Postordering. The elimination is complete, but no permutation has been computed. All that is left
        // of the graph is the assembly tree (ptr) and a set of dead nodes and elements (i is a dead node if
        // nv[i] is zero and a dead element if nv[i] > 0). It is from this information only that the final permutation
        // is computed. The tree is restored by unflipping all of ptr.
        // fix assembly tree
        for(i = 0; i < n; i++)cptr[i] = (0, $d5d21ffdbc06b94e$export$d405b3d9168b83fa)(cptr[i]);
        for(j = 0; j <= n; j++)W[head + j] = -1;
         // place unordered nodes in lists
        for(j = n; j >= 0; j--){
            // skip if j is an element
            if (W[nv + j] > 0) continue;
             // place j in list of its parent
            W[next + j] = W[head + cptr[j]];
            W[head + cptr[j]] = j;
        } // place elements in lists
        for(e = n; e >= 0; e--){
            // skip unless e is an element
            if (W[nv + e] <= 0) continue;
            if (cptr[e] !== -1) {
                // place e in list of its parent
                W[next + e] = W[head + cptr[e]];
                W[head + cptr[e]] = e;
            }
        } // postorder the assembly tree
        for(k = 0, i = 0; i <= n; i++)if (cptr[i] === -1) k = (0, $29876d633c2a2514$export$18e42241aee7902a)(i, k, W, head, next, P, w);
         // remove last item in array
        P.splice(P.length - 1, 1); // return P
        return P;
    };
    /**
   * Creates the matrix that will be used by the approximate minimum degree ordering algorithm. The function accepts the matrix M as input and returns a permutation
   * vector P. The amd algorithm operates on a symmetrix matrix, so one of three symmetric matrices is formed.
   *
   * Order: 0
   *   A natural ordering P=null matrix is returned.
   *
   * Order: 1
   *   Matrix must be square. This is appropriate for a Cholesky or LU factorization.
   *   P = M + M'
   *
   * Order: 2
   *   Dense columns from M' are dropped, M recreated from M'. This is appropriatefor LU factorization of unsymmetric matrices.
   *   P = M' * M
   *
   * Order: 3
   *   This is best used for QR factorization or LU factorization is matrix M has no dense rows. A dense row is a row with more than 10*sqr(columns) entries.
   *   P = M' * M
   */ function _createTargetMatrix(order, a, m, n, dense) {
        // compute A'
        var at = transpose(a); // check order = 1, matrix must be square
        if (order === 1 && n === m) // C = A + A'
        return add(a, at);
         // check order = 2, drop dense columns from M'
        if (order === 2) {
            // transpose arrays
            var tindex = at._index;
            var tptr = at._ptr; // new column index
            var p2 = 0; // loop A' columns (rows)
            for(var j = 0; j < m; j++){
                // column j of AT starts here
                var p = tptr[j]; // new column j starts here
                tptr[j] = p2; // skip dense col j
                if (tptr[j + 1] - p > dense) continue;
                 // map rows in column j of A
                for(var p1 = tptr[j + 1]; p < p1; p++)tindex[p2++] = tindex[p];
            } // finalize AT
            tptr[m] = p2; // recreate A from new transpose matrix
            a = transpose(at); // use A' * A
            return multiply(at, a);
        } // use A' * A, square or rectangular matrix
        return multiply(at, a);
    }
    /**
   * Initialize quotient graph. There are four kind of nodes and elements that must be represented:
   *
   *  - A live node is a node i (or a supernode) that has not been selected as a pivot nad has not been merged into another supernode.
   *  - A dead node i is one that has been removed from the graph, having been absorved into r = flip(ptr[i]).
   *  - A live element e is one that is in the graph, having been formed when node e was selected as the pivot.
   *  - A dead element e is one that has benn absorved into a subsequent element s = flip(ptr[e]).
   */ function _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree) {
        // Initialize quotient graph
        for(var k = 0; k < n; k++)W[len + k] = cptr[k + 1] - cptr[k];
        W[len + n] = 0; // initialize workspace
        for(var i = 0; i <= n; i++){
            // degree list i is empty
            W[head + i] = -1;
            last[i] = -1;
            W[next + i] = -1; // hash list i is empty
            W[hhead + i] = -1; // node i is just one node
            W[nv + i] = 1; // node i is alive
            W[w + i] = 1; // Ek of node i is empty
            W[elen + i] = 0; // degree of node i
            W[degree + i] = W[len + i];
        } // clear w
        var mark = _wclear(0, 0, W, w, n); // n is a dead element
        W[elen + n] = -2; // n is a root of assembly tree
        cptr[n] = -1; // n is a dead element
        W[w + n] = 0; // return mark
        return mark;
    }
    /**
   * Initialize degree lists. Each node is placed in its degree lists. Nodes of zero degree are eliminated immediately. Nodes with
   * degree >= dense are alsol eliminated and merged into a placeholder node n, a dead element. Thes nodes will appera last in the
   * output permutation p.
   */ function _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next) {
        // result
        var nel = 0; // loop columns
        for(var i = 0; i < n; i++){
            // degree @ i
            var d = W[degree + i]; // check node i is empty
            if (d === 0) {
                // element i is dead
                W[elen + i] = -2;
                nel++; // i is a root of assembly tree
                cptr[i] = -1;
                W[w + i] = 0;
            } else if (d > dense) {
                // absorb i into element n
                W[nv + i] = 0; // node i is dead
                W[elen + i] = -1;
                nel++;
                cptr[i] = (0, $d5d21ffdbc06b94e$export$d405b3d9168b83fa)(n);
                W[nv + n]++;
            } else {
                var h = W[head + d];
                if (h !== -1) last[h] = i;
                 // put node i in degree list d
                W[next + i] = W[head + d];
                W[head + d] = i;
            }
        }
        return nel;
    }
    function _wclear(mark, lemax, W, w, n) {
        if (mark < 2 || mark + lemax < 0) {
            for(var k = 0; k < n; k++)if (W[w + k] !== 0) W[w + k] = 1;
            mark = 2;
        } // at this point, W [0..n-1] < mark holds
        return mark;
    }
    function _diag(i, j) {
        return i !== j;
    }
});



/**
 * This function determines if j is a leaf of the ith row subtree.
 * Consider A(i,j), node j in ith row subtree and return lca(jprev,j)
 *
 * @param {Number}  i               The ith row subtree
 * @param {Number}  j               The node to test
 * @param {Array}   w               The workspace array
 * @param {Number}  first           The index offset within the workspace for the first array
 * @param {Number}  maxfirst        The index offset within the workspace for the maxfirst array
 * @param {Number}  prevleaf        The index offset within the workspace for the prevleaf array
 * @param {Number}  ancestor        The index offset within the workspace for the ancestor array
 *
 * @return {Object}
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $58e0c37e3280a957$export$e5adc9884f74ac27(i, j, w, first, maxfirst, prevleaf, ancestor) {
    var s, sparent; // our result
    var jleaf = 0;
    var q; // check j is a leaf
    if (i <= j || w[first + j] <= w[maxfirst + i]) return -1;
     // update max first[j] seen so far
    w[maxfirst + i] = w[first + j]; // jprev = previous leaf of ith subtree
    var jprev = w[prevleaf + i];
    w[prevleaf + i] = j; // check j is first or subsequent leaf
    if (jprev === -1) {
        // 1st leaf, q = root of ith subtree
        jleaf = 1;
        q = i;
    } else {
        // update jleaf
        jleaf = 2; // q = least common ancester (jprev,j)
        for(q = jprev; q !== w[ancestor + q]; q = w[ancestor + q]);
        for(s = jprev; s !== q; s = sparent){
            // path compression
            sparent = w[ancestor + s];
            w[ancestor + s] = q;
        }
    }
    return {
        jleaf: jleaf,
        q: q
    };
}


var $9a4aa31daa9ee085$var$name = "csCounts";
var $9a4aa31daa9ee085$var$dependencies = [
    "transpose"
];
var $9a4aa31daa9ee085$export$1feb4fbda2abf3b3 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($9a4aa31daa9ee085$var$name, $9a4aa31daa9ee085$var$dependencies, (_ref)=>{
    var { transpose: transpose } = _ref;
    /**
   * Computes the column counts using the upper triangular part of A.
   * It transposes A internally, none of the input parameters are modified.
   *
   * @param {Matrix} a           The sparse matrix A
   *
   * @param {Matrix} ata         Count the columns of A'A instead
   *
   * @return                     An array of size n of the column counts or null on error
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function(a, parent, post, ata) {
        // check inputs
        if (!a || !parent || !post) return null;
         // a matrix arrays
        var asize = a._size; // rows and columns
        var m = asize[0];
        var n = asize[1]; // variables
        var i, j, k, J, p, p0, p1; // workspace size
        var s = 4 * n + (ata ? n + m + 1 : 0); // allocate workspace
        var w = []; // (s)
        var ancestor = 0; // first n entries
        var maxfirst = n; // next n entries
        var prevleaf = 2 * n; // next n entries
        var first = 3 * n; // next n entries
        var head = 4 * n; // next n + 1 entries (used when ata is true)
        var next = 5 * n + 1; // last entries in workspace
        // clear workspace w[0..s-1]
        for(k = 0; k < s; k++)w[k] = -1;
         // allocate result
        var colcount = []; // (n)
        // AT = A'
        var at = transpose(a); // at arrays
        var tindex = at._index;
        var tptr = at._ptr; // find w[first + j]
        for(k = 0; k < n; k++){
            j = post[k]; // colcount[j]=1 if j is a leaf
            colcount[j] = w[first + j] === -1 ? 1 : 0;
            for(; j !== -1 && w[first + j] === -1; j = parent[j])w[first + j] = k;
        } // initialize ata if needed
        if (ata) {
            // invert post
            for(k = 0; k < n; k++)w[post[k]] = k;
             // loop rows (columns in AT)
            for(i = 0; i < m; i++){
                // values in column i of AT
                for(k = n, p0 = tptr[i], p1 = tptr[i + 1], p = p0; p < p1; p++)k = Math.min(k, w[tindex[p]]);
                 // place row i in linked list k
                w[next + i] = w[head + k];
                w[head + k] = i;
            }
        } // each node in its own set
        for(i = 0; i < n; i++)w[ancestor + i] = i;
        for(k = 0; k < n; k++){
            // j is the kth node in postordered etree
            j = post[k]; // check j is not a root
            if (parent[j] !== -1) colcount[parent[j]]--;
             // J=j for LL'=A case
            for(J = ata ? w[head + k] : j; J !== -1; J = ata ? w[next + J] : -1)for(p = tptr[J]; p < tptr[J + 1]; p++){
                i = tindex[p];
                var r = (0, $58e0c37e3280a957$export$e5adc9884f74ac27)(i, j, w, first, maxfirst, prevleaf, ancestor); // check A(i,j) is in skeleton
                if (r.jleaf >= 1) colcount[j]++;
                 // check account for overlap in q
                if (r.jleaf === 2) colcount[r.q]--;
            }
            if (parent[j] !== -1) w[ancestor + j] = parent[j];
        } // sum up colcount's of each child
        for(j = 0; j < n; j++)if (parent[j] !== -1) colcount[parent[j]] += colcount[j];
        return colcount;
    };
});



var $1ef7f34205f6d056$var$name = "csSqr";
var $1ef7f34205f6d056$var$dependencies = [
    "add",
    "multiply",
    "transpose"
];
var $1ef7f34205f6d056$export$4d3f338d9cfe48c1 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1ef7f34205f6d056$var$name, $1ef7f34205f6d056$var$dependencies, (_ref)=>{
    var { add: add, multiply: multiply, transpose: transpose } = _ref;
    var csAmd = (0, $7dd2fdb070f85aa8$export$485230eb48878637)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csCounts = (0, $9a4aa31daa9ee085$export$1feb4fbda2abf3b3)({
        transpose: transpose
    });
    /**
   * Symbolic ordering and analysis for QR and LU decompositions.
   *
   * @param {Number}  order           The ordering strategy (see csAmd for more details)
   * @param {Matrix}  a               The A matrix
   * @param {boolean} qr              Symbolic ordering and analysis for QR decomposition (true) or
   *                                  symbolic ordering and analysis for LU decomposition (false)
   *
   * @return {Object}                 The Symbolic ordering and analysis for matrix A
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csSqr(order, a, qr) {
        // a arrays
        var aptr = a._ptr;
        var asize = a._size; // columns
        var n = asize[1]; // vars
        var k; // symbolic analysis result
        var s = {}; // fill-reducing ordering
        s.q = csAmd(order, a); // validate results
        if (order && !s.q) return null;
         // QR symbolic analysis
        if (qr) {
            // apply permutations if needed
            var c = order ? (0, $dca56a61055f1e45$export$76070a0ecffd0bb2)(a, null, s.q, 0) : a; // etree of C'*C, where C=A(:,q)
            s.parent = (0, $736e5a4730723aeb$export$720e2a9a0fdebf8c)(c, 1); // post order elimination tree
            var post = (0, $60036bd6dd0efc7f$export$90626b0a5705891a)(s.parent, n); // col counts chol(C'*C)
            s.cp = csCounts(c, s.parent, post, 1); // check we have everything needed to calculate number of nonzero elements
            if (c && s.parent && s.cp && _vcount(c, s)) // calculate number of nonzero elements
            for(s.unz = 0, k = 0; k < n; k++)s.unz += s.cp[k];
        } else {
            // for LU factorization only, guess nnz(L) and nnz(U)
            s.unz = 4 * aptr[n] + n;
            s.lnz = s.unz;
        } // return result S
        return s;
    };
    /**
   * Compute nnz(V) = s.lnz, s.pinv, s.leftmost, s.m2 from A and s.parent
   */ function _vcount(a, s) {
        // a arrays
        var aptr = a._ptr;
        var aindex = a._index;
        var asize = a._size; // rows & columns
        var m = asize[0];
        var n = asize[1]; // initialize s arrays
        s.pinv = []; // (m + n)
        s.leftmost = []; // (m)
        // vars
        var parent = s.parent;
        var pinv = s.pinv;
        var leftmost = s.leftmost; // workspace, next: first m entries, head: next n entries, tail: next n entries, nque: next n entries
        var w = []; // (m + 3 * n)
        var next = 0;
        var head = m;
        var tail = m + n;
        var nque = m + 2 * n; // vars
        var i, k, p, p0, p1; // initialize w
        for(k = 0; k < n; k++){
            // queue k is empty
            w[head + k] = -1;
            w[tail + k] = -1;
            w[nque + k] = 0;
        } // initialize row arrays
        for(i = 0; i < m; i++)leftmost[i] = -1;
         // loop columns backwards
        for(k = n - 1; k >= 0; k--)// values & index for column k
        for(p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++)// leftmost[i] = min(find(A(i,:)))
        leftmost[aindex[p]] = k;
         // scan rows in reverse order
        for(i = m - 1; i >= 0; i--){
            // row i is not yet ordered
            pinv[i] = -1;
            k = leftmost[i]; // check row i is empty
            if (k === -1) continue;
             // first row in queue k
            if (w[nque + k]++ === 0) w[tail + k] = i;
             // put i at head of queue k
            w[next + i] = w[head + k];
            w[head + k] = i;
        }
        s.lnz = 0;
        s.m2 = m; // find row permutation and nnz(V)
        for(k = 0; k < n; k++){
            // remove row i from queue k
            i = w[head + k]; // count V(k,k) as nonzero
            s.lnz++; // add a fictitious row
            if (i < 0) i = s.m2++;
             // associate row i with V(:,k)
            pinv[i] = k; // skip if V(k+1:m,k) is empty
            if (--nque[k] <= 0) continue;
             // nque[k] is nnz (V(k+1:m,k))
            s.lnz += w[nque + k]; // move all rows to parent of k
            var pa = parent[k];
            if (pa !== -1) {
                if (w[nque + pa] === 0) w[tail + pa] = w[tail + k];
                w[next + w[tail + k]] = w[head + pa];
                w[head + pa] = w[next + i];
                w[nque + pa] += w[nque + k];
            }
        }
        for(i = 0; i < m; i++)if (pinv[i] < 0) pinv[i] = k++;
        return true;
    }
});



/**
 * Checks if the node at w[j] is marked
 *
 * @param {Array}   w               The array
 * @param {Number}  j               The array index
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $31012de9eb4e6f79$export$f0d640c1b5bfa3e(w, j) {
    // check node is marked
    return w[j] < 0;
}



function $4870a2c70467a794$export$53b20e7656f0b914(w, j) {
    // mark w[j]
    w[j] = (0, $d5d21ffdbc06b94e$export$d405b3d9168b83fa)(w[j]);
}





function $f954380163ee4aa2$export$8b1bf205e2e76d92(i) {
    // flip the value if it is negative
    return i < 0 ? (0, $d5d21ffdbc06b94e$export$d405b3d9168b83fa)(i) : i;
}


function $300d79a80da85091$export$c913fe476af3832b(j, g, top, xi, pinv) {
    // g arrays
    var index = g._index;
    var ptr = g._ptr;
    var size = g._size; // columns
    var n = size[1]; // vars
    var i, p, p2; // initialize head
    var head = 0; // initialize the recursion stack
    xi[0] = j; // loop
    while(head >= 0){
        // get j from the top of the recursion stack
        j = xi[head]; // apply permutation vector
        var jnew = pinv ? pinv[j] : j; // check node j is marked
        if (!(0, $31012de9eb4e6f79$export$f0d640c1b5bfa3e)(ptr, j)) {
            // mark node j as visited
            (0, $4870a2c70467a794$export$53b20e7656f0b914)(ptr, j); // update stack (last n entries in xi)
            xi[n + head] = jnew < 0 ? 0 : (0, $f954380163ee4aa2$export$8b1bf205e2e76d92)(ptr[jnew]);
        } // node j done if no unvisited neighbors
        var done = 1; // examine all neighbors of j, stack (last n entries in xi)
        for(p = xi[n + head], p2 = jnew < 0 ? 0 : (0, $f954380163ee4aa2$export$8b1bf205e2e76d92)(ptr[jnew + 1]); p < p2; p++){
            // consider neighbor node i
            i = index[p]; // check we have visited node i, skip it
            if ((0, $31012de9eb4e6f79$export$f0d640c1b5bfa3e)(ptr, i)) continue;
             // pause depth-first search of node j, update stack (last n entries in xi)
            xi[n + head] = p; // start dfs at node i
            xi[++head] = i; // node j is not done
            done = 0; // break, to start dfs(i)
            break;
        } // check depth-first search at node j is done
        if (done) {
            // remove j from the recursion stack
            head--; // and place in the output stack
            xi[--top] = j;
        }
    }
    return top;
}


function $4018b70ce35ad9ba$export$125cefbcd149ec98(g, b, k, xi, pinv) {
    // g arrays
    var gptr = g._ptr;
    var gsize = g._size; // b arrays
    var bindex = b._index;
    var bptr = b._ptr; // columns
    var n = gsize[1]; // vars
    var p, p0, p1; // initialize top
    var top = n; // loop column indeces in B
    for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++){
        // node i
        var i = bindex[p]; // check node i is marked
        if (!(0, $31012de9eb4e6f79$export$f0d640c1b5bfa3e)(gptr, i)) // start a dfs at unmarked node i
        top = (0, $300d79a80da85091$export$c913fe476af3832b)(i, g, top, xi, pinv);
    } // loop columns from top -> n - 1
    for(p = top; p < n; p++)// restore G
    (0, $4870a2c70467a794$export$53b20e7656f0b914)(gptr, xi[p]);
    return top;
}



var $c36a3ee6ada424b6$var$name = "csSpsolve";
var $c36a3ee6ada424b6$var$dependencies = [
    "divideScalar",
    "multiply",
    "subtract"
];
var $c36a3ee6ada424b6$export$517933164557054f = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c36a3ee6ada424b6$var$name, $c36a3ee6ada424b6$var$dependencies, (_ref)=>{
    var { divideScalar: divideScalar, multiply: multiply, subtract: subtract } = _ref;
    /**
   * The function csSpsolve() computes the solution to G * x = bk, where bk is the
   * kth column of B. When lo is true, the function assumes G = L is lower triangular with the
   * diagonal entry as the first entry in each column. When lo is true, the function assumes G = U
   * is upper triangular with the diagonal entry as the last entry in each column.
   *
   * @param {Matrix}  g               The G matrix
   * @param {Matrix}  b               The B matrix
   * @param {Number}  k               The kth column in B
   * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
   *                                  The first n entries is the nonzero pattern, the last n entries is the stack
   * @param {Array}   x               The soluton to the linear system G * x = b
   * @param {Array}   pinv            The inverse row permutation vector, must be null for L * x = b
   * @param {boolean} lo              The lower (true) upper triangular (false) flag
   *
   * @return {Number}                 The index for the nonzero pattern
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csSpsolve(g, b, k, xi, x, pinv, lo) {
        // g arrays
        var gvalues = g._values;
        var gindex = g._index;
        var gptr = g._ptr;
        var gsize = g._size; // columns
        var n = gsize[1]; // b arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr; // vars
        var p, p0, p1, q; // xi[top..n-1] = csReach(B(:,k))
        var top = (0, $4018b70ce35ad9ba$export$125cefbcd149ec98)(g, b, k, xi, pinv); // clear x
        for(p = top; p < n; p++)x[xi[p]] = 0;
         // scatter b
        for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++)x[bindex[p]] = bvalues[p];
         // loop columns
        for(var px = top; px < n; px++){
            // x array index for px
            var j = xi[px]; // apply permutation vector (U x = b), j maps to column J of G
            var J = pinv ? pinv[j] : j; // check column J is empty
            if (J < 0) continue;
             // column value indeces in G, p0 <= p < p1
            p0 = gptr[J];
            p1 = gptr[J + 1]; // x(j) /= G(j,j)
            x[j] = divideScalar(x[j], gvalues[lo ? p0 : p1 - 1]); // first entry L(j,j)
            p = lo ? p0 + 1 : p0;
            q = lo ? p1 : p1 - 1; // loop
            for(; p < q; p++){
                // row
                var i = gindex[p]; // x(i) -= G(i,j) * x(j)
                x[i] = subtract(x[i], multiply(gvalues[p], x[j]));
            }
        } // return top of stack
        return top;
    };
});


var $3f5361adc7478e44$var$name = "csLu";
var $3f5361adc7478e44$var$dependencies = [
    "abs",
    "divideScalar",
    "multiply",
    "subtract",
    "larger",
    "largerEq",
    "SparseMatrix"
];
var $3f5361adc7478e44$export$5487b5fadeacd2f6 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($3f5361adc7478e44$var$name, $3f5361adc7478e44$var$dependencies, (_ref)=>{
    var { abs: abs, divideScalar: divideScalar, multiply: multiply, subtract: subtract, larger: larger, largerEq: largerEq, SparseMatrix: SparseMatrix } = _ref;
    var csSpsolve = (0, $c36a3ee6ada424b6$export$517933164557054f)({
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract
    });
    /**
   * Computes the numeric LU factorization of the sparse matrix A. Implements a Left-looking LU factorization
   * algorithm that computes L and U one column at a tume. At the kth step, it access columns 1 to k-1 of L
   * and column k of A. Given the fill-reducing column ordering q (see parameter s) computes L, U and pinv so
   * L * U = A(p, q), where p is the inverse of pinv.
   *
   * @param {Matrix}  m               The A Matrix to factorize
   * @param {Object}  s               The symbolic analysis from csSqr(). Provides the fill-reducing
   *                                  column ordering q
   * @param {Number}  tol             Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Number}                 The numeric LU factorization of A or null
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csLu(m, s, tol) {
        // validate input
        if (!m) return null;
         // m arrays
        var size = m._size; // columns
        var n = size[1]; // symbolic analysis result
        var q;
        var lnz = 100;
        var unz = 100; // update symbolic analysis parameters
        if (s) {
            q = s.q;
            lnz = s.lnz || lnz;
            unz = s.unz || unz;
        } // L arrays
        var lvalues = []; // (lnz)
        var lindex = []; // (lnz)
        var lptr = []; // (n + 1)
        // L
        var L = new SparseMatrix({
            values: lvalues,
            index: lindex,
            ptr: lptr,
            size: [
                n,
                n
            ]
        }); // U arrays
        var uvalues = []; // (unz)
        var uindex = []; // (unz)
        var uptr = []; // (n + 1)
        // U
        var U = new SparseMatrix({
            values: uvalues,
            index: uindex,
            ptr: uptr,
            size: [
                n,
                n
            ]
        }); // inverse of permutation vector
        var pinv = []; // (n)
        // vars
        var i, p; // allocate arrays
        var x = []; // (n)
        var xi = []; // (2 * n)
        // initialize variables
        for(i = 0; i < n; i++){
            // clear workspace
            x[i] = 0; // no rows pivotal yet
            pinv[i] = -1; // no cols of L yet
            lptr[i + 1] = 0;
        } // reset number of nonzero elements in L and U
        lnz = 0;
        unz = 0; // compute L(:,k) and U(:,k)
        for(var k = 0; k < n; k++){
            // update ptr
            lptr[k] = lnz;
            uptr[k] = unz; // apply column permutations if needed
            var col = q ? q[k] : k; // solve triangular system, x = L\A(:,col)
            var top = csSpsolve(L, m, col, xi, x, pinv, 1); // find pivot
            var ipiv = -1;
            var a = -1; // loop xi[] from top -> n
            for(p = top; p < n; p++){
                // x[i] is nonzero
                i = xi[p]; // check row i is not yet pivotal
                if (pinv[i] < 0) {
                    // absolute value of x[i]
                    var xabs = abs(x[i]); // check absoulte value is greater than pivot value
                    if (larger(xabs, a)) {
                        // largest pivot candidate so far
                        a = xabs;
                        ipiv = i;
                    }
                } else {
                    // x(i) is the entry U(pinv[i],k)
                    uindex[unz] = pinv[i];
                    uvalues[unz++] = x[i];
                }
            } // validate we found a valid pivot
            if (ipiv === -1 || a <= 0) return null;
             // update actual pivot column, give preference to diagonal value
            if (pinv[col] < 0 && largerEq(abs(x[col]), multiply(a, tol))) ipiv = col;
             // the chosen pivot
            var pivot = x[ipiv]; // last entry in U(:,k) is U(k,k)
            uindex[unz] = k;
            uvalues[unz++] = pivot; // ipiv is the kth pivot row
            pinv[ipiv] = k; // first entry in L(:,k) is L(k,k) = 1
            lindex[lnz] = ipiv;
            lvalues[lnz++] = 1; // L(k+1:n,k) = x / pivot
            for(p = top; p < n; p++){
                // row
                i = xi[p]; // check x(i) is an entry in L(:,k)
                if (pinv[i] < 0) {
                    // save unpermuted row in L
                    lindex[lnz] = i; // scale pivot column
                    lvalues[lnz++] = divideScalar(x[i], pivot);
                } // x[0..n-1] = 0 for next k
                x[i] = 0;
            }
        } // update ptr
        lptr[n] = lnz;
        uptr[n] = unz; // fix row indices of L for final pinv
        for(p = 0; p < lnz; p++)lindex[p] = pinv[lindex[p]];
         // trim arrays
        lvalues.splice(lnz, lvalues.length - lnz);
        lindex.splice(lnz, lindex.length - lnz);
        uvalues.splice(unz, uvalues.length - unz);
        uindex.splice(unz, uindex.length - unz); // return LU factor
        return {
            L: L,
            U: U,
            pinv: pinv
        };
    };
});


var $3527f7e8ae9be964$var$name = "slu";
var $3527f7e8ae9be964$var$dependencies = [
    "typed",
    "abs",
    "add",
    "multiply",
    "transpose",
    "divideScalar",
    "subtract",
    "larger",
    "largerEq",
    "SparseMatrix"
];
var $3527f7e8ae9be964$export$e44ac9822ce417ae = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($3527f7e8ae9be964$var$name, $3527f7e8ae9be964$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, multiply: multiply, transpose: transpose, divideScalar: divideScalar, subtract: subtract, larger: larger, largerEq: largerEq, SparseMatrix: SparseMatrix } = _ref;
    var csSqr = (0, $1ef7f34205f6d056$export$4d3f338d9cfe48c1)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csLu = (0, $3f5361adc7478e44$export$5487b5fadeacd2f6)({
        abs: abs,
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract,
        larger: larger,
        largerEq: largerEq,
        SparseMatrix: SparseMatrix
    });
    /**
   * Calculate the Sparse Matrix LU decomposition with full pivoting. Sparse Matrix `A` is decomposed in two matrices (`L`, `U`) and two permutation vectors (`pinv`, `q`) where
   *
   * `P * A * Q = L * U`
   *
   * Syntax:
   *
   *    math.slu(A, order, threshold)
   *
   * Examples:
   *
   *    const A = math.sparse([[4,3], [6, 3]])
   *    math.slu(A, 1, 0.001)
   *    // returns:
   *    // {
   *    //   L: [[1, 0], [1.5, 1]]
   *    //   U: [[4, 3], [0, -1.5]]
   *    //   p: [0, 1]
   *    //   q: [0, 1]
   *    // }
   *
   * See also:
   *
   *    lup, lsolve, usolve, lusolve
   *
   * @param {SparseMatrix} A              A two dimensional sparse matrix for which to get the LU decomposition.
   * @param {Number}       order          The Symbolic Ordering and Analysis order:
   *                                       0 - Natural ordering, no permutation vector q is returned
   *                                       1 - Matrix must be square, symbolic ordering and analisis is performed on M = A + A'
   *                                       2 - Symbolic ordering and analisis is performed on M = A' * A. Dense columns from A' are dropped, A recreated from A'.
   *                                           This is appropriatefor LU factorization of unsymmetric matrices.
   *                                       3 - Symbolic ordering and analisis is performed on M = A' * A. This is best used for LU factorization is matrix M has no dense rows.
   *                                           A dense row is a row with more than 10*sqr(columns) entries.
   * @param {Number}       threshold       Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Object} The lower triangular matrix, the upper triangular matrix and the permutation vectors.
   */ return typed($3527f7e8ae9be964$var$name, {
        "SparseMatrix, number, number": function SparseMatrixNumberNumber(a, order, threshold) {
            // verify order
            if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(order) || order < 0 || order > 3) throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
             // verify threshold
            if (threshold < 0 || threshold > 1) throw new Error("Partial pivoting threshold must be a number from 0 to 1");
             // perform symbolic ordering and analysis
            var s = csSqr(order, a, false); // perform lu decomposition
            var f = csLu(a, s, threshold); // return decomposition
            return {
                L: f.L,
                U: f.U,
                p: f.pinv,
                q: s.q,
                toString: function toString() {
                    return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\np: " + this.p.toString() + (this.q ? "\nq: " + this.q.toString() : "") + "\n";
                }
            };
        }
    });
});









var $e72de5f9a305542d$var$name = "smaller";
var $e72de5f9a305542d$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $e72de5f9a305542d$export$6b477d90b957f03e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e72de5f9a305542d$var$name, $e72de5f9a305542d$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $49703efd2d98c69c$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether value x is smaller than y.
   *
   * The function returns true when x is smaller than y and the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smaller(x, y)
   *
   * Examples:
   *
   *    math.smaller(2, 3)            // returns true
   *    math.smaller(5, 2 * 2)        // returns false
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.smaller(a, b)            // returns true
   *
   * See also:
   *
   *    equal, unequal, smallerEq, smaller, smallerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ return typed($e72de5f9a305542d$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x < y;
        },
        "number, number": function numberNumber(x, y) {
            return x < y && !(0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.lt(y) && !(0, $cea3608675fc8eba$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) === -1;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $e72de5f9a305542d$export$4f82e7db4d803209 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e72de5f9a305542d$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($e72de5f9a305542d$var$name, {
        "number, number": function numberNumber(x, y) {
            return x < y && !(0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon);
        }
    });
});









var $26fdadb7586338bc$var$name = "smallerEq";
var $26fdadb7586338bc$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $26fdadb7586338bc$export$e1b2fff975be9083 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($26fdadb7586338bc$var$name, $26fdadb7586338bc$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $49703efd2d98c69c$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether value x is smaller or equal to y.
   *
   * The function returns true when x is smaller than y or the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smallerEq(x, y)
   *
   * Examples:
   *
   *    math.smaller(1 + 2, 3)        // returns false
   *    math.smallerEq(1 + 2, 3)      // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ return typed($26fdadb7586338bc$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x <= y;
        },
        "number, number": function numberNumber(x, y) {
            return x <= y || (0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.lte(y) || (0, $cea3608675fc8eba$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) !== 1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $26fdadb7586338bc$export$78c24428429985da = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($26fdadb7586338bc$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($26fdadb7586338bc$var$name, {
        "number, number": function numberNumber(x, y) {
            return x <= y || (0, $a03283b133c3c55b$export$6f3989c6ecc04081)(x, y, config.epsilon);
        }
    });
});



var $ae63fe71060c4c24$var$name = "sort";
var $ae63fe71060c4c24$var$dependencies = [
    "typed",
    "matrix",
    "compare",
    "compareNatural"
];
var $ae63fe71060c4c24$export$10463693a2093403 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($ae63fe71060c4c24$var$name, $ae63fe71060c4c24$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, compare: compare, compareNatural: compareNatural } = _ref;
    var compareAsc = compare;
    var compareDesc = (a, b)=>-compare(a, b);
    /**
   * Sort the items in a matrix.
   *
   * Syntax:
   *
   *    math.sort(x)
   *    math.sort(x, compare)
   *
   * Examples:
   *
   *    math.sort([5, 10, 1]) // returns [1, 5, 10]
   *    math.sort(['C', 'B', 'A', 'D'], math.compareNatural)
   *    // returns ['A', 'B', 'C', 'D']
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.sort(['Langdon', 'Tom', 'Sara'], sortByLength)
   *    // returns ['Tom', 'Sara', 'Langdon']
   *
   * See also:
   *
   *    filter, forEach, map, compare, compareNatural
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Function | 'asc' | 'desc' | 'natural'} [compare='asc']
   *        An optional _comparator function or name. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {Matrix | Array} Returns the sorted matrix.
   */ return typed($ae63fe71060c4c24$var$name, {
        Array: function Array(x) {
            _arrayIsVector(x);
            return x.sort(compareAsc);
        },
        Matrix: function Matrix(x) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(compareAsc), x.storage());
        },
        "Array, function": function ArrayFunction(x, _comparator) {
            _arrayIsVector(x);
            return x.sort(_comparator);
        },
        "Matrix, function": function MatrixFunction(x, _comparator) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator), x.storage());
        },
        "Array, string": function ArrayString(x, order) {
            _arrayIsVector(x);
            return x.sort(_comparator(order));
        },
        "Matrix, string": function MatrixString(x, order) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator(order)), x.storage());
        }
    });
    /**
   * Get the comparator for given order ('asc', 'desc', 'natural')
   * @param {'asc' | 'desc' | 'natural'} order
   * @return {Function} Returns a _comparator function
   */ function _comparator(order) {
        if (order === "asc") return compareAsc;
        else if (order === "desc") return compareDesc;
        else if (order === "natural") return compareNatural;
        else throw new Error('String "asc", "desc", or "natural" expected');
    }
    /**
   * Validate whether an array is one dimensional
   * Throws an error when this is not the case
   * @param {Array} array
   * @private
   */ function _arrayIsVector(array) {
        if ((0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(array).length !== 1) throw new Error("One dimensional array expected");
    }
    /**
   * Validate whether a matrix is one dimensional
   * Throws an error when this is not the case
   * @param {Matrix} matrix
   * @private
   */ function _matrixIsVector(matrix) {
        if (matrix.size().length !== 1) throw new Error("One dimensional matrix expected");
    }
});


var $4a16c0cb547a60b2$var$name = "Spa";
var $4a16c0cb547a60b2$var$dependencies = [
    "addScalar",
    "equalScalar",
    "FibonacciHeap"
];
var $4a16c0cb547a60b2$export$5e37e847685a0540 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($4a16c0cb547a60b2$var$name, $4a16c0cb547a60b2$var$dependencies, (_ref)=>{
    var { addScalar: addScalar, equalScalar: equalScalar, FibonacciHeap: FibonacciHeap } = _ref;
    /**
   * An ordered Sparse Accumulator is a representation for a sparse vector that includes a dense array
   * of the vector elements and an ordered list of non-zero elements.
   */ function Spa() {
        if (!(this instanceof Spa)) throw new SyntaxError("Constructor must be called with the new operator");
         // allocate vector, TODO use typed arrays
        this._values = [];
        this._heap = new FibonacciHeap();
    }
    /**
   * Attach type information
   */ Spa.prototype.type = "Spa";
    Spa.prototype.isSpa = true;
    /**
   * Set the value for index i.
   *
   * @param {number} i                       The index
   * @param {number | BigNumber | Complex}   The value at index i
   */ Spa.prototype.set = function(i, v) {
        // check we have a value @ i
        if (!this._values[i]) {
            // insert in heap
            var node = this._heap.insert(i, v); // set the value @ i
            this._values[i] = node;
        } else // update the value @ i
        this._values[i].value = v;
    };
    Spa.prototype.get = function(i) {
        var node = this._values[i];
        if (node) return node.value;
        return 0;
    };
    Spa.prototype.accumulate = function(i, v) {
        // node @ i
        var node = this._values[i];
        if (!node) {
            // insert in heap
            node = this._heap.insert(i, v); // initialize value
            this._values[i] = node;
        } else // accumulate value
        node.value = addScalar(node.value, v);
    };
    Spa.prototype.forEach = function(from, to, callback) {
        // references
        var heap = this._heap;
        var values = this._values; // nodes
        var nodes = []; // node with minimum key, save it
        var node = heap.extractMinimum();
        if (node) nodes.push(node);
         // extract nodes from heap (ordered)
        while(node && node.key <= to){
            // check it is in range
            if (node.key >= from) // check value is not zero
            {
                if (!equalScalar(node.value, 0)) // invoke callback
                callback(node.key, node.value, this);
            } // extract next node, save it
            node = heap.extractMinimum();
            if (node) nodes.push(node);
        } // reinsert all nodes in heap
        for(var i = 0; i < nodes.length; i++){
            // current node
            var n = nodes[i]; // insert node in heap
            node = heap.insert(n.key, n.value); // update values
            values[node.key] = node;
        }
    };
    Spa.prototype.swap = function(i, j) {
        // node @ i and j
        var nodei = this._values[i];
        var nodej = this._values[j]; // check we need to insert indeces
        if (!nodei && nodej) {
            // insert in heap
            nodei = this._heap.insert(i, nodej.value); // remove from heap
            this._heap.remove(nodej); // set values
            this._values[i] = nodei;
            this._values[j] = undefined;
        } else if (nodei && !nodej) {
            // insert in heap
            nodej = this._heap.insert(j, nodei.value); // remove from heap
            this._heap.remove(nodei); // set values
            this._values[j] = nodej;
            this._values[i] = undefined;
        } else if (nodei && nodej) {
            // swap values
            var v = nodei.value;
            nodei.value = nodej.value;
            nodej.value = v;
        }
    };
    return Spa;
}, {
    isClass: true
});


var $2e38ec0cdadeb1a4$var$name = "sparse";
var $2e38ec0cdadeb1a4$var$dependencies = [
    "typed",
    "SparseMatrix"
];
var $2e38ec0cdadeb1a4$export$89ff03fdb3964a99 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($2e38ec0cdadeb1a4$var$name, $2e38ec0cdadeb1a4$var$dependencies, (_ref)=>{
    var { typed: typed, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a Sparse Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   * Note that a Sparse Matrix is always 2-dimensional, so for example if
   * you create one from a plain array of _n_ numbers, you get an _n_ by 1
   * Sparse "column vector".
   *
   * Syntax:
   *
   *    math.sparse()               // creates an empty sparse matrix.
   *    math.sparse(data)           // creates a sparse matrix with initial data.
   *    math.sparse(data, 'number') // creates a sparse matrix with initial data, number datatype.
   *
   * Examples:
   *
   *    let m = math.sparse([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *    let v = math.sparse([0, 0, 1])
   *    v.size()                        // Array [3, 1]
   *    v.get([2, 0])                   // number 1
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, matrix
   *
   * @param {Array | Matrix} [data]    A two dimensional array
   *
   * @return {Matrix} The created matrix
   */ return typed($2e38ec0cdadeb1a4$var$name, {
        "": function _() {
            return new SparseMatrix([]);
        },
        string: function string(datatype) {
            return new SparseMatrix([], datatype);
        },
        "Array | Matrix": function ArrayMatrix(data) {
            return new SparseMatrix(data);
        },
        "Array | Matrix, string": function ArrayMatrixString(data, datatype) {
            return new SparseMatrix(data, datatype);
        }
    });
});








var $506dafb406c6f1a0$var$name = "SparseMatrix";
var $506dafb406c6f1a0$var$dependencies = [
    "typed",
    "equalScalar",
    "Matrix"
];
var $506dafb406c6f1a0$export$a783ce8f6a98b2e5 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($506dafb406c6f1a0$var$name, $506dafb406c6f1a0$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar, Matrix: Matrix } = _ref;
    /**
   * Sparse Matrix implementation. This type implements
   * a [Compressed Column Storage](https://en.wikipedia.org/wiki/Sparse_matrix#Compressed_sparse_column_(CSC_or_CCS))
   * format for two-dimensional sparse matrices.
   * @class SparseMatrix
   */ function SparseMatrix(data, datatype) {
        if (!(this instanceof SparseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $2c4f948f17aa2240$export$844ec244b1367d54)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(data)) // create from matrix
        _createFromMatrix(this, data, datatype);
        else if (data && (0, $2c4f948f17aa2240$export$43bee75e5e14138e)(data.index) && (0, $2c4f948f17aa2240$export$43bee75e5e14138e)(data.ptr) && (0, $2c4f948f17aa2240$export$43bee75e5e14138e)(data.size)) {
            // initialize fields
            this._values = data.values;
            this._index = data.index;
            this._ptr = data.ptr;
            this._size = data.size;
            this._datatype = datatype || data.datatype;
        } else if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(data)) // create from array
        _createFromArray(this, data, datatype);
        else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(data) + ")");
        else {
            // nothing provided
            this._values = [];
            this._index = [];
            this._ptr = [
                0
            ];
            this._size = [
                0,
                0
            ];
            this._datatype = datatype;
        }
    }
    function _createFromMatrix(matrix, source, datatype) {
        // check matrix type
        if (source.type === "SparseMatrix") {
            // clone arrays
            matrix._values = source._values ? (0, $33619877a15996ac$export$9cd59f9826255e47)(source._values) : undefined;
            matrix._index = (0, $33619877a15996ac$export$9cd59f9826255e47)(source._index);
            matrix._ptr = (0, $33619877a15996ac$export$9cd59f9826255e47)(source._ptr);
            matrix._size = (0, $33619877a15996ac$export$9cd59f9826255e47)(source._size);
            matrix._datatype = datatype || source._datatype;
        } else // build from matrix data
        _createFromArray(matrix, source.valueOf(), datatype || source._datatype);
    }
    function _createFromArray(matrix, data, datatype) {
        // initialize fields
        matrix._values = [];
        matrix._index = [];
        matrix._ptr = [];
        matrix._datatype = datatype; // discover rows & columns, do not use math.size() to avoid looping array twice
        var rows = data.length;
        var columns = 0; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $2c4f948f17aa2240$export$844ec244b1367d54)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        } // check we have rows (empty array)
        if (rows > 0) {
            // column index
            var j = 0;
            do {
                // store pointer to values index
                matrix._ptr.push(matrix._index.length); // loop rows
                for(var i = 0; i < rows; i++){
                    // current row
                    var row = data[i]; // check row is an array
                    if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(row)) {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < row.length) columns = row.length;
                         // check row has column
                        if (j < row.length) {
                            // value
                            var v = row[j]; // check value != 0
                            if (!eq(v, zero)) {
                                // store value
                                matrix._values.push(v); // index
                                matrix._index.push(i);
                            }
                        }
                    } else {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < 1) columns = 1;
                         // check value != 0 (row is a scalar)
                        if (!eq(row, zero)) {
                            // store value
                            matrix._values.push(row); // index
                            matrix._index.push(i);
                        }
                    }
                } // increment index
                j++;
            }while (j < columns);
        } // store number of values in ptr
        matrix._ptr.push(matrix._index.length); // size
        matrix._size = [
            rows,
            columns
        ];
    }
    SparseMatrix.prototype = new Matrix();
    /**
   * Create a new SparseMatrix
   */ SparseMatrix.prototype.createSparseMatrix = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ SparseMatrix.prototype.type = "SparseMatrix";
    SparseMatrix.prototype.isSparseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf SparseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ SparseMatrix.prototype.getDataType = function() {
        return (0, $802b18b8c920d4c6$export$d31e00bf4359ea8b)(this._values, (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @memberof SparseMatrix
   * @return {string}           The storage format.
   */ SparseMatrix.prototype.storage = function() {
        return "sparse";
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @memberof SparseMatrix
   * @return {string}           The datatype.
   */ SparseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new SparseMatrix
   * @memberof SparseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ SparseMatrix.prototype.create = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Get the matrix density.
   *
   * Usage:
   *     const density = matrix.density()                   // retrieve matrix density
   *
   * @memberof SparseMatrix
   * @return {number}           The matrix density.
   */ SparseMatrix.prototype.density = function() {
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // calculate density
        return rows !== 0 && columns !== 0 ? this._index.length / (rows * columns) : 0;
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof SparseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ SparseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke subset on a Pattern only matrix");
         // check arguments
        switch(arguments.length){
            case 1:
                return _getsubset(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _setsubset(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    function _getsubset(matrix, idx) {
        // check idx
        if (!(0, $2c4f948f17aa2240$export$ba3dc792055c2f45)(idx)) throw new TypeError("Invalid index");
        var isScalar = idx.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(idx.min());
         // validate dimensions
        var size = idx.size();
        if (size.length !== matrix._size.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(size.length, matrix._size.length);
         // vars
        var i, ii, k, kk; // validate if any of the ranges in the index is out of range
        var min = idx.min();
        var max = idx.max();
        for(i = 0, ii = matrix._size.length; i < ii; i++){
            (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(min[i], matrix._size[i]);
            (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(max[i], matrix._size[i]);
        } // matrix arrays
        var mvalues = matrix._values;
        var mindex = matrix._index;
        var mptr = matrix._ptr; // rows & columns dimensions for result matrix
        var rows = idx.dimension(0);
        var columns = idx.dimension(1); // workspace & permutation vector
        var w = [];
        var pv = []; // loop rows in resulting matrix
        rows.forEach(function(i, r) {
            // update permutation vector
            pv[i] = r[0]; // mark i in workspace
            w[i] = true;
        }); // result matrix arrays
        var values = mvalues ? [] : undefined;
        var index = [];
        var ptr = []; // loop columns in result matrix
        columns.forEach(function(j) {
            // update ptr
            ptr.push(index.length); // loop values in column j
            for(k = mptr[j], kk = mptr[j + 1]; k < kk; k++){
                // row
                i = mindex[k]; // check row is in result matrix
                if (w[i] === true) {
                    // push index
                    index.push(pv[i]); // check we need to process values
                    if (values) values.push(mvalues[k]);
                }
            }
        }); // update ptr
        ptr.push(index.length); // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: size,
            datatype: matrix._datatype
        });
    }
    function _setsubset(matrix, index, submatrix, defaultValue) {
        // check index
        if (!index || index.isIndex !== true) throw new TypeError("Invalid index");
         // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(submatrix)) {
            // submatrix size
            sSize = submatrix.size(); // use array representation
            submatrix = submatrix.toArray();
        } else // get submatrix size (array, scalar)
        sSize = (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(submatrix);
         // check index is a scalar
        if (isScalar) {
            // verify submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError("Scalar expected");
             // set value
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // validate dimensions, index size must be one or two dimensions
            if (iSize.length !== 1 && iSize.length !== 2) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(iSize.length, matrix._size.length, "<");
             // check submatrix and index have the same dimensions
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                } // unsqueeze both outer and inner dimensions
                submatrix = (0, $802b18b8c920d4c6$export$5a07c5202d40a604)(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size
            if (!(0, $33619877a15996ac$export$6cc798251952180)(iSize, sSize)) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(iSize, sSize, ">");
             // insert the sub matrix
            if (iSize.length === 1) {
                // if the replacement index only has 1 dimension, go trough each one and set its value
                var range = index.dimension(0);
                range.forEach(function(dataIndex, subIndex) {
                    (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(dataIndex);
                    matrix.set([
                        dataIndex,
                        0
                    ], submatrix[subIndex[0]], defaultValue);
                });
            } else {
                // if the replacement index has 2 dimensions, go through each one and set the value in the correct index
                var firstDimensionRange = index.dimension(0);
                var secondDimensionRange = index.dimension(1);
                firstDimensionRange.forEach(function(firstDataIndex, firstSubIndex) {
                    (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(firstDataIndex);
                    secondDimensionRange.forEach(function(secondDataIndex, secondSubIndex) {
                        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(secondDataIndex);
                        matrix.set([
                            firstDataIndex,
                            secondDataIndex
                        ], submatrix[firstSubIndex[0]][secondSubIndex[0]], defaultValue);
                    });
                });
            }
        }
        return matrix;
    }
    /**
   * Get a single element from the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ SparseMatrix.prototype.get = function(index) {
        if (!(0, $2c4f948f17aa2240$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(index.length, this._size.length);
         // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke get on a Pattern only matrix");
         // row and column
        var i = index[0];
        var j = index[1]; // check i, j are valid
        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(i, this._size[0]);
        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(j, this._size[1]); // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) return this._values[k];
        return 0;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} v
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be set to zero.
   * @return {SparseMatrix} self
   */ SparseMatrix.prototype.set = function(index, v, defaultValue) {
        if (!(0, $2c4f948f17aa2240$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(index.length, this._size.length);
         // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke set on a Pattern only matrix");
         // row and column
        var i = index[0];
        var j = index[1]; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $2c4f948f17aa2240$export$844ec244b1367d54)(this._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                this._datatype,
                this._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, this._datatype);
        } // check we need to resize matrix
        if (i > rows - 1 || j > columns - 1) {
            // resize matrix
            _resize(this, Math.max(i + 1, rows), Math.max(j + 1, columns), defaultValue); // update rows & columns
            rows = this._size[0];
            columns = this._size[1];
        } // check i, j are valid
        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(i, rows);
        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(j, columns); // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) {
            // check value != 0
            if (!eq(v, zero)) // update value
            this._values[k] = v;
            else // remove value from matrix
            _remove(k, j, this._values, this._index, this._ptr);
        } else // insert value @ (i, j)
        _insert(k, i, j, v, this._values, this._index, this._ptr);
        return this;
    };
    function _getValueIndex(i, top, bottom, index) {
        // check row is on the bottom side
        if (bottom - top === 0) return bottom;
         // loop rows [top, bottom[
        for(var r = top; r < bottom; r++){
            // check we found value index
            if (index[r] === i) return r;
        } // we did not find row
        return top;
    }
    function _remove(k, j, values, index, ptr) {
        // remove value @ k
        values.splice(k, 1);
        index.splice(k, 1); // update pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]--;
    }
    function _insert(k, i, j, v, values, index, ptr) {
        // insert value
        values.splice(k, 0, v); // update row for k
        index.splice(k, 0, i); // update column pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]++;
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof SparseMatrix
   * @param {number[] | Matrix} size  The new size the matrix should have.
   *                                  Since sparse matrices are always two-dimensional,
   *                                  size must be two numbers in either an array or a matrix
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ SparseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $2c4f948f17aa2240$export$cea7aa84e978eba5)(size)) throw new TypeError("Array or Matrix expected");
         // SparseMatrix input is always 2d, flatten this into 1d if it's indeed a vector
        var sizeArray = size.valueOf().map((value)=>{
            return Array.isArray(value) && value.length === 1 ? value[0] : value;
        });
        if (sizeArray.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // check sizes
        sizeArray.forEach(function(value) {
            if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(value) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(sizeArray) + ")");
        }); // matrix to resize
        var m = copy ? this.clone() : this; // resize matrix
        return _resize(m, sizeArray[0], sizeArray[1], defaultValue);
    };
    function _resize(matrix, rows, columns, defaultValue) {
        // value to insert at the time of growing matrix
        var value = defaultValue || 0; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $2c4f948f17aa2240$export$844ec244b1367d54)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype); // convert value to the same datatype
            value = typed.convert(value, matrix._datatype);
        } // should we insert the value?
        var ins = !eq(value, zero); // old columns and rows
        var r = matrix._size[0];
        var c = matrix._size[1];
        var i, j, k; // check we need to increase columns
        if (columns > c) {
            // loop new columns
            for(j = c; j < columns; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._values.length; // check we need to insert matrix._values
                if (ins) // loop rows
                for(i = 0; i < r; i++){
                    // add new matrix._values
                    matrix._values.push(value); // update matrix._index
                    matrix._index.push(i);
                }
            } // store number of matrix._values in matrix._ptr
            matrix._ptr[columns] = matrix._values.length;
        } else if (columns < c) {
            // truncate matrix._ptr
            matrix._ptr.splice(columns + 1, c - columns); // truncate matrix._values and matrix._index
            matrix._values.splice(matrix._ptr[columns], matrix._values.length);
            matrix._index.splice(matrix._ptr[columns], matrix._index.length);
        } // update columns
        c = columns; // check we need to increase rows
        if (rows > r) // check we have to insert values
        {
            if (ins) {
                // inserts
                var n = 0; // loop columns
                for(j = 0; j < c; j++){
                    // update matrix._ptr for current column
                    matrix._ptr[j] = matrix._ptr[j] + n; // where to insert matrix._values
                    k = matrix._ptr[j + 1] + n; // pointer
                    var p = 0; // loop new rows, initialize pointer
                    for(i = r; i < rows; i++, p++){
                        // add value
                        matrix._values.splice(k + p, 0, value); // update matrix._index
                        matrix._index.splice(k + p, 0, i); // increment inserts
                        n++;
                    }
                } // store number of matrix._values in matrix._ptr
                matrix._ptr[c] = matrix._values.length;
            }
        } else if (rows < r) {
            // deletes
            var d = 0; // loop columns
            for(j = 0; j < c; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._ptr[j] - d; // where matrix._values start for next column
                var k0 = matrix._ptr[j];
                var k1 = matrix._ptr[j + 1] - d; // loop matrix._index
                for(k = k0; k < k1; k++){
                    // row
                    i = matrix._index[k]; // check we need to delete value and matrix._index
                    if (i > rows - 1) {
                        // remove value
                        matrix._values.splice(k, 1); // remove item from matrix._index
                        matrix._index.splice(k, 1); // increase deletes
                        d++;
                    }
                }
            } // update matrix._ptr for current column
            matrix._ptr[j] = matrix._values.length;
        } // update matrix._size
        matrix._size[0] = rows;
        matrix._size[1] = columns; // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof SparseMatrix
   * @param {number[]} sizes          The new size the matrix should have.
   *                                  Since sparse matrices are always two-dimensional,
   *                                  size must be two numbers in either an array or a matrix
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ SparseMatrix.prototype.reshape = function(sizes, copy) {
        // validate arguments
        if (!(0, $2c4f948f17aa2240$export$43bee75e5e14138e)(sizes)) throw new TypeError("Array expected");
        if (sizes.length !== 2) throw new Error("Sparse matrices can only be reshaped in two dimensions");
         // check sizes
        sizes.forEach(function(value) {
            if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(value) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(value) || value <= -2 || value === 0) throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(sizes) + ")");
        });
        var currentLength = this._size[0] * this._size[1];
        sizes = (0, $802b18b8c920d4c6$export$d0efc868ac2c6822)(sizes, currentLength);
        var newLength = sizes[0] * sizes[1]; // m * n must not change
        if (currentLength !== newLength) throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
         // matrix to reshape
        var m = copy ? this.clone() : this; // return unchanged if the same shape
        if (this._size[0] === sizes[0] && this._size[1] === sizes[1]) return m;
         // Convert to COO format (generate a column index)
        var colIndex = [];
        for(var i = 0; i < m._ptr.length; i++)for(var j = 0; j < m._ptr[i + 1] - m._ptr[i]; j++)colIndex.push(i);
         // Clone the values array
        var values = m._values.slice(); // Clone the row index array
        var rowIndex = m._index.slice(); // Transform the (row, column) indices
        for(var _i = 0; _i < m._index.length; _i++){
            var r1 = rowIndex[_i];
            var c1 = colIndex[_i];
            var flat = r1 * m._size[1] + c1;
            colIndex[_i] = flat % sizes[1];
            rowIndex[_i] = Math.floor(flat / sizes[1]);
        } // Now reshaping is supposed to preserve the row-major order, BUT these sparse matrices are stored
        // in column-major order, so we have to reorder the value array now. One option is to use a multisort,
        // sorting several arrays based on some other array.
        // OR, we could easily just:
        // 1. Remove all values from the matrix
        m._values.length = 0;
        m._index.length = 0;
        m._ptr.length = sizes[1] + 1;
        m._size = sizes.slice();
        for(var _i2 = 0; _i2 < m._ptr.length; _i2++)m._ptr[_i2] = 0;
         // 2. Re-insert all elements in the proper order (simplified code from SparseMatrix.prototype.set)
        // This step is probably the most time-consuming
        for(var h = 0; h < values.length; h++){
            var _i3 = rowIndex[h];
            var _j = colIndex[h];
            var v = values[h];
            var k = _getValueIndex(_i3, m._ptr[_j], m._ptr[_j + 1], m._index);
            _insert(k, _i3, _j, v, m._values, m._index, m._ptr);
        } // The value indices are inserted out of order, but apparently that's... still OK?
        return m;
    };
    /**
   * Create a clone of the matrix
   * @memberof SparseMatrix
   * @return {SparseMatrix} clone
   */ SparseMatrix.prototype.clone = function() {
        var m = new SparseMatrix({
            values: this._values ? (0, $33619877a15996ac$export$9cd59f9826255e47)(this._values) : undefined,
            index: (0, $33619877a15996ac$export$9cd59f9826255e47)(this._index),
            ptr: (0, $33619877a15996ac$export$9cd59f9826255e47)(this._ptr),
            size: (0, $33619877a15996ac$export$9cd59f9826255e47)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof SparseMatrix
   * @returns {number[]} size
   */ SparseMatrix.prototype.size = function() {
        return this._size.slice(0); // copy the Array
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {SparseMatrix} matrix
   */ SparseMatrix.prototype.map = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke map on a Pattern only matrix");
         // matrix instance
        var me = this; // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // invoke callback
        var invoke = function invoke(v, i, j) {
            // invoke callback
            return callback(v, [
                i,
                j
            ], me);
        }; // invoke _map
        return _map(this, 0, rows - 1, 0, columns - 1, invoke, skipZeros);
    };
    /**
   * Create a new matrix with the results of the callback function executed on the interval
   * [minRow..maxRow, minColumn..maxColumn].
   */ function _map(matrix, minRow, maxRow, minColumn, maxColumn, callback, skipZeros) {
        // result arrays
        var values = [];
        var index = [];
        var ptr = []; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $2c4f948f17aa2240$export$844ec244b1367d54)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype);
        } // invoke callback
        var invoke = function invoke(v, x, y) {
            // invoke callback
            v = callback(v, x, y); // check value != 0
            if (!eq(v, zero)) {
                // store value
                values.push(v); // index
                index.push(x);
            }
        }; // loop columns
        for(var j = minColumn; j <= maxColumn; j++){
            // store pointer to values index
            ptr.push(values.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = matrix._ptr[j];
            var k1 = matrix._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = matrix._index[k]; // check i is in range
                if (i >= minRow && i <= maxRow) // value @ k
                invoke(matrix._values[k], i - minRow, j - minColumn);
            }
            else {
                // create a cache holding all defined values
                var _values = {};
                for(var _k = k0; _k < k1; _k++){
                    var _i4 = matrix._index[_k];
                    _values[_i4] = matrix._values[_k];
                } // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i5 = minRow; _i5 <= maxRow; _i5++){
                    var value = _i5 in _values ? _values[_i5] : 0;
                    invoke(value, _i5 - minRow, j - minColumn);
                }
            }
        } // store number of values in ptr
        ptr.push(values.length); // return sparse matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                maxRow - minRow + 1,
                maxColumn - minColumn + 1
            ]
        });
    }
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *                              If false, the indices are guaranteed to be in order,
   *                              if true, the indices can be unordered.
   */ SparseMatrix.prototype.forEach = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke forEach on a Pattern only matrix");
         // matrix instance
        var me = this; // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k]; // value @ k
                callback(this._values[k], [
                    i,
                    j
                ], me);
            }
            else {
                // create a cache holding all defined values
                var values = {};
                for(var _k2 = k0; _k2 < k1; _k2++){
                    var _i6 = this._index[_k2];
                    values[_i6] = this._values[_k2];
                } // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i7 = 0; _i7 < rows; _i7++){
                    var value = _i7 in values ? values[_i7] : 0;
                    callback(value, [
                        _i7,
                        j
                    ], me);
                }
            }
        }
    };
    /**
   * Iterate over the matrix elements, skipping zeros
   * @return {Iterable<{ value, index: number[] }>}
   */ SparseMatrix.prototype[Symbol.iterator] = function*() {
        if (!this._values) throw new Error("Cannot iterate a Pattern only matrix");
        var columns = this._size[1];
        for(var j = 0; j < columns; j++){
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k];
                yield {
                    value: this._values[k],
                    index: [
                        i,
                        j
                    ]
                };
            }
        }
    };
    /**
   * Create an Array with a copy of the data of the SparseMatrix
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.toArray = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, true);
    };
    /**
   * Get the primitive value of the SparseMatrix: a two dimensions array
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.valueOf = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, false);
    };
    function _toArray(values, index, ptr, size, copy) {
        // rows and columns
        var rows = size[0];
        var columns = size[1]; // result
        var a = []; // vars
        var i, j; // initialize array
        for(i = 0; i < rows; i++){
            a[i] = [];
            for(j = 0; j < columns; j++)a[i][j] = 0;
        } // loop columns
        for(j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                i = index[k]; // set value (use one for pattern matrix)
                a[i][j] = values ? copy ? (0, $33619877a15996ac$export$9cd59f9826255e47)(values[k]) : values[k] : 1;
            }
        }
        return a;
    }
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof SparseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ SparseMatrix.prototype.format = function(options) {
        // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // density
        var density = this.density(); // rows & columns
        var str = "Sparse Matrix [" + (0, $addf7cb66573d3e4$export$d9468344d3651243)(rows, options) + " x " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(columns, options) + "] density: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(density, options) + "\n"; // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k]; // append value
                str += "\n    (" + (0, $addf7cb66573d3e4$export$d9468344d3651243)(i, options) + ", " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(j, options) + ") ==> " + (this._values ? (0, $addf7cb66573d3e4$export$d9468344d3651243)(this._values[k], options) : "X");
            }
        }
        return str;
    };
    /**
   * Get a string representation of the matrix
   * @memberof SparseMatrix
   * @returns {string} str
   */ SparseMatrix.prototype.toString = function() {
        return (0, $addf7cb66573d3e4$export$d9468344d3651243)(this.toArray());
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof SparseMatrix
   * @returns {Object}
   */ SparseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "SparseMatrix",
            values: this._values,
            index: this._index,
            ptr: this._ptr,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof SparseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix vector with the diagonal values.
   */ SparseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(k) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper); // diagonal arrays
        var values = [];
        var index = [];
        var ptr = []; // initial ptr value
        ptr[0] = 0; // loop columns
        for(var j = kSuper; j < columns && values.length < n; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop x within [k0, k1[
            for(var x = k0; x < k1; x++){
                // row index
                var i = this._index[x]; // check row
                if (i === j - kSuper + kSub) {
                    // value on this column
                    values.push(this._values[x]); // store row
                    index[values.length - 1] = i - kSub; // exit loop
                    break;
                }
            }
        } // close ptr
        ptr.push(values.length); // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                n,
                1
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof SparseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SparseMatrix", "values": [], "index": [], "ptr": [], "size": []}`,
   *                       where mathjs is optional
   * @returns {SparseMatrix}
   */ SparseMatrix.fromJSON = function(json) {
        return new SparseMatrix(json);
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof SparseMatrix
   * @param {Array} size                       The matrix size.
   * @param {number | Array | Matrix } value   The values for the diagonal.
   * @param {number | BigNumber} [k=0]         The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]            The default value for non-diagonal
   * @param {string} [datatype]                The Matrix datatype, values must be of this datatype.
   *
   * @returns {SparseMatrix}
   */ SparseMatrix.diagonal = function(size, value, k, defaultValue, datatype) {
        if (!(0, $2c4f948f17aa2240$export$43bee75e5e14138e)(size)) throw new TypeError("Array expected, size parameter");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(s)) // convert it
            s = s.toNumber();
             // validate arguments
            if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(s) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(s) || s < 1) throw new Error("Size values must be positive integers");
            return s;
        }); // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(k) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
         // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $2c4f948f17aa2240$export$844ec244b1367d54)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        }
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows and columns
        var rows = size[0];
        var columns = size[1]; // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper); // value extraction function
        var _value; // check value
        if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error("Invalid value array length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(value)) {
            // matrix size
            var ms = value.size(); // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error("Invalid matrix length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
         // create arrays
        var values = [];
        var index = [];
        var ptr = []; // loop items
        for(var j = 0; j < columns; j++){
            // number of rows with value
            ptr.push(values.length); // diagonal index
            var i = j - kSuper; // check we need to set diagonal value
            if (i >= 0 && i < n) {
                // get value @ i
                var v = _value(i); // check for zero
                if (!eq(v, zero)) {
                    // column
                    index.push(i + kSub); // add value
                    values.push(v);
                }
            }
        } // last value should be number of values
        ptr.push(values.length); // create SparseMatrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof SparseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ SparseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(i) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(i) || !(0, $2c4f948f17aa2240$export$7e4aa119212bc614)(j) || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(j)) throw new Error("Row index must be positive integers");
         // check dimensions
        if (this._size.length !== 2) throw new Error("Only two dimensional matrix is supported");
         // validate index
        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(i, this._size[0]);
        (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(j, this._size[0]); // swap rows
        SparseMatrix._swapRows(i, j, this._size[1], this._values, this._index, this._ptr); // return current instance
        return this;
    };
    /**
   * Loop rows with data in column j.
   *
   * @param {number} j            Column
   * @param {Array} values        Matrix values
   * @param {Array} index         Matrix row indeces
   * @param {Array} ptr           Matrix column pointers
   * @param {Function} callback   Callback function invoked for every row in column j
   */ SparseMatrix._forEachRow = function(j, values, index, ptr, callback) {
        // indeces for column j
        var k0 = ptr[j];
        var k1 = ptr[j + 1]; // loop
        for(var k = k0; k < k1; k++)// invoke callback
        callback(index[k], values[k]);
    };
    /**
   * Swap rows x and y in Sparse Matrix data structures.
   *
   * @param {number} x         Matrix row index 1
   * @param {number} y         Matrix row index 2
   * @param {number} columns   Number of columns in matrix
   * @param {Array} values     Matrix values
   * @param {Array} index      Matrix row indeces
   * @param {Array} ptr        Matrix column pointers
   */ SparseMatrix._swapRows = function(x, y, columns, values, index, ptr) {
        // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // find value index @ x
            var kx = _getValueIndex(x, k0, k1, index); // find value index @ x
            var ky = _getValueIndex(y, k0, k1, index); // check both rows exist in matrix
            if (kx < k1 && ky < k1 && index[kx] === x && index[ky] === y) {
                // swap values (check for pattern matrix)
                if (values) {
                    var v = values[kx];
                    values[kx] = values[ky];
                    values[ky] = v;
                } // next column
                continue;
            } // check x row exist & no y row
            if (kx < k1 && index[kx] === x && (ky >= k1 || index[ky] !== y)) {
                // value @ x (check for pattern matrix)
                var vx = values ? values[kx] : undefined; // insert value @ y
                index.splice(ky, 0, y);
                if (values) values.splice(ky, 0, vx);
                 // remove value @ x (adjust array index if needed)
                index.splice(ky <= kx ? kx + 1 : kx, 1);
                if (values) values.splice(ky <= kx ? kx + 1 : kx, 1);
                 // next column
                continue;
            } // check y row exist & no x row
            if (ky < k1 && index[ky] === y && (kx >= k1 || index[kx] !== x)) {
                // value @ y (check for pattern matrix)
                var vy = values ? values[ky] : undefined; // insert value @ x
                index.splice(kx, 0, x);
                if (values) values.splice(kx, 0, vy);
                 // remove value @ y (adjust array index if needed)
                index.splice(kx <= ky ? ky + 1 : ky, 1);
                if (values) values.splice(kx <= ky ? ky + 1 : ky, 1);
            }
        }
    };
    return SparseMatrix;
}, {
    isClass: true
});


var $f2c98b92b1d9d107$var$name = "splitUnit";
var $f2c98b92b1d9d107$var$dependencies = [
    "typed"
];
var $f2c98b92b1d9d107$export$a9f61753ee14ea96 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($f2c98b92b1d9d107$var$name, $f2c98b92b1d9d107$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Split a unit in an array of units whose sum is equal to the original unit.
   *
   * Syntax:
   *
   *     splitUnit(unit: Unit, parts: Array.<Unit>)
   *
   * Example:
   *
   *     math.splitUnit(new Unit(1, 'm'), ['feet', 'inch'])
   *     // [ 3 feet, 3.3700787401575 inch ]
   *
   * See also:
   *
   *     unit
   *
   * @param {Array} [parts] An array of strings or valueless units.
   * @return {Array} An array of units.
   */ return typed($f2c98b92b1d9d107$var$name, {
        "Unit, Array": function UnitArray(unit, parts) {
            return unit.splitUnit(parts);
        }
    });
});



var $c1c695cc0f242d01$var$name = "sqrt";
var $c1c695cc0f242d01$var$dependencies = [
    "config",
    "typed",
    "Complex"
];
var $c1c695cc0f242d01$export$eb18ce1988c5f19c = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c1c695cc0f242d01$var$name, $c1c695cc0f242d01$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, Complex: Complex } = _ref;
    /**
   * Calculate the square root of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sqrt(x)
   *
   * Examples:
   *
   *    math.sqrt(25)                // returns 5
   *    math.square(5)               // returns 25
   *    math.sqrt(-4)                // returns Complex 2i
   *
   * See also:
   *
   *    square, multiply, cube, cbrt, sqrtm
   *
   * @param {number | BigNumber | Complex | Array | Matrix | Unit} x
   *            Value for which to calculate the square root.
   * @return {number | BigNumber | Complex | Array | Matrix | Unit}
   *            Returns the square root of `x`
   */ return typed("sqrt", {
        number: _sqrtNumber,
        Complex: function Complex(x) {
            return x.sqrt();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.sqrt();
            else // negative value -> downgrade to number to do complex value computation
            return _sqrtNumber(x.toNumber());
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sqrt(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        },
        Unit: function Unit(x) {
            // Someday will work for complex units when they are implemented
            return x.pow(0.5);
        }
    });
    /**
   * Calculate sqrt for a number
   * @param {number} x
   * @returns {number | Complex} Returns the square root of x
   * @private
   */ function _sqrtNumber(x) {
        if (isNaN(x)) return NaN;
        else if (x >= 0 || config.predictable) return Math.sqrt(x);
        else return new Complex(x, 0).sqrt();
    }
});





var $02b4e496a8575f9f$var$name = "sqrtm";
var $02b4e496a8575f9f$var$dependencies = [
    "typed",
    "abs",
    "add",
    "multiply",
    "sqrt",
    "subtract",
    "inv",
    "size",
    "max",
    "identity"
];
var $02b4e496a8575f9f$export$71d0f952576e7511 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($02b4e496a8575f9f$var$name, $02b4e496a8575f9f$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, multiply: multiply, sqrt: sqrt, subtract: subtract, inv: inv, size: size, max: max, identity: identity } = _ref;
    var _maxIterations = 1e3;
    var _tolerance = 1e-6;
    /**
   * Calculate the principal square root matrix using the Denman–Beavers iterative method
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix#By_Denman–Beavers_iteration
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   * @private
   */ function _denmanBeavers(A) {
        var error;
        var iterations = 0;
        var Y = A;
        var Z = identity(size(A));
        do {
            var Yk = Y;
            Y = multiply(0.5, add(Yk, inv(Z)));
            Z = multiply(0.5, add(Z, inv(Yk)));
            error = max(abs(subtract(Y, Yk)));
            if (error > _tolerance && ++iterations > _maxIterations) throw new Error("computing square root of matrix: iterative method could not converge");
        }while (error > _tolerance);
        return Y;
    }
    /**
   * Calculate the principal square root of a square matrix.
   * The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix
   *
   * Syntax:
   *
   *     X = math.sqrtm(A)
   *
   * Examples:
   *
   *     math.sqrtm([[1, 2], [3, 4]]) // returns [[-2, 1], [1.5, -0.5]]
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   */ return typed($02b4e496a8575f9f$var$name, {
        "Array | Matrix": function ArrayMatrix(A) {
            var size = (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(A) ? A.size() : (0, $802b18b8c920d4c6$export$51ffaee4afb683a5)(A);
            switch(size.length){
                case 1:
                    // Single element Array | Matrix
                    if (size[0] === 1) return sqrt(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
                case 2:
                    // Two-dimensional Array | Matrix
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _denmanBeavers(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
                default:
                    // Multi dimensional array
                    throw new RangeError("Matrix must be at most two dimensional (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
            }
        }
    });
});




var $5a0a22f6aac9de8e$var$name = "square";
var $5a0a22f6aac9de8e$var$dependencies = [
    "typed"
];
var $5a0a22f6aac9de8e$export$4ba960a63f731b0b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($5a0a22f6aac9de8e$var$name, $5a0a22f6aac9de8e$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the square of a value, `x * x`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.square(x)
   *
   * Examples:
   *
   *    math.square(2)           // returns number 4
   *    math.square(3)           // returns number 9
   *    math.pow(3, 2)           // returns number 9
   *    math.multiply(3, 3)      // returns number 9
   *
   *    math.square([1, 2, 3, 4])  // returns Array [1, 4, 9, 16]
   *
   * See also:
   *
   *    multiply, cube, sqrt, pow
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            Number for which to calculate the square
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
   *            Squared value
   */ return typed($5a0a22f6aac9de8e$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$c4094a156ed9ab35),
        Complex: function Complex(x) {
            return x.mul(x);
        },
        BigNumber: function BigNumber(x) {
            return x.times(x);
        },
        Fraction: function Fraction(x) {
            return x.mul(x);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since square(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        },
        Unit: function Unit(x) {
            return x.pow(2);
        }
    });
});




var $8075455fb6180966$var$name = "squeeze";
var $8075455fb6180966$var$dependencies = [
    "typed",
    "matrix"
];
var $8075455fb6180966$export$1a885844ffd505a4 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8075455fb6180966$var$name, $8075455fb6180966$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Squeeze a matrix, remove inner and outer singleton dimensions from a matrix.
   *
   * Syntax:
   *
   *     math.squeeze(x)
   *
   * Examples:
   *
   *     math.squeeze([3])           // returns 3
   *     math.squeeze([[3]])         // returns 3
   *
   *     const A = math.zeros(3, 1)    // returns [[0], [0], [0]] (size 3x1)
   *     math.squeeze(A)             // returns [0, 0, 0] (size 3)
   *
   *     const B = math.zeros(1, 3)    // returns [[0, 0, 0]] (size 1x3)
   *     math.squeeze(B)             // returns [0, 0, 0] (size 3)
   *
   *     // only inner and outer dimensions are removed
   *     const C = math.zeros(2, 1, 3) // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *     math.squeeze(C)             // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *
   * See also:
   *
   *     subset
   *
   * @param {Matrix | Array} x      Matrix to be squeezed
   * @return {Matrix | Array} Squeezed matrix
   */ return typed($8075455fb6180966$var$name, {
        Array: function Array1(x) {
            return (0, $802b18b8c920d4c6$export$889c931173b77c2f)((0, $33619877a15996ac$export$9cd59f9826255e47)(x));
        },
        Matrix: function Matrix(x) {
            var res = (0, $802b18b8c920d4c6$export$889c931173b77c2f)(x.toArray()); // FIXME: return the same type of matrix as the input
            return Array.isArray(res) ? matrix(res) : res;
        },
        any: function any(x) {
            // scalar
            return (0, $33619877a15996ac$export$9cd59f9826255e47)(x);
        }
    });
});


var $33589fdb3f464f29$var$name = "std";
var $33589fdb3f464f29$var$dependencies = [
    "typed",
    "sqrt",
    "variance"
];
var $33589fdb3f464f29$export$d3f0a8dda5df7afd = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($33589fdb3f464f29$var$name, $33589fdb3f464f29$var$dependencies, (_ref)=>{
    var { typed: typed, sqrt: sqrt, variance: variance } = _ref;
    /**
   * Compute the standard deviation of a matrix or a  list with values.
   * The standard deviations is defined as the square root of the variance:
   * `std(A) = sqrt(variance(A))`.
   * In case of a (multi dimensional) array or matrix, the standard deviation
   * over all elements will be calculated by default, unless an axis is specified
   * in which case the standard deviation will be computed along that axis.
   *
   * Additionally, it is possible to compute the standard deviation along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Syntax:
   *
   *     math.std(a, b, c, ...)
   *     math.std(A)
   *     math.std(A, normalization)
   *     math.std(A, dimension)
   *     math.std(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.std(2, 4, 6)                     // returns 2
   *     math.std([2, 4, 6, 8])                // returns 2.581988897471611
   *     math.std([2, 4, 6, 8], 'uncorrected') // returns 2.23606797749979
   *     math.std([2, 4, 6, 8], 'biased')      // returns 2
   *
   *     math.std([[1, 2, 3], [4, 5, 6]])      // returns 1.8708286933869707
   *     math.std([[1, 2, 3], [4, 6, 8]], 0)    // returns [2.1213203435596424, 2.8284271247461903, 3.5355339059327378]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1)    // returns [1, 2]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.7071067811865476, 1.4142135623730951]
   *
   * See also:
   *
   *    mean, median, max, min, prod, sum, variance
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the standard deviation for a matrix
   * @return {*} The standard deviation
   */ return typed($33589fdb3f464f29$var$name, {
        // std([a, b, c, d, ...])
        "Array | Matrix": _std,
        // std([a, b, c, d, ...], normalization)
        "Array | Matrix, string": _std,
        // std([a, b, c, c, ...], dim)
        "Array | Matrix, number | BigNumber": _std,
        // std([a, b, c, c, ...], dim, normalization)
        "Array | Matrix, number | BigNumber, string": _std,
        // std(a, b, c, d, ...)
        "...": function _(args) {
            return _std(args);
        }
    });
    function _std(array, normalization) {
        if (array.length === 0) throw new SyntaxError("Function std requires one or more parameters (0 provided)");
        try {
            return sqrt(variance.apply(null, arguments));
        } catch (err) {
            if (err instanceof TypeError && err.message.indexOf(" variance") !== -1) throw new TypeError(err.message.replace(" variance", " std"));
            else throw err;
        }
    }
});



var $7a5bf86ddba77b1a$var$name = "stirlingS2";
var $7a5bf86ddba77b1a$var$dependencies = [
    "typed",
    "addScalar",
    "subtract",
    "multiplyScalar",
    "divideScalar",
    "pow",
    "factorial",
    "combinations",
    "isNegative",
    "isInteger",
    "number",
    "?bignumber",
    "larger"
];
var $7a5bf86ddba77b1a$export$18813d136a9b83d0 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($7a5bf86ddba77b1a$var$name, $7a5bf86ddba77b1a$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, subtract: subtract, multiplyScalar: multiplyScalar, divideScalar: divideScalar, pow: pow, factorial: factorial, combinations: combinations, isNegative: isNegative, isInteger: isInteger, number: number, bignumber: bignumber, larger: larger } = _ref;
    var smallCache = [];
    var bigCache = [];
    /**
   * The Stirling numbers of the second kind, counts the number of ways to partition
   * a set of n labelled objects into k nonempty unlabelled subsets.
   * stirlingS2 only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   *  If n = k or k = 1 <= n, then s(n,k) = 1
   *  If k = 0 < n, then s(n,k) = 0
   *
   * Note that if either n or k is supplied as a BigNumber, the result will be
   * as well.
   *
   * Syntax:
   *
   *   math.stirlingS2(n, k)
   *
   * Examples:
   *
   *    math.stirlingS2(5, 3) //returns 25
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     S(n,k)
   */ return typed($7a5bf86ddba77b1a$var$name, {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || isNegative(n) || !isInteger(k) || isNegative(k)) throw new TypeError("Non-negative integer value expected in function stirlingS2");
            else if (larger(k, n)) throw new TypeError("k must be less than or equal to n in function stirlingS2");
            var big = !((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(n) && (0, $2c4f948f17aa2240$export$7e4aa119212bc614)(k));
            var cache = big ? bigCache : smallCache;
            var make = big ? bignumber : number;
            var nn = number(n);
            var nk = number(k);
            /* See if we already have the value: */ if (cache[nn] && cache[nn].length > nk) return cache[nn][nk];
            /* Fill the cache */ for(var m = 0; m <= nn; ++m){
                if (!cache[m]) cache[m] = [
                    m === 0 ? make(1) : make(0)
                ];
                if (m === 0) continue;
                var row = cache[m];
                var prev = cache[m - 1];
                for(var i = row.length; i <= m && i <= nk; ++i)if (i === m) row[i] = 1;
                else row[i] = addScalar(multiplyScalar(make(i), prev[i]), prev[i - 1]);
            }
            return cache[nn][nk];
        }
    });
});




var $1555b5277cf2086a$var$name = "string";
var $1555b5277cf2086a$var$dependencies = [
    "typed"
];
var $1555b5277cf2086a$export$b2cf5914f5f18823 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1555b5277cf2086a$var$name, $1555b5277cf2086a$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a string or convert any object into a string.
   * Elements of Arrays and Matrices are processed element wise.
   *
   * Syntax:
   *
   *    math.string(value)
   *
   * Examples:
   *
   *    math.string(4.2)               // returns string '4.2'
   *    math.string(math.complex(3, 2) // returns string '3 + 2i'
   *
   *    const u = math.unit(5, 'km')
   *    math.string(u.to('m'))         // returns string '5000 m'
   *
   *    math.string([true, false])     // returns ['true', 'false']
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, unit
   *
   * @param {* | Array | Matrix | null} [value]  A value to convert to a string
   * @return {string | Array | Matrix} The created string
   */ return typed($1555b5277cf2086a$var$name, {
        "": function _() {
            return "";
        },
        number: (0, $a03283b133c3c55b$export$d9468344d3651243),
        null: function _null(x) {
            return "null";
        },
        boolean: function boolean(x) {
            return x + "";
        },
        string: function string(x) {
            return x;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        },
        any: function any(x) {
            return String(x);
        }
    });
});





/**
 * Get a property of a plain object
 * Throws an error in case the object is not a plain object or the
 * property is not defined on the object itself
 * @param {Object} object
 * @param {string} prop
 * @return {*} Returns the property value when safe
 */ function $49d1ac263f403507$export$87a87648a1961976(object, prop) {
    // only allow getting safe properties of a plain object
    if ($49d1ac263f403507$export$53b83ca8eaab0383(object) && $49d1ac263f403507$export$3039c640f3cfc12a(object, prop)) return object[prop];
    if (typeof object[prop] === "function" && $49d1ac263f403507$export$2220a91638ab1d9e(object, prop)) throw new Error('Cannot access method "' + prop + '" as a property');
    throw new Error('No access to property "' + prop + '"');
}
/**
 * Set a property on a plain object.
 * Throws an error in case the object is not a plain object or the
 * property would override an inherited property like .constructor or .toString
 * @param {Object} object
 * @param {string} prop
 * @param {*} value
 * @return {*} Returns the value
 */ // TODO: merge this function into access.js?
function $49d1ac263f403507$export$e99fe8700ee9f9cd(object, prop, value) {
    // only allow setting safe properties of a plain object
    if ($49d1ac263f403507$export$53b83ca8eaab0383(object) && $49d1ac263f403507$export$3039c640f3cfc12a(object, prop)) {
        object[prop] = value;
        return value;
    }
    throw new Error('No access to property "' + prop + '"');
}
function $49d1ac263f403507$export$97accea1a2314d22(object) {
    return Object.keys(object).filter((prop)=>(0, $33619877a15996ac$export$5a15a386532a5ea4)(object, prop));
}
function $49d1ac263f403507$export$626bde2ef1d9655a(object, prop) {
    return prop in object;
}
/**
 * Test whether a property is safe to use for an object.
 * For example .toString and .constructor are not safe
 * @param {string} prop
 * @return {boolean} Returns true when safe
 */ function $49d1ac263f403507$export$3039c640f3cfc12a(object, prop) {
    if (!object || typeof object !== "object") return false;
     // SAFE: whitelisted
    // e.g length
    if ((0, $33619877a15996ac$export$5a15a386532a5ea4)($49d1ac263f403507$var$safeNativeProperties, prop)) return true;
     // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (prop in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
     // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (prop in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
/**
 * Validate whether a method is safe.
 * Throws an error when that's not the case.
 * @param {Object} object
 * @param {string} method
 */ // TODO: merge this function into assign.js?
function $49d1ac263f403507$export$7cfb146d96805fec(object, method) {
    if (!$49d1ac263f403507$export$2220a91638ab1d9e(object, method)) throw new Error('No access to method "' + method + '"');
}
/**
 * Check whether a method is safe.
 * Throws an error when that's not the case (for example for `constructor`).
 * @param {Object} object
 * @param {string} method
 * @return {boolean} Returns true when safe, false otherwise
 */ function $49d1ac263f403507$export$2220a91638ab1d9e(object, method) {
    if (object === null || object === undefined || typeof object[method] !== "function") return false;
     // UNSAFE: ghosted
    // e.g overridden toString
    // Note that IE10 doesn't support __proto__ and we can't do this check there.
    if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(object, method) && Object.getPrototypeOf && method in Object.getPrototypeOf(object)) return false;
     // SAFE: whitelisted
    // e.g toString
    if ((0, $33619877a15996ac$export$5a15a386532a5ea4)($49d1ac263f403507$var$safeNativeMethods, method)) return true;
     // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (method in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
     // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (method in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
function $49d1ac263f403507$export$53b83ca8eaab0383(object) {
    return typeof object === "object" && object && object.constructor === Object;
}
var $49d1ac263f403507$var$safeNativeProperties = {
    length: true,
    name: true
};
var $49d1ac263f403507$var$safeNativeMethods = {
    toString: true,
    valueOf: true,
    toLocaleString: true
};




var $6bf0a697d4bb28ee$var$name = "subset";
var $6bf0a697d4bb28ee$var$dependencies = [
    "typed",
    "matrix"
];
var $6bf0a697d4bb28ee$export$d8c56e74d683bb33 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($6bf0a697d4bb28ee$var$name, $6bf0a697d4bb28ee$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Get or set a subset of a matrix or string.
   *
   * Syntax:
   *     math.subset(value, index)                                // retrieve a subset
   *     math.subset(value, index, replacement [, defaultValue])  // replace a subset
   *
   * Examples:
   *
   *     // get a subset
   *     const d = [[1, 2], [3, 4]]
   *     math.subset(d, math.index(1, 0))        // returns 3
   *     math.subset(d, math.index([0, 1], 1))   // returns [[2], [4]]
   *
   *     // replace a subset
   *     const e = []
   *     const f = math.subset(e, math.index(0, [0, 2]), [5, 6])  // f = [[5, 6]] and e = [[5, 0, 6]]
   *     const g = math.subset(f, math.index(1, 1), 7, 0)         // g = [[5, 6], [0, 7]]
   *
   *     // get submatrix using ranges
   *     const M = [
   *       [1,2,3],
   *       [4,5,6],
   *       [7,8,9]
   *     ]
   *     math.subset(M, math.index(math.range(0,2), math.range(0,3))) // [[1,2,3],[4,5,6]]
   *
   * See also:
   *
   *     size, resize, squeeze, index
   *
   * @param {Array | Matrix | string} matrix  An array, matrix, or string
   * @param {Index} index
   *    For each dimension of the target, specifies an index or a list of
   *    indices to fetch or set. `subset` uses the cartesian product of
   *    the indices specified in each dimension.
   * @param {*} [replacement]                 An array, matrix, or scalar.
   *                                          If provided, the subset is replaced with replacement.
   *                                          If not provided, the subset is returned
   * @param {*} [defaultValue=undefined]      Default value, filled in on new entries when
   *                                          the matrix is resized. If not provided,
   *                                          math.matrix elements will be left undefined.
   * @return {Array | Matrix | string} Either the retrieved subset or the updated matrix.
   */ return typed($6bf0a697d4bb28ee$var$name, {
        // get subset
        "Array, Index": function ArrayIndex(value, index) {
            var m = matrix(value);
            var subset = m.subset(index); // returns a Matrix
            return index.isScalar() ? subset : subset.valueOf(); // return an Array (like the input)
        },
        "Matrix, Index": function MatrixIndex(value, index) {
            return value.subset(index);
        },
        "Object, Index": $6bf0a697d4bb28ee$var$_getObjectProperty,
        "string, Index": $6bf0a697d4bb28ee$var$_getSubstring,
        // set subset
        "Array, Index, any": function ArrayIndexAny(value, index, replacement) {
            return matrix((0, $33619877a15996ac$export$9cd59f9826255e47)(value)).subset(index, replacement, undefined).valueOf();
        },
        "Array, Index, any, any": function ArrayIndexAnyAny(value, index, replacement, defaultValue) {
            return matrix((0, $33619877a15996ac$export$9cd59f9826255e47)(value)).subset(index, replacement, defaultValue).valueOf();
        },
        "Matrix, Index, any": function MatrixIndexAny(value, index, replacement) {
            return value.clone().subset(index, replacement);
        },
        "Matrix, Index, any, any": function MatrixIndexAnyAny(value, index, replacement, defaultValue) {
            return value.clone().subset(index, replacement, defaultValue);
        },
        "string, Index, string": $6bf0a697d4bb28ee$var$_setSubstring,
        "string, Index, string, string": $6bf0a697d4bb28ee$var$_setSubstring,
        "Object, Index, any": $6bf0a697d4bb28ee$var$_setObjectProperty
    });
});
/**
 * Retrieve a subset of a string
 * @param {string} str            string from which to get a substring
 * @param {Index} index           An index or list of indices (character positions)
 * @returns {string} substring
 * @private
 */ function $6bf0a697d4bb28ee$var$_getSubstring(str, index) {
    if (!(0, $2c4f948f17aa2240$export$ba3dc792055c2f45)(index)) // TODO: better error message
    throw new TypeError("Index expected");
    if (index.size().length !== 1) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(index.size().length, 1);
     // validate whether the range is out of range
    var strLen = str.length;
    (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(index.min()[0], strLen);
    (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(index.max()[0], strLen);
    var range = index.dimension(0);
    var substr = "";
    range.forEach(function(v) {
        substr += str.charAt(v);
    });
    return substr;
}
/**
 * Replace a substring in a string
 * @param {string} str            string to be replaced
 * @param {Index} index           An index or list of indices (character positions)
 * @param {string} replacement    Replacement string
 * @param {string} [defaultValue] Default value to be uses when resizing
 *                                the string. is ' ' by default
 * @returns {string} result
 * @private
 */ function $6bf0a697d4bb28ee$var$_setSubstring(str, index, replacement, defaultValue) {
    if (!index || index.isIndex !== true) // TODO: better error message
    throw new TypeError("Index expected");
    if (index.size().length !== 1) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(index.size().length, 1);
    if (defaultValue !== undefined) {
        if (typeof defaultValue !== "string" || defaultValue.length !== 1) throw new TypeError("Single character expected as defaultValue");
    } else defaultValue = " ";
    var range = index.dimension(0);
    var len = range.size()[0];
    if (len !== replacement.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(range.size()[0], replacement.length);
     // validate whether the range is out of range
    var strLen = str.length;
    (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(index.min()[0]);
    (0, $802b18b8c920d4c6$export$3cfe3fbfec03f260)(index.max()[0]); // copy the string into an array with characters
    var chars = [];
    for(var i = 0; i < strLen; i++)chars[i] = str.charAt(i);
    range.forEach(function(v, i) {
        chars[v] = replacement.charAt(i[0]);
    }); // initialize undefined characters with a space
    if (chars.length > strLen) {
        for(var _i = strLen - 1, _len = chars.length; _i < _len; _i++)if (!chars[_i]) chars[_i] = defaultValue;
    }
    return chars.join("");
}
/**
 * Retrieve a property from an object
 * @param {Object} object
 * @param {Index} index
 * @return {*} Returns the value of the property
 * @private
 */ function $6bf0a697d4bb28ee$var$_getObjectProperty(object, index) {
    if (index.size().length !== 1) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== "string") throw new TypeError("String expected as index to retrieve an object property");
    return (0, $49d1ac263f403507$export$87a87648a1961976)(object, key);
}
/**
 * Set a property on an object
 * @param {Object} object
 * @param {Index} index
 * @param {*} replacement
 * @return {*} Returns the updated object
 * @private
 */ function $6bf0a697d4bb28ee$var$_setObjectProperty(object, index, replacement) {
    if (index.size().length !== 1) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== "string") throw new TypeError("String expected as index to retrieve an object property");
     // clone the object, and apply the property to the clone
    var updated = (0, $33619877a15996ac$export$9cd59f9826255e47)(object);
    (0, $49d1ac263f403507$export$e99fe8700ee9f9cd)(updated, key, replacement);
    return updated;
}









var $61cfdedf377cd0ed$var$name = "subtract";
var $61cfdedf377cd0ed$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "addScalar",
    "unaryMinus",
    "DenseMatrix"
];
var $61cfdedf377cd0ed$export$cd7a6c131b18ab16 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($61cfdedf377cd0ed$var$name, $61cfdedf377cd0ed$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, addScalar: addScalar, unaryMinus: unaryMinus, DenseMatrix: DenseMatrix } = _ref;
    // TODO: split function subtract in two: subtract and subtractScalar
    var algorithm01 = (0, $3feaf9e0b000398a$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm05 = (0, $a7b97f0cac0b5286$export$f80c3080566d43b4)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $e9da21a7968d7093$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Subtract two values, `x - y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.subtract(x, y)
   *
   * Examples:
   *
   *    math.subtract(5.3, 2)        // returns number 3.3
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.subtract(a, b)          // returns Complex -2 + 2i
   *
   *    math.subtract([5, 7, 4], 4)  // returns Array [1, 3, 0]
   *
   *    const c = math.unit('2.1 km')
   *    const d = math.unit('500m')
   *    math.subtract(c, d)          // returns Unit 1.6 km
   *
   * See also:
   *
   *    add
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x
   *            Initial value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y
   *            Value to subtract from `x`
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Subtraction of `x` and `y`
   */ return typed($61cfdedf377cd0ed$var$name, {
        "number, number": function numberNumber(x, y) {
            return x - y;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.sub(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.minus(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.sub(y);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (x.value === null) throw new Error("Parameter x contains a unit with undefined value");
            if (y.value === null) throw new Error("Parameter y contains a unit with undefined value");
            if (!x.equalBase(y)) throw new Error("Units do not match");
            var res = x.clone();
            res.value = this(res.value, y.value);
            res.fixPrefix = false;
            return res;
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            $61cfdedf377cd0ed$var$checkEqualDimensions(x, y);
            return algorithm05(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            $61cfdedf377cd0ed$var$checkEqualDimensions(x, y);
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            $61cfdedf377cd0ed$var$checkEqualDimensions(x, y);
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            $61cfdedf377cd0ed$var$checkEqualDimensions(x, y);
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, unaryMinus(y), addScalar);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
/**
 * Check whether matrix x and y have the same number of dimensions.
 * Throws a DimensionError when dimensions are not equal
 * @param {Matrix} x
 * @param {Matrix} y
 */ function $61cfdedf377cd0ed$var$checkEqualDimensions(x, y) {
    var xsize = x.size();
    var ysize = y.size();
    if (xsize.length !== ysize.length) throw new (0, $99933e18a0d55444$export$ad1391ca020fdd96)(xsize.length, ysize.length);
}




var $583973e5c597423f$var$name = "sum";
var $583973e5c597423f$var$dependencies = [
    "typed",
    "config",
    "add",
    "numeric"
];
var $583973e5c597423f$export$14d444d810bc35b5 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($583973e5c597423f$var$name, $583973e5c597423f$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, add: add, numeric: numeric } = _ref;
    /**
   * Compute the sum of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.sum(a, b, c, ...)
   *     math.sum(A)
   *
   * Examples:
   *
   *     math.sum(2, 1, 4, 3)               // returns 10
   *     math.sum([2, 1, 4, 3])             // returns 10
   *     math.sum([[2, 5], [4, 3], [1, 7]]) // returns 22
   *
   * See also:
   *
   *    mean, median, min, max, prod, std, variance, cumsum
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The sum of all values
   */ return typed($583973e5c597423f$var$name, {
        // sum([a, b, c, d, ...])
        "Array | Matrix": _sum,
        // sum([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": _nsumDim,
        // sum(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $cd13353fc76500f7$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function sum");
            return _sum(args);
        }
    });
    /**
   * Recursively calculate the sum of an n-dimensional array
   * @param {Array | Matrix} array
   * @return {number} sum
   * @private
   */ function _sum(array) {
        var sum;
        (0, $cd13353fc76500f7$export$519ada94592b97fc)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
            } catch (err) {
                throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "sum", value);
            }
        }); // make sure returning numeric value: parse a string into a numeric value
        if (sum === undefined) sum = numeric(0, config.number);
        if (typeof sum === "string") sum = numeric(sum, config.number);
        return sum;
    }
    function _nsumDim(array, dim) {
        try {
            var sum = (0, $cd13353fc76500f7$export$533b26079ad0b4b)(array, dim, add);
            return sum;
        } catch (err) {
            throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "sum");
        }
    }
});



var $0cdb2c85df323367$var$name = "tan";
var $0cdb2c85df323367$var$dependencies = [
    "typed"
];
var $0cdb2c85df323367$export$b61ad4f38fd9301d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($0cdb2c85df323367$var$name, $0cdb2c85df323367$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the tangent of a value. `tan(x)` is equal to `sin(x) / cos(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.tan(x)
   *
   * Examples:
   *
   *    math.tan(0.5)                    // returns number 0.5463024898437905
   *    math.sin(0.5) / math.cos(0.5)    // returns number 0.5463024898437905
   *    math.tan(math.pi / 4)            // returns number 1
   *    math.tan(math.unit(45, 'deg'))   // returns number 1
   *
   * See also:
   *
   *    atan, sin, cos
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Tangent of x
   */ return typed($0cdb2c85df323367$var$name, {
        number: Math.tan,
        Complex: function Complex(x) {
            return x.tan();
        },
        BigNumber: function BigNumber(x) {
            return x.tan();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function tan is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since tan(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});




var $381e84b17f4f72ed$var$name = "tanh";
var $381e84b17f4f72ed$var$dependencies = [
    "typed"
];
var $381e84b17f4f72ed$export$e1f66a5bda779194 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($381e84b17f4f72ed$var$name, $381e84b17f4f72ed$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic tangent of a value,
   * defined as `tanh(x) = (exp(2 * x) - 1) / (exp(2 * x) + 1)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.tanh(x)
   *
   * Examples:
   *
   *    // tanh(x) = sinh(x) / cosh(x) = 1 / coth(x)
   *    math.tanh(0.5)                   // returns 0.46211715726000974
   *    math.sinh(0.5) / math.cosh(0.5)  // returns 0.46211715726000974
   *    1 / math.coth(0.5)               // returns 0.46211715726000974
   *
   * See also:
   *
   *    sinh, cosh, coth
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic tangent of x
   */ return typed("tanh", {
        number: (0, $a03283b133c3c55b$export$7128670e45beef9a),
        Complex: function Complex(x) {
            return x.tanh();
        },
        BigNumber: function BigNumber(x) {
            return x.tanh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function tanh is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since tanh(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});




var $00c2484649264bfd$var$name = "to";
var $00c2484649264bfd$var$dependencies = [
    "typed",
    "matrix"
];
var $00c2484649264bfd$export$6e6c19ceb4cd6856 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($00c2484649264bfd$var$name, $00c2484649264bfd$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Change the unit of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.to(x, unit)
   *
   * Examples:
   *
   *    math.to(math.unit('2 inch'), 'cm')                   // returns Unit 5.08 cm
   *    math.to(math.unit('2 inch'), math.unit(null, 'cm'))  // returns Unit 5.08 cm
   *    math.to(math.unit(16, 'bytes'), 'bits')              // returns Unit 128 bits
   *
   * See also:
   *
   *    unit
   *
   * @param {Unit | Array | Matrix} x     The unit to be converted.
   * @param {Unit | Array | Matrix} unit  New unit. Can be a string like "cm"
   *                                      or a unit without value.
   * @return {Unit | Array | Matrix} value with changed, fixed unit.
   */ return typed($00c2484649264bfd$var$name, {
        "Unit, Unit | string": function UnitUnitString(x, unit) {
            return x.to(unit);
        },
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            // SparseMatrix does not support Units
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "Matrix, any": function MatrixAny(x, y) {
            // SparseMatrix does not support Units
            return algorithm14(x, y, this, false);
        },
        "any, Matrix": function anyMatrix(x, y) {
            // SparseMatrix does not support Units
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});




var $e111385d1c31411b$var$name = "trace";
var $e111385d1c31411b$var$dependencies = [
    "typed",
    "matrix",
    "add"
];
var $e111385d1c31411b$export$acff8254414be03b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($e111385d1c31411b$var$name, $e111385d1c31411b$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, add: add } = _ref;
    /**
   * Calculate the trace of a matrix: the sum of the elements on the main
   * diagonal of a square matrix.
   *
   * Syntax:
   *
   *    math.trace(x)
   *
   * Examples:
   *
   *    math.trace([[1, 2], [3, 4]]) // returns 5
   *
   *    const A = [
   *      [1, 2, 3],
   *      [-1, 2, 3],
   *      [2, 0, 3]
   *    ]
   *    math.trace(A) // returns 6
   *
   * See also:
   *
   *    diag
   *
   * @param {Array | Matrix} x  A matrix
   *
   * @return {number} The trace of `x`
   */ return typed("trace", {
        Array: function _arrayTrace(x) {
            // use dense matrix implementation
            return _denseTrace(matrix(x));
        },
        SparseMatrix: _sparseTrace,
        DenseMatrix: _denseTrace,
        any: (0, $33619877a15996ac$export$9cd59f9826255e47)
    });
    function _denseTrace(m) {
        // matrix size & data
        var size = m._size;
        var data = m._data; // process dimensions
        switch(size.length){
            case 1:
                // vector
                if (size[0] === 1) // return data[0]
                return (0, $33619877a15996ac$export$9cd59f9826255e47)(data[0]);
                throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
            case 2:
                // two dimensional
                var rows = size[0];
                var cols = size[1];
                if (rows === cols) {
                    // calulate sum
                    var sum = 0; // loop diagonal
                    for(var i = 0; i < rows; i++)sum = add(sum, data[i][i]);
                     // return trace
                    return sum;
                } else throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
            default:
                // multi dimensional
                throw new RangeError("Matrix must be two dimensional (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
        }
    }
    function _sparseTrace(m) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        var size = m._size; // check dimensions
        var rows = size[0];
        var columns = size[1]; // matrix must be square
        if (rows === columns) {
            // calulate sum
            var sum = 0; // check we have data (avoid looping columns)
            if (values.length > 0) // loop columns
            for(var j = 0; j < columns; j++){
                // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
                var k0 = ptr[j];
                var k1 = ptr[j + 1]; // loop k within [k0, k1[
                for(var k = k0; k < k1; k++){
                    // row index
                    var i = index[k]; // check row
                    if (i === j) {
                        // accumulate value
                        sum = add(sum, values[k]); // exit loop
                        break;
                    }
                    if (i > j) break;
                }
            }
             // return trace
            return sum;
        }
        throw new RangeError("Matrix must be square (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
    }
});




var $5c8e110e83150124$var$name = "transpose";
var $5c8e110e83150124$var$dependencies = [
    "typed",
    "matrix"
];
var $5c8e110e83150124$export$9a8c88485f8f638b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($5c8e110e83150124$var$name, $5c8e110e83150124$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Transpose a matrix. All values of the matrix are reflected over its
   * main diagonal. Only applicable to two dimensional matrices containing
   * a vector (i.e. having size `[1,n]` or `[n,1]`). One dimensional
   * vectors and scalars return the input unchanged.
   *
   * Syntax:
   *
   *     math.transpose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.transpose(A)               // returns [[1, 4], [2, 5], [3, 6]]
   *
   * See also:
   *
   *     diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be transposed
   * @return {Array | Matrix}   The transposed matrix
   */ return typed("transpose", {
        Array: function Array(x) {
            // use dense matrix implementation
            return this(matrix(x)).valueOf();
        },
        Matrix: function Matrix(x) {
            // matrix size
            var size = x.size(); // result
            var c; // process dimensions
            switch(size.length){
                case 1:
                    // vector
                    c = x.clone();
                    break;
                case 2:
                    // rows and columns
                    var rows = size[0];
                    var columns = size[1]; // check columns
                    if (columns === 0) // throw exception
                    throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(size) + ")");
                     // process storage format
                    switch(x.storage()){
                        case "dense":
                            c = _denseTranspose(x, rows, columns);
                            break;
                        case "sparse":
                            c = _sparseTranspose(x, rows, columns);
                            break;
                    }
                    break;
                default:
                    // multi dimensional
                    throw new RangeError("Matrix must be a vector or two dimensional (size: " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(this._size) + ")");
            }
            return c;
        },
        // scalars
        any: function any(x) {
            return (0, $33619877a15996ac$export$9cd59f9826255e47)(x);
        }
    });
    function _denseTranspose(m, rows, columns) {
        // matrix array
        var data = m._data; // transposed matrix data
        var transposed = [];
        var transposedRow; // loop columns
        for(var j = 0; j < columns; j++){
            // initialize row
            transposedRow = transposed[j] = []; // loop rows
            for(var i = 0; i < rows; i++)// set data
            transposedRow[i] = (0, $33619877a15996ac$export$9cd59f9826255e47)(data[i][j]);
        } // return matrix
        return m.createDenseMatrix({
            data: transposed,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
    function _sparseTranspose(m, rows, columns) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // result matrices
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = []; // row counts
        var w = [];
        for(var x = 0; x < rows; x++)w[x] = 0;
         // vars
        var p, l, j; // loop values in matrix
        for(p = 0, l = index.length; p < l; p++)// number of values in row
        w[index[p]]++;
         // cumulative sum
        var sum = 0; // initialize cptr with the cummulative sum of row counts
        for(var i = 0; i < rows; i++){
            // update cptr
            cptr.push(sum); // update sum
            sum += w[i]; // update w
            w[i] = cptr[i];
        } // update cptr
        cptr.push(sum); // loop columns
        for(j = 0; j < columns; j++)// values & index in column
        for(var k0 = ptr[j], k1 = ptr[j + 1], k = k0; k < k1; k++){
            // C values & index
            var q = w[index[k]]++; // C[j, i] = A[i, j]
            cindex[q] = j; // check we need to process values (pattern matrix)
            if (values) cvalues[q] = (0, $33619877a15996ac$export$9cd59f9826255e47)(values[k]);
        }
         // return matrix
        return m.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
});

/**
 * Create a typed-function which checks the types of the arguments and
 * can match them against multiple provided signatures. The typed-function
 * automatically converts inputs in order to find a matching signature.
 * Typed functions throw informative errors in case of wrong input arguments.
 *
 * See the library [typed-function](https://github.com/josdejong/typed-function)
 * for detailed documentation.
 *
 * Syntax:
 *
 *     math.typed(name, signatures) : function
 *     math.typed(signatures) : function
 *
 * Examples:
 *
 *     // create a typed function with multiple types per argument (type union)
 *     const fn2 = typed({
 *       'number | boolean': function (b) {
 *         return 'b is a number or boolean'
 *       },
 *       'string, number | boolean': function (a, b) {
 *         return 'a is a string, b is a number or boolean'
 *       }
 *     })
 *
 *     // create a typed function with an any type argument
 *     const log = typed({
 *       'string, any': function (event, data) {
 *         console.log('event: ' + event + ', data: ' + JSON.stringify(data))
 *       }
 *     })
 *
 * @param {string} [name]                          Optional name for the typed-function
 * @param {Object<string, function>} signatures   Object with one or multiple function signatures
 * @returns {function} The created typed-function.
 */ 
var $b1251d94cf75f7eb$exports = {};
/**
 * typed-function
 *
 * Type checking for JavaScript functions
 *
 * https://github.com/josdejong/typed-function
 */ "use strict";
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else // OldNode. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like OldNode.
    $b1251d94cf75f7eb$exports = factory();
})($b1251d94cf75f7eb$exports, function() {
    function ok() {
        return true;
    }
    function notOk() {
        return false;
    }
    function undef() {
        return undefined;
    }
    /**
   * @typedef {{
   *   params: Param[],
   *   fn: function
   * }} Signature
   *
   * @typedef {{
   *   types: Type[],
   *   restParam: boolean
   * }} Param
   *
   * @typedef {{
   *   name: string,
   *   typeIndex: number,
   *   test: function,
   *   conversion?: ConversionDef,
   *   conversionIndex: number,
   * }} Type
   *
   * @typedef {{
   *   from: string,
   *   to: string,
   *   convert: function (*) : *
   * }} ConversionDef
   *
   * @typedef {{
   *   name: string,
   *   test: function(*) : boolean
   * }} TypeDef
   */ // create a new instance of typed-function
    function create() {
        // data type tests
        var _types = [
            {
                name: "number",
                test: function(x) {
                    return typeof x === "number";
                }
            },
            {
                name: "string",
                test: function(x) {
                    return typeof x === "string";
                }
            },
            {
                name: "boolean",
                test: function(x) {
                    return typeof x === "boolean";
                }
            },
            {
                name: "Function",
                test: function(x) {
                    return typeof x === "function";
                }
            },
            {
                name: "Array",
                test: Array.isArray
            },
            {
                name: "Date",
                test: function(x) {
                    return x instanceof Date;
                }
            },
            {
                name: "RegExp",
                test: function(x) {
                    return x instanceof RegExp;
                }
            },
            {
                name: "Object",
                test: function(x) {
                    return typeof x === "object" && x !== null && x.constructor === Object;
                }
            },
            {
                name: "null",
                test: function(x) {
                    return x === null;
                }
            },
            {
                name: "undefined",
                test: function(x) {
                    return x === undefined;
                }
            }
        ];
        var anyType = {
            name: "any",
            test: ok
        };
        // types which need to be ignored
        var _ignore = [];
        // type conversions
        var _conversions = [];
        // This is a temporary object, will be replaced with a typed function at the end
        var typed = {
            types: _types,
            conversions: _conversions,
            ignore: _ignore
        };
        /**
     * Find the test function for a type
     * @param {String} typeName
     * @return {TypeDef} Returns the type definition when found,
     *                    Throws a TypeError otherwise
     */ function findTypeByName(typeName) {
            var entry = findInArray(typed.types, function(entry) {
                return entry.name === typeName;
            });
            if (entry) return entry;
            if (typeName === "any") return anyType;
            var hint = findInArray(typed.types, function(entry) {
                return entry.name.toLowerCase() === typeName.toLowerCase();
            });
            throw new TypeError('Unknown type "' + typeName + '"' + (hint ? '. Did you mean "' + hint.name + '"?' : ""));
        }
        /**
     * Find the index of a type definition. Handles special case 'any'
     * @param {TypeDef} type
     * @return {number}
     */ function findTypeIndex(type) {
            if (type === anyType) return 999;
            return typed.types.indexOf(type);
        }
        /**
     * Find a type that matches a value.
     * @param {*} value
     * @return {string} Returns the name of the first type for which
     *                  the type test matches the value.
     */ function findTypeName(value) {
            var entry = findInArray(typed.types, function(entry) {
                return entry.test(value);
            });
            if (entry) return entry.name;
            throw new TypeError("Value has unknown type. Value: " + value);
        }
        /**
     * Find a specific signature from a (composed) typed function, for example:
     *
     *   typed.find(fn, ['number', 'string'])
     *   typed.find(fn, 'number, string')
     *
     * Function find only only works for exact matches.
     *
     * @param {Function} fn                   A typed-function
     * @param {string | string[]} signature   Signature to be found, can be
     *                                        an array or a comma separated string.
     * @return {Function}                     Returns the matching signature, or
     *                                        throws an error when no signature
     *                                        is found.
     */ function find(fn, signature) {
            if (!fn.signatures) throw new TypeError("Function is no typed-function");
            // normalize input
            var arr;
            if (typeof signature === "string") {
                arr = signature.split(",");
                for(var i = 0; i < arr.length; i++)arr[i] = arr[i].trim();
            } else if (Array.isArray(signature)) arr = signature;
            else throw new TypeError("String array or a comma separated string expected");
            var str = arr.join(",");
            // find an exact match
            var match = fn.signatures[str];
            if (match) return match;
            // TODO: extend find to match non-exact signatures
            throw new TypeError("Signature not found (signature: " + (fn.name || "unnamed") + "(" + arr.join(", ") + "))");
        }
        /**
     * Convert a given value to another data type.
     * @param {*} value
     * @param {string} type
     */ function convert(value, type) {
            var from = findTypeName(value);
            // check conversion is needed
            if (type === from) return value;
            for(var i = 0; i < typed.conversions.length; i++){
                var conversion = typed.conversions[i];
                if (conversion.from === from && conversion.to === type) return conversion.convert(value);
            }
            throw new Error("Cannot convert from " + from + " to " + type);
        }
        /**
     * Stringify parameters in a normalized way
     * @param {Param[]} params
     * @return {string}
     */ function stringifyParams(params) {
            return params.map(function(param) {
                var typeNames = param.types.map(getTypeName);
                return (param.restParam ? "..." : "") + typeNames.join("|");
            }).join(",");
        }
        /**
     * Parse a parameter, like "...number | boolean"
     * @param {string} param
     * @param {ConversionDef[]} conversions
     * @return {Param} param
     */ function parseParam(param, conversions) {
            var restParam = param.indexOf("...") === 0;
            var types = !restParam ? param : param.length > 3 ? param.slice(3) : "any";
            var typeNames = types.split("|").map(trim).filter(notEmpty).filter(notIgnore);
            var matchingConversions = filterConversions(conversions, typeNames);
            var exactTypes = typeNames.map(function(typeName) {
                var type = findTypeByName(typeName);
                return {
                    name: typeName,
                    typeIndex: findTypeIndex(type),
                    test: type.test,
                    conversion: null,
                    conversionIndex: -1
                };
            });
            var convertibleTypes = matchingConversions.map(function(conversion) {
                var type = findTypeByName(conversion.from);
                return {
                    name: conversion.from,
                    typeIndex: findTypeIndex(type),
                    test: type.test,
                    conversion: conversion,
                    conversionIndex: conversions.indexOf(conversion)
                };
            });
            return {
                types: exactTypes.concat(convertibleTypes),
                restParam: restParam
            };
        }
        /**
     * Parse a signature with comma separated parameters,
     * like "number | boolean, ...string"
     * @param {string} signature
     * @param {function} fn
     * @param {ConversionDef[]} conversions
     * @return {Signature | null} signature
     */ function parseSignature(signature, fn, conversions) {
            var params = [];
            if (signature.trim() !== "") params = signature.split(",").map(trim).map(function(param, index, array) {
                var parsedParam = parseParam(param, conversions);
                if (parsedParam.restParam && index !== array.length - 1) throw new SyntaxError('Unexpected rest parameter "' + param + '": ' + "only allowed for the last parameter");
                return parsedParam;
            });
            if (params.some(isInvalidParam)) // invalid signature: at least one parameter has no types
            // (they may have been filtered)
            return null;
            return {
                params: params,
                fn: fn
            };
        }
        /**
     * Test whether a set of params contains a restParam
     * @param {Param[]} params
     * @return {boolean} Returns true when the last parameter is a restParam
     */ function hasRestParam(params) {
            var param = last(params);
            return param ? param.restParam : false;
        }
        /**
     * Test whether a parameter contains conversions
     * @param {Param} param
     * @return {boolean} Returns true when at least one of the parameters
     *                   contains a conversion.
     */ function hasConversions(param) {
            return param.types.some(function(type) {
                return type.conversion != null;
            });
        }
        /**
     * Create a type test for a single parameter, which can have one or multiple
     * types.
     * @param {Param} param
     * @return {function(x: *) : boolean} Returns a test function
     */ function compileTest(param) {
            if (!param || param.types.length === 0) // nothing to do
            return ok;
            else if (param.types.length === 1) return findTypeByName(param.types[0].name).test;
            else if (param.types.length === 2) {
                var test0 = findTypeByName(param.types[0].name).test;
                var test1 = findTypeByName(param.types[1].name).test;
                return function or(x) {
                    return test0(x) || test1(x);
                };
            } else {
                var tests = param.types.map(function(type) {
                    return findTypeByName(type.name).test;
                });
                return function or(x) {
                    for(var i = 0; i < tests.length; i++){
                        if (tests[i](x)) return true;
                    }
                    return false;
                };
            }
        }
        /**
     * Create a test for all parameters of a signature
     * @param {Param[]} params
     * @return {function(args: Array<*>) : boolean}
     */ function compileTests(params) {
            var tests, test0, test1;
            if (hasRestParam(params)) {
                // variable arguments like '...number'
                tests = initial(params).map(compileTest);
                var varIndex = tests.length;
                var lastTest = compileTest(last(params));
                var testRestParam = function(args) {
                    for(var i = varIndex; i < args.length; i++){
                        if (!lastTest(args[i])) return false;
                    }
                    return true;
                };
                return function testArgs(args) {
                    for(var i = 0; i < tests.length; i++){
                        if (!tests[i](args[i])) return false;
                    }
                    return testRestParam(args) && args.length >= varIndex + 1;
                };
            } else {
                // no variable arguments
                if (params.length === 0) return function testArgs(args) {
                    return args.length === 0;
                };
                else if (params.length === 1) {
                    test0 = compileTest(params[0]);
                    return function testArgs(args) {
                        return test0(args[0]) && args.length === 1;
                    };
                } else if (params.length === 2) {
                    test0 = compileTest(params[0]);
                    test1 = compileTest(params[1]);
                    return function testArgs(args) {
                        return test0(args[0]) && test1(args[1]) && args.length === 2;
                    };
                } else {
                    tests = params.map(compileTest);
                    return function testArgs(args) {
                        for(var i = 0; i < tests.length; i++){
                            if (!tests[i](args[i])) return false;
                        }
                        return args.length === tests.length;
                    };
                }
            }
        }
        /**
     * Find the parameter at a specific index of a signature.
     * Handles rest parameters.
     * @param {Signature} signature
     * @param {number} index
     * @return {Param | null} Returns the matching parameter when found,
     *                        null otherwise.
     */ function getParamAtIndex(signature, index) {
            return index < signature.params.length ? signature.params[index] : hasRestParam(signature.params) ? last(signature.params) : null;
        }
        /**
     * Get all type names of a parameter
     * @param {Signature} signature
     * @param {number} index
     * @param {boolean} excludeConversions
     * @return {string[]} Returns an array with type names
     */ function getExpectedTypeNames(signature, index, excludeConversions) {
            var param = getParamAtIndex(signature, index);
            var types = param ? excludeConversions ? param.types.filter(isExactType) : param.types : [];
            return types.map(getTypeName);
        }
        /**
     * Returns the name of a type
     * @param {Type} type
     * @return {string} Returns the type name
     */ function getTypeName(type) {
            return type.name;
        }
        /**
     * Test whether a type is an exact type or conversion
     * @param {Type} type
     * @return {boolean} Returns true when
     */ function isExactType(type) {
            return type.conversion === null || type.conversion === undefined;
        }
        /**
     * Helper function for creating error messages: create an array with
     * all available types on a specific argument index.
     * @param {Signature[]} signatures
     * @param {number} index
     * @return {string[]} Returns an array with available types
     */ function mergeExpectedParams(signatures, index) {
            var typeNames = uniq(flatMap(signatures, function(signature) {
                return getExpectedTypeNames(signature, index, false);
            }));
            return typeNames.indexOf("any") !== -1 ? [
                "any"
            ] : typeNames;
        }
        /**
     * Create
     * @param {string} name             The name of the function
     * @param {array.<*>} args          The actual arguments passed to the function
     * @param {Signature[]} signatures  A list with available signatures
     * @return {TypeError} Returns a type error with additional data
     *                     attached to it in the property `data`
     */ function createError(name, args, signatures) {
            var err, expected;
            var _name = name || "unnamed";
            // test for wrong type at some index
            var matchingSignatures = signatures;
            var index;
            for(index = 0; index < args.length; index++){
                var nextMatchingDefs = matchingSignatures.filter(function(signature) {
                    var test = compileTest(getParamAtIndex(signature, index));
                    return (index < signature.params.length || hasRestParam(signature.params)) && test(args[index]);
                });
                if (nextMatchingDefs.length === 0) {
                    // no matching signatures anymore, throw error "wrong type"
                    expected = mergeExpectedParams(matchingSignatures, index);
                    if (expected.length > 0) {
                        var actualType = findTypeName(args[index]);
                        err = new TypeError("Unexpected type of argument in function " + _name + " (expected: " + expected.join(" or ") + ", actual: " + actualType + ", index: " + index + ")");
                        err.data = {
                            category: "wrongType",
                            fn: _name,
                            index: index,
                            actual: actualType,
                            expected: expected
                        };
                        return err;
                    }
                } else matchingSignatures = nextMatchingDefs;
            }
            // test for too few arguments
            var lengths = matchingSignatures.map(function(signature) {
                return hasRestParam(signature.params) ? Infinity : signature.params.length;
            });
            if (args.length < Math.min.apply(null, lengths)) {
                expected = mergeExpectedParams(matchingSignatures, index);
                err = new TypeError("Too few arguments in function " + _name + " (expected: " + expected.join(" or ") + ", index: " + args.length + ")");
                err.data = {
                    category: "tooFewArgs",
                    fn: _name,
                    index: args.length,
                    expected: expected
                };
                return err;
            }
            // test for too many arguments
            var maxLength = Math.max.apply(null, lengths);
            if (args.length > maxLength) {
                err = new TypeError("Too many arguments in function " + _name + " (expected: " + maxLength + ", actual: " + args.length + ")");
                err.data = {
                    category: "tooManyArgs",
                    fn: _name,
                    index: args.length,
                    expectedLength: maxLength
                };
                return err;
            }
            err = new TypeError('Arguments of type "' + args.join(", ") + '" do not match any of the defined signatures of function ' + _name + ".");
            err.data = {
                category: "mismatch",
                actual: args.map(findTypeName)
            };
            return err;
        }
        /**
     * Find the lowest index of all exact types of a parameter (no conversions)
     * @param {Param} param
     * @return {number} Returns the index of the lowest type in typed.types
     */ function getLowestTypeIndex(param) {
            var min = 999;
            for(var i = 0; i < param.types.length; i++)if (isExactType(param.types[i])) min = Math.min(min, param.types[i].typeIndex);
            return min;
        }
        /**
     * Find the lowest index of the conversion of all types of the parameter
     * having a conversion
     * @param {Param} param
     * @return {number} Returns the lowest index of the conversions of this type
     */ function getLowestConversionIndex(param) {
            var min = 999;
            for(var i = 0; i < param.types.length; i++)if (!isExactType(param.types[i])) min = Math.min(min, param.types[i].conversionIndex);
            return min;
        }
        /**
     * Compare two params
     * @param {Param} param1
     * @param {Param} param2
     * @return {number} returns a negative number when param1 must get a lower
     *                  index than param2, a positive number when the opposite,
     *                  or zero when both are equal
     */ function compareParams(param1, param2) {
            var c;
            // compare having a rest parameter or not
            c = param1.restParam - param2.restParam;
            if (c !== 0) return c;
            // compare having conversions or not
            c = hasConversions(param1) - hasConversions(param2);
            if (c !== 0) return c;
            // compare the index of the types
            c = getLowestTypeIndex(param1) - getLowestTypeIndex(param2);
            if (c !== 0) return c;
            // compare the index of any conversion
            return getLowestConversionIndex(param1) - getLowestConversionIndex(param2);
        }
        /**
     * Compare two signatures
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {number} returns a negative number when param1 must get a lower
     *                  index than param2, a positive number when the opposite,
     *                  or zero when both are equal
     */ function compareSignatures(signature1, signature2) {
            var len = Math.min(signature1.params.length, signature2.params.length);
            var i;
            var c;
            // compare whether the params have conversions at all or not
            c = signature1.params.some(hasConversions) - signature2.params.some(hasConversions);
            if (c !== 0) return c;
            // next compare whether the params have conversions one by one
            for(i = 0; i < len; i++){
                c = hasConversions(signature1.params[i]) - hasConversions(signature2.params[i]);
                if (c !== 0) return c;
            }
            // compare the types of the params one by one
            for(i = 0; i < len; i++){
                c = compareParams(signature1.params[i], signature2.params[i]);
                if (c !== 0) return c;
            }
            // compare the number of params
            return signature1.params.length - signature2.params.length;
        }
        /**
     * Get params containing all types that can be converted to the defined types.
     *
     * @param {ConversionDef[]} conversions
     * @param {string[]} typeNames
     * @return {ConversionDef[]} Returns the conversions that are available
     *                        for every type (if any)
     */ function filterConversions(conversions, typeNames) {
            var matches = {};
            conversions.forEach(function(conversion) {
                if (typeNames.indexOf(conversion.from) === -1 && typeNames.indexOf(conversion.to) !== -1 && !matches[conversion.from]) matches[conversion.from] = conversion;
            });
            return Object.keys(matches).map(function(from) {
                return matches[from];
            });
        }
        /**
     * Preprocess arguments before calling the original function:
     * - if needed convert the parameters
     * - in case of rest parameters, move the rest parameters into an Array
     * @param {Param[]} params
     * @param {function} fn
     * @return {function} Returns a wrapped function
     */ function compileArgsPreprocessing(params, fn) {
            var fnConvert = fn;
            // TODO: can we make this wrapper function smarter/simpler?
            if (params.some(hasConversions)) {
                var restParam = hasRestParam(params);
                var compiledConversions = params.map(compileArgConversion);
                fnConvert = function convertArgs() {
                    var args = [];
                    var last = restParam ? arguments.length - 1 : arguments.length;
                    for(var i = 0; i < last; i++)args[i] = compiledConversions[i](arguments[i]);
                    if (restParam) args[last] = arguments[last].map(compiledConversions[last]);
                    return fn.apply(this, args);
                };
            }
            var fnPreprocess = fnConvert;
            if (hasRestParam(params)) {
                var offset = params.length - 1;
                fnPreprocess = function preprocessRestParams() {
                    return fnConvert.apply(this, slice(arguments, 0, offset).concat([
                        slice(arguments, offset)
                    ]));
                };
            }
            return fnPreprocess;
        }
        /**
     * Compile conversion for a parameter to the right type
     * @param {Param} param
     * @return {function} Returns the wrapped function that will convert arguments
     *
     */ function compileArgConversion(param) {
            var test0, test1, conversion0, conversion1;
            var tests = [];
            var conversions = [];
            param.types.forEach(function(type) {
                if (type.conversion) {
                    tests.push(findTypeByName(type.conversion.from).test);
                    conversions.push(type.conversion.convert);
                }
            });
            // create optimized conversion functions depending on the number of conversions
            switch(conversions.length){
                case 0:
                    return function convertArg(arg) {
                        return arg;
                    };
                case 1:
                    test0 = tests[0];
                    conversion0 = conversions[0];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        return arg;
                    };
                case 2:
                    test0 = tests[0];
                    test1 = tests[1];
                    conversion0 = conversions[0];
                    conversion1 = conversions[1];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        if (test1(arg)) return conversion1(arg);
                        return arg;
                    };
                default:
                    return function convertArg(arg) {
                        for(var i = 0; i < conversions.length; i++){
                            if (tests[i](arg)) return conversions[i](arg);
                        }
                        return arg;
                    };
            }
        }
        /**
     * Convert an array with signatures into a map with signatures,
     * where signatures with union types are split into separate signatures
     *
     * Throws an error when there are conflicting types
     *
     * @param {Signature[]} signatures
     * @return {Object.<string, function>}  Returns a map with signatures
     *                                      as key and the original function
     *                                      of this signature as value.
     */ function createSignaturesMap(signatures) {
            var signaturesMap = {};
            signatures.forEach(function(signature) {
                if (!signature.params.some(hasConversions)) splitParams(signature.params, true).forEach(function(params) {
                    signaturesMap[stringifyParams(params)] = signature.fn;
                });
            });
            return signaturesMap;
        }
        /**
     * Split params with union types in to separate params.
     *
     * For example:
     *
     *     splitParams([['Array', 'Object'], ['string', 'RegExp'])
     *     // returns:
     *     // [
     *     //   ['Array', 'string'],
     *     //   ['Array', 'RegExp'],
     *     //   ['Object', 'string'],
     *     //   ['Object', 'RegExp']
     *     // ]
     *
     * @param {Param[]} params
     * @param {boolean} ignoreConversionTypes
     * @return {Param[]}
     */ function splitParams(params, ignoreConversionTypes) {
            function _splitParams(params, index, types) {
                if (index < params.length) {
                    var param = params[index];
                    var filteredTypes = ignoreConversionTypes ? param.types.filter(isExactType) : param.types;
                    var typeGroups;
                    if (param.restParam) {
                        // split the types of a rest parameter in two:
                        // one with only exact types, and one with exact types and conversions
                        var exactTypes = filteredTypes.filter(isExactType);
                        typeGroups = exactTypes.length < filteredTypes.length ? [
                            exactTypes,
                            filteredTypes
                        ] : [
                            filteredTypes
                        ];
                    } else // split all the types of a regular parameter into one type per group
                    typeGroups = filteredTypes.map(function(type) {
                        return [
                            type
                        ];
                    });
                    // recurse over the groups with types
                    return flatMap(typeGroups, function(typeGroup) {
                        return _splitParams(params, index + 1, types.concat([
                            typeGroup
                        ]));
                    });
                } else {
                    // we've reached the end of the parameters. Now build a new Param
                    var splittedParams = types.map(function(type, typeIndex) {
                        return {
                            types: type,
                            restParam: typeIndex === params.length - 1 && hasRestParam(params)
                        };
                    });
                    return [
                        splittedParams
                    ];
                }
            }
            return _splitParams(params, 0, []);
        }
        /**
     * Test whether two signatures have a conflicting signature
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {boolean} Returns true when the signatures conflict, false otherwise.
     */ function hasConflictingParams(signature1, signature2) {
            var ii = Math.max(signature1.params.length, signature2.params.length);
            for(var i = 0; i < ii; i++){
                var typesNames1 = getExpectedTypeNames(signature1, i, true);
                var typesNames2 = getExpectedTypeNames(signature2, i, true);
                if (!hasOverlap(typesNames1, typesNames2)) return false;
            }
            var len1 = signature1.params.length;
            var len2 = signature2.params.length;
            var restParam1 = hasRestParam(signature1.params);
            var restParam2 = hasRestParam(signature2.params);
            return restParam1 ? restParam2 ? len1 === len2 : len2 >= len1 : restParam2 ? len1 >= len2 : len1 === len2;
        }
        /**
     * Create a typed function
     * @param {String} name               The name for the typed function
     * @param {Object.<string, function>} signaturesMap
     *                                    An object with one or
     *                                    multiple signatures as key, and the
     *                                    function corresponding to the
     *                                    signature as value.
     * @return {function}  Returns the created typed function.
     */ function createTypedFunction(name, signaturesMap) {
            if (Object.keys(signaturesMap).length === 0) throw new SyntaxError("No signatures provided");
            // parse the signatures, and check for conflicts
            var parsedSignatures = [];
            Object.keys(signaturesMap).map(function(signature) {
                return parseSignature(signature, signaturesMap[signature], typed.conversions);
            }).filter(notNull).forEach(function(parsedSignature) {
                // check whether this parameter conflicts with already parsed signatures
                var conflictingSignature = findInArray(parsedSignatures, function(s) {
                    return hasConflictingParams(s, parsedSignature);
                });
                if (conflictingSignature) throw new TypeError('Conflicting signatures "' + stringifyParams(conflictingSignature.params) + '" and "' + stringifyParams(parsedSignature.params) + '".');
                parsedSignatures.push(parsedSignature);
            });
            // split and filter the types of the signatures, and then order them
            var signatures = flatMap(parsedSignatures, function(parsedSignature) {
                var params = parsedSignature ? splitParams(parsedSignature.params, false) : [];
                return params.map(function(params) {
                    return {
                        params: params,
                        fn: parsedSignature.fn
                    };
                });
            }).filter(notNull);
            signatures.sort(compareSignatures);
            // we create a highly optimized checks for the first couple of signatures with max 2 arguments
            var ok0 = signatures[0] && signatures[0].params.length <= 2 && !hasRestParam(signatures[0].params);
            var ok1 = signatures[1] && signatures[1].params.length <= 2 && !hasRestParam(signatures[1].params);
            var ok2 = signatures[2] && signatures[2].params.length <= 2 && !hasRestParam(signatures[2].params);
            var ok3 = signatures[3] && signatures[3].params.length <= 2 && !hasRestParam(signatures[3].params);
            var ok4 = signatures[4] && signatures[4].params.length <= 2 && !hasRestParam(signatures[4].params);
            var ok5 = signatures[5] && signatures[5].params.length <= 2 && !hasRestParam(signatures[5].params);
            var allOk = ok0 && ok1 && ok2 && ok3 && ok4 && ok5;
            // compile the tests
            var tests = signatures.map(function(signature) {
                return compileTests(signature.params);
            });
            var test00 = ok0 ? compileTest(signatures[0].params[0]) : notOk;
            var test10 = ok1 ? compileTest(signatures[1].params[0]) : notOk;
            var test20 = ok2 ? compileTest(signatures[2].params[0]) : notOk;
            var test30 = ok3 ? compileTest(signatures[3].params[0]) : notOk;
            var test40 = ok4 ? compileTest(signatures[4].params[0]) : notOk;
            var test50 = ok5 ? compileTest(signatures[5].params[0]) : notOk;
            var test01 = ok0 ? compileTest(signatures[0].params[1]) : notOk;
            var test11 = ok1 ? compileTest(signatures[1].params[1]) : notOk;
            var test21 = ok2 ? compileTest(signatures[2].params[1]) : notOk;
            var test31 = ok3 ? compileTest(signatures[3].params[1]) : notOk;
            var test41 = ok4 ? compileTest(signatures[4].params[1]) : notOk;
            var test51 = ok5 ? compileTest(signatures[5].params[1]) : notOk;
            // compile the functions
            var fns = signatures.map(function(signature) {
                return compileArgsPreprocessing(signature.params, signature.fn);
            });
            var fn0 = ok0 ? fns[0] : undef;
            var fn1 = ok1 ? fns[1] : undef;
            var fn2 = ok2 ? fns[2] : undef;
            var fn3 = ok3 ? fns[3] : undef;
            var fn4 = ok4 ? fns[4] : undef;
            var fn5 = ok5 ? fns[5] : undef;
            var len0 = ok0 ? signatures[0].params.length : -1;
            var len1 = ok1 ? signatures[1].params.length : -1;
            var len2 = ok2 ? signatures[2].params.length : -1;
            var len3 = ok3 ? signatures[3].params.length : -1;
            var len4 = ok4 ? signatures[4].params.length : -1;
            var len5 = ok5 ? signatures[5].params.length : -1;
            // simple and generic, but also slow
            var iStart = allOk ? 6 : 0;
            var iEnd = signatures.length;
            var generic = function generic() {
                "use strict";
                for(var i = iStart; i < iEnd; i++){
                    if (tests[i](arguments)) return fns[i].apply(this, arguments);
                }
                return typed.onMismatch(name, arguments, signatures);
            };
            // create the typed function
            // fast, specialized version. Falls back to the slower, generic one if needed
            var fn = function fn(arg0, arg1) {
                "use strict";
                if (arguments.length === len0 && test00(arg0) && test01(arg1)) return fn0.apply(fn, arguments);
                if (arguments.length === len1 && test10(arg0) && test11(arg1)) return fn1.apply(fn, arguments);
                if (arguments.length === len2 && test20(arg0) && test21(arg1)) return fn2.apply(fn, arguments);
                if (arguments.length === len3 && test30(arg0) && test31(arg1)) return fn3.apply(fn, arguments);
                if (arguments.length === len4 && test40(arg0) && test41(arg1)) return fn4.apply(fn, arguments);
                if (arguments.length === len5 && test50(arg0) && test51(arg1)) return fn5.apply(fn, arguments);
                return generic.apply(fn, arguments);
            };
            // attach name the typed function
            try {
                Object.defineProperty(fn, "name", {
                    value: name
                });
            } catch (err) {
            // old browsers do not support Object.defineProperty and some don't support setting the name property
            // the function name is not essential for the functioning, it's mostly useful for debugging,
            // so it's fine to have unnamed functions.
            }
            // attach signatures to the function
            fn.signatures = createSignaturesMap(signatures);
            return fn;
        }
        /**
     * Action to take on mismatch
     * @param {string} name      Name of function that was attempted to be called
     * @param {Array} args       Actual arguments to the call
     * @param {Array} signatures Known signatures of the named typed-function
     */ function _onMismatch(name, args, signatures) {
            throw createError(name, args, signatures);
        }
        /**
     * Test whether a type should be NOT be ignored
     * @param {string} typeName
     * @return {boolean}
     */ function notIgnore(typeName) {
            return typed.ignore.indexOf(typeName) === -1;
        }
        /**
     * trim a string
     * @param {string} str
     * @return {string}
     */ function trim(str) {
            return str.trim();
        }
        /**
     * Test whether a string is not empty
     * @param {string} str
     * @return {boolean}
     */ function notEmpty(str) {
            return !!str;
        }
        /**
     * test whether a value is not strict equal to null
     * @param {*} value
     * @return {boolean}
     */ function notNull(value) {
            return value !== null;
        }
        /**
     * Test whether a parameter has no types defined
     * @param {Param} param
     * @return {boolean}
     */ function isInvalidParam(param) {
            return param.types.length === 0;
        }
        /**
     * Return all but the last items of an array
     * @param {Array} arr
     * @return {Array}
     */ function initial(arr) {
            return arr.slice(0, arr.length - 1);
        }
        /**
     * return the last item of an array
     * @param {Array} arr
     * @return {*}
     */ function last(arr) {
            return arr[arr.length - 1];
        }
        /**
     * Slice an array or function Arguments
     * @param {Array | Arguments | IArguments} arr
     * @param {number} start
     * @param {number} [end]
     * @return {Array}
     */ function slice(arr, start, end) {
            return Array.prototype.slice.call(arr, start, end);
        }
        /**
     * Test whether an array contains some item
     * @param {Array} array
     * @param {*} item
     * @return {boolean} Returns true if array contains item, false if not.
     */ function contains(array, item) {
            return array.indexOf(item) !== -1;
        }
        /**
     * Test whether two arrays have overlapping items
     * @param {Array} array1
     * @param {Array} array2
     * @return {boolean} Returns true when at least one item exists in both arrays
     */ function hasOverlap(array1, array2) {
            for(var i = 0; i < array1.length; i++){
                if (contains(array2, array1[i])) return true;
            }
            return false;
        }
        /**
     * Return the first item from an array for which test(arr[i]) returns true
     * @param {Array} arr
     * @param {function} test
     * @return {* | undefined} Returns the first matching item
     *                         or undefined when there is no match
     */ function findInArray(arr, test) {
            for(var i = 0; i < arr.length; i++){
                if (test(arr[i])) return arr[i];
            }
            return undefined;
        }
        /**
     * Filter unique items of an array with strings
     * @param {string[]} arr
     * @return {string[]}
     */ function uniq(arr) {
            var entries = {};
            for(var i = 0; i < arr.length; i++)entries[arr[i]] = true;
            return Object.keys(entries);
        }
        /**
     * Flat map the result invoking a callback for every item in an array.
     * https://gist.github.com/samgiles/762ee337dff48623e729
     * @param {Array} arr
     * @param {function} callback
     * @return {Array}
     */ function flatMap(arr, callback) {
            return Array.prototype.concat.apply([], arr.map(callback));
        }
        /**
     * Retrieve the function name from a set of typed functions,
     * and check whether the name of all functions match (if given)
     * @param {function[]} fns
     */ function getName(fns) {
            var name = "";
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                // check whether the names are the same when defined
                if ((typeof fn.signatures === "object" || typeof fn.signature === "string") && fn.name !== "") {
                    if (name === "") name = fn.name;
                    else if (name !== fn.name) {
                        var err = new Error("Function names do not match (expected: " + name + ", actual: " + fn.name + ")");
                        err.data = {
                            actual: fn.name,
                            expected: name
                        };
                        throw err;
                    }
                }
            }
            return name;
        }
        // extract and merge all signatures of a list with typed functions
        function extractSignatures(fns) {
            var err;
            var signaturesMap = {};
            function validateUnique(_signature, _fn) {
                if (signaturesMap.hasOwnProperty(_signature) && _fn !== signaturesMap[_signature]) {
                    err = new Error('Signature "' + _signature + '" is defined twice');
                    err.data = {
                        signature: _signature
                    };
                    throw err;
                // else: both signatures point to the same function, that's fine
                }
            }
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                // test whether this is a typed-function
                if (typeof fn.signatures === "object") {
                    // merge the signatures
                    for(var signature in fn.signatures)if (fn.signatures.hasOwnProperty(signature)) {
                        validateUnique(signature, fn.signatures[signature]);
                        signaturesMap[signature] = fn.signatures[signature];
                    }
                } else if (typeof fn.signature === "string") {
                    validateUnique(fn.signature, fn);
                    signaturesMap[fn.signature] = fn;
                } else {
                    err = new TypeError("Function is no typed-function (index: " + i + ")");
                    err.data = {
                        index: i
                    };
                    throw err;
                }
            }
            return signaturesMap;
        }
        typed = createTypedFunction("typed", {
            "string, Object": createTypedFunction,
            "Object": function(signaturesMap) {
                // find existing name
                var fns = [];
                for(var signature in signaturesMap)if (signaturesMap.hasOwnProperty(signature)) fns.push(signaturesMap[signature]);
                var name = getName(fns);
                return createTypedFunction(name, signaturesMap);
            },
            "...Function": function(fns) {
                return createTypedFunction(getName(fns), extractSignatures(fns));
            },
            "string, ...Function": function(name, fns) {
                return createTypedFunction(name, extractSignatures(fns));
            }
        });
        typed.create = create;
        typed.types = _types;
        typed.conversions = _conversions;
        typed.ignore = _ignore;
        typed.onMismatch = _onMismatch;
        typed.throwMismatchError = _onMismatch;
        typed.createError = createError;
        typed.convert = convert;
        typed.find = find;
        /**
     * add a type
     * @param {{name: string, test: function}} type
     * @param {boolean} [beforeObjectTest=true]
     *                          If true, the new test will be inserted before
     *                          the test with name 'Object' (if any), since
     *                          tests for Object match Array and classes too.
     */ typed.addType = function(type, beforeObjectTest) {
            if (!type || typeof type.name !== "string" || typeof type.test !== "function") throw new TypeError("Object with properties {name: string, test: function} expected");
            if (beforeObjectTest !== false) {
                for(var i = 0; i < typed.types.length; i++)if (typed.types[i].name === "Object") {
                    typed.types.splice(i, 0, type);
                    return;
                }
            }
            typed.types.push(type);
        };
        // add a conversion
        typed.addConversion = function(conversion) {
            if (!conversion || typeof conversion.from !== "string" || typeof conversion.to !== "string" || typeof conversion.convert !== "function") throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
            typed.conversions.push(conversion);
        };
        return typed;
    }
    return create();
});






class $8f2e3669195c8ad5$export$6f491f8f4fd27271 {
    keys() {
        return Object.keys(this.wrappedObject);
    }
    get(key) {
        return (0, $49d1ac263f403507$export$87a87648a1961976)(this.wrappedObject, key);
    }
    set(key, value) {
        (0, $49d1ac263f403507$export$e99fe8700ee9f9cd)(this.wrappedObject, key, value);
        return this;
    }
    has(key) {
        return (0, $49d1ac263f403507$export$626bde2ef1d9655a)(this.wrappedObject, key);
    }
    constructor(object){
        this.wrappedObject = object;
    }
}
function $8f2e3669195c8ad5$export$89a4bcaf5b4d37d2() {
    return new Map();
}
function $8f2e3669195c8ad5$export$d49c9aa30b771d59(mapOrObject) {
    if (!mapOrObject) return $8f2e3669195c8ad5$export$89a4bcaf5b4d37d2();
    if ($8f2e3669195c8ad5$export$5c90113a285f2241(mapOrObject)) return mapOrObject;
    if ((0, $2c4f948f17aa2240$export$a6cdc56e425d0d0a)(mapOrObject)) return new $8f2e3669195c8ad5$export$6f491f8f4fd27271(mapOrObject);
    throw new Error("createMap can create maps from objects or Maps");
}
function $8f2e3669195c8ad5$export$697e4a1b90752ce2(map) {
    if (map instanceof $8f2e3669195c8ad5$export$6f491f8f4fd27271) return map.wrappedObject;
    var object = {};
    for (var key of map.keys()){
        var value = map.get(key);
        (0, $49d1ac263f403507$export$e99fe8700ee9f9cd)(object, key, value);
    }
    return object;
}
function $8f2e3669195c8ad5$export$5c90113a285f2241(object) {
    // We can use the fast instanceof, or a slower duck typing check.
    // The duck typing method needs to cover enough methods to not be confused with DenseMatrix.
    if (!object) return false;
    return object instanceof Map || object instanceof $8f2e3669195c8ad5$export$6f491f8f4fd27271 || typeof object.set === "function" && typeof object.get === "function" && typeof object.keys === "function" && typeof object.has === "function";
}
function $8f2e3669195c8ad5$export$e6e34fd1f2686227(map) {
    for(var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)objects[_key - 1] = arguments[_key];
    for (var args of objects){
        if (!args) continue;
        if ($8f2e3669195c8ad5$export$5c90113a285f2241(args)) for (var key of args.keys())map.set(key, args.get(key));
        else if ((0, $2c4f948f17aa2240$export$a6cdc56e425d0d0a)(args)) for (var _key2 of Object.keys(args))map.set(_key2, args[_key2]);
    }
    return map;
}


var $41903bc6f503885b$var$_createTyped2 = function _createTyped() {
    // initially, return the original instance of typed-function
    // consecutively, return a new instance from typed.create.
    $41903bc6f503885b$var$_createTyped2 = (0, (/*@__PURE__*/$parcel$interopDefault($b1251d94cf75f7eb$exports))).create;
    return 0, (/*@__PURE__*/$parcel$interopDefault($b1251d94cf75f7eb$exports));
};
var $41903bc6f503885b$var$dependencies = [
    "?BigNumber",
    "?Complex",
    "?DenseMatrix",
    "?Fraction"
];
var $41903bc6f503885b$export$8597b5d47504f989 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)("typed", $41903bc6f503885b$var$dependencies, function createTyped(_ref) {
    var { BigNumber: BigNumber, Complex: Complex, DenseMatrix: DenseMatrix, Fraction: Fraction } = _ref;
    // TODO: typed-function must be able to silently ignore signatures with unknown data types
    // get a new instance of typed-function
    var typed = $41903bc6f503885b$var$_createTyped2(); // define all types. The order of the types determines in which order function
    // arguments are type-checked (so for performance it's important to put the
    // most used types first).
    typed.types = [
        {
            name: "number",
            test: (0, $2c4f948f17aa2240$export$7e4aa119212bc614)
        },
        {
            name: "Complex",
            test: (0, $2c4f948f17aa2240$export$8849a896711efe0c)
        },
        {
            name: "BigNumber",
            test: (0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)
        },
        {
            name: "Fraction",
            test: (0, $2c4f948f17aa2240$export$e312cb8a8e5e7c34)
        },
        {
            name: "Unit",
            test: (0, $2c4f948f17aa2240$export$8960dc335987b8da)
        },
        {
            name: "string",
            test: (0, $2c4f948f17aa2240$export$844ec244b1367d54)
        },
        {
            name: "Chain",
            test: (0, $2c4f948f17aa2240$export$dc36953d0b3a4f05)
        },
        {
            name: "Array",
            test: (0, $2c4f948f17aa2240$export$43bee75e5e14138e)
        },
        {
            name: "Matrix",
            test: (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)
        },
        {
            name: "DenseMatrix",
            test: (0, $2c4f948f17aa2240$export$eb44495df7ba11d)
        },
        {
            name: "SparseMatrix",
            test: (0, $2c4f948f17aa2240$export$d508368d4da3c38a)
        },
        {
            name: "Range",
            test: (0, $2c4f948f17aa2240$export$e331ccfa6f694c99)
        },
        {
            name: "Index",
            test: (0, $2c4f948f17aa2240$export$ba3dc792055c2f45)
        },
        {
            name: "boolean",
            test: (0, $2c4f948f17aa2240$export$f9ce7b637dfbe238)
        },
        {
            name: "ResultSet",
            test: (0, $2c4f948f17aa2240$export$381a1a20e6a63376)
        },
        {
            name: "Help",
            test: (0, $2c4f948f17aa2240$export$e5dec9a75b602d6c)
        },
        {
            name: "function",
            test: (0, $2c4f948f17aa2240$export$f6e2535fb5126e54)
        },
        {
            name: "Date",
            test: (0, $2c4f948f17aa2240$export$871608497c498473)
        },
        {
            name: "RegExp",
            test: (0, $2c4f948f17aa2240$export$49841c62b9eff15)
        },
        {
            name: "null",
            test: (0, $2c4f948f17aa2240$export$630801d484da15df)
        },
        {
            name: "undefined",
            test: (0, $2c4f948f17aa2240$export$fce6876652108ab)
        },
        {
            name: "AccessorNode",
            test: (0, $2c4f948f17aa2240$export$f88fb19d6b9ee5cb)
        },
        {
            name: "ArrayNode",
            test: (0, $2c4f948f17aa2240$export$440fa93dcf2757a3)
        },
        {
            name: "AssignmentNode",
            test: (0, $2c4f948f17aa2240$export$64d7d515ec030d5e)
        },
        {
            name: "BlockNode",
            test: (0, $2c4f948f17aa2240$export$1665e2275a3d717a)
        },
        {
            name: "ConditionalNode",
            test: (0, $2c4f948f17aa2240$export$e1babefe78c70737)
        },
        {
            name: "ConstantNode",
            test: (0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)
        },
        {
            name: "FunctionNode",
            test: (0, $2c4f948f17aa2240$export$6ae03b16e064e6c4)
        },
        {
            name: "FunctionAssignmentNode",
            test: (0, $2c4f948f17aa2240$export$27c05cfffd263d30)
        },
        {
            name: "IndexNode",
            test: (0, $2c4f948f17aa2240$export$ff90979121a6cabc)
        },
        {
            name: "Node",
            test: (0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)
        },
        {
            name: "ObjectNode",
            test: (0, $2c4f948f17aa2240$export$3f18867a334658e9)
        },
        {
            name: "OperatorNode",
            test: (0, $2c4f948f17aa2240$export$7e624cbaab6cce94)
        },
        {
            name: "ParenthesisNode",
            test: (0, $2c4f948f17aa2240$export$c55e3736c5721220)
        },
        {
            name: "RangeNode",
            test: (0, $2c4f948f17aa2240$export$92729c5c4ff6fc83)
        },
        {
            name: "SymbolNode",
            test: (0, $2c4f948f17aa2240$export$87815d550facaed9)
        },
        {
            name: "Map",
            test: (0, $8f2e3669195c8ad5$export$5c90113a285f2241)
        },
        {
            name: "Object",
            test: (0, $2c4f948f17aa2240$export$a6cdc56e425d0d0a)
        } // order 'Object' last, it matches on other classes too
    ];
    typed.conversions = [
        {
            from: "number",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $41903bc6f503885b$var$throwNoBignumber(x);
                 // note: conversion from number to BigNumber can fail if x has >15 digits
                if ((0, $a03283b133c3c55b$export$9c0987062f8f5d89)(x) > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + x + "). " + "Use function bignumber(x) to convert to BigNumber.");
                return new BigNumber(x);
            }
        },
        {
            from: "number",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $41903bc6f503885b$var$throwNoComplex(x);
                return new Complex(x, 0);
            }
        },
        {
            from: "number",
            to: "string",
            convert: function convert(x) {
                return x + "";
            }
        },
        {
            from: "BigNumber",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $41903bc6f503885b$var$throwNoComplex(x);
                return new Complex(x.toNumber(), 0);
            }
        },
        {
            from: "Fraction",
            to: "BigNumber",
            convert: function convert(x) {
                throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
            }
        },
        {
            from: "Fraction",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $41903bc6f503885b$var$throwNoComplex(x);
                return new Complex(x.valueOf(), 0);
            }
        },
        {
            from: "number",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $41903bc6f503885b$var$throwNoFraction(x);
                var f = new Fraction(x);
                if (f.valueOf() !== x) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + x + "). " + "Use function fraction(x) to convert to Fraction.");
                return f;
            }
        },
        {
            // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
            //  from: 'Fraction',
            //  to: 'number',
            //  convert: function (x) {
            //    return x.valueOf()
            //  }
            // }, {
            from: "string",
            to: "number",
            convert: function convert(x) {
                var n = Number(x);
                if (isNaN(n)) throw new Error('Cannot convert "' + x + '" to a number');
                return n;
            }
        },
        {
            from: "string",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $41903bc6f503885b$var$throwNoBignumber(x);
                try {
                    return new BigNumber(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to BigNumber');
                }
            }
        },
        {
            from: "string",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $41903bc6f503885b$var$throwNoFraction(x);
                try {
                    return new Fraction(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Fraction');
                }
            }
        },
        {
            from: "string",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $41903bc6f503885b$var$throwNoComplex(x);
                try {
                    return new Complex(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Complex');
                }
            }
        },
        {
            from: "boolean",
            to: "number",
            convert: function convert(x) {
                return +x;
            }
        },
        {
            from: "boolean",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $41903bc6f503885b$var$throwNoBignumber(x);
                return new BigNumber(+x);
            }
        },
        {
            from: "boolean",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $41903bc6f503885b$var$throwNoFraction(x);
                return new Fraction(+x);
            }
        },
        {
            from: "boolean",
            to: "string",
            convert: function convert(x) {
                return String(x);
            }
        },
        {
            from: "Array",
            to: "Matrix",
            convert: function convert(array) {
                if (!DenseMatrix) $41903bc6f503885b$var$throwNoMatrix();
                return new DenseMatrix(array);
            }
        },
        {
            from: "Matrix",
            to: "Array",
            convert: function convert(matrix) {
                return matrix.valueOf();
            }
        }
    ];
    return typed;
});
function $41903bc6f503885b$var$throwNoBignumber(x) {
    throw new Error("Cannot convert value ".concat(x, " into a BigNumber: no class 'BigNumber' provided"));
}
function $41903bc6f503885b$var$throwNoComplex(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Complex number: no class 'Complex' provided"));
}
function $41903bc6f503885b$var$throwNoMatrix() {
    throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function $41903bc6f503885b$var$throwNoFraction(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Fraction, no class 'Fraction' provided."));
}



var $cb2ce56b08d01187$var$name = "typeOf";
var $cb2ce56b08d01187$var$dependencies = [
    "typed"
];
var $cb2ce56b08d01187$export$d7acf116afef7b4d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($cb2ce56b08d01187$var$name, $cb2ce56b08d01187$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Determine the type of a variable.
   *
   * Function `typeOf` recognizes the following types of objects:
   *
   * Object                 | Returns       | Example
   * ---------------------- | ------------- | ------------------------------------------
   * null                   | `'null'`      | `math.typeOf(null)`
   * number                 | `'number'`    | `math.typeOf(3.5)`
   * boolean                | `'boolean'`   | `math.typeOf(true)`
   * string                 | `'string'`    | `math.typeOf('hello world')`
   * Array                  | `'Array'`     | `math.typeOf([1, 2, 3])`
   * Date                   | `'Date'`      | `math.typeOf(new Date())`
   * Function               | `'Function'`  | `math.typeOf(function () {})`
   * Object                 | `'Object'`    | `math.typeOf({a: 2, b: 3})`
   * RegExp                 | `'RegExp'`    | `math.typeOf(/a regexp/)`
   * undefined              | `'undefined'` | `math.typeOf(undefined)`
   * math.BigNumber         | `'BigNumber'` | `math.typeOf(math.bignumber('2.3e500'))`
   * math.Chain             | `'Chain'`     | `math.typeOf(math.chain(2))`
   * math.Complex           | `'Complex'`   | `math.typeOf(math.complex(2, 3))`
   * math.Fraction          | `'Fraction'`  | `math.typeOf(math.fraction(1, 3))`
   * math.Help              | `'Help'`      | `math.typeOf(math.help('sqrt'))`
   * math.Help              | `'Help'`      | `math.typeOf(math.help('sqrt'))`
   * math.Index             | `'Index'`     | `math.typeOf(math.index(1, 3))`
   * math.Matrix            | `'Matrix'`    | `math.typeOf(math.matrix([[1,2], [3, 4]]))`
   * math.Range             | `'Range'`     | `math.typeOf(math.range(0, 10))`
   * math.ResultSet         | `'ResultSet'` | `math.typeOf(math.evaluate('a=2\nb=3'))`
   * math.Unit              | `'Unit'`      | `math.typeOf(math.unit('45 deg'))`
   * math.AccessorNode            | `'AccessorNode'`            | `math.typeOf(math.parse('A[2]'))`
   * math.ArrayNode               | `'ArrayNode'`               | `math.typeOf(math.parse('[1,2,3]'))`
   * math.AssignmentNode          | `'AssignmentNode'`          | `math.typeOf(math.parse('x=2'))`
   * math.BlockNode               | `'BlockNode'`               | `math.typeOf(math.parse('a=2; b=3'))`
   * math.ConditionalNode         | `'ConditionalNode'`         | `math.typeOf(math.parse('x<0 ? -x : x'))`
   * math.ConstantNode            | `'ConstantNode'`            | `math.typeOf(math.parse('2.3'))`
   * math.FunctionAssignmentNode  | `'FunctionAssignmentNode'`  | `math.typeOf(math.parse('f(x)=x^2'))`
   * math.FunctionNode            | `'FunctionNode'`            | `math.typeOf(math.parse('sqrt(4)'))`
   * math.IndexNode               | `'IndexNode'`               | `math.typeOf(math.parse('A[2]').index)`
   * math.ObjectNode              | `'ObjectNode'`              | `math.typeOf(math.parse('{a:2}'))`
   * math.ParenthesisNode         | `'ParenthesisNode'`         | `math.typeOf(math.parse('(2+3)'))`
   * math.RangeNode               | `'RangeNode'`               | `math.typeOf(math.parse('1:10'))`
   * math.SymbolNode              | `'SymbolNode'`              | `math.typeOf(math.parse('x'))`
   *
   * Syntax:
   *
   *    math.typeOf(x)
   *
   * Examples:
   *
   *    math.typeOf(3.5)                     // returns 'number'
   *    math.typeOf(math.complex('2-4i'))    // returns 'Complex'
   *    math.typeOf(math.unit('45 deg'))     // returns 'Unit'
   *    math.typeOf('hello world')           // returns 'string'
   *
   * @param {*} x     The variable for which to test the type.
   * @return {string} Returns the name of the type. Primitive types are lower case,
   *                  non-primitive types are upper-camel-case.
   *                  For example 'number', 'string', 'Array', 'Date'.
   */ return typed($cb2ce56b08d01187$var$name, {
        any: (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)
    });
});




var $ff4d8ade2c8d9d49$var$name = "unaryMinus";
var $ff4d8ade2c8d9d49$var$dependencies = [
    "typed"
];
var $ff4d8ade2c8d9d49$export$939e1be6e134f392 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($ff4d8ade2c8d9d49$var$name, $ff4d8ade2c8d9d49$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Inverse the sign of a value, apply a unary minus operation.
   *
   * For matrices, the function is evaluated element wise. Boolean values and
   * strings will be converted to a number. For complex numbers, both real and
   * complex value are inverted.
   *
   * Syntax:
   *
   *    math.unaryMinus(x)
   *
   * Examples:
   *
   *    math.unaryMinus(3.5)      // returns -3.5
   *    math.unaryMinus(-4.2)     // returns 4.2
   *
   * See also:
   *
   *    add, subtract, unaryPlus
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Number to be inverted.
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Returns the value with inverted sign.
   */ return typed($ff4d8ade2c8d9d49$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$339666dc881be46b),
        Complex: function Complex(x) {
            return x.neg();
        },
        BigNumber: function BigNumber(x) {
            return x.neg();
        },
        Fraction: function Fraction(x) {
            return x.neg();
        },
        Unit: function Unit(x) {
            var res = x.clone();
            res.value = this(x.value);
            return res;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryMinus(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        } // TODO: add support for string
    });
});




var $158c2228ede227dc$var$name = "unaryPlus";
var $158c2228ede227dc$var$dependencies = [
    "typed",
    "config",
    "BigNumber"
];
var $158c2228ede227dc$export$cb425222dc08ff4e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($158c2228ede227dc$var$name, $158c2228ede227dc$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, BigNumber: BigNumber } = _ref;
    /**
   * Unary plus operation.
   * Boolean values and strings will be converted to a number, numeric values will be returned as is.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.unaryPlus(x)
   *
   * Examples:
   *
   *    math.unaryPlus(3.5)      // returns 3.5
   *    math.unaryPlus(1)     // returns 1
   *
   * See also:
   *
   *    unaryMinus, add, subtract
   *
   * @param  {number | BigNumber | Fraction | string | Complex | Unit | Array | Matrix} x
   *            Input value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns the input value when numeric, converts to a number when input is non-numeric.
   */ return typed($158c2228ede227dc$var$name, {
        number: (0, $08ae6b2eb4bd0049$export$da5b80d388a295fb),
        Complex: function Complex(x) {
            return x; // complex numbers are immutable
        },
        BigNumber: function BigNumber(x) {
            return x; // bignumbers are immutable
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Unit: function Unit(x) {
            return x.clone();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryPlus(0) = 0
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this, true);
        },
        "boolean | string": function booleanString(x) {
            // convert to a number or bignumber
            return config.number === "BigNumber" ? new BigNumber(+x) : +x;
        }
    });
});







var $c00f679dc7586e06$var$name = "unequal";
var $c00f679dc7586e06$var$dependencies = [
    "typed",
    "config",
    "equalScalar",
    "matrix",
    "DenseMatrix"
];
var $c00f679dc7586e06$export$833e6c382e279d04 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c00f679dc7586e06$var$name, $c00f679dc7586e06$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, equalScalar: equalScalar, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $49703efd2d98c69c$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether two values are unequal.
   *
   * The function tests whether the relative difference between x and y is
   * larger than the configured epsilon. The function cannot be used to compare
   * values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must unequal y.re, or x.im must unequal y.im.
   * Strings are compared by their numerical value.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is unequal
   * with everything except `null`, and `undefined` is unequal with everything
   * except `undefined`.
   *
   * Syntax:
   *
   *    math.unequal(x, y)
   *
   * Examples:
   *
   *    math.unequal(2 + 2, 3)       // returns true
   *    math.unequal(2 + 2, 4)       // returns false
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.unequal(a, b)           // returns false
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.unequal(c, d)           // returns [false, true, false]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.unequal(0, null)        // returns true
   * See also:
   *
   *    equal, deepEqual, smaller, smallerEq, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are unequal, else returns false
   */ return typed("unequal", {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return _unequal(x, y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, _unequal);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, _unequal, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, _unequal, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, _unequal);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, _unequal, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, _unequal, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, _unequal, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, _unequal, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, _unequal, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, _unequal, true).valueOf();
        }
    });
    function _unequal(x, y) {
        return !equalScalar(x, y);
    }
});
var $c00f679dc7586e06$export$b0b3dad01e54080b = (0, $a671619231063c2b$export$e9008f2713103c6c)($c00f679dc7586e06$var$name, [
    "typed",
    "equalScalar"
], (_ref2)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref2;
    return typed($c00f679dc7586e06$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return !equalScalar(x, y);
        }
    });
});


var $1209e17e2c23a854$exports = {};
var $8160f01d9a0efca9$exports = {};
var $821f3d756d79d648$exports = {};
function $821f3d756d79d648$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $821f3d756d79d648$exports = $821f3d756d79d648$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $821f3d756d79d648$exports.__esModule = true, $821f3d756d79d648$exports["default"] = $821f3d756d79d648$exports, $821f3d756d79d648$var$_typeof(o);
}
$821f3d756d79d648$exports = $821f3d756d79d648$var$_typeof, $821f3d756d79d648$exports.__esModule = true, $821f3d756d79d648$exports["default"] = $821f3d756d79d648$exports;


var $8160f01d9a0efca9$var$_typeof = $821f3d756d79d648$exports.default;
var $5fee45205841f0c9$exports = {};

var $5fee45205841f0c9$var$_typeof = $821f3d756d79d648$exports.default;
function $5fee45205841f0c9$var$toPrimitive(t, r) {
    if ("object" != $5fee45205841f0c9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5fee45205841f0c9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$5fee45205841f0c9$exports = $5fee45205841f0c9$var$toPrimitive, $5fee45205841f0c9$exports.__esModule = true, $5fee45205841f0c9$exports["default"] = $5fee45205841f0c9$exports;


function $8160f01d9a0efca9$var$toPropertyKey(t) {
    var i = $5fee45205841f0c9$exports(t, "string");
    return "symbol" == $8160f01d9a0efca9$var$_typeof(i) ? i : i + "";
}
$8160f01d9a0efca9$exports = $8160f01d9a0efca9$var$toPropertyKey, $8160f01d9a0efca9$exports.__esModule = true, $8160f01d9a0efca9$exports["default"] = $8160f01d9a0efca9$exports;


function $1209e17e2c23a854$var$_defineProperty(e, r, t) {
    return (r = $8160f01d9a0efca9$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$1209e17e2c23a854$exports = $1209e17e2c23a854$var$_defineProperty, $1209e17e2c23a854$exports.__esModule = true, $1209e17e2c23a854$exports["default"] = $1209e17e2c23a854$exports;








function $ff7711f29b636d73$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ff7711f29b636d73$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ff7711f29b636d73$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ff7711f29b636d73$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $ff7711f29b636d73$var$name = "Unit";
var $ff7711f29b636d73$var$dependencies = [
    "?on",
    "config",
    "addScalar",
    "subtract",
    "multiplyScalar",
    "divideScalar",
    "pow",
    "abs",
    "fix",
    "round",
    "equal",
    "isNumeric",
    "format",
    "number",
    "Complex",
    "BigNumber",
    "Fraction"
];
var $ff7711f29b636d73$export$3ad06557a3ac7a63 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($ff7711f29b636d73$var$name, $ff7711f29b636d73$var$dependencies, (_ref)=>{
    var { on: on, config: config, addScalar: addScalar, subtract: subtract, multiplyScalar: multiplyScalar, divideScalar: divideScalar, pow: pow, abs: abs, fix: fix, round: round, equal: equal, isNumeric: isNumeric, format: format, number: number, Complex: Complex, BigNumber: _BigNumber, Fraction: _Fraction } = _ref;
    var toNumber = number;
    /**
   * A unit can be constructed in the following ways:
   *
   *     const a = new Unit(value, name)
   *     const b = new Unit(null, name)
   *     const c = Unit.parse(str)
   *
   * Example usage:
   *
   *     const a = new Unit(5, 'cm')               // 50 mm
   *     const b = Unit.parse('23 kg')             // 23 kg
   *     const c = math.in(a, new Unit(null, 'm')  // 0.05 m
   *     const d = new Unit(9.81, "m/s^2")         // 9.81 m/s^2
   *
   * @class Unit
   * @constructor Unit
   * @param {number | BigNumber | Fraction | Complex | boolean} [value]  A value like 5.2
   * @param {string} [name]   A unit name like "cm" or "inch", or a derived unit of the form: "u1[^ex1] [u2[^ex2] ...] [/ u3[^ex3] [u4[^ex4]]]", such as "kg m^2/s^2", where each unit appearing after the forward slash is taken to be in the denominator. "kg m^2 s^-2" is a synonym and is also acceptable. Any of the units can include a prefix.
   */ function Unit(value, name) {
        if (!(this instanceof Unit)) throw new Error("Constructor must be called with the new operator");
        if (!(value === null || value === undefined || isNumeric(value) || (0, $2c4f948f17aa2240$export$8849a896711efe0c)(value))) throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
        if (name !== undefined && (typeof name !== "string" || name === "")) throw new TypeError("Second parameter in Unit constructor must be a string");
        if (name !== undefined) {
            var u = Unit.parse(name);
            this.units = u.units;
            this.dimensions = u.dimensions;
        } else {
            this.units = [
                {
                    unit: UNIT_NONE,
                    prefix: PREFIXES.NONE,
                    // link to a list with supported prefixes
                    power: 0
                }
            ];
            this.dimensions = [];
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)this.dimensions[i] = 0;
        }
        this.value = value !== undefined && value !== null ? this._normalize(value) : null;
        this.fixPrefix = false; // if true, function format will not search for the
        // best prefix but leave it as initially provided.
        // fixPrefix is set true by the method Unit.to
        // The justification behind this is that if the constructor is explicitly called,
        // the caller wishes the units to be returned exactly as he supplied.
        this.skipAutomaticSimplification = true;
    }
    /**
   * Attach type information
   */ Unit.prototype.type = "Unit";
    Unit.prototype.isUnit = true; // private variables and functions for the Unit parser
    var text, index, c;
    function skipWhitespace() {
        while(c === " " || c === "	")next();
    }
    function isDigitDot(c) {
        return c >= "0" && c <= "9" || c === ".";
    }
    function isDigit(c) {
        return c >= "0" && c <= "9";
    }
    function next() {
        index++;
        c = text.charAt(index);
    }
    function revert(oldIndex) {
        index = oldIndex;
        c = text.charAt(index);
    }
    function parseNumber() {
        var number = "";
        var oldIndex = index;
        if (c === "+") next();
        else if (c === "-") {
            number += c;
            next();
        }
        if (!isDigitDot(c)) {
            // a + or - must be followed by a digit
            revert(oldIndex);
            return null;
        } // get number, can have a single dot
        if (c === ".") {
            number += c;
            next();
            if (!isDigit(c)) {
                // this is no legal number, it is just a dot
                revert(oldIndex);
                return null;
            }
        } else {
            while(isDigit(c)){
                number += c;
                next();
            }
            if (c === ".") {
                number += c;
                next();
            }
        }
        while(isDigit(c)){
            number += c;
            next();
        } // check for exponential notation like "2.3e-4" or "1.23e50"
        if (c === "E" || c === "e") {
            // The grammar branches here. This could either be part of an exponent or the start of a unit that begins with the letter e, such as "4exabytes"
            var tentativeNumber = "";
            var tentativeIndex = index;
            tentativeNumber += c;
            next();
            if (c === "+" || c === "-") {
                tentativeNumber += c;
                next();
            } // Scientific notation MUST be followed by an exponent (otherwise we assume it is not scientific notation)
            if (!isDigit(c)) {
                // The e or E must belong to something else, so return the number without the e or E.
                revert(tentativeIndex);
                return number;
            } // We can now safely say that this is scientific notation.
            number = number + tentativeNumber;
            while(isDigit(c)){
                number += c;
                next();
            }
        }
        return number;
    }
    function parseUnit() {
        var unitName = ""; // Alphanumeric characters only; matches [a-zA-Z0-9]
        while(isDigit(c) || Unit.isValidAlpha(c)){
            unitName += c;
            next();
        } // Must begin with [a-zA-Z]
        var firstC = unitName.charAt(0);
        if (Unit.isValidAlpha(firstC)) return unitName;
        else return null;
    }
    function parseCharacter(toFind) {
        if (c === toFind) {
            next();
            return toFind;
        } else return null;
    }
    /**
   * Parse a string into a unit. The value of the unit is parsed as number,
   * BigNumber, or Fraction depending on the math.js config setting `number`.
   *
   * Throws an exception if the provided string does not contain a valid unit or
   * cannot be parsed.
   * @memberof Unit
   * @param {string} str        A string like "5.2 inch", "4e2 cm/s^2"
   * @return {Unit} unit
   */ Unit.parse = function(str, options) {
        options = options || {};
        text = str;
        index = -1;
        c = "";
        if (typeof text !== "string") throw new TypeError("Invalid argument in Unit.parse, string expected");
        var unit = new Unit();
        unit.units = [];
        var powerMultiplierCurrent = 1;
        var expectingUnit = false; // A unit should follow this pattern:
        // [number] ...[ [*/] unit[^number] ]
        // unit[^number] ... [ [*/] unit[^number] ]
        // Rules:
        // number is any floating point number.
        // unit is any alphanumeric string beginning with an alpha. Units with names like e3 should be avoided because they look like the exponent of a floating point number!
        // The string may optionally begin with a number.
        // Each unit may optionally be followed by ^number.
        // Whitespace or a forward slash is recommended between consecutive units, although the following technically is parseable:
        //   2m^2kg/s^2
        // it is not good form. If a unit starts with e, then it could be confused as a floating point number:
        //   4erg
        next();
        skipWhitespace(); // Optional number at the start of the string
        var valueStr = parseNumber();
        var value = null;
        if (valueStr) {
            if (config.number === "BigNumber") value = new _BigNumber(valueStr);
            else if (config.number === "Fraction") try {
                // not all numbers can be turned in Fractions, for example very small numbers not
                value = new _Fraction(valueStr);
            } catch (err) {
                value = parseFloat(valueStr);
            }
            else // number
            value = parseFloat(valueStr);
            skipWhitespace(); // Whitespace is not required here
            // handle multiplication or division right after the value, like '1/s'
            if (parseCharacter("*")) {
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter("/")) {
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            }
        } // Stack to keep track of powerMultipliers applied to each parentheses group
        var powerMultiplierStack = []; // Running product of all elements in powerMultiplierStack
        var powerMultiplierStackProduct = 1;
        while(true){
            skipWhitespace(); // Check for and consume opening parentheses, pushing powerMultiplierCurrent to the stack
            // A '(' will always appear directly before a unit.
            while(c === "("){
                powerMultiplierStack.push(powerMultiplierCurrent);
                powerMultiplierStackProduct *= powerMultiplierCurrent;
                powerMultiplierCurrent = 1;
                next();
                skipWhitespace();
            } // Is there something here?
            var uStr = void 0;
            if (c) {
                var oldC = c;
                uStr = parseUnit();
                if (uStr === null) throw new SyntaxError('Unexpected "' + oldC + '" in "' + text + '" at index ' + index.toString());
            } else break;
             // Verify the unit exists and get the prefix (if any)
            var res = _findUnit(uStr);
            if (res === null) // Unit not found.
            throw new SyntaxError('Unit "' + uStr + '" not found.');
            var power = powerMultiplierCurrent * powerMultiplierStackProduct; // Is there a "^ number"?
            skipWhitespace();
            if (parseCharacter("^")) {
                skipWhitespace();
                var p = parseNumber();
                if (p === null) // No valid number found for the power!
                throw new SyntaxError('In "' + str + '", "^" must be followed by a floating-point number');
                power *= p;
            } // Add the unit to the list
            unit.units.push({
                unit: res.unit,
                prefix: res.prefix,
                power: power
            });
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)unit.dimensions[i] += (res.unit.dimensions[i] || 0) * power;
             // Check for and consume closing parentheses, popping from the stack.
            // A ')' will always follow a unit.
            skipWhitespace();
            while(c === ")"){
                if (powerMultiplierStack.length === 0) throw new SyntaxError('Unmatched ")" in "' + text + '" at index ' + index.toString());
                powerMultiplierStackProduct /= powerMultiplierStack.pop();
                next();
                skipWhitespace();
            } // "*" and "/" should mean we are expecting something to come next.
            // Is there a forward slash? If so, negate powerMultiplierCurrent. The next unit or paren group is in the denominator.
            expectingUnit = false;
            if (parseCharacter("*")) {
                // explicit multiplication
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter("/")) {
                // division
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            } else // implicit multiplication
            powerMultiplierCurrent = 1;
             // Replace the unit into the auto unit system
            if (res.unit.base) {
                var baseDim = res.unit.base.key;
                UNIT_SYSTEMS.auto[baseDim] = {
                    unit: res.unit,
                    prefix: res.prefix
                };
            }
        } // Has the string been entirely consumed?
        skipWhitespace();
        if (c) throw new SyntaxError('Could not parse: "' + str + '"');
         // Is there a trailing slash?
        if (expectingUnit) throw new SyntaxError('Trailing characters: "' + str + '"');
         // Is the parentheses stack empty?
        if (powerMultiplierStack.length !== 0) throw new SyntaxError('Unmatched "(" in "' + text + '"');
         // Are there any units at all?
        if (unit.units.length === 0 && !options.allowNoUnits) throw new SyntaxError('"' + str + '" contains no units');
        unit.value = value !== undefined ? unit._normalize(value) : null;
        return unit;
    };
    /**
   * create a copy of this unit
   * @memberof Unit
   * @return {Unit} Returns a cloned version of the unit
   */ Unit.prototype.clone = function() {
        var unit = new Unit();
        unit.fixPrefix = this.fixPrefix;
        unit.skipAutomaticSimplification = this.skipAutomaticSimplification;
        unit.value = (0, $33619877a15996ac$export$9cd59f9826255e47)(this.value);
        unit.dimensions = this.dimensions.slice(0);
        unit.units = [];
        for(var i = 0; i < this.units.length; i++){
            unit.units[i] = {};
            for(var p in this.units[i])if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(this.units[i], p)) unit.units[i][p] = this.units[i][p];
        }
        return unit;
    };
    /**
   * Return whether the unit is derived (such as m/s, or cm^2, but not N)
   * @memberof Unit
   * @return {boolean} True if the unit is derived
   */ Unit.prototype._isDerived = function() {
        if (this.units.length === 0) return false;
        return this.units.length > 1 || Math.abs(this.units[0].power - 1.0) > 1e-15;
    };
    /**
   * Normalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number | BigNumber | Fraction | boolean} value
   * @return {number | BigNumber | Fraction | boolean} normalized value
   * @private
   */ Unit.prototype._normalize = function(value) {
        if (value === null || value === undefined || this.units.length === 0) return value;
        var res = value;
        var convert = Unit._getNumberConverter((0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(value)); // convert to Fraction or BigNumber if needed
        for(var i = 0; i < this.units.length; i++){
            var unitValue = convert(this.units[i].unit.value);
            var unitPrefixValue = convert(this.units[i].prefix.value);
            var unitPower = convert(this.units[i].power);
            res = multiplyScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
        }
        return res;
    };
    /**
   * Denormalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number} value
   * @param {number} [prefixValue]    Optional prefix value to be used (ignored if this is a derived unit)
   * @return {number} denormalized value
   * @private
   */ Unit.prototype._denormalize = function(value, prefixValue) {
        if (value === null || value === undefined || this.units.length === 0) return value;
        var res = value;
        var convert = Unit._getNumberConverter((0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(value)); // convert to Fraction or BigNumber if needed
        for(var i = 0; i < this.units.length; i++){
            var unitValue = convert(this.units[i].unit.value);
            var unitPrefixValue = convert(this.units[i].prefix.value);
            var unitPower = convert(this.units[i].power);
            res = divideScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
        }
        return res;
    };
    /**
   * Find a unit from a string
   * @memberof Unit
   * @param {string} str              A string like 'cm' or 'inch'
   * @returns {Object | null} result  When found, an object with fields unit and
   *                                  prefix is returned. Else, null is returned.
   * @private
   */ var _findUnit = (0, $43b7a970faec5d37$export$fc10aeed3a532e2a)((str)=>{
        // First, match units names exactly. For example, a user could define 'mm' as 10^-4 m, which is silly, but then we would want 'mm' to match the user-defined unit.
        if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(UNITS, str)) {
            var unit = UNITS[str];
            var prefix = unit.prefixes[""];
            return {
                unit: unit,
                prefix: prefix
            };
        }
        for(var _name in UNITS){
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(UNITS, _name)) {
                if ((0, $addf7cb66573d3e4$export$10fdab3683b55b22)(str, _name)) {
                    var _unit = UNITS[_name];
                    var prefixLen = str.length - _name.length;
                    var prefixName = str.substring(0, prefixLen);
                    var _prefix = (0, $33619877a15996ac$export$5a15a386532a5ea4)(_unit.prefixes, prefixName) ? _unit.prefixes[prefixName] : undefined;
                    if (_prefix !== undefined) // store unit, prefix, and value
                    return {
                        unit: _unit,
                        prefix: _prefix
                    };
                }
            }
        }
        return null;
    }, {
        hasher: (args)=>args[0],
        limit: 100
    });
    /**
   * Test if the given expression is a unit.
   * The unit can have a prefix but cannot have a value.
   * @memberof Unit
   * @param {string} name   A string to be tested whether it is a value less unit.
   *                        The unit can have prefix, like "cm"
   * @return {boolean}      true if the given string is a unit
   */ Unit.isValuelessUnit = function(name) {
        return _findUnit(name) !== null;
    };
    /**
   * check if this unit has given base unit
   * If this unit is a derived unit, this will ALWAYS return false, since by definition base units are not derived.
   * @memberof Unit
   * @param {BASE_UNITS | string | undefined} base
   */ Unit.prototype.hasBase = function(base) {
        if (typeof base === "string") base = BASE_UNITS[base];
        if (!base) return false;
         // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (base.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit has a base or bases equal to another base or bases
   * For derived units, the exponent on each base also must match
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if equal base
   */ Unit.prototype.equalBase = function(other) {
        // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (other.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit equals another unit
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if both units are equal
   */ Unit.prototype.equals = function(other) {
        return this.equalBase(other) && equal(this.value, other.value);
    };
    /**
   * Multiply this unit with another one
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} product of this unit and the other unit
   */ Unit.prototype.multiply = function(other) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) + (other.dimensions[i] || 0);
         // Append other's units list onto res
        for(var _i = 0; _i < other.units.length; _i++){
            // Make a shallow copy of every unit
            var inverted = $ff7711f29b636d73$var$_objectSpread({}, other.units[_i]);
            res.units.push(inverted);
        } // If at least one operand has a value, then the result should also have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = multiplyScalar(valThis, valOther);
        } else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Divide this unit by another one
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} result of dividing this unit by the other unit
   */ Unit.prototype.divide = function(other) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) - (other.dimensions[i] || 0);
         // Invert and append other's units list onto res
        for(var _i2 = 0; _i2 < other.units.length; _i2++){
            // Make a shallow copy of every unit
            var inverted = $ff7711f29b636d73$var$_objectSpread($ff7711f29b636d73$var$_objectSpread({}, other.units[_i2]), {}, {
                power: -other.units[_i2].power
            });
            res.units.push(inverted);
        } // If at least one operand has a value, the result should have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = divideScalar(valThis, valOther);
        } else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Calculate the power of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} p
   * @returns {Unit}      The result: this^p
   */ Unit.prototype.pow = function(p) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) * p;
         // Adjust the power of each unit in the list
        for(var _i3 = 0; _i3 < res.units.length; _i3++)res.units[_i3].power *= p;
        if (res.value !== null) res.value = pow(res.value, p); // only allow numeric output, we don't want to return a Complex number
        else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Return the numeric value of this unit if it is dimensionless, has a value, and config.predictable == false; or the original unit otherwise
   * @param {Unit} unit
   * @returns {number | Fraction | BigNumber | Unit}  The numeric value of the unit if conditions are met, or the original unit otherwise
   */ function getNumericIfUnitless(unit) {
        if (unit.equalBase(BASE_UNITS.NONE) && unit.value !== null && !config.predictable) return unit.value;
        else return unit;
    }
    /**
   * Calculate the absolute value of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} x
   * @returns {Unit}      The result: |x|, absolute value of x
   */ Unit.prototype.abs = function() {
        var ret = this.clone();
        if (ret.value !== null) {
            if (ret._isDerived() || ret.units[0].unit.offset === 0) ret.value = abs(ret.value);
            else {
                // To give the correct, but unexpected, results for units with an offset.
                // For example, abs(-283.15 degC) = -263.15 degC !!!
                // We must take the offset into consideration here
                var convert = Unit._getNumberConverter((0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(ret.value)); // convert to Fraction or BigNumber if needed
                var unitValue = convert(ret.units[0].unit.value);
                var nominalOffset = convert(ret.units[0].unit.offset);
                var unitOffset = multiplyScalar(unitValue, nominalOffset);
                ret.value = subtract(abs(addScalar(ret.value, unitOffset)), unitOffset);
            }
        }
        for(var i in ret.units)if (ret.units[i].unit.name === "VA" || ret.units[i].unit.name === "VAR") ret.units[i].unit = UNITS.W;
        return ret;
    };
    /**
   * Convert the unit to a specific unit name.
   * @memberof Unit
   * @param {string | Unit} valuelessUnit   A unit without value. Can have prefix, like "cm"
   * @returns {Unit} Returns a clone of the unit with a fixed prefix and unit.
   */ Unit.prototype.to = function(valuelessUnit) {
        var value = this.value === null ? this._normalize(1) : this.value;
        var other;
        if (typeof valuelessUnit === "string") other = Unit.parse(valuelessUnit);
        else if ((0, $2c4f948f17aa2240$export$8960dc335987b8da)(valuelessUnit)) other = valuelessUnit.clone();
        else throw new Error("String or Unit expected as parameter");
        if (!this.equalBase(other)) throw new Error("Units do not match ('".concat(other.toString(), "' != '").concat(this.toString(), "')"));
        if (other.value !== null) throw new Error("Cannot convert to a unit with a value");
        if (this.value === null || this._isDerived() || this.units[0].unit.offset === other.units[0].unit.offset) other.value = (0, $33619877a15996ac$export$9cd59f9826255e47)(value);
        else {
            /* Need to adjust value by difference in offset to convert */ var convert = Unit._getNumberConverter((0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(value)); // convert to Fraction or BigNumber if needed
            var thisUnitValue = convert(this.units[0].unit.value);
            var thisNominalOffset = convert(this.units[0].unit.offset);
            var thisUnitOffset = multiplyScalar(thisUnitValue, thisNominalOffset);
            var otherUnitValue = convert(other.units[0].unit.value);
            var otherNominalOffset = convert(other.units[0].unit.offset);
            var otherUnitOffset = multiplyScalar(otherUnitValue, otherNominalOffset);
            other.value = subtract(addScalar(value, thisUnitOffset), otherUnitOffset);
        }
        other.fixPrefix = true;
        other.skipAutomaticSimplification = true;
        return other;
    };
    /**
   * Return the value of the unit when represented with given valueless unit
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number} Returns the unit value as number.
   */ // TODO: deprecate Unit.toNumber? It's always better to use toNumeric
    Unit.prototype.toNumber = function(valuelessUnit) {
        return toNumber(this.toNumeric(valuelessUnit));
    };
    /**
   * Return the value of the unit in the original numeric type
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number | BigNumber | Fraction} Returns the unit value
   */ Unit.prototype.toNumeric = function(valuelessUnit) {
        var other;
        if (valuelessUnit) // Allow getting the numeric value without converting to a different unit
        other = this.to(valuelessUnit);
        else other = this.clone();
        if (other._isDerived() || other.units.length === 0) return other._denormalize(other.value);
        else return other._denormalize(other.value, other.units[0].prefix.value);
    };
    /**
   * Get a string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the unit
   * @memberof Unit
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   */ Unit.prototype.toJSON = function() {
        return {
            mathjs: "Unit",
            value: this._denormalize(this.value),
            unit: this.formatUnits(),
            fixPrefix: this.fixPrefix
        };
    };
    /**
   * Instantiate a Unit from a JSON object
   * @memberof Unit
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   * @return {Unit}
   */ Unit.fromJSON = function(json) {
        var unit = new Unit(json.value, json.unit);
        unit.fixPrefix = json.fixPrefix || false;
        return unit;
    };
    /**
   * Returns the string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.valueOf = Unit.prototype.toString;
    /**
   * Simplify this Unit's unit list and return a new Unit with the simplified list.
   * The returned Unit will contain a list of the "best" units for formatting.
   */ Unit.prototype.simplify = function() {
        var ret = this.clone();
        var proposedUnitList = []; // Search for a matching base
        var matchingBase;
        for(var key in currentUnitSystem){
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(currentUnitSystem, key)) {
                if (ret.hasBase(BASE_UNITS[key])) {
                    matchingBase = key;
                    break;
                }
            }
        }
        if (matchingBase === "NONE") ret.units = [];
        else {
            var matchingUnit;
            if (matchingBase) // Does the unit system have a matching unit?
            {
                if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(currentUnitSystem, matchingBase)) matchingUnit = currentUnitSystem[matchingBase];
            }
            if (matchingUnit) ret.units = [
                {
                    unit: matchingUnit.unit,
                    prefix: matchingUnit.prefix,
                    power: 1.0
                }
            ];
            else {
                // Multiple units or units with powers are formatted like this:
                // 5 (kg m^2) / (s^3 mol)
                // Build an representation from the base units of the current unit system
                var missingBaseDim = false;
                for(var i = 0; i < BASE_DIMENSIONS.length; i++){
                    var baseDim = BASE_DIMENSIONS[i];
                    if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                        if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(currentUnitSystem, baseDim)) proposedUnitList.push({
                            unit: currentUnitSystem[baseDim].unit,
                            prefix: currentUnitSystem[baseDim].prefix,
                            power: ret.dimensions[i] || 0
                        });
                        else missingBaseDim = true;
                    }
                } // Is the proposed unit list "simpler" than the existing one?
                if (proposedUnitList.length < ret.units.length && !missingBaseDim) // Replace this unit list with the proposed list
                ret.units = proposedUnitList;
            }
        }
        return ret;
    };
    /**
   * Returns a new Unit in the SI system with the same value as this one
   */ Unit.prototype.toSI = function() {
        var ret = this.clone();
        var proposedUnitList = []; // Multiple units or units with powers are formatted like this:
        // 5 (kg m^2) / (s^3 mol)
        // Build an representation from the base units of the SI unit system
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            var baseDim = BASE_DIMENSIONS[i];
            if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(UNIT_SYSTEMS.si, baseDim)) proposedUnitList.push({
                    unit: UNIT_SYSTEMS.si[baseDim].unit,
                    prefix: UNIT_SYSTEMS.si[baseDim].prefix,
                    power: ret.dimensions[i] || 0
                });
                else throw new Error("Cannot express custom unit " + baseDim + " in SI units");
            }
        } // Replace this unit list with the proposed list
        ret.units = proposedUnitList;
        ret.fixPrefix = true;
        ret.skipAutomaticSimplification = true;
        return ret;
    };
    /**
   * Get a string representation of the units of this Unit, without the value. The unit list is formatted as-is without first being simplified.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.formatUnits = function() {
        var strNum = "";
        var strDen = "";
        var nNum = 0;
        var nDen = 0;
        for(var i = 0; i < this.units.length; i++){
            if (this.units[i].power > 0) {
                nNum++;
                strNum += " " + this.units[i].prefix.name + this.units[i].unit.name;
                if (Math.abs(this.units[i].power - 1.0) > 1e-15) strNum += "^" + this.units[i].power;
            } else if (this.units[i].power < 0) nDen++;
        }
        if (nDen > 0) {
            for(var _i4 = 0; _i4 < this.units.length; _i4++)if (this.units[_i4].power < 0) {
                if (nNum > 0) {
                    strDen += " " + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    if (Math.abs(this.units[_i4].power + 1.0) > 1e-15) strDen += "^" + -this.units[_i4].power;
                } else {
                    strDen += " " + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    strDen += "^" + this.units[_i4].power;
                }
            }
        } // Remove leading " "
        strNum = strNum.substr(1);
        strDen = strDen.substr(1); // Add parans for better copy/paste back into evaluate, for example, or for better pretty print formatting
        if (nNum > 1 && nDen > 0) strNum = "(" + strNum + ")";
        if (nDen > 1 && nNum > 0) strDen = "(" + strDen + ")";
        var str = strNum;
        if (nNum > 0 && nDen > 0) str += " / ";
        str += strDen;
        return str;
    };
    /**
   * Get a string representation of the Unit, with optional formatting options.
   * @memberof Unit
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string}
   */ Unit.prototype.format = function(options) {
        // Simplfy the unit list, unless it is valueless or was created directly in the
        // constructor or as the result of to or toSI
        var simp = this.skipAutomaticSimplification || this.value === null ? this.clone() : this.simplify(); // Apply some custom logic for handling VA and VAR. The goal is to express the value of the unit as a real value, if possible. Otherwise, use a real-valued unit instead of a complex-valued one.
        var isImaginary = false;
        if (typeof simp.value !== "undefined" && simp.value !== null && (0, $2c4f948f17aa2240$export$8849a896711efe0c)(simp.value)) // TODO: Make this better, for example, use relative magnitude of re and im rather than absolute
        isImaginary = Math.abs(simp.value.re) < 1e-14;
        for(var i in simp.units){
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(simp.units, i)) {
                if (simp.units[i].unit) {
                    if (simp.units[i].unit.name === "VA" && isImaginary) simp.units[i].unit = UNITS.VAR;
                    else if (simp.units[i].unit.name === "VAR" && !isImaginary) simp.units[i].unit = UNITS.VA;
                }
            }
        } // Now apply the best prefix
        // Units must have only one unit and not have the fixPrefix flag set
        if (simp.units.length === 1 && !simp.fixPrefix) // Units must have integer powers, otherwise the prefix will change the
        // outputted value by not-an-integer-power-of-ten
        {
            if (Math.abs(simp.units[0].power - Math.round(simp.units[0].power)) < 1e-14) // Apply the best prefix
            simp.units[0].prefix = simp._bestPrefix();
        }
        var value = simp._denormalize(simp.value);
        var str = simp.value !== null ? format(value, options || {}) : "";
        var unitStr = simp.formatUnits();
        if (simp.value && (0, $2c4f948f17aa2240$export$8849a896711efe0c)(simp.value)) str = "(" + str + ")"; // Surround complex values with ( ) to enable better parsing
        if (unitStr.length > 0 && str.length > 0) str += " ";
        str += unitStr;
        return str;
    };
    /**
   * Calculate the best prefix using current value.
   * @memberof Unit
   * @returns {Object} prefix
   * @private
   */ Unit.prototype._bestPrefix = function() {
        if (this.units.length !== 1) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
        if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
         // find the best prefix value (resulting in the value of which
        // the absolute value of the log10 is closest to zero,
        // though with a little offset of 1.2 for nicer values: you get a
        // sequence 1mm 100mm 500mm 0.6m 1m 10m 100m 500m 0.6km 1km ...
        // Note: the units value can be any numeric type, but to find the best
        // prefix it's enough to work with limited precision of a regular number
        // Update: using mathjs abs since we also allow complex numbers
        var absValue = this.value !== null ? abs(this.value) : 0;
        var absUnitValue = abs(this.units[0].unit.value);
        var bestPrefix = this.units[0].prefix;
        if (absValue === 0) return bestPrefix;
        var power = this.units[0].power;
        var bestDiff = Math.log(absValue / Math.pow(bestPrefix.value * absUnitValue, power)) / Math.LN10 - 1.2;
        if (bestDiff > -2.200001 && bestDiff < 1.800001) return bestPrefix; // Allow the original prefix
        bestDiff = Math.abs(bestDiff);
        var prefixes = this.units[0].unit.prefixes;
        for(var p in prefixes)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(prefixes, p)) {
            var prefix = prefixes[p];
            if (prefix.scientific) {
                var diff = Math.abs(Math.log(absValue / Math.pow(prefix.value * absUnitValue, power)) / Math.LN10 - 1.2);
                if (diff < bestDiff || diff === bestDiff && prefix.name.length < bestPrefix.name.length) {
                    // choose the prefix with the smallest diff, or if equal, choose the one
                    // with the shortest name (can happen with SHORTLONG for example)
                    bestPrefix = prefix;
                    bestDiff = diff;
                }
            }
        }
        return bestPrefix;
    };
    /**
   * Returns an array of units whose sum is equal to this unit
   * @memberof Unit
   * @param {Array} [parts] An array of strings or valueless units.
   *
   *   Example:
   *
   *   const u = new Unit(1, 'm')
   *   u.splitUnit(['feet', 'inch'])
   *     [ 3 feet, 3.3700787401575 inch ]
   *
   * @return {Array} An array of units.
   */ Unit.prototype.splitUnit = function(parts) {
        var x = this.clone();
        var ret = [];
        for(var i = 0; i < parts.length; i++){
            // Convert x to the requested unit
            x = x.to(parts[i]);
            if (i === parts.length - 1) break; // Get the numeric value of this unit
            var xNumeric = x.toNumeric(); // Check to see if xNumeric is nearly equal to an integer,
            // since fix can incorrectly round down if there is round-off error
            var xRounded = round(xNumeric);
            var xFixed = void 0;
            var isNearlyEqual = equal(xRounded, xNumeric);
            if (isNearlyEqual) xFixed = xRounded;
            else xFixed = fix(x.toNumeric());
            var y = new Unit(xFixed, parts[i].toString());
            ret.push(y);
            x = subtract(x, y);
        } // This little bit fixes a bug where the remainder should be 0 but is a little bit off.
        // But instead of comparing x, the remainder, with zero--we will compare the sum of
        // all the parts so far with the original value. If they are nearly equal,
        // we set the remainder to 0.
        var testSum = 0;
        for(var _i5 = 0; _i5 < ret.length; _i5++)testSum = addScalar(testSum, ret[_i5].value);
        if (equal(testSum, this.value)) x.value = 0;
        ret.push(x);
        return ret;
    };
    var PREFIXES = {
        NONE: {
            "": {
                name: "",
                value: 1,
                scientific: true
            }
        },
        SHORT: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e1,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e2,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e3,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e6,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e9,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e12,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e15,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e18,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e21,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e24,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-1,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-2,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-3,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-6,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-9,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-12,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-15,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-18,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-21,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-24,
                scientific: true
            }
        },
        LONG: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            deca: {
                name: "deca",
                value: 1e1,
                scientific: false
            },
            hecto: {
                name: "hecto",
                value: 1e2,
                scientific: false
            },
            kilo: {
                name: "kilo",
                value: 1e3,
                scientific: true
            },
            mega: {
                name: "mega",
                value: 1e6,
                scientific: true
            },
            giga: {
                name: "giga",
                value: 1e9,
                scientific: true
            },
            tera: {
                name: "tera",
                value: 1e12,
                scientific: true
            },
            peta: {
                name: "peta",
                value: 1e15,
                scientific: true
            },
            exa: {
                name: "exa",
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: "zetta",
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: "yotta",
                value: 1e24,
                scientific: true
            },
            deci: {
                name: "deci",
                value: 1e-1,
                scientific: false
            },
            centi: {
                name: "centi",
                value: 1e-2,
                scientific: false
            },
            milli: {
                name: "milli",
                value: 1e-3,
                scientific: true
            },
            micro: {
                name: "micro",
                value: 1e-6,
                scientific: true
            },
            nano: {
                name: "nano",
                value: 1e-9,
                scientific: true
            },
            pico: {
                name: "pico",
                value: 1e-12,
                scientific: true
            },
            femto: {
                name: "femto",
                value: 1e-15,
                scientific: true
            },
            atto: {
                name: "atto",
                value: 1e-18,
                scientific: true
            },
            zepto: {
                name: "zepto",
                value: 1e-21,
                scientific: true
            },
            yocto: {
                name: "yocto",
                value: 1e-24,
                scientific: true
            }
        },
        SQUARED: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e2,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e4,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e6,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e12,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e18,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e24,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e30,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e36,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e42,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e48,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-2,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-4,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-6,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-12,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-18,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-24,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-30,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-36,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-42,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-48,
                scientific: true
            }
        },
        CUBIC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e3,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e6,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e9,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e18,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e27,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e36,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e45,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e54,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e63,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e72,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-3,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-6,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-9,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-18,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-27,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-36,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-45,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-54,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-63,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-72,
                scientific: true
            }
        },
        BINARY_SHORT_SI: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            k: {
                name: "k",
                value: 1e3,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e6,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e9,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e12,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e15,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e18,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e21,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e24,
                scientific: true
            }
        },
        BINARY_SHORT_IEC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            Ki: {
                name: "Ki",
                value: 1024,
                scientific: true
            },
            Mi: {
                name: "Mi",
                value: Math.pow(1024, 2),
                scientific: true
            },
            Gi: {
                name: "Gi",
                value: Math.pow(1024, 3),
                scientific: true
            },
            Ti: {
                name: "Ti",
                value: Math.pow(1024, 4),
                scientific: true
            },
            Pi: {
                name: "Pi",
                value: Math.pow(1024, 5),
                scientific: true
            },
            Ei: {
                name: "Ei",
                value: Math.pow(1024, 6),
                scientific: true
            },
            Zi: {
                name: "Zi",
                value: Math.pow(1024, 7),
                scientific: true
            },
            Yi: {
                name: "Yi",
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BINARY_LONG_SI: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            kilo: {
                name: "kilo",
                value: 1e3,
                scientific: true
            },
            mega: {
                name: "mega",
                value: 1e6,
                scientific: true
            },
            giga: {
                name: "giga",
                value: 1e9,
                scientific: true
            },
            tera: {
                name: "tera",
                value: 1e12,
                scientific: true
            },
            peta: {
                name: "peta",
                value: 1e15,
                scientific: true
            },
            exa: {
                name: "exa",
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: "zetta",
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: "yotta",
                value: 1e24,
                scientific: true
            }
        },
        BINARY_LONG_IEC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            kibi: {
                name: "kibi",
                value: 1024,
                scientific: true
            },
            mebi: {
                name: "mebi",
                value: Math.pow(1024, 2),
                scientific: true
            },
            gibi: {
                name: "gibi",
                value: Math.pow(1024, 3),
                scientific: true
            },
            tebi: {
                name: "tebi",
                value: Math.pow(1024, 4),
                scientific: true
            },
            pebi: {
                name: "pebi",
                value: Math.pow(1024, 5),
                scientific: true
            },
            exi: {
                name: "exi",
                value: Math.pow(1024, 6),
                scientific: true
            },
            zebi: {
                name: "zebi",
                value: Math.pow(1024, 7),
                scientific: true
            },
            yobi: {
                name: "yobi",
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BTU: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            MM: {
                name: "MM",
                value: 1e6,
                scientific: true
            }
        }
    };
    PREFIXES.SHORTLONG = (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))({}, PREFIXES.SHORT, PREFIXES.LONG);
    PREFIXES.BINARY_SHORT = (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))({}, PREFIXES.BINARY_SHORT_SI, PREFIXES.BINARY_SHORT_IEC);
    PREFIXES.BINARY_LONG = (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))({}, PREFIXES.BINARY_LONG_SI, PREFIXES.BINARY_LONG_IEC);
    /* Internally, each unit is represented by a value and a dimension array. The elements of the dimensions array have the following meaning:
   * Index  Dimension
   * -----  ---------
   *   0    Length
   *   1    Mass
   *   2    Time
   *   3    Current
   *   4    Temperature
   *   5    Luminous intensity
   *   6    Amount of substance
   *   7    Angle
   *   8    Bit (digital)
   * For example, the unit "298.15 K" is a pure temperature and would have a value of 298.15 and a dimension array of [0, 0, 0, 0, 1, 0, 0, 0, 0]. The unit "1 cal / (gm °C)" can be written in terms of the 9 fundamental dimensions as [length^2] / ([time^2] * [temperature]), and would a value of (after conversion to SI) 4184.0 and a dimensions array of [2, 0, -2, 0, -1, 0, 0, 0, 0].
   *
   */ var BASE_DIMENSIONS = [
        "MASS",
        "LENGTH",
        "TIME",
        "CURRENT",
        "TEMPERATURE",
        "LUMINOUS_INTENSITY",
        "AMOUNT_OF_SUBSTANCE",
        "ANGLE",
        "BIT"
    ];
    var BASE_UNITS = {
        NONE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MASS: {
            dimensions: [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        LENGTH: {
            dimensions: [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TIME: {
            dimensions: [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        CURRENT: {
            dimensions: [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TEMPERATURE: {
            dimensions: [
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0
            ]
        },
        LUMINOUS_INTENSITY: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0
            ]
        },
        AMOUNT_OF_SUBSTANCE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0
            ]
        },
        FORCE: {
            dimensions: [
                1,
                1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        SURFACE: {
            dimensions: [
                0,
                2,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        VOLUME: {
            dimensions: [
                0,
                3,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ENERGY: {
            dimensions: [
                1,
                2,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        POWER: {
            dimensions: [
                1,
                2,
                -3,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        PRESSURE: {
            dimensions: [
                1,
                -1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CHARGE: {
            dimensions: [
                0,
                0,
                1,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CAPACITANCE: {
            dimensions: [
                -1,
                -2,
                4,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_POTENTIAL: {
            dimensions: [
                1,
                2,
                -3,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_RESISTANCE: {
            dimensions: [
                1,
                2,
                -3,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_INDUCTANCE: {
            dimensions: [
                1,
                2,
                -2,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CONDUCTANCE: {
            dimensions: [
                -1,
                -2,
                3,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX: {
            dimensions: [
                1,
                2,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX_DENSITY: {
            dimensions: [
                1,
                0,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        FREQUENCY: {
            dimensions: [
                0,
                0,
                -1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ANGLE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]
        },
        BIT: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ]
        }
    };
    for(var key in BASE_UNITS)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(BASE_UNITS, key)) BASE_UNITS[key].key = key;
    var BASE_UNIT_NONE = {};
    var UNIT_NONE = {
        name: "",
        base: BASE_UNIT_NONE,
        value: 1,
        offset: 0,
        dimensions: BASE_DIMENSIONS.map((x)=>0)
    };
    var UNITS = {
        // length
        meter: {
            name: "meter",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        inch: {
            name: "inch",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        foot: {
            name: "foot",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yard: {
            name: "yard",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mile: {
            name: "mile",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        link: {
            name: "link",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rod: {
            name: "rod",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.0292,
            offset: 0
        },
        chain: {
            name: "chain",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        angstrom: {
            name: "angstrom",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1e-10,
            offset: 0
        },
        m: {
            name: "m",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        in: {
            name: "in",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        ft: {
            name: "ft",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yd: {
            name: "yd",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mi: {
            name: "mi",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        li: {
            name: "li",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rd: {
            name: "rd",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.029210,
            offset: 0
        },
        ch: {
            name: "ch",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        mil: {
            name: "mil",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0000254,
            offset: 0
        },
        // 1/1000 inch
        // Surface
        m2: {
            name: "m2",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.SQUARED,
            value: 1,
            offset: 0
        },
        sqin: {
            name: "sqin",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.00064516,
            offset: 0
        },
        // 645.16 mm2
        sqft: {
            name: "sqft",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.09290304,
            offset: 0
        },
        // 0.09290304 m2
        sqyd: {
            name: "sqyd",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.83612736,
            offset: 0
        },
        // 0.83612736 m2
        sqmi: {
            name: "sqmi",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 2589988.110336,
            offset: 0
        },
        // 2.589988110336 km2
        sqrd: {
            name: "sqrd",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 25.29295,
            offset: 0
        },
        // 25.29295 m2
        sqch: {
            name: "sqch",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 404.6873,
            offset: 0
        },
        // 404.6873 m2
        sqmil: {
            name: "sqmil",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 6.4516e-10,
            offset: 0
        },
        // 6.4516 * 10^-10 m2
        acre: {
            name: "acre",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 4046.86,
            offset: 0
        },
        // 4046.86 m2
        hectare: {
            name: "hectare",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 10000,
            offset: 0
        },
        // 10000 m2
        // Volume
        m3: {
            name: "m3",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.CUBIC,
            value: 1,
            offset: 0
        },
        L: {
            name: "L",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        l: {
            name: "l",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        litre: {
            name: "litre",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        cuin: {
            name: "cuin",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1.6387064e-5,
            offset: 0
        },
        // 1.6387064e-5 m3
        cuft: {
            name: "cuft",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.028316846592,
            offset: 0
        },
        // 28.316 846 592 L
        cuyd: {
            name: "cuyd",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.764554857984,
            offset: 0
        },
        // 764.554 857 984 L
        teaspoon: {
            name: "teaspoon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000005,
            offset: 0
        },
        // 5 mL
        tablespoon: {
            name: "tablespoon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000015,
            offset: 0
        },
        // 15 mL
        // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
        drop: {
            name: "drop",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        gtt: {
            name: "gtt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        // Liquid volume
        minim: {
            name: "minim",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00000006161152,
            offset: 0
        },
        // 0.06161152 mL
        fluiddram: {
            name: "fluiddram",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911,
            offset: 0
        },
        // 3.696691 mL
        fluidounce: {
            name: "fluidounce",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00002957353,
            offset: 0
        },
        // 29.57353 mL
        gill: {
            name: "gill",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0001182941,
            offset: 0
        },
        // 118.2941 mL
        cc: {
            name: "cc",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1e-6,
            offset: 0
        },
        // 1e-6 L
        cup: {
            name: "cup",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882,
            offset: 0
        },
        // 236.5882 mL
        pint: {
            name: "pint",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0004731765,
            offset: 0
        },
        // 473.1765 mL
        quart: {
            name: "quart",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0009463529,
            offset: 0
        },
        // 946.3529 mL
        gallon: {
            name: "gallon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785412,
            offset: 0
        },
        // 3.785412 L
        beerbarrel: {
            name: "beerbarrel",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1173478,
            offset: 0
        },
        // 117.3478 L
        oilbarrel: {
            name: "oilbarrel",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1589873,
            offset: 0
        },
        // 158.9873 L
        hogshead: {
            name: "hogshead",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.2384810,
            offset: 0
        },
        // 238.4810 L
        // {name: 'min', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.00000006161152, offset: 0}, // 0.06161152 mL // min is already in use as minute
        fldr: {
            name: "fldr",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911,
            offset: 0
        },
        // 3.696691 mL
        floz: {
            name: "floz",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00002957353,
            offset: 0
        },
        // 29.57353 mL
        gi: {
            name: "gi",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0001182941,
            offset: 0
        },
        // 118.2941 mL
        cp: {
            name: "cp",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882,
            offset: 0
        },
        // 236.5882 mL
        pt: {
            name: "pt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0004731765,
            offset: 0
        },
        // 473.1765 mL
        qt: {
            name: "qt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0009463529,
            offset: 0
        },
        // 946.3529 mL
        gal: {
            name: "gal",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785412,
            offset: 0
        },
        // 3.785412 L
        bbl: {
            name: "bbl",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1173478,
            offset: 0
        },
        // 117.3478 L
        obl: {
            name: "obl",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1589873,
            offset: 0
        },
        // 158.9873 L
        // {name: 'hogshead', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.2384810, offset: 0}, // 238.4810 L // TODO: hh?
        // Mass
        g: {
            name: "g",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        gram: {
            name: "gram",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        ton: {
            name: "ton",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 907.18474,
            offset: 0
        },
        t: {
            name: "t",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 1000,
            offset: 0
        },
        tonne: {
            name: "tonne",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 1000,
            offset: 0
        },
        grain: {
            name: "grain",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dram: {
            name: "dram",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        ounce: {
            name: "ounce",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        poundmass: {
            name: "poundmass",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        hundredweight: {
            name: "hundredweight",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        stick: {
            name: "stick",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 115e-3,
            offset: 0
        },
        stone: {
            name: "stone",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 6.35029318,
            offset: 0
        },
        gr: {
            name: "gr",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dr: {
            name: "dr",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        oz: {
            name: "oz",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        lbm: {
            name: "lbm",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        cwt: {
            name: "cwt",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        // Time
        s: {
            name: "s",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        min: {
            name: "min",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        h: {
            name: "h",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        second: {
            name: "second",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        sec: {
            name: "sec",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        minute: {
            name: "minute",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        hour: {
            name: "hour",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        day: {
            name: "day",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 86400,
            offset: 0
        },
        week: {
            name: "week",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 604800,
            offset: 0
        },
        month: {
            name: "month",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 2629800,
            // 1/12th of Julian year
            offset: 0
        },
        year: {
            name: "year",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600,
            // Julian year
            offset: 0
        },
        decade: {
            name: "decade",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 315576000,
            // Julian decade
            offset: 0
        },
        century: {
            name: "century",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3155760000,
            // Julian century
            offset: 0
        },
        millennium: {
            name: "millennium",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600000,
            // Julian millennium
            offset: 0
        },
        // Frequency
        hertz: {
            name: "Hertz",
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        Hz: {
            name: "Hz",
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        // Angle
        rad: {
            name: "rad",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        radian: {
            name: "radian",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
        deg: {
            name: "deg",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        degree: {
            name: "degree",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
        grad: {
            name: "grad",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        gradian: {
            name: "gradian",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
        cycle: {
            name: "cycle",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
        arcsec: {
            name: "arcsec",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
        arcmin: {
            name: "arcmin",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // Electric current
        A: {
            name: "A",
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        ampere: {
            name: "ampere",
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // Temperature
        // K(C) = °C + 273.15
        // K(F) = (°F + 459.67) / 1.8
        // K(R) = °R / 1.8
        K: {
            name: "K",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 0
        },
        degC: {
            name: "degC",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 273.15
        },
        degF: {
            name: "degF",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 459.67
        },
        degR: {
            name: "degR",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 0
        },
        kelvin: {
            name: "kelvin",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 0
        },
        celsius: {
            name: "celsius",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 273.15
        },
        fahrenheit: {
            name: "fahrenheit",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 459.67
        },
        rankine: {
            name: "rankine",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 0
        },
        // amount of substance
        mol: {
            name: "mol",
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        mole: {
            name: "mole",
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // luminous intensity
        cd: {
            name: "cd",
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        candela: {
            name: "candela",
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // TODO: units STERADIAN
        // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // Force
        N: {
            name: "N",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        newton: {
            name: "newton",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        dyn: {
            name: "dyn",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 0.00001,
            offset: 0
        },
        dyne: {
            name: "dyne",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 0.00001,
            offset: 0
        },
        lbf: {
            name: "lbf",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        poundforce: {
            name: "poundforce",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        kip: {
            name: "kip",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 4448.2216,
            offset: 0
        },
        kilogramforce: {
            name: "kilogramforce",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        // Energy
        J: {
            name: "J",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        joule: {
            name: "joule",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        erg: {
            name: "erg",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.NONE,
            value: 1e-7,
            offset: 0
        },
        Wh: {
            name: "Wh",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 3600,
            offset: 0
        },
        BTU: {
            name: "BTU",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.BTU,
            value: 1055.05585262,
            offset: 0
        },
        eV: {
            name: "eV",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1.602176565e-19,
            offset: 0
        },
        electronvolt: {
            name: "electronvolt",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.LONG,
            value: 1.602176565e-19,
            offset: 0
        },
        // Power
        W: {
            name: "W",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        watt: {
            name: "watt",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        hp: {
            name: "hp",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.NONE,
            value: 745.6998715386,
            offset: 0
        },
        // Electrical power units
        VAR: {
            name: "VAR",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: Complex.I,
            offset: 0
        },
        VA: {
            name: "VA",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Pressure
        Pa: {
            name: "Pa",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        psi: {
            name: "psi",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 6894.75729276459,
            offset: 0
        },
        atm: {
            name: "atm",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 101325,
            offset: 0
        },
        bar: {
            name: "bar",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORTLONG,
            value: 100000,
            offset: 0
        },
        torr: {
            name: "torr",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmHg: {
            name: "mmHg",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmH2O: {
            name: "mmH2O",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        cmH2O: {
            name: "cmH2O",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 98.0665,
            offset: 0
        },
        // Electric charge
        coulomb: {
            name: "coulomb",
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        C: {
            name: "C",
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric capacitance
        farad: {
            name: "farad",
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        F: {
            name: "F",
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric potential
        volt: {
            name: "volt",
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        V: {
            name: "V",
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric resistance
        ohm: {
            name: "ohm",
            base: BASE_UNITS.ELECTRIC_RESISTANCE,
            prefixes: PREFIXES.SHORTLONG,
            // Both Mohm and megaohm are acceptable
            value: 1,
            offset: 0
        },
        /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */ // Electric inductance
        henry: {
            name: "henry",
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        H: {
            name: "H",
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric conductance
        siemens: {
            name: "siemens",
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        S: {
            name: "S",
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux
        weber: {
            name: "weber",
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        Wb: {
            name: "Wb",
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux density
        tesla: {
            name: "tesla",
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        T: {
            name: "T",
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Binary
        b: {
            name: "b",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 1,
            offset: 0
        },
        bits: {
            name: "bits",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 1,
            offset: 0
        },
        B: {
            name: "B",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 8,
            offset: 0
        },
        bytes: {
            name: "bytes",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 8,
            offset: 0
        }
    }; // aliases (formerly plurals)
    var ALIASES = {
        meters: "meter",
        inches: "inch",
        feet: "foot",
        yards: "yard",
        miles: "mile",
        links: "link",
        rods: "rod",
        chains: "chain",
        angstroms: "angstrom",
        lt: "l",
        litres: "litre",
        liter: "litre",
        liters: "litre",
        teaspoons: "teaspoon",
        tablespoons: "tablespoon",
        minims: "minim",
        fluiddrams: "fluiddram",
        fluidounces: "fluidounce",
        gills: "gill",
        cups: "cup",
        pints: "pint",
        quarts: "quart",
        gallons: "gallon",
        beerbarrels: "beerbarrel",
        oilbarrels: "oilbarrel",
        hogsheads: "hogshead",
        gtts: "gtt",
        grams: "gram",
        tons: "ton",
        tonnes: "tonne",
        grains: "grain",
        drams: "dram",
        ounces: "ounce",
        poundmasses: "poundmass",
        hundredweights: "hundredweight",
        sticks: "stick",
        lb: "lbm",
        lbs: "lbm",
        kips: "kip",
        kgf: "kilogramforce",
        acres: "acre",
        hectares: "hectare",
        sqfeet: "sqft",
        sqyard: "sqyd",
        sqmile: "sqmi",
        sqmiles: "sqmi",
        mmhg: "mmHg",
        mmh2o: "mmH2O",
        cmh2o: "cmH2O",
        seconds: "second",
        secs: "second",
        minutes: "minute",
        mins: "minute",
        hours: "hour",
        hr: "hour",
        hrs: "hour",
        days: "day",
        weeks: "week",
        months: "month",
        years: "year",
        decades: "decade",
        centuries: "century",
        millennia: "millennium",
        hertz: "hertz",
        radians: "radian",
        degrees: "degree",
        gradians: "gradian",
        cycles: "cycle",
        arcsecond: "arcsec",
        arcseconds: "arcsec",
        arcminute: "arcmin",
        arcminutes: "arcmin",
        BTUs: "BTU",
        watts: "watt",
        joules: "joule",
        amperes: "ampere",
        coulombs: "coulomb",
        volts: "volt",
        ohms: "ohm",
        farads: "farad",
        webers: "weber",
        teslas: "tesla",
        electronvolts: "electronvolt",
        moles: "mole",
        bit: "bits",
        byte: "bytes"
    };
    /**
   * Calculate the values for the angle units.
   * Value is calculated as number or BigNumber depending on the configuration
   * @param {{number: 'number' | 'BigNumber'}} config
   */ function calculateAngleValues(config) {
        if (config.number === "BigNumber") {
            var pi = (0, $49598b72b195f651$export$d0a8190d955e3c5b)(_BigNumber);
            UNITS.rad.value = new _BigNumber(1);
            UNITS.deg.value = pi.div(180); // 2 * pi / 360
            UNITS.grad.value = pi.div(200); // 2 * pi / 400
            UNITS.cycle.value = pi.times(2); // 2 * pi
            UNITS.arcsec.value = pi.div(648000); // 2 * pi / 360 / 3600
            UNITS.arcmin.value = pi.div(10800); // 2 * pi / 360 / 60
        } else {
            // number
            UNITS.rad.value = 1;
            UNITS.deg.value = Math.PI / 180; // 2 * pi / 360
            UNITS.grad.value = Math.PI / 200; // 2 * pi / 400
            UNITS.cycle.value = Math.PI * 2; // 2 * pi
            UNITS.arcsec.value = Math.PI / 648000; // 2 * pi / 360 / 3600
            UNITS.arcmin.value = Math.PI / 10800; // 2 * pi / 360 / 60
        } // copy to the full names of the angles
        UNITS.radian.value = UNITS.rad.value;
        UNITS.degree.value = UNITS.deg.value;
        UNITS.gradian.value = UNITS.grad.value;
    } // apply the angle values now
    calculateAngleValues(config);
    if (on) // recalculate the values on change of configuration
    on("config", function(curr, prev) {
        if (curr.number !== prev.number) calculateAngleValues(curr);
    });
    /**
   * A unit system is a set of dimensionally independent base units plus a set of derived units, formed by multiplication and division of the base units, that are by convention used with the unit system.
   * A user perhaps could issue a command to select a preferred unit system, or use the default (see below).
   * Auto unit system: The default unit system is updated on the fly anytime a unit is parsed. The corresponding unit in the default unit system is updated, so that answers are given in the same units the user supplies.
   */ var UNIT_SYSTEMS = {
        si: {
            // Base units
            NONE: {
                unit: UNIT_NONE,
                prefix: PREFIXES.NONE[""]
            },
            LENGTH: {
                unit: UNITS.m,
                prefix: PREFIXES.SHORT[""]
            },
            MASS: {
                unit: UNITS.g,
                prefix: PREFIXES.SHORT.k
            },
            TIME: {
                unit: UNITS.s,
                prefix: PREFIXES.SHORT[""]
            },
            CURRENT: {
                unit: UNITS.A,
                prefix: PREFIXES.SHORT[""]
            },
            TEMPERATURE: {
                unit: UNITS.K,
                prefix: PREFIXES.SHORT[""]
            },
            LUMINOUS_INTENSITY: {
                unit: UNITS.cd,
                prefix: PREFIXES.SHORT[""]
            },
            AMOUNT_OF_SUBSTANCE: {
                unit: UNITS.mol,
                prefix: PREFIXES.SHORT[""]
            },
            ANGLE: {
                unit: UNITS.rad,
                prefix: PREFIXES.SHORT[""]
            },
            BIT: {
                unit: UNITS.bits,
                prefix: PREFIXES.SHORT[""]
            },
            // Derived units
            FORCE: {
                unit: UNITS.N,
                prefix: PREFIXES.SHORT[""]
            },
            ENERGY: {
                unit: UNITS.J,
                prefix: PREFIXES.SHORT[""]
            },
            POWER: {
                unit: UNITS.W,
                prefix: PREFIXES.SHORT[""]
            },
            PRESSURE: {
                unit: UNITS.Pa,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CHARGE: {
                unit: UNITS.C,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CAPACITANCE: {
                unit: UNITS.F,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_POTENTIAL: {
                unit: UNITS.V,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_RESISTANCE: {
                unit: UNITS.ohm,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_INDUCTANCE: {
                unit: UNITS.H,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CONDUCTANCE: {
                unit: UNITS.S,
                prefix: PREFIXES.SHORT[""]
            },
            MAGNETIC_FLUX: {
                unit: UNITS.Wb,
                prefix: PREFIXES.SHORT[""]
            },
            MAGNETIC_FLUX_DENSITY: {
                unit: UNITS.T,
                prefix: PREFIXES.SHORT[""]
            },
            FREQUENCY: {
                unit: UNITS.Hz,
                prefix: PREFIXES.SHORT[""]
            }
        }
    }; // Clone to create the other unit systems
    UNIT_SYSTEMS.cgs = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.cgs.LENGTH = {
        unit: UNITS.m,
        prefix: PREFIXES.SHORT.c
    };
    UNIT_SYSTEMS.cgs.MASS = {
        unit: UNITS.g,
        prefix: PREFIXES.SHORT[""]
    };
    UNIT_SYSTEMS.cgs.FORCE = {
        unit: UNITS.dyn,
        prefix: PREFIXES.SHORT[""]
    };
    UNIT_SYSTEMS.cgs.ENERGY = {
        unit: UNITS.erg,
        prefix: PREFIXES.NONE[""]
    }; // there are wholly 4 unique cgs systems for electricity and magnetism,
    // so let's not worry about it unless somebody complains
    UNIT_SYSTEMS.us = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.us.LENGTH = {
        unit: UNITS.ft,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.MASS = {
        unit: UNITS.lbm,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.TEMPERATURE = {
        unit: UNITS.degF,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.FORCE = {
        unit: UNITS.lbf,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.ENERGY = {
        unit: UNITS.BTU,
        prefix: PREFIXES.BTU[""]
    };
    UNIT_SYSTEMS.us.POWER = {
        unit: UNITS.hp,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.PRESSURE = {
        unit: UNITS.psi,
        prefix: PREFIXES.NONE[""]
    }; // Add additional unit systems here.
    // Choose a unit system to seed the auto unit system.
    UNIT_SYSTEMS.auto = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si)); // Set the current unit system
    var currentUnitSystem = UNIT_SYSTEMS.auto;
    /**
   * Set a unit system for formatting derived units.
   * @param {string} [name] The name of the unit system.
   */ Unit.setUnitSystem = function(name) {
        if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(UNIT_SYSTEMS, name)) currentUnitSystem = UNIT_SYSTEMS[name];
        else throw new Error("Unit system " + name + " does not exist. Choices are: " + Object.keys(UNIT_SYSTEMS).join(", "));
    };
    /**
   * Return the current unit system.
   * @return {string} The current unit system.
   */ Unit.getUnitSystem = function() {
        for(var _key in UNIT_SYSTEMS)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(UNIT_SYSTEMS, _key)) {
            if (UNIT_SYSTEMS[_key] === currentUnitSystem) return _key;
        }
    };
    /**
   * Converters to convert from number to an other numeric type like BigNumber
   * or Fraction
   */ Unit.typeConverters = {
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x + ""); // stringify to prevent constructor error
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x);
        },
        Complex: function Complex(x) {
            return x;
        },
        number: function number(x) {
            return x;
        }
    };
    /**
   * Retrieve the right convertor function corresponding with the type
   * of provided exampleValue.
   *
   * @param {string} type   A string 'number', 'BigNumber', or 'Fraction'
   *                        In case of an unknown type,
   * @return {Function}
   */ Unit._getNumberConverter = function(type) {
        if (!Unit.typeConverters[type]) throw new TypeError('Unsupported type "' + type + '"');
        return Unit.typeConverters[type];
    }; // Add dimensions to each built-in unit
    for(var _key2 in UNITS)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(UNITS, _key2)) {
        var unit = UNITS[_key2];
        unit.dimensions = unit.base.dimensions;
    }
     // Create aliases
    for(var _name2 in ALIASES)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(ALIASES, _name2)) {
        var _unit2 = UNITS[ALIASES[_name2]];
        var alias = {};
        for(var _key3 in _unit2)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(_unit2, _key3)) alias[_key3] = _unit2[_key3];
        alias.name = _name2;
        UNITS[_name2] = alias;
    }
    /**
   * Checks if a character is a valid latin letter (upper or lower case).
   * Note that this function can be overridden, for example to allow support of other alphabets.
   * @param {string} c Tested character
   */ Unit.isValidAlpha = function isValidAlpha(c) {
        return /^[a-zA-Z]$/.test(c);
    };
    function assertUnitNameIsValid(name) {
        for(var i = 0; i < name.length; i++){
            c = name.charAt(i);
            if (i === 0 && !Unit.isValidAlpha(c)) throw new Error('Invalid unit name (must begin with alpha character): "' + name + '"');
            if (i > 0 && !(Unit.isValidAlpha(c) || isDigit(c))) throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + name + '"');
        }
    }
    /**
   * Wrapper around createUnitSingle.
   * Example:
   *  createUnit({
   *    foo: { },
   *    bar: {
   *      definition: 'kg/foo',
   *      aliases: ['ba', 'barr', 'bars'],
   *      offset: 200
   *    },
   *    baz: '4 bar'
   *  },
   *  {
   *    override: true
   *  })
   * @param {object} obj      Object map. Each key becomes a unit which is defined by its value.
   * @param {object} options
   */ Unit.createUnit = function(obj, options) {
        if (typeof obj !== "object") throw new TypeError("createUnit expects first parameter to be of type 'Object'");
         // Remove all units and aliases we are overriding
        if (options && options.override) for(var _key4 in obj){
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(obj, _key4)) Unit.deleteUnit(_key4);
            if (obj[_key4].aliases) for(var i = 0; i < obj[_key4].aliases.length; i++)Unit.deleteUnit(obj[_key4].aliases[i]);
        }
         // TODO: traverse multiple times until all units have been added
        var lastUnit;
        for(var _key5 in obj)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(obj, _key5)) lastUnit = Unit.createUnitSingle(_key5, obj[_key5]);
        return lastUnit;
    };
    /**
   * Create a user-defined unit and register it with the Unit type.
   * Example:
   *  createUnitSingle('knot', '0.514444444 m/s')
   *  createUnitSingle('acre', new Unit(43560, 'ft^2'))
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, Unit, Object} definition      Definition of the unit in terms
   * of existing units. For example, '0.514444444 m / s'. Can be a Unit, a string,
   * or an Object. If an Object, may have the following properties:
   *   - definition {string|Unit} The definition of this unit.
   *   - prefixes {string} "none", "short", "long", "binary_short", or "binary_long".
   *     The default is "none".
   *   - aliases {Array} Array of strings. Example: ['knots', 'kt', 'kts']
   *   - offset {Numeric} An offset to apply when converting from the unit. For
   *     example, the offset for celsius is 273.15 and the offset for farhenheit
   *     is 459.67. Default is 0.
   *   - baseName {string} If the unit's dimension does not match that of any other
   *     base unit, the name of the newly create base unit. Otherwise, this property
   *     has no effect.
   *
   * @param {Object} options   (optional) An object containing any of the following
   * properties:
   *   - override {boolean} Whether this unit should be allowed to override existing
   *     units.
   *
   * @return {Unit}
   */ Unit.createUnitSingle = function(name, obj, options) {
        if (typeof obj === "undefined" || obj === null) obj = {};
        if (typeof name !== "string") throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
         // Check collisions with existing units
        if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(UNITS, name)) throw new Error('Cannot create unit "' + name + '": a unit with that name already exists');
         // TODO: Validate name for collisions with other built-in functions (like abs or cos, for example), and for acceptable variable names. For example, '42' is probably not a valid unit. Nor is '%', since it is also an operator.
        assertUnitNameIsValid(name);
        var defUnit = null; // The Unit from which the new unit will be created.
        var aliases = [];
        var offset = 0;
        var definition;
        var prefixes;
        var baseName;
        if (obj && obj.type === "Unit") defUnit = obj.clone();
        else if (typeof obj === "string") {
            if (obj !== "") definition = obj;
        } else if (typeof obj === "object") {
            definition = obj.definition;
            prefixes = obj.prefixes;
            offset = obj.offset;
            baseName = obj.baseName;
            if (obj.aliases) aliases = obj.aliases.valueOf(); // aliases could be a Matrix, so convert to Array
        } else throw new TypeError('Cannot create unit "' + name + '" from "' + obj.toString() + '": expecting "string" or "Unit" or "Object"');
        if (aliases) for(var i = 0; i < aliases.length; i++){
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(UNITS, aliases[i])) throw new Error('Cannot create alias "' + aliases[i] + '": a unit with that name already exists');
        }
        if (definition && typeof definition === "string" && !defUnit) try {
            defUnit = Unit.parse(definition, {
                allowNoUnits: true
            });
        } catch (ex) {
            ex.message = 'Could not create unit "' + name + '" from "' + definition + '": ' + ex.message;
            throw ex;
        }
        else if (definition && definition.type === "Unit") defUnit = definition.clone();
        aliases = aliases || [];
        offset = offset || 0;
        if (prefixes && prefixes.toUpperCase) prefixes = PREFIXES[prefixes.toUpperCase()] || PREFIXES.NONE;
        else prefixes = PREFIXES.NONE;
         // If defUnit is null, it is because the user did not
        // specify a defintion. So create a new base dimension.
        var newUnit = {};
        if (!defUnit) {
            // Add a new base dimension
            baseName = baseName || name + "_STUFF"; // foo --> foo_STUFF, or the essence of foo
            if (BASE_DIMENSIONS.indexOf(baseName) >= 0) throw new Error('Cannot create new base unit "' + name + '": a base unit with that name already exists (and cannot be overridden)');
            BASE_DIMENSIONS.push(baseName); // Push 0 onto existing base units
            for(var b in BASE_UNITS)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(BASE_UNITS, b)) BASE_UNITS[b].dimensions[BASE_DIMENSIONS.length - 1] = 0;
             // Add the new base unit
            var newBaseUnit = {
                dimensions: []
            };
            for(var _i6 = 0; _i6 < BASE_DIMENSIONS.length; _i6++)newBaseUnit.dimensions[_i6] = 0;
            newBaseUnit.dimensions[BASE_DIMENSIONS.length - 1] = 1;
            newBaseUnit.key = baseName;
            BASE_UNITS[baseName] = newBaseUnit;
            newUnit = {
                name: name,
                value: 1,
                dimensions: BASE_UNITS[baseName].dimensions.slice(0),
                prefixes: prefixes,
                offset: offset,
                base: BASE_UNITS[baseName]
            };
            currentUnitSystem[baseName] = {
                unit: newUnit,
                prefix: PREFIXES.NONE[""]
            };
        } else {
            newUnit = {
                name: name,
                value: defUnit.value,
                dimensions: defUnit.dimensions.slice(0),
                prefixes: prefixes,
                offset: offset
            }; // Create a new base if no matching base exists
            var anyMatch = false;
            for(var _i7 in BASE_UNITS)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(BASE_UNITS, _i7)) {
                var match = true;
                for(var j = 0; j < BASE_DIMENSIONS.length; j++)if (Math.abs((newUnit.dimensions[j] || 0) - (BASE_UNITS[_i7].dimensions[j] || 0)) > 1e-12) {
                    match = false;
                    break;
                }
                if (match) {
                    anyMatch = true;
                    newUnit.base = BASE_UNITS[_i7];
                    break;
                }
            }
            if (!anyMatch) {
                baseName = baseName || name + "_STUFF"; // foo --> foo_STUFF, or the essence of foo
                // Add the new base unit
                var _newBaseUnit = {
                    dimensions: defUnit.dimensions.slice(0)
                };
                _newBaseUnit.key = baseName;
                BASE_UNITS[baseName] = _newBaseUnit;
                currentUnitSystem[baseName] = {
                    unit: newUnit,
                    prefix: PREFIXES.NONE[""]
                };
                newUnit.base = BASE_UNITS[baseName];
            }
        }
        Unit.UNITS[name] = newUnit;
        for(var _i8 = 0; _i8 < aliases.length; _i8++){
            var aliasName = aliases[_i8];
            var _alias = {};
            for(var _key6 in newUnit)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(newUnit, _key6)) _alias[_key6] = newUnit[_key6];
            _alias.name = aliasName;
            Unit.UNITS[aliasName] = _alias;
        } // delete the memoization cache, since adding a new unit to the array
        // invalidates all old results
        delete _findUnit.cache;
        return new Unit(null, name);
    };
    Unit.deleteUnit = function(name) {
        delete Unit.UNITS[name];
    }; // expose arrays with prefixes, dimensions, units, systems
    Unit.PREFIXES = PREFIXES;
    Unit.BASE_DIMENSIONS = BASE_DIMENSIONS;
    Unit.BASE_UNITS = BASE_UNITS;
    Unit.UNIT_SYSTEMS = UNIT_SYSTEMS;
    Unit.UNITS = UNITS;
    return Unit;
}, {
    isClass: true
});



var $c160b7e6f9fbf5ba$var$name = "unit";
var $c160b7e6f9fbf5ba$var$dependencies = [
    "typed",
    "Unit"
]; // This function is named createUnitFunction to prevent a naming conflict with createUnit
var $c160b7e6f9fbf5ba$export$17074f98b69d2545 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c160b7e6f9fbf5ba$var$name, $c160b7e6f9fbf5ba$var$dependencies, (_ref)=>{
    var { typed: typed, Unit: Unit } = _ref;
    /**
   * Create a unit. Depending on the passed arguments, the function
   * will create and return a new math.Unit object.
   * When a matrix is provided, all elements will be converted to units.
   *
   * Syntax:
   *
   *     math.unit(unit : string)
   *     math.unit(value : number, unit : string)
   *
   * Examples:
   *
   *    const a = math.unit(5, 'cm')    // returns Unit 50 mm
   *    const b = math.unit('23 kg')    // returns Unit 23 kg
   *    a.to('m')                       // returns Unit 0.05 m
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, string, createUnit
   *
   * @param {* | Array | Matrix} args   A number and unit.
   * @return {Unit | Array | Matrix}    The created unit
   */ return typed($c160b7e6f9fbf5ba$var$name, {
        Unit: function Unit(x) {
            return x.clone();
        },
        string: function string(x) {
            if (Unit.isValuelessUnit(x)) return new Unit(null, x); // a pure unit
            return Unit.parse(x, {
                allowNoUnits: true
            }); // a unit with value, like '5cm'
        },
        "number | BigNumber | Fraction | Complex, string": function numberBigNumberFractionComplexString(value, unit) {
            return new Unit(value, unit);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $63bcd5f260b641f1$var$name = "usolve";
var $63bcd5f260b641f1$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $63bcd5f260b641f1$export$f652f5e8e3e838da = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($63bcd5f260b641f1$var$name, $63bcd5f260b641f1$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $00dc5b12f1db226b$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds one solution of a linear equation system by backward substitution. Matrix must be an upper triangular matrix. Throws an error if there's no solution.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolve(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolve(a, b)  // [[8], [9]]
   *
   * See also:
   *
   *    usolveAll, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($63bcd5f260b641f1$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseBackwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseBackwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var r = _denseBackwardSubstitution(m, b);
            return r.valueOf();
        }
    });
    function _denseBackwardSubstitution(m, b) {
        // make b into a column vector
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1]; // result
        var x = [];
        var mdata = m._data; // loop columns backwards
        for(var j = columns - 1; j >= 0; j--){
            // b[j]
            var bj = bdata[j][0] || 0; // x[j]
            var xj = void 0;
            if (!equalScalar(bj, 0)) {
                // value at [j, j]
                var vjj = mdata[j][j];
                if (equalScalar(vjj, 0)) // system cannot be solved
                throw new Error("Linear system cannot be solved since matrix is singular");
                xj = divideScalar(bj, vjj); // loop rows
                for(var i = j - 1; i >= 0; i--)// update copy of b
                bdata[i] = [
                    subtract(bdata[i][0] || 0, multiplyScalar(xj, mdata[i][j]))
                ];
            } else // zero value at j
            xj = 0;
             // update x
            x[j] = [
                xj
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseBackwardSubstitution(m, b) {
        // make b into a column vector
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // result
        var x = []; // loop columns backwards
        for(var j = columns - 1; j >= 0; j--){
            var bj = bdata[j][0] || 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = 0; // upper triangular matrix values & index (column j)
                var jValues = [];
                var jIndices = []; // first & last indeces in column
                var firstIndex = ptr[j];
                var lastIndex = ptr[j + 1]; // values in column, find value at [j, j], loop backwards
                for(var k = lastIndex - 1; k >= firstIndex; k--){
                    var i = index[k]; // check row (rows are not sorted!)
                    if (i === j) vjj = values[k];
                    else if (i < j) {
                        // store upper triangular
                        jValues.push(values[k]);
                        jIndices.push(i);
                    }
                } // at this point we must have a value in vjj
                if (equalScalar(vjj, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                var xj = divideScalar(bj, vjj);
                for(var _k = 0, _lastIndex = jIndices.length; _k < _lastIndex; _k++){
                    var _i = jIndices[_k];
                    bdata[_i] = [
                        subtract(bdata[_i][0], multiplyScalar(xj, jValues[_k]))
                    ];
                }
                x[j] = [
                    xj
                ];
            } else // degenerate row, we can choose any value
            x[j] = [
                0
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});



var $a63e1284442e6298$var$name = "usolveAll";
var $a63e1284442e6298$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $a63e1284442e6298$export$c8bbc8bec60c7fc3 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a63e1284442e6298$var$name, $a63e1284442e6298$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $00dc5b12f1db226b$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds all solutions of a linear equation system by backward substitution. Matrix must be an upper triangular matrix.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolveAll(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolveAll(a, b)  // [ [[8], [9]] ]
   *
   * See also:
   *
   *    usolve, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix[] | Array[]}  An array of affine-independent column vectors (x) that solve the linear system
   */ return typed($a63e1284442e6298$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseBackwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseBackwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var R = _denseBackwardSubstitution(m, b);
            return R.map((r)=>r.valueOf());
        }
    });
    function _denseBackwardSubstitution(m, b_) {
        // the algorithm is derived from
        // https://www.overleaf.com/read/csvgqdxggyjv
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var M = m._data;
        var rows = m._size[0];
        var columns = m._size[1]; // loop columns backwards
        for(var i = columns - 1; i >= 0; i--){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                if (!equalScalar(M[i][i], 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], M[i][i]);
                    for(var j = i - 1; j >= 0; j--)// b[j] -= b[i] * M[j,i]
                    b[j] = subtract(b[j], multiplyScalar(b[i], M[j][i]));
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j = i - 1; _j >= 0; _j--)bNew[_j] = subtract(bNew[_j], M[_j][i]);
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
    function _sparseBackwardSubstitution(m, b_) {
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // loop columns backwards
        for(var i = columns - 1; i >= 0; i--){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k]; // values & indices (column i)
                var iValues = [];
                var iIndices = []; // first & last indeces in column
                var firstIndex = ptr[i];
                var lastIndex = ptr[i + 1]; // find the value at [i, i]
                var Mii = 0;
                for(var j = lastIndex - 1; j >= firstIndex; j--){
                    var J = index[j]; // check row
                    if (J === i) Mii = values[j];
                    else if (J < i) {
                        // store upper triangular
                        iValues.push(values[j]);
                        iIndices.push(J);
                    }
                }
                if (!equalScalar(Mii, 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], Mii); // loop upper triangular
                    for(var _j2 = 0, _lastIndex = iIndices.length; _j2 < _lastIndex; _j2++){
                        var _J = iIndices[_j2];
                        b[_J] = subtract(b[_J], multiplyScalar(b[i], iValues[_j2]));
                    }
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1; // loop upper triangular
                    for(var _j3 = 0, _lastIndex2 = iIndices.length; _j3 < _lastIndex2; _j3++){
                        var _J2 = iIndices[_j3];
                        bNew[_J2] = subtract(bNew[_J2], iValues[_j3]);
                    }
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
});





var $b421b520bfd774f5$var$DEFAULT_NORMALIZATION = "unbiased";
var $b421b520bfd774f5$var$name = "variance";
var $b421b520bfd774f5$var$dependencies = [
    "typed",
    "add",
    "subtract",
    "multiply",
    "divide",
    "apply",
    "isNaN"
];
var $b421b520bfd774f5$export$b989221824390fb = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b421b520bfd774f5$var$name, $b421b520bfd774f5$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, subtract: subtract, multiply: multiply, divide: divide, apply: apply, isNaN: isNaN } = _ref;
    /**
   * Compute the variance of a matrix or a  list with values.
   * In case of a (multi dimensional) array or matrix, the variance over all
   * elements will be calculated.
   *
   * Additionally, it is possible to compute the variance along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Note that older browser may not like the variable name `var`. In that
   * case, the function can be called as `math['var'](...)` instead of
   * `math.var(...)`.
   *
   * Syntax:
   *
   *     math.variance(a, b, c, ...)
   *     math.variance(A)
   *     math.variance(A, normalization)
   *     math.variance(A, dimension)
   *     math.variance(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.variance(2, 4, 6)                     // returns 4
   *     math.variance([2, 4, 6, 8])                // returns 6.666666666666667
   *     math.variance([2, 4, 6, 8], 'uncorrected') // returns 5
   *     math.variance([2, 4, 6, 8], 'biased')      // returns 4
   *
   *     math.variance([[1, 2, 3], [4, 5, 6]])      // returns 3.5
   *     math.variance([[1, 2, 3], [4, 6, 8]], 0)   // returns [4.5, 8, 12.5]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1)   // returns [1, 4]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.5, 2]
   *
   * See also:
   *
   *    mean, median, max, min, prod, std, sum
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the variance for a matrix
   * @return {*} The variance
   */ return typed($b421b520bfd774f5$var$name, {
        // variance([a, b, c, d, ...])
        "Array | Matrix": function ArrayMatrix(array) {
            return _var(array, $b421b520bfd774f5$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, d, ...], normalization)
        "Array | Matrix, string": _var,
        // variance([a, b, c, c, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return _varDim(array, dim, $b421b520bfd774f5$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, c, ...], dim, normalization)
        "Array | Matrix, number | BigNumber, string": _varDim,
        // variance(a, b, c, d, ...)
        "...": function _(args) {
            return _var(args, $b421b520bfd774f5$var$DEFAULT_NORMALIZATION);
        }
    });
    /**
   * Recursively calculate the variance of an n-dimensional array
   * @param {Array} array
   * @param {string} normalization
   *                        Determines how to normalize the variance:
   *                        - 'unbiased'    The sum of squared errors is divided by (n - 1)
   *                        - 'uncorrected' The sum of squared errors is divided by n
   *                        - 'biased'      The sum of squared errors is divided by (n + 1)
   * @return {number | BigNumber} variance
   * @private
   */ function _var(array, normalization) {
        var sum;
        var num = 0;
        if (array.length === 0) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
         // calculate the mean and number of elements
        (0, $cd13353fc76500f7$export$519ada94592b97fc)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "variance", value);
            }
        });
        if (num === 0) throw new Error("Cannot calculate variance of an empty array");
        var mean = divide(sum, num); // calculate the variance
        sum = undefined;
        (0, $cd13353fc76500f7$export$519ada94592b97fc)(array, function(value) {
            var diff = subtract(value, mean);
            sum = sum === undefined ? multiply(diff, diff) : add(sum, multiply(diff, diff));
        });
        if (isNaN(sum)) return sum;
        switch(normalization){
            case "uncorrected":
                return divide(sum, num);
            case "biased":
                return divide(sum, num + 1);
            case "unbiased":
                var zero = (0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(sum) ? sum.mul(0) : 0;
                return num === 1 ? zero : divide(sum, num - 1);
            default:
                throw new Error('Unknown normalization "' + normalization + '". ' + 'Choose "unbiased" (default), "uncorrected", or "biased".');
        }
    }
    function _varDim(array, dim, normalization) {
        try {
            if (array.length === 0) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
            return apply(array, dim, (x)=>_var(x, normalization));
        } catch (err) {
            throw (0, $a15af65dbad833ab$export$c8994973cec629ae)(err, "variance");
        }
    }
});



var $d7d2329bae0bdbeb$var$name = "xgcd";
var $d7d2329bae0bdbeb$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $d7d2329bae0bdbeb$export$de8cbd18c98bf9d5 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d7d2329bae0bdbeb$var$name, $d7d2329bae0bdbeb$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Calculate the extended greatest common divisor for two values.
   * See https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm.
   *
   * Syntax:
   *
   *    math.xgcd(a, b)
   *
   * Examples:
   *
   *    math.xgcd(8, 12)             // returns [4, -1, 1]
   *    math.gcd(8, 12)              // returns 4
   *    math.xgcd(36163, 21199)      // returns [1247, -7, 12]
   *
   * See also:
   *
   *    gcd, lcm
   *
   * @param {number | BigNumber} a  An integer number
   * @param {number | BigNumber} b  An integer number
   * @return {Array}              Returns an array containing 3 integers `[div, m, n]`
   *                              where `div = gcd(a, b)` and `a*m + b*n = div`
   */ return typed($d7d2329bae0bdbeb$var$name, {
        "number, number": function numberNumber(a, b) {
            var res = (0, $08ae6b2eb4bd0049$export$8cb756a23a623229)(a, b);
            return config.matrix === "Array" ? res : matrix(res);
        },
        "BigNumber, BigNumber": _xgcdBigNumber // TODO: implement support for Fraction
    });
    /**
   * Calculate xgcd for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @return {BigNumber[]} result
   * @private
   */ function _xgcdBigNumber(a, b) {
        // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
        var t;
        var q;
        var r;
        var zero = new BigNumber(0);
        var one = new BigNumber(1);
        var x = zero;
        var lastx = one;
        var y = one;
        var lasty = zero;
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function xgcd must be integer numbers");
        while(!b.isZero()){
            q = a.div(b).floor();
            r = a.mod(b);
            t = x;
            x = lastx.minus(q.times(x));
            lastx = t;
            t = y;
            y = lasty.minus(q.times(y));
            lasty = t;
            a = b;
            b = r;
        }
        var res;
        if (a.lt(zero)) res = [
            a.neg(),
            lastx.neg(),
            lasty.neg()
        ];
        else res = [
            a,
            !a.isZero() ? lastx : 0,
            lasty
        ];
        return config.matrix === "Array" ? res : matrix(res);
    }
});








var $7b40147032659d57$var$name = "xor";
var $7b40147032659d57$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix"
];
var $7b40147032659d57$export$a2b8cab2c7385f0e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($7b40147032659d57$var$name, $7b40147032659d57$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $b77d8309a4e59b1f$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $49703efd2d98c69c$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $2c0794088bd09e2c$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $2926213e02b15f73$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $d667d3eb521eddec$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Logical `xor`. Test whether one and only one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.xor(x, y)
   *
   * Examples:
   *
   *    math.xor(2, 4)   // returns false
   *
   *    a = [2, 0, 0]
   *    b = [2, 7, 0]
   *    c = 0
   *
   *    math.xor(a, b)   // returns [false, true, false]
   *    math.xor(a, c)   // returns [true, false, false]
   *
   * See also:
   *
   *    and, not, or
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one and only one input is defined with a nonzero/nonempty value.
   */ return typed($7b40147032659d57$var$name, {
        "number, number": (0, $9ff9fc757fde94e9$export$17cc7dc3a74df3af),
        "Complex, Complex": function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) !== (y.re !== 0 || y.im !== 0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return (!x.isZero() && !x.isNaN()) !== (!y.isZero() && !y.isNaN());
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return this(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});





var $ecd50cd80ce67ac0$var$name = "zeros";
var $ecd50cd80ce67ac0$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $ecd50cd80ce67ac0$export$13096c1635fe6e3d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($ecd50cd80ce67ac0$var$name, $ecd50cd80ce67ac0$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Create a matrix filled with zeros. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.zeros(m)
   *    math.zeros(m, format)
   *    math.zeros(m, n)
   *    math.zeros(m, n, format)
   *    math.zeros([m, n])
   *    math.zeros([m, n], format)
   *
   * Examples:
   *
   *    math.zeros(3)                  // returns [0, 0, 0]
   *    math.zeros(3, 2)               // returns [[0, 0], [0, 0], [0, 0]]
   *    math.zeros(3, 'dense')         // returns [0, 0, 0]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.zeros(math.size(A))       // returns [[0, 0, 0], [0, 0, 0]]
   *
   * See also:
   *
   *    ones, identity, size, range
   *
   * @param {...number | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix}           A matrix filled with zeros
   */ return typed($ecd50cd80ce67ac0$var$name, {
        "": function _() {
            return config.matrix === "Array" ? _zeros([]) : _zeros([], "default");
        },
        // math.zeros(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        "...number | BigNumber | string": function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === "string") {
                var format = size.pop();
                return _zeros(size, format);
            } else if (config.matrix === "Array") return _zeros(size);
            else return _zeros(size, "default");
        },
        Array: _zeros,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _zeros(size.valueOf(), format);
        },
        "Array | Matrix, string": function ArrayMatrixString(size, format) {
            return _zeros(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with zeros
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _zeros(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(0) : 0;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $802b18b8c920d4c6$export$4380c87abf28fdf)(arr, size, defaultValue);
            return arr;
        }
    } // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    } // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== "number" || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(value) || value < 0) throw new Error("Parameters in function zeros must be positive integers");
        });
    }
}); // TODO: zeros contains almost the same code as ones. Reuse this?


var $bed779fa205b8d7c$export$d97aa349ed20696 = /* #__PURE__ */ (0, $14d0db6ed7dee273$export$234de8d4231bfea3)({
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$50ceb3fb9926e63e = /* #__PURE__ */ (0, $97e857c901ea227e$export$24a4be44fc8b6392)({});
var $bed779fa205b8d7c$export$f1e1789686576879 = /* #__PURE__ */ (0, $81d79d71cb274b51$export$6dca51ff4d4b257f)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$f650004d56f90c2a = /* #__PURE__ */ (0, $81d79d71cb274b51$export$cb94e3a54c9e99b)({});
var $bed779fa205b8d7c$export$5c15dd8d2782cbd0 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$aaddb59a993d3ac4)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$b336c2702c498be5 = /* #__PURE__ */ (0, $8198075b72ba6116$export$c317f082100fca89)({});
var $bed779fa205b8d7c$export$23f2a1d2818174ef = /* #__PURE__ */ (0, $81d79d71cb274b51$export$7122d2461a6f9b76)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e
});
var $bed779fa205b8d7c$export$20607595d292e7d3 = /* #__PURE__ */ (0, $81d79d71cb274b51$export$df1313fb6eb44f05)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$c44341d65988fdd6 = /* #__PURE__ */ (0, $81d79d71cb274b51$export$5365e90aad1235b4)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$5ed2c057bd191c66 = /* #__PURE__ */ (0, $81d79d71cb274b51$export$57f654bce66ec8ce)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$5b12bf1653c0dd85 = /* #__PURE__ */ (0, $93edf6af35216078$export$72d485cc3ed6a97a)({});
var $bed779fa205b8d7c$export$14edd9ca775dcd61 = /* #__PURE__ */ (0, $81d79d71cb274b51$export$fbdaee11df58c3cc)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$a2cbb38cda512d16 = /* #__PURE__ */ (0, $81d79d71cb274b51$export$d07c6114481fc17b)({});
var $bed779fa205b8d7c$export$324943737027944a = /* #__PURE__ */ (0, $81d79d71cb274b51$export$f131830080647892)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$9a58ef0d7ad3278c = /* #__PURE__ */ (0, $8bf602457c875317$export$e87cc8d3f29c5e1b)({});
var $bed779fa205b8d7c$export$aebd5179ff543a90 = /* #__PURE__ */ (0, $198c48d4ca2741b6$export$dfb3187f1c4e3bbe)({});
var $bed779fa205b8d7c$export$83247d8be11c091e = /* #__PURE__ */ (0, $81d79d71cb274b51$export$e6df2cb14f3e8316)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$a7100dcd4c5af6d4 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$467c65d9dfc3d3a2)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$a4b4b4d4d776fe92 = /* #__PURE__ */ (0, $81d79d71cb274b51$export$d5973a6d5d95d479)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$93f71dfe5e50cd3e = /* #__PURE__ */ (0, $81d79d71cb274b51$export$e13d32722e2756df)({});
var $bed779fa205b8d7c$export$83d89fbfd8236492 = /* #__PURE__ */ (0, $81d79d71cb274b51$export$72a91d9326d5a672)({});
var $bed779fa205b8d7c$export$97f0d27b48f120e8 = /* #__PURE__ */ (0, $cba7468445748363$export$1a088ca8dd364cd1)({
    Matrix: $bed779fa205b8d7c$export$5b12bf1653c0dd85
});
var $bed779fa205b8d7c$export$9ea6550edaaee998 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$55fc8769b037d266)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$578b45ddcdefa518 = /* #__PURE__ */ (0, $81d79d71cb274b51$export$ab67ddb9e8290a2c)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$18c7bea995a110f = /* #__PURE__ */ (0, $81d79d71cb274b51$export$2dbe69c48ac7f49c)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$b644b65666fe0c18 = /* #__PURE__ */ (0, $51a943c5fd7f2a04$export$481a522c866104eb)({});
var $bed779fa205b8d7c$export$3681641e15b6e2c3 = /* #__PURE__ */ (0, $81d79d71cb274b51$export$f7a593fe98eba575)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$519f616c41a1c711 = /* #__PURE__ */ (0, $41903bc6f503885b$export$8597b5d47504f989)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    Fraction: $bed779fa205b8d7c$export$b336c2702c498be5
});
var $bed779fa205b8d7c$export$df8c837ae5df4ce4 = /* #__PURE__ */ (0, $158c2228ede227dc$export$cb425222dc08ff4e)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$857d2e3e2bc524d0 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$fa2d42c5c25c1883)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$2335f513bbd82c6d = /* #__PURE__ */ (0, $29a83c248ac78edd$export$dd8a9b3843a4df95)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$fd6306be3fde5b04 = /* #__PURE__ */ (0, $a70f9f93e05a2084$export$33da46c5ece67581)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$4919a578c4aafd3 = /* #__PURE__ */ (0, $9af91d7937791a4a$export$8a6845771325148e)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$43298db932064b4a = /* #__PURE__ */ (0, $079fcfb5c717dbe5$export$95580581b134a5bd)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$2b7b095c4f443355 = /* #__PURE__ */ (0, $779418672cbd1256$export$bbebd809b9ccc50b)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$d8da458ed75e15b = /* #__PURE__ */ (0, $550f8f3a9abc709b$export$bde3dabbd4699a93)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$3aaf4e522be48075 = /* #__PURE__ */ (0, $d245c0d227af4eb1$export$8eeff5f09afe95bc)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$839d8a01b6af4fc0 = /* #__PURE__ */ (0, $24f33341c424235f$export$7278bb4e3c84d46a)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$628dc4eed22b0fbd = /* #__PURE__ */ (0, $849b8afd38dd3092$export$b87f3a3301a24256)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$21ea955025ceb08b = /* #__PURE__ */ (0, $beb73f9dec69afc9$export$c2dbbeab1e5e6195)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$8576f72eb7f14a7e = /* #__PURE__ */ (0, $f645461b7f19365e$export$1c955ee1b8a97877)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$aabc449fa5b5f4c0 = /* #__PURE__ */ (0, $02a92c0d0a799d87$export$9e7f3c72ca8b5aa)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$4a21f16c33752377 = /* #__PURE__ */ (0, $41c3c4abe68f69b8$export$3c82aec2d86a5525)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$9cd59f9826255e47 = /* #__PURE__ */ (0, $cb210a377d372289$export$39ad70de4044028a)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$bdfcf4c6b5766439 = /* #__PURE__ */ (0, $a25fce9d29b8284e$export$63e3129a196da23d)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$83a0e34f1302825b = /* #__PURE__ */ (0, $8911afbb0665e63e$export$82a905fb6826da0d)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$fb254c661fe9c0db = /* #__PURE__ */ (0, $15bdb7f2cb5a0211$export$af5efe8ad97f01a2)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$2e2fd1ad24e4d350 = /* #__PURE__ */ (0, $7722fe2c00afd7b3$export$63d35097da636c02)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$fe7b8a3b046ac25b = /* #__PURE__ */ (0, $f53b70395c97bef9$export$3f7f9b5400315e6a)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$a830b5ed334924be = /* #__PURE__ */ (0, $8573ce3c9ca9115c$export$a0beb298aa7a2962)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$2b0340f6c7dec49a = /* #__PURE__ */ (0, $08b3f0c1004aaba8$export$ce223d612b94804b)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$943761f5c9c3f156 = /* #__PURE__ */ (0, $f853be7ea7c49bfd$export$c370bab664a0c9a2)({
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$d3896f355fc09423 = /* #__PURE__ */ (0, $65f5cbe23f5ce903$export$470dfa326d6cbdf5)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$b310ec824aaee37f = /* #__PURE__ */ (0, $d52e3dd66dea5f0d$export$95a576617fd015b1)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$b6c0a80d46d3391d = /* #__PURE__ */ (0, $8c67ccae451ccda3$export$2b203b63f664bab3)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$3dea766d36a8935f = /* #__PURE__ */ (0, $22ae454ba62fbf56$export$5d81789ff4aeccdf)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$4b80e395e36b5a56 = /* #__PURE__ */ (0, $0fed3482d31b5817$export$a5218987e0811e05)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$d9468344d3651243 = /* #__PURE__ */ (0, $403585168a691256$export$abf0d9399b60f9bb)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$42c7d1d712906e32 = /* #__PURE__ */ (0, $a25390cd72c3de6b$export$b83055c9a38abe3c)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$834dfc94dde4b3d8 = /* #__PURE__ */ (0, $2d0ca931c325139b$export$9cafd9970d25a17c)({
    format: $bed779fa205b8d7c$export$d9468344d3651243,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$5fc500b917996661 = /* #__PURE__ */ (0, $48d7b93a2bd1bc9f$export$47dfdf308b91581)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$a287f47fed4544b8 = /* #__PURE__ */ (0, $1835ca939a9c842a$export$766996d075d5608a)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$d0909a4f38b5c4d0 = /* #__PURE__ */ (0, $9ba354edacdac2e9$export$159ccd8c63e17c58)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$7e69d4236fcc3b19 = /* #__PURE__ */ (0, $a2e59934015b5265$export$2d862c12fb537dd9)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$c46ec7d82fb1f602 = /* #__PURE__ */ (0, $3c8f82201186a392$export$ea90652d00dab06e)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$8c2c65adacba8d14 = /* #__PURE__ */ (0, $81d79d71cb274b51$export$b57f4b4cfc057c2d)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$3daae2744d8ce460 = /* #__PURE__ */ (0, $c473a94c8d441725$export$bc3a6f6286e9085a)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$75e08744a3ff8516 = /* #__PURE__ */ (0, $2366a456b37decda$export$dea4efeb24d4590d)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$b9fae0bba9d9094d = /* #__PURE__ */ (0, $983791d280b8931b$export$a993dae3988e0f19)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$871de8747c9eaa88 = /* #__PURE__ */ (0, $5b257b6b328906b9$export$d49c9aa30b771d59)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$c697bed75648cdb7 = /* #__PURE__ */ (0, $536449042aed6cc4$export$37dc64d7e8361b32)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$6003a5f097c73977 = /* #__PURE__ */ (0, $4ef43ceaf9cd3ad7$export$8dbfb388cd6a8853)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$98e628dec113755e = /* #__PURE__ */ (0, $e00338ee98cc80c1$export$763ee9f6477981ab)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$8d9f5ae1af806929 = /* #__PURE__ */ (0, $a0d9f7d0ac5f7acd$export$6692788ef49c21c9)({
    format: $bed779fa205b8d7c$export$d9468344d3651243,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$2e015b6955893291 = /* #__PURE__ */ (0, $c0c64b43e676705a$export$fbe25b9f25feec34)({
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$c2d084dc44961371 = /* #__PURE__ */ (0, $d1a9199bb0046643$export$ea4b9d9569ff81cc)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$4385e60b38654f68 = /* #__PURE__ */ (0, $b01d6fe4f5379b79$export$5c03d20f483e909a)({
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$b1f1627d659a651 = /* #__PURE__ */ (0, $e295fdb9427861e0$export$803e46d0de790dbf)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$e17a63917e2ebf0f = /* #__PURE__ */ (0, $16523ae6cb9d15c0$export$5c169ecd5c25a09e)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$c5552dfdbc7cec71 = /* #__PURE__ */ (0, $1e1fccc801ebe958$export$45df7cae684751af)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Fraction: $bed779fa205b8d7c$export$b336c2702c498be5,
    complex: $bed779fa205b8d7c$export$83a0e34f1302825b,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$5de3937cb4b592ed = /* #__PURE__ */ (0, $de45d2b722729ea6$export$4b4fac44ef379cae)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$de9b2b7556879848 = /* #__PURE__ */ (0, $506dafb406c6f1a0$export$a783ce8f6a98b2e5)({
    Matrix: $bed779fa205b8d7c$export$5b12bf1653c0dd85,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$dd67294014106b35 = /* #__PURE__ */ (0, $f2c98b92b1d9d107$export$a9f61753ee14ea96)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$dd4f28cef696bc7d = /* #__PURE__ */ (0, $5a0a22f6aac9de8e$export$4ba960a63f731b0b)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$22b082955e083ec3 = /* #__PURE__ */ (0, $1555b5277cf2086a$export$b2cf5914f5f18823)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$fcdd3b0b3246a325 = /* #__PURE__ */ (0, $0cdb2c85df323367$export$b61ad4f38fd9301d)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$f5bbd400c2f4426f = /* #__PURE__ */ (0, $cb2ce56b08d01187$export$d7acf116afef7b4d)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$b26caf0f29211d08 = /* #__PURE__ */ (0, $79a1e41cdfad09cd$export$c634796792055579)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$eafdb403a25900df = /* #__PURE__ */ (0, $57ab0d336c2aa775$export$d6534043a40dc59)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$5635d7ef4b8fee1c = /* #__PURE__ */ (0, $87c3e66f3771976e$export$5ccffa1686df7f00)({
    isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$ec42f46098b24bb4 = /* #__PURE__ */ (0, $0f27587f75810b19$export$e1f28fc7c94f90b0)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$f03e751d9cddb7a = /* #__PURE__ */ (0, $82fe4e81579d6b46$export$a770ddfd7e536064)({
    format: $bed779fa205b8d7c$export$d9468344d3651243,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$f297162cf5d656b2 = /* #__PURE__ */ (0, $ff11099601f7a485$export$4bdc90311ec7c1dd)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$50d414a77b60d802 = /* #__PURE__ */ (0, $dcca3b987b6790eb$export$923b60dfa791c630)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$ca7427e8bf42a21b = /* #__PURE__ */ (0, $fae53b9923fcb02b$export$9160aa3a39425fc9)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$c9f5652083b8129d = /* #__PURE__ */ (0, $e4bfeeaf868ddf25$export$f85085363cf09711)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$8676dd5fabd5ee34 = /* #__PURE__ */ (0, $1944a198df7f372f$export$4e02350f5fb7a050)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$3c5f89dae98e900b = /* #__PURE__ */ (0, $c59a322413f08e7c$export$e158da47ae479dd4)({
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$becbc39f348ea65e = /* #__PURE__ */ (0, $306076fad9180d2e$export$97a0cf2b7d31f38b)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$545004b505d7c555 = /* #__PURE__ */ (0, $8e14d9c263a8a0f8$export$c3a62182c56878d5)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$b6b7e189aa5d134c = /* #__PURE__ */ (0, $2e38ec0cdadeb1a4$export$89ff03fdb3964a99)({
    SparseMatrix: $bed779fa205b8d7c$export$de9b2b7556879848,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$eba8049fb5020b81 = /* #__PURE__ */ (0, $c1c695cc0f242d01$export$eb18ce1988c5f19c)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$7128670e45beef9a = /* #__PURE__ */ (0, $381e84b17f4f72ed$export$e1f66a5bda779194)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$6cd304851a69e08 = /* #__PURE__ */ (0, $ff4d8ade2c8d9d49$export$939e1be6e134f392)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$6faaac9ab79fd3a4 = /* #__PURE__ */ (0, $eebe0a93cbf83e73$export$67e40c7fd8f5703a)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$ef569ec50496610c = /* #__PURE__ */ (0, $b4f24371aeeb165a$export$c5598f542ea1565c)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$7f34ce79760854f7 = /* #__PURE__ */ (0, $ee5e0aa1b0a5d1a9$export$de147ca8498e0312)({
    Fraction: $bed779fa205b8d7c$export$b336c2702c498be5,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$e90fb89750dba83f = /* #__PURE__ */ (0, $11e94d2787bb4994$export$85b0631fa122b7f1)({
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$9bdad1ae37d738e0 = /* #__PURE__ */ (0, $199f1076ce182c10$export$f3cf8b510f9cb8ab)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    Matrix: $bed779fa205b8d7c$export$5b12bf1653c0dd85,
    SparseMatrix: $bed779fa205b8d7c$export$de9b2b7556879848,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$7860df605315d572 = /* #__PURE__ */ (0, $9c8650853386b120$export$983d2c97138363e0)({
    isZero: $bed779fa205b8d7c$export$c46ec7d82fb1f602,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$842a2cf37af977e1 = /* #__PURE__ */ (0, $fa3529761d10d542$export$735bb6c30160c058)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$cc5da69d359d7991 = /* #__PURE__ */ (0, $a128cb85fc14281f$export$964e38ef60b1ac68)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$b7a508fa8dae59fc = /* #__PURE__ */ (0, $a7ac5e97e6c87c05$export$e3cf2d123164e554)({
    bignumber: $bed779fa205b8d7c$export$8576f72eb7f14a7e,
    fraction: $bed779fa205b8d7c$export$7f34ce79760854f7,
    number: $bed779fa205b8d7c$export$98e628dec113755e
});
var $bed779fa205b8d7c$export$252bb8b3bbdf6749 = /* #__PURE__ */ (0, $cc0486a759f71602$export$3d19b09907d6fd4a)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$5e143010dea16c85 = /* #__PURE__ */ (0, $5c3ba90b076e82c1$export$60310f756e9cfd41)({
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    numeric: $bed779fa205b8d7c$export$b7a508fa8dae59fc,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$9eaad88cf88cee2b = /* #__PURE__ */ (0, $b2013f42cf679ffd$export$76c9752f34fb3440)({
    isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$346677f925de839c = /* #__PURE__ */ (0, $c9f4857e58101d5d$export$9151c23a59ce3fb6)({
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$3f732695c1493aec = /* #__PURE__ */ (0, $e72de5f9a305542d$export$6b477d90b957f03e)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$889c931173b77c2f = /* #__PURE__ */ (0, $8075455fb6180966$export$1a885844ffd505a4)({
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$e06bd7b1ab877a71 = /* #__PURE__ */ (0, $6bf0a697d4bb28ee$export$d8c56e74d683bb33)({
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$4e2d2ead65e5f7e3 = /* #__PURE__ */ (0, $61cfdedf377cd0ed$export$cd7a6c131b18ab16)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    unaryMinus: $bed779fa205b8d7c$export$6cd304851a69e08
});
var $bed779fa205b8d7c$export$2c618a4308a30424 = /* #__PURE__ */ (0, $00c2484649264bfd$export$6e6c19ceb4cd6856)({
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$9cb09a71b7d66923 = /* #__PURE__ */ (0, $5c8e110e83150124$export$9a8c88485f8f638b)({
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$6ba103b0465fe6cc = /* #__PURE__ */ (0, $d7d2329bae0bdbeb$export$de8cbd18c98bf9d5)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$4445a00dafa2633b = /* #__PURE__ */ (0, $ecd50cd80ce67ac0$export$13096c1635fe6e3d)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$21c0ac7fe1cef1b8 = /* #__PURE__ */ (0, $6365a3a8a2647722$export$15a698d88cae0eff)({
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    not: $bed779fa205b8d7c$export$6003a5f097c73977,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    zeros: $bed779fa205b8d7c$export$4445a00dafa2633b
});
var $bed779fa205b8d7c$export$a74ff8d3fdef72fc = /* #__PURE__ */ (0, $0eb069adb3ca2bbc$export$bea4e06c5befec3b)({
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$bfcff4501301c191 = /* #__PURE__ */ (0, $1a25f56a5dfc1822$export$1cae728fa8e01928)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$841fc4d5a1480b85 = /* #__PURE__ */ (0, $e70bdb67e3f771ce$export$2103fed9c34b0004)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    Fraction: $bed779fa205b8d7c$export$b336c2702c498be5,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    isNegative: $bed779fa205b8d7c$export$d0909a4f38b5c4d0,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    unaryMinus: $bed779fa205b8d7c$export$6cd304851a69e08
});
var $bed779fa205b8d7c$export$398604a469f7de9a = /* #__PURE__ */ (0, $9c205cf301f4a645$export$a6e723c0e3b918d4)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    Fraction: $bed779fa205b8d7c$export$b336c2702c498be5,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$2da9287da10b19e2 = /* #__PURE__ */ (0, $d8f75931f26ea1d2$export$3e578d0534ab5935)({
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$ee1b3e54f0441b22 = /* #__PURE__ */ (0, $a08e4bc6f360edf5$export$c36b5511b12560e8)({
    isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$85b9a36db797e02b = /* #__PURE__ */ (0, $1187bcc945cde180$export$decd32c762b504bc)({
    prod: $bed779fa205b8d7c$export$5e143010dea16c85,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$eb6ad7870b1d0b0b = /* #__PURE__ */ (0, $0cf9f0bdf47c9467$export$5d07146b3894f212)({
    conj: $bed779fa205b8d7c$export$fb254c661fe9c0db,
    transpose: $bed779fa205b8d7c$export$9cb09a71b7d66923,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$c042e7c2f59bc046 = /* #__PURE__ */ (0, $292157f960c71f3f$export$743a950f2cd4bacc)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    SparseMatrix: $bed779fa205b8d7c$export$de9b2b7556879848,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$67275f837d70084d = /* #__PURE__ */ (0, $e265b0dea50e77d7$export$399593177816ff82)({
    numeric: $bed779fa205b8d7c$export$b7a508fa8dae59fc,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$c74f132961c51406 = /* #__PURE__ */ (0, $2f4f0fc5426630eb$export$e4930a420a373a24)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$411ce8e5a71e3069 = /* #__PURE__ */ (0, $213c875c686f103c$export$988f37bc1f709b0d)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$a535ef183b6128fa = /* #__PURE__ */ (0, $b822c93efe1e3bd7$export$41ce8d9733cb73c1)({
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    exp: $bed779fa205b8d7c$export$b310ec824aaee37f,
    i: $bed779fa205b8d7c$export$23f2a1d2818174ef,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    tau: $bed779fa205b8d7c$export$a4b4b4d4d776fe92,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$bffa455ba8c619a6 = /* #__PURE__ */ (0, $40df0a4579b1d367$export$107988e3ee9f3d12)({
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$f81847884871263e = /* #__PURE__ */ (0, $823068d9c91a7a49$export$2eb8acc96c598512)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$f6fc628e09f3ff5d = /* #__PURE__ */ (0, $20ef53407c994c0c$export$acff9f91b891ace6)({
    isNumeric: $bed779fa205b8d7c$export$e90fb89750dba83f,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$f95c7888b62f8e9a = /* #__PURE__ */ (0, $fdb0409149ca1269$export$87e3687740a09cb)({
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    isPositive: $bed779fa205b8d7c$export$7e69d4236fcc3b19,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    smaller: $bed779fa205b8d7c$export$3f732695c1493aec,
    sqrt: $bed779fa205b8d7c$export$eba8049fb5020b81,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$776649b0bf8ce1fd = /* #__PURE__ */ (0, $fd735f13075fb9a0$export$fb893320704d694a)({
    conj: $bed779fa205b8d7c$export$fb254c661fe9c0db,
    dotDivide: $bed779fa205b8d7c$export$c74f132961c51406,
    fft: $bed779fa205b8d7c$export$a535ef183b6128fa,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$44f32dfde3d58545 = /* #__PURE__ */ (0, $e1c5b87aee7e3853$export$cee275bf38ddc295)({
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$72693dfc692346df = /* #__PURE__ */ (0, $8b0fee74312464cb$export$26aa7f5b5fee1150)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$48901d58d322262f = /* #__PURE__ */ (0, $9a14c9a977308573$export$ce15600b23f5e78)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    zeros: $bed779fa205b8d7c$export$4445a00dafa2633b
});
var $bed779fa205b8d7c$export$be3b83cc1aa539e4 = /* #__PURE__ */ (0, $6da940a9c2b9be9a$export$1b88d04961967a10)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$e8999e227859a482 = /* #__PURE__ */ (0, $08e848efca6908c4$export$65fefc9f63da4d13)({
    flatten: $bed779fa205b8d7c$export$bffa455ba8c619a6,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$96ec731ed4dcb222 = /* #__PURE__ */ (0, $6c5d3a7a97f7f6e5$export$b795f47e2b99170)({
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    numeric: $bed779fa205b8d7c$export$b7a508fa8dae59fc,
    smaller: $bed779fa205b8d7c$export$3f732695c1493aec,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$549ff81930776885 = /* #__PURE__ */ (0, $bea4d437980b171e$export$822530980ba269d9)({
    isNaN: $bed779fa205b8d7c$export$c9f5652083b8129d,
    isNumeric: $bed779fa205b8d7c$export$e90fb89750dba83f,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$adb173527af10aca = /* #__PURE__ */ (0, $bae3d9c8768a3833$export$36e27b45d2aa738c)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$21041dee6b8001b0 = /* #__PURE__ */ (0, $f8bd29f490666f55$export$f524a435b9c16a90)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$54d1e322cf7aa273 = /* #__PURE__ */ (0, $4940426141ad1d0d$export$47c1a746705f5c42)({
    compare: $bed779fa205b8d7c$export$398604a469f7de9a,
    isNaN: $bed779fa205b8d7c$export$c9f5652083b8129d,
    isNumeric: $bed779fa205b8d7c$export$e90fb89750dba83f,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$4380c87abf28fdf = /* #__PURE__ */ (0, $c5c8833e96575b06$export$58909557046ca413)({
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0
});
var $bed779fa205b8d7c$export$a1da16976d3a5f68 = /* #__PURE__ */ (0, $c66aa75ad1eb6247$export$ef742376390cbf7)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    zeros: $bed779fa205b8d7c$export$4445a00dafa2633b
});
var $bed779fa205b8d7c$export$2077e0241d6afd3c = /* #__PURE__ */ (0, $dc81f66c0e39e53a$export$c41ddfead54b1fbc)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    zeros: $bed779fa205b8d7c$export$4445a00dafa2633b
});
var $bed779fa205b8d7c$export$8d38c87f33a93d98 = /* #__PURE__ */ (0, $26fdadb7586338bc$export$e1b2fff975be9083)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$b20c1c5fa0c7dd75 = /* #__PURE__ */ (0, $c00f679dc7586e06$export$833e6c382e279d04)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$41828460570e21eb = /* #__PURE__ */ (0, $63bcd5f260b641f1$export$f652f5e8e3e838da)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$6444ef5cd411280c = /* #__PURE__ */ (0, $7b40147032659d57$export$a2b8cab2c7385f0e)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$e16d8520af44a096 = /* #__PURE__ */ (0, $165750d8541756e9$export$c6b51545da64d82f)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    SparseMatrix: $bed779fa205b8d7c$export$de9b2b7556879848,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$b8b770ee6a0d9760 = /* #__PURE__ */ (0, $ec0ad837a8ecf196$export$c56716e11a38354e)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$361eb278cc70bacf = /* #__PURE__ */ (0, $bcc20db561cde5a8$export$f45a7846535e9b07)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$d8807a6c0487483a = /* #__PURE__ */ (0, $6f641cd1741589d4$export$5a3f7692f3d4dd50)({
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    combinations: $bed779fa205b8d7c$export$bdfcf4c6b5766439,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
    isNegative: $bed779fa205b8d7c$export$d0909a4f38b5c4d0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$762e84baec56595d = /* #__PURE__ */ (0, $d7387473996ac08f$export$ac9dd39e43534605)({
    compare: $bed779fa205b8d7c$export$398604a469f7de9a,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$71990b1e1c4912fe = /* #__PURE__ */ (0, $1ffc641b3300209d$export$e11ffe2ce577c262)({
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    unaryPlus: $bed779fa205b8d7c$export$df8c837ae5df4ce4
});
var $bed779fa205b8d7c$export$9cb4719e2e525b7a = /* #__PURE__ */ (0, $8cc4e85650e794bb$export$b1b11fc839367b58)({
    equal: $bed779fa205b8d7c$export$411ce8e5a71e3069,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$a37e3c603d7117e5 = /* #__PURE__ */ (0, $54b1b5983775b69c$export$49df08fd121951b4)({
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    number: $bed779fa205b8d7c$export$98e628dec113755e,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$94132a0e348806d4 = /* #__PURE__ */ (0, $dc1481857435092d$export$3dc59ff00984d687)({
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    conj: $bed779fa205b8d7c$export$fb254c661fe9c0db,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$5bc21f656fb5d284 = /* #__PURE__ */ (0, $418b3e9d1661e179$export$1589aaa29568b87)({
    compareText: $bed779fa205b8d7c$export$2da9287da10b19e2,
    isZero: $bed779fa205b8d7c$export$c46ec7d82fb1f602,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$a3fe094919f356fd = /* #__PURE__ */ (0, $24c5519c293b10ca$export$e04e4803a9128c9b)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    round: $bed779fa205b8d7c$export$2077e0241d6afd3c,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    zeros: $bed779fa205b8d7c$export$4445a00dafa2633b
});
var $bed779fa205b8d7c$export$f0954fd7d5368655 = /* #__PURE__ */ (0, $852c3f8bd303942b$export$2eca89e9ac669625)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    SparseMatrix: $bed779fa205b8d7c$export$de9b2b7556879848,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$5c1ba7f73c917315 = /* #__PURE__ */ (0, $b4606295304ff90e$export$1e04c9355dadf1c8)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    equal: $bed779fa205b8d7c$export$411ce8e5a71e3069,
    isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
    mod: $bed779fa205b8d7c$export$842a2cf37af977e1,
    smaller: $bed779fa205b8d7c$export$3f732695c1493aec,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    xgcd: $bed779fa205b8d7c$export$6ba103b0465fe6cc
});
var $bed779fa205b8d7c$export$a94a7414fa942aea = /* #__PURE__ */ (0, $6b7b92b9e5bcba58$export$af9bc16ae70e9aa8)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$bef1f36f5486a6a3 = /* #__PURE__ */ (0, $471dd5220326217f$export$aea8a16d5c9d1b93)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$de5c6af4003ef448 = /* #__PURE__ */ (0, $9634d31bbd877a55$export$70743fd0ad1f42d7)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$f4f4b934de52d430 = /* #__PURE__ */ (0, $684d6e0dd088a86f$export$b72d61f960d7c36b)({
    flatten: $bed779fa205b8d7c$export$bffa455ba8c619a6,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$2060d2db72cce88f = /* #__PURE__ */ (0, $039c29510f5f4675$export$86d08fd318fa07c8)({
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    dot: $bed779fa205b8d7c$export$94132a0e348806d4,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$7c27fb47516129d9 = /* #__PURE__ */ (0, $c0e7843ca654b723$export$39b52312ba2c4d03)({
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    complex: $bed779fa205b8d7c$export$83a0e34f1302825b,
    conj: $bed779fa205b8d7c$export$fb254c661fe9c0db,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    equal: $bed779fa205b8d7c$export$411ce8e5a71e3069,
    identity: $bed779fa205b8d7c$export$f0954fd7d5368655,
    isZero: $bed779fa205b8d7c$export$c46ec7d82fb1f602,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    sign: $bed779fa205b8d7c$export$c5552dfdbc7cec71,
    sqrt: $bed779fa205b8d7c$export$eba8049fb5020b81,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    unaryMinus: $bed779fa205b8d7c$export$6cd304851a69e08,
    zeros: $bed779fa205b8d7c$export$4445a00dafa2633b
});
var $bed779fa205b8d7c$export$d02631cccf789723 = /* #__PURE__ */ (0, $1f3643faa6d2156c$export$d372f2f3c4d1b8e5)({
    bignumber: $bed779fa205b8d7c$export$8576f72eb7f14a7e,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
    largerEq: $bed779fa205b8d7c$export$72693dfc692346df,
    smaller: $bed779fa205b8d7c$export$3f732695c1493aec,
    smallerEq: $bed779fa205b8d7c$export$8d38c87f33a93d98,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$502f8a5a1147da = /* #__PURE__ */ (0, $cc5bb041bccab06e$export$2dd001e9fd66adcd)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    zeros: $bed779fa205b8d7c$export$4445a00dafa2633b
});
var $bed779fa205b8d7c$export$1c70a6cc12bc0366 = /* #__PURE__ */ (0, $9188e7c34789cc6e$export$55134310fc79366a)({
    compareNatural: $bed779fa205b8d7c$export$762e84baec56595d,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$95c7459688ef4e3a = /* #__PURE__ */ (0, $3527f7e8ae9be964$export$e44ac9822ce417ae)({
    SparseMatrix: $bed779fa205b8d7c$export$de9b2b7556879848,
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
    largerEq: $bed779fa205b8d7c$export$72693dfc692346df,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    transpose: $bed779fa205b8d7c$export$9cb09a71b7d66923,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$8a63f25cc62965f1 = /* #__PURE__ */ (0, $583973e5c597423f$export$14d444d810bc35b5)({
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    numeric: $bed779fa205b8d7c$export$b7a508fa8dae59fc,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$357889f174732d38 = /* #__PURE__ */ (0, $e111385d1c31411b$export$acff8254414be03b)({
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$c8a1cf0e83678d9 = /* #__PURE__ */ (0, $a63e1284442e6298$export$c8bbc8bec60c7fc3)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$41726bdb1fc63f = /* #__PURE__ */ (0, $2da105de6a9ebe93$export$5f05d91ddc56bc14)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$803ce6b71a0a94b2 = /* #__PURE__ */ (0, $4a2f381b6ba30e6c$export$bab247d909829ddf)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    round: $bed779fa205b8d7c$export$2077e0241d6afd3c,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    zeros: $bed779fa205b8d7c$export$4445a00dafa2633b
});
var $bed779fa205b8d7c$export$fd2cf6bce05a0b18 = /* #__PURE__ */ (0, $20d65ad76b85c91d$export$1ddf9cbadd17315f)({
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    combinations: $bed779fa205b8d7c$export$bdfcf4c6b5766439,
    isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
    isNegative: $bed779fa205b8d7c$export$d0909a4f38b5c4d0,
    isPositive: $bed779fa205b8d7c$export$7e69d4236fcc3b19,
    larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$bb646b20bb93d339 = /* #__PURE__ */ (0, $5669faf581ad4517$export$bc2585c0ed744c0e)({
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$d063d65fed97e7fa = /* #__PURE__ */ (0, $505fb7024bf95a58$export$93f810683c54b005)({
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    isZero: $bed779fa205b8d7c$export$c46ec7d82fb1f602,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    unaryMinus: $bed779fa205b8d7c$export$6cd304851a69e08
});
var $bed779fa205b8d7c$export$9f17032d917177de = /* #__PURE__ */ (0, $012e689cf7e69dcb$export$23f482ad1a94fa7e)({
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    sqrt: $bed779fa205b8d7c$export$eba8049fb5020b81,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    unaryMinus: $bed779fa205b8d7c$export$6cd304851a69e08
});
var $bed779fa205b8d7c$export$c6d93afbf4ee8afc = /* #__PURE__ */ (0, $3043bfe628ca0380$export$a4620e84460f321e)({
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$dd5bb73729f20aa3 = /* #__PURE__ */ (0, $2ea7a6ca53421abc$export$3143a09e27a84c41)({
    larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
    smaller: $bed779fa205b8d7c$export$3f732695c1493aec
});
var $bed779fa205b8d7c$export$d838837eb5b184e3 = /* #__PURE__ */ (0, $848db03932484735$export$3ed06081b8a4ee6)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    ceil: $bed779fa205b8d7c$export$803ce6b71a0a94b2,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    floor: $bed779fa205b8d7c$export$a3fe094919f356fd,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    zeros: $bed779fa205b8d7c$export$4445a00dafa2633b
});
var $bed779fa205b8d7c$export$66fe727d7ec8c7b9 = /* #__PURE__ */ (0, $049153ac255ea4af$export$49a565643b9ab608)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    smaller: $bed779fa205b8d7c$export$3f732695c1493aec
});
var $bed779fa205b8d7c$export$cf17b003b6192af3 = /* #__PURE__ */ (0, $cf7fbbe5a9154dba$export$300720b4fe34e62e)({
    ImmutableDenseMatrix: $bed779fa205b8d7c$export$66fe727d7ec8c7b9
});
var $bed779fa205b8d7c$export$1f4807a235930d45 = /* #__PURE__ */ (0, $d4d9c54a71d248b2$export$e2d92d8f89fdd92d)({
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    flatten: $bed779fa205b8d7c$export$bffa455ba8c619a6,
    isNumeric: $bed779fa205b8d7c$export$e90fb89750dba83f,
    isZero: $bed779fa205b8d7c$export$c46ec7d82fb1f602,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    smaller: $bed779fa205b8d7c$export$3f732695c1493aec,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$f686d97e407ec4ef = /* #__PURE__ */ (0, $a3045b8800fd0820$export$5d3af1956d9bb33b)({
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$144dcf16adfb9698 = /* #__PURE__ */ (0, $e9f88e29ad122b34$export$93da279859a704f0)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    log: $bed779fa205b8d7c$export$bef1f36f5486a6a3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$8960430cfd85939f = /* #__PURE__ */ (0, $cba3fdd1ff2350ea$export$b18a1b0c26c000ee)({
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
    numeric: $bed779fa205b8d7c$export$b7a508fa8dae59fc,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$ff63ee916cadcfe = /* #__PURE__ */ (0, $fc8c3b9f19fe3038$export$524607d17ea053e9)({
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    compare: $bed779fa205b8d7c$export$398604a469f7de9a,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    partitionSelect: $bed779fa205b8d7c$export$54d1e322cf7aa273,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$120ff0929b202a6d = /* #__PURE__ */ (0, $1d936a877a324b9b$export$3442c5d213434705)({
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    range: $bed779fa205b8d7c$export$d02631cccf789723,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$dcac7a71ff10ad82 = /* #__PURE__ */ (0, $ec2116155f4a3747$export$9fa12a9d198718c8)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    compareNatural: $bed779fa205b8d7c$export$762e84baec56595d,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$ec60221e756bab15 = /* #__PURE__ */ (0, $23c9218fe295927f$export$c149680b9d8f2963)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    compareNatural: $bed779fa205b8d7c$export$762e84baec56595d,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$ca5251f59a067f9a = /* #__PURE__ */ (0, $d7cd54c960d47b27$export$40ad73493b9f8712)({
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    compareNatural: $bed779fa205b8d7c$export$762e84baec56595d,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$f6ce4c11993e56f2 = /* #__PURE__ */ (0, $09c13ea186f3bb8d$export$55c6b5cb0b0637db)({
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    compareNatural: $bed779fa205b8d7c$export$762e84baec56595d,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$97db5808d8f88186 = /* #__PURE__ */ (0, $ae63fe71060c4c24$export$10463693a2093403)({
    compare: $bed779fa205b8d7c$export$398604a469f7de9a,
    compareNatural: $bed779fa205b8d7c$export$762e84baec56595d,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$4e0c71f277ca26b3 = /* #__PURE__ */ (0, $6fe5fc677152824f$export$1bfa986e9c92c0b5)({
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    range: $bed779fa205b8d7c$export$d02631cccf789723,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$b610b8812bbcded9 = /* #__PURE__ */ (0, $f80e0fb9f9e3e794$export$c6d108d7c8095f19)({
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$c02accee9f2b6a8f = /* #__PURE__ */ (0, $1609836b2ebed995$export$ad9771ef9eafe06a)({
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    det: $bed779fa205b8d7c$export$d063d65fed97e7fa,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    identity: $bed779fa205b8d7c$export$f0954fd7d5368655,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    unaryMinus: $bed779fa205b8d7c$export$6cd304851a69e08
});
var $bed779fa205b8d7c$export$5cde0f23b96c7c61 = /* #__PURE__ */ (0, $b170176d7e0038ab$export$1456c5eaeee6aa07)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    ctranspose: $bed779fa205b8d7c$export$eb6ad7870b1d0b0b,
    deepEqual: $bed779fa205b8d7c$export$9cb4719e2e525b7a,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    dot: $bed779fa205b8d7c$export$94132a0e348806d4,
    dotDivide: $bed779fa205b8d7c$export$c74f132961c51406,
    equal: $bed779fa205b8d7c$export$411ce8e5a71e3069,
    inv: $bed779fa205b8d7c$export$c02accee9f2b6a8f,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$9c297f60e22e3389 = /* #__PURE__ */ (0, $15bf360b0492d6be$export$9c94d2d08a8d8146)({
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    fraction: $bed779fa205b8d7c$export$7f34ce79760854f7,
    identity: $bed779fa205b8d7c$export$f0954fd7d5368655,
    inv: $bed779fa205b8d7c$export$c02accee9f2b6a8f,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    number: $bed779fa205b8d7c$export$98e628dec113755e,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$8bd517cc5b3722f7 = /* #__PURE__ */ (0, $a57af78f1a255d75$export$d81c0f9dab86d854)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    compareNatural: $bed779fa205b8d7c$export$762e84baec56595d,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$8bb4a52260216736 = /* #__PURE__ */ (0, $8cf2a7f50d42faf7$export$d1f961d649e525df)({
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    compareNatural: $bed779fa205b8d7c$export$762e84baec56595d,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$6d4069f4b64f7492 = /* #__PURE__ */ (0, $4a16c0cb547a60b2$export$5e37e847685a0540)({
    FibonacciHeap: $bed779fa205b8d7c$export$dd5bb73729f20aa3,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156
});
var $bed779fa205b8d7c$export$17c7cd2216e18593 = /* #__PURE__ */ (0, $02b4e496a8575f9f$export$71d0f952576e7511)({
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    identity: $bed779fa205b8d7c$export$f0954fd7d5368655,
    inv: $bed779fa205b8d7c$export$c02accee9f2b6a8f,
    max: $bed779fa205b8d7c$export$8960430cfd85939f,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    sqrt: $bed779fa205b8d7c$export$eba8049fb5020b81,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$1d8b9ae22d404866 = /* #__PURE__ */ (0, $ff7711f29b636d73$export$3ad06557a3ac7a63)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    Fraction: $bed779fa205b8d7c$export$b336c2702c498be5,
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    equal: $bed779fa205b8d7c$export$411ce8e5a71e3069,
    fix: $bed779fa205b8d7c$export$d838837eb5b184e3,
    format: $bed779fa205b8d7c$export$d9468344d3651243,
    isNumeric: $bed779fa205b8d7c$export$e90fb89750dba83f,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    number: $bed779fa205b8d7c$export$98e628dec113755e,
    pow: $bed779fa205b8d7c$export$9c297f60e22e3389,
    round: $bed779fa205b8d7c$export$2077e0241d6afd3c,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3
});
var $bed779fa205b8d7c$export$4b15dbe639ad9539 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$c9ff08d282f03cf0)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$2bcc1e96766dec50 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$3c74568e9574d168)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$11b531e5540c3ca4 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$2f8d2da219209d0a)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$c779781d69f736e8 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$f5851397fd1173db)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$f727e86dcab4e2c6 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$221b7a8c9510b6cc)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$6eafe330bdda8c71 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$e26bbd27fc291ddf)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$aab44654646f3ccc = /* #__PURE__ */ (0, $de2041ace057e0bb$export$27641941eb5cadbb)({
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$80bf07f129ad1319 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$a403f6c5bed71f22)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$ef3b15136279c2ab = /* #__PURE__ */ (0, $2e69e7700ff47253$export$734b49568d8effd6)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    pow: $bed779fa205b8d7c$export$9c297f60e22e3389,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$11ff82822f958f25 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$d69030cf93f04407)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$199cdfec7f52c877 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$542715ad7e3a9798)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$d9bacaa51f70e8e = /* #__PURE__ */ (0, $85259d56fb40c4ba$export$f2c0a6357ff6cb4c)({
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    identity: $bed779fa205b8d7c$export$f0954fd7d5368655,
    inv: $bed779fa205b8d7c$export$c02accee9f2b6a8f,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$7130fbae042d5c0f = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$17ef8d738c9b0091)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$f83f3c3b84952e0b = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$266a9bae8a62fb6e)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$a7ebe8cc6aaf8d37 = /* #__PURE__ */ (0, $e2a6f07303f719c0$export$115da31fc3cf3d15)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    pow: $bed779fa205b8d7c$export$9c297f60e22e3389,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$d9cccfa50756330b = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$157e78cb05354391)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$37b0dd3693d47685 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$8bb818baeaa40bd6)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$10054c6b64de12f5 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$e3f21ac13bee6a0f)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$9eedba962d6a1c01 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$c38bce537e0ffddb)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$ba3f3691dd1c5a7 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$e7fcb8898ecb0703)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$6d4ff429f3f89356 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$85414d775c93e6de)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$dacf4a2cf8881dff = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$12e2358797b853c9)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$ba7a41eda790cc15 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$676d5ebe8fbeb250)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$7274fb1d27d1cd19 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$9670d94122b9a81b)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$9b1b4e5bc980cec6 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$43e139a6eec1ab59)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$c20ab336465d7d5e = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$675ebbcd6bdcebd7)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$5a85cd1a26c2cced = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$d21f20fc89fac8c0)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$1c88a737209eb089 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$f357c1a8d4fccef6)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$963167ae5579ea00 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$50bee65ab76b402)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$683732ab8f5759dc = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$fd1b48ecb0d5c0ef)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$9404cfefeb010e68 = /* #__PURE__ */ (0, $054e972ee136ed95$export$b20ee2bdfbf6defd)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    compareNatural: $bed779fa205b8d7c$export$762e84baec56595d,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$5d66ae3b3e8fce48 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$ace78258608300fc)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$f63e81544c3d56ef = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$a943525a62f69cd2)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$93039724ea765a8e = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$229739a879741f68)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$1236f2451dbdfd63 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$4924e3d8de6ad850)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$5a57f82afcc3edeb = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$19b72356ad84e4ee)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$2f2e110dac549211 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$815f2029cd62d0d6)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$cd007d971a5a2143 = /* #__PURE__ */ (0, $f5048ea0a84c29ec$export$4df5e56bb6d14758)({
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    inv: $bed779fa205b8d7c$export$c02accee9f2b6a8f,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$c00fb43e712bef2c = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$85362d2a7862e209)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$329ce89a99f0e343 = /* #__PURE__ */ (0, $71f84c34a81f2c01$export$92c37ad44e3d0481)({
    gamma: $bed779fa205b8d7c$export$a7ebe8cc6aaf8d37,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$bfb00cec0048377d = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$42b5845f95e0feee)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$f060c4f0aa5bef89 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$f2f136373157165b)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$91d2d01a33a1e6f8 = /* #__PURE__ */ (0, $5e1d678989975f92$export$86ddf344397699d5)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    Spa: $bed779fa205b8d7c$export$6d4069f4b64f7492,
    SparseMatrix: $bed779fa205b8d7c$export$de9b2b7556879848,
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    unaryMinus: $bed779fa205b8d7c$export$6cd304851a69e08
});
var $bed779fa205b8d7c$export$699e2a89b148c5ee = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$fd46b6c8680e4d01)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$9589ebe123df8f2e = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$d5045cf71611a462)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$f4d580f3101a1c7e = /* #__PURE__ */ (0, $4f976f0e5fcf1860$export$b15aee1001d110)({
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    divide: $bed779fa205b8d7c$export$cd007d971a5a2143,
    factorial: $bed779fa205b8d7c$export$329ce89a99f0e343,
    isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
    isPositive: $bed779fa205b8d7c$export$7e69d4236fcc3b19,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$4567adbe5dd91621 = /* #__PURE__ */ (0, $ffd61eaf80563e5a$export$1d58d7915914cc9c)({
    factorial: $bed779fa205b8d7c$export$329ce89a99f0e343,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$5ce790af25e5ac75 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$d44b96c94520b20e)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$5d88bfa2004001d3 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$6840f334b8a5b6b1)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$1f7c42a78c01e4f9 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$ea93a35a6f35e1b6)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$a5abae3de3985f2f = /* #__PURE__ */ (0, $7a5bf86ddba77b1a$export$18813d136a9b83d0)({
    bignumber: $bed779fa205b8d7c$export$8576f72eb7f14a7e,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    combinations: $bed779fa205b8d7c$export$bdfcf4c6b5766439,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    factorial: $bed779fa205b8d7c$export$329ce89a99f0e343,
    isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
    isNegative: $bed779fa205b8d7c$export$d0909a4f38b5c4d0,
    larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    number: $bed779fa205b8d7c$export$98e628dec113755e,
    pow: $bed779fa205b8d7c$export$9c297f60e22e3389,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$523c0b569236b342 = /* #__PURE__ */ (0, $c160b7e6f9fbf5ba$export$17074f98b69d2545)({
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$bb522a71cda46a13 = /* #__PURE__ */ (0, $0f0c535893f780a2$export$7b7dc3bd00d38afb)({
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
    isNegative: $bed779fa205b8d7c$export$d0909a4f38b5c4d0,
    stirlingS2: $bed779fa205b8d7c$export$a5abae3de3985f2f,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$e822b38c59ee8a2a = /* #__PURE__ */ (0, $00e0ec84f48d888d$export$ba9e077a2df092d7)({
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    atan: $bed779fa205b8d7c$export$628dc4eed22b0fbd,
    bignumber: $bed779fa205b8d7c$export$8576f72eb7f14a7e,
    column: $bed779fa205b8d7c$export$4e0c71f277ca26b3,
    complex: $bed779fa205b8d7c$export$83a0e34f1302825b,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    cos: $bed779fa205b8d7c$export$50d414a77b60d802,
    diag: $bed779fa205b8d7c$export$c042e7c2f59bc046,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    dot: $bed779fa205b8d7c$export$94132a0e348806d4,
    equal: $bed779fa205b8d7c$export$411ce8e5a71e3069,
    flatten: $bed779fa205b8d7c$export$bffa455ba8c619a6,
    im: $bed779fa205b8d7c$export$5fc500b917996661,
    inv: $bed779fa205b8d7c$export$c02accee9f2b6a8f,
    larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    matrixFromColumns: $bed779fa205b8d7c$export$e8999e227859a482,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    number: $bed779fa205b8d7c$export$98e628dec113755e,
    qr: $bed779fa205b8d7c$export$7c27fb47516129d9,
    re: $bed779fa205b8d7c$export$b1f1627d659a651,
    sin: $bed779fa205b8d7c$export$5de3937cb4b592ed,
    smaller: $bed779fa205b8d7c$export$3f732695c1493aec,
    sqrt: $bed779fa205b8d7c$export$eba8049fb5020b81,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    usolve: $bed779fa205b8d7c$export$41828460570e21eb,
    usolveAll: $bed779fa205b8d7c$export$c8a1cf0e83678d9
});
var $bed779fa205b8d7c$export$84a9a66802fec40 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$b6687a2f3911256b)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$1ce691f85baaa52 = /* #__PURE__ */ (0, $10a1e69809a3890c$export$301ef7ca1de6782c)({
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    divide: $bed779fa205b8d7c$export$cd007d971a5a2143,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$863459416408c428 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$f5e8f56ebfacbaca)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$cbd33810258dab2e = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$e58ff8150d83ea6a)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$a7eac91d5496c35b = /* #__PURE__ */ (0, $5eab92963756711c$export$4a9a0ead2012bfc4)({
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    concat: $bed779fa205b8d7c$export$ee1b3e54f0441b22,
    setDifference: $bed779fa205b8d7c$export$8bd517cc5b3722f7,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$f48a0c6b8cc21601 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$68a9771dccce9a23)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$fccc724a69f253a = /* #__PURE__ */ (0, $cdf4478490d5b2ea$export$a3f0777edf21dcd5)({
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    lsolve: $bed779fa205b8d7c$export$be3b83cc1aa539e4,
    lup: $bed779fa205b8d7c$export$91d2d01a33a1e6f8,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    slu: $bed779fa205b8d7c$export$95c7459688ef4e3a,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    usolve: $bed779fa205b8d7c$export$41828460570e21eb
});
var $bed779fa205b8d7c$export$9c490b34b2f16a34 = /* #__PURE__ */ (0, $41f4212f7361dbfc$export$cdebf3fc89add777)({
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    compare: $bed779fa205b8d7c$export$398604a469f7de9a,
    divide: $bed779fa205b8d7c$export$cd007d971a5a2143,
    partitionSelect: $bed779fa205b8d7c$export$54d1e322cf7aa273,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$667066422fa0af46 = /* #__PURE__ */ (0, $24a7bcebd15554ea$export$fbdfd2054d37f888)({
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    concat: $bed779fa205b8d7c$export$ee1b3e54f0441b22,
    setIntersect: $bed779fa205b8d7c$export$9404cfefeb010e68,
    setSymDifference: $bed779fa205b8d7c$export$a7eac91d5496c35b,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$9b77da0927470c3d = /* #__PURE__ */ (0, $b421b520bfd774f5$export$b989221824390fb)({
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    apply: $bed779fa205b8d7c$export$5635d7ef4b8fee1c,
    divide: $bed779fa205b8d7c$export$cd007d971a5a2143,
    isNaN: $bed779fa205b8d7c$export$c9f5652083b8129d,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$a9fffb6ae6e33dcc = /* #__PURE__ */ (0, $a420a2ea03e61460$export$eaa5cb8fd86b8d43)({
    divide: $bed779fa205b8d7c$export$cd007d971a5a2143,
    dotDivide: $bed779fa205b8d7c$export$c74f132961c51406,
    isNumeric: $bed779fa205b8d7c$export$e90fb89750dba83f,
    log: $bed779fa205b8d7c$export$bef1f36f5486a6a3,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    sum: $bed779fa205b8d7c$export$8a63f25cc62965f1,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$1991ecd29cc92c6b = /* #__PURE__ */ (0, $e94b67d2301140bc$export$ce85a9d2952c2966)({
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    conj: $bed779fa205b8d7c$export$fb254c661fe9c0db,
    ctranspose: $bed779fa205b8d7c$export$eb6ad7870b1d0b0b,
    eigs: $bed779fa205b8d7c$export$e822b38c59ee8a2a,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    pow: $bed779fa205b8d7c$export$9c297f60e22e3389,
    smaller: $bed779fa205b8d7c$export$3f732695c1493aec,
    sqrt: $bed779fa205b8d7c$export$eba8049fb5020b81,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$85aaf319784a5b0 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$3bf63d7b96fd8541)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$52ded331ee8b28e8 = /* #__PURE__ */ (0, $8f6b2496cc590404$export$7c79514a80dc15a2)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    SparseMatrix: $bed779fa205b8d7c$export$de9b2b7556879848,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    cos: $bed779fa205b8d7c$export$50d414a77b60d802,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    norm: $bed779fa205b8d7c$export$1991ecd29cc92c6b,
    sin: $bed779fa205b8d7c$export$5de3937cb4b592ed,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    unaryMinus: $bed779fa205b8d7c$export$6cd304851a69e08
});
var $bed779fa205b8d7c$export$a614e1ad972260a9 = /* #__PURE__ */ (0, $9fad9c9a56db7329$export$85a77a0842c24f74)({
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
var $bed779fa205b8d7c$export$b14c5e819cb6c927 = /* #__PURE__ */ (0, $33589fdb3f464f29$export$d3f0a8dda5df7afd)({
    sqrt: $bed779fa205b8d7c$export$eba8049fb5020b81,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    variance: $bed779fa205b8d7c$export$9b77da0927470c3d
});
var $bed779fa205b8d7c$export$b14ea41a64d6efa6 = /* #__PURE__ */ (0, $0856b6f5f0c05256$export$7b17fbe41c88575a)({
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    map: $bed779fa205b8d7c$export$871de8747c9eaa88,
    median: $bed779fa205b8d7c$export$9c490b34b2f16a34,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $bed779fa205b8d7c$export$bb628a54ab399bc9 = /* #__PURE__ */ (0, $4d0319c78e460cc0$export$484058214789ee04)({
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    rotationMatrix: $bed779fa205b8d7c$export$52ded331ee8b28e8,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});



class $5341e3bc0b86f0fc$export$3e0428823926e888 extends (0, $6f125744f8893ba5$export$94cd813f5440f38d) {
    displayItemContent(content, bindTarget) {
        const multipleCorrect = document.querySelector(".item .multiplecorrect");
        multipleCorrect.classList.remove("d-none");
        multipleCorrect.classList.add("invisible");
        const name = multipleCorrect.querySelector(".name");
        const prompt = multipleCorrect.querySelector(".prompt");
        const style = multipleCorrect.querySelector("style");
        name.innerHTML = content.name + ".";
        prompt.innerHTML = content.multiplecorrect.prompt;
        style.innerText = [].concat(content.multiplecorrect.style, content.contexts.map((c)=>c.style)).join("\n\n");
        Array.from(multipleCorrect.querySelectorAll(".context-panel")).slice(1).forEach((panel)=>{
            panel.remove();
        });
        const contextPanel = multipleCorrect.querySelector(".context-panel");
        const context = multipleCorrect.querySelector(".context");
        if (content.contexts.length > 0) {
            context.innerHTML = content.contexts[0].content_html;
            context.classList.remove("d-none");
            contextPanel.dataset.context = content.contexts[0].id;
            contextPanel.classList.remove("d-none");
            content.contexts.slice(1).reverse().forEach((_context)=>{
                const panel = contextPanel.cloneNode(true);
                const context = panel.querySelector(".context");
                context.innerHTML = _context.content_html;
                context.classList.remove("d-none");
                panel.dataset.context = _context.id;
                panel.classList.remove("d-none");
                panel.addEventListener("click", (e)=>{
                    bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$fe0b591ac3aa4171)([
                        panel.dataset.context
                    ]));
                });
                contextPanel.after(panel);
            });
        } else {
            context.innerHTML = "";
            context.classList.add("d-none");
            contextPanel.removeAttribute("data-context");
            contextPanel.classList.add("d-none");
        }
        const answers = multipleCorrect.querySelector(".answers");
        const answerTemplate = answers.querySelector(".answer").cloneNode(true);
        answers.innerHTML = "";
        content.multiplecorrect.answers.forEach((answerContent, index)=>{
            const answerNode = answerTemplate.cloneNode(true);
            const input = answerNode.querySelector("input[name=answer]");
            const label = answerNode.querySelector("label");
            const container = answerNode.querySelector(".content");
            container.innerHTML = answerContent.content;
            input.id = "mr-answer-" + answerContent.name;
            input.value = answerContent.name;
            label.setAttribute("for", "mr-answer-" + answerContent.name);
            answers.appendChild(answerNode);
        });
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        const multipleCorrect = document.querySelector(".item .multiplecorrect");
        const answerSet = new Set(answer ?? []);
        const answers = multipleCorrect.querySelector(".answers");
        content.multiplecorrect.answers.forEach((answerContent, index)=>{
            const answerNode = answers.children[index];
            const input = answerNode.querySelector("input[name=answer]");
            const label = answerNode.querySelector("label");
            input.addEventListener("change", (e)=>{
                const selected = Array.from(multipleCorrect.querySelectorAll("input[name=answer]")).filter((input)=>input.checked).map((input)=>input.value).sort();
                bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3dd7a8e950550ea4)(selected));
            });
            input.checked = answerSet.has(answerContent.name);
            if (answerSet.has(answerContent.name)) label.classList.add("border", "rounded", "bg-light");
            else label.classList.remove("border", "rounded", "bg-light");
        });
    }
    displayItemReview(content, answer) {
        const multipleCorrect = document.querySelector(".item .multiplecorrect");
        const answerSet = new Set(answer ?? []);
        const explanation = multipleCorrect.querySelector(".explanation");
        explanation.innerHTML = content.multiplecorrect.explanation;
        const explanationPanel = explanation.closest("div.card");
        const correct = document.querySelector(".correct");
        const correctAnswers = content.multiplecorrect.answers.filter((answerContent)=>answerContent.correct).map((answerContent)=>answerContent.name);
        // @ts-ignore math.setSymDifference expects a number[] but has been working with the string[] we've been giving it
        if (answer && $bed779fa205b8d7c$export$a7eac91d5496c35b(answer, correctAnswers).length <= 0) {
            correct.innerHTML = "Correct";
            correct.classList.remove("alert-danger", "alert-info");
            correct.classList.add("alert-success");
            explanationPanel.classList.remove("border-danger", "border-info");
            explanationPanel.classList.add("border-success");
        } else if (answer && answer.length > 0) {
            correct.innerHTML = "Incorrect";
            correct.classList.remove("alert-success", "alert-info");
            correct.classList.add("alert-danger");
            explanationPanel.classList.remove("border-success", "border-info");
            explanationPanel.classList.add("border-danger");
        } else {
            correct.innerHTML = "Unanswered";
            correct.classList.remove("alert-success", "alert-danger");
            correct.classList.add("alert-info");
            explanationPanel.classList.remove("border-success", "border-danger");
            explanationPanel.classList.add("border-info");
        }
        const answers = multipleCorrect.querySelector(".answers");
        content.multiplecorrect.answers.forEach((answerContent, index)=>{
            const answerNode = answers.children[index];
            const label = answerNode.querySelector("label");
            const name = answerNode.querySelector(".name");
            if (name) name.innerHTML = answerContent.name + ".";
            const correct = answerNode.querySelector(".correct");
            if (answerContent.correct) {
                label.classList.remove("border-danger");
                label.classList.add("border-success");
                correct.classList.remove("d-none");
            } else if (answerSet.has(answerContent.name)) {
                label.classList.remove("border-success");
                label.classList.add("border-danger");
                correct.classList.add("d-none");
            } else {
                label.classList.remove("border-success", "border-danger");
                correct.classList.add("d-none");
            }
        });
    }
    displayItemRendered(content, mathjax) {
        const multipleCorrect = document.querySelector(".item .multiplecorrect");
        mathjax.typesetPromise().then(()=>{
            multipleCorrect.classList.remove("invisible");
        });
    }
    displayItemAlerts(content) {
        // Do nothing.
        return;
    }
}









function $97c8cd33ff544df3$export$1b927030cd80a31b(err) {
    if (err && err.isIndexError) return new (0, $b954584cbe120407$export$efa5eacb1304c464)(err.index + 1, err.min + 1, err.max !== undefined ? err.max + 1 : undefined);
    return err;
}



function $06297ce2c7dc9e93$export$f8ba146648777f78(_ref) {
    var { subset: subset } = _ref;
    /**
   * Retrieve part of an object:
   *
   * - Retrieve a property from an object
   * - Retrieve a part of a string
   * - Retrieve a matrix subset
   *
   * @param {Object | Array | Matrix | string} object
   * @param {Index} index
   * @return {Object | Array | Matrix | string} Returns the subset
   */ return function access(object, index) {
        try {
            if (Array.isArray(object)) return subset(object, index);
            else if (object && typeof object.subset === "function") // Matrix
            return object.subset(index);
            else if (typeof object === "string") // TODO: move getStringSubset into a separate util file, use that
            return subset(object, index);
            else if (typeof object === "object") {
                if (!index.isObjectProperty()) throw new TypeError("Cannot apply a numeric index as object property");
                return (0, $49d1ac263f403507$export$87a87648a1961976)(object, index.getObjectProperty());
            } else throw new TypeError("Cannot apply index: unsupported type of object");
        } catch (err) {
            throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
        }
    };
}


var $ae7194b0850e3794$var$name = "AccessorNode";
var $ae7194b0850e3794$var$dependencies = [
    "subset",
    "Node"
];
var $ae7194b0850e3794$export$a21116b1766eb74 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($ae7194b0850e3794$var$name, $ae7194b0850e3794$var$dependencies, (_ref)=>{
    var { subset: subset, Node: Node } = _ref;
    var access = (0, $06297ce2c7dc9e93$export$f8ba146648777f78)({
        subset: subset
    });
    /**
   * @constructor AccessorNode
   * @extends {Node}
   * Access an object property or get a matrix subset
   *
   * @param {Node} object                 The object from which to retrieve
   *                                      a property or subset.
   * @param {IndexNode} index             IndexNode containing ranges
   */ function AccessorNode(object, index) {
        if (!(this instanceof AccessorNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(object)) throw new TypeError('Node expected for parameter "object"');
        if (!(0, $2c4f948f17aa2240$export$ff90979121a6cabc)(index)) throw new TypeError('IndexNode expected for parameter "index"');
        this.object = object || null;
        this.index = index; // readonly property name
        Object.defineProperty(this, "name", {
            get: (function() {
                if (this.index) return this.index.isObjectProperty() ? this.index.getObjectProperty() : "";
                else return this.object.name || "";
            }).bind(this),
            set: function set() {
                throw new Error("Cannot assign a new name, name is read-only");
            }
        });
    }
    AccessorNode.prototype = new Node();
    AccessorNode.prototype.type = "AccessorNode";
    AccessorNode.prototype.isAccessorNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ AccessorNode.prototype._compile = function(math, argNames) {
        var evalObject = this.object._compile(math, argNames);
        var evalIndex = this.index._compile(math, argNames);
        if (this.index.isObjectProperty()) {
            var prop = this.index.getObjectProperty();
            return function evalAccessorNode(scope, args, context) {
                // get a property from an object evaluated using the scope.
                return (0, $49d1ac263f403507$export$87a87648a1961976)(evalObject(scope, args, context), prop);
            };
        } else return function evalAccessorNode(scope, args, context) {
            var object = evalObject(scope, args, context);
            var index = evalIndex(scope, args, object); // we pass object here instead of context
            return access(object, index);
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ AccessorNode.prototype.forEach = function(callback) {
        callback(this.object, "object", this);
        callback(this.index, "index", this);
    };
    /**
   * Create a new AccessorNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {AccessorNode} Returns a transformed copy of the node
   */ AccessorNode.prototype.map = function(callback) {
        return new AccessorNode(this._ifNode(callback(this.object, "object", this)), this._ifNode(callback(this.index, "index", this)));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {AccessorNode}
   */ AccessorNode.prototype.clone = function() {
        return new AccessorNode(this.object, this.index);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string}
   */ AccessorNode.prototype._toString = function(options) {
        var object = this.object.toString(options);
        if (needParenthesis(this.object)) object = "(" + object + ")";
        return object + this.index.toString(options);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string}
   */ AccessorNode.prototype.toHTML = function(options) {
        var object = this.object.toHTML(options);
        if (needParenthesis(this.object)) object = '<span class="math-parenthesis math-round-parenthesis">(</span>' + object + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return object + this.index.toHTML(options);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string}
   */ AccessorNode.prototype._toTex = function(options) {
        var object = this.object.toTex(options);
        if (needParenthesis(this.object)) object = "\\left(' + object + '\\right)";
        return object + this.index.toTex(options);
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ AccessorNode.prototype.toJSON = function() {
        return {
            mathjs: "AccessorNode",
            object: this.object,
            index: this.index
        };
    };
    /**
   * Instantiate an AccessorNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "AccessorNode", object: ..., index: ...}`,
   *                       where mathjs is optional
   * @returns {AccessorNode}
   */ AccessorNode.fromJSON = function(json) {
        return new AccessorNode(json.object, json.index);
    };
    /**
   * Are parenthesis needed?
   * @private
   */ function needParenthesis(node) {
        // TODO: maybe make a method on the nodes which tells whether they need parenthesis?
        return !((0, $2c4f948f17aa2240$export$f88fb19d6b9ee5cb)(node) || (0, $2c4f948f17aa2240$export$440fa93dcf2757a3)(node) || (0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(node) || (0, $2c4f948f17aa2240$export$6ae03b16e064e6c4)(node) || (0, $2c4f948f17aa2240$export$3f18867a334658e9)(node) || (0, $2c4f948f17aa2240$export$c55e3736c5721220)(node) || (0, $2c4f948f17aa2240$export$87815d550facaed9)(node));
    }
    return AccessorNode;
}, {
    isClass: true,
    isNode: true
});





var $8b98c8b21f871482$var$name = "apply";
var $8b98c8b21f871482$var$dependencies = [
    "typed",
    "isInteger"
];
var $8b98c8b21f871482$export$1c2b553a3b99e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8b98c8b21f871482$var$name, $8b98c8b21f871482$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    var apply = (0, $87c3e66f3771976e$export$5ccffa1686df7f00)({
        typed: typed,
        isInteger: isInteger
    }); // @see: comment of concat itself
    return typed("apply", {
        "...any": function any(args) {
            // change dim from one-based to zero-based
            var dim = args[1];
            if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(dim)) args[1] = dim - 1;
            else if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(dim)) args[1] = dim.minus(1);
            try {
                return apply.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});




var $d8ba1e5320d3cb4e$var$name = "ArrayNode";
var $d8ba1e5320d3cb4e$var$dependencies = [
    "Node"
];
var $d8ba1e5320d3cb4e$export$c4666c772dc9bece = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d8ba1e5320d3cb4e$var$name, $d8ba1e5320d3cb4e$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    /**
   * @constructor ArrayNode
   * @extends {Node}
   * Holds an 1-dimensional array with items
   * @param {Node[]} [items]   1 dimensional array with items
   */ function ArrayNode(items) {
        if (!(this instanceof ArrayNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.items = items || []; // validate input
        if (!Array.isArray(this.items) || !this.items.every((0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee))) throw new TypeError("Array containing Nodes expected");
    }
    ArrayNode.prototype = new Node();
    ArrayNode.prototype.type = "ArrayNode";
    ArrayNode.prototype.isArrayNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ArrayNode.prototype._compile = function(math, argNames) {
        var evalItems = (0, $802b18b8c920d4c6$export$871de8747c9eaa88)(this.items, function(item) {
            return item._compile(math, argNames);
        });
        var asMatrix = math.config.matrix !== "Array";
        if (asMatrix) {
            var matrix = math.matrix;
            return function evalArrayNode(scope, args, context) {
                return matrix((0, $802b18b8c920d4c6$export$871de8747c9eaa88)(evalItems, function(evalItem) {
                    return evalItem(scope, args, context);
                }));
            };
        } else return function evalArrayNode(scope, args, context) {
            return (0, $802b18b8c920d4c6$export$871de8747c9eaa88)(evalItems, function(evalItem) {
                return evalItem(scope, args, context);
            });
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ArrayNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.items.length; i++){
            var node = this.items[i];
            callback(node, "items[" + i + "]", this);
        }
    };
    /**
   * Create a new ArrayNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {ArrayNode} Returns a transformed copy of the node
   */ ArrayNode.prototype.map = function(callback) {
        var items = [];
        for(var i = 0; i < this.items.length; i++)items[i] = this._ifNode(callback(this.items[i], "items[" + i + "]", this));
        return new ArrayNode(items);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ArrayNode}
   */ ArrayNode.prototype.clone = function() {
        return new ArrayNode(this.items.slice(0));
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ArrayNode.prototype._toString = function(options) {
        var items = this.items.map(function(node) {
            return node.toString(options);
        });
        return "[" + items.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ArrayNode.prototype.toJSON = function() {
        return {
            mathjs: "ArrayNode",
            items: this.items
        };
    };
    /**
   * Instantiate an ArrayNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ArrayNode", items: [...]}`,
   *                       where mathjs is optional
   * @returns {ArrayNode}
   */ ArrayNode.fromJSON = function(json) {
        return new ArrayNode(json.items);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ArrayNode.prototype.toHTML = function(options) {
        var items = this.items.map(function(node) {
            return node.toHTML(options);
        });
        return '<span class="math-parenthesis math-square-parenthesis">[</span>' + items.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ArrayNode.prototype._toTex = function(options) {
        function itemsToTex(items, nested) {
            var mixedItems = items.some((0, $2c4f948f17aa2240$export$440fa93dcf2757a3)) && !items.every((0, $2c4f948f17aa2240$export$440fa93dcf2757a3));
            var itemsFormRow = nested || mixedItems;
            var itemSep = itemsFormRow ? "&" : "\\\\";
            var itemsTex = items.map(function(node) {
                if (node.items) return itemsToTex(node.items, !nested);
                else return node.toTex(options);
            }).join(itemSep);
            return mixedItems || !itemsFormRow || itemsFormRow && !nested ? "\\begin{bmatrix}" + itemsTex + "\\end{bmatrix}" : itemsTex;
        }
        return itemsToTex(this.items, false);
    };
    return ArrayNode;
}, {
    isClass: true,
    isNode: true
});







function $2ca730b91d857478$export$796df36381b10d7d(_ref) {
    var { subset: subset, matrix: matrix } = _ref;
    /**
   * Replace part of an object:
   *
   * - Assign a property to an object
   * - Replace a part of a string
   * - Replace a matrix subset
   *
   * @param {Object | Array | Matrix | string} object
   * @param {Index} index
   * @param {*} value
   * @return {Object | Array | Matrix | string} Returns the original object
   *                                            except in case of a string
   */ // TODO: change assign to return the value instead of the object
    return function assign(object, index, value) {
        try {
            if (Array.isArray(object)) // we use matrix.subset here instead of the function subset because we must not clone the contents
            return matrix(object).subset(index, value).valueOf();
            else if (object && typeof object.subset === "function") // Matrix
            return object.subset(index, value);
            else if (typeof object === "string") // TODO: move setStringSubset into a separate util file, use that
            return subset(object, index, value);
            else if (typeof object === "object") {
                if (!index.isObjectProperty()) throw TypeError("Cannot apply a numeric index as object property");
                (0, $49d1ac263f403507$export$e99fe8700ee9f9cd)(object, index.getObjectProperty(), value);
                return object;
            } else throw new TypeError("Cannot apply index: unsupported type of object");
        } catch (err) {
            throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
        }
    };
}


// list of identifiers of nodes in order of their precedence
// also contains information about left/right associativity
// and which other operator the operator is associative with
// Example:
// addition is associative with addition and subtraction, because:
// (a+b)+c=a+(b+c)
// (a+b)-c=a+(b-c)
//
// postfix operators are left associative, prefix operators
// are right associative
//
// It's also possible to set the following properties:
// latexParens: if set to false, this node doesn't need to be enclosed
//              in parentheses when using LaTeX
// latexLeftParens: if set to false, this !OperatorNode's!
//                  left argument doesn't need to be enclosed
//                  in parentheses
// latexRightParens: the same for the right argument

var $d7d1ac259ad9d921$export$3cb21709c4058847 = [
    {
        // assignment
        AssignmentNode: {},
        FunctionAssignmentNode: {}
    },
    {
        // conditional expression
        ConditionalNode: {
            latexLeftParens: false,
            latexRightParens: false,
            latexParens: false // conditionals don't need parentheses in LaTeX because
        }
    },
    {
        // logical or
        "OperatorNode:or": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // logical xor
        "OperatorNode:xor": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // logical and
        "OperatorNode:and": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise or
        "OperatorNode:bitOr": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise xor
        "OperatorNode:bitXor": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise and
        "OperatorNode:bitAnd": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // relational operators
        "OperatorNode:equal": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:unequal": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:smaller": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:larger": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:smallerEq": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:largerEq": {
            associativity: "left",
            associativeWith: []
        },
        RelationalNode: {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitshift operators
        "OperatorNode:leftShift": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:rightArithShift": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:rightLogShift": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // unit conversion
        "OperatorNode:to": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // range
        RangeNode: {}
    },
    {
        // addition, subtraction
        "OperatorNode:add": {
            associativity: "left",
            associativeWith: [
                "OperatorNode:add",
                "OperatorNode:subtract"
            ]
        },
        "OperatorNode:subtract": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // multiply, divide, modulus
        "OperatorNode:multiply": {
            associativity: "left",
            associativeWith: [
                "OperatorNode:multiply",
                "OperatorNode:divide",
                "Operator:dotMultiply",
                "Operator:dotDivide"
            ]
        },
        "OperatorNode:divide": {
            associativity: "left",
            associativeWith: [],
            latexLeftParens: false,
            latexRightParens: false,
            latexParens: false // fractions don't require parentheses because
        },
        "OperatorNode:dotMultiply": {
            associativity: "left",
            associativeWith: [
                "OperatorNode:multiply",
                "OperatorNode:divide",
                "OperatorNode:dotMultiply",
                "OperatorNode:doDivide"
            ]
        },
        "OperatorNode:dotDivide": {
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:mod": {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // unary prefix operators
        "OperatorNode:unaryPlus": {
            associativity: "right"
        },
        "OperatorNode:unaryMinus": {
            associativity: "right"
        },
        "OperatorNode:bitNot": {
            associativity: "right"
        },
        "OperatorNode:not": {
            associativity: "right"
        }
    },
    {
        // exponentiation
        "OperatorNode:pow": {
            associativity: "right",
            associativeWith: [],
            latexRightParens: false // the exponent doesn't need parentheses in
        },
        "OperatorNode:dotPow": {
            associativity: "right",
            associativeWith: []
        }
    },
    {
        // factorial
        "OperatorNode:factorial": {
            associativity: "left"
        }
    },
    {
        // matrix transpose
        "OperatorNode:transpose": {
            associativity: "left"
        }
    }
];
function $d7d1ac259ad9d921$export$94314bea1477f3d5(_node, parenthesis) {
    var node = _node;
    if (parenthesis !== "keep") // ParenthesisNodes are only ignored when not in 'keep' mode
    node = _node.getContent();
    var identifier = node.getIdentifier();
    for(var i = 0; i < $d7d1ac259ad9d921$export$3cb21709c4058847.length; i++){
        if (identifier in $d7d1ac259ad9d921$export$3cb21709c4058847[i]) return i;
    }
    return null;
}
function $d7d1ac259ad9d921$export$8a3de49886b85474(_node, parenthesis) {
    var node = _node;
    if (parenthesis !== "keep") // ParenthesisNodes are only ignored when not in 'keep' mode
    node = _node.getContent();
    var identifier = node.getIdentifier();
    var index = $d7d1ac259ad9d921$export$94314bea1477f3d5(node, parenthesis);
    if (index === null) // node isn't in the list
    return null;
    var property = $d7d1ac259ad9d921$export$3cb21709c4058847[index][identifier];
    if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(property, "associativity")) {
        if (property.associativity === "left") return "left";
        if (property.associativity === "right") return "right";
         // associativity is invalid
        throw Error("'" + identifier + "' has the invalid associativity '" + property.associativity + "'.");
    } // associativity is undefined
    return null;
}
function $d7d1ac259ad9d921$export$b539869f53b6850a(nodeA, nodeB, parenthesis) {
    // ParenthesisNodes are only ignored when not in 'keep' mode
    var a = parenthesis !== "keep" ? nodeA.getContent() : nodeA;
    var b = parenthesis !== "keep" ? nodeA.getContent() : nodeB;
    var identifierA = a.getIdentifier();
    var identifierB = b.getIdentifier();
    var index = $d7d1ac259ad9d921$export$94314bea1477f3d5(a, parenthesis);
    if (index === null) // node isn't in the list
    return null;
    var property = $d7d1ac259ad9d921$export$3cb21709c4058847[index][identifierA];
    if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(property, "associativeWith") && property.associativeWith instanceof Array) {
        for(var i = 0; i < property.associativeWith.length; i++){
            if (property.associativeWith[i] === identifierB) return true;
        }
        return false;
    } // associativeWith is not defined
    return null;
}


var $6fb89c3e33c5b9bd$var$name = "AssignmentNode";
var $6fb89c3e33c5b9bd$var$dependencies = [
    "subset",
    "?matrix",
    "Node"
];
var $6fb89c3e33c5b9bd$export$1461ecd49f170d54 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($6fb89c3e33c5b9bd$var$name, $6fb89c3e33c5b9bd$var$dependencies, (_ref)=>{
    var { subset: subset, matrix: matrix, Node: Node } = _ref;
    var access = (0, $06297ce2c7dc9e93$export$f8ba146648777f78)({
        subset: subset
    });
    var assign = (0, $2ca730b91d857478$export$796df36381b10d7d)({
        subset: subset,
        matrix: matrix
    });
    /**
   * @constructor AssignmentNode
   * @extends {Node}
   *
   * Define a symbol, like `a=3.2`, update a property like `a.b=3.2`, or
   * replace a subset of a matrix like `A[2,2]=42`.
   *
   * Syntax:
   *
   *     new AssignmentNode(symbol, value)
   *     new AssignmentNode(object, index, value)
   *
   * Usage:
   *
   *    new AssignmentNode(new SymbolNode('a'), new ConstantNode(2))                       // a=2
   *    new AssignmentNode(new SymbolNode('a'), new IndexNode('b'), new ConstantNode(2))   // a.b=2
   *    new AssignmentNode(new SymbolNode('a'), new IndexNode(1, 2), new ConstantNode(3))  // a[1,2]=3
   *
   * @param {SymbolNode | AccessorNode} object  Object on which to assign a value
   * @param {IndexNode} [index=null]            Index, property name or matrix
   *                                            index. Optional. If not provided
   *                                            and `object` is a SymbolNode,
   *                                            the property is assigned to the
   *                                            global scope.
   * @param {Node} value                        The value to be assigned
   */ function AssignmentNode(object, index, value) {
        if (!(this instanceof AssignmentNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.object = object;
        this.index = value ? index : null;
        this.value = value || index; // validate input
        if (!(0, $2c4f948f17aa2240$export$87815d550facaed9)(object) && !(0, $2c4f948f17aa2240$export$f88fb19d6b9ee5cb)(object)) throw new TypeError('SymbolNode or AccessorNode expected as "object"');
        if ((0, $2c4f948f17aa2240$export$87815d550facaed9)(object) && object.name === "end") throw new Error('Cannot assign to symbol "end"');
        if (this.index && !(0, $2c4f948f17aa2240$export$ff90979121a6cabc)(this.index)) // index is optional
        throw new TypeError('IndexNode expected as "index"');
        if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(this.value)) throw new TypeError('Node expected as "value"');
         // readonly property name
        Object.defineProperty(this, "name", {
            get: (function() {
                if (this.index) return this.index.isObjectProperty() ? this.index.getObjectProperty() : "";
                else return this.object.name || "";
            }).bind(this),
            set: function set() {
                throw new Error("Cannot assign a new name, name is read-only");
            }
        });
    }
    AssignmentNode.prototype = new Node();
    AssignmentNode.prototype.type = "AssignmentNode";
    AssignmentNode.prototype.isAssignmentNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ AssignmentNode.prototype._compile = function(math, argNames) {
        var evalObject = this.object._compile(math, argNames);
        var evalIndex = this.index ? this.index._compile(math, argNames) : null;
        var evalValue = this.value._compile(math, argNames);
        var name = this.object.name;
        if (!this.index) {
            // apply a variable to the scope, for example `a=2`
            if (!(0, $2c4f948f17aa2240$export$87815d550facaed9)(this.object)) throw new TypeError("SymbolNode expected as object");
            return function evalAssignmentNode(scope, args, context) {
                var value = evalValue(scope, args, context);
                scope.set(name, value);
                return value;
            };
        } else if (this.index.isObjectProperty()) {
            // apply an object property for example `a.b=2`
            var prop = this.index.getObjectProperty();
            return function evalAssignmentNode(scope, args, context) {
                var object = evalObject(scope, args, context);
                var value = evalValue(scope, args, context);
                (0, $49d1ac263f403507$export$e99fe8700ee9f9cd)(object, prop, value);
                return value;
            };
        } else if ((0, $2c4f948f17aa2240$export$87815d550facaed9)(this.object)) // update a matrix subset, for example `a[2]=3`
        return function evalAssignmentNode(scope, args, context) {
            var childObject = evalObject(scope, args, context);
            var value = evalValue(scope, args, context);
            var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context
            scope.set(name, assign(childObject, index, value));
            return value;
        };
        else {
            // isAccessorNode(node.object) === true
            // update a matrix subset, for example `a.b[2]=3`
            // we will not use the compile function of the AccessorNode, but compile it
            // ourselves here as we need the parent object of the AccessorNode:
            // wee need to apply the updated object to parent object
            var evalParentObject = this.object.object._compile(math, argNames);
            if (this.object.index.isObjectProperty()) {
                var parentProp = this.object.index.getObjectProperty();
                return function evalAssignmentNode(scope, args, context) {
                    var parent = evalParentObject(scope, args, context);
                    var childObject = (0, $49d1ac263f403507$export$87a87648a1961976)(parent, parentProp);
                    var index = evalIndex(scope, args, childObject); // Important: we pass childObject instead of context
                    var value = evalValue(scope, args, context);
                    (0, $49d1ac263f403507$export$e99fe8700ee9f9cd)(parent, parentProp, assign(childObject, index, value));
                    return value;
                };
            } else {
                // if some parameters use the 'end' parameter, we need to calculate the size
                var evalParentIndex = this.object.index._compile(math, argNames);
                return function evalAssignmentNode(scope, args, context) {
                    var parent = evalParentObject(scope, args, context);
                    var parentIndex = evalParentIndex(scope, args, parent); // Important: we pass parent instead of context
                    var childObject = access(parent, parentIndex);
                    var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context
                    var value = evalValue(scope, args, context);
                    assign(parent, parentIndex, assign(childObject, index, value));
                    return value;
                };
            }
        }
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ AssignmentNode.prototype.forEach = function(callback) {
        callback(this.object, "object", this);
        if (this.index) callback(this.index, "index", this);
        callback(this.value, "value", this);
    };
    /**
   * Create a new AssignmentNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {AssignmentNode} Returns a transformed copy of the node
   */ AssignmentNode.prototype.map = function(callback) {
        var object = this._ifNode(callback(this.object, "object", this));
        var index = this.index ? this._ifNode(callback(this.index, "index", this)) : null;
        var value = this._ifNode(callback(this.value, "value", this));
        return new AssignmentNode(object, index, value);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {AssignmentNode}
   */ AssignmentNode.prototype.clone = function() {
        return new AssignmentNode(this.object, this.index, this.value);
    };
    /*
   * Is parenthesis needed?
   * @param {node} node
   * @param {string} [parenthesis='keep']
   * @private
   */ function needParenthesis(node, parenthesis) {
        if (!parenthesis) parenthesis = "keep";
        var precedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(node, parenthesis);
        var exprPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(node.value, parenthesis);
        return parenthesis === "all" || exprPrecedence !== null && exprPrecedence <= precedence;
    }
    /**
   * Get string representation
   * @param {Object} options
   * @return {string}
   */ AssignmentNode.prototype._toString = function(options) {
        var object = this.object.toString(options);
        var index = this.index ? this.index.toString(options) : "";
        var value = this.value.toString(options);
        if (needParenthesis(this, options && options.parenthesis)) value = "(" + value + ")";
        return object + index + " = " + value;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ AssignmentNode.prototype.toJSON = function() {
        return {
            mathjs: "AssignmentNode",
            object: this.object,
            index: this.index,
            value: this.value
        };
    };
    /**
   * Instantiate an AssignmentNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "AssignmentNode", object: ..., index: ..., value: ...}`,
   *                       where mathjs is optional
   * @returns {AssignmentNode}
   */ AssignmentNode.fromJSON = function(json) {
        return new AssignmentNode(json.object, json.index, json.value);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string}
   */ AssignmentNode.prototype.toHTML = function(options) {
        var object = this.object.toHTML(options);
        var index = this.index ? this.index.toHTML(options) : "";
        var value = this.value.toHTML(options);
        if (needParenthesis(this, options && options.parenthesis)) value = '<span class="math-paranthesis math-round-parenthesis">(</span>' + value + '<span class="math-paranthesis math-round-parenthesis">)</span>';
        return object + index + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + value;
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string}
   */ AssignmentNode.prototype._toTex = function(options) {
        var object = this.object.toTex(options);
        var index = this.index ? this.index.toTex(options) : "";
        var value = this.value.toTex(options);
        if (needParenthesis(this, options && options.parenthesis)) value = "\\left(".concat(value, "\\right)");
        return object + index + ":=" + value;
    };
    return AssignmentNode;
}, {
    isClass: true,
    isNode: true
});




var $0f6b6cbc53ffa55b$var$name = "BlockNode";
var $0f6b6cbc53ffa55b$var$dependencies = [
    "ResultSet",
    "Node"
];
var $0f6b6cbc53ffa55b$export$850df8ca0896c9ef = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($0f6b6cbc53ffa55b$var$name, $0f6b6cbc53ffa55b$var$dependencies, (_ref)=>{
    var { ResultSet: ResultSet, Node: Node } = _ref;
    /**
   * @constructor BlockNode
   * @extends {Node}
   * Holds a set with blocks
   * @param {Array.<{node: Node} | {node: Node, visible: boolean}>} blocks
   *            An array with blocks, where a block is constructed as an Object
   *            with properties block, which is a Node, and visible, which is
   *            a boolean. The property visible is optional and is true by default
   */ function BlockNode(blocks) {
        if (!(this instanceof BlockNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input, copy blocks
        if (!Array.isArray(blocks)) throw new Error("Array expected");
        this.blocks = blocks.map(function(block) {
            var node = block && block.node;
            var visible = block && block.visible !== undefined ? block.visible : true;
            if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(node)) throw new TypeError('Property "node" must be a Node');
            if (typeof visible !== "boolean") throw new TypeError('Property "visible" must be a boolean');
            return {
                node: node,
                visible: visible
            };
        });
    }
    BlockNode.prototype = new Node();
    BlockNode.prototype.type = "BlockNode";
    BlockNode.prototype.isBlockNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ BlockNode.prototype._compile = function(math, argNames) {
        var evalBlocks = (0, $802b18b8c920d4c6$export$871de8747c9eaa88)(this.blocks, function(block) {
            return {
                evaluate: block.node._compile(math, argNames),
                visible: block.visible
            };
        });
        return function evalBlockNodes(scope, args, context) {
            var results = [];
            (0, $802b18b8c920d4c6$export$4b80e395e36b5a56)(evalBlocks, function evalBlockNode(block) {
                var result = block.evaluate(scope, args, context);
                if (block.visible) results.push(result);
            });
            return new ResultSet(results);
        };
    };
    /**
   * Execute a callback for each of the child blocks of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ BlockNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.blocks.length; i++)callback(this.blocks[i].node, "blocks[" + i + "].node", this);
    };
    /**
   * Create a new BlockNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {BlockNode} Returns a transformed copy of the node
   */ BlockNode.prototype.map = function(callback) {
        var blocks = [];
        for(var i = 0; i < this.blocks.length; i++){
            var block = this.blocks[i];
            var node = this._ifNode(callback(block.node, "blocks[" + i + "].node", this));
            blocks[i] = {
                node: node,
                visible: block.visible
            };
        }
        return new BlockNode(blocks);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {BlockNode}
   */ BlockNode.prototype.clone = function() {
        var blocks = this.blocks.map(function(block) {
            return {
                node: block.node,
                visible: block.visible
            };
        });
        return new BlockNode(blocks);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ BlockNode.prototype._toString = function(options) {
        return this.blocks.map(function(param) {
            return param.node.toString(options) + (param.visible ? "" : ";");
        }).join("\n");
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ BlockNode.prototype.toJSON = function() {
        return {
            mathjs: "BlockNode",
            blocks: this.blocks
        };
    };
    /**
   * Instantiate an BlockNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "BlockNode", blocks: [{node: ..., visible: false}, ...]}`,
   *                       where mathjs is optional
   * @returns {BlockNode}
   */ BlockNode.fromJSON = function(json) {
        return new BlockNode(json.blocks);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ BlockNode.prototype.toHTML = function(options) {
        return this.blocks.map(function(param) {
            return param.node.toHTML(options) + (param.visible ? "" : '<span class="math-separator">;</span>');
        }).join('<span class="math-separator"><br /></span>');
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ BlockNode.prototype._toTex = function(options) {
        return this.blocks.map(function(param) {
            return param.node.toTex(options) + (param.visible ? "" : ";");
        }).join("\\;\\;\n");
    };
    return BlockNode;
}, {
    isClass: true,
    isNode: true
});


var $76b9737e120ccd28$var$name = "chain";
var $76b9737e120ccd28$var$dependencies = [
    "typed",
    "Chain"
];
var $76b9737e120ccd28$export$3ffb1c732bc8392d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($76b9737e120ccd28$var$name, $76b9737e120ccd28$var$dependencies, (_ref)=>{
    var { typed: typed, Chain: Chain } = _ref;
    /**
   * Wrap any value in a chain, allowing to perform chained operations on
   * the value.
   *
   * All methods available in the math.js library can be called upon the chain,
   * and then will be evaluated with the value itself as first argument.
   * The chain can be closed by executing `chain.done()`, which returns
   * the final value.
   *
   * The chain has a number of special functions:
   *
   * - `done()`     Finalize the chain and return the chain's value.
   * - `valueOf()`  The same as `done()`
   * - `toString()` Executes `math.format()` onto the chain's value, returning
   *                a string representation of the value.
   *
   * Syntax:
   *
   *    math.chain(value)
   *
   * Examples:
   *
   *     math.chain(3)
   *         .add(4)
   *         .subtract(2)
   *         .done()     // 5
   *
   *     math.chain( [[1, 2], [3, 4]] )
   *         .subset(math.index(0, 0), 8)
   *         .multiply(3)
   *         .done()     // [[24, 6], [9, 12]]
   *
   * @param {*} [value]   A value of any type on which to start a chained operation.
   * @return {math.Chain} The created chain
   */ return typed($76b9737e120ccd28$var$name, {
        "": function _() {
            return new Chain();
        },
        any: function any(value) {
            return new Chain(value);
        }
    });
});





var $7e7f3b826c23b8f3$var$name = "Chain";
var $7e7f3b826c23b8f3$var$dependencies = [
    "?on",
    "math"
];
var $7e7f3b826c23b8f3$export$1aeed9ab2df4999f = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($7e7f3b826c23b8f3$var$name, $7e7f3b826c23b8f3$var$dependencies, (_ref)=>{
    var { on: on, math: math } = _ref;
    /**
   * @constructor Chain
   * Wrap any value in a chain, allowing to perform chained operations on
   * the value.
   *
   * All methods available in the math.js library can be called upon the chain,
   * and then will be evaluated with the value itself as first argument.
   * The chain can be closed by executing chain.done(), which will return
   * the final value.
   *
   * The Chain has a number of special functions:
   * - done()             Finalize the chained operation and return the
   *                      chain's value.
   * - valueOf()          The same as done()
   * - toString()         Returns a string representation of the chain's value.
   *
   * @param {*} [value]
   */ function Chain(value) {
        if (!(this instanceof Chain)) throw new SyntaxError("Constructor must be called with the new operator");
        if ((0, $2c4f948f17aa2240$export$dc36953d0b3a4f05)(value)) this.value = value.value;
        else this.value = value;
    }
    /**
   * Attach type information
   */ Chain.prototype.type = "Chain";
    Chain.prototype.isChain = true;
    /**
   * Close the chain. Returns the final value.
   * Does the same as method valueOf()
   * @returns {*} value
   */ Chain.prototype.done = function() {
        return this.value;
    };
    /**
   * Close the chain. Returns the final value.
   * Does the same as method done()
   * @returns {*} value
   */ Chain.prototype.valueOf = function() {
        return this.value;
    };
    /**
   * Get a string representation of the value in the chain
   * @returns {string}
   */ Chain.prototype.toString = function() {
        return (0, $addf7cb66573d3e4$export$d9468344d3651243)(this.value);
    };
    /**
   * Get a JSON representation of the chain
   * @returns {Object}
   */ Chain.prototype.toJSON = function() {
        return {
            mathjs: "Chain",
            value: this.value
        };
    };
    /**
   * Instantiate a Chain from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "Chain", value: ...}`,
   *                       where mathjs is optional
   * @returns {Chain}
   */ Chain.fromJSON = function(json) {
        return new Chain(json.value);
    };
    /**
   * Create a proxy method for the chain
   * @param {string} name
   * @param {Function} fn      The function to be proxied
   *                           If fn is no function, it is silently ignored.
   * @private
   */ function createProxy(name, fn) {
        if (typeof fn === "function") Chain.prototype[name] = chainify(fn);
    }
    /**
   * Create a proxy method for the chain
   * @param {string} name
   * @param {function} resolver   The function resolving with the
   *                              function to be proxied
   * @private
   */ function createLazyProxy(name, resolver) {
        (0, $33619877a15996ac$export$488013bae63b21da)(Chain.prototype, name, function outerResolver() {
            var fn = resolver();
            if (typeof fn === "function") return chainify(fn);
            return undefined; // if not a function, ignore
        });
    }
    /**
   * Make a function chainable
   * @param {function} fn
   * @return {Function} chain function
   * @private
   */ function chainify(fn) {
        return function() {
            var args = [
                this.value
            ]; // `this` will be the context of a Chain instance
            for(var i = 0; i < arguments.length; i++)args[i + 1] = arguments[i];
            return new Chain(fn.apply(fn, args));
        };
    }
    /**
   * Create a proxy for a single method, or an object with multiple methods.
   * Example usage:
   *
   *   Chain.createProxy('add', function add (x, y) {...})
   *   Chain.createProxy({
   *     add:      function add (x, y) {...},
   *     subtract: function subtract (x, y) {...}
   *   }
   *
   * @param {string | Object} arg0   A name (string), or an object with
   *                                 functions
   * @param {*} [arg1]               A function, when arg0 is a name
   */ Chain.createProxy = function(arg0, arg1) {
        if (typeof arg0 === "string") // createProxy(name, value)
        createProxy(arg0, arg1);
        else {
            var _loop = function _loop(_name) {
                if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(arg0, _name) && excludedNames[_name] === undefined) createLazyProxy(_name, ()=>arg0[_name]);
            };
            // createProxy(values)
            for(var _name in arg0)_loop(_name);
        }
    };
    var excludedNames = {
        expression: true,
        docs: true,
        type: true,
        classes: true,
        json: true,
        error: true,
        isChain: true // conflicts with the property isChain of a Chain instance
    }; // create proxy for everything that is in math.js
    Chain.createProxy(math); // register on the import event, automatically add a proxy for every imported function.
    if (on) on("import", function(name, resolver, path) {
        if (!path) // an imported function (not a data type or something special)
        createLazyProxy(name, resolver);
    });
    return Chain;
}, {
    isClass: true
});





var $9edea299faf18da9$var$name = "column";
var $9edea299faf18da9$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $9edea299faf18da9$export$cb052a3b92a960e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($9edea299faf18da9$var$name, $9edea299faf18da9$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    var column = (0, $6fe5fc677152824f$export$1bfa986e9c92c0b5)({
        typed: typed,
        Index: Index,
        matrix: matrix,
        range: range
    }); // @see: comment of column itself
    return typed("column", {
        "...any": function any(args) {
            // change last argument from zero-based to one-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(last)) args[lastIndex] = last - 1;
            try {
                return column.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});



var $95e6ce6de7c190b0$var$name = "compile";
var $95e6ce6de7c190b0$var$dependencies = [
    "typed",
    "parse"
];
var $95e6ce6de7c190b0$export$6c15201c8dbd106f = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($95e6ce6de7c190b0$var$name, $95e6ce6de7c190b0$var$dependencies, (_ref)=>{
    var { typed: typed, parse: parse } = _ref;
    /**
   * Parse and compile an expression.
   * Returns a an object with a function `evaluate([scope])` to evaluate the
   * compiled expression.
   *
   * Syntax:
   *
   *     math.compile(expr)                       // returns one node
   *     math.compile([expr1, expr2, expr3, ...]) // returns an array with nodes
   *
   * Examples:
   *
   *     const code1 = math.compile('sqrt(3^2 + 4^2)')
   *     code1.evaluate() // 5
   *
   *     let scope = {a: 3, b: 4}
   *     const code2 = math.compile('a * b') // 12
   *     code2.evaluate(scope) // 12
   *     scope.a = 5
   *     code2.evaluate(scope) // 20
   *
   *     const nodes = math.compile(['a = 3', 'b = 4', 'a * b'])
   *     nodes[2].evaluate() // 12
   *
   * See also:
   *
   *    parse, evaluate
   *
   * @param {string | string[] | Array | Matrix} expr
   *            The expression to be compiled
   * @return {{evaluate: Function} | Array.<{evaluate: Function}>} code
   *            An object with the compiled expression
   * @throws {Error}
   */ return typed($95e6ce6de7c190b0$var$name, {
        string: function string(expr) {
            return parse(expr).compile();
        },
        "Array | Matrix": function ArrayMatrix(expr) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(expr, function(entry) {
                return parse(entry).compile();
            });
        }
    });
});





var $d69b78ec04be14c1$var$name = "concat";
var $d69b78ec04be14c1$var$dependencies = [
    "typed",
    "matrix",
    "isInteger"
];
var $d69b78ec04be14c1$export$3571c61ed942e965 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d69b78ec04be14c1$var$name, $d69b78ec04be14c1$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isInteger: isInteger } = _ref;
    var concat = (0, $a08e4bc6f360edf5$export$c36b5511b12560e8)({
        typed: typed,
        matrix: matrix,
        isInteger: isInteger
    });
    /**
   * Attach a transform function to math.range
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function concat
   * from one-based to zero based
   */ return typed("concat", {
        "...any": function any(args) {
            // change last argument from one-based to zero-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(last)) args[lastIndex] = last - 1;
            else if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(last)) args[lastIndex] = last.minus(1);
            try {
                return concat.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});




var $0dc403e718746947$var$name = "ConditionalNode";
var $0dc403e718746947$var$dependencies = [
    "Node"
];
var $0dc403e718746947$export$401636051e48ab09 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($0dc403e718746947$var$name, $0dc403e718746947$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    /**
   * A lazy evaluating conditional operator: 'condition ? trueExpr : falseExpr'
   *
   * @param {Node} condition   Condition, must result in a boolean
   * @param {Node} trueExpr    Expression evaluated when condition is true
   * @param {Node} falseExpr   Expression evaluated when condition is true
   *
   * @constructor ConditionalNode
   * @extends {Node}
   */ function ConditionalNode(condition, trueExpr, falseExpr) {
        if (!(this instanceof ConditionalNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(condition)) throw new TypeError("Parameter condition must be a Node");
        if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(trueExpr)) throw new TypeError("Parameter trueExpr must be a Node");
        if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(falseExpr)) throw new TypeError("Parameter falseExpr must be a Node");
        this.condition = condition;
        this.trueExpr = trueExpr;
        this.falseExpr = falseExpr;
    }
    ConditionalNode.prototype = new Node();
    ConditionalNode.prototype.type = "ConditionalNode";
    ConditionalNode.prototype.isConditionalNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ConditionalNode.prototype._compile = function(math, argNames) {
        var evalCondition = this.condition._compile(math, argNames);
        var evalTrueExpr = this.trueExpr._compile(math, argNames);
        var evalFalseExpr = this.falseExpr._compile(math, argNames);
        return function evalConditionalNode(scope, args, context) {
            return testCondition(evalCondition(scope, args, context)) ? evalTrueExpr(scope, args, context) : evalFalseExpr(scope, args, context);
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ConditionalNode.prototype.forEach = function(callback) {
        callback(this.condition, "condition", this);
        callback(this.trueExpr, "trueExpr", this);
        callback(this.falseExpr, "falseExpr", this);
    };
    /**
   * Create a new ConditionalNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {ConditionalNode} Returns a transformed copy of the node
   */ ConditionalNode.prototype.map = function(callback) {
        return new ConditionalNode(this._ifNode(callback(this.condition, "condition", this)), this._ifNode(callback(this.trueExpr, "trueExpr", this)), this._ifNode(callback(this.falseExpr, "falseExpr", this)));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ConditionalNode}
   */ ConditionalNode.prototype.clone = function() {
        return new ConditionalNode(this.condition, this.trueExpr, this.falseExpr);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ ConditionalNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(this, parenthesis); // Enclose Arguments in parentheses if they are an OperatorNode
        // or have lower or equal precedence
        // NOTE: enclosing all OperatorNodes in parentheses is a decision
        // purely based on aesthetics and readability
        var condition = this.condition.toString(options);
        var conditionPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(this.condition, parenthesis);
        if (parenthesis === "all" || this.condition.type === "OperatorNode" || conditionPrecedence !== null && conditionPrecedence <= precedence) condition = "(" + condition + ")";
        var trueExpr = this.trueExpr.toString(options);
        var truePrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(this.trueExpr, parenthesis);
        if (parenthesis === "all" || this.trueExpr.type === "OperatorNode" || truePrecedence !== null && truePrecedence <= precedence) trueExpr = "(" + trueExpr + ")";
        var falseExpr = this.falseExpr.toString(options);
        var falsePrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(this.falseExpr, parenthesis);
        if (parenthesis === "all" || this.falseExpr.type === "OperatorNode" || falsePrecedence !== null && falsePrecedence <= precedence) falseExpr = "(" + falseExpr + ")";
        return condition + " ? " + trueExpr + " : " + falseExpr;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ConditionalNode.prototype.toJSON = function() {
        return {
            mathjs: "ConditionalNode",
            condition: this.condition,
            trueExpr: this.trueExpr,
            falseExpr: this.falseExpr
        };
    };
    /**
   * Instantiate an ConditionalNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ConditionalNode", "condition": ..., "trueExpr": ..., "falseExpr": ...}`,
   *                       where mathjs is optional
   * @returns {ConditionalNode}
   */ ConditionalNode.fromJSON = function(json) {
        return new ConditionalNode(json.condition, json.trueExpr, json.falseExpr);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ ConditionalNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(this, parenthesis); // Enclose Arguments in parentheses if they are an OperatorNode
        // or have lower or equal precedence
        // NOTE: enclosing all OperatorNodes in parentheses is a decision
        // purely based on aesthetics and readability
        var condition = this.condition.toHTML(options);
        var conditionPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(this.condition, parenthesis);
        if (parenthesis === "all" || this.condition.type === "OperatorNode" || conditionPrecedence !== null && conditionPrecedence <= precedence) condition = '<span class="math-parenthesis math-round-parenthesis">(</span>' + condition + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        var trueExpr = this.trueExpr.toHTML(options);
        var truePrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(this.trueExpr, parenthesis);
        if (parenthesis === "all" || this.trueExpr.type === "OperatorNode" || truePrecedence !== null && truePrecedence <= precedence) trueExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + trueExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        var falseExpr = this.falseExpr.toHTML(options);
        var falsePrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(this.falseExpr, parenthesis);
        if (parenthesis === "all" || this.falseExpr.type === "OperatorNode" || falsePrecedence !== null && falsePrecedence <= precedence) falseExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + falseExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return condition + '<span class="math-operator math-conditional-operator">?</span>' + trueExpr + '<span class="math-operator math-conditional-operator">:</span>' + falseExpr;
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ConditionalNode.prototype._toTex = function(options) {
        return "\\begin{cases} {" + this.trueExpr.toTex(options) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(options) + "}\\\\{" + this.falseExpr.toTex(options) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
    };
    /**
   * Test whether a condition is met
   * @param {*} condition
   * @returns {boolean} true if condition is true or non-zero, else false
   */ function testCondition(condition) {
        if (typeof condition === "number" || typeof condition === "boolean" || typeof condition === "string") return !!condition;
        if (condition) {
            if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(condition)) return !condition.isZero();
            if ((0, $2c4f948f17aa2240$export$8849a896711efe0c)(condition)) return !!(condition.re || condition.im);
            if ((0, $2c4f948f17aa2240$export$8960dc335987b8da)(condition)) return !!condition.value;
        }
        if (condition === null || condition === undefined) return false;
        throw new TypeError('Unsupported type of condition "' + (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(condition) + '"');
    }
    return ConditionalNode;
}, {
    isClass: true,
    isNode: true
});



/* eslint no-template-curly-in-string: "off" */ var $c202b4d97c154079$exports = {};
"use strict";
// Map the characters to escape to their escaped values. The list is derived
// from http://www.cespedes.org/blog/85/how-to-escape-latex-special-characters
var $c202b4d97c154079$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c202b4d97c154079$var$defaultEscapes = {
    "{": "\\{",
    "}": "\\}",
    "\\": "\\textbackslash{}",
    "#": "\\#",
    $: "\\$",
    "%": "\\%",
    "&": "\\&",
    "^": "\\textasciicircum{}",
    _: "\\_",
    "~": "\\textasciitilde{}"
};
var $c202b4d97c154079$var$formatEscapes = {
    "\u2013": "\\--",
    "\u2014": "\\---",
    " ": "~",
    "	": "\\qquad{}",
    "\r\n": "\\newline{}",
    "\n": "\\newline{}"
};
var $c202b4d97c154079$var$defaultEscapeMapFn = function defaultEscapeMapFn(defaultEscapes, formatEscapes) {
    return $c202b4d97c154079$var$_extends({}, defaultEscapes, formatEscapes);
};
/**
 * Escape a string to be used in LaTeX documents.
 * @param {string} str the string to be escaped.
 * @param {boolean} params.preserveFormatting whether formatting escapes should
 *  be performed (default: false).
 * @param {function} params.escapeMapFn the function to modify the escape maps.
 * @return {string} the escaped string, ready to be used in LaTeX.
 */ $c202b4d97c154079$exports = function(str) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$preserveFormatti = _ref.preserveFormatting, preserveFormatting = _ref$preserveFormatti === undefined ? false : _ref$preserveFormatti, _ref$escapeMapFn = _ref.escapeMapFn, escapeMapFn = _ref$escapeMapFn === undefined ? $c202b4d97c154079$var$defaultEscapeMapFn : _ref$escapeMapFn;
    var runningStr = String(str);
    var result = "";
    var escapes = escapeMapFn($c202b4d97c154079$var$_extends({}, $c202b4d97c154079$var$defaultEscapes), preserveFormatting ? $c202b4d97c154079$var$_extends({}, $c202b4d97c154079$var$formatEscapes) : {});
    var escapeKeys = Object.keys(escapes); // as it is reused later on
    // Algorithm: Go through the string character by character, if it matches
    // with one of the special characters then we'll replace it with the escaped
    // version.
    var _loop = function _loop() {
        var specialCharFound = false;
        escapeKeys.forEach(function(key, index) {
            if (specialCharFound) return;
            if (runningStr.length >= key.length && runningStr.slice(0, key.length) === key) {
                result += escapes[escapeKeys[index]];
                runningStr = runningStr.slice(key.length, runningStr.length);
                specialCharFound = true;
            }
        });
        if (!specialCharFound) {
            result += runningStr.slice(0, 1);
            runningStr = runningStr.slice(1, runningStr.length);
        }
    };
    while(runningStr)_loop();
    return result;
};



var $22194b07116816cc$export$98cd3902fcdeb93d = {
    // GREEK LETTERS
    Alpha: "A",
    alpha: "\\alpha",
    Beta: "B",
    beta: "\\beta",
    Gamma: "\\Gamma",
    gamma: "\\gamma",
    Delta: "\\Delta",
    delta: "\\delta",
    Epsilon: "E",
    epsilon: "\\epsilon",
    varepsilon: "\\varepsilon",
    Zeta: "Z",
    zeta: "\\zeta",
    Eta: "H",
    eta: "\\eta",
    Theta: "\\Theta",
    theta: "\\theta",
    vartheta: "\\vartheta",
    Iota: "I",
    iota: "\\iota",
    Kappa: "K",
    kappa: "\\kappa",
    varkappa: "\\varkappa",
    Lambda: "\\Lambda",
    lambda: "\\lambda",
    Mu: "M",
    mu: "\\mu",
    Nu: "N",
    nu: "\\nu",
    Xi: "\\Xi",
    xi: "\\xi",
    Omicron: "O",
    omicron: "o",
    Pi: "\\Pi",
    pi: "\\pi",
    varpi: "\\varpi",
    Rho: "P",
    rho: "\\rho",
    varrho: "\\varrho",
    Sigma: "\\Sigma",
    sigma: "\\sigma",
    varsigma: "\\varsigma",
    Tau: "T",
    tau: "\\tau",
    Upsilon: "\\Upsilon",
    upsilon: "\\upsilon",
    Phi: "\\Phi",
    phi: "\\phi",
    varphi: "\\varphi",
    Chi: "X",
    chi: "\\chi",
    Psi: "\\Psi",
    psi: "\\psi",
    Omega: "\\Omega",
    omega: "\\omega",
    // logic
    true: "\\mathrm{True}",
    false: "\\mathrm{False}",
    // other
    i: "i",
    // TODO use \i ??
    inf: "\\infty",
    Inf: "\\infty",
    infinity: "\\infty",
    Infinity: "\\infty",
    oo: "\\infty",
    lim: "\\lim",
    undefined: "\\mathbf{?}"
};
var $22194b07116816cc$export$c728a46e4168cd75 = {
    transpose: "^\\top",
    ctranspose: "^H",
    factorial: "!",
    pow: "^",
    dotPow: ".^\\wedge",
    // TODO find ideal solution
    unaryPlus: "+",
    unaryMinus: "-",
    bitNot: "\\~",
    // TODO find ideal solution
    not: "\\neg",
    multiply: "\\cdot",
    divide: "\\frac",
    // TODO how to handle that properly?
    dotMultiply: ".\\cdot",
    // TODO find ideal solution
    dotDivide: ".:",
    // TODO find ideal solution
    mod: "\\mod",
    add: "+",
    subtract: "-",
    to: "\\rightarrow",
    leftShift: "<<",
    rightArithShift: ">>",
    rightLogShift: ">>>",
    equal: "=",
    unequal: "\\neq",
    smaller: "<",
    larger: ">",
    smallerEq: "\\leq",
    largerEq: "\\geq",
    bitAnd: "\\&",
    bitXor: "\\underline{|}",
    bitOr: "|",
    and: "\\wedge",
    xor: "\\veebar",
    or: "\\vee"
};
var $22194b07116816cc$export$b0cfc37067573780 = {
    // arithmetic
    abs: {
        1: "\\left|${args[0]}\\right|"
    },
    add: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.add, "${args[1]}\\right)")
    },
    cbrt: {
        1: "\\sqrt[3]{${args[0]}}"
    },
    ceil: {
        1: "\\left\\lceil${args[0]}\\right\\rceil"
    },
    cube: {
        1: "\\left(${args[0]}\\right)^3"
    },
    divide: {
        2: "\\frac{${args[0]}}{${args[1]}}"
    },
    dotDivide: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.dotDivide, "${args[1]}\\right)")
    },
    dotMultiply: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.dotMultiply, "${args[1]}\\right)")
    },
    dotPow: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.dotPow, "${args[1]}\\right)")
    },
    exp: {
        1: "\\exp\\left(${args[0]}\\right)"
    },
    expm1: "\\left(e".concat($22194b07116816cc$export$c728a46e4168cd75.pow, "{${args[0]}}-1\\right)"),
    fix: {
        1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
    },
    floor: {
        1: "\\left\\lfloor${args[0]}\\right\\rfloor"
    },
    gcd: "\\gcd\\left(${args}\\right)",
    hypot: "\\hypot\\left(${args}\\right)",
    log: {
        1: "\\ln\\left(${args[0]}\\right)",
        2: "\\log_{${args[1]}}\\left(${args[0]}\\right)"
    },
    log10: {
        1: "\\log_{10}\\left(${args[0]}\\right)"
    },
    log1p: {
        1: "\\ln\\left(${args[0]}+1\\right)",
        2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)"
    },
    log2: "\\log_{2}\\left(${args[0]}\\right)",
    mod: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.mod, "${args[1]}\\right)")
    },
    multiply: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.multiply, "${args[1]}\\right)")
    },
    norm: {
        1: "\\left\\|${args[0]}\\right\\|",
        2: undefined // use default template
    },
    nthRoot: {
        2: "\\sqrt[${args[1]}]{${args[0]}}"
    },
    nthRoots: {
        2: "\\{y : $y^{args[1]} = {${args[0]}}\\}"
    },
    pow: {
        2: "\\left(${args[0]}\\right)".concat($22194b07116816cc$export$c728a46e4168cd75.pow, "{${args[1]}}")
    },
    round: {
        1: "\\left\\lfloor${args[0]}\\right\\rceil",
        2: undefined // use default template
    },
    sign: {
        1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
    },
    sqrt: {
        1: "\\sqrt{${args[0]}}"
    },
    square: {
        1: "\\left(${args[0]}\\right)^2"
    },
    subtract: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.subtract, "${args[1]}\\right)")
    },
    unaryMinus: {
        1: "".concat($22194b07116816cc$export$c728a46e4168cd75.unaryMinus, "\\left(${args[0]}\\right)")
    },
    unaryPlus: {
        1: "".concat($22194b07116816cc$export$c728a46e4168cd75.unaryPlus, "\\left(${args[0]}\\right)")
    },
    // bitwise
    bitAnd: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.bitAnd, "${args[1]}\\right)")
    },
    bitNot: {
        1: $22194b07116816cc$export$c728a46e4168cd75.bitNot + "\\left(${args[0]}\\right)"
    },
    bitOr: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.bitOr, "${args[1]}\\right)")
    },
    bitXor: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.bitXor, "${args[1]}\\right)")
    },
    leftShift: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.leftShift, "${args[1]}\\right)")
    },
    rightArithShift: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.rightArithShift, "${args[1]}\\right)")
    },
    rightLogShift: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.rightLogShift, "${args[1]}\\right)")
    },
    // combinatorics
    bellNumbers: {
        1: "\\mathrm{B}_{${args[0]}}"
    },
    catalan: {
        1: "\\mathrm{C}_{${args[0]}}"
    },
    stirlingS2: {
        2: "\\mathrm{S}\\left(${args}\\right)"
    },
    // complex
    arg: {
        1: "\\arg\\left(${args[0]}\\right)"
    },
    conj: {
        1: "\\left(${args[0]}\\right)^*"
    },
    im: {
        1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace"
    },
    re: {
        1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace"
    },
    // logical
    and: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.and, "${args[1]}\\right)")
    },
    not: {
        1: $22194b07116816cc$export$c728a46e4168cd75.not + "\\left(${args[0]}\\right)"
    },
    or: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.or, "${args[1]}\\right)")
    },
    xor: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.xor, "${args[1]}\\right)")
    },
    // matrix
    cross: {
        2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"
    },
    ctranspose: {
        1: "\\left(${args[0]}\\right)".concat($22194b07116816cc$export$c728a46e4168cd75.ctranspose)
    },
    det: {
        1: "\\det\\left(${args[0]}\\right)"
    },
    dot: {
        2: "\\left(${args[0]}\\cdot${args[1]}\\right)"
    },
    expm: {
        1: "\\exp\\left(${args[0]}\\right)"
    },
    inv: {
        1: "\\left(${args[0]}\\right)^{-1}"
    },
    pinv: {
        1: "\\left(${args[0]}\\right)^{+}"
    },
    sqrtm: {
        1: "{${args[0]}}".concat($22194b07116816cc$export$c728a46e4168cd75.pow, "{\\frac{1}{2}}")
    },
    trace: {
        1: "\\mathrm{tr}\\left(${args[0]}\\right)"
    },
    transpose: {
        1: "\\left(${args[0]}\\right)".concat($22194b07116816cc$export$c728a46e4168cd75.transpose)
    },
    // probability
    combinations: {
        2: "\\binom{${args[0]}}{${args[1]}}"
    },
    combinationsWithRep: {
        2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)"
    },
    factorial: {
        1: "\\left(${args[0]}\\right)".concat($22194b07116816cc$export$c728a46e4168cd75.factorial)
    },
    gamma: {
        1: "\\Gamma\\left(${args[0]}\\right)"
    },
    lgamma: {
        1: "\\ln\\Gamma\\left(${args[0]}\\right)"
    },
    // relational
    equal: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.equal, "${args[1]}\\right)")
    },
    larger: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.larger, "${args[1]}\\right)")
    },
    largerEq: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.largerEq, "${args[1]}\\right)")
    },
    smaller: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.smaller, "${args[1]}\\right)")
    },
    smallerEq: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.smallerEq, "${args[1]}\\right)")
    },
    unequal: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.unequal, "${args[1]}\\right)")
    },
    // special
    erf: {
        1: "erf\\left(${args[0]}\\right)"
    },
    // statistics
    max: "\\max\\left(${args}\\right)",
    min: "\\min\\left(${args}\\right)",
    variance: "\\mathrm{Var}\\left(${args}\\right)",
    // trigonometry
    acos: {
        1: "\\cos^{-1}\\left(${args[0]}\\right)"
    },
    acosh: {
        1: "\\cosh^{-1}\\left(${args[0]}\\right)"
    },
    acot: {
        1: "\\cot^{-1}\\left(${args[0]}\\right)"
    },
    acoth: {
        1: "\\coth^{-1}\\left(${args[0]}\\right)"
    },
    acsc: {
        1: "\\csc^{-1}\\left(${args[0]}\\right)"
    },
    acsch: {
        1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)"
    },
    asec: {
        1: "\\sec^{-1}\\left(${args[0]}\\right)"
    },
    asech: {
        1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)"
    },
    asin: {
        1: "\\sin^{-1}\\left(${args[0]}\\right)"
    },
    asinh: {
        1: "\\sinh^{-1}\\left(${args[0]}\\right)"
    },
    atan: {
        1: "\\tan^{-1}\\left(${args[0]}\\right)"
    },
    atan2: {
        2: "\\mathrm{atan2}\\left(${args}\\right)"
    },
    atanh: {
        1: "\\tanh^{-1}\\left(${args[0]}\\right)"
    },
    cos: {
        1: "\\cos\\left(${args[0]}\\right)"
    },
    cosh: {
        1: "\\cosh\\left(${args[0]}\\right)"
    },
    cot: {
        1: "\\cot\\left(${args[0]}\\right)"
    },
    coth: {
        1: "\\coth\\left(${args[0]}\\right)"
    },
    csc: {
        1: "\\csc\\left(${args[0]}\\right)"
    },
    csch: {
        1: "\\mathrm{csch}\\left(${args[0]}\\right)"
    },
    sec: {
        1: "\\sec\\left(${args[0]}\\right)"
    },
    sech: {
        1: "\\mathrm{sech}\\left(${args[0]}\\right)"
    },
    sin: {
        1: "\\sin\\left(${args[0]}\\right)"
    },
    sinh: {
        1: "\\sinh\\left(${args[0]}\\right)"
    },
    tan: {
        1: "\\tan\\left(${args[0]}\\right)"
    },
    tanh: {
        1: "\\tanh\\left(${args[0]}\\right)"
    },
    // unit
    to: {
        2: "\\left(${args[0]}".concat($22194b07116816cc$export$c728a46e4168cd75.to, "${args[1]}\\right)")
    },
    // utils
    numeric: function numeric(node, options) {
        // Not sure if this is strictly right but should work correctly for the vast majority of use cases.
        return node.args[0].toTex();
    },
    // type
    number: {
        0: "0",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
    },
    string: {
        0: '\\mathtt{""}',
        1: "\\mathrm{string}\\left(${args[0]}\\right)"
    },
    bignumber: {
        0: "0",
        1: "\\left(${args[0]}\\right)"
    },
    complex: {
        0: "0",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)+".concat($22194b07116816cc$export$98cd3902fcdeb93d.i, "\\cdot\\left(${args[1]}\\right)\\right)")
    },
    matrix: {
        0: "\\begin{bmatrix}\\end{bmatrix}",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(${args[0]}\\right)"
    },
    sparse: {
        0: "\\begin{bsparse}\\end{bsparse}",
        1: "\\left(${args[0]}\\right)"
    },
    unit: {
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
    }
};
var $22194b07116816cc$export$76173758cefa70e5 = "\\mathrm{${name}}\\left(${args}\\right)";
var $22194b07116816cc$var$latexUnits = {
    deg: "^\\circ"
};
function $22194b07116816cc$export$1b86a510a6af60c2(string) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c202b4d97c154079$exports)))(string, {
        preserveFormatting: true
    });
} // @param {string} name
function $22194b07116816cc$export$358d3bb1a752ff(name, isUnit) {
    isUnit = typeof isUnit === "undefined" ? false : isUnit;
    if (isUnit) {
        if ((0, $33619877a15996ac$export$5a15a386532a5ea4)($22194b07116816cc$var$latexUnits, name)) return $22194b07116816cc$var$latexUnits[name];
        return "\\mathrm{" + $22194b07116816cc$export$1b86a510a6af60c2(name) + "}";
    }
    if ((0, $33619877a15996ac$export$5a15a386532a5ea4)($22194b07116816cc$export$98cd3902fcdeb93d, name)) return $22194b07116816cc$export$98cd3902fcdeb93d[name];
    return $22194b07116816cc$export$1b86a510a6af60c2(name);
}



var $a602ad0b51d0eff3$var$name = "ConstantNode";
var $a602ad0b51d0eff3$var$dependencies = [
    "Node"
];
var $a602ad0b51d0eff3$export$70fc17189bb5117e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a602ad0b51d0eff3$var$name, $a602ad0b51d0eff3$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    /**
   * A ConstantNode holds a constant value like a number or string.
   *
   * Usage:
   *
   *     new ConstantNode(2.3)
   *     new ConstantNode('hello')
   *
   * @param {*} value    Value can be any type (number, BigNumber, string, ...)
   * @constructor ConstantNode
   * @extends {Node}
   */ function ConstantNode(value) {
        if (!(this instanceof ConstantNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.value = value;
    }
    ConstantNode.prototype = new Node();
    ConstantNode.prototype.type = "ConstantNode";
    ConstantNode.prototype.isConstantNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ConstantNode.prototype._compile = function(math, argNames) {
        var value = this.value;
        return function evalConstantNode() {
            return value;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ConstantNode.prototype.forEach = function(callback) {};
    /**
   * Create a new ConstantNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node) : Node} callback
   * @returns {ConstantNode} Returns a clone of the node
   */ ConstantNode.prototype.map = function(callback) {
        return this.clone();
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ConstantNode}
   */ ConstantNode.prototype.clone = function() {
        return new ConstantNode(this.value);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ ConstantNode.prototype._toString = function(options) {
        return (0, $addf7cb66573d3e4$export$d9468344d3651243)(this.value, options);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ ConstantNode.prototype.toHTML = function(options) {
        var value = this._toString(options);
        switch((0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(this.value)){
            case "number":
            case "BigNumber":
            case "Fraction":
                return '<span class="math-number">' + value + "</span>";
            case "string":
                return '<span class="math-string">' + value + "</span>";
            case "boolean":
                return '<span class="math-boolean">' + value + "</span>";
            case "null":
                return '<span class="math-null-symbol">' + value + "</span>";
            case "undefined":
                return '<span class="math-undefined">' + value + "</span>";
            default:
                return '<span class="math-symbol">' + value + "</span>";
        }
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ConstantNode.prototype.toJSON = function() {
        return {
            mathjs: "ConstantNode",
            value: this.value
        };
    };
    /**
   * Instantiate a ConstantNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SymbolNode", value: 2.3}`,
   *                       where mathjs is optional
   * @returns {ConstantNode}
   */ ConstantNode.fromJSON = function(json) {
        return new ConstantNode(json.value);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ConstantNode.prototype._toTex = function(options) {
        var value = this._toString(options);
        switch((0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(this.value)){
            case "string":
                return "\\mathtt{" + (0, $22194b07116816cc$export$1b86a510a6af60c2)(value) + "}";
            case "number":
            case "BigNumber":
                if (!isFinite(this.value)) return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
                var index = value.toLowerCase().indexOf("e");
                if (index !== -1) return value.substring(0, index) + "\\cdot10^{" + value.substring(index + 1) + "}";
                return value;
            case "Fraction":
                return this.value.toLatex();
            default:
                return value;
        }
    };
    return ConstantNode;
}, {
    isClass: true,
    isNode: true
});





/**
 * Attach a transform function to math.sum
 * Adds a property transform containing the transform function.
 *
 * This transform changed the last `dim` parameter of function sum
 * from one-based to zero based
 */ var $eae45d185d81e121$var$name = "cumsum";
var $eae45d185d81e121$var$dependencies = [
    "typed",
    "add",
    "unaryPlus"
];
var $eae45d185d81e121$export$3052aed7543acf3e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($eae45d185d81e121$var$name, $eae45d185d81e121$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, unaryPlus: unaryPlus } = _ref;
    var cumsum = (0, $1ffc641b3300209d$export$e11ffe2ce577c262)({
        typed: typed,
        add: add,
        unaryPlus: unaryPlus
    });
    return typed($eae45d185d81e121$var$name, {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length === 2 && (0, $2c4f948f17aa2240$export$cea7aa84e978eba5)(args[0])) {
                var dim = args[1];
                if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(dim)) args[1] = dim - 1;
                else if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(dim)) args[1] = dim.minus(1);
            }
            try {
                return cumsum.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});



var $f98c11ce6e494d57$var$name = "derivative";
var $f98c11ce6e494d57$var$dependencies = [
    "typed",
    "config",
    "parse",
    "simplify",
    "equal",
    "isZero",
    "numeric",
    "ConstantNode",
    "FunctionNode",
    "OperatorNode",
    "ParenthesisNode",
    "SymbolNode"
];
var $f98c11ce6e494d57$export$d1d6fcabea5d55e0 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($f98c11ce6e494d57$var$name, $f98c11ce6e494d57$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, parse: parse, simplify: simplify, equal: equal, isZero: isZero, numeric: numeric, ConstantNode: ConstantNode, FunctionNode: FunctionNode, OperatorNode: OperatorNode, ParenthesisNode: ParenthesisNode, SymbolNode: SymbolNode } = _ref;
    /**
   * Takes the derivative of an expression expressed in parser Nodes.
   * The derivative will be taken over the supplied variable in the
   * second parameter. If there are multiple variables in the expression,
   * it will return a partial derivative.
   *
   * This uses rules of differentiation which can be found here:
   *
   * - [Differentiation rules (Wikipedia)](https://en.wikipedia.org/wiki/Differentiation_rules)
   *
   * Syntax:
   *
   *     derivative(expr, variable)
   *     derivative(expr, variable, options)
   *
   * Examples:
   *
   *     math.derivative('x^2', 'x')                     // Node {2 * x}
   *     math.derivative('x^2', 'x', {simplify: false})  // Node {2 * 1 * x ^ (2 - 1)
   *     math.derivative('sin(2x)', 'x'))                // Node {2 * cos(2 * x)}
   *     math.derivative('2*x', 'x').evaluate()          // number 2
   *     math.derivative('x^2', 'x').evaluate({x: 4})    // number 8
   *     const f = math.parse('x^2')
   *     const x = math.parse('x')
   *     math.derivative(f, x)                           // Node {2 * x}
   *
   * See also:
   *
   *     simplify, parse, evaluate
   *
   * @param  {Node | string} expr           The expression to differentiate
   * @param  {SymbolNode | string} variable The variable over which to differentiate
   * @param  {{simplify: boolean}} [options]
   *                         There is one option available, `simplify`, which
   *                         is true by default. When false, output will not
   *                         be simplified.
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
   */ var derivative = typed("derivative", {
        "Node, SymbolNode, Object": function NodeSymbolNodeObject(expr, variable, options) {
            var constNodes = {};
            constTag(constNodes, expr, variable.name);
            var res = _derivative(expr, constNodes);
            return options.simplify ? simplify(res) : res;
        },
        "Node, SymbolNode": function NodeSymbolNode(expr, variable) {
            return this(expr, variable, {
                simplify: true
            });
        },
        "string, SymbolNode": function stringSymbolNode(expr, variable) {
            return this(parse(expr), variable);
        },
        "string, SymbolNode, Object": function stringSymbolNodeObject(expr, variable, options) {
            return this(parse(expr), variable, options);
        },
        "string, string": function stringString(expr, variable) {
            return this(parse(expr), parse(variable));
        },
        "string, string, Object": function stringStringObject(expr, variable, options) {
            return this(parse(expr), parse(variable), options);
        },
        "Node, string": function NodeString(expr, variable) {
            return this(expr, parse(variable));
        },
        "Node, string, Object": function NodeStringObject(expr, variable, options) {
            return this(expr, parse(variable), options);
        } // TODO: replace the 8 signatures above with 4 as soon as typed-function supports optional arguments
    });
    derivative._simplify = true;
    derivative.toTex = function(deriv) {
        return _derivTex.apply(null, deriv.args);
    }; // FIXME: move the toTex method of derivative to latex.js. Difficulty is that it relies on parse.
    // NOTE: the optional "order" parameter here is currently unused
    var _derivTex = typed("_derivTex", {
        "Node, SymbolNode": function NodeSymbolNode(expr, x) {
            if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(expr) && (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(expr.value) === "string") return _derivTex(parse(expr.value).toString(), x.toString(), 1);
            else return _derivTex(expr.toTex(), x.toString(), 1);
        },
        "Node, ConstantNode": function NodeConstantNode(expr, x) {
            if ((0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(x.value) === "string") return _derivTex(expr, parse(x.value));
            else throw new Error("The second parameter to 'derivative' is a non-string constant");
        },
        "Node, SymbolNode, ConstantNode": function NodeSymbolNodeConstantNode(expr, x, order) {
            return _derivTex(expr.toString(), x.name, order.value);
        },
        "string, string, number": function stringStringNumber(expr, x, order) {
            var d;
            if (order === 1) d = "{d\\over d" + x + "}";
            else d = "{d^{" + order + "}\\over d" + x + "^{" + order + "}}";
            return d + "\\left[".concat(expr, "\\right]");
        }
    });
    /**
   * Does a depth-first search on the expression tree to identify what Nodes
   * are constants (e.g. 2 + 2), and stores the ones that are constants in
   * constNodes. Classification is done as follows:
   *
   *   1. ConstantNodes are constants.
   *   2. If there exists a SymbolNode, of which we are differentiating over,
   *      in the subtree it is not constant.
   *
   * @param  {Object} constNodes  Holds the nodes that are constant
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param  {string} varName     Variable that we are differentiating
   * @return {boolean}  if node is constant
   */ // TODO: can we rewrite constTag into a pure function?
    var constTag = typed("constTag", {
        "Object, ConstantNode, string": function ObjectConstantNodeString(constNodes, node) {
            constNodes[node] = true;
            return true;
        },
        "Object, SymbolNode, string": function ObjectSymbolNodeString(constNodes, node, varName) {
            // Treat other variables like constants. For reasoning, see:
            //   https://en.wikipedia.org/wiki/Partial_derivative
            if (node.name !== varName) {
                constNodes[node] = true;
                return true;
            }
            return false;
        },
        "Object, ParenthesisNode, string": function ObjectParenthesisNodeString(constNodes, node, varName) {
            return constTag(constNodes, node.content, varName);
        },
        "Object, FunctionAssignmentNode, string": function ObjectFunctionAssignmentNodeString(constNodes, node, varName) {
            if (node.params.indexOf(varName) === -1) {
                constNodes[node] = true;
                return true;
            }
            return constTag(constNodes, node.expr, varName);
        },
        "Object, FunctionNode | OperatorNode, string": function ObjectFunctionNodeOperatorNodeString(constNodes, node, varName) {
            if (node.args.length > 0) {
                var isConst = constTag(constNodes, node.args[0], varName);
                for(var i = 1; i < node.args.length; ++i)isConst = constTag(constNodes, node.args[i], varName) && isConst;
                if (isConst) {
                    constNodes[node] = true;
                    return true;
                }
            }
            return false;
        }
    });
    /**
   * Applies differentiation rules.
   *
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param  {Object} constNodes  Holds the nodes that are constant
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
   */ var _derivative = typed("_derivative", {
        "ConstantNode, Object": function ConstantNodeObject(node) {
            return createConstantNode(0);
        },
        "SymbolNode, Object": function SymbolNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            return createConstantNode(1);
        },
        "ParenthesisNode, Object": function ParenthesisNodeObject(node, constNodes) {
            return new ParenthesisNode(_derivative(node.content, constNodes));
        },
        "FunctionAssignmentNode, Object": function FunctionAssignmentNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            return _derivative(node.expr, constNodes);
        },
        "FunctionNode, Object": function FunctionNodeObject(node, constNodes) {
            if (node.args.length !== 1) funcArgsCheck(node);
            if (constNodes[node] !== undefined) return createConstantNode(0);
            var arg0 = node.args[0];
            var arg1;
            var div = false; // is output a fraction?
            var negative = false; // is output negative?
            var funcDerivative;
            switch(node.name){
                case "cbrt":
                    // d/dx(cbrt(x)) = 1 / (3x^(2/3))
                    div = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        createConstantNode(3),
                        new OperatorNode("^", "pow", [
                            arg0,
                            new OperatorNode("/", "divide", [
                                createConstantNode(2),
                                createConstantNode(3)
                            ])
                        ])
                    ]);
                    break;
                case "sqrt":
                case "nthRoot":
                    // d/dx(sqrt(x)) = 1 / (2*sqrt(x))
                    if (node.args.length === 1) {
                        div = true;
                        funcDerivative = new OperatorNode("*", "multiply", [
                            createConstantNode(2),
                            new FunctionNode("sqrt", [
                                arg0
                            ])
                        ]);
                    } else if (node.args.length === 2) {
                        // Rearrange from nthRoot(x, a) -> x^(1/a)
                        arg1 = new OperatorNode("/", "divide", [
                            createConstantNode(1),
                            node.args[1]
                        ]); // Is a variable?
                        constNodes[arg1] = constNodes[node.args[1]];
                        return _derivative(new OperatorNode("^", "pow", [
                            arg0,
                            arg1
                        ]), constNodes);
                    }
                    break;
                case "log10":
                    arg1 = createConstantNode(10);
                /* fall through! */ case "log":
                    if (!arg1 && node.args.length === 1) {
                        // d/dx(log(x)) = 1 / x
                        funcDerivative = arg0.clone();
                        div = true;
                    } else if (node.args.length === 1 && arg1 || node.args.length === 2 && constNodes[node.args[1]] !== undefined) {
                        // d/dx(log(x, c)) = 1 / (x*ln(c))
                        funcDerivative = new OperatorNode("*", "multiply", [
                            arg0.clone(),
                            new FunctionNode("log", [
                                arg1 || node.args[1]
                            ])
                        ]);
                        div = true;
                    } else if (node.args.length === 2) // d/dx(log(f(x), g(x))) = d/dx(log(f(x)) / log(g(x)))
                    return _derivative(new OperatorNode("/", "divide", [
                        new FunctionNode("log", [
                            arg0
                        ]),
                        new FunctionNode("log", [
                            node.args[1]
                        ])
                    ]), constNodes);
                    break;
                case "pow":
                    constNodes[arg1] = constNodes[node.args[1]]; // Pass to pow operator node parser
                    return _derivative(new OperatorNode("^", "pow", [
                        arg0,
                        node.args[1]
                    ]), constNodes);
                case "exp":
                    // d/dx(e^x) = e^x
                    funcDerivative = new FunctionNode("exp", [
                        arg0.clone()
                    ]);
                    break;
                case "sin":
                    // d/dx(sin(x)) = cos(x)
                    funcDerivative = new FunctionNode("cos", [
                        arg0.clone()
                    ]);
                    break;
                case "cos":
                    // d/dx(cos(x)) = -sin(x)
                    funcDerivative = new OperatorNode("-", "unaryMinus", [
                        new FunctionNode("sin", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "tan":
                    // d/dx(tan(x)) = sec(x)^2
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("sec", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "sec":
                    // d/dx(sec(x)) = sec(x)tan(x)
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("tan", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "csc":
                    // d/dx(csc(x)) = -csc(x)cot(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("cot", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "cot":
                    // d/dx(cot(x)) = -csc(x)^2
                    negative = true;
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("csc", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "asin":
                    // d/dx(asin(x)) = 1 / sqrt(1 - x^2)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            createConstantNode(1),
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ])
                        ])
                    ]);
                    break;
                case "acos":
                    // d/dx(acos(x)) = -1 / sqrt(1 - x^2)
                    div = true;
                    negative = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            createConstantNode(1),
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ])
                        ])
                    ]);
                    break;
                case "atan":
                    // d/dx(atan(x)) = 1 / (x^2 + 1)
                    div = true;
                    funcDerivative = new OperatorNode("+", "add", [
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ]),
                        createConstantNode(1)
                    ]);
                    break;
                case "asec":
                    // d/dx(asec(x)) = 1 / (|x|*sqrt(x^2 - 1))
                    div = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acsc":
                    // d/dx(acsc(x)) = -1 / (|x|*sqrt(x^2 - 1))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acot":
                    // d/dx(acot(x)) = -1 / (x^2 + 1)
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("+", "add", [
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ]),
                        createConstantNode(1)
                    ]);
                    break;
                case "sinh":
                    // d/dx(sinh(x)) = cosh(x)
                    funcDerivative = new FunctionNode("cosh", [
                        arg0.clone()
                    ]);
                    break;
                case "cosh":
                    // d/dx(cosh(x)) = sinh(x)
                    funcDerivative = new FunctionNode("sinh", [
                        arg0.clone()
                    ]);
                    break;
                case "tanh":
                    // d/dx(tanh(x)) = sech(x)^2
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("sech", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "sech":
                    // d/dx(sech(x)) = -sech(x)tanh(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("tanh", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "csch":
                    // d/dx(csch(x)) = -csch(x)coth(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("coth", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "coth":
                    // d/dx(coth(x)) = -csch(x)^2
                    negative = true;
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("csch", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "asinh":
                    // d/dx(asinh(x)) = 1 / sqrt(x^2 + 1)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("+", "add", [
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ]),
                            createConstantNode(1)
                        ])
                    ]);
                    break;
                case "acosh":
                    // d/dx(acosh(x)) = 1 / sqrt(x^2 - 1); XXX potentially only for x >= 1 (the real spectrum)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ]),
                            createConstantNode(1)
                        ])
                    ]);
                    break;
                case "atanh":
                    // d/dx(atanh(x)) = 1 / (1 - x^2)
                    div = true;
                    funcDerivative = new OperatorNode("-", "subtract", [
                        createConstantNode(1),
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ])
                    ]);
                    break;
                case "asech":
                    // d/dx(asech(x)) = -1 / (x*sqrt(1 - x^2))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        arg0.clone(),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                createConstantNode(1),
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ])
                            ])
                        ])
                    ]);
                    break;
                case "acsch":
                    // d/dx(acsch(x)) = -1 / (|x|*sqrt(x^2 + 1))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("+", "add", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acoth":
                    // d/dx(acoth(x)) = -1 / (1 - x^2)
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("-", "subtract", [
                        createConstantNode(1),
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ])
                    ]);
                    break;
                case "abs":
                    // d/dx(abs(x)) = abs(x)/x
                    funcDerivative = new OperatorNode("/", "divide", [
                        new FunctionNode(new SymbolNode("abs"), [
                            arg0.clone()
                        ]),
                        arg0.clone()
                    ]);
                    break;
                case "gamma":
                default:
                    throw new Error('Function "' + node.name + '" is not supported by derivative, or a wrong number of arguments is passed');
            }
            var op, func;
            if (div) {
                op = "/";
                func = "divide";
            } else {
                op = "*";
                func = "multiply";
            }
            /* Apply chain rule to all functions:
         F(x)  = f(g(x))
         F'(x) = g'(x)*f'(g(x)) */ var chainDerivative = _derivative(arg0, constNodes);
            if (negative) chainDerivative = new OperatorNode("-", "unaryMinus", [
                chainDerivative
            ]);
            return new OperatorNode(op, func, [
                chainDerivative,
                funcDerivative
            ]);
        },
        "OperatorNode, Object": function OperatorNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            if (node.op === "+") // d/dx(sum(f(x)) = sum(f'(x))
            return new OperatorNode(node.op, node.fn, node.args.map(function(arg) {
                return _derivative(arg, constNodes);
            }));
            if (node.op === "-") {
                // d/dx(+/-f(x)) = +/-f'(x)
                if (node.isUnary()) return new OperatorNode(node.op, node.fn, [
                    _derivative(node.args[0], constNodes)
                ]);
                 // Linearity of differentiation, d/dx(f(x) +/- g(x)) = f'(x) +/- g'(x)
                if (node.isBinary()) return new OperatorNode(node.op, node.fn, [
                    _derivative(node.args[0], constNodes),
                    _derivative(node.args[1], constNodes)
                ]);
            }
            if (node.op === "*") {
                // d/dx(c*f(x)) = c*f'(x)
                var constantTerms = node.args.filter(function(arg) {
                    return constNodes[arg] !== undefined;
                });
                if (constantTerms.length > 0) {
                    var nonConstantTerms = node.args.filter(function(arg) {
                        return constNodes[arg] === undefined;
                    });
                    var nonConstantNode = nonConstantTerms.length === 1 ? nonConstantTerms[0] : new OperatorNode("*", "multiply", nonConstantTerms);
                    var newArgs = constantTerms.concat(_derivative(nonConstantNode, constNodes));
                    return new OperatorNode("*", "multiply", newArgs);
                } // Product Rule, d/dx(f(x)*g(x)) = f'(x)*g(x) + f(x)*g'(x)
                return new OperatorNode("+", "add", node.args.map(function(argOuter) {
                    return new OperatorNode("*", "multiply", node.args.map(function(argInner) {
                        return argInner === argOuter ? _derivative(argInner, constNodes) : argInner.clone();
                    }));
                }));
            }
            if (node.op === "/" && node.isBinary()) {
                var arg0 = node.args[0];
                var arg1 = node.args[1]; // d/dx(f(x) / c) = f'(x) / c
                if (constNodes[arg1] !== undefined) return new OperatorNode("/", "divide", [
                    _derivative(arg0, constNodes),
                    arg1
                ]);
                 // Reciprocal Rule, d/dx(c / f(x)) = -c(f'(x)/f(x)^2)
                if (constNodes[arg0] !== undefined) return new OperatorNode("*", "multiply", [
                    new OperatorNode("-", "unaryMinus", [
                        arg0
                    ]),
                    new OperatorNode("/", "divide", [
                        _derivative(arg1, constNodes),
                        new OperatorNode("^", "pow", [
                            arg1.clone(),
                            createConstantNode(2)
                        ])
                    ])
                ]);
                 // Quotient rule, d/dx(f(x) / g(x)) = (f'(x)g(x) - f(x)g'(x)) / g(x)^2
                return new OperatorNode("/", "divide", [
                    new OperatorNode("-", "subtract", [
                        new OperatorNode("*", "multiply", [
                            _derivative(arg0, constNodes),
                            arg1.clone()
                        ]),
                        new OperatorNode("*", "multiply", [
                            arg0.clone(),
                            _derivative(arg1, constNodes)
                        ])
                    ]),
                    new OperatorNode("^", "pow", [
                        arg1.clone(),
                        createConstantNode(2)
                    ])
                ]);
            }
            if (node.op === "^" && node.isBinary()) {
                var _arg = node.args[0];
                var _arg2 = node.args[1];
                if (constNodes[_arg] !== undefined) {
                    // If is secretly constant; 0^f(x) = 1 (in JS), 1^f(x) = 1
                    if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(_arg) && (isZero(_arg.value) || equal(_arg.value, 1))) return createConstantNode(0);
                     // d/dx(c^f(x)) = c^f(x)*ln(c)*f'(x)
                    return new OperatorNode("*", "multiply", [
                        node,
                        new OperatorNode("*", "multiply", [
                            new FunctionNode("log", [
                                _arg.clone()
                            ]),
                            _derivative(_arg2.clone(), constNodes)
                        ])
                    ]);
                }
                if (constNodes[_arg2] !== undefined) {
                    if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(_arg2)) {
                        // If is secretly constant; f(x)^0 = 1 -> d/dx(1) = 0
                        if (isZero(_arg2.value)) return createConstantNode(0);
                         // Ignore exponent; f(x)^1 = f(x)
                        if (equal(_arg2.value, 1)) return _derivative(_arg, constNodes);
                    } // Elementary Power Rule, d/dx(f(x)^c) = c*f'(x)*f(x)^(c-1)
                    var powMinusOne = new OperatorNode("^", "pow", [
                        _arg.clone(),
                        new OperatorNode("-", "subtract", [
                            _arg2,
                            createConstantNode(1)
                        ])
                    ]);
                    return new OperatorNode("*", "multiply", [
                        _arg2.clone(),
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg, constNodes),
                            powMinusOne
                        ])
                    ]);
                } // Functional Power Rule, d/dx(f^g) = f^g*[f'*(g/f) + g'ln(f)]
                return new OperatorNode("*", "multiply", [
                    new OperatorNode("^", "pow", [
                        _arg.clone(),
                        _arg2.clone()
                    ]),
                    new OperatorNode("+", "add", [
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg, constNodes),
                            new OperatorNode("/", "divide", [
                                _arg2.clone(),
                                _arg.clone()
                            ])
                        ]),
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg2, constNodes),
                            new FunctionNode("log", [
                                _arg.clone()
                            ])
                        ])
                    ])
                ]);
            }
            throw new Error('Operator "' + node.op + '" is not supported by derivative, or a wrong number of arguments is passed');
        }
    });
    /**
   * Ensures the number of arguments for a function are correct,
   * and will throw an error otherwise.
   *
   * @param {FunctionNode} node
   */ function funcArgsCheck(node) {
        // TODO add min, max etc
        if ((node.name === "log" || node.name === "nthRoot" || node.name === "pow") && node.args.length === 2) return;
         // There should be an incorrect number of arguments if we reach here
        // Change all args to constants to avoid unidentified
        // symbol error when compiling function
        for(var i = 0; i < node.args.length; ++i)node.args[i] = createConstantNode(0);
        node.compile().evaluate();
        throw new Error("Expected TypeError, but none found");
    }
    /**
   * Helper function to create a constant node with a specific type
   * (number, BigNumber, Fraction)
   * @param {number} value
   * @param {string} [valueType]
   * @return {ConstantNode}
   */ function createConstantNode(value, valueType) {
        return new ConstantNode(numeric(value, valueType || config.number));
    }
    return derivative;
});





function $cae718b9f1559ea4$export$75974926bb7e1bd6(args) {
    if (args.length === 2 && (0, $2c4f948f17aa2240$export$cea7aa84e978eba5)(args[0])) {
        args = args.slice();
        var dim = args[1];
        if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(dim)) args[1] = dim - 1;
        else if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(dim)) args[1] = dim.minus(1);
    }
    return args;
}


var $00182defd0737530$var$name = "diff";
var $00182defd0737530$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "number",
    "bignumber"
];
var $00182defd0737530$export$829cfcec5c5f4a9d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($00182defd0737530$var$name, $00182defd0737530$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, number: number, bignumber: bignumber } = _ref;
    var diff = (0, $54b1b5983775b69c$export$49df08fd121951b4)({
        typed: typed,
        matrix: matrix,
        subtract: subtract,
        number: number,
        bignumber: bignumber
    });
    /**
   * Attach a transform function to math.diff
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */ return typed($00182defd0737530$var$name, {
        "...any": function any(args) {
            args = (0, $cae718b9f1559ea4$export$75974926bb7e1bd6)(args);
            try {
                return diff.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});




var $5b04846e36d2595c$var$name = "evaluate";
var $5b04846e36d2595c$var$dependencies = [
    "typed",
    "parse"
];
var $5b04846e36d2595c$export$4f825d0ade64f616 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($5b04846e36d2595c$var$name, $5b04846e36d2595c$var$dependencies, (_ref)=>{
    var { typed: typed, parse: parse } = _ref;
    /**
   * Evaluate an expression.
   *
   * Note the evaluating arbitrary expressions may involve security risks,
   * see [https://mathjs.org/docs/expressions/security.html](https://mathjs.org/docs/expressions/security.html) for more information.
   *
   * Syntax:
   *
   *     math.evaluate(expr)
   *     math.evaluate(expr, scope)
   *     math.evaluate([expr1, expr2, expr3, ...])
   *     math.evaluate([expr1, expr2, expr3, ...], scope)
   *
   * Example:
   *
   *     math.evaluate('(2+3)/4')                // 1.25
   *     math.evaluate('sqrt(3^2 + 4^2)')        // 5
   *     math.evaluate('sqrt(-4)')               // 2i
   *     math.evaluate(['a=3', 'b=4', 'a*b'])    // [3, 4, 12]
   *
   *     let scope = {a:3, b:4}
   *     math.evaluate('a * b', scope)           // 12
   *
   * See also:
   *
   *    parse, compile
   *
   * @param {string | string[] | Matrix} expr   The expression to be evaluated
   * @param {Object} [scope]                    Scope to read/write variables
   * @return {*} The result of the expression
   * @throws {Error}
   */ return typed($5b04846e36d2595c$var$name, {
        string: function string(expr) {
            var scope = (0, $8f2e3669195c8ad5$export$89a4bcaf5b4d37d2)();
            return parse(expr).compile().evaluate(scope);
        },
        "string, Map | Object": function stringMapObject(expr, scope) {
            return parse(expr).compile().evaluate(scope);
        },
        "Array | Matrix": function ArrayMatrix(expr) {
            var scope = (0, $8f2e3669195c8ad5$export$89a4bcaf5b4d37d2)();
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(expr, function(entry) {
                return parse(entry).compile().evaluate(scope);
            });
        },
        "Array | Matrix, Map | Object": function ArrayMatrixMapObject(expr, scope) {
            return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(expr, function(entry) {
                return parse(entry).compile().evaluate(scope);
            });
        }
    });
});






function $b559cd42bd3c02a2$export$6357aae939e9e636(parentScope) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    if (typeof parentScope.createSubScope === "function") return (0, $8f2e3669195c8ad5$export$e6e34fd1f2686227)(parentScope.createSubScope(), ...args);
    return (0, $8f2e3669195c8ad5$export$e6e34fd1f2686227)((0, $8f2e3669195c8ad5$export$89a4bcaf5b4d37d2)(), parentScope, ...args);
}


function $51e0129aa0eee95b$export$cbb6101da03c2e83(expression, math, scope) {
    // find an undefined symbol
    var symbol = expression.filter(function(node) {
        return (0, $2c4f948f17aa2240$export$87815d550facaed9)(node) && !(node.name in math) && !scope.has(node.name);
    })[0];
    if (!symbol) throw new Error('No undefined variable found in inline expression "' + expression + '"');
     // create a test function for this equation
    var name = symbol.name; // variable name
    var subScope = (0, $b559cd42bd3c02a2$export$6357aae939e9e636)(scope);
    var eq = expression.compile();
    return function inlineExpression(x) {
        subScope.set(name, x);
        return eq.evaluate(subScope);
    };
}



var $3c9fe43ad031677c$var$name = "filter";
var $3c9fe43ad031677c$var$dependencies = [
    "typed"
];
var $3c9fe43ad031677c$export$a53d7aa4a2c1e7e3 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($3c9fe43ad031677c$var$name, $3c9fe43ad031677c$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Attach a transform function to math.filter
   * Adds a property transform containing the transform function.
   *
   * This transform adds support for equations as test function for math.filter,
   * so you can do something like 'filter([3, -2, 5], x > 0)'.
   */ function filterTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $2c4f948f17aa2240$export$87815d550facaed9)(args[1]) || (0, $2c4f948f17aa2240$export$27c05cfffd263d30)(args[1])) // a function pointer, like filter([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like filter([3, -2, 5], x > 0)
            callback = (0, $51e0129aa0eee95b$export$cbb6101da03c2e83)(args[1], math, scope);
        }
        return filter(x, callback);
    }
    filterTransform.rawArgs = true; // one based version of function filter
    var filter = typed("filter", {
        "Array, function": $3c9fe43ad031677c$var$_filter,
        "Matrix, function": function MatrixFunction(x, test) {
            return x.create($3c9fe43ad031677c$var$_filter(x.toArray(), test));
        },
        "Array, RegExp": (0, $802b18b8c920d4c6$export$322859471e81229d),
        "Matrix, RegExp": function MatrixRegExp(x, test) {
            return x.create((0, $802b18b8c920d4c6$export$322859471e81229d)(x.toArray(), test));
        }
    });
    return filterTransform;
}, {
    isTransformFunction: true
});
/**
 * Filter values in a callback given a callback function
 *
 * !!! Passes a one-based index !!!
 *
 * @param {Array} x
 * @param {Function} callback
 * @return {Array} Returns the filtered array
 * @private
 */ function $3c9fe43ad031677c$var$_filter(x, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $43b7a970faec5d37$export$6c00fba23f8c91a7)(callback);
    return (0, $802b18b8c920d4c6$export$3dea766d36a8935f)(x, function(value, index, array) {
        // invoke the callback function with the right number of arguments
        if (args === 1) return callback(value);
        else if (args === 2) return callback(value, [
            index + 1
        ]);
        else // 3 or -1
        return callback(value, [
            index + 1
        ], array);
    });
}






var $c9b9efdabed6c757$var$name = "forEach";
var $c9b9efdabed6c757$var$dependencies = [
    "typed"
];
var $c9b9efdabed6c757$export$342aa09106704265 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c9b9efdabed6c757$var$name, $c9b9efdabed6c757$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Attach a transform function to math.forEach
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ function forEachTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $2c4f948f17aa2240$export$87815d550facaed9)(args[1]) || (0, $2c4f948f17aa2240$export$27c05cfffd263d30)(args[1])) // a function pointer, like forEach([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like forEach([3, -2, 5], x > 0 ? callback1(x) : callback2(x) )
            callback = (0, $51e0129aa0eee95b$export$cbb6101da03c2e83)(args[1], math, scope);
        }
        return _forEach(x, callback);
    }
    forEachTransform.rawArgs = true; // one-based version of forEach
    var _forEach = typed("forEach", {
        "Array | Matrix, function": function ArrayMatrixFunction(array, callback) {
            // figure out what number of arguments the callback function expects
            var args = (0, $43b7a970faec5d37$export$6c00fba23f8c91a7)(callback);
            var recurse = function recurse(value, index) {
                if (Array.isArray(value)) (0, $802b18b8c920d4c6$export$4b80e395e36b5a56)(value, function(child, i) {
                    // we create a copy of the index array and append the new index value
                    recurse(child, index.concat(i + 1)); // one based index, hence i+1
                });
                else {
                    // invoke the callback function with the right number of arguments
                    if (args === 1) callback(value);
                    else if (args === 2) callback(value, index);
                    else // 3 or -1
                    callback(value, index, array);
                }
            };
            recurse(array.valueOf(), []); // pass Array
        }
    });
    return forEachTransform;
}, {
    isTransformFunction: true
});


// Reserved keywords not allowed to use in the parser
var $1bf21f9be84ac464$export$eebaaf2b24d91f63 = new Set([
    "end"
]);







var $1c442fe04a879094$var$name = "FunctionAssignmentNode";
var $1c442fe04a879094$var$dependencies = [
    "typed",
    "Node"
];
var $1c442fe04a879094$export$fd037c04876b4924 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1c442fe04a879094$var$name, $1c442fe04a879094$var$dependencies, (_ref)=>{
    var { typed: typed, Node: Node } = _ref;
    /**
   * @constructor FunctionAssignmentNode
   * @extends {Node}
   * Function assignment
   *
   * @param {string} name           Function name
   * @param {string[] | Array.<{name: string, type: string}>} params
   *                                Array with function parameter names, or an
   *                                array with objects containing the name
   *                                and type of the parameter
   * @param {Node} expr             The function expression
   */ function FunctionAssignmentNode(name, params, expr) {
        if (!(this instanceof FunctionAssignmentNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (typeof name !== "string") throw new TypeError('String expected for parameter "name"');
        if (!Array.isArray(params)) throw new TypeError('Array containing strings or objects expected for parameter "params"');
        if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(expr)) throw new TypeError('Node expected for parameter "expr"');
        if ((0, $1bf21f9be84ac464$export$eebaaf2b24d91f63).has(name)) throw new Error('Illegal function name, "' + name + '" is a reserved keyword');
        this.name = name;
        this.params = params.map(function(param) {
            return param && param.name || param;
        });
        this.types = params.map(function(param) {
            return param && param.type || "any";
        });
        this.expr = expr;
    }
    FunctionAssignmentNode.prototype = new Node();
    FunctionAssignmentNode.prototype.type = "FunctionAssignmentNode";
    FunctionAssignmentNode.prototype.isFunctionAssignmentNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ FunctionAssignmentNode.prototype._compile = function(math, argNames) {
        var childArgNames = Object.create(argNames);
        (0, $802b18b8c920d4c6$export$4b80e395e36b5a56)(this.params, function(param) {
            childArgNames[param] = true;
        }); // compile the function expression with the child args
        var evalExpr = this.expr._compile(math, childArgNames);
        var name = this.name;
        var params = this.params;
        var signature = (0, $802b18b8c920d4c6$export$f7e2c8231c57a8bd)(this.types, ",");
        var syntax = name + "(" + (0, $802b18b8c920d4c6$export$f7e2c8231c57a8bd)(this.params, ", ") + ")";
        return function evalFunctionAssignmentNode(scope, args, context) {
            var signatures = {};
            signatures[signature] = function() {
                var childArgs = Object.create(args);
                for(var i = 0; i < params.length; i++)childArgs[params[i]] = arguments[i];
                return evalExpr(scope, childArgs, context);
            };
            var fn = typed(name, signatures);
            fn.syntax = syntax;
            scope.set(name, fn);
            return fn;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ FunctionAssignmentNode.prototype.forEach = function(callback) {
        callback(this.expr, "expr", this);
    };
    /**
   * Create a new FunctionAssignmentNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {FunctionAssignmentNode} Returns a transformed copy of the node
   */ FunctionAssignmentNode.prototype.map = function(callback) {
        var expr = this._ifNode(callback(this.expr, "expr", this));
        return new FunctionAssignmentNode(this.name, this.params.slice(0), expr);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {FunctionAssignmentNode}
   */ FunctionAssignmentNode.prototype.clone = function() {
        return new FunctionAssignmentNode(this.name, this.params.slice(0), this.expr);
    };
    /**
   * Is parenthesis needed?
   * @param {Node} node
   * @param {Object} parenthesis
   * @private
   */ function needParenthesis(node, parenthesis) {
        var precedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(node, parenthesis);
        var exprPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(node.expr, parenthesis);
        return parenthesis === "all" || exprPrecedence !== null && exprPrecedence <= precedence;
    }
    /**
   * get string representation
   * @param {Object} options
   * @return {string} str
   */ FunctionAssignmentNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var expr = this.expr.toString(options);
        if (needParenthesis(this, parenthesis)) expr = "(" + expr + ")";
        return this.name + "(" + this.params.join(", ") + ") = " + expr;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ FunctionAssignmentNode.prototype.toJSON = function() {
        var types = this.types;
        return {
            mathjs: "FunctionAssignmentNode",
            name: this.name,
            params: this.params.map(function(param, index) {
                return {
                    name: param,
                    type: types[index]
                };
            }),
            expr: this.expr
        };
    };
    /**
   * Instantiate an FunctionAssignmentNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "FunctionAssignmentNode", name: ..., params: ..., expr: ...}`,
   *                       where mathjs is optional
   * @returns {FunctionAssignmentNode}
   */ FunctionAssignmentNode.fromJSON = function(json) {
        return new FunctionAssignmentNode(json.name, json.params, json.expr);
    };
    /**
   * get HTML representation
   * @param {Object} options
   * @return {string} str
   */ FunctionAssignmentNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var params = [];
        for(var i = 0; i < this.params.length; i++)params.push('<span class="math-symbol math-parameter">' + (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(this.params[i]) + "</span>");
        var expr = this.expr.toHTML(options);
        if (needParenthesis(this, parenthesis)) expr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + expr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return '<span class="math-function">' + (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(this.name) + "</span>" + '<span class="math-parenthesis math-round-parenthesis">(</span>' + params.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + expr;
    };
    /**
   * get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ FunctionAssignmentNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var expr = this.expr.toTex(options);
        if (needParenthesis(this, parenthesis)) expr = "\\left(".concat(expr, "\\right)");
        return "\\mathrm{" + this.name + "}\\left(" + this.params.map((0, $22194b07116816cc$export$358d3bb1a752ff)).join(",") + "\\right):=" + expr;
    };
    return FunctionAssignmentNode;
}, {
    isClass: true,
    isNode: true
});








var $d43db709575d9e16$var$name = "FunctionNode";
var $d43db709575d9e16$var$dependencies = [
    "math",
    "Node",
    "SymbolNode"
];
var $d43db709575d9e16$export$d03e7338a74cdf4c = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d43db709575d9e16$var$name, $d43db709575d9e16$var$dependencies, (_ref)=>{
    var { math: math, Node: Node, SymbolNode: SymbolNode } = _ref;
    /**
   * @constructor FunctionNode
   * @extends {./Node}
   * invoke a list with arguments on a node
   * @param {./Node | string} fn Node resolving with a function on which to invoke
   *                             the arguments, typically a SymboNode or AccessorNode
   * @param {./Node[]} args
   */ function FunctionNode(fn, args) {
        if (!(this instanceof FunctionNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (typeof fn === "string") fn = new SymbolNode(fn);
         // validate input
        if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(fn)) throw new TypeError('Node expected as parameter "fn"');
        if (!Array.isArray(args) || !args.every((0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee))) throw new TypeError('Array containing Nodes expected for parameter "args"');
        this.fn = fn;
        this.args = args || []; // readonly property name
        Object.defineProperty(this, "name", {
            get: (function() {
                return this.fn.name || "";
            }).bind(this),
            set: function set() {
                throw new Error("Cannot assign a new name, name is read-only");
            }
        });
    }
    FunctionNode.prototype = new Node();
    FunctionNode.prototype.type = "FunctionNode";
    FunctionNode.prototype.isFunctionNode = true;
    /* format to fixed length */ var strin = (entity)=>(0, $addf7cb66573d3e4$export$d9468344d3651243)(entity, {
            truncate: 78
        });
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ FunctionNode.prototype._compile = function(math, argNames) {
        if (!(this instanceof FunctionNode)) throw new TypeError("No valid FunctionNode");
         // compile arguments
        var evalArgs = this.args.map((arg)=>arg._compile(math, argNames));
        if ((0, $2c4f948f17aa2240$export$87815d550facaed9)(this.fn)) {
            var _name = this.fn.name;
            if (!argNames[_name]) {
                // we can statically determine whether the function has an rawArgs property
                var fn = _name in math ? (0, $49d1ac263f403507$export$87a87648a1961976)(math, _name) : undefined;
                var isRaw = typeof fn === "function" && fn.rawArgs === true;
                var resolveFn = (scope)=>{
                    var value;
                    if (scope.has(_name)) value = scope.get(_name);
                    else if (_name in math) value = (0, $49d1ac263f403507$export$87a87648a1961976)(math, _name);
                    else return FunctionNode.onUndefinedFunction(_name);
                    if (typeof value === "function") return value;
                    throw new TypeError("'".concat(_name, "' is not a function; its value is:\n  ").concat(strin(value)));
                };
                if (isRaw) {
                    // pass unevaluated parameters (nodes) to the function
                    // "raw" evaluation
                    var rawArgs = this.args;
                    return function evalFunctionNode(scope, args, context) {
                        var fn = resolveFn(scope);
                        return fn(rawArgs, math, (0, $b559cd42bd3c02a2$export$6357aae939e9e636)(scope, args), scope);
                    };
                } else // "regular" evaluation
                switch(evalArgs.length){
                    case 0:
                        return function evalFunctionNode(scope, args, context) {
                            var fn = resolveFn(scope);
                            return fn();
                        };
                    case 1:
                        return function evalFunctionNode(scope, args, context) {
                            var fn = resolveFn(scope);
                            var evalArg0 = evalArgs[0];
                            return fn(evalArg0(scope, args, context));
                        };
                    case 2:
                        return function evalFunctionNode(scope, args, context) {
                            var fn = resolveFn(scope);
                            var evalArg0 = evalArgs[0];
                            var evalArg1 = evalArgs[1];
                            return fn(evalArg0(scope, args, context), evalArg1(scope, args, context));
                        };
                    default:
                        return function evalFunctionNode(scope, args, context) {
                            var fn = resolveFn(scope);
                            var values = evalArgs.map((evalArg)=>evalArg(scope, args, context));
                            return fn(...values);
                        };
                }
            } else {
                // the function symbol is an argName
                var _rawArgs = this.args;
                return function evalFunctionNode(scope, args, context) {
                    var fn = args[_name];
                    if (typeof fn !== "function") throw new TypeError("Argument '".concat(_name, "' was not a function; received: ").concat(strin(fn)));
                    if (fn.rawArgs) return fn(_rawArgs, math, (0, $b559cd42bd3c02a2$export$6357aae939e9e636)(scope, args), scope); // "raw" evaluation
                    else {
                        var values = evalArgs.map((evalArg)=>evalArg(scope, args, context));
                        return fn.apply(fn, values);
                    }
                };
            }
        } else if ((0, $2c4f948f17aa2240$export$f88fb19d6b9ee5cb)(this.fn) && (0, $2c4f948f17aa2240$export$ff90979121a6cabc)(this.fn.index) && this.fn.index.isObjectProperty()) {
            // execute the function with the right context: the object of the AccessorNode
            var evalObject = this.fn.object._compile(math, argNames);
            var prop = this.fn.index.getObjectProperty();
            var _rawArgs2 = this.args;
            return function evalFunctionNode(scope, args, context) {
                var object = evalObject(scope, args, context);
                (0, $49d1ac263f403507$export$7cfb146d96805fec)(object, prop);
                var isRaw = object[prop] && object[prop].rawArgs;
                if (isRaw) return object[prop](_rawArgs2, math, (0, $b559cd42bd3c02a2$export$6357aae939e9e636)(scope, args), scope); // "raw" evaluation
                else {
                    // "regular" evaluation
                    var values = evalArgs.map((evalArg)=>evalArg(scope, args, context));
                    return object[prop].apply(object, values);
                }
            };
        } else {
            // node.fn.isAccessorNode && !node.fn.index.isObjectProperty()
            // we have to dynamically determine whether the function has a rawArgs property
            var fnExpr = this.fn.toString();
            var evalFn = this.fn._compile(math, argNames);
            var _rawArgs3 = this.args;
            return function evalFunctionNode(scope, args, context) {
                var fn = evalFn(scope, args, context);
                if (typeof fn !== "function") throw new TypeError("Expression '".concat(fnExpr, "' did not evaluate to a function; value is:") + "\n  ".concat(strin(fn)));
                if (fn.rawArgs) return fn(_rawArgs3, math, (0, $b559cd42bd3c02a2$export$6357aae939e9e636)(scope, args), scope); // "raw" evaluation
                else {
                    // "regular" evaluation
                    var values = evalArgs.map((evalArg)=>evalArg(scope, args, context));
                    return fn.apply(fn, values);
                }
            };
        }
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ FunctionNode.prototype.forEach = function(callback) {
        callback(this.fn, "fn", this);
        for(var i = 0; i < this.args.length; i++)callback(this.args[i], "args[" + i + "]", this);
    };
    /**
   * Create a new FunctionNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {FunctionNode} Returns a transformed copy of the node
   */ FunctionNode.prototype.map = function(callback) {
        var fn = this._ifNode(callback(this.fn, "fn", this));
        var args = [];
        for(var i = 0; i < this.args.length; i++)args[i] = this._ifNode(callback(this.args[i], "args[" + i + "]", this));
        return new FunctionNode(fn, args);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {FunctionNode}
   */ FunctionNode.prototype.clone = function() {
        return new FunctionNode(this.fn, this.args.slice(0));
    };
    /**
   * Throws an error 'Undefined function {name}'
   * @param {string} name
   */ FunctionNode.onUndefinedFunction = function(name) {
        throw new Error("Undefined function " + name);
    }; // backup Node's toString function
    // @private
    var nodeToString = FunctionNode.prototype.toString;
    /**
   * Get string representation. (wrapper function)
   * This overrides parts of Node's toString function.
   * If callback is an object containing callbacks, it
   * calls the correct callback for the current node,
   * otherwise it falls back to calling Node's toString
   * function.
   *
   * @param {Object} options
   * @return {string} str
   * @override
   */ FunctionNode.prototype.toString = function(options) {
        var customString;
        var name = this.fn.toString(options);
        if (options && typeof options.handler === "object" && (0, $33619877a15996ac$export$5a15a386532a5ea4)(options.handler, name)) // callback is a map of callback functions
        customString = options.handler[name](this, options);
        if (typeof customString !== "undefined") return customString;
         // fall back to Node's toString
        return nodeToString.call(this, options);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ FunctionNode.prototype._toString = function(options) {
        var args = this.args.map(function(arg) {
            return arg.toString(options);
        });
        var fn = (0, $2c4f948f17aa2240$export$27c05cfffd263d30)(this.fn) ? "(" + this.fn.toString(options) + ")" : this.fn.toString(options); // format the arguments like "add(2, 4.2)"
        return fn + "(" + args.join(", ") + ")";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ FunctionNode.prototype.toJSON = function() {
        return {
            mathjs: "FunctionNode",
            fn: this.fn,
            args: this.args
        };
    };
    /**
   * Instantiate an AssignmentNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "FunctionNode", fn: ..., args: ...}`,
   *                       where mathjs is optional
   * @returns {FunctionNode}
   */ FunctionNode.fromJSON = function(json) {
        return new FunctionNode(json.fn, json.args);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ FunctionNode.prototype.toHTML = function(options) {
        var args = this.args.map(function(arg) {
            return arg.toHTML(options);
        }); // format the arguments like "add(2, 4.2)"
        return '<span class="math-function">' + (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + args.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    };
    /*
   * Expand a LaTeX template
   *
   * @param {string} template
   * @param {Node} node
   * @param {Object} options
   * @private
   **/ function expandTemplate(template, node, options) {
        var latex = ""; // Match everything of the form ${identifier} or ${identifier[2]} or $$
        // while submatching identifier and 2 (in the second case)
        var regex = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi;
        var inputPos = 0; // position in the input string
        var match;
        while((match = regex.exec(template)) !== null){
            // go through all matches
            // add everything in front of the match to the LaTeX string
            latex += template.substring(inputPos, match.index);
            inputPos = match.index;
            if (match[0] === "$$") {
                // escaped dollar sign
                latex += "$";
                inputPos++;
            } else {
                // template parameter
                inputPos += match[0].length;
                var property = node[match[1]];
                if (!property) throw new ReferenceError("Template: Property " + match[1] + " does not exist.");
                if (match[2] === undefined) // no square brackets
                switch(typeof property){
                    case "string":
                        latex += property;
                        break;
                    case "object":
                        if ((0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(property)) latex += property.toTex(options);
                        else if (Array.isArray(property)) // make array of Nodes into comma separated list
                        latex += property.map(function(arg, index) {
                            if ((0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(arg)) return arg.toTex(options);
                            throw new TypeError("Template: " + match[1] + "[" + index + "] is not a Node.");
                        }).join(",");
                        else throw new TypeError("Template: " + match[1] + " has to be a Node, String or array of Nodes");
                        break;
                    default:
                        throw new TypeError("Template: " + match[1] + " has to be a Node, String or array of Nodes");
                }
                else {
                    // with square brackets
                    if ((0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(property[match[2]] && property[match[2]])) latex += property[match[2]].toTex(options);
                    else throw new TypeError("Template: " + match[1] + "[" + match[2] + "] is not a Node.");
                }
            }
        }
        latex += template.slice(inputPos); // append rest of the template
        return latex;
    } // backup Node's toTex function
    // @private
    var nodeToTex = FunctionNode.prototype.toTex;
    /**
   * Get LaTeX representation. (wrapper function)
   * This overrides parts of Node's toTex function.
   * If callback is an object containing callbacks, it
   * calls the correct callback for the current node,
   * otherwise it falls back to calling Node's toTex
   * function.
   *
   * @param {Object} options
   * @return {string}
   */ FunctionNode.prototype.toTex = function(options) {
        var customTex;
        if (options && typeof options.handler === "object" && (0, $33619877a15996ac$export$5a15a386532a5ea4)(options.handler, this.name)) // callback is a map of callback functions
        customTex = options.handler[this.name](this, options);
        if (typeof customTex !== "undefined") return customTex;
         // fall back to Node's toTex
        return nodeToTex.call(this, options);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ FunctionNode.prototype._toTex = function(options) {
        var args = this.args.map(function(arg) {
            // get LaTeX of the arguments
            return arg.toTex(options);
        });
        var latexConverter;
        if ((0, $22194b07116816cc$export$b0cfc37067573780)[this.name]) latexConverter = (0, $22194b07116816cc$export$b0cfc37067573780)[this.name];
         // toTex property on the function itself
        if (math[this.name] && (typeof math[this.name].toTex === "function" || typeof math[this.name].toTex === "object" || typeof math[this.name].toTex === "string")) // .toTex is a callback function
        latexConverter = math[this.name].toTex;
        var customToTex;
        switch(typeof latexConverter){
            case "function":
                // a callback function
                customToTex = latexConverter(this, options);
                break;
            case "string":
                // a template string
                customToTex = expandTemplate(latexConverter, this, options);
                break;
            case "object":
                // an object with different "converters" for different numbers of arguments
                switch(typeof latexConverter[args.length]){
                    case "function":
                        customToTex = latexConverter[args.length](this, options);
                        break;
                    case "string":
                        customToTex = expandTemplate(latexConverter[args.length], this, options);
                        break;
                }
        }
        if (typeof customToTex !== "undefined") return customToTex;
        return expandTemplate((0, $22194b07116816cc$export$76173758cefa70e5), this, options);
    };
    /**
   * Get identifier.
   * @return {string}
   */ FunctionNode.prototype.getIdentifier = function() {
        return this.type + ":" + this.name;
    };
    return FunctionNode;
}, {
    isClass: true,
    isNode: true
});



var $4df866376cb41031$export$3fcb7a132c6e2ba6 = {
    name: "e",
    category: "Constants",
    syntax: [
        "e"
    ],
    description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828",
    examples: [
        "e",
        "e ^ 2",
        "exp(2)",
        "log(e)"
    ],
    seealso: [
        "exp"
    ]
};


var $f37ac914769ce280$export$a73c839095ae9f5c = {
    name: "false",
    category: "Constants",
    syntax: [
        "false"
    ],
    description: "Boolean value false",
    examples: [
        "false"
    ],
    seealso: [
        "true"
    ]
};


var $f5a2a244617a6198$export$e6ca220ee1b42382 = {
    name: "i",
    category: "Constants",
    syntax: [
        "i"
    ],
    description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",
    examples: [
        "i",
        "i * i",
        "sqrt(-1)"
    ],
    seealso: []
};


var $3324a0268fb2ab78$export$15a96a548a33c6f1 = {
    name: "Infinity",
    category: "Constants",
    syntax: [
        "Infinity"
    ],
    description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",
    examples: [
        "Infinity",
        "1 / 0"
    ],
    seealso: []
};


var $fc116263ec33d8ce$export$a1bd41a4b6a2fca0 = {
    name: "LN10",
    category: "Constants",
    syntax: [
        "LN10"
    ],
    description: "Returns the natural logarithm of 10, approximately equal to 2.302",
    examples: [
        "LN10",
        "log(10)"
    ],
    seealso: []
};


var $cfc6c6529c66247b$export$6e0577c024a56563 = {
    name: "LN2",
    category: "Constants",
    syntax: [
        "LN2"
    ],
    description: "Returns the natural logarithm of 2, approximately equal to 0.693",
    examples: [
        "LN2",
        "log(2)"
    ],
    seealso: []
};


var $585eae9d09b052d2$export$c706f91356bdd28c = {
    name: "LOG10E",
    category: "Constants",
    syntax: [
        "LOG10E"
    ],
    description: "Returns the base-10 logarithm of E, approximately equal to 0.434",
    examples: [
        "LOG10E",
        "log(e, 10)"
    ],
    seealso: []
};


var $81e8d6cb6bc5642b$export$813e053668381c19 = {
    name: "LOG2E",
    category: "Constants",
    syntax: [
        "LOG2E"
    ],
    description: "Returns the base-2 logarithm of E, approximately equal to 1.442",
    examples: [
        "LOG2E",
        "log(e, 2)"
    ],
    seealso: []
};


var $e986eb6449dcaf4e$export$eabb08eada5c068d = {
    name: "NaN",
    category: "Constants",
    syntax: [
        "NaN"
    ],
    description: "Not a number",
    examples: [
        "NaN",
        "0 / 0"
    ],
    seealso: []
};


var $9ec2c97b8d94830b$export$a805f16f075f20cb = {
    name: "null",
    category: "Constants",
    syntax: [
        "null"
    ],
    description: "Value null",
    examples: [
        "null"
    ],
    seealso: [
        "true",
        "false"
    ]
};


var $ea1d7dc77765f035$export$f4e037238b5533c1 = {
    name: "phi",
    category: "Constants",
    syntax: [
        "phi"
    ],
    description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",
    examples: [
        "phi"
    ],
    seealso: []
};


var $2e10a592641bc971$export$acdd1b7b7d3e5e4e = {
    name: "pi",
    category: "Constants",
    syntax: [
        "pi"
    ],
    description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159",
    examples: [
        "pi",
        "sin(pi/2)"
    ],
    seealso: [
        "tau"
    ]
};


var $e61c61689c2a761a$export$6838d33506c2b5d0 = {
    name: "SQRT1_2",
    category: "Constants",
    syntax: [
        "SQRT1_2"
    ],
    description: "Returns the square root of 1/2, approximately equal to 0.707",
    examples: [
        "SQRT1_2",
        "sqrt(1/2)"
    ],
    seealso: []
};


var $320c6aa7e5151920$export$ce0e8257aab3e4ae = {
    name: "SQRT2",
    category: "Constants",
    syntax: [
        "SQRT2"
    ],
    description: "Returns the square root of 2, approximately equal to 1.414",
    examples: [
        "SQRT2",
        "sqrt(2)"
    ],
    seealso: []
};


var $48c7641fcd361624$export$aee6f1e4bf7402c8 = {
    name: "tau",
    category: "Constants",
    syntax: [
        "tau"
    ],
    description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.",
    examples: [
        "tau",
        "2 * pi"
    ],
    seealso: [
        "pi"
    ]
};


var $e619af5a857533a2$export$f6ccf6a3f013127d = {
    name: "true",
    category: "Constants",
    syntax: [
        "true"
    ],
    description: "Boolean value true",
    examples: [
        "true"
    ],
    seealso: [
        "false"
    ]
};


var $0b909a7faf5b81c4$export$c94cc7868097f914 = {
    name: "version",
    category: "Constants",
    syntax: [
        "version"
    ],
    description: "A string with the version number of math.js",
    examples: [
        "version"
    ],
    seealso: []
};


var $4f86be50a1ba66c2$export$e8c3f4e3ad52a4e6 = {
    name: "bignumber",
    category: "Construction",
    syntax: [
        "bignumber(x)"
    ],
    description: "Create a big number from a number or string.",
    examples: [
        "0.1 + 0.2",
        "bignumber(0.1) + bignumber(0.2)",
        'bignumber("7.2")',
        'bignumber("7.2e500")',
        "bignumber([0.1, 0.2, 0.3])"
    ],
    seealso: [
        "boolean",
        "complex",
        "fraction",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};


var $33485e150e22f8ba$export$dbe10b9a90fd671a = {
    name: "boolean",
    category: "Construction",
    syntax: [
        "x",
        "boolean(x)"
    ],
    description: "Convert a string or number into a boolean.",
    examples: [
        "boolean(0)",
        "boolean(1)",
        "boolean(3)",
        'boolean("true")',
        'boolean("false")',
        "boolean([1, 0, 1, 1])"
    ],
    seealso: [
        "bignumber",
        "complex",
        "index",
        "matrix",
        "number",
        "string",
        "unit"
    ]
};


var $097dfc938d0b3651$export$a266a326dd0e84ff = {
    name: "complex",
    category: "Construction",
    syntax: [
        "complex()",
        "complex(re, im)",
        "complex(string)"
    ],
    description: "Create a complex number.",
    examples: [
        "complex()",
        "complex(2, 3)",
        'complex("7 - 2i")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "index",
        "matrix",
        "number",
        "string",
        "unit"
    ]
};


var $d3dea2bfdb26b176$export$e56a121dfffbec82 = {
    name: "createUnit",
    category: "Construction",
    syntax: [
        "createUnit(definitions)",
        "createUnit(name, definition)"
    ],
    description: "Create a user-defined unit and register it with the Unit type.",
    examples: [
        'createUnit("foo")',
        'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})',
        'createUnit("mph", "1 mile/hour")'
    ],
    seealso: [
        "unit",
        "splitUnit"
    ]
};


var $ffb9c4298840fffa$export$46678100e6b87439 = {
    name: "fraction",
    category: "Construction",
    syntax: [
        "fraction(num)",
        "fraction(matrix)",
        "fraction(num,den)",
        "fraction({n: num, d: den})"
    ],
    description: "Create a fraction from a number or from integer numerator and denominator.",
    examples: [
        "fraction(0.125)",
        "fraction(1, 3) + fraction(2, 5)",
        "fraction({n: 333, d: 53})",
        "fraction([sqrt(9), sqrt(10), sqrt(11)])"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};


var $951c7e5e7d6ee02f$export$39876fcf61312bba = {
    name: "index",
    category: "Construction",
    syntax: [
        "[start]",
        "[start:end]",
        "[start:step:end]",
        "[start1, start 2, ...]",
        "[start1:end1, start2:end2, ...]",
        "[start1:step1:end1, start2:step2:end2, ...]"
    ],
    description: "Create an index to get or replace a subset of a matrix",
    examples: [
        "[]",
        "[1, 2, 3]",
        "A = [1, 2, 3; 4, 5, 6]",
        "A[1, :]",
        "A[1, 2] = 50",
        "A[0:2, 0:2] = ones(2, 2)"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "matrix,",
        "number",
        "range",
        "string",
        "unit"
    ]
};


var $96cbb525c1395ade$export$dc433018b5b5e90f = {
    name: "matrix",
    category: "Construction",
    syntax: [
        "[]",
        "[a1, b1, ...; a2, b2, ...]",
        "matrix()",
        'matrix("dense")',
        "matrix([...])"
    ],
    description: "Create a matrix.",
    examples: [
        "[]",
        "[1, 2, 3]",
        "[1, 2, 3; 4, 5, 6]",
        "matrix()",
        "matrix([3, 4])",
        'matrix([3, 4; 5, 6], "sparse")',
        'matrix([3, 4; 5, 6], "sparse", "number")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "number",
        "string",
        "unit",
        "sparse"
    ]
};


var $563e91a35560db1c$export$3b011c0eed79d7e0 = {
    name: "number",
    category: "Construction",
    syntax: [
        "x",
        "number(x)",
        "number(unit, valuelessUnit)"
    ],
    description: "Create a number or convert a string or boolean into a number.",
    examples: [
        "2",
        "2e3",
        "4.05",
        "number(2)",
        'number("7.2")',
        "number(true)",
        "number([true, false, true, true])",
        'number(unit("52cm"), "m")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "fraction",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};


var $f054447c83c26eca$export$b569625c2404133 = {
    name: "sparse",
    category: "Construction",
    syntax: [
        "sparse()",
        "sparse([a1, b1, ...; a1, b2, ...])",
        'sparse([a1, b1, ...; a1, b2, ...], "number")'
    ],
    description: "Create a sparse matrix.",
    examples: [
        "sparse()",
        "sparse([3, 4; 5, 6])",
        'sparse([3, 0; 5, 0], "number")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "number",
        "string",
        "unit",
        "matrix"
    ]
};


var $c9710c2f92611a63$export$f729a0241c48cb52 = {
    name: "splitUnit",
    category: "Construction",
    syntax: [
        "splitUnit(unit: Unit, parts: Unit[])"
    ],
    description: "Split a unit in an array of units whose sum is equal to the original unit.",
    examples: [
        'splitUnit(1 m, ["feet", "inch"])'
    ],
    seealso: [
        "unit",
        "createUnit"
    ]
};


var $b4d681757b56ae21$export$783e4a4a90f7bc1d = {
    name: "string",
    category: "Construction",
    syntax: [
        '"text"',
        "string(x)"
    ],
    description: "Create a string or convert a value to a string",
    examples: [
        '"Hello World!"',
        "string(4.2)",
        "string(3 + 2i)"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "number",
        "unit"
    ]
};


var $711e1d87ff757af5$export$478a7368ebd56459 = {
    name: "unit",
    category: "Construction",
    syntax: [
        "value unit",
        "unit(value, unit)",
        "unit(string)"
    ],
    description: "Create a unit.",
    examples: [
        "5.5 mm",
        "3 inch",
        'unit(7.1, "kilogram")',
        'unit("23 deg")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "number",
        "string"
    ]
};


var $ea13b7bddcaae422$export$ec99a334d8c9a14a = {
    name: "config",
    category: "Core",
    syntax: [
        "config()",
        "config(options)"
    ],
    description: "Get configuration or change configuration.",
    examples: [
        "config()",
        "1/3 + 1/4",
        'config({number: "Fraction"})',
        "1/3 + 1/4"
    ],
    seealso: []
};


var $88839605a651815d$export$5989ac4b02cf8057 = {
    name: "import",
    category: "Core",
    syntax: [
        "import(functions)",
        "import(functions, options)"
    ],
    description: "Import functions or constants from an object.",
    examples: [
        "import({myFn: f(x)=x^2, myConstant: 32 })",
        "myFn(2)",
        "myConstant"
    ],
    seealso: []
};


var $dbb92124c4fa01a0$export$7adf399073101884 = {
    name: "typed",
    category: "Core",
    syntax: [
        "typed(signatures)",
        "typed(name, signatures)"
    ],
    description: "Create a typed function.",
    examples: [
        'double = typed({ "number": f(x)=x+x })',
        "double(2)",
        'double("hello")'
    ],
    seealso: []
};


var $0677a0889548ccc9$export$14d93412c4f1ed0d = {
    name: "derivative",
    category: "Algebra",
    syntax: [
        "derivative(expr, variable)",
        "derivative(expr, variable, {simplify: boolean})"
    ],
    description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.",
    examples: [
        'derivative("2x^3", "x")',
        'derivative("2x^3", "x", {simplify: false})',
        'derivative("2x^2 + 3x + 4", "x")',
        'derivative("sin(2x)", "x")',
        'f = parse("x^2 + x")',
        'x = parse("x")',
        "df = derivative(f, x)",
        "df.evaluate({x: 3})"
    ],
    seealso: [
        "simplify",
        "parse",
        "evaluate"
    ]
};


var $b411bba36e573973$export$a44548b5a791ce3a = {
    name: "leafCount",
    category: "Algebra",
    syntax: [
        "leafCount(expr)"
    ],
    description: "Computes the number of leaves in the parse tree of the given expression",
    examples: [
        'leafCount("e^(i*pi)-1")',
        'leafCount(parse("{a: 22/7, b: 10^(1/2)}"))'
    ],
    seealso: [
        "simplify"
    ]
};


var $66ab1993c2c9ec25$export$4bef5c6fa8c1f081 = {
    name: "lsolve",
    category: "Algebra",
    syntax: [
        "x=lsolve(L, b)"
    ],
    description: "Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
    examples: [
        "a = [-2, 3; 2, 1]",
        "b = [11, 9]",
        "x = lsolve(a, b)"
    ],
    seealso: [
        "lsolveAll",
        "lup",
        "lusolve",
        "usolve",
        "matrix",
        "sparse"
    ]
};


var $4fc27e688547a630$export$40bf697ca86bce02 = {
    name: "lsolveAll",
    category: "Algebra",
    syntax: [
        "x=lsolveAll(L, b)"
    ],
    description: "Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
    examples: [
        "a = [-2, 3; 2, 1]",
        "b = [11, 9]",
        "x = lsolve(a, b)"
    ],
    seealso: [
        "lsolve",
        "lup",
        "lusolve",
        "usolve",
        "matrix",
        "sparse"
    ]
};


var $5af0be486ef008e0$export$aa45954995260db7 = {
    name: "lup",
    category: "Algebra",
    syntax: [
        "lup(m)"
    ],
    description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",
    examples: [
        "lup([[2, 1], [1, 4]])",
        "lup(matrix([[2, 1], [1, 4]]))",
        "lup(sparse([[2, 1], [1, 4]]))"
    ],
    seealso: [
        "lusolve",
        "lsolve",
        "usolve",
        "matrix",
        "sparse",
        "slu",
        "qr"
    ]
};


var $2e3ef1b796781072$export$b24588d98e782136 = {
    name: "lusolve",
    category: "Algebra",
    syntax: [
        "x=lusolve(A, b)",
        "x=lusolve(lu, b)"
    ],
    description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",
    examples: [
        "a = [-2, 3; 2, 1]",
        "b = [11, 9]",
        "x = lusolve(a, b)"
    ],
    seealso: [
        "lup",
        "slu",
        "lsolve",
        "usolve",
        "matrix",
        "sparse"
    ]
};


var $89820395287d2c4b$export$717c61ebe37cce2a = {
    name: "qr",
    category: "Algebra",
    syntax: [
        "qr(A)"
    ],
    description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.",
    examples: [
        "qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"
    ],
    seealso: [
        "lup",
        "slu",
        "matrix"
    ]
};


var $e89b1db434055690$export$1802f015e36a313 = {
    name: "rationalize",
    category: "Algebra",
    syntax: [
        "rationalize(expr)",
        "rationalize(expr, scope)",
        "rationalize(expr, scope, detailed)"
    ],
    description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.",
    examples: [
        'rationalize("2x/y - y/(x+1)")',
        'rationalize("2x/y - y/(x+1)", true)'
    ],
    seealso: [
        "simplify"
    ]
};


var $bcbd996bcaed18d5$export$becee114188e4530 = {
    name: "resolve",
    category: "Algebra",
    syntax: [
        "resolve(node, scope)"
    ],
    description: "Recursively substitute variables in an expression tree.",
    examples: [
        'resolve(parse("1 + x"), { x: 7 })',
        'resolve(parse("size(text)"), { text: "Hello World" })',
        'resolve(parse("x + y"), { x: parse("3z") })',
        'resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })'
    ],
    seealso: [
        "simplify",
        "evaluate"
    ],
    mayThrow: [
        "ReferenceError"
    ]
};


var $712ae80751bd32ff$export$5a53589a8ff0d1cd = {
    name: "simplify",
    category: "Algebra",
    syntax: [
        "simplify(expr)",
        "simplify(expr, rules)"
    ],
    description: "Simplify an expression tree.",
    examples: [
        'simplify("3 + 2 / 4")',
        'simplify("2x + x")',
        'f = parse("x * (x + 2 + x)")',
        "simplified = simplify(f)",
        "simplified.evaluate({x: 2})"
    ],
    seealso: [
        "simplifyCore",
        "derivative",
        "evaluate",
        "parse",
        "rationalize",
        "resolve"
    ]
};


var $f3aa809e44b7ad95$export$466a93707e1e5969 = {
    name: "simplifyCore",
    category: "Algebra",
    syntax: [
        "simplifyCore(node)"
    ],
    description: "Perform simple one-pass simplifications on an expression tree.",
    examples: [
        'simplifyCore(parse("0*x"))',
        'simplifyCore(parse("(x+0)*2"))'
    ],
    seealso: [
        "simplify",
        "evaluate"
    ]
};


var $fa7c065b3f015282$export$a68dbefd846d8955 = {
    name: "slu",
    category: "Algebra",
    syntax: [
        "slu(A, order, threshold)"
    ],
    description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",
    examples: [
        "slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"
    ],
    seealso: [
        "lusolve",
        "lsolve",
        "usolve",
        "matrix",
        "sparse",
        "lup",
        "qr"
    ]
};


var $75ac32e61766dd00$export$1ff0943310cb2f46 = {
    name: "symbolicEqual",
    category: "Algebra",
    syntax: [
        "symbolicEqual(expr1, expr2)",
        "symbolicEqual(expr1, expr2, options)"
    ],
    description: "Returns true if the difference of the expressions simplifies to 0",
    examples: [
        'symbolicEqual("x*y","y*x")',
        'symbolicEqual("abs(x^2)", "x^2")',
        'symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})'
    ],
    seealso: [
        "simplify",
        "evaluate"
    ]
};


var $70567ed61ead988d$export$2e45391f5cc49d1d = {
    name: "usolve",
    category: "Algebra",
    syntax: [
        "x=usolve(U, b)"
    ],
    description: "Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
    examples: [
        "x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"
    ],
    seealso: [
        "usolveAll",
        "lup",
        "lusolve",
        "lsolve",
        "matrix",
        "sparse"
    ]
};


var $27d0c9229b4f1bc8$export$64b3b7af0d3d4548 = {
    name: "usolveAll",
    category: "Algebra",
    syntax: [
        "x=usolve(U, b)"
    ],
    description: "Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
    examples: [
        "x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"
    ],
    seealso: [
        "usolve",
        "lup",
        "lusolve",
        "lsolve",
        "matrix",
        "sparse"
    ]
};


var $b6595d12d9a37f56$export$d21ec9cf3daa768b = {
    name: "abs",
    category: "Arithmetic",
    syntax: [
        "abs(x)"
    ],
    description: "Compute the absolute value.",
    examples: [
        "abs(3.5)",
        "abs(-4.2)"
    ],
    seealso: [
        "sign"
    ]
};


var $a49d9cf328cf58c0$export$6fe0cea5d5e6ddba = {
    name: "add",
    category: "Operators",
    syntax: [
        "x + y",
        "add(x, y)"
    ],
    description: "Add two values.",
    examples: [
        "a = 2.1 + 3.6",
        "a - 3.6",
        "3 + 2i",
        "3 cm + 2 inch",
        '"2.3" + "4"'
    ],
    seealso: [
        "subtract"
    ]
};


var $1b8de4974886ee29$export$9330e90a8e7851e6 = {
    name: "cbrt",
    category: "Arithmetic",
    syntax: [
        "cbrt(x)",
        "cbrt(x, allRoots)"
    ],
    description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",
    examples: [
        "cbrt(64)",
        "cube(4)",
        "cbrt(-8)",
        "cbrt(2 + 3i)",
        "cbrt(8i)",
        "cbrt(8i, true)",
        "cbrt(27 m^3)"
    ],
    seealso: [
        "square",
        "sqrt",
        "cube",
        "multiply"
    ]
};


var $c54551ef7545a215$export$bf625dbce78edf39 = {
    name: "ceil",
    category: "Arithmetic",
    syntax: [
        "ceil(x)"
    ],
    description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",
    examples: [
        "ceil(3.2)",
        "ceil(3.8)",
        "ceil(-4.2)"
    ],
    seealso: [
        "floor",
        "fix",
        "round"
    ]
};


var $7b93d3024290f78f$export$ceabaa40b420fd2f = {
    name: "cube",
    category: "Arithmetic",
    syntax: [
        "cube(x)"
    ],
    description: "Compute the cube of a value. The cube of x is x * x * x.",
    examples: [
        "cube(2)",
        "2^3",
        "2 * 2 * 2"
    ],
    seealso: [
        "multiply",
        "square",
        "pow"
    ]
};


var $707a84fe61a604df$export$e4cc3c6ddad47fb = {
    name: "divide",
    category: "Operators",
    syntax: [
        "x / y",
        "divide(x, y)"
    ],
    description: "Divide two values.",
    examples: [
        "a = 2 / 3",
        "a * 3",
        "4.5 / 2",
        "3 + 4 / 2",
        "(3 + 4) / 2",
        "18 km / 4.5"
    ],
    seealso: [
        "multiply"
    ]
};


var $12a5d5e2c65c5eaf$export$f1a6e1f6a311adf8 = {
    name: "dotDivide",
    category: "Operators",
    syntax: [
        "x ./ y",
        "dotDivide(x, y)"
    ],
    description: "Divide two values element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "b = [2, 1, 1; 3, 2, 5]",
        "a ./ b"
    ],
    seealso: [
        "multiply",
        "dotMultiply",
        "divide"
    ]
};


var $2e00aa760615e0ae$export$4e72f4c646ece24a = {
    name: "dotMultiply",
    category: "Operators",
    syntax: [
        "x .* y",
        "dotMultiply(x, y)"
    ],
    description: "Multiply two values element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "b = [2, 1, 1; 3, 2, 5]",
        "a .* b"
    ],
    seealso: [
        "multiply",
        "divide",
        "dotDivide"
    ]
};


var $0a965cd4f26b61b4$export$db82d026e80f1871 = {
    name: "dotPow",
    category: "Operators",
    syntax: [
        "x .^ y",
        "dotPow(x, y)"
    ],
    description: "Calculates the power of x to y element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a .^ 2"
    ],
    seealso: [
        "pow"
    ]
};


var $5b5095dbf60d7a6a$export$e855e42434736fab = {
    name: "exp",
    category: "Arithmetic",
    syntax: [
        "exp(x)"
    ],
    description: "Calculate the exponent of a value.",
    examples: [
        "exp(1.3)",
        "e ^ 1.3",
        "log(exp(1.3))",
        "x = 2.4",
        "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"
    ],
    seealso: [
        "expm",
        "expm1",
        "pow",
        "log"
    ]
};


var $90dcd15cadcd875a$export$df3b4f2159ca23f5 = {
    name: "expm",
    category: "Arithmetic",
    syntax: [
        "exp(x)"
    ],
    description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.",
    examples: [
        "expm([[0,2],[0,0]])"
    ],
    seealso: [
        "exp"
    ]
};


var $efd9dd838957b1f9$export$d6fb67f466ac866c = {
    name: "expm1",
    category: "Arithmetic",
    syntax: [
        "expm1(x)"
    ],
    description: "Calculate the value of subtracting 1 from the exponential value.",
    examples: [
        "expm1(2)",
        "pow(e, 2) - 1",
        "log(expm1(2) + 1)"
    ],
    seealso: [
        "exp",
        "pow",
        "log"
    ]
};


var $cf32cc8aa0045b73$export$ec1a27fd93212099 = {
    name: "fix",
    category: "Arithmetic",
    syntax: [
        "fix(x)"
    ],
    description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",
    examples: [
        "fix(3.2)",
        "fix(3.8)",
        "fix(-4.2)",
        "fix(-4.8)"
    ],
    seealso: [
        "ceil",
        "floor",
        "round"
    ]
};


var $92887728829140ae$export$7eb1ac5a6cfbe8b6 = {
    name: "floor",
    category: "Arithmetic",
    syntax: [
        "floor(x)"
    ],
    description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",
    examples: [
        "floor(3.2)",
        "floor(3.8)",
        "floor(-4.2)"
    ],
    seealso: [
        "ceil",
        "fix",
        "round"
    ]
};


var $4c0a08e9ad879902$export$ccc9190f6201c21e = {
    name: "gcd",
    category: "Arithmetic",
    syntax: [
        "gcd(a, b)",
        "gcd(a, b, c, ...)"
    ],
    description: "Compute the greatest common divisor.",
    examples: [
        "gcd(8, 12)",
        "gcd(-4, 6)",
        "gcd(25, 15, -10)"
    ],
    seealso: [
        "lcm",
        "xgcd"
    ]
};


var $7a3aa31d7d41df42$export$53821d38c3eeff69 = {
    name: "hypot",
    category: "Arithmetic",
    syntax: [
        "hypot(a, b, c, ...)",
        "hypot([a, b, c, ...])"
    ],
    description: "Calculate the hypotenusa of a list with values. ",
    examples: [
        "hypot(3, 4)",
        "sqrt(3^2 + 4^2)",
        "hypot(-2)",
        "hypot([3, 4, 5])"
    ],
    seealso: [
        "abs",
        "norm"
    ]
};


var $ed49e36780d59c97$export$7d988771513789e5 = {
    name: "invmod",
    category: "Arithmetic",
    syntax: [
        "invmod(a, b)"
    ],
    description: "Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax \u2263 1 (mod b)",
    examples: [
        "invmod(8, 12)=NaN",
        "invmod(7, 13)=2",
        "math.invmod(15151, 15122)=10429"
    ],
    seealso: [
        "gcd",
        "xgcd"
    ]
};


var $4aa80ac8af9a8c85$export$371d4953326569cb = {
    name: "lcm",
    category: "Arithmetic",
    syntax: [
        "lcm(x, y)"
    ],
    description: "Compute the least common multiple.",
    examples: [
        "lcm(4, 6)",
        "lcm(6, 21)",
        "lcm(6, 21, 5)"
    ],
    seealso: [
        "gcd"
    ]
};


var $d32689f0b872f329$export$10fa3fadd260900f = {
    name: "log",
    category: "Arithmetic",
    syntax: [
        "log(x)",
        "log(x, base)"
    ],
    description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",
    examples: [
        "log(3.5)",
        "a = log(2.4)",
        "exp(a)",
        "10 ^ 4",
        "log(10000, 10)",
        "log(10000) / log(10)",
        "b = log(1024, 2)",
        "2 ^ b"
    ],
    seealso: [
        "exp",
        "log1p",
        "log2",
        "log10"
    ]
};


var $b0b842b0e49b3c02$export$a4c310b6d4346035 = {
    name: "log10",
    category: "Arithmetic",
    syntax: [
        "log10(x)"
    ],
    description: "Compute the 10-base logarithm of a value.",
    examples: [
        "log10(0.00001)",
        "log10(10000)",
        "10 ^ 4",
        "log(10000) / log(10)",
        "log(10000, 10)"
    ],
    seealso: [
        "exp",
        "log"
    ]
};


var $5ab0a391b8f697af$export$5739f5d11cd187ac = {
    name: "log1p",
    category: "Arithmetic",
    syntax: [
        "log1p(x)",
        "log1p(x, base)"
    ],
    description: "Calculate the logarithm of a `value+1`",
    examples: [
        "log1p(2.5)",
        "exp(log1p(1.4))",
        "pow(10, 4)",
        "log1p(9999, 10)",
        "log1p(9999) / log(10)"
    ],
    seealso: [
        "exp",
        "log",
        "log2",
        "log10"
    ]
};


var $b69b4ac028cc0a97$export$fa36f06e6e8bfb36 = {
    name: "log2",
    category: "Arithmetic",
    syntax: [
        "log2(x)"
    ],
    description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.",
    examples: [
        "log2(0.03125)",
        "log2(16)",
        "log2(16) / log2(2)",
        "pow(2, 4)"
    ],
    seealso: [
        "exp",
        "log1p",
        "log",
        "log10"
    ]
};


var $e835c4da59d0d72d$export$f9c7d95d1ec52e50 = {
    name: "mod",
    category: "Operators",
    syntax: [
        "x % y",
        "x mod y",
        "mod(x, y)"
    ],
    description: "Calculates the modulus, the remainder of an integer division.",
    examples: [
        "7 % 3",
        "11 % 2",
        "10 mod 4",
        "isOdd(x) = x % 2",
        "isOdd(2)",
        "isOdd(3)"
    ],
    seealso: [
        "divide"
    ]
};


var $0aff45cd2aac1b58$export$1506e47b2a5ae6da = {
    name: "multiply",
    category: "Operators",
    syntax: [
        "x * y",
        "multiply(x, y)"
    ],
    description: "multiply two values.",
    examples: [
        "a = 2.1 * 3.4",
        "a / 3.4",
        "2 * 3 + 4",
        "2 * (3 + 4)",
        "3 * 2.1 km"
    ],
    seealso: [
        "divide"
    ]
};


var $8a2585c2fb84ed7f$export$9745ccea7c23999 = {
    name: "norm",
    category: "Arithmetic",
    syntax: [
        "norm(x)",
        "norm(x, p)"
    ],
    description: "Calculate the norm of a number, vector or matrix.",
    examples: [
        "abs(-3.5)",
        "norm(-3.5)",
        "norm(3 - 4i)",
        "norm([1, 2, -3], Infinity)",
        "norm([1, 2, -3], -Infinity)",
        "norm([3, 4], 2)",
        "norm([[1, 2], [3, 4]], 1)",
        'norm([[1, 2], [3, 4]], "inf")',
        'norm([[1, 2], [3, 4]], "fro")'
    ]
};


var $62180f242f22e253$export$6eeb5046d44da601 = {
    name: "nthRoot",
    category: "Arithmetic",
    syntax: [
        "nthRoot(a)",
        "nthRoot(a, root)"
    ],
    description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".',
    examples: [
        "4 ^ 3",
        "nthRoot(64, 3)",
        "nthRoot(9, 2)",
        "sqrt(9)"
    ],
    seealso: [
        "nthRoots",
        "pow",
        "sqrt"
    ]
};


var $8ef7b9cf0165c947$export$3d5c8967f6152f8f = {
    name: "nthRoots",
    category: "Arithmetic",
    syntax: [
        "nthRoots(A)",
        "nthRoots(A, root)"
    ],
    description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.',
    examples: [
        "nthRoots(1)",
        "nthRoots(1, 3)"
    ],
    seealso: [
        "sqrt",
        "pow",
        "nthRoot"
    ]
};


var $91448ffe7dfcca58$export$2d9619da64c2bdd4 = {
    name: "pow",
    category: "Operators",
    syntax: [
        "x ^ y",
        "pow(x, y)"
    ],
    description: "Calculates the power of x to y, x^y.",
    examples: [
        "2^3",
        "2*2*2",
        "1 + e ^ (pi * i)",
        "math.pow([[1, 2], [4, 3]], 2)",
        "math.pow([[1, 2], [4, 3]], -1)"
    ],
    seealso: [
        "multiply",
        "nthRoot",
        "nthRoots",
        "sqrt"
    ]
};


var $7e390896305417a7$export$aaef6018d3e651c3 = {
    name: "round",
    category: "Arithmetic",
    syntax: [
        "round(x)",
        "round(x, n)"
    ],
    description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",
    examples: [
        "round(3.2)",
        "round(3.8)",
        "round(-4.2)",
        "round(-4.8)",
        "round(pi, 3)",
        "round(123.45678, 2)"
    ],
    seealso: [
        "ceil",
        "floor",
        "fix"
    ]
};


var $d3125e0b5fffdac5$export$4190acef139a44f2 = {
    name: "sign",
    category: "Arithmetic",
    syntax: [
        "sign(x)"
    ],
    description: "Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.",
    examples: [
        "sign(3.5)",
        "sign(-4.2)",
        "sign(0)"
    ],
    seealso: [
        "abs"
    ]
};


var $d4ccc1b1a91ce142$export$4c6bee88dcda7f24 = {
    name: "sqrt",
    category: "Arithmetic",
    syntax: [
        "sqrt(x)"
    ],
    description: "Compute the square root value. If x = y * y, then y is the square root of x.",
    examples: [
        "sqrt(25)",
        "5 * 5",
        "sqrt(-1)"
    ],
    seealso: [
        "square",
        "sqrtm",
        "multiply",
        "nthRoot",
        "nthRoots",
        "pow"
    ]
};


var $0859a2907892b15d$export$f470c8ca9def7f14 = {
    name: "sqrtm",
    category: "Arithmetic",
    syntax: [
        "sqrtm(x)"
    ],
    description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.",
    examples: [
        "sqrtm([[1, 2], [3, 4]])"
    ],
    seealso: [
        "sqrt",
        "abs",
        "square",
        "multiply"
    ]
};


var $85643118d92218eb$export$8aa8fe580e40693e = {
    name: "square",
    category: "Arithmetic",
    syntax: [
        "square(x)"
    ],
    description: "Compute the square of a value. The square of x is x * x.",
    examples: [
        "square(3)",
        "sqrt(9)",
        "3^2",
        "3 * 3"
    ],
    seealso: [
        "multiply",
        "pow",
        "sqrt",
        "cube"
    ]
};


var $5aecf3940b46b1f2$export$435374265ca1b923 = {
    name: "subtract",
    category: "Operators",
    syntax: [
        "x - y",
        "subtract(x, y)"
    ],
    description: "subtract two values.",
    examples: [
        "a = 5.3 - 2",
        "a + 2",
        "2/3 - 1/6",
        "2 * 3 - 3",
        "2.1 km - 500m"
    ],
    seealso: [
        "add"
    ]
};


var $1f006f1d9fab103a$export$4d94f3f25dc2600b = {
    name: "unaryMinus",
    category: "Operators",
    syntax: [
        "-x",
        "unaryMinus(x)"
    ],
    description: "Inverse the sign of a value. Converts booleans and strings to numbers.",
    examples: [
        "-4.5",
        "-(-5.6)",
        '-"22"'
    ],
    seealso: [
        "add",
        "subtract",
        "unaryPlus"
    ]
};


var $5c768e8e50006228$export$e50639526da1c8e2 = {
    name: "unaryPlus",
    category: "Operators",
    syntax: [
        "+x",
        "unaryPlus(x)"
    ],
    description: "Converts booleans and strings to numbers.",
    examples: [
        "+true",
        '+"2"'
    ],
    seealso: [
        "add",
        "subtract",
        "unaryMinus"
    ]
};


var $98b1c59d1b5158cb$export$82911c1a1d0407b8 = {
    name: "xgcd",
    category: "Arithmetic",
    syntax: [
        "xgcd(a, b)"
    ],
    description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.",
    examples: [
        "xgcd(8, 12)",
        "gcd(8, 12)",
        "xgcd(36163, 21199)"
    ],
    seealso: [
        "gcd",
        "lcm"
    ]
};


var $5e17598aaa570c58$export$9809e2502d5f7c7c = {
    name: "bitAnd",
    category: "Bitwise",
    syntax: [
        "x & y",
        "bitAnd(x, y)"
    ],
    description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",
    examples: [
        "5 & 3",
        "bitAnd(53, 131)",
        "[1, 12, 31] & 42"
    ],
    seealso: [
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};


var $68ab63be9d5d7659$export$3d49fbbfcb05eb36 = {
    name: "bitNot",
    category: "Bitwise",
    syntax: [
        "~x",
        "bitNot(x)"
    ],
    description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",
    examples: [
        "~1",
        "~2",
        "bitNot([2, -3, 4])"
    ],
    seealso: [
        "bitAnd",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};


var $72707859d6eccd5f$export$dc934370739527a8 = {
    name: "bitOr",
    category: "Bitwise",
    syntax: [
        "x | y",
        "bitOr(x, y)"
    ],
    description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",
    examples: [
        "5 | 3",
        "bitOr([1, 2, 3], 4)"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};


var $1da6222e2b756157$export$c5717818ea6d1c80 = {
    name: "bitXor",
    category: "Bitwise",
    syntax: [
        "bitXor(x, y)"
    ],
    description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",
    examples: [
        "bitOr(1, 2)",
        "bitXor([2, 3, 4], 4)"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};


var $6a5f5b74b9ea00bf$export$fb75ebd54811e095 = {
    name: "leftShift",
    category: "Bitwise",
    syntax: [
        "x << y",
        "leftShift(x, y)"
    ],
    description: "Bitwise left logical shift of a value x by y number of bits.",
    examples: [
        "4 << 1",
        "8 >> 1"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "rightArithShift",
        "rightLogShift"
    ]
};


var $e83ceedca2ee502b$export$180767993e37a793 = {
    name: "rightArithShift",
    category: "Bitwise",
    syntax: [
        "x >> y",
        "rightArithShift(x, y)"
    ],
    description: "Bitwise right arithmetic shift of a value x by y number of bits.",
    examples: [
        "8 >> 1",
        "4 << 1",
        "-12 >> 2"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightLogShift"
    ]
};


var $95179647fe13adaa$export$613695fe01bcb038 = {
    name: "rightLogShift",
    category: "Bitwise",
    syntax: [
        "x >>> y",
        "rightLogShift(x, y)"
    ],
    description: "Bitwise right logical shift of a value x by y number of bits.",
    examples: [
        "8 >>> 1",
        "4 << 1",
        "-12 >>> 2"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift"
    ]
};


var $7a4c9dfb9ac97397$export$f6a5bb92e66e375e = {
    name: "bellNumbers",
    category: "Combinatorics",
    syntax: [
        "bellNumbers(n)"
    ],
    description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",
    examples: [
        "bellNumbers(3)",
        "bellNumbers(8)"
    ],
    seealso: [
        "stirlingS2"
    ]
};


var $95b05c160038618b$export$b34ea8a080f60e3b = {
    name: "catalan",
    category: "Combinatorics",
    syntax: [
        "catalan(n)"
    ],
    description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",
    examples: [
        "catalan(3)",
        "catalan(8)"
    ],
    seealso: [
        "bellNumbers"
    ]
};


var $926a208bb4d7b2c1$export$7898728062a0cb7c = {
    name: "composition",
    category: "Combinatorics",
    syntax: [
        "composition(n, k)"
    ],
    description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",
    examples: [
        "composition(5, 3)"
    ],
    seealso: [
        "combinations"
    ]
};


var $d465957fdbe0c8b1$export$46c34bdf03072170 = {
    name: "stirlingS2",
    category: "Combinatorics",
    syntax: [
        "stirlingS2(n, k)"
    ],
    description: "he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",
    examples: [
        "stirlingS2(5, 3)"
    ],
    seealso: [
        "bellNumbers"
    ]
};


var $837a242ae91733a6$export$eace15c6c3c286dc = {
    name: "arg",
    category: "Complex",
    syntax: [
        "arg(x)"
    ],
    description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",
    examples: [
        "arg(2 + 2i)",
        "atan2(3, 2)",
        "arg(2 + 3i)"
    ],
    seealso: [
        "re",
        "im",
        "conj",
        "abs"
    ]
};


var $d90c46520cc9704e$export$e042ae5cfa3c3343 = {
    name: "conj",
    category: "Complex",
    syntax: [
        "conj(x)"
    ],
    description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",
    examples: [
        "conj(2 + 3i)",
        "conj(2 - 3i)",
        "conj(-5.2i)"
    ],
    seealso: [
        "re",
        "im",
        "abs",
        "arg"
    ]
};


var $62183631e98026b4$export$3476e22b3f658c7c = {
    name: "im",
    category: "Complex",
    syntax: [
        "im(x)"
    ],
    description: "Get the imaginary part of a complex number.",
    examples: [
        "im(2 + 3i)",
        "re(2 + 3i)",
        "im(-5.2i)",
        "im(2.4)"
    ],
    seealso: [
        "re",
        "conj",
        "abs",
        "arg"
    ]
};


var $597311ba38df1e3b$export$f13699bc77b8ea67 = {
    name: "re",
    category: "Complex",
    syntax: [
        "re(x)"
    ],
    description: "Get the real part of a complex number.",
    examples: [
        "re(2 + 3i)",
        "im(2 + 3i)",
        "re(-5.2i)",
        "re(2.4)"
    ],
    seealso: [
        "im",
        "conj",
        "abs",
        "arg"
    ]
};


var $d001196bd1825479$export$f32c54c70ddd9931 = {
    name: "evaluate",
    category: "Expression",
    syntax: [
        "evaluate(expression)",
        "evaluate([expr1, expr2, expr3, ...])"
    ],
    description: "Evaluate an expression or an array with expressions.",
    examples: [
        'evaluate("2 + 3")',
        'evaluate("sqrt(" + 4 + ")")'
    ],
    seealso: []
};


var $67c55f2dc5947548$export$e55ca8c24fbd3be8 = {
    name: "help",
    category: "Expression",
    syntax: [
        "help(object)",
        "help(string)"
    ],
    description: "Display documentation on a function or data type.",
    examples: [
        "help(sqrt)",
        'help("complex")'
    ],
    seealso: []
};


var $997d95a3d8950a13$export$128b8878fdfb9e22 = {
    name: "distance",
    category: "Geometry",
    syntax: [
        "distance([x1, y1], [x2, y2])",
        "distance([[x1, y1], [x2, y2]])"
    ],
    description: "Calculates the Euclidean distance between two points.",
    examples: [
        "distance([0,0], [4,4])",
        "distance([[0,0], [4,4]])"
    ],
    seealso: []
};


var $e9015dcebc20d4cd$export$cf98256b70808117 = {
    name: "intersect",
    category: "Geometry",
    syntax: [
        "intersect(expr1, expr2, expr3, expr4)",
        "intersect(expr1, expr2, expr3)"
    ],
    description: "Computes the intersection point of lines and/or planes.",
    examples: [
        "intersect([0, 0], [10, 10], [10, 0], [0, 10])",
        "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"
    ],
    seealso: []
};


var $e3a2325581294c58$export$20737fc9b0a3839c = {
    name: "and",
    category: "Logical",
    syntax: [
        "x and y",
        "and(x, y)"
    ],
    description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.",
    examples: [
        "true and false",
        "true and true",
        "2 and 4"
    ],
    seealso: [
        "not",
        "or",
        "xor"
    ]
};


var $ef141ad85d452b16$export$dfd4aa05f81041ff = {
    name: "not",
    category: "Logical",
    syntax: [
        "not x",
        "not(x)"
    ],
    description: "Logical not. Flips the boolean value of given argument.",
    examples: [
        "not true",
        "not false",
        "not 2",
        "not 0"
    ],
    seealso: [
        "and",
        "or",
        "xor"
    ]
};


var $cbbd91070172fcd7$export$2200bcb1a08f6f8d = {
    name: "or",
    category: "Logical",
    syntax: [
        "x or y",
        "or(x, y)"
    ],
    description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.",
    examples: [
        "true or false",
        "false or false",
        "0 or 4"
    ],
    seealso: [
        "not",
        "and",
        "xor"
    ]
};


var $ebc5d6dd279c8460$export$dd9d665b8b14e2b2 = {
    name: "xor",
    category: "Logical",
    syntax: [
        "x xor y",
        "xor(x, y)"
    ],
    description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",
    examples: [
        "true xor false",
        "false xor false",
        "true xor true",
        "0 xor 4"
    ],
    seealso: [
        "not",
        "and",
        "or"
    ]
};


var $cd4449c32e003adc$export$a5760461eff76999 = {
    name: "column",
    category: "Matrix",
    syntax: [
        "column(x, index)"
    ],
    description: "Return a column from a matrix or array.",
    examples: [
        "A = [[1, 2], [3, 4]]",
        "column(A, 1)",
        "column(A, 2)"
    ],
    seealso: [
        "row",
        "matrixFromColumns"
    ]
};


var $c34f97e5b2f31e8f$export$2651d46c991329eb = {
    name: "concat",
    category: "Matrix",
    syntax: [
        "concat(A, B, C, ...)",
        "concat(A, B, C, ..., dim)"
    ],
    description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",
    examples: [
        "A = [1, 2; 5, 6]",
        "B = [3, 4; 7, 8]",
        "concat(A, B)",
        "concat(A, B, 1)",
        "concat(A, B, 2)"
    ],
    seealso: [
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $886f9692c2a9cbde$export$f5ba6930b6adafd1 = {
    name: "count",
    category: "Matrix",
    syntax: [
        "count(x)"
    ],
    description: "Count the number of elements of a matrix, array or string.",
    examples: [
        "a = [1, 2; 3, 4; 5, 6]",
        "count(a)",
        "size(a)",
        'count("hello world")'
    ],
    seealso: [
        "size"
    ]
};


var $ac0f8cc1a8a50d11$export$daf3380fde4ae39d = {
    name: "cross",
    category: "Matrix",
    syntax: [
        "cross(A, B)"
    ],
    description: "Calculate the cross product for two vectors in three dimensional space.",
    examples: [
        "cross([1, 1, 0],  [0, 1, 1])",
        "cross([3, -3, 1], [4, 9, 2])",
        "cross([2, 3, 4],  [5, 6, 7])"
    ],
    seealso: [
        "multiply",
        "dot"
    ]
};


var $4d77ade2444bce47$export$f9de74ff268bebd9 = {
    name: "ctranspose",
    category: "Matrix",
    syntax: [
        "x'",
        "ctranspose(x)"
    ],
    description: "Complex Conjugate and Transpose a matrix",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a'",
        "ctranspose(a)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "zeros"
    ]
};


var $b1a0dcb279c23674$export$8730784260ee72c2 = {
    name: "det",
    category: "Matrix",
    syntax: [
        "det(x)"
    ],
    description: "Calculate the determinant of a matrix",
    examples: [
        "det([1, 2; 3, 4])",
        "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"
    ],
    seealso: [
        "concat",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $1e891f1fae1a1c23$export$1c196182ad1e1777 = {
    name: "diag",
    category: "Matrix",
    syntax: [
        "diag(x)",
        "diag(x, k)"
    ],
    description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",
    examples: [
        "diag(1:3)",
        "diag(1:3, 1)",
        "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]",
        "diag(a)"
    ],
    seealso: [
        "concat",
        "det",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $9154cfd11ef2e4c9$export$68cc1a794c4b923 = {
    name: "diff",
    category: "Matrix",
    syntax: [
        "diff(arr)",
        "diff(arr, dim)"
    ],
    description: [
        "Create a new matrix or array with the difference of the passed matrix or array.",
        "Dim parameter is optional and used to indicant the dimension of the array/matrix to apply the difference",
        "If no dimension parameter is passed it is assumed as dimension 0",
        "Dimension is zero-based in javascript and one-based in the parser",
        "Arrays must be 'rectangular' meaning arrays like [1, 2]",
        "If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays"
    ],
    examples: [
        "diff([1, 2, 4, 7, 0])",
        "diff([1, 2, 4, 7, 0], 0)",
        "diff(matrix([1, 2, 4, 7, 0]))",
        "diff([[1, 2], [3, 4]])",
        "diff([[1, 2], [3, 4]], 0)",
        "diff([[1, 2], [3, 4]], 1)",
        "diff([[1, 2], [3, 4]], bignumber(1))",
        "diff(matrix([[1, 2], [3, 4]]), 1)",
        "diff([[1, 2], matrix([3, 4])], 1)"
    ],
    seealso: [
        "subtract",
        "partitionSelect"
    ]
};


var $a24fdef4ad18cd9f$export$5fcedf26656436a1 = {
    name: "dot",
    category: "Matrix",
    syntax: [
        "dot(A, B)",
        "A * B"
    ],
    description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",
    examples: [
        "dot([2, 4, 1], [2, 2, 3])",
        "[2, 4, 1] * [2, 2, 3]"
    ],
    seealso: [
        "multiply",
        "cross"
    ]
};


var $8b2a9d76ffd8ee0f$export$fb74125542bfdbb = {
    name: "eigs",
    category: "Matrix",
    syntax: [
        "eigs(x)"
    ],
    description: "Calculate the eigenvalues and eigenvectors of a real symmetric matrix",
    examples: [
        "eigs([[5, 2.3], [2.3, 1]])"
    ],
    seealso: [
        "inv"
    ]
};


var $d353ba20283a0fb5$export$86d791908cc7fd0c = {
    name: "filter",
    category: "Matrix",
    syntax: [
        "filter(x, test)"
    ],
    description: "Filter items in a matrix.",
    examples: [
        "isPositive(x) = x > 0",
        "filter([6, -2, -1, 4, 3], isPositive)",
        "filter([6, -2, 0, 1, 0], x != 0)"
    ],
    seealso: [
        "sort",
        "map",
        "forEach"
    ]
};


var $01982124ef74531f$export$501e32649028a485 = {
    name: "flatten",
    category: "Matrix",
    syntax: [
        "flatten(x)"
    ],
    description: "Flatten a multi dimensional matrix into a single dimensional matrix.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "size(a)",
        "b = flatten(a)",
        "size(b)"
    ],
    seealso: [
        "concat",
        "resize",
        "size",
        "squeeze"
    ]
};


var $314c2f2f06a2e70a$export$aa1ea88ef762ab5e = {
    name: "forEach",
    category: "Matrix",
    syntax: [
        "forEach(x, callback)"
    ],
    description: "Iterates over all elements of a matrix/array, and executes the given callback function.",
    examples: [
        "numberOfPets = {}",
        "addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;",
        'forEach(["Dog","Cat","Cat"], addPet)',
        "numberOfPets"
    ],
    seealso: [
        "map",
        "sort",
        "filter"
    ]
};


var $5898d7568016650a$export$bd8d81afc6159d78 = {
    name: "getMatrixDataType",
    category: "Matrix",
    syntax: [
        "getMatrixDataType(x)"
    ],
    description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".',
    examples: [
        "getMatrixDataType([1, 2, 3])",
        "getMatrixDataType([[5 cm], [2 inch]])",
        'getMatrixDataType([1, "text"])',
        "getMatrixDataType([1, bignumber(4)])"
    ],
    seealso: [
        "matrix",
        "sparse",
        "typeOf"
    ]
};


var $30f4e808a9d418cc$export$7fb92bf552f6842 = {
    name: "identity",
    category: "Matrix",
    syntax: [
        "identity(n)",
        "identity(m, n)",
        "identity([m, n])"
    ],
    description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",
    examples: [
        "identity(3)",
        "identity(3, 5)",
        "a = [1, 2, 3; 4, 5, 6]",
        "identity(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $ffa5cf785866dfb9$export$d584490ba37af473 = {
    name: "inv",
    category: "Matrix",
    syntax: [
        "inv(x)"
    ],
    description: "Calculate the inverse of a matrix",
    examples: [
        "inv([1, 2; 3, 4])",
        "inv(4)",
        "1 / 4"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $c82034b5ef08c274$export$11c117636228617d = {
    name: "pinv",
    category: "Matrix",
    syntax: [
        "pinv(x)"
    ],
    description: "Calculate the Moore\u2013Penrose inverse of a matrix",
    examples: [
        "pinv([1, 2; 3, 4])",
        "pinv([[1, 0], [0, 1], [0, 1]])",
        "pinv(4)"
    ],
    seealso: [
        "inv"
    ]
};


var $f2c574c0225a12d0$export$483111e0489c2571 = {
    name: "kron",
    category: "Matrix",
    syntax: [
        "kron(x, y)"
    ],
    description: "Calculates the kronecker product of 2 matrices or vectors.",
    examples: [
        "kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])",
        "kron([1,1], [2,3,4])"
    ],
    seealso: [
        "multiply",
        "dot",
        "cross"
    ]
};


var $78ffc72fe571e144$export$212579151a971c0d = {
    name: "map",
    category: "Matrix",
    syntax: [
        "map(x, callback)"
    ],
    description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.",
    examples: [
        "map([1, 2, 3], square)"
    ],
    seealso: [
        "filter",
        "forEach"
    ]
};


var $d67b1fde1d983112$export$b34e4bfbf268d446 = {
    name: "matrixFromColumns",
    category: "Matrix",
    syntax: [
        "math.matrixFromColumns(...arr)",
        "math.matrixFromColumns(row1, row2)",
        "math.matrixFromColumns(row1, row2, row3)"
    ],
    description: "Create a dense matrix from vectors as individual columns.",
    examples: [
        "matrixFromColumns([1, 2, 3], [[4],[5],[6]])"
    ],
    seealso: [
        "matrix",
        "matrixFromRows",
        "matrixFromFunction",
        "zeros"
    ]
};


var $9ab9acf04b8acaec$export$979fb7b58dfbecb3 = {
    name: "matrixFromFunction",
    category: "Matrix",
    syntax: [
        "math.matrixFromFunction(size, fn)",
        "math.matrixFromFunction(size, fn, format)",
        "math.matrixFromFunction(size, fn, format, datatype)",
        "math.matrixFromFunction(size, format, fn)",
        "math.matrixFromFunction(size, format, datatype, fn)"
    ],
    description: "Create a matrix by evaluating a generating function at each index.",
    examples: [
        "f(I) = I[1] - I[2]",
        "matrixFromFunction([3,3], f)",
        "g(I) = I[1] - I[2] == 1 ? 4 : 0",
        'matrixFromFunction([100, 100], "sparse", g)',
        "matrixFromFunction([5], random)"
    ],
    seealso: [
        "matrix",
        "matrixFromRows",
        "matrixFromColumns",
        "zeros"
    ]
};


var $29adc65be8339be6$export$99216cc634505607 = {
    name: "matrixFromRows",
    category: "Matrix",
    syntax: [
        "math.matrixFromRows(...arr)",
        "math.matrixFromRows(row1, row2)",
        "math.matrixFromRows(row1, row2, row3)"
    ],
    description: "Create a dense matrix from vectors as individual rows.",
    examples: [
        "matrixFromRows([1, 2, 3], [[4],[5],[6]])"
    ],
    seealso: [
        "matrix",
        "matrixFromColumns",
        "matrixFromFunction",
        "zeros"
    ]
};


var $08cbd45fe96bf170$export$910fc795c37fb1b2 = {
    name: "ones",
    category: "Matrix",
    syntax: [
        "ones(m)",
        "ones(m, n)",
        "ones(m, n, p, ...)",
        "ones([m])",
        "ones([m, n])",
        "ones([m, n, p, ...])"
    ],
    description: "Create a matrix containing ones.",
    examples: [
        "ones(3)",
        "ones(3, 5)",
        "ones([2,3]) * 4.5",
        "a = [1, 2, 3; 4, 5, 6]",
        "ones(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $6e738232c3db2d4e$export$65c28ab37b5158f2 = {
    name: "partitionSelect",
    category: "Matrix",
    syntax: [
        "partitionSelect(x, k)",
        "partitionSelect(x, k, compare)"
    ],
    description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",
    examples: [
        "partitionSelect([5, 10, 1], 2)",
        'partitionSelect(["C", "B", "A", "D"], 1)'
    ],
    seealso: [
        "sort"
    ]
};


var $644ed0ee001cc92b$export$f7c7d2df7253c271 = {
    name: "range",
    category: "Type",
    syntax: [
        "start:end",
        "start:step:end",
        "range(start, end)",
        "range(start, end, step)",
        "range(string)"
    ],
    description: "Create a range. Lower bound of the range is included, upper bound is excluded.",
    examples: [
        "1:5",
        "3:-1:-3",
        "range(3, 7)",
        "range(0, 12, 2)",
        'range("4:10")',
        "a = [1, 2, 3, 4; 5, 6, 7, 8]",
        "a[1:2, 1:2]"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $505cab02cc3bcde8$export$f57c799cb449edab = {
    name: "reshape",
    category: "Matrix",
    syntax: [
        "reshape(x, sizes)"
    ],
    description: "Reshape a multi dimensional array to fit the specified dimensions.",
    examples: [
        "reshape([1, 2, 3, 4, 5, 6], [2, 3])",
        "reshape([[1, 2], [3, 4]], [1, 4])",
        "reshape([[1, 2], [3, 4]], [4])"
    ],
    seealso: [
        "size",
        "squeeze",
        "resize"
    ]
};


var $6768f3f59e7cdc9b$export$9444f970d5d871cc = {
    name: "resize",
    category: "Matrix",
    syntax: [
        "resize(x, size)",
        "resize(x, size, defaultValue)"
    ],
    description: "Resize a matrix.",
    examples: [
        "resize([1,2,3,4,5], [3])",
        "resize([1,2,3], [5])",
        "resize([1,2,3], [5], -1)",
        "resize(2, [2, 3])",
        'resize("hello", [8], "!")'
    ],
    seealso: [
        "size",
        "subset",
        "squeeze",
        "reshape"
    ]
};


var $2578dddc4ce153bc$export$7e4afefc91c50a64 = {
    name: "rotate",
    category: "Matrix",
    syntax: [
        "rotate(w, theta)",
        "rotate(w, theta, v)"
    ],
    description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
    examples: [
        "rotate([1, 0], math.pi / 2)",
        'rotate(matrix([1, 0]), unit("35deg"))',
        'rotate([1, 0, 0], unit("90deg"), [0, 0, 1])',
        'rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))'
    ],
    seealso: [
        "matrix",
        "rotationMatrix"
    ]
};


var $de8bf97a0f1e6293$export$95d0e442170bdedb = {
    name: "rotationMatrix",
    category: "Matrix",
    syntax: [
        "rotationMatrix(theta)",
        "rotationMatrix(theta, v)",
        "rotationMatrix(theta, v, format)"
    ],
    description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
    examples: [
        "rotationMatrix(pi / 2)",
        'rotationMatrix(unit("45deg"), [0, 0, 1])',
        'rotationMatrix(1, matrix([0, 0, 1]), "sparse")'
    ],
    seealso: [
        "cos",
        "sin"
    ]
};


var $20feff1e11ae21e6$export$74b9786bafaa0a25 = {
    name: "row",
    category: "Matrix",
    syntax: [
        "row(x, index)"
    ],
    description: "Return a row from a matrix or array.",
    examples: [
        "A = [[1, 2], [3, 4]]",
        "row(A, 1)",
        "row(A, 2)"
    ],
    seealso: [
        "column",
        "matrixFromRows"
    ]
};


var $6bebcd8996f0b0fe$export$5044182a5ddc46fd = {
    name: "size",
    category: "Matrix",
    syntax: [
        "size(x)"
    ],
    description: "Calculate the size of a matrix.",
    examples: [
        "size(2.3)",
        'size("hello world")',
        "a = [1, 2; 3, 4; 5, 6]",
        "size(a)",
        "size(1:6)"
    ],
    seealso: [
        "concat",
        "count",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $9ab9c33147ee64b5$export$879539db0de7fe73 = {
    name: "sort",
    category: "Matrix",
    syntax: [
        "sort(x)",
        "sort(x, compare)"
    ],
    description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',
    examples: [
        "sort([5, 10, 1])",
        'sort(["C", "B", "A", "D"])',
        "sortByLength(a, b) = size(a)[1] - size(b)[1]",
        'sort(["Langdon", "Tom", "Sara"], sortByLength)',
        'sort(["10", "1", "2"], "natural")'
    ],
    seealso: [
        "map",
        "filter",
        "forEach"
    ]
};


var $5697390d9b0fa537$export$84665209630d2bb0 = {
    name: "squeeze",
    category: "Matrix",
    syntax: [
        "squeeze(x)"
    ],
    description: "Remove inner and outer singleton dimensions from a matrix.",
    examples: [
        "a = zeros(3,2,1)",
        "size(squeeze(a))",
        "b = zeros(1,1,3)",
        "size(squeeze(b))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $488be1bea21cad2f$export$c809a1297fda8972 = {
    name: "subset",
    category: "Matrix",
    syntax: [
        "value(index)",
        "value(index) = replacement",
        "subset(value, [index])",
        "subset(value, [index], replacement)"
    ],
    description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.",
    examples: [
        "d = [1, 2; 3, 4]",
        "e = []",
        "e[1, 1:2] = [5, 6]",
        "e[2, :] = [7, 8]",
        "f = d * e",
        "f[2, 1]",
        "f[:, 1]",
        "f[[1,2], [1,3]] = [9, 10; 11, 12]",
        "f"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $b8f8399cf6469a77$export$46db08346422dd41 = {
    name: "trace",
    category: "Matrix",
    syntax: [
        "trace(A)"
    ],
    description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",
    examples: [
        "A = [1, 2, 3; -1, 2, 3; 2, 0, 3]",
        "trace(A)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "transpose",
        "zeros"
    ]
};


var $3c19dadbdace9ea5$export$96fcaa3e48aec95b = {
    name: "transpose",
    category: "Matrix",
    syntax: [
        "x'",
        "transpose(x)"
    ],
    description: "Transpose a matrix",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a'",
        "transpose(a)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "zeros"
    ]
};


var $ca2401f3b00259df$export$d2794fce5915ba29 = {
    name: "zeros",
    category: "Matrix",
    syntax: [
        "zeros(m)",
        "zeros(m, n)",
        "zeros(m, n, p, ...)",
        "zeros([m])",
        "zeros([m, n])",
        "zeros([m, n, p, ...])"
    ],
    description: "Create a matrix containing zeros.",
    examples: [
        "zeros(3)",
        "zeros(3, 5)",
        "a = [1, 2, 3; 4, 5, 6]",
        "zeros(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose"
    ]
};


var $68e180461cf238bd$export$3e6cafc8d17845c7 = {
    name: "fft",
    category: "Matrix",
    syntax: [
        "fft(x)"
    ],
    description: "Calculate N-dimensional fourier transform",
    examples: [
        "fft([[1, 0], [1, 0]])"
    ],
    seealso: [
        "ifft"
    ]
};


var $141350ddbba23b9f$export$d2931323ec07a3c0 = {
    name: "ifft",
    category: "Matrix",
    syntax: [
        "ifft(x)"
    ],
    description: "Calculate N-dimensional inverse fourier transform",
    examples: [
        "ifft([[2, 2], [0, 0]])"
    ],
    seealso: [
        "fft"
    ]
};


var $6ef8131e553d2179$export$c3382240e69dd024 = {
    name: "combinations",
    category: "Probability",
    syntax: [
        "combinations(n, k)"
    ],
    description: "Compute the number of combinations of n items taken k at a time",
    examples: [
        "combinations(7, 5)"
    ],
    seealso: [
        "combinationsWithRep",
        "permutations",
        "factorial"
    ]
};


var $a47e27e54032bf64$export$6bd2fb28e29d18e3 = {
    name: "combinationsWithRep",
    category: "Probability",
    syntax: [
        "combinationsWithRep(n, k)"
    ],
    description: "Compute the number of combinations of n items taken k at a time with replacements.",
    examples: [
        "combinationsWithRep(7, 5)"
    ],
    seealso: [
        "combinations",
        "permutations",
        "factorial"
    ]
};


var $4bee48e0bf1fcb8a$export$3e6b0f8e2df12b9d = {
    name: "factorial",
    category: "Probability",
    syntax: [
        "n!",
        "factorial(n)"
    ],
    description: "Compute the factorial of a value",
    examples: [
        "5!",
        "5 * 4 * 3 * 2 * 1",
        "3!"
    ],
    seealso: [
        "combinations",
        "combinationsWithRep",
        "permutations",
        "gamma"
    ]
};


var $fcc0c6cf12df97bb$export$499ae9272b264120 = {
    name: "gamma",
    category: "Probability",
    syntax: [
        "gamma(n)"
    ],
    description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",
    examples: [
        "gamma(4)",
        "3!",
        "gamma(1/2)",
        "sqrt(pi)"
    ],
    seealso: [
        "factorial"
    ]
};


var $1b0c934e3cf4f2d7$export$b9351e80d68524a5 = {
    name: "lgamma",
    category: "Probability",
    syntax: [
        "lgamma(n)"
    ],
    description: "Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.",
    examples: [
        "lgamma(4)",
        "lgamma(1/2)",
        "lgamma(math.i)",
        "lgamma(complex(1.1, 2))"
    ],
    seealso: [
        "gamma"
    ]
};


var $804dedcef33b8ea5$export$9f240af60ea686af = {
    name: "kldivergence",
    category: "Probability",
    syntax: [
        "kldivergence(x, y)"
    ],
    description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.",
    examples: [
        "kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"
    ],
    seealso: []
};


var $725c57c8a0ced6aa$export$5f53cf42e3f9579d = {
    name: "multinomial",
    category: "Probability",
    syntax: [
        "multinomial(A)"
    ],
    description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.",
    examples: [
        "multinomial([1, 2, 1])"
    ],
    seealso: [
        "combinations",
        "factorial"
    ]
};


var $c399f37242ac0ce3$export$eebb1076c4c85884 = {
    name: "permutations",
    category: "Probability",
    syntax: [
        "permutations(n)",
        "permutations(n, k)"
    ],
    description: "Compute the number of permutations of n items taken k at a time",
    examples: [
        "permutations(5)",
        "permutations(5, 3)"
    ],
    seealso: [
        "combinations",
        "combinationsWithRep",
        "factorial"
    ]
};


var $c20e0d914bc4b3c0$export$4a787d8dccbe181f = {
    name: "pickRandom",
    category: "Probability",
    syntax: [
        "pickRandom(array)",
        "pickRandom(array, number)",
        "pickRandom(array, weights)",
        "pickRandom(array, number, weights)",
        "pickRandom(array, weights, number)"
    ],
    description: "Pick a random entry from a given array.",
    examples: [
        "pickRandom(0:10)",
        "pickRandom([1, 3, 1, 6])",
        "pickRandom([1, 3, 1, 6], 2)",
        "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])",
        "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])",
        "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"
    ],
    seealso: [
        "random",
        "randomInt"
    ]
};


var $b29168ba0f90a833$export$d2b3cacd4d3219ec = {
    name: "random",
    category: "Probability",
    syntax: [
        "random()",
        "random(max)",
        "random(min, max)",
        "random(size)",
        "random(size, max)",
        "random(size, min, max)"
    ],
    description: "Return a random number.",
    examples: [
        "random()",
        "random(10, 20)",
        "random([2, 3])"
    ],
    seealso: [
        "pickRandom",
        "randomInt"
    ]
};


var $e463d715b96f3f13$export$8e2c9b3226630e9d = {
    name: "randomInt",
    category: "Probability",
    syntax: [
        "randomInt(max)",
        "randomInt(min, max)",
        "randomInt(size)",
        "randomInt(size, max)",
        "randomInt(size, min, max)"
    ],
    description: "Return a random integer number",
    examples: [
        "randomInt(10, 20)",
        "randomInt([2, 3], 10)"
    ],
    seealso: [
        "pickRandom",
        "random"
    ]
};


var $a8e21e53a6aa8c7f$export$b01f6c58c90dea20 = {
    name: "compare",
    category: "Relational",
    syntax: [
        "compare(x, y)"
    ],
    description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        "compare(2, 3)",
        "compare(3, 2)",
        "compare(2, 2)",
        "compare(5cm, 40mm)",
        "compare(2, [1, 2, 3])"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compareNatural",
        "compareText"
    ]
};


var $312b7c4345f17d89$export$3d0415783a6e23a4 = {
    name: "compareNatural",
    category: "Relational",
    syntax: [
        "compareNatural(x, y)"
    ],
    description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        "compareNatural(2, 3)",
        "compareNatural(3, 2)",
        "compareNatural(2, 2)",
        "compareNatural(5cm, 40mm)",
        'compareNatural("2", "10")',
        "compareNatural(2 + 3i, 2 + 4i)",
        "compareNatural([1, 2, 4], [1, 2, 3])",
        "compareNatural([1, 5], [1, 2, 3])",
        "compareNatural([1, 2], [1, 2])",
        "compareNatural({a: 2}, {a: 4})"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compare",
        "compareText"
    ]
};


var $c24800e118d7d1fd$export$f1ca5e1f3bd19e5d = {
    name: "compareText",
    category: "Relational",
    syntax: [
        "compareText(x, y)"
    ],
    description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        'compareText("B", "A")',
        'compareText("A", "B")',
        'compareText("A", "A")',
        'compareText("2", "10")',
        'compare("2", "10")',
        "compare(2, 10)",
        'compareNatural("2", "10")',
        'compareText("B", ["A", "B", "C"])'
    ],
    seealso: [
        "compare",
        "compareNatural"
    ]
};


var $35f2234ec2ca48ca$export$b25f67ed715e775e = {
    name: "deepEqual",
    category: "Relational",
    syntax: [
        "deepEqual(x, y)"
    ],
    description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",
    examples: [
        "deepEqual([1,3,4], [1,3,4])",
        "deepEqual([1,3,4], [1,3])"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};


var $b1dc129c50280855$export$5d5e6107045d826c = {
    name: "equal",
    category: "Relational",
    syntax: [
        "x == y",
        "equal(x, y)"
    ],
    description: "Check equality of two values. Returns true if the values are equal, and false if not.",
    examples: [
        "2+2 == 3",
        "2+2 == 4",
        "a = 3.2",
        "b = 6-2.8",
        "a == b",
        "50cm == 0.5m"
    ],
    seealso: [
        "unequal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare",
        "deepEqual",
        "equalText"
    ]
};


var $68b5bb179081da5a$export$9f17f53860452971 = {
    name: "equalText",
    category: "Relational",
    syntax: [
        "equalText(x, y)"
    ],
    description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.",
    examples: [
        'equalText("Hello", "Hello")',
        'equalText("a", "A")',
        'equal("2e3", "2000")',
        'equalText("2e3", "2000")',
        'equalText("B", ["A", "B", "C"])'
    ],
    seealso: [
        "compare",
        "compareNatural",
        "compareText",
        "equal"
    ]
};


var $0e96ebd0b35278b7$export$c775ecf5ac7366c3 = {
    name: "larger",
    category: "Relational",
    syntax: [
        "x > y",
        "larger(x, y)"
    ],
    description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not.",
    examples: [
        "2 > 3",
        "5 > 2*2",
        "a = 3.3",
        "b = 6-2.8",
        "(a > b)",
        "(b < a)",
        "5 cm > 2 inch"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};


var $7c868a15bc76e5a6$export$6ba4892ab98a938f = {
    name: "largerEq",
    category: "Relational",
    syntax: [
        "x >= y",
        "largerEq(x, y)"
    ],
    description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",
    examples: [
        "2 >= 1+1",
        "2 > 1+1",
        "a = 3.2",
        "b = 6-2.8",
        "(a >= b)"
    ],
    seealso: [
        "equal",
        "unequal",
        "smallerEq",
        "smaller",
        "compare"
    ]
};


var $d86d8decd4746ba8$export$4ecf0efdd4fb906b = {
    name: "smaller",
    category: "Relational",
    syntax: [
        "x < y",
        "smaller(x, y)"
    ],
    description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.",
    examples: [
        "2 < 3",
        "5 < 2*2",
        "a = 3.3",
        "b = 6-2.8",
        "(a < b)",
        "5 cm < 2 inch"
    ],
    seealso: [
        "equal",
        "unequal",
        "larger",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};


var $80d0cbf089d2086f$export$2693b3d153548453 = {
    name: "smallerEq",
    category: "Relational",
    syntax: [
        "x <= y",
        "smallerEq(x, y)"
    ],
    description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",
    examples: [
        "2 <= 1+1",
        "2 < 1+1",
        "a = 3.2",
        "b = 6-2.8",
        "(a <= b)"
    ],
    seealso: [
        "equal",
        "unequal",
        "larger",
        "smaller",
        "largerEq",
        "compare"
    ]
};


var $5e300e38cd40a1c6$export$adade6432715c34e = {
    name: "unequal",
    category: "Relational",
    syntax: [
        "x != y",
        "unequal(x, y)"
    ],
    description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",
    examples: [
        "2+2 != 3",
        "2+2 != 4",
        "a = 3.2",
        "b = 6-2.8",
        "a != b",
        "50cm != 0.5m",
        "5 cm != 2 inch"
    ],
    seealso: [
        "equal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare",
        "deepEqual"
    ]
};


var $4ae63caf54d72476$export$6f06d74ab9e6fcad = {
    name: "setCartesian",
    category: "Set",
    syntax: [
        "setCartesian(set1, set2)"
    ],
    description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.",
    examples: [
        "setCartesian([1, 2], [3, 4])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference",
        "setPowerset"
    ]
};


var $c6715de721b9076b$export$44337ef629295c55 = {
    name: "setDifference",
    category: "Set",
    syntax: [
        "setDifference(set1, set2)"
    ],
    description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setDifference([1, 2, 3, 4], [3, 4, 5, 6])",
        "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setSymDifference"
    ]
};


var $b2877cb4d790610b$export$4c8f2f903562c625 = {
    name: "setDistinct",
    category: "Set",
    syntax: [
        "setDistinct(set)"
    ],
    description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setDistinct([1, 1, 1, 2, 2, 3])"
    ],
    seealso: [
        "setMultiplicity"
    ]
};


var $c3d4084642789751$export$97fa484e42285777 = {
    name: "setIntersect",
    category: "Set",
    syntax: [
        "setIntersect(set1, set2)"
    ],
    description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setIntersect([1, 2, 3, 4], [3, 4, 5, 6])",
        "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setDifference"
    ]
};


var $d970a19710317060$export$995337132a02fcf0 = {
    name: "setIsSubset",
    category: "Set",
    syntax: [
        "setIsSubset(set1, set2)"
    ],
    description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setIsSubset([1, 2], [3, 4, 5, 6])",
        "setIsSubset([3, 4], [3, 4, 5, 6])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};


var $3ebc318771fb4ae7$export$33972a95e247fd58 = {
    name: "setMultiplicity",
    category: "Set",
    syntax: [
        "setMultiplicity(element, set)"
    ],
    description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setMultiplicity(1, [1, 2, 2, 4])",
        "setMultiplicity(2, [1, 2, 2, 4])"
    ],
    seealso: [
        "setDistinct",
        "setSize"
    ]
};


var $a3ee595ed0cbc29f$export$7040fb97e0f08a08 = {
    name: "setPowerset",
    category: "Set",
    syntax: [
        "setPowerset(set)"
    ],
    description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setPowerset([1, 2, 3])"
    ],
    seealso: [
        "setCartesian"
    ]
};


var $5cb0834a237ae2d3$export$47ff1cdc99784c11 = {
    name: "setSize",
    category: "Set",
    syntax: [
        "setSize(set)",
        "setSize(set, unique)"
    ],
    description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
    examples: [
        "setSize([1, 2, 2, 4])",
        "setSize([1, 2, 2, 4], true)"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};


var $b976cc6e26e052a6$export$340d6a7da02d62f3 = {
    name: "setSymDifference",
    category: "Set",
    syntax: [
        "setSymDifference(set1, set2)"
    ],
    description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])",
        "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};


var $709766d55bb8f379$export$c6ab538723059178 = {
    name: "setUnion",
    category: "Set",
    syntax: [
        "setUnion(set1, set2)"
    ],
    description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setUnion([1, 2, 3, 4], [3, 4, 5, 6])",
        "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setIntersect",
        "setDifference"
    ]
};


var $79a1ea4a659ff9cc$export$23984555c8f4e00a = {
    name: "erf",
    category: "Special",
    syntax: [
        "erf(x)"
    ],
    description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",
    examples: [
        "erf(0.2)",
        "erf(-0.5)",
        "erf(4)"
    ],
    seealso: []
};


var $49d957a22f7c2e09$export$113a75651a4a72c6 = {
    name: "mad",
    category: "Statistics",
    syntax: [
        "mad(a, b, c, ...)",
        "mad(A)"
    ],
    description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.",
    examples: [
        "mad(10, 20, 30)",
        "mad([1, 2, 3])"
    ],
    seealso: [
        "mean",
        "median",
        "std",
        "abs"
    ]
};


var $ec5ee268c8d90847$export$f3fddd6eb2764aa6 = {
    name: "max",
    category: "Statistics",
    syntax: [
        "max(a, b, c, ...)",
        "max(A)",
        "max(A, dim)"
    ],
    description: "Compute the maximum value of a list of values.",
    examples: [
        "max(2, 3, 4, 1)",
        "max([2, 3, 4, 1])",
        "max([2, 5; 4, 3])",
        "max([2, 5; 4, 3], 1)",
        "max([2, 5; 4, 3], 2)",
        "max(2.7, 7.1, -4.5, 2.0, 4.1)",
        "min(2.7, 7.1, -4.5, 2.0, 4.1)"
    ],
    seealso: [
        "mean",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $46b48455193a3b96$export$1f7fad79151d4cc1 = {
    name: "mean",
    category: "Statistics",
    syntax: [
        "mean(a, b, c, ...)",
        "mean(A)",
        "mean(A, dim)"
    ],
    description: "Compute the arithmetic mean of a list of values.",
    examples: [
        "mean(2, 3, 4, 1)",
        "mean([2, 3, 4, 1])",
        "mean([2, 5; 4, 3])",
        "mean([2, 5; 4, 3], 1)",
        "mean([2, 5; 4, 3], 2)",
        "mean([1.0, 2.7, 3.2, 4.0])"
    ],
    seealso: [
        "max",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $fa30f0fbd0bbffce$export$dd1c97a64d85784b = {
    name: "median",
    category: "Statistics",
    syntax: [
        "median(a, b, c, ...)",
        "median(A)"
    ],
    description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",
    examples: [
        "median(5, 2, 7)",
        "median([3, -1, 5, 7])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "prod",
        "std",
        "sum",
        "variance",
        "quantileSeq"
    ]
};


var $ff77cd7bda8604c2$export$17718e9907e3ac84 = {
    name: "min",
    category: "Statistics",
    syntax: [
        "min(a, b, c, ...)",
        "min(A)",
        "min(A, dim)"
    ],
    description: "Compute the minimum value of a list of values.",
    examples: [
        "min(2, 3, 4, 1)",
        "min([2, 3, 4, 1])",
        "min([2, 5; 4, 3])",
        "min([2, 5; 4, 3], 1)",
        "min([2, 5; 4, 3], 2)",
        "min(2.7, 7.1, -4.5, 2.0, 4.1)",
        "max(2.7, 7.1, -4.5, 2.0, 4.1)"
    ],
    seealso: [
        "max",
        "mean",
        "median",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $c9da70cb1d4adf04$export$30b601fd0273be74 = {
    name: "mode",
    category: "Statistics",
    syntax: [
        "mode(a, b, c, ...)",
        "mode(A)",
        "mode(A, a, b, B, c, ...)"
    ],
    description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",
    examples: [
        "mode(2, 1, 4, 3, 1)",
        "mode([1, 2.7, 3.2, 4, 2.7])",
        "mode(1, 4, 6, 1, 6)"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $d42fe21ce270e8f1$export$524cc5e521f0e533 = {
    name: "prod",
    category: "Statistics",
    syntax: [
        "prod(a, b, c, ...)",
        "prod(A)"
    ],
    description: "Compute the product of all values.",
    examples: [
        "prod(2, 3, 4)",
        "prod([2, 3, 4])",
        "prod([2, 5; 4, 3])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "min",
        "std",
        "sum",
        "variance"
    ]
};


var $6cfdbe89893b4569$export$f80c87524ae9a59f = {
    name: "quantileSeq",
    category: "Statistics",
    syntax: [
        "quantileSeq(A, prob[, sorted])",
        "quantileSeq(A, [prob1, prob2, ...][, sorted])",
        "quantileSeq(A, N[, sorted])"
    ],
    description: "Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.",
    examples: [
        "quantileSeq([3, -1, 5, 7], 0.5)",
        "quantileSeq([3, -1, 5, 7], [1/3, 2/3])",
        "quantileSeq([3, -1, 5, 7], 2)",
        "quantileSeq([-1, 3, 5, 7], 0.5, true)"
    ],
    seealso: [
        "mean",
        "median",
        "min",
        "max",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $c26b586576c19687$export$d1c23b21300d0eb8 = {
    name: "std",
    category: "Statistics",
    syntax: [
        "std(a, b, c, ...)",
        "std(A)",
        "std(A, normalization)"
    ],
    description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
    examples: [
        "std(2, 4, 6)",
        "std([2, 4, 6, 8])",
        'std([2, 4, 6, 8], "uncorrected")',
        'std([2, 4, 6, 8], "biased")',
        "std([1, 2, 3; 4, 5, 6])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "prod",
        "sum",
        "variance"
    ]
};


var $7d5e45907c57faaf$export$b230561799d1722c = {
    name: "cumsum",
    category: "Statistics",
    syntax: [
        "cumsum(a, b, c, ...)",
        "cumsum(A)"
    ],
    description: "Compute the cumulative sum of all values.",
    examples: [
        "cumsum(2, 3, 4, 1)",
        "cumsum([2, 3, 4, 1])",
        "cumsum([1, 2; 3, 4])",
        "cumsum([1, 2; 3, 4], 1)",
        "cumsum([1, 2; 3, 4], 2)"
    ],
    seealso: [
        "max",
        "mean",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $4d6096bf80569584$export$cd6065b38df4efb0 = {
    name: "sum",
    category: "Statistics",
    syntax: [
        "sum(a, b, c, ...)",
        "sum(A)"
    ],
    description: "Compute the sum of all values.",
    examples: [
        "sum(2, 3, 4, 1)",
        "sum([2, 3, 4, 1])",
        "sum([2, 5; 4, 3])"
    ],
    seealso: [
        "max",
        "mean",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $6194797ab1c2c7b5$export$5a58a225f78b347f = {
    name: "variance",
    category: "Statistics",
    syntax: [
        "variance(a, b, c, ...)",
        "variance(A)",
        "variance(A, normalization)"
    ],
    description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
    examples: [
        "variance(2, 4, 6)",
        "variance([2, 4, 6, 8])",
        'variance([2, 4, 6, 8], "uncorrected")',
        'variance([2, 4, 6, 8], "biased")',
        "variance([1, 2, 3; 4, 5, 6])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "min",
        "prod",
        "std",
        "sum"
    ]
};


var $74633421cf9ef90c$export$a96a9170bca705dc = {
    name: "acos",
    category: "Trigonometry",
    syntax: [
        "acos(x)"
    ],
    description: "Compute the inverse cosine of a value in radians.",
    examples: [
        "acos(0.5)",
        "acos(cos(2.3))"
    ],
    seealso: [
        "cos",
        "atan",
        "asin"
    ]
};


var $64e8695993baed0b$export$eb8f1b26819009ca = {
    name: "acosh",
    category: "Trigonometry",
    syntax: [
        "acosh(x)"
    ],
    description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",
    examples: [
        "acosh(1.5)"
    ],
    seealso: [
        "cosh",
        "asinh",
        "atanh"
    ]
};


var $9cb8aedc06492773$export$5df2d36103c3facc = {
    name: "acot",
    category: "Trigonometry",
    syntax: [
        "acot(x)"
    ],
    description: "Calculate the inverse cotangent of a value.",
    examples: [
        "acot(0.5)",
        "acot(cot(0.5))",
        "acot(2)"
    ],
    seealso: [
        "cot",
        "atan"
    ]
};


var $3f74b1fc3bdc55a8$export$b7d7f2d7d0d4ec7d = {
    name: "acoth",
    category: "Trigonometry",
    syntax: [
        "acoth(x)"
    ],
    description: "Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",
    examples: [
        "acoth(2)",
        "acoth(0.5)"
    ],
    seealso: [
        "acsch",
        "asech"
    ]
};


var $bbe09ed5b44b14e2$export$911b51cd6a7612a8 = {
    name: "acsc",
    category: "Trigonometry",
    syntax: [
        "acsc(x)"
    ],
    description: "Calculate the inverse cotangent of a value.",
    examples: [
        "acsc(2)",
        "acsc(csc(0.5))",
        "acsc(0.5)"
    ],
    seealso: [
        "csc",
        "asin",
        "asec"
    ]
};


var $376af896a4d8f265$export$319c6d631e591850 = {
    name: "acsch",
    category: "Trigonometry",
    syntax: [
        "acsch(x)"
    ],
    description: "Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",
    examples: [
        "acsch(0.5)"
    ],
    seealso: [
        "asech",
        "acoth"
    ]
};


var $39569a83ccd752d6$export$fbe1d815e0591494 = {
    name: "asec",
    category: "Trigonometry",
    syntax: [
        "asec(x)"
    ],
    description: "Calculate the inverse secant of a value.",
    examples: [
        "asec(0.5)",
        "asec(sec(0.5))",
        "asec(2)"
    ],
    seealso: [
        "acos",
        "acot",
        "acsc"
    ]
};


var $31e0309d642af8ad$export$52f8b22e9936e0e = {
    name: "asech",
    category: "Trigonometry",
    syntax: [
        "asech(x)"
    ],
    description: "Calculate the inverse secant of a value.",
    examples: [
        "asech(0.5)"
    ],
    seealso: [
        "acsch",
        "acoth"
    ]
};


var $db8c6f5deda8e8f6$export$b85b8db6e8a2ed3d = {
    name: "asin",
    category: "Trigonometry",
    syntax: [
        "asin(x)"
    ],
    description: "Compute the inverse sine of a value in radians.",
    examples: [
        "asin(0.5)",
        "asin(sin(0.5))"
    ],
    seealso: [
        "sin",
        "acos",
        "atan"
    ]
};


var $3243a92138a19e3b$export$afe7a3b04750ebb7 = {
    name: "asinh",
    category: "Trigonometry",
    syntax: [
        "asinh(x)"
    ],
    description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",
    examples: [
        "asinh(0.5)"
    ],
    seealso: [
        "acosh",
        "atanh"
    ]
};


var $a210922253ed5928$export$80066e40c56154f0 = {
    name: "atan",
    category: "Trigonometry",
    syntax: [
        "atan(x)"
    ],
    description: "Compute the inverse tangent of a value in radians.",
    examples: [
        "atan(0.5)",
        "atan(tan(0.5))"
    ],
    seealso: [
        "tan",
        "acos",
        "asin"
    ]
};


var $0561a6cd556852b2$export$e4fc5308b4910337 = {
    name: "atan2",
    category: "Trigonometry",
    syntax: [
        "atan2(y, x)"
    ],
    description: "Computes the principal value of the arc tangent of y/x in radians.",
    examples: [
        "atan2(2, 2) / pi",
        "angle = 60 deg in rad",
        "x = cos(angle)",
        "y = sin(angle)",
        "atan2(y, x)"
    ],
    seealso: [
        "sin",
        "cos",
        "tan"
    ]
};


var $dc604408d4053fdc$export$e5bbdb9caa9a8f09 = {
    name: "atanh",
    category: "Trigonometry",
    syntax: [
        "atanh(x)"
    ],
    description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",
    examples: [
        "atanh(0.5)"
    ],
    seealso: [
        "acosh",
        "asinh"
    ]
};


var $cfea0b87c559480d$export$1a1af52900b6c58e = {
    name: "cos",
    category: "Trigonometry",
    syntax: [
        "cos(x)"
    ],
    description: "Compute the cosine of x in radians.",
    examples: [
        "cos(2)",
        "cos(pi / 4) ^ 2",
        "cos(180 deg)",
        "cos(60 deg)",
        "sin(0.2)^2 + cos(0.2)^2"
    ],
    seealso: [
        "acos",
        "sin",
        "tan"
    ]
};


var $e1a66baabb551f60$export$5af2bed23001ffc5 = {
    name: "cosh",
    category: "Trigonometry",
    syntax: [
        "cosh(x)"
    ],
    description: "Compute the hyperbolic cosine of x in radians.",
    examples: [
        "cosh(0.5)"
    ],
    seealso: [
        "sinh",
        "tanh",
        "coth"
    ]
};


var $49cced690dca5d11$export$b6bae004c5b418ef = {
    name: "cot",
    category: "Trigonometry",
    syntax: [
        "cot(x)"
    ],
    description: "Compute the cotangent of x in radians. Defined as 1/tan(x)",
    examples: [
        "cot(2)",
        "1 / tan(2)"
    ],
    seealso: [
        "sec",
        "csc",
        "tan"
    ]
};


var $3267dd055a3fe7b0$export$7cd2898db0b732d0 = {
    name: "coth",
    category: "Trigonometry",
    syntax: [
        "coth(x)"
    ],
    description: "Compute the hyperbolic cotangent of x in radians.",
    examples: [
        "coth(2)",
        "1 / tanh(2)"
    ],
    seealso: [
        "sech",
        "csch",
        "tanh"
    ]
};


var $5efaf69fccbc3d83$export$1be2e18f41ba39dc = {
    name: "csc",
    category: "Trigonometry",
    syntax: [
        "csc(x)"
    ],
    description: "Compute the cosecant of x in radians. Defined as 1/sin(x)",
    examples: [
        "csc(2)",
        "1 / sin(2)"
    ],
    seealso: [
        "sec",
        "cot",
        "sin"
    ]
};


var $573206f6209de842$export$8baf7f6e609495d8 = {
    name: "csch",
    category: "Trigonometry",
    syntax: [
        "csch(x)"
    ],
    description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",
    examples: [
        "csch(2)",
        "1 / sinh(2)"
    ],
    seealso: [
        "sech",
        "coth",
        "sinh"
    ]
};


var $0bf905659afcc0a1$export$3dae56ab28d48626 = {
    name: "sec",
    category: "Trigonometry",
    syntax: [
        "sec(x)"
    ],
    description: "Compute the secant of x in radians. Defined as 1/cos(x)",
    examples: [
        "sec(2)",
        "1 / cos(2)"
    ],
    seealso: [
        "cot",
        "csc",
        "cos"
    ]
};


var $77b971d35836931f$export$6da75bc9afc8303b = {
    name: "sech",
    category: "Trigonometry",
    syntax: [
        "sech(x)"
    ],
    description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",
    examples: [
        "sech(2)",
        "1 / cosh(2)"
    ],
    seealso: [
        "coth",
        "csch",
        "cosh"
    ]
};


var $ed54145358cfe85f$export$c7700d6ff32b1413 = {
    name: "sin",
    category: "Trigonometry",
    syntax: [
        "sin(x)"
    ],
    description: "Compute the sine of x in radians.",
    examples: [
        "sin(2)",
        "sin(pi / 4) ^ 2",
        "sin(90 deg)",
        "sin(30 deg)",
        "sin(0.2)^2 + cos(0.2)^2"
    ],
    seealso: [
        "asin",
        "cos",
        "tan"
    ]
};


var $3ac2ed6dc831b1e8$export$e07b4c62bc488091 = {
    name: "sinh",
    category: "Trigonometry",
    syntax: [
        "sinh(x)"
    ],
    description: "Compute the hyperbolic sine of x in radians.",
    examples: [
        "sinh(0.5)"
    ],
    seealso: [
        "cosh",
        "tanh"
    ]
};


var $be5d9f1fc419d6b3$export$14fc997d4768f36a = {
    name: "tan",
    category: "Trigonometry",
    syntax: [
        "tan(x)"
    ],
    description: "Compute the tangent of x in radians.",
    examples: [
        "tan(0.5)",
        "sin(0.5) / cos(0.5)",
        "tan(pi / 4)",
        "tan(45 deg)"
    ],
    seealso: [
        "atan",
        "sin",
        "cos"
    ]
};


var $6a5d951e94d66f7e$export$52a5c54b85f75620 = {
    name: "tanh",
    category: "Trigonometry",
    syntax: [
        "tanh(x)"
    ],
    description: "Compute the hyperbolic tangent of x in radians.",
    examples: [
        "tanh(0.5)",
        "sinh(0.5) / cosh(0.5)"
    ],
    seealso: [
        "sinh",
        "cosh"
    ]
};


var $059ee44edccbc8e4$export$c532fecb2dfa6274 = {
    name: "to",
    category: "Units",
    syntax: [
        "x to unit",
        "to(x, unit)"
    ],
    description: "Change the unit of a value.",
    examples: [
        "5 inch to cm",
        "3.2kg to g",
        "16 bytes in bits"
    ],
    seealso: []
};


var $abdf318988da290b$export$9859a5b8f644d8ff = {
    name: "bin",
    category: "Utils",
    syntax: [
        "bin(value)"
    ],
    description: "Format a number as binary",
    examples: [
        "bin(2)"
    ],
    seealso: [
        "oct",
        "hex"
    ]
};


var $6d72d99a6c688cb7$export$500c01a79e32a1ad = {
    name: "clone",
    category: "Utils",
    syntax: [
        "clone(x)"
    ],
    description: "Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices",
    examples: [
        "clone(3.5)",
        "clone(2 - 4i)",
        "clone(45 deg)",
        "clone([1, 2; 3, 4])",
        'clone("hello world")'
    ],
    seealso: []
};


var $eca950294c42a27f$export$278425b4fe1ff1bf = {
    name: "format",
    category: "Utils",
    syntax: [
        "format(value)",
        "format(value, precision)"
    ],
    description: "Format a value of any type as string.",
    examples: [
        "format(2.3)",
        "format(3 - 4i)",
        "format([])",
        "format(pi, 3)"
    ],
    seealso: [
        "print"
    ]
};


var $f2c279657dda588c$export$9d10d68d9b7d7a67 = {
    name: "hasNumericValue",
    category: "Utils",
    syntax: [
        "hasNumericValue(x)"
    ],
    description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.",
    examples: [
        "hasNumericValue(2)",
        'hasNumericValue("2")',
        'isNumeric("2")',
        "hasNumericValue(0)",
        "hasNumericValue(bignumber(500))",
        "hasNumericValue(fraction(0.125))",
        "hasNumericValue(2 + 3i)",
        'hasNumericValue([2.3, "foo", false])'
    ],
    seealso: [
        "isInteger",
        "isZero",
        "isNegative",
        "isPositive",
        "isNaN",
        "isNumeric"
    ]
};


var $240fd59418f900c6$export$81a08b4e66fc3038 = {
    name: "hex",
    category: "Utils",
    syntax: [
        "hex(value)"
    ],
    description: "Format a number as hexadecimal",
    examples: [
        "hex(240)"
    ],
    seealso: [
        "bin",
        "oct"
    ]
};


var $010bc0a52ceff6db$export$1d8b51b394bbccdc = {
    name: "isInteger",
    category: "Utils",
    syntax: [
        "isInteger(x)"
    ],
    description: "Test whether a value is an integer number.",
    examples: [
        "isInteger(2)",
        "isInteger(3.5)",
        "isInteger([3, 0.5, -2])"
    ],
    seealso: [
        "isNegative",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};


var $f0f1882e2c97aceb$export$f4e7c51d549c187f = {
    name: "isNaN",
    category: "Utils",
    syntax: [
        "isNaN(x)"
    ],
    description: "Test whether a value is NaN (not a number)",
    examples: [
        "isNaN(2)",
        "isNaN(0 / 0)",
        "isNaN(NaN)",
        "isNaN(Infinity)"
    ],
    seealso: [
        "isNegative",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};


var $cc84482b4e9e7400$export$f94a800b9b237f17 = {
    name: "isNegative",
    category: "Utils",
    syntax: [
        "isNegative(x)"
    ],
    description: "Test whether a value is negative: smaller than zero.",
    examples: [
        "isNegative(2)",
        "isNegative(0)",
        "isNegative(-4)",
        "isNegative([3, 0.5, -2])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};


var $3cdd105b43ebf198$export$7ac3927ed17fe2b6 = {
    name: "isNumeric",
    category: "Utils",
    syntax: [
        "isNumeric(x)"
    ],
    description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",
    examples: [
        "isNumeric(2)",
        'isNumeric("2")',
        'hasNumericValue("2")',
        "isNumeric(0)",
        "isNumeric(bignumber(500))",
        "isNumeric(fraction(0.125))",
        "isNumeric(2 + 3i)",
        'isNumeric([2.3, "foo", false])'
    ],
    seealso: [
        "isInteger",
        "isZero",
        "isNegative",
        "isPositive",
        "isNaN",
        "hasNumericValue"
    ]
};


var $6aea868debec50b8$export$338f53b321c261b9 = {
    name: "isPositive",
    category: "Utils",
    syntax: [
        "isPositive(x)"
    ],
    description: "Test whether a value is positive: larger than zero.",
    examples: [
        "isPositive(2)",
        "isPositive(0)",
        "isPositive(-4)",
        "isPositive([3, 0.5, -2])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isZero"
    ]
};


var $7966a8d5fbe9ccd7$export$d6ada432c5e7d9c7 = {
    name: "isPrime",
    category: "Utils",
    syntax: [
        "isPrime(x)"
    ],
    description: "Test whether a value is prime: has no divisors other than itself and one.",
    examples: [
        "isPrime(3)",
        "isPrime(-2)",
        "isPrime([2, 17, 100])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isZero"
    ]
};


var $d987b41b731c5507$export$52c03b663dd15fa3 = {
    name: "isZero",
    category: "Utils",
    syntax: [
        "isZero(x)"
    ],
    description: "Test whether a value is zero.",
    examples: [
        "isZero(2)",
        "isZero(0)",
        "isZero(-4)",
        "isZero([3, 0, -2, 0])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isPositive"
    ]
};


var $5bb0469bf1017158$export$d275ce05039a5f7a = {
    name: "numeric",
    category: "Utils",
    syntax: [
        "numeric(x)"
    ],
    description: "Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.",
    examples: [
        'numeric("4")',
        'numeric("4", "number")',
        'numeric("4", "BigNumber")',
        'numeric("4", "Fraction)',
        'numeric(4, "Fraction")',
        'numeric(fraction(2, 5), "number)'
    ],
    seealso: [
        "number",
        "fraction",
        "bignumber",
        "string",
        "format"
    ]
};


var $e9eb40d9b792b9b5$export$669461bdc241fd13 = {
    name: "oct",
    category: "Utils",
    syntax: [
        "oct(value)"
    ],
    description: "Format a number as octal",
    examples: [
        "oct(56)"
    ],
    seealso: [
        "bin",
        "hex"
    ]
};


var $ca43422b7cf59797$export$e3b3b470cfab492d = {
    name: "print",
    category: "Utils",
    syntax: [
        "print(template, values)",
        "print(template, values, precision)"
    ],
    description: "Interpolate values into a string template.",
    examples: [
        'print("Lucy is $age years old", {age: 5})',
        'print("The value of pi is $pi", {pi: pi}, 3)',
        'print("Hello, $user.name!", {user: {name: "John"}})',
        'print("Values: $0, $1, $2", [6, 9, 4])'
    ],
    seealso: [
        "format"
    ]
};


var $94229334d5aacdf9$export$5b193b71b9b497e6 = {
    name: "typeOf",
    category: "Utils",
    syntax: [
        "typeOf(x)"
    ],
    description: "Get the type of a variable.",
    examples: [
        "typeOf(3.5)",
        "typeOf(2 - 4i)",
        "typeOf(45 deg)",
        'typeOf("hello world")'
    ],
    seealso: [
        "getMatrixDataType"
    ]
};


var $8f197836390b4e8e$export$c2adf0a3344c85c9 = {
    // construction functions
    bignumber: (0, $4f86be50a1ba66c2$export$e8c3f4e3ad52a4e6),
    boolean: (0, $33485e150e22f8ba$export$dbe10b9a90fd671a),
    complex: (0, $097dfc938d0b3651$export$a266a326dd0e84ff),
    createUnit: (0, $d3dea2bfdb26b176$export$e56a121dfffbec82),
    fraction: (0, $ffb9c4298840fffa$export$46678100e6b87439),
    index: (0, $951c7e5e7d6ee02f$export$39876fcf61312bba),
    matrix: (0, $96cbb525c1395ade$export$dc433018b5b5e90f),
    number: (0, $563e91a35560db1c$export$3b011c0eed79d7e0),
    sparse: (0, $f054447c83c26eca$export$b569625c2404133),
    splitUnit: (0, $c9710c2f92611a63$export$f729a0241c48cb52),
    string: (0, $b4d681757b56ae21$export$783e4a4a90f7bc1d),
    unit: (0, $711e1d87ff757af5$export$478a7368ebd56459),
    // constants
    e: (0, $4df866376cb41031$export$3fcb7a132c6e2ba6),
    E: (0, $4df866376cb41031$export$3fcb7a132c6e2ba6),
    false: (0, $f37ac914769ce280$export$a73c839095ae9f5c),
    i: (0, $f5a2a244617a6198$export$e6ca220ee1b42382),
    Infinity: (0, $3324a0268fb2ab78$export$15a96a548a33c6f1),
    LN2: (0, $cfc6c6529c66247b$export$6e0577c024a56563),
    LN10: (0, $fc116263ec33d8ce$export$a1bd41a4b6a2fca0),
    LOG2E: (0, $81e8d6cb6bc5642b$export$813e053668381c19),
    LOG10E: (0, $585eae9d09b052d2$export$c706f91356bdd28c),
    NaN: (0, $e986eb6449dcaf4e$export$eabb08eada5c068d),
    null: (0, $9ec2c97b8d94830b$export$a805f16f075f20cb),
    pi: (0, $2e10a592641bc971$export$acdd1b7b7d3e5e4e),
    PI: (0, $2e10a592641bc971$export$acdd1b7b7d3e5e4e),
    phi: (0, $ea1d7dc77765f035$export$f4e037238b5533c1),
    SQRT1_2: (0, $e61c61689c2a761a$export$6838d33506c2b5d0),
    SQRT2: (0, $320c6aa7e5151920$export$ce0e8257aab3e4ae),
    tau: (0, $48c7641fcd361624$export$aee6f1e4bf7402c8),
    true: (0, $e619af5a857533a2$export$f6ccf6a3f013127d),
    version: (0, $0b909a7faf5b81c4$export$c94cc7868097f914),
    // physical constants
    // TODO: more detailed docs for physical constants
    speedOfLight: {
        description: "Speed of light in vacuum",
        examples: [
            "speedOfLight"
        ]
    },
    gravitationConstant: {
        description: "Newtonian constant of gravitation",
        examples: [
            "gravitationConstant"
        ]
    },
    planckConstant: {
        description: "Planck constant",
        examples: [
            "planckConstant"
        ]
    },
    reducedPlanckConstant: {
        description: "Reduced Planck constant",
        examples: [
            "reducedPlanckConstant"
        ]
    },
    magneticConstant: {
        description: "Magnetic constant (vacuum permeability)",
        examples: [
            "magneticConstant"
        ]
    },
    electricConstant: {
        description: "Electric constant (vacuum permeability)",
        examples: [
            "electricConstant"
        ]
    },
    vacuumImpedance: {
        description: "Characteristic impedance of vacuum",
        examples: [
            "vacuumImpedance"
        ]
    },
    coulomb: {
        description: "Coulomb's constant",
        examples: [
            "coulomb"
        ]
    },
    elementaryCharge: {
        description: "Elementary charge",
        examples: [
            "elementaryCharge"
        ]
    },
    bohrMagneton: {
        description: "Borh magneton",
        examples: [
            "bohrMagneton"
        ]
    },
    conductanceQuantum: {
        description: "Conductance quantum",
        examples: [
            "conductanceQuantum"
        ]
    },
    inverseConductanceQuantum: {
        description: "Inverse conductance quantum",
        examples: [
            "inverseConductanceQuantum"
        ]
    },
    // josephson: {description: 'Josephson constant', examples: ['josephson']},
    magneticFluxQuantum: {
        description: "Magnetic flux quantum",
        examples: [
            "magneticFluxQuantum"
        ]
    },
    nuclearMagneton: {
        description: "Nuclear magneton",
        examples: [
            "nuclearMagneton"
        ]
    },
    klitzing: {
        description: "Von Klitzing constant",
        examples: [
            "klitzing"
        ]
    },
    bohrRadius: {
        description: "Borh radius",
        examples: [
            "bohrRadius"
        ]
    },
    classicalElectronRadius: {
        description: "Classical electron radius",
        examples: [
            "classicalElectronRadius"
        ]
    },
    electronMass: {
        description: "Electron mass",
        examples: [
            "electronMass"
        ]
    },
    fermiCoupling: {
        description: "Fermi coupling constant",
        examples: [
            "fermiCoupling"
        ]
    },
    fineStructure: {
        description: "Fine-structure constant",
        examples: [
            "fineStructure"
        ]
    },
    hartreeEnergy: {
        description: "Hartree energy",
        examples: [
            "hartreeEnergy"
        ]
    },
    protonMass: {
        description: "Proton mass",
        examples: [
            "protonMass"
        ]
    },
    deuteronMass: {
        description: "Deuteron Mass",
        examples: [
            "deuteronMass"
        ]
    },
    neutronMass: {
        description: "Neutron mass",
        examples: [
            "neutronMass"
        ]
    },
    quantumOfCirculation: {
        description: "Quantum of circulation",
        examples: [
            "quantumOfCirculation"
        ]
    },
    rydberg: {
        description: "Rydberg constant",
        examples: [
            "rydberg"
        ]
    },
    thomsonCrossSection: {
        description: "Thomson cross section",
        examples: [
            "thomsonCrossSection"
        ]
    },
    weakMixingAngle: {
        description: "Weak mixing angle",
        examples: [
            "weakMixingAngle"
        ]
    },
    efimovFactor: {
        description: "Efimov factor",
        examples: [
            "efimovFactor"
        ]
    },
    atomicMass: {
        description: "Atomic mass constant",
        examples: [
            "atomicMass"
        ]
    },
    avogadro: {
        description: "Avogadro's number",
        examples: [
            "avogadro"
        ]
    },
    boltzmann: {
        description: "Boltzmann constant",
        examples: [
            "boltzmann"
        ]
    },
    faraday: {
        description: "Faraday constant",
        examples: [
            "faraday"
        ]
    },
    firstRadiation: {
        description: "First radiation constant",
        examples: [
            "firstRadiation"
        ]
    },
    loschmidt: {
        description: "Loschmidt constant at T=273.15 K and p=101.325 kPa",
        examples: [
            "loschmidt"
        ]
    },
    gasConstant: {
        description: "Gas constant",
        examples: [
            "gasConstant"
        ]
    },
    molarPlanckConstant: {
        description: "Molar Planck constant",
        examples: [
            "molarPlanckConstant"
        ]
    },
    molarVolume: {
        description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",
        examples: [
            "molarVolume"
        ]
    },
    sackurTetrode: {
        description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa",
        examples: [
            "sackurTetrode"
        ]
    },
    secondRadiation: {
        description: "Second radiation constant",
        examples: [
            "secondRadiation"
        ]
    },
    stefanBoltzmann: {
        description: "Stefan-Boltzmann constant",
        examples: [
            "stefanBoltzmann"
        ]
    },
    wienDisplacement: {
        description: "Wien displacement law constant",
        examples: [
            "wienDisplacement"
        ]
    },
    // spectralRadiance: {description: 'First radiation constant for spectral radiance', examples: ['spectralRadiance']},
    molarMass: {
        description: "Molar mass constant",
        examples: [
            "molarMass"
        ]
    },
    molarMassC12: {
        description: "Molar mass constant of carbon-12",
        examples: [
            "molarMassC12"
        ]
    },
    gravity: {
        description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)",
        examples: [
            "gravity"
        ]
    },
    planckLength: {
        description: "Planck length",
        examples: [
            "planckLength"
        ]
    },
    planckMass: {
        description: "Planck mass",
        examples: [
            "planckMass"
        ]
    },
    planckTime: {
        description: "Planck time",
        examples: [
            "planckTime"
        ]
    },
    planckCharge: {
        description: "Planck charge",
        examples: [
            "planckCharge"
        ]
    },
    planckTemperature: {
        description: "Planck temperature",
        examples: [
            "planckTemperature"
        ]
    },
    // functions - algebra
    derivative: (0, $0677a0889548ccc9$export$14d93412c4f1ed0d),
    lsolve: (0, $66ab1993c2c9ec25$export$4bef5c6fa8c1f081),
    lsolveAll: (0, $4fc27e688547a630$export$40bf697ca86bce02),
    lup: (0, $5af0be486ef008e0$export$aa45954995260db7),
    lusolve: (0, $2e3ef1b796781072$export$b24588d98e782136),
    leafCount: (0, $b411bba36e573973$export$a44548b5a791ce3a),
    resolve: (0, $bcbd996bcaed18d5$export$becee114188e4530),
    simplify: (0, $712ae80751bd32ff$export$5a53589a8ff0d1cd),
    simplifyCore: (0, $f3aa809e44b7ad95$export$466a93707e1e5969),
    symbolicEqual: (0, $75ac32e61766dd00$export$1ff0943310cb2f46),
    rationalize: (0, $e89b1db434055690$export$1802f015e36a313),
    slu: (0, $fa7c065b3f015282$export$a68dbefd846d8955),
    usolve: (0, $70567ed61ead988d$export$2e45391f5cc49d1d),
    usolveAll: (0, $27d0c9229b4f1bc8$export$64b3b7af0d3d4548),
    qr: (0, $89820395287d2c4b$export$717c61ebe37cce2a),
    // functions - arithmetic
    abs: (0, $b6595d12d9a37f56$export$d21ec9cf3daa768b),
    add: (0, $a49d9cf328cf58c0$export$6fe0cea5d5e6ddba),
    cbrt: (0, $1b8de4974886ee29$export$9330e90a8e7851e6),
    ceil: (0, $c54551ef7545a215$export$bf625dbce78edf39),
    cube: (0, $7b93d3024290f78f$export$ceabaa40b420fd2f),
    divide: (0, $707a84fe61a604df$export$e4cc3c6ddad47fb),
    dotDivide: (0, $12a5d5e2c65c5eaf$export$f1a6e1f6a311adf8),
    dotMultiply: (0, $2e00aa760615e0ae$export$4e72f4c646ece24a),
    dotPow: (0, $0a965cd4f26b61b4$export$db82d026e80f1871),
    exp: (0, $5b5095dbf60d7a6a$export$e855e42434736fab),
    expm: (0, $90dcd15cadcd875a$export$df3b4f2159ca23f5),
    expm1: (0, $efd9dd838957b1f9$export$d6fb67f466ac866c),
    fix: (0, $cf32cc8aa0045b73$export$ec1a27fd93212099),
    floor: (0, $92887728829140ae$export$7eb1ac5a6cfbe8b6),
    gcd: (0, $4c0a08e9ad879902$export$ccc9190f6201c21e),
    hypot: (0, $7a3aa31d7d41df42$export$53821d38c3eeff69),
    lcm: (0, $4aa80ac8af9a8c85$export$371d4953326569cb),
    log: (0, $d32689f0b872f329$export$10fa3fadd260900f),
    log2: (0, $b69b4ac028cc0a97$export$fa36f06e6e8bfb36),
    log1p: (0, $5ab0a391b8f697af$export$5739f5d11cd187ac),
    log10: (0, $b0b842b0e49b3c02$export$a4c310b6d4346035),
    mod: (0, $e835c4da59d0d72d$export$f9c7d95d1ec52e50),
    multiply: (0, $0aff45cd2aac1b58$export$1506e47b2a5ae6da),
    norm: (0, $8a2585c2fb84ed7f$export$9745ccea7c23999),
    nthRoot: (0, $62180f242f22e253$export$6eeb5046d44da601),
    nthRoots: (0, $8ef7b9cf0165c947$export$3d5c8967f6152f8f),
    pow: (0, $91448ffe7dfcca58$export$2d9619da64c2bdd4),
    round: (0, $7e390896305417a7$export$aaef6018d3e651c3),
    sign: (0, $d3125e0b5fffdac5$export$4190acef139a44f2),
    sqrt: (0, $d4ccc1b1a91ce142$export$4c6bee88dcda7f24),
    sqrtm: (0, $0859a2907892b15d$export$f470c8ca9def7f14),
    square: (0, $85643118d92218eb$export$8aa8fe580e40693e),
    subtract: (0, $5aecf3940b46b1f2$export$435374265ca1b923),
    unaryMinus: (0, $1f006f1d9fab103a$export$4d94f3f25dc2600b),
    unaryPlus: (0, $5c768e8e50006228$export$e50639526da1c8e2),
    xgcd: (0, $98b1c59d1b5158cb$export$82911c1a1d0407b8),
    invmod: (0, $ed49e36780d59c97$export$7d988771513789e5),
    // functions - bitwise
    bitAnd: (0, $5e17598aaa570c58$export$9809e2502d5f7c7c),
    bitNot: (0, $68ab63be9d5d7659$export$3d49fbbfcb05eb36),
    bitOr: (0, $72707859d6eccd5f$export$dc934370739527a8),
    bitXor: (0, $1da6222e2b756157$export$c5717818ea6d1c80),
    leftShift: (0, $6a5f5b74b9ea00bf$export$fb75ebd54811e095),
    rightArithShift: (0, $e83ceedca2ee502b$export$180767993e37a793),
    rightLogShift: (0, $95179647fe13adaa$export$613695fe01bcb038),
    // functions - combinatorics
    bellNumbers: (0, $7a4c9dfb9ac97397$export$f6a5bb92e66e375e),
    catalan: (0, $95b05c160038618b$export$b34ea8a080f60e3b),
    composition: (0, $926a208bb4d7b2c1$export$7898728062a0cb7c),
    stirlingS2: (0, $d465957fdbe0c8b1$export$46c34bdf03072170),
    // functions - core
    config: (0, $ea13b7bddcaae422$export$ec99a334d8c9a14a),
    import: (0, $88839605a651815d$export$5989ac4b02cf8057),
    typed: (0, $dbb92124c4fa01a0$export$7adf399073101884),
    // functions - complex
    arg: (0, $837a242ae91733a6$export$eace15c6c3c286dc),
    conj: (0, $d90c46520cc9704e$export$e042ae5cfa3c3343),
    re: (0, $597311ba38df1e3b$export$f13699bc77b8ea67),
    im: (0, $62183631e98026b4$export$3476e22b3f658c7c),
    // functions - expression
    evaluate: (0, $d001196bd1825479$export$f32c54c70ddd9931),
    help: (0, $67c55f2dc5947548$export$e55ca8c24fbd3be8),
    // functions - geometry
    distance: (0, $997d95a3d8950a13$export$128b8878fdfb9e22),
    intersect: (0, $e9015dcebc20d4cd$export$cf98256b70808117),
    // functions - logical
    and: (0, $e3a2325581294c58$export$20737fc9b0a3839c),
    not: (0, $ef141ad85d452b16$export$dfd4aa05f81041ff),
    or: (0, $cbbd91070172fcd7$export$2200bcb1a08f6f8d),
    xor: (0, $ebc5d6dd279c8460$export$dd9d665b8b14e2b2),
    // functions - matrix
    concat: (0, $c34f97e5b2f31e8f$export$2651d46c991329eb),
    count: (0, $886f9692c2a9cbde$export$f5ba6930b6adafd1),
    cross: (0, $ac0f8cc1a8a50d11$export$daf3380fde4ae39d),
    column: (0, $cd4449c32e003adc$export$a5760461eff76999),
    ctranspose: (0, $4d77ade2444bce47$export$f9de74ff268bebd9),
    det: (0, $b1a0dcb279c23674$export$8730784260ee72c2),
    diag: (0, $1e891f1fae1a1c23$export$1c196182ad1e1777),
    diff: (0, $9154cfd11ef2e4c9$export$68cc1a794c4b923),
    dot: (0, $a24fdef4ad18cd9f$export$5fcedf26656436a1),
    getMatrixDataType: (0, $5898d7568016650a$export$bd8d81afc6159d78),
    identity: (0, $30f4e808a9d418cc$export$7fb92bf552f6842),
    filter: (0, $d353ba20283a0fb5$export$86d791908cc7fd0c),
    flatten: (0, $01982124ef74531f$export$501e32649028a485),
    forEach: (0, $314c2f2f06a2e70a$export$aa1ea88ef762ab5e),
    inv: (0, $ffa5cf785866dfb9$export$d584490ba37af473),
    pinv: (0, $c82034b5ef08c274$export$11c117636228617d),
    eigs: (0, $8b2a9d76ffd8ee0f$export$fb74125542bfdbb),
    kron: (0, $f2c574c0225a12d0$export$483111e0489c2571),
    matrixFromFunction: (0, $9ab9acf04b8acaec$export$979fb7b58dfbecb3),
    matrixFromRows: (0, $29adc65be8339be6$export$99216cc634505607),
    matrixFromColumns: (0, $d67b1fde1d983112$export$b34e4bfbf268d446),
    map: (0, $78ffc72fe571e144$export$212579151a971c0d),
    ones: (0, $08cbd45fe96bf170$export$910fc795c37fb1b2),
    partitionSelect: (0, $6e738232c3db2d4e$export$65c28ab37b5158f2),
    range: (0, $644ed0ee001cc92b$export$f7c7d2df7253c271),
    resize: (0, $6768f3f59e7cdc9b$export$9444f970d5d871cc),
    reshape: (0, $505cab02cc3bcde8$export$f57c799cb449edab),
    rotate: (0, $2578dddc4ce153bc$export$7e4afefc91c50a64),
    rotationMatrix: (0, $de8bf97a0f1e6293$export$95d0e442170bdedb),
    row: (0, $20feff1e11ae21e6$export$74b9786bafaa0a25),
    size: (0, $6bebcd8996f0b0fe$export$5044182a5ddc46fd),
    sort: (0, $9ab9c33147ee64b5$export$879539db0de7fe73),
    squeeze: (0, $5697390d9b0fa537$export$84665209630d2bb0),
    subset: (0, $488be1bea21cad2f$export$c809a1297fda8972),
    trace: (0, $b8f8399cf6469a77$export$46db08346422dd41),
    transpose: (0, $3c19dadbdace9ea5$export$96fcaa3e48aec95b),
    zeros: (0, $ca2401f3b00259df$export$d2794fce5915ba29),
    fft: (0, $68e180461cf238bd$export$3e6cafc8d17845c7),
    ifft: (0, $141350ddbba23b9f$export$d2931323ec07a3c0),
    // functions - probability
    combinations: (0, $6ef8131e553d2179$export$c3382240e69dd024),
    combinationsWithRep: (0, $a47e27e54032bf64$export$6bd2fb28e29d18e3),
    // distribution: distributionDocs,
    factorial: (0, $4bee48e0bf1fcb8a$export$3e6b0f8e2df12b9d),
    gamma: (0, $fcc0c6cf12df97bb$export$499ae9272b264120),
    kldivergence: (0, $804dedcef33b8ea5$export$9f240af60ea686af),
    lgamma: (0, $1b0c934e3cf4f2d7$export$b9351e80d68524a5),
    multinomial: (0, $725c57c8a0ced6aa$export$5f53cf42e3f9579d),
    permutations: (0, $c399f37242ac0ce3$export$eebb1076c4c85884),
    pickRandom: (0, $c20e0d914bc4b3c0$export$4a787d8dccbe181f),
    random: (0, $b29168ba0f90a833$export$d2b3cacd4d3219ec),
    randomInt: (0, $e463d715b96f3f13$export$8e2c9b3226630e9d),
    // functions - relational
    compare: (0, $a8e21e53a6aa8c7f$export$b01f6c58c90dea20),
    compareNatural: (0, $312b7c4345f17d89$export$3d0415783a6e23a4),
    compareText: (0, $c24800e118d7d1fd$export$f1ca5e1f3bd19e5d),
    deepEqual: (0, $35f2234ec2ca48ca$export$b25f67ed715e775e),
    equal: (0, $b1dc129c50280855$export$5d5e6107045d826c),
    equalText: (0, $68b5bb179081da5a$export$9f17f53860452971),
    larger: (0, $0e96ebd0b35278b7$export$c775ecf5ac7366c3),
    largerEq: (0, $7c868a15bc76e5a6$export$6ba4892ab98a938f),
    smaller: (0, $d86d8decd4746ba8$export$4ecf0efdd4fb906b),
    smallerEq: (0, $80d0cbf089d2086f$export$2693b3d153548453),
    unequal: (0, $5e300e38cd40a1c6$export$adade6432715c34e),
    // functions - set
    setCartesian: (0, $4ae63caf54d72476$export$6f06d74ab9e6fcad),
    setDifference: (0, $c6715de721b9076b$export$44337ef629295c55),
    setDistinct: (0, $b2877cb4d790610b$export$4c8f2f903562c625),
    setIntersect: (0, $c3d4084642789751$export$97fa484e42285777),
    setIsSubset: (0, $d970a19710317060$export$995337132a02fcf0),
    setMultiplicity: (0, $3ebc318771fb4ae7$export$33972a95e247fd58),
    setPowerset: (0, $a3ee595ed0cbc29f$export$7040fb97e0f08a08),
    setSize: (0, $5cb0834a237ae2d3$export$47ff1cdc99784c11),
    setSymDifference: (0, $b976cc6e26e052a6$export$340d6a7da02d62f3),
    setUnion: (0, $709766d55bb8f379$export$c6ab538723059178),
    // functions - special
    erf: (0, $79a1ea4a659ff9cc$export$23984555c8f4e00a),
    // functions - statistics
    cumsum: (0, $7d5e45907c57faaf$export$b230561799d1722c),
    mad: (0, $49d957a22f7c2e09$export$113a75651a4a72c6),
    max: (0, $ec5ee268c8d90847$export$f3fddd6eb2764aa6),
    mean: (0, $46b48455193a3b96$export$1f7fad79151d4cc1),
    median: (0, $fa30f0fbd0bbffce$export$dd1c97a64d85784b),
    min: (0, $ff77cd7bda8604c2$export$17718e9907e3ac84),
    mode: (0, $c9da70cb1d4adf04$export$30b601fd0273be74),
    prod: (0, $d42fe21ce270e8f1$export$524cc5e521f0e533),
    quantileSeq: (0, $6cfdbe89893b4569$export$f80c87524ae9a59f),
    std: (0, $c26b586576c19687$export$d1c23b21300d0eb8),
    sum: (0, $4d6096bf80569584$export$cd6065b38df4efb0),
    variance: (0, $6194797ab1c2c7b5$export$5a58a225f78b347f),
    // functions - trigonometry
    acos: (0, $74633421cf9ef90c$export$a96a9170bca705dc),
    acosh: (0, $64e8695993baed0b$export$eb8f1b26819009ca),
    acot: (0, $9cb8aedc06492773$export$5df2d36103c3facc),
    acoth: (0, $3f74b1fc3bdc55a8$export$b7d7f2d7d0d4ec7d),
    acsc: (0, $bbe09ed5b44b14e2$export$911b51cd6a7612a8),
    acsch: (0, $376af896a4d8f265$export$319c6d631e591850),
    asec: (0, $39569a83ccd752d6$export$fbe1d815e0591494),
    asech: (0, $31e0309d642af8ad$export$52f8b22e9936e0e),
    asin: (0, $db8c6f5deda8e8f6$export$b85b8db6e8a2ed3d),
    asinh: (0, $3243a92138a19e3b$export$afe7a3b04750ebb7),
    atan: (0, $a210922253ed5928$export$80066e40c56154f0),
    atanh: (0, $dc604408d4053fdc$export$e5bbdb9caa9a8f09),
    atan2: (0, $0561a6cd556852b2$export$e4fc5308b4910337),
    cos: (0, $cfea0b87c559480d$export$1a1af52900b6c58e),
    cosh: (0, $e1a66baabb551f60$export$5af2bed23001ffc5),
    cot: (0, $49cced690dca5d11$export$b6bae004c5b418ef),
    coth: (0, $3267dd055a3fe7b0$export$7cd2898db0b732d0),
    csc: (0, $5efaf69fccbc3d83$export$1be2e18f41ba39dc),
    csch: (0, $573206f6209de842$export$8baf7f6e609495d8),
    sec: (0, $0bf905659afcc0a1$export$3dae56ab28d48626),
    sech: (0, $77b971d35836931f$export$6da75bc9afc8303b),
    sin: (0, $ed54145358cfe85f$export$c7700d6ff32b1413),
    sinh: (0, $3ac2ed6dc831b1e8$export$e07b4c62bc488091),
    tan: (0, $be5d9f1fc419d6b3$export$14fc997d4768f36a),
    tanh: (0, $6a5d951e94d66f7e$export$52a5c54b85f75620),
    // functions - units
    to: (0, $059ee44edccbc8e4$export$c532fecb2dfa6274),
    // functions - utils
    clone: (0, $6d72d99a6c688cb7$export$500c01a79e32a1ad),
    format: (0, $eca950294c42a27f$export$278425b4fe1ff1bf),
    bin: (0, $abdf318988da290b$export$9859a5b8f644d8ff),
    oct: (0, $e9eb40d9b792b9b5$export$669461bdc241fd13),
    hex: (0, $240fd59418f900c6$export$81a08b4e66fc3038),
    isNaN: (0, $f0f1882e2c97aceb$export$f4e7c51d549c187f),
    isInteger: (0, $010bc0a52ceff6db$export$1d8b51b394bbccdc),
    isNegative: (0, $cc84482b4e9e7400$export$f94a800b9b237f17),
    isNumeric: (0, $3cdd105b43ebf198$export$7ac3927ed17fe2b6),
    hasNumericValue: (0, $f2c279657dda588c$export$9d10d68d9b7d7a67),
    isPositive: (0, $6aea868debec50b8$export$338f53b321c261b9),
    isPrime: (0, $7966a8d5fbe9ccd7$export$d6ada432c5e7d9c7),
    isZero: (0, $d987b41b731c5507$export$52c03b663dd15fa3),
    print: (0, $ca43422b7cf59797$export$e3b3b470cfab492d),
    typeOf: (0, $94229334d5aacdf9$export$5b193b71b9b497e6),
    numeric: (0, $5bb0469bf1017158$export$d275ce05039a5f7a)
};



var $1f7a43f946788c1b$var$name = "help";
var $1f7a43f946788c1b$var$dependencies = [
    "typed",
    "mathWithTransform",
    "Help"
];
var $1f7a43f946788c1b$export$cbe80567b8b3b8ac = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1f7a43f946788c1b$var$name, $1f7a43f946788c1b$var$dependencies, (_ref)=>{
    var { typed: typed, mathWithTransform: mathWithTransform, Help: Help } = _ref;
    /**
   * Retrieve help on a function or data type.
   * Help files are retrieved from the embedded documentation in math.docs.
   *
   * Syntax:
   *
   *    math.help(search)
   *
   * Examples:
   *
   *    console.log(math.help('sin').toString())
   *    console.log(math.help(math.add).toString())
   *    console.log(math.help(math.add).toJSON())
   *
   * @param {Function | string | Object} search   A function or function name
   *                                              for which to get help
   * @return {Help} A help object
   */ return typed($1f7a43f946788c1b$var$name, {
        any: function any(search) {
            var prop;
            var searchName = search;
            if (typeof search !== "string") {
                for(prop in mathWithTransform)// search in functions and constants
                if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(mathWithTransform, prop) && search === mathWithTransform[prop]) {
                    searchName = prop;
                    break;
                }
            /* TODO: implement help for data types
         if (!text) {
         // search data type
         for (prop in math.type) {
         if (hasOwnProperty(math, prop)) {
         if (search === math.type[prop]) {
         text = prop
         break
         }
         }
         }
         }
         */ }
            var doc = (0, $49d1ac263f403507$export$87a87648a1961976)((0, $8f197836390b4e8e$export$c2adf0a3344c85c9), searchName);
            if (!doc) {
                var searchText = typeof searchName === "function" ? searchName.name : searchName;
                throw new Error('No documentation found on "' + searchText + '"');
            }
            return new Help(doc);
        }
    });
});





var $4da182a870e431e6$var$name = "Help";
var $4da182a870e431e6$var$dependencies = [
    "parse"
];
var $4da182a870e431e6$export$704346eb22eef29 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($4da182a870e431e6$var$name, $4da182a870e431e6$var$dependencies, (_ref)=>{
    var { parse: parse } = _ref;
    /**
   * Documentation object
   * @param {Object} doc  Object containing properties:
   *                      {string} name
   *                      {string} category
   *                      {string} description
   *                      {string[]} syntax
   *                      {string[]} examples
   *                      {string[]} seealso
   * @constructor
   */ function Help(doc) {
        if (!(this instanceof Help)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!doc) throw new Error('Argument "doc" missing');
        this.doc = doc;
    }
    /**
   * Attach type information
   */ Help.prototype.type = "Help";
    Help.prototype.isHelp = true;
    /**
   * Generate a string representation of the Help object
   * @return {string} Returns a string
   * @private
   */ Help.prototype.toString = function() {
        var doc = this.doc || {};
        var desc = "\n";
        if (doc.name) desc += "Name: " + doc.name + "\n\n";
        if (doc.category) desc += "Category: " + doc.category + "\n\n";
        if (doc.description) desc += "Description:\n    " + doc.description + "\n\n";
        if (doc.syntax) desc += "Syntax:\n    " + doc.syntax.join("\n    ") + "\n\n";
        if (doc.examples) {
            desc += "Examples:\n";
            var scope = {};
            for(var i = 0; i < doc.examples.length; i++){
                var expr = doc.examples[i];
                desc += "    " + expr + "\n";
                var res = void 0;
                try {
                    // note: res can be undefined when `expr` is an empty string
                    res = parse(expr).compile().evaluate(scope);
                } catch (e) {
                    res = e;
                }
                if (res !== undefined && !(0, $2c4f948f17aa2240$export$e5dec9a75b602d6c)(res)) desc += "        " + (0, $addf7cb66573d3e4$export$d9468344d3651243)(res, {
                    precision: 14
                }) + "\n";
            }
            desc += "\n";
        }
        if (doc.mayThrow && doc.mayThrow.length) desc += "Throws: " + doc.mayThrow.join(", ") + "\n\n";
        if (doc.seealso && doc.seealso.length) desc += "See also: " + doc.seealso.join(", ") + "\n";
        return desc;
    };
    /**
   * Export the help object to JSON
   */ Help.prototype.toJSON = function() {
        var obj = (0, $33619877a15996ac$export$9cd59f9826255e47)(this.doc);
        obj.mathjs = "Help";
        return obj;
    };
    /**
   * Instantiate a Help object from a JSON object
   * @param {Object} json
   * @returns {Help} Returns a new Help object
   */ Help.fromJSON = function(json) {
        var doc = {};
        Object.keys(json).filter((prop)=>prop !== "mathjs").forEach((prop)=>{
            doc[prop] = json[prop];
        });
        return new Help(doc);
    };
    /**
   * Returns a string representation of the Help object
   */ Help.prototype.valueOf = Help.prototype.toString;
    return Help;
}, {
    isClass: true
});






var $8a470f3913d2f9eb$var$name = "IndexNode";
var $8a470f3913d2f9eb$var$dependencies = [
    "Node",
    "size"
];
var $8a470f3913d2f9eb$export$883b7fdc0499e9f0 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8a470f3913d2f9eb$var$name, $8a470f3913d2f9eb$var$dependencies, (_ref)=>{
    var { Node: Node, size: size } = _ref;
    /**
   * @constructor IndexNode
   * @extends Node
   *
   * Describes a subset of a matrix or an object property.
   * Cannot be used on its own, needs to be used within an AccessorNode or
   * AssignmentNode.
   *
   * @param {Node[]} dimensions
   * @param {boolean} [dotNotation=false]  Optional property describing whether
   *                                       this index was written using dot
   *                                       notation like `a.b`, or using bracket
   *                                       notation like `a["b"]` (default).
   *                                       Used to stringify an IndexNode.
   */ function IndexNode(dimensions, dotNotation) {
        if (!(this instanceof IndexNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.dimensions = dimensions;
        this.dotNotation = dotNotation || false; // validate input
        if (!Array.isArray(dimensions) || !dimensions.every((0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee))) throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
        if (this.dotNotation && !this.isObjectProperty()) throw new Error("dotNotation only applicable for object properties");
    }
    IndexNode.prototype = new Node();
    IndexNode.prototype.type = "IndexNode";
    IndexNode.prototype.isIndexNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ IndexNode.prototype._compile = function(math, argNames) {
        // TODO: implement support for bignumber (currently bignumbers are silently
        //       reduced to numbers when changing the value to zero-based)
        // TODO: Optimization: when the range values are ConstantNodes,
        //       we can beforehand resolve the zero-based value
        // optimization for a simple object property
        var evalDimensions = (0, $802b18b8c920d4c6$export$871de8747c9eaa88)(this.dimensions, function(dimension, i) {
            var needsEnd = dimension.filter((node)=>node.isSymbolNode && node.name === "end").length > 0;
            if (needsEnd) {
                // SymbolNode 'end' is used inside the index,
                // like in `A[end]` or `A[end - 2]`
                var childArgNames = Object.create(argNames);
                childArgNames.end = true;
                var _evalDimension = dimension._compile(math, childArgNames);
                return function evalDimension(scope, args, context) {
                    if (!(0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(context) && !(0, $2c4f948f17aa2240$export$43bee75e5e14138e)(context) && !(0, $2c4f948f17aa2240$export$844ec244b1367d54)(context)) throw new TypeError('Cannot resolve "end": context must be a Matrix, Array, or string but is ' + (0, $2c4f948f17aa2240$export$f5bbd400c2f4426f)(context));
                    var s = size(context).valueOf();
                    var childArgs = Object.create(args);
                    childArgs.end = s[i];
                    return _evalDimension(scope, childArgs, context);
                };
            } else // SymbolNode `end` not used
            return dimension._compile(math, argNames);
        });
        var index = (0, $49d1ac263f403507$export$87a87648a1961976)(math, "index");
        return function evalIndexNode(scope, args, context) {
            var dimensions = (0, $802b18b8c920d4c6$export$871de8747c9eaa88)(evalDimensions, function(evalDimension) {
                return evalDimension(scope, args, context);
            });
            return index(...dimensions);
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ IndexNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.dimensions.length; i++)callback(this.dimensions[i], "dimensions[" + i + "]", this);
    };
    /**
   * Create a new IndexNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {IndexNode} Returns a transformed copy of the node
   */ IndexNode.prototype.map = function(callback) {
        var dimensions = [];
        for(var i = 0; i < this.dimensions.length; i++)dimensions[i] = this._ifNode(callback(this.dimensions[i], "dimensions[" + i + "]", this));
        return new IndexNode(dimensions, this.dotNotation);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {IndexNode}
   */ IndexNode.prototype.clone = function() {
        return new IndexNode(this.dimensions.slice(0), this.dotNotation);
    };
    /**
   * Test whether this IndexNode contains a single property name
   * @return {boolean}
   */ IndexNode.prototype.isObjectProperty = function() {
        return this.dimensions.length === 1 && (0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(this.dimensions[0]) && typeof this.dimensions[0].value === "string";
    };
    /**
   * Returns the property name if IndexNode contains a property.
   * If not, returns null.
   * @return {string | null}
   */ IndexNode.prototype.getObjectProperty = function() {
        return this.isObjectProperty() ? this.dimensions[0].value : null;
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ IndexNode.prototype._toString = function(options) {
        // format the parameters like "[1, 0:5]"
        return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ IndexNode.prototype.toJSON = function() {
        return {
            mathjs: "IndexNode",
            dimensions: this.dimensions,
            dotNotation: this.dotNotation
        };
    };
    /**
   * Instantiate an IndexNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "IndexNode", dimensions: [...], dotNotation: false}`,
   *                       where mathjs is optional
   * @returns {IndexNode}
   */ IndexNode.fromJSON = function(json) {
        return new IndexNode(json.dimensions, json.dotNotation);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ IndexNode.prototype.toHTML = function(options) {
        // format the parameters like "[1, 0:5]"
        var dimensions = [];
        for(var i = 0; i < this.dimensions.length; i++)dimensions[i] = this.dimensions[i].toHTML();
        if (this.dotNotation) return '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(this.getObjectProperty()) + "</span>";
        else return '<span class="math-parenthesis math-square-parenthesis">[</span>' + dimensions.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ IndexNode.prototype._toTex = function(options) {
        var dimensions = this.dimensions.map(function(range) {
            return range.toTex(options);
        });
        return this.dotNotation ? "." + this.getObjectProperty() + "" : "_{" + dimensions.join(",") + "}";
    };
    return IndexNode;
}, {
    isClass: true,
    isNode: true
});



var $2db75e88aebd80ef$var$name = "index";
var $2db75e88aebd80ef$var$dependencies = [
    "Index"
];
var $2db75e88aebd80ef$export$f20e87a60dbfc89e = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($2db75e88aebd80ef$var$name, $2db75e88aebd80ef$var$dependencies, (_ref)=>{
    var { Index: Index } = _ref;
    /**
   * Attach a transform function to math.index
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ return function indexTransform() {
        var args = [];
        for(var i = 0, ii = arguments.length; i < ii; i++){
            var arg = arguments[i]; // change from one-based to zero based, and convert BigNumber to number
            if ((0, $2c4f948f17aa2240$export$e331ccfa6f694c99)(arg)) {
                arg.start--;
                arg.end -= arg.step > 0 ? 0 : 2;
            } else if (arg && arg.isSet === true) arg = arg.map(function(v) {
                return v - 1;
            });
            else if ((0, $2c4f948f17aa2240$export$43bee75e5e14138e)(arg) || (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(arg)) arg = arg.map(function(v) {
                return v - 1;
            });
            else if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(arg)) arg--;
            else if ((0, $2c4f948f17aa2240$export$e51d0e7e5c4a03ab)(arg)) arg = arg.toNumber() - 1;
            else if (typeof arg === "string") ;
            else throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
            args[i] = arg;
        }
        var res = new Index();
        Index.apply(res, args);
        return res;
    };
}, {
    isTransformFunction: true
});


var $2506eca8ad1f1031$var$name = "leafCount";
var $2506eca8ad1f1031$var$dependencies = [
    "parse",
    "typed"
];
var $2506eca8ad1f1031$export$38658a33c7766170 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($2506eca8ad1f1031$var$name, $2506eca8ad1f1031$var$dependencies, (_ref)=>{
    var { parse: parse, typed: typed } = _ref;
    // This does the real work, but we don't have to recurse through
    // a typed call if we separate it out
    function countLeaves(node) {
        var count = 0;
        node.forEach((n)=>{
            count += countLeaves(n);
        });
        return count || 1;
    }
    /**
   * Gives the number of "leaf nodes" in the parse tree of the given expression
   * A leaf node is one that has no subexpressions, essentially either a
   * symbol or a constant. Note that `5!` has just one leaf, the '5'; the
   * unary factorial operator does not add a leaf. On the other hand,
   * function symbols do add leaves, so `sin(x)/cos(x)` has four leaves.
   *
   * The `simplify()` function should generally not increase the `leafCount()`
   * of an expression, although currently there is no guarantee that it never
   * does so. In many cases, `simplify()` reduces the leaf count.
   *
   * Syntax:
   *
   *     leafCount(expr)
   *
   * Examples:
   *
   *     math.leafCount('x') // 1
   *     math.leafCount(math.parse('a*d-b*c')) // 4
   *     math.leafCount('[a,b;c,d][0,1]') // 6
   *
   * See also:
   *
   *     simplify
   *
   * @param {Node|string} expr    The expression to count the leaves of
   *
   * @return {number}  The number of leaves of `expr`
   *
   */ return typed($2506eca8ad1f1031$var$name, {
        string: function string(expr) {
            return this(parse(expr));
        },
        Node: function Node(expr) {
            return countLeaves(expr);
        }
    });
});






var $cbb88054bded9d40$var$name = "map";
var $cbb88054bded9d40$var$dependencies = [
    "typed"
];
var $cbb88054bded9d40$export$5ae33143d676d4d4 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($cbb88054bded9d40$var$name, $cbb88054bded9d40$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Attach a transform function to math.map
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ function mapTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $2c4f948f17aa2240$export$87815d550facaed9)(args[1]) || (0, $2c4f948f17aa2240$export$27c05cfffd263d30)(args[1])) // a function pointer, like filter([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like filter([3, -2, 5], x > 0)
            callback = (0, $51e0129aa0eee95b$export$cbb6101da03c2e83)(args[1], math, scope);
        }
        return map(x, callback);
    }
    mapTransform.rawArgs = true; // one-based version of map function
    var map = typed("map", {
        "Array, function": function ArrayFunction(x, callback) {
            return $cbb88054bded9d40$var$_map(x, callback, x);
        },
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.create($cbb88054bded9d40$var$_map(x.valueOf(), callback, x));
        }
    });
    return mapTransform;
}, {
    isTransformFunction: true
});
/**
 * Map for a multi dimensional array. One-based indexes
 * @param {Array} array
 * @param {function} callback
 * @param {Array} orig
 * @return {Array}
 * @private
 */ function $cbb88054bded9d40$var$_map(array, callback, orig) {
    // figure out what number of arguments the callback function expects
    var argsCount = (0, $43b7a970faec5d37$export$6c00fba23f8c91a7)(callback);
    function recurse(value, index) {
        if (Array.isArray(value)) return (0, $802b18b8c920d4c6$export$871de8747c9eaa88)(value, function(child, i) {
            // we create a copy of the index array and append the new index value
            return recurse(child, index.concat(i + 1)); // one based index, hence i + 1
        });
        else {
            // invoke the (typed) callback function with the right number of arguments
            if (argsCount === 1) return callback(value);
            else if (argsCount === 2) return callback(value, index);
            else // 3 or -1
            return callback(value, index, orig);
        }
    }
    return recurse(array, []);
}





var $8ad5d1f0d8e69974$var$name = "max";
var $8ad5d1f0d8e69974$var$dependencies = [
    "typed",
    "config",
    "numeric",
    "larger"
];
var $8ad5d1f0d8e69974$export$cb806a795cec8077 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($8ad5d1f0d8e69974$var$name, $8ad5d1f0d8e69974$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, larger: larger } = _ref;
    var max = (0, $cba3fdd1ff2350ea$export$b18a1b0c26c000ee)({
        typed: typed,
        config: config,
        numeric: numeric,
        larger: larger
    });
    /**
   * Attach a transform function to math.max
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function max
   * from one-based to zero based
   */ return typed("max", {
        "...any": function any(args) {
            args = (0, $cae718b9f1559ea4$export$75974926bb7e1bd6)(args);
            try {
                return max.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});





var $1db60fc21b99e458$var$name = "mean";
var $1db60fc21b99e458$var$dependencies = [
    "typed",
    "add",
    "divide"
];
var $1db60fc21b99e458$export$caaba12fb8f94b67 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1db60fc21b99e458$var$name, $1db60fc21b99e458$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide } = _ref;
    var mean = (0, $10a1e69809a3890c$export$301ef7ca1de6782c)({
        typed: typed,
        add: add,
        divide: divide
    });
    /**
   * Attach a transform function to math.mean
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function mean
   * from one-based to zero based
   */ return typed("mean", {
        "...any": function any(args) {
            args = (0, $cae718b9f1559ea4$export$75974926bb7e1bd6)(args);
            try {
                return mean.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});





var $a16f206ff91e15cb$var$name = "min";
var $a16f206ff91e15cb$var$dependencies = [
    "typed",
    "config",
    "numeric",
    "smaller"
];
var $a16f206ff91e15cb$export$e6239917a808c35d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($a16f206ff91e15cb$var$name, $a16f206ff91e15cb$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, smaller: smaller } = _ref;
    var min = (0, $6c5d3a7a97f7f6e5$export$b795f47e2b99170)({
        typed: typed,
        config: config,
        numeric: numeric,
        smaller: smaller
    });
    /**
   * Attach a transform function to math.min
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function min
   * from one-based to zero based
   */ return typed("min", {
        "...any": function any(args) {
            args = (0, $cae718b9f1559ea4$export$75974926bb7e1bd6)(args);
            try {
                return min.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});






var $7203aed697a91fec$var$name = "Node";
var $7203aed697a91fec$var$dependencies = [
    "mathWithTransform"
];
var $7203aed697a91fec$export$270e7ba5936d3c48 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($7203aed697a91fec$var$name, $7203aed697a91fec$var$dependencies, (_ref)=>{
    var { mathWithTransform: mathWithTransform } = _ref;
    /**
   * Node
   */ function Node() {
        if (!(this instanceof Node)) throw new SyntaxError("Constructor must be called with the new operator");
    }
    /**
   * Evaluate the node
   * @param {Object} [scope]  Scope to read/write variables
   * @return {*}              Returns the result
   */ Node.prototype.evaluate = function(scope) {
        return this.compile().evaluate(scope);
    };
    Node.prototype.type = "Node";
    Node.prototype.isNode = true;
    Node.prototype.comment = "";
    /**
   * Compile the node into an optimized, evauatable JavaScript function
   * @return {{evaluate: function([Object])}} object
   *                Returns an object with a function 'evaluate',
   *                which can be invoked as expr.evaluate([scope: Object]),
   *                where scope is an optional object with
   *                variables.
   */ Node.prototype.compile = function() {
        var expr = this._compile(mathWithTransform, {});
        var args = {};
        var context = null;
        function evaluate(scope) {
            var s = (0, $8f2e3669195c8ad5$export$d49c9aa30b771d59)(scope);
            _validateScope(s);
            return expr(s, args, context);
        }
        return {
            evaluate: evaluate
        };
    };
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ Node.prototype._compile = function(math, argNames) {
        throw new Error("Method _compile should be implemented by type " + this.type);
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ Node.prototype.forEach = function(callback) {
        // must be implemented by each of the Node implementations
        throw new Error("Cannot run forEach on a Node interface");
    };
    /**
   * Create a new Node having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {OperatorNode} Returns a transformed copy of the node
   */ Node.prototype.map = function(callback) {
        // must be implemented by each of the Node implementations
        throw new Error("Cannot run map on a Node interface");
    };
    /**
   * Validate whether an object is a Node, for use with map
   * @param {Node} node
   * @returns {Node} Returns the input if it's a node, else throws an Error
   * @protected
   */ Node.prototype._ifNode = function(node) {
        if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(node)) throw new TypeError("Callback function must return a Node");
        return node;
    };
    /**
   * Recursively traverse all nodes in a node tree. Executes given callback for
   * this node and each of its child nodes.
   * @param {function(node: Node, path: string, parent: Node)} callback
   *          A callback called for every node in the node tree.
   */ Node.prototype.traverse = function(callback) {
        // execute callback for itself
        // eslint-disable-next-line
        callback(this, null, null); // recursively traverse over all childs of a node
        function _traverse(node, callback) {
            node.forEach(function(child, path, parent) {
                callback(child, path, parent);
                _traverse(child, callback);
            });
        }
        _traverse(this, callback);
    };
    /**
   * Recursively transform a node tree via a transform function.
   *
   * For example, to replace all nodes of type SymbolNode having name 'x' with a
   * ConstantNode with value 2:
   *
   *     const res = Node.transform(function (node, path, parent) {
   *       if (node && node.isSymbolNode) && (node.name === 'x')) {
   *         return new ConstantNode(2)
   *       }
   *       else {
   *         return node
   *       }
   *     })
   *
   * @param {function(node: Node, path: string, parent: Node) : Node} callback
   *          A mapping function accepting a node, and returning
   *          a replacement for the node or the original node.
   *          Signature: callback(node: Node, index: string, parent: Node) : Node
   * @return {Node} Returns the original node or its replacement
   */ Node.prototype.transform = function(callback) {
        function _transform(child, path, parent) {
            var replacement = callback(child, path, parent);
            if (replacement !== child) // stop iterating when the node is replaced
            return replacement;
            return child.map(_transform);
        }
        return _transform(this, null, null);
    };
    /**
   * Find any node in the node tree matching given filter function. For example, to
   * find all nodes of type SymbolNode having name 'x':
   *
   *     const results = Node.filter(function (node) {
   *       return (node && node.isSymbolNode) && (node.name === 'x')
   *     })
   *
   * @param {function(node: Node, path: string, parent: Node) : Node} callback
   *            A test function returning true when a node matches, and false
   *            otherwise. Function signature:
   *            callback(node: Node, index: string, parent: Node) : boolean
   * @return {Node[]} nodes       An array with nodes matching given filter criteria
   */ Node.prototype.filter = function(callback) {
        var nodes = [];
        this.traverse(function(node, path, parent) {
            if (callback(node, path, parent)) nodes.push(node);
        });
        return nodes;
    };
    /**
   * Create a shallow clone of this node
   * @return {Node}
   */ Node.prototype.clone = function() {
        // must be implemented by each of the Node implementations
        throw new Error("Cannot clone a Node interface");
    };
    /**
   * Create a deep clone of this node
   * @return {Node}
   */ Node.prototype.cloneDeep = function() {
        return this.map(function(node) {
            return node.cloneDeep();
        });
    };
    /**
   * Deep compare this node with another node.
   * @param {Node} other
   * @return {boolean} Returns true when both nodes are of the same type and
   *                   contain the same values (as do their childs)
   */ Node.prototype.equals = function(other) {
        return other ? (0, $33619877a15996ac$export$6cc798251952180)(this, other) : false;
    };
    /**
   * Get string representation. (wrapper function)
   *
   * This function can get an object of the following form:
   * {
   *    handler: //This can be a callback function of the form
   *             // "function callback(node, options)"or
   *             // a map that maps function names (used in FunctionNodes)
   *             // to callbacks
   *    parenthesis: "keep" //the parenthesis option (This is optional)
   * }
   *
   * @param {Object} [options]
   * @return {string}
   */ Node.prototype.toString = function(options) {
        var customString = this._getCustomString(options);
        if (typeof customString !== "undefined") return customString;
        return this._toString(options);
    };
    /**
   * Get a JSON representation of the node
   * Both .toJSON() and the static .fromJSON(json) should be implemented by all
   * implementations of Node
   * @returns {Object}
   */ Node.prototype.toJSON = function() {
        throw new Error("Cannot serialize object: toJSON not implemented by " + this.type);
    };
    /**
   * Get HTML representation. (wrapper function)
   *
   * This function can get an object of the following form:
   * {
   *    handler: //This can be a callback function of the form
   *             // "function callback(node, options)" or
   *             // a map that maps function names (used in FunctionNodes)
   *             // to callbacks
   *    parenthesis: "keep" //the parenthesis option (This is optional)
   * }
   *
   * @param {Object} [options]
   * @return {string}
   */ Node.prototype.toHTML = function(options) {
        var customString = this._getCustomString(options);
        if (typeof customString !== "undefined") return customString;
        return this.toHTML(options);
    };
    /**
   * Internal function to generate the string output.
   * This has to be implemented by every Node
   *
   * @throws {Error}
   */ Node.prototype._toString = function() {
        // must be implemented by each of the Node implementations
        throw new Error("_toString not implemented for " + this.type);
    };
    /**
   * Get LaTeX representation. (wrapper function)
   *
   * This function can get an object of the following form:
   * {
   *    handler: //This can be a callback function of the form
   *             // "function callback(node, options)"or
   *             // a map that maps function names (used in FunctionNodes)
   *             // to callbacks
   *    parenthesis: "keep" //the parenthesis option (This is optional)
   * }
   *
   * @param {Object} [options]
   * @return {string}
   */ Node.prototype.toTex = function(options) {
        var customString = this._getCustomString(options);
        if (typeof customString !== "undefined") return customString;
        return this._toTex(options);
    };
    /**
   * Internal function to generate the LaTeX output.
   * This has to be implemented by every Node
   *
   * @param {Object} [options]
   * @throws {Error}
   */ Node.prototype._toTex = function(options) {
        // must be implemented by each of the Node implementations
        throw new Error("_toTex not implemented for " + this.type);
    };
    /**
   * Helper used by `to...` functions.
   */ Node.prototype._getCustomString = function(options) {
        if (options && typeof options === "object") switch(typeof options.handler){
            case "object":
            case "undefined":
                return;
            case "function":
                return options.handler(this, options);
            default:
                throw new TypeError("Object or function expected as callback");
        }
    };
    /**
   * Get identifier.
   * @return {string}
   */ Node.prototype.getIdentifier = function() {
        return this.type;
    };
    /**
   * Get the content of the current Node.
   * @return {Node} node
   **/ Node.prototype.getContent = function() {
        return this;
    };
    /**
   * Validate the symbol names of a scope.
   * Throws an error when the scope contains an illegal symbol.
   * @param {Object} scope
   */ function _validateScope(scope) {
        for (var symbol of [
            ...(0, $1bf21f9be84ac464$export$eebaaf2b24d91f63)
        ]){
            if (scope.has(symbol)) throw new Error('Scope contains an illegal symbol, "' + symbol + '" is a reserved keyword');
        }
    }
    return Node;
}, {
    isClass: true,
    isNode: true
});






var $0b74ddc820daba2d$var$name = "ObjectNode";
var $0b74ddc820daba2d$var$dependencies = [
    "Node"
];
var $0b74ddc820daba2d$export$385a7f4e27f173c4 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($0b74ddc820daba2d$var$name, $0b74ddc820daba2d$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    /**
   * @constructor ObjectNode
   * @extends {Node}
   * Holds an object with keys/values
   * @param {Object.<string, Node>} [properties]   object with key/value pairs
   */ function ObjectNode(properties) {
        if (!(this instanceof ObjectNode)) throw new SyntaxError("Constructor must be called with the new operator");
        this.properties = properties || {}; // validate input
        if (properties) {
            if (!(typeof properties === "object") || !Object.keys(properties).every(function(key) {
                return (0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(properties[key]);
            })) throw new TypeError("Object containing Nodes expected");
        }
    }
    ObjectNode.prototype = new Node();
    ObjectNode.prototype.type = "ObjectNode";
    ObjectNode.prototype.isObjectNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ObjectNode.prototype._compile = function(math, argNames) {
        var evalEntries = {};
        for(var key in this.properties)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(this.properties, key)) {
            // we stringify/parse the key here to resolve unicode characters,
            // so you cannot create a key like {"co\\u006Estructor": null}
            var stringifiedKey = (0, $addf7cb66573d3e4$export$fac44ee5b035f737)(key);
            var parsedKey = JSON.parse(stringifiedKey);
            if (!(0, $49d1ac263f403507$export$3039c640f3cfc12a)(this.properties, parsedKey)) throw new Error('No access to property "' + parsedKey + '"');
            evalEntries[parsedKey] = this.properties[key]._compile(math, argNames);
        }
        return function evalObjectNode(scope, args, context) {
            var obj = {};
            for(var _key in evalEntries)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(evalEntries, _key)) obj[_key] = evalEntries[_key](scope, args, context);
            return obj;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ObjectNode.prototype.forEach = function(callback) {
        for(var key in this.properties)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(this.properties, key)) callback(this.properties[key], "properties[" + (0, $addf7cb66573d3e4$export$fac44ee5b035f737)(key) + "]", this);
    };
    /**
   * Create a new ObjectNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {ObjectNode} Returns a transformed copy of the node
   */ ObjectNode.prototype.map = function(callback) {
        var properties = {};
        for(var key in this.properties)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(this.properties, key)) properties[key] = this._ifNode(callback(this.properties[key], "properties[" + (0, $addf7cb66573d3e4$export$fac44ee5b035f737)(key) + "]", this));
        return new ObjectNode(properties);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ObjectNode}
   */ ObjectNode.prototype.clone = function() {
        var properties = {};
        for(var key in this.properties)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(this.properties, key)) properties[key] = this.properties[key];
        return new ObjectNode(properties);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ObjectNode.prototype._toString = function(options) {
        var entries = [];
        for(var key in this.properties)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(this.properties, key)) entries.push((0, $addf7cb66573d3e4$export$fac44ee5b035f737)(key) + ": " + this.properties[key].toString(options));
        return "{" + entries.join(", ") + "}";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ObjectNode.prototype.toJSON = function() {
        return {
            mathjs: "ObjectNode",
            properties: this.properties
        };
    };
    /**
   * Instantiate an OperatorNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ObjectNode", "properties": {...}}`,
   *                       where mathjs is optional
   * @returns {ObjectNode}
   */ ObjectNode.fromJSON = function(json) {
        return new ObjectNode(json.properties);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ObjectNode.prototype.toHTML = function(options) {
        var entries = [];
        for(var key in this.properties)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(this.properties, key)) entries.push('<span class="math-symbol math-property">' + (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(key) + "</span>" + '<span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[key].toHTML(options));
        return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + entries.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ ObjectNode.prototype._toTex = function(options) {
        var entries = [];
        for(var key in this.properties)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(this.properties, key)) entries.push("\\mathbf{" + key + ":} & " + this.properties[key].toTex(options) + "\\\\");
        return "\\left\\{\\begin{array}{ll}".concat(entries.join("\n"), "\\end{array}\\right\\}");
    };
    return ObjectNode;
}, {
    isClass: true,
    isNode: true
});








var $69acbf3fe056b32b$var$name = "OperatorNode";
var $69acbf3fe056b32b$var$dependencies = [
    "Node"
];
var $69acbf3fe056b32b$export$aa95756bacab93d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($69acbf3fe056b32b$var$name, $69acbf3fe056b32b$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    /**
   * @constructor OperatorNode
   * @extends {Node}
   * An operator with two arguments, like 2+3
   *
   * @param {string} op           Operator name, for example '+'
   * @param {string} fn           Function name, for example 'add'
   * @param {Node[]} args         Operator arguments
   * @param {boolean} [implicit]  Is this an implicit multiplication?
   * @param {boolean} [isPercentage] Is this an percentage Operation?
   */ function OperatorNode(op, fn, args, implicit, isPercentage) {
        if (!(this instanceof OperatorNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (typeof op !== "string") throw new TypeError('string expected for parameter "op"');
        if (typeof fn !== "string") throw new TypeError('string expected for parameter "fn"');
        if (!Array.isArray(args) || !args.every((0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee))) throw new TypeError('Array containing Nodes expected for parameter "args"');
        this.implicit = implicit === true;
        this.isPercentage = isPercentage === true;
        this.op = op;
        this.fn = fn;
        this.args = args || [];
    }
    OperatorNode.prototype = new Node();
    OperatorNode.prototype.type = "OperatorNode";
    OperatorNode.prototype.isOperatorNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ OperatorNode.prototype._compile = function(math, argNames) {
        // validate fn
        if (typeof this.fn !== "string" || !(0, $49d1ac263f403507$export$2220a91638ab1d9e)(math, this.fn)) {
            if (!math[this.fn]) throw new Error("Function " + this.fn + ' missing in provided namespace "math"');
            else throw new Error('No access to function "' + this.fn + '"');
        }
        var fn = (0, $49d1ac263f403507$export$87a87648a1961976)(math, this.fn);
        var evalArgs = (0, $802b18b8c920d4c6$export$871de8747c9eaa88)(this.args, function(arg) {
            return arg._compile(math, argNames);
        });
        if (evalArgs.length === 1) {
            var evalArg0 = evalArgs[0];
            return function evalOperatorNode(scope, args, context) {
                return fn(evalArg0(scope, args, context));
            };
        } else if (evalArgs.length === 2) {
            var _evalArg = evalArgs[0];
            var evalArg1 = evalArgs[1];
            return function evalOperatorNode(scope, args, context) {
                return fn(_evalArg(scope, args, context), evalArg1(scope, args, context));
            };
        } else return function evalOperatorNode(scope, args, context) {
            return fn.apply(null, (0, $802b18b8c920d4c6$export$871de8747c9eaa88)(evalArgs, function(evalArg) {
                return evalArg(scope, args, context);
            }));
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ OperatorNode.prototype.forEach = function(callback) {
        for(var i = 0; i < this.args.length; i++)callback(this.args[i], "args[" + i + "]", this);
    };
    /**
   * Create a new OperatorNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {OperatorNode} Returns a transformed copy of the node
   */ OperatorNode.prototype.map = function(callback) {
        var args = [];
        for(var i = 0; i < this.args.length; i++)args[i] = this._ifNode(callback(this.args[i], "args[" + i + "]", this));
        return new OperatorNode(this.op, this.fn, args, this.implicit, this.isPercentage);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {OperatorNode}
   */ OperatorNode.prototype.clone = function() {
        return new OperatorNode(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
    };
    /**
   * Check whether this is an unary OperatorNode:
   * has exactly one argument, like `-a`.
   * @return {boolean} Returns true when an unary operator node, false otherwise.
   */ OperatorNode.prototype.isUnary = function() {
        return this.args.length === 1;
    };
    /**
   * Check whether this is a binary OperatorNode:
   * has exactly two arguments, like `a + b`.
   * @return {boolean} Returns true when a binary operator node, false otherwise.
   */ OperatorNode.prototype.isBinary = function() {
        return this.args.length === 2;
    };
    /**
   * Calculate which parentheses are necessary. Gets an OperatorNode
   * (which is the root of the tree) and an Array of Nodes
   * (this.args) and returns an array where 'true' means that an argument
   * has to be enclosed in parentheses whereas 'false' means the opposite.
   *
   * @param {OperatorNode} root
   * @param {string} parenthesis
   * @param {Node[]} args
   * @param {boolean} latex
   * @return {boolean[]}
   * @private
   */ function calculateNecessaryParentheses(root, parenthesis, implicit, args, latex) {
        // precedence of the root OperatorNode
        var precedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(root, parenthesis);
        var associativity = (0, $d7d1ac259ad9d921$export$8a3de49886b85474)(root, parenthesis);
        if (parenthesis === "all" || args.length > 2 && root.getIdentifier() !== "OperatorNode:add" && root.getIdentifier() !== "OperatorNode:multiply") return args.map(function(arg) {
            switch(arg.getContent().type){
                // Nodes that don't need extra parentheses
                case "ArrayNode":
                case "ConstantNode":
                case "SymbolNode":
                case "ParenthesisNode":
                    return false;
                default:
                    return true;
            }
        });
        var result;
        switch(args.length){
            case 0:
                result = [];
                break;
            case 1:
                // precedence of the operand
                var operandPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(args[0], parenthesis); // handle special cases for LaTeX, where some of the parentheses aren't needed
                if (latex && operandPrecedence !== null) {
                    var operandIdentifier;
                    var rootIdentifier;
                    if (parenthesis === "keep") {
                        operandIdentifier = args[0].getIdentifier();
                        rootIdentifier = root.getIdentifier();
                    } else {
                        // Ignore Parenthesis Nodes when not in 'keep' mode
                        operandIdentifier = args[0].getContent().getIdentifier();
                        rootIdentifier = root.getContent().getIdentifier();
                    }
                    if ((0, $d7d1ac259ad9d921$export$3cb21709c4058847)[precedence][rootIdentifier].latexLeftParens === false) {
                        result = [
                            false
                        ];
                        break;
                    }
                    if ((0, $d7d1ac259ad9d921$export$3cb21709c4058847)[operandPrecedence][operandIdentifier].latexParens === false) {
                        result = [
                            false
                        ];
                        break;
                    }
                }
                if (operandPrecedence === null) {
                    // if the operand has no defined precedence, no parens are needed
                    result = [
                        false
                    ];
                    break;
                }
                if (operandPrecedence <= precedence) {
                    // if the operands precedence is lower, parens are needed
                    result = [
                        true
                    ];
                    break;
                } // otherwise, no parens needed
                result = [
                    false
                ];
                break;
            case 2:
                var lhsParens; // left hand side needs parenthesis?
                // precedence of the left hand side
                var lhsPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(args[0], parenthesis); // is the root node associative with the left hand side
                var assocWithLhs = (0, $d7d1ac259ad9d921$export$b539869f53b6850a)(root, args[0], parenthesis);
                if (lhsPrecedence === null) // if the left hand side has no defined precedence, no parens are needed
                // FunctionNode for example
                lhsParens = false;
                else if (lhsPrecedence === precedence && associativity === "right" && !assocWithLhs) // In case of equal precedence, if the root node is left associative
                // parens are **never** necessary for the left hand side.
                // If it is right associative however, parens are necessary
                // if the root node isn't associative with the left hand side
                lhsParens = true;
                else if (lhsPrecedence < precedence) lhsParens = true;
                else lhsParens = false;
                var rhsParens; // right hand side needs parenthesis?
                // precedence of the right hand side
                var rhsPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(args[1], parenthesis); // is the root node associative with the right hand side?
                var assocWithRhs = (0, $d7d1ac259ad9d921$export$b539869f53b6850a)(root, args[1], parenthesis);
                if (rhsPrecedence === null) // if the right hand side has no defined precedence, no parens are needed
                // FunctionNode for example
                rhsParens = false;
                else if (rhsPrecedence === precedence && associativity === "left" && !assocWithRhs) // In case of equal precedence, if the root node is right associative
                // parens are **never** necessary for the right hand side.
                // If it is left associative however, parens are necessary
                // if the root node isn't associative with the right hand side
                rhsParens = true;
                else if (rhsPrecedence < precedence) rhsParens = true;
                else rhsParens = false;
                 // handle special cases for LaTeX, where some of the parentheses aren't needed
                if (latex) {
                    var _rootIdentifier;
                    var lhsIdentifier;
                    var rhsIdentifier;
                    if (parenthesis === "keep") {
                        _rootIdentifier = root.getIdentifier();
                        lhsIdentifier = root.args[0].getIdentifier();
                        rhsIdentifier = root.args[1].getIdentifier();
                    } else {
                        // Ignore ParenthesisNodes when not in 'keep' mode
                        _rootIdentifier = root.getContent().getIdentifier();
                        lhsIdentifier = root.args[0].getContent().getIdentifier();
                        rhsIdentifier = root.args[1].getContent().getIdentifier();
                    }
                    if (lhsPrecedence !== null) {
                        if ((0, $d7d1ac259ad9d921$export$3cb21709c4058847)[precedence][_rootIdentifier].latexLeftParens === false) lhsParens = false;
                        if ((0, $d7d1ac259ad9d921$export$3cb21709c4058847)[lhsPrecedence][lhsIdentifier].latexParens === false) lhsParens = false;
                    }
                    if (rhsPrecedence !== null) {
                        if ((0, $d7d1ac259ad9d921$export$3cb21709c4058847)[precedence][_rootIdentifier].latexRightParens === false) rhsParens = false;
                        if ((0, $d7d1ac259ad9d921$export$3cb21709c4058847)[rhsPrecedence][rhsIdentifier].latexParens === false) rhsParens = false;
                    }
                }
                result = [
                    lhsParens,
                    rhsParens
                ];
                break;
            default:
                if (root.getIdentifier() === "OperatorNode:add" || root.getIdentifier() === "OperatorNode:multiply") result = args.map(function(arg) {
                    var argPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(arg, parenthesis);
                    var assocWithArg = (0, $d7d1ac259ad9d921$export$b539869f53b6850a)(root, arg, parenthesis);
                    var argAssociativity = (0, $d7d1ac259ad9d921$export$8a3de49886b85474)(arg, parenthesis);
                    if (argPrecedence === null) // if the argument has no defined precedence, no parens are needed
                    return false;
                    else if (precedence === argPrecedence && associativity === argAssociativity && !assocWithArg) return true;
                    else if (argPrecedence < precedence) return true;
                    return false;
                });
                break;
        } // handles an edge case of 'auto' parentheses with implicit multiplication of ConstantNode
        // In that case print parentheses for ParenthesisNodes even though they normally wouldn't be
        // printed.
        if (args.length >= 2 && root.getIdentifier() === "OperatorNode:multiply" && root.implicit && parenthesis === "auto" && implicit === "hide") result = args.map(function(arg, index) {
            var isParenthesisNode = arg.getIdentifier() === "ParenthesisNode";
            if (result[index] || isParenthesisNode) // put in parenthesis?
            return true;
            return false;
        });
        return result;
    }
    /**
   * Get string representation.
   * @param {Object} options
   * @return {string} str
   */ OperatorNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var implicit = options && options.implicit ? options.implicit : "hide";
        var args = this.args;
        var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);
        if (args.length === 1) {
            // unary operators
            var assoc = (0, $d7d1ac259ad9d921$export$8a3de49886b85474)(this, parenthesis);
            var operand = args[0].toString(options);
            if (parens[0]) operand = "(" + operand + ")";
             // for example for "not", we want a space between operand and argument
            var opIsNamed = /[a-zA-Z]+/.test(this.op);
            if (assoc === "right") // prefix operator
            return this.op + (opIsNamed ? " " : "") + operand;
            else if (assoc === "left") // postfix
            return operand + (opIsNamed ? " " : "") + this.op;
             // fall back to postfix
            return operand + this.op;
        } else if (args.length === 2) {
            var lhs = args[0].toString(options); // left hand side
            var rhs = args[1].toString(options); // right hand side
            if (parens[0]) // left hand side in parenthesis?
            lhs = "(" + lhs + ")";
            if (parens[1]) // right hand side in parenthesis?
            rhs = "(" + rhs + ")";
            if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return lhs + " " + rhs;
            return lhs + " " + this.op + " " + rhs;
        } else if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
            var stringifiedArgs = args.map(function(arg, index) {
                arg = arg.toString(options);
                if (parens[index]) // put in parenthesis?
                arg = "(" + arg + ")";
                return arg;
            });
            if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return stringifiedArgs.join(" ");
            return stringifiedArgs.join(" " + this.op + " ");
        } else // fallback to formatting as a function call
        return this.fn + "(" + this.args.join(", ") + ")";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ OperatorNode.prototype.toJSON = function() {
        return {
            mathjs: "OperatorNode",
            op: this.op,
            fn: this.fn,
            args: this.args,
            implicit: this.implicit,
            isPercentage: this.isPercentage
        };
    };
    /**
   * Instantiate an OperatorNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "OperatorNode", "op": "+", "fn": "add", "args": [...], "implicit": false, "isPercentage":false}`,
   *                       where mathjs is optional
   * @returns {OperatorNode}
   */ OperatorNode.fromJSON = function(json) {
        return new OperatorNode(json.op, json.fn, json.args, json.implicit, json.isPercentage);
    };
    /**
   * Get HTML representation.
   * @param {Object} options
   * @return {string} str
   */ OperatorNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var implicit = options && options.implicit ? options.implicit : "hide";
        var args = this.args;
        var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);
        if (args.length === 1) {
            // unary operators
            var assoc = (0, $d7d1ac259ad9d921$export$8a3de49886b85474)(this, parenthesis);
            var operand = args[0].toHTML(options);
            if (parens[0]) operand = '<span class="math-parenthesis math-round-parenthesis">(</span>' + operand + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            if (assoc === "right") // prefix operator
            return '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(this.op) + "</span>" + operand;
            else // postfix when assoc === 'left' or undefined
            return operand + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(this.op) + "</span>";
        } else if (args.length === 2) {
            // binary operatoes
            var lhs = args[0].toHTML(options); // left hand side
            var rhs = args[1].toHTML(options); // right hand side
            if (parens[0]) // left hand side in parenthesis?
            lhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + lhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            if (parens[1]) // right hand side in parenthesis?
            rhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + rhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return lhs + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + rhs;
            return lhs + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(this.op) + "</span>" + rhs;
        } else {
            var stringifiedArgs = args.map(function(arg, index) {
                arg = arg.toHTML(options);
                if (parens[index]) // put in parenthesis?
                arg = '<span class="math-parenthesis math-round-parenthesis">(</span>' + arg + '<span class="math-parenthesis math-round-parenthesis">)</span>';
                return arg;
            });
            if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
                if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return stringifiedArgs.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>');
                return stringifiedArgs.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(this.op) + "</span>");
            } else // fallback to formatting as a function call
            return '<span class="math-function">' + (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + stringifiedArgs.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
        }
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ OperatorNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var implicit = options && options.implicit ? options.implicit : "hide";
        var args = this.args;
        var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, true);
        var op = (0, $22194b07116816cc$export$c728a46e4168cd75)[this.fn];
        op = typeof op === "undefined" ? this.op : op; // fall back to using this.op
        if (args.length === 1) {
            // unary operators
            var assoc = (0, $d7d1ac259ad9d921$export$8a3de49886b85474)(this, parenthesis);
            var operand = args[0].toTex(options);
            if (parens[0]) operand = "\\left(".concat(operand, "\\right)");
            if (assoc === "right") // prefix operator
            return op + operand;
            else if (assoc === "left") // postfix operator
            return operand + op;
             // fall back to postfix
            return operand + op;
        } else if (args.length === 2) {
            // binary operators
            var lhs = args[0]; // left hand side
            var lhsTex = lhs.toTex(options);
            if (parens[0]) lhsTex = "\\left(".concat(lhsTex, "\\right)");
            var rhs = args[1]; // right hand side
            var rhsTex = rhs.toTex(options);
            if (parens[1]) rhsTex = "\\left(".concat(rhsTex, "\\right)");
             // handle some exceptions (due to the way LaTeX works)
            var lhsIdentifier;
            if (parenthesis === "keep") lhsIdentifier = lhs.getIdentifier();
            else // Ignore ParenthesisNodes if in 'keep' mode
            lhsIdentifier = lhs.getContent().getIdentifier();
            switch(this.getIdentifier()){
                case "OperatorNode:divide":
                    // op contains '\\frac' at this point
                    return op + "{" + lhsTex + "}" + "{" + rhsTex + "}";
                case "OperatorNode:pow":
                    lhsTex = "{" + lhsTex + "}";
                    rhsTex = "{" + rhsTex + "}";
                    switch(lhsIdentifier){
                        case "ConditionalNode":
                        case "OperatorNode:divide":
                            lhsTex = "\\left(".concat(lhsTex, "\\right)");
                    }
                    break;
                case "OperatorNode:multiply":
                    if (this.implicit && implicit === "hide") return lhsTex + "~" + rhsTex;
            }
            return lhsTex + op + rhsTex;
        } else if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
            var texifiedArgs = args.map(function(arg, index) {
                arg = arg.toTex(options);
                if (parens[index]) arg = "\\left(".concat(arg, "\\right)");
                return arg;
            });
            if (this.getIdentifier() === "OperatorNode:multiply" && this.implicit) return texifiedArgs.join("~");
            return texifiedArgs.join(op);
        } else // fall back to formatting as a function call
        // as this is a fallback, it doesn't use
        // fancy function names
        return "\\mathrm{" + this.fn + "}\\left(" + args.map(function(arg) {
            return arg.toTex(options);
        }).join(",") + "\\right)";
    };
    /**
   * Get identifier.
   * @return {string}
   */ OperatorNode.prototype.getIdentifier = function() {
        return this.type + ":" + this.fn;
    };
    return OperatorNode;
}, {
    isClass: true,
    isNode: true
});



var $c79c9cb7e0cc15cd$var$name = "ParenthesisNode";
var $c79c9cb7e0cc15cd$var$dependencies = [
    "Node"
];
var $c79c9cb7e0cc15cd$export$9bf5d3d4ef922b0c = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($c79c9cb7e0cc15cd$var$name, $c79c9cb7e0cc15cd$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    /**
   * @constructor ParenthesisNode
   * @extends {Node}
   * A parenthesis node describes manual parenthesis from the user input
   * @param {Node} content
   * @extends {Node}
   */ function ParenthesisNode(content) {
        if (!(this instanceof ParenthesisNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(content)) throw new TypeError('Node expected for parameter "content"');
        this.content = content;
    }
    ParenthesisNode.prototype = new Node();
    ParenthesisNode.prototype.type = "ParenthesisNode";
    ParenthesisNode.prototype.isParenthesisNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ ParenthesisNode.prototype._compile = function(math, argNames) {
        return this.content._compile(math, argNames);
    };
    /**
   * Get the content of the current Node.
   * @return {Node} content
   * @override
   **/ ParenthesisNode.prototype.getContent = function() {
        return this.content.getContent();
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ ParenthesisNode.prototype.forEach = function(callback) {
        callback(this.content, "content", this);
    };
    /**
   * Create a new ParenthesisNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node) : Node} callback
   * @returns {ParenthesisNode} Returns a clone of the node
   */ ParenthesisNode.prototype.map = function(callback) {
        var content = callback(this.content, "content", this);
        return new ParenthesisNode(content);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {ParenthesisNode}
   */ ParenthesisNode.prototype.clone = function() {
        return new ParenthesisNode(this.content);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ParenthesisNode.prototype._toString = function(options) {
        if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return "(" + this.content.toString(options) + ")";
        return this.content.toString(options);
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ ParenthesisNode.prototype.toJSON = function() {
        return {
            mathjs: "ParenthesisNode",
            content: this.content
        };
    };
    /**
   * Instantiate an ParenthesisNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ParenthesisNode", "content": ...}`,
   *                       where mathjs is optional
   * @returns {ParenthesisNode}
   */ ParenthesisNode.fromJSON = function(json) {
        return new ParenthesisNode(json.content);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ParenthesisNode.prototype.toHTML = function(options) {
        if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        return this.content.toHTML(options);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ ParenthesisNode.prototype._toTex = function(options) {
        if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return "\\left(".concat(this.content.toTex(options), "\\right)");
        return this.content.toTex(options);
    };
    return ParenthesisNode;
}, {
    isClass: true,
    isNode: true
});






var $47bf1b9390b2e8b5$var$name = "parse";
var $47bf1b9390b2e8b5$var$dependencies = [
    "typed",
    "numeric",
    "config",
    "AccessorNode",
    "ArrayNode",
    "AssignmentNode",
    "BlockNode",
    "ConditionalNode",
    "ConstantNode",
    "FunctionAssignmentNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "ParenthesisNode",
    "RangeNode",
    "RelationalNode",
    "SymbolNode"
];
var $47bf1b9390b2e8b5$export$fef7a8850e50b7 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($47bf1b9390b2e8b5$var$name, $47bf1b9390b2e8b5$var$dependencies, (_ref)=>{
    var { typed: typed, numeric: numeric, config: config, AccessorNode: AccessorNode, ArrayNode: ArrayNode, AssignmentNode: AssignmentNode, BlockNode: BlockNode, ConditionalNode: ConditionalNode, ConstantNode: ConstantNode, FunctionAssignmentNode: FunctionAssignmentNode, FunctionNode: FunctionNode, IndexNode: IndexNode, ObjectNode: ObjectNode, OperatorNode: OperatorNode, ParenthesisNode: ParenthesisNode, RangeNode: RangeNode, RelationalNode: RelationalNode, SymbolNode: SymbolNode } = _ref;
    /**
   * Parse an expression. Returns a node tree, which can be evaluated by
   * invoking node.evaluate().
   *
   * Note the evaluating arbitrary expressions may involve security risks,
   * see [https://mathjs.org/docs/expressions/security.html](https://mathjs.org/docs/expressions/security.html) for more information.
   *
   * Syntax:
   *
   *     math.parse(expr)
   *     math.parse(expr, options)
   *     math.parse([expr1, expr2, expr3, ...])
   *     math.parse([expr1, expr2, expr3, ...], options)
   *
   * Example:
   *
   *     const node1 = math.parse('sqrt(3^2 + 4^2)')
   *     node1.compile().evaluate() // 5
   *
   *     let scope = {a:3, b:4}
   *     const node2 = math.parse('a * b') // 12
   *     const code2 = node2.compile()
   *     code2.evaluate(scope) // 12
   *     scope.a = 5
   *     code2.evaluate(scope) // 20
   *
   *     const nodes = math.parse(['a = 3', 'b = 4', 'a * b'])
   *     nodes[2].compile().evaluate() // 12
   *
   * See also:
   *
   *     evaluate, compile
   *
   * @param {string | string[] | Matrix} expr          Expression to be parsed
   * @param {{nodes: Object<string, Node>}} [options]  Available options:
   *                                                   - `nodes` a set of custom nodes
   * @return {Node | Node[]} node
   * @throws {Error}
   */ var parse = typed($47bf1b9390b2e8b5$var$name, {
        string: function string(expression) {
            return parseStart(expression, {});
        },
        "Array | Matrix": function ArrayMatrix(expressions) {
            return parseMultiple(expressions, {});
        },
        "string, Object": function stringObject(expression, options) {
            var extraNodes = options.nodes !== undefined ? options.nodes : {};
            return parseStart(expression, extraNodes);
        },
        "Array | Matrix, Object": parseMultiple
    });
    function parseMultiple(expressions) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var extraNodes = options.nodes !== undefined ? options.nodes : {}; // parse an array or matrix with expressions
        return (0, $cd13353fc76500f7$export$ce7eaaed37329a1b)(expressions, function(elem) {
            if (typeof elem !== "string") throw new TypeError("String expected");
            return parseStart(elem, extraNodes);
        });
    } // token types enumeration
    var TOKENTYPE = {
        NULL: 0,
        DELIMITER: 1,
        NUMBER: 2,
        SYMBOL: 3,
        UNKNOWN: 4
    }; // map with all delimiters
    var DELIMITERS = {
        ",": true,
        "(": true,
        ")": true,
        "[": true,
        "]": true,
        "{": true,
        "}": true,
        '"': true,
        "'": true,
        ";": true,
        "+": true,
        "-": true,
        "*": true,
        ".*": true,
        "/": true,
        "./": true,
        "%": true,
        "^": true,
        ".^": true,
        "~": true,
        "!": true,
        "&": true,
        "|": true,
        "^|": true,
        "=": true,
        ":": true,
        "?": true,
        "==": true,
        "!=": true,
        "<": true,
        ">": true,
        "<=": true,
        ">=": true,
        "<<": true,
        ">>": true,
        ">>>": true
    }; // map with all named delimiters
    var NAMED_DELIMITERS = {
        mod: true,
        to: true,
        in: true,
        and: true,
        xor: true,
        or: true,
        not: true
    };
    var CONSTANTS = {
        true: true,
        false: false,
        null: null,
        undefined: undefined
    };
    var NUMERIC_CONSTANTS = [
        "NaN",
        "Infinity"
    ];
    function initialState() {
        return {
            extraNodes: {},
            // current extra nodes, must be careful not to mutate
            expression: "",
            // current expression
            comment: "",
            // last parsed comment
            index: 0,
            // current index in expr
            token: "",
            // current token
            tokenType: TOKENTYPE.NULL,
            // type of the token
            nestingLevel: 0,
            // level of nesting inside parameters, used to ignore newline characters
            conditionalLevel: null // when a conditional is being parsed, the level of the conditional is stored here
        };
    }
    /**
   * View upto `length` characters of the expression starting at the current character.
   *
   * @param {Object} state
   * @param {number} [length=1] Number of characters to view
   * @returns {string}
   * @private
   */ function currentString(state, length) {
        return state.expression.substr(state.index, length);
    }
    /**
   * View the current character. Returns '' if end of expression is reached.
   *
   * @param {Object} state
   * @returns {string}
   * @private
   */ function currentCharacter(state) {
        return currentString(state, 1);
    }
    /**
   * Get the next character from the expression.
   * The character is stored into the char c. If the end of the expression is
   * reached, the function puts an empty string in c.
   * @private
   */ function next(state) {
        state.index++;
    }
    /**
   * Preview the previous character from the expression.
   * @return {string} cNext
   * @private
   */ function prevCharacter(state) {
        return state.expression.charAt(state.index - 1);
    }
    /**
   * Preview the next character from the expression.
   * @return {string} cNext
   * @private
   */ function nextCharacter(state) {
        return state.expression.charAt(state.index + 1);
    }
    /**
   * Get next token in the current string expr.
   * The token and token type are available as token and tokenType
   * @private
   */ function getToken(state) {
        state.tokenType = TOKENTYPE.NULL;
        state.token = "";
        state.comment = ""; // skip over ignored characters:
        while(true){
            // comments:
            if (currentCharacter(state) === "#") while(currentCharacter(state) !== "\n" && currentCharacter(state) !== ""){
                state.comment += currentCharacter(state);
                next(state);
            }
             // whitespace: space, tab, and newline when inside parameters
            if (parse.isWhitespace(currentCharacter(state), state.nestingLevel)) next(state);
            else break;
        } // check for end of expression
        if (currentCharacter(state) === "") {
            // token is still empty
            state.tokenType = TOKENTYPE.DELIMITER;
            return;
        } // check for new line character
        if (currentCharacter(state) === "\n" && !state.nestingLevel) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = currentCharacter(state);
            next(state);
            return;
        }
        var c1 = currentCharacter(state);
        var c2 = currentString(state, 2);
        var c3 = currentString(state, 3);
        if (c3.length === 3 && DELIMITERS[c3]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c3;
            next(state);
            next(state);
            next(state);
            return;
        } // check for delimiters consisting of 2 characters
        if (c2.length === 2 && DELIMITERS[c2]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c2;
            next(state);
            next(state);
            return;
        } // check for delimiters consisting of 1 character
        if (DELIMITERS[c1]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c1;
            next(state);
            return;
        } // check for a number
        if (parse.isDigitDot(c1)) {
            state.tokenType = TOKENTYPE.NUMBER; // check for binary, octal, or hex
            var _c = currentString(state, 2);
            if (_c === "0b" || _c === "0o" || _c === "0x") {
                state.token += currentCharacter(state);
                next(state);
                state.token += currentCharacter(state);
                next(state);
                while(parse.isHexDigit(currentCharacter(state))){
                    state.token += currentCharacter(state);
                    next(state);
                }
                if (currentCharacter(state) === ".") {
                    // this number has a radix point
                    state.token += ".";
                    next(state); // get the digits after the radix
                    while(parse.isHexDigit(currentCharacter(state))){
                        state.token += currentCharacter(state);
                        next(state);
                    }
                } else if (currentCharacter(state) === "i") {
                    // this number has a word size suffix
                    state.token += "i";
                    next(state); // get the word size
                    while(parse.isDigit(currentCharacter(state))){
                        state.token += currentCharacter(state);
                        next(state);
                    }
                }
                return;
            } // get number, can have a single dot
            if (currentCharacter(state) === ".") {
                state.token += currentCharacter(state);
                next(state);
                if (!parse.isDigit(currentCharacter(state))) {
                    // this is no number, it is just a dot (can be dot notation)
                    state.tokenType = TOKENTYPE.DELIMITER;
                    return;
                }
            } else {
                while(parse.isDigit(currentCharacter(state))){
                    state.token += currentCharacter(state);
                    next(state);
                }
                if (parse.isDecimalMark(currentCharacter(state), nextCharacter(state))) {
                    state.token += currentCharacter(state);
                    next(state);
                }
            }
            while(parse.isDigit(currentCharacter(state))){
                state.token += currentCharacter(state);
                next(state);
            } // check for exponential notation like "2.3e-4", "1.23e50" or "2e+4"
            if (currentCharacter(state) === "E" || currentCharacter(state) === "e") {
                if (parse.isDigit(nextCharacter(state)) || nextCharacter(state) === "-" || nextCharacter(state) === "+") {
                    state.token += currentCharacter(state);
                    next(state);
                    if (currentCharacter(state) === "+" || currentCharacter(state) === "-") {
                        state.token += currentCharacter(state);
                        next(state);
                    } // Scientific notation MUST be followed by an exponent
                    if (!parse.isDigit(currentCharacter(state))) throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                    while(parse.isDigit(currentCharacter(state))){
                        state.token += currentCharacter(state);
                        next(state);
                    }
                    if (parse.isDecimalMark(currentCharacter(state), nextCharacter(state))) throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                } else if (nextCharacter(state) === ".") {
                    next(state);
                    throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                }
            }
            return;
        } // check for variables, functions, named operators
        if (parse.isAlpha(currentCharacter(state), prevCharacter(state), nextCharacter(state))) {
            while(parse.isAlpha(currentCharacter(state), prevCharacter(state), nextCharacter(state)) || parse.isDigit(currentCharacter(state))){
                state.token += currentCharacter(state);
                next(state);
            }
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(NAMED_DELIMITERS, state.token)) state.tokenType = TOKENTYPE.DELIMITER;
            else state.tokenType = TOKENTYPE.SYMBOL;
            return;
        } // something unknown is found, wrong characters -> a syntax error
        state.tokenType = TOKENTYPE.UNKNOWN;
        while(currentCharacter(state) !== ""){
            state.token += currentCharacter(state);
            next(state);
        }
        throw createSyntaxError(state, 'Syntax error in part "' + state.token + '"');
    }
    /**
   * Get next token and skip newline tokens
   */ function getTokenSkipNewline(state) {
        do getToken(state);
        while (state.token === "\n"); // eslint-disable-line no-unmodified-loop-condition
    }
    /**
   * Open parameters.
   * New line characters will be ignored until closeParams(state) is called
   */ function openParams(state) {
        state.nestingLevel++;
    }
    /**
   * Close parameters.
   * New line characters will no longer be ignored
   */ function closeParams(state) {
        state.nestingLevel--;
    }
    /**
   * Checks whether the current character `c` is a valid alpha character:
   *
   * - A latin letter (upper or lower case) Ascii: a-z, A-Z
   * - An underscore                        Ascii: _
   * - A dollar sign                        Ascii: $
   * - A latin letter with accents          Unicode: \u00C0 - \u02AF
   * - A greek letter                       Unicode: \u0370 - \u03FF
   * - A mathematical alphanumeric symbol   Unicode: \u{1D400} - \u{1D7FF} excluding invalid code points
   *
   * The previous and next characters are needed to determine whether
   * this character is part of a unicode surrogate pair.
   *
   * @param {string} c      Current character in the expression
   * @param {string} cPrev  Previous character
   * @param {string} cNext  Next character
   * @return {boolean}
   */ parse.isAlpha = function isAlpha(c, cPrev, cNext) {
        return parse.isValidLatinOrGreek(c) || parse.isValidMathSymbol(c, cNext) || parse.isValidMathSymbol(cPrev, c);
    };
    /**
   * Test whether a character is a valid latin, greek, or letter-like character
   * @param {string} c
   * @return {boolean}
   */ parse.isValidLatinOrGreek = function isValidLatinOrGreek(c) {
        return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(c);
    };
    /**
   * Test whether two given 16 bit characters form a surrogate pair of a
   * unicode math symbol.
   *
   * https://unicode-table.com/en/
   * https://www.wikiwand.com/en/Mathematical_operators_and_symbols_in_Unicode
   *
   * Note: In ES6 will be unicode aware:
   * https://stackoverflow.com/questions/280712/javascript-unicode-regexes
   * https://mathiasbynens.be/notes/es6-unicode-regex
   *
   * @param {string} high
   * @param {string} low
   * @return {boolean}
   */ parse.isValidMathSymbol = function isValidMathSymbol(high, low) {
        return /^[\uD835]$/.test(high) && /^[\uDC00-\uDFFF]$/.test(low) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(low);
    };
    /**
   * Check whether given character c is a white space character: space, tab, or enter
   * @param {string} c
   * @param {number} nestingLevel
   * @return {boolean}
   */ parse.isWhitespace = function isWhitespace(c, nestingLevel) {
        // TODO: also take '\r' carriage return as newline? Or does that give problems on mac?
        return c === " " || c === "	" || c === "\n" && nestingLevel > 0;
    };
    /**
   * Test whether the character c is a decimal mark (dot).
   * This is the case when it's not the start of a delimiter '.*', './', or '.^'
   * @param {string} c
   * @param {string} cNext
   * @return {boolean}
   */ parse.isDecimalMark = function isDecimalMark(c, cNext) {
        return c === "." && cNext !== "/" && cNext !== "*" && cNext !== "^";
    };
    /**
   * checks if the given char c is a digit or dot
   * @param {string} c   a string with one character
   * @return {boolean}
   */ parse.isDigitDot = function isDigitDot(c) {
        return c >= "0" && c <= "9" || c === ".";
    };
    /**
   * checks if the given char c is a digit
   * @param {string} c   a string with one character
   * @return {boolean}
   */ parse.isDigit = function isDigit(c) {
        return c >= "0" && c <= "9";
    };
    /**
   * checks if the given char c is a hex digit
   * @param {string} c   a string with one character
   * @return {boolean}
   */ parse.isHexDigit = function isHexDigit(c) {
        return c >= "0" && c <= "9" || c >= "a" && c <= "f" || c >= "A" && c <= "F";
    };
    /**
   * Start of the parse levels below, in order of precedence
   * @return {Node} node
   * @private
   */ function parseStart(expression, extraNodes) {
        var state = initialState();
        (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))(state, {
            expression: expression,
            extraNodes: extraNodes
        });
        getToken(state);
        var node = parseBlock(state); // check for garbage at the end of the expression
        // an expression ends with a empty character '' and tokenType DELIMITER
        if (state.token !== "") {
            if (state.tokenType === TOKENTYPE.DELIMITER) // user entered a not existing operator like "//"
            // TODO: give hints for aliases, for example with "<>" give as hint " did you mean !== ?"
            throw createError(state, "Unexpected operator " + state.token);
            else throw createSyntaxError(state, 'Unexpected part "' + state.token + '"');
        }
        return node;
    }
    /**
   * Parse a block with expressions. Expressions can be separated by a newline
   * character '\n', or by a semicolon ';'. In case of a semicolon, no output
   * of the preceding line is returned.
   * @return {Node} node
   * @private
   */ function parseBlock(state) {
        var node;
        var blocks = [];
        var visible;
        if (state.token !== "" && state.token !== "\n" && state.token !== ";") {
            node = parseAssignment(state);
            node.comment = state.comment;
        } // TODO: simplify this loop
        while(state.token === "\n" || state.token === ";"){
            // eslint-disable-line no-unmodified-loop-condition
            if (blocks.length === 0 && node) {
                visible = state.token !== ";";
                blocks.push({
                    node: node,
                    visible: visible
                });
            }
            getToken(state);
            if (state.token !== "\n" && state.token !== ";" && state.token !== "") {
                node = parseAssignment(state);
                node.comment = state.comment;
                visible = state.token !== ";";
                blocks.push({
                    node: node,
                    visible: visible
                });
            }
        }
        if (blocks.length > 0) return new BlockNode(blocks);
        else {
            if (!node) {
                node = new ConstantNode(undefined);
                node.comment = state.comment;
            }
            return node;
        }
    }
    /**
   * Assignment of a function or variable,
   * - can be a variable like 'a=2.3'
   * - or a updating an existing variable like 'matrix(2,3:5)=[6,7,8]'
   * - defining a function like 'f(x) = x^2'
   * @return {Node} node
   * @private
   */ function parseAssignment(state) {
        var name, args, value, valid;
        var node = parseConditional(state);
        if (state.token === "=") {
            if ((0, $2c4f948f17aa2240$export$87815d550facaed9)(node)) {
                // parse a variable assignment like 'a = 2/3'
                name = node.name;
                getTokenSkipNewline(state);
                value = parseAssignment(state);
                return new AssignmentNode(new SymbolNode(name), value);
            } else if ((0, $2c4f948f17aa2240$export$f88fb19d6b9ee5cb)(node)) {
                // parse a matrix subset assignment like 'A[1,2] = 4'
                getTokenSkipNewline(state);
                value = parseAssignment(state);
                return new AssignmentNode(node.object, node.index, value);
            } else if ((0, $2c4f948f17aa2240$export$6ae03b16e064e6c4)(node) && (0, $2c4f948f17aa2240$export$87815d550facaed9)(node.fn)) {
                // parse function assignment like 'f(x) = x^2'
                valid = true;
                args = [];
                name = node.name;
                node.args.forEach(function(arg, index) {
                    if ((0, $2c4f948f17aa2240$export$87815d550facaed9)(arg)) args[index] = arg.name;
                    else valid = false;
                });
                if (valid) {
                    getTokenSkipNewline(state);
                    value = parseAssignment(state);
                    return new FunctionAssignmentNode(name, args, value);
                }
            }
            throw createSyntaxError(state, "Invalid left hand side of assignment operator =");
        }
        return node;
    }
    /**
   * conditional operation
   *
   *     condition ? truePart : falsePart
   *
   * Note: conditional operator is right-associative
   *
   * @return {Node} node
   * @private
   */ function parseConditional(state) {
        var node = parseLogicalOr(state);
        while(state.token === "?"){
            // eslint-disable-line no-unmodified-loop-condition
            // set a conditional level, the range operator will be ignored as long
            // as conditionalLevel === state.nestingLevel.
            var prev = state.conditionalLevel;
            state.conditionalLevel = state.nestingLevel;
            getTokenSkipNewline(state);
            var condition = node;
            var trueExpr = parseAssignment(state);
            if (state.token !== ":") throw createSyntaxError(state, "False part of conditional expression expected");
            state.conditionalLevel = null;
            getTokenSkipNewline(state);
            var falseExpr = parseAssignment(state); // Note: check for conditional operator again, right associativity
            node = new ConditionalNode(condition, trueExpr, falseExpr); // restore the previous conditional level
            state.conditionalLevel = prev;
        }
        return node;
    }
    /**
   * logical or, 'x or y'
   * @return {Node} node
   * @private
   */ function parseLogicalOr(state) {
        var node = parseLogicalXor(state);
        while(state.token === "or"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("or", "or", [
                node,
                parseLogicalXor(state)
            ]);
        }
        return node;
    }
    /**
   * logical exclusive or, 'x xor y'
   * @return {Node} node
   * @private
   */ function parseLogicalXor(state) {
        var node = parseLogicalAnd(state);
        while(state.token === "xor"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("xor", "xor", [
                node,
                parseLogicalAnd(state)
            ]);
        }
        return node;
    }
    /**
   * logical and, 'x and y'
   * @return {Node} node
   * @private
   */ function parseLogicalAnd(state) {
        var node = parseBitwiseOr(state);
        while(state.token === "and"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("and", "and", [
                node,
                parseBitwiseOr(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise or, 'x | y'
   * @return {Node} node
   * @private
   */ function parseBitwiseOr(state) {
        var node = parseBitwiseXor(state);
        while(state.token === "|"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("|", "bitOr", [
                node,
                parseBitwiseXor(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise exclusive or (xor), 'x ^| y'
   * @return {Node} node
   * @private
   */ function parseBitwiseXor(state) {
        var node = parseBitwiseAnd(state);
        while(state.token === "^|"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("^|", "bitXor", [
                node,
                parseBitwiseAnd(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise and, 'x & y'
   * @return {Node} node
   * @private
   */ function parseBitwiseAnd(state) {
        var node = parseRelational(state);
        while(state.token === "&"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("&", "bitAnd", [
                node,
                parseRelational(state)
            ]);
        }
        return node;
    }
    /**
   * Parse a chained conditional, like 'a > b >= c'
   * @return {Node} node
   */ function parseRelational(state) {
        var params = [
            parseShift(state)
        ];
        var conditionals = [];
        var operators = {
            "==": "equal",
            "!=": "unequal",
            "<": "smaller",
            ">": "larger",
            "<=": "smallerEq",
            ">=": "largerEq"
        };
        while((0, $33619877a15996ac$export$5a15a386532a5ea4)(operators, state.token)){
            // eslint-disable-line no-unmodified-loop-condition
            var cond = {
                name: state.token,
                fn: operators[state.token]
            };
            conditionals.push(cond);
            getTokenSkipNewline(state);
            params.push(parseShift(state));
        }
        if (params.length === 1) return params[0];
        else if (params.length === 2) return new OperatorNode(conditionals[0].name, conditionals[0].fn, params);
        else return new RelationalNode(conditionals.map((c)=>c.fn), params);
    }
    /**
   * Bitwise left shift, bitwise right arithmetic shift, bitwise right logical shift
   * @return {Node} node
   * @private
   */ function parseShift(state) {
        var node, name, fn, params;
        node = parseConversion(state);
        var operators = {
            "<<": "leftShift",
            ">>": "rightArithShift",
            ">>>": "rightLogShift"
        };
        while((0, $33619877a15996ac$export$5a15a386532a5ea4)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            params = [
                node,
                parseConversion(state)
            ];
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * conversion operators 'to' and 'in'
   * @return {Node} node
   * @private
   */ function parseConversion(state) {
        var node, name, fn, params;
        node = parseRange(state);
        var operators = {
            to: "to",
            in: "to" // alias of 'to'
        };
        while((0, $33619877a15996ac$export$5a15a386532a5ea4)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            if (name === "in" && state.token === "") // end of expression -> this is the unit 'in' ('inch')
            node = new OperatorNode("*", "multiply", [
                node,
                new SymbolNode("in")
            ], true);
            else {
                // operator 'a to b' or 'a in b'
                params = [
                    node,
                    parseRange(state)
                ];
                node = new OperatorNode(name, fn, params);
            }
        }
        return node;
    }
    /**
   * parse range, "start:end", "start:step:end", ":", "start:", ":end", etc
   * @return {Node} node
   * @private
   */ function parseRange(state) {
        var node;
        var params = [];
        if (state.token === ":") // implicit start=1 (one-based)
        node = new ConstantNode(1);
        else // explicit start
        node = parseAddSubtract(state);
        if (state.token === ":" && state.conditionalLevel !== state.nestingLevel) {
            // we ignore the range operator when a conditional operator is being processed on the same level
            params.push(node); // parse step and end
            while(state.token === ":" && params.length < 3){
                // eslint-disable-line no-unmodified-loop-condition
                getTokenSkipNewline(state);
                if (state.token === ")" || state.token === "]" || state.token === "," || state.token === "") // implicit end
                params.push(new SymbolNode("end"));
                else // explicit end
                params.push(parseAddSubtract(state));
            }
            if (params.length === 3) // params = [start, step, end]
            node = new RangeNode(params[0], params[2], params[1]); // start, end, step
            else // length === 2
            // params = [start, end]
            node = new RangeNode(params[0], params[1]); // start, end
        }
        return node;
    }
    /**
   * add or subtract
   * @return {Node} node
   * @private
   */ function parseAddSubtract(state) {
        var node, name, fn, params;
        node = parseMultiplyDivide(state);
        var operators = {
            "+": "add",
            "-": "subtract"
        };
        while((0, $33619877a15996ac$export$5a15a386532a5ea4)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            var rightNode = parseMultiplyDivide(state);
            if (rightNode.isPercentage) params = [
                node,
                new OperatorNode("*", "multiply", [
                    node,
                    rightNode
                ])
            ];
            else params = [
                node,
                rightNode
            ];
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * multiply, divide, modulus
   * @return {Node} node
   * @private
   */ function parseMultiplyDivide(state) {
        var node, last, name, fn;
        node = parseImplicitMultiplication(state);
        last = node;
        var operators = {
            "*": "multiply",
            ".*": "dotMultiply",
            "/": "divide",
            "./": "dotDivide"
        };
        while(true){
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(operators, state.token)) {
                // explicit operators
                name = state.token;
                fn = operators[name];
                getTokenSkipNewline(state);
                last = parseImplicitMultiplication(state);
                node = new OperatorNode(name, fn, [
                    node,
                    last
                ]);
            } else break;
        }
        return node;
    }
    /**
   * implicit multiplication
   * @return {Node} node
   * @private
   */ function parseImplicitMultiplication(state) {
        var node, last;
        node = parseRule2(state);
        last = node;
        while(true){
            if (state.tokenType === TOKENTYPE.SYMBOL || state.token === "in" && (0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(node) || state.tokenType === TOKENTYPE.NUMBER && !(0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(last) && (!(0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(last) || last.op === "!") || state.token === "(") {
                // parse implicit multiplication
                //
                // symbol:      implicit multiplication like '2a', '(2+3)a', 'a b'
                // number:      implicit multiplication like '(2+3)2'
                // parenthesis: implicit multiplication like '2(3+4)', '(3+4)(1+2)'
                last = parseRule2(state);
                node = new OperatorNode("*", "multiply", [
                    node,
                    last
                ], true);
            } else break;
        }
        return node;
    }
    /**
   * Infamous "rule 2" as described in https://github.com/josdejong/mathjs/issues/792#issuecomment-361065370
   * Explicit division gets higher precedence than implicit multiplication
   * when the division matches this pattern: [number] / [number] [symbol]
   * @return {Node} node
   * @private
   */ function parseRule2(state) {
        var node = parsePercentage(state);
        var last = node;
        var tokenStates = [];
        while(true){
            // Match the "number /" part of the pattern "number / number symbol"
            if (state.token === "/" && (0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(last)) {
                // Look ahead to see if the next token is a number
                tokenStates.push((0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))({}, state));
                getTokenSkipNewline(state); // Match the "number / number" part of the pattern
                if (state.tokenType === TOKENTYPE.NUMBER) {
                    // Look ahead again
                    tokenStates.push((0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))({}, state));
                    getTokenSkipNewline(state); // Match the "symbol" part of the pattern, or a left parenthesis
                    if (state.tokenType === TOKENTYPE.SYMBOL || state.token === "(") {
                        // We've matched the pattern "number / number symbol".
                        // Rewind once and build the "number / number" node; the symbol will be consumed later
                        (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))(state, tokenStates.pop());
                        tokenStates.pop();
                        last = parsePercentage(state);
                        node = new OperatorNode("/", "divide", [
                            node,
                            last
                        ]);
                    } else {
                        // Not a match, so rewind
                        tokenStates.pop();
                        (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))(state, tokenStates.pop());
                        break;
                    }
                } else {
                    // Not a match, so rewind
                    (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))(state, tokenStates.pop());
                    break;
                }
            } else break;
        }
        return node;
    }
    /**
   * percentage or mod
   * @return {Node} node
   * @private
   */ function parsePercentage(state) {
        var node, name, fn, params;
        node = parseUnary(state);
        var operators = {
            "%": "mod",
            mod: "mod"
        };
        while((0, $33619877a15996ac$export$5a15a386532a5ea4)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            if (name === "%" && state.tokenType === TOKENTYPE.DELIMITER && state.token !== "(") // If the expression contains only %, then treat that as /100
            node = new OperatorNode("/", "divide", [
                node,
                new ConstantNode(100)
            ], false, true);
            else {
                params = [
                    node,
                    parseUnary(state)
                ];
                node = new OperatorNode(name, fn, params);
            }
        }
        return node;
    }
    /**
   * Unary plus and minus, and logical and bitwise not
   * @return {Node} node
   * @private
   */ function parseUnary(state) {
        var name, params, fn;
        var operators = {
            "-": "unaryMinus",
            "+": "unaryPlus",
            "~": "bitNot",
            not: "not"
        };
        if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(operators, state.token)) {
            fn = operators[state.token];
            name = state.token;
            getTokenSkipNewline(state);
            params = [
                parseUnary(state)
            ];
            return new OperatorNode(name, fn, params);
        }
        return parsePow(state);
    }
    /**
   * power
   * Note: power operator is right associative
   * @return {Node} node
   * @private
   */ function parsePow(state) {
        var node, name, fn, params;
        node = parseLeftHandOperators(state);
        if (state.token === "^" || state.token === ".^") {
            name = state.token;
            fn = name === "^" ? "pow" : "dotPow";
            getTokenSkipNewline(state);
            params = [
                node,
                parseUnary(state)
            ]; // Go back to unary, we can have '2^-3'
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * Left hand operators: factorial x!, ctranspose x'
   * @return {Node} node
   * @private
   */ function parseLeftHandOperators(state) {
        var node, name, fn, params;
        node = parseCustomNodes(state);
        var operators = {
            "!": "factorial",
            "'": "ctranspose"
        };
        while((0, $33619877a15996ac$export$5a15a386532a5ea4)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getToken(state);
            params = [
                node
            ];
            node = new OperatorNode(name, fn, params);
            node = parseAccessors(state, node);
        }
        return node;
    }
    /**
   * Parse a custom node handler. A node handler can be used to process
   * nodes in a custom way, for example for handling a plot.
   *
   * A handler must be passed as second argument of the parse function.
   * - must extend math.Node
   * - must contain a function _compile(defs: Object) : string
   * - must contain a function find(filter: Object) : Node[]
   * - must contain a function toString() : string
   * - the constructor is called with a single argument containing all parameters
   *
   * For example:
   *
   *     nodes = {
   *       'plot': PlotHandler
   *     }
   *
   * The constructor of the handler is called as:
   *
   *     node = new PlotHandler(params)
   *
   * The handler will be invoked when evaluating an expression like:
   *
   *     node = math.parse('plot(sin(x), x)', nodes)
   *
   * @return {Node} node
   * @private
   */ function parseCustomNodes(state) {
        var params = [];
        if (state.tokenType === TOKENTYPE.SYMBOL && (0, $33619877a15996ac$export$5a15a386532a5ea4)(state.extraNodes, state.token)) {
            var CustomNode = state.extraNodes[state.token];
            getToken(state); // parse parameters
            if (state.token === "(") {
                params = [];
                openParams(state);
                getToken(state);
                if (state.token !== ")") {
                    params.push(parseAssignment(state)); // parse a list with parameters
                    while(state.token === ","){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        params.push(parseAssignment(state));
                    }
                }
                if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
                closeParams(state);
                getToken(state);
            } // create a new custom node
            // noinspection JSValidateTypes
            return new CustomNode(params);
        }
        return parseSymbol(state);
    }
    /**
   * parse symbols: functions, variables, constants, units
   * @return {Node} node
   * @private
   */ function parseSymbol(state) {
        var node, name;
        if (state.tokenType === TOKENTYPE.SYMBOL || state.tokenType === TOKENTYPE.DELIMITER && state.token in NAMED_DELIMITERS) {
            name = state.token;
            getToken(state);
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(CONSTANTS, name)) // true, false, null, ...
            node = new ConstantNode(CONSTANTS[name]);
            else if (NUMERIC_CONSTANTS.indexOf(name) !== -1) // NaN, Infinity
            node = new ConstantNode(numeric(name, "number"));
            else node = new SymbolNode(name);
             // parse function parameters and matrix index
            node = parseAccessors(state, node);
            return node;
        }
        return parseDoubleQuotesString(state);
    }
    /**
   * parse accessors:
   * - function invocation in round brackets (...), for example sqrt(2)
   * - index enclosed in square brackets [...], for example A[2,3]
   * - dot notation for properties, like foo.bar
   * @param {Object} state
   * @param {Node} node    Node on which to apply the parameters. If there
   *                       are no parameters in the expression, the node
   *                       itself is returned
   * @param {string[]} [types]  Filter the types of notations
   *                            can be ['(', '[', '.']
   * @return {Node} node
   * @private
   */ function parseAccessors(state, node, types) {
        var params;
        while((state.token === "(" || state.token === "[" || state.token === ".") && (!types || types.indexOf(state.token) !== -1)){
            // eslint-disable-line no-unmodified-loop-condition
            params = [];
            if (state.token === "(") {
                if ((0, $2c4f948f17aa2240$export$87815d550facaed9)(node) || (0, $2c4f948f17aa2240$export$f88fb19d6b9ee5cb)(node)) {
                    // function invocation like fn(2, 3) or obj.fn(2, 3)
                    openParams(state);
                    getToken(state);
                    if (state.token !== ")") {
                        params.push(parseAssignment(state)); // parse a list with parameters
                        while(state.token === ","){
                            // eslint-disable-line no-unmodified-loop-condition
                            getToken(state);
                            params.push(parseAssignment(state));
                        }
                    }
                    if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
                    closeParams(state);
                    getToken(state);
                    node = new FunctionNode(node, params);
                } else // implicit multiplication like (2+3)(4+5) or sqrt(2)(1+2)
                // don't parse it here but let it be handled by parseImplicitMultiplication
                // with correct precedence
                return node;
            } else if (state.token === "[") {
                // index notation like variable[2, 3]
                openParams(state);
                getToken(state);
                if (state.token !== "]") {
                    params.push(parseAssignment(state)); // parse a list with parameters
                    while(state.token === ","){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        params.push(parseAssignment(state));
                    }
                }
                if (state.token !== "]") throw createSyntaxError(state, "Parenthesis ] expected");
                closeParams(state);
                getToken(state);
                node = new AccessorNode(node, new IndexNode(params));
            } else {
                // dot notation like variable.prop
                getToken(state);
                if (state.tokenType !== TOKENTYPE.SYMBOL) throw createSyntaxError(state, "Property name expected after dot");
                params.push(new ConstantNode(state.token));
                getToken(state);
                var dotNotation = true;
                node = new AccessorNode(node, new IndexNode(params, dotNotation));
            }
        }
        return node;
    }
    /**
   * Parse a double quotes string.
   * @return {Node} node
   * @private
   */ function parseDoubleQuotesString(state) {
        var node, str;
        if (state.token === '"') {
            str = parseDoubleQuotesStringToken(state); // create constant
            node = new ConstantNode(str); // parse index parameters
            node = parseAccessors(state, node);
            return node;
        }
        return parseSingleQuotesString(state);
    }
    /**
   * Parse a string surrounded by double quotes "..."
   * @return {string}
   */ function parseDoubleQuotesStringToken(state) {
        var str = "";
        while(currentCharacter(state) !== "" && currentCharacter(state) !== '"'){
            if (currentCharacter(state) === "\\") {
                // escape character, immediately process the next
                // character to prevent stopping at a next '\"'
                str += currentCharacter(state);
                next(state);
            }
            str += currentCharacter(state);
            next(state);
        }
        getToken(state);
        if (state.token !== '"') throw createSyntaxError(state, 'End of string " expected');
        getToken(state);
        return JSON.parse('"' + str + '"'); // unescape escaped characters
    }
    /**
   * Parse a single quotes string.
   * @return {Node} node
   * @private
   */ function parseSingleQuotesString(state) {
        var node, str;
        if (state.token === "'") {
            str = parseSingleQuotesStringToken(state); // create constant
            node = new ConstantNode(str); // parse index parameters
            node = parseAccessors(state, node);
            return node;
        }
        return parseMatrix(state);
    }
    /**
   * Parse a string surrounded by single quotes '...'
   * @return {string}
   */ function parseSingleQuotesStringToken(state) {
        var str = "";
        while(currentCharacter(state) !== "" && currentCharacter(state) !== "'"){
            if (currentCharacter(state) === "\\") {
                // escape character, immediately process the next
                // character to prevent stopping at a next '\''
                str += currentCharacter(state);
                next(state);
            }
            str += currentCharacter(state);
            next(state);
        }
        getToken(state);
        if (state.token !== "'") throw createSyntaxError(state, "End of string ' expected");
        getToken(state);
        return JSON.parse('"' + str + '"'); // unescape escaped characters
    }
    /**
   * parse the matrix
   * @return {Node} node
   * @private
   */ function parseMatrix(state) {
        var array, params, rows, cols;
        if (state.token === "[") {
            // matrix [...]
            openParams(state);
            getToken(state);
            if (state.token !== "]") {
                // this is a non-empty matrix
                var row = parseRow(state);
                if (state.token === ";") {
                    // 2 dimensional array
                    rows = 1;
                    params = [
                        row
                    ]; // the rows of the matrix are separated by dot-comma's
                    while(state.token === ";"){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        params[rows] = parseRow(state);
                        rows++;
                    }
                    if (state.token !== "]") throw createSyntaxError(state, "End of matrix ] expected");
                    closeParams(state);
                    getToken(state); // check if the number of columns matches in all rows
                    cols = params[0].items.length;
                    for(var r = 1; r < rows; r++){
                        if (params[r].items.length !== cols) throw createError(state, "Column dimensions mismatch (" + params[r].items.length + " !== " + cols + ")");
                    }
                    array = new ArrayNode(params);
                } else {
                    // 1 dimensional vector
                    if (state.token !== "]") throw createSyntaxError(state, "End of matrix ] expected");
                    closeParams(state);
                    getToken(state);
                    array = row;
                }
            } else {
                // this is an empty matrix "[ ]"
                closeParams(state);
                getToken(state);
                array = new ArrayNode([]);
            }
            return parseAccessors(state, array);
        }
        return parseObject(state);
    }
    /**
   * Parse a single comma-separated row from a matrix, like 'a, b, c'
   * @return {ArrayNode} node
   */ function parseRow(state) {
        var params = [
            parseAssignment(state)
        ];
        var len = 1;
        while(state.token === ","){
            // eslint-disable-line no-unmodified-loop-condition
            getToken(state); // parse expression
            params[len] = parseAssignment(state);
            len++;
        }
        return new ArrayNode(params);
    }
    /**
   * parse an object, enclosed in angle brackets{...}, for example {value: 2}
   * @return {Node} node
   * @private
   */ function parseObject(state) {
        if (state.token === "{") {
            openParams(state);
            var key;
            var properties = {};
            do {
                getToken(state);
                if (state.token !== "}") {
                    // parse key
                    if (state.token === '"') key = parseDoubleQuotesStringToken(state);
                    else if (state.token === "'") key = parseSingleQuotesStringToken(state);
                    else if (state.tokenType === TOKENTYPE.SYMBOL || state.tokenType === TOKENTYPE.DELIMITER && state.token in NAMED_DELIMITERS) {
                        key = state.token;
                        getToken(state);
                    } else throw createSyntaxError(state, "Symbol or string expected as object key");
                     // parse key/value separator
                    if (state.token !== ":") throw createSyntaxError(state, "Colon : expected after object key");
                    getToken(state); // parse key
                    properties[key] = parseAssignment(state);
                }
            }while (state.token === ","); // eslint-disable-line no-unmodified-loop-condition
            if (state.token !== "}") throw createSyntaxError(state, "Comma , or bracket } expected after object value");
            closeParams(state);
            getToken(state);
            var node = new ObjectNode(properties); // parse index parameters
            node = parseAccessors(state, node);
            return node;
        }
        return parseNumber(state);
    }
    /**
   * parse a number
   * @return {Node} node
   * @private
   */ function parseNumber(state) {
        var numberStr;
        if (state.tokenType === TOKENTYPE.NUMBER) {
            // this is a number
            numberStr = state.token;
            getToken(state);
            return new ConstantNode(numeric(numberStr, config.number));
        }
        return parseParentheses(state);
    }
    /**
   * parentheses
   * @return {Node} node
   * @private
   */ function parseParentheses(state) {
        var node; // check if it is a parenthesized expression
        if (state.token === "(") {
            // parentheses (...)
            openParams(state);
            getToken(state);
            node = parseAssignment(state); // start again
            if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
            closeParams(state);
            getToken(state);
            node = new ParenthesisNode(node);
            node = parseAccessors(state, node);
            return node;
        }
        return parseEnd(state);
    }
    /**
   * Evaluated when the expression is not yet ended but expected to end
   * @return {Node} res
   * @private
   */ function parseEnd(state) {
        if (state.token === "") // syntax error or unexpected end of expression
        throw createSyntaxError(state, "Unexpected end of expression");
        else throw createSyntaxError(state, "Value expected");
    }
    /**
   * Shortcut for getting the current row value (one based)
   * Returns the line of the currently handled expression
   * @private
   */ /* TODO: implement keeping track on the row number
  function row () {
    return null
  }
  */ /**
   * Shortcut for getting the current col value (one based)
   * Returns the column (position) where the last state.token starts
   * @private
   */ function col(state) {
        return state.index - state.token.length + 1;
    }
    /**
   * Create an error
   * @param {Object} state
   * @param {string} message
   * @return {SyntaxError} instantiated error
   * @private
   */ function createSyntaxError(state, message) {
        var c = col(state);
        var error = new SyntaxError(message + " (char " + c + ")");
        error.char = c;
        return error;
    }
    /**
   * Create an error
   * @param {Object} state
   * @param {string} message
   * @return {Error} instantiated error
   * @private
   */ function createError(state, message) {
        var c = col(state);
        var error = new SyntaxError(message + " (char " + c + ")");
        error.char = c;
        return error;
    }
    return parse;
});


var $b765548e953e7ea6$var$name = "parser";
var $b765548e953e7ea6$var$dependencies = [
    "typed",
    "Parser"
];
var $b765548e953e7ea6$export$88a1156fad04455f = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b765548e953e7ea6$var$name, $b765548e953e7ea6$var$dependencies, (_ref)=>{
    var { typed: typed, Parser: Parser } = _ref;
    /**
   * Create a parser. The function creates a new `math.Parser` object.
   *
   * Syntax:
   *
   *    math.parser()
   *
   * Examples:
   *
   *     const parser = new math.parser()
   *
   *     // evaluate expressions
   *     const a = parser.evaluate('sqrt(3^2 + 4^2)') // 5
   *     const b = parser.evaluate('sqrt(-4)')        // 2i
   *     const c = parser.evaluate('2 inch in cm')    // 5.08 cm
   *     const d = parser.evaluate('cos(45 deg)')     // 0.7071067811865476
   *
   *     // define variables and functions
   *     parser.evaluate('x = 7 / 2')             // 3.5
   *     parser.evaluate('x + 3')                 // 6.5
   *     parser.evaluate('f(x, y) = x^y')         // f(x, y)
   *     parser.evaluate('f(2, 3)')               // 8
   *
   *     // get and set variables and functions
   *     const x = parser.get('x')                // 7
   *     const f = parser.get('f')                // function
   *     const g = f(3, 2)                        // 9
   *     parser.set('h', 500)
   *     const i = parser.evaluate('h / 2')       // 250
   *     parser.set('hello', function (name) {
   *       return 'hello, ' + name + '!'
   *     })
   *     parser.evaluate('hello("user")')         // "hello, user!"
   *
   *     // clear defined functions and variables
   *     parser.clear()
   *
   * See also:
   *
   *    evaluate, compile, parse
   *
   * @return {Parser} Parser
   */ return typed($b765548e953e7ea6$var$name, {
        "": function _() {
            return new Parser();
        }
    });
});



var $df0de5ca7183e0db$var$name = "Parser";
var $df0de5ca7183e0db$var$dependencies = [
    "evaluate"
];
var $df0de5ca7183e0db$export$17c8a99aaef91654 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($df0de5ca7183e0db$var$name, $df0de5ca7183e0db$var$dependencies, (_ref)=>{
    var { evaluate: evaluate } = _ref;
    /**
   * @constructor Parser
   * Parser contains methods to evaluate or parse expressions, and has a number
   * of convenience methods to get, set, and remove variables from memory. Parser
   * keeps a scope containing variables in memory, which is used for all
   * evaluations.
   *
   * Methods:
   *    const result = parser.evaluate(expr)  // evaluate an expression
   *    const value = parser.get(name)        // retrieve a variable from the parser
   *    const values = parser.getAll()        // retrieve all defined variables
   *    parser.set(name, value)               // set a variable in the parser
   *    parser.remove(name)                   // clear a variable from the
   *                                          // parsers scope
   *    parser.clear()                        // clear the parsers scope
   *
   * Example usage:
   *    const parser = new Parser()
   *    // Note: there is a convenience method which can be used instead:
   *    // const parser = new math.parser()
   *
   *    // evaluate expressions
   *    parser.evaluate('sqrt(3^2 + 4^2)')        // 5
   *    parser.evaluate('sqrt(-4)')               // 2i
   *    parser.evaluate('2 inch in cm')           // 5.08 cm
   *    parser.evaluate('cos(45 deg)')            // 0.7071067811865476
   *
   *    // define variables and functions
   *    parser.evaluate('x = 7 / 2')              // 3.5
   *    parser.evaluate('x + 3')                  // 6.5
   *    parser.evaluate('f(x, y) = x^y')          // f(x, y)
   *    parser.evaluate('f(2, 3)')                // 8
   *
   *    // get and set variables and functions
   *    const x = parser.get('x')                 // 7
   *    const f = parser.get('f')                 // function
   *    const g = f(3, 2)                         // 9
   *    parser.set('h', 500)
   *    const i = parser.evaluate('h / 2')        // 250
   *    parser.set('hello', function (name) {
   *        return 'hello, ' + name + '!'
   *    })
   *    parser.evaluate('hello("user")')          // "hello, user!"
   *
   *    // clear defined functions and variables
   *    parser.clear()
   *
   */ function Parser() {
        if (!(this instanceof Parser)) throw new SyntaxError("Constructor must be called with the new operator");
        Object.defineProperty(this, "scope", {
            value: (0, $8f2e3669195c8ad5$export$89a4bcaf5b4d37d2)(),
            writable: false
        });
    }
    /**
   * Attach type information
   */ Parser.prototype.type = "Parser";
    Parser.prototype.isParser = true;
    /**
   * Parse and evaluate the given expression
   * @param {string | string[]} expr   A string containing an expression,
   *                                   for example "2+3", or a list with expressions
   * @return {*} result     The result, or undefined when the expression was empty
   * @throws {Error}
   */ Parser.prototype.evaluate = function(expr) {
        // TODO: validate arguments
        return evaluate(expr, this.scope);
    };
    /**
   * Get a variable (a function or variable) by name from the parsers scope.
   * Returns undefined when not found
   * @param {string} name
   * @return {* | undefined} value
   */ Parser.prototype.get = function(name) {
        // TODO: validate arguments
        if (this.scope.has(name)) return this.scope.get(name);
    };
    /**
   * Get a map with all defined variables
   * @return {Object} values
   */ Parser.prototype.getAll = function() {
        return (0, $8f2e3669195c8ad5$export$697e4a1b90752ce2)(this.scope);
    };
    /**
   * Get a map with all defined variables
   * @return {Map} values
   */ Parser.prototype.getAllAsMap = function() {
        return this.scope;
    };
    /**
   * Set a symbol (a function or variable) by name from the parsers scope.
   * @param {string} name
   * @param {* | undefined} value
   */ Parser.prototype.set = function(name, value) {
        this.scope.set(name, value);
        return value;
    };
    /**
   * Remove a variable from the parsers scope
   * @param {string} name
   */ Parser.prototype.remove = function(name) {
        this.scope.delete(name);
    };
    /**
   * Clear the scope with variables and functions
   */ Parser.prototype.clear = function() {
        this.scope.clear();
    };
    return Parser;
}, {
    isClass: true
});




var $5d69aff0d81b70dc$var$name = "RangeNode";
var $5d69aff0d81b70dc$var$dependencies = [
    "Node"
];
var $5d69aff0d81b70dc$export$fb6d9b21e29b8d46 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($5d69aff0d81b70dc$var$name, $5d69aff0d81b70dc$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    /**
   * @constructor RangeNode
   * @extends {Node}
   * create a range
   * @param {Node} start  included lower-bound
   * @param {Node} end    included upper-bound
   * @param {Node} [step] optional step
   */ function RangeNode(start, end, step) {
        if (!(this instanceof RangeNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate inputs
        if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(start)) throw new TypeError("Node expected");
        if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(end)) throw new TypeError("Node expected");
        if (step && !(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(step)) throw new TypeError("Node expected");
        if (arguments.length > 3) throw new Error("Too many arguments");
        this.start = start; // included lower-bound
        this.end = end; // included upper-bound
        this.step = step || null; // optional step
    }
    RangeNode.prototype = new Node();
    RangeNode.prototype.type = "RangeNode";
    RangeNode.prototype.isRangeNode = true;
    /**
   * Check whether the RangeNode needs the `end` symbol to be defined.
   * This end is the size of the Matrix in current dimension.
   * @return {boolean}
   */ RangeNode.prototype.needsEnd = function() {
        // find all `end` symbols in this RangeNode
        var endSymbols = this.filter(function(node) {
            return (0, $2c4f948f17aa2240$export$87815d550facaed9)(node) && node.name === "end";
        });
        return endSymbols.length > 0;
    };
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ RangeNode.prototype._compile = function(math, argNames) {
        var range = math.range;
        var evalStart = this.start._compile(math, argNames);
        var evalEnd = this.end._compile(math, argNames);
        if (this.step) {
            var evalStep = this.step._compile(math, argNames);
            return function evalRangeNode(scope, args, context) {
                return range(evalStart(scope, args, context), evalEnd(scope, args, context), evalStep(scope, args, context));
            };
        } else return function evalRangeNode(scope, args, context) {
            return range(evalStart(scope, args, context), evalEnd(scope, args, context));
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ RangeNode.prototype.forEach = function(callback) {
        callback(this.start, "start", this);
        callback(this.end, "end", this);
        if (this.step) callback(this.step, "step", this);
    };
    /**
   * Create a new RangeNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {RangeNode} Returns a transformed copy of the node
   */ RangeNode.prototype.map = function(callback) {
        return new RangeNode(this._ifNode(callback(this.start, "start", this)), this._ifNode(callback(this.end, "end", this)), this.step && this._ifNode(callback(this.step, "step", this)));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {RangeNode}
   */ RangeNode.prototype.clone = function() {
        return new RangeNode(this.start, this.end, this.step && this.step);
    };
    /**
   * Calculate the necessary parentheses
   * @param {Node} node
   * @param {string} parenthesis
   * @return {Object} parentheses
   * @private
   */ function calculateNecessaryParentheses(node, parenthesis) {
        var precedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(node, parenthesis);
        var parens = {};
        var startPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(node.start, parenthesis);
        parens.start = startPrecedence !== null && startPrecedence <= precedence || parenthesis === "all";
        if (node.step) {
            var stepPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(node.step, parenthesis);
            parens.step = stepPrecedence !== null && stepPrecedence <= precedence || parenthesis === "all";
        }
        var endPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(node.end, parenthesis);
        parens.end = endPrecedence !== null && endPrecedence <= precedence || parenthesis === "all";
        return parens;
    }
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   */ RangeNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var parens = calculateNecessaryParentheses(this, parenthesis); // format string as start:step:stop
        var str;
        var start = this.start.toString(options);
        if (parens.start) start = "(" + start + ")";
        str = start;
        if (this.step) {
            var step = this.step.toString(options);
            if (parens.step) step = "(" + step + ")";
            str += ":" + step;
        }
        var end = this.end.toString(options);
        if (parens.end) end = "(" + end + ")";
        str += ":" + end;
        return str;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ RangeNode.prototype.toJSON = function() {
        return {
            mathjs: "RangeNode",
            start: this.start,
            end: this.end,
            step: this.step
        };
    };
    /**
   * Instantiate an RangeNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "RangeNode", "start": ..., "end": ..., "step": ...}`,
   *                       where mathjs is optional
   * @returns {RangeNode}
   */ RangeNode.fromJSON = function(json) {
        return new RangeNode(json.start, json.end, json.step);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ RangeNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var parens = calculateNecessaryParentheses(this, parenthesis); // format string as start:step:stop
        var str;
        var start = this.start.toHTML(options);
        if (parens.start) start = '<span class="math-parenthesis math-round-parenthesis">(</span>' + start + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        str = start;
        if (this.step) {
            var step = this.step.toHTML(options);
            if (parens.step) step = '<span class="math-parenthesis math-round-parenthesis">(</span>' + step + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            str += '<span class="math-operator math-range-operator">:</span>' + step;
        }
        var end = this.end.toHTML(options);
        if (parens.end) end = '<span class="math-parenthesis math-round-parenthesis">(</span>' + end + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        str += '<span class="math-operator math-range-operator">:</span>' + end;
        return str;
    };
    /**
   * Get LaTeX representation
   * @params {Object} options
   * @return {string} str
   */ RangeNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var parens = calculateNecessaryParentheses(this, parenthesis);
        var str = this.start.toTex(options);
        if (parens.start) str = "\\left(".concat(str, "\\right)");
        if (this.step) {
            var step = this.step.toTex(options);
            if (parens.step) step = "\\left(".concat(step, "\\right)");
            str += ":" + step;
        }
        var end = this.end.toTex(options);
        if (parens.end) end = "\\left(".concat(end, "\\right)");
        str += ":" + end;
        return str;
    };
    return RangeNode;
}, {
    isClass: true,
    isNode: true
});



var $56d63b8ec1d2d4db$var$name = "range";
var $56d63b8ec1d2d4db$var$dependencies = [
    "typed",
    "config",
    "?matrix",
    "?bignumber",
    "smaller",
    "smallerEq",
    "larger",
    "largerEq"
];
var $56d63b8ec1d2d4db$export$af4628cd15bbfbf2 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($56d63b8ec1d2d4db$var$name, $56d63b8ec1d2d4db$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, bignumber: bignumber, smaller: smaller, smallerEq: smallerEq, larger: larger, largerEq: largerEq } = _ref;
    var range = (0, $1f3643faa6d2156c$export$d372f2f3c4d1b8e5)({
        typed: typed,
        config: config,
        matrix: matrix,
        bignumber: bignumber,
        smaller: smaller,
        smallerEq: smallerEq,
        larger: larger,
        largerEq: largerEq
    });
    /**
   * Attach a transform function to math.range
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */ return typed("range", {
        "...any": function any(args) {
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if (typeof last !== "boolean") // append a parameter includeEnd=true
            args.push(true);
            return range.apply(null, args);
        }
    });
}, {
    isTransformFunction: true
});



// TODO this could be improved by simplifying seperated constants under associative and commutative operators






function $cc6b879c4ae1b0e9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cc6b879c4ae1b0e9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cc6b879c4ae1b0e9$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cc6b879c4ae1b0e9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $cc6b879c4ae1b0e9$var$name = "simplifyUtil";
var $cc6b879c4ae1b0e9$var$dependencies = [
    "FunctionNode",
    "OperatorNode",
    "SymbolNode"
];
var $cc6b879c4ae1b0e9$export$f2206d57cebf291a = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($cc6b879c4ae1b0e9$var$name, $cc6b879c4ae1b0e9$var$dependencies, (_ref)=>{
    var { FunctionNode: FunctionNode, OperatorNode: OperatorNode, SymbolNode: SymbolNode } = _ref;
    // TODO commutative/associative properties rely on the arguments
    // e.g. multiply is not commutative for matrices
    // The properties should be calculated from an argument to simplify, or possibly something in math.config
    // the other option is for typed() to specify a return type so that we can evaluate the type of arguments
    /* So that properties of an operator fit on one line: */ var T = true;
    var F = false;
    var defaultName = "defaultF";
    var defaultContext = {
        /*      */ add: {
            trivial: T,
            total: T,
            commutative: T,
            associative: T
        },
        /**/ unaryPlus: {
            trivial: T,
            total: T,
            commutative: T,
            associative: T
        },
        /* */ subtract: {
            trivial: F,
            total: T,
            commutative: F,
            associative: F
        },
        /* */ multiply: {
            trivial: T,
            total: T,
            commutative: T,
            associative: T
        },
        /*   */ divide: {
            trivial: F,
            total: T,
            commutative: F,
            associative: F
        },
        /*    */ paren: {
            trivial: T,
            total: T,
            commutative: T,
            associative: F
        },
        /* */ defaultF: {
            trivial: F,
            total: T,
            commutative: F,
            associative: F
        }
    };
    var realContext = {
        divide: {
            total: F
        },
        log: {
            total: F
        }
    };
    var positiveContext = {
        subtract: {
            total: F
        },
        abs: {
            trivial: T
        },
        log: {
            total: T
        }
    };
    function hasProperty(nodeOrName, property) {
        var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultContext;
        var name = defaultName;
        if (typeof nodeOrName === "string") name = nodeOrName;
        else if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(nodeOrName)) name = nodeOrName.fn.toString();
        else if ((0, $2c4f948f17aa2240$export$6ae03b16e064e6c4)(nodeOrName)) name = nodeOrName.name;
        else if ((0, $2c4f948f17aa2240$export$c55e3736c5721220)(nodeOrName)) name = "paren";
        if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(context, name)) {
            var properties = context[name];
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(properties, property)) return properties[property];
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(defaultContext, name)) return defaultContext[name][property];
        }
        if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(context, defaultName)) {
            var _properties = context[defaultName];
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(_properties, property)) return _properties[property];
            return defaultContext[defaultName][property];
        }
        /* name not found in context and context has no global default */ /* So use default context. */ if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(defaultContext, name)) {
            var _properties2 = defaultContext[name];
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(_properties2, property)) return _properties2[property];
        }
        return defaultContext[defaultName][property];
    }
    function isCommutative(node) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultContext;
        return hasProperty(node, "commutative", context);
    }
    function isAssociative(node) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultContext;
        return hasProperty(node, "associative", context);
    }
    /**
   * Merge the given contexts, with primary overriding secondary
   * wherever they might conflict
   */ function mergeContext(primary, secondary) {
        var merged = $cc6b879c4ae1b0e9$var$_objectSpread({}, primary);
        for(var prop in secondary)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(primary, prop)) merged[prop] = $cc6b879c4ae1b0e9$var$_objectSpread($cc6b879c4ae1b0e9$var$_objectSpread({}, secondary[prop]), primary[prop]);
        else merged[prop] = secondary[prop];
        return merged;
    }
    /**
   * Flatten all associative operators in an expression tree.
   * Assumes parentheses have already been removed.
   */ function flatten(node, context) {
        if (!node.args || node.args.length === 0) return node;
        node.args = allChildren(node, context);
        for(var i = 0; i < node.args.length; i++)flatten(node.args[i], context);
    }
    /**
   * Get the children of a node as if it has been flattened.
   * TODO implement for FunctionNodes
   */ function allChildren(node, context) {
        var op;
        var children = [];
        var findChildren = function findChildren(node) {
            for(var i = 0; i < node.args.length; i++){
                var child = node.args[i];
                if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(child) && op === child.op) findChildren(child);
                else children.push(child);
            }
        };
        if (isAssociative(node, context)) {
            op = node.op;
            findChildren(node);
            return children;
        } else return node.args;
    }
    /**
   *  Unflatten all flattened operators to a right-heavy binary tree.
   */ function unflattenr(node, context) {
        if (!node.args || node.args.length === 0) return;
        var makeNode = createMakeNodeFunction(node);
        var l = node.args.length;
        for(var i = 0; i < l; i++)unflattenr(node.args[i], context);
        if (l > 2 && isAssociative(node, context)) {
            var curnode = node.args.pop();
            while(node.args.length > 0)curnode = makeNode([
                node.args.pop(),
                curnode
            ]);
            node.args = curnode.args;
        }
    }
    /**
   *  Unflatten all flattened operators to a left-heavy binary tree.
   */ function unflattenl(node, context) {
        if (!node.args || node.args.length === 0) return;
        var makeNode = createMakeNodeFunction(node);
        var l = node.args.length;
        for(var i = 0; i < l; i++)unflattenl(node.args[i], context);
        if (l > 2 && isAssociative(node, context)) {
            var curnode = node.args.shift();
            while(node.args.length > 0)curnode = makeNode([
                curnode,
                node.args.shift()
            ]);
            node.args = curnode.args;
        }
    }
    function createMakeNodeFunction(node) {
        if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(node)) return function(args) {
            try {
                return new OperatorNode(node.op, node.fn, args, node.implicit);
            } catch (err) {
                console.error(err);
                return [];
            }
        };
        else return function(args) {
            return new FunctionNode(new SymbolNode(node.name), args);
        };
    }
    return {
        createMakeNodeFunction: createMakeNodeFunction,
        hasProperty: hasProperty,
        isCommutative: isCommutative,
        isAssociative: isAssociative,
        mergeContext: mergeContext,
        flatten: flatten,
        allChildren: allChildren,
        unflattenr: unflattenr,
        unflattenl: unflattenl,
        defaultContext: defaultContext,
        realContext: realContext,
        positiveContext: positiveContext
    };
});



var $6b8561cb89789184$var$name = "simplifyConstant";
var $6b8561cb89789184$var$dependencies = [
    "typed",
    "config",
    "mathWithTransform",
    "matrix",
    "?fraction",
    "?bignumber",
    "AccessorNode",
    "ArrayNode",
    "ConstantNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "SymbolNode"
];
var $6b8561cb89789184$export$d72b8f0d2b277ae2 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($6b8561cb89789184$var$name, $6b8561cb89789184$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, mathWithTransform: mathWithTransform, matrix: matrix, fraction: fraction, bignumber: bignumber, AccessorNode: AccessorNode, ArrayNode: ArrayNode, ConstantNode: ConstantNode, FunctionNode: FunctionNode, IndexNode: IndexNode, ObjectNode: ObjectNode, OperatorNode: OperatorNode, SymbolNode: SymbolNode } = _ref;
    var { isCommutative: isCommutative, isAssociative: isAssociative, allChildren: allChildren, createMakeNodeFunction: createMakeNodeFunction } = (0, $cc6b879c4ae1b0e9$export$f2206d57cebf291a)({
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    });
    function simplifyConstant(expr, options) {
        return _ensureNode(foldFraction(expr, options));
    }
    function _removeFractions(thing) {
        if ((0, $2c4f948f17aa2240$export$e312cb8a8e5e7c34)(thing)) return thing.valueOf();
        if (thing instanceof Array) return thing.map(_removeFractions);
        if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(thing)) return matrix(_removeFractions(thing.valueOf()));
        return thing;
    }
    function _eval(fnname, args, options) {
        try {
            return mathWithTransform[fnname].apply(null, args);
        } catch (ignore) {
            // sometimes the implicit type conversion causes the evaluation to fail, so we'll try again after removing Fractions
            args = args.map(_removeFractions);
            return _toNumber(mathWithTransform[fnname].apply(null, args), options);
        }
    }
    var _toNode = typed({
        Fraction: _fractionToNode,
        number: function number(n) {
            if (n < 0) return unaryMinusNode(new ConstantNode(-n));
            return new ConstantNode(n);
        },
        BigNumber: function BigNumber(n) {
            if (n < 0) return unaryMinusNode(new ConstantNode(-n));
            return new ConstantNode(n); // old parameters: (n.toString(), 'number')
        },
        Complex: function Complex(s) {
            throw new Error("Cannot convert Complex number to Node");
        },
        string: function string(s) {
            return new ConstantNode(s);
        },
        Matrix: function Matrix(m) {
            return new ArrayNode(m.valueOf().map((e)=>_toNode(e)));
        }
    });
    function _ensureNode(thing) {
        if ((0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(thing)) return thing;
        return _toNode(thing);
    } // convert a number to a fraction only if it can be expressed exactly,
    // and when both numerator and denominator are small enough
    function _exactFraction(n, options) {
        var exactFractions = options && options.exactFractions !== false;
        if (exactFractions && isFinite(n) && fraction) {
            var f = fraction(n);
            var fractionsLimit = options && typeof options.fractionsLimit === "number" ? options.fractionsLimit : Infinity; // no limit by default
            if (f.valueOf() === n && f.n < fractionsLimit && f.d < fractionsLimit) return f;
        }
        return n;
    } // Convert numbers to a preferred number type in preference order: Fraction, number, Complex
    // BigNumbers are left alone
    var _toNumber = typed({
        "string, Object": function stringObject(s, options) {
            if (config.number === "BigNumber") {
                if (bignumber === undefined) (0, $59e7e238555a97e6$export$f0829713dc162a8)();
                return bignumber(s);
            } else if (config.number === "Fraction") {
                if (fraction === undefined) (0, $59e7e238555a97e6$export$9978fd42ef220ba0)();
                return fraction(s);
            } else {
                var n = parseFloat(s);
                return _exactFraction(n, options);
            }
        },
        "Fraction, Object": function FractionObject(s, options) {
            return s;
        },
        // we don't need options here
        "BigNumber, Object": function BigNumberObject(s, options) {
            return s;
        },
        // we don't need options here
        "number, Object": function numberObject(s, options) {
            return _exactFraction(s, options);
        },
        "Complex, Object": function ComplexObject(s, options) {
            if (s.im !== 0) return s;
            return _exactFraction(s.re, options);
        },
        "Matrix, Object": function MatrixObject(s, options) {
            return matrix(_exactFraction(s.valueOf()));
        },
        "Array, Object": function ArrayObject(s, options) {
            return s.map(_exactFraction);
        }
    });
    function unaryMinusNode(n) {
        return new OperatorNode("-", "unaryMinus", [
            n
        ]);
    }
    function _fractionToNode(f) {
        var n;
        var vn = f.s * f.n;
        if (vn < 0) n = new OperatorNode("-", "unaryMinus", [
            new ConstantNode(-vn)
        ]);
        else n = new ConstantNode(vn);
        if (f.d === 1) return n;
        return new OperatorNode("/", "divide", [
            n,
            new ConstantNode(f.d)
        ]);
    }
    /* Handles constant indexing of ArrayNodes, matrices, and ObjectNodes */ function _foldAccessor(obj, index, options) {
        if (!(0, $2c4f948f17aa2240$export$ff90979121a6cabc)(index)) // don't know what to do with that...
        return new AccessorNode(_ensureNode(obj), _ensureNode(index));
        if ((0, $2c4f948f17aa2240$export$440fa93dcf2757a3)(obj) || (0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(obj)) {
            var remainingDims = Array.from(index.dimensions);
            /* We will resolve constant indices one at a time, looking
       * just in the first or second dimensions because (a) arrays
       * of more than two dimensions are likely rare, and (b) pulling
       * out the third or higher dimension would be pretty intricate.
       * The price is that we miss simplifying [..3d array][x,y,1]
       */ while(remainingDims.length > 0){
                if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(remainingDims[0]) && typeof remainingDims[0].value !== "string") {
                    var first = _toNumber(remainingDims.shift().value, options);
                    if ((0, $2c4f948f17aa2240$export$440fa93dcf2757a3)(obj)) obj = obj.items[first - 1];
                    else {
                        // matrix
                        obj = obj.valueOf()[first - 1];
                        if (obj instanceof Array) obj = matrix(obj);
                    }
                } else if (remainingDims.length > 1 && (0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(remainingDims[1]) && typeof remainingDims[1].value !== "string") {
                    var second = _toNumber(remainingDims[1].value, options);
                    var tryItems = [];
                    var fromItems = (0, $2c4f948f17aa2240$export$440fa93dcf2757a3)(obj) ? obj.items : obj.valueOf();
                    for (var item of fromItems){
                        if ((0, $2c4f948f17aa2240$export$440fa93dcf2757a3)(item)) tryItems.push(item.items[second - 1]);
                        else if ((0, $2c4f948f17aa2240$export$b22160e0a14f87b7)(obj)) tryItems.push(item[second - 1]);
                        else break;
                    }
                    if (tryItems.length === fromItems.length) {
                        if ((0, $2c4f948f17aa2240$export$440fa93dcf2757a3)(obj)) obj = new ArrayNode(tryItems);
                        else // matrix
                        obj = matrix(tryItems);
                        remainingDims.splice(1, 1);
                    } else break;
                } else break;
            }
            if (remainingDims.length === index.dimensions.length) /* No successful constant indexing */ return new AccessorNode(_ensureNode(obj), index);
            if (remainingDims.length > 0) {
                /* Indexed some but not all dimensions */ index = new IndexNode(remainingDims);
                return new AccessorNode(_ensureNode(obj), index);
            }
            /* All dimensions were constant, access completely resolved */ return obj;
        }
        if ((0, $2c4f948f17aa2240$export$3f18867a334658e9)(obj) && index.dimensions.length === 1 && (0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(index.dimensions[0])) {
            var key = index.dimensions[0].value;
            if (key in obj.properties) return obj.properties[key];
            return new ConstantNode(); // undefined
        }
        /* Don't know how to index this sort of obj, at least not with this index */ return new AccessorNode(_ensureNode(obj), index);
    }
    /*
   * Create a binary tree from a list of Fractions and Nodes.
   * Tries to fold Fractions by evaluating them until the first Node in the list is hit, so
   * `args` should be sorted to have the Fractions at the start (if the operator is commutative).
   * @param args - list of Fractions and Nodes
   * @param fn - evaluator for the binary operation evaluator that accepts two Fractions
   * @param makeNode - creates a binary OperatorNode/FunctionNode from a list of child Nodes
   * if args.length is 1, returns args[0]
   * @return - Either a Node representing a binary expression or Fraction
   */ function foldOp(fn, args, makeNode, options) {
        return args.reduce(function(a, b) {
            if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(a) && !(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(b)) {
                try {
                    return _eval(fn, [
                        a,
                        b
                    ], options);
                } catch (ignoreandcontinue) {}
                a = _toNode(a);
                b = _toNode(b);
            } else if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(a)) a = _toNode(a);
            else if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(b)) b = _toNode(b);
            return makeNode([
                a,
                b
            ]);
        });
    } // destroys the original node and returns a folded one
    function foldFraction(node, options) {
        switch(node.type){
            case "SymbolNode":
                return node;
            case "ConstantNode":
                switch(typeof node.value){
                    case "number":
                        return _toNumber(node.value, options);
                    case "string":
                        return node.value;
                    default:
                        if (!isNaN(node.value)) return _toNumber(node.value, options);
                }
                return node;
            case "FunctionNode":
                if (mathWithTransform[node.name] && mathWithTransform[node.name].rawArgs) return node;
                // Process operators as OperatorNode
                var operatorFunctions = [
                    "add",
                    "multiply"
                ];
                if (operatorFunctions.indexOf(node.name) === -1) {
                    var args = node.args.map((arg)=>foldFraction(arg, options)); // If all args are numbers
                    if (!args.some((0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee))) try {
                        return _eval(node.name, args, options);
                    } catch (ignoreandcontinue) {}
                     // Size of a matrix does not depend on entries
                    if (node.name === "size" && args.length === 1 && (0, $2c4f948f17aa2240$export$440fa93dcf2757a3)(args[0])) {
                        var sz = [];
                        var section = args[0];
                        while((0, $2c4f948f17aa2240$export$440fa93dcf2757a3)(section)){
                            sz.push(section.items.length);
                            section = section.items[0];
                        }
                        return matrix(sz);
                    } // Convert all args to nodes and construct a symbolic function call
                    return new FunctionNode(node.name, args.map(_ensureNode));
                }
            /* falls through */ case "OperatorNode":
                var fn = node.fn.toString();
                var _args;
                var res;
                var makeNode = createMakeNodeFunction(node);
                if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(node) && node.isUnary()) {
                    _args = [
                        foldFraction(node.args[0], options)
                    ];
                    if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(_args[0])) res = _eval(fn, _args, options);
                    else res = makeNode(_args);
                } else if (isAssociative(node, options.context)) {
                    _args = allChildren(node, options.context);
                    _args = _args.map((arg)=>foldFraction(arg, options));
                    if (isCommutative(fn, options.context)) {
                        // commutative binary operator
                        var consts = [];
                        var vars = [];
                        for(var i = 0; i < _args.length; i++)if (!(0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(_args[i])) consts.push(_args[i]);
                        else vars.push(_args[i]);
                        if (consts.length > 1) {
                            res = foldOp(fn, consts, makeNode, options);
                            vars.unshift(res);
                            res = foldOp(fn, vars, makeNode, options);
                        } else // we won't change the children order since it's not neccessary
                        res = foldOp(fn, _args, makeNode, options);
                    } else // non-commutative binary operator
                    res = foldOp(fn, _args, makeNode, options);
                } else {
                    // non-associative binary operator
                    _args = node.args.map((arg)=>foldFraction(arg, options));
                    res = foldOp(fn, _args, makeNode, options);
                }
                return res;
            case "ParenthesisNode":
                // remove the uneccessary parenthesis
                return foldFraction(node.content, options);
            case "AccessorNode":
                return _foldAccessor(foldFraction(node.object, options), foldFraction(node.index, options), options);
            case "ArrayNode":
                var foldItems = node.items.map((item)=>foldFraction(item, options));
                if (foldItems.some((0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee))) return new ArrayNode(foldItems.map(_ensureNode));
                /* All literals -- return a Matrix so we can operate on it */ return matrix(foldItems);
            case "IndexNode":
                return new IndexNode(node.dimensions.map((n)=>simplifyConstant(n, options)));
            case "ObjectNode":
                var foldProps = {};
                for(var prop in node.properties)foldProps[prop] = simplifyConstant(node.properties[prop], options);
                return new ObjectNode(foldProps);
            case "AssignmentNode":
            /* falls through */ case "BlockNode":
            /* falls through */ case "FunctionAssignmentNode":
            /* falls through */ case "RangeNode":
            /* falls through */ case "ConditionalNode":
            /* falls through */ default:
                throw new Error("Unimplemented node type in simplifyConstant: ".concat(node.type));
        }
    }
    return simplifyConstant;
});


var $01adc6de4444f632$var$name = "rationalize";
var $01adc6de4444f632$var$dependencies = [
    "config",
    "typed",
    "equal",
    "isZero",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "parse",
    "simplifyCore",
    "simplify",
    "?bignumber",
    "?fraction",
    "mathWithTransform",
    "matrix",
    "AccessorNode",
    "ArrayNode",
    "ConstantNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "SymbolNode",
    "ParenthesisNode"
];
var $01adc6de4444f632$export$abd0968f5b11b2a8 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($01adc6de4444f632$var$name, $01adc6de4444f632$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, equal: equal, isZero: isZero, add: add, subtract: subtract, multiply: multiply, divide: divide, pow: pow, parse: parse, simplifyCore: simplifyCore, simplify: simplify, fraction: fraction, bignumber: bignumber, mathWithTransform: mathWithTransform, matrix: matrix, AccessorNode: AccessorNode, ArrayNode: ArrayNode, ConstantNode: ConstantNode, FunctionNode: FunctionNode, IndexNode: IndexNode, ObjectNode: ObjectNode, OperatorNode: OperatorNode, SymbolNode: SymbolNode, ParenthesisNode: ParenthesisNode } = _ref;
    var simplifyConstant = (0, $6b8561cb89789184$export$d72b8f0d2b277ae2)({
        typed: typed,
        config: config,
        mathWithTransform: mathWithTransform,
        matrix: matrix,
        fraction: fraction,
        bignumber: bignumber,
        AccessorNode: AccessorNode,
        ArrayNode: ArrayNode,
        ConstantNode: ConstantNode,
        FunctionNode: FunctionNode,
        IndexNode: IndexNode,
        ObjectNode: ObjectNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    });
    /**
   * Transform a rationalizable expression in a rational fraction.
   * If rational fraction is one variable polynomial then converts
   * the numerator and denominator in canonical form, with decreasing
   * exponents, returning the coefficients of numerator.
   *
   * Syntax:
   *
   *     rationalize(expr)
   *     rationalize(expr, detailed)
   *     rationalize(expr, scope)
   *     rationalize(expr, scope, detailed)
   *
   * Examples:
   *
   *     math.rationalize('sin(x)+y')
   *                   //  Error: There is an unsolved function call
   *     math.rationalize('2x/y - y/(x+1)')
   *                   // (2*x^2-y^2+2*x)/(x*y+y)
   *     math.rationalize('(2x+1)^6')
   *                   // 64*x^6+192*x^5+240*x^4+160*x^3+60*x^2+12*x+1
   *     math.rationalize('2x/( (2x-1) / (3x+2) ) - 5x/ ( (3x+4) / (2x^2-5) ) + 3')
   *                   // -20*x^4+28*x^3+104*x^2+6*x-12)/(6*x^2+5*x-4)
   *     math.rationalize('x/(1-x)/(x-2)/(x-3)/(x-4) + 2x/ ( (1-2x)/(2-3x) )/ ((3-4x)/(4-5x) )') =
   *                   // (-30*x^7+344*x^6-1506*x^5+3200*x^4-3472*x^3+1846*x^2-381*x)/
   *                   //     (-8*x^6+90*x^5-383*x^4+780*x^3-797*x^2+390*x-72)
   *
   *     math.rationalize('x+x+x+y',{y:1}) // 3*x+1
   *     math.rationalize('x+x+x+y',{})    // 3*x+y
   *
   *     const ret = math.rationalize('x+x+x+y',{},true)
   *                   // ret.expression=3*x+y, ret.variables = ["x","y"]
   *     const ret = math.rationalize('-2+5x^2',{},true)
   *                   // ret.expression=5*x^2-2, ret.variables = ["x"], ret.coefficients=[-2,0,5]
   *
   * See also:
   *
   *     simplify
   *
   * @param  {Node|string} expr    The expression to check if is a polynomial expression
   * @param  {Object|boolean}      optional scope of expression or true for already evaluated rational expression at input
   * @param  {Boolean}  detailed   optional True if return an object, false if return expression node (default)
   *
   * @return {Object | Node}    The rational polynomial of `expr` or an object
   *            `{expression, numerator, denominator, variables, coefficients}`, where
   *              `expression` is a `Node` with the node simplified expression,
   *              `numerator` is a `Node` with the simplified numerator of expression,
   *              `denominator` is a `Node` or `boolean` with the simplified denominator or `false` (if there is no denominator),
   *              `variables` is an array with variable names,
   *              and `coefficients` is an array with coefficients of numerator sorted by increased exponent
   *           {Expression Node}  node simplified expression
   *
   */ return typed($01adc6de4444f632$var$name, {
        string: function string(expr) {
            return this(parse(expr), {}, false);
        },
        "string, boolean": function stringBoolean(expr, detailed) {
            return this(parse(expr), {}, detailed);
        },
        "string, Object": function stringObject(expr, scope) {
            return this(parse(expr), scope, false);
        },
        "string, Object, boolean": function stringObjectBoolean(expr, scope, detailed) {
            return this(parse(expr), scope, detailed);
        },
        Node: function Node(expr) {
            return this(expr, {}, false);
        },
        "Node, boolean": function NodeBoolean(expr, detailed) {
            return this(expr, {}, detailed);
        },
        "Node, Object": function NodeObject(expr, scope) {
            return this(expr, scope, false);
        },
        "Node, Object, boolean": function NodeObjectBoolean(expr, scope, detailed) {
            var setRules = rulesRationalize(); // Rules for change polynomial in near canonical form
            var polyRet = polynomial(expr, scope, true, setRules.firstRules); // Check if expression is a rationalizable polynomial
            var nVars = polyRet.variables.length;
            var noExactFractions = {
                exactFractions: false
            };
            var withExactFractions = {
                exactFractions: true
            };
            expr = polyRet.expression;
            if (nVars >= 1) {
                // If expression in not a constant
                expr = expandPower(expr); // First expand power of polynomials (cannot be made from rules!)
                var sBefore; // Previous expression
                var rules;
                var eDistrDiv = true;
                var redoInic = false; // Apply the initial rules, including succ div rules:
                expr = simplify(expr, setRules.firstRules, {}, noExactFractions);
                var s;
                while(true){
                    // Alternate applying successive division rules and distr.div.rules
                    // until there are no more changes:
                    rules = eDistrDiv ? setRules.distrDivRules : setRules.sucDivRules;
                    expr = simplify(expr, rules, {}, withExactFractions);
                    eDistrDiv = !eDistrDiv; // Swap between Distr.Div and Succ. Div. Rules
                    s = expr.toString();
                    if (s === sBefore) break; // No changes : end of the loop
                    redoInic = true;
                    sBefore = s;
                }
                if (redoInic) // Apply first rules again without succ div rules (if there are changes)
                expr = simplify(expr, setRules.firstRulesAgain, {}, noExactFractions);
                 // Apply final rules:
                expr = simplify(expr, setRules.finalRules, {}, noExactFractions);
            } // NVars >= 1
            var coefficients = [];
            var retRationalize = {};
            if (expr.type === "OperatorNode" && expr.isBinary() && expr.op === "/") {
                // Separate numerator from denominator
                if (nVars === 1) {
                    expr.args[0] = polyToCanonical(expr.args[0], coefficients);
                    expr.args[1] = polyToCanonical(expr.args[1]);
                }
                if (detailed) {
                    retRationalize.numerator = expr.args[0];
                    retRationalize.denominator = expr.args[1];
                }
            } else {
                if (nVars === 1) expr = polyToCanonical(expr, coefficients);
                if (detailed) {
                    retRationalize.numerator = expr;
                    retRationalize.denominator = null;
                }
            } // nVars
            if (!detailed) return expr;
            retRationalize.coefficients = coefficients;
            retRationalize.variables = polyRet.variables;
            retRationalize.expression = expr;
            return retRationalize;
        } // ^^^^^^^ end of rationalize ^^^^^^^^
    }); // end of typed rationalize
    /**
   *  Function to simplify an expression using an optional scope and
   *  return it if the expression is a polynomial expression, i.e.
   *  an expression with one or more variables and the operators
   *  +, -, *, and ^, where the exponent can only be a positive integer.
   *
   * Syntax:
   *
   *     polynomial(expr,scope,extended, rules)
   *
   * @param  {Node | string} expr     The expression to simplify and check if is polynomial expression
   * @param  {object} scope           Optional scope for expression simplification
   * @param  {boolean} extended       Optional. Default is false. When true allows divide operator.
   * @param  {array}  rules           Optional. Default is no rule.
   *
   *
   * @return {Object}
   *            {Object} node:   node simplified expression
   *            {Array}  variables:  variable names
   */ function polynomial(expr, scope, extended, rules) {
        var variables = [];
        var node = simplify(expr, rules, scope, {
            exactFractions: false
        }); // Resolves any variables and functions with all defined parameters
        extended = !!extended;
        var oper = "+-*" + (extended ? "/" : "");
        recPoly(node);
        var retFunc = {};
        retFunc.expression = node;
        retFunc.variables = variables;
        return retFunc; // -------------------------------------------------------------------------------------------------------
        /**
     *  Function to simplify an expression using an optional scope and
     *  return it if the expression is a polynomial expression, i.e.
     *  an expression with one or more variables and the operators
     *  +, -, *, and ^, where the exponent can only be a positive integer.
     *
     * Syntax:
     *
     *     recPoly(node)
     *
     *
     * @param  {Node} node               The current sub tree expression in recursion
     *
     * @return                           nothing, throw an exception if error
     */ function recPoly(node) {
            var tp = node.type; // node type
            if (tp === "FunctionNode") // No function call in polynomial expression
            throw new Error("There is an unsolved function call");
            else if (tp === "OperatorNode") {
                if (node.op === "^") {
                    // TODO: handle negative exponents like in '1/x^(-2)'
                    if (node.args[1].type !== "ConstantNode" || !(0, $a03283b133c3c55b$export$a287f47fed4544b8)(parseFloat(node.args[1].value))) throw new Error("There is a non-integer exponent");
                    else recPoly(node.args[0]);
                } else {
                    if (oper.indexOf(node.op) === -1) throw new Error("Operator " + node.op + " invalid in polynomial expression");
                    for(var i = 0; i < node.args.length; i++)recPoly(node.args[i]);
                } // type of operator
            } else if (tp === "SymbolNode") {
                var _name = node.name; // variable name
                var pos = variables.indexOf(_name);
                if (pos === -1) // new variable in expression
                variables.push(_name);
            } else if (tp === "ParenthesisNode") recPoly(node.content);
            else if (tp !== "ConstantNode") throw new Error("type " + tp + " is not allowed in polynomial expression");
        } // end of recPoly
    } // end of polynomial
    // ---------------------------------------------------------------------------------------
    /**
   * Return a rule set to rationalize an polynomial expression in rationalize
   *
   * Syntax:
   *
   *     rulesRationalize()
   *
   * @return {array}        rule set to rationalize an polynomial expression
   */ function rulesRationalize() {
        var oldRules = [
            simplifyCore,
            {
                l: "n+n",
                r: "2*n"
            },
            {
                l: "n+-n",
                r: "0"
            },
            simplifyConstant,
            {
                l: "n*(n1^-1)",
                r: "n/n1"
            },
            {
                l: "n*n1^-n2",
                r: "n/n1^n2"
            },
            {
                l: "n1^-1",
                r: "1/n1"
            },
            {
                l: "n*(n1/n2)",
                r: "(n*n1)/n2"
            },
            {
                l: "1*n",
                r: "n"
            }
        ];
        var rulesFirst = [
            {
                l: "(-n1)/(-n2)",
                r: "n1/n2"
            },
            {
                l: "(-n1)*(-n2)",
                r: "n1*n2"
            },
            {
                l: "n1--n2",
                r: "n1+n2"
            },
            {
                l: "n1-n2",
                r: "n1+(-n2)"
            },
            {
                l: "(n1+n2)*n3",
                r: "(n1*n3 + n2*n3)"
            },
            {
                l: "n1*(n2+n3)",
                r: "(n1*n2+n1*n3)"
            },
            {
                l: "c1*n + c2*n",
                r: "(c1+c2)*n"
            },
            {
                l: "c1*n + n",
                r: "(c1+1)*n"
            },
            {
                l: "c1*n - c2*n",
                r: "(c1-c2)*n"
            },
            {
                l: "c1*n - n",
                r: "(c1-1)*n"
            },
            {
                l: "v/c",
                r: "(1/c)*v"
            },
            {
                l: "v/-c",
                r: "-(1/c)*v"
            },
            {
                l: "-v*-c",
                r: "c*v"
            },
            {
                l: "-v*c",
                r: "-c*v"
            },
            {
                l: "v*-c",
                r: "-c*v"
            },
            {
                l: "v*c",
                r: "c*v"
            },
            {
                l: "-(-n1*n2)",
                r: "(n1*n2)"
            },
            {
                l: "-(n1*n2)",
                r: "(-n1*n2)"
            },
            {
                l: "-(-n1+n2)",
                r: "(n1-n2)"
            },
            {
                l: "-(n1+n2)",
                r: "(-n1-n2)"
            },
            {
                l: "(n1^n2)^n3",
                r: "(n1^(n2*n3))"
            },
            {
                l: "-(-n1/n2)",
                r: "(n1/n2)"
            },
            {
                l: "-(n1/n2)",
                r: "(-n1/n2)"
            }
        ]; // Divisao and Unary
        var rulesDistrDiv = [
            {
                l: "(n1/n2 + n3/n4)",
                r: "((n1*n4 + n3*n2)/(n2*n4))"
            },
            {
                l: "(n1/n2 + n3)",
                r: "((n1 + n3*n2)/n2)"
            },
            {
                l: "(n1 + n2/n3)",
                r: "((n1*n3 + n2)/n3)"
            }
        ]; // Sum fraction with number 1
        var rulesSucDiv = [
            {
                l: "(n1/(n2/n3))",
                r: "((n1*n3)/n2)"
            },
            {
                l: "(n1/n2/n3)",
                r: "(n1/(n2*n3))"
            }
        ];
        var setRules = {}; // rules set in 4 steps.
        // All rules => infinite loop
        // setRules.allRules =oldRules.concat(rulesFirst,rulesDistrDiv,rulesSucDiv)
        setRules.firstRules = oldRules.concat(rulesFirst, rulesSucDiv); // First rule set
        setRules.distrDivRules = rulesDistrDiv; // Just distr. div. rules
        setRules.sucDivRules = rulesSucDiv; // Jus succ. div. rules
        setRules.firstRulesAgain = oldRules.concat(rulesFirst); // Last rules set without succ. div.
        // Division simplification
        // Second rule set.
        // There is no aggregate expression with parentesis, but the only variable can be scattered.
        setRules.finalRules = [
            simplifyCore,
            {
                l: "n*-n",
                r: "-n^2"
            },
            {
                l: "n*n",
                r: "n^2"
            },
            simplifyConstant,
            {
                l: "n*-n^n1",
                r: "-n^(n1+1)"
            },
            {
                l: "n*n^n1",
                r: "n^(n1+1)"
            },
            {
                l: "n^n1*-n^n2",
                r: "-n^(n1+n2)"
            },
            {
                l: "n^n1*n^n2",
                r: "n^(n1+n2)"
            },
            {
                l: "n^n1*-n",
                r: "-n^(n1+1)"
            },
            {
                l: "n^n1*n",
                r: "n^(n1+1)"
            },
            {
                l: "n^n1/-n",
                r: "-n^(n1-1)"
            },
            {
                l: "n^n1/n",
                r: "n^(n1-1)"
            },
            {
                l: "n/-n^n1",
                r: "-n^(1-n1)"
            },
            {
                l: "n/n^n1",
                r: "n^(1-n1)"
            },
            {
                l: "n^n1/-n^n2",
                r: "n^(n1-n2)"
            },
            {
                l: "n^n1/n^n2",
                r: "n^(n1-n2)"
            },
            {
                l: "n1+(-n2*n3)",
                r: "n1-n2*n3"
            },
            {
                l: "v*(-c)",
                r: "-c*v"
            },
            {
                l: "n1+-n2",
                r: "n1-n2"
            },
            {
                l: "v*c",
                r: "c*v"
            },
            {
                l: "(n1^n2)^n3",
                r: "(n1^(n2*n3))"
            } // Power to Power
        ];
        return setRules;
    } // End rulesRationalize
    // ---------------------------------------------------------------------------------------
    /**
   *  Expand recursively a tree node for handling with expressions with exponents
   *  (it's not for constants, symbols or functions with exponents)
   *  PS: The other parameters are internal for recursion
   *
   * Syntax:
   *
   *     expandPower(node)
   *
   * @param  {Node} node         Current expression node
   * @param  {node} parent       Parent current node inside the recursion
   * @param  (int}               Parent number of chid inside the rercursion
   *
   * @return {node}        node expression with all powers expanded.
   */ function expandPower(node, parent, indParent) {
        var tp = node.type;
        var internal = arguments.length > 1; // TRUE in internal calls
        if (tp === "OperatorNode" && node.isBinary()) {
            var does = false;
            var val;
            if (node.op === "^") // First operator: Parenthesis or UnaryMinus
            {
                if ((node.args[0].type === "ParenthesisNode" || node.args[0].type === "OperatorNode") && node.args[1].type === "ConstantNode") {
                    // Second operator: Constant
                    val = parseFloat(node.args[1].value);
                    does = val >= 2 && (0, $a03283b133c3c55b$export$a287f47fed4544b8)(val);
                }
            }
            if (does) {
                // Exponent >= 2
                // Before:
                //            operator A --> Subtree
                // parent pow
                //            constant
                //
                if (val > 2) {
                    // Exponent > 2,
                    // AFTER:  (exponent > 2)
                    //             operator A --> Subtree
                    // parent  *
                    //                 deep clone (operator A --> Subtree
                    //             pow
                    //                 constant - 1
                    //
                    var nEsqTopo = node.args[0];
                    var nDirTopo = new OperatorNode("^", "pow", [
                        node.args[0].cloneDeep(),
                        new ConstantNode(val - 1)
                    ]);
                    node = new OperatorNode("*", "multiply", [
                        nEsqTopo,
                        nDirTopo
                    ]);
                } else // Expo = 2 - no power
                // AFTER:  (exponent =  2)
                //             operator A --> Subtree
                // parent   oper
                //            deep clone (operator A --> Subtree)
                //
                node = new OperatorNode("*", "multiply", [
                    node.args[0],
                    node.args[0].cloneDeep()
                ]);
                if (internal) {
                    // Change parent references in internal recursive calls
                    if (indParent === "content") parent.content = node;
                    else parent.args[indParent] = node;
                }
            } // does
        } // binary OperatorNode
        if (tp === "ParenthesisNode") // Recursion
        expandPower(node.content, node, "content");
        else if (tp !== "ConstantNode" && tp !== "SymbolNode") for(var i = 0; i < node.args.length; i++)expandPower(node.args[i], node, i);
        if (!internal) // return the root node
        return node;
    } // End expandPower
    // ---------------------------------------------------------------------------------------
    /**
   * Auxilary function for rationalize
   * Convert near canonical polynomial in one variable in a canonical polynomial
   * with one term for each exponent in decreasing order
   *
   * Syntax:
   *
   *     polyToCanonical(node [, coefficients])
   *
   * @param  {Node | string} expr       The near canonical polynomial expression to convert in a a canonical polynomial expression
   *
   *        The string or tree expression needs to be at below syntax, with free spaces:
   *         (  (^(-)? | [+-]? )cte (*)? var (^expo)?  | cte )+
   *       Where 'var' is one variable with any valid name
   *             'cte' are real numeric constants with any value. It can be omitted if equal than 1
   *             'expo' are integers greater than 0. It can be omitted if equal than 1.
   *
   * @param  {array}   coefficients             Optional returns coefficients sorted by increased exponent
   *
   *
   * @return {node}        new node tree with one variable polynomial or string error.
   */ function polyToCanonical(node, coefficients) {
        if (coefficients === undefined) coefficients = [];
         // coefficients.
        coefficients[0] = 0; // index is the exponent
        var o = {};
        o.cte = 1;
        o.oper = "+"; // fire: mark with * or ^ when finds * or ^ down tree, reset to "" with + and -.
        //       It is used to deduce the exponent: 1 for *, 0 for "".
        o.fire = "";
        var maxExpo = 0; // maximum exponent
        var varname = ""; // variable name
        recurPol(node, null, o);
        maxExpo = coefficients.length - 1;
        var first = true;
        var no;
        for(var i = maxExpo; i >= 0; i--){
            if (coefficients[i] === 0) continue;
            var n1 = new ConstantNode(first ? coefficients[i] : Math.abs(coefficients[i]));
            var op = coefficients[i] < 0 ? "-" : "+";
            if (i > 0) {
                // Is not a constant without variable
                var n2 = new SymbolNode(varname);
                if (i > 1) {
                    var n3 = new ConstantNode(i);
                    n2 = new OperatorNode("^", "pow", [
                        n2,
                        n3
                    ]);
                }
                if (coefficients[i] === -1 && first) n1 = new OperatorNode("-", "unaryMinus", [
                    n2
                ]);
                else if (Math.abs(coefficients[i]) === 1) n1 = n2;
                else n1 = new OperatorNode("*", "multiply", [
                    n1,
                    n2
                ]);
            }
            if (first) no = n1;
            else if (op === "+") no = new OperatorNode("+", "add", [
                no,
                n1
            ]);
            else no = new OperatorNode("-", "subtract", [
                no,
                n1
            ]);
            first = false;
        } // for
        if (first) return new ConstantNode(0);
        else return no;
        /**
     * Recursive auxilary function inside polyToCanonical for
     * converting expression in canonical form
     *
     * Syntax:
     *
     *     recurPol(node, noPai, obj)
     *
     * @param  {Node} node        The current subpolynomial expression
     * @param  {Node | Null}  noPai   The current parent node
     * @param  {object}    obj        Object with many internal flags
     *
     * @return {}                    No return. If error, throws an exception
     */ function recurPol(node, noPai, o) {
            var tp = node.type;
            if (tp === "FunctionNode") // ***** FunctionName *****
            // No function call in polynomial expression
            throw new Error("There is an unsolved function call");
            else if (tp === "OperatorNode") {
                // ***** OperatorName *****
                if ("+-*^".indexOf(node.op) === -1) throw new Error("Operator " + node.op + " invalid");
                if (noPai !== null) {
                    // -(unary),^  : children of *,+,-
                    if ((node.fn === "unaryMinus" || node.fn === "pow") && noPai.fn !== "add" && noPai.fn !== "subtract" && noPai.fn !== "multiply") throw new Error("Invalid " + node.op + " placing");
                     // -,+,* : children of +,-
                    if ((node.fn === "subtract" || node.fn === "add" || node.fn === "multiply") && noPai.fn !== "add" && noPai.fn !== "subtract") throw new Error("Invalid " + node.op + " placing");
                     // -,+ : first child
                    if ((node.fn === "subtract" || node.fn === "add" || node.fn === "unaryMinus") && o.noFil !== 0) throw new Error("Invalid " + node.op + " placing");
                } // Has parent
                // Firers: ^,*       Old:   ^,&,-(unary): firers
                if (node.op === "^" || node.op === "*") o.fire = node.op;
                for(var _i = 0; _i < node.args.length; _i++){
                    // +,-: reset fire
                    if (node.fn === "unaryMinus") o.oper = "-";
                    if (node.op === "+" || node.fn === "subtract") {
                        o.fire = "";
                        o.cte = 1; // default if there is no constant
                        o.oper = _i === 0 ? "+" : node.op;
                    }
                    o.noFil = _i; // number of son
                    recurPol(node.args[_i], node, o);
                } // for in children
            } else if (tp === "SymbolNode") {
                // ***** SymbolName *****
                if (node.name !== varname && varname !== "") throw new Error("There is more than one variable");
                varname = node.name;
                if (noPai === null) {
                    coefficients[1] = 1;
                    return;
                } // ^: Symbol is First child
                if (noPai.op === "^" && o.noFil !== 0) throw new Error("In power the variable should be the first parameter");
                 // *: Symbol is Second child
                if (noPai.op === "*" && o.noFil !== 1) throw new Error("In multiply the variable should be the second parameter");
                 // Symbol: firers '',* => it means there is no exponent above, so it's 1 (cte * var)
                if (o.fire === "" || o.fire === "*") {
                    if (maxExpo < 1) coefficients[1] = 0;
                    coefficients[1] += o.cte * (o.oper === "+" ? 1 : -1);
                    maxExpo = Math.max(1, maxExpo);
                }
            } else if (tp === "ConstantNode") {
                var valor = parseFloat(node.value);
                if (noPai === null) {
                    coefficients[0] = valor;
                    return;
                }
                if (noPai.op === "^") {
                    // cte: second  child of power
                    if (o.noFil !== 1) throw new Error("Constant cannot be powered");
                    if (!(0, $a03283b133c3c55b$export$a287f47fed4544b8)(valor) || valor <= 0) throw new Error("Non-integer exponent is not allowed");
                    for(var _i2 = maxExpo + 1; _i2 < valor; _i2++)coefficients[_i2] = 0;
                    if (valor > maxExpo) coefficients[valor] = 0;
                    coefficients[valor] += o.cte * (o.oper === "+" ? 1 : -1);
                    maxExpo = Math.max(valor, maxExpo);
                    return;
                }
                o.cte = valor; // Cte: firer '' => There is no exponent and no multiplication, so the exponent is 0.
                if (o.fire === "") coefficients[0] += o.cte * (o.oper === "+" ? 1 : -1);
            } else throw new Error("Type " + tp + " is not allowed");
        } // End of recurPol
    } // End of polyToCanonical
});






var $0bbf0a3d26e75a69$var$name = "RelationalNode";
var $0bbf0a3d26e75a69$var$dependencies = [
    "Node"
];
var $0bbf0a3d26e75a69$export$92a3c2dff1e32f25 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($0bbf0a3d26e75a69$var$name, $0bbf0a3d26e75a69$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    /**
   * A node representing a chained conditional expression, such as 'x > y > z'
   *
   * @param {String[]} conditionals   An array of conditional operators used to compare the parameters
   * @param {Node[]} params   The parameters that will be compared
   *
   * @constructor RelationalNode
   * @extends {Node}
   */ function RelationalNode(conditionals, params) {
        if (!(this instanceof RelationalNode)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!Array.isArray(conditionals)) throw new TypeError("Parameter conditionals must be an array");
        if (!Array.isArray(params)) throw new TypeError("Parameter params must be an array");
        if (conditionals.length !== params.length - 1) throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");
        this.conditionals = conditionals;
        this.params = params;
    }
    RelationalNode.prototype = new Node();
    RelationalNode.prototype.type = "RelationalNode";
    RelationalNode.prototype.isRelationalNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ RelationalNode.prototype._compile = function(math, argNames) {
        var self = this;
        var compiled = this.params.map((p)=>p._compile(math, argNames));
        return function evalRelationalNode(scope, args, context) {
            var evalLhs;
            var evalRhs = compiled[0](scope, args, context);
            for(var i = 0; i < self.conditionals.length; i++){
                evalLhs = evalRhs;
                evalRhs = compiled[i + 1](scope, args, context);
                var condFn = (0, $49d1ac263f403507$export$87a87648a1961976)(math, self.conditionals[i]);
                if (!condFn(evalLhs, evalRhs)) return false;
            }
            return true;
        };
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ RelationalNode.prototype.forEach = function(callback) {
        this.params.forEach((n, i)=>callback(n, "params[" + i + "]", this), this);
    };
    /**
   * Create a new RelationalNode having its childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node): Node} callback
   * @returns {RelationalNode} Returns a transformed copy of the node
   */ RelationalNode.prototype.map = function(callback) {
        return new RelationalNode(this.conditionals.slice(), this.params.map((n, i)=>this._ifNode(callback(n, "params[" + i + "]", this)), this));
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {RelationalNode}
   */ RelationalNode.prototype.clone = function() {
        return new RelationalNode(this.conditionals, this.params);
    };
    /**
   * Get string representation.
   * @param {Object} options
   * @return {string} str
   */ RelationalNode.prototype._toString = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(this, parenthesis);
        var paramStrings = this.params.map(function(p, index) {
            var paramPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(p, parenthesis);
            return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? "(" + p.toString(options) + ")" : p.toString(options);
        });
        var operatorMap = {
            equal: "==",
            unequal: "!=",
            smaller: "<",
            larger: ">",
            smallerEq: "<=",
            largerEq: ">="
        };
        var ret = paramStrings[0];
        for(var i = 0; i < this.conditionals.length; i++)ret += " " + operatorMap[this.conditionals[i]] + " " + paramStrings[i + 1];
        return ret;
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ RelationalNode.prototype.toJSON = function() {
        return {
            mathjs: "RelationalNode",
            conditionals: this.conditionals,
            params: this.params
        };
    };
    /**
   * Instantiate a RelationalNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "RelationalNode", "condition": ..., "trueExpr": ..., "falseExpr": ...}`,
   *                       where mathjs is optional
   * @returns {RelationalNode}
   */ RelationalNode.fromJSON = function(json) {
        return new RelationalNode(json.conditionals, json.params);
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   */ RelationalNode.prototype.toHTML = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(this, parenthesis);
        var paramStrings = this.params.map(function(p, index) {
            var paramPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(p, parenthesis);
            return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + p.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : p.toHTML(options);
        });
        var operatorMap = {
            equal: "==",
            unequal: "!=",
            smaller: "<",
            larger: ">",
            smallerEq: "<=",
            largerEq: ">="
        };
        var ret = paramStrings[0];
        for(var i = 0; i < this.conditionals.length; i++)ret += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(operatorMap[this.conditionals[i]]) + "</span>" + paramStrings[i + 1];
        return ret;
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   */ RelationalNode.prototype._toTex = function(options) {
        var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
        var precedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(this, parenthesis);
        var paramStrings = this.params.map(function(p, index) {
            var paramPrecedence = (0, $d7d1ac259ad9d921$export$94314bea1477f3d5)(p, parenthesis);
            return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? "\\left(" + p.toTex(options) + "\right)" : p.toTex(options);
        });
        var ret = paramStrings[0];
        for(var i = 0; i < this.conditionals.length; i++)ret += (0, $22194b07116816cc$export$c728a46e4168cd75)[this.conditionals[i]] + paramStrings[i + 1];
        return ret;
    };
    return RelationalNode;
}, {
    isClass: true,
    isNode: true
});




var $43e83069b9938162$var$name = "resolve";
var $43e83069b9938162$var$dependencies = [
    "parse",
    "ConstantNode",
    "FunctionNode",
    "OperatorNode",
    "ParenthesisNode"
];
var $43e83069b9938162$export$de059f4622c7c2ca = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($43e83069b9938162$var$name, $43e83069b9938162$var$dependencies, (_ref)=>{
    var { parse: parse, ConstantNode: ConstantNode, FunctionNode: FunctionNode, OperatorNode: OperatorNode, ParenthesisNode: ParenthesisNode } = _ref;
    /**
   * resolve(expr, scope) replaces variable nodes with their scoped values
   *
   * Syntax:
   *
   *     resolve(expr, scope)
   *
   * Examples:
   *
   *     math.resolve('x + y', {x:1, y:2})           // Node {1 + 2}
   *     math.resolve(math.parse('x+y'), {x:1, y:2}) // Node {1 + 2}
   *     math.simplify('x+y', {x:2, y:'x+x'}).toString()      // "6"
   *
   * See also:
   *
   *     simplify, evaluate
   *
   * @param {Node | Node[]} node
   *     The expression tree (or trees) to be simplified
   * @param {Object} scope
   *     Scope specifying variables to be resolved
   * @return {Node | Node[]} Returns `node` with variables recursively substituted.
   * @throws {ReferenceError}
   *     If there is a cyclic dependency among the variables in `scope`,
   *     resolution is impossible and a ReferenceError is thrown.
   */ function resolve(node, scope) {
        var within = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();
        // note `within`:
        // `within` is not documented, since it is for internal cycle
        // detection only
        if (!scope) return node;
        if (!(0, $8f2e3669195c8ad5$export$5c90113a285f2241)(scope)) scope = (0, $8f2e3669195c8ad5$export$d49c9aa30b771d59)(scope);
        if ((0, $2c4f948f17aa2240$export$87815d550facaed9)(node)) {
            if (within.has(node.name)) {
                var variables = Array.from(within).join(", ");
                throw new ReferenceError("recursive loop of variable definitions among {".concat(variables, "}"));
            }
            var value = scope.get(node.name);
            if ((0, $2c4f948f17aa2240$export$8ee0fc9ee280b4ee)(value)) {
                var nextWithin = new Set(within);
                nextWithin.add(node.name);
                return resolve(value, scope, nextWithin);
            } else if (typeof value === "number") return parse(String(value));
            else if (value !== undefined) return new ConstantNode(value);
            else return node;
        } else if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(node)) {
            var args = node.args.map(function(arg) {
                return resolve(arg, scope, within);
            });
            return new OperatorNode(node.op, node.fn, args, node.implicit);
        } else if ((0, $2c4f948f17aa2240$export$c55e3736c5721220)(node)) return new ParenthesisNode(resolve(node.content, scope, within));
        else if ((0, $2c4f948f17aa2240$export$6ae03b16e064e6c4)(node)) {
            var _args = node.args.map(function(arg) {
                return resolve(arg, scope, within);
            });
            return new FunctionNode(node.name, _args);
        } // Otherwise just recursively resolve any children (might also work
        // for some of the above special cases)
        return node.map((child)=>resolve(child, scope, within));
    }
    return resolve;
});


var $5b5c30457a5d4ee4$var$name = "reviver";
var $5b5c30457a5d4ee4$var$dependencies = [
    "classes"
];
var $5b5c30457a5d4ee4$export$288f43fef560974b = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($5b5c30457a5d4ee4$var$name, $5b5c30457a5d4ee4$var$dependencies, (_ref)=>{
    var { classes: classes } = _ref;
    /**
   * Instantiate mathjs data types from their JSON representation
   * @param {string} key
   * @param {*} value
   * @returns {*} Returns the revived object
   */ return function reviver(key, value) {
        var constructor = classes[value && value.mathjs];
        if (constructor && typeof constructor.fromJSON === "function") return constructor.fromJSON(value);
        return value;
    };
});





var $ebaf1bcbb4af801e$var$name = "row";
var $ebaf1bcbb4af801e$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $ebaf1bcbb4af801e$export$649101a1e7f0c38d = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($ebaf1bcbb4af801e$var$name, $ebaf1bcbb4af801e$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    var row = (0, $1d936a877a324b9b$export$3442c5d213434705)({
        typed: typed,
        Index: Index,
        matrix: matrix,
        range: range
    }); // @see: comment of row itself
    return typed("row", {
        "...any": function any(args) {
            // change last argument from zero-based to one-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $2c4f948f17aa2240$export$7e4aa119212bc614)(last)) args[lastIndex] = last - 1;
            try {
                return row.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});







var $d45bbe3b21890957$var$name = "simplify";
var $d45bbe3b21890957$var$dependencies = [
    "config",
    "typed",
    "parse",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "isZero",
    "equal",
    "resolve",
    "simplifyCore",
    "?fraction",
    "?bignumber",
    "mathWithTransform",
    "matrix",
    "AccessorNode",
    "ArrayNode",
    "ConstantNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "ParenthesisNode",
    "SymbolNode"
];
var $d45bbe3b21890957$export$5085b3a4c8276699 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d45bbe3b21890957$var$name, $d45bbe3b21890957$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, parse: parse, add: add, subtract: subtract, multiply: multiply, divide: divide, pow: pow, isZero: isZero, equal: equal, resolve: resolve, simplifyCore: simplifyCore, fraction: fraction, bignumber: bignumber, mathWithTransform: mathWithTransform, matrix: matrix, AccessorNode: AccessorNode, ArrayNode: ArrayNode, ConstantNode: ConstantNode, FunctionNode: FunctionNode, IndexNode: IndexNode, ObjectNode: ObjectNode, OperatorNode: OperatorNode, ParenthesisNode: ParenthesisNode, SymbolNode: SymbolNode } = _ref;
    var simplifyConstant = (0, $6b8561cb89789184$export$d72b8f0d2b277ae2)({
        typed: typed,
        config: config,
        mathWithTransform: mathWithTransform,
        matrix: matrix,
        fraction: fraction,
        bignumber: bignumber,
        AccessorNode: AccessorNode,
        ArrayNode: ArrayNode,
        ConstantNode: ConstantNode,
        FunctionNode: FunctionNode,
        IndexNode: IndexNode,
        ObjectNode: ObjectNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    });
    var { hasProperty: hasProperty, isCommutative: isCommutative, isAssociative: isAssociative, mergeContext: mergeContext, flatten: flatten, unflattenr: unflattenr, unflattenl: unflattenl, createMakeNodeFunction: createMakeNodeFunction, defaultContext: defaultContext, realContext: realContext, positiveContext: positiveContext } = (0, $cc6b879c4ae1b0e9$export$f2206d57cebf291a)({
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    });
    /**
   * Simplify an expression tree.
   *
   * A list of rules are applied to an expression, repeating over the list until
   * no further changes are made.
   * It's possible to pass a custom set of rules to the function as second
   * argument. A rule can be specified as an object, string, or function:
   *
   *     const rules = [
   *       { l: 'n1*n3 + n2*n3', r: '(n1+n2)*n3' },
   *       'n1*n3 + n2*n3 -> (n1+n2)*n3',
   *       function (node) {
   *         // ... return a new node or return the node unchanged
   *         return node
   *       }
   *     ]
   *
   * String and object rules consist of a left and right pattern. The left is
   * used to match against the expression and the right determines what matches
   * are replaced with. The main difference between a pattern and a normal
   * expression is that variables starting with the following characters are
   * interpreted as wildcards:
   *
   * - 'n' - matches any Node
   * - 'c' - matches any ConstantNode
   * - 'v' - matches any Node that is not a ConstantNode
   *
   * The default list of rules is exposed on the function as `simplify.rules`
   * and can be used as a basis to built a set of custom rules.
   *
   * To specify a rule as a string, separate the left and right pattern by '->'
   * When specifying a rule as an object, the following keys are meaningful:
   * - l - the left pattern
   * - r - the right pattern
   * - s - in lieu of l and r, the string form that is broken at -> to give them
   * - repeat - whether to repeat this rule until the expression stabilizes
   * - assuming - gives a context object, as in the 'context' option to
   *     simplify. Every property in the context object must match the current
   *     context in order, or else the rule will not be applied.
   * - imposeContext - gives a context object, as in the 'context' option to
   *     simplify. Any settings specified will override the incoming context
   *     for all matches of this rule.
   *
   * For more details on the theory, see:
   *
   * - [Strategies for simplifying math expressions (Stackoverflow)](https://stackoverflow.com/questions/7540227/strategies-for-simplifying-math-expressions)
   * - [Symbolic computation - Simplification (Wikipedia)](https://en.wikipedia.org/wiki/Symbolic_computation#Simplification)
   *
   *  An optional `options` argument can be passed as last argument of `simplify`.
   *  Currently available options (defaults in parentheses):
   *  - `consoleDebug` (false): whether to write the expression being simplified
   *    and any changes to it, along with the rule responsible, to console
   *  - `context` (simplify.defaultContext): an object giving properties of
   *    each operator, which determine what simplifications are allowed. The
   *    currently meaningful properties are commutative, associative,
   *    total (whether the operation is defined for all arguments), and
   *    trivial (whether the operation applied to a single argument leaves
   *    that argument unchanged). The default context is very permissive and
   *    allows almost all simplifications. Only properties differing from
   *    the default need to be specified; the default context is used as a
   *    fallback. Additional contexts `simplify.realContext` and
   *    `simplify.positiveContext` are supplied to cause simplify to perform
   *    just simplifications guaranteed to preserve all values of the expression
   *    assuming all variables and subexpressions are real numbers or
   *    positive real numbers, respectively. (Note that these are in some cases
   *    more restrictive than the default context; for example, the default
   *    context will allow `x/x` to simplify to 1, whereas
   *    `simplify.realContext` will not, as `0/0` is not equal to 1.)
   *  - `exactFractions` (true): whether to try to convert all constants to
   *    exact rational numbers.
   *  - `fractionsLimit` (10000): when `exactFractions` is true, constants will
   *    be expressed as fractions only when both numerator and denominator
   *    are smaller than `fractionsLimit`.
   *
   * Syntax:
   *
   *     simplify(expr)
   *     simplify(expr, rules)
   *     simplify(expr, rules)
   *     simplify(expr, rules, scope)
   *     simplify(expr, rules, scope, options)
   *     simplify(expr, scope)
   *     simplify(expr, scope, options)
   *
   * Examples:
   *
   *     math.simplify('2 * 1 * x ^ (2 - 1)')      // Node "2 * x"
   *     math.simplify('2 * 3 * x', {x: 4})        // Node "24"
   *     const f = math.parse('2 * 1 * x ^ (2 - 1)')
   *     math.simplify(f)                          // Node "2 * x"
   *     math.simplify('0.4 * x', {}, {exactFractions: true})  // Node "x * 2 / 5"
   *     math.simplify('0.4 * x', {}, {exactFractions: false}) // Node "0.4 * x"
   *
   * See also:
   *
   *     simplifyCore, derivative, evaluate, parse, rationalize, resolve
   *
   * @param {Node | string} expr
   *            The expression to be simplified
   * @param {Array<{l:string, r: string} | string | function>} [rules]
   *            Optional list with custom rules
   * @return {Node} Returns the simplified form of `expr`
   */ var simplify = typed("simplify", {
        string: function string(expr) {
            return this(parse(expr), this.rules, (0, $8f2e3669195c8ad5$export$89a4bcaf5b4d37d2)(), {});
        },
        "string, Map | Object": function stringMapObject(expr, scope) {
            return this(parse(expr), this.rules, scope, {});
        },
        "string, Map | Object, Object": function stringMapObjectObject(expr, scope, options) {
            return this(parse(expr), this.rules, scope, options);
        },
        "string, Array": function stringArray(expr, rules) {
            return this(parse(expr), rules, (0, $8f2e3669195c8ad5$export$89a4bcaf5b4d37d2)(), {});
        },
        "string, Array, Map | Object": function stringArrayMapObject(expr, rules, scope) {
            return this(parse(expr), rules, scope, {});
        },
        "string, Array, Map | Object, Object": function stringArrayMapObjectObject(expr, rules, scope, options) {
            return this(parse(expr), rules, scope, options);
        },
        "Node, Map | Object": function NodeMapObject(expr, scope) {
            return this(expr, this.rules, scope, {});
        },
        "Node, Map | Object, Object": function NodeMapObjectObject(expr, scope, options) {
            return this(expr, this.rules, scope, options);
        },
        Node: function Node(expr) {
            return this(expr, this.rules, (0, $8f2e3669195c8ad5$export$89a4bcaf5b4d37d2)(), {});
        },
        "Node, Array": function NodeArray(expr, rules) {
            return this(expr, rules, (0, $8f2e3669195c8ad5$export$89a4bcaf5b4d37d2)(), {});
        },
        "Node, Array, Map | Object": function NodeArrayMapObject(expr, rules, scope) {
            return this(expr, rules, scope, {});
        },
        "Node, Array, Object, Object": function NodeArrayObjectObject(expr, rules, scope, options) {
            return this(expr, rules, (0, $8f2e3669195c8ad5$export$d49c9aa30b771d59)(scope), options);
        },
        "Node, Array, Map, Object": function NodeArrayMapObject(expr, rules, scope, options) {
            var debug = options.consoleDebug;
            rules = _buildRules(rules, options.context);
            var res = resolve(expr, scope);
            res = removeParens(res);
            var visited = {};
            var str = res.toString({
                parenthesis: "all"
            });
            while(!visited[str]){
                visited[str] = true;
                _lastsym = 0; // counter for placeholder symbols
                var laststr = str;
                if (debug) console.log("Working on: ", str);
                for(var i = 0; i < rules.length; i++){
                    var rulestr = "";
                    if (typeof rules[i] === "function") {
                        res = rules[i](res, options);
                        if (debug) rulestr = rules[i].name;
                    } else {
                        flatten(res, options.context);
                        res = applyRule(res, rules[i], options.context);
                        if (debug) rulestr = "".concat(rules[i].l.toString(), " -> ").concat(rules[i].r.toString());
                    }
                    if (debug) {
                        var newstr = res.toString({
                            parenthesis: "all"
                        });
                        if (newstr !== laststr) {
                            console.log("Applying", rulestr, "produced", newstr);
                            laststr = newstr;
                        }
                    }
                    /* Use left-heavy binary tree internally,
           * since custom rule functions may expect it
           */ unflattenl(res, options.context);
                }
                str = res.toString({
                    parenthesis: "all"
                });
            }
            return res;
        }
    });
    simplify.defaultContext = defaultContext;
    simplify.realContext = realContext;
    simplify.positiveContext = positiveContext;
    function removeParens(node) {
        return node.transform(function(node, path, parent) {
            return (0, $2c4f948f17aa2240$export$c55e3736c5721220)(node) ? removeParens(node.content) : node;
        });
    } // All constants that are allowed in rules
    var SUPPORTED_CONSTANTS = {
        true: true,
        false: true,
        e: true,
        i: true,
        Infinity: true,
        LN2: true,
        LN10: true,
        LOG2E: true,
        LOG10E: true,
        NaN: true,
        phi: true,
        pi: true,
        SQRT1_2: true,
        SQRT2: true,
        tau: true // null: false,
    }; // Array of strings, used to build the ruleSet.
    // Each l (left side) and r (right side) are parsed by
    // the expression parser into a node tree.
    // Left hand sides are matched to subtrees within the
    // expression to be parsed and replaced with the right
    // hand side.
    // TODO: Add support for constraints on constants (either in the form of a '=' expression or a callback [callback allows things like comparing symbols alphabetically])
    // To evaluate lhs constants for rhs constants, use: { l: 'c1+c2', r: 'c3', evaluate: 'c3 = c1 + c2' }. Multiple assignments are separated by ';' in block format.
    // It is possible to get into an infinite loop with conflicting rules
    simplify.rules = [
        simplifyCore,
        // { l: 'n^0', r: '1' },     // simplifyCore
        // { l: '0*n', r: '0' },     // simplifyCore
        // { l: 'n/n', r: '1'},      // simplifyCore
        // { l: 'n^1', r: 'n' },     // simplifyCore
        // { l: '+n1', r:'n1' },     // simplifyCore
        // { l: 'n--n1', r:'n+n1' }, // simplifyCore
        {
            l: "log(e)",
            r: "1"
        },
        // Note initially we tend constants to the right because like-term
        // collection prefers the left, and we would rather collect nonconstants
        {
            s: "n-n1 -> n+-n1",
            // temporarily replace 'subtract' so we can further flatten the 'add' operator
            assuming: {
                subtract: {
                    total: true
                }
            }
        },
        {
            s: "n-n -> 0",
            // partial alternative when we can't always subtract
            assuming: {
                subtract: {
                    total: false
                }
            }
        },
        {
            s: "-(c*v) -> v * (-c)",
            // make non-constant terms positive
            assuming: {
                multiply: {
                    commutative: true
                },
                subtract: {
                    total: true
                }
            }
        },
        {
            s: "-(c*v) -> (-c) * v",
            // non-commutative version, part 1
            assuming: {
                multiply: {
                    commutative: false
                },
                subtract: {
                    total: true
                }
            }
        },
        {
            s: "-(v*c) -> v * (-c)",
            // non-commutative version, part 2
            assuming: {
                multiply: {
                    commutative: false
                },
                subtract: {
                    total: true
                }
            }
        },
        {
            l: "-(n1/n2)",
            r: "-n1/n2"
        },
        {
            l: "-v",
            r: "v * (-1)"
        },
        {
            l: "(n1 + n2)*(-1)",
            r: "n1*(-1) + n2*(-1)",
            repeat: true
        },
        {
            l: "n/n1^n2",
            r: "n*n1^-n2"
        },
        {
            l: "n/n1",
            r: "n*n1^-1"
        },
        {
            s: "(n1*n2)^n3 -> n1^n3 * n2^n3",
            assuming: {
                multiply: {
                    commutative: true
                }
            }
        },
        {
            s: "(n1*n2)^(-1) -> n2^(-1) * n1^(-1)",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        {
            s: "(n ^ n1) ^ n2 -> n ^ (n1 * n2)",
            assuming: {
                divide: {
                    total: true
                }
            } // 1/(1/n) = n needs 1/n to exist
        },
        {
            l: " v   * ( v   * n1 + n2)",
            r: "v^2       * n1 +  v   * n2"
        },
        {
            s: " v   * (v^n4 * n1 + n2)   ->  v^(1+n4)  * n1 +  v   * n2",
            assuming: {
                divide: {
                    total: true
                }
            } // v*1/v = v^(1+-1) needs 1/v
        },
        {
            s: "v^n3 * ( v   * n1 + n2)   ->  v^(n3+1)  * n1 + v^n3 * n2",
            assuming: {
                divide: {
                    total: true
                }
            }
        },
        {
            s: "v^n3 * (v^n4 * n1 + n2)   ->  v^(n3+n4) * n1 + v^n3 * n2",
            assuming: {
                divide: {
                    total: true
                }
            }
        },
        {
            l: "n*n",
            r: "n^2"
        },
        {
            s: "n * n^n1 -> n^(n1+1)",
            assuming: {
                divide: {
                    total: true
                }
            } // n*1/n = n^(-1+1) needs 1/n
        },
        {
            s: "n^n1 * n^n2 -> n^(n1+n2)",
            assuming: {
                divide: {
                    total: true
                }
            } // ditto for n^2*1/n^2
        },
        // becomes necessary to simplify constants twice per pass. It's not
        // terribly expensive compared to matching rules, so this should not
        // pose a performance problem.
        simplifyConstant,
        // collect like terms
        {
            s: "n+n -> 2*n",
            assuming: {
                add: {
                    total: true
                }
            } // 2 = 1 + 1 needs to exist
        },
        {
            l: "n+-n",
            r: "0"
        },
        {
            l: "v*n + v",
            r: "v*(n+1)"
        },
        {
            l: "n3*n1 + n3*n2",
            r: "n3*(n1+n2)"
        },
        {
            l: "n3^(-n4)*n1 +   n3  * n2",
            r: "n3^(-n4)*(n1 + n3^(n4+1) *n2)"
        },
        {
            l: "n3^(-n4)*n1 + n3^n5 * n2",
            r: "n3^(-n4)*(n1 + n3^(n4+n5)*n2)"
        },
        {
            s: "n*v + v -> (n+1)*v",
            // noncommutative additional cases
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        {
            s: "n1*n3 + n2*n3 -> (n1+n2)*n3",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        {
            s: "n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        {
            s: "n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        {
            l: "n*c + c",
            r: "(n+1)*c"
        },
        {
            s: "c*n + c -> c*(n+1)",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        simplifyConstant,
        // make factors positive (and undo 'make non-constant terms positive')
        {
            s: "(-n)*n1 -> -(n*n1)",
            assuming: {
                subtract: {
                    total: true
                }
            }
        },
        {
            s: "n1*(-n) -> -(n1*n)",
            // in case * non-commutative
            assuming: {
                subtract: {
                    total: true
                },
                multiply: {
                    commutative: false
                }
            }
        },
        {
            s: "c+v -> v+c",
            assuming: {
                add: {
                    commutative: true
                }
            },
            imposeContext: {
                add: {
                    commutative: false
                }
            }
        },
        {
            s: "v*c -> c*v",
            assuming: {
                multiply: {
                    commutative: true
                }
            },
            imposeContext: {
                multiply: {
                    commutative: false
                }
            }
        },
        // { l: '(-1) * n', r: '-n' }, // #811 added test which proved this is redundant
        {
            l: "n+-n1",
            r: "n-n1"
        },
        {
            s: "n*(n1^-1) -> n/n1",
            // undo replace 'divide'; for * commutative
            assuming: {
                multiply: {
                    commutative: true
                }
            } // o.w. / not conventional
        },
        {
            s: "n*n1^-n2 -> n/n1^n2",
            assuming: {
                multiply: {
                    commutative: true
                }
            } // o.w. / not conventional
        },
        {
            s: "n^-1 -> 1/n",
            assuming: {
                multiply: {
                    commutative: true
                }
            } // o.w. / not conventional
        },
        {
            l: "n^1",
            r: "n"
        },
        {
            s: "n*(n1/n2) -> (n*n1)/n2",
            // '*' before '/'
            assuming: {
                multiply: {
                    associative: true
                }
            }
        },
        {
            s: "n-(n1+n2) -> n-n1-n2",
            // '-' before '+'
            assuming: {
                addition: {
                    associative: true,
                    commutative: true
                }
            }
        },
        // { l: '(n*n1)/(n*n2)', r: 'n1/n2' },
        // simplifyConstant can leave an extra factor of 1, which can always
        // be eliminated, since the identity always commutes
        {
            l: "1*n",
            r: "n",
            imposeContext: {
                multiply: {
                    commutative: true
                }
            }
        },
        {
            s: "n1/(n2/n3) -> (n1*n3)/n2",
            assuming: {
                multiply: {
                    associative: true
                }
            }
        },
        {
            l: "n1/(-n2)",
            r: "-n1/n2"
        }
    ];
    /**
   * Takes any rule object as allowed by the specification in simplify
   * and puts it in a standard form used by applyRule
   */ function _canonicalizeRule(ruleObject, context) {
        var newRule = {};
        if (ruleObject.s) {
            var lr = ruleObject.s.split("->");
            if (lr.length === 2) {
                newRule.l = lr[0];
                newRule.r = lr[1];
            } else throw SyntaxError("Could not parse rule: " + ruleObject.s);
        } else {
            newRule.l = ruleObject.l;
            newRule.r = ruleObject.r;
        }
        newRule.l = removeParens(parse(newRule.l));
        newRule.r = removeParens(parse(newRule.r));
        for (var prop of [
            "imposeContext",
            "repeat",
            "assuming"
        ])if (prop in ruleObject) newRule[prop] = ruleObject[prop];
        if (ruleObject.evaluate) newRule.evaluate = parse(ruleObject.evaluate);
        if (isAssociative(newRule.l, context)) {
            var makeNode = createMakeNodeFunction(newRule.l);
            var expandsym = _getExpandPlaceholderSymbol();
            newRule.expanded = {};
            newRule.expanded.l = makeNode([
                newRule.l.clone(),
                expandsym
            ]); // Push the expandsym into the deepest possible branch.
            // This helps to match the newRule against nodes returned from getSplits() later on.
            flatten(newRule.expanded.l, context);
            unflattenr(newRule.expanded.l, context);
            newRule.expanded.r = makeNode([
                newRule.r,
                expandsym
            ]);
        }
        return newRule;
    }
    /**
   * Parse the string array of rules into nodes
   *
   * Example syntax for rules:
   *
   * Position constants to the left in a product:
   * { l: 'n1 * c1', r: 'c1 * n1' }
   * n1 is any Node, and c1 is a ConstantNode.
   *
   * Apply difference of squares formula:
   * { l: '(n1 - n2) * (n1 + n2)', r: 'n1^2 - n2^2' }
   * n1, n2 mean any Node.
   *
   * Short hand notation:
   * 'n1 * c1 -> c1 * n1'
   */ function _buildRules(rules, context) {
        // Array of rules to be used to simplify expressions
        var ruleSet = [];
        for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var newRule = void 0;
            var ruleType = typeof rule;
            switch(ruleType){
                case "string":
                    rule = {
                        s: rule
                    };
                /* falls through */ case "object":
                    newRule = _canonicalizeRule(rule, context);
                    break;
                case "function":
                    newRule = rule;
                    break;
                default:
                    throw TypeError("Unsupported type of rule: " + ruleType);
            } // console.log('Adding rule: ' + rules[i])
            // console.log(newRule)
            ruleSet.push(newRule);
        }
        return ruleSet;
    }
    var _lastsym = 0;
    function _getExpandPlaceholderSymbol() {
        return new SymbolNode("_p" + _lastsym++);
    }
    function mapRule(nodes, rule, context) {
        var resNodes = nodes;
        if (nodes) for(var i = 0; i < nodes.length; ++i){
            var newNode = applyRule(nodes[i], rule, context);
            if (newNode !== nodes[i]) {
                if (resNodes === nodes) resNodes = nodes.slice();
                resNodes[i] = newNode;
            }
        }
        return resNodes;
    }
    /**
   * Returns a simplfied form of node, or the original node if no simplification was possible.
   *
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param  {Object | Function} rule
   * @param  {Object} context -- information about assumed properties of operators
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} The simplified form of `expr`, or the original node if no simplification was possible.
   */ function applyRule(node, rule, context) {
        //    console.log('Entering applyRule("', rule.l.toString({parenthesis:'all'}), '->', rule.r.toString({parenthesis:'all'}), '",', node.toString({parenthesis:'all'}),')')
        // check that the assumptions for this rule are satisfied by the current
        // context:
        if (rule.assuming) {
            for(var symbol in rule.assuming)for(var property in rule.assuming[symbol]){
                if (hasProperty(symbol, property, context) !== rule.assuming[symbol][property]) return node;
            }
        }
        var mergedContext = mergeContext(rule.imposeContext, context); // Do not clone node unless we find a match
        var res = node; // First replace our child nodes with their simplified versions
        // If a child could not be simplified, applying the rule to it
        // will have no effect since the node is returned unchanged
        if (res instanceof OperatorNode || res instanceof FunctionNode) {
            var newArgs = mapRule(res.args, rule, context);
            if (newArgs !== res.args) {
                res = res.clone();
                res.args = newArgs;
            }
        } else if (res instanceof ParenthesisNode) {
            if (res.content) {
                var newContent = applyRule(res.content, rule, context);
                if (newContent !== res.content) res = new ParenthesisNode(newContent);
            }
        } else if (res instanceof ArrayNode) {
            var newItems = mapRule(res.items, rule, context);
            if (newItems !== res.items) res = new ArrayNode(newItems);
        } else if (res instanceof AccessorNode) {
            var newObj = res.object;
            if (res.object) newObj = applyRule(res.object, rule, context);
            var newIndex = res.index;
            if (res.index) newIndex = applyRule(res.index, rule, context);
            if (newObj !== res.object || newIndex !== res.index) res = new AccessorNode(newObj, newIndex);
        } else if (res instanceof IndexNode) {
            var newDims = mapRule(res.dimensions, rule, context);
            if (newDims !== res.dimensions) res = new IndexNode(newDims);
        } else if (res instanceof ObjectNode) {
            var changed = false;
            var newProps = {};
            for(var prop in res.properties){
                newProps[prop] = applyRule(res.properties[prop], rule, context);
                if (newProps[prop] !== res.properties[prop]) changed = true;
            }
            if (changed) res = new ObjectNode(newProps);
        } // Try to match a rule against this node
        var repl = rule.r;
        var matches = _ruleMatch(rule.l, res, mergedContext)[0]; // If the rule is associative operator, we can try matching it while allowing additional terms.
        // This allows us to match rules like 'n+n' to the expression '(1+x)+x' or even 'x+1+x' if the operator is commutative.
        if (!matches && rule.expanded) {
            repl = rule.expanded.r;
            matches = _ruleMatch(rule.expanded.l, res, mergedContext)[0];
        }
        if (matches) {
            // const before = res.toString({parenthesis: 'all'})
            // Create a new node by cloning the rhs of the matched rule
            // we keep any implicit multiplication state if relevant
            var implicit = res.implicit;
            res = repl.clone();
            if (implicit && "implicit" in repl) res.implicit = true;
             // Replace placeholders with their respective nodes without traversing deeper into the replaced nodes
            res = res.transform(function(node) {
                if (node.isSymbolNode && (0, $33619877a15996ac$export$5a15a386532a5ea4)(matches.placeholders, node.name)) return matches.placeholders[node.name].clone();
                else return node;
            }); // const after = res.toString({parenthesis: 'all'})
        // console.log('Simplified ' + before + ' to ' + after)
        }
        if (rule.repeat && res !== node) res = applyRule(res, rule, context);
        return res;
    }
    /**
   * Get (binary) combinations of a flattened binary node
   * e.g. +(node1, node2, node3) -> [
   *        +(node1,  +(node2, node3)),
   *        +(node2,  +(node1, node3)),
   *        +(node3,  +(node1, node2))]
   *
   */ function getSplits(node, context) {
        var res = [];
        var right, rightArgs;
        var makeNode = createMakeNodeFunction(node);
        if (isCommutative(node, context)) for(var i = 0; i < node.args.length; i++){
            rightArgs = node.args.slice(0);
            rightArgs.splice(i, 1);
            right = rightArgs.length === 1 ? rightArgs[0] : makeNode(rightArgs);
            res.push(makeNode([
                node.args[i],
                right
            ]));
        }
        else // Keep order, but try all parenthesizations
        for(var _i = 1; _i < node.args.length; _i++){
            var left = node.args[0];
            if (_i > 1) left = makeNode(node.args.slice(0, _i));
            rightArgs = node.args.slice(_i);
            right = rightArgs.length === 1 ? rightArgs[0] : makeNode(rightArgs);
            res.push(makeNode([
                left,
                right
            ]));
        }
        return res;
    }
    /**
   * Returns the set union of two match-placeholders or null if there is a conflict.
   */ function mergeMatch(match1, match2) {
        var res = {
            placeholders: {}
        }; // Some matches may not have placeholders; this is OK
        if (!match1.placeholders && !match2.placeholders) return res;
        else if (!match1.placeholders) return match2;
        else if (!match2.placeholders) return match1;
         // Placeholders with the same key must match exactly
        for(var key in match1.placeholders)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(match1.placeholders, key)) {
            res.placeholders[key] = match1.placeholders[key];
            if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(match2.placeholders, key)) {
                if (!_exactMatch(match1.placeholders[key], match2.placeholders[key])) return null;
            }
        }
        for(var _key in match2.placeholders)if ((0, $33619877a15996ac$export$5a15a386532a5ea4)(match2.placeholders, _key)) res.placeholders[_key] = match2.placeholders[_key];
        return res;
    }
    /**
   * Combine two lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
   * Each list represents matches found in one child of a node.
   */ function combineChildMatches(list1, list2) {
        var res = [];
        if (list1.length === 0 || list2.length === 0) return res;
        var merged;
        for(var i1 = 0; i1 < list1.length; i1++)for(var i2 = 0; i2 < list2.length; i2++){
            merged = mergeMatch(list1[i1], list2[i2]);
            if (merged) res.push(merged);
        }
        return res;
    }
    /**
   * Combine multiple lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
   * Each list represents matches found in one child of a node.
   * Returns a list of unique matches.
   */ function mergeChildMatches(childMatches) {
        if (childMatches.length === 0) return childMatches;
        var sets = childMatches.reduce(combineChildMatches);
        var uniqueSets = [];
        var unique = {};
        for(var i = 0; i < sets.length; i++){
            var s = JSON.stringify(sets[i]);
            if (!unique[s]) {
                unique[s] = true;
                uniqueSets.push(sets[i]);
            }
        }
        return uniqueSets;
    }
    /**
   * Determines whether node matches rule.
   *
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} rule
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param {Object} context -- provides assumed properties of operators
   * @param {Boolean} isSplit -- whether we are in process of splitting an
   *                    n-ary operator node into possible binary combinations.
   *                    Defaults to false.
   * @return {Object} Information about the match, if it exists.
   */ function _ruleMatch(rule, node, context, isSplit) {
        //    console.log('Entering _ruleMatch(' + JSON.stringify(rule) + ', ' + JSON.stringify(node) + ')')
        //    console.log('rule = ' + rule)
        //    console.log('node = ' + node)
        //    console.log('Entering _ruleMatch(', rule.toString({parenthesis:'all'}), ', ', node.toString({parenthesis:'all'}), ', ', context, ')')
        var res = [
            {
                placeholders: {}
            }
        ];
        if (rule instanceof OperatorNode && node instanceof OperatorNode || rule instanceof FunctionNode && node instanceof FunctionNode) {
            // If the rule is an OperatorNode or a FunctionNode, then node must match exactly
            if (rule instanceof OperatorNode) {
                if (rule.op !== node.op || rule.fn !== node.fn) return [];
            } else if (rule instanceof FunctionNode) {
                if (rule.name !== node.name) return [];
            } // rule and node match. Search the children of rule and node.
            if (node.args.length === 1 && rule.args.length === 1 || !isAssociative(node, context) && node.args.length === rule.args.length || isSplit) {
                // Expect non-associative operators to match exactly,
                // except in any order if operator is commutative
                var childMatches = [];
                for(var i = 0; i < rule.args.length; i++){
                    var childMatch = _ruleMatch(rule.args[i], node.args[i], context);
                    if (childMatch.length === 0) break;
                     // The child matched, so add the information returned from the child to our result
                    childMatches.push(childMatch);
                }
                if (childMatches.length !== rule.args.length) {
                    if (!isCommutative(node, context) || // exact match in order needed
                    rule.args.length === 1) // nothing to commute
                    return [];
                    if (rule.args.length > 2) /* Need to generate all permutations and try them.
             * It's a bit complicated, and unlikely to come up since there
             * are very few ternary or higher operators. So punt for now.
             */ throw new Error("permuting >2 commutative non-associative rule arguments not yet implemented");
                    /* Exactly two arguments, try them reversed */ var leftMatch = _ruleMatch(rule.args[0], node.args[1], context);
                    if (leftMatch.length === 0) return [];
                    var rightMatch = _ruleMatch(rule.args[1], node.args[0], context);
                    if (rightMatch.length === 0) return [];
                    childMatches = [
                        leftMatch,
                        rightMatch
                    ];
                }
                res = mergeChildMatches(childMatches);
            } else if (node.args.length >= 2 && rule.args.length === 2) {
                // node is flattened, rule is not
                // Associative operators/functions can be split in different ways so we check if the rule matches each
                // them and return their union.
                var splits = getSplits(node, context);
                var splitMatches = [];
                for(var _i2 = 0; _i2 < splits.length; _i2++){
                    var matchSet = _ruleMatch(rule, splits[_i2], context, true); // recursing at the same tree depth here
                    splitMatches = splitMatches.concat(matchSet);
                }
                return splitMatches;
            } else if (rule.args.length > 2) throw Error("Unexpected non-binary associative function: " + rule.toString());
            else // Incorrect number of arguments in rule and node, so no match
            return [];
        } else if (rule instanceof SymbolNode) {
            // If the rule is a SymbolNode, then it carries a special meaning
            // according to the first character of the symbol node name.
            // c.* matches a ConstantNode
            // n.* matches any node
            if (rule.name.length === 0) throw new Error("Symbol in rule has 0 length...!?");
            if (SUPPORTED_CONSTANTS[rule.name]) {
                // built-in constant must match exactly
                if (rule.name !== node.name) return [];
            } else if (rule.name[0] === "n" || rule.name.substring(0, 2) === "_p") // rule matches _anything_, so assign this node to the rule.name placeholder
            // Assign node to the rule.name placeholder.
            // Our parent will check for matches among placeholders.
            res[0].placeholders[rule.name] = node;
            else if (rule.name[0] === "v") {
                // rule matches any variable thing (not a ConstantNode)
                if (!(0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(node)) res[0].placeholders[rule.name] = node;
                else // Mis-match: rule was expecting something other than a ConstantNode
                return [];
            } else if (rule.name[0] === "c") {
                // rule matches any ConstantNode
                if (node instanceof ConstantNode) res[0].placeholders[rule.name] = node;
                else // Mis-match: rule was expecting a ConstantNode
                return [];
            } else throw new Error("Invalid symbol in rule: " + rule.name);
        } else if (rule instanceof ConstantNode) {
            // Literal constant must match exactly
            if (!equal(rule.value, node.value)) return [];
        } else // Some other node was encountered which we aren't prepared for, so no match
        return [];
         // It's a match!
        // console.log('_ruleMatch(' + rule.toString() + ', ' + node.toString() + ') found a match')
        return res;
    }
    /**
   * Determines whether p and q (and all their children nodes) are identical.
   *
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} p
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} q
   * @return {Object} Information about the match, if it exists.
   */ function _exactMatch(p, q) {
        if (p instanceof ConstantNode && q instanceof ConstantNode) {
            if (!equal(p.value, q.value)) return false;
        } else if (p instanceof SymbolNode && q instanceof SymbolNode) {
            if (p.name !== q.name) return false;
        } else if (p instanceof OperatorNode && q instanceof OperatorNode || p instanceof FunctionNode && q instanceof FunctionNode) {
            if (p instanceof OperatorNode) {
                if (p.op !== q.op || p.fn !== q.fn) return false;
            } else if (p instanceof FunctionNode) {
                if (p.name !== q.name) return false;
            }
            if (p.args.length !== q.args.length) return false;
            for(var i = 0; i < p.args.length; i++){
                if (!_exactMatch(p.args[i], q.args[i])) return false;
            }
        } else return false;
        return true;
    }
    return simplify;
});




var $95e9a6ac60ba274b$var$name = "simplifyCore";
var $95e9a6ac60ba274b$var$dependencies = [
    "equal",
    "isZero",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "AccessorNode",
    "ArrayNode",
    "ConstantNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "ParenthesisNode",
    "SymbolNode"
];
var $95e9a6ac60ba274b$export$c3d7d520703291df = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($95e9a6ac60ba274b$var$name, $95e9a6ac60ba274b$var$dependencies, (_ref)=>{
    var { equal: equal, isZero: isZero, add: add, subtract: subtract, multiply: multiply, divide: divide, pow: pow, AccessorNode: AccessorNode, ArrayNode: ArrayNode, ConstantNode: ConstantNode, FunctionNode: FunctionNode, IndexNode: IndexNode, ObjectNode: ObjectNode, OperatorNode: OperatorNode, ParenthesisNode: ParenthesisNode, SymbolNode: SymbolNode } = _ref;
    var node0 = new ConstantNode(0);
    var node1 = new ConstantNode(1);
    var { hasProperty: hasProperty, isCommutative: isCommutative } = (0, $cc6b879c4ae1b0e9$export$f2206d57cebf291a)({
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    });
    /**
   * simplifyCore() performs single pass simplification suitable for
   * applications requiring ultimate performance. In contrast, simplify()
   * extends simplifyCore() with additional passes to provide deeper
   * simplification.
   *
   * Syntax:
   *
   *     simplifyCore(expr)
   *
   * Examples:
   *
   *     const f = math.parse('2 * 1 * x ^ (2 - 1)')
   *     math.simpifyCore(f)                          // Node {2 * x}
   *     math.simplify('2 * 1 * x ^ (2 - 1)', [math.simplifyCore]) // Node {2 * x}
   *
   * See also:
   *
   *     simplify, resolve, derivative
   *
   * @param {Node} node
   *     The expression to be simplified
   * @param {Object} options
   *     Simplification options, as per simplify()
   * @return {Node} Returns expression with basic simplifications applied
   */ function simplifyCore(node, options) {
        var context = options ? options.context : undefined;
        if (hasProperty(node, "trivial", context)) {
            // This node does nothing if it has only one argument, so if so,
            // return that argument simplified
            if ((0, $2c4f948f17aa2240$export$6ae03b16e064e6c4)(node) && node.args.length === 1) return simplifyCore(node.args[0], options);
             // For other node types, we try the generic methods
            var simpChild = false;
            var childCount = 0;
            node.forEach((c)=>{
                ++childCount;
                if (childCount === 1) simpChild = simplifyCore(c, options);
            });
            if (childCount === 1) return simpChild;
        }
        if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(node) && node.isUnary()) {
            var a0 = simplifyCore(node.args[0], options);
            if (node.op === "-") {
                // unary minus
                if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(a0)) {
                    if (a0.isUnary() && a0.op === "-") return a0.args[0];
                    else if (a0.isBinary() && a0.fn === "subtract") return new OperatorNode("-", "subtract", [
                        a0.args[1],
                        a0.args[0]
                    ]);
                }
                return new OperatorNode(node.op, node.fn, [
                    a0
                ]);
            }
        } else if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(node) && node.isBinary()) {
            var _a = simplifyCore(node.args[0], options);
            var a1 = simplifyCore(node.args[1], options);
            if (node.op === "+") {
                if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(_a)) {
                    if (isZero(_a.value)) return a1;
                    else if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(a1)) return new ConstantNode(add(_a.value, a1.value));
                }
                if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(a1) && isZero(a1.value)) return _a;
                if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(a1) && a1.isUnary() && a1.op === "-") return new OperatorNode("-", "subtract", [
                    _a,
                    a1.args[0]
                ]);
                return new OperatorNode(node.op, node.fn, a1 ? [
                    _a,
                    a1
                ] : [
                    _a
                ]);
            } else if (node.op === "-") {
                if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(_a) && a1) {
                    if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(a1)) return new ConstantNode(subtract(_a.value, a1.value));
                    else if (isZero(_a.value)) return new OperatorNode("-", "unaryMinus", [
                        a1
                    ]);
                } // if (node.fn === "subtract" && node.args.length === 2) {
                if (node.fn === "subtract") {
                    if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(a1) && isZero(a1.value)) return _a;
                    if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(a1) && a1.isUnary() && a1.op === "-") return simplifyCore(new OperatorNode("+", "add", [
                        _a,
                        a1.args[0]
                    ]), options);
                    return new OperatorNode(node.op, node.fn, [
                        _a,
                        a1
                    ]);
                }
            } else if (node.op === "*") {
                if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(_a)) {
                    if (isZero(_a.value)) return node0;
                    else if (equal(_a.value, 1)) return a1;
                    else if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(a1)) return new ConstantNode(multiply(_a.value, a1.value));
                }
                if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(a1)) {
                    if (isZero(a1.value)) return node0;
                    else if (equal(a1.value, 1)) return _a;
                    else if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(_a) && _a.isBinary() && _a.op === node.op && isCommutative(node, context)) {
                        var a00 = _a.args[0];
                        if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(a00)) {
                            var a00a1 = new ConstantNode(multiply(a00.value, a1.value));
                            return new OperatorNode(node.op, node.fn, [
                                a00a1,
                                _a.args[1]
                            ], node.implicit); // constants on left
                        }
                    }
                    if (isCommutative(node, context)) return new OperatorNode(node.op, node.fn, [
                        a1,
                        _a
                    ], node.implicit); // constants on left
                    else return new OperatorNode(node.op, node.fn, [
                        _a,
                        a1
                    ], node.implicit);
                }
                return new OperatorNode(node.op, node.fn, [
                    _a,
                    a1
                ], node.implicit);
            } else if (node.op === "/") {
                if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(_a)) {
                    if (isZero(_a.value)) return node0;
                    else if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(a1) && (equal(a1.value, 1) || equal(a1.value, 2) || equal(a1.value, 4))) return new ConstantNode(divide(_a.value, a1.value));
                }
                return new OperatorNode(node.op, node.fn, [
                    _a,
                    a1
                ]);
            } else if (node.op === "^") {
                if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(a1)) {
                    if (isZero(a1.value)) return node1;
                    else if (equal(a1.value, 1)) return _a;
                    else {
                        if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(_a)) // fold constant
                        return new ConstantNode(pow(_a.value, a1.value));
                        else if ((0, $2c4f948f17aa2240$export$7e624cbaab6cce94)(_a) && _a.isBinary() && _a.op === "^") {
                            var a01 = _a.args[1];
                            if ((0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(a01)) return new OperatorNode(node.op, node.fn, [
                                _a.args[0],
                                new ConstantNode(multiply(a01.value, a1.value))
                            ]);
                        }
                    }
                }
            }
            return new OperatorNode(node.op, node.fn, [
                _a,
                a1
            ]);
        } else if ((0, $2c4f948f17aa2240$export$6ae03b16e064e6c4)(node)) return new FunctionNode(simplifyCore(node.fn), node.args.map((n)=>simplifyCore(n, options)));
        else if ((0, $2c4f948f17aa2240$export$440fa93dcf2757a3)(node)) return new ArrayNode(node.items.map((n)=>simplifyCore(n, options)));
        else if ((0, $2c4f948f17aa2240$export$f88fb19d6b9ee5cb)(node)) return new AccessorNode(simplifyCore(node.object, options), simplifyCore(node.index, options));
        else if ((0, $2c4f948f17aa2240$export$ff90979121a6cabc)(node)) return new IndexNode(node.dimensions.map((n)=>simplifyCore(n, options)));
        else if ((0, $2c4f948f17aa2240$export$3f18867a334658e9)(node)) {
            var newProps = {};
            for(var prop in node.properties)newProps[prop] = simplifyCore(node.properties[prop], options);
            return new ObjectNode(newProps);
        }
        return node;
    }
    return simplifyCore;
});





var $061d235b829fb888$var$name = "std";
var $061d235b829fb888$var$dependencies = [
    "typed",
    "sqrt",
    "variance"
];
var $061d235b829fb888$export$ef5049c11f391200 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($061d235b829fb888$var$name, $061d235b829fb888$var$dependencies, (_ref)=>{
    var { typed: typed, sqrt: sqrt, variance: variance } = _ref;
    var std = (0, $33589fdb3f464f29$export$d3f0a8dda5df7afd)({
        typed: typed,
        sqrt: sqrt,
        variance: variance
    });
    return typed("std", {
        "...any": function any(args) {
            args = (0, $cae718b9f1559ea4$export$75974926bb7e1bd6)(args);
            try {
                return std.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});




var $d423dd8c57bef047$var$name = "subset";
var $d423dd8c57bef047$var$dependencies = [
    "typed",
    "matrix"
];
var $d423dd8c57bef047$export$3dd4e26b0ef52fd5 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($d423dd8c57bef047$var$name, $d423dd8c57bef047$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    var subset = (0, $6bf0a697d4bb28ee$export$d8c56e74d683bb33)({
        typed: typed,
        matrix: matrix
    });
    /**
   * Attach a transform function to math.subset
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */ return typed("subset", {
        "...any": function any(args) {
            try {
                return subset.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});





/**
 * Attach a transform function to math.sum
 * Adds a property transform containing the transform function.
 *
 * This transform changed the last `dim` parameter of function sum
 * from one-based to zero based
 */ var $1ba3b6c4bcc19d3d$var$name = "sum";
var $1ba3b6c4bcc19d3d$var$dependencies = [
    "typed",
    "config",
    "add",
    "numeric"
];
var $1ba3b6c4bcc19d3d$export$1b9b65ea533d42ec = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($1ba3b6c4bcc19d3d$var$name, $1ba3b6c4bcc19d3d$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, add: add, numeric: numeric } = _ref;
    var sum = (0, $583973e5c597423f$export$14d444d810bc35b5)({
        typed: typed,
        config: config,
        add: add,
        numeric: numeric
    });
    return typed($1ba3b6c4bcc19d3d$var$name, {
        "...any": function any(args) {
            args = (0, $cae718b9f1559ea4$export$75974926bb7e1bd6)(args);
            try {
                return sum.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});



var $b64ba096b5789b9d$var$name = "symbolicEqual";
var $b64ba096b5789b9d$var$dependencies = [
    "parse",
    "simplify",
    "typed",
    "OperatorNode"
];
var $b64ba096b5789b9d$export$ac8cd7544d2e68af = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b64ba096b5789b9d$var$name, $b64ba096b5789b9d$var$dependencies, (_ref)=>{
    var { parse: parse, simplify: simplify, typed: typed, OperatorNode: OperatorNode } = _ref;
    /**
   * Attempts to determine if two expressions are symbolically equal, i.e.
   * one is the result of valid algebraic manipulations on the other.
   * Currently, this simply checks if the difference of the two expressions
   * simplifies down to 0. So there are two important caveats:
   * 1. whether two expressions are symbolically equal depends on the
   *     manipulations allowed. Therefore, this function takes an optional
   *     third argument, which are the options that control the behavior
   *     as documented for the `simplify()` function.
   * 2. it is in general intractable to find the minimal simplification of
   *     an arbitrarily complicated expression. So while a `true` value
   *     of `symbolicEqual` ensures that the two expressions can be manipulated
   *     to match each other, a `false` value does not absolutely rule this out.
   *
   * Syntax:
   *
   *    symbolicEqual(expr1, expr2)
   *    symbolicEqual(expr1, expr2, options)
   *
   * Examples:
   *
   *    symbolicEqual('x*y', 'y*x') // true
   *    symbolicEqual('x*y', 'y*x', {context: {multiply: {commutative: false}}})
   *        //false
   *    symbolicEqual('x/y', '(y*x^(-1))^(-1)') // true
   *    symbolicEqual('abs(x)','x') // false
   *    symbolicEqual('abs(x)','x', simplify.positiveContext) // true
   *
   * See also:
   *
   *    simplify, evaluate
   *
   * @param {Node|string} expr1  The first expression to compare
   * @param {Node|string} expr2  The second expression to compare
   * @param {Object} [options] Optional option object, passed to simplify
   * @returns {boolean}
   *     Returns true if a valid manipulation making the expressions equal
   *     is found.
   */ return typed($b64ba096b5789b9d$var$name, {
        "string, string": function stringString(s1, s2) {
            return this(parse(s1), parse(s2), {});
        },
        "string, string, Object": function stringStringObject(s1, s2, options) {
            return this(parse(s1), parse(s2), options);
        },
        "Node, string": function NodeString(e1, s2) {
            return this(e1, parse(s2), {});
        },
        "Node, string, Object": function NodeStringObject(e1, s2, options) {
            return this(e1, parse(s2), options);
        },
        "string, Node": function stringNode(s1, e2) {
            return this(parse(s1), e2, {});
        },
        "string, Node, Object": function stringNodeObject(s1, e2, options) {
            return this(parse(s1), e2, options);
        },
        "Node, Node": function NodeNode(e1, e2) {
            return this(e1, e2, {});
        },
        "Node, Node, Object": function NodeNodeObject(e1, e2, options) {
            var diff = new OperatorNode("-", "subtract", [
                e1,
                e2
            ]);
            var simplified = simplify(diff, {}, options);
            return (0, $2c4f948f17aa2240$export$fa9d80731fd8c54b)(simplified) && !simplified.value;
        }
    });
});





var $b478beee86cd2144$var$name = "SymbolNode";
var $b478beee86cd2144$var$dependencies = [
    "math",
    "?Unit",
    "Node"
];
var $b478beee86cd2144$export$b9e0005fc35ab4ee = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($b478beee86cd2144$var$name, $b478beee86cd2144$var$dependencies, (_ref)=>{
    var { math: math, Unit: Unit, Node: Node } = _ref;
    /**
   * Check whether some name is a valueless unit like "inch".
   * @param {string} name
   * @return {boolean}
   */ function isValuelessUnit(name) {
        return Unit ? Unit.isValuelessUnit(name) : false;
    }
    /**
   * @constructor SymbolNode
   * @extends {Node}
   * A symbol node can hold and resolve a symbol
   * @param {string} name
   * @extends {Node}
   */ function SymbolNode(name) {
        if (!(this instanceof SymbolNode)) throw new SyntaxError("Constructor must be called with the new operator");
         // validate input
        if (typeof name !== "string") throw new TypeError('String expected for parameter "name"');
        this.name = name;
    }
    SymbolNode.prototype = new Node();
    SymbolNode.prototype.type = "SymbolNode";
    SymbolNode.prototype.isSymbolNode = true;
    /**
   * Compile a node into a JavaScript function.
   * This basically pre-calculates as much as possible and only leaves open
   * calculations which depend on a dynamic scope with variables.
   * @param {Object} math     Math.js namespace with functions and constants.
   * @param {Object} argNames An object with argument names as key and `true`
   *                          as value. Used in the SymbolNode to optimize
   *                          for arguments from user assigned functions
   *                          (see FunctionAssignmentNode) or special symbols
   *                          like `end` (see IndexNode).
   * @return {function} Returns a function which can be called like:
   *                        evalNode(scope: Object, args: Object, context: *)
   */ SymbolNode.prototype._compile = function(math, argNames) {
        var name = this.name;
        if (argNames[name] === true) // this is a FunctionAssignment argument
        // (like an x when inside the expression of a function assignment `f(x) = ...`)
        return function(scope, args, context) {
            return args[name];
        };
        else if (name in math) return function(scope, args, context) {
            return scope.has(name) ? scope.get(name) : (0, $49d1ac263f403507$export$87a87648a1961976)(math, name);
        };
        else {
            var isUnit = isValuelessUnit(name);
            return function(scope, args, context) {
                return scope.has(name) ? scope.get(name) : isUnit ? new Unit(null, name) : SymbolNode.onUndefinedSymbol(name);
            };
        }
    };
    /**
   * Execute a callback for each of the child nodes of this node
   * @param {function(child: Node, path: string, parent: Node)} callback
   */ SymbolNode.prototype.forEach = function(callback) {};
    /**
   * Create a new SymbolNode having it's childs be the results of calling
   * the provided callback function for each of the childs of the original node.
   * @param {function(child: Node, path: string, parent: Node) : Node} callback
   * @returns {SymbolNode} Returns a clone of the node
   */ SymbolNode.prototype.map = function(callback) {
        return this.clone();
    };
    /**
   * Throws an error 'Undefined symbol {name}'
   * @param {string} name
   */ SymbolNode.onUndefinedSymbol = function(name) {
        throw new Error("Undefined symbol " + name);
    };
    /**
   * Create a clone of this node, a shallow copy
   * @return {SymbolNode}
   */ SymbolNode.prototype.clone = function() {
        return new SymbolNode(this.name);
    };
    /**
   * Get string representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ SymbolNode.prototype._toString = function(options) {
        return this.name;
    };
    /**
   * Get HTML representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ SymbolNode.prototype.toHTML = function(options) {
        var name = (0, $addf7cb66573d3e4$export$4e7f196112fea3c5)(this.name);
        if (name === "true" || name === "false") return '<span class="math-symbol math-boolean">' + name + "</span>";
        else if (name === "i") return '<span class="math-symbol math-imaginary-symbol">' + name + "</span>";
        else if (name === "Infinity") return '<span class="math-symbol math-infinity-symbol">' + name + "</span>";
        else if (name === "NaN") return '<span class="math-symbol math-nan-symbol">' + name + "</span>";
        else if (name === "null") return '<span class="math-symbol math-null-symbol">' + name + "</span>";
        else if (name === "undefined") return '<span class="math-symbol math-undefined-symbol">' + name + "</span>";
        return '<span class="math-symbol">' + name + "</span>";
    };
    /**
   * Get a JSON representation of the node
   * @returns {Object}
   */ SymbolNode.prototype.toJSON = function() {
        return {
            mathjs: "SymbolNode",
            name: this.name
        };
    };
    /**
   * Instantiate a SymbolNode from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SymbolNode", name: "x"}`,
   *                       where mathjs is optional
   * @returns {SymbolNode}
   */ SymbolNode.fromJSON = function(json) {
        return new SymbolNode(json.name);
    };
    /**
   * Get LaTeX representation
   * @param {Object} options
   * @return {string} str
   * @override
   */ SymbolNode.prototype._toTex = function(options) {
        var isUnit = false;
        if (typeof math[this.name] === "undefined" && isValuelessUnit(this.name)) isUnit = true;
        var symbol = (0, $22194b07116816cc$export$358d3bb1a752ff)(this.name, isUnit);
        if (symbol[0] === "\\") // no space needed if the symbol starts with '\'
        return symbol;
         // the space prevents symbols from breaking stuff like '\cdot' if it's written right before the symbol
        return " " + symbol;
    };
    return SymbolNode;
}, {
    isClass: true,
    isNode: true
});





var $f8d7ada6bf4c4fee$var$name = "variance";
var $f8d7ada6bf4c4fee$var$dependencies = [
    "typed",
    "add",
    "subtract",
    "multiply",
    "divide",
    "apply",
    "isNaN"
];
var $f8d7ada6bf4c4fee$export$8ab5ca08ecd18ef3 = /* #__PURE__ */ (0, $a671619231063c2b$export$e9008f2713103c6c)($f8d7ada6bf4c4fee$var$name, $f8d7ada6bf4c4fee$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, subtract: subtract, multiply: multiply, divide: divide, apply: apply, isNaN: isNaN } = _ref;
    var variance = (0, $b421b520bfd774f5$export$b989221824390fb)({
        typed: typed,
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide,
        apply: apply,
        isNaN: isNaN
    });
    return typed($f8d7ada6bf4c4fee$var$name, {
        "...any": function any(args) {
            args = (0, $cae718b9f1559ea4$export$75974926bb7e1bd6)(args);
            try {
                return variance.apply(null, args);
            } catch (err) {
                throw (0, $97c8cd33ff544df3$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});




var $991c91e6b5fb711c$var$math = {}; // NOT pure!
var $991c91e6b5fb711c$var$mathWithTransform = {}; // NOT pure!
var $991c91e6b5fb711c$var$classes = {}; // NOT pure!
var $991c91e6b5fb711c$export$f18d5acc27d70423 = (0, $7e7f3b826c23b8f3$export$1aeed9ab2df4999f)({
    math: $991c91e6b5fb711c$var$math
});
var $991c91e6b5fb711c$export$85c928794f8d04d4 = (0, $7203aed697a91fec$export$270e7ba5936d3c48)({
    mathWithTransform: $991c91e6b5fb711c$var$mathWithTransform
});
var $991c91e6b5fb711c$export$b70fa93b5fbdd997 = (0, $0b74ddc820daba2d$export$385a7f4e27f173c4)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4
});
var $991c91e6b5fb711c$export$cd498840ad265e90 = (0, $69acbf3fe056b32b$export$aa95756bacab93d)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4
});
var $991c91e6b5fb711c$export$dbdb6279b6a3bac9 = (0, $c79c9cb7e0cc15cd$export$9bf5d3d4ef922b0c)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4
});
var $991c91e6b5fb711c$export$a4d9a8de1ded3461 = (0, $0bbf0a3d26e75a69$export$92a3c2dff1e32f25)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4
});
var $991c91e6b5fb711c$export$97d96bf9b84874d5 = (0, $d8ba1e5320d3cb4e$export$c4666c772dc9bece)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4
});
var $991c91e6b5fb711c$export$ec7b1e3e36733ff3 = (0, $0f6b6cbc53ffa55b$export$850df8ca0896c9ef)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4,
    ResultSet: $bed779fa205b8d7c$export$aebd5179ff543a90
});
var $991c91e6b5fb711c$export$8e402c64e6081013 = (0, $0dc403e718746947$export$401636051e48ab09)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4
});
var $991c91e6b5fb711c$export$3166e8715d58cf9a = (0, $a602ad0b51d0eff3$export$70fc17189bb5117e)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4
});
var $991c91e6b5fb711c$export$d0e9917d83c120a0 = (0, $5d69aff0d81b70dc$export$fb6d9b21e29b8d46)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4
});
var $991c91e6b5fb711c$export$63698c10df99509c = (0, $5b5c30457a5d4ee4$export$288f43fef560974b)({
    classes: $991c91e6b5fb711c$var$classes
});
var $991c91e6b5fb711c$export$e08e3b67e392101e = (0, $76b9737e120ccd28$export$3ffb1c732bc8392d)({
    Chain: $991c91e6b5fb711c$export$f18d5acc27d70423,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $991c91e6b5fb711c$export$446a68c3fb943f17 = (0, $1c442fe04a879094$export$fd037c04876b4924)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $991c91e6b5fb711c$export$c3248ebc7ade74c5 = (0, $ae7194b0850e3794$export$a21116b1766eb74)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71
});
var $991c91e6b5fb711c$export$a144098e31f7b52f = (0, $6fb89c3e33c5b9bd$export$1461ecd49f170d54)({
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71
});
var $991c91e6b5fb711c$export$929eaad981940a63 = (0, $8a470f3913d2f9eb$export$883b7fdc0499e9f0)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4,
    size: $bed779fa205b8d7c$export$346677f925de839c
});
var $991c91e6b5fb711c$export$93b6424aaa42dda7 = (0, $b478beee86cd2144$export$b9e0005fc35ab4ee)({
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4,
    math: $991c91e6b5fb711c$var$math
});
var $991c91e6b5fb711c$export$f2972be796679c12 = (0, $d43db709575d9e16$export$d03e7338a74cdf4c)({
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4,
    SymbolNode: $991c91e6b5fb711c$export$93b6424aaa42dda7,
    math: $991c91e6b5fb711c$var$math
});
var $991c91e6b5fb711c$export$98e6a39c04603d36 = (0, $47bf1b9390b2e8b5$export$fef7a8850e50b7)({
    AccessorNode: $991c91e6b5fb711c$export$c3248ebc7ade74c5,
    ArrayNode: $991c91e6b5fb711c$export$97d96bf9b84874d5,
    AssignmentNode: $991c91e6b5fb711c$export$a144098e31f7b52f,
    BlockNode: $991c91e6b5fb711c$export$ec7b1e3e36733ff3,
    ConditionalNode: $991c91e6b5fb711c$export$8e402c64e6081013,
    ConstantNode: $991c91e6b5fb711c$export$3166e8715d58cf9a,
    FunctionAssignmentNode: $991c91e6b5fb711c$export$446a68c3fb943f17,
    FunctionNode: $991c91e6b5fb711c$export$f2972be796679c12,
    IndexNode: $991c91e6b5fb711c$export$929eaad981940a63,
    ObjectNode: $991c91e6b5fb711c$export$b70fa93b5fbdd997,
    OperatorNode: $991c91e6b5fb711c$export$cd498840ad265e90,
    ParenthesisNode: $991c91e6b5fb711c$export$dbdb6279b6a3bac9,
    RangeNode: $991c91e6b5fb711c$export$d0e9917d83c120a0,
    RelationalNode: $991c91e6b5fb711c$export$a4d9a8de1ded3461,
    SymbolNode: $991c91e6b5fb711c$export$93b6424aaa42dda7,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    numeric: $bed779fa205b8d7c$export$b7a508fa8dae59fc,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $991c91e6b5fb711c$export$f7ad0328861e2f03 = (0, $43e83069b9938162$export$de059f4622c7c2ca)({
    ConstantNode: $991c91e6b5fb711c$export$3166e8715d58cf9a,
    FunctionNode: $991c91e6b5fb711c$export$f2972be796679c12,
    OperatorNode: $991c91e6b5fb711c$export$cd498840ad265e90,
    ParenthesisNode: $991c91e6b5fb711c$export$dbdb6279b6a3bac9,
    parse: $991c91e6b5fb711c$export$98e6a39c04603d36
});
var $991c91e6b5fb711c$export$ddd27c5929ee7e34 = (0, $95e9a6ac60ba274b$export$c3d7d520703291df)({
    AccessorNode: $991c91e6b5fb711c$export$c3248ebc7ade74c5,
    ArrayNode: $991c91e6b5fb711c$export$97d96bf9b84874d5,
    ConstantNode: $991c91e6b5fb711c$export$3166e8715d58cf9a,
    FunctionNode: $991c91e6b5fb711c$export$f2972be796679c12,
    IndexNode: $991c91e6b5fb711c$export$929eaad981940a63,
    ObjectNode: $991c91e6b5fb711c$export$b70fa93b5fbdd997,
    OperatorNode: $991c91e6b5fb711c$export$cd498840ad265e90,
    ParenthesisNode: $991c91e6b5fb711c$export$dbdb6279b6a3bac9,
    SymbolNode: $991c91e6b5fb711c$export$93b6424aaa42dda7,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    divide: $bed779fa205b8d7c$export$cd007d971a5a2143,
    equal: $bed779fa205b8d7c$export$411ce8e5a71e3069,
    isZero: $bed779fa205b8d7c$export$c46ec7d82fb1f602,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    pow: $bed779fa205b8d7c$export$9c297f60e22e3389,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3
});
var $991c91e6b5fb711c$export$ef7acd7185315e22 = (0, $95e6ce6de7c190b0$export$6c15201c8dbd106f)({
    parse: $991c91e6b5fb711c$export$98e6a39c04603d36,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $991c91e6b5fb711c$export$1be7516c0280bee8 = (0, $4da182a870e431e6$export$704346eb22eef29)({
    parse: $991c91e6b5fb711c$export$98e6a39c04603d36
});
var $991c91e6b5fb711c$export$c30bea1139d4d8ed = (0, $2506eca8ad1f1031$export$38658a33c7766170)({
    parse: $991c91e6b5fb711c$export$98e6a39c04603d36,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $991c91e6b5fb711c$export$798b53621063651 = (0, $d45bbe3b21890957$export$5085b3a4c8276699)({
    bignumber: $bed779fa205b8d7c$export$8576f72eb7f14a7e,
    fraction: $bed779fa205b8d7c$export$7f34ce79760854f7,
    AccessorNode: $991c91e6b5fb711c$export$c3248ebc7ade74c5,
    ArrayNode: $991c91e6b5fb711c$export$97d96bf9b84874d5,
    ConstantNode: $991c91e6b5fb711c$export$3166e8715d58cf9a,
    FunctionNode: $991c91e6b5fb711c$export$f2972be796679c12,
    IndexNode: $991c91e6b5fb711c$export$929eaad981940a63,
    ObjectNode: $991c91e6b5fb711c$export$b70fa93b5fbdd997,
    OperatorNode: $991c91e6b5fb711c$export$cd498840ad265e90,
    ParenthesisNode: $991c91e6b5fb711c$export$dbdb6279b6a3bac9,
    SymbolNode: $991c91e6b5fb711c$export$93b6424aaa42dda7,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    divide: $bed779fa205b8d7c$export$cd007d971a5a2143,
    equal: $bed779fa205b8d7c$export$411ce8e5a71e3069,
    isZero: $bed779fa205b8d7c$export$c46ec7d82fb1f602,
    mathWithTransform: $991c91e6b5fb711c$var$mathWithTransform,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    parse: $991c91e6b5fb711c$export$98e6a39c04603d36,
    pow: $bed779fa205b8d7c$export$9c297f60e22e3389,
    resolve: $991c91e6b5fb711c$export$f7ad0328861e2f03,
    simplifyCore: $991c91e6b5fb711c$export$ddd27c5929ee7e34,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $991c91e6b5fb711c$export$31543a561a829288 = (0, $b64ba096b5789b9d$export$ac8cd7544d2e68af)({
    OperatorNode: $991c91e6b5fb711c$export$cd498840ad265e90,
    parse: $991c91e6b5fb711c$export$98e6a39c04603d36,
    simplify: $991c91e6b5fb711c$export$798b53621063651,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $991c91e6b5fb711c$export$fef61f332f2c0afc = (0, $5b04846e36d2595c$export$4f825d0ade64f616)({
    parse: $991c91e6b5fb711c$export$98e6a39c04603d36,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $991c91e6b5fb711c$export$34512e3b2db52a4e = (0, $1f7a43f946788c1b$export$cbe80567b8b3b8ac)({
    Help: $991c91e6b5fb711c$export$1be7516c0280bee8,
    mathWithTransform: $991c91e6b5fb711c$var$mathWithTransform,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $991c91e6b5fb711c$export$7acfa6ed01010e37 = (0, $df0de5ca7183e0db$export$17c8a99aaef91654)({
    evaluate: $991c91e6b5fb711c$export$fef61f332f2c0afc
});
var $991c91e6b5fb711c$export$725d762cc154d53 = (0, $01adc6de4444f632$export$abd0968f5b11b2a8)({
    bignumber: $bed779fa205b8d7c$export$8576f72eb7f14a7e,
    fraction: $bed779fa205b8d7c$export$7f34ce79760854f7,
    AccessorNode: $991c91e6b5fb711c$export$c3248ebc7ade74c5,
    ArrayNode: $991c91e6b5fb711c$export$97d96bf9b84874d5,
    ConstantNode: $991c91e6b5fb711c$export$3166e8715d58cf9a,
    FunctionNode: $991c91e6b5fb711c$export$f2972be796679c12,
    IndexNode: $991c91e6b5fb711c$export$929eaad981940a63,
    ObjectNode: $991c91e6b5fb711c$export$b70fa93b5fbdd997,
    OperatorNode: $991c91e6b5fb711c$export$cd498840ad265e90,
    ParenthesisNode: $991c91e6b5fb711c$export$dbdb6279b6a3bac9,
    SymbolNode: $991c91e6b5fb711c$export$93b6424aaa42dda7,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    divide: $bed779fa205b8d7c$export$cd007d971a5a2143,
    equal: $bed779fa205b8d7c$export$411ce8e5a71e3069,
    isZero: $bed779fa205b8d7c$export$c46ec7d82fb1f602,
    mathWithTransform: $991c91e6b5fb711c$var$mathWithTransform,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    parse: $991c91e6b5fb711c$export$98e6a39c04603d36,
    pow: $bed779fa205b8d7c$export$9c297f60e22e3389,
    simplify: $991c91e6b5fb711c$export$798b53621063651,
    simplifyCore: $991c91e6b5fb711c$export$ddd27c5929ee7e34,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $991c91e6b5fb711c$export$42645bbd8ddfc464 = (0, $f98c11ce6e494d57$export$d1d6fcabea5d55e0)({
    ConstantNode: $991c91e6b5fb711c$export$3166e8715d58cf9a,
    FunctionNode: $991c91e6b5fb711c$export$f2972be796679c12,
    OperatorNode: $991c91e6b5fb711c$export$cd498840ad265e90,
    ParenthesisNode: $991c91e6b5fb711c$export$dbdb6279b6a3bac9,
    SymbolNode: $991c91e6b5fb711c$export$93b6424aaa42dda7,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
    equal: $bed779fa205b8d7c$export$411ce8e5a71e3069,
    isZero: $bed779fa205b8d7c$export$c46ec7d82fb1f602,
    numeric: $bed779fa205b8d7c$export$b7a508fa8dae59fc,
    parse: $991c91e6b5fb711c$export$98e6a39c04603d36,
    simplify: $991c91e6b5fb711c$export$798b53621063651,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
var $991c91e6b5fb711c$export$8f49e4af10703ce3 = (0, $b765548e953e7ea6$export$88a1156fad04455f)({
    Parser: $991c91e6b5fb711c$export$7acfa6ed01010e37,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711
});
(0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))($991c91e6b5fb711c$var$math, {
    e: $bed779fa205b8d7c$export$f1e1789686576879,
    false: (0, $bed779fa205b8d7c$export$f650004d56f90c2a),
    fineStructure: $bed779fa205b8d7c$export$5c15dd8d2782cbd0,
    i: $bed779fa205b8d7c$export$23f2a1d2818174ef,
    Infinity: (0, $bed779fa205b8d7c$export$20607595d292e7d3),
    LN10: $bed779fa205b8d7c$export$c44341d65988fdd6,
    LOG10E: $bed779fa205b8d7c$export$5ed2c057bd191c66,
    NaN: (0, $bed779fa205b8d7c$export$14edd9ca775dcd61),
    null: (0, $bed779fa205b8d7c$export$a2cbb38cda512d16),
    phi: $bed779fa205b8d7c$export$324943737027944a,
    SQRT1_2: $bed779fa205b8d7c$export$83247d8be11c091e,
    sackurTetrode: $bed779fa205b8d7c$export$a7100dcd4c5af6d4,
    tau: $bed779fa205b8d7c$export$a4b4b4d4d776fe92,
    true: (0, $bed779fa205b8d7c$export$93f71dfe5e50cd3e),
    "E": (0, $bed779fa205b8d7c$export$f1e1789686576879),
    version: $bed779fa205b8d7c$export$83d89fbfd8236492,
    efimovFactor: $bed779fa205b8d7c$export$9ea6550edaaee998,
    LN2: $bed779fa205b8d7c$export$578b45ddcdefa518,
    pi: $bed779fa205b8d7c$export$18c7bea995a110f,
    replacer: $bed779fa205b8d7c$export$b644b65666fe0c18,
    reviver: $991c91e6b5fb711c$export$63698c10df99509c,
    SQRT2: $bed779fa205b8d7c$export$3681641e15b6e2c3,
    typed: $bed779fa205b8d7c$export$519f616c41a1c711,
    unaryPlus: $bed779fa205b8d7c$export$df8c837ae5df4ce4,
    "PI": (0, $bed779fa205b8d7c$export$18c7bea995a110f),
    weakMixingAngle: $bed779fa205b8d7c$export$857d2e3e2bc524d0,
    abs: $bed779fa205b8d7c$export$2335f513bbd82c6d,
    acos: $bed779fa205b8d7c$export$fd6306be3fde5b04,
    acot: $bed779fa205b8d7c$export$4919a578c4aafd3,
    acsc: $bed779fa205b8d7c$export$43298db932064b4a,
    addScalar: $bed779fa205b8d7c$export$2b7b095c4f443355,
    arg: $bed779fa205b8d7c$export$d8da458ed75e15b,
    asech: $bed779fa205b8d7c$export$3aaf4e522be48075,
    asinh: $bed779fa205b8d7c$export$839d8a01b6af4fc0,
    atan: $bed779fa205b8d7c$export$628dc4eed22b0fbd,
    atanh: $bed779fa205b8d7c$export$21ea955025ceb08b,
    bignumber: $bed779fa205b8d7c$export$8576f72eb7f14a7e,
    bitNot: $bed779fa205b8d7c$export$aabc449fa5b5f4c0,
    boolean: $bed779fa205b8d7c$export$4a21f16c33752377,
    chain: $991c91e6b5fb711c$export$e08e3b67e392101e,
    clone: $bed779fa205b8d7c$export$9cd59f9826255e47,
    combinations: $bed779fa205b8d7c$export$bdfcf4c6b5766439,
    complex: $bed779fa205b8d7c$export$83a0e34f1302825b,
    conj: $bed779fa205b8d7c$export$fb254c661fe9c0db,
    cosh: $bed779fa205b8d7c$export$2e2fd1ad24e4d350,
    coth: $bed779fa205b8d7c$export$fe7b8a3b046ac25b,
    csc: $bed779fa205b8d7c$export$a830b5ed334924be,
    cube: $bed779fa205b8d7c$export$2b0340f6c7dec49a,
    equalScalar: $bed779fa205b8d7c$export$943761f5c9c3f156,
    erf: $bed779fa205b8d7c$export$d3896f355fc09423,
    exp: $bed779fa205b8d7c$export$b310ec824aaee37f,
    expm1: $bed779fa205b8d7c$export$b6c0a80d46d3391d,
    filter: $bed779fa205b8d7c$export$3dea766d36a8935f,
    forEach: $bed779fa205b8d7c$export$4b80e395e36b5a56,
    format: $bed779fa205b8d7c$export$d9468344d3651243,
    getMatrixDataType: $bed779fa205b8d7c$export$42c7d1d712906e32,
    hex: $bed779fa205b8d7c$export$834dfc94dde4b3d8,
    im: $bed779fa205b8d7c$export$5fc500b917996661,
    isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
    isNegative: $bed779fa205b8d7c$export$d0909a4f38b5c4d0,
    isPositive: $bed779fa205b8d7c$export$7e69d4236fcc3b19,
    isZero: $bed779fa205b8d7c$export$c46ec7d82fb1f602,
    LOG2E: $bed779fa205b8d7c$export$8c2c65adacba8d14,
    lgamma: $bed779fa205b8d7c$export$3daae2744d8ce460,
    log10: $bed779fa205b8d7c$export$75e08744a3ff8516,
    log2: $bed779fa205b8d7c$export$b9fae0bba9d9094d,
    map: $bed779fa205b8d7c$export$871de8747c9eaa88,
    multiplyScalar: $bed779fa205b8d7c$export$c697bed75648cdb7,
    not: $bed779fa205b8d7c$export$6003a5f097c73977,
    number: $bed779fa205b8d7c$export$98e628dec113755e,
    oct: $bed779fa205b8d7c$export$8d9f5ae1af806929,
    pickRandom: $bed779fa205b8d7c$export$2e015b6955893291,
    print: $bed779fa205b8d7c$export$c2d084dc44961371,
    random: $bed779fa205b8d7c$export$4385e60b38654f68,
    re: $bed779fa205b8d7c$export$b1f1627d659a651,
    sec: $bed779fa205b8d7c$export$e17a63917e2ebf0f,
    sign: $bed779fa205b8d7c$export$c5552dfdbc7cec71,
    sin: $bed779fa205b8d7c$export$5de3937cb4b592ed,
    splitUnit: $bed779fa205b8d7c$export$dd67294014106b35,
    square: $bed779fa205b8d7c$export$dd4f28cef696bc7d,
    string: $bed779fa205b8d7c$export$22b082955e083ec3,
    tan: $bed779fa205b8d7c$export$fcdd3b0b3246a325,
    typeOf: $bed779fa205b8d7c$export$f5bbd400c2f4426f,
    acosh: $bed779fa205b8d7c$export$b26caf0f29211d08,
    acsch: $bed779fa205b8d7c$export$eafdb403a25900df,
    apply: $bed779fa205b8d7c$export$5635d7ef4b8fee1c,
    asec: $bed779fa205b8d7c$export$ec42f46098b24bb4,
    bin: $bed779fa205b8d7c$export$f03e751d9cddb7a,
    combinationsWithRep: $bed779fa205b8d7c$export$f297162cf5d656b2,
    cos: $bed779fa205b8d7c$export$50d414a77b60d802,
    csch: $bed779fa205b8d7c$export$ca7427e8bf42a21b,
    isNaN: $bed779fa205b8d7c$export$c9f5652083b8129d,
    isPrime: $bed779fa205b8d7c$export$8676dd5fabd5ee34,
    randomInt: $bed779fa205b8d7c$export$3c5f89dae98e900b,
    sech: $bed779fa205b8d7c$export$becbc39f348ea65e,
    sinh: $bed779fa205b8d7c$export$545004b505d7c555,
    sparse: $bed779fa205b8d7c$export$b6b7e189aa5d134c,
    sqrt: $bed779fa205b8d7c$export$eba8049fb5020b81,
    tanh: $bed779fa205b8d7c$export$7128670e45beef9a,
    unaryMinus: $bed779fa205b8d7c$export$6cd304851a69e08,
    acoth: $bed779fa205b8d7c$export$6faaac9ab79fd3a4,
    cot: $bed779fa205b8d7c$export$ef569ec50496610c,
    fraction: $bed779fa205b8d7c$export$7f34ce79760854f7,
    isNumeric: $bed779fa205b8d7c$export$e90fb89750dba83f,
    matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
    matrixFromFunction: $bed779fa205b8d7c$export$7860df605315d572,
    mod: $bed779fa205b8d7c$export$842a2cf37af977e1,
    nthRoot: $bed779fa205b8d7c$export$cc5da69d359d7991,
    numeric: $bed779fa205b8d7c$export$b7a508fa8dae59fc,
    or: $bed779fa205b8d7c$export$252bb8b3bbdf6749,
    prod: $bed779fa205b8d7c$export$5e143010dea16c85,
    reshape: $bed779fa205b8d7c$export$9eaad88cf88cee2b,
    size: $bed779fa205b8d7c$export$346677f925de839c,
    smaller: $bed779fa205b8d7c$export$3f732695c1493aec,
    squeeze: $bed779fa205b8d7c$export$889c931173b77c2f,
    subset: $bed779fa205b8d7c$export$e06bd7b1ab877a71,
    subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
    to: $bed779fa205b8d7c$export$2c618a4308a30424,
    transpose: $bed779fa205b8d7c$export$9cb09a71b7d66923,
    xgcd: $bed779fa205b8d7c$export$6ba103b0465fe6cc,
    zeros: $bed779fa205b8d7c$export$4445a00dafa2633b,
    and: $bed779fa205b8d7c$export$21c0ac7fe1cef1b8,
    bitAnd: $bed779fa205b8d7c$export$a74ff8d3fdef72fc,
    bitXor: $bed779fa205b8d7c$export$bfcff4501301c191,
    cbrt: $bed779fa205b8d7c$export$841fc4d5a1480b85,
    compare: $bed779fa205b8d7c$export$398604a469f7de9a,
    compareText: $bed779fa205b8d7c$export$2da9287da10b19e2,
    concat: $bed779fa205b8d7c$export$ee1b3e54f0441b22,
    count: $bed779fa205b8d7c$export$85b9a36db797e02b,
    ctranspose: $bed779fa205b8d7c$export$eb6ad7870b1d0b0b,
    diag: $bed779fa205b8d7c$export$c042e7c2f59bc046,
    divideScalar: $bed779fa205b8d7c$export$67275f837d70084d,
    dotDivide: $bed779fa205b8d7c$export$c74f132961c51406,
    equal: $bed779fa205b8d7c$export$411ce8e5a71e3069,
    fft: $bed779fa205b8d7c$export$a535ef183b6128fa,
    flatten: $bed779fa205b8d7c$export$bffa455ba8c619a6,
    gcd: $bed779fa205b8d7c$export$f81847884871263e,
    hasNumericValue: $bed779fa205b8d7c$export$f6fc628e09f3ff5d,
    hypot: $bed779fa205b8d7c$export$f95c7888b62f8e9a,
    ifft: $bed779fa205b8d7c$export$776649b0bf8ce1fd,
    kron: $bed779fa205b8d7c$export$44f32dfde3d58545,
    largerEq: $bed779fa205b8d7c$export$72693dfc692346df,
    leftShift: $bed779fa205b8d7c$export$48901d58d322262f,
    lsolve: $bed779fa205b8d7c$export$be3b83cc1aa539e4,
    matrixFromColumns: $bed779fa205b8d7c$export$e8999e227859a482,
    min: $bed779fa205b8d7c$export$96ec731ed4dcb222,
    mode: $bed779fa205b8d7c$export$549ff81930776885,
    nthRoots: $bed779fa205b8d7c$export$adb173527af10aca,
    ones: $bed779fa205b8d7c$export$21041dee6b8001b0,
    partitionSelect: $bed779fa205b8d7c$export$54d1e322cf7aa273,
    resize: $bed779fa205b8d7c$export$4380c87abf28fdf,
    rightArithShift: $bed779fa205b8d7c$export$a1da16976d3a5f68,
    round: $bed779fa205b8d7c$export$2077e0241d6afd3c,
    smallerEq: $bed779fa205b8d7c$export$8d38c87f33a93d98,
    unequal: $bed779fa205b8d7c$export$b20c1c5fa0c7dd75,
    usolve: $bed779fa205b8d7c$export$41828460570e21eb,
    xor: $bed779fa205b8d7c$export$6444ef5cd411280c,
    add: $bed779fa205b8d7c$export$e16d8520af44a096,
    atan2: $bed779fa205b8d7c$export$b8b770ee6a0d9760,
    bitOr: $bed779fa205b8d7c$export$361eb278cc70bacf,
    catalan: $bed779fa205b8d7c$export$d8807a6c0487483a,
    compareNatural: $bed779fa205b8d7c$export$762e84baec56595d,
    cumsum: $bed779fa205b8d7c$export$71990b1e1c4912fe,
    deepEqual: $bed779fa205b8d7c$export$9cb4719e2e525b7a,
    diff: $bed779fa205b8d7c$export$a37e3c603d7117e5,
    dot: $bed779fa205b8d7c$export$94132a0e348806d4,
    equalText: $bed779fa205b8d7c$export$5bc21f656fb5d284,
    floor: $bed779fa205b8d7c$export$a3fe094919f356fd,
    identity: $bed779fa205b8d7c$export$f0954fd7d5368655,
    invmod: $bed779fa205b8d7c$export$5c1ba7f73c917315,
    larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
    log: $bed779fa205b8d7c$export$bef1f36f5486a6a3,
    lsolveAll: $bed779fa205b8d7c$export$de5c6af4003ef448,
    matrixFromRows: $bed779fa205b8d7c$export$f4f4b934de52d430,
    multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
    qr: $bed779fa205b8d7c$export$7c27fb47516129d9,
    range: $bed779fa205b8d7c$export$d02631cccf789723,
    rightLogShift: $bed779fa205b8d7c$export$502f8a5a1147da,
    setSize: $bed779fa205b8d7c$export$1c70a6cc12bc0366,
    slu: $bed779fa205b8d7c$export$95c7459688ef4e3a,
    sum: $bed779fa205b8d7c$export$8a63f25cc62965f1,
    trace: $bed779fa205b8d7c$export$357889f174732d38,
    usolveAll: $bed779fa205b8d7c$export$c8a1cf0e83678d9,
    asin: $bed779fa205b8d7c$export$41726bdb1fc63f,
    ceil: $bed779fa205b8d7c$export$803ce6b71a0a94b2,
    composition: $bed779fa205b8d7c$export$fd2cf6bce05a0b18,
    cross: $bed779fa205b8d7c$export$bb646b20bb93d339,
    det: $bed779fa205b8d7c$export$d063d65fed97e7fa,
    distance: $bed779fa205b8d7c$export$9f17032d917177de,
    dotMultiply: $bed779fa205b8d7c$export$c6d93afbf4ee8afc,
    fix: $bed779fa205b8d7c$export$d838837eb5b184e3,
    intersect: $bed779fa205b8d7c$export$1f4807a235930d45,
    lcm: $bed779fa205b8d7c$export$f686d97e407ec4ef,
    log1p: $bed779fa205b8d7c$export$144dcf16adfb9698,
    max: $bed779fa205b8d7c$export$8960430cfd85939f,
    quantileSeq: $bed779fa205b8d7c$export$ff63ee916cadcfe,
    row: $bed779fa205b8d7c$export$120ff0929b202a6d,
    setCartesian: $bed779fa205b8d7c$export$dcac7a71ff10ad82,
    setDistinct: $bed779fa205b8d7c$export$ec60221e756bab15,
    setIsSubset: $bed779fa205b8d7c$export$ca5251f59a067f9a,
    setPowerset: $bed779fa205b8d7c$export$f6ce4c11993e56f2,
    sort: $bed779fa205b8d7c$export$97db5808d8f88186,
    column: $bed779fa205b8d7c$export$4e0c71f277ca26b3,
    index: $bed779fa205b8d7c$export$b610b8812bbcded9,
    inv: $bed779fa205b8d7c$export$c02accee9f2b6a8f,
    pinv: $bed779fa205b8d7c$export$5cde0f23b96c7c61,
    pow: $bed779fa205b8d7c$export$9c297f60e22e3389,
    setDifference: $bed779fa205b8d7c$export$8bd517cc5b3722f7,
    setMultiplicity: $bed779fa205b8d7c$export$8bb4a52260216736,
    sqrtm: $bed779fa205b8d7c$export$17c7cd2216e18593,
    vacuumImpedance: $bed779fa205b8d7c$export$4b15dbe639ad9539,
    wienDisplacement: $bed779fa205b8d7c$export$2bcc1e96766dec50,
    atomicMass: $bed779fa205b8d7c$export$11b531e5540c3ca4,
    bohrMagneton: $bed779fa205b8d7c$export$c779781d69f736e8,
    boltzmann: $bed779fa205b8d7c$export$f727e86dcab4e2c6,
    conductanceQuantum: $bed779fa205b8d7c$export$6eafe330bdda8c71,
    createUnit: $bed779fa205b8d7c$export$aab44654646f3ccc,
    deuteronMass: $bed779fa205b8d7c$export$80bf07f129ad1319,
    dotPow: $bed779fa205b8d7c$export$ef3b15136279c2ab,
    electricConstant: $bed779fa205b8d7c$export$11ff82822f958f25,
    elementaryCharge: $bed779fa205b8d7c$export$199cdfec7f52c877,
    expm: $bed779fa205b8d7c$export$d9bacaa51f70e8e,
    faraday: $bed779fa205b8d7c$export$7130fbae042d5c0f,
    firstRadiation: $bed779fa205b8d7c$export$f83f3c3b84952e0b,
    gamma: $bed779fa205b8d7c$export$a7ebe8cc6aaf8d37,
    gravitationConstant: $bed779fa205b8d7c$export$d9cccfa50756330b,
    hartreeEnergy: $bed779fa205b8d7c$export$37b0dd3693d47685,
    klitzing: $bed779fa205b8d7c$export$10054c6b64de12f5,
    loschmidt: $bed779fa205b8d7c$export$9eedba962d6a1c01,
    magneticConstant: $bed779fa205b8d7c$export$ba3f3691dd1c5a7,
    molarMass: $bed779fa205b8d7c$export$6d4ff429f3f89356,
    molarPlanckConstant: $bed779fa205b8d7c$export$dacf4a2cf8881dff,
    neutronMass: $bed779fa205b8d7c$export$ba7a41eda790cc15,
    nuclearMagneton: $bed779fa205b8d7c$export$7274fb1d27d1cd19,
    planckCharge: $bed779fa205b8d7c$export$9b1b4e5bc980cec6,
    planckLength: $bed779fa205b8d7c$export$c20ab336465d7d5e,
    planckTemperature: $bed779fa205b8d7c$export$5a85cd1a26c2cced,
    protonMass: $bed779fa205b8d7c$export$1c88a737209eb089,
    reducedPlanckConstant: $bed779fa205b8d7c$export$963167ae5579ea00,
    rydberg: $bed779fa205b8d7c$export$683732ab8f5759dc,
    setIntersect: $bed779fa205b8d7c$export$9404cfefeb010e68,
    speedOfLight: $bed779fa205b8d7c$export$5d66ae3b3e8fce48,
    stefanBoltzmann: $bed779fa205b8d7c$export$f63e81544c3d56ef,
    thomsonCrossSection: $bed779fa205b8d7c$export$93039724ea765a8e,
    avogadro: $bed779fa205b8d7c$export$1236f2451dbdfd63,
    bohrRadius: $bed779fa205b8d7c$export$5a57f82afcc3edeb,
    coulomb: $bed779fa205b8d7c$export$2f2e110dac549211,
    divide: $bed779fa205b8d7c$export$cd007d971a5a2143,
    electronMass: $bed779fa205b8d7c$export$c00fb43e712bef2c,
    factorial: $bed779fa205b8d7c$export$329ce89a99f0e343,
    gravity: $bed779fa205b8d7c$export$bfb00cec0048377d,
    inverseConductanceQuantum: $bed779fa205b8d7c$export$f060c4f0aa5bef89,
    lup: $bed779fa205b8d7c$export$91d2d01a33a1e6f8,
    magneticFluxQuantum: $bed779fa205b8d7c$export$699e2a89b148c5ee,
    molarMassC12: $bed779fa205b8d7c$export$9589ebe123df8f2e,
    multinomial: $bed779fa205b8d7c$export$f4d580f3101a1c7e,
    parse: $991c91e6b5fb711c$export$98e6a39c04603d36,
    permutations: $bed779fa205b8d7c$export$4567adbe5dd91621,
    planckMass: $bed779fa205b8d7c$export$5ce790af25e5ac75,
    quantumOfCirculation: $bed779fa205b8d7c$export$5d88bfa2004001d3,
    resolve: $991c91e6b5fb711c$export$f7ad0328861e2f03,
    secondRadiation: $bed779fa205b8d7c$export$1f7c42a78c01e4f9,
    simplifyCore: $991c91e6b5fb711c$export$ddd27c5929ee7e34,
    stirlingS2: $bed779fa205b8d7c$export$a5abae3de3985f2f,
    unit: $bed779fa205b8d7c$export$523c0b569236b342,
    bellNumbers: $bed779fa205b8d7c$export$bb522a71cda46a13,
    compile: $991c91e6b5fb711c$export$ef7acd7185315e22,
    eigs: $bed779fa205b8d7c$export$e822b38c59ee8a2a,
    fermiCoupling: $bed779fa205b8d7c$export$84a9a66802fec40,
    leafCount: $991c91e6b5fb711c$export$c30bea1139d4d8ed,
    mean: $bed779fa205b8d7c$export$1ce691f85baaa52,
    molarVolume: $bed779fa205b8d7c$export$863459416408c428,
    planckConstant: $bed779fa205b8d7c$export$cbd33810258dab2e,
    setSymDifference: $bed779fa205b8d7c$export$a7eac91d5496c35b,
    simplify: $991c91e6b5fb711c$export$798b53621063651,
    symbolicEqual: $991c91e6b5fb711c$export$31543a561a829288,
    classicalElectronRadius: $bed779fa205b8d7c$export$f48a0c6b8cc21601,
    evaluate: $991c91e6b5fb711c$export$fef61f332f2c0afc,
    help: $991c91e6b5fb711c$export$34512e3b2db52a4e,
    lusolve: $bed779fa205b8d7c$export$fccc724a69f253a,
    median: $bed779fa205b8d7c$export$9c490b34b2f16a34,
    rationalize: $991c91e6b5fb711c$export$725d762cc154d53,
    setUnion: $bed779fa205b8d7c$export$667066422fa0af46,
    variance: $bed779fa205b8d7c$export$9b77da0927470c3d,
    derivative: $991c91e6b5fb711c$export$42645bbd8ddfc464,
    kldivergence: $bed779fa205b8d7c$export$a9fffb6ae6e33dcc,
    norm: $bed779fa205b8d7c$export$1991ecd29cc92c6b,
    planckTime: $bed779fa205b8d7c$export$85aaf319784a5b0,
    rotationMatrix: $bed779fa205b8d7c$export$52ded331ee8b28e8,
    gasConstant: $bed779fa205b8d7c$export$a614e1ad972260a9,
    parser: $991c91e6b5fb711c$export$8f49e4af10703ce3,
    std: $bed779fa205b8d7c$export$b14c5e819cb6c927,
    mad: $bed779fa205b8d7c$export$b14ea41a64d6efa6,
    rotate: $bed779fa205b8d7c$export$bb628a54ab399bc9,
    config: $28bb29a4365991c4$export$e506a1d27d1eaa20
});
(0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))($991c91e6b5fb711c$var$mathWithTransform, $991c91e6b5fb711c$var$math, {
    filter: (0, $3c9fe43ad031677c$export$a53d7aa4a2c1e7e3)({
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    forEach: (0, $c9b9efdabed6c757$export$342aa09106704265)({
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    map: (0, $cbb88054bded9d40$export$5ae33143d676d4d4)({
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    apply: (0, $8b98c8b21f871482$export$1c2b553a3b99e)({
        isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    diff: (0, $00182defd0737530$export$829cfcec5c5f4a9d)({
        bignumber: $bed779fa205b8d7c$export$8576f72eb7f14a7e,
        matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
        number: $bed779fa205b8d7c$export$98e628dec113755e,
        subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    subset: (0, $d423dd8c57bef047$export$3dd4e26b0ef52fd5)({
        matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    concat: (0, $d69b78ec04be14c1$export$3571c61ed942e965)({
        isInteger: $bed779fa205b8d7c$export$a287f47fed4544b8,
        matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    max: (0, $8ad5d1f0d8e69974$export$cb806a795cec8077)({
        config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
        larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
        numeric: $bed779fa205b8d7c$export$b7a508fa8dae59fc,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    min: (0, $a16f206ff91e15cb$export$e6239917a808c35d)({
        config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
        numeric: $bed779fa205b8d7c$export$b7a508fa8dae59fc,
        smaller: $bed779fa205b8d7c$export$3f732695c1493aec,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    range: (0, $56d63b8ec1d2d4db$export$af4628cd15bbfbf2)({
        bignumber: $bed779fa205b8d7c$export$8576f72eb7f14a7e,
        matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
        config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
        larger: $bed779fa205b8d7c$export$a94a7414fa942aea,
        largerEq: $bed779fa205b8d7c$export$72693dfc692346df,
        smaller: $bed779fa205b8d7c$export$3f732695c1493aec,
        smallerEq: $bed779fa205b8d7c$export$8d38c87f33a93d98,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    sum: (0, $1ba3b6c4bcc19d3d$export$1b9b65ea533d42ec)({
        add: $bed779fa205b8d7c$export$e16d8520af44a096,
        config: $28bb29a4365991c4$export$e506a1d27d1eaa20,
        numeric: $bed779fa205b8d7c$export$b7a508fa8dae59fc,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    cumsum: (0, $eae45d185d81e121$export$3052aed7543acf3e)({
        add: $bed779fa205b8d7c$export$e16d8520af44a096,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711,
        unaryPlus: $bed779fa205b8d7c$export$df8c837ae5df4ce4
    }),
    row: (0, $ebaf1bcbb4af801e$export$649101a1e7f0c38d)({
        Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
        matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
        range: $bed779fa205b8d7c$export$d02631cccf789723,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    column: (0, $9edea299faf18da9$export$cb052a3b92a960e)({
        Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
        matrix: $bed779fa205b8d7c$export$9bdad1ae37d738e0,
        range: $bed779fa205b8d7c$export$d02631cccf789723,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    index: (0, $2db75e88aebd80ef$export$f20e87a60dbfc89e)({
        Index: $bed779fa205b8d7c$export$cf17b003b6192af3
    }),
    mean: (0, $1db60fc21b99e458$export$caaba12fb8f94b67)({
        add: $bed779fa205b8d7c$export$e16d8520af44a096,
        divide: $bed779fa205b8d7c$export$cd007d971a5a2143,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    variance: (0, $f8d7ada6bf4c4fee$export$8ab5ca08ecd18ef3)({
        add: $bed779fa205b8d7c$export$e16d8520af44a096,
        apply: $bed779fa205b8d7c$export$5635d7ef4b8fee1c,
        divide: $bed779fa205b8d7c$export$cd007d971a5a2143,
        isNaN: $bed779fa205b8d7c$export$c9f5652083b8129d,
        multiply: $bed779fa205b8d7c$export$2060d2db72cce88f,
        subtract: $bed779fa205b8d7c$export$4e2d2ead65e5f7e3,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711
    }),
    std: (0, $061d235b829fb888$export$ef5049c11f391200)({
        sqrt: $bed779fa205b8d7c$export$eba8049fb5020b81,
        typed: $bed779fa205b8d7c$export$519f616c41a1c711,
        variance: $bed779fa205b8d7c$export$9b77da0927470c3d
    })
});
(0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))($991c91e6b5fb711c$var$classes, {
    BigNumber: $bed779fa205b8d7c$export$d97aa349ed20696,
    Chain: $991c91e6b5fb711c$export$f18d5acc27d70423,
    Complex: $bed779fa205b8d7c$export$50ceb3fb9926e63e,
    Fraction: $bed779fa205b8d7c$export$b336c2702c498be5,
    Matrix: $bed779fa205b8d7c$export$5b12bf1653c0dd85,
    Node: $991c91e6b5fb711c$export$85c928794f8d04d4,
    ObjectNode: $991c91e6b5fb711c$export$b70fa93b5fbdd997,
    OperatorNode: $991c91e6b5fb711c$export$cd498840ad265e90,
    ParenthesisNode: $991c91e6b5fb711c$export$dbdb6279b6a3bac9,
    Range: $bed779fa205b8d7c$export$9a58ef0d7ad3278c,
    RelationalNode: $991c91e6b5fb711c$export$a4d9a8de1ded3461,
    ResultSet: $bed779fa205b8d7c$export$aebd5179ff543a90,
    ArrayNode: $991c91e6b5fb711c$export$97d96bf9b84874d5,
    BlockNode: $991c91e6b5fb711c$export$ec7b1e3e36733ff3,
    ConditionalNode: $991c91e6b5fb711c$export$8e402c64e6081013,
    ConstantNode: $991c91e6b5fb711c$export$3166e8715d58cf9a,
    DenseMatrix: $bed779fa205b8d7c$export$97f0d27b48f120e8,
    RangeNode: $991c91e6b5fb711c$export$d0e9917d83c120a0,
    FunctionAssignmentNode: $991c91e6b5fb711c$export$446a68c3fb943f17,
    SparseMatrix: $bed779fa205b8d7c$export$de9b2b7556879848,
    AccessorNode: $991c91e6b5fb711c$export$c3248ebc7ade74c5,
    AssignmentNode: $991c91e6b5fb711c$export$a144098e31f7b52f,
    IndexNode: $991c91e6b5fb711c$export$929eaad981940a63,
    FibonacciHeap: $bed779fa205b8d7c$export$dd5bb73729f20aa3,
    ImmutableDenseMatrix: $bed779fa205b8d7c$export$66fe727d7ec8c7b9,
    Index: $bed779fa205b8d7c$export$cf17b003b6192af3,
    Spa: $bed779fa205b8d7c$export$6d4069f4b64f7492,
    Unit: $bed779fa205b8d7c$export$1d8b9ae22d404866,
    SymbolNode: $991c91e6b5fb711c$export$93b6424aaa42dda7,
    FunctionNode: $991c91e6b5fb711c$export$f2972be796679c12,
    Help: $991c91e6b5fb711c$export$1be7516c0280bee8,
    Parser: $991c91e6b5fb711c$export$7acfa6ed01010e37
});
$991c91e6b5fb711c$export$f18d5acc27d70423.createProxy($991c91e6b5fb711c$var$math);



class $0d5ddf370e1398bc$export$96fe2c02b12de670 extends (0, $6f125744f8893ba5$export$94cd813f5440f38d) {
    displayItemContent(content, bindTarget) {
        const numeric = document.querySelector(".item .numeric");
        numeric.classList.remove("d-none");
        numeric.classList.add("invisible");
        const name = numeric.querySelector(".name");
        const prompt = numeric.querySelector(".prompt");
        const style = numeric.querySelector("style");
        name.innerHTML = content.name + ".";
        prompt.innerHTML = content.numeric.prompt;
        style.innerText = [].concat(content.numeric.style, content.contexts.map((c)=>c.style)).join("\n\n");
        Array.from(numeric.querySelectorAll(".context-panel")).slice(1).forEach((panel)=>{
            panel.remove();
        });
        const contextPanel = numeric.querySelector(".context-panel");
        const context = contextPanel.querySelector(".context");
        if (content.contexts.length > 0) {
            context.innerHTML = content.contexts[0].content_html;
            context.classList.remove("d-none");
            contextPanel.dataset.context = content.contexts[0].id;
            contextPanel.classList.remove("d-none");
            content.contexts.slice(1).reverse().forEach((_context)=>{
                const panel = contextPanel.cloneNode(true);
                const context = panel.querySelector(".context");
                context.innerHTML = _context.content_html;
                context.classList.remove("d-none");
                panel.dataset.context = _context.id;
                panel.classList.remove("d-none");
                panel.addEventListener("click", (e)=>{
                    bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$fe0b591ac3aa4171)([
                        panel.dataset.context
                    ]));
                });
                contextPanel.after(panel);
            });
        } else {
            context.innerHTML = "";
            context.classList.add("d-none");
            contextPanel.removeAttribute("data-context");
            contextPanel.classList.add("d-none");
        }
        const answers = numeric.querySelector(".answers");
        const answerTemplate = answers.querySelector(".answer").cloneNode(true);
        answers.innerHTML = "";
        const answerNode = answerTemplate.cloneNode(true);
        const input = answerNode.querySelector("input[name=answer]");
        input.value = "";
        answers.appendChild(answerNode);
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        const numeric = document.querySelector(".item .numeric");
        const answers = numeric.querySelector(".answers");
        const answerNode = answers.querySelector(".answer");
        const input = answerNode.querySelector("input[name=answer]");
        if (answer) input.value = answer;
        input.addEventListener("change", (e)=>{
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3dd7a8e950550ea4)(input.value));
        });
    }
    displayItemReview(content, answer) {
        const numeric = document.querySelector(".item .numeric");
        const minimum = content.numeric.answers.minimum;
        const maximum = content.numeric.answers.maximum;
        const number = content.numeric.answers.number;
        function compare(referenceText, referenceValue, compareText) {
            try {
                return $bed779fa205b8d7c$export$398604a469f7de9a($991c91e6b5fb711c$export$fef61f332f2c0afc(referenceText), $991c91e6b5fb711c$export$fef61f332f2c0afc(compareText));
            } catch (ex) {
                try {
                    return $bed779fa205b8d7c$export$398604a469f7de9a(referenceValue, $991c91e6b5fb711c$export$fef61f332f2c0afc(compareText));
                } catch (ex) {
                    try {
                        return $bed779fa205b8d7c$export$398604a469f7de9a(referenceValue, compareText.replace(/[^\-.0-9\/]/g, ""));
                    } catch (ex) {
                        console.warn("Could not parse", compareText);
                    }
                }
            }
        }
        let isCorrect = false;
        if (answer && minimum && maximum) isCorrect = compare(minimum.text, minimum.value, answer) <= 0 && compare(maximum.text, maximum.value, answer) >= 0;
        else if (answer && number) isCorrect = compare(number.text, number.value, answer) === 0;
        const explanation = numeric.querySelector(".explanation");
        explanation.innerHTML = content.numeric.explanation;
        const explanationPanel = explanation.closest("div.card");
        const correct = document.querySelector(".correct");
        if (isCorrect) {
            correct.innerHTML = "Correct";
            correct.classList.remove("alert-danger", "alert-info");
            correct.classList.add("alert-success");
            explanationPanel.classList.remove("border-danger", "border-info");
            explanationPanel.classList.add("border-success");
        } else if (answer) {
            correct.innerHTML = "Incorrect";
            correct.classList.remove("alert-success", "alert-info");
            correct.classList.add("alert-danger");
            explanationPanel.classList.remove("border-success", "border-info");
            explanationPanel.classList.add("border-danger");
        } else {
            correct.innerHTML = "Unanswered";
            correct.classList.remove("alert-success", "alert-danger");
            correct.classList.add("alert-info");
            explanationPanel.classList.remove("border-success", "border-danger");
            explanationPanel.classList.add("border-info");
        }
        const answers = numeric.querySelector(".answers");
        const answerNode = answers.querySelector(".answer");
        const input = answerNode.querySelector("input[name=answer]");
        const feedback = answerNode.querySelector(".feedback");
        const answerCorrect = answerNode.querySelector(".answer-correct");
        const answerReference = answerNode.querySelector(".answer-reference");
        const numericAnswers = content.numeric.answers;
        if (isCorrect) {
            input.classList.remove("is-invalid");
            input.classList.add("is-valid");
            feedback.classList.remove("invalid-feedback", "text-info", "small");
            feedback.classList.add("valid-feedback");
            answerCorrect.classList.remove("text-bg-danger", "badge-danger", "text-bg-info", "badge-info");
            answerCorrect.classList.add("text-bg-success", "badge-success");
            answerCorrect.innerHTML = "Correct";
            answerReference.innerHTML = numericAnswers.number ? numericAnswers.number.text : `between ${numericAnswers.minimum.text} and ${numericAnswers.maximum.text}`;
        } else if (answer) {
            input.classList.remove("is-valid");
            input.classList.add("is-invalid");
            feedback.classList.remove("valid-feedback", "text-info", "small");
            feedback.classList.add("invalid-feedback");
            answerCorrect.classList.remove("text-bg-success", "badge-success", "text-bg-info", "badge-info");
            answerCorrect.classList.add("text-bg-danger", "badge-danger");
            answerCorrect.innerHTML = "Incorrect";
            answerReference.innerHTML = numericAnswers.number ? numericAnswers.number.text : `between ${numericAnswers.minimum.text} and ${numericAnswers.maximum.text}`;
        } else {
            input.classList.remove("is-valid", "is-invalid");
            feedback.classList.remove("valid-feedback", "invalid-feedback");
            feedback.classList.add("text-info", "small");
            answerCorrect.classList.remove("text-bg-success", "badge-success", "text-bg-danger", "badge-danger");
            answerCorrect.classList.add("text-bg-info", "badge-info");
            answerCorrect.innerHTML = "Unanswered";
            answerReference.innerHTML = numericAnswers.number ? numericAnswers.number.text : `between ${numericAnswers.minimum.text} and ${numericAnswers.maximum.text}`;
        }
    }
    displayItemRendered(content, mathjax) {
        const numeric = document.querySelector(".item .numeric");
        mathjax.typesetPromise().then(()=>{
            numeric.classList.remove("invisible");
        });
    }
    displayItemAlerts(content) {
        // Do nothing.
        return;
    }
}




class $5d09e0e2815d1769$export$8ab55b8a6a6c86f4 extends (0, $6f125744f8893ba5$export$94cd813f5440f38d) {
    displayItemContent(content, bindTarget) {
        const cloze = document.querySelector(".item .cloze");
        cloze.classList.remove("d-none");
        cloze.classList.add("invisible");
        const name = cloze.querySelector(".name");
        const prompt = cloze.querySelector(".prompt");
        const style = cloze.querySelector("style");
        name.innerHTML = content.name + ".";
        prompt.innerHTML = content.cloze.prompt;
        style.innerText = [].concat(content.cloze.style, content.contexts.map((c)=>c.style)).join("\n\n");
        Array.from(cloze.querySelectorAll(".context-panel")).slice(1).forEach((panel)=>{
            panel.remove();
        });
        const contextPanel = cloze.querySelector(".context-panel");
        const context = contextPanel.querySelector(".context");
        if (content.contexts.length > 0) {
            context.innerHTML = content.contexts[0].content_html;
            context.classList.remove("d-none");
            contextPanel.dataset.context = content.contexts[0].id;
            contextPanel.classList.remove("d-none");
            content.contexts.slice(1).reverse().forEach((_context)=>{
                const panel = contextPanel.cloneNode(true);
                const context = panel.querySelector(".context");
                context.innerHTML = _context.content_html;
                context.classList.remove("d-none");
                panel.dataset.context = _context.id;
                panel.classList.remove("d-none");
                panel.addEventListener("click", (e)=>{
                    bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$fe0b591ac3aa4171)([
                        panel.dataset.context
                    ]));
                });
                contextPanel.after(panel);
            });
        } else {
            context.innerHTML = "";
            context.classList.add("d-none");
            contextPanel.removeAttribute("data-context");
            contextPanel.classList.add("d-none");
        }
        const answers = cloze.querySelector(".answers");
        const answerTemplate = answers.querySelector(".answer").cloneNode(true);
        answers.innerHTML = "";
        content.cloze.answers.forEach((answerContent, index)=>{
            const answerNode = answerTemplate.cloneNode(true);
            const input = answerNode.querySelector("input[name=answer]");
            const label = answerNode.querySelector("label");
            input.id = "clz-answer-" + answerContent.name.replace(" ", "-");
            input.value = "";
            input.dataset.name = answerContent.name;
            label.innerText = answerContent.name;
            label.setAttribute("for", "clz-answer-" + answerContent.name.replace(" ", "-"));
            answers.appendChild(answerNode);
        });
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        const cloze = document.querySelector(".item .cloze");
        const answers = cloze.querySelector(".answers");
        Array.from(answers.querySelectorAll(".answer")).map((answerNode)=>{
            const input = answerNode.querySelector("input[name=answer]");
            input.value = answer?.[input.dataset.name] ?? "";
            input.addEventListener("change", (e)=>{
                bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3dd7a8e950550ea4)(Array.from(answers.querySelectorAll(".answer input[name=answer]")).reduce((a, b)=>({
                        ...a,
                        [b.dataset.name]: b.value
                    }), {})));
            });
        });
    }
    displayItemReview(content, answer) {
        const cloze = document.querySelector(".item .cloze");
        function compare(reference, compare) {
            return reference === compare.correct || compare.accept?.some((value)=>value.regex ? RegExp(value.text).test(reference) : value.text === reference);
        }
        const explanation = cloze.querySelector(".explanation");
        explanation.innerHTML = content.cloze.explanation;
        const answerLength = answer ? Object.keys(answer).length : 0;
        const isCorrect = content.cloze.answers.every((clozeAnswer)=>answer && compare(answer[clozeAnswer.name], clozeAnswer));
        const explanationPanel = explanation.closest("div.card");
        const correct = document.querySelector(".correct");
        if (answerLength > 0 && isCorrect) {
            correct.innerHTML = "Correct";
            correct.classList.remove("alert-danger", "alert-info");
            correct.classList.add("alert-success");
            explanationPanel.classList.remove("border-danger", "border-info");
            explanationPanel.classList.add("border-success");
        } else if (answerLength > 0 && !isCorrect) {
            correct.innerHTML = "Incorrect";
            correct.classList.remove("alert-success", "alert-info");
            correct.classList.add("alert-danger");
            explanationPanel.classList.remove("border-success", "border-info");
            explanationPanel.classList.add("border-danger");
        } else {
            correct.innerHTML = "Unanswered";
            correct.classList.remove("alert-success", "alert-danger");
            correct.classList.add("alert-info");
            explanationPanel.classList.remove("border-success", "border-danger");
            explanationPanel.classList.add("border-info");
        }
        const answers = cloze.querySelector(".answers");
        const answerNodes = answers.querySelectorAll(".answer");
        Array.from(answerNodes).map((answerNode, index)=>{
            const input = answerNode.querySelector("input[name=answer]");
            const feedback = answerNode.querySelector(".feedback");
            const answerCorrect = answerNode.querySelector(".answer-correct");
            const answerReference = answerNode.querySelector(".answer-reference");
            const clozeRef = content.cloze.answers[index];
            const answerRef = answer ? answer[clozeRef.name] : "";
            const correct = compare(answerRef, clozeRef);
            if (correct) {
                input.classList.remove("is-invalid");
                input.classList.add("is-valid");
                feedback.classList.remove("invalid-feedback", "text-info", "small");
                feedback.classList.add("valid-feedback");
                answerCorrect.classList.remove("text-bg-danger", "badge-danger", "text-bg-info", "badge-info");
                answerCorrect.classList.add("text-bg-success", "badge-success");
                answerCorrect.innerHTML = "Correct";
                answerReference.innerHTML = clozeRef.correct;
            } else if (answerRef) {
                input.classList.remove("is-valid");
                input.classList.add("is-invalid");
                feedback.classList.remove("valid-feedback", "text-info", "small");
                feedback.classList.add("invalid-feedback");
                answerCorrect.classList.remove("text-bg-success", "badge-success", "text-bg-info", "badge-info");
                answerCorrect.classList.add("text-bg-danger", "badge-danger");
                answerCorrect.innerHTML = "Incorrect";
                answerReference.innerHTML = clozeRef.correct;
            } else {
                input.classList.remove("is-valid", "is-invalid");
                feedback.classList.remove("valid-feedback", "invalid-feedback");
                feedback.classList.add("text-info", "small");
                answerCorrect.classList.remove("text-bg-success", "badge-success", "text-bg-danger", "badge-danger");
                answerCorrect.classList.add("text-bg-info", "badge-info");
                answerCorrect.innerHTML = "Unanswered";
                answerReference.innerHTML = clozeRef.correct;
            }
        });
    }
    displayItemRendered(content, mathjax) {
        const cloze = document.querySelector(".item .cloze");
        mathjax.typesetPromise().then(()=>{
            cloze.classList.remove("invisible");
        });
    }
    displayItemAlerts(content) {
        // Do nothing.
        return;
    }
}




/**!
 * Sortable 1.15.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $e9436c4c4d600e19$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e9436c4c4d600e19$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e9436c4c4d600e19$var$ownKeys(Object(source), true).forEach(function(key) {
            $e9436c4c4d600e19$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e9436c4c4d600e19$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e9436c4c4d600e19$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e9436c4c4d600e19$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $e9436c4c4d600e19$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e9436c4c4d600e19$var$_typeof(obj);
}
function $e9436c4c4d600e19$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e9436c4c4d600e19$var$_extends() {
    $e9436c4c4d600e19$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e9436c4c4d600e19$var$_extends.apply(this, arguments);
}
function $e9436c4c4d600e19$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e9436c4c4d600e19$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e9436c4c4d600e19$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e9436c4c4d600e19$var$_toConsumableArray(arr) {
    return $e9436c4c4d600e19$var$_arrayWithoutHoles(arr) || $e9436c4c4d600e19$var$_iterableToArray(arr) || $e9436c4c4d600e19$var$_unsupportedIterableToArray(arr) || $e9436c4c4d600e19$var$_nonIterableSpread();
}
function $e9436c4c4d600e19$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e9436c4c4d600e19$var$_arrayLikeToArray(arr);
}
function $e9436c4c4d600e19$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e9436c4c4d600e19$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e9436c4c4d600e19$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e9436c4c4d600e19$var$_arrayLikeToArray(o, minLen);
}
function $e9436c4c4d600e19$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e9436c4c4d600e19$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $e9436c4c4d600e19$var$version = "1.15.2";
function $e9436c4c4d600e19$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $e9436c4c4d600e19$var$IE11OrLess = $e9436c4c4d600e19$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $e9436c4c4d600e19$var$Edge = $e9436c4c4d600e19$var$userAgent(/Edge/i);
var $e9436c4c4d600e19$var$FireFox = $e9436c4c4d600e19$var$userAgent(/firefox/i);
var $e9436c4c4d600e19$var$Safari = $e9436c4c4d600e19$var$userAgent(/safari/i) && !$e9436c4c4d600e19$var$userAgent(/chrome/i) && !$e9436c4c4d600e19$var$userAgent(/android/i);
var $e9436c4c4d600e19$var$IOS = $e9436c4c4d600e19$var$userAgent(/iP(ad|od|hone)/i);
var $e9436c4c4d600e19$var$ChromeForAndroid = $e9436c4c4d600e19$var$userAgent(/chrome/i) && $e9436c4c4d600e19$var$userAgent(/android/i);
var $e9436c4c4d600e19$var$captureMode = {
    capture: false,
    passive: false
};
function $e9436c4c4d600e19$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$e9436c4c4d600e19$var$IE11OrLess && $e9436c4c4d600e19$var$captureMode);
}
function $e9436c4c4d600e19$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$e9436c4c4d600e19$var$IE11OrLess && $e9436c4c4d600e19$var$captureMode);
}
function $e9436c4c4d600e19$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $e9436c4c4d600e19$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $e9436c4c4d600e19$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $e9436c4c4d600e19$var$matches(el, selector) : $e9436c4c4d600e19$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $e9436c4c4d600e19$var$getParentOrHost(el));
    }
    return null;
}
var $e9436c4c4d600e19$var$R_SPACE = /\s+/g;
function $e9436c4c4d600e19$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($e9436c4c4d600e19$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($e9436c4c4d600e19$var$R_SPACE, " ");
        }
    }
}
function $e9436c4c4d600e19$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $e9436c4c4d600e19$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $e9436c4c4d600e19$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $e9436c4c4d600e19$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $e9436c4c4d600e19$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $e9436c4c4d600e19$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $e9436c4c4d600e19$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$e9436c4c4d600e19$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($e9436c4c4d600e19$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $e9436c4c4d600e19$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($e9436c4c4d600e19$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($e9436c4c4d600e19$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $e9436c4c4d600e19$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $e9436c4c4d600e19$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $e9436c4c4d600e19$var$getParentAutoScrollElement(el, true), elSideVal = $e9436c4c4d600e19$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $e9436c4c4d600e19$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $e9436c4c4d600e19$var$getWindowScrollingElement()) break;
        parent = $e9436c4c4d600e19$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $e9436c4c4d600e19$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $e9436c4c4d600e19$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $e9436c4c4d600e19$export$31b3ca70d8f57423.dragged) && $e9436c4c4d600e19$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $e9436c4c4d600e19$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $e9436c4c4d600e19$export$31b3ca70d8f57423.ghost || $e9436c4c4d600e19$var$css(last, "display") === "none" || selector && !$e9436c4c4d600e19$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $e9436c4c4d600e19$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $e9436c4c4d600e19$export$31b3ca70d8f57423.clone && (!selector || $e9436c4c4d600e19$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $e9436c4c4d600e19$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $e9436c4c4d600e19$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $e9436c4c4d600e19$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $e9436c4c4d600e19$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $e9436c4c4d600e19$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $e9436c4c4d600e19$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $e9436c4c4d600e19$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $e9436c4c4d600e19$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $e9436c4c4d600e19$var$getWindowScrollingElement();
}
function $e9436c4c4d600e19$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $e9436c4c4d600e19$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $e9436c4c4d600e19$var$_throttleTimeout;
function $e9436c4c4d600e19$var$throttle(callback, ms) {
    return function() {
        if (!$e9436c4c4d600e19$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $e9436c4c4d600e19$var$_throttleTimeout = setTimeout(function() {
                $e9436c4c4d600e19$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $e9436c4c4d600e19$var$cancelThrottle() {
    clearTimeout($e9436c4c4d600e19$var$_throttleTimeout);
    $e9436c4c4d600e19$var$_throttleTimeout = void 0;
}
function $e9436c4c4d600e19$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $e9436c4c4d600e19$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $e9436c4c4d600e19$var$setRect(el, rect) {
    $e9436c4c4d600e19$var$css(el, "position", "absolute");
    $e9436c4c4d600e19$var$css(el, "top", rect.top);
    $e9436c4c4d600e19$var$css(el, "left", rect.left);
    $e9436c4c4d600e19$var$css(el, "width", rect.width);
    $e9436c4c4d600e19$var$css(el, "height", rect.height);
}
function $e9436c4c4d600e19$var$unsetRect(el) {
    $e9436c4c4d600e19$var$css(el, "position", "");
    $e9436c4c4d600e19$var$css(el, "top", "");
    $e9436c4c4d600e19$var$css(el, "left", "");
    $e9436c4c4d600e19$var$css(el, "width", "");
    $e9436c4c4d600e19$var$css(el, "height", "");
}
function $e9436c4c4d600e19$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$e9436c4c4d600e19$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $e9436c4c4d600e19$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $e9436c4c4d600e19$var$expando = "Sortable" + new Date().getTime();
function $e9436c4c4d600e19$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($e9436c4c4d600e19$var$css(child, "display") === "none" || child === $e9436c4c4d600e19$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $e9436c4c4d600e19$var$getRect(child)
                });
                var fromRect = $e9436c4c4d600e19$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $e9436c4c4d600e19$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($e9436c4c4d600e19$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $e9436c4c4d600e19$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $e9436c4c4d600e19$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($e9436c4c4d600e19$var$isRectEqual(prevFromRect, toRect) && !$e9436c4c4d600e19$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $e9436c4c4d600e19$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$e9436c4c4d600e19$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $e9436c4c4d600e19$var$css(target, "transition", "");
                $e9436c4c4d600e19$var$css(target, "transform", "");
                var elMatrix = $e9436c4c4d600e19$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $e9436c4c4d600e19$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $e9436c4c4d600e19$var$repaint(target); // repaint
                $e9436c4c4d600e19$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $e9436c4c4d600e19$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $e9436c4c4d600e19$var$css(target, "transition", "");
                    $e9436c4c4d600e19$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $e9436c4c4d600e19$var$repaint(target) {
    return target.offsetWidth;
}
function $e9436c4c4d600e19$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $e9436c4c4d600e19$var$plugins = [];
var $e9436c4c4d600e19$var$defaults = {
    initializeByDefault: true
};
var $e9436c4c4d600e19$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $e9436c4c4d600e19$var$defaults)if ($e9436c4c4d600e19$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $e9436c4c4d600e19$var$defaults[option];
        $e9436c4c4d600e19$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $e9436c4c4d600e19$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $e9436c4c4d600e19$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($e9436c4c4d600e19$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($e9436c4c4d600e19$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $e9436c4c4d600e19$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $e9436c4c4d600e19$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $e9436c4c4d600e19$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $e9436c4c4d600e19$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $e9436c4c4d600e19$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $e9436c4c4d600e19$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$e9436c4c4d600e19$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$e9436c4c4d600e19$var$IE11OrLess && !$e9436c4c4d600e19$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $e9436c4c4d600e19$var$_objectSpread2($e9436c4c4d600e19$var$_objectSpread2({}, extraEventProperties), $e9436c4c4d600e19$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $e9436c4c4d600e19$var$_excluded = [
    "evt"
];
var $e9436c4c4d600e19$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $e9436c4c4d600e19$var$_objectWithoutProperties(_ref, $e9436c4c4d600e19$var$_excluded);
    $e9436c4c4d600e19$var$PluginManager.pluginEvent.bind($e9436c4c4d600e19$export$31b3ca70d8f57423)(eventName, sortable, $e9436c4c4d600e19$var$_objectSpread2({
        dragEl: $e9436c4c4d600e19$var$dragEl,
        parentEl: $e9436c4c4d600e19$var$parentEl,
        ghostEl: $e9436c4c4d600e19$var$ghostEl,
        rootEl: $e9436c4c4d600e19$var$rootEl,
        nextEl: $e9436c4c4d600e19$var$nextEl,
        lastDownEl: $e9436c4c4d600e19$var$lastDownEl,
        cloneEl: $e9436c4c4d600e19$var$cloneEl,
        cloneHidden: $e9436c4c4d600e19$var$cloneHidden,
        dragStarted: $e9436c4c4d600e19$var$moved,
        putSortable: $e9436c4c4d600e19$var$putSortable,
        activeSortable: $e9436c4c4d600e19$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $e9436c4c4d600e19$var$oldIndex,
        oldDraggableIndex: $e9436c4c4d600e19$var$oldDraggableIndex,
        newIndex: $e9436c4c4d600e19$var$newIndex,
        newDraggableIndex: $e9436c4c4d600e19$var$newDraggableIndex,
        hideGhostForTarget: $e9436c4c4d600e19$var$_hideGhostForTarget,
        unhideGhostForTarget: $e9436c4c4d600e19$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $e9436c4c4d600e19$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $e9436c4c4d600e19$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $e9436c4c4d600e19$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $e9436c4c4d600e19$var$_dispatchEvent(info) {
    $e9436c4c4d600e19$var$dispatchEvent($e9436c4c4d600e19$var$_objectSpread2({
        putSortable: $e9436c4c4d600e19$var$putSortable,
        cloneEl: $e9436c4c4d600e19$var$cloneEl,
        targetEl: $e9436c4c4d600e19$var$dragEl,
        rootEl: $e9436c4c4d600e19$var$rootEl,
        oldIndex: $e9436c4c4d600e19$var$oldIndex,
        oldDraggableIndex: $e9436c4c4d600e19$var$oldDraggableIndex,
        newIndex: $e9436c4c4d600e19$var$newIndex,
        newDraggableIndex: $e9436c4c4d600e19$var$newDraggableIndex
    }, info));
}
var $e9436c4c4d600e19$var$dragEl, $e9436c4c4d600e19$var$parentEl, $e9436c4c4d600e19$var$ghostEl, $e9436c4c4d600e19$var$rootEl, $e9436c4c4d600e19$var$nextEl, $e9436c4c4d600e19$var$lastDownEl, $e9436c4c4d600e19$var$cloneEl, $e9436c4c4d600e19$var$cloneHidden, $e9436c4c4d600e19$var$oldIndex, $e9436c4c4d600e19$var$newIndex, $e9436c4c4d600e19$var$oldDraggableIndex, $e9436c4c4d600e19$var$newDraggableIndex, $e9436c4c4d600e19$var$activeGroup, $e9436c4c4d600e19$var$putSortable, $e9436c4c4d600e19$var$awaitingDragStarted = false, $e9436c4c4d600e19$var$ignoreNextClick = false, $e9436c4c4d600e19$var$sortables = [], $e9436c4c4d600e19$var$tapEvt, $e9436c4c4d600e19$var$touchEvt, $e9436c4c4d600e19$var$lastDx, $e9436c4c4d600e19$var$lastDy, $e9436c4c4d600e19$var$tapDistanceLeft, $e9436c4c4d600e19$var$tapDistanceTop, $e9436c4c4d600e19$var$moved, $e9436c4c4d600e19$var$lastTarget, $e9436c4c4d600e19$var$lastDirection, $e9436c4c4d600e19$var$pastFirstInvertThresh = false, $e9436c4c4d600e19$var$isCircumstantialInvert = false, $e9436c4c4d600e19$var$targetMoveDistance, // For positioning ghost absolutely
$e9436c4c4d600e19$var$ghostRelativeParent, $e9436c4c4d600e19$var$ghostRelativeParentInitialScroll = [], // (left, top)
$e9436c4c4d600e19$var$_silent = false, $e9436c4c4d600e19$var$savedInputChecked = [];
/** @const */ var $e9436c4c4d600e19$var$documentExists = typeof document !== "undefined", $e9436c4c4d600e19$var$PositionGhostAbsolutely = $e9436c4c4d600e19$var$IOS, $e9436c4c4d600e19$var$CSSFloatProperty = $e9436c4c4d600e19$var$Edge || $e9436c4c4d600e19$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$e9436c4c4d600e19$var$supportDraggable = $e9436c4c4d600e19$var$documentExists && !$e9436c4c4d600e19$var$ChromeForAndroid && !$e9436c4c4d600e19$var$IOS && "draggable" in document.createElement("div"), $e9436c4c4d600e19$var$supportCssPointerEvents = function() {
    if (!$e9436c4c4d600e19$var$documentExists) return;
    // false when <= IE11
    if ($e9436c4c4d600e19$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $e9436c4c4d600e19$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $e9436c4c4d600e19$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $e9436c4c4d600e19$var$getChild(el, 0, options), child2 = $e9436c4c4d600e19$var$getChild(el, 1, options), firstChildCSS = child1 && $e9436c4c4d600e19$var$css(child1), secondChildCSS = child2 && $e9436c4c4d600e19$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $e9436c4c4d600e19$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $e9436c4c4d600e19$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$e9436c4c4d600e19$var$CSSFloatProperty] === "none" || child2 && elCSS[$e9436c4c4d600e19$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $e9436c4c4d600e19$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $e9436c4c4d600e19$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $e9436c4c4d600e19$var$sortables.some(function(sortable) {
        var threshold = sortable[$e9436c4c4d600e19$var$expando].options.emptyInsertThreshold;
        if (!threshold || $e9436c4c4d600e19$var$lastChild(sortable)) return;
        var rect = $e9436c4c4d600e19$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $e9436c4c4d600e19$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $e9436c4c4d600e19$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $e9436c4c4d600e19$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$e9436c4c4d600e19$var$supportCssPointerEvents && $e9436c4c4d600e19$var$ghostEl) $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "display", "none");
}, $e9436c4c4d600e19$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$e9436c4c4d600e19$var$supportCssPointerEvents && $e9436c4c4d600e19$var$ghostEl) $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "display", "");
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($e9436c4c4d600e19$var$documentExists && !$e9436c4c4d600e19$var$ChromeForAndroid) document.addEventListener("click", function(evt) {
    if ($e9436c4c4d600e19$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $e9436c4c4d600e19$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $e9436c4c4d600e19$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($e9436c4c4d600e19$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $e9436c4c4d600e19$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$e9436c4c4d600e19$var$expando]._onDragOver(event);
        }
    }
};
var $e9436c4c4d600e19$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($e9436c4c4d600e19$var$dragEl) $e9436c4c4d600e19$var$dragEl.parentNode[$e9436c4c4d600e19$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $e9436c4c4d600e19$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $e9436c4c4d600e19$var$_extends({}, options);
    // Export instance
    el[$e9436c4c4d600e19$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $e9436c4c4d600e19$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $e9436c4c4d600e19$export$31b3ca70d8f57423.supportPointer !== false && "PointerEvent" in window && !$e9436c4c4d600e19$var$Safari,
        emptyInsertThreshold: 5
    };
    $e9436c4c4d600e19$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $e9436c4c4d600e19$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $e9436c4c4d600e19$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $e9436c4c4d600e19$var$on(el, "pointerdown", this._onTapStart);
    else {
        $e9436c4c4d600e19$var$on(el, "mousedown", this._onTapStart);
        $e9436c4c4d600e19$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $e9436c4c4d600e19$var$on(el, "dragover", this);
        $e9436c4c4d600e19$var$on(el, "dragenter", this);
    }
    $e9436c4c4d600e19$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $e9436c4c4d600e19$var$_extends(this, $e9436c4c4d600e19$var$AnimationStateManager());
}
$e9436c4c4d600e19$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $e9436c4c4d600e19$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $e9436c4c4d600e19$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $e9436c4c4d600e19$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $e9436c4c4d600e19$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($e9436c4c4d600e19$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $e9436c4c4d600e19$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $e9436c4c4d600e19$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($e9436c4c4d600e19$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $e9436c4c4d600e19$var$oldIndex = $e9436c4c4d600e19$var$index(target);
        $e9436c4c4d600e19$var$oldDraggableIndex = $e9436c4c4d600e19$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $e9436c4c4d600e19$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $e9436c4c4d600e19$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $e9436c4c4d600e19$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $e9436c4c4d600e19$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $e9436c4c4d600e19$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$e9436c4c4d600e19$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$e9436c4c4d600e19$var$dragEl && target.parentNode === el) {
            var dragRect = $e9436c4c4d600e19$var$getRect(target);
            $e9436c4c4d600e19$var$rootEl = el;
            $e9436c4c4d600e19$var$dragEl = target;
            $e9436c4c4d600e19$var$parentEl = $e9436c4c4d600e19$var$dragEl.parentNode;
            $e9436c4c4d600e19$var$nextEl = $e9436c4c4d600e19$var$dragEl.nextSibling;
            $e9436c4c4d600e19$var$lastDownEl = target;
            $e9436c4c4d600e19$var$activeGroup = options.group;
            $e9436c4c4d600e19$export$31b3ca70d8f57423.dragged = $e9436c4c4d600e19$var$dragEl;
            $e9436c4c4d600e19$var$tapEvt = {
                target: $e9436c4c4d600e19$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $e9436c4c4d600e19$var$tapDistanceLeft = $e9436c4c4d600e19$var$tapEvt.clientX - dragRect.left;
            $e9436c4c4d600e19$var$tapDistanceTop = $e9436c4c4d600e19$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $e9436c4c4d600e19$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $e9436c4c4d600e19$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($e9436c4c4d600e19$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$e9436c4c4d600e19$var$FireFox && _this.nativeDraggable) $e9436c4c4d600e19$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $e9436c4c4d600e19$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                });
                // Chosen item
                $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $e9436c4c4d600e19$var$find($e9436c4c4d600e19$var$dragEl, criteria.trim(), $e9436c4c4d600e19$var$_disableDraggable);
            });
            $e9436c4c4d600e19$var$on(ownerDocument, "dragover", $e9436c4c4d600e19$var$nearestEmptyInsertDetectEvent);
            $e9436c4c4d600e19$var$on(ownerDocument, "mousemove", $e9436c4c4d600e19$var$nearestEmptyInsertDetectEvent);
            $e9436c4c4d600e19$var$on(ownerDocument, "touchmove", $e9436c4c4d600e19$var$nearestEmptyInsertDetectEvent);
            $e9436c4c4d600e19$var$on(ownerDocument, "mouseup", _this._onDrop);
            $e9436c4c4d600e19$var$on(ownerDocument, "touchend", _this._onDrop);
            $e9436c4c4d600e19$var$on(ownerDocument, "touchcancel", _this._onDrop);
            // Make dragEl draggable (must be before delay for FireFox)
            if ($e9436c4c4d600e19$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $e9436c4c4d600e19$var$dragEl.draggable = true;
            }
            $e9436c4c4d600e19$var$pluginEvent("delayStart", this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($e9436c4c4d600e19$var$Edge || $e9436c4c4d600e19$var$IE11OrLess))) {
                if ($e9436c4c4d600e19$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $e9436c4c4d600e19$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $e9436c4c4d600e19$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $e9436c4c4d600e19$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $e9436c4c4d600e19$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $e9436c4c4d600e19$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $e9436c4c4d600e19$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $e9436c4c4d600e19$var$dragEl && $e9436c4c4d600e19$var$_disableDraggable($e9436c4c4d600e19$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $e9436c4c4d600e19$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $e9436c4c4d600e19$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $e9436c4c4d600e19$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $e9436c4c4d600e19$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $e9436c4c4d600e19$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $e9436c4c4d600e19$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $e9436c4c4d600e19$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $e9436c4c4d600e19$var$on(document, "touchmove", this._onTouchMove);
            else $e9436c4c4d600e19$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $e9436c4c4d600e19$var$on($e9436c4c4d600e19$var$dragEl, "dragend", this);
            $e9436c4c4d600e19$var$on($e9436c4c4d600e19$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $e9436c4c4d600e19$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $e9436c4c4d600e19$var$awaitingDragStarted = false;
        if ($e9436c4c4d600e19$var$rootEl && $e9436c4c4d600e19$var$dragEl) {
            $e9436c4c4d600e19$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $e9436c4c4d600e19$var$on(document, "dragover", $e9436c4c4d600e19$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$dragEl, options.dragClass, false);
            $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$dragEl, options.ghostClass, true);
            $e9436c4c4d600e19$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $e9436c4c4d600e19$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($e9436c4c4d600e19$var$touchEvt) {
            this._lastX = $e9436c4c4d600e19$var$touchEvt.clientX;
            this._lastY = $e9436c4c4d600e19$var$touchEvt.clientY;
            $e9436c4c4d600e19$var$_hideGhostForTarget();
            var target = document.elementFromPoint($e9436c4c4d600e19$var$touchEvt.clientX, $e9436c4c4d600e19$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($e9436c4c4d600e19$var$touchEvt.clientX, $e9436c4c4d600e19$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $e9436c4c4d600e19$var$dragEl.parentNode[$e9436c4c4d600e19$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$e9436c4c4d600e19$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$e9436c4c4d600e19$var$expando]._onDragOver({
                        clientX: $e9436c4c4d600e19$var$touchEvt.clientX,
                        clientY: $e9436c4c4d600e19$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $e9436c4c4d600e19$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($e9436c4c4d600e19$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $e9436c4c4d600e19$var$ghostEl && $e9436c4c4d600e19$var$matrix($e9436c4c4d600e19$var$ghostEl, true), scaleX = $e9436c4c4d600e19$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $e9436c4c4d600e19$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $e9436c4c4d600e19$var$PositionGhostAbsolutely && $e9436c4c4d600e19$var$ghostRelativeParent && $e9436c4c4d600e19$var$getRelativeScrollOffset($e9436c4c4d600e19$var$ghostRelativeParent), dx = (touch.clientX - $e9436c4c4d600e19$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $e9436c4c4d600e19$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $e9436c4c4d600e19$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $e9436c4c4d600e19$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$e9436c4c4d600e19$export$31b3ca70d8f57423.active && !$e9436c4c4d600e19$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($e9436c4c4d600e19$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($e9436c4c4d600e19$var$lastDx || 0);
                    ghostMatrix.f += dy - ($e9436c4c4d600e19$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "webkitTransform", cssMatrix);
                $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "mozTransform", cssMatrix);
                $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "msTransform", cssMatrix);
                $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "transform", cssMatrix);
                $e9436c4c4d600e19$var$lastDx = dx;
                $e9436c4c4d600e19$var$lastDy = dy;
                $e9436c4c4d600e19$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$e9436c4c4d600e19$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $e9436c4c4d600e19$var$rootEl, rect = $e9436c4c4d600e19$var$getRect($e9436c4c4d600e19$var$dragEl, true, $e9436c4c4d600e19$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($e9436c4c4d600e19$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $e9436c4c4d600e19$var$ghostRelativeParent = container;
                while($e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostRelativeParent, "position") === "static" && $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostRelativeParent, "transform") === "none" && $e9436c4c4d600e19$var$ghostRelativeParent !== document)$e9436c4c4d600e19$var$ghostRelativeParent = $e9436c4c4d600e19$var$ghostRelativeParent.parentNode;
                if ($e9436c4c4d600e19$var$ghostRelativeParent !== document.body && $e9436c4c4d600e19$var$ghostRelativeParent !== document.documentElement) {
                    if ($e9436c4c4d600e19$var$ghostRelativeParent === document) $e9436c4c4d600e19$var$ghostRelativeParent = $e9436c4c4d600e19$var$getWindowScrollingElement();
                    rect.top += $e9436c4c4d600e19$var$ghostRelativeParent.scrollTop;
                    rect.left += $e9436c4c4d600e19$var$ghostRelativeParent.scrollLeft;
                } else $e9436c4c4d600e19$var$ghostRelativeParent = $e9436c4c4d600e19$var$getWindowScrollingElement();
                $e9436c4c4d600e19$var$ghostRelativeParentInitialScroll = $e9436c4c4d600e19$var$getRelativeScrollOffset($e9436c4c4d600e19$var$ghostRelativeParent);
            }
            $e9436c4c4d600e19$var$ghostEl = $e9436c4c4d600e19$var$dragEl.cloneNode(true);
            $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$ghostEl, options.ghostClass, false);
            $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$ghostEl, options.fallbackClass, true);
            $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$ghostEl, options.dragClass, true);
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "transition", "");
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "transform", "");
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "box-sizing", "border-box");
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "margin", 0);
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "top", rect.top);
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "left", rect.left);
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "width", rect.width);
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "height", rect.height);
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "opacity", "0.8");
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "position", $e9436c4c4d600e19$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "zIndex", "100000");
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "pointerEvents", "none");
            $e9436c4c4d600e19$export$31b3ca70d8f57423.ghost = $e9436c4c4d600e19$var$ghostEl;
            container.appendChild($e9436c4c4d600e19$var$ghostEl);
            // Set transform-origin
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$ghostEl, "transform-origin", $e9436c4c4d600e19$var$tapDistanceLeft / parseInt($e9436c4c4d600e19$var$ghostEl.style.width) * 100 + "% " + $e9436c4c4d600e19$var$tapDistanceTop / parseInt($e9436c4c4d600e19$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $e9436c4c4d600e19$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($e9436c4c4d600e19$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $e9436c4c4d600e19$var$pluginEvent("setupClone", this);
        if (!$e9436c4c4d600e19$export$31b3ca70d8f57423.eventCanceled) {
            $e9436c4c4d600e19$var$cloneEl = $e9436c4c4d600e19$var$clone($e9436c4c4d600e19$var$dragEl);
            $e9436c4c4d600e19$var$cloneEl.removeAttribute("id");
            $e9436c4c4d600e19$var$cloneEl.draggable = false;
            $e9436c4c4d600e19$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$cloneEl, this.options.chosenClass, false);
            $e9436c4c4d600e19$export$31b3ca70d8f57423.clone = $e9436c4c4d600e19$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $e9436c4c4d600e19$var$_nextTick(function() {
            $e9436c4c4d600e19$var$pluginEvent("clone", _this);
            if ($e9436c4c4d600e19$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $e9436c4c4d600e19$var$rootEl.insertBefore($e9436c4c4d600e19$var$cloneEl, $e9436c4c4d600e19$var$dragEl);
            _this._hideClone();
            $e9436c4c4d600e19$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $e9436c4c4d600e19$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $e9436c4c4d600e19$var$off(document, "mouseup", _this._onDrop);
            $e9436c4c4d600e19$var$off(document, "touchend", _this._onDrop);
            $e9436c4c4d600e19$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $e9436c4c4d600e19$var$dragEl);
            }
            $e9436c4c4d600e19$var$on(document, "drop", _this);
            // #1276 fix:
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$dragEl, "transform", "translateZ(0)");
        }
        $e9436c4c4d600e19$var$awaitingDragStarted = true;
        _this._dragStartId = $e9436c4c4d600e19$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $e9436c4c4d600e19$var$on(document, "selectstart", _this);
        $e9436c4c4d600e19$var$moved = true;
        if ($e9436c4c4d600e19$var$Safari) $e9436c4c4d600e19$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $e9436c4c4d600e19$export$31b3ca70d8f57423.active, isOwner = $e9436c4c4d600e19$var$activeGroup === group, canSort = options.sort, fromSortable = $e9436c4c4d600e19$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($e9436c4c4d600e19$var$_silent) return;
        function dragOverEvent(name, extra) {
            $e9436c4c4d600e19$var$pluginEvent(name, _this, $e9436c4c4d600e19$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $e9436c4c4d600e19$var$_onMove($e9436c4c4d600e19$var$rootEl, el, $e9436c4c4d600e19$var$dragEl, dragRect, target, $e9436c4c4d600e19$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$dragEl, $e9436c4c4d600e19$var$putSortable ? $e9436c4c4d600e19$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$dragEl, options.ghostClass, true);
                }
                if ($e9436c4c4d600e19$var$putSortable !== _this && _this !== $e9436c4c4d600e19$export$31b3ca70d8f57423.active) $e9436c4c4d600e19$var$putSortable = _this;
                else if (_this === $e9436c4c4d600e19$export$31b3ca70d8f57423.active && $e9436c4c4d600e19$var$putSortable) $e9436c4c4d600e19$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $e9436c4c4d600e19$var$dragEl && !$e9436c4c4d600e19$var$dragEl.animated || target === el && !target.animated) $e9436c4c4d600e19$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $e9436c4c4d600e19$var$dragEl.parentNode[$e9436c4c4d600e19$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $e9436c4c4d600e19$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $e9436c4c4d600e19$var$newIndex = $e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$dragEl);
            $e9436c4c4d600e19$var$newDraggableIndex = $e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$dragEl, options.draggable);
            $e9436c4c4d600e19$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $e9436c4c4d600e19$var$newIndex,
                newDraggableIndex: $e9436c4c4d600e19$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $e9436c4c4d600e19$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($e9436c4c4d600e19$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($e9436c4c4d600e19$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $e9436c4c4d600e19$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $e9436c4c4d600e19$var$parentEl !== $e9436c4c4d600e19$var$rootEl // Reverting item into the original list
        ) : $e9436c4c4d600e19$var$putSortable === this || (this.lastPutMode = $e9436c4c4d600e19$var$activeGroup.checkPull(this, activeSortable, $e9436c4c4d600e19$var$dragEl, evt)) && group.checkPut(this, activeSortable, $e9436c4c4d600e19$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $e9436c4c4d600e19$var$getRect($e9436c4c4d600e19$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($e9436c4c4d600e19$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $e9436c4c4d600e19$var$parentEl = $e9436c4c4d600e19$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$e9436c4c4d600e19$export$31b3ca70d8f57423.eventCanceled) {
                    if ($e9436c4c4d600e19$var$nextEl) $e9436c4c4d600e19$var$rootEl.insertBefore($e9436c4c4d600e19$var$dragEl, $e9436c4c4d600e19$var$nextEl);
                    else $e9436c4c4d600e19$var$rootEl.appendChild($e9436c4c4d600e19$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $e9436c4c4d600e19$var$lastChild(el, options.draggable);
            if (!elLastChild || $e9436c4c4d600e19$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $e9436c4c4d600e19$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $e9436c4c4d600e19$var$getRect(target);
                if ($e9436c4c4d600e19$var$_onMove($e9436c4c4d600e19$var$rootEl, el, $e9436c4c4d600e19$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($e9436c4c4d600e19$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($e9436c4c4d600e19$var$dragEl);
                    $e9436c4c4d600e19$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $e9436c4c4d600e19$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $e9436c4c4d600e19$var$getChild(el, 0, options, true);
                if (firstChild === $e9436c4c4d600e19$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $e9436c4c4d600e19$var$getRect(target);
                if ($e9436c4c4d600e19$var$_onMove($e9436c4c4d600e19$var$rootEl, el, $e9436c4c4d600e19$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($e9436c4c4d600e19$var$dragEl, firstChild);
                    $e9436c4c4d600e19$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $e9436c4c4d600e19$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $e9436c4c4d600e19$var$dragEl.parentNode !== el, differentRowCol = !$e9436c4c4d600e19$var$_dragElInRowColumn($e9436c4c4d600e19$var$dragEl.animated && $e9436c4c4d600e19$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $e9436c4c4d600e19$var$isScrolledPast(target, "top", "top") || $e9436c4c4d600e19$var$isScrolledPast($e9436c4c4d600e19$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($e9436c4c4d600e19$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $e9436c4c4d600e19$var$pastFirstInvertThresh = false;
                    $e9436c4c4d600e19$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $e9436c4c4d600e19$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $e9436c4c4d600e19$var$isCircumstantialInvert, $e9436c4c4d600e19$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $e9436c4c4d600e19$var$parentEl.children[dragIndex];
                    }while (sibling && ($e9436c4c4d600e19$var$css(sibling, "display") === "none" || sibling === $e9436c4c4d600e19$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $e9436c4c4d600e19$var$lastTarget = target;
                $e9436c4c4d600e19$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $e9436c4c4d600e19$var$_onMove($e9436c4c4d600e19$var$rootEl, el, $e9436c4c4d600e19$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $e9436c4c4d600e19$var$_silent = true;
                    setTimeout($e9436c4c4d600e19$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($e9436c4c4d600e19$var$dragEl);
                    else target.parentNode.insertBefore($e9436c4c4d600e19$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $e9436c4c4d600e19$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $e9436c4c4d600e19$var$parentEl = $e9436c4c4d600e19$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$e9436c4c4d600e19$var$isCircumstantialInvert) $e9436c4c4d600e19$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $e9436c4c4d600e19$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($e9436c4c4d600e19$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $e9436c4c4d600e19$var$off(document, "mousemove", this._onTouchMove);
        $e9436c4c4d600e19$var$off(document, "touchmove", this._onTouchMove);
        $e9436c4c4d600e19$var$off(document, "pointermove", this._onTouchMove);
        $e9436c4c4d600e19$var$off(document, "dragover", $e9436c4c4d600e19$var$nearestEmptyInsertDetectEvent);
        $e9436c4c4d600e19$var$off(document, "mousemove", $e9436c4c4d600e19$var$nearestEmptyInsertDetectEvent);
        $e9436c4c4d600e19$var$off(document, "touchmove", $e9436c4c4d600e19$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $e9436c4c4d600e19$var$off(ownerDocument, "mouseup", this._onDrop);
        $e9436c4c4d600e19$var$off(ownerDocument, "touchend", this._onDrop);
        $e9436c4c4d600e19$var$off(ownerDocument, "pointerup", this._onDrop);
        $e9436c4c4d600e19$var$off(ownerDocument, "touchcancel", this._onDrop);
        $e9436c4c4d600e19$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $e9436c4c4d600e19$var$newIndex = $e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$dragEl);
        $e9436c4c4d600e19$var$newDraggableIndex = $e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$dragEl, options.draggable);
        $e9436c4c4d600e19$var$pluginEvent("drop", this, {
            evt: evt
        });
        $e9436c4c4d600e19$var$parentEl = $e9436c4c4d600e19$var$dragEl && $e9436c4c4d600e19$var$dragEl.parentNode;
        // Get again after plugin event
        $e9436c4c4d600e19$var$newIndex = $e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$dragEl);
        $e9436c4c4d600e19$var$newDraggableIndex = $e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$dragEl, options.draggable);
        if ($e9436c4c4d600e19$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $e9436c4c4d600e19$var$awaitingDragStarted = false;
        $e9436c4c4d600e19$var$isCircumstantialInvert = false;
        $e9436c4c4d600e19$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $e9436c4c4d600e19$var$_cancelNextTick(this.cloneId);
        $e9436c4c4d600e19$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $e9436c4c4d600e19$var$off(document, "drop", this);
            $e9436c4c4d600e19$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($e9436c4c4d600e19$var$Safari) $e9436c4c4d600e19$var$css(document.body, "user-select", "");
        $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$dragEl, "transform", "");
        if (evt) {
            if ($e9436c4c4d600e19$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $e9436c4c4d600e19$var$ghostEl && $e9436c4c4d600e19$var$ghostEl.parentNode && $e9436c4c4d600e19$var$ghostEl.parentNode.removeChild($e9436c4c4d600e19$var$ghostEl);
            if ($e9436c4c4d600e19$var$rootEl === $e9436c4c4d600e19$var$parentEl || $e9436c4c4d600e19$var$putSortable && $e9436c4c4d600e19$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $e9436c4c4d600e19$var$cloneEl && $e9436c4c4d600e19$var$cloneEl.parentNode && $e9436c4c4d600e19$var$cloneEl.parentNode.removeChild($e9436c4c4d600e19$var$cloneEl);
            if ($e9436c4c4d600e19$var$dragEl) {
                if (this.nativeDraggable) $e9436c4c4d600e19$var$off($e9436c4c4d600e19$var$dragEl, "dragend", this);
                $e9436c4c4d600e19$var$_disableDraggable($e9436c4c4d600e19$var$dragEl);
                $e9436c4c4d600e19$var$dragEl.style["will-change"] = "";
                // Remove classes
                // ghostClass is added in dragStarted
                if ($e9436c4c4d600e19$var$moved && !$e9436c4c4d600e19$var$awaitingDragStarted) $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$dragEl, $e9436c4c4d600e19$var$putSortable ? $e9436c4c4d600e19$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $e9436c4c4d600e19$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $e9436c4c4d600e19$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($e9436c4c4d600e19$var$rootEl !== $e9436c4c4d600e19$var$parentEl) {
                    if ($e9436c4c4d600e19$var$newIndex >= 0) {
                        // Add event
                        $e9436c4c4d600e19$var$_dispatchEvent({
                            rootEl: $e9436c4c4d600e19$var$parentEl,
                            name: "add",
                            toEl: $e9436c4c4d600e19$var$parentEl,
                            fromEl: $e9436c4c4d600e19$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $e9436c4c4d600e19$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $e9436c4c4d600e19$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $e9436c4c4d600e19$var$_dispatchEvent({
                            rootEl: $e9436c4c4d600e19$var$parentEl,
                            name: "sort",
                            toEl: $e9436c4c4d600e19$var$parentEl,
                            fromEl: $e9436c4c4d600e19$var$rootEl,
                            originalEvent: evt
                        });
                        $e9436c4c4d600e19$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $e9436c4c4d600e19$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $e9436c4c4d600e19$var$putSortable && $e9436c4c4d600e19$var$putSortable.save();
                } else {
                    if ($e9436c4c4d600e19$var$newIndex !== $e9436c4c4d600e19$var$oldIndex) {
                        if ($e9436c4c4d600e19$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $e9436c4c4d600e19$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $e9436c4c4d600e19$var$parentEl,
                                originalEvent: evt
                            });
                            $e9436c4c4d600e19$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $e9436c4c4d600e19$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($e9436c4c4d600e19$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($e9436c4c4d600e19$var$newIndex == null || $e9436c4c4d600e19$var$newIndex === -1) {
                        $e9436c4c4d600e19$var$newIndex = $e9436c4c4d600e19$var$oldIndex;
                        $e9436c4c4d600e19$var$newDraggableIndex = $e9436c4c4d600e19$var$oldDraggableIndex;
                    }
                    $e9436c4c4d600e19$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $e9436c4c4d600e19$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $e9436c4c4d600e19$var$pluginEvent("nulling", this);
        $e9436c4c4d600e19$var$rootEl = $e9436c4c4d600e19$var$dragEl = $e9436c4c4d600e19$var$parentEl = $e9436c4c4d600e19$var$ghostEl = $e9436c4c4d600e19$var$nextEl = $e9436c4c4d600e19$var$cloneEl = $e9436c4c4d600e19$var$lastDownEl = $e9436c4c4d600e19$var$cloneHidden = $e9436c4c4d600e19$var$tapEvt = $e9436c4c4d600e19$var$touchEvt = $e9436c4c4d600e19$var$moved = $e9436c4c4d600e19$var$newIndex = $e9436c4c4d600e19$var$newDraggableIndex = $e9436c4c4d600e19$var$oldIndex = $e9436c4c4d600e19$var$oldDraggableIndex = $e9436c4c4d600e19$var$lastTarget = $e9436c4c4d600e19$var$lastDirection = $e9436c4c4d600e19$var$putSortable = $e9436c4c4d600e19$var$activeGroup = $e9436c4c4d600e19$export$31b3ca70d8f57423.dragged = $e9436c4c4d600e19$export$31b3ca70d8f57423.ghost = $e9436c4c4d600e19$export$31b3ca70d8f57423.clone = $e9436c4c4d600e19$export$31b3ca70d8f57423.active = null;
        $e9436c4c4d600e19$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $e9436c4c4d600e19$var$savedInputChecked.length = $e9436c4c4d600e19$var$lastDx = $e9436c4c4d600e19$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($e9436c4c4d600e19$var$dragEl) {
                    this._onDragOver(evt);
                    $e9436c4c4d600e19$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($e9436c4c4d600e19$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $e9436c4c4d600e19$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($e9436c4c4d600e19$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $e9436c4c4d600e19$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $e9436c4c4d600e19$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $e9436c4c4d600e19$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $e9436c4c4d600e19$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$e9436c4c4d600e19$var$expando] = null;
        $e9436c4c4d600e19$var$off(el, "mousedown", this._onTapStart);
        $e9436c4c4d600e19$var$off(el, "touchstart", this._onTapStart);
        $e9436c4c4d600e19$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $e9436c4c4d600e19$var$off(el, "dragover", this);
            $e9436c4c4d600e19$var$off(el, "dragenter", this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $e9436c4c4d600e19$var$sortables.splice($e9436c4c4d600e19$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$e9436c4c4d600e19$var$cloneHidden) {
            $e9436c4c4d600e19$var$pluginEvent("hideClone", this);
            if ($e9436c4c4d600e19$export$31b3ca70d8f57423.eventCanceled) return;
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $e9436c4c4d600e19$var$cloneEl.parentNode) $e9436c4c4d600e19$var$cloneEl.parentNode.removeChild($e9436c4c4d600e19$var$cloneEl);
            $e9436c4c4d600e19$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($e9436c4c4d600e19$var$cloneHidden) {
            $e9436c4c4d600e19$var$pluginEvent("showClone", this);
            if ($e9436c4c4d600e19$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($e9436c4c4d600e19$var$dragEl.parentNode == $e9436c4c4d600e19$var$rootEl && !this.options.group.revertClone) $e9436c4c4d600e19$var$rootEl.insertBefore($e9436c4c4d600e19$var$cloneEl, $e9436c4c4d600e19$var$dragEl);
            else if ($e9436c4c4d600e19$var$nextEl) $e9436c4c4d600e19$var$rootEl.insertBefore($e9436c4c4d600e19$var$cloneEl, $e9436c4c4d600e19$var$nextEl);
            else $e9436c4c4d600e19$var$rootEl.appendChild($e9436c4c4d600e19$var$cloneEl);
            if (this.options.group.revertClone) this.animate($e9436c4c4d600e19$var$dragEl, $e9436c4c4d600e19$var$cloneEl);
            $e9436c4c4d600e19$var$css($e9436c4c4d600e19$var$cloneEl, "display", "");
            $e9436c4c4d600e19$var$cloneHidden = false;
        }
    }
};
function $e9436c4c4d600e19$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $e9436c4c4d600e19$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$e9436c4c4d600e19$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$e9436c4c4d600e19$var$IE11OrLess && !$e9436c4c4d600e19$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $e9436c4c4d600e19$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $e9436c4c4d600e19$var$_disableDraggable(el) {
    el.draggable = false;
}
function $e9436c4c4d600e19$var$_unsilent() {
    $e9436c4c4d600e19$var$_silent = false;
}
function $e9436c4c4d600e19$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $e9436c4c4d600e19$var$getRect($e9436c4c4d600e19$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $e9436c4c4d600e19$var$getChildContainingRectFromElement(sortable.el, sortable.options, $e9436c4c4d600e19$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $e9436c4c4d600e19$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $e9436c4c4d600e19$var$getRect($e9436c4c4d600e19$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $e9436c4c4d600e19$var$getChildContainingRectFromElement(sortable.el, sortable.options, $e9436c4c4d600e19$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $e9436c4c4d600e19$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $e9436c4c4d600e19$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$e9436c4c4d600e19$var$pastFirstInvertThresh && ($e9436c4c4d600e19$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $e9436c4c4d600e19$var$pastFirstInvertThresh = true;
            if (!$e9436c4c4d600e19$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($e9436c4c4d600e19$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $e9436c4c4d600e19$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $e9436c4c4d600e19$var$targetMoveDistance) return -$e9436c4c4d600e19$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $e9436c4c4d600e19$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $e9436c4c4d600e19$var$_getInsertDirection(target) {
    if ($e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$dragEl) < $e9436c4c4d600e19$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $e9436c4c4d600e19$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $e9436c4c4d600e19$var$_saveInputCheckedState(root) {
    $e9436c4c4d600e19$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $e9436c4c4d600e19$var$savedInputChecked.push(el);
    }
}
function $e9436c4c4d600e19$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $e9436c4c4d600e19$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($e9436c4c4d600e19$var$documentExists) $e9436c4c4d600e19$var$on(document, "touchmove", function(evt) {
    if (($e9436c4c4d600e19$export$31b3ca70d8f57423.active || $e9436c4c4d600e19$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$e9436c4c4d600e19$export$31b3ca70d8f57423.utils = {
    on: $e9436c4c4d600e19$var$on,
    off: $e9436c4c4d600e19$var$off,
    css: $e9436c4c4d600e19$var$css,
    find: $e9436c4c4d600e19$var$find,
    is: function is(el, selector) {
        return !!$e9436c4c4d600e19$var$closest(el, selector, el, false);
    },
    extend: $e9436c4c4d600e19$var$extend,
    throttle: $e9436c4c4d600e19$var$throttle,
    closest: $e9436c4c4d600e19$var$closest,
    toggleClass: $e9436c4c4d600e19$var$toggleClass,
    clone: $e9436c4c4d600e19$var$clone,
    index: $e9436c4c4d600e19$var$index,
    nextTick: $e9436c4c4d600e19$var$_nextTick,
    cancelNextTick: $e9436c4c4d600e19$var$_cancelNextTick,
    detectDirection: $e9436c4c4d600e19$var$_detectDirection,
    getChild: $e9436c4c4d600e19$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $e9436c4c4d600e19$export$31b3ca70d8f57423.get = function(element) {
    return element[$e9436c4c4d600e19$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $e9436c4c4d600e19$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $e9436c4c4d600e19$export$31b3ca70d8f57423.utils = $e9436c4c4d600e19$var$_objectSpread2($e9436c4c4d600e19$var$_objectSpread2({}, $e9436c4c4d600e19$export$31b3ca70d8f57423.utils), plugin.utils);
        $e9436c4c4d600e19$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $e9436c4c4d600e19$export$31b3ca70d8f57423.create = function(el, options) {
    return new $e9436c4c4d600e19$export$31b3ca70d8f57423(el, options);
};
// Export
$e9436c4c4d600e19$export$31b3ca70d8f57423.version = $e9436c4c4d600e19$var$version;
var $e9436c4c4d600e19$var$autoScrolls = [], $e9436c4c4d600e19$var$scrollEl, $e9436c4c4d600e19$var$scrollRootEl, $e9436c4c4d600e19$var$scrolling = false, $e9436c4c4d600e19$var$lastAutoScrollX, $e9436c4c4d600e19$var$lastAutoScrollY, $e9436c4c4d600e19$var$touchEvt$1, $e9436c4c4d600e19$var$pointerElemChangedInterval;
function $e9436c4c4d600e19$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $e9436c4c4d600e19$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $e9436c4c4d600e19$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $e9436c4c4d600e19$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $e9436c4c4d600e19$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $e9436c4c4d600e19$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $e9436c4c4d600e19$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $e9436c4c4d600e19$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $e9436c4c4d600e19$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $e9436c4c4d600e19$var$clearPointerElemChangedInterval();
            $e9436c4c4d600e19$var$clearAutoScrolls();
            $e9436c4c4d600e19$var$cancelThrottle();
        },
        nulling: function nulling() {
            $e9436c4c4d600e19$var$touchEvt$1 = $e9436c4c4d600e19$var$scrollRootEl = $e9436c4c4d600e19$var$scrollEl = $e9436c4c4d600e19$var$scrolling = $e9436c4c4d600e19$var$pointerElemChangedInterval = $e9436c4c4d600e19$var$lastAutoScrollX = $e9436c4c4d600e19$var$lastAutoScrollY = null;
            $e9436c4c4d600e19$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $e9436c4c4d600e19$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $e9436c4c4d600e19$var$Edge || $e9436c4c4d600e19$var$IE11OrLess || $e9436c4c4d600e19$var$Safari) {
                $e9436c4c4d600e19$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $e9436c4c4d600e19$var$getParentAutoScrollElement(elem, true);
                if ($e9436c4c4d600e19$var$scrolling && (!$e9436c4c4d600e19$var$pointerElemChangedInterval || x !== $e9436c4c4d600e19$var$lastAutoScrollX || y !== $e9436c4c4d600e19$var$lastAutoScrollY)) {
                    $e9436c4c4d600e19$var$pointerElemChangedInterval && $e9436c4c4d600e19$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $e9436c4c4d600e19$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $e9436c4c4d600e19$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $e9436c4c4d600e19$var$clearAutoScrolls();
                        }
                        $e9436c4c4d600e19$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $e9436c4c4d600e19$var$lastAutoScrollX = x;
                    $e9436c4c4d600e19$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $e9436c4c4d600e19$var$getParentAutoScrollElement(elem, true) === $e9436c4c4d600e19$var$getWindowScrollingElement()) {
                    $e9436c4c4d600e19$var$clearAutoScrolls();
                    return;
                }
                $e9436c4c4d600e19$var$autoScroll(evt, this.options, $e9436c4c4d600e19$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $e9436c4c4d600e19$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $e9436c4c4d600e19$var$clearAutoScrolls() {
    $e9436c4c4d600e19$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $e9436c4c4d600e19$var$autoScrolls = [];
}
function $e9436c4c4d600e19$var$clearPointerElemChangedInterval() {
    clearInterval($e9436c4c4d600e19$var$pointerElemChangedInterval);
}
var $e9436c4c4d600e19$var$autoScroll = $e9436c4c4d600e19$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $e9436c4c4d600e19$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($e9436c4c4d600e19$var$scrollRootEl !== rootEl) {
        $e9436c4c4d600e19$var$scrollRootEl = rootEl;
        $e9436c4c4d600e19$var$clearAutoScrolls();
        $e9436c4c4d600e19$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($e9436c4c4d600e19$var$scrollEl === true) $e9436c4c4d600e19$var$scrollEl = $e9436c4c4d600e19$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $e9436c4c4d600e19$var$scrollEl;
    do {
        var el = currentParent, rect = $e9436c4c4d600e19$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $e9436c4c4d600e19$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$e9436c4c4d600e19$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$e9436c4c4d600e19$var$autoScrolls[i]) $e9436c4c4d600e19$var$autoScrolls[i] = {};
        }
        if ($e9436c4c4d600e19$var$autoScrolls[layersOut].vx != vx || $e9436c4c4d600e19$var$autoScrolls[layersOut].vy != vy || $e9436c4c4d600e19$var$autoScrolls[layersOut].el !== el) {
            $e9436c4c4d600e19$var$autoScrolls[layersOut].el = el;
            $e9436c4c4d600e19$var$autoScrolls[layersOut].vx = vx;
            $e9436c4c4d600e19$var$autoScrolls[layersOut].vy = vy;
            clearInterval($e9436c4c4d600e19$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $e9436c4c4d600e19$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $e9436c4c4d600e19$export$31b3ca70d8f57423.active._onTouchMove($e9436c4c4d600e19$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $e9436c4c4d600e19$var$autoScrolls[this.layer].vy ? $e9436c4c4d600e19$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $e9436c4c4d600e19$var$autoScrolls[this.layer].vx ? $e9436c4c4d600e19$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($e9436c4c4d600e19$export$31b3ca70d8f57423.dragged.parentNode[$e9436c4c4d600e19$var$expando], scrollOffsetX, scrollOffsetY, evt, $e9436c4c4d600e19$var$touchEvt$1, $e9436c4c4d600e19$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $e9436c4c4d600e19$var$scrollBy($e9436c4c4d600e19$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $e9436c4c4d600e19$var$getParentAutoScrollElement(currentParent, false)));
    $e9436c4c4d600e19$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $e9436c4c4d600e19$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $e9436c4c4d600e19$var$Revert() {}
$e9436c4c4d600e19$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $e9436c4c4d600e19$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $e9436c4c4d600e19$var$drop
};
$e9436c4c4d600e19$var$_extends($e9436c4c4d600e19$var$Revert, {
    pluginName: "revertOnSpill"
});
function $e9436c4c4d600e19$var$Remove() {}
$e9436c4c4d600e19$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $e9436c4c4d600e19$var$drop
};
$e9436c4c4d600e19$var$_extends($e9436c4c4d600e19$var$Remove, {
    pluginName: "removeOnSpill"
});
var $e9436c4c4d600e19$var$lastSwapEl;
function $e9436c4c4d600e19$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $e9436c4c4d600e19$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $e9436c4c4d600e19$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $e9436c4c4d600e19$var$toggleClass(target, options.swapClass, true);
                    $e9436c4c4d600e19$var$lastSwapEl = target;
                } else $e9436c4c4d600e19$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $e9436c4c4d600e19$var$lastSwapEl) $e9436c4c4d600e19$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $e9436c4c4d600e19$var$lastSwapEl && $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$lastSwapEl, options.swapClass, false);
            if ($e9436c4c4d600e19$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $e9436c4c4d600e19$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $e9436c4c4d600e19$var$swapNodes(dragEl, $e9436c4c4d600e19$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $e9436c4c4d600e19$var$lastSwapEl = null;
        }
    };
    return $e9436c4c4d600e19$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $e9436c4c4d600e19$var$lastSwapEl
            };
        }
    });
}
function $e9436c4c4d600e19$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $e9436c4c4d600e19$var$index(n1);
    i2 = $e9436c4c4d600e19$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $e9436c4c4d600e19$var$multiDragElements = [], $e9436c4c4d600e19$var$multiDragClones = [], $e9436c4c4d600e19$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$e9436c4c4d600e19$var$multiDragSortable, $e9436c4c4d600e19$var$initialFolding = false, // Initial multi-drag fold when drag started
$e9436c4c4d600e19$var$folding = false, // Folding any other time
$e9436c4c4d600e19$var$dragStarted = false, $e9436c4c4d600e19$var$dragEl$1, $e9436c4c4d600e19$var$clonesFromRect, $e9436c4c4d600e19$var$clonesHidden;
function $e9436c4c4d600e19$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $e9436c4c4d600e19$var$on(document, "pointerup", this._deselectMultiDrag);
            else {
                $e9436c4c4d600e19$var$on(document, "mouseup", this._deselectMultiDrag);
                $e9436c4c4d600e19$var$on(document, "touchend", this._deselectMultiDrag);
            }
        }
        $e9436c4c4d600e19$var$on(document, "keydown", this._checkKeyDown);
        $e9436c4c4d600e19$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($e9436c4c4d600e19$var$multiDragElements.length && $e9436c4c4d600e19$var$multiDragSortable === sortable) $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $e9436c4c4d600e19$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$e9436c4c4d600e19$var$multiDragElements.indexOf($e9436c4c4d600e19$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $e9436c4c4d600e19$var$multiDragElements.length; i++){
                $e9436c4c4d600e19$var$multiDragClones.push($e9436c4c4d600e19$var$clone($e9436c4c4d600e19$var$multiDragElements[i]));
                $e9436c4c4d600e19$var$multiDragClones[i].sortableIndex = $e9436c4c4d600e19$var$multiDragElements[i].sortableIndex;
                $e9436c4c4d600e19$var$multiDragClones[i].draggable = false;
                $e9436c4c4d600e19$var$multiDragClones[i].style["will-change"] = "";
                $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$multiDragClones[i], this.options.selectedClass, false);
                $e9436c4c4d600e19$var$multiDragElements[i] === $e9436c4c4d600e19$var$dragEl$1 && $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($e9436c4c4d600e19$var$multiDragElements.length && $e9436c4c4d600e19$var$multiDragSortable === sortable) {
                    $e9436c4c4d600e19$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $e9436c4c4d600e19$var$insertMultiDragClones(false, rootEl);
            $e9436c4c4d600e19$var$multiDragClones.forEach(function(clone) {
                $e9436c4c4d600e19$var$css(clone, "display", "");
            });
            cloneNowShown();
            $e9436c4c4d600e19$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $e9436c4c4d600e19$var$multiDragClones.forEach(function(clone) {
                $e9436c4c4d600e19$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $e9436c4c4d600e19$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $e9436c4c4d600e19$var$multiDragSortable) $e9436c4c4d600e19$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $e9436c4c4d600e19$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $e9436c4c4d600e19$var$multiDragElements = $e9436c4c4d600e19$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $e9436c4c4d600e19$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $e9436c4c4d600e19$var$dragEl$1) return;
                        $e9436c4c4d600e19$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $e9436c4c4d600e19$var$getRect($e9436c4c4d600e19$var$dragEl$1, false, true, true);
                    $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $e9436c4c4d600e19$var$dragEl$1) return;
                        $e9436c4c4d600e19$var$setRect(multiDragElement, dragRect);
                    });
                    $e9436c4c4d600e19$var$folding = true;
                    $e9436c4c4d600e19$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $e9436c4c4d600e19$var$folding = false;
                $e9436c4c4d600e19$var$initialFolding = false;
                if (_this2.options.animation) $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                    $e9436c4c4d600e19$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $e9436c4c4d600e19$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($e9436c4c4d600e19$var$folding && ~$e9436c4c4d600e19$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($e9436c4c4d600e19$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $e9436c4c4d600e19$var$folding ? $e9436c4c4d600e19$var$getRect(multiDragElement) : dragRect
                    });
                    $e9436c4c4d600e19$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $e9436c4c4d600e19$var$folding = false;
                $e9436c4c4d600e19$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $e9436c4c4d600e19$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $e9436c4c4d600e19$var$multiDragElements.length > 1 && ($e9436c4c4d600e19$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $e9436c4c4d600e19$var$getRect($e9436c4c4d600e19$var$dragEl$1, false, true, true);
                    $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $e9436c4c4d600e19$var$dragEl$1) return;
                        $e9436c4c4d600e19$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $e9436c4c4d600e19$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$e9436c4c4d600e19$var$folding) $e9436c4c4d600e19$var$removeMultiDragElements();
                    if ($e9436c4c4d600e19$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $e9436c4c4d600e19$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$e9436c4c4d600e19$var$clonesHidden && clonesHiddenBefore) $e9436c4c4d600e19$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $e9436c4c4d600e19$var$clonesFromRect
                            });
                            clone.fromRect = $e9436c4c4d600e19$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $e9436c4c4d600e19$var$clonesFromRect = $e9436c4c4d600e19$var$_extends({}, dragRect);
                var dragMatrix = $e9436c4c4d600e19$var$matrix($e9436c4c4d600e19$var$dragEl$1, true);
                $e9436c4c4d600e19$var$clonesFromRect.top -= dragMatrix.f;
                $e9436c4c4d600e19$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($e9436c4c4d600e19$var$folding) {
                $e9436c4c4d600e19$var$folding = false;
                $e9436c4c4d600e19$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$e9436c4c4d600e19$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $e9436c4c4d600e19$var$toggleClass($e9436c4c4d600e19$var$dragEl$1, options.selectedClass, !~$e9436c4c4d600e19$var$multiDragElements.indexOf($e9436c4c4d600e19$var$dragEl$1));
                if (!~$e9436c4c4d600e19$var$multiDragElements.indexOf($e9436c4c4d600e19$var$dragEl$1)) {
                    $e9436c4c4d600e19$var$multiDragElements.push($e9436c4c4d600e19$var$dragEl$1);
                    $e9436c4c4d600e19$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $e9436c4c4d600e19$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $e9436c4c4d600e19$var$lastMultiDragSelect && sortable.el.contains($e9436c4c4d600e19$var$lastMultiDragSelect)) {
                        var lastIndex = $e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$lastMultiDragSelect), currentIndex = $e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$e9436c4c4d600e19$var$multiDragElements.indexOf(children[i])) continue;
                                $e9436c4c4d600e19$var$toggleClass(children[i], options.selectedClass, true);
                                $e9436c4c4d600e19$var$multiDragElements.push(children[i]);
                                $e9436c4c4d600e19$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $e9436c4c4d600e19$var$lastMultiDragSelect = $e9436c4c4d600e19$var$dragEl$1;
                    $e9436c4c4d600e19$var$multiDragSortable = toSortable;
                } else {
                    $e9436c4c4d600e19$var$multiDragElements.splice($e9436c4c4d600e19$var$multiDragElements.indexOf($e9436c4c4d600e19$var$dragEl$1), 1);
                    $e9436c4c4d600e19$var$lastMultiDragSelect = null;
                    $e9436c4c4d600e19$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $e9436c4c4d600e19$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($e9436c4c4d600e19$var$dragStarted && this.isMultiDrag) {
                $e9436c4c4d600e19$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$e9436c4c4d600e19$var$expando].options.sort || parentEl !== rootEl) && $e9436c4c4d600e19$var$multiDragElements.length > 1) {
                    var dragRect = $e9436c4c4d600e19$var$getRect($e9436c4c4d600e19$var$dragEl$1), multiDragIndex = $e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$e9436c4c4d600e19$var$initialFolding && options.animation) $e9436c4c4d600e19$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$e9436c4c4d600e19$var$initialFolding) {
                        if (options.animation) {
                            $e9436c4c4d600e19$var$dragEl$1.fromRect = dragRect;
                            $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $e9436c4c4d600e19$var$dragEl$1) {
                                    var rect = $e9436c4c4d600e19$var$folding ? $e9436c4c4d600e19$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $e9436c4c4d600e19$var$removeMultiDragElements();
                        $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $e9436c4c4d600e19$var$index($e9436c4c4d600e19$var$dragEl$1)) {
                            var update = false;
                            $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $e9436c4c4d600e19$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent("update");
                                dispatchSortableEvent("sort");
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                        $e9436c4c4d600e19$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $e9436c4c4d600e19$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $e9436c4c4d600e19$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $e9436c4c4d600e19$var$dragStarted = false;
            $e9436c4c4d600e19$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $e9436c4c4d600e19$var$off(document, "pointerup", this._deselectMultiDrag);
            $e9436c4c4d600e19$var$off(document, "mouseup", this._deselectMultiDrag);
            $e9436c4c4d600e19$var$off(document, "touchend", this._deselectMultiDrag);
            $e9436c4c4d600e19$var$off(document, "keydown", this._checkKeyDown);
            $e9436c4c4d600e19$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $e9436c4c4d600e19$var$dragStarted !== "undefined" && $e9436c4c4d600e19$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($e9436c4c4d600e19$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $e9436c4c4d600e19$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($e9436c4c4d600e19$var$multiDragElements.length){
                var el = $e9436c4c4d600e19$var$multiDragElements[0];
                $e9436c4c4d600e19$var$toggleClass(el, this.options.selectedClass, false);
                $e9436c4c4d600e19$var$multiDragElements.shift();
                $e9436c4c4d600e19$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $e9436c4c4d600e19$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$e9436c4c4d600e19$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$e9436c4c4d600e19$var$multiDragElements.indexOf(el)) return;
                if ($e9436c4c4d600e19$var$multiDragSortable && $e9436c4c4d600e19$var$multiDragSortable !== sortable) {
                    $e9436c4c4d600e19$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $e9436c4c4d600e19$var$multiDragSortable = sortable;
                }
                $e9436c4c4d600e19$var$toggleClass(el, sortable.options.selectedClass, true);
                $e9436c4c4d600e19$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$e9436c4c4d600e19$var$expando], index = $e9436c4c4d600e19$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $e9436c4c4d600e19$var$toggleClass(el, sortable.options.selectedClass, false);
                $e9436c4c4d600e19$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($e9436c4c4d600e19$var$folding && multiDragElement !== $e9436c4c4d600e19$var$dragEl$1) newIndex = -1;
                else if ($e9436c4c4d600e19$var$folding) newIndex = $e9436c4c4d600e19$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $e9436c4c4d600e19$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $e9436c4c4d600e19$var$_toConsumableArray($e9436c4c4d600e19$var$multiDragElements),
                clones: [].concat($e9436c4c4d600e19$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $e9436c4c4d600e19$var$insertMultiDragElements(clonesInserted, rootEl) {
    $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $e9436c4c4d600e19$var$insertMultiDragClones(elementsInserted, rootEl) {
    $e9436c4c4d600e19$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $e9436c4c4d600e19$var$removeMultiDragElements() {
    $e9436c4c4d600e19$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $e9436c4c4d600e19$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$e9436c4c4d600e19$export$31b3ca70d8f57423.mount(new $e9436c4c4d600e19$var$AutoScrollPlugin());
$e9436c4c4d600e19$export$31b3ca70d8f57423.mount($e9436c4c4d600e19$var$Remove, $e9436c4c4d600e19$var$Revert);
var $e9436c4c4d600e19$export$2e2bcd8739ae039 = $e9436c4c4d600e19$export$31b3ca70d8f57423;


class $905e822fdeb5e0e6$export$31b3ca70d8f57423 extends (0, $e9436c4c4d600e19$export$2e2bcd8739ae039) {
}


class $de3a0b1bbf7828e4$export$40da85cfb177ef04 extends Error {
    constructor(message){
        super(message);
        this.name = "InvalidIdError";
    }
}
class $de3a0b1bbf7828e4$export$d9f3c5f91b7099dd extends Error {
    constructor(message){
        super(message);
        this.name = "InvalidIndexError";
    }
}
class $de3a0b1bbf7828e4$export$2e2bcd8739ae039 extends (0, $905e822fdeb5e0e6$export$31b3ca70d8f57423) {
    _onKeyDown(e) {
        const sortable = (0, $905e822fdeb5e0e6$export$31b3ca70d8f57423).get(this);
        if (!sortable.options.hasKeybinds || sortable.options.disabled || !e.key.startsWith("Arrow")) return;
        if (sortable.options.direction === "vertical" && !(e.key === "ArrowUp" || e.key === "ArrowDown") || sortable.options.direction === "horizontal" && !(e.key === "ArrowLeft" || e.key === "ArrowRight")) return;
        try {
            if (e.key === "ArrowUp" || e.key === "ArrowLeft") sortable.moveUp(e.target.getAttribute(sortable.options.dataIdAttr), !!sortable.options.animation);
            else if (e.key === "ArrowDown" || e.key === "ArrowRight") sortable.moveDown(e.target.getAttribute(sortable.options.dataIdAttr), !!sortable.options.animation);
            sortable.options.onKeyBindMove(e);
            e.target.focus();
        } catch (e) {
            if (e instanceof $de3a0b1bbf7828e4$export$40da85cfb177ef04 || e instanceof $de3a0b1bbf7828e4$export$d9f3c5f91b7099dd) return;
        }
    }
    destroy() {
        (0, $905e822fdeb5e0e6$export$31b3ca70d8f57423).utils.off(this.el, "keydown", this._onKeyDown);
        super.destroy();
    }
    sort(order, useAnimation) {
        const items = this.serialMap();
        const children = Array.from(this.el.children).map((e, i)=>({
                e: e,
                i: i
            })).filter(({ e: e })=>(0, $905e822fdeb5e0e6$export$31b3ca70d8f57423).utils.closest(e, this.options.draggable));
        useAnimation && this.captureAnimationState();
        order.slice(0, -1).forEach((id, index)=>{
            this.swapNodes(this.el.children[children[index].i], items[id]);
        });
        useAnimation && this.animateAll();
    }
    _swap(a, b, useAnimation) {
        if (![
            a,
            b
        ].every((v)=>this.toArray().includes(v))) throw new $de3a0b1bbf7828e4$export$40da85cfb177ef04("swap must receive two valid serialized items");
        const items = this.serialMap();
        useAnimation && this.captureAnimationState();
        this.swapNodes(items[a], items[b]);
        useAnimation && this.animateAll();
    }
    moveUp(id, useAnimation) {
        const ids = this.toArray();
        if (!ids.includes(id)) throw new $de3a0b1bbf7828e4$export$40da85cfb177ef04("moveUp must receive a valid serialized item");
        const index = ids.indexOf(id);
        if (index <= 0) throw new $de3a0b1bbf7828e4$export$d9f3c5f91b7099dd("item already at the start");
        this._swap(id, ids[index - 1], useAnimation);
    }
    moveDown(id, useAnimation) {
        const ids = this.toArray();
        if (!ids.includes(id)) throw new $de3a0b1bbf7828e4$export$40da85cfb177ef04("moveDown must receive a valid serialized item");
        const index = ids.indexOf(id);
        if (index >= ids.length - 1) throw new $de3a0b1bbf7828e4$export$d9f3c5f91b7099dd("item already at the end");
        this._swap(id, ids[index + 1], useAnimation);
    }
    children() {
        return Array.from(this.el.children).filter((c)=>(0, $905e822fdeb5e0e6$export$31b3ca70d8f57423).utils.closest(c, this.options.draggable));
    }
    serialMap() {
        const children = this.children();
        return this.toArray().reduce((result, id, index)=>({
                ...result,
                [id]: children[index]
            }), {});
    }
    swapNodes(n1, n2) {
        let p1 = n1.parentNode, p2 = n2.parentNode;
        if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
        let i1 = (0, $905e822fdeb5e0e6$export$31b3ca70d8f57423).utils.index(n1);
        let i2 = (0, $905e822fdeb5e0e6$export$31b3ca70d8f57423).utils.index(n2);
        if (p1.isEqualNode(p2) && i1 < i2) i2++;
        p1.insertBefore(n2, p1.children[i1]);
        p2.insertBefore(n1, p2.children[i2]);
    }
    static get(element) {
        return (0, $905e822fdeb5e0e6$export$31b3ca70d8f57423).get(element);
    }
    constructor(el, options){
        const defaults = {
            hasKeybinds: true
        };
        super(el, {
            ...defaults,
            ...options
        });
        this.moveLeft = this.moveUp;
        this.moveRight = this.moveDown;
        (0, $905e822fdeb5e0e6$export$31b3ca70d8f57423).utils.on(el, "keydown", this._onKeyDown);
    }
}


class $888888e1ba14c771$export$215771809dcb7028 extends (0, $6f125744f8893ba5$export$94cd813f5440f38d) {
    displayItemContent(content, bindTarget) {
        const matching = document.querySelector(".item .matching");
        matching.classList.remove("d-none");
        matching.classList.add("invisible");
        const name = matching.querySelector(".name");
        const prompt = matching.querySelector(".prompt");
        const style = matching.querySelector("style");
        name.innerHTML = content.name + ".";
        prompt.innerHTML = content.matching.prompt;
        style.innerText = [].concat(content.matching.style, content.contexts.map((c)=>c.style)).join("\n\n");
        Array.from(matching.querySelectorAll(".context-panel")).slice(1).forEach((panel)=>{
            panel.remove();
        });
        const contextPanel = matching.querySelector(".context-panel");
        const context = contextPanel.querySelector(".context");
        if (content.contexts.length > 0) {
            context.innerHTML = content.contexts[0].content_html;
            context.classList.remove("d-none");
            contextPanel.dataset.context = content.contexts[0].id;
            contextPanel.classList.remove("d-none");
            content.contexts.slice(1).reverse().forEach((_context)=>{
                const panel = contextPanel.cloneNode(true);
                const context = panel.querySelector(".context");
                context.innerHTML = _context.content_html;
                context.classList.remove("d-none");
                panel.dataset.context = _context.id;
                panel.classList.remove("d-none");
                panel.addEventListener("click", (e)=>{
                    bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$fe0b591ac3aa4171)([
                        panel.dataset.context
                    ]));
                });
                contextPanel.after(panel);
            });
        } else {
            context.innerHTML = "";
            context.classList.add("d-none");
            contextPanel.removeAttribute("data-context");
            contextPanel.classList.add("d-none");
        }
        const answers = matching.querySelector(".answers");
        const headers = Array.from(answers.querySelectorAll(".header")).map((e)=>e.cloneNode(true));
        const columns = parseInt(answers.dataset.columns) || answers.children.length - headers.length;
        if (!answers.dataset.columns) answers.dataset.columns = columns.toString();
        const templates = Array.from(answers.children).filter((a)=>!a.classList.contains("header")).filter((a, index)=>index % ((answers.children.length - headers.length) / columns) == 0).map((e)=>e.cloneNode(true));
        answers.innerHTML = "";
        templates.forEach((element)=>content.matching.answers.forEach((answer, index)=>{
                const itemNode = element.cloneNode(true);
                itemNode.dataset.id = index.toString();
                answers.appendChild(itemNode);
            }));
        headers.forEach((header)=>answers.appendChild(header));
        answers.style.gridTemplateRows = `repeat(${content.matching.answers.length + (headers.length ? 1 : 0)}, min-content)`;
        const terms = answers.querySelectorAll(".term");
        const definitions = answers.querySelectorAll(".definition");
        content.matching.answers.forEach((answer, index)=>{
            terms[index].innerHTML = answer.term;
            definitions[index].innerHTML = answer.definition;
        });
        new (0, $de3a0b1bbf7828e4$export$2e2bcd8739ae039)(answers, {
            draggable: ".sortable-term",
            disabled: true
        }).sort(content.matching.answers.reduce((res, answer, index)=>{
            res[answer.term_order] = index;
            return res;
        }, []).filter((n)=>n !== undefined).map(String));
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        const matching = document.querySelector(".item .matching");
        const defListTarget = matching.querySelector(".answers");
        const indexToTermOrder = Object.fromEntries(content.matching.answers.map((key, index)=>[
                index,
                key.term_order
            ]));
        const termOrderToIndex = Object.fromEntries(content.matching.answers.map((key, index)=>[
                key.term_order,
                index
            ]));
        (0, $de3a0b1bbf7828e4$export$2e2bcd8739ae039).get(defListTarget)?.destroy();
        const defList = new (0, $de3a0b1bbf7828e4$export$2e2bcd8739ae039)(defListTarget, {
            swap: true,
            draggable: ".sortable-definition",
            animation: 150,
            direction: "vertical",
            onUpdate: (e)=>{
                bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3dd7a8e950550ea4)(defList.toArray().map((i)=>indexToTermOrder[parseInt(i)])));
                e.item.focus();
            },
            onKeyBindMove: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3dd7a8e950550ea4)(defList.toArray().map((i)=>indexToTermOrder[parseInt(i)])));
            }
        });
        defList.children().forEach((element)=>{
            element.tabIndex = 0;
        });
        defList.sort(answer && answer.length > 0 ? answer.map((n)=>termOrderToIndex[n]).filter((n)=>n !== undefined).map(String) : content.matching.answers.reduce((res, answer, index)=>{
            res[answer.definition_order] = index;
            return res;
        }, []).filter((n)=>n !== undefined).map(String));
    }
    displayItemReview(content, rawAnswer) {
        const matching = document.querySelector(".item .matching");
        const termOrderToIndex = Object.fromEntries(content.matching.answers.map((key, index)=>[
                key.term_order,
                index
            ]));
        const answer = rawAnswer?.map((n)=>termOrderToIndex[n]);
        const explanation = matching.querySelector(".card .explanation");
        const explanationPanel = explanation.closest("div.card");
        explanation.innerHTML = content.matching.explanation;
        const answerLength = rawAnswer?.length ?? 0;
        const isCorrect = Array.from(content.matching.answers).map((answer, index)=>({
                ...answer,
                index: index
            })).sort((a, b)=>a.term_order - b.term_order).every((reference, index)=>answer && reference.index === answer[index]);
        const correct = document.querySelector(".correct");
        if (answerLength > 0 && isCorrect) {
            correct.innerHTML = "Correct";
            correct.classList.remove("alert-danger", "alert-info");
            correct.classList.add("alert-success");
            explanationPanel.classList.remove("border-danger", "border-info");
            explanationPanel.classList.add("border-success");
        } else if (answerLength > 0 && !isCorrect) {
            correct.innerHTML = "Incorrect";
            correct.classList.remove("alert-success", "alert-info");
            correct.classList.add("alert-danger");
            explanationPanel.classList.remove("border-success", "border-info");
            explanationPanel.classList.add("border-danger");
        } else {
            correct.innerHTML = "Unanswered";
            correct.classList.remove("alert-success", "alert-danger");
            correct.classList.add("alert-info");
            explanationPanel.classList.remove("border-success", "border-danger");
            explanationPanel.classList.add("border-info");
        }
        (0, $de3a0b1bbf7828e4$export$2e2bcd8739ae039).get(matching.querySelector(".answers")).option("disabled", true);
        const answers = matching.querySelectorAll(".answers .definition");
        const badges = matching.querySelectorAll(".answers .answer-correct");
        const references = matching.querySelectorAll(".answers .answer-reference");
        const explanations = matching.querySelectorAll(".answers .answer-explanation");
        Array.from(content.matching.answers).map((answer, index)=>({
                ...answer,
                index: index
            })).sort((a, b)=>a.term_order - b.term_order).forEach((answerRef, index)=>{
            const answerNode = answers[index];
            const reference = references[index];
            const correct = badges[index];
            const explanation = explanations[index];
            const isCorrect = answer?.[index] == answerRef.index;
            if (isCorrect) {
                answerNode.classList.remove("border-danger", "border-info");
                answerNode.classList.add("border-success");
                correct.classList.remove("text-bg-danger", "badge-danger", "text-bg-info", "badge-info");
                correct.classList.add("text-bg-success", "badge-success");
                correct.innerHTML = "Correct";
                reference.innerHTML = "";
                explanation.innerHTML = "";
            } else if (answerLength > 0 && !isCorrect) {
                answerNode.classList.remove("border-success", "border-info");
                answerNode.classList.add("border-danger");
                correct.classList.remove("text-bg-success", "badge-success", "text-bg-info", "badge-info");
                correct.classList.add("text-bg-danger", "badge-danger");
                correct.innerHTML = `Incorrect`;
                reference.innerHTML = answerRef.definition;
                explanation.innerHTML = answerRef.explanation;
            } else {
                answerNode.classList.remove("border-success", "border-danger");
                answerNode.classList.add("border-info");
                correct.classList.remove("text-bg-success", "badge-success", "text-bg-danger", "badge-danger");
                correct.classList.add("text-bg-info", "badge-info");
                correct.innerHTML = `Unanswered`;
                reference.innerHTML = answerRef.definition;
                explanation.innerHTML = answerRef.explanation;
            }
        });
    }
    displayItemRendered(content, mathjax) {
        const matching = document.querySelector(".item .matching");
        mathjax.typesetPromise().then(()=>{
            matching.classList.remove("invisible");
        });
    }
    displayItemAlerts(content) {
        // Do nothing.
        return;
    }
}





class $0c30ecb6ddb6e82a$export$116addb240a95eea extends (0, $6f125744f8893ba5$export$94cd813f5440f38d) {
    displayItemContent(content, bindTarget) {
        const sorting = document.querySelector(".item .sorting");
        sorting.classList.remove("d-none");
        sorting.classList.add("invisible");
        const name = sorting.querySelector(".name");
        const prompt = sorting.querySelector(".prompt");
        const style = sorting.querySelector("style");
        name.innerHTML = content.name + ".";
        prompt.innerHTML = content.sorting.prompt;
        style.innerText = [].concat(content.sorting.style, content.contexts.map((c)=>c.style)).join("\n\n");
        Array.from(sorting.querySelectorAll(".context-panel")).slice(1).forEach((panel)=>{
            panel.remove();
        });
        const contextPanel = sorting.querySelector(".context-panel");
        const context = contextPanel.querySelector(".context");
        if (content.contexts.length > 0) {
            context.innerHTML = content.contexts[0].content_html;
            context.classList.remove("d-none");
            contextPanel.dataset.context = content.contexts[0].id;
            contextPanel.classList.remove("d-none");
            content.contexts.slice(1).reverse().forEach((_context)=>{
                const panel = contextPanel.cloneNode(true);
                const context = panel.querySelector(".context");
                context.innerHTML = _context.content_html;
                context.classList.remove("d-none");
                panel.dataset.context = _context.id;
                panel.classList.remove("d-none");
                panel.addEventListener("click", (e)=>{
                    bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$fe0b591ac3aa4171)([
                        panel.dataset.context
                    ]));
                });
                contextPanel.after(panel);
            });
        } else {
            context.innerHTML = "";
            context.classList.add("d-none");
            contextPanel.removeAttribute("data-context");
            contextPanel.classList.add("d-none");
        }
        const answers = sorting.querySelector(".answers");
        const headers = Array.from(answers.querySelectorAll(".header")).map((e)=>e.cloneNode(true));
        const columns = parseInt(answers.dataset.columns) || answers.children.length - headers.length;
        if (!answers.dataset.columns) answers.dataset.columns = columns.toString();
        const templates = Array.from(answers.children).filter((e)=>!e.classList.contains("header")).filter((a, index)=>index % ((answers.children.length - headers.length) / columns) == 0).map((e)=>e.cloneNode(true));
        answers.innerHTML = "";
        templates.forEach((element)=>content.sorting.answers.forEach((answer, index)=>{
                const itemNode = element.cloneNode(true);
                itemNode.dataset.id = index.toString();
                answers.appendChild(itemNode);
            }));
        headers.forEach((header)=>answers.appendChild(header));
        answers.style.gridTemplateRows = `repeat(${content.sorting.answers.length + (headers.length ? 1 : 0)}, min-content)`;
        const answerItems = answers.querySelectorAll(".answer");
        content.sorting.answers.forEach((answer, index)=>{
            answerItems[index].innerHTML = answer.content;
        });
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        const sorting = document.querySelector(".item .sorting");
        const answerListTarget = sorting.querySelector(".answers");
        const indexToCorrectOrder = Object.fromEntries(content.sorting.answers.map((key, index)=>[
                index,
                key.correct_order
            ]));
        const correctOrderToIndex = Object.fromEntries(content.sorting.answers.map((key, index)=>[
                key.correct_order,
                index
            ]));
        (0, $de3a0b1bbf7828e4$export$2e2bcd8739ae039).get(answerListTarget)?.destroy();
        const answerList = new (0, $de3a0b1bbf7828e4$export$2e2bcd8739ae039)(answerListTarget, {
            swap: true,
            draggable: ".sortable",
            animation: 150,
            direction: "vertical",
            onUpdate: (e)=>{
                bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3dd7a8e950550ea4)(answerList.toArray().map((i)=>indexToCorrectOrder[parseInt(i)])));
                e.item.focus();
            },
            onKeyBindMove: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3dd7a8e950550ea4)(answerList.toArray().map((i)=>indexToCorrectOrder[parseInt(i)])));
            }
        });
        answerList.children().forEach((element)=>{
            element.tabIndex = 0;
        });
        answerList.sort(answer && answer.length > 0 ? answer.map((n)=>correctOrderToIndex[n]).filter((n)=>n !== undefined).map(String) : content.sorting.answers.reduce((res, answer, index)=>{
            res[answer.display_order] = index;
            return res;
        }, []).filter((n)=>n !== undefined).map(String));
    }
    displayItemReview(content, rawAnswer) {
        const sorting = document.querySelector(".item .sorting");
        const correctOrderToIndex = Object.fromEntries(content.sorting.answers.map((key, index)=>[
                key.correct_order,
                index
            ]));
        const answer = rawAnswer?.map((n)=>correctOrderToIndex[n]);
        const explanation = sorting.querySelector(":not(.feedback) > .explanation");
        explanation.innerHTML = content.sorting.explanation;
        const answerLength = rawAnswer?.length ?? 0;
        const isCorrect = Array.from(content.sorting.answers).map((answer, index)=>({
                ...answer,
                index: index
            })).sort((a, b)=>a.correct_order - b.correct_order).every((reference, index)=>answer && reference.index === answer[index]);
        const explanationPanel = explanation.closest("div.card");
        const correct = document.querySelector(".correct");
        if (answerLength > 0 && isCorrect) {
            correct.innerHTML = "Correct";
            correct.classList.remove("alert-danger", "alert-info");
            correct.classList.add("alert-success");
            explanationPanel.classList.remove("border-danger", "border-info");
            explanationPanel.classList.add("border-success");
        } else if (answerLength > 0 && !isCorrect) {
            correct.innerHTML = "Incorrect";
            correct.classList.remove("alert-success", "alert-info");
            correct.classList.add("alert-danger");
            explanationPanel.classList.remove("border-success", "border-info");
            explanationPanel.classList.add("border-danger");
        } else {
            correct.innerHTML = "Unanswered";
            correct.classList.remove("alert-success", "alert-danger");
            correct.classList.add("alert-info");
            explanationPanel.classList.remove("border-success", "border-danger");
            explanationPanel.classList.add("border-info");
        }
        (0, $de3a0b1bbf7828e4$export$2e2bcd8739ae039).get(sorting.querySelector(".answers")).option("disabled", true);
        const answers = sorting.querySelectorAll(".answers .answer");
        const badges = sorting.querySelectorAll(".answers .answer-correct");
        const references = sorting.querySelectorAll(".answers .answer-reference");
        const explanations = sorting.querySelectorAll(".answers .answer-explanation");
        Array.from(content.sorting.answers).map((answer, index)=>({
                ...answer,
                index: index
            })).sort((a, b)=>a.correct_order - b.correct_order).forEach((answerRef, index)=>{
            const answerNode = answers[index];
            const correct = badges[index];
            const reference = references[index];
            const explanation = explanations[index];
            const isCorrect = answer?.[index] == answerRef.index;
            if (isCorrect) {
                answerNode.classList.remove("border-danger", "border-info");
                answerNode.classList.add("border-success");
                correct.classList.remove("text-bg-danger", "badge-danger", "text-bg-info", "badge-info");
                correct.classList.add("text-bg-success", "badge-success");
                correct.innerHTML = "Correct";
                reference.innerHTML = "";
                explanation.innerHTML = "";
            } else if (answerLength > 0 && !isCorrect) {
                answerNode.classList.remove("border-success", "border-info");
                answerNode.classList.add("border-danger");
                correct.classList.remove("text-bg-success", "badge-success", "text-bg-info", "badge-info");
                correct.classList.add("text-bg-danger", "badge-danger");
                correct.innerHTML = `Incorrect`;
                reference.innerHTML = answerRef.content;
                explanation.innerHTML = answerRef.explanation;
            } else {
                answerNode.classList.remove("border-success", "border-danger");
                answerNode.classList.add("border-info");
                correct.classList.remove("text-bg-success", "badge-success", "text-bg-danger", "badge-danger");
                correct.classList.add("text-bg-info", "badge-info");
                correct.innerHTML = `Unanswered`;
                reference.innerHTML = answerRef.content;
                explanation.innerHTML = answerRef.explanation;
            }
        });
    }
    displayItemRendered(content, mathjax) {
        const sorting = document.querySelector(".item .sorting");
        mathjax.typesetPromise().then(()=>{
            sorting.classList.remove("invisible");
        });
    }
    displayItemAlerts(content) {
        // Do nothing.
        return;
    }
}




class $92e76b665a6d584f$export$3764db0de7a07656 extends (0, $6f125744f8893ba5$export$94cd813f5440f38d) {
    displayItemContent(content, bindTarget) {
        const constructedResponse = document.querySelector(".item .constructedresponse");
        constructedResponse.classList.remove("d-none");
        constructedResponse.classList.add("invisible");
        const name = constructedResponse.querySelector(".name");
        const prompt = constructedResponse.querySelector(".prompt");
        const style = constructedResponse.querySelector("style");
        name.innerHTML = content.name + ".";
        prompt.innerHTML = content.constructedresponse.prompt;
        style.innerText = [].concat(content.constructedresponse.style, content.contexts.map((c)=>c.style)).join("\n\n");
        Array.from(constructedResponse.querySelectorAll(".context-panel")).slice(1).forEach((panel)=>{
            panel.remove();
        });
        const contextPanel = constructedResponse.querySelector(".context-panel");
        const context = contextPanel.querySelector(".context");
        if (content.contexts.length > 0) {
            context.innerHTML = content.contexts[0].content_html;
            context.classList.remove("d-none");
            contextPanel.dataset.context = content.contexts[0].id;
            contextPanel.classList.remove("d-none");
            content.contexts.slice(1).reverse().forEach((_context)=>{
                const panel = contextPanel.cloneNode(true);
                const context = panel.querySelector(".context");
                context.innerHTML = _context.content_html;
                context.classList.remove("d-none");
                panel.dataset.context = _context.id;
                panel.classList.remove("d-none");
                panel.addEventListener("click", (e)=>{
                    bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$fe0b591ac3aa4171)([
                        panel.dataset.context
                    ]));
                });
                contextPanel.after(panel);
            });
        } else {
            context.innerHTML = "";
            context.classList.add("d-none");
            contextPanel.removeAttribute("data-context");
            contextPanel.classList.add("d-none");
        }
        const answers = constructedResponse.querySelector(".answers");
        const answerTemplate = answers.querySelector(".answer").cloneNode(true);
        answers.innerHTML = "";
        const answerNode = answerTemplate.cloneNode(true);
        const textarea = answerNode.querySelector("textarea");
        textarea.value = "";
        answers.appendChild(answerNode);
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        const constructedResponse = document.querySelector(".item .constructedresponse");
        const answers = constructedResponse.querySelector(".answers");
        const textarea = answers.querySelector("textarea[name=answer]");
        textarea.value = answer || "";
        textarea.addEventListener("change", (e)=>{
            bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$3dd7a8e950550ea4)(textarea.value));
        });
    }
    displayItemReview(content, answer) {
        const constructedResponse = document.querySelector(".item .constructedresponse");
        const explanation = constructedResponse.querySelector(".explanation");
        explanation.innerHTML = content.constructedresponse.explanation;
        const explanationPanel = explanation.closest("div.card");
        const correct = document.querySelector(".correct");
        if (answer?.length > 0) {
            correct.innerHTML = "Answered";
            correct.classList.remove("alert-danger", "alert-info");
            correct.classList.add("alert-success");
            explanationPanel.classList.remove("border-danger", "border-info");
            explanationPanel.classList.add("border-success");
        } else {
            correct.innerHTML = "Unanswered";
            correct.classList.remove("alert-danger", "alert-success");
            correct.classList.add("alert-info");
            explanationPanel.classList.remove("border-danger", "border-success");
            explanationPanel.classList.add("border-info");
        }
    }
    displayItemRendered(content, mathjax) {
        const constructedResponse = document.querySelector(".item .constructedresponse");
        mathjax.typesetPromise().then(()=>{
            constructedResponse.classList.remove("invisible");
        });
    }
    displayItemAlerts(content) {
        // Do nothing.
        return;
    }
}



class $e94fa8a06833efd6$export$3176023c8081c8f0 extends (0, $6f125744f8893ba5$export$94cd813f5440f38d) {
    displayItemContent(content, bindTarget) {
        const card = document.querySelector(".item .flashcard");
        const name = card.querySelector(".name");
        const front = card.querySelector(".question");
        const back = card.querySelector(".answer");
        const style = card.querySelector("style");
        name.innerHTML = content.name + ".";
        front.innerHTML = content.flashcard.question;
        back.innerHTML = content.flashcard.answer;
        style.innerText = content.flashcard.style;
        card.classList.remove("d-none");
        card.classList.add("invisible");
    }
    displayItemSelectedAnswer(content, bindTarget, answer) {
        throw new Error("Method not implemented.");
    }
    displayItemReview(content, answer) {
        throw new Error("Method not implemented.");
    }
    displayItemRendered(content, mathjax) {
        const card = document.querySelector(".item .flashcard");
        mathjax.typesetPromise().then(()=>{
            card.classList.remove("invisible");
        });
    }
    displayItemAlerts(content) {
        // Do nothing.
        return;
    }
}








class $4d734273fd686967$export$c1d069a2952947a2 {
    getSwipeTarget() {
        return document.querySelectorAll("div.item");
    }
    getBindHashChange() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)([
            window
        ], "hashchange", (element)=>new (0, $7923788bad7460a0$export$5df3ac09e96c1e8a)(decodeURIComponent(location.hash.replace(/^#/, ""))));
    }
    getBindNext() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".next"), "click", (element)=>new (0, $7923788bad7460a0$export$9a0c977f93e56706)());
    }
    getBindSwipeLeft() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(this.getSwipeTarget(), (0, $f57f2c1271bc31b7$export$c7ad1118445900ce).type, (element)=>new (0, $7923788bad7460a0$export$9a0c977f93e56706)());
    }
    getKeyBindNext() {
        return new (0, $4afb854d5a7f4d82$export$425d25f1ccf4a6b5)((key, answers, type)=>key === "ArrowRight", (answers, type)=>new (0, $7923788bad7460a0$export$9a0c977f93e56706)());
    }
    getBindPrevious() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".prev"), "click", (element)=>new (0, $7923788bad7460a0$export$ab08e41a03656110)());
    }
    getBindSwipeRight() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(this.getSwipeTarget(), (0, $f57f2c1271bc31b7$export$38dcc7c13021f798).type, (element)=>new (0, $7923788bad7460a0$export$ab08e41a03656110)());
    }
    getKeyBindPrevious() {
        return new (0, $4afb854d5a7f4d82$export$425d25f1ccf4a6b5)((key, answers, type)=>key === "ArrowLeft", (answers, type)=>new (0, $7923788bad7460a0$export$ab08e41a03656110)());
    }
    getBindReload() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".reload"), "click", (element)=>new (0, $7923788bad7460a0$export$9c971d3e2e1a3b3b)());
    }
    getBindToggleContext() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".context-panel"), "click", (element)=>new (0, $7923788bad7460a0$export$fe0b591ac3aa4171)([
                element.dataset.context
            ]));
    }
    getKeyBindToggleContext() {
        return new (0, $4afb854d5a7f4d82$export$425d25f1ccf4a6b5)((key, answers, type)=>key === "`", (answers, type)=>new (0, $7923788bad7460a0$export$fe0b591ac3aa4171)(Array.from(document.querySelectorAll(".context-panel")).map((e)=>e.dataset.context)));
    }
    getBindFinish() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".finish"), "click", (element)=>new (0, $7923788bad7460a0$export$2dd9981939617ffa)());
    }
    getKeyBindAnswer(index) {
        return new (0, $4afb854d5a7f4d82$export$425d25f1ccf4a6b5)((key, answers, type)=>key === [
                "a",
                "b",
                "c",
                "d",
                "e",
                "f",
                "g",
                "h",
                "i",
                "j"
            ][index] && answers.length > index, (answers, type)=>{
            const value = answers[index].value;
            if (type === "multiplechoice") return new (0, $7923788bad7460a0$export$3dd7a8e950550ea4)(value);
            else if (type === "multiplecorrect") {
                const answerSet = new Set(Array.from(answers).filter((answer)=>answer.checked).map((answer)=>answer.value));
                if (answerSet.has(value)) answerSet.delete(value);
                else answerSet.add(value);
                return new (0, $7923788bad7460a0$export$3dd7a8e950550ea4)(Array.from(answerSet).sort());
            }
        });
    }
    getBindContextShown() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".context-panel"), (0, $7923788bad7460a0$export$f39d3f3b9871ec9b).type, (element, event)=>new (0, $7923788bad7460a0$export$f39d3f3b9871ec9b)(event.detail));
    }
    getBindResume() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".pause-test .resume"), "click", (element)=>new (0, $7923788bad7460a0$export$60458c85dad92def)(false));
    }
    getBindHideTimer() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".pause-test .hide"), "click", (element)=>[
                new (0, $7923788bad7460a0$export$60458c85dad92def)(false),
                new (0, $7923788bad7460a0$export$d4ddcefded388801)()
            ]);
    }
    getKeyBindShortcutModal() {
        return new (0, $4afb854d5a7f4d82$export$425d25f1ccf4a6b5)((key, answers, type)=>key === "?", (answers, type)=>new (0, $7923788bad7460a0$export$ded2c80848e1b1a)());
    }
    getAnswers() {
        return document.querySelectorAll(".item > :not(.d-none) .answers .answer input");
    }
    bindKeyboard(bindings, answers, type, bindTarget, isKeyboardShortcuts) {
        if (this.keyboardListener) document.removeEventListener("keydown", this.keyboardListener);
        this.keyboardListener = (e)=>{
            // TODO: Figure out a different way to catch top level key events
            if (![
                "BODY",
                "#document"
            ].includes(e.target.nodeName)) {
                if (e.key === "Escape") e.target.blur();
            } else if (isKeyboardShortcuts()) bindings.forEach((bind)=>{
                if (bind.condition(e.key, answers, type)) {
                    if (bind.suppress) e.preventDefault();
                    const event = bind.invoke(answers, type);
                    bindTarget.dispatchEvent(event);
                }
            });
        };
        document.addEventListener("keydown", this.keyboardListener);
    }
    bindJquery(jQuery, selector, event) {
        jQuery(selector).on(event, (e)=>{
            e.target.dispatchEvent(new CustomEvent(event, {
                detail: e
            }));
        });
    }
    setVisible(element, state) {
        const int = Number, cls = [
            "d-none",
            "d-flex"
        ];
        if (element === document.querySelector("div.item")) element.classList.toggle("d-none", !state);
        else element.classList.replace(cls[int(!state)], cls[int(state)]);
    }
    displayLoading(status) {
        Object.entries({
            done: document.querySelector("div.item"),
            loading: document.querySelector("div.item-loading"),
            error: document.querySelector("div.item-errored")
        }).forEach(([state, element])=>this.setVisible(element, state == status));
    }
    displayFinishing(status) {
        const button = document.querySelector(".modal.finish-test .finish");
        const loading = document.querySelector(".modal.finish-test .loading");
        const error = document.querySelector(".modal.finish-test .error");
        button.classList.toggle("d-none", status !== "ready" && status !== "error");
        loading.classList.toggle("d-none", status !== "loading");
        error.classList.toggle("d-none", status !== "error");
    }
    displayUnknown() {
        const unknown = document.querySelector(".item .unknown");
        unknown.classList.remove("d-none");
    }
    toggleContexts(ids) {
        this.displayContexts(Array.from(document.querySelectorAll(".item > :not(.d-none) .context-panel")).reduce((o, e)=>{
            const collapse = e.querySelector(".context-collapse");
            return Object.assign(o, {
                [e.dataset.context]: ids.includes(e.dataset.context) ? !collapse.classList.contains("show") : collapse.classList.contains("show")
            });
        }, {}));
    }
    /**
	 * Function will set given contexts to expanded or collapsed according to
	 * their shown attribute in the contexts record. Any contexts not included
	 * in the record will default to being shown.
	 *
	 * @param {Record<string, boolean>} contexts A record of context IDs to
	 * boolean shown flags.
	 */ displayContexts(contexts) {
        const top_panel = document.querySelector(".item > :not(.d-none) .context-panel");
        Array.from(document.querySelectorAll(".item > :not(.d-none) .context-panel")).forEach((panel)=>{
            const show = contexts[panel.dataset.context] ?? true;
            const collapse = panel.querySelector(".context-collapse");
            const gradient = panel.querySelector(".context-gradient");
            if (show) {
                collapse.classList.add("show");
                collapse.style.maxHeight = "max-content";
                gradient.classList.replace("d-flex", "d-none");
                panel.querySelectorAll(".context-collapser i").forEach((e)=>e.classList.replace("fa-chevron-down", "fa-chevron-up"));
                top_panel.dispatchEvent(new (0, $7923788bad7460a0$export$f39d3f3b9871ec9b)(panel.dataset.context));
            } else {
                collapse.classList.remove("show");
                collapse.style.maxHeight = "9em";
                gradient.classList.replace("d-none", "d-flex");
                panel.querySelectorAll(".context-collapser i").forEach((e)=>e.classList.replace("fa-chevron-up", "fa-chevron-down"));
            }
        });
    }
    displayFontSize(fontSize) {
        document.querySelectorAll(".viewer .item").forEach((item)=>{
            item.style.fontSize = `${fontSize}em`;
        });
    }
    displayResults(url) {
        const parsed = new URL(url, window.location.origin);
        window.location.href = parsed.toString();
        const redirect = document.querySelector(".modal.finish-test .redirect");
        redirect.classList.remove("d-none");
        const anchor = redirect.querySelector("a.url");
        anchor.href = parsed.toString();
    }
    displayPauseModal(jQuery, command) {
        jQuery(".pause-test").modal(command);
    }
    constructor(item){
        this.itemIdSerializer = item;
    }
}
class $4d734273fd686967$export$c779ca608bc7e518 extends $4d734273fd686967$export$c1d069a2952947a2 {
    displaySelectedAnswerMultipleChoice(answer) {
        document.querySelectorAll(".multiplechoice .answers .answer").forEach((other)=>{
            const label = other.querySelector("label.border");
            const input = other.querySelector("input");
            if (label) label.classList.remove("border", "rounded", "bg-light");
            input.checked = false;
        });
        const input = document.querySelector(`.multiplechoice .answers .answer input[value="${answer}"]`);
        if (input) {
            const element = input.closest(".answer");
            const label = element.querySelector("label");
            label.classList.add("border", "rounded", "bg-light");
            input.checked = true;
        }
    }
    displaySelectedAnswerMultipleCorrect(answer) {
        const answerSet = new Set(answer);
        document.querySelectorAll(".multiplecorrect .answers .answer").forEach((other)=>{
            const label = other.querySelector("label");
            const input = other.querySelector("input");
            if (answerSet.has(input.value)) {
                label.classList.add("border", "rounded", "bg-light");
                input.checked = true;
            } else {
                if (label) label.classList.remove("border", "rounded", "bg-light");
                input.checked = false;
            }
        });
    }
    displayItemClass(content) {
        if (content.type === "multiplechoice") return new (0, $bde34c4506ee90eb$export$6fa019cb400783c4)();
        else if (content.type === "multiplecorrect") return new (0, $5341e3bc0b86f0fc$export$3e0428823926e888)();
        else if (content.type === "numeric") return new (0, $0d5ddf370e1398bc$export$96fe2c02b12de670)();
        else if (content.type === "cloze") return new (0, $5d09e0e2815d1769$export$8ab55b8a6a6c86f4)();
        else if (content.type === "matching") return new (0, $888888e1ba14c771$export$215771809dcb7028)();
        else if (content.type === "sorting") return new (0, $0c30ecb6ddb6e82a$export$116addb240a95eea)();
        else if (content.type === "constructedresponse") return new (0, $92e76b665a6d584f$export$3764db0de7a07656)();
        else return new (0, $6f125744f8893ba5$export$1741f5fbb0046105)();
    }
    initSortable() {
        (0, $de3a0b1bbf7828e4$export$2e2bcd8739ae039).mount(new (0, $e9436c4c4d600e19$export$bdb5f0a1b77546f4)());
    }
}
class $4d734273fd686967$export$9d58fa389ea7da9 extends $4d734273fd686967$export$c1d069a2952947a2 {
    getBindFlipCard() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".flip-card"), "click", (element)=>new (0, $7923788bad7460a0$export$5aedb0666ade7cfe)(element.classList.contains("show-question")));
    }
    getKeyBindFlipCard() {
        return new (0, $4afb854d5a7f4d82$export$425d25f1ccf4a6b5)((key, answers, type)=>key === " ", (answers, type)=>new (0, $7923788bad7460a0$export$5aedb0666ade7cfe)(document.querySelector(".flip-card").classList.contains("show-question")), true);
    }
    hideCardSides() {
        [
            document.querySelector(".item .flashcard .question"),
            document.querySelector(".item .flashcard .answer")
        ].forEach((element)=>{
            element.classList.add("d-none");
        });
    }
    displayCardFront() {
        const front = document.querySelector(".item .flashcard .question");
        front.classList.remove("d-none");
    }
    displayCardBack() {
        this.displayCardFront();
        const back = document.querySelector(".item .flashcard .answer");
        back.classList.remove("d-none");
    }
    displayItemClass(content) {
        if (content.type === "flashcard") return new (0, $e94fa8a06833efd6$export$3176023c8081c8f0)();
        else if (content.type === "colorflashcard") // TODO: return new ColorFlashcardFrontend();
        return new (0, $e94fa8a06833efd6$export$3176023c8081c8f0)();
        else return new (0, $6f125744f8893ba5$export$1741f5fbb0046105)();
    }
}






class $787cbb42a3de36ec$export$bd5b2ff202412f16 {
    getBindJump() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".item-list .item"), "click", (element)=>new (0, $7923788bad7460a0$export$f210b93e2bf140a8)(element.dataset.id));
    }
    getBindToggleFilter() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".filter-list .filter input:not(.invisible)"), "change", (element)=>new (0, $7923788bad7460a0$export$e7295f8a101b6f3d)([
                new (0, $43dd4374f28efe45$export$ce3e5ea407eb882e)(element.dataset.filter).id
            ]));
    }
    getBindSetFilter() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)([
            window
        ], "popstate", ()=>new (0, $7923788bad7460a0$export$3e02572c0fd6d3b9)((0, $e6d9787dca477675$export$2e2bcd8739ae039).parseURLFilters()));
    }
    getBindFilterLinks() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".filter-link"), "click", (element)=>new (0, $7923788bad7460a0$export$806e07265bdb8daf)(element));
    }
    bindCollapseIcons() {
        const triggers = document.querySelectorAll([
            'a[data-toggle="collapse"]',
            'a[data-bs-toggle="collapse"]',
            'button[data-bs-toggle="collapse"]'
        ].join(","));
        for (const trigger of Array.from(triggers)){
            const collapse = document.querySelector(trigger.getAttribute("data-bs-target") || trigger.getAttribute("data-target") || trigger.getAttribute("href"));
            const triggerIcons = trigger.querySelectorAll("i");
            for (const icon of Array.from(triggerIcons)){
                const collapseClass = icon.getAttribute("icon-collapse") || "fa-minus";
                const expandClass = icon.getAttribute("icon-expand") || "fa-plus";
                collapse.addEventListener("show.bs.collapse", (e)=>{
                    icon.classList.replace(expandClass, collapseClass);
                });
                collapse.addEventListener("hide.bs.collapse", (e)=>{
                    icon.classList.replace(collapseClass, expandClass);
                });
            }
        }
    }
    bindSectionHighlight() {
        const itemList = Array.from(document.querySelectorAll(".item-list .item"));
        itemList.forEach((item)=>{
            const same = itemList.filter((i)=>i.dataset.section_id === item.dataset.section_id);
            item.addEventListener("mouseover", (e)=>{
                item.classList.remove("border-light", "border-dark");
                item.classList.add("border-primary");
                same.forEach((item)=>{
                    item.style.filter = "opacity(90%)";
                    item.classList.add("font-weight-bold");
                });
            });
            item.addEventListener("mouseleave", (e)=>{
                item.classList.remove("border-primary");
                if (item.classList.contains("current")) item.classList.add("border-dark");
                else item.classList.add("border-light");
                same.forEach((item)=>{
                    item.style.filter = "";
                    if (!item.classList.contains("current")) item.classList.remove("font-weight-bold");
                });
            });
        });
    }
    displayFlagged(item, flagged, status) {
        const icon = document.querySelector(`.item-list .item[data-id="${CSS.escape(this.itemIdSerializer.toString(item))}"] i.flag-icon`);
        icon.classList.remove("fas", "fa-flag", "fa-exclamation-triangle", "spinner-border", "spinner-border-sm");
        if (flagged && !status) icon.classList.add("fas", "fa-flag");
        else if (status === "error") icon.classList.add("fas", "fa-exclamation-triangle");
        else if (status === "loading") icon.classList.add("spinner-border", "spinner-border-sm");
    }
    displaySelectedAnswer(item, answer, status) {
        const current = document.querySelector(`.item-list .item[data-id="${CSS.escape(this.itemIdSerializer.toString(item))}"]`);
        const icon = current.querySelector("i.answer-icon");
        icon.classList.remove("fas", "fa-circle", "fa-exclamation-triangle", "spinner-border", "spinner-border-sm");
        if (answer !== null && answer && !status) icon.classList.add("fas", "fa-circle");
        else if (status === "error") icon.classList.add("fas", "fa-exclamation-triangle");
        else if (status === "loading") icon.classList.add("spinner-border", "spinner-border-sm");
        if (!status) current.style.backgroundColor = current.style.backgroundColor.replace(/rgba?\((?<color>(?:[\d.]+,\s*){2}[\d.]+)(?<alpha>|,\s*[\d.]+)\)/, `rgba($<color>, ${answer !== null ? "1.0" : "0.5"})`);
    }
    displayCurrent(index) {
        const previous = document.querySelectorAll(".item-list .item.current");
        const current = document.querySelectorAll(".item-list .item")[index];
        previous.forEach((prev)=>{
            prev.classList.replace("border-dark", "border-light");
            prev.classList.remove("current", "font-weight-bold");
        });
        current.classList.add("border-dark", "current", "font-weight-bold");
        current.classList.remove("border-light");
    }
    displayFilters(filters, bindTarget) {
        const filterList = document.querySelector(".active-filter-list");
        filterList.innerHTML = filters.map((filter)=>`
				<a class="badge badge-primary filter"
					data-filter='${filter.id}'
					href="#"
					title="${filter.title}"
					onclick="return false;"
				>${filter.title.length > 23 ? filter.title.substring(0, 20) + "..." : filter.title} &times;
				</a>
			`).concat(filters.length > 0 ? [
            `<a class="filter-clear" href="#" onclick="return false;">
					Clear
				</a>`
        ] : []).join("");
        filterList.querySelectorAll(".filter").forEach((filter)=>{
            filter.addEventListener("click", (e)=>{
                bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$f0a09197511a3838)([
                    filter.dataset.filter
                ]));
            });
        });
        filterList.querySelectorAll(".filter-clear").forEach((clear)=>{
            clear.addEventListener("click", (e)=>{
                bindTarget.dispatchEvent(new (0, $7923788bad7460a0$export$6b720b50052660b5)());
            });
        });
        document.querySelectorAll(".filter-list .filter").forEach((div)=>{
            const input = div.querySelector("input");
            input.checked = false;
            div.classList.remove("border", "bg-light", "rounded");
        });
        filters.forEach((filter)=>{
            const input = document.querySelector(`
				.filter-list
				.filter
				input[data-filter='${JSON.stringify(filter)}']
			`);
            const div = input.closest(".filter");
            div.classList.add("border", "bg-light", "rounded");
            input.checked = true;
        });
    }
    displayFiltered(filtered) {
        const items = Array.from(document.querySelectorAll(".item-list .item"));
        const active = items.filter((item, index)=>filtered.includes(index));
        const inactive = items.filter((item, index)=>!filtered.includes(index));
        active.forEach((item)=>{
            item.classList.remove("d-none");
        });
        inactive.forEach((item)=>{
            item.classList.add("d-none");
        });
    }
    displaySorted(order) {
        const items = Array.from(document.querySelectorAll(".item-list .item"));
        order.forEach((index, order)=>{
            items[index].style.order = order.toString();
        });
    }
    constructor(item){
        this.itemIdSerializer = item;
    }
}




class $6f042d9f175fbdb8$export$432093ad9c671135 {
    getBindScoreFilter() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".summary .score-filter"), "click", (element)=>{
            /** @type {CustomEvent[]} */ const filters = [
                element.dataset.filterSection,
                element.dataset.filterAnswer
            ].filter((v)=>v);
            const events = [
                new (0, $7923788bad7460a0$export$3e02572c0fd6d3b9)(filters.map((filter)=>filter))
            ];
            return events;
        });
    }
    bindSummaryCollapse() {
        const collapse = document.querySelector(".summary.collapse");
        const collapser = document.querySelector(".summary-collapser");
        const label = collapser?.querySelector("span");
        if (label) {
            collapse?.addEventListener("show.bs.collapse", (e)=>{
                label.innerText = "Hide Summary";
            });
            collapse?.addEventListener("hide.bs.collapse", (e)=>{
                label.innerText = "Show Summary";
            });
        }
    }
    getSectionScoreChart() {
        return document.querySelector(".score-chart");
    }
}




class $ef3ed923fbd5ed31$export$f1d3e53a76c30bcd {
    getBindStart() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".start"), "click", (element)=>new (0, $7923788bad7460a0$export$cc4ebe9deb7007ee)(element));
    }
    getSectionChart(quiz) {
        return document.querySelector(`.test-score[data-quiz='${CSS.escape(this.quizIdSerializer.toString(quiz))}'] .chart`);
    }
    toggleStart(element) {
        const loading = element.parentElement.querySelector(".loading");
        console.log("hiding", element, "and showing", loading);
        loading.classList.remove("d-none");
        element.classList.add("d-none");
    }
    constructor(quiz, item){
        this.itemIdSerializer = item;
        this.quizIdSerializer = quiz;
    }
}


/// <reference types="bootstrap" />
/// <reference types="grecaptcha" />


function $bdaf673a6608829b$var$serializeErrors(errors) {
    return JSON.stringify(errors.reduce((serialized, error)=>{
        if (error instanceof Object) {
            let message = `${error} (${error.stack})`;
            const props = Object.getOwnPropertyNames(error).filter((k)=>![
                    "message",
                    "stack"
                ].includes(k));
            if (props && props.length) message += " " + JSON.stringify(props.reduce((props, prop)=>({
                    ...props,
                    [prop]: error[prop]
                }), {}));
            serialized.push(message);
        } else serialized.push(error);
        return serialized;
    }, []));
}
class $bdaf673a6608829b$export$86a3e6247396dc7d {
    getBindToggleTimer() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll("input#show-timer"), "change", (element)=>new (0, $7923788bad7460a0$export$d4ddcefded388801)());
    }
    getBindKeyboardShortcuts() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll("input#keyboard-shortcuts"), "change", (element)=>new (0, $7923788bad7460a0$export$8d75d221682b4901)(element.checked));
    }
    getBindChangeFontSize() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll("input#fontsize"), "change", (element)=>new (0, $7923788bad7460a0$export$b289c91fe03907fc)(parseFloat(element.value) / 100 * 2 + 0.5));
    }
    getBindResetFontSize() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".fontsize-reset"), "click", // TODO: Find a better default initialization
        (element)=>new (0, $7923788bad7460a0$export$b289c91fe03907fc)(1));
    }
    getBindToggleReport() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll("a.report-toggle"), "click", (element)=>new (0, $7923788bad7460a0$export$8d5d557b23906369)());
    }
    getBindEnterEmail() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll("input[name=email]"), "input", (element)=>new (0, $7923788bad7460a0$export$e149524ebdefa115)(element));
    }
    getBindOverrideInput() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll("a.input-override"), "click", (element)=>new (0, $7923788bad7460a0$export$29dc3df1c55e2e49)(element.closest("form"), element.dataset.selector, element.dataset.value), true);
    }
    getBindReportError() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll("form.report"), "submit", (element)=>new (0, $7923788bad7460a0$export$e65ec9e9698a1bd7)(element), true);
    }
    getBindToggleAutoAdvance() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".advance-toggle"), "click", (element)=>new (0, $7923788bad7460a0$export$f072eab12773765c)(element.value.toLowerCase() == "true"));
    }
    getBindChangeAdvanceInterval() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll("input#advance-interval"), "change", (element)=>new (0, $7923788bad7460a0$export$23a57784a706597f)(parseInt(element.value) * 1000));
    }
    getBindResetTimer() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".reset-timer"), "click", (element)=>new (0, $7923788bad7460a0$export$20655a32208d5ee9)());
    }
    displayFontSize(size) {
        document.querySelector("input#fontsize").value = ((size - 0.5) / 2 * 100).toString();
    }
    displayKeyboardShortcuts(enabled) {
        document.querySelector("input#keyboard-shortcuts").checked = enabled;
    }
    displayTimer(show) {
        document.querySelector("input#show-timer").checked = show;
    }
    displayErrorLoading(show) {
        const loading = document.querySelector(".report-loading");
        if (show) loading.classList.remove("d-none");
        else loading.classList.add("d-none");
    }
    displayErrorModal(jQuery, url, item, filters, screenshot, errors, localStorage) {
        const form = document.querySelector(".report-error form.report");
        const image = document.querySelector(".report-error img.screenshot");
        form.url.value = url;
        form.item.value = JSON.stringify(item);
        form.filter.value = JSON.stringify(filters);
        form.screenshot.value = screenshot;
        form.errors.value = $bdaf673a6608829b$var$serializeErrors(errors);
        form.localstorage.value = JSON.stringify(localStorage);
        image.src = screenshot;
        grecaptcha.reset();
        document.querySelector(".report-error .error").innerHTML = "";
        jQuery(".report-error").modal("show");
    }
    hideErrorModal(jQuery) {
        const form = document.querySelector(".report-error form.report");
        jQuery(".report-error").modal("hide");
        form.email.value = "";
        form.description.value = "";
    }
    displayInputSuggestion(element, suggestion) {
        const form = element.closest("form");
        const suggestionElement = form.querySelector(element.dataset.suggestion);
        const valueLink = suggestionElement.querySelector("a.value");
        if (suggestion) valueLink.innerText = valueLink.dataset.value = suggestion;
        suggestionElement.classList.toggle("d-none", !suggestion);
    }
    updateInputs(root, selector, value) {
        const targets = Array.from(root.querySelectorAll(selector));
        for (const t of targets)t.value = value;
        return targets;
    }
    displayErrorResultModal(jQuery, success, reason) {
        const title = document.querySelector(".report-status .title");
        const body = document.querySelector(".report-status .body");
        title.innerHTML = success ? "Report Submitted" : "Report Failed";
        body.innerHTML = success ? "Your report has been successfully submitted." : "Your report has not succesfully submitted: " + reason;
        jQuery(".report-status").modal("show");
    }
    toggleShortcutModal(jQuery) {
        jQuery(".keyboard-reference").modal("toggle");
    }
    displayReportErrorMessage(message) {
        document.querySelector(".report-error .error").innerHTML = message;
    }
    displayAdvance(enable) {}
    displayAdvanceInterval(interval) {
        document.querySelector("input#advance-interval").value = `${interval / 1000}`;
    }
    displayTimed(enable) {
        document.querySelectorAll("input.pause").forEach((element)=>{
            element.checked = enable;
        });
    }
    constructor(item){
        this.itemIdSerializer = item;
    }
}


class $98104a4c5f72d3f1$export$52be8eb626f981c6 {
    getTable() {
        return document.querySelector(".attempts table");
    }
    constructor(item){
        this.productIdSerializer = item;
    }
}


class $b99c2fd4d7477968$export$dcc6fb7d82b5bc7b extends Map {
    get(key) {
        return super.get($b99c2fd4d7477968$var$intern_get(this, key));
    }
    has(key) {
        return super.has($b99c2fd4d7477968$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($b99c2fd4d7477968$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($b99c2fd4d7477968$var$intern_delete(this, key));
    }
    constructor(entries, key = $b99c2fd4d7477968$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
}
class $b99c2fd4d7477968$export$55278c3294239828 extends Set {
    has(value) {
        return super.has($b99c2fd4d7477968$var$intern_get(this, value));
    }
    add(value) {
        return super.add($b99c2fd4d7477968$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($b99c2fd4d7477968$var$intern_delete(this, value));
    }
    constructor(values, key = $b99c2fd4d7477968$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
}
function $b99c2fd4d7477968$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $b99c2fd4d7477968$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $b99c2fd4d7477968$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $b99c2fd4d7477968$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}


function $c968f941ac06b803$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $c968f941ac06b803$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}


const $8a65d664d179e374$export$e4f898ab14d9d460 = Symbol("implicit");
function $8a65d664d179e374$export$2e2bcd8739ae039() {
    var index = new (0, $b99c2fd4d7477968$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $8a65d664d179e374$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $8a65d664d179e374$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $b99c2fd4d7477968$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $8a65d664d179e374$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $c968f941ac06b803$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}



function $4760d317639f2e10$var$none() {}
function $4760d317639f2e10$export$2e2bcd8739ae039(selector) {
    return selector == null ? $4760d317639f2e10$var$none : function() {
        return this.querySelector(selector);
    };
}


function $1eaaf679326a77e4$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $4760d317639f2e10$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $888ff001a7c8df76$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $ef66b17df9e24220$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $852fc70fba3fc261$var$empty() {
    return [];
}
function $852fc70fba3fc261$export$2e2bcd8739ae039(selector) {
    return selector == null ? $852fc70fba3fc261$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $c5e186facb325bf7$var$arrayAll(select) {
    return function() {
        return (0, $ef66b17df9e24220$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $c5e186facb325bf7$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $c5e186facb325bf7$var$arrayAll(select);
    else select = (0, $852fc70fba3fc261$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $888ff001a7c8df76$export$52baac22726c72bf)(subgroups, parents);
}


function $a728a55ce00b707a$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $a728a55ce00b707a$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $b5509182f472f9f6$var$find = Array.prototype.find;
function $b5509182f472f9f6$var$childFind(match) {
    return function() {
        return $b5509182f472f9f6$var$find.call(this.children, match);
    };
}
function $b5509182f472f9f6$var$childFirst() {
    return this.firstElementChild;
}
function $b5509182f472f9f6$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $b5509182f472f9f6$var$childFirst : $b5509182f472f9f6$var$childFind(typeof match === "function" ? match : (0, $a728a55ce00b707a$export$90c2759c036528)(match)));
}



var $cced9feaa7e876f0$var$filter = Array.prototype.filter;
function $cced9feaa7e876f0$var$children() {
    return Array.from(this.children);
}
function $cced9feaa7e876f0$var$childrenFilter(match) {
    return function() {
        return $cced9feaa7e876f0$var$filter.call(this.children, match);
    };
}
function $cced9feaa7e876f0$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $cced9feaa7e876f0$var$children : $cced9feaa7e876f0$var$childrenFilter(typeof match === "function" ? match : (0, $a728a55ce00b707a$export$90c2759c036528)(match)));
}




function $2368b3b733560c68$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $a728a55ce00b707a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $888ff001a7c8df76$export$52baac22726c72bf)(subgroups, this._parents);
}



function $b924a70f784ac9c3$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $3cc848164081249c$export$2e2bcd8739ae039() {
    return new (0, $888ff001a7c8df76$export$52baac22726c72bf)(this._enter || this._groups.map((0, $b924a70f784ac9c3$export$2e2bcd8739ae039)), this._parents);
}
function $3cc848164081249c$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$3cc848164081249c$export$67b01759a14cf6a4.prototype = {
    constructor: $3cc848164081249c$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $351921ff2f730e88$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $286d2cb11c9886e1$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $3cc848164081249c$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $286d2cb11c9886e1$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $3cc848164081249c$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $286d2cb11c9886e1$var$datum(node) {
    return node.__data__;
}
function $286d2cb11c9886e1$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $286d2cb11c9886e1$var$datum);
    var bind = key ? $286d2cb11c9886e1$var$bindKey : $286d2cb11c9886e1$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $351921ff2f730e88$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $286d2cb11c9886e1$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $888ff001a7c8df76$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $286d2cb11c9886e1$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $41f4de0282172f91$export$2e2bcd8739ae039() {
    return new (0, $888ff001a7c8df76$export$52baac22726c72bf)(this._exit || this._groups.map((0, $b924a70f784ac9c3$export$2e2bcd8739ae039)), this._parents);
}


function $1cc4974d4334226b$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $d5c8ae21615194fc$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $888ff001a7c8df76$export$52baac22726c72bf)(merges, this._parents);
}


function $cf6e9c0f8ce44da5$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $871e1a6b4d8db120$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $871e1a6b4d8db120$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $888ff001a7c8df76$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $871e1a6b4d8db120$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $24c7096c25ee2a1a$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $5e112341f7a35210$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $6a974c3f4db31e87$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $c02f3400e6370dcb$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $10215b00de102938$export$2e2bcd8739ae039() {
    return !this.node();
}


function $54821ee8617eebf3$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $991758ddb44b1a56$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $991758ddb44b1a56$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $991758ddb44b1a56$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $89143032e11c3d09$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $991758ddb44b1a56$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $991758ddb44b1a56$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $8e8b0dc04eeda3c1$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $8e8b0dc04eeda3c1$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $8e8b0dc04eeda3c1$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $8e8b0dc04eeda3c1$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $8e8b0dc04eeda3c1$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $8e8b0dc04eeda3c1$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $8e8b0dc04eeda3c1$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $89143032e11c3d09$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $8e8b0dc04eeda3c1$var$attrRemoveNS : $8e8b0dc04eeda3c1$var$attrRemove : typeof value === "function" ? fullname.local ? $8e8b0dc04eeda3c1$var$attrFunctionNS : $8e8b0dc04eeda3c1$var$attrFunction : fullname.local ? $8e8b0dc04eeda3c1$var$attrConstantNS : $8e8b0dc04eeda3c1$var$attrConstant)(fullname, value));
}


function $74d35626edd0086a$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $1637bce2c26d4dda$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $1637bce2c26d4dda$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $1637bce2c26d4dda$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $1637bce2c26d4dda$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $1637bce2c26d4dda$var$styleRemove : typeof value === "function" ? $1637bce2c26d4dda$var$styleFunction : $1637bce2c26d4dda$var$styleConstant)(name, value, priority == null ? "" : priority)) : $1637bce2c26d4dda$export$5e3cec964f0b5efd(this.node(), name);
}
function $1637bce2c26d4dda$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $74d35626edd0086a$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $95f85d3f14570093$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $95f85d3f14570093$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $95f85d3f14570093$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $95f85d3f14570093$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $95f85d3f14570093$var$propertyRemove : typeof value === "function" ? $95f85d3f14570093$var$propertyFunction : $95f85d3f14570093$var$propertyConstant)(name, value)) : this.node()[name];
}


function $9db445bd3c12cc0a$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $9db445bd3c12cc0a$var$classList(node) {
    return node.classList || new $9db445bd3c12cc0a$var$ClassList(node);
}
function $9db445bd3c12cc0a$var$ClassList(node) {
    this._node = node;
    this._names = $9db445bd3c12cc0a$var$classArray(node.getAttribute("class") || "");
}
$9db445bd3c12cc0a$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $9db445bd3c12cc0a$var$classedAdd(node, names) {
    var list = $9db445bd3c12cc0a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $9db445bd3c12cc0a$var$classedRemove(node, names) {
    var list = $9db445bd3c12cc0a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $9db445bd3c12cc0a$var$classedTrue(names) {
    return function() {
        $9db445bd3c12cc0a$var$classedAdd(this, names);
    };
}
function $9db445bd3c12cc0a$var$classedFalse(names) {
    return function() {
        $9db445bd3c12cc0a$var$classedRemove(this, names);
    };
}
function $9db445bd3c12cc0a$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $9db445bd3c12cc0a$var$classedAdd : $9db445bd3c12cc0a$var$classedRemove)(this, names);
    };
}
function $9db445bd3c12cc0a$export$2e2bcd8739ae039(name, value) {
    var names = $9db445bd3c12cc0a$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $9db445bd3c12cc0a$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $9db445bd3c12cc0a$var$classedFunction : value ? $9db445bd3c12cc0a$var$classedTrue : $9db445bd3c12cc0a$var$classedFalse)(names, value));
}


function $2a5f8182d170a568$var$textRemove() {
    this.textContent = "";
}
function $2a5f8182d170a568$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $2a5f8182d170a568$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $2a5f8182d170a568$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $2a5f8182d170a568$var$textRemove : (typeof value === "function" ? $2a5f8182d170a568$var$textFunction : $2a5f8182d170a568$var$textConstant)(value)) : this.node().textContent;
}


function $695a2e781708858f$var$htmlRemove() {
    this.innerHTML = "";
}
function $695a2e781708858f$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $695a2e781708858f$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $695a2e781708858f$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $695a2e781708858f$var$htmlRemove : (typeof value === "function" ? $695a2e781708858f$var$htmlFunction : $695a2e781708858f$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $6f612ccd8cd53d2e$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $6f612ccd8cd53d2e$export$2e2bcd8739ae039() {
    return this.each($6f612ccd8cd53d2e$var$raise);
}


function $2c5e5aeec27943ea$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $2c5e5aeec27943ea$export$2e2bcd8739ae039() {
    return this.each($2c5e5aeec27943ea$var$lower);
}




function $8ec7b4233fe06153$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $991758ddb44b1a56$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $991758ddb44b1a56$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $8ec7b4233fe06153$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $8ec7b4233fe06153$export$2e2bcd8739ae039(name) {
    var fullname = (0, $89143032e11c3d09$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $8ec7b4233fe06153$var$creatorFixed : $8ec7b4233fe06153$var$creatorInherit)(fullname);
}


function $32316b75fe05c76e$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $8ec7b4233fe06153$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $6752de825c2317b1$var$constantNull() {
    return null;
}
function $6752de825c2317b1$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $8ec7b4233fe06153$export$2e2bcd8739ae039)(name), select = before == null ? $6752de825c2317b1$var$constantNull : typeof before === "function" ? before : (0, $4760d317639f2e10$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $5e91d7a6cf62e418$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $5e91d7a6cf62e418$export$2e2bcd8739ae039() {
    return this.each($5e91d7a6cf62e418$var$remove);
}


function $45c70610384d1a2d$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $45c70610384d1a2d$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $45c70610384d1a2d$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $45c70610384d1a2d$var$selection_cloneDeep : $45c70610384d1a2d$var$selection_cloneShallow);
}


function $46efae388a937f9f$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $bad9449716c35ae5$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $bad9449716c35ae5$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $bad9449716c35ae5$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $bad9449716c35ae5$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $bad9449716c35ae5$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $bad9449716c35ae5$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $bad9449716c35ae5$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $bad9449716c35ae5$var$onAdd : $bad9449716c35ae5$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $c9ae6cc015345bc8$var$dispatchEvent(node, type, params) {
    var window = (0, $74d35626edd0086a$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $c9ae6cc015345bc8$var$dispatchConstant(type, params) {
    return function() {
        return $c9ae6cc015345bc8$var$dispatchEvent(this, type, params);
    };
}
function $c9ae6cc015345bc8$var$dispatchFunction(type, params) {
    return function() {
        return $c9ae6cc015345bc8$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $c9ae6cc015345bc8$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $c9ae6cc015345bc8$var$dispatchFunction : $c9ae6cc015345bc8$var$dispatchConstant)(type, params));
}


function* $720c47b6cab85079$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $888ff001a7c8df76$export$e8e78c978b129247 = [
    null
];
function $888ff001a7c8df76$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $888ff001a7c8df76$var$selection() {
    return new $888ff001a7c8df76$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $888ff001a7c8df76$export$e8e78c978b129247);
}
function $888ff001a7c8df76$var$selection_selection() {
    return this;
}
$888ff001a7c8df76$export$52baac22726c72bf.prototype = $888ff001a7c8df76$var$selection.prototype = {
    constructor: $888ff001a7c8df76$export$52baac22726c72bf,
    select: (0, $1eaaf679326a77e4$export$2e2bcd8739ae039),
    selectAll: (0, $c5e186facb325bf7$export$2e2bcd8739ae039),
    selectChild: (0, $b5509182f472f9f6$export$2e2bcd8739ae039),
    selectChildren: (0, $cced9feaa7e876f0$export$2e2bcd8739ae039),
    filter: (0, $2368b3b733560c68$export$2e2bcd8739ae039),
    data: (0, $286d2cb11c9886e1$export$2e2bcd8739ae039),
    enter: (0, $3cc848164081249c$export$2e2bcd8739ae039),
    exit: (0, $41f4de0282172f91$export$2e2bcd8739ae039),
    join: (0, $1cc4974d4334226b$export$2e2bcd8739ae039),
    merge: (0, $d5c8ae21615194fc$export$2e2bcd8739ae039),
    selection: $888ff001a7c8df76$var$selection_selection,
    order: (0, $cf6e9c0f8ce44da5$export$2e2bcd8739ae039),
    sort: (0, $871e1a6b4d8db120$export$2e2bcd8739ae039),
    call: (0, $24c7096c25ee2a1a$export$2e2bcd8739ae039),
    nodes: (0, $5e112341f7a35210$export$2e2bcd8739ae039),
    node: (0, $6a974c3f4db31e87$export$2e2bcd8739ae039),
    size: (0, $c02f3400e6370dcb$export$2e2bcd8739ae039),
    empty: (0, $10215b00de102938$export$2e2bcd8739ae039),
    each: (0, $54821ee8617eebf3$export$2e2bcd8739ae039),
    attr: (0, $8e8b0dc04eeda3c1$export$2e2bcd8739ae039),
    style: (0, $1637bce2c26d4dda$export$2e2bcd8739ae039),
    property: (0, $95f85d3f14570093$export$2e2bcd8739ae039),
    classed: (0, $9db445bd3c12cc0a$export$2e2bcd8739ae039),
    text: (0, $2a5f8182d170a568$export$2e2bcd8739ae039),
    html: (0, $695a2e781708858f$export$2e2bcd8739ae039),
    raise: (0, $6f612ccd8cd53d2e$export$2e2bcd8739ae039),
    lower: (0, $2c5e5aeec27943ea$export$2e2bcd8739ae039),
    append: (0, $32316b75fe05c76e$export$2e2bcd8739ae039),
    insert: (0, $6752de825c2317b1$export$2e2bcd8739ae039),
    remove: (0, $5e91d7a6cf62e418$export$2e2bcd8739ae039),
    clone: (0, $45c70610384d1a2d$export$2e2bcd8739ae039),
    datum: (0, $46efae388a937f9f$export$2e2bcd8739ae039),
    on: (0, $bad9449716c35ae5$export$2e2bcd8739ae039),
    dispatch: (0, $c9ae6cc015345bc8$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $720c47b6cab85079$export$2e2bcd8739ae039)
};
var $888ff001a7c8df76$export$2e2bcd8739ae039 = $888ff001a7c8df76$var$selection;


function $e364575a41f2aa58$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $888ff001a7c8df76$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $888ff001a7c8df76$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $888ff001a7c8df76$export$e8e78c978b129247));
}


function $ce9c13419f4a4d2c$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


const $35d6c55c9c1bb968$export$2335f513bbd82c6d = Math.abs;
const $35d6c55c9c1bb968$export$b8b770ee6a0d9760 = Math.atan2;
const $35d6c55c9c1bb968$export$50d414a77b60d802 = Math.cos;
const $35d6c55c9c1bb968$export$8960430cfd85939f = Math.max;
const $35d6c55c9c1bb968$export$96ec731ed4dcb222 = Math.min;
const $35d6c55c9c1bb968$export$5de3937cb4b592ed = Math.sin;
const $35d6c55c9c1bb968$export$eba8049fb5020b81 = Math.sqrt;
const $35d6c55c9c1bb968$export$6c421550c66a327d = 1e-12;
const $35d6c55c9c1bb968$export$18c7bea995a110f = Math.PI;
const $35d6c55c9c1bb968$export$e51408a300e8929a = $35d6c55c9c1bb968$export$18c7bea995a110f / 2;
const $35d6c55c9c1bb968$export$a4b4b4d4d776fe92 = 2 * $35d6c55c9c1bb968$export$18c7bea995a110f;
function $35d6c55c9c1bb968$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $35d6c55c9c1bb968$export$18c7bea995a110f : Math.acos(x);
}
function $35d6c55c9c1bb968$export$41726bdb1fc63f(x) {
    return x >= 1 ? $35d6c55c9c1bb968$export$e51408a300e8929a : x <= -1 ? -$35d6c55c9c1bb968$export$e51408a300e8929a : Math.asin(x);
}


const $234cb0a0450ba414$var$pi = Math.PI, $234cb0a0450ba414$var$tau = 2 * $234cb0a0450ba414$var$pi, $234cb0a0450ba414$var$epsilon = 1e-6, $234cb0a0450ba414$var$tauEpsilon = $234cb0a0450ba414$var$tau - $234cb0a0450ba414$var$epsilon;
function $234cb0a0450ba414$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $234cb0a0450ba414$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $234cb0a0450ba414$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $234cb0a0450ba414$export$4b2950bdac9b6ee9 {
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $234cb0a0450ba414$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $234cb0a0450ba414$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($234cb0a0450ba414$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $234cb0a0450ba414$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $234cb0a0450ba414$var$epsilon || Math.abs(this._y1 - y0) > $234cb0a0450ba414$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $234cb0a0450ba414$var$tau + $234cb0a0450ba414$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $234cb0a0450ba414$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $234cb0a0450ba414$var$epsilon) this._append`A${r},${r},0,${+(da >= $234cb0a0450ba414$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $234cb0a0450ba414$var$append : $234cb0a0450ba414$var$appendRound(digits);
    }
}
function $234cb0a0450ba414$export$bb654e07daaf8c3a() {
    return new $234cb0a0450ba414$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$234cb0a0450ba414$export$bb654e07daaf8c3a.prototype = $234cb0a0450ba414$export$4b2950bdac9b6ee9.prototype;
function $234cb0a0450ba414$export$e181c6ece8d9cc5f(digits = 3) {
    return new $234cb0a0450ba414$export$4b2950bdac9b6ee9(+digits);
}


function $c69a87cab76870d3$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $234cb0a0450ba414$export$4b2950bdac9b6ee9)(digits);
}


function $8606ab35a498d19a$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $8606ab35a498d19a$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $8606ab35a498d19a$var$arcStartAngle(d) {
    return d.startAngle;
}
function $8606ab35a498d19a$var$arcEndAngle(d) {
    return d.endAngle;
}
function $8606ab35a498d19a$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $8606ab35a498d19a$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $35d6c55c9c1bb968$export$6c421550c66a327d)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $8606ab35a498d19a$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $35d6c55c9c1bb968$export$eba8049fb5020b81)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $35d6c55c9c1bb968$export$eba8049fb5020b81)((0, $35d6c55c9c1bb968$export$8960430cfd85939f)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $8606ab35a498d19a$export$2e2bcd8739ae039() {
    var innerRadius = $8606ab35a498d19a$var$arcInnerRadius, outerRadius = $8606ab35a498d19a$var$arcOuterRadius, cornerRadius = (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(0), padRadius = null, startAngle = $8606ab35a498d19a$var$arcStartAngle, endAngle = $8606ab35a498d19a$var$arcEndAngle, padAngle = $8606ab35a498d19a$var$arcPadAngle, context = null, path = (0, $c69a87cab76870d3$export$fb6e83118a5dcd45)(arc);
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $35d6c55c9c1bb968$export$e51408a300e8929a), a1 = endAngle.apply(this, arguments) - (0, $35d6c55c9c1bb968$export$e51408a300e8929a), da = (0, $35d6c55c9c1bb968$export$2335f513bbd82c6d)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = path();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $35d6c55c9c1bb968$export$6c421550c66a327d))) context.moveTo(0, 0);
        else if (da > (0, $35d6c55c9c1bb968$export$a4b4b4d4d776fe92) - (0, $35d6c55c9c1bb968$export$6c421550c66a327d)) {
            context.moveTo(r1 * (0, $35d6c55c9c1bb968$export$50d414a77b60d802)(a0), r1 * (0, $35d6c55c9c1bb968$export$5de3937cb4b592ed)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $35d6c55c9c1bb968$export$6c421550c66a327d)) {
                context.moveTo(r0 * (0, $35d6c55c9c1bb968$export$50d414a77b60d802)(a1), r0 * (0, $35d6c55c9c1bb968$export$5de3937cb4b592ed)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $35d6c55c9c1bb968$export$6c421550c66a327d) && (padRadius ? +padRadius.apply(this, arguments) : (0, $35d6c55c9c1bb968$export$eba8049fb5020b81)(r0 * r0 + r1 * r1)), rc = (0, $35d6c55c9c1bb968$export$96ec731ed4dcb222)((0, $35d6c55c9c1bb968$export$2335f513bbd82c6d)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $35d6c55c9c1bb968$export$6c421550c66a327d)) {
                var p0 = (0, $35d6c55c9c1bb968$export$41726bdb1fc63f)(rp / r0 * (0, $35d6c55c9c1bb968$export$5de3937cb4b592ed)(ap)), p1 = (0, $35d6c55c9c1bb968$export$41726bdb1fc63f)(rp / r1 * (0, $35d6c55c9c1bb968$export$5de3937cb4b592ed)(ap));
                if ((da0 -= p0 * 2) > (0, $35d6c55c9c1bb968$export$6c421550c66a327d)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $35d6c55c9c1bb968$export$6c421550c66a327d)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $35d6c55c9c1bb968$export$50d414a77b60d802)(a01), y01 = r1 * (0, $35d6c55c9c1bb968$export$5de3937cb4b592ed)(a01), x10 = r0 * (0, $35d6c55c9c1bb968$export$50d414a77b60d802)(a10), y10 = r0 * (0, $35d6c55c9c1bb968$export$5de3937cb4b592ed)(a10);
            // Apply rounded corners?
            if (rc > (0, $35d6c55c9c1bb968$export$6c421550c66a327d)) {
                var x11 = r1 * (0, $35d6c55c9c1bb968$export$50d414a77b60d802)(a11), y11 = r1 * (0, $35d6c55c9c1bb968$export$5de3937cb4b592ed)(a11), x00 = r0 * (0, $35d6c55c9c1bb968$export$50d414a77b60d802)(a00), y00 = r0 * (0, $35d6c55c9c1bb968$export$5de3937cb4b592ed)(a00), oc;
                // Restrict the corner radius according to the sector angle. If this
                // intersection fails, it’s probably because the arc is too small, so
                // disable the corner radius entirely.
                if (da < (0, $35d6c55c9c1bb968$export$18c7bea995a110f)) {
                    if (oc = $8606ab35a498d19a$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $35d6c55c9c1bb968$export$5de3937cb4b592ed)((0, $35d6c55c9c1bb968$export$fd6306be3fde5b04)((ax * bx + ay * by) / ((0, $35d6c55c9c1bb968$export$eba8049fb5020b81)(ax * ax + ay * ay) * (0, $35d6c55c9c1bb968$export$eba8049fb5020b81)(bx * bx + by * by))) / 2), lc = (0, $35d6c55c9c1bb968$export$eba8049fb5020b81)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, $35d6c55c9c1bb968$export$96ec731ed4dcb222)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, $35d6c55c9c1bb968$export$96ec731ed4dcb222)(rc, (r1 - lc) / (kc + 1));
                    } else rc0 = rc1 = 0;
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $35d6c55c9c1bb968$export$6c421550c66a327d))) context.moveTo(x01, y01);
            else if (rc1 > (0, $35d6c55c9c1bb968$export$6c421550c66a327d)) {
                t0 = $8606ab35a498d19a$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $8606ab35a498d19a$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t1.y11, t1.x11), (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $35d6c55c9c1bb968$export$6c421550c66a327d)) || !(da0 > (0, $35d6c55c9c1bb968$export$6c421550c66a327d))) context.lineTo(x10, y10);
            else if (rc0 > (0, $35d6c55c9c1bb968$export$6c421550c66a327d)) {
                t0 = $8606ab35a498d19a$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $8606ab35a498d19a$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t1.y11, t1.x11), (0, $35d6c55c9c1bb968$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $35d6c55c9c1bb968$export$18c7bea995a110f) / 2;
        return [
            (0, $35d6c55c9c1bb968$export$50d414a77b60d802)(a) * r,
            (0, $35d6c55c9c1bb968$export$5de3937cb4b592ed)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

var $8f1fb305f7f433d2$export$58adb3bec8346d0f = Array.prototype.slice;
function $8f1fb305f7f433d2$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}



function $9bda197e732deac7$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $8f945d0827324e82$export$2e2bcd8739ae039(d) {
    return d;
}



function $7ea3db66faab6af9$export$2e2bcd8739ae039() {
    var value = (0, $8f945d0827324e82$export$2e2bcd8739ae039), sortValues = (0, $9bda197e732deac7$export$2e2bcd8739ae039), sort = null, startAngle = (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(0), endAngle = (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)((0, $35d6c55c9c1bb968$export$a4b4b4d4d776fe92)), padAngle = (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(0);
    function pie(data) {
        var i, n = (data = (0, $8f1fb305f7f433d2$export$2e2bcd8739ae039)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $35d6c55c9c1bb968$export$a4b4b4d4d776fe92), Math.max(-(0, $35d6c55c9c1bb968$export$a4b4b4d4d776fe92), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), pie) : padAngle;
    };
    return pie;
}


class $76654d8a9a88e74d$export$2e2bcd8739ae039 {
    display(parent, data) {
        if (data == null) return;
        const { background: background, title: title, arc: arc } = this.axes(this.categories, this.colors, this.dimensions);
        const pieData = this.formatData(data);
        const chart = this.addChart(parent.querySelector("svg"), this.dimensions);
        const tooltip = this.addTooltip(parent);
        const segments = this.addSegments(chart, pieData, arc, background);
        this.addEvents(segments, tooltip, parent, title, data.total_count);
    }
    getDimensions(width, height, padTop, padLeft, padBottom, padRight) {
        return {
            width: width,
            height: height,
            padding: {
                top: padTop,
                left: padLeft,
                bottom: padBottom,
                right: padRight
            },
            totalWidth: width + padLeft + padRight,
            totalHeight: height + padTop + padBottom,
            radius: Math.min(width, height) / 2
        };
    }
    axes(categories, colors, dimensions) {
        return {
            background: (0, $8a65d664d179e374$export$2e2bcd8739ae039)().domain(categories).range(colors),
            title: (0, $8a65d664d179e374$export$2e2bcd8739ae039)().domain(categories).range([
                "Correct",
                "Incorrect",
                "Unanswered"
            ]),
            arc: (0, $8606ab35a498d19a$export$2e2bcd8739ae039)().innerRadius(dimensions.radius * 0.5).outerRadius(dimensions.radius * 1.0)
        };
    }
    addChart(selector, dimensions) {
        const svg = (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(selector).attr("width", dimensions.totalWidth).attr("height", dimensions.totalHeight);
        return svg.append("g").attr("transform", "translate(" + (dimensions.padding.left + dimensions.width / 2) + "," + (dimensions.padding.top + dimensions.height / 2) + ")");
    }
    addTooltip(parent) {
        return (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(parent).insert("div", ":first-child").style("float", "left").style("width", 0).insert("div", ":first-child").attr("class", "border rounded p-1 bg-light text-body").style("width", "max-content").style("display", "none").style("z-index", 10).style("position", "relative");
    }
    formatData(total) {
        return (0, $7ea3db66faab6af9$export$2e2bcd8739ae039)().sort(null).value((d)=>d.value)([
            {
                key: "correct",
                value: parseInt(total.correct_count)
            },
            {
                key: "incorrect",
                value: parseInt(total.answered_count) - parseInt(total.correct_count)
            },
            {
                key: "unanswered",
                value: parseInt(total.total_count) - parseInt(total.answered_count)
            }
        ]);
    }
    addSegments(chart, data, arc, background) {
        return chart.selectAll("g").data(data).enter().append("path").attr("d", arc).attr("fill", (d)=>background(d.data.key)).attr("stroke", "white").style("stroke-width", "2px");
    }
    addEvents(segments, tooltip, parent, title, total) {
        return segments.on("mouseover", (e, d)=>{
            (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(e.currentTarget).style("opacity", 0.9);
            tooltip.style("display", "block");
        }).on("mousemove", (e, d)=>{
            const chartRect = parent.getBoundingClientRect();
            tooltip.style("top", e.pageY - chartRect.y - window.scrollY + "px").style("left", e.pageX - chartRect.x - window.scrollX + 20 + "px").html(title(d.data.key) + ": " + d.data.value + " / " + total);
        }).on("mouseout", (e, d)=>{
            (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(e.currentTarget).style("opacity", 1);
            tooltip.style("display", "none");
        });
    }
    constructor(categories, colors, width, height, padding){
        width = width || 50;
        height = height || 50;
        padding = padding || 2;
        this.dimensions = this.getDimensions(width, height, padding, padding, padding, padding);
        this.colors = colors || [
            "#28a745",
            "#dc3545",
            "#17a2b8"
        ];
        this.categories = categories || [
            "correct",
            "incorrect",
            "unanswered"
        ];
    }
}


function $800539bfc9b874e7$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}


function $73834247356fcbfd$export$2e2bcd8739ae039(x) {
    return x;
}


var $29b93e4e9fea23ba$var$top = 1, $29b93e4e9fea23ba$var$right = 2, $29b93e4e9fea23ba$var$bottom = 3, $29b93e4e9fea23ba$var$left = 4, $29b93e4e9fea23ba$var$epsilon = 1e-6;
function $29b93e4e9fea23ba$var$translateX(x) {
    return "translate(" + x + ",0)";
}
function $29b93e4e9fea23ba$var$translateY(y) {
    return "translate(0," + y + ")";
}
function $29b93e4e9fea23ba$var$number(scale) {
    return (d)=>+scale(d);
}
function $29b93e4e9fea23ba$var$center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function $29b93e4e9fea23ba$var$entering() {
    return !this.__axis;
}
function $29b93e4e9fea23ba$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === $29b93e4e9fea23ba$var$top || orient === $29b93e4e9fea23ba$var$left ? -1 : 1, x = orient === $29b93e4e9fea23ba$var$left || orient === $29b93e4e9fea23ba$var$right ? "x" : "y", transform = orient === $29b93e4e9fea23ba$var$top || orient === $29b93e4e9fea23ba$var$bottom ? $29b93e4e9fea23ba$var$translateX : $29b93e4e9fea23ba$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $73834247356fcbfd$export$2e2bcd8739ae039) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? $29b93e4e9fea23ba$var$center : $29b93e4e9fea23ba$var$number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $29b93e4e9fea23ba$var$top ? "0em" : orient === $29b93e4e9fea23ba$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $29b93e4e9fea23ba$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $29b93e4e9fea23ba$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === $29b93e4e9fea23ba$var$left || orient === $29b93e4e9fea23ba$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($29b93e4e9fea23ba$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $29b93e4e9fea23ba$var$right ? "start" : orient === $29b93e4e9fea23ba$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = Array.from(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function $29b93e4e9fea23ba$export$59b8cfab074bdeb1(scale) {
    return $29b93e4e9fea23ba$var$axis($29b93e4e9fea23ba$var$top, scale);
}
function $29b93e4e9fea23ba$export$b0d2e24dc4f898f0(scale) {
    return $29b93e4e9fea23ba$var$axis($29b93e4e9fea23ba$var$right, scale);
}
function $29b93e4e9fea23ba$export$e5cb22533a15e72e(scale) {
    return $29b93e4e9fea23ba$var$axis($29b93e4e9fea23ba$var$bottom, scale);
}
function $29b93e4e9fea23ba$export$2749afb169a520d2(scale) {
    return $29b93e4e9fea23ba$var$axis($29b93e4e9fea23ba$var$left, scale);
}


function $dd90163c78946590$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}




function $86cc0597d8670c27$export$2e2bcd8739ae039() {
    var scale = (0, $8a65d664d179e374$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $dd90163c78946590$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $86cc0597d8670c27$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $c968f941ac06b803$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $86cc0597d8670c27$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $86cc0597d8670c27$var$pointish(copy());
    };
    return scale;
}
function $86cc0597d8670c27$export$105684a3041cb6f3() {
    return $86cc0597d8670c27$var$pointish($86cc0597d8670c27$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

const $a707011926c55b22$var$e10 = Math.sqrt(50), $a707011926c55b22$var$e5 = Math.sqrt(10), $a707011926c55b22$var$e2 = Math.sqrt(2);
function $a707011926c55b22$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $a707011926c55b22$var$e10 ? 10 : error >= $a707011926c55b22$var$e5 ? 5 : error >= $a707011926c55b22$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $a707011926c55b22$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $a707011926c55b22$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $a707011926c55b22$var$tickSpec(stop, start, count) : $a707011926c55b22$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $a707011926c55b22$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $a707011926c55b22$var$tickSpec(start, stop, count)[2];
}
function $a707011926c55b22$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $a707011926c55b22$export$bc64d00cc98e7e95(stop, start, count) : $a707011926c55b22$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


function $65ec430c005bb061$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $4e82f40db7826ca2$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $21ff4cbd972536a9$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $65ec430c005bb061$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $65ec430c005bb061$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $65ec430c005bb061$export$2e2bcd8739ae039) || f === (0, $4e82f40db7826ca2$export$2e2bcd8739ae039) ? f : $21ff4cbd972536a9$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $21ff4cbd972536a9$var$zero() {
    return 0;
}


function $c715e7387d6e6d95$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $c715e7387d6e6d95$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $1f866f2e4865deca$var$ascendingBisect = (0, $21ff4cbd972536a9$export$2e2bcd8739ae039)((0, $65ec430c005bb061$export$2e2bcd8739ae039));
const $1f866f2e4865deca$export$4d945ad3ad5751b0 = $1f866f2e4865deca$var$ascendingBisect.right;
const $1f866f2e4865deca$export$df7d25c84ebd12a5 = $1f866f2e4865deca$var$ascendingBisect.left;
const $1f866f2e4865deca$export$c1cb828b1117c77b = (0, $21ff4cbd972536a9$export$2e2bcd8739ae039)((0, $c715e7387d6e6d95$export$2e2bcd8739ae039)).center;
var $1f866f2e4865deca$export$2e2bcd8739ae039 = $1f866f2e4865deca$export$4d945ad3ad5751b0;



var $3uo0s = parcelRequire("3uo0s");

var $3uo0s = parcelRequire("3uo0s");
function $1269de0059a989c3$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $1269de0059a989c3$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $1269de0059a989c3$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $e543077a24db799a$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $1269de0059a989c3$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $698bf26e9ff74037$export$2e2bcd8739ae039 = (x)=>()=>x;


function $5ffbed33a5caf128$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $5ffbed33a5caf128$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $5ffbed33a5caf128$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $5ffbed33a5caf128$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $698bf26e9ff74037$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $5ffbed33a5caf128$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $5ffbed33a5caf128$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $5ffbed33a5caf128$var$exponential(a, b, y) : (0, $698bf26e9ff74037$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $5ffbed33a5caf128$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $5ffbed33a5caf128$var$linear(a, d) : (0, $698bf26e9ff74037$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $6f3b7070e66415ce$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $5ffbed33a5caf128$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $3uo0s.rgb)(start)).r, (end = (0, $3uo0s.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $5ffbed33a5caf128$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $6f3b7070e66415ce$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $3uo0s.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $6f3b7070e66415ce$export$2c0e28f2e2852d3f = $6f3b7070e66415ce$var$rgbSpline((0, $1269de0059a989c3$export$2e2bcd8739ae039));
var $6f3b7070e66415ce$export$53d5214f625ccd4c = $6f3b7070e66415ce$var$rgbSpline((0, $e543077a24db799a$export$2e2bcd8739ae039));



function $433f5eb4c50a1727$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $433f5eb4c50a1727$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $9501a1d7a2719848$export$2e2bcd8739ae039(a, b) {
    return ((0, $433f5eb4c50a1727$export$5cd576d1827d40c8)(b) ? (0, $433f5eb4c50a1727$export$2e2bcd8739ae039) : $9501a1d7a2719848$export$15d09067c6a5ee49)(a, b);
}
function $9501a1d7a2719848$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $f130e3ae68d1ffef$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $827b19be8c2c5f0c$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $b44e2310648557b8$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $65a9eeebceb85b19$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $f130e3ae68d1ffef$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $f769de6564047a23$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $f769de6564047a23$var$reB = new RegExp($f769de6564047a23$var$reA.source, "g");
function $f769de6564047a23$var$zero(b) {
    return function() {
        return b;
    };
}
function $f769de6564047a23$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $f769de6564047a23$export$2e2bcd8739ae039(a, b) {
    var bi = $f769de6564047a23$var$reA.lastIndex = $f769de6564047a23$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $f769de6564047a23$var$reA.exec(a)) && (bm = $f769de6564047a23$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $b44e2310648557b8$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $f769de6564047a23$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $f769de6564047a23$var$one(q[0].x) : $f769de6564047a23$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $f130e3ae68d1ffef$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $698bf26e9ff74037$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $b44e2310648557b8$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $3uo0s.default)(b)) ? (b = c, $6f3b7070e66415ce$export$2e2bcd8739ae039) : (0, $f769de6564047a23$export$2e2bcd8739ae039) : b instanceof (0, $3uo0s.default) ? (0, $6f3b7070e66415ce$export$2e2bcd8739ae039) : b instanceof Date ? (0, $827b19be8c2c5f0c$export$2e2bcd8739ae039) : (0, $433f5eb4c50a1727$export$5cd576d1827d40c8)(b) ? (0, $433f5eb4c50a1727$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $9501a1d7a2719848$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $65a9eeebceb85b19$export$2e2bcd8739ae039) : (0, $b44e2310648557b8$export$2e2bcd8739ae039))(a, b);
}

function $ac2ee972a9cbfd14$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $91a9f80d019f21a5$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $0dc57bbe03b09c5d$export$2e2bcd8739ae039(x) {
    return +x;
}


var $c31f44301b95edb5$var$unit = [
    0,
    1
];
function $c31f44301b95edb5$export$f0954fd7d5368655(x) {
    return x;
}
function $c31f44301b95edb5$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $91a9f80d019f21a5$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $c31f44301b95edb5$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $c31f44301b95edb5$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $c31f44301b95edb5$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $c31f44301b95edb5$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $c31f44301b95edb5$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $c31f44301b95edb5$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $1f866f2e4865deca$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $c31f44301b95edb5$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $c31f44301b95edb5$export$6b468dcfb64c653c() {
    var domain = $c31f44301b95edb5$var$unit, range = $c31f44301b95edb5$var$unit, interpolate = (0, $f130e3ae68d1ffef$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $c31f44301b95edb5$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $c31f44301b95edb5$export$f0954fd7d5368655) clamp = $c31f44301b95edb5$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $c31f44301b95edb5$var$polymap : $c31f44301b95edb5$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $b44e2310648557b8$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $0dc57bbe03b09c5d$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $ac2ee972a9cbfd14$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $c31f44301b95edb5$export$f0954fd7d5368655, rescale()) : clamp !== $c31f44301b95edb5$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $c31f44301b95edb5$export$2e2bcd8739ae039() {
    return $c31f44301b95edb5$export$6b468dcfb64c653c()($c31f44301b95edb5$export$f0954fd7d5368655, $c31f44301b95edb5$export$f0954fd7d5368655);
}




function $c1887779f7bce7f2$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $c1887779f7bce7f2$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $58b90971264ea117$export$2e2bcd8739ae039(x) {
    return x = (0, $c1887779f7bce7f2$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $6c9ea20aa9789170$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $f2cf412153fa889f$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $f8eb1e2ed0516dc9$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $f8eb1e2ed0516dc9$export$2e2bcd8739ae039(specifier) {
    if (!(match = $f8eb1e2ed0516dc9$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $f8eb1e2ed0516dc9$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$f8eb1e2ed0516dc9$export$2e2bcd8739ae039.prototype = $f8eb1e2ed0516dc9$export$963aac351db36ed4.prototype; // instanceof
function $f8eb1e2ed0516dc9$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$f8eb1e2ed0516dc9$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $b12ac732638bee82$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $4133b99b58e79819$export$6863724d9a42263;
function $4133b99b58e79819$export$2e2bcd8739ae039(x, p) {
    var d = (0, $c1887779f7bce7f2$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($4133b99b58e79819$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $c1887779f7bce7f2$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $80577edc3f819097$export$2e2bcd8739ae039(x, p) {
    var d = (0, $c1887779f7bce7f2$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $d288b8f427cf509d$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $c1887779f7bce7f2$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $80577edc3f819097$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $80577edc3f819097$export$2e2bcd8739ae039),
    "s": (0, $4133b99b58e79819$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $add4e2fc740e38fe$export$2e2bcd8739ae039(x) {
    return x;
}


var $dcd47befb85f5d66$var$map = Array.prototype.map, $dcd47befb85f5d66$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $dcd47befb85f5d66$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $add4e2fc740e38fe$export$2e2bcd8739ae039) : (0, $6c9ea20aa9789170$export$2e2bcd8739ae039)($dcd47befb85f5d66$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $add4e2fc740e38fe$export$2e2bcd8739ae039) : (0, $f2cf412153fa889f$export$2e2bcd8739ae039)($dcd47befb85f5d66$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $f8eb1e2ed0516dc9$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $d288b8f427cf509d$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $d288b8f427cf509d$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $b12ac732638bee82$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $dcd47befb85f5d66$var$prefixes[8 + (0, $4133b99b58e79819$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $f8eb1e2ed0516dc9$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $58b90971264ea117$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $dcd47befb85f5d66$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $f620af7074118973$var$locale;
var $f620af7074118973$export$d9468344d3651243;
var $f620af7074118973$export$8d85692a469dde6f;
$f620af7074118973$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $f620af7074118973$export$2e2bcd8739ae039(definition) {
    $f620af7074118973$var$locale = (0, $dcd47befb85f5d66$export$2e2bcd8739ae039)(definition);
    $f620af7074118973$export$d9468344d3651243 = $f620af7074118973$var$locale.format;
    $f620af7074118973$export$8d85692a469dde6f = $f620af7074118973$var$locale.formatPrefix;
    return $f620af7074118973$var$locale;
}


function $01459054e5ce6a54$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $58b90971264ea117$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $5480703e08f7e01a$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $58b90971264ea117$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $58b90971264ea117$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $1214173ef4a26b50$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $58b90971264ea117$export$2e2bcd8739ae039)(max) - (0, $58b90971264ea117$export$2e2bcd8739ae039)(step)) + 1;
}


function $c58c4d807da7e72a$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $a707011926c55b22$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $f8eb1e2ed0516dc9$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $5480703e08f7e01a$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $f620af7074118973$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $1214173ef4a26b50$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $01459054e5ce6a54$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $f620af7074118973$export$d9468344d3651243)(specifier);
}


function $46340e1ddeb76e73$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $a707011926c55b22$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $c58c4d807da7e72a$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $a707011926c55b22$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $46340e1ddeb76e73$export$2e2bcd8739ae039() {
    var scale = (0, $c31f44301b95edb5$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $c31f44301b95edb5$export$784d13d8ee351f07)(scale, $46340e1ddeb76e73$export$2e2bcd8739ae039());
    };
    (0, $c968f941ac06b803$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $46340e1ddeb76e73$export$16a5d4b4a61a274d(scale);
}





function $8c8e1f887cbd6817$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $5e41cb1efb6ddbf1$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $8d475aa4dc516a83$var$stackValue(d, key) {
    return d[key];
}
function $8d475aa4dc516a83$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $8d475aa4dc516a83$export$2e2bcd8739ae039() {
    var keys = (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)([]), order = (0, $5e41cb1efb6ddbf1$export$2e2bcd8739ae039), offset = (0, $8c8e1f887cbd6817$export$2e2bcd8739ae039), value = $8d475aa4dc516a83$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $8d475aa4dc516a83$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $8f1fb305f7f433d2$export$2e2bcd8739ae039)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $5e41cb1efb6ddbf1$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $ce9c13419f4a4d2c$export$2e2bcd8739ae039)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $8c8e1f887cbd6817$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}


class $a517049a9fa09796$export$2e2bcd8739ae039 {
    display(element, sections) {
        const dimensions = this.getDimensions(this.width, this.heightMult * sections.length, this.padTop, this.padLeft, this.padBottom, this.padRight);
        const sectionData = this.formatData(sections, this.categories);
        const axes = this.axes(sections, this.categories, this.colors, dimensions);
        const chart = this.addChart(element.querySelector("svg"), dimensions);
        const tooltip = this.addTooltip(element);
        const bars = this.addBars(chart, axes.background, sectionData);
        this.fillBars(bars, axes.x, axes.y);
        this.addEvents(bars, tooltip, element, axes.title);
        this.addAxes(chart, dimensions.height, axes.x, axes.y, 18);
    }
    getDimensions(width, height, padTop, padLeft, padBottom, padRight) {
        return {
            width: width,
            height: height,
            padding: {
                top: padTop,
                left: padLeft,
                bottom: padBottom,
                right: padRight
            },
            totalWidth: width + padLeft + padRight,
            totalHeight: height + padTop + padBottom
        };
    }
    formatData(sections, categories) {
        return (0, $8d475aa4dc516a83$export$2e2bcd8739ae039)().keys(categories)(sections.map((s)=>({
                section: s.section,
                correct: s.correct,
                incorrect: s.incorrect,
                unanswered: s.unanswered,
                total: s.total
            })));
    }
    axes(sections, categories, colors, dimensions) {
        return {
            x: (0, $46340e1ddeb76e73$export$2e2bcd8739ae039)().domain([
                0,
                (0, $800539bfc9b874e7$export$2e2bcd8739ae039)(sections, (d)=>d.total)
            ]).range([
                0,
                dimensions.width
            ]),
            y: (0, $86cc0597d8670c27$export$2e2bcd8739ae039)().domain(sections.map((s)=>s.section)).range([
                0,
                dimensions.height
            ]).padding(0.12),
            background: (0, $8a65d664d179e374$export$2e2bcd8739ae039)().domain(categories).range(colors),
            foreground: (0, $8a65d664d179e374$export$2e2bcd8739ae039)().domain(categories).range([
                "white",
                "white",
                "white"
            ]),
            title: (0, $8a65d664d179e374$export$2e2bcd8739ae039)().domain(categories).range([
                "Correct",
                "Incorrect",
                "Unanswered"
            ])
        };
    }
    addChart(element, dimensions) {
        const svg = (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(element).attr("width", dimensions.totalWidth).attr("height", dimensions.totalHeight);
        return svg.append("g").attr("transform", "translate(" + dimensions.padding.left + "," + dimensions.padding.top + ")").attr("width", dimensions.width).attr("height", dimensions.height);
    }
    addTooltip(parent) {
        return (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(parent).insert("div", ":first-child").style("float", "left").style("width", 0).insert("div", ":first-child").attr("class", "border rounded p-1 bg-light").style("width", "max-content").style("display", "none").style("position", "relative");
    }
    addBars(chart, background, data) {
        return chart.selectAll("g").data(data).join("g").attr("fill", (d)=>background(d.key)).selectAll("g").data((d)=>d.map((i)=>{
                i.key = d.key;
                return i;
            })).join("g");
    }
    addEvents(bars, tooltip, parent, title) {
        return bars.on("mouseover", (event, data)=>{
            tooltip.style("display", "block");
            (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(event.currentTarget).select("rect").style("opacity", 0.95);
        }).on("mouseleave", (event, data)=>{
            tooltip.style("display", "none");
            (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(event.currentTarget).select("rect").style("opacity", 1);
        }).on("mousemove", (event, data)=>{
            const svgRect = parent.getBoundingClientRect();
            tooltip.style("top", event.pageY - svgRect.y - window.scrollY + "px").style("left", event.pageX - svgRect.x - window.scrollX + 20 + "px").html("<b>" + data.data.section + "</b><br/>" + title(data.key) + ": " + data.data[data.key] + " / " + data.data.total);
        });
    }
    fillBars(bars, x, y) {
        return bars.append("rect").attr("x", (d)=>x(d[0])).attr("y", (d)=>y(d.data.section)).attr("width", (d)=>x(d[1]) - x(d[0])).attr("height", y.bandwidth());
    }
    addAxes(chart, height, x, y, truncate) {
        chart.append("g").attr("transform", "translate(0, " + height + ")").call((0, $29b93e4e9fea23ba$export$e5cb22533a15e72e)(x));
        chart.append("g").attr("transform", "translate(0, 0)").call((0, $29b93e4e9fea23ba$export$2749afb169a520d2)(y).tickFormat((d)=>d.length > truncate ? d.substring(0, truncate) + "..." : d));
    }
    constructor(categories, colors, width, heightMult, padTop, padLeft, padBottom, padRight){
        this.heightMult = heightMult || 36;
        this.width = width || 200;
        this.padTop = padTop || 0;
        this.padLeft = padLeft || 120;
        this.padBottom = padBottom || 20;
        this.padRight = padRight || 5;
        this.categories = categories || [
            "correct",
            "incorrect",
            "unanswered"
        ];
        this.colors = colors || [
            "#28a745",
            "#dc3545",
            "#17a2b8"
        ];
    }
}





class $393886a4136ecb5a$export$2e2bcd8739ae039 {
    display(element, total) {
        const { background: background, title: title, x: x } = this.axes(total, this.categories, this.colors, this.dimensions);
        const data = this.formatData(total, this.categories);
        const chart = this.addChart(element.querySelector("svg"), this.dimensions);
        const tooltip = this.addTooltip(element);
        const bars = this.addBars(chart, data, background);
        this.addEvents(bars, tooltip, element, title, total.total);
        this.fillBars(bars, x, this.dimensions);
        this.addPercent(bars, x, total.total, this.dimensions.height);
    }
    getDimensions(width, height, padTop, padLeft, padBottom, padRight) {
        return {
            width: width,
            height: height,
            padding: {
                top: padTop,
                left: padLeft,
                bottom: padBottom,
                right: padRight
            },
            totalWidth: width + padLeft + padRight,
            totalHeight: height + padTop + padBottom
        };
    }
    axes(total, categories, colors, dimensions) {
        return {
            background: (0, $8a65d664d179e374$export$2e2bcd8739ae039)().domain(categories).range(colors),
            title: (0, $8a65d664d179e374$export$2e2bcd8739ae039)().domain(categories).range([
                "Correct",
                "Incorrect",
                "Unanswered"
            ]),
            x: (0, $46340e1ddeb76e73$export$2e2bcd8739ae039)().domain([
                0,
                total.total
            ]).range([
                0,
                dimensions.width
            ])
        };
    }
    formatData(total, categories) {
        return (0, $8d475aa4dc516a83$export$2e2bcd8739ae039)().keys(categories)([
            total
        ]);
    }
    addChart(element, dimensions) {
        const svg = (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(element).attr("width", dimensions.totalWidth + "%").attr("height", dimensions.totalHeight);
        return svg.append("g").attr("transform", "translate(" + dimensions.padding.left + "," + dimensions.padding.top + ")");
    }
    addTooltip(parent) {
        return (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(parent).insert("div", ":first-child").style("float", "left").style("width", 0).insert("div", ":first-child").attr("class", "border rounded p-1 bg-light").style("width", "max-content").style("display", "none").style("z-index", 10).style("position", "relative");
    }
    addBars(chart, data, background) {
        return chart.selectAll("g").data(data.reverse()).join("g").attr("fill", (d)=>background(d.key)).selectAll("g").data((d)=>d.map((i)=>{
                i.key = d.key;
                return i;
            })).join("g");
    }
    addEvents(bars, tooltip, parent, title, total) {
        return bars.on("mouseover", (e, d)=>{
            (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(e.currentTarget).style("opacity", 0.9);
            tooltip.style("display", "block");
        }).on("mousemove", (e, d)=>{
            const chartRect = parent.getBoundingClientRect();
            tooltip.style("top", e.pageY - chartRect.y - window.scrollY + "px").style("left", e.pageX - chartRect.x - window.scrollX + 20 + "px").html(title(d.key) + ": " + d.data[d.key] + " / " + total);
        }).on("mouseout", (e, d)=>{
            (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(e.currentTarget).style("opacity", 1);
            tooltip.style("display", "none");
        });
    }
    fillBars(bars, x, dimensions) {
        return bars.append("rect").attr("x", 0).attr("y", 0).attr("rx", 5).attr("width", (d)=>x(d[1]) + "%").attr("height", dimensions.height);
    }
    addPercent(bars, x, total, height) {
        return bars.append("text").attr("x", (d)=>x((d[1] - d[0]) / 2 + d[0]) + "%").attr("dy", "50%").attr("dominant-baseline", "central").attr("text-anchor", "middle").attr("fill", "white").text((d)=>(d[1] - d[0]) / total < 0.04 ? "" : Math.round(d.data[d.key] / total * 100) + "%");
    }
    constructor(categories, colors, width, height, padding){
        this.categories = categories || [
            "correct",
            "incorrect",
            "unanswered"
        ];
        this.colors = colors || [
            "#28a745",
            "#dc3545",
            "#17a2b8"
        ];
        this.dimensions = this.getDimensions(width, height, padding, padding, padding, padding);
    }
}




class $36ae95b3cf151580$export$2e2bcd8739ae039 {
    display(parent, progress, total) {
        const x = this.axis(total, this.dimensions);
        const chart = this.addChart(parent.querySelector("svg"), this.dimensions);
        const tooltip = this.addTooltip(parent);
        const bars = this.addBars(chart, [
            {
                value: total,
                color: this.colors[0]
            },
            {
                value: progress,
                color: this.colors[1]
            }
        ]);
        this.fillBars(bars, x, this.dimensions.height);
        this.addPercent(chart, x, progress, this.dimensions.height);
        this.addEvents(bars, tooltip, parent.querySelector("svg"), progress, total);
    }
    getDimensions(width, height, padTop, padLeft, padBottom, padRight) {
        return {
            width: width,
            height: height,
            padding: {
                top: padTop,
                left: padLeft,
                bottom: padBottom,
                right: padRight
            },
            totalWidth: width + padLeft + padRight,
            totalHeight: height + padTop + padBottom
        };
    }
    axis(total, dimensions) {
        return (0, $46340e1ddeb76e73$export$2e2bcd8739ae039)().domain([
            0,
            total
        ]).range([
            0,
            dimensions.width
        ]);
    }
    addChart(element, dimensions) {
        element.innerHTML = "";
        const svg = (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(element).attr("width", dimensions.totalWidth + "%").attr("height", dimensions.totalHeight);
        return svg.append("g").attr("transform", "translate(" + dimensions.padding.left + "," + dimensions.padding.top + ")").attr("width", dimensions.width + "%").attr("height", dimensions.height);
    }
    addTooltip(parent) {
        return (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(parent).insert("div", ":first-child").style("float", "left").style("width", 0).insert("div", ":first-child").attr("class", "border rounded p-1 bg-light").style("width", "max-content").style("display", "none").style("position", "relative").style("z-index", 10);
    }
    addBars(chart, data) {
        return chart.selectAll("g").data(data).join("g").attr("fill", (d)=>d.color);
    }
    addEvents(bars, tooltip, element, answered, total) {
        return bars.on("mouseover", (event, data)=>{
            tooltip.style("display", "block");
            (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(event.currentTarget).select("rect").style("opacity", 0.75);
        }).on("mouseleave", (event, data)=>{
            tooltip.style("display", "none");
            (0, $e364575a41f2aa58$export$2e2bcd8739ae039)(event.currentTarget).select("rect").style("opacity", 1);
        }).on("mousemove", (event, data)=>{
            const svgRect = element.getBoundingClientRect();
            tooltip.style("top", event.pageY - svgRect.y - window.scrollY + "px").style("left", event.pageX - svgRect.x - window.scrollX + 20 + "px").html(`Progress: ${answered} / ${total}`);
        });
    }
    fillBars(bars, x, height) {
        return bars.append("rect").attr("x", (d)=>x(0)).attr("y", 0).attr("rx", 5).attr("width", (d)=>x(d.value) + "%").attr("height", height);
    }
    addPercent(chart, x, answered, height) {
        if (x(answered) >= 4) return chart.append("text").attr("x", x(answered) + "%").attr("dx", -5).attr("dy", "50%").attr("dominant-baseline", "central").attr("text-anchor", "end").attr("fill", "white").text(Math.round(x(answered)) + "%");
    }
    constructor(colors, width, height, padding){
        width = width || 100;
        height = height || 20;
        padding = padding || 0;
        this.dimensions = this.getDimensions(width, height, padding, padding, padding, padding);
        this.colors = colors || [
            "#00000011",
            "var(--dominant-color)"
        ];
    }
}





/// <reference types="datatables.net" />
class $9b4877c7931d8c2c$export$2e2bcd8739ae039 {
    display(element, product) {
        const dataTable = this.table(element, product);
        const filterRow = this.addFilterRow(dataTable);
        const toggle = this.addToggle(filterRow);
        return dataTable;
    }
    table(element, product) {
        return this.jQuery(element).DataTable({
            dom: "<'row'<'col-sm-12 col-md-6 filter-toggle'><'col-sm-12 col-md-6 d-flex flex-row justify-content-end'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
            responsive: true,
            order: [
                [
                    2,
                    "desc"
                ]
            ],
            columns: [
                {
                    visible: false,
                    type: "num"
                },
                {
                    render: (data, type, row, meta)=>{
                        if (type === "display") {
                            const complete = row[1] === "true";
                            const first = this.jQuery(element).DataTable().cell({
                                row: meta.row,
                                column: meta.col
                            }).node().dataset.first;
                            return `<div class="d-flex flex-row justify-content-center">
								<div style="width: 4.5em;">
									<input type="checkbox"
										${data === "true" ? "checked" : ""}
										onclick="return false;"
										style="filter: hue-rotate(270deg);"
									/>
									<a class="small ml-1" href="${[
                                "/practicequestion",
                                complete ? "result" : "test",
                                this.productIdSerializer.toString(product),
                                row[0]
                            ].join("/") + (first && !complete ? `#${first}` : "")}">
										<u>${row[1] === "true" ? "Review" : "Resume"}</u>
									</a>
								</div>
							</div>`;
                        }
                        return data;
                    }
                },
                {
                    type: "date",
                    render: (data, type, row, meta)=>{
                        if (type === "display") return new Date(data).toLocaleString();
                        return data;
                    }
                },
                {
                    type: "html"
                },
                {
                    type: "num",
                    render: (data, type, row, meta)=>{
                        if (type === "display") return this.jQuery(element).DataTable().cell({
                            row: meta.row,
                            column: meta.col
                        }).node().dataset.formatted;
                        return data;
                    }
                },
                {
                    type: "num"
                },
                {
                    type: "num"
                },
                {
                    type: "num"
                },
                {
                    type: "num"
                },
                {
                    type: "num",
                    render: (d)=>d
                }
            ]
        });
    }
    values(table, index) {
        return this.jQuery.makeArray(table.column(index).cache("search").sort().unique());
    }
    search(table, index, value, regex) {
        table.column(index).search(value, regex).draw();
    }
    addFilterRow(table) {
        const filterRow = document.createElement("tr");
        filterRow.classList.add("collapse", "practice-filter");
        table.table(undefined).header().prepend(filterRow);
        [
            {
                render: (index, cell)=>{
                    cell.innerHTML = `<select class="form-control-sm">
						<option value="">View All</option>
						${this.values(table, index).map((value)=>`<option value="${value}">
								${value === "true" ? "Done" : "In Progress"}
							</option>`)}
					</select>`;
                    const select = cell.querySelector("select");
                    select.addEventListener("change", (e)=>{
                        this.search(table, index, e.target.value, false);
                    });
                }
            },
            {
                render: (index, cell)=>{
                    cell.innerHTML = `
						<input type="date" class="form-control-sm" name="from" />
						<div class="text-center">to</div>
						<input type="date" class="form-control-sm" name="to" />
					`;
                    const dates = this.values(table, index);
                    const from = cell.querySelector("input[name=from]");
                    const to = cell.querySelector("input[name=to]");
                    from.addEventListener("change", ()=>this.dateSearch(table, dates, from, to, index));
                    to.addEventListener("change", ()=>this.dateSearch(table, dates, from, to, index));
                }
            },
            {
                render: (index, cell)=>{
                    cell.innerHTML = `<select class="form-control-sm">
						<option value="">All Tests</optionv>
						${this.values(table, index).map((value)=>`<option value="${value}">${value}</option>`)}
					</select>`;
                    const select = cell.querySelector("select");
                    select.addEventListener("change", (e)=>this.search(table, index, e.target.value ? `^${e.target.value}$` : "", true));
                }
            },
            {},
            {},
            {},
            {},
            {},
            {}
        ].forEach((params, i)=>{
            const index = i + 1;
            const cell = document.createElement("td");
            cell.classList.add("align-bottom", "border-top-0");
            if ("render" in params) params.render(index, cell);
            filterRow.append(cell);
        });
        return filterRow;
    }
    dateSearch(table, dates, from, to, index) {
        const match = dates.filter((d)=>(!from.value || d >= from.value) && (!to.value || d <= to.value)).map((d)=>// Escape characters for regex
            d.replace(/[ +]/g, "."));
        this.search(table, index, "(" + (match.length > 0 ? match.join("|") : "n/a") + ")", true);
    }
    addToggle(filterRow) {
        const toggleCreate = document.createElement("temp");
        toggleCreate.innerHTML = `<button
			data-toggle="collapse"
			data-target=".practice-filter"
			title="Show Filters"
			class="btn btn-outline-secondary btn-sm"
		>
			<i class="fas fa-filter" />
		</button>`;
        const toggle = toggleCreate.querySelector("button");
        document.querySelector(".filter-toggle").append(toggle);
        this.jQuery(filterRow).on("hide.bs.collapse", ()=>toggle.title = "Show Filters");
        this.jQuery(filterRow).on("show.bs.collapse", ()=>toggle.title = "Hide Filters");
        return toggle;
    }
    constructor(jQuery, product){
        this.jQuery = jQuery;
        this.productIdSerializer = product;
    }
}


class $c08d305e44b10fb6$export$4a89174a73c83a4e {
    getReviewTotalScoreChart() {
        return new (0, $393886a4136ecb5a$export$2e2bcd8739ae039)(null, null, 100, 20, 0);
    }
    getReviewSectionScoreChart() {
        return new (0, $a517049a9fa09796$export$2e2bcd8739ae039)(null, null, 200, 36, 0, 120, 20, 5);
    }
    getOverviewScoreChart() {
        return new (0, $76654d8a9a88e74d$export$2e2bcd8739ae039)(null, null, 50, 50, 2);
    }
    getTestProgressChart() {
        return new (0, $36ae95b3cf151580$export$2e2bcd8739ae039)(null, 100, 20, 0);
    }
    getOverviewSummaryTable(jQuery) {
        return new (0, $9b4877c7931d8c2c$export$2e2bcd8739ae039)(jQuery, this.productIdSerializer);
    }
    constructor(product){
        this.productIdSerializer = product;
    }
}


class $441b99cf2460a579$export$d81743de5a701f8a {
}
class $441b99cf2460a579$export$a22f609f85658e94 extends $441b99cf2460a579$export$d81743de5a701f8a {
}
class $441b99cf2460a579$export$70f9c4f648908aba extends $441b99cf2460a579$export$d81743de5a701f8a {
}



class $f55fea245b5af805$export$9c5a59fea446b525 extends (0, $3b5206c0221e9546$export$297f7e0dec408b43) {
}
class $f55fea245b5af805$export$a3477e3552228f4a extends (0, $787cbb42a3de36ec$export$bd5b2ff202412f16) {
}
class $f55fea245b5af805$export$23f126f79715fc38 extends (0, $4d734273fd686967$export$c779ca608bc7e518) {
    getSwipeTarget() {
        return document.querySelectorAll("notanelement");
    }
}
class $f55fea245b5af805$export$358907161ca9df2f extends (0, $bdaf673a6608829b$export$86a3e6247396dc7d) {
}
class $f55fea245b5af805$export$83ddbdee60777543 extends (0, $6f042d9f175fbdb8$export$432093ad9c671135) {
}
class $f55fea245b5af805$export$272a6eb28dfc386a extends (0, $ef3ed923fbd5ed31$export$f1d3e53a76c30bcd) {
}
class $f55fea245b5af805$export$67979cf497d64f5f extends (0, $98104a4c5f72d3f1$export$52be8eb626f981c6) {
}
class $f55fea245b5af805$export$aeed581b40867c18 extends (0, $c08d305e44b10fb6$export$4a89174a73c83a4e) {
}




class $a0c9b220ddd06428$export$4873c9e45f1f022e extends (0, $1464aabbdbd5323e$export$5280b677eac0c76a) {
    listDataSource(item) {
        return new (0, $c8843a02291a36e7$export$8571e238509b9601)(item);
    }
    metadataDataSource() {
        return new (0, $c8843a02291a36e7$export$4f1e0ee9b7a3ff67)();
    }
    itemDataSource() {
        return new (0, $c8843a02291a36e7$export$d63adfee35a5f384)();
    }
    scoreDataSource(quiz) {
        return new (0, $c8843a02291a36e7$export$fdef18a6e7ebbbf9)(quiz);
    }
    settingsDataSource() {
        return new (0, $c8843a02291a36e7$export$63463c4bda1ea56a)();
    }
    globalStateDataSource(initializer) {
        return new (0, $c8843a02291a36e7$export$7b6b126472f9f21c)(initializer);
    }
    attemptStateDataSource(initializer) {
        return new (0, $c8843a02291a36e7$export$94d7ae0124faaa6d)(initializer);
    }
}
class $a0c9b220ddd06428$export$66384c79b2d2277f extends (0, $441b99cf2460a579$export$d81743de5a701f8a) {
    headerFrontend(item) {
        return new (0, $f55fea245b5af805$export$9c5a59fea446b525)(item);
    }
    listFrontend(item) {
        return new (0, $f55fea245b5af805$export$a3477e3552228f4a)(item);
    }
    itemFrontend(item) {
        return new (0, $f55fea245b5af805$export$23f126f79715fc38)(item);
    }
    scoreFrontend() {
        return new (0, $f55fea245b5af805$export$83ddbdee60777543)();
    }
    sectionFrontend(quiz, item) {
        return new (0, $f55fea245b5af805$export$272a6eb28dfc386a)(quiz, item);
    }
    settingsFrontend(item) {
        return new (0, $f55fea245b5af805$export$358907161ca9df2f)(item);
    }
    summaryFrontend(product) {
        return new (0, $f55fea245b5af805$export$67979cf497d64f5f)(product);
    }
    chartFrontend(product) {
        return new (0, $f55fea245b5af805$export$aeed581b40867c18)(product);
    }
}
class $a0c9b220ddd06428$export$2e2bcd8739ae039 {
    static constructOverviewApp(config) {
        return (0, $6fbfe6f14c8e4909$export$1e02a9be3c7e8753).constructOverview($a0c9b220ddd06428$export$2e2bcd8739ae039.datasource, $a0c9b220ddd06428$export$2e2bcd8739ae039.frontend, config);
    }
    static constructTestApp(config) {
        return (0, $6fbfe6f14c8e4909$export$1e02a9be3c7e8753).constructTest($a0c9b220ddd06428$export$2e2bcd8739ae039.datasource, $a0c9b220ddd06428$export$2e2bcd8739ae039.frontend, config);
    }
    static constructReviewApp(config) {
        return (0, $6fbfe6f14c8e4909$export$1e02a9be3c7e8753).constructReview($a0c9b220ddd06428$export$2e2bcd8739ae039.datasource, $a0c9b220ddd06428$export$2e2bcd8739ae039.frontend, config);
    }
}
$a0c9b220ddd06428$export$2e2bcd8739ae039.datasource = new $a0c9b220ddd06428$export$4873c9e45f1f022e();
$a0c9b220ddd06428$export$2e2bcd8739ae039.frontend = new $a0c9b220ddd06428$export$66384c79b2d2277f();







const $29935126ff466b6e$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $29935126ff466b6e$var$idbProxyableTypes;
let $29935126ff466b6e$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $29935126ff466b6e$var$getIdbProxyableTypes() {
    return $29935126ff466b6e$var$idbProxyableTypes || ($29935126ff466b6e$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $29935126ff466b6e$var$getCursorAdvanceMethods() {
    return $29935126ff466b6e$var$cursorAdvanceMethods || ($29935126ff466b6e$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $29935126ff466b6e$var$transactionDoneMap = new WeakMap();
const $29935126ff466b6e$var$transformCache = new WeakMap();
const $29935126ff466b6e$var$reverseTransformCache = new WeakMap();
function $29935126ff466b6e$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($29935126ff466b6e$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $29935126ff466b6e$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $29935126ff466b6e$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($29935126ff466b6e$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $29935126ff466b6e$var$transactionDoneMap.set(tx, done);
}
let $29935126ff466b6e$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $29935126ff466b6e$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $29935126ff466b6e$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $29935126ff466b6e$var$replaceTraps(callback) {
    $29935126ff466b6e$var$idbProxyTraps = callback($29935126ff466b6e$var$idbProxyTraps);
}
function $29935126ff466b6e$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($29935126ff466b6e$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($29935126ff466b6e$export$debb760848ca95a(this), args);
        return $29935126ff466b6e$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $29935126ff466b6e$export$4997ffc0176396a6(func.apply($29935126ff466b6e$export$debb760848ca95a(this), args));
    };
}
function $29935126ff466b6e$var$transformCachableValue(value) {
    if (typeof value === "function") return $29935126ff466b6e$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $29935126ff466b6e$var$cacheDonePromiseForTransaction(value);
    if ($29935126ff466b6e$var$instanceOfAny(value, $29935126ff466b6e$var$getIdbProxyableTypes())) return new Proxy(value, $29935126ff466b6e$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $29935126ff466b6e$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $29935126ff466b6e$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($29935126ff466b6e$var$transformCache.has(value)) return $29935126ff466b6e$var$transformCache.get(value);
    const newValue = $29935126ff466b6e$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $29935126ff466b6e$var$transformCache.set(value, newValue);
        $29935126ff466b6e$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $29935126ff466b6e$export$debb760848ca95a = (value)=>$29935126ff466b6e$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $29935126ff466b6e$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $29935126ff466b6e$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade($29935126ff466b6e$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $29935126ff466b6e$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $29935126ff466b6e$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $29935126ff466b6e$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $29935126ff466b6e$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $29935126ff466b6e$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $29935126ff466b6e$var$cachedMethods = new Map();
function $29935126ff466b6e$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($29935126ff466b6e$var$cachedMethods.get(prop)) return $29935126ff466b6e$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $29935126ff466b6e$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $29935126ff466b6e$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $29935126ff466b6e$var$cachedMethods.set(prop, method);
    return method;
}
$29935126ff466b6e$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$29935126ff466b6e$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$29935126ff466b6e$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $29935126ff466b6e$var$advanceMethodProps = [
    "continue",
    "continuePrimaryKey",
    "advance"
];
const $29935126ff466b6e$var$methodMap = {};
const $29935126ff466b6e$var$advanceResults = new WeakMap();
const $29935126ff466b6e$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $29935126ff466b6e$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$29935126ff466b6e$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $29935126ff466b6e$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $29935126ff466b6e$var$methodMap[prop] = function(...args) {
            $29935126ff466b6e$var$advanceResults.set(this, $29935126ff466b6e$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $29935126ff466b6e$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $29935126ff466b6e$var$cursorIteratorTraps);
    $29935126ff466b6e$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $29935126ff466b6e$var$reverseTransformCache.set(proxiedCursor, $29935126ff466b6e$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($29935126ff466b6e$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $29935126ff466b6e$var$advanceResults.delete(proxiedCursor);
    }
}
function $29935126ff466b6e$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $29935126ff466b6e$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === "iterate" && $29935126ff466b6e$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$29935126ff466b6e$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($29935126ff466b6e$var$isIteratorProp(target, prop)) return $29935126ff466b6e$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $29935126ff466b6e$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));


function $6d0ba700fa61861e$export$4be65e66cfa2648a() {
    const config = $6d0ba700fa61861e$export$44487a86467333c3();
    return document.cookie.split(";").map((cookie)=>cookie.split("=").map((part)=>part.trim())).map(([key, value])=>({
            key: key,
            value: value
        })).find((cookie)=>cookie.key == config.contentCookie)?.value;
}
function $6d0ba700fa61861e$export$1fc0f6205829e19c() {
    const pattern = /practicequestion\/(?<type>products|test|result)\/(?:v\/)?(?<sku>[-\w.~%!$&'()*+,;=:@]+)(?:\/(?<attempt>\d+))?/;
    const url = new URL(window.location.href);
    const result = pattern.exec(url.pathname);
    return result ? result.groups["type"] : undefined;
}
function $6d0ba700fa61861e$export$bc923b2c79b1b36c() {
    const pattern = /practicequestion\/(?<type>products|test|result)\/(?:v\/)?(?<sku>[-\w.~%!$&'()*+,;=:@]+)(?:\/(?<attempt>\d+))?/;
    const url = new URL(window.location.href);
    const result = pattern.exec(url.pathname);
    return result ? result.groups["sku"] : undefined;
}
function $6d0ba700fa61861e$export$ea67fb1abcd4d264() {
    const pattern = /practicequestion\/(?<type>products|test|result)\/(?:v\/)?(?<sku>[-\w.~%!$&'()*+,;=:@]+)(?:\/(?<attempt>\d+))?/;
    const url = new URL(window.location.href);
    const result = pattern.exec(url.pathname);
    if (result) {
        const value = parseInt(result.groups["attempt"]);
        if (!Number.isNaN(value)) return value;
    }
    return undefined;
}
function $6d0ba700fa61861e$export$44487a86467333c3() {
    // @ts-ignore
    return AppConfig;
}
function $6d0ba700fa61861e$export$ec17b125bc42c229() {
    // @ts-ignore
    return testId;
}
function $6d0ba700fa61861e$export$42409dceaad0b3() {
    return document.querySelector("ol > li > h3")?.textContent ?? "Practice Test";
}
function $6d0ba700fa61861e$export$4e7c2edc266bb521() {
    // @ts-ignore
    return started ? new Date(started) : new Date();
}
function $6d0ba700fa61861e$export$4661b290ab44c400() {
    // @ts-ignore
    return attempts;
}


class $d884bee41e3be132$export$c13294241c7a27ae {
    async getDb() {
        return await $29935126ff466b6e$export$ca0ed41b1a2af7e("elibraryMist", 1, {
            upgrade (db) {
                db.createObjectStore($d884bee41e3be132$export$c13294241c7a27ae.global);
                db.createObjectStore($d884bee41e3be132$export$c13294241c7a27ae.attempt);
            }
        });
    }
    async write(store, id, callback) {
        const db = await this.getDb();
        if (!(store in $d884bee41e3be132$export$c13294241c7a27ae.locks)) $d884bee41e3be132$export$c13294241c7a27ae.locks[store] = Promise.resolve(true);
        return $d884bee41e3be132$export$c13294241c7a27ae.locks[store] = $d884bee41e3be132$export$c13294241c7a27ae.locks[store].then(async ()=>{
            const transaction = db.transaction(store, "readwrite");
            await callback(transaction);
            await transaction.done;
            return true;
        });
    }
    getGlobalKey() {
        return (0, $6d0ba700fa61861e$export$4be65e66cfa2648a)();
    }
    getAttemptKey(product, attempt, cookie) {
        return `${product ?? (0, $6d0ba700fa61861e$export$bc923b2c79b1b36c)()}.${attempt ?? (0, $6d0ba700fa61861e$export$ea67fb1abcd4d264)()}.${cookie ?? (0, $6d0ba700fa61861e$export$4be65e66cfa2648a)()}`;
    }
}
$d884bee41e3be132$export$c13294241c7a27ae.global = "globalState";
$d884bee41e3be132$export$c13294241c7a27ae.attempt = "attemptState";
$d884bee41e3be132$export$c13294241c7a27ae.locks = {};




class $d8515eaaa7eb63a7$export$f4bb5053b2f6d6d9 extends (0, $c8843a02291a36e7$export$d63adfee35a5f384) {
    getItem(product, question, randomize) {
        return super.getItem(product, question, randomize);
    }
    async setUserData(product, attempt, question, data) {
        const db = await this.local.getDb();
        // TODO: Figure out how to mark questions correct as they are answered. Data is in lib/content
        await this.local.write((0, $d884bee41e3be132$export$c13294241c7a27ae).attempt, question, async (transaction)=>{
            const state = await transaction.store.get(this.local.getAttemptKey());
            const newState = (0, $434124d31c68176b$export$6969335ea1e4e77c)({
                ...state,
                userData: state?.userData ?? {}
            }, {
                userData: {
                    [question]: data
                }
            });
            await transaction.store.put(newState, this.local.getAttemptKey());
            return true;
        });
        return {
            id: question,
            attempt_id: (0, $6d0ba700fa61861e$export$ea67fb1abcd4d264)(),
            item_id: question,
            name: question,
            answer: data.answer.toString(),
            correct: false
        };
    }
    setPing(product, attempt, mode, times) {
        return Promise.resolve();
    //return super.setPing(product, attempt, mode, times);
    }
    // @ts-ignore
    async setFinished(product, attempt, total_time) {
        const db = await this.local.getDb();
        const state = await db.get((0, $d884bee41e3be132$export$c13294241c7a27ae).attempt, this.local.getAttemptKey());
        const answers = Array.from(document.querySelectorAll(".item-list .item")).reduce((result, element)=>({
                ...result,
                ...state.userData[element.dataset.id].answer ? {
                    [element.dataset.id]: {
                        answer: state.userData[element.dataset.id].answer,
                        correct: state.userData[element.dataset.id].status == "correct"
                    }
                } : {}
            }), {});
        const response = await fetch(`/practicequestion/finish/${product}/${attempt}`, {
            method: "POST",
            redirect: "manual",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                total_time: total_time,
                answers: answers
            })
        });
        const result = await response.json();
        return result.result;
    }
    constructor(){
        super();
        this.local = new (0, $d884bee41e3be132$export$c13294241c7a27ae)();
    }
}




class $59ad65f0bf1ff879$export$c152fea7f6de6e6c extends (0, $c8843a02291a36e7$export$8571e238509b9601) {
    async getItemList() {
        const db = await this.local.getDb();
        const state = await db.get((0, $d884bee41e3be132$export$c13294241c7a27ae).attempt, this.local.getAttemptKey());
        const items = Array.from(document.querySelectorAll(".item-list .item")).map((element)=>this.makeListItem(element.dataset)).map((item)=>({
                ...item,
                ...state?.userData && item.id in state.userData ? state.userData[item.id] : {}
            }));
        return items;
    }
    constructor(item){
        super(item);
        this.local = new (0, $d884bee41e3be132$export$c13294241c7a27ae)();
    }
}





class $e0f3b9579c57d0b8$export$2e6f42a48c174608 extends (0, $c8843a02291a36e7$export$4f1e0ee9b7a3ff67) {
    setIncomplete(product, attempt) {
        return fetch(`/practicequestion/incomplete/${product}/${attempt}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        }).then((response)=>response.json()).then((content)=>content.result);
    }
    getTestUrl() {
        const reviewUrl = new URL(window.location.href);
        reviewUrl.pathname = reviewUrl.pathname.replace("result", "test");
        reviewUrl.hash = document.querySelector('.item-list .item[data-status="unanswered"]')?.dataset?.id;
        return Promise.resolve(reviewUrl.toString());
    }
    async revertToLocalCookie() {
        const db = await new (0, $d884bee41e3be132$export$c13294241c7a27ae)().getDb();
        const config = (0, $6d0ba700fa61861e$export$44487a86467333c3)();
        const cookie = (0, $6d0ba700fa61861e$export$4be65e66cfa2648a)();
        const keys = await db.getAllKeys((0, $d884bee41e3be132$export$c13294241c7a27ae).global);
        if (keys.some((key)=>key == cookie) || keys.length <= 0) return;
        const replacement = keys[0].toString();
        if ("cookieStore" in window) // @ts-ignore
        await window.cookieStore.set({
            name: config.contentCookie,
            value: replacement,
            path: "/"
        });
        else document.cookie = `${config.contentCookie}=${replacement};path=/`;
        window.location.reload();
        return;
    }
}





class $06ac5489544f5d64$export$ff6d34349e78ccc2 extends (0, $c8843a02291a36e7$export$fdef18a6e7ebbbf9) {
    async restoreAttempts() {
        const db = await this.local.getDb();
        const attempts = (0, $6d0ba700fa61861e$export$4661b290ab44c400)();
        const product = (0, $6d0ba700fa61861e$export$bc923b2c79b1b36c)();
        const cookie = (0, $6d0ba700fa61861e$export$4be65e66cfa2648a)();
        const keys = await db.getAllKeys((0, $d884bee41e3be132$export$c13294241c7a27ae).attempt, IDBKeyRange.bound(`${product}.0000000000`, `${product}.9999999999`));
        await this.local.write((0, $d884bee41e3be132$export$c13294241c7a27ae).attempt, `restore${Date.now()}`, async (transaction)=>{
            await Promise.all(attempts.map((attempt)=>{
                const key = this.local.getAttemptKey(product, attempt.id, cookie);
                if (keys.findIndex((k)=>k == key) >= 0) return Promise.resolve();
                return transaction.store.put({
                    version: 2,
                    timestamp: new Date().toISOString(),
                    times: {},
                    filters: [],
                    cookie: cookie,
                    productId: product,
                    testId: `${attempt.set_id.join(",")}-${attempt.test_id}`,
                    attemptId: attempt.id,
                    testName: attempt.name,
                    mode: attempt.complete ? "result" : "test",
                    started: new Date(attempt.started),
                    userData: Object.entries(attempt.answers ?? {}).reduce((result, [key, answer])=>({
                            ...result,
                            [key]: {
                                answer: answer.answer,
                                status: answer.correct ? "correct" : "incorrect"
                            }
                        }), {})
                }, key);
            }));
            return true;
        });
    }
    async getAttempts() {
        const db = await this.local.getDb();
        const product = (0, $6d0ba700fa61861e$export$bc923b2c79b1b36c)();
        const records = await db.getAll((0, $d884bee41e3be132$export$c13294241c7a27ae).attempt, IDBKeyRange.bound(`${product}.0000000000`, `${product}.9999999999`));
        const cookie = (0, $6d0ba700fa61861e$export$4be65e66cfa2648a)();
        return records.filter((r)=>r.cookie == cookie).map((record)=>{
            const time = Object.values(record.times).reduce((result, time)=>result + time, 0);
            const complete = record.mode == "result";
            const stats = {
                correct: complete ? 0 : undefined,
                incorrect: complete ? 0 : undefined,
                unanswered: 0,
                total: 0,
                percent: 0,
                first: undefined
            };
            for (const [key, item] of Object.entries(record.userData)){
                stats.total++;
                stats.unanswered += !item.status || item.status == "unanswered" ? 1 : 0;
                if (!stats.first && (!item.status || item.status == "unanswered")) stats.first = key;
                if (complete) {
                    stats.correct += item.status == "correct" ? 1 : 0;
                    stats.incorrect += item.status == "incorrect" ? 1 : 0;
                    stats.percent = stats.correct / stats.total;
                }
            }
            return {
                id: record.attemptId,
                date: record.started,
                test: record.testName,
                complete: complete,
                time: time,
                timeFormatted: new Date(time).toLocaleTimeString(navigator.language ?? navigator.languages[0], time > 3600000 ? {
                    hour: "numeric",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZone: "utc",
                    hour12: false
                } : {
                    minute: "numeric",
                    second: "2-digit",
                    timeZone: "utc",
                    hour12: false
                }),
                ...stats
            };
        });
    }
    async getOverviewScores() {
        const db = await this.local.getDb();
        const product = (0, $6d0ba700fa61861e$export$bc923b2c79b1b36c)();
        const records = await db.getAll((0, $d884bee41e3be132$export$c13294241c7a27ae).attempt, IDBKeyRange.bound(`${product}.0000000000`, `${product}.9999999999`));
        const scores = {};
        for (const record of records){
            if (record.mode != "result") continue;
            const answered_count = Object.values(record.userData).filter((item)=>item.status != "unanswered").length;
            const correct_count = Object.values(record.userData).filter((item)=>item.status == "correct").length;
            const total_count = Object.values(record.userData).length;
            if (!(record.testId in scores) || correct_count / (total_count || 1) > scores[record.testId].correct_count / (scores[record.testId].total_count || 1)) scores[record.testId] = {
                id: record.attemptId,
                answered_count: answered_count,
                correct_count: correct_count,
                total_count: total_count
            };
        }
        return scores;
    }
    async getTableScores() {
        const db = await this.local.getDb();
        const state = await db.get((0, $d884bee41e3be132$export$c13294241c7a27ae).attempt, this.local.getAttemptKey());
        const items = Array.from(document.querySelectorAll(".item-list .item")).map((item)=>item.dataset);
        const config = (0, $6d0ba700fa61861e$export$44487a86467333c3)();
        const unlocked = !config.hasEmail ? items.slice(0, config.freeQuestions) : items;
        const sections = unlocked.reduce((result, item)=>({
                ...result,
                [item.section_id]: {
                    section: config.hasEmail ? item.section : "Unlocked",
                    time: (result[item.section_id]?.time ?? 0) + (state.times[item.id] ?? 0),
                    correct: (result[item.section_id]?.correct ?? 0) + (state.userData[item.id]?.status == "correct" ? 1 : 0),
                    incorrect: (result[item.section_id]?.incorrect ?? 0) + (state.userData[item.id]?.status == "incorrect" ? 1 : 0),
                    unanswered: (result[item.section_id]?.unanswered ?? 0) + (![
                        "correct",
                        "incorrect"
                    ].includes(state.userData[item.id]?.status) ? 1 : 0),
                    total: (result[item.section_id]?.total ?? 0) + 1,
                    percent: ((result[item.section_id]?.correct ?? 0) + (state.userData[item.id]?.status == "correct" ? 1 : 0)) / ((result[item.section_id]?.total ?? 0) + 1)
                }
            }), {});
        if (!config.hasEmail) sections["locked"] = {
            section: "Locked",
            time: "0",
            correct: 0,
            incorrect: 0,
            unanswered: items.length - config.freeQuestions,
            total: items.length - config.freeQuestions,
            percent: 0
        };
        return Object.values(sections).map((section)=>({
                ...section,
                number: section.time,
                time: new Date(section.time).toLocaleTimeString(undefined, parseInt(section.time) > 3600000 ? {
                    hour: "numeric",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZone: "utc",
                    hour12: false
                } : {
                    minute: "numeric",
                    second: "2-digit",
                    timeZone: "utc",
                    hour12: false
                })
            }));
    }
    async getTotalScores() {
        const db = await this.local.getDb();
        const state = await db.get((0, $d884bee41e3be132$export$c13294241c7a27ae).attempt, this.local.getAttemptKey());
        const config = (0, $6d0ba700fa61861e$export$44487a86467333c3)();
        const items = Array.from(document.querySelectorAll(".item-list .item")).map((item)=>item.dataset).filter((item, index)=>config.hasEmail || index < config.freeQuestions);
        const total = items.reduce((result, item)=>({
                section: "total",
                time: (result?.time ?? 0) + (state.times[item.id] ?? 0),
                correct: (result?.correct ?? 0) + (state.userData[item.id]?.status == "correct" ? 1 : 0),
                incorrect: (result?.incorrect ?? 0) + (state.userData[item.id]?.status == "incorrect" ? 1 : 0),
                unanswered: (result?.unanswered ?? 0) + (![
                    "correct",
                    "incorrect"
                ].includes(state.userData[item.id]?.status) ? 1 : 0),
                total: (result?.total ?? 0) + 1,
                percent: ((result?.correct ?? 0) + (state.userData[item.id]?.status == "correct" ? 1 : 0)) / ((result?.total ?? 0) + 1)
            }), {});
        return {
            ...total,
            time: new Date(total.time).toLocaleTimeString(undefined, total.time > 3600000 ? {
                hour: "numeric",
                minute: "2-digit",
                second: "2-digit",
                timeZone: "utc",
                hour12: false
            } : {
                minute: "numeric",
                second: "2-digit",
                timeZone: "utc",
                hour12: false
            })
        };
    }
    constructor(item){
        super(item);
        this.local = new (0, $d884bee41e3be132$export$c13294241c7a27ae)();
    }
}



class $2cccd3dca35372ad$export$1229e8dc8f1f5aa2 extends (0, $c8843a02291a36e7$export$63463c4bda1ea56a) {
    setEmail(product, email) {
        return fetch(`/practicequestion/email/${product}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email
            })
        }).then((response)=>response.json()).then((content)=>content.unlocked);
    }
    async checkEmail(product, email) {
        const response = await fetch(`/practicequestion/unlock/${product}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email
            })
        });
        const content = await response.json();
        return content.unlocked;
    }
}




class $0b9812bf9d5317a4$export$392935a129755b73 extends (0, $434124d31c68176b$export$2df7f0b5c09577ab) {
    async getState() {
        const db = await this.local.getDb();
        return await db.get(this.getStoreName(), this.getStateKey());
    }
    async setState(state) {
        const db = await this.local.getDb();
        await this.local.write(this.getStoreName(), `set${Date.now()}`, async (transaction)=>{
            transaction.store.put(state, this.getStateKey());
            return true;
        });
    }
    async updateState(state) {
        await this.local.write(this.getStoreName(), `update${Date.now()}`, async (transaction)=>{
            const current = await transaction.store.get(this.getStateKey());
            const newState = (0, $434124d31c68176b$export$6969335ea1e4e77c)(current, state);
            await transaction.store.put(newState, this.getStateKey());
            return true;
        });
    }
    constructor(initializer){
        super(initializer);
        this.local = new (0, $d884bee41e3be132$export$c13294241c7a27ae)();
    }
}
class $0b9812bf9d5317a4$export$201cba85c9c771ee extends $0b9812bf9d5317a4$export$392935a129755b73 {
    getStoreName() {
        return (0, $d884bee41e3be132$export$c13294241c7a27ae).global;
    }
    getStateKey() {
        return this.local.getGlobalKey();
    }
}
class $0b9812bf9d5317a4$export$82ecf18d012ab57b extends $0b9812bf9d5317a4$export$392935a129755b73 {
    getStoreName() {
        return (0, $d884bee41e3be132$export$c13294241c7a27ae).attempt;
    }
    getStateKey() {
        return this.local.getAttemptKey();
    }
}




class $610a0fdd53bb43c3$export$1083b15cbe071e84 extends (0, $64a84e97a08b3b3f$export$c71c6275427547ae) {
    getInitialState(cache) {
        return {
            ...super.getInitialState(cache),
            userData: cache?.userData ?? {},
            cookie: (0, $6d0ba700fa61861e$export$4be65e66cfa2648a)(),
            testId: (0, $6d0ba700fa61861e$export$ec17b125bc42c229)(),
            testName: (0, $6d0ba700fa61861e$export$42409dceaad0b3)(),
            productId: (0, $6d0ba700fa61861e$export$bc923b2c79b1b36c)(),
            attemptId: (0, $6d0ba700fa61861e$export$ea67fb1abcd4d264)(),
            mode: (0, $6d0ba700fa61861e$export$1fc0f6205829e19c)(),
            started: (0, $6d0ba700fa61861e$export$4e7c2edc266bb521)()
        };
    }
    getInitialTimes(cache) {
        return cache?.times ?? {};
    }
}


class $4a0dde927eab9818$export$a8f4da67ea307958 extends (0, $a0c9b220ddd06428$export$4873c9e45f1f022e) {
    listDataSource(item) {
        return new (0, $59ad65f0bf1ff879$export$c152fea7f6de6e6c)(item);
    }
    metadataDataSource() {
        return new (0, $e0f3b9579c57d0b8$export$2e6f42a48c174608)();
    }
    itemDataSource() {
        return new (0, $d8515eaaa7eb63a7$export$f4bb5053b2f6d6d9)();
    }
    scoreDataSource(quiz) {
        return new (0, $06ac5489544f5d64$export$ff6d34349e78ccc2)(quiz);
    }
    settingsDataSource() {
        return new (0, $2cccd3dca35372ad$export$1229e8dc8f1f5aa2)();
    }
    globalStateDataSource(initializer) {
        return new (0, $0b9812bf9d5317a4$export$201cba85c9c771ee)(initializer);
    }
    attemptStateDataSource(initializer) {
        return new (0, $0b9812bf9d5317a4$export$82ecf18d012ab57b)(initializer);
    }
    attemptStateInitializer() {
        return new (0, $610a0fdd53bb43c3$export$1083b15cbe071e84)();
    }
}






class $734fe8d205d5c0a8$export$513b1a86b705f1e7 extends (0, $65fd8e9c390e16cf$export$3247fa725e92f7aa) {
}
class $734fe8d205d5c0a8$export$a37e60efb2948042 extends (0, $65fd8e9c390e16cf$export$1e241e1a557fe85f) {
    setEmail(product, email) {
        return this.datasource.setEmail(product, email);
    }
    checkEmail(product, email) {
        return this.datasource.checkEmail(product, email);
    }
}
class $734fe8d205d5c0a8$export$189c417670cd25df extends (0, $65fd8e9c390e16cf$export$43deca918d12a831) {
}
class $734fe8d205d5c0a8$export$5be859bd4953550e extends (0, $65fd8e9c390e16cf$export$43deca918d12a831) {
}
class $734fe8d205d5c0a8$export$75ac32e898285be extends (0, $23ef5a606ebfeae9$export$8f32e90ddca8b9a1) {
}
class $734fe8d205d5c0a8$export$3b6c2018e59bdca7 extends (0, $23ef5a606ebfeae9$export$f23c5d9ea3ade0cf) {
    setIncomplete(product, attempt) {
        return this.datasource.setIncomplete(product, attempt);
    }
    getTestUrl() {
        return this.datasource.getTestUrl();
    }
    revertToLocalCookie() {
        return this.datasource.revertToLocalCookie();
    }
}
class $734fe8d205d5c0a8$export$323d4c73621fbce8 extends (0, $c9cb9b4370d94384$export$5528a70bc0755d5d) {
    // @ts-ignore
    setFinished(product, attempt, total_time) {
        return this.datasource.setFinished(product, attempt, total_time);
    }
}
class $734fe8d205d5c0a8$export$72b2dbb12e4f66a5 extends (0, $c9cb9b4370d94384$export$a0007e43b5a1bad3) {
    setIncomplete(product, attempt) {
        return this.datasource.setIncomplete(product, attempt);
    }
    getTestUrl() {
        return this.datasource.getTestUrl();
    }
    revertToLocalCookie() {
        return this.datasource.revertToLocalCookie();
    }
}
class $734fe8d205d5c0a8$export$cb26533f91386d57 extends (0, $f4437f1565542c94$export$ad4c18518f7b40ba) {
    setIncomplete(product, attempt) {
        return this.datasource.setIncomplete(product, attempt);
    }
    getTestUrl() {
        return this.datasource.getTestUrl();
    }
    revertToLocalCookie() {
        return this.datasource.revertToLocalCookie();
    }
}
class $734fe8d205d5c0a8$export$ca1b2c9eeadaff10 extends (0, $f4437f1565542c94$export$6e5c9d23f15a050d) {
    getAttempts() {
        return this.datasource.getAttempts();
    }
    restoreAttempts() {
        return this.datasource.restoreAttempts();
    }
}









class $1f21bf59bc2e8120$export$9f2c149a4bc24a09 extends (0, $7da36b87c3d781bf$export$2e2bcd8739ae039) {
}
class $1f21bf59bc2e8120$export$3ef34106d05f14d5 extends (0, $5eb91562a72e7d98$export$36e5777a1ba4b7c3) {
}
class $1f21bf59bc2e8120$export$7f67701eef20f852 extends (0, $5910a18df0888d73$export$a8921d56ff297fe8) {
}
class $1f21bf59bc2e8120$export$524f8d5a8144e515 extends (0, $fd94f3d84008c02d$export$3e1dbb683a4d88c6) {
}
class $1f21bf59bc2e8120$export$33d2b7a058f81f68 extends (0, $2599da8a0112b4f5$export$90d6e7d0a021328f) {
}
class $1f21bf59bc2e8120$export$6036f27d7407fce2 extends (0, $101491ae16521a44$export$408de2e5b2acd098) {
}
class $1f21bf59bc2e8120$export$b83071b9125e902b extends (0, $9fc514620fc133ee$export$49ca3e4dd873795e) {
}
class $1f21bf59bc2e8120$export$da7dc6b6095f269f extends (0, $9fc514620fc133ee$export$49ca3e4dd873795e) {
}
var $1f21bf59bc2e8120$export$2e2bcd8739ae039 = $1f21bf59bc2e8120$export$9f2c149a4bc24a09;









class $29ef8a11df957974$export$6783a8e950c9830c extends (0, $d0a8d7b98af9bc77$export$fb7d762431c8b738) {
    displayLockedQuestions(freeQuestions, locked, baseColor) {
        return this.frontend.displayLockedQuestions(freeQuestions, locked, baseColor);
    }
    displayQuestionResult(item, status, time) {
        return this.frontend.displayQuestionResult(item, status, time);
    }
}
class $29ef8a11df957974$export$530917017b5538f1 extends (0, $d0a8d7b98af9bc77$export$f937810bd0e7b396) {
    getBindSaveEmail() {
        return this.frontend.getBindSaveEmail();
    }
    getBindPartialResults() {
        return this.frontend.getBindPartialResults();
    }
    getBindRetryEmail() {
        return this.frontend.getBindRetryEmail();
    }
    getBindCheckEmail() {
        return this.frontend.getBindCheckEmail();
    }
    updateReportEmail(email) {
        return this.frontend.updateReportEmail(email);
    }
    displayEmailModal(jQuery, count) {
        return this.frontend.displayEmailModal(jQuery, count);
    }
    hideEmailModal(jQuery) {
        return this.frontend.hideEmailModal(jQuery);
    }
    displayDoubleOptInModal(jQuery, email) {
        return this.frontend.displayDoubleOptInModal(jQuery, email);
    }
    displayDoubleOptInRetry() {
        return this.frontend.displayDoubleOptInRetry();
    }
    displayDoubleOptInUnlock() {
        return this.frontend.displayDoubleOptInUnlock();
    }
    hideDoubleOptInModal(jQuery) {
        return this.frontend.hideDoubleOptInModal(jQuery);
    }
}
class $29ef8a11df957974$export$7ee5445f4db3118b extends (0, $4c4cd8cc9be28930$export$3d57bb984caea565) {
    getOverviewSummaryTable(jQuery) {
        return this.frontend.getOverviewSummaryTable(jQuery);
    }
}
class $29ef8a11df957974$export$8231ef415c6cccfb extends (0, $4c4cd8cc9be28930$export$4816f478639a3147) {
    displayHighScores(scores) {
        return this.frontend.displayHighScores(scores);
    }
}
class $29ef8a11df957974$export$dd0d475ddb1639a1 extends (0, $f8619edde51811ce$export$df8f44f0b3a8b5a4) {
    displayTest(url) {
        return this.frontend.displayTest(url);
    }
}
class $29ef8a11df957974$export$a16e9ffcd2480c1c extends (0, $f8619edde51811ce$export$d8df626f347bc16) {
    displayTotalTime(time) {
        this.frontend.displayTotalTime(time);
    }
}
class $29ef8a11df957974$export$14381305c7e09158 extends (0, $f8619edde51811ce$export$d1d3d31ef366b4f4) {
    displayReviewScoreTable(scores, total) {
        return this.frontend.displayReviewScoreTable(scores, total);
    }
}
class $29ef8a11df957974$export$df47ae508551a1ee extends (0, $05c6ae7be4e66a65$export$2413a969a84c33cb) {
    displayTest(url) {
        return this.frontend.displayTest(url);
    }
}








var $09e1eb705a635d06$export$2e2bcd8739ae039 = $f988e9e393868e1c$export$2e2bcd8739ae039;




class $4a57e96ac360722d$export$af6d014038e2701c extends (0, $f988e9e393868e1c$export$bce690a38ac79874) {
    constructor(viewProps, bindTarget){
        super(viewProps);
        this.bindTarget = bindTarget;
    }
}
class $4a57e96ac360722d$export$2a1c75b23f0cb5e6 extends (0, $9764fa64f8e41b70$export$ad29949578474ab2) {
}
class $4a57e96ac360722d$export$925aaff03f92adcd extends (0, $ba7ece8b7e297340$export$7e965828e2884d) {
}
class $4a57e96ac360722d$export$ab67ea8f294f990f extends (0, $438ea9632a36718a$export$84d0dd190d551cd1) {
}
class $4a57e96ac360722d$export$ba9f35f986dd307a extends (0, $d97321baad67d913$export$b5fd6146180b74ff) {
}
class $4a57e96ac360722d$export$24ff75506e2f6ae5 extends (0, $3035e28da4cb4cd7$export$cffe4c650c020bcc) {
}
class $4a57e96ac360722d$export$eda75efd11280250 extends (0, $0cd70bb5c18f46c5$export$7d05e0deed78c249) {
}
var $4a57e96ac360722d$export$2e2bcd8739ae039 = $4a57e96ac360722d$export$af6d014038e2701c;




class $3c237bc8bd3226d6$export$c85113c9ba9db03f extends (0, $6fbfe6f14c8e4909$export$1e02a9be3c7e8753) {
    serialize(indices) {
        const state = super.serialize(indices);
        const { userData: userData, ...attemptDefaults } = this.model.state.attempt.datasource.initializer.getInitialState(state.attempt, this.config.timer);
        return {
            ...state,
            attempt: {
                ...state.attempt,
                userData: Object.entries(this.userdata.userdata).reduce((result, [index, annotation])=>({
                        ...result,
                        [indices[index]]: annotation
                    }), {}),
                ...attemptDefaults
            }
        };
    }
    static constructOverview(datasource, frontend, config, serializer, controllers, extra_controllers, libs) {
        serializer ??= new (0, $1464aabbdbd5323e$export$2c32508fceb0b7d7)();
        const productSerializer = serializer.productSerializer();
        const quizSerializer = serializer.quizSerializer();
        const itemSerializer = serializer.itemSerializer();
        const pq_app = super.constructOverview(datasource, frontend, config, serializer, controllers, extra_controllers, libs);
        pq_app.model = new (0, $1f21bf59bc2e8120$export$2e2bcd8739ae039)({
            ...pq_app.model,
            metadata: new (0, $734fe8d205d5c0a8$export$cb26533f91386d57)(datasource.metadataDataSource()),
            score: new (0, $734fe8d205d5c0a8$export$ca1b2c9eeadaff10)(datasource.scoreDataSource(serializer.quizSerializer()))
        });
        pq_app.view = new (0, $4a57e96ac360722d$export$af6d014038e2701c)({
            ...pq_app.view,
            chart: new (0, $29ef8a11df957974$export$7ee5445f4db3118b)(frontend.chartFrontend(productSerializer)),
            list: new (0, $29ef8a11df957974$export$6783a8e950c9830c)(frontend.listFrontend(serializer.itemSerializer())),
            settings: new (0, $29ef8a11df957974$export$530917017b5538f1)(frontend.settingsFrontend(serializer.itemSerializer())),
            sections: new (0, $29ef8a11df957974$export$8231ef415c6cccfb)(frontend.sectionFrontend(quizSerializer, itemSerializer))
        }, pq_app.view.bindTarget);
        return pq_app;
    }
    static constructTest(datasource, frontend, config, serializer, controllers, extra_controllers, libs) {
        serializer ??= new (0, $1464aabbdbd5323e$export$2c32508fceb0b7d7)();
        const itemSerializer = serializer.itemSerializer();
        const pq_app = super.constructTest(datasource, frontend, config, serializer, controllers, extra_controllers, libs);
        pq_app.model = new (0, $1f21bf59bc2e8120$export$2e2bcd8739ae039)({
            ...pq_app.model,
            metadata: new (0, $734fe8d205d5c0a8$export$72b2dbb12e4f66a5)(datasource.metadataDataSource()),
            list: new (0, $734fe8d205d5c0a8$export$513b1a86b705f1e7)(datasource.listDataSource(itemSerializer)),
            item: new (0, $734fe8d205d5c0a8$export$323d4c73621fbce8)(datasource.itemDataSource()),
            settings: new (0, $734fe8d205d5c0a8$export$a37e60efb2948042)(datasource.settingsDataSource()),
            state: {
                global: new (0, $734fe8d205d5c0a8$export$5be859bd4953550e)(datasource.globalStateDataSource(datasource.globalStateInitializer() ?? new (0, $64a84e97a08b3b3f$export$eac5cc7c756f6526)())),
                attempt: new (0, $734fe8d205d5c0a8$export$189c417670cd25df)(datasource.attemptStateDataSource(datasource.attemptStateInitializer() ?? new (0, $610a0fdd53bb43c3$export$1083b15cbe071e84)()))
            }
        });
        pq_app.view = new (0, $4a57e96ac360722d$export$af6d014038e2701c)({
            ...pq_app.view,
            list: new (0, $29ef8a11df957974$export$6783a8e950c9830c)(frontend.listFrontend(itemSerializer)),
            item: new (0, $29ef8a11df957974$export$df47ae508551a1ee)(frontend.itemFrontend(itemSerializer)),
            settings: new (0, $29ef8a11df957974$export$530917017b5538f1)(frontend.settingsFrontend(itemSerializer))
        }, pq_app.view.bindTarget);
        return pq_app;
    }
    static constructReview(datasource, frontend, config, serializer, controllers, extra_controllers, libs) {
        serializer ??= new (0, $1464aabbdbd5323e$export$2c32508fceb0b7d7)();
        const itemSerializer = serializer.itemSerializer();
        const pq_app = super.constructReview(datasource, frontend, config, serializer, controllers, extra_controllers, libs);
        pq_app.model = new (0, $1f21bf59bc2e8120$export$2e2bcd8739ae039)({
            ...pq_app.model,
            metadata: new (0, $734fe8d205d5c0a8$export$3b6c2018e59bdca7)(datasource.metadataDataSource()),
            list: new (0, $734fe8d205d5c0a8$export$513b1a86b705f1e7)(datasource.listDataSource(itemSerializer)),
            item: new (0, $734fe8d205d5c0a8$export$75ac32e898285be)(datasource.itemDataSource()),
            settings: new (0, $734fe8d205d5c0a8$export$a37e60efb2948042)(datasource.settingsDataSource()),
            state: {
                global: new (0, $734fe8d205d5c0a8$export$5be859bd4953550e)(datasource.globalStateDataSource(datasource.globalStateInitializer() ?? new (0, $64a84e97a08b3b3f$export$eac5cc7c756f6526)())),
                // @ts-ignore
                attempt: new (0, $734fe8d205d5c0a8$export$189c417670cd25df)(datasource.attemptStateDataSource(datasource.attemptStateInitializer() ?? new (0, $610a0fdd53bb43c3$export$1083b15cbe071e84)()))
            }
        });
        pq_app.view = new (0, $4a57e96ac360722d$export$af6d014038e2701c)({
            ...pq_app.view,
            header: new (0, $29ef8a11df957974$export$a16e9ffcd2480c1c)(frontend.headerFrontend(itemSerializer)),
            item: new (0, $29ef8a11df957974$export$dd0d475ddb1639a1)(frontend.itemFrontend(itemSerializer)),
            list: new (0, $29ef8a11df957974$export$6783a8e950c9830c)(frontend.listFrontend(itemSerializer)),
            scores: new (0, $29ef8a11df957974$export$14381305c7e09158)(frontend.scoreFrontend()),
            settings: new (0, $29ef8a11df957974$export$530917017b5538f1)(frontend.settingsFrontend(itemSerializer))
        }, pq_app.view.bindTarget);
        return pq_app;
    }
}






class $17921a7fbffdbf4e$export$96678a2cc37e23a7 extends (0, $9b4877c7931d8c2c$export$2e2bcd8739ae039) {
    getTable(element) {
        return this.jQuery(element).DataTable();
    }
    populate(table, rows) {
        table.clear();
        table.rows.add(rows.map((row)=>[
                row.id.toString(),
                row.complete.toString(),
                row.date.toISOString(),
                row.test,
                row.time.toString(),
                row.correct !== undefined ? row.correct.toString() : "",
                row.incorrect !== undefined ? row.incorrect.toString() : "",
                row.unanswered.toString(),
                row.total.toString(),
                row.percent ? `${Math.round(row.percent * 10000) / 100}%` : "",
                row.timeFormatted,
                row.first ?? ""
            ]));
        const header = table.table().header();
        table.columns.adjust().draw();
        const filters = header.querySelector("tr.practice-filter");
        filters.remove();
        this.addFilterRow(table);
    }
    table(element, product) {
        return this.jQuery(element).DataTable({
            dom: "<'row'<'col-sm-12 col-md-6 filter-toggle'><'col-sm-12 col-md-6 d-flex flex-row justify-content-end'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
            responsive: true,
            order: [
                [
                    2,
                    "desc"
                ]
            ],
            columns: [
                {
                    visible: false,
                    type: "num"
                },
                {
                    render: (data, type, row, meta)=>{
                        if (type === "display") {
                            const complete = row[1] === "true";
                            const first = row[11];
                            // const first = (this.jQuery(element).DataTable()
                            // 	.cell({row: meta.row, column: meta.col})
                            // 	.node() as HTMLElement)
                            // 	.dataset.first;
                            const content = `<div class="d-flex flex-row justify-content-center">
								<div style="width: 4.5em;">
									<input type="checkbox"
										${data === "true" ? "checked" : ""}
										onclick="return false;"
										style="filter: hue-rotate(270deg);"
									/>
									<a class="small ml-1" href="${[
                                "/practicequestion",
                                complete ? "result" : "test",
                                this.productIdSerializer.toString(product),
                                row[0]
                            ].join("/") + (first && !complete ? `#${first}` : "")}">
										<u>${row[1] === "true" ? "Review" : "Resume"}</u>
									</a>
								</div>
							</div>`;
                            return content;
                        }
                        return data;
                    }
                },
                {
                    type: "date",
                    render: (data, type, row, meta)=>{
                        if (type === "display") return new Date(data).toLocaleString();
                        return data;
                    }
                },
                {
                    type: "html"
                },
                {
                    type: "num",
                    render: (data, type, row, meta)=>{
                        if (type === "display") return row[10];
                        return data;
                    }
                },
                {
                    type: "num"
                },
                {
                    type: "num"
                },
                {
                    type: "num"
                },
                {
                    type: "num"
                },
                {
                    type: "num",
                    render: (d)=>d
                },
                {
                    type: "string"
                },
                {
                    type: "string"
                }
            ]
        });
    }
}


class $aecfd20d1cc501cb$export$ce59d0eabc43c929 extends (0, $f55fea245b5af805$export$aeed581b40867c18) {
    getOverviewSummaryTable(jQuery) {
        return new (0, $17921a7fbffdbf4e$export$96678a2cc37e23a7)(jQuery, this.productIdSerializer);
    }
}



class $74c981901e301f1f$export$176a4e21573065ee extends (0, $f55fea245b5af805$export$23f126f79715fc38) {
    displayTest(url) {
        const parsed = new URL(url, window.location.origin);
        window.location.href = parsed.toString();
    }
}



class $690ace91f05e8f72$export$9d8f9d1fec29a0ed extends (0, $f55fea245b5af805$export$a3477e3552228f4a) {
    displayLockedQuestions(freeQuestions, locked, baseColor) {
        const itemList = Array.from(document.querySelectorAll(".item-list .item"));
        itemList.slice(freeQuestions).forEach((item)=>{
            item.style.background = locked ? "rgb(0, 50, 100, 0.5)" : baseColor;
        });
    }
    displayQuestionResult(item, status, time) {
        const element = document.querySelector(`.item-list .item[data-id="${CSS.escape(this.itemIdSerializer.toString(item))}"]`);
        element.title = element.title.replace(/Time: \d+:\d+/, `Time: ${new Date(time).toLocaleTimeString(undefined, time > 3600000 ? {
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            timeZone: "utc",
            hour12: false
        } : {
            minute: "numeric",
            second: "2-digit",
            timeZone: "utc",
            hour12: false
        })}`);
        const icon = element.querySelector("i.answer-status");
        icon.classList.remove("fas", "fa-check", "fa-times", "d-none");
        if (status === "correct") {
            icon.classList.add("fas", "fa-check");
            element.style.backgroundColor = "#28a745";
            element.style.color = "#d4edda";
        } else if (status === "incorrect") {
            icon.classList.add("fas", "fa-times");
            element.style.backgroundColor = "#dc3545";
            element.style.color = "#f8d7da";
        } else if (status === "unanswered") {
            icon.classList.add("d-none");
            element.style.backgroundColor = "#17a2b8";
            element.style.color = "#d1ecf1";
        }
    }
}



class $f71bfa28f8957887$export$240766deb3481470 extends (0, $f55fea245b5af805$export$83ddbdee60777543) {
    displayReviewScoreTable(scores, total) {
        const table = document.querySelector("table.scores");
        const rows = Array.from(table.querySelectorAll("tbody tr"));
        if (rows.length < scores.length) for(let i = 0; i < scores.length - rows.length; i++){
            const newRow = rows[0].cloneNode(true);
            rows[rows.length - 1].after(newRow);
            rows.push(newRow);
        }
        scores.forEach((section, index)=>{
            const row = rows[index];
            row.cells[0].textContent = section.section;
            row.cells[1].textContent = section.time;
            row.cells[2].textContent = section.correct.toString();
            row.cells[3].textContent = section.incorrect.toString();
            row.cells[4].textContent = section.unanswered.toString();
            row.cells[5].textContent = section.total.toString();
            row.cells[6].textContent = `${(section.percent * 100).toFixed(2)}%`;
        });
        const footer = table.querySelector("tfoot tr");
        footer.cells[1].textContent = total.time;
        footer.cells[2].textContent = total.correct.toString();
        footer.cells[3].textContent = total.incorrect.toString();
        footer.cells[4].textContent = total.unanswered.toString();
        footer.cells[5].textContent = total.total.toString();
        footer.cells[6].textContent = `${(total.percent * 100).toFixed(2)}%`;
    }
}




class $30f2322d65d1d89f$export$2a9e3b5f5a584b66 extends (0, $f55fea245b5af805$export$272a6eb28dfc386a) {
    displayHighScores(scores) {
        const quizzes = Array.from(document.querySelectorAll(".test-score[data-quiz]"));
        for (const quiz of quizzes){
            const score = scores.find((score)=>this.quizIdSerializer.toString(score.quiz) == quiz.dataset.quiz);
            const complete = quiz.querySelector("a.complete");
            const notComplete = quiz.querySelector(".not-complete");
            if (score) {
                const scoreDisplay = quiz.querySelector(".test-score");
                complete.href = `/practicequestion/result/${(0, $6d0ba700fa61861e$export$bc923b2c79b1b36c)()}/${score.data.id}`;
                scoreDisplay.innerHTML = `${score.data.correct_count} / ${score.data.total_count}`;
                complete.classList.toggle("d-none", false);
                complete.classList.toggle("d-flex", true);
                notComplete.classList.toggle("d-none", true);
            } else {
                complete.classList.toggle("d-none", true);
                complete.classList.toggle("d-flex", false);
                notComplete.classList.toggle("d-none", false);
            }
        }
        for (const score of scores){
            const testScore = document.querySelector(`.test-score[data-quiz="${this.quizIdSerializer.toString(score.quiz)}"] .test-score`);
            if (testScore) testScore.innerText = `${score.data.correct_count} / ${score.data.total_count}`;
        }
    }
}





class $ef465d6bcf465fb7$export$14efbce61eaa6ef4 extends CustomEvent {
    constructor(){
        super($ef465d6bcf465fb7$export$14efbce61eaa6ef4.type);
    }
}
$ef465d6bcf465fb7$export$14efbce61eaa6ef4.type = "mist.academy.promptemail";
class $ef465d6bcf465fb7$export$81fd8c372c6c6681 extends CustomEvent {
    constructor(form){
        super($ef465d6bcf465fb7$export$81fd8c372c6c6681.type, {
            detail: form
        });
    }
}
$ef465d6bcf465fb7$export$81fd8c372c6c6681.type = "mist.academy.saveemail";
class $ef465d6bcf465fb7$export$836c4cbef731cb67 extends CustomEvent {
    constructor(form){
        super($ef465d6bcf465fb7$export$836c4cbef731cb67.type, {
            detail: form
        });
    }
}
$ef465d6bcf465fb7$export$836c4cbef731cb67.type = "mist.academy.resendemail";
class $ef465d6bcf465fb7$export$18021afda4f1db8f extends CustomEvent {
    constructor(form){
        super($ef465d6bcf465fb7$export$18021afda4f1db8f.type, {
            detail: form
        });
    }
}
$ef465d6bcf465fb7$export$18021afda4f1db8f.type = "mist.academy.checkemail";


class $b0b667b7024f3985$export$bfc1fe5b5bbfd0bd extends (0, $f55fea245b5af805$export$358907161ca9df2f) {
    getBindSaveEmail() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".collect-email form"), "submit", (element)=>new (0, $ef465d6bcf465fb7$export$81fd8c372c6c6681)(element), true);
    }
    getBindPartialResults() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".collect-email .results"), "click", (element)=>new (0, $7923788bad7460a0$export$2dd9981939617ffa)(), true);
    }
    getBindRetryEmail() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".double-opt-in-notice form"), "submit", (element)=>new (0, $ef465d6bcf465fb7$export$836c4cbef731cb67)(element), true);
    }
    getBindCheckEmail() {
        return new (0, $4afb854d5a7f4d82$export$3b5445cacfccd6cf)(document.querySelectorAll(".double-opt-in-notice .unlock"), "click", (element)=>new (0, $ef465d6bcf465fb7$export$18021afda4f1db8f)(element.closest("form.double-opt-in")), true);
    }
    updateReportEmail(email) {
        const report = document.querySelector(".modal-dialog form.report");
        report.elements["email"].value = email;
    }
    displayEmailModal(jQuery, count) {
        const modal = document.querySelector(".collect-email");
        modal.querySelectorAll(".question-count").forEach((label)=>{
            label.textContent = `${count}`;
        });
        jQuery(modal).modal("show");
    }
    hideEmailModal(jQuery) {
        const modal = document.querySelector(".collect-email");
        jQuery(modal).modal("hide");
    }
    displayDoubleOptInModal(jQuery, email) {
        const doubleOptIn = document.querySelector(".modal-dialog form.double-opt-in");
        doubleOptIn.elements["email"].value = email;
        jQuery(".double-opt-in-notice").modal("show");
    }
    displayDoubleOptInRetry() {
        const retry = document.querySelector(".modal-dialog .retry-message");
        const unlock = document.querySelector(".modal-dialog .unlock-message");
        retry.classList.toggle("d-none", false);
        retry.classList.toggle("text-muted", false);
        unlock.classList.toggle("d-none", true);
        setTimeout(()=>{
            retry.classList.add("text-muted");
        }, 100);
    }
    displayDoubleOptInUnlock() {
        const retry = document.querySelector(".modal-dialog .retry-message");
        const unlock = document.querySelector(".modal-dialog .unlock-message");
        unlock.classList.toggle("d-none", false);
        unlock.classList.toggle("text-muted", false);
        retry.classList.toggle("d-none", true);
        setTimeout(()=>{
            unlock.classList.add("text-muted");
        }, 100);
    }
    hideDoubleOptInModal(jQuery) {
        jQuery(".double-opt-in-notice").modal("hide");
    }
    displayErrorModal(jQuery, url, item, filters, screenshot, errors, localStorage) {
        const explanation = document.querySelector(".report-error .explanation");
        explanation.classList.remove("show");
        switch(item.type){
            case "multiplechoice":
                explanation.innerHTML = item.multiplechoice.explanation;
                break;
            case "multiplecorrect":
                explanation.innerHTML = item.multiplecorrect.explanation;
                break;
            case "numeric":
                explanation.innerHTML = item.numeric.explanation;
                break;
            case "cloze":
                explanation.innerHTML = item.cloze.explanation;
                break;
            case "unknown":
            default:
                explanation.innerHTML = "Error: Unable to load explanation";
                break;
        }
        window.MathJax.typesetPromise().then(()=>{
            super.displayErrorModal(jQuery, url, item, filters, screenshot, errors, localStorage);
        });
    }
}


class $1526029269962be5$export$1de448726d519c91 extends (0, $a0c9b220ddd06428$export$66384c79b2d2277f) {
    listFrontend(item) {
        return new (0, $690ace91f05e8f72$export$9d8f9d1fec29a0ed)(item);
    }
    itemFrontend(item) {
        return new (0, $74c981901e301f1f$export$176a4e21573065ee)(item);
    }
    scoreFrontend() {
        return new (0, $f71bfa28f8957887$export$240766deb3481470)();
    }
    sectionFrontend(quiz, item) {
        return new (0, $30f2322d65d1d89f$export$2a9e3b5f5a584b66)(quiz, item);
    }
    settingsFrontend(item) {
        return new (0, $b0b667b7024f3985$export$bfc1fe5b5bbfd0bd)(item);
    }
    chartFrontend(product) {
        return new (0, $aecfd20d1cc501cb$export$ce59d0eabc43c929)(product);
    }
}




class $8da735eaf28ee314$export$308f1fc0e74d6ae5 extends (0, $71dcbf4eb844fc85$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $ef465d6bcf465fb7$export$14efbce61eaa6ef4).type, ()=>this.promptEmail(app));
        target.addEventListener((0, $ef465d6bcf465fb7$export$81fd8c372c6c6681).type, (e)=>this.saveEmail(app, e));
        target.addEventListener((0, $ef465d6bcf465fb7$export$836c4cbef731cb67).type, (e)=>this.resendEmail(app, e));
        target.addEventListener((0, $ef465d6bcf465fb7$export$18021afda4f1db8f).type, (e)=>this.checkEmail(app, e));
    }
    async promptEmail(app) {
        const list = await app.model.list.getItemList();
        const unlockCount = list.length - app.config.freeQuestions;
        app.view.settings.displayEmailModal(app.getJquery(), unlockCount);
    }
    async saveEmail(app, event) {
        event.preventDefault();
        const [attempt, product] = await Promise.all([
            app.model.metadata.getAttempt(),
            app.model.metadata.getProductId()
        ]);
        const email = event.detail.elements["email"].value;
        app.config.hasEmail = await app.model.settings.setEmail(product, email);
        if (app.config.hasEmail) await this.unlock(app, product, attempt, email);
        else {
            app.view.settings.hideEmailModal(app.getJquery());
            app.view.settings.displayDoubleOptInModal(app.getJquery(), email);
        }
        return false;
    }
    async resendEmail(app, event) {
        await this.saveEmail(app, event);
        app.view.settings.displayDoubleOptInRetry();
        return false;
    }
    async checkEmail(app, event) {
        event.preventDefault();
        const [attempt, product] = await Promise.all([
            await app.model.metadata.getAttempt(),
            await app.model.metadata.getProductId()
        ]);
        const email = event.detail.elements["email"].value;
        app.config.hasEmail = await app.model.settings.checkEmail(product, email);
        if (app.config.hasEmail) await this.unlock(app, product, attempt, email);
        else app.view.settings.displayDoubleOptInUnlock();
    }
    async unlock(app, product, attempt, email) {
        if (this.review) {
            await app.model.metadata.setIncomplete(product, attempt);
            const testUrl = await app.model.metadata.getTestUrl();
            app.view.item.displayTest(testUrl);
        } else {
            app.view.list.displayLockedQuestions(app.config.freeQuestions, !app.config.hasEmail, app.config.review ? "rgb(23, 162, 184)" : `rgb(${app.config.color}, 0.5)`);
            app.view.settings.updateReportEmail(email);
            app.view.settings.hideEmailModal(app.getJquery());
            app.view.settings.hideDoubleOptInModal(app.getJquery());
        }
    }
    constructor(review){
        super();
        this.review = false;
        this.review = review;
    }
}




class $04d13c77c75288cb$export$71a1be2b328386f9 extends (0, $71dcbf4eb844fc85$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$49a1ecce8d203).type, ()=>this.initialize(app));
    }
    initialize(app) {
        const bindTarget = app.view.getBindTarget();
        [
            app.view.settings.getBindSaveEmail(),
            app.view.settings.getBindRetryEmail(),
            app.view.settings.getBindPartialResults(),
            app.view.settings.getBindCheckEmail()
        ].map((bind)=>bind.bind(bindTarget));
        if (typeof app.config.freeQuestions == "number") app.view.list.displayLockedQuestions(app.config.freeQuestions, !app.config.hasEmail, app.config.color);
    }
}



class $40f3565d01dd64b1$export$77580565d3ff4cbb extends (0, $04637eb48d465816$export$77cd77b88309b1c9) {
    async init(app) {
        app.view.init(app);
        await app.model.metadata.revertToLocalCookie();
        await app.model.score.restoreAttempts();
        const [product, scores, attempts] = await Promise.all([
            app.model.metadata.getProductId(),
            app.model.score.getOverviewScores(),
            app.model.score.getAttempts()
        ]);
        const summary = app.view.chart.getOverviewSummaryTable(app.getJquery());
        app.view.summary.displayTable(summary, product);
        summary.populate(summary.getTable(app.view.summary.frontend.getTable()), attempts);
        app.view.sections.displayOverviewScores(app.view.chart.getOverviewScoreChart(), scores);
        app.view.sections.displayHighScores(scores);
    }
}




class $1eb607fce263f7a8$export$91bdca39ca9a95b7 extends (0, $71dcbf4eb844fc85$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$49a1ecce8d203).type, ()=>this.initialize(app));
    }
    async initialize(app) {
        const listModel = app.model.list;
        const list = await listModel.getItemList();
        const indices = await app.model.list.getItemIndexMap();
        const times = app.timer.serializeTimes(indices);
        for (const item of list)if (item.answer) app.view.list.displayQuestionResult(item.id, item.status, times[item.id]);
        const [scores, total] = await Promise.all([
            app.model.score.getReviewScores(),
            app.model.score.getTotalScores()
        ]);
        app.view.scores.displayReviewScoreTable(scores, total);
    }
}




class $6c5ea64a53f7b285$export$fb0e2bdfb5996585 extends (0, $71dcbf4eb844fc85$export$2e2bcd8739ae039) {
    bind(target, app) {
        target.addEventListener((0, $7923788bad7460a0$export$49a1ecce8d203).type, ()=>this.initialize(app));
    }
    async initialize(app) {
        app.model.list.getItemList().then((list)=>{
            for (const item of list)if (item.answer) app.view.list.displaySelectedAnswer(item.id, item.answer, undefined);
        });
    }
}




class $01753c71d857c973$export$1a1d58c8841abf19 extends (0, $9b189da8a270b36a$export$b16fba08cef0c11b) {
    switch(app, previous, next) {
        if (!app.config.hasEmail && typeof app.config.freeQuestions == "number" && next >= app.config.freeQuestions) {
            app.current.set(previous);
            app.view.getBindTarget().dispatchEvent(new (0, $ef465d6bcf465fb7$export$14efbce61eaa6ef4)());
            return super.switch(app, previous, previous);
        } else return super.switch(app, previous, next);
    }
}



/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */ 
var $9db7cd4309d5c0db$export$c2f8e0cc249a8d8f = {
    // minimum relative difference between two compared values,
    // used by all comparison functions
    relTol: 1e-12,
    // minimum absolute difference between two compared values,
    // used by all comparison functions
    absTol: 1e-15,
    // type of default matrix output. Choose 'matrix' (default) or 'array'
    matrix: "Matrix",
    // type of default number output. Choose 'number' (default) 'BigNumber', 'bigint', or 'Fraction'
    number: "number",
    // type of fallback used for config { number: 'bigint' } when a value cannot be represented
    // in the configured numeric type. Choose 'number' (default) or 'BigNumber'.
    numberFallback: "number",
    // number of significant digits in BigNumbers
    precision: 64,
    // predictable output type of functions. When true, output type depends only
    // on the input types. When false (default), output type can vary depending
    // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
    // predictable is false, and returns `NaN` when true.
    predictable: false,
    // random seed for seeded pseudo random number generation
    // null = randomly seed
    randomSeed: null
};


// type checks for all known types
//
// note that:
//
// - check by duck-typing on a property like `isUnit`, instead of checking instanceof.
//   instanceof cannot be used because that would not allow to pass data from
//   one instance of math.js to another since each has it's own instance of Unit.
// - check the `isUnit` property via the constructor, so there will be no
//   matches for "fake" instances like plain objects with a property `isUnit`.
//   That is important for security reasons.
// - It must not be possible to override the type checks used internally,
//   for security reasons, so these functions are not exposed in the expression
//   parser.
function $23cfe017d190638f$export$7e4aa119212bc614(x) {
    return typeof x === "number";
}
function $23cfe017d190638f$export$e51d0e7e5c4a03ab(x) {
    if (!x || typeof x !== "object" || typeof x.constructor !== "function") return false;
    if (x.isBigNumber === true && typeof x.constructor.prototype === "object" && x.constructor.prototype.isBigNumber === true) return true;
    if (typeof x.constructor.isDecimal === "function" && x.constructor.isDecimal(x) === true) return true;
    return false;
}
function $23cfe017d190638f$export$c4c1bdb0d1c7cfc7(x) {
    return typeof x === "bigint";
}
function $23cfe017d190638f$export$8849a896711efe0c(x) {
    return x && typeof x === "object" && Object.getPrototypeOf(x).isComplex === true || false;
}
function $23cfe017d190638f$export$e312cb8a8e5e7c34(x) {
    return x && typeof x === "object" && Object.getPrototypeOf(x).isFraction === true || false;
}
function $23cfe017d190638f$export$8960dc335987b8da(x) {
    return x && x.constructor.prototype.isUnit === true || false;
}
function $23cfe017d190638f$export$844ec244b1367d54(x) {
    return typeof x === "string";
}
var $23cfe017d190638f$export$43bee75e5e14138e = Array.isArray;
function $23cfe017d190638f$export$b22160e0a14f87b7(x) {
    return x && x.constructor.prototype.isMatrix === true || false;
}
function $23cfe017d190638f$export$cea7aa84e978eba5(x) {
    return Array.isArray(x) || $23cfe017d190638f$export$b22160e0a14f87b7(x);
}
function $23cfe017d190638f$export$eb44495df7ba11d(x) {
    return x && x.isDenseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $23cfe017d190638f$export$d508368d4da3c38a(x) {
    return x && x.isSparseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $23cfe017d190638f$export$e331ccfa6f694c99(x) {
    return x && x.constructor.prototype.isRange === true || false;
}
function $23cfe017d190638f$export$ba3dc792055c2f45(x) {
    return x && x.constructor.prototype.isIndex === true || false;
}
function $23cfe017d190638f$export$f9ce7b637dfbe238(x) {
    return typeof x === "boolean";
}
function $23cfe017d190638f$export$381a1a20e6a63376(x) {
    return x && x.constructor.prototype.isResultSet === true || false;
}
function $23cfe017d190638f$export$e5dec9a75b602d6c(x) {
    return x && x.constructor.prototype.isHelp === true || false;
}
function $23cfe017d190638f$export$f6e2535fb5126e54(x) {
    return typeof x === "function";
}
function $23cfe017d190638f$export$871608497c498473(x) {
    return x instanceof Date;
}
function $23cfe017d190638f$export$49841c62b9eff15(x) {
    return x instanceof RegExp;
}
function $23cfe017d190638f$export$a6cdc56e425d0d0a(x) {
    return !!(x && typeof x === "object" && x.constructor === Object && !$23cfe017d190638f$export$8849a896711efe0c(x) && !$23cfe017d190638f$export$e312cb8a8e5e7c34(x));
}
function $23cfe017d190638f$export$630801d484da15df(x) {
    return x === null;
}
function $23cfe017d190638f$export$fce6876652108ab(x) {
    return x === undefined;
}
function $23cfe017d190638f$export$f88fb19d6b9ee5cb(x) {
    return x && x.isAccessorNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$440fa93dcf2757a3(x) {
    return x && x.isArrayNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$64d7d515ec030d5e(x) {
    return x && x.isAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$1665e2275a3d717a(x) {
    return x && x.isBlockNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$e1babefe78c70737(x) {
    return x && x.isConditionalNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$fa9d80731fd8c54b(x) {
    return x && x.isConstantNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$e6caeb7474dbdff3(node) {
    return $23cfe017d190638f$export$fa9d80731fd8c54b(node) || $23cfe017d190638f$export$7e624cbaab6cce94(node) && node.args.length === 1 && $23cfe017d190638f$export$fa9d80731fd8c54b(node.args[0]) && "-+~".includes(node.op);
}
function $23cfe017d190638f$export$27c05cfffd263d30(x) {
    return x && x.isFunctionAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$6ae03b16e064e6c4(x) {
    return x && x.isFunctionNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$ff90979121a6cabc(x) {
    return x && x.isIndexNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$8ee0fc9ee280b4ee(x) {
    return x && x.isNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$3f18867a334658e9(x) {
    return x && x.isObjectNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$7e624cbaab6cce94(x) {
    return x && x.isOperatorNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$c55e3736c5721220(x) {
    return x && x.isParenthesisNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$92729c5c4ff6fc83(x) {
    return x && x.isRangeNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$51bc4e372ab35935(x) {
    return x && x.isRelationalNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$87815d550facaed9(x) {
    return x && x.isSymbolNode === true && x.constructor.prototype.isNode === true || false;
}
function $23cfe017d190638f$export$dc36953d0b3a4f05(x) {
    return x && x.constructor.prototype.isChain === true || false;
}
function $23cfe017d190638f$export$f5bbd400c2f4426f(x) {
    var t = typeof x;
    if (t === "object") {
        if (x === null) return "null";
        if ($23cfe017d190638f$export$e51d0e7e5c4a03ab(x)) return "BigNumber"; // Special: weird mashup with Decimal
        if (x.constructor && x.constructor.name) return x.constructor.name;
        return "Object"; // just in case
    }
    return t; // can be 'string', 'number', 'boolean', 'function', 'bigint', ...
}


function $46a94b3d1146edd8$export$9cd59f9826255e47(x) {
    var type = typeof x;
    // immutable primitive types
    if (type === "number" || type === "bigint" || type === "string" || type === "boolean" || x === null || x === undefined) return x;
    // use clone function of the object when available
    if (typeof x.clone === "function") return x.clone();
    // array
    if (Array.isArray(x)) return x.map(function(value) {
        return $46a94b3d1146edd8$export$9cd59f9826255e47(value);
    });
    if (x instanceof Date) return new Date(x.valueOf());
    if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(x)) return x; // bignumbers are immutable
    // object
    if ((0, $23cfe017d190638f$export$a6cdc56e425d0d0a)(x)) return $46a94b3d1146edd8$export$d6051a0f7a227332(x, $46a94b3d1146edd8$export$9cd59f9826255e47);
    throw new TypeError("Cannot clone: unknown type of value (value: ".concat(x, ")"));
}
function $46a94b3d1146edd8$export$d6051a0f7a227332(object, callback) {
    var clone = {};
    for(var key in object)if ($46a94b3d1146edd8$export$5a15a386532a5ea4(object, key)) clone[key] = callback(object[key]);
    return clone;
}
function $46a94b3d1146edd8$export$8b58be045bf06082(a, b) {
    for(var prop in b)if ($46a94b3d1146edd8$export$5a15a386532a5ea4(b, prop)) a[prop] = b[prop];
    return a;
}
function $46a94b3d1146edd8$export$54e9fb29908872fa(a, b) {
    // TODO: add support for Arrays to deepExtend
    if (Array.isArray(b)) throw new TypeError("Arrays are not supported by deepExtend");
    for(var prop in b)// We check against prop not being in Object.prototype or Function.prototype
    // to prevent polluting for example Object.__proto__.
    if ($46a94b3d1146edd8$export$5a15a386532a5ea4(b, prop) && !(prop in Object.prototype) && !(prop in Function.prototype)) {
        if (b[prop] && b[prop].constructor === Object) {
            if (a[prop] === undefined) a[prop] = {};
            if (a[prop] && a[prop].constructor === Object) $46a94b3d1146edd8$export$54e9fb29908872fa(a[prop], b[prop]);
            else a[prop] = b[prop];
        } else if (Array.isArray(b[prop])) throw new TypeError("Arrays are not supported by deepExtend");
        else a[prop] = b[prop];
    }
    return a;
}
function $46a94b3d1146edd8$export$6cc798251952180(a, b) {
    var prop, i, len;
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0, len = a.length; i < len; i++){
            if (!$46a94b3d1146edd8$export$6cc798251952180(a[i], b[i])) return false;
        }
        return true;
    } else if (typeof a === "function") return a === b;
    else if (a instanceof Object) {
        if (Array.isArray(b) || !(b instanceof Object)) return false;
        for(prop in a){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in b) || !$46a94b3d1146edd8$export$6cc798251952180(a[prop], b[prop])) return false;
        }
        for(prop in b){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in a)) return false;
        }
        return true;
    } else return a === b;
}
function $46a94b3d1146edd8$export$519b2d75cc54d03b(nestedObject) {
    var flattenedObject = {};
    $46a94b3d1146edd8$var$_deepFlatten(nestedObject, flattenedObject);
    return flattenedObject;
}
// helper function used by deepFlatten
function $46a94b3d1146edd8$var$_deepFlatten(nestedObject, flattenedObject) {
    for(var prop in nestedObject)if ($46a94b3d1146edd8$export$5a15a386532a5ea4(nestedObject, prop)) {
        var value = nestedObject[prop];
        if (typeof value === "object" && value !== null) $46a94b3d1146edd8$var$_deepFlatten(value, flattenedObject);
        else flattenedObject[prop] = value;
    }
}
function $46a94b3d1146edd8$export$a73e197d57374bd3() {
    // test needed for broken IE8 implementation
    try {
        if (Object.defineProperty) {
            Object.defineProperty({}, "x", {
                get: function get() {
                    return null;
                }
            });
            return true;
        }
    } catch (e) {}
    return false;
}
function $46a94b3d1146edd8$export$488013bae63b21da(object, prop, valueResolver) {
    var _uninitialized = true;
    var _value;
    Object.defineProperty(object, prop, {
        get: function get() {
            if (_uninitialized) {
                _value = valueResolver();
                _uninitialized = false;
            }
            return _value;
        },
        set: function set(value) {
            _value = value;
            _uninitialized = false;
        },
        configurable: true,
        enumerable: true
    });
}
function $46a94b3d1146edd8$export$df3f009e3d155b20(object, path) {
    if (path && typeof path === "string") return $46a94b3d1146edd8$export$df3f009e3d155b20(object, path.split("."));
    var obj = object;
    if (path) for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (!(key in obj)) obj[key] = {};
        obj = obj[key];
    }
    return obj;
}
function $46a94b3d1146edd8$export$5a15a386532a5ea4(object, property) {
    return object && Object.hasOwnProperty.call(object, property);
}
function $46a94b3d1146edd8$export$1bc2c269dfa97885(object) {
    return object && typeof object.factory === "function";
}
function $46a94b3d1146edd8$export$3988ae62b71be9a3(object, path) {
    if (typeof path === "string") {
        if ($46a94b3d1146edd8$var$isPath(path)) return $46a94b3d1146edd8$export$3988ae62b71be9a3(object, path.split("."));
        else return object[path];
    }
    var child = object;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        child = child ? child[key] : undefined;
    }
    return child;
}
function $46a94b3d1146edd8$export$adaa4cf7ef1b65be(object, path, value) {
    if (typeof path === "string") {
        if ($46a94b3d1146edd8$var$isPath(path)) return $46a94b3d1146edd8$export$adaa4cf7ef1b65be(object, path.split("."), value);
        else {
            object[path] = value;
            return object;
        }
    }
    var child = object;
    for(var i = 0; i < path.length - 1; i++){
        var key = path[i];
        if (child[key] === undefined) child[key] = {};
        child = child[key];
    }
    if (path.length > 0) {
        var lastKey = path[path.length - 1];
        child[lastKey] = value;
    }
    return object;
}
function $46a94b3d1146edd8$export$357523c63a2253b9(object, properties, transform) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = $46a94b3d1146edd8$export$3988ae62b71be9a3(object, key);
        if (value !== undefined) $46a94b3d1146edd8$export$adaa4cf7ef1b65be(copy, key, transform ? transform(value, key) : value);
    }
    return copy;
}
function $46a94b3d1146edd8$export$8cea971c64639ea7(object, properties) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = object[key];
        if (value !== undefined) copy[key] = value;
    }
    return copy;
}
// helper function to test whether a string contains a path like 'user.name'
function $46a94b3d1146edd8$var$isPath(str) {
    return str.includes(".");
}



var $3f4182c2cc14bc92$export$517ab898194ae9af = [
    "Matrix",
    "Array"
]; // valid values for option matrix
var $3f4182c2cc14bc92$export$f4b0a2084fdf2177 = [
    "number",
    "BigNumber",
    "Fraction"
]; // valid values for option number
function $3f4182c2cc14bc92$export$3984aa6f7f77f1ae(config, emit) {
    /**
   * Set configuration options for math.js, and get current options.
   * Will emit a 'config' event, with arguments (curr, prev, changes).
   *
   * This function is only available on a mathjs instance created using `create`.
   *
   * Syntax:
   *
   *     math.config(config: Object): Object
   *
   * Examples:
   *
   *
   *     import { create, all } from 'mathjs'
   *
   *     // create a mathjs instance
   *     const math = create(all)
   *
   *     math.config().number                // outputs 'number'
   *     math.evaluate('0.4')                // outputs number 0.4
   *     math.config({number: 'Fraction'})
   *     math.evaluate('0.4')                // outputs Fraction 2/5
   *
   * @param {Object} [options] Available options:
   *                            {number} relTol
   *                              Minimum relative difference between two
   *                              compared values, used by all comparison functions.
   *                            {number} absTol
   *                              Minimum absolute difference between two
   *                              compared values, used by all comparison functions.
   *                            {string} matrix
   *                              A string 'Matrix' (default) or 'Array'.
   *                            {string} number
   *                              A string 'number' (default), 'BigNumber', 'bigint', or 'Fraction'
   *                            {number} precision
   *                              The number of significant digits for BigNumbers.
   *                              Not applicable for Numbers.
   *                            {string} parenthesis
   *                              How to display parentheses in LaTeX and string
   *                              output.
   *                            {string} randomSeed
   *                              Random seed for seeded pseudo random number generator.
   *                              Set to null to randomly seed.
   * @return {Object} Returns the current configuration
   */ function _config(options) {
        if (options) {
            if (options.epsilon !== undefined) {
                // this if is only for backwards compatibility, it can be removed in the future.
                console.warn('Warning: The configuration option "epsilon" is deprecated. Use "relTol" and "absTol" instead.');
                var optionsFix = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(options);
                optionsFix.relTol = options.epsilon;
                optionsFix.absTol = options.epsilon * 1e-3;
                delete optionsFix.epsilon;
                return _config(optionsFix);
            }
            var prev = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(config);
            // validate some of the options
            $3f4182c2cc14bc92$var$validateOption(options, "matrix", $3f4182c2cc14bc92$export$517ab898194ae9af);
            $3f4182c2cc14bc92$var$validateOption(options, "number", $3f4182c2cc14bc92$export$f4b0a2084fdf2177);
            // merge options
            (0, $46a94b3d1146edd8$export$54e9fb29908872fa)(config, options);
            var curr = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(config);
            var changes = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(options);
            // emit 'config' event
            emit("config", curr, prev, changes);
            return curr;
        } else return (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(config);
    }
    // attach the valid options to the function so they can be extended
    _config.MATRIX_OPTIONS = $3f4182c2cc14bc92$export$517ab898194ae9af;
    _config.NUMBER_OPTIONS = $3f4182c2cc14bc92$export$f4b0a2084fdf2177;
    // attach the config properties as readonly properties to the config function
    Object.keys((0, $9db7cd4309d5c0db$export$c2f8e0cc249a8d8f)).forEach((key)=>{
        Object.defineProperty(_config, key, {
            get: ()=>config[key],
            enumerable: true,
            configurable: true
        });
    });
    return _config;
}
/**
 * Validate an option
 * @param {Object} options         Object with options
 * @param {string} name            Name of the option to validate
 * @param {Array.<string>} values  Array with valid values for this option
 */ function $3f4182c2cc14bc92$var$validateOption(options, name, values) {
    if (options[name] !== undefined && !values.includes(options[name])) // unknown value
    console.warn('Warning: Unknown value "' + options[name] + '" for configuration option "' + name + '". ' + "Available options: " + values.map((value)=>JSON.stringify(value)).join(", ") + ".");
}


var $51a6b35cfb657a1d$export$e506a1d27d1eaa20 = function config(options) {
    if (options) throw new Error("The global config is readonly. \nPlease create a mathjs instance if you want to change the default configuration. \nExample:\n\n  import { create, all } from 'mathjs';\n  const mathjs = create(all);\n  mathjs.config({ number: 'BigNumber' });\n");
    return Object.freeze((0, $9db7cd4309d5c0db$export$c2f8e0cc249a8d8f));
};
(0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))($51a6b35cfb657a1d$export$e506a1d27d1eaa20, (0, $9db7cd4309d5c0db$export$c2f8e0cc249a8d8f), {
    MATRIX_OPTIONS: $3f4182c2cc14bc92$export$517ab898194ae9af,
    NUMBER_OPTIONS: $3f4182c2cc14bc92$export$f4b0a2084fdf2177
});



function $a690df4b5d23d55b$export$e9008f2713103c6c(name, dependencies, create, meta) {
    function assertAndCreate(scope) {
        // we only pass the requested dependencies to the factory function
        // to prevent functions to rely on dependencies that are not explicitly
        // requested.
        var deps = (0, $46a94b3d1146edd8$export$8cea971c64639ea7)(scope, dependencies.map($a690df4b5d23d55b$export$2f4d32a1468e229c));
        $a690df4b5d23d55b$export$19a2c26dad95d6e7(name, dependencies, scope);
        return create(deps);
    }
    assertAndCreate.isFactory = true;
    assertAndCreate.fn = name;
    assertAndCreate.dependencies = dependencies.slice().sort();
    if (meta) assertAndCreate.meta = meta;
    return assertAndCreate;
}
function $a690df4b5d23d55b$export$883f1d394ed355c(factories) {
    var factoriesByName = {};
    factories.forEach((factory)=>{
        factoriesByName[factory.fn] = factory;
    });
    function containsDependency(factory, dependency) {
        // TODO: detect circular references
        if ($a690df4b5d23d55b$export$34763cfbed1075c2(factory)) {
            if (factory.dependencies.includes(dependency.fn || dependency.name)) return true;
            if (factory.dependencies.some((d)=>containsDependency(factoriesByName[d], dependency))) return true;
        }
        return false;
    }
    var sorted = [];
    function addFactory(factory) {
        var index = 0;
        while(index < sorted.length && !containsDependency(sorted[index], factory))index++;
        sorted.splice(index, 0, factory);
    }
    // sort regular factory functions
    factories.filter($a690df4b5d23d55b$export$34763cfbed1075c2).forEach(addFactory);
    // sort legacy factory functions AFTER the regular factory functions
    factories.filter((factory)=>!$a690df4b5d23d55b$export$34763cfbed1075c2(factory)).forEach(addFactory);
    return sorted;
}
function $a690df4b5d23d55b$export$185802fd694ee1f5(factories) {
    var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $a690df4b5d23d55b$export$883f1d394ed355c(factories).forEach((factory)=>factory(scope));
    return scope;
}
function $a690df4b5d23d55b$export$34763cfbed1075c2(obj) {
    return typeof obj === "function" && typeof obj.fn === "string" && Array.isArray(obj.dependencies);
}
function $a690df4b5d23d55b$export$19a2c26dad95d6e7(name, dependencies, scope) {
    var allDefined = dependencies.filter((dependency)=>!$a690df4b5d23d55b$export$1399ac7f45b04b5(dependency)) // filter optionals
    .every((dependency)=>scope[dependency] !== undefined);
    if (!allDefined) {
        var missingDependencies = dependencies.filter((dependency)=>scope[dependency] === undefined);
        // TODO: create a custom error class for this, a MathjsError or something like that
        throw new Error('Cannot create function "'.concat(name, '", ') + "some dependencies are missing: ".concat(missingDependencies.map((d)=>'"'.concat(d, '"')).join(", "), "."));
    }
}
function $a690df4b5d23d55b$export$1399ac7f45b04b5(dependency) {
    return dependency && dependency[0] === "?";
}
function $a690df4b5d23d55b$export$2f4d32a1468e229c(dependency) {
    return dependency && dependency[0] === "?" ? dependency.slice(1) : dependency;
}



/**
 * Create a range error with the message:
 *     'Index out of range (index < min)'
 *     'Index out of range (index < max)'
 *
 * @param {number} index     The actual index
 * @param {number} [min=0]   Minimum index (included)
 * @param {number} [max]     Maximum index (excluded)
 * @extends RangeError
 */ function $7e61b13fb7752c23$export$efa5eacb1304c464(index, min, max) {
    if (!(this instanceof $7e61b13fb7752c23$export$efa5eacb1304c464)) throw new SyntaxError("Constructor must be called with the new operator");
    this.index = index;
    if (arguments.length < 3) {
        this.min = 0;
        this.max = min;
    } else {
        this.min = min;
        this.max = max;
    }
    if (this.min !== undefined && this.index < this.min) this.message = "Index out of range (" + this.index + " < " + this.min + ")";
    else if (this.max !== undefined && this.index >= this.max) this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")";
    else this.message = "Index out of range (" + this.index + ")";
    this.stack = new Error().stack;
}
$7e61b13fb7752c23$export$efa5eacb1304c464.prototype = new RangeError();
$7e61b13fb7752c23$export$efa5eacb1304c464.prototype.constructor = RangeError;
$7e61b13fb7752c23$export$efa5eacb1304c464.prototype.name = "IndexError";
$7e61b13fb7752c23$export$efa5eacb1304c464.prototype.isIndexError = true;




function $a246eb207aab6d09$export$a287f47fed4544b8(value) {
    if (typeof value === "boolean") return true;
    return isFinite(value) ? value === Math.round(value) : false;
}
function $a246eb207aab6d09$export$f19ba20bcb50d13d(str) {
    // regex matching strings like "123" and "-123"
    return /^-?\d+$/.test(str);
}
function $a246eb207aab6d09$export$28199db5a610a1ee(numberStr, config) {
    if (config.number === "bigint" && !$a246eb207aab6d09$export$f19ba20bcb50d13d(numberStr)) return config.numberFallback;
    return config.number;
}
var $a246eb207aab6d09$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    if (x > 0) return 1;
    else if (x < 0) return -1;
    else return 0;
};
var $a246eb207aab6d09$export$b9fae0bba9d9094d = Math.log2 || function log2(x) {
    return Math.log(x) / Math.LN2;
};
var $a246eb207aab6d09$export$75e08744a3ff8516 = Math.log10 || function log10(x) {
    return Math.log(x) / Math.LN10;
};
var $a246eb207aab6d09$export$144dcf16adfb9698 = Math.log1p || function(x) {
    return Math.log(x + 1);
};
var $a246eb207aab6d09$export$841fc4d5a1480b85 = Math.cbrt || function cbrt(x) {
    if (x === 0) return x;
    var negate = x < 0;
    var result;
    if (negate) x = -x;
    if (isFinite(x)) {
        result = Math.exp(Math.log(x) / 3);
        // from https://en.wikipedia.org/wiki/Cube_root#Numerical_methods
        result = (x / (result * result) + 2 * result) / 3;
    } else result = x;
    return negate ? -result : result;
};
var $a246eb207aab6d09$export$b6c0a80d46d3391d = Math.expm1 || function expm1(x) {
    return x >= 2e-4 || x <= -0.0002 ? Math.exp(x) - 1 : x + x * x / 2 + x * x * x / 6;
};
/**
 * Formats a number in a given base
 * @param {number} n
 * @param {number} base
 * @param {number} size
 * @returns {string}
 */ function $a246eb207aab6d09$var$formatNumberToBase(n, base, size) {
    var prefixes = {
        2: "0b",
        8: "0o",
        16: "0x"
    };
    var prefix = prefixes[base];
    var suffix = "";
    if (size) {
        if (size < 1) throw new Error("size must be in greater than 0");
        if (!$a246eb207aab6d09$export$a287f47fed4544b8(size)) throw new Error("size must be an integer");
        if (n > 2 ** (size - 1) - 1 || n < -(2 ** (size - 1))) throw new Error("Value must be in range [-2^".concat(size - 1, ", 2^").concat(size - 1, "-1]"));
        if (!$a246eb207aab6d09$export$a287f47fed4544b8(n)) throw new Error("Value must be an integer");
        if (n < 0) n = n + 2 ** size;
        suffix = "i".concat(size);
    }
    var sign = "";
    if (n < 0) {
        n = -n;
        sign = "-";
    }
    return "".concat(sign).concat(prefix).concat(n.toString(base)).concat(suffix);
}
function $a246eb207aab6d09$export$d9468344d3651243(value, options) {
    if (typeof options === "function") // handle format(value, fn)
    return options(value);
    // handle special cases
    if (value === Infinity) return "Infinity";
    else if (value === -Infinity) return "-Infinity";
    else if (isNaN(value)) return "NaN";
    var { notation: notation, precision: precision, wordSize: wordSize } = $a246eb207aab6d09$export$2f3e6f8e6b67bad4(options);
    // handle the various notations
    switch(notation){
        case "fixed":
            return $a246eb207aab6d09$export$a81f732198733497(value, precision);
        case "exponential":
            return $a246eb207aab6d09$export$888cb08ddc4765be(value, precision);
        case "engineering":
            return $a246eb207aab6d09$export$9299fe684ed0ee48(value, precision);
        case "bin":
            return $a246eb207aab6d09$var$formatNumberToBase(value, 2, wordSize);
        case "oct":
            return $a246eb207aab6d09$var$formatNumberToBase(value, 8, wordSize);
        case "hex":
            return $a246eb207aab6d09$var$formatNumberToBase(value, 16, wordSize);
        case "auto":
            // remove trailing zeros after the decimal point
            return $a246eb207aab6d09$export$3e91a10e66078270(value, precision, options).replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== "." ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
    }
}
function $a246eb207aab6d09$export$2f3e6f8e6b67bad4(options) {
    // default values for options
    var notation = "auto";
    var precision;
    var wordSize;
    if (options !== undefined) {
        if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(options)) precision = options;
        else if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(options)) precision = options.toNumber();
        else if ((0, $23cfe017d190638f$export$a6cdc56e425d0d0a)(options)) {
            if (options.precision !== undefined) precision = $a246eb207aab6d09$var$_toNumberOrThrow(options.precision, ()=>{
                throw new Error('Option "precision" must be a number or BigNumber');
            });
            if (options.wordSize !== undefined) wordSize = $a246eb207aab6d09$var$_toNumberOrThrow(options.wordSize, ()=>{
                throw new Error('Option "wordSize" must be a number or BigNumber');
            });
            if (options.notation) notation = options.notation;
        } else throw new Error("Unsupported type of options, number, BigNumber, or object expected");
    }
    return {
        notation: notation,
        precision: precision,
        wordSize: wordSize
    };
}
function $a246eb207aab6d09$export$feb80e120a50087f(value) {
    // parse the input value
    var match = String(value).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
    if (!match) throw new SyntaxError("Invalid number " + value);
    var sign = match[1];
    var digits = match[2];
    var exponent = parseFloat(match[4] || "0");
    var dot = digits.indexOf(".");
    exponent += dot !== -1 ? dot - 1 : digits.length - 1;
    var coefficients = digits.replace(".", "") // remove the dot (must be removed before removing leading zeros)
    .replace(/^0*/, function(zeros) {
        // remove leading zeros, add their count to the exponent
        exponent -= zeros.length;
        return "";
    }).replace(/0*$/, "") // remove trailing zeros
    .split("").map(function(d) {
        return parseInt(d);
    });
    if (coefficients.length === 0) {
        coefficients.push(0);
        exponent++;
    }
    return {
        sign: sign,
        coefficients: coefficients,
        exponent: exponent
    };
}
function $a246eb207aab6d09$export$9299fe684ed0ee48(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var split = $a246eb207aab6d09$export$feb80e120a50087f(value);
    var rounded = $a246eb207aab6d09$export$e5b32ced877afc7e(split, precision);
    var e = rounded.exponent;
    var c = rounded.coefficients;
    // find nearest lower multiple of 3 for exponent
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3;
    if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(precision)) // add zeroes to give correct sig figs
    while(precision > c.length || e - newExp + 1 > c.length)c.push(0);
    else {
        // concatenate coefficients with necessary zeros
        // add zeros if necessary (for example: 1e+8 -> 100e+6)
        var missingZeros = Math.abs(e - newExp) - (c.length - 1);
        for(var i = 0; i < missingZeros; i++)c.push(0);
    }
    // find difference in exponents
    var expDiff = Math.abs(e - newExp);
    var decimalIdx = 1;
    // push decimal index over by expDiff times
    while(expDiff > 0){
        decimalIdx++;
        expDiff--;
    }
    // if all coefficient values are zero after the decimal point and precision is unset, don't add a decimal value.
    // otherwise concat with the rest of the coefficients
    var decimals = c.slice(decimalIdx).join("");
    var decimalVal = (0, $23cfe017d190638f$export$7e4aa119212bc614)(precision) && decimals.length || decimals.match(/[1-9]/) ? "." + decimals : "";
    var str = c.slice(0, decimalIdx).join("") + decimalVal + "e" + (e >= 0 ? "+" : "") + newExp.toString();
    return rounded.sign + str;
}
function $a246eb207aab6d09$export$a81f732198733497(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var splitValue = $a246eb207aab6d09$export$feb80e120a50087f(value);
    var rounded = typeof precision === "number" ? $a246eb207aab6d09$export$e5b32ced877afc7e(splitValue, splitValue.exponent + 1 + precision) : splitValue;
    var c = rounded.coefficients;
    var p = rounded.exponent + 1; // exponent may have changed
    // append zeros if needed
    var pp = p + (precision || 0);
    if (c.length < pp) c = c.concat($a246eb207aab6d09$var$zeros(pp - c.length));
    // prepend zeros if needed
    if (p < 0) {
        c = $a246eb207aab6d09$var$zeros(-p + 1).concat(c);
        p = 1;
    }
    // insert a dot if needed
    if (p < c.length) c.splice(p, 0, p === 0 ? "0." : ".");
    return rounded.sign + c.join("");
}
function $a246eb207aab6d09$export$888cb08ddc4765be(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    // round if needed, else create a clone
    var split = $a246eb207aab6d09$export$feb80e120a50087f(value);
    var rounded = precision ? $a246eb207aab6d09$export$e5b32ced877afc7e(split, precision) : split;
    var c = rounded.coefficients;
    var e = rounded.exponent;
    // append zeros if needed
    if (c.length < precision) c = c.concat($a246eb207aab6d09$var$zeros(precision - c.length));
    // format as `C.CCCe+EEE` or `C.CCCe-EEE`
    var first = c.shift();
    return rounded.sign + first + (c.length > 0 ? "." + c.join("") : "") + "e" + (e >= 0 ? "+" : "") + e;
}
function $a246eb207aab6d09$export$3e91a10e66078270(value, precision, options) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    // determine lower and upper bound for exponential notation.
    var lowerExp = $a246eb207aab6d09$var$_toNumberOrDefault(options === null || options === void 0 ? void 0 : options.lowerExp, -3);
    var upperExp = $a246eb207aab6d09$var$_toNumberOrDefault(options === null || options === void 0 ? void 0 : options.upperExp, 5);
    var split = $a246eb207aab6d09$export$feb80e120a50087f(value);
    var rounded = precision ? $a246eb207aab6d09$export$e5b32ced877afc7e(split, precision) : split;
    if (rounded.exponent < lowerExp || rounded.exponent >= upperExp) // exponential notation
    return $a246eb207aab6d09$export$888cb08ddc4765be(value, precision);
    else {
        var c = rounded.coefficients;
        var e = rounded.exponent;
        // append trailing zeros
        if (c.length < precision) c = c.concat($a246eb207aab6d09$var$zeros(precision - c.length));
        // append trailing zeros
        // TODO: simplify the next statement
        c = c.concat($a246eb207aab6d09$var$zeros(e - c.length + 1 + (c.length < precision ? precision - c.length : 0)));
        // prepend zeros
        c = $a246eb207aab6d09$var$zeros(-e).concat(c);
        var dot = e > 0 ? e : 0;
        if (dot < c.length - 1) c.splice(dot + 1, 0, ".");
        return rounded.sign + c.join("");
    }
}
function $a246eb207aab6d09$export$e5b32ced877afc7e(split, precision) {
    // create a clone
    var rounded = {
        sign: split.sign,
        coefficients: split.coefficients,
        exponent: split.exponent
    };
    var c = rounded.coefficients;
    // prepend zeros if needed
    while(precision <= 0){
        c.unshift(0);
        rounded.exponent++;
        precision++;
    }
    if (c.length > precision) {
        var removed = c.splice(precision, c.length - precision);
        if (removed[0] >= 5) {
            var i = precision - 1;
            c[i]++;
            while(c[i] === 10){
                c.pop();
                if (i === 0) {
                    c.unshift(0);
                    rounded.exponent++;
                    i++;
                }
                i--;
                c[i]++;
            }
        }
    }
    return rounded;
}
/**
 * Create an array filled with zeros.
 * @param {number} length
 * @return {Array}
 */ function $a246eb207aab6d09$var$zeros(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push(0);
    return arr;
}
function $a246eb207aab6d09$export$9c0987062f8f5d89(value) {
    return value.toExponential().replace(/e.*$/, "") // remove exponential notation
    .replace(/^0\.?0*|\./, "") // remove decimal point and leading zeros
    .length;
}
var $a246eb207aab6d09$export$41b54fa1db30dbb5 = Number.EPSILON || 2.2204460492503130808472633361816E-16;
function $a246eb207aab6d09$export$6f3989c6ecc04081(a, b) {
    var relTol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e-8;
    var absTol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    if (relTol <= 0) throw new Error("Relative tolerance must be greater than 0");
    if (absTol < 0) throw new Error("Absolute tolerance must be at least 0");
    // NaN
    if (isNaN(a) || isNaN(b)) return false;
    if (!isFinite(a) || !isFinite(b)) return a === b;
    if (a === b) return true;
    // abs(a-b) <= max(rel_tol * max(abs(a), abs(b)), abs_tol)
    return Math.abs(a - b) <= Math.max(relTol * Math.max(Math.abs(a), Math.abs(b)), absTol);
}
var $a246eb207aab6d09$export$b26caf0f29211d08 = Math.acosh || function(x) {
    return Math.log(Math.sqrt(x * x - 1) + x);
};
var $a246eb207aab6d09$export$839d8a01b6af4fc0 = Math.asinh || function(x) {
    return Math.log(Math.sqrt(x * x + 1) + x);
};
var $a246eb207aab6d09$export$21ea955025ceb08b = Math.atanh || function(x) {
    return Math.log((1 + x) / (1 - x)) / 2;
};
var $a246eb207aab6d09$export$2e2fd1ad24e4d350 = Math.cosh || function(x) {
    return (Math.exp(x) + Math.exp(-x)) / 2;
};
var $a246eb207aab6d09$export$545004b505d7c555 = Math.sinh || function(x) {
    return (Math.exp(x) - Math.exp(-x)) / 2;
};
var $a246eb207aab6d09$export$7128670e45beef9a = Math.tanh || function(x) {
    var e = Math.exp(2 * x);
    return (e - 1) / (e + 1);
};
function $a246eb207aab6d09$export$fe7b50dc6162f97e(x, y) {
    var signx = x > 0 ? true : x < 0 ? false : 1 / x === Infinity;
    var signy = y > 0 ? true : y < 0 ? false : 1 / y === Infinity;
    return signx ^ signy ? -x : x;
}
function $a246eb207aab6d09$var$_toNumberOrThrow(value, onError) {
    if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(value)) return value;
    else if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(value)) return value.toNumber();
    else onError();
}
function $a246eb207aab6d09$var$_toNumberOrDefault(value, defaultValue) {
    if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(value)) return value;
    else if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(value)) return value.toNumber();
    else return defaultValue;
}







/**
 * Formats a BigNumber in a given base
 * @param {BigNumber} n
 * @param {number} base
 * @param {number} size
 * @returns {string}
 */ function $b2361c9afb6902a3$var$formatBigNumberToBase(n, base, size) {
    var BigNumberCtor = n.constructor;
    var big2 = new BigNumberCtor(2);
    var suffix = "";
    if (size) {
        if (size < 1) throw new Error("size must be in greater than 0");
        if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(size)) throw new Error("size must be an integer");
        if (n.greaterThan(big2.pow(size - 1).sub(1)) || n.lessThan(big2.pow(size - 1).mul(-1))) throw new Error("Value must be in range [-2^".concat(size - 1, ", 2^").concat(size - 1, "-1]"));
        if (!n.isInteger()) throw new Error("Value must be an integer");
        if (n.lessThan(0)) n = n.add(big2.pow(size));
        suffix = "i".concat(size);
    }
    switch(base){
        case 2:
            return "".concat(n.toBinary()).concat(suffix);
        case 8:
            return "".concat(n.toOctal()).concat(suffix);
        case 16:
            return "".concat(n.toHexadecimal()).concat(suffix);
        default:
            throw new Error("Base ".concat(base, " not supported "));
    }
}
function $b2361c9afb6902a3$export$d9468344d3651243(value, options) {
    if (typeof options === "function") // handle format(value, fn)
    return options(value);
    // handle special cases
    if (!value.isFinite()) return value.isNaN() ? "NaN" : value.gt(0) ? "Infinity" : "-Infinity";
    var { notation: notation, precision: precision, wordSize: wordSize } = (0, $a246eb207aab6d09$export$2f3e6f8e6b67bad4)(options);
    // handle the various notations
    switch(notation){
        case "fixed":
            return $b2361c9afb6902a3$export$a81f732198733497(value, precision);
        case "exponential":
            return $b2361c9afb6902a3$export$888cb08ddc4765be(value, precision);
        case "engineering":
            return $b2361c9afb6902a3$export$9299fe684ed0ee48(value, precision);
        case "bin":
            return $b2361c9afb6902a3$var$formatBigNumberToBase(value, 2, wordSize);
        case "oct":
            return $b2361c9afb6902a3$var$formatBigNumberToBase(value, 8, wordSize);
        case "hex":
            return $b2361c9afb6902a3$var$formatBigNumberToBase(value, 16, wordSize);
        case "auto":
            // determine lower and upper bound for exponential notation.
            // TODO: implement support for upper and lower to be BigNumbers themselves
            var lowerExp = $b2361c9afb6902a3$var$_toNumberOrDefault(options === null || options === void 0 ? void 0 : options.lowerExp, -3);
            var upperExp = $b2361c9afb6902a3$var$_toNumberOrDefault(options === null || options === void 0 ? void 0 : options.upperExp, 5);
            // handle special case zero
            if (value.isZero()) return "0";
            // determine whether or not to output exponential notation
            var str;
            var rounded = value.toSignificantDigits(precision);
            var exp = rounded.e;
            if (exp >= lowerExp && exp < upperExp) // normal number notation
            str = rounded.toFixed();
            else // exponential notation
            str = $b2361c9afb6902a3$export$888cb08ddc4765be(value, precision);
            // remove trailing zeros after the decimal point
            return str.replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== "." ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
    }
}
function $b2361c9afb6902a3$export$9299fe684ed0ee48(value, precision) {
    // find nearest lower multiple of 3 for exponent
    var e = value.e;
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3;
    // find difference in exponents, and calculate the value without exponent
    var valueWithoutExp = value.mul(Math.pow(10, -newExp));
    var valueStr = valueWithoutExp.toPrecision(precision);
    if (valueStr.includes("e")) {
        var BigNumber = value.constructor;
        valueStr = new BigNumber(valueStr).toFixed();
    }
    return valueStr + "e" + (e >= 0 ? "+" : "") + newExp.toString();
}
function $b2361c9afb6902a3$export$888cb08ddc4765be(value, precision) {
    if (precision !== undefined) return value.toExponential(precision - 1); // Note the offset of one
    else return value.toExponential();
}
function $b2361c9afb6902a3$export$a81f732198733497(value, precision) {
    return value.toFixed(precision);
}
function $b2361c9afb6902a3$var$_toNumberOrDefault(value, defaultValue) {
    if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(value)) return value;
    else if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(value)) return value.toNumber();
    else return defaultValue;
}


function $1b038b7ade911d0e$export$10fdab3683b55b22(text, search) {
    var start = text.length - search.length;
    var end = text.length;
    return text.substring(start, end) === search;
}
function $1b038b7ade911d0e$export$d9468344d3651243(value, options) {
    var result = $1b038b7ade911d0e$var$_format(value, options);
    if (options && typeof options === "object" && "truncate" in options && result.length > options.truncate) return result.substring(0, options.truncate - 3) + "...";
    return result;
}
function $1b038b7ade911d0e$var$_format(value, options) {
    if (typeof value === "number") return (0, $a246eb207aab6d09$export$d9468344d3651243)(value, options);
    if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(value)) return (0, $b2361c9afb6902a3$export$d9468344d3651243)(value, options);
    // note: we use unsafe duck-typing here to check for Fractions, this is
    // ok here since we're only invoking toString or concatenating its values
    if ($1b038b7ade911d0e$var$looksLikeFraction(value)) {
        if (!options || options.fraction !== "decimal") // output as ratio, like '1/3'
        return value.s * value.n + "/" + value.d;
        else // output as decimal, like '0.(3)'
        return value.toString();
    }
    if (Array.isArray(value)) return $1b038b7ade911d0e$var$formatArray(value, options);
    if ((0, $23cfe017d190638f$export$844ec244b1367d54)(value)) return $1b038b7ade911d0e$export$fac44ee5b035f737(value);
    if (typeof value === "function") return value.syntax ? String(value.syntax) : "function";
    if (value && typeof value === "object") {
        if (typeof value.format === "function") return value.format(options);
        else if (value && value.toString(options) !== ({}).toString()) // this object has a non-native toString method, use that one
        return value.toString(options);
        else {
            var entries = Object.keys(value).map((key)=>{
                return $1b038b7ade911d0e$export$fac44ee5b035f737(key) + ": " + $1b038b7ade911d0e$export$d9468344d3651243(value[key], options);
            });
            return "{" + entries.join(", ") + "}";
        }
    }
    return String(value);
}
function $1b038b7ade911d0e$export$fac44ee5b035f737(value) {
    var text = String(value);
    var escaped = "";
    var i = 0;
    while(i < text.length){
        var c = text.charAt(i);
        escaped += c in $1b038b7ade911d0e$var$controlCharacters ? $1b038b7ade911d0e$var$controlCharacters[c] : c;
        i++;
    }
    return '"' + escaped + '"';
}
var $1b038b7ade911d0e$var$controlCharacters = {
    '"': '\\"',
    "\\": "\\\\",
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "	": "\\t"
};
function $1b038b7ade911d0e$export$4e7f196112fea3c5(value) {
    var text = String(value);
    text = text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return text;
}
/**
 * Recursively format an n-dimensional matrix
 * Example output: "[[1, 2], [3, 4]]"
 * @param {Array} array
 * @param {Object | number | Function} [options]  Formatting options. See
 *                                                lib/utils/number:format for a
 *                                                description of the available
 *                                                options.
 * @returns {string} str
 */ function $1b038b7ade911d0e$var$formatArray(array, options) {
    if (Array.isArray(array)) {
        var str = "[";
        var len = array.length;
        for(var i = 0; i < len; i++){
            if (i !== 0) str += ", ";
            str += $1b038b7ade911d0e$var$formatArray(array[i], options);
        }
        str += "]";
        return str;
    } else return $1b038b7ade911d0e$export$d9468344d3651243(array, options);
}
/**
 * Check whether a value looks like a Fraction (unsafe duck-type check)
 * @param {*} value
 * @return {boolean}
 */ function $1b038b7ade911d0e$var$looksLikeFraction(value) {
    return value && typeof value === "object" && typeof value.s === "number" && typeof value.n === "number" && typeof value.d === "number" || false;
}
function $1b038b7ade911d0e$export$2da9287da10b19e2(x, y) {
    // we don't want to convert numbers to string, only accept string input
    if (!(0, $23cfe017d190638f$export$844ec244b1367d54)(x)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(x) + ", index: 0)");
    if (!(0, $23cfe017d190638f$export$844ec244b1367d54)(y)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(y) + ", index: 1)");
    return x === y ? 0 : x > y ? 1 : -1;
}


/**
 * Create a range error with the message:
 *     'Dimension mismatch (<actual size> != <expected size>)'
 * @param {number | number[]} actual        The actual size
 * @param {number | number[]} expected      The expected size
 * @param {string} [relation='!=']          Optional relation between actual
 *                                          and expected size: '!=', '<', etc.
 * @extends RangeError
 */ function $9b62b26fef4c910f$export$ad1391ca020fdd96(actual, expected, relation) {
    if (!(this instanceof $9b62b26fef4c910f$export$ad1391ca020fdd96)) throw new SyntaxError("Constructor must be called with the new operator");
    this.actual = actual;
    this.expected = expected;
    this.relation = relation;
    this.message = "Dimension mismatch (" + (Array.isArray(actual) ? "[" + actual.join(", ") + "]" : actual) + " " + (this.relation || "!=") + " " + (Array.isArray(expected) ? "[" + expected.join(", ") + "]" : expected) + ")";
    this.stack = new Error().stack;
}
$9b62b26fef4c910f$export$ad1391ca020fdd96.prototype = new RangeError();
$9b62b26fef4c910f$export$ad1391ca020fdd96.prototype.constructor = RangeError;
$9b62b26fef4c910f$export$ad1391ca020fdd96.prototype.name = "DimensionError";
$9b62b26fef4c910f$export$ad1391ca020fdd96.prototype.isDimensionError = true;




function $eee21df0c3527ff1$export$51ffaee4afb683a5(x) {
    var s = [];
    while(Array.isArray(x)){
        s.push(x.length);
        x = x[0];
    }
    return s;
}
/**
 * Recursively validate whether each element in a multi dimensional array
 * has a size corresponding to the provided size array.
 * @param {Array} array    Array to be validated
 * @param {number[]} size  Array with the size of each dimension
 * @param {number} dim   Current dimension
 * @throws DimensionError
 * @private
 */ function $eee21df0c3527ff1$var$_validate(array, size, dim) {
    var i;
    var len = array.length;
    if (len !== size[dim]) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(len, size[dim]);
    if (dim < size.length - 1) {
        // recursively validate each child array
        var dimNext = dim + 1;
        for(i = 0; i < len; i++){
            var child = array[i];
            if (!Array.isArray(child)) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(size.length - 1, size.length, "<");
            $eee21df0c3527ff1$var$_validate(array[i], size, dimNext);
        }
    } else // last dimension. none of the childs may be an array
    for(i = 0; i < len; i++){
        if (Array.isArray(array[i])) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(size.length + 1, size.length, ">");
    }
}
function $eee21df0c3527ff1$export$a22775fa5e2eebd9(array, size) {
    var isScalar = size.length === 0;
    if (isScalar) {
        // scalar
        if (Array.isArray(array)) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(array.length, 0);
    } else // array
    $eee21df0c3527ff1$var$_validate(array, size, 0);
}
function $eee21df0c3527ff1$export$a406fce6a920be3c(value, index) {
    var valueSize = value.isMatrix ? value._size : $eee21df0c3527ff1$export$51ffaee4afb683a5(value);
    var sourceSize = index._sourceSize;
    // checks if the source size is not null and matches the valueSize
    sourceSize.forEach((sourceDim, i)=>{
        if (sourceDim !== null && sourceDim !== valueSize[i]) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(sourceDim, valueSize[i]);
    });
}
function $eee21df0c3527ff1$export$3cfe3fbfec03f260(index, length) {
    if (index !== undefined) {
        if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(index) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(index)) throw new TypeError("Index must be an integer (value: " + index + ")");
        if (index < 0 || typeof length === "number" && index >= length) throw new (0, $7e61b13fb7752c23$export$efa5eacb1304c464)(index, length);
    }
}
function $eee21df0c3527ff1$export$1f3203c278bd022(index) {
    for(var i = 0; i < index._dimensions.length; ++i){
        var dimension = index._dimensions[i];
        if (dimension._data && (0, $23cfe017d190638f$export$43bee75e5e14138e)(dimension._data)) {
            if (dimension._size[0] === 0) return true;
        } else if (dimension.isRange) {
            if (dimension.start === dimension.end) return true;
        } else if ((0, $23cfe017d190638f$export$844ec244b1367d54)(dimension)) {
            if (dimension.length === 0) return true;
        }
    }
    return false;
}
function $eee21df0c3527ff1$export$4380c87abf28fdf(array, size, defaultValue) {
    // check the type of the arguments
    if (!Array.isArray(size)) throw new TypeError("Array expected");
    if (size.length === 0) throw new Error("Resizing to scalar is not supported");
    // check whether size contains positive integers
    size.forEach(function(value) {
        if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(value) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
    });
    // convert number to an array
    if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(array) || (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(array)) array = [
        array
    ];
    // recursively resize the array
    var _defaultValue = defaultValue !== undefined ? defaultValue : 0;
    $eee21df0c3527ff1$var$_resize(array, size, 0, _defaultValue);
    return array;
}
/**
 * Recursively resize a multi dimensional array
 * @param {Array} array         Array to be resized
 * @param {number[]} size       Array with the size of each dimension
 * @param {number} dim          Current dimension
 * @param {*} [defaultValue]    Value to be filled in in new entries,
 *                              undefined by default.
 * @private
 */ function $eee21df0c3527ff1$var$_resize(array, size, dim, defaultValue) {
    var i;
    var elem;
    var oldLen = array.length;
    var newLen = size[dim];
    var minLen = Math.min(oldLen, newLen);
    // apply new length
    array.length = newLen;
    if (dim < size.length - 1) {
        // non-last dimension
        var dimNext = dim + 1;
        // resize existing child arrays
        for(i = 0; i < minLen; i++){
            // resize child array
            elem = array[i];
            if (!Array.isArray(elem)) {
                elem = [
                    elem
                ]; // add a dimension
                array[i] = elem;
            }
            $eee21df0c3527ff1$var$_resize(elem, size, dimNext, defaultValue);
        }
        // create new child arrays
        for(i = minLen; i < newLen; i++){
            // get child array
            elem = [];
            array[i] = elem;
            // resize new child array
            $eee21df0c3527ff1$var$_resize(elem, size, dimNext, defaultValue);
        }
    } else {
        // last dimension
        // remove dimensions of existing values
        for(i = 0; i < minLen; i++)while(Array.isArray(array[i]))array[i] = array[i][0];
        // fill new elements with the default value
        for(i = minLen; i < newLen; i++)array[i] = defaultValue;
    }
}
function $eee21df0c3527ff1$export$9eaad88cf88cee2b(array, sizes) {
    var flatArray = $eee21df0c3527ff1$export$bffa455ba8c619a6(array);
    var currentLength = flatArray.length;
    if (!Array.isArray(array) || !Array.isArray(sizes)) throw new TypeError("Array expected");
    if (sizes.length === 0) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(0, currentLength, "!=");
    sizes = $eee21df0c3527ff1$export$d0efc868ac2c6822(sizes, currentLength);
    var newLength = $eee21df0c3527ff1$var$product(sizes);
    if (currentLength !== newLength) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(newLength, currentLength, "!=");
    try {
        return $eee21df0c3527ff1$var$_reshape(flatArray, sizes);
    } catch (e) {
        if (e instanceof (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(newLength, currentLength, "!=");
        throw e;
    }
}
function $eee21df0c3527ff1$export$d0efc868ac2c6822(sizes, currentLength) {
    var newLength = $eee21df0c3527ff1$var$product(sizes);
    var processedSizes = sizes.slice();
    var WILDCARD = -1;
    var wildCardIndex = sizes.indexOf(WILDCARD);
    var isMoreThanOneWildcard = sizes.indexOf(WILDCARD, wildCardIndex + 1) >= 0;
    if (isMoreThanOneWildcard) throw new Error("More than one wildcard in sizes");
    var hasWildcard = wildCardIndex >= 0;
    var canReplaceWildcard = currentLength % newLength === 0;
    if (hasWildcard) {
        if (canReplaceWildcard) processedSizes[wildCardIndex] = -currentLength / newLength;
        else throw new Error("Could not replace wildcard, since " + currentLength + " is no multiple of " + -newLength);
    }
    return processedSizes;
}
/**
 * Computes the product of all array elements.
 * @param {number[]} array Array of factors
 * @returns {number}            Product of all elements
 */ function $eee21df0c3527ff1$var$product(array) {
    return array.reduce((prev, curr)=>prev * curr, 1);
}
/**
 * Iteratively re-shape a multi dimensional array to fit the specified dimensions
 * @param {Array} array           Array to be reshaped
 * @param {number[]} sizes  List of sizes for each dimension
 * @returns {Array}               Array whose data has been formatted to fit the
 *                                specified dimensions
 */ function $eee21df0c3527ff1$var$_reshape(array, sizes) {
    // testing if there are enough elements for the requested shape
    var tmpArray = array;
    var tmpArray2;
    // for each dimensions starting by the last one and ignoring the first one
    for(var sizeIndex = sizes.length - 1; sizeIndex > 0; sizeIndex--){
        var size = sizes[sizeIndex];
        tmpArray2 = [];
        // aggregate the elements of the current tmpArray in elements of the requested size
        var length = tmpArray.length / size;
        for(var i = 0; i < length; i++)tmpArray2.push(tmpArray.slice(i * size, (i + 1) * size));
        // set it as the new tmpArray for the next loop turn or for return
        tmpArray = tmpArray2;
    }
    return tmpArray;
}
function $eee21df0c3527ff1$export$889c931173b77c2f(array, size) {
    var s = size || $eee21df0c3527ff1$export$51ffaee4afb683a5(array);
    // squeeze outer dimensions
    while(Array.isArray(array) && array.length === 1){
        array = array[0];
        s.shift();
    }
    // find the first dimension to be squeezed
    var dims = s.length;
    while(s[dims - 1] === 1)dims--;
    // squeeze inner dimensions
    if (dims < s.length) {
        array = $eee21df0c3527ff1$var$_squeeze(array, dims, 0);
        s.length = dims;
    }
    return array;
}
/**
 * Recursively squeeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $eee21df0c3527ff1$var$_squeeze(array, dims, dim) {
    var i, ii;
    if (dim < dims) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $eee21df0c3527ff1$var$_squeeze(array[i], dims, next);
    } else while(Array.isArray(array))array = array[0];
    return array;
}
function $eee21df0c3527ff1$export$5a07c5202d40a604(array, dims, outer, size) {
    var s = size || $eee21df0c3527ff1$export$51ffaee4afb683a5(array);
    // unsqueeze outer dimensions
    if (outer) for(var i = 0; i < outer; i++){
        array = [
            array
        ];
        s.unshift(1);
    }
    // unsqueeze inner dimensions
    array = $eee21df0c3527ff1$var$_unsqueeze(array, dims, 0);
    while(s.length < dims)s.push(1);
    return array;
}
/**
 * Recursively unsqueeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $eee21df0c3527ff1$var$_unsqueeze(array, dims, dim) {
    var i, ii;
    if (Array.isArray(array)) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $eee21df0c3527ff1$var$_unsqueeze(array[i], dims, next);
    } else for(var d = dim; d < dims; d++)array = [
        array
    ];
    return array;
}
function $eee21df0c3527ff1$export$bffa455ba8c619a6(array) {
    if (!Array.isArray(array)) // if not an array, return as is
    return array;
    var flat = [];
    array.forEach(function callback(value) {
        if (Array.isArray(value)) value.forEach(callback); // traverse through sub-arrays recursively
        else flat.push(value);
    });
    return flat;
}
function $eee21df0c3527ff1$export$871de8747c9eaa88(array, callback) {
    return Array.prototype.map.call(array, callback);
}
function $eee21df0c3527ff1$export$4b80e395e36b5a56(array, callback) {
    Array.prototype.forEach.call(array, callback);
}
function $eee21df0c3527ff1$export$3dea766d36a8935f(array, callback) {
    if ($eee21df0c3527ff1$export$51ffaee4afb683a5(array).length !== 1) throw new Error("Only one dimensional matrices supported");
    return Array.prototype.filter.call(array, callback);
}
function $eee21df0c3527ff1$export$322859471e81229d(array, regexp) {
    if ($eee21df0c3527ff1$export$51ffaee4afb683a5(array).length !== 1) throw new Error("Only one dimensional matrices supported");
    return Array.prototype.filter.call(array, (entry)=>regexp.test(entry));
}
function $eee21df0c3527ff1$export$f7e2c8231c57a8bd(array, separator) {
    return Array.prototype.join.call(array, separator);
}
function $eee21df0c3527ff1$export$65e5b62a4c490288(a) {
    if (!Array.isArray(a)) throw new TypeError("Array input expected");
    if (a.length === 0) return a;
    var b = [];
    var count = 0;
    b[0] = {
        value: a[0],
        identifier: 0
    };
    for(var i = 1; i < a.length; i++){
        if (a[i] === a[i - 1]) count++;
        else count = 0;
        b.push({
            value: a[i],
            identifier: count
        });
    }
    return b;
}
function $eee21df0c3527ff1$export$d57ad8b840ad6a01(a) {
    if (!Array.isArray(a)) throw new TypeError("Array input expected");
    if (a.length === 0) return a;
    var b = [];
    for(var i = 0; i < a.length; i++)b.push(a[i].value);
    return b;
}
function $eee21df0c3527ff1$export$d31e00bf4359ea8b(array, typeOf) {
    var type; // to hold type info
    var length = 0; // to hold length value to ensure it has consistent sizes
    for(var i = 0; i < array.length; i++){
        var item = array[i];
        var _isArray = Array.isArray(item);
        // Saving the target matrix row size
        if (i === 0 && _isArray) length = item.length;
        // If the current item is an array but the length does not equal the targetVectorSize
        if (_isArray && item.length !== length) return undefined;
        var itemType = _isArray ? $eee21df0c3527ff1$export$d31e00bf4359ea8b(item, typeOf) // recurse into a nested array
         : typeOf(item);
        if (type === undefined) type = itemType; // first item
        else if (type !== itemType) return "mixed";
    }
    return type;
}
function $eee21df0c3527ff1$export$4c7897fafd92b108(array) {
    return array[array.length - 1];
}
function $eee21df0c3527ff1$export$59ff82fc918bd7e3(array) {
    return array.slice(0, array.length - 1);
}
/**
 * Recursively concatenate two matrices.
 * The contents of the matrices is not cloned.
 * @param {Array} a             Multi dimensional array
 * @param {Array} b             Multi dimensional array
 * @param {number} concatDim    The dimension on which to concatenate (zero-based)
 * @param {number} dim          The current dim (zero-based)
 * @return {Array} c            The concatenated matrix
 * @private
 */ function $eee21df0c3527ff1$var$concatRecursive(a, b, concatDim, dim) {
    if (dim < concatDim) {
        // recurse into next dimension
        if (a.length !== b.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(a.length, b.length);
        var c = [];
        for(var i = 0; i < a.length; i++)c[i] = $eee21df0c3527ff1$var$concatRecursive(a[i], b[i], concatDim, dim + 1);
        return c;
    } else // concatenate this dimension
    return a.concat(b);
}
function $eee21df0c3527ff1$export$ee1b3e54f0441b22() {
    var arrays = Array.prototype.slice.call(arguments, 0, -1);
    var concatDim = Array.prototype.slice.call(arguments, -1);
    if (arrays.length === 1) return arrays[0];
    if (arrays.length > 1) return arrays.slice(1).reduce(function(A, B) {
        return $eee21df0c3527ff1$var$concatRecursive(A, B, concatDim, 0);
    }, arrays[0]);
    else throw new Error("Wrong number of arguments in function concat");
}
function $eee21df0c3527ff1$export$8b730531a4706abd() {
    for(var _len = arguments.length, sizes = new Array(_len), _key = 0; _key < _len; _key++)sizes[_key] = arguments[_key];
    var dimensions = sizes.map((s)=>s.length);
    var N = Math.max(...dimensions);
    var sizeMax = new Array(N).fill(null);
    // check for every size
    for(var i = 0; i < sizes.length; i++){
        var size = sizes[i];
        var dim = dimensions[i];
        for(var j = 0; j < dim; j++){
            var n = N - dim + j;
            if (size[j] > sizeMax[n]) sizeMax[n] = size[j];
        }
    }
    for(var _i = 0; _i < sizes.length; _i++)$eee21df0c3527ff1$export$9da4eac5423f8f77(sizes[_i], sizeMax);
    return sizeMax;
}
function $eee21df0c3527ff1$export$9da4eac5423f8f77(size, toSize) {
    var N = toSize.length;
    var dim = size.length;
    for(var j = 0; j < dim; j++){
        var n = N - dim + j;
        if (size[j] < toSize[n] && size[j] > 1 || size[j] > toSize[n]) throw new Error("shape missmatch: missmatch is found in arg with shape (".concat(size, ") not possible to broadcast dimension ").concat(dim, " with size ").concat(size[j], " to size ").concat(toSize[n]));
    }
}
function $eee21df0c3527ff1$export$ec9086aff2624eab(array, toSize) {
    var Asize = $eee21df0c3527ff1$export$51ffaee4afb683a5(array);
    if ((0, $46a94b3d1146edd8$export$6cc798251952180)(Asize, toSize)) return array;
    $eee21df0c3527ff1$export$9da4eac5423f8f77(Asize, toSize);
    var broadcastedSize = $eee21df0c3527ff1$export$8b730531a4706abd(Asize, toSize);
    var N = broadcastedSize.length;
    var paddedSize = [
        ...Array(N - Asize.length).fill(1),
        ...Asize
    ];
    var A = $eee21df0c3527ff1$export$9cd59f9826255e47(array);
    // reshape A if needed to make it ready for concat
    if (Asize.length < N) {
        A = $eee21df0c3527ff1$export$9eaad88cf88cee2b(A, paddedSize);
        Asize = $eee21df0c3527ff1$export$51ffaee4afb683a5(A);
    }
    // stretches the array on each dimension to make it the same size as index
    for(var dim = 0; dim < N; dim++)if (Asize[dim] < broadcastedSize[dim]) {
        A = $eee21df0c3527ff1$export$1726ea10b1063b9f(A, broadcastedSize[dim], dim);
        Asize = $eee21df0c3527ff1$export$51ffaee4afb683a5(A);
    }
    return A;
}
function $eee21df0c3527ff1$export$fb727ea99e1eb85a() {
    for(var _len2 = arguments.length, arrays = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)arrays[_key2] = arguments[_key2];
    if (arrays.length === 0) throw new Error("Insuficient number of argumnets in function broadcastArrays");
    if (arrays.length === 1) return arrays[0];
    var sizes = arrays.map(function(array) {
        return $eee21df0c3527ff1$export$51ffaee4afb683a5(array);
    });
    var broadcastedSize = $eee21df0c3527ff1$export$8b730531a4706abd(...sizes);
    var broadcastedArrays = [];
    arrays.forEach(function(array) {
        broadcastedArrays.push($eee21df0c3527ff1$export$ec9086aff2624eab(array, broadcastedSize));
    });
    return broadcastedArrays;
}
function $eee21df0c3527ff1$export$1726ea10b1063b9f(arrayToStretch, sizeToStretch, dimToStretch) {
    return $eee21df0c3527ff1$export$ee1b3e54f0441b22(...Array(sizeToStretch).fill(arrayToStretch), dimToStretch);
}
function $eee21df0c3527ff1$export$9cd59f9826255e47(array) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))([], array);
}


/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $18f7dabd54a3c382$export$424b8b2ab9af2944(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
}


function $b3f9e93020d0f987$export$4d8f6a27e2f5bcb2(array) {
    for(var i = 0; i < array.length; i++){
        if ((0, $23cfe017d190638f$export$cea7aa84e978eba5)(array[i])) return true;
    }
    return false;
}
function $b3f9e93020d0f987$export$519ada94592b97fc(array, callback) {
    if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(array)) array = array.valueOf();
    for(var i = 0, ii = array.length; i < ii; i++){
        var value = array[i];
        if (Array.isArray(value)) $b3f9e93020d0f987$export$519ada94592b97fc(value, callback);
        else callback(value);
    }
}
function $b3f9e93020d0f987$export$ce7eaaed37329a1b(array, callback, skipZeros) {
    if (array && typeof array.map === "function") // TODO: replace array.map with a for loop to improve performance
    return array.map(function(x) {
        return $b3f9e93020d0f987$export$ce7eaaed37329a1b(x, callback, skipZeros);
    });
    else return callback(array);
}
function $b3f9e93020d0f987$export$533b26079ad0b4b(mat, dim, callback) {
    var size = Array.isArray(mat) ? (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(mat) : mat.size();
    if (dim < 0 || dim >= size.length) // TODO: would be more clear when throwing a DimensionError here
    throw new (0, $7e61b13fb7752c23$export$efa5eacb1304c464)(dim, size.length);
    if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(mat)) return mat.create($b3f9e93020d0f987$var$_reduce(mat.valueOf(), dim, callback));
    else return $b3f9e93020d0f987$var$_reduce(mat, dim, callback);
}
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $b3f9e93020d0f987$var$_reduce(mat, dim, callback) {
    var i, ret, val, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) {
            val = mat[0];
            for(i = 1; i < mat.length; i++)val = callback(val, mat[i]);
            return val;
        } else {
            tran = (0, $18f7dabd54a3c382$export$424b8b2ab9af2944)(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $b3f9e93020d0f987$var$_reduce(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $b3f9e93020d0f987$var$_reduce(mat[i], dim - 1, callback);
        return ret;
    }
}
function $b3f9e93020d0f987$export$c97954fff4307550(a, j, w, x, u, mark, cindex, f, inverse, update, value) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    // vars
    var k, k0, k1, i;
    // check we need to process values (pattern matrix)
    if (x) // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k];
        // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark;
            // add i to pattern of C
            cindex.push(i);
            // x(i) = A, check we need to call function this time
            if (update) {
                // copy value to workspace calling callback function
                x[i] = inverse ? f(avalues[k], value) : f(value, avalues[k]);
                // function was called on current row
                u[i] = mark;
            } else // copy value to workspace
            x[i] = avalues[k];
        } else {
            // i exists in C already
            x[i] = inverse ? f(avalues[k], x[i]) : f(x[i], avalues[k]);
            // function was called on current row
            u[i] = mark;
        }
    }
    else // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k];
        // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark;
            // add i to pattern of C
            cindex.push(i);
        } else // indicate function was called on current row
        u[i] = mark;
    }
}



var $f38f49d8e24d4a9f$var$n1 = "number";
var $f38f49d8e24d4a9f$var$n2 = "number, number";
function $f38f49d8e24d4a9f$export$59270f717756a93a(a) {
    return Math.abs(a);
}
$f38f49d8e24d4a9f$export$59270f717756a93a.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$d6751d2a3b6da12a(a, b) {
    return a + b;
}
$f38f49d8e24d4a9f$export$d6751d2a3b6da12a.signature = $f38f49d8e24d4a9f$var$n2;
function $f38f49d8e24d4a9f$export$fd8ce9cfca47ace5(a, b) {
    return a - b;
}
$f38f49d8e24d4a9f$export$fd8ce9cfca47ace5.signature = $f38f49d8e24d4a9f$var$n2;
function $f38f49d8e24d4a9f$export$4ad41ac849e391ec(a, b) {
    return a * b;
}
$f38f49d8e24d4a9f$export$4ad41ac849e391ec.signature = $f38f49d8e24d4a9f$var$n2;
function $f38f49d8e24d4a9f$export$58c48a269ab4a155(a, b) {
    return a / b;
}
$f38f49d8e24d4a9f$export$58c48a269ab4a155.signature = $f38f49d8e24d4a9f$var$n2;
function $f38f49d8e24d4a9f$export$339666dc881be46b(x) {
    return -x;
}
$f38f49d8e24d4a9f$export$339666dc881be46b.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$da5b80d388a295fb(x) {
    return x;
}
$f38f49d8e24d4a9f$export$da5b80d388a295fb.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$95c2aecb85f70726(x) {
    return (0, $a246eb207aab6d09$export$841fc4d5a1480b85)(x);
}
$f38f49d8e24d4a9f$export$95c2aecb85f70726.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$9505f0b39acd04c(x) {
    return x * x * x;
}
$f38f49d8e24d4a9f$export$9505f0b39acd04c.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$a33b288b35672fe5(x) {
    return Math.exp(x);
}
$f38f49d8e24d4a9f$export$a33b288b35672fe5.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$756d0c010cecc6c3(x) {
    return (0, $a246eb207aab6d09$export$b6c0a80d46d3391d)(x);
}
$f38f49d8e24d4a9f$export$756d0c010cecc6c3.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$3a8d786b08b3a70c(a, b) {
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(a) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(b)) throw new Error("Parameters in function gcd must be integer numbers");
    // https://en.wikipedia.org/wiki/Euclidean_algorithm
    var r;
    while(b !== 0){
        r = a % b;
        a = b;
        b = r;
    }
    return a < 0 ? -a : a;
}
$f38f49d8e24d4a9f$export$3a8d786b08b3a70c.signature = $f38f49d8e24d4a9f$var$n2;
function $f38f49d8e24d4a9f$export$b55f99ec1f4c5649(a, b) {
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(a) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(b)) throw new Error("Parameters in function lcm must be integer numbers");
    if (a === 0 || b === 0) return 0;
    // https://en.wikipedia.org/wiki/Euclidean_algorithm
    // evaluate lcm here inline to reduce overhead
    var t;
    var prod = a * b;
    while(b !== 0){
        t = b;
        b = a % t;
        a = t;
    }
    return Math.abs(prod / a);
}
$f38f49d8e24d4a9f$export$b55f99ec1f4c5649.signature = $f38f49d8e24d4a9f$var$n2;
function $f38f49d8e24d4a9f$export$4df0e8fcdd5c0927(x, y) {
    if (y) return Math.log(x) / Math.log(y);
    return Math.log(x);
}
function $f38f49d8e24d4a9f$export$e3f8d49574d29dff(x) {
    return (0, $a246eb207aab6d09$export$75e08744a3ff8516)(x);
}
$f38f49d8e24d4a9f$export$e3f8d49574d29dff.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$f9bc93220cfa3c59(x) {
    return (0, $a246eb207aab6d09$export$b9fae0bba9d9094d)(x);
}
$f38f49d8e24d4a9f$export$f9bc93220cfa3c59.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$ae1f56e105ebe4a1(x) {
    return (0, $a246eb207aab6d09$export$144dcf16adfb9698)(x);
}
$f38f49d8e24d4a9f$export$ae1f56e105ebe4a1.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$64b58c5b0372ae95(x, y) {
    // We don't use JavaScript's % operator here as this doesn't work
    // correctly for x < 0 and x === 0
    // see https://en.wikipedia.org/wiki/Modulo_operation
    return y === 0 ? x : x - y * Math.floor(x / y);
}
$f38f49d8e24d4a9f$export$64b58c5b0372ae95.signature = $f38f49d8e24d4a9f$var$n2;
function $f38f49d8e24d4a9f$export$9f26f16bd796a7b3(a) {
    var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var inv = root < 0;
    if (inv) root = -root;
    if (root === 0) throw new Error("Root must be non-zero");
    if (a < 0 && Math.abs(root) % 2 !== 1) throw new Error("Root must be odd when a is negative.");
    // edge cases zero and infinity
    if (a === 0) return inv ? Infinity : 0;
    if (!isFinite(a)) return inv ? 0 : a;
    var x = Math.pow(Math.abs(a), 1 / root);
    // If a < 0, we require that root is an odd integer,
    // so (-1) ^ (1/root) = -1
    x = a < 0 ? -x : x;
    return inv ? 1 / x : x;
// Very nice algorithm, but fails with nthRoot(-2, 3).
// Newton's method has some well-known problems at times:
// https://en.wikipedia.org/wiki/Newton%27s_method#Failure_analysis
/*
  let x = 1 // Initial guess
  let xPrev = 1
  let i = 0
  const iMax = 10000
  do {
    const delta = (a / Math.pow(x, root - 1) - x) / root
    xPrev = x
    x = x + delta
    i++
  }
  while (xPrev !== x && i < iMax)
   if (xPrev !== x) {
    throw new Error('Function nthRoot failed to converge')
  }
   return inv ? 1 / x : x
  */ }
function $f38f49d8e24d4a9f$export$af3d9fe43be78285(x) {
    return (0, $a246eb207aab6d09$export$c5552dfdbc7cec71)(x);
}
$f38f49d8e24d4a9f$export$af3d9fe43be78285.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$aacd0ed14e49886d(x) {
    return Math.sqrt(x);
}
$f38f49d8e24d4a9f$export$aacd0ed14e49886d.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$c4094a156ed9ab35(x) {
    return x * x;
}
$f38f49d8e24d4a9f$export$c4094a156ed9ab35.signature = $f38f49d8e24d4a9f$var$n1;
function $f38f49d8e24d4a9f$export$8cb756a23a623229(a, b) {
    // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
    var t; // used to swap two variables
    var q; // quotient
    var r; // remainder
    var x = 0;
    var lastx = 1;
    var y = 1;
    var lasty = 0;
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(a) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(b)) throw new Error("Parameters in function xgcd must be integer numbers");
    while(b){
        q = Math.floor(a / b);
        r = a - q * b;
        t = x;
        x = lastx - q * x;
        lastx = t;
        t = y;
        y = lasty - q * y;
        lasty = t;
        a = b;
        b = r;
    }
    var res;
    if (a < 0) res = [
        -a,
        -lastx,
        -lasty
    ];
    else res = [
        a,
        a ? lastx : 0,
        lasty
    ];
    return res;
}
$f38f49d8e24d4a9f$export$8cb756a23a623229.signature = $f38f49d8e24d4a9f$var$n2;
function $f38f49d8e24d4a9f$export$3f512e7fd4999e01(x, y) {
    // x^Infinity === 0 if -1 < x < 1
    // A real number 0 is returned instead of complex(0)
    if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
    return Math.pow(x, y);
}
$f38f49d8e24d4a9f$export$3f512e7fd4999e01.signature = $f38f49d8e24d4a9f$var$n2;
function $f38f49d8e24d4a9f$export$a3992db8dd0fd9e6(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(decimals) || decimals < 0 || decimals > 15) throw new Error("Number of decimals in function round must be an integer from 0 to 15 inclusive");
    return parseFloat((0, $a246eb207aab6d09$export$a81f732198733497)(value, decimals));
}
function $f38f49d8e24d4a9f$export$d78ecacee56245ec(x) {
    return Math.abs(x);
}
$f38f49d8e24d4a9f$export$d78ecacee56245ec.signature = $f38f49d8e24d4a9f$var$n1;


var $63f22a9e6164e359$var$name = "abs";
var $63f22a9e6164e359$var$dependencies = [
    "typed"
];
var $63f22a9e6164e359$export$dd8a9b3843a4df95 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($63f22a9e6164e359$var$name, $63f22a9e6164e359$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the absolute value of a number. For matrices, the function is
   * evaluated element wise.
   *
   * Syntax:
   *
   *    math.abs(x)
   *
   * Examples:
   *
   *    math.abs(3.5)                // returns number 3.5
   *    math.abs(-4.2)               // returns number 4.2
   *
   *    math.abs([3, -5, -1, 0, 2])  // returns Array [3, 5, 1, 0, 2]
   *
   * See also:
   *
   *    sign
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Array | Matrix | Unit} x
   *            A number or matrix for which to get the absolute value
   * @return {number | BigNumber | bigint | Fraction | Complex | Array | Matrix | Unit}
   *            Absolute value of `x`
   */ return typed($63f22a9e6164e359$var$name, {
        number: (0, $f38f49d8e24d4a9f$export$59270f717756a93a),
        "Complex | BigNumber | Fraction | Unit": (x)=>x.abs(),
        bigint: (x)=>x < 0n ? -x : x,
        // deep map collection, skip zeros since abs(0) = 0
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self, true))
    });
});


var $225e3a2952854876$var$name = "acos";
var $225e3a2952854876$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $225e3a2952854876$export$33da46c5ece67581 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($225e3a2952854876$var$name, $225e3a2952854876$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the inverse cosine of a value.
   *
   * To avoid confusion with the matrix arccosine, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.acos(x)
   *
   * Examples:
   *
   *    math.acos(0.5)           // returns number 1.0471975511965979
   *    math.acos(math.cos(1.5)) // returns number 1.5
   *
   *    math.acos(2)             // returns Complex 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    cos, atan, asin
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} The arc cosine of x
   */ return typed($225e3a2952854876$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.acos(x);
            else return new Complex(x, 0).acos();
        },
        Complex: function Complex(x) {
            return x.acos();
        },
        BigNumber: function BigNumber(x) {
            return x.acos();
        }
    });
});



var $08edde3ad76e4ae3$var$n1 = "number";
var $08edde3ad76e4ae3$var$n2 = "number, number";
function $08edde3ad76e4ae3$export$99a14685a3a2b607(x) {
    return Math.acos(x);
}
$08edde3ad76e4ae3$export$99a14685a3a2b607.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$84088556f7d2d0be(x) {
    return (0, $a246eb207aab6d09$export$b26caf0f29211d08)(x);
}
$08edde3ad76e4ae3$export$84088556f7d2d0be.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$ba80ccbf024897ef(x) {
    return Math.atan(1 / x);
}
$08edde3ad76e4ae3$export$ba80ccbf024897ef.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$e2be1aa5d5a3f81(x) {
    return isFinite(x) ? (Math.log((x + 1) / x) + Math.log(x / (x - 1))) / 2 : 0;
}
$08edde3ad76e4ae3$export$e2be1aa5d5a3f81.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$e3b67a6e3df3fd81(x) {
    return Math.asin(1 / x);
}
$08edde3ad76e4ae3$export$e3b67a6e3df3fd81.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$51cd224337b2c783(x) {
    var xInv = 1 / x;
    return Math.log(xInv + Math.sqrt(xInv * xInv + 1));
}
$08edde3ad76e4ae3$export$51cd224337b2c783.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$5ec3930177455ade(x) {
    return Math.acos(1 / x);
}
$08edde3ad76e4ae3$export$5ec3930177455ade.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$cf144300ea173362(x) {
    var xInv = 1 / x;
    var ret = Math.sqrt(xInv * xInv - 1);
    return Math.log(ret + xInv);
}
$08edde3ad76e4ae3$export$cf144300ea173362.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$444ef2855488a2d5(x) {
    return Math.asin(x);
}
$08edde3ad76e4ae3$export$444ef2855488a2d5.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$3a027485d3336d8d(x) {
    return (0, $a246eb207aab6d09$export$839d8a01b6af4fc0)(x);
}
$08edde3ad76e4ae3$export$3a027485d3336d8d.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$c38dcb11df4699c0(x) {
    return Math.atan(x);
}
$08edde3ad76e4ae3$export$c38dcb11df4699c0.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$a97666a135b540f9(y, x) {
    return Math.atan2(y, x);
}
$08edde3ad76e4ae3$export$a97666a135b540f9.signature = $08edde3ad76e4ae3$var$n2;
function $08edde3ad76e4ae3$export$44a1f653c6513db8(x) {
    return (0, $a246eb207aab6d09$export$21ea955025ceb08b)(x);
}
$08edde3ad76e4ae3$export$44a1f653c6513db8.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$8d04496be3e647d4(x) {
    return Math.cos(x);
}
$08edde3ad76e4ae3$export$8d04496be3e647d4.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$7cf8db0cff734545(x) {
    return (0, $a246eb207aab6d09$export$2e2fd1ad24e4d350)(x);
}
$08edde3ad76e4ae3$export$7cf8db0cff734545.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$515b39f7fd07e09f(x) {
    return 1 / Math.tan(x);
}
$08edde3ad76e4ae3$export$515b39f7fd07e09f.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$925affe88b2512fc(x) {
    var e = Math.exp(2 * x);
    return (e + 1) / (e - 1);
}
$08edde3ad76e4ae3$export$925affe88b2512fc.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$5a8409ad16e318b2(x) {
    return 1 / Math.sin(x);
}
$08edde3ad76e4ae3$export$5a8409ad16e318b2.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$143835b5c1db9790(x) {
    // consider values close to zero (+/-)
    if (x === 0) return Number.POSITIVE_INFINITY;
    else return Math.abs(2 / (Math.exp(x) - Math.exp(-x))) * (0, $a246eb207aab6d09$export$c5552dfdbc7cec71)(x);
}
$08edde3ad76e4ae3$export$143835b5c1db9790.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$ee1efc70bd8a6d93(x) {
    return 1 / Math.cos(x);
}
$08edde3ad76e4ae3$export$ee1efc70bd8a6d93.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$b83345d70fe4a871(x) {
    return 2 / (Math.exp(x) + Math.exp(-x));
}
$08edde3ad76e4ae3$export$b83345d70fe4a871.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$b6e96f13f41c8816(x) {
    return Math.sin(x);
}
$08edde3ad76e4ae3$export$b6e96f13f41c8816.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$89648c4ce0d79e70(x) {
    return (0, $a246eb207aab6d09$export$545004b505d7c555)(x);
}
$08edde3ad76e4ae3$export$89648c4ce0d79e70.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$ecbd7b3271ebce16(x) {
    return Math.tan(x);
}
$08edde3ad76e4ae3$export$ecbd7b3271ebce16.signature = $08edde3ad76e4ae3$var$n1;
function $08edde3ad76e4ae3$export$70e2e2cc9c2555e4(x) {
    return (0, $a246eb207aab6d09$export$7128670e45beef9a)(x);
}
$08edde3ad76e4ae3$export$70e2e2cc9c2555e4.signature = $08edde3ad76e4ae3$var$n1;


var $88b48448acc5d82b$var$name = "acosh";
var $88b48448acc5d82b$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $88b48448acc5d82b$export$c634796792055579 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($88b48448acc5d82b$var$name, $88b48448acc5d82b$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the hyperbolic arccos of a value,
   * defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acosh(x)
   *
   * Examples:
   *
   *    math.acosh(1.5)       // returns 0.9624236501192069
   *
   * See also:
   *
   *    cosh, asinh, atanh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arccosine of x
   */ return typed($88b48448acc5d82b$var$name, {
        number: function number(x) {
            if (x >= 1 || config.predictable) return (0, $08edde3ad76e4ae3$export$84088556f7d2d0be)(x);
            if (x <= -1) return new Complex(Math.log(Math.sqrt(x * x - 1) - x), Math.PI);
            return new Complex(x, 0).acosh();
        },
        Complex: function Complex(x) {
            return x.acosh();
        },
        BigNumber: function BigNumber(x) {
            return x.acosh();
        }
    });
});



var $47b4cd57dd8bb923$var$name = "acot";
var $47b4cd57dd8bb923$var$dependencies = [
    "typed",
    "BigNumber"
];
var $47b4cd57dd8bb923$export$8a6845771325148e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($47b4cd57dd8bb923$var$name, $47b4cd57dd8bb923$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse cotangent of a value, defined as `acot(x) = atan(1/x)`.
   *
   * To avoid confusion with the matrix arccotanget, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.acot(x)
   *
   * Examples:
   *
   *    math.acot(0.5)           // returns number 1.1071487177940904
   *    math.acot(2)             // returns number 0.4636476090008061
   *    math.acot(math.cot(1.5)) // returns number 1.5
   *
   * See also:
   *
   *    cot, atan
   *
   * @param {number | BigNumber| Complex} x   Function input
   * @return {number | BigNumber| Complex} The arc cotangent of x
   */ return typed($47b4cd57dd8bb923$var$name, {
        number: (0, $08edde3ad76e4ae3$export$ba80ccbf024897ef),
        Complex: function Complex(x) {
            return x.acot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atan();
        }
    });
});



var $1b6d9001976447ee$var$name = "acoth";
var $1b6d9001976447ee$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $1b6d9001976447ee$export$67e40c7fd8f5703a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($1b6d9001976447ee$var$name, $1b6d9001976447ee$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arccotangent of a value,
   * defined as `acoth(x) = atanh(1/x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.
   *
   * To avoid confusion with the matrix hyperbolic arccotangent, this
   * function does not apply to matrices.
   *
   * Syntax:
   *
   *    math.acoth(x)
   *
   * Examples:
   *
   *    math.acoth(0.5)       // returns 0.8047189562170503
   *
   * See also:
   *
   *    acsch, asech
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arccotangent of x
   */ return typed($1b6d9001976447ee$var$name, {
        number: function number(x) {
            if (x >= 1 || x <= -1 || config.predictable) return (0, $08edde3ad76e4ae3$export$e2be1aa5d5a3f81)(x);
            return new Complex(x, 0).acoth();
        },
        Complex: function Complex(x) {
            return x.acoth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atanh();
        }
    });
});



var $b9098f3d66ec7d96$var$name = "acsc";
var $b9098f3d66ec7d96$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $b9098f3d66ec7d96$export$95580581b134a5bd = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b9098f3d66ec7d96$var$name, $b9098f3d66ec7d96$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse cosecant of a value, defined as `acsc(x) = asin(1/x)`.
   *
   * To avoid confusion with the matrix arccosecant, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.acsc(x)
   *
   * Examples:
   *
   *    math.acsc(2)             // returns 0.5235987755982989
   *    math.acsc(0.5)           // returns Complex 1.5707963267948966 -1.3169578969248166i
   *    math.acsc(math.csc(1.5)) // returns number ~1.5
   *
   * See also:
   *
   *    csc, asin, asec
   *
   * @param {number | BigNumber | Complex} x   Function input
   * @return {number | BigNumber | Complex} The arc cosecant of x
   */ return typed($b9098f3d66ec7d96$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $08edde3ad76e4ae3$export$e3b67a6e3df3fd81)(x);
            return new Complex(x, 0).acsc();
        },
        Complex: function Complex(x) {
            return x.acsc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asin();
        }
    });
});



var $8896d6756d422141$var$name = "acsch";
var $8896d6756d422141$var$dependencies = [
    "typed",
    "BigNumber"
];
var $8896d6756d422141$export$d6534043a40dc59 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($8896d6756d422141$var$name, $8896d6756d422141$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arccosecant of a value,
   * defined as `acsch(x) = asinh(1/x) = ln(1/x + sqrt(1/x^2 + 1))`.
   *
   * To avoid confusion with the matrix hyperbolic arccosecant, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.acsch(x)
   *
   * Examples:
   *
   *    math.acsch(0.5)       // returns 1.4436354751788103
   *
   * See also:
   *
   *    asech, acoth
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arccosecant of x
   */ return typed($8896d6756d422141$var$name, {
        number: (0, $08edde3ad76e4ae3$export$51cd224337b2c783),
        Complex: function Complex(x) {
            return x.acsch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asinh();
        }
    });
});




var $a0c1a11a7836c6b2$var$name = "matAlgo01xDSid";
var $a0c1a11a7836c6b2$var$dependencies = [
    "typed"
];
var $a0c1a11a7836c6b2$export$727ab96f88a9e651 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a0c1a11a7836c6b2$var$name, $a0c1a11a7836c6b2$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  Dij          ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm1(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype || denseMatrix.getDataType();
        // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype || sparseMatrix._data === undefined ? sparseMatrix._datatype : sparseMatrix.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
        // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // process data types
        var dt = typeof adt === "string" && adt !== "mixed" && adt === bdt ? adt : undefined;
        // callback function
        var cf = dt ? typed.find(callback, [
            dt,
            dt
        ]) : callback;
        // vars
        var i, j;
        // result (DenseMatrix)
        var cdata = [];
        // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
        // workspace
        var x = [];
        // marks indicating we have a value in x for a given column
        var w = [];
        // loop columns in b
        for(j = 0; j < columns; j++){
            // column mark
            var mark = j + 1;
            // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k];
                // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
                // mark i as updated
                w[i] = mark;
            }
            // loop rows
            for(i = 0; i < rows; i++)// check row is in workspace
            if (w[i] === mark) // c[i][j] was already calculated
            cdata[i][j] = x[i];
            else // item does not exist in S
            cdata[i][j] = adata[i][j];
        }
        // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: adt === denseMatrix._datatype && bdt === sparseMatrix._datatype ? dt : undefined
        });
    };
});




var $64a06aca87feb287$var$name = "matAlgo04xSidSid";
var $64a06aca87feb287$var$dependencies = [
    "typed",
    "equalScalar"
];
var $64a06aca87feb287$export$1dd33d839e34f63c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($64a06aca87feb287$var$name, $64a06aca87feb287$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0 && B(i,j) === 0
   *          └  B(i,j)       ; A(i,j) === 0
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function matAlgo04xSidSid(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string" && adt === bdt && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // workspace
        var xa = avalues && bvalues ? [] : undefined;
        var xb = avalues && bvalues ? [] : undefined;
        // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = [];
        // vars
        var i, j, k, k0, k1;
        // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // columns mark
            var mark = j + 1;
            // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k];
                // update c
                cindex.push(i);
                // update workspace
                wa[i] = mark;
                // check we need to process values
                if (xa) xa[i] = avalues[k];
            }
            // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k];
                // check row exists in A
                if (wa[i] === mark) // update record in xa @ i
                {
                    if (xa) {
                        // invoke callback
                        var v = cf(xa[i], bvalues[k]);
                        // check for zero
                        if (!eq(v, zero)) // update workspace
                        xa[i] = v;
                        else // remove mark (index will be removed later)
                        wa[i] = null;
                    }
                } else {
                    // update c
                    cindex.push(i);
                    // update workspace
                    wb[i] = mark;
                    // check we need to process values
                    if (xb) xb[i] = bvalues[k];
                }
            }
            // check we need to process values (non pattern matrix)
            if (xa && xb) {
                // initialize first index in j
                k = cptr[j];
                // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k];
                    // check workspace has value @ i
                    if (wa[i] === mark) {
                        // push value (Aij != 0 || (Aij != 0 && Bij != 0))
                        cvalues[k] = xa[i];
                        // increment pointer
                        k++;
                    } else if (wb[i] === mark) {
                        // push value (bij != 0)
                        cvalues[k] = xb[i];
                        // increment pointer
                        k++;
                    } else // remove index @ k
                    cindex.splice(k, 1);
                }
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
});



var $00357ab6509f98c8$var$name = "matAlgo10xSids";
var $00357ab6509f98c8$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $00357ab6509f98c8$export$5295edae9a41ff00 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($00357ab6509f98c8$var$name, $00357ab6509f98c8$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  b          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function matAlgo10xSids(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype;
        // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt;
            // convert b to the same datatype
            b = typed.convert(b, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cdata = [];
        // workspaces
        var x = [];
        // marks indicating we have a value in x for a given column
        var w = [];
        // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1;
            // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k];
                // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            }
            // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = b;
            }
        }
        // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});






var $af015c5e2a3a9d50$var$name = "matAlgo13xDD";
var $af015c5e2a3a9d50$var$dependencies = [
    "typed"
];
var $af015c5e2a3a9d50$export$bd1609c374d6d636 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($af015c5e2a3a9d50$var$name, $af015c5e2a3a9d50$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, Bij..z).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, Bij..z)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Matrix}   b                 The DenseMatrix instance (B)
   * @param {Function} callback          The f(Aij..z,Bij..z) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97658658
   */ return function matAlgo13xDD(a, b, callback) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype;
        // b arrays
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype;
        // c arrays
        var csize = [];
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(asize.length, bsize.length);
        // validate each one of the dimension sizes
        for(var s = 0; s < asize.length; s++){
            // must match
            if (asize[s] !== bsize[s]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
            // update dimension in c
            csize[s] = asize[s];
        }
        // datatype
        var dt;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt;
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // populate cdata, iterate through dimensions
        var cdata = csize.length > 0 ? _iterate(cf, 0, csize, csize[0], adata, bdata) : [];
        // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: csize,
            datatype: dt
        });
    };
    // recursive function
    function _iterate(f, level, s, n, av, bv) {
        // initialize array for this level
        var cv = [];
        // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = f(av[i], bv[i]);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv[j]);
        return cv;
    }
});




var $ada7281b5c8c5fa6$var$name = "matAlgo14xDs";
var $ada7281b5c8c5fa6$var$dependencies = [
    "typed"
];
var $ada7281b5c8c5fa6$export$4b07063314120f7c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($ada7281b5c8c5fa6$var$name, $ada7281b5c8c5fa6$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, b).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, b)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij..z,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Aij..z)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97659042
   */ return function matAlgo14xDs(a, b, callback, inverse) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype;
        // datatype
        var dt;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt;
            // convert b to the same datatype
            b = typed.convert(b, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // populate cdata, iterate through dimensions
        var cdata = asize.length > 0 ? _iterate(cf, 0, asize, asize[0], adata, b, inverse) : [];
        // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(asize),
            datatype: dt
        });
    };
    // recursive function
    function _iterate(f, level, s, n, av, bv, inverse) {
        // initialize array for this level
        var cv = [];
        // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = inverse ? f(bv, av[i]) : f(av[i], bv);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv, inverse);
        return cv;
    }
});




function $74e248c5c2f15c40$export$24d33a6f4bffea69(A, B) {
    if ((0, $46a94b3d1146edd8$export$6cc798251952180)(A.size(), B.size())) // If matrices have the same size return them
    return [
        A,
        B
    ];
    // calculate the broadcasted sizes
    var newSize = (0, $eee21df0c3527ff1$export$8b730531a4706abd)(A.size(), B.size());
    // return the array with the two broadcasted matrices
    return [
        A,
        B
    ].map((M)=>$74e248c5c2f15c40$var$_broadcastTo(M, newSize));
}
/**
 * Broadcasts a matrix to the given size.
 *
 * @param {Matrix} M - The matrix to be broadcasted.
 * @param {number[]} size - The desired size of the broadcasted matrix.
 * @returns {Matrix} The broadcasted matrix.
 * @throws {Error} If the size parameter is not an array of numbers.
 */ function $74e248c5c2f15c40$var$_broadcastTo(M, size) {
    if ((0, $46a94b3d1146edd8$export$6cc798251952180)(M.size(), size)) return M;
    return M.create((0, $eee21df0c3527ff1$export$ec9086aff2624eab)(M.valueOf(), size), M.datatype());
}


var $14cb5501dcbd1d68$var$name = "matrixAlgorithmSuite";
var $14cb5501dcbd1d68$var$dependencies = [
    "typed",
    "matrix"
];
var $14cb5501dcbd1d68$export$16b92d4ea17760ac = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($14cb5501dcbd1d68$var$name, $14cb5501dcbd1d68$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    var matAlgo13xDD = (0, $af015c5e2a3a9d50$export$bd1609c374d6d636)({
        typed: typed
    });
    var matAlgo14xDs = (0, $ada7281b5c8c5fa6$export$4b07063314120f7c)({
        typed: typed
    });
    /**
   * Return a signatures object with the usual boilerplate of
   * matrix algorithms, based on a plain options object with the
   * following properties:
   *   elop: function -- the elementwise operation to use, defaults to self
   *   SS: function -- the algorithm to apply for two sparse matrices
   *   DS: function -- the algorithm to apply for a dense and a sparse matrix
   *   SD: function -- algo for a sparse and a dense; defaults to SD flipped
   *   Ss: function -- the algorithm to apply for a sparse matrix and scalar
   *   sS: function -- algo for scalar and sparse; defaults to Ss flipped
   *   scalar: string -- typed-function type for scalars, defaults to 'any'
   *
   * If Ss is not specified, no matrix-scalar signatures are generated.
   *
   * @param {object} options
   * @return {Object<string, function>} signatures
   */ return function matrixAlgorithmSuite(options) {
        var elop = options.elop;
        var SD = options.SD || options.DS;
        var matrixSignatures;
        if (elop) {
            // First the dense ones
            matrixSignatures = {
                "DenseMatrix, DenseMatrix": (x, y)=>matAlgo13xDD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(x, y), elop),
                "Array, Array": (x, y)=>matAlgo13xDD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(matrix(x), matrix(y)), elop).valueOf(),
                "Array, DenseMatrix": (x, y)=>matAlgo13xDD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(matrix(x), y), elop),
                "DenseMatrix, Array": (x, y)=>matAlgo13xDD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(x, matrix(y)), elop)
            };
            // Now incorporate sparse matrices
            if (options.SS) matrixSignatures["SparseMatrix, SparseMatrix"] = (x, y)=>options.SS(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(x, y), elop, false);
            if (options.DS) {
                matrixSignatures["DenseMatrix, SparseMatrix"] = (x, y)=>options.DS(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(x, y), elop, false);
                matrixSignatures["Array, SparseMatrix"] = (x, y)=>options.DS(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(matrix(x), y), elop, false);
            }
            if (SD) {
                matrixSignatures["SparseMatrix, DenseMatrix"] = (x, y)=>SD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(y, x), elop, true);
                matrixSignatures["SparseMatrix, Array"] = (x, y)=>SD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(matrix(y), x), elop, true);
            }
        } else {
            // No elop, use this
            // First the dense ones
            matrixSignatures = {
                "DenseMatrix, DenseMatrix": typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo13xDD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(x, y), self);
                    }),
                "Array, Array": typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo13xDD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(matrix(x), matrix(y)), self).valueOf();
                    }),
                "Array, DenseMatrix": typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo13xDD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(matrix(x), y), self);
                    }),
                "DenseMatrix, Array": typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo13xDD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(x, matrix(y)), self);
                    })
            };
            // Now incorporate sparse matrices
            if (options.SS) matrixSignatures["SparseMatrix, SparseMatrix"] = typed.referToSelf((self)=>(x, y)=>{
                    return options.SS(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(x, y), self, false);
                });
            if (options.DS) {
                matrixSignatures["DenseMatrix, SparseMatrix"] = typed.referToSelf((self)=>(x, y)=>{
                        return options.DS(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(x, y), self, false);
                    });
                matrixSignatures["Array, SparseMatrix"] = typed.referToSelf((self)=>(x, y)=>{
                        return options.DS(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(matrix(x), y), self, false);
                    });
            }
            if (SD) {
                matrixSignatures["SparseMatrix, DenseMatrix"] = typed.referToSelf((self)=>(x, y)=>{
                        return SD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(y, x), self, true);
                    });
                matrixSignatures["SparseMatrix, Array"] = typed.referToSelf((self)=>(x, y)=>{
                        return SD(...(0, $74e248c5c2f15c40$export$24d33a6f4bffea69)(matrix(y), x), self, true);
                    });
            }
        }
        // Now add the scalars
        var scalar = options.scalar || "any";
        var Ds = options.Ds || options.Ss;
        if (Ds) {
            if (elop) {
                matrixSignatures["DenseMatrix," + scalar] = (x, y)=>matAlgo14xDs(x, y, elop, false);
                matrixSignatures[scalar + ", DenseMatrix"] = (x, y)=>matAlgo14xDs(y, x, elop, true);
                matrixSignatures["Array," + scalar] = (x, y)=>matAlgo14xDs(matrix(x), y, elop, false).valueOf();
                matrixSignatures[scalar + ", Array"] = (x, y)=>matAlgo14xDs(matrix(y), x, elop, true).valueOf();
            } else {
                matrixSignatures["DenseMatrix," + scalar] = typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo14xDs(x, y, self, false);
                    });
                matrixSignatures[scalar + ", DenseMatrix"] = typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo14xDs(y, x, self, true);
                    });
                matrixSignatures["Array," + scalar] = typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo14xDs(matrix(x), y, self, false).valueOf();
                    });
                matrixSignatures[scalar + ", Array"] = typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo14xDs(matrix(y), x, self, true).valueOf();
                    });
            }
        }
        var sS = options.sS !== undefined ? options.sS : options.Ss;
        if (elop) {
            if (options.Ss) matrixSignatures["SparseMatrix," + scalar] = (x, y)=>options.Ss(x, y, elop, false);
            if (sS) matrixSignatures[scalar + ", SparseMatrix"] = (x, y)=>sS(y, x, elop, true);
        } else {
            if (options.Ss) matrixSignatures["SparseMatrix," + scalar] = typed.referToSelf((self)=>(x, y)=>{
                    return options.Ss(x, y, self, false);
                });
            if (sS) matrixSignatures[scalar + ", SparseMatrix"] = typed.referToSelf((self)=>(x, y)=>{
                    return sS(y, x, self, true);
                });
        }
        // Also pull in the scalar signatures if the operator is a typed function
        if (elop && elop.signatures) (0, $46a94b3d1146edd8$export$8b58be045bf06082)(matrixSignatures, elop.signatures);
        return matrixSignatures;
    };
});


var $470766fdb1b0259b$var$name = "add";
var $470766fdb1b0259b$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "equalScalar",
    "DenseMatrix",
    "SparseMatrix",
    "concat"
];
var $470766fdb1b0259b$export$c6b51545da64d82f = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($470766fdb1b0259b$var$name, $470766fdb1b0259b$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $a0c1a11a7836c6b2$export$727ab96f88a9e651)({
        typed: typed
    });
    var matAlgo04xSidSid = (0, $64a06aca87feb287$export$1dd33d839e34f63c)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $00357ab6509f98c8$export$5295edae9a41ff00)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
  * Add two or more values, `x + y`.
  * For matrices, the function is evaluated element wise.
  *
  * Syntax:
  *
  *    math.add(x, y)
  *    math.add(x, y, z, ...)
  *
  * Examples:
  *
  *    math.add(2, 3)               // returns number 5
  *    math.add(2, 3, 4)            // returns number 9
  *
  *    const a = math.complex(2, 3)
  *    const b = math.complex(-4, 1)
  *    math.add(a, b)               // returns Complex -2 + 4i
  *
  *    math.add([1, 2, 3], 4)       // returns Array [5, 6, 7]
  *
  *    const c = math.unit('5 cm')
  *    const d = math.unit('2.1 mm')
  *    math.add(c, d)               // returns Unit 52.1 mm
  *
  *    math.add("2.3", "4")         // returns number 6.3
  *
  * See also:
  *
  *    subtract, sum
  *
  * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} x First value to add
  * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} y Second value to add
  * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} Sum of `x` and `y`
  */ return typed($470766fdb1b0259b$var$name, {
        "any, any": addScalar,
        "any, any, ...any": typed.referToSelf((self)=>(x, y, rest)=>{
                var result = self(x, y);
                for(var i = 0; i < rest.length; i++)result = self(result, rest[i]);
                return result;
            })
    }, matrixAlgorithmSuite({
        elop: addScalar,
        DS: matAlgo01xDSid,
        SS: matAlgo04xSidSid,
        Ss: matAlgo10xSids
    }));
});



var $2b6c00a128174602$var$name = "addScalar";
var $2b6c00a128174602$var$dependencies = [
    "typed"
];
var $2b6c00a128174602$export$bbebd809b9ccc50b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($2b6c00a128174602$var$name, $2b6c00a128174602$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Add two scalar values, `x + y`.
   * This function is meant for internal use: it is used by the public function
   * `add`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x   First value to add
   * @param  {number | BigNumber | bigint | Fraction | Complex} y          Second value to add
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit}     Sum of `x` and `y`
   * @private
   */ return typed($2b6c00a128174602$var$name, {
        "number, number": (0, $f38f49d8e24d4a9f$export$d6751d2a3b6da12a),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.add(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.plus(y);
        },
        "bigint, bigint": function bigintBigint(x, y) {
            return x + y;
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.add(y);
        },
        "Unit, Unit": typed.referToSelf((self)=>(x, y)=>{
                if (x.value === null || x.value === undefined) throw new Error("Parameter x contains a unit with undefined value");
                if (y.value === null || y.value === undefined) throw new Error("Parameter y contains a unit with undefined value");
                if (!x.equalBase(y)) throw new Error("Units do not match");
                var res = x.clone();
                res.value = typed.find(self, [
                    res.valueType(),
                    y.valueType()
                ])(res.value, y.value);
                res.fixPrefix = false;
                return res;
            })
    });
});



var $94e325bf4fc92f8c$var$name = "matAlgo02xDS0";
var $94e325bf4fc92f8c$var$dependencies = [
    "typed",
    "equalScalar"
];
var $94e325bf4fc92f8c$export$32ae34d6563cd126 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($94e325bf4fc92f8c$var$name, $94e325bf4fc92f8c$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function matAlgo02xDS0(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype || denseMatrix.getDataType();
        // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype || sparseMatrix._data === undefined ? sparseMatrix._datatype : sparseMatrix.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
        // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string" && adt === bdt && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result (SparseMatrix)
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // loop columns in b
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k];
                // update C(i,j)
                var cij = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
                // check for nonzero
                if (!eq(cij, zero)) {
                    // push i & v
                    cindex.push(i);
                    cvalues.push(cij);
                }
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return sparseMatrix.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === denseMatrix._datatype && bdt === sparseMatrix._datatype ? dt : undefined
        });
    };
});



var $f2f17e08f891b9a8$var$name = "matAlgo11xS0s";
var $f2f17e08f891b9a8$var$dependencies = [
    "typed",
    "equalScalar"
];
var $f2f17e08f891b9a8$export$b315efa10530691e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f2f17e08f891b9a8$var$name, $f2f17e08f891b9a8$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function matAlgo11xS0s(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype;
        // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // convert b to the same datatype
            b = typed.convert(b, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // loop columns
        for(var j = 0; j < columns; j++){
            // initialize ptr
            cptr[j] = cindex.length;
            // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = aindex[k];
                // invoke callback
                var v = inverse ? cf(b, avalues[k]) : cf(avalues[k], b);
                // check value is zero
                if (!eq(v, zero)) {
                    // push index & value
                    cindex.push(i);
                    cvalues.push(v);
                }
            }
        }
        // update ptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return s.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});






var $bc13b8f894d6d714$var$name = "matAlgo06xS0S0";
var $bc13b8f894d6d714$var$dependencies = [
    "typed",
    "equalScalar"
];
var $bc13b8f894d6d714$export$7e944de5217ad25 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($bc13b8f894d6d714$var$name, $bc13b8f894d6d714$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked (Anz U Bnz) times, where Anz and Bnz are the nonzero elements in both matrices.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function matAlgo06xS0S0(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // sparse matrix arrays
        var bvalues = b._values;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string" && adt === bdt && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // workspaces
        var x = cvalues ? [] : undefined;
        // marks indicating we have a value in x for a given column
        var w = [];
        // marks indicating value in a given row has been updated
        var u = [];
        // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // columns mark
            var mark = j + 1;
            // scatter the values of A(:,j) into workspace
            (0, $b3f9e93020d0f987$export$c97954fff4307550)(a, j, w, x, u, mark, cindex, cf);
            // scatter the values of B(:,j) into workspace
            (0, $b3f9e93020d0f987$export$c97954fff4307550)(b, j, w, x, u, mark, cindex, cf);
            // check we need to process values (non pattern matrix)
            if (x) {
                // initialize first index in j
                var k = cptr[j];
                // loop index in j
                while(k < cindex.length){
                    // row
                    var i = cindex[k];
                    // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[i] === mark) {
                        // value @ i
                        var v = x[i];
                        // check for zero value
                        if (!eq(v, zero)) {
                            // push value
                            cvalues.push(v);
                            // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    } else // remove value @ i, do not increment pointer
                    cindex.splice(k, 1);
                }
            } else {
                // initialize first index in j
                var p = cptr[j];
                // loop index in j
                while(p < cindex.length){
                    // row
                    var r = cindex[p];
                    // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[r] !== mark) // remove value @ i, do not increment pointer
                    cindex.splice(p, 1);
                    else // increment pointer
                    p++;
                }
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
});




var $89192b5d651983ac$var$n1 = "number";
var $89192b5d651983ac$var$n2 = "number, number";
function $89192b5d651983ac$export$5c3e9fce4e8f3d3a(x) {
    return !x;
}
$89192b5d651983ac$export$5c3e9fce4e8f3d3a.signature = $89192b5d651983ac$var$n1;
function $89192b5d651983ac$export$cb9e31d07eec8012(x, y) {
    return !!(x || y);
}
$89192b5d651983ac$export$cb9e31d07eec8012.signature = $89192b5d651983ac$var$n2;
function $89192b5d651983ac$export$17cc7dc3a74df3af(x, y) {
    return !!x !== !!y;
}
$89192b5d651983ac$export$17cc7dc3a74df3af.signature = $89192b5d651983ac$var$n2;
function $89192b5d651983ac$export$11dffb061e00e795(x, y) {
    return !!(x && y);
}
$89192b5d651983ac$export$11dffb061e00e795.signature = $89192b5d651983ac$var$n2;


var $b2c13d33c3f9595a$var$name = "and";
var $b2c13d33c3f9595a$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "not",
    "concat"
];
var $b2c13d33c3f9595a$export$15a698d88cae0eff = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b2c13d33c3f9595a$var$name, $b2c13d33c3f9595a$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, not: not, concat: concat } = _ref;
    var matAlgo02xDS0 = (0, $94e325bf4fc92f8c$export$32ae34d6563cd126)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo06xS0S0 = (0, $bc13b8f894d6d714$export$7e944de5217ad25)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $ada7281b5c8c5fa6$export$4b07063314120f7c)({
        typed: typed
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Logical `and`. Test whether two values are both defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.and(x, y)
   *
   * Examples:
   *
   *    math.and(2, 4)   // returns true
   *
   *    a = [2, 0, 0]
   *    b = [3, 7, 0]
   *    c = 0
   *
   *    math.and(a, b)   // returns [true, false, false]
   *    math.and(a, c)   // returns [false, false, false]
   *
   * See also:
   *
   *    not, or, xor
   *
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when both inputs are defined with a nonzero/nonempty value.
   */ return typed($b2c13d33c3f9595a$var$name, {
        "number, number": (0, $89192b5d651983ac$export$11dffb061e00e795),
        "Complex, Complex": function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) && (y.re !== 0 || y.im !== 0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return !x.isZero() && !y.isZero() && !x.isNaN() && !y.isNaN();
        },
        "bigint, bigint": (0, $89192b5d651983ac$export$11dffb061e00e795),
        "Unit, Unit": typed.referToSelf((self)=>(x, y)=>self(x.value || 0, y.value || 0)),
        "SparseMatrix, any": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (not(y)) // return zero matrix
                return zeros(x.size(), x.storage());
                return matAlgo11xS0s(x, y, self, false);
            }),
        "DenseMatrix, any": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (not(y)) // return zero matrix
                return zeros(x.size(), x.storage());
                return matAlgo14xDs(x, y, self, false);
            }),
        "any, SparseMatrix": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (not(x)) // return zero matrix
                return zeros(x.size(), x.storage());
                return matAlgo11xS0s(y, x, self, true);
            }),
        "any, DenseMatrix": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (not(x)) // return zero matrix
                return zeros(x.size(), x.storage());
                return matAlgo14xDs(y, x, self, true);
            }),
        "Array, any": typed.referToSelf((self)=>(x, y)=>{
                // use matrix implementation
                return self(matrix(x), y).valueOf();
            }),
        "any, Array": typed.referToSelf((self)=>(x, y)=>{
                // use matrix implementation
                return self(x, matrix(y)).valueOf();
            })
    }, matrixAlgorithmSuite({
        SS: matAlgo06xS0S0,
        DS: matAlgo02xDS0
    }));
});





var $b9ebe2aeb9e55336$var$name = "apply";
var $b9ebe2aeb9e55336$var$dependencies = [
    "typed",
    "isInteger"
];
var $b9ebe2aeb9e55336$export$5ccffa1686df7f00 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b9ebe2aeb9e55336$var$name, $b9ebe2aeb9e55336$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    /**
   * Apply a function that maps an array to a scalar
   * along a given axis of a matrix or array.
   * Returns a new matrix or array with one less dimension than the input.
   *
   * Syntax:
   *
   *     math.apply(A, dim, callback)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [3, 4]]
   *    const sum = math.sum
   *
   *    math.apply(A, 0, sum)             // returns [4, 6]
   *    math.apply(A, 1, sum)             // returns [3, 7]
   *
   * See also:
   *
   *    map, filter, forEach
   *
   * @param {Array | Matrix} array   The input Matrix
   * @param {number} dim             The dimension along which the callback is applied
   * @param {Function} callback      The callback function that is applied. This Function
   *                                 should take an array or 1-d matrix as an input and
   *                                 return a number.
   * @return {Array | Matrix} res    The residual matrix with the function applied over some dimension.
   */ return typed($b9ebe2aeb9e55336$var$name, {
        "Array | Matrix, number | BigNumber, function": function ArrayMatrixNumberBigNumberFunction(mat, dim, callback) {
            if (!isInteger(dim)) throw new TypeError("Integer number expected for dimension");
            var size = Array.isArray(mat) ? (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(mat) : mat.size();
            if (dim < 0 || dim >= size.length) throw new (0, $7e61b13fb7752c23$export$efa5eacb1304c464)(dim, size.length);
            if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(mat)) return mat.create($b9ebe2aeb9e55336$var$_apply(mat.valueOf(), dim, callback));
            else return $b9ebe2aeb9e55336$var$_apply(mat, dim, callback);
        }
    });
});
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $b9ebe2aeb9e55336$var$_apply(mat, dim, callback) {
    var i, ret, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) return callback(mat);
        else {
            tran = $b9ebe2aeb9e55336$var$_switch(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $b9ebe2aeb9e55336$var$_apply(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $b9ebe2aeb9e55336$var$_apply(mat[i], dim - 1, callback);
        return ret;
    }
}
/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $b9ebe2aeb9e55336$var$_switch(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
}



var $a6c586ab564bc0bd$var$name = "arg";
var $a6c586ab564bc0bd$var$dependencies = [
    "typed"
];
var $a6c586ab564bc0bd$export$bde3dabbd4699a93 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a6c586ab564bc0bd$var$name, $a6c586ab564bc0bd$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the argument of a complex value.
   * For a complex number `a + bi`, the argument is computed as `atan2(b, a)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.arg(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 2)
   *    math.arg(a) / math.pi          // returns number 0.25
   *
   *    const b = math.complex('2 + 3i')
   *    math.arg(b)                    // returns number 0.982793723247329
   *    math.atan2(3, 2)               // returns number 0.982793723247329
   *
   * See also:
   *
   *    re, im, conj, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The argument of x
   */ return typed($a6c586ab564bc0bd$var$name, {
        number: function number(x) {
            return Math.atan2(0, x);
        },
        BigNumber: function BigNumber(x) {
            return x.constructor.atan2(0, x);
        },
        Complex: function Complex(x) {
            return x.arg();
        },
        // TODO: implement BigNumber support for function arg
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});



var $07973b37d7124c32$var$name = "asec";
var $07973b37d7124c32$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $07973b37d7124c32$export$e1f28fc7c94f90b0 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($07973b37d7124c32$var$name, $07973b37d7124c32$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse secant of a value. Defined as `asec(x) = acos(1/x)`.
   *
   * To avoid confusion with the matrix arcsecant, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.asec(x)
   *
   * Examples:
   *
   *    math.asec(2)             // returns 1.0471975511965979
   *    math.asec(math.sec(1.5)) // returns 1.5
   *
   *    math.asec(0.5)           // returns Complex 0 + 1.3169578969248166i
   *
   * See also:
   *
   *    acos, acot, acsc
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} The arc secant of x
   */ return typed($07973b37d7124c32$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $08edde3ad76e4ae3$export$5ec3930177455ade)(x);
            return new Complex(x, 0).asec();
        },
        Complex: function Complex(x) {
            return x.asec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acos();
        }
    });
});



var $3f66c557a350645d$var$name = "asech";
var $3f66c557a350645d$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $3f66c557a350645d$export$8eeff5f09afe95bc = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3f66c557a350645d$var$name, $3f66c557a350645d$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arcsecant of a value,
   * defined as `asech(x) = acosh(1/x) = ln(sqrt(1/x^2 - 1) + 1/x)`.
   *
   * To avoid confusion with the matrix hyperbolic arcsecant, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.asech(x)
   *
   * Examples:
   *
   *    math.asech(0.5)       // returns 1.3169578969248166
   *
   * See also:
   *
   *    acsch, acoth
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arcsecant of x
   */ return typed($3f66c557a350645d$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) {
                var xInv = 1 / x;
                if (xInv > 0 || config.predictable) return (0, $08edde3ad76e4ae3$export$cf144300ea173362)(x);
                var ret = Math.sqrt(xInv * xInv - 1);
                return new Complex(Math.log(ret - xInv), Math.PI);
            }
            return new Complex(x, 0).asech();
        },
        Complex: function Complex(x) {
            return x.asech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acosh();
        }
    });
});


var $42d22c259f86a7bb$var$name = "asin";
var $42d22c259f86a7bb$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $42d22c259f86a7bb$export$5f05d91ddc56bc14 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($42d22c259f86a7bb$var$name, $42d22c259f86a7bb$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the inverse sine of a value.
   *
   * To avoid confusion with the matric arcsine, this function does not apply
   * to matrices.
   *
   * Syntax:
   *
   *    math.asin(x)
   *
   * Examples:
   *
   *    math.asin(0.5)           // returns number 0.5235987755982989
   *    math.asin(math.sin(1.5)) // returns number ~1.5
   *
   *    math.asin(2)             // returns Complex 1.5707963267948966 -1.3169578969248166i
   *
   * See also:
   *
   *    sin, atan, acos
   *
   * @param {number | BigNumber | Complex} x   Function input
   * @return {number | BigNumber | Complex} The arc sine of x
   */ return typed($42d22c259f86a7bb$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.asin(x);
            else return new Complex(x, 0).asin();
        },
        Complex: function Complex(x) {
            return x.asin();
        },
        BigNumber: function BigNumber(x) {
            return x.asin();
        }
    });
});



var $8bccec96a1e05cfa$var$name = "asinh";
var $8bccec96a1e05cfa$var$dependencies = [
    "typed"
];
var $8bccec96a1e05cfa$export$7278bb4e3c84d46a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($8bccec96a1e05cfa$var$name, $8bccec96a1e05cfa$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic arcsine of a value,
   * defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.
   *
   * To avoid confusion with the matrix hyperbolic arcsine, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.asinh(x)
   *
   * Examples:
   *
   *    math.asinh(0.5)       // returns 0.48121182505960347
   *
   * See also:
   *
   *    acosh, atanh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arcsine of x
   */ return typed("asinh", {
        number: (0, $08edde3ad76e4ae3$export$3a027485d3336d8d),
        Complex: function Complex(x) {
            return x.asinh();
        },
        BigNumber: function BigNumber(x) {
            return x.asinh();
        }
    });
});


var $7905114719152cdb$var$name = "atan";
var $7905114719152cdb$var$dependencies = [
    "typed"
];
var $7905114719152cdb$export$b87f3a3301a24256 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($7905114719152cdb$var$name, $7905114719152cdb$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the inverse tangent of a value.
   *
   * To avoid confusion with matrix arctangent, this function does not apply
   * to matrices.
   *
   * Syntax:
   *
   *    math.atan(x)
   *
   * Examples:
   *
   *    math.atan(0.5)           // returns number 0.4636476090008061
   *    math.atan(2)             // returns number 1.1071487177940904
   *    math.atan(math.tan(1.5)) // returns number 1.5
   *
   * See also:
   *
   *    tan, asin, acos
   *
   * @param {number | BigNumber | Complex} x   Function input
   * @return {number | BigNumber | Complex} The arc tangent of x
   */ return typed("atan", {
        number: function number(x) {
            return Math.atan(x);
        },
        Complex: function Complex(x) {
            return x.atan();
        },
        BigNumber: function BigNumber(x) {
            return x.atan();
        }
    });
});





var $4ec2f48a64980d8f$var$name = "matAlgo03xDSf";
var $4ec2f48a64980d8f$var$dependencies = [
    "typed"
];
var $4ec2f48a64980d8f$export$6325e83173a86892 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($4ec2f48a64980d8f$var$name, $4ec2f48a64980d8f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over SparseMatrix items and invokes the callback function f(Dij, Sij).
   * Callback function invoked M*N times.
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(Dij, 0)    ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (C)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function matAlgo03xDSf(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype || denseMatrix.getDataType();
        // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype || sparseMatrix._data === undefined ? sparseMatrix._datatype : sparseMatrix.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
        // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string" && adt === bdt && adt !== "mixed") {
            // datatype
            dt = adt;
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result (DenseMatrix)
        var cdata = [];
        // initialize dense matrix
        for(var z = 0; z < rows; z++)// initialize row
        cdata[z] = [];
        // workspace
        var x = [];
        // marks indicating we have a value in x for a given column
        var w = [];
        // loop columns in b
        for(var j = 0; j < columns; j++){
            // column mark
            var mark = j + 1;
            // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k];
                // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
                w[i] = mark;
            }
            // process workspace
            for(var y = 0; y < rows; y++)// check we have a calculated value for current row
            if (w[y] === mark) // use calculated value
            cdata[y][j] = x[y];
            else // calculate value
            cdata[y][j] = inverse ? cf(zero, adata[y][j]) : cf(adata[y][j], zero);
        }
        // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: adt === denseMatrix._datatype && bdt === sparseMatrix._datatype ? dt : undefined
        });
    };
});




var $d51e93553e316d93$var$name = "matAlgo09xS0Sf";
var $d51e93553e316d93$var$dependencies = [
    "typed",
    "equalScalar"
];
var $d51e93553e316d93$export$53a31b0bf876516 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d51e93553e316d93$var$name, $d51e93553e316d93$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and invokes the callback function f(Aij, Bij).
   * Callback function invoked NZA times, number of nonzero elements in A.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function matAlgo09xS0Sf(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string" && adt === bdt && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // workspaces
        var x = cvalues ? [] : undefined;
        // marks indicating we have a value in x for a given column
        var w = [];
        // vars
        var i, j, k, k0, k1;
        // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // column mark
            var mark = j + 1;
            // check we need to process values
            if (x) // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k];
                // update workspace
                w[i] = mark;
                x[i] = bvalues[k];
            }
            // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k];
                // check we need to process values
                if (x) {
                    // b value @ i,j
                    var vb = w[i] === mark ? x[i] : zero;
                    // invoke f
                    var vc = cf(avalues[k], vb);
                    // check zero value
                    if (!eq(vc, zero)) {
                        // push index
                        cindex.push(i);
                        // push value
                        cvalues.push(vc);
                    }
                } else // push index
                cindex.push(i);
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
});




var $0e61f64a39d5fa10$var$name = "matAlgo12xSfs";
var $0e61f64a39d5fa10$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $0e61f64a39d5fa10$export$c966408e3ecf83ee = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0e61f64a39d5fa10$var$name, $0e61f64a39d5fa10$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked MxN times.
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(0, b)    ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function matAlgo12xSfs(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype;
        // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt;
            // convert b to the same datatype
            b = typed.convert(b, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cdata = [];
        // workspaces
        var x = [];
        // marks indicating we have a value in x for a given column
        var w = [];
        // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1;
            // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k];
                // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            }
            // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = inverse ? cf(b, 0) : cf(0, b);
            }
        }
        // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});



var $d2b3c5af1b96583c$var$name = "atan2";
var $d2b3c5af1b96583c$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber",
    "DenseMatrix",
    "concat"
];
var $d2b3c5af1b96583c$export$c56716e11a38354e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d2b3c5af1b96583c$var$name, $d2b3c5af1b96583c$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: BigNumber, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo02xDS0 = (0, $94e325bf4fc92f8c$export$32ae34d6563cd126)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo09xS0Sf = (0, $d51e93553e316d93$export$53a31b0bf876516)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Calculate the inverse tangent function with two arguments, y/x.
   * By providing two arguments, the right quadrant of the computed angle can be
   * determined.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan2(y, x)
   *
   * Examples:
   *
   *    math.atan2(2, 2) / math.pi       // returns number 0.25
   *
   *    const angle = math.unit(60, 'deg') // returns Unit 60 deg
   *    const x = math.cos(angle)
   *    const y = math.sin(angle)
   *
   *    math.atan(2)             // returns number 1.1071487177940904
   *
   * See also:
   *
   *    tan, atan, sin, cos
   *
   * @param {number | Array | Matrix} y  Second dimension
   * @param {number | Array | Matrix} x  First dimension
   * @return {number | Array | Matrix} Four-quadrant inverse tangent
   */ return typed($d2b3c5af1b96583c$var$name, {
        "number, number": Math.atan2,
        // Complex numbers doesn't seem to have a reasonable implementation of
        // atan2(). Even Matlab removed the support, after they only calculated
        // the atan only on base of the real part of the numbers and ignored
        // the imaginary.
        "BigNumber, BigNumber": (y, x)=>BigNumber.atan2(y, x)
    }, matrixAlgorithmSuite({
        scalar: "number | BigNumber",
        SS: matAlgo09xS0Sf,
        DS: matAlgo03xDSf,
        SD: matAlgo02xDS0,
        Ss: matAlgo11xS0s,
        sS: matAlgo12xSfs
    }));
});



var $dff3cd9decddb6b0$var$name = "atanh";
var $dff3cd9decddb6b0$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $dff3cd9decddb6b0$export$c2dbbeab1e5e6195 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($dff3cd9decddb6b0$var$name, $dff3cd9decddb6b0$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the hyperbolic arctangent of a value,
   * defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.
   *
   * To avoid confusion with the matrix hyperbolic arctangent, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.atanh(x)
   *
   * Examples:
   *
   *    math.atanh(0.5)       // returns 0.5493061443340549
   *
   * See also:
   *
   *    acosh, asinh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arctangent of x
   */ return typed($dff3cd9decddb6b0$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) return (0, $08edde3ad76e4ae3$export$44a1f653c6513db8)(x);
            return new Complex(x, 0).atanh();
        },
        Complex: function Complex(x) {
            return x.atanh();
        },
        BigNumber: function BigNumber(x) {
            return x.atanh();
        }
    });
});


var $0fc922cf7b8f0510$export$ace78258608300fc = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("speedOfLight", "299792458", "m s^-1");
var $0fc922cf7b8f0510$export$157e78cb05354391 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2");
var $0fc922cf7b8f0510$export$e58ff8150d83ea6a = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("planckConstant", "6.62607015e-34", "J s");
var $0fc922cf7b8f0510$export$50bee65ab76b402 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("reducedPlanckConstant", "1.0545718176461565e-34", "J s");
var $0fc922cf7b8f0510$export$e7fcb8898ecb0703 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("magneticConstant", "1.25663706212e-6", "N A^-2");
var $0fc922cf7b8f0510$export$d69030cf93f04407 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("electricConstant", "8.8541878128e-12", "F m^-1");
var $0fc922cf7b8f0510$export$c9ff08d282f03cf0 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("vacuumImpedance", "376.730313667", "ohm");
var $0fc922cf7b8f0510$export$815f2029cd62d0d6 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("coulomb", "8.987551792261171e9", "N m^2 C^-2");
var $0fc922cf7b8f0510$export$542715ad7e3a9798 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("elementaryCharge", "1.602176634e-19", "C");
var $0fc922cf7b8f0510$export$f5851397fd1173db = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("bohrMagneton", "9.2740100783e-24", "J T^-1");
var $0fc922cf7b8f0510$export$e26bbd27fc291ddf = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("conductanceQuantum", "7.748091729863649e-5", "S");
var $0fc922cf7b8f0510$export$f2f136373157165b = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("inverseConductanceQuantum", "12906.403729652257", "ohm");
var $0fc922cf7b8f0510$export$fd46b6c8680e4d01 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("magneticFluxQuantum", "2.0678338484619295e-15", "Wb");
var $0fc922cf7b8f0510$export$9670d94122b9a81b = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("nuclearMagneton", "5.0507837461e-27", "J T^-1");
var $0fc922cf7b8f0510$export$e3f21ac13bee6a0f = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("klitzing", "25812.807459304513", "ohm");
var $0fc922cf7b8f0510$export$c090909964c68de4 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("josephson", "4.835978484169836e14 Hz V", "Hz V^-1"); // TODO: support for Hz needed
var $0fc922cf7b8f0510$export$19b72356ad84e4ee = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("bohrRadius", "5.29177210903e-11", "m");
var $0fc922cf7b8f0510$export$68a9771dccce9a23 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("classicalElectronRadius", "2.8179403262e-15", "m");
var $0fc922cf7b8f0510$export$85362d2a7862e209 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("electronMass", "9.1093837015e-31", "kg");
var $0fc922cf7b8f0510$export$b6687a2f3911256b = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("fermiCoupling", "1.1663787e-5", "GeV^-2");
var $0fc922cf7b8f0510$export$aaddb59a993d3ac4 = $0fc922cf7b8f0510$var$numberFactory("fineStructure", 7.2973525693e-3);
var $0fc922cf7b8f0510$export$8bb818baeaa40bd6 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("hartreeEnergy", "4.3597447222071e-18", "J");
var $0fc922cf7b8f0510$export$f357c1a8d4fccef6 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("protonMass", "1.67262192369e-27", "kg");
var $0fc922cf7b8f0510$export$a403f6c5bed71f22 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("deuteronMass", "3.3435830926e-27", "kg");
var $0fc922cf7b8f0510$export$676d5ebe8fbeb250 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("neutronMass", "1.6749271613e-27", "kg");
var $0fc922cf7b8f0510$export$6840f334b8a5b6b1 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1");
var $0fc922cf7b8f0510$export$fd1b48ecb0d5c0ef = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("rydberg", "10973731.568160", "m^-1");
var $0fc922cf7b8f0510$export$229739a879741f68 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("thomsonCrossSection", "6.6524587321e-29", "m^2");
var $0fc922cf7b8f0510$export$fa2d42c5c25c1883 = $0fc922cf7b8f0510$var$numberFactory("weakMixingAngle", 0.22290);
var $0fc922cf7b8f0510$export$55fc8769b037d266 = $0fc922cf7b8f0510$var$numberFactory("efimovFactor", 22.7);
var $0fc922cf7b8f0510$export$2f8d2da219209d0a = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("atomicMass", "1.66053906660e-27", "kg");
var $0fc922cf7b8f0510$export$4924e3d8de6ad850 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("avogadro", "6.02214076e23", "mol^-1");
var $0fc922cf7b8f0510$export$221b7a8c9510b6cc = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("boltzmann", "1.380649e-23", "J K^-1");
var $0fc922cf7b8f0510$export$17ef8d738c9b0091 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("faraday", "96485.33212331001", "C mol^-1");
var $0fc922cf7b8f0510$export$266a9bae8a62fb6e = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("firstRadiation", "3.7417718521927573e-16", "W m^2");
var $0fc922cf7b8f0510$export$c38bce537e0ffddb = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("loschmidt", "2.686780111798444e25", "m^-3");
var $0fc922cf7b8f0510$export$85a77a0842c24f74 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("gasConstant", "8.31446261815324", "J K^-1 mol^-1");
var $0fc922cf7b8f0510$export$12e2358797b853c9 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1");
var $0fc922cf7b8f0510$export$f5e8f56ebfacbaca = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("molarVolume", "0.022413969545014137", "m^3 mol^-1");
var $0fc922cf7b8f0510$export$467c65d9dfc3d3a2 = $0fc922cf7b8f0510$var$numberFactory("sackurTetrode", -1.16487052358);
var $0fc922cf7b8f0510$export$ea93a35a6f35e1b6 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("secondRadiation", "0.014387768775039337", "m K");
var $0fc922cf7b8f0510$export$a943525a62f69cd2 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4");
var $0fc922cf7b8f0510$export$3c74568e9574d168 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("wienDisplacement", "2.897771955e-3", "m K");
var $0fc922cf7b8f0510$export$85414d775c93e6de = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("molarMass", "0.99999999965e-3", "kg mol^-1");
var $0fc922cf7b8f0510$export$d5045cf71611a462 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("molarMassC12", "11.9999999958e-3", "kg mol^-1");
var $0fc922cf7b8f0510$export$42b5845f95e0feee = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("gravity", "9.80665", "m s^-2");
var $0fc922cf7b8f0510$export$675ebbcd6bdcebd7 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("planckLength", "1.616255e-35", "m");
var $0fc922cf7b8f0510$export$d44b96c94520b20e = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("planckMass", "2.176435e-8", "kg");
var $0fc922cf7b8f0510$export$3bf63d7b96fd8541 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("planckTime", "5.391245e-44", "s");
var $0fc922cf7b8f0510$export$43e139a6eec1ab59 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("planckCharge", "1.87554603778e-18", "C");
var $0fc922cf7b8f0510$export$d21f20fc89fac8c0 = /* #__PURE__ */ $0fc922cf7b8f0510$var$unitFactory("planckTemperature", "1.416785e+32", "K");
// helper function to create a factory function which creates a physical constant,
// a Unit with either a number value or a BigNumber value depending on the configuration
function $0fc922cf7b8f0510$var$unitFactory(name, valueStr, unitStr) {
    var dependencies = [
        "config",
        "Unit",
        "BigNumber"
    ];
    return (0, $a690df4b5d23d55b$export$e9008f2713103c6c)(name, dependencies, (_ref)=>{
        var { config: config, Unit: Unit, BigNumber: BigNumber } = _ref;
        // Note that we can parse into number or BigNumber.
        // We do not parse into Fractions as that doesn't make sense: we would lose precision of the values
        // Therefore we dont use Unit.parse()
        var value = config.number === "BigNumber" ? new BigNumber(valueStr) : parseFloat(valueStr);
        var unit = new Unit(value, unitStr);
        unit.fixPrefix = true;
        return unit;
    });
}
// helper function to create a factory function which creates a numeric constant,
// either a number or BigNumber depending on the configuration
function $0fc922cf7b8f0510$var$numberFactory(name, value) {
    var dependencies = [
        "config",
        "BigNumber"
    ];
    return (0, $a690df4b5d23d55b$export$e9008f2713103c6c)(name, dependencies, (_ref2)=>{
        var { config: config, BigNumber: BigNumber } = _ref2;
        return config.number === "BigNumber" ? new BigNumber(value) : value;
    });
}


var $18ba17d26d484454$var$name = "bellNumbers";
var $18ba17d26d484454$var$dependencies = [
    "typed",
    "addScalar",
    "isNegative",
    "isInteger",
    "stirlingS2"
];
var $18ba17d26d484454$export$7b7dc3bd00d38afb = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($18ba17d26d484454$var$name, $18ba17d26d484454$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, isNegative: isNegative, isInteger: isInteger, stirlingS2: stirlingS2 } = _ref;
    /**
   * The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S.
   * bellNumbers only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.bellNumbers(n)
   *
   * Examples:
   *
   *    math.bellNumbers(3) // returns 5
   *    math.bellNumbers(8) // returns 4140
   *
   * See also:
   *
   *    stirlingS2
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @return {Number | BigNumber}     B(n)
   */ return typed($18ba17d26d484454$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError("Non-negative integer value expected in function bellNumbers");
            // Sum (k=0, n) S(n,k).
            var result = 0;
            for(var i = 0; i <= n; i++)result = addScalar(result, stirlingS2(n, i));
            return result;
        }
    });
});



var $a688087d0499c924$var$name = "bigint";
var $a688087d0499c924$var$dependencies = [
    "typed"
];
var $a688087d0499c924$export$bfbfca9aa02d908c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a688087d0499c924$var$name, $a688087d0499c924$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a bigint or convert a string, boolean, or unit to a bigint.
   * When value is a matrix, all elements will be converted to bigint.
   *
   * Syntax:
   *
   *    math.bigint(value)
   *
   * Examples:
   *
   *    math.bigint(2)                         // returns 2n
   *    math.bigint('123')                     // returns 123n
   *    math.bigint(true)                      // returns 1n
   *    math.bigint([true, false, true, true]) // returns [1n, 0n, 1n, 1n]
   *
   * See also:
   *
   *    number, bignumber, boolean, complex, index, matrix, string, unit
   *
   * @param {string | number | BigNumber | bigint | Fraction | boolean | Array | Matrix | null} [value]  Value to be converted
   * @return {bigint | Array | Matrix} The created bigint
   */ var bigint = typed("bigint", {
        "": function _() {
            return 0n;
        },
        bigint: function bigint(x) {
            return x;
        },
        number: function number(x) {
            return BigInt(x.toFixed());
        },
        BigNumber: function BigNumber(x) {
            return BigInt(x.round().toString());
        },
        Fraction: function Fraction(x) {
            return BigInt(x.valueOf().toFixed());
        },
        "string | boolean": function stringBoolean(x) {
            return BigInt(x);
        },
        null: function _null(x) {
            return 0n;
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
    // reviver function to parse a JSON object like:
    //
    //     {"mathjs":"bigint","value":"123"}
    //
    // into a bigint 123n
    bigint.fromJSON = function(json) {
        return BigInt(json.value);
    };
    return bigint;
});



var $5bf10209a169e049$var$name = "bignumber";
var $5bf10209a169e049$var$dependencies = [
    "typed",
    "BigNumber"
];
var $5bf10209a169e049$export$1c955ee1b8a97877 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($5bf10209a169e049$var$name, $5bf10209a169e049$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: BigNumber } = _ref;
    /**
   * Create a BigNumber, which can store numbers with arbitrary precision.
   * When a matrix is provided, all elements will be converted to BigNumber.
   *
   * Syntax:
   *
   *    math.bignumber(x)
   *
   * Examples:
   *
   *    0.1 + 0.2                                  // returns number 0.30000000000000004
   *    math.bignumber(0.1) + math.bignumber(0.2)  // returns BigNumber 0.3
   *
   *
   *    7.2e500                                    // returns number Infinity
   *    math.bignumber('7.2e500')                  // returns BigNumber 7.2e500
   *
   * See also:
   *
   *    number, bigint, boolean, complex, index, matrix, string, unit
   *
   * @param {number | string | Fraction | BigNumber | bigint | Array | Matrix | boolean | null} [value]  Value for the big number,
   *                                                    0 by default.
   * @returns {BigNumber} The created bignumber
   */ return typed("bignumber", {
        "": function _() {
            return new BigNumber(0);
        },
        number: function number(x) {
            // convert to string to prevent errors in case of >15 digits
            return new BigNumber(x + "");
        },
        string: function string(x) {
            var wordSizeSuffixMatch = x.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
            if (wordSizeSuffixMatch) {
                // x has a word size suffix
                var size = wordSizeSuffixMatch[2];
                var n = BigNumber(wordSizeSuffixMatch[1]);
                var twoPowSize = new BigNumber(2).pow(Number(size));
                if (n.gt(twoPowSize.sub(1))) throw new SyntaxError('String "'.concat(x, '" is out of range'));
                var twoPowSizeSubOne = new BigNumber(2).pow(Number(size) - 1);
                if (n.gte(twoPowSizeSubOne)) return n.sub(twoPowSize);
                else return n;
            }
            return new BigNumber(x);
        },
        BigNumber: function BigNumber(x) {
            // we assume a BigNumber is immutable
            return x;
        },
        bigint: function bigint(x) {
            return new BigNumber(x.toString());
        },
        Unit: typed.referToSelf((self)=>(x)=>{
                var clone = x.clone();
                clone.value = self(x.value);
                return clone;
            }),
        Fraction: function Fraction(x) {
            return new BigNumber(x.n).div(x.d).times(x.s);
        },
        null: function _null(x) {
            return new BigNumber(0);
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});



var $cfd46da444216cd5$var$name = "BigNumber";
var $cfd46da444216cd5$var$dependencies = [
    "?on",
    "config"
];
var $cfd46da444216cd5$export$234de8d4231bfea3 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($cfd46da444216cd5$var$name, $cfd46da444216cd5$var$dependencies, (_ref)=>{
    var { on: on, config: config } = _ref;
    var BigNumber = (0, (/*@__PURE__*/$parcel$interopDefault($22467ec447bdc2ca$exports))).clone({
        precision: config.precision,
        modulo: (0, (/*@__PURE__*/$parcel$interopDefault($22467ec447bdc2ca$exports))).EUCLID
    });
    BigNumber.prototype = Object.create(BigNumber.prototype);
    /**
   * Attach type information
   */ BigNumber.prototype.type = "BigNumber";
    BigNumber.prototype.isBigNumber = true;
    /**
   * Get a JSON representation of a BigNumber containing
   * type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "BigNumber", "value": "0.2"}`
   */ BigNumber.prototype.toJSON = function() {
        return {
            mathjs: "BigNumber",
            value: this.toString()
        };
    };
    /**
   * Instantiate a BigNumber from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "BigNumber", "value": "0.2"}`
   * @return {BigNumber}
   */ BigNumber.fromJSON = function(json) {
        return new BigNumber(json.value);
    };
    if (on) // listen for changed in the configuration, automatically apply changed precision
    on("config", function(curr, prev) {
        if (curr.precision !== prev.precision) BigNumber.config({
            precision: curr.precision
        });
    });
    return BigNumber;
}, {
    isClass: true
});


var $0039a008386ed187$var$name = "bin";
var $0039a008386ed187$var$dependencies = [
    "typed",
    "format"
];
var $0039a008386ed187$export$a770ddfd7e536064 = (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0039a008386ed187$var$name, $0039a008386ed187$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($0039a008386ed187$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            return format(n, {
                notation: "bin"
            });
        },
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, wordSize) {
            return format(n, {
                notation: "bin",
                wordSize: wordSize
            });
        }
    });
});

/**
 * Bitwise and for Bignumbers
 *
 * Special Cases:
 *   N &  n =  N
 *   n &  0 =  0
 *   n & -1 =  n
 *   n &  n =  n
 *   I &  I =  I
 *  -I & -I = -I
 *   I & -I =  0
 *   I &  n =  n
 *   I & -n =  I
 *  -I &  n =  0
 *  -I & -n = -I
 *
 * @param {BigNumber} x
 * @param {BigNumber} y
 * @return {BigNumber} Result of `x` & `y`, is fully precise
 * @private
 */ function $6f96750d17929332$export$94757ce5cf54fec9(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitAnd");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero() || y.eq(-1) || x.eq(y)) return x;
    if (y.isZero() || x.eq(-1)) return y;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) {
            if (x.isNegative() === y.isNegative()) return x;
            return new BigNumber(0);
        }
        if (!x.isFinite()) {
            if (y.isNegative()) return x;
            if (x.isNegative()) return new BigNumber(0);
            return y;
        }
        if (!y.isFinite()) {
            if (x.isNegative()) return y;
            if (y.isNegative()) return new BigNumber(0);
            return x;
        }
    }
    return $6f96750d17929332$export$884842863a0853c4(x, y, function(a, b) {
        return a & b;
    });
}
function $6f96750d17929332$export$2ada53b3c51e9645(x) {
    if (x.isFinite() && !x.isInteger()) throw new Error("Integer expected in function bitNot");
    var BigNumber = x.constructor;
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    var result = x.plus(new BigNumber(1));
    result.s = -result.s || null;
    BigNumber.config({
        precision: prevPrec
    });
    return result;
}
function $6f96750d17929332$export$e43ec6c4cff46d2c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitOr");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    var negOne = new BigNumber(-1);
    if (x.isZero() || y.eq(negOne) || x.eq(y)) return y;
    if (y.isZero() || x.eq(negOne)) return x;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !x.isNegative() && y.isNegative() || x.isNegative() && !y.isNegative() && !y.isFinite()) return negOne;
        if (x.isNegative() && y.isNegative()) return x.isFinite() ? x : y;
        return x.isFinite() ? y : x;
    }
    return $6f96750d17929332$export$884842863a0853c4(x, y, function(a, b) {
        return a | b;
    });
}
function $6f96750d17929332$export$884842863a0853c4(x, y, func) {
    var BigNumber = x.constructor;
    var xBits, yBits;
    var xSign = +(x.s < 0);
    var ySign = +(y.s < 0);
    if (xSign) {
        xBits = $6f96750d17929332$var$decCoefficientToBinaryString($6f96750d17929332$export$2ada53b3c51e9645(x));
        for(var i = 0; i < xBits.length; ++i)xBits[i] ^= 1;
    } else xBits = $6f96750d17929332$var$decCoefficientToBinaryString(x);
    if (ySign) {
        yBits = $6f96750d17929332$var$decCoefficientToBinaryString($6f96750d17929332$export$2ada53b3c51e9645(y));
        for(var _i = 0; _i < yBits.length; ++_i)yBits[_i] ^= 1;
    } else yBits = $6f96750d17929332$var$decCoefficientToBinaryString(y);
    var minBits, maxBits, minSign;
    if (xBits.length <= yBits.length) {
        minBits = xBits;
        maxBits = yBits;
        minSign = xSign;
    } else {
        minBits = yBits;
        maxBits = xBits;
        minSign = ySign;
    }
    var shortLen = minBits.length;
    var longLen = maxBits.length;
    var expFuncVal = func(xSign, ySign) ^ 1;
    var outVal = new BigNumber(expFuncVal ^ 1);
    var twoPower = new BigNumber(1);
    var two = new BigNumber(2);
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    while(shortLen > 0){
        if (func(minBits[--shortLen], maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    while(longLen > 0){
        if (func(minSign, maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    BigNumber.config({
        precision: prevPrec
    });
    if (expFuncVal === 0) outVal.s = -outVal.s;
    return outVal;
}
/* Extracted from decimal.js, and edited to specialize. */ function $6f96750d17929332$var$decCoefficientToBinaryString(x) {
    // Convert to string
    var a = x.d; // array with digits
    var r = a[0] + "";
    for(var i = 1; i < a.length; ++i){
        var s = a[i] + "";
        for(var z = 7 - s.length; z--;)s = "0" + s;
        r += s;
    }
    var j = r.length;
    while(r.charAt(j) === "0")j--;
    var xe = x.e;
    var str = r.slice(0, j + 1 || 1);
    var strL = str.length;
    if (xe > 0) {
        if (++xe > strL) {
            // Append zeros.
            xe -= strL;
            while(xe--)str += "0";
        } else if (xe < strL) str = str.slice(0, xe) + "." + str.slice(xe);
    }
    // Convert from base 10 (decimal) to base 2
    var arr = [
        0
    ];
    for(var _i2 = 0; _i2 < str.length;){
        var arrL = arr.length;
        while(arrL--)arr[arrL] *= 10;
        arr[0] += parseInt(str.charAt(_i2++)); // convert to int
        for(var _j = 0; _j < arr.length; ++_j)if (arr[_j] > 1) {
            if (arr[_j + 1] === null || arr[_j + 1] === undefined) arr[_j + 1] = 0;
            arr[_j + 1] += arr[_j] >> 1;
            arr[_j] &= 1;
        }
    }
    return arr.reverse();
}
function $6f96750d17929332$export$bfcff4501301c191(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitXor");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero()) return y;
    if (y.isZero()) return x;
    if (x.eq(y)) return new BigNumber(0);
    var negOne = new BigNumber(-1);
    if (x.eq(negOne)) return $6f96750d17929332$export$2ada53b3c51e9645(y);
    if (y.eq(negOne)) return $6f96750d17929332$export$2ada53b3c51e9645(x);
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) return negOne;
        return new BigNumber(x.isNegative() === y.isNegative() ? Infinity : -Infinity);
    }
    return $6f96750d17929332$export$884842863a0853c4(x, y, function(a, b) {
        return a ^ b;
    });
}
function $6f96750d17929332$export$626dff8098a67b4c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function leftShift");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!x.isFinite() && !y.isFinite()) return new BigNumber(NaN);
    // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.times(Math.pow(2, y.toNumber()) + "");
    return x.times(new BigNumber(2).pow(y));
}
function $6f96750d17929332$export$d489c03691bd4cd(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function rightArithShift");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!y.isFinite()) {
        if (x.isNegative()) return new BigNumber(-1);
        if (!x.isFinite()) return new BigNumber(NaN);
        return new BigNumber(0);
    }
    // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.div(Math.pow(2, y.toNumber()) + "").floor();
    return x.div(new BigNumber(2).pow(y)).floor();
}








var $23d3870094e55520$var$n1 = "number";
var $23d3870094e55520$var$n2 = "number, number";
function $23d3870094e55520$export$e7607930867bd49a(x, y) {
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(x) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function bitAnd");
    return x & y;
}
$23d3870094e55520$export$e7607930867bd49a.signature = $23d3870094e55520$var$n2;
function $23d3870094e55520$export$22a2b2a0351218e7(x) {
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(x)) throw new Error("Integer expected in function bitNot");
    return ~x;
}
$23d3870094e55520$export$22a2b2a0351218e7.signature = $23d3870094e55520$var$n1;
function $23d3870094e55520$export$9aecb772cb5ad1c7(x, y) {
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(x) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function bitOr");
    return x | y;
}
$23d3870094e55520$export$9aecb772cb5ad1c7.signature = $23d3870094e55520$var$n2;
function $23d3870094e55520$export$2260a44ec1c987dc(x, y) {
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(x) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function bitXor");
    return x ^ y;
}
$23d3870094e55520$export$2260a44ec1c987dc.signature = $23d3870094e55520$var$n2;
function $23d3870094e55520$export$65c07a47901525ba(x, y) {
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(x) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function leftShift");
    return x << y;
}
$23d3870094e55520$export$65c07a47901525ba.signature = $23d3870094e55520$var$n2;
function $23d3870094e55520$export$b6d96f775be90000(x, y) {
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(x) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function rightArithShift");
    return x >> y;
}
$23d3870094e55520$export$b6d96f775be90000.signature = $23d3870094e55520$var$n2;
function $23d3870094e55520$export$2a8d1e3dcede6e47(x, y) {
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(x) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function rightLogShift");
    return x >>> y;
}
$23d3870094e55520$export$2a8d1e3dcede6e47.signature = $23d3870094e55520$var$n2;


var $35b2aafc006b23e8$var$name = "bitAnd";
var $35b2aafc006b23e8$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "concat"
];
var $35b2aafc006b23e8$export$bea4e06c5befec3b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($35b2aafc006b23e8$var$name, $35b2aafc006b23e8$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, concat: concat } = _ref;
    var matAlgo02xDS0 = (0, $94e325bf4fc92f8c$export$32ae34d6563cd126)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo06xS0S0 = (0, $bc13b8f894d6d714$export$7e944de5217ad25)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Bitwise AND two values, `x & y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitAnd(x, y)
   *
   * Examples:
   *
   *    math.bitAnd(53, 131)               // returns number 1
   *
   *    math.bitAnd([1, 12, 31], 42)       // returns Array [0, 8, 10]
   *
   * See also:
   *
   *    bitNot, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x First value to and
   * @param  {number | BigNumber | bigint | Array | Matrix} y Second value to and
   * @return {number | BigNumber | bigint | Array | Matrix} AND of `x` and `y`
   */ return typed($35b2aafc006b23e8$var$name, {
        "number, number": (0, $23d3870094e55520$export$e7607930867bd49a),
        "BigNumber, BigNumber": (0, $6f96750d17929332$export$94757ce5cf54fec9),
        "bigint, bigint": (x, y)=>x & y
    }, matrixAlgorithmSuite({
        SS: matAlgo06xS0S0,
        DS: matAlgo02xDS0,
        Ss: matAlgo11xS0s
    }));
});





var $a94e1f2b547c0bb8$var$name = "bitNot";
var $a94e1f2b547c0bb8$var$dependencies = [
    "typed"
];
var $a94e1f2b547c0bb8$export$9e7f3c72ca8b5aa = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a94e1f2b547c0bb8$var$name, $a94e1f2b547c0bb8$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Bitwise NOT value, `~x`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.bitNot(x)
   *
   * Examples:
   *
   *    math.bitNot(1)               // returns number -2
   *
   *    math.bitNot([2, -3, 4])      // returns Array [-3, 2, -5]
   *
   * See also:
   *
   *    bitAnd, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x Value to not
   * @return {number | BigNumber | bigint | Array | Matrix} NOT of `x`
   */ return typed($a94e1f2b547c0bb8$var$name, {
        number: (0, $23d3870094e55520$export$22a2b2a0351218e7),
        BigNumber: (0, $6f96750d17929332$export$2ada53b3c51e9645),
        bigint: (x)=>~x,
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});








var $a68747c1126dd4e3$var$name = "bitOr";
var $a68747c1126dd4e3$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix",
    "concat"
];
var $a68747c1126dd4e3$export$f45a7846535e9b07 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a68747c1126dd4e3$var$name, $a68747c1126dd4e3$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $a0c1a11a7836c6b2$export$727ab96f88a9e651)({
        typed: typed
    });
    var matAlgo04xSidSid = (0, $64a06aca87feb287$export$1dd33d839e34f63c)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $00357ab6509f98c8$export$5295edae9a41ff00)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Bitwise OR two values, `x | y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the lowest print base.
   *
   * Syntax:
   *
   *    math.bitOr(x, y)
   *
   * Examples:
   *
   *    math.bitOr(1, 2)               // returns number 3
   *
   *    math.bitOr([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x First value to or
   * @param  {number | BigNumber | bigint | Array | Matrix} y Second value to or
   * @return {number | BigNumber | bigint | Array | Matrix} OR of `x` and `y`
   */ return typed($a68747c1126dd4e3$var$name, {
        "number, number": (0, $23d3870094e55520$export$9aecb772cb5ad1c7),
        "BigNumber, BigNumber": (0, $6f96750d17929332$export$e43ec6c4cff46d2c),
        "bigint, bigint": (x, y)=>x | y
    }, matrixAlgorithmSuite({
        SS: matAlgo04xSidSid,
        DS: matAlgo01xDSid,
        Ss: matAlgo10xSids
    }));
});





var $5e352e66a45fa3fa$var$name = "matAlgo07xSSf";
var $5e352e66a45fa3fa$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $5e352e66a45fa3fa$export$439c4d7accd2a586 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($5e352e66a45fa3fa$var$name, $5e352e66a45fa3fa$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B items (zero and nonzero) and invokes the callback function f(Aij, Bij).
   * Callback function invoked MxN times.
   *
   * C(i,j) = f(Aij, Bij)
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function matAlgo07xSSf(a, b, callback) {
        // sparse matrix arrays
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // sparse matrix arrays
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string" && adt === bdt && adt !== "mixed") {
            // datatype
            dt = adt;
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // vars
        var i, j;
        // result arrays
        var cdata = [];
        // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
        // workspaces
        var xa = [];
        var xb = [];
        // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = [];
        // loop columns
        for(j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1;
            // scatter the values of A(:,j) into workspace
            _scatter(a, j, wa, xa, mark);
            // scatter the values of B(:,j) into workspace
            _scatter(b, j, wb, xb, mark);
            // loop rows
            for(i = 0; i < rows; i++){
                // matrix values @ i,j
                var va = wa[i] === mark ? xa[i] : zero;
                var vb = wb[i] === mark ? xb[i] : zero;
                // invoke callback
                cdata[i][j] = cf(va, vb);
            }
        }
        // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
    function _scatter(m, j, w, x, mark) {
        // a arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // loop values in column j
        for(var k = ptr[j], k1 = ptr[j + 1]; k < k1; k++){
            // row
            var i = index[k];
            // update workspace
            w[i] = mark;
            x[i] = values[k];
        }
    }
});






var $573b3a9c20c2e229$var$name = "bitXor";
var $573b3a9c20c2e229$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix",
    "concat"
];
var $573b3a9c20c2e229$export$1cae728fa8e01928 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($573b3a9c20c2e229$var$name, $573b3a9c20c2e229$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $5e352e66a45fa3fa$export$439c4d7accd2a586)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Bitwise XOR two values, `x ^ y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitXor(x, y)
   *
   * Examples:
   *
   *    math.bitXor(1, 2)               // returns number 3
   *
   *    math.bitXor([2, 3, 4], 4)       // returns Array [6, 7, 0]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x First value to xor
   * @param  {number | BigNumber | bigint | Array | Matrix} y Second value to xor
   * @return {number | BigNumber | bigint | Array | Matrix} XOR of `x` and `y`
   */ return typed($573b3a9c20c2e229$var$name, {
        "number, number": (0, $23d3870094e55520$export$2260a44ec1c987dc),
        "BigNumber, BigNumber": (0, $6f96750d17929332$export$bfcff4501301c191),
        "bigint, bigint": (x, y)=>x ^ y
    }, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});



var $e80b9cf32ddb26b3$var$name = "boolean";
var $e80b9cf32ddb26b3$var$dependencies = [
    "typed"
];
var $e80b9cf32ddb26b3$export$3c82aec2d86a5525 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e80b9cf32ddb26b3$var$name, $e80b9cf32ddb26b3$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a boolean or convert a string or number to a boolean.
   * In case of a number, `true` is returned for non-zero numbers, and `false` in
   * case of zero.
   * Strings can be `'true'` or `'false'`, or can contain a number.
   * When value is a matrix, all elements will be converted to boolean.
   *
   * Syntax:
   *
   *    math.boolean(x)
   *
   * Examples:
   *
   *    math.boolean(0)     // returns false
   *    math.boolean(1)     // returns true
   *    math.boolean(-3)     // returns true
   *    math.boolean('true')     // returns true
   *    math.boolean('false')     // returns false
   *    math.boolean([1, 0, 1, 1])     // returns [true, false, true, true]
   *
   * See also:
   *
   *    bignumber, complex, index, matrix, string, unit
   *
   * @param {string | number | boolean | Array | Matrix | null} value  A value of any type
   * @return {boolean | Array | Matrix} The boolean value
   */ return typed($e80b9cf32ddb26b3$var$name, {
        "": function _() {
            return false;
        },
        boolean: function boolean(x) {
            return x;
        },
        number: function number(x) {
            return !!x;
        },
        null: function _null(x) {
            return false;
        },
        BigNumber: function BigNumber(x) {
            return !x.isZero();
        },
        string: function string(x) {
            // try case insensitive
            var lcase = x.toLowerCase();
            if (lcase === "true") return true;
            else if (lcase === "false") return false;
            // test whether value is a valid number
            var num = Number(x);
            if (x !== "" && !isNaN(num)) return !!num;
            throw new Error('Cannot convert "' + x + '" to a boolean');
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});


var $92cdff0f51648878$var$name = "catalan";
var $92cdff0f51648878$var$dependencies = [
    "typed",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "combinations",
    "isNegative",
    "isInteger"
];
var $92cdff0f51648878$export$5a3f7692f3d4dd50 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($92cdff0f51648878$var$name, $92cdff0f51648878$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, combinations: combinations, isNegative: isNegative, isInteger: isInteger } = _ref;
    /**
   * The Catalan Numbers enumerate combinatorial structures of many different types.
   * catalan only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.catalan(n)
   *
   * Examples:
   *
   *    math.catalan(3) // returns 5
   *    math.catalan(8) // returns 1430
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    nth Catalan number
   * @return {Number | BigNumber}     Cn(n)
   */ return typed($92cdff0f51648878$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError("Non-negative integer value expected in function catalan");
            return divideScalar(combinations(multiplyScalar(n, 2), n), addScalar(n, 1));
        }
    });
});




var $d6787f501a70ed33$var$name = "cbrt";
var $d6787f501a70ed33$var$dependencies = [
    "config",
    "typed",
    "isNegative",
    "unaryMinus",
    "matrix",
    "Complex",
    "BigNumber",
    "Fraction"
];
var $d6787f501a70ed33$export$2103fed9c34b0004 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d6787f501a70ed33$var$name, $d6787f501a70ed33$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, isNegative: isNegative, unaryMinus: unaryMinus, matrix: matrix, Complex: Complex, BigNumber: BigNumber, Fraction: Fraction } = _ref;
    /**
   * Calculate the cubic root of a value.
   *
   * To avoid confusion with the matrix cube root, this function does not
   * apply to matrices. For a matrix, to take the cube root elementwise,
   * see the examples.
   *
   * Syntax:
   *
   *    math.cbrt(x)
   *    math.cbrt(x, allRoots)
   *
   * Examples:
   *
   *    math.cbrt(27)                  // returns 3
   *    math.cube(3)                   // returns 27
   *    math.cbrt(-64)                 // returns -4
   *    math.cbrt(math.unit('27 m^3')) // returns Unit 3 m
   *    math.map([27, 64, 125], x => math.cbrt(x))       // returns [3, 4, 5]
   *
   *    const x = math.complex('8i')
   *    math.cbrt(x)                   // returns Complex 1.7320508075689 + i
   *    math.cbrt(x, true)             // returns Matrix [
   *                                    //    1.7320508075689 + i
   *                                    //   -1.7320508075689 + i
   *                                    //   -2i
   *                                    // ]
   *
   * See also:
   *
   *    square, sqrt, cube
   *
   * @param {number | BigNumber | Complex | Unit} x
   *            Value for which to calculate the cubic root.
   * @param {boolean} [allRoots]  Optional, false by default. Only applicable
   *            when `x` is a number or complex number. If true, all complex
   *            roots are returned, if false (default) the principal root is
   *            returned.
   * @return {number | BigNumber | Complex | Unit}
   *            Returns the cubic root of `x`
   */ return typed($d6787f501a70ed33$var$name, {
        number: (0, $f38f49d8e24d4a9f$export$95c2aecb85f70726),
        // note: signature 'number, boolean' is also supported,
        //       created by typed as it knows how to convert number to Complex
        Complex: _cbrtComplex,
        "Complex, boolean": _cbrtComplex,
        BigNumber: function BigNumber(x) {
            return x.cbrt();
        },
        Unit: _cbrtUnit
    });
    /**
   * Calculate the cubic root for a complex number
   * @param {Complex} x
   * @param {boolean} [allRoots]   If true, the function will return an array
   *                               with all three roots. If false or undefined,
   *                               the principal root is returned.
   * @returns {Complex | Array.<Complex> | Matrix.<Complex>} Returns the cubic root(s) of x
   * @private
   */ function _cbrtComplex(x, allRoots) {
        // https://www.wikiwand.com/en/Cube_root#/Complex_numbers
        var arg3 = x.arg() / 3;
        var abs = x.abs();
        // principal root:
        var principal = new Complex((0, $f38f49d8e24d4a9f$export$95c2aecb85f70726)(abs), 0).mul(new Complex(0, arg3).exp());
        if (allRoots) {
            var all = [
                principal,
                new Complex((0, $f38f49d8e24d4a9f$export$95c2aecb85f70726)(abs), 0).mul(new Complex(0, arg3 + Math.PI * 2 / 3).exp()),
                new Complex((0, $f38f49d8e24d4a9f$export$95c2aecb85f70726)(abs), 0).mul(new Complex(0, arg3 - Math.PI * 2 / 3).exp())
            ];
            return config.matrix === "Array" ? all : matrix(all);
        } else return principal;
    }
    /**
   * Calculate the cubic root for a Unit
   * @param {Unit} x
   * @return {Unit} Returns the cubic root of x
   * @private
   */ function _cbrtUnit(x) {
        if (x.value && (0, $23cfe017d190638f$export$8849a896711efe0c)(x.value)) {
            var result = x.clone();
            result.value = 1.0;
            result = result.pow(1.0 / 3); // Compute the units
            result.value = _cbrtComplex(x.value); // Compute the value
            return result;
        } else {
            var negate = isNegative(x.value);
            if (negate) x.value = unaryMinus(x.value);
            // TODO: create a helper function for this
            var third;
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(x.value)) third = new BigNumber(1).div(3);
            else if ((0, $23cfe017d190638f$export$e312cb8a8e5e7c34)(x.value)) third = new Fraction(1, 3);
            else third = 1 / 3;
            var _result = x.pow(third);
            if (negate) _result.value = unaryMinus(_result.value);
            return _result;
        }
    }
});





/**
 * Compares two BigNumbers.
 * @param {BigNumber} a - First value to compare
 * @param {BigNumber} b - Second value to compare
 * @param {number} [relTol=1e-09] - The relative tolerance, indicating the maximum allowed difference relative to the larger absolute value. Must be greater than 0.
 * @param {number} [absTol=0] - The minimum absolute tolerance, useful for comparisons near zero. Must be at least 0.
 * @returns {boolean} whether the two numbers are nearly equal
 * @throws {Error} If `relTol` is less than or equal to 0.
 * @throws {Error} If `absTol` is less than 0.
 *
 * @example
 * nearlyEqual(1.000000001, 1.0, 1e-9);            // true
 * nearlyEqual(1.000000002, 1.0, 0);            // false
 * nearlyEqual(1.0, 1.009, undefined, 0.02);       // true
 * nearlyEqual(0.000000001, 0.0, undefined, 1e-8); // true
 */ function $6a2233744a2a4c6f$export$6f3989c6ecc04081(a, b) {
    var relTol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e-9;
    var absTol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    if (relTol <= 0) throw new Error("Relative tolerance must be greater than 0");
    if (absTol < 0) throw new Error("Absolute tolerance must be at least 0");
    // NaN
    if (a.isNaN() || b.isNaN()) return false;
    if (!a.isFinite() || !b.isFinite()) return a.eq(b);
    // use "==" operator, handles infinities
    if (a.eq(b)) return true;
    // abs(a-b) <= max(relTol * max(abs(a), abs(b)), absTol)
    return a.minus(b).abs().lte(a.constructor.max(a.constructor.max(a.abs(), b.abs()).mul(relTol), absTol));
}





var $651047ae30ddd654$var$name = "ceil";
var $651047ae30ddd654$var$dependencies = [
    "typed",
    "config",
    "round",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $651047ae30ddd654$export$7f32b339ed8a324b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($651047ae30ddd654$var$name, [
    "typed",
    "config",
    "round"
], (_ref)=>{
    var { typed: typed, config: config, round: round } = _ref;
    return typed($651047ae30ddd654$var$name, {
        number: function number(x) {
            if ((0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, round(x), config.relTol, config.absTol)) return round(x);
            else return Math.ceil(x);
        },
        "number, number": function numberNumber(x, n) {
            if ((0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, round(x, n), config.relTol, config.absTol)) return round(x, n);
            else {
                var [number, exponent] = "".concat(x, "e").split("e");
                var result = Math.ceil(Number("".concat(number, "e").concat(Number(exponent) + n)));
                [number, exponent] = "".concat(result, "e").split("e");
                return Number("".concat(number, "e").concat(Number(exponent) - n));
            }
        }
    });
});
var $651047ae30ddd654$export$bab247d909829ddf = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($651047ae30ddd654$var$name, $651047ae30ddd654$var$dependencies, (_ref2)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo14xDs = (0, $ada7281b5c8c5fa6$export$4b07063314120f7c)({
        typed: typed
    });
    var ceilNumber = $651047ae30ddd654$export$7f32b339ed8a324b({
        typed: typed,
        config: config,
        round: round
    });
    /**
   * Round a value towards plus infinity
   * If `x` is complex, both real and imaginary part are rounded towards plus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.ceil(x)
   *    math.ceil(x, n)
   *
   * Examples:
   *
   *    math.ceil(3.2)               // returns number 4
   *    math.ceil(3.8)               // returns number 4
   *    math.ceil(-4.2)              // returns number -4
   *    math.ceil(-4.7)              // returns number -4
   *
   *    math.ceil(3.212, 2)          // returns number 3.22
   *    math.ceil(3.288, 2)          // returns number 3.29
   *    math.ceil(-4.212, 2)         // returns number -4.21
   *    math.ceil(-4.782, 2)         // returns number -4.78
   *
   *    const c = math.complex(3.24, -2.71)
   *    math.ceil(c)                 // returns Complex 4 - 2i
   *    math.ceil(c, 1)              // returns Complex 3.3 - 2.7i
   *
   *    math.ceil([3.2, 3.8, -4.7])  // returns Array [4, 4, -4]
   *    math.ceil([3.21, 3.82, -4.71], 1)  // returns Array [3.3, 3.9, -4.7]
   *
   * See also:
   *
   *    floor, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed("ceil", {
        number: ceilNumber.signatures.number,
        "number,number": ceilNumber.signatures["number,number"],
        Complex: function Complex(x) {
            return x.ceil();
        },
        "Complex, number": function ComplexNumber(x, n) {
            return x.ceil(n);
        },
        "Complex, BigNumber": function ComplexBigNumber(x, n) {
            return x.ceil(n.toNumber());
        },
        BigNumber: function BigNumber(x) {
            if ((0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, round(x), config.relTol, config.absTol)) return round(x);
            else return x.ceil();
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, n) {
            if ((0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, round(x, n), config.relTol, config.absTol)) return round(x, n);
            else return x.toDecimalPlaces(n.toNumber(), (0, (/*@__PURE__*/$parcel$interopDefault($22467ec447bdc2ca$exports))).ROUND_CEIL);
        },
        Fraction: function Fraction(x) {
            return x.ceil();
        },
        "Fraction, number": function FractionNumber(x, n) {
            return x.ceil(n);
        },
        "Fraction, BigNumber": function FractionBigNumber(x, n) {
            return x.ceil(n.toNumber());
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>{
                // deep map collection, skip zeros since ceil(0) = 0
                return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self, true);
            }),
        "Array, number | BigNumber": typed.referToSelf((self)=>(x, n)=>{
                // deep map collection, skip zeros since ceil(0) = 0
                return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, (i)=>self(i, n), true);
            }),
        "SparseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, y)=>{
                return matAlgo11xS0s(x, y, self, false);
            }),
        "DenseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, y)=>{
                return matAlgo14xDs(x, y, self, false);
            }),
        "number | Complex | Fraction | BigNumber, Array": typed.referToSelf((self)=>(x, y)=>{
                // use matrix implementation
                return matAlgo14xDs(matrix(y), x, self, true).valueOf();
            }),
        "number | Complex | Fraction | BigNumber, Matrix": typed.referToSelf((self)=>(x, y)=>{
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                if (y.storage() === "dense") return matAlgo14xDs(y, x, self, true);
                return matAlgo12xSfs(y, x, self, true);
            })
    });
});



var $97806624bc4daa59$var$name = "clone";
var $97806624bc4daa59$var$dependencies = [
    "typed"
];
var $97806624bc4daa59$export$39ad70de4044028a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($97806624bc4daa59$var$name, $97806624bc4daa59$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Clone an object. Will make a deep copy of the data.
   *
   * Syntax:
   *
   *     math.clone(x)
   *
   * Examples:
   *
   *    math.clone(3.5)                   // returns number 3.5
   *    math.clone(math.complex('2-4i'))  // returns Complex 2 - 4i
   *    math.clone(math.unit(45, 'deg'))  // returns Unit 45 deg
   *    math.clone([[1, 2], [3, 4]])      // returns Array [[1, 2], [3, 4]]
   *    math.clone("hello world")         // returns string "hello world"
   *
   * @param {*} x   Object to be cloned
   * @return {*} A clone of object x
   */ return typed($97806624bc4daa59$var$name, {
        any: (0, $46a94b3d1146edd8$export$9cd59f9826255e47)
    });
});





var $e16a495e01b5c57a$var$name = "column";
var $e16a495e01b5c57a$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $e16a495e01b5c57a$export$1bfa986e9c92c0b5 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e16a495e01b5c57a$var$name, $e16a495e01b5c57a$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    /**
   * Return a column from a Matrix.
   *
   * Syntax:
   *
   *     math.column(value, index)
   *
   * Example:
   *
   *     // get a column
   *     const d = [[1, 2], [3, 4]]
   *     math.column(d, 1) // returns [[2], [4]]
   *
   * See also:
   *
   *     row
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} column           The index of the column
   * @return {Array | Matrix}         The retrieved column
   */ return typed($e16a495e01b5c57a$var$name, {
        "Matrix, number": _column,
        "Array, number": function ArrayNumber(value, column) {
            return _column(matrix((0, $46a94b3d1146edd8$export$9cd59f9826255e47)(value)), column).valueOf();
        }
    });
    /**
   * Retrieve a column of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} column  The index of the column
   * @return {Matrix}        The retrieved column
   */ function _column(value, column) {
        // check dimensions
        if (value.size().length !== 2) throw new Error("Only two dimensional matrix is supported");
        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(column, value.size()[1]);
        var rowRange = range(0, value.size()[0]);
        var index = new Index(rowRange, column);
        var result = value.subset(index);
        return (0, $23cfe017d190638f$export$b22160e0a14f87b7)(result) ? result : matrix([
            [
                result
            ]
        ]);
    }
});



/** @param {number} i
 *  @param {number} n
 *  @returns {number} product of i to n
 */ function $22c7ec3c40338f55$export$dbd0f18357df1ddd(i, n) {
    if (n < i) return 1;
    if (n === i) return n;
    var half = n + i >> 1; // divide (n + i) by 2 and truncate to integer
    return $22c7ec3c40338f55$export$dbd0f18357df1ddd(i, half) * $22c7ec3c40338f55$export$dbd0f18357df1ddd(half + 1, n);
}


function $8f7f58b29fabdb98$export$2a122d28e37477a2(n, k) {
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(n) || n < 0) throw new TypeError("Positive integer value expected in function combinations");
    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(k) || k < 0) throw new TypeError("Positive integer value expected in function combinations");
    if (k > n) throw new TypeError("k must be less than or equal to n");
    var nMinusk = n - k;
    var answer = 1;
    var firstnumerator = k < nMinusk ? nMinusk + 1 : k + 1;
    var nextdivisor = 2;
    var lastdivisor = k < nMinusk ? k : nMinusk;
    // balance multiplications and divisions to try to keep intermediate values
    // in exact-integer range as long as possible
    for(var nextnumerator = firstnumerator; nextnumerator <= n; ++nextnumerator){
        answer *= nextnumerator;
        while(nextdivisor <= lastdivisor && answer % nextdivisor === 0){
            answer /= nextdivisor;
            ++nextdivisor;
        }
    }
    // for big n, k, floating point may have caused weirdness in remainder
    if (nextdivisor <= lastdivisor) answer /= (0, $22c7ec3c40338f55$export$dbd0f18357df1ddd)(nextdivisor, lastdivisor);
    return answer;
}
$8f7f58b29fabdb98$export$2a122d28e37477a2.signature = "number, number";


var $07d6664b75d4c02b$var$name = "combinations";
var $07d6664b75d4c02b$var$dependencies = [
    "typed"
];
var $07d6664b75d4c02b$export$63e3129a196da23d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($07d6664b75d4c02b$var$name, $07d6664b75d4c02b$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities.
   *
   * Combinations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.combinations(n, k)
   *
   * Examples:
   *
   *    math.combinations(7, 5) // returns 21
   *
   * See also:
   *
   *    combinationsWithRep, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations.
   */ return typed($07d6664b75d4c02b$var$name, {
        "number, number": (0, $8f7f58b29fabdb98$export$2a122d28e37477a2),
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var nMinusk = n.minus(k);
            var one = new BigNumber(1);
            if (!$07d6664b75d4c02b$var$isPositiveInteger(n) || !$07d6664b75d4c02b$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function combinations");
            if (k.gt(n)) throw new TypeError("k must be less than n in function combinations");
            result = one;
            if (k.lt(nMinusk)) for(i = one; i.lte(nMinusk); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusk.plus(i)).dividedBy(i);
            return result;
        }
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $07d6664b75d4c02b$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}




var $3132671d543c7922$var$name = "combinationsWithRep";
var $3132671d543c7922$var$dependencies = [
    "typed"
];
var $3132671d543c7922$export$4bdc90311ec7c1dd = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3132671d543c7922$var$name, $3132671d543c7922$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities, allowing individual outcomes to be repeated more than once.
   *
   * CombinationsWithRep only takes integer arguments.
   * The following condition must be enforced: k <= n + k -1.
   *
   * Syntax:
   *
   *     math.combinationsWithRep(n, k)
   *
   * Examples:
   *
   *    math.combinationsWithRep(7, 5) // returns 462
   *
   * See also:
   *
   *    combinations, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations with replacement.
   */ return typed($3132671d543c7922$var$name, {
        "number, number": function numberNumber(n, k) {
            if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(n) || n < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(k) || k < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (n < 1) throw new TypeError("k must be less than or equal to n + k - 1");
            if (k < n - 1) {
                var _prodrange = (0, $22c7ec3c40338f55$export$dbd0f18357df1ddd)(n, n + k - 1);
                return _prodrange / (0, $22c7ec3c40338f55$export$dbd0f18357df1ddd)(1, k);
            }
            var prodrange = (0, $22c7ec3c40338f55$export$dbd0f18357df1ddd)(k + 1, n + k - 1);
            return prodrange / (0, $22c7ec3c40338f55$export$dbd0f18357df1ddd)(1, n - 1);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var one = new BigNumber(1);
            var nMinusOne = n.minus(one);
            if (!$3132671d543c7922$var$isPositiveInteger(n) || !$3132671d543c7922$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (n.lt(one)) throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
            result = one;
            if (k.lt(nMinusOne)) for(i = one; i.lte(nMinusOne); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusOne.plus(i)).dividedBy(i);
            return result;
        }
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $3132671d543c7922$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}








var $a54f9597be0f9a42$var$name = "matAlgo05xSfSf";
var $a54f9597be0f9a42$var$dependencies = [
    "typed",
    "equalScalar"
];
var $a54f9597be0f9a42$export$a0ee15a3591ad1a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a54f9597be0f9a42$var$name, $a54f9597be0f9a42$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 || B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function matAlgo05xSfSf(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string" && adt === bdt && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // workspaces
        var xa = cvalues ? [] : undefined;
        var xb = cvalues ? [] : undefined;
        // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = [];
        // vars
        var i, j, k, k1;
        // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // columns mark
            var mark = j + 1;
            // loop values A(:,j)
            for(k = aptr[j], k1 = aptr[j + 1]; k < k1; k++){
                // row
                i = aindex[k];
                // push index
                cindex.push(i);
                // update workspace
                wa[i] = mark;
                // check we need to process values
                if (xa) xa[i] = avalues[k];
            }
            // loop values B(:,j)
            for(k = bptr[j], k1 = bptr[j + 1]; k < k1; k++){
                // row
                i = bindex[k];
                // check row existed in A
                if (wa[i] !== mark) // push index
                cindex.push(i);
                // update workspace
                wb[i] = mark;
                // check we need to process values
                if (xb) xb[i] = bvalues[k];
            }
            // check we need to process values (non pattern matrix)
            if (cvalues) {
                // initialize first index in j
                k = cptr[j];
                // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k];
                    // marks
                    var wai = wa[i];
                    var wbi = wb[i];
                    // check Aij or Bij are nonzero
                    if (wai === mark || wbi === mark) {
                        // matrix values @ i,j
                        var va = wai === mark ? xa[i] : zero;
                        var vb = wbi === mark ? xb[i] : zero;
                        // Cij
                        var vc = cf(va, vb);
                        // check for zero
                        if (!eq(vc, zero)) {
                            // push value
                            cvalues.push(vc);
                            // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    }
                }
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
});




var $c47ed063b6d2cbd9$export$f15f03c51630bb25 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)("compareUnits", [
    "typed"
], (_ref)=>{
    var { typed: typed } = _ref;
    return {
        "Unit, Unit": typed.referToSelf((self)=>(x, y)=>{
                if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
                return typed.find(self, [
                    x.valueType(),
                    y.valueType()
                ])(x.value, y.value);
            })
    };
});


var $a8f31786c0d995dc$var$name = "compare";
var $a8f31786c0d995dc$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "equalScalar",
    "BigNumber",
    "Fraction",
    "DenseMatrix",
    "concat"
];
var $a8f31786c0d995dc$export$a6e723c0e3b918d4 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a8f31786c0d995dc$var$name, $a8f31786c0d995dc$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, equalScalar: equalScalar, matrix: matrix, BigNumber: BigNumber, Fraction: Fraction, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo05xSfSf = (0, $a54f9597be0f9a42$export$a0ee15a3591ad1a)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var compareUnits = (0, $c47ed063b6d2cbd9$export$f15f03c51630bb25)({
        typed: typed
    });
    /**
   * Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * x and y are considered equal when the relative difference between x and y
   * is smaller than the configured absTol and relTol. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.compare(x, y)
   *
   * Examples:
   *
   *    math.compare(6, 1)           // returns 1
   *    math.compare(2, 3)           // returns -1
   *    math.compare(7, 7)           // returns 0
   *    math.compare('10', '2')      // returns 1
   *    math.compare('1000', '1e3')  // returns 0
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compare(a, b)           // returns 1
   *
   *    math.compare(2, [1, 2, 3])   // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, largerEq, compareNatural, compareText
   *
   * @param  {number | BigNumber | bigint | Fraction | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | Fraction | Unit | string | Array | Matrix} y Second value to compare
   * @return {number | BigNumber | bigint | Fraction | Array | Matrix} Returns the result of the comparison:
   *                                                          1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($a8f31786c0d995dc$var$name, $a8f31786c0d995dc$export$e744cf3e2e3d6926({
        typed: typed,
        config: config
    }), {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x === y ? 0 : x > y ? 1 : -1;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return (0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol) ? new BigNumber(0) : new BigNumber(x.cmp(y));
        },
        "bigint, bigint": function bigintBigint(x, y) {
            return x === y ? 0n : x > y ? 1n : -1n;
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return new Fraction(x.compare(y));
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        }
    }, compareUnits, matrixAlgorithmSuite({
        SS: matAlgo05xSfSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $a8f31786c0d995dc$export$e744cf3e2e3d6926 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a8f31786c0d995dc$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($a8f31786c0d995dc$var$name, {
        "number, number": function numberNumber(x, y) {
            return (0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol) ? 0 : x > y ? 1 : -1;
        }
    });
});




var $cc9ce6148945a1e3$var$name = "compareNatural";
var $cc9ce6148945a1e3$var$dependencies = [
    "typed",
    "compare"
];
var $cc9ce6148945a1e3$export$ac9dd39e43534605 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($cc9ce6148945a1e3$var$name, $cc9ce6148945a1e3$var$dependencies, (_ref)=>{
    var { typed: typed, compare: compare } = _ref;
    var compareBooleans = compare.signatures["boolean,boolean"];
    /**
   * Compare two values of any type in a deterministic, natural way.
   *
   * For numeric values, the function works the same as `math.compare`.
   * For types of values that can't be compared mathematically,
   * the function compares in a natural way.
   *
   * For numeric values, x and y are considered equal when the relative
   * difference between x and y is smaller than the configured relTol and absTol.
   * The function cannot be used to compare values smaller than
   * approximately 2.22e-16.
   *
   * For Complex numbers, first the real parts are compared. If equal,
   * the imaginary parts are compared.
   *
   * Strings are compared with a natural sorting algorithm, which
   * orders strings in a "logic" way following some heuristics.
   * This differs from the function `compare`, which converts the string
   * into a numeric value and compares that. The function `compareText`
   * on the other hand compares text lexically.
   *
   * Arrays and Matrices are compared value by value until there is an
   * unequal pair of values encountered. Objects are compared by sorted
   * keys until the keys or their values are unequal.
   *
   * Syntax:
   *
   *    math.compareNatural(x, y)
   *
   * Examples:
   *
   *    math.compareNatural(6, 1)              // returns 1
   *    math.compareNatural(2, 3)              // returns -1
   *    math.compareNatural(7, 7)              // returns 0
   *
   *    math.compareNatural('10', '2')         // returns 1
   *    math.compareText('10', '2')            // returns -1
   *    math.compare('10', '2')                // returns 1
   *
   *    math.compareNatural('Answer: 10', 'Answer: 2') // returns 1
   *    math.compareText('Answer: 10', 'Answer: 2')    // returns -1
   *    math.compare('Answer: 10', 'Answer: 2')
   *        // Error: Cannot convert "Answer: 10" to a number
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compareNatural(a, b)              // returns 1
   *
   *    const c = math.complex('2 + 3i')
   *    const d = math.complex('2 + 4i')
   *    math.compareNatural(c, d)              // returns -1
   *
   *    math.compareNatural([1, 2, 4], [1, 2, 3]) // returns 1
   *    math.compareNatural([1, 2, 3], [1, 2])    // returns 1
   *    math.compareNatural([1, 5], [1, 2, 3])    // returns 1
   *    math.compareNatural([1, 2], [1, 2])       // returns 0
   *
   *    math.compareNatural({a: 2}, {a: 4})       // returns -1
   *
   * See also:
   *
   *    compare, compareText
   *
   * @param  {*} x First value to compare
   * @param  {*} y Second value to compare
   * @return {number} Returns the result of the comparison:
   *                  1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($cc9ce6148945a1e3$var$name, {
        "any, any": _compareNatural
    }); // just to check # args
    function _compareNatural(x, y) {
        var typeX = (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(x);
        var typeY = (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(y);
        var c;
        // numeric types
        if ((typeX === "number" || typeX === "BigNumber" || typeX === "Fraction") && (typeY === "number" || typeY === "BigNumber" || typeY === "Fraction")) {
            c = compare(x, y);
            if (c.toString() !== "0") // c can be number, BigNumber, or Fraction
            return c > 0 ? 1 : -1; // return a number
            else return (0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports)))(typeX, typeY);
        }
        // matrix types
        var matTypes = [
            "Array",
            "DenseMatrix",
            "SparseMatrix"
        ];
        if (matTypes.includes(typeX) || matTypes.includes(typeY)) {
            c = compareMatricesAndArrays(_compareNatural, x, y);
            if (c !== 0) return c;
            else return (0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports)))(typeX, typeY);
        }
        // in case of different types, order by name of type, i.e. 'BigNumber' < 'Complex'
        if (typeX !== typeY) return (0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports)))(typeX, typeY);
        if (typeX === "Complex") return $cc9ce6148945a1e3$var$compareComplexNumbers(x, y);
        if (typeX === "Unit") {
            if (x.equalBase(y)) return _compareNatural(x.value, y.value);
            // compare by units
            return compareArrays(_compareNatural, x.formatUnits(), y.formatUnits());
        }
        if (typeX === "boolean") return compareBooleans(x, y);
        if (typeX === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports)))(x, y);
        if (typeX === "Object") return compareObjects(_compareNatural, x, y);
        if (typeX === "null") return 0;
        if (typeX === "undefined") return 0;
        // this should not occur...
        throw new TypeError('Unsupported type of value "' + typeX + '"');
    }
    /**
   * Compare mixed matrix/array types, by converting to same-shaped array.
   * This comparator is non-deterministic regarding input types.
   * @param {Array | SparseMatrix | DenseMatrix | *} x
   * @param {Array | SparseMatrix | DenseMatrix | *} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareMatricesAndArrays(compareNatural, x, y) {
        if ((0, $23cfe017d190638f$export$d508368d4da3c38a)(x) && (0, $23cfe017d190638f$export$d508368d4da3c38a)(y)) return compareArrays(compareNatural, x.toJSON().values, y.toJSON().values);
        if ((0, $23cfe017d190638f$export$d508368d4da3c38a)(x)) // note: convert to array is expensive
        return compareMatricesAndArrays(compareNatural, x.toArray(), y);
        if ((0, $23cfe017d190638f$export$d508368d4da3c38a)(y)) // note: convert to array is expensive
        return compareMatricesAndArrays(compareNatural, x, y.toArray());
        // convert DenseArray into Array
        if ((0, $23cfe017d190638f$export$eb44495df7ba11d)(x)) return compareMatricesAndArrays(compareNatural, x.toJSON().data, y);
        if ((0, $23cfe017d190638f$export$eb44495df7ba11d)(y)) return compareMatricesAndArrays(compareNatural, x, y.toJSON().data);
        // convert scalars to array
        if (!Array.isArray(x)) return compareMatricesAndArrays(compareNatural, [
            x
        ], y);
        if (!Array.isArray(y)) return compareMatricesAndArrays(compareNatural, x, [
            y
        ]);
        return compareArrays(compareNatural, x, y);
    }
    /**
   * Compare two Arrays
   *
   * - First, compares value by value
   * - Next, if all corresponding values are equal,
   *   look at the length: longest array will be considered largest
   *
   * @param {Array} x
   * @param {Array} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareArrays(compareNatural, x, y) {
        // compare each value
        for(var i = 0, ii = Math.min(x.length, y.length); i < ii; i++){
            var v = compareNatural(x[i], y[i]);
            if (v !== 0) return v;
        }
        // compare the size of the arrays
        if (x.length > y.length) return 1;
        if (x.length < y.length) return -1;
        // both Arrays have equal size and content
        return 0;
    }
    /**
   * Compare two objects
   *
   * - First, compare sorted property names
   * - Next, compare the property values
   *
   * @param {Object} x
   * @param {Object} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareObjects(compareNatural, x, y) {
        var keysX = Object.keys(x);
        var keysY = Object.keys(y);
        // compare keys
        keysX.sort((0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports))));
        keysY.sort((0, (/*@__PURE__*/$parcel$interopDefault($686a00245b7b9b4d$exports))));
        var c = compareArrays(compareNatural, keysX, keysY);
        if (c !== 0) return c;
        // compare values
        for(var i = 0; i < keysX.length; i++){
            var v = compareNatural(x[keysX[i]], y[keysY[i]]);
            if (v !== 0) return v;
        }
        return 0;
    }
});
/**
 * Compare two complex numbers, `x` and `y`:
 *
 * - First, compare the real values of `x` and `y`
 * - If equal, compare the imaginary values of `x` and `y`
 *
 * @params {Complex} x
 * @params {Complex} y
 * @returns {number} Returns the comparison result: -1, 0, or 1
 */ function $cc9ce6148945a1e3$var$compareComplexNumbers(x, y) {
    if (x.re > y.re) return 1;
    if (x.re < y.re) return -1;
    if (x.im > y.im) return 1;
    if (x.im < y.im) return -1;
    return 0;
}




var $b5e8e12e1f843853$var$name = "compareText";
var $b5e8e12e1f843853$var$dependencies = [
    "typed",
    "matrix",
    "concat"
];
(0, $1b038b7ade911d0e$export$2da9287da10b19e2).signature = "any, any";
var $b5e8e12e1f843853$export$3e578d0534ab5935 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b5e8e12e1f843853$var$name, $b5e8e12e1f843853$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, concat: concat } = _ref;
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Compare two strings lexically. Comparison is case sensitive.
   * Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.compareText(x, y)
   *
   * Examples:
   *
   *    math.compareText('B', 'A')     // returns 1
   *    math.compareText('2', '10')    // returns 1
   *    math.compare('2', '10')        // returns -1
   *    math.compareNatural('2', '10') // returns -1
   *
   *    math.compareText('B', ['A', 'B', 'C']) // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, equalText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns the result of the comparison:
   *                                        1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($b5e8e12e1f843853$var$name, (0, $1b038b7ade911d0e$export$2da9287da10b19e2), matrixAlgorithmSuite({
        elop: (0, $1b038b7ade911d0e$export$2da9287da10b19e2),
        Ds: true
    }));
});
var $b5e8e12e1f843853$export$1d0ea0d151dafd85 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b5e8e12e1f843853$var$name, [
    "typed"
], (_ref2)=>{
    var { typed: typed } = _ref2;
    return typed($b5e8e12e1f843853$var$name, (0, $1b038b7ade911d0e$export$2da9287da10b19e2));
});



var $76be1aea8cfa4fc0$var$name = "complex";
var $76be1aea8cfa4fc0$var$dependencies = [
    "typed",
    "Complex"
];
var $76be1aea8cfa4fc0$export$82a905fb6826da0d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($76be1aea8cfa4fc0$var$name, $76be1aea8cfa4fc0$var$dependencies, (_ref)=>{
    var { typed: typed, Complex: Complex } = _ref;
    /**
   * Create a complex value or convert a value to a complex value.
   *
   * Syntax:
   *
   *     math.complex()                           // creates a complex value with zero
   *                                              // as real and imaginary part.
   *     math.complex(re : number, im : string)   // creates a complex value with provided
   *                                              // values for real and imaginary part.
   *     math.complex(re : number)                // creates a complex value with provided
   *                                              // real value and zero imaginary part.
   *     math.complex(complex : Complex)          // clones the provided complex value.
   *     math.complex(arg : string)               // parses a string into a complex value.
   *     math.complex(array : Array)              // converts the elements of the array
   *                                              // or matrix element wise into a
   *                                              // complex value.
   *     math.complex({re: number, im: number})   // creates a complex value with provided
   *                                              // values for real an imaginary part.
   *     math.complex({r: number, phi: number})   // creates a complex value with provided
   *                                              // polar coordinates
   *
   * Examples:
   *
   *    const a = math.complex(3, -4)     // a = Complex 3 - 4i
   *    a.re = 5                          // a = Complex 5 - 4i
   *    const i = a.im                    // Number -4
   *    const b = math.complex('2 + 6i')  // Complex 2 + 6i
   *    const c = math.complex()          // Complex 0 + 0i
   *    const d = math.add(a, b)          // Complex 5 + 2i
   *
   * See also:
   *
   *    bignumber, boolean, index, matrix, number, string, unit
   *
   * @param {* | Array | Matrix} [args]
   *            Arguments specifying the real and imaginary part of the complex number
   * @return {Complex | Array | Matrix} Returns a complex value
   */ return typed("complex", {
        "": function _() {
            return Complex.ZERO;
        },
        number: function number(x) {
            return new Complex(x, 0);
        },
        "number, number": function numberNumber(re, im) {
            return new Complex(re, im);
        },
        // TODO: this signature should be redundant
        "BigNumber, BigNumber": function BigNumberBigNumber(re, im) {
            return new Complex(re.toNumber(), im.toNumber());
        },
        Fraction: function Fraction(x) {
            return new Complex(x.valueOf(), 0);
        },
        Complex: function Complex(x) {
            return x.clone();
        },
        string: function string(x) {
            return Complex(x); // for example '2 + 3i'
        },
        null: function _null(x) {
            return Complex(0);
        },
        Object: function Object(x) {
            if ("re" in x && "im" in x) return new Complex(x.re, x.im);
            if ("r" in x && "phi" in x || "abs" in x && "arg" in x) return new Complex(x);
            throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});





var $da8f8ceba4b637ad$var$name = "Complex";
var $da8f8ceba4b637ad$var$dependencies = [];
var $da8f8ceba4b637ad$export$24a4be44fc8b6392 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($da8f8ceba4b637ad$var$name, $da8f8ceba4b637ad$var$dependencies, ()=>{
    /**
   * Attach type information
   */ Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))), "name", {
        value: "Complex"
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.constructor = (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports)));
    (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.type = "Complex";
    (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.isComplex = true;
    /**
   * Get a JSON representation of the complex number
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Complex", "re": 2, "im": 3}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.toJSON = function() {
        return {
            mathjs: "Complex",
            re: this.re,
            im: this.im
        };
    };
    /*
   * Return the value of the complex number in polar notation
   * The angle phi will be set in the interval of [-pi, pi].
   * @return {{r: number, phi: number}} Returns and object with properties r and phi.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.toPolar = function() {
        return {
            r: this.abs(),
            phi: this.arg()
        };
    };
    /**
   * Get a string representation of the complex number,
   * with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string} str
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.format = function(options) {
        var str = "";
        var im = this.im;
        var re = this.re;
        var strRe = (0, $a246eb207aab6d09$export$d9468344d3651243)(this.re, options);
        var strIm = (0, $a246eb207aab6d09$export$d9468344d3651243)(this.im, options);
        // round either re or im when smaller than the configured precision
        var precision = (0, $23cfe017d190638f$export$7e4aa119212bc614)(options) ? options : options ? options.precision : null;
        if (precision !== null) {
            var epsilon = Math.pow(10, -precision);
            if (Math.abs(re / im) < epsilon) re = 0;
            if (Math.abs(im / re) < epsilon) im = 0;
        }
        if (im === 0) // real value
        str = strRe;
        else if (re === 0) {
            // purely complex value
            if (im === 1) str = "i";
            else if (im === -1) str = "-i";
            else str = strIm + "i";
        } else {
            // complex value
            if (im < 0) {
                if (im === -1) str = strRe + " - i";
                else str = strRe + " - " + strIm.substring(1) + "i";
            } else if (im === 1) str = strRe + " + i";
            else str = strRe + " + " + strIm + "i";
        }
        return str;
    };
    /**
   * Create a complex number from polar coordinates
   *
   * Usage:
   *
   *     Complex.fromPolar(r: number, phi: number) : Complex
   *     Complex.fromPolar({r: number, phi: number}) : Complex
   *
   * @param {*} args...
   * @return {Complex}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).fromPolar = function(args) {
        switch(arguments.length){
            case 1:
                var arg = arguments[0];
                if (typeof arg === "object") return (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports)))(arg);
                else throw new TypeError("Input has to be an object with r and phi keys.");
            case 2:
                var r = arguments[0];
                var phi = arguments[1];
                if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(r)) {
                    if ((0, $23cfe017d190638f$export$8960dc335987b8da)(phi) && phi.hasBase("ANGLE")) // convert unit to a number in radians
                    phi = phi.toNumber("rad");
                    if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(phi)) return new (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports)))({
                        r: r,
                        phi: phi
                    });
                    throw new TypeError("Phi is not a number nor an angle unit.");
                } else throw new TypeError("Radius r is not a number.");
            default:
                throw new SyntaxError("Wrong number of arguments in function fromPolar");
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.valueOf = (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).prototype.toString;
    /**
   * Create a Complex number from a JSON object
   * @param {Object} json  A JSON Object structured as
   *                       {"mathjs": "Complex", "re": 2, "im": 3}
   *                       All properties are optional, default values
   *                       for `re` and `im` are 0.
   * @return {Complex} Returns a new Complex number
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports)))(json);
    };
    /**
   * Compare two complex numbers, `a` and `b`:
   *
   * - Returns 1 when the real part of `a` is larger than the real part of `b`
   * - Returns -1 when the real part of `a` is smaller than the real part of `b`
   * - Returns 1 when the real parts are equal
   *   and the imaginary part of `a` is larger than the imaginary part of `b`
   * - Returns -1 when the real parts are equal
   *   and the imaginary part of `a` is smaller than the imaginary part of `b`
   * - Returns 0 when both real and imaginary parts are equal.
   *
   * @params {Complex} a
   * @params {Complex} b
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports))).compare = function(a, b) {
        if (a.re > b.re) return 1;
        if (a.re < b.re) return -1;
        if (a.im > b.im) return 1;
        if (a.im < b.im) return -1;
        return 0;
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($2e216b23251d121c$exports));
}, {
    isClass: true
});


var $1a40f7586f911343$var$name = "composition";
var $1a40f7586f911343$var$dependencies = [
    "typed",
    "addScalar",
    "combinations",
    "isNegative",
    "isPositive",
    "isInteger",
    "larger"
];
var $1a40f7586f911343$export$1ddf9cbadd17315f = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($1a40f7586f911343$var$name, $1a40f7586f911343$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, combinations: combinations, isPositive: isPositive, isNegative: isNegative, isInteger: isInteger, larger: larger } = _ref;
    /**
   * The composition counts of n into k parts.
   *
   * composition only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *   math.composition(n, k)
   *
   * Examples:
   *
   *    math.composition(5, 3) // returns 6
   *
   * See also:
   *
   *    combinations
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     Returns the composition counts of n into k parts.
   */ return typed($1a40f7586f911343$var$name, {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || !isPositive(n) || !isInteger(k) || !isPositive(k)) throw new TypeError("Positive integer value expected in function composition");
            else if (larger(k, n)) throw new TypeError("k must be less than or equal to n in function composition");
            return combinations(addScalar(n, -1), addScalar(k, -1));
        }
    });
});







var $b26adab4221c7e8d$var$name = "concat";
var $b26adab4221c7e8d$var$dependencies = [
    "typed",
    "matrix",
    "isInteger"
];
var $b26adab4221c7e8d$export$c36b5511b12560e8 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b26adab4221c7e8d$var$name, $b26adab4221c7e8d$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isInteger: isInteger } = _ref;
    /**
   * Concatenate two or more matrices.
   *
   * Syntax:
   *
   *     math.concat(A, B, C, ...)
   *     math.concat(A, B, C, ..., dim)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *   By default the last dimension of the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [5, 6]]
   *    const B = [[3, 4], [7, 8]]
   *
   *    math.concat(A, B)                  // returns [[1, 2, 3, 4], [5, 6, 7, 8]]
   *    math.concat(A, B, 0)               // returns [[1, 2], [5, 6], [3, 4], [7, 8]]
   *    math.concat('hello', ' ', 'world') // returns 'hello world'
   *
   * See also:
   *
   *    size, squeeze, subset, transpose
   *
   * @param {... Array | Matrix} args     Two or more matrices
   * @return {Array | Matrix} Concatenated matrix
   */ return typed($b26adab4221c7e8d$var$name, {
        // TODO: change signature to '...Array | Matrix, dim?' when supported
        "...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumber(args) {
            var i;
            var len = args.length;
            var dim = -1; // zero-based dimension
            var prevDim;
            var asMatrix = false;
            var matrices = []; // contains multi dimensional arrays
            for(i = 0; i < len; i++){
                var arg = args[i];
                // test whether we need to return a Matrix (if not we return an Array)
                if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(arg)) asMatrix = true;
                if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(arg) || (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(arg)) {
                    if (i !== len - 1) throw new Error("Dimension must be specified as last argument");
                    // last argument contains the dimension on which to concatenate
                    prevDim = dim;
                    dim = arg.valueOf(); // change BigNumber to number
                    if (!isInteger(dim)) throw new TypeError("Integer number expected for dimension");
                    if (dim < 0 || i > 0 && dim > prevDim) // TODO: would be more clear when throwing a DimensionError here
                    throw new (0, $7e61b13fb7752c23$export$efa5eacb1304c464)(dim, prevDim + 1);
                } else {
                    // this is a matrix or array
                    var m = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(arg).valueOf();
                    var size = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(m);
                    matrices[i] = m;
                    prevDim = dim;
                    dim = size.length - 1;
                    // verify whether each of the matrices has the same number of dimensions
                    if (i > 0 && dim !== prevDim) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(prevDim + 1, dim + 1);
                }
            }
            if (matrices.length === 0) throw new SyntaxError("At least one matrix expected");
            var res = matrices.shift();
            while(matrices.length)res = (0, $eee21df0c3527ff1$export$ee1b3e54f0441b22)(res, matrices.shift(), dim);
            return asMatrix ? matrix(res) : res;
        },
        "...string": function string(args) {
            return args.join("");
        }
    });
});



var $421d08a6c65b63df$var$name = "conj";
var $421d08a6c65b63df$var$dependencies = [
    "typed"
];
var $421d08a6c65b63df$export$af5efe8ad97f01a2 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($421d08a6c65b63df$var$name, $421d08a6c65b63df$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the complex conjugate of a complex value.
   * If `x = a+bi`, the complex conjugate of `x` is `a - bi`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.conj(x)
   *
   * Examples:
   *
   *    math.conj(math.complex('2 + 3i'))  // returns Complex 2 - 3i
   *    math.conj(math.complex('2 - 3i'))  // returns Complex 2 + 3i
   *    math.conj(math.complex('-5.2i'))  // returns Complex 5.2i
   *
   * See also:
   *
   *    re, im, arg, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            The complex conjugate of x
   */ return typed($421d08a6c65b63df$var$name, {
        "number | BigNumber | Fraction": (x)=>x,
        Complex: (x)=>x.conjugate(),
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});


var $c289bf3dd95c4280$var$name = "corr";
var $c289bf3dd95c4280$var$dependencies = [
    "typed",
    "matrix",
    "mean",
    "sqrt",
    "sum",
    "add",
    "subtract",
    "multiply",
    "pow",
    "divide"
];
var $c289bf3dd95c4280$export$10240de9e69376f9 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c289bf3dd95c4280$var$name, $c289bf3dd95c4280$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, sqrt: sqrt, sum: sum, add: add, subtract: subtract, multiply: multiply, pow: pow, divide: divide } = _ref;
    /**
   * Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.
   *
   * Syntax:
   *
   *     math.corr(A, B)
   *
   * Examples:
   *
   *     math.corr([1, 2, 3, 4, 5], [4, 5, 6, 7, 8])     // returns 1
   *     math.corr([1, 2.2, 3, 4.8, 5], [4, 5.3, 6.6, 7, 8])     //returns 0.9569941688503644
   *     math.corr([[1, 2.2, 3, 4.8, 5], [4, 5.3, 6.6, 7, 8]],[[1, 2.2, 3, 4.8, 5], [4, 5.3, 6.6, 7, 8]])   // returns [1,1]
   *
   * See also:
   *
   *     median, mean, min, max, sum, prod, std, variance
   *
   * @param {Array | Matrix} A The first array or matrix to compute correlation coefficient
   * @param {Array | Matrix} B The second array or matrix to compute correlation coefficient
   * @return {*} The correlation coefficient
   */ return typed($c289bf3dd95c4280$var$name, {
        "Array, Array": function ArrayArray(A, B) {
            return _corr(A, B);
        },
        "Matrix, Matrix": function MatrixMatrix(A, B) {
            var res = _corr(A.toArray(), B.toArray());
            return Array.isArray(res) ? matrix(res) : res;
        }
    });
    /**
   * Calculate the correlation coefficient between two arrays or matrices.
   * @param {Array | Matrix} A
   * @param {Array | Matrix} B
   * @return {*} correlation coefficient
   * @private
   */ function _corr(A, B) {
        var correlations = [];
        if (Array.isArray(A[0]) && Array.isArray(B[0])) {
            if (A.length !== B.length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same length.");
            for(var i = 0; i < A.length; i++){
                if (A[i].length !== B[i].length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
                correlations.push(correlation(A[i], B[i]));
            }
            return correlations;
        } else {
            if (A.length !== B.length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
            return correlation(A, B);
        }
    }
    function correlation(A, B) {
        var n = A.length;
        var sumX = sum(A);
        var sumY = sum(B);
        var sumXY = A.reduce((acc, x, index)=>add(acc, multiply(x, B[index])), 0);
        var sumXSquare = sum(A.map((x)=>pow(x, 2)));
        var sumYSquare = sum(B.map((y)=>pow(y, 2)));
        var numerator = subtract(multiply(n, sumXY), multiply(sumX, sumY));
        var denominator = sqrt(multiply(subtract(multiply(n, sumXSquare), pow(sumX, 2)), subtract(multiply(n, sumYSquare), pow(sumY, 2))));
        return divide(numerator, denominator);
    }
});



var $5b7412feb4d38bfc$export$33129064a3329835 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)("trigUnit", [
    "typed"
], (_ref)=>{
    var { typed: typed } = _ref;
    return {
        Unit: typed.referToSelf((self)=>(x)=>{
                if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cot is no angle");
                return typed.find(self, x.valueType())(x.value);
            })
    };
});


var $d82926857202e838$var$name = "cos";
var $d82926857202e838$var$dependencies = [
    "typed"
];
var $d82926857202e838$export$923b60dfa791c630 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d82926857202e838$var$name, $d82926857202e838$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    var trigUnit = (0, $5b7412feb4d38bfc$export$33129064a3329835)({
        typed: typed
    });
    /**
   * Calculate the cosine of a value.
   *
   * To avoid confusion with the matrix cosine, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.cos(x)
   *
   * Examples:
   *
   *    math.cos(2)                      // returns number -0.4161468365471422
   *    math.cos(math.pi / 4)            // returns number  0.7071067811865475
   *    math.cos(math.unit(180, 'deg'))  // returns number -1
   *    math.cos(math.unit(60, 'deg'))   // returns number  0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit} x  Function input
   * @return {number | BigNumber | Complex} Cosine of x
   */ return typed($d82926857202e838$var$name, {
        number: Math.cos,
        "Complex | BigNumber": (x)=>x.cos()
    }, trigUnit);
});



var $fae4d4b5e5eff48b$var$name = "cosh";
var $fae4d4b5e5eff48b$var$dependencies = [
    "typed"
];
var $fae4d4b5e5eff48b$export$63d35097da636c02 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($fae4d4b5e5eff48b$var$name, $fae4d4b5e5eff48b$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic cosine of a value,
   * defined as `cosh(x) = 1/2 * (exp(x) + exp(-x))`.
   *
   * To avoid confusion with the matrix hyperbolic cosine, this function does
   * not apply to matrices.
   *
   * Syntax:
   *
   *    math.cosh(x)
   *
   * Examples:
   *
   *    math.cosh(0.5)       // returns number 1.1276259652063807
   *
   * See also:
   *
   *    sinh, tanh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic cosine of x
   */ return typed($fae4d4b5e5eff48b$var$name, {
        number: (0, $a246eb207aab6d09$export$2e2fd1ad24e4d350),
        "Complex | BigNumber": (x)=>x.cosh()
    });
});




var $22188c2f04abcb2b$var$name = "cot";
var $22188c2f04abcb2b$var$dependencies = [
    "typed",
    "BigNumber"
];
var $22188c2f04abcb2b$export$c5598f542ea1565c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($22188c2f04abcb2b$var$name, $22188c2f04abcb2b$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    var trigUnit = (0, $5b7412feb4d38bfc$export$33129064a3329835)({
        typed: typed
    });
    /**
   * Calculate the cotangent of a value. Defined as `cot(x) = 1 / tan(x)`.
   *
   * To avoid confusion with the matrix cotangent, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.cot(x)
   *
   * Examples:
   *
   *    math.cot(2)      // returns number -0.45765755436028577
   *    1 / math.tan(2)  // returns number -0.45765755436028577
   *
   * See also:
   *
   *    tan, sec, csc
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cotangent of x
   */ return typed($22188c2f04abcb2b$var$name, {
        number: (0, $08edde3ad76e4ae3$export$515b39f7fd07e09f),
        Complex: (x)=>x.cot(),
        BigNumber: (x)=>new _BigNumber(1).div(x.tan())
    }, trigUnit);
});



var $323a049fccc958a4$var$name = "coth";
var $323a049fccc958a4$var$dependencies = [
    "typed",
    "BigNumber"
];
var $323a049fccc958a4$export$3f7f9b5400315e6a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($323a049fccc958a4$var$name, $323a049fccc958a4$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic cotangent of a value,
   * defined as `coth(x) = 1 / tanh(x)`.
   *
   * To avoid confusion with the matrix hyperbolic cotangent, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.coth(x)
   *
   * Examples:
   *
   *    // coth(x) = 1 / tanh(x)
   *    math.coth(2)         // returns 1.0373147207275482
   *    1 / math.tanh(2)     // returns 1.0373147207275482
   *
   * See also:
   *
   *    sinh, tanh, cosh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic cotangent of x
   */ return typed($323a049fccc958a4$var$name, {
        number: (0, $08edde3ad76e4ae3$export$925affe88b2512fc),
        Complex: (x)=>x.coth(),
        BigNumber: (x)=>new _BigNumber(1).div(x.tanh())
    });
});


var $d2ef57d94b6ab37b$var$name = "count";
var $d2ef57d94b6ab37b$var$dependencies = [
    "typed",
    "size",
    "prod"
];
var $d2ef57d94b6ab37b$export$decd32c762b504bc = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d2ef57d94b6ab37b$var$name, $d2ef57d94b6ab37b$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, prod: prod } = _ref;
    /**
   * Count the number of elements of a matrix, array or string.
   *
   * Syntax:
   *
   *     math.count(x)
   *
   * Examples:
   *
   *     math.count('hello world')        // returns 11
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.count(A)                    // returns 6
   *     math.count(math.range(1,6))      // returns 5
   *
   * See also:
   *
   *     size
   *
   * @param {string | Array | Matrix} x  A matrix or string
   * @return {number} An integer with the elements in `x`.
   */ return typed($d2ef57d94b6ab37b$var$name, {
        string: function string(x) {
            return x.length;
        },
        "Matrix | Array": function MatrixArray(x) {
            return prod(size(x));
        }
    });
});


var $402f4511b2372d65$var$name = "createUnit";
var $402f4511b2372d65$var$dependencies = [
    "typed",
    "Unit"
];
var $402f4511b2372d65$export$27641941eb5cadbb = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($402f4511b2372d65$var$name, $402f4511b2372d65$var$dependencies, (_ref)=>{
    var { typed: typed, Unit: Unit } = _ref;
    /**
   * Create a user-defined unit and register it with the Unit type.
   *
   * Syntax:
   *
   *     math.createUnit({
   *       baseUnit1: {
   *         aliases: [string, ...]
   *         prefixes: object
   *       },
   *       unit2: {
   *         definition: string,
   *         aliases: [string, ...]
   *         prefixes: object,
   *         offset: number
   *       },
   *       unit3: string    // Shortcut
   *     })
   *
   *     // Another shortcut:
   *     math.createUnit(string, unit : string, [object])
   *
   * Examples:
   *
   *     math.createUnit('foo')
   *     math.createUnit('knot', {definition: '0.514444444 m/s', aliases: ['knots', 'kt', 'kts']})
   *     math.createUnit('mph', '1 mile/hour')
   *     math.createUnit('km', math.unit(1000, 'm'))
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, UnitDefinition, Unit} definition      Definition of the unit in terms of existing units. For example, '0.514444444 m / s'.
   * @param {Object} options   (optional) An object containing any of the following properties:
   *     - `prefixes {string}` "none", "short", "long", "binary_short", or "binary_long". The default is "none".
   *     - `aliases {Array}` Array of strings. Example: ['knots', 'kt', 'kts']
   *     - `offset {Numeric}` An offset to apply when converting from the unit. For example, the offset for celsius is 273.15. Default is 0.
   *
   * See also:
   *
   *     unit
   *
   * @return {Unit} The new unit
   */ return typed($402f4511b2372d65$var$name, {
        // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
        "Object, Object": function ObjectObject(obj, options) {
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        Object: function Object(obj) {
            return Unit.createUnit(obj, {});
        },
        // Shortcut method for creating one unit.
        "string, Unit | string | Object, Object": function stringUnitStringObjectObject(name, def, options) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        "string, Unit | string | Object": function stringUnitStringObject(name, def) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, {});
        },
        // Without a definition, creates a base unit.
        string: function string(name) {
            var obj = {};
            obj[name] = {};
            return Unit.createUnit(obj, {});
        }
    });
});



var $80d317bf8845a13f$var$name = "cross";
var $80d317bf8845a13f$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "multiply"
];
var $80d317bf8845a13f$export$bc2585c0ed744c0e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($80d317bf8845a13f$var$name, $80d317bf8845a13f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, multiply: multiply } = _ref;
    /**
   * Calculate the cross product for two vectors in three dimensional space.
   * The cross product of `A = [a1, a2, a3]` and `B = [b1, b2, b3]` is defined
   * as:
   *
   *    cross(A, B) = [
   *      a2 * b3 - a3 * b2,
   *      a3 * b1 - a1 * b3,
   *      a1 * b2 - a2 * b1
   *    ]
   *
   * If one of the input vectors has a dimension greater than 1, the output
   * vector will be a 1x3 (2-dimensional) matrix.
   *
   * Syntax:
   *
   *    math.cross(x, y)
   *
   * Examples:
   *
   *    math.cross([1, 1, 0],   [0, 1, 1])       // Returns [1, -1, 1]
   *    math.cross([3, -3, 1],  [4, 9, 2])       // Returns [-15, -2, 39]
   *    math.cross([2, 3, 4],   [5, 6, 7])       // Returns [-3, 6, -3]
   *    math.cross([[1, 2, 3]], [[4], [5], [6]]) // Returns [[-3, 6, -3]]
   *
   * See also:
   *
   *    dot, multiply
   *
   * @param  {Array | Matrix} x   First vector
   * @param  {Array | Matrix} y   Second vector
   * @return {Array | Matrix}     Returns the cross product of `x` and `y`
   */ return typed($80d317bf8845a13f$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return matrix(_cross(x.toArray(), y.toArray()));
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return matrix(_cross(x.toArray(), y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return matrix(_cross(x, y.toArray()));
        },
        "Array, Array": _cross
    });
    /**
   * Calculate the cross product for two arrays
   * @param {Array} x  First vector
   * @param {Array} y  Second vector
   * @returns {Array} Returns the cross product of x and y
   * @private
   */ function _cross(x, y) {
        var highestDimension = Math.max((0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x).length, (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(y).length);
        x = (0, $eee21df0c3527ff1$export$889c931173b77c2f)(x);
        y = (0, $eee21df0c3527ff1$export$889c931173b77c2f)(y);
        var xSize = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x);
        var ySize = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(y);
        if (xSize.length !== 1 || ySize.length !== 1 || xSize[0] !== 3 || ySize[0] !== 3) throw new RangeError("Vectors with length 3 expected (Size A = [" + xSize.join(", ") + "], B = [" + ySize.join(", ") + "])");
        var product = [
            subtract(multiply(x[1], y[2]), multiply(x[2], y[1])),
            subtract(multiply(x[2], y[0]), multiply(x[0], y[2])),
            subtract(multiply(x[0], y[1]), multiply(x[1], y[0]))
        ];
        if (highestDimension > 1) return [
            product
        ];
        else return product;
    }
});




var $f9d712b2dbcd8faf$var$name = "csc";
var $f9d712b2dbcd8faf$var$dependencies = [
    "typed",
    "BigNumber"
];
var $f9d712b2dbcd8faf$export$a0beb298aa7a2962 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f9d712b2dbcd8faf$var$name, $f9d712b2dbcd8faf$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    var trigUnit = (0, $5b7412feb4d38bfc$export$33129064a3329835)({
        typed: typed
    });
    /**
   * Calculate the cosecant of a value, defined as `csc(x) = 1/sin(x)`.
   *
   * To avoid confusion with the matrix cosecant, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.csc(x)
   *
   * Examples:
   *
   *    math.csc(2)      // returns number 1.099750170294617
   *    1 / math.sin(2)  // returns number 1.099750170294617
   *
   * See also:
   *
   *    sin, sec, cot
   *
   * @param {number | BigNumber | Complex | Unit} x  Function input
   * @return {number | BigNumber | Complex} Cosecant of x
   */ return typed($f9d712b2dbcd8faf$var$name, {
        number: (0, $08edde3ad76e4ae3$export$5a8409ad16e318b2),
        Complex: (x)=>x.csc(),
        BigNumber: (x)=>new _BigNumber(1).div(x.sin())
    }, trigUnit);
});



var $218777d0dda9754b$var$name = "csch";
var $218777d0dda9754b$var$dependencies = [
    "typed",
    "BigNumber"
];
var $218777d0dda9754b$export$9160aa3a39425fc9 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($218777d0dda9754b$var$name, $218777d0dda9754b$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic cosecant of a value,
   * defined as `csch(x) = 1 / sinh(x)`.
   *
   * To avoid confusion with the matrix hyperbolic cosecant, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.csch(x)
   *
   * Examples:
   *
   *    // csch(x) = 1/ sinh(x)
   *    math.csch(0.5)       // returns 1.9190347513349437
   *    1 / math.sinh(0.5)   // returns 1.9190347513349437
   *
   * See also:
   *
   *    sinh, sech, coth
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic cosecant of x
   */ return typed($218777d0dda9754b$var$name, {
        number: (0, $08edde3ad76e4ae3$export$143835b5c1db9790),
        Complex: (x)=>x.csch(),
        BigNumber: (x)=>new _BigNumber(1).div(x.sinh())
    });
});


var $0df238b4bfbaae1c$var$name = "ctranspose";
var $0df238b4bfbaae1c$var$dependencies = [
    "typed",
    "transpose",
    "conj"
];
var $0df238b4bfbaae1c$export$5d07146b3894f212 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0df238b4bfbaae1c$var$name, $0df238b4bfbaae1c$var$dependencies, (_ref)=>{
    var { typed: typed, transpose: transpose, conj: conj } = _ref;
    /**
   * Transpose and complex conjugate a matrix. All values of the matrix are
   * reflected over its main diagonal and then the complex conjugate is
   * taken. This is equivalent to complex conjugation for scalars and
   * vectors.
   *
   * Syntax:
   *
   *     math.ctranspose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, math.complex(6,7)]]
   *     math.ctranspose(A)               // returns [[1, 4], [2, 5], [3, {re:6,im:7}]]
   *
   * See also:
   *
   *     transpose, diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be ctransposed
   * @return {Array | Matrix}   The ctransposed matrix
   */ return typed($0df238b4bfbaae1c$var$name, {
        any: function any(x) {
            return conj(transpose(x));
        }
    });
});



var $3411ebfd551dee7a$var$name = "cube";
var $3411ebfd551dee7a$var$dependencies = [
    "typed"
];
var $3411ebfd551dee7a$export$ce223d612b94804b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3411ebfd551dee7a$var$name, $3411ebfd551dee7a$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the cube of a value, `x * x * x`.
   * To avoid confusion with `pow(M,3)`, this function does not apply to matrices.
   * If you wish to cube every entry of a matrix, see the examples.
   *
   * Syntax:
   *
   *    math.cube(x)
   *
   * Examples:
   *
   *    math.cube(2)            // returns number 8
   *    math.pow(2, 3)          // returns number 8
   *    math.cube(4)            // returns number 64
   *    4 * 4 * 4               // returns number 64
   *
   *    math.map([1, 2, 3, 4], math.cube) // returns Array [1, 8, 27, 64]
   *
   * See also:
   *
   *    multiply, square, pow, cbrt
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x  Number for which to calculate the cube
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit} Cube of x
   */ return typed($3411ebfd551dee7a$var$name, {
        number: (0, $f38f49d8e24d4a9f$export$9505f0b39acd04c),
        Complex: function Complex(x) {
            return x.mul(x).mul(x); // Is faster than pow(x, 3)
        },
        BigNumber: function BigNumber(x) {
            return x.times(x).times(x);
        },
        bigint: function bigint(x) {
            return x * x * x;
        },
        Fraction: function Fraction(x) {
            return x.pow(3); // Is faster than mul()mul()mul()
        },
        Unit: function Unit(x) {
            return x.pow(3);
        }
    });
});





function $b84e6160513a21c1$export$c8994973cec629ae(err, fnName, value) {
    // TODO: add information with the index (also needs transform in expression parser)
    var details;
    if (String(err).includes("Unexpected type")) {
        details = arguments.length > 2 ? " (type: " + (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(value) + ", value: " + JSON.stringify(value) + ")" : " (type: " + err.data.actual + ")";
        return new TypeError("Cannot calculate " + fnName + ", unexpected type of argument" + details);
    }
    if (String(err).includes("complex numbers")) {
        details = arguments.length > 2 ? " (type: " + (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(value) + ", value: " + JSON.stringify(value) + ")" : "";
        return new TypeError("Cannot calculate " + fnName + ", no ordering relation is defined for complex numbers" + details);
    }
    return err;
}




var $a4767d153782e37a$var$name = "cumsum";
var $a4767d153782e37a$var$dependencies = [
    "typed",
    "add",
    "unaryPlus"
];
var $a4767d153782e37a$export$e11ffe2ce577c262 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a4767d153782e37a$var$name, $a4767d153782e37a$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, unaryPlus: unaryPlus } = _ref;
    /**
   * Compute the cumulative sum of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the cumulative sums
   * along a specified dimension (defaulting to the first) will be calculated.
   *
   * Syntax:
   *
   *     math.cumsum(a, b, c, ...)
   *     math.cumsum(A)
   *
   * Examples:
   *
   *     math.cumsum(2, 1, 4, 3)               // returns [2, 3, 7, 10]
   *     math.cumsum([2, 1, 4, 3])             // returns [2, 3, 7, 10]
   *     math.cumsum([[1, 2], [3, 4]])         // returns [[1, 2], [4, 6]]
   *     math.cumsum([[1, 2], [3, 4]], 0)      // returns [[1, 2], [4, 6]]
   *     math.cumsum([[1, 2], [3, 4]], 1)      // returns [[1, 3], [3, 7]]
   *     math.cumsum([[2, 5], [4, 3], [1, 7]]) // returns [[2, 5], [6, 8], [7, 15]]
   *
   * See also:
   *
   *    mean, median, min, max, prod, std, variance, sum
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The cumulative sum of all values
   */ return typed($a4767d153782e37a$var$name, {
        // sum([a, b, c, d, ...])
        Array: _cumsum,
        Matrix: function Matrix(matrix) {
            return matrix.create(_cumsum(matrix.valueOf()));
        },
        // sum([a, b, c, d, ...], dim)
        "Array, number | BigNumber": _ncumSumDim,
        "Matrix, number | BigNumber": function MatrixNumberBigNumber(matrix, dim) {
            return matrix.create(_ncumSumDim(matrix.valueOf(), dim));
        },
        // cumsum(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $b3f9e93020d0f987$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("All values expected to be scalar in function cumsum");
            return _cumsum(args);
        }
    });
    /**
     * Recursively calculate the cumulative sum of an n-dimensional array
     * @param {Array} array
     * @return {number} cumsum
     * @private
     */ function _cumsum(array) {
        try {
            return _cumsummap(array);
        } catch (err) {
            throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, $a4767d153782e37a$var$name);
        }
    }
    function _cumsummap(array) {
        if (array.length === 0) return [];
        var sums = [
            unaryPlus(array[0])
        ]; // unaryPlus converts to number if need be
        for(var i = 1; i < array.length; ++i)// Must use add below and not addScalar for the case of summing a
        // 2+-dimensional array along the 0th dimension (the row vectors,
        // or higher-d analogues, are literally added to each other).
        sums.push(add(sums[i - 1], array[i]));
        return sums;
    }
    function _ncumSumDim(array, dim) {
        var size = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(array);
        if (dim < 0 || dim >= size.length) // TODO: would be more clear when throwing a DimensionError here
        throw new (0, $7e61b13fb7752c23$export$efa5eacb1304c464)(dim, size.length);
        try {
            return _cumsumDimensional(array, dim);
        } catch (err) {
            throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, $a4767d153782e37a$var$name);
        }
    }
    /* Possible TODO: Refactor _reduce in collection.js to be able to work here as well */ function _cumsumDimensional(mat, dim) {
        var i, ret, tran;
        if (dim <= 0) {
            var initialValue = mat[0][0];
            if (!Array.isArray(initialValue)) return _cumsummap(mat);
            else {
                tran = (0, $18f7dabd54a3c382$export$424b8b2ab9af2944)(mat);
                ret = [];
                for(i = 0; i < tran.length; i++)ret[i] = _cumsumDimensional(tran[i], dim - 1);
                return ret;
            }
        } else {
            ret = [];
            for(i = 0; i < mat.length; i++)ret[i] = _cumsumDimensional(mat[i], dim - 1);
            return ret;
        }
    }
});


var $c4ecd976ad480366$var$name = "deepEqual";
var $c4ecd976ad480366$var$dependencies = [
    "typed",
    "equal"
];
var $c4ecd976ad480366$export$b1b11fc839367b58 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c4ecd976ad480366$var$name, $c4ecd976ad480366$var$dependencies, (_ref)=>{
    var { typed: typed, equal: equal } = _ref;
    /**
   * Test element wise whether two matrices are equal.
   * The function accepts both matrices and scalar values.
   *
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.deepEqual(x, y)
   *
   * Examples:
   *
   *    math.deepEqual(2, 4)   // returns false
   *
   *    a = [2, 5, 1]
   *    b = [2, 7, 1]
   *
   *    math.deepEqual(a, b)   // returns false
   *    math.equal(a, b)       // returns [true, false, true]
   *
   * See also:
   *
   *    equal, unequal
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First matrix to compare
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second matrix to compare
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns true when the input matrices have the same size and each of their elements is equal.
   */ return typed($c4ecd976ad480366$var$name, {
        "any, any": function anyAny(x, y) {
            return _deepEqual(x.valueOf(), y.valueOf());
        }
    });
    /**
   * Test whether two arrays have the same size and all elements are equal
   * @param {Array | *} x
   * @param {Array | *} y
   * @return {boolean} Returns true if both arrays are deep equal
   */ function _deepEqual(x, y) {
        if (Array.isArray(x)) {
            if (Array.isArray(y)) {
                var len = x.length;
                if (len !== y.length) return false;
                for(var i = 0; i < len; i++){
                    if (!_deepEqual(x[i], y[i])) return false;
                }
                return true;
            } else return false;
        } else {
            if (Array.isArray(y)) return false;
            else return equal(x, y);
        }
    }
});








// function utils
// (c) 2018, Mariusz Nowak
// SPDX-License-Identifier: ISC
// Derived from https://github.com/medikoo/lru-queue
function $7247d83caa4e0763$export$6080faceac22b73a(limit) {
    var size = 0;
    var base = 1;
    var queue = Object.create(null);
    var map = Object.create(null);
    var index = 0;
    var del = function del(id) {
        var oldIndex = map[id];
        if (!oldIndex) return;
        delete queue[oldIndex];
        delete map[id];
        --size;
        if (base !== oldIndex) return;
        if (!size) {
            index = 0;
            base = 1;
            return;
        }
        while(!Object.prototype.hasOwnProperty.call(queue, ++base));
    };
    limit = Math.abs(limit);
    return {
        hit: function hit(id) {
            var oldIndex = map[id];
            var nuIndex = ++index;
            queue[nuIndex] = id;
            map[id] = nuIndex;
            if (!oldIndex) {
                ++size;
                if (size <= limit) return undefined;
                id = queue[base];
                del(id);
                return id;
            }
            delete queue[oldIndex];
            if (base !== oldIndex) return undefined;
            while(!Object.prototype.hasOwnProperty.call(queue, ++base));
            return undefined;
        },
        delete: del,
        clear: function clear() {
            size = index = 0;
            base = 1;
            queue = Object.create(null);
            map = Object.create(null);
        }
    };
}


function $ffc30f141434c696$export$fc10aeed3a532e2a(fn) {
    var { hasher: hasher, limit: limit } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    limit = limit == null ? Number.POSITIVE_INFINITY : limit;
    hasher = hasher == null ? JSON.stringify : hasher;
    return function memoize() {
        if (typeof memoize.cache !== "object") memoize.cache = {
            values: new Map(),
            lru: (0, $7247d83caa4e0763$export$6080faceac22b73a)(limit || Number.POSITIVE_INFINITY)
        };
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        var hash = hasher(args);
        if (memoize.cache.values.has(hash)) {
            memoize.cache.lru.hit(hash);
            return memoize.cache.values.get(hash);
        }
        var newVal = fn.apply(fn, args);
        memoize.cache.values.set(hash, newVal);
        memoize.cache.values.delete(memoize.cache.lru.hit(hash));
        return newVal;
    };
}
function $ffc30f141434c696$export$22992fec26710d5a(fn, isEqual) {
    var memoize = function memoize() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        for(var c = 0; c < memoize.cache.length; c++){
            var cached = memoize.cache[c];
            if (isEqual(args, cached.args)) // TODO: move this cache entry to the top so recently used entries move up?
            return cached.res;
        }
        var res = fn.apply(fn, args);
        memoize.cache.unshift({
            args: args,
            res: res
        });
        return res;
    };
    memoize.cache = [];
    return memoize;
}
function $ffc30f141434c696$export$6c00fba23f8c91a7(fn) {
    return Object.keys(fn.signatures || {}).reduce(function(args, signature) {
        var count = (signature.match(/,/g) || []).length + 1;
        return Math.max(args, count);
    }, -1);
}


var $c3ad35825bd0e89e$var$name = "DenseMatrix";
var $c3ad35825bd0e89e$var$dependencies = [
    "Matrix"
];
var $c3ad35825bd0e89e$export$1a088ca8dd364cd1 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c3ad35825bd0e89e$var$name, $c3ad35825bd0e89e$var$dependencies, (_ref)=>{
    var { Matrix: Matrix } = _ref;
    /**
   * Dense Matrix implementation. A regular, dense matrix, supporting multi-dimensional matrices. This is the default matrix type.
   * @class DenseMatrix
   * @enum {{ value, index: number[] }}
   */ function DenseMatrix(data, datatype) {
        if (!(this instanceof DenseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $23cfe017d190638f$export$844ec244b1367d54)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(data)) {
            // check data is a DenseMatrix
            if (data.type === "DenseMatrix") {
                // clone data & size
                this._data = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(data._data);
                this._size = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(data._size);
                this._datatype = datatype || data._datatype;
            } else {
                // build data from existing matrix
                this._data = data.toArray();
                this._size = data.size();
                this._datatype = datatype || data._datatype;
            }
        } else if (data && (0, $23cfe017d190638f$export$43bee75e5e14138e)(data.data) && (0, $23cfe017d190638f$export$43bee75e5e14138e)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size;
            // verify the dimensions of the array
            (0, $eee21df0c3527ff1$export$a22775fa5e2eebd9)(this._data, this._size);
            this._datatype = datatype || data.datatype;
        } else if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(data)) {
            // replace nested Matrices with Arrays
            this._data = preprocess(data);
            // get the dimensions of the array
            this._size = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(this._data);
            // verify the dimensions of the array, TODO: compute size while processing array
            (0, $eee21df0c3527ff1$export$a22775fa5e2eebd9)(this._data, this._size);
            // data type unknown
            this._datatype = datatype;
        } else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(data) + ")");
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
        }
    }
    DenseMatrix.prototype = new Matrix();
    /**
   * Create a new DenseMatrix
   */ DenseMatrix.prototype.createDenseMatrix = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ Object.defineProperty(DenseMatrix, "name", {
        value: "DenseMatrix"
    });
    DenseMatrix.prototype.constructor = DenseMatrix;
    DenseMatrix.prototype.type = "DenseMatrix";
    DenseMatrix.prototype.isDenseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf DenseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ DenseMatrix.prototype.getDataType = function() {
        return (0, $eee21df0c3527ff1$export$d31e00bf4359ea8b)(this._data, (0, $23cfe017d190638f$export$f5bbd400c2f4426f));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()  // retrieve storage format
   *
   * @memberof DenseMatrix
   * @return {string}           The storage format.
   */ DenseMatrix.prototype.storage = function() {
        return "dense";
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()   // retrieve matrix datatype
   *
   * @memberof DenseMatrix
   * @return {string}           The datatype.
   */ DenseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new DenseMatrix
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ DenseMatrix.prototype.create = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof DenseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ DenseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        switch(arguments.length){
            case 1:
                return _get(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _set(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    /**
   * Get a single element from the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ DenseMatrix.prototype.get = function(index) {
        if (!(0, $23cfe017d190638f$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(index.length, this._size.length);
        // check index
        for(var x = 0; x < index.length; x++)(0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(index[x], this._size[x]);
        var data = this._data;
        for(var i = 0, ii = index.length; i < ii; i++){
            var indexI = index[i];
            (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(indexI, data.length);
            data = data[indexI];
        }
        return data;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {DenseMatrix} self
   */ DenseMatrix.prototype.set = function(index, value, defaultValue) {
        if (!(0, $23cfe017d190638f$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length < this._size.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(index.length, this._size.length, "<");
        var i, ii, indexI;
        // enlarge matrix when needed
        var size = index.map(function(i) {
            return i + 1;
        });
        _fit(this, size, defaultValue);
        // traverse over the dimensions
        var data = this._data;
        for(i = 0, ii = index.length - 1; i < ii; i++){
            indexI = index[i];
            (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(indexI, data.length);
            data = data[indexI];
        }
        // set new value
        indexI = index[index.length - 1];
        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(indexI, data.length);
        data[indexI] = value;
        return this;
    };
    /**
   * Get a submatrix of this matrix
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index   Zero-based index
   * @private
   */ function _get(matrix, index) {
        if (!(0, $23cfe017d190638f$export$ba3dc792055c2f45)(index)) throw new TypeError("Invalid index");
        var isScalar = index.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(index.min());
        else {
            // validate dimensions
            var size = index.size();
            if (size.length !== matrix._size.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(size.length, matrix._size.length);
            // validate if any of the ranges in the index is out of range
            var min = index.min();
            var max = index.max();
            for(var i = 0, ii = matrix._size.length; i < ii; i++){
                (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(min[i], matrix._size[i]);
                (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(max[i], matrix._size[i]);
            }
            // retrieve submatrix
            // TODO: more efficient when creating an empty matrix and setting _data and _size manually
            return new DenseMatrix(_getSubmatrix(matrix._data, index, size.length, 0), matrix._datatype);
        }
    }
    /**
   * Recursively get a submatrix of a multi dimensional matrix.
   * Index is not checked for correct number or length of dimensions.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {number} dims   Total number of dimensions
   * @param {number} dim    Current dimension
   * @return {Array} submatrix
   * @private
   */ function _getSubmatrix(data, index, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) return range.map(function(i) {
            (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(i, data.length);
            return data[i];
        }).valueOf();
        else return range.map(function(i) {
            (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(i, data.length);
            var child = data[i];
            return _getSubmatrix(child, index, dims, dim + 1);
        }).valueOf();
    }
    /**
   * Replace a submatrix in this matrix
   * Indexes are zero-based.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index
   * @param {DenseMatrix | Array | *} submatrix
   * @param {*} defaultValue          Default value, filled in on new entries when
   *                                  the matrix is resized.
   * @return {DenseMatrix} matrix
   * @private
   */ function _set(matrix, index, submatrix, defaultValue) {
        if (!index || index.isIndex !== true) throw new TypeError("Invalid index");
        // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar();
        // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(submatrix)) {
            sSize = submatrix.size();
            submatrix = submatrix.valueOf();
        } else sSize = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(submatrix);
        if (isScalar) {
            // set a scalar
            // check whether submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError("Scalar expected");
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // set a submatrix
            // broadcast submatrix
            if (!(0, $46a94b3d1146edd8$export$6cc798251952180)(sSize, iSize)) try {
                if (sSize.length === 0) submatrix = (0, $eee21df0c3527ff1$export$ec9086aff2624eab)([
                    submatrix
                ], iSize);
                else submatrix = (0, $eee21df0c3527ff1$export$ec9086aff2624eab)(submatrix, iSize);
                sSize = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(submatrix);
            } catch (_unused) {}
            // validate dimensions
            if (iSize.length < matrix._size.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(iSize.length, matrix._size.length, "<");
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                }
                // unsqueeze both outer and inner dimensions
                submatrix = (0, $eee21df0c3527ff1$export$5a07c5202d40a604)(submatrix, iSize.length, outer, sSize);
            }
            // check whether the size of the submatrix matches the index size
            if (!(0, $46a94b3d1146edd8$export$6cc798251952180)(iSize, sSize)) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(iSize, sSize, ">");
            // enlarge matrix when needed
            var size = index.max().map(function(i) {
                return i + 1;
            });
            _fit(matrix, size, defaultValue);
            // insert the sub matrix
            var dims = iSize.length;
            var dim = 0;
            _setSubmatrix(matrix._data, index, submatrix, dims, dim);
        }
        return matrix;
    }
    /**
   * Replace a submatrix of a multi dimensional matrix.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {Array} submatrix
   * @param {number} dims   Total number of dimensions
   * @param {number} dim
   * @private
   */ function _setSubmatrix(data, index, submatrix, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) range.forEach(function(dataIndex, subIndex) {
            (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(dataIndex);
            data[dataIndex] = submatrix[subIndex[0]];
        });
        else range.forEach(function(dataIndex, subIndex) {
            (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(dataIndex);
            _setSubmatrix(data[dataIndex], index, submatrix[subIndex[0]], dims, dim + 1);
        });
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof DenseMatrix
   * @param {number[] || Matrix} size The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ DenseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $23cfe017d190638f$export$cea7aa84e978eba5)(size)) throw new TypeError("Array or Matrix expected");
        // SparseMatrix input is always 2d, flatten this into 1d if it's indeed a vector
        var sizeArray = size.valueOf().map((value)=>{
            return Array.isArray(value) && value.length === 1 ? value[0] : value;
        });
        // matrix to resize
        var m = copy ? this.clone() : this;
        // resize matrix
        return _resize(m, sizeArray, defaultValue);
    };
    function _resize(matrix, size, defaultValue) {
        // check size
        if (size.length === 0) {
            // first value in matrix
            var v = matrix._data;
            // go deep
            while((0, $23cfe017d190638f$export$43bee75e5e14138e)(v))v = v[0];
            return v;
        }
        // resize matrix
        matrix._size = size.slice(0); // copy the array
        matrix._data = (0, $eee21df0c3527ff1$export$4380c87abf28fdf)(matrix._data, matrix._size, defaultValue);
        // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof DenseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ DenseMatrix.prototype.reshape = function(size, copy) {
        var m = copy ? this.clone() : this;
        m._data = (0, $eee21df0c3527ff1$export$9eaad88cf88cee2b)(m._data, size);
        var currentLength = m._size.reduce((length, size)=>length * size);
        m._size = (0, $eee21df0c3527ff1$export$d0efc868ac2c6822)(size, currentLength);
        return m;
    };
    /**
   * Enlarge the matrix when it is smaller than given size.
   * If the matrix is larger or equal sized, nothing is done.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix           The matrix to be resized
   * @param {number[]} size
   * @param {*} defaultValue          Default value, filled in on new entries.
   * @private
   */ function _fit(matrix, size, defaultValue) {
        var // copy the array
        newSize = matrix._size.slice(0);
        var changed = false;
        // add dimensions when needed
        while(newSize.length < size.length){
            newSize.push(0);
            changed = true;
        }
        // enlarge size when needed
        for(var i = 0, ii = size.length; i < ii; i++)if (size[i] > newSize[i]) {
            newSize[i] = size[i];
            changed = true;
        }
        if (changed) // resize only when size is changed
        _resize(matrix, newSize, defaultValue);
    }
    /**
   * Create a clone of the matrix
   * @memberof DenseMatrix
   * @return {DenseMatrix} clone
   */ DenseMatrix.prototype.clone = function() {
        var m = new DenseMatrix({
            data: (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this._data),
            size: (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof DenseMatrix
   * @returns {number[]} size
   */ DenseMatrix.prototype.size = function() {
        return this._size.slice(0); // return a clone of _size
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   *
   * @return {DenseMatrix} matrix
   */ DenseMatrix.prototype.map = function(callback) {
        // matrix instance
        var me = this;
        var args = (0, $ffc30f141434c696$export$6c00fba23f8c91a7)(callback);
        var recurse = function recurse(value, index) {
            if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(value)) return value.map(function(child, i) {
                return recurse(child, index.concat(i));
            });
            else {
                // invoke the callback function with the right number of arguments
                if (args === 1) return callback(value);
                else if (args === 2) return callback(value, index);
                else // 3 or -1
                return callback(value, index, me);
            }
        };
        // determine the new datatype when the original matrix has datatype defined
        // TODO: should be done in matrix constructor instead
        var data = recurse(this._data, []);
        var datatype = this._datatype !== undefined ? (0, $eee21df0c3527ff1$export$d31e00bf4359ea8b)(data, (0, $23cfe017d190638f$export$f5bbd400c2f4426f)) : undefined;
        return new DenseMatrix(data, datatype);
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ DenseMatrix.prototype.forEach = function(callback) {
        // matrix instance
        var me = this;
        var recurse = function recurse(value, index) {
            if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(value)) value.forEach(function(child, i) {
                recurse(child, index.concat(i));
            });
            else callback(value, index, me);
        };
        recurse(this._data, []);
    };
    /**
   * Iterate over the matrix elements
   * @return {Iterable<{ value, index: number[] }>}
   */ DenseMatrix.prototype[Symbol.iterator] = function*() {
        var recurse = function* recurse(value, index) {
            if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(value)) for(var i = 0; i < value.length; i++)yield* recurse(value[i], index.concat(i));
            else yield {
                value: value,
                index: index
            };
        };
        yield* recurse(this._data, []);
    };
    /**
   * Returns an array containing the rows of a 2D matrix
   * @returns {Array<Matrix>}
   */ DenseMatrix.prototype.rows = function() {
        var result = [];
        var s = this.size();
        if (s.length !== 2) throw new TypeError("Rows can only be returned for a 2D matrix.");
        var data = this._data;
        for (var row of data)result.push(new DenseMatrix([
            row
        ], this._datatype));
        return result;
    };
    /**
   * Returns an array containing the columns of a 2D matrix
   * @returns {Array<Matrix>}
   */ DenseMatrix.prototype.columns = function() {
        var _this = this;
        var result = [];
        var s = this.size();
        if (s.length !== 2) throw new TypeError("Rows can only be returned for a 2D matrix.");
        var data = this._data;
        var _loop = function _loop(i) {
            var col = data.map((row)=>[
                    row[i]
                ]);
            result.push(new DenseMatrix(col, _this._datatype));
        };
        for(var i = 0; i < s[1]; i++)_loop(i);
        return result;
    };
    /**
   * Create an Array with a copy of the data of the DenseMatrix
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.toArray = function() {
        return (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this._data);
    };
    /**
   * Get the primitive value of the DenseMatrix: a multidimensional array
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.valueOf = function() {
        return this._data;
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof DenseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ DenseMatrix.prototype.format = function(options) {
        return (0, $1b038b7ade911d0e$export$d9468344d3651243)(this._data, options);
    };
    /**
   * Get a string representation of the matrix
   * @memberof DenseMatrix
   * @returns {string} str
   */ DenseMatrix.prototype.toString = function() {
        return (0, $1b038b7ade911d0e$export$d9468344d3651243)(this._data);
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof DenseMatrix
   * @returns {Object}
   */ DenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "DenseMatrix",
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof DenseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix with the diagonal values.
   */ DenseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
            // is must be an integer
            if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(k) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0;
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1];
        // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper);
        // x is a matrix get diagonal from matrix
        var data = [];
        // loop rows
        for(var i = 0; i < n; i++)data[i] = this._data[i + kSub][i + kSuper];
        // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                n
            ],
            datatype: this._datatype
        });
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof DenseMatrix
   * @param {Array} size                     The matrix size.
   * @param {number | Matrix | Array } value The values for the diagonal.
   * @param {number | BigNumber} [k=0]       The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]          The default value for non-diagonal
   * @param {string} [datatype]              The datatype for the diagonal
   *
   * @returns {DenseMatrix}
   */ DenseMatrix.diagonal = function(size, value, k, defaultValue) {
        if (!(0, $23cfe017d190638f$export$43bee75e5e14138e)(size)) throw new TypeError("Array expected, size parameter");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
        // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(s)) // convert it
            s = s.toNumber();
            // validate arguments
            if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(s) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(s) || s < 1) throw new Error("Size values must be positive integers");
            return s;
        });
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
            // is must be an integer
            if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(k) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0;
        // rows and columns
        var rows = size[0];
        var columns = size[1];
        // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper);
        // value extraction function
        var _value;
        // check value
        if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error("Invalid value array length");
            // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(value)) {
            // matrix size
            var ms = value.size();
            // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error("Invalid matrix length");
            // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
        // discover default value if needed
        if (!defaultValue) // check first value in array
        defaultValue = (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(_value(0)) ? _value(0).mul(0) // trick to create a BigNumber with value zero
         : 0;
        // empty array
        var data = [];
        // check we need to resize array
        if (size.length > 0) {
            // resize array
            data = (0, $eee21df0c3527ff1$export$4380c87abf28fdf)(data, size, defaultValue);
            // fill diagonal
            for(var d = 0; d < n; d++)data[d + kSub][d + kSuper] = _value(d);
        }
        // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof DenseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "DenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {DenseMatrix}
   */ DenseMatrix.fromJSON = function(json) {
        return new DenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof DenseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ DenseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(i) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(i) || !(0, $23cfe017d190638f$export$7e4aa119212bc614)(j) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(j)) throw new Error("Row index must be positive integers");
        // check dimensions
        if (this._size.length !== 2) throw new Error("Only two dimensional matrix is supported");
        // validate index
        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(i, this._size[0]);
        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(j, this._size[0]);
        // swap rows
        DenseMatrix._swapRows(i, j, this._data);
        // return current instance
        return this;
    };
    /**
   * Swap rows i and j in Dense Matrix data structure.
   *
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   * @param {Array} data     Matrix data
   */ DenseMatrix._swapRows = function(i, j, data) {
        // swap values i <-> j
        var vi = data[i];
        data[i] = data[j];
        data[j] = vi;
    };
    /**
   * Preprocess data, which can be an Array or DenseMatrix with nested Arrays and
   * Matrices. Clones all (nested) Arrays, and replaces all nested Matrices with Arrays
   * @memberof DenseMatrix
   * @param {Array | Matrix} data
   * @return {Array} data
   */ function preprocess(data) {
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(data)) return preprocess(data.valueOf());
        if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(data)) return data.map(preprocess);
        return data;
    }
    return DenseMatrix;
}, {
    isClass: true
});





var $181e8af6d7e0616f$var$name = "det";
var $181e8af6d7e0616f$var$dependencies = [
    "typed",
    "matrix",
    "subtractScalar",
    "multiply",
    "divideScalar",
    "isZero",
    "unaryMinus"
];
var $181e8af6d7e0616f$export$93f810683c54b005 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($181e8af6d7e0616f$var$name, $181e8af6d7e0616f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtractScalar: subtractScalar, multiply: multiply, divideScalar: divideScalar, isZero: isZero, unaryMinus: unaryMinus } = _ref;
    /**
   * Calculate the determinant of a matrix.
   *
   * Syntax:
   *
   *    math.det(x)
   *
   * Examples:
   *
   *    math.det([[1, 2], [3, 4]]) // returns -2
   *
   *    const A = [
   *      [-2, 2, 3],
   *      [-1, 1, 3],
   *      [2, 0, -1]
   *    ]
   *    math.det(A) // returns 6
   *
   * See also:
   *
   *    inv
   *
   * @param {Array | Matrix} x  A matrix
   * @return {number} The determinant of `x`
   */ return typed($181e8af6d7e0616f$var$name, {
        any: function any(x) {
            return (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(x);
        },
        "Array | Matrix": function det(x) {
            var size;
            if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(x)) size = x.size();
            else if (Array.isArray(x)) {
                x = matrix(x);
                size = x.size();
            } else // a scalar
            size = [];
            switch(size.length){
                case 0:
                    // scalar
                    return (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(x);
                case 1:
                    // vector
                    if (size[0] === 1) return (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(x.valueOf()[0]);
                    if (size[0] === 0) return 1; // det of an empty matrix is per definition 1
                    else throw new RangeError("Matrix must be square (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
                case 2:
                    // two-dimensional array
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _det(x.clone().valueOf(), rows, cols);
                    if (cols === 0) return 1; // det of an empty matrix is per definition 1
                    else throw new RangeError("Matrix must be square (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
            }
        }
    });
    /**
   * Calculate the determinant of a matrix
   * @param {Array[]} matrix  A square, two dimensional matrix
   * @param {number} rows     Number of rows of the matrix (zero-based)
   * @param {number} cols     Number of columns of the matrix (zero-based)
   * @returns {number} det
   * @private
   */ function _det(matrix, rows, cols) {
        if (rows === 1) // this is a 1 x 1 matrix
        return (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(matrix[0][0]);
        else if (rows === 2) // this is a 2 x 2 matrix
        // the determinant of [a11,a12;a21,a22] is det = a11*a22-a21*a12
        return subtractScalar(multiply(matrix[0][0], matrix[1][1]), multiply(matrix[1][0], matrix[0][1]));
        else {
            // Bareiss algorithm
            // this algorithm have same complexity as LUP decomposition (O(n^3))
            // but it preserve precision of floating point more relative to the LUP decomposition
            var negated = false;
            var rowIndices = new Array(rows).fill(0).map((_, i)=>i); // matrix index of row i
            for(var k = 0; k < rows; k++){
                var k_ = rowIndices[k];
                if (isZero(matrix[k_][k])) {
                    var _k = void 0;
                    for(_k = k + 1; _k < rows; _k++)if (!isZero(matrix[rowIndices[_k]][k])) {
                        k_ = rowIndices[_k];
                        rowIndices[_k] = rowIndices[k];
                        rowIndices[k] = k_;
                        negated = !negated;
                        break;
                    }
                    if (_k === rows) return matrix[k_][k]; // some zero of the type
                }
                var piv = matrix[k_][k];
                var piv_ = k === 0 ? 1 : matrix[rowIndices[k - 1]][k - 1];
                for(var i = k + 1; i < rows; i++){
                    var i_ = rowIndices[i];
                    for(var j = k + 1; j < rows; j++)matrix[i_][j] = divideScalar(subtractScalar(multiply(matrix[i_][j], piv), multiply(matrix[i_][k], matrix[k_][j])), piv_);
                }
            }
            var det = matrix[rowIndices[rows - 1]][rows - 1];
            return negated ? unaryMinus(det) : det;
        }
    }
});





var $26afb3aa4fce391c$var$name = "diag";
var $26afb3aa4fce391c$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix",
    "SparseMatrix"
];
var $26afb3aa4fce391c$export$743a950f2cd4bacc = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($26afb3aa4fce391c$var$name, $26afb3aa4fce391c$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a diagonal matrix or retrieve the diagonal of a matrix
   *
   * When `x` is a vector, a matrix with vector `x` on the diagonal will be returned.
   * When `x` is a two dimensional matrix, the matrixes `k`th diagonal will be returned as vector.
   * When k is positive, the values are placed on the super diagonal.
   * When k is negative, the values are placed on the sub diagonal.
   *
   * Syntax:
   *
   *     math.diag(X)
   *     math.diag(X, format)
   *     math.diag(X, k)
   *     math.diag(X, k, format)
   *
   * Examples:
   *
   *     // create a diagonal matrix
   *     math.diag([1, 2, 3])      // returns [[1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *     math.diag([1, 2, 3], 1)   // returns [[0, 1, 0, 0], [0, 0, 2, 0], [0, 0, 0, 3]]
   *     math.diag([1, 2, 3], -1)  // returns [[0, 0, 0], [1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *
   *    // retrieve the diagonal from a matrix
   *    const a = [[1, 2, 3], [4, 5, 6], [7, 8, 9]]
   *    math.diag(a)   // returns [1, 5, 9]
   *
   * See also:
   *
   *     ones, zeros, identity
   *
   * @param {Matrix | Array} x          A two dimensional matrix or a vector
   * @param {number | BigNumber} [k=0]  The diagonal where the vector will be filled
   *                                    in or retrieved.
   * @param {string} [format='dense']   The matrix storage format.
   *
   * @returns {Matrix | Array} Diagonal matrix from input vector, or diagonal from input matrix.
   */ return typed($26afb3aa4fce391c$var$name, {
        // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
        Array: function Array(x) {
            return _diag(x, 0, (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x), null);
        },
        "Array, number": function ArrayNumber(x, k) {
            return _diag(x, k, (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x), null);
        },
        "Array, BigNumber": function ArrayBigNumber(x, k) {
            return _diag(x, k.toNumber(), (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x), null);
        },
        "Array, string": function ArrayString(x, format) {
            return _diag(x, 0, (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x), format);
        },
        "Array, number, string": function ArrayNumberString(x, k, format) {
            return _diag(x, k, (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x), format);
        },
        "Array, BigNumber, string": function ArrayBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x), format);
        },
        Matrix: function Matrix(x) {
            return _diag(x, 0, x.size(), x.storage());
        },
        "Matrix, number": function MatrixNumber(x, k) {
            return _diag(x, k, x.size(), x.storage());
        },
        "Matrix, BigNumber": function MatrixBigNumber(x, k) {
            return _diag(x, k.toNumber(), x.size(), x.storage());
        },
        "Matrix, string": function MatrixString(x, format) {
            return _diag(x, 0, x.size(), format);
        },
        "Matrix, number, string": function MatrixNumberString(x, k, format) {
            return _diag(x, k, x.size(), format);
        },
        "Matrix, BigNumber, string": function MatrixBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), x.size(), format);
        }
    });
    /**
   * Creeate diagonal matrix from a vector or vice versa
   * @param {Array | Matrix} x
   * @param {number} k
   * @param {string} format Storage format for matrix. If null,
   *                          an Array is returned
   * @returns {Array | Matrix}
   * @private
   */ function _diag(x, k, size, format) {
        if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(k)) throw new TypeError("Second parameter in function diag must be an integer");
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0;
        // check dimensions
        switch(size.length){
            case 1:
                return _createDiagonalMatrix(x, k, format, size[0], kSub, kSuper);
            case 2:
                return _getDiagonal(x, k, format, size, kSub, kSuper);
        }
        throw new RangeError("Matrix for function diag must be 2 dimensional");
    }
    function _createDiagonalMatrix(x, k, format, l, kSub, kSuper) {
        // matrix size
        var ms = [
            l + kSub,
            l + kSuper
        ];
        if (format && format !== "sparse" && format !== "dense") throw new TypeError("Unknown matrix type ".concat(format, '"'));
        // create diagonal matrix
        var m = format === "sparse" ? SparseMatrix.diagonal(ms, x, k) : DenseMatrix.diagonal(ms, x, k);
        // check we need to return a matrix
        return format !== null ? m : m.valueOf();
    }
    function _getDiagonal(x, k, format, s, kSub, kSuper) {
        // check x is a Matrix
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(x)) {
            // get diagonal matrix
            var dm = x.diagonal(k);
            // check we need to return a matrix
            if (format !== null) {
                // check we need to change matrix format
                if (format !== dm.storage()) return matrix(dm, format);
                return dm;
            }
            return dm.valueOf();
        }
        // vector size
        var n = Math.min(s[0] - kSub, s[1] - kSuper);
        // diagonal values
        var vector = [];
        // loop diagonal
        for(var i = 0; i < n; i++)vector[i] = x[i + kSub][i + kSuper];
        // check we need to return a matrix
        return format !== null ? matrix(vector) : vector;
    }
});




var $b9be86f35c7035bf$var$name = "diff";
var $b9be86f35c7035bf$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "number"
];
var $b9be86f35c7035bf$export$49df08fd121951b4 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b9be86f35c7035bf$var$name, $b9be86f35c7035bf$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, number: number } = _ref;
    /**
   * Create a new matrix or array of the difference between elements of the given array
   * The optional dim parameter lets you specify the dimension to evaluate the difference of
   * If no dimension parameter is passed it is assumed as dimension 0
   *
   * Dimension is zero-based in javascript and one-based in the parser and can be a number or bignumber
   * Arrays must be 'rectangular' meaning arrays like [1, 2]
   * If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays
   *
   * Syntax:
   *
   *     math.diff(arr)
   *     math.diff(arr, dim)
   *
   * Examples:
   *
   *     const arr = [1, 2, 4, 7, 0]
   *     math.diff(arr) // returns [1, 2, 3, -7] (no dimension passed so 0 is assumed)
   *     math.diff(math.matrix(arr)) // returns Matrix [1, 2, 3, -7]
   *
   *     const arr = [[1, 2, 3, 4, 5], [1, 2, 3, 4, 5], [9, 8, 7, 6, 4]]
   *     math.diff(arr) // returns [[0, 0, 0, 0, 0], [8, 6, 4, 2, -1]]
   *     math.diff(arr, 0) // returns [[0, 0, 0, 0, 0], [8, 6, 4, 2, -1]]
   *     math.diff(arr, 1) // returns [[1, 1, 1, 1], [1, 1, 1, 1], [-1, -1, -1, -2]]
   *     math.diff(arr, math.bignumber(1)) // returns [[1, 1, 1, 1], [1, 1, 1, 1], [-1, -1, -1, -2]]
   *
   *     math.diff(arr, 2) // throws RangeError as arr is 2 dimensional not 3
   *     math.diff(arr, -1) // throws RangeError as negative dimensions are not allowed
   *
   *     // These will all produce the same result
   *     math.diff([[1, 2], [3, 4]])
   *     math.diff([math.matrix([1, 2]), math.matrix([3, 4])])
   *     math.diff([[1, 2], math.matrix([3, 4])])
   *     math.diff([math.matrix([1, 2]), [3, 4]])
   *     // They do not produce the same result as  math.diff(math.matrix([[1, 2], [3, 4]])) as this returns a matrix
   *
   * See Also:
   *
   *      sum
   *      subtract
   *      partitionSelect
   *
   * @param {Array | Matrix} arr      An array or matrix
   * @param {number | BigNumber} dim  Dimension
   * @return {Array | Matrix}         Difference between array elements in given dimension
   */ return typed($b9be86f35c7035bf$var$name, {
        "Array | Matrix": function ArrayMatrix(arr) {
            // No dimension specified => assume dimension 0
            if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(arr)) return matrix(_diff(arr.toArray()));
            else return _diff(arr);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(arr, dim) {
            if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(dim)) throw new RangeError("Dimension must be a whole number");
            if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(arr)) return matrix(_recursive(arr.toArray(), dim));
            else return _recursive(arr, dim);
        },
        "Array, BigNumber": typed.referTo("Array,number", (selfAn)=>(arr, dim)=>selfAn(arr, number(dim))),
        "Matrix, BigNumber": typed.referTo("Matrix,number", (selfMn)=>(arr, dim)=>selfMn(arr, number(dim)))
    });
    /**
   * Recursively find the correct dimension in the array/matrix
   * Then Apply _diff to that dimension
   *
   * @param {Array} arr      The array
   * @param {number} dim     Dimension
   * @return {Array}         resulting array
   */ function _recursive(arr, dim) {
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(arr)) arr = arr.toArray(); // Makes sure arrays like [ matrix([0, 1]), matrix([1, 0]) ] are processed properly
        if (!Array.isArray(arr)) throw RangeError("Array/Matrix does not have that many dimensions");
        if (dim > 0) {
            var result = [];
            arr.forEach((element)=>{
                result.push(_recursive(element, dim - 1));
            });
            return result;
        } else if (dim === 0) return _diff(arr);
        else throw RangeError("Cannot have negative dimension");
    }
    /**
   * Difference between elements in the array
   *
   * @param {Array} arr      An array
   * @return {Array}         resulting array
   */ function _diff(arr) {
        var result = [];
        var size = arr.length;
        for(var i = 1; i < size; i++)result.push(_ElementDiff(arr[i - 1], arr[i]));
        return result;
    }
    /**
   * Difference between 2 objects
   *
   * @param {Object} obj1    First object
   * @param {Object} obj2    Second object
   * @return {Array}         resulting array
   */ function _ElementDiff(obj1, obj2) {
        // Convert matrices to arrays
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(obj1)) obj1 = obj1.toArray();
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(obj2)) obj2 = obj2.toArray();
        var obj1IsArray = Array.isArray(obj1);
        var obj2IsArray = Array.isArray(obj2);
        if (obj1IsArray && obj2IsArray) return _ArrayDiff(obj1, obj2);
        if (!obj1IsArray && !obj2IsArray) return subtract(obj2, obj1); // Difference is (second - first) NOT (first - second)
        throw TypeError("Cannot calculate difference between 1 array and 1 non-array");
    }
    /**
   * Difference of elements in 2 arrays
   *
   * @param {Array} arr1     Array 1
   * @param {Array} arr2     Array 2
   * @return {Array}         resulting array
   */ function _ArrayDiff(arr1, arr2) {
        if (arr1.length !== arr2.length) throw RangeError("Not all sub-arrays have the same length");
        var result = [];
        var size = arr1.length;
        for(var i = 0; i < size; i++)result.push(_ElementDiff(arr1[i], arr2[i]));
        return result;
    }
});



var $faf8bf69ea8cd285$var$name = "distance";
var $faf8bf69ea8cd285$var$dependencies = [
    "typed",
    "addScalar",
    "subtractScalar",
    "divideScalar",
    "multiplyScalar",
    "deepEqual",
    "sqrt",
    "abs"
];
var $faf8bf69ea8cd285$export$23f482ad1a94fa7e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($faf8bf69ea8cd285$var$name, $faf8bf69ea8cd285$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, subtractScalar: subtractScalar, multiplyScalar: multiplyScalar, divideScalar: divideScalar, deepEqual: deepEqual, sqrt: sqrt, abs: abs } = _ref;
    /**
    * Calculates:
    *    The eucledian distance between two points in N-dimensional spaces.
    *    Distance between point and a line in 2 and 3 dimensional spaces.
    *    Pairwise distance between a set of 2D or 3D points
    * NOTE:
    *    When substituting coefficients of a line(a, b and c), use ax + by + c = 0 instead of ax + by = c
    *    For parametric equation of a 3D line, x0, y0, z0, a, b, c are from: (x−x0, y−y0, z−z0) = t(a, b, c)
    *
    * Syntax:
    *
    *    math.distance([x1,y1], [x2,y2])
    *    math.distance({pointOneX, pointOneY}, {pointTwoX, pointTwoY})
    *    math.distance([x1,y1,z1], [x2,y2,z2])
    *    math.distance({pointOneX, pointOneY, pointOneZ}, {pointTwoX, pointTwoY, pointTwoZ})
    *    math.distance([x1,y1,z1,a1], [x2,y2,z2,a2])
    *    math.distance([[x1,y1], [x2,y2], [x3,y3]])
    *    math.distance([[x1,y1,z1], [x2,y2,z2], [x3,y3,z3]])
    *    math.distance([pointX,pointY], [a,b,c])
    *    math.distance([pointX,pointY], [lineOnePtX,lineOnePtY], [lineTwoPtX,lineTwoPtY])
    *    math.distance({pointX, pointY}, {lineOnePtX, lineOnePtY}, {lineTwoPtX, lineTwoPtY})
    *    math.distance([pointX,pointY,pointZ], [x0, y0, z0, a, b, c])
    *    math.distance({pointX, pointY, pointZ}, {x0, y0, z0, a, b, c})
    *
    * Examples:
    *    math.distance([0,0], [4,4])                     // Returns 5.656854249492381
    *    math.distance(
    *     {pointOneX: 0, pointOneY: 0},
    *     {pointTwoX: 10, pointTwoY: 10})                // Returns 14.142135623730951
    *    math.distance([1, 0, 1], [4, -2, 2])            // Returns 3.7416573867739413
    *    math.distance(
    *     {pointOneX: 4, pointOneY: 5, pointOneZ: 8},
    *     {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})    // Returns 3
    *    math.distance([1, 0, 1, 0], [0, -1, 0, -1])     // Returns 2
    *    math.distance([[1, 2], [1, 2], [1, 3]])         // Returns [0, 1, 1]
    *    math.distance([[1,2,4], [1,2,6], [8,1,3]])      // Returns [2, 7.14142842854285, 7.681145747868608]
    *    math.distance([10, 10], [8, 1, 3])              // Returns 11.535230316796387
    *    math.distance([0, 0], [3, 0], [0, 4])        // Returns 2.4
    *    math.distance(
    *     {pointX: 0, pointY: 0},
    *     {lineOnePtX: 3, lineOnePtY: 0},
    *     {lineTwoPtX: 0, lineTwoPtY: 4})                // Returns 2.4
    *    math.distance([2, 3, 1], [1, 1, 2, 5, 0, 1])    // Returns 2.3204774044612857
    *    math.distance(
    *     {pointX: 2, pointY: 3, pointZ: 1},
    *     {x0: 1, y0: 1, z0: 2, a: 5, b: 0, c: 1})       // Returns 2.3204774044612857
    *
    * @param {Array | Matrix | Object} x    Co-ordinates of first point
    * @param {Array | Matrix | Object} y    Co-ordinates of second point
    * @return {Number | BigNumber} Returns the distance from two/three points
  */ return typed($faf8bf69ea8cd285$var$name, {
        "Array, Array, Array": function ArrayArrayArray(x, y, z) {
            // Point to Line 2D (x=Point, y=LinePoint1, z=LinePoint2)
            if (x.length === 2 && y.length === 2 && z.length === 2) {
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_2d(y)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
                if (!_2d(z)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
                if (deepEqual(y, z)) throw new TypeError("LinePoint1 should not be same with LinePoint2");
                var xCoeff = subtractScalar(z[1], y[1]);
                var yCoeff = subtractScalar(y[0], z[0]);
                var constant = subtractScalar(multiplyScalar(z[0], y[1]), multiplyScalar(y[0], z[1]));
                return _distancePointLine2D(x[0], x[1], xCoeff, yCoeff, constant);
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object, Object": function ObjectObjectObject(x, y, z) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 2 && Object.keys(z).length === 2) {
                if (!_2d(x)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                if (!_2d(y)) throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
                if (!_2d(z)) throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
                if (deepEqual(_objectToArray(y), _objectToArray(z))) throw new TypeError("LinePoint1 should not be same with LinePoint2");
                if ("pointX" in x && "pointY" in x && "lineOnePtX" in y && "lineOnePtY" in y && "lineTwoPtX" in z && "lineTwoPtY" in z) {
                    var xCoeff = subtractScalar(z.lineTwoPtY, y.lineOnePtY);
                    var yCoeff = subtractScalar(y.lineOnePtX, z.lineTwoPtX);
                    var constant = subtractScalar(multiplyScalar(z.lineTwoPtX, y.lineOnePtY), multiplyScalar(y.lineOnePtX, z.lineTwoPtY));
                    return _distancePointLine2D(x.pointX, x.pointY, xCoeff, yCoeff, constant);
                } else throw new TypeError("Key names do not match");
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Array, Array": function ArrayArray(x, y) {
            // Point to Line 2D (x=[pointX, pointY], y=[x-coeff, y-coeff, const])
            if (x.length === 2 && y.length === 3) {
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
                return _distancePointLine2D(x[0], x[1], y[0], y[1], y[2]);
            } else if (x.length === 3 && y.length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
                if (!_parametricLine(y)) throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
                return _distancePointLine3D(x[0], x[1], x[2], y[0], y[1], y[2], y[3], y[4], y[5]);
            } else if (x.length === y.length && x.length > 0) {
                // Point to Point N-dimensions
                if (!_containsOnlyNumbers(x)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                if (!_containsOnlyNumbers(y)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                return _euclideanDistance(x, y);
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object": function ObjectObject(x, y) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 3) {
                if (!_2d(x)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                if (!_3d(y)) throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "xCoeffLine" in y && "yCoeffLine" in y && "constant" in y) return _distancePointLine2D(x.pointX, x.pointY, y.xCoeffLine, y.yCoeffLine, y.constant);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
                if (!_parametricLine(y)) throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "x0" in y && "y0" in y && "z0" in y && "a" in y && "b" in y && "c" in y) return _distancePointLine3D(x.pointX, x.pointY, x.pointZ, y.x0, y.y0, y.z0, y.a, y.b, y.c);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 2 && Object.keys(y).length === 2) {
                // Point to Point 2D
                if (!_2d(x)) throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
                if (!_2d(y)) throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
                if ("pointOneX" in x && "pointOneY" in x && "pointTwoX" in y && "pointTwoY" in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY
                ], [
                    y.pointTwoX,
                    y.pointTwoY
                ]);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 3) {
                // Point to Point 3D
                if (!_3d(x)) throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
                if (!_3d(y)) throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
                if ("pointOneX" in x && "pointOneY" in x && "pointOneZ" in x && "pointTwoX" in y && "pointTwoY" in y && "pointTwoZ" in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY,
                    x.pointOneZ
                ], [
                    y.pointTwoX,
                    y.pointTwoY,
                    y.pointTwoZ
                ]);
                else throw new TypeError("Key names do not match");
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        Array: function Array1(arr) {
            if (!_pairwise(arr)) throw new TypeError("Incorrect array format entered for pairwise distance calculation");
            return _distancePairwise(arr);
        }
    });
    function _isNumber(a) {
        // distance supports numbers and bignumbers
        return typeof a === "number" || (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(a);
    }
    function _2d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]);
    }
    function _3d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]);
    }
    function _containsOnlyNumbers(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (!Array.isArray(a)) a = _objectToArray(a);
        return a.every(_isNumber);
    }
    function _parametricLine(a) {
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]) && _isNumber(a[3]) && _isNumber(a[4]) && _isNumber(a[5]);
    }
    function _objectToArray(o) {
        var keys = Object.keys(o);
        var a = [];
        for(var i = 0; i < keys.length; i++)a.push(o[keys[i]]);
        return a;
    }
    function _pairwise(a) {
        // checks for valid arguments passed to _distancePairwise(Array)
        if (a[0].length === 2 && _isNumber(a[0][0]) && _isNumber(a[0][1])) {
            if (a.some((aI)=>aI.length !== 2 || !_isNumber(aI[0]) || !_isNumber(aI[1]))) return false;
        } else if (a[0].length === 3 && _isNumber(a[0][0]) && _isNumber(a[0][1]) && _isNumber(a[0][2])) {
            if (a.some((aI)=>aI.length !== 3 || !_isNumber(aI[0]) || !_isNumber(aI[1]) || !_isNumber(aI[2]))) return false;
        } else return false;
        return true;
    }
    function _distancePointLine2D(x, y, a, b, c) {
        var num = abs(addScalar(addScalar(multiplyScalar(a, x), multiplyScalar(b, y)), c));
        var den = sqrt(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)));
        return divideScalar(num, den);
    }
    function _distancePointLine3D(x, y, z, x0, y0, z0, a, b, c) {
        var num = [
            subtractScalar(multiplyScalar(subtractScalar(y0, y), c), multiplyScalar(subtractScalar(z0, z), b)),
            subtractScalar(multiplyScalar(subtractScalar(z0, z), a), multiplyScalar(subtractScalar(x0, x), c)),
            subtractScalar(multiplyScalar(subtractScalar(x0, x), b), multiplyScalar(subtractScalar(y0, y), a))
        ];
        num = sqrt(addScalar(addScalar(multiplyScalar(num[0], num[0]), multiplyScalar(num[1], num[1])), multiplyScalar(num[2], num[2])));
        var den = sqrt(addScalar(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)), multiplyScalar(c, c)));
        return divideScalar(num, den);
    }
    function _euclideanDistance(x, y) {
        var vectorSize = x.length;
        var result = 0;
        var diff = 0;
        for(var i = 0; i < vectorSize; i++){
            diff = subtractScalar(x[i], y[i]);
            result = addScalar(multiplyScalar(diff, diff), result);
        }
        return sqrt(result);
    }
    function _distancePairwise(a) {
        var result = [];
        var pointA = [];
        var pointB = [];
        for(var i = 0; i < a.length - 1; i++)for(var j = i + 1; j < a.length; j++){
            if (a[0].length === 2) {
                pointA = [
                    a[i][0],
                    a[i][1]
                ];
                pointB = [
                    a[j][0],
                    a[j][1]
                ];
            } else if (a[0].length === 3) {
                pointA = [
                    a[i][0],
                    a[i][1],
                    a[i][2]
                ];
                pointB = [
                    a[j][0],
                    a[j][1],
                    a[j][2]
                ];
            }
            result.push(_euclideanDistance(pointA, pointB));
        }
        return result;
    }
});





var $8da595bfc6f83799$var$name = "divide";
var $8da595bfc6f83799$var$dependencies = [
    "typed",
    "matrix",
    "multiply",
    "equalScalar",
    "divideScalar",
    "inv"
];
var $8da595bfc6f83799$export$4df5e56bb6d14758 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($8da595bfc6f83799$var$name, $8da595bfc6f83799$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, multiply: multiply, equalScalar: equalScalar, divideScalar: divideScalar, inv: inv } = _ref;
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $ada7281b5c8c5fa6$export$4b07063314120f7c)({
        typed: typed
    });
    /**
   * Divide two values, `x / y`.
   * To divide matrices, `x` is multiplied with the inverse of `y`: `x * inv(y)`.
   *
   * Syntax:
   *
   *    math.divide(x, y)
   *
   * Examples:
   *
   *    math.divide(2, 3)            // returns number 0.6666666666666666
   *
   *    const a = math.complex(5, 14)
   *    const b = math.complex(4, 1)
   *    math.divide(a, b)            // returns Complex 2 + 3i
   *
   *    const c = [[7, -6], [13, -4]]
   *    const d = [[1, 2], [4, 3]]
   *    math.divide(c, d)            // returns Array [[-9, 4], [-11, 6]]
   *
   *    const e = math.unit('18 km')
   *    math.divide(e, 4.5)          // returns Unit 4 km
   *
   * See also:
   *
   *    multiply
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} x   Numerator
   * @param  {number | BigNumber | bigint | Fraction | Complex | Array | Matrix} y          Denominator
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix}                      Quotient, `x / y`
   */ return typed("divide", (0, $46a94b3d1146edd8$export$8b58be045bf06082)({
        // we extend the signatures of divideScalar with signatures dealing with matrices
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(x, y) {
            // TODO: implement matrix right division using pseudo inverse
            // https://www.mathworks.nl/help/matlab/ref/mrdivide.html
            // https://www.gnu.org/software/octave/doc/interpreter/Arithmetic-Ops.html
            // https://stackoverflow.com/questions/12263932/how-does-gnu-octave-matrix-division-work-getting-unexpected-behaviour
            return multiply(x, inv(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return matAlgo14xDs(x, y, divideScalar, false);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return matAlgo11xS0s(x, y, divideScalar, false);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return matAlgo14xDs(matrix(x), y, divideScalar, false).valueOf();
        },
        "any, Array | Matrix": function anyArrayMatrix(x, y) {
            return multiply(x, inv(y));
        }
    }, divideScalar.signatures));
});


var $af46154f7602077c$var$name = "divideScalar";
var $af46154f7602077c$var$dependencies = [
    "typed",
    "numeric"
];
var $af46154f7602077c$export$399593177816ff82 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($af46154f7602077c$var$name, $af46154f7602077c$var$dependencies, (_ref)=>{
    var { typed: typed, numeric: numeric } = _ref;
    /**
   * Divide two scalar values, `x / y`.
   * This function is meant for internal use: it is used by the public functions
   * `divide` and `inv`.
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x   Numerator
   * @param  {number | BigNumber | bigint | Fraction | Complex} y          Denominator
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit}     Quotient, `x / y`
   * @private
   */ return typed($af46154f7602077c$var$name, {
        "number, number": function numberNumber(x, y) {
            return x / y;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.div(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.div(y);
        },
        "bigint, bigint": function bigintBigint(x, y) {
            return x / y;
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.div(y);
        },
        "Unit, number | Complex | Fraction | BigNumber | Unit": (x, y)=>x.divide(y),
        "number | Fraction | Complex | BigNumber, Unit": (x, y)=>y.divideInto(x)
    });
});



var $69c03c7c70af9e3e$var$name = "dot";
var $69c03c7c70af9e3e$var$dependencies = [
    "typed",
    "addScalar",
    "multiplyScalar",
    "conj",
    "size"
];
var $69c03c7c70af9e3e$export$3dc59ff00984d687 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($69c03c7c70af9e3e$var$name, $69c03c7c70af9e3e$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, multiplyScalar: multiplyScalar, conj: conj, size: size } = _ref;
    /**
   * Calculate the dot product of two vectors. The dot product of
   * `A = [a1, a2, ..., an]` and `B = [b1, b2, ..., bn]` is defined as:
   *
   *    dot(A, B) = conj(a1) * b1 + conj(a2) * b2 + ... + conj(an) * bn
   *
   * Syntax:
   *
   *    math.dot(x, y)
   *
   * Examples:
   *
   *    math.dot([2, 4, 1], [2, 2, 3])       // returns number 15
   *    math.multiply([2, 4, 1], [2, 2, 3])  // returns number 15
   *
   * See also:
   *
   *    multiply, cross
   *
   * @param  {Array | Matrix} x     First vector
   * @param  {Array | Matrix} y     Second vector
   * @return {number}               Returns the dot product of `x` and `y`
   */ return typed($69c03c7c70af9e3e$var$name, {
        "Array | DenseMatrix, Array | DenseMatrix": _denseDot,
        "SparseMatrix, SparseMatrix": _sparseDot
    });
    function _validateDim(x, y) {
        var xSize = _size(x);
        var ySize = _size(y);
        var xLen, yLen;
        if (xSize.length === 1) xLen = xSize[0];
        else if (xSize.length === 2 && xSize[1] === 1) xLen = xSize[0];
        else throw new RangeError("Expected a column vector, instead got a matrix of size (" + xSize.join(", ") + ")");
        if (ySize.length === 1) yLen = ySize[0];
        else if (ySize.length === 2 && ySize[1] === 1) yLen = ySize[0];
        else throw new RangeError("Expected a column vector, instead got a matrix of size (" + ySize.join(", ") + ")");
        if (xLen !== yLen) throw new RangeError("Vectors must have equal length (" + xLen + " != " + yLen + ")");
        if (xLen === 0) throw new RangeError("Cannot calculate the dot product of empty vectors");
        return xLen;
    }
    function _denseDot(a, b) {
        var N = _validateDim(a, b);
        var adata = (0, $23cfe017d190638f$export$b22160e0a14f87b7)(a) ? a._data : a;
        var adt = (0, $23cfe017d190638f$export$b22160e0a14f87b7)(a) ? a._datatype || a.getDataType() : undefined;
        var bdata = (0, $23cfe017d190638f$export$b22160e0a14f87b7)(b) ? b._data : b;
        var bdt = (0, $23cfe017d190638f$export$b22160e0a14f87b7)(b) ? b._datatype || b.getDataType() : undefined;
        // are these 2-dimensional column vectors? (as opposed to 1-dimensional vectors)
        var aIsColumn = _size(a).length === 2;
        var bIsColumn = _size(b).length === 2;
        var add = addScalar;
        var mul = multiplyScalar;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string" && adt !== "mixed") {
            var dt = adt;
            // find signatures that matches (dt, dt)
            add = typed.find(addScalar, [
                dt,
                dt
            ]);
            mul = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        }
        // both vectors 1-dimensional
        if (!aIsColumn && !bIsColumn) {
            var c = mul(conj(adata[0]), bdata[0]);
            for(var i = 1; i < N; i++)c = add(c, mul(conj(adata[i]), bdata[i]));
            return c;
        }
        // a is 1-dim, b is column
        if (!aIsColumn && bIsColumn) {
            var _c = mul(conj(adata[0]), bdata[0][0]);
            for(var _i = 1; _i < N; _i++)_c = add(_c, mul(conj(adata[_i]), bdata[_i][0]));
            return _c;
        }
        // a is column, b is 1-dim
        if (aIsColumn && !bIsColumn) {
            var _c2 = mul(conj(adata[0][0]), bdata[0]);
            for(var _i2 = 1; _i2 < N; _i2++)_c2 = add(_c2, mul(conj(adata[_i2][0]), bdata[_i2]));
            return _c2;
        }
        // both vectors are column
        if (aIsColumn && bIsColumn) {
            var _c3 = mul(conj(adata[0][0]), bdata[0][0]);
            for(var _i3 = 1; _i3 < N; _i3++)_c3 = add(_c3, mul(conj(adata[_i3][0]), bdata[_i3][0]));
            return _c3;
        }
    }
    function _sparseDot(x, y) {
        _validateDim(x, y);
        var xindex = x._index;
        var xvalues = x._values;
        var yindex = y._index;
        var yvalues = y._values;
        // TODO optimize add & mul using datatype
        var c = 0;
        var add = addScalar;
        var mul = multiplyScalar;
        var i = 0;
        var j = 0;
        while(i < xindex.length && j < yindex.length){
            var I = xindex[i];
            var J = yindex[j];
            if (I < J) {
                i++;
                continue;
            }
            if (I > J) {
                j++;
                continue;
            }
            if (I === J) {
                c = add(c, mul(xvalues[i], yvalues[j]));
                i++;
                j++;
            }
        }
        return c;
    }
    // TODO remove this once #1771 is fixed
    function _size(x) {
        return (0, $23cfe017d190638f$export$b22160e0a14f87b7)(x) ? x.size() : size(x);
    }
});








var $d64e687f8aef4e84$var$name = "dotDivide";
var $d64e687f8aef4e84$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "divideScalar",
    "DenseMatrix",
    "concat"
];
var $d64e687f8aef4e84$export$e4930a420a373a24 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d64e687f8aef4e84$var$name, $d64e687f8aef4e84$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, divideScalar: divideScalar, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo02xDS0 = (0, $94e325bf4fc92f8c$export$32ae34d6563cd126)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $5e352e66a45fa3fa$export$439c4d7accd2a586)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Divide two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotDivide(x, y)
   *
   * Examples:
   *
   *    math.dotDivide(2, 4)   // returns 0.5
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotDivide(a, b)   // returns [[3, 2.5], [1.2, 0.5]]
   *    math.divide(a, b)      // returns [[1.75, 0.75], [-1.75, 2.25]]
   *
   * See also:
   *
   *    divide, multiply, dotMultiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Numerator
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Quotient, `x ./ y`
   */ return typed($d64e687f8aef4e84$var$name, matrixAlgorithmSuite({
        elop: divideScalar,
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        SD: matAlgo02xDS0,
        Ss: matAlgo11xS0s,
        sS: matAlgo12xSfs
    }));
});






var $a1b68d5cf7d91184$var$name = "dotMultiply";
var $a1b68d5cf7d91184$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "multiplyScalar",
    "concat"
];
var $a1b68d5cf7d91184$export$a4620e84460f321e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a1b68d5cf7d91184$var$name, $a1b68d5cf7d91184$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, multiplyScalar: multiplyScalar, concat: concat } = _ref;
    var matAlgo02xDS0 = (0, $94e325bf4fc92f8c$export$32ae34d6563cd126)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo09xS0Sf = (0, $d51e93553e316d93$export$53a31b0bf876516)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Multiply two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotMultiply(x, y)
   *
   * Examples:
   *
   *    math.dotMultiply(2, 4) // returns 8
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotMultiply(a, b) // returns [[27, 10], [30, 2]]
   *    math.multiply(a, b)    // returns [[52, 28], [23, 14]]
   *
   * See also:
   *
   *    multiply, divide, dotDivide
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Left hand value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Right hand value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Multiplication of `x` and `y`
   */ return typed($a1b68d5cf7d91184$var$name, matrixAlgorithmSuite({
        elop: multiplyScalar,
        SS: matAlgo09xS0Sf,
        DS: matAlgo02xDS0,
        Ss: matAlgo11xS0s
    }));
});







var $76cfd3284e4236cd$var$name = "dotPow";
var $76cfd3284e4236cd$var$dependencies = [
    "typed",
    "equalScalar",
    "matrix",
    "pow",
    "DenseMatrix",
    "concat"
];
var $76cfd3284e4236cd$export$734b49568d8effd6 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($76cfd3284e4236cd$var$name, $76cfd3284e4236cd$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar, matrix: matrix, pow: pow, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $5e352e66a45fa3fa$export$439c4d7accd2a586)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var powScalarSignatures = {};
    for(var signature in pow.signatures){
        if (Object.prototype.hasOwnProperty.call(pow.signatures, signature)) {
            if (!signature.includes("Matrix") && !signature.includes("Array")) powScalarSignatures[signature] = pow.signatures[signature];
        }
    }
    var powScalar = typed(powScalarSignatures);
    /**
   * Calculates the power of x to y element wise.
   *
   * Syntax:
   *
   *    math.dotPow(x, y)
   *
   * Examples:
   *
   *    math.dotPow(2, 3)            // returns number 8
   *
   *    const a = [[1, 2], [4, 3]]
   *    math.dotPow(a, 2)            // returns Array [[1, 4], [16, 9]]
   *    math.pow(a, 2)               // returns Array [[9, 8], [16, 17]]
   *
   * See also:
   *
   *    pow, sqrt, multiply
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y  The exponent
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}                     The value of `x` to the power `y`
   */ return typed($76cfd3284e4236cd$var$name, matrixAlgorithmSuite({
        elop: powScalar,
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo11xS0s,
        sS: matAlgo12xSfs
    }));
});


var $5de67846ea97b93b$export$83d89fbfd8236492 = "13.0.3"; // Note: This file is automatically generated when building math.js.
 // Changes made in this file will be overwritten.



var $b74557deecba29f4$export$737cba75de6dfb68 = (0, $ffc30f141434c696$export$fc10aeed3a532e2a)(function(BigNumber) {
    return new BigNumber(1).exp();
}, {
    hasher: $b74557deecba29f4$var$hasher
});
var $b74557deecba29f4$export$c7e121b24930c156 = (0, $ffc30f141434c696$export$fc10aeed3a532e2a)(function(BigNumber) {
    return new BigNumber(1).plus(new BigNumber(5).sqrt()).div(2);
}, {
    hasher: $b74557deecba29f4$var$hasher
});
var $b74557deecba29f4$export$d0a8190d955e3c5b = (0, $ffc30f141434c696$export$fc10aeed3a532e2a)(function(BigNumber) {
    return BigNumber.acos(-1);
}, {
    hasher: $b74557deecba29f4$var$hasher
});
var $b74557deecba29f4$export$83b6ee92a84f32c6 = (0, $ffc30f141434c696$export$fc10aeed3a532e2a)(function(BigNumber) {
    return $b74557deecba29f4$export$d0a8190d955e3c5b(BigNumber).times(2);
}, {
    hasher: $b74557deecba29f4$var$hasher
});
/**
 * Create a hash for a BigNumber constructor function. The created has is
 * the configured precision
 * @param {Array} args         Supposed to contain a single entry with
 *                             a BigNumber constructor
 * @return {number} precision
 * @private
 */ function $b74557deecba29f4$var$hasher(args) {
    return args[0].precision;
}


var $c4d5b3c037727a6f$export$18c7bea995a110f = Math.PI;
var $c4d5b3c037727a6f$export$a4b4b4d4d776fe92 = 2 * Math.PI;
var $c4d5b3c037727a6f$export$f1e1789686576879 = Math.E;
var $c4d5b3c037727a6f$export$324943737027944a = 1.6180339887498948; // eslint-disable-line no-loss-of-precision


var $f3fa4ca4dc0610f2$export$e13d32722e2756df = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)("true", [], ()=>true);
var $f3fa4ca4dc0610f2$export$cb94e3a54c9e99b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)("false", [], ()=>false);
var $f3fa4ca4dc0610f2$export$d07c6114481fc17b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)("null", [], ()=>null);
var $f3fa4ca4dc0610f2$export$df1313fb6eb44f05 = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("Infinity", [
    "config",
    "?BigNumber"
], (_ref)=>{
    var { config: config, BigNumber: BigNumber } = _ref;
    return config.number === "BigNumber" ? new BigNumber(Infinity) : Infinity;
});
var $f3fa4ca4dc0610f2$export$fbdaee11df58c3cc = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("NaN", [
    "config",
    "?BigNumber"
], (_ref2)=>{
    var { config: config, BigNumber: BigNumber } = _ref2;
    return config.number === "BigNumber" ? new BigNumber(NaN) : NaN;
});
var $f3fa4ca4dc0610f2$export$2dbe69c48ac7f49c = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("pi", [
    "config",
    "?BigNumber"
], (_ref3)=>{
    var { config: config, BigNumber: BigNumber } = _ref3;
    return config.number === "BigNumber" ? (0, $b74557deecba29f4$export$d0a8190d955e3c5b)(BigNumber) : (0, $c4d5b3c037727a6f$export$18c7bea995a110f);
});
var $f3fa4ca4dc0610f2$export$d5973a6d5d95d479 = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("tau", [
    "config",
    "?BigNumber"
], (_ref4)=>{
    var { config: config, BigNumber: BigNumber } = _ref4;
    return config.number === "BigNumber" ? (0, $b74557deecba29f4$export$83b6ee92a84f32c6)(BigNumber) : (0, $c4d5b3c037727a6f$export$a4b4b4d4d776fe92);
});
var $f3fa4ca4dc0610f2$export$6dca51ff4d4b257f = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("e", [
    "config",
    "?BigNumber"
], (_ref5)=>{
    var { config: config, BigNumber: BigNumber } = _ref5;
    return config.number === "BigNumber" ? (0, $b74557deecba29f4$export$737cba75de6dfb68)(BigNumber) : (0, $c4d5b3c037727a6f$export$f1e1789686576879);
});
var $f3fa4ca4dc0610f2$export$f131830080647892 = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("phi", [
    "config",
    "?BigNumber"
], (_ref6)=>{
    var { config: config, BigNumber: BigNumber } = _ref6;
    return config.number === "BigNumber" ? (0, $b74557deecba29f4$export$c7e121b24930c156)(BigNumber) : (0, $c4d5b3c037727a6f$export$324943737027944a);
});
var $f3fa4ca4dc0610f2$export$ab67ddb9e8290a2c = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("LN2", [
    "config",
    "?BigNumber"
], (_ref7)=>{
    var { config: config, BigNumber: BigNumber } = _ref7;
    return config.number === "BigNumber" ? new BigNumber(2).ln() : Math.LN2;
});
var $f3fa4ca4dc0610f2$export$5365e90aad1235b4 = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("LN10", [
    "config",
    "?BigNumber"
], (_ref8)=>{
    var { config: config, BigNumber: BigNumber } = _ref8;
    return config.number === "BigNumber" ? new BigNumber(10).ln() : Math.LN10;
});
var $f3fa4ca4dc0610f2$export$b57f4b4cfc057c2d = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("LOG2E", [
    "config",
    "?BigNumber"
], (_ref9)=>{
    var { config: config, BigNumber: BigNumber } = _ref9;
    return config.number === "BigNumber" ? new BigNumber(1).div(new BigNumber(2).ln()) : Math.LOG2E;
});
var $f3fa4ca4dc0610f2$export$57f654bce66ec8ce = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("LOG10E", [
    "config",
    "?BigNumber"
], (_ref10)=>{
    var { config: config, BigNumber: BigNumber } = _ref10;
    return config.number === "BigNumber" ? new BigNumber(1).div(new BigNumber(10).ln()) : Math.LOG10E;
});
var $f3fa4ca4dc0610f2$export$e6df2cb14f3e8316 = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory(// eslint-disable-line camelcase
"SQRT1_2", [
    "config",
    "?BigNumber"
], (_ref11)=>{
    var { config: config, BigNumber: BigNumber } = _ref11;
    return config.number === "BigNumber" ? new BigNumber("0.5").sqrt() : Math.SQRT1_2;
});
var $f3fa4ca4dc0610f2$export$f7a593fe98eba575 = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("SQRT2", [
    "config",
    "?BigNumber"
], (_ref12)=>{
    var { config: config, BigNumber: BigNumber } = _ref12;
    return config.number === "BigNumber" ? new BigNumber(2).sqrt() : Math.SQRT2;
});
var $f3fa4ca4dc0610f2$export$7122d2461a6f9b76 = /* #__PURE__ */ $f3fa4ca4dc0610f2$var$recreateFactory("i", [
    "Complex"
], (_ref13)=>{
    var { Complex: Complex } = _ref13;
    return Complex.I;
});
var $f3fa4ca4dc0610f2$export$5aab935c59859292 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)("PI", [
    "pi"
], (_ref14)=>{
    var { pi: pi } = _ref14;
    return pi;
});
var $f3fa4ca4dc0610f2$export$56c791a240a1c942 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)("E", [
    "e"
], (_ref15)=>{
    var { e: e } = _ref15;
    return e;
});
var $f3fa4ca4dc0610f2$export$72a91d9326d5a672 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)("version", [], ()=>(0, $5de67846ea97b93b$export$83d89fbfd8236492));
// helper function to create a factory with a flag recreateOnConfigChange
// idea: allow passing optional properties to be attached to the factory function as 4th argument?
function $f3fa4ca4dc0610f2$var$recreateFactory(name, dependencies, create) {
    return (0, $a690df4b5d23d55b$export$e9008f2713103c6c)(name, dependencies, create, {
        recreateOnConfigChange: true
    });
}





function $426474c94157a7cf$export$190353ff415180b5(_ref) {
    var { addScalar: addScalar, subtract: subtract, flatten: flatten, multiply: multiply, multiplyScalar: multiplyScalar, divideScalar: divideScalar, sqrt: sqrt, abs: abs, bignumber: bignumber, diag: diag, size: size, reshape: reshape, inv: inv, qr: qr, usolve: usolve, usolveAll: usolveAll, equal: equal, complex: complex, larger: larger, smaller: smaller, matrixFromColumns: matrixFromColumns, dot: dot } = _ref;
    /**
   * @param {number[][]} arr the matrix to find eigenvalues of
   * @param {number} N size of the matrix
   * @param {number|BigNumber} prec precision, anything lower will be considered zero
   * @param {'number'|'BigNumber'|'Complex'} type
   * @param {boolean} findVectors should we find eigenvectors?
   *
   * @returns {{ values: number[], vectors: number[][] }}
   */ function complexEigs(arr, N, prec, type) {
        var findVectors = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
        // TODO check if any row/col are zero except the diagonal
        // make sure corresponding rows and columns have similar magnitude
        // important because of numerical stability
        // MODIFIES arr by side effect!
        var R = balance(arr, N, prec, type, findVectors);
        // R is the row transformation matrix
        // arr = A' = R A R^-1, A is the original matrix
        // (if findVectors is false, R is undefined)
        // (And so to return to original matrix: A = R^-1 arr R)
        // TODO if magnitudes of elements vary over many orders,
        // move greatest elements to the top left corner
        // using similarity transformations, reduce the matrix
        // to Hessenberg form (upper triangular plus one subdiagonal row)
        // updates the transformation matrix R with new row operationsq
        // MODIFIES arr by side effect!
        reduceToHessenberg(arr, N, prec, type, findVectors, R);
        // still true that original A = R^-1 arr R)
        // find eigenvalues
        var { values: values, C: C } = iterateUntilTriangular(arr, N, prec, type, findVectors);
        // values is the list of eigenvalues, C is the column
        // transformation matrix that transforms arr, the hessenberg
        // matrix, to upper triangular
        // (So U = C^-1 arr C and the relationship between current arr
        // and original A is unchanged.)
        if (findVectors) {
            var eigenvectors = findEigenvectors(arr, N, C, R, values, prec, type);
            return {
                values: values,
                eigenvectors: eigenvectors
            };
        }
        return {
            values: values
        };
    }
    /**
   * @param {number[][]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {number[][]}
   */ function balance(arr, N, prec, type, findVectors) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var realzero = big ? bignumber(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        var realone = big ? bignumber(1) : 1;
        // base of the floating-point arithmetic
        var radix = big ? bignumber(10) : 2;
        var radixSq = multiplyScalar(radix, radix);
        // the diagonal transformation matrix R
        var Rdiag;
        if (findVectors) Rdiag = Array(N).fill(one);
        // this isn't the only time we loop thru the matrix...
        var last = false;
        while(!last){
            // ...haha I'm joking! unless...
            last = true;
            for(var i = 0; i < N; i++){
                // compute the taxicab norm of i-th column and row
                // TODO optimize for complex numbers
                var colNorm = realzero;
                var rowNorm = realzero;
                for(var j = 0; j < N; j++){
                    if (i === j) continue;
                    colNorm = addScalar(colNorm, abs(arr[j][i]));
                    rowNorm = addScalar(rowNorm, abs(arr[i][j]));
                }
                if (!equal(colNorm, 0) && !equal(rowNorm, 0)) {
                    // find integer power closest to balancing the matrix
                    // (we want to scale only by integer powers of radix,
                    // so that we don't lose any precision due to round-off)
                    var f = realone;
                    var c = colNorm;
                    var rowDivRadix = divideScalar(rowNorm, radix);
                    var rowMulRadix = multiplyScalar(rowNorm, radix);
                    while(smaller(c, rowDivRadix)){
                        c = multiplyScalar(c, radixSq);
                        f = multiplyScalar(f, radix);
                    }
                    while(larger(c, rowMulRadix)){
                        c = divideScalar(c, radixSq);
                        f = divideScalar(f, radix);
                    }
                    // check whether balancing is needed
                    // condition = (c + rowNorm) / f < 0.95 * (colNorm + rowNorm)
                    var condition = smaller(divideScalar(addScalar(c, rowNorm), f), multiplyScalar(addScalar(colNorm, rowNorm), 0.95));
                    // apply balancing similarity transformation
                    if (condition) {
                        // we should loop once again to check whether
                        // another rebalancing is needed
                        last = false;
                        var g = divideScalar(1, f);
                        for(var _j = 0; _j < N; _j++){
                            if (i === _j) continue;
                            arr[i][_j] = multiplyScalar(arr[i][_j], g);
                            arr[_j][i] = multiplyScalar(arr[_j][i], f);
                        }
                        // keep track of transformations
                        if (findVectors) Rdiag[i] = multiplyScalar(Rdiag[i], g);
                    }
                }
            }
        }
        // return the diagonal row transformation matrix
        return findVectors ? diag(Rdiag) : null;
    }
    /**
   * @param {number[][]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number'|'BigNumber'|'Complex'} type
   * @param {boolean} findVectors
   * @param {number[][]} R the row transformation matrix that will be modified
   */ function reduceToHessenberg(arr, N, prec, type, findVectors, R) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        if (big) prec = bignumber(prec);
        for(var i = 0; i < N - 2; i++){
            // Find the largest subdiag element in the i-th col
            var maxIndex = 0;
            var max = zero;
            for(var j = i + 1; j < N; j++){
                var el = arr[j][i];
                if (smaller(abs(max), abs(el))) {
                    max = el;
                    maxIndex = j;
                }
            }
            // This col is pivoted, no need to do anything
            if (smaller(abs(max), prec)) continue;
            if (maxIndex !== i + 1) {
                // Interchange maxIndex-th and (i+1)-th row
                var tmp1 = arr[maxIndex];
                arr[maxIndex] = arr[i + 1];
                arr[i + 1] = tmp1;
                // Interchange maxIndex-th and (i+1)-th column
                for(var _j2 = 0; _j2 < N; _j2++){
                    var tmp2 = arr[_j2][maxIndex];
                    arr[_j2][maxIndex] = arr[_j2][i + 1];
                    arr[_j2][i + 1] = tmp2;
                }
                // keep track of transformations
                if (findVectors) {
                    var tmp3 = R[maxIndex];
                    R[maxIndex] = R[i + 1];
                    R[i + 1] = tmp3;
                }
            }
            // Reduce following rows and columns
            for(var _j3 = i + 2; _j3 < N; _j3++){
                var n = divideScalar(arr[_j3][i], max);
                if (n === 0) continue;
                // from j-th row subtract n-times (i+1)th row
                for(var k = 0; k < N; k++)arr[_j3][k] = subtract(arr[_j3][k], multiplyScalar(n, arr[i + 1][k]));
                // to (i+1)th column add n-times j-th column
                for(var _k = 0; _k < N; _k++)arr[_k][i + 1] = addScalar(arr[_k][i + 1], multiplyScalar(n, arr[_k][_j3]));
                // keep track of transformations
                if (findVectors) for(var _k2 = 0; _k2 < N; _k2++)R[_j3][_k2] = subtract(R[_j3][_k2], multiplyScalar(n, R[i + 1][_k2]));
            }
        }
        return R;
    }
    /**
   * @returns {{values: values, C: Matrix}}
   * @see Press, Wiliams: Numerical recipes in Fortran 77
   * @see https://en.wikipedia.org/wiki/QR_algorithm
   */ function iterateUntilTriangular(A, N, prec, type, findVectors) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        if (big) prec = bignumber(prec);
        // The Francis Algorithm
        // The core idea of this algorithm is that doing successive
        // A' = QtAQ transformations will eventually converge to block-
        // upper-triangular with diagonal blocks either 1x1 or 2x2.
        // The Q here is the one from the QR decomposition, A = QR.
        // Since the eigenvalues of a block-upper-triangular matrix are
        // the eigenvalues of its diagonal blocks and we know how to find
        // eigenvalues of a 2x2 matrix, we know the eigenvalues of A.
        var arr = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(A);
        // the list of converged eigenvalues
        var lambdas = [];
        // size of arr, which will get smaller as eigenvalues converge
        var n = N;
        // the diagonal of the block-diagonal matrix that turns
        // converged 2x2 matrices into upper triangular matrices
        var Sdiag = [];
        // N×N matrix describing the overall transformation done during the QR algorithm
        var Qtotal = findVectors ? diag(Array(N).fill(one)) : undefined;
        // nxn matrix describing the QR transformations done since last convergence
        var Qpartial = findVectors ? diag(Array(n).fill(one)) : undefined;
        // last eigenvalue converged before this many steps
        var lastConvergenceBefore = 0;
        while(lastConvergenceBefore <= 100){
            lastConvergenceBefore += 1;
            // TODO if the convergence is slow, do something clever
            // Perform the factorization
            var k = arr[n - 1][n - 1]; // TODO this is apparently a somewhat
            // old-fashioned choice; ideally set close to an eigenvalue, or
            // perhaps better yet switch to the implicit QR version that is sometimes
            // specifically called the "Francis algorithm" that is alluded to
            // in the following TODO. (Or perhaps we switch to an independently
            // optimized third-party package for the linear algebra operations...)
            for(var i = 0; i < n; i++)arr[i][i] = subtract(arr[i][i], k);
            // TODO do an implicit QR transformation
            var { Q: Q, R: R } = qr(arr);
            arr = multiply(R, Q);
            for(var _i = 0; _i < n; _i++)arr[_i][_i] = addScalar(arr[_i][_i], k);
            // keep track of transformations
            if (findVectors) Qpartial = multiply(Qpartial, Q);
            // The rightmost diagonal element converged to an eigenvalue
            if (n === 1 || smaller(abs(arr[n - 1][n - 2]), prec)) {
                lastConvergenceBefore = 0;
                lambdas.push(arr[n - 1][n - 1]);
                // keep track of transformations
                if (findVectors) {
                    Sdiag.unshift([
                        [
                            1
                        ]
                    ]);
                    inflateMatrix(Qpartial, N);
                    Qtotal = multiply(Qtotal, Qpartial);
                    if (n > 1) Qpartial = diag(Array(n - 1).fill(one));
                }
                // reduce the matrix size
                n -= 1;
                arr.pop();
                for(var _i2 = 0; _i2 < n; _i2++)arr[_i2].pop();
            // The rightmost diagonal 2x2 block converged
            } else if (n === 2 || smaller(abs(arr[n - 2][n - 3]), prec)) {
                lastConvergenceBefore = 0;
                var ll = eigenvalues2x2(arr[n - 2][n - 2], arr[n - 2][n - 1], arr[n - 1][n - 2], arr[n - 1][n - 1]);
                lambdas.push(...ll);
                // keep track of transformations
                if (findVectors) {
                    Sdiag.unshift(jordanBase2x2(arr[n - 2][n - 2], arr[n - 2][n - 1], arr[n - 1][n - 2], arr[n - 1][n - 1], ll[0], ll[1], prec, type));
                    inflateMatrix(Qpartial, N);
                    Qtotal = multiply(Qtotal, Qpartial);
                    if (n > 2) Qpartial = diag(Array(n - 2).fill(one));
                }
                // reduce the matrix size
                n -= 2;
                arr.pop();
                arr.pop();
                for(var _i3 = 0; _i3 < n; _i3++){
                    arr[_i3].pop();
                    arr[_i3].pop();
                }
            }
            if (n === 0) break;
        }
        // standard sorting
        lambdas.sort((a, b)=>+subtract(abs(a), abs(b)));
        // the algorithm didn't converge
        if (lastConvergenceBefore > 100) {
            var err = Error("The eigenvalues failed to converge. Only found these eigenvalues: " + lambdas.join(", "));
            err.values = lambdas;
            err.vectors = [];
            throw err;
        }
        // combine the overall QR transformation Qtotal with the subsequent
        // transformation S that turns the diagonal 2x2 blocks to upper triangular
        var C = findVectors ? multiply(Qtotal, blockDiag(Sdiag, N)) : undefined;
        return {
            values: lambdas,
            C: C
        };
    }
    /**
   * @param {Matrix} A hessenberg-form matrix
   * @param {number} N size of A
   * @param {Matrix} C column transformation matrix that turns A into upper triangular
   * @param {Matrix} R similarity that turns original matrix into A
   * @param {number[]} values array of eigenvalues of A
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {number[][]} eigenvalues
   */ function findEigenvectors(A, N, C, R, values, prec, type) {
        var Cinv = inv(C);
        var U = multiply(Cinv, A, C);
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        // turn values into a kind of "multiset"
        // this way it is easier to find eigenvectors
        var uniqueValues = [];
        var multiplicities = [];
        for (var lambda of values){
            var i = indexOf(uniqueValues, lambda, equal);
            if (i === -1) {
                uniqueValues.push(lambda);
                multiplicities.push(1);
            } else multiplicities[i] += 1;
        }
        // find eigenvectors by solving U − lambdaE = 0
        // TODO replace with an iterative eigenvector algorithm
        // (this one might fail for imprecise eigenvalues)
        var vectors = [];
        var len = uniqueValues.length;
        var b = Array(N).fill(zero);
        var E = diag(Array(N).fill(one));
        var _loop = function _loop() {
            var lambda = uniqueValues[_i4];
            var S = subtract(U, multiply(lambda, E)); // the characteristic matrix
            var solutions = usolveAll(S, b);
            solutions.shift(); // ignore the null vector
            // looks like we missed something, try inverse iteration
            // But if that fails, just presume that the original matrix truly
            // was defective.
            while(solutions.length < multiplicities[_i4]){
                var approxVec = inverseIterate(S, N, solutions, prec, type);
                if (approxVec === null) break;
                 // no more vectors were found
                solutions.push(approxVec);
            }
            // Transform back into original array coordinates
            var correction = multiply(inv(R), C);
            solutions = solutions.map((v)=>multiply(correction, v));
            vectors.push(...solutions.map((v)=>({
                    value: lambda,
                    vector: flatten(v)
                })));
        };
        for(var _i4 = 0; _i4 < len; _i4++)_loop();
        return vectors;
    }
    /**
   * Compute the eigenvalues of an 2x2 matrix
   * @return {[number,number]}
   */ function eigenvalues2x2(a, b, c, d) {
        // lambda_+- = 1/2 trA +- 1/2 sqrt( tr^2 A - 4 detA )
        var trA = addScalar(a, d);
        var detA = subtract(multiplyScalar(a, d), multiplyScalar(b, c));
        var x = multiplyScalar(trA, 0.5);
        var y = multiplyScalar(sqrt(subtract(multiplyScalar(trA, trA), multiplyScalar(4, detA))), 0.5);
        return [
            addScalar(x, y),
            subtract(x, y)
        ];
    }
    /**
   * For an 2x2 matrix compute the transformation matrix S,
   * so that SAS^-1 is an upper triangular matrix
   * @return {[[number,number],[number,number]]}
   * @see https://math.berkeley.edu/~ogus/old/Math_54-05/webfoils/jordan.pdf
   * @see http://people.math.harvard.edu/~knill/teaching/math21b2004/exhibits/2dmatrices/index.html
   */ function jordanBase2x2(a, b, c, d, l1, l2, prec, type) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        // matrix is already upper triangular
        // return an identity matrix
        if (smaller(abs(c), prec)) return [
            [
                one,
                zero
            ],
            [
                zero,
                one
            ]
        ];
        // matrix is diagonalizable
        // return its eigenvectors as columns
        if (larger(abs(subtract(l1, l2)), prec)) return [
            [
                subtract(l1, d),
                subtract(l2, d)
            ],
            [
                c,
                c
            ]
        ];
        // matrix is not diagonalizable
        // compute diagonal elements of N = A - lambdaI
        var na = subtract(a, l1);
        var nd = subtract(d, l1);
        // col(N,2) = 0  implies  S = ( col(N,1), e_1 )
        // col(N,2) != 0 implies  S = ( col(N,2), e_2 )
        if (smaller(abs(b), prec) && smaller(abs(nd), prec)) return [
            [
                na,
                one
            ],
            [
                c,
                zero
            ]
        ];
        else return [
            [
                b,
                zero
            ],
            [
                nd,
                one
            ]
        ];
    }
    /**
   * Enlarge the matrix from nxn to NxN, setting the new
   * elements to 1 on diagonal and 0 elsewhere
   */ function inflateMatrix(arr, N) {
        // add columns
        for(var i = 0; i < arr.length; i++)arr[i].push(...Array(N - arr[i].length).fill(0));
        // add rows
        for(var _i5 = arr.length; _i5 < N; _i5++){
            arr.push(Array(N).fill(0));
            arr[_i5][_i5] = 1;
        }
        return arr;
    }
    /**
   * Create a block-diagonal matrix with the given square matrices on the diagonal
   * @param {Matrix[] | number[][][]} arr array of matrices to be placed on the diagonal
   * @param {number} N the size of the resulting matrix
   */ function blockDiag(arr, N) {
        var M = [];
        for(var i = 0; i < N; i++)M[i] = Array(N).fill(0);
        var I = 0;
        for (var sub of arr){
            var n = sub.length;
            for(var _i6 = 0; _i6 < n; _i6++)for(var j = 0; j < n; j++)M[I + _i6][I + j] = sub[_i6][j];
            I += n;
        }
        return M;
    }
    /**
   * Finds the index of an element in an array using a custom equality function
   * @template T
   * @param {Array<T>} arr array in which to search
   * @param {T} el the element to find
   * @param {function(T, T): boolean} fn the equality function, first argument is an element of `arr`, the second is always `el`
   * @returns {number} the index of `el`, or -1 when it's not in `arr`
   */ function indexOf(arr, el, fn) {
        for(var i = 0; i < arr.length; i++){
            if (fn(arr[i], el)) return i;
        }
        return -1;
    }
    /**
   * Provided a near-singular upper-triangular matrix A and a list of vectors,
   * finds an eigenvector of A with the smallest eigenvalue, which is orthogonal
   * to each vector in the list
   * @template T
   * @param {T[][]} A near-singular square matrix
   * @param {number} N dimension
   * @param {T[][]} orthog list of vectors
   * @param {number} prec epsilon
   * @param {'number'|'BigNumber'|'Complex'} type
   * @return {T[] | null} eigenvector
   *
   * @see Numerical Recipes for Fortran 77 – 11.7 Eigenvalues or Eigenvectors by Inverse Iteration
   */ function inverseIterate(A, N, orthog, prec, type) {
        var largeNum = type === "BigNumber" ? bignumber(1000) : 1000;
        var b; // the vector
        // you better choose a random vector before I count to five
        var i = 0;
        for(; i < 5; ++i){
            b = randomOrthogonalVector(N, orthog, type);
            try {
                b = usolve(A, b);
            } catch (_unused) {
                continue;
            }
            if (larger(norm(b), largeNum)) break;
        }
        if (i >= 5) return null; // couldn't find any orthogonal vector in the image
        // you better converge before I count to ten
        i = 0;
        while(true){
            var c = usolve(A, b);
            if (smaller(norm(orthogonalComplement(b, [
                c
            ])), prec)) break;
            if (++i >= 10) return null;
            b = normalize(c);
        }
        return b;
    }
    /**
   * Generates a random unit vector of dimension N, orthogonal to each vector in the list
   * @template T
   * @param {number} N dimension
   * @param {T[][]} orthog list of vectors
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {T[]} random vector
   */ function randomOrthogonalVector(N, orthog, type) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        // generate random vector with the correct type
        var v = Array(N).fill(0).map((_)=>2 * Math.random() - 1);
        if (big) v = v.map((n)=>bignumber(n));
        if (cplx) v = v.map((n)=>complex(n));
        // project to orthogonal complement
        v = orthogonalComplement(v, orthog);
        // normalize
        return normalize(v, type);
    }
    /**
   * Project vector v to the orthogonal complement of an array of vectors
   */ function orthogonalComplement(v, orthog) {
        var vectorShape = size(v);
        for (var w of orthog){
            w = reshape(w, vectorShape); // make sure this is just a vector computation
            // v := v − (w, v)/|w|^2 w
            v = subtract(v, multiply(divideScalar(dot(w, v), dot(w, w)), w));
        }
        return v;
    }
    /**
   * Calculate the norm of a vector.
   * We can't use math.norm because factory can't handle circular dependency.
   * Seriously, I'm really fed up with factory.
   */ function norm(v) {
        return abs(sqrt(dot(v, v)));
    }
    /**
   * Normalize a vector
   * @template T
   * @param {T[]} v
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {T[]} normalized vec
   */ function normalize(v, type) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        return multiply(divideScalar(one, norm(v)), v);
    }
    return complexEigs;
}



function $ca8c4ba5f43b4404$export$a8f76d83a88e1b99(_ref) {
    var { config: config, addScalar: addScalar, subtract: subtract, abs: abs, atan: atan, cos: cos, sin: sin, multiplyScalar: multiplyScalar, inv: inv, bignumber: bignumber, multiply: multiply, add: add } = _ref;
    /**
   * @param {number[] | BigNumber[]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number' | 'BigNumber'} type
   */ function main(arr, N) {
        var prec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : config.relTol;
        var type = arguments.length > 3 ? arguments[3] : undefined;
        var computeVectors = arguments.length > 4 ? arguments[4] : undefined;
        if (type === "number") return diag(arr, prec, computeVectors);
        if (type === "BigNumber") return diagBig(arr, prec, computeVectors);
        throw TypeError("Unsupported data type: " + type);
    }
    // diagonalization implementation for number (efficient)
    function diag(x, precision, computeVectors) {
        var N = x.length;
        var e0 = Math.abs(precision / N);
        var psi;
        var Sij;
        if (computeVectors) {
            Sij = new Array(N);
            // Sij is Identity Matrix
            for(var i = 0; i < N; i++){
                Sij[i] = Array(N).fill(0);
                Sij[i][i] = 1.0;
            }
        }
        // initial error
        var Vab = getAij(x);
        while(Math.abs(Vab[1]) >= Math.abs(e0)){
            var _i = Vab[0][0];
            var j = Vab[0][1];
            psi = getTheta(x[_i][_i], x[j][j], x[_i][j]);
            x = x1(x, psi, _i, j);
            if (computeVectors) Sij = Sij1(Sij, psi, _i, j);
            Vab = getAij(x);
        }
        var Ei = Array(N).fill(0); // eigenvalues
        for(var _i2 = 0; _i2 < N; _i2++)Ei[_i2] = x[_i2][_i2];
        return sorting((0, $46a94b3d1146edd8$export$9cd59f9826255e47)(Ei), Sij, computeVectors);
    }
    // diagonalization implementation for bigNumber
    function diagBig(x, precision, computeVectors) {
        var N = x.length;
        var e0 = abs(precision / N);
        var psi;
        var Sij;
        if (computeVectors) {
            Sij = new Array(N);
            // Sij is Identity Matrix
            for(var i = 0; i < N; i++){
                Sij[i] = Array(N).fill(0);
                Sij[i][i] = 1.0;
            }
        }
        // initial error
        var Vab = getAijBig(x);
        while(abs(Vab[1]) >= abs(e0)){
            var _i3 = Vab[0][0];
            var j = Vab[0][1];
            psi = getThetaBig(x[_i3][_i3], x[j][j], x[_i3][j]);
            x = x1Big(x, psi, _i3, j);
            if (computeVectors) Sij = Sij1Big(Sij, psi, _i3, j);
            Vab = getAijBig(x);
        }
        var Ei = Array(N).fill(0); // eigenvalues
        for(var _i4 = 0; _i4 < N; _i4++)Ei[_i4] = x[_i4][_i4];
        // return [clone(Ei), clone(Sij)]
        return sorting((0, $46a94b3d1146edd8$export$9cd59f9826255e47)(Ei), Sij, computeVectors);
    }
    // get angle
    function getTheta(aii, ajj, aij) {
        var denom = ajj - aii;
        if (Math.abs(denom) <= config.relTol) return Math.PI / 4.0;
        else return 0.5 * Math.atan(2.0 * aij / (ajj - aii));
    }
    // get angle
    function getThetaBig(aii, ajj, aij) {
        var denom = subtract(ajj, aii);
        if (abs(denom) <= config.relTol) return bignumber(-1).acos().div(4);
        else return multiplyScalar(0.5, atan(multiply(2.0, aij, inv(denom))));
    }
    // update eigvec
    function Sij1(Sij, theta, i, j) {
        var N = Sij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var Ski = Array(N).fill(0);
        var Skj = Array(N).fill(0);
        for(var k = 0; k < N; k++){
            Ski[k] = c * Sij[k][i] - s * Sij[k][j];
            Skj[k] = s * Sij[k][i] + c * Sij[k][j];
        }
        for(var _k = 0; _k < N; _k++){
            Sij[_k][i] = Ski[_k];
            Sij[_k][j] = Skj[_k];
        }
        return Sij;
    }
    // update eigvec for overlap
    function Sij1Big(Sij, theta, i, j) {
        var N = Sij.length;
        var c = cos(theta);
        var s = sin(theta);
        var Ski = Array(N).fill(bignumber(0));
        var Skj = Array(N).fill(bignumber(0));
        for(var k = 0; k < N; k++){
            Ski[k] = subtract(multiplyScalar(c, Sij[k][i]), multiplyScalar(s, Sij[k][j]));
            Skj[k] = addScalar(multiplyScalar(s, Sij[k][i]), multiplyScalar(c, Sij[k][j]));
        }
        for(var _k2 = 0; _k2 < N; _k2++){
            Sij[_k2][i] = Ski[_k2];
            Sij[_k2][j] = Skj[_k2];
        }
        return Sij;
    }
    // update matrix
    function x1Big(Hij, theta, i, j) {
        var N = Hij.length;
        var c = bignumber(cos(theta));
        var s = bignumber(sin(theta));
        var c2 = multiplyScalar(c, c);
        var s2 = multiplyScalar(s, s);
        var Aki = Array(N).fill(bignumber(0));
        var Akj = Array(N).fill(bignumber(0));
        // 2cs Hij
        var csHij = multiply(bignumber(2), c, s, Hij[i][j]);
        //  Aii
        var Aii = addScalar(subtract(multiplyScalar(c2, Hij[i][i]), csHij), multiplyScalar(s2, Hij[j][j]));
        var Ajj = add(multiplyScalar(s2, Hij[i][i]), csHij, multiplyScalar(c2, Hij[j][j]));
        // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = subtract(multiplyScalar(c, Hij[i][k]), multiplyScalar(s, Hij[j][k]));
            Akj[k] = addScalar(multiplyScalar(s, Hij[i][k]), multiplyScalar(c, Hij[j][k]));
        }
        // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = bignumber(0);
        Hij[j][i] = bignumber(0);
        // 0  to i
        for(var _k3 = 0; _k3 < N; _k3++)if (_k3 !== i && _k3 !== j) {
            Hij[i][_k3] = Aki[_k3];
            Hij[_k3][i] = Aki[_k3];
            Hij[j][_k3] = Akj[_k3];
            Hij[_k3][j] = Akj[_k3];
        }
        return Hij;
    }
    // update matrix
    function x1(Hij, theta, i, j) {
        var N = Hij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var c2 = c * c;
        var s2 = s * s;
        var Aki = Array(N).fill(0);
        var Akj = Array(N).fill(0);
        //  Aii
        var Aii = c2 * Hij[i][i] - 2 * c * s * Hij[i][j] + s2 * Hij[j][j];
        var Ajj = s2 * Hij[i][i] + 2 * c * s * Hij[i][j] + c2 * Hij[j][j];
        // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = c * Hij[i][k] - s * Hij[j][k];
            Akj[k] = s * Hij[i][k] + c * Hij[j][k];
        }
        // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = 0;
        Hij[j][i] = 0;
        // 0  to i
        for(var _k4 = 0; _k4 < N; _k4++)if (_k4 !== i && _k4 !== j) {
            Hij[i][_k4] = Aki[_k4];
            Hij[_k4][i] = Aki[_k4];
            Hij[j][_k4] = Akj[_k4];
            Hij[_k4][j] = Akj[_k4];
        }
        return Hij;
    }
    // get max off-diagonal value from Upper Diagonal
    function getAij(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (Math.abs(maxMij) < Math.abs(Mij[i][j])) {
                maxMij = Math.abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    }
    // get max off-diagonal value from Upper Diagonal
    function getAijBig(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (abs(maxMij) < abs(Mij[i][j])) {
                maxMij = abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    }
    // sort results
    function sorting(E, S, computeVectors) {
        var N = E.length;
        var values = Array(N);
        var vecs;
        if (computeVectors) {
            vecs = Array(N);
            for(var k = 0; k < N; k++)vecs[k] = Array(N);
        }
        for(var i = 0; i < N; i++){
            var minID = 0;
            var minE = E[0];
            for(var j = 0; j < E.length; j++)if (abs(E[j]) < abs(minE)) {
                minID = j;
                minE = E[minID];
            }
            values[i] = E.splice(minID, 1)[0];
            if (computeVectors) for(var _k5 = 0; _k5 < N; _k5++){
                vecs[i][_k5] = S[_k5][minID];
                S[_k5].splice(minID, 1);
            }
        }
        if (!computeVectors) return {
            values: values
        };
        var eigenvectors = vecs.map((vector, i)=>({
                value: values[i],
                vector: vector
            }));
        return {
            values: values,
            eigenvectors: eigenvectors
        };
    }
    return main;
}



var $67be443f2a674d81$var$name = "eigs";
// The absolute state of math.js's dependency system:
var $67be443f2a674d81$var$dependencies = [
    "config",
    "typed",
    "matrix",
    "addScalar",
    "equal",
    "subtract",
    "abs",
    "atan",
    "cos",
    "sin",
    "multiplyScalar",
    "divideScalar",
    "inv",
    "bignumber",
    "multiply",
    "add",
    "larger",
    "column",
    "flatten",
    "number",
    "complex",
    "sqrt",
    "diag",
    "size",
    "reshape",
    "qr",
    "usolve",
    "usolveAll",
    "im",
    "re",
    "smaller",
    "matrixFromColumns",
    "dot"
];
var $67be443f2a674d81$export$ba9e077a2df092d7 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($67be443f2a674d81$var$name, $67be443f2a674d81$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, matrix: matrix, addScalar: addScalar, subtract: subtract, equal: equal, abs: abs, atan: atan, cos: cos, sin: sin, multiplyScalar: multiplyScalar, divideScalar: divideScalar, inv: inv, bignumber: bignumber, multiply: multiply, add: add, larger: larger, column: column, flatten: flatten, number: number, complex: complex, sqrt: sqrt, diag: diag, size: size, reshape: reshape, qr: qr, usolve: usolve, usolveAll: usolveAll, im: im, re: re, smaller: smaller, matrixFromColumns: matrixFromColumns, dot: dot } = _ref;
    var doRealSymmetric = (0, $ca8c4ba5f43b4404$export$a8f76d83a88e1b99)({
        config: config,
        addScalar: addScalar,
        subtract: subtract,
        column: column,
        flatten: flatten,
        equal: equal,
        abs: abs,
        atan: atan,
        cos: cos,
        sin: sin,
        multiplyScalar: multiplyScalar,
        inv: inv,
        bignumber: bignumber,
        complex: complex,
        multiply: multiply,
        add: add
    });
    var doComplexEigs = (0, $426474c94157a7cf$export$190353ff415180b5)({
        config: config,
        addScalar: addScalar,
        subtract: subtract,
        multiply: multiply,
        multiplyScalar: multiplyScalar,
        flatten: flatten,
        divideScalar: divideScalar,
        sqrt: sqrt,
        abs: abs,
        bignumber: bignumber,
        diag: diag,
        size: size,
        reshape: reshape,
        qr: qr,
        inv: inv,
        usolve: usolve,
        usolveAll: usolveAll,
        equal: equal,
        complex: complex,
        larger: larger,
        smaller: smaller,
        matrixFromColumns: matrixFromColumns,
        dot: dot
    });
    /**
   * Compute eigenvalues and optionally eigenvectors of a square matrix.
   * The eigenvalues are sorted by their absolute value, ascending, and
   * returned as a vector in the `values` property of the returned project.
   * An eigenvalue with algebraic multiplicity k will be listed k times, so
   * that the returned `values` vector always has length equal to the size
   * of the input matrix.
   *
   * The `eigenvectors` property of the return value provides the eigenvectors.
   * It is an array of plain objects: the `value` property of each gives the
   * associated eigenvalue, and the `vector` property gives the eigenvector
   * itself. Note that the same `value` property will occur as many times in
   * the list provided by `eigenvectors` as the geometric multiplicity of
   * that value.
   *
   * If the algorithm fails to converge, it will throw an error –
   * in that case, however, you may still find useful information
   * in `err.values` and `err.vectors`.
   *
   * Note that the 'precision' option does not directly specify the _accuracy_
   * of the returned eigenvalues. Rather, it determines how small an entry
   * of the iterative approximations to an upper triangular matrix must be
   * in order to be considered zero. The actual accuracy of the returned
   * eigenvalues may be greater or less than the precision, depending on the
   * conditioning of the matrix and how far apart or close the actual
   * eigenvalues are. Note that currently, relatively simple, "traditional"
   * methods of eigenvalue computation are being used; this is not a modern,
   * high-precision eigenvalue computation. That said, it should typically
   * produce fairly reasonable results.
   *
   * Syntax:
   *
   *     math.eigs(x, [prec])
   *     math.eigs(x, {options})
   *
   * Examples:
   *
   *     const { eigs, multiply, column, transpose, matrixFromColumns } = math
   *     const H = [[5, 2.3], [2.3, 1]]
   *     const ans = eigs(H) // returns {values: [E1,E2...sorted], eigenvectors: [{value: E1, vector: v2}, {value: e, vector: v2}, ...]
   *     const E = ans.values
   *     const V = ans.eigenvectors
   *     multiply(H, V[0].vector)) // returns multiply(E[0], V[0].vector))
   *     const U = matrixFromColumns(...V.map(obj => obj.vector))
   *     const UTxHxU = multiply(transpose(U), H, U) // diagonalizes H if possible
   *     E[0] == UTxHxU[0][0]  // returns true always
   *
   *     // Compute only approximate eigenvalues:
   *     const {values} = eigs(H, {eigenvectors: false, precision: 1e-6})
   *
   * See also:
   *
   *     inv
   *
   * @param {Array | Matrix} x  Matrix to be diagonalized
   *
   * @param {number | BigNumber | OptsObject} [opts] Object with keys `precision`, defaulting to config.relTol, and `eigenvectors`, defaulting to true and specifying whether to compute eigenvectors. If just a number, specifies precision.
   * @return {{values: Array|Matrix, eigenvectors?: Array<EVobj>}} Object containing an array of eigenvalues and an array of {value: number|BigNumber, vector: Array|Matrix} objects. The eigenvectors property is undefined if eigenvectors were not requested.
   *
   */ return typed("eigs", {
        // The conversion to matrix in the first two implementations,
        // just to convert back to an array right away in
        // computeValuesAndVectors, is unfortunate, and should perhaps be
        // streamlined. It is done because the Matrix object carries some
        // type information about its entries, and so constructing the matrix
        // is a roundabout way of doing type detection.
        Array: function Array(x) {
            return doEigs(matrix(x));
        },
        "Array, number|BigNumber": function ArrayNumberBigNumber(x, prec) {
            return doEigs(matrix(x), {
                precision: prec
            });
        },
        "Array, Object" (x, opts) {
            return doEigs(matrix(x), opts);
        },
        Matrix: function Matrix(mat) {
            return doEigs(mat, {
                matricize: true
            });
        },
        "Matrix, number|BigNumber": function MatrixNumberBigNumber(mat, prec) {
            return doEigs(mat, {
                precision: prec,
                matricize: true
            });
        },
        "Matrix, Object": function MatrixObject(mat, opts) {
            var useOpts = {
                matricize: true
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))(useOpts, opts);
            return doEigs(mat, useOpts);
        }
    });
    function doEigs(mat) {
        var _opts$precision;
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var computeVectors = "eigenvectors" in opts ? opts.eigenvectors : true;
        var prec = (_opts$precision = opts.precision) !== null && _opts$precision !== void 0 ? _opts$precision : config.relTol;
        var result = computeValuesAndVectors(mat, prec, computeVectors);
        if (opts.matricize) {
            result.values = matrix(result.values);
            if (computeVectors) result.eigenvectors = result.eigenvectors.map((_ref2)=>{
                var { value: value, vector: vector } = _ref2;
                return {
                    value: value,
                    vector: matrix(vector)
                };
            });
        }
        if (computeVectors) Object.defineProperty(result, "vectors", {
            enumerable: false,
            // to make sure that the eigenvectors can still be
            // converted to string.
            get: ()=>{
                throw new Error("eigs(M).vectors replaced with eigs(M).eigenvectors");
            }
        });
        return result;
    }
    function computeValuesAndVectors(mat, prec, computeVectors) {
        var arr = mat.toArray(); // NOTE: arr is guaranteed to be unaliased
        // and so safe to modify in place
        var asize = mat.size();
        if (asize.length !== 2 || asize[0] !== asize[1]) throw new RangeError("Matrix must be square (size: ".concat((0, $1b038b7ade911d0e$export$d9468344d3651243)(asize), ")"));
        var N = asize[0];
        if (isReal(arr, N, prec)) {
            coerceReal(arr, N); // modifies arr by side effect
            if (isSymmetric(arr, N, prec)) {
                var _type = coerceTypes(mat, arr, N); // modifies arr by side effect
                return doRealSymmetric(arr, N, prec, _type, computeVectors);
            }
        }
        var type = coerceTypes(mat, arr, N); // modifies arr by side effect
        return doComplexEigs(arr, N, prec, type, computeVectors);
    }
    /** @return {boolean} */ function isSymmetric(arr, N, prec) {
        for(var i = 0; i < N; i++)for(var j = i; j < N; j++){
            // TODO proper comparison of bignum and frac
            if (larger(bignumber(abs(subtract(arr[i][j], arr[j][i]))), prec)) return false;
        }
        return true;
    }
    /** @return {boolean} */ function isReal(arr, N, prec) {
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++){
            // TODO proper comparison of bignum and frac
            if (larger(bignumber(abs(im(arr[i][j]))), prec)) return false;
        }
        return true;
    }
    function coerceReal(arr, N) {
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++)arr[i][j] = re(arr[i][j]);
    }
    /** @return {'number' | 'BigNumber' | 'Complex'} */ function coerceTypes(mat, arr, N) {
        /** @type {string} */ var type = mat.datatype();
        if (type === "number" || type === "BigNumber" || type === "Complex") return type;
        var hasNumber = false;
        var hasBig = false;
        var hasComplex = false;
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++){
            var el = arr[i][j];
            if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(el) || (0, $23cfe017d190638f$export$e312cb8a8e5e7c34)(el)) hasNumber = true;
            else if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(el)) hasBig = true;
            else if ((0, $23cfe017d190638f$export$8849a896711efe0c)(el)) hasComplex = true;
            else throw TypeError("Unsupported type in Matrix: " + (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(el));
        }
        if (hasBig && hasComplex) console.warn("Complex BigNumbers not supported, this operation will lose precission.");
        if (hasComplex) {
            for(var _i = 0; _i < N; _i++)for(var _j = 0; _j < N; _j++)arr[_i][_j] = complex(arr[_i][_j]);
            return "Complex";
        }
        if (hasBig) {
            for(var _i2 = 0; _i2 < N; _i2++)for(var _j2 = 0; _j2 < N; _j2++)arr[_i2][_j2] = bignumber(arr[_i2][_j2]);
            return "BigNumber";
        }
        if (hasNumber) {
            for(var _i3 = 0; _i3 < N; _i3++)for(var _j3 = 0; _j3 < N; _j3++)arr[_i3][_j3] = number(arr[_i3][_j3]);
            return "number";
        } else throw TypeError("Matrix contains unsupported types only.");
    }
});






var $df769625b9fdd98f$var$name = "equal";
var $df769625b9fdd98f$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix",
    "concat"
];
var $df769625b9fdd98f$export$988f37bc1f709b0d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($df769625b9fdd98f$var$name, $df769625b9fdd98f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $5e352e66a45fa3fa$export$439c4d7accd2a586)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Test whether two values are equal.
   *
   * The function tests whether the relative difference between x and y is
   * smaller than the configured relTol and absTol. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must equal y.re, and x.im must equal y.im.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is only
   * equal to `null` and nothing else, and `undefined` is only equal to
   * `undefined` and nothing else. Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.equal(x, y)
   *
   * Examples:
   *
   *    math.equal(2 + 2, 3)         // returns false
   *    math.equal(2 + 2, 4)         // returns true
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.equal(a, b)             // returns true
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.equal(c, d)             // returns [true, false, true]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.equal("1000", "1e3")    // returns true
   *    math.equal(0, null)          // returns false
   *
   * See also:
   *
   *    unequal, smaller, smallerEq, larger, largerEq, compare, deepEqual, equalText
   *
   * @param  {number | BigNumber | bigint | boolean | Complex | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | boolean | Complex | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are equal, else returns false
   */ return typed($df769625b9fdd98f$var$name, $df769625b9fdd98f$export$87c1b92540f5e2ae({
        typed: typed,
        equalScalar: equalScalar
    }), matrixAlgorithmSuite({
        elop: equalScalar,
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $df769625b9fdd98f$export$87c1b92540f5e2ae = (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($df769625b9fdd98f$var$name, [
    "typed",
    "equalScalar"
], (_ref2)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref2;
    return typed($df769625b9fdd98f$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        }
    });
});





function $481fb5a762130ec3$export$852c8261c9f393e0(x, y, relTol, absTol) {
    return (0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x.re, y.re, relTol, absTol) && (0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x.im, y.im, relTol, absTol);
}



var $6722033ff124706e$var$name = "equalScalar";
var $6722033ff124706e$var$dependencies = [
    "typed",
    "config"
];
var $6722033ff124706e$export$c370bab664a0c9a2 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6722033ff124706e$var$name, $6722033ff124706e$var$dependencies, (_ref)=>{
    var { typed: typed, config: config } = _ref;
    var compareUnits = (0, $c47ed063b6d2cbd9$export$f15f03c51630bb25)({
        typed: typed
    });
    /**
   * Test whether two scalar values are nearly equal.
   *
   * @param  {number | BigNumber | bigint | Fraction | boolean | Complex | Unit} x   First value to compare
   * @param  {number | BigNumber | bigint | Fraction | boolean | Complex} y          Second value to compare
   * @return {boolean}                                                  Returns true when the compared values are equal, else returns false
   * @private
   */ return typed($6722033ff124706e$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x === y;
        },
        "number, number": function numberNumber(x, y) {
            return (0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.eq(y) || (0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol);
        },
        "bigint, bigint": function bigintBigint(x, y) {
            return x === y;
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.equals(y);
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return (0, $481fb5a762130ec3$export$852c8261c9f393e0)(x, y, config.relTol, config.absTol);
        }
    }, compareUnits);
});
var $6722033ff124706e$export$55f78fcc2979d648 = (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6722033ff124706e$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($6722033ff124706e$var$name, {
        "number, number": function numberNumber(x, y) {
            return (0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol);
        }
    });
});


var $ce44d9609174aa60$var$name = "equalText";
var $ce44d9609174aa60$var$dependencies = [
    "typed",
    "compareText",
    "isZero"
];
var $ce44d9609174aa60$export$1589aaa29568b87 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($ce44d9609174aa60$var$name, $ce44d9609174aa60$var$dependencies, (_ref)=>{
    var { typed: typed, compareText: compareText, isZero: isZero } = _ref;
    /**
   * Check equality of two strings. Comparison is case sensitive.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.equalText(x, y)
   *
   * Examples:
   *
   *    math.equalText('Hello', 'Hello')     // returns true
   *    math.equalText('a', 'A')             // returns false
   *    math.equal('2e3', '2000')            // returns true
   *    math.equalText('2e3', '2000')        // returns false
   *
   *    math.equalText('B', ['A', 'B', 'C']) // returns [false, true, false]
   *
   * See also:
   *
   *    equal, compareText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns true if the values are equal, and false if not.
   */ return typed($ce44d9609174aa60$var$name, {
        "any, any": function anyAny(x, y) {
            return isZero(compareText(x, y));
        }
    });
});

/* eslint-disable no-loss-of-precision */ 


var $31a7e7763ce27ff9$var$name = "erf";
var $31a7e7763ce27ff9$var$dependencies = [
    "typed"
];
var $31a7e7763ce27ff9$export$470dfa326d6cbdf5 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($31a7e7763ce27ff9$var$name, $31a7e7763ce27ff9$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the erf function of a value using a rational Chebyshev
   * approximations for different intervals of x.
   *
   * This is a translation of W. J. Cody's Fortran implementation from 1987
   * ( https://www.netlib.org/specfun/erf ). See the AMS publication
   * "Rational Chebyshev Approximations for the Error Function" by W. J. Cody
   * for an explanation of this process.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.erf(x)
   *
   * Examples:
   *
   *    math.erf(0.2)    // returns 0.22270258921047847
   *    math.erf(-0.5)   // returns -0.5204998778130465
   *    math.erf(4)      // returns 0.9999999845827421
   *
   * See also:
   *    zeta
   *
   * @param {number | Array | Matrix} x   A real number
   * @return {number | Array | Matrix}    The erf of `x`
   */ return typed("name", {
        number: function number(x) {
            var y = Math.abs(x);
            if (y >= $31a7e7763ce27ff9$var$MAX_NUM) return (0, $a246eb207aab6d09$export$c5552dfdbc7cec71)(x);
            if (y <= $31a7e7763ce27ff9$var$THRESH) return (0, $a246eb207aab6d09$export$c5552dfdbc7cec71)(x) * erf1(y);
            if (y <= 4.0) return (0, $a246eb207aab6d09$export$c5552dfdbc7cec71)(x) * (1 - erfc2(y));
            return (0, $a246eb207aab6d09$export$c5552dfdbc7cec71)(x) * (1 - erfc3(y));
        },
        "Array | Matrix": typed.referToSelf((self)=>(n)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(n, self))
    });
    /**
   * Approximates the error function erf() for x <= 0.46875 using this function:
   *               n
   * erf(x) = x * sum (p_j * x^(2j)) / (q_j * x^(2j))
   *              j=0
   */ function erf1(y) {
        var ysq = y * y;
        var xnum = $31a7e7763ce27ff9$var$P[0][4] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 3; i += 1){
            xnum = (xnum + $31a7e7763ce27ff9$var$P[0][i]) * ysq;
            xden = (xden + $31a7e7763ce27ff9$var$Q[0][i]) * ysq;
        }
        return y * (xnum + $31a7e7763ce27ff9$var$P[0][3]) / (xden + $31a7e7763ce27ff9$var$Q[0][3]);
    }
    /**
   * Approximates the complement of the error function erfc() for
   * 0.46875 <= x <= 4.0 using this function:
   *                       n
   * erfc(x) = e^(-x^2) * sum (p_j * x^j) / (q_j * x^j)
   *                      j=0
   */ function erfc2(y) {
        var xnum = $31a7e7763ce27ff9$var$P[1][8] * y;
        var xden = y;
        var i;
        for(i = 0; i < 7; i += 1){
            xnum = (xnum + $31a7e7763ce27ff9$var$P[1][i]) * y;
            xden = (xden + $31a7e7763ce27ff9$var$Q[1][i]) * y;
        }
        var result = (xnum + $31a7e7763ce27ff9$var$P[1][7]) / (xden + $31a7e7763ce27ff9$var$Q[1][7]);
        var ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
    /**
   * Approximates the complement of the error function erfc() for x > 4.0 using
   * this function:
   *
   * erfc(x) = (e^(-x^2) / x) * [ 1/sqrt(pi) +
   *               n
   *    1/(x^2) * sum (p_j * x^(-2j)) / (q_j * x^(-2j)) ]
   *              j=0
   */ function erfc3(y) {
        var ysq = 1 / (y * y);
        var xnum = $31a7e7763ce27ff9$var$P[2][5] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 4; i += 1){
            xnum = (xnum + $31a7e7763ce27ff9$var$P[2][i]) * ysq;
            xden = (xden + $31a7e7763ce27ff9$var$Q[2][i]) * ysq;
        }
        var result = ysq * (xnum + $31a7e7763ce27ff9$var$P[2][4]) / (xden + $31a7e7763ce27ff9$var$Q[2][4]);
        result = ($31a7e7763ce27ff9$var$SQRPI - result) / y;
        ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
});
/**
 * Upper bound for the first approximation interval, 0 <= x <= THRESH
 * @constant
 */ var $31a7e7763ce27ff9$var$THRESH = 0.46875;
/**
 * Constant used by W. J. Cody's Fortran77 implementation to denote sqrt(pi)
 * @constant
 */ var $31a7e7763ce27ff9$var$SQRPI = 5.6418958354775628695e-1;
/**
 * Coefficients for each term of the numerator sum (p_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $31a7e7763ce27ff9$var$P = [
    [
        3.16112374387056560e00,
        1.13864154151050156e02,
        3.77485237685302021e02,
        3.20937758913846947e03,
        1.85777706184603153e-1
    ],
    [
        5.64188496988670089e-1,
        8.88314979438837594e00,
        6.61191906371416295e01,
        2.98635138197400131e02,
        8.81952221241769090e02,
        1.71204761263407058e03,
        2.05107837782607147e03,
        1.23033935479799725e03,
        2.15311535474403846e-8
    ],
    [
        3.05326634961232344e-1,
        3.60344899949804439e-1,
        1.25781726111229246e-1,
        1.60837851487422766e-2,
        6.58749161529837803e-4,
        1.63153871373020978e-2
    ]
];
/**
 * Coefficients for each term of the denominator sum (q_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $31a7e7763ce27ff9$var$Q = [
    [
        2.36012909523441209e01,
        2.44024637934444173e02,
        1.28261652607737228e03,
        2.84423683343917062e03
    ],
    [
        1.57449261107098347e01,
        1.17693950891312499e02,
        5.37181101862009858e02,
        1.62138957456669019e03,
        3.29079923573345963e03,
        4.36261909014324716e03,
        3.43936767414372164e03,
        1.23033935480374942e03
    ],
    [
        2.56852019228982242e00,
        1.87295284992346047e00,
        5.27905102951428412e-1,
        6.05183413124413191e-2,
        2.33520497626869185e-3
    ]
];
/**
 * Maximum/minimum safe numbers to input to erf() (in ES6+, this number is
 * Number.[MAX|MIN]_SAFE_INTEGER). erf() for all numbers beyond this limit will
 * return 1
 */ var $31a7e7763ce27ff9$var$MAX_NUM = Math.pow(2, 53);



var $ec7df944117251ea$var$name = "exp";
var $ec7df944117251ea$var$dependencies = [
    "typed"
];
var $ec7df944117251ea$export$95a576617fd015b1 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($ec7df944117251ea$var$name, $ec7df944117251ea$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the exponential of a value.
   * For matrices, if you want the matrix exponential of square matrix, use
   * the `expm` function; if you want to take the exponential of each element,
   * see the examples.
   *
   * Syntax:
   *
   *    math.exp(x)
   *
   * Examples:
   *
   *    math.exp(2)                  // returns number 7.3890560989306495
   *    math.pow(math.e, 2)          // returns number 7.3890560989306495
   *    math.log(math.exp(2))        // returns number 2
   *
   *    math.map([1, 2, 3], math.exp)
   *    // returns Array [
   *    //   2.718281828459045,
   *    //   7.3890560989306495,
   *    //   20.085536923187668
   *    // ]
   *
   * See also:
   *
   *    expm1, expm, log, pow
   *
   * @param {number | BigNumber | Complex} x  A number to exponentiate
   * @return {number | BigNumber | Complex} Exponential of `x`
   */ return typed($ec7df944117251ea$var$name, {
        number: (0, $f38f49d8e24d4a9f$export$a33b288b35672fe5),
        Complex: function Complex(x) {
            return x.exp();
        },
        BigNumber: function BigNumber(x) {
            return x.exp();
        }
    });
});




var $b8ceb10535e48d66$var$name = "expm";
var $b8ceb10535e48d66$var$dependencies = [
    "typed",
    "abs",
    "add",
    "identity",
    "inv",
    "multiply"
];
var $b8ceb10535e48d66$export$f2c0a6357ff6cb4c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b8ceb10535e48d66$var$name, $b8ceb10535e48d66$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, identity: identity, inv: inv, multiply: multiply } = _ref;
    /**
   * Compute the matrix exponential, expm(A) = e^A. The matrix must be square.
   * Not to be confused with exp(a), which performs element-wise
   * exponentiation.
   *
   * The exponential is calculated using the Padé approximant with scaling and
   * squaring; see "Nineteen Dubious Ways to Compute the Exponential of a
   * Matrix," by Moler and Van Loan.
   *
   * Syntax:
   *
   *     math.expm(x)
   *
   * Examples:
   *
   *     const A = [[0,2],[0,0]]
   *     math.expm(A)        // returns [[1,2],[0,1]]
   *
   * See also:
   *
   *     exp
   *
   * @param {Matrix} x  A square Matrix
   * @return {Matrix}   The exponential of x
   */ return typed($b8ceb10535e48d66$var$name, {
        Matrix: function Matrix(A) {
            // Check matrix size
            var size = A.size();
            if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
            var n = size[0];
            // Desired accuracy of the approximant (The actual accuracy
            // will be affected by round-off error)
            var eps = 1e-15;
            // The Padé approximant is not so accurate when the values of A
            // are "large", so scale A by powers of two. Then compute the
            // exponential, and square the result repeatedly according to
            // the identity e^A = (e^(A/m))^m
            // Compute infinity-norm of A, ||A||, to see how "big" it is
            var infNorm = infinityNorm(A);
            // Find the optimal scaling factor and number of terms in the
            // Padé approximant to reach the desired accuracy
            var params = findParams(infNorm, eps);
            var q = params.q;
            var j = params.j;
            // The Pade approximation to e^A is:
            // Rqq(A) = Dqq(A) ^ -1 * Nqq(A)
            // where
            // Nqq(A) = sum(i=0, q, (2q-i)!p! / [ (2q)!i!(q-i)! ] A^i
            // Dqq(A) = sum(i=0, q, (2q-i)!q! / [ (2q)!i!(q-i)! ] (-A)^i
            // Scale A by 1 / 2^j
            var Apos = multiply(A, Math.pow(2, -j));
            // The i=0 term is just the identity matrix
            var N = identity(n);
            var D = identity(n);
            // Initialization (i=0)
            var factor = 1;
            // Initialization (i=1)
            var AposToI = Apos; // Cloning not necessary
            var alternate = -1;
            for(var i = 1; i <= q; i++){
                if (i > 1) {
                    AposToI = multiply(AposToI, Apos);
                    alternate = -alternate;
                }
                factor = factor * (q - i + 1) / ((2 * q - i + 1) * i);
                N = add(N, multiply(factor, AposToI));
                D = add(D, multiply(factor * alternate, AposToI));
            }
            var R = multiply(inv(D), N);
            // Square j times
            for(var _i = 0; _i < j; _i++)R = multiply(R, R);
            return (0, $23cfe017d190638f$export$d508368d4da3c38a)(A) ? A.createSparseMatrix(R) : R;
        }
    });
    function infinityNorm(A) {
        var n = A.size()[0];
        var infNorm = 0;
        for(var i = 0; i < n; i++){
            var rowSum = 0;
            for(var j = 0; j < n; j++)rowSum += abs(A.get([
                i,
                j
            ]));
            infNorm = Math.max(rowSum, infNorm);
        }
        return infNorm;
    }
    /**
   * Find the best parameters for the Pade approximant given
   * the matrix norm and desired accuracy. Returns the first acceptable
   * combination in order of increasing computational load.
   */ function findParams(infNorm, eps) {
        var maxSearchSize = 30;
        for(var k = 0; k < maxSearchSize; k++)for(var q = 0; q <= k; q++){
            var j = k - q;
            if (errorEstimate(infNorm, q, j) < eps) return {
                q: q,
                j: j
            };
        }
        throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
    }
    /**
   * Returns the estimated error of the Pade approximant for the given
   * parameters.
   */ function errorEstimate(infNorm, q, j) {
        var qfac = 1;
        for(var i = 2; i <= q; i++)qfac *= i;
        var twoqfac = qfac;
        for(var _i2 = q + 1; _i2 <= 2 * q; _i2++)twoqfac *= _i2;
        var twoqp1fac = twoqfac * (2 * q + 1);
        return 8.0 * Math.pow(infNorm / Math.pow(2, j), 2 * q) * qfac * qfac / (twoqfac * twoqp1fac);
    }
});



var $b06fb08102326836$var$name = "expm1";
var $b06fb08102326836$var$dependencies = [
    "typed",
    "Complex"
];
var $b06fb08102326836$export$2b203b63f664bab3 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b06fb08102326836$var$name, $b06fb08102326836$var$dependencies, (_ref)=>{
    var { typed: typed, Complex: _Complex } = _ref;
    /**
   * Calculate the value of subtracting 1 from the exponential value.
   * This function is more accurate than `math.exp(x)-1` when `x` is near 0
   * To avoid ambiguity with the matrix exponential `expm`, this function
   * does not operate on matrices; if you wish to apply it elementwise, see
   * the examples.
   *
   * Syntax:
   *
   *    math.expm1(x)
   *
   * Examples:
   *
   *    math.expm1(2)                      // returns number 6.38905609893065
   *    math.pow(math.e, 2) - 1            // returns number 6.3890560989306495
   *    math.expm1(1e-8)                   // returns number 1.0000000050000001e-8
   *    math.exp(1e-8) - 1                 // returns number 9.9999999392253e-9
   *    math.log(math.expm1(2) + 1)        // returns number 2
   *
   *    math.map([1, 2, 3], math.expm1)
   *    // returns Array [
   *    //   1.718281828459045,
   *    //   6.3890560989306495,
   *    //   19.085536923187668
   *    // ]
   *
   * See also:
   *
   *    exp, expm, log, pow
   *
   * @param {number | BigNumber | Complex} x  The number to exponentiate
   * @return {number | BigNumber | Complex} Exponential of `x`, minus one
   */ return typed($b06fb08102326836$var$name, {
        number: (0, $f38f49d8e24d4a9f$export$756d0c010cecc6c3),
        Complex: function Complex(x) {
            var r = Math.exp(x.re);
            return new _Complex(r * Math.cos(x.im) - 1, r * Math.sin(x.im));
        },
        BigNumber: function BigNumber(x) {
            return x.exp().minus(1);
        }
    });
});



var $7a023b320bdc24d4$var$name = "factorial";
var $7a023b320bdc24d4$var$dependencies = [
    "typed",
    "gamma"
];
var $7a023b320bdc24d4$export$92c37ad44e3d0481 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($7a023b320bdc24d4$var$name, $7a023b320bdc24d4$var$dependencies, (_ref)=>{
    var { typed: typed, gamma: gamma } = _ref;
    /**
   * Compute the factorial of a value
   *
   * Factorial only supports an integer value as argument.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.factorial(n)
   *
   * Examples:
   *
   *    math.factorial(5)    // returns 120
   *    math.factorial(3)    // returns 6
   *
   * See also:
   *
   *    combinations, combinationsWithRep, gamma, permutations
   *
   * @param {number | BigNumber | Array | Matrix} n   An integer number
   * @return {number | BigNumber | Array | Matrix}    The factorial of `n`
   */ return typed($7a023b320bdc24d4$var$name, {
        number: function number(n) {
            if (n < 0) throw new Error("Value must be non-negative");
            return gamma(n + 1);
        },
        BigNumber: function BigNumber(n) {
            if (n.isNegative()) throw new Error("Value must be non-negative");
            return gamma(n.plus(1));
        },
        "Array | Matrix": typed.referToSelf((self)=>(n)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(n, self))
    });
});



var $f5f567aafaf6dcdc$var$name = "fft";
var $f5f567aafaf6dcdc$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "multiplyScalar",
    "divideScalar",
    "exp",
    "tau",
    "i",
    "dotDivide",
    "conj",
    "pow",
    "ceil",
    "log2"
];
var $f5f567aafaf6dcdc$export$41ce8d9733cb73c1 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f5f567aafaf6dcdc$var$name, $f5f567aafaf6dcdc$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, multiplyScalar: multiplyScalar, divideScalar: divideScalar, exp: exp, tau: tau, i: I, dotDivide: dotDivide, conj: conj, pow: pow, ceil: ceil, log2: log2 } = _ref;
    /**
   * Calculate N-dimensional fourier transform
   *
   * Syntax:
   *
   *     math.fft(arr)
   *
   * Examples:
   *
   *    math.fft([[1, 0], [1, 0]]) // returns [[{re:2, im:0}, {re:2, im:0}], [{re:0, im:0}, {re:0, im:0}]]
   *
   *
   * See Also:
   *
   *      ifft
   *
   * @param {Array | Matrix} arr    An array or matrix
   * @return {Array | Matrix}       N-dimensional fourier transformation of the array
   */ return typed($f5f567aafaf6dcdc$var$name, {
        Array: _ndFft,
        Matrix: function Matrix(matrix) {
            return matrix.create(_ndFft(matrix.toArray()));
        }
    });
    /**
   * Perform an N-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @return {Array}         resulting array
   */ function _ndFft(arr) {
        var size = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(arr);
        if (size.length === 1) return _fft(arr, size[0]);
        // ndFft along dimension 1,...,N-1 then 1dFft along dimension 0
        return _1dFft(arr.map((slice)=>_ndFft(slice, size.slice(1))), 0);
    }
    /**
   * Perform an 1-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @param {number} dim     dimension of the array to perform on
   * @return {Array}         resulting array
   */ function _1dFft(arr, dim) {
        var size = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(arr);
        if (dim !== 0) return new Array(size[0]).fill(0).map((_, i)=>_1dFft(arr[i], dim - 1));
        if (size.length === 1) return _fft(arr);
        function _transpose(arr) {
            // Swap first 2 dimensions
            var size = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(arr);
            return new Array(size[1]).fill(0).map((_, j)=>new Array(size[0]).fill(0).map((_, i)=>arr[i][j]));
        }
        return _transpose(_1dFft(_transpose(arr), 1));
    }
    /**
   * Perform an 1-dimensional non-power-of-2 Fourier transform using Chirp-Z Transform
   *
   * @param {Array} arr      The array
   * @return {Array}         resulting array
   */ function _czt(arr) {
        var n = arr.length;
        var w = exp(divideScalar(multiplyScalar(-1, multiplyScalar(I, tau)), n));
        var chirp = [];
        for(var i = 1 - n; i < n; i++)chirp.push(pow(w, divideScalar(pow(i, 2), 2)));
        var N2 = pow(2, ceil(log2(n + n - 1)));
        var xp = [
            ...new Array(n).fill(0).map((_, i)=>multiplyScalar(arr[i], chirp[n - 1 + i])),
            ...new Array(N2 - n).fill(0)
        ];
        var ichirp = [
            ...new Array(n + n - 1).fill(0).map((_, i)=>divideScalar(1, chirp[i])),
            ...new Array(N2 - (n + n - 1)).fill(0)
        ];
        var fftXp = _fft(xp);
        var fftIchirp = _fft(ichirp);
        var fftProduct = new Array(N2).fill(0).map((_, i)=>multiplyScalar(fftXp[i], fftIchirp[i]));
        var ifftProduct = dotDivide(conj(_ndFft(conj(fftProduct))), N2);
        var ret = [];
        for(var _i = n - 1; _i < n + n - 1; _i++)ret.push(multiplyScalar(ifftProduct[_i], chirp[_i]));
        return ret;
    }
    /**
   * Perform an 1-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @return {Array}         resulting array
   */ function _fft(arr) {
        var len = arr.length;
        if (len === 1) return [
            arr[0]
        ];
        if (len % 2 === 0) {
            var ret = [
                ..._fft(arr.filter((_, i)=>i % 2 === 0), len / 2),
                ..._fft(arr.filter((_, i)=>i % 2 === 1), len / 2)
            ];
            for(var k = 0; k < len / 2; k++){
                var p = ret[k];
                var q = multiplyScalar(ret[k + len / 2], exp(multiplyScalar(multiplyScalar(tau, I), divideScalar(-k, len))));
                ret[k] = addScalar(p, q);
                ret[k + len / 2] = addScalar(p, multiplyScalar(-1, q));
            }
            return ret;
        } else // use chirp-z transform for non-power-of-2 FFT
        return _czt(arr);
    // throw new Error('Can only calculate FFT of power-of-two size')
    }
});


var $6c5f453dda79b257$var$name = "FibonacciHeap";
var $6c5f453dda79b257$var$dependencies = [
    "smaller",
    "larger"
];
var $6c5f453dda79b257$export$3143a09e27a84c41 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6c5f453dda79b257$var$name, $6c5f453dda79b257$var$dependencies, (_ref)=>{
    var { smaller: smaller, larger: larger } = _ref;
    var oneOverLogPhi = 1.0 / Math.log((1.0 + Math.sqrt(5.0)) / 2.0);
    /**
   * Fibonacci Heap implementation, used interally for Matrix math.
   * @class FibonacciHeap
   * @constructor FibonacciHeap
   */ function FibonacciHeap() {
        if (!(this instanceof FibonacciHeap)) throw new SyntaxError("Constructor must be called with the new operator");
        // initialize fields
        this._minimum = null;
        this._size = 0;
    }
    /**
   * Attach type information
   */ FibonacciHeap.prototype.type = "FibonacciHeap";
    FibonacciHeap.prototype.isFibonacciHeap = true;
    /**
   * Inserts a new data element into the heap. No heap consolidation is
   * performed at this time, the new node is simply inserted into the root
   * list of this heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.insert = function(key, value) {
        // create node
        var node = {
            key: key,
            value: value,
            degree: 0
        };
        // check we have a node in the minimum
        if (this._minimum) {
            // minimum node
            var minimum = this._minimum;
            // update left & right of node
            node.left = minimum;
            node.right = minimum.right;
            minimum.right = node;
            node.right.left = node;
            // update minimum node in heap if needed
            if (smaller(key, minimum.key)) // node has a smaller key, use it as minimum
            this._minimum = node;
        } else {
            // set left & right
            node.left = node;
            node.right = node;
            // this is the first node
            this._minimum = node;
        }
        // increment number of nodes in heap
        this._size++;
        // return node
        return node;
    };
    /**
   * Returns the number of nodes in heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.size = function() {
        return this._size;
    };
    /**
   * Removes all elements from this heap.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.clear = function() {
        this._minimum = null;
        this._size = 0;
    };
    /**
   * Returns true if the heap is empty, otherwise false.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.isEmpty = function() {
        return this._size === 0;
    };
    /**
   * Extracts the node with minimum key from heap. Amortized running
   * time: O(log n).
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.extractMinimum = function() {
        // node to remove
        var node = this._minimum;
        // check we have a minimum
        if (node === null) return node;
        // current minimum
        var minimum = this._minimum;
        // get number of children
        var numberOfChildren = node.degree;
        // pointer to the first child
        var x = node.child;
        // for each child of node do...
        while(numberOfChildren > 0){
            // store node in right side
            var tempRight = x.right;
            // remove x from child list
            x.left.right = x.right;
            x.right.left = x.left;
            // add x to root list of heap
            x.left = minimum;
            x.right = minimum.right;
            minimum.right = x;
            x.right.left = x;
            // set Parent[x] to null
            x.parent = null;
            x = tempRight;
            numberOfChildren--;
        }
        // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left;
        // update minimum
        if (node === node.right) // empty
        minimum = null;
        else {
            // update minimum
            minimum = node.right;
            // we need to update the pointer to the root with minimum key
            minimum = _findMinimumNode(minimum, this._size);
        }
        // decrement size of heap
        this._size--;
        // update minimum
        this._minimum = minimum;
        // return node
        return node;
    };
    /**
   * Removes a node from the heap given the reference to the node. The trees
   * in the heap will be consolidated, if necessary. This operation may fail
   * to remove the correct element if there are nodes with key value -Infinity.
   * Running time: O(log n) amortized.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.remove = function(node) {
        // decrease key value
        this._minimum = _decreaseKey(this._minimum, node, -1);
        // remove the smallest
        this.extractMinimum();
    };
    /**
   * Decreases the key value for a heap node, given the new value to take on.
   * The structure of the heap may be changed and will not be consolidated.
   * Running time: O(1) amortized.
   * @memberof FibonacciHeap
   */ function _decreaseKey(minimum, node, key) {
        // set node key
        node.key = key;
        // get parent node
        var parent = node.parent;
        if (parent && smaller(node.key, parent.key)) {
            // remove node from parent
            _cut(minimum, node, parent);
            // remove all nodes from parent to the root parent
            _cascadingCut(minimum, parent);
        }
        // update minimum node if needed
        if (smaller(node.key, minimum.key)) minimum = node;
        // return minimum
        return minimum;
    }
    /**
   * The reverse of the link operation: removes node from the child list of parent.
   * This method assumes that min is non-null. Running time: O(1).
   * @memberof FibonacciHeap
   */ function _cut(minimum, node, parent) {
        // remove node from parent children and decrement Degree[parent]
        node.left.right = node.right;
        node.right.left = node.left;
        parent.degree--;
        // reset y.child if necessary
        if (parent.child === node) parent.child = node.right;
        // remove child if degree is 0
        if (parent.degree === 0) parent.child = null;
        // add node to root list of heap
        node.left = minimum;
        node.right = minimum.right;
        minimum.right = node;
        node.right.left = node;
        // set parent[node] to null
        node.parent = null;
        // set mark[node] to false
        node.mark = false;
    }
    /**
   * Performs a cascading cut operation. This cuts node from its parent and then
   * does the same for its parent, and so on up the tree.
   * Running time: O(log n); O(1) excluding the recursion.
   * @memberof FibonacciHeap
   */ function _cascadingCut(minimum, node) {
        // store parent node
        var parent = node.parent;
        // if there's a parent...
        if (!parent) return;
        // if node is unmarked, set it marked
        if (!node.mark) node.mark = true;
        else {
            // it's marked, cut it from parent
            _cut(minimum, node, parent);
            // cut its parent as well
            _cascadingCut(parent);
        }
    }
    /**
   * Make the first node a child of the second one. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ var _linkNodes = function _linkNodes(node, parent) {
        // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left;
        // make node a Child of parent
        node.parent = parent;
        if (!parent.child) {
            parent.child = node;
            node.right = node;
            node.left = node;
        } else {
            node.left = parent.child;
            node.right = parent.child.right;
            parent.child.right = node;
            node.right.left = node;
        }
        // increase degree[parent]
        parent.degree++;
        // set mark[node] false
        node.mark = false;
    };
    function _findMinimumNode(minimum, size) {
        // to find trees of the same degree efficiently we use an array of length O(log n) in which we keep a pointer to one root of each degree
        var arraySize = Math.floor(Math.log(size) * oneOverLogPhi) + 1;
        // create list with initial capacity
        var array = new Array(arraySize);
        // find the number of root nodes.
        var numRoots = 0;
        var x = minimum;
        if (x) {
            numRoots++;
            x = x.right;
            while(x !== minimum){
                numRoots++;
                x = x.right;
            }
        }
        // vars
        var y;
        // For each node in root list do...
        while(numRoots > 0){
            // access this node's degree..
            var d = x.degree;
            // get next node
            var next = x.right;
            // check if there is a node already in array with the same degree
            while(true){
                // get node with the same degree is any
                y = array[d];
                if (!y) break;
                // make one node with the same degree a child of the other, do this based on the key value.
                if (larger(x.key, y.key)) {
                    var temp = y;
                    y = x;
                    x = temp;
                }
                // make y a child of x
                _linkNodes(y, x);
                // we have handled this degree, go to next one.
                array[d] = null;
                d++;
            }
            // save this node for later when we might encounter another of the same degree.
            array[d] = x;
            // move forward through list.
            x = next;
            numRoots--;
        }
        // Set min to null (effectively losing the root list) and reconstruct the root list from the array entries in array[].
        minimum = null;
        // loop nodes in array
        for(var i = 0; i < arraySize; i++){
            // get current node
            y = array[i];
            if (!y) continue;
            // check if we have a linked list
            if (minimum) {
                // First remove node from root list.
                y.left.right = y.right;
                y.right.left = y.left;
                // now add to root list, again.
                y.left = minimum;
                y.right = minimum.right;
                minimum.right = y;
                y.right.left = y;
                // check if this is a new min.
                if (smaller(y.key, minimum.key)) minimum = y;
            } else minimum = y;
        }
        return minimum;
    }
    return FibonacciHeap;
}, {
    isClass: true
});

var $25db5d51e6b14f18$exports = {};
(function(global, factory) {
    $25db5d51e6b14f18$exports = factory();
})($25db5d51e6b14f18$exports, function() {
    "use strict";
    function ok() {
        return true;
    }
    function notOk() {
        return false;
    }
    function undef() {
        return undefined;
    }
    const NOT_TYPED_FUNCTION = "Argument is not a typed-function.";
    /**
   * @typedef {{
   *   params: Param[],
   *   fn: function,
   *   test: function,
   *   implementation: function
   * }} Signature
   *
   * @typedef {{
   *   types: Type[],
   *   hasAny: boolean,
   *   hasConversion: boolean,
   *   restParam: boolean
   * }} Param
   *
   * @typedef {{
   *   name: string,
   *   typeIndex: number,
   *   test: function,
   *   isAny: boolean,
   *   conversion?: ConversionDef,
   *   conversionIndex: number,
   * }} Type
   *
   * @typedef {{
   *   from: string,
   *   to: string,
   *   convert: function (*) : *
   * }} ConversionDef
   *
   * @typedef {{
   *   name: string,
   *   test: function(*) : boolean,
   *   isAny?: boolean
   * }} TypeDef
   */ /**
   * @returns {() => function}
   */ function create() {
        // data type tests
        /**
     * Returns true if the argument is a non-null "plain" object
     */ function isPlainObject(x) {
            return typeof x === "object" && x !== null && x.constructor === Object;
        }
        const _types = [
            {
                name: "number",
                test: function(x) {
                    return typeof x === "number";
                }
            },
            {
                name: "string",
                test: function(x) {
                    return typeof x === "string";
                }
            },
            {
                name: "boolean",
                test: function(x) {
                    return typeof x === "boolean";
                }
            },
            {
                name: "Function",
                test: function(x) {
                    return typeof x === "function";
                }
            },
            {
                name: "Array",
                test: Array.isArray
            },
            {
                name: "Date",
                test: function(x) {
                    return x instanceof Date;
                }
            },
            {
                name: "RegExp",
                test: function(x) {
                    return x instanceof RegExp;
                }
            },
            {
                name: "Object",
                test: isPlainObject
            },
            {
                name: "null",
                test: function(x) {
                    return x === null;
                }
            },
            {
                name: "undefined",
                test: function(x) {
                    return x === undefined;
                }
            }
        ];
        const anyType = {
            name: "any",
            test: ok,
            isAny: true
        };
        // Data structures to track the types. As these are local variables in
        // create(), each typed universe will get its own copy, but the variables
        // will only be accessible through the (closures of the) functions supplied
        // as properties of the typed object, not directly.
        // These will be initialized in clear() below
        let typeMap; // primary store of all types
        let typeList; // Array of just type names, for the sake of ordering
        // And similar data structures for the type conversions:
        let nConversions = 0;
        // the actual conversions are stored on a property of the destination types
        // This is a temporary object, will be replaced with a function at the end
        let typed = {
            createCount: 0
        };
        /**
     * Takes a type name and returns the corresponding official type object
     * for that type.
     *
     * @param {string} typeName
     * @returns {TypeDef} type
     */ function findType(typeName) {
            const type = typeMap.get(typeName);
            if (type) return type;
            // Remainder is error handling
            let message = 'Unknown type "' + typeName + '"';
            const name = typeName.toLowerCase();
            let otherName;
            for (otherName of typeList)if (otherName.toLowerCase() === name) {
                message += '. Did you mean "' + otherName + '" ?';
                break;
            }
            throw new TypeError(message);
        }
        /**
     * Adds an array `types` of type definitions to this typed instance.
     * Each type definition should be an object with properties:
     * 'name' - a string giving the name of the type; 'test' - function
     * returning a boolean that tests membership in the type; and optionally
     * 'isAny' - true only for the 'any' type.
     *
     * The second optional argument, `before`, gives the name of a type that
     * these types should be added before. The new types are added in the
     * order specified.
     * @param {TypeDef[]} types
     * @param {string | boolean} [beforeSpec='any'] before
     */ function addTypes(types) {
            let beforeSpec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "any";
            const beforeIndex = beforeSpec ? findType(beforeSpec).index : typeList.length;
            const newTypes = [];
            for(let i = 0; i < types.length; ++i){
                if (!types[i] || typeof types[i].name !== "string" || typeof types[i].test !== "function") throw new TypeError("Object with properties {name: string, test: function} expected");
                const typeName = types[i].name;
                if (typeMap.has(typeName)) throw new TypeError('Duplicate type name "' + typeName + '"');
                newTypes.push(typeName);
                typeMap.set(typeName, {
                    name: typeName,
                    test: types[i].test,
                    isAny: types[i].isAny,
                    index: beforeIndex + i,
                    conversionsTo: [] // Newly added type can't have any conversions to it
                });
            }
            // update the typeList
            const affectedTypes = typeList.slice(beforeIndex);
            typeList = typeList.slice(0, beforeIndex).concat(newTypes).concat(affectedTypes);
            // Fix the indices
            for(let i = beforeIndex + newTypes.length; i < typeList.length; ++i)typeMap.get(typeList[i]).index = i;
        }
        /**
     * Removes all types and conversions from this typed instance.
     * May cause previously constructed typed-functions to throw
     * strange errors when they are called with types that do not
     * match any of their signatures.
     */ function clear() {
            typeMap = new Map();
            typeList = [];
            nConversions = 0;
            addTypes([
                anyType
            ], false);
        }
        // initialize the types to the default list
        clear();
        addTypes(_types);
        /**
     * Removes all conversions, leaving the types alone.
     */ function clearConversions() {
            let typeName;
            for (typeName of typeList)typeMap.get(typeName).conversionsTo = [];
            nConversions = 0;
        }
        /**
     * Find the type names that match a value.
     * @param {*} value
     * @return {string[]} Array of names of types for which
     *                  the type test matches the value.
     */ function findTypeNames(value) {
            const matches = typeList.filter((name)=>{
                const type = typeMap.get(name);
                return !type.isAny && type.test(value);
            });
            if (matches.length) return matches;
            return [
                "any"
            ];
        }
        /**
     * Check if an entity is a typed function created by any instance
     * @param {any} entity
     * @returns {boolean}
     */ function isTypedFunction(entity) {
            return entity && typeof entity === "function" && "_typedFunctionData" in entity;
        }
        /**
     * Find a specific signature from a (composed) typed function, for example:
     *
     *   typed.findSignature(fn, ['number', 'string'])
     *   typed.findSignature(fn, 'number, string')
     *   typed.findSignature(fn, 'number,string', {exact: true})
     *
     * This function findSignature will by default return the best match to
     * the given signature, possibly employing type conversions.
     *
     * The (optional) third argument is a plain object giving options
     * controlling the signature search. Currently the only implemented
     * option is `exact`: if specified as true (default is false), only
     * exact matches will be returned (i.e. signatures for which `fn` was
     * directly defined). Note that a (possibly different) type matching
     * `any`, or one or more instances of TYPE matching `...TYPE` are
     * considered exact matches in this regard, as no conversions are used.
     *
     * This function returns a "signature" object, as does `typed.resolve()`,
     * which is a plain object with four keys: `params` (the array of parameters
     * for this signature), `fn` (the originally supplied function for this
     * signature), `test` (a generated function that determines if an argument
     * list matches this signature, and `implementation` (the function to call
     * on a matching argument list, that performs conversions if necessary and
     * then calls the originally supplied function).
     *
     * @param {Function} fn                   A typed-function
     * @param {string | string[]} signature
     *     Signature to be found, can be an array or a comma separated string.
     * @param {object} options  Controls the signature search as documented
     * @return {{ params: Param[], fn: function, test: function, implementation: function }}
     *     Returns the matching signature, or throws an error when no signature
     *     is found.
     */ function findSignature(fn, signature, options) {
            if (!isTypedFunction(fn)) throw new TypeError(NOT_TYPED_FUNCTION);
            // Canonicalize input
            const exact = options && options.exact;
            const stringSignature = Array.isArray(signature) ? signature.join(",") : signature;
            const params = parseSignature(stringSignature);
            const canonicalSignature = stringifyParams(params);
            // First hope we get lucky and exactly match a signature
            if (!exact || canonicalSignature in fn.signatures) {
                // OK, we can check the internal signatures
                const match = fn._typedFunctionData.signatureMap.get(canonicalSignature);
                if (match) return match;
            }
            // Oh well, we did not; so we have to go back and check the parameters
            // one by one, in order to catch things like `any` and rest params.
            // Note here we can assume there is at least one parameter, because
            // the empty signature would have matched successfully above.
            const nParams = params.length;
            let remainingSignatures;
            if (exact) {
                remainingSignatures = [];
                let name;
                for(name in fn.signatures)remainingSignatures.push(fn._typedFunctionData.signatureMap.get(name));
            } else remainingSignatures = fn._typedFunctionData.signatures;
            for(let i = 0; i < nParams; ++i){
                const want = params[i];
                const filteredSignatures = [];
                let possibility;
                for (possibility of remainingSignatures){
                    const have = getParamAtIndex(possibility.params, i);
                    if (!have || want.restParam && !have.restParam) continue;
                    if (!have.hasAny) {
                        // have to check all of the wanted types are available
                        const haveTypes = paramTypeSet(have);
                        if (want.types.some((wtype)=>!haveTypes.has(wtype.name))) continue;
                    }
                    // OK, this looks good
                    filteredSignatures.push(possibility);
                }
                remainingSignatures = filteredSignatures;
                if (remainingSignatures.length === 0) break;
            }
            // Return the first remaining signature that was totally matched:
            let candidate;
            for (candidate of remainingSignatures){
                if (candidate.params.length <= nParams) return candidate;
            }
            throw new TypeError("Signature not found (signature: " + (fn.name || "unnamed") + "(" + stringifyParams(params, ", ") + "))");
        }
        /**
     * Find the proper function to call for a specific signature from
     * a (composed) typed function, for example:
     *
     *   typed.find(fn, ['number', 'string'])
     *   typed.find(fn, 'number, string')
     *   typed.find(fn, 'number,string', {exact: true})
     *
     * This function find will by default return the best match to
     * the given signature, possibly employing type conversions (and returning
     * a function that will perform those conversions as needed). The
     * (optional) third argument is a plain object giving options contolling
     * the signature search. Currently only the option `exact` is implemented,
     * which defaults to "false". If `exact` is specified as true, then only
     * exact matches will be returned (i.e. signatures for which `fn` was
     * directly defined). Uses of `any` and `...TYPE` are considered exact if
     * no conversions are necessary to apply the corresponding function.
     *
     * @param {Function} fn                   A typed-function
     * @param {string | string[]} signature
     *     Signature to be found, can be an array or a comma separated string.
     * @param {object} options  Controls the signature match as documented
     * @return {function}
     *     Returns the function to call for the given signature, or throws an
     *     error if no match is found.
     */ function find(fn, signature, options) {
            return findSignature(fn, signature, options).implementation;
        }
        /**
     * Convert a given value to another data type, specified by type name.
     *
     * @param {*} value
     * @param {string} typeName
     */ function convert(value, typeName) {
            // check conversion is needed
            const type = findType(typeName);
            if (type.test(value)) return value;
            const conversions = type.conversionsTo;
            if (conversions.length === 0) throw new Error("There are no conversions to " + typeName + " defined.");
            for(let i = 0; i < conversions.length; i++){
                const fromType = findType(conversions[i].from);
                if (fromType.test(value)) return conversions[i].convert(value);
            }
            throw new Error("Cannot convert " + value + " to " + typeName);
        }
        /**
     * Stringify parameters in a normalized way
     * @param {Param[]} params
     * @param {string} [','] separator
     * @return {string}
     */ function stringifyParams(params) {
            let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
            return params.map((p)=>p.name).join(separator);
        }
        /**
     * Parse a parameter, like "...number | boolean"
     * @param {string} param
     * @return {Param} param
     */ function parseParam(param) {
            const restParam = param.indexOf("...") === 0;
            const types = !restParam ? param : param.length > 3 ? param.slice(3) : "any";
            const typeDefs = types.split("|").map((s)=>findType(s.trim()));
            let hasAny = false;
            let paramName = restParam ? "..." : "";
            const exactTypes = typeDefs.map(function(type) {
                hasAny = type.isAny || hasAny;
                paramName += type.name + "|";
                return {
                    name: type.name,
                    typeIndex: type.index,
                    test: type.test,
                    isAny: type.isAny,
                    conversion: null,
                    conversionIndex: -1
                };
            });
            return {
                types: exactTypes,
                name: paramName.slice(0, -1),
                hasAny: // remove trailing '|' from above
                hasAny,
                hasConversion: false,
                restParam: restParam
            };
        }
        /**
     * Expands a parsed parameter with the types available from currently
     * defined conversions.
     * @param {Param} param
     * @return {Param} param
     */ function expandParam(param) {
            const typeNames = param.types.map((t)=>t.name);
            const matchingConversions = availableConversions(typeNames);
            let hasAny = param.hasAny;
            let newName = param.name;
            const convertibleTypes = matchingConversions.map(function(conversion) {
                const type = findType(conversion.from);
                hasAny = type.isAny || hasAny;
                newName += "|" + conversion.from;
                return {
                    name: conversion.from,
                    typeIndex: type.index,
                    test: type.test,
                    isAny: type.isAny,
                    conversion: conversion,
                    conversionIndex: conversion.index
                };
            });
            return {
                types: param.types.concat(convertibleTypes),
                name: newName,
                hasAny: hasAny,
                hasConversion: convertibleTypes.length > 0,
                restParam: param.restParam
            };
        }
        /**
     * Return the set of type names in a parameter.
     * Caches the result for efficiency
     *
     * @param {Param} param
     * @return {Set<string>} typenames
     */ function paramTypeSet(param) {
            if (!param.typeSet) {
                param.typeSet = new Set();
                param.types.forEach((type)=>param.typeSet.add(type.name));
            }
            return param.typeSet;
        }
        /**
     * Parse a signature with comma separated parameters,
     * like "number | boolean, ...string"
     *
     * @param {string} signature
     * @return {Param[]} params
     */ function parseSignature(rawSignature) {
            const params = [];
            if (typeof rawSignature !== "string") throw new TypeError("Signatures must be strings");
            const signature = rawSignature.trim();
            if (signature === "") return params;
            const rawParams = signature.split(",");
            for(let i = 0; i < rawParams.length; ++i){
                const parsedParam = parseParam(rawParams[i].trim());
                if (parsedParam.restParam && i !== rawParams.length - 1) throw new SyntaxError('Unexpected rest parameter "' + rawParams[i] + '": ' + "only allowed for the last parameter");
                // if invalid, short-circuit (all the types may have been filtered)
                if (parsedParam.types.length === 0) return null;
                params.push(parsedParam);
            }
            return params;
        }
        /**
     * Test whether a set of params contains a restParam
     * @param {Param[]} params
     * @return {boolean} Returns true when the last parameter is a restParam
     */ function hasRestParam(params) {
            const param = last(params);
            return param ? param.restParam : false;
        }
        /**
     * Create a type test for a single parameter, which can have one or multiple
     * types.
     * @param {Param} param
     * @return {function(x: *) : boolean} Returns a test function
     */ function compileTest(param) {
            if (!param || param.types.length === 0) // nothing to do
            return ok;
            else if (param.types.length === 1) return findType(param.types[0].name).test;
            else if (param.types.length === 2) {
                const test0 = findType(param.types[0].name).test;
                const test1 = findType(param.types[1].name).test;
                return function or(x) {
                    return test0(x) || test1(x);
                };
            } else {
                // param.types.length > 2
                const tests = param.types.map(function(type) {
                    return findType(type.name).test;
                });
                return function or(x) {
                    for(let i = 0; i < tests.length; i++){
                        if (tests[i](x)) return true;
                    }
                    return false;
                };
            }
        }
        /**
     * Create a test for all parameters of a signature
     * @param {Param[]} params
     * @return {function(args: Array<*>) : boolean}
     */ function compileTests(params) {
            let tests, test0, test1;
            if (hasRestParam(params)) {
                // variable arguments like '...number'
                tests = initial(params).map(compileTest);
                const varIndex = tests.length;
                const lastTest = compileTest(last(params));
                const testRestParam = function(args) {
                    for(let i = varIndex; i < args.length; i++){
                        if (!lastTest(args[i])) return false;
                    }
                    return true;
                };
                return function testArgs(args) {
                    for(let i = 0; i < tests.length; i++){
                        if (!tests[i](args[i])) return false;
                    }
                    return testRestParam(args) && args.length >= varIndex + 1;
                };
            } else {
                // no variable arguments
                if (params.length === 0) return function testArgs(args) {
                    return args.length === 0;
                };
                else if (params.length === 1) {
                    test0 = compileTest(params[0]);
                    return function testArgs(args) {
                        return test0(args[0]) && args.length === 1;
                    };
                } else if (params.length === 2) {
                    test0 = compileTest(params[0]);
                    test1 = compileTest(params[1]);
                    return function testArgs(args) {
                        return test0(args[0]) && test1(args[1]) && args.length === 2;
                    };
                } else {
                    // arguments.length > 2
                    tests = params.map(compileTest);
                    return function testArgs(args) {
                        for(let i = 0; i < tests.length; i++){
                            if (!tests[i](args[i])) return false;
                        }
                        return args.length === tests.length;
                    };
                }
            }
        }
        /**
     * Find the parameter at a specific index of a Params list.
     * Handles rest parameters.
     * @param {Param[]} params
     * @param {number} index
     * @return {Param | null} Returns the matching parameter when found,
     *                        null otherwise.
     */ function getParamAtIndex(params, index) {
            return index < params.length ? params[index] : hasRestParam(params) ? last(params) : null;
        }
        /**
     * Get all type names of a parameter
     * @param {Params[]} params
     * @param {number} index
     * @return {string[]} Returns an array with type names
     */ function getTypeSetAtIndex(params, index) {
            const param = getParamAtIndex(params, index);
            if (!param) return new Set();
            return paramTypeSet(param);
        }
        /**
     * Test whether a type is an exact type or conversion
     * @param {Type} type
     * @return {boolean} Returns true when
     */ function isExactType(type) {
            return type.conversion === null || type.conversion === undefined;
        }
        /**
     * Helper function for creating error messages: create an array with
     * all available types on a specific argument index.
     * @param {Signature[]} signatures
     * @param {number} index
     * @return {string[]} Returns an array with available types
     */ function mergeExpectedParams(signatures, index) {
            const typeSet = new Set();
            signatures.forEach((signature)=>{
                const paramSet = getTypeSetAtIndex(signature.params, index);
                let name;
                for (name of paramSet)typeSet.add(name);
            });
            return typeSet.has("any") ? [
                "any"
            ] : Array.from(typeSet);
        }
        /**
     * Create
     * @param {string} name             The name of the function
     * @param {array.<*>} args          The actual arguments passed to the function
     * @param {Signature[]} signatures  A list with available signatures
     * @return {TypeError} Returns a type error with additional data
     *                     attached to it in the property `data`
     */ function createError(name, args, signatures) {
            let err, expected;
            const _name = name || "unnamed";
            // test for wrong type at some index
            let matchingSignatures = signatures;
            let index;
            for(index = 0; index < args.length; index++){
                const nextMatchingDefs = [];
                matchingSignatures.forEach((signature)=>{
                    const param = getParamAtIndex(signature.params, index);
                    const test = compileTest(param);
                    if ((index < signature.params.length || hasRestParam(signature.params)) && test(args[index])) nextMatchingDefs.push(signature);
                });
                if (nextMatchingDefs.length === 0) {
                    // no matching signatures anymore, throw error "wrong type"
                    expected = mergeExpectedParams(matchingSignatures, index);
                    if (expected.length > 0) {
                        const actualTypes = findTypeNames(args[index]);
                        err = new TypeError("Unexpected type of argument in function " + _name + " (expected: " + expected.join(" or ") + ", actual: " + actualTypes.join(" | ") + ", index: " + index + ")");
                        err.data = {
                            category: "wrongType",
                            fn: _name,
                            index: index,
                            actual: actualTypes,
                            expected: expected
                        };
                        return err;
                    }
                } else matchingSignatures = nextMatchingDefs;
            }
            // test for too few arguments
            const lengths = matchingSignatures.map(function(signature) {
                return hasRestParam(signature.params) ? Infinity : signature.params.length;
            });
            if (args.length < Math.min.apply(null, lengths)) {
                expected = mergeExpectedParams(matchingSignatures, index);
                err = new TypeError("Too few arguments in function " + _name + " (expected: " + expected.join(" or ") + ", index: " + args.length + ")");
                err.data = {
                    category: "tooFewArgs",
                    fn: _name,
                    index: args.length,
                    expected: expected
                };
                return err;
            }
            // test for too many arguments
            const maxLength = Math.max.apply(null, lengths);
            if (args.length > maxLength) {
                err = new TypeError("Too many arguments in function " + _name + " (expected: " + maxLength + ", actual: " + args.length + ")");
                err.data = {
                    category: "tooManyArgs",
                    fn: _name,
                    index: args.length,
                    expectedLength: maxLength
                };
                return err;
            }
            // Generic error
            const argTypes = [];
            for(let i = 0; i < args.length; ++i)argTypes.push(findTypeNames(args[i]).join("|"));
            err = new TypeError('Arguments of type "' + argTypes.join(", ") + '" do not match any of the defined signatures of function ' + _name + ".");
            err.data = {
                category: "mismatch",
                actual: argTypes
            };
            return err;
        }
        /**
     * Find the lowest index of all exact types of a parameter (no conversions)
     * @param {Param} param
     * @return {number} Returns the index of the lowest type in typed.types
     */ function getLowestTypeIndex(param) {
            let min = typeList.length + 1;
            for(let i = 0; i < param.types.length; i++)if (isExactType(param.types[i])) min = Math.min(min, param.types[i].typeIndex);
            return min;
        }
        /**
     * Find the lowest index of the conversion of all types of the parameter
     * having a conversion
     * @param {Param} param
     * @return {number} Returns the lowest index of the conversions of this type
     */ function getLowestConversionIndex(param) {
            let min = nConversions + 1;
            for(let i = 0; i < param.types.length; i++)if (!isExactType(param.types[i])) min = Math.min(min, param.types[i].conversionIndex);
            return min;
        }
        /**
     * Compare two params
     * @param {Param} param1
     * @param {Param} param2
     * @return {number} returns -1 when param1 must get a lower
     *                  index than param2, 1 when the opposite,
     *                  or zero when both are equal
     */ function compareParams(param1, param2) {
            // We compare a number of metrics on a param in turn:
            // 1) 'any' parameters are the least preferred
            if (param1.hasAny) {
                if (!param2.hasAny) return 1;
            } else if (param2.hasAny) return -1;
            // 2) Prefer non-rest to rest parameters
            if (param1.restParam) {
                if (!param2.restParam) return 1;
            } else if (param2.restParam) return -1;
            // 3) Prefer exact type match to conversions
            if (param1.hasConversion) {
                if (!param2.hasConversion) return 1;
            } else if (param2.hasConversion) return -1;
            // 4) Prefer lower type index:
            const typeDiff = getLowestTypeIndex(param1) - getLowestTypeIndex(param2);
            if (typeDiff < 0) return -1;
            if (typeDiff > 0) return 1;
            // 5) Prefer lower conversion index
            const convDiff = getLowestConversionIndex(param1) - getLowestConversionIndex(param2);
            if (convDiff < 0) return -1;
            if (convDiff > 0) return 1;
            // Don't have a basis for preference
            return 0;
        }
        /**
     * Compare two signatures
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {number} returns a negative number when param1 must get a lower
     *                  index than param2, a positive number when the opposite,
     *                  or zero when both are equal
     */ function compareSignatures(signature1, signature2) {
            const pars1 = signature1.params;
            const pars2 = signature2.params;
            const last1 = last(pars1);
            const last2 = last(pars2);
            const hasRest1 = hasRestParam(pars1);
            const hasRest2 = hasRestParam(pars2);
            // We compare a number of metrics on signatures in turn:
            // 1) An "any rest param" is least preferred
            if (hasRest1 && last1.hasAny) {
                if (!hasRest2 || !last2.hasAny) return 1;
            } else if (hasRest2 && last2.hasAny) return -1;
            // 2) Minimize the number of 'any' parameters
            let any1 = 0;
            let conv1 = 0;
            let par;
            for (par of pars1){
                if (par.hasAny) ++any1;
                if (par.hasConversion) ++conv1;
            }
            let any2 = 0;
            let conv2 = 0;
            for (par of pars2){
                if (par.hasAny) ++any2;
                if (par.hasConversion) ++conv2;
            }
            if (any1 !== any2) return any1 - any2;
            // 3) A conversion rest param is less preferred
            if (hasRest1 && last1.hasConversion) {
                if (!hasRest2 || !last2.hasConversion) return 1;
            } else if (hasRest2 && last2.hasConversion) return -1;
            // 4) Minimize the number of conversions
            if (conv1 !== conv2) return conv1 - conv2;
            // 5) Prefer no rest param
            if (hasRest1) {
                if (!hasRest2) return 1;
            } else if (hasRest2) return -1;
            // 6) Prefer shorter with rest param, longer without
            const lengthCriterion = (pars1.length - pars2.length) * (hasRest1 ? -1 : 1);
            if (lengthCriterion !== 0) return lengthCriterion;
            // Signatures are identical in each of the above metrics.
            // In particular, they are the same length.
            // We can therefore compare the parameters one by one.
            // First we count which signature has more preferred parameters.
            const comparisons = [];
            let tc = 0;
            for(let i = 0; i < pars1.length; ++i){
                const thisComparison = compareParams(pars1[i], pars2[i]);
                comparisons.push(thisComparison);
                tc += thisComparison;
            }
            if (tc !== 0) return tc;
            // They have the same number of preferred parameters, so go by the
            // earliest parameter in which we have a preference.
            // In other words, dispatch is driven somewhat more by earlier
            // parameters than later ones.
            let c;
            for (c of comparisons){
                if (c !== 0) return c;
            }
            // It's a tossup:
            return 0;
        }
        /**
     * Produce a list of all conversions from distinct types to one of
     * the given types.
     *
     * @param {string[]} typeNames
     * @return {ConversionDef[]} Returns the conversions that are available
     *                        resulting in any given type (if any)
     */ function availableConversions(typeNames) {
            if (typeNames.length === 0) return [];
            const types = typeNames.map(findType);
            if (typeNames.length > 1) types.sort((t1, t2)=>t1.index - t2.index);
            let matches = types[0].conversionsTo;
            if (typeNames.length === 1) return matches;
            matches = matches.concat([]); // shallow copy the matches
            // Since the types are now in index order, we just want the first
            // occurrence of any from type:
            const knownTypes = new Set(typeNames);
            for(let i = 1; i < types.length; ++i){
                let newMatch;
                for (newMatch of types[i].conversionsTo)if (!knownTypes.has(newMatch.from)) {
                    matches.push(newMatch);
                    knownTypes.add(newMatch.from);
                }
            }
            return matches;
        }
        /**
     * Preprocess arguments before calling the original function:
     * - if needed convert the parameters
     * - in case of rest parameters, move the rest parameters into an Array
     * @param {Param[]} params
     * @param {function} fn
     * @return {function} Returns a wrapped function
     */ function compileArgsPreprocessing(params, fn) {
            let fnConvert = fn;
            // TODO: can we make this wrapper function smarter/simpler?
            if (params.some((p)=>p.hasConversion)) {
                const restParam = hasRestParam(params);
                const compiledConversions = params.map(compileArgConversion);
                fnConvert = function convertArgs() {
                    const args = [];
                    const last = restParam ? arguments.length - 1 : arguments.length;
                    for(let i = 0; i < last; i++)args[i] = compiledConversions[i](arguments[i]);
                    if (restParam) args[last] = arguments[last].map(compiledConversions[last]);
                    return fn.apply(this, args);
                };
            }
            let fnPreprocess = fnConvert;
            if (hasRestParam(params)) {
                const offset = params.length - 1;
                fnPreprocess = function preprocessRestParams() {
                    return fnConvert.apply(this, slice(arguments, 0, offset).concat([
                        slice(arguments, offset)
                    ]));
                };
            }
            return fnPreprocess;
        }
        /**
     * Compile conversion for a parameter to the right type
     * @param {Param} param
     * @return {function} Returns the wrapped function that will convert arguments
     *
     */ function compileArgConversion(param) {
            let test0, test1, conversion0, conversion1;
            const tests = [];
            const conversions = [];
            param.types.forEach(function(type) {
                if (type.conversion) {
                    tests.push(findType(type.conversion.from).test);
                    conversions.push(type.conversion.convert);
                }
            });
            // create optimized conversion functions depending on the number of conversions
            switch(conversions.length){
                case 0:
                    return function convertArg(arg) {
                        return arg;
                    };
                case 1:
                    test0 = tests[0];
                    conversion0 = conversions[0];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        return arg;
                    };
                case 2:
                    test0 = tests[0];
                    test1 = tests[1];
                    conversion0 = conversions[0];
                    conversion1 = conversions[1];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        if (test1(arg)) return conversion1(arg);
                        return arg;
                    };
                default:
                    return function convertArg(arg) {
                        for(let i = 0; i < conversions.length; i++){
                            if (tests[i](arg)) return conversions[i](arg);
                        }
                        return arg;
                    };
            }
        }
        /**
     * Split params with union types in to separate params.
     *
     * For example:
     *
     *     splitParams([['Array', 'Object'], ['string', 'RegExp'])
     *     // returns:
     *     // [
     *     //   ['Array', 'string'],
     *     //   ['Array', 'RegExp'],
     *     //   ['Object', 'string'],
     *     //   ['Object', 'RegExp']
     *     // ]
     *
     * @param {Param[]} params
     * @return {Param[]}
     */ function splitParams(params) {
            function _splitParams(params, index, paramsSoFar) {
                if (index < params.length) {
                    const param = params[index];
                    let resultingParams = [];
                    if (param.restParam) {
                        // split the types of a rest parameter in two:
                        // one with only exact types, and one with exact types and conversions
                        const exactTypes = param.types.filter(isExactType);
                        if (exactTypes.length < param.types.length) resultingParams.push({
                            types: exactTypes,
                            name: "..." + exactTypes.map((t)=>t.name).join("|"),
                            hasAny: exactTypes.some((t)=>t.isAny),
                            hasConversion: false,
                            restParam: true
                        });
                        resultingParams.push(param);
                    } else // split all the types of a regular parameter into one type per param
                    resultingParams = param.types.map(function(type) {
                        return {
                            types: [
                                type
                            ],
                            name: type.name,
                            hasAny: type.isAny,
                            hasConversion: type.conversion,
                            restParam: false
                        };
                    });
                    // recurse over the groups with types
                    return flatMap(resultingParams, function(nextParam) {
                        return _splitParams(params, index + 1, paramsSoFar.concat([
                            nextParam
                        ]));
                    });
                } else // we've reached the end of the parameters.
                return [
                    paramsSoFar
                ];
            }
            return _splitParams(params, 0, []);
        }
        /**
     * Test whether two param lists represent conflicting signatures
     * @param {Param[]} params1
     * @param {Param[]} params2
     * @return {boolean} Returns true when the signatures conflict, false otherwise.
     */ function conflicting(params1, params2) {
            const ii = Math.max(params1.length, params2.length);
            for(let i = 0; i < ii; i++){
                const typeSet1 = getTypeSetAtIndex(params1, i);
                const typeSet2 = getTypeSetAtIndex(params2, i);
                let overlap = false;
                let name;
                for (name of typeSet2)if (typeSet1.has(name)) {
                    overlap = true;
                    break;
                }
                if (!overlap) return false;
            }
            const len1 = params1.length;
            const len2 = params2.length;
            const restParam1 = hasRestParam(params1);
            const restParam2 = hasRestParam(params2);
            return restParam1 ? restParam2 ? len1 === len2 : len2 >= len1 : restParam2 ? len1 >= len2 : len1 === len2;
        }
        /**
     * Helper function for `resolveReferences` that returns a copy of
     * functionList wihe any prior resolutions cleared out, in case we are
     * recycling signatures from a prior typed function construction.
     *
     * @param {Array.<function|typed-reference>} functionList
     * @return {Array.<function|typed-reference>}
     */ function clearResolutions(functionList) {
            return functionList.map((fn)=>{
                if (isReferToSelf(fn)) return referToSelf(fn.referToSelf.callback);
                if (isReferTo(fn)) return makeReferTo(fn.referTo.references, fn.referTo.callback);
                return fn;
            });
        }
        /**
     * Take a list of references, a list of functions functionList, and a
     * signatureMap indexing signatures into functionList, and return
     * the list of resolutions, or a false-y value if they don't all
     * resolve in a valid way (yet).
     *
     * @param {string[]} references
     * @param {Array<function|typed-reference} functionList
     * @param {Object.<string, integer>} signatureMap
     * @return {function[] | false} resolutions
     */ function collectResolutions(references, functionList, signatureMap) {
            const resolvedReferences = [];
            let reference;
            for (reference of references){
                let resolution = signatureMap[reference];
                if (typeof resolution !== "number") throw new TypeError('No definition for referenced signature "' + reference + '"');
                resolution = functionList[resolution];
                if (typeof resolution !== "function") return false;
                resolvedReferences.push(resolution);
            }
            return resolvedReferences;
        }
        /**
     * Resolve any references in the functionList for the typed function
     * itself. The signatureMap tells which index in the functionList a
     * given signature should be mapped to (for use in resolving typed.referTo)
     * and self provides the destions of a typed.referToSelf.
     *
     * @param {Array<function | typed-reference-object>} functionList
     * @param {Object.<string, function>} signatureMap
     * @param {function} self  The typed-function itself
     * @return {Array<function>} The list of resolved functions
     */ function resolveReferences(functionList, signatureMap, self) {
            const resolvedFunctions = clearResolutions(functionList);
            const isResolved = new Array(resolvedFunctions.length).fill(false);
            let leftUnresolved = true;
            while(leftUnresolved){
                leftUnresolved = false;
                let nothingResolved = true;
                for(let i = 0; i < resolvedFunctions.length; ++i){
                    if (isResolved[i]) continue;
                    const fn = resolvedFunctions[i];
                    if (isReferToSelf(fn)) {
                        resolvedFunctions[i] = fn.referToSelf.callback(self);
                        // Preserve reference in case signature is reused someday:
                        resolvedFunctions[i].referToSelf = fn.referToSelf;
                        isResolved[i] = true;
                        nothingResolved = false;
                    } else if (isReferTo(fn)) {
                        const resolvedReferences = collectResolutions(fn.referTo.references, resolvedFunctions, signatureMap);
                        if (resolvedReferences) {
                            resolvedFunctions[i] = fn.referTo.callback.apply(this, resolvedReferences);
                            // Preserve reference in case signature is reused someday:
                            resolvedFunctions[i].referTo = fn.referTo;
                            isResolved[i] = true;
                            nothingResolved = false;
                        } else leftUnresolved = true;
                    }
                }
                if (nothingResolved && leftUnresolved) throw new SyntaxError("Circular reference detected in resolving typed.referTo");
            }
            return resolvedFunctions;
        }
        /**
     * Validate whether any of the function bodies contains a self-reference
     * usage like `this(...)` or `this.signatures`. This self-referencing is
     * deprecated since typed-function v3. It has been replaced with
     * the functions typed.referTo and typed.referToSelf.
     * @param {Object.<string, function>} signaturesMap
     */ function validateDeprecatedThis(signaturesMap) {
            // TODO: remove this deprecation warning logic some day (it's introduced in v3)
            // match occurrences like 'this(' and 'this.signatures'
            const deprecatedThisRegex = /\bthis(\(|\.signatures\b)/;
            Object.keys(signaturesMap).forEach((signature)=>{
                const fn = signaturesMap[signature];
                if (deprecatedThisRegex.test(fn.toString())) throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
            });
        }
        /**
     * Create a typed function
     * @param {String} name               The name for the typed function
     * @param {Object.<string, function>} rawSignaturesMap
     *                                    An object with one or
     *                                    multiple signatures as key, and the
     *                                    function corresponding to the
     *                                    signature as value.
     * @return {function}  Returns the created typed function.
     */ function createTypedFunction(name, rawSignaturesMap) {
            typed.createCount++;
            if (Object.keys(rawSignaturesMap).length === 0) throw new SyntaxError("No signatures provided");
            if (typed.warnAgainstDeprecatedThis) validateDeprecatedThis(rawSignaturesMap);
            // Main processing loop for signatures
            const parsedParams = [];
            const originalFunctions = [];
            const signaturesMap = {};
            const preliminarySignatures = []; // may have duplicates from conversions
            let signature;
            for(signature in rawSignaturesMap){
                // A) Protect against polluted Object prototype:
                if (!Object.prototype.hasOwnProperty.call(rawSignaturesMap, signature)) continue;
                // B) Parse the signature
                const params = parseSignature(signature);
                if (!params) continue;
                // C) Check for conflicts
                parsedParams.forEach(function(pp) {
                    if (conflicting(pp, params)) throw new TypeError('Conflicting signatures "' + stringifyParams(pp) + '" and "' + stringifyParams(params) + '".');
                });
                parsedParams.push(params);
                // D) Store the provided function and add conversions
                const functionIndex = originalFunctions.length;
                originalFunctions.push(rawSignaturesMap[signature]);
                const conversionParams = params.map(expandParam);
                // E) Split the signatures and collect them up
                let sp;
                for (sp of splitParams(conversionParams)){
                    const spName = stringifyParams(sp);
                    preliminarySignatures.push({
                        params: sp,
                        name: spName,
                        fn: functionIndex
                    });
                    if (sp.every((p)=>!p.hasConversion)) signaturesMap[spName] = functionIndex;
                }
            }
            preliminarySignatures.sort(compareSignatures);
            // Note the forward reference to theTypedFn
            const resolvedFunctions = resolveReferences(originalFunctions, signaturesMap, theTypedFn);
            // Fill in the proper function for each signature
            let s;
            for(s in signaturesMap)if (Object.prototype.hasOwnProperty.call(signaturesMap, s)) signaturesMap[s] = resolvedFunctions[signaturesMap[s]];
            const signatures = [];
            const internalSignatureMap = new Map(); // benchmarks faster than object
            for (s of preliminarySignatures)// Note it's only safe to eliminate duplicates like this
            // _after_ the signature sorting step above; otherwise we might
            // remove the wrong one.
            if (!internalSignatureMap.has(s.name)) {
                s.fn = resolvedFunctions[s.fn];
                signatures.push(s);
                internalSignatureMap.set(s.name, s);
            }
            // we create a highly optimized checks for the first couple of signatures with max 2 arguments
            const ok0 = signatures[0] && signatures[0].params.length <= 2 && !hasRestParam(signatures[0].params);
            const ok1 = signatures[1] && signatures[1].params.length <= 2 && !hasRestParam(signatures[1].params);
            const ok2 = signatures[2] && signatures[2].params.length <= 2 && !hasRestParam(signatures[2].params);
            const ok3 = signatures[3] && signatures[3].params.length <= 2 && !hasRestParam(signatures[3].params);
            const ok4 = signatures[4] && signatures[4].params.length <= 2 && !hasRestParam(signatures[4].params);
            const ok5 = signatures[5] && signatures[5].params.length <= 2 && !hasRestParam(signatures[5].params);
            const allOk = ok0 && ok1 && ok2 && ok3 && ok4 && ok5;
            // compile the tests
            for(let i = 0; i < signatures.length; ++i)signatures[i].test = compileTests(signatures[i].params);
            const test00 = ok0 ? compileTest(signatures[0].params[0]) : notOk;
            const test10 = ok1 ? compileTest(signatures[1].params[0]) : notOk;
            const test20 = ok2 ? compileTest(signatures[2].params[0]) : notOk;
            const test30 = ok3 ? compileTest(signatures[3].params[0]) : notOk;
            const test40 = ok4 ? compileTest(signatures[4].params[0]) : notOk;
            const test50 = ok5 ? compileTest(signatures[5].params[0]) : notOk;
            const test01 = ok0 ? compileTest(signatures[0].params[1]) : notOk;
            const test11 = ok1 ? compileTest(signatures[1].params[1]) : notOk;
            const test21 = ok2 ? compileTest(signatures[2].params[1]) : notOk;
            const test31 = ok3 ? compileTest(signatures[3].params[1]) : notOk;
            const test41 = ok4 ? compileTest(signatures[4].params[1]) : notOk;
            const test51 = ok5 ? compileTest(signatures[5].params[1]) : notOk;
            // compile the functions
            for(let i = 0; i < signatures.length; ++i)signatures[i].implementation = compileArgsPreprocessing(signatures[i].params, signatures[i].fn);
            const fn0 = ok0 ? signatures[0].implementation : undef;
            const fn1 = ok1 ? signatures[1].implementation : undef;
            const fn2 = ok2 ? signatures[2].implementation : undef;
            const fn3 = ok3 ? signatures[3].implementation : undef;
            const fn4 = ok4 ? signatures[4].implementation : undef;
            const fn5 = ok5 ? signatures[5].implementation : undef;
            const len0 = ok0 ? signatures[0].params.length : -1;
            const len1 = ok1 ? signatures[1].params.length : -1;
            const len2 = ok2 ? signatures[2].params.length : -1;
            const len3 = ok3 ? signatures[3].params.length : -1;
            const len4 = ok4 ? signatures[4].params.length : -1;
            const len5 = ok5 ? signatures[5].params.length : -1;
            // simple and generic, but also slow
            const iStart = allOk ? 6 : 0;
            const iEnd = signatures.length;
            // de-reference ahead for execution speed:
            const tests = signatures.map((s)=>s.test);
            const fns = signatures.map((s)=>s.implementation);
            const generic = function generic() {
                for(let i = iStart; i < iEnd; i++){
                    if (tests[i](arguments)) return fns[i].apply(this, arguments);
                }
                return typed.onMismatch(name, arguments, signatures);
            };
            // create the typed function
            // fast, specialized version. Falls back to the slower, generic one if needed
            function theTypedFn(arg0, arg1) {
                if (arguments.length === len0 && test00(arg0) && test01(arg1)) return fn0.apply(this, arguments);
                if (arguments.length === len1 && test10(arg0) && test11(arg1)) return fn1.apply(this, arguments);
                if (arguments.length === len2 && test20(arg0) && test21(arg1)) return fn2.apply(this, arguments);
                if (arguments.length === len3 && test30(arg0) && test31(arg1)) return fn3.apply(this, arguments);
                if (arguments.length === len4 && test40(arg0) && test41(arg1)) return fn4.apply(this, arguments);
                if (arguments.length === len5 && test50(arg0) && test51(arg1)) return fn5.apply(this, arguments);
                return generic.apply(this, arguments);
            }
            // attach name the typed function
            try {
                Object.defineProperty(theTypedFn, "name", {
                    value: name
                });
            } catch (err) {
            // old browsers do not support Object.defineProperty and some don't support setting the name property
            // the function name is not essential for the functioning, it's mostly useful for debugging,
            // so it's fine to have unnamed functions.
            }
            // attach signatures to the function.
            // This property is close to the original collection of signatures
            // used to create the typed-function, just with unions split:
            theTypedFn.signatures = signaturesMap;
            // Store internal data for functions like resolve, find, etc.
            // Also serves as the flag that this is a typed-function
            theTypedFn._typedFunctionData = {
                signatures: signatures,
                signatureMap: internalSignatureMap
            };
            return theTypedFn;
        }
        /**
     * Action to take on mismatch
     * @param {string} name      Name of function that was attempted to be called
     * @param {Array} args       Actual arguments to the call
     * @param {Array} signatures Known signatures of the named typed-function
     */ function _onMismatch(name, args, signatures) {
            throw createError(name, args, signatures);
        }
        /**
     * Return all but the last items of an array or function Arguments
     * @param {Array | Arguments} arr
     * @return {Array}
     */ function initial(arr) {
            return slice(arr, 0, arr.length - 1);
        }
        /**
     * return the last item of an array or function Arguments
     * @param {Array | Arguments} arr
     * @return {*}
     */ function last(arr) {
            return arr[arr.length - 1];
        }
        /**
     * Slice an array or function Arguments
     * @param {Array | Arguments | IArguments} arr
     * @param {number} start
     * @param {number} [end]
     * @return {Array}
     */ function slice(arr, start, end) {
            return Array.prototype.slice.call(arr, start, end);
        }
        /**
     * Return the first item from an array for which test(arr[i]) returns true
     * @param {Array} arr
     * @param {function} test
     * @return {* | undefined} Returns the first matching item
     *                         or undefined when there is no match
     */ function findInArray(arr, test) {
            for(let i = 0; i < arr.length; i++){
                if (test(arr[i])) return arr[i];
            }
            return undefined;
        }
        /**
     * Flat map the result invoking a callback for every item in an array.
     * https://gist.github.com/samgiles/762ee337dff48623e729
     * @param {Array} arr
     * @param {function} callback
     * @return {Array}
     */ function flatMap(arr, callback) {
            return Array.prototype.concat.apply([], arr.map(callback));
        }
        /**
     * Create a reference callback to one or multiple signatures
     *
     * Syntax:
     *
     *     typed.referTo(signature1, signature2, ..., function callback(fn1, fn2, ...) {
     *       // ...
     *     })
     *
     * @returns {{referTo: {references: string[], callback}}}
     */ function referTo() {
            const references = initial(arguments).map((s)=>stringifyParams(parseSignature(s)));
            const callback = last(arguments);
            if (typeof callback !== "function") throw new TypeError("Callback function expected as last argument");
            return makeReferTo(references, callback);
        }
        function makeReferTo(references, callback) {
            return {
                referTo: {
                    references: references,
                    callback: callback
                }
            };
        }
        /**
     * Create a reference callback to the typed-function itself
     *
     * @param {(self: function) => function} callback
     * @returns {{referToSelf: { callback: function }}}
     */ function referToSelf(callback) {
            if (typeof callback !== "function") throw new TypeError("Callback function expected as first argument");
            return {
                referToSelf: {
                    callback: callback
                }
            };
        }
        /**
     * Test whether something is a referTo object, holding a list with reference
     * signatures and a callback.
     *
     * @param {Object | function} objectOrFn
     * @returns {boolean}
     */ function isReferTo(objectOrFn) {
            return objectOrFn && typeof objectOrFn.referTo === "object" && Array.isArray(objectOrFn.referTo.references) && typeof objectOrFn.referTo.callback === "function";
        }
        /**
     * Test whether something is a referToSelf object, holding a callback where
     * to pass `self`.
     *
     * @param {Object | function} objectOrFn
     * @returns {boolean}
     */ function isReferToSelf(objectOrFn) {
            return objectOrFn && typeof objectOrFn.referToSelf === "object" && typeof objectOrFn.referToSelf.callback === "function";
        }
        /**
     * Check if name is (A) new, (B) a match, or (C) a mismatch; and throw
     * an error in case (C).
     *
     * @param { string | undefined } nameSoFar
     * @param { string | undefined } newName
     * @returns { string } updated name
     */ function checkName(nameSoFar, newName) {
            if (!nameSoFar) return newName;
            if (newName && newName !== nameSoFar) {
                const err = new Error("Function names do not match (expected: " + nameSoFar + ", actual: " + newName + ")");
                err.data = {
                    actual: newName,
                    expected: nameSoFar
                };
                throw err;
            }
            return nameSoFar;
        }
        /**
     * Retrieve the implied name from an object with signature keys
     * and function values, checking whether all value names match
     *
     * @param { {string: function} } obj
     */ function getObjectName(obj) {
            let name;
            for(const key in obj)// Only pay attention to own properties, and only if their values
            // are typed functions or functions with a signature property
            if (Object.prototype.hasOwnProperty.call(obj, key) && (isTypedFunction(obj[key]) || typeof obj[key].signature === "string")) name = checkName(name, obj[key].name);
            return name;
        }
        /**
     * Copy all of the signatures from the second argument into the first,
     * which is modified by side effect, checking for conflicts
     *
     * @param {Object.<string, function|typed-reference>} dest
     * @param {Object.<string, function|typed-reference>} source
     */ function mergeSignatures(dest, source) {
            let key;
            for(key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
                if (key in dest) {
                    if (source[key] !== dest[key]) {
                        const err = new Error('Signature "' + key + '" is defined twice');
                        err.data = {
                            signature: key,
                            sourceFunction: source[key],
                            destFunction: dest[key]
                        };
                        throw err;
                    }
                }
                dest[key] = source[key];
            }
        }
        const saveTyped = typed;
        /**
     * Originally the main function was a typed function itself, but then
     * it might not be able to generate error messages if the client
     * replaced the type system with different names.
     *
     * Main entry: typed([name], functions/objects with signatures...)
     *
     * Assembles and returns a new typed-function from the given items
     * that provide signatures and implementations, each of which may be
     * * a plain object mapping (string) signatures to implementing functions,
     * * a previously constructed typed function, or
     * * any other single function with a string-valued property `signature`.
      * The name of the resulting typed-function will be given by the
     * string-valued name argument if present, or if not, by the name
     * of any of the arguments that have one, as long as any that do are
     * consistent with each other. If no name is specified, the name will be
     * an empty string.
     *
     * @param {string} maybeName [optional]
     * @param {(function|object)[]} signature providers
     * @returns {typed-function}
     */ typed = function(maybeName) {
            const named = typeof maybeName === "string";
            const start = named ? 1 : 0;
            let name = named ? maybeName : "";
            const allSignatures = {};
            for(let i = start; i < arguments.length; ++i){
                const item = arguments[i];
                let theseSignatures = {};
                let thisName;
                if (typeof item === "function") {
                    thisName = item.name;
                    if (typeof item.signature === "string") // Case 1: Ordinary function with a string 'signature' property
                    theseSignatures[item.signature] = item;
                    else if (isTypedFunction(item)) // Case 2: Existing typed function
                    theseSignatures = item.signatures;
                } else if (isPlainObject(item)) {
                    // Case 3: Plain object, assume keys = signatures, values = functions
                    theseSignatures = item;
                    if (!named) thisName = getObjectName(item);
                }
                if (Object.keys(theseSignatures).length === 0) {
                    const err = new TypeError("Argument to 'typed' at index " + i + " is not a (typed) function, " + "nor an object with signatures as keys and functions as values.");
                    err.data = {
                        index: i,
                        argument: item
                    };
                    throw err;
                }
                if (!named) name = checkName(name, thisName);
                mergeSignatures(allSignatures, theseSignatures);
            }
            return createTypedFunction(name || "", allSignatures);
        };
        typed.create = create;
        typed.createCount = saveTyped.createCount;
        typed.onMismatch = _onMismatch;
        typed.throwMismatchError = _onMismatch;
        typed.createError = createError;
        typed.clear = clear;
        typed.clearConversions = clearConversions;
        typed.addTypes = addTypes;
        typed._findType = findType; // For unit testing only
        typed.referTo = referTo;
        typed.referToSelf = referToSelf;
        typed.convert = convert;
        typed.findSignature = findSignature;
        typed.find = find;
        typed.isTypedFunction = isTypedFunction;
        typed.warnAgainstDeprecatedThis = true;
        /**
     * add a type (convenience wrapper for typed.addTypes)
     * @param {{name: string, test: function}} type
     * @param {boolean} [beforeObjectTest=true]
     *                          If true, the new test will be inserted before
     *                          the test with name 'Object' (if any), since
     *                          tests for Object match Array and classes too.
     */ typed.addType = function(type, beforeObjectTest) {
            let before = "any";
            if (beforeObjectTest !== false && typeMap.has("Object")) before = "Object";
            typed.addTypes([
                type
            ], before);
        };
        /**
     * Verify that the ConversionDef conversion has a valid format.
     *
     * @param {conversionDef} conversion
     * @return {void}
     * @throws {TypeError|SyntaxError}
     */ function _validateConversion(conversion) {
            if (!conversion || typeof conversion.from !== "string" || typeof conversion.to !== "string" || typeof conversion.convert !== "function") throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
            if (conversion.to === conversion.from) throw new SyntaxError('Illegal to define conversion from "' + conversion.from + '" to itself.');
        }
        /**
     * Add a conversion
     *
     * @param {ConversionDef} conversion
     * @param {{override: boolean}} [options]
     * @returns {void}
     * @throws {TypeError}
     */ typed.addConversion = function(conversion) {
            let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                override: false
            };
            _validateConversion(conversion);
            const to = findType(conversion.to);
            const existing = to.conversionsTo.find((other)=>other.from === conversion.from);
            if (existing) {
                if (options && options.override) typed.removeConversion({
                    from: existing.from,
                    to: conversion.to,
                    convert: existing.convert
                });
                else throw new Error('There is already a conversion from "' + conversion.from + '" to "' + to.name + '"');
            }
            to.conversionsTo.push({
                from: conversion.from,
                convert: conversion.convert,
                index: nConversions++
            });
        };
        /**
     * Convenience wrapper to call addConversion on each conversion in a list.
     *
     * @param {ConversionDef[]} conversions
     * @param {{override: boolean}} [options]
     * @returns {void}
     * @throws {TypeError}
     */ typed.addConversions = function(conversions, options) {
            conversions.forEach((conversion)=>typed.addConversion(conversion, options));
        };
        /**
     * Remove the specified conversion. The format is the same as for
     * addConversion, and the convert function must match or an error
     * is thrown.
     *
     * @param {{from: string, to: string, convert: function}} conversion
     * @returns {void}
     * @throws {TypeError|SyntaxError|Error}
     */ typed.removeConversion = function(conversion) {
            _validateConversion(conversion);
            const to = findType(conversion.to);
            const existingConversion = findInArray(to.conversionsTo, (c)=>c.from === conversion.from);
            if (!existingConversion) throw new Error("Attempt to remove nonexistent conversion from " + conversion.from + " to " + conversion.to);
            if (existingConversion.convert !== conversion.convert) throw new Error("Conversion to remove does not match existing conversion");
            const index = to.conversionsTo.indexOf(existingConversion);
            to.conversionsTo.splice(index, 1);
        };
        /**
     * Produce the specific signature that a typed function
     * will execute on the given arguments. Here, a "signature" is an
     * object with properties 'params', 'test', 'fn', and 'implementation'.
     * This last property is a function that converts params as necessary
     * and then calls 'fn'. Returns null if there is no matching signature.
     * @param {typed-function} tf
     * @param {any[]} argList
     * @returns {{params: string, test: function, fn: function, implementation: function}}
     */ typed.resolve = function(tf, argList) {
            if (!isTypedFunction(tf)) throw new TypeError(NOT_TYPED_FUNCTION);
            const sigs = tf._typedFunctionData.signatures;
            for(let i = 0; i < sigs.length; ++i){
                if (sigs[i].test(argList)) return sigs[i];
            }
            return null;
        };
        return typed;
    }
    var typedFunction = create();
    return typedFunction;
});



function $1427f34fc9a7e1b3$export$c081893a7ce04a4c(callback, value, index, array, mappingFnName) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($25db5d51e6b14f18$exports))).isTypedFunction(callback)) {
        // invoke the typed callback function with the matching number of arguments only
        var args3 = [
            value,
            index,
            array
        ];
        var signature3 = (0, (/*@__PURE__*/$parcel$interopDefault($25db5d51e6b14f18$exports))).resolve(callback, args3);
        if (signature3) return tryWithArgs(signature3.implementation, args3);
        var args2 = [
            value,
            index
        ];
        var signature2 = (0, (/*@__PURE__*/$parcel$interopDefault($25db5d51e6b14f18$exports))).resolve(callback, args2);
        if (signature2) return tryWithArgs(signature2.implementation, args2);
        var args1 = [
            value
        ];
        var signature1 = (0, (/*@__PURE__*/$parcel$interopDefault($25db5d51e6b14f18$exports))).resolve(callback, args1);
        if (signature1) return tryWithArgs(signature1.implementation, args1);
        // fallback (will throw an exception)
        return tryWithArgs(callback, args3);
    } else // A regular JavaScript function
    return callback(value, index, array);
    /**
   * @param {function} signature The selected signature of the typed-function
   * @param {Array} args List with arguments to apply to the selected signature
   * @returns {*} Returns the return value of the invoked signature
   * @throws {TypeError} Throws an error when no matching signature was found
   */ function tryWithArgs(signature, args) {
        try {
            return signature.apply(signature, args);
        } catch (err) {
            var _err$data;
            // Enrich the error message so the user understands that it took place inside the callback function
            if (err instanceof TypeError && ((_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.category) === "wrongType") {
                var argsDesc = [];
                argsDesc.push("value: ".concat((0, $23cfe017d190638f$export$f5bbd400c2f4426f)(value)));
                if (args.length >= 2) argsDesc.push("index: ".concat((0, $23cfe017d190638f$export$f5bbd400c2f4426f)(index)));
                if (args.length >= 3) argsDesc.push("array: ".concat((0, $23cfe017d190638f$export$f5bbd400c2f4426f)(array)));
                throw new TypeError("Function ".concat(mappingFnName, " cannot apply callback arguments ") + "".concat(callback.name, "(").concat(argsDesc.join(", "), ") at index ").concat(JSON.stringify(index)));
            } else throw new TypeError("Function ".concat(mappingFnName, " cannot apply callback arguments ") + "to function ".concat(callback.name, ": ").concat(err.message));
        }
    }
}




var $52f9b87db4f9c98c$var$name = "filter";
var $52f9b87db4f9c98c$var$dependencies = [
    "typed"
];
var $52f9b87db4f9c98c$export$5d81789ff4aeccdf = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($52f9b87db4f9c98c$var$name, $52f9b87db4f9c98c$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Filter the items in an array or one dimensional matrix.
   *
   * Syntax:
   *
   *    math.filter(x, test)
   *
   * Examples:
   *
   *    function isPositive (x) {
   *      return x > 0
   *    }
   *    math.filter([6, -2, -1, 4, 3], isPositive) // returns [6, 4, 3]
   *
   *    math.filter(["23", "foo", "100", "55", "bar"], /[0-9]+/) // returns ["23", "100", "55"]
   *
   * See also:
   *
   *    forEach, map, sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to filter
   * @param {Function | RegExp} test
   *        A function or regular expression to test items.
   *        All entries for which `test` returns true are returned.
   *        When `test` is a function, it is invoked with three parameters:
   *        the value of the element, the index of the element, and the
   *        matrix/array being traversed. The function must return a boolean.
   * @return {Matrix | Array} Returns the filtered matrix.
   */ return typed("filter", {
        "Array, function": $52f9b87db4f9c98c$var$_filterCallback,
        "Matrix, function": function MatrixFunction(x, test) {
            return x.create($52f9b87db4f9c98c$var$_filterCallback(x.toArray(), test));
        },
        "Array, RegExp": (0, $eee21df0c3527ff1$export$322859471e81229d),
        "Matrix, RegExp": function MatrixRegExp(x, test) {
            return x.create((0, $eee21df0c3527ff1$export$322859471e81229d)(x.toArray(), test));
        }
    });
});
/**
 * Filter values in a callback given a callback function
 * @param {Array} x
 * @param {Function} callback
 * @return {Array} Returns the filtered array
 * @private
 */ function $52f9b87db4f9c98c$var$_filterCallback(x, callback) {
    return (0, $eee21df0c3527ff1$export$3dea766d36a8935f)(x, function(value, index, array) {
        // invoke the callback function with the right number of arguments
        return (0, $1427f34fc9a7e1b3$export$c081893a7ce04a4c)(callback, value, [
            index
        ], array, "filter");
    });
}





var $24c8992ed9281b77$var$name = "fix";
var $24c8992ed9281b77$var$dependencies = [
    "typed",
    "Complex",
    "matrix",
    "ceil",
    "floor",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $24c8992ed9281b77$export$595d114466bb5460 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($24c8992ed9281b77$var$name, [
    "typed",
    "ceil",
    "floor"
], (_ref)=>{
    var { typed: typed, ceil: ceil, floor: floor } = _ref;
    return typed($24c8992ed9281b77$var$name, {
        number: function number(x) {
            return x > 0 ? floor(x) : ceil(x);
        },
        "number, number": function numberNumber(x, n) {
            return x > 0 ? floor(x, n) : ceil(x, n);
        }
    });
});
var $24c8992ed9281b77$export$3ed06081b8a4ee6 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($24c8992ed9281b77$var$name, $24c8992ed9281b77$var$dependencies, (_ref2)=>{
    var { typed: typed, Complex: _Complex, matrix: matrix, ceil: ceil, floor: floor, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo14xDs = (0, $ada7281b5c8c5fa6$export$4b07063314120f7c)({
        typed: typed
    });
    var fixNumber = $24c8992ed9281b77$export$595d114466bb5460({
        typed: typed,
        ceil: ceil,
        floor: floor
    });
    /**
   * Round a value towards zero.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.fix(x)
   *    math.fix(x,n)
   *
   * Examples:
   *
   *    math.fix(3.2)                // returns number 3
   *    math.fix(3.8)                // returns number 3
   *    math.fix(-4.2)               // returns number -4
   *    math.fix(-4.7)               // returns number -4
   *
   *    math.fix(3.12, 1)                // returns number 3.1
   *    math.fix(3.18, 1)                // returns number 3.1
   *    math.fix(-4.12, 1)               // returns number -4.1
   *    math.fix(-4.17, 1)               // returns number -4.1
   *
   *    const c = math.complex(3.22, -2.78)
   *    math.fix(c)                  // returns Complex 3 - 2i
   *    math.fix(c, 1)               // returns Complex 3.2 -2.7i
   *
   *    math.fix([3.2, 3.8, -4.7])      // returns Array [3, 3, -4]
   *    math.fix([3.2, 3.8, -4.7], 1)   // returns Array [3.2, 3.8, -4.7]
   *
   * See also:
   *
   *    ceil, floor, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x    Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                             Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix}     Rounded value
   */ return typed("fix", {
        number: fixNumber.signatures.number,
        "number, number | BigNumber": fixNumber.signatures["number,number"],
        Complex: function Complex(x) {
            return new _Complex(x.re > 0 ? Math.floor(x.re) : Math.ceil(x.re), x.im > 0 ? Math.floor(x.im) : Math.ceil(x.im));
        },
        "Complex, number": function ComplexNumber(x, n) {
            return new _Complex(x.re > 0 ? floor(x.re, n) : ceil(x.re, n), x.im > 0 ? floor(x.im, n) : ceil(x.im, n));
        },
        "Complex, BigNumber": function ComplexBigNumber(x, bn) {
            var n = bn.toNumber();
            return new _Complex(x.re > 0 ? floor(x.re, n) : ceil(x.re, n), x.im > 0 ? floor(x.im, n) : ceil(x.im, n));
        },
        BigNumber: function BigNumber(x) {
            return x.isNegative() ? ceil(x) : floor(x);
        },
        "BigNumber, number | BigNumber": function BigNumberNumberBigNumber(x, n) {
            return x.isNegative() ? ceil(x, n) : floor(x, n);
        },
        Fraction: function Fraction(x) {
            return x.s < 0 ? x.ceil() : x.floor();
        },
        "Fraction, number | BigNumber": function FractionNumberBigNumber(x, n) {
            return x.s < 0 ? ceil(x, n) : floor(x, n);
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>{
                // deep map collection, skip zeros since fix(0) = 0
                return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self, true);
            }),
        "Array | Matrix, number | BigNumber": typed.referToSelf((self)=>(x, n)=>{
                // deep map collection, skip zeros since fix(0) = 0
                return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, (i)=>self(i, n), true);
            }),
        "number | Complex | Fraction | BigNumber, Array": typed.referToSelf((self)=>(x, y)=>{
                // use matrix implementation
                return matAlgo14xDs(matrix(y), x, self, true).valueOf();
            }),
        "number | Complex | Fraction | BigNumber, Matrix": typed.referToSelf((self)=>(x, y)=>{
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                if (y.storage() === "dense") return matAlgo14xDs(y, x, self, true);
                return matAlgo12xSfs(y, x, self, true);
            })
    });
});



var $1905ab18d425dffd$var$name = "flatten";
var $1905ab18d425dffd$var$dependencies = [
    "typed",
    "matrix"
];
var $1905ab18d425dffd$export$107988e3ee9f3d12 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($1905ab18d425dffd$var$name, $1905ab18d425dffd$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Flatten a multidimensional matrix into a single dimensional matrix.
   * A new matrix is returned, the original matrix is left untouched.
   *
   * Syntax:
   *
   *    math.flatten(x)
   *
   * Examples:
   *
   *    math.flatten([[1,2], [3,4]])   // returns [1, 2, 3, 4]
   *
   * See also:
   *
   *    concat, resize, size, squeeze
   *
   * @param {Matrix | Array} x   Matrix to be flattened
   * @return {Matrix | Array} Returns the flattened matrix
   */ return typed($1905ab18d425dffd$var$name, {
        Array: function Array(x) {
            return (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(x);
        },
        Matrix: function Matrix(x) {
            var flat = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(x.toArray());
            // TODO: return the same matrix type as x (Dense or Sparse Matrix)
            return matrix(flat);
        }
    });
});









var $6bb08bcefc55a9f9$var$name = "floor";
var $6bb08bcefc55a9f9$var$dependencies = [
    "typed",
    "config",
    "round",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $6bb08bcefc55a9f9$export$a13f3226a75ff445 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6bb08bcefc55a9f9$var$name, [
    "typed",
    "config",
    "round"
], (_ref)=>{
    var { typed: typed, config: config, round: round } = _ref;
    return typed($6bb08bcefc55a9f9$var$name, {
        number: function number(x) {
            if ((0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, round(x), config.relTol, config.absTol)) return round(x);
            else return Math.floor(x);
        },
        "number, number": function numberNumber(x, n) {
            if ((0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, round(x, n), config.relTol, config.absTol)) return round(x, n);
            else {
                var [number, exponent] = "".concat(x, "e").split("e");
                var result = Math.floor(Number("".concat(number, "e").concat(Number(exponent) + n)));
                [number, exponent] = "".concat(result, "e").split("e");
                return Number("".concat(number, "e").concat(Number(exponent) - n));
            }
        }
    });
});
var $6bb08bcefc55a9f9$export$e04e4803a9128c9b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6bb08bcefc55a9f9$var$name, $6bb08bcefc55a9f9$var$dependencies, (_ref2)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo14xDs = (0, $ada7281b5c8c5fa6$export$4b07063314120f7c)({
        typed: typed
    });
    var floorNumber = $6bb08bcefc55a9f9$export$a13f3226a75ff445({
        typed: typed,
        config: config,
        round: round
    });
    /**
   * Round a value towards minus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.floor(x)
   *    math.floor(x, n)
   *
   * Examples:
   *
   *    math.floor(3.2)              // returns number 3
   *    math.floor(3.8)              // returns number 3
   *    math.floor(-4.2)             // returns number -5
   *    math.floor(-4.7)             // returns number -5
   *
   *    math.floor(3.212, 2)          // returns number 3.21
   *    math.floor(3.288, 2)          // returns number 3.28
   *    math.floor(-4.212, 2)         // returns number -4.22
   *    math.floor(-4.782, 2)         // returns number -4.79
   *
   *    const c = math.complex(3.24, -2.71)
   *    math.floor(c)                 // returns Complex 3 - 3i
   *    math.floor(c, 1)              // returns Complex 3.2 -2.8i
   *
   *    math.floor([3.2, 3.8, -4.7])       // returns Array [3, 3, -5]
   *    math.floor([3.21, 3.82, -4.71], 1)  // returns Array [3.2, 3.8, -4.8]
   *
   *    math.floor(math.tau, [2, 3])  // returns Array [6.28, 6.283]
   *
   *    // Note that floor(array, array) currently not implemented.
   *
   * See also:
   *
   *    ceil, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed("floor", {
        number: floorNumber.signatures.number,
        "number,number": floorNumber.signatures["number,number"],
        Complex: function Complex(x) {
            return x.floor();
        },
        "Complex, number": function ComplexNumber(x, n) {
            return x.floor(n);
        },
        "Complex, BigNumber": function ComplexBigNumber(x, n) {
            return x.floor(n.toNumber());
        },
        BigNumber: function BigNumber(x) {
            if ((0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, round(x), config.relTol, config.absTol)) return round(x);
            else return x.floor();
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, n) {
            if ((0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, round(x, n), config.relTol, config.absTol)) return round(x, n);
            else return x.toDecimalPlaces(n.toNumber(), (0, (/*@__PURE__*/$parcel$interopDefault($22467ec447bdc2ca$exports))).ROUND_FLOOR);
        },
        Fraction: function Fraction(x) {
            return x.floor();
        },
        "Fraction, number": function FractionNumber(x, n) {
            return x.floor(n);
        },
        "Fraction, BigNumber": function FractionBigNumber(x, n) {
            return x.floor(n.toNumber());
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>{
                // deep map collection, skip zeros since floor(0) = 0
                return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self, true);
            }),
        "Array, number | BigNumber": typed.referToSelf((self)=>(x, n)=>{
                // deep map collection, skip zeros since ceil(0) = 0
                return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, (i)=>self(i, n), true);
            }),
        "SparseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, y)=>{
                return matAlgo11xS0s(x, y, self, false);
            }),
        "DenseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, y)=>{
                return matAlgo14xDs(x, y, self, false);
            }),
        "number | Complex | Fraction | BigNumber, Array": typed.referToSelf((self)=>(x, y)=>{
                // use matrix implementation
                return matAlgo14xDs(matrix(y), x, self, true).valueOf();
            }),
        "number | Complex | Fraction | BigNumber, Matrix": typed.referToSelf((self)=>(x, y)=>{
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                if (y.storage() === "dense") return matAlgo14xDs(y, x, self, true);
                return matAlgo12xSfs(y, x, self, true);
            })
    });
});




var $bcfc207c51e62c61$var$name = "forEach";
var $bcfc207c51e62c61$var$dependencies = [
    "typed"
];
var $bcfc207c51e62c61$export$a5218987e0811e05 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($bcfc207c51e62c61$var$name, $bcfc207c51e62c61$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterate over all elements of a matrix/array, and executes the given callback function.
   *
   * Syntax:
   *
   *    math.forEach(x, callback)
   *
   * Examples:
   *
   *    math.forEach([1, 2, 3], function(value) {
   *      console.log(value)
   *    })
   *    // outputs 1, 2, 3
   *
   * See also:
   *
   *    filter, map, sort
   *
   * @param {Matrix | Array} x    The matrix to iterate on.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix/array being traversed.
   */ return typed($bcfc207c51e62c61$var$name, {
        "Array, function": $bcfc207c51e62c61$var$_forEach,
        "Matrix, function": function MatrixFunction(x, callback) {
            x.forEach(callback);
        }
    });
});
/**
 * forEach for a multidimensional array
 * @param {Array} array
 * @param {Function} callback
 * @private
 */ function $bcfc207c51e62c61$var$_forEach(array, callback) {
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) (0, $eee21df0c3527ff1$export$4b80e395e36b5a56)(value, function(child, i) {
            // we create a copy of the index array and append the new index value
            recurse(child, index.concat(i));
        });
        else // invoke the callback function with the right number of arguments
        return (0, $1427f34fc9a7e1b3$export$c081893a7ce04a4c)(callback, value, index, array, "forEach");
    };
    recurse(array, []);
}



var $6f8e46201541c0bb$var$name = "format";
var $6f8e46201541c0bb$var$dependencies = [
    "typed"
];
var $6f8e46201541c0bb$export$abf0d9399b60f9bb = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6f8e46201541c0bb$var$name, $6f8e46201541c0bb$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Format a value of any type into a string.
   *
   * Syntax:
   *
   *    math.format(value)
   *    math.format(value, options)
   *    math.format(value, precision)
   *    math.format(value, callback)
   *
   * Where:
   *
   *  - `value: *`
   *    The value to be formatted
   *  - `options: Object`
   *    An object with formatting options. Available options:
   *    - `notation: string`
   *      Number notation. Choose from:
   *      - `'fixed'`
   *        Always use regular number notation.
   *        For example `'123.40'` and `'14000000'`
   *      - `'exponential'`
   *        Always use exponential notation.
   *        For example `'1.234e+2'` and `'1.4e+7'`
   *      - `'engineering'`
   *        Always use engineering notation: always have exponential notation,
   *        and select the exponent to be a multiple of `3`.
   *        For example `'123.4e+0'` and `'14.0e+6'`
   *      - `'auto'` (default)
   *        Regular number notation for numbers having an absolute value between
   *        `lower` and `upper` bounds, and uses exponential notation elsewhere.
   *        Lower bound is included, upper bound is excluded.
   *        For example `'123.4'` and `'1.4e7'`.
   *      - `'bin'`, `'oct'`, or `'hex'`
   *        Format the number using binary, octal, or hexadecimal notation.
   *        For example `'0b1101'` and `'0x10fe'`.
   *    - `wordSize: number | BigNumber`
   *      The word size in bits to use for formatting in binary, octal, or
   *      hexadecimal notation. To be used only with `'bin'`, `'oct'`, or `'hex'`
   *      values for `notation` option. When this option is defined the value
   *      is formatted as a signed twos complement integer of the given word
   *      size and the size suffix is appended to the output.
   *      For example `format(-1, {notation: 'hex', wordSize: 8}) === '0xffi8'`.
   *      Default value is undefined.
   *    - `precision: number | BigNumber`
   *      Limit the number of digits of the formatted value.
   *      For regular numbers, must be a number between `0` and `16`.
   *      For bignumbers, the maximum depends on the configured precision,
   *      see function `config()`.
   *      In case of notations `'exponential'`, `'engineering'`, and `'auto'`,
   *      `precision` defines the total number of significant digits returned.
   *      In case of notation `'fixed'`, `precision` defines the number of
   *      significant digits after the decimal point.
   *      `precision` is undefined by default.
   *    - `lowerExp: number`
   *      Exponent determining the lower boundary for formatting a value with
   *      an exponent when `notation='auto'`. Default value is `-3`.
   *    - `upperExp: number`
   *      Exponent determining the upper boundary for formatting a value with
   *      an exponent when `notation='auto'`. Default value is `5`.
   *    - `fraction: string`. Available values: `'ratio'` (default) or `'decimal'`.
   *      For example `format(fraction(1, 3))` will output `'1/3'` when `'ratio'`
   *      is configured, and will output `'0.(3)'` when `'decimal'` is configured.
   *    - `truncate: number`. Specifies the maximum allowed length of the
   *      returned string. If it had been longer, the excess characters
   *      are deleted and replaced with `'...'`.
   * - `callback: function`
   *   A custom formatting function, invoked for all numeric elements in `value`,
   *   for example all elements of a matrix, or the real and imaginary
   *   parts of a complex number. This callback can be used to override the
   *   built-in numeric notation with any type of formatting. Function `callback`
   *   is called with `value` as parameter and must return a string.
   *
   * When `value` is an Object:
   *
   * - When the object contains a property `format` being a function, this function
   *   is invoked as `value.format(options)` and the result is returned.
   * - When the object has its own `toString` method, this method is invoked
   *   and the result is returned.
   * - In other cases the function will loop over all object properties and
   *   return JSON object notation like '{"a": 2, "b": 3}'.
   *
   * When value is a function:
   *
   * - When the function has a property `syntax`, it returns this
   *   syntax description.
   * - In other cases, a string `'function'` is returned.
   *
   * Examples:
   *
   *    math.format(6.4)                                        // returns '6.4'
   *    math.format(1240000)                                    // returns '1.24e+6'
   *    math.format(1/3)                                        // returns '0.3333333333333333'
   *    math.format(1/3, 3)                                     // returns '0.333'
   *    math.format(21385, 2)                                   // returns '21000'
   *    math.format(12e8, {notation: 'fixed'})                  // returns '1200000000'
   *    math.format(2.3,  {notation: 'fixed', precision: 4})    // returns '2.3000'
   *    math.format(52.8, {notation: 'exponential'})            // returns '5.28e+1'
   *    math.format(12400, {notation: 'engineering'})           // returns '12.4e+3'
   *    math.format(2000, {lowerExp: -2, upperExp: 2})          // returns '2e+3'
   *
   *    function formatCurrency(value) {
   *      // return currency notation with two digits:
   *      return '$' + value.toFixed(2)
   *
   *      // you could also use math.format inside the callback:
   *      // return '$' + math.format(value, {notation: 'fixed', precision: 2})
   *    }
   *    math.format([2.1, 3, 0.016], formatCurrency)            // returns '[$2.10, $3.00, $0.02]'
   *
   * See also:
   *
   *    print
   *
   * @param {*} value                               Value to be stringified
   * @param {Object | Function | number} [options]  Formatting options
   * @return {string} The formatted value
   */ return typed($6f8e46201541c0bb$var$name, {
        any: (0, $1b038b7ade911d0e$export$d9468344d3651243),
        "any, Object | function | number | BigNumber": (0, $1b038b7ade911d0e$export$d9468344d3651243)
    });
});



var $f8082e8dc393ab0b$var$name = "fraction";
var $f8082e8dc393ab0b$var$dependencies = [
    "typed",
    "Fraction"
];
var $f8082e8dc393ab0b$export$de147ca8498e0312 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f8082e8dc393ab0b$var$name, $f8082e8dc393ab0b$var$dependencies, (_ref)=>{
    var { typed: typed, Fraction: Fraction } = _ref;
    /**
   * Create a fraction or convert a value to a fraction.
   *
   * With one numeric argument, produces the closest rational approximation to the
   * input.
   * With two arguments, the first is the numerator and the second is the denominator,
   * and creates the corresponding fraction. Both numerator and denominator must be
   * integers.
   * With one object argument, looks for the integer numerator as the value of property
   * 'n' and the integer denominator as the value of property 'd'.
   * With a matrix argument, creates a matrix of the same shape with entries
   * converted into fractions.
   *
   * Syntax:
   *     math.fraction(value)
   *     math.fraction(numerator, denominator)
   *     math.fraction({n: numerator, d: denominator})
   *     math.fraction(matrix: Array | Matrix)
   *
   * Examples:
   *
   *     math.fraction(6.283)             // returns Fraction 6283/1000
   *     math.fraction(1, 3)              // returns Fraction 1/3
   *     math.fraction('2/3')             // returns Fraction 2/3
   *     math.fraction({n: 2, d: 3})      // returns Fraction 2/3
   *     math.fraction([0.2, 0.25, 1.25]) // returns Array [1/5, 1/4, 5/4]
   *     math.fraction(4, 5.1)            // throws Error: Parameters must be integer
   *
   * See also:
   *
   *    bignumber, number, string, unit
   *
   * @param {number | string | Fraction | BigNumber | bigint | Unit | Array | Matrix} [args]
   *            Arguments specifying the value, or numerator and denominator of
   *            the fraction
   * @return {Fraction | Array | Matrix} Returns a fraction
   */ return typed("fraction", {
        number: function number(x) {
            if (!isFinite(x) || isNaN(x)) throw new Error(x + " cannot be represented as a fraction");
            return new Fraction(x);
        },
        string: function string(x) {
            return new Fraction(x);
        },
        "number, number": function numberNumber(numerator, denominator) {
            return new Fraction(numerator, denominator);
        },
        null: function _null(x) {
            return new Fraction(0);
        },
        BigNumber: function BigNumber(x) {
            return new Fraction(x.toString());
        },
        bigint: function bigint(x) {
            return new Fraction(x.toString());
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Unit: typed.referToSelf((self)=>(x)=>{
                var clone = x.clone();
                clone.value = self(x.value);
                return clone;
            }),
        Object: function Object(x) {
            return new Fraction(x);
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});



var $aaa48a8cda61b48f$var$name = "Fraction";
var $aaa48a8cda61b48f$var$dependencies = [];
var $aaa48a8cda61b48f$export$c317f082100fca89 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($aaa48a8cda61b48f$var$name, $aaa48a8cda61b48f$var$dependencies, ()=>{
    /**
   * Attach type information
   */ Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports))), "name", {
        value: "Fraction"
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports))).prototype.constructor = (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports)));
    (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports))).prototype.type = "Fraction";
    (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports))).prototype.isFraction = true;
    /**
   * Get a JSON representation of a Fraction containing type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Fraction", "n": 3, "d": 8}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports))).prototype.toJSON = function() {
        return {
            mathjs: "Fraction",
            n: this.s * this.n,
            d: this.d
        };
    };
    /**
   * Instantiate a Fraction from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "Fraction", "n": 3, "d": 8}`
   * @return {BigNumber}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports)))(json);
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($b70f17e3a20fc795$exports));
}, {
    isClass: true
});


var $6c3b824257ddbc95$var$name = "freqz";
var $6c3b824257ddbc95$var$dependencies = [
    "typed",
    "add",
    "multiply",
    "Complex",
    "divide",
    "matrix"
];
var $6c3b824257ddbc95$export$5a5299860d551a36 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6c3b824257ddbc95$var$name, $6c3b824257ddbc95$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, multiply: multiply, Complex: Complex, divide: divide, matrix: matrix } = _ref;
    /**
     * Calculates the frequency response of a filter given its numerator and denominator coefficients.
     *
     * Syntax:
     *    math.freqz(b, a)
     *    math.freqz(b, a, w)
     *
     * Examples:
     *   math.freqz([1, 2], [1, 2, 3], 4) // returns { h: [0.5 + 0i, 0.4768589245763655 + 0.2861153547458193i, 0.25000000000000006 + 0.75i, -0.770976571635189 + 0.4625859429811135i], w: [0, 0.7853981633974483, 1.5707963267948966, 2.356194490192345 ] }
     *   math.freqz([1, 2], [1, 2, 3], [0, 1]) // returns { h: [0.5 + 0i, 0.45436781 + 0.38598051i], w: [0, 1] }
     *
     * See also:
     *  zpk2tf
     *
     * @param {Array.<number>} b The numerator coefficients of the filter.
     * @param {Array.<number>} a The denominator coefficients of the filter.
     * @param {Array.<number>} [w] A vector of frequencies (in radians/sample) at which the frequency response is to be computed or the number of points to compute (if a number is not provided, the default is 512 points)
     * @returns {Object} An object with two properties: h, a vector containing the complex frequency response, and w, a vector containing the normalized frequencies (in radians/sample) at which the response was computed.
     *
     *
     */ return typed($6c3b824257ddbc95$var$name, {
        "Array, Array": function ArrayArray(b, a) {
            var w = createBins(512);
            return _freqz(b, a, w);
        },
        "Array, Array, Array": function ArrayArrayArray(b, a, w) {
            return _freqz(b, a, w);
        },
        "Array, Array, number": function ArrayArrayNumber(b, a, w) {
            if (w < 0) throw new Error("w must be a positive number");
            var w2 = createBins(w);
            return _freqz(b, a, w2);
        },
        "Matrix, Matrix": function MatrixMatrix(b, a) {
            // console.log('here')
            var _w = createBins(512);
            var { w: w, h: h } = _freqz(b.valueOf(), a.valueOf(), _w);
            return {
                w: matrix(w),
                h: matrix(h)
            };
        },
        "Matrix, Matrix, Matrix": function MatrixMatrixMatrix(b, a, w) {
            var { h: h } = _freqz(b.valueOf(), a.valueOf(), w.valueOf());
            return {
                h: matrix(h),
                w: matrix(w)
            };
        },
        "Matrix, Matrix, number": function MatrixMatrixNumber(b, a, w) {
            if (w < 0) throw new Error("w must be a positive number");
            var _w = createBins(w);
            var { h: h } = _freqz(b.valueOf(), a.valueOf(), _w);
            return {
                h: matrix(h),
                w: matrix(_w)
            };
        }
    });
    function _freqz(b, a, w) {
        var num = [];
        var den = [];
        for(var i = 0; i < w.length; i++){
            var sumNum = Complex(0, 0);
            var sumDen = Complex(0, 0);
            for(var j = 0; j < b.length; j++)sumNum = add(sumNum, multiply(b[j], Complex(Math.cos(-j * w[i]), Math.sin(-j * w[i]))));
            for(var _j = 0; _j < a.length; _j++)sumDen = add(sumDen, multiply(a[_j], Complex(Math.cos(-_j * w[i]), Math.sin(-_j * w[i]))));
            num.push(sumNum);
            den.push(sumDen);
        }
        var h = [];
        for(var _i = 0; _i < num.length; _i++)h.push(divide(num[_i], den[_i]));
        return {
            h: h,
            w: w
        };
    }
    function createBins(n) {
        var bins = [];
        for(var i = 0; i < n; i++)bins.push(i / n * Math.PI);
        return bins;
    }
});


/* eslint-disable no-loss-of-precision */ 

function $94a9a68b4672560c$export$da03a9f23c941fae(n) {
    var x;
    if ((0, $a246eb207aab6d09$export$a287f47fed4544b8)(n)) {
        if (n <= 0) return isFinite(n) ? Infinity : NaN;
        if (n > 171) return Infinity; // Will overflow
        return (0, $22c7ec3c40338f55$export$dbd0f18357df1ddd)(1, n - 1);
    }
    if (n < 0.5) return Math.PI / (Math.sin(Math.PI * n) * $94a9a68b4672560c$export$da03a9f23c941fae(1 - n));
    if (n >= 171.35) return Infinity; // will overflow
    if (n > 85.0) {
        // Extended Stirling Approx
        var twoN = n * n;
        var threeN = twoN * n;
        var fourN = threeN * n;
        var fiveN = fourN * n;
        return Math.sqrt(2 * Math.PI / n) * Math.pow(n / Math.E, n) * (1 + 1 / (12 * n) + 1 / (288 * twoN) - 139 / (51840 * threeN) - 571 / (2488320 * fourN) + 163879 / (209018880 * fiveN) + 5246819 / (75246796800 * fiveN * n));
    }
    --n;
    x = $94a9a68b4672560c$export$4ef5d09c80bf8d89[0];
    for(var i = 1; i < $94a9a68b4672560c$export$4ef5d09c80bf8d89.length; ++i)x += $94a9a68b4672560c$export$4ef5d09c80bf8d89[i] / (n + i);
    var t = n + $94a9a68b4672560c$export$c1392abb9fefd3b6 + 0.5;
    return Math.sqrt(2 * Math.PI) * Math.pow(t, n + 0.5) * Math.exp(-t) * x;
}
$94a9a68b4672560c$export$da03a9f23c941fae.signature = "number";
var $94a9a68b4672560c$export$c1392abb9fefd3b6 = 4.7421875;
var $94a9a68b4672560c$export$4ef5d09c80bf8d89 = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.59796035547549,
    14.136097974741747174,
    -0.4919138160976202,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.00009837447530487956,
    0.15808870322491248884e-3,
    -0.00021026444172410488,
    0.21743961811521264320e-3,
    -0.0001643181065367639,
    0.84418223983852743293e-4,
    -0.000026190838401581408,
    0.36899182659531622704e-5
];
var $94a9a68b4672560c$export$6854df5fcb691251 = 0.91893853320467274178;
var $94a9a68b4672560c$export$ec32a260632ccc98 = 5; // Lanczos parameter "g"
var $94a9a68b4672560c$export$e1cadc5b48a02cef = 7; // Range of coefficients "n"
var $94a9a68b4672560c$export$591d8f773e88a995 = [
    1.000000000190015,
    76.18009172947146,
    -86.50532032941678,
    24.01409824083091,
    -1.231739572450155,
    0.1208650973866179e-2,
    -0.000005395239384953
];
function $94a9a68b4672560c$export$a9c1cdc6d03f0efc(n) {
    if (n < 0) return NaN;
    if (n === 0) return Infinity;
    if (!isFinite(n)) return n;
    if (n < 0.5) // Use Euler's reflection formula:
    // gamma(z) = PI / (sin(PI * z) * gamma(1 - z))
    return Math.log(Math.PI / Math.sin(Math.PI * n)) - $94a9a68b4672560c$export$a9c1cdc6d03f0efc(1 - n);
    // Compute the logarithm of the Gamma function using the Lanczos method
    n = n - 1;
    var base = n + $94a9a68b4672560c$export$ec32a260632ccc98 + 0.5; // Base of the Lanczos exponential
    var sum = $94a9a68b4672560c$export$591d8f773e88a995[0];
    // We start with the terms that have the smallest coefficients and largest denominator
    for(var i = $94a9a68b4672560c$export$e1cadc5b48a02cef - 1; i >= 1; i--)sum += $94a9a68b4672560c$export$591d8f773e88a995[i] / (n + i);
    return $94a9a68b4672560c$export$6854df5fcb691251 + (n + 0.5) * Math.log(base) - base + Math.log(sum);
}
$94a9a68b4672560c$export$a9c1cdc6d03f0efc.signature = "number";


var $39088a69841814d3$var$name = "gamma";
var $39088a69841814d3$var$dependencies = [
    "typed",
    "config",
    "multiplyScalar",
    "pow",
    "BigNumber",
    "Complex"
];
var $39088a69841814d3$export$115da31fc3cf3d15 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($39088a69841814d3$var$name, $39088a69841814d3$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, pow: pow, BigNumber: _BigNumber, Complex: Complex } = _ref;
    /**
   * Compute the gamma function of a value using Lanczos approximation for
   * small values, and an extended Stirling approximation for large values.
   *
   * To avoid confusion with the matrix Gamma function, this function does
   * not apply to matrices.
   *
   * Syntax:
   *
   *    math.gamma(n)
   *
   * Examples:
   *
   *    math.gamma(5)       // returns 24
   *    math.gamma(-0.5)    // returns -3.5449077018110335
   *    math.gamma(math.i)  // returns -0.15494982830180973 - 0.49801566811835596i
   *
   * See also:
   *
   *    combinations, factorial, permutations
   *
   * @param {number | BigNumber | Complex} n   A real or complex number
   * @return {number | BigNumber | Complex}    The gamma of `n`
   */ function gammaComplex(n) {
        if (n.im === 0) return (0, $94a9a68b4672560c$export$da03a9f23c941fae)(n.re);
        // Lanczos approximation doesn't work well with real part lower than 0.5
        // So reflection formula is required
        if (n.re < 0.5) {
            // Euler's reflection formula
            // gamma(1-z) * gamma(z) = PI / sin(PI * z)
            // real part of Z should not be integer [sin(PI) == 0 -> 1/0 - undefined]
            // thanks to imperfect sin implementation sin(PI * n) != 0
            // we can safely use it anyway
            var _t = new Complex(1 - n.re, -n.im);
            var r = new Complex(Math.PI * n.re, Math.PI * n.im);
            return new Complex(Math.PI).div(r.sin()).div(gammaComplex(_t));
        }
        // Lanczos approximation
        // z -= 1
        n = new Complex(n.re - 1, n.im);
        // x = gammaPval[0]
        var x = new Complex((0, $94a9a68b4672560c$export$4ef5d09c80bf8d89)[0], 0);
        // for (i, gammaPval) in enumerate(gammaP):
        for(var i = 1; i < (0, $94a9a68b4672560c$export$4ef5d09c80bf8d89).length; ++i){
            // x += gammaPval / (z + i)
            var gammaPval = new Complex((0, $94a9a68b4672560c$export$4ef5d09c80bf8d89)[i], 0);
            x = x.add(gammaPval.div(n.add(i)));
        }
        // t = z + gammaG + 0.5
        var t = new Complex(n.re + (0, $94a9a68b4672560c$export$c1392abb9fefd3b6) + 0.5, n.im);
        // y = sqrt(2 * pi) * t ** (z + 0.5) * exp(-t) * x
        var twoPiSqrt = Math.sqrt(2 * Math.PI);
        var tpow = t.pow(n.add(0.5));
        var expt = t.neg().exp();
        // y = [x] * [sqrt(2 * pi)] * [t ** (z + 0.5)] * [exp(-t)]
        return x.mul(twoPiSqrt).mul(tpow).mul(expt);
    }
    return typed($39088a69841814d3$var$name, {
        number: (0, $94a9a68b4672560c$export$da03a9f23c941fae),
        Complex: gammaComplex,
        BigNumber: function BigNumber(n) {
            if (n.isInteger()) return n.isNegative() || n.isZero() ? new _BigNumber(Infinity) : bigFactorial(n.minus(1));
            if (!n.isFinite()) return new _BigNumber(n.isNegative() ? NaN : Infinity);
            throw new Error("Integer BigNumber expected");
        }
    });
    /**
   * Calculate factorial for a BigNumber
   * @param {BigNumber} n
   * @returns {BigNumber} Returns the factorial of n
   */ function bigFactorial(n) {
        if (n < 8) return new _BigNumber([
            1,
            1,
            2,
            6,
            24,
            120,
            720,
            5040
        ][n]);
        var precision = config.precision + (Math.log(n.toNumber()) | 0);
        var Big = _BigNumber.clone({
            precision: precision
        });
        if (n % 2 === 1) return n.times(bigFactorial(new _BigNumber(n - 1)));
        var p = n;
        var prod = new Big(n);
        var sum = n.toNumber();
        while(p > 2){
            p -= 2;
            sum += p;
            prod = prod.times(sum);
        }
        return new _BigNumber(prod.toPrecision(_BigNumber.precision));
    }
});











var $a24b06a4ef896914$var$name = "mod";
var $a24b06a4ef896914$var$dependencies = [
    "typed",
    "config",
    "round",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix",
    "concat"
];
var $a24b06a4ef896914$export$735bb6c30160c058 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a24b06a4ef896914$var$name, $a24b06a4ef896914$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var floor = (0, $6bb08bcefc55a9f9$export$e04e4803a9128c9b)({
        typed: typed,
        config: config,
        round: round,
        matrix: matrix,
        equalScalar: equalScalar,
        zeros: zeros,
        DenseMatrix: DenseMatrix
    });
    var matAlgo02xDS0 = (0, $94e325bf4fc92f8c$export$32ae34d6563cd126)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo05xSfSf = (0, $a54f9597be0f9a42$export$a0ee15a3591ad1a)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Calculates the modulus, the remainder of an integer division.
   *
   * For matrices, the function is evaluated element wise.
   *
   * The modulus is defined as:
   *
   *     x - y * floor(x / y)
   *
   * See https://en.wikipedia.org/wiki/Modulo_operation.
   *
   * Syntax:
   *
   *    math.mod(x, y)
   *
   * Examples:
   *
   *    math.mod(8, 3)                // returns 2
   *    math.mod(11, 2)               // returns 1
   *
   *    function isOdd(x) {
   *      return math.mod(x, 2) != 0
   *    }
   *
   *    isOdd(2)                      // returns false
   *    isOdd(3)                      // returns true
   *
   * See also:
   *
   *    divide
   *
   * @param  {number | BigNumber | bigint | Fraction | Array | Matrix} x Dividend
   * @param  {number | BigNumber | bigint | Fraction | Array | Matrix} y Divisor
   * @return {number | BigNumber | bigint | Fraction | Array | Matrix} Returns the remainder of `x` divided by `y`.
   */ return typed($a24b06a4ef896914$var$name, {
        "number, number": _modNumber,
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return y.isZero() ? x : x.sub(y.mul(floor(x.div(y))));
        },
        "bigint, bigint": function bigintBigint(x, y) {
            if (y === 0n) return x;
            if (x < 0) {
                var m = x % y;
                return m === 0n ? m : m + y;
            }
            return x % y;
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return y.equals(0) ? x : x.sub(y.mul(floor(x.div(y))));
        }
    }, matrixAlgorithmSuite({
        SS: matAlgo05xSfSf,
        DS: matAlgo03xDSf,
        SD: matAlgo02xDS0,
        Ss: matAlgo11xS0s,
        sS: matAlgo12xSfs
    }));
    /**
  * Calculate the modulus of two numbers
  * @param {number} x
  * @param {number} y
  * @returns {number} res
  * @private
  */ function _modNumber(x, y) {
        // We don't use JavaScript's % operator here as this doesn't work
        // correctly for x < 0 and x === 0
        // see https://en.wikipedia.org/wiki/Modulo_operation
        // We use mathjs floor to handle errors associated with
        // precision float approximation
        return y === 0 ? x : x - y * floor(x / y);
    }
});






/**
 * Create a syntax error with the message:
 *     'Wrong number of arguments in function <fn> (<count> provided, <min>-<max> expected)'
 * @param {string} fn     Function name
 * @param {number} count  Actual argument count
 * @param {number} min    Minimum required argument count
 * @param {number} [max]  Maximum required argument count
 * @extends Error
 */ function $3530305357b9cbe9$export$f27c2c74ddc37d80(fn, count, min, max) {
    if (!(this instanceof $3530305357b9cbe9$export$f27c2c74ddc37d80)) throw new SyntaxError("Constructor must be called with the new operator");
    this.fn = fn;
    this.count = count;
    this.min = min;
    this.max = max;
    this.message = "Wrong number of arguments in function " + fn + " (" + count + " provided, " + min + (max !== undefined && max !== null ? "-" + max : "") + " expected)";
    this.stack = new Error().stack;
}
$3530305357b9cbe9$export$f27c2c74ddc37d80.prototype = new Error();
$3530305357b9cbe9$export$f27c2c74ddc37d80.prototype.constructor = Error;
$3530305357b9cbe9$export$f27c2c74ddc37d80.prototype.name = "ArgumentsError";
$3530305357b9cbe9$export$f27c2c74ddc37d80.prototype.isArgumentsError = true;


var $6af12ac22a20b8f9$var$name = "gcd";
var $6af12ac22a20b8f9$var$dependencies = [
    "typed",
    "config",
    "round",
    "matrix",
    "equalScalar",
    "zeros",
    "BigNumber",
    "DenseMatrix",
    "concat"
];
var $6af12ac22a20b8f9$var$gcdTypes = "number | BigNumber | Fraction | Matrix | Array";
var $6af12ac22a20b8f9$var$gcdManyTypesSignature = "".concat($6af12ac22a20b8f9$var$gcdTypes, ", ").concat($6af12ac22a20b8f9$var$gcdTypes, ", ...").concat($6af12ac22a20b8f9$var$gcdTypes);
function $6af12ac22a20b8f9$var$is1d(array) {
    return !array.some((element)=>Array.isArray(element));
}
var $6af12ac22a20b8f9$export$2eb8acc96c598512 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6af12ac22a20b8f9$var$name, $6af12ac22a20b8f9$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, config: config, round: round, equalScalar: equalScalar, zeros: zeros, BigNumber: BigNumber, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var mod = (0, $a24b06a4ef896914$export$735bb6c30160c058)({
        typed: typed,
        config: config,
        round: round,
        matrix: matrix,
        equalScalar: equalScalar,
        zeros: zeros,
        DenseMatrix: DenseMatrix,
        concat: concat
    });
    var matAlgo01xDSid = (0, $a0c1a11a7836c6b2$export$727ab96f88a9e651)({
        typed: typed
    });
    var matAlgo04xSidSid = (0, $64a06aca87feb287$export$1dd33d839e34f63c)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $00357ab6509f98c8$export$5295edae9a41ff00)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Calculate the greatest common divisor for two or more values or arrays.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gcd(a, b)
   *    math.gcd(a, b, c, ...)
   *
   * Examples:
   *
   *    math.gcd(8, 12)              // returns 4
   *    math.gcd(-4, 6)              // returns 2
   *    math.gcd(25, 15, -10)        // returns 5
   *
   *    math.gcd([8, -4], [12, 6])   // returns [4, 2]
   *
   * See also:
   *
   *    lcm, xgcd
   *
   * @param {... number | BigNumber | Fraction | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Fraction | Array | Matrix}                           The greatest common divisor
   */ return typed($6af12ac22a20b8f9$var$name, {
        "number, number": _gcdNumber,
        "BigNumber, BigNumber": _gcdBigNumber,
        "Fraction, Fraction": (x, y)=>x.gcd(y)
    }, matrixAlgorithmSuite({
        SS: matAlgo04xSidSid,
        DS: matAlgo01xDSid,
        Ss: matAlgo10xSids
    }), {
        [$6af12ac22a20b8f9$var$gcdManyTypesSignature]: typed.referToSelf((self)=>(a, b, args)=>{
                var res = self(a, b);
                for(var i = 0; i < args.length; i++)res = self(res, args[i]);
                return res;
            }),
        Array: typed.referToSelf((self)=>(array)=>{
                if (array.length === 1 && Array.isArray(array[0]) && $6af12ac22a20b8f9$var$is1d(array[0])) return self(...array[0]);
                if ($6af12ac22a20b8f9$var$is1d(array)) return self(...array);
                throw new (0, $3530305357b9cbe9$export$f27c2c74ddc37d80)("gcd() supports only 1d matrices!");
            }),
        Matrix: typed.referToSelf((self)=>(matrix)=>{
                return self(matrix.toArray());
            })
    });
    /**
  * Calculate gcd for numbers
  * @param {number} a
  * @param {number} b
  * @returns {number} Returns the greatest common denominator of a and b
  * @private
  */ function _gcdNumber(a, b) {
        if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(a) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(b)) throw new Error("Parameters in function gcd must be integer numbers");
        // https://en.wikipedia.org/wiki/Euclidean_algorithm
        var r;
        while(b !== 0){
            r = mod(a, b);
            a = b;
            b = r;
        }
        return a < 0 ? -a : a;
    }
    /**
   * Calculate gcd for BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns greatest common denominator of a and b
   * @private
   */ function _gcdBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function gcd must be integer numbers");
        // https://en.wikipedia.org/wiki/Euclidean_algorithm
        var zero = new BigNumber(0);
        while(!b.isZero()){
            var r = mod(a, b);
            a = b;
            b = r;
        }
        return a.lt(zero) ? a.neg() : a;
    }
});




var $325d73579104a7e7$var$name = "getMatrixDataType";
var $325d73579104a7e7$var$dependencies = [
    "typed"
];
var $325d73579104a7e7$export$b83055c9a38abe3c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($325d73579104a7e7$var$name, $325d73579104a7e7$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Find the data type of all elements in a matrix or array,
   * for example 'number' if all items are a number and 'Complex' if all values
   * are complex numbers.
   * If a matrix contains more than one data type, it will return 'mixed'.
   *
   * Syntax:
   *
   *    math.getMatrixDataType(x)
   *
   * Examples:
   *
   *    const x = [ [1, 2, 3], [4, 5, 6] ]
   *    const mixedX = [ [1, true], [2, 3] ]
   *    const fractionX = [ [math.fraction(1, 3)], [math.fraction(1, 3)] ]
   *    const unitX = [ [math.unit('5cm')], [math.unit('5cm')] ]
   *    const bigNumberX = [ [math.bignumber(1)], [math.bignumber(0)] ]
   *    const sparse = math.sparse(x)
   *    const dense = math.matrix(x)
   *    math.getMatrixDataType(x)   // returns 'number'
   *    math.getMatrixDataType(sparse)   // returns 'number'
   *    math.getMatrixDataType(dense)   // returns 'number'
   *    math.getMatrixDataType(mixedX) // returns 'mixed'
   *    math.getMatrixDataType(fractionX) // returns 'Fraction'
   *    math.getMatrixDataType(unitX) // returns 'Unit'
   *    math.getMatrixDataType(bigNumberX) // return 'BigNumber'
   *
   * See also:
   *  SparseMatrix, DenseMatrix
   *
   * @param {...Matrix | Array} x   The Matrix with values.
   *
   * @return {string} A string representation of the matrix type
   */ return typed($325d73579104a7e7$var$name, {
        Array: function Array(x) {
            return (0, $eee21df0c3527ff1$export$d31e00bf4359ea8b)(x, (0, $23cfe017d190638f$export$f5bbd400c2f4426f));
        },
        Matrix: function Matrix(x) {
            return x.getDataType();
        }
    });
});


var $b0eec8101f607af7$var$name = "hasNumericValue";
var $b0eec8101f607af7$var$dependencies = [
    "typed",
    "isNumeric"
];
var $b0eec8101f607af7$export$acff9f91b891ace6 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b0eec8101f607af7$var$name, $b0eec8101f607af7$var$dependencies, (_ref)=>{
    var { typed: typed, isNumeric: isNumeric } = _ref;
    /**
   * Test whether a value is an numeric value.
   *
   * In case of a string, true is returned if the string contains a numeric value.
   *
   * Syntax:
   *
   *     math.hasNumericValue(x)
   *
   * Examples:
   *
   *    math.hasNumericValue(2)                     // returns true
   *    math.hasNumericValue('2')                   // returns true
   *    math.isNumeric('2')                         // returns false
   *    math.hasNumericValue(0)                     // returns true
   *    math.hasNumericValue(math.bignumber('500')) // returns true
   *    math.hasNumericValue(math.bigint('42'))     // returns true
   *    math.hasNumericValue(42n)                   // returns true
   *    math.hasNumericValue(math.fraction(4))      // returns true
   *    math.hasNumericValue(math.complex('2-4i'))  // returns false
   *    math.hasNumericValue(false)                 // returns true
   *    math.hasNumericValue([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, isNumeric
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, `Boolean`, or a `String` containing number. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($b0eec8101f607af7$var$name, {
        boolean: ()=>true,
        string: function string(x) {
            return x.trim().length > 0 && !isNaN(Number(x));
        },
        any: function any(x) {
            return isNumeric(x);
        }
    });
});


var $a323eeecc705dabc$var$name = "hex";
var $a323eeecc705dabc$var$dependencies = [
    "typed",
    "format"
];
var $a323eeecc705dabc$export$9cafd9970d25a17c = (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a323eeecc705dabc$var$name, $a323eeecc705dabc$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($a323eeecc705dabc$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            return format(n, {
                notation: "hex"
            });
        },
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, wordSize) {
            return format(n, {
                notation: "hex",
                wordSize: wordSize
            });
        }
    });
});




var $444c0a26caa42504$var$name = "hypot";
var $444c0a26caa42504$var$dependencies = [
    "typed",
    "abs",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "sqrt",
    "smaller",
    "isPositive"
];
var $444c0a26caa42504$export$87e3687740a09cb = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($444c0a26caa42504$var$name, $444c0a26caa42504$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, sqrt: sqrt, smaller: smaller, isPositive: isPositive } = _ref;
    /**
   * Calculate the hypotenusa of a list with values. The hypotenusa is defined as:
   *
   *     hypot(a, b, c, ...) = sqrt(a^2 + b^2 + c^2 + ...)
   *
   * For matrix input, the hypotenusa is calculated for all values in the matrix.
   *
   * Syntax:
   *
   *     math.hypot(a, b, ...)
   *     math.hypot([a, b, c, ...])
   *
   * Examples:
   *
   *     math.hypot(3, 4)      // 5
   *     math.hypot(3, 4, 5)   // 7.0710678118654755
   *     math.hypot([3, 4, 5]) // 7.0710678118654755
   *     math.hypot(-2)        // 2
   *
   * See also:
   *
   *     abs, norm
   *
   * @param {... number | BigNumber | Array | Matrix} args    A list with numeric values or an Array or Matrix.
   *                                                          Matrix and Array input is flattened and returns a
   *                                                          single number for the whole matrix.
   * @return {number | BigNumber} Returns the hypothenusa of the input values.
   */ return typed($444c0a26caa42504$var$name, {
        "... number | BigNumber": _hypot,
        Array: _hypot,
        Matrix: (M)=>_hypot((0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(M.toArray()))
    });
    /**
   * Calculate the hypotenusa for an Array with values
   * @param {Array.<number | BigNumber>} args
   * @return {number | BigNumber} Returns the result
   * @private
   */ function _hypot(args) {
        // code based on `hypot` from es6-shim:
        // https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L1619-L1633
        var result = 0;
        var largest = 0;
        for(var i = 0; i < args.length; i++){
            if ((0, $23cfe017d190638f$export$8849a896711efe0c)(args[i])) throw new TypeError("Unexpected type of argument to hypot");
            var value = abs(args[i]);
            if (smaller(largest, value)) {
                result = multiplyScalar(result, multiplyScalar(divideScalar(largest, value), divideScalar(largest, value)));
                result = addScalar(result, 1);
                largest = value;
            } else result = addScalar(result, isPositive(value) ? multiplyScalar(divideScalar(value, largest), divideScalar(value, largest)) : value);
        }
        return multiplyScalar(largest, sqrt(result));
    }
});





var $62af8e9daee85a4d$var$name = "identity";
var $62af8e9daee85a4d$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber",
    "DenseMatrix",
    "SparseMatrix"
];
var $62af8e9daee85a4d$export$2eca89e9ac669625 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($62af8e9daee85a4d$var$name, $62af8e9daee85a4d$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a 2-dimensional identity matrix with size m x n or n x n.
   * The matrix has ones on the diagonal and zeros elsewhere.
   *
   * Syntax:
   *
   *    math.identity(n)
   *    math.identity(n, format)
   *    math.identity(m, n)
   *    math.identity(m, n, format)
   *    math.identity([m, n])
   *    math.identity([m, n], format)
   *
   * Examples:
   *
   *    math.identity(3)                    // returns [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
   *    math.identity(3, 2)                 // returns [[1, 0], [0, 1], [0, 0]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.identity(math.size(A))         // returns [[1, 0, 0], [0, 1, 0]]
   *
   * See also:
   *
   *    diag, ones, zeros, size, range
   *
   * @param {...number | Matrix | Array} size   The size for the matrix
   * @param {string} [format]                   The Matrix storage format
   *
   * @return {Matrix | Array | number} A matrix with ones on the diagonal.
   */ return typed($62af8e9daee85a4d$var$name, {
        "": function _() {
            return config.matrix === "Matrix" ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        "number | BigNumber": function numberBigNumber(rows) {
            return _identity(rows, rows, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber, string": function numberBigNumberString(rows, format) {
            return _identity(rows, rows, format);
        },
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(rows, cols) {
            return _identity(rows, cols, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber, number | BigNumber, string": function numberBigNumberNumberBigNumberString(rows, cols, format) {
            return _identity(rows, cols, format);
        },
        Array: function Array(size) {
            return _identityVector(size);
        },
        "Array, string": function ArrayString(size, format) {
            return _identityVector(size, format);
        },
        Matrix: function Matrix(size) {
            return _identityVector(size.valueOf(), size.storage());
        },
        "Matrix, string": function MatrixString(size, format) {
            return _identityVector(size.valueOf(), format);
        }
    });
    function _identityVector(size, format) {
        switch(size.length){
            case 0:
                return format ? matrix(format) : [];
            case 1:
                return _identity(size[0], size[0], format);
            case 2:
                return _identity(size[0], size[1], format);
            default:
                throw new Error("Vector containing two values expected");
        }
    }
    /**
   * Create an identity matrix
   * @param {number | BigNumber} rows
   * @param {number | BigNumber} cols
   * @param {string} [format]
   * @returns {Matrix}
   * @private
   */ function _identity(rows, cols, format) {
        // BigNumber constructor with the right precision
        var Big = (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(rows) || (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(cols) ? BigNumber : null;
        if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(rows)) rows = rows.toNumber();
        if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(cols)) cols = cols.toNumber();
        if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(rows) || rows < 1) throw new Error("Parameters in function identity must be positive integers");
        if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(cols) || cols < 1) throw new Error("Parameters in function identity must be positive integers");
        var one = Big ? new BigNumber(1) : 1;
        var defaultValue = Big ? new Big(0) : 0;
        var size = [
            rows,
            cols
        ];
        // check we need to return a matrix
        if (format) {
            // create diagonal matrix (use optimized implementation for storage format)
            if (format === "sparse") return SparseMatrix.diagonal(size, one, 0, defaultValue);
            if (format === "dense") return DenseMatrix.diagonal(size, one, 0, defaultValue);
            throw new TypeError('Unknown matrix type "'.concat(format, '"'));
        }
        // create and resize array
        var res = (0, $eee21df0c3527ff1$export$4380c87abf28fdf)([], size, defaultValue);
        // fill in ones on the diagonal
        var minimum = rows < cols ? rows : cols;
        // fill diagonal
        for(var d = 0; d < minimum; d++)res[d][d] = one;
        return res;
    }
});




var $92817f2759acbcf2$var$name = "ifft";
var $92817f2759acbcf2$var$dependencies = [
    "typed",
    "fft",
    "dotDivide",
    "conj"
];
var $92817f2759acbcf2$export$fb893320704d694a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($92817f2759acbcf2$var$name, $92817f2759acbcf2$var$dependencies, (_ref)=>{
    var { typed: typed, fft: fft, dotDivide: dotDivide, conj: conj } = _ref;
    /**
   * Calculate N-dimensional inverse fourier transform
   *
   * Syntax:
   *
   *     math.ifft(arr)
   *
   * Examples:
   *
   *    math.ifft([[2, 2], [0, 0]]) // returns [[{re:1, im:0}, {re:0, im:0}], [{re:1, im:0}, {re:0, im:0}]]
   *
   * See Also:
   *
   *      fft
   *
   * @param {Array | Matrix} arr    An array or matrix
   * @return {Array | Matrix}       N-dimensional fourier transformation of the array
   */ return typed($92817f2759acbcf2$var$name, {
        "Array | Matrix": function ArrayMatrix(arr) {
            var size = (0, $23cfe017d190638f$export$b22160e0a14f87b7)(arr) ? arr.size() : (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(arr);
            return dotDivide(conj(fft(conj(arr))), size.reduce((acc, curr)=>acc * curr, 1));
        }
    });
});



var $c48de93c8b059d6e$var$name = "im";
var $c48de93c8b059d6e$var$dependencies = [
    "typed"
];
var $c48de93c8b059d6e$export$47dfdf308b91581 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c48de93c8b059d6e$var$name, $c48de93c8b059d6e$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Get the imaginary part of a complex number.
   * For a complex number `a + bi`, the function returns `b`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.im(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number -5.2
   *    math.re(math.complex(2.4))     // returns number 0
   *
   * See also:
   *
   *    re, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The imaginary part of x
   */ return typed($c48de93c8b059d6e$var$name, {
        number: ()=>0,
        "BigNumber | Fraction": (x)=>x.mul(0),
        Complex: (x)=>x.im,
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});




var $e60d683b6bdd8a35$var$name = "ImmutableDenseMatrix";
var $e60d683b6bdd8a35$var$dependencies = [
    "smaller",
    "DenseMatrix"
];
var $e60d683b6bdd8a35$export$49a565643b9ab608 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e60d683b6bdd8a35$var$name, $e60d683b6bdd8a35$var$dependencies, (_ref)=>{
    var { smaller: smaller, DenseMatrix: DenseMatrix } = _ref;
    function ImmutableDenseMatrix(data, datatype) {
        if (!(this instanceof ImmutableDenseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $23cfe017d190638f$export$844ec244b1367d54)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(data) || (0, $23cfe017d190638f$export$43bee75e5e14138e)(data)) {
            // use DenseMatrix implementation
            var matrix = new DenseMatrix(data, datatype);
            // internal structures
            this._data = matrix._data;
            this._size = matrix._size;
            this._datatype = matrix._datatype;
            this._min = null;
            this._max = null;
        } else if (data && (0, $23cfe017d190638f$export$43bee75e5e14138e)(data.data) && (0, $23cfe017d190638f$export$43bee75e5e14138e)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size;
            this._datatype = data.datatype;
            this._min = typeof data.min !== "undefined" ? data.min : null;
            this._max = typeof data.max !== "undefined" ? data.max : null;
        } else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(data) + ")");
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
            this._min = null;
            this._max = null;
        }
    }
    ImmutableDenseMatrix.prototype = new DenseMatrix();
    /**
   * Attach type information
   */ ImmutableDenseMatrix.prototype.type = "ImmutableDenseMatrix";
    ImmutableDenseMatrix.prototype.isImmutableDenseMatrix = true;
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | ImmutableDenseMatrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ ImmutableDenseMatrix.prototype.subset = function(index) {
        switch(arguments.length){
            case 1:
                // use base implementation
                var m = DenseMatrix.prototype.subset.call(this, index);
                // check result is a matrix
                if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(m)) // return immutable matrix
                return new ImmutableDenseMatrix({
                    data: m._data,
                    size: m._size,
                    datatype: m._datatype
                });
                return m;
            // intentional fall through
            case 2:
            case 3:
                throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    /**
   * Replace a single element in the matrix.
   * @param {Number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {ImmutableDenseMatrix} self
   */ ImmutableDenseMatrix.prototype.set = function() {
        throw new Error("Cannot invoke set on an Immutable Matrix instance");
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {Number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ ImmutableDenseMatrix.prototype.resize = function() {
        throw new Error("Cannot invoke resize on an Immutable Matrix instance");
    };
    /**
   * Disallows reshaping in favor of immutability.
   *
   * @throws {Error} Operation not allowed
   */ ImmutableDenseMatrix.prototype.reshape = function() {
        throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
    };
    /**
   * Create a clone of the matrix
   * @return {ImmutableDenseMatrix} clone
   */ ImmutableDenseMatrix.prototype.clone = function() {
        return new ImmutableDenseMatrix({
            data: (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this._data),
            size: (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this._size),
            datatype: this._datatype
        });
    };
    /**
   * Get a JSON representation of the matrix
   * @returns {Object}
   */ ImmutableDenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "ImmutableDenseMatrix",
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Generate a matrix from a JSON object
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ImmutableDenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {ImmutableDenseMatrix}
   */ ImmutableDenseMatrix.fromJSON = function(json) {
        return new ImmutableDenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @param {Number} i       Matrix row index 1
   * @param {Number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ ImmutableDenseMatrix.prototype.swapRows = function() {
        throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
    };
    /**
   * Calculate the minimum value in the set
   * @return {Number | undefined} min
   */ ImmutableDenseMatrix.prototype.min = function() {
        // check min has been calculated before
        if (this._min === null) {
            // minimum
            var m = null;
            // compute min
            this.forEach(function(v) {
                if (m === null || smaller(v, m)) m = v;
            });
            this._min = m !== null ? m : undefined;
        }
        return this._min;
    };
    /**
   * Calculate the maximum value in the set
   * @return {Number | undefined} max
   */ ImmutableDenseMatrix.prototype.max = function() {
        // check max has been calculated before
        if (this._max === null) {
            // maximum
            var m = null;
            // compute max
            this.forEach(function(v) {
                if (m === null || smaller(m, v)) m = v;
            });
            this._max = m !== null ? m : undefined;
        }
        return this._max;
    };
    return ImmutableDenseMatrix;
}, {
    isClass: true
});



var $7cdf6cdabd5d9d7f$var$name = "index";
var $7cdf6cdabd5d9d7f$var$dependencies = [
    "typed",
    "Index"
];
var $7cdf6cdabd5d9d7f$export$c6d108d7c8095f19 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($7cdf6cdabd5d9d7f$var$name, $7cdf6cdabd5d9d7f$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index } = _ref;
    /**
   * Create an index. An Index can store ranges having start, step, and end
   * for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Syntax:
   *
   *     math.index(range1, range2, ...)
   *
   * Where each range can be any of:
   *
   * - A number
   * - A string for getting/setting an object property
   * - An instance of `Range`
   * - A one-dimensional Array or a Matrix with numbers or booleans
   *
   * Indexes must be zero-based, integer numbers.
   *
   * Examples:
   *
   *    const b = [1, 2, 3, 4, 5]
   *    math.subset(b, math.index([1, 2, 3]))                         // returns [2, 3, 4]
   *    math.subset(b, math.index([false, true, true, true, false]))  // returns [2, 3, 4]
   *
   *    const a = math.matrix([[1, 2], [3, 4]])
   *    a.subset(math.index(0, 1))             // returns 2
   *    a.subset(math.index(0, [false, true])) // returns 2
   *
   * See also:
   *
   *    bignumber, boolean, complex, matrix, number, string, unit
   *
   * @param {...*} ranges   Zero or more ranges or numbers.
   * @return {Index}        Returns the created index
   */ return typed($7cdf6cdabd5d9d7f$var$name, {
        "...number | string | BigNumber | Range | Array | Matrix": function numberStringBigNumberRangeArrayMatrix(args) {
            var ranges = args.map(function(arg) {
                if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(arg)) return arg.toNumber(); // convert BigNumber to Number
                else if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(arg) || (0, $23cfe017d190638f$export$b22160e0a14f87b7)(arg)) return arg.map(function(elem) {
                    // convert BigNumber to Number
                    return (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(elem) ? elem.toNumber() : elem;
                });
                else return arg;
            });
            var res = new Index();
            Index.apply(res, ranges);
            return res;
        }
    });
});





var $e40593440b241175$var$name = "Index";
var $e40593440b241175$var$dependencies = [
    "ImmutableDenseMatrix",
    "getMatrixDataType"
];
var $e40593440b241175$export$300720b4fe34e62e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e40593440b241175$var$name, $e40593440b241175$var$dependencies, (_ref)=>{
    var { ImmutableDenseMatrix: ImmutableDenseMatrix, getMatrixDataType: getMatrixDataType } = _ref;
    /**
   * Create an index. An Index can store ranges and sets for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Usage:
   *     const index = new Index(range1, range2, matrix1, array1, ...)
   *
   * Where each parameter can be any of:
   *     A number
   *     A string (containing a name of an object property)
   *     An instance of Range
   *     An Array with the Set values
   *     An Array with Booleans
   *     A Matrix with the Set values
   *     A Matrix with Booleans
   *
   * The parameters start, end, and step must be integer numbers.
   *
   * @class Index
   * @Constructor Index
   * @param {...*} ranges
   */ function Index(ranges) {
        if (!(this instanceof Index)) throw new SyntaxError("Constructor must be called with the new operator");
        this._dimensions = [];
        this._sourceSize = [];
        this._isScalar = true;
        for(var i = 0, ii = arguments.length; i < ii; i++){
            var arg = arguments[i];
            var argIsArray = (0, $23cfe017d190638f$export$43bee75e5e14138e)(arg);
            var argIsMatrix = (0, $23cfe017d190638f$export$b22160e0a14f87b7)(arg);
            var sourceSize = null;
            if ((0, $23cfe017d190638f$export$e331ccfa6f694c99)(arg)) {
                this._dimensions.push(arg);
                this._isScalar = false;
            } else if (argIsArray || argIsMatrix) {
                // create matrix
                var m = void 0;
                if (getMatrixDataType(arg) === "boolean") {
                    if (argIsArray) m = _createImmutableMatrix($e40593440b241175$var$_booleansArrayToNumbersForIndex(arg).valueOf());
                    if (argIsMatrix) m = _createImmutableMatrix($e40593440b241175$var$_booleansArrayToNumbersForIndex(arg._data).valueOf());
                    sourceSize = arg.valueOf().length;
                } else m = _createImmutableMatrix(arg.valueOf());
                this._dimensions.push(m);
                // size
                var size = m.size();
                // scalar
                if (size.length !== 1 || size[0] !== 1 || sourceSize !== null) this._isScalar = false;
            } else if (typeof arg === "number") this._dimensions.push(_createImmutableMatrix([
                arg
            ]));
            else if (typeof arg === "string") // object property (arguments.count should be 1)
            this._dimensions.push(arg);
            else throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
            this._sourceSize.push(sourceSize);
        // TODO: implement support for wildcard '*'
        }
    }
    /**
   * Attach type information
   */ Index.prototype.type = "Index";
    Index.prototype.isIndex = true;
    function _createImmutableMatrix(arg) {
        // loop array elements
        for(var i = 0, l = arg.length; i < l; i++){
            if (typeof arg[i] !== "number" || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(arg[i])) throw new TypeError("Index parameters must be positive integer numbers");
        }
        // create matrix
        return new ImmutableDenseMatrix(arg);
    }
    /**
   * Create a clone of the index
   * @memberof Index
   * @return {Index} clone
   */ Index.prototype.clone = function() {
        var index = new Index();
        index._dimensions = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this._dimensions);
        index._isScalar = this._isScalar;
        index._sourceSize = this._sourceSize;
        return index;
    };
    /**
   * Create an index from an array with ranges/numbers
   * @memberof Index
   * @param {Array.<Array | number>} ranges
   * @return {Index} index
   * @private
   */ Index.create = function(ranges) {
        var index = new Index();
        Index.apply(index, ranges);
        return index;
    };
    /**
   * Retrieve the size of the index, the number of elements for each dimension.
   * @memberof Index
   * @returns {number[]} size
   */ Index.prototype.size = function() {
        var size = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var d = this._dimensions[i];
            size[i] = typeof d === "string" ? 1 : d.size()[0];
        }
        return size;
    };
    /**
   * Get the maximum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} max
   */ Index.prototype.max = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === "string" ? range : range.max();
        }
        return values;
    };
    /**
   * Get the minimum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} min
   */ Index.prototype.min = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === "string" ? range : range.min();
        }
        return values;
    };
    /**
   * Loop over each of the ranges of the index
   * @memberof Index
   * @param {Function} callback   Called for each range with a Range as first
   *                              argument, the dimension as second, and the
   *                              index object as third.
   */ Index.prototype.forEach = function(callback) {
        for(var i = 0, ii = this._dimensions.length; i < ii; i++)callback(this._dimensions[i], i, this);
    };
    /**
   * Retrieve the dimension for the given index
   * @memberof Index
   * @param {Number} dim                  Number of the dimension
   * @returns {Range | null} range
   */ Index.prototype.dimension = function(dim) {
        return this._dimensions[dim] || null;
    };
    /**
   * Test whether this index contains an object property
   * @returns {boolean} Returns true if the index is an object property
   */ Index.prototype.isObjectProperty = function() {
        return this._dimensions.length === 1 && typeof this._dimensions[0] === "string";
    };
    /**
   * Returns the object property name when the Index holds a single object property,
   * else returns null
   * @returns {string | null}
   */ Index.prototype.getObjectProperty = function() {
        return this.isObjectProperty() ? this._dimensions[0] : null;
    };
    /**
   * Test whether this index contains only a single value.
   *
   * This is the case when the index is created with only scalar values as ranges,
   * not for ranges resolving into a single value.
   * @memberof Index
   * @return {boolean} isScalar
   */ Index.prototype.isScalar = function() {
        return this._isScalar;
    };
    /**
   * Expand the Index into an array.
   * For example new Index([0,3], [2,7]) returns [[0,1,2], [2,3,4,5,6]]
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.toArray = function() {
        var array = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            array.push(typeof dimension === "string" ? dimension : dimension.toArray());
        }
        return array;
    };
    /**
   * Get the primitive value of the Index, a two dimensional array.
   * Equivalent to Index.toArray().
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.valueOf = Index.prototype.toArray;
    /**
   * Get the string representation of the index, for example '[2:6]' or '[0:2:10, 4:7, [1,2,3]]'
   * @memberof Index
   * @returns {String} str
   */ Index.prototype.toString = function() {
        var strings = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            if (typeof dimension === "string") strings.push(JSON.stringify(dimension));
            else strings.push(dimension.toString());
        }
        return "[" + strings.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the Index
   * @memberof Index
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Index", "ranges": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   */ Index.prototype.toJSON = function() {
        return {
            mathjs: "Index",
            dimensions: this._dimensions
        };
    };
    /**
   * Instantiate an Index from a JSON object
   * @memberof Index
   * @param {Object} json A JSON object structured as:
   *                     `{"mathjs": "Index", "dimensions": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   * @return {Index}
   */ Index.fromJSON = function(json) {
        return Index.create(json.dimensions);
    };
    return Index;
}, {
    isClass: true
});
/**
 * Receives an array of booleans and returns an array of Numbers for Index
 * @param {Array} booleanArrayIndex An array of booleans
 * @return {Array} A set of numbers ready for index
 */ function $e40593440b241175$var$_booleansArrayToNumbersForIndex(booleanArrayIndex) {
    // gets an array of booleans and returns an array of numbers
    var indexOfNumbers = [];
    booleanArrayIndex.forEach((bool, idx)=>{
        if (bool) indexOfNumbers.push(idx);
    });
    return indexOfNumbers;
}


var $b904376875f9b144$var$name = "intersect";
var $b904376875f9b144$var$dependencies = [
    "typed",
    "config",
    "abs",
    "add",
    "addScalar",
    "matrix",
    "multiply",
    "multiplyScalar",
    "divideScalar",
    "subtract",
    "smaller",
    "equalScalar",
    "flatten",
    "isZero",
    "isNumeric"
];
var $b904376875f9b144$export$e2d92d8f89fdd92d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b904376875f9b144$var$name, $b904376875f9b144$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, abs: abs, add: add, addScalar: addScalar, matrix: matrix, multiply: multiply, multiplyScalar: multiplyScalar, divideScalar: divideScalar, subtract: subtract, smaller: smaller, equalScalar: equalScalar, flatten: flatten, isZero: isZero, isNumeric: isNumeric } = _ref;
    /**
   * Calculates the point of intersection of two lines in two or three dimensions
   * and of a line and a plane in three dimensions. The inputs are in the form of
   * arrays or 1 dimensional matrices. The line intersection functions return null
   * if the lines do not meet.
   *
   * Note: Fill the plane coefficients as `x + y + z = c` and not as `x + y + z + c = 0`.
   *
   * Syntax:
   *
   *    math.intersect(endPoint1Line1, endPoint2Line1, endPoint1Line2, endPoint2Line2)
   *    math.intersect(endPoint1, endPoint2, planeCoefficients)
   *
   * Examples:
   *
   *    math.intersect([0, 0], [10, 10], [10, 0], [0, 10])              // Returns [5, 5]
   *    math.intersect([0, 0, 0], [10, 10, 0], [10, 0, 0], [0, 10, 0])  // Returns [5, 5, 0]
   *    math.intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])            // Returns [7, -4, 3]
   *
   * @param  {Array | Matrix} w   Co-ordinates of first end-point of first line
   * @param  {Array | Matrix} x   Co-ordinates of second end-point of first line
   * @param  {Array | Matrix} y   Co-ordinates of first end-point of second line
   *                              OR Co-efficients of the plane's equation
   * @param  {Array | Matrix} z   Co-ordinates of second end-point of second line
   *                              OR undefined if the calculation is for line and plane
   * @return {Array}              Returns the point of intersection of lines/lines-planes
   */ return typed("intersect", {
        "Array, Array, Array": _AAA,
        "Array, Array, Array, Array": _AAAA,
        "Matrix, Matrix, Matrix": function MatrixMatrixMatrix(x, y, plane) {
            var arr = _AAA(x.valueOf(), y.valueOf(), plane.valueOf());
            return arr === null ? null : matrix(arr);
        },
        "Matrix, Matrix, Matrix, Matrix": function MatrixMatrixMatrixMatrix(w, x, y, z) {
            // TODO: output matrix type should match input matrix type
            var arr = _AAAA(w.valueOf(), x.valueOf(), y.valueOf(), z.valueOf());
            return arr === null ? null : matrix(arr);
        }
    });
    function _AAA(x, y, plane) {
        x = _coerceArr(x);
        y = _coerceArr(y);
        plane = _coerceArr(plane);
        if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
        if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
        if (!_4d(plane)) throw new TypeError("Array with 4 numbers expected as third argument");
        return _intersectLinePlane(x[0], x[1], x[2], y[0], y[1], y[2], plane[0], plane[1], plane[2], plane[3]);
    }
    function _AAAA(w, x, y, z) {
        w = _coerceArr(w);
        x = _coerceArr(x);
        y = _coerceArr(y);
        z = _coerceArr(z);
        if (w.length === 2) {
            if (!_2d(w)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
            if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
            if (!_2d(y)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
            if (!_2d(z)) throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
            return _intersect2d(w, x, y, z);
        } else if (w.length === 3) {
            if (!_3d(w)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
            if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
            if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
            if (!_3d(z)) throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
            return _intersect3d(w[0], w[1], w[2], x[0], x[1], x[2], y[0], y[1], y[2], z[0], z[1], z[2]);
        } else throw new TypeError("Arrays with two or thee dimensional points expected");
    }
    /** Coerce row and column 2-dim arrays to 1-dim array */ function _coerceArr(arr) {
        // row matrix
        if (arr.length === 1) return arr[0];
        // column matrix
        if (arr.length > 1 && Array.isArray(arr[0])) {
            if (arr.every((el)=>Array.isArray(el) && el.length === 1)) return flatten(arr);
        }
        return arr;
    }
    function _2d(x) {
        return x.length === 2 && isNumeric(x[0]) && isNumeric(x[1]);
    }
    function _3d(x) {
        return x.length === 3 && isNumeric(x[0]) && isNumeric(x[1]) && isNumeric(x[2]);
    }
    function _4d(x) {
        return x.length === 4 && isNumeric(x[0]) && isNumeric(x[1]) && isNumeric(x[2]) && isNumeric(x[3]);
    }
    function _intersect2d(p1a, p1b, p2a, p2b) {
        var o1 = p1a;
        var o2 = p2a;
        var d1 = subtract(o1, p1b);
        var d2 = subtract(o2, p2b);
        var det = subtract(multiplyScalar(d1[0], d2[1]), multiplyScalar(d2[0], d1[1]));
        if (isZero(det)) return null;
        if (smaller(abs(det), config.relTol)) return null;
        var d20o11 = multiplyScalar(d2[0], o1[1]);
        var d21o10 = multiplyScalar(d2[1], o1[0]);
        var d20o21 = multiplyScalar(d2[0], o2[1]);
        var d21o20 = multiplyScalar(d2[1], o2[0]);
        var t = divideScalar(addScalar(subtract(subtract(d20o11, d21o10), d20o21), d21o20), det);
        return add(multiply(d1, t), o1);
    }
    function _intersect3dHelper(a, b, c, d, e, f, g, h, i, j, k, l) {
        // (a - b)*(c - d) + (e - f)*(g - h) + (i - j)*(k - l)
        var add1 = multiplyScalar(subtract(a, b), subtract(c, d));
        var add2 = multiplyScalar(subtract(e, f), subtract(g, h));
        var add3 = multiplyScalar(subtract(i, j), subtract(k, l));
        return addScalar(addScalar(add1, add2), add3);
    }
    function _intersect3d(x1, y1, z1, x2, y2, z2, x3, y3, z3, x4, y4, z4) {
        var d1343 = _intersect3dHelper(x1, x3, x4, x3, y1, y3, y4, y3, z1, z3, z4, z3);
        var d4321 = _intersect3dHelper(x4, x3, x2, x1, y4, y3, y2, y1, z4, z3, z2, z1);
        var d1321 = _intersect3dHelper(x1, x3, x2, x1, y1, y3, y2, y1, z1, z3, z2, z1);
        var d4343 = _intersect3dHelper(x4, x3, x4, x3, y4, y3, y4, y3, z4, z3, z4, z3);
        var d2121 = _intersect3dHelper(x2, x1, x2, x1, y2, y1, y2, y1, z2, z1, z2, z1);
        var numerator = subtract(multiplyScalar(d1343, d4321), multiplyScalar(d1321, d4343));
        var denominator = subtract(multiplyScalar(d2121, d4343), multiplyScalar(d4321, d4321));
        if (isZero(denominator)) return null;
        var ta = divideScalar(numerator, denominator);
        var tb = divideScalar(addScalar(d1343, multiplyScalar(ta, d4321)), d4343);
        var pax = addScalar(x1, multiplyScalar(ta, subtract(x2, x1)));
        var pay = addScalar(y1, multiplyScalar(ta, subtract(y2, y1)));
        var paz = addScalar(z1, multiplyScalar(ta, subtract(z2, z1)));
        var pbx = addScalar(x3, multiplyScalar(tb, subtract(x4, x3)));
        var pby = addScalar(y3, multiplyScalar(tb, subtract(y4, y3)));
        var pbz = addScalar(z3, multiplyScalar(tb, subtract(z4, z3)));
        if (equalScalar(pax, pbx) && equalScalar(pay, pby) && equalScalar(paz, pbz)) return [
            pax,
            pay,
            paz
        ];
        else return null;
    }
    function _intersectLinePlane(x1, y1, z1, x2, y2, z2, x, y, z, c) {
        var x1x = multiplyScalar(x1, x);
        var x2x = multiplyScalar(x2, x);
        var y1y = multiplyScalar(y1, y);
        var y2y = multiplyScalar(y2, y);
        var z1z = multiplyScalar(z1, z);
        var z2z = multiplyScalar(z2, z);
        var numerator = subtract(subtract(subtract(c, x1x), y1y), z1z);
        var denominator = subtract(subtract(subtract(addScalar(addScalar(x2x, y2y), z2z), x1x), y1y), z1z);
        var t = divideScalar(numerator, denominator);
        var px = addScalar(x1, multiplyScalar(t, subtract(x2, x1)));
        var py = addScalar(y1, multiplyScalar(t, subtract(y2, y1)));
        var pz = addScalar(z1, multiplyScalar(t, subtract(z2, z1)));
        return [
            px,
            py,
            pz
        ];
    // TODO: Add cases when line is parallel to the plane:
    //       (a) no intersection,
    //       (b) line contained in plane
    }
});





var $9cc11cdde88fab9f$var$name = "inv";
var $9cc11cdde88fab9f$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "addScalar",
    "multiply",
    "unaryMinus",
    "det",
    "identity",
    "abs"
];
var $9cc11cdde88fab9f$export$ad9771ef9eafe06a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9cc11cdde88fab9f$var$name, $9cc11cdde88fab9f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, addScalar: addScalar, multiply: multiply, unaryMinus: unaryMinus, det: det, identity: identity, abs: abs } = _ref;
    /**
   * Calculate the inverse of a square matrix.
   *
   * Syntax:
   *
   *     math.inv(x)
   *
   * Examples:
   *
   *     math.inv([[1, 2], [3, 4]])  // returns [[-2, 1], [1.5, -0.5]]
   *     math.inv(4)                 // returns 0.25
   *     1 / 4                       // returns 0.25
   *
   * See also:
   *
   *     det, transpose
   *
   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
   * @return {number | Complex | Array | Matrix} The inverse of `x`.
   */ return typed($9cc11cdde88fab9f$var$name, {
        "Array | Matrix": function ArrayMatrix(x) {
            var size = (0, $23cfe017d190638f$export$b22160e0a14f87b7)(x) ? x.size() : (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x);
            switch(size.length){
                case 1:
                    // vector
                    if (size[0] === 1) {
                        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(x)) return matrix([
                            divideScalar(1, x.valueOf()[0])
                        ]);
                        else return [
                            divideScalar(1, x[0])
                        ];
                    } else throw new RangeError("Matrix must be square (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
                case 2:
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) {
                        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(x)) return matrix(_inv(x.valueOf(), rows, cols), x.storage());
                        else // return an Array
                        return _inv(x, rows, cols);
                    } else throw new RangeError("Matrix must be square (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
            }
        },
        any: function any(x) {
            // scalar
            return divideScalar(1, x); // FIXME: create a BigNumber one when configured for bignumbers
        }
    });
    /**
   * Calculate the inverse of a square matrix
   * @param {Array[]} mat     A square matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns, must equal rows
   * @return {Array[]} inv    Inverse matrix
   * @private
   */ function _inv(mat, rows, cols) {
        var r, s, f, value, temp;
        if (rows === 1) {
            // this is a 1 x 1 matrix
            value = mat[0][0];
            if (value === 0) throw Error("Cannot calculate inverse, determinant is zero");
            return [
                [
                    divideScalar(1, value)
                ]
            ];
        } else if (rows === 2) {
            // this is a 2 x 2 matrix
            var d = det(mat);
            if (d === 0) throw Error("Cannot calculate inverse, determinant is zero");
            return [
                [
                    divideScalar(mat[1][1], d),
                    divideScalar(unaryMinus(mat[0][1]), d)
                ],
                [
                    divideScalar(unaryMinus(mat[1][0]), d),
                    divideScalar(mat[0][0], d)
                ]
            ];
        } else {
            // this is a matrix of 3 x 3 or larger
            // calculate inverse using gauss-jordan elimination
            //      https://en.wikipedia.org/wiki/Gaussian_elimination
            //      http://mathworld.wolfram.com/MatrixInverse.html
            //      http://math.uww.edu/~mcfarlat/inverse.htm
            // make a copy of the matrix (only the arrays, not of the elements)
            var A = mat.concat();
            for(r = 0; r < rows; r++)A[r] = A[r].concat();
            // create an identity matrix which in the end will contain the
            // matrix inverse
            var B = identity(rows).valueOf();
            // loop over all columns, and perform row reductions
            for(var c = 0; c < cols; c++){
                // Pivoting: Swap row c with row r, where row r contains the largest element A[r][c]
                var ABig = abs(A[c][c]);
                var rBig = c;
                r = c + 1;
                while(r < rows){
                    if (abs(A[r][c]) > ABig) {
                        ABig = abs(A[r][c]);
                        rBig = r;
                    }
                    r++;
                }
                if (ABig === 0) throw Error("Cannot calculate inverse, determinant is zero");
                r = rBig;
                if (r !== c) {
                    temp = A[c];
                    A[c] = A[r];
                    A[r] = temp;
                    temp = B[c];
                    B[c] = B[r];
                    B[r] = temp;
                }
                // eliminate non-zero values on the other rows at column c
                var Ac = A[c];
                var Bc = B[c];
                for(r = 0; r < rows; r++){
                    var Ar = A[r];
                    var Br = B[r];
                    if (r !== c) // eliminate value at column c and row r
                    {
                        if (Ar[c] !== 0) {
                            f = divideScalar(unaryMinus(Ar[c]), Ac[c]);
                            // add (f * row c) to row r to eliminate the value
                            // at column c
                            for(s = c; s < cols; s++)Ar[s] = addScalar(Ar[s], multiply(f, Ac[s]));
                            for(s = 0; s < cols; s++)Br[s] = addScalar(Br[s], multiply(f, Bc[s]));
                        }
                    } else {
                        // normalize value at Acc to 1,
                        // divide each value on row r with the value at Acc
                        f = Ac[c];
                        for(s = c; s < cols; s++)Ar[s] = divideScalar(Ar[s], f);
                        for(s = 0; s < cols; s++)Br[s] = divideScalar(Br[s], f);
                    }
                }
            }
            return B;
        }
    }
});


var $39facb57073ad4d3$var$name = "invmod";
var $39facb57073ad4d3$var$dependencies = [
    "typed",
    "config",
    "BigNumber",
    "xgcd",
    "equal",
    "smaller",
    "mod",
    "add",
    "isInteger"
];
var $39facb57073ad4d3$export$1e04c9355dadf1c8 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($39facb57073ad4d3$var$name, $39facb57073ad4d3$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, BigNumber: BigNumber, xgcd: xgcd, equal: equal, smaller: smaller, mod: mod, add: add, isInteger: isInteger } = _ref;
    /**
   * Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation `ax ≣ 1 (mod b)`
   * See https://en.wikipedia.org/wiki/Modular_multiplicative_inverse.
   *
   * Syntax:
   *
   *    math.invmod(a, b)
   *
   * Examples:
   *
   *    math.invmod(8, 12)             // returns NaN
   *    math.invmod(7, 13)             // returns 2
   *    math.invmod(15151, 15122)      // returns 10429
   *
   * See also:
   *
   *    gcd, xgcd
   *
   * @param {number | BigNumber} a  An integer number
   * @param {number | BigNumber} b  An integer number
   * @return {number | BigNumber }  Returns an integer number
   *                              where `invmod(a,b)*a ≣ 1 (mod b)`
   */ return typed($39facb57073ad4d3$var$name, {
        "number, number": invmod,
        "BigNumber, BigNumber": invmod
    });
    function invmod(a, b) {
        if (!isInteger(a) || !isInteger(b)) throw new Error("Parameters in function invmod must be integer numbers");
        a = mod(a, b);
        if (equal(b, 0)) throw new Error("Divisor must be non zero");
        var res = xgcd(a, b);
        res = res.valueOf();
        var [gcd, inv] = res;
        if (!equal(gcd, BigNumber(1))) return NaN;
        inv = mod(inv, b);
        if (smaller(inv, BigNumber(0))) inv = add(inv, b);
        return inv;
    }
});




var $17e9fa1e43eb1261$var$name = "isInteger";
var $17e9fa1e43eb1261$var$dependencies = [
    "typed"
];
var $17e9fa1e43eb1261$export$766996d075d5608a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($17e9fa1e43eb1261$var$name, $17e9fa1e43eb1261$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is an integer number.
   * The function supports `number`, `BigNumber`, and `Fraction`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isInteger(x)
   *
   * Examples:
   *
   *    math.isInteger(2)                     // returns true
   *    math.isInteger(0)                     // returns true
   *    math.isInteger(0.5)                   // returns false
   *    math.isInteger(math.bignumber(500))   // returns true
   *    math.isInteger(math.fraction(4))      // returns true
   *    math.isInteger('3')                   // returns true
   *    math.isInteger([3, 0.5, -2])          // returns [true, false, true]
   *    math.isInteger(math.complex('2-4i'))  // throws an error
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isZero
   *
   * @param {number | BigNumber | bigint | Fraction | Array | Matrix} x   Value to be tested
   * @return {boolean}  Returns true when `x` contains a numeric, integer value.
   *                    Throws an error in case of an unknown data type.
   */ return typed($17e9fa1e43eb1261$var$name, {
        number: (0, $a246eb207aab6d09$export$a287f47fed4544b8),
        // TODO: what to do with isInteger(add(0.1, 0.2))  ?
        BigNumber: function BigNumber(x) {
            return x.isInt();
        },
        bigint: function bigint(x) {
            return true;
        },
        Fraction: function Fraction(x) {
            return x.d === 1 && isFinite(x.n);
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});




var $6a39cbf1042b6178$var$n1 = "number";
function $6a39cbf1042b6178$export$312381923ba56895(x) {
    return (0, $a246eb207aab6d09$export$a287f47fed4544b8)(x);
}
$6a39cbf1042b6178$export$312381923ba56895.signature = $6a39cbf1042b6178$var$n1;
function $6a39cbf1042b6178$export$6dbd64961904ec9a(x) {
    return x < 0;
}
$6a39cbf1042b6178$export$6dbd64961904ec9a.signature = $6a39cbf1042b6178$var$n1;
function $6a39cbf1042b6178$export$5374bb854d0e41c8(x) {
    return x > 0;
}
$6a39cbf1042b6178$export$5374bb854d0e41c8.signature = $6a39cbf1042b6178$var$n1;
function $6a39cbf1042b6178$export$83fb4ed1cc9804a(x) {
    return x === 0;
}
$6a39cbf1042b6178$export$83fb4ed1cc9804a.signature = $6a39cbf1042b6178$var$n1;
function $6a39cbf1042b6178$export$9fd08d8371c55110(x) {
    return Number.isNaN(x);
}
$6a39cbf1042b6178$export$9fd08d8371c55110.signature = $6a39cbf1042b6178$var$n1;


var $e34bb448b012aa7d$var$name = "isNaN";
var $e34bb448b012aa7d$var$dependencies = [
    "typed"
];
var $e34bb448b012aa7d$export$f85085363cf09711 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e34bb448b012aa7d$var$name, $e34bb448b012aa7d$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is NaN (not a number).
   * The function supports types `number`, `BigNumber`, `Fraction`, `Unit` and `Complex`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNaN(x)
   *
   * Examples:
   *
   *    math.isNaN(3)                     // returns false
   *    math.isNaN(NaN)                   // returns true
   *    math.isNaN(0)                     // returns false
   *    math.isNaN(math.bignumber(NaN))   // returns true
   *    math.isNaN(math.bignumber(0))     // returns false
   *    math.isNaN(math.fraction(-2, 5))  // returns false
   *    math.isNaN('-2')                  // returns false
   *    math.isNaN([2, 0, -3, NaN])       // returns [false, false, false, true]
   *
   * See also:
   *
   *    isNumeric, isNegative, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | bigint | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is NaN.
   *                    Throws an error in case of an unknown data type.
   */ return typed($e34bb448b012aa7d$var$name, {
        number: (0, $6a39cbf1042b6178$export$9fd08d8371c55110),
        BigNumber: function BigNumber(x) {
            return x.isNaN();
        },
        bigint: function bigint(x) {
            return false;
        },
        Fraction: function Fraction(x) {
            return false;
        },
        Complex: function Complex(x) {
            return x.isNaN();
        },
        Unit: function Unit(x) {
            return Number.isNaN(x.value);
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});






var $22ade9d4e885d510$var$name = "isNegative";
var $22ade9d4e885d510$var$dependencies = [
    "typed",
    "config"
];
var $22ade9d4e885d510$export$159ccd8c63e17c58 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($22ade9d4e885d510$var$name, $22ade9d4e885d510$var$dependencies, (_ref)=>{
    var { typed: typed, config: config } = _ref;
    /**
   * Test whether a value is negative: smaller than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNegative(x)
   *
   * Examples:
   *
   *    math.isNegative(3)                     // returns false
   *    math.isNegative(-2)                    // returns true
   *    math.isNegative(0)                     // returns false
   *    math.isNegative(-0)                    // returns false
   *    math.isNegative(math.bignumber(2))     // returns false
   *    math.isNegative(math.fraction(-2, 5))  // returns true
   *    math.isNegative('-2')                  // returns true
   *    math.isNegative([2, 0, -3])            // returns [false, false, true]
   *
   * See also:
   *
   *    isNumeric, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | bigint | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($22ade9d4e885d510$var$name, {
        number: (x)=>(0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, 0, config.relTol, config.absTol) ? false : (0, $6a39cbf1042b6178$export$6dbd64961904ec9a)(x),
        BigNumber: (x)=>(0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, new x.constructor(0), config.relTol, config.absTol) ? false : x.isNeg() && !x.isZero() && !x.isNaN(),
        bigint: (x)=>x < 0n,
        Fraction: (x)=>x.s < 0,
        // It's enough to decide on the sign
        Unit: typed.referToSelf((self)=>(x)=>typed.find(self, x.valueType())(x.value)),
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});



var $8a2cf62cb8d75cee$var$name = "isNumeric";
var $8a2cf62cb8d75cee$var$dependencies = [
    "typed"
];
var $8a2cf62cb8d75cee$export$85b0631fa122b7f1 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($8a2cf62cb8d75cee$var$name, $8a2cf62cb8d75cee$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is an numeric value.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNumeric(x)
   *
   * Examples:
   *
   *    math.isNumeric(2)                     // returns true
   *    math.isNumeric('2')                   // returns false
   *    math.hasNumericValue('2')             // returns true
   *    math.isNumeric(0)                     // returns true
   *    math.isNumeric(math.bignumber('42'))  // returns true
   *    math.isNumeric(math.bigint('42'))     // returns true
   *    math.isNumeric(math.fraction(4))      // returns true
   *    math.isNumeric(math.complex('2-4i'))  // returns false
   *    math.isNumeric([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, hasNumericValue
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, or `boolean`. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($8a2cf62cb8d75cee$var$name, {
        "number | BigNumber | bigint | Fraction | boolean": ()=>true,
        "Complex | Unit | string | null | undefined | Node": ()=>false,
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});






var $e12f71367558f9e7$var$name = "isPositive";
var $e12f71367558f9e7$var$dependencies = [
    "typed",
    "config"
];
var $e12f71367558f9e7$export$2d862c12fb537dd9 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e12f71367558f9e7$var$name, $e12f71367558f9e7$var$dependencies, (_ref)=>{
    var { typed: typed, config: config } = _ref;
    /**
   * Test whether a value is positive: larger than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPositive(x)
   *
   * Examples:
   *
   *    math.isPositive(3)                     // returns true
   *    math.isPositive(-2)                    // returns false
   *    math.isPositive(0)                     // returns false
   *    math.isPositive(-0)                    // returns false
   *    math.isPositive(0.5)                   // returns true
   *    math.isPositive(math.bignumber(2))     // returns true
   *    math.isPositive(math.fraction(-2, 5))  // returns false
   *    math.isPositive(math.fraction(1, 3))   // returns true
   *    math.isPositive('2')                   // returns true
   *    math.isPositive([2, 0, -3])            // returns [true, false, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | bigint | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($e12f71367558f9e7$var$name, {
        number: (x)=>(0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, 0, config.relTol, config.absTol) ? false : (0, $6a39cbf1042b6178$export$5374bb854d0e41c8)(x),
        BigNumber: (x)=>(0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, new x.constructor(0), config.relTol, config.absTol) ? false : !x.isNeg() && !x.isZero() && !x.isNaN(),
        bigint: (x)=>x > 0n,
        Fraction: (x)=>x.s > 0 && x.n > 0,
        Unit: typed.referToSelf((self)=>(x)=>typed.find(self, x.valueType())(x.value)),
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});



var $c3d407c2ee36ec5b$var$name = "isPrime";
var $c3d407c2ee36ec5b$var$dependencies = [
    "typed"
];
var $c3d407c2ee36ec5b$export$4e02350f5fb7a050 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c3d407c2ee36ec5b$var$name, $c3d407c2ee36ec5b$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is prime: has no divisors other than itself and one.
   * The function supports type `number`, `bignumber`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPrime(x)
   *
   * Examples:
   *
   *    math.isPrime(3)                     // returns true
   *    math.isPrime(-2)                    // returns false
   *    math.isPrime(0)                     // returns false
   *    math.isPrime(-0)                    // returns false
   *    math.isPrime(0.5)                   // returns false
   *    math.isPrime('2')                   // returns true
   *    math.isPrime([2, 17, 100])           // returns [true, true, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | bigint | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($c3d407c2ee36ec5b$var$name, {
        number: function number(x) {
            if (x <= 3) return x > 1;
            if (x % 2 === 0 || x % 3 === 0) return false;
            for(var i = 5; i * i <= x; i += 6){
                if (x % i === 0 || x % (i + 2) === 0) return false;
            }
            return true;
        },
        bigint: function bigint(x) {
            if (x <= 3n) return x > 1n;
            if (x % 2n === 0n || x % 3n === 0n) return false;
            for(var i = 5n; i * i <= x; i += 6n){
                if (x % i === 0n || x % (i + 2n) === 0n) return false;
            }
            return true;
        },
        BigNumber: function BigNumber(n) {
            if (n.lte(3)) return n.gt(1);
            if (n.mod(2).eq(0) || n.mod(3).eq(0)) return false;
            if (n.lt(Math.pow(2, 32))) {
                var x = n.toNumber();
                for(var i = 5; i * i <= x; i += 6){
                    if (x % i === 0 || x % (i + 2) === 0) return false;
                }
                return true;
            }
            function modPow(base, exponent, modulus) {
                // exponent can be huge, use non-recursive variant
                var accumulator = 1;
                while(!exponent.eq(0))if (exponent.mod(2).eq(0)) {
                    exponent = exponent.div(2);
                    base = base.mul(base).mod(modulus);
                } else {
                    exponent = exponent.sub(1);
                    accumulator = base.mul(accumulator).mod(modulus);
                }
                return accumulator;
            }
            // https://en.wikipedia.org/wiki/Miller%E2%80%93Rabin_primality_test#Deterministic_variants
            var Decimal = n.constructor.clone({
                precision: n.toFixed(0).length * 2
            });
            n = new Decimal(n);
            var r = 0;
            var d = n.sub(1);
            while(d.mod(2).eq(0)){
                d = d.div(2);
                r += 1;
            }
            var bases = null;
            // https://en.wikipedia.org/wiki/Miller–Rabin_primality_test#Testing_against_small_sets_of_bases
            if (n.lt("3317044064679887385961981")) bases = [
                2,
                3,
                5,
                7,
                11,
                13,
                17,
                19,
                23,
                29,
                31,
                37,
                41
            ].filter((x)=>x < n);
            else {
                var max = Math.min(n.toNumber() - 2, Math.floor(2 * Math.pow(n.toFixed(0).length * Math.log(10), 2)));
                bases = [];
                for(var _i = 2; _i <= max; _i += 1)bases.push(max);
            }
            for(var _i2 = 0; _i2 < bases.length; _i2 += 1){
                var a = bases[_i2];
                var adn = modPow(n.sub(n).add(a), d, n);
                if (!adn.eq(1)) for(var _i3 = 0, _x = adn; !_x.eq(n.sub(1)); _i3 += 1, _x = _x.mul(_x).mod(n)){
                    if (_i3 === r - 1) return false;
                }
            }
            return true;
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});



var $8eb868389d2fe92f$var$name = "isZero";
var $8eb868389d2fe92f$var$dependencies = [
    "typed",
    "equalScalar"
];
var $8eb868389d2fe92f$export$ea90652d00dab06e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($8eb868389d2fe92f$var$name, $8eb868389d2fe92f$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Test whether a value is zero.
   * The function can check for zero for types `number`, `BigNumber`, `Fraction`,
   * `Complex`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isZero(x)
   *
   * Examples:
   *
   *    math.isZero(0)                      // returns true
   *    math.isZero(2)                      // returns false
   *    math.isZero(0.5)                    // returns false
   *    math.isZero(math.bignumber(0))      // returns true
   *    math.isZero(math.fraction(0))       // returns true
   *    math.isZero(math.fraction(1,3))     // returns false
   *    math.isZero(math.complex('2 - 4i')) // returns false
   *    math.isZero(math.complex('0i'))     // returns true
   *    math.isZero('0')                    // returns true
   *    math.isZero('2')                    // returns false
   *    math.isZero([2, 0, -3])             // returns [false, true, false]
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isInteger
   *
   * @param {number | BigNumber | bigint | Complex | Fraction | Unit | Array | Matrix} x       Value to be tested
   * @return {boolean}  Returns true when `x` is zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($8eb868389d2fe92f$var$name, {
        "number | BigNumber | Complex | Fraction": (x)=>equalScalar(x, 0),
        bigint: (x)=>x === 0n,
        Unit: typed.referToSelf((self)=>(x)=>typed.find(self, x.valueType())(x.value)),
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});


var $f35cb8b4b634fc03$var$name = "kldivergence";
var $f35cb8b4b634fc03$var$dependencies = [
    "typed",
    "matrix",
    "divide",
    "sum",
    "multiply",
    "map",
    "dotDivide",
    "log",
    "isNumeric"
];
var $f35cb8b4b634fc03$export$eaa5cb8fd86b8d43 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f35cb8b4b634fc03$var$name, $f35cb8b4b634fc03$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divide: divide, sum: sum, multiply: multiply, map: map, dotDivide: dotDivide, log: log, isNumeric: isNumeric } = _ref;
    /**
     * Calculate the Kullback-Leibler (KL) divergence  between two distributions
     *
     * Syntax:
     *
     *     math.kldivergence(x, y)
     *
     * Examples:
     *
     *     math.kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])   //returns 0.24376698773121153
     *
     *
     * @param  {Array | Matrix} q    First vector
     * @param  {Array | Matrix} p    Second vector
     * @return {number}              Returns distance between q and p
     */ return typed($f35cb8b4b634fc03$var$name, {
        "Array, Array": function ArrayArray(q, p) {
            return _kldiv(matrix(q), matrix(p));
        },
        "Matrix, Array": function MatrixArray(q, p) {
            return _kldiv(q, matrix(p));
        },
        "Array, Matrix": function ArrayMatrix(q, p) {
            return _kldiv(matrix(q), p);
        },
        "Matrix, Matrix": function MatrixMatrix(q, p) {
            return _kldiv(q, p);
        }
    });
    function _kldiv(q, p) {
        var plength = p.size().length;
        var qlength = q.size().length;
        if (plength > 1) throw new Error("first object must be one dimensional");
        if (qlength > 1) throw new Error("second object must be one dimensional");
        if (plength !== qlength) throw new Error("Length of two vectors must be equal");
        // Before calculation, apply normalization
        var sumq = sum(q);
        if (sumq === 0) throw new Error("Sum of elements in first object must be non zero");
        var sump = sum(p);
        if (sump === 0) throw new Error("Sum of elements in second object must be non zero");
        var qnorm = divide(q, sum(q));
        var pnorm = divide(p, sum(p));
        var result = sum(multiply(qnorm, map(dotDivide(qnorm, pnorm), (x)=>log(x))));
        if (isNumeric(result)) return result;
        else return Number.NaN;
    }
});



var $407907043ec789ce$var$name = "kron";
var $407907043ec789ce$var$dependencies = [
    "typed",
    "matrix",
    "multiplyScalar"
];
var $407907043ec789ce$export$cee275bf38ddc295 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($407907043ec789ce$var$name, $407907043ec789ce$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, multiplyScalar: multiplyScalar } = _ref;
    /**
     * Calculates the kronecker product of 2 matrices or vectors.
     *
     * NOTE: If a one dimensional vector / matrix is given, it will be
     * wrapped so its two dimensions.
     * See the examples.
     *
     * Syntax:
     *
     *    math.kron(x, y)
     *
     * Examples:
     *
     *    math.kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])
     *    // returns [ [ 1, 2, 0, 0 ], [ 3, 4, 0, 0 ], [ 0, 0, 1, 2 ], [ 0, 0, 3, 4 ] ]
     *
     *    math.kron([1,1], [2,3,4])
     *    // returns [ [ 2, 3, 4, 2, 3, 4 ] ]
     *
     * See also:
     *
     *    multiply, dot, cross
     *
     * @param  {Array | Matrix} x     First vector
     * @param  {Array | Matrix} y     Second vector
     * @return {Array | Matrix}       Returns the kronecker product of `x` and `y`
     */ return typed($407907043ec789ce$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return matrix(_kron(x.toArray(), y.toArray()));
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return matrix(_kron(x.toArray(), y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return matrix(_kron(x, y.toArray()));
        },
        "Array, Array": _kron
    });
    /**
     * Calculate the kronecker product of two matrices / vectors
     * @param {Array} a  First vector
     * @param {Array} b  Second vector
     * @returns {Array} Returns the kronecker product of x and y
     * @private
     */ function _kron(a, b) {
        // Deal with the dimensions of the matricies.
        if ((0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(a).length === 1) // Wrap it in a 2D Matrix
        a = [
            a
        ];
        if ((0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(b).length === 1) // Wrap it in a 2D Matrix
        b = [
            b
        ];
        if ((0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(a).length > 2 || (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(b).length > 2) throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(a.length) + ", y = " + JSON.stringify(b.length) + ")");
        var t = [];
        var r = [];
        return a.map(function(a) {
            return b.map(function(b) {
                r = [];
                t.push(r);
                return a.map(function(y) {
                    return b.map(function(x) {
                        return r.push(multiplyScalar(y, x));
                    });
                });
            });
        }) && t;
    }
});









var $9c9a2ee8039818d3$var$name = "larger";
var $9c9a2ee8039818d3$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix",
    "concat"
];
var $9c9a2ee8039818d3$export$af9bc16ae70e9aa8 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9c9a2ee8039818d3$var$name, $9c9a2ee8039818d3$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $5e352e66a45fa3fa$export$439c4d7accd2a586)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var compareUnits = (0, $c47ed063b6d2cbd9$export$f15f03c51630bb25)({
        typed: typed
    });
    /**
   * Test whether value x is larger than y.
   *
   * The function returns true when x is larger than y and the relative
   * difference between x and y is larger than the configured relTol and absTol. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.larger(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 3)             // returns false
   *    math.larger(5, 2 + 2)         // returns true
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.larger(a, b)             // returns false
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, largerEq, compare
   *
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger than y, else returns false
   */ return typed($9c9a2ee8039818d3$var$name, $9c9a2ee8039818d3$export$36e0507f86788708({
        typed: typed,
        config: config
    }), {
        "boolean, boolean": (x, y)=>x > y,
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.gt(y) && !(0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol);
        },
        "bigint, bigint": (x, y)=>x > y,
        "Fraction, Fraction": (x, y)=>x.compare(y) === 1,
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        }
    }, compareUnits, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $9c9a2ee8039818d3$export$36e0507f86788708 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9c9a2ee8039818d3$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($9c9a2ee8039818d3$var$name, {
        "number, number": function numberNumber(x, y) {
            return x > y && !(0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol);
        }
    });
});









var $07b88fca941d8455$var$name = "largerEq";
var $07b88fca941d8455$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix",
    "concat"
];
var $07b88fca941d8455$export$26aa7f5b5fee1150 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($07b88fca941d8455$var$name, $07b88fca941d8455$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $5e352e66a45fa3fa$export$439c4d7accd2a586)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var compareUnits = (0, $c47ed063b6d2cbd9$export$f15f03c51630bb25)({
        typed: typed
    });
    /**
   * Test whether value x is larger or equal to y.
   *
   * The function returns true when x is larger than y or the relative
   * difference between x and y is smaller than the configured relTol and absTol. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.largerEq(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 1 + 1)         // returns false
   *    math.largerEq(2, 1 + 1)       // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, compare
   *
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger or equal to y, else returns false
   */ return typed($07b88fca941d8455$var$name, $07b88fca941d8455$export$494ed93834104475({
        typed: typed,
        config: config
    }), {
        "boolean, boolean": (x, y)=>x >= y,
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.gte(y) || (0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol);
        },
        "bigint, bigint": function bigintBigint(x, y) {
            return x >= y;
        },
        "Fraction, Fraction": (x, y)=>x.compare(y) !== -1,
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        }
    }, compareUnits, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $07b88fca941d8455$export$494ed93834104475 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($07b88fca941d8455$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($07b88fca941d8455$var$name, {
        "number, number": function numberNumber(x, y) {
            return x >= y || (0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol);
        }
    });
});







var $f2886936ecd0f035$var$name = "lcm";
var $f2886936ecd0f035$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "concat"
];
var $f2886936ecd0f035$export$5d3af1956d9bb33b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f2886936ecd0f035$var$name, $f2886936ecd0f035$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, concat: concat } = _ref;
    var matAlgo02xDS0 = (0, $94e325bf4fc92f8c$export$32ae34d6563cd126)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo06xS0S0 = (0, $bc13b8f894d6d714$export$7e944de5217ad25)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var lcmTypes = "number | BigNumber | Fraction | Matrix | Array";
    var lcmManySignature = {};
    lcmManySignature["".concat(lcmTypes, ", ").concat(lcmTypes, ", ...").concat(lcmTypes)] = typed.referToSelf((self)=>(a, b, args)=>{
            var res = self(a, b);
            for(var i = 0; i < args.length; i++)res = self(res, args[i]);
            return res;
        });
    /**
   * Calculate the least common multiple for two or more values or arrays.
   *
   * lcm is defined as:
   *
   *     lcm(a, b) = abs(a * b) / gcd(a, b)
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.lcm(a, b)
   *    math.lcm(a, b, c, ...)
   *
   * Examples:
   *
   *    math.lcm(4, 6)               // returns 12
   *    math.lcm(6, 21)              // returns 42
   *    math.lcm(6, 21, 5)           // returns 210
   *
   *    math.lcm([4, 6], [6, 21])    // returns [12, 42]
   *
   * See also:
   *
   *    gcd, xgcd
   *
   * @param {... number | BigNumber | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Array | Matrix}                           The least common multiple
   */ return typed($f2886936ecd0f035$var$name, {
        "number, number": (0, $f38f49d8e24d4a9f$export$b55f99ec1f4c5649),
        "BigNumber, BigNumber": _lcmBigNumber,
        "Fraction, Fraction": (x, y)=>x.lcm(y)
    }, matrixAlgorithmSuite({
        SS: matAlgo06xS0S0,
        DS: matAlgo02xDS0,
        Ss: matAlgo11xS0s
    }), lcmManySignature);
    /**
   * Calculate lcm for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns the least common multiple of a and b
   * @private
   */ function _lcmBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function lcm must be integer numbers");
        if (a.isZero()) return a;
        if (b.isZero()) return b;
        // https://en.wikipedia.org/wiki/Euclidean_algorithm
        // evaluate lcm here inline to reduce overhead
        var prod = a.times(b);
        while(!b.isZero()){
            var t = b;
            b = a.mod(t);
            a = t;
        }
        return prod.div(a).abs();
    }
});








var $131ade0646aa8fa7$var$name = "matAlgo08xS0Sid";
var $131ade0646aa8fa7$var$dependencies = [
    "typed",
    "equalScalar"
];
var $131ade0646aa8fa7$export$704047d0f247b5d8 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($131ade0646aa8fa7$var$name, $131ade0646aa8fa7$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0 && B(i,j) === 0
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function matAlgo08xS0Sid(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
        // sparse matrix cannot be a Pattern matrix
        if (!avalues || !bvalues) throw new Error("Cannot perform operation on Pattern Sparse Matrices");
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === "string" && adt === bdt && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // workspace
        var x = [];
        // marks indicating we have a value in x for a given column
        var w = [];
        // vars
        var k, k0, k1, i;
        // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // columns mark
            var mark = j + 1;
            // loop values in a
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k];
                // mark workspace
                w[i] = mark;
                // set value
                x[i] = avalues[k];
                // add index
                cindex.push(i);
            }
            // loop values in b
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k];
                // check value exists in workspace
                if (w[i] === mark) // evaluate callback
                x[i] = cf(x[i], bvalues[k]);
            }
            // initialize first index in j
            k = cptr[j];
            // loop index in j
            while(k < cindex.length){
                // row
                i = cindex[k];
                // value @ i
                var v = x[i];
                // check for zero value
                if (!eq(v, zero)) {
                    // push value
                    cvalues.push(v);
                    // increment pointer
                    k++;
                } else // remove value @ i, do not increment pointer
                cindex.splice(k, 1);
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
});





var $3cafdf5e5d3bcef6$export$5ec2267d257aecc = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)("useMatrixForArrayScalar", [
    "typed",
    "matrix"
], (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    return {
        "Array, number": typed.referTo("DenseMatrix, number", (selfDn)=>(x, y)=>selfDn(matrix(x), y).valueOf()),
        "Array, BigNumber": typed.referTo("DenseMatrix, BigNumber", (selfDB)=>(x, y)=>selfDB(matrix(x), y).valueOf()),
        "number, Array": typed.referTo("number, DenseMatrix", (selfnD)=>(x, y)=>selfnD(x, matrix(y)).valueOf()),
        "BigNumber, Array": typed.referTo("BigNumber, DenseMatrix", (selfBD)=>(x, y)=>selfBD(x, matrix(y)).valueOf())
    };
});




var $daf8f177c408156d$var$name = "leftShift";
var $daf8f177c408156d$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix",
    "concat"
];
var $daf8f177c408156d$export$ce15600b23f5e78 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($daf8f177c408156d$var$name, $daf8f177c408156d$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $a0c1a11a7836c6b2$export$727ab96f88a9e651)({
        typed: typed
    });
    var matAlgo02xDS0 = (0, $94e325bf4fc92f8c$export$32ae34d6563cd126)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo08xS0Sid = (0, $131ade0646aa8fa7$export$704047d0f247b5d8)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $00357ab6509f98c8$export$5295edae9a41ff00)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $ada7281b5c8c5fa6$export$4b07063314120f7c)({
        typed: typed
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var useMatrixForArrayScalar = (0, $3cafdf5e5d3bcef6$export$5ec2267d257aecc)({
        typed: typed,
        matrix: matrix
    });
    /**
   * Bitwise left logical shift of a value x by y number of bits, `x << y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.leftShift(x, y)
   *
   * Examples:
   *
   *    math.leftShift(1, 2)               // returns number 4
   *
   *    math.leftShift([1, 2, 4], 4)       // returns Array [16, 32, 64]
   *
   * See also:
   *
   *    leftShift, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber | bigint} y Amount of shifts
   * @return {number | BigNumber | bigint | Array | Matrix} `x` shifted left `y` times
   */ return typed($daf8f177c408156d$var$name, {
        "number, number": (0, $23d3870094e55520$export$65c07a47901525ba),
        "BigNumber, BigNumber": (0, $6f96750d17929332$export$626dff8098a67b4c),
        "bigint, bigint": (x, y)=>x << y,
        "SparseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo11xS0s(x, y, self, false);
            }),
        "DenseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo14xDs(x, y, self, false);
            }),
        "number | BigNumber, SparseMatrix": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo10xSids(y, x, self, true);
            }),
        "number | BigNumber, DenseMatrix": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo14xDs(y, x, self, true);
            })
    }, useMatrixForArrayScalar, matrixAlgorithmSuite({
        SS: matAlgo08xS0Sid,
        DS: matAlgo01xDSid,
        SD: matAlgo02xDS0
    }));
});

/* eslint-disable no-loss-of-precision */ // References
// ----------
// [1] Hare, "Computing the Principal Branch of log-Gamma", Journal of Algorithms, 1997.
// [2] https://math.stackexchange.com/questions/1338753/how-do-i-calculate-values-for-gamma-function-with-complex-arguments



var $9723ce71c7fd8798$var$name = "lgamma";
var $9723ce71c7fd8798$var$dependencies = [
    "Complex",
    "typed"
];
var $9723ce71c7fd8798$export$bc3a6f6286e9085a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9723ce71c7fd8798$var$name, $9723ce71c7fd8798$var$dependencies, (_ref)=>{
    var { Complex: Complex, typed: typed } = _ref;
    // Stirling series is non-convergent, we need to use the recurrence `lgamma(z) = lgamma(z+1) - log z` to get
    // sufficient accuracy.
    //
    // These two values are copied from Scipy implementation:
    // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L37
    var SMALL_RE = 7;
    var SMALL_IM = 7;
    /**
   * The coefficients are B[2*n]/(2*n*(2*n - 1)) where B[2*n] is the (2*n)th Bernoulli number. See (1.1) in [1].
   *
   * If you cannot access the paper, can also get these values from the formula in [2].
   *
   *    1 /     12 = 0.00833333333333333333333333333333
   *    1 /    360 = 0.00277777777777777777777777777778
   * ...
   * 3617 / 133400 = 0.02955065359477124183006535947712
   */ var coeffs = [
        -0.029550653594771242,
        6.4102564102564102564e-3,
        -0.0019175269175269176,
        8.4175084175084175084e-4,
        -0.0005952380952380953,
        7.9365079365079365079e-4,
        -0.002777777777777778,
        8.3333333333333333333e-2
    ];
    /**
   * Logarithm of the gamma function for real, positive numbers and complex numbers,
   * using Lanczos approximation for numbers and Stirling series for complex numbers.
   *
   * Syntax:
   *
   *    math.lgamma(n)
   *
   * Examples:
   *
   *    math.lgamma(5)       // returns 3.178053830347945
   *    math.lgamma(0)       // returns Infinity
   *    math.lgamma(-0.5)    // returns NaN
   *    math.lgamma(math.i)  // returns -0.6509231993018536 - 1.8724366472624294i
   *
   * See also:
   *
   *    gamma
   *
   * @param {number | Complex} n   A real or complex number
   * @return {number | Complex}    The log gamma of `n`
   */ return typed($9723ce71c7fd8798$var$name, {
        number: (0, $94a9a68b4672560c$export$a9c1cdc6d03f0efc),
        Complex: lgammaComplex,
        BigNumber: function BigNumber() {
            throw new Error("mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber");
        }
    });
    function lgammaComplex(n) {
        var TWOPI = 6.2831853071795864769252842; // 2*pi
        var LOGPI = 1.1447298858494001741434262; // log(pi)
        var REFLECTION = 0.1;
        if (n.isNaN()) return new Complex(NaN, NaN);
        else if (n.im === 0) return new Complex((0, $94a9a68b4672560c$export$a9c1cdc6d03f0efc)(n.re), 0);
        else if (n.re >= SMALL_RE || Math.abs(n.im) >= SMALL_IM) return lgammaStirling(n);
        else if (n.re <= REFLECTION) {
            // Reflection formula. see Proposition 3.1 in [1]
            var tmp = (0, $a246eb207aab6d09$export$fe7b50dc6162f97e)(TWOPI, n.im) * Math.floor(0.5 * n.re + 0.25);
            var a = n.mul(Math.PI).sin().log();
            var b = lgammaComplex(new Complex(1 - n.re, -n.im));
            return new Complex(LOGPI, tmp).sub(a).sub(b);
        } else if (n.im >= 0) return lgammaRecurrence(n);
        else return lgammaRecurrence(n.conjugate()).conjugate();
    }
    function lgammaStirling(z) {
        // formula ref in [2]
        // computation ref:
        // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L101
        // left part
        // x (log(x) - 1) + 1/2 (log(2PI) - log(x))
        // => (x - 0.5) * log(x) - x + log(2PI) / 2
        var leftPart = z.sub(0.5).mul(z.log()).sub(z).add((0, $94a9a68b4672560c$export$6854df5fcb691251));
        // right part
        var rz = new Complex(1, 0).div(z);
        var rzz = rz.div(z);
        var a = coeffs[0];
        var b = coeffs[1];
        var r = 2 * rzz.re;
        var s = rzz.re * rzz.re + rzz.im * rzz.im;
        for(var i = 2; i < 8; i++){
            var tmp = b;
            b = -s * a + coeffs[i];
            a = r * a + tmp;
        }
        var rightPart = rz.mul(rzz.mul(a).add(b));
        // plus left and right
        return leftPart.add(rightPart);
    }
    function lgammaRecurrence(z) {
        // computation ref:
        // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L78
        var signflips = 0;
        var sb = 0;
        var shiftprod = z;
        z = z.add(1);
        while(z.re <= SMALL_RE){
            shiftprod = shiftprod.mul(z);
            var nsb = shiftprod.im < 0 ? 1 : 0;
            if (nsb !== 0 && sb === 0) signflips++;
            sb = nsb;
            z = z.add(1);
        }
        return lgammaStirling(z).sub(shiftprod.log()).sub(new Complex(0, signflips * 2 * Math.PI * 1));
    }
});



var $3483f9f89d68744a$var$name = "log";
var $3483f9f89d68744a$var$dependencies = [
    "config",
    "typed",
    "divideScalar",
    "Complex"
];
var $3483f9f89d68744a$export$aea8a16d5c9d1b93 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3483f9f89d68744a$var$name, $3483f9f89d68744a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, Complex: Complex } = _ref;
    /**
   * Calculate the logarithm of a value.
   *
   * To avoid confusion with the matrix logarithm, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.log(x)
   *    math.log(x, base)
   *
   * Examples:
   *
   *    math.log(3.5)                  // returns 1.252762968495368
   *    math.exp(math.log(2.4))        // returns 2.4
   *
   *    math.pow(10, 4)                // returns 10000
   *    math.log(10000, 10)            // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *
   *    math.log(1024, 2)              // returns 10
   *    math.pow(2, 10)                // returns 1024
   *
   * See also:
   *
   *    exp, log2, log10, log1p
   *
   * @param {number | BigNumber | Complex} x
   *            Value for which to calculate the logarithm.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x` is calculated.
   * @return {number | BigNumber | Complex}
   *            Returns the logarithm of `x`
   */ return typed($3483f9f89d68744a$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $f38f49d8e24d4a9f$export$4df0e8fcdd5c0927)(x);
            else // negative value -> complex value computation
            return new Complex(x, 0).log();
        },
        Complex: function Complex(x) {
            return x.log();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.ln();
            else // downgrade to number, return Complex valued result
            return new Complex(x.toNumber(), 0).log();
        },
        "any, any": typed.referToSelf((self)=>(x, base)=>{
                // calculate logarithm for a specified base, log(x, base)
                return divideScalar(self(x), self(base));
            })
    });
});




var $055d574b08c61f26$var$name = "log10";
var $055d574b08c61f26$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $055d574b08c61f26$export$dea4efeb24d4590d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($055d574b08c61f26$var$name, $055d574b08c61f26$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: _Complex } = _ref;
    /**
   * Calculate the 10-base logarithm of a value. This is the same as calculating `log(x, 10)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log10(x)
   *
   * Examples:
   *
   *    math.log10(0.00001)            // returns -5
   *    math.log10(10000)              // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *    math.pow(10, 4)                // returns 10000
   *
   * See also:
   *
   *    exp, log, log1p, log2
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 10-base logarithm of `x`
   */ return typed($055d574b08c61f26$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $f38f49d8e24d4a9f$export$e3f8d49574d29dff)(x);
            else // negative value -> complex value computation
            return new _Complex(x, 0).log().div(Math.LN10);
        },
        Complex: function Complex(x) {
            return new _Complex(x).log().div(Math.LN10);
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log();
            else // downgrade to number, return Complex valued result
            return new _Complex(x.toNumber(), 0).log().div(Math.LN10);
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});




var $a6fbf051f9b6f22a$var$name = "log1p";
var $a6fbf051f9b6f22a$var$dependencies = [
    "typed",
    "config",
    "divideScalar",
    "log",
    "Complex"
];
var $a6fbf051f9b6f22a$export$93da279859a704f0 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a6fbf051f9b6f22a$var$name, $a6fbf051f9b6f22a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, log: log, Complex: Complex } = _ref;
    /**
   * Calculate the logarithm of a `value+1`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log1p(x)
   *    math.log1p(x, base)
   *
   * Examples:
   *
   *    math.log1p(2.5)                 // returns 1.252762968495368
   *    math.exp(math.log1p(1.4))       // returns 2.4
   *
   *    math.pow(10, 4)                 // returns 10000
   *    math.log1p(9999, 10)            // returns 4
   *    math.log1p(9999) / math.log(10) // returns 4
   *
   * See also:
   *
   *    exp, log, log2, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm of `x+1`.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x+1` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x+1`
   */ return typed($a6fbf051f9b6f22a$var$name, {
        number: function number(x) {
            if (x >= -1 || config.predictable) return (0, $a246eb207aab6d09$export$144dcf16adfb9698)(x);
            else // negative value -> complex value computation
            return _log1pComplex(new Complex(x, 0));
        },
        Complex: _log1pComplex,
        BigNumber: function BigNumber(x) {
            var y = x.plus(1);
            if (!y.isNegative() || config.predictable) return y.ln();
            else // downgrade to number, return Complex valued result
            return _log1pComplex(new Complex(x.toNumber(), 0));
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self)),
        "any, any": typed.referToSelf((self)=>(x, base)=>{
                // calculate logarithm for a specified base, log1p(x, base)
                return divideScalar(self(x), log(base));
            })
    });
    /**
   * Calculate the natural logarithm of a complex number + 1
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log1pComplex(x) {
        var xRe1p = x.re + 1;
        return new Complex(Math.log(Math.sqrt(xRe1p * xRe1p + x.im * x.im)), Math.atan2(x.im, xRe1p));
    }
});




var $72b1bfb767181ea9$var$name = "log2";
var $72b1bfb767181ea9$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $72b1bfb767181ea9$export$a993dae3988e0f19 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($72b1bfb767181ea9$var$name, $72b1bfb767181ea9$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log2(x)
   *
   * Examples:
   *
   *    math.log2(0.03125)           // returns -5
   *    math.log2(16)                // returns 4
   *    math.log2(16) / math.log2(2) // returns 4
   *    math.pow(2, 4)               // returns 16
   *
   * See also:
   *
   *    exp, log, log1p, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 2-base logarithm of `x`
   */ return typed($72b1bfb767181ea9$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $f38f49d8e24d4a9f$export$f9bc93220cfa3c59)(x);
            else // negative value -> complex value computation
            return _log2Complex(new Complex(x, 0));
        },
        Complex: _log2Complex,
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log(2);
            else // downgrade to number, return Complex valued result
            return _log2Complex(new Complex(x.toNumber(), 0));
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
    /**
   * Calculate log2 for a complex value
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log2Complex(x) {
        var newX = Math.sqrt(x.re * x.re + x.im * x.im);
        return new Complex(Math.log2 ? Math.log2(newX) : Math.log(newX) / Math.LN2, Math.atan2(x.im, x.re) / Math.LN2);
    }
});





function $252033fdefeca445$export$6accbcba5dda801d(_ref) {
    var { DenseMatrix: DenseMatrix } = _ref;
    /**
   * Validates matrix and column vector b for backward/forward substitution algorithms.
   *
   * @param {Matrix} m            An N x N matrix
   * @param {Array | Matrix} b    A column vector
   * @param {Boolean} copy        Return a copy of vector b
   *
   * @return {DenseMatrix}        Dense column vector b
   */ return function solveValidation(m, b, copy) {
        var mSize = m.size();
        if (mSize.length !== 2) throw new RangeError("Matrix must be two dimensional (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(mSize) + ")");
        var rows = mSize[0];
        var columns = mSize[1];
        if (rows !== columns) throw new RangeError("Matrix must be square (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(mSize) + ")");
        var data = [];
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(b)) {
            var bSize = b.size();
            var bdata = b._data;
            // 1-dim vector
            if (bSize.length === 1) {
                if (bSize[0] !== rows) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                for(var i = 0; i < rows; i++)data[i] = [
                    bdata[i]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ],
                    datatype: b._datatype
                });
            }
            // 2-dim column
            if (bSize.length === 2) {
                if (bSize[0] !== rows || bSize[1] !== 1) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                if ((0, $23cfe017d190638f$export$eb44495df7ba11d)(b)) {
                    if (copy) {
                        data = [];
                        for(var _i = 0; _i < rows; _i++)data[_i] = [
                            bdata[_i][0]
                        ];
                        return new DenseMatrix({
                            data: data,
                            size: [
                                rows,
                                1
                            ],
                            datatype: b._datatype
                        });
                    }
                    return b;
                }
                if ((0, $23cfe017d190638f$export$d508368d4da3c38a)(b)) {
                    for(var _i2 = 0; _i2 < rows; _i2++)data[_i2] = [
                        0
                    ];
                    var values = b._values;
                    var index = b._index;
                    var ptr = b._ptr;
                    for(var k1 = ptr[1], k = ptr[0]; k < k1; k++){
                        var _i3 = index[k];
                        data[_i3][0] = values[k];
                    }
                    return new DenseMatrix({
                        data: data,
                        size: [
                            rows,
                            1
                        ],
                        datatype: b._datatype
                    });
                }
            }
            throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
        }
        if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(b)) {
            var bsize = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(b);
            if (bsize.length === 1) {
                if (bsize[0] !== rows) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                for(var _i4 = 0; _i4 < rows; _i4++)data[_i4] = [
                    b[_i4]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            if (bsize.length === 2) {
                if (bsize[0] !== rows || bsize[1] !== 1) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                for(var _i5 = 0; _i5 < rows; _i5++)data[_i5] = [
                    b[_i5][0]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
        }
    };
}


var $e026765f1419d9b5$var$name = "lsolve";
var $e026765f1419d9b5$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtractScalar",
    "equalScalar",
    "DenseMatrix"
];
var $e026765f1419d9b5$export$1b88d04961967a10 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e026765f1419d9b5$var$name, $e026765f1419d9b5$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $252033fdefeca445$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds one solution of a linear equation system by forwards substitution. Matrix must be a lower triangular matrix. Throws an error if there's no solution.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolve(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolve(a, b)  // [[-5.5], [20]]
   *
   * See also:
   *
   *    lsolveAll, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($e026765f1419d9b5$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseForwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseForwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var r = _denseForwardSubstitution(m, b);
            return r.valueOf();
        }
    });
    function _denseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        // result
        var x = [];
        var mdata = m._data;
        // loop columns
        for(var j = 0; j < columns; j++){
            var bj = bdata[j][0] || 0;
            var xj = void 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = mdata[j][j];
                if (equalScalar(vjj, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                xj = divideScalar(bj, vjj);
                // loop rows
                for(var i = j + 1; i < rows; i++)bdata[i] = [
                    subtractScalar(bdata[i][0] || 0, multiplyScalar(xj, mdata[i][j]))
                ];
            } else // degenerate row, we can choose any value
            xj = 0;
            x[j] = [
                xj
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // result
        var x = [];
        // loop columns
        for(var j = 0; j < columns; j++){
            var bj = bdata[j][0] || 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = 0;
                // matrix values & indices (column j)
                var jValues = [];
                var jIndices = [];
                // first and last index in the column
                var firstIndex = ptr[j];
                var lastIndex = ptr[j + 1];
                // values in column, find value at [j, j]
                for(var k = firstIndex; k < lastIndex; k++){
                    var i = index[k];
                    // check row (rows are not sorted!)
                    if (i === j) vjj = values[k];
                    else if (i > j) {
                        // store lower triangular
                        jValues.push(values[k]);
                        jIndices.push(i);
                    }
                }
                // at this point we must have a value in vjj
                if (equalScalar(vjj, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                var xj = divideScalar(bj, vjj);
                for(var _k = 0, l = jIndices.length; _k < l; _k++){
                    var _i = jIndices[_k];
                    bdata[_i] = [
                        subtractScalar(bdata[_i][0] || 0, multiplyScalar(xj, jValues[_k]))
                    ];
                }
                x[j] = [
                    xj
                ];
            } else // degenerate row, we can choose any value
            x[j] = [
                0
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});



var $39f3f900e3e17ff9$var$name = "lsolveAll";
var $39f3f900e3e17ff9$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtractScalar",
    "equalScalar",
    "DenseMatrix"
];
var $39f3f900e3e17ff9$export$70743fd0ad1f42d7 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($39f3f900e3e17ff9$var$name, $39f3f900e3e17ff9$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $252033fdefeca445$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds all solutions of a linear equation system by forwards substitution. Matrix must be a lower triangular matrix.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolveAll(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolveAll(a, b)  // [ [[-5.5], [20]] ]
   *
   * See also:
   *
   *    lsolve, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix[] | Array[]}  An array of affine-independent column vectors (x) that solve the linear system
   */ return typed($39f3f900e3e17ff9$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseForwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseForwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var R = _denseForwardSubstitution(m, b);
            return R.map((r)=>r.valueOf());
        }
    });
    function _denseForwardSubstitution(m, b_) {
        // the algorithm is derived from
        // https://www.overleaf.com/read/csvgqdxggyjv
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var M = m._data;
        var rows = m._size[0];
        var columns = m._size[1];
        // loop columns
        for(var i = 0; i < columns; i++){
            var L = B.length;
            // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                if (!equalScalar(M[i][i], 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], M[i][i]);
                    for(var j = i + 1; j < columns; j++)// b[j] -= b[i] * M[j,i]
                    b[j] = subtractScalar(b[j], multiplyScalar(b[i], M[j][i]));
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j = i + 1; _j < columns; _j++)bNew[_j] = subtractScalar(bNew[_j], M[_j][i]);
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
    function _sparseForwardSubstitution(m, b_) {
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // loop columns
        for(var i = 0; i < columns; i++){
            var L = B.length;
            // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                // values & indices (column i)
                var iValues = [];
                var iIndices = [];
                // first & last indeces in column
                var firstIndex = ptr[i];
                var lastIndex = ptr[i + 1];
                // find the value at [i, i]
                var Mii = 0;
                for(var j = firstIndex; j < lastIndex; j++){
                    var J = index[j];
                    // check row
                    if (J === i) Mii = values[j];
                    else if (J > i) {
                        // store lower triangular
                        iValues.push(values[j]);
                        iIndices.push(J);
                    }
                }
                if (!equalScalar(Mii, 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], Mii);
                    for(var _j2 = 0, _lastIndex = iIndices.length; _j2 < _lastIndex; _j2++){
                        var _J = iIndices[_j2];
                        b[_J] = subtractScalar(b[_J], multiplyScalar(b[i], iValues[_j2]));
                    }
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j3 = 0, _lastIndex2 = iIndices.length; _j3 < _lastIndex2; _j3++){
                        var _J2 = iIndices[_j3];
                        bNew[_J2] = subtractScalar(bNew[_J2], iValues[_j3]);
                    }
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
});



var $70a7445f2fdeaccc$var$name = "lup";
var $70a7445f2fdeaccc$var$dependencies = [
    "typed",
    "matrix",
    "abs",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "subtractScalar",
    "larger",
    "equalScalar",
    "unaryMinus",
    "DenseMatrix",
    "SparseMatrix",
    "Spa"
];
var $70a7445f2fdeaccc$export$86ddf344397699d5 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($70a7445f2fdeaccc$var$name, $70a7445f2fdeaccc$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, abs: abs, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, larger: larger, equalScalar: equalScalar, unaryMinus: unaryMinus, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, Spa: Spa } = _ref;
    /**
   * Calculate the Matrix LU decomposition with partial pivoting. Matrix `A` is decomposed in two matrices (`L`, `U`) and a
   * row permutation vector `p` where `A[p,:] = L * U`
   *
   * Syntax:
   *
   *    math.lup(A)
   *
   * Example:
   *
   *    const m = [[2, 1], [1, 4]]
   *    const r = math.lup(m)
   *    // r = {
   *    //   L: [[1, 0], [0.5, 1]],
   *    //   U: [[2, 1], [0, 3.5]],
   *    //   P: [0, 1]
   *    // }
   *
   * See also:
   *
   *    slu, lsolve, lusolve, usolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array for which to get the LUP decomposition.
   *
   * @return {{L: Array | Matrix, U: Array | Matrix, P: Array.<number>}} The lower triangular matrix, the upper triangular matrix and the permutation matrix.
   */ return typed($70a7445f2fdeaccc$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseLUP(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseLUP(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a);
            // lup, use matrix implementation
            var r = _denseLUP(m);
            // result
            return {
                L: r.L.valueOf(),
                U: r.U.valueOf(),
                p: r.p
            };
        }
    });
    function _denseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1];
        // minimum rows and columns
        var n = Math.min(rows, columns);
        // matrix array, clone original data
        var data = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(m._data);
        // l matrix arrays
        var ldata = [];
        var lsize = [
            rows,
            n
        ];
        // u matrix arrays
        var udata = [];
        var usize = [
            n,
            columns
        ];
        // vars
        var i, j, k;
        // permutation vector
        var p = [];
        for(i = 0; i < rows; i++)p[i] = i;
        // loop columns
        for(j = 0; j < columns; j++){
            // skip first column in upper triangular matrix
            if (j > 0) // loop rows
            for(i = 0; i < rows; i++){
                // min i,j
                var min = Math.min(i, j);
                // v[i, j]
                var s = 0;
                // loop up to min
                for(k = 0; k < min; k++)// s = l[i, k] - data[k, j]
                s = addScalar(s, multiplyScalar(data[i][k], data[k][j]));
                data[i][j] = subtractScalar(data[i][j], s);
            }
            // row with larger value in cvector, row >= j
            var pi = j;
            var pabsv = 0;
            var vjj = 0;
            // loop rows
            for(i = j; i < rows; i++){
                // data @ i, j
                var v = data[i][j];
                // absolute value
                var absv = abs(v);
                // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = i;
                    // update max value
                    pabsv = absv;
                    // value @ [j, j]
                    vjj = v;
                }
            }
            // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in p
                p[j] = [
                    p[pi],
                    p[pi] = p[j]
                ][0];
                // swap j <-> pi in data
                DenseMatrix._swapRows(j, pi, data);
            }
            // check column is in lower triangular matrix
            if (j < rows) // loop rows (lower triangular matrix)
            for(i = j + 1; i < rows; i++){
                // value @ i, j
                var vij = data[i][j];
                if (!equalScalar(vij, 0)) // update data
                data[i][j] = divideScalar(data[i][j], vjj);
            }
        }
        // loop columns
        for(j = 0; j < columns; j++)// loop rows
        for(i = 0; i < rows; i++){
            // initialize row in arrays
            if (j === 0) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i] = [];
                // L
                ldata[i] = [];
            }
            // check we are in the upper triangular matrix
            if (i < j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 0;
                continue;
            }
            // diagonal value
            if (i === j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 1;
                continue;
            }
            // check row exists in upper triangular matrix
            if (i < columns) // U
            udata[i][j] = 0;
            // check column exists in lower triangular matrix
            if (j < rows) // L
            ldata[i][j] = data[i][j];
        }
        // l matrix
        var l = new DenseMatrix({
            data: ldata,
            size: lsize
        });
        // u matrix
        var u = new DenseMatrix({
            data: udata,
            size: usize
        });
        // p vector
        var pv = [];
        for(i = 0, n = p.length; i < n; i++)pv[p[i]] = i;
        // return matrices
        return {
            L: l,
            U: u,
            p: pv,
            toString: function toString() {
                return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
            }
        };
    }
    function _sparseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1];
        // minimum rows and columns
        var n = Math.min(rows, columns);
        // matrix arrays (will not be modified, thanks to permutation vector)
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // l matrix arrays
        var lvalues = [];
        var lindex = [];
        var lptr = [];
        var lsize = [
            rows,
            n
        ];
        // u matrix arrays
        var uvalues = [];
        var uindex = [];
        var uptr = [];
        var usize = [
            n,
            columns
        ];
        // vars
        var i, j, k;
        // permutation vectors, (current index -> original index) and (original index -> current index)
        var pvCo = [];
        var pvOc = [];
        for(i = 0; i < rows; i++){
            pvCo[i] = i;
            pvOc[i] = i;
        }
        // swap indices in permutation vectors (condition x < y)!
        var swapIndeces = function swapIndeces(x, y) {
            // find pv indeces getting data from x and y
            var kx = pvOc[x];
            var ky = pvOc[y];
            // update permutation vector current -> original
            pvCo[kx] = y;
            pvCo[ky] = x;
            // update permutation vector original -> current
            pvOc[x] = ky;
            pvOc[y] = kx;
        };
        // loop columns
        var _loop = function _loop() {
            // sparse accumulator
            var spa = new Spa();
            // check lower triangular matrix has a value @ column j
            if (j < rows) {
                // update ptr
                lptr.push(lvalues.length);
                // first value in j column for lower triangular matrix
                lvalues.push(1);
                lindex.push(j);
            }
            // update ptr
            uptr.push(uvalues.length);
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1];
            // copy column j into sparse accumulator
            for(k = k0; k < k1; k++){
                // row
                i = index[k];
                // copy column values into sparse accumulator (use permutation vector)
                spa.set(pvCo[i], values[k]);
            }
            // skip first column in upper triangular matrix
            if (j > 0) // loop rows in column j (above diagonal)
            spa.forEach(0, j - 1, function(k, vkj) {
                // loop rows in column k (L)
                SparseMatrix._forEachRow(k, lvalues, lindex, lptr, function(i, vik) {
                    // check row is below k
                    if (i > k) // update spa value
                    spa.accumulate(i, unaryMinus(multiplyScalar(vik, vkj)));
                });
            });
            // row with larger value in spa, row >= j
            var pi = j;
            var vjj = spa.get(j);
            var pabsv = abs(vjj);
            // loop values in spa (order by row, below diagonal)
            spa.forEach(j + 1, rows - 1, function(x, v) {
                // absolute value
                var absv = abs(v);
                // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = x;
                    // update max value
                    pabsv = absv;
                    // value @ [j, j]
                    vjj = v;
                }
            });
            // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in L
                SparseMatrix._swapRows(j, pi, lsize[1], lvalues, lindex, lptr);
                // swap values j <-> pi in U
                SparseMatrix._swapRows(j, pi, usize[1], uvalues, uindex, uptr);
                // swap values in spa
                spa.swap(j, pi);
                // update permutation vector (swap values @ j, pi)
                swapIndeces(j, pi);
            }
            // loop values in spa (order by row)
            spa.forEach(0, rows - 1, function(x, v) {
                // check we are above diagonal
                if (x <= j) {
                    // update upper triangular matrix
                    uvalues.push(v);
                    uindex.push(x);
                } else {
                    // update value
                    v = divideScalar(v, vjj);
                    // check value is non zero
                    if (!equalScalar(v, 0)) {
                        // update lower triangular matrix
                        lvalues.push(v);
                        lindex.push(x);
                    }
                }
            });
        };
        for(j = 0; j < columns; j++)_loop();
        // update ptrs
        uptr.push(uvalues.length);
        lptr.push(lvalues.length);
        // return matrices
        return {
            L: new SparseMatrix({
                values: lvalues,
                index: lindex,
                ptr: lptr,
                size: lsize
            }),
            U: new SparseMatrix({
                values: uvalues,
                index: uindex,
                ptr: uptr,
                size: usize
            }),
            p: pvCo,
            toString: function toString() {
                return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
            }
        };
    }
});




// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Permutes a vector; x = P'b. In MATLAB notation, x(p)=b.
 *
 * @param {Array} p           The permutation vector of length n. null value denotes identity
 * @param {Array} b           The input vector
 *
 * @return {Array}            The output vector x = P'b
 */ function $50805723dbbb1e81$export$29cc81cfd083fd62(p, b) {
    // vars
    var k;
    var n = b.length;
    var x = [];
    // check permutation vector was provided, p = null denotes identity
    if (p) // loop vector
    for(k = 0; k < n; k++)// apply permutation
    x[p[k]] = b[k];
    else // loop vector
    for(k = 0; k < n; k++)// x[i] = b[i]
    x[k] = b[k];
    return x;
}


var $5e96a71d9fe5174b$var$name = "lusolve";
var $5e96a71d9fe5174b$var$dependencies = [
    "typed",
    "matrix",
    "lup",
    "slu",
    "usolve",
    "lsolve",
    "DenseMatrix"
];
var $5e96a71d9fe5174b$export$a3f0777edf21dcd5 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($5e96a71d9fe5174b$var$name, $5e96a71d9fe5174b$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, lup: lup, slu: slu, usolve: usolve, lsolve: lsolve, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $252033fdefeca445$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Solves the linear system `A * x = b` where `A` is an [n x n] matrix and `b` is a [n] column vector.
   *
   * Syntax:
   *
   *    math.lusolve(A, b)     // returns column vector with the solution to the linear system A * x = b
   *    math.lusolve(lup, b)   // returns column vector with the solution to the linear system A * x = b, lup = math.lup(A)
   *
   * Examples:
   *
   *    const m = [[1, 0, 0, 0], [0, 2, 0, 0], [0, 0, 3, 0], [0, 0, 0, 4]]
   *
   *    const x = math.lusolve(m, [-1, -1, -1, -1])        // x = [[-1], [-0.5], [-1/3], [-0.25]]
   *
   *    const f = math.lup(m)
   *    const x1 = math.lusolve(f, [-1, -1, -1, -1])       // x1 = [[-1], [-0.5], [-1/3], [-0.25]]
   *    const x2 = math.lusolve(f, [1, 2, 1, -1])          // x2 = [[1], [1], [1/3], [-0.25]]
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = math.lusolve(a, b)  // [[2], [5]]
   *
   * See also:
   *
   *    lup, slu, lsolve, usolve
   *
   * @param {Matrix | Array | Object} A      Invertible Matrix or the Matrix LU decomposition
   * @param {Matrix | Array} b               Column Vector
   * @param {number} [order]                 The Symbolic Ordering and Analysis order, see slu for details. Matrix must be a SparseMatrix
   * @param {Number} [threshold]             Partial pivoting threshold (1 for partial pivoting), see slu for details. Matrix must be a SparseMatrix.
   *
   * @return {DenseMatrix | Array}           Column vector with the solution to the linear system A * x = b
   */ return typed($5e96a71d9fe5174b$var$name, {
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            a = matrix(a);
            var d = lup(a);
            var x = _lusolve(d.L, d.U, d.p, null, b);
            return x.valueOf();
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(a, b) {
            var d = lup(a);
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(a, b) {
            var d = lup(a);
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        "SparseMatrix, Array | Matrix, number, number": function SparseMatrixArrayMatrixNumberNumber(a, b, order, threshold) {
            var d = slu(a, order, threshold);
            return _lusolve(d.L, d.U, d.p, d.q, b);
        },
        "Object, Array | Matrix": function ObjectArrayMatrix(d, b) {
            return _lusolve(d.L, d.U, d.p, d.q, b);
        }
    });
    function _toMatrix(a) {
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(a)) return a;
        if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(a)) return matrix(a);
        throw new TypeError("Invalid Matrix LU decomposition");
    }
    function _lusolve(l, u, p, q, b) {
        // verify decomposition
        l = _toMatrix(l);
        u = _toMatrix(u);
        // apply row permutations if needed (b is a DenseMatrix)
        if (p) {
            b = solveValidation(l, b, true);
            b._data = (0, $50805723dbbb1e81$export$29cc81cfd083fd62)(p, b._data);
        }
        // use forward substitution to resolve L * y = b
        var y = lsolve(l, b);
        // use backward substitution to resolve U * x = y
        var x = usolve(u, y);
        // apply column permutations if needed (x is a DenseMatrix)
        if (q) x._data = (0, $50805723dbbb1e81$export$29cc81cfd083fd62)(q, x._data);
        return x;
    }
});


var $0c3ca4ef51d787c8$var$name = "lyap";
var $0c3ca4ef51d787c8$var$dependencies = [
    "typed",
    "matrix",
    "sylvester",
    "multiply",
    "transpose"
];
var $0c3ca4ef51d787c8$export$4279d742852ce356 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0c3ca4ef51d787c8$var$name, $0c3ca4ef51d787c8$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, sylvester: sylvester, multiply: multiply, transpose: transpose } = _ref;
    /**
   *
   * Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P, where
   * Q is an input matrix. When Q is symmetric, P is also symmetric. Notice
   * that different equivalent definitions exist for the Continuous-time
   * Lyapunov equation.
   * https://en.wikipedia.org/wiki/Lyapunov_equation
   *
   * Syntax:
   *
   *     math.lyap(A, Q)
   *
   * Examples:
   *
   *     const A = [[-2, 0], [1, -4]]
   *     const Q = [[3, 1], [1, 3]]
   *     const P = math.lyap(A, Q)
   *
   * See also:
   *
   *     sylvester, schur
   *
   * @param {Matrix | Array} A  Matrix A
   * @param {Matrix | Array} Q  Matrix Q
   * @return {Matrix | Array} Matrix P solution to the Continuous-time Lyapunov equation AP+PA'=Q
   */ return typed($0c3ca4ef51d787c8$var$name, {
        "Matrix, Matrix": function MatrixMatrix(A, Q) {
            return sylvester(A, transpose(A), multiply(-1, Q));
        },
        "Array, Matrix": function ArrayMatrix(A, Q) {
            return sylvester(matrix(A), transpose(matrix(A)), multiply(-1, Q));
        },
        "Matrix, Array": function MatrixArray(A, Q) {
            return sylvester(A, transpose(matrix(A)), matrix(multiply(-1, Q)));
        },
        "Array, Array": function ArrayArray(A, Q) {
            return sylvester(matrix(A), transpose(matrix(A)), matrix(multiply(-1, Q))).toArray();
        }
    });
});




var $268c74e19f98e220$var$name = "mad";
var $268c74e19f98e220$var$dependencies = [
    "typed",
    "abs",
    "map",
    "median",
    "subtract"
];
var $268c74e19f98e220$export$7b17fbe41c88575a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($268c74e19f98e220$var$name, $268c74e19f98e220$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, map: map, median: median, subtract: subtract } = _ref;
    /**
   * Compute the median absolute deviation of a matrix or a list with values.
   * The median absolute deviation is defined as the median of the absolute
   * deviations from the median.
   *
   * Syntax:
   *
   *     math.mad(a, b, c, ...)
   *     math.mad(A)
   *
   * Examples:
   *
   *     math.mad(10, 20, 30)             // returns 10
   *     math.mad([1, 2, 3])              // returns 1
   *     math.mad([[1, 2, 3], [4, 5, 6]]) // returns 1.5
   *
   * See also:
   *
   *     median, mean, std, abs
   *
   * @param {Array | Matrix} array
   *                        A single matrix or multiple scalar values.
   * @return {*} The median absolute deviation.
   */ return typed($268c74e19f98e220$var$name, {
        // mad([a, b, c, d, ...])
        "Array | Matrix": _mad,
        // mad(a, b, c, d, ...)
        "...": function _(args) {
            return _mad(args);
        }
    });
    function _mad(array) {
        array = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(array.valueOf());
        if (array.length === 0) throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
        try {
            var med = median(array);
            return median(map(array, function(value) {
                return abs(subtract(value, med));
            }));
        } catch (err) {
            if (err instanceof TypeError && err.message.includes("median")) throw new TypeError(err.message.replace("median", "mad"));
            else throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "mad");
        }
    }
});



var $dc528eeb9e35a331$var$name = "map";
var $dc528eeb9e35a331$var$dependencies = [
    "typed"
];
var $dc528eeb9e35a331$export$d49c9aa30b771d59 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($dc528eeb9e35a331$var$name, $dc528eeb9e35a331$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a new matrix or array with the results of a callback function executed on
   * each entry of a given matrix/array.
   *
   * For each entry of the input, the callback is invoked with three arguments:
   * the value of the entry, the index at which that entry occurs, and the full
   * matrix/array being traversed. Note that because the matrix/array might be
   * multidimensional, the "index" argument is always an array of numbers giving
   * the index in each dimension. This is true even for vectors: the "index"
   * argument is an array of length 1, rather than simply a number.
   *
   * Syntax:
   *
   *    math.map(x, callback)
   *
   * Examples:
   *
   *    math.map([1, 2, 3], function(value) {
   *      return value * value
   *    })  // returns [1, 4, 9]
   *
   *    // The callback is normally called with three arguments:
   *    //    callback(value, index, Array)
   *    // If you want to call with only one argument, use:
   *    math.map([1, 2, 3], x => math.format(x)) // returns ['1', '2', '3']
   *
   * See also:
   *
   *    filter, forEach, sort
   *
   * @param {Matrix | Array} x    The input to iterate on.
   * @param {Function} callback
   *     The function to call (as described above) on each entry of the input
   * @return {Matrix | array}
   *     Transformed map of x; always has the same type and shape as x
   */ return typed($dc528eeb9e35a331$var$name, {
        "Array, function": $dc528eeb9e35a331$var$_map,
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.map(callback);
        }
    });
});
/**
 * Map for a multi dimensional array
 * @param {Array} array
 * @param {Function} callback
 * @return {Array}
 * @private
 */ function $dc528eeb9e35a331$var$_map(array, callback) {
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) return value.map(function(child, i) {
            // we create a copy of the index array and append the new index value
            return recurse(child, index.concat(i));
        });
        else // invoke the callback function with the right number of arguments
        return (0, $1427f34fc9a7e1b3$export$c081893a7ce04a4c)(callback, value, index, array, "map");
    };
    return recurse(array, []);
}


var $3b49a34f5201c722$var$name = "matrix";
var $3b49a34f5201c722$var$dependencies = [
    "typed",
    "Matrix",
    "DenseMatrix",
    "SparseMatrix"
];
var $3b49a34f5201c722$export$f3cf8b510f9cb8ab = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3b49a34f5201c722$var$name, $3b49a34f5201c722$var$dependencies, (_ref)=>{
    var { typed: typed, Matrix: Matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   * Supported storage formats are 'dense' and 'sparse'.
   *
   * Syntax:
   *
   *    math.matrix()                         // creates an empty matrix using default storage format (dense).
   *    math.matrix(data)                     // creates a matrix with initial data using default storage format (dense).
   *    math.matrix('dense')                  // creates an empty matrix using the given storage format.
   *    math.matrix(data, 'dense')            // creates a matrix with initial data using the given storage format.
   *    math.matrix(data, 'sparse')           // creates a sparse matrix with initial data.
   *    math.matrix(data, 'sparse', 'number') // creates a sparse matrix with initial data, number data type.
   *
   * Examples:
   *
   *    let m = math.matrix([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, sparse
   *
   * @param {Array | Matrix} [data]    A multi dimensional array
   * @param {string} [format]          The Matrix storage format, either `'dense'` or `'sparse'`
   * @param {string} [datatype]        Type of the values
   *
   * @return {Matrix} The created matrix
   */ return typed($3b49a34f5201c722$var$name, {
        "": function _() {
            return _create([]);
        },
        string: function string(format) {
            return _create([], format);
        },
        "string, string": function stringString(format, datatype) {
            return _create([], format, datatype);
        },
        Array: function Array(data) {
            return _create(data);
        },
        Matrix: function Matrix(data) {
            return _create(data, data.storage());
        },
        "Array | Matrix, string": _create,
        "Array | Matrix, string, string": _create
    });
    /**
   * Create a new Matrix with given storage format
   * @param {Array} data
   * @param {string} [format]
   * @param {string} [datatype]
   * @returns {Matrix} Returns a new Matrix
   * @private
   */ function _create(data, format, datatype) {
        // get storage format constructor
        if (format === "dense" || format === "default" || format === undefined) return new DenseMatrix(data, datatype);
        if (format === "sparse") return new SparseMatrix(data, datatype);
        throw new TypeError("Unknown matrix type " + JSON.stringify(format) + ".");
    }
});


var $d737a2a17212fb6c$var$name = "Matrix";
var $d737a2a17212fb6c$var$dependencies = [];
var $d737a2a17212fb6c$export$72d485cc3ed6a97a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d737a2a17212fb6c$var$name, $d737a2a17212fb6c$var$dependencies, ()=>{
    /**
   * @constructor Matrix
   *
   * A Matrix is a wrapper around an Array. A matrix can hold a multi dimensional
   * array. A matrix can be constructed as:
   *
   *     let matrix = math.matrix(data)
   *
   * Matrix contains the functions to resize, get and set values, get the size,
   * clone the matrix and to convert the matrix to a vector, array, or scalar.
   * Furthermore, one can iterate over the matrix using map and forEach.
   * The internal Array of the Matrix can be accessed using the function valueOf.
   *
   * Example usage:
   *
   *     let matrix = math.matrix([[1, 2], [3, 4]])
   *     matix.size()              // [2, 2]
   *     matrix.resize([3, 2], 5)
   *     matrix.valueOf()          // [[1, 2], [3, 4], [5, 5]]
   *     matrix.subset([1,2])       // 3 (indexes are zero-based)
   *
   */ function Matrix() {
        if (!(this instanceof Matrix)) throw new SyntaxError("Constructor must be called with the new operator");
    }
    /**
   * Attach type information
   */ Matrix.prototype.type = "Matrix";
    Matrix.prototype.isMatrix = true;
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @return {string}           The storage format.
   */ Matrix.prototype.storage = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke storage on a Matrix interface");
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @return {string}           The datatype.
   */ Matrix.prototype.datatype = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke datatype on a Matrix interface");
    };
    /**
   * Create a new Matrix With the type of the current matrix instance
   * @param {Array | Object} data
   * @param {string} [datatype]
   */ Matrix.prototype.create = function(data, datatype) {
        throw new Error("Cannot invoke create on a Matrix interface");
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ Matrix.prototype.subset = function(index, replacement, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke subset on a Matrix interface");
    };
    /**
   * Get a single element from the matrix.
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ Matrix.prototype.get = function(index) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke get on a Matrix interface");
    };
    /**
   * Replace a single element in the matrix.
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {Matrix} self
   */ Matrix.prototype.set = function(index, value, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke set on a Matrix interface");
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ Matrix.prototype.resize = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke resize on a Matrix interface");
    };
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ Matrix.prototype.reshape = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke reshape on a Matrix interface");
    };
    /**
   * Create a clone of the matrix
   * @return {Matrix} clone
   */ Matrix.prototype.clone = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke clone on a Matrix interface");
    };
    /**
   * Retrieve the size of the matrix.
   * @returns {number[]} size
   */ Matrix.prototype.size = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke size on a Matrix interface");
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {Matrix} matrix
   */ Matrix.prototype.map = function(callback, skipZeros) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke map on a Matrix interface");
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ Matrix.prototype.forEach = function(callback) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke forEach on a Matrix interface");
    };
    /**
   * Iterate over the matrix elements
   * @return {Iterable<{ value, index: number[] }>}
   */ Matrix.prototype[Symbol.iterator] = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot iterate a Matrix interface");
    };
    /**
   * Create an Array with a copy of the data of the Matrix
   * @returns {Array} array
   */ Matrix.prototype.toArray = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke toArray on a Matrix interface");
    };
    /**
   * Get the primitive value of the Matrix: a multidimensional array
   * @returns {Array} array
   */ Matrix.prototype.valueOf = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke valueOf on a Matrix interface");
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Matrix.prototype.format = function(options) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke format on a Matrix interface");
    };
    /**
   * Get a string representation of the matrix
   * @returns {string} str
   */ Matrix.prototype.toString = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke toString on a Matrix interface");
    };
    return Matrix;
}, {
    isClass: true
});


var $cf4fd53e38645b50$var$name = "matrixFromColumns";
var $cf4fd53e38645b50$var$dependencies = [
    "typed",
    "matrix",
    "flatten",
    "size"
];
var $cf4fd53e38645b50$export$65fefc9f63da4d13 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($cf4fd53e38645b50$var$name, $cf4fd53e38645b50$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, flatten: flatten, size: size } = _ref;
    /**
   * Create a dense matrix from vectors as individual columns.
   * If you pass row vectors, they will be transposed (but not conjugated!)
   *
   * Syntax:
   *
   *    math.matrixFromColumns(...arr)
   *    math.matrixFromColumns(col1, col2)
   *    math.matrixFromColumns(col1, col2, col3)
   *
   * Examples:
   *
   *    math.matrixFromColumns([1, 2, 3], [[4],[5],[6]])
   *    math.matrixFromColumns(...vectors)
   *
   * See also:
   *
   *    matrix, matrixFromRows, matrixFromFunction, zeros
   *
   * @param {... Array | Matrix} cols Multiple columns
   * @return { number[][] | Matrix } if at least one of the arguments is an array, an array will be returned
   */ return typed($cf4fd53e38645b50$var$name, {
        "...Array": function Array(arr) {
            return _createArray(arr);
        },
        "...Matrix": function Matrix(arr) {
            return matrix(_createArray(arr.map((m)=>m.toArray())));
        }
    });
    function _createArray(arr) {
        if (arr.length === 0) throw new TypeError("At least one column is needed to construct a matrix.");
        var N = checkVectorTypeAndReturnLength(arr[0]);
        // create an array with empty rows
        var result = [];
        for(var i = 0; i < N; i++)result[i] = [];
        // loop columns
        for (var col of arr){
            var colLength = checkVectorTypeAndReturnLength(col);
            if (colLength !== N) throw new TypeError("The vectors had different length: " + (N | 0) + " \u2260 " + (colLength | 0));
            var f = flatten(col);
            // push a value to each row
            for(var _i = 0; _i < N; _i++)result[_i].push(f[_i]);
        }
        return result;
    }
    function checkVectorTypeAndReturnLength(vec) {
        var s = size(vec);
        if (s.length === 1) // 1D vector
        return s[0];
        else if (s.length === 2) {
            // 2D vector
            if (s[0] === 1) // row vector
            return s[1];
            else if (s[1] === 1) // col vector
            return s[0];
            else throw new TypeError("At least one of the arguments is not a vector.");
        } else throw new TypeError("Only one- or two-dimensional vectors are supported.");
    }
});


var $d17791e0f78841d7$var$name = "matrixFromFunction";
var $d17791e0f78841d7$var$dependencies = [
    "typed",
    "matrix",
    "isZero"
];
var $d17791e0f78841d7$export$983d2c97138363e0 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d17791e0f78841d7$var$name, $d17791e0f78841d7$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isZero: isZero } = _ref;
    /**
   * Create a matrix by evaluating a generating function at each index.
   * The simplest overload returns a multi-dimensional array as long as `size` is an array.
   * Passing `size` as a Matrix or specifying a `format` will result in returning a Matrix.
   *
   * Syntax:
   *
   *    math.matrixFromFunction(size, fn)
   *    math.matrixFromFunction(size, fn, format)
   *    math.matrixFromFunction(size, fn, format, datatype)
   *    math.matrixFromFunction(size, format, fn)
   *    math.matrixFromFunction(size, format, datatype, fn)
   *
   * Examples:
   *
   *    math.matrixFromFunction([3,3], i => i[0] - i[1]) // an antisymmetric matrix
   *    math.matrixFromFunction([100, 100], 'sparse', i => i[0] - i[1] === 1 ? 4 : 0) // a sparse subdiagonal matrix
   *    math.matrixFromFunction([5], i => math.random()) // a random vector
   *
   * See also:
   *
   *    matrix, zeros
   *
   * @param {Array | Matrix} size   The size of the matrix to be created
   * @param {function} fn           Callback function invoked for every entry in the matrix
   * @param {string} [format]       The Matrix storage format, either `'dense'` or `'sparse'`
   * @param {string} [datatype]     Type of the values
   * @return {Array | Matrix} Returns the created matrix
   */ return typed($d17791e0f78841d7$var$name, {
        "Array | Matrix, function, string, string": function ArrayMatrixFunctionStringString(size, fn, format, datatype) {
            return _create(size, fn, format, datatype);
        },
        "Array | Matrix, function, string": function ArrayMatrixFunctionString(size, fn, format) {
            return _create(size, fn, format);
        },
        "Matrix, function": function MatrixFunction(size, fn) {
            return _create(size, fn, "dense");
        },
        "Array, function": function ArrayFunction(size, fn) {
            return _create(size, fn, "dense").toArray();
        },
        "Array | Matrix, string, function": function ArrayMatrixStringFunction(size, format, fn) {
            return _create(size, fn, format);
        },
        "Array | Matrix, string, string, function": function ArrayMatrixStringStringFunction(size, format, datatype, fn) {
            return _create(size, fn, format, datatype);
        }
    });
    function _create(size, fn, format, datatype) {
        var m;
        if (datatype !== undefined) m = matrix(format, datatype);
        else m = matrix(format);
        m.resize(size);
        m.forEach(function(_, index) {
            var val = fn(index);
            if (isZero(val)) return;
            m.set(index, val);
        });
        return m;
    }
});


var $c6cd253d1f7c45df$var$name = "matrixFromRows";
var $c6cd253d1f7c45df$var$dependencies = [
    "typed",
    "matrix",
    "flatten",
    "size"
];
var $c6cd253d1f7c45df$export$b72d61f960d7c36b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c6cd253d1f7c45df$var$name, $c6cd253d1f7c45df$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, flatten: flatten, size: size } = _ref;
    /**
   * Create a dense matrix from vectors as individual rows.
   * If you pass column vectors, they will be transposed (but not conjugated!)
   *
   * Syntax:
   *
   *    math.matrixFromRows(...arr)
   *    math.matrixFromRows(row1, row2)
   *    math.matrixFromRows(row1, row2, row3)
   *
   * Examples:
   *
   *    math.matrixFromRows([1, 2, 3], [[4],[5],[6]])
   *    math.matrixFromRows(...vectors)
   *
   * See also:
   *
   *    matrix, matrixFromColumns, matrixFromFunction, zeros
   *
   * @param {... Array | Matrix} rows  Multiple rows
   * @return { number[][] | Matrix } if at least one of the arguments is an array, an array will be returned
   */ return typed($c6cd253d1f7c45df$var$name, {
        "...Array": function Array(arr) {
            return _createArray(arr);
        },
        "...Matrix": function Matrix(arr) {
            return matrix(_createArray(arr.map((m)=>m.toArray())));
        }
    });
    function _createArray(arr) {
        if (arr.length === 0) throw new TypeError("At least one row is needed to construct a matrix.");
        var N = checkVectorTypeAndReturnLength(arr[0]);
        var result = [];
        for (var row of arr){
            var rowLength = checkVectorTypeAndReturnLength(row);
            if (rowLength !== N) throw new TypeError("The vectors had different length: " + (N | 0) + " \u2260 " + (rowLength | 0));
            result.push(flatten(row));
        }
        return result;
    }
    function checkVectorTypeAndReturnLength(vec) {
        var s = size(vec);
        if (s.length === 1) // 1D vector
        return s[0];
        else if (s.length === 2) {
            // 2D vector
            if (s[0] === 1) // row vector
            return s[1];
            else if (s[1] === 1) // col vector
            return s[0];
            else throw new TypeError("At least one of the arguments is not a vector.");
        } else throw new TypeError("Only one- or two-dimensional vectors are supported.");
    }
});





var $3c6c9bc5ad48e278$var$name = "max";
var $3c6c9bc5ad48e278$var$dependencies = [
    "typed",
    "config",
    "numeric",
    "larger"
];
var $3c6c9bc5ad48e278$export$b18a1b0c26c000ee = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3c6c9bc5ad48e278$var$name, $3c6c9bc5ad48e278$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, larger: larger } = _ref;
    /**
   * Compute the maximum value of a matrix or a  list with values.
   * In case of a multidimensional array, the maximum of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.max(a, b, c, ...)
   *     math.max(A)
   *     math.max(A, dimension)
   *
   * Examples:
   *
   *     math.max(2, 1, 4, 3)                  // returns 4
   *     math.max([2, 1, 4, 3])                // returns 4
   *
   *     // maximum over a specified dimension (zero-based)
   *     math.max([[2, 5], [4, 3], [1, 7]], 0) // returns [4, 7]
   *     math.max([[2, 5], [4, 3], [1, 7]], 1) // returns [5, 4, 7]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, min, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The maximum value
   */ return typed($3c6c9bc5ad48e278$var$name, {
        // max([a, b, c, d, ...])
        "Array | Matrix": _max,
        // max([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $b3f9e93020d0f987$export$533b26079ad0b4b)(array, dim.valueOf(), _largest);
        },
        // max(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $b3f9e93020d0f987$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function max");
            return _max(args);
        }
    });
    /**
   * Return the largest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is largest, or y when y is largest
   * @private
   */ function _largest(x, y) {
        try {
            return larger(x, y) ? x : y;
        } catch (err) {
            throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "max", y);
        }
    }
    /**
   * Recursively calculate the maximum value in an n-dimensional array
   * @param {Array} array
   * @return {number} max
   * @private
   */ function _max(array) {
        var res;
        (0, $b3f9e93020d0f987$export$519ada94592b97fc)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === "number") res = NaN;
                else if (res === undefined || larger(value, res)) res = value;
            } catch (err) {
                throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "max", value);
            }
        });
        if (res === undefined) throw new Error("Cannot calculate max of an empty array");
        // make sure returning numeric value: parse a string into a numeric value
        if (typeof res === "string") res = numeric(res, (0, $a246eb207aab6d09$export$28199db5a610a1ee)(res, config));
        return res;
    }
});





var $12c6138c58f8eae0$var$name = "mean";
var $12c6138c58f8eae0$var$dependencies = [
    "typed",
    "add",
    "divide"
];
var $12c6138c58f8eae0$export$301ef7ca1de6782c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($12c6138c58f8eae0$var$name, $12c6138c58f8eae0$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide } = _ref;
    /**
   * Compute the mean value of matrix or a list with values.
   * In case of a multidimensional array, the mean of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.mean(a, b, c, ...)
   *     math.mean(A)
   *     math.mean(A, dimension)
   *
   * Examples:
   *
   *     math.mean(2, 1, 4, 3)                     // returns 2.5
   *     math.mean([1, 2.7, 3.2, 4])               // returns 2.725
   *
   *     math.mean([[2, 5], [6, 3], [1, 7]], 0)    // returns [3, 5]
   *     math.mean([[2, 5], [6, 3], [1, 7]], 1)    // returns [3.5, 4.5, 4]
   *
   * See also:
   *
   *     median, min, max, sum, prod, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The mean of all values
   */ return typed($12c6138c58f8eae0$var$name, {
        // mean([a, b, c, d, ...])
        "Array | Matrix": _mean,
        // mean([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": _nmeanDim,
        // mean(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $b3f9e93020d0f987$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function mean");
            return _mean(args);
        }
    });
    /**
   * Calculate the mean value in an n-dimensional array, returning a
   * n-1 dimensional array
   * @param {Array} array
   * @param {number} dim
   * @return {number} mean
   * @private
   */ function _nmeanDim(array, dim) {
        try {
            var sum = (0, $b3f9e93020d0f987$export$533b26079ad0b4b)(array, dim, add);
            var s = Array.isArray(array) ? (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(array) : array.size();
            return divide(sum, s[dim]);
        } catch (err) {
            throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "mean");
        }
    }
    /**
   * Recursively calculate the mean value in an n-dimensional array
   * @param {Array} array
   * @return {number} mean
   * @private
   */ function _mean(array) {
        var sum;
        var num = 0;
        (0, $b3f9e93020d0f987$export$519ada94592b97fc)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "mean", value);
            }
        });
        if (num === 0) throw new Error("Cannot calculate the mean of an empty array");
        return divide(sum, num);
    }
});





var $8c506d8b3b8052eb$var$name = "median";
var $8c506d8b3b8052eb$var$dependencies = [
    "typed",
    "add",
    "divide",
    "compare",
    "partitionSelect"
];
var $8c506d8b3b8052eb$export$cdebf3fc89add777 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($8c506d8b3b8052eb$var$name, $8c506d8b3b8052eb$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide, compare: compare, partitionSelect: partitionSelect } = _ref;
    /**
   * Recursively calculate the median of an n-dimensional array
   * @param {Array} array
   * @return {Number} median
   * @private
   */ function _median(array) {
        try {
            array = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(array.valueOf());
            var num = array.length;
            if (num === 0) throw new Error("Cannot calculate median of an empty array");
            if (num % 2 === 0) {
                // even: return the average of the two middle values
                var mid = num / 2 - 1;
                var right = partitionSelect(array, mid + 1);
                // array now partitioned at mid + 1, take max of left part
                var left = array[mid];
                for(var i = 0; i < mid; ++i)if (compare(array[i], left) > 0) left = array[i];
                return middle2(left, right);
            } else {
                // odd: return the middle value
                var m = partitionSelect(array, (num - 1) / 2);
                return middle(m);
            }
        } catch (err) {
            throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "median");
        }
    }
    // helper function to type check the middle value of the array
    var middle = typed({
        "number | BigNumber | Complex | Unit": function numberBigNumberComplexUnit(value) {
            return value;
        }
    });
    // helper function to type check the two middle value of the array
    var middle2 = typed({
        "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function numberBigNumberComplexUnitNumberBigNumberComplexUnit(left, right) {
            return divide(add(left, right), 2);
        }
    });
    /**
   * Compute the median of a matrix or a list with values. The values are
   * sorted and the middle value is returned. In case of an even number of
   * values, the average of the two middle values is returned.
   * Supported types of values are: Number, BigNumber, Unit
   *
   * In case of a (multi dimensional) array or matrix, the median of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.median(a, b, c, ...)
   *     math.median(A)
   *
   * Examples:
   *
   *     math.median(5, 2, 7)        // returns 5
   *     math.median([3, -1, 5, 7])  // returns 4
   *
   * See also:
   *
   *     mean, min, max, sum, prod, std, variance, quantileSeq
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The median
   */ return typed($8c506d8b3b8052eb$var$name, {
        // median([a, b, c, d, ...])
        "Array | Matrix": _median,
        // median([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement median(A, dim)
            throw new Error("median(A, dim) is not yet supported");
        // return reduce(arguments[0], arguments[1], ...)
        },
        // median(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $b3f9e93020d0f987$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function median");
            return _median(args);
        }
    });
});





var $12a6ba5b1a83f142$var$name = "min";
var $12a6ba5b1a83f142$var$dependencies = [
    "typed",
    "config",
    "numeric",
    "smaller"
];
var $12a6ba5b1a83f142$export$b795f47e2b99170 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($12a6ba5b1a83f142$var$name, $12a6ba5b1a83f142$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, smaller: smaller } = _ref;
    /**
   * Compute the minimum value of a matrix or a  list of values.
   * In case of a multidimensional array, the minimum of the flattened array
   * will be calculated. When `dim` is provided, the minimum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.min(a, b, c, ...)
   *     math.min(A)
   *     math.min(A, dimension)
   *
   * Examples:
   *
   *     math.min(2, 1, 4, 3)                  // returns 1
   *     math.min([2, 1, 4, 3])                // returns 1
   *
   *     // minimum over a specified dimension (zero-based)
   *     math.min([[2, 5], [4, 3], [1, 7]], 0) // returns [1, 3]
   *     math.min([[2, 5], [4, 3], [1, 7]], 1) // returns [2, 3, 1]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, max, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The minimum value
   */ return typed($12a6ba5b1a83f142$var$name, {
        // min([a, b, c, d, ...])
        "Array | Matrix": _min,
        // min([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $b3f9e93020d0f987$export$533b26079ad0b4b)(array, dim.valueOf(), _smallest);
        },
        // min(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $b3f9e93020d0f987$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function min");
            return _min(args);
        }
    });
    /**
   * Return the smallest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is smallest, or y when y is smallest
   * @private
   */ function _smallest(x, y) {
        try {
            return smaller(x, y) ? x : y;
        } catch (err) {
            throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "min", y);
        }
    }
    /**
   * Recursively calculate the minimum value in an n-dimensional array
   * @param {Array} array
   * @return {number} min
   * @private
   */ function _min(array) {
        var min;
        (0, $b3f9e93020d0f987$export$519ada94592b97fc)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === "number") min = NaN;
                else if (min === undefined || smaller(value, min)) min = value;
            } catch (err) {
                throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "min", value);
            }
        });
        if (min === undefined) throw new Error("Cannot calculate min of an empty array");
        // make sure returning numeric value: parse a string into a numeric value
        if (typeof min === "string") min = numeric(min, (0, $a246eb207aab6d09$export$28199db5a610a1ee)(min, config));
        return min;
    }
});



var $c24efd38082c5cdb$var$name = "mode";
var $c24efd38082c5cdb$var$dependencies = [
    "typed",
    "isNaN",
    "isNumeric"
];
var $c24efd38082c5cdb$export$822530980ba269d9 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c24efd38082c5cdb$var$name, $c24efd38082c5cdb$var$dependencies, (_ref)=>{
    var { typed: typed, isNaN: isNaN, isNumeric: isNumeric } = _ref;
    /**
  * Computes the mode of a set of numbers or a list with values(numbers or characters).
  * If there are multiple modes, it returns a list of those values.
  *
  * Syntax:
  *
  *     math.mode(a, b, c, ...)
  *     math.mode(A)
  *
  * Examples:
  *
  *     math.mode(2, 1, 4, 3, 1)                            // returns [1]
  *     math.mode([1, 2.7, 3.2, 4, 2.7])                    // returns [2.7]
  *     math.mode(1, 4, 6, 1, 6)                             // returns [1, 6]
  *     math.mode('a','a','b','c')                           // returns ["a"]
  *     math.mode(1, 1.5, 'abc')                             // returns [1, 1.5, "abc"]
  *
  * See also:
  *
  *     median,
  *     mean
  *
  * @param {... *} args  A single matrix
  * @return {*} The mode of all values
  */ return typed($c24efd38082c5cdb$var$name, {
        "Array | Matrix": _mode,
        "...": function _(args) {
            return _mode(args);
        }
    });
    /**
   * Calculates the mode in an 1-dimensional array
   * @param {Array} values
   * @return {Array} mode
   * @private
   */ function _mode(values) {
        values = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(values.valueOf());
        var num = values.length;
        if (num === 0) throw new Error("Cannot calculate mode of an empty array");
        var count = {};
        var mode = [];
        var max = 0;
        for(var i = 0; i < values.length; i++){
            var value = values[i];
            if (isNumeric(value) && isNaN(value)) throw new Error("Cannot calculate mode of an array containing NaN values");
            if (!(value in count)) count[value] = 0;
            count[value]++;
            if (count[value] === max) mode.push(value);
            else if (count[value] > max) {
                max = count[value];
                mode = [
                    value
                ];
            }
        }
        return mode;
    }
});



var $c035f40e00852fc3$var$name = "multinomial";
var $c035f40e00852fc3$var$dependencies = [
    "typed",
    "add",
    "divide",
    "multiply",
    "factorial",
    "isInteger",
    "isPositive"
];
var $c035f40e00852fc3$export$b15aee1001d110 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c035f40e00852fc3$var$name, $c035f40e00852fc3$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide, multiply: multiply, factorial: factorial, isInteger: isInteger, isPositive: isPositive } = _ref;
    /**
   * Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities.
   *
   * multinomial takes one array of integers as an argument.
   * The following condition must be enforced: every ai <= 0
   *
   * Syntax:
   *
   *     math.multinomial(a) // a is an array type
   *
   * Examples:
   *
   *    math.multinomial([1,2,1]) // returns 12
   *
   * See also:
   *
   *    combinations, factorial
   *
   * @param {number[] | BigNumber[]} a    Integer numbers of objects in the subset
   * @return {Number | BigNumber}         Multinomial coefficient.
   */ return typed($c035f40e00852fc3$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            var sum = 0;
            var denom = 1;
            (0, $b3f9e93020d0f987$export$519ada94592b97fc)(a, function(ai) {
                if (!isInteger(ai) || !isPositive(ai)) throw new TypeError("Positive integer value expected in function multinomial");
                sum = add(sum, ai);
                denom = multiply(denom, factorial(ai));
            });
            return divide(factorial(sum), denom);
        }
    });
});






var $2a87ec6ce9d50781$var$name = "multiply";
var $2a87ec6ce9d50781$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "multiplyScalar",
    "equalScalar",
    "dot"
];
var $2a87ec6ce9d50781$export$86d08fd318fa07c8 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($2a87ec6ce9d50781$var$name, $2a87ec6ce9d50781$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, multiplyScalar: multiplyScalar, equalScalar: equalScalar, dot: dot } = _ref;
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $ada7281b5c8c5fa6$export$4b07063314120f7c)({
        typed: typed
    });
    function _validateMatrixDimensions(size1, size2) {
        // check left operand dimensions
        switch(size1.length){
            case 1:
                // check size2
                switch(size2.length){
                    case 1:
                        // Vector x Vector
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
                        break;
                    case 2:
                        // Vector x Matrix
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Vector length (" + size1[0] + ") must match Matrix rows (" + size2[0] + ")");
                        break;
                    default:
                        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + size2.length + " dimensions)");
                }
                break;
            case 2:
                // check size2
                switch(size2.length){
                    case 1:
                        // Matrix x Vector
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + size1[1] + ") must match Vector length (" + size2[0] + ")");
                        break;
                    case 2:
                        // Matrix x Matrix
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + size1[1] + ") must match Matrix B rows (" + size2[0] + ")");
                        break;
                    default:
                        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + size2.length + " dimensions)");
                }
                break;
            default:
                throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + size1.length + " dimensions)");
        }
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (N)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {number}             Scalar value
   */ function _multiplyVectorVector(a, b, n) {
        // check empty vector
        if (n === 0) throw new Error("Cannot multiply two empty vectors");
        return dot(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Matrix         (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorMatrix(a, b) {
        // process storage
        if (b.storage() !== "dense") throw new Error("Support for SparseMatrix not implemented");
        return _multiplyVectorDenseMatrix(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Dense Matrix   (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype || a.getDataType();
        // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype || b.getDataType();
        // rows & columns
        var alength = asize[0];
        var bcolumns = bsize[1];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string" && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        }
        // result
        var c = [];
        // loop matrix columns
        for(var j = 0; j < bcolumns; j++){
            // sum (do not initialize it with zero)
            var sum = mf(adata[0], bdata[0][j]);
            // loop vector
            for(var i = 1; i < alength; i++)// multiply & accumulate
            sum = af(sum, mf(adata[i], bdata[i][j]));
            c[j] = sum;
        }
        // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                bcolumns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {Matrix}             Dense Vector   (M)
   */ var _multiplyMatrixVector = typed("_multiplyMatrixVector", {
        "DenseMatrix, any": _multiplyDenseMatrixVector,
        "SparseMatrix, any": _multiplySparseMatrixVector
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Matrix         (NxC)
   *
   * @return {Matrix}             Matrix         (MxC)
   */ var _multiplyMatrixMatrix = typed("_multiplyMatrixMatrix", {
        "DenseMatrix, DenseMatrix": _multiplyDenseMatrixDenseMatrix,
        "DenseMatrix, SparseMatrix": _multiplyDenseMatrixSparseMatrix,
        "SparseMatrix, DenseMatrix": _multiplySparseMatrixDenseMatrix,
        "SparseMatrix, SparseMatrix": _multiplySparseMatrixSparseMatrix
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix  (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             Dense Vector (M)
   */ function _multiplyDenseMatrixVector(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype || a.getDataType();
        // b dense
        var bdata = b._data;
        var bdt = b._datatype || b.getDataType();
        // rows & columns
        var arows = asize[0];
        var acolumns = asize[1];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string" && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        }
        // result
        var c = [];
        // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i];
            // sum (do not initialize it with zero)
            var sum = mf(row[0], bdata[0]);
            // loop matrix a columns
            for(var j = 1; j < acolumns; j++)// multiply & accumulate
            sum = af(sum, mf(row[j], bdata[j]));
            c[i] = sum;
        }
        // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            DenseMatrix    (NxC)
   *
   * @return {Matrix}             DenseMatrix    (MxC)
   */ function _multiplyDenseMatrixDenseMatrix(a, b) {
        // getDataType()
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype || a.getDataType();
        // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype || b.getDataType();
        // rows & columns
        var arows = asize[0];
        var acolumns = asize[1];
        var bcolumns = bsize[1];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string" && adt !== "mixed" && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        }
        // result
        var c = [];
        // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i];
            // initialize row array
            c[i] = [];
            // loop matrix b columns
            for(var j = 0; j < bcolumns; j++){
                // sum (avoid initializing sum to zero)
                var sum = mf(row[0], bdata[0][j]);
                // loop matrix a columns
                for(var x = 1; x < acolumns; x++)// multiply & accumulate
                sum = af(sum, mf(row[x], bdata[x][j]));
                c[i][j] = sum;
            }
        }
        // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows,
                bcolumns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            SparseMatrix   (NxC)
   *
   * @return {Matrix}             SparseMatrix   (MxC)
   */ function _multiplyDenseMatrixSparseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype || a.getDataType();
        // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate b matrix
        if (!bvalues) throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
        // rows & columns
        var arows = asize[0];
        var bcolumns = bsize[1];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // equalScalar signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string" && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        }
        // result
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // c matrix
        var c = b.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
        // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length;
            // indeces in column jb
            var kb0 = bptr[jb];
            var kb1 = bptr[jb + 1];
            // do not process column jb if no data exists
            if (kb1 > kb0) {
                // last row mark processed
                var last = 0;
                // loop a rows
                for(var i = 0; i < arows; i++){
                    // column mark
                    var mark = i + 1;
                    // C[i, jb]
                    var cij = void 0;
                    // values in b column j
                    for(var kb = kb0; kb < kb1; kb++){
                        // row
                        var ib = bindex[kb];
                        // check value has been initialized
                        if (last !== mark) {
                            // first value in column jb
                            cij = mf(adata[i][ib], bvalues[kb]);
                            // update mark
                            last = mark;
                        } else // accumulate value
                        cij = af(cij, mf(adata[i][ib], bvalues[kb]));
                    }
                    // check column has been processed and value != 0
                    if (last === mark && !eq(cij, zero)) {
                        // push row & value
                        cindex.push(i);
                        cvalues.push(cij);
                    }
                }
            }
        }
        // update ptr
        cptr[bcolumns] = cindex.length;
        // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix    (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             SparseMatrix    (M, 1)
   */ function _multiplySparseMatrixVector(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // validate a matrix
        if (!avalues) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
        // b dense
        var bdata = b._data;
        var bdt = b._datatype || b.getDataType();
        // rows & columns
        var arows = a._size[0];
        var brows = b._size[0];
        // result
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // equalScalar signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string" && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        }
        // workspace
        var x = [];
        // vector with marks indicating a value x[i] exists in a given column
        var w = [];
        // update ptr
        cptr[0] = 0;
        // rows in b
        for(var ib = 0; ib < brows; ib++){
            // b[ib]
            var vbi = bdata[ib];
            // check b[ib] != 0, avoid loops
            if (!eq(vbi, zero)) // A values & index in ib column
            for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                // a row
                var ia = aindex[ka];
                // check value exists in current j
                if (!w[ia]) {
                    // ia is new entry in j
                    w[ia] = true;
                    // add i to pattern of C
                    cindex.push(ia);
                    // x(ia) = A
                    x[ia] = mf(vbi, avalues[ka]);
                } else // i exists in C already
                x[ia] = af(x[ia], mf(vbi, avalues[ka]));
            }
        }
        // copy values from x to column jb of c
        for(var p1 = cindex.length, p = 0; p < p1; p++){
            // row
            var ic = cindex[p];
            // copy value
            cvalues[p] = x[ic];
        }
        // update ptr
        cptr[1] = cindex.length;
        // matrix to return
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                1
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            DenseMatrix       (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixDenseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // validate a matrix
        if (!avalues) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
        // b dense
        var bdata = b._data;
        var bdt = b._datatype || b.getDataType();
        // rows & columns
        var arows = a._size[0];
        var brows = b._size[0];
        var bcolumns = b._size[1];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // equalScalar signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string" && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        }
        // result
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
        // workspace
        var x = [];
        // vector with marks indicating a value x[i] exists in a given column
        var w = [];
        // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length;
            // mark in workspace for current column
            var mark = jb + 1;
            // rows in jb
            for(var ib = 0; ib < brows; ib++){
                // b[ib, jb]
                var vbij = bdata[ib][jb];
                // check b[ib, jb] != 0, avoid loops
                if (!eq(vbij, zero)) // A values & index in ib column
                for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // a row
                    var ia = aindex[ka];
                    // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark;
                        // add i to pattern of C
                        cindex.push(ia);
                        // x(ia) = A
                        x[ia] = mf(vbij, avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(vbij, avalues[ka]));
                }
            }
            // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p];
                // copy value
                cvalues[p] = x[ic];
            }
        }
        // update ptr
        cptr[bcolumns] = cindex.length;
        // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            SparseMatrix      (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixSparseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // rows & columns
        var arows = a._size[0];
        var bcolumns = b._size[1];
        // flag indicating both matrices (a & b) contain data
        var values = avalues && bvalues;
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string" && adt !== "mixed") {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        }
        // result
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
        // workspace
        var x = values ? [] : undefined;
        // vector with marks indicating a value x[i] exists in a given column
        var w = [];
        // variables
        var ka, ka0, ka1, kb, kb0, kb1, ia, ib;
        // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length;
            // mark in workspace for current column
            var mark = jb + 1;
            // B values & index in j
            for(kb0 = bptr[jb], kb1 = bptr[jb + 1], kb = kb0; kb < kb1; kb++){
                // b row
                ib = bindex[kb];
                // check we need to process values
                if (values) // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka];
                    // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark;
                        // add i to pattern of C
                        cindex.push(ia);
                        // x(ia) = A
                        x[ia] = mf(bvalues[kb], avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(bvalues[kb], avalues[ka]));
                }
                else // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka];
                    // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark;
                        // add i to pattern of C
                        cindex.push(ia);
                    }
                }
            }
            // check we need to process matrix values (pattern matrix)
            if (values) // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p];
                // copy value
                cvalues[p] = x[ic];
            }
        }
        // update ptr
        cptr[bcolumns] = cindex.length;
        // return sparse matrix
        return c;
    }
    /**
   * Multiply two or more values, `x * y`.
   * For matrices, the matrix product is calculated.
   *
   * Syntax:
   *
   *    math.multiply(x, y)
   *    math.multiply(x, y, z, ...)
   *
   * Examples:
   *
   *    math.multiply(4, 5.2)        // returns number 20.8
   *    math.multiply(2, 3, 4)       // returns number 24
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.multiply(a, b)          // returns Complex 5 + 14i
   *
   *    const c = [[1, 2], [4, 3]]
   *    const d = [[1, 2, 3], [3, -4, 7]]
   *    math.multiply(c, d)          // returns Array [[7, -6, 17], [13, -4, 33]]
   *
   *    const e = math.unit('2.1 km')
   *    math.multiply(3, e)          // returns Unit 6.3 km
   *
   * See also:
   *
   *    divide, prod, cross, dot
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} x First value to multiply
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} y Second value to multiply
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} Multiplication of `x` and `y`
   */ return typed($2a87ec6ce9d50781$var$name, multiplyScalar, {
        // we extend the signatures of multiplyScalar with signatures dealing with matrices
        "Array, Array": typed.referTo("Matrix, Matrix", (selfMM)=>(x, y)=>{
                // check dimensions
                _validateMatrixDimensions((0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x), (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(y));
                // use dense matrix implementation
                var m = selfMM(matrix(x), matrix(y));
                // return array or scalar
                return (0, $23cfe017d190638f$export$b22160e0a14f87b7)(m) ? m.valueOf() : m;
            }),
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            // dimensions
            var xsize = x.size();
            var ysize = y.size();
            // check dimensions
            _validateMatrixDimensions(xsize, ysize);
            // process dimensions
            if (xsize.length === 1) {
                // process y dimensions
                if (ysize.length === 1) // Vector * Vector
                return _multiplyVectorVector(x, y, xsize[0]);
                // Vector * Matrix
                return _multiplyVectorMatrix(x, y);
            }
            // process y dimensions
            if (ysize.length === 1) // Matrix * Vector
            return _multiplyMatrixVector(x, y);
            // Matrix * Matrix
            return _multiplyMatrixMatrix(x, y);
        },
        "Matrix, Array": typed.referTo("Matrix,Matrix", (selfMM)=>(x, y)=>selfMM(x, matrix(y))),
        "Array, Matrix": typed.referToSelf((self)=>(x, y)=>{
                // use Matrix * Matrix implementation
                return self(matrix(x, y.storage()), y);
            }),
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return matAlgo11xS0s(x, y, multiplyScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return matAlgo14xDs(x, y, multiplyScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return matAlgo11xS0s(y, x, multiplyScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return matAlgo14xDs(y, x, multiplyScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return matAlgo14xDs(matrix(x), y, multiplyScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return matAlgo14xDs(matrix(y), x, multiplyScalar, true).valueOf();
        },
        "any, any": multiplyScalar,
        "any, any, ...any": typed.referToSelf((self)=>(x, y, rest)=>{
                var result = self(x, y);
                for(var i = 0; i < rest.length; i++)result = self(result, rest[i]);
                return result;
            })
    });
});



var $510e45e57dd1e093$var$name = "multiplyScalar";
var $510e45e57dd1e093$var$dependencies = [
    "typed"
];
var $510e45e57dd1e093$export$37dc64d7e8361b32 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($510e45e57dd1e093$var$name, $510e45e57dd1e093$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Multiply two scalar values, `x * y`.
   * This function is meant for internal use: it is used by the public function
   * `multiply`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x   First value to multiply
   * @param  {number | BigNumber | bigint | Fraction | Complex} y          Second value to multiply
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit}     Multiplication of `x` and `y`
   * @private
   */ return typed("multiplyScalar", {
        "number, number": (0, $f38f49d8e24d4a9f$export$4ad41ac849e391ec),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.mul(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.times(y);
        },
        "bigint, bigint": function bigintBigint(x, y) {
            return x * y;
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.mul(y);
        },
        "number | Fraction | BigNumber | Complex, Unit": (x, y)=>y.multiply(x),
        "Unit, number | Fraction | BigNumber | Complex | Unit": (x, y)=>x.multiply(y)
    });
});


var $6d4110c279646dec$var$name = "norm";
var $6d4110c279646dec$var$dependencies = [
    "typed",
    "abs",
    "add",
    "pow",
    "conj",
    "sqrt",
    "multiply",
    "equalScalar",
    "larger",
    "smaller",
    "matrix",
    "ctranspose",
    "eigs"
];
var $6d4110c279646dec$export$ce85a9d2952c2966 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6d4110c279646dec$var$name, $6d4110c279646dec$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, pow: pow, conj: conj, sqrt: sqrt, multiply: multiply, equalScalar: equalScalar, larger: larger, smaller: smaller, matrix: matrix, ctranspose: ctranspose, eigs: eigs } = _ref;
    /**
   * Calculate the norm of a number, vector or matrix.
   *
   * The second parameter p is optional. If not provided, it defaults to 2.
   *
   * Syntax:
   *
   *    math.norm(x)
   *    math.norm(x, p)
   *
   * Examples:
   *
   *    math.abs(-3.5)                         // returns 3.5
   *    math.norm(-3.5)                        // returns 3.5
   *
   *    math.norm(math.complex(3, -4))         // returns 5
   *
   *    math.norm([1, 2, -3], Infinity)        // returns 3
   *    math.norm([1, 2, -3], -Infinity)       // returns 1
   *
   *    math.norm([3, 4], 2)                   // returns 5
   *
   *    math.norm([[1, 2], [3, 4]], 1)          // returns 6
   *    math.norm([[1, 2], [3, 4]], 'inf')     // returns 7
   *    math.norm([[1, 2], [3, 4]], 'fro')     // returns 5.477225575051661
   *
   * See also:
   *
   *    abs, hypot
   *
   * @param  {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the norm
   * @param  {number | BigNumber | string} [p=2]
   *            Vector space.
   *            Supported numbers include Infinity and -Infinity.
   *            Supported strings are: 'inf', '-inf', and 'fro' (The Frobenius norm)
   * @return {number | BigNumber} the p-norm
   */ return typed($6d4110c279646dec$var$name, {
        number: Math.abs,
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            // norm(x) = abs(x)
            return x.abs();
        },
        boolean: function boolean(x) {
            // norm(x) = abs(x)
            return Math.abs(x);
        },
        Array: function Array(x) {
            return _norm(matrix(x), 2);
        },
        Matrix: function Matrix(x) {
            return _norm(x, 2);
        },
        "Array, number | BigNumber | string": function ArrayNumberBigNumberString(x, p) {
            return _norm(matrix(x), p);
        },
        "Matrix, number | BigNumber | string": function MatrixNumberBigNumberString(x, p) {
            return _norm(x, p);
        }
    });
    /**
   * Calculate the plus infinity norm for a vector
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNormPlusInfinity(x) {
        // norm(x, Infinity) = max(abs(x))
        var pinf = 0;
        // skip zeros since abs(0) === 0
        x.forEach(function(value) {
            var v = abs(value);
            if (larger(v, pinf)) pinf = v;
        }, true);
        return pinf;
    }
    /**
   * Calculate the minus infinity norm for a vector
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNormMinusInfinity(x) {
        // norm(x, -Infinity) = min(abs(x))
        var ninf;
        // skip zeros since abs(0) === 0
        x.forEach(function(value) {
            var v = abs(value);
            if (!ninf || smaller(v, ninf)) ninf = v;
        }, true);
        return ninf || 0;
    }
    /**
   * Calculate the norm for a vector
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNorm(x, p) {
        // check p
        if (p === Number.POSITIVE_INFINITY || p === "inf") return _vectorNormPlusInfinity(x);
        if (p === Number.NEGATIVE_INFINITY || p === "-inf") return _vectorNormMinusInfinity(x);
        if (p === "fro") return _norm(x, 2);
        if (typeof p === "number" && !isNaN(p)) {
            // check p != 0
            if (!equalScalar(p, 0)) {
                // norm(x, p) = sum(abs(xi) ^ p) ^ 1/p
                var n = 0;
                // skip zeros since abs(0) === 0
                x.forEach(function(value) {
                    n = add(pow(abs(value), p), n);
                }, true);
                return pow(n, 1 / p);
            }
            return Number.POSITIVE_INFINITY;
        }
        // invalid parameter value
        throw new Error("Unsupported parameter value");
    }
    /**
   * Calculate the Frobenius norm for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormFrobenius(x) {
        // norm(x) = sqrt(sum(diag(x'x)))
        var fro = 0;
        x.forEach(function(value, index) {
            fro = add(fro, multiply(value, conj(value)));
        });
        return abs(sqrt(fro));
    }
    /**
   * Calculate the norm L1 for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormOne(x) {
        // norm(x) = the largest column sum
        var c = [];
        // result
        var maxc = 0;
        // skip zeros since abs(0) == 0
        x.forEach(function(value, index) {
            var j = index[1];
            var cj = add(c[j] || 0, abs(value));
            if (larger(cj, maxc)) maxc = cj;
            c[j] = cj;
        }, true);
        return maxc;
    }
    /**
   * Calculate the norm L2 for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormTwo(x) {
        // norm(x) = sqrt( max eigenvalue of A*.A)
        var sizeX = x.size();
        if (sizeX[0] !== sizeX[1]) throw new RangeError("Invalid matrix dimensions");
        var tx = ctranspose(x);
        var squaredX = multiply(tx, x);
        var eigenVals = eigs(squaredX).values.toArray();
        var rho = eigenVals[eigenVals.length - 1];
        return abs(sqrt(rho));
    }
    /**
   * Calculate the infinity norm for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormInfinity(x) {
        // norm(x) = the largest row sum
        var r = [];
        // result
        var maxr = 0;
        // skip zeros since abs(0) == 0
        x.forEach(function(value, index) {
            var i = index[0];
            var ri = add(r[i] || 0, abs(value));
            if (larger(ri, maxr)) maxr = ri;
            r[i] = ri;
        }, true);
        return maxr;
    }
    /**
   * Calculate the norm for a 2D Matrix (M*N)
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNorm(x, p) {
        // check p
        if (p === 1) return _matrixNormOne(x);
        if (p === Number.POSITIVE_INFINITY || p === "inf") return _matrixNormInfinity(x);
        if (p === "fro") return _matrixNormFrobenius(x);
        if (p === 2) return _matrixNormTwo(x);
         // invalid parameter value
        throw new Error("Unsupported parameter value " + p);
    }
    /**
   * Calculate the norm for an array
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _norm(x, p) {
        // size
        var sizeX = x.size();
        // check if it is a vector
        if (sizeX.length === 1) return _vectorNorm(x, p);
        // MxN matrix
        if (sizeX.length === 2) {
            if (sizeX[0] && sizeX[1]) return _matrixNorm(x, p);
            else throw new RangeError("Invalid matrix dimensions");
        }
    }
});




var $be2e63de4538ed30$var$name = "not";
var $be2e63de4538ed30$var$dependencies = [
    "typed"
];
var $be2e63de4538ed30$export$8dbfb388cd6a8853 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($be2e63de4538ed30$var$name, $be2e63de4538ed30$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Logical `not`. Flips boolean value of a given parameter.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.not(x)
   *
   * Examples:
   *
   *    math.not(2)      // returns false
   *    math.not(0)      // returns true
   *    math.not(true)   // returns false
   *
   *    a = [2, -7, 0]
   *    math.not(a)      // returns [false, false, true]
   *
   * See also:
   *
   *    and, or, xor
   *
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} x First value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when input is a zero or empty value.
   */ return typed($be2e63de4538ed30$var$name, {
        "null | undefined": ()=>true,
        number: (0, $89192b5d651983ac$export$5c3e9fce4e8f3d3a),
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        BigNumber: function BigNumber(x) {
            return x.isZero() || x.isNaN();
        },
        bigint: (x)=>!x,
        Unit: typed.referToSelf((self)=>(x)=>typed.find(self, x.valueType())(x.value)),
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});








var $2274d53442855e7a$var$name = "nthRoot";
var $2274d53442855e7a$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber",
    "concat"
];
var $2274d53442855e7a$export$964e38ef60b1ac68 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($2274d53442855e7a$var$name, $2274d53442855e7a$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: _BigNumber, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $a0c1a11a7836c6b2$export$727ab96f88a9e651)({
        typed: typed
    });
    var matAlgo02xDS0 = (0, $94e325bf4fc92f8c$export$32ae34d6563cd126)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo06xS0S0 = (0, $bc13b8f894d6d714$export$7e944de5217ad25)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Calculate the nth root of a value.
   * The principal nth root of a positive real number A, is the positive real
   * solution of the equation
   *
   *     x^root = A
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *     math.nthRoot(a)
   *     math.nthRoot(a, root)
   *
   * Examples:
   *
   *     math.nthRoot(9, 2)    // returns 3 (since 3^2 == 9)
   *     math.sqrt(9)          // returns 3 (since 3^2 == 9)
   *     math.nthRoot(64, 3)   // returns 4 (since 4^3 == 64)
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param {number | BigNumber | Array | Matrix | Complex} a
   *              Value for which to calculate the nth root
   * @param {number | BigNumber} [root=2]    The root.
   * @return {number | Complex | Array | Matrix} Returns the nth root of `a`
   */ function complexErr() {
        throw new Error("Complex number not supported in function nthRoot. Use nthRoots instead.");
    }
    return typed($2274d53442855e7a$var$name, {
        number: (0, $f38f49d8e24d4a9f$export$9f26f16bd796a7b3),
        "number, number": (0, $f38f49d8e24d4a9f$export$9f26f16bd796a7b3),
        BigNumber: (x)=>_bigNthRoot(x, new _BigNumber(2)),
        "BigNumber, BigNumber": _bigNthRoot,
        Complex: complexErr,
        "Complex, number": complexErr,
        Array: typed.referTo("DenseMatrix,number", (selfDn)=>(x)=>selfDn(matrix(x), 2).valueOf()),
        DenseMatrix: typed.referTo("DenseMatrix,number", (selfDn)=>(x)=>selfDn(x, 2)),
        SparseMatrix: typed.referTo("SparseMatrix,number", (selfSn)=>(x)=>selfSn(x, 2)),
        "SparseMatrix, SparseMatrix": typed.referToSelf((self)=>(x, y)=>{
                // density must be one (no zeros in matrix)
                if (y.density() === 1) // sparse + sparse
                return matAlgo06xS0S0(x, y, self);
                else // throw exception
                throw new Error("Root must be non-zero");
            }),
        "DenseMatrix, SparseMatrix": typed.referToSelf((self)=>(x, y)=>{
                // density must be one (no zeros in matrix)
                if (y.density() === 1) // dense + sparse
                return matAlgo01xDSid(x, y, self, false);
                else // throw exception
                throw new Error("Root must be non-zero");
            }),
        "Array, SparseMatrix": typed.referTo("DenseMatrix,SparseMatrix", (selfDS)=>(x, y)=>selfDS(matrix(x), y)),
        "number | BigNumber, SparseMatrix": typed.referToSelf((self)=>(x, y)=>{
                // density must be one (no zeros in matrix)
                if (y.density() === 1) // sparse - scalar
                return matAlgo11xS0s(y, x, self, true);
                else // throw exception
                throw new Error("Root must be non-zero");
            })
    }, matrixAlgorithmSuite({
        scalar: "number | BigNumber",
        SD: matAlgo02xDS0,
        Ss: matAlgo11xS0s,
        sS: false
    }));
    /**
   * Calculate the nth root of a for BigNumbers, solve x^root == a
   * https://rosettacode.org/wiki/Nth_root#JavaScript
   * @param {BigNumber} a
   * @param {BigNumber} root
   * @private
   */ function _bigNthRoot(a, root) {
        var precision = _BigNumber.precision;
        var Big = _BigNumber.clone({
            precision: precision + 2
        });
        var zero = new _BigNumber(0);
        var one = new Big(1);
        var inv = root.isNegative();
        if (inv) root = root.neg();
        if (root.isZero()) throw new Error("Root must be non-zero");
        if (a.isNegative() && !root.abs().mod(2).equals(1)) throw new Error("Root must be odd when a is negative.");
        // edge cases zero and infinity
        if (a.isZero()) return inv ? new Big(Infinity) : 0;
        if (!a.isFinite()) return inv ? zero : a;
        var x = a.abs().pow(one.div(root));
        // If a < 0, we require that root is an odd integer,
        // so (-1) ^ (1/root) = -1
        x = a.isNeg() ? x.neg() : x;
        return new _BigNumber((inv ? one.div(x) : x).toPrecision(precision));
    }
});
var $2274d53442855e7a$export$f098cf3c4ef0f7ef = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($2274d53442855e7a$var$name, [
    "typed"
], (_ref2)=>{
    var { typed: typed } = _ref2;
    return typed($2274d53442855e7a$var$name, {
        number: (0, $f38f49d8e24d4a9f$export$9f26f16bd796a7b3),
        "number, number": (0, $f38f49d8e24d4a9f$export$9f26f16bd796a7b3)
    });
});


var $f89532c85ca94204$var$name = "nthRoots";
var $f89532c85ca94204$var$dependencies = [
    "config",
    "typed",
    "divideScalar",
    "Complex"
];
var $f89532c85ca94204$export$36e27b45d2aa738c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f89532c85ca94204$var$name, $f89532c85ca94204$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, Complex: Complex } = _ref;
    /**
   * Each function here returns a real multiple of i as a Complex value.
   * @param  {number} val
   * @return {Complex} val, i*val, -val or -i*val for index 0, 1, 2, 3
   */ // This is used to fix float artifacts for zero-valued components.
    var _calculateExactResult = [
        function realPos(val) {
            return new Complex(val, 0);
        },
        function imagPos(val) {
            return new Complex(0, val);
        },
        function realNeg(val) {
            return new Complex(-val, 0);
        },
        function imagNeg(val) {
            return new Complex(0, -val);
        }
    ];
    /**
   * Calculate the nth root of a Complex Number a using De Movire's Theorem.
   * @param  {Complex} a
   * @param  {number} root
   * @return {Array} array of n Complex Roots
   */ function _nthComplexRoots(a, root) {
        if (root < 0) throw new Error("Root must be greater than zero");
        if (root === 0) throw new Error("Root must be non-zero");
        if (root % 1 !== 0) throw new Error("Root must be an integer");
        if (a === 0 || a.abs() === 0) return [
            new Complex(0, 0)
        ];
        var aIsNumeric = typeof a === "number";
        var offset;
        // determine the offset (argument of a)/(pi/2)
        if (aIsNumeric || a.re === 0 || a.im === 0) {
            if (aIsNumeric) offset = 2 * +(a < 0); // numeric value on the real axis
            else if (a.im === 0) offset = 2 * +(a.re < 0); // complex value on the real axis
            else offset = 2 * +(a.im < 0) + 1; // complex value on the imaginary axis
        }
        var arg = a.arg();
        var abs = a.abs();
        var roots = [];
        var r = Math.pow(abs, 1 / root);
        for(var k = 0; k < root; k++){
            var halfPiFactor = (offset + 4 * k) / root;
            /**
       * If (offset + 4*k)/root is an integral multiple of pi/2
       * then we can produce a more exact result.
       */ if (halfPiFactor === Math.round(halfPiFactor)) {
                roots.push(_calculateExactResult[halfPiFactor % 4](r));
                continue;
            }
            roots.push(new Complex({
                r: r,
                phi: (arg + 2 * Math.PI * k) / root
            }));
        }
        return roots;
    }
    /**
   * Calculate the nth roots of a value.
   * An nth root of a positive real number A,
   * is a positive real solution of the equation "x^root = A".
   * This function returns an array of complex values.
   *
   * Syntax:
   *
   *    math.nthRoots(x)
   *    math.nthRoots(x, root)
   *
   * Examples:
   *
   *    math.nthRoots(1)
   *    // returns [
   *    //   {re: 1, im: 0},
   *    //   {re: -1, im: 0}
   *    // ]
   *    math.nthRoots(1, 3)
   *    // returns [
   *    //   { re: 1, im: 0 },
   *    //   { re: -0.4999999999999998, im: 0.8660254037844387 },
   *    //   { re: -0.5000000000000004, im: -0.8660254037844385 }
   *    // ]
   *
   * See also:
   *
   *    nthRoot, pow, sqrt
   *
   * @param {number | BigNumber | Fraction | Complex} x Number to be rounded
   * @param {number} [root=2] Optional root, default value is 2
   * @return {number | BigNumber | Fraction | Complex} Returns the nth roots
   */ return typed($f89532c85ca94204$var$name, {
        Complex: function Complex(x) {
            return _nthComplexRoots(x, 2);
        },
        "Complex, number": _nthComplexRoots
    });
});



var $dd1aaaf5bbafc3c8$var$name = "number";
var $dd1aaaf5bbafc3c8$var$dependencies = [
    "typed"
];
/**
 * Separates the radix, integer part, and fractional part of a non decimal number string
 * @param {string} input string to parse
 * @returns {object} the parts of the string or null if not a valid input
 */ function $dd1aaaf5bbafc3c8$var$getNonDecimalNumberParts(input) {
    var nonDecimalWithRadixMatch = input.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
    if (nonDecimalWithRadixMatch) {
        var radix = {
            "0b": 2,
            "0o": 8,
            "0x": 16
        }[nonDecimalWithRadixMatch[1]];
        var integerPart = nonDecimalWithRadixMatch[2];
        var fractionalPart = nonDecimalWithRadixMatch[3];
        return {
            input: input,
            radix: radix,
            integerPart: integerPart,
            fractionalPart: fractionalPart
        };
    } else return null;
}
/**
 * Makes a number from a radix, and integer part, and a fractional part
 * @param {parts} [x] parts of the number string (from getNonDecimalNumberParts)
 * @returns {number} the number
 */ function $dd1aaaf5bbafc3c8$var$makeNumberFromNonDecimalParts(parts) {
    var n = parseInt(parts.integerPart, parts.radix);
    var f = 0;
    for(var i = 0; i < parts.fractionalPart.length; i++){
        var digitValue = parseInt(parts.fractionalPart[i], parts.radix);
        f += digitValue / Math.pow(parts.radix, i + 1);
    }
    var result = n + f;
    if (isNaN(result)) throw new SyntaxError('String "' + parts.input + '" is not a valid number');
    return result;
}
var $dd1aaaf5bbafc3c8$export$763ee9f6477981ab = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($dd1aaaf5bbafc3c8$var$name, $dd1aaaf5bbafc3c8$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a number or convert a string, boolean, or unit to a number.
   * When value is a matrix, all elements will be converted to number.
   *
   * Syntax:
   *
   *    math.number(value)
   *    math.number(unit, valuelessUnit)
   *
   * Examples:
   *
   *    math.number(2)                         // returns number 2
   *    math.number('7.2')                     // returns number 7.2
   *    math.number(true)                      // returns number 1
   *    math.number([true, false, true, true]) // returns [1, 0, 1, 1]
   *    math.number(math.unit('52cm'), 'm')    // returns 0.52
   *
   * See also:
   *
   *    bignumber, bigint, boolean, numeric, complex, index, matrix, string, unit
   *
   * @param {string | number | BigNumber | Fraction | boolean | Array | Matrix | Unit | null} [value]  Value to be converted
   * @param {Unit | string} [valuelessUnit] A valueless unit, used to convert a unit to a number
   * @return {number | Array | Matrix} The created number
   */ var number = typed("number", {
        "": function _() {
            return 0;
        },
        number: function number(x) {
            return x;
        },
        string: function string(x) {
            if (x === "NaN") return NaN;
            var nonDecimalNumberParts = $dd1aaaf5bbafc3c8$var$getNonDecimalNumberParts(x);
            if (nonDecimalNumberParts) return $dd1aaaf5bbafc3c8$var$makeNumberFromNonDecimalParts(nonDecimalNumberParts);
            var size = 0;
            var wordSizeSuffixMatch = x.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
            if (wordSizeSuffixMatch) {
                // x includes a size suffix like 0xffffi32, so we extract
                // the suffix and remove it from x
                size = Number(wordSizeSuffixMatch[2]);
                x = wordSizeSuffixMatch[1];
            }
            var num = Number(x);
            if (isNaN(num)) throw new SyntaxError('String "' + x + '" is not a valid number');
            if (wordSizeSuffixMatch) {
                // x is a signed bin, oct, or hex literal
                // num is the value of string x if x is interpreted as unsigned
                if (num > 2 ** size - 1) // literal is too large for size suffix
                throw new SyntaxError('String "'.concat(x, '" is out of range'));
                // check if the bit at index size - 1 is set and if so do the twos complement
                if (num >= 2 ** (size - 1)) num = num - 2 ** size;
            }
            return num;
        },
        BigNumber: function BigNumber(x) {
            return x.toNumber();
        },
        bigint: function bigint(x) {
            return Number(x);
        },
        Fraction: function Fraction(x) {
            return x.valueOf();
        },
        Unit: typed.referToSelf((self)=>(x)=>{
                var clone = x.clone();
                clone.value = self(x.value);
                return clone;
            }),
        null: function _null(x) {
            return 0;
        },
        "Unit, string | Unit": function UnitStringUnit(unit, valuelessUnit) {
            return unit.toNumber(valuelessUnit);
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
    // reviver function to parse a JSON object like:
    //
    //     {"mathjs":"number","value":"2.3"}
    //
    // into a number 2.3
    number.fromJSON = function(json) {
        return parseFloat(json.value);
    };
    return number;
});



function $ba7e85df6c2910bf$export$f0829713dc162a8() {
    throw new Error('No "bignumber" implementation available');
}
function $ba7e85df6c2910bf$export$9978fd42ef220ba0() {
    throw new Error('No "fraction" implementation available');
}
function $ba7e85df6c2910bf$export$b81416cb7ecca475() {
    throw new Error('No "matrix" implementation available');
}
function $ba7e85df6c2910bf$export$a38f8cf2e48f2bd() {
    throw new Error('No "index" implementation available');
}
function $ba7e85df6c2910bf$export$32411ef9704d5eea() {
    throw new Error('No "matrix" implementation available');
}


var $3d940ca8d5f722a7$var$name = "numeric";
var $3d940ca8d5f722a7$var$dependencies = [
    "number",
    "?bignumber",
    "?fraction"
];
var $3d940ca8d5f722a7$export$e3cf2d123164e554 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3d940ca8d5f722a7$var$name, $3d940ca8d5f722a7$var$dependencies, (_ref)=>{
    var { number: _number, bignumber: bignumber, fraction: fraction } = _ref;
    var validInputTypes = {
        string: true,
        number: true,
        BigNumber: true,
        Fraction: true
    };
    // Load the conversion functions for each output type
    var validOutputTypes = {
        number: (x)=>_number(x),
        BigNumber: bignumber ? (x)=>bignumber(x) : (0, $ba7e85df6c2910bf$export$f0829713dc162a8),
        bigint: (x)=>BigInt(x),
        Fraction: fraction ? (x)=>fraction(x) : (0, $ba7e85df6c2910bf$export$9978fd42ef220ba0)
    };
    /**
   * Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.
   *
   * Syntax:
   *
   *    math.numeric(x)
   *
   * Examples:
   *
   *    math.numeric('4')                           // returns 4
   *    math.numeric('4', 'number')                 // returns 4
   *    math.numeric('4', 'bigint')                 // returns 4n
   *    math.numeric('4', 'BigNumber')              // returns BigNumber 4
   *    math.numeric('4', 'Fraction')               // returns Fraction 4
   *    math.numeric(4, 'Fraction')                 // returns Fraction 4
   *    math.numeric(math.fraction(2, 5), 'number') // returns 0.4
   *
   * See also:
   *
   *    number, fraction, bignumber, bigint, string, format
   *
   * @param {string | number | BigNumber | bigint | Fraction } value
   *              A numeric value or a string containing a numeric value
   * @param {string} outputType
   *              Desired numeric output type.
   *              Available values: 'number', 'BigNumber', or 'Fraction'
   * @return {number | BigNumber | bigint | Fraction}
   *              Returns an instance of the numeric in the requested type
   */ return function numeric(value) {
        var outputType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "number";
        var check = arguments.length > 2 ? arguments[2] : undefined;
        if (check !== undefined) throw new SyntaxError("numeric() takes one or two arguments");
        var inputType = (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(value);
        if (!(inputType in validInputTypes)) throw new TypeError("Cannot convert " + value + ' of type "' + inputType + '"; valid input types are ' + Object.keys(validInputTypes).join(", "));
        if (!(outputType in validOutputTypes)) throw new TypeError("Cannot convert " + value + ' to type "' + outputType + '"; valid output types are ' + Object.keys(validOutputTypes).join(", "));
        if (outputType === inputType) return value;
        else return validOutputTypes[outputType](value);
    };
});


var $11e7ed358b24e81c$var$name = "oct";
var $11e7ed358b24e81c$var$dependencies = [
    "typed",
    "format"
];
var $11e7ed358b24e81c$export$6692788ef49c21c9 = (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($11e7ed358b24e81c$var$name, $11e7ed358b24e81c$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($11e7ed358b24e81c$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            return format(n, {
                notation: "oct"
            });
        },
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, wordSize) {
            return format(n, {
                notation: "oct",
                wordSize: wordSize
            });
        }
    });
});





var $6337772943e476d6$var$name = "ones";
var $6337772943e476d6$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $6337772943e476d6$export$f524a435b9c16a90 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6337772943e476d6$var$name, $6337772943e476d6$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Create a matrix filled with ones. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.ones(m)
   *    math.ones(m, format)
   *    math.ones(m, n)
   *    math.ones(m, n, format)
   *    math.ones([m, n])
   *    math.ones([m, n], format)
   *    math.ones([m, n, p, ...])
   *    math.ones([m, n, p, ...], format)
   *
   * Examples:
   *
   *    math.ones()                    // returns []
   *    math.ones(3)                   // returns [1, 1, 1]
   *    math.ones(3, 2)                // returns [[1, 1], [1, 1], [1, 1]]
   *    math.ones(3, 2, 'dense')       // returns Dense Matrix [[1, 1], [1, 1], [1, 1]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.ones(math.size(A))       // returns [[1, 1, 1], [1, 1, 1]]
   *
   * See also:
   *
   *    zeros, identity, size, range
   *
   * @param {...(number|BigNumber) | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix | number}  A matrix filled with ones
   */ return typed("ones", {
        "": function _() {
            return config.matrix === "Array" ? _ones([]) : _ones([], "default");
        },
        // math.ones(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        "...number | BigNumber | string": function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === "string") {
                var format = size.pop();
                return _ones(size, format);
            } else if (config.matrix === "Array") return _ones(size);
            else return _ones(size, "default");
        },
        Array: _ones,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _ones(size.valueOf(), format);
        },
        "Array | Matrix, string": function ArrayMatrixString(size, format) {
            return _ones(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with ones
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _ones(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(1) : 1;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $eee21df0c3527ff1$export$4380c87abf28fdf)(arr, size, defaultValue);
            return arr;
        }
    }
    // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    }
    // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== "number" || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(value) || value < 0) throw new Error("Parameters in function ones must be positive integers");
        });
    }
});







var $cfe9a4f8156ec37d$var$name = "or";
var $cfe9a4f8156ec37d$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix",
    "concat"
];
var $cfe9a4f8156ec37d$export$3d19b09907d6fd4a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($cfe9a4f8156ec37d$var$name, $cfe9a4f8156ec37d$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo05xSfSf = (0, $a54f9597be0f9a42$export$a0ee15a3591ad1a)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Logical `or`. Test if at least one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.or(x, y)
   *
   * Examples:
   *
   *    math.or(2, 4)   // returns true
   *
   *    a = [2, 5, 0]
   *    b = [0, 22, 0]
   *    c = 0
   *
   *    math.or(a, b)   // returns [true, true, false]
   *    math.or(b, c)   // returns [false, true, false]
   *
   * See also:
   *
   *    and, not, xor
   *
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one of the inputs is defined with a nonzero/nonempty value.
   */ return typed($cfe9a4f8156ec37d$var$name, {
        "number, number": (0, $89192b5d651983ac$export$cb9e31d07eec8012),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.re !== 0 || x.im !== 0 || y.re !== 0 || y.im !== 0;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return !x.isZero() && !x.isNaN() || !y.isZero() && !y.isNaN();
        },
        "bigint, bigint": (0, $89192b5d651983ac$export$cb9e31d07eec8012),
        "Unit, Unit": typed.referToSelf((self)=>(x, y)=>self(x.value || 0, y.value || 0))
    }, matrixAlgorithmSuite({
        SS: matAlgo05xSfSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});




var $95b22b407d00a096$var$name = "partitionSelect";
var $95b22b407d00a096$var$dependencies = [
    "typed",
    "isNumeric",
    "isNaN",
    "compare"
];
var $95b22b407d00a096$export$47c1a746705f5c42 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($95b22b407d00a096$var$name, $95b22b407d00a096$var$dependencies, (_ref)=>{
    var { typed: typed, isNumeric: isNumeric, isNaN: isNaN, compare: compare } = _ref;
    var asc = compare;
    var desc = (a, b)=>-compare(a, b);
    /**
   * Partition-based selection of an array or 1D matrix.
   * Will find the kth smallest value, and mutates the input array.
   * Uses Quickselect.
   *
   * Syntax:
   *
   *    math.partitionSelect(x, k)
   *    math.partitionSelect(x, k, compare)
   *
   * Examples:
   *
   *    math.partitionSelect([5, 10, 1], 2)                               // returns 10
   *    math.partitionSelect(['C', 'B', 'A', 'D'], 1, math.compareText)   // returns 'B'
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.partitionSelect(['Langdon', 'Tom', 'Sara'], 2, sortByLength) // returns 'Langdon'
   *
   *    // the input array is mutated
   *    arr = [5, 2, 1]
   *    math.partitionSelect(arr, 0) // returns 1, arr is now: [1, 2, 5]
   *    math.partitionSelect(arr, 1, 'desc') // returns 2, arr is now: [5, 2, 1]
   *
   * See also:
   *
   *    sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Number} k            The kth smallest value to be retrieved zero-based index
   * @param {Function | 'asc' | 'desc'} [compare='asc']
   *        An optional comparator function. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {*} Returns the kth lowest value.
   */ return typed($95b22b407d00a096$var$name, {
        "Array | Matrix, number": function ArrayMatrixNumber(x, k) {
            return _partitionSelect(x, k, asc);
        },
        "Array | Matrix, number, string": function ArrayMatrixNumberString(x, k, compare) {
            if (compare === "asc") return _partitionSelect(x, k, asc);
            else if (compare === "desc") return _partitionSelect(x, k, desc);
            else throw new Error('Compare string must be "asc" or "desc"');
        },
        "Array | Matrix, number, function": _partitionSelect
    });
    function _partitionSelect(x, k, compare) {
        if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(k) || k < 0) throw new Error("k must be a non-negative integer");
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(x)) {
            var size = x.size();
            if (size.length > 1) throw new Error("Only one dimensional matrices supported");
            return quickSelect(x.valueOf(), k, compare);
        }
        if (Array.isArray(x)) return quickSelect(x, k, compare);
    }
    /**
   * Quickselect algorithm.
   * Code adapted from:
   * https://blog.teamleadnet.com/2012/07/quick-select-algorithm-find-kth-element.html
   *
   * @param {Array} arr
   * @param {Number} k
   * @param {Function} compare
   * @private
   */ function quickSelect(arr, k, compare) {
        if (k >= arr.length) throw new Error("k out of bounds");
        // check for NaN values since these can cause an infinite while loop
        for(var i = 0; i < arr.length; i++){
            if (isNumeric(arr[i]) && isNaN(arr[i])) return arr[i]; // return NaN
        }
        var from = 0;
        var to = arr.length - 1;
        // if from == to we reached the kth element
        while(from < to){
            var r = from;
            var w = to;
            var pivot = arr[Math.floor(Math.random() * (to - from + 1)) + from];
            // stop if the reader and writer meets
            while(r < w)// arr[r] >= pivot
            if (compare(arr[r], pivot) >= 0) {
                // put the large values at the end
                var tmp = arr[w];
                arr[w] = arr[r];
                arr[r] = tmp;
                --w;
            } else // the value is smaller than the pivot, skip
            ++r;
            // if we stepped up (r++) we need to step one down (arr[r] > pivot)
            if (compare(arr[r], pivot) > 0) --r;
            // the r pointer is on the end of the first k elements
            if (k <= r) to = r;
            else from = r + 1;
        }
        return arr[k];
    }
});




var $9e4e8d94f58c66f2$var$name = "permutations";
var $9e4e8d94f58c66f2$var$dependencies = [
    "typed",
    "factorial"
];
var $9e4e8d94f58c66f2$export$1d58d7915914cc9c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9e4e8d94f58c66f2$var$name, $9e4e8d94f58c66f2$var$dependencies, (_ref)=>{
    var { typed: typed, factorial: factorial } = _ref;
    /**
   * Compute the number of ways of obtaining an ordered subset of `k` elements
   * from a set of `n` elements.
   *
   * Permutations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.permutations(n)
   *     math.permutations(n, k)
   *
   * Examples:
   *
   *    math.permutations(5)     // 120
   *    math.permutations(5, 3)  // 60
   *
   * See also:
   *
   *    combinations, combinationsWithRep, factorial
   *
   * @param {number | BigNumber} n   The number of objects in total
   * @param {number | BigNumber} [k] The number of objects in the subset
   * @return {number | BigNumber}    The number of permutations
   */ return typed($9e4e8d94f58c66f2$var$name, {
        "number | BigNumber": factorial,
        "number, number": function numberNumber(n, k) {
            if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(n) || n < 0) throw new TypeError("Positive integer value expected in function permutations");
            if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(k) || k < 0) throw new TypeError("Positive integer value expected in function permutations");
            if (k > n) throw new TypeError("second argument k must be less than or equal to first argument n");
            // Permute n objects, k at a time
            return (0, $22c7ec3c40338f55$export$dbd0f18357df1ddd)(n - k + 1, n);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var result, i;
            if (!$9e4e8d94f58c66f2$var$isPositiveInteger(n) || !$9e4e8d94f58c66f2$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function permutations");
            if (k.gt(n)) throw new TypeError("second argument k must be less than or equal to first argument n");
            var one = n.mul(0).add(1);
            result = one;
            for(i = n.minus(k).plus(1); i.lte(n); i = i.plus(1))result = result.times(i);
            return result;
        }
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $9e4e8d94f58c66f2$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}





var $8f353717497e9626$var$singletonRandom = /* #__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($922020686b51a817$exports)))(Date.now());
function $8f353717497e9626$export$eaf9227667332084(randomSeed) {
    var random;
    // create a new random generator with given seed
    function setSeed(seed) {
        random = seed === null ? $8f353717497e9626$var$singletonRandom : (0, (/*@__PURE__*/$parcel$interopDefault($922020686b51a817$exports)))(String(seed));
    }
    // initialize a seeded pseudo random number generator with config's random seed
    setSeed(randomSeed);
    // wrapper function so the rng can be updated via generator
    function rng() {
        return random();
    }
    return rng;
}


var $25c930acffc7ae34$var$name = "pickRandom";
var $25c930acffc7ae34$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $25c930acffc7ae34$export$fbe25b9f25feec34 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($25c930acffc7ae34$var$name, $25c930acffc7ae34$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $8f353717497e9626$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $8f353717497e9626$export$eaf9227667332084)(curr.randomSeed);
    });
    /**
   * Random pick one or more values from a one dimensional array.
   * Array elements are picked using a random function with uniform or weighted distribution.
   *
   * Syntax:
   *
   *     math.pickRandom(array)
   *     math.pickRandom(array, number)
   *     math.pickRandom(array, weights)
   *     math.pickRandom(array, number, weights)
   *     math.pickRandom(array, weights, number)
   *     math.pickRandom(array, { weights, number, elementWise })
   *
   * Examples:
   *
   *     math.pickRandom([3, 6, 12, 2])                  // returns one of the values in the array
   *     math.pickRandom([3, 6, 12, 2], 2)               // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], { number: 2 })   // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1])    // returns one of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], 2, [1, 3, 2, 1]) // returns an array of two of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1], 2) // returns an array of two of the values in the array with weighted distribution
   *
   *     math.pickRandom([{x: 1.0, y: 2.0}, {x: 1.1, y: 2.0}], { elementWise: false })
   *         // returns one of the items in the array
   *
   * See also:
   *
   *     random, randomInt
   *
   * @param {Array | Matrix} array     A one dimensional array
   * @param {Int} number               An int or float
   * @param {Array | Matrix} weights   An array of ints or floats
   * @return {number | Array}          Returns a single random value from array when number is undefined.
   *                                   Returns an array with the configured number of elements when number is defined.
   */ return typed($25c930acffc7ae34$var$name, {
        "Array | Matrix": function ArrayMatrix(possibles) {
            return _pickRandom(possibles, {});
        },
        "Array | Matrix, Object": function ArrayMatrixObject(possibles, options) {
            return _pickRandom(possibles, options);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(possibles, number) {
            return _pickRandom(possibles, {
                number: number
            });
        },
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(possibles, weights) {
            return _pickRandom(possibles, {
                weights: weights
            });
        },
        "Array | Matrix, Array | Matrix, number": function ArrayMatrixArrayMatrixNumber(possibles, weights, number) {
            return _pickRandom(possibles, {
                number: number,
                weights: weights
            });
        },
        "Array | Matrix, number, Array | Matrix": function ArrayMatrixNumberArrayMatrix(possibles, number, weights) {
            return _pickRandom(possibles, {
                number: number,
                weights: weights
            });
        }
    });
    /**
   * @param {Array | Matrix} possibles
   * @param {{
   *   number?: number,
   *   weights?: Array | Matrix,
   *   elementWise: boolean
   * }} options
   * @returns {number | Array}
   * @private
   */ function _pickRandom(possibles, _ref2) {
        var { number: number, weights: weights, elementWise: elementWise = true } = _ref2;
        var single = typeof number === "undefined";
        if (single) number = 1;
        var createMatrix = (0, $23cfe017d190638f$export$b22160e0a14f87b7)(possibles) ? possibles.create : (0, $23cfe017d190638f$export$b22160e0a14f87b7)(weights) ? weights.create : null;
        possibles = possibles.valueOf(); // get Array
        if (weights) weights = weights.valueOf(); // get Array
        if (elementWise === true) {
            possibles = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(possibles);
            weights = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(weights);
        }
        var totalWeights = 0;
        if (typeof weights !== "undefined") {
            if (weights.length !== possibles.length) throw new Error("Weights must have the same length as possibles");
            for(var i = 0, len = weights.length; i < len; i++){
                if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(weights[i]) || weights[i] < 0) throw new Error("Weights must be an array of positive numbers");
                totalWeights += weights[i];
            }
        }
        var length = possibles.length;
        var result = [];
        var pick;
        while(result.length < number){
            if (typeof weights === "undefined") pick = possibles[Math.floor(rng() * length)];
            else {
                var randKey = rng() * totalWeights;
                for(var _i = 0, _len = possibles.length; _i < _len; _i++){
                    randKey -= weights[_i];
                    if (randKey < 0) {
                        pick = possibles[_i];
                        break;
                    }
                }
            }
            result.push(pick);
        }
        return single ? result[0] : createMatrix ? createMatrix(result) : result;
    }
});






var $38b7699e16ae7f7c$var$name = "pinv";
var $38b7699e16ae7f7c$var$dependencies = [
    "typed",
    "matrix",
    "inv",
    "deepEqual",
    "equal",
    "dotDivide",
    "dot",
    "ctranspose",
    "divideScalar",
    "multiply",
    "add",
    "Complex"
];
var $38b7699e16ae7f7c$export$1456c5eaeee6aa07 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($38b7699e16ae7f7c$var$name, $38b7699e16ae7f7c$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, inv: inv, deepEqual: deepEqual, equal: equal, dotDivide: dotDivide, dot: dot, ctranspose: ctranspose, divideScalar: divideScalar, multiply: multiply, add: add, Complex: Complex } = _ref;
    /**
   * Calculate the Moore–Penrose inverse of a matrix.
   *
   * Syntax:
   *
   *     math.pinv(x)
   *
   * Examples:
   *
   *     math.pinv([[1, 2], [3, 4]])          // returns [[-2, 1], [1.5, -0.5]]
   *     math.pinv([[1, 0], [0, 1], [0, 1]])  // returns [[1, 0, 0], [0, 0.5, 0.5]]
   *     math.pinv(4)                         // returns 0.25
   *
   * See also:
   *
   *     inv
   *
   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
   * @return {number | Complex | Array | Matrix} The inverse of `x`.
   */ return typed($38b7699e16ae7f7c$var$name, {
        "Array | Matrix": function ArrayMatrix(x) {
            var size = (0, $23cfe017d190638f$export$b22160e0a14f87b7)(x) ? x.size() : (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x);
            switch(size.length){
                case 1:
                    // vector
                    if (_isZeros(x)) return ctranspose(x); // null vector
                    if (size[0] === 1) return inv(x); // invertible matrix
                    else return dotDivide(ctranspose(x), dot(x, x));
                case 2:
                    if (_isZeros(x)) return ctranspose(x); // zero matrixx
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) try {
                        return inv(x); // invertible matrix
                    } catch (err) {
                        if (err instanceof Error && err.message.match(/Cannot calculate inverse, determinant is zero/)) ;
                        else throw err;
                    }
                    if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(x)) return matrix(_pinv(x.valueOf(), rows, cols), x.storage());
                    else // return an Array
                    return _pinv(x, rows, cols);
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
            }
        },
        any: function any(x) {
            // scalar
            if (equal(x, 0)) return (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(x); // zero
            return divideScalar(1, x);
        }
    });
    /**
   * Calculate the Moore–Penrose inverse of a matrix
   * @param {Array[]} mat     A matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns
   * @return {Array[]} pinv    Pseudoinverse matrix
   * @private
   */ function _pinv(mat, rows, cols) {
        var { C: C, F: F } = _rankFact(mat, rows, cols); // TODO: Use SVD instead (may improve precision)
        var Cpinv = multiply(inv(multiply(ctranspose(C), C)), ctranspose(C));
        var Fpinv = multiply(ctranspose(F), inv(multiply(F, ctranspose(F))));
        return multiply(Fpinv, Cpinv);
    }
    /**
   * Calculate the reduced row echelon form of a matrix
   *
   * Modified from https://rosettacode.org/wiki/Reduced_row_echelon_form
   *
   * @param {Array[]} mat     A matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns
   * @return {Array[]}        Reduced row echelon form
   * @private
   */ function _rref(mat, rows, cols) {
        var M = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(mat);
        var lead = 0;
        for(var r = 0; r < rows; r++){
            if (cols <= lead) return M;
            var i = r;
            while(_isZero(M[i][lead])){
                i++;
                if (rows === i) {
                    i = r;
                    lead++;
                    if (cols === lead) return M;
                }
            }
            [M[i], M[r]] = [
                M[r],
                M[i]
            ];
            var val = M[r][lead];
            for(var j = 0; j < cols; j++)M[r][j] = dotDivide(M[r][j], val);
            for(var _i = 0; _i < rows; _i++){
                if (_i === r) continue;
                val = M[_i][lead];
                for(var _j = 0; _j < cols; _j++)M[_i][_j] = add(M[_i][_j], multiply(-1, multiply(val, M[r][_j])));
            }
            lead++;
        }
        return M;
    }
    /**
   * Calculate the rank factorization of a matrix
   *
   * @param {Array[]} mat                  A matrix (M)
   * @param {number} rows                  Number of rows
   * @param {number} cols                  Number of columns
   * @return {{C: Array, F: Array}}        rank factorization where M = C F
   * @private
   */ function _rankFact(mat, rows, cols) {
        var rref = _rref(mat, rows, cols);
        var C = mat.map((_, i)=>_.filter((_, j)=>j < rows && !_isZero(dot(rref[j], rref[j]))));
        var F = rref.filter((_, i)=>!_isZero(dot(rref[i], rref[i])));
        return {
            C: C,
            F: F
        };
    }
    function _isZero(x) {
        return equal(add(x, Complex(1, 1)), add(0, Complex(1, 1)));
    }
    function _isZeros(arr) {
        return deepEqual(add(arr, Complex(1, 1)), add(multiply(arr, 0), Complex(1, 1)));
    }
});


var $bc14bec9ad559c32$var$name = "polynomialRoot";
var $bc14bec9ad559c32$var$dependencies = [
    "typed",
    "isZero",
    "equalScalar",
    "add",
    "subtract",
    "multiply",
    "divide",
    "sqrt",
    "unaryMinus",
    "cbrt",
    "typeOf",
    "im",
    "re"
];
var $bc14bec9ad559c32$export$b41551d8a03b9b7f = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($bc14bec9ad559c32$var$name, $bc14bec9ad559c32$var$dependencies, (_ref)=>{
    var { typed: typed, isZero: isZero, equalScalar: equalScalar, add: add, subtract: subtract, multiply: multiply, divide: divide, sqrt: sqrt, unaryMinus: unaryMinus, cbrt: cbrt, typeOf: typeOf, im: im, re: re } = _ref;
    /**
   * Finds the numerical values of the distinct roots of a polynomial with real or complex coefficients.
   * Currently operates only on linear, quadratic, and cubic polynomials using the standard
   * formulas for the roots.
   *
   * Syntax:
   *
   *     math.polynomialRoot(constant, linearCoeff, quadraticCoeff, cubicCoeff)
   *
   * Examples:
   *     // linear
   *     math.polynomialRoot(6, 3)                                        // [-2]
   *     math.polynomialRoot(math.complex(6,3), 3)                        // [-2 - i]
   *     math.polynomialRoot(math.complex(6,3), math.complex(2,1))        // [-3 + 0i]
   *     // quadratic
   *     math.polynomialRoot(2, -3, 1)                                    // [2, 1]
   *     math.polynomialRoot(8, 8, 2)                                     // [-2]
   *     math.polynomialRoot(-2, 0, 1)                                    // [1.4142135623730951, -1.4142135623730951]
   *     math.polynomialRoot(2, -2, 1)                                    // [1 + i, 1 - i]
   *     math.polynomialRoot(math.complex(1,3), math.complex(-3, -2), 1)  // [2 + i, 1 + i]
   *     // cubic
   *     math.polynomialRoot(-6, 11, -6, 1)                               // [1, 3, 2]
   *     math.polynomialRoot(-8, 0, 0, 1)                                 // [-1 - 1.7320508075688774i, 2, -1 + 1.7320508075688774i]
   *     math.polynomialRoot(0, 8, 8, 2)                                  // [0, -2]
   *     math.polynomialRoot(1, 1, 1, 1)                                  // [-1 + 0i, 0 - i, 0 + i]
   *
   * See also:
   *     cbrt, sqrt
   *
   * @param {... number | Complex} coeffs
   *     The coefficients of the polynomial, starting with with the constant coefficent, followed
   *     by the linear coefficient and subsequent coefficients of increasing powers.
   * @return {Array} The distinct roots of the polynomial
   */ return typed($bc14bec9ad559c32$var$name, {
        "number|Complex, ...number|Complex": (constant, restCoeffs)=>{
            var coeffs = [
                constant,
                ...restCoeffs
            ];
            while(coeffs.length > 0 && isZero(coeffs[coeffs.length - 1]))coeffs.pop();
            if (coeffs.length < 2) throw new RangeError("Polynomial [".concat(constant, ", ").concat(restCoeffs, "] must have a non-zero non-constant coefficient"));
            switch(coeffs.length){
                case 2:
                    // linear
                    return [
                        unaryMinus(divide(coeffs[0], coeffs[1]))
                    ];
                case 3:
                    // quadratic
                    var [c, b, a] = coeffs;
                    var denom = multiply(2, a);
                    var d1 = multiply(b, b);
                    var d2 = multiply(4, a, c);
                    if (equalScalar(d1, d2)) return [
                        divide(unaryMinus(b), denom)
                    ];
                    var discriminant = sqrt(subtract(d1, d2));
                    return [
                        divide(subtract(discriminant, b), denom),
                        divide(subtract(unaryMinus(discriminant), b), denom)
                    ];
                case 4:
                    // cubic, cf. https://en.wikipedia.org/wiki/Cubic_equation
                    var [d, _c, _b, _a] = coeffs;
                    var _denom = unaryMinus(multiply(3, _a));
                    var D0_1 = multiply(_b, _b);
                    var D0_2 = multiply(3, _a, _c);
                    var D1_1 = add(multiply(2, _b, _b, _b), multiply(27, _a, _a, d));
                    var D1_2 = multiply(9, _a, _b, _c);
                    if (equalScalar(D0_1, D0_2) && equalScalar(D1_1, D1_2)) return [
                        divide(_b, _denom)
                    ];
                    var Delta0 = subtract(D0_1, D0_2);
                    var Delta1 = subtract(D1_1, D1_2);
                    var discriminant1 = add(multiply(18, _a, _b, _c, d), multiply(_b, _b, _c, _c));
                    var discriminant2 = add(multiply(4, _b, _b, _b, d), multiply(4, _a, _c, _c, _c), multiply(27, _a, _a, d, d));
                    if (equalScalar(discriminant1, discriminant2)) return [
                        divide(subtract(multiply(4, _a, _b, _c), add(multiply(9, _a, _a, d), multiply(_b, _b, _b))), multiply(_a, Delta0)),
                        // simple root
                        divide(subtract(multiply(9, _a, d), multiply(_b, _c)), multiply(2, Delta0)) // double root
                    ];
                    // OK, we have three distinct roots
                    var Ccubed;
                    if (equalScalar(D0_1, D0_2)) Ccubed = Delta1;
                    else Ccubed = divide(add(Delta1, sqrt(subtract(multiply(Delta1, Delta1), multiply(4, Delta0, Delta0, Delta0)))), 2);
                    var allRoots = true;
                    var rawRoots = cbrt(Ccubed, allRoots).toArray().map((C)=>divide(add(_b, C, divide(Delta0, C)), _denom));
                    return rawRoots.map((r)=>{
                        if (typeOf(r) === "Complex" && equalScalar(re(r), re(r) + im(r))) return re(r);
                        return r;
                    });
                default:
                    throw new RangeError("only implemented for cubic or lower-order polynomials, not ".concat(coeffs));
            }
        }
    });
});





var $d6b57bce62d2aee4$var$name = "pow";
var $d6b57bce62d2aee4$var$dependencies = [
    "typed",
    "config",
    "identity",
    "multiply",
    "matrix",
    "inv",
    "fraction",
    "number",
    "Complex"
];
var $d6b57bce62d2aee4$export$9c94d2d08a8d8146 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d6b57bce62d2aee4$var$name, $d6b57bce62d2aee4$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, identity: identity, multiply: multiply, matrix: matrix, inv: inv, number: number, fraction: fraction, Complex: Complex } = _ref;
    /**
   * Calculates the power of x to y, `x ^ y`.
   *
   * Matrix exponentiation is supported for square matrices `x` and integers `y`:
   * when `y` is nonnegative, `x` may be any square matrix; and when `y` is
   * negative, `x` must be invertible, and then this function returns
   * inv(x)^(-y).
   *
   * For cubic roots of negative numbers, the function returns the principal
   * root by default. In order to let the function return the real root,
   * math.js can be configured with `math.config({predictable: true})`.
   * To retrieve all cubic roots of a value, use `math.cbrt(x, true)`.
   *
   * Syntax:
   *
   *    math.pow(x, y)
   *
   * Examples:
   *
   *    math.pow(2, 3)               // returns number 8
   *
   *    const a = math.complex(2, 3)
   *    math.pow(a, 2)                // returns Complex -5 + 12i
   *
   *    const b = [[1, 2], [4, 3]]
   *    math.pow(b, 2)               // returns Array [[9, 8], [16, 17]]
   *
   *    const c = [[1, 2], [4, 3]]
   *    math.pow(c, -1)               // returns Array [[-0.6, 0.4], [0.8, -0.2]]
   *
   * See also:
   *
   *    multiply, sqrt, cbrt, nthRoot
   *
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | bigint | Complex} y                          The exponent
   * @return {number | BigNumber | bigint | Complex | Array | Matrix} The value of `x` to the power `y`
   */ return typed($d6b57bce62d2aee4$var$name, {
        "number, number": _pow,
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.pow(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            if (y.isInteger() || x >= 0 || config.predictable) return x.pow(y);
            else return new Complex(x.toNumber(), 0).pow(y.toNumber(), 0);
        },
        "bigint, bigint": (x, y)=>x ** y,
        "Fraction, Fraction": function FractionFraction(x, y) {
            var result = x.pow(y);
            if (result != null) return result;
            if (config.predictable) throw new Error("Result of pow is non-rational and cannot be expressed as a fraction");
            else return _pow(x.valueOf(), y.valueOf());
        },
        "Array, number": _powArray,
        "Array, BigNumber": function ArrayBigNumber(x, y) {
            return _powArray(x, y.toNumber());
        },
        "Matrix, number": _powMatrix,
        "Matrix, BigNumber": function MatrixBigNumber(x, y) {
            return _powMatrix(x, y.toNumber());
        },
        "Unit, number | BigNumber": function UnitNumberBigNumber(x, y) {
            return x.pow(y);
        }
    });
    /**
   * Calculates the power of x to y, x^y, for two numbers.
   * @param {number} x
   * @param {number} y
   * @return {number | Complex} res
   * @private
   */ function _pow(x, y) {
        // Alternatively could define a 'realmode' config option or something, but
        // 'predictable' will work for now
        if (config.predictable && !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(y) && x < 0) // Check to see if y can be represented as a fraction
        try {
            var yFrac = fraction(y);
            var yNum = number(yFrac);
            if (y === yNum || Math.abs((y - yNum) / y) < 1e-14) {
                if (yFrac.d % 2 === 1) return (yFrac.n % 2 === 0 ? 1 : -1) * Math.pow(-x, y);
            }
        } catch (ex) {
        // fraction() throws an error if y is Infinity, etc.
        }
        // **for predictable mode** x^Infinity === NaN if x < -1
        // N.B. this behavour is different from `Math.pow` which gives
        // (-2)^Infinity === Infinity
        if (config.predictable && (x < -1 && y === Infinity || x > -1 && x < 0 && y === -Infinity)) return NaN;
        if ((0, $a246eb207aab6d09$export$a287f47fed4544b8)(y) || x >= 0 || config.predictable) return (0, $f38f49d8e24d4a9f$export$3f512e7fd4999e01)(x, y);
        else {
            // TODO: the following infinity checks are duplicated from powNumber. Deduplicate this somehow
            // x^Infinity === 0 if -1 < x < 1
            // A real number 0 is returned instead of complex(0)
            if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
            return new Complex(x, 0).pow(y, 0);
        }
    }
    /**
   * Calculate the power of a 2d array
   * @param {Array} x     must be a 2 dimensional, square matrix
   * @param {number} y    a integer value (positive if `x` is not invertible)
   * @returns {Array}
   * @private
   */ function _powArray(x, y) {
        if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(y)) throw new TypeError("For A^b, b must be an integer (value is " + y + ")");
        // verify that A is a 2 dimensional square matrix
        var s = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(x);
        if (s.length !== 2) throw new Error("For A^b, A must be 2 dimensional (A has " + s.length + " dimensions)");
        if (s[0] !== s[1]) throw new Error("For A^b, A must be square (size is " + s[0] + "x" + s[1] + ")");
        if (y < 0) try {
            return _powArray(inv(x), -y);
        } catch (error) {
            if (error.message === "Cannot calculate inverse, determinant is zero") throw new TypeError("For A^b, when A is not invertible, b must be a positive integer (value is " + y + ")");
            throw error;
        }
        var res = identity(s[0]).valueOf();
        var px = x;
        while(y >= 1){
            if ((y & 1) === 1) res = multiply(px, res);
            y >>= 1;
            px = multiply(px, px);
        }
        return res;
    }
    /**
   * Calculate the power of a 2d matrix
   * @param {Matrix} x     must be a 2 dimensional, square matrix
   * @param {number} y    a positive, integer value
   * @returns {Matrix}
   * @private
   */ function _powMatrix(x, y) {
        return matrix(_powArray(x.valueOf(), y));
    }
});




var $6cdeefd9bf00c3e2$export$d0aef82ef51185f0 = /\$([\w.]+)/g;


var $4e89f948aaeed74d$var$name = "print";
var $4e89f948aaeed74d$var$dependencies = [
    "typed"
];
var $4e89f948aaeed74d$export$ea4b9d9569ff81cc = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($4e89f948aaeed74d$var$name, $4e89f948aaeed74d$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Interpolate values into a string template.
   *
   * Syntax:
   *
   *     math.print(template, values)
   *     math.print(template, values, precision)
   *     math.print(template, values, options)
   *
   * Example usage:
   *
   *     // the following outputs: 'Lucy is 5 years old'
   *     math.print('Lucy is $age years old', {age: 5})
   *
   *     // the following outputs: 'The value of pi is 3.141592654'
   *     math.print('The value of pi is $pi', {pi: math.pi}, 10)
   *
   *     // the following outputs: 'hello Mary! The date is 2013-03-23'
   *     math.print('Hello $user.name! The date is $date', {
   *       user: {
   *         name: 'Mary',
   *       },
   *       date: new Date(2013, 2, 23).toISOString().substring(0, 10)
   *     })
   *
   *     // the following outputs: 'My favorite fruits are apples and bananas !'
   *     math.print('My favorite fruits are $0 and $1 !', [
   *       'apples',
   *       'bananas'
   *     ])
   *
   * See also:
   *
   *     format
   *
   * @param {string} template           A string containing variable placeholders.
   * @param {Object | Array | Matrix}   values An object or array containing variables
   *                                    which will be filled in in the template.
   * @param {number | Object} [options] Formatting options,
   *                                    or the number of digits to format numbers.
   *                                    See function math.format for a description
   *                                    of all options.
   * @return {string} Interpolated string
   */ return typed($4e89f948aaeed74d$var$name, {
        // note: Matrix will be converted automatically to an Array
        "string, Object | Array": $4e89f948aaeed74d$var$_print,
        "string, Object | Array, number | Object": $4e89f948aaeed74d$var$_print
    });
});
/**
 * Interpolate values into a string template.
 * @param {string} template
 * @param {Object} values
 * @param {number | Object} [options]
 * @returns {string} Interpolated string
 * @private
 */ function $4e89f948aaeed74d$var$_print(template, values, options) {
    return template.replace((0, $6cdeefd9bf00c3e2$export$d0aef82ef51185f0), function(original, key) {
        var keys = key.split(".");
        var value = values[keys.shift()];
        if (value !== undefined && value.isMatrix) value = value.toArray();
        while(keys.length && value !== undefined){
            var k = keys.shift();
            value = k ? value[k] : value + ".";
        }
        if (value !== undefined) {
            if (!(0, $23cfe017d190638f$export$844ec244b1367d54)(value)) return (0, $1b038b7ade911d0e$export$d9468344d3651243)(value, options);
            else return value;
        }
        return original;
    });
}





var $124fdd5895b55f2a$var$name = "prod";
var $124fdd5895b55f2a$var$dependencies = [
    "typed",
    "config",
    "multiplyScalar",
    "numeric"
];
var $124fdd5895b55f2a$export$60310f756e9cfd41 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($124fdd5895b55f2a$var$name, $124fdd5895b55f2a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, numeric: numeric } = _ref;
    /**
   * Compute the product of a matrix or a list with values.
   * In case of a multidimensional array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.prod(a, b, c, ...)
   *     math.prod(A)
   *
   * Examples:
   *
   *     math.multiply(2, 3)           // returns 6
   *     math.prod(2, 3)               // returns 6
   *     math.prod(2, 3, 4)            // returns 24
   *     math.prod([2, 3, 4])          // returns 24
   *     math.prod([[2, 5], [4, 3]])   // returns 120
   *
   * See also:
   *
   *    mean, median, min, max, sum, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The product of all values
   */ return typed($124fdd5895b55f2a$var$name, {
        // prod([a, b, c, d, ...])
        "Array | Matrix": _prod,
        // prod([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement prod(A, dim)
            throw new Error("prod(A, dim) is not yet supported");
        // return reduce(arguments[0], arguments[1], math.prod)
        },
        // prod(a, b, c, d, ...)
        "...": function _(args) {
            return _prod(args);
        }
    });
    /**
   * Recursively calculate the product of an n-dimensional array
   * @param {Array} array
   * @return {number} prod
   * @private
   */ function _prod(array) {
        var prod;
        (0, $b3f9e93020d0f987$export$519ada94592b97fc)(array, function(value) {
            try {
                prod = prod === undefined ? value : multiplyScalar(prod, value);
            } catch (err) {
                throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "prod", value);
            }
        });
        // make sure returning numeric value: parse a string into a numeric value
        if (typeof prod === "string") prod = numeric(prod, (0, $a246eb207aab6d09$export$28199db5a610a1ee)(prod, config));
        if (prod === undefined) throw new Error("Cannot calculate prod of an empty array");
        return prod;
    }
});



var $4fa9d44bfe7678f5$var$name = "qr";
var $4fa9d44bfe7678f5$var$dependencies = [
    "typed",
    "matrix",
    "zeros",
    "identity",
    "isZero",
    "equal",
    "sign",
    "sqrt",
    "conj",
    "unaryMinus",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "subtractScalar",
    "complex"
];
var $4fa9d44bfe7678f5$export$39b52312ba2c4d03 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($4fa9d44bfe7678f5$var$name, $4fa9d44bfe7678f5$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, zeros: zeros, identity: identity, isZero: isZero, equal: equal, sign: sign, sqrt: sqrt, conj: conj, unaryMinus: unaryMinus, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, complex: complex } = _ref;
    /**
   * Calculate the Matrix QR decomposition. Matrix `A` is decomposed in
   * two matrices (`Q`, `R`) where `Q` is an
   * orthogonal matrix and `R` is an upper triangular matrix.
   *
   * Syntax:
   *
   *    math.qr(A)
   *
   * Example:
   *
   *    const m = [
   *      [1, -1,  4],
   *      [1,  4, -2],
   *      [1,  4,  2],
   *      [1,  -1, 0]
   *    ]
   *    const result = math.qr(m)
   *    // r = {
   *    //   Q: [
   *    //     [0.5, -0.5,   0.5],
   *    //     [0.5,  0.5,  -0.5],
   *    //     [0.5,  0.5,   0.5],
   *    //     [0.5, -0.5,  -0.5],
   *    //   ],
   *    //   R: [
   *    //     [2, 3,  2],
   *    //     [0, 5, -2],
   *    //     [0, 0,  4],
   *    //     [0, 0,  0]
   *    //   ]
   *    // }
   *
   * See also:
   *
   *    lup, lusolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array
   * for which to get the QR decomposition.
   *
   * @return {{Q: Array | Matrix, R: Array | Matrix}} Q: the orthogonal
   * matrix and R: the upper triangular matrix
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))(typed($4fa9d44bfe7678f5$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseQR(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseQR(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a);
            // lup, use matrix implementation
            var r = _denseQR(m);
            // result
            return {
                Q: r.Q.valueOf(),
                R: r.R.valueOf()
            };
        }
    }), {
        _denseQRimpl: _denseQRimpl
    });
    function _denseQRimpl(m) {
        // rows & columns (m x n)
        var rows = m._size[0]; // m
        var cols = m._size[1]; // n
        var Q = identity([
            rows
        ], "dense");
        var Qdata = Q._data;
        var R = m.clone();
        var Rdata = R._data;
        // vars
        var i, j, k;
        var w = zeros([
            rows
        ], "");
        for(k = 0; k < Math.min(cols, rows); ++k){
            /*
       * **k-th Household matrix**
       *
       * The matrix I - 2*v*transpose(v)
       * x     = first column of A
       * x1    = first element of x
       * alpha = x1 / |x1| * |x|
       * e1    = tranpose([1, 0, 0, ...])
       * u     = x - alpha * e1
       * v     = u / |u|
       *
       * Household matrix = I - 2 * v * tranpose(v)
       *
       *  * Initially Q = I and R = A.
       *  * Household matrix is a reflection in a plane normal to v which
       *    will zero out all but the top right element in R.
       *  * Appplying reflection to both Q and R will not change product.
       *  * Repeat this process on the (1,1) minor to get R as an upper
       *    triangular matrix.
       *  * Reflections leave the magnitude of the columns of Q unchanged
       *    so Q remains othoganal.
       *
       */ var pivot = Rdata[k][k];
            var sgn = unaryMinus(equal(pivot, 0) ? 1 : sign(pivot));
            var conjSgn = conj(sgn);
            var alphaSquared = 0;
            for(i = k; i < rows; i++)alphaSquared = addScalar(alphaSquared, multiplyScalar(Rdata[i][k], conj(Rdata[i][k])));
            var alpha = multiplyScalar(sgn, sqrt(alphaSquared));
            if (!isZero(alpha)) {
                // first element in vector u
                var u1 = subtractScalar(pivot, alpha);
                // w = v * u1 / |u|    (only elements k to (rows-1) are used)
                w[k] = 1;
                for(i = k + 1; i < rows; i++)w[i] = divideScalar(Rdata[i][k], u1);
                // tau = - conj(u1 / alpha)
                var tau = unaryMinus(conj(divideScalar(u1, alpha)));
                var s = void 0;
                /*
         * tau and w have been choosen so that
         *
         * 2 * v * tranpose(v) = tau * w * tranpose(w)
         */ /*
         * -- calculate R = R - tau * w * tranpose(w) * R --
         * Only do calculation with rows k to (rows-1)
         * Additionally columns 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(j = k; j < cols; j++){
                    s = 0.0;
                    // calculate jth element of [tranpose(w) * R]
                    for(i = k; i < rows; i++)s = addScalar(s, multiplyScalar(conj(w[i]), Rdata[i][j]));
                    // calculate the jth element of [tau * transpose(w) * R]
                    s = multiplyScalar(s, tau);
                    for(i = k; i < rows; i++)Rdata[i][j] = multiplyScalar(subtractScalar(Rdata[i][j], multiplyScalar(w[i], s)), conjSgn);
                }
                /*
         * -- calculate Q = Q - tau * Q * w * transpose(w) --
         * Q is a square matrix (rows x rows)
         * Only do calculation with columns k to (rows-1)
         * Additionally rows 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(i = 0; i < rows; i++){
                    s = 0.0;
                    // calculate ith element of [Q * w]
                    for(j = k; j < rows; j++)s = addScalar(s, multiplyScalar(Qdata[i][j], w[j]));
                    // calculate the ith element of [tau * Q * w]
                    s = multiplyScalar(s, tau);
                    for(j = k; j < rows; ++j)Qdata[i][j] = divideScalar(subtractScalar(Qdata[i][j], multiplyScalar(s, conj(w[j]))), conjSgn);
                }
            }
        }
        // return matrices
        return {
            Q: Q,
            R: R,
            toString: function toString() {
                return "Q: " + this.Q.toString() + "\nR: " + this.R.toString();
            }
        };
    }
    function _denseQR(m) {
        var ret = _denseQRimpl(m);
        var Rdata = ret.R._data;
        if (m._data.length > 0) {
            var zero = Rdata[0][0].type === "Complex" ? complex(0) : 0;
            for(var i = 0; i < Rdata.length; ++i)for(var j = 0; j < i && j < (Rdata[0] || []).length; ++j)Rdata[i][j] = zero;
        }
        return ret;
    }
    function _sparseQR(m) {
        throw new Error("qr not implemented for sparse matrices yet");
    }
});





var $35d974c6d0137ed7$var$name = "quantileSeq";
var $35d974c6d0137ed7$var$dependencies = [
    "typed",
    "?bignumber",
    "add",
    "subtract",
    "divide",
    "multiply",
    "partitionSelect",
    "compare",
    "isInteger",
    "smaller",
    "smallerEq",
    "larger"
];
var $35d974c6d0137ed7$export$524607d17ea053e9 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($35d974c6d0137ed7$var$name, $35d974c6d0137ed7$var$dependencies, (_ref)=>{
    var { typed: typed, bignumber: bignumber, add: add, subtract: subtract, divide: divide, multiply: multiply, partitionSelect: partitionSelect, compare: compare, isInteger: isInteger, smaller: smaller, smallerEq: smallerEq, larger: larger } = _ref;
    var apply = (0, $b9ebe2aeb9e55336$export$5ccffa1686df7f00)({
        typed: typed,
        isInteger: isInteger
    });
    /**
   * Compute the prob order quantile of a matrix or a list with values.
   * The sequence is sorted and the middle value is returned.
   * Supported types of sequence values are: Number, BigNumber, Unit
   * Supported types of probability are: Number, BigNumber
   *
   * In case of a multidimensional array or matrix, the prob order quantile
   * of all elements will be calculated.
   *
   * Syntax:
   *
   *     math.quantileSeq(A, prob[, sorted])
   *     math.quantileSeq(A, [prob1, prob2, ...][, sorted])
   *     math.quantileSeq(A, N[, sorted])
   *
   * Examples:
   *
   *     math.quantileSeq([3, -1, 5, 7], 0.5)         // returns 4
   *     math.quantileSeq([3, -1, 5, 7], [1/3, 2/3])  // returns [3, 5]
   *     math.quantileSeq([3, -1, 5, 7], 2)           // returns [3, 5]
   *     math.quantileSeq([-1, 3, 5, 7], 0.5, true)   // returns 4
   *
   * See also:
   *
   *     median, mean, min, max, sum, prod, std, variance
   *
   * @param {Array, Matrix} data                A single matrix or Array
   * @param {Number, BigNumber, Array} probOrN  prob is the order of the quantile, while N is
   *                                            the amount of evenly distributed steps of
   *                                            probabilities; only one of these options can
   *                                            be provided
   * @param {Boolean} sorted=false              is data sorted in ascending order
   * @return {Number, BigNumber, Unit, Array}   Quantile(s)
   */ return typed($35d974c6d0137ed7$var$name, {
        "Array | Matrix, number | BigNumber": (data, p)=>_quantileSeqProbNumber(data, p, false),
        "Array | Matrix, number | BigNumber, number": (data, prob, dim)=>_quantileSeqDim(data, prob, false, dim, _quantileSeqProbNumber),
        "Array | Matrix, number | BigNumber, boolean": _quantileSeqProbNumber,
        "Array | Matrix, number | BigNumber, boolean, number": (data, prob, sorted, dim)=>_quantileSeqDim(data, prob, sorted, dim, _quantileSeqProbNumber),
        "Array | Matrix, Array | Matrix": (data, p)=>_quantileSeqProbCollection(data, p, false),
        "Array | Matrix, Array | Matrix, number": (data, prob, dim)=>_quantileSeqDim(data, prob, false, dim, _quantileSeqProbCollection),
        "Array | Matrix, Array | Matrix, boolean": _quantileSeqProbCollection,
        "Array | Matrix, Array | Matrix, boolean, number": (data, prob, sorted, dim)=>_quantileSeqDim(data, prob, sorted, dim, _quantileSeqProbCollection)
    });
    function _quantileSeqDim(data, prob, sorted, dim, fn) {
        return apply(data, dim, (x)=>fn(x, prob, sorted));
    }
    function _quantileSeqProbNumber(data, probOrN, sorted) {
        var probArr;
        var dataArr = data.valueOf();
        if (smaller(probOrN, 0)) throw new Error("N/prob must be non-negative");
        if (smallerEq(probOrN, 1)) // quantileSeq([a, b, c, d, ...], prob[,sorted])
        return (0, $23cfe017d190638f$export$7e4aa119212bc614)(probOrN) ? _quantileSeq(dataArr, probOrN, sorted) : bignumber(_quantileSeq(dataArr, probOrN, sorted));
        if (larger(probOrN, 1)) {
            // quantileSeq([a, b, c, d, ...], N[,sorted])
            if (!isInteger(probOrN)) throw new Error("N must be a positive integer");
            // largest possible Array length is 2^32-1
            // 2^32 < 10^15, thus safe conversion guaranteed
            if (larger(probOrN, 4294967295)) throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
            var nPlusOne = add(probOrN, 1);
            probArr = [];
            for(var i = 0; smaller(i, probOrN); i++){
                var prob = divide(i + 1, nPlusOne);
                probArr.push(_quantileSeq(dataArr, prob, sorted));
            }
            return (0, $23cfe017d190638f$export$7e4aa119212bc614)(probOrN) ? probArr : bignumber(probArr);
        }
    }
    /**
   * Calculate the prob order quantile of an n-dimensional array.
   *
   * @param {Array, Matrix} array
   * @param {Array, Matrix} prob
   * @param {Boolean} sorted
   * @return {Number, BigNumber, Unit} prob order quantile
   * @private
   */ function _quantileSeqProbCollection(data, probOrN, sorted) {
        var dataArr = data.valueOf();
        // quantileSeq([a, b, c, d, ...], [prob1, prob2, ...][,sorted])
        var probOrNArr = probOrN.valueOf();
        var probArr = [];
        for(var i = 0; i < probOrNArr.length; ++i)probArr.push(_quantileSeq(dataArr, probOrNArr[i], sorted));
        return probArr;
    }
    /**
   * Calculate the prob order quantile of an n-dimensional array.
   *
   * @param {Array} array
   * @param {Number, BigNumber} prob
   * @param {Boolean} sorted
   * @return {Number, BigNumber, Unit} prob order quantile
   * @private
   */ function _quantileSeq(array, prob, sorted) {
        var flat = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(array);
        var len = flat.length;
        if (len === 0) throw new Error("Cannot calculate quantile of an empty sequence");
        var index = (0, $23cfe017d190638f$export$7e4aa119212bc614)(prob) ? prob * (len - 1) : prob.times(len - 1);
        var integerPart = (0, $23cfe017d190638f$export$7e4aa119212bc614)(prob) ? Math.floor(index) : index.floor().toNumber();
        var fracPart = (0, $23cfe017d190638f$export$7e4aa119212bc614)(prob) ? index % 1 : index.minus(integerPart);
        if (isInteger(index)) return sorted ? flat[index] : partitionSelect(flat, (0, $23cfe017d190638f$export$7e4aa119212bc614)(prob) ? index : index.valueOf());
        var left;
        var right;
        if (sorted) {
            left = flat[integerPart];
            right = flat[integerPart + 1];
        } else {
            right = partitionSelect(flat, integerPart + 1);
            // max of partition is kth largest
            left = flat[integerPart];
            for(var i = 0; i < integerPart; ++i)if (compare(flat[i], left) > 0) left = flat[i];
        }
        // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
        return add(multiply(left, subtract(1, fracPart)), multiply(right, fracPart));
    }
});




/**
 * This is a util function for generating a random matrix recursively.
 * @param {number[]} size
 * @param {function} random
 * @returns {Array}
 */ function $c5e87e0e5442a9d4$export$6549281d357a44ec(size, random) {
    var data = [];
    size = size.slice(0);
    if (size.length > 1) for(var i = 0, length = size.shift(); i < length; i++)data.push($c5e87e0e5442a9d4$export$6549281d357a44ec(size, random));
    else for(var _i = 0, _length = size.shift(); _i < _length; _i++)data.push(random());
    return data;
}


var $d51e5ceaee382e3b$var$name = "random";
var $d51e5ceaee382e3b$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $d51e5ceaee382e3b$export$5c03d20f483e909a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d51e5ceaee382e3b$var$name, $d51e5ceaee382e3b$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $8f353717497e9626$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $8f353717497e9626$export$eaf9227667332084)(curr.randomSeed);
    });
    /**
   * Return a random number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.random()                // generate a random number between 0 and 1
   *     math.random(max)             // generate a random number between 0 and max
   *     math.random(min, max)        // generate a random number between min and max
   *     math.random(size)            // generate a matrix with random numbers between 0 and 1
   *     math.random(size, max)       // generate a matrix with random numbers between 0 and max
   *     math.random(size, min, max)  // generate a matrix with random numbers between min and max
   *
   * Examples:
   *
   *     math.random()       // returns a random number between 0 and 1
   *     math.random(100)    // returns a random number between 0 and 100
   *     math.random(30, 40) // returns a random number between 30 and 40
   *     math.random([2, 3]) // returns a 2x3 matrix with random numbers between 0 and 1
   *
   * See also:
   *
   *     randomInt, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random number
   */ return typed($d51e5ceaee382e3b$var$name, {
        "": ()=>_random(0, 1),
        number: (max)=>_random(0, max),
        "number, number": (min, max)=>_random(min, max),
        "Array | Matrix": (size)=>_randomMatrix(size, 0, 1),
        "Array | Matrix, number": (size, max)=>_randomMatrix(size, 0, max),
        "Array | Matrix, number, number": (size, min, max)=>_randomMatrix(size, min, max)
    });
    function _randomMatrix(size, min, max) {
        var res = (0, $c5e87e0e5442a9d4$export$6549281d357a44ec)(size.valueOf(), ()=>_random(min, max));
        return (0, $23cfe017d190638f$export$b22160e0a14f87b7)(size) ? size.create(res) : res;
    }
    function _random(min, max) {
        return min + rng() * (max - min);
    }
});
var $d51e5ceaee382e3b$export$267a132af241f602 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d51e5ceaee382e3b$var$name, [
    "typed",
    "config",
    "?on"
], (_ref2)=>{
    var { typed: typed, config: config, on: on, matrix: matrix } = _ref2;
    // seeded pseudo random number generator1
    var rng = (0, $8f353717497e9626$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $8f353717497e9626$export$eaf9227667332084)(curr.randomSeed);
    });
    return typed($d51e5ceaee382e3b$var$name, {
        "": ()=>_random(0, 1),
        number: (max)=>_random(0, max),
        "number, number": (min, max)=>_random(min, max)
    });
    function _random(min, max) {
        return min + rng() * (max - min);
    }
});





var $4e329e0490333c7d$var$name = "randomInt";
var $4e329e0490333c7d$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $4e329e0490333c7d$export$e158da47ae479dd4 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($4e329e0490333c7d$var$name, $4e329e0490333c7d$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $8f353717497e9626$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $8f353717497e9626$export$eaf9227667332084)(curr.randomSeed);
    });
    /**
   * Return a random integer number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.randomInt()                // generate a random integer between 0 and 1
   *     math.randomInt(max)             // generate a random integer between 0 and max
   *     math.randomInt(min, max)        // generate a random integer between min and max
   *     math.randomInt(size)            // generate a matrix with random integer between 0 and 1
   *     math.randomInt(size, max)       // generate a matrix with random integer between 0 and max
   *     math.randomInt(size, min, max)  // generate a matrix with random integer between min and max
   *
   * Examples:
   *
   *     math.randomInt(100)    // returns a random integer between 0 and 100
   *     math.randomInt(30, 40) // returns a random integer between 30 and 40
   *     math.randomInt([2, 3]) // returns a 2x3 matrix with random integers between 0 and 1
   *
   * See also:
   *
   *     random, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random integer value
   */ return typed($4e329e0490333c7d$var$name, {
        "": ()=>_randomInt(0, 1),
        number: (max)=>_randomInt(0, max),
        "number, number": (min, max)=>_randomInt(min, max),
        "Array | Matrix": (size)=>_randomIntMatrix(size, 0, 1),
        "Array | Matrix, number": (size, max)=>_randomIntMatrix(size, 0, max),
        "Array | Matrix, number, number": (size, min, max)=>_randomIntMatrix(size, min, max)
    });
    function _randomIntMatrix(size, min, max) {
        var res = (0, $c5e87e0e5442a9d4$export$6549281d357a44ec)(size.valueOf(), ()=>_randomInt(min, max));
        return (0, $23cfe017d190638f$export$b22160e0a14f87b7)(size) ? size.create(res) : res;
    }
    function _randomInt(min, max) {
        return Math.floor(min + rng() * (max - min));
    }
});



var $74b267caaabc4839$var$name = "range";
var $74b267caaabc4839$var$dependencies = [
    "typed",
    "config",
    "?matrix",
    "?bignumber",
    "smaller",
    "smallerEq",
    "larger",
    "largerEq",
    "add",
    "isPositive"
];
var $74b267caaabc4839$export$d372f2f3c4d1b8e5 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($74b267caaabc4839$var$name, $74b267caaabc4839$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, bignumber: bignumber, smaller: smaller, smallerEq: smallerEq, larger: larger, largerEq: largerEq, add: add, isPositive: isPositive } = _ref;
    /**
   * Create an array from a range.
   * By default, the range end is excluded. This can be customized by providing
   * an extra parameter `includeEnd`.
   *
   * Syntax:
   *
   *     math.range(str [, includeEnd])               // Create a range from a string,
   *                                                  // where the string contains the
   *                                                  // start, optional step, and end,
   *                                                  // separated by a colon.
   *     math.range(start, end [, includeEnd])        // Create a range with start and
   *                                                  // end and a step size of 1.
   *     math.range(start, end, step [, includeEnd])  // Create a range with start, step,
   *                                                  // and end.
   *
   * Where:
   *
   * - `str: string`
   *   A string 'start:end' or 'start:step:end'
   * - `start: {number | BigNumber | Unit}`
   *   Start of the range
   * - `end: number | BigNumber | Unit`
   *   End of the range, excluded by default, included when parameter includeEnd=true
   * - `step: number | BigNumber | Unit`
   *   Step size. Default value is 1.
   * - `includeEnd: boolean`
   *   Option to specify whether to include the end or not. False by default.
   *
   * Examples:
   *
   *     math.range(2, 6)        // [2, 3, 4, 5]
   *     math.range(2, -3, -1)   // [2, 1, 0, -1, -2]
   *     math.range('2:1:6')     // [2, 3, 4, 5]
   *     math.range(2, 6, true)  // [2, 3, 4, 5, 6]
   *     math.range(math.unit(2, 'm'), math.unit(-3, 'm'), math.unit(-1, 'm')) // [2 m, 1 m, 0 m , -1 m, -2 m]
   *
   * See also:
   *
   *     ones, zeros, size, subset
   *
   * @param {*} args   Parameters describing the ranges `start`, `end`, and optional `step`.
   * @return {Array | Matrix} range
   */ return typed($74b267caaabc4839$var$name, {
        // TODO: simplify signatures when typed-function supports default values and optional arguments
        // TODO: a number or boolean should not be converted to string here
        string: _strRange,
        "string, boolean": _strRange,
        "number, number": function numberNumber(start, end) {
            return _out(_range(start, end, 1, false));
        },
        "number, number, number": function numberNumberNumber(start, end, step) {
            return _out(_range(start, end, step, false));
        },
        "number, number, boolean": function numberNumberBoolean(start, end, includeEnd) {
            return _out(_range(start, end, 1, includeEnd));
        },
        "number, number, number, boolean": function numberNumberNumberBoolean(start, end, step, includeEnd) {
            return _out(_range(start, end, step, includeEnd));
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(start, end) {
            var BigNumber = start.constructor;
            return _out(_range(start, end, new BigNumber(1), false));
        },
        "BigNumber, BigNumber, BigNumber": function BigNumberBigNumberBigNumber(start, end, step) {
            return _out(_range(start, end, step, false));
        },
        "BigNumber, BigNumber, boolean": function BigNumberBigNumberBoolean(start, end, includeEnd) {
            var BigNumber = start.constructor;
            return _out(_range(start, end, new BigNumber(1), includeEnd));
        },
        "BigNumber, BigNumber, BigNumber, boolean": function BigNumberBigNumberBigNumberBoolean(start, end, step, includeEnd) {
            return _out(_range(start, end, step, includeEnd));
        },
        "Unit, Unit, Unit": function UnitUnitUnit(start, end, step) {
            return _out(_range(start, end, step, false));
        },
        "Unit, Unit, Unit, boolean": function UnitUnitUnitBoolean(start, end, step, includeEnd) {
            return _out(_range(start, end, step, includeEnd));
        }
    });
    function _out(arr) {
        if (config.matrix === "Matrix") return matrix ? matrix(arr) : (0, $ba7e85df6c2910bf$export$b81416cb7ecca475)();
        return arr;
    }
    function _strRange(str, includeEnd) {
        var r = _parse(str);
        if (!r) throw new SyntaxError('String "' + str + '" is no valid range');
        if (config.number === "BigNumber") {
            if (bignumber === undefined) (0, $ba7e85df6c2910bf$export$f0829713dc162a8)();
            return _out(_range(bignumber(r.start), bignumber(r.end), bignumber(r.step)), includeEnd);
        } else return _out(_range(r.start, r.end, r.step, includeEnd));
    }
    /**
   * Create a range with numbers or BigNumbers
   * @param {number | BigNumber | Unit} start
   * @param {number | BigNumber | Unit} end
   * @param {number | BigNumber | Unit} step
   * @param {boolean} includeEnd
   * @returns {Array} range
   * @private
   */ function _range(start, end, step, includeEnd) {
        var array = [];
        var ongoing = isPositive(step) ? includeEnd ? smallerEq : smaller : includeEnd ? largerEq : larger;
        var x = start;
        while(ongoing(x, end)){
            array.push(x);
            x = add(x, step);
        }
        return array;
    }
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @param {string} str
   * @return {{start: number, end: number, step: number} | null} range Object containing properties start, end, step
   * @private
   */ function _parse(str) {
        var args = str.split(":");
        // number
        var nums = args.map(function(arg) {
            // use Number and not parseFloat as Number returns NaN on invalid garbage in the string
            return Number(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return {
                    start: nums[0],
                    end: nums[1],
                    step: 1
                };
            case 3:
                return {
                    start: nums[0],
                    end: nums[2],
                    step: nums[1]
                };
            default:
                return null;
        }
    }
});




var $f99883b990dced88$var$name = "Range";
var $f99883b990dced88$var$dependencies = [];
var $f99883b990dced88$export$e87cc8d3f29c5e1b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f99883b990dced88$var$name, $f99883b990dced88$var$dependencies, ()=>{
    /**
   * Create a range. A range has a start, step, and end, and contains functions
   * to iterate over the range.
   *
   * A range can be constructed as:
   *
   *     const range = new Range(start, end)
   *     const range = new Range(start, end, step)
   *
   * To get the result of the range:
   *     range.forEach(function (x) {
   *         console.log(x)
   *     })
   *     range.map(function (x) {
   *         return math.sin(x)
   *     })
   *     range.toArray()
   *
   * Example usage:
   *
   *     const c = new Range(2, 6)       // 2:1:5
   *     c.toArray()                     // [2, 3, 4, 5]
   *     const d = new Range(2, -3, -1)  // 2:-1:-2
   *     d.toArray()                     // [2, 1, 0, -1, -2]
   *
   * @class Range
   * @constructor Range
   * @param {number} start  included lower bound
   * @param {number} end    excluded upper bound
   * @param {number} [step] step size, default value is 1
   */ function Range(start, end, step) {
        if (!(this instanceof Range)) throw new SyntaxError("Constructor must be called with the new operator");
        var hasStart = start !== null && start !== undefined;
        var hasEnd = end !== null && end !== undefined;
        var hasStep = step !== null && step !== undefined;
        if (hasStart) {
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(start)) start = start.toNumber();
            else if (typeof start !== "number") throw new TypeError("Parameter start must be a number");
        }
        if (hasEnd) {
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(end)) end = end.toNumber();
            else if (typeof end !== "number") throw new TypeError("Parameter end must be a number");
        }
        if (hasStep) {
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(step)) step = step.toNumber();
            else if (typeof step !== "number") throw new TypeError("Parameter step must be a number");
        }
        this.start = hasStart ? parseFloat(start) : 0;
        this.end = hasEnd ? parseFloat(end) : 0;
        this.step = hasStep ? parseFloat(step) : 1;
    }
    /**
   * Attach type information
   */ Range.prototype.type = "Range";
    Range.prototype.isRange = true;
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @memberof Range
   * @param {string} str
   * @return {Range | null} range
   */ Range.parse = function(str) {
        if (typeof str !== "string") return null;
        var args = str.split(":");
        var nums = args.map(function(arg) {
            return parseFloat(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return new Range(nums[0], nums[1]);
            case 3:
                return new Range(nums[0], nums[2], nums[1]);
            default:
                return null;
        }
    };
    /**
   * Create a clone of the range
   * @return {Range} clone
   */ Range.prototype.clone = function() {
        return new Range(this.start, this.end, this.step);
    };
    /**
   * Retrieve the size of the range.
   * Returns an array containing one number, the number of elements in the range.
   * @memberof Range
   * @returns {number[]} size
   */ Range.prototype.size = function() {
        var len = 0;
        var start = this.start;
        var step = this.step;
        var end = this.end;
        var diff = end - start;
        if ((0, $a246eb207aab6d09$export$c5552dfdbc7cec71)(step) === (0, $a246eb207aab6d09$export$c5552dfdbc7cec71)(diff)) len = Math.ceil(diff / step);
        else if (diff === 0) len = 0;
        if (isNaN(len)) len = 0;
        return [
            len
        ];
    };
    /**
   * Calculate the minimum value in the range
   * @memberof Range
   * @return {number | undefined} min
   */ Range.prototype.min = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start;
            else // negative step
            return this.start + (size - 1) * this.step;
        } else return undefined;
    };
    /**
   * Calculate the maximum value in the range
   * @memberof Range
   * @return {number | undefined} max
   */ Range.prototype.max = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start + (size - 1) * this.step;
            else // negative step
            return this.start;
        } else return undefined;
    };
    /**
   * Execute a callback function for each value in the range.
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Range being traversed.
   */ Range.prototype.forEach = function(callback) {
        var x = this.start;
        var step = this.step;
        var end = this.end;
        var i = 0;
        if (step > 0) while(x < end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
        else if (step < 0) while(x > end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
    };
    /**
   * Execute a callback function for each value in the Range, and return the
   * results as an array
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @returns {Array} array
   */ Range.prototype.map = function(callback) {
        var array = [];
        this.forEach(function(value, index, obj) {
            array[index[0]] = callback(value, index, obj);
        });
        return array;
    };
    /**
   * Create an Array with a copy of the Ranges data
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.toArray = function() {
        var array = [];
        this.forEach(function(value, index) {
            array[index[0]] = value;
        });
        return array;
    };
    /**
   * Get the primitive value of the Range, a one dimensional array
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.valueOf = function() {
        // TODO: implement a caching mechanism for range.valueOf()
        return this.toArray();
    };
    /**
   * Get a string representation of the range, with optional formatting options.
   * Output is formatted as 'start:step:end', for example '2:6' or '0:0.2:11'
   * @memberof Range
   * @param {Object | number | function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Range.prototype.format = function(options) {
        var str = (0, $a246eb207aab6d09$export$d9468344d3651243)(this.start, options);
        if (this.step !== 1) str += ":" + (0, $a246eb207aab6d09$export$d9468344d3651243)(this.step, options);
        str += ":" + (0, $a246eb207aab6d09$export$d9468344d3651243)(this.end, options);
        return str;
    };
    /**
   * Get a string representation of the range.
   * @memberof Range
   * @returns {string}
   */ Range.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the range
   * @memberof Range
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   */ Range.prototype.toJSON = function() {
        return {
            mathjs: "Range",
            start: this.start,
            end: this.end,
            step: this.step
        };
    };
    /**
   * Instantiate a Range from a JSON object
   * @memberof Range
   * @param {Object} json A JSON object structured as:
   *                      `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   * @return {Range}
   */ Range.fromJSON = function(json) {
        return new Range(json.start, json.end, json.step);
    };
    return Range;
}, {
    isClass: true
});



var $9ed579ffe277110c$var$name = "re";
var $9ed579ffe277110c$var$dependencies = [
    "typed"
];
var $9ed579ffe277110c$export$803e46d0de790dbf = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9ed579ffe277110c$var$name, $9ed579ffe277110c$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Get the real part of a complex number.
   * For a complex number `a + bi`, the function returns `a`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.re(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number 0
   *    math.re(math.complex(2.4))     // returns number 2.4
   *
   * See also:
   *
   *    im, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The real part of x
   */ return typed($9ed579ffe277110c$var$name, {
        "number | BigNumber | Fraction": (x)=>x,
        Complex: (x)=>x.re,
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});


var $e1c3561e9b6d1bf7$var$name = "replacer";
var $e1c3561e9b6d1bf7$var$dependencies = [];
var $e1c3561e9b6d1bf7$export$481a522c866104eb = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e1c3561e9b6d1bf7$var$name, $e1c3561e9b6d1bf7$var$dependencies, ()=>{
    /**
   * Stringify data types into their JSON representation.
   * Most data types can be serialized using their `.toJSON` method,
   * but not all, for example the number `Infinity`. For these cases you have
   * to use the replacer. Example usage:
   *
   *     JSON.stringify([2, Infinity], math.replacer)
   *
   * @param {string} key
   * @param {*} value
   * @returns {*} Returns the replaced object
   */ return function replacer(key, value) {
        // the numeric values Infinitiy, -Infinity, and NaN cannot be serialized to JSON
        if (typeof value === "number" && (!isFinite(value) || isNaN(value))) return {
            mathjs: "number",
            value: String(value)
        };
        if (typeof value === "bigint") return {
            mathjs: "bigint",
            value: String(value)
        };
        return value;
    };
});



var $3bb93b6d8b5938c5$var$name = "reshape";
var $3bb93b6d8b5938c5$var$dependencies = [
    "typed",
    "isInteger",
    "matrix"
];
var $3bb93b6d8b5938c5$export$76c9752f34fb3440 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3bb93b6d8b5938c5$var$name, $3bb93b6d8b5938c5$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    /**
   * Reshape a multi dimensional array to fit the specified dimensions
   *
   * Syntax:
   *
   *     math.reshape(x, sizes)
   *
   * Examples:
   *
   *     math.reshape([1, 2, 3, 4, 5, 6], [2, 3])
   *     // returns Array  [[1, 2, 3], [4, 5, 6]]
   *
   *     math.reshape([[1, 2], [3, 4]], [1, 4])
   *     // returns Array  [[1, 2, 3, 4]]
   *
   *     math.reshape([[1, 2], [3, 4]], [4])
   *     // returns Array [1, 2, 3, 4]
   *
   *     const x = math.matrix([1, 2, 3, 4, 5, 6, 7, 8])
   *     math.reshape(x, [2, 2, 2])
   *     // returns Matrix [[[1, 2], [3, 4]], [[5, 6], [7, 8]]]
   *
   *    math.reshape([1, 2, 3, 4], [-1, 2])
   *    // returns Matrix [[1, 2], [3, 4]]
   *
   * See also:
   *
   *     size, squeeze, resize
   *
   * @param {Array | Matrix | *} x  Matrix to be reshaped
   * @param {number[]} sizes        One dimensional array with integral sizes for
   *                                each dimension. One -1 is allowed as wildcard,
   *                                which calculates this dimension automatically.
   *
   * @return {* | Array | Matrix}   A reshaped clone of matrix `x`
   *
   * @throws {TypeError}            If `sizes` does not contain solely integers
   * @throws {DimensionError}       If the product of the new dimension sizes does
   *                                not equal that of the old ones
   */ return typed($3bb93b6d8b5938c5$var$name, {
        "Matrix, Array": function MatrixArray(x, sizes) {
            return x.reshape(sizes, true);
        },
        "Array, Array": function ArrayArray(x, sizes) {
            sizes.forEach(function(size) {
                if (!isInteger(size)) throw new TypeError("Invalid size for dimension: " + size);
            });
            return (0, $eee21df0c3527ff1$export$9eaad88cf88cee2b)(x, sizes);
        }
    });
});









var $b6657f8fd10a6a98$var$name = "resize";
var $b6657f8fd10a6a98$var$dependencies = [
    "config",
    "matrix"
];
var $b6657f8fd10a6a98$export$58909557046ca413 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b6657f8fd10a6a98$var$name, $b6657f8fd10a6a98$var$dependencies, (_ref)=>{
    var { config: config, matrix: matrix } = _ref;
    /**
   * Resize a matrix
   *
   * Syntax:
   *
   *     math.resize(x, size)
   *     math.resize(x, size, defaultValue)
   *
   * Examples:
   *
   *     math.resize([1, 2, 3, 4, 5], [3]) // returns Array  [1, 2, 3]
   *     math.resize([1, 2, 3], [5], 0)    // returns Array  [1, 2, 3, 0, 0]
   *     math.resize(2, [2, 3], 0)         // returns Matrix [[2, 0, 0], [0, 0, 0]]
   *     math.resize("hello", [8], "!")    // returns string 'hello!!!'
   *
   * See also:
   *
   *     size, squeeze, subset, reshape
   *
   * @param {Array | Matrix | *} x             Matrix to be resized
   * @param {Array | Matrix} size              One dimensional array with numbers
   * @param {number | string} [defaultValue=0] Zero by default, except in
   *                                           case of a string, in that case
   *                                           defaultValue = ' '
   * @return {* | Array | Matrix} A resized clone of matrix `x`
   */ // TODO: rework resize to a typed-function
    return function resize(x, size, defaultValue) {
        if (arguments.length !== 2 && arguments.length !== 3) throw new (0, $3530305357b9cbe9$export$f27c2c74ddc37d80)("resize", arguments.length, 2, 3);
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(size)) size = size.valueOf(); // get Array
        if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(size[0])) // convert bignumbers to numbers
        size = size.map(function(value) {
            return !(0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(value) ? value : value.toNumber();
        });
        // check x is a Matrix
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(x)) // use optimized matrix implementation, return copy
        return x.resize(size, defaultValue, true);
        if (typeof x === "string") // resize string
        return _resizeString(x, size, defaultValue);
        // check result should be a matrix
        var asMatrix = Array.isArray(x) ? false : config.matrix !== "Array";
        if (size.length === 0) {
            // output a scalar
            while(Array.isArray(x))x = x[0];
            return (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(x);
        } else {
            // output an array/matrix
            if (!Array.isArray(x)) x = [
                x
            ];
            x = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(x);
            var res = (0, $eee21df0c3527ff1$export$4380c87abf28fdf)(x, size, defaultValue);
            return asMatrix ? matrix(res) : res;
        }
    };
    /**
   * Resize a string
   * @param {string} str
   * @param {number[]} size
   * @param {string} [defaultChar=' ']
   * @private
   */ function _resizeString(str, size, defaultChar) {
        if (defaultChar !== undefined) {
            if (typeof defaultChar !== "string" || defaultChar.length !== 1) throw new TypeError("Single character expected as defaultValue");
        } else defaultChar = " ";
        if (size.length !== 1) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(size.length, 1);
        var len = size[0];
        if (typeof len !== "number" || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(len)) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
        if (str.length > len) return str.substring(0, len);
        else if (str.length < len) {
            var res = str;
            for(var i = 0, ii = len - str.length; i < ii; i++)res += defaultChar;
            return res;
        } else return str;
    }
});


var $ac4cd90c012d6eb1$var$name = "ResultSet";
var $ac4cd90c012d6eb1$var$dependencies = [];
var $ac4cd90c012d6eb1$export$dfb3187f1c4e3bbe = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($ac4cd90c012d6eb1$var$name, $ac4cd90c012d6eb1$var$dependencies, ()=>{
    /**
   * A ResultSet contains a list or results
   * @class ResultSet
   * @param {Array} entries
   * @constructor ResultSet
   */ function ResultSet(entries) {
        if (!(this instanceof ResultSet)) throw new SyntaxError("Constructor must be called with the new operator");
        this.entries = entries || [];
    }
    /**
   * Attach type information
   */ ResultSet.prototype.type = "ResultSet";
    ResultSet.prototype.isResultSet = true;
    /**
   * Returns the array with results hold by this ResultSet
   * @memberof ResultSet
   * @returns {Array} entries
   */ ResultSet.prototype.valueOf = function() {
        return this.entries;
    };
    /**
   * Returns the stringified results of the ResultSet
   * @memberof ResultSet
   * @returns {string} string
   */ ResultSet.prototype.toString = function() {
        return "[" + this.entries.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the ResultSet
   * @memberof ResultSet
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "ResultSet", "entries": [...]}`
   */ ResultSet.prototype.toJSON = function() {
        return {
            mathjs: "ResultSet",
            entries: this.entries
        };
    };
    /**
   * Instantiate a ResultSet from a JSON object
   * @memberof ResultSet
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "ResultSet", "entries": [...]}`
   * @return {ResultSet}
   */ ResultSet.fromJSON = function(json) {
        return new ResultSet(json.entries);
    };
    return ResultSet;
}, {
    isClass: true
});












var $95014785bd1b3b54$var$name = "rightArithShift";
var $95014785bd1b3b54$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix",
    "concat"
];
var $95014785bd1b3b54$export$ef742376390cbf7 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($95014785bd1b3b54$var$name, $95014785bd1b3b54$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $a0c1a11a7836c6b2$export$727ab96f88a9e651)({
        typed: typed
    });
    var matAlgo02xDS0 = (0, $94e325bf4fc92f8c$export$32ae34d6563cd126)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo08xS0Sid = (0, $131ade0646aa8fa7$export$704047d0f247b5d8)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $00357ab6509f98c8$export$5295edae9a41ff00)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $ada7281b5c8c5fa6$export$4b07063314120f7c)({
        typed: typed
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var useMatrixForArrayScalar = (0, $3cafdf5e5d3bcef6$export$5ec2267d257aecc)({
        typed: typed,
        matrix: matrix
    });
    /**
   * Bitwise right arithmetic shift of a value x by y number of bits, `x >> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightArithShift(x, y)
   *
   * Examples:
   *
   *    math.rightArithShift(4, 2)               // returns number 1
   *
   *    math.rightArithShift([16, -32, 64], 4)   // returns Array [1, -2, 4]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber | bigint} y Amount of shifts
   * @return {number | BigNumber | bigint | Array | Matrix} `x` zero-filled shifted right `y` times
   */ return typed($95014785bd1b3b54$var$name, {
        "number, number": (0, $23d3870094e55520$export$b6d96f775be90000),
        "BigNumber, BigNumber": (0, $6f96750d17929332$export$d489c03691bd4cd),
        "bigint, bigint": (x, y)=>x >> y,
        "SparseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo11xS0s(x, y, self, false);
            }),
        "DenseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo14xDs(x, y, self, false);
            }),
        "number | BigNumber, SparseMatrix": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo10xSids(y, x, self, true);
            }),
        "number | BigNumber, DenseMatrix": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo14xDs(y, x, self, true);
            })
    }, useMatrixForArrayScalar, matrixAlgorithmSuite({
        SS: matAlgo08xS0Sid,
        DS: matAlgo01xDSid,
        SD: matAlgo02xDS0
    }));
});











var $bfdaaae7c60743c4$var$name = "rightLogShift";
var $bfdaaae7c60743c4$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix",
    "concat"
];
var $bfdaaae7c60743c4$export$2dd001e9fd66adcd = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($bfdaaae7c60743c4$var$name, $bfdaaae7c60743c4$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $a0c1a11a7836c6b2$export$727ab96f88a9e651)({
        typed: typed
    });
    var matAlgo02xDS0 = (0, $94e325bf4fc92f8c$export$32ae34d6563cd126)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo08xS0Sid = (0, $131ade0646aa8fa7$export$704047d0f247b5d8)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $00357ab6509f98c8$export$5295edae9a41ff00)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $ada7281b5c8c5fa6$export$4b07063314120f7c)({
        typed: typed
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var useMatrixForArrayScalar = (0, $3cafdf5e5d3bcef6$export$5ec2267d257aecc)({
        typed: typed,
        matrix: matrix
    });
    /**
   * Bitwise right logical shift of value x by y number of bits, `x >>> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightLogShift(x, y)
   *
   * Examples:
   *
   *    math.rightLogShift(4, 2)               // returns number 1
   *
   *    math.rightLogShift([16, 32, 64], 4)    // returns Array [1, 2, 4]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, leftShift, rightLogShift
   *
   * @param  {number | Array | Matrix} x Value to be shifted
   * @param  {number} y Amount of shifts
   * @return {number | Array | Matrix} `x` zero-filled shifted right `y` times
   */ return typed($bfdaaae7c60743c4$var$name, {
        "number, number": (0, $23d3870094e55520$export$2a8d1e3dcede6e47),
        // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
        "SparseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo11xS0s(x, y, self, false);
            }),
        "DenseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo14xDs(x, y, self, false);
            }),
        "number | BigNumber, SparseMatrix": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo10xSids(y, x, self, true);
            }),
        "number | BigNumber, DenseMatrix": typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo14xDs(y, x, self, true);
            })
    }, useMatrixForArrayScalar, matrixAlgorithmSuite({
        SS: matAlgo08xS0Sid,
        DS: matAlgo01xDSid,
        SD: matAlgo02xDS0
    }));
});



var $b94207871d7275ac$var$name = "rotate";
var $b94207871d7275ac$var$dependencies = [
    "typed",
    "multiply",
    "rotationMatrix"
];
var $b94207871d7275ac$export$484058214789ee04 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b94207871d7275ac$var$name, $b94207871d7275ac$var$dependencies, (_ref)=>{
    var { typed: typed, multiply: multiply, rotationMatrix: rotationMatrix } = _ref;
    /**
     * Rotate a vector of size 1x2 counter-clockwise by a given angle
     * Rotate a vector of size 1x3 counter-clockwise by a given angle around the given axis
     *
     * Syntax:
     *
     *    math.rotate(w, theta)
     *    math.rotate(w, theta, v)
     *
     * Examples:
     *
     *    math.rotate([11, 12], math.pi / 2)                           // returns [-12, 11]
     *    math.rotate(matrix([11, 12]), math.pi / 2)                   // returns [-12, 11]
     *
     *    math.rotate([1, 0, 0], unit('90deg'), [0, 0, 1])             // returns [0, 1, 0]
     *    math.rotate(matrix([1, 0, 0]), unit('90deg'), [0, 0, 1])     // returns Matrix [0, 1, 0]
     *
     *    math.rotate([1, 0], math.complex(1 + i))                     // returns [cos(1 + i) - sin(1 + i), sin(1 + i) + cos(1 + i)]
     *
     * See also:
     *
     *    matrix, rotationMatrix
     *
     * @param {Array | Matrix} w                             Vector to rotate
     * @param {number | BigNumber | Complex | Unit} theta    Rotation angle
     * @param {Array | Matrix} [v]                           Rotation axis
     * @return {Array | Matrix}                              Multiplication of the rotation matrix and w
     */ return typed($b94207871d7275ac$var$name, {
        "Array , number | BigNumber | Complex | Unit": function ArrayNumberBigNumberComplexUnit(w, theta) {
            _validateSize(w, 2);
            var matrixRes = multiply(rotationMatrix(theta), w);
            return matrixRes.toArray();
        },
        "Matrix , number | BigNumber | Complex | Unit": function MatrixNumberBigNumberComplexUnit(w, theta) {
            _validateSize(w, 2);
            return multiply(rotationMatrix(theta), w);
        },
        "Array, number | BigNumber | Complex | Unit, Array | Matrix": function ArrayNumberBigNumberComplexUnitArrayMatrix(w, theta, v) {
            _validateSize(w, 3);
            var matrixRes = multiply(rotationMatrix(theta, v), w);
            return matrixRes;
        },
        "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function MatrixNumberBigNumberComplexUnitArrayMatrix(w, theta, v) {
            _validateSize(w, 3);
            return multiply(rotationMatrix(theta, v), w);
        }
    });
    function _validateSize(v, expectedSize) {
        var actualSize = Array.isArray(v) ? (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(v) : v.size();
        if (actualSize.length > 2) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
        if (actualSize.length === 2 && actualSize[1] !== 1) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
        if (actualSize[0] !== expectedSize) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
    }
});



var $32649f08c528ce08$var$name = "rotationMatrix";
var $32649f08c528ce08$var$dependencies = [
    "typed",
    "config",
    "multiplyScalar",
    "addScalar",
    "unaryMinus",
    "norm",
    "matrix",
    "BigNumber",
    "DenseMatrix",
    "SparseMatrix",
    "cos",
    "sin"
];
var $32649f08c528ce08$export$7c79514a80dc15a2 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($32649f08c528ce08$var$name, $32649f08c528ce08$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, addScalar: addScalar, unaryMinus: unaryMinus, norm: norm, BigNumber: BigNumber, matrix: matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, cos: cos, sin: sin } = _ref;
    /**
   * Create a 2-dimensional counter-clockwise rotation matrix (2x2) for a given angle (expressed in radians).
   * Create a 2-dimensional counter-clockwise rotation matrix (3x3) by a given angle (expressed in radians) around a given axis (1x3).
   *
   * Syntax:
   *
   *    math.rotationMatrix(theta)
   *    math.rotationMatrix(theta, format)
   *    math.rotationMatrix(theta, [v])
   *    math.rotationMatrix(theta, [v], format)
   *
   * Examples:
   *
   *    math.rotationMatrix(math.pi / 2)                      // returns [[0, -1], [1, 0]]
   *    math.rotationMatrix(math.bignumber(1))                // returns [[bignumber(cos(1)), bignumber(-sin(1))], [bignumber(sin(1)), bignumber(cos(1))]]
   *    math.rotationMatrix(math.complex(1 + i))              // returns [[cos(1 + i), -sin(1 + i)], [sin(1 + i), cos(1 + i)]]
   *    math.rotationMatrix(math.unit('1rad'))                // returns [[cos(1), -sin(1)], [sin(1), cos(1)]]
   *
   *    math.rotationMatrix(math.pi / 2, [0, 1, 0])           // returns [[0, 0, 1], [0, 1, 0], [-1, 0, 0]]
   *    math.rotationMatrix(math.pi / 2, matrix([0, 1, 0]))   // returns matrix([[0, 0, 1], [0, 1, 0], [-1, 0, 0]])
   *
   *
   * See also:
   *
   *    matrix, cos, sin
   *
   *
   * @param {number | BigNumber | Complex | Unit} theta    Rotation angle
   * @param {Array | Matrix} [v]                           Rotation axis
   * @param {string} [format]                              Result Matrix storage format
   * @return {Array | Matrix}                              Rotation matrix
   */ return typed($32649f08c528ce08$var$name, {
        "": function _() {
            return config.matrix === "Matrix" ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        "number | BigNumber | Complex | Unit": function numberBigNumberComplexUnit(theta) {
            return _rotationMatrix2x2(theta, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber | Complex | Unit, string": function numberBigNumberComplexUnitString(theta, format) {
            return _rotationMatrix2x2(theta, format);
        },
        "number | BigNumber | Complex | Unit, Array": function numberBigNumberComplexUnitArray(theta, v) {
            var matrixV = matrix(v);
            _validateVector(matrixV);
            return _rotationMatrix3x3(theta, matrixV, undefined);
        },
        "number | BigNumber | Complex | Unit, Matrix": function numberBigNumberComplexUnitMatrix(theta, v) {
            _validateVector(v);
            var storageType = v.storage() || (config.matrix === "Matrix" ? "dense" : undefined);
            return _rotationMatrix3x3(theta, v, storageType);
        },
        "number | BigNumber | Complex | Unit, Array, string": function numberBigNumberComplexUnitArrayString(theta, v, format) {
            var matrixV = matrix(v);
            _validateVector(matrixV);
            return _rotationMatrix3x3(theta, matrixV, format);
        },
        "number | BigNumber | Complex | Unit, Matrix, string": function numberBigNumberComplexUnitMatrixString(theta, v, format) {
            _validateVector(v);
            return _rotationMatrix3x3(theta, v, format);
        }
    });
    /**
   * Returns 2x2 matrix of 2D rotation of angle theta
   *
   * @param {number | BigNumber | Complex | Unit} theta  The rotation angle
   * @param {string} format                              The result Matrix storage format
   * @returns {Matrix}
   * @private
   */ function _rotationMatrix2x2(theta, format) {
        var Big = (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(theta);
        var minusOne = Big ? new BigNumber(-1) : -1;
        var cosTheta = cos(theta);
        var sinTheta = sin(theta);
        var data = [
            [
                cosTheta,
                multiplyScalar(minusOne, sinTheta)
            ],
            [
                sinTheta,
                cosTheta
            ]
        ];
        return _convertToFormat(data, format);
    }
    function _validateVector(v) {
        var size = v.size();
        if (size.length < 1 || size[0] !== 3) throw new RangeError("Vector must be of dimensions 1x3");
    }
    function _mul(array) {
        return array.reduce((p, curr)=>multiplyScalar(p, curr));
    }
    function _convertToFormat(data, format) {
        if (format) {
            if (format === "sparse") return new SparseMatrix(data);
            if (format === "dense") return new DenseMatrix(data);
            throw new TypeError('Unknown matrix type "'.concat(format, '"'));
        }
        return data;
    }
    /**
   * Returns a 3x3 matrix of rotation of angle theta around vector v
   *
   * @param {number | BigNumber | Complex | Unit} theta The rotation angle
   * @param {Matrix} v                                  The rotation axis vector
   * @param {string} format                             The storage format of the resulting matrix
   * @returns {Matrix}
   * @private
   */ function _rotationMatrix3x3(theta, v, format) {
        var normV = norm(v);
        if (normV === 0) throw new RangeError("Rotation around zero vector");
        var Big = (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(theta) ? BigNumber : null;
        var one = Big ? new Big(1) : 1;
        var minusOne = Big ? new Big(-1) : -1;
        var vx = Big ? new Big(v.get([
            0
        ]) / normV) : v.get([
            0
        ]) / normV;
        var vy = Big ? new Big(v.get([
            1
        ]) / normV) : v.get([
            1
        ]) / normV;
        var vz = Big ? new Big(v.get([
            2
        ]) / normV) : v.get([
            2
        ]) / normV;
        var c = cos(theta);
        var oneMinusC = addScalar(one, unaryMinus(c));
        var s = sin(theta);
        var r11 = addScalar(c, _mul([
            vx,
            vx,
            oneMinusC
        ]));
        var r12 = addScalar(_mul([
            vx,
            vy,
            oneMinusC
        ]), _mul([
            minusOne,
            vz,
            s
        ]));
        var r13 = addScalar(_mul([
            vx,
            vz,
            oneMinusC
        ]), _mul([
            vy,
            s
        ]));
        var r21 = addScalar(_mul([
            vx,
            vy,
            oneMinusC
        ]), _mul([
            vz,
            s
        ]));
        var r22 = addScalar(c, _mul([
            vy,
            vy,
            oneMinusC
        ]));
        var r23 = addScalar(_mul([
            vy,
            vz,
            oneMinusC
        ]), _mul([
            minusOne,
            vx,
            s
        ]));
        var r31 = addScalar(_mul([
            vx,
            vz,
            oneMinusC
        ]), _mul([
            minusOne,
            vy,
            s
        ]));
        var r32 = addScalar(_mul([
            vy,
            vz,
            oneMinusC
        ]), _mul([
            vx,
            s
        ]));
        var r33 = addScalar(c, _mul([
            vz,
            vz,
            oneMinusC
        ]));
        var data = [
            [
                r11,
                r12,
                r13
            ],
            [
                r21,
                r22,
                r23
            ],
            [
                r31,
                r32,
                r33
            ]
        ];
        return _convertToFormat(data, format);
    }
});









var $eb65acbf5e133648$var$NO_INT = "Number of decimals in function round must be an integer";
var $eb65acbf5e133648$var$name = "round";
var $eb65acbf5e133648$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "equalScalar",
    "zeros",
    "BigNumber",
    "DenseMatrix"
];
var $eb65acbf5e133648$export$c41ddfead54b1fbc = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($eb65acbf5e133648$var$name, $eb65acbf5e133648$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, equalScalar: equalScalar, zeros: zeros, BigNumber: _BigNumber, DenseMatrix: DenseMatrix } = _ref;
    var matAlgo11xS0s = (0, $f2f17e08f891b9a8$export$b315efa10530691e)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo14xDs = (0, $ada7281b5c8c5fa6$export$4b07063314120f7c)({
        typed: typed
    });
    function toExponent(epsilon) {
        return Math.abs((0, $a246eb207aab6d09$export$feb80e120a50087f)(epsilon).exponent);
    }
    /**
   * Round a value towards the nearest rounded value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.round(x)
   *    math.round(x, n)
   *    math.round(unit, valuelessUnit)
   *    math.round(unit, n, valuelessUnit)
   *
   * Examples:
   *
   *    math.round(3.22)             // returns number 3
   *    math.round(3.82)             // returns number 4
   *    math.round(-4.2)             // returns number -4
   *    math.round(-4.7)             // returns number -5
   *    math.round(3.22, 1)          // returns number 3.2
   *    math.round(3.88, 1)          // returns number 3.9
   *    math.round(-4.21, 1)         // returns number -4.2
   *    math.round(-4.71, 1)         // returns number -4.7
   *    math.round(math.pi, 3)       // returns number 3.142
   *    math.round(123.45678, 2)     // returns number 123.46
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.round(c)                // returns Complex 3 - 3i
   *
   *    const unit = math.unit('3.241 cm')
   *    const cm = math.unit('cm')
   *    const mm = math.unit('mm')
   *    math.round(unit, 1, cm)      // returns Unit 3.2 cm
   *    math.round(unit, 1, mm)      // returns Unit 32.4 mm
   *
   *    math.round([3.2, 3.8, -4.7]) // returns Array [3, 4, -5]
   *
   * See also:
   *
   *    ceil, fix, floor
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x  Value to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @param  {Unit} [valuelessUnit]                                        A valueless unit
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed($eb65acbf5e133648$var$name, {
        number: function number(x) {
            // Handle round off errors by first rounding to relTol precision
            var xEpsilon = (0, $f38f49d8e24d4a9f$export$a3992db8dd0fd9e6)(x, toExponent(config.relTol));
            var xSelected = (0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, xEpsilon, config.relTol, config.absTol) ? xEpsilon : x;
            return (0, $f38f49d8e24d4a9f$export$a3992db8dd0fd9e6)(xSelected);
        },
        "number, number": function numberNumber(x, n) {
            // Same as number: unless user specifies more decimals than relTol
            var epsilonExponent = toExponent(config.relTol);
            if (n >= epsilonExponent) return (0, $f38f49d8e24d4a9f$export$a3992db8dd0fd9e6)(x, n);
            var xEpsilon = (0, $f38f49d8e24d4a9f$export$a3992db8dd0fd9e6)(x, epsilonExponent);
            var xSelected = (0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, xEpsilon, config.relTol, config.absTol) ? xEpsilon : x;
            return (0, $f38f49d8e24d4a9f$export$a3992db8dd0fd9e6)(xSelected, n);
        },
        "number, BigNumber": function numberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($eb65acbf5e133648$var$NO_INT);
            return new _BigNumber(x).toDecimalPlaces(n.toNumber());
        },
        Complex: function Complex(x) {
            return x.round();
        },
        "Complex, number": function ComplexNumber(x, n) {
            if (n % 1) throw new TypeError($eb65acbf5e133648$var$NO_INT);
            return x.round(n);
        },
        "Complex, BigNumber": function ComplexBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($eb65acbf5e133648$var$NO_INT);
            var _n = n.toNumber();
            return x.round(_n);
        },
        BigNumber: function BigNumber(x) {
            // Handle round off errors by first rounding to relTol precision
            var xEpsilon = new _BigNumber(x).toDecimalPlaces(toExponent(config.relTol));
            var xSelected = (0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, xEpsilon, config.relTol, config.absTol) ? xEpsilon : x;
            return xSelected.toDecimalPlaces(0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($eb65acbf5e133648$var$NO_INT);
            // Same as BigNumber: unless user specifies more decimals than relTol
            var epsilonExponent = toExponent(config.relTol);
            if (n >= epsilonExponent) return x.toDecimalPlaces(n.toNumber());
            var xEpsilon = x.toDecimalPlaces(epsilonExponent);
            var xSelected = (0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, xEpsilon, config.relTol, config.absTol) ? xEpsilon : x;
            return xSelected.toDecimalPlaces(n.toNumber());
        },
        Fraction: function Fraction(x) {
            return x.round();
        },
        "Fraction, number": function FractionNumber(x, n) {
            if (n % 1) throw new TypeError($eb65acbf5e133648$var$NO_INT);
            return x.round(n);
        },
        "Fraction, BigNumber": function FractionBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($eb65acbf5e133648$var$NO_INT);
            return x.round(n.toNumber());
        },
        "Unit, number, Unit": typed.referToSelf((self)=>function(x, n, unit) {
                var valueless = x.toNumeric(unit);
                return unit.multiply(self(valueless, n));
            }),
        "Unit, BigNumber, Unit": typed.referToSelf((self)=>(x, n, unit)=>self(x, n.toNumber(), unit)),
        "Unit, Unit": typed.referToSelf((self)=>(x, unit)=>self(x, 0, unit)),
        "Array | Matrix, number, Unit": typed.referToSelf((self)=>(x, n, unit)=>{
                // deep map collection, skip zeros since round(0) = 0
                return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, (value)=>self(value, n, unit), true);
            }),
        "Array | Matrix, BigNumber, Unit": typed.referToSelf((self)=>(x, n, unit)=>self(x, n.toNumber(), unit)),
        "Array | Matrix, Unit": typed.referToSelf((self)=>(x, unit)=>self(x, 0, unit)),
        "Array | Matrix": typed.referToSelf((self)=>(x)=>{
                // deep map collection, skip zeros since round(0) = 0
                return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self, true);
            }),
        "SparseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, n)=>{
                return matAlgo11xS0s(x, n, self, false);
            }),
        "DenseMatrix, number | BigNumber": typed.referToSelf((self)=>(x, n)=>{
                return matAlgo14xDs(x, n, self, false);
            }),
        "Array, number | BigNumber": typed.referToSelf((self)=>(x, n)=>{
                // use matrix implementation
                return matAlgo14xDs(matrix(x), n, self, false).valueOf();
            }),
        "number | Complex | BigNumber | Fraction, SparseMatrix": typed.referToSelf((self)=>(x, n)=>{
                // check scalar is zero
                if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
                return zeros(n.size(), n.storage());
                return matAlgo12xSfs(n, x, self, true);
            }),
        "number | Complex | BigNumber | Fraction, DenseMatrix": typed.referToSelf((self)=>(x, n)=>{
                // check scalar is zero
                if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
                return zeros(n.size(), n.storage());
                return matAlgo14xDs(n, x, self, true);
            }),
        "number | Complex | BigNumber | Fraction, Array": typed.referToSelf((self)=>(x, n)=>{
                // use matrix implementation
                return matAlgo14xDs(matrix(n), x, self, true).valueOf();
            })
    });
});





var $32060d84ed5feee2$var$name = "row";
var $32060d84ed5feee2$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $32060d84ed5feee2$export$3442c5d213434705 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($32060d84ed5feee2$var$name, $32060d84ed5feee2$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    /**
   * Return a row from a Matrix.
   *
   * Syntax:
   *
   *     math.row(value, index)
   *
   * Example:
   *
   *     // get a row
   *     const d = [[1, 2], [3, 4]]
   *     math.row(d, 1) // returns [[3, 4]]
   *
   * See also:
   *
   *     column
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} row              The index of the row
   * @return {Array | Matrix}         The retrieved row
   */ return typed($32060d84ed5feee2$var$name, {
        "Matrix, number": _row,
        "Array, number": function ArrayNumber(value, row) {
            return _row(matrix((0, $46a94b3d1146edd8$export$9cd59f9826255e47)(value)), row).valueOf();
        }
    });
    /**
   * Retrieve a row of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} row     The index of the row
   * @return {Matrix}        The retrieved row
   */ function _row(value, row) {
        // check dimensions
        if (value.size().length !== 2) throw new Error("Only two dimensional matrix is supported");
        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(row, value.size()[0]);
        var columnRange = range(0, value.size()[1]);
        var index = new Index(row, columnRange);
        var result = value.subset(index);
        return (0, $23cfe017d190638f$export$b22160e0a14f87b7)(result) ? result : matrix([
            [
                result
            ]
        ]);
    }
});


var $4976518eea094a85$var$name = "schur";
var $4976518eea094a85$var$dependencies = [
    "typed",
    "matrix",
    "identity",
    "multiply",
    "qr",
    "norm",
    "subtract"
];
var $4976518eea094a85$export$7c8bdcd3ab83037d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($4976518eea094a85$var$name, $4976518eea094a85$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, identity: identity, multiply: multiply, qr: qr, norm: norm, subtract: subtract } = _ref;
    /**
   *
   * Performs a real Schur decomposition of the real matrix A = UTU' where U is orthogonal
   * and T is upper quasi-triangular.
   * https://en.wikipedia.org/wiki/Schur_decomposition
   *
   * Syntax:
   *
   *     math.schur(A)
   *
   * Examples:
   *
   *     const A = [[1, 0], [-4, 3]]
   *     math.schur(A) // returns {T: [[3, 4], [0, 1]], R: [[0, 1], [-1, 0]]}
   *
   * See also:
   *
   *     sylvester, lyap, qr
   *
   * @param {Array | Matrix} A  Matrix A
   * @return {{U: Array | Matrix, T: Array | Matrix}} Object containing both matrix U and T of the Schur Decomposition A=UTU'
   */ return typed($4976518eea094a85$var$name, {
        Array: function Array(X) {
            var r = _schur(matrix(X));
            return {
                U: r.U.valueOf(),
                T: r.T.valueOf()
            };
        },
        Matrix: function Matrix(X) {
            return _schur(X);
        }
    });
    function _schur(X) {
        var n = X.size()[0];
        var A = X;
        var U = identity(n);
        var k = 0;
        var A0;
        do {
            A0 = A;
            var QR = qr(A);
            var Q = QR.Q;
            var R = QR.R;
            A = multiply(R, Q);
            U = multiply(U, Q);
            if (k++ > 100) break;
        }while (norm(subtract(A, A0)) > 1e-4);
        return {
            U: U,
            T: A
        };
    }
});




var $5e48e90f2787bd8a$var$name = "sec";
var $5e48e90f2787bd8a$var$dependencies = [
    "typed",
    "BigNumber"
];
var $5e48e90f2787bd8a$export$5c169ecd5c25a09e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($5e48e90f2787bd8a$var$name, $5e48e90f2787bd8a$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    var trigUnit = (0, $5b7412feb4d38bfc$export$33129064a3329835)({
        typed: typed
    });
    /**
   * Calculate the secant of a value, defined as `sec(x) = 1/cos(x)`.
   *
   * To avoid confusion with the matrix secant, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.sec(x)
   *
   * Examples:
   *
   *    math.sec(2)      // returns number -2.4029979617223822
   *    1 / math.cos(2)  // returns number -2.4029979617223822
   *
   * See also:
   *
   *    cos, csc, cot
   *
   * @param {number | BigNumber | Complex | Unit} x  Function input
   * @return {number | BigNumber | Complex} Secant of x
   */ return typed($5e48e90f2787bd8a$var$name, {
        number: (0, $08edde3ad76e4ae3$export$ee1efc70bd8a6d93),
        Complex: (x)=>x.sec(),
        BigNumber: (x)=>new _BigNumber(1).div(x.cos())
    }, trigUnit);
});



var $1e2c79630dbf87cf$var$name = "sech";
var $1e2c79630dbf87cf$var$dependencies = [
    "typed",
    "BigNumber"
];
var $1e2c79630dbf87cf$export$97a0cf2b7d31f38b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($1e2c79630dbf87cf$var$name, $1e2c79630dbf87cf$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic secant of a value,
   * defined as `sech(x) = 1 / cosh(x)`.
   *
   * To avoid confusion with the matrix hyperbolic secant, this function does
   * not apply to matrices.
   *
   * Syntax:
   *
   *    math.sech(x)
   *
   * Examples:
   *
   *    // sech(x) = 1/ cosh(x)
   *    math.sech(0.5)       // returns 0.886818883970074
   *    1 / math.cosh(0.5)   // returns 0.886818883970074
   *
   * See also:
   *
   *    cosh, csch, coth
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic secant of x
   */ return typed($1e2c79630dbf87cf$var$name, {
        number: (0, $08edde3ad76e4ae3$export$b83345d70fe4a871),
        Complex: (x)=>x.sech(),
        BigNumber: (x)=>new _BigNumber(1).div(x.cosh())
    });
});



var $739faf53f45efc18$var$name = "setCartesian";
var $739faf53f45efc18$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $739faf53f45efc18$export$9fa12a9d198718c8 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($739faf53f45efc18$var$name, $739faf53f45efc18$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the cartesian product of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays
   * and the values will be sorted in ascending order before the operation.
   *
   * Syntax:
   *
   *    math.setCartesian(set1, set2)
   *
   * Examples:
   *
   *    math.setCartesian([1, 2], [3, 4])        // returns [[1, 3], [1, 4], [2, 3], [2, 4]]
   *    math.setCartesian([4, 3], [2, 1])        // returns [[3, 1], [3, 2], [4, 1], [4, 2]]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference, setPowerset
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The cartesian product of two (multi)sets
   */ return typed($739faf53f45efc18$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result = [];
            if (subset(size(a1), new Index(0)) !== 0 && subset(size(a2), new Index(0)) !== 0) {
                // if any of them is empty, return empty
                var b1 = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural);
                var b2 = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural);
                result = [];
                for(var i = 0; i < b1.length; i++)for(var j = 0; j < b2.length; j++)result.push([
                    b1[i],
                    b2[j]
                ]);
            }
            // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return result;
            // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});



var $c8758c7f18bbcb02$var$name = "setDifference";
var $c8758c7f18bbcb02$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $c8758c7f18bbcb02$export$d81c0f9dab86d854 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c8758c7f18bbcb02$var$name, $c8758c7f18bbcb02$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the difference of two (multi)sets: every element of set1, that is not the element of set2.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2]
   *    math.setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2]
   *
   * See also:
   *
   *    setUnion, setIntersect, setSymDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The difference of two (multi)sets
   */ return typed($c8758c7f18bbcb02$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0) // empty-anything=empty
            result = [];
            else if (subset(size(a2), new Index(0)) === 0) // anything-empty=anything
            return (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a1.toArray());
            else {
                var b1 = (0, $eee21df0c3527ff1$export$65e5b62a4c490288)((0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $eee21df0c3527ff1$export$65e5b62a4c490288)((0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                var inb2;
                for(var i = 0; i < b1.length; i++){
                    inb2 = false;
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        inb2 = true;
                        break;
                    }
                    if (!inb2) result.push(b1[i]);
                }
            }
            // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $eee21df0c3527ff1$export$d57ad8b840ad6a01)(result);
            // return a matrix otherwise
            return new DenseMatrix((0, $eee21df0c3527ff1$export$d57ad8b840ad6a01)(result));
        }
    });
});



var $4b348e2ef5f983ee$var$name = "setDistinct";
var $4b348e2ef5f983ee$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $4b348e2ef5f983ee$export$c149680b9d8f2963 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($4b348e2ef5f983ee$var$name, $4b348e2ef5f983ee$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Collect the distinct elements of a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setDistinct(set)
   *
   * Examples:
   *
   *    math.setDistinct([1, 1, 1, 2, 2, 3])        // returns [1, 2, 3]
   *
   * See also:
   *
   *    setMultiplicity
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {Array | Matrix}    A set containing the distinc elements of the multiset
   */ return typed($4b348e2ef5f983ee$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            var result;
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            result = [];
            else {
                var b = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                result = [];
                result.push(b[0]);
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) result.push(b[i]);
            }
            // return an array, if the input was an array
            if (Array.isArray(a)) return result;
            // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});



var $706a989b4326e615$var$name = "setIntersect";
var $706a989b4326e615$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $706a989b4326e615$export$b20ee2bdfbf6defd = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($706a989b4326e615$var$name, $706a989b4326e615$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the intersection of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIntersect(set1, set2)
   *
   * Examples:
   *
   *    math.setIntersect([1, 2, 3, 4], [3, 4, 5, 6])            // returns [3, 4]
   *    math.setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [3, 4]
   *
   * See also:
   *
   *    setUnion, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The intersection of two (multi)sets
   */ return typed($706a989b4326e615$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0 || subset(size(a2), new Index(0)) === 0) // of any of them is empty, return empty
            result = [];
            else {
                var b1 = (0, $eee21df0c3527ff1$export$65e5b62a4c490288)((0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $eee21df0c3527ff1$export$65e5b62a4c490288)((0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                for(var i = 0; i < b1.length; i++){
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        result.push(b1[i]);
                        break;
                    }
                }
            }
            // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $eee21df0c3527ff1$export$d57ad8b840ad6a01)(result);
            // return a matrix otherwise
            return new DenseMatrix((0, $eee21df0c3527ff1$export$d57ad8b840ad6a01)(result));
        }
    });
});



var $bd1ec53a8ba99770$var$name = "setIsSubset";
var $bd1ec53a8ba99770$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $bd1ec53a8ba99770$export$40ad73493b9f8712 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($bd1ec53a8ba99770$var$name, $bd1ec53a8ba99770$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Check whether a (multi)set is a subset of another (multi)set. (Every element of set1 is the element of set2.)
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIsSubset(set1, set2)
   *
   * Examples:
   *
   *    math.setIsSubset([1, 2], [3, 4, 5, 6])        // returns false
   *    math.setIsSubset([3, 4], [3, 4, 5, 6])        // returns true
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {boolean} Returns true when a1 is a subset of a2, returns false otherwise
   */ return typed($bd1ec53a8ba99770$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // empty is a subset of anything
            return true;
            else if (subset(size(a2), new Index(0)) === 0) // anything is not a subset of empty
            return false;
            var b1 = (0, $eee21df0c3527ff1$export$65e5b62a4c490288)((0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
            var b2 = (0, $eee21df0c3527ff1$export$65e5b62a4c490288)((0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
            var inb2;
            for(var i = 0; i < b1.length; i++){
                inb2 = false;
                for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                    // the identifier is always a decimal int
                    inb2 = true;
                    break;
                }
                if (inb2 === false) return false;
            }
            return true;
        }
    });
});



var $64ceee9b9a5f8d84$var$name = "setMultiplicity";
var $64ceee9b9a5f8d84$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $64ceee9b9a5f8d84$export$d1f961d649e525df = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($64ceee9b9a5f8d84$var$name, $64ceee9b9a5f8d84$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Count the multiplicity of an element in a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setMultiplicity(element, set)
   *
   * Examples:
   *
   *    math.setMultiplicity(1, [1, 2, 2, 4])    // returns 1
   *    math.setMultiplicity(2, [1, 2, 2, 4])    // returns 2
   *
   * See also:
   *
   *    setDistinct, setSize
   *
   * @param {number | BigNumber | Fraction | Complex} e  An element in the multiset
   * @param {Array | Matrix}     a  A multiset
   * @return {number}            The number of how many times the multiset contains the element
   */ return typed($64ceee9b9a5f8d84$var$name, {
        "number | BigNumber | Fraction | Complex, Array | Matrix": function numberBigNumberFractionComplexArrayMatrix(e, a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return 0
            return 0;
            var b = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray());
            var count = 0;
            for(var i = 0; i < b.length; i++)if (compareNatural(b[i], e) === 0) count++;
            return count;
        }
    });
});



var $5c9cdd0a4629e6cd$var$name = "setPowerset";
var $5c9cdd0a4629e6cd$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $5c9cdd0a4629e6cd$export$55c6b5cb0b0637db = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($5c9cdd0a4629e6cd$var$name, $5c9cdd0a4629e6cd$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Create the powerset of a (multi)set. (The powerset contains very possible subsets of a (multi)set.)
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setPowerset(set)
   *
   * Examples:
   *
   *    math.setPowerset([1, 2, 3])        // returns [[], [1], [2], [3], [1, 2], [1, 3], [2, 3], [1, 2, 3]]
   *
   * See also:
   *
   *    setCartesian
   *
   * @param {Array | Matrix}    a  A (multi)set
   * @return {Array}    The powerset of the (multi)set
   */ return typed($5c9cdd0a4629e6cd$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            return [];
            var b = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
            var result = [];
            var number = 0;
            while(number.toString(2).length <= b.length){
                result.push(_subset(b, number.toString(2).split("").reverse()));
                number++;
            }
            // can not return a matrix, because of the different size of the subarrays
            return _sort(result);
        }
    });
    // create subset
    function _subset(array, bitarray) {
        var result = [];
        for(var i = 0; i < bitarray.length; i++)if (bitarray[i] === "1") result.push(array[i]);
        return result;
    }
    // sort subsests by length
    function _sort(array) {
        var temp = [];
        for(var i = array.length - 1; i > 0; i--){
            for(var j = 0; j < i; j++)if (array[j].length > array[j + 1].length) {
                temp = array[j];
                array[j] = array[j + 1];
                array[j + 1] = temp;
            }
        }
        return array;
    }
});



var $46df54224eee310f$var$name = "setSize";
var $46df54224eee310f$var$dependencies = [
    "typed",
    "compareNatural"
];
var $46df54224eee310f$export$55134310fc79366a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($46df54224eee310f$var$name, $46df54224eee310f$var$dependencies, (_ref)=>{
    var { typed: typed, compareNatural: compareNatural } = _ref;
    /**
   * Count the number of elements of a (multi)set. When a second parameter is 'true', count only the unique values.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setSize(set)
   *    math.setSize(set, unique)
   *
   * Examples:
   *
   *    math.setSize([1, 2, 2, 4])          // returns 4
   *    math.setSize([1, 2, 2, 4], true)    // returns 3
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix} a  A multiset
   * @param {boolean} [unique]  If true, only the unique values are counted. False by default
   * @return {number}           The number of elements of the (multi)set
   */ return typed($46df54224eee310f$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            return Array.isArray(a) ? (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a).length : (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a.toArray()).length;
        },
        "Array | Matrix, boolean": function ArrayMatrixBoolean(a, unique) {
            if (unique === false || a.length === 0) return Array.isArray(a) ? (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a).length : (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a.toArray()).length;
            else {
                var b = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                var count = 1;
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) count++;
                return count;
            }
        }
    });
});



var $231328e32a912b3b$var$name = "setSymDifference";
var $231328e32a912b3b$var$dependencies = [
    "typed",
    "size",
    "concat",
    "subset",
    "setDifference",
    "Index"
];
var $231328e32a912b3b$export$4a9a0ead2012bfc4 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($231328e32a912b3b$var$name, $231328e32a912b3b$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, concat: concat, subset: subset, setDifference: setDifference, Index: Index } = _ref;
    /**
   * Create the symmetric difference of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setSymDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 5, 6]
   *    math.setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 5, 6]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The symmetric difference of two (multi)sets
   */ return typed($231328e32a912b3b$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a1);
            var b1 = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a1);
            var b2 = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a2);
            return concat(setDifference(b1, b2), setDifference(b2, b1));
        }
    });
});



var $47d57cff4da74de8$var$name = "setUnion";
var $47d57cff4da74de8$var$dependencies = [
    "typed",
    "size",
    "concat",
    "subset",
    "setIntersect",
    "setSymDifference",
    "Index"
];
var $47d57cff4da74de8$export$fbdfd2054d37f888 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($47d57cff4da74de8$var$name, $47d57cff4da74de8$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, concat: concat, subset: subset, setIntersect: setIntersect, setSymDifference: setSymDifference, Index: Index } = _ref;
    /**
   * Create the union of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setUnion(set1, set2)
   *
   * Examples:
   *
   *    math.setUnion([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 3, 4, 5, 6]
   *    math.setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 3, 4, 5, 6]
   *
   * See also:
   *
   *    setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The union of two (multi)sets
   */ return typed($47d57cff4da74de8$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a1);
            var b1 = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a1);
            var b2 = (0, $eee21df0c3527ff1$export$bffa455ba8c619a6)(a2);
            return concat(setSymDifference(b1, b2), setIntersect(b1, b2));
        }
    });
});




var $f5ab7d7b58725a06$var$name = "sign";
var $f5ab7d7b58725a06$var$dependencies = [
    "typed",
    "BigNumber",
    "Fraction",
    "complex"
];
var $f5ab7d7b58725a06$export$45df7cae684751af = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f5ab7d7b58725a06$var$name, $f5ab7d7b58725a06$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber, complex: complex, Fraction: _Fraction } = _ref;
    /**
   * Compute the sign of a value. The sign of a value x is:
   *
   * -  1 when x > 0
   * - -1 when x < 0
   * -  0 when x == 0
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sign(x)
   *
   * Examples:
   *
   *    math.sign(3.5)               // returns 1
   *    math.sign(-4.2)              // returns -1
   *    math.sign(0)                 // returns 0
   *
   *    math.sign([3, 5, -2, 0, 2])  // returns [1, 1, -1, 0, 1]
   *
   * See also:
   *
   *    abs
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Array | Matrix | Unit} x
   *            The number for which to determine the sign
   * @return {number | BigNumber | bigint | Fraction | Complex | Array | Matrix | Unit}
   *            The sign of `x`
   */ return typed($f5ab7d7b58725a06$var$name, {
        number: (0, $f38f49d8e24d4a9f$export$af3d9fe43be78285),
        Complex: function Complex(x) {
            return x.im === 0 ? complex((0, $f38f49d8e24d4a9f$export$af3d9fe43be78285)(x.re)) : x.sign();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x.cmp(0));
        },
        bigint: function bigint(x) {
            return x > 0n ? 1n : x < 0n ? -1n : 0n;
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x.s, 1);
        },
        // deep map collection, skip zeros since sign(0) = 0
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self, true)),
        Unit: typed.referToSelf((self)=>(x)=>{
                if (!x._isDerived() && x.units[0].unit.offset !== 0) throw new TypeError("sign is ambiguous for units with offset");
                return typed.find(self, x.valueType())(x.value);
            })
    });
});



var $9c2458d8ce9d1886$var$name = "sin";
var $9c2458d8ce9d1886$var$dependencies = [
    "typed"
];
var $9c2458d8ce9d1886$export$4b4fac44ef379cae = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9c2458d8ce9d1886$var$name, $9c2458d8ce9d1886$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    var trigUnit = (0, $5b7412feb4d38bfc$export$33129064a3329835)({
        typed: typed
    });
    /**
   * Calculate the sine of a value.
   *
   * To avoid confusion with the matrix sine, this function does not apply
   * to matrices.
   *
   * Syntax:
   *
   *    math.sin(x)
   *
   * Examples:
   *
   *    math.sin(2)                      // returns number 0.9092974268256813
   *    math.sin(math.pi / 4)            // returns number 0.7071067811865475
   *    math.sin(math.unit(90, 'deg'))   // returns number 1
   *    math.sin(math.unit(30, 'deg'))   // returns number 0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit} x  Function input
   * @return {number | BigNumber | Complex} Sine of x
   */ return typed($9c2458d8ce9d1886$var$name, {
        number: Math.sin,
        "Complex | BigNumber": (x)=>x.sin()
    }, trigUnit);
});



var $d3e1ffc4f2272b89$var$name = "sinh";
var $d3e1ffc4f2272b89$var$dependencies = [
    "typed"
];
var $d3e1ffc4f2272b89$export$c3a62182c56878d5 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d3e1ffc4f2272b89$var$name, $d3e1ffc4f2272b89$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic sine of a value,
   * defined as `sinh(x) = 1/2 * (exp(x) - exp(-x))`.
   *
   * To avoid confusion with the matrix hyperbolic sine, this function does
   * not apply to matrices.
   *
   * Syntax:
   *
   *    math.sinh(x)
   *
   * Examples:
   *
   *    math.sinh(0.5)       // returns number 0.5210953054937474
   *
   * See also:
   *
   *    cosh, tanh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic sine of x
   */ return typed($d3e1ffc4f2272b89$var$name, {
        number: (0, $08edde3ad76e4ae3$export$89648c4ce0d79e70),
        "Complex | BigNumber": (x)=>x.sinh()
    });
});




var $17bd5face8a48f01$var$name = "size";
var $17bd5face8a48f01$var$dependencies = [
    "typed",
    "config",
    "?matrix"
];
var $17bd5face8a48f01$export$9151c23a59ce3fb6 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($17bd5face8a48f01$var$name, $17bd5face8a48f01$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix } = _ref;
    /**
   * Calculate the size of a matrix or scalar.
   *
   * Syntax:
   *
   *     math.size(x)
   *
   * Examples:
   *
   *     math.size(2.3)                  // returns []
   *     math.size('hello world')        // returns [11]
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.size(A)                    // returns [2, 3]
   *     math.size(math.range(1,6))      // returns [5]
   *
   * See also:
   *
   *     count, resize, squeeze, subset
   *
   * @param {boolean | number | Complex | Unit | string | Array | Matrix} x  A matrix
   * @return {Array | Matrix} A vector with size of `x`.
   */ return typed($17bd5face8a48f01$var$name, {
        Matrix: function Matrix(x) {
            return x.create(x.size());
        },
        Array: (0, $eee21df0c3527ff1$export$51ffaee4afb683a5),
        string: function string(x) {
            return config.matrix === "Array" ? [
                x.length
            ] : matrix([
                x.length
            ]);
        },
        "number | Complex | BigNumber | Unit | boolean | null": function numberComplexBigNumberUnitBooleanNull(x) {
            // scalar
            return config.matrix === "Array" ? [] : matrix ? matrix([]) : (0, $ba7e85df6c2910bf$export$b81416cb7ecca475)();
        }
    });
});



// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Permutes a sparse matrix C = P * A * Q
 *
 * @param {SparseMatrix}  a         The Matrix A
 * @param {Array}   pinv            The row permutation vector
 * @param {Array}   q               The column permutation vector
 * @param {boolean} values          Create a pattern matrix (false), values and pattern otherwise
 *
 * @return {Matrix}                 C = P * A * Q, null on error
 */ function $4528c388835845d6$export$76070a0ecffd0bb2(a, pinv, q, values) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size;
    var adt = a._datatype;
    // rows & columns
    var m = asize[0];
    var n = asize[1];
    // c arrays
    var cvalues = values && a._values ? [] : null;
    var cindex = []; // (aptr[n])
    var cptr = []; // (n + 1)
    // initialize vars
    var nz = 0;
    // loop columns
    for(var k = 0; k < n; k++){
        // column k of C is column q[k] of A
        cptr[k] = nz;
        // apply column permutation
        var j = q ? q[k] : k;
        // loop values in column j of A
        for(var t0 = aptr[j], t1 = aptr[j + 1], t = t0; t < t1; t++){
            // row i of A is row pinv[i] of C
            var r = pinv ? pinv[aindex[t]] : aindex[t];
            // index
            cindex[nz] = r;
            // check we need to populate values
            if (cvalues) cvalues[nz] = avalues[t];
            // increment number of nonzero elements
            nz++;
        }
    }
    // finalize the last column of C
    cptr[n] = nz;
    // return C matrix
    return a.createSparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [
            m,
            n
        ],
        datatype: adt
    });
}


// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Depth-first search and postorder of a tree rooted at node j
 *
 * @param {Number}  j               The tree node
 * @param {Number}  k
 * @param {Array}   w               The workspace array
 * @param {Number}  head            The index offset within the workspace for the head array
 * @param {Number}  next            The index offset within the workspace for the next array
 * @param {Array}   post            The post ordering array
 * @param {Number}  stack           The index offset within the workspace for the stack array
 */ function $24e980d8ee1d8396$export$18e42241aee7902a(j, k, w, head, next, post, stack) {
    // variables
    var top = 0;
    // place j on the stack
    w[stack] = j;
    // while (stack is not empty)
    while(top >= 0){
        // p = top of stack
        var p = w[stack + top];
        // i = youngest child of p
        var i = w[head + p];
        if (i === -1) {
            // p has no unordered children left
            top--;
            // node p is the kth postordered node
            post[k++] = p;
        } else {
            // remove i from children of p
            w[head + p] = w[next + i];
            // increment top
            ++top;
            // start dfs on child node i
            w[stack + top] = i;
        }
    }
    return k;
}


function $fbbb2ebf925d5341$export$90626b0a5705891a(parent, n) {
    // check inputs
    if (!parent) return null;
    // vars
    var k = 0;
    var j;
    // allocate result
    var post = []; // (n)
    // workspace, head: first n entries, next: next n entries, stack: last n entries
    var w = []; // (3 * n)
    var head = 0;
    var next = n;
    var stack = 2 * n;
    // initialize workspace
    for(j = 0; j < n; j++)// empty linked lists
    w[head + j] = -1;
    // traverse nodes in reverse order
    for(j = n - 1; j >= 0; j--){
        // check j is a root
        if (parent[j] === -1) continue;
        // add j to list of its parent
        w[next + j] = w[head + parent[j]];
        w[head + parent[j]] = j;
    }
    // loop nodes
    for(j = 0; j < n; j++){
        // skip j if it is not a root
        if (parent[j] !== -1) continue;
        // depth-first search
        k = (0, $24e980d8ee1d8396$export$18e42241aee7902a)(j, k, w, head, next, post, stack);
    }
    return post;
}


// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Computes the elimination tree of Matrix A (using triu(A)) or the
 * elimination tree of A'A without forming A'A.
 *
 * @param {Matrix}  a               The A Matrix
 * @param {boolean} ata             A value of true the function computes the etree of A'A
 */ function $176ab7a2c88ddfd6$export$720e2a9a0fdebf8c(a, ata) {
    // check inputs
    if (!a) return null;
    // a arrays
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size;
    // rows & columns
    var m = asize[0];
    var n = asize[1];
    // allocate result
    var parent = []; // (n)
    // allocate workspace
    var w = []; // (n + (ata ? m : 0))
    var ancestor = 0; // first n entries in w
    var prev = n; // last m entries (ata = true)
    var i, inext;
    // check we are calculating A'A
    if (ata) // initialize workspace
    for(i = 0; i < m; i++)w[prev + i] = -1;
    // loop columns
    for(var k = 0; k < n; k++){
        // node k has no parent yet
        parent[k] = -1;
        // nor does k have an ancestor
        w[ancestor + k] = -1;
        // values in column k
        for(var p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++){
            // row
            var r = aindex[p];
            // node
            i = ata ? w[prev + r] : r;
            // traverse from i to k
            for(; i !== -1 && i < k; i = inext){
                // inext = ancestor of i
                inext = w[ancestor + i];
                // path compression
                w[ancestor + i] = k;
                // check no anc., parent is k
                if (inext === -1) parent[i] = k;
            }
            if (ata) w[prev + r] = k;
        }
    }
    return parent;
}


// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Keeps entries in the matrix when the callback function returns true, removes the entry otherwise
 *
 * @param {Matrix}   a              The sparse matrix
 * @param {function} callback       The callback function, function will be invoked with the following args:
 *                                    - The entry row
 *                                    - The entry column
 *                                    - The entry value
 *                                    - The state parameter
 * @param {any}      other          The state
 *
 * @return                          The number of nonzero elements in the matrix
 */ function $3f8c693a0411b901$export$9453433d9395b8cb(a, callback, other) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size;
    // columns
    var n = asize[1];
    // nonzero items
    var nz = 0;
    // loop columns
    for(var j = 0; j < n; j++){
        // get current location of col j
        var p = aptr[j];
        // record new location of col j
        aptr[j] = nz;
        for(; p < aptr[j + 1]; p++)// check we need to keep this item
        if (callback(aindex[p], j, avalues ? avalues[p] : 1, other)) {
            // keep A(i,j)
            aindex[nz] = aindex[p];
            // check we need to process values (pattern only)
            if (avalues) avalues[nz] = avalues[p];
            // increment nonzero items
            nz++;
        }
    }
    // finalize A
    aptr[n] = nz;
    // trim arrays
    aindex.splice(nz, aindex.length - nz);
    // check we need to process values (pattern only)
    if (avalues) avalues.splice(nz, avalues.length - nz);
    // return number of nonzero items
    return nz;
}


// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * This function "flips" its input about the integer -1.
 *
 * @param {Number}  i               The value to flip
 */ function $28faff025bfe5ea1$export$d405b3d9168b83fa(i) {
    // flip the value
    return -i - 2;
}



var $9c9b153f50326929$var$name = "csAmd";
var $9c9b153f50326929$var$dependencies = [
    "add",
    "multiply",
    "transpose"
];
var $9c9b153f50326929$export$485230eb48878637 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9c9b153f50326929$var$name, $9c9b153f50326929$var$dependencies, (_ref)=>{
    var { add: add, multiply: multiply, transpose: transpose } = _ref;
    /**
   * Approximate minimum degree ordering. The minimum degree algorithm is a widely used
   * heuristic for finding a permutation P so that P*A*P' has fewer nonzeros in its factorization
   * than A. It is a gready method that selects the sparsest pivot row and column during the course
   * of a right looking sparse Cholesky factorization.
   *
   * @param {Number} order    0: Natural, 1: Cholesky, 2: LU, 3: QR
   * @param {Matrix} m        Sparse Matrix
   */ return function csAmd(order, a) {
        // check input parameters
        if (!a || order <= 0 || order > 3) return null;
        // a matrix arrays
        var asize = a._size;
        // rows and columns
        var m = asize[0];
        var n = asize[1];
        // initialize vars
        var lemax = 0;
        // dense threshold
        var dense = Math.max(16, 10 * Math.sqrt(n));
        dense = Math.min(n - 2, dense);
        // create target matrix C
        var cm = _createTargetMatrix(order, a, m, n, dense);
        // drop diagonal entries
        (0, $3f8c693a0411b901$export$9453433d9395b8cb)(cm, _diag, null);
        // C matrix arrays
        var cindex = cm._index;
        var cptr = cm._ptr;
        // number of nonzero elements in C
        var cnz = cptr[n];
        // allocate result (n+1)
        var P = [];
        // create workspace (8 * (n + 1))
        var W = [];
        var len = 0; // first n + 1 entries
        var nv = n + 1; // next n + 1 entries
        var next = 2 * (n + 1); // next n + 1 entries
        var head = 3 * (n + 1); // next n + 1 entries
        var elen = 4 * (n + 1); // next n + 1 entries
        var degree = 5 * (n + 1); // next n + 1 entries
        var w = 6 * (n + 1); // next n + 1 entries
        var hhead = 7 * (n + 1); // last n + 1 entries
        // use P as workspace for last
        var last = P;
        // initialize quotient graph
        var mark = _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree);
        // initialize degree lists
        var nel = _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next);
        // minimum degree node
        var mindeg = 0;
        // vars
        var i, j, k, k1, k2, e, pj, ln, nvi, pk, eln, p1, p2, pn, h, d;
        // while (selecting pivots) do
        while(nel < n){
            // select node of minimum approximate degree. amd() is now ready to start eliminating the graph. It first
            // finds a node k of minimum degree and removes it from its degree list. The variable nel keeps track of thow
            // many nodes have been eliminated.
            for(k = -1; mindeg < n && (k = W[head + mindeg]) === -1; mindeg++);
            if (W[next + k] !== -1) last[W[next + k]] = -1;
            // remove k from degree list
            W[head + mindeg] = W[next + k];
            // elenk = |Ek|
            var elenk = W[elen + k];
            // # of nodes k represents
            var nvk = W[nv + k];
            // W[nv + k] nodes of A eliminated
            nel += nvk;
            // Construct a new element. The new element Lk is constructed in place if |Ek| = 0. nv[i] is
            // negated for all nodes i in Lk to flag them as members of this set. Each node i is removed from the
            // degree lists. All elements e in Ek are absorved into element k.
            var dk = 0;
            // flag k as in Lk
            W[nv + k] = -nvk;
            var p = cptr[k];
            // do in place if W[elen + k] === 0
            var pk1 = elenk === 0 ? p : cnz;
            var pk2 = pk1;
            for(k1 = 1; k1 <= elenk + 1; k1++){
                if (k1 > elenk) {
                    // search the nodes in k
                    e = k;
                    // list of nodes starts at cindex[pj]
                    pj = p;
                    // length of list of nodes in k
                    ln = W[len + k] - elenk;
                } else {
                    // search the nodes in e
                    e = cindex[p++];
                    pj = cptr[e];
                    // length of list of nodes in e
                    ln = W[len + e];
                }
                for(k2 = 1; k2 <= ln; k2++){
                    i = cindex[pj++];
                    // check  node i dead, or seen
                    if ((nvi = W[nv + i]) <= 0) continue;
                    // W[degree + Lk] += size of node i
                    dk += nvi;
                    // negate W[nv + i] to denote i in Lk
                    W[nv + i] = -nvi;
                    // place i in Lk
                    cindex[pk2++] = i;
                    if (W[next + i] !== -1) last[W[next + i]] = last[i];
                    // check we need to remove i from degree list
                    if (last[i] !== -1) W[next + last[i]] = W[next + i];
                    else W[head + W[degree + i]] = W[next + i];
                }
                if (e !== k) {
                    // absorb e into k
                    cptr[e] = (0, $28faff025bfe5ea1$export$d405b3d9168b83fa)(k);
                    // e is now a dead element
                    W[w + e] = 0;
                }
            }
            // cindex[cnz...nzmax] is free
            if (elenk !== 0) cnz = pk2;
            // external degree of k - |Lk\i|
            W[degree + k] = dk;
            // element k is in cindex[pk1..pk2-1]
            cptr[k] = pk1;
            W[len + k] = pk2 - pk1;
            // k is now an element
            W[elen + k] = -2;
            // Find set differences. The scan1 function now computes the set differences |Le \ Lk| for all elements e. At the start of the
            // scan, no entry in the w array is greater than or equal to mark.
            // clear w if necessary
            mark = _wclear(mark, lemax, W, w, n);
            // scan 1: find |Le\Lk|
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk];
                // check if W[elen + i] empty, skip it
                if ((eln = W[elen + i]) <= 0) continue;
                // W[nv + i] was negated
                nvi = -W[nv + i];
                var wnvi = mark - nvi;
                // scan Ei
                for(p = cptr[i], p1 = cptr[i] + eln - 1; p <= p1; p++){
                    e = cindex[p];
                    if (W[w + e] >= mark) // decrement |Le\Lk|
                    W[w + e] -= nvi;
                    else if (W[w + e] !== 0) // ensure e is a live element, 1st time e seen in scan 1
                    W[w + e] = W[degree + e] + wnvi;
                }
            }
            // degree update
            // The second pass computes the approximate degree di, prunes the sets Ei and Ai, and computes a hash
            // function h(i) for all nodes in Lk.
            // scan2: degree update
            for(pk = pk1; pk < pk2; pk++){
                // consider node i in Lk
                i = cindex[pk];
                p1 = cptr[i];
                p2 = p1 + W[elen + i] - 1;
                pn = p1;
                // scan Ei
                for(h = 0, d = 0, p = p1; p <= p2; p++){
                    e = cindex[p];
                    // check e is an unabsorbed element
                    if (W[w + e] !== 0) {
                        // dext = |Le\Lk|
                        var dext = W[w + e] - mark;
                        if (dext > 0) {
                            // sum up the set differences
                            d += dext;
                            // keep e in Ei
                            cindex[pn++] = e;
                            // compute the hash of node i
                            h += e;
                        } else {
                            // aggressive absorb. e->k
                            cptr[e] = (0, $28faff025bfe5ea1$export$d405b3d9168b83fa)(k);
                            // e is a dead element
                            W[w + e] = 0;
                        }
                    }
                }
                // W[elen + i] = |Ei|
                W[elen + i] = pn - p1 + 1;
                var p3 = pn;
                var p4 = p1 + W[len + i];
                // prune edges in Ai
                for(p = p2 + 1; p < p4; p++){
                    j = cindex[p];
                    // check node j dead or in Lk
                    var nvj = W[nv + j];
                    if (nvj <= 0) continue;
                    // degree(i) += |j|
                    d += nvj;
                    // place j in node list of i
                    cindex[pn++] = j;
                    // compute hash for node i
                    h += j;
                }
                // check for mass elimination
                if (d === 0) {
                    // absorb i into k
                    cptr[i] = (0, $28faff025bfe5ea1$export$d405b3d9168b83fa)(k);
                    nvi = -W[nv + i];
                    // |Lk| -= |i|
                    dk -= nvi;
                    // |k| += W[nv + i]
                    nvk += nvi;
                    nel += nvi;
                    W[nv + i] = 0;
                    // node i is dead
                    W[elen + i] = -1;
                } else {
                    // update degree(i)
                    W[degree + i] = Math.min(W[degree + i], d);
                    // move first node to end
                    cindex[pn] = cindex[p3];
                    // move 1st el. to end of Ei
                    cindex[p3] = cindex[p1];
                    // add k as 1st element in of Ei
                    cindex[p1] = k;
                    // new len of adj. list of node i
                    W[len + i] = pn - p1 + 1;
                    // finalize hash of i
                    h = (h < 0 ? -h : h) % n;
                    // place i in hash bucket
                    W[next + i] = W[hhead + h];
                    W[hhead + h] = i;
                    // save hash of i in last[i]
                    last[i] = h;
                }
            }
            // finalize |Lk|
            W[degree + k] = dk;
            lemax = Math.max(lemax, dk);
            // clear w
            mark = _wclear(mark + lemax, lemax, W, w, n);
            // Supernode detection. Supernode detection relies on the hash function h(i) computed for each node i.
            // If two nodes have identical adjacency lists, their hash functions wil be identical.
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk];
                // check i is dead, skip it
                if (W[nv + i] >= 0) continue;
                // scan hash bucket of node i
                h = last[i];
                i = W[hhead + h];
                // hash bucket will be empty
                W[hhead + h] = -1;
                for(; i !== -1 && W[next + i] !== -1; i = W[next + i], mark++){
                    ln = W[len + i];
                    eln = W[elen + i];
                    for(p = cptr[i] + 1; p <= cptr[i] + ln - 1; p++)W[w + cindex[p]] = mark;
                    var jlast = i;
                    // compare i with all j
                    for(j = W[next + i]; j !== -1;){
                        var ok = W[len + j] === ln && W[elen + j] === eln;
                        for(p = cptr[j] + 1; ok && p <= cptr[j] + ln - 1; p++)// compare i and j
                        if (W[w + cindex[p]] !== mark) ok = 0;
                        // check i and j are identical
                        if (ok) {
                            // absorb j into i
                            cptr[j] = (0, $28faff025bfe5ea1$export$d405b3d9168b83fa)(i);
                            W[nv + i] += W[nv + j];
                            W[nv + j] = 0;
                            // node j is dead
                            W[elen + j] = -1;
                            // delete j from hash bucket
                            j = W[next + j];
                            W[next + jlast] = j;
                        } else {
                            // j and i are different
                            jlast = j;
                            j = W[next + j];
                        }
                    }
                }
            }
            // Finalize new element. The elimination of node k is nearly complete. All nodes i in Lk are scanned one last time.
            // Node i is removed from Lk if it is dead. The flagged status of nv[i] is cleared.
            for(p = pk1, pk = pk1; pk < pk2; pk++){
                i = cindex[pk];
                // check  i is dead, skip it
                if ((nvi = -W[nv + i]) <= 0) continue;
                // restore W[nv + i]
                W[nv + i] = nvi;
                // compute external degree(i)
                d = W[degree + i] + dk - nvi;
                d = Math.min(d, n - nel - nvi);
                if (W[head + d] !== -1) last[W[head + d]] = i;
                // put i back in degree list
                W[next + i] = W[head + d];
                last[i] = -1;
                W[head + d] = i;
                // find new minimum degree
                mindeg = Math.min(mindeg, d);
                W[degree + i] = d;
                // place i in Lk
                cindex[p++] = i;
            }
            // # nodes absorbed into k
            W[nv + k] = nvk;
            // length of adj list of element k
            if ((W[len + k] = p - pk1) === 0) {
                // k is a root of the tree
                cptr[k] = -1;
                // k is now a dead element
                W[w + k] = 0;
            }
            if (elenk !== 0) // free unused space in Lk
            cnz = p;
        }
        // Postordering. The elimination is complete, but no permutation has been computed. All that is left
        // of the graph is the assembly tree (ptr) and a set of dead nodes and elements (i is a dead node if
        // nv[i] is zero and a dead element if nv[i] > 0). It is from this information only that the final permutation
        // is computed. The tree is restored by unflipping all of ptr.
        // fix assembly tree
        for(i = 0; i < n; i++)cptr[i] = (0, $28faff025bfe5ea1$export$d405b3d9168b83fa)(cptr[i]);
        for(j = 0; j <= n; j++)W[head + j] = -1;
        // place unordered nodes in lists
        for(j = n; j >= 0; j--){
            // skip if j is an element
            if (W[nv + j] > 0) continue;
            // place j in list of its parent
            W[next + j] = W[head + cptr[j]];
            W[head + cptr[j]] = j;
        }
        // place elements in lists
        for(e = n; e >= 0; e--){
            // skip unless e is an element
            if (W[nv + e] <= 0) continue;
            if (cptr[e] !== -1) {
                // place e in list of its parent
                W[next + e] = W[head + cptr[e]];
                W[head + cptr[e]] = e;
            }
        }
        // postorder the assembly tree
        for(k = 0, i = 0; i <= n; i++)if (cptr[i] === -1) k = (0, $24e980d8ee1d8396$export$18e42241aee7902a)(i, k, W, head, next, P, w);
        // remove last item in array
        P.splice(P.length - 1, 1);
        // return P
        return P;
    };
    /**
   * Creates the matrix that will be used by the approximate minimum degree ordering algorithm. The function accepts the matrix M as input and returns a permutation
   * vector P. The amd algorithm operates on a symmetrix matrix, so one of three symmetric matrices is formed.
   *
   * Order: 0
   *   A natural ordering P=null matrix is returned.
   *
   * Order: 1
   *   Matrix must be square. This is appropriate for a Cholesky or LU factorization.
   *   P = M + M'
   *
   * Order: 2
   *   Dense columns from M' are dropped, M recreated from M'. This is appropriatefor LU factorization of unsymmetric matrices.
   *   P = M' * M
   *
   * Order: 3
   *   This is best used for QR factorization or LU factorization is matrix M has no dense rows. A dense row is a row with more than 10*sqr(columns) entries.
   *   P = M' * M
   */ function _createTargetMatrix(order, a, m, n, dense) {
        // compute A'
        var at = transpose(a);
        // check order = 1, matrix must be square
        if (order === 1 && n === m) // C = A + A'
        return add(a, at);
        // check order = 2, drop dense columns from M'
        if (order === 2) {
            // transpose arrays
            var tindex = at._index;
            var tptr = at._ptr;
            // new column index
            var p2 = 0;
            // loop A' columns (rows)
            for(var j = 0; j < m; j++){
                // column j of AT starts here
                var p = tptr[j];
                // new column j starts here
                tptr[j] = p2;
                // skip dense col j
                if (tptr[j + 1] - p > dense) continue;
                // map rows in column j of A
                for(var p1 = tptr[j + 1]; p < p1; p++)tindex[p2++] = tindex[p];
            }
            // finalize AT
            tptr[m] = p2;
            // recreate A from new transpose matrix
            a = transpose(at);
            // use A' * A
            return multiply(at, a);
        }
        // use A' * A, square or rectangular matrix
        return multiply(at, a);
    }
    /**
   * Initialize quotient graph. There are four kind of nodes and elements that must be represented:
   *
   *  - A live node is a node i (or a supernode) that has not been selected as a pivot nad has not been merged into another supernode.
   *  - A dead node i is one that has been removed from the graph, having been absorved into r = flip(ptr[i]).
   *  - A live element e is one that is in the graph, having been formed when node e was selected as the pivot.
   *  - A dead element e is one that has benn absorved into a subsequent element s = flip(ptr[e]).
   */ function _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree) {
        // Initialize quotient graph
        for(var k = 0; k < n; k++)W[len + k] = cptr[k + 1] - cptr[k];
        W[len + n] = 0;
        // initialize workspace
        for(var i = 0; i <= n; i++){
            // degree list i is empty
            W[head + i] = -1;
            last[i] = -1;
            W[next + i] = -1;
            // hash list i is empty
            W[hhead + i] = -1;
            // node i is just one node
            W[nv + i] = 1;
            // node i is alive
            W[w + i] = 1;
            // Ek of node i is empty
            W[elen + i] = 0;
            // degree of node i
            W[degree + i] = W[len + i];
        }
        // clear w
        var mark = _wclear(0, 0, W, w, n);
        // n is a dead element
        W[elen + n] = -2;
        // n is a root of assembly tree
        cptr[n] = -1;
        // n is a dead element
        W[w + n] = 0;
        // return mark
        return mark;
    }
    /**
   * Initialize degree lists. Each node is placed in its degree lists. Nodes of zero degree are eliminated immediately. Nodes with
   * degree >= dense are alsol eliminated and merged into a placeholder node n, a dead element. Thes nodes will appera last in the
   * output permutation p.
   */ function _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next) {
        // result
        var nel = 0;
        // loop columns
        for(var i = 0; i < n; i++){
            // degree @ i
            var d = W[degree + i];
            // check node i is empty
            if (d === 0) {
                // element i is dead
                W[elen + i] = -2;
                nel++;
                // i is a root of assembly tree
                cptr[i] = -1;
                W[w + i] = 0;
            } else if (d > dense) {
                // absorb i into element n
                W[nv + i] = 0;
                // node i is dead
                W[elen + i] = -1;
                nel++;
                cptr[i] = (0, $28faff025bfe5ea1$export$d405b3d9168b83fa)(n);
                W[nv + n]++;
            } else {
                var h = W[head + d];
                if (h !== -1) last[h] = i;
                // put node i in degree list d
                W[next + i] = W[head + d];
                W[head + d] = i;
            }
        }
        return nel;
    }
    function _wclear(mark, lemax, W, w, n) {
        if (mark < 2 || mark + lemax < 0) {
            for(var k = 0; k < n; k++)if (W[w + k] !== 0) W[w + k] = 1;
            mark = 2;
        }
        // at this point, W [0..n-1] < mark holds
        return mark;
    }
    function _diag(i, j) {
        return i !== j;
    }
});


// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * This function determines if j is a leaf of the ith row subtree.
 * Consider A(i,j), node j in ith row subtree and return lca(jprev,j)
 *
 * @param {Number}  i               The ith row subtree
 * @param {Number}  j               The node to test
 * @param {Array}   w               The workspace array
 * @param {Number}  first           The index offset within the workspace for the first array
 * @param {Number}  maxfirst        The index offset within the workspace for the maxfirst array
 * @param {Number}  prevleaf        The index offset within the workspace for the prevleaf array
 * @param {Number}  ancestor        The index offset within the workspace for the ancestor array
 *
 * @return {Object}
 */ function $793ee079041dbef9$export$e5adc9884f74ac27(i, j, w, first, maxfirst, prevleaf, ancestor) {
    var s, sparent;
    // our result
    var jleaf = 0;
    var q;
    // check j is a leaf
    if (i <= j || w[first + j] <= w[maxfirst + i]) return -1;
    // update max first[j] seen so far
    w[maxfirst + i] = w[first + j];
    // jprev = previous leaf of ith subtree
    var jprev = w[prevleaf + i];
    w[prevleaf + i] = j;
    // check j is first or subsequent leaf
    if (jprev === -1) {
        // 1st leaf, q = root of ith subtree
        jleaf = 1;
        q = i;
    } else {
        // update jleaf
        jleaf = 2;
        // q = least common ancester (jprev,j)
        for(q = jprev; q !== w[ancestor + q]; q = w[ancestor + q]);
        for(s = jprev; s !== q; s = sparent){
            // path compression
            sparent = w[ancestor + s];
            w[ancestor + s] = q;
        }
    }
    return {
        jleaf: jleaf,
        q: q
    };
}


var $47427e8ca7f7c69a$var$name = "csCounts";
var $47427e8ca7f7c69a$var$dependencies = [
    "transpose"
];
var $47427e8ca7f7c69a$export$1feb4fbda2abf3b3 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($47427e8ca7f7c69a$var$name, $47427e8ca7f7c69a$var$dependencies, (_ref)=>{
    var { transpose: transpose } = _ref;
    /**
   * Computes the column counts using the upper triangular part of A.
   * It transposes A internally, none of the input parameters are modified.
   *
   * @param {Matrix} a           The sparse matrix A
   *
   * @param {Matrix} ata         Count the columns of A'A instead
   *
   * @return                     An array of size n of the column counts or null on error
   */ return function(a, parent, post, ata) {
        // check inputs
        if (!a || !parent || !post) return null;
        // a matrix arrays
        var asize = a._size;
        // rows and columns
        var m = asize[0];
        var n = asize[1];
        // variables
        var i, j, k, J, p, p0, p1;
        // workspace size
        var s = 4 * n + (ata ? n + m + 1 : 0);
        // allocate workspace
        var w = []; // (s)
        var ancestor = 0; // first n entries
        var maxfirst = n; // next n entries
        var prevleaf = 2 * n; // next n entries
        var first = 3 * n; // next n entries
        var head = 4 * n; // next n + 1 entries (used when ata is true)
        var next = 5 * n + 1; // last entries in workspace
        // clear workspace w[0..s-1]
        for(k = 0; k < s; k++)w[k] = -1;
        // allocate result
        var colcount = []; // (n)
        // AT = A'
        var at = transpose(a);
        // at arrays
        var tindex = at._index;
        var tptr = at._ptr;
        // find w[first + j]
        for(k = 0; k < n; k++){
            j = post[k];
            // colcount[j]=1 if j is a leaf
            colcount[j] = w[first + j] === -1 ? 1 : 0;
            for(; j !== -1 && w[first + j] === -1; j = parent[j])w[first + j] = k;
        }
        // initialize ata if needed
        if (ata) {
            // invert post
            for(k = 0; k < n; k++)w[post[k]] = k;
            // loop rows (columns in AT)
            for(i = 0; i < m; i++){
                // values in column i of AT
                for(k = n, p0 = tptr[i], p1 = tptr[i + 1], p = p0; p < p1; p++)k = Math.min(k, w[tindex[p]]);
                // place row i in linked list k
                w[next + i] = w[head + k];
                w[head + k] = i;
            }
        }
        // each node in its own set
        for(i = 0; i < n; i++)w[ancestor + i] = i;
        for(k = 0; k < n; k++){
            // j is the kth node in postordered etree
            j = post[k];
            // check j is not a root
            if (parent[j] !== -1) colcount[parent[j]]--;
            // J=j for LL'=A case
            for(J = ata ? w[head + k] : j; J !== -1; J = ata ? w[next + J] : -1)for(p = tptr[J]; p < tptr[J + 1]; p++){
                i = tindex[p];
                var r = (0, $793ee079041dbef9$export$e5adc9884f74ac27)(i, j, w, first, maxfirst, prevleaf, ancestor);
                // check A(i,j) is in skeleton
                if (r.jleaf >= 1) colcount[j]++;
                // check account for overlap in q
                if (r.jleaf === 2) colcount[r.q]--;
            }
            if (parent[j] !== -1) w[ancestor + j] = parent[j];
        }
        // sum up colcount's of each child
        for(j = 0; j < n; j++)if (parent[j] !== -1) colcount[parent[j]] += colcount[j];
        return colcount;
    };
});



var $6c34cbb0f1a084de$var$name = "csSqr";
var $6c34cbb0f1a084de$var$dependencies = [
    "add",
    "multiply",
    "transpose"
];
var $6c34cbb0f1a084de$export$4d3f338d9cfe48c1 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6c34cbb0f1a084de$var$name, $6c34cbb0f1a084de$var$dependencies, (_ref)=>{
    var { add: add, multiply: multiply, transpose: transpose } = _ref;
    var csAmd = (0, $9c9b153f50326929$export$485230eb48878637)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csCounts = (0, $47427e8ca7f7c69a$export$1feb4fbda2abf3b3)({
        transpose: transpose
    });
    /**
   * Symbolic ordering and analysis for QR and LU decompositions.
   *
   * @param {Number}  order           The ordering strategy (see csAmd for more details)
   * @param {Matrix}  a               The A matrix
   * @param {boolean} qr              Symbolic ordering and analysis for QR decomposition (true) or
   *                                  symbolic ordering and analysis for LU decomposition (false)
   *
   * @return {Object}                 The Symbolic ordering and analysis for matrix A
   */ return function csSqr(order, a, qr) {
        // a arrays
        var aptr = a._ptr;
        var asize = a._size;
        // columns
        var n = asize[1];
        // vars
        var k;
        // symbolic analysis result
        var s = {};
        // fill-reducing ordering
        s.q = csAmd(order, a);
        // validate results
        if (order && !s.q) return null;
        // QR symbolic analysis
        if (qr) {
            // apply permutations if needed
            var c = order ? (0, $4528c388835845d6$export$76070a0ecffd0bb2)(a, null, s.q, 0) : a;
            // etree of C'*C, where C=A(:,q)
            s.parent = (0, $176ab7a2c88ddfd6$export$720e2a9a0fdebf8c)(c, 1);
            // post order elimination tree
            var post = (0, $fbbb2ebf925d5341$export$90626b0a5705891a)(s.parent, n);
            // col counts chol(C'*C)
            s.cp = csCounts(c, s.parent, post, 1);
            // check we have everything needed to calculate number of nonzero elements
            if (c && s.parent && s.cp && _vcount(c, s)) // calculate number of nonzero elements
            for(s.unz = 0, k = 0; k < n; k++)s.unz += s.cp[k];
        } else {
            // for LU factorization only, guess nnz(L) and nnz(U)
            s.unz = 4 * aptr[n] + n;
            s.lnz = s.unz;
        }
        // return result S
        return s;
    };
    /**
   * Compute nnz(V) = s.lnz, s.pinv, s.leftmost, s.m2 from A and s.parent
   */ function _vcount(a, s) {
        // a arrays
        var aptr = a._ptr;
        var aindex = a._index;
        var asize = a._size;
        // rows & columns
        var m = asize[0];
        var n = asize[1];
        // initialize s arrays
        s.pinv = []; // (m + n)
        s.leftmost = []; // (m)
        // vars
        var parent = s.parent;
        var pinv = s.pinv;
        var leftmost = s.leftmost;
        // workspace, next: first m entries, head: next n entries, tail: next n entries, nque: next n entries
        var w = []; // (m + 3 * n)
        var next = 0;
        var head = m;
        var tail = m + n;
        var nque = m + 2 * n;
        // vars
        var i, k, p, p0, p1;
        // initialize w
        for(k = 0; k < n; k++){
            // queue k is empty
            w[head + k] = -1;
            w[tail + k] = -1;
            w[nque + k] = 0;
        }
        // initialize row arrays
        for(i = 0; i < m; i++)leftmost[i] = -1;
        // loop columns backwards
        for(k = n - 1; k >= 0; k--)// values & index for column k
        for(p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++)// leftmost[i] = min(find(A(i,:)))
        leftmost[aindex[p]] = k;
        // scan rows in reverse order
        for(i = m - 1; i >= 0; i--){
            // row i is not yet ordered
            pinv[i] = -1;
            k = leftmost[i];
            // check row i is empty
            if (k === -1) continue;
            // first row in queue k
            if (w[nque + k]++ === 0) w[tail + k] = i;
            // put i at head of queue k
            w[next + i] = w[head + k];
            w[head + k] = i;
        }
        s.lnz = 0;
        s.m2 = m;
        // find row permutation and nnz(V)
        for(k = 0; k < n; k++){
            // remove row i from queue k
            i = w[head + k];
            // count V(k,k) as nonzero
            s.lnz++;
            // add a fictitious row
            if (i < 0) i = s.m2++;
            // associate row i with V(:,k)
            pinv[i] = k;
            // skip if V(k+1:m,k) is empty
            if (--nque[k] <= 0) continue;
            // nque[k] is nnz (V(k+1:m,k))
            s.lnz += w[nque + k];
            // move all rows to parent of k
            var pa = parent[k];
            if (pa !== -1) {
                if (w[nque + pa] === 0) w[tail + pa] = w[tail + k];
                w[next + w[tail + k]] = w[head + pa];
                w[head + pa] = w[next + i];
                w[nque + pa] += w[nque + k];
            }
        }
        for(i = 0; i < m; i++)if (pinv[i] < 0) pinv[i] = k++;
        return true;
    }
});


// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Checks if the node at w[j] is marked
 *
 * @param {Array}   w               The array
 * @param {Number}  j               The array index
 */ function $577ceb5f4ff177f5$export$f0d640c1b5bfa3e(w, j) {
    // check node is marked
    return w[j] < 0;
}


// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

function $f967d739ddd1cde1$export$53b20e7656f0b914(w, j) {
    // mark w[j]
    w[j] = (0, $28faff025bfe5ea1$export$d405b3d9168b83fa)(w[j]);
}


// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source


// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

function $eac572e163cf5212$export$8b1bf205e2e76d92(i) {
    // flip the value if it is negative
    return i < 0 ? (0, $28faff025bfe5ea1$export$d405b3d9168b83fa)(i) : i;
}


function $1b1205ea59f93f6b$export$c913fe476af3832b(j, g, top, xi, pinv) {
    // g arrays
    var index = g._index;
    var ptr = g._ptr;
    var size = g._size;
    // columns
    var n = size[1];
    // vars
    var i, p, p2;
    // initialize head
    var head = 0;
    // initialize the recursion stack
    xi[0] = j;
    // loop
    while(head >= 0){
        // get j from the top of the recursion stack
        j = xi[head];
        // apply permutation vector
        var jnew = pinv ? pinv[j] : j;
        // check node j is marked
        if (!(0, $577ceb5f4ff177f5$export$f0d640c1b5bfa3e)(ptr, j)) {
            // mark node j as visited
            (0, $f967d739ddd1cde1$export$53b20e7656f0b914)(ptr, j);
            // update stack (last n entries in xi)
            xi[n + head] = jnew < 0 ? 0 : (0, $eac572e163cf5212$export$8b1bf205e2e76d92)(ptr[jnew]);
        }
        // node j done if no unvisited neighbors
        var done = 1;
        // examine all neighbors of j, stack (last n entries in xi)
        for(p = xi[n + head], p2 = jnew < 0 ? 0 : (0, $eac572e163cf5212$export$8b1bf205e2e76d92)(ptr[jnew + 1]); p < p2; p++){
            // consider neighbor node i
            i = index[p];
            // check we have visited node i, skip it
            if ((0, $577ceb5f4ff177f5$export$f0d640c1b5bfa3e)(ptr, i)) continue;
            // pause depth-first search of node j, update stack (last n entries in xi)
            xi[n + head] = p;
            // start dfs at node i
            xi[++head] = i;
            // node j is not done
            done = 0;
            break;
        }
        // check depth-first search at node j is done
        if (done) {
            // remove j from the recursion stack
            head--;
            // and place in the output stack
            xi[--top] = j;
        }
    }
    return top;
}


function $079b9c3f0c0dab61$export$125cefbcd149ec98(g, b, k, xi, pinv) {
    // g arrays
    var gptr = g._ptr;
    var gsize = g._size;
    // b arrays
    var bindex = b._index;
    var bptr = b._ptr;
    // columns
    var n = gsize[1];
    // vars
    var p, p0, p1;
    // initialize top
    var top = n;
    // loop column indeces in B
    for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++){
        // node i
        var i = bindex[p];
        // check node i is marked
        if (!(0, $577ceb5f4ff177f5$export$f0d640c1b5bfa3e)(gptr, i)) // start a dfs at unmarked node i
        top = (0, $1b1205ea59f93f6b$export$c913fe476af3832b)(i, g, top, xi, pinv);
    }
    // loop columns from top -> n - 1
    for(p = top; p < n; p++)// restore G
    (0, $f967d739ddd1cde1$export$53b20e7656f0b914)(gptr, xi[p]);
    return top;
}



var $577b94ed98f2b02f$var$name = "csSpsolve";
var $577b94ed98f2b02f$var$dependencies = [
    "divideScalar",
    "multiply",
    "subtract"
];
var $577b94ed98f2b02f$export$517933164557054f = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($577b94ed98f2b02f$var$name, $577b94ed98f2b02f$var$dependencies, (_ref)=>{
    var { divideScalar: divideScalar, multiply: multiply, subtract: subtract } = _ref;
    /**
   * The function csSpsolve() computes the solution to G * x = bk, where bk is the
   * kth column of B. When lo is true, the function assumes G = L is lower triangular with the
   * diagonal entry as the first entry in each column. When lo is true, the function assumes G = U
   * is upper triangular with the diagonal entry as the last entry in each column.
   *
   * @param {Matrix}  g               The G matrix
   * @param {Matrix}  b               The B matrix
   * @param {Number}  k               The kth column in B
   * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
   *                                  The first n entries is the nonzero pattern, the last n entries is the stack
   * @param {Array}   x               The soluton to the linear system G * x = b
   * @param {Array}   pinv            The inverse row permutation vector, must be null for L * x = b
   * @param {boolean} lo              The lower (true) upper triangular (false) flag
   *
   * @return {Number}                 The index for the nonzero pattern
   */ return function csSpsolve(g, b, k, xi, x, pinv, lo) {
        // g arrays
        var gvalues = g._values;
        var gindex = g._index;
        var gptr = g._ptr;
        var gsize = g._size;
        // columns
        var n = gsize[1];
        // b arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        // vars
        var p, p0, p1, q;
        // xi[top..n-1] = csReach(B(:,k))
        var top = (0, $079b9c3f0c0dab61$export$125cefbcd149ec98)(g, b, k, xi, pinv);
        // clear x
        for(p = top; p < n; p++)x[xi[p]] = 0;
        // scatter b
        for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++)x[bindex[p]] = bvalues[p];
        // loop columns
        for(var px = top; px < n; px++){
            // x array index for px
            var j = xi[px];
            // apply permutation vector (U x = b), j maps to column J of G
            var J = pinv ? pinv[j] : j;
            // check column J is empty
            if (J < 0) continue;
            // column value indeces in G, p0 <= p < p1
            p0 = gptr[J];
            p1 = gptr[J + 1];
            // x(j) /= G(j,j)
            x[j] = divideScalar(x[j], gvalues[lo ? p0 : p1 - 1]);
            // first entry L(j,j)
            p = lo ? p0 + 1 : p0;
            q = lo ? p1 : p1 - 1;
            // loop
            for(; p < q; p++){
                // row
                var i = gindex[p];
                // x(i) -= G(i,j) * x(j)
                x[i] = subtract(x[i], multiply(gvalues[p], x[j]));
            }
        }
        // return top of stack
        return top;
    };
});


var $1f3bb7edd7d09c6d$var$name = "csLu";
var $1f3bb7edd7d09c6d$var$dependencies = [
    "abs",
    "divideScalar",
    "multiply",
    "subtract",
    "larger",
    "largerEq",
    "SparseMatrix"
];
var $1f3bb7edd7d09c6d$export$5487b5fadeacd2f6 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($1f3bb7edd7d09c6d$var$name, $1f3bb7edd7d09c6d$var$dependencies, (_ref)=>{
    var { abs: abs, divideScalar: divideScalar, multiply: multiply, subtract: subtract, larger: larger, largerEq: largerEq, SparseMatrix: SparseMatrix } = _ref;
    var csSpsolve = (0, $577b94ed98f2b02f$export$517933164557054f)({
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract
    });
    /**
   * Computes the numeric LU factorization of the sparse matrix A. Implements a Left-looking LU factorization
   * algorithm that computes L and U one column at a tume. At the kth step, it access columns 1 to k-1 of L
   * and column k of A. Given the fill-reducing column ordering q (see parameter s) computes L, U and pinv so
   * L * U = A(p, q), where p is the inverse of pinv.
   *
   * @param {Matrix}  m               The A Matrix to factorize
   * @param {Object}  s               The symbolic analysis from csSqr(). Provides the fill-reducing
   *                                  column ordering q
   * @param {Number}  tol             Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Number}                 The numeric LU factorization of A or null
   */ return function csLu(m, s, tol) {
        // validate input
        if (!m) return null;
        // m arrays
        var size = m._size;
        // columns
        var n = size[1];
        // symbolic analysis result
        var q;
        var lnz = 100;
        var unz = 100;
        // update symbolic analysis parameters
        if (s) {
            q = s.q;
            lnz = s.lnz || lnz;
            unz = s.unz || unz;
        }
        // L arrays
        var lvalues = []; // (lnz)
        var lindex = []; // (lnz)
        var lptr = []; // (n + 1)
        // L
        var L = new SparseMatrix({
            values: lvalues,
            index: lindex,
            ptr: lptr,
            size: [
                n,
                n
            ]
        });
        // U arrays
        var uvalues = []; // (unz)
        var uindex = []; // (unz)
        var uptr = []; // (n + 1)
        // U
        var U = new SparseMatrix({
            values: uvalues,
            index: uindex,
            ptr: uptr,
            size: [
                n,
                n
            ]
        });
        // inverse of permutation vector
        var pinv = []; // (n)
        // vars
        var i, p;
        // allocate arrays
        var x = []; // (n)
        var xi = []; // (2 * n)
        // initialize variables
        for(i = 0; i < n; i++){
            // clear workspace
            x[i] = 0;
            // no rows pivotal yet
            pinv[i] = -1;
            // no cols of L yet
            lptr[i + 1] = 0;
        }
        // reset number of nonzero elements in L and U
        lnz = 0;
        unz = 0;
        // compute L(:,k) and U(:,k)
        for(var k = 0; k < n; k++){
            // update ptr
            lptr[k] = lnz;
            uptr[k] = unz;
            // apply column permutations if needed
            var col = q ? q[k] : k;
            // solve triangular system, x = L\A(:,col)
            var top = csSpsolve(L, m, col, xi, x, pinv, 1);
            // find pivot
            var ipiv = -1;
            var a = -1;
            // loop xi[] from top -> n
            for(p = top; p < n; p++){
                // x[i] is nonzero
                i = xi[p];
                // check row i is not yet pivotal
                if (pinv[i] < 0) {
                    // absolute value of x[i]
                    var xabs = abs(x[i]);
                    // check absoulte value is greater than pivot value
                    if (larger(xabs, a)) {
                        // largest pivot candidate so far
                        a = xabs;
                        ipiv = i;
                    }
                } else {
                    // x(i) is the entry U(pinv[i],k)
                    uindex[unz] = pinv[i];
                    uvalues[unz++] = x[i];
                }
            }
            // validate we found a valid pivot
            if (ipiv === -1 || a <= 0) return null;
            // update actual pivot column, give preference to diagonal value
            if (pinv[col] < 0 && largerEq(abs(x[col]), multiply(a, tol))) ipiv = col;
            // the chosen pivot
            var pivot = x[ipiv];
            // last entry in U(:,k) is U(k,k)
            uindex[unz] = k;
            uvalues[unz++] = pivot;
            // ipiv is the kth pivot row
            pinv[ipiv] = k;
            // first entry in L(:,k) is L(k,k) = 1
            lindex[lnz] = ipiv;
            lvalues[lnz++] = 1;
            // L(k+1:n,k) = x / pivot
            for(p = top; p < n; p++){
                // row
                i = xi[p];
                // check x(i) is an entry in L(:,k)
                if (pinv[i] < 0) {
                    // save unpermuted row in L
                    lindex[lnz] = i;
                    // scale pivot column
                    lvalues[lnz++] = divideScalar(x[i], pivot);
                }
                // x[0..n-1] = 0 for next k
                x[i] = 0;
            }
        }
        // update ptr
        lptr[n] = lnz;
        uptr[n] = unz;
        // fix row indices of L for final pinv
        for(p = 0; p < lnz; p++)lindex[p] = pinv[lindex[p]];
        // trim arrays
        lvalues.splice(lnz, lvalues.length - lnz);
        lindex.splice(lnz, lindex.length - lnz);
        uvalues.splice(unz, uvalues.length - unz);
        uindex.splice(unz, uindex.length - unz);
        // return LU factor
        return {
            L: L,
            U: U,
            pinv: pinv
        };
    };
});


var $e3d1fc760aabbc8a$var$name = "slu";
var $e3d1fc760aabbc8a$var$dependencies = [
    "typed",
    "abs",
    "add",
    "multiply",
    "transpose",
    "divideScalar",
    "subtract",
    "larger",
    "largerEq",
    "SparseMatrix"
];
var $e3d1fc760aabbc8a$export$e44ac9822ce417ae = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e3d1fc760aabbc8a$var$name, $e3d1fc760aabbc8a$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, multiply: multiply, transpose: transpose, divideScalar: divideScalar, subtract: subtract, larger: larger, largerEq: largerEq, SparseMatrix: SparseMatrix } = _ref;
    var csSqr = (0, $6c34cbb0f1a084de$export$4d3f338d9cfe48c1)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csLu = (0, $1f3bb7edd7d09c6d$export$5487b5fadeacd2f6)({
        abs: abs,
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract,
        larger: larger,
        largerEq: largerEq,
        SparseMatrix: SparseMatrix
    });
    /**
   * Calculate the Sparse Matrix LU decomposition with full pivoting. Sparse Matrix `A` is decomposed in two matrices (`L`, `U`) and two permutation vectors (`pinv`, `q`) where
   *
   * `P * A * Q = L * U`
   *
   * Syntax:
   *
   *    math.slu(A, order, threshold)
   *
   * Examples:
   *
   *    const A = math.sparse([[4,3], [6, 3]])
   *    math.slu(A, 1, 0.001)
   *    // returns:
   *    // {
   *    //   L: [[1, 0], [1.5, 1]]
   *    //   U: [[4, 3], [0, -1.5]]
   *    //   p: [0, 1]
   *    //   q: [0, 1]
   *    // }
   *
   * See also:
   *
   *    lup, lsolve, usolve, lusolve
   *
   * @param {SparseMatrix} A              A two dimensional sparse matrix for which to get the LU decomposition.
   * @param {Number}       order          The Symbolic Ordering and Analysis order:
   *                                       0 - Natural ordering, no permutation vector q is returned
   *                                       1 - Matrix must be square, symbolic ordering and analisis is performed on M = A + A'
   *                                       2 - Symbolic ordering and analisis is performed on M = A' * A. Dense columns from A' are dropped, A recreated from A'.
   *                                           This is appropriatefor LU factorization of unsymmetric matrices.
   *                                       3 - Symbolic ordering and analisis is performed on M = A' * A. This is best used for LU factorization is matrix M has no dense rows.
   *                                           A dense row is a row with more than 10*sqr(columns) entries.
   * @param {Number}       threshold       Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Object} The lower triangular matrix, the upper triangular matrix and the permutation vectors.
   */ return typed($e3d1fc760aabbc8a$var$name, {
        "SparseMatrix, number, number": function SparseMatrixNumberNumber(a, order, threshold) {
            // verify order
            if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(order) || order < 0 || order > 3) throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
            // verify threshold
            if (threshold < 0 || threshold > 1) throw new Error("Partial pivoting threshold must be a number from 0 to 1");
            // perform symbolic ordering and analysis
            var s = csSqr(order, a, false);
            // perform lu decomposition
            var f = csLu(a, s, threshold);
            // return decomposition
            return {
                L: f.L,
                U: f.U,
                p: f.pinv,
                q: s.q,
                toString: function toString() {
                    return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\np: " + this.p.toString() + (this.q ? "\nq: " + this.q.toString() : "") + "\n";
                }
            };
        }
    });
});









var $dc266a434600d916$var$name = "smaller";
var $dc266a434600d916$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix",
    "concat"
];
var $dc266a434600d916$export$6b477d90b957f03e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($dc266a434600d916$var$name, $dc266a434600d916$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $5e352e66a45fa3fa$export$439c4d7accd2a586)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var compareUnits = (0, $c47ed063b6d2cbd9$export$f15f03c51630bb25)({
        typed: typed
    });
    /**
   * Test whether value x is smaller than y.
   *
   * The function returns true when x is smaller than y and the relative
   * difference between x and y is smaller than the configured relTol and absTol. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smaller(x, y)
   *
   * Examples:
   *
   *    math.smaller(2, 3)            // returns true
   *    math.smaller(5, 2 * 2)        // returns false
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.smaller(a, b)            // returns true
   *
   * See also:
   *
   *    equal, unequal, smallerEq, smaller, smallerEq, compare
   *
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ return typed($dc266a434600d916$var$name, $dc266a434600d916$export$4f82e7db4d803209({
        typed: typed,
        config: config
    }), {
        "boolean, boolean": (x, y)=>x < y,
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.lt(y) && !(0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol);
        },
        "bigint, bigint": (x, y)=>x < y,
        "Fraction, Fraction": (x, y)=>x.compare(y) === -1,
        "Complex, Complex": function ComplexComplex(x, y) {
            throw new TypeError("No ordering relation is defined for complex numbers");
        }
    }, compareUnits, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $dc266a434600d916$export$4f82e7db4d803209 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($dc266a434600d916$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($dc266a434600d916$var$name, {
        "number, number": function numberNumber(x, y) {
            return x < y && !(0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol);
        }
    });
});









var $a72eaf45d8253930$var$name = "smallerEq";
var $a72eaf45d8253930$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix",
    "concat"
];
var $a72eaf45d8253930$export$e1b2fff975be9083 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a72eaf45d8253930$var$name, $a72eaf45d8253930$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $5e352e66a45fa3fa$export$439c4d7accd2a586)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var compareUnits = (0, $c47ed063b6d2cbd9$export$f15f03c51630bb25)({
        typed: typed
    });
    /**
   * Test whether value x is smaller or equal to y.
   *
   * The function returns true when x is smaller than y or the relative
   * difference between x and y is smaller than the configured relTol and absTol. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smallerEq(x, y)
   *
   * Examples:
   *
   *    math.smaller(1 + 2, 3)        // returns false
   *    math.smallerEq(1 + 2, 3)      // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, larger, largerEq, compare
   *
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ return typed($a72eaf45d8253930$var$name, $a72eaf45d8253930$export$78c24428429985da({
        typed: typed,
        config: config
    }), {
        "boolean, boolean": (x, y)=>x <= y,
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.lte(y) || (0, $6a2233744a2a4c6f$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol);
        },
        "bigint, bigint": (x, y)=>x <= y,
        "Fraction, Fraction": (x, y)=>x.compare(y) !== 1,
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        }
    }, compareUnits, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $a72eaf45d8253930$export$78c24428429985da = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a72eaf45d8253930$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($a72eaf45d8253930$var$name, {
        "number, number": function numberNumber(x, y) {
            return x <= y || (0, $a246eb207aab6d09$export$6f3989c6ecc04081)(x, y, config.relTol, config.absTol);
        }
    });
});




function $4f98e7629f4c1b51$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4f98e7629f4c1b51$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4f98e7629f4c1b51$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4f98e7629f4c1b51$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4f98e7629f4c1b51$var$name = "solveODE";
var $4f98e7629f4c1b51$var$dependencies = [
    "typed",
    "add",
    "subtract",
    "multiply",
    "divide",
    "max",
    "map",
    "abs",
    "isPositive",
    "isNegative",
    "larger",
    "smaller",
    "matrix",
    "bignumber",
    "unaryMinus"
];
var $4f98e7629f4c1b51$export$73f8b9bd532fee8 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($4f98e7629f4c1b51$var$name, $4f98e7629f4c1b51$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, subtract: subtract, multiply: multiply, divide: divide, max: max, map: map, abs: abs, isPositive: isPositive, isNegative: isNegative, larger: larger, smaller: smaller, matrix: matrix, bignumber: bignumber, unaryMinus: unaryMinus } = _ref;
    /**
     * Numerical Integration of Ordinary Differential Equations
     *
     * Two variable step methods are provided:
     * - "RK23": Bogacki–Shampine method
     * - "RK45": Dormand-Prince method RK5(4)7M (default)
     *
     * The arguments are expected as follows.
     *
     * - `func` should be the forcing function `f(t, y)`
     * - `tspan` should be a vector of two numbers or units `[tStart, tEnd]`
     * - `y0` the initial state values, should be a scalar or a flat array
     * - `options` should be an object with the following information:
     *   - `method` ('RK45'): ['RK23', 'RK45']
     *   - `tol` (1e-3): Numeric tolerance of the method, the solver keeps the error estimates less than this value
     *   - `firstStep`: Initial step size
     *   - `minStep`: minimum step size of the method
     *   - `maxStep`: maximum step size of the method
     *   - `minDelta` (0.2): minimum ratio of change for the step
     *   - `maxDelta` (5): maximum ratio of change for the step
     *   - `maxIter` (1e4): maximum number of iterations
     *
     * The returned value is an object with `{t, y}` please note that even though `t` means time, it can represent any other independant variable like `x`:
     * - `t` an array of size `[n]`
     * - `y` the states array can be in two ways
     *   - **if `y0` is a scalar:** returns an array-like of size `[n]`
     *   - **if `y0` is a flat array-like of size [m]:** returns an array like of size `[n, m]`
     *
     * Syntax:
     *
     *     math.solveODE(func, tspan, y0)
     *     math.solveODE(func, tspan, y0, options)
     *
     * Examples:
     *
     *     function func(t, y) {return y}
     *     const tspan = [0, 4]
     *     const y0 = 1
     *     math.solveODE(func, tspan, y0)
     *     math.solveODE(func, tspan, [1, 2])
     *     math.solveODE(func, tspan, y0, { method:"RK23", maxStep:0.1 })
     *
     * See also:
     *
     *     derivative, simplifyCore
     *
     * @param {function} func The forcing function f(t,y)
     * @param {Array | Matrix} tspan The time span
     * @param {number | BigNumber | Unit | Array | Matrix} y0 The initial value
     * @param {Object} [options] Optional configuration options
     * @return {Object} Return an object with t and y values as arrays
     */ function _rk(butcherTableau) {
        // generates an adaptive runge kutta method from it's butcher tableau
        return function(f, tspan, y0, options) {
            // adaptive runge kutta methods
            var wrongTSpan = !(tspan.length === 2 && (tspan.every(isNumOrBig) || tspan.every((0, $23cfe017d190638f$export$8960dc335987b8da))));
            if (wrongTSpan) throw new Error('"tspan" must be an Array of two numeric values or two units [tStart, tEnd]');
            var t0 = tspan[0]; // initial time
            var tf = tspan[1]; // final time
            var isForwards = larger(tf, t0);
            var firstStep = options.firstStep;
            if (firstStep !== undefined && !isPositive(firstStep)) throw new Error('"firstStep" must be positive');
            var maxStep = options.maxStep;
            if (maxStep !== undefined && !isPositive(maxStep)) throw new Error('"maxStep" must be positive');
            var minStep = options.minStep;
            if (minStep && isNegative(minStep)) throw new Error('"minStep" must be positive or zero');
            var timeVars = [
                t0,
                tf,
                firstStep,
                minStep,
                maxStep
            ].filter((x)=>x !== undefined);
            if (!(timeVars.every(isNumOrBig) || timeVars.every((0, $23cfe017d190638f$export$8960dc335987b8da)))) throw new Error('Inconsistent type of "t" dependant variables');
            var steps = 1; // divide time in this number of steps
            var tol = options.tol ? options.tol : 1e-4; // define a tolerance (must be an option)
            var minDelta = options.minDelta ? options.minDelta : 0.2;
            var maxDelta = options.maxDelta ? options.maxDelta : 5;
            var maxIter = options.maxIter ? options.maxIter : 10000; // stop inifite evaluation if something goes wrong
            var hasBigNumbers = [
                t0,
                tf,
                ...y0,
                maxStep,
                minStep
            ].some((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab));
            var [a, c, b, bp] = hasBigNumbers ? [
                bignumber(butcherTableau.a),
                bignumber(butcherTableau.c),
                bignumber(butcherTableau.b),
                bignumber(butcherTableau.bp)
            ] : [
                butcherTableau.a,
                butcherTableau.c,
                butcherTableau.b,
                butcherTableau.bp
            ];
            var h = firstStep ? isForwards ? firstStep : unaryMinus(firstStep) : divide(subtract(tf, t0), steps); // define the first step size
            var t = [
                t0
            ]; // start the time array
            var y = [
                y0
            ]; // start the solution array
            var deltaB = subtract(b, bp); // b - bp
            var n = 0;
            var iter = 0;
            var ongoing = _createOngoing(isForwards);
            var trimStep = _createTrimStep(isForwards);
            // iterate unitil it reaches either the final time or maximum iterations
            while(ongoing(t[n], tf)){
                var k = [];
                // trim the time step so that it doesn't overshoot
                h = trimStep(t[n], tf, h);
                // calculate the first value of k
                k.push(f(t[n], y[n]));
                // calculate the rest of the values of k
                for(var i = 1; i < c.length; ++i)k.push(f(add(t[n], multiply(c[i], h)), add(y[n], multiply(h, a[i], k))));
                // estimate the error by comparing solutions of different orders
                var TE = max(abs(map(multiply(deltaB, k), (X)=>(0, $23cfe017d190638f$export$8960dc335987b8da)(X) ? X.value : X)));
                if (TE < tol && tol / TE > 1 / 4) {
                    // push solution if within tol
                    t.push(add(t[n], h));
                    y.push(add(y[n], multiply(h, b, k)));
                    n++;
                }
                // estimate the delta value that will affect the step size
                var delta = 0.84 * (tol / TE) ** 0.2;
                if (smaller(delta, minDelta)) delta = minDelta;
                else if (larger(delta, maxDelta)) delta = maxDelta;
                delta = hasBigNumbers ? bignumber(delta) : delta;
                h = multiply(h, delta);
                if (maxStep && larger(abs(h), maxStep)) h = isForwards ? maxStep : unaryMinus(maxStep);
                else if (minStep && smaller(abs(h), minStep)) h = isForwards ? minStep : unaryMinus(minStep);
                iter++;
                if (iter > maxIter) throw new Error("Maximum number of iterations reached, try changing options");
            }
            return {
                t: t,
                y: y
            };
        };
    }
    function _rk23(f, tspan, y0, options) {
        // Bogacki–Shampine method
        // Define the butcher table
        var a = [
            [],
            [
                0.5
            ],
            [
                0,
                3 / 4
            ],
            [
                2 / 9,
                1 / 3,
                4 / 9
            ]
        ];
        var c = [
            null,
            0.5,
            3 / 4,
            1
        ];
        var b = [
            2 / 9,
            1 / 3,
            4 / 9,
            0
        ];
        var bp = [
            7 / 24,
            1 / 4,
            1 / 3,
            1 / 8
        ];
        var butcherTableau = {
            a: a,
            c: c,
            b: b,
            bp: bp
        };
        // Solve an adaptive step size rk method
        return _rk(butcherTableau)(f, tspan, y0, options);
    }
    function _rk45(f, tspan, y0, options) {
        // Dormand Prince method
        // Define the butcher tableau
        var a = [
            [],
            [
                0.2
            ],
            [
                3 / 40,
                9 / 40
            ],
            [
                44 / 45,
                -56 / 15,
                32 / 9
            ],
            [
                19372 / 6561,
                -25360 / 2187,
                64448 / 6561,
                -212 / 729
            ],
            [
                9017 / 3168,
                -355 / 33,
                46732 / 5247,
                49 / 176,
                -5103 / 18656
            ],
            [
                35 / 384,
                0,
                500 / 1113,
                125 / 192,
                -2187 / 6784,
                11 / 84
            ]
        ];
        var c = [
            null,
            0.2,
            0.3,
            0.8,
            8 / 9,
            1,
            1
        ];
        var b = [
            35 / 384,
            0,
            500 / 1113,
            125 / 192,
            -2187 / 6784,
            11 / 84,
            0
        ];
        var bp = [
            5179 / 57600,
            0,
            7571 / 16695,
            393 / 640,
            -92097 / 339200,
            187 / 2100,
            1 / 40
        ];
        var butcherTableau = {
            a: a,
            c: c,
            b: b,
            bp: bp
        };
        // Solve an adaptive step size rk method
        return _rk(butcherTableau)(f, tspan, y0, options);
    }
    function _solveODE(f, tspan, y0, opt) {
        var method = opt.method ? opt.method : "RK45";
        var methods = {
            RK23: _rk23,
            RK45: _rk45
        };
        if (method.toUpperCase() in methods) {
            var methodOptions = $4f98e7629f4c1b51$var$_objectSpread({}, opt); // clone the options object
            delete methodOptions.method; // delete the method as it won't be needed
            return methods[method.toUpperCase()](f, tspan, y0, methodOptions);
        } else {
            // throw an error indicating there is no such method
            var methodsWithQuotes = Object.keys(methods).map((x)=>'"'.concat(x, '"'));
            // generates a string of methods like: "BDF", "RK23" and "RK45"
            var availableMethodsString = "".concat(methodsWithQuotes.slice(0, -1).join(", "), " and ").concat(methodsWithQuotes.slice(-1));
            throw new Error('Unavailable method "'.concat(method, '". Available methods are ').concat(availableMethodsString));
        }
    }
    function _createOngoing(isForwards) {
        // returns the correct function to test if it's still iterating
        return isForwards ? smaller : larger;
    }
    function _createTrimStep(isForwards) {
        var outOfBounds = isForwards ? larger : smaller;
        return function(t, tf, h) {
            var next = add(t, h);
            return outOfBounds(next, tf) ? subtract(tf, t) : h;
        };
    }
    function isNumOrBig(x) {
        // checks if it's a number or bignumber
        return (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(x) || (0, $23cfe017d190638f$export$7e4aa119212bc614)(x);
    }
    function _matrixSolveODE(f, T, y0, options) {
        // receives matrices and returns matrices
        var sol = _solveODE(f, T.toArray(), y0.toArray(), options);
        return {
            t: matrix(sol.t),
            y: matrix(sol.y)
        };
    }
    return typed("solveODE", {
        "function, Array, Array, Object": _solveODE,
        "function, Matrix, Matrix, Object": _matrixSolveODE,
        "function, Array, Array": (f, T, y0)=>_solveODE(f, T, y0, {}),
        "function, Matrix, Matrix": (f, T, y0)=>_matrixSolveODE(f, T, y0, {}),
        "function, Array, number | BigNumber | Unit": (f, T, y0)=>{
            var sol = _solveODE(f, T, [
                y0
            ], {});
            return {
                t: sol.t,
                y: sol.y.map((Y)=>Y[0])
            };
        },
        "function, Matrix, number | BigNumber | Unit": (f, T, y0)=>{
            var sol = _solveODE(f, T.toArray(), [
                y0
            ], {});
            return {
                t: matrix(sol.t),
                y: matrix(sol.y.map((Y)=>Y[0]))
            };
        },
        "function, Array, number | BigNumber | Unit, Object": (f, T, y0, options)=>{
            var sol = _solveODE(f, T, [
                y0
            ], options);
            return {
                t: sol.t,
                y: sol.y.map((Y)=>Y[0])
            };
        },
        "function, Matrix, number | BigNumber | Unit, Object": (f, T, y0, options)=>{
            var sol = _solveODE(f, T.toArray(), [
                y0
            ], options);
            return {
                t: matrix(sol.t),
                y: matrix(sol.y.map((Y)=>Y[0]))
            };
        }
    });
});



var $0d272956785d1388$var$name = "sort";
var $0d272956785d1388$var$dependencies = [
    "typed",
    "matrix",
    "compare",
    "compareNatural"
];
var $0d272956785d1388$export$10463693a2093403 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0d272956785d1388$var$name, $0d272956785d1388$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, compare: compare, compareNatural: compareNatural } = _ref;
    var compareAsc = compare;
    var compareDesc = (a, b)=>-compare(a, b);
    /**
   * Sort the items in a matrix.
   *
   * Syntax:
   *
   *    math.sort(x)
   *    math.sort(x, compare)
   *
   * Examples:
   *
   *    math.sort([5, 10, 1]) // returns [1, 5, 10]
   *    math.sort(['C', 'B', 'A', 'D'], math.compareNatural)
   *    // returns ['A', 'B', 'C', 'D']
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.sort(['Langdon', 'Tom', 'Sara'], sortByLength)
   *    // returns ['Tom', 'Sara', 'Langdon']
   *
   * See also:
   *
   *    filter, forEach, map, compare, compareNatural
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Function | 'asc' | 'desc' | 'natural'} [compare='asc']
   *        An optional _comparator function or name. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {Matrix | Array} Returns the sorted matrix.
   */ return typed($0d272956785d1388$var$name, {
        Array: function Array(x) {
            _arrayIsVector(x);
            return x.sort(compareAsc);
        },
        Matrix: function Matrix(x) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(compareAsc), x.storage());
        },
        "Array, function": function ArrayFunction(x, _comparator) {
            _arrayIsVector(x);
            return x.sort(_comparator);
        },
        "Matrix, function": function MatrixFunction(x, _comparator) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator), x.storage());
        },
        "Array, string": function ArrayString(x, order) {
            _arrayIsVector(x);
            return x.sort(_comparator(order));
        },
        "Matrix, string": function MatrixString(x, order) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator(order)), x.storage());
        }
    });
    /**
   * Get the comparator for given order ('asc', 'desc', 'natural')
   * @param {'asc' | 'desc' | 'natural'} order
   * @return {Function} Returns a _comparator function
   */ function _comparator(order) {
        if (order === "asc") return compareAsc;
        else if (order === "desc") return compareDesc;
        else if (order === "natural") return compareNatural;
        else throw new Error('String "asc", "desc", or "natural" expected');
    }
    /**
   * Validate whether an array is one dimensional
   * Throws an error when this is not the case
   * @param {Array} array
   * @private
   */ function _arrayIsVector(array) {
        if ((0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(array).length !== 1) throw new Error("One dimensional array expected");
    }
    /**
   * Validate whether a matrix is one dimensional
   * Throws an error when this is not the case
   * @param {Matrix} matrix
   * @private
   */ function _matrixIsVector(matrix) {
        if (matrix.size().length !== 1) throw new Error("One dimensional matrix expected");
    }
});


var $740d8ea2f318c5be$var$name = "Spa";
var $740d8ea2f318c5be$var$dependencies = [
    "addScalar",
    "equalScalar",
    "FibonacciHeap"
];
var $740d8ea2f318c5be$export$5e37e847685a0540 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($740d8ea2f318c5be$var$name, $740d8ea2f318c5be$var$dependencies, (_ref)=>{
    var { addScalar: addScalar, equalScalar: equalScalar, FibonacciHeap: FibonacciHeap } = _ref;
    /**
   * An ordered Sparse Accumulator is a representation for a sparse vector that includes a dense array
   * of the vector elements and an ordered list of non-zero elements.
   */ function Spa() {
        if (!(this instanceof Spa)) throw new SyntaxError("Constructor must be called with the new operator");
        // allocate vector, TODO use typed arrays
        this._values = [];
        this._heap = new FibonacciHeap();
    }
    /**
   * Attach type information
   */ Spa.prototype.type = "Spa";
    Spa.prototype.isSpa = true;
    /**
   * Set the value for index i.
   *
   * @param {number} i                       The index
   * @param {number | BigNumber | Complex}   The value at index i
   */ Spa.prototype.set = function(i, v) {
        // check we have a value @ i
        if (!this._values[i]) {
            // insert in heap
            var node = this._heap.insert(i, v);
            // set the value @ i
            this._values[i] = node;
        } else // update the value @ i
        this._values[i].value = v;
    };
    Spa.prototype.get = function(i) {
        var node = this._values[i];
        if (node) return node.value;
        return 0;
    };
    Spa.prototype.accumulate = function(i, v) {
        // node @ i
        var node = this._values[i];
        if (!node) {
            // insert in heap
            node = this._heap.insert(i, v);
            // initialize value
            this._values[i] = node;
        } else // accumulate value
        node.value = addScalar(node.value, v);
    };
    Spa.prototype.forEach = function(from, to, callback) {
        // references
        var heap = this._heap;
        var values = this._values;
        // nodes
        var nodes = [];
        // node with minimum key, save it
        var node = heap.extractMinimum();
        if (node) nodes.push(node);
        // extract nodes from heap (ordered)
        while(node && node.key <= to){
            // check it is in range
            if (node.key >= from) // check value is not zero
            {
                if (!equalScalar(node.value, 0)) // invoke callback
                callback(node.key, node.value, this);
            }
            // extract next node, save it
            node = heap.extractMinimum();
            if (node) nodes.push(node);
        }
        // reinsert all nodes in heap
        for(var i = 0; i < nodes.length; i++){
            // current node
            var n = nodes[i];
            // insert node in heap
            node = heap.insert(n.key, n.value);
            // update values
            values[node.key] = node;
        }
    };
    Spa.prototype.swap = function(i, j) {
        // node @ i and j
        var nodei = this._values[i];
        var nodej = this._values[j];
        // check we need to insert indeces
        if (!nodei && nodej) {
            // insert in heap
            nodei = this._heap.insert(i, nodej.value);
            // remove from heap
            this._heap.remove(nodej);
            // set values
            this._values[i] = nodei;
            this._values[j] = undefined;
        } else if (nodei && !nodej) {
            // insert in heap
            nodej = this._heap.insert(j, nodei.value);
            // remove from heap
            this._heap.remove(nodei);
            // set values
            this._values[j] = nodej;
            this._values[i] = undefined;
        } else if (nodei && nodej) {
            // swap values
            var v = nodei.value;
            nodei.value = nodej.value;
            nodej.value = v;
        }
    };
    return Spa;
}, {
    isClass: true
});


var $3b151484333e8d7e$var$name = "sparse";
var $3b151484333e8d7e$var$dependencies = [
    "typed",
    "SparseMatrix"
];
var $3b151484333e8d7e$export$89ff03fdb3964a99 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3b151484333e8d7e$var$name, $3b151484333e8d7e$var$dependencies, (_ref)=>{
    var { typed: typed, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a Sparse Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   * Note that a Sparse Matrix is always 2-dimensional, so for example if
   * you create one from a plain array of _n_ numbers, you get an _n_ by 1
   * Sparse "column vector".
   *
   * Syntax:
   *
   *    math.sparse()               // creates an empty sparse matrix.
   *    math.sparse(data)           // creates a sparse matrix with initial data.
   *    math.sparse(data, 'number') // creates a sparse matrix with initial data, number datatype.
   *
   * Examples:
   *
   *    let m = math.sparse([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *    let v = math.sparse([0, 0, 1])
   *    v.size()                        // Array [3, 1]
   *    v.get([2, 0])                   // number 1
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, matrix
   *
   * @param {Array | Matrix} [data]    A two dimensional array
   *
   * @return {Matrix} The created matrix
   */ return typed($3b151484333e8d7e$var$name, {
        "": function _() {
            return new SparseMatrix([]);
        },
        string: function string(datatype) {
            return new SparseMatrix([], datatype);
        },
        "Array | Matrix": function ArrayMatrix(data) {
            return new SparseMatrix(data);
        },
        "Array | Matrix, string": function ArrayMatrixString(data, datatype) {
            return new SparseMatrix(data, datatype);
        }
    });
});









var $81d4ac66979a3607$var$name = "SparseMatrix";
var $81d4ac66979a3607$var$dependencies = [
    "typed",
    "equalScalar",
    "Matrix"
];
var $81d4ac66979a3607$export$a783ce8f6a98b2e5 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($81d4ac66979a3607$var$name, $81d4ac66979a3607$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar, Matrix: Matrix } = _ref;
    /**
   * Sparse Matrix implementation. This type implements
   * a [Compressed Column Storage](https://en.wikipedia.org/wiki/Sparse_matrix#Compressed_sparse_column_(CSC_or_CCS))
   * format for two-dimensional sparse matrices.
   * @class SparseMatrix
   */ function SparseMatrix(data, datatype) {
        if (!(this instanceof SparseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $23cfe017d190638f$export$844ec244b1367d54)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(data)) // create from matrix
        _createFromMatrix(this, data, datatype);
        else if (data && (0, $23cfe017d190638f$export$43bee75e5e14138e)(data.index) && (0, $23cfe017d190638f$export$43bee75e5e14138e)(data.ptr) && (0, $23cfe017d190638f$export$43bee75e5e14138e)(data.size)) {
            // initialize fields
            this._values = data.values;
            this._index = data.index;
            this._ptr = data.ptr;
            this._size = data.size;
            this._datatype = datatype || data.datatype;
        } else if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(data)) // create from array
        _createFromArray(this, data, datatype);
        else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(data) + ")");
        else {
            // nothing provided
            this._values = [];
            this._index = [];
            this._ptr = [
                0
            ];
            this._size = [
                0,
                0
            ];
            this._datatype = datatype;
        }
    }
    function _createFromMatrix(matrix, source, datatype) {
        // check matrix type
        if (source.type === "SparseMatrix") {
            // clone arrays
            matrix._values = source._values ? (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(source._values) : undefined;
            matrix._index = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(source._index);
            matrix._ptr = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(source._ptr);
            matrix._size = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(source._size);
            matrix._datatype = datatype || source._datatype;
        } else // build from matrix data
        _createFromArray(matrix, source.valueOf(), datatype || source._datatype);
    }
    function _createFromArray(matrix, data, datatype) {
        // initialize fields
        matrix._values = [];
        matrix._index = [];
        matrix._ptr = [];
        matrix._datatype = datatype;
        // discover rows & columns, do not use math.size() to avoid looping array twice
        var rows = data.length;
        var columns = 0;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        if ((0, $23cfe017d190638f$export$844ec244b1367d54)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar;
            // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        }
        // check we have rows (empty array)
        if (rows > 0) {
            // column index
            var j = 0;
            do {
                // store pointer to values index
                matrix._ptr.push(matrix._index.length);
                // loop rows
                for(var i = 0; i < rows; i++){
                    // current row
                    var row = data[i];
                    // check row is an array
                    if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(row)) {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < row.length) columns = row.length;
                        // check row has column
                        if (j < row.length) {
                            // value
                            var v = row[j];
                            // check value != 0
                            if (!eq(v, zero)) {
                                // store value
                                matrix._values.push(v);
                                // index
                                matrix._index.push(i);
                            }
                        }
                    } else {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < 1) columns = 1;
                        // check value != 0 (row is a scalar)
                        if (!eq(row, zero)) {
                            // store value
                            matrix._values.push(row);
                            // index
                            matrix._index.push(i);
                        }
                    }
                }
                // increment index
                j++;
            }while (j < columns);
        }
        // store number of values in ptr
        matrix._ptr.push(matrix._index.length);
        // size
        matrix._size = [
            rows,
            columns
        ];
    }
    SparseMatrix.prototype = new Matrix();
    /**
   * Create a new SparseMatrix
   */ SparseMatrix.prototype.createSparseMatrix = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ Object.defineProperty(SparseMatrix, "name", {
        value: "SparseMatrix"
    });
    SparseMatrix.prototype.constructor = SparseMatrix;
    SparseMatrix.prototype.type = "SparseMatrix";
    SparseMatrix.prototype.isSparseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf SparseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ SparseMatrix.prototype.getDataType = function() {
        return (0, $eee21df0c3527ff1$export$d31e00bf4359ea8b)(this._values, (0, $23cfe017d190638f$export$f5bbd400c2f4426f));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @memberof SparseMatrix
   * @return {string}           The storage format.
   */ SparseMatrix.prototype.storage = function() {
        return "sparse";
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @memberof SparseMatrix
   * @return {string}           The datatype.
   */ SparseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new SparseMatrix
   * @memberof SparseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ SparseMatrix.prototype.create = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Get the matrix density.
   *
   * Usage:
   *     const density = matrix.density()                   // retrieve matrix density
   *
   * @memberof SparseMatrix
   * @return {number}           The matrix density.
   */ SparseMatrix.prototype.density = function() {
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1];
        // calculate density
        return rows !== 0 && columns !== 0 ? this._index.length / (rows * columns) : 0;
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof SparseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ SparseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke subset on a Pattern only matrix");
        // check arguments
        switch(arguments.length){
            case 1:
                return _getsubset(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _setsubset(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    function _getsubset(matrix, idx) {
        // check idx
        if (!(0, $23cfe017d190638f$export$ba3dc792055c2f45)(idx)) throw new TypeError("Invalid index");
        var isScalar = idx.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(idx.min());
        // validate dimensions
        var size = idx.size();
        if (size.length !== matrix._size.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(size.length, matrix._size.length);
        // vars
        var i, ii, k, kk;
        // validate if any of the ranges in the index is out of range
        var min = idx.min();
        var max = idx.max();
        for(i = 0, ii = matrix._size.length; i < ii; i++){
            (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(min[i], matrix._size[i]);
            (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(max[i], matrix._size[i]);
        }
        // matrix arrays
        var mvalues = matrix._values;
        var mindex = matrix._index;
        var mptr = matrix._ptr;
        // rows & columns dimensions for result matrix
        var rows = idx.dimension(0);
        var columns = idx.dimension(1);
        // workspace & permutation vector
        var w = [];
        var pv = [];
        // loop rows in resulting matrix
        rows.forEach(function(i, r) {
            // update permutation vector
            pv[i] = r[0];
            // mark i in workspace
            w[i] = true;
        });
        // result matrix arrays
        var values = mvalues ? [] : undefined;
        var index = [];
        var ptr = [];
        // loop columns in result matrix
        columns.forEach(function(j) {
            // update ptr
            ptr.push(index.length);
            // loop values in column j
            for(k = mptr[j], kk = mptr[j + 1]; k < kk; k++){
                // row
                i = mindex[k];
                // check row is in result matrix
                if (w[i] === true) {
                    // push index
                    index.push(pv[i]);
                    // check we need to process values
                    if (values) values.push(mvalues[k]);
                }
            }
        });
        // update ptr
        ptr.push(index.length);
        // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: size,
            datatype: matrix._datatype
        });
    }
    function _setsubset(matrix, index, submatrix, defaultValue) {
        // check index
        if (!index || index.isIndex !== true) throw new TypeError("Invalid index");
        // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar();
        // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(submatrix)) {
            // submatrix size
            sSize = submatrix.size();
            // use array representation
            submatrix = submatrix.toArray();
        } else // get submatrix size (array, scalar)
        sSize = (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(submatrix);
        // check index is a scalar
        if (isScalar) {
            // verify submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError("Scalar expected");
            // set value
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // validate dimensions, index size must be one or two dimensions
            if (iSize.length !== 1 && iSize.length !== 2) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(iSize.length, matrix._size.length, "<");
            // check submatrix and index have the same dimensions
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                }
                // unsqueeze both outer and inner dimensions
                submatrix = (0, $eee21df0c3527ff1$export$5a07c5202d40a604)(submatrix, iSize.length, outer, sSize);
            }
            // check whether the size of the submatrix matches the index size
            if (!(0, $46a94b3d1146edd8$export$6cc798251952180)(iSize, sSize)) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(iSize, sSize, ">");
            // insert the sub matrix
            if (iSize.length === 1) {
                // if the replacement index only has 1 dimension, go trough each one and set its value
                var range = index.dimension(0);
                range.forEach(function(dataIndex, subIndex) {
                    (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(dataIndex);
                    matrix.set([
                        dataIndex,
                        0
                    ], submatrix[subIndex[0]], defaultValue);
                });
            } else {
                // if the replacement index has 2 dimensions, go through each one and set the value in the correct index
                var firstDimensionRange = index.dimension(0);
                var secondDimensionRange = index.dimension(1);
                firstDimensionRange.forEach(function(firstDataIndex, firstSubIndex) {
                    (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(firstDataIndex);
                    secondDimensionRange.forEach(function(secondDataIndex, secondSubIndex) {
                        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(secondDataIndex);
                        matrix.set([
                            firstDataIndex,
                            secondDataIndex
                        ], submatrix[firstSubIndex[0]][secondSubIndex[0]], defaultValue);
                    });
                });
            }
        }
        return matrix;
    }
    /**
   * Get a single element from the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ SparseMatrix.prototype.get = function(index) {
        if (!(0, $23cfe017d190638f$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(index.length, this._size.length);
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke get on a Pattern only matrix");
        // row and column
        var i = index[0];
        var j = index[1];
        // check i, j are valid
        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(i, this._size[0]);
        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(j, this._size[1]);
        // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index);
        // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) return this._values[k];
        return 0;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} v
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be set to zero.
   * @return {SparseMatrix} self
   */ SparseMatrix.prototype.set = function(index, v, defaultValue) {
        if (!(0, $23cfe017d190638f$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(index.length, this._size.length);
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke set on a Pattern only matrix");
        // row and column
        var i = index[0];
        var j = index[1];
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1];
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        if ((0, $23cfe017d190638f$export$844ec244b1367d54)(this._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                this._datatype,
                this._datatype
            ]) || equalScalar;
            // convert 0 to the same datatype
            zero = typed.convert(0, this._datatype);
        }
        // check we need to resize matrix
        if (i > rows - 1 || j > columns - 1) {
            // resize matrix
            _resize(this, Math.max(i + 1, rows), Math.max(j + 1, columns), defaultValue);
            // update rows & columns
            rows = this._size[0];
            columns = this._size[1];
        }
        // check i, j are valid
        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(i, rows);
        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(j, columns);
        // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index);
        // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) {
            // check value != 0
            if (!eq(v, zero)) // update value
            this._values[k] = v;
            else // remove value from matrix
            _remove(k, j, this._values, this._index, this._ptr);
        } else if (!eq(v, zero)) // insert value @ (i, j)
        _insert(k, i, j, v, this._values, this._index, this._ptr);
        return this;
    };
    function _getValueIndex(i, top, bottom, index) {
        // check row is on the bottom side
        if (bottom - top === 0) return bottom;
        // loop rows [top, bottom[
        for(var r = top; r < bottom; r++){
            // check we found value index
            if (index[r] === i) return r;
        }
        // we did not find row
        return top;
    }
    function _remove(k, j, values, index, ptr) {
        // remove value @ k
        values.splice(k, 1);
        index.splice(k, 1);
        // update pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]--;
    }
    function _insert(k, i, j, v, values, index, ptr) {
        // insert value
        values.splice(k, 0, v);
        // update row for k
        index.splice(k, 0, i);
        // update column pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]++;
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof SparseMatrix
   * @param {number[] | Matrix} size  The new size the matrix should have.
   *                                  Since sparse matrices are always two-dimensional,
   *                                  size must be two numbers in either an array or a matrix
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ SparseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $23cfe017d190638f$export$cea7aa84e978eba5)(size)) throw new TypeError("Array or Matrix expected");
        // SparseMatrix input is always 2d, flatten this into 1d if it's indeed a vector
        var sizeArray = size.valueOf().map((value)=>{
            return Array.isArray(value) && value.length === 1 ? value[0] : value;
        });
        if (sizeArray.length !== 2) throw new Error("Only two dimensions matrix are supported");
        // check sizes
        sizeArray.forEach(function(value) {
            if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(value) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(sizeArray) + ")");
        });
        // matrix to resize
        var m = copy ? this.clone() : this;
        // resize matrix
        return _resize(m, sizeArray[0], sizeArray[1], defaultValue);
    };
    function _resize(matrix, rows, columns, defaultValue) {
        // value to insert at the time of growing matrix
        var value = defaultValue || 0;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        if ((0, $23cfe017d190638f$export$844ec244b1367d54)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar;
            // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype);
            // convert value to the same datatype
            value = typed.convert(value, matrix._datatype);
        }
        // should we insert the value?
        var ins = !eq(value, zero);
        // old columns and rows
        var r = matrix._size[0];
        var c = matrix._size[1];
        var i, j, k;
        // check we need to increase columns
        if (columns > c) {
            // loop new columns
            for(j = c; j < columns; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._values.length;
                // check we need to insert matrix._values
                if (ins) // loop rows
                for(i = 0; i < r; i++){
                    // add new matrix._values
                    matrix._values.push(value);
                    // update matrix._index
                    matrix._index.push(i);
                }
            }
            // store number of matrix._values in matrix._ptr
            matrix._ptr[columns] = matrix._values.length;
        } else if (columns < c) {
            // truncate matrix._ptr
            matrix._ptr.splice(columns + 1, c - columns);
            // truncate matrix._values and matrix._index
            matrix._values.splice(matrix._ptr[columns], matrix._values.length);
            matrix._index.splice(matrix._ptr[columns], matrix._index.length);
        }
        // update columns
        c = columns;
        // check we need to increase rows
        if (rows > r) // check we have to insert values
        {
            if (ins) {
                // inserts
                var n = 0;
                // loop columns
                for(j = 0; j < c; j++){
                    // update matrix._ptr for current column
                    matrix._ptr[j] = matrix._ptr[j] + n;
                    // where to insert matrix._values
                    k = matrix._ptr[j + 1] + n;
                    // pointer
                    var p = 0;
                    // loop new rows, initialize pointer
                    for(i = r; i < rows; i++, p++){
                        // add value
                        matrix._values.splice(k + p, 0, value);
                        // update matrix._index
                        matrix._index.splice(k + p, 0, i);
                        // increment inserts
                        n++;
                    }
                }
                // store number of matrix._values in matrix._ptr
                matrix._ptr[c] = matrix._values.length;
            }
        } else if (rows < r) {
            // deletes
            var d = 0;
            // loop columns
            for(j = 0; j < c; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._ptr[j] - d;
                // where matrix._values start for next column
                var k0 = matrix._ptr[j];
                var k1 = matrix._ptr[j + 1] - d;
                // loop matrix._index
                for(k = k0; k < k1; k++){
                    // row
                    i = matrix._index[k];
                    // check we need to delete value and matrix._index
                    if (i > rows - 1) {
                        // remove value
                        matrix._values.splice(k, 1);
                        // remove item from matrix._index
                        matrix._index.splice(k, 1);
                        // increase deletes
                        d++;
                    }
                }
            }
            // update matrix._ptr for current column
            matrix._ptr[j] = matrix._values.length;
        }
        // update matrix._size
        matrix._size[0] = rows;
        matrix._size[1] = columns;
        // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof SparseMatrix
   * @param {number[]} sizes          The new size the matrix should have.
   *                                  Since sparse matrices are always two-dimensional,
   *                                  size must be two numbers in either an array or a matrix
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ SparseMatrix.prototype.reshape = function(sizes, copy) {
        // validate arguments
        if (!(0, $23cfe017d190638f$export$43bee75e5e14138e)(sizes)) throw new TypeError("Array expected");
        if (sizes.length !== 2) throw new Error("Sparse matrices can only be reshaped in two dimensions");
        // check sizes
        sizes.forEach(function(value) {
            if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(value) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(value) || value <= -2 || value === 0) throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(sizes) + ")");
        });
        var currentLength = this._size[0] * this._size[1];
        sizes = (0, $eee21df0c3527ff1$export$d0efc868ac2c6822)(sizes, currentLength);
        var newLength = sizes[0] * sizes[1];
        // m * n must not change
        if (currentLength !== newLength) throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
        // matrix to reshape
        var m = copy ? this.clone() : this;
        // return unchanged if the same shape
        if (this._size[0] === sizes[0] && this._size[1] === sizes[1]) return m;
        // Convert to COO format (generate a column index)
        var colIndex = [];
        for(var i = 0; i < m._ptr.length; i++)for(var j = 0; j < m._ptr[i + 1] - m._ptr[i]; j++)colIndex.push(i);
        // Clone the values array
        var values = m._values.slice();
        // Clone the row index array
        var rowIndex = m._index.slice();
        // Transform the (row, column) indices
        for(var _i = 0; _i < m._index.length; _i++){
            var r1 = rowIndex[_i];
            var c1 = colIndex[_i];
            var flat = r1 * m._size[1] + c1;
            colIndex[_i] = flat % sizes[1];
            rowIndex[_i] = Math.floor(flat / sizes[1]);
        }
        // Now reshaping is supposed to preserve the row-major order, BUT these sparse matrices are stored
        // in column-major order, so we have to reorder the value array now. One option is to use a multisort,
        // sorting several arrays based on some other array.
        // OR, we could easily just:
        // 1. Remove all values from the matrix
        m._values.length = 0;
        m._index.length = 0;
        m._ptr.length = sizes[1] + 1;
        m._size = sizes.slice();
        for(var _i2 = 0; _i2 < m._ptr.length; _i2++)m._ptr[_i2] = 0;
        // 2. Re-insert all elements in the proper order (simplified code from SparseMatrix.prototype.set)
        // This step is probably the most time-consuming
        for(var h = 0; h < values.length; h++){
            var _i3 = rowIndex[h];
            var _j = colIndex[h];
            var v = values[h];
            var k = _getValueIndex(_i3, m._ptr[_j], m._ptr[_j + 1], m._index);
            _insert(k, _i3, _j, v, m._values, m._index, m._ptr);
        }
        // The value indices are inserted out of order, but apparently that's... still OK?
        return m;
    };
    /**
   * Create a clone of the matrix
   * @memberof SparseMatrix
   * @return {SparseMatrix} clone
   */ SparseMatrix.prototype.clone = function() {
        var m = new SparseMatrix({
            values: this._values ? (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this._values) : undefined,
            index: (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this._index),
            ptr: (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this._ptr),
            size: (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof SparseMatrix
   * @returns {number[]} size
   */ SparseMatrix.prototype.size = function() {
        return this._size.slice(0); // copy the Array
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {SparseMatrix} matrix
   */ SparseMatrix.prototype.map = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke map on a Pattern only matrix");
        // matrix instance
        var me = this;
        // rows and columns
        var rows = this._size[0];
        var columns = this._size[1];
        // invoke callback
        var args = (0, $ffc30f141434c696$export$6c00fba23f8c91a7)(callback);
        var invoke = function invoke(v, i, j) {
            // invoke callback
            if (args === 1) return callback(v);
            if (args === 2) return callback(v, [
                i,
                j
            ]);
            return callback(v, [
                i,
                j
            ], me);
        };
        // invoke _map
        return _map(this, 0, rows - 1, 0, columns - 1, invoke, skipZeros);
    };
    /**
   * Create a new matrix with the results of the callback function executed on the interval
   * [minRow..maxRow, minColumn..maxColumn].
   */ function _map(matrix, minRow, maxRow, minColumn, maxColumn, callback, skipZeros) {
        // result arrays
        var values = [];
        var index = [];
        var ptr = [];
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        if ((0, $23cfe017d190638f$export$844ec244b1367d54)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar;
            // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype);
        }
        // invoke callback
        var invoke = function invoke(v, x, y) {
            // invoke callback
            v = callback(v, x, y);
            // check value != 0
            if (!eq(v, zero)) {
                // store value
                values.push(v);
                // index
                index.push(x);
            }
        };
        // loop columns
        for(var j = minColumn; j <= maxColumn; j++){
            // store pointer to values index
            ptr.push(values.length);
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = matrix._ptr[j];
            var k1 = matrix._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = matrix._index[k];
                // check i is in range
                if (i >= minRow && i <= maxRow) // value @ k
                invoke(matrix._values[k], i - minRow, j - minColumn);
            }
            else {
                // create a cache holding all defined values
                var _values = {};
                for(var _k = k0; _k < k1; _k++){
                    var _i4 = matrix._index[_k];
                    _values[_i4] = matrix._values[_k];
                }
                // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i5 = minRow; _i5 <= maxRow; _i5++){
                    var value = _i5 in _values ? _values[_i5] : 0;
                    invoke(value, _i5 - minRow, j - minColumn);
                }
            }
        }
        // store number of values in ptr
        ptr.push(values.length);
        // return sparse matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                maxRow - minRow + 1,
                maxColumn - minColumn + 1
            ]
        });
    }
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *                              If false, the indices are guaranteed to be in order,
   *                              if true, the indices can be unordered.
   */ SparseMatrix.prototype.forEach = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke forEach on a Pattern only matrix");
        // matrix instance
        var me = this;
        // rows and columns
        var rows = this._size[0];
        var columns = this._size[1];
        // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k];
                // value @ k
                callback(this._values[k], [
                    i,
                    j
                ], me);
            }
            else {
                // create a cache holding all defined values
                var values = {};
                for(var _k2 = k0; _k2 < k1; _k2++){
                    var _i6 = this._index[_k2];
                    values[_i6] = this._values[_k2];
                }
                // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i7 = 0; _i7 < rows; _i7++){
                    var value = _i7 in values ? values[_i7] : 0;
                    callback(value, [
                        _i7,
                        j
                    ], me);
                }
            }
        }
    };
    /**
   * Iterate over the matrix elements, skipping zeros
   * @return {Iterable<{ value, index: number[] }>}
   */ SparseMatrix.prototype[Symbol.iterator] = function*() {
        if (!this._values) throw new Error("Cannot iterate a Pattern only matrix");
        var columns = this._size[1];
        for(var j = 0; j < columns; j++){
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k];
                yield {
                    value: this._values[k],
                    index: [
                        i,
                        j
                    ]
                };
            }
        }
    };
    /**
   * Create an Array with a copy of the data of the SparseMatrix
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.toArray = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, true);
    };
    /**
   * Get the primitive value of the SparseMatrix: a two dimensions array
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.valueOf = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, false);
    };
    function _toArray(values, index, ptr, size, copy) {
        // rows and columns
        var rows = size[0];
        var columns = size[1];
        // result
        var a = [];
        // vars
        var i, j;
        // initialize array
        for(i = 0; i < rows; i++){
            a[i] = [];
            for(j = 0; j < columns; j++)a[i][j] = 0;
        }
        // loop columns
        for(j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1];
            // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                i = index[k];
                // set value (use one for pattern matrix)
                a[i][j] = values ? copy ? (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(values[k]) : values[k] : 1;
            }
        }
        return a;
    }
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof SparseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ SparseMatrix.prototype.format = function(options) {
        // rows and columns
        var rows = this._size[0];
        var columns = this._size[1];
        // density
        var density = this.density();
        // rows & columns
        var str = "Sparse Matrix [" + (0, $1b038b7ade911d0e$export$d9468344d3651243)(rows, options) + " x " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(columns, options) + "] density: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(density, options) + "\n";
        // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k];
                // append value
                str += "\n    (" + (0, $1b038b7ade911d0e$export$d9468344d3651243)(i, options) + ", " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(j, options) + ") ==> " + (this._values ? (0, $1b038b7ade911d0e$export$d9468344d3651243)(this._values[k], options) : "X");
            }
        }
        return str;
    };
    /**
   * Get a string representation of the matrix
   * @memberof SparseMatrix
   * @returns {string} str
   */ SparseMatrix.prototype.toString = function() {
        return (0, $1b038b7ade911d0e$export$d9468344d3651243)(this.toArray());
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof SparseMatrix
   * @returns {Object}
   */ SparseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "SparseMatrix",
            values: this._values,
            index: this._index,
            ptr: this._ptr,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof SparseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix vector with the diagonal values.
   */ SparseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
            // is must be an integer
            if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(k) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0;
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1];
        // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper);
        // diagonal arrays
        var values = [];
        var index = [];
        var ptr = [];
        // initial ptr value
        ptr[0] = 0;
        // loop columns
        for(var j = kSuper; j < columns && values.length < n; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            // loop x within [k0, k1[
            for(var x = k0; x < k1; x++){
                // row index
                var i = this._index[x];
                // check row
                if (i === j - kSuper + kSub) {
                    // value on this column
                    values.push(this._values[x]);
                    // store row
                    index[values.length - 1] = i - kSub;
                    break;
                }
            }
        }
        // close ptr
        ptr.push(values.length);
        // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                n,
                1
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof SparseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SparseMatrix", "values": [], "index": [], "ptr": [], "size": []}`,
   *                       where mathjs is optional
   * @returns {SparseMatrix}
   */ SparseMatrix.fromJSON = function(json) {
        return new SparseMatrix(json);
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof SparseMatrix
   * @param {Array} size                       The matrix size.
   * @param {number | Array | Matrix } value   The values for the diagonal.
   * @param {number | BigNumber} [k=0]         The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]            The default value for non-diagonal
   * @param {string} [datatype]                The Matrix datatype, values must be of this datatype.
   *
   * @returns {SparseMatrix}
   */ SparseMatrix.diagonal = function(size, value, k, defaultValue, datatype) {
        if (!(0, $23cfe017d190638f$export$43bee75e5e14138e)(size)) throw new TypeError("Array expected, size parameter");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
        // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(s)) // convert it
            s = s.toNumber();
            // validate arguments
            if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(s) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(s) || s < 1) throw new Error("Size values must be positive integers");
            return s;
        });
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
            // is must be an integer
            if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(k) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        if ((0, $23cfe017d190638f$export$844ec244b1367d54)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar;
            // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        }
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0;
        // rows and columns
        var rows = size[0];
        var columns = size[1];
        // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper);
        // value extraction function
        var _value;
        // check value
        if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error("Invalid value array length");
            // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(value)) {
            // matrix size
            var ms = value.size();
            // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error("Invalid matrix length");
            // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
        // create arrays
        var values = [];
        var index = [];
        var ptr = [];
        // loop items
        for(var j = 0; j < columns; j++){
            // number of rows with value
            ptr.push(values.length);
            // diagonal index
            var i = j - kSuper;
            // check we need to set diagonal value
            if (i >= 0 && i < n) {
                // get value @ i
                var v = _value(i);
                // check for zero
                if (!eq(v, zero)) {
                    // column
                    index.push(i + kSub);
                    // add value
                    values.push(v);
                }
            }
        }
        // last value should be number of values
        ptr.push(values.length);
        // create SparseMatrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof SparseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ SparseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $23cfe017d190638f$export$7e4aa119212bc614)(i) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(i) || !(0, $23cfe017d190638f$export$7e4aa119212bc614)(j) || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(j)) throw new Error("Row index must be positive integers");
        // check dimensions
        if (this._size.length !== 2) throw new Error("Only two dimensional matrix is supported");
        // validate index
        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(i, this._size[0]);
        (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(j, this._size[0]);
        // swap rows
        SparseMatrix._swapRows(i, j, this._size[1], this._values, this._index, this._ptr);
        // return current instance
        return this;
    };
    /**
   * Loop rows with data in column j.
   *
   * @param {number} j            Column
   * @param {Array} values        Matrix values
   * @param {Array} index         Matrix row indeces
   * @param {Array} ptr           Matrix column pointers
   * @param {Function} callback   Callback function invoked for every row in column j
   */ SparseMatrix._forEachRow = function(j, values, index, ptr, callback) {
        // indeces for column j
        var k0 = ptr[j];
        var k1 = ptr[j + 1];
        // loop
        for(var k = k0; k < k1; k++)// invoke callback
        callback(index[k], values[k]);
    };
    /**
   * Swap rows x and y in Sparse Matrix data structures.
   *
   * @param {number} x         Matrix row index 1
   * @param {number} y         Matrix row index 2
   * @param {number} columns   Number of columns in matrix
   * @param {Array} values     Matrix values
   * @param {Array} index      Matrix row indeces
   * @param {Array} ptr        Matrix column pointers
   */ SparseMatrix._swapRows = function(x, y, columns, values, index, ptr) {
        // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1];
            // find value index @ x
            var kx = _getValueIndex(x, k0, k1, index);
            // find value index @ x
            var ky = _getValueIndex(y, k0, k1, index);
            // check both rows exist in matrix
            if (kx < k1 && ky < k1 && index[kx] === x && index[ky] === y) {
                // swap values (check for pattern matrix)
                if (values) {
                    var v = values[kx];
                    values[kx] = values[ky];
                    values[ky] = v;
                }
                continue;
            }
            // check x row exist & no y row
            if (kx < k1 && index[kx] === x && (ky >= k1 || index[ky] !== y)) {
                // value @ x (check for pattern matrix)
                var vx = values ? values[kx] : undefined;
                // insert value @ y
                index.splice(ky, 0, y);
                if (values) values.splice(ky, 0, vx);
                // remove value @ x (adjust array index if needed)
                index.splice(ky <= kx ? kx + 1 : kx, 1);
                if (values) values.splice(ky <= kx ? kx + 1 : kx, 1);
                continue;
            }
            // check y row exist & no x row
            if (ky < k1 && index[ky] === y && (kx >= k1 || index[kx] !== x)) {
                // value @ y (check for pattern matrix)
                var vy = values ? values[ky] : undefined;
                // insert value @ x
                index.splice(kx, 0, x);
                if (values) values.splice(kx, 0, vy);
                // remove value @ y (adjust array index if needed)
                index.splice(kx <= ky ? ky + 1 : ky, 1);
                if (values) values.splice(kx <= ky ? ky + 1 : ky, 1);
            }
        }
    };
    return SparseMatrix;
}, {
    isClass: true
});


var $4c352732a8482df8$var$name = "splitUnit";
var $4c352732a8482df8$var$dependencies = [
    "typed"
];
var $4c352732a8482df8$export$a9f61753ee14ea96 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($4c352732a8482df8$var$name, $4c352732a8482df8$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Split a unit in an array of units whose sum is equal to the original unit.
   *
   * Syntax:
   *
   *     math.splitUnit(unit: Unit, parts: Array.<Unit>)
   *
   * Example:
   *
   *     math.splitUnit(new Unit(1, 'm'), ['feet', 'inch'])
   *     // [ 3 feet, 3.3700787401575 inch ]
   *
   * See also:
   *
   *     unit
   *
   * @param {Array} [parts] An array of strings or valueless units.
   * @return {Array} An array of units.
   */ return typed($4c352732a8482df8$var$name, {
        "Unit, Array": function UnitArray(unit, parts) {
            return unit.splitUnit(parts);
        }
    });
});


var $0b816ac5c817f96d$var$name = "sqrt";
var $0b816ac5c817f96d$var$dependencies = [
    "config",
    "typed",
    "Complex"
];
var $0b816ac5c817f96d$export$eb18ce1988c5f19c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0b816ac5c817f96d$var$name, $0b816ac5c817f96d$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, Complex: Complex } = _ref;
    /**
   * Calculate the square root of a value.
   *
   * For matrices, if you want the matrix square root of a square matrix,
   * use the `sqrtm` function. If you wish to apply `sqrt` elementwise to
   * a matrix M, use `math.map(M, math.sqrt)`.
   *
   * Syntax:
   *
   *    math.sqrt(x)
   *
   * Examples:
   *
   *    math.sqrt(25)                // returns 5
   *    math.square(5)               // returns 25
   *    math.sqrt(-4)                // returns Complex 2i
   *
   * See also:
   *
   *    square, multiply, cube, cbrt, sqrtm
   *
   * @param {number | BigNumber | Complex | Unit} x
   *            Value for which to calculate the square root.
   * @return {number | BigNumber | Complex | Unit}
   *            Returns the square root of `x`
   */ return typed("sqrt", {
        number: _sqrtNumber,
        Complex: function Complex(x) {
            return x.sqrt();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.sqrt();
            else // negative value -> downgrade to number to do complex value computation
            return _sqrtNumber(x.toNumber());
        },
        Unit: function Unit(x) {
            // Someday will work for complex units when they are implemented
            return x.pow(0.5);
        }
    });
    /**
   * Calculate sqrt for a number
   * @param {number} x
   * @returns {number | Complex} Returns the square root of x
   * @private
   */ function _sqrtNumber(x) {
        if (isNaN(x)) return NaN;
        else if (x >= 0 || config.predictable) return Math.sqrt(x);
        else return new Complex(x, 0).sqrt();
    }
});





var $9cac357e7d6ae4b5$var$name = "sqrtm";
var $9cac357e7d6ae4b5$var$dependencies = [
    "typed",
    "abs",
    "add",
    "multiply",
    "map",
    "sqrt",
    "subtract",
    "inv",
    "size",
    "max",
    "identity"
];
var $9cac357e7d6ae4b5$export$71d0f952576e7511 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9cac357e7d6ae4b5$var$name, $9cac357e7d6ae4b5$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, multiply: multiply, map: map, sqrt: sqrt, subtract: subtract, inv: inv, size: size, max: max, identity: identity } = _ref;
    var _maxIterations = 1e3;
    var _tolerance = 1e-6;
    /**
   * Calculate the principal square root matrix using the Denman–Beavers iterative method
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix#By_Denman–Beavers_iteration
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   * @private
   */ function _denmanBeavers(A) {
        var error;
        var iterations = 0;
        var Y = A;
        var Z = identity(size(A));
        do {
            var Yk = Y;
            Y = multiply(0.5, add(Yk, inv(Z)));
            Z = multiply(0.5, add(Z, inv(Yk)));
            error = max(abs(subtract(Y, Yk)));
            if (error > _tolerance && ++iterations > _maxIterations) throw new Error("computing square root of matrix: iterative method could not converge");
        }while (error > _tolerance);
        return Y;
    }
    /**
   * Calculate the principal square root of a square matrix.
   * The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix
   *
   * Syntax:
   *
   *     math.sqrtm(A)
   *
   * Examples:
   *
   *     math.sqrtm([[33, 24], [48, 57]]) // returns [[5, 2], [4, 7]]
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   */ return typed($9cac357e7d6ae4b5$var$name, {
        "Array | Matrix": function ArrayMatrix(A) {
            var size = (0, $23cfe017d190638f$export$b22160e0a14f87b7)(A) ? A.size() : (0, $eee21df0c3527ff1$export$51ffaee4afb683a5)(A);
            switch(size.length){
                case 1:
                    // Single element Array | Matrix
                    if (size[0] === 1) return map(A, sqrt);
                    else throw new RangeError("Matrix must be square (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
                case 2:
                    // Two-dimensional Array | Matrix
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _denmanBeavers(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
                default:
                    // Multi dimensional array
                    throw new RangeError("Matrix must be at most two dimensional (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
            }
        }
    });
});



var $6f66f1ead66c4128$var$name = "square";
var $6f66f1ead66c4128$var$dependencies = [
    "typed"
];
var $6f66f1ead66c4128$export$4ba960a63f731b0b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($6f66f1ead66c4128$var$name, $6f66f1ead66c4128$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the square of a value, `x * x`.
   * To avoid confusion with multiplying a square matrix by itself,
   * this function does not apply to matrices. If you wish to square
   * every element of a matrix, see the examples.
   *
   * Syntax:
   *
   *    math.square(x)
   *
   * Examples:
   *
   *    math.square(2)           // returns number 4
   *    math.square(3)           // returns number 9
   *    math.pow(3, 2)           // returns number 9
   *    math.multiply(3, 3)      // returns number 9
   *
   *    math.map([1, 2, 3, 4], math.square)  // returns Array [1, 4, 9, 16]
   *
   * See also:
   *
   *    multiply, cube, sqrt, pow
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x
   *            Number for which to calculate the square
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit}
   *            Squared value
   */ return typed($6f66f1ead66c4128$var$name, {
        number: (0, $f38f49d8e24d4a9f$export$c4094a156ed9ab35),
        Complex: function Complex(x) {
            return x.mul(x);
        },
        BigNumber: function BigNumber(x) {
            return x.times(x);
        },
        bigint: function bigint(x) {
            return x * x;
        },
        Fraction: function Fraction(x) {
            return x.mul(x);
        },
        Unit: function Unit(x) {
            return x.pow(2);
        }
    });
});




var $7a8cb1da8313f19f$var$name = "squeeze";
var $7a8cb1da8313f19f$var$dependencies = [
    "typed",
    "matrix"
];
var $7a8cb1da8313f19f$export$1a885844ffd505a4 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($7a8cb1da8313f19f$var$name, $7a8cb1da8313f19f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Squeeze a matrix, remove inner and outer singleton dimensions from a matrix.
   *
   * Syntax:
   *
   *     math.squeeze(x)
   *
   * Examples:
   *
   *     math.squeeze([3])           // returns 3
   *     math.squeeze([[3]])         // returns 3
   *
   *     const A = math.zeros(3, 1)    // returns [[0], [0], [0]] (size 3x1)
   *     math.squeeze(A)             // returns [0, 0, 0] (size 3)
   *
   *     const B = math.zeros(1, 3)    // returns [[0, 0, 0]] (size 1x3)
   *     math.squeeze(B)             // returns [0, 0, 0] (size 3)
   *
   *     // only inner and outer dimensions are removed
   *     const C = math.zeros(2, 1, 3) // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *     math.squeeze(C)             // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *
   * See also:
   *
   *     subset
   *
   * @param {Matrix | Array} x      Matrix to be squeezed
   * @return {Matrix | Array} Squeezed matrix
   */ return typed($7a8cb1da8313f19f$var$name, {
        Array: function Array1(x) {
            return (0, $eee21df0c3527ff1$export$889c931173b77c2f)((0, $46a94b3d1146edd8$export$9cd59f9826255e47)(x));
        },
        Matrix: function Matrix(x) {
            var res = (0, $eee21df0c3527ff1$export$889c931173b77c2f)(x.toArray());
            // FIXME: return the same type of matrix as the input
            return Array.isArray(res) ? matrix(res) : res;
        },
        any: function any(x) {
            // scalar
            return (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(x);
        }
    });
});



var $76f34cb06b4782d2$var$name = "std";
var $76f34cb06b4782d2$var$dependencies = [
    "typed",
    "map",
    "sqrt",
    "variance"
];
var $76f34cb06b4782d2$export$d3f0a8dda5df7afd = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($76f34cb06b4782d2$var$name, $76f34cb06b4782d2$var$dependencies, (_ref)=>{
    var { typed: typed, map: map, sqrt: sqrt, variance: variance } = _ref;
    /**
   * Compute the standard deviation of a matrix or a  list with values.
   * The standard deviations is defined as the square root of the variance:
   * `std(A) = sqrt(variance(A))`.
   * In case of a (multi dimensional) array or matrix, the standard deviation
   * over all elements will be calculated by default, unless an axis is specified
   * in which case the standard deviation will be computed along that axis.
   *
   * Additionally, it is possible to compute the standard deviation along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Syntax:
   *
   *     math.std(a, b, c, ...)
   *     math.std(A)
   *     math.std(A, normalization)
   *     math.std(A, dimension)
   *     math.std(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.std(2, 4, 6)                     // returns 2
   *     math.std([2, 4, 6, 8])                // returns 2.581988897471611
   *     math.std([2, 4, 6, 8], 'uncorrected') // returns 2.23606797749979
   *     math.std([2, 4, 6, 8], 'biased')      // returns 2
   *
   *     math.std([[1, 2, 3], [4, 5, 6]])      // returns 1.8708286933869707
   *     math.std([[1, 2, 3], [4, 6, 8]], 0)    // returns [2.1213203435596424, 2.8284271247461903, 3.5355339059327378]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1)    // returns [1, 2]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.7071067811865476, 1.4142135623730951]
   *
   * See also:
   *
   *    mean, median, max, min, prod, sum, variance
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the standard deviation for a matrix
   * @return {*} The standard deviation
   */ return typed($76f34cb06b4782d2$var$name, {
        // std([a, b, c, d, ...])
        "Array | Matrix": _std,
        // std([a, b, c, d, ...], normalization)
        "Array | Matrix, string": _std,
        // std([a, b, c, c, ...], dim)
        "Array | Matrix, number | BigNumber": _std,
        // std([a, b, c, c, ...], dim, normalization)
        "Array | Matrix, number | BigNumber, string": _std,
        // std(a, b, c, d, ...)
        "...": function _(args) {
            return _std(args);
        }
    });
    function _std(array, normalization) {
        if (array.length === 0) throw new SyntaxError("Function std requires one or more parameters (0 provided)");
        try {
            var v = variance.apply(null, arguments);
            if ((0, $23cfe017d190638f$export$cea7aa84e978eba5)(v)) return map(v, sqrt);
            else return sqrt(v);
        } catch (err) {
            if (err instanceof TypeError && err.message.includes(" variance")) throw new TypeError(err.message.replace(" variance", " std"));
            else throw err;
        }
    }
});



var $a1b77682c2eda603$var$name = "stirlingS2";
var $a1b77682c2eda603$var$dependencies = [
    "typed",
    "addScalar",
    "subtractScalar",
    "multiplyScalar",
    "divideScalar",
    "pow",
    "factorial",
    "combinations",
    "isNegative",
    "isInteger",
    "number",
    "?bignumber",
    "larger"
];
var $a1b77682c2eda603$export$18813d136a9b83d0 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a1b77682c2eda603$var$name, $a1b77682c2eda603$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, subtractScalar: subtractScalar, multiplyScalar: multiplyScalar, divideScalar: divideScalar, pow: pow, factorial: factorial, combinations: combinations, isNegative: isNegative, isInteger: isInteger, number: number, bignumber: bignumber, larger: larger } = _ref;
    var smallCache = [];
    var bigCache = [];
    /**
   * The Stirling numbers of the second kind, counts the number of ways to partition
   * a set of n labelled objects into k nonempty unlabelled subsets.
   * stirlingS2 only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   *  If n = k or k = 1 <= n, then s(n,k) = 1
   *  If k = 0 < n, then s(n,k) = 0
   *
   * Note that if either n or k is supplied as a BigNumber, the result will be
   * as well.
   *
   * Syntax:
   *
   *   math.stirlingS2(n, k)
   *
   * Examples:
   *
   *    math.stirlingS2(5, 3) //returns 25
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     S(n,k)
   */ return typed($a1b77682c2eda603$var$name, {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || isNegative(n) || !isInteger(k) || isNegative(k)) throw new TypeError("Non-negative integer value expected in function stirlingS2");
            else if (larger(k, n)) throw new TypeError("k must be less than or equal to n in function stirlingS2");
            var big = !((0, $23cfe017d190638f$export$7e4aa119212bc614)(n) && (0, $23cfe017d190638f$export$7e4aa119212bc614)(k));
            var cache = big ? bigCache : smallCache;
            var make = big ? bignumber : number;
            var nn = number(n);
            var nk = number(k);
            /* See if we already have the value: */ if (cache[nn] && cache[nn].length > nk) return cache[nn][nk];
            /* Fill the cache */ for(var m = 0; m <= nn; ++m){
                if (!cache[m]) cache[m] = [
                    m === 0 ? make(1) : make(0)
                ];
                if (m === 0) continue;
                var row = cache[m];
                var prev = cache[m - 1];
                for(var i = row.length; i <= m && i <= nk; ++i)if (i === m) row[i] = 1;
                else row[i] = addScalar(multiplyScalar(make(i), prev[i]), prev[i - 1]);
            }
            return cache[nn][nk];
        }
    });
});




var $547e965165ab470e$var$name = "string";
var $547e965165ab470e$var$dependencies = [
    "typed"
];
var $547e965165ab470e$export$b2cf5914f5f18823 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($547e965165ab470e$var$name, $547e965165ab470e$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a string or convert any object into a string.
   * Elements of Arrays and Matrices are processed element wise.
   *
   * Syntax:
   *
   *    math.string(value)
   *
   * Examples:
   *
   *    math.string(4.2)               // returns string '4.2'
   *    math.string(math.complex(3, 2) // returns string '3 + 2i'
   *
   *    const u = math.unit(5, 'km')
   *    math.string(u.to('m'))         // returns string '5000 m'
   *
   *    math.string([true, false])     // returns ['true', 'false']
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, unit
   *
   * @param {* | Array | Matrix | null} [value]  A value to convert to a string
   * @return {string | Array | Matrix} The created string
   */ return typed($547e965165ab470e$var$name, {
        "": function _() {
            return "";
        },
        number: (0, $a246eb207aab6d09$export$d9468344d3651243),
        null: function _null(x) {
            return "null";
        },
        boolean: function boolean(x) {
            return x + "";
        },
        string: function string(x) {
            return x;
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self)),
        any: function any(x) {
            return String(x);
        }
    });
});





/**
 * Get a property of a plain object
 * Throws an error in case the object is not a plain object or the
 * property is not defined on the object itself
 * @param {Object} object
 * @param {string} prop
 * @return {*} Returns the property value when safe
 */ function $f59a31bcbbaa9e5a$export$87a87648a1961976(object, prop) {
    // only allow getting safe properties of a plain object
    if ($f59a31bcbbaa9e5a$export$53b83ca8eaab0383(object) && $f59a31bcbbaa9e5a$export$3039c640f3cfc12a(object, prop)) return object[prop];
    if (typeof object[prop] === "function" && $f59a31bcbbaa9e5a$export$2220a91638ab1d9e(object, prop)) throw new Error('Cannot access method "' + prop + '" as a property');
    throw new Error('No access to property "' + prop + '"');
}
/**
 * Set a property on a plain object.
 * Throws an error in case the object is not a plain object or the
 * property would override an inherited property like .constructor or .toString
 * @param {Object} object
 * @param {string} prop
 * @param {*} value
 * @return {*} Returns the value
 */ // TODO: merge this function into access.js?
function $f59a31bcbbaa9e5a$export$e99fe8700ee9f9cd(object, prop, value) {
    // only allow setting safe properties of a plain object
    if ($f59a31bcbbaa9e5a$export$53b83ca8eaab0383(object) && $f59a31bcbbaa9e5a$export$3039c640f3cfc12a(object, prop)) {
        object[prop] = value;
        return value;
    }
    throw new Error('No access to property "' + prop + '"');
}
function $f59a31bcbbaa9e5a$export$97accea1a2314d22(object) {
    return Object.keys(object).filter((prop)=>(0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(object, prop));
}
function $f59a31bcbbaa9e5a$export$626bde2ef1d9655a(object, prop) {
    return prop in object;
}
/**
 * Test whether a property is safe to use for an object.
 * For example .toString and .constructor are not safe
 * @param {string} prop
 * @return {boolean} Returns true when safe
 */ function $f59a31bcbbaa9e5a$export$3039c640f3cfc12a(object, prop) {
    if (!object || typeof object !== "object") return false;
    // SAFE: whitelisted
    // e.g length
    if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)($f59a31bcbbaa9e5a$var$safeNativeProperties, prop)) return true;
    // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (prop in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
    // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (prop in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
/**
 * Validate whether a method is safe.
 * Throws an error when that's not the case.
 * @param {Object} object
 * @param {string} method
 * @return {function} Returns the method when valid
 */ function $f59a31bcbbaa9e5a$export$94fda296bbe7ba21(object, method) {
    if (!$f59a31bcbbaa9e5a$export$2220a91638ab1d9e(object, method)) throw new Error('No access to method "' + method + '"');
    return object[method];
}
/**
 * Check whether a method is safe.
 * Throws an error when that's not the case (for example for `constructor`).
 * @param {Object} object
 * @param {string} method
 * @return {boolean} Returns true when safe, false otherwise
 */ function $f59a31bcbbaa9e5a$export$2220a91638ab1d9e(object, method) {
    if (object === null || object === undefined || typeof object[method] !== "function") return false;
    // UNSAFE: ghosted
    // e.g overridden toString
    // Note that IE10 doesn't support __proto__ and we can't do this check there.
    if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(object, method) && Object.getPrototypeOf && method in Object.getPrototypeOf(object)) return false;
    // SAFE: whitelisted
    // e.g toString
    if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)($f59a31bcbbaa9e5a$var$safeNativeMethods, method)) return true;
    // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (method in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
    // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (method in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
function $f59a31bcbbaa9e5a$export$53b83ca8eaab0383(object) {
    return typeof object === "object" && object && object.constructor === Object;
}
var $f59a31bcbbaa9e5a$var$safeNativeProperties = {
    length: true,
    name: true
};
var $f59a31bcbbaa9e5a$var$safeNativeMethods = {
    toString: true,
    valueOf: true,
    toLocaleString: true
};




var $11b312cf9e6477c6$var$name = "subset";
var $11b312cf9e6477c6$var$dependencies = [
    "typed",
    "matrix",
    "zeros",
    "add"
];
var $11b312cf9e6477c6$export$d8c56e74d683bb33 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($11b312cf9e6477c6$var$name, $11b312cf9e6477c6$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, zeros: zeros, add: add } = _ref;
    /**
   * Get or set a subset of a matrix or string.
   *
   * Syntax:
   *     math.subset(value, index)                                // retrieve a subset
   *     math.subset(value, index, replacement [, defaultValue])  // replace a subset
   *
   * Examples:
   *
   *     // get a subset
   *     const d = [[1, 2], [3, 4]]
   *     math.subset(d, math.index(1, 0))             // returns 3
   *     math.subset(d, math.index([0, 1], 1))        // returns [[2], [4]]
   *     math.subset(d, math.index([false, true], 0)) // returns [[3]]
   *
   *     // replace a subset
   *     const e = []
   *     const f = math.subset(e, math.index(0, [0, 2]), [5, 6])  // f = [[5, 0, 6]]
   *     const g = math.subset(f, math.index(1, 1), 7, 0)         // g = [[5, 0, 6], [0, 7, 0]]
   *     math.subset(g, math.index([false, true], 1), 8)          // returns [[5, 0, 6], [0, 8, 0]]
   *
   *     // get submatrix using ranges
   *     const M = [
   *       [1,2,3],
   *       [4,5,6],
   *       [7,8,9]
   *     ]
   *     math.subset(M, math.index(math.range(0,2), math.range(0,3))) // [[1, 2, 3], [4, 5, 6]]
   *
   * See also:
   *
   *     size, resize, squeeze, index
   *
   * @param {Array | Matrix | string} matrix  An array, matrix, or string
   * @param {Index} index
   *    For each dimension of the target, specifies an index or a list of
   *    indices to fetch or set. `subset` uses the cartesian product of
   *    the indices specified in each dimension.
   * @param {*} [replacement]                 An array, matrix, or scalar.
   *                                          If provided, the subset is replaced with replacement.
   *                                          If not provided, the subset is returned
   * @param {*} [defaultValue=undefined]      Default value, filled in on new entries when
   *                                          the matrix is resized. If not provided,
   *                                          math.matrix elements will be left undefined.
   * @return {Array | Matrix | string} Either the retrieved subset or the updated matrix.
   */ return typed($11b312cf9e6477c6$var$name, {
        // get subset
        "Matrix, Index": function MatrixIndex(value, index) {
            if ((0, $eee21df0c3527ff1$export$1f3203c278bd022)(index)) return matrix();
            (0, $eee21df0c3527ff1$export$a406fce6a920be3c)(value, index);
            return value.subset(index);
        },
        "Array, Index": typed.referTo("Matrix, Index", function(subsetRef) {
            return function(value, index) {
                var subsetResult = subsetRef(matrix(value), index);
                return index.isScalar() ? subsetResult : subsetResult.valueOf();
            };
        }),
        "Object, Index": $11b312cf9e6477c6$var$_getObjectProperty,
        "string, Index": $11b312cf9e6477c6$var$_getSubstring,
        // set subset
        "Matrix, Index, any, any": function MatrixIndexAnyAny(value, index, replacement, defaultValue) {
            if ((0, $eee21df0c3527ff1$export$1f3203c278bd022)(index)) return value;
            (0, $eee21df0c3527ff1$export$a406fce6a920be3c)(value, index);
            return value.clone().subset(index, _broadcastReplacement(replacement, index), defaultValue);
        },
        "Array, Index, any, any": typed.referTo("Matrix, Index, any, any", function(subsetRef) {
            return function(value, index, replacement, defaultValue) {
                var subsetResult = subsetRef(matrix(value), index, replacement, defaultValue);
                return subsetResult.isMatrix ? subsetResult.valueOf() : subsetResult;
            };
        }),
        "Array, Index, any": typed.referTo("Matrix, Index, any, any", function(subsetRef) {
            return function(value, index, replacement) {
                return subsetRef(matrix(value), index, replacement, undefined).valueOf();
            };
        }),
        "Matrix, Index, any": typed.referTo("Matrix, Index, any, any", function(subsetRef) {
            return function(value, index, replacement) {
                return subsetRef(value, index, replacement, undefined);
            };
        }),
        "string, Index, string": $11b312cf9e6477c6$var$_setSubstring,
        "string, Index, string, string": $11b312cf9e6477c6$var$_setSubstring,
        "Object, Index, any": $11b312cf9e6477c6$var$_setObjectProperty
    });
    /**
   * Broadcasts a replacment value to be the same size as index
   * @param {number | BigNumber | Array | Matrix} replacement Replacement value to try to broadcast
   * @param {*} index Index value
   * @returns broadcasted replacement that matches the size of index
   */ function _broadcastReplacement(replacement, index) {
        if (typeof replacement === "string") throw new Error("can't boradcast a string");
        if (index._isScalar) return replacement;
        var indexSize = index.size();
        if (indexSize.every((d)=>d > 0)) try {
            return add(replacement, zeros(indexSize));
        } catch (error) {
            return replacement;
        }
        else return replacement;
    }
});
/**
 * Retrieve a subset of a string
 * @param {string} str            string from which to get a substring
 * @param {Index} index           An index or list of indices (character positions)
 * @returns {string} substring
 * @private
 */ function $11b312cf9e6477c6$var$_getSubstring(str, index) {
    if (!(0, $23cfe017d190638f$export$ba3dc792055c2f45)(index)) // TODO: better error message
    throw new TypeError("Index expected");
    if ((0, $eee21df0c3527ff1$export$1f3203c278bd022)(index)) return "";
    (0, $eee21df0c3527ff1$export$a406fce6a920be3c)(Array.from(str), index);
    if (index.size().length !== 1) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(index.size().length, 1);
    // validate whether the range is out of range
    var strLen = str.length;
    (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(index.min()[0], strLen);
    (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(index.max()[0], strLen);
    var range = index.dimension(0);
    var substr = "";
    range.forEach(function(v) {
        substr += str.charAt(v);
    });
    return substr;
}
/**
 * Replace a substring in a string
 * @param {string} str            string to be replaced
 * @param {Index} index           An index or list of indices (character positions)
 * @param {string} replacement    Replacement string
 * @param {string} [defaultValue] Default value to be used when resizing
 *                                the string. is ' ' by default
 * @returns {string} result
 * @private
 */ function $11b312cf9e6477c6$var$_setSubstring(str, index, replacement, defaultValue) {
    if (!index || index.isIndex !== true) // TODO: better error message
    throw new TypeError("Index expected");
    if ((0, $eee21df0c3527ff1$export$1f3203c278bd022)(index)) return str;
    (0, $eee21df0c3527ff1$export$a406fce6a920be3c)(Array.from(str), index);
    if (index.size().length !== 1) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(index.size().length, 1);
    if (defaultValue !== undefined) {
        if (typeof defaultValue !== "string" || defaultValue.length !== 1) throw new TypeError("Single character expected as defaultValue");
    } else defaultValue = " ";
    var range = index.dimension(0);
    var len = range.size()[0];
    if (len !== replacement.length) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(range.size()[0], replacement.length);
    // validate whether the range is out of range
    var strLen = str.length;
    (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(index.min()[0]);
    (0, $eee21df0c3527ff1$export$3cfe3fbfec03f260)(index.max()[0]);
    // copy the string into an array with characters
    var chars = [];
    for(var i = 0; i < strLen; i++)chars[i] = str.charAt(i);
    range.forEach(function(v, i) {
        chars[v] = replacement.charAt(i[0]);
    });
    // initialize undefined characters with a space
    if (chars.length > strLen) {
        for(var _i = strLen - 1, _len = chars.length; _i < _len; _i++)if (!chars[_i]) chars[_i] = defaultValue;
    }
    return chars.join("");
}
/**
 * Retrieve a property from an object
 * @param {Object} object
 * @param {Index} index
 * @return {*} Returns the value of the property
 * @private
 */ function $11b312cf9e6477c6$var$_getObjectProperty(object, index) {
    if ((0, $eee21df0c3527ff1$export$1f3203c278bd022)(index)) return undefined;
    if (index.size().length !== 1) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== "string") throw new TypeError("String expected as index to retrieve an object property");
    return (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(object, key);
}
/**
 * Set a property on an object
 * @param {Object} object
 * @param {Index} index
 * @param {*} replacement
 * @return {*} Returns the updated object
 * @private
 */ function $11b312cf9e6477c6$var$_setObjectProperty(object, index, replacement) {
    if ((0, $eee21df0c3527ff1$export$1f3203c278bd022)(index)) return object;
    if (index.size().length !== 1) throw new (0, $9b62b26fef4c910f$export$ad1391ca020fdd96)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== "string") throw new TypeError("String expected as index to retrieve an object property");
    // clone the object, and apply the property to the clone
    var updated = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(object);
    (0, $f59a31bcbbaa9e5a$export$e99fe8700ee9f9cd)(updated, key, replacement);
    return updated;
}








var $3a141bfdebc4cc26$var$name = "subtract";
var $3a141bfdebc4cc26$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "subtractScalar",
    "unaryMinus",
    "DenseMatrix",
    "concat"
];
var $3a141bfdebc4cc26$export$cd7a6c131b18ab16 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3a141bfdebc4cc26$var$name, $3a141bfdebc4cc26$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, subtractScalar: subtractScalar, unaryMinus: unaryMinus, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    // TODO: split function subtract in two: subtract and subtractScalar
    var matAlgo01xDSid = (0, $a0c1a11a7836c6b2$export$727ab96f88a9e651)({
        typed: typed
    });
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo05xSfSf = (0, $a54f9597be0f9a42$export$a0ee15a3591ad1a)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $00357ab6509f98c8$export$5295edae9a41ff00)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Subtract two values, `x - y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.subtract(x, y)
   *
   * Examples:
   *
   *    math.subtract(5.3, 2)        // returns number 3.3
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.subtract(a, b)          // returns Complex -2 + 2i
   *
   *    math.subtract([5, 7, 4], 4)  // returns Array [1, 3, 0]
   *
   *    const c = math.unit('2.1 km')
   *    const d = math.unit('500m')
   *    math.subtract(c, d)          // returns Unit 1.6 km
   *
   * See also:
   *
   *    add
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} x Initial value
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} y Value to subtract from `x`
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} Subtraction of `x` and `y`
   */ return typed($3a141bfdebc4cc26$var$name, {
        "any, any": subtractScalar
    }, matrixAlgorithmSuite({
        elop: subtractScalar,
        SS: matAlgo05xSfSf,
        DS: matAlgo01xDSid,
        SD: matAlgo03xDSf,
        Ss: matAlgo12xSfs,
        sS: matAlgo10xSids
    }));
});



var $e7d22dd09f419c66$var$name = "subtractScalar";
var $e7d22dd09f419c66$var$dependencies = [
    "typed"
];
var $e7d22dd09f419c66$export$7b5719caf153b43d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e7d22dd09f419c66$var$name, $e7d22dd09f419c66$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Subtract two scalar values, `x - y`.
   * This function is meant for internal use: it is used by the public function
   * `subtract`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x   First value
   * @param  {number | BigNumber | bigint | Fraction | Complex} y          Second value to be subtracted from `x`
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit}     Difference of `x` and `y`
   * @private
   */ return typed($e7d22dd09f419c66$var$name, {
        "number, number": (0, $f38f49d8e24d4a9f$export$fd8ce9cfca47ace5),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.sub(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.minus(y);
        },
        "bigint, bigint": function bigintBigint(x, y) {
            return x - y;
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.sub(y);
        },
        "Unit, Unit": typed.referToSelf((self)=>(x, y)=>{
                if (x.value === null || x.value === undefined) throw new Error("Parameter x contains a unit with undefined value");
                if (y.value === null || y.value === undefined) throw new Error("Parameter y contains a unit with undefined value");
                if (!x.equalBase(y)) throw new Error("Units do not match");
                var res = x.clone();
                res.value = typed.find(self, [
                    res.valueType(),
                    y.valueType()
                ])(res.value, y.value);
                res.fixPrefix = false;
                return res;
            })
    });
});





var $31556c126aadddbc$var$name = "sum";
var $31556c126aadddbc$var$dependencies = [
    "typed",
    "config",
    "add",
    "numeric"
];
var $31556c126aadddbc$export$14d444d810bc35b5 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($31556c126aadddbc$var$name, $31556c126aadddbc$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, add: add, numeric: numeric } = _ref;
    /**
   * Compute the sum of a matrix or a list with values.
   * In case of a multidimensional array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.sum(a, b, c, ...)
   *     math.sum(A)
   *     math.sum(A, dimension)
   *
   * Examples:
   *
   *     math.sum(2, 1, 4, 3)               // returns 10
   *     math.sum([2, 1, 4, 3])             // returns 10
   *     math.sum([[2, 5], [4, 3], [1, 7]]) // returns 22
   *
   * See also:
   *
   *    mean, median, min, max, prod, std, variance, cumsum
   *
   * @param {... *} args  A single matrix or multiple scalar values
   * @return {*} The sum of all values
   */ return typed($31556c126aadddbc$var$name, {
        // sum([a, b, c, d, ...])
        "Array | Matrix": _sum,
        // sum([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": _nsumDim,
        // sum(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $b3f9e93020d0f987$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function sum");
            return _sum(args);
        }
    });
    /**
   * Recursively calculate the sum of an n-dimensional array
   * @param {Array | Matrix} array
   * @return {number} sum
   * @private
   */ function _sum(array) {
        var sum;
        (0, $b3f9e93020d0f987$export$519ada94592b97fc)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
            } catch (err) {
                throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "sum", value);
            }
        });
        // make sure returning numeric value: parse a string into a numeric value
        if (sum === undefined) sum = numeric(0, config.number);
        if (typeof sum === "string") sum = numeric(sum, (0, $a246eb207aab6d09$export$28199db5a610a1ee)(sum, config));
        return sum;
    }
    function _nsumDim(array, dim) {
        try {
            var sum = (0, $b3f9e93020d0f987$export$533b26079ad0b4b)(array, dim, add);
            return sum;
        } catch (err) {
            throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "sum");
        }
    }
});


var $0c932622b244290f$var$name = "sylvester";
var $0c932622b244290f$var$dependencies = [
    "typed",
    "schur",
    "matrixFromColumns",
    "matrix",
    "multiply",
    "range",
    "concat",
    "transpose",
    "index",
    "subset",
    "add",
    "subtract",
    "identity",
    "lusolve",
    "abs"
];
var $0c932622b244290f$export$9b5f479487e82b81 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0c932622b244290f$var$name, $0c932622b244290f$var$dependencies, (_ref)=>{
    var { typed: typed, schur: schur, matrixFromColumns: matrixFromColumns, matrix: matrix, multiply: multiply, range: range, concat: concat, transpose: transpose, index: index, subset: subset, add: add, subtract: subtract, identity: identity, lusolve: lusolve, abs: abs } = _ref;
    /**
   *
   * Solves the real-valued Sylvester equation AX+XB=C for X, where A, B and C are
   * matrices of appropriate dimensions, being A and B squared. Notice that other
   * equivalent definitions for the Sylvester equation exist and this function
   * assumes the one presented in the original publication of the the Bartels-
   * Stewart algorithm, which is implemented by this function.
   * https://en.wikipedia.org/wiki/Sylvester_equation
   *
   * Syntax:
   *
   *     math.sylvester(A, B, C)
   *
   * Examples:
   *
   *     const A = [[-1, -2], [1, 1]]
   *     const B = [[2, -1], [1, -2]]
   *     const C = [[-3, 2], [3, 0]]
   *     math.sylvester(A, B, C)      // returns DenseMatrix [[-0.25, 0.25], [1.5, -1.25]]
   *
   * See also:
   *
   *     schur, lyap
   *
   * @param {Matrix | Array} A  Matrix A
   * @param {Matrix | Array} B  Matrix B
   * @param {Matrix | Array} C  Matrix C
   * @return {Matrix | Array}   Matrix X, solving the Sylvester equation
   */ return typed($0c932622b244290f$var$name, {
        "Matrix, Matrix, Matrix": _sylvester,
        "Array, Matrix, Matrix": function ArrayMatrixMatrix(A, B, C) {
            return _sylvester(matrix(A), B, C);
        },
        "Array, Array, Matrix": function ArrayArrayMatrix(A, B, C) {
            return _sylvester(matrix(A), matrix(B), C);
        },
        "Array, Matrix, Array": function ArrayMatrixArray(A, B, C) {
            return _sylvester(matrix(A), B, matrix(C));
        },
        "Matrix, Array, Matrix": function MatrixArrayMatrix(A, B, C) {
            return _sylvester(A, matrix(B), C);
        },
        "Matrix, Array, Array": function MatrixArrayArray(A, B, C) {
            return _sylvester(A, matrix(B), matrix(C));
        },
        "Matrix, Matrix, Array": function MatrixMatrixArray(A, B, C) {
            return _sylvester(A, B, matrix(C));
        },
        "Array, Array, Array": function ArrayArrayArray(A, B, C) {
            return _sylvester(matrix(A), matrix(B), matrix(C)).toArray();
        }
    });
    function _sylvester(A, B, C) {
        var n = B.size()[0];
        var m = A.size()[0];
        var sA = schur(A);
        var F = sA.T;
        var U = sA.U;
        var sB = schur(multiply(-1, B));
        var G = sB.T;
        var V = sB.U;
        var D = multiply(multiply(transpose(U), C), V);
        var all = range(0, m);
        var y = [];
        var hc = (a, b)=>concat(a, b, 1);
        var vc = (a, b)=>concat(a, b, 0);
        for(var k = 0; k < n; k++)if (k < n - 1 && abs(subset(G, index(k + 1, k))) > 1e-5) {
            var RHS = vc(subset(D, index(all, k)), subset(D, index(all, k + 1)));
            for(var j = 0; j < k; j++)RHS = add(RHS, vc(multiply(y[j], subset(G, index(j, k))), multiply(y[j], subset(G, index(j, k + 1)))));
            var gkk = multiply(identity(m), multiply(-1, subset(G, index(k, k))));
            var gmk = multiply(identity(m), multiply(-1, subset(G, index(k + 1, k))));
            var gkm = multiply(identity(m), multiply(-1, subset(G, index(k, k + 1))));
            var gmm = multiply(identity(m), multiply(-1, subset(G, index(k + 1, k + 1))));
            var LHS = vc(hc(add(F, gkk), gmk), hc(gkm, add(F, gmm)));
            var yAux = lusolve(LHS, RHS);
            y[k] = yAux.subset(index(range(0, m), 0));
            y[k + 1] = yAux.subset(index(range(m, 2 * m), 0));
            k++;
        } else {
            var _RHS = subset(D, index(all, k));
            for(var _j = 0; _j < k; _j++)_RHS = add(_RHS, multiply(y[_j], subset(G, index(_j, k))));
            var _gkk = subset(G, index(k, k));
            var _LHS = subtract(F, multiply(_gkk, identity(m)));
            y[k] = lusolve(_LHS, _RHS);
        }
        var Y = matrix(matrixFromColumns(...y));
        var X = multiply(U, multiply(Y, transpose(V)));
        return X;
    }
});



var $9de694fdfc189374$var$name = "tan";
var $9de694fdfc189374$var$dependencies = [
    "typed"
];
var $9de694fdfc189374$export$b61ad4f38fd9301d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9de694fdfc189374$var$name, $9de694fdfc189374$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    var trigUnit = (0, $5b7412feb4d38bfc$export$33129064a3329835)({
        typed: typed
    });
    /**
   * Calculate the tangent of a value. `tan(x)` is equal to `sin(x) / cos(x)`.
   *
   * To avoid confusion with the matrix tangent, this function does not apply
   * to matrices.
   *
   * Syntax:
   *
   *    math.tan(x)
   *
   * Examples:
   *
   *    math.tan(0.5)                    // returns number 0.5463024898437905
   *    math.sin(0.5) / math.cos(0.5)    // returns number 0.5463024898437905
   *    math.tan(math.pi / 4)            // returns number 1
   *    math.tan(math.unit(45, 'deg'))   // returns number 1
   *
   * See also:
   *
   *    atan, sin, cos
   *
   * @param {number | BigNumber | Complex | Unit} x  Function input
   * @return {number | BigNumber | Complex} Tangent of x
   */ return typed($9de694fdfc189374$var$name, {
        number: Math.tan,
        "Complex | BigNumber": (x)=>x.tan()
    }, trigUnit);
});



var $b3d0d74899ecac05$var$name = "tanh";
var $b3d0d74899ecac05$var$dependencies = [
    "typed"
];
var $b3d0d74899ecac05$export$e1f66a5bda779194 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b3d0d74899ecac05$var$name, $b3d0d74899ecac05$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic tangent of a value,
   * defined as `tanh(x) = (exp(2 * x) - 1) / (exp(2 * x) + 1)`.
   *
   * To avoid confusion with matrix hyperbolic tangent, this function does
   * not apply to matrices.
   *
   * Syntax:
   *
   *    math.tanh(x)
   *
   * Examples:
   *
   *    // tanh(x) = sinh(x) / cosh(x) = 1 / coth(x)
   *    math.tanh(0.5)                   // returns 0.46211715726000974
   *    math.sinh(0.5) / math.cosh(0.5)  // returns 0.46211715726000974
   *    1 / math.coth(0.5)               // returns 0.46211715726000974
   *
   * See also:
   *
   *    sinh, cosh, coth
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic tangent of x
   */ return typed("tanh", {
        number: (0, $a246eb207aab6d09$export$7128670e45beef9a),
        "Complex | BigNumber": (x)=>x.tanh()
    });
});



var $e37b76990ad255f2$var$name = "to";
var $e37b76990ad255f2$var$dependencies = [
    "typed",
    "matrix",
    "concat"
];
var $e37b76990ad255f2$export$6e6c19ceb4cd6856 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e37b76990ad255f2$var$name, $e37b76990ad255f2$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, concat: concat } = _ref;
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Change the unit of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.to(x, unit)
   *
   * Examples:
   *
   *    math.to(math.unit('2 inch'), 'cm')             // returns Unit 5.08 cm
   *    math.to(math.unit('2 inch'), math.unit('cm'))  // returns Unit 5.08 cm
   *    math.to(math.unit(16, 'bytes'), 'bits')        // returns Unit 128 bits
   *
   * See also:
   *
   *    unit
   *
   * @param {Unit | Array | Matrix} x     The unit to be converted.
   * @param {Unit | Array | Matrix} unit  New unit. Can be a string like "cm"
   *                                      or a unit without value.
   * @return {Unit | Array | Matrix} value with changed, fixed unit.
   */ return typed($e37b76990ad255f2$var$name, {
        "Unit, Unit | string": (x, unit)=>x.to(unit)
    }, matrixAlgorithmSuite({
        Ds: true
    }));
});




var $18c7e209693ae4ed$var$name = "trace";
var $18c7e209693ae4ed$var$dependencies = [
    "typed",
    "matrix",
    "add"
];
var $18c7e209693ae4ed$export$acff8254414be03b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($18c7e209693ae4ed$var$name, $18c7e209693ae4ed$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, add: add } = _ref;
    /**
   * Calculate the trace of a matrix: the sum of the elements on the main
   * diagonal of a square matrix.
   *
   * Syntax:
   *
   *    math.trace(x)
   *
   * Examples:
   *
   *    math.trace([[1, 2], [3, 4]]) // returns 5
   *
   *    const A = [
   *      [1, 2, 3],
   *      [-1, 2, 3],
   *      [2, 0, 3]
   *    ]
   *    math.trace(A) // returns 6
   *
   * See also:
   *
   *    diag
   *
   * @param {Array | Matrix} x  A matrix
   *
   * @return {number} The trace of `x`
   */ return typed("trace", {
        Array: function _arrayTrace(x) {
            // use dense matrix implementation
            return _denseTrace(matrix(x));
        },
        SparseMatrix: _sparseTrace,
        DenseMatrix: _denseTrace,
        any: (0, $46a94b3d1146edd8$export$9cd59f9826255e47)
    });
    function _denseTrace(m) {
        // matrix size & data
        var size = m._size;
        var data = m._data;
        // process dimensions
        switch(size.length){
            case 1:
                // vector
                if (size[0] === 1) // return data[0]
                return (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(data[0]);
                throw new RangeError("Matrix must be square (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
            case 2:
                // two dimensional
                var rows = size[0];
                var cols = size[1];
                if (rows === cols) {
                    // calulate sum
                    var sum = 0;
                    // loop diagonal
                    for(var i = 0; i < rows; i++)sum = add(sum, data[i][i]);
                    // return trace
                    return sum;
                } else throw new RangeError("Matrix must be square (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
            default:
                // multi dimensional
                throw new RangeError("Matrix must be two dimensional (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
        }
    }
    function _sparseTrace(m) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        var size = m._size;
        // check dimensions
        var rows = size[0];
        var columns = size[1];
        // matrix must be square
        if (rows === columns) {
            // calulate sum
            var sum = 0;
            // check we have data (avoid looping columns)
            if (values.length > 0) // loop columns
            for(var j = 0; j < columns; j++){
                // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
                var k0 = ptr[j];
                var k1 = ptr[j + 1];
                // loop k within [k0, k1[
                for(var k = k0; k < k1; k++){
                    // row index
                    var i = index[k];
                    // check row
                    if (i === j) {
                        // accumulate value
                        sum = add(sum, values[k]);
                        break;
                    }
                    if (i > j) break;
                }
            }
            // return trace
            return sum;
        }
        throw new RangeError("Matrix must be square (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
    }
});




var $152b3cfaa9806a63$var$name = "transpose";
var $152b3cfaa9806a63$var$dependencies = [
    "typed",
    "matrix"
];
var $152b3cfaa9806a63$export$9a8c88485f8f638b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($152b3cfaa9806a63$var$name, $152b3cfaa9806a63$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Transpose a matrix. All values of the matrix are reflected over its
   * main diagonal. Only applicable to two dimensional matrices containing
   * a vector (i.e. having size `[1,n]` or `[n,1]`). One dimensional
   * vectors and scalars return the input unchanged.
   *
   * Syntax:
   *
   *     math.transpose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.transpose(A)               // returns [[1, 4], [2, 5], [3, 6]]
   *
   * See also:
   *
   *     diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be transposed
   * @return {Array | Matrix}   The transposed matrix
   */ return typed($152b3cfaa9806a63$var$name, {
        Array: (x)=>transposeMatrix(matrix(x)).valueOf(),
        Matrix: transposeMatrix,
        any: (0, $46a94b3d1146edd8$export$9cd59f9826255e47 // scalars
        )
    });
    function transposeMatrix(x) {
        // matrix size
        var size = x.size();
        // result
        var c;
        // process dimensions
        switch(size.length){
            case 1:
                // vector
                c = x.clone();
                break;
            case 2:
                // rows and columns
                var rows = size[0];
                var columns = size[1];
                // check columns
                if (columns === 0) // throw exception
                throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
                // process storage format
                switch(x.storage()){
                    case "dense":
                        c = _denseTranspose(x, rows, columns);
                        break;
                    case "sparse":
                        c = _sparseTranspose(x, rows, columns);
                        break;
                }
                break;
            default:
                // multi dimensional
                throw new RangeError("Matrix must be a vector or two dimensional (size: " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(size) + ")");
        }
        return c;
    }
    function _denseTranspose(m, rows, columns) {
        // matrix array
        var data = m._data;
        // transposed matrix data
        var transposed = [];
        var transposedRow;
        // loop columns
        for(var j = 0; j < columns; j++){
            // initialize row
            transposedRow = transposed[j] = [];
            // loop rows
            for(var i = 0; i < rows; i++)// set data
            transposedRow[i] = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(data[i][j]);
        }
        // return matrix
        return m.createDenseMatrix({
            data: transposed,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
    function _sparseTranspose(m, rows, columns) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // result matrices
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // row counts
        var w = [];
        for(var x = 0; x < rows; x++)w[x] = 0;
        // vars
        var p, l, j;
        // loop values in matrix
        for(p = 0, l = index.length; p < l; p++)// number of values in row
        w[index[p]]++;
        // cumulative sum
        var sum = 0;
        // initialize cptr with the cummulative sum of row counts
        for(var i = 0; i < rows; i++){
            // update cptr
            cptr.push(sum);
            // update sum
            sum += w[i];
            // update w
            w[i] = cptr[i];
        }
        // update cptr
        cptr.push(sum);
        // loop columns
        for(j = 0; j < columns; j++)// values & index in column
        for(var k0 = ptr[j], k1 = ptr[j + 1], k = k0; k < k1; k++){
            // C values & index
            var q = w[index[k]]++;
            // C[j, i] = A[i, j]
            cindex[q] = j;
            // check we need to process values (pattern matrix)
            if (values) cvalues[q] = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(values[k]);
        }
        // return matrix
        return m.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
});

/**
 * Create a typed-function which checks the types of the arguments and
 * can match them against multiple provided signatures. The typed-function
 * automatically converts inputs in order to find a matching signature.
 * Typed functions throw informative errors in case of wrong input arguments.
 *
 * See the library [typed-function](https://github.com/josdejong/typed-function)
 * for detailed documentation.
 *
 * Syntax:
 *
 *     math.typed(name, signatures) : function
 *     math.typed(signatures) : function
 *
 * Examples:
 *
 *     // create a typed function with multiple types per argument (type union)
 *     const fn2 = typed({
 *       'number | boolean': function (b) {
 *         return 'b is a number or boolean'
 *       },
 *       'string, number | boolean': function (a, b) {
 *         return 'a is a string, b is a number or boolean'
 *       }
 *     })
 *
 *     // create a typed function with an any type argument
 *     const log = typed({
 *       'string, any': function (event, data) {
 *         console.log('event: ' + event + ', data: ' + JSON.stringify(data))
 *       }
 *     })
 *
 * @param {string} [name]                          Optional name for the typed-function
 * @param {Object<string, function>} signatures   Object with one or multiple function signatures
 * @returns {function} The created typed-function.
 */ 





class $ec715b2ae25daaa7$export$6f491f8f4fd27271 {
    keys() {
        return Object.keys(this.wrappedObject).values();
    }
    get(key) {
        return (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(this.wrappedObject, key);
    }
    set(key, value) {
        (0, $f59a31bcbbaa9e5a$export$e99fe8700ee9f9cd)(this.wrappedObject, key, value);
        return this;
    }
    has(key) {
        return (0, $f59a31bcbbaa9e5a$export$626bde2ef1d9655a)(this.wrappedObject, key);
    }
    entries() {
        return $ec715b2ae25daaa7$var$mapIterator(this.keys(), (key)=>[
                key,
                this.get(key)
            ]);
    }
    forEach(callback) {
        for (var key of this.keys())callback(this.get(key), key, this);
    }
    delete(key) {
        delete this.wrappedObject[key];
    }
    clear() {
        for (var key of this.keys())this.delete(key);
    }
    get size() {
        return Object.keys(this.wrappedObject).length;
    }
    constructor(object){
        this.wrappedObject = object;
        this[Symbol.iterator] = this.entries;
    }
}
class $ec715b2ae25daaa7$export$93f35497d1acacc3 {
    get(key) {
        return this.bKeys.has(key) ? this.b.get(key) : this.a.get(key);
    }
    set(key, value) {
        if (this.bKeys.has(key)) this.b.set(key, value);
        else this.a.set(key, value);
        return this;
    }
    has(key) {
        return this.b.has(key) || this.a.has(key);
    }
    keys() {
        return new Set([
            ...this.a.keys(),
            ...this.b.keys()
        ])[Symbol.iterator]();
    }
    entries() {
        return $ec715b2ae25daaa7$var$mapIterator(this.keys(), (key)=>[
                key,
                this.get(key)
            ]);
    }
    forEach(callback) {
        for (var key of this.keys())callback(this.get(key), key, this);
    }
    delete(key) {
        return this.bKeys.has(key) ? this.b.delete(key) : this.a.delete(key);
    }
    clear() {
        this.a.clear();
        this.b.clear();
    }
    get size() {
        return [
            ...this.keys()
        ].length;
    }
    /**
   * @param {Map} a
   * @param {Map} b
   * @param {Set} bKeys
   */ constructor(a, b, bKeys){
        this.a = a;
        this.b = b;
        this.bKeys = bKeys;
        this[Symbol.iterator] = this.entries;
    }
}
/**
 * Create a new iterator that maps over the provided iterator, applying a mapping function to each item
 */ function $ec715b2ae25daaa7$var$mapIterator(it, callback) {
    return {
        next: ()=>{
            var n = it.next();
            return n.done ? n : {
                value: callback(n.value),
                done: false
            };
        }
    };
}
function $ec715b2ae25daaa7$export$89a4bcaf5b4d37d2() {
    return new Map();
}
function $ec715b2ae25daaa7$export$d49c9aa30b771d59(mapOrObject) {
    if (!mapOrObject) return $ec715b2ae25daaa7$export$89a4bcaf5b4d37d2();
    if ($ec715b2ae25daaa7$export$5c90113a285f2241(mapOrObject)) return mapOrObject;
    if ((0, $23cfe017d190638f$export$a6cdc56e425d0d0a)(mapOrObject)) return new $ec715b2ae25daaa7$export$6f491f8f4fd27271(mapOrObject);
    throw new Error("createMap can create maps from objects or Maps");
}
function $ec715b2ae25daaa7$export$697e4a1b90752ce2(map) {
    if (map instanceof $ec715b2ae25daaa7$export$6f491f8f4fd27271) return map.wrappedObject;
    var object = {};
    for (var key of map.keys()){
        var value = map.get(key);
        (0, $f59a31bcbbaa9e5a$export$e99fe8700ee9f9cd)(object, key, value);
    }
    return object;
}
function $ec715b2ae25daaa7$export$5c90113a285f2241(object) {
    // We can use the fast instanceof, or a slower duck typing check.
    // The duck typing method needs to cover enough methods to not be confused with DenseMatrix.
    if (!object) return false;
    return object instanceof Map || object instanceof $ec715b2ae25daaa7$export$6f491f8f4fd27271 || typeof object.set === "function" && typeof object.get === "function" && typeof object.keys === "function" && typeof object.has === "function";
}
function $ec715b2ae25daaa7$export$e6e34fd1f2686227(map) {
    for(var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)objects[_key - 1] = arguments[_key];
    for (var args of objects){
        if (!args) continue;
        if ($ec715b2ae25daaa7$export$5c90113a285f2241(args)) for (var key of args.keys())map.set(key, args.get(key));
        else if ((0, $23cfe017d190638f$export$a6cdc56e425d0d0a)(args)) for (var _key2 of Object.keys(args))map.set(_key2, args[_key2]);
    }
    return map;
}


// returns a new instance of typed-function
var $fecd1c72801697ff$var$_createTyped2 = function _createTyped() {
    // initially, return the original instance of typed-function
    // consecutively, return a new instance from typed.create.
    $fecd1c72801697ff$var$_createTyped2 = (0, (/*@__PURE__*/$parcel$interopDefault($25db5d51e6b14f18$exports))).create;
    return 0, (/*@__PURE__*/$parcel$interopDefault($25db5d51e6b14f18$exports));
};
var $fecd1c72801697ff$var$dependencies = [
    "?BigNumber",
    "?Complex",
    "?DenseMatrix",
    "?Fraction"
];
var $fecd1c72801697ff$export$8597b5d47504f989 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)("typed", $fecd1c72801697ff$var$dependencies, function createTyped(_ref) {
    var { BigNumber: BigNumber, Complex: Complex, DenseMatrix: DenseMatrix, Fraction: Fraction } = _ref;
    // TODO: typed-function must be able to silently ignore signatures with unknown data types
    // get a new instance of typed-function
    var typed = $fecd1c72801697ff$var$_createTyped2();
    // define all types. The order of the types determines in which order function
    // arguments are type-checked (so for performance it's important to put the
    // most used types first).
    typed.clear();
    typed.addTypes([
        {
            name: "number",
            test: (0, $23cfe017d190638f$export$7e4aa119212bc614)
        },
        {
            name: "Complex",
            test: (0, $23cfe017d190638f$export$8849a896711efe0c)
        },
        {
            name: "BigNumber",
            test: (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)
        },
        {
            name: "bigint",
            test: (0, $23cfe017d190638f$export$c4c1bdb0d1c7cfc7)
        },
        {
            name: "Fraction",
            test: (0, $23cfe017d190638f$export$e312cb8a8e5e7c34)
        },
        {
            name: "Unit",
            test: (0, $23cfe017d190638f$export$8960dc335987b8da)
        },
        // The following type matches a valid variable name, i.e., an alphanumeric
        // string starting with an alphabetic character. It is used (at least)
        // in the definition of the derivative() function, as the argument telling
        // what to differentiate over must (currently) be a variable.
        {
            name: "identifier",
            test: (s)=>(0, $23cfe017d190638f$export$844ec244b1367d54) && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])*$/.test(s)
        },
        {
            name: "string",
            test: (0, $23cfe017d190638f$export$844ec244b1367d54)
        },
        {
            name: "Chain",
            test: (0, $23cfe017d190638f$export$dc36953d0b3a4f05)
        },
        {
            name: "Array",
            test: (0, $23cfe017d190638f$export$43bee75e5e14138e)
        },
        {
            name: "Matrix",
            test: (0, $23cfe017d190638f$export$b22160e0a14f87b7)
        },
        {
            name: "DenseMatrix",
            test: (0, $23cfe017d190638f$export$eb44495df7ba11d)
        },
        {
            name: "SparseMatrix",
            test: (0, $23cfe017d190638f$export$d508368d4da3c38a)
        },
        {
            name: "Range",
            test: (0, $23cfe017d190638f$export$e331ccfa6f694c99)
        },
        {
            name: "Index",
            test: (0, $23cfe017d190638f$export$ba3dc792055c2f45)
        },
        {
            name: "boolean",
            test: (0, $23cfe017d190638f$export$f9ce7b637dfbe238)
        },
        {
            name: "ResultSet",
            test: (0, $23cfe017d190638f$export$381a1a20e6a63376)
        },
        {
            name: "Help",
            test: (0, $23cfe017d190638f$export$e5dec9a75b602d6c)
        },
        {
            name: "function",
            test: (0, $23cfe017d190638f$export$f6e2535fb5126e54)
        },
        {
            name: "Date",
            test: (0, $23cfe017d190638f$export$871608497c498473)
        },
        {
            name: "RegExp",
            test: (0, $23cfe017d190638f$export$49841c62b9eff15)
        },
        {
            name: "null",
            test: (0, $23cfe017d190638f$export$630801d484da15df)
        },
        {
            name: "undefined",
            test: (0, $23cfe017d190638f$export$fce6876652108ab)
        },
        {
            name: "AccessorNode",
            test: (0, $23cfe017d190638f$export$f88fb19d6b9ee5cb)
        },
        {
            name: "ArrayNode",
            test: (0, $23cfe017d190638f$export$440fa93dcf2757a3)
        },
        {
            name: "AssignmentNode",
            test: (0, $23cfe017d190638f$export$64d7d515ec030d5e)
        },
        {
            name: "BlockNode",
            test: (0, $23cfe017d190638f$export$1665e2275a3d717a)
        },
        {
            name: "ConditionalNode",
            test: (0, $23cfe017d190638f$export$e1babefe78c70737)
        },
        {
            name: "ConstantNode",
            test: (0, $23cfe017d190638f$export$fa9d80731fd8c54b)
        },
        {
            name: "FunctionNode",
            test: (0, $23cfe017d190638f$export$6ae03b16e064e6c4)
        },
        {
            name: "FunctionAssignmentNode",
            test: (0, $23cfe017d190638f$export$27c05cfffd263d30)
        },
        {
            name: "IndexNode",
            test: (0, $23cfe017d190638f$export$ff90979121a6cabc)
        },
        {
            name: "Node",
            test: (0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)
        },
        {
            name: "ObjectNode",
            test: (0, $23cfe017d190638f$export$3f18867a334658e9)
        },
        {
            name: "OperatorNode",
            test: (0, $23cfe017d190638f$export$7e624cbaab6cce94)
        },
        {
            name: "ParenthesisNode",
            test: (0, $23cfe017d190638f$export$c55e3736c5721220)
        },
        {
            name: "RangeNode",
            test: (0, $23cfe017d190638f$export$92729c5c4ff6fc83)
        },
        {
            name: "RelationalNode",
            test: (0, $23cfe017d190638f$export$51bc4e372ab35935)
        },
        {
            name: "SymbolNode",
            test: (0, $23cfe017d190638f$export$87815d550facaed9)
        },
        {
            name: "Map",
            test: (0, $ec715b2ae25daaa7$export$5c90113a285f2241)
        },
        {
            name: "Object",
            test: (0, $23cfe017d190638f$export$a6cdc56e425d0d0a)
        } // order 'Object' last, it matches on other classes too
    ]);
    typed.addConversions([
        {
            from: "number",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $fecd1c72801697ff$var$throwNoBignumber(x);
                // note: conversion from number to BigNumber can fail if x has >15 digits
                if ((0, $a246eb207aab6d09$export$9c0987062f8f5d89)(x) > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + x + "). " + "Use function bignumber(x) to convert to BigNumber.");
                return new BigNumber(x);
            }
        },
        {
            from: "number",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $fecd1c72801697ff$var$throwNoComplex(x);
                return new Complex(x, 0);
            }
        },
        {
            from: "BigNumber",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $fecd1c72801697ff$var$throwNoComplex(x);
                return new Complex(x.toNumber(), 0);
            }
        },
        {
            from: "bigint",
            to: "number",
            convert: function convert(x) {
                if (x > Number.MAX_SAFE_INTEGER) throw new TypeError("Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: " + x + ")");
                return Number(x);
            }
        },
        {
            from: "bigint",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $fecd1c72801697ff$var$throwNoBignumber(x);
                return new BigNumber(x.toString());
            }
        },
        {
            from: "bigint",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $fecd1c72801697ff$var$throwNoFraction(x);
                return new Fraction(x.toString());
            }
        },
        {
            from: "Fraction",
            to: "BigNumber",
            convert: function convert(x) {
                throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
            }
        },
        {
            from: "Fraction",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $fecd1c72801697ff$var$throwNoComplex(x);
                return new Complex(x.valueOf(), 0);
            }
        },
        {
            from: "number",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $fecd1c72801697ff$var$throwNoFraction(x);
                var f = new Fraction(x);
                if (f.valueOf() !== x) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + x + "). " + "Use function fraction(x) to convert to Fraction.");
                return f;
            }
        },
        {
            // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
            //  from: 'Fraction',
            //  to: 'number',
            //  convert: function (x) {
            //    return x.valueOf()
            //  }
            // }, {
            from: "string",
            to: "number",
            convert: function convert(x) {
                var n = Number(x);
                if (isNaN(n)) throw new Error('Cannot convert "' + x + '" to a number');
                return n;
            }
        },
        {
            from: "string",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $fecd1c72801697ff$var$throwNoBignumber(x);
                try {
                    return new BigNumber(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to BigNumber');
                }
            }
        },
        {
            from: "string",
            to: "bigint",
            convert: function convert(x) {
                try {
                    return BigInt(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to BigInt');
                }
            }
        },
        {
            from: "string",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $fecd1c72801697ff$var$throwNoFraction(x);
                try {
                    return new Fraction(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Fraction');
                }
            }
        },
        {
            from: "string",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $fecd1c72801697ff$var$throwNoComplex(x);
                try {
                    return new Complex(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Complex');
                }
            }
        },
        {
            from: "boolean",
            to: "number",
            convert: function convert(x) {
                return +x;
            }
        },
        {
            from: "boolean",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $fecd1c72801697ff$var$throwNoBignumber(x);
                return new BigNumber(+x);
            }
        },
        {
            from: "boolean",
            to: "bigint",
            convert: function convert(x) {
                return BigInt(+x);
            }
        },
        {
            from: "boolean",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $fecd1c72801697ff$var$throwNoFraction(x);
                return new Fraction(+x);
            }
        },
        {
            from: "boolean",
            to: "string",
            convert: function convert(x) {
                return String(x);
            }
        },
        {
            from: "Array",
            to: "Matrix",
            convert: function convert(array) {
                if (!DenseMatrix) $fecd1c72801697ff$var$throwNoMatrix();
                return new DenseMatrix(array);
            }
        },
        {
            from: "Matrix",
            to: "Array",
            convert: function convert(matrix) {
                return matrix.valueOf();
            }
        }
    ]);
    // Provide a suggestion on how to call a function elementwise
    // This was added primarily as guidance for the v10 -> v11 transition,
    // and could potentially be removed in the future if it no longer seems
    // to be helpful.
    typed.onMismatch = (name, args, signatures)=>{
        var usualError = typed.createError(name, args, signatures);
        if ([
            "wrongType",
            "mismatch"
        ].includes(usualError.data.category) && args.length === 1 && (0, $23cfe017d190638f$export$cea7aa84e978eba5)(args[0]) && // check if the function can be unary:
        signatures.some((sig)=>!sig.params.includes(","))) {
            var err = new TypeError("Function '".concat(name, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(name, ")'."));
            err.data = usualError.data;
            throw err;
        }
        throw usualError;
    };
    // Provide a suggestion on how to call a function elementwise
    // This was added primarily as guidance for the v10 -> v11 transition,
    // and could potentially be removed in the future if it no longer seems
    // to be helpful.
    typed.onMismatch = (name, args, signatures)=>{
        var usualError = typed.createError(name, args, signatures);
        if ([
            "wrongType",
            "mismatch"
        ].includes(usualError.data.category) && args.length === 1 && (0, $23cfe017d190638f$export$cea7aa84e978eba5)(args[0]) && // check if the function can be unary:
        signatures.some((sig)=>!sig.params.includes(","))) {
            var err = new TypeError("Function '".concat(name, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(name, ")'."));
            err.data = usualError.data;
            throw err;
        }
        throw usualError;
    };
    return typed;
});
function $fecd1c72801697ff$var$throwNoBignumber(x) {
    throw new Error("Cannot convert value ".concat(x, " into a BigNumber: no class 'BigNumber' provided"));
}
function $fecd1c72801697ff$var$throwNoComplex(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Complex number: no class 'Complex' provided"));
}
function $fecd1c72801697ff$var$throwNoMatrix() {
    throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function $fecd1c72801697ff$var$throwNoFraction(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Fraction, no class 'Fraction' provided."));
}



var $2e551e404befc1d2$var$name = "typeOf";
var $2e551e404befc1d2$var$dependencies = [
    "typed"
];
var $2e551e404befc1d2$export$d7acf116afef7b4d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($2e551e404befc1d2$var$name, $2e551e404befc1d2$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Determine the type of an entity.
   *
   * Syntax:
   *
   *    math.typeOf(x)
   *
   * Examples:
   *
   *    // This list is intended to include all relevant types, for testing
   *    // purposes:
   *    math.typeOf(3.5)                      // returns 'number'
   *    math.typeOf(42n)                      // returns 'bigint'
   *    math.typeOf(math.complex('2-4i'))     // returns 'Complex'
   *    math.typeOf(math.unit('45 deg'))      // returns 'Unit'
   *    math.typeOf('hello world')            // returns 'string'
   *    math.typeOf(null)                     // returns 'null'
   *    math.typeOf(true)                     // returns 'boolean'
   *    math.typeOf([1, 2, 3])                // returns 'Array'
   *    math.typeOf(new Date())               // returns 'Date'
   *    math.typeOf(function () {})           // returns 'function'
   *    math.typeOf({a: 2, b: 3})             // returns 'Object'
   *    math.typeOf(/a regexp/)               // returns 'RegExp'
   *    math.typeOf(undefined)                // returns 'undefined'
   *    math.typeOf(math.bignumber('23e99'))  // returns 'BigNumber'
   *    math.typeOf(math.chain(2))            // returns 'Chain'
   *    math.typeOf(math.fraction(1, 3))      // returns 'Fraction'
   *    math.typeOf(math.help('sqrt'))        // returns 'Help'
   *    math.typeOf(math.index(1, 3))         // returns 'Index'
   *    math.typeOf(math.matrix([[1],[3]]))   // returns 'DenseMatrix'
   *    math.typeOf(math.matrix([],'sparse')) // returns 'SparseMatrix'
   *    math.typeOf(new math.Range(0, 10))    // returns 'Range'
   *    math.typeOf(math.evaluate('a=2\na'))  // returns 'ResultSet'
   *    math.typeOf(math.parse('A[2]'))       // returns 'AccessorNode'
   *    math.typeOf(math.parse('[1,2,3]'))    // returns 'ArrayNode'
   *    math.typeOf(math.parse('x=2'))        // returns 'AssignmentNode'
   *    math.typeOf(math.parse('a=2; b=3'))   // returns 'BlockNode'
   *    math.typeOf(math.parse('x<0?-1:1'))   // returns 'ConditionalNode'
   *    math.typeOf(math.parse('2.3'))        // returns 'ConstantNode'
   *    math.typeOf(math.parse('f(x)=x^2'))   // returns 'FunctionAssignmentNode'
   *    math.typeOf(math.parse('sqrt(4)'))    // returns 'FunctionNode'
   *    math.typeOf(math.parse('A[2]').index) // returns 'IndexNode'
   *    math.typeOf(math.parse('{a:2}'))      // returns 'ObjectNode'
   *    math.typeOf(math.parse('(2+3)'))      // returns 'ParenthesisNode'
   *    math.typeOf(math.parse('1:10'))       // returns 'RangeNode'
   *    math.typeOf(math.parse('a<b<c'))      // returns 'RelationalNode'
   *    math.typeOf(math.parse('x'))          // returns 'SymbolNode'
   *
   * @param {*} x     The variable for which to test the type.
   * @return {string} Returns the name of the type. Primitive types are lower case,
   *                  non-primitive types are upper-camel-case.
   *                  For example 'number', 'string', 'Array', 'Date'.
   */ return typed($2e551e404befc1d2$var$name, {
        any: (0, $23cfe017d190638f$export$f5bbd400c2f4426f)
    });
});




var $593104fa76be2510$var$name = "unaryMinus";
var $593104fa76be2510$var$dependencies = [
    "typed"
];
var $593104fa76be2510$export$939e1be6e134f392 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($593104fa76be2510$var$name, $593104fa76be2510$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Inverse the sign of a value, apply a unary minus operation.
   *
   * For matrices, the function is evaluated element wise. Boolean values and
   * strings will be converted to a number. For complex numbers, both real and
   * complex value are inverted.
   *
   * Syntax:
   *
   *    math.unaryMinus(x)
   *
   * Examples:
   *
   *    math.unaryMinus(3.5)      // returns -3.5
   *    math.unaryMinus(-4.2)     // returns 4.2
   *
   * See also:
   *
   *    add, subtract, unaryPlus
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} x Number to be inverted.
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} Returns the value with inverted sign.
   */ return typed($593104fa76be2510$var$name, {
        number: (0, $f38f49d8e24d4a9f$export$339666dc881be46b),
        "Complex | BigNumber | Fraction": (x)=>x.neg(),
        bigint: (x)=>-x,
        Unit: typed.referToSelf((self)=>(x)=>{
                var res = x.clone();
                res.value = typed.find(self, res.valueType())(x.value);
                return res;
            }),
        // deep map collection, skip zeros since unaryMinus(0) = 0
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self, true))
    });
});





var $c4c7cd9f47d65d2f$var$name = "unaryPlus";
var $c4c7cd9f47d65d2f$var$dependencies = [
    "typed",
    "config",
    "numeric"
];
var $c4c7cd9f47d65d2f$export$cb425222dc08ff4e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c4c7cd9f47d65d2f$var$name, $c4c7cd9f47d65d2f$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric } = _ref;
    /**
   * Unary plus operation.
   * Boolean values and strings will be converted to a number, numeric values will be returned as is.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.unaryPlus(x)
   *
   * Examples:
   *
   *    math.unaryPlus(3.5)      // returns 3.5
   *    math.unaryPlus(1)     // returns 1
   *
   * See also:
   *
   *    unaryMinus, add, subtract
   *
   * @param  {number | BigNumber | bigint | Fraction | string | Complex | Unit | Array | Matrix} x
   *            Input value
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix}
   *            Returns the input value when numeric, converts to a number when input is non-numeric.
   */ return typed($c4c7cd9f47d65d2f$var$name, {
        number: (0, $f38f49d8e24d4a9f$export$da5b80d388a295fb),
        Complex: function Complex(x) {
            return x; // complex numbers are immutable
        },
        BigNumber: function BigNumber(x) {
            return x; // bignumbers are immutable
        },
        bigint: function bigint(x) {
            return x;
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Unit: function Unit(x) {
            return x.clone();
        },
        // deep map collection, skip zeros since unaryPlus(0) = 0
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self, true)),
        boolean: function boolean(x) {
            return numeric(x ? 1 : 0, config.number);
        },
        string: function string(x) {
            return numeric(x, (0, $a246eb207aab6d09$export$28199db5a610a1ee)(x, config));
        }
    });
});






var $fe39bda396a8c79c$var$name = "unequal";
var $fe39bda396a8c79c$var$dependencies = [
    "typed",
    "config",
    "equalScalar",
    "matrix",
    "DenseMatrix",
    "concat"
];
var $fe39bda396a8c79c$export$833e6c382e279d04 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($fe39bda396a8c79c$var$name, $fe39bda396a8c79c$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, equalScalar: equalScalar, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $5e352e66a45fa3fa$export$439c4d7accd2a586)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Test whether two values are unequal.
   *
   * The function tests whether the relative difference between x and y is
   * larger than the configured relTol and absTol. The function cannot be used to compare
   * values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must unequal y.re, or x.im must unequal y.im.
   * Strings are compared by their numerical value.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is unequal
   * with everything except `null`, and `undefined` is unequal with everything
   * except `undefined`.
   *
   * Syntax:
   *
   *    math.unequal(x, y)
   *
   * Examples:
   *
   *    math.unequal(2 + 2, 3)       // returns true
   *    math.unequal(2 + 2, 4)       // returns false
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.unequal(a, b)           // returns false
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.unequal(c, d)           // returns [false, true, false]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.unequal(0, null)        // returns true
   * See also:
   *
   *    equal, deepEqual, smaller, smallerEq, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are unequal, else returns false
   */ return typed($fe39bda396a8c79c$var$name, $fe39bda396a8c79c$export$b0b3dad01e54080b({
        typed: typed,
        equalScalar: equalScalar
    }), matrixAlgorithmSuite({
        elop: _unequal,
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
    function _unequal(x, y) {
        return !equalScalar(x, y);
    }
});
var $fe39bda396a8c79c$export$b0b3dad01e54080b = (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($fe39bda396a8c79c$var$name, [
    "typed",
    "equalScalar"
], (_ref2)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref2;
    return typed($fe39bda396a8c79c$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return !equalScalar(x, y);
        }
    });
});









function $f5aa26fb27a90528$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f5aa26fb27a90528$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f5aa26fb27a90528$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f5aa26fb27a90528$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f5aa26fb27a90528$var$name = "Unit";
var $f5aa26fb27a90528$var$dependencies = [
    "?on",
    "config",
    "addScalar",
    "subtractScalar",
    "multiplyScalar",
    "divideScalar",
    "pow",
    "abs",
    "fix",
    "round",
    "equal",
    "isNumeric",
    "format",
    "number",
    "Complex",
    "BigNumber",
    "Fraction"
];
var $f5aa26fb27a90528$export$3ad06557a3ac7a63 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f5aa26fb27a90528$var$name, $f5aa26fb27a90528$var$dependencies, (_ref)=>{
    var { on: on, config: config, addScalar: addScalar, subtractScalar: subtractScalar, multiplyScalar: multiplyScalar, divideScalar: divideScalar, pow: pow, abs: abs, fix: fix, round: round, equal: equal, isNumeric: isNumeric, format: format, number: _number, Complex: Complex, BigNumber: _BigNumber, Fraction: _Fraction } = _ref;
    var toNumber = _number;
    /**
   * A unit can be constructed in the following ways:
   *
   *     const a = new Unit(value, valuelessUnit)
   *     const b = new Unit(null, valuelessUnit)
   *     const c = Unit.parse(str)
   *
   * Example usage:
   *
   *     const a = new Unit(5, 'cm')               // 50 mm
   *     const b = Unit.parse('23 kg')             // 23 kg
   *     const c = math.in(a, new Unit(null, 'm')  // 0.05 m
   *     const d = new Unit(9.81, "m/s^2")         // 9.81 m/s^2
   *
   * @class Unit
   * @constructor Unit
   * @param {number | BigNumber | Fraction | Complex | boolean} [value]  A value like 5.2
   * @param {string | Unit} valuelessUnit   A unit without value. Can have prefix, like "cm"
   */ function Unit(value, valuelessUnit) {
        if (!(this instanceof Unit)) throw new Error("Constructor must be called with the new operator");
        if (!(value === null || value === undefined || isNumeric(value) || (0, $23cfe017d190638f$export$8849a896711efe0c)(value))) throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
        this.fixPrefix = false; // if true, function format will not search for the
        // best prefix but leave it as initially provided.
        // fixPrefix is set true by the method Unit.to
        // The justification behind this is that if the constructor is explicitly called,
        // the caller wishes the units to be returned exactly as supplied.
        this.skipAutomaticSimplification = true;
        if (valuelessUnit === undefined) {
            this.units = [];
            this.dimensions = BASE_DIMENSIONS.map((x)=>0);
        } else if (typeof valuelessUnit === "string") {
            var u = Unit.parse(valuelessUnit);
            this.units = u.units;
            this.dimensions = u.dimensions;
        } else if ((0, $23cfe017d190638f$export$8960dc335987b8da)(valuelessUnit) && valuelessUnit.value === null) {
            // clone from valuelessUnit
            this.fixPrefix = valuelessUnit.fixPrefix;
            this.skipAutomaticSimplification = valuelessUnit.skipAutomaticSimplification;
            this.dimensions = valuelessUnit.dimensions.slice(0);
            this.units = valuelessUnit.units.map((u)=>(0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))({}, u));
        } else throw new TypeError("Second parameter in Unit constructor must be a string or valueless Unit");
        this.value = this._normalize(value);
    }
    /**
   * Attach type information
   */ Object.defineProperty(Unit, "name", {
        value: "Unit"
    });
    Unit.prototype.constructor = Unit;
    Unit.prototype.type = "Unit";
    Unit.prototype.isUnit = true;
    // private variables and functions for the Unit parser
    var text, index, c;
    function skipWhitespace() {
        while(c === " " || c === "	")next();
    }
    function isDigitDot(c) {
        return c >= "0" && c <= "9" || c === ".";
    }
    function isDigit(c) {
        return c >= "0" && c <= "9";
    }
    function next() {
        index++;
        c = text.charAt(index);
    }
    function revert(oldIndex) {
        index = oldIndex;
        c = text.charAt(index);
    }
    function parseNumber() {
        var number = "";
        var oldIndex = index;
        if (c === "+") next();
        else if (c === "-") {
            number += c;
            next();
        }
        if (!isDigitDot(c)) {
            // a + or - must be followed by a digit
            revert(oldIndex);
            return null;
        }
        // get number, can have a single dot
        if (c === ".") {
            number += c;
            next();
            if (!isDigit(c)) {
                // this is no legal number, it is just a dot
                revert(oldIndex);
                return null;
            }
        } else {
            while(isDigit(c)){
                number += c;
                next();
            }
            if (c === ".") {
                number += c;
                next();
            }
        }
        while(isDigit(c)){
            number += c;
            next();
        }
        // check for exponential notation like "2.3e-4" or "1.23e50"
        if (c === "E" || c === "e") {
            // The grammar branches here. This could either be part of an exponent or the start of a unit that begins with the letter e, such as "4exabytes"
            var tentativeNumber = "";
            var tentativeIndex = index;
            tentativeNumber += c;
            next();
            if (c === "+" || c === "-") {
                tentativeNumber += c;
                next();
            }
            // Scientific notation MUST be followed by an exponent (otherwise we assume it is not scientific notation)
            if (!isDigit(c)) {
                // The e or E must belong to something else, so return the number without the e or E.
                revert(tentativeIndex);
                return number;
            }
            // We can now safely say that this is scientific notation.
            number = number + tentativeNumber;
            while(isDigit(c)){
                number += c;
                next();
            }
        }
        return number;
    }
    function parseUnit() {
        var unitName = "";
        // Alphanumeric characters only; matches [a-zA-Z0-9]
        while(isDigit(c) || Unit.isValidAlpha(c)){
            unitName += c;
            next();
        }
        // Must begin with [a-zA-Z]
        var firstC = unitName.charAt(0);
        if (Unit.isValidAlpha(firstC)) return unitName;
        else return null;
    }
    function parseCharacter(toFind) {
        if (c === toFind) {
            next();
            return toFind;
        } else return null;
    }
    /**
   * Parse a string into a unit. The value of the unit is parsed as number,
   * BigNumber, or Fraction depending on the math.js config setting `number`.
   *
   * Throws an exception if the provided string does not contain a valid unit or
   * cannot be parsed.
   * @memberof Unit
   * @param {string} str        A string like "5.2 inch", "4e2 cm/s^2"
   * @return {Unit} unit
   */ Unit.parse = function(str, options) {
        options = options || {};
        text = str;
        index = -1;
        c = "";
        if (typeof text !== "string") throw new TypeError("Invalid argument in Unit.parse, string expected");
        var unit = new Unit();
        unit.units = [];
        var powerMultiplierCurrent = 1;
        var expectingUnit = false;
        // A unit should follow this pattern:
        // [number] ...[ [*/] unit[^number] ]
        // unit[^number] ... [ [*/] unit[^number] ]
        // Rules:
        // number is any floating point number.
        // unit is any alphanumeric string beginning with an alpha. Units with names like e3 should be avoided because they look like the exponent of a floating point number!
        // The string may optionally begin with a number.
        // Each unit may optionally be followed by ^number.
        // Whitespace or a forward slash is recommended between consecutive units, although the following technically is parseable:
        //   2m^2kg/s^2
        // it is not good form. If a unit starts with e, then it could be confused as a floating point number:
        //   4erg
        next();
        skipWhitespace();
        // Optional number at the start of the string
        var valueStr = parseNumber();
        var value = null;
        if (valueStr) {
            if (config.number === "BigNumber") value = new _BigNumber(valueStr);
            else if (config.number === "Fraction") try {
                // not all numbers can be turned in Fractions, for example very small numbers not
                value = new _Fraction(valueStr);
            } catch (err) {
                value = parseFloat(valueStr);
            }
            else // number
            value = parseFloat(valueStr);
            skipWhitespace(); // Whitespace is not required here
            // handle multiplication or division right after the value, like '1/s'
            if (parseCharacter("*")) {
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter("/")) {
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            }
        }
        // Stack to keep track of powerMultipliers applied to each parentheses group
        var powerMultiplierStack = [];
        // Running product of all elements in powerMultiplierStack
        var powerMultiplierStackProduct = 1;
        while(true){
            skipWhitespace();
            // Check for and consume opening parentheses, pushing powerMultiplierCurrent to the stack
            // A '(' will always appear directly before a unit.
            while(c === "("){
                powerMultiplierStack.push(powerMultiplierCurrent);
                powerMultiplierStackProduct *= powerMultiplierCurrent;
                powerMultiplierCurrent = 1;
                next();
                skipWhitespace();
            }
            // Is there something here?
            var uStr = void 0;
            if (c) {
                var oldC = c;
                uStr = parseUnit();
                if (uStr === null) throw new SyntaxError('Unexpected "' + oldC + '" in "' + text + '" at index ' + index.toString());
            } else break;
            // Verify the unit exists and get the prefix (if any)
            var res = _findUnit(uStr);
            if (res === null) // Unit not found.
            throw new SyntaxError('Unit "' + uStr + '" not found.');
            var power = powerMultiplierCurrent * powerMultiplierStackProduct;
            // Is there a "^ number"?
            skipWhitespace();
            if (parseCharacter("^")) {
                skipWhitespace();
                var p = parseNumber();
                if (p === null) // No valid number found for the power!
                throw new SyntaxError('In "' + str + '", "^" must be followed by a floating-point number');
                power *= p;
            }
            // Add the unit to the list
            unit.units.push({
                unit: res.unit,
                prefix: res.prefix,
                power: power
            });
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)unit.dimensions[i] += (res.unit.dimensions[i] || 0) * power;
            // Check for and consume closing parentheses, popping from the stack.
            // A ')' will always follow a unit.
            skipWhitespace();
            while(c === ")"){
                if (powerMultiplierStack.length === 0) throw new SyntaxError('Unmatched ")" in "' + text + '" at index ' + index.toString());
                powerMultiplierStackProduct /= powerMultiplierStack.pop();
                next();
                skipWhitespace();
            }
            // "*" and "/" should mean we are expecting something to come next.
            // Is there a forward slash? If so, negate powerMultiplierCurrent. The next unit or paren group is in the denominator.
            expectingUnit = false;
            if (parseCharacter("*")) {
                // explicit multiplication
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter("/")) {
                // division
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            } else // implicit multiplication
            powerMultiplierCurrent = 1;
            // Replace the unit into the auto unit system
            if (res.unit.base) {
                var baseDim = res.unit.base.key;
                UNIT_SYSTEMS.auto[baseDim] = {
                    unit: res.unit,
                    prefix: res.prefix
                };
            }
        }
        // Has the string been entirely consumed?
        skipWhitespace();
        if (c) throw new SyntaxError('Could not parse: "' + str + '"');
        // Is there a trailing slash?
        if (expectingUnit) throw new SyntaxError('Trailing characters: "' + str + '"');
        // Is the parentheses stack empty?
        if (powerMultiplierStack.length !== 0) throw new SyntaxError('Unmatched "(" in "' + text + '"');
        // Are there any units at all?
        if (unit.units.length === 0 && !options.allowNoUnits) throw new SyntaxError('"' + str + '" contains no units');
        unit.value = value !== undefined ? unit._normalize(value) : null;
        return unit;
    };
    /**
   * create a copy of this unit
   * @memberof Unit
   * @return {Unit} Returns a cloned version of the unit
   */ Unit.prototype.clone = function() {
        var unit = new Unit();
        unit.fixPrefix = this.fixPrefix;
        unit.skipAutomaticSimplification = this.skipAutomaticSimplification;
        unit.value = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this.value);
        unit.dimensions = this.dimensions.slice(0);
        unit.units = [];
        for(var i = 0; i < this.units.length; i++){
            unit.units[i] = {};
            for(var p in this.units[i])if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(this.units[i], p)) unit.units[i][p] = this.units[i][p];
        }
        return unit;
    };
    /**
   * Return the type of the value of this unit
   *
   * @memberof Unit
   * @return {string} type of the value of the unit
   */ Unit.prototype.valueType = function() {
        return (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(this.value);
    };
    /**
   * Return whether the unit is derived (such as m/s, or cm^2, but not N)
   * @memberof Unit
   * @return {boolean} True if the unit is derived
   * @private
   */ Unit.prototype._isDerived = function() {
        if (this.units.length === 0) return false;
        return this.units.length > 1 || Math.abs(this.units[0].power - 1.0) > 1e-15;
    };
    /**
   * Normalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number | BigNumber | Fraction | boolean} value
   * @return {number | BigNumber | Fraction | boolean} normalized value
   * @private
   */ Unit.prototype._normalize = function(value) {
        if (value === null || value === undefined || this.units.length === 0) return value;
        var res = value;
        var convert = Unit._getNumberConverter((0, $23cfe017d190638f$export$f5bbd400c2f4426f)(value)); // convert to Fraction or BigNumber if needed
        for(var i = 0; i < this.units.length; i++){
            var unitValue = convert(this.units[i].unit.value);
            var unitPrefixValue = convert(this.units[i].prefix.value);
            var unitPower = convert(this.units[i].power);
            res = multiplyScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
        }
        return res;
    };
    /**
   * Denormalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number} value
   * @param {number} [prefixValue]    Optional prefix value to be used (ignored if this is a derived unit)
   * @return {number} denormalized value
   * @private
   */ Unit.prototype._denormalize = function(value, prefixValue) {
        if (value === null || value === undefined || this.units.length === 0) return value;
        var res = value;
        var convert = Unit._getNumberConverter((0, $23cfe017d190638f$export$f5bbd400c2f4426f)(value)); // convert to Fraction or BigNumber if needed
        for(var i = 0; i < this.units.length; i++){
            var unitValue = convert(this.units[i].unit.value);
            var unitPrefixValue = convert(this.units[i].prefix.value);
            var unitPower = convert(this.units[i].power);
            res = divideScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
        }
        return res;
    };
    /**
   * Find a unit from a string
   * @memberof Unit
   * @param {string} str              A string like 'cm' or 'inch'
   * @returns {Object | null} result  When found, an object with fields unit and
   *                                  prefix is returned. Else, null is returned.
   * @private
   */ var _findUnit = (0, $ffc30f141434c696$export$fc10aeed3a532e2a)((str)=>{
        // First, match units names exactly. For example, a user could define 'mm' as 10^-4 m, which is silly, but then we would want 'mm' to match the user-defined unit.
        if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(UNITS, str)) {
            var unit = UNITS[str];
            var prefix = unit.prefixes[""];
            return {
                unit: unit,
                prefix: prefix
            };
        }
        for(var _name in UNITS){
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(UNITS, _name)) {
                if ((0, $1b038b7ade911d0e$export$10fdab3683b55b22)(str, _name)) {
                    var _unit = UNITS[_name];
                    var prefixLen = str.length - _name.length;
                    var prefixName = str.substring(0, prefixLen);
                    var _prefix = (0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(_unit.prefixes, prefixName) ? _unit.prefixes[prefixName] : undefined;
                    if (_prefix !== undefined) // store unit, prefix, and value
                    return {
                        unit: _unit,
                        prefix: _prefix
                    };
                }
            }
        }
        return null;
    }, {
        hasher: (args)=>args[0],
        limit: 100
    });
    /**
   * Test if the given expression is a unit.
   * The unit can have a prefix but cannot have a value.
   * @memberof Unit
   * @param {string} name   A string to be tested whether it is a value less unit.
   *                        The unit can have prefix, like "cm"
   * @return {boolean}      true if the given string is a unit
   */ Unit.isValuelessUnit = function(name) {
        return _findUnit(name) !== null;
    };
    /**
   * check if this unit has given base unit
   * If this unit is a derived unit, this will ALWAYS return false, since by definition base units are not derived.
   * @memberof Unit
   * @param {BASE_UNIT | string | undefined} base
   */ Unit.prototype.hasBase = function(base) {
        if (typeof base === "string") base = BASE_UNITS[base];
        if (!base) return false;
        // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (base.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit has a base or bases equal to another base or bases
   * For derived units, the exponent on each base also must match
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if equal base
   */ Unit.prototype.equalBase = function(other) {
        // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (other.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit equals another unit
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if both units are equal
   */ Unit.prototype.equals = function(other) {
        return this.equalBase(other) && equal(this.value, other.value);
    };
    /**
   * Multiply this unit with another one or with a scalar
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} product of this unit and the other unit
   */ Unit.prototype.multiply = function(_other) {
        var res = this.clone();
        var other = (0, $23cfe017d190638f$export$8960dc335987b8da)(_other) ? _other : new Unit(_other);
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) + (other.dimensions[i] || 0);
        // Append other's units list onto res
        for(var _i = 0; _i < other.units.length; _i++){
            // Make a shallow copy of every unit
            var inverted = $f5aa26fb27a90528$var$_objectSpread({}, other.units[_i]);
            res.units.push(inverted);
        }
        // If at least one operand has a value, then the result should also have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = multiplyScalar(valThis, valOther);
        } else res.value = null;
        if ((0, $23cfe017d190638f$export$8960dc335987b8da)(_other)) res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Divide a number by this unit
   *
   * @memberof Unit
   * @param {numeric} numerator
   * @param {unit} result of dividing numerator by this unit
   */ Unit.prototype.divideInto = function(numerator) {
        return new Unit(numerator).divide(this);
    };
    /**
   * Divide this unit by another one
   * @memberof Unit
   * @param {Unit | numeric} other
   * @return {Unit} result of dividing this unit by the other unit
   */ Unit.prototype.divide = function(_other) {
        var res = this.clone();
        var other = (0, $23cfe017d190638f$export$8960dc335987b8da)(_other) ? _other : new Unit(_other);
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) - (other.dimensions[i] || 0);
        // Invert and append other's units list onto res
        for(var _i2 = 0; _i2 < other.units.length; _i2++){
            // Make a shallow copy of every unit
            var inverted = $f5aa26fb27a90528$var$_objectSpread($f5aa26fb27a90528$var$_objectSpread({}, other.units[_i2]), {}, {
                power: -other.units[_i2].power
            });
            res.units.push(inverted);
        }
        // If at least one operand has a value, the result should have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = divideScalar(valThis, valOther);
        } else res.value = null;
        if ((0, $23cfe017d190638f$export$8960dc335987b8da)(_other)) res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Calculate the power of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} p
   * @returns {Unit}      The result: this^p
   */ Unit.prototype.pow = function(p) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) * p;
        // Adjust the power of each unit in the list
        for(var _i3 = 0; _i3 < res.units.length; _i3++)res.units[_i3].power *= p;
        if (res.value !== null) res.value = pow(res.value, p);
        else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Return the numeric value of this unit if it is dimensionless, has a value, and config.predictable == false; or the original unit otherwise
   * @param {Unit} unit
   * @returns {number | Fraction | BigNumber | Unit}  The numeric value of the unit if conditions are met, or the original unit otherwise
   */ function getNumericIfUnitless(unit) {
        if (unit.equalBase(BASE_UNITS.NONE) && unit.value !== null && !config.predictable) return unit.value;
        else return unit;
    }
    /**
   * Calculate the absolute value of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} x
   * @returns {Unit}      The result: |x|, absolute value of x
   */ Unit.prototype.abs = function() {
        var ret = this.clone();
        if (ret.value !== null) {
            if (ret._isDerived() || ret.units.length === 0 || ret.units[0].unit.offset === 0) ret.value = abs(ret.value);
            else {
                // To give the correct, but unexpected, results for units with an offset.
                // For example, abs(-283.15 degC) = -263.15 degC !!!
                // We must take the offset into consideration here
                var convert = ret._numberConverter(); // convert to Fraction or BigNumber if needed
                var unitValue = convert(ret.units[0].unit.value);
                var nominalOffset = convert(ret.units[0].unit.offset);
                var unitOffset = multiplyScalar(unitValue, nominalOffset);
                ret.value = subtractScalar(abs(addScalar(ret.value, unitOffset)), unitOffset);
            }
        }
        for(var i in ret.units)if (ret.units[i].unit.name === "VA" || ret.units[i].unit.name === "VAR") ret.units[i].unit = UNITS.W;
        return ret;
    };
    /**
   * Convert the unit to a specific unit name.
   * @memberof Unit
   * @param {string | Unit} valuelessUnit   A unit without value. Can have prefix, like "cm"
   * @returns {Unit} Returns a clone of the unit with a fixed prefix and unit.
   */ Unit.prototype.to = function(valuelessUnit) {
        var value = this.value === null ? this._normalize(1) : this.value;
        var other;
        if (typeof valuelessUnit === "string") other = Unit.parse(valuelessUnit);
        else if ((0, $23cfe017d190638f$export$8960dc335987b8da)(valuelessUnit)) other = valuelessUnit.clone();
        else throw new Error("String or Unit expected as parameter");
        if (!this.equalBase(other)) throw new Error("Units do not match ('".concat(other.toString(), "' != '").concat(this.toString(), "')"));
        if (other.value !== null) throw new Error("Cannot convert to a unit with a value");
        if (this.value === null || this._isDerived() || this.units.length === 0 || other.units.length === 0 || this.units[0].unit.offset === other.units[0].unit.offset) other.value = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(value);
        else {
            /* Need to adjust value by difference in offset to convert */ var convert = Unit._getNumberConverter((0, $23cfe017d190638f$export$f5bbd400c2f4426f)(value)); // convert to Fraction or BigNumber if needed
            var thisUnitValue = this.units[0].unit.value;
            var thisNominalOffset = this.units[0].unit.offset;
            var thisUnitOffset = multiplyScalar(thisUnitValue, thisNominalOffset);
            var otherUnitValue = other.units[0].unit.value;
            var otherNominalOffset = other.units[0].unit.offset;
            var otherUnitOffset = multiplyScalar(otherUnitValue, otherNominalOffset);
            other.value = addScalar(value, convert(subtractScalar(thisUnitOffset, otherUnitOffset)));
        }
        other.fixPrefix = true;
        other.skipAutomaticSimplification = true;
        return other;
    };
    /**
   * Return the value of the unit when represented with given valueless unit
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number} Returns the unit value as number.
   */ // TODO: deprecate Unit.toNumber? It's always better to use toNumeric
    Unit.prototype.toNumber = function(valuelessUnit) {
        return toNumber(this.toNumeric(valuelessUnit));
    };
    /**
   * Return the value of the unit in the original numeric type
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number | BigNumber | Fraction} Returns the unit value
   */ Unit.prototype.toNumeric = function(valuelessUnit) {
        var other;
        if (valuelessUnit) // Allow getting the numeric value without converting to a different unit
        other = this.to(valuelessUnit);
        else other = this.clone();
        if (other._isDerived() || other.units.length === 0) return other._denormalize(other.value);
        else return other._denormalize(other.value, other.units[0].prefix.value);
    };
    /**
   * Get a string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the unit
   * @memberof Unit
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   */ Unit.prototype.toJSON = function() {
        return {
            mathjs: "Unit",
            value: this._denormalize(this.value),
            unit: this.units.length > 0 ? this.formatUnits() : null,
            fixPrefix: this.fixPrefix
        };
    };
    /**
   * Instantiate a Unit from a JSON object
   * @memberof Unit
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   * @return {Unit}
   */ Unit.fromJSON = function(json) {
        var _json$unit;
        var unit = new Unit(json.value, (_json$unit = json.unit) !== null && _json$unit !== void 0 ? _json$unit : undefined);
        unit.fixPrefix = json.fixPrefix || false;
        return unit;
    };
    /**
   * Returns the string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.valueOf = Unit.prototype.toString;
    /**
   * Simplify this Unit's unit list and return a new Unit with the simplified list.
   * The returned Unit will contain a list of the "best" units for formatting.
   */ Unit.prototype.simplify = function() {
        var ret = this.clone();
        var proposedUnitList = [];
        // Search for a matching base
        var matchingBase;
        for(var key in currentUnitSystem){
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(currentUnitSystem, key)) {
                if (ret.hasBase(BASE_UNITS[key])) {
                    matchingBase = key;
                    break;
                }
            }
        }
        if (matchingBase === "NONE") ret.units = [];
        else {
            var matchingUnit;
            if (matchingBase) // Does the unit system have a matching unit?
            {
                if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(currentUnitSystem, matchingBase)) matchingUnit = currentUnitSystem[matchingBase];
            }
            if (matchingUnit) ret.units = [
                {
                    unit: matchingUnit.unit,
                    prefix: matchingUnit.prefix,
                    power: 1.0
                }
            ];
            else {
                // Multiple units or units with powers are formatted like this:
                // 5 (kg m^2) / (s^3 mol)
                // Build an representation from the base units of the current unit system
                var missingBaseDim = false;
                for(var i = 0; i < BASE_DIMENSIONS.length; i++){
                    var baseDim = BASE_DIMENSIONS[i];
                    if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                        if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(currentUnitSystem, baseDim)) proposedUnitList.push({
                            unit: currentUnitSystem[baseDim].unit,
                            prefix: currentUnitSystem[baseDim].prefix,
                            power: ret.dimensions[i] || 0
                        });
                        else missingBaseDim = true;
                    }
                }
                // Is the proposed unit list "simpler" than the existing one?
                if (proposedUnitList.length < ret.units.length && !missingBaseDim) // Replace this unit list with the proposed list
                ret.units = proposedUnitList;
            }
        }
        return ret;
    };
    /**
   * Returns a new Unit in the SI system with the same value as this one
   */ Unit.prototype.toSI = function() {
        var ret = this.clone();
        var proposedUnitList = [];
        // Multiple units or units with powers are formatted like this:
        // 5 (kg m^2) / (s^3 mol)
        // Build an representation from the base units of the SI unit system
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            var baseDim = BASE_DIMENSIONS[i];
            if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(UNIT_SYSTEMS.si, baseDim)) proposedUnitList.push({
                    unit: UNIT_SYSTEMS.si[baseDim].unit,
                    prefix: UNIT_SYSTEMS.si[baseDim].prefix,
                    power: ret.dimensions[i] || 0
                });
                else throw new Error("Cannot express custom unit " + baseDim + " in SI units");
            }
        }
        // Replace this unit list with the proposed list
        ret.units = proposedUnitList;
        ret.fixPrefix = true;
        ret.skipAutomaticSimplification = true;
        if (this.value !== null) {
            ret.value = null;
            return this.to(ret);
        }
        return ret;
    };
    /**
   * Get a string representation of the units of this Unit, without the value. The unit list is formatted as-is without first being simplified.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.formatUnits = function() {
        var strNum = "";
        var strDen = "";
        var nNum = 0;
        var nDen = 0;
        for(var i = 0; i < this.units.length; i++){
            if (this.units[i].power > 0) {
                nNum++;
                strNum += " " + this.units[i].prefix.name + this.units[i].unit.name;
                if (Math.abs(this.units[i].power - 1.0) > 1e-15) strNum += "^" + this.units[i].power;
            } else if (this.units[i].power < 0) nDen++;
        }
        if (nDen > 0) {
            for(var _i4 = 0; _i4 < this.units.length; _i4++)if (this.units[_i4].power < 0) {
                if (nNum > 0) {
                    strDen += " " + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    if (Math.abs(this.units[_i4].power + 1.0) > 1e-15) strDen += "^" + -this.units[_i4].power;
                } else {
                    strDen += " " + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    strDen += "^" + this.units[_i4].power;
                }
            }
        }
        // Remove leading " "
        strNum = strNum.substr(1);
        strDen = strDen.substr(1);
        // Add parans for better copy/paste back into evaluate, for example, or for better pretty print formatting
        if (nNum > 1 && nDen > 0) strNum = "(" + strNum + ")";
        if (nDen > 1 && nNum > 0) strDen = "(" + strDen + ")";
        var str = strNum;
        if (nNum > 0 && nDen > 0) str += " / ";
        str += strDen;
        return str;
    };
    /**
   * Get a string representation of the Unit, with optional formatting options.
   * @memberof Unit
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string}
   */ Unit.prototype.format = function(options) {
        // Simplfy the unit list, unless it is valueless or was created directly in the
        // constructor or as the result of to or toSI
        var simp = this.skipAutomaticSimplification || this.value === null ? this.clone() : this.simplify();
        // Apply some custom logic for handling VA and VAR. The goal is to express the value of the unit as a real value, if possible. Otherwise, use a real-valued unit instead of a complex-valued one.
        var isImaginary = false;
        if (typeof simp.value !== "undefined" && simp.value !== null && (0, $23cfe017d190638f$export$8849a896711efe0c)(simp.value)) // TODO: Make this better, for example, use relative magnitude of re and im rather than absolute
        isImaginary = Math.abs(simp.value.re) < 1e-14;
        for(var i in simp.units){
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(simp.units, i)) {
                if (simp.units[i].unit) {
                    if (simp.units[i].unit.name === "VA" && isImaginary) simp.units[i].unit = UNITS.VAR;
                    else if (simp.units[i].unit.name === "VAR" && !isImaginary) simp.units[i].unit = UNITS.VA;
                }
            }
        }
        // Now apply the best prefix
        // Units must have only one unit and not have the fixPrefix flag set
        if (simp.units.length === 1 && !simp.fixPrefix) // Units must have integer powers, otherwise the prefix will change the
        // outputted value by not-an-integer-power-of-ten
        {
            if (Math.abs(simp.units[0].power - Math.round(simp.units[0].power)) < 1e-14) // Apply the best prefix
            simp.units[0].prefix = simp._bestPrefix();
        }
        var value = simp._denormalize(simp.value);
        var str = simp.value !== null ? format(value, options || {}) : "";
        var unitStr = simp.formatUnits();
        if (simp.value && (0, $23cfe017d190638f$export$8849a896711efe0c)(simp.value)) str = "(" + str + ")"; // Surround complex values with ( ) to enable better parsing
        if (unitStr.length > 0 && str.length > 0) str += " ";
        str += unitStr;
        return str;
    };
    /**
   * Calculate the best prefix using current value.
   * @memberof Unit
   * @returns {Object} prefix
   * @private
   */ Unit.prototype._bestPrefix = function() {
        if (this.units.length !== 1) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
        if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
        // find the best prefix value (resulting in the value of which
        // the absolute value of the log10 is closest to zero,
        // though with a little offset of 1.2 for nicer values: you get a
        // sequence 1mm 100mm 500mm 0.6m 1m 10m 100m 500m 0.6km 1km ...
        // Note: the units value can be any numeric type, but to find the best
        // prefix it's enough to work with limited precision of a regular number
        // Update: using mathjs abs since we also allow complex numbers
        var absValue = this.value !== null ? abs(this.value) : 0;
        var absUnitValue = abs(this.units[0].unit.value);
        var bestPrefix = this.units[0].prefix;
        if (absValue === 0) return bestPrefix;
        var power = this.units[0].power;
        var bestDiff = Math.log(absValue / Math.pow(bestPrefix.value * absUnitValue, power)) / Math.LN10 - 1.2;
        if (bestDiff > -2.200001 && bestDiff < 1.800001) return bestPrefix; // Allow the original prefix
        bestDiff = Math.abs(bestDiff);
        var prefixes = this.units[0].unit.prefixes;
        for(var p in prefixes)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(prefixes, p)) {
            var prefix = prefixes[p];
            if (prefix.scientific) {
                var diff = Math.abs(Math.log(absValue / Math.pow(prefix.value * absUnitValue, power)) / Math.LN10 - 1.2);
                if (diff < bestDiff || diff === bestDiff && prefix.name.length < bestPrefix.name.length) {
                    // choose the prefix with the smallest diff, or if equal, choose the one
                    // with the shortest name (can happen with SHORTLONG for example)
                    bestPrefix = prefix;
                    bestDiff = diff;
                }
            }
        }
        return bestPrefix;
    };
    /**
   * Returns an array of units whose sum is equal to this unit
   * @memberof Unit
   * @param {Array} [parts] An array of strings or valueless units.
   *
   *   Example:
   *
   *   const u = new Unit(1, 'm')
   *   u.splitUnit(['feet', 'inch'])
   *     [ 3 feet, 3.3700787401575 inch ]
   *
   * @return {Array} An array of units.
   */ Unit.prototype.splitUnit = function(parts) {
        var x = this.clone();
        var ret = [];
        for(var i = 0; i < parts.length; i++){
            // Convert x to the requested unit
            x = x.to(parts[i]);
            if (i === parts.length - 1) break;
            // Get the numeric value of this unit
            var xNumeric = x.toNumeric();
            // Check to see if xNumeric is nearly equal to an integer,
            // since fix can incorrectly round down if there is round-off error
            var xRounded = round(xNumeric);
            var xFixed = void 0;
            var isNearlyEqual = equal(xRounded, xNumeric);
            if (isNearlyEqual) xFixed = xRounded;
            else xFixed = fix(x.toNumeric());
            var y = new Unit(xFixed, parts[i].toString());
            ret.push(y);
            x = subtractScalar(x, y);
        }
        // This little bit fixes a bug where the remainder should be 0 but is a little bit off.
        // But instead of comparing x, the remainder, with zero--we will compare the sum of
        // all the parts so far with the original value. If they are nearly equal,
        // we set the remainder to 0.
        var testSum = 0;
        for(var _i5 = 0; _i5 < ret.length; _i5++)testSum = addScalar(testSum, ret[_i5].value);
        if (equal(testSum, this.value)) x.value = 0;
        ret.push(x);
        return ret;
    };
    var PREFIXES = {
        NONE: {
            "": {
                name: "",
                value: 1,
                scientific: true
            }
        },
        SHORT: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e1,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e2,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e3,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e6,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e9,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e12,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e15,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e18,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e21,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e24,
                scientific: true
            },
            R: {
                name: "R",
                value: 1e27,
                scientific: true
            },
            Q: {
                name: "Q",
                value: 1e30,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-1,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-2,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-3,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-6,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-9,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-12,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-15,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-18,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-21,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-24,
                scientific: true
            },
            r: {
                name: "r",
                value: 1e-27,
                scientific: true
            },
            q: {
                name: "q",
                value: 1e-30,
                scientific: true
            }
        },
        LONG: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            deca: {
                name: "deca",
                value: 1e1,
                scientific: false
            },
            hecto: {
                name: "hecto",
                value: 1e2,
                scientific: false
            },
            kilo: {
                name: "kilo",
                value: 1e3,
                scientific: true
            },
            mega: {
                name: "mega",
                value: 1e6,
                scientific: true
            },
            giga: {
                name: "giga",
                value: 1e9,
                scientific: true
            },
            tera: {
                name: "tera",
                value: 1e12,
                scientific: true
            },
            peta: {
                name: "peta",
                value: 1e15,
                scientific: true
            },
            exa: {
                name: "exa",
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: "zetta",
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: "yotta",
                value: 1e24,
                scientific: true
            },
            ronna: {
                name: "ronna",
                value: 1e27,
                scientific: true
            },
            quetta: {
                name: "quetta",
                value: 1e30,
                scientific: true
            },
            deci: {
                name: "deci",
                value: 1e-1,
                scientific: false
            },
            centi: {
                name: "centi",
                value: 1e-2,
                scientific: false
            },
            milli: {
                name: "milli",
                value: 1e-3,
                scientific: true
            },
            micro: {
                name: "micro",
                value: 1e-6,
                scientific: true
            },
            nano: {
                name: "nano",
                value: 1e-9,
                scientific: true
            },
            pico: {
                name: "pico",
                value: 1e-12,
                scientific: true
            },
            femto: {
                name: "femto",
                value: 1e-15,
                scientific: true
            },
            atto: {
                name: "atto",
                value: 1e-18,
                scientific: true
            },
            zepto: {
                name: "zepto",
                value: 1e-21,
                scientific: true
            },
            yocto: {
                name: "yocto",
                value: 1e-24,
                scientific: true
            },
            ronto: {
                name: "ronto",
                value: 1e-27,
                scientific: true
            },
            quecto: {
                name: "quecto",
                value: 1e-30,
                scientific: true
            }
        },
        SQUARED: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e2,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e4,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e6,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e12,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e18,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e24,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e30,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e36,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e42,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e48,
                scientific: true
            },
            R: {
                name: "R",
                value: 1e54,
                scientific: true
            },
            Q: {
                name: "Q",
                value: 1e60,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-2,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-4,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-6,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-12,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-18,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-24,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-30,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-36,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-42,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-48,
                scientific: true
            },
            r: {
                name: "r",
                value: 1e-54,
                scientific: true
            },
            q: {
                name: "q",
                value: 1e-60,
                scientific: true
            }
        },
        CUBIC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e3,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e6,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e9,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e18,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e27,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e36,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e45,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e54,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e63,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e72,
                scientific: true
            },
            R: {
                name: "R",
                value: 1e81,
                scientific: true
            },
            Q: {
                name: "Q",
                value: 1e90,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-3,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-6,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-9,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-18,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-27,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-36,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-45,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-54,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-63,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-72,
                scientific: true
            },
            r: {
                name: "r",
                value: 1e-81,
                scientific: true
            },
            q: {
                name: "q",
                value: 1e-90,
                scientific: true
            }
        },
        BINARY_SHORT_SI: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            k: {
                name: "k",
                value: 1e3,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e6,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e9,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e12,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e15,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e18,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e21,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e24,
                scientific: true
            }
        },
        BINARY_SHORT_IEC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            Ki: {
                name: "Ki",
                value: 1024,
                scientific: true
            },
            Mi: {
                name: "Mi",
                value: Math.pow(1024, 2),
                scientific: true
            },
            Gi: {
                name: "Gi",
                value: Math.pow(1024, 3),
                scientific: true
            },
            Ti: {
                name: "Ti",
                value: Math.pow(1024, 4),
                scientific: true
            },
            Pi: {
                name: "Pi",
                value: Math.pow(1024, 5),
                scientific: true
            },
            Ei: {
                name: "Ei",
                value: Math.pow(1024, 6),
                scientific: true
            },
            Zi: {
                name: "Zi",
                value: Math.pow(1024, 7),
                scientific: true
            },
            Yi: {
                name: "Yi",
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BINARY_LONG_SI: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            kilo: {
                name: "kilo",
                value: 1e3,
                scientific: true
            },
            mega: {
                name: "mega",
                value: 1e6,
                scientific: true
            },
            giga: {
                name: "giga",
                value: 1e9,
                scientific: true
            },
            tera: {
                name: "tera",
                value: 1e12,
                scientific: true
            },
            peta: {
                name: "peta",
                value: 1e15,
                scientific: true
            },
            exa: {
                name: "exa",
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: "zetta",
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: "yotta",
                value: 1e24,
                scientific: true
            }
        },
        BINARY_LONG_IEC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            kibi: {
                name: "kibi",
                value: 1024,
                scientific: true
            },
            mebi: {
                name: "mebi",
                value: Math.pow(1024, 2),
                scientific: true
            },
            gibi: {
                name: "gibi",
                value: Math.pow(1024, 3),
                scientific: true
            },
            tebi: {
                name: "tebi",
                value: Math.pow(1024, 4),
                scientific: true
            },
            pebi: {
                name: "pebi",
                value: Math.pow(1024, 5),
                scientific: true
            },
            exi: {
                name: "exi",
                value: Math.pow(1024, 6),
                scientific: true
            },
            zebi: {
                name: "zebi",
                value: Math.pow(1024, 7),
                scientific: true
            },
            yobi: {
                name: "yobi",
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BTU: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            MM: {
                name: "MM",
                value: 1e6,
                scientific: true
            }
        }
    };
    PREFIXES.SHORTLONG = (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))({}, PREFIXES.SHORT, PREFIXES.LONG);
    PREFIXES.BINARY_SHORT = (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))({}, PREFIXES.BINARY_SHORT_SI, PREFIXES.BINARY_SHORT_IEC);
    PREFIXES.BINARY_LONG = (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))({}, PREFIXES.BINARY_LONG_SI, PREFIXES.BINARY_LONG_IEC);
    /* Internally, each unit is represented by a value and a dimension array. The elements of the dimensions array have the following meaning:
   * Index  Dimension
   * -----  ---------
   *   0    Length
   *   1    Mass
   *   2    Time
   *   3    Current
   *   4    Temperature
   *   5    Luminous intensity
   *   6    Amount of substance
   *   7    Angle
   *   8    Bit (digital)
   * For example, the unit "298.15 K" is a pure temperature and would have a value of 298.15 and a dimension array of [0, 0, 0, 0, 1, 0, 0, 0, 0]. The unit "1 cal / (gm °C)" can be written in terms of the 9 fundamental dimensions as [length^2] / ([time^2] * [temperature]), and would a value of (after conversion to SI) 4184.0 and a dimensions array of [2, 0, -2, 0, -1, 0, 0, 0, 0].
   *
   */ var BASE_DIMENSIONS = [
        "MASS",
        "LENGTH",
        "TIME",
        "CURRENT",
        "TEMPERATURE",
        "LUMINOUS_INTENSITY",
        "AMOUNT_OF_SUBSTANCE",
        "ANGLE",
        "BIT"
    ];
    var BASE_UNITS = {
        NONE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MASS: {
            dimensions: [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        LENGTH: {
            dimensions: [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TIME: {
            dimensions: [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        CURRENT: {
            dimensions: [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TEMPERATURE: {
            dimensions: [
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0
            ]
        },
        LUMINOUS_INTENSITY: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0
            ]
        },
        AMOUNT_OF_SUBSTANCE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0
            ]
        },
        FORCE: {
            dimensions: [
                1,
                1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        SURFACE: {
            dimensions: [
                0,
                2,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        VOLUME: {
            dimensions: [
                0,
                3,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ENERGY: {
            dimensions: [
                1,
                2,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        POWER: {
            dimensions: [
                1,
                2,
                -3,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        PRESSURE: {
            dimensions: [
                1,
                -1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CHARGE: {
            dimensions: [
                0,
                0,
                1,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CAPACITANCE: {
            dimensions: [
                -1,
                -2,
                4,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_POTENTIAL: {
            dimensions: [
                1,
                2,
                -3,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_RESISTANCE: {
            dimensions: [
                1,
                2,
                -3,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_INDUCTANCE: {
            dimensions: [
                1,
                2,
                -2,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CONDUCTANCE: {
            dimensions: [
                -1,
                -2,
                3,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX: {
            dimensions: [
                1,
                2,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX_DENSITY: {
            dimensions: [
                1,
                0,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        FREQUENCY: {
            dimensions: [
                0,
                0,
                -1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ANGLE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]
        },
        BIT: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ]
        }
    };
    for(var key in BASE_UNITS)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(BASE_UNITS, key)) BASE_UNITS[key].key = key;
    var BASE_UNIT_NONE = {};
    var UNIT_NONE = {
        name: "",
        base: BASE_UNIT_NONE,
        value: 1,
        offset: 0,
        dimensions: BASE_DIMENSIONS.map((x)=>0)
    };
    var UNITS = {
        // length
        meter: {
            name: "meter",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        inch: {
            name: "inch",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        foot: {
            name: "foot",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yard: {
            name: "yard",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mile: {
            name: "mile",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        link: {
            name: "link",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rod: {
            name: "rod",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.0292,
            offset: 0
        },
        chain: {
            name: "chain",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        angstrom: {
            name: "angstrom",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1e-10,
            offset: 0
        },
        m: {
            name: "m",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        in: {
            name: "in",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        ft: {
            name: "ft",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yd: {
            name: "yd",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mi: {
            name: "mi",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        li: {
            name: "li",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rd: {
            name: "rd",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.029210,
            offset: 0
        },
        ch: {
            name: "ch",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        mil: {
            name: "mil",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0000254,
            offset: 0
        },
        // 1/1000 inch
        // Surface
        m2: {
            name: "m2",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.SQUARED,
            value: 1,
            offset: 0
        },
        sqin: {
            name: "sqin",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.00064516,
            offset: 0
        },
        // 645.16 mm2
        sqft: {
            name: "sqft",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.09290304,
            offset: 0
        },
        // 0.09290304 m2
        sqyd: {
            name: "sqyd",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.83612736,
            offset: 0
        },
        // 0.83612736 m2
        sqmi: {
            name: "sqmi",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 2589988.110336,
            offset: 0
        },
        // 2.589988110336 km2
        sqrd: {
            name: "sqrd",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 25.29295,
            offset: 0
        },
        // 25.29295 m2
        sqch: {
            name: "sqch",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 404.6873,
            offset: 0
        },
        // 404.6873 m2
        sqmil: {
            name: "sqmil",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 6.4516e-10,
            offset: 0
        },
        // 6.4516 * 10^-10 m2
        acre: {
            name: "acre",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 4046.86,
            offset: 0
        },
        // 4046.86 m2
        hectare: {
            name: "hectare",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 10000,
            offset: 0
        },
        // 10000 m2
        // Volume
        m3: {
            name: "m3",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.CUBIC,
            value: 1,
            offset: 0
        },
        L: {
            name: "L",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        l: {
            name: "l",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        litre: {
            name: "litre",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        cuin: {
            name: "cuin",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1.6387064e-5,
            offset: 0
        },
        // 1.6387064e-5 m3
        cuft: {
            name: "cuft",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.028316846592,
            offset: 0
        },
        // 28.316 846 592 L
        cuyd: {
            name: "cuyd",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.764554857984,
            offset: 0
        },
        // 764.554 857 984 L
        teaspoon: {
            name: "teaspoon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000005,
            offset: 0
        },
        // 5 mL
        tablespoon: {
            name: "tablespoon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000015,
            offset: 0
        },
        // 15 mL
        // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
        drop: {
            name: "drop",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        gtt: {
            name: "gtt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        // Liquid volume
        minim: {
            name: "minim",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000000061611519921875,
            offset: 0
        },
        // 1/61440 gallons
        fluiddram: {
            name: "fluiddram",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911953125,
            offset: 0
        },
        // 1/1024 gallons
        fluidounce: {
            name: "fluidounce",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000295735295625,
            offset: 0
        },
        // 1/128 gallons
        gill: {
            name: "gill",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00011829411825,
            offset: 0
        },
        // 1/32 gallons
        cc: {
            name: "cc",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1e-6,
            offset: 0
        },
        // 1e-6 L
        cup: {
            name: "cup",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882365,
            offset: 0
        },
        // 1/16 gallons
        pint: {
            name: "pint",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000473176473,
            offset: 0
        },
        // 1/8 gallons
        quart: {
            name: "quart",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000946352946,
            offset: 0
        },
        // 1/4 gallons
        gallon: {
            name: "gallon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785411784,
            offset: 0
        },
        // 3.785411784 L
        beerbarrel: {
            name: "beerbarrel",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.117347765304,
            offset: 0
        },
        // 31 gallons
        oilbarrel: {
            name: "oilbarrel",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.158987294928,
            offset: 0
        },
        // 42 gallons
        hogshead: {
            name: "hogshead",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.238480942392,
            offset: 0
        },
        // 63 gallons
        // Mass
        g: {
            name: "g",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        gram: {
            name: "gram",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        ton: {
            name: "ton",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 907.18474,
            offset: 0
        },
        t: {
            name: "t",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 1000,
            offset: 0
        },
        tonne: {
            name: "tonne",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 1000,
            offset: 0
        },
        grain: {
            name: "grain",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dram: {
            name: "dram",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        ounce: {
            name: "ounce",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        poundmass: {
            name: "poundmass",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        hundredweight: {
            name: "hundredweight",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        stick: {
            name: "stick",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 115e-3,
            offset: 0
        },
        stone: {
            name: "stone",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 6.35029318,
            offset: 0
        },
        gr: {
            name: "gr",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dr: {
            name: "dr",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        oz: {
            name: "oz",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        lbm: {
            name: "lbm",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        cwt: {
            name: "cwt",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        // Time
        s: {
            name: "s",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        min: {
            name: "min",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        h: {
            name: "h",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        second: {
            name: "second",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        sec: {
            name: "sec",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        minute: {
            name: "minute",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        hour: {
            name: "hour",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        day: {
            name: "day",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 86400,
            offset: 0
        },
        week: {
            name: "week",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 604800,
            offset: 0
        },
        month: {
            name: "month",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 2629800,
            // 1/12th of Julian year
            offset: 0
        },
        year: {
            name: "year",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600,
            // Julian year
            offset: 0
        },
        decade: {
            name: "decade",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 315576000,
            // Julian decade
            offset: 0
        },
        century: {
            name: "century",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3155760000,
            // Julian century
            offset: 0
        },
        millennium: {
            name: "millennium",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600000,
            // Julian millennium
            offset: 0
        },
        // Frequency
        hertz: {
            name: "Hertz",
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        Hz: {
            name: "Hz",
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        // Angle
        rad: {
            name: "rad",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        radian: {
            name: "radian",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
        deg: {
            name: "deg",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        degree: {
            name: "degree",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
        grad: {
            name: "grad",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        gradian: {
            name: "gradian",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
        cycle: {
            name: "cycle",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
        arcsec: {
            name: "arcsec",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
        arcmin: {
            name: "arcmin",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // Electric current
        A: {
            name: "A",
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        ampere: {
            name: "ampere",
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // Temperature
        // K(C) = °C + 273.15
        // K(F) = (°F + 459.67) * (5 / 9)
        // K(R) = °R * (5 / 9)
        K: {
            name: "K",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        degC: {
            name: "degC",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 273.15
        },
        degF: {
            name: "degF",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.SHORT,
            value: new _Fraction(5, 9),
            offset: 459.67
        },
        degR: {
            name: "degR",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.SHORT,
            value: new _Fraction(5, 9),
            offset: 0
        },
        kelvin: {
            name: "kelvin",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        celsius: {
            name: "celsius",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 273.15
        },
        fahrenheit: {
            name: "fahrenheit",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.LONG,
            value: new _Fraction(5, 9),
            offset: 459.67
        },
        rankine: {
            name: "rankine",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.LONG,
            value: new _Fraction(5, 9),
            offset: 0
        },
        // amount of substance
        mol: {
            name: "mol",
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        mole: {
            name: "mole",
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // luminous intensity
        cd: {
            name: "cd",
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        candela: {
            name: "candela",
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // TODO: units STERADIAN
        // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // Force
        N: {
            name: "N",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        newton: {
            name: "newton",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        dyn: {
            name: "dyn",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 0.00001,
            offset: 0
        },
        dyne: {
            name: "dyne",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 0.00001,
            offset: 0
        },
        lbf: {
            name: "lbf",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        poundforce: {
            name: "poundforce",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        kip: {
            name: "kip",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 4448.2216,
            offset: 0
        },
        kilogramforce: {
            name: "kilogramforce",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        // Energy
        J: {
            name: "J",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        joule: {
            name: "joule",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        erg: {
            name: "erg",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORTLONG,
            // Both kiloerg and kerg are acceptable
            value: 1e-7,
            offset: 0
        },
        Wh: {
            name: "Wh",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 3600,
            offset: 0
        },
        BTU: {
            name: "BTU",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.BTU,
            value: 1055.05585262,
            offset: 0
        },
        eV: {
            name: "eV",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1.602176565e-19,
            offset: 0
        },
        electronvolt: {
            name: "electronvolt",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.LONG,
            value: 1.602176565e-19,
            offset: 0
        },
        // Power
        W: {
            name: "W",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        watt: {
            name: "watt",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        hp: {
            name: "hp",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.NONE,
            value: 745.6998715386,
            offset: 0
        },
        // Electrical power units
        VAR: {
            name: "VAR",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: Complex.I,
            offset: 0
        },
        VA: {
            name: "VA",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Pressure
        Pa: {
            name: "Pa",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        psi: {
            name: "psi",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 6894.75729276459,
            offset: 0
        },
        atm: {
            name: "atm",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 101325,
            offset: 0
        },
        bar: {
            name: "bar",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORTLONG,
            value: 100000,
            offset: 0
        },
        torr: {
            name: "torr",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmHg: {
            name: "mmHg",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmH2O: {
            name: "mmH2O",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        cmH2O: {
            name: "cmH2O",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 98.0665,
            offset: 0
        },
        // Electric charge
        coulomb: {
            name: "coulomb",
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        C: {
            name: "C",
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric capacitance
        farad: {
            name: "farad",
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        F: {
            name: "F",
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric potential
        volt: {
            name: "volt",
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        V: {
            name: "V",
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric resistance
        ohm: {
            name: "ohm",
            base: BASE_UNITS.ELECTRIC_RESISTANCE,
            prefixes: PREFIXES.SHORTLONG,
            // Both Mohm and megaohm are acceptable
            value: 1,
            offset: 0
        },
        /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */ // Electric inductance
        henry: {
            name: "henry",
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        H: {
            name: "H",
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric conductance
        siemens: {
            name: "siemens",
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        S: {
            name: "S",
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux
        weber: {
            name: "weber",
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        Wb: {
            name: "Wb",
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux density
        tesla: {
            name: "tesla",
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        T: {
            name: "T",
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Binary
        b: {
            name: "b",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 1,
            offset: 0
        },
        bits: {
            name: "bits",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 1,
            offset: 0
        },
        B: {
            name: "B",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 8,
            offset: 0
        },
        bytes: {
            name: "bytes",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 8,
            offset: 0
        }
    };
    // aliases (formerly plurals)
    // note that ALIASES is only used at creation to create more entries in UNITS by copying the aliased units
    var ALIASES = {
        meters: "meter",
        inches: "inch",
        feet: "foot",
        yards: "yard",
        miles: "mile",
        links: "link",
        rods: "rod",
        chains: "chain",
        angstroms: "angstrom",
        lt: "l",
        litres: "litre",
        liter: "litre",
        liters: "litre",
        teaspoons: "teaspoon",
        tablespoons: "tablespoon",
        minims: "minim",
        fldr: "fluiddram",
        fluiddrams: "fluiddram",
        floz: "fluidounce",
        fluidounces: "fluidounce",
        gi: "gill",
        gills: "gill",
        cp: "cup",
        cups: "cup",
        pt: "pint",
        pints: "pint",
        qt: "quart",
        quarts: "quart",
        gal: "gallon",
        gallons: "gallon",
        bbl: "beerbarrel",
        beerbarrels: "beerbarrel",
        obl: "oilbarrel",
        oilbarrels: "oilbarrel",
        hogsheads: "hogshead",
        gtts: "gtt",
        grams: "gram",
        tons: "ton",
        tonnes: "tonne",
        grains: "grain",
        drams: "dram",
        ounces: "ounce",
        poundmasses: "poundmass",
        hundredweights: "hundredweight",
        sticks: "stick",
        lb: "lbm",
        lbs: "lbm",
        kips: "kip",
        kgf: "kilogramforce",
        acres: "acre",
        hectares: "hectare",
        sqfeet: "sqft",
        sqyard: "sqyd",
        sqmile: "sqmi",
        sqmiles: "sqmi",
        mmhg: "mmHg",
        mmh2o: "mmH2O",
        cmh2o: "cmH2O",
        seconds: "second",
        secs: "second",
        minutes: "minute",
        mins: "minute",
        hours: "hour",
        hr: "hour",
        hrs: "hour",
        days: "day",
        weeks: "week",
        months: "month",
        years: "year",
        decades: "decade",
        centuries: "century",
        millennia: "millennium",
        hertz: "hertz",
        radians: "radian",
        degrees: "degree",
        gradians: "gradian",
        cycles: "cycle",
        arcsecond: "arcsec",
        arcseconds: "arcsec",
        arcminute: "arcmin",
        arcminutes: "arcmin",
        BTUs: "BTU",
        watts: "watt",
        joules: "joule",
        amperes: "ampere",
        amps: "ampere",
        amp: "ampere",
        coulombs: "coulomb",
        volts: "volt",
        ohms: "ohm",
        farads: "farad",
        webers: "weber",
        teslas: "tesla",
        electronvolts: "electronvolt",
        moles: "mole",
        bit: "bits",
        byte: "bytes"
    };
    /**
   * Calculate the values for the angle units.
   * Value is calculated as number or BigNumber depending on the configuration
   * @param {{number: 'number' | 'BigNumber'}} config
   */ function calculateAngleValues(config) {
        if (config.number === "BigNumber") {
            var pi = (0, $b74557deecba29f4$export$d0a8190d955e3c5b)(_BigNumber);
            UNITS.rad.value = new _BigNumber(1);
            UNITS.deg.value = pi.div(180); // 2 * pi / 360
            UNITS.grad.value = pi.div(200); // 2 * pi / 400
            UNITS.cycle.value = pi.times(2); // 2 * pi
            UNITS.arcsec.value = pi.div(648000); // 2 * pi / 360 / 3600
            UNITS.arcmin.value = pi.div(10800); // 2 * pi / 360 / 60
        } else {
            // number
            UNITS.rad.value = 1;
            UNITS.deg.value = Math.PI / 180; // 2 * pi / 360
            UNITS.grad.value = Math.PI / 200; // 2 * pi / 400
            UNITS.cycle.value = Math.PI * 2; // 2 * pi
            UNITS.arcsec.value = Math.PI / 648000; // 2 * pi / 360 / 3600
            UNITS.arcmin.value = Math.PI / 10800; // 2 * pi / 360 / 60
        }
        // copy to the full names of the angles
        UNITS.radian.value = UNITS.rad.value;
        UNITS.degree.value = UNITS.deg.value;
        UNITS.gradian.value = UNITS.grad.value;
    }
    // apply the angle values now
    calculateAngleValues(config);
    if (on) // recalculate the values on change of configuration
    on("config", function(curr, prev) {
        if (curr.number !== prev.number) calculateAngleValues(curr);
    });
    /**
   * A unit system is a set of dimensionally independent base units plus a set of derived units, formed by multiplication and division of the base units, that are by convention used with the unit system.
   * A user perhaps could issue a command to select a preferred unit system, or use the default (see below).
   * Auto unit system: The default unit system is updated on the fly anytime a unit is parsed. The corresponding unit in the default unit system is updated, so that answers are given in the same units the user supplies.
   */ var UNIT_SYSTEMS = {
        si: {
            // Base units
            NONE: {
                unit: UNIT_NONE,
                prefix: PREFIXES.NONE[""]
            },
            LENGTH: {
                unit: UNITS.m,
                prefix: PREFIXES.SHORT[""]
            },
            MASS: {
                unit: UNITS.g,
                prefix: PREFIXES.SHORT.k
            },
            TIME: {
                unit: UNITS.s,
                prefix: PREFIXES.SHORT[""]
            },
            CURRENT: {
                unit: UNITS.A,
                prefix: PREFIXES.SHORT[""]
            },
            TEMPERATURE: {
                unit: UNITS.K,
                prefix: PREFIXES.SHORT[""]
            },
            LUMINOUS_INTENSITY: {
                unit: UNITS.cd,
                prefix: PREFIXES.SHORT[""]
            },
            AMOUNT_OF_SUBSTANCE: {
                unit: UNITS.mol,
                prefix: PREFIXES.SHORT[""]
            },
            ANGLE: {
                unit: UNITS.rad,
                prefix: PREFIXES.SHORT[""]
            },
            BIT: {
                unit: UNITS.bits,
                prefix: PREFIXES.SHORT[""]
            },
            // Derived units
            FORCE: {
                unit: UNITS.N,
                prefix: PREFIXES.SHORT[""]
            },
            ENERGY: {
                unit: UNITS.J,
                prefix: PREFIXES.SHORT[""]
            },
            POWER: {
                unit: UNITS.W,
                prefix: PREFIXES.SHORT[""]
            },
            PRESSURE: {
                unit: UNITS.Pa,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CHARGE: {
                unit: UNITS.C,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CAPACITANCE: {
                unit: UNITS.F,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_POTENTIAL: {
                unit: UNITS.V,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_RESISTANCE: {
                unit: UNITS.ohm,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_INDUCTANCE: {
                unit: UNITS.H,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CONDUCTANCE: {
                unit: UNITS.S,
                prefix: PREFIXES.SHORT[""]
            },
            MAGNETIC_FLUX: {
                unit: UNITS.Wb,
                prefix: PREFIXES.SHORT[""]
            },
            MAGNETIC_FLUX_DENSITY: {
                unit: UNITS.T,
                prefix: PREFIXES.SHORT[""]
            },
            FREQUENCY: {
                unit: UNITS.Hz,
                prefix: PREFIXES.SHORT[""]
            }
        }
    };
    // Clone to create the other unit systems
    UNIT_SYSTEMS.cgs = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.cgs.LENGTH = {
        unit: UNITS.m,
        prefix: PREFIXES.SHORT.c
    };
    UNIT_SYSTEMS.cgs.MASS = {
        unit: UNITS.g,
        prefix: PREFIXES.SHORT[""]
    };
    UNIT_SYSTEMS.cgs.FORCE = {
        unit: UNITS.dyn,
        prefix: PREFIXES.SHORT[""]
    };
    UNIT_SYSTEMS.cgs.ENERGY = {
        unit: UNITS.erg,
        prefix: PREFIXES.NONE[""]
    };
    // there are wholly 4 unique cgs systems for electricity and magnetism,
    // so let's not worry about it unless somebody complains
    UNIT_SYSTEMS.us = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.us.LENGTH = {
        unit: UNITS.ft,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.MASS = {
        unit: UNITS.lbm,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.TEMPERATURE = {
        unit: UNITS.degF,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.FORCE = {
        unit: UNITS.lbf,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.ENERGY = {
        unit: UNITS.BTU,
        prefix: PREFIXES.BTU[""]
    };
    UNIT_SYSTEMS.us.POWER = {
        unit: UNITS.hp,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.PRESSURE = {
        unit: UNITS.psi,
        prefix: PREFIXES.NONE[""]
    };
    // Add additional unit systems here.
    // Choose a unit system to seed the auto unit system.
    UNIT_SYSTEMS.auto = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    // Set the current unit system
    var currentUnitSystem = UNIT_SYSTEMS.auto;
    /**
   * Set a unit system for formatting derived units.
   * @memberof Unit
   * @param {string} [name] The name of the unit system.
   */ Unit.setUnitSystem = function(name) {
        if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(UNIT_SYSTEMS, name)) currentUnitSystem = UNIT_SYSTEMS[name];
        else throw new Error("Unit system " + name + " does not exist. Choices are: " + Object.keys(UNIT_SYSTEMS).join(", "));
    };
    /**
   * Return the current unit system.
   * @memberof Unit
   * @return {string} The current unit system.
   */ Unit.getUnitSystem = function() {
        for(var _key in UNIT_SYSTEMS)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(UNIT_SYSTEMS, _key)) {
            if (UNIT_SYSTEMS[_key] === currentUnitSystem) return _key;
        }
    };
    /**
   * Converters to convert from number to an other numeric type like BigNumber
   * or Fraction
   */ Unit.typeConverters = {
        BigNumber: function BigNumber(x) {
            if (x !== null && x !== void 0 && x.isFraction) return new _BigNumber(x.n).div(x.d).times(x.s);
            return new _BigNumber(x + ""); // stringify to prevent constructor error
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x);
        },
        Complex: function Complex(x) {
            return x;
        },
        number: function number(x) {
            if (x !== null && x !== void 0 && x.isFraction) return _number(x);
            return x;
        }
    };
    /**
   * Retrieve the right converter function corresponding with this unit's
   * value
   *
   * @memberof Unit
   * @return {Function}
   */ Unit.prototype._numberConverter = function() {
        var convert = Unit.typeConverters[this.valueType()];
        if (convert) return convert;
        throw new TypeError('Unsupported Unit value type "' + this.valueType() + '"');
    };
    /**
   * Retrieve the right convertor function corresponding with the type
   * of provided exampleValue.
   *
   * @param {string} type   A string 'number', 'BigNumber', or 'Fraction'
   *                        In case of an unknown type,
   * @return {Function}
   */ Unit._getNumberConverter = function(type) {
        if (!Unit.typeConverters[type]) throw new TypeError('Unsupported type "' + type + '"');
        return Unit.typeConverters[type];
    };
    // Add dimensions to each built-in unit
    for(var _key2 in UNITS)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(UNITS, _key2)) {
        var unit = UNITS[_key2];
        unit.dimensions = unit.base.dimensions;
    }
    // Create aliases
    for(var _name2 in ALIASES)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(ALIASES, _name2)) {
        var _unit2 = UNITS[ALIASES[_name2]];
        var alias = {};
        for(var _key3 in _unit2)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(_unit2, _key3)) alias[_key3] = _unit2[_key3];
        alias.name = _name2;
        UNITS[_name2] = alias;
    }
    /**
   * Checks if a character is a valid latin letter (upper or lower case).
   * Note that this function can be overridden, for example to allow support of other alphabets.
   * @memberof Unit
   * @param {string} c Tested character
   * @return {boolean} true if the character is a latin letter
   */ Unit.isValidAlpha = function isValidAlpha(c) {
        return /^[a-zA-Z]$/.test(c);
    };
    function assertUnitNameIsValid(name) {
        for(var i = 0; i < name.length; i++){
            c = name.charAt(i);
            if (i === 0 && !Unit.isValidAlpha(c)) throw new Error('Invalid unit name (must begin with alpha character): "' + name + '"');
            if (i > 0 && !(Unit.isValidAlpha(c) || isDigit(c))) throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + name + '"');
        }
    }
    /**
   * Wrapper around createUnitSingle.
   * Example:
   *  createUnit( {
   *     foo: {
   *       prefixes: 'long',
   *       baseName: 'essence-of-foo'
   *     },
   *     bar: '40 foo',
   *     baz: {
   *       definition: '1 bar/hour',
   *       prefixes: 'long'
   *     }
   *   },
   *   {
   *     override: true
   *   })
   * @memberof Unit
   * @param {object} obj      Object map. Each key becomes a unit which is defined by its value.
   * @param {object} options
   * @return {Unit} the last created unit
   */ Unit.createUnit = function(obj, options) {
        if (typeof obj !== "object") throw new TypeError("createUnit expects first parameter to be of type 'Object'");
        // Remove all units and aliases we are overriding
        if (options && options.override) for(var _key4 in obj){
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(obj, _key4)) Unit.deleteUnit(_key4);
            if (obj[_key4].aliases) for(var i = 0; i < obj[_key4].aliases.length; i++)Unit.deleteUnit(obj[_key4].aliases[i]);
        }
        // TODO: traverse multiple times until all units have been added
        var lastUnit;
        for(var _key5 in obj)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(obj, _key5)) lastUnit = Unit.createUnitSingle(_key5, obj[_key5]);
        return lastUnit;
    };
    /**
   * Create a user-defined unit and register it with the Unit type.
   * Example:
   *  createUnitSingle('knot', '0.514444444 m/s')
   *
   * @memberof Unit
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string | Unit | object} definition      Definition of the unit in terms
   * of existing units. For example, '0.514444444 m / s'. Can be a Unit, a string,
   * or an Object. If an Object, may have the following properties:
   *   - definition {string | Unit} The definition of this unit.
   *   - prefixes {string} "none", "short", "long", "binary_short", or "binary_long".
   *     The default is "none".
   *   - aliases {Array} Array of strings. Example: ['knots', 'kt', 'kts']
   *   - offset {Numeric} An offset to apply when converting from the unit. For
   *     example, the offset for celsius is 273.15 and the offset for farhenheit
   *     is 459.67. Default is 0.
   *   - baseName {string} If the unit's dimension does not match that of any other
   *     base unit, the name of the newly create base unit. Otherwise, this property
   *     has no effect.
   *
   * @return {Unit}
   */ Unit.createUnitSingle = function(name, obj) {
        if (typeof obj === "undefined" || obj === null) obj = {};
        if (typeof name !== "string") throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
        // Check collisions with existing units
        if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(UNITS, name)) throw new Error('Cannot create unit "' + name + '": a unit with that name already exists');
        // TODO: Validate name for collisions with other built-in functions (like abs or cos, for example), and for acceptable variable names. For example, '42' is probably not a valid unit. Nor is '%', since it is also an operator.
        assertUnitNameIsValid(name);
        var defUnit = null; // The Unit from which the new unit will be created.
        var aliases = [];
        var offset = 0;
        var definition;
        var prefixes;
        var baseName;
        if (obj && obj.type === "Unit") defUnit = obj.clone();
        else if (typeof obj === "string") {
            if (obj !== "") definition = obj;
        } else if (typeof obj === "object") {
            definition = obj.definition;
            prefixes = obj.prefixes;
            offset = obj.offset;
            baseName = obj.baseName;
            if (obj.aliases) aliases = obj.aliases.valueOf(); // aliases could be a Matrix, so convert to Array
        } else throw new TypeError('Cannot create unit "' + name + '" from "' + obj.toString() + '": expecting "string" or "Unit" or "Object"');
        if (aliases) for(var i = 0; i < aliases.length; i++){
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(UNITS, aliases[i])) throw new Error('Cannot create alias "' + aliases[i] + '": a unit with that name already exists');
        }
        if (definition && typeof definition === "string" && !defUnit) try {
            defUnit = Unit.parse(definition, {
                allowNoUnits: true
            });
        } catch (ex) {
            ex.message = 'Could not create unit "' + name + '" from "' + definition + '": ' + ex.message;
            throw ex;
        }
        else if (definition && definition.type === "Unit") defUnit = definition.clone();
        aliases = aliases || [];
        offset = offset || 0;
        if (prefixes && prefixes.toUpperCase) prefixes = PREFIXES[prefixes.toUpperCase()] || PREFIXES.NONE;
        else prefixes = PREFIXES.NONE;
        // If defUnit is null, it is because the user did not
        // specify a defintion. So create a new base dimension.
        var newUnit = {};
        if (!defUnit) {
            // Add a new base dimension
            baseName = baseName || name + "_STUFF"; // foo --> foo_STUFF, or the essence of foo
            if (BASE_DIMENSIONS.indexOf(baseName) >= 0) throw new Error('Cannot create new base unit "' + name + '": a base unit with that name already exists (and cannot be overridden)');
            BASE_DIMENSIONS.push(baseName);
            // Push 0 onto existing base units
            for(var b in BASE_UNITS)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(BASE_UNITS, b)) BASE_UNITS[b].dimensions[BASE_DIMENSIONS.length - 1] = 0;
            // Add the new base unit
            var newBaseUnit = {
                dimensions: []
            };
            for(var _i6 = 0; _i6 < BASE_DIMENSIONS.length; _i6++)newBaseUnit.dimensions[_i6] = 0;
            newBaseUnit.dimensions[BASE_DIMENSIONS.length - 1] = 1;
            newBaseUnit.key = baseName;
            BASE_UNITS[baseName] = newBaseUnit;
            newUnit = {
                name: name,
                value: 1,
                dimensions: BASE_UNITS[baseName].dimensions.slice(0),
                prefixes: prefixes,
                offset: offset,
                base: BASE_UNITS[baseName]
            };
            currentUnitSystem[baseName] = {
                unit: newUnit,
                prefix: PREFIXES.NONE[""]
            };
        } else {
            newUnit = {
                name: name,
                value: defUnit.value,
                dimensions: defUnit.dimensions.slice(0),
                prefixes: prefixes,
                offset: offset
            };
            // Create a new base if no matching base exists
            var anyMatch = false;
            for(var _i7 in BASE_UNITS)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(BASE_UNITS, _i7)) {
                var match = true;
                for(var j = 0; j < BASE_DIMENSIONS.length; j++)if (Math.abs((newUnit.dimensions[j] || 0) - (BASE_UNITS[_i7].dimensions[j] || 0)) > 1e-12) {
                    match = false;
                    break;
                }
                if (match) {
                    anyMatch = true;
                    newUnit.base = BASE_UNITS[_i7];
                    break;
                }
            }
            if (!anyMatch) {
                baseName = baseName || name + "_STUFF"; // foo --> foo_STUFF, or the essence of foo
                // Add the new base unit
                var _newBaseUnit = {
                    dimensions: defUnit.dimensions.slice(0)
                };
                _newBaseUnit.key = baseName;
                BASE_UNITS[baseName] = _newBaseUnit;
                currentUnitSystem[baseName] = {
                    unit: newUnit,
                    prefix: PREFIXES.NONE[""]
                };
                newUnit.base = BASE_UNITS[baseName];
            }
        }
        Unit.UNITS[name] = newUnit;
        for(var _i8 = 0; _i8 < aliases.length; _i8++){
            var aliasName = aliases[_i8];
            var _alias = {};
            for(var _key6 in newUnit)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(newUnit, _key6)) _alias[_key6] = newUnit[_key6];
            _alias.name = aliasName;
            Unit.UNITS[aliasName] = _alias;
        }
        // delete the memoization cache because we created a new unit
        delete _findUnit.cache;
        return new Unit(null, name);
    };
    Unit.deleteUnit = function(name) {
        delete Unit.UNITS[name];
        // delete the memoization cache because we deleted a unit
        delete _findUnit.cache;
    };
    // expose arrays with prefixes, dimensions, units, systems
    Unit.PREFIXES = PREFIXES;
    Unit.BASE_DIMENSIONS = BASE_DIMENSIONS;
    Unit.BASE_UNITS = BASE_UNITS;
    Unit.UNIT_SYSTEMS = UNIT_SYSTEMS;
    Unit.UNITS = UNITS;
    return Unit;
}, {
    isClass: true
});



var $dc7b520117824df4$var$name = "unit";
var $dc7b520117824df4$var$dependencies = [
    "typed",
    "Unit"
];
var $dc7b520117824df4$export$17074f98b69d2545 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($dc7b520117824df4$var$name, $dc7b520117824df4$var$dependencies, (_ref)=>{
    var { typed: typed, Unit: Unit } = _ref;
    /**
   * Create a unit. Depending on the passed arguments, the function
   * will create and return a new math.Unit object.
   * When a matrix is provided, all elements will be converted to units.
   *
   * Syntax:
   *
   *     math.unit(unit : string)
   *     math.unit(value : number, valuelessUnit : Unit)
   *     math.unit(value : number, valuelessUnit : string)
   *
   * Examples:
   *
   *    const kph = math.unit('km/h')   // returns Unit km/h (valueless)
   *    const v = math.unit(25, kph)    // returns Unit 25 km/h
   *    const a = math.unit(5, 'cm')    // returns Unit 50 mm
   *    const b = math.unit('23 kg')    // returns Unit 23 kg
   *    a.to('m')                       // returns Unit 0.05 m
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, string, createUnit
   *
   * @param {* | Array | Matrix} args   A number and unit.
   * @return {Unit | Array | Matrix}    The created unit
   */ return typed($dc7b520117824df4$var$name, {
        Unit: function Unit(x) {
            return x.clone();
        },
        string: function string(x) {
            if (Unit.isValuelessUnit(x)) return new Unit(null, x); // a pure unit
            return Unit.parse(x, {
                allowNoUnits: true
            }); // a unit with value, like '5cm'
        },
        "number | BigNumber | Fraction | Complex, string | Unit": function numberBigNumberFractionComplexStringUnit(value, unit) {
            return new Unit(value, unit);
        },
        "number | BigNumber | Fraction": function numberBigNumberFraction(value) {
            // dimensionless
            return new Unit(value);
        },
        "Array | Matrix": typed.referToSelf((self)=>(x)=>(0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(x, self))
    });
});



var $f7ea5b439a439199$var$name = "usolve";
var $f7ea5b439a439199$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtractScalar",
    "equalScalar",
    "DenseMatrix"
];
var $f7ea5b439a439199$export$f652f5e8e3e838da = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f7ea5b439a439199$var$name, $f7ea5b439a439199$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $252033fdefeca445$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds one solution of a linear equation system by backward substitution. Matrix must be an upper triangular matrix. Throws an error if there's no solution.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolve(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolve(a, b)  // [[8], [9]]
   *
   * See also:
   *
   *    usolveAll, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($f7ea5b439a439199$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseBackwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseBackwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var r = _denseBackwardSubstitution(m, b);
            return r.valueOf();
        }
    });
    function _denseBackwardSubstitution(m, b) {
        // make b into a column vector
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        // result
        var x = [];
        var mdata = m._data;
        // loop columns backwards
        for(var j = columns - 1; j >= 0; j--){
            // b[j]
            var bj = bdata[j][0] || 0;
            // x[j]
            var xj = void 0;
            if (!equalScalar(bj, 0)) {
                // value at [j, j]
                var vjj = mdata[j][j];
                if (equalScalar(vjj, 0)) // system cannot be solved
                throw new Error("Linear system cannot be solved since matrix is singular");
                xj = divideScalar(bj, vjj);
                // loop rows
                for(var i = j - 1; i >= 0; i--)// update copy of b
                bdata[i] = [
                    subtractScalar(bdata[i][0] || 0, multiplyScalar(xj, mdata[i][j]))
                ];
            } else // zero value at j
            xj = 0;
            // update x
            x[j] = [
                xj
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseBackwardSubstitution(m, b) {
        // make b into a column vector
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // result
        var x = [];
        // loop columns backwards
        for(var j = columns - 1; j >= 0; j--){
            var bj = bdata[j][0] || 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = 0;
                // upper triangular matrix values & index (column j)
                var jValues = [];
                var jIndices = [];
                // first & last indeces in column
                var firstIndex = ptr[j];
                var lastIndex = ptr[j + 1];
                // values in column, find value at [j, j], loop backwards
                for(var k = lastIndex - 1; k >= firstIndex; k--){
                    var i = index[k];
                    // check row (rows are not sorted!)
                    if (i === j) vjj = values[k];
                    else if (i < j) {
                        // store upper triangular
                        jValues.push(values[k]);
                        jIndices.push(i);
                    }
                }
                // at this point we must have a value in vjj
                if (equalScalar(vjj, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                var xj = divideScalar(bj, vjj);
                for(var _k = 0, _lastIndex = jIndices.length; _k < _lastIndex; _k++){
                    var _i = jIndices[_k];
                    bdata[_i] = [
                        subtractScalar(bdata[_i][0], multiplyScalar(xj, jValues[_k]))
                    ];
                }
                x[j] = [
                    xj
                ];
            } else // degenerate row, we can choose any value
            x[j] = [
                0
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});



var $e13677081a695c76$var$name = "usolveAll";
var $e13677081a695c76$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtractScalar",
    "equalScalar",
    "DenseMatrix"
];
var $e13677081a695c76$export$c8bbc8bec60c7fc3 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e13677081a695c76$var$name, $e13677081a695c76$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $252033fdefeca445$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds all solutions of a linear equation system by backward substitution. Matrix must be an upper triangular matrix.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolveAll(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolveAll(a, b)  // [ [[8], [9]] ]
   *
   * See also:
   *
   *    usolve, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix[] | Array[]}  An array of affine-independent column vectors (x) that solve the linear system
   */ return typed($e13677081a695c76$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseBackwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseBackwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var R = _denseBackwardSubstitution(m, b);
            return R.map((r)=>r.valueOf());
        }
    });
    function _denseBackwardSubstitution(m, b_) {
        // the algorithm is derived from
        // https://www.overleaf.com/read/csvgqdxggyjv
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var M = m._data;
        var rows = m._size[0];
        var columns = m._size[1];
        // loop columns backwards
        for(var i = columns - 1; i >= 0; i--){
            var L = B.length;
            // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                if (!equalScalar(M[i][i], 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], M[i][i]);
                    for(var j = i - 1; j >= 0; j--)// b[j] -= b[i] * M[j,i]
                    b[j] = subtractScalar(b[j], multiplyScalar(b[i], M[j][i]));
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j = i - 1; _j >= 0; _j--)bNew[_j] = subtractScalar(bNew[_j], M[_j][i]);
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
    function _sparseBackwardSubstitution(m, b_) {
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // loop columns backwards
        for(var i = columns - 1; i >= 0; i--){
            var L = B.length;
            // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                // values & indices (column i)
                var iValues = [];
                var iIndices = [];
                // first & last indeces in column
                var firstIndex = ptr[i];
                var lastIndex = ptr[i + 1];
                // find the value at [i, i]
                var Mii = 0;
                for(var j = lastIndex - 1; j >= firstIndex; j--){
                    var J = index[j];
                    // check row
                    if (J === i) Mii = values[j];
                    else if (J < i) {
                        // store upper triangular
                        iValues.push(values[j]);
                        iIndices.push(J);
                    }
                }
                if (!equalScalar(Mii, 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], Mii);
                    // loop upper triangular
                    for(var _j2 = 0, _lastIndex = iIndices.length; _j2 < _lastIndex; _j2++){
                        var _J = iIndices[_j2];
                        b[_J] = subtractScalar(b[_J], multiplyScalar(b[i], iValues[_j2]));
                    }
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    // loop upper triangular
                    for(var _j3 = 0, _lastIndex2 = iIndices.length; _j3 < _lastIndex2; _j3++){
                        var _J2 = iIndices[_j3];
                        bNew[_J2] = subtractScalar(bNew[_J2], iValues[_j3]);
                    }
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
});





var $97b420845d05c5d5$var$DEFAULT_NORMALIZATION = "unbiased";
var $97b420845d05c5d5$var$name = "variance";
var $97b420845d05c5d5$var$dependencies = [
    "typed",
    "add",
    "subtract",
    "multiply",
    "divide",
    "apply",
    "isNaN"
];
var $97b420845d05c5d5$export$b989221824390fb = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($97b420845d05c5d5$var$name, $97b420845d05c5d5$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, subtract: subtract, multiply: multiply, divide: divide, apply: apply, isNaN: isNaN } = _ref;
    /**
   * Compute the variance of a matrix or a  list with values.
   * In case of a multidimensional array or matrix, the variance over all
   * elements will be calculated.
   *
   * Additionally, it is possible to compute the variance along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Note that older browser may not like the variable name `var`. In that
   * case, the function can be called as `math['var'](...)` instead of
   * `math.var(...)`.
   *
   * Syntax:
   *
   *     math.variance(a, b, c, ...)
   *     math.variance(A)
   *     math.variance(A, normalization)
   *     math.variance(A, dimension)
   *     math.variance(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.variance(2, 4, 6)                     // returns 4
   *     math.variance([2, 4, 6, 8])                // returns 6.666666666666667
   *     math.variance([2, 4, 6, 8], 'uncorrected') // returns 5
   *     math.variance([2, 4, 6, 8], 'biased')      // returns 4
   *
   *     math.variance([[1, 2, 3], [4, 5, 6]])      // returns 3.5
   *     math.variance([[1, 2, 3], [4, 6, 8]], 0)   // returns [4.5, 8, 12.5]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1)   // returns [1, 4]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.5, 2]
   *
   * See also:
   *
   *    mean, median, max, min, prod, std, sum
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the variance for a matrix
   * @return {*} The variance
   */ return typed($97b420845d05c5d5$var$name, {
        // variance([a, b, c, d, ...])
        "Array | Matrix": function ArrayMatrix(array) {
            return _var(array, $97b420845d05c5d5$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, d, ...], normalization)
        "Array | Matrix, string": _var,
        // variance([a, b, c, c, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return _varDim(array, dim, $97b420845d05c5d5$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, c, ...], dim, normalization)
        "Array | Matrix, number | BigNumber, string": _varDim,
        // variance(a, b, c, d, ...)
        "...": function _(args) {
            return _var(args, $97b420845d05c5d5$var$DEFAULT_NORMALIZATION);
        }
    });
    /**
   * Recursively calculate the variance of an n-dimensional array
   * @param {Array} array
   * @param {string} normalization
   *                        Determines how to normalize the variance:
   *                        - 'unbiased'    The sum of squared errors is divided by (n - 1)
   *                        - 'uncorrected' The sum of squared errors is divided by n
   *                        - 'biased'      The sum of squared errors is divided by (n + 1)
   * @return {number | BigNumber} variance
   * @private
   */ function _var(array, normalization) {
        var sum;
        var num = 0;
        if (array.length === 0) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
        // calculate the mean and number of elements
        (0, $b3f9e93020d0f987$export$519ada94592b97fc)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "variance", value);
            }
        });
        if (num === 0) throw new Error("Cannot calculate variance of an empty array");
        var mean = divide(sum, num);
        // calculate the variance
        sum = undefined;
        (0, $b3f9e93020d0f987$export$519ada94592b97fc)(array, function(value) {
            var diff = subtract(value, mean);
            sum = sum === undefined ? multiply(diff, diff) : add(sum, multiply(diff, diff));
        });
        if (isNaN(sum)) return sum;
        switch(normalization){
            case "uncorrected":
                return divide(sum, num);
            case "biased":
                return divide(sum, num + 1);
            case "unbiased":
                var zero = (0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(sum) ? sum.mul(0) : 0;
                return num === 1 ? zero : divide(sum, num - 1);
            default:
                throw new Error('Unknown normalization "' + normalization + '". ' + 'Choose "unbiased" (default), "uncorrected", or "biased".');
        }
    }
    function _varDim(array, dim, normalization) {
        try {
            if (array.length === 0) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
            return apply(array, dim, (x)=>_var(x, normalization));
        } catch (err) {
            throw (0, $b84e6160513a21c1$export$c8994973cec629ae)(err, "variance");
        }
    }
});



var $d50e8dc7a72caee8$var$name = "xgcd";
var $d50e8dc7a72caee8$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $d50e8dc7a72caee8$export$de8cbd18c98bf9d5 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d50e8dc7a72caee8$var$name, $d50e8dc7a72caee8$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Calculate the extended greatest common divisor for two values.
   * See https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm.
   *
   * Syntax:
   *
   *    math.xgcd(a, b)
   *
   * Examples:
   *
   *    math.xgcd(8, 12)             // returns [4, -1, 1]
   *    math.gcd(8, 12)              // returns 4
   *    math.xgcd(36163, 21199)      // returns [1247, -7, 12]
   *
   * See also:
   *
   *    gcd, lcm
   *
   * @param {number | BigNumber} a  An integer number
   * @param {number | BigNumber} b  An integer number
   * @return {Array}              Returns an array containing 3 integers `[div, m, n]`
   *                              where `div = gcd(a, b)` and `a*m + b*n = div`
   */ return typed($d50e8dc7a72caee8$var$name, {
        "number, number": function numberNumber(a, b) {
            var res = (0, $f38f49d8e24d4a9f$export$8cb756a23a623229)(a, b);
            return config.matrix === "Array" ? res : matrix(res);
        },
        "BigNumber, BigNumber": _xgcdBigNumber
    });
    /**
   * Calculate xgcd for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @return {BigNumber[]} result
   * @private
   */ function _xgcdBigNumber(a, b) {
        // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
        var // used to swap two variables
        t;
        var // quotient
        q;
        var // remainder
        r;
        var zero = new BigNumber(0);
        var one = new BigNumber(1);
        var x = zero;
        var lastx = one;
        var y = one;
        var lasty = zero;
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function xgcd must be integer numbers");
        while(!b.isZero()){
            q = a.div(b).floor();
            r = a.mod(b);
            t = x;
            x = lastx.minus(q.times(x));
            lastx = t;
            t = y;
            y = lasty.minus(q.times(y));
            lasty = t;
            a = b;
            b = r;
        }
        var res;
        if (a.lt(zero)) res = [
            a.neg(),
            lastx.neg(),
            lasty.neg()
        ];
        else res = [
            a,
            !a.isZero() ? lastx : 0,
            lasty
        ];
        return config.matrix === "Array" ? res : matrix(res);
    }
});







var $a3dd3952ef35f088$var$name = "xor";
var $a3dd3952ef35f088$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix",
    "concat"
];
var $a3dd3952ef35f088$export$a2b8cab2c7385f0e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a3dd3952ef35f088$var$name, $a3dd3952ef35f088$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $4ec2f48a64980d8f$export$6325e83173a86892)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $5e352e66a45fa3fa$export$439c4d7accd2a586)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo12xSfs = (0, $0e61f64a39d5fa10$export$c966408e3ecf83ee)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $14cb5501dcbd1d68$export$16b92d4ea17760ac)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Logical `xor`. Test whether one and only one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.xor(x, y)
   *
   * Examples:
   *
   *    math.xor(2, 4)   // returns false
   *
   *    a = [2, 0, 0]
   *    b = [2, 7, 0]
   *    c = 0
   *
   *    math.xor(a, b)   // returns [false, true, false]
   *    math.xor(a, c)   // returns [true, false, false]
   *
   * See also:
   *
   *    and, not, or
   *
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one and only one input is defined with a nonzero/nonempty value.
   */ return typed($a3dd3952ef35f088$var$name, {
        "number, number": (0, $89192b5d651983ac$export$17cc7dc3a74df3af),
        "Complex, Complex": function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) !== (y.re !== 0 || y.im !== 0);
        },
        "bigint, bigint": (0, $89192b5d651983ac$export$17cc7dc3a74df3af),
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return (!x.isZero() && !x.isNaN()) !== (!y.isZero() && !y.isNaN());
        },
        "Unit, Unit": typed.referToSelf((self)=>(x, y)=>self(x.value || 0, y.value || 0))
    }, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});





var $f9544132d92b4410$var$name = "zeros";
var $f9544132d92b4410$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $f9544132d92b4410$export$13096c1635fe6e3d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f9544132d92b4410$var$name, $f9544132d92b4410$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Create a matrix filled with zeros. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.zeros(m)
   *    math.zeros(m, format)
   *    math.zeros(m, n)
   *    math.zeros(m, n, format)
   *    math.zeros([m, n])
   *    math.zeros([m, n], format)
   *
   * Examples:
   *
   *    math.zeros()                   // returns []
   *    math.zeros(3)                  // returns [0, 0, 0]
   *    math.zeros(3, 2)               // returns [[0, 0], [0, 0], [0, 0]]
   *    math.zeros(3, 'dense')         // returns [0, 0, 0]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.zeros(math.size(A))       // returns [[0, 0, 0], [0, 0, 0]]
   *
   * See also:
   *
   *    ones, identity, size, range
   *
   * @param {...(number|BigNumber) | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix}           A matrix filled with zeros
   */ return typed($f9544132d92b4410$var$name, {
        "": function _() {
            return config.matrix === "Array" ? _zeros([]) : _zeros([], "default");
        },
        // math.zeros(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        "...number | BigNumber | string": function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === "string") {
                var format = size.pop();
                return _zeros(size, format);
            } else if (config.matrix === "Array") return _zeros(size);
            else return _zeros(size, "default");
        },
        Array: _zeros,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _zeros(size.valueOf(), format);
        },
        "Array | Matrix, string": function ArrayMatrixString(size, format) {
            return _zeros(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with zeros
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _zeros(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(0) : 0;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $eee21df0c3527ff1$export$4380c87abf28fdf)(arr, size, defaultValue);
            return arr;
        }
    }
    // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    }
    // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== "number" || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(value) || value < 0) throw new Error("Parameters in function zeros must be positive integers");
        });
    }
}); // TODO: zeros contains almost the same code as ones. Reuse this?


var $62a8e78e77cf4b97$var$name = "zeta";
var $62a8e78e77cf4b97$var$dependencies = [
    "typed",
    "config",
    "multiply",
    "pow",
    "divide",
    "factorial",
    "equal",
    "smallerEq",
    "isNegative",
    "gamma",
    "sin",
    "subtract",
    "add",
    "?Complex",
    "?BigNumber",
    "pi"
];
var $62a8e78e77cf4b97$export$7bb33f27b1ded438 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($62a8e78e77cf4b97$var$name, $62a8e78e77cf4b97$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiply: multiply, pow: pow, divide: divide, factorial: factorial, equal: equal, smallerEq: smallerEq, isNegative: isNegative, gamma: gamma, sin: sin, subtract: subtract, add: add, Complex: Complex, BigNumber: _BigNumber, pi: pi } = _ref;
    /**
   * Compute the Riemann Zeta function of a value using an infinite series for
   * all of the complex plane using Riemann's Functional equation.
   *
   * Based off the paper by Xavier Gourdon and Pascal Sebah
   * ( http://numbers.computation.free.fr/Constants/Miscellaneous/zetaevaluations.pdf )
   *
   * Implementation and slight modification by Anik Patel
   *
   * Note: the implementation is accurate up to about 6 digits.
   *
   * Syntax:
   *
   *    math.zeta(n)
   *
   * Examples:
   *
   *    math.zeta(5)       // returns 1.0369277551433895
   *    math.zeta(-0.5)    // returns -0.2078862249773449
   *    math.zeta(math.i)  // returns 0.0033002236853253153 - 0.4181554491413212i
   *
   * See also:
   *    erf
   *
   * @param {number | Complex | BigNumber} s   A Real, Complex or BigNumber parameter to the Riemann Zeta Function
   * @return {number | Complex | BigNumber}    The Riemann Zeta of `s`
   */ return typed($62a8e78e77cf4b97$var$name, {
        number: (s)=>zetaNumeric(s, (value)=>value, ()=>20),
        BigNumber: (s)=>zetaNumeric(s, (value)=>new _BigNumber(value), ()=>{
                // relTol is for example 1e-12. Extract the positive exponent 12 from that
                return Math.abs(Math.log10(config.relTol));
            }),
        Complex: zetaComplex
    });
    /**
   * @param {number | BigNumber} s
   * @param {(value: number) => number | BigNumber} createValue
   * @param {(value: number | BigNumber | Complex) => number} determineDigits
   * @returns {number | BigNumber}
   */ function zetaNumeric(s, createValue, determineDigits) {
        if (equal(s, 0)) return createValue(-0.5);
        if (equal(s, 1)) return createValue(NaN);
        if (!isFinite(s)) return isNegative(s) ? createValue(NaN) : createValue(1);
        return zeta(s, createValue, determineDigits, (s)=>s);
    }
    /**
   * @param {Complex} s
   * @returns {Complex}
   */ function zetaComplex(s) {
        if (s.re === 0 && s.im === 0) return new Complex(-0.5);
        if (s.re === 1) return new Complex(NaN, NaN);
        if (s.re === Infinity && s.im === 0) return new Complex(1);
        if (s.im === Infinity || s.re === -Infinity) return new Complex(NaN, NaN);
        return zeta(s, (value)=>value, (s)=>Math.round(19.5 + 0.9 * Math.abs(s.im)), (s)=>s.re);
    }
    /**
   * @param {number | BigNumber | Complex} s
   * @param {(value: number) => number | BigNumber | Complex} createValue
   * @param {(value: number | BigNumber | Complex) => number} determineDigits
   * @param {(value: number | BigNumber | Complex) => number} getRe
   * @returns {*|number}
   */ function zeta(s, createValue, determineDigits, getRe) {
        var n = determineDigits(s);
        if (getRe(s) > -(n - 1) / 2) return f(s, createValue(n), createValue);
        else {
            // Function Equation for reflection to x < 1
            var c = multiply(pow(2, s), pow(createValue(pi), subtract(s, 1)));
            c = multiply(c, sin(multiply(divide(createValue(pi), 2), s)));
            c = multiply(c, gamma(subtract(1, s)));
            return multiply(c, zeta(subtract(1, s), createValue, determineDigits, getRe));
        }
    }
    /**
   * Calculate a portion of the sum
   * @param {number | BigNumber} k   a positive integer
   * @param {number | BigNumber} n   a positive integer
   * @return {number}    the portion of the sum
   **/ function d(k, n) {
        var S = k;
        for(var j = k; smallerEq(j, n); j = add(j, 1)){
            var factor = divide(multiply(factorial(add(n, subtract(j, 1))), pow(4, j)), multiply(factorial(subtract(n, j)), factorial(multiply(2, j))));
            S = add(S, factor);
        }
        return multiply(n, S);
    }
    /**
   * Calculate the positive Riemann Zeta function
   * @param {number} s   a real or complex number with s.re > 1
   * @param {number} n   a positive integer
   * @param {(number) => number | BigNumber | Complex} createValue
   * @return {number}    Riemann Zeta of s
   **/ function f(s, n, createValue) {
        var c = divide(1, multiply(d(createValue(0), n), subtract(1, pow(2, subtract(1, s)))));
        var S = createValue(0);
        for(var k = createValue(1); smallerEq(k, n); k = add(k, 1))S = add(S, divide(multiply((-1) ** (k - 1), d(k, n)), pow(k, s)));
        return multiply(c, S);
    }
});


var $e6fdcd99a430547c$var$name = "zpk2tf";
var $e6fdcd99a430547c$var$dependencies = [
    "typed",
    "add",
    "multiply",
    "Complex",
    "number"
];
var $e6fdcd99a430547c$export$9d6f6343ff32e725 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e6fdcd99a430547c$var$name, $e6fdcd99a430547c$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, multiply: multiply, Complex: Complex, number: number } = _ref;
    /**
     * Compute the transfer function of a zero-pole-gain model.
     *
     * Syntax:
     *      math.zpk2tf(z, p, k)
     *
     * Examples:
     *    math.zpk2tf([1, 2], [-1, -2], 1)    // returns [[1, -3, 2], [1, 3, 2]]
     *
     * See also:
     *   freqz
     *
     * @param {Array} z Array of zeros values
     * @param {Array} p Array of poles values
     * @param {number} k Gain value
     * @return {Array} Two dimensional array containing the numerator (first row) and denominator (second row) polynomials
     *
     */ return typed($e6fdcd99a430547c$var$name, {
        "Array,Array,number": function ArrayArrayNumber(z, p, k) {
            return _zpk2tf(z, p, k);
        },
        "Array,Array": function ArrayArray(z, p) {
            return _zpk2tf(z, p, 1);
        },
        "Matrix,Matrix,number": function MatrixMatrixNumber(z, p, k) {
            return _zpk2tf(z.valueOf(), p.valueOf(), k);
        },
        "Matrix,Matrix": function MatrixMatrix(z, p) {
            return _zpk2tf(z.valueOf(), p.valueOf(), 1);
        }
    });
    function _zpk2tf(z, p, k) {
        // if z is bignumber, convert it to number
        if (z.some((el)=>el.type === "BigNumber")) z = z.map((el)=>number(el));
        // if p is bignumber, convert it to number
        if (p.some((el)=>el.type === "BigNumber")) p = p.map((el)=>number(el));
        var num = [
            Complex(1, 0)
        ];
        var den = [
            Complex(1, 0)
        ];
        for(var i = 0; i < z.length; i++){
            var zero = z[i];
            if (typeof zero === "number") zero = Complex(zero, 0);
            num = _multiply(num, [
                Complex(1, 0),
                Complex(-zero.re, -zero.im)
            ]);
        }
        for(var _i = 0; _i < p.length; _i++){
            var pole = p[_i];
            if (typeof pole === "number") pole = Complex(pole, 0);
            den = _multiply(den, [
                Complex(1, 0),
                Complex(-pole.re, -pole.im)
            ]);
        }
        for(var _i2 = 0; _i2 < num.length; _i2++)num[_i2] = multiply(num[_i2], k);
        return [
            num,
            den
        ];
    }
    function _multiply(a, b) {
        var c = [];
        for(var i = 0; i < a.length + b.length - 1; i++){
            c[i] = Complex(0, 0);
            for(var j = 0; j < a.length; j++)if (i - j >= 0 && i - j < b.length) c[i] = add(c[i], multiply(a[j], b[i - j]));
        }
        return c;
    }
});


var $209b60385dcf2884$export$d97aa349ed20696 = /* #__PURE__ */ (0, $cfd46da444216cd5$export$234de8d4231bfea3)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$50ceb3fb9926e63e = /* #__PURE__ */ (0, $da8f8ceba4b637ad$export$24a4be44fc8b6392)({});
var $209b60385dcf2884$export$f1e1789686576879 = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$6dca51ff4d4b257f)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$f650004d56f90c2a = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$cb94e3a54c9e99b)({});
var $209b60385dcf2884$export$5c15dd8d2782cbd0 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$aaddb59a993d3ac4)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$b336c2702c498be5 = /* #__PURE__ */ (0, $aaa48a8cda61b48f$export$c317f082100fca89)({});
var $209b60385dcf2884$export$23f2a1d2818174ef = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$7122d2461a6f9b76)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e
});
var $209b60385dcf2884$export$20607595d292e7d3 = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$df1313fb6eb44f05)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$c44341d65988fdd6 = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$5365e90aad1235b4)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$5ed2c057bd191c66 = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$57f654bce66ec8ce)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$5b12bf1653c0dd85 = /* #__PURE__ */ (0, $d737a2a17212fb6c$export$72d485cc3ed6a97a)({});
var $209b60385dcf2884$export$14edd9ca775dcd61 = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$fbdaee11df58c3cc)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$a2cbb38cda512d16 = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$d07c6114481fc17b)({});
var $209b60385dcf2884$export$324943737027944a = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$f131830080647892)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$9a58ef0d7ad3278c = /* #__PURE__ */ (0, $f99883b990dced88$export$e87cc8d3f29c5e1b)({});
var $209b60385dcf2884$export$aebd5179ff543a90 = /* #__PURE__ */ (0, $ac4cd90c012d6eb1$export$dfb3187f1c4e3bbe)({});
var $209b60385dcf2884$export$83247d8be11c091e = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$e6df2cb14f3e8316)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$a7100dcd4c5af6d4 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$467c65d9dfc3d3a2)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$a4b4b4d4d776fe92 = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$d5973a6d5d95d479)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$93f71dfe5e50cd3e = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$e13d32722e2756df)({});
var $209b60385dcf2884$export$83d89fbfd8236492 = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$72a91d9326d5a672)({});
var $209b60385dcf2884$export$97f0d27b48f120e8 = /* #__PURE__ */ (0, $c3ad35825bd0e89e$export$1a088ca8dd364cd1)({
    Matrix: $209b60385dcf2884$export$5b12bf1653c0dd85
});
var $209b60385dcf2884$export$9ea6550edaaee998 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$55fc8769b037d266)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$578b45ddcdefa518 = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$ab67ddb9e8290a2c)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$18c7bea995a110f = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$2dbe69c48ac7f49c)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$b644b65666fe0c18 = /* #__PURE__ */ (0, $e1c3561e9b6d1bf7$export$481a522c866104eb)({});
var $209b60385dcf2884$export$3681641e15b6e2c3 = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$f7a593fe98eba575)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$519f616c41a1c711 = /* #__PURE__ */ (0, $fecd1c72801697ff$export$8597b5d47504f989)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    Fraction: $209b60385dcf2884$export$b336c2702c498be5
});
var $209b60385dcf2884$export$857d2e3e2bc524d0 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$fa2d42c5c25c1883)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$2335f513bbd82c6d = /* #__PURE__ */ (0, $63f22a9e6164e359$export$dd8a9b3843a4df95)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$fd6306be3fde5b04 = /* #__PURE__ */ (0, $225e3a2952854876$export$33da46c5ece67581)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$4919a578c4aafd3 = /* #__PURE__ */ (0, $47b4cd57dd8bb923$export$8a6845771325148e)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$43298db932064b4a = /* #__PURE__ */ (0, $b9098f3d66ec7d96$export$95580581b134a5bd)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$2b7b095c4f443355 = /* #__PURE__ */ (0, $2b6c00a128174602$export$bbebd809b9ccc50b)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$d8da458ed75e15b = /* #__PURE__ */ (0, $a6c586ab564bc0bd$export$bde3dabbd4699a93)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$3aaf4e522be48075 = /* #__PURE__ */ (0, $3f66c557a350645d$export$8eeff5f09afe95bc)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$839d8a01b6af4fc0 = /* #__PURE__ */ (0, $8bccec96a1e05cfa$export$7278bb4e3c84d46a)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$628dc4eed22b0fbd = /* #__PURE__ */ (0, $7905114719152cdb$export$b87f3a3301a24256)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$21ea955025ceb08b = /* #__PURE__ */ (0, $dff3cd9decddb6b0$export$c2dbbeab1e5e6195)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$a0f65b52274bcc00 = /* #__PURE__ */ (0, $a688087d0499c924$export$bfbfca9aa02d908c)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$aabc449fa5b5f4c0 = /* #__PURE__ */ (0, $a94e1f2b547c0bb8$export$9e7f3c72ca8b5aa)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$4a21f16c33752377 = /* #__PURE__ */ (0, $e80b9cf32ddb26b3$export$3c82aec2d86a5525)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$9cd59f9826255e47 = /* #__PURE__ */ (0, $97806624bc4daa59$export$39ad70de4044028a)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$bdfcf4c6b5766439 = /* #__PURE__ */ (0, $07d6664b75d4c02b$export$63e3129a196da23d)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$83a0e34f1302825b = /* #__PURE__ */ (0, $76be1aea8cfa4fc0$export$82a905fb6826da0d)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$fb254c661fe9c0db = /* #__PURE__ */ (0, $421d08a6c65b63df$export$af5efe8ad97f01a2)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$50d414a77b60d802 = /* #__PURE__ */ (0, $d82926857202e838$export$923b60dfa791c630)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$ef569ec50496610c = /* #__PURE__ */ (0, $22188c2f04abcb2b$export$c5598f542ea1565c)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$a830b5ed334924be = /* #__PURE__ */ (0, $f9d712b2dbcd8faf$export$a0beb298aa7a2962)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$2b0340f6c7dec49a = /* #__PURE__ */ (0, $3411ebfd551dee7a$export$ce223d612b94804b)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$943761f5c9c3f156 = /* #__PURE__ */ (0, $6722033ff124706e$export$c370bab664a0c9a2)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$d3896f355fc09423 = /* #__PURE__ */ (0, $31a7e7763ce27ff9$export$470dfa326d6cbdf5)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$b310ec824aaee37f = /* #__PURE__ */ (0, $ec7df944117251ea$export$95a576617fd015b1)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$b6c0a80d46d3391d = /* #__PURE__ */ (0, $b06fb08102326836$export$2b203b63f664bab3)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$3dea766d36a8935f = /* #__PURE__ */ (0, $52f9b87db4f9c98c$export$5d81789ff4aeccdf)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$4b80e395e36b5a56 = /* #__PURE__ */ (0, $bcfc207c51e62c61$export$a5218987e0811e05)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$d9468344d3651243 = /* #__PURE__ */ (0, $6f8e46201541c0bb$export$abf0d9399b60f9bb)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$42c7d1d712906e32 = /* #__PURE__ */ (0, $325d73579104a7e7$export$b83055c9a38abe3c)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$834dfc94dde4b3d8 = /* #__PURE__ */ (0, $a323eeecc705dabc$export$9cafd9970d25a17c)({
    format: $209b60385dcf2884$export$d9468344d3651243,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$5fc500b917996661 = /* #__PURE__ */ (0, $c48de93c8b059d6e$export$47dfdf308b91581)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$a287f47fed4544b8 = /* #__PURE__ */ (0, $17e9fa1e43eb1261$export$766996d075d5608a)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$d0909a4f38b5c4d0 = /* #__PURE__ */ (0, $22ade9d4e885d510$export$159ccd8c63e17c58)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$7e69d4236fcc3b19 = /* #__PURE__ */ (0, $e12f71367558f9e7$export$2d862c12fb537dd9)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$c46ec7d82fb1f602 = /* #__PURE__ */ (0, $8eb868389d2fe92f$export$ea90652d00dab06e)({
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$8c2c65adacba8d14 = /* #__PURE__ */ (0, $f3fa4ca4dc0610f2$export$b57f4b4cfc057c2d)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$3daae2744d8ce460 = /* #__PURE__ */ (0, $9723ce71c7fd8798$export$bc3a6f6286e9085a)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$75e08744a3ff8516 = /* #__PURE__ */ (0, $055d574b08c61f26$export$dea4efeb24d4590d)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$b9fae0bba9d9094d = /* #__PURE__ */ (0, $72b1bfb767181ea9$export$a993dae3988e0f19)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$871de8747c9eaa88 = /* #__PURE__ */ (0, $dc528eeb9e35a331$export$d49c9aa30b771d59)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$c697bed75648cdb7 = /* #__PURE__ */ (0, $510e45e57dd1e093$export$37dc64d7e8361b32)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$6003a5f097c73977 = /* #__PURE__ */ (0, $be2e63de4538ed30$export$8dbfb388cd6a8853)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$98e628dec113755e = /* #__PURE__ */ (0, $dd1aaaf5bbafc3c8$export$763ee9f6477981ab)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$8d9f5ae1af806929 = /* #__PURE__ */ (0, $11e7ed358b24e81c$export$6692788ef49c21c9)({
    format: $209b60385dcf2884$export$d9468344d3651243,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$2e015b6955893291 = /* #__PURE__ */ (0, $25c930acffc7ae34$export$fbe25b9f25feec34)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$c2d084dc44961371 = /* #__PURE__ */ (0, $4e89f948aaeed74d$export$ea4b9d9569ff81cc)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$4385e60b38654f68 = /* #__PURE__ */ (0, $d51e5ceaee382e3b$export$5c03d20f483e909a)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$b1f1627d659a651 = /* #__PURE__ */ (0, $9ed579ffe277110c$export$803e46d0de790dbf)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$e17a63917e2ebf0f = /* #__PURE__ */ (0, $5e48e90f2787bd8a$export$5c169ecd5c25a09e)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$c5552dfdbc7cec71 = /* #__PURE__ */ (0, $f5ab7d7b58725a06$export$45df7cae684751af)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Fraction: $209b60385dcf2884$export$b336c2702c498be5,
    complex: $209b60385dcf2884$export$83a0e34f1302825b,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$5de3937cb4b592ed = /* #__PURE__ */ (0, $9c2458d8ce9d1886$export$4b4fac44ef379cae)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$de9b2b7556879848 = /* #__PURE__ */ (0, $81d4ac66979a3607$export$a783ce8f6a98b2e5)({
    Matrix: $209b60385dcf2884$export$5b12bf1653c0dd85,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$dd67294014106b35 = /* #__PURE__ */ (0, $4c352732a8482df8$export$a9f61753ee14ea96)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$dd4f28cef696bc7d = /* #__PURE__ */ (0, $6f66f1ead66c4128$export$4ba960a63f731b0b)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$22b082955e083ec3 = /* #__PURE__ */ (0, $547e965165ab470e$export$b2cf5914f5f18823)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$fdebd7f5d4c6e658 = /* #__PURE__ */ (0, $e7d22dd09f419c66$export$7b5719caf153b43d)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$fcdd3b0b3246a325 = /* #__PURE__ */ (0, $9de694fdfc189374$export$b61ad4f38fd9301d)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$f5bbd400c2f4426f = /* #__PURE__ */ (0, $2e551e404befc1d2$export$d7acf116afef7b4d)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$b26caf0f29211d08 = /* #__PURE__ */ (0, $88b48448acc5d82b$export$c634796792055579)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$eafdb403a25900df = /* #__PURE__ */ (0, $8896d6756d422141$export$d6534043a40dc59)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$5635d7ef4b8fee1c = /* #__PURE__ */ (0, $b9ebe2aeb9e55336$export$5ccffa1686df7f00)({
    isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$ec42f46098b24bb4 = /* #__PURE__ */ (0, $07973b37d7124c32$export$e1f28fc7c94f90b0)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$8576f72eb7f14a7e = /* #__PURE__ */ (0, $5bf10209a169e049$export$1c955ee1b8a97877)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$f297162cf5d656b2 = /* #__PURE__ */ (0, $3132671d543c7922$export$4bdc90311ec7c1dd)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$2e2fd1ad24e4d350 = /* #__PURE__ */ (0, $fae4d4b5e5eff48b$export$63d35097da636c02)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$ca7427e8bf42a21b = /* #__PURE__ */ (0, $218777d0dda9754b$export$9160aa3a39425fc9)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$c9f5652083b8129d = /* #__PURE__ */ (0, $e34bb448b012aa7d$export$f85085363cf09711)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$8676dd5fabd5ee34 = /* #__PURE__ */ (0, $c3d407c2ee36ec5b$export$4e02350f5fb7a050)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$3c5f89dae98e900b = /* #__PURE__ */ (0, $4e329e0490333c7d$export$e158da47ae479dd4)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$becbc39f348ea65e = /* #__PURE__ */ (0, $1e2c79630dbf87cf$export$97a0cf2b7d31f38b)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$545004b505d7c555 = /* #__PURE__ */ (0, $d3e1ffc4f2272b89$export$c3a62182c56878d5)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$b6b7e189aa5d134c = /* #__PURE__ */ (0, $3b151484333e8d7e$export$89ff03fdb3964a99)({
    SparseMatrix: $209b60385dcf2884$export$de9b2b7556879848,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$eba8049fb5020b81 = /* #__PURE__ */ (0, $0b816ac5c817f96d$export$eb18ce1988c5f19c)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$7128670e45beef9a = /* #__PURE__ */ (0, $b3d0d74899ecac05$export$e1f66a5bda779194)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$6cd304851a69e08 = /* #__PURE__ */ (0, $593104fa76be2510$export$939e1be6e134f392)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$6faaac9ab79fd3a4 = /* #__PURE__ */ (0, $1b6d9001976447ee$export$67e40c7fd8f5703a)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$f03e751d9cddb7a = /* #__PURE__ */ (0, $0039a008386ed187$export$a770ddfd7e536064)({
    format: $209b60385dcf2884$export$d9468344d3651243,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$fe7b8a3b046ac25b = /* #__PURE__ */ (0, $323a049fccc958a4$export$3f7f9b5400315e6a)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$7f34ce79760854f7 = /* #__PURE__ */ (0, $f8082e8dc393ab0b$export$de147ca8498e0312)({
    Fraction: $209b60385dcf2884$export$b336c2702c498be5,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$e90fb89750dba83f = /* #__PURE__ */ (0, $8a2cf62cb8d75cee$export$85b0631fa122b7f1)({
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$9bdad1ae37d738e0 = /* #__PURE__ */ (0, $3b49a34f5201c722$export$f3cf8b510f9cb8ab)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    Matrix: $209b60385dcf2884$export$5b12bf1653c0dd85,
    SparseMatrix: $209b60385dcf2884$export$de9b2b7556879848,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$7860df605315d572 = /* #__PURE__ */ (0, $d17791e0f78841d7$export$983d2c97138363e0)({
    isZero: $209b60385dcf2884$export$c46ec7d82fb1f602,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$549ff81930776885 = /* #__PURE__ */ (0, $c24efd38082c5cdb$export$822530980ba269d9)({
    isNaN: $209b60385dcf2884$export$c9f5652083b8129d,
    isNumeric: $209b60385dcf2884$export$e90fb89750dba83f,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$b7a508fa8dae59fc = /* #__PURE__ */ (0, $3d940ca8d5f722a7$export$e3cf2d123164e554)({
    bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
    fraction: $209b60385dcf2884$export$7f34ce79760854f7,
    number: $209b60385dcf2884$export$98e628dec113755e
});
var $209b60385dcf2884$export$5e143010dea16c85 = /* #__PURE__ */ (0, $124fdd5895b55f2a$export$60310f756e9cfd41)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$9eaad88cf88cee2b = /* #__PURE__ */ (0, $3bb93b6d8b5938c5$export$76c9752f34fb3440)({
    isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$346677f925de839c = /* #__PURE__ */ (0, $17bd5face8a48f01$export$9151c23a59ce3fb6)({
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$889c931173b77c2f = /* #__PURE__ */ (0, $7a8cb1da8313f19f$export$1a885844ffd505a4)({
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$9cb09a71b7d66923 = /* #__PURE__ */ (0, $152b3cfaa9806a63$export$9a8c88485f8f638b)({
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$6ba103b0465fe6cc = /* #__PURE__ */ (0, $d50e8dc7a72caee8$export$de8cbd18c98bf9d5)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$4445a00dafa2633b = /* #__PURE__ */ (0, $f9544132d92b4410$export$13096c1635fe6e3d)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$41726bdb1fc63f = /* #__PURE__ */ (0, $42d22c259f86a7bb$export$5f05d91ddc56bc14)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$841fc4d5a1480b85 = /* #__PURE__ */ (0, $d6787f501a70ed33$export$2103fed9c34b0004)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    Fraction: $209b60385dcf2884$export$b336c2702c498be5,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    isNegative: $209b60385dcf2884$export$d0909a4f38b5c4d0,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    unaryMinus: $209b60385dcf2884$export$6cd304851a69e08
});
var $209b60385dcf2884$export$ee1b3e54f0441b22 = /* #__PURE__ */ (0, $b26adab4221c7e8d$export$c36b5511b12560e8)({
    isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$85b9a36db797e02b = /* #__PURE__ */ (0, $d2ef57d94b6ab37b$export$decd32c762b504bc)({
    prod: $209b60385dcf2884$export$5e143010dea16c85,
    size: $209b60385dcf2884$export$346677f925de839c,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$eb6ad7870b1d0b0b = /* #__PURE__ */ (0, $0df238b4bfbaae1c$export$5d07146b3894f212)({
    conj: $209b60385dcf2884$export$fb254c661fe9c0db,
    transpose: $209b60385dcf2884$export$9cb09a71b7d66923,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$c042e7c2f59bc046 = /* #__PURE__ */ (0, $26afb3aa4fce391c$export$743a950f2cd4bacc)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    SparseMatrix: $209b60385dcf2884$export$de9b2b7556879848,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$67275f837d70084d = /* #__PURE__ */ (0, $af46154f7602077c$export$399593177816ff82)({
    numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$c74f132961c51406 = /* #__PURE__ */ (0, $d64e687f8aef4e84$export$e4930a420a373a24)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$411ce8e5a71e3069 = /* #__PURE__ */ (0, $df769625b9fdd98f$export$988f37bc1f709b0d)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$bffa455ba8c619a6 = /* #__PURE__ */ (0, $1905ab18d425dffd$export$107988e3ee9f3d12)({
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$f6fc628e09f3ff5d = /* #__PURE__ */ (0, $b0eec8101f607af7$export$acff9f91b891ace6)({
    isNumeric: $209b60385dcf2884$export$e90fb89750dba83f,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$f0954fd7d5368655 = /* #__PURE__ */ (0, $62af8e9daee85a4d$export$2eca89e9ac669625)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    SparseMatrix: $209b60385dcf2884$export$de9b2b7556879848,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$44f32dfde3d58545 = /* #__PURE__ */ (0, $407907043ec789ce$export$cee275bf38ddc295)({
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$72693dfc692346df = /* #__PURE__ */ (0, $07b88fca941d8455$export$26aa7f5b5fee1150)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$48901d58d322262f = /* #__PURE__ */ (0, $daf8f177c408156d$export$ce15600b23f5e78)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$be3b83cc1aa539e4 = /* #__PURE__ */ (0, $e026765f1419d9b5$export$1b88d04961967a10)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$e8999e227859a482 = /* #__PURE__ */ (0, $cf4fd53e38645b50$export$65fefc9f63da4d13)({
    flatten: $209b60385dcf2884$export$bffa455ba8c619a6,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    size: $209b60385dcf2884$export$346677f925de839c,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$cc5da69d359d7991 = /* #__PURE__ */ (0, $2274d53442855e7a$export$964e38ef60b1ac68)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$21041dee6b8001b0 = /* #__PURE__ */ (0, $6337772943e476d6$export$f524a435b9c16a90)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$7c27fb47516129d9 = /* #__PURE__ */ (0, $4fa9d44bfe7678f5$export$39b52312ba2c4d03)({
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    complex: $209b60385dcf2884$export$83a0e34f1302825b,
    conj: $209b60385dcf2884$export$fb254c661fe9c0db,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    identity: $209b60385dcf2884$export$f0954fd7d5368655,
    isZero: $209b60385dcf2884$export$c46ec7d82fb1f602,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    sign: $209b60385dcf2884$export$c5552dfdbc7cec71,
    sqrt: $209b60385dcf2884$export$eba8049fb5020b81,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    unaryMinus: $209b60385dcf2884$export$6cd304851a69e08,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$4380c87abf28fdf = /* #__PURE__ */ (0, $b6657f8fd10a6a98$export$58909557046ca413)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0
});
var $209b60385dcf2884$export$a1da16976d3a5f68 = /* #__PURE__ */ (0, $95014785bd1b3b54$export$ef742376390cbf7)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$2077e0241d6afd3c = /* #__PURE__ */ (0, $eb65acbf5e133648$export$c41ddfead54b1fbc)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$3f732695c1493aec = /* #__PURE__ */ (0, $dc266a434600d916$export$6b477d90b957f03e)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$4e2d2ead65e5f7e3 = /* #__PURE__ */ (0, $3a141bfdebc4cc26$export$cd7a6c131b18ab16)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    unaryMinus: $209b60385dcf2884$export$6cd304851a69e08
});
var $209b60385dcf2884$export$2c618a4308a30424 = /* #__PURE__ */ (0, $e37b76990ad255f2$export$6e6c19ceb4cd6856)({
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$df8c837ae5df4ce4 = /* #__PURE__ */ (0, $c4c7cd9f47d65d2f$export$cb425222dc08ff4e)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$41828460570e21eb = /* #__PURE__ */ (0, $f7ea5b439a439199$export$f652f5e8e3e838da)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$6444ef5cd411280c = /* #__PURE__ */ (0, $a3dd3952ef35f088$export$a2b8cab2c7385f0e)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$e16d8520af44a096 = /* #__PURE__ */ (0, $470766fdb1b0259b$export$c6b51545da64d82f)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    SparseMatrix: $209b60385dcf2884$export$de9b2b7556879848,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$b8b770ee6a0d9760 = /* #__PURE__ */ (0, $d2b3c5af1b96583c$export$c56716e11a38354e)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$a74ff8d3fdef72fc = /* #__PURE__ */ (0, $35b2aafc006b23e8$export$bea4e06c5befec3b)({
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$361eb278cc70bacf = /* #__PURE__ */ (0, $a68747c1126dd4e3$export$f45a7846535e9b07)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$bfcff4501301c191 = /* #__PURE__ */ (0, $573b3a9c20c2e229$export$1cae728fa8e01928)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$d8807a6c0487483a = /* #__PURE__ */ (0, $92cdff0f51648878$export$5a3f7692f3d4dd50)({
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    combinations: $209b60385dcf2884$export$bdfcf4c6b5766439,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
    isNegative: $209b60385dcf2884$export$d0909a4f38b5c4d0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$398604a469f7de9a = /* #__PURE__ */ (0, $a8f31786c0d995dc$export$a6e723c0e3b918d4)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    Fraction: $209b60385dcf2884$export$b336c2702c498be5,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$2da9287da10b19e2 = /* #__PURE__ */ (0, $b5e8e12e1f843853$export$3e578d0534ab5935)({
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$71990b1e1c4912fe = /* #__PURE__ */ (0, $a4767d153782e37a$export$e11ffe2ce577c262)({
    add: $209b60385dcf2884$export$e16d8520af44a096,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    unaryPlus: $209b60385dcf2884$export$df8c837ae5df4ce4
});
var $209b60385dcf2884$export$9cb4719e2e525b7a = /* #__PURE__ */ (0, $c4ecd976ad480366$export$b1b11fc839367b58)({
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$a37e3c603d7117e5 = /* #__PURE__ */ (0, $b9be86f35c7035bf$export$49df08fd121951b4)({
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    number: $209b60385dcf2884$export$98e628dec113755e,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$9f17032d917177de = /* #__PURE__ */ (0, $faf8bf69ea8cd285$export$23f482ad1a94fa7e)({
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    deepEqual: $209b60385dcf2884$export$9cb4719e2e525b7a,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    sqrt: $209b60385dcf2884$export$eba8049fb5020b81,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$94132a0e348806d4 = /* #__PURE__ */ (0, $69c03c7c70af9e3e$export$3dc59ff00984d687)({
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    conj: $209b60385dcf2884$export$fb254c661fe9c0db,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    size: $209b60385dcf2884$export$346677f925de839c,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$5bc21f656fb5d284 = /* #__PURE__ */ (0, $ce44d9609174aa60$export$1589aaa29568b87)({
    compareText: $209b60385dcf2884$export$2da9287da10b19e2,
    isZero: $209b60385dcf2884$export$c46ec7d82fb1f602,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$a3fe094919f356fd = /* #__PURE__ */ (0, $6bb08bcefc55a9f9$export$e04e4803a9128c9b)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    round: $209b60385dcf2884$export$2077e0241d6afd3c,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$f81847884871263e = /* #__PURE__ */ (0, $6af12ac22a20b8f9$export$2eb8acc96c598512)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    round: $209b60385dcf2884$export$2077e0241d6afd3c,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$f95c7888b62f8e9a = /* #__PURE__ */ (0, $444c0a26caa42504$export$87e3687740a09cb)({
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    isPositive: $209b60385dcf2884$export$7e69d4236fcc3b19,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    smaller: $209b60385dcf2884$export$3f732695c1493aec,
    sqrt: $209b60385dcf2884$export$eba8049fb5020b81,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$66fe727d7ec8c7b9 = /* #__PURE__ */ (0, $e60d683b6bdd8a35$export$49a565643b9ab608)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    smaller: $209b60385dcf2884$export$3f732695c1493aec
});
var $209b60385dcf2884$export$cf17b003b6192af3 = /* #__PURE__ */ (0, $e40593440b241175$export$300720b4fe34e62e)({
    ImmutableDenseMatrix: $209b60385dcf2884$export$66fe727d7ec8c7b9,
    getMatrixDataType: $209b60385dcf2884$export$42c7d1d712906e32
});
var $209b60385dcf2884$export$a94a7414fa942aea = /* #__PURE__ */ (0, $9c9a2ee8039818d3$export$af9bc16ae70e9aa8)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$bef1f36f5486a6a3 = /* #__PURE__ */ (0, $3483f9f89d68744a$export$aea8a16d5c9d1b93)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$de5c6af4003ef448 = /* #__PURE__ */ (0, $39f3f900e3e17ff9$export$70743fd0ad1f42d7)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$f4f4b934de52d430 = /* #__PURE__ */ (0, $c6cd253d1f7c45df$export$b72d61f960d7c36b)({
    flatten: $209b60385dcf2884$export$bffa455ba8c619a6,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    size: $209b60385dcf2884$export$346677f925de839c,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$96ec731ed4dcb222 = /* #__PURE__ */ (0, $12a6ba5b1a83f142$export$b795f47e2b99170)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
    smaller: $209b60385dcf2884$export$3f732695c1493aec,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$842a2cf37af977e1 = /* #__PURE__ */ (0, $a24b06a4ef896914$export$735bb6c30160c058)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    round: $209b60385dcf2884$export$2077e0241d6afd3c,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$2060d2db72cce88f = /* #__PURE__ */ (0, $2a87ec6ce9d50781$export$86d08fd318fa07c8)({
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    dot: $209b60385dcf2884$export$94132a0e348806d4,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$adb173527af10aca = /* #__PURE__ */ (0, $f89532c85ca94204$export$36e27b45d2aa738c)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$252bb8b3bbdf6749 = /* #__PURE__ */ (0, $cfe9a4f8156ec37d$export$3d19b09907d6fd4a)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$54d1e322cf7aa273 = /* #__PURE__ */ (0, $95b22b407d00a096$export$47c1a746705f5c42)({
    compare: $209b60385dcf2884$export$398604a469f7de9a,
    isNaN: $209b60385dcf2884$export$c9f5652083b8129d,
    isNumeric: $209b60385dcf2884$export$e90fb89750dba83f,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$502f8a5a1147da = /* #__PURE__ */ (0, $bfdaaae7c60743c4$export$2dd001e9fd66adcd)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$95c7459688ef4e3a = /* #__PURE__ */ (0, $e3d1fc760aabbc8a$export$e44ac9822ce417ae)({
    SparseMatrix: $209b60385dcf2884$export$de9b2b7556879848,
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    largerEq: $209b60385dcf2884$export$72693dfc692346df,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    transpose: $209b60385dcf2884$export$9cb09a71b7d66923,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$e06bd7b1ab877a71 = /* #__PURE__ */ (0, $11b312cf9e6477c6$export$d8c56e74d683bb33)({
    add: $209b60385dcf2884$export$e16d8520af44a096,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$8a63f25cc62965f1 = /* #__PURE__ */ (0, $31556c126aadddbc$export$14d444d810bc35b5)({
    add: $209b60385dcf2884$export$e16d8520af44a096,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$357889f174732d38 = /* #__PURE__ */ (0, $18c7e209693ae4ed$export$acff8254414be03b)({
    add: $209b60385dcf2884$export$e16d8520af44a096,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$c8a1cf0e83678d9 = /* #__PURE__ */ (0, $e13677081a695c76$export$c8bbc8bec60c7fc3)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$e4d83a2347bfd199 = /* #__PURE__ */ (0, $e6fdcd99a430547c$export$9d6f6343ff32e725)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    number: $209b60385dcf2884$export$98e628dec113755e,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$803ce6b71a0a94b2 = /* #__PURE__ */ (0, $651047ae30ddd654$export$bab247d909829ddf)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    round: $209b60385dcf2884$export$2077e0241d6afd3c,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$762e84baec56595d = /* #__PURE__ */ (0, $cc9ce6148945a1e3$export$ac9dd39e43534605)({
    compare: $209b60385dcf2884$export$398604a469f7de9a,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$fd2cf6bce05a0b18 = /* #__PURE__ */ (0, $1a40f7586f911343$export$1ddf9cbadd17315f)({
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    combinations: $209b60385dcf2884$export$bdfcf4c6b5766439,
    isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
    isNegative: $209b60385dcf2884$export$d0909a4f38b5c4d0,
    isPositive: $209b60385dcf2884$export$7e69d4236fcc3b19,
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$bb646b20bb93d339 = /* #__PURE__ */ (0, $80d317bf8845a13f$export$bc2585c0ed744c0e)({
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$d063d65fed97e7fa = /* #__PURE__ */ (0, $181e8af6d7e0616f$export$93f810683c54b005)({
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    isZero: $209b60385dcf2884$export$c46ec7d82fb1f602,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    unaryMinus: $209b60385dcf2884$export$6cd304851a69e08
});
var $209b60385dcf2884$export$c6d93afbf4ee8afc = /* #__PURE__ */ (0, $a1b68d5cf7d91184$export$a4620e84460f321e)({
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$dd5bb73729f20aa3 = /* #__PURE__ */ (0, $6c5f453dda79b257$export$3143a09e27a84c41)({
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    smaller: $209b60385dcf2884$export$3f732695c1493aec
});
var $209b60385dcf2884$export$d838837eb5b184e3 = /* #__PURE__ */ (0, $24c8992ed9281b77$export$3ed06081b8a4ee6)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    ceil: $209b60385dcf2884$export$803ce6b71a0a94b2,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    floor: $209b60385dcf2884$export$a3fe094919f356fd,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$b610b8812bbcded9 = /* #__PURE__ */ (0, $7cdf6cdabd5d9d7f$export$c6d108d7c8095f19)({
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$1f4807a235930d45 = /* #__PURE__ */ (0, $b904376875f9b144$export$e2d92d8f89fdd92d)({
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    flatten: $209b60385dcf2884$export$bffa455ba8c619a6,
    isNumeric: $209b60385dcf2884$export$e90fb89750dba83f,
    isZero: $209b60385dcf2884$export$c46ec7d82fb1f602,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    smaller: $209b60385dcf2884$export$3f732695c1493aec,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$5c1ba7f73c917315 = /* #__PURE__ */ (0, $39facb57073ad4d3$export$1e04c9355dadf1c8)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
    mod: $209b60385dcf2884$export$842a2cf37af977e1,
    smaller: $209b60385dcf2884$export$3f732695c1493aec,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    xgcd: $209b60385dcf2884$export$6ba103b0465fe6cc
});
var $209b60385dcf2884$export$f686d97e407ec4ef = /* #__PURE__ */ (0, $f2886936ecd0f035$export$5d3af1956d9bb33b)({
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$144dcf16adfb9698 = /* #__PURE__ */ (0, $a6fbf051f9b6f22a$export$93da279859a704f0)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    log: $209b60385dcf2884$export$bef1f36f5486a6a3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$8960430cfd85939f = /* #__PURE__ */ (0, $3c6c9bc5ad48e278$export$b18a1b0c26c000ee)({
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$dcac7a71ff10ad82 = /* #__PURE__ */ (0, $739faf53f45efc18$export$9fa12a9d198718c8)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    compareNatural: $209b60385dcf2884$export$762e84baec56595d,
    size: $209b60385dcf2884$export$346677f925de839c,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$ec60221e756bab15 = /* #__PURE__ */ (0, $4b348e2ef5f983ee$export$c149680b9d8f2963)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    compareNatural: $209b60385dcf2884$export$762e84baec56595d,
    size: $209b60385dcf2884$export$346677f925de839c,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$ca5251f59a067f9a = /* #__PURE__ */ (0, $bd1ec53a8ba99770$export$40ad73493b9f8712)({
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    compareNatural: $209b60385dcf2884$export$762e84baec56595d,
    size: $209b60385dcf2884$export$346677f925de839c,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$f6ce4c11993e56f2 = /* #__PURE__ */ (0, $5c9cdd0a4629e6cd$export$55c6b5cb0b0637db)({
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    compareNatural: $209b60385dcf2884$export$762e84baec56595d,
    size: $209b60385dcf2884$export$346677f925de839c,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$8d38c87f33a93d98 = /* #__PURE__ */ (0, $a72eaf45d8253930$export$e1b2fff975be9083)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$97db5808d8f88186 = /* #__PURE__ */ (0, $0d272956785d1388$export$10463693a2093403)({
    compare: $209b60385dcf2884$export$398604a469f7de9a,
    compareNatural: $209b60385dcf2884$export$762e84baec56595d,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$b20c1c5fa0c7dd75 = /* #__PURE__ */ (0, $fe39bda396a8c79c$export$833e6c382e279d04)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$21c0ac7fe1cef1b8 = /* #__PURE__ */ (0, $b2c13d33c3f9595a$export$15a698d88cae0eff)({
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    not: $209b60385dcf2884$export$6003a5f097c73977,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b
});
var $209b60385dcf2884$export$d02631cccf789723 = /* #__PURE__ */ (0, $74b267caaabc4839$export$d372f2f3c4d1b8e5)({
    bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    isPositive: $209b60385dcf2884$export$7e69d4236fcc3b19,
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    largerEq: $209b60385dcf2884$export$72693dfc692346df,
    smaller: $209b60385dcf2884$export$3f732695c1493aec,
    smallerEq: $209b60385dcf2884$export$8d38c87f33a93d98,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$120ff0929b202a6d = /* #__PURE__ */ (0, $32060d84ed5feee2$export$3442c5d213434705)({
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    range: $209b60385dcf2884$export$d02631cccf789723,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$8bd517cc5b3722f7 = /* #__PURE__ */ (0, $c8758c7f18bbcb02$export$d81c0f9dab86d854)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    compareNatural: $209b60385dcf2884$export$762e84baec56595d,
    size: $209b60385dcf2884$export$346677f925de839c,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$8bb4a52260216736 = /* #__PURE__ */ (0, $64ceee9b9a5f8d84$export$d1f961d649e525df)({
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    compareNatural: $209b60385dcf2884$export$762e84baec56595d,
    size: $209b60385dcf2884$export$346677f925de839c,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$a7eac91d5496c35b = /* #__PURE__ */ (0, $231328e32a912b3b$export$4a9a0ead2012bfc4)({
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    setDifference: $209b60385dcf2884$export$8bd517cc5b3722f7,
    size: $209b60385dcf2884$export$346677f925de839c,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$6d4069f4b64f7492 = /* #__PURE__ */ (0, $740d8ea2f318c5be$export$5e37e847685a0540)({
    FibonacciHeap: $209b60385dcf2884$export$dd5bb73729f20aa3,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156
});
var $209b60385dcf2884$export$4e0c71f277ca26b3 = /* #__PURE__ */ (0, $e16a495e01b5c57a$export$1bfa986e9c92c0b5)({
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    range: $209b60385dcf2884$export$d02631cccf789723,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$c02accee9f2b6a8f = /* #__PURE__ */ (0, $9cc11cdde88fab9f$export$ad9771ef9eafe06a)({
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    det: $209b60385dcf2884$export$d063d65fed97e7fa,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    identity: $209b60385dcf2884$export$f0954fd7d5368655,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    unaryMinus: $209b60385dcf2884$export$6cd304851a69e08
});
var $209b60385dcf2884$export$91d2d01a33a1e6f8 = /* #__PURE__ */ (0, $70a7445f2fdeaccc$export$86ddf344397699d5)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    Spa: $209b60385dcf2884$export$6d4069f4b64f7492,
    SparseMatrix: $209b60385dcf2884$export$de9b2b7556879848,
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    unaryMinus: $209b60385dcf2884$export$6cd304851a69e08
});
var $209b60385dcf2884$export$5cde0f23b96c7c61 = /* #__PURE__ */ (0, $38b7699e16ae7f7c$export$1456c5eaeee6aa07)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    ctranspose: $209b60385dcf2884$export$eb6ad7870b1d0b0b,
    deepEqual: $209b60385dcf2884$export$9cb4719e2e525b7a,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    dot: $209b60385dcf2884$export$94132a0e348806d4,
    dotDivide: $209b60385dcf2884$export$c74f132961c51406,
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    inv: $209b60385dcf2884$export$c02accee9f2b6a8f,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$9c297f60e22e3389 = /* #__PURE__ */ (0, $d6b57bce62d2aee4$export$9c94d2d08a8d8146)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    fraction: $209b60385dcf2884$export$7f34ce79760854f7,
    identity: $209b60385dcf2884$export$f0954fd7d5368655,
    inv: $209b60385dcf2884$export$c02accee9f2b6a8f,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    number: $209b60385dcf2884$export$98e628dec113755e,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$9404cfefeb010e68 = /* #__PURE__ */ (0, $706a989b4326e615$export$b20ee2bdfbf6defd)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    compareNatural: $209b60385dcf2884$export$762e84baec56595d,
    size: $209b60385dcf2884$export$346677f925de839c,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$667066422fa0af46 = /* #__PURE__ */ (0, $47d57cff4da74de8$export$fbdfd2054d37f888)({
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    setIntersect: $209b60385dcf2884$export$9404cfefeb010e68,
    setSymDifference: $209b60385dcf2884$export$a7eac91d5496c35b,
    size: $209b60385dcf2884$export$346677f925de839c,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$17c7cd2216e18593 = /* #__PURE__ */ (0, $9cac357e7d6ae4b5$export$71d0f952576e7511)({
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    identity: $209b60385dcf2884$export$f0954fd7d5368655,
    inv: $209b60385dcf2884$export$c02accee9f2b6a8f,
    map: $209b60385dcf2884$export$871de8747c9eaa88,
    max: $209b60385dcf2884$export$8960430cfd85939f,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    size: $209b60385dcf2884$export$346677f925de839c,
    sqrt: $209b60385dcf2884$export$eba8049fb5020b81,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$1d8b9ae22d404866 = /* #__PURE__ */ (0, $f5aa26fb27a90528$export$3ad06557a3ac7a63)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    Fraction: $209b60385dcf2884$export$b336c2702c498be5,
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    fix: $209b60385dcf2884$export$d838837eb5b184e3,
    format: $209b60385dcf2884$export$d9468344d3651243,
    isNumeric: $209b60385dcf2884$export$e90fb89750dba83f,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    number: $209b60385dcf2884$export$98e628dec113755e,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    round: $209b60385dcf2884$export$2077e0241d6afd3c,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658
});
var $209b60385dcf2884$export$4b15dbe639ad9539 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$c9ff08d282f03cf0)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$2bcc1e96766dec50 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$3c74568e9574d168)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$11b531e5540c3ca4 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$2f8d2da219209d0a)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$c779781d69f736e8 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$f5851397fd1173db)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$f727e86dcab4e2c6 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$221b7a8c9510b6cc)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$6eafe330bdda8c71 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$e26bbd27fc291ddf)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$2f2e110dac549211 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$815f2029cd62d0d6)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$80bf07f129ad1319 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$a403f6c5bed71f22)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$ef3b15136279c2ab = /* #__PURE__ */ (0, $76cfd3284e4236cd$export$734b49568d8effd6)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$11ff82822f958f25 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$d69030cf93f04407)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$199cdfec7f52c877 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$542715ad7e3a9798)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$d9bacaa51f70e8e = /* #__PURE__ */ (0, $b8ceb10535e48d66$export$f2c0a6357ff6cb4c)({
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    identity: $209b60385dcf2884$export$f0954fd7d5368655,
    inv: $209b60385dcf2884$export$c02accee9f2b6a8f,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$7130fbae042d5c0f = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$17ef8d738c9b0091)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$a535ef183b6128fa = /* #__PURE__ */ (0, $f5f567aafaf6dcdc$export$41ce8d9733cb73c1)({
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    ceil: $209b60385dcf2884$export$803ce6b71a0a94b2,
    conj: $209b60385dcf2884$export$fb254c661fe9c0db,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    dotDivide: $209b60385dcf2884$export$c74f132961c51406,
    exp: $209b60385dcf2884$export$b310ec824aaee37f,
    i: $209b60385dcf2884$export$23f2a1d2818174ef,
    log2: $209b60385dcf2884$export$b9fae0bba9d9094d,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    tau: $209b60385dcf2884$export$a4b4b4d4d776fe92,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$a7ebe8cc6aaf8d37 = /* #__PURE__ */ (0, $39088a69841814d3$export$115da31fc3cf3d15)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$d9cccfa50756330b = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$157e78cb05354391)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$37b0dd3693d47685 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$8bb818baeaa40bd6)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$776649b0bf8ce1fd = /* #__PURE__ */ (0, $92817f2759acbcf2$export$fb893320704d694a)({
    conj: $209b60385dcf2884$export$fb254c661fe9c0db,
    dotDivide: $209b60385dcf2884$export$c74f132961c51406,
    fft: $209b60385dcf2884$export$a535ef183b6128fa,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$10054c6b64de12f5 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$e3f21ac13bee6a0f)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$9eedba962d6a1c01 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$c38bce537e0ffddb)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$ba3f3691dd1c5a7 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$e7fcb8898ecb0703)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$6d4ff429f3f89356 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$85414d775c93e6de)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$dacf4a2cf8881dff = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$12e2358797b853c9)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$ba7a41eda790cc15 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$676d5ebe8fbeb250)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$7274fb1d27d1cd19 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$9670d94122b9a81b)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$9b1b4e5bc980cec6 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$43e139a6eec1ab59)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$c20ab336465d7d5e = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$675ebbcd6bdcebd7)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$5a85cd1a26c2cced = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$d21f20fc89fac8c0)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$1c88a737209eb089 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$f357c1a8d4fccef6)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$5d88bfa2004001d3 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$6840f334b8a5b6b1)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$963167ae5579ea00 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$50bee65ab76b402)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$683732ab8f5759dc = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$fd1b48ecb0d5c0ef)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$1f7c42a78c01e4f9 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$ea93a35a6f35e1b6)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$5d66ae3b3e8fce48 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$ace78258608300fc)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$f63e81544c3d56ef = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$a943525a62f69cd2)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$93039724ea765a8e = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$229739a879741f68)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$1236f2451dbdfd63 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$4924e3d8de6ad850)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$5a57f82afcc3edeb = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$19b72356ad84e4ee)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$aab44654646f3ccc = /* #__PURE__ */ (0, $402f4511b2372d65$export$27641941eb5cadbb)({
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$cd007d971a5a2143 = /* #__PURE__ */ (0, $8da595bfc6f83799$export$4df5e56bb6d14758)({
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    inv: $209b60385dcf2884$export$c02accee9f2b6a8f,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$c00fb43e712bef2c = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$85362d2a7862e209)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$329ce89a99f0e343 = /* #__PURE__ */ (0, $7a023b320bdc24d4$export$92c37ad44e3d0481)({
    gamma: $209b60385dcf2884$export$a7ebe8cc6aaf8d37,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$f83f3c3b84952e0b = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$266a9bae8a62fb6e)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$bfb00cec0048377d = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$42b5845f95e0feee)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$f060c4f0aa5bef89 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$f2f136373157165b)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$fccc724a69f253a = /* #__PURE__ */ (0, $5e96a71d9fe5174b$export$a3f0777edf21dcd5)({
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    lsolve: $209b60385dcf2884$export$be3b83cc1aa539e4,
    lup: $209b60385dcf2884$export$91d2d01a33a1e6f8,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    slu: $209b60385dcf2884$export$95c7459688ef4e3a,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    usolve: $209b60385dcf2884$export$41828460570e21eb
});
var $209b60385dcf2884$export$699e2a89b148c5ee = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$fd46b6c8680e4d01)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$9589ebe123df8f2e = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$d5045cf71611a462)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$f4d580f3101a1c7e = /* #__PURE__ */ (0, $c035f40e00852fc3$export$b15aee1001d110)({
    add: $209b60385dcf2884$export$e16d8520af44a096,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    factorial: $209b60385dcf2884$export$329ce89a99f0e343,
    isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
    isPositive: $209b60385dcf2884$export$7e69d4236fcc3b19,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$4567adbe5dd91621 = /* #__PURE__ */ (0, $9e4e8d94f58c66f2$export$1d58d7915914cc9c)({
    factorial: $209b60385dcf2884$export$329ce89a99f0e343,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$5ce790af25e5ac75 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$d44b96c94520b20e)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$a543de521896982d = /* #__PURE__ */ (0, $bc14bec9ad559c32$export$b41551d8a03b9b7f)({
    add: $209b60385dcf2884$export$e16d8520af44a096,
    cbrt: $209b60385dcf2884$export$841fc4d5a1480b85,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    im: $209b60385dcf2884$export$5fc500b917996661,
    isZero: $209b60385dcf2884$export$c46ec7d82fb1f602,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    re: $209b60385dcf2884$export$b1f1627d659a651,
    sqrt: $209b60385dcf2884$export$eba8049fb5020b81,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typeOf: $209b60385dcf2884$export$f5bbd400c2f4426f,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    unaryMinus: $209b60385dcf2884$export$6cd304851a69e08
});
var $209b60385dcf2884$export$1c70a6cc12bc0366 = /* #__PURE__ */ (0, $46df54224eee310f$export$55134310fc79366a)({
    compareNatural: $209b60385dcf2884$export$762e84baec56595d,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$877a84c9618ec845 = /* #__PURE__ */ (0, $4f98e7629f4c1b51$export$73f8b9bd532fee8)({
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    isNegative: $209b60385dcf2884$export$d0909a4f38b5c4d0,
    isPositive: $209b60385dcf2884$export$7e69d4236fcc3b19,
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    map: $209b60385dcf2884$export$871de8747c9eaa88,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    max: $209b60385dcf2884$export$8960430cfd85939f,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    smaller: $209b60385dcf2884$export$3f732695c1493aec,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    unaryMinus: $209b60385dcf2884$export$6cd304851a69e08
});
var $209b60385dcf2884$export$a5abae3de3985f2f = /* #__PURE__ */ (0, $a1b77682c2eda603$export$18813d136a9b83d0)({
    bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    combinations: $209b60385dcf2884$export$bdfcf4c6b5766439,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    factorial: $209b60385dcf2884$export$329ce89a99f0e343,
    isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
    isNegative: $209b60385dcf2884$export$d0909a4f38b5c4d0,
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    number: $209b60385dcf2884$export$98e628dec113755e,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$523c0b569236b342 = /* #__PURE__ */ (0, $dc7b520117824df4$export$17074f98b69d2545)({
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$bb522a71cda46a13 = /* #__PURE__ */ (0, $18ba17d26d484454$export$7b7dc3bd00d38afb)({
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
    isNegative: $209b60385dcf2884$export$d0909a4f38b5c4d0,
    stirlingS2: $209b60385dcf2884$export$a5abae3de3985f2f,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$e822b38c59ee8a2a = /* #__PURE__ */ (0, $67be443f2a674d81$export$ba9e077a2df092d7)({
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    atan: $209b60385dcf2884$export$628dc4eed22b0fbd,
    bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
    column: $209b60385dcf2884$export$4e0c71f277ca26b3,
    complex: $209b60385dcf2884$export$83a0e34f1302825b,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    cos: $209b60385dcf2884$export$50d414a77b60d802,
    diag: $209b60385dcf2884$export$c042e7c2f59bc046,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    dot: $209b60385dcf2884$export$94132a0e348806d4,
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    flatten: $209b60385dcf2884$export$bffa455ba8c619a6,
    im: $209b60385dcf2884$export$5fc500b917996661,
    inv: $209b60385dcf2884$export$c02accee9f2b6a8f,
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    matrixFromColumns: $209b60385dcf2884$export$e8999e227859a482,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    number: $209b60385dcf2884$export$98e628dec113755e,
    qr: $209b60385dcf2884$export$7c27fb47516129d9,
    re: $209b60385dcf2884$export$b1f1627d659a651,
    reshape: $209b60385dcf2884$export$9eaad88cf88cee2b,
    sin: $209b60385dcf2884$export$5de3937cb4b592ed,
    size: $209b60385dcf2884$export$346677f925de839c,
    smaller: $209b60385dcf2884$export$3f732695c1493aec,
    sqrt: $209b60385dcf2884$export$eba8049fb5020b81,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    usolve: $209b60385dcf2884$export$41828460570e21eb,
    usolveAll: $209b60385dcf2884$export$c8a1cf0e83678d9
});
var $209b60385dcf2884$export$84a9a66802fec40 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$b6687a2f3911256b)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$a614e1ad972260a9 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$85a77a0842c24f74)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$a9fffb6ae6e33dcc = /* #__PURE__ */ (0, $f35cb8b4b634fc03$export$eaa5cb8fd86b8d43)({
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    dotDivide: $209b60385dcf2884$export$c74f132961c51406,
    isNumeric: $209b60385dcf2884$export$e90fb89750dba83f,
    log: $209b60385dcf2884$export$bef1f36f5486a6a3,
    map: $209b60385dcf2884$export$871de8747c9eaa88,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    sum: $209b60385dcf2884$export$8a63f25cc62965f1,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$1ce691f85baaa52 = /* #__PURE__ */ (0, $12c6138c58f8eae0$export$301ef7ca1de6782c)({
    add: $209b60385dcf2884$export$e16d8520af44a096,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$863459416408c428 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$f5e8f56ebfacbaca)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$cbd33810258dab2e = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$e58ff8150d83ea6a)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$ff63ee916cadcfe = /* #__PURE__ */ (0, $35d974c6d0137ed7$export$524607d17ea053e9)({
    bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    compare: $209b60385dcf2884$export$398604a469f7de9a,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    partitionSelect: $209b60385dcf2884$export$54d1e322cf7aa273,
    smaller: $209b60385dcf2884$export$3f732695c1493aec,
    smallerEq: $209b60385dcf2884$export$8d38c87f33a93d98,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$9b77da0927470c3d = /* #__PURE__ */ (0, $97b420845d05c5d5$export$b989221824390fb)({
    add: $209b60385dcf2884$export$e16d8520af44a096,
    apply: $209b60385dcf2884$export$5635d7ef4b8fee1c,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    isNaN: $209b60385dcf2884$export$c9f5652083b8129d,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$f48a0c6b8cc21601 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$68a9771dccce9a23)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$9c490b34b2f16a34 = /* #__PURE__ */ (0, $8c506d8b3b8052eb$export$cdebf3fc89add777)({
    add: $209b60385dcf2884$export$e16d8520af44a096,
    compare: $209b60385dcf2884$export$398604a469f7de9a,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    partitionSelect: $209b60385dcf2884$export$54d1e322cf7aa273,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$962a8812c08af262 = /* #__PURE__ */ (0, $c289bf3dd95c4280$export$10240de9e69376f9)({
    add: $209b60385dcf2884$export$e16d8520af44a096,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    mean: $209b60385dcf2884$export$1ce691f85baaa52,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    sqrt: $209b60385dcf2884$export$eba8049fb5020b81,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    sum: $209b60385dcf2884$export$8a63f25cc62965f1,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$d343cdcf8054100e = /* #__PURE__ */ (0, $6c3b824257ddbc95$export$5a5299860d551a36)({
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$b14ea41a64d6efa6 = /* #__PURE__ */ (0, $268c74e19f98e220$export$7b17fbe41c88575a)({
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    map: $209b60385dcf2884$export$871de8747c9eaa88,
    median: $209b60385dcf2884$export$9c490b34b2f16a34,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$b14c5e819cb6c927 = /* #__PURE__ */ (0, $76f34cb06b4782d2$export$d3f0a8dda5df7afd)({
    map: $209b60385dcf2884$export$871de8747c9eaa88,
    sqrt: $209b60385dcf2884$export$eba8049fb5020b81,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    variance: $209b60385dcf2884$export$9b77da0927470c3d
});
var $209b60385dcf2884$export$327d565dd49bd5b0 = /* #__PURE__ */ (0, $62a8e78e77cf4b97$export$7bb33f27b1ded438)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    factorial: $209b60385dcf2884$export$329ce89a99f0e343,
    gamma: $209b60385dcf2884$export$a7ebe8cc6aaf8d37,
    isNegative: $209b60385dcf2884$export$d0909a4f38b5c4d0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    pi: $209b60385dcf2884$export$18c7bea995a110f,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    sin: $209b60385dcf2884$export$5de3937cb4b592ed,
    smallerEq: $209b60385dcf2884$export$8d38c87f33a93d98,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$1991ecd29cc92c6b = /* #__PURE__ */ (0, $6d4110c279646dec$export$ce85a9d2952c2966)({
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    conj: $209b60385dcf2884$export$fb254c661fe9c0db,
    ctranspose: $209b60385dcf2884$export$eb6ad7870b1d0b0b,
    eigs: $209b60385dcf2884$export$e822b38c59ee8a2a,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    smaller: $209b60385dcf2884$export$3f732695c1493aec,
    sqrt: $209b60385dcf2884$export$eba8049fb5020b81,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$52ded331ee8b28e8 = /* #__PURE__ */ (0, $32649f08c528ce08$export$7c79514a80dc15a2)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    SparseMatrix: $209b60385dcf2884$export$de9b2b7556879848,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    cos: $209b60385dcf2884$export$50d414a77b60d802,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    norm: $209b60385dcf2884$export$1991ecd29cc92c6b,
    sin: $209b60385dcf2884$export$5de3937cb4b592ed,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    unaryMinus: $209b60385dcf2884$export$6cd304851a69e08
});
var $209b60385dcf2884$export$85aaf319784a5b0 = /* #__PURE__ */ (0, $0fc922cf7b8f0510$export$3bf63d7b96fd8541)({
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
var $209b60385dcf2884$export$c81e2c0e8b1065f5 = /* #__PURE__ */ (0, $4976518eea094a85$export$7c8bdcd3ab83037d)({
    identity: $209b60385dcf2884$export$f0954fd7d5368655,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    norm: $209b60385dcf2884$export$1991ecd29cc92c6b,
    qr: $209b60385dcf2884$export$7c27fb47516129d9,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$bb628a54ab399bc9 = /* #__PURE__ */ (0, $b94207871d7275ac$export$484058214789ee04)({
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    rotationMatrix: $209b60385dcf2884$export$52ded331ee8b28e8,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$7f6dd94c0096067a = /* #__PURE__ */ (0, $0c932622b244290f$export$9b5f479487e82b81)({
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    identity: $209b60385dcf2884$export$f0954fd7d5368655,
    index: $209b60385dcf2884$export$b610b8812bbcded9,
    lusolve: $209b60385dcf2884$export$fccc724a69f253a,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    matrixFromColumns: $209b60385dcf2884$export$e8999e227859a482,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    range: $209b60385dcf2884$export$d02631cccf789723,
    schur: $209b60385dcf2884$export$c81e2c0e8b1065f5,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    transpose: $209b60385dcf2884$export$9cb09a71b7d66923,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $209b60385dcf2884$export$462de2f2fa40b84 = /* #__PURE__ */ (0, $0c3ca4ef51d787c8$export$4279d742852ce356)({
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    sylvester: $209b60385dcf2884$export$7f6dd94c0096067a,
    transpose: $209b60385dcf2884$export$9cb09a71b7d66923,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});








function $9792df5d0777eb88$export$1b927030cd80a31b(err) {
    if (err && err.isIndexError) return new (0, $7e61b13fb7752c23$export$efa5eacb1304c464)(err.index + 1, err.min + 1, err.max !== undefined ? err.max + 1 : undefined);
    return err;
}



function $966c1a5ba5d74076$export$f8ba146648777f78(_ref) {
    var { subset: subset } = _ref;
    /**
   * Retrieve part of an object:
   *
   * - Retrieve a property from an object
   * - Retrieve a part of a string
   * - Retrieve a matrix subset
   *
   * @param {Object | Array | Matrix | string} object
   * @param {Index} index
   * @return {Object | Array | Matrix | string} Returns the subset
   */ return function access(object, index) {
        try {
            if (Array.isArray(object)) return subset(object, index);
            else if (object && typeof object.subset === "function") // Matrix
            return object.subset(index);
            else if (typeof object === "string") // TODO: move getStringSubset into a separate util file, use that
            return subset(object, index);
            else if (typeof object === "object") {
                if (!index.isObjectProperty()) throw new TypeError("Cannot apply a numeric index as object property");
                return (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(object, index.getObjectProperty());
            } else throw new TypeError("Cannot apply index: unsupported type of object");
        } catch (err) {
            throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
        }
    };
}


var $cbdb93e4bf22ecad$var$name = "AccessorNode";
var $cbdb93e4bf22ecad$var$dependencies = [
    "subset",
    "Node"
];
var $cbdb93e4bf22ecad$export$a21116b1766eb74 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($cbdb93e4bf22ecad$var$name, $cbdb93e4bf22ecad$var$dependencies, (_ref)=>{
    var { subset: subset, Node: Node } = _ref;
    var access = (0, $966c1a5ba5d74076$export$f8ba146648777f78)({
        subset: subset
    });
    /**
   * Are parenthesis needed?
   * @private
   */ function needParenthesis(node) {
        // TODO: maybe make a method on the nodes which tells whether they need parenthesis?
        return !((0, $23cfe017d190638f$export$f88fb19d6b9ee5cb)(node) || (0, $23cfe017d190638f$export$440fa93dcf2757a3)(node) || (0, $23cfe017d190638f$export$fa9d80731fd8c54b)(node) || (0, $23cfe017d190638f$export$6ae03b16e064e6c4)(node) || (0, $23cfe017d190638f$export$3f18867a334658e9)(node) || (0, $23cfe017d190638f$export$c55e3736c5721220)(node) || (0, $23cfe017d190638f$export$87815d550facaed9)(node));
    }
    class AccessorNode extends Node {
        // readonly property name
        get name() {
            if (this.index) return this.index.isObjectProperty() ? this.index.getObjectProperty() : "";
            else return this.object.name || "";
        }
        get type() {
            return $cbdb93e4bf22ecad$var$name;
        }
        get isAccessorNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            var evalObject = this.object._compile(math, argNames);
            var evalIndex = this.index._compile(math, argNames);
            if (this.index.isObjectProperty()) {
                var prop = this.index.getObjectProperty();
                return function evalAccessorNode(scope, args, context) {
                    // get a property from an object evaluated using the scope.
                    return (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(evalObject(scope, args, context), prop);
                };
            } else return function evalAccessorNode(scope, args, context) {
                var object = evalObject(scope, args, context);
                // we pass just object here instead of context:
                var index = evalIndex(scope, args, object);
                return access(object, index);
            };
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            callback(this.object, "object", this);
            callback(this.index, "index", this);
        }
        /**
     * Create a new AccessorNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {AccessorNode} Returns a transformed copy of the node
     */ map(callback) {
            return new AccessorNode(this._ifNode(callback(this.object, "object", this)), this._ifNode(callback(this.index, "index", this)));
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {AccessorNode}
     */ clone() {
            return new AccessorNode(this.object, this.index);
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string}
     */ _toString(options) {
            var object = this.object.toString(options);
            if (needParenthesis(this.object)) object = "(" + object + ")";
            return object + this.index.toString(options);
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string}
     */ _toHTML(options) {
            var object = this.object.toHTML(options);
            if (needParenthesis(this.object)) object = '<span class="math-parenthesis math-round-parenthesis">(</span>' + object + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            return object + this.index.toHTML(options);
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string}
     */ _toTex(options) {
            var object = this.object.toTex(options);
            if (needParenthesis(this.object)) object = "\\left(' + object + '\\right)";
            return object + this.index.toTex(options);
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $cbdb93e4bf22ecad$var$name,
                object: this.object,
                index: this.index
            };
        }
        /**
     * Instantiate an AccessorNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "AccessorNode", object: ..., index: ...}`,
     *     where mathjs is optional
     * @returns {AccessorNode}
     */ static fromJSON(json) {
            return new AccessorNode(json.object, json.index);
        }
        /**
     * @constructor AccessorNode
     * @extends {Node}
     * Access an object property or get a matrix subset
     *
     * @param {Node} object                 The object from which to retrieve
     *                                      a property or subset.
     * @param {IndexNode} index             IndexNode containing ranges
     */ constructor(object, index){
            super();
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(object)) throw new TypeError('Node expected for parameter "object"');
            if (!(0, $23cfe017d190638f$export$ff90979121a6cabc)(index)) throw new TypeError('IndexNode expected for parameter "index"');
            this.object = object;
            this.index = index;
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(AccessorNode, "name", $cbdb93e4bf22ecad$var$name);
    return AccessorNode;
}, {
    isClass: true,
    isNode: true
});




var $745940dcea7aa6ce$var$name = "and";
var $745940dcea7aa6ce$var$dependencies = [
    "typed",
    "matrix",
    "zeros",
    "add",
    "equalScalar",
    "not",
    "concat"
];
var $745940dcea7aa6ce$export$6164f7c7c2c93691 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($745940dcea7aa6ce$var$name, $745940dcea7aa6ce$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, not: not, concat: concat } = _ref;
    var and = (0, $b2c13d33c3f9595a$export$15a698d88cae0eff)({
        typed: typed,
        matrix: matrix,
        equalScalar: equalScalar,
        zeros: zeros,
        not: not,
        concat: concat
    });
    function andTransform(args, math, scope) {
        var condition1 = args[0].compile().evaluate(scope);
        if (!(0, $23cfe017d190638f$export$cea7aa84e978eba5)(condition1) && !and(condition1, true)) return false;
        var condition2 = args[1].compile().evaluate(scope);
        return and(condition1, condition2);
    }
    andTransform.rawArgs = true;
    return andTransform;
}, {
    isTransformFunction: true
});





var $effd660edd3438e3$var$name = "apply";
var $effd660edd3438e3$var$dependencies = [
    "typed",
    "isInteger"
];
var $effd660edd3438e3$export$1c2b553a3b99e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($effd660edd3438e3$var$name, $effd660edd3438e3$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    var apply = (0, $b9ebe2aeb9e55336$export$5ccffa1686df7f00)({
        typed: typed,
        isInteger: isInteger
    });
    // @see: comment of concat itself
    return typed("apply", {
        "...any": function any(args) {
            // change dim from one-based to zero-based
            var dim = args[1];
            if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(dim)) args[1] = dim - 1;
            else if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(dim)) args[1] = dim.minus(1);
            try {
                return apply.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});





var $a0b5f232970dc845$var$name = "ArrayNode";
var $a0b5f232970dc845$var$dependencies = [
    "Node"
];
var $a0b5f232970dc845$export$c4666c772dc9bece = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a0b5f232970dc845$var$name, $a0b5f232970dc845$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    class ArrayNode extends Node {
        get type() {
            return $a0b5f232970dc845$var$name;
        }
        get isArrayNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            var evalItems = (0, $eee21df0c3527ff1$export$871de8747c9eaa88)(this.items, function(item) {
                return item._compile(math, argNames);
            });
            var asMatrix = math.config.matrix !== "Array";
            if (asMatrix) {
                var matrix = math.matrix;
                return function evalArrayNode(scope, args, context) {
                    return matrix((0, $eee21df0c3527ff1$export$871de8747c9eaa88)(evalItems, function(evalItem) {
                        return evalItem(scope, args, context);
                    }));
                };
            } else return function evalArrayNode(scope, args, context) {
                return (0, $eee21df0c3527ff1$export$871de8747c9eaa88)(evalItems, function(evalItem) {
                    return evalItem(scope, args, context);
                });
            };
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            for(var i = 0; i < this.items.length; i++){
                var node = this.items[i];
                callback(node, "items[" + i + "]", this);
            }
        }
        /**
     * Create a new ArrayNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ArrayNode} Returns a transformed copy of the node
     */ map(callback) {
            var items = [];
            for(var i = 0; i < this.items.length; i++)items[i] = this._ifNode(callback(this.items[i], "items[" + i + "]", this));
            return new ArrayNode(items);
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {ArrayNode}
     */ clone() {
            return new ArrayNode(this.items.slice(0));
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toString(options) {
            var items = this.items.map(function(node) {
                return node.toString(options);
            });
            return "[" + items.join(", ") + "]";
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $a0b5f232970dc845$var$name,
                items: this.items
            };
        }
        /**
     * Instantiate an ArrayNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ArrayNode", items: [...]}`,
     *                       where mathjs is optional
     * @returns {ArrayNode}
     */ static fromJSON(json) {
            return new ArrayNode(json.items);
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toHTML(options) {
            var items = this.items.map(function(node) {
                return node.toHTML(options);
            });
            return '<span class="math-parenthesis math-square-parenthesis">[</span>' + items.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */ _toTex(options) {
            function itemsToTex(items, nested) {
                var mixedItems = items.some((0, $23cfe017d190638f$export$440fa93dcf2757a3)) && !items.every((0, $23cfe017d190638f$export$440fa93dcf2757a3));
                var itemsFormRow = nested || mixedItems;
                var itemSep = itemsFormRow ? "&" : "\\\\";
                var itemsTex = items.map(function(node) {
                    if (node.items) return itemsToTex(node.items, !nested);
                    else return node.toTex(options);
                }).join(itemSep);
                return mixedItems || !itemsFormRow || itemsFormRow && !nested ? "\\begin{bmatrix}" + itemsTex + "\\end{bmatrix}" : itemsTex;
            }
            return itemsToTex(this.items, false);
        }
        /**
     * @constructor ArrayNode
     * @extends {Node}
     * Holds an 1-dimensional array with items
     * @param {Node[]} [items]   1 dimensional array with items
     */ constructor(items){
            super();
            this.items = items || [];
            // validate input
            if (!Array.isArray(this.items) || !this.items.every((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee))) throw new TypeError("Array containing Nodes expected");
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(ArrayNode, "name", $a0b5f232970dc845$var$name);
    return ArrayNode;
}, {
    isClass: true,
    isNode: true
});








function $685333569f2029ef$export$796df36381b10d7d(_ref) {
    var { subset: subset, matrix: matrix } = _ref;
    /**
   * Replace part of an object:
   *
   * - Assign a property to an object
   * - Replace a part of a string
   * - Replace a matrix subset
   *
   * @param {Object | Array | Matrix | string} object
   * @param {Index} index
   * @param {*} value
   * @return {Object | Array | Matrix | string} Returns the original object
   *                                            except in case of a string
   */ // TODO: change assign to return the value instead of the object
    return function assign(object, index, value) {
        try {
            if (Array.isArray(object)) {
                var result = matrix(object).subset(index, value).valueOf();
                // shallow copy all (updated) items into the original array
                result.forEach((item, index)=>{
                    object[index] = item;
                });
                return object;
            } else if (object && typeof object.subset === "function") // Matrix
            return object.subset(index, value);
            else if (typeof object === "string") // TODO: move setStringSubset into a separate util file, use that
            return subset(object, index, value);
            else if (typeof object === "object") {
                if (!index.isObjectProperty()) throw TypeError("Cannot apply a numeric index as object property");
                (0, $f59a31bcbbaa9e5a$export$e99fe8700ee9f9cd)(object, index.getObjectProperty(), value);
                return object;
            } else throw new TypeError("Cannot apply index: unsupported type of object");
        } catch (err) {
            throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
        }
    };
}


// list of identifiers of nodes in order of their precedence
// also contains information about left/right associativity
// and which other operator the operator is associative with
// Example:
// addition is associative with addition and subtraction, because:
// (a+b)+c=a+(b+c)
// (a+b)-c=a+(b-c)
//
// postfix operators are left associative, prefix operators
// are right associative
//
// It's also possible to set the following properties:
// latexParens: if set to false, this node doesn't need to be enclosed
//              in parentheses when using LaTeX
// latexLeftParens: if set to false, this !OperatorNode's!
//                  left argument doesn't need to be enclosed
//                  in parentheses
// latexRightParens: the same for the right argument


var $c57e483ac23cf50e$export$3cb21709c4058847 = [
    {
        // assignment
        AssignmentNode: {},
        FunctionAssignmentNode: {}
    },
    {
        // conditional expression
        ConditionalNode: {
            latexLeftParens: false,
            latexRightParens: false,
            latexParens: false
        }
    },
    {
        // logical or
        "OperatorNode:or": {
            op: "or",
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // logical xor
        "OperatorNode:xor": {
            op: "xor",
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // logical and
        "OperatorNode:and": {
            op: "and",
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise or
        "OperatorNode:bitOr": {
            op: "|",
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise xor
        "OperatorNode:bitXor": {
            op: "^|",
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitwise and
        "OperatorNode:bitAnd": {
            op: "&",
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // relational operators
        "OperatorNode:equal": {
            op: "==",
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:unequal": {
            op: "!=",
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:smaller": {
            op: "<",
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:larger": {
            op: ">",
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:smallerEq": {
            op: "<=",
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:largerEq": {
            op: ">=",
            associativity: "left",
            associativeWith: []
        },
        RelationalNode: {
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // bitshift operators
        "OperatorNode:leftShift": {
            op: "<<",
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:rightArithShift": {
            op: ">>",
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:rightLogShift": {
            op: ">>>",
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // unit conversion
        "OperatorNode:to": {
            op: "to",
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // range
        RangeNode: {}
    },
    {
        // addition, subtraction
        "OperatorNode:add": {
            op: "+",
            associativity: "left",
            associativeWith: [
                "OperatorNode:add",
                "OperatorNode:subtract"
            ]
        },
        "OperatorNode:subtract": {
            op: "-",
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // multiply, divide, modulus
        "OperatorNode:multiply": {
            op: "*",
            associativity: "left",
            associativeWith: [
                "OperatorNode:multiply",
                "OperatorNode:divide",
                "Operator:dotMultiply",
                "Operator:dotDivide"
            ]
        },
        "OperatorNode:divide": {
            op: "/",
            associativity: "left",
            associativeWith: [],
            latexLeftParens: false,
            latexRightParens: false,
            latexParens: false
        },
        "OperatorNode:dotMultiply": {
            op: ".*",
            associativity: "left",
            associativeWith: [
                "OperatorNode:multiply",
                "OperatorNode:divide",
                "OperatorNode:dotMultiply",
                "OperatorNode:doDivide"
            ]
        },
        "OperatorNode:dotDivide": {
            op: "./",
            associativity: "left",
            associativeWith: []
        },
        "OperatorNode:mod": {
            op: "mod",
            associativity: "left",
            associativeWith: []
        }
    },
    {
        // Repeat multiplication for implicit multiplication
        "OperatorNode:multiply": {
            associativity: "left",
            associativeWith: [
                "OperatorNode:multiply",
                "OperatorNode:divide",
                "Operator:dotMultiply",
                "Operator:dotDivide"
            ]
        }
    },
    {
        // unary prefix operators
        "OperatorNode:unaryPlus": {
            op: "+",
            associativity: "right"
        },
        "OperatorNode:unaryMinus": {
            op: "-",
            associativity: "right"
        },
        "OperatorNode:bitNot": {
            op: "~",
            associativity: "right"
        },
        "OperatorNode:not": {
            op: "not",
            associativity: "right"
        }
    },
    {
        // exponentiation
        "OperatorNode:pow": {
            op: "^",
            associativity: "right",
            associativeWith: [],
            latexRightParens: false
        },
        "OperatorNode:dotPow": {
            op: ".^",
            associativity: "right",
            associativeWith: []
        }
    },
    {
        // factorial
        "OperatorNode:factorial": {
            op: "!",
            associativity: "left"
        }
    },
    {
        // matrix transpose
        "OperatorNode:ctranspose": {
            op: "'",
            associativity: "left"
        }
    }
];
/**
 * Returns the first non-parenthesis internal node, but only
 * when the 'parenthesis' option is unset or auto.
 * @param {Node} _node
 * @param {string} parenthesis
 * @return {Node}
 */ function $c57e483ac23cf50e$var$unwrapParen(_node, parenthesis) {
    if (!parenthesis || parenthesis !== "auto") return _node;
    var node = _node;
    while((0, $23cfe017d190638f$export$c55e3736c5721220)(node))node = node.content;
    return node;
}
function $c57e483ac23cf50e$export$94314bea1477f3d5(_node, parenthesis, implicit, parent) {
    var node = _node;
    if (parenthesis !== "keep") // ParenthesisNodes are only ignored when not in 'keep' mode
    node = _node.getContent();
    var identifier = node.getIdentifier();
    var precedence = null;
    for(var i = 0; i < $c57e483ac23cf50e$export$3cb21709c4058847.length; i++)if (identifier in $c57e483ac23cf50e$export$3cb21709c4058847[i]) {
        precedence = i;
        break;
    }
    // Bump up precedence of implicit multiplication, except when preceded
    // by a "Rule 2" fraction ( [unaryOp]constant / constant )
    if (identifier === "OperatorNode:multiply" && node.implicit && implicit !== "show") {
        var leftArg = $c57e483ac23cf50e$var$unwrapParen(node.args[0], parenthesis);
        if (!((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(leftArg) && parent && parent.getIdentifier() === "OperatorNode:divide" && (0, $23cfe017d190638f$export$e6caeb7474dbdff3)($c57e483ac23cf50e$var$unwrapParen(parent.args[0], parenthesis))) && !(leftArg.getIdentifier() === "OperatorNode:divide" && (0, $23cfe017d190638f$export$e6caeb7474dbdff3)($c57e483ac23cf50e$var$unwrapParen(leftArg.args[0], parenthesis)) && (0, $23cfe017d190638f$export$fa9d80731fd8c54b)($c57e483ac23cf50e$var$unwrapParen(leftArg.args[1])))) precedence += 1;
    }
    return precedence;
}
function $c57e483ac23cf50e$export$8a3de49886b85474(_node, parenthesis) {
    var node = _node;
    if (parenthesis !== "keep") // ParenthesisNodes are only ignored when not in 'keep' mode
    node = _node.getContent();
    var identifier = node.getIdentifier();
    var index = $c57e483ac23cf50e$export$94314bea1477f3d5(node, parenthesis);
    if (index === null) // node isn't in the list
    return null;
    var property = $c57e483ac23cf50e$export$3cb21709c4058847[index][identifier];
    if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(property, "associativity")) {
        if (property.associativity === "left") return "left";
        if (property.associativity === "right") return "right";
        // associativity is invalid
        throw Error("'" + identifier + "' has the invalid associativity '" + property.associativity + "'.");
    }
    // associativity is undefined
    return null;
}
function $c57e483ac23cf50e$export$b539869f53b6850a(nodeA, nodeB, parenthesis) {
    // ParenthesisNodes are only ignored when not in 'keep' mode
    var a = parenthesis !== "keep" ? nodeA.getContent() : nodeA;
    var b = parenthesis !== "keep" ? nodeA.getContent() : nodeB;
    var identifierA = a.getIdentifier();
    var identifierB = b.getIdentifier();
    var index = $c57e483ac23cf50e$export$94314bea1477f3d5(a, parenthesis);
    if (index === null) // node isn't in the list
    return null;
    var property = $c57e483ac23cf50e$export$3cb21709c4058847[index][identifierA];
    if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(property, "associativeWith") && property.associativeWith instanceof Array) {
        for(var i = 0; i < property.associativeWith.length; i++){
            if (property.associativeWith[i] === identifierB) return true;
        }
        return false;
    }
    // associativeWith is not defined
    return null;
}
function $c57e483ac23cf50e$export$b6e51e32101e2448(fn) {
    var identifier = "OperatorNode:" + fn;
    for (var group of $c57e483ac23cf50e$export$3cb21709c4058847){
        if (identifier in group) return group[identifier].op;
    }
    return null;
}


var $a878721819780eba$var$name = "AssignmentNode";
var $a878721819780eba$var$dependencies = [
    "subset",
    "?matrix",
    // FIXME: should not be needed at all, should be handled by subset
    "Node"
];
var $a878721819780eba$export$1461ecd49f170d54 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a878721819780eba$var$name, $a878721819780eba$var$dependencies, (_ref)=>{
    var { subset: subset, matrix: matrix, Node: Node } = _ref;
    var access = (0, $966c1a5ba5d74076$export$f8ba146648777f78)({
        subset: subset
    });
    var assign = (0, $685333569f2029ef$export$796df36381b10d7d)({
        subset: subset,
        matrix: matrix
    });
    /*
   * Is parenthesis needed?
   * @param {node} node
   * @param {string} [parenthesis='keep']
   * @param {string} implicit
   * @private
   */ function needParenthesis(node, parenthesis, implicit) {
        if (!parenthesis) parenthesis = "keep";
        var precedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(node, parenthesis, implicit);
        var exprPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(node.value, parenthesis, implicit);
        return parenthesis === "all" || exprPrecedence !== null && exprPrecedence <= precedence;
    }
    class AssignmentNode extends Node {
        // class name for typing purposes:
        // readonly property name
        get name() {
            if (this.index) return this.index.isObjectProperty() ? this.index.getObjectProperty() : "";
            else return this.object.name || "";
        }
        get type() {
            return $a878721819780eba$var$name;
        }
        get isAssignmentNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            var evalObject = this.object._compile(math, argNames);
            var evalIndex = this.index ? this.index._compile(math, argNames) : null;
            var evalValue = this.value._compile(math, argNames);
            var name = this.object.name;
            if (!this.index) {
                // apply a variable to the scope, for example `a=2`
                if (!(0, $23cfe017d190638f$export$87815d550facaed9)(this.object)) throw new TypeError("SymbolNode expected as object");
                return function evalAssignmentNode(scope, args, context) {
                    var value = evalValue(scope, args, context);
                    scope.set(name, value);
                    return value;
                };
            } else if (this.index.isObjectProperty()) {
                // apply an object property for example `a.b=2`
                var prop = this.index.getObjectProperty();
                return function evalAssignmentNode(scope, args, context) {
                    var object = evalObject(scope, args, context);
                    var value = evalValue(scope, args, context);
                    (0, $f59a31bcbbaa9e5a$export$e99fe8700ee9f9cd)(object, prop, value);
                    return value;
                };
            } else if ((0, $23cfe017d190638f$export$87815d550facaed9)(this.object)) // update a matrix subset, for example `a[2]=3`
            return function evalAssignmentNode(scope, args, context) {
                var childObject = evalObject(scope, args, context);
                var value = evalValue(scope, args, context);
                // Important:  we pass childObject instead of context:
                var index = evalIndex(scope, args, childObject);
                scope.set(name, assign(childObject, index, value));
                return value;
            };
            else {
                // isAccessorNode(node.object) === true
                // update a matrix subset, for example `a.b[2]=3`
                // we will not use the compile function of the AccessorNode, but
                // compile it ourselves here as we need the parent object of the
                // AccessorNode:
                // wee need to apply the updated object to parent object
                var evalParentObject = this.object.object._compile(math, argNames);
                if (this.object.index.isObjectProperty()) {
                    var parentProp = this.object.index.getObjectProperty();
                    return function evalAssignmentNode(scope, args, context) {
                        var parent = evalParentObject(scope, args, context);
                        var childObject = (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(parent, parentProp);
                        // Important: we pass childObject instead of context:
                        var index = evalIndex(scope, args, childObject);
                        var value = evalValue(scope, args, context);
                        (0, $f59a31bcbbaa9e5a$export$e99fe8700ee9f9cd)(parent, parentProp, assign(childObject, index, value));
                        return value;
                    };
                } else {
                    // if some parameters use the 'end' parameter, we need to calculate
                    // the size
                    var evalParentIndex = this.object.index._compile(math, argNames);
                    return function evalAssignmentNode(scope, args, context) {
                        var parent = evalParentObject(scope, args, context);
                        // Important: we pass parent instead of context:
                        var parentIndex = evalParentIndex(scope, args, parent);
                        var childObject = access(parent, parentIndex);
                        // Important:  we pass childObject instead of context
                        var index = evalIndex(scope, args, childObject);
                        var value = evalValue(scope, args, context);
                        assign(parent, parentIndex, assign(childObject, index, value));
                        return value;
                    };
                }
            }
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            callback(this.object, "object", this);
            if (this.index) callback(this.index, "index", this);
            callback(this.value, "value", this);
        }
        /**
     * Create a new AssignmentNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {AssignmentNode} Returns a transformed copy of the node
     */ map(callback) {
            var object = this._ifNode(callback(this.object, "object", this));
            var index = this.index ? this._ifNode(callback(this.index, "index", this)) : null;
            var value = this._ifNode(callback(this.value, "value", this));
            return new AssignmentNode(object, index, value);
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {AssignmentNode}
     */ clone() {
            return new AssignmentNode(this.object, this.index, this.value);
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string}
     */ _toString(options) {
            var object = this.object.toString(options);
            var index = this.index ? this.index.toString(options) : "";
            var value = this.value.toString(options);
            if (needParenthesis(this, options && options.parenthesis, options && options.implicit)) value = "(" + value + ")";
            return object + index + " = " + value;
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $a878721819780eba$var$name,
                object: this.object,
                index: this.index,
                value: this.value
            };
        }
        /**
     * Instantiate an AssignmentNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "AssignmentNode", object: ..., index: ..., value: ...}`,
     *     where mathjs is optional
     * @returns {AssignmentNode}
     */ static fromJSON(json) {
            return new AssignmentNode(json.object, json.index, json.value);
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string}
     */ _toHTML(options) {
            var object = this.object.toHTML(options);
            var index = this.index ? this.index.toHTML(options) : "";
            var value = this.value.toHTML(options);
            if (needParenthesis(this, options && options.parenthesis, options && options.implicit)) value = '<span class="math-paranthesis math-round-parenthesis">(</span>' + value + '<span class="math-paranthesis math-round-parenthesis">)</span>';
            return object + index + '<span class="math-operator math-assignment-operator ' + 'math-variable-assignment-operator math-binary-operator">=</span>' + value;
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string}
     */ _toTex(options) {
            var object = this.object.toTex(options);
            var index = this.index ? this.index.toTex(options) : "";
            var value = this.value.toTex(options);
            if (needParenthesis(this, options && options.parenthesis, options && options.implicit)) value = "\\left(".concat(value, "\\right)");
            return object + index + "=" + value;
        }
        /**
     * @constructor AssignmentNode
     * @extends {Node}
     *
     * Define a symbol, like `a=3.2`, update a property like `a.b=3.2`, or
     * replace a subset of a matrix like `A[2,2]=42`.
     *
     * Syntax:
     *
     *     new AssignmentNode(symbol, value)
     *     new AssignmentNode(object, index, value)
     *
     * Usage:
     *
     *    new AssignmentNode(new SymbolNode('a'), new ConstantNode(2))  // a=2
     *    new AssignmentNode(new SymbolNode('a'),
     *                       new IndexNode('b'),
     *                       new ConstantNode(2))   // a.b=2
     *    new AssignmentNode(new SymbolNode('a'),
     *                       new IndexNode(1, 2),
     *                       new ConstantNode(3))  // a[1,2]=3
     *
     * @param {SymbolNode | AccessorNode} object
     *     Object on which to assign a value
     * @param {IndexNode} [index=null]
     *     Index, property name or matrix index. Optional. If not provided
     *     and `object` is a SymbolNode, the property is assigned to the
     *     global scope.
     * @param {Node} value
     *     The value to be assigned
     */ constructor(object, index, value){
            super();
            this.object = object;
            this.index = value ? index : null;
            this.value = value || index;
            // validate input
            if (!(0, $23cfe017d190638f$export$87815d550facaed9)(object) && !(0, $23cfe017d190638f$export$f88fb19d6b9ee5cb)(object)) throw new TypeError('SymbolNode or AccessorNode expected as "object"');
            if ((0, $23cfe017d190638f$export$87815d550facaed9)(object) && object.name === "end") throw new Error('Cannot assign to symbol "end"');
            if (this.index && !(0, $23cfe017d190638f$export$ff90979121a6cabc)(this.index)) // index is optional
            throw new TypeError('IndexNode expected as "index"');
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(this.value)) throw new TypeError('Node expected as "value"');
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(AssignmentNode, "name", $a878721819780eba$var$name);
    return AssignmentNode;
}, {
    isClass: true,
    isNode: true
});




var $abef36f6ac0c4e01$var$name = "bitAnd";
var $abef36f6ac0c4e01$var$dependencies = [
    "typed",
    "matrix",
    "zeros",
    "add",
    "equalScalar",
    "not",
    "concat"
];
var $abef36f6ac0c4e01$export$64a08704539c8e93 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($abef36f6ac0c4e01$var$name, $abef36f6ac0c4e01$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, not: not, concat: concat } = _ref;
    var bitAnd = (0, $35b2aafc006b23e8$export$bea4e06c5befec3b)({
        typed: typed,
        matrix: matrix,
        equalScalar: equalScalar,
        zeros: zeros,
        not: not,
        concat: concat
    });
    function bitAndTransform(args, math, scope) {
        var condition1 = args[0].compile().evaluate(scope);
        if (!(0, $23cfe017d190638f$export$cea7aa84e978eba5)(condition1)) {
            if (isNaN(condition1)) return NaN;
            if (condition1 === 0 || condition1 === false) return 0;
        }
        var condition2 = args[1].compile().evaluate(scope);
        return bitAnd(condition1, condition2);
    }
    bitAndTransform.rawArgs = true;
    return bitAndTransform;
}, {
    isTransformFunction: true
});




var $9bda4f34af0f54cd$var$name = "bitOr";
var $9bda4f34af0f54cd$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix",
    "concat"
];
var $9bda4f34af0f54cd$export$d2f720394cc4e68 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9bda4f34af0f54cd$var$name, $9bda4f34af0f54cd$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var bitOr = (0, $a68747c1126dd4e3$export$f45a7846535e9b07)({
        typed: typed,
        matrix: matrix,
        equalScalar: equalScalar,
        DenseMatrix: DenseMatrix,
        concat: concat
    });
    function bitOrTransform(args, math, scope) {
        var condition1 = args[0].compile().evaluate(scope);
        if (!(0, $23cfe017d190638f$export$cea7aa84e978eba5)(condition1)) {
            if (isNaN(condition1)) return NaN;
            if (condition1 === -1) return -1;
            if (condition1 === true) return 1;
        }
        var condition2 = args[1].compile().evaluate(scope);
        return bitOr(condition1, condition2);
    }
    bitOrTransform.rawArgs = true;
    return bitOrTransform;
}, {
    isTransformFunction: true
});





var $2988b61d80f6fa92$var$name = "BlockNode";
var $2988b61d80f6fa92$var$dependencies = [
    "ResultSet",
    "Node"
];
var $2988b61d80f6fa92$export$850df8ca0896c9ef = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($2988b61d80f6fa92$var$name, $2988b61d80f6fa92$var$dependencies, (_ref)=>{
    var { ResultSet: ResultSet, Node: Node } = _ref;
    class BlockNode extends Node {
        get type() {
            return $2988b61d80f6fa92$var$name;
        }
        get isBlockNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            var evalBlocks = (0, $eee21df0c3527ff1$export$871de8747c9eaa88)(this.blocks, function(block) {
                return {
                    evaluate: block.node._compile(math, argNames),
                    visible: block.visible
                };
            });
            return function evalBlockNodes(scope, args, context) {
                var results = [];
                (0, $eee21df0c3527ff1$export$4b80e395e36b5a56)(evalBlocks, function evalBlockNode(block) {
                    var result = block.evaluate(scope, args, context);
                    if (block.visible) results.push(result);
                });
                return new ResultSet(results);
            };
        }
        /**
     * Execute a callback for each of the child blocks of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            for(var i = 0; i < this.blocks.length; i++)callback(this.blocks[i].node, "blocks[" + i + "].node", this);
        }
        /**
     * Create a new BlockNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {BlockNode} Returns a transformed copy of the node
     */ map(callback) {
            var blocks = [];
            for(var i = 0; i < this.blocks.length; i++){
                var block = this.blocks[i];
                var node = this._ifNode(callback(block.node, "blocks[" + i + "].node", this));
                blocks[i] = {
                    node: node,
                    visible: block.visible
                };
            }
            return new BlockNode(blocks);
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {BlockNode}
     */ clone() {
            var blocks = this.blocks.map(function(block) {
                return {
                    node: block.node,
                    visible: block.visible
                };
            });
            return new BlockNode(blocks);
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toString(options) {
            return this.blocks.map(function(param) {
                return param.node.toString(options) + (param.visible ? "" : ";");
            }).join("\n");
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $2988b61d80f6fa92$var$name,
                blocks: this.blocks
            };
        }
        /**
     * Instantiate an BlockNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "BlockNode", blocks: [{node: ..., visible: false}, ...]}`,
     *     where mathjs is optional
     * @returns {BlockNode}
     */ static fromJSON(json) {
            return new BlockNode(json.blocks);
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toHTML(options) {
            return this.blocks.map(function(param) {
                return param.node.toHTML(options) + (param.visible ? "" : '<span class="math-separator">;</span>');
            }).join('<span class="math-separator"><br /></span>');
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */ _toTex(options) {
            return this.blocks.map(function(param) {
                return param.node.toTex(options) + (param.visible ? "" : ";");
            }).join("\\;\\;\n");
        }
        /**
     * @constructor BlockNode
     * @extends {Node}
     * Holds a set with blocks
     * @param {Array.<{node: Node} | {node: Node, visible: boolean}>} blocks
     *            An array with blocks, where a block is constructed as an
     *            Object with properties block, which is a Node, and visible,
     *            which is a boolean. The property visible is optional and
     *            is true by default
     */ constructor(blocks){
            super();
            // validate input, copy blocks
            if (!Array.isArray(blocks)) throw new Error("Array expected");
            this.blocks = blocks.map(function(block) {
                var node = block && block.node;
                var visible = block && block.visible !== undefined ? block.visible : true;
                if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(node)) throw new TypeError('Property "node" must be a Node');
                if (typeof visible !== "boolean") throw new TypeError('Property "visible" must be a boolean');
                return {
                    node: node,
                    visible: visible
                };
            });
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(BlockNode, "name", $2988b61d80f6fa92$var$name);
    return BlockNode;
}, {
    isClass: true,
    isNode: true
});


var $0049980c99ed0f79$var$name = "chain";
var $0049980c99ed0f79$var$dependencies = [
    "typed",
    "Chain"
];
var $0049980c99ed0f79$export$3ffb1c732bc8392d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0049980c99ed0f79$var$name, $0049980c99ed0f79$var$dependencies, (_ref)=>{
    var { typed: typed, Chain: Chain } = _ref;
    /**
   * Wrap any value in a chain, allowing to perform chained operations on
   * the value.
   *
   * All methods available in the math.js library can be called upon the chain,
   * and then will be evaluated with the value itself as first argument.
   * The chain can be closed by executing `chain.done()`, which returns
   * the final value.
   *
   * The chain has a number of special functions:
   *
   * - `done()`     Finalize the chain and return the chain's value.
   * - `valueOf()`  The same as `done()`
   * - `toString()` Executes `math.format()` onto the chain's value, returning
   *                a string representation of the value.
   *
   * Syntax:
   *
   *    math.chain(value)
   *
   * Examples:
   *
   *     math.chain(3)
   *         .add(4)
   *         .subtract(2)
   *         .done()     // 5
   *
   *     math.chain( [[1, 2], [3, 4]] )
   *         .subset(math.index(0, 0), 8)
   *         .multiply(3)
   *         .done()     // [[24, 6], [9, 12]]
   *
   * @param {*} [value]   A value of any type on which to start a chained operation.
   * @return {math.Chain} The created chain
   */ return typed($0049980c99ed0f79$var$name, {
        "": function _() {
            return new Chain();
        },
        any: function any(value) {
            return new Chain(value);
        }
    });
});





var $3a4f492ee0d3ca45$var$name = "Chain";
var $3a4f492ee0d3ca45$var$dependencies = [
    "?on",
    "math",
    "typed"
];
var $3a4f492ee0d3ca45$export$1aeed9ab2df4999f = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3a4f492ee0d3ca45$var$name, $3a4f492ee0d3ca45$var$dependencies, (_ref)=>{
    var { on: on, math: math, typed: typed } = _ref;
    /**
   * @constructor Chain
   * Wrap any value in a chain, allowing to perform chained operations on
   * the value.
   *
   * All methods available in the math.js library can be called upon the chain,
   * and then will be evaluated with the value itself as first argument.
   * The chain can be closed by executing chain.done(), which will return
   * the final value.
   *
   * The Chain has a number of special functions:
   * - done()             Finalize the chained operation and return the
   *                      chain's value.
   * - valueOf()          The same as done()
   * - toString()         Returns a string representation of the chain's value.
   *
   * @param {*} [value]
   */ function Chain(value) {
        if (!(this instanceof Chain)) throw new SyntaxError("Constructor must be called with the new operator");
        if ((0, $23cfe017d190638f$export$dc36953d0b3a4f05)(value)) this.value = value.value;
        else this.value = value;
    }
    /**
   * Attach type information
   */ Chain.prototype.type = "Chain";
    Chain.prototype.isChain = true;
    /**
   * Close the chain. Returns the final value.
   * Does the same as method valueOf()
   * @returns {*} value
   */ Chain.prototype.done = function() {
        return this.value;
    };
    /**
   * Close the chain. Returns the final value.
   * Does the same as method done()
   * @returns {*} value
   */ Chain.prototype.valueOf = function() {
        return this.value;
    };
    /**
   * Get a string representation of the value in the chain
   * @returns {string}
   */ Chain.prototype.toString = function() {
        return (0, $1b038b7ade911d0e$export$d9468344d3651243)(this.value);
    };
    /**
   * Get a JSON representation of the chain
   * @returns {Object}
   */ Chain.prototype.toJSON = function() {
        return {
            mathjs: "Chain",
            value: this.value
        };
    };
    /**
   * Instantiate a Chain from its JSON representation
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "Chain", value: ...}`,
   *                       where mathjs is optional
   * @returns {Chain}
   */ Chain.fromJSON = function(json) {
        return new Chain(json.value);
    };
    /**
   * Create a proxy method for the chain
   * @param {string} name
   * @param {Function} fn      The function to be proxied
   *                           If fn is no function, it is silently ignored.
   * @private
   */ function createProxy(name, fn) {
        if (typeof fn === "function") Chain.prototype[name] = chainify(fn);
    }
    /**
   * Create a proxy method for the chain
   * @param {string} name
   * @param {function} resolver   The function resolving with the
   *                              function to be proxied
   * @private
   */ function createLazyProxy(name, resolver) {
        (0, $46a94b3d1146edd8$export$488013bae63b21da)(Chain.prototype, name, function outerResolver() {
            var fn = resolver();
            if (typeof fn === "function") return chainify(fn);
            return undefined; // if not a function, ignore
        });
    }
    /**
   * Make a function chainable
   * @param {function} fn
   * @return {Function} chain function
   * @private
   */ function chainify(fn) {
        return function() {
            // Here, `this` will be the context of a Chain instance
            if (arguments.length === 0) return new Chain(fn(this.value));
            var args = [
                this.value
            ];
            for(var i = 0; i < arguments.length; i++)args[i + 1] = arguments[i];
            if (typed.isTypedFunction(fn)) {
                var sigObject = typed.resolve(fn, args);
                // We want to detect if a rest parameter has matched across the
                // value in the chain and the current arguments of this call.
                // That is the case if and only if the matching signature has
                // exactly one parameter (which then must be a rest parameter
                // as it is matching at least two actual arguments).
                if (sigObject.params.length === 1) throw new Error("chain function " + fn.name + " cannot match rest parameter between chain value and additional arguments.");
                return new Chain(sigObject.implementation.apply(fn, args));
            }
            return new Chain(fn.apply(fn, args));
        };
    }
    /**
   * Create a proxy for a single method, or an object with multiple methods.
   * Example usage:
   *
   *   Chain.createProxy('add', function add (x, y) {...})
   *   Chain.createProxy({
   *     add:      function add (x, y) {...},
   *     subtract: function subtract (x, y) {...}
   *   }
   *
   * @param {string | Object} arg0   A name (string), or an object with
   *                                 functions
   * @param {*} [arg1]               A function, when arg0 is a name
   */ Chain.createProxy = function(arg0, arg1) {
        if (typeof arg0 === "string") // createProxy(name, value)
        createProxy(arg0, arg1);
        else {
            var _loop = function _loop(_name) {
                if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(arg0, _name) && excludedNames[_name] === undefined) createLazyProxy(_name, ()=>arg0[_name]);
            };
            // createProxy(values)
            for(var _name in arg0)_loop(_name);
        }
    };
    var excludedNames = {
        expression: true,
        docs: true,
        type: true,
        classes: true,
        json: true,
        error: true,
        isChain: true // conflicts with the property isChain of a Chain instance
    };
    // create proxy for everything that is in math.js
    Chain.createProxy(math);
    // register on the import event, automatically add a proxy for every imported function.
    if (on) on("import", function(name, resolver, path) {
        if (!path) // an imported function (not a data type or something special)
        createLazyProxy(name, resolver);
    });
    return Chain;
}, {
    isClass: true
});





var $cbf04e10412fb5e9$var$name = "column";
var $cbf04e10412fb5e9$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $cbf04e10412fb5e9$export$cb052a3b92a960e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($cbf04e10412fb5e9$var$name, $cbf04e10412fb5e9$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    var column = (0, $e16a495e01b5c57a$export$1bfa986e9c92c0b5)({
        typed: typed,
        Index: Index,
        matrix: matrix,
        range: range
    });
    // @see: comment of column itself
    return typed("column", {
        "...any": function any(args) {
            // change last argument from zero-based to one-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(last)) args[lastIndex] = last - 1;
            try {
                return column.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});



var $0a0482ee1e2bb1a2$var$name = "compile";
var $0a0482ee1e2bb1a2$var$dependencies = [
    "typed",
    "parse"
];
var $0a0482ee1e2bb1a2$export$6c15201c8dbd106f = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0a0482ee1e2bb1a2$var$name, $0a0482ee1e2bb1a2$var$dependencies, (_ref)=>{
    var { typed: typed, parse: parse } = _ref;
    /**
   * Parse and compile an expression.
   * Returns a an object with a function `evaluate([scope])` to evaluate the
   * compiled expression.
   *
   * Syntax:
   *
   *     math.compile(expr)                       // returns one node
   *     math.compile([expr1, expr2, expr3, ...]) // returns an array with nodes
   *
   * Examples:
   *
   *     const code1 = math.compile('sqrt(3^2 + 4^2)')
   *     code1.evaluate() // 5
   *
   *     let scope = {a: 3, b: 4}
   *     const code2 = math.compile('a * b') // 12
   *     code2.evaluate(scope) // 12
   *     scope.a = 5
   *     code2.evaluate(scope) // 20
   *
   *     const nodes = math.compile(['a = 3', 'b = 4', 'a * b'])
   *     nodes[2].evaluate() // 12
   *
   * See also:
   *
   *    parse, evaluate
   *
   * @param {string | string[] | Array | Matrix} expr
   *            The expression to be compiled
   * @return {{evaluate: Function} | Array.<{evaluate: Function}>} code
   *            An object with the compiled expression
   * @throws {Error}
   */ return typed($0a0482ee1e2bb1a2$var$name, {
        string: function string(expr) {
            return parse(expr).compile();
        },
        "Array | Matrix": function ArrayMatrix(expr) {
            return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(expr, function(entry) {
                return parse(entry).compile();
            });
        }
    });
});





var $d1a32cb9dd365d16$var$name = "concat";
var $d1a32cb9dd365d16$var$dependencies = [
    "typed",
    "matrix",
    "isInteger"
];
var $d1a32cb9dd365d16$export$3571c61ed942e965 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($d1a32cb9dd365d16$var$name, $d1a32cb9dd365d16$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isInteger: isInteger } = _ref;
    var concat = (0, $b26adab4221c7e8d$export$c36b5511b12560e8)({
        typed: typed,
        matrix: matrix,
        isInteger: isInteger
    });
    /**
   * Attach a transform function to math.range
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function concat
   * from one-based to zero based
   */ return typed("concat", {
        "...any": function any(args) {
            // change last argument from one-based to zero-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(last)) args[lastIndex] = last - 1;
            else if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(last)) args[lastIndex] = last.minus(1);
            try {
                return concat.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});





var $c3c30838c78cb182$var$name = "ConditionalNode";
var $c3c30838c78cb182$var$dependencies = [
    "Node"
];
var $c3c30838c78cb182$export$401636051e48ab09 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c3c30838c78cb182$var$name, $c3c30838c78cb182$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    /**
   * Test whether a condition is met
   * @param {*} condition
   * @returns {boolean} true if condition is true or non-zero, else false
   */ function testCondition(condition) {
        if (typeof condition === "number" || typeof condition === "boolean" || typeof condition === "string") return !!condition;
        if (condition) {
            if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(condition)) return !condition.isZero();
            if ((0, $23cfe017d190638f$export$8849a896711efe0c)(condition)) return !!(condition.re || condition.im);
            if ((0, $23cfe017d190638f$export$8960dc335987b8da)(condition)) return !!condition.value;
        }
        if (condition === null || condition === undefined) return false;
        throw new TypeError('Unsupported type of condition "' + (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(condition) + '"');
    }
    class ConditionalNode extends Node {
        get type() {
            return $c3c30838c78cb182$var$name;
        }
        get isConditionalNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            var evalCondition = this.condition._compile(math, argNames);
            var evalTrueExpr = this.trueExpr._compile(math, argNames);
            var evalFalseExpr = this.falseExpr._compile(math, argNames);
            return function evalConditionalNode(scope, args, context) {
                return testCondition(evalCondition(scope, args, context)) ? evalTrueExpr(scope, args, context) : evalFalseExpr(scope, args, context);
            };
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            callback(this.condition, "condition", this);
            callback(this.trueExpr, "trueExpr", this);
            callback(this.falseExpr, "falseExpr", this);
        }
        /**
     * Create a new ConditionalNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ConditionalNode} Returns a transformed copy of the node
     */ map(callback) {
            return new ConditionalNode(this._ifNode(callback(this.condition, "condition", this)), this._ifNode(callback(this.trueExpr, "trueExpr", this)), this._ifNode(callback(this.falseExpr, "falseExpr", this)));
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {ConditionalNode}
     */ clone() {
            return new ConditionalNode(this.condition, this.trueExpr, this.falseExpr);
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */ _toString(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var precedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(this, parenthesis, options && options.implicit);
            // Enclose Arguments in parentheses if they are an OperatorNode
            // or have lower or equal precedence
            // NOTE: enclosing all OperatorNodes in parentheses is a decision
            // purely based on aesthetics and readability
            var condition = this.condition.toString(options);
            var conditionPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(this.condition, parenthesis, options && options.implicit);
            if (parenthesis === "all" || this.condition.type === "OperatorNode" || conditionPrecedence !== null && conditionPrecedence <= precedence) condition = "(" + condition + ")";
            var trueExpr = this.trueExpr.toString(options);
            var truePrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(this.trueExpr, parenthesis, options && options.implicit);
            if (parenthesis === "all" || this.trueExpr.type === "OperatorNode" || truePrecedence !== null && truePrecedence <= precedence) trueExpr = "(" + trueExpr + ")";
            var falseExpr = this.falseExpr.toString(options);
            var falsePrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(this.falseExpr, parenthesis, options && options.implicit);
            if (parenthesis === "all" || this.falseExpr.type === "OperatorNode" || falsePrecedence !== null && falsePrecedence <= precedence) falseExpr = "(" + falseExpr + ")";
            return condition + " ? " + trueExpr + " : " + falseExpr;
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $c3c30838c78cb182$var$name,
                condition: this.condition,
                trueExpr: this.trueExpr,
                falseExpr: this.falseExpr
            };
        }
        /**
     * Instantiate an ConditionalNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "ConditionalNode",
     *      "condition": ...,
     *      "trueExpr": ...,
     *      "falseExpr": ...}
     *     ```
     *     where mathjs is optional
     * @returns {ConditionalNode}
     */ static fromJSON(json) {
            return new ConditionalNode(json.condition, json.trueExpr, json.falseExpr);
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */ _toHTML(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var precedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(this, parenthesis, options && options.implicit);
            // Enclose Arguments in parentheses if they are an OperatorNode
            // or have lower or equal precedence
            // NOTE: enclosing all OperatorNodes in parentheses is a decision
            // purely based on aesthetics and readability
            var condition = this.condition.toHTML(options);
            var conditionPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(this.condition, parenthesis, options && options.implicit);
            if (parenthesis === "all" || this.condition.type === "OperatorNode" || conditionPrecedence !== null && conditionPrecedence <= precedence) condition = '<span class="math-parenthesis math-round-parenthesis">(</span>' + condition + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            var trueExpr = this.trueExpr.toHTML(options);
            var truePrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(this.trueExpr, parenthesis, options && options.implicit);
            if (parenthesis === "all" || this.trueExpr.type === "OperatorNode" || truePrecedence !== null && truePrecedence <= precedence) trueExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + trueExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            var falseExpr = this.falseExpr.toHTML(options);
            var falsePrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(this.falseExpr, parenthesis, options && options.implicit);
            if (parenthesis === "all" || this.falseExpr.type === "OperatorNode" || falsePrecedence !== null && falsePrecedence <= precedence) falseExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + falseExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            return condition + '<span class="math-operator math-conditional-operator">?</span>' + trueExpr + '<span class="math-operator math-conditional-operator">:</span>' + falseExpr;
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */ _toTex(options) {
            return "\\begin{cases} {" + this.trueExpr.toTex(options) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(options) + "}\\\\{" + this.falseExpr.toTex(options) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
        }
        /**
     * A lazy evaluating conditional operator: 'condition ? trueExpr : falseExpr'
     *
     * @param {Node} condition   Condition, must result in a boolean
     * @param {Node} trueExpr    Expression evaluated when condition is true
     * @param {Node} falseExpr   Expression evaluated when condition is true
     *
     * @constructor ConditionalNode
     * @extends {Node}
     */ constructor(condition, trueExpr, falseExpr){
            super();
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(condition)) throw new TypeError("Parameter condition must be a Node");
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(trueExpr)) throw new TypeError("Parameter trueExpr must be a Node");
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(falseExpr)) throw new TypeError("Parameter falseExpr must be a Node");
            this.condition = condition;
            this.trueExpr = trueExpr;
            this.falseExpr = falseExpr;
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(ConditionalNode, "name", $c3c30838c78cb182$var$name);
    return ConditionalNode;
}, {
    isClass: true,
    isNode: true
});




/* eslint no-template-curly-in-string: "off" */ 

var $a279f526ff78ebb8$export$98cd3902fcdeb93d = {
    // GREEK LETTERS
    Alpha: "A",
    alpha: "\\alpha",
    Beta: "B",
    beta: "\\beta",
    Gamma: "\\Gamma",
    gamma: "\\gamma",
    Delta: "\\Delta",
    delta: "\\delta",
    Epsilon: "E",
    epsilon: "\\epsilon",
    varepsilon: "\\varepsilon",
    Zeta: "Z",
    zeta: "\\zeta",
    Eta: "H",
    eta: "\\eta",
    Theta: "\\Theta",
    theta: "\\theta",
    vartheta: "\\vartheta",
    Iota: "I",
    iota: "\\iota",
    Kappa: "K",
    kappa: "\\kappa",
    varkappa: "\\varkappa",
    Lambda: "\\Lambda",
    lambda: "\\lambda",
    Mu: "M",
    mu: "\\mu",
    Nu: "N",
    nu: "\\nu",
    Xi: "\\Xi",
    xi: "\\xi",
    Omicron: "O",
    omicron: "o",
    Pi: "\\Pi",
    pi: "\\pi",
    varpi: "\\varpi",
    Rho: "P",
    rho: "\\rho",
    varrho: "\\varrho",
    Sigma: "\\Sigma",
    sigma: "\\sigma",
    varsigma: "\\varsigma",
    Tau: "T",
    tau: "\\tau",
    Upsilon: "\\Upsilon",
    upsilon: "\\upsilon",
    Phi: "\\Phi",
    phi: "\\phi",
    varphi: "\\varphi",
    Chi: "X",
    chi: "\\chi",
    Psi: "\\Psi",
    psi: "\\psi",
    Omega: "\\Omega",
    omega: "\\omega",
    // logic
    true: "\\mathrm{True}",
    false: "\\mathrm{False}",
    // other
    i: "i",
    // TODO use \i ??
    inf: "\\infty",
    Inf: "\\infty",
    infinity: "\\infty",
    Infinity: "\\infty",
    oo: "\\infty",
    lim: "\\lim",
    undefined: "\\mathbf{?}"
};
var $a279f526ff78ebb8$export$c728a46e4168cd75 = {
    transpose: "^\\top",
    ctranspose: "^H",
    factorial: "!",
    pow: "^",
    dotPow: ".^\\wedge",
    // TODO find ideal solution
    unaryPlus: "+",
    unaryMinus: "-",
    bitNot: "\\~",
    // TODO find ideal solution
    not: "\\neg",
    multiply: "\\cdot",
    divide: "\\frac",
    // TODO how to handle that properly?
    dotMultiply: ".\\cdot",
    // TODO find ideal solution
    dotDivide: ".:",
    // TODO find ideal solution
    mod: "\\mod",
    add: "+",
    subtract: "-",
    to: "\\rightarrow",
    leftShift: "<<",
    rightArithShift: ">>",
    rightLogShift: ">>>",
    equal: "=",
    unequal: "\\neq",
    smaller: "<",
    larger: ">",
    smallerEq: "\\leq",
    largerEq: "\\geq",
    bitAnd: "\\&",
    bitXor: "\\underline{|}",
    bitOr: "|",
    and: "\\wedge",
    xor: "\\veebar",
    or: "\\vee"
};
var $a279f526ff78ebb8$export$b0cfc37067573780 = {
    // arithmetic
    abs: {
        1: "\\left|${args[0]}\\right|"
    },
    add: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.add, "${args[1]}\\right)")
    },
    cbrt: {
        1: "\\sqrt[3]{${args[0]}}"
    },
    ceil: {
        1: "\\left\\lceil${args[0]}\\right\\rceil"
    },
    cube: {
        1: "\\left(${args[0]}\\right)^3"
    },
    divide: {
        2: "\\frac{${args[0]}}{${args[1]}}"
    },
    dotDivide: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.dotDivide, "${args[1]}\\right)")
    },
    dotMultiply: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.dotMultiply, "${args[1]}\\right)")
    },
    dotPow: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.dotPow, "${args[1]}\\right)")
    },
    exp: {
        1: "\\exp\\left(${args[0]}\\right)"
    },
    expm1: "\\left(e".concat($a279f526ff78ebb8$export$c728a46e4168cd75.pow, "{${args[0]}}-1\\right)"),
    fix: {
        1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
    },
    floor: {
        1: "\\left\\lfloor${args[0]}\\right\\rfloor"
    },
    gcd: "\\gcd\\left(${args}\\right)",
    hypot: "\\hypot\\left(${args}\\right)",
    log: {
        1: "\\ln\\left(${args[0]}\\right)",
        2: "\\log_{${args[1]}}\\left(${args[0]}\\right)"
    },
    log10: {
        1: "\\log_{10}\\left(${args[0]}\\right)"
    },
    log1p: {
        1: "\\ln\\left(${args[0]}+1\\right)",
        2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)"
    },
    log2: "\\log_{2}\\left(${args[0]}\\right)",
    mod: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.mod, "${args[1]}\\right)")
    },
    multiply: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.multiply, "${args[1]}\\right)")
    },
    norm: {
        1: "\\left\\|${args[0]}\\right\\|",
        2: undefined // use default template
    },
    nthRoot: {
        2: "\\sqrt[${args[1]}]{${args[0]}}"
    },
    nthRoots: {
        2: "\\{y : $y^{args[1]} = {${args[0]}}\\}"
    },
    pow: {
        2: "\\left(${args[0]}\\right)".concat($a279f526ff78ebb8$export$c728a46e4168cd75.pow, "{${args[1]}}")
    },
    round: {
        1: "\\left\\lfloor${args[0]}\\right\\rceil",
        2: undefined // use default template
    },
    sign: {
        1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
    },
    sqrt: {
        1: "\\sqrt{${args[0]}}"
    },
    square: {
        1: "\\left(${args[0]}\\right)^2"
    },
    subtract: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.subtract, "${args[1]}\\right)")
    },
    unaryMinus: {
        1: "".concat($a279f526ff78ebb8$export$c728a46e4168cd75.unaryMinus, "\\left(${args[0]}\\right)")
    },
    unaryPlus: {
        1: "".concat($a279f526ff78ebb8$export$c728a46e4168cd75.unaryPlus, "\\left(${args[0]}\\right)")
    },
    // bitwise
    bitAnd: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.bitAnd, "${args[1]}\\right)")
    },
    bitNot: {
        1: $a279f526ff78ebb8$export$c728a46e4168cd75.bitNot + "\\left(${args[0]}\\right)"
    },
    bitOr: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.bitOr, "${args[1]}\\right)")
    },
    bitXor: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.bitXor, "${args[1]}\\right)")
    },
    leftShift: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.leftShift, "${args[1]}\\right)")
    },
    rightArithShift: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.rightArithShift, "${args[1]}\\right)")
    },
    rightLogShift: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.rightLogShift, "${args[1]}\\right)")
    },
    // combinatorics
    bellNumbers: {
        1: "\\mathrm{B}_{${args[0]}}"
    },
    catalan: {
        1: "\\mathrm{C}_{${args[0]}}"
    },
    stirlingS2: {
        2: "\\mathrm{S}\\left(${args}\\right)"
    },
    // complex
    arg: {
        1: "\\arg\\left(${args[0]}\\right)"
    },
    conj: {
        1: "\\left(${args[0]}\\right)^*"
    },
    im: {
        1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace"
    },
    re: {
        1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace"
    },
    // logical
    and: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.and, "${args[1]}\\right)")
    },
    not: {
        1: $a279f526ff78ebb8$export$c728a46e4168cd75.not + "\\left(${args[0]}\\right)"
    },
    or: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.or, "${args[1]}\\right)")
    },
    xor: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.xor, "${args[1]}\\right)")
    },
    // matrix
    cross: {
        2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"
    },
    ctranspose: {
        1: "\\left(${args[0]}\\right)".concat($a279f526ff78ebb8$export$c728a46e4168cd75.ctranspose)
    },
    det: {
        1: "\\det\\left(${args[0]}\\right)"
    },
    dot: {
        2: "\\left(${args[0]}\\cdot${args[1]}\\right)"
    },
    expm: {
        1: "\\exp\\left(${args[0]}\\right)"
    },
    inv: {
        1: "\\left(${args[0]}\\right)^{-1}"
    },
    pinv: {
        1: "\\left(${args[0]}\\right)^{+}"
    },
    sqrtm: {
        1: "{${args[0]}}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.pow, "{\\frac{1}{2}}")
    },
    trace: {
        1: "\\mathrm{tr}\\left(${args[0]}\\right)"
    },
    transpose: {
        1: "\\left(${args[0]}\\right)".concat($a279f526ff78ebb8$export$c728a46e4168cd75.transpose)
    },
    // probability
    combinations: {
        2: "\\binom{${args[0]}}{${args[1]}}"
    },
    combinationsWithRep: {
        2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)"
    },
    factorial: {
        1: "\\left(${args[0]}\\right)".concat($a279f526ff78ebb8$export$c728a46e4168cd75.factorial)
    },
    gamma: {
        1: "\\Gamma\\left(${args[0]}\\right)"
    },
    lgamma: {
        1: "\\ln\\Gamma\\left(${args[0]}\\right)"
    },
    // relational
    equal: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.equal, "${args[1]}\\right)")
    },
    larger: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.larger, "${args[1]}\\right)")
    },
    largerEq: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.largerEq, "${args[1]}\\right)")
    },
    smaller: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.smaller, "${args[1]}\\right)")
    },
    smallerEq: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.smallerEq, "${args[1]}\\right)")
    },
    unequal: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.unequal, "${args[1]}\\right)")
    },
    // special
    erf: {
        1: "erf\\left(${args[0]}\\right)"
    },
    // statistics
    max: "\\max\\left(${args}\\right)",
    min: "\\min\\left(${args}\\right)",
    variance: "\\mathrm{Var}\\left(${args}\\right)",
    // trigonometry
    acos: {
        1: "\\cos^{-1}\\left(${args[0]}\\right)"
    },
    acosh: {
        1: "\\cosh^{-1}\\left(${args[0]}\\right)"
    },
    acot: {
        1: "\\cot^{-1}\\left(${args[0]}\\right)"
    },
    acoth: {
        1: "\\coth^{-1}\\left(${args[0]}\\right)"
    },
    acsc: {
        1: "\\csc^{-1}\\left(${args[0]}\\right)"
    },
    acsch: {
        1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)"
    },
    asec: {
        1: "\\sec^{-1}\\left(${args[0]}\\right)"
    },
    asech: {
        1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)"
    },
    asin: {
        1: "\\sin^{-1}\\left(${args[0]}\\right)"
    },
    asinh: {
        1: "\\sinh^{-1}\\left(${args[0]}\\right)"
    },
    atan: {
        1: "\\tan^{-1}\\left(${args[0]}\\right)"
    },
    atan2: {
        2: "\\mathrm{atan2}\\left(${args}\\right)"
    },
    atanh: {
        1: "\\tanh^{-1}\\left(${args[0]}\\right)"
    },
    cos: {
        1: "\\cos\\left(${args[0]}\\right)"
    },
    cosh: {
        1: "\\cosh\\left(${args[0]}\\right)"
    },
    cot: {
        1: "\\cot\\left(${args[0]}\\right)"
    },
    coth: {
        1: "\\coth\\left(${args[0]}\\right)"
    },
    csc: {
        1: "\\csc\\left(${args[0]}\\right)"
    },
    csch: {
        1: "\\mathrm{csch}\\left(${args[0]}\\right)"
    },
    sec: {
        1: "\\sec\\left(${args[0]}\\right)"
    },
    sech: {
        1: "\\mathrm{sech}\\left(${args[0]}\\right)"
    },
    sin: {
        1: "\\sin\\left(${args[0]}\\right)"
    },
    sinh: {
        1: "\\sinh\\left(${args[0]}\\right)"
    },
    tan: {
        1: "\\tan\\left(${args[0]}\\right)"
    },
    tanh: {
        1: "\\tanh\\left(${args[0]}\\right)"
    },
    // unit
    to: {
        2: "\\left(${args[0]}".concat($a279f526ff78ebb8$export$c728a46e4168cd75.to, "${args[1]}\\right)")
    },
    // utils
    numeric: function numeric(node, options) {
        // Not sure if this is strictly right but should work correctly for the vast majority of use cases.
        return node.args[0].toTex();
    },
    // type
    number: {
        0: "0",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
    },
    string: {
        0: '\\mathtt{""}',
        1: "\\mathrm{string}\\left(${args[0]}\\right)"
    },
    bignumber: {
        0: "0",
        1: "\\left(${args[0]}\\right)"
    },
    bigint: {
        0: "0",
        1: "\\left(${args[0]}\\right)"
    },
    complex: {
        0: "0",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)+".concat($a279f526ff78ebb8$export$98cd3902fcdeb93d.i, "\\cdot\\left(${args[1]}\\right)\\right)")
    },
    matrix: {
        0: "\\begin{bmatrix}\\end{bmatrix}",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(${args[0]}\\right)"
    },
    sparse: {
        0: "\\begin{bsparse}\\end{bsparse}",
        1: "\\left(${args[0]}\\right)"
    },
    unit: {
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
    }
};
var $a279f526ff78ebb8$export$76173758cefa70e5 = "\\mathrm{${name}}\\left(${args}\\right)";
var $a279f526ff78ebb8$var$latexUnits = {
    deg: "^\\circ"
};
function $a279f526ff78ebb8$export$1b86a510a6af60c2(string) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c202b4d97c154079$exports)))(string, {
        preserveFormatting: true
    });
}
function $a279f526ff78ebb8$export$358d3bb1a752ff(name, isUnit) {
    isUnit = typeof isUnit === "undefined" ? false : isUnit;
    if (isUnit) {
        if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)($a279f526ff78ebb8$var$latexUnits, name)) return $a279f526ff78ebb8$var$latexUnits[name];
        return "\\mathrm{" + $a279f526ff78ebb8$export$1b86a510a6af60c2(name) + "}";
    }
    if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)($a279f526ff78ebb8$export$98cd3902fcdeb93d, name)) return $a279f526ff78ebb8$export$98cd3902fcdeb93d[name];
    return $a279f526ff78ebb8$export$1b86a510a6af60c2(name);
}



var $45e3119513fd120b$var$name = "ConstantNode";
var $45e3119513fd120b$var$dependencies = [
    "Node"
];
var $45e3119513fd120b$export$70fc17189bb5117e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($45e3119513fd120b$var$name, $45e3119513fd120b$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    class ConstantNode extends Node {
        get type() {
            return $45e3119513fd120b$var$name;
        }
        get isConstantNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            var value = this.value;
            return function evalConstantNode() {
                return value;
            };
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
        // nothing to do, we don't have any children
        }
        /**
     * Create a new ConstantNode with children produced by the given callback.
     * Trivial because there are no children.
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {ConstantNode} Returns a clone of the node
     */ map(callback) {
            return this.clone();
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {ConstantNode}
     */ clone() {
            return new ConstantNode(this.value);
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */ _toString(options) {
            return (0, $1b038b7ade911d0e$export$d9468344d3651243)(this.value, options);
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */ _toHTML(options) {
            var value = this._toString(options);
            switch((0, $23cfe017d190638f$export$f5bbd400c2f4426f)(this.value)){
                case "number":
                case "bigint":
                case "BigNumber":
                case "Fraction":
                    return '<span class="math-number">' + value + "</span>";
                case "string":
                    return '<span class="math-string">' + value + "</span>";
                case "boolean":
                    return '<span class="math-boolean">' + value + "</span>";
                case "null":
                    return '<span class="math-null-symbol">' + value + "</span>";
                case "undefined":
                    return '<span class="math-undefined">' + value + "</span>";
                default:
                    return '<span class="math-symbol">' + value + "</span>";
            }
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $45e3119513fd120b$var$name,
                value: this.value
            };
        }
        /**
     * Instantiate a ConstantNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "SymbolNode", value: 2.3}`,
     *                       where mathjs is optional
     * @returns {ConstantNode}
     */ static fromJSON(json) {
            return new ConstantNode(json.value);
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */ _toTex(options) {
            var value = this._toString(options);
            var type = (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(this.value);
            switch(type){
                case "string":
                    return "\\mathtt{" + (0, $a279f526ff78ebb8$export$1b86a510a6af60c2)(value) + "}";
                case "number":
                case "BigNumber":
                    var finite = type === "BigNumber" ? this.value.isFinite() : isFinite(this.value);
                    if (!finite) return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
                    var index = value.toLowerCase().indexOf("e");
                    if (index !== -1) return value.substring(0, index) + "\\cdot10^{" + value.substring(index + 1) + "}";
                    return value;
                case "bigint":
                    return value.toString();
                case "Fraction":
                    return this.value.toLatex();
                default:
                    return value;
            }
        }
        /**
     * A ConstantNode holds a constant value like a number or string.
     *
     * Usage:
     *
     *     new ConstantNode(2.3)
     *     new ConstantNode('hello')
     *
     * @param {*} value    Value can be any type (number, BigNumber, bigint, string, ...)
     * @constructor ConstantNode
     * @extends {Node}
     */ constructor(value){
            super();
            this.value = value;
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(ConstantNode, "name", $45e3119513fd120b$var$name);
    return ConstantNode;
}, {
    isClass: true,
    isNode: true
});





/**
 * Attach a transform function to math.sum
 * Adds a property transform containing the transform function.
 *
 * This transform changed the last `dim` parameter of function sum
 * from one-based to zero based
 */ var $0be9d7e7644706d7$var$name = "cumsum";
var $0be9d7e7644706d7$var$dependencies = [
    "typed",
    "add",
    "unaryPlus"
];
var $0be9d7e7644706d7$export$3052aed7543acf3e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0be9d7e7644706d7$var$name, $0be9d7e7644706d7$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, unaryPlus: unaryPlus } = _ref;
    var cumsum = (0, $a4767d153782e37a$export$e11ffe2ce577c262)({
        typed: typed,
        add: add,
        unaryPlus: unaryPlus
    });
    return typed($0be9d7e7644706d7$var$name, {
        "...any": function any(args) {
            // change last argument dim from one-based to zero-based
            if (args.length === 2 && (0, $23cfe017d190638f$export$cea7aa84e978eba5)(args[0])) {
                var dim = args[1];
                if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(dim)) args[1] = dim - 1;
                else if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(dim)) args[1] = dim.minus(1);
            }
            try {
                return cumsum.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});




var $85667ebfd6fe4be4$var$name = "derivative";
var $85667ebfd6fe4be4$var$dependencies = [
    "typed",
    "config",
    "parse",
    "simplify",
    "equal",
    "isZero",
    "numeric",
    "ConstantNode",
    "FunctionNode",
    "OperatorNode",
    "ParenthesisNode",
    "SymbolNode"
];
var $85667ebfd6fe4be4$export$d1d6fcabea5d55e0 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($85667ebfd6fe4be4$var$name, $85667ebfd6fe4be4$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, parse: parse, simplify: simplify, equal: equal, isZero: isZero, numeric: numeric, ConstantNode: ConstantNode, FunctionNode: FunctionNode, OperatorNode: OperatorNode, ParenthesisNode: ParenthesisNode, SymbolNode: SymbolNode } = _ref;
    /**
   * Takes the derivative of an expression expressed in parser Nodes.
   * The derivative will be taken over the supplied variable in the
   * second parameter. If there are multiple variables in the expression,
   * it will return a partial derivative.
   *
   * This uses rules of differentiation which can be found here:
   *
   * - [Differentiation rules (Wikipedia)](https://en.wikipedia.org/wiki/Differentiation_rules)
   *
   * Syntax:
   *
   *     math.derivative(expr, variable)
   *     math.derivative(expr, variable, options)
   *
   * Examples:
   *
   *     math.derivative('x^2', 'x')                     // Node '2 * x'
   *     math.derivative('x^2', 'x', {simplify: false})  // Node '2 * 1 * x ^ (2 - 1)'
   *     math.derivative('sin(2x)', 'x'))                // Node '2 * cos(2 * x)'
   *     math.derivative('2*x', 'x').evaluate()          // number 2
   *     math.derivative('x^2', 'x').evaluate({x: 4})    // number 8
   *     const f = math.parse('x^2')
   *     const x = math.parse('x')
   *     math.derivative(f, x)                           // Node {2 * x}
   *
   * See also:
   *
   *     simplify, parse, evaluate
   *
   * @param  {Node | string} expr           The expression to differentiate
   * @param  {SymbolNode | string} variable The variable over which to differentiate
   * @param  {{simplify: boolean}} [options]
   *                         There is one option available, `simplify`, which
   *                         is true by default. When false, output will not
   *                         be simplified.
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
   */ function plainDerivative(expr, variable) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            simplify: true
        };
        var constNodes = {};
        constTag(constNodes, expr, variable.name);
        var res = _derivative(expr, constNodes);
        return options.simplify ? simplify(res) : res;
    }
    typed.addConversion({
        from: "identifier",
        to: "SymbolNode",
        convert: parse
    });
    var derivative = typed($85667ebfd6fe4be4$var$name, {
        "Node, SymbolNode": plainDerivative,
        "Node, SymbolNode, Object": plainDerivative
    });
    typed.removeConversion({
        from: "identifier",
        to: "SymbolNode",
        convert: parse
    });
    derivative._simplify = true;
    derivative.toTex = function(deriv) {
        return _derivTex.apply(null, deriv.args);
    };
    // FIXME: move the toTex method of derivative to latex.js. Difficulty is that it relies on parse.
    // NOTE: the optional "order" parameter here is currently unused
    var _derivTex = typed("_derivTex", {
        "Node, SymbolNode": function NodeSymbolNode(expr, x) {
            if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(expr) && (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(expr.value) === "string") return _derivTex(parse(expr.value).toString(), x.toString(), 1);
            else return _derivTex(expr.toTex(), x.toString(), 1);
        },
        "Node, ConstantNode": function NodeConstantNode(expr, x) {
            if ((0, $23cfe017d190638f$export$f5bbd400c2f4426f)(x.value) === "string") return _derivTex(expr, parse(x.value));
            else throw new Error("The second parameter to 'derivative' is a non-string constant");
        },
        "Node, SymbolNode, ConstantNode": function NodeSymbolNodeConstantNode(expr, x, order) {
            return _derivTex(expr.toString(), x.name, order.value);
        },
        "string, string, number": function stringStringNumber(expr, x, order) {
            var d;
            if (order === 1) d = "{d\\over d" + x + "}";
            else d = "{d^{" + order + "}\\over d" + x + "^{" + order + "}}";
            return d + "\\left[".concat(expr, "\\right]");
        }
    });
    /**
   * Does a depth-first search on the expression tree to identify what Nodes
   * are constants (e.g. 2 + 2), and stores the ones that are constants in
   * constNodes. Classification is done as follows:
   *
   *   1. ConstantNodes are constants.
   *   2. If there exists a SymbolNode, of which we are differentiating over,
   *      in the subtree it is not constant.
   *
   * @param  {Object} constNodes  Holds the nodes that are constant
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param  {string} varName     Variable that we are differentiating
   * @return {boolean}  if node is constant
   */ // TODO: can we rewrite constTag into a pure function?
    var constTag = typed("constTag", {
        "Object, ConstantNode, string": function ObjectConstantNodeString(constNodes, node) {
            constNodes[node] = true;
            return true;
        },
        "Object, SymbolNode, string": function ObjectSymbolNodeString(constNodes, node, varName) {
            // Treat other variables like constants. For reasoning, see:
            //   https://en.wikipedia.org/wiki/Partial_derivative
            if (node.name !== varName) {
                constNodes[node] = true;
                return true;
            }
            return false;
        },
        "Object, ParenthesisNode, string": function ObjectParenthesisNodeString(constNodes, node, varName) {
            return constTag(constNodes, node.content, varName);
        },
        "Object, FunctionAssignmentNode, string": function ObjectFunctionAssignmentNodeString(constNodes, node, varName) {
            if (!node.params.includes(varName)) {
                constNodes[node] = true;
                return true;
            }
            return constTag(constNodes, node.expr, varName);
        },
        "Object, FunctionNode | OperatorNode, string": function ObjectFunctionNodeOperatorNodeString(constNodes, node, varName) {
            if (node.args.length > 0) {
                var isConst = constTag(constNodes, node.args[0], varName);
                for(var i = 1; i < node.args.length; ++i)isConst = constTag(constNodes, node.args[i], varName) && isConst;
                if (isConst) {
                    constNodes[node] = true;
                    return true;
                }
            }
            return false;
        }
    });
    /**
   * Applies differentiation rules.
   *
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param  {Object} constNodes  Holds the nodes that are constant
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
   */ var _derivative = typed("_derivative", {
        "ConstantNode, Object": function ConstantNodeObject(node) {
            return createConstantNode(0);
        },
        "SymbolNode, Object": function SymbolNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            return createConstantNode(1);
        },
        "ParenthesisNode, Object": function ParenthesisNodeObject(node, constNodes) {
            return new ParenthesisNode(_derivative(node.content, constNodes));
        },
        "FunctionAssignmentNode, Object": function FunctionAssignmentNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            return _derivative(node.expr, constNodes);
        },
        "FunctionNode, Object": function FunctionNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            var arg0 = node.args[0];
            var arg1;
            var div = false; // is output a fraction?
            var negative = false; // is output negative?
            var funcDerivative;
            switch(node.name){
                case "cbrt":
                    // d/dx(cbrt(x)) = 1 / (3x^(2/3))
                    div = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        createConstantNode(3),
                        new OperatorNode("^", "pow", [
                            arg0,
                            new OperatorNode("/", "divide", [
                                createConstantNode(2),
                                createConstantNode(3)
                            ])
                        ])
                    ]);
                    break;
                case "sqrt":
                case "nthRoot":
                    // d/dx(sqrt(x)) = 1 / (2*sqrt(x))
                    if (node.args.length === 1) {
                        div = true;
                        funcDerivative = new OperatorNode("*", "multiply", [
                            createConstantNode(2),
                            new FunctionNode("sqrt", [
                                arg0
                            ])
                        ]);
                    } else if (node.args.length === 2) {
                        // Rearrange from nthRoot(x, a) -> x^(1/a)
                        arg1 = new OperatorNode("/", "divide", [
                            createConstantNode(1),
                            node.args[1]
                        ]);
                        // Is a variable?
                        constNodes[arg1] = constNodes[node.args[1]];
                        return _derivative(new OperatorNode("^", "pow", [
                            arg0,
                            arg1
                        ]), constNodes);
                    }
                    break;
                case "log10":
                    arg1 = createConstantNode(10);
                /* fall through! */ case "log":
                    if (!arg1 && node.args.length === 1) {
                        // d/dx(log(x)) = 1 / x
                        funcDerivative = arg0.clone();
                        div = true;
                    } else if (node.args.length === 1 && arg1 || node.args.length === 2 && constNodes[node.args[1]] !== undefined) {
                        // d/dx(log(x, c)) = 1 / (x*ln(c))
                        funcDerivative = new OperatorNode("*", "multiply", [
                            arg0.clone(),
                            new FunctionNode("log", [
                                arg1 || node.args[1]
                            ])
                        ]);
                        div = true;
                    } else if (node.args.length === 2) // d/dx(log(f(x), g(x))) = d/dx(log(f(x)) / log(g(x)))
                    return _derivative(new OperatorNode("/", "divide", [
                        new FunctionNode("log", [
                            arg0
                        ]),
                        new FunctionNode("log", [
                            node.args[1]
                        ])
                    ]), constNodes);
                    break;
                case "pow":
                    if (node.args.length === 2) {
                        constNodes[arg1] = constNodes[node.args[1]];
                        // Pass to pow operator node parser
                        return _derivative(new OperatorNode("^", "pow", [
                            arg0,
                            node.args[1]
                        ]), constNodes);
                    }
                    break;
                case "exp":
                    // d/dx(e^x) = e^x
                    funcDerivative = new FunctionNode("exp", [
                        arg0.clone()
                    ]);
                    break;
                case "sin":
                    // d/dx(sin(x)) = cos(x)
                    funcDerivative = new FunctionNode("cos", [
                        arg0.clone()
                    ]);
                    break;
                case "cos":
                    // d/dx(cos(x)) = -sin(x)
                    funcDerivative = new OperatorNode("-", "unaryMinus", [
                        new FunctionNode("sin", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "tan":
                    // d/dx(tan(x)) = sec(x)^2
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("sec", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "sec":
                    // d/dx(sec(x)) = sec(x)tan(x)
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("tan", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "csc":
                    // d/dx(csc(x)) = -csc(x)cot(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("cot", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "cot":
                    // d/dx(cot(x)) = -csc(x)^2
                    negative = true;
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("csc", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "asin":
                    // d/dx(asin(x)) = 1 / sqrt(1 - x^2)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            createConstantNode(1),
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ])
                        ])
                    ]);
                    break;
                case "acos":
                    // d/dx(acos(x)) = -1 / sqrt(1 - x^2)
                    div = true;
                    negative = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            createConstantNode(1),
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ])
                        ])
                    ]);
                    break;
                case "atan":
                    // d/dx(atan(x)) = 1 / (x^2 + 1)
                    div = true;
                    funcDerivative = new OperatorNode("+", "add", [
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ]),
                        createConstantNode(1)
                    ]);
                    break;
                case "asec":
                    // d/dx(asec(x)) = 1 / (|x|*sqrt(x^2 - 1))
                    div = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acsc":
                    // d/dx(acsc(x)) = -1 / (|x|*sqrt(x^2 - 1))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acot":
                    // d/dx(acot(x)) = -1 / (x^2 + 1)
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("+", "add", [
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ]),
                        createConstantNode(1)
                    ]);
                    break;
                case "sinh":
                    // d/dx(sinh(x)) = cosh(x)
                    funcDerivative = new FunctionNode("cosh", [
                        arg0.clone()
                    ]);
                    break;
                case "cosh":
                    // d/dx(cosh(x)) = sinh(x)
                    funcDerivative = new FunctionNode("sinh", [
                        arg0.clone()
                    ]);
                    break;
                case "tanh":
                    // d/dx(tanh(x)) = sech(x)^2
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("sech", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "sech":
                    // d/dx(sech(x)) = -sech(x)tanh(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("tanh", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "csch":
                    // d/dx(csch(x)) = -csch(x)coth(x)
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        node,
                        new FunctionNode("coth", [
                            arg0.clone()
                        ])
                    ]);
                    break;
                case "coth":
                    // d/dx(coth(x)) = -csch(x)^2
                    negative = true;
                    funcDerivative = new OperatorNode("^", "pow", [
                        new FunctionNode("csch", [
                            arg0.clone()
                        ]),
                        createConstantNode(2)
                    ]);
                    break;
                case "asinh":
                    // d/dx(asinh(x)) = 1 / sqrt(x^2 + 1)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("+", "add", [
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ]),
                            createConstantNode(1)
                        ])
                    ]);
                    break;
                case "acosh":
                    // d/dx(acosh(x)) = 1 / sqrt(x^2 - 1); XXX potentially only for x >= 1 (the real spectrum)
                    div = true;
                    funcDerivative = new FunctionNode("sqrt", [
                        new OperatorNode("-", "subtract", [
                            new OperatorNode("^", "pow", [
                                arg0.clone(),
                                createConstantNode(2)
                            ]),
                            createConstantNode(1)
                        ])
                    ]);
                    break;
                case "atanh":
                    // d/dx(atanh(x)) = 1 / (1 - x^2)
                    div = true;
                    funcDerivative = new OperatorNode("-", "subtract", [
                        createConstantNode(1),
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ])
                    ]);
                    break;
                case "asech":
                    // d/dx(asech(x)) = -1 / (x*sqrt(1 - x^2))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        arg0.clone(),
                        new FunctionNode("sqrt", [
                            new OperatorNode("-", "subtract", [
                                createConstantNode(1),
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ])
                            ])
                        ])
                    ]);
                    break;
                case "acsch":
                    // d/dx(acsch(x)) = -1 / (|x|*sqrt(x^2 + 1))
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("*", "multiply", [
                        new FunctionNode("abs", [
                            arg0.clone()
                        ]),
                        new FunctionNode("sqrt", [
                            new OperatorNode("+", "add", [
                                new OperatorNode("^", "pow", [
                                    arg0.clone(),
                                    createConstantNode(2)
                                ]),
                                createConstantNode(1)
                            ])
                        ])
                    ]);
                    break;
                case "acoth":
                    // d/dx(acoth(x)) = -1 / (1 - x^2)
                    div = true;
                    negative = true;
                    funcDerivative = new OperatorNode("-", "subtract", [
                        createConstantNode(1),
                        new OperatorNode("^", "pow", [
                            arg0.clone(),
                            createConstantNode(2)
                        ])
                    ]);
                    break;
                case "abs":
                    // d/dx(abs(x)) = abs(x)/x
                    funcDerivative = new OperatorNode("/", "divide", [
                        new FunctionNode(new SymbolNode("abs"), [
                            arg0.clone()
                        ]),
                        arg0.clone()
                    ]);
                    break;
                case "gamma":
                default:
                    throw new Error('Cannot process function "' + node.name + '" in derivative: ' + "the function is not supported, undefined, or the number of arguments passed to it are not supported");
            }
            var op, func;
            if (div) {
                op = "/";
                func = "divide";
            } else {
                op = "*";
                func = "multiply";
            }
            /* Apply chain rule to all functions:
         F(x)  = f(g(x))
         F'(x) = g'(x)*f'(g(x)) */ var chainDerivative = _derivative(arg0, constNodes);
            if (negative) chainDerivative = new OperatorNode("-", "unaryMinus", [
                chainDerivative
            ]);
            return new OperatorNode(op, func, [
                chainDerivative,
                funcDerivative
            ]);
        },
        "OperatorNode, Object": function OperatorNodeObject(node, constNodes) {
            if (constNodes[node] !== undefined) return createConstantNode(0);
            if (node.op === "+") // d/dx(sum(f(x)) = sum(f'(x))
            return new OperatorNode(node.op, node.fn, node.args.map(function(arg) {
                return _derivative(arg, constNodes);
            }));
            if (node.op === "-") {
                // d/dx(+/-f(x)) = +/-f'(x)
                if (node.isUnary()) return new OperatorNode(node.op, node.fn, [
                    _derivative(node.args[0], constNodes)
                ]);
                // Linearity of differentiation, d/dx(f(x) +/- g(x)) = f'(x) +/- g'(x)
                if (node.isBinary()) return new OperatorNode(node.op, node.fn, [
                    _derivative(node.args[0], constNodes),
                    _derivative(node.args[1], constNodes)
                ]);
            }
            if (node.op === "*") {
                // d/dx(c*f(x)) = c*f'(x)
                var constantTerms = node.args.filter(function(arg) {
                    return constNodes[arg] !== undefined;
                });
                if (constantTerms.length > 0) {
                    var nonConstantTerms = node.args.filter(function(arg) {
                        return constNodes[arg] === undefined;
                    });
                    var nonConstantNode = nonConstantTerms.length === 1 ? nonConstantTerms[0] : new OperatorNode("*", "multiply", nonConstantTerms);
                    var newArgs = constantTerms.concat(_derivative(nonConstantNode, constNodes));
                    return new OperatorNode("*", "multiply", newArgs);
                }
                // Product Rule, d/dx(f(x)*g(x)) = f'(x)*g(x) + f(x)*g'(x)
                return new OperatorNode("+", "add", node.args.map(function(argOuter) {
                    return new OperatorNode("*", "multiply", node.args.map(function(argInner) {
                        return argInner === argOuter ? _derivative(argInner, constNodes) : argInner.clone();
                    }));
                }));
            }
            if (node.op === "/" && node.isBinary()) {
                var arg0 = node.args[0];
                var arg1 = node.args[1];
                // d/dx(f(x) / c) = f'(x) / c
                if (constNodes[arg1] !== undefined) return new OperatorNode("/", "divide", [
                    _derivative(arg0, constNodes),
                    arg1
                ]);
                // Reciprocal Rule, d/dx(c / f(x)) = -c(f'(x)/f(x)^2)
                if (constNodes[arg0] !== undefined) return new OperatorNode("*", "multiply", [
                    new OperatorNode("-", "unaryMinus", [
                        arg0
                    ]),
                    new OperatorNode("/", "divide", [
                        _derivative(arg1, constNodes),
                        new OperatorNode("^", "pow", [
                            arg1.clone(),
                            createConstantNode(2)
                        ])
                    ])
                ]);
                // Quotient rule, d/dx(f(x) / g(x)) = (f'(x)g(x) - f(x)g'(x)) / g(x)^2
                return new OperatorNode("/", "divide", [
                    new OperatorNode("-", "subtract", [
                        new OperatorNode("*", "multiply", [
                            _derivative(arg0, constNodes),
                            arg1.clone()
                        ]),
                        new OperatorNode("*", "multiply", [
                            arg0.clone(),
                            _derivative(arg1, constNodes)
                        ])
                    ]),
                    new OperatorNode("^", "pow", [
                        arg1.clone(),
                        createConstantNode(2)
                    ])
                ]);
            }
            if (node.op === "^" && node.isBinary()) {
                var _arg = node.args[0];
                var _arg2 = node.args[1];
                if (constNodes[_arg] !== undefined) {
                    // If is secretly constant; 0^f(x) = 1 (in JS), 1^f(x) = 1
                    if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(_arg) && (isZero(_arg.value) || equal(_arg.value, 1))) return createConstantNode(0);
                    // d/dx(c^f(x)) = c^f(x)*ln(c)*f'(x)
                    return new OperatorNode("*", "multiply", [
                        node,
                        new OperatorNode("*", "multiply", [
                            new FunctionNode("log", [
                                _arg.clone()
                            ]),
                            _derivative(_arg2.clone(), constNodes)
                        ])
                    ]);
                }
                if (constNodes[_arg2] !== undefined) {
                    if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(_arg2)) {
                        // If is secretly constant; f(x)^0 = 1 -> d/dx(1) = 0
                        if (isZero(_arg2.value)) return createConstantNode(0);
                        // Ignore exponent; f(x)^1 = f(x)
                        if (equal(_arg2.value, 1)) return _derivative(_arg, constNodes);
                    }
                    // Elementary Power Rule, d/dx(f(x)^c) = c*f'(x)*f(x)^(c-1)
                    var powMinusOne = new OperatorNode("^", "pow", [
                        _arg.clone(),
                        new OperatorNode("-", "subtract", [
                            _arg2,
                            createConstantNode(1)
                        ])
                    ]);
                    return new OperatorNode("*", "multiply", [
                        _arg2.clone(),
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg, constNodes),
                            powMinusOne
                        ])
                    ]);
                }
                // Functional Power Rule, d/dx(f^g) = f^g*[f'*(g/f) + g'ln(f)]
                return new OperatorNode("*", "multiply", [
                    new OperatorNode("^", "pow", [
                        _arg.clone(),
                        _arg2.clone()
                    ]),
                    new OperatorNode("+", "add", [
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg, constNodes),
                            new OperatorNode("/", "divide", [
                                _arg2.clone(),
                                _arg.clone()
                            ])
                        ]),
                        new OperatorNode("*", "multiply", [
                            _derivative(_arg2, constNodes),
                            new FunctionNode("log", [
                                _arg.clone()
                            ])
                        ])
                    ])
                ]);
            }
            throw new Error('Cannot process operator "' + node.op + '" in derivative: ' + "the operator is not supported, undefined, or the number of arguments passed to it are not supported");
        }
    });
    /**
   * Helper function to create a constant node with a specific type
   * (number, BigNumber, Fraction)
   * @param {number} value
   * @param {string} [valueType]
   * @return {ConstantNode}
   */ function createConstantNode(value, valueType) {
        return new ConstantNode(numeric(value, valueType || (0, $a246eb207aab6d09$export$28199db5a610a1ee)(String(value), config)));
    }
    return derivative;
});





function $43b0d4e2cc26d017$export$75974926bb7e1bd6(args) {
    if (args.length === 2 && (0, $23cfe017d190638f$export$cea7aa84e978eba5)(args[0])) {
        args = args.slice();
        var dim = args[1];
        if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(dim)) args[1] = dim - 1;
        else if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(dim)) args[1] = dim.minus(1);
    }
    return args;
}


var $0e008be10e4f54a4$var$name = "diff";
var $0e008be10e4f54a4$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "number",
    "bignumber"
];
var $0e008be10e4f54a4$export$829cfcec5c5f4a9d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0e008be10e4f54a4$var$name, $0e008be10e4f54a4$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, number: number, bignumber: bignumber } = _ref;
    var diff = (0, $b9be86f35c7035bf$export$49df08fd121951b4)({
        typed: typed,
        matrix: matrix,
        subtract: subtract,
        number: number,
        bignumber: bignumber
    });
    /**
   * Attach a transform function to math.diff
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */ return typed($0e008be10e4f54a4$var$name, {
        "...any": function any(args) {
            args = (0, $43b0d4e2cc26d017$export$75974926bb7e1bd6)(args);
            try {
                return diff.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});




var $59cf63bca65202ff$var$name = "evaluate";
var $59cf63bca65202ff$var$dependencies = [
    "typed",
    "parse"
];
var $59cf63bca65202ff$export$4f825d0ade64f616 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($59cf63bca65202ff$var$name, $59cf63bca65202ff$var$dependencies, (_ref)=>{
    var { typed: typed, parse: parse } = _ref;
    /**
   * Evaluate an expression.
   *
   * Note the evaluating arbitrary expressions may involve security risks,
   * see [https://mathjs.org/docs/expressions/security.html](https://mathjs.org/docs/expressions/security.html) for more information.
   *
   * Syntax:
   *
   *     math.evaluate(expr)
   *     math.evaluate(expr, scope)
   *     math.evaluate([expr1, expr2, expr3, ...])
   *     math.evaluate([expr1, expr2, expr3, ...], scope)
   *
   * Example:
   *
   *     math.evaluate('(2+3)/4')                // 1.25
   *     math.evaluate('sqrt(3^2 + 4^2)')        // 5
   *     math.evaluate('sqrt(-4)')               // 2i
   *     math.evaluate(['a=3', 'b=4', 'a*b'])    // [3, 4, 12]
   *
   *     let scope = {a:3, b:4}
   *     math.evaluate('a * b', scope)           // 12
   *
   * See also:
   *
   *    parse, compile
   *
   * @param {string | string[] | Matrix} expr   The expression to be evaluated
   * @param {Object} [scope]                    Scope to read/write variables
   * @return {*} The result of the expression
   * @throws {Error}
   */ return typed($59cf63bca65202ff$var$name, {
        string: function string(expr) {
            var scope = (0, $ec715b2ae25daaa7$export$89a4bcaf5b4d37d2)();
            return parse(expr).compile().evaluate(scope);
        },
        "string, Map | Object": function stringMapObject(expr, scope) {
            return parse(expr).compile().evaluate(scope);
        },
        "Array | Matrix": function ArrayMatrix(expr) {
            var scope = (0, $ec715b2ae25daaa7$export$89a4bcaf5b4d37d2)();
            return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(expr, function(entry) {
                return parse(entry).compile().evaluate(scope);
            });
        },
        "Array | Matrix, Map | Object": function ArrayMatrixMapObject(expr, scope) {
            return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(expr, function(entry) {
                return parse(entry).compile().evaluate(scope);
            });
        }
    });
});







function $2865fa308ee8113b$export$cbb6101da03c2e83(expression, math, scope) {
    // find an undefined symbol
    var symbol = expression.filter(function(node) {
        return (0, $23cfe017d190638f$export$87815d550facaed9)(node) && !(node.name in math) && !scope.has(node.name);
    })[0];
    if (!symbol) throw new Error('No undefined variable found in inline expression "' + expression + '"');
    // create a test function for this equation
    var name = symbol.name; // variable name
    var argsScope = new Map();
    var subScope = new (0, $ec715b2ae25daaa7$export$93f35497d1acacc3)(scope, argsScope, new Set([
        name
    ]));
    var eq = expression.compile();
    return function inlineExpression(x) {
        argsScope.set(name, x);
        return eq.evaluate(subScope);
    };
}


var $0e6efe9bf30d97e6$var$name = "filter";
var $0e6efe9bf30d97e6$var$dependencies = [
    "typed"
];
var $0e6efe9bf30d97e6$export$a53d7aa4a2c1e7e3 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0e6efe9bf30d97e6$var$name, $0e6efe9bf30d97e6$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Attach a transform function to math.filter
   * Adds a property transform containing the transform function.
   *
   * This transform adds support for equations as test function for math.filter,
   * so you can do something like 'filter([3, -2, 5], x > 0)'.
   */ function filterTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $23cfe017d190638f$export$87815d550facaed9)(args[1]) || (0, $23cfe017d190638f$export$27c05cfffd263d30)(args[1])) // a function pointer, like filter([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like filter([3, -2, 5], x > 0)
            callback = (0, $2865fa308ee8113b$export$cbb6101da03c2e83)(args[1], math, scope);
        }
        return filter(x, callback);
    }
    filterTransform.rawArgs = true;
    // one based version of function filter
    var filter = typed("filter", {
        "Array, function": $0e6efe9bf30d97e6$var$_filter,
        "Matrix, function": function MatrixFunction(x, test) {
            return x.create($0e6efe9bf30d97e6$var$_filter(x.toArray(), test));
        },
        "Array, RegExp": (0, $eee21df0c3527ff1$export$322859471e81229d),
        "Matrix, RegExp": function MatrixRegExp(x, test) {
            return x.create((0, $eee21df0c3527ff1$export$322859471e81229d)(x.toArray(), test));
        }
    });
    return filterTransform;
}, {
    isTransformFunction: true
});
/**
 * Filter values in a callback given a callback function
 *
 * !!! Passes a one-based index !!!
 *
 * @param {Array} x
 * @param {Function} callback
 * @return {Array} Returns the filtered array
 * @private
 */ function $0e6efe9bf30d97e6$var$_filter(x, callback) {
    return (0, $eee21df0c3527ff1$export$3dea766d36a8935f)(x, function(value, index, array) {
        // invoke the callback function with the right number of arguments
        return (0, $1427f34fc9a7e1b3$export$c081893a7ce04a4c)(callback, value, [
            index + 1
        ], array, "filter");
    });
}






var $7a1b9a29380f7b7f$var$name = "forEach";
var $7a1b9a29380f7b7f$var$dependencies = [
    "typed"
];
var $7a1b9a29380f7b7f$export$342aa09106704265 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($7a1b9a29380f7b7f$var$name, $7a1b9a29380f7b7f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Attach a transform function to math.forEach
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ function forEachTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $23cfe017d190638f$export$87815d550facaed9)(args[1]) || (0, $23cfe017d190638f$export$27c05cfffd263d30)(args[1])) // a function pointer, like forEach([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like forEach([3, -2, 5], x > 0 ? callback1(x) : callback2(x) )
            callback = (0, $2865fa308ee8113b$export$cbb6101da03c2e83)(args[1], math, scope);
        }
        return _forEach(x, callback);
    }
    forEachTransform.rawArgs = true;
    // one-based version of forEach
    var _forEach = typed("forEach", {
        "Array | Matrix, function": function ArrayMatrixFunction(array, callback) {
            var recurse = function recurse(value, index) {
                if (Array.isArray(value)) (0, $eee21df0c3527ff1$export$4b80e395e36b5a56)(value, function(child, i) {
                    // we create a copy of the index array and append the new index value
                    recurse(child, index.concat(i + 1)); // one based index, hence i+1
                });
                else // invoke the callback function with the right number of arguments
                return (0, $1427f34fc9a7e1b3$export$c081893a7ce04a4c)(callback, value, index, array, "forEach");
            };
            recurse(array.valueOf(), []); // pass Array
        }
    });
    return forEachTransform;
}, {
    isTransformFunction: true
});



// Reserved keywords not allowed to use in the parser
var $cd3ff6322acd5c08$export$eebaaf2b24d91f63 = new Set([
    "end"
]);







var $0fee188404352d0b$var$name = "FunctionAssignmentNode";
var $0fee188404352d0b$var$dependencies = [
    "typed",
    "Node"
];
var $0fee188404352d0b$export$fd037c04876b4924 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0fee188404352d0b$var$name, $0fee188404352d0b$var$dependencies, (_ref)=>{
    var { typed: typed, Node: Node } = _ref;
    /**
   * Is parenthesis needed?
   * @param {Node} node
   * @param {Object} parenthesis
   * @param {string} implicit
   * @private
   */ function needParenthesis(node, parenthesis, implicit) {
        var precedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(node, parenthesis, implicit);
        var exprPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(node.expr, parenthesis, implicit);
        return parenthesis === "all" || exprPrecedence !== null && exprPrecedence <= precedence;
    }
    class FunctionAssignmentNode extends Node {
        get type() {
            return $0fee188404352d0b$var$name;
        }
        get isFunctionAssignmentNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            var childArgNames = Object.create(argNames);
            (0, $eee21df0c3527ff1$export$4b80e395e36b5a56)(this.params, function(param) {
                childArgNames[param] = true;
            });
            // compile the function expression with the child args
            var evalExpr = this.expr._compile(math, childArgNames);
            var name = this.name;
            var params = this.params;
            var signature = (0, $eee21df0c3527ff1$export$f7e2c8231c57a8bd)(this.types, ",");
            var syntax = name + "(" + (0, $eee21df0c3527ff1$export$f7e2c8231c57a8bd)(this.params, ", ") + ")";
            return function evalFunctionAssignmentNode(scope, args, context) {
                var signatures = {};
                signatures[signature] = function() {
                    var childArgs = Object.create(args);
                    for(var i = 0; i < params.length; i++)childArgs[params[i]] = arguments[i];
                    return evalExpr(scope, childArgs, context);
                };
                var fn = typed(name, signatures);
                fn.syntax = syntax;
                scope.set(name, fn);
                return fn;
            };
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            callback(this.expr, "expr", this);
        }
        /**
     * Create a new FunctionAssignmentNode whose children are the results of
     * calling the provided callback function for each child of the original
     * node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {FunctionAssignmentNode} Returns a transformed copy of the node
     */ map(callback) {
            var expr = this._ifNode(callback(this.expr, "expr", this));
            return new FunctionAssignmentNode(this.name, this.params.slice(0), expr);
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {FunctionAssignmentNode}
     */ clone() {
            return new FunctionAssignmentNode(this.name, this.params.slice(0), this.expr);
        }
        /**
     * get string representation
     * @param {Object} options
     * @return {string} str
     */ _toString(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var expr = this.expr.toString(options);
            if (needParenthesis(this, parenthesis, options && options.implicit)) expr = "(" + expr + ")";
            return this.name + "(" + this.params.join(", ") + ") = " + expr;
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            var types = this.types;
            return {
                mathjs: $0fee188404352d0b$var$name,
                name: this.name,
                params: this.params.map(function(param, index) {
                    return {
                        name: param,
                        type: types[index]
                    };
                }),
                expr: this.expr
            };
        }
        /**
     * Instantiate an FunctionAssignmentNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "FunctionAssignmentNode",
     *      name: ..., params: ..., expr: ...}
     *     ```
     *     where mathjs is optional
     * @returns {FunctionAssignmentNode}
     */ static fromJSON(json) {
            return new FunctionAssignmentNode(json.name, json.params, json.expr);
        }
        /**
     * get HTML representation
     * @param {Object} options
     * @return {string} str
     */ _toHTML(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var params = [];
            for(var i = 0; i < this.params.length; i++)params.push('<span class="math-symbol math-parameter">' + (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(this.params[i]) + "</span>");
            var expr = this.expr.toHTML(options);
            if (needParenthesis(this, parenthesis, options && options.implicit)) expr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + expr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            return '<span class="math-function">' + (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(this.name) + "</span>" + '<span class="math-parenthesis math-round-parenthesis">(</span>' + params.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span>' + '<span class="math-operator math-assignment-operator ' + 'math-variable-assignment-operator math-binary-operator">=</span>' + expr;
        }
        /**
     * get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */ _toTex(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var expr = this.expr.toTex(options);
            if (needParenthesis(this, parenthesis, options && options.implicit)) expr = "\\left(".concat(expr, "\\right)");
            return "\\mathrm{" + this.name + "}\\left(" + this.params.map((0, $a279f526ff78ebb8$export$358d3bb1a752ff)).join(",") + "\\right)=" + expr;
        }
        /**
     * @constructor FunctionAssignmentNode
     * @extends {Node}
     * Function assignment
     *
     * @param {string} name           Function name
     * @param {string[] | Array.<{name: string, type: string}>} params
     *                                Array with function parameter names, or an
     *                                array with objects containing the name
     *                                and type of the parameter
     * @param {Node} expr             The function expression
     */ constructor(name, params, expr){
            super();
            // validate input
            if (typeof name !== "string") throw new TypeError('String expected for parameter "name"');
            if (!Array.isArray(params)) throw new TypeError('Array containing strings or objects expected for parameter "params"');
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(expr)) throw new TypeError('Node expected for parameter "expr"');
            if ((0, $cd3ff6322acd5c08$export$eebaaf2b24d91f63).has(name)) throw new Error('Illegal function name, "' + name + '" is a reserved keyword');
            var paramNames = new Set();
            for (var param of params){
                var _name = typeof param === "string" ? param : param.name;
                if (paramNames.has(_name)) throw new Error('Duplicate parameter name "'.concat(_name, '"'));
                else paramNames.add(_name);
            }
            this.name = name;
            this.params = params.map(function(param) {
                return param && param.name || param;
            });
            this.types = params.map(function(param) {
                return param && param.type || "any";
            });
            this.expr = expr;
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(FunctionAssignmentNode, "name", $0fee188404352d0b$var$name);
    return FunctionAssignmentNode;
}, {
    isClass: true,
    isNode: true
});







function $726d3abcc79d73a1$export$6357aae939e9e636(parentScope, args) {
    return new (0, $ec715b2ae25daaa7$export$93f35497d1acacc3)(parentScope, new (0, $ec715b2ae25daaa7$export$6f491f8f4fd27271)(args), new Set(Object.keys(args)));
}




var $39afce01eb92a424$var$name = "FunctionNode";
var $39afce01eb92a424$var$dependencies = [
    "math",
    "Node",
    "SymbolNode"
];
var $39afce01eb92a424$export$d03e7338a74cdf4c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($39afce01eb92a424$var$name, $39afce01eb92a424$var$dependencies, (_ref)=>{
    var _FunctionNode;
    var { math: math, Node: Node, SymbolNode: SymbolNode } = _ref;
    /* format to fixed length */ var strin = (entity)=>(0, $1b038b7ade911d0e$export$d9468344d3651243)(entity, {
            truncate: 78
        });
    /*
   * Expand a LaTeX template
   *
   * @param {string} template
   * @param {Node} node
   * @param {Object} options
   * @private
   **/ function expandTemplate(template, node, options) {
        var latex = "";
        // Match everything of the form ${identifier} or ${identifier[2]} or $$
        // while submatching identifier and 2 (in the second case)
        var regex = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi;
        var inputPos = 0; // position in the input string
        var match;
        while((match = regex.exec(template)) !== null){
            // go through all matches
            // add everything in front of the match to the LaTeX string
            latex += template.substring(inputPos, match.index);
            inputPos = match.index;
            if (match[0] === "$$") {
                // escaped dollar sign
                latex += "$";
                inputPos++;
            } else {
                // template parameter
                inputPos += match[0].length;
                var property = node[match[1]];
                if (!property) throw new ReferenceError("Template: Property " + match[1] + " does not exist.");
                if (match[2] === undefined) // no square brackets
                switch(typeof property){
                    case "string":
                        latex += property;
                        break;
                    case "object":
                        if ((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(property)) latex += property.toTex(options);
                        else if (Array.isArray(property)) // make array of Nodes into comma separated list
                        latex += property.map(function(arg, index) {
                            if ((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(arg)) return arg.toTex(options);
                            throw new TypeError("Template: " + match[1] + "[" + index + "] is not a Node.");
                        }).join(",");
                        else throw new TypeError("Template: " + match[1] + " has to be a Node, String or array of Nodes");
                        break;
                    default:
                        throw new TypeError("Template: " + match[1] + " has to be a Node, String or array of Nodes");
                }
                else {
                    // with square brackets
                    if ((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(property[match[2]] && property[match[2]])) latex += property[match[2]].toTex(options);
                    else throw new TypeError("Template: " + match[1] + "[" + match[2] + "] is not a Node.");
                }
            }
        }
        latex += template.slice(inputPos); // append rest of the template
        return latex;
    }
    class FunctionNode extends Node {
        // readonly property name
        get name() {
            return this.fn.name || "";
        }
        get type() {
            return $39afce01eb92a424$var$name;
        }
        get isFunctionNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            // compile arguments
            var evalArgs = this.args.map((arg)=>arg._compile(math, argNames));
            if ((0, $23cfe017d190638f$export$87815d550facaed9)(this.fn)) {
                var _name = this.fn.name;
                if (!argNames[_name]) {
                    // we can statically determine whether the function
                    // has the rawArgs property
                    var fn = _name in math ? (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(math, _name) : undefined;
                    var isRaw = typeof fn === "function" && fn.rawArgs === true;
                    var resolveFn = (scope)=>{
                        var value;
                        if (scope.has(_name)) value = scope.get(_name);
                        else if (_name in math) value = (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(math, _name);
                        else return FunctionNode.onUndefinedFunction(_name);
                        if (typeof value === "function") return value;
                        throw new TypeError("'".concat(_name, "' is not a function; its value is:\n  ").concat(strin(value)));
                    };
                    if (isRaw) {
                        // pass unevaluated parameters (nodes) to the function
                        // "raw" evaluation
                        var rawArgs = this.args;
                        return function evalFunctionNode(scope, args, context) {
                            var fn = resolveFn(scope);
                            return fn(rawArgs, math, (0, $726d3abcc79d73a1$export$6357aae939e9e636)(scope, args));
                        };
                    } else // "regular" evaluation
                    switch(evalArgs.length){
                        case 0:
                            return function evalFunctionNode(scope, args, context) {
                                var fn = resolveFn(scope);
                                return fn();
                            };
                        case 1:
                            return function evalFunctionNode(scope, args, context) {
                                var fn = resolveFn(scope);
                                var evalArg0 = evalArgs[0];
                                return fn(evalArg0(scope, args, context));
                            };
                        case 2:
                            return function evalFunctionNode(scope, args, context) {
                                var fn = resolveFn(scope);
                                var evalArg0 = evalArgs[0];
                                var evalArg1 = evalArgs[1];
                                return fn(evalArg0(scope, args, context), evalArg1(scope, args, context));
                            };
                        default:
                            return function evalFunctionNode(scope, args, context) {
                                var fn = resolveFn(scope);
                                var values = evalArgs.map((evalArg)=>evalArg(scope, args, context));
                                return fn(...values);
                            };
                    }
                } else {
                    // the function symbol is an argName
                    var _rawArgs = this.args;
                    return function evalFunctionNode(scope, args, context) {
                        var fn = (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(args, _name);
                        if (typeof fn !== "function") throw new TypeError("Argument '".concat(_name, "' was not a function; received: ").concat(strin(fn)));
                        if (fn.rawArgs) // "Raw" evaluation
                        return fn(_rawArgs, math, (0, $726d3abcc79d73a1$export$6357aae939e9e636)(scope, args));
                        else {
                            var values = evalArgs.map((evalArg)=>evalArg(scope, args, context));
                            return fn.apply(fn, values);
                        }
                    };
                }
            } else if ((0, $23cfe017d190638f$export$f88fb19d6b9ee5cb)(this.fn) && (0, $23cfe017d190638f$export$ff90979121a6cabc)(this.fn.index) && this.fn.index.isObjectProperty()) {
                // execute the function with the right context:
                // the object of the AccessorNode
                var evalObject = this.fn.object._compile(math, argNames);
                var prop = this.fn.index.getObjectProperty();
                var _rawArgs2 = this.args;
                return function evalFunctionNode(scope, args, context) {
                    var object = evalObject(scope, args, context);
                    var fn = (0, $f59a31bcbbaa9e5a$export$94fda296bbe7ba21)(object, prop);
                    if (fn !== null && fn !== void 0 && fn.rawArgs) // "Raw" evaluation
                    return fn(_rawArgs2, math, (0, $726d3abcc79d73a1$export$6357aae939e9e636)(scope, args));
                    else {
                        // "regular" evaluation
                        var values = evalArgs.map((evalArg)=>evalArg(scope, args, context));
                        return fn.apply(object, values);
                    }
                };
            } else {
                // node.fn.isAccessorNode && !node.fn.index.isObjectProperty()
                // we have to dynamically determine whether the function has the
                // rawArgs property
                var fnExpr = this.fn.toString();
                var evalFn = this.fn._compile(math, argNames);
                var _rawArgs3 = this.args;
                return function evalFunctionNode(scope, args, context) {
                    var fn = evalFn(scope, args, context);
                    if (typeof fn !== "function") throw new TypeError("Expression '".concat(fnExpr, "' did not evaluate to a function; value is:") + "\n  ".concat(strin(fn)));
                    if (fn.rawArgs) // "Raw" evaluation
                    return fn(_rawArgs3, math, (0, $726d3abcc79d73a1$export$6357aae939e9e636)(scope, args));
                    else {
                        // "regular" evaluation
                        var values = evalArgs.map((evalArg)=>evalArg(scope, args, context));
                        return fn.apply(fn, values);
                    }
                };
            }
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            callback(this.fn, "fn", this);
            for(var i = 0; i < this.args.length; i++)callback(this.args[i], "args[" + i + "]", this);
        }
        /**
     * Create a new FunctionNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {FunctionNode} Returns a transformed copy of the node
     */ map(callback) {
            var fn = this._ifNode(callback(this.fn, "fn", this));
            var args = [];
            for(var i = 0; i < this.args.length; i++)args[i] = this._ifNode(callback(this.args[i], "args[" + i + "]", this));
            return new FunctionNode(fn, args);
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {FunctionNode}
     */ clone() {
            return new FunctionNode(this.fn, this.args.slice(0));
        }
        /**
     * Throws an error 'Undefined function {name}'
     * @param {string} name
     */ /**
     * Get string representation. (wrapper function)
     * This overrides parts of Node's toString function.
     * If callback is an object containing callbacks, it
     * calls the correct callback for the current node,
     * otherwise it falls back to calling Node's toString
     * function.
     *
     * @param {Object} options
     * @return {string} str
     * @override
     */ toString(options) {
            var customString;
            var name = this.fn.toString(options);
            if (options && typeof options.handler === "object" && (0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(options.handler, name)) // callback is a map of callback functions
            customString = options.handler[name](this, options);
            if (typeof customString !== "undefined") return customString;
            // fall back to Node's toString
            return super.toString(options);
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */ _toString(options) {
            var args = this.args.map(function(arg) {
                return arg.toString(options);
            });
            var fn = (0, $23cfe017d190638f$export$27c05cfffd263d30)(this.fn) ? "(" + this.fn.toString(options) + ")" : this.fn.toString(options);
            // format the arguments like "add(2, 4.2)"
            return fn + "(" + args.join(", ") + ")";
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $39afce01eb92a424$var$name,
                fn: this.fn,
                args: this.args
            };
        }
        /**
     * Instantiate an AssignmentNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "FunctionNode", fn: ..., args: ...}`,
     *                       where mathjs is optional
     * @returns {FunctionNode}
     */ /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */ _toHTML(options) {
            var args = this.args.map(function(arg) {
                return arg.toHTML(options);
            });
            // format the arguments like "add(2, 4.2)"
            return '<span class="math-function">' + (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + args.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
        }
        /**
     * Get LaTeX representation. (wrapper function)
     * This overrides parts of Node's toTex function.
     * If callback is an object containing callbacks, it
     * calls the correct callback for the current node,
     * otherwise it falls back to calling Node's toTex
     * function.
     *
     * @param {Object} options
     * @return {string}
     */ toTex(options) {
            var customTex;
            if (options && typeof options.handler === "object" && (0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(options.handler, this.name)) // callback is a map of callback functions
            customTex = options.handler[this.name](this, options);
            if (typeof customTex !== "undefined") return customTex;
            // fall back to Node's toTex
            return super.toTex(options);
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */ _toTex(options) {
            var args = this.args.map(function(arg) {
                // get LaTeX of the arguments
                return arg.toTex(options);
            });
            var latexConverter;
            if ((0, $a279f526ff78ebb8$export$b0cfc37067573780)[this.name]) latexConverter = (0, $a279f526ff78ebb8$export$b0cfc37067573780)[this.name];
            // toTex property on the function itself
            if (math[this.name] && (typeof math[this.name].toTex === "function" || typeof math[this.name].toTex === "object" || typeof math[this.name].toTex === "string")) // .toTex is a callback function
            latexConverter = math[this.name].toTex;
            var customToTex;
            switch(typeof latexConverter){
                case "function":
                    // a callback function
                    customToTex = latexConverter(this, options);
                    break;
                case "string":
                    // a template string
                    customToTex = expandTemplate(latexConverter, this, options);
                    break;
                case "object":
                    // an object with different "converters" for different
                    // numbers of arguments
                    switch(typeof latexConverter[args.length]){
                        case "function":
                            customToTex = latexConverter[args.length](this, options);
                            break;
                        case "string":
                            customToTex = expandTemplate(latexConverter[args.length], this, options);
                            break;
                    }
            }
            if (typeof customToTex !== "undefined") return customToTex;
            return expandTemplate((0, $a279f526ff78ebb8$export$76173758cefa70e5), this, options);
        }
        /**
     * Get identifier.
     * @return {string}
     */ getIdentifier() {
            return this.type + ":" + this.name;
        }
        /**
     * @constructor FunctionNode
     * @extends {./Node}
     * invoke a list with arguments on a node
     * @param {./Node | string} fn
     *     Item resolving to a function on which to invoke
     *     the arguments, typically a SymboNode or AccessorNode
     * @param {./Node[]} args
     */ constructor(fn, args){
            super();
            if (typeof fn === "string") fn = new SymbolNode(fn);
            // validate input
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(fn)) throw new TypeError('Node expected as parameter "fn"');
            if (!Array.isArray(args) || !args.every((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee))) throw new TypeError('Array containing Nodes expected for parameter "args"');
            this.fn = fn;
            this.args = args || [];
        }
    }
    _FunctionNode = FunctionNode;
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(FunctionNode, "name", $39afce01eb92a424$var$name);
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(FunctionNode, "onUndefinedFunction", function(name) {
        throw new Error("Undefined function " + name);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(FunctionNode, "fromJSON", function(json) {
        return new _FunctionNode(json.fn, json.args);
    });
    return FunctionNode;
}, {
    isClass: true,
    isNode: true
});



var $869b89673aca58e7$export$3fcb7a132c6e2ba6 = {
    name: "e",
    category: "Constants",
    syntax: [
        "e"
    ],
    description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828",
    examples: [
        "e",
        "e ^ 2",
        "exp(2)",
        "log(e)"
    ],
    seealso: [
        "exp"
    ]
};


var $c5bd98cecf9e56b4$export$a73c839095ae9f5c = {
    name: "false",
    category: "Constants",
    syntax: [
        "false"
    ],
    description: "Boolean value false",
    examples: [
        "false"
    ],
    seealso: [
        "true"
    ]
};


var $a2f1e96f98767691$export$e6ca220ee1b42382 = {
    name: "i",
    category: "Constants",
    syntax: [
        "i"
    ],
    description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",
    examples: [
        "i",
        "i * i",
        "sqrt(-1)"
    ],
    seealso: []
};


var $c2ef533cf01255af$export$15a96a548a33c6f1 = {
    name: "Infinity",
    category: "Constants",
    syntax: [
        "Infinity"
    ],
    description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",
    examples: [
        "Infinity",
        "1 / 0"
    ],
    seealso: []
};


var $635e435fc95fe61d$export$a1bd41a4b6a2fca0 = {
    name: "LN10",
    category: "Constants",
    syntax: [
        "LN10"
    ],
    description: "Returns the natural logarithm of 10, approximately equal to 2.302",
    examples: [
        "LN10",
        "log(10)"
    ],
    seealso: []
};


var $64ac6d13638085d3$export$6e0577c024a56563 = {
    name: "LN2",
    category: "Constants",
    syntax: [
        "LN2"
    ],
    description: "Returns the natural logarithm of 2, approximately equal to 0.693",
    examples: [
        "LN2",
        "log(2)"
    ],
    seealso: []
};


var $607af81a54b51f6b$export$c706f91356bdd28c = {
    name: "LOG10E",
    category: "Constants",
    syntax: [
        "LOG10E"
    ],
    description: "Returns the base-10 logarithm of E, approximately equal to 0.434",
    examples: [
        "LOG10E",
        "log(e, 10)"
    ],
    seealso: []
};


var $c0478b8cc3620ca5$export$813e053668381c19 = {
    name: "LOG2E",
    category: "Constants",
    syntax: [
        "LOG2E"
    ],
    description: "Returns the base-2 logarithm of E, approximately equal to 1.442",
    examples: [
        "LOG2E",
        "log(e, 2)"
    ],
    seealso: []
};


var $91e9ab16b10c7478$export$eabb08eada5c068d = {
    name: "NaN",
    category: "Constants",
    syntax: [
        "NaN"
    ],
    description: "Not a number",
    examples: [
        "NaN",
        "0 / 0"
    ],
    seealso: []
};


var $e2f611a3c9cc6d3c$export$a805f16f075f20cb = {
    name: "null",
    category: "Constants",
    syntax: [
        "null"
    ],
    description: "Value null",
    examples: [
        "null"
    ],
    seealso: [
        "true",
        "false"
    ]
};


var $927f5ada2d843694$export$f4e037238b5533c1 = {
    name: "phi",
    category: "Constants",
    syntax: [
        "phi"
    ],
    description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",
    examples: [
        "phi"
    ],
    seealso: []
};


var $cc23124e471e747e$export$acdd1b7b7d3e5e4e = {
    name: "pi",
    category: "Constants",
    syntax: [
        "pi"
    ],
    description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159",
    examples: [
        "pi",
        "sin(pi/2)"
    ],
    seealso: [
        "tau"
    ]
};


var $ed0d11305883f623$export$6838d33506c2b5d0 = {
    name: "SQRT1_2",
    category: "Constants",
    syntax: [
        "SQRT1_2"
    ],
    description: "Returns the square root of 1/2, approximately equal to 0.707",
    examples: [
        "SQRT1_2",
        "sqrt(1/2)"
    ],
    seealso: []
};


var $acf6bec3752691ae$export$ce0e8257aab3e4ae = {
    name: "SQRT2",
    category: "Constants",
    syntax: [
        "SQRT2"
    ],
    description: "Returns the square root of 2, approximately equal to 1.414",
    examples: [
        "SQRT2",
        "sqrt(2)"
    ],
    seealso: []
};


var $1dd1873b721cc97c$export$aee6f1e4bf7402c8 = {
    name: "tau",
    category: "Constants",
    syntax: [
        "tau"
    ],
    description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.",
    examples: [
        "tau",
        "2 * pi"
    ],
    seealso: [
        "pi"
    ]
};


var $10a80b3e040bd92c$export$f6ccf6a3f013127d = {
    name: "true",
    category: "Constants",
    syntax: [
        "true"
    ],
    description: "Boolean value true",
    examples: [
        "true"
    ],
    seealso: [
        "false"
    ]
};


var $35a55c148b2609a7$export$c94cc7868097f914 = {
    name: "version",
    category: "Constants",
    syntax: [
        "version"
    ],
    description: "A string with the version number of math.js",
    examples: [
        "version"
    ],
    seealso: []
};


var $e77b8720ad558a33$export$e8c3f4e3ad52a4e6 = {
    name: "bignumber",
    category: "Construction",
    syntax: [
        "bignumber(x)"
    ],
    description: "Create a big number from a number or string.",
    examples: [
        "0.1 + 0.2",
        "bignumber(0.1) + bignumber(0.2)",
        'bignumber("7.2")',
        'bignumber("7.2e500")',
        "bignumber([0.1, 0.2, 0.3])"
    ],
    seealso: [
        "boolean",
        "bigint",
        "complex",
        "fraction",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};


var $53b61ab7dc049001$export$857f42eb63034b3f = {
    name: "bigint",
    category: "Construction",
    syntax: [
        "bigint(x)"
    ],
    description: "Create a bigint, an integer with an arbitrary number of digits, from a number or string.",
    examples: [
        "123123123123123123 # a large number will lose digits",
        'bigint("123123123123123123")',
        'bignumber(["1", "3", "5"])'
    ],
    seealso: [
        "boolean",
        "bignumber",
        "number",
        "complex",
        "fraction",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};


var $6566513983122549$export$dbe10b9a90fd671a = {
    name: "boolean",
    category: "Construction",
    syntax: [
        "x",
        "boolean(x)"
    ],
    description: "Convert a string or number into a boolean.",
    examples: [
        "boolean(0)",
        "boolean(1)",
        "boolean(3)",
        'boolean("true")',
        'boolean("false")',
        "boolean([1, 0, 1, 1])"
    ],
    seealso: [
        "bignumber",
        "complex",
        "index",
        "matrix",
        "number",
        "string",
        "unit"
    ]
};


var $5579b3bb90453cde$export$a266a326dd0e84ff = {
    name: "complex",
    category: "Construction",
    syntax: [
        "complex()",
        "complex(re, im)",
        "complex(string)"
    ],
    description: "Create a complex number.",
    examples: [
        "complex()",
        "complex(2, 3)",
        'complex("7 - 2i")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "index",
        "matrix",
        "number",
        "string",
        "unit"
    ]
};


var $6ef065584dea6494$export$e56a121dfffbec82 = {
    name: "createUnit",
    category: "Construction",
    syntax: [
        "createUnit(definitions)",
        "createUnit(name, definition)"
    ],
    description: "Create a user-defined unit and register it with the Unit type.",
    examples: [
        'createUnit("foo")',
        'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})',
        'createUnit("mph", "1 mile/hour")'
    ],
    seealso: [
        "unit",
        "splitUnit"
    ]
};


var $5e186ca0b0be2272$export$46678100e6b87439 = {
    name: "fraction",
    category: "Construction",
    syntax: [
        "fraction(num)",
        "fraction(matrix)",
        "fraction(num,den)",
        "fraction({n: num, d: den})"
    ],
    description: "Create a fraction from a number or from integer numerator and denominator.",
    examples: [
        "fraction(0.125)",
        "fraction(1, 3) + fraction(2, 5)",
        "fraction({n: 333, d: 53})",
        "fraction([sqrt(9), sqrt(10), sqrt(11)])"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};


var $7a81896693161c6c$export$39876fcf61312bba = {
    name: "index",
    category: "Construction",
    syntax: [
        "[start]",
        "[start:end]",
        "[start:step:end]",
        "[start1, start 2, ...]",
        "[start1:end1, start2:end2, ...]",
        "[start1:step1:end1, start2:step2:end2, ...]"
    ],
    description: "Create an index to get or replace a subset of a matrix",
    examples: [
        "A = [1, 2, 3; 4, 5, 6]",
        "A[1, :]",
        "A[1, 2] = 50",
        "A[1:2, 1:2] = 1",
        "B = [1, 2, 3]",
        "B[B>1 and B<3]"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "matrix,",
        "number",
        "range",
        "string",
        "unit"
    ]
};


var $d53c01610458e1b0$export$dc433018b5b5e90f = {
    name: "matrix",
    category: "Construction",
    syntax: [
        "[]",
        "[a1, b1, ...; a2, b2, ...]",
        "matrix()",
        'matrix("dense")',
        "matrix([...])"
    ],
    description: "Create a matrix.",
    examples: [
        "[]",
        "[1, 2, 3]",
        "[1, 2, 3; 4, 5, 6]",
        "matrix()",
        "matrix([3, 4])",
        'matrix([3, 4; 5, 6], "sparse")',
        'matrix([3, 4; 5, 6], "sparse", "number")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "number",
        "string",
        "unit",
        "sparse"
    ]
};


var $32de92aabdb43840$export$3b011c0eed79d7e0 = {
    name: "number",
    category: "Construction",
    syntax: [
        "x",
        "number(x)",
        "number(unit, valuelessUnit)"
    ],
    description: "Create a number or convert a string or boolean into a number.",
    examples: [
        "2",
        "2e3",
        "4.05",
        "number(2)",
        'number("7.2")',
        "number(true)",
        "number([true, false, true, true])",
        'number(unit("52cm"), "m")'
    ],
    seealso: [
        "bignumber",
        "bigint",
        "boolean",
        "complex",
        "fraction",
        "index",
        "matrix",
        "string",
        "unit"
    ]
};


var $02440e85e81f831d$export$b569625c2404133 = {
    name: "sparse",
    category: "Construction",
    syntax: [
        "sparse()",
        "sparse([a1, b1, ...; a1, b2, ...])",
        'sparse([a1, b1, ...; a1, b2, ...], "number")'
    ],
    description: "Create a sparse matrix.",
    examples: [
        "sparse()",
        "sparse([3, 4; 5, 6])",
        'sparse([3, 0; 5, 0], "number")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "number",
        "string",
        "unit",
        "matrix"
    ]
};


var $9f54b754fadc3081$export$f729a0241c48cb52 = {
    name: "splitUnit",
    category: "Construction",
    syntax: [
        "splitUnit(unit: Unit, parts: Unit[])"
    ],
    description: "Split a unit in an array of units whose sum is equal to the original unit.",
    examples: [
        'splitUnit(1 m, ["feet", "inch"])'
    ],
    seealso: [
        "unit",
        "createUnit"
    ]
};


var $975a71e4f1c7ead7$export$783e4a4a90f7bc1d = {
    name: "string",
    category: "Construction",
    syntax: [
        '"text"',
        "string(x)"
    ],
    description: "Create a string or convert a value to a string",
    examples: [
        '"Hello World!"',
        "string(4.2)",
        "string(3 + 2i)"
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "number",
        "unit"
    ]
};


var $69e7fb2c282e30e8$export$478a7368ebd56459 = {
    name: "unit",
    category: "Construction",
    syntax: [
        "value unit",
        "unit(value, unit)",
        "unit(string)"
    ],
    description: "Create a unit.",
    examples: [
        "5.5 mm",
        "3 inch",
        'unit(7.1, "kilogram")',
        'unit("23 deg")'
    ],
    seealso: [
        "bignumber",
        "boolean",
        "complex",
        "index",
        "matrix",
        "number",
        "string"
    ]
};


var $56bac2676b7788d8$export$ec99a334d8c9a14a = {
    name: "config",
    category: "Core",
    syntax: [
        "config()",
        "config(options)"
    ],
    description: "Get configuration or change configuration.",
    examples: [
        "config()",
        "1/3 + 1/4",
        'config({number: "Fraction"})',
        "1/3 + 1/4"
    ],
    seealso: []
};


var $94e3b8f96924ea5b$export$5989ac4b02cf8057 = {
    name: "import",
    category: "Core",
    syntax: [
        "import(functions)",
        "import(functions, options)"
    ],
    description: "Import functions or constants from an object.",
    examples: [
        "import({myFn: f(x)=x^2, myConstant: 32 })",
        "myFn(2)",
        "myConstant"
    ],
    seealso: []
};


var $a630fffa746e3e8a$export$7adf399073101884 = {
    name: "typed",
    category: "Core",
    syntax: [
        "typed(signatures)",
        "typed(name, signatures)"
    ],
    description: "Create a typed function.",
    examples: [
        'double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })',
        "double(2)",
        'double("hello")'
    ],
    seealso: []
};


var $23e896358f88f978$export$14d93412c4f1ed0d = {
    name: "derivative",
    category: "Algebra",
    syntax: [
        "derivative(expr, variable)",
        "derivative(expr, variable, {simplify: boolean})"
    ],
    description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.",
    examples: [
        'derivative("2x^3", "x")',
        'derivative("2x^3", "x", {simplify: false})',
        'derivative("2x^2 + 3x + 4", "x")',
        'derivative("sin(2x)", "x")',
        'f = parse("x^2 + x")',
        'x = parse("x")',
        "df = derivative(f, x)",
        "df.evaluate({x: 3})"
    ],
    seealso: [
        "simplify",
        "parse",
        "evaluate"
    ]
};


var $19e8c7d1f205e88a$export$a44548b5a791ce3a = {
    name: "leafCount",
    category: "Algebra",
    syntax: [
        "leafCount(expr)"
    ],
    description: "Computes the number of leaves in the parse tree of the given expression",
    examples: [
        'leafCount("e^(i*pi)-1")',
        'leafCount(parse("{a: 22/7, b: 10^(1/2)}"))'
    ],
    seealso: [
        "simplify"
    ]
};


var $2583e28540492eb0$export$4bef5c6fa8c1f081 = {
    name: "lsolve",
    category: "Algebra",
    syntax: [
        "x=lsolve(L, b)"
    ],
    description: "Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
    examples: [
        "a = [-2, 3; 2, 1]",
        "b = [11, 9]",
        "x = lsolve(a, b)"
    ],
    seealso: [
        "lsolveAll",
        "lup",
        "lusolve",
        "usolve",
        "matrix",
        "sparse"
    ]
};


var $98da7095cd128878$export$40bf697ca86bce02 = {
    name: "lsolveAll",
    category: "Algebra",
    syntax: [
        "x=lsolveAll(L, b)"
    ],
    description: "Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
    examples: [
        "a = [-2, 3; 2, 1]",
        "b = [11, 9]",
        "x = lsolve(a, b)"
    ],
    seealso: [
        "lsolve",
        "lup",
        "lusolve",
        "usolve",
        "matrix",
        "sparse"
    ]
};


var $9926f970c9d73895$export$aa45954995260db7 = {
    name: "lup",
    category: "Algebra",
    syntax: [
        "lup(m)"
    ],
    description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",
    examples: [
        "lup([[2, 1], [1, 4]])",
        "lup(matrix([[2, 1], [1, 4]]))",
        "lup(sparse([[2, 1], [1, 4]]))"
    ],
    seealso: [
        "lusolve",
        "lsolve",
        "usolve",
        "matrix",
        "sparse",
        "slu",
        "qr"
    ]
};


var $faaeaa061e2182f3$export$b24588d98e782136 = {
    name: "lusolve",
    category: "Algebra",
    syntax: [
        "x=lusolve(A, b)",
        "x=lusolve(lu, b)"
    ],
    description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",
    examples: [
        "a = [-2, 3; 2, 1]",
        "b = [11, 9]",
        "x = lusolve(a, b)"
    ],
    seealso: [
        "lup",
        "slu",
        "lsolve",
        "usolve",
        "matrix",
        "sparse"
    ]
};


var $55993951929a18a2$export$b8b5e00b23dec14b = {
    name: "polynomialRoot",
    category: "Algebra",
    syntax: [
        "x=polynomialRoot(-6, 3)",
        "x=polynomialRoot(4, -4, 1)",
        "x=polynomialRoot(-8, 12, -6, 1)"
    ],
    description: "Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.",
    examples: [
        "a = polynomialRoot(-6, 11, -6, 1)"
    ],
    seealso: [
        "cbrt",
        "sqrt"
    ]
};


var $51397644d11732e4$export$717c61ebe37cce2a = {
    name: "qr",
    category: "Algebra",
    syntax: [
        "qr(A)"
    ],
    description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.",
    examples: [
        "qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"
    ],
    seealso: [
        "lup",
        "slu",
        "matrix"
    ]
};


var $9deb2fac63191f67$export$1802f015e36a313 = {
    name: "rationalize",
    category: "Algebra",
    syntax: [
        "rationalize(expr)",
        "rationalize(expr, scope)",
        "rationalize(expr, scope, detailed)"
    ],
    description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.",
    examples: [
        'rationalize("2x/y - y/(x+1)")',
        'rationalize("2x/y - y/(x+1)", true)'
    ],
    seealso: [
        "simplify"
    ]
};


var $66e1b0c55cea11f2$export$becee114188e4530 = {
    name: "resolve",
    category: "Algebra",
    syntax: [
        "resolve(node, scope)"
    ],
    description: "Recursively substitute variables in an expression tree.",
    examples: [
        'resolve(parse("1 + x"), { x: 7 })',
        'resolve(parse("size(text)"), { text: "Hello World" })',
        'resolve(parse("x + y"), { x: parse("3z") })',
        'resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })'
    ],
    seealso: [
        "simplify",
        "evaluate"
    ],
    mayThrow: [
        "ReferenceError"
    ]
};


var $c95c1299a284c4b5$export$5a53589a8ff0d1cd = {
    name: "simplify",
    category: "Algebra",
    syntax: [
        "simplify(expr)",
        "simplify(expr, rules)"
    ],
    description: "Simplify an expression tree.",
    examples: [
        'simplify("3 + 2 / 4")',
        'simplify("2x + x")',
        'f = parse("x * (x + 2 + x)")',
        "simplified = simplify(f)",
        "simplified.evaluate({x: 2})"
    ],
    seealso: [
        "simplifyCore",
        "derivative",
        "evaluate",
        "parse",
        "rationalize",
        "resolve"
    ]
};


var $1e1659533c0e424b$export$f20b2f36e9c7150 = {
    name: "simplifyConstant",
    category: "Algebra",
    syntax: [
        "simplifyConstant(expr)",
        "simplifyConstant(expr, options)"
    ],
    description: "Replace constant subexpressions of node with their values.",
    examples: [
        'simplifyConstant("(3-3)*x")',
        'simplifyConstant(parse("z-cos(tau/8)"))'
    ],
    seealso: [
        "simplify",
        "simplifyCore",
        "evaluate"
    ]
};


var $81c635434f523012$export$466a93707e1e5969 = {
    name: "simplifyCore",
    category: "Algebra",
    syntax: [
        "simplifyCore(node)"
    ],
    description: "Perform simple one-pass simplifications on an expression tree.",
    examples: [
        'simplifyCore(parse("0*x"))',
        'simplifyCore(parse("(x+0)*2"))'
    ],
    seealso: [
        "simplify",
        "simplifyConstant",
        "evaluate"
    ]
};


var $377e2d7bdcfece4e$export$a68dbefd846d8955 = {
    name: "slu",
    category: "Algebra",
    syntax: [
        "slu(A, order, threshold)"
    ],
    description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",
    examples: [
        "slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"
    ],
    seealso: [
        "lusolve",
        "lsolve",
        "usolve",
        "matrix",
        "sparse",
        "lup",
        "qr"
    ]
};


var $5ce5c54f33e18788$export$1ff0943310cb2f46 = {
    name: "symbolicEqual",
    category: "Algebra",
    syntax: [
        "symbolicEqual(expr1, expr2)",
        "symbolicEqual(expr1, expr2, options)"
    ],
    description: "Returns true if the difference of the expressions simplifies to 0",
    examples: [
        'symbolicEqual("x*y","y*x")',
        'symbolicEqual("abs(x^2)", "x^2")',
        'symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})'
    ],
    seealso: [
        "simplify",
        "evaluate"
    ]
};


var $f5a376e60c81653b$export$2e45391f5cc49d1d = {
    name: "usolve",
    category: "Algebra",
    syntax: [
        "x=usolve(U, b)"
    ],
    description: "Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
    examples: [
        "x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"
    ],
    seealso: [
        "usolveAll",
        "lup",
        "lusolve",
        "lsolve",
        "matrix",
        "sparse"
    ]
};


var $ede90181ca5a11fd$export$64b3b7af0d3d4548 = {
    name: "usolveAll",
    category: "Algebra",
    syntax: [
        "x=usolve(U, b)"
    ],
    description: "Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
    examples: [
        "x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"
    ],
    seealso: [
        "usolve",
        "lup",
        "lusolve",
        "lsolve",
        "matrix",
        "sparse"
    ]
};


var $85a78118ae6a85de$export$d21ec9cf3daa768b = {
    name: "abs",
    category: "Arithmetic",
    syntax: [
        "abs(x)"
    ],
    description: "Compute the absolute value.",
    examples: [
        "abs(3.5)",
        "abs(-4.2)"
    ],
    seealso: [
        "sign"
    ]
};


var $316ab5d94c24e587$export$6fe0cea5d5e6ddba = {
    name: "add",
    category: "Operators",
    syntax: [
        "x + y",
        "add(x, y)"
    ],
    description: "Add two values.",
    examples: [
        "a = 2.1 + 3.6",
        "a - 3.6",
        "3 + 2i",
        "3 cm + 2 inch",
        '"2.3" + "4"'
    ],
    seealso: [
        "subtract"
    ]
};


var $4b2658ab9232bf89$export$9330e90a8e7851e6 = {
    name: "cbrt",
    category: "Arithmetic",
    syntax: [
        "cbrt(x)",
        "cbrt(x, allRoots)"
    ],
    description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",
    examples: [
        "cbrt(64)",
        "cube(4)",
        "cbrt(-8)",
        "cbrt(2 + 3i)",
        "cbrt(8i)",
        "cbrt(8i, true)",
        "cbrt(27 m^3)"
    ],
    seealso: [
        "square",
        "sqrt",
        "cube",
        "multiply"
    ]
};


var $c37db8f09d02b0e2$export$bf625dbce78edf39 = {
    name: "ceil",
    category: "Arithmetic",
    syntax: [
        "ceil(x)"
    ],
    description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",
    examples: [
        "ceil(3.2)",
        "ceil(3.8)",
        "ceil(-4.2)"
    ],
    seealso: [
        "floor",
        "fix",
        "round"
    ]
};


var $949e091259dcb07e$export$ceabaa40b420fd2f = {
    name: "cube",
    category: "Arithmetic",
    syntax: [
        "cube(x)"
    ],
    description: "Compute the cube of a value. The cube of x is x * x * x.",
    examples: [
        "cube(2)",
        "2^3",
        "2 * 2 * 2"
    ],
    seealso: [
        "multiply",
        "square",
        "pow"
    ]
};


var $6de4934ce8a4b9a7$export$e4cc3c6ddad47fb = {
    name: "divide",
    category: "Operators",
    syntax: [
        "x / y",
        "divide(x, y)"
    ],
    description: "Divide two values.",
    examples: [
        "a = 2 / 3",
        "a * 3",
        "4.5 / 2",
        "3 + 4 / 2",
        "(3 + 4) / 2",
        "18 km / 4.5"
    ],
    seealso: [
        "multiply"
    ]
};


var $7836ef51d4f16380$export$f1a6e1f6a311adf8 = {
    name: "dotDivide",
    category: "Operators",
    syntax: [
        "x ./ y",
        "dotDivide(x, y)"
    ],
    description: "Divide two values element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "b = [2, 1, 1; 3, 2, 5]",
        "a ./ b"
    ],
    seealso: [
        "multiply",
        "dotMultiply",
        "divide"
    ]
};


var $ff6cdb59c011e496$export$4e72f4c646ece24a = {
    name: "dotMultiply",
    category: "Operators",
    syntax: [
        "x .* y",
        "dotMultiply(x, y)"
    ],
    description: "Multiply two values element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "b = [2, 1, 1; 3, 2, 5]",
        "a .* b"
    ],
    seealso: [
        "multiply",
        "divide",
        "dotDivide"
    ]
};


var $b637718c84ceae0a$export$db82d026e80f1871 = {
    name: "dotPow",
    category: "Operators",
    syntax: [
        "x .^ y",
        "dotPow(x, y)"
    ],
    description: "Calculates the power of x to y element wise.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a .^ 2"
    ],
    seealso: [
        "pow"
    ]
};


var $0a57934b07922479$export$e855e42434736fab = {
    name: "exp",
    category: "Arithmetic",
    syntax: [
        "exp(x)"
    ],
    description: "Calculate the exponent of a value.",
    examples: [
        "exp(1.3)",
        "e ^ 1.3",
        "log(exp(1.3))",
        "x = 2.4",
        "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"
    ],
    seealso: [
        "expm",
        "expm1",
        "pow",
        "log"
    ]
};


var $f85961c75ad73b75$export$df3b4f2159ca23f5 = {
    name: "expm",
    category: "Arithmetic",
    syntax: [
        "exp(x)"
    ],
    description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.",
    examples: [
        "expm([[0,2],[0,0]])"
    ],
    seealso: [
        "exp"
    ]
};


var $3d687d930784404a$export$d6fb67f466ac866c = {
    name: "expm1",
    category: "Arithmetic",
    syntax: [
        "expm1(x)"
    ],
    description: "Calculate the value of subtracting 1 from the exponential value.",
    examples: [
        "expm1(2)",
        "pow(e, 2) - 1",
        "log(expm1(2) + 1)"
    ],
    seealso: [
        "exp",
        "pow",
        "log"
    ]
};


var $2b78a6408c7e00c3$export$ec1a27fd93212099 = {
    name: "fix",
    category: "Arithmetic",
    syntax: [
        "fix(x)"
    ],
    description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",
    examples: [
        "fix(3.2)",
        "fix(3.8)",
        "fix(-4.2)",
        "fix(-4.8)"
    ],
    seealso: [
        "ceil",
        "floor",
        "round"
    ]
};


var $0c83b745632c4029$export$7eb1ac5a6cfbe8b6 = {
    name: "floor",
    category: "Arithmetic",
    syntax: [
        "floor(x)"
    ],
    description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",
    examples: [
        "floor(3.2)",
        "floor(3.8)",
        "floor(-4.2)"
    ],
    seealso: [
        "ceil",
        "fix",
        "round"
    ]
};


var $059ac54e3b4cda17$export$ccc9190f6201c21e = {
    name: "gcd",
    category: "Arithmetic",
    syntax: [
        "gcd(a, b)",
        "gcd(a, b, c, ...)"
    ],
    description: "Compute the greatest common divisor.",
    examples: [
        "gcd(8, 12)",
        "gcd(-4, 6)",
        "gcd(25, 15, -10)"
    ],
    seealso: [
        "lcm",
        "xgcd"
    ]
};


var $06f5c3955a0e0fe7$export$53821d38c3eeff69 = {
    name: "hypot",
    category: "Arithmetic",
    syntax: [
        "hypot(a, b, c, ...)",
        "hypot([a, b, c, ...])"
    ],
    description: "Calculate the hypotenusa of a list with values. ",
    examples: [
        "hypot(3, 4)",
        "sqrt(3^2 + 4^2)",
        "hypot(-2)",
        "hypot([3, 4, 5])"
    ],
    seealso: [
        "abs",
        "norm"
    ]
};


var $b6efbef5866280f2$export$7d988771513789e5 = {
    name: "invmod",
    category: "Arithmetic",
    syntax: [
        "invmod(a, b)"
    ],
    description: "Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax \u2263 1 (mod b)",
    examples: [
        "invmod(8, 12)",
        "invmod(7, 13)",
        "invmod(15151, 15122)"
    ],
    seealso: [
        "gcd",
        "xgcd"
    ]
};


var $62c28fc5a8868094$export$371d4953326569cb = {
    name: "lcm",
    category: "Arithmetic",
    syntax: [
        "lcm(x, y)"
    ],
    description: "Compute the least common multiple.",
    examples: [
        "lcm(4, 6)",
        "lcm(6, 21)",
        "lcm(6, 21, 5)"
    ],
    seealso: [
        "gcd"
    ]
};


var $de5277fd82d6bd47$export$10fa3fadd260900f = {
    name: "log",
    category: "Arithmetic",
    syntax: [
        "log(x)",
        "log(x, base)"
    ],
    description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",
    examples: [
        "log(3.5)",
        "a = log(2.4)",
        "exp(a)",
        "10 ^ 4",
        "log(10000, 10)",
        "log(10000) / log(10)",
        "b = log(1024, 2)",
        "2 ^ b"
    ],
    seealso: [
        "exp",
        "log1p",
        "log2",
        "log10"
    ]
};


var $b68c5643d6bffeb5$export$a4c310b6d4346035 = {
    name: "log10",
    category: "Arithmetic",
    syntax: [
        "log10(x)"
    ],
    description: "Compute the 10-base logarithm of a value.",
    examples: [
        "log10(0.00001)",
        "log10(10000)",
        "10 ^ 4",
        "log(10000) / log(10)",
        "log(10000, 10)"
    ],
    seealso: [
        "exp",
        "log"
    ]
};


var $b2b92f458abcf0e0$export$5739f5d11cd187ac = {
    name: "log1p",
    category: "Arithmetic",
    syntax: [
        "log1p(x)",
        "log1p(x, base)"
    ],
    description: "Calculate the logarithm of a `value+1`",
    examples: [
        "log1p(2.5)",
        "exp(log1p(1.4))",
        "pow(10, 4)",
        "log1p(9999, 10)",
        "log1p(9999) / log(10)"
    ],
    seealso: [
        "exp",
        "log",
        "log2",
        "log10"
    ]
};


var $9c038207fcf4bd49$export$fa36f06e6e8bfb36 = {
    name: "log2",
    category: "Arithmetic",
    syntax: [
        "log2(x)"
    ],
    description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.",
    examples: [
        "log2(0.03125)",
        "log2(16)",
        "log2(16) / log2(2)",
        "pow(2, 4)"
    ],
    seealso: [
        "exp",
        "log1p",
        "log",
        "log10"
    ]
};


var $ca1eca2f5b0ec20c$export$f9c7d95d1ec52e50 = {
    name: "mod",
    category: "Operators",
    syntax: [
        "x % y",
        "x mod y",
        "mod(x, y)"
    ],
    description: "Calculates the modulus, the remainder of an integer division.",
    examples: [
        "7 % 3",
        "11 % 2",
        "10 mod 4",
        "isOdd(x) = x % 2",
        "isOdd(2)",
        "isOdd(3)"
    ],
    seealso: [
        "divide"
    ]
};


var $c68e21fdab9e122f$export$1506e47b2a5ae6da = {
    name: "multiply",
    category: "Operators",
    syntax: [
        "x * y",
        "multiply(x, y)"
    ],
    description: "multiply two values.",
    examples: [
        "a = 2.1 * 3.4",
        "a / 3.4",
        "2 * 3 + 4",
        "2 * (3 + 4)",
        "3 * 2.1 km"
    ],
    seealso: [
        "divide"
    ]
};


var $11ed400156458240$export$9745ccea7c23999 = {
    name: "norm",
    category: "Arithmetic",
    syntax: [
        "norm(x)",
        "norm(x, p)"
    ],
    description: "Calculate the norm of a number, vector or matrix.",
    examples: [
        "abs(-3.5)",
        "norm(-3.5)",
        "norm(3 - 4i)",
        "norm([1, 2, -3], Infinity)",
        "norm([1, 2, -3], -Infinity)",
        "norm([3, 4], 2)",
        "norm([[1, 2], [3, 4]], 1)",
        'norm([[1, 2], [3, 4]], "inf")',
        'norm([[1, 2], [3, 4]], "fro")'
    ]
};


var $857a0b7dfb5d0d6a$export$6eeb5046d44da601 = {
    name: "nthRoot",
    category: "Arithmetic",
    syntax: [
        "nthRoot(a)",
        "nthRoot(a, root)"
    ],
    description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".',
    examples: [
        "4 ^ 3",
        "nthRoot(64, 3)",
        "nthRoot(9, 2)",
        "sqrt(9)"
    ],
    seealso: [
        "nthRoots",
        "pow",
        "sqrt"
    ]
};


var $83d1c4cde44b9a1a$export$3d5c8967f6152f8f = {
    name: "nthRoots",
    category: "Arithmetic",
    syntax: [
        "nthRoots(A)",
        "nthRoots(A, root)"
    ],
    description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.',
    examples: [
        "nthRoots(1)",
        "nthRoots(1, 3)"
    ],
    seealso: [
        "sqrt",
        "pow",
        "nthRoot"
    ]
};


var $9a53b5f9de0ae95b$export$2d9619da64c2bdd4 = {
    name: "pow",
    category: "Operators",
    syntax: [
        "x ^ y",
        "pow(x, y)"
    ],
    description: "Calculates the power of x to y, x^y.",
    examples: [
        "2^3",
        "2*2*2",
        "1 + e ^ (pi * i)",
        "pow([[1, 2], [4, 3]], 2)",
        "pow([[1, 2], [4, 3]], -1)"
    ],
    seealso: [
        "multiply",
        "nthRoot",
        "nthRoots",
        "sqrt"
    ]
};


var $4b5c242cc9907040$export$aaef6018d3e651c3 = {
    name: "round",
    category: "Arithmetic",
    syntax: [
        "round(x)",
        "round(x, n)",
        "round(unit, valuelessUnit)",
        "round(unit, n, valuelessUnit)"
    ],
    description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",
    examples: [
        "round(3.2)",
        "round(3.8)",
        "round(-4.2)",
        "round(-4.8)",
        "round(pi, 3)",
        "round(123.45678, 2)",
        "round(3.241cm, 2, cm)",
        "round([3.2, 3.8, -4.7])"
    ],
    seealso: [
        "ceil",
        "floor",
        "fix"
    ]
};


var $82d8e4a5a66a8207$export$4190acef139a44f2 = {
    name: "sign",
    category: "Arithmetic",
    syntax: [
        "sign(x)"
    ],
    description: "Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.",
    examples: [
        "sign(3.5)",
        "sign(-4.2)",
        "sign(0)"
    ],
    seealso: [
        "abs"
    ]
};


var $d93be67d81914ab4$export$4c6bee88dcda7f24 = {
    name: "sqrt",
    category: "Arithmetic",
    syntax: [
        "sqrt(x)"
    ],
    description: "Compute the square root value. If x = y * y, then y is the square root of x.",
    examples: [
        "sqrt(25)",
        "5 * 5",
        "sqrt(-1)"
    ],
    seealso: [
        "square",
        "sqrtm",
        "multiply",
        "nthRoot",
        "nthRoots",
        "pow"
    ]
};


var $8cd74a92de6808cf$export$f470c8ca9def7f14 = {
    name: "sqrtm",
    category: "Arithmetic",
    syntax: [
        "sqrtm(x)"
    ],
    description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.",
    examples: [
        "sqrtm([[33, 24], [48, 57]])"
    ],
    seealso: [
        "sqrt",
        "abs",
        "square",
        "multiply"
    ]
};


var $e10e74b260eaf413$export$e19046f098fe7be7 = {
    name: "sylvester",
    category: "Algebra",
    syntax: [
        "sylvester(A,B,C)"
    ],
    description: "Solves the real-valued Sylvester equation AX+XB=C for X",
    examples: [
        "sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])",
        "A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]",
        "sylvester(A, B, C)"
    ],
    seealso: [
        "schur",
        "lyap"
    ]
};


var $dcf90e0087c1a6fd$export$2037e513e50c005d = {
    name: "schur",
    category: "Algebra",
    syntax: [
        "schur(A)"
    ],
    description: "Performs a real Schur decomposition of the real matrix A = UTU'",
    examples: [
        "schur([[1, 0], [-4, 3]])",
        "A = [[1, 0], [-4, 3]]",
        "schur(A)"
    ],
    seealso: [
        "lyap",
        "sylvester"
    ]
};


var $d9e47ce70b1b3bd1$export$1203cb978ac2acd7 = {
    name: "lyap",
    category: "Algebra",
    syntax: [
        "lyap(A,Q)"
    ],
    description: "Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P",
    examples: [
        "lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])",
        "A = [[-2, 0], [1, -4]]",
        "Q = [[3, 1], [1, 3]]",
        "lyap(A,Q)"
    ],
    seealso: [
        "schur",
        "sylvester"
    ]
};


var $6a7462dd0528c104$export$8aa8fe580e40693e = {
    name: "square",
    category: "Arithmetic",
    syntax: [
        "square(x)"
    ],
    description: "Compute the square of a value. The square of x is x * x.",
    examples: [
        "square(3)",
        "sqrt(9)",
        "3^2",
        "3 * 3"
    ],
    seealso: [
        "multiply",
        "pow",
        "sqrt",
        "cube"
    ]
};


var $77eda33d2eff4c1d$export$435374265ca1b923 = {
    name: "subtract",
    category: "Operators",
    syntax: [
        "x - y",
        "subtract(x, y)"
    ],
    description: "subtract two values.",
    examples: [
        "a = 5.3 - 2",
        "a + 2",
        "2/3 - 1/6",
        "2 * 3 - 3",
        "2.1 km - 500m"
    ],
    seealso: [
        "add"
    ]
};


var $43480989308a6fe2$export$4d94f3f25dc2600b = {
    name: "unaryMinus",
    category: "Operators",
    syntax: [
        "-x",
        "unaryMinus(x)"
    ],
    description: "Inverse the sign of a value. Converts booleans and strings to numbers.",
    examples: [
        "-4.5",
        "-(-5.6)",
        '-"22"'
    ],
    seealso: [
        "add",
        "subtract",
        "unaryPlus"
    ]
};


var $06c2b184dde4f14b$export$e50639526da1c8e2 = {
    name: "unaryPlus",
    category: "Operators",
    syntax: [
        "+x",
        "unaryPlus(x)"
    ],
    description: "Converts booleans and strings to numbers.",
    examples: [
        "+true",
        '+"2"'
    ],
    seealso: [
        "add",
        "subtract",
        "unaryMinus"
    ]
};


var $bd6d75152d02eb73$export$82911c1a1d0407b8 = {
    name: "xgcd",
    category: "Arithmetic",
    syntax: [
        "xgcd(a, b)"
    ],
    description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.",
    examples: [
        "xgcd(8, 12)",
        "gcd(8, 12)",
        "xgcd(36163, 21199)"
    ],
    seealso: [
        "gcd",
        "lcm"
    ]
};


var $cf0662a7312f667d$export$9809e2502d5f7c7c = {
    name: "bitAnd",
    category: "Bitwise",
    syntax: [
        "x & y",
        "bitAnd(x, y)"
    ],
    description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",
    examples: [
        "5 & 3",
        "bitAnd(53, 131)",
        "[1, 12, 31] & 42"
    ],
    seealso: [
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};


var $16dbd79d3d31a6ac$export$3d49fbbfcb05eb36 = {
    name: "bitNot",
    category: "Bitwise",
    syntax: [
        "~x",
        "bitNot(x)"
    ],
    description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",
    examples: [
        "~1",
        "~2",
        "bitNot([2, -3, 4])"
    ],
    seealso: [
        "bitAnd",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};


var $7dcdac613b60685d$export$dc934370739527a8 = {
    name: "bitOr",
    category: "Bitwise",
    syntax: [
        "x | y",
        "bitOr(x, y)"
    ],
    description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",
    examples: [
        "5 | 3",
        "bitOr([1, 2, 3], 4)"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitXor",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};


var $b5e4fb1c3f708c23$export$c5717818ea6d1c80 = {
    name: "bitXor",
    category: "Bitwise",
    syntax: [
        "bitXor(x, y)"
    ],
    description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",
    examples: [
        "bitOr(1, 2)",
        "bitXor([2, 3, 4], 4)"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "leftShift",
        "rightArithShift",
        "rightLogShift"
    ]
};


var $57db96cd19388383$export$fb75ebd54811e095 = {
    name: "leftShift",
    category: "Bitwise",
    syntax: [
        "x << y",
        "leftShift(x, y)"
    ],
    description: "Bitwise left logical shift of a value x by y number of bits.",
    examples: [
        "4 << 1",
        "8 >> 1"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "rightArithShift",
        "rightLogShift"
    ]
};


var $0a5aff9c5a222e02$export$180767993e37a793 = {
    name: "rightArithShift",
    category: "Bitwise",
    syntax: [
        "x >> y",
        "rightArithShift(x, y)"
    ],
    description: "Bitwise right arithmetic shift of a value x by y number of bits.",
    examples: [
        "8 >> 1",
        "4 << 1",
        "-12 >> 2"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightLogShift"
    ]
};


var $9f41930afb5a7a48$export$613695fe01bcb038 = {
    name: "rightLogShift",
    category: "Bitwise",
    syntax: [
        "x >>> y",
        "rightLogShift(x, y)"
    ],
    description: "Bitwise right logical shift of a value x by y number of bits.",
    examples: [
        "8 >>> 1",
        "4 << 1",
        "-12 >>> 2"
    ],
    seealso: [
        "bitAnd",
        "bitNot",
        "bitOr",
        "bitXor",
        "leftShift",
        "rightArithShift"
    ]
};


var $e2e0da5840b89ce2$export$f6a5bb92e66e375e = {
    name: "bellNumbers",
    category: "Combinatorics",
    syntax: [
        "bellNumbers(n)"
    ],
    description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",
    examples: [
        "bellNumbers(3)",
        "bellNumbers(8)"
    ],
    seealso: [
        "stirlingS2"
    ]
};


var $2ace6e16b46f54cf$export$b34ea8a080f60e3b = {
    name: "catalan",
    category: "Combinatorics",
    syntax: [
        "catalan(n)"
    ],
    description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",
    examples: [
        "catalan(3)",
        "catalan(8)"
    ],
    seealso: [
        "bellNumbers"
    ]
};


var $77209587dfe71b21$export$7898728062a0cb7c = {
    name: "composition",
    category: "Combinatorics",
    syntax: [
        "composition(n, k)"
    ],
    description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",
    examples: [
        "composition(5, 3)"
    ],
    seealso: [
        "combinations"
    ]
};


var $66f555436450f091$export$46c34bdf03072170 = {
    name: "stirlingS2",
    category: "Combinatorics",
    syntax: [
        "stirlingS2(n, k)"
    ],
    description: "he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",
    examples: [
        "stirlingS2(5, 3)"
    ],
    seealso: [
        "bellNumbers"
    ]
};


var $48548ed49c7a69c2$export$eace15c6c3c286dc = {
    name: "arg",
    category: "Complex",
    syntax: [
        "arg(x)"
    ],
    description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",
    examples: [
        "arg(2 + 2i)",
        "atan2(3, 2)",
        "arg(2 + 3i)"
    ],
    seealso: [
        "re",
        "im",
        "conj",
        "abs"
    ]
};


var $46a9b9f0b63724c5$export$e042ae5cfa3c3343 = {
    name: "conj",
    category: "Complex",
    syntax: [
        "conj(x)"
    ],
    description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",
    examples: [
        "conj(2 + 3i)",
        "conj(2 - 3i)",
        "conj(-5.2i)"
    ],
    seealso: [
        "re",
        "im",
        "abs",
        "arg"
    ]
};


var $4f2004d4396885cf$export$3476e22b3f658c7c = {
    name: "im",
    category: "Complex",
    syntax: [
        "im(x)"
    ],
    description: "Get the imaginary part of a complex number.",
    examples: [
        "im(2 + 3i)",
        "re(2 + 3i)",
        "im(-5.2i)",
        "im(2.4)"
    ],
    seealso: [
        "re",
        "conj",
        "abs",
        "arg"
    ]
};


var $d35bc534caf5648f$export$f13699bc77b8ea67 = {
    name: "re",
    category: "Complex",
    syntax: [
        "re(x)"
    ],
    description: "Get the real part of a complex number.",
    examples: [
        "re(2 + 3i)",
        "im(2 + 3i)",
        "re(-5.2i)",
        "re(2.4)"
    ],
    seealso: [
        "im",
        "conj",
        "abs",
        "arg"
    ]
};


var $694314b5c6c3bfbe$export$f32c54c70ddd9931 = {
    name: "evaluate",
    category: "Expression",
    syntax: [
        "evaluate(expression)",
        "evaluate(expression, scope)",
        "evaluate([expr1, expr2, expr3, ...])",
        "evaluate([expr1, expr2, expr3, ...], scope)"
    ],
    description: "Evaluate an expression or an array with expressions.",
    examples: [
        'evaluate("2 + 3")',
        'evaluate("sqrt(16)")',
        'evaluate("2 inch to cm")',
        'evaluate("sin(x * pi)", { "x": 1/2 })',
        'evaluate(["width=2", "height=4","width*height"])'
    ],
    seealso: []
};


var $21d992ee5fb04230$export$e55ca8c24fbd3be8 = {
    name: "help",
    category: "Expression",
    syntax: [
        "help(object)",
        "help(string)"
    ],
    description: "Display documentation on a function or data type.",
    examples: [
        "help(sqrt)",
        'help("complex")'
    ],
    seealso: []
};


var $716f334535c66be1$export$128b8878fdfb9e22 = {
    name: "distance",
    category: "Geometry",
    syntax: [
        "distance([x1, y1], [x2, y2])",
        "distance([[x1, y1], [x2, y2]])"
    ],
    description: "Calculates the Euclidean distance between two points.",
    examples: [
        "distance([0,0], [4,4])",
        "distance([[0,0], [4,4]])"
    ],
    seealso: []
};


var $b33a4ddcae4ef84d$export$cf98256b70808117 = {
    name: "intersect",
    category: "Geometry",
    syntax: [
        "intersect(expr1, expr2, expr3, expr4)",
        "intersect(expr1, expr2, expr3)"
    ],
    description: "Computes the intersection point of lines and/or planes.",
    examples: [
        "intersect([0, 0], [10, 10], [10, 0], [0, 10])",
        "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"
    ],
    seealso: []
};


var $3de479d340a161c0$export$20737fc9b0a3839c = {
    name: "and",
    category: "Logical",
    syntax: [
        "x and y",
        "and(x, y)"
    ],
    description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.",
    examples: [
        "true and false",
        "true and true",
        "2 and 4"
    ],
    seealso: [
        "not",
        "or",
        "xor"
    ]
};


var $4a82e49ca91fea3a$export$dfd4aa05f81041ff = {
    name: "not",
    category: "Logical",
    syntax: [
        "not x",
        "not(x)"
    ],
    description: "Logical not. Flips the boolean value of given argument.",
    examples: [
        "not true",
        "not false",
        "not 2",
        "not 0"
    ],
    seealso: [
        "and",
        "or",
        "xor"
    ]
};


var $592708e372ce31e9$export$2200bcb1a08f6f8d = {
    name: "or",
    category: "Logical",
    syntax: [
        "x or y",
        "or(x, y)"
    ],
    description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.",
    examples: [
        "true or false",
        "false or false",
        "0 or 4"
    ],
    seealso: [
        "not",
        "and",
        "xor"
    ]
};


var $ab516528ed44ce68$export$dd9d665b8b14e2b2 = {
    name: "xor",
    category: "Logical",
    syntax: [
        "x xor y",
        "xor(x, y)"
    ],
    description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",
    examples: [
        "true xor false",
        "false xor false",
        "true xor true",
        "0 xor 4"
    ],
    seealso: [
        "not",
        "and",
        "or"
    ]
};


var $365393f6e912a48c$export$a5760461eff76999 = {
    name: "column",
    category: "Matrix",
    syntax: [
        "column(x, index)"
    ],
    description: "Return a column from a matrix or array.",
    examples: [
        "A = [[1, 2], [3, 4]]",
        "column(A, 1)",
        "column(A, 2)"
    ],
    seealso: [
        "row",
        "matrixFromColumns"
    ]
};


var $9b398a59b0145bf8$export$2651d46c991329eb = {
    name: "concat",
    category: "Matrix",
    syntax: [
        "concat(A, B, C, ...)",
        "concat(A, B, C, ..., dim)"
    ],
    description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",
    examples: [
        "A = [1, 2; 5, 6]",
        "B = [3, 4; 7, 8]",
        "concat(A, B)",
        "concat(A, B, 1)",
        "concat(A, B, 2)"
    ],
    seealso: [
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $3944837c2e53cfa6$export$f5ba6930b6adafd1 = {
    name: "count",
    category: "Matrix",
    syntax: [
        "count(x)"
    ],
    description: "Count the number of elements of a matrix, array or string.",
    examples: [
        "a = [1, 2; 3, 4; 5, 6]",
        "count(a)",
        "size(a)",
        'count("hello world")'
    ],
    seealso: [
        "size"
    ]
};


var $312527754cbb4fc4$export$daf3380fde4ae39d = {
    name: "cross",
    category: "Matrix",
    syntax: [
        "cross(A, B)"
    ],
    description: "Calculate the cross product for two vectors in three dimensional space.",
    examples: [
        "cross([1, 1, 0],  [0, 1, 1])",
        "cross([3, -3, 1], [4, 9, 2])",
        "cross([2, 3, 4],  [5, 6, 7])"
    ],
    seealso: [
        "multiply",
        "dot"
    ]
};


var $8a8664eb6f21f204$export$f9de74ff268bebd9 = {
    name: "ctranspose",
    category: "Matrix",
    syntax: [
        "x'",
        "ctranspose(x)"
    ],
    description: "Complex Conjugate and Transpose a matrix",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a'",
        "ctranspose(a)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "zeros"
    ]
};


var $82278869afa798b5$export$8730784260ee72c2 = {
    name: "det",
    category: "Matrix",
    syntax: [
        "det(x)"
    ],
    description: "Calculate the determinant of a matrix",
    examples: [
        "det([1, 2; 3, 4])",
        "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"
    ],
    seealso: [
        "concat",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $d66f974d39798bc8$export$1c196182ad1e1777 = {
    name: "diag",
    category: "Matrix",
    syntax: [
        "diag(x)",
        "diag(x, k)"
    ],
    description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",
    examples: [
        "diag(1:3)",
        "diag(1:3, 1)",
        "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]",
        "diag(a)"
    ],
    seealso: [
        "concat",
        "det",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $cbe9cb1b05092676$export$68cc1a794c4b923 = {
    name: "diff",
    category: "Matrix",
    syntax: [
        "diff(arr)",
        "diff(arr, dim)"
    ],
    description: [
        "Create a new matrix or array with the difference of the passed matrix or array.",
        "Dim parameter is optional and used to indicant the dimension of the array/matrix to apply the difference",
        "If no dimension parameter is passed it is assumed as dimension 0",
        "Dimension is zero-based in javascript and one-based in the parser",
        "Arrays must be 'rectangular' meaning arrays like [1, 2]",
        "If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays"
    ],
    examples: [
        "A = [1, 2, 4, 7, 0]",
        "diff(A)",
        "diff(A, 1)",
        "B = [[1, 2], [3, 4]]",
        "diff(B)",
        "diff(B, 1)",
        "diff(B, 2)",
        "diff(B, bignumber(2))",
        "diff([[1, 2], matrix([3, 4])], 2)"
    ],
    seealso: [
        "subtract",
        "partitionSelect"
    ]
};


var $fb1ea007d7bce4d6$export$5fcedf26656436a1 = {
    name: "dot",
    category: "Matrix",
    syntax: [
        "dot(A, B)",
        "A * B"
    ],
    description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",
    examples: [
        "dot([2, 4, 1], [2, 2, 3])",
        "[2, 4, 1] * [2, 2, 3]"
    ],
    seealso: [
        "multiply",
        "cross"
    ]
};


var $f9d306cb265582a0$export$fb74125542bfdbb = {
    name: "eigs",
    category: "Matrix",
    syntax: [
        "eigs(x)"
    ],
    description: "Calculate the eigenvalues and optionally eigenvectors of a square matrix",
    examples: [
        "eigs([[5, 2.3], [2.3, 1]])",
        "eigs([[1, 2, 3], [4, 5, 6], [7, 8, 9]], { precision: 1e-6, eigenvectors: false })"
    ],
    seealso: [
        "inv"
    ]
};


var $2ebf5eeb79f5c139$export$86d791908cc7fd0c = {
    name: "filter",
    category: "Matrix",
    syntax: [
        "filter(x, test)"
    ],
    description: "Filter items in a matrix.",
    examples: [
        "isPositive(x) = x > 0",
        "filter([6, -2, -1, 4, 3], isPositive)",
        "filter([6, -2, 0, 1, 0], x != 0)"
    ],
    seealso: [
        "sort",
        "map",
        "forEach"
    ]
};


var $5f829c0ed9563c81$export$501e32649028a485 = {
    name: "flatten",
    category: "Matrix",
    syntax: [
        "flatten(x)"
    ],
    description: "Flatten a multi dimensional matrix into a single dimensional matrix.",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "size(a)",
        "b = flatten(a)",
        "size(b)"
    ],
    seealso: [
        "concat",
        "resize",
        "size",
        "squeeze"
    ]
};


var $f68dbd4e605e2814$export$aa1ea88ef762ab5e = {
    name: "forEach",
    category: "Matrix",
    syntax: [
        "forEach(x, callback)"
    ],
    description: "Iterates over all elements of a matrix/array, and executes the given callback function.",
    examples: [
        "numberOfPets = {}",
        "addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;",
        'forEach(["Dog","Cat","Cat"], addPet)',
        "numberOfPets"
    ],
    seealso: [
        "map",
        "sort",
        "filter"
    ]
};


var $04f0159fb6d0f511$export$bd8d81afc6159d78 = {
    name: "getMatrixDataType",
    category: "Matrix",
    syntax: [
        "getMatrixDataType(x)"
    ],
    description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".',
    examples: [
        "getMatrixDataType([1, 2, 3])",
        "getMatrixDataType([[5 cm], [2 inch]])",
        'getMatrixDataType([1, "text"])',
        "getMatrixDataType([1, bignumber(4)])"
    ],
    seealso: [
        "matrix",
        "sparse",
        "typeOf"
    ]
};


var $c7e032fa7c752cd0$export$7fb92bf552f6842 = {
    name: "identity",
    category: "Matrix",
    syntax: [
        "identity(n)",
        "identity(m, n)",
        "identity([m, n])"
    ],
    description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",
    examples: [
        "identity(3)",
        "identity(3, 5)",
        "a = [1, 2, 3; 4, 5, 6]",
        "identity(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $0141498a26e9f6ad$export$d584490ba37af473 = {
    name: "inv",
    category: "Matrix",
    syntax: [
        "inv(x)"
    ],
    description: "Calculate the inverse of a matrix",
    examples: [
        "inv([1, 2; 3, 4])",
        "inv(4)",
        "1 / 4"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $16931b16b31f1f93$export$11c117636228617d = {
    name: "pinv",
    category: "Matrix",
    syntax: [
        "pinv(x)"
    ],
    description: "Calculate the Moore\u2013Penrose inverse of a matrix",
    examples: [
        "pinv([1, 2; 3, 4])",
        "pinv([[1, 0], [0, 1], [0, 1]])",
        "pinv(4)"
    ],
    seealso: [
        "inv"
    ]
};


var $92e30bc0d2e07640$export$483111e0489c2571 = {
    name: "kron",
    category: "Matrix",
    syntax: [
        "kron(x, y)"
    ],
    description: "Calculates the kronecker product of 2 matrices or vectors.",
    examples: [
        "kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])",
        "kron([1,1], [2,3,4])"
    ],
    seealso: [
        "multiply",
        "dot",
        "cross"
    ]
};


var $d735bfc60df20a83$export$212579151a971c0d = {
    name: "map",
    category: "Matrix",
    syntax: [
        "map(x, callback)"
    ],
    description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.",
    examples: [
        "map([1, 2, 3], square)"
    ],
    seealso: [
        "filter",
        "forEach"
    ]
};


var $b0b181f55c733183$export$b34e4bfbf268d446 = {
    name: "matrixFromColumns",
    category: "Matrix",
    syntax: [
        "matrixFromColumns(...arr)",
        "matrixFromColumns(row1, row2)",
        "matrixFromColumns(row1, row2, row3)"
    ],
    description: "Create a dense matrix from vectors as individual columns.",
    examples: [
        "matrixFromColumns([1, 2, 3], [[4],[5],[6]])"
    ],
    seealso: [
        "matrix",
        "matrixFromRows",
        "matrixFromFunction",
        "zeros"
    ]
};


var $8e06bd5ed4362a93$export$979fb7b58dfbecb3 = {
    name: "matrixFromFunction",
    category: "Matrix",
    syntax: [
        "matrixFromFunction(size, fn)",
        "matrixFromFunction(size, fn, format)",
        "matrixFromFunction(size, fn, format, datatype)",
        "matrixFromFunction(size, format, fn)",
        "matrixFromFunction(size, format, datatype, fn)"
    ],
    description: "Create a matrix by evaluating a generating function at each index.",
    examples: [
        "f(I) = I[1] - I[2]",
        "matrixFromFunction([3,3], f)",
        "g(I) = I[1] - I[2] == 1 ? 4 : 0",
        'matrixFromFunction([100, 100], "sparse", g)',
        "matrixFromFunction([5], random)"
    ],
    seealso: [
        "matrix",
        "matrixFromRows",
        "matrixFromColumns",
        "zeros"
    ]
};


var $9eaee797a18c1771$export$99216cc634505607 = {
    name: "matrixFromRows",
    category: "Matrix",
    syntax: [
        "matrixFromRows(...arr)",
        "matrixFromRows(row1, row2)",
        "matrixFromRows(row1, row2, row3)"
    ],
    description: "Create a dense matrix from vectors as individual rows.",
    examples: [
        "matrixFromRows([1, 2, 3], [[4],[5],[6]])"
    ],
    seealso: [
        "matrix",
        "matrixFromColumns",
        "matrixFromFunction",
        "zeros"
    ]
};


var $82256620d5fcf8da$export$910fc795c37fb1b2 = {
    name: "ones",
    category: "Matrix",
    syntax: [
        "ones(m)",
        "ones(m, n)",
        "ones(m, n, p, ...)",
        "ones([m])",
        "ones([m, n])",
        "ones([m, n, p, ...])"
    ],
    description: "Create a matrix containing ones.",
    examples: [
        "ones(3)",
        "ones(3, 5)",
        "ones([2,3]) * 4.5",
        "a = [1, 2, 3; 4, 5, 6]",
        "ones(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $28e409388c9eb229$export$65c28ab37b5158f2 = {
    name: "partitionSelect",
    category: "Matrix",
    syntax: [
        "partitionSelect(x, k)",
        "partitionSelect(x, k, compare)"
    ],
    description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",
    examples: [
        "partitionSelect([5, 10, 1], 2)",
        'partitionSelect(["C", "B", "A", "D"], 1, compareText)',
        "arr = [5, 2, 1]",
        "partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]",
        "arr",
        "partitionSelect(arr, 1, 'desc') # returns 2, arr is now: [5, 2, 1]",
        "arr"
    ],
    seealso: [
        "sort"
    ]
};


var $6cc28bb2b382ffdb$export$f7c7d2df7253c271 = {
    name: "range",
    category: "Type",
    syntax: [
        "start:end",
        "start:step:end",
        "range(start, end)",
        "range(start, end, step)",
        "range(string)"
    ],
    description: "Create a range. Lower bound of the range is included, upper bound is excluded.",
    examples: [
        "1:5",
        "3:-1:-3",
        "range(3, 7)",
        "range(0, 12, 2)",
        'range("4:10")',
        "range(1m, 1m, 3m)",
        "a = [1, 2, 3, 4; 5, 6, 7, 8]",
        "a[1:2, 1:2]"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $2c2fa85a96e47dc8$export$f57c799cb449edab = {
    name: "reshape",
    category: "Matrix",
    syntax: [
        "reshape(x, sizes)"
    ],
    description: "Reshape a multi dimensional array to fit the specified dimensions.",
    examples: [
        "reshape([1, 2, 3, 4, 5, 6], [2, 3])",
        "reshape([[1, 2], [3, 4]], [1, 4])",
        "reshape([[1, 2], [3, 4]], [4])",
        "reshape([1, 2, 3, 4], [-1, 2])"
    ],
    seealso: [
        "size",
        "squeeze",
        "resize"
    ]
};


var $49d2ec512fc8129b$export$9444f970d5d871cc = {
    name: "resize",
    category: "Matrix",
    syntax: [
        "resize(x, size)",
        "resize(x, size, defaultValue)"
    ],
    description: "Resize a matrix.",
    examples: [
        "resize([1,2,3,4,5], [3])",
        "resize([1,2,3], [5])",
        "resize([1,2,3], [5], -1)",
        "resize(2, [2, 3])",
        'resize("hello", [8], "!")'
    ],
    seealso: [
        "size",
        "subset",
        "squeeze",
        "reshape"
    ]
};


var $9b2daebf325198c3$export$7e4afefc91c50a64 = {
    name: "rotate",
    category: "Matrix",
    syntax: [
        "rotate(w, theta)",
        "rotate(w, theta, v)"
    ],
    description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
    examples: [
        "rotate([1, 0], pi / 2)",
        'rotate(matrix([1, 0]), unit("35deg"))',
        'rotate([1, 0, 0], unit("90deg"), [0, 0, 1])',
        'rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))'
    ],
    seealso: [
        "matrix",
        "rotationMatrix"
    ]
};


var $18c559d0cf9d7de1$export$95d0e442170bdedb = {
    name: "rotationMatrix",
    category: "Matrix",
    syntax: [
        "rotationMatrix(theta)",
        "rotationMatrix(theta, v)",
        "rotationMatrix(theta, v, format)"
    ],
    description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
    examples: [
        "rotationMatrix(pi / 2)",
        'rotationMatrix(unit("45deg"), [0, 0, 1])',
        'rotationMatrix(1, matrix([0, 0, 1]), "sparse")'
    ],
    seealso: [
        "cos",
        "sin"
    ]
};


var $b96ad139c2ec7127$export$74b9786bafaa0a25 = {
    name: "row",
    category: "Matrix",
    syntax: [
        "row(x, index)"
    ],
    description: "Return a row from a matrix or array.",
    examples: [
        "A = [[1, 2], [3, 4]]",
        "row(A, 1)",
        "row(A, 2)"
    ],
    seealso: [
        "column",
        "matrixFromRows"
    ]
};


var $d40412d49432cbe2$export$5044182a5ddc46fd = {
    name: "size",
    category: "Matrix",
    syntax: [
        "size(x)"
    ],
    description: "Calculate the size of a matrix.",
    examples: [
        "size(2.3)",
        'size("hello world")',
        "a = [1, 2; 3, 4; 5, 6]",
        "size(a)",
        "size(1:6)"
    ],
    seealso: [
        "concat",
        "count",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "squeeze",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $0c191261f304cae7$export$879539db0de7fe73 = {
    name: "sort",
    category: "Matrix",
    syntax: [
        "sort(x)",
        "sort(x, compare)"
    ],
    description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',
    examples: [
        "sort([5, 10, 1])",
        'sort(["C", "B", "A", "D"], "natural")',
        "sortByLength(a, b) = size(a)[1] - size(b)[1]",
        'sort(["Langdon", "Tom", "Sara"], sortByLength)',
        'sort(["10", "1", "2"], "natural")'
    ],
    seealso: [
        "map",
        "filter",
        "forEach"
    ]
};


var $2f37eac5ee5d69fb$export$84665209630d2bb0 = {
    name: "squeeze",
    category: "Matrix",
    syntax: [
        "squeeze(x)"
    ],
    description: "Remove inner and outer singleton dimensions from a matrix.",
    examples: [
        "a = zeros(3,2,1)",
        "size(squeeze(a))",
        "b = zeros(1,1,3)",
        "size(squeeze(b))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "subset",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $3a76af07c9482095$export$c809a1297fda8972 = {
    name: "subset",
    category: "Matrix",
    syntax: [
        "value(index)",
        "value(index) = replacement",
        "subset(value, [index])",
        "subset(value, [index], replacement)"
    ],
    description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.",
    examples: [
        "d = [1, 2; 3, 4]",
        "e = []",
        "e[1, 1:2] = [5, 6]",
        "e[2, :] = [7, 8]",
        "f = d * e",
        "f[2, 1]",
        "f[:, 1]",
        "f[[1,2], [1,3]] = [9, 10; 11, 12]",
        "f"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "trace",
        "transpose",
        "zeros"
    ]
};


var $71028f6f09d9dd22$export$46db08346422dd41 = {
    name: "trace",
    category: "Matrix",
    syntax: [
        "trace(A)"
    ],
    description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",
    examples: [
        "A = [1, 2, 3; -1, 2, 3; 2, 0, 3]",
        "trace(A)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "transpose",
        "zeros"
    ]
};


var $115494b0e3d44134$export$96fcaa3e48aec95b = {
    name: "transpose",
    category: "Matrix",
    syntax: [
        "x'",
        "transpose(x)"
    ],
    description: "Transpose a matrix",
    examples: [
        "a = [1, 2, 3; 4, 5, 6]",
        "a'",
        "transpose(a)"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "zeros"
    ]
};


var $426180724bef2495$export$d2794fce5915ba29 = {
    name: "zeros",
    category: "Matrix",
    syntax: [
        "zeros(m)",
        "zeros(m, n)",
        "zeros(m, n, p, ...)",
        "zeros([m])",
        "zeros([m, n])",
        "zeros([m, n, p, ...])"
    ],
    description: "Create a matrix containing zeros.",
    examples: [
        "zeros(3)",
        "zeros(3, 5)",
        "a = [1, 2, 3; 4, 5, 6]",
        "zeros(size(a))"
    ],
    seealso: [
        "concat",
        "det",
        "diag",
        "identity",
        "inv",
        "ones",
        "range",
        "size",
        "squeeze",
        "subset",
        "trace",
        "transpose"
    ]
};


var $583fc625e34dff90$export$3e6cafc8d17845c7 = {
    name: "fft",
    category: "Matrix",
    syntax: [
        "fft(x)"
    ],
    description: "Calculate N-dimensional fourier transform",
    examples: [
        "fft([[1, 0], [1, 0]])"
    ],
    seealso: [
        "ifft"
    ]
};


var $7064c54942afd807$export$d2931323ec07a3c0 = {
    name: "ifft",
    category: "Matrix",
    syntax: [
        "ifft(x)"
    ],
    description: "Calculate N-dimensional inverse fourier transform",
    examples: [
        "ifft([[2, 2], [0, 0]])"
    ],
    seealso: [
        "fft"
    ]
};


var $81e67aa7586dc3c6$export$c3382240e69dd024 = {
    name: "combinations",
    category: "Probability",
    syntax: [
        "combinations(n, k)"
    ],
    description: "Compute the number of combinations of n items taken k at a time",
    examples: [
        "combinations(7, 5)"
    ],
    seealso: [
        "combinationsWithRep",
        "permutations",
        "factorial"
    ]
};


var $2a7542d4f8d9d5f1$export$6bd2fb28e29d18e3 = {
    name: "combinationsWithRep",
    category: "Probability",
    syntax: [
        "combinationsWithRep(n, k)"
    ],
    description: "Compute the number of combinations of n items taken k at a time with replacements.",
    examples: [
        "combinationsWithRep(7, 5)"
    ],
    seealso: [
        "combinations",
        "permutations",
        "factorial"
    ]
};


var $978ee862ec9440ef$export$3e6b0f8e2df12b9d = {
    name: "factorial",
    category: "Probability",
    syntax: [
        "n!",
        "factorial(n)"
    ],
    description: "Compute the factorial of a value",
    examples: [
        "5!",
        "5 * 4 * 3 * 2 * 1",
        "3!"
    ],
    seealso: [
        "combinations",
        "combinationsWithRep",
        "permutations",
        "gamma"
    ]
};


var $e30d09e89bc2fe9e$export$499ae9272b264120 = {
    name: "gamma",
    category: "Probability",
    syntax: [
        "gamma(n)"
    ],
    description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",
    examples: [
        "gamma(4)",
        "3!",
        "gamma(1/2)",
        "sqrt(pi)"
    ],
    seealso: [
        "factorial"
    ]
};


var $737adace74f27ecb$export$b9351e80d68524a5 = {
    name: "lgamma",
    category: "Probability",
    syntax: [
        "lgamma(n)"
    ],
    description: "Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.",
    examples: [
        "lgamma(4)",
        "lgamma(1/2)",
        "lgamma(i)",
        "lgamma(complex(1.1, 2))"
    ],
    seealso: [
        "gamma"
    ]
};


var $f0f6810e3ff26c78$export$9f240af60ea686af = {
    name: "kldivergence",
    category: "Probability",
    syntax: [
        "kldivergence(x, y)"
    ],
    description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.",
    examples: [
        "kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"
    ],
    seealso: []
};


var $f8bd3d561ec525aa$export$5f53cf42e3f9579d = {
    name: "multinomial",
    category: "Probability",
    syntax: [
        "multinomial(A)"
    ],
    description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.",
    examples: [
        "multinomial([1, 2, 1])"
    ],
    seealso: [
        "combinations",
        "factorial"
    ]
};


var $f5e273227ad98bfe$export$eebb1076c4c85884 = {
    name: "permutations",
    category: "Probability",
    syntax: [
        "permutations(n)",
        "permutations(n, k)"
    ],
    description: "Compute the number of permutations of n items taken k at a time",
    examples: [
        "permutations(5)",
        "permutations(5, 3)"
    ],
    seealso: [
        "combinations",
        "combinationsWithRep",
        "factorial"
    ]
};


var $3304d744b908c47c$export$4a787d8dccbe181f = {
    name: "pickRandom",
    category: "Probability",
    syntax: [
        "pickRandom(array)",
        "pickRandom(array, number)",
        "pickRandom(array, weights)",
        "pickRandom(array, number, weights)",
        "pickRandom(array, weights, number)"
    ],
    description: "Pick a random entry from a given array.",
    examples: [
        "pickRandom(0:10)",
        "pickRandom([1, 3, 1, 6])",
        "pickRandom([1, 3, 1, 6], 2)",
        "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])",
        "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])",
        "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"
    ],
    seealso: [
        "random",
        "randomInt"
    ]
};


var $bab234f323771f92$export$d2b3cacd4d3219ec = {
    name: "random",
    category: "Probability",
    syntax: [
        "random()",
        "random(max)",
        "random(min, max)",
        "random(size)",
        "random(size, max)",
        "random(size, min, max)"
    ],
    description: "Return a random number.",
    examples: [
        "random()",
        "random(10, 20)",
        "random([2, 3])"
    ],
    seealso: [
        "pickRandom",
        "randomInt"
    ]
};


var $bb9b1539bf872f31$export$8e2c9b3226630e9d = {
    name: "randomInt",
    category: "Probability",
    syntax: [
        "randomInt(max)",
        "randomInt(min, max)",
        "randomInt(size)",
        "randomInt(size, max)",
        "randomInt(size, min, max)"
    ],
    description: "Return a random integer number",
    examples: [
        "randomInt(10, 20)",
        "randomInt([2, 3], 10)"
    ],
    seealso: [
        "pickRandom",
        "random"
    ]
};


var $bb173759f884c356$export$b01f6c58c90dea20 = {
    name: "compare",
    category: "Relational",
    syntax: [
        "compare(x, y)"
    ],
    description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        "compare(2, 3)",
        "compare(3, 2)",
        "compare(2, 2)",
        "compare(5cm, 40mm)",
        "compare(2, [1, 2, 3])"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compareNatural",
        "compareText"
    ]
};


var $b4c427985728823d$export$3d0415783a6e23a4 = {
    name: "compareNatural",
    category: "Relational",
    syntax: [
        "compareNatural(x, y)"
    ],
    description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        "compareNatural(2, 3)",
        "compareNatural(3, 2)",
        "compareNatural(2, 2)",
        "compareNatural(5cm, 40mm)",
        'compareNatural("2", "10")',
        "compareNatural(2 + 3i, 2 + 4i)",
        "compareNatural([1, 2, 4], [1, 2, 3])",
        "compareNatural([1, 5], [1, 2, 3])",
        "compareNatural([1, 2], [1, 2])",
        "compareNatural({a: 2}, {a: 4})"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compare",
        "compareText"
    ]
};


var $8c2d03da92c24473$export$f1ca5e1f3bd19e5d = {
    name: "compareText",
    category: "Relational",
    syntax: [
        "compareText(x, y)"
    ],
    description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
    examples: [
        'compareText("B", "A")',
        'compareText("A", "B")',
        'compareText("A", "A")',
        'compareText("2", "10")',
        'compare("2", "10")',
        "compare(2, 10)",
        'compareNatural("2", "10")',
        'compareText("B", ["A", "B", "C"])'
    ],
    seealso: [
        "compare",
        "compareNatural"
    ]
};


var $25dad40f39b9e47e$export$b25f67ed715e775e = {
    name: "deepEqual",
    category: "Relational",
    syntax: [
        "deepEqual(x, y)"
    ],
    description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",
    examples: [
        "deepEqual([1,3,4], [1,3,4])",
        "deepEqual([1,3,4], [1,3])"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};


var $5eac044a52d1edd6$export$5d5e6107045d826c = {
    name: "equal",
    category: "Relational",
    syntax: [
        "x == y",
        "equal(x, y)"
    ],
    description: "Check equality of two values. Returns true if the values are equal, and false if not.",
    examples: [
        "2+2 == 3",
        "2+2 == 4",
        "a = 3.2",
        "b = 6-2.8",
        "a == b",
        "50cm == 0.5m"
    ],
    seealso: [
        "unequal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare",
        "deepEqual",
        "equalText"
    ]
};


var $0bbc4b3fd372f745$export$9f17f53860452971 = {
    name: "equalText",
    category: "Relational",
    syntax: [
        "equalText(x, y)"
    ],
    description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.",
    examples: [
        'equalText("Hello", "Hello")',
        'equalText("a", "A")',
        'equal("2e3", "2000")',
        'equalText("2e3", "2000")',
        'equalText("B", ["A", "B", "C"])'
    ],
    seealso: [
        "compare",
        "compareNatural",
        "compareText",
        "equal"
    ]
};


var $3818f7a471103cc8$export$c775ecf5ac7366c3 = {
    name: "larger",
    category: "Relational",
    syntax: [
        "x > y",
        "larger(x, y)"
    ],
    description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not.",
    examples: [
        "2 > 3",
        "5 > 2*2",
        "a = 3.3",
        "b = 6-2.8",
        "(a > b)",
        "(b < a)",
        "5 cm > 2 inch"
    ],
    seealso: [
        "equal",
        "unequal",
        "smaller",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};


var $070158936ceff222$export$6ba4892ab98a938f = {
    name: "largerEq",
    category: "Relational",
    syntax: [
        "x >= y",
        "largerEq(x, y)"
    ],
    description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",
    examples: [
        "2 >= 1+1",
        "2 > 1+1",
        "a = 3.2",
        "b = 6-2.8",
        "(a >= b)"
    ],
    seealso: [
        "equal",
        "unequal",
        "smallerEq",
        "smaller",
        "compare"
    ]
};


var $78dbdee238bed599$export$4ecf0efdd4fb906b = {
    name: "smaller",
    category: "Relational",
    syntax: [
        "x < y",
        "smaller(x, y)"
    ],
    description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.",
    examples: [
        "2 < 3",
        "5 < 2*2",
        "a = 3.3",
        "b = 6-2.8",
        "(a < b)",
        "5 cm < 2 inch"
    ],
    seealso: [
        "equal",
        "unequal",
        "larger",
        "smallerEq",
        "largerEq",
        "compare"
    ]
};


var $187ca300b90f178c$export$2693b3d153548453 = {
    name: "smallerEq",
    category: "Relational",
    syntax: [
        "x <= y",
        "smallerEq(x, y)"
    ],
    description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",
    examples: [
        "2 <= 1+1",
        "2 < 1+1",
        "a = 3.2",
        "b = 6-2.8",
        "(a <= b)"
    ],
    seealso: [
        "equal",
        "unequal",
        "larger",
        "smaller",
        "largerEq",
        "compare"
    ]
};


var $cc46a37d4def43df$export$adade6432715c34e = {
    name: "unequal",
    category: "Relational",
    syntax: [
        "x != y",
        "unequal(x, y)"
    ],
    description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",
    examples: [
        "2+2 != 3",
        "2+2 != 4",
        "a = 3.2",
        "b = 6-2.8",
        "a != b",
        "50cm != 0.5m",
        "5 cm != 2 inch"
    ],
    seealso: [
        "equal",
        "smaller",
        "larger",
        "smallerEq",
        "largerEq",
        "compare",
        "deepEqual"
    ]
};


var $f0ef107b1b2066e8$export$6f06d74ab9e6fcad = {
    name: "setCartesian",
    category: "Set",
    syntax: [
        "setCartesian(set1, set2)"
    ],
    description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.",
    examples: [
        "setCartesian([1, 2], [3, 4])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference",
        "setPowerset"
    ]
};


var $e570260a29ed4a2a$export$44337ef629295c55 = {
    name: "setDifference",
    category: "Set",
    syntax: [
        "setDifference(set1, set2)"
    ],
    description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setDifference([1, 2, 3, 4], [3, 4, 5, 6])",
        "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setSymDifference"
    ]
};


var $aadae903d155118a$export$4c8f2f903562c625 = {
    name: "setDistinct",
    category: "Set",
    syntax: [
        "setDistinct(set)"
    ],
    description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setDistinct([1, 1, 1, 2, 2, 3])"
    ],
    seealso: [
        "setMultiplicity"
    ]
};


var $c4bb45a5ad0f7df1$export$97fa484e42285777 = {
    name: "setIntersect",
    category: "Set",
    syntax: [
        "setIntersect(set1, set2)"
    ],
    description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setIntersect([1, 2, 3, 4], [3, 4, 5, 6])",
        "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setDifference"
    ]
};


var $8921dcaf8b97c4ea$export$995337132a02fcf0 = {
    name: "setIsSubset",
    category: "Set",
    syntax: [
        "setIsSubset(set1, set2)"
    ],
    description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setIsSubset([1, 2], [3, 4, 5, 6])",
        "setIsSubset([3, 4], [3, 4, 5, 6])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};


var $fdc35551166b9045$export$33972a95e247fd58 = {
    name: "setMultiplicity",
    category: "Set",
    syntax: [
        "setMultiplicity(element, set)"
    ],
    description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setMultiplicity(1, [1, 2, 2, 4])",
        "setMultiplicity(2, [1, 2, 2, 4])"
    ],
    seealso: [
        "setDistinct",
        "setSize"
    ]
};


var $97a29c1690b47791$export$7040fb97e0f08a08 = {
    name: "setPowerset",
    category: "Set",
    syntax: [
        "setPowerset(set)"
    ],
    description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.",
    examples: [
        "setPowerset([1, 2, 3])"
    ],
    seealso: [
        "setCartesian"
    ]
};


var $2874f47d986bbc8f$export$47ff1cdc99784c11 = {
    name: "setSize",
    category: "Set",
    syntax: [
        "setSize(set)",
        "setSize(set, unique)"
    ],
    description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
    examples: [
        "setSize([1, 2, 2, 4])",
        "setSize([1, 2, 2, 4], true)"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};


var $653b075373b11918$export$340d6a7da02d62f3 = {
    name: "setSymDifference",
    category: "Set",
    syntax: [
        "setSymDifference(set1, set2)"
    ],
    description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])",
        "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setUnion",
        "setIntersect",
        "setDifference"
    ]
};


var $02ddf5298c7001c9$export$c6ab538723059178 = {
    name: "setUnion",
    category: "Set",
    syntax: [
        "setUnion(set1, set2)"
    ],
    description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
    examples: [
        "setUnion([1, 2, 3, 4], [3, 4, 5, 6])",
        "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
    ],
    seealso: [
        "setIntersect",
        "setDifference"
    ]
};


var $78ab532d951c56bf$export$ab6b87b59204b134 = {
    name: "zpk2tf",
    category: "Signal",
    syntax: [
        "zpk2tf(z, p, k)"
    ],
    description: "Compute the transfer function of a zero-pole-gain model.",
    examples: [
        "zpk2tf([1, 2], [-1, -2], 1)",
        "zpk2tf([1, 2], [-1, -2])",
        "zpk2tf([1 - 3i, 2 + 2i], [-1, -2])"
    ],
    seealso: []
};


var $a43df4026c171298$export$e4067b8f2cf8b3a7 = {
    name: "freqz",
    category: "Signal",
    syntax: [
        "freqz(b, a)",
        "freqz(b, a, w)"
    ],
    description: "Calculates the frequency response of a filter given its numerator and denominator coefficients.",
    examples: [
        "freqz([1, 2], [1, 2, 3])",
        "freqz([1, 2], [1, 2, 3], [0, 1])",
        "freqz([1, 2], [1, 2, 3], 512)"
    ],
    seealso: []
};


var $307e77d099acd64e$export$23984555c8f4e00a = {
    name: "erf",
    category: "Special",
    syntax: [
        "erf(x)"
    ],
    description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",
    examples: [
        "erf(0.2)",
        "erf(-0.5)",
        "erf(4)"
    ],
    seealso: []
};


var $69fd4902d552f9c1$export$f326627f77aa9768 = {
    name: "zeta",
    category: "Special",
    syntax: [
        "zeta(s)"
    ],
    description: "Compute the Riemann Zeta Function using an infinite series and Riemanns Functional Equation for the entire complex plane",
    examples: [
        "zeta(0.2)",
        "zeta(-0.5)",
        "zeta(4)"
    ],
    seealso: []
};


var $1704f378c7b0bb03$export$113a75651a4a72c6 = {
    name: "mad",
    category: "Statistics",
    syntax: [
        "mad(a, b, c, ...)",
        "mad(A)"
    ],
    description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.",
    examples: [
        "mad(10, 20, 30)",
        "mad([1, 2, 3])"
    ],
    seealso: [
        "mean",
        "median",
        "std",
        "abs"
    ]
};


var $99c68223fd1e31f0$export$f3fddd6eb2764aa6 = {
    name: "max",
    category: "Statistics",
    syntax: [
        "max(a, b, c, ...)",
        "max(A)",
        "max(A, dimension)"
    ],
    description: "Compute the maximum value of a list of values.",
    examples: [
        "max(2, 3, 4, 1)",
        "max([2, 3, 4, 1])",
        "max([2, 5; 4, 3])",
        "max([2, 5; 4, 3], 1)",
        "max([2, 5; 4, 3], 2)",
        "max(2.7, 7.1, -4.5, 2.0, 4.1)",
        "min(2.7, 7.1, -4.5, 2.0, 4.1)"
    ],
    seealso: [
        "mean",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $28d51b07edc7113e$export$1f7fad79151d4cc1 = {
    name: "mean",
    category: "Statistics",
    syntax: [
        "mean(a, b, c, ...)",
        "mean(A)",
        "mean(A, dimension)"
    ],
    description: "Compute the arithmetic mean of a list of values.",
    examples: [
        "mean(2, 3, 4, 1)",
        "mean([2, 3, 4, 1])",
        "mean([2, 5; 4, 3])",
        "mean([2, 5; 4, 3], 1)",
        "mean([2, 5; 4, 3], 2)",
        "mean([1.0, 2.7, 3.2, 4.0])"
    ],
    seealso: [
        "max",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $96d4307a2ee61417$export$dd1c97a64d85784b = {
    name: "median",
    category: "Statistics",
    syntax: [
        "median(a, b, c, ...)",
        "median(A)"
    ],
    description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",
    examples: [
        "median(5, 2, 7)",
        "median([3, -1, 5, 7])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "prod",
        "std",
        "sum",
        "variance",
        "quantileSeq"
    ]
};


var $c9d771206f9d85a7$export$17718e9907e3ac84 = {
    name: "min",
    category: "Statistics",
    syntax: [
        "min(a, b, c, ...)",
        "min(A)",
        "min(A, dimension)"
    ],
    description: "Compute the minimum value of a list of values.",
    examples: [
        "min(2, 3, 4, 1)",
        "min([2, 3, 4, 1])",
        "min([2, 5; 4, 3])",
        "min([2, 5; 4, 3], 1)",
        "min([2, 5; 4, 3], 2)",
        "min(2.7, 7.1, -4.5, 2.0, 4.1)",
        "max(2.7, 7.1, -4.5, 2.0, 4.1)"
    ],
    seealso: [
        "max",
        "mean",
        "median",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $20fec8350969f89b$export$30b601fd0273be74 = {
    name: "mode",
    category: "Statistics",
    syntax: [
        "mode(a, b, c, ...)",
        "mode(A)",
        "mode(A, a, b, B, c, ...)"
    ],
    description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",
    examples: [
        "mode(2, 1, 4, 3, 1)",
        "mode([1, 2.7, 3.2, 4, 2.7])",
        "mode(1, 4, 6, 1, 6)"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $fa24ff617ac9ab9e$export$524cc5e521f0e533 = {
    name: "prod",
    category: "Statistics",
    syntax: [
        "prod(a, b, c, ...)",
        "prod(A)"
    ],
    description: "Compute the product of all values.",
    examples: [
        "prod(2, 3, 4)",
        "prod([2, 3, 4])",
        "prod([2, 5; 4, 3])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "min",
        "std",
        "sum",
        "variance"
    ]
};


var $af56becd76cf4368$export$f80c87524ae9a59f = {
    name: "quantileSeq",
    category: "Statistics",
    syntax: [
        "quantileSeq(A, prob[, sorted])",
        "quantileSeq(A, [prob1, prob2, ...][, sorted])",
        "quantileSeq(A, N[, sorted])"
    ],
    description: "Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.",
    examples: [
        "quantileSeq([3, -1, 5, 7], 0.5)",
        "quantileSeq([3, -1, 5, 7], [1/3, 2/3])",
        "quantileSeq([3, -1, 5, 7], 2)",
        "quantileSeq([-1, 3, 5, 7], 0.5, true)"
    ],
    seealso: [
        "mean",
        "median",
        "min",
        "max",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $6926e4629e064d2e$export$d1c23b21300d0eb8 = {
    name: "std",
    category: "Statistics",
    syntax: [
        "std(a, b, c, ...)",
        "std(A)",
        "std(A, dimension)",
        "std(A, normalization)",
        "std(A, dimension, normalization)"
    ],
    description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
    examples: [
        "std(2, 4, 6)",
        "std([2, 4, 6, 8])",
        'std([2, 4, 6, 8], "uncorrected")',
        'std([2, 4, 6, 8], "biased")',
        "std([1, 2, 3; 4, 5, 6])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "prod",
        "sum",
        "variance"
    ]
};


var $00e7ff758a3d18e0$export$b230561799d1722c = {
    name: "cumsum",
    category: "Statistics",
    syntax: [
        "cumsum(a, b, c, ...)",
        "cumsum(A)"
    ],
    description: "Compute the cumulative sum of all values.",
    examples: [
        "cumsum(2, 3, 4, 1)",
        "cumsum([2, 3, 4, 1])",
        "cumsum([1, 2; 3, 4])",
        "cumsum([1, 2; 3, 4], 1)",
        "cumsum([1, 2; 3, 4], 2)"
    ],
    seealso: [
        "max",
        "mean",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $bee08c970a80b9f3$export$cd6065b38df4efb0 = {
    name: "sum",
    category: "Statistics",
    syntax: [
        "sum(a, b, c, ...)",
        "sum(A)",
        "sum(A, dimension)"
    ],
    description: "Compute the sum of all values.",
    examples: [
        "sum(2, 3, 4, 1)",
        "sum([2, 3, 4, 1])",
        "sum([2, 5; 4, 3])"
    ],
    seealso: [
        "max",
        "mean",
        "median",
        "min",
        "prod",
        "std",
        "sum",
        "variance"
    ]
};


var $bfe40c8be78a4e94$export$5a58a225f78b347f = {
    name: "variance",
    category: "Statistics",
    syntax: [
        "variance(a, b, c, ...)",
        "variance(A)",
        "variance(A, dimension)",
        "variance(A, normalization)",
        "variance(A, dimension, normalization)"
    ],
    description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
    examples: [
        "variance(2, 4, 6)",
        "variance([2, 4, 6, 8])",
        'variance([2, 4, 6, 8], "uncorrected")',
        'variance([2, 4, 6, 8], "biased")',
        "variance([1, 2, 3; 4, 5, 6])"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "min",
        "prod",
        "std",
        "sum"
    ]
};


var $0a09bd42d5284d52$export$7d36823afee68b24 = {
    name: "corr",
    category: "Statistics",
    syntax: [
        "corr(A,B)"
    ],
    description: "Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.",
    examples: [
        "corr([2, 4, 6, 8],[1, 2, 3, 6])",
        "corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))"
    ],
    seealso: [
        "max",
        "mean",
        "min",
        "median",
        "min",
        "prod",
        "std",
        "sum"
    ]
};


var $cce6d11ecdd1a138$export$a96a9170bca705dc = {
    name: "acos",
    category: "Trigonometry",
    syntax: [
        "acos(x)"
    ],
    description: "Compute the inverse cosine of a value in radians.",
    examples: [
        "acos(0.5)",
        "acos(cos(2.3))"
    ],
    seealso: [
        "cos",
        "atan",
        "asin"
    ]
};


var $d42a56b3d04395cc$export$eb8f1b26819009ca = {
    name: "acosh",
    category: "Trigonometry",
    syntax: [
        "acosh(x)"
    ],
    description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",
    examples: [
        "acosh(1.5)"
    ],
    seealso: [
        "cosh",
        "asinh",
        "atanh"
    ]
};


var $5054961e83453235$export$5df2d36103c3facc = {
    name: "acot",
    category: "Trigonometry",
    syntax: [
        "acot(x)"
    ],
    description: "Calculate the inverse cotangent of a value.",
    examples: [
        "acot(0.5)",
        "acot(cot(0.5))",
        "acot(2)"
    ],
    seealso: [
        "cot",
        "atan"
    ]
};


var $5505166916234fe3$export$b7d7f2d7d0d4ec7d = {
    name: "acoth",
    category: "Trigonometry",
    syntax: [
        "acoth(x)"
    ],
    description: "Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",
    examples: [
        "acoth(2)",
        "acoth(0.5)"
    ],
    seealso: [
        "acsch",
        "asech"
    ]
};


var $a164f7f9f68c0fd3$export$911b51cd6a7612a8 = {
    name: "acsc",
    category: "Trigonometry",
    syntax: [
        "acsc(x)"
    ],
    description: "Calculate the inverse cotangent of a value.",
    examples: [
        "acsc(2)",
        "acsc(csc(0.5))",
        "acsc(0.5)"
    ],
    seealso: [
        "csc",
        "asin",
        "asec"
    ]
};


var $957130e6983394ea$export$319c6d631e591850 = {
    name: "acsch",
    category: "Trigonometry",
    syntax: [
        "acsch(x)"
    ],
    description: "Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",
    examples: [
        "acsch(0.5)"
    ],
    seealso: [
        "asech",
        "acoth"
    ]
};


var $8a3601e531e4985d$export$fbe1d815e0591494 = {
    name: "asec",
    category: "Trigonometry",
    syntax: [
        "asec(x)"
    ],
    description: "Calculate the inverse secant of a value.",
    examples: [
        "asec(0.5)",
        "asec(sec(0.5))",
        "asec(2)"
    ],
    seealso: [
        "acos",
        "acot",
        "acsc"
    ]
};


var $f2d2b3bad4745e73$export$52f8b22e9936e0e = {
    name: "asech",
    category: "Trigonometry",
    syntax: [
        "asech(x)"
    ],
    description: "Calculate the inverse secant of a value.",
    examples: [
        "asech(0.5)"
    ],
    seealso: [
        "acsch",
        "acoth"
    ]
};


var $bb16ed338a95c7c6$export$b85b8db6e8a2ed3d = {
    name: "asin",
    category: "Trigonometry",
    syntax: [
        "asin(x)"
    ],
    description: "Compute the inverse sine of a value in radians.",
    examples: [
        "asin(0.5)",
        "asin(sin(0.5))"
    ],
    seealso: [
        "sin",
        "acos",
        "atan"
    ]
};


var $aa39408d1f42a459$export$afe7a3b04750ebb7 = {
    name: "asinh",
    category: "Trigonometry",
    syntax: [
        "asinh(x)"
    ],
    description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",
    examples: [
        "asinh(0.5)"
    ],
    seealso: [
        "acosh",
        "atanh"
    ]
};


var $d5ebb57e41970d89$export$80066e40c56154f0 = {
    name: "atan",
    category: "Trigonometry",
    syntax: [
        "atan(x)"
    ],
    description: "Compute the inverse tangent of a value in radians.",
    examples: [
        "atan(0.5)",
        "atan(tan(0.5))"
    ],
    seealso: [
        "tan",
        "acos",
        "asin"
    ]
};


var $da3f11feea190a41$export$e4fc5308b4910337 = {
    name: "atan2",
    category: "Trigonometry",
    syntax: [
        "atan2(y, x)"
    ],
    description: "Computes the principal value of the arc tangent of y/x in radians.",
    examples: [
        "atan2(2, 2) / pi",
        "angle = 60 deg in rad",
        "x = cos(angle)",
        "y = sin(angle)",
        "atan2(y, x)"
    ],
    seealso: [
        "sin",
        "cos",
        "tan"
    ]
};


var $ecb49a480e5d3c52$export$e5bbdb9caa9a8f09 = {
    name: "atanh",
    category: "Trigonometry",
    syntax: [
        "atanh(x)"
    ],
    description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",
    examples: [
        "atanh(0.5)"
    ],
    seealso: [
        "acosh",
        "asinh"
    ]
};


var $b7b89f6f8494a9f1$export$1a1af52900b6c58e = {
    name: "cos",
    category: "Trigonometry",
    syntax: [
        "cos(x)"
    ],
    description: "Compute the cosine of x in radians.",
    examples: [
        "cos(2)",
        "cos(pi / 4) ^ 2",
        "cos(180 deg)",
        "cos(60 deg)",
        "sin(0.2)^2 + cos(0.2)^2"
    ],
    seealso: [
        "acos",
        "sin",
        "tan"
    ]
};


var $daba36d8932d481f$export$5af2bed23001ffc5 = {
    name: "cosh",
    category: "Trigonometry",
    syntax: [
        "cosh(x)"
    ],
    description: "Compute the hyperbolic cosine of x in radians.",
    examples: [
        "cosh(0.5)"
    ],
    seealso: [
        "sinh",
        "tanh",
        "coth"
    ]
};


var $e1687223c1838a8d$export$b6bae004c5b418ef = {
    name: "cot",
    category: "Trigonometry",
    syntax: [
        "cot(x)"
    ],
    description: "Compute the cotangent of x in radians. Defined as 1/tan(x)",
    examples: [
        "cot(2)",
        "1 / tan(2)"
    ],
    seealso: [
        "sec",
        "csc",
        "tan"
    ]
};


var $d63f9ad71c0f2efd$export$7cd2898db0b732d0 = {
    name: "coth",
    category: "Trigonometry",
    syntax: [
        "coth(x)"
    ],
    description: "Compute the hyperbolic cotangent of x in radians.",
    examples: [
        "coth(2)",
        "1 / tanh(2)"
    ],
    seealso: [
        "sech",
        "csch",
        "tanh"
    ]
};


var $0650e3a98cdc4f48$export$1be2e18f41ba39dc = {
    name: "csc",
    category: "Trigonometry",
    syntax: [
        "csc(x)"
    ],
    description: "Compute the cosecant of x in radians. Defined as 1/sin(x)",
    examples: [
        "csc(2)",
        "1 / sin(2)"
    ],
    seealso: [
        "sec",
        "cot",
        "sin"
    ]
};


var $9bfa409a092ec036$export$8baf7f6e609495d8 = {
    name: "csch",
    category: "Trigonometry",
    syntax: [
        "csch(x)"
    ],
    description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",
    examples: [
        "csch(2)",
        "1 / sinh(2)"
    ],
    seealso: [
        "sech",
        "coth",
        "sinh"
    ]
};


var $73ff10f1b82b7134$export$3dae56ab28d48626 = {
    name: "sec",
    category: "Trigonometry",
    syntax: [
        "sec(x)"
    ],
    description: "Compute the secant of x in radians. Defined as 1/cos(x)",
    examples: [
        "sec(2)",
        "1 / cos(2)"
    ],
    seealso: [
        "cot",
        "csc",
        "cos"
    ]
};


var $c170ac5e0e36a797$export$6da75bc9afc8303b = {
    name: "sech",
    category: "Trigonometry",
    syntax: [
        "sech(x)"
    ],
    description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",
    examples: [
        "sech(2)",
        "1 / cosh(2)"
    ],
    seealso: [
        "coth",
        "csch",
        "cosh"
    ]
};


var $8ea6043e850f149e$export$c7700d6ff32b1413 = {
    name: "sin",
    category: "Trigonometry",
    syntax: [
        "sin(x)"
    ],
    description: "Compute the sine of x in radians.",
    examples: [
        "sin(2)",
        "sin(pi / 4) ^ 2",
        "sin(90 deg)",
        "sin(30 deg)",
        "sin(0.2)^2 + cos(0.2)^2"
    ],
    seealso: [
        "asin",
        "cos",
        "tan"
    ]
};


var $7406ce9e47e8165e$export$e07b4c62bc488091 = {
    name: "sinh",
    category: "Trigonometry",
    syntax: [
        "sinh(x)"
    ],
    description: "Compute the hyperbolic sine of x in radians.",
    examples: [
        "sinh(0.5)"
    ],
    seealso: [
        "cosh",
        "tanh"
    ]
};


var $394287381ebd5be9$export$14fc997d4768f36a = {
    name: "tan",
    category: "Trigonometry",
    syntax: [
        "tan(x)"
    ],
    description: "Compute the tangent of x in radians.",
    examples: [
        "tan(0.5)",
        "sin(0.5) / cos(0.5)",
        "tan(pi / 4)",
        "tan(45 deg)"
    ],
    seealso: [
        "atan",
        "sin",
        "cos"
    ]
};


var $1128286b7e522bd9$export$52a5c54b85f75620 = {
    name: "tanh",
    category: "Trigonometry",
    syntax: [
        "tanh(x)"
    ],
    description: "Compute the hyperbolic tangent of x in radians.",
    examples: [
        "tanh(0.5)",
        "sinh(0.5) / cosh(0.5)"
    ],
    seealso: [
        "sinh",
        "cosh"
    ]
};


var $e4a3d5dd2193e0c4$export$c532fecb2dfa6274 = {
    name: "to",
    category: "Units",
    syntax: [
        "x to unit",
        "to(x, unit)"
    ],
    description: "Change the unit of a value.",
    examples: [
        "5 inch to cm",
        "3.2kg to g",
        "16 bytes in bits"
    ],
    seealso: []
};


var $649f02345ce6fca1$export$9859a5b8f644d8ff = {
    name: "bin",
    category: "Utils",
    syntax: [
        "bin(value)"
    ],
    description: "Format a number as binary",
    examples: [
        "bin(2)"
    ],
    seealso: [
        "oct",
        "hex"
    ]
};


var $bf6500baef10138f$export$500c01a79e32a1ad = {
    name: "clone",
    category: "Utils",
    syntax: [
        "clone(x)"
    ],
    description: "Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices",
    examples: [
        "clone(3.5)",
        "clone(2 - 4i)",
        "clone(45 deg)",
        "clone([1, 2; 3, 4])",
        'clone("hello world")'
    ],
    seealso: []
};


var $5f0b803045d7ceb0$export$278425b4fe1ff1bf = {
    name: "format",
    category: "Utils",
    syntax: [
        "format(value)",
        "format(value, precision)"
    ],
    description: "Format a value of any type as string.",
    examples: [
        "format(2.3)",
        "format(3 - 4i)",
        "format([])",
        "format(pi, 3)"
    ],
    seealso: [
        "print"
    ]
};


var $00e2f8731573a15b$export$9d10d68d9b7d7a67 = {
    name: "hasNumericValue",
    category: "Utils",
    syntax: [
        "hasNumericValue(x)"
    ],
    description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.",
    examples: [
        "hasNumericValue(2)",
        'hasNumericValue("2")',
        'isNumeric("2")',
        "hasNumericValue(0)",
        "hasNumericValue(bignumber(500))",
        "hasNumericValue(fraction(0.125))",
        "hasNumericValue(2 + 3i)",
        'hasNumericValue([2.3, "foo", false])'
    ],
    seealso: [
        "isInteger",
        "isZero",
        "isNegative",
        "isPositive",
        "isNaN",
        "isNumeric"
    ]
};


var $46a1f32bfdfe77fb$export$81a08b4e66fc3038 = {
    name: "hex",
    category: "Utils",
    syntax: [
        "hex(value)"
    ],
    description: "Format a number as hexadecimal",
    examples: [
        "hex(240)"
    ],
    seealso: [
        "bin",
        "oct"
    ]
};


var $4f6b2035a77755f2$export$1d8b51b394bbccdc = {
    name: "isInteger",
    category: "Utils",
    syntax: [
        "isInteger(x)"
    ],
    description: "Test whether a value is an integer number.",
    examples: [
        "isInteger(2)",
        "isInteger(3.5)",
        "isInteger([3, 0.5, -2])"
    ],
    seealso: [
        "isNegative",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};


var $b2467bf5e8721fcc$export$f4e7c51d549c187f = {
    name: "isNaN",
    category: "Utils",
    syntax: [
        "isNaN(x)"
    ],
    description: "Test whether a value is NaN (not a number)",
    examples: [
        "isNaN(2)",
        "isNaN(0 / 0)",
        "isNaN(NaN)",
        "isNaN(Infinity)"
    ],
    seealso: [
        "isNegative",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};


var $ee960ed1e649f01c$export$f94a800b9b237f17 = {
    name: "isNegative",
    category: "Utils",
    syntax: [
        "isNegative(x)"
    ],
    description: "Test whether a value is negative: smaller than zero.",
    examples: [
        "isNegative(2)",
        "isNegative(0)",
        "isNegative(-4)",
        "isNegative([3, 0.5, -2])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isPositive",
        "isZero"
    ]
};


var $2ccc991b7eadbc0a$export$7ac3927ed17fe2b6 = {
    name: "isNumeric",
    category: "Utils",
    syntax: [
        "isNumeric(x)"
    ],
    description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",
    examples: [
        "isNumeric(2)",
        'isNumeric("2")',
        'hasNumericValue("2")',
        "isNumeric(0)",
        "isNumeric(bignumber(500))",
        "isNumeric(fraction(0.125))",
        "isNumeric(2 + 3i)",
        'isNumeric([2.3, "foo", false])'
    ],
    seealso: [
        "isInteger",
        "isZero",
        "isNegative",
        "isPositive",
        "isNaN",
        "hasNumericValue"
    ]
};


var $ad1a5039438f9526$export$338f53b321c261b9 = {
    name: "isPositive",
    category: "Utils",
    syntax: [
        "isPositive(x)"
    ],
    description: "Test whether a value is positive: larger than zero.",
    examples: [
        "isPositive(2)",
        "isPositive(0)",
        "isPositive(-4)",
        "isPositive([3, 0.5, -2])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isZero"
    ]
};


var $bce15bcc97eef83b$export$d6ada432c5e7d9c7 = {
    name: "isPrime",
    category: "Utils",
    syntax: [
        "isPrime(x)"
    ],
    description: "Test whether a value is prime: has no divisors other than itself and one.",
    examples: [
        "isPrime(3)",
        "isPrime(-2)",
        "isPrime([2, 17, 100])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isZero"
    ]
};


var $cb48c726517b1f12$export$52c03b663dd15fa3 = {
    name: "isZero",
    category: "Utils",
    syntax: [
        "isZero(x)"
    ],
    description: "Test whether a value is zero.",
    examples: [
        "isZero(2)",
        "isZero(0)",
        "isZero(-4)",
        "isZero([3, 0, -2, 0])"
    ],
    seealso: [
        "isInteger",
        "isNumeric",
        "isNegative",
        "isPositive"
    ]
};


var $1b5cd085ae6a7b75$export$d275ce05039a5f7a = {
    name: "numeric",
    category: "Utils",
    syntax: [
        "numeric(x)"
    ],
    description: "Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.",
    examples: [
        'numeric("4")',
        'numeric("4", "number")',
        'numeric("4", "bigint")',
        'numeric("4", "BigNumber")',
        'numeric("4", "Fraction")',
        'numeric(4, "Fraction")',
        'numeric(fraction(2, 5), "number")'
    ],
    seealso: [
        "number",
        "bigint",
        "fraction",
        "bignumber",
        "string",
        "format"
    ]
};


var $62ca1db7b2a0a5fa$export$669461bdc241fd13 = {
    name: "oct",
    category: "Utils",
    syntax: [
        "oct(value)"
    ],
    description: "Format a number as octal",
    examples: [
        "oct(56)"
    ],
    seealso: [
        "bin",
        "hex"
    ]
};


var $a393a69f0deb107d$export$e3b3b470cfab492d = {
    name: "print",
    category: "Utils",
    syntax: [
        "print(template, values)",
        "print(template, values, precision)"
    ],
    description: "Interpolate values into a string template.",
    examples: [
        'print("Lucy is $age years old", {age: 5})',
        'print("The value of pi is $pi", {pi: pi}, 3)',
        'print("Hello, $user.name!", {user: {name: "John"}})',
        'print("Values: $1, $2, $3", [6, 9, 4])'
    ],
    seealso: [
        "format"
    ]
};


var $b69e74134876a4c1$export$5b193b71b9b497e6 = {
    name: "typeOf",
    category: "Utils",
    syntax: [
        "typeOf(x)"
    ],
    description: "Get the type of a variable.",
    examples: [
        "typeOf(3.5)",
        "typeOf(2 - 4i)",
        "typeOf(45 deg)",
        'typeOf("hello world")'
    ],
    seealso: [
        "getMatrixDataType"
    ]
};


var $514e812226437c44$export$eb31de1eb82537e = {
    name: "solveODE",
    category: "Numeric",
    syntax: [
        "solveODE(func, tspan, y0)",
        "solveODE(func, tspan, y0, options)"
    ],
    description: "Numerical Integration of Ordinary Differential Equations.",
    examples: [
        "f(t,y) = y",
        "tspan = [0, 4]",
        "solveODE(f, tspan, 1)",
        "solveODE(f, tspan, [1, 2])",
        'solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })'
    ],
    seealso: [
        "derivative",
        "simplifyCore"
    ]
};


var $7218f41f830f83ad$export$c2adf0a3344c85c9 = {
    // construction functions
    bignumber: (0, $e77b8720ad558a33$export$e8c3f4e3ad52a4e6),
    bigint: (0, $53b61ab7dc049001$export$857f42eb63034b3f),
    boolean: (0, $6566513983122549$export$dbe10b9a90fd671a),
    complex: (0, $5579b3bb90453cde$export$a266a326dd0e84ff),
    createUnit: (0, $6ef065584dea6494$export$e56a121dfffbec82),
    fraction: (0, $5e186ca0b0be2272$export$46678100e6b87439),
    index: (0, $7a81896693161c6c$export$39876fcf61312bba),
    matrix: (0, $d53c01610458e1b0$export$dc433018b5b5e90f),
    number: (0, $32de92aabdb43840$export$3b011c0eed79d7e0),
    sparse: (0, $02440e85e81f831d$export$b569625c2404133),
    splitUnit: (0, $9f54b754fadc3081$export$f729a0241c48cb52),
    string: (0, $975a71e4f1c7ead7$export$783e4a4a90f7bc1d),
    unit: (0, $69e7fb2c282e30e8$export$478a7368ebd56459),
    // constants
    e: (0, $869b89673aca58e7$export$3fcb7a132c6e2ba6),
    E: (0, $869b89673aca58e7$export$3fcb7a132c6e2ba6),
    false: (0, $c5bd98cecf9e56b4$export$a73c839095ae9f5c),
    i: (0, $a2f1e96f98767691$export$e6ca220ee1b42382),
    Infinity: (0, $c2ef533cf01255af$export$15a96a548a33c6f1),
    LN2: (0, $64ac6d13638085d3$export$6e0577c024a56563),
    LN10: (0, $635e435fc95fe61d$export$a1bd41a4b6a2fca0),
    LOG2E: (0, $c0478b8cc3620ca5$export$813e053668381c19),
    LOG10E: (0, $607af81a54b51f6b$export$c706f91356bdd28c),
    NaN: (0, $91e9ab16b10c7478$export$eabb08eada5c068d),
    null: (0, $e2f611a3c9cc6d3c$export$a805f16f075f20cb),
    pi: (0, $cc23124e471e747e$export$acdd1b7b7d3e5e4e),
    PI: (0, $cc23124e471e747e$export$acdd1b7b7d3e5e4e),
    phi: (0, $927f5ada2d843694$export$f4e037238b5533c1),
    SQRT1_2: (0, $ed0d11305883f623$export$6838d33506c2b5d0),
    SQRT2: (0, $acf6bec3752691ae$export$ce0e8257aab3e4ae),
    tau: (0, $1dd1873b721cc97c$export$aee6f1e4bf7402c8),
    true: (0, $10a80b3e040bd92c$export$f6ccf6a3f013127d),
    version: (0, $35a55c148b2609a7$export$c94cc7868097f914),
    // physical constants
    // TODO: more detailed docs for physical constants
    speedOfLight: {
        description: "Speed of light in vacuum",
        examples: [
            "speedOfLight"
        ]
    },
    gravitationConstant: {
        description: "Newtonian constant of gravitation",
        examples: [
            "gravitationConstant"
        ]
    },
    planckConstant: {
        description: "Planck constant",
        examples: [
            "planckConstant"
        ]
    },
    reducedPlanckConstant: {
        description: "Reduced Planck constant",
        examples: [
            "reducedPlanckConstant"
        ]
    },
    magneticConstant: {
        description: "Magnetic constant (vacuum permeability)",
        examples: [
            "magneticConstant"
        ]
    },
    electricConstant: {
        description: "Electric constant (vacuum permeability)",
        examples: [
            "electricConstant"
        ]
    },
    vacuumImpedance: {
        description: "Characteristic impedance of vacuum",
        examples: [
            "vacuumImpedance"
        ]
    },
    coulomb: {
        description: "Coulomb's constant",
        examples: [
            "coulomb"
        ]
    },
    elementaryCharge: {
        description: "Elementary charge",
        examples: [
            "elementaryCharge"
        ]
    },
    bohrMagneton: {
        description: "Borh magneton",
        examples: [
            "bohrMagneton"
        ]
    },
    conductanceQuantum: {
        description: "Conductance quantum",
        examples: [
            "conductanceQuantum"
        ]
    },
    inverseConductanceQuantum: {
        description: "Inverse conductance quantum",
        examples: [
            "inverseConductanceQuantum"
        ]
    },
    // josephson: {description: 'Josephson constant', examples: ['josephson']},
    magneticFluxQuantum: {
        description: "Magnetic flux quantum",
        examples: [
            "magneticFluxQuantum"
        ]
    },
    nuclearMagneton: {
        description: "Nuclear magneton",
        examples: [
            "nuclearMagneton"
        ]
    },
    klitzing: {
        description: "Von Klitzing constant",
        examples: [
            "klitzing"
        ]
    },
    bohrRadius: {
        description: "Borh radius",
        examples: [
            "bohrRadius"
        ]
    },
    classicalElectronRadius: {
        description: "Classical electron radius",
        examples: [
            "classicalElectronRadius"
        ]
    },
    electronMass: {
        description: "Electron mass",
        examples: [
            "electronMass"
        ]
    },
    fermiCoupling: {
        description: "Fermi coupling constant",
        examples: [
            "fermiCoupling"
        ]
    },
    fineStructure: {
        description: "Fine-structure constant",
        examples: [
            "fineStructure"
        ]
    },
    hartreeEnergy: {
        description: "Hartree energy",
        examples: [
            "hartreeEnergy"
        ]
    },
    protonMass: {
        description: "Proton mass",
        examples: [
            "protonMass"
        ]
    },
    deuteronMass: {
        description: "Deuteron Mass",
        examples: [
            "deuteronMass"
        ]
    },
    neutronMass: {
        description: "Neutron mass",
        examples: [
            "neutronMass"
        ]
    },
    quantumOfCirculation: {
        description: "Quantum of circulation",
        examples: [
            "quantumOfCirculation"
        ]
    },
    rydberg: {
        description: "Rydberg constant",
        examples: [
            "rydberg"
        ]
    },
    thomsonCrossSection: {
        description: "Thomson cross section",
        examples: [
            "thomsonCrossSection"
        ]
    },
    weakMixingAngle: {
        description: "Weak mixing angle",
        examples: [
            "weakMixingAngle"
        ]
    },
    efimovFactor: {
        description: "Efimov factor",
        examples: [
            "efimovFactor"
        ]
    },
    atomicMass: {
        description: "Atomic mass constant",
        examples: [
            "atomicMass"
        ]
    },
    avogadro: {
        description: "Avogadro's number",
        examples: [
            "avogadro"
        ]
    },
    boltzmann: {
        description: "Boltzmann constant",
        examples: [
            "boltzmann"
        ]
    },
    faraday: {
        description: "Faraday constant",
        examples: [
            "faraday"
        ]
    },
    firstRadiation: {
        description: "First radiation constant",
        examples: [
            "firstRadiation"
        ]
    },
    loschmidt: {
        description: "Loschmidt constant at T=273.15 K and p=101.325 kPa",
        examples: [
            "loschmidt"
        ]
    },
    gasConstant: {
        description: "Gas constant",
        examples: [
            "gasConstant"
        ]
    },
    molarPlanckConstant: {
        description: "Molar Planck constant",
        examples: [
            "molarPlanckConstant"
        ]
    },
    molarVolume: {
        description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",
        examples: [
            "molarVolume"
        ]
    },
    sackurTetrode: {
        description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa",
        examples: [
            "sackurTetrode"
        ]
    },
    secondRadiation: {
        description: "Second radiation constant",
        examples: [
            "secondRadiation"
        ]
    },
    stefanBoltzmann: {
        description: "Stefan-Boltzmann constant",
        examples: [
            "stefanBoltzmann"
        ]
    },
    wienDisplacement: {
        description: "Wien displacement law constant",
        examples: [
            "wienDisplacement"
        ]
    },
    // spectralRadiance: {description: 'First radiation constant for spectral radiance', examples: ['spectralRadiance']},
    molarMass: {
        description: "Molar mass constant",
        examples: [
            "molarMass"
        ]
    },
    molarMassC12: {
        description: "Molar mass constant of carbon-12",
        examples: [
            "molarMassC12"
        ]
    },
    gravity: {
        description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)",
        examples: [
            "gravity"
        ]
    },
    planckLength: {
        description: "Planck length",
        examples: [
            "planckLength"
        ]
    },
    planckMass: {
        description: "Planck mass",
        examples: [
            "planckMass"
        ]
    },
    planckTime: {
        description: "Planck time",
        examples: [
            "planckTime"
        ]
    },
    planckCharge: {
        description: "Planck charge",
        examples: [
            "planckCharge"
        ]
    },
    planckTemperature: {
        description: "Planck temperature",
        examples: [
            "planckTemperature"
        ]
    },
    // functions - algebra
    derivative: (0, $23e896358f88f978$export$14d93412c4f1ed0d),
    lsolve: (0, $2583e28540492eb0$export$4bef5c6fa8c1f081),
    lsolveAll: (0, $98da7095cd128878$export$40bf697ca86bce02),
    lup: (0, $9926f970c9d73895$export$aa45954995260db7),
    lusolve: (0, $faaeaa061e2182f3$export$b24588d98e782136),
    leafCount: (0, $19e8c7d1f205e88a$export$a44548b5a791ce3a),
    polynomialRoot: (0, $55993951929a18a2$export$b8b5e00b23dec14b),
    resolve: (0, $66e1b0c55cea11f2$export$becee114188e4530),
    simplify: (0, $c95c1299a284c4b5$export$5a53589a8ff0d1cd),
    simplifyConstant: (0, $1e1659533c0e424b$export$f20b2f36e9c7150),
    simplifyCore: (0, $81c635434f523012$export$466a93707e1e5969),
    symbolicEqual: (0, $5ce5c54f33e18788$export$1ff0943310cb2f46),
    rationalize: (0, $9deb2fac63191f67$export$1802f015e36a313),
    slu: (0, $377e2d7bdcfece4e$export$a68dbefd846d8955),
    usolve: (0, $f5a376e60c81653b$export$2e45391f5cc49d1d),
    usolveAll: (0, $ede90181ca5a11fd$export$64b3b7af0d3d4548),
    qr: (0, $51397644d11732e4$export$717c61ebe37cce2a),
    // functions - arithmetic
    abs: (0, $85a78118ae6a85de$export$d21ec9cf3daa768b),
    add: (0, $316ab5d94c24e587$export$6fe0cea5d5e6ddba),
    cbrt: (0, $4b2658ab9232bf89$export$9330e90a8e7851e6),
    ceil: (0, $c37db8f09d02b0e2$export$bf625dbce78edf39),
    cube: (0, $949e091259dcb07e$export$ceabaa40b420fd2f),
    divide: (0, $6de4934ce8a4b9a7$export$e4cc3c6ddad47fb),
    dotDivide: (0, $7836ef51d4f16380$export$f1a6e1f6a311adf8),
    dotMultiply: (0, $ff6cdb59c011e496$export$4e72f4c646ece24a),
    dotPow: (0, $b637718c84ceae0a$export$db82d026e80f1871),
    exp: (0, $0a57934b07922479$export$e855e42434736fab),
    expm: (0, $f85961c75ad73b75$export$df3b4f2159ca23f5),
    expm1: (0, $3d687d930784404a$export$d6fb67f466ac866c),
    fix: (0, $2b78a6408c7e00c3$export$ec1a27fd93212099),
    floor: (0, $0c83b745632c4029$export$7eb1ac5a6cfbe8b6),
    gcd: (0, $059ac54e3b4cda17$export$ccc9190f6201c21e),
    hypot: (0, $06f5c3955a0e0fe7$export$53821d38c3eeff69),
    lcm: (0, $62c28fc5a8868094$export$371d4953326569cb),
    log: (0, $de5277fd82d6bd47$export$10fa3fadd260900f),
    log2: (0, $9c038207fcf4bd49$export$fa36f06e6e8bfb36),
    log1p: (0, $b2b92f458abcf0e0$export$5739f5d11cd187ac),
    log10: (0, $b68c5643d6bffeb5$export$a4c310b6d4346035),
    mod: (0, $ca1eca2f5b0ec20c$export$f9c7d95d1ec52e50),
    multiply: (0, $c68e21fdab9e122f$export$1506e47b2a5ae6da),
    norm: (0, $11ed400156458240$export$9745ccea7c23999),
    nthRoot: (0, $857a0b7dfb5d0d6a$export$6eeb5046d44da601),
    nthRoots: (0, $83d1c4cde44b9a1a$export$3d5c8967f6152f8f),
    pow: (0, $9a53b5f9de0ae95b$export$2d9619da64c2bdd4),
    round: (0, $4b5c242cc9907040$export$aaef6018d3e651c3),
    sign: (0, $82d8e4a5a66a8207$export$4190acef139a44f2),
    sqrt: (0, $d93be67d81914ab4$export$4c6bee88dcda7f24),
    sqrtm: (0, $8cd74a92de6808cf$export$f470c8ca9def7f14),
    square: (0, $6a7462dd0528c104$export$8aa8fe580e40693e),
    subtract: (0, $77eda33d2eff4c1d$export$435374265ca1b923),
    unaryMinus: (0, $43480989308a6fe2$export$4d94f3f25dc2600b),
    unaryPlus: (0, $06c2b184dde4f14b$export$e50639526da1c8e2),
    xgcd: (0, $bd6d75152d02eb73$export$82911c1a1d0407b8),
    invmod: (0, $b6efbef5866280f2$export$7d988771513789e5),
    // functions - bitwise
    bitAnd: (0, $cf0662a7312f667d$export$9809e2502d5f7c7c),
    bitNot: (0, $16dbd79d3d31a6ac$export$3d49fbbfcb05eb36),
    bitOr: (0, $7dcdac613b60685d$export$dc934370739527a8),
    bitXor: (0, $b5e4fb1c3f708c23$export$c5717818ea6d1c80),
    leftShift: (0, $57db96cd19388383$export$fb75ebd54811e095),
    rightArithShift: (0, $0a5aff9c5a222e02$export$180767993e37a793),
    rightLogShift: (0, $9f41930afb5a7a48$export$613695fe01bcb038),
    // functions - combinatorics
    bellNumbers: (0, $e2e0da5840b89ce2$export$f6a5bb92e66e375e),
    catalan: (0, $2ace6e16b46f54cf$export$b34ea8a080f60e3b),
    composition: (0, $77209587dfe71b21$export$7898728062a0cb7c),
    stirlingS2: (0, $66f555436450f091$export$46c34bdf03072170),
    // functions - core
    config: (0, $56bac2676b7788d8$export$ec99a334d8c9a14a),
    import: (0, $94e3b8f96924ea5b$export$5989ac4b02cf8057),
    typed: (0, $a630fffa746e3e8a$export$7adf399073101884),
    // functions - complex
    arg: (0, $48548ed49c7a69c2$export$eace15c6c3c286dc),
    conj: (0, $46a9b9f0b63724c5$export$e042ae5cfa3c3343),
    re: (0, $d35bc534caf5648f$export$f13699bc77b8ea67),
    im: (0, $4f2004d4396885cf$export$3476e22b3f658c7c),
    // functions - expression
    evaluate: (0, $694314b5c6c3bfbe$export$f32c54c70ddd9931),
    help: (0, $21d992ee5fb04230$export$e55ca8c24fbd3be8),
    // functions - geometry
    distance: (0, $716f334535c66be1$export$128b8878fdfb9e22),
    intersect: (0, $b33a4ddcae4ef84d$export$cf98256b70808117),
    // functions - logical
    and: (0, $3de479d340a161c0$export$20737fc9b0a3839c),
    not: (0, $4a82e49ca91fea3a$export$dfd4aa05f81041ff),
    or: (0, $592708e372ce31e9$export$2200bcb1a08f6f8d),
    xor: (0, $ab516528ed44ce68$export$dd9d665b8b14e2b2),
    // functions - matrix
    concat: (0, $9b398a59b0145bf8$export$2651d46c991329eb),
    count: (0, $3944837c2e53cfa6$export$f5ba6930b6adafd1),
    cross: (0, $312527754cbb4fc4$export$daf3380fde4ae39d),
    column: (0, $365393f6e912a48c$export$a5760461eff76999),
    ctranspose: (0, $8a8664eb6f21f204$export$f9de74ff268bebd9),
    det: (0, $82278869afa798b5$export$8730784260ee72c2),
    diag: (0, $d66f974d39798bc8$export$1c196182ad1e1777),
    diff: (0, $cbe9cb1b05092676$export$68cc1a794c4b923),
    dot: (0, $fb1ea007d7bce4d6$export$5fcedf26656436a1),
    getMatrixDataType: (0, $04f0159fb6d0f511$export$bd8d81afc6159d78),
    identity: (0, $c7e032fa7c752cd0$export$7fb92bf552f6842),
    filter: (0, $2ebf5eeb79f5c139$export$86d791908cc7fd0c),
    flatten: (0, $5f829c0ed9563c81$export$501e32649028a485),
    forEach: (0, $f68dbd4e605e2814$export$aa1ea88ef762ab5e),
    inv: (0, $0141498a26e9f6ad$export$d584490ba37af473),
    pinv: (0, $16931b16b31f1f93$export$11c117636228617d),
    eigs: (0, $f9d306cb265582a0$export$fb74125542bfdbb),
    kron: (0, $92e30bc0d2e07640$export$483111e0489c2571),
    matrixFromFunction: (0, $8e06bd5ed4362a93$export$979fb7b58dfbecb3),
    matrixFromRows: (0, $9eaee797a18c1771$export$99216cc634505607),
    matrixFromColumns: (0, $b0b181f55c733183$export$b34e4bfbf268d446),
    map: (0, $d735bfc60df20a83$export$212579151a971c0d),
    ones: (0, $82256620d5fcf8da$export$910fc795c37fb1b2),
    partitionSelect: (0, $28e409388c9eb229$export$65c28ab37b5158f2),
    range: (0, $6cc28bb2b382ffdb$export$f7c7d2df7253c271),
    resize: (0, $49d2ec512fc8129b$export$9444f970d5d871cc),
    reshape: (0, $2c2fa85a96e47dc8$export$f57c799cb449edab),
    rotate: (0, $9b2daebf325198c3$export$7e4afefc91c50a64),
    rotationMatrix: (0, $18c559d0cf9d7de1$export$95d0e442170bdedb),
    row: (0, $b96ad139c2ec7127$export$74b9786bafaa0a25),
    size: (0, $d40412d49432cbe2$export$5044182a5ddc46fd),
    sort: (0, $0c191261f304cae7$export$879539db0de7fe73),
    squeeze: (0, $2f37eac5ee5d69fb$export$84665209630d2bb0),
    subset: (0, $3a76af07c9482095$export$c809a1297fda8972),
    trace: (0, $71028f6f09d9dd22$export$46db08346422dd41),
    transpose: (0, $115494b0e3d44134$export$96fcaa3e48aec95b),
    zeros: (0, $426180724bef2495$export$d2794fce5915ba29),
    fft: (0, $583fc625e34dff90$export$3e6cafc8d17845c7),
    ifft: (0, $7064c54942afd807$export$d2931323ec07a3c0),
    sylvester: (0, $e10e74b260eaf413$export$e19046f098fe7be7),
    schur: (0, $dcf90e0087c1a6fd$export$2037e513e50c005d),
    lyap: (0, $d9e47ce70b1b3bd1$export$1203cb978ac2acd7),
    // functions - numeric
    solveODE: (0, $514e812226437c44$export$eb31de1eb82537e),
    // functions - probability
    combinations: (0, $81e67aa7586dc3c6$export$c3382240e69dd024),
    combinationsWithRep: (0, $2a7542d4f8d9d5f1$export$6bd2fb28e29d18e3),
    // distribution: distributionDocs,
    factorial: (0, $978ee862ec9440ef$export$3e6b0f8e2df12b9d),
    gamma: (0, $e30d09e89bc2fe9e$export$499ae9272b264120),
    kldivergence: (0, $f0f6810e3ff26c78$export$9f240af60ea686af),
    lgamma: (0, $737adace74f27ecb$export$b9351e80d68524a5),
    multinomial: (0, $f8bd3d561ec525aa$export$5f53cf42e3f9579d),
    permutations: (0, $f5e273227ad98bfe$export$eebb1076c4c85884),
    pickRandom: (0, $3304d744b908c47c$export$4a787d8dccbe181f),
    random: (0, $bab234f323771f92$export$d2b3cacd4d3219ec),
    randomInt: (0, $bb9b1539bf872f31$export$8e2c9b3226630e9d),
    // functions - relational
    compare: (0, $bb173759f884c356$export$b01f6c58c90dea20),
    compareNatural: (0, $b4c427985728823d$export$3d0415783a6e23a4),
    compareText: (0, $8c2d03da92c24473$export$f1ca5e1f3bd19e5d),
    deepEqual: (0, $25dad40f39b9e47e$export$b25f67ed715e775e),
    equal: (0, $5eac044a52d1edd6$export$5d5e6107045d826c),
    equalText: (0, $0bbc4b3fd372f745$export$9f17f53860452971),
    larger: (0, $3818f7a471103cc8$export$c775ecf5ac7366c3),
    largerEq: (0, $070158936ceff222$export$6ba4892ab98a938f),
    smaller: (0, $78dbdee238bed599$export$4ecf0efdd4fb906b),
    smallerEq: (0, $187ca300b90f178c$export$2693b3d153548453),
    unequal: (0, $cc46a37d4def43df$export$adade6432715c34e),
    // functions - set
    setCartesian: (0, $f0ef107b1b2066e8$export$6f06d74ab9e6fcad),
    setDifference: (0, $e570260a29ed4a2a$export$44337ef629295c55),
    setDistinct: (0, $aadae903d155118a$export$4c8f2f903562c625),
    setIntersect: (0, $c4bb45a5ad0f7df1$export$97fa484e42285777),
    setIsSubset: (0, $8921dcaf8b97c4ea$export$995337132a02fcf0),
    setMultiplicity: (0, $fdc35551166b9045$export$33972a95e247fd58),
    setPowerset: (0, $97a29c1690b47791$export$7040fb97e0f08a08),
    setSize: (0, $2874f47d986bbc8f$export$47ff1cdc99784c11),
    setSymDifference: (0, $653b075373b11918$export$340d6a7da02d62f3),
    setUnion: (0, $02ddf5298c7001c9$export$c6ab538723059178),
    // functions - signal
    zpk2tf: (0, $78ab532d951c56bf$export$ab6b87b59204b134),
    freqz: (0, $a43df4026c171298$export$e4067b8f2cf8b3a7),
    // functions - special
    erf: (0, $307e77d099acd64e$export$23984555c8f4e00a),
    zeta: (0, $69fd4902d552f9c1$export$f326627f77aa9768),
    // functions - statistics
    cumsum: (0, $00e7ff758a3d18e0$export$b230561799d1722c),
    mad: (0, $1704f378c7b0bb03$export$113a75651a4a72c6),
    max: (0, $99c68223fd1e31f0$export$f3fddd6eb2764aa6),
    mean: (0, $28d51b07edc7113e$export$1f7fad79151d4cc1),
    median: (0, $96d4307a2ee61417$export$dd1c97a64d85784b),
    min: (0, $c9d771206f9d85a7$export$17718e9907e3ac84),
    mode: (0, $20fec8350969f89b$export$30b601fd0273be74),
    prod: (0, $fa24ff617ac9ab9e$export$524cc5e521f0e533),
    quantileSeq: (0, $af56becd76cf4368$export$f80c87524ae9a59f),
    std: (0, $6926e4629e064d2e$export$d1c23b21300d0eb8),
    sum: (0, $bee08c970a80b9f3$export$cd6065b38df4efb0),
    variance: (0, $bfe40c8be78a4e94$export$5a58a225f78b347f),
    corr: (0, $0a09bd42d5284d52$export$7d36823afee68b24),
    // functions - trigonometry
    acos: (0, $cce6d11ecdd1a138$export$a96a9170bca705dc),
    acosh: (0, $d42a56b3d04395cc$export$eb8f1b26819009ca),
    acot: (0, $5054961e83453235$export$5df2d36103c3facc),
    acoth: (0, $5505166916234fe3$export$b7d7f2d7d0d4ec7d),
    acsc: (0, $a164f7f9f68c0fd3$export$911b51cd6a7612a8),
    acsch: (0, $957130e6983394ea$export$319c6d631e591850),
    asec: (0, $8a3601e531e4985d$export$fbe1d815e0591494),
    asech: (0, $f2d2b3bad4745e73$export$52f8b22e9936e0e),
    asin: (0, $bb16ed338a95c7c6$export$b85b8db6e8a2ed3d),
    asinh: (0, $aa39408d1f42a459$export$afe7a3b04750ebb7),
    atan: (0, $d5ebb57e41970d89$export$80066e40c56154f0),
    atanh: (0, $ecb49a480e5d3c52$export$e5bbdb9caa9a8f09),
    atan2: (0, $da3f11feea190a41$export$e4fc5308b4910337),
    cos: (0, $b7b89f6f8494a9f1$export$1a1af52900b6c58e),
    cosh: (0, $daba36d8932d481f$export$5af2bed23001ffc5),
    cot: (0, $e1687223c1838a8d$export$b6bae004c5b418ef),
    coth: (0, $d63f9ad71c0f2efd$export$7cd2898db0b732d0),
    csc: (0, $0650e3a98cdc4f48$export$1be2e18f41ba39dc),
    csch: (0, $9bfa409a092ec036$export$8baf7f6e609495d8),
    sec: (0, $73ff10f1b82b7134$export$3dae56ab28d48626),
    sech: (0, $c170ac5e0e36a797$export$6da75bc9afc8303b),
    sin: (0, $8ea6043e850f149e$export$c7700d6ff32b1413),
    sinh: (0, $7406ce9e47e8165e$export$e07b4c62bc488091),
    tan: (0, $394287381ebd5be9$export$14fc997d4768f36a),
    tanh: (0, $1128286b7e522bd9$export$52a5c54b85f75620),
    // functions - units
    to: (0, $e4a3d5dd2193e0c4$export$c532fecb2dfa6274),
    // functions - utils
    clone: (0, $bf6500baef10138f$export$500c01a79e32a1ad),
    format: (0, $5f0b803045d7ceb0$export$278425b4fe1ff1bf),
    bin: (0, $649f02345ce6fca1$export$9859a5b8f644d8ff),
    oct: (0, $62ca1db7b2a0a5fa$export$669461bdc241fd13),
    hex: (0, $46a1f32bfdfe77fb$export$81a08b4e66fc3038),
    isNaN: (0, $b2467bf5e8721fcc$export$f4e7c51d549c187f),
    isInteger: (0, $4f6b2035a77755f2$export$1d8b51b394bbccdc),
    isNegative: (0, $ee960ed1e649f01c$export$f94a800b9b237f17),
    isNumeric: (0, $2ccc991b7eadbc0a$export$7ac3927ed17fe2b6),
    hasNumericValue: (0, $00e2f8731573a15b$export$9d10d68d9b7d7a67),
    isPositive: (0, $ad1a5039438f9526$export$338f53b321c261b9),
    isPrime: (0, $bce15bcc97eef83b$export$d6ada432c5e7d9c7),
    isZero: (0, $cb48c726517b1f12$export$52c03b663dd15fa3),
    print: (0, $a393a69f0deb107d$export$e3b3b470cfab492d),
    typeOf: (0, $b69e74134876a4c1$export$5b193b71b9b497e6),
    numeric: (0, $1b5cd085ae6a7b75$export$d275ce05039a5f7a)
};



var $b802e3b500458322$var$name = "help";
var $b802e3b500458322$var$dependencies = [
    "typed",
    "mathWithTransform",
    "Help"
];
var $b802e3b500458322$export$cbe80567b8b3b8ac = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($b802e3b500458322$var$name, $b802e3b500458322$var$dependencies, (_ref)=>{
    var { typed: typed, mathWithTransform: mathWithTransform, Help: Help } = _ref;
    /**
   * Retrieve help on a function or data type.
   * Help files are retrieved from the embedded documentation in math.docs.
   *
   * Syntax:
   *
   *    math.help(search)
   *
   * Examples:
   *
   *    console.log(math.help('sin').toString())
   *    console.log(math.help(math.add).toString())
   *    console.log(math.help(math.add).toJSON())
   *
   * @param {Function | string | Object} search   A function or function name
   *                                              for which to get help
   * @return {Help} A help object
   */ return typed($b802e3b500458322$var$name, {
        any: function any(search) {
            var prop;
            var searchName = search;
            if (typeof search !== "string") {
                for(prop in mathWithTransform)// search in functions and constants
                if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(mathWithTransform, prop) && search === mathWithTransform[prop]) {
                    searchName = prop;
                    break;
                }
            /* TODO: implement help for data types
         if (!text) {
         // search data type
         for (prop in math.type) {
         if (hasOwnProperty(math, prop)) {
         if (search === math.type[prop]) {
         text = prop
         break
         }
         }
         }
         }
         */ }
            var doc = (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)((0, $7218f41f830f83ad$export$c2adf0a3344c85c9), searchName);
            if (!doc) {
                var searchText = typeof searchName === "function" ? searchName.name : searchName;
                throw new Error('No documentation found on "' + searchText + '"');
            }
            return new Help(doc);
        }
    });
});





var $bf30539058880d96$var$name = "Help";
var $bf30539058880d96$var$dependencies = [
    "evaluate"
];
var $bf30539058880d96$export$704346eb22eef29 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($bf30539058880d96$var$name, $bf30539058880d96$var$dependencies, (_ref)=>{
    var { evaluate: evaluate } = _ref;
    /**
   * Documentation object
   * @param {Object} doc  Object containing properties:
   *                      {string} name
   *                      {string} category
   *                      {string} description
   *                      {string[]} syntax
   *                      {string[]} examples
   *                      {string[]} seealso
   * @constructor
   */ function Help(doc) {
        if (!(this instanceof Help)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!doc) throw new Error('Argument "doc" missing');
        this.doc = doc;
    }
    /**
   * Attach type information
   */ Help.prototype.type = "Help";
    Help.prototype.isHelp = true;
    /**
   * Generate a string representation of the Help object
   * @return {string} Returns a string
   * @private
   */ Help.prototype.toString = function() {
        var doc = this.doc || {};
        var desc = "\n";
        if (doc.name) desc += "Name: " + doc.name + "\n\n";
        if (doc.category) desc += "Category: " + doc.category + "\n\n";
        if (doc.description) desc += "Description:\n    " + doc.description + "\n\n";
        if (doc.syntax) desc += "Syntax:\n    " + doc.syntax.join("\n    ") + "\n\n";
        if (doc.examples) {
            desc += "Examples:\n";
            // after evaluating the examples, we restore config in case the examples
            // did change the config.
            var configChanged = false;
            var originalConfig = evaluate("config()");
            var scope = {
                config: (newConfig)=>{
                    configChanged = true;
                    return evaluate("config(newConfig)", {
                        newConfig: newConfig
                    });
                }
            };
            for(var i = 0; i < doc.examples.length; i++){
                var expr = doc.examples[i];
                desc += "    " + expr + "\n";
                var res = void 0;
                try {
                    // note: res can be undefined when `expr` is an empty string
                    res = evaluate(expr, scope);
                } catch (e) {
                    res = e;
                }
                if (res !== undefined && !(0, $23cfe017d190638f$export$e5dec9a75b602d6c)(res)) desc += "        " + (0, $1b038b7ade911d0e$export$d9468344d3651243)(res, {
                    precision: 14
                }) + "\n";
            }
            desc += "\n";
            if (configChanged) evaluate("config(originalConfig)", {
                originalConfig: originalConfig
            });
        }
        if (doc.mayThrow && doc.mayThrow.length) desc += "Throws: " + doc.mayThrow.join(", ") + "\n\n";
        if (doc.seealso && doc.seealso.length) desc += "See also: " + doc.seealso.join(", ") + "\n";
        return desc;
    };
    /**
   * Export the help object to JSON
   */ Help.prototype.toJSON = function() {
        var obj = (0, $46a94b3d1146edd8$export$9cd59f9826255e47)(this.doc);
        obj.mathjs = "Help";
        return obj;
    };
    /**
   * Instantiate a Help object from a JSON object
   * @param {Object} json
   * @returns {Help} Returns a new Help object
   */ Help.fromJSON = function(json) {
        var doc = {};
        Object.keys(json).filter((prop)=>prop !== "mathjs").forEach((prop)=>{
            doc[prop] = json[prop];
        });
        return new Help(doc);
    };
    /**
   * Returns a string representation of the Help object
   */ Help.prototype.valueOf = Help.prototype.toString;
    return Help;
}, {
    isClass: true
});







var $8058fec22ef027de$var$name = "IndexNode";
var $8058fec22ef027de$var$dependencies = [
    "Node",
    "size"
];
var $8058fec22ef027de$export$883b7fdc0499e9f0 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($8058fec22ef027de$var$name, $8058fec22ef027de$var$dependencies, (_ref)=>{
    var { Node: Node, size: size } = _ref;
    class IndexNode extends Node {
        get type() {
            return $8058fec22ef027de$var$name;
        }
        get isIndexNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            // TODO: implement support for bignumber (currently bignumbers are silently
            //       reduced to numbers when changing the value to zero-based)
            // TODO: Optimization: when the range values are ConstantNodes,
            //       we can beforehand resolve the zero-based value
            // optimization for a simple object property
            var evalDimensions = (0, $eee21df0c3527ff1$export$871de8747c9eaa88)(this.dimensions, function(dimension, i) {
                var needsEnd = dimension.filter((node)=>node.isSymbolNode && node.name === "end").length > 0;
                if (needsEnd) {
                    // SymbolNode 'end' is used inside the index,
                    // like in `A[end]` or `A[end - 2]`
                    var childArgNames = Object.create(argNames);
                    childArgNames.end = true;
                    var _evalDimension = dimension._compile(math, childArgNames);
                    return function evalDimension(scope, args, context) {
                        if (!(0, $23cfe017d190638f$export$b22160e0a14f87b7)(context) && !(0, $23cfe017d190638f$export$43bee75e5e14138e)(context) && !(0, $23cfe017d190638f$export$844ec244b1367d54)(context)) throw new TypeError('Cannot resolve "end": context must be a Matrix, Array, or string but is ' + (0, $23cfe017d190638f$export$f5bbd400c2f4426f)(context));
                        var s = size(context).valueOf();
                        var childArgs = Object.create(args);
                        childArgs.end = s[i];
                        return _evalDimension(scope, childArgs, context);
                    };
                } else // SymbolNode `end` not used
                return dimension._compile(math, argNames);
            });
            var index = (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(math, "index");
            return function evalIndexNode(scope, args, context) {
                var dimensions = (0, $eee21df0c3527ff1$export$871de8747c9eaa88)(evalDimensions, function(evalDimension) {
                    return evalDimension(scope, args, context);
                });
                return index(...dimensions);
            };
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            for(var i = 0; i < this.dimensions.length; i++)callback(this.dimensions[i], "dimensions[" + i + "]", this);
        }
        /**
     * Create a new IndexNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {IndexNode} Returns a transformed copy of the node
     */ map(callback) {
            var dimensions = [];
            for(var i = 0; i < this.dimensions.length; i++)dimensions[i] = this._ifNode(callback(this.dimensions[i], "dimensions[" + i + "]", this));
            return new IndexNode(dimensions, this.dotNotation);
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {IndexNode}
     */ clone() {
            return new IndexNode(this.dimensions.slice(0), this.dotNotation);
        }
        /**
     * Test whether this IndexNode contains a single property name
     * @return {boolean}
     */ isObjectProperty() {
            return this.dimensions.length === 1 && (0, $23cfe017d190638f$export$fa9d80731fd8c54b)(this.dimensions[0]) && typeof this.dimensions[0].value === "string";
        }
        /**
     * Returns the property name if IndexNode contains a property.
     * If not, returns null.
     * @return {string | null}
     */ getObjectProperty() {
            return this.isObjectProperty() ? this.dimensions[0].value : null;
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */ _toString(options) {
            // format the parameters like "[1, 0:5]"
            return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $8058fec22ef027de$var$name,
                dimensions: this.dimensions,
                dotNotation: this.dotNotation
            };
        }
        /**
     * Instantiate an IndexNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "IndexNode", dimensions: [...], dotNotation: false}`,
     *     where mathjs is optional
     * @returns {IndexNode}
     */ static fromJSON(json) {
            return new IndexNode(json.dimensions, json.dotNotation);
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */ _toHTML(options) {
            // format the parameters like "[1, 0:5]"
            var dimensions = [];
            for(var i = 0; i < this.dimensions.length; i++)dimensions[i] = this.dimensions[i].toHTML();
            if (this.dotNotation) return '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(this.getObjectProperty()) + "</span>";
            else return '<span class="math-parenthesis math-square-parenthesis">[</span>' + dimensions.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */ _toTex(options) {
            var dimensions = this.dimensions.map(function(range) {
                return range.toTex(options);
            });
            return this.dotNotation ? "." + this.getObjectProperty() + "" : "_{" + dimensions.join(",") + "}";
        }
        /**
     * @constructor IndexNode
     * @extends Node
     *
     * Describes a subset of a matrix or an object property.
     * Cannot be used on its own, needs to be used within an AccessorNode or
     * AssignmentNode.
     *
     * @param {Node[]} dimensions
     * @param {boolean} [dotNotation=false]
     *     Optional property describing whether this index was written using dot
     *     notation like `a.b`, or using bracket notation like `a["b"]`
     *     (which is the default). This property is used for string conversion.
     */ constructor(dimensions, dotNotation){
            super();
            this.dimensions = dimensions;
            this.dotNotation = dotNotation || false;
            // validate input
            if (!Array.isArray(dimensions) || !dimensions.every((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee))) throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
            if (this.dotNotation && !this.isObjectProperty()) throw new Error("dotNotation only applicable for object properties");
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(IndexNode, "name", $8058fec22ef027de$var$name);
    return IndexNode;
}, {
    isClass: true,
    isNode: true
});



var $f0c30b6863882d36$var$name = "index";
var $f0c30b6863882d36$var$dependencies = [
    "Index",
    "getMatrixDataType"
];
var $f0c30b6863882d36$export$f20e87a60dbfc89e = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($f0c30b6863882d36$var$name, $f0c30b6863882d36$var$dependencies, (_ref)=>{
    var { Index: Index, getMatrixDataType: getMatrixDataType } = _ref;
    /**
   * Attach a transform function to math.index
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ return function indexTransform() {
        var args = [];
        for(var i = 0, ii = arguments.length; i < ii; i++){
            var arg = arguments[i];
            // change from one-based to zero based, convert BigNumber to number and leave Array of Booleans as is
            if ((0, $23cfe017d190638f$export$e331ccfa6f694c99)(arg)) {
                arg.start--;
                arg.end -= arg.step > 0 ? 0 : 2;
            } else if (arg && arg.isSet === true) arg = arg.map(function(v) {
                return v - 1;
            });
            else if ((0, $23cfe017d190638f$export$43bee75e5e14138e)(arg) || (0, $23cfe017d190638f$export$b22160e0a14f87b7)(arg)) {
                if (getMatrixDataType(arg) !== "boolean") arg = arg.map(function(v) {
                    return v - 1;
                });
            } else if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(arg)) arg--;
            else if ((0, $23cfe017d190638f$export$e51d0e7e5c4a03ab)(arg)) arg = arg.toNumber() - 1;
            else if (typeof arg === "string") ;
            else throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
            args[i] = arg;
        }
        var res = new Index();
        Index.apply(res, args);
        return res;
    };
}, {
    isTransformFunction: true
});


var $a921f5472e44b7b2$var$name = "leafCount";
var $a921f5472e44b7b2$var$dependencies = [
    "parse",
    "typed"
];
var $a921f5472e44b7b2$export$38658a33c7766170 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a921f5472e44b7b2$var$name, $a921f5472e44b7b2$var$dependencies, (_ref)=>{
    var { parse: parse, typed: typed } = _ref;
    // This does the real work, but we don't have to recurse through
    // a typed call if we separate it out
    function countLeaves(node) {
        var count = 0;
        node.forEach((n)=>{
            count += countLeaves(n);
        });
        return count || 1;
    }
    /**
   * Gives the number of "leaf nodes" in the parse tree of the given expression
   * A leaf node is one that has no subexpressions, essentially either a
   * symbol or a constant. Note that `5!` has just one leaf, the '5'; the
   * unary factorial operator does not add a leaf. On the other hand,
   * function symbols do add leaves, so `sin(x)/cos(x)` has four leaves.
   *
   * The `simplify()` function should generally not increase the `leafCount()`
   * of an expression, although currently there is no guarantee that it never
   * does so. In many cases, `simplify()` reduces the leaf count.
   *
   * Syntax:
   *
   *     math.leafCount(expr)
   *
   * Examples:
   *
   *     math.leafCount('x') // 1
   *     math.leafCount(math.parse('a*d-b*c')) // 4
   *     math.leafCount('[a,b;c,d][0,1]') // 6
   *
   * See also:
   *
   *     simplify
   *
   * @param {Node|string} expr    The expression to count the leaves of
   *
   * @return {number}  The number of leaves of `expr`
   *
   */ return typed($a921f5472e44b7b2$var$name, {
        Node: function Node(expr) {
            return countLeaves(expr);
        }
    });
});






var $9e9793b56cfe2208$var$name = "map";
var $9e9793b56cfe2208$var$dependencies = [
    "typed"
];
var $9e9793b56cfe2208$export$5ae33143d676d4d4 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9e9793b56cfe2208$var$name, $9e9793b56cfe2208$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Attach a transform function to math.map
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */ function mapTransform(args, math, scope) {
        var x, callback;
        if (args[0]) x = args[0].compile().evaluate(scope);
        if (args[1]) {
            if ((0, $23cfe017d190638f$export$87815d550facaed9)(args[1]) || (0, $23cfe017d190638f$export$27c05cfffd263d30)(args[1])) // a function pointer, like filter([3, -2, 5], myTestFunction)
            callback = args[1].compile().evaluate(scope);
            else // an expression like filter([3, -2, 5], x > 0)
            callback = (0, $2865fa308ee8113b$export$cbb6101da03c2e83)(args[1], math, scope);
        }
        return map(x, callback);
    }
    mapTransform.rawArgs = true;
    // one-based version of map function
    var map = typed("map", {
        "Array, function": function ArrayFunction(x, callback) {
            return $9e9793b56cfe2208$var$_map(x, callback, x);
        },
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.create($9e9793b56cfe2208$var$_map(x.valueOf(), callback, x));
        }
    });
    return mapTransform;
}, {
    isTransformFunction: true
});
/**
 * Map for a multidimensional array. One-based indexes
 * @param {Array} array
 * @param {function} callback
 * @param {Array} orig
 * @return {Array}
 * @private
 */ function $9e9793b56cfe2208$var$_map(array, callback, orig) {
    function recurse(value, index) {
        if (Array.isArray(value)) return (0, $eee21df0c3527ff1$export$871de8747c9eaa88)(value, function(child, i) {
            // we create a copy of the index array and append the new index value
            return recurse(child, index.concat(i + 1)); // one based index, hence i + 1
        });
        else // invoke the (typed) callback function with the right number of arguments
        return (0, $1427f34fc9a7e1b3$export$c081893a7ce04a4c)(callback, value, index, orig, "map");
    }
    return recurse(array, []);
}





var $c2d39629260f7044$var$name = "max";
var $c2d39629260f7044$var$dependencies = [
    "typed",
    "config",
    "numeric",
    "larger"
];
var $c2d39629260f7044$export$cb806a795cec8077 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c2d39629260f7044$var$name, $c2d39629260f7044$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, larger: larger } = _ref;
    var max = (0, $3c6c9bc5ad48e278$export$b18a1b0c26c000ee)({
        typed: typed,
        config: config,
        numeric: numeric,
        larger: larger
    });
    /**
   * Attach a transform function to math.max
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function max
   * from one-based to zero based
   */ return typed("max", {
        "...any": function any(args) {
            args = (0, $43b0d4e2cc26d017$export$75974926bb7e1bd6)(args);
            try {
                return max.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});





var $fca18124272cdcac$var$name = "mean";
var $fca18124272cdcac$var$dependencies = [
    "typed",
    "add",
    "divide"
];
var $fca18124272cdcac$export$caaba12fb8f94b67 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($fca18124272cdcac$var$name, $fca18124272cdcac$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide } = _ref;
    var mean = (0, $12c6138c58f8eae0$export$301ef7ca1de6782c)({
        typed: typed,
        add: add,
        divide: divide
    });
    /**
   * Attach a transform function to math.mean
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function mean
   * from one-based to zero based
   */ return typed("mean", {
        "...any": function any(args) {
            args = (0, $43b0d4e2cc26d017$export$75974926bb7e1bd6)(args);
            try {
                return mean.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});





var $86d37de1ab9e5b6c$var$name = "min";
var $86d37de1ab9e5b6c$var$dependencies = [
    "typed",
    "config",
    "numeric",
    "smaller"
];
var $86d37de1ab9e5b6c$export$e6239917a808c35d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($86d37de1ab9e5b6c$var$name, $86d37de1ab9e5b6c$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, smaller: smaller } = _ref;
    var min = (0, $12a6ba5b1a83f142$export$b795f47e2b99170)({
        typed: typed,
        config: config,
        numeric: numeric,
        smaller: smaller
    });
    /**
   * Attach a transform function to math.min
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function min
   * from one-based to zero based
   */ return typed("min", {
        "...any": function any(args) {
            args = (0, $43b0d4e2cc26d017$export$75974926bb7e1bd6)(args);
            try {
                return min.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});






var $715716079f2326b7$var$name = "Node";
var $715716079f2326b7$var$dependencies = [
    "mathWithTransform"
];
var $715716079f2326b7$export$270e7ba5936d3c48 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($715716079f2326b7$var$name, $715716079f2326b7$var$dependencies, (_ref)=>{
    var { mathWithTransform: mathWithTransform } = _ref;
    /**
   * Validate the symbol names of a scope.
   * Throws an error when the scope contains an illegal symbol.
   * @param {Object} scope
   */ function _validateScope(scope) {
        for (var symbol of [
            ...(0, $cd3ff6322acd5c08$export$eebaaf2b24d91f63)
        ]){
            if (scope.has(symbol)) throw new Error('Scope contains an illegal symbol, "' + symbol + '" is a reserved keyword');
        }
    }
    class Node {
        get type() {
            return "Node";
        }
        get isNode() {
            return true;
        }
        /**
     * Evaluate the node
     * @param {Object} [scope]  Scope to read/write variables
     * @return {*}              Returns the result
     */ evaluate(scope) {
            return this.compile().evaluate(scope);
        }
        /**
     * Compile the node into an optimized, evauatable JavaScript function
     * @return {{evaluate: function([Object])}} object
     *                Returns an object with a function 'evaluate',
     *                which can be invoked as expr.evaluate([scope: Object]),
     *                where scope is an optional object with
     *                variables.
     */ compile() {
            var expr = this._compile(mathWithTransform, {});
            var args = {};
            var context = null;
            function evaluate(scope) {
                var s = (0, $ec715b2ae25daaa7$export$d49c9aa30b771d59)(scope);
                _validateScope(s);
                return expr(s, args, context);
            }
            return {
                evaluate: evaluate
            };
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            throw new Error("Method _compile must be implemented by type " + this.type);
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            // must be implemented by each of the Node implementations
            throw new Error("Cannot run forEach on a Node interface");
        }
        /**
     * Create a new Node whose children are the results of calling the
     * provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {OperatorNode} Returns a transformed copy of the node
     */ map(callback) {
            // must be implemented by each of the Node implementations
            throw new Error("Cannot run map on a Node interface");
        }
        /**
     * Validate whether an object is a Node, for use with map
     * @param {Node} node
     * @returns {Node} Returns the input if it's a node, else throws an Error
     * @protected
     */ _ifNode(node) {
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(node)) throw new TypeError("Callback function must return a Node");
            return node;
        }
        /**
     * Recursively traverse all nodes in a node tree. Executes given callback for
     * this node and each of its child nodes.
     * @param {function(node: Node, path: string, parent: Node)} callback
     *          A callback called for every node in the node tree.
     */ traverse(callback) {
            // execute callback for itself
            // eslint-disable-next-line
            callback(this, null, null);
            // recursively traverse over all children of a node
            function _traverse(node, callback) {
                node.forEach(function(child, path, parent) {
                    callback(child, path, parent);
                    _traverse(child, callback);
                });
            }
            _traverse(this, callback);
        }
        /**
     * Recursively transform a node tree via a transform function.
     *
     * For example, to replace all nodes of type SymbolNode having name 'x' with
     * a ConstantNode with value 2:
     *
     *     const res = Node.transform(function (node, path, parent) {
     *       if (node && node.isSymbolNode) && (node.name === 'x')) {
     *         return new ConstantNode(2)
     *       }
     *       else {
     *         return node
     *       }
     *     })
     *
     * @param {function(node: Node, path: string, parent: Node) : Node} callback
     *          A mapping function accepting a node, and returning
     *          a replacement for the node or the original node. The "signature"
     *          of the callback must be:
     *          callback(node: Node, index: string, parent: Node) : Node
     * @return {Node} Returns the original node or its replacement
     */ transform(callback) {
            function _transform(child, path, parent) {
                var replacement = callback(child, path, parent);
                if (replacement !== child) // stop iterating when the node is replaced
                return replacement;
                return child.map(_transform);
            }
            return _transform(this, null, null);
        }
        /**
     * Find any node in the node tree matching given filter function. For
     * example, to find all nodes of type SymbolNode having name 'x':
     *
     *     const results = Node.filter(function (node) {
     *       return (node && node.isSymbolNode) && (node.name === 'x')
     *     })
     *
     * @param {function(node: Node, path: string, parent: Node) : Node} callback
     *            A test function returning true when a node matches, and false
     *            otherwise. Function signature:
     *            callback(node: Node, index: string, parent: Node) : boolean
     * @return {Node[]} nodes
     *            An array with nodes matching given filter criteria
     */ filter(callback) {
            var nodes = [];
            this.traverse(function(node, path, parent) {
                if (callback(node, path, parent)) nodes.push(node);
            });
            return nodes;
        }
        /**
     * Create a shallow clone of this node
     * @return {Node}
     */ clone() {
            // must be implemented by each of the Node implementations
            throw new Error("Cannot clone a Node interface");
        }
        /**
     * Create a deep clone of this node
     * @return {Node}
     */ cloneDeep() {
            return this.map(function(node) {
                return node.cloneDeep();
            });
        }
        /**
     * Deep compare this node with another node.
     * @param {Node} other
     * @return {boolean} Returns true when both nodes are of the same type and
     *                   contain the same values (as do their childs)
     */ equals(other) {
            return other ? this.type === other.type && (0, $46a94b3d1146edd8$export$6cc798251952180)(this, other) : false;
        }
        /**
     * Get string representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)"or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */ toString(options) {
            var customString = this._getCustomString(options);
            if (typeof customString !== "undefined") return customString;
            return this._toString(options);
        }
        /**
     * Internal function to generate the string output.
     * This has to be implemented by every Node
     *
     * @throws {Error}
     */ _toString() {
            // must be implemented by each of the Node implementations
            throw new Error("_toString not implemented for " + this.type);
        }
        /**
     * Get a JSON representation of the node
     * Both .toJSON() and the static .fromJSON(json) should be implemented by all
     * implementations of Node
     * @returns {Object}
     */ toJSON() {
            throw new Error("Cannot serialize object: toJSON not implemented by " + this.type);
        }
        /**
     * Get HTML representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)" or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */ toHTML(options) {
            var customString = this._getCustomString(options);
            if (typeof customString !== "undefined") return customString;
            return this._toHTML(options);
        }
        /**
     * Internal function to generate the HTML output.
     * This has to be implemented by every Node
     *
     * @throws {Error}
     */ _toHTML() {
            // must be implemented by each of the Node implementations
            throw new Error("_toHTML not implemented for " + this.type);
        }
        /**
     * Get LaTeX representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)"or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */ toTex(options) {
            var customString = this._getCustomString(options);
            if (typeof customString !== "undefined") return customString;
            return this._toTex(options);
        }
        /**
     * Internal function to generate the LaTeX output.
     * This has to be implemented by every Node
     *
     * @param {Object} [options]
     * @throws {Error}
     */ _toTex(options) {
            // must be implemented by each of the Node implementations
            throw new Error("_toTex not implemented for " + this.type);
        }
        /**
     * Helper used by `to...` functions.
     */ _getCustomString(options) {
            if (options && typeof options === "object") switch(typeof options.handler){
                case "object":
                case "undefined":
                    return;
                case "function":
                    return options.handler(this, options);
                default:
                    throw new TypeError("Object or function expected as callback");
            }
        }
        /**
     * Get identifier.
     * @return {string}
     */ getIdentifier() {
            return this.type;
        }
        /**
     * Get the content of the current Node.
     * @return {Node} node
     **/ getContent() {
            return this;
        }
    }
    return Node;
}, {
    isClass: true,
    isNode: true
});







var $3166ae3469ea536e$var$name = "ObjectNode";
var $3166ae3469ea536e$var$dependencies = [
    "Node"
];
var $3166ae3469ea536e$export$385a7f4e27f173c4 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3166ae3469ea536e$var$name, $3166ae3469ea536e$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    class ObjectNode extends Node {
        get type() {
            return $3166ae3469ea536e$var$name;
        }
        get isObjectNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            var evalEntries = {};
            for(var key in this.properties)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(this.properties, key)) {
                // we stringify/parse the key here to resolve unicode characters,
                // so you cannot create a key like {"co\\u006Estructor": null}
                var stringifiedKey = (0, $1b038b7ade911d0e$export$fac44ee5b035f737)(key);
                var parsedKey = JSON.parse(stringifiedKey);
                var prop = (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(this.properties, key);
                evalEntries[parsedKey] = prop._compile(math, argNames);
            }
            return function evalObjectNode(scope, args, context) {
                var obj = {};
                for(var _key in evalEntries)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(evalEntries, _key)) obj[_key] = evalEntries[_key](scope, args, context);
                return obj;
            };
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            for(var key in this.properties)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(this.properties, key)) callback(this.properties[key], "properties[" + (0, $1b038b7ade911d0e$export$fac44ee5b035f737)(key) + "]", this);
        }
        /**
     * Create a new ObjectNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ObjectNode} Returns a transformed copy of the node
     */ map(callback) {
            var properties = {};
            for(var key in this.properties)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(this.properties, key)) properties[key] = this._ifNode(callback(this.properties[key], "properties[" + (0, $1b038b7ade911d0e$export$fac44ee5b035f737)(key) + "]", this));
            return new ObjectNode(properties);
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {ObjectNode}
     */ clone() {
            var properties = {};
            for(var key in this.properties)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(this.properties, key)) properties[key] = this.properties[key];
            return new ObjectNode(properties);
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toString(options) {
            var entries = [];
            for(var key in this.properties)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(this.properties, key)) entries.push((0, $1b038b7ade911d0e$export$fac44ee5b035f737)(key) + ": " + this.properties[key].toString(options));
            return "{" + entries.join(", ") + "}";
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $3166ae3469ea536e$var$name,
                properties: this.properties
            };
        }
        /**
     * Instantiate an OperatorNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ObjectNode", "properties": {...}}`,
     *                       where mathjs is optional
     * @returns {ObjectNode}
     */ static fromJSON(json) {
            return new ObjectNode(json.properties);
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toHTML(options) {
            var entries = [];
            for(var key in this.properties)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(this.properties, key)) entries.push('<span class="math-symbol math-property">' + (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(key) + "</span>" + '<span class="math-operator math-assignment-operator ' + 'math-property-assignment-operator math-binary-operator">' + ":</span>" + this.properties[key].toHTML(options));
            return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + entries.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */ _toTex(options) {
            var entries = [];
            for(var key in this.properties)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(this.properties, key)) entries.push("\\mathbf{" + key + ":} & " + this.properties[key].toTex(options) + "\\\\");
            var tex = "\\left\\{\\begin{array}{ll}" + entries.join("\n") + "\\end{array}\\right\\}";
            return tex;
        }
        /**
     * @constructor ObjectNode
     * @extends {Node}
     * Holds an object with keys/values
     * @param {Object.<string, Node>} [properties]   object with key/value pairs
     */ constructor(properties){
            super();
            this.properties = properties || {};
            // validate input
            if (properties) {
                if (!(typeof properties === "object") || !Object.keys(properties).every(function(key) {
                    return (0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(properties[key]);
                })) throw new TypeError("Object containing Nodes expected");
            }
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(ObjectNode, "name", $3166ae3469ea536e$var$name);
    return ObjectNode;
}, {
    isClass: true,
    isNode: true
});










var $8867bbe30748af52$var$name = "OperatorNode";
var $8867bbe30748af52$var$dependencies = [
    "Node"
];
var $8867bbe30748af52$export$aa95756bacab93d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($8867bbe30748af52$var$name, $8867bbe30748af52$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    /**
   * Returns true if the expression starts with a constant, under
   * the current parenthesization:
   * @param {Node} expression
   * @param {string} parenthesis
   * @return {boolean}
   */ function startsWithConstant(expr, parenthesis) {
        var curNode = expr;
        if (parenthesis === "auto") while((0, $23cfe017d190638f$export$c55e3736c5721220)(curNode))curNode = curNode.content;
        if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(curNode)) return true;
        if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(curNode)) return startsWithConstant(curNode.args[0], parenthesis);
        return false;
    }
    /**
   * Calculate which parentheses are necessary. Gets an OperatorNode
   * (which is the root of the tree) and an Array of Nodes
   * (this.args) and returns an array where 'true' means that an argument
   * has to be enclosed in parentheses whereas 'false' means the opposite.
   *
   * @param {OperatorNode} root
   * @param {string} parenthesis
   * @param {Node[]} args
   * @param {boolean} latex
   * @return {boolean[]}
   * @private
   */ function calculateNecessaryParentheses(root, parenthesis, implicit, args, latex) {
        // precedence of the root OperatorNode
        var precedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(root, parenthesis, implicit);
        var associativity = (0, $c57e483ac23cf50e$export$8a3de49886b85474)(root, parenthesis);
        if (parenthesis === "all" || args.length > 2 && root.getIdentifier() !== "OperatorNode:add" && root.getIdentifier() !== "OperatorNode:multiply") return args.map(function(arg) {
            switch(arg.getContent().type){
                // Nodes that don't need extra parentheses
                case "ArrayNode":
                case "ConstantNode":
                case "SymbolNode":
                case "ParenthesisNode":
                    return false;
                default:
                    return true;
            }
        });
        var result;
        switch(args.length){
            case 0:
                result = [];
                break;
            case 1:
                // precedence of the operand
                var operandPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(args[0], parenthesis, implicit, root);
                // handle special cases for LaTeX, where some of the parentheses aren't needed
                if (latex && operandPrecedence !== null) {
                    var operandIdentifier;
                    var rootIdentifier;
                    if (parenthesis === "keep") {
                        operandIdentifier = args[0].getIdentifier();
                        rootIdentifier = root.getIdentifier();
                    } else {
                        // Ignore Parenthesis Nodes when not in 'keep' mode
                        operandIdentifier = args[0].getContent().getIdentifier();
                        rootIdentifier = root.getContent().getIdentifier();
                    }
                    if ((0, $c57e483ac23cf50e$export$3cb21709c4058847)[precedence][rootIdentifier].latexLeftParens === false) {
                        result = [
                            false
                        ];
                        break;
                    }
                    if ((0, $c57e483ac23cf50e$export$3cb21709c4058847)[operandPrecedence][operandIdentifier].latexParens === false) {
                        result = [
                            false
                        ];
                        break;
                    }
                }
                if (operandPrecedence === null) {
                    // if the operand has no defined precedence, no parens are needed
                    result = [
                        false
                    ];
                    break;
                }
                if (operandPrecedence <= precedence) {
                    // if the operands precedence is lower, parens are needed
                    result = [
                        true
                    ];
                    break;
                }
                // otherwise, no parens needed
                result = [
                    false
                ];
                break;
            case 2:
                var lhsParens; // left hand side needs parenthesis?
                // precedence of the left hand side
                var lhsPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(args[0], parenthesis, implicit, root);
                // is the root node associative with the left hand side
                var assocWithLhs = (0, $c57e483ac23cf50e$export$b539869f53b6850a)(root, args[0], parenthesis);
                if (lhsPrecedence === null) // if the left hand side has no defined precedence, no parens are needed
                // FunctionNode for example
                lhsParens = false;
                else if (lhsPrecedence === precedence && associativity === "right" && !assocWithLhs) // In case of equal precedence, if the root node is left associative
                // parens are **never** necessary for the left hand side.
                // If it is right associative however, parens are necessary
                // if the root node isn't associative with the left hand side
                lhsParens = true;
                else if (lhsPrecedence < precedence) lhsParens = true;
                else lhsParens = false;
                var rhsParens; // right hand side needs parenthesis?
                // precedence of the right hand side
                var rhsPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(args[1], parenthesis, implicit, root);
                // is the root node associative with the right hand side?
                var assocWithRhs = (0, $c57e483ac23cf50e$export$b539869f53b6850a)(root, args[1], parenthesis);
                if (rhsPrecedence === null) // if the right hand side has no defined precedence, no parens are needed
                // FunctionNode for example
                rhsParens = false;
                else if (rhsPrecedence === precedence && associativity === "left" && !assocWithRhs) // In case of equal precedence, if the root node is right associative
                // parens are **never** necessary for the right hand side.
                // If it is left associative however, parens are necessary
                // if the root node isn't associative with the right hand side
                rhsParens = true;
                else if (rhsPrecedence < precedence) rhsParens = true;
                else rhsParens = false;
                // handle special cases for LaTeX, where some of the parentheses aren't needed
                if (latex) {
                    var _rootIdentifier;
                    var lhsIdentifier;
                    var rhsIdentifier;
                    if (parenthesis === "keep") {
                        _rootIdentifier = root.getIdentifier();
                        lhsIdentifier = root.args[0].getIdentifier();
                        rhsIdentifier = root.args[1].getIdentifier();
                    } else {
                        // Ignore ParenthesisNodes when not in 'keep' mode
                        _rootIdentifier = root.getContent().getIdentifier();
                        lhsIdentifier = root.args[0].getContent().getIdentifier();
                        rhsIdentifier = root.args[1].getContent().getIdentifier();
                    }
                    if (lhsPrecedence !== null) {
                        if ((0, $c57e483ac23cf50e$export$3cb21709c4058847)[precedence][_rootIdentifier].latexLeftParens === false) lhsParens = false;
                        if ((0, $c57e483ac23cf50e$export$3cb21709c4058847)[lhsPrecedence][lhsIdentifier].latexParens === false) lhsParens = false;
                    }
                    if (rhsPrecedence !== null) {
                        if ((0, $c57e483ac23cf50e$export$3cb21709c4058847)[precedence][_rootIdentifier].latexRightParens === false) rhsParens = false;
                        if ((0, $c57e483ac23cf50e$export$3cb21709c4058847)[rhsPrecedence][rhsIdentifier].latexParens === false) rhsParens = false;
                    }
                }
                result = [
                    lhsParens,
                    rhsParens
                ];
                break;
            default:
                if (root.getIdentifier() === "OperatorNode:add" || root.getIdentifier() === "OperatorNode:multiply") result = args.map(function(arg) {
                    var argPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(arg, parenthesis, implicit, root);
                    var assocWithArg = (0, $c57e483ac23cf50e$export$b539869f53b6850a)(root, arg, parenthesis);
                    var argAssociativity = (0, $c57e483ac23cf50e$export$8a3de49886b85474)(arg, parenthesis);
                    if (argPrecedence === null) // if the argument has no defined precedence, no parens are needed
                    return false;
                    else if (precedence === argPrecedence && associativity === argAssociativity && !assocWithArg) return true;
                    else if (argPrecedence < precedence) return true;
                    return false;
                });
                break;
        }
        // Handles an edge case of parentheses with implicit multiplication
        // of ConstantNode.
        // In that case, parenthesize ConstantNodes that follow an unparenthesized
        // expression, even though they normally wouldn't be printed.
        if (args.length >= 2 && root.getIdentifier() === "OperatorNode:multiply" && root.implicit && parenthesis !== "all" && implicit === "hide") {
            for(var i = 1; i < result.length; ++i)if (startsWithConstant(args[i], parenthesis) && !result[i - 1] && (parenthesis !== "keep" || !(0, $23cfe017d190638f$export$c55e3736c5721220)(args[i - 1]))) result[i] = true;
        }
        return result;
    }
    class OperatorNode extends Node {
        get type() {
            return $8867bbe30748af52$var$name;
        }
        get isOperatorNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            // validate fn
            if (typeof this.fn !== "string" || !(0, $f59a31bcbbaa9e5a$export$2220a91638ab1d9e)(math, this.fn)) {
                if (!math[this.fn]) throw new Error("Function " + this.fn + ' missing in provided namespace "math"');
                else throw new Error('No access to function "' + this.fn + '"');
            }
            var fn = (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(math, this.fn);
            var evalArgs = (0, $eee21df0c3527ff1$export$871de8747c9eaa88)(this.args, function(arg) {
                return arg._compile(math, argNames);
            });
            if (typeof fn === "function" && fn.rawArgs === true) {
                // pass unevaluated parameters (nodes) to the function
                // "raw" evaluation
                var rawArgs = this.args;
                return function evalOperatorNode(scope, args, context) {
                    return fn(rawArgs, math, (0, $726d3abcc79d73a1$export$6357aae939e9e636)(scope, args));
                };
            } else if (evalArgs.length === 1) {
                var evalArg0 = evalArgs[0];
                return function evalOperatorNode(scope, args, context) {
                    return fn(evalArg0(scope, args, context));
                };
            } else if (evalArgs.length === 2) {
                var _evalArg = evalArgs[0];
                var evalArg1 = evalArgs[1];
                return function evalOperatorNode(scope, args, context) {
                    return fn(_evalArg(scope, args, context), evalArg1(scope, args, context));
                };
            } else return function evalOperatorNode(scope, args, context) {
                return fn.apply(null, (0, $eee21df0c3527ff1$export$871de8747c9eaa88)(evalArgs, function(evalArg) {
                    return evalArg(scope, args, context);
                }));
            };
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            for(var i = 0; i < this.args.length; i++)callback(this.args[i], "args[" + i + "]", this);
        }
        /**
     * Create a new OperatorNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {OperatorNode} Returns a transformed copy of the node
     */ map(callback) {
            var args = [];
            for(var i = 0; i < this.args.length; i++)args[i] = this._ifNode(callback(this.args[i], "args[" + i + "]", this));
            return new OperatorNode(this.op, this.fn, args, this.implicit, this.isPercentage);
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {OperatorNode}
     */ clone() {
            return new OperatorNode(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
        }
        /**
     * Check whether this is an unary OperatorNode:
     * has exactly one argument, like `-a`.
     * @return {boolean}
     *     Returns true when an unary operator node, false otherwise.
     */ isUnary() {
            return this.args.length === 1;
        }
        /**
     * Check whether this is a binary OperatorNode:
     * has exactly two arguments, like `a + b`.
     * @return {boolean}
     *     Returns true when a binary operator node, false otherwise.
     */ isBinary() {
            return this.args.length === 2;
        }
        /**
     * Get string representation.
     * @param {Object} options
     * @return {string} str
     */ _toString(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var implicit = options && options.implicit ? options.implicit : "hide";
            var args = this.args;
            var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);
            if (args.length === 1) {
                // unary operators
                var assoc = (0, $c57e483ac23cf50e$export$8a3de49886b85474)(this, parenthesis);
                var operand = args[0].toString(options);
                if (parens[0]) operand = "(" + operand + ")";
                // for example for "not", we want a space between operand and argument
                var opIsNamed = /[a-zA-Z]+/.test(this.op);
                if (assoc === "right") // prefix operator
                return this.op + (opIsNamed ? " " : "") + operand;
                else if (assoc === "left") // postfix
                return operand + (opIsNamed ? " " : "") + this.op;
                // fall back to postfix
                return operand + this.op;
            } else if (args.length === 2) {
                var lhs = args[0].toString(options); // left hand side
                var rhs = args[1].toString(options); // right hand side
                if (parens[0]) // left hand side in parenthesis?
                lhs = "(" + lhs + ")";
                if (parens[1]) // right hand side in parenthesis?
                rhs = "(" + rhs + ")";
                if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return lhs + " " + rhs;
                return lhs + " " + this.op + " " + rhs;
            } else if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
                var stringifiedArgs = args.map(function(arg, index) {
                    arg = arg.toString(options);
                    if (parens[index]) // put in parenthesis?
                    arg = "(" + arg + ")";
                    return arg;
                });
                if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return stringifiedArgs.join(" ");
                return stringifiedArgs.join(" " + this.op + " ");
            } else // fallback to formatting as a function call
            return this.fn + "(" + this.args.join(", ") + ")";
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $8867bbe30748af52$var$name,
                op: this.op,
                fn: this.fn,
                args: this.args,
                implicit: this.implicit,
                isPercentage: this.isPercentage
            };
        }
        /**
     * Instantiate an OperatorNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "OperatorNode",
     *      "op": "+", "fn": "add", "args": [...],
     *      "implicit": false,
     *      "isPercentage":false}
     *     ```
     *     where mathjs is optional
     * @returns {OperatorNode}
     */ static fromJSON(json) {
            return new OperatorNode(json.op, json.fn, json.args, json.implicit, json.isPercentage);
        }
        /**
     * Get HTML representation.
     * @param {Object} options
     * @return {string} str
     */ _toHTML(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var implicit = options && options.implicit ? options.implicit : "hide";
            var args = this.args;
            var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);
            if (args.length === 1) {
                // unary operators
                var assoc = (0, $c57e483ac23cf50e$export$8a3de49886b85474)(this, parenthesis);
                var operand = args[0].toHTML(options);
                if (parens[0]) operand = '<span class="math-parenthesis math-round-parenthesis">(</span>' + operand + '<span class="math-parenthesis math-round-parenthesis">)</span>';
                if (assoc === "right") // prefix operator
                return '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(this.op) + "</span>" + operand;
                else // postfix when assoc === 'left' or undefined
                return operand + '<span class="math-operator math-unary-operator ' + 'math-righthand-unary-operator">' + (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(this.op) + "</span>";
            } else if (args.length === 2) {
                // binary operatoes
                var lhs = args[0].toHTML(options); // left hand side
                var rhs = args[1].toHTML(options); // right hand side
                if (parens[0]) // left hand side in parenthesis?
                lhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + lhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
                if (parens[1]) // right hand side in parenthesis?
                rhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + rhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
                if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return lhs + '<span class="math-operator math-binary-operator ' + 'math-implicit-binary-operator"></span>' + rhs;
                return lhs + '<span class="math-operator math-binary-operator ' + 'math-explicit-binary-operator">' + (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(this.op) + "</span>" + rhs;
            } else {
                var stringifiedArgs = args.map(function(arg, index) {
                    arg = arg.toHTML(options);
                    if (parens[index]) // put in parenthesis?
                    arg = '<span class="math-parenthesis math-round-parenthesis">(</span>' + arg + '<span class="math-parenthesis math-round-parenthesis">)</span>';
                    return arg;
                });
                if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
                    if (this.implicit && this.getIdentifier() === "OperatorNode:multiply" && implicit === "hide") return stringifiedArgs.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>');
                    return stringifiedArgs.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(this.op) + "</span>");
                } else // fallback to formatting as a function call
                return '<span class="math-function">' + (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">' + "(</span>" + stringifiedArgs.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
            }
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */ _toTex(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var implicit = options && options.implicit ? options.implicit : "hide";
            var args = this.args;
            var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, true);
            var op = (0, $a279f526ff78ebb8$export$c728a46e4168cd75)[this.fn];
            op = typeof op === "undefined" ? this.op : op; // fall back to using this.op
            if (args.length === 1) {
                // unary operators
                var assoc = (0, $c57e483ac23cf50e$export$8a3de49886b85474)(this, parenthesis);
                var operand = args[0].toTex(options);
                if (parens[0]) operand = "\\left(".concat(operand, "\\right)");
                if (assoc === "right") // prefix operator
                return op + operand;
                else if (assoc === "left") // postfix operator
                return operand + op;
                // fall back to postfix
                return operand + op;
            } else if (args.length === 2) {
                // binary operators
                var lhs = args[0]; // left hand side
                var lhsTex = lhs.toTex(options);
                if (parens[0]) lhsTex = "\\left(".concat(lhsTex, "\\right)");
                var rhs = args[1]; // right hand side
                var rhsTex = rhs.toTex(options);
                if (parens[1]) rhsTex = "\\left(".concat(rhsTex, "\\right)");
                // handle some exceptions (due to the way LaTeX works)
                var lhsIdentifier;
                if (parenthesis === "keep") lhsIdentifier = lhs.getIdentifier();
                else // Ignore ParenthesisNodes if in 'keep' mode
                lhsIdentifier = lhs.getContent().getIdentifier();
                switch(this.getIdentifier()){
                    case "OperatorNode:divide":
                        // op contains '\\frac' at this point
                        return op + "{" + lhsTex + "}" + "{" + rhsTex + "}";
                    case "OperatorNode:pow":
                        lhsTex = "{" + lhsTex + "}";
                        rhsTex = "{" + rhsTex + "}";
                        switch(lhsIdentifier){
                            case "ConditionalNode":
                            case "OperatorNode:divide":
                                lhsTex = "\\left(".concat(lhsTex, "\\right)");
                        }
                        break;
                    case "OperatorNode:multiply":
                        if (this.implicit && implicit === "hide") return lhsTex + "~" + rhsTex;
                }
                return lhsTex + op + rhsTex;
            } else if (args.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
                var texifiedArgs = args.map(function(arg, index) {
                    arg = arg.toTex(options);
                    if (parens[index]) arg = "\\left(".concat(arg, "\\right)");
                    return arg;
                });
                if (this.getIdentifier() === "OperatorNode:multiply" && this.implicit && implicit === "hide") return texifiedArgs.join("~");
                return texifiedArgs.join(op);
            } else // fall back to formatting as a function call
            // as this is a fallback, it doesn't use
            // fancy function names
            return "\\mathrm{" + this.fn + "}\\left(" + args.map(function(arg) {
                return arg.toTex(options);
            }).join(",") + "\\right)";
        }
        /**
     * Get identifier.
     * @return {string}
     */ getIdentifier() {
            return this.type + ":" + this.fn;
        }
        /**
     * @constructor OperatorNode
     * @extends {Node}
     * An operator with two arguments, like 2+3
     *
     * @param {string} op           Operator name, for example '+'
     * @param {string} fn           Function name, for example 'add'
     * @param {Node[]} args         Operator arguments
     * @param {boolean} [implicit]  Is this an implicit multiplication?
     * @param {boolean} [isPercentage] Is this an percentage Operation?
     */ constructor(op, fn, args, implicit, isPercentage){
            super();
            // validate input
            if (typeof op !== "string") throw new TypeError('string expected for parameter "op"');
            if (typeof fn !== "string") throw new TypeError('string expected for parameter "fn"');
            if (!Array.isArray(args) || !args.every((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee))) throw new TypeError('Array containing Nodes expected for parameter "args"');
            this.implicit = implicit === true;
            this.isPercentage = isPercentage === true;
            this.op = op;
            this.fn = fn;
            this.args = args || [];
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(OperatorNode, "name", $8867bbe30748af52$var$name);
    return OperatorNode;
}, {
    isClass: true,
    isNode: true
});




var $c9f5900e99415d04$var$name = "or";
var $c9f5900e99415d04$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix",
    "concat"
];
var $c9f5900e99415d04$export$fa061a00743ba4b9 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c9f5900e99415d04$var$name, $c9f5900e99415d04$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var or = (0, $cfe9a4f8156ec37d$export$3d19b09907d6fd4a)({
        typed: typed,
        matrix: matrix,
        equalScalar: equalScalar,
        DenseMatrix: DenseMatrix,
        concat: concat
    });
    function orTransform(args, math, scope) {
        var condition1 = args[0].compile().evaluate(scope);
        if (!(0, $23cfe017d190638f$export$cea7aa84e978eba5)(condition1) && or(condition1, false)) return true;
        var condition2 = args[1].compile().evaluate(scope);
        return or(condition1, condition2);
    }
    orTransform.rawArgs = true;
    return orTransform;
}, {
    isTransformFunction: true
});




var $64021b24de3dfb3e$var$name = "ParenthesisNode";
var $64021b24de3dfb3e$var$dependencies = [
    "Node"
];
var $64021b24de3dfb3e$export$9bf5d3d4ef922b0c = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($64021b24de3dfb3e$var$name, $64021b24de3dfb3e$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    class ParenthesisNode extends Node {
        get type() {
            return $64021b24de3dfb3e$var$name;
        }
        get isParenthesisNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            return this.content._compile(math, argNames);
        }
        /**
     * Get the content of the current Node.
     * @return {Node} content
     * @override
     **/ getContent() {
            return this.content.getContent();
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            callback(this.content, "content", this);
        }
        /**
     * Create a new ParenthesisNode whose child is the result of calling
     * the provided callback function on the child of this node.
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {ParenthesisNode} Returns a clone of the node
     */ map(callback) {
            var content = callback(this.content, "content", this);
            return new ParenthesisNode(content);
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {ParenthesisNode}
     */ clone() {
            return new ParenthesisNode(this.content);
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toString(options) {
            if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return "(" + this.content.toString(options) + ")";
            return this.content.toString(options);
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $64021b24de3dfb3e$var$name,
                content: this.content
            };
        }
        /**
     * Instantiate an ParenthesisNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ParenthesisNode", "content": ...}`,
     *                       where mathjs is optional
     * @returns {ParenthesisNode}
     */ static fromJSON(json) {
            return new ParenthesisNode(json.content);
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toHTML(options) {
            if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            return this.content.toHTML(options);
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toTex(options) {
            if (!options || options && !options.parenthesis || options && options.parenthesis === "keep") return "\\left(".concat(this.content.toTex(options), "\\right)");
            return this.content.toTex(options);
        }
        /**
     * @constructor ParenthesisNode
     * @extends {Node}
     * A parenthesis node describes manual parenthesis from the user input
     * @param {Node} content
     * @extends {Node}
     */ constructor(content){
            super();
            // validate input
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(content)) throw new TypeError('Node expected for parameter "content"');
            this.content = content;
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(ParenthesisNode, "name", $64021b24de3dfb3e$var$name);
    return ParenthesisNode;
}, {
    isClass: true,
    isNode: true
});







var $22451ab470938039$var$name = "parse";
var $22451ab470938039$var$dependencies = [
    "typed",
    "numeric",
    "config",
    "AccessorNode",
    "ArrayNode",
    "AssignmentNode",
    "BlockNode",
    "ConditionalNode",
    "ConstantNode",
    "FunctionAssignmentNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "ParenthesisNode",
    "RangeNode",
    "RelationalNode",
    "SymbolNode"
];
var $22451ab470938039$export$fef7a8850e50b7 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($22451ab470938039$var$name, $22451ab470938039$var$dependencies, (_ref)=>{
    var { typed: typed, numeric: numeric, config: config, AccessorNode: AccessorNode, ArrayNode: ArrayNode, AssignmentNode: AssignmentNode, BlockNode: BlockNode, ConditionalNode: ConditionalNode, ConstantNode: ConstantNode, FunctionAssignmentNode: FunctionAssignmentNode, FunctionNode: FunctionNode, IndexNode: IndexNode, ObjectNode: ObjectNode, OperatorNode: OperatorNode, ParenthesisNode: ParenthesisNode, RangeNode: RangeNode, RelationalNode: RelationalNode, SymbolNode: SymbolNode } = _ref;
    /**
   * Parse an expression. Returns a node tree, which can be evaluated by
   * invoking node.evaluate().
   *
   * Note the evaluating arbitrary expressions may involve security risks,
   * see [https://mathjs.org/docs/expressions/security.html](https://mathjs.org/docs/expressions/security.html) for more information.
   *
   * Syntax:
   *
   *     math.parse(expr)
   *     math.parse(expr, options)
   *     math.parse([expr1, expr2, expr3, ...])
   *     math.parse([expr1, expr2, expr3, ...], options)
   *
   * Example:
   *
   *     const node1 = math.parse('sqrt(3^2 + 4^2)')
   *     node1.compile().evaluate() // 5
   *
   *     let scope = {a:3, b:4}
   *     const node2 = math.parse('a * b') // 12
   *     const code2 = node2.compile()
   *     code2.evaluate(scope) // 12
   *     scope.a = 5
   *     code2.evaluate(scope) // 20
   *
   *     const nodes = math.parse(['a = 3', 'b = 4', 'a * b'])
   *     nodes[2].compile().evaluate() // 12
   *
   * See also:
   *
   *     evaluate, compile
   *
   * @param {string | string[] | Matrix} expr          Expression to be parsed
   * @param {{nodes: Object<string, Node>}} [options]  Available options:
   *                                                   - `nodes` a set of custom nodes
   * @return {Node | Node[]} node
   * @throws {Error}
   */ var parse = typed($22451ab470938039$var$name, {
        string: function string(expression) {
            return parseStart(expression, {});
        },
        "Array | Matrix": function ArrayMatrix(expressions) {
            return parseMultiple(expressions, {});
        },
        "string, Object": function stringObject(expression, options) {
            var extraNodes = options.nodes !== undefined ? options.nodes : {};
            return parseStart(expression, extraNodes);
        },
        "Array | Matrix, Object": parseMultiple
    });
    function parseMultiple(expressions) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var extraNodes = options.nodes !== undefined ? options.nodes : {};
        // parse an array or matrix with expressions
        return (0, $b3f9e93020d0f987$export$ce7eaaed37329a1b)(expressions, function(elem) {
            if (typeof elem !== "string") throw new TypeError("String expected");
            return parseStart(elem, extraNodes);
        });
    }
    // token types enumeration
    var TOKENTYPE = {
        NULL: 0,
        DELIMITER: 1,
        NUMBER: 2,
        SYMBOL: 3,
        UNKNOWN: 4
    };
    // map with all delimiters
    var DELIMITERS = {
        ",": true,
        "(": true,
        ")": true,
        "[": true,
        "]": true,
        "{": true,
        "}": true,
        '"': true,
        "'": true,
        ";": true,
        "+": true,
        "-": true,
        "*": true,
        ".*": true,
        "/": true,
        "./": true,
        "%": true,
        "^": true,
        ".^": true,
        "~": true,
        "!": true,
        "&": true,
        "|": true,
        "^|": true,
        "=": true,
        ":": true,
        "?": true,
        "==": true,
        "!=": true,
        "<": true,
        ">": true,
        "<=": true,
        ">=": true,
        "<<": true,
        ">>": true,
        ">>>": true
    };
    // map with all named delimiters
    var NAMED_DELIMITERS = {
        mod: true,
        to: true,
        in: true,
        and: true,
        xor: true,
        or: true,
        not: true
    };
    var CONSTANTS = {
        true: true,
        false: false,
        null: null,
        undefined: undefined
    };
    var NUMERIC_CONSTANTS = [
        "NaN",
        "Infinity"
    ];
    var ESCAPE_CHARACTERS = {
        '"': '"',
        "'": "'",
        "\\": "\\",
        "/": "/",
        b: "\b",
        f: "\f",
        n: "\n",
        r: "\r",
        t: "	"
    };
    function initialState() {
        return {
            extraNodes: {},
            // current extra nodes, must be careful not to mutate
            expression: "",
            // current expression
            comment: "",
            // last parsed comment
            index: 0,
            // current index in expr
            token: "",
            // current token
            tokenType: TOKENTYPE.NULL,
            // type of the token
            nestingLevel: 0,
            // level of nesting inside parameters, used to ignore newline characters
            conditionalLevel: null // when a conditional is being parsed, the level of the conditional is stored here
        };
    }
    /**
   * View upto `length` characters of the expression starting at the current character.
   *
   * @param {Object} state
   * @param {number} [length=1] Number of characters to view
   * @returns {string}
   * @private
   */ function currentString(state, length) {
        return state.expression.substr(state.index, length);
    }
    /**
   * View the current character. Returns '' if end of expression is reached.
   *
   * @param {Object} state
   * @returns {string}
   * @private
   */ function currentCharacter(state) {
        return currentString(state, 1);
    }
    /**
   * Get the next character from the expression.
   * The character is stored into the char c. If the end of the expression is
   * reached, the function puts an empty string in c.
   * @private
   */ function next(state) {
        state.index++;
    }
    /**
   * Preview the previous character from the expression.
   * @return {string} cNext
   * @private
   */ function prevCharacter(state) {
        return state.expression.charAt(state.index - 1);
    }
    /**
   * Preview the next character from the expression.
   * @return {string} cNext
   * @private
   */ function nextCharacter(state) {
        return state.expression.charAt(state.index + 1);
    }
    /**
   * Get next token in the current string expr.
   * The token and token type are available as token and tokenType
   * @private
   */ function getToken(state) {
        state.tokenType = TOKENTYPE.NULL;
        state.token = "";
        state.comment = "";
        // skip over ignored characters:
        while(true){
            // comments:
            if (currentCharacter(state) === "#") while(currentCharacter(state) !== "\n" && currentCharacter(state) !== ""){
                state.comment += currentCharacter(state);
                next(state);
            }
            // whitespace: space, tab, and newline when inside parameters
            if (parse.isWhitespace(currentCharacter(state), state.nestingLevel)) next(state);
            else break;
        }
        // check for end of expression
        if (currentCharacter(state) === "") {
            // token is still empty
            state.tokenType = TOKENTYPE.DELIMITER;
            return;
        }
        // check for new line character
        if (currentCharacter(state) === "\n" && !state.nestingLevel) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = currentCharacter(state);
            next(state);
            return;
        }
        var c1 = currentCharacter(state);
        var c2 = currentString(state, 2);
        var c3 = currentString(state, 3);
        if (c3.length === 3 && DELIMITERS[c3]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c3;
            next(state);
            next(state);
            next(state);
            return;
        }
        // check for delimiters consisting of 2 characters
        if (c2.length === 2 && DELIMITERS[c2]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c2;
            next(state);
            next(state);
            return;
        }
        // check for delimiters consisting of 1 character
        if (DELIMITERS[c1]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c1;
            next(state);
            return;
        }
        // check for a number
        if (parse.isDigitDot(c1)) {
            state.tokenType = TOKENTYPE.NUMBER;
            // check for binary, octal, or hex
            var _c = currentString(state, 2);
            if (_c === "0b" || _c === "0o" || _c === "0x") {
                state.token += currentCharacter(state);
                next(state);
                state.token += currentCharacter(state);
                next(state);
                while(parse.isHexDigit(currentCharacter(state))){
                    state.token += currentCharacter(state);
                    next(state);
                }
                if (currentCharacter(state) === ".") {
                    // this number has a radix point
                    state.token += ".";
                    next(state);
                    // get the digits after the radix
                    while(parse.isHexDigit(currentCharacter(state))){
                        state.token += currentCharacter(state);
                        next(state);
                    }
                } else if (currentCharacter(state) === "i") {
                    // this number has a word size suffix
                    state.token += "i";
                    next(state);
                    // get the word size
                    while(parse.isDigit(currentCharacter(state))){
                        state.token += currentCharacter(state);
                        next(state);
                    }
                }
                return;
            }
            // get number, can have a single dot
            if (currentCharacter(state) === ".") {
                state.token += currentCharacter(state);
                next(state);
                if (!parse.isDigit(currentCharacter(state))) {
                    // this is no number, it is just a dot (can be dot notation)
                    state.tokenType = TOKENTYPE.DELIMITER;
                    return;
                }
            } else {
                while(parse.isDigit(currentCharacter(state))){
                    state.token += currentCharacter(state);
                    next(state);
                }
                if (parse.isDecimalMark(currentCharacter(state), nextCharacter(state))) {
                    state.token += currentCharacter(state);
                    next(state);
                }
            }
            while(parse.isDigit(currentCharacter(state))){
                state.token += currentCharacter(state);
                next(state);
            }
            // check for exponential notation like "2.3e-4", "1.23e50" or "2e+4"
            if (currentCharacter(state) === "E" || currentCharacter(state) === "e") {
                if (parse.isDigit(nextCharacter(state)) || nextCharacter(state) === "-" || nextCharacter(state) === "+") {
                    state.token += currentCharacter(state);
                    next(state);
                    if (currentCharacter(state) === "+" || currentCharacter(state) === "-") {
                        state.token += currentCharacter(state);
                        next(state);
                    }
                    // Scientific notation MUST be followed by an exponent
                    if (!parse.isDigit(currentCharacter(state))) throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                    while(parse.isDigit(currentCharacter(state))){
                        state.token += currentCharacter(state);
                        next(state);
                    }
                    if (parse.isDecimalMark(currentCharacter(state), nextCharacter(state))) throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                } else if (nextCharacter(state) === ".") {
                    next(state);
                    throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                }
            }
            return;
        }
        // check for variables, functions, named operators
        if (parse.isAlpha(currentCharacter(state), prevCharacter(state), nextCharacter(state))) {
            while(parse.isAlpha(currentCharacter(state), prevCharacter(state), nextCharacter(state)) || parse.isDigit(currentCharacter(state))){
                state.token += currentCharacter(state);
                next(state);
            }
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(NAMED_DELIMITERS, state.token)) state.tokenType = TOKENTYPE.DELIMITER;
            else state.tokenType = TOKENTYPE.SYMBOL;
            return;
        }
        // something unknown is found, wrong characters -> a syntax error
        state.tokenType = TOKENTYPE.UNKNOWN;
        while(currentCharacter(state) !== ""){
            state.token += currentCharacter(state);
            next(state);
        }
        throw createSyntaxError(state, 'Syntax error in part "' + state.token + '"');
    }
    /**
   * Get next token and skip newline tokens
   */ function getTokenSkipNewline(state) {
        do getToken(state);
        while (state.token === "\n"); // eslint-disable-line no-unmodified-loop-condition
    }
    /**
   * Open parameters.
   * New line characters will be ignored until closeParams(state) is called
   */ function openParams(state) {
        state.nestingLevel++;
    }
    /**
   * Close parameters.
   * New line characters will no longer be ignored
   */ function closeParams(state) {
        state.nestingLevel--;
    }
    /**
   * Checks whether the current character `c` is a valid alpha character:
   *
   * - A latin letter (upper or lower case) Ascii: a-z, A-Z
   * - An underscore                        Ascii: _
   * - A dollar sign                        Ascii: $
   * - A latin letter with accents          Unicode: \u00C0 - \u02AF
   * - A greek letter                       Unicode: \u0370 - \u03FF
   * - A mathematical alphanumeric symbol   Unicode: \u{1D400} - \u{1D7FF} excluding invalid code points
   *
   * The previous and next characters are needed to determine whether
   * this character is part of a unicode surrogate pair.
   *
   * @param {string} c      Current character in the expression
   * @param {string} cPrev  Previous character
   * @param {string} cNext  Next character
   * @return {boolean}
   */ parse.isAlpha = function isAlpha(c, cPrev, cNext) {
        return parse.isValidLatinOrGreek(c) || parse.isValidMathSymbol(c, cNext) || parse.isValidMathSymbol(cPrev, c);
    };
    /**
   * Test whether a character is a valid latin, greek, or letter-like character
   * @param {string} c
   * @return {boolean}
   */ parse.isValidLatinOrGreek = function isValidLatinOrGreek(c) {
        return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(c);
    };
    /**
   * Test whether two given 16 bit characters form a surrogate pair of a
   * unicode math symbol.
   *
   * https://unicode-table.com/en/
   * https://www.wikiwand.com/en/Mathematical_operators_and_symbols_in_Unicode
   *
   * Note: In ES6 will be unicode aware:
   * https://stackoverflow.com/questions/280712/javascript-unicode-regexes
   * https://mathiasbynens.be/notes/es6-unicode-regex
   *
   * @param {string} high
   * @param {string} low
   * @return {boolean}
   */ parse.isValidMathSymbol = function isValidMathSymbol(high, low) {
        return /^[\uD835]$/.test(high) && /^[\uDC00-\uDFFF]$/.test(low) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(low);
    };
    /**
   * Check whether given character c is a white space character: space, tab, or enter
   * @param {string} c
   * @param {number} nestingLevel
   * @return {boolean}
   */ parse.isWhitespace = function isWhitespace(c, nestingLevel) {
        // TODO: also take '\r' carriage return as newline? Or does that give problems on mac?
        return c === " " || c === "	" || c === "\n" && nestingLevel > 0;
    };
    /**
   * Test whether the character c is a decimal mark (dot).
   * This is the case when it's not the start of a delimiter '.*', './', or '.^'
   * @param {string} c
   * @param {string} cNext
   * @return {boolean}
   */ parse.isDecimalMark = function isDecimalMark(c, cNext) {
        return c === "." && cNext !== "/" && cNext !== "*" && cNext !== "^";
    };
    /**
   * checks if the given char c is a digit or dot
   * @param {string} c   a string with one character
   * @return {boolean}
   */ parse.isDigitDot = function isDigitDot(c) {
        return c >= "0" && c <= "9" || c === ".";
    };
    /**
   * checks if the given char c is a digit
   * @param {string} c   a string with one character
   * @return {boolean}
   */ parse.isDigit = function isDigit(c) {
        return c >= "0" && c <= "9";
    };
    /**
   * checks if the given char c is a hex digit
   * @param {string} c   a string with one character
   * @return {boolean}
   */ parse.isHexDigit = function isHexDigit(c) {
        return c >= "0" && c <= "9" || c >= "a" && c <= "f" || c >= "A" && c <= "F";
    };
    /**
   * Start of the parse levels below, in order of precedence
   * @return {Node} node
   * @private
   */ function parseStart(expression, extraNodes) {
        var state = initialState();
        (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))(state, {
            expression: expression,
            extraNodes: extraNodes
        });
        getToken(state);
        var node = parseBlock(state);
        // check for garbage at the end of the expression
        // an expression ends with a empty character '' and tokenType DELIMITER
        if (state.token !== "") {
            if (state.tokenType === TOKENTYPE.DELIMITER) // user entered a not existing operator like "//"
            // TODO: give hints for aliases, for example with "<>" give as hint " did you mean !== ?"
            throw createError(state, "Unexpected operator " + state.token);
            else throw createSyntaxError(state, 'Unexpected part "' + state.token + '"');
        }
        return node;
    }
    /**
   * Parse a block with expressions. Expressions can be separated by a newline
   * character '\n', or by a semicolon ';'. In case of a semicolon, no output
   * of the preceding line is returned.
   * @return {Node} node
   * @private
   */ function parseBlock(state) {
        var node;
        var blocks = [];
        var visible;
        if (state.token !== "" && state.token !== "\n" && state.token !== ";") {
            node = parseAssignment(state);
            if (state.comment) node.comment = state.comment;
        }
        // TODO: simplify this loop
        while(state.token === "\n" || state.token === ";"){
            // eslint-disable-line no-unmodified-loop-condition
            if (blocks.length === 0 && node) {
                visible = state.token !== ";";
                blocks.push({
                    node: node,
                    visible: visible
                });
            }
            getToken(state);
            if (state.token !== "\n" && state.token !== ";" && state.token !== "") {
                node = parseAssignment(state);
                if (state.comment) node.comment = state.comment;
                visible = state.token !== ";";
                blocks.push({
                    node: node,
                    visible: visible
                });
            }
        }
        if (blocks.length > 0) return new BlockNode(blocks);
        else {
            if (!node) {
                node = new ConstantNode(undefined);
                if (state.comment) node.comment = state.comment;
            }
            return node;
        }
    }
    /**
   * Assignment of a function or variable,
   * - can be a variable like 'a=2.3'
   * - or a updating an existing variable like 'matrix(2,3:5)=[6,7,8]'
   * - defining a function like 'f(x) = x^2'
   * @return {Node} node
   * @private
   */ function parseAssignment(state) {
        var name, args, value, valid;
        var node = parseConditional(state);
        if (state.token === "=") {
            if ((0, $23cfe017d190638f$export$87815d550facaed9)(node)) {
                // parse a variable assignment like 'a = 2/3'
                name = node.name;
                getTokenSkipNewline(state);
                value = parseAssignment(state);
                return new AssignmentNode(new SymbolNode(name), value);
            } else if ((0, $23cfe017d190638f$export$f88fb19d6b9ee5cb)(node)) {
                // parse a matrix subset assignment like 'A[1,2] = 4'
                getTokenSkipNewline(state);
                value = parseAssignment(state);
                return new AssignmentNode(node.object, node.index, value);
            } else if ((0, $23cfe017d190638f$export$6ae03b16e064e6c4)(node) && (0, $23cfe017d190638f$export$87815d550facaed9)(node.fn)) {
                // parse function assignment like 'f(x) = x^2'
                valid = true;
                args = [];
                name = node.name;
                node.args.forEach(function(arg, index) {
                    if ((0, $23cfe017d190638f$export$87815d550facaed9)(arg)) args[index] = arg.name;
                    else valid = false;
                });
                if (valid) {
                    getTokenSkipNewline(state);
                    value = parseAssignment(state);
                    return new FunctionAssignmentNode(name, args, value);
                }
            }
            throw createSyntaxError(state, "Invalid left hand side of assignment operator =");
        }
        return node;
    }
    /**
   * conditional operation
   *
   *     condition ? truePart : falsePart
   *
   * Note: conditional operator is right-associative
   *
   * @return {Node} node
   * @private
   */ function parseConditional(state) {
        var node = parseLogicalOr(state);
        while(state.token === "?"){
            // eslint-disable-line no-unmodified-loop-condition
            // set a conditional level, the range operator will be ignored as long
            // as conditionalLevel === state.nestingLevel.
            var prev = state.conditionalLevel;
            state.conditionalLevel = state.nestingLevel;
            getTokenSkipNewline(state);
            var condition = node;
            var trueExpr = parseAssignment(state);
            if (state.token !== ":") throw createSyntaxError(state, "False part of conditional expression expected");
            state.conditionalLevel = null;
            getTokenSkipNewline(state);
            var falseExpr = parseAssignment(state); // Note: check for conditional operator again, right associativity
            node = new ConditionalNode(condition, trueExpr, falseExpr);
            // restore the previous conditional level
            state.conditionalLevel = prev;
        }
        return node;
    }
    /**
   * logical or, 'x or y'
   * @return {Node} node
   * @private
   */ function parseLogicalOr(state) {
        var node = parseLogicalXor(state);
        while(state.token === "or"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("or", "or", [
                node,
                parseLogicalXor(state)
            ]);
        }
        return node;
    }
    /**
   * logical exclusive or, 'x xor y'
   * @return {Node} node
   * @private
   */ function parseLogicalXor(state) {
        var node = parseLogicalAnd(state);
        while(state.token === "xor"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("xor", "xor", [
                node,
                parseLogicalAnd(state)
            ]);
        }
        return node;
    }
    /**
   * logical and, 'x and y'
   * @return {Node} node
   * @private
   */ function parseLogicalAnd(state) {
        var node = parseBitwiseOr(state);
        while(state.token === "and"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("and", "and", [
                node,
                parseBitwiseOr(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise or, 'x | y'
   * @return {Node} node
   * @private
   */ function parseBitwiseOr(state) {
        var node = parseBitwiseXor(state);
        while(state.token === "|"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("|", "bitOr", [
                node,
                parseBitwiseXor(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise exclusive or (xor), 'x ^| y'
   * @return {Node} node
   * @private
   */ function parseBitwiseXor(state) {
        var node = parseBitwiseAnd(state);
        while(state.token === "^|"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("^|", "bitXor", [
                node,
                parseBitwiseAnd(state)
            ]);
        }
        return node;
    }
    /**
   * bitwise and, 'x & y'
   * @return {Node} node
   * @private
   */ function parseBitwiseAnd(state) {
        var node = parseRelational(state);
        while(state.token === "&"){
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode("&", "bitAnd", [
                node,
                parseRelational(state)
            ]);
        }
        return node;
    }
    /**
   * Parse a chained conditional, like 'a > b >= c'
   * @return {Node} node
   */ function parseRelational(state) {
        var params = [
            parseShift(state)
        ];
        var conditionals = [];
        var operators = {
            "==": "equal",
            "!=": "unequal",
            "<": "smaller",
            ">": "larger",
            "<=": "smallerEq",
            ">=": "largerEq"
        };
        while((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(operators, state.token)){
            // eslint-disable-line no-unmodified-loop-condition
            var cond = {
                name: state.token,
                fn: operators[state.token]
            };
            conditionals.push(cond);
            getTokenSkipNewline(state);
            params.push(parseShift(state));
        }
        if (params.length === 1) return params[0];
        else if (params.length === 2) return new OperatorNode(conditionals[0].name, conditionals[0].fn, params);
        else return new RelationalNode(conditionals.map((c)=>c.fn), params);
    }
    /**
   * Bitwise left shift, bitwise right arithmetic shift, bitwise right logical shift
   * @return {Node} node
   * @private
   */ function parseShift(state) {
        var node, name, fn, params;
        node = parseConversion(state);
        var operators = {
            "<<": "leftShift",
            ">>": "rightArithShift",
            ">>>": "rightLogShift"
        };
        while((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            params = [
                node,
                parseConversion(state)
            ];
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * conversion operators 'to' and 'in'
   * @return {Node} node
   * @private
   */ function parseConversion(state) {
        var node, name, fn, params;
        node = parseRange(state);
        var operators = {
            to: "to",
            in: "to" // alias of 'to'
        };
        while((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            if (name === "in" && state.token === "") // end of expression -> this is the unit 'in' ('inch')
            node = new OperatorNode("*", "multiply", [
                node,
                new SymbolNode("in")
            ], true);
            else {
                // operator 'a to b' or 'a in b'
                params = [
                    node,
                    parseRange(state)
                ];
                node = new OperatorNode(name, fn, params);
            }
        }
        return node;
    }
    /**
   * parse range, "start:end", "start:step:end", ":", "start:", ":end", etc
   * @return {Node} node
   * @private
   */ function parseRange(state) {
        var node;
        var params = [];
        if (state.token === ":") // implicit start=1 (one-based)
        node = new ConstantNode(1);
        else // explicit start
        node = parseAddSubtract(state);
        if (state.token === ":" && state.conditionalLevel !== state.nestingLevel) {
            // we ignore the range operator when a conditional operator is being processed on the same level
            params.push(node);
            // parse step and end
            while(state.token === ":" && params.length < 3){
                // eslint-disable-line no-unmodified-loop-condition
                getTokenSkipNewline(state);
                if (state.token === ")" || state.token === "]" || state.token === "," || state.token === "") // implicit end
                params.push(new SymbolNode("end"));
                else // explicit end
                params.push(parseAddSubtract(state));
            }
            if (params.length === 3) // params = [start, step, end]
            node = new RangeNode(params[0], params[2], params[1]); // start, end, step
            else // length === 2
            // params = [start, end]
            node = new RangeNode(params[0], params[1]); // start, end
        }
        return node;
    }
    /**
   * add or subtract
   * @return {Node} node
   * @private
   */ function parseAddSubtract(state) {
        var node, name, fn, params;
        node = parseMultiplyDivide(state);
        var operators = {
            "+": "add",
            "-": "subtract"
        };
        while((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            var rightNode = parseMultiplyDivide(state);
            if (rightNode.isPercentage) params = [
                node,
                new OperatorNode("*", "multiply", [
                    node,
                    rightNode
                ])
            ];
            else params = [
                node,
                rightNode
            ];
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * multiply, divide
   * @return {Node} node
   * @private
   */ function parseMultiplyDivide(state) {
        var node, last, name, fn;
        node = parseImplicitMultiplication(state);
        last = node;
        var operators = {
            "*": "multiply",
            ".*": "dotMultiply",
            "/": "divide",
            "./": "dotDivide"
        };
        while(true){
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(operators, state.token)) {
                // explicit operators
                name = state.token;
                fn = operators[name];
                getTokenSkipNewline(state);
                last = parseImplicitMultiplication(state);
                node = new OperatorNode(name, fn, [
                    node,
                    last
                ]);
            } else break;
        }
        return node;
    }
    /**
   * implicit multiplication
   * @return {Node} node
   * @private
   */ function parseImplicitMultiplication(state) {
        var node, last;
        node = parseRule2(state);
        last = node;
        while(true){
            if (state.tokenType === TOKENTYPE.SYMBOL || state.token === "in" && (0, $23cfe017d190638f$export$fa9d80731fd8c54b)(node) || state.tokenType === TOKENTYPE.NUMBER && !(0, $23cfe017d190638f$export$fa9d80731fd8c54b)(last) && (!(0, $23cfe017d190638f$export$7e624cbaab6cce94)(last) || last.op === "!") || state.token === "(") {
                // parse implicit multiplication
                //
                // symbol:      implicit multiplication like '2a', '(2+3)a', 'a b'
                // number:      implicit multiplication like '(2+3)2'
                // parenthesis: implicit multiplication like '2(3+4)', '(3+4)(1+2)'
                last = parseRule2(state);
                node = new OperatorNode("*", "multiply", [
                    node,
                    last
                ], true);
            } else break;
        }
        return node;
    }
    /**
   * Infamous "rule 2" as described in https://github.com/josdejong/mathjs/issues/792#issuecomment-361065370
   * And as amended in https://github.com/josdejong/mathjs/issues/2370#issuecomment-1054052164
   * Explicit division gets higher precedence than implicit multiplication
   * when the division matches this pattern:
   *   [unaryPrefixOp]?[number] / [number] [symbol]
   * @return {Node} node
   * @private
   */ function parseRule2(state) {
        var node = parseModulusPercentage(state);
        var last = node;
        var tokenStates = [];
        while(true){
            // Match the "number /" part of the pattern "number / number symbol"
            if (state.token === "/" && (0, $23cfe017d190638f$export$e6caeb7474dbdff3)(last)) {
                // Look ahead to see if the next token is a number
                tokenStates.push((0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))({}, state));
                getTokenSkipNewline(state);
                // Match the "number / number" part of the pattern
                if (state.tokenType === TOKENTYPE.NUMBER) {
                    // Look ahead again
                    tokenStates.push((0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))({}, state));
                    getTokenSkipNewline(state);
                    // Match the "symbol" part of the pattern, or a left parenthesis
                    if (state.tokenType === TOKENTYPE.SYMBOL || state.token === "(") {
                        // We've matched the pattern "number / number symbol".
                        // Rewind once and build the "number / number" node; the symbol will be consumed later
                        (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))(state, tokenStates.pop());
                        tokenStates.pop();
                        last = parseModulusPercentage(state);
                        node = new OperatorNode("/", "divide", [
                            node,
                            last
                        ]);
                    } else {
                        // Not a match, so rewind
                        tokenStates.pop();
                        (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))(state, tokenStates.pop());
                        break;
                    }
                } else {
                    // Not a match, so rewind
                    (0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))(state, tokenStates.pop());
                    break;
                }
            } else break;
        }
        return node;
    }
    /**
   * modulus and percentage
   * @return {Node} node
   * @private
   */ function parseModulusPercentage(state) {
        var node, name, fn, params;
        node = parseUnary(state);
        var operators = {
            "%": "mod",
            mod: "mod"
        };
        while((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            if (name === "%" && state.tokenType === TOKENTYPE.DELIMITER && state.token !== "(") // If the expression contains only %, then treat that as /100
            node = new OperatorNode("/", "divide", [
                node,
                new ConstantNode(100)
            ], false, true);
            else {
                params = [
                    node,
                    parseUnary(state)
                ];
                node = new OperatorNode(name, fn, params);
            }
        }
        return node;
    }
    /**
   * Unary plus and minus, and logical and bitwise not
   * @return {Node} node
   * @private
   */ function parseUnary(state) {
        var name, params, fn;
        var operators = {
            "-": "unaryMinus",
            "+": "unaryPlus",
            "~": "bitNot",
            not: "not"
        };
        if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(operators, state.token)) {
            fn = operators[state.token];
            name = state.token;
            getTokenSkipNewline(state);
            params = [
                parseUnary(state)
            ];
            return new OperatorNode(name, fn, params);
        }
        return parsePow(state);
    }
    /**
   * power
   * Note: power operator is right associative
   * @return {Node} node
   * @private
   */ function parsePow(state) {
        var node, name, fn, params;
        node = parseLeftHandOperators(state);
        if (state.token === "^" || state.token === ".^") {
            name = state.token;
            fn = name === "^" ? "pow" : "dotPow";
            getTokenSkipNewline(state);
            params = [
                node,
                parseUnary(state)
            ]; // Go back to unary, we can have '2^-3'
            node = new OperatorNode(name, fn, params);
        }
        return node;
    }
    /**
   * Left hand operators: factorial x!, ctranspose x'
   * @return {Node} node
   * @private
   */ function parseLeftHandOperators(state) {
        var node, name, fn, params;
        node = parseCustomNodes(state);
        var operators = {
            "!": "factorial",
            "'": "ctranspose"
        };
        while((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(operators, state.token)){
            name = state.token;
            fn = operators[name];
            getToken(state);
            params = [
                node
            ];
            node = new OperatorNode(name, fn, params);
            node = parseAccessors(state, node);
        }
        return node;
    }
    /**
   * Parse a custom node handler. A node handler can be used to process
   * nodes in a custom way, for example for handling a plot.
   *
   * A handler must be passed as second argument of the parse function.
   * - must extend math.Node
   * - must contain a function _compile(defs: Object) : string
   * - must contain a function find(filter: Object) : Node[]
   * - must contain a function toString() : string
   * - the constructor is called with a single argument containing all parameters
   *
   * For example:
   *
   *     nodes = {
   *       'plot': PlotHandler
   *     }
   *
   * The constructor of the handler is called as:
   *
   *     node = new PlotHandler(params)
   *
   * The handler will be invoked when evaluating an expression like:
   *
   *     node = math.parse('plot(sin(x), x)', nodes)
   *
   * @return {Node} node
   * @private
   */ function parseCustomNodes(state) {
        var params = [];
        if (state.tokenType === TOKENTYPE.SYMBOL && (0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(state.extraNodes, state.token)) {
            var CustomNode = state.extraNodes[state.token];
            getToken(state);
            // parse parameters
            if (state.token === "(") {
                params = [];
                openParams(state);
                getToken(state);
                if (state.token !== ")") {
                    params.push(parseAssignment(state));
                    // parse a list with parameters
                    while(state.token === ","){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        params.push(parseAssignment(state));
                    }
                }
                if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
                closeParams(state);
                getToken(state);
            }
            // create a new custom node
            // noinspection JSValidateTypes
            return new CustomNode(params);
        }
        return parseSymbol(state);
    }
    /**
   * parse symbols: functions, variables, constants, units
   * @return {Node} node
   * @private
   */ function parseSymbol(state) {
        var node, name;
        if (state.tokenType === TOKENTYPE.SYMBOL || state.tokenType === TOKENTYPE.DELIMITER && state.token in NAMED_DELIMITERS) {
            name = state.token;
            getToken(state);
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(CONSTANTS, name)) // true, false, null, ...
            node = new ConstantNode(CONSTANTS[name]);
            else if (NUMERIC_CONSTANTS.includes(name)) // NaN, Infinity
            node = new ConstantNode(numeric(name, "number"));
            else node = new SymbolNode(name);
            // parse function parameters and matrix index
            node = parseAccessors(state, node);
            return node;
        }
        return parseString(state);
    }
    /**
   * parse accessors:
   * - function invocation in round brackets (...), for example sqrt(2)
   * - index enclosed in square brackets [...], for example A[2,3]
   * - dot notation for properties, like foo.bar
   * @param {Object} state
   * @param {Node} node    Node on which to apply the parameters. If there
   *                       are no parameters in the expression, the node
   *                       itself is returned
   * @param {string[]} [types]  Filter the types of notations
   *                            can be ['(', '[', '.']
   * @return {Node} node
   * @private
   */ function parseAccessors(state, node, types) {
        var params;
        while((state.token === "(" || state.token === "[" || state.token === ".") && (!types || types.includes(state.token))){
            // eslint-disable-line no-unmodified-loop-condition
            params = [];
            if (state.token === "(") {
                if ((0, $23cfe017d190638f$export$87815d550facaed9)(node) || (0, $23cfe017d190638f$export$f88fb19d6b9ee5cb)(node)) {
                    // function invocation like fn(2, 3) or obj.fn(2, 3)
                    openParams(state);
                    getToken(state);
                    if (state.token !== ")") {
                        params.push(parseAssignment(state));
                        // parse a list with parameters
                        while(state.token === ","){
                            // eslint-disable-line no-unmodified-loop-condition
                            getToken(state);
                            params.push(parseAssignment(state));
                        }
                    }
                    if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
                    closeParams(state);
                    getToken(state);
                    node = new FunctionNode(node, params);
                } else // implicit multiplication like (2+3)(4+5) or sqrt(2)(1+2)
                // don't parse it here but let it be handled by parseImplicitMultiplication
                // with correct precedence
                return node;
            } else if (state.token === "[") {
                // index notation like variable[2, 3]
                openParams(state);
                getToken(state);
                if (state.token !== "]") {
                    params.push(parseAssignment(state));
                    // parse a list with parameters
                    while(state.token === ","){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        params.push(parseAssignment(state));
                    }
                }
                if (state.token !== "]") throw createSyntaxError(state, "Parenthesis ] expected");
                closeParams(state);
                getToken(state);
                node = new AccessorNode(node, new IndexNode(params));
            } else {
                // dot notation like variable.prop
                getToken(state);
                var isPropertyName = state.tokenType === TOKENTYPE.SYMBOL || state.tokenType === TOKENTYPE.DELIMITER && state.token in NAMED_DELIMITERS;
                if (!isPropertyName) throw createSyntaxError(state, "Property name expected after dot");
                params.push(new ConstantNode(state.token));
                getToken(state);
                var dotNotation = true;
                node = new AccessorNode(node, new IndexNode(params, dotNotation));
            }
        }
        return node;
    }
    /**
   * Parse a single or double quoted string.
   * @return {Node} node
   * @private
   */ function parseString(state) {
        var node, str;
        if (state.token === '"' || state.token === "'") {
            str = parseStringToken(state, state.token);
            // create constant
            node = new ConstantNode(str);
            // parse index parameters
            node = parseAccessors(state, node);
            return node;
        }
        return parseMatrix(state);
    }
    /**
   * Parse a string surrounded by single or double quotes
   * @param {Object} state
   * @param {"'" | "\""} quote
   * @return {string}
   */ function parseStringToken(state, quote) {
        var str = "";
        while(currentCharacter(state) !== "" && currentCharacter(state) !== quote)if (currentCharacter(state) === "\\") {
            next(state);
            var char = currentCharacter(state);
            var escapeChar = ESCAPE_CHARACTERS[char];
            if (escapeChar !== undefined) {
                // an escaped control character like \" or \n
                str += escapeChar;
                state.index += 1;
            } else if (char === "u") {
                // escaped unicode character
                var unicode = state.expression.slice(state.index + 1, state.index + 5);
                if (/^[0-9A-Fa-f]{4}$/.test(unicode)) {
                    // test whether the string holds four hexadecimal values
                    str += String.fromCharCode(parseInt(unicode, 16));
                    state.index += 5;
                } else throw createSyntaxError(state, "Invalid unicode character \\u".concat(unicode));
            } else throw createSyntaxError(state, "Bad escape character \\".concat(char));
        } else {
            // any regular character
            str += currentCharacter(state);
            next(state);
        }
        getToken(state);
        if (state.token !== quote) throw createSyntaxError(state, "End of string ".concat(quote, " expected"));
        getToken(state);
        return str;
    }
    /**
   * parse the matrix
   * @return {Node} node
   * @private
   */ function parseMatrix(state) {
        var array, params, rows, cols;
        if (state.token === "[") {
            // matrix [...]
            openParams(state);
            getToken(state);
            if (state.token !== "]") {
                // this is a non-empty matrix
                var row = parseRow(state);
                if (state.token === ";") {
                    // 2 dimensional array
                    rows = 1;
                    params = [
                        row
                    ];
                    // the rows of the matrix are separated by dot-comma's
                    while(state.token === ";"){
                        // eslint-disable-line no-unmodified-loop-condition
                        getToken(state);
                        if (state.token !== "]") {
                            params[rows] = parseRow(state);
                            rows++;
                        }
                    }
                    if (state.token !== "]") throw createSyntaxError(state, "End of matrix ] expected");
                    closeParams(state);
                    getToken(state);
                    // check if the number of columns matches in all rows
                    cols = params[0].items.length;
                    for(var r = 1; r < rows; r++){
                        if (params[r].items.length !== cols) throw createError(state, "Column dimensions mismatch (" + params[r].items.length + " !== " + cols + ")");
                    }
                    array = new ArrayNode(params);
                } else {
                    // 1 dimensional vector
                    if (state.token !== "]") throw createSyntaxError(state, "End of matrix ] expected");
                    closeParams(state);
                    getToken(state);
                    array = row;
                }
            } else {
                // this is an empty matrix "[ ]"
                closeParams(state);
                getToken(state);
                array = new ArrayNode([]);
            }
            return parseAccessors(state, array);
        }
        return parseObject(state);
    }
    /**
   * Parse a single comma-separated row from a matrix, like 'a, b, c'
   * @return {ArrayNode} node
   */ function parseRow(state) {
        var params = [
            parseAssignment(state)
        ];
        var len = 1;
        while(state.token === ","){
            // eslint-disable-line no-unmodified-loop-condition
            getToken(state);
            // parse expression
            if (state.token !== "]" && state.token !== ";") {
                params[len] = parseAssignment(state);
                len++;
            }
        }
        return new ArrayNode(params);
    }
    /**
   * parse an object, enclosed in angle brackets{...}, for example {value: 2}
   * @return {Node} node
   * @private
   */ function parseObject(state) {
        if (state.token === "{") {
            openParams(state);
            var key;
            var properties = {};
            do {
                getToken(state);
                if (state.token !== "}") {
                    // parse key
                    if (state.token === '"' || state.token === "'") key = parseStringToken(state, state.token);
                    else if (state.tokenType === TOKENTYPE.SYMBOL || state.tokenType === TOKENTYPE.DELIMITER && state.token in NAMED_DELIMITERS) {
                        key = state.token;
                        getToken(state);
                    } else throw createSyntaxError(state, "Symbol or string expected as object key");
                    // parse key/value separator
                    if (state.token !== ":") throw createSyntaxError(state, "Colon : expected after object key");
                    getToken(state);
                    // parse key
                    properties[key] = parseAssignment(state);
                }
            }while (state.token === ","); // eslint-disable-line no-unmodified-loop-condition
            if (state.token !== "}") throw createSyntaxError(state, "Comma , or bracket } expected after object value");
            closeParams(state);
            getToken(state);
            var node = new ObjectNode(properties);
            // parse index parameters
            node = parseAccessors(state, node);
            return node;
        }
        return parseNumber(state);
    }
    /**
   * parse a number
   * @return {Node} node
   * @private
   */ function parseNumber(state) {
        var numberStr;
        if (state.tokenType === TOKENTYPE.NUMBER) {
            // this is a number
            numberStr = state.token;
            getToken(state);
            var numericType = (0, $a246eb207aab6d09$export$28199db5a610a1ee)(numberStr, config);
            var value = numeric(numberStr, numericType);
            return new ConstantNode(value);
        }
        return parseParentheses(state);
    }
    /**
   * parentheses
   * @return {Node} node
   * @private
   */ function parseParentheses(state) {
        var node;
        // check if it is a parenthesized expression
        if (state.token === "(") {
            // parentheses (...)
            openParams(state);
            getToken(state);
            node = parseAssignment(state); // start again
            if (state.token !== ")") throw createSyntaxError(state, "Parenthesis ) expected");
            closeParams(state);
            getToken(state);
            node = new ParenthesisNode(node);
            node = parseAccessors(state, node);
            return node;
        }
        return parseEnd(state);
    }
    /**
   * Evaluated when the expression is not yet ended but expected to end
   * @return {Node} res
   * @private
   */ function parseEnd(state) {
        if (state.token === "") // syntax error or unexpected end of expression
        throw createSyntaxError(state, "Unexpected end of expression");
        else throw createSyntaxError(state, "Value expected");
    }
    /**
   * Shortcut for getting the current row value (one based)
   * Returns the line of the currently handled expression
   * @private
   */ /* TODO: implement keeping track on the row number
  function row () {
    return null
  }
  */ /**
   * Shortcut for getting the current col value (one based)
   * Returns the column (position) where the last state.token starts
   * @private
   */ function col(state) {
        return state.index - state.token.length + 1;
    }
    /**
   * Create an error
   * @param {Object} state
   * @param {string} message
   * @return {SyntaxError} instantiated error
   * @private
   */ function createSyntaxError(state, message) {
        var c = col(state);
        var error = new SyntaxError(message + " (char " + c + ")");
        error.char = c;
        return error;
    }
    /**
   * Create an error
   * @param {Object} state
   * @param {string} message
   * @return {Error} instantiated error
   * @private
   */ function createError(state, message) {
        var c = col(state);
        var error = new SyntaxError(message + " (char " + c + ")");
        error.char = c;
        return error;
    }
    // Now that we can parse, automatically convert strings to Nodes by parsing
    typed.addConversion({
        from: "string",
        to: "Node",
        convert: parse
    });
    return parse;
});


var $fcf874745ae18340$var$name = "parser";
var $fcf874745ae18340$var$dependencies = [
    "typed",
    "Parser"
];
var $fcf874745ae18340$export$88a1156fad04455f = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($fcf874745ae18340$var$name, $fcf874745ae18340$var$dependencies, (_ref)=>{
    var { typed: typed, Parser: Parser } = _ref;
    /**
   * Create a parser. The function creates a new `math.Parser` object.
   *
   * Syntax:
   *
   *    math.parser()
   *
   * Examples:
   *
   *     const parser = new math.parser()
   *
   *     // evaluate expressions
   *     const a = parser.evaluate('sqrt(3^2 + 4^2)') // 5
   *     const b = parser.evaluate('sqrt(-4)')        // 2i
   *     const c = parser.evaluate('2 inch in cm')    // 5.08 cm
   *     const d = parser.evaluate('cos(45 deg)')     // 0.7071067811865476
   *
   *     // define variables and functions
   *     parser.evaluate('x = 7 / 2')             // 3.5
   *     parser.evaluate('x + 3')                 // 6.5
   *     parser.evaluate('f(x, y) = x^y')         // f(x, y)
   *     parser.evaluate('f(2, 3)')               // 8
   *
   *     // get and set variables and functions
   *     const x = parser.get('x')                // 3.5
   *     const f = parser.get('f')                // function
   *     const g = f(3, 2)                        // 9
   *     parser.set('h', 500)
   *     const i = parser.evaluate('h / 2')       // 250
   *     parser.set('hello', function (name) {
   *       return 'hello, ' + name + '!'
   *     })
   *     parser.evaluate('hello("user")')         // "hello, user!"
   *
   *     // clear defined functions and variables
   *     parser.clear()
   *
   * See also:
   *
   *    evaluate, compile, parse
   *
   * @return {Parser} Parser
   */ return typed($fcf874745ae18340$var$name, {
        "": function _() {
            return new Parser();
        }
    });
});



var $382dc69211195f35$var$name = "Parser";
var $382dc69211195f35$var$dependencies = [
    "evaluate"
];
var $382dc69211195f35$export$17c8a99aaef91654 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($382dc69211195f35$var$name, $382dc69211195f35$var$dependencies, (_ref)=>{
    var { evaluate: evaluate } = _ref;
    /**
   * @constructor Parser
   * Parser contains methods to evaluate or parse expressions, and has a number
   * of convenience methods to get, set, and remove variables from memory. Parser
   * keeps a scope containing variables in memory, which is used for all
   * evaluations.
   *
   * Methods:
   *    const result = parser.evaluate(expr)  // evaluate an expression
   *    const value = parser.get(name)        // retrieve a variable from the parser
   *    const values = parser.getAll()        // retrieve all defined variables
   *    parser.set(name, value)               // set a variable in the parser
   *    parser.remove(name)                   // clear a variable from the
   *                                          // parsers scope
   *    parser.clear()                        // clear the parsers scope
   *
   * Example usage:
   *    const parser = new Parser()
   *    // Note: there is a convenience method which can be used instead:
   *    // const parser = new math.parser()
   *
   *    // evaluate expressions
   *    parser.evaluate('sqrt(3^2 + 4^2)')        // 5
   *    parser.evaluate('sqrt(-4)')               // 2i
   *    parser.evaluate('2 inch in cm')           // 5.08 cm
   *    parser.evaluate('cos(45 deg)')            // 0.7071067811865476
   *
   *    // define variables and functions
   *    parser.evaluate('x = 7 / 2')              // 3.5
   *    parser.evaluate('x + 3')                  // 6.5
   *    parser.evaluate('f(x, y) = x^y')          // f(x, y)
   *    parser.evaluate('f(2, 3)')                // 8
   *
   *    // get and set variables and functions
   *    const x = parser.get('x')                 // 3.5
   *    const f = parser.get('f')                 // function
   *    const g = f(3, 2)                         // 9
   *    parser.set('h', 500)
   *    const i = parser.evaluate('h / 2')        // 250
   *    parser.set('hello', function (name) {
   *        return 'hello, ' + name + '!'
   *    })
   *    parser.evaluate('hello("user")')          // "hello, user!"
   *
   *    // clear defined functions and variables
   *    parser.clear()
   *
   */ function Parser() {
        if (!(this instanceof Parser)) throw new SyntaxError("Constructor must be called with the new operator");
        Object.defineProperty(this, "scope", {
            value: (0, $ec715b2ae25daaa7$export$89a4bcaf5b4d37d2)(),
            writable: false
        });
    }
    /**
   * Attach type information
   */ Parser.prototype.type = "Parser";
    Parser.prototype.isParser = true;
    /**
   * Parse and evaluate the given expression
   * @param {string | string[]} expr   A string containing an expression,
   *                                   for example "2+3", or a list with expressions
   * @return {*} result     The result, or undefined when the expression was empty
   * @throws {Error}
   */ Parser.prototype.evaluate = function(expr) {
        // TODO: validate arguments
        return evaluate(expr, this.scope);
    };
    /**
   * Get a variable (a function or variable) by name from the parsers scope.
   * Returns undefined when not found
   * @param {string} name
   * @return {* | undefined} value
   */ Parser.prototype.get = function(name) {
        // TODO: validate arguments
        if (this.scope.has(name)) return this.scope.get(name);
    };
    /**
   * Get a map with all defined variables
   * @return {Object} values
   */ Parser.prototype.getAll = function() {
        return (0, $ec715b2ae25daaa7$export$697e4a1b90752ce2)(this.scope);
    };
    /**
   * Get a map with all defined variables
   * @return {Map} values
   */ Parser.prototype.getAllAsMap = function() {
        return this.scope;
    };
    /**
   * Set a symbol (a function or variable) by name from the parsers scope.
   * @param {string} name
   * @param {* | undefined} value
   */ Parser.prototype.set = function(name, value) {
        this.scope.set(name, value);
        return value;
    };
    /**
   * Remove a variable from the parsers scope
   * @param {string} name
   */ Parser.prototype.remove = function(name) {
        this.scope.delete(name);
    };
    /**
   * Clear the scope with variables and functions
   */ Parser.prototype.clear = function() {
        this.scope.clear();
    };
    return Parser;
}, {
    isClass: true
});




var $1925a6f6b0f193d2$var$name = "print";
var $1925a6f6b0f193d2$var$dependencies = [
    "typed",
    "matrix",
    "zeros",
    "add"
];
var $1925a6f6b0f193d2$export$368cdeada54b4479 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($1925a6f6b0f193d2$var$name, $1925a6f6b0f193d2$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, zeros: zeros, add: add } = _ref;
    var print = (0, $4e89f948aaeed74d$export$ea4b9d9569ff81cc)({
        typed: typed,
        matrix: matrix,
        zeros: zeros,
        add: add
    });
    return typed($1925a6f6b0f193d2$var$name, {
        "string, Object | Array": function stringObjectArray(template, values) {
            return print(_convertTemplateToZeroBasedIndex(template), values);
        },
        "string, Object | Array, number | Object": function stringObjectArrayNumberObject(template, values, options) {
            return print(_convertTemplateToZeroBasedIndex(template), values, options);
        }
    });
    function _convertTemplateToZeroBasedIndex(template) {
        return template.replace((0, $6cdeefd9bf00c3e2$export$d0aef82ef51185f0), (x)=>{
            var parts = x.slice(1).split(".");
            var result = parts.map(function(part) {
                if (!isNaN(part) && part.length > 0) return parseInt(part) - 1;
                else return part;
            });
            return "$" + result.join(".");
        });
    }
}, {
    isTransformFunction: true
});




var $e329f13ccfcae0bd$var$name = "quantileSeq";
var $e329f13ccfcae0bd$var$dependencies = [
    "typed",
    "bignumber",
    "add",
    "subtract",
    "divide",
    "multiply",
    "partitionSelect",
    "compare",
    "isInteger",
    "smaller",
    "smallerEq",
    "larger"
];
var $e329f13ccfcae0bd$export$b649bff65b5ade9f = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($e329f13ccfcae0bd$var$name, $e329f13ccfcae0bd$var$dependencies, (_ref)=>{
    var { typed: typed, bignumber: bignumber, add: add, subtract: subtract, divide: divide, multiply: multiply, partitionSelect: partitionSelect, compare: compare, isInteger: isInteger, smaller: smaller, smallerEq: smallerEq, larger: larger } = _ref;
    var quantileSeq = (0, $35d974c6d0137ed7$export$524607d17ea053e9)({
        typed: typed,
        bignumber: bignumber,
        add: add,
        subtract: subtract,
        divide: divide,
        multiply: multiply,
        partitionSelect: partitionSelect,
        compare: compare,
        isInteger: isInteger,
        smaller: smaller,
        smallerEq: smallerEq,
        larger: larger
    });
    return typed("quantileSeq", {
        "Array | Matrix, number | BigNumber": quantileSeq,
        "Array | Matrix, number | BigNumber, number": (arr, prob, dim)=>quantileSeq(arr, prob, dimToZeroBase(dim)),
        "Array | Matrix, number | BigNumber, boolean": quantileSeq,
        "Array | Matrix, number | BigNumber, boolean, number": (arr, prob, sorted, dim)=>quantileSeq(arr, prob, sorted, dimToZeroBase(dim)),
        "Array | Matrix, Array | Matrix": quantileSeq,
        "Array | Matrix, Array | Matrix, number": (data, prob, dim)=>quantileSeq(data, prob, dimToZeroBase(dim)),
        "Array | Matrix, Array | Matrix, boolean": quantileSeq,
        "Array | Matrix, Array | Matrix, boolean, number": (data, prob, sorted, dim)=>quantileSeq(data, prob, sorted, dimToZeroBase(dim))
    });
    function dimToZeroBase(dim) {
        // TODO: find a better way, maybe lastDimToZeroBase could apply to more cases.
        return (0, $43b0d4e2cc26d017$export$75974926bb7e1bd6)([
            [],
            dim
        ])[1];
    }
}, {
    isTransformFunction: true
});





var $de26fa0fce424851$var$name = "RangeNode";
var $de26fa0fce424851$var$dependencies = [
    "Node"
];
var $de26fa0fce424851$export$fb6d9b21e29b8d46 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($de26fa0fce424851$var$name, $de26fa0fce424851$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    /**
   * Calculate the necessary parentheses
   * @param {Node} node
   * @param {string} parenthesis
   * @param {string} implicit
   * @return {Object} parentheses
   * @private
   */ function calculateNecessaryParentheses(node, parenthesis, implicit) {
        var precedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(node, parenthesis, implicit);
        var parens = {};
        var startPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(node.start, parenthesis, implicit);
        parens.start = startPrecedence !== null && startPrecedence <= precedence || parenthesis === "all";
        if (node.step) {
            var stepPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(node.step, parenthesis, implicit);
            parens.step = stepPrecedence !== null && stepPrecedence <= precedence || parenthesis === "all";
        }
        var endPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(node.end, parenthesis, implicit);
        parens.end = endPrecedence !== null && endPrecedence <= precedence || parenthesis === "all";
        return parens;
    }
    class RangeNode extends Node {
        get type() {
            return $de26fa0fce424851$var$name;
        }
        get isRangeNode() {
            return true;
        }
        /**
     * Check whether the RangeNode needs the `end` symbol to be defined.
     * This end is the size of the Matrix in current dimension.
     * @return {boolean}
     */ needsEnd() {
            // find all `end` symbols in this RangeNode
            var endSymbols = this.filter(function(node) {
                return (0, $23cfe017d190638f$export$87815d550facaed9)(node) && node.name === "end";
            });
            return endSymbols.length > 0;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            var range = math.range;
            var evalStart = this.start._compile(math, argNames);
            var evalEnd = this.end._compile(math, argNames);
            if (this.step) {
                var evalStep = this.step._compile(math, argNames);
                return function evalRangeNode(scope, args, context) {
                    return range(evalStart(scope, args, context), evalEnd(scope, args, context), evalStep(scope, args, context));
                };
            } else return function evalRangeNode(scope, args, context) {
                return range(evalStart(scope, args, context), evalEnd(scope, args, context));
            };
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            callback(this.start, "start", this);
            callback(this.end, "end", this);
            if (this.step) callback(this.step, "step", this);
        }
        /**
     * Create a new RangeNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {RangeNode} Returns a transformed copy of the node
     */ map(callback) {
            return new RangeNode(this._ifNode(callback(this.start, "start", this)), this._ifNode(callback(this.end, "end", this)), this.step && this._ifNode(callback(this.step, "step", this)));
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {RangeNode}
     */ clone() {
            return new RangeNode(this.start, this.end, this.step && this.step);
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */ _toString(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var parens = calculateNecessaryParentheses(this, parenthesis, options && options.implicit);
            // format string as start:step:stop
            var str;
            var start = this.start.toString(options);
            if (parens.start) start = "(" + start + ")";
            str = start;
            if (this.step) {
                var step = this.step.toString(options);
                if (parens.step) step = "(" + step + ")";
                str += ":" + step;
            }
            var end = this.end.toString(options);
            if (parens.end) end = "(" + end + ")";
            str += ":" + end;
            return str;
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $de26fa0fce424851$var$name,
                start: this.start,
                end: this.end,
                step: this.step
            };
        }
        /**
     * Instantiate an RangeNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "RangeNode", "start": ..., "end": ..., "step": ...}`,
     *     where mathjs is optional
     * @returns {RangeNode}
     */ static fromJSON(json) {
            return new RangeNode(json.start, json.end, json.step);
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */ _toHTML(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var parens = calculateNecessaryParentheses(this, parenthesis, options && options.implicit);
            // format string as start:step:stop
            var str;
            var start = this.start.toHTML(options);
            if (parens.start) start = '<span class="math-parenthesis math-round-parenthesis">(</span>' + start + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            str = start;
            if (this.step) {
                var step = this.step.toHTML(options);
                if (parens.step) step = '<span class="math-parenthesis math-round-parenthesis">(</span>' + step + '<span class="math-parenthesis math-round-parenthesis">)</span>';
                str += '<span class="math-operator math-range-operator">:</span>' + step;
            }
            var end = this.end.toHTML(options);
            if (parens.end) end = '<span class="math-parenthesis math-round-parenthesis">(</span>' + end + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            str += '<span class="math-operator math-range-operator">:</span>' + end;
            return str;
        }
        /**
     * Get LaTeX representation
     * @params {Object} options
     * @return {string} str
     */ _toTex(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var parens = calculateNecessaryParentheses(this, parenthesis, options && options.implicit);
            var str = this.start.toTex(options);
            if (parens.start) str = "\\left(".concat(str, "\\right)");
            if (this.step) {
                var step = this.step.toTex(options);
                if (parens.step) step = "\\left(".concat(step, "\\right)");
                str += ":" + step;
            }
            var end = this.end.toTex(options);
            if (parens.end) end = "\\left(".concat(end, "\\right)");
            str += ":" + end;
            return str;
        }
        /**
     * @constructor RangeNode
     * @extends {Node}
     * create a range
     * @param {Node} start  included lower-bound
     * @param {Node} end    included upper-bound
     * @param {Node} [step] optional step
     */ constructor(start, end, step){
            super();
            // validate inputs
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(start)) throw new TypeError("Node expected");
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(end)) throw new TypeError("Node expected");
            if (step && !(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(step)) throw new TypeError("Node expected");
            if (arguments.length > 3) throw new Error("Too many arguments");
            this.start = start; // included lower-bound
            this.end = end; // included upper-bound
            this.step = step || null; // optional step
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(RangeNode, "name", $de26fa0fce424851$var$name);
    return RangeNode;
}, {
    isClass: true,
    isNode: true
});



var $20714f3d27f9f19d$var$name = "range";
var $20714f3d27f9f19d$var$dependencies = [
    "typed",
    "config",
    "?matrix",
    "?bignumber",
    "smaller",
    "smallerEq",
    "larger",
    "largerEq",
    "add",
    "isPositive"
];
var $20714f3d27f9f19d$export$af4628cd15bbfbf2 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($20714f3d27f9f19d$var$name, $20714f3d27f9f19d$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, bignumber: bignumber, smaller: smaller, smallerEq: smallerEq, larger: larger, largerEq: largerEq, add: add, isPositive: isPositive } = _ref;
    var range = (0, $74b267caaabc4839$export$d372f2f3c4d1b8e5)({
        typed: typed,
        config: config,
        matrix: matrix,
        bignumber: bignumber,
        smaller: smaller,
        smallerEq: smallerEq,
        larger: larger,
        largerEq: largerEq,
        add: add,
        isPositive: isPositive
    });
    /**
   * Attach a transform function to math.range
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */ return typed("range", {
        "...any": function any(args) {
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if (typeof last !== "boolean") // append a parameter includeEnd=true
            args.push(true);
            return range.apply(null, args);
        }
    });
}, {
    isTransformFunction: true
});



var $c072013d25c4273c$var$name = "rationalize";
var $c072013d25c4273c$var$dependencies = [
    "config",
    "typed",
    "equal",
    "isZero",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "parse",
    "simplifyConstant",
    "simplifyCore",
    "simplify",
    "?bignumber",
    "?fraction",
    "mathWithTransform",
    "matrix",
    "AccessorNode",
    "ArrayNode",
    "ConstantNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "SymbolNode",
    "ParenthesisNode"
];
var $c072013d25c4273c$export$abd0968f5b11b2a8 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($c072013d25c4273c$var$name, $c072013d25c4273c$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, equal: equal, isZero: isZero, add: add, subtract: subtract, multiply: multiply, divide: divide, pow: pow, parse: parse, simplifyConstant: simplifyConstant, simplifyCore: simplifyCore, simplify: simplify, fraction: fraction, bignumber: bignumber, mathWithTransform: mathWithTransform, matrix: matrix, AccessorNode: AccessorNode, ArrayNode: ArrayNode, ConstantNode: ConstantNode, FunctionNode: FunctionNode, IndexNode: IndexNode, ObjectNode: ObjectNode, OperatorNode: OperatorNode, SymbolNode: SymbolNode, ParenthesisNode: ParenthesisNode } = _ref;
    /**
   * Transform a rationalizable expression in a rational fraction.
   * If rational fraction is one variable polynomial then converts
   * the numerator and denominator in canonical form, with decreasing
   * exponents, returning the coefficients of numerator.
   *
   * Syntax:
   *
   *     math.rationalize(expr)
   *     math.rationalize(expr, detailed)
   *     math.rationalize(expr, scope)
   *     math.rationalize(expr, scope, detailed)
   *
   * Examples:
   *
   *     math.rationalize('sin(x)+y')
   *                   //  Error: There is an unsolved function call
   *     math.rationalize('2x/y - y/(x+1)')
   *                   // (2*x^2-y^2+2*x)/(x*y+y)
   *     math.rationalize('(2x+1)^6')
   *                   // 64*x^6+192*x^5+240*x^4+160*x^3+60*x^2+12*x+1
   *     math.rationalize('2x/( (2x-1) / (3x+2) ) - 5x/ ( (3x+4) / (2x^2-5) ) + 3')
   *                   // -20*x^4+28*x^3+104*x^2+6*x-12)/(6*x^2+5*x-4)
   *     math.rationalize('x/(1-x)/(x-2)/(x-3)/(x-4) + 2x/ ( (1-2x)/(2-3x) )/ ((3-4x)/(4-5x) )') =
   *                   // (-30*x^7+344*x^6-1506*x^5+3200*x^4-3472*x^3+1846*x^2-381*x)/
   *                   //     (-8*x^6+90*x^5-383*x^4+780*x^3-797*x^2+390*x-72)
   *
   *     math.rationalize('x+x+x+y',{y:1}) // 3*x+1
   *     math.rationalize('x+x+x+y',{})    // 3*x+y
   *
   *     const ret = math.rationalize('x+x+x+y',{},true)
   *                   // ret.expression=3*x+y, ret.variables = ["x","y"]
   *     const ret = math.rationalize('-2+5x^2',{},true)
   *                   // ret.expression=5*x^2-2, ret.variables = ["x"], ret.coefficients=[-2,0,5]
   *
   * See also:
   *
   *     simplify
   *
   * @param  {Node|string} expr    The expression to check if is a polynomial expression
   * @param  {Object|boolean}      optional scope of expression or true for already evaluated rational expression at input
   * @param  {Boolean}  detailed   optional True if return an object, false if return expression node (default)
   *
   * @return {Object | Node}    The rational polynomial of `expr` or an object
   *            `{expression, numerator, denominator, variables, coefficients}`, where
   *              `expression` is a `Node` with the node simplified expression,
   *              `numerator` is a `Node` with the simplified numerator of expression,
   *              `denominator` is a `Node` or `boolean` with the simplified denominator or `false` (if there is no denominator),
   *              `variables` is an array with variable names,
   *              and `coefficients` is an array with coefficients of numerator sorted by increased exponent
   *           {Expression Node}  node simplified expression
   *
   */ function _rationalize(expr) {
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var detailed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var setRules = rulesRationalize(); // Rules for change polynomial in near canonical form
        var polyRet = polynomial(expr, scope, true, setRules.firstRules); // Check if expression is a rationalizable polynomial
        var nVars = polyRet.variables.length;
        var noExactFractions = {
            exactFractions: false
        };
        var withExactFractions = {
            exactFractions: true
        };
        expr = polyRet.expression;
        if (nVars >= 1) {
            // If expression in not a constant
            expr = expandPower(expr); // First expand power of polynomials (cannot be made from rules!)
            var sBefore; // Previous expression
            var rules;
            var eDistrDiv = true;
            var redoInic = false;
            // Apply the initial rules, including succ div rules:
            expr = simplify(expr, setRules.firstRules, {}, noExactFractions);
            var s;
            while(true){
                // Alternate applying successive division rules and distr.div.rules
                // until there are no more changes:
                rules = eDistrDiv ? setRules.distrDivRules : setRules.sucDivRules;
                expr = simplify(expr, rules, {}, withExactFractions);
                eDistrDiv = !eDistrDiv; // Swap between Distr.Div and Succ. Div. Rules
                s = expr.toString();
                if (s === sBefore) break; // No changes : end of the loop
                redoInic = true;
                sBefore = s;
            }
            if (redoInic) // Apply first rules again without succ div rules (if there are changes)
            expr = simplify(expr, setRules.firstRulesAgain, {}, noExactFractions);
            // Apply final rules:
            expr = simplify(expr, setRules.finalRules, {}, noExactFractions);
        } // NVars >= 1
        var coefficients = [];
        var retRationalize = {};
        if (expr.type === "OperatorNode" && expr.isBinary() && expr.op === "/") {
            // Separate numerator from denominator
            if (nVars === 1) {
                expr.args[0] = polyToCanonical(expr.args[0], coefficients);
                expr.args[1] = polyToCanonical(expr.args[1]);
            }
            if (detailed) {
                retRationalize.numerator = expr.args[0];
                retRationalize.denominator = expr.args[1];
            }
        } else {
            if (nVars === 1) expr = polyToCanonical(expr, coefficients);
            if (detailed) {
                retRationalize.numerator = expr;
                retRationalize.denominator = null;
            }
        }
        // nVars
        if (!detailed) return expr;
        retRationalize.coefficients = coefficients;
        retRationalize.variables = polyRet.variables;
        retRationalize.expression = expr;
        return retRationalize;
    }
    return typed($c072013d25c4273c$var$name, {
        Node: _rationalize,
        "Node, boolean": (expr, detailed)=>_rationalize(expr, {}, detailed),
        "Node, Object": _rationalize,
        "Node, Object, boolean": _rationalize
    }); // end of typed rationalize
    /**
   *  Function to simplify an expression using an optional scope and
   *  return it if the expression is a polynomial expression, i.e.
   *  an expression with one or more variables and the operators
   *  +, -, *, and ^, where the exponent can only be a positive integer.
   *
   * Syntax:
   *
   *     polynomial(expr,scope,extended, rules)
   *
   * @param  {Node | string} expr     The expression to simplify and check if is polynomial expression
   * @param  {object} scope           Optional scope for expression simplification
   * @param  {boolean} extended       Optional. Default is false. When true allows divide operator.
   * @param  {array}  rules           Optional. Default is no rule.
   *
   *
   * @return {Object}
   *            {Object} node:   node simplified expression
   *            {Array}  variables:  variable names
   */ function polynomial(expr, scope, extended, rules) {
        var variables = [];
        var node = simplify(expr, rules, scope, {
            exactFractions: false
        }); // Resolves any variables and functions with all defined parameters
        extended = !!extended;
        var oper = "+-*" + (extended ? "/" : "");
        recPoly(node);
        var retFunc = {};
        retFunc.expression = node;
        retFunc.variables = variables;
        return retFunc;
        // -------------------------------------------------------------------------------------------------------
        /**
     *  Function to simplify an expression using an optional scope and
     *  return it if the expression is a polynomial expression, i.e.
     *  an expression with one or more variables and the operators
     *  +, -, *, and ^, where the exponent can only be a positive integer.
     *
     * Syntax:
     *
     *     recPoly(node)
     *
     *
     * @param  {Node} node               The current sub tree expression in recursion
     *
     * @return                           nothing, throw an exception if error
     */ function recPoly(node) {
            var tp = node.type; // node type
            if (tp === "FunctionNode") // No function call in polynomial expression
            throw new Error("There is an unsolved function call");
            else if (tp === "OperatorNode") {
                if (node.op === "^") {
                    // TODO: handle negative exponents like in '1/x^(-2)'
                    if (node.args[1].type !== "ConstantNode" || !(0, $a246eb207aab6d09$export$a287f47fed4544b8)(parseFloat(node.args[1].value))) throw new Error("There is a non-integer exponent");
                    else recPoly(node.args[0]);
                } else {
                    if (!oper.includes(node.op)) throw new Error("Operator " + node.op + " invalid in polynomial expression");
                    for(var i = 0; i < node.args.length; i++)recPoly(node.args[i]);
                } // type of operator
            } else if (tp === "SymbolNode") {
                var _name = node.name; // variable name
                var pos = variables.indexOf(_name);
                if (pos === -1) // new variable in expression
                variables.push(_name);
            } else if (tp === "ParenthesisNode") recPoly(node.content);
            else if (tp !== "ConstantNode") throw new Error("type " + tp + " is not allowed in polynomial expression");
        } // end of recPoly
    } // end of polynomial
    // ---------------------------------------------------------------------------------------
    /**
   * Return a rule set to rationalize an polynomial expression in rationalize
   *
   * Syntax:
   *
   *     rulesRationalize()
   *
   * @return {array}        rule set to rationalize an polynomial expression
   */ function rulesRationalize() {
        var oldRules = [
            simplifyCore,
            // sCore
            {
                l: "n+n",
                r: "2*n"
            },
            {
                l: "n+-n",
                r: "0"
            },
            simplifyConstant,
            // sConstant
            {
                l: "n*(n1^-1)",
                r: "n/n1"
            },
            {
                l: "n*n1^-n2",
                r: "n/n1^n2"
            },
            {
                l: "n1^-1",
                r: "1/n1"
            },
            {
                l: "n*(n1/n2)",
                r: "(n*n1)/n2"
            },
            {
                l: "1*n",
                r: "n"
            }
        ];
        var rulesFirst = [
            {
                l: "(-n1)/(-n2)",
                r: "n1/n2"
            },
            // Unary division
            {
                l: "(-n1)*(-n2)",
                r: "n1*n2"
            },
            // Unary multiplication
            {
                l: "n1--n2",
                r: "n1+n2"
            },
            // '--' elimination
            {
                l: "n1-n2",
                r: "n1+(-n2)"
            },
            // Subtraction turn into add with un�ry minus
            {
                l: "(n1+n2)*n3",
                r: "(n1*n3 + n2*n3)"
            },
            // Distributive 1
            {
                l: "n1*(n2+n3)",
                r: "(n1*n2+n1*n3)"
            },
            // Distributive 2
            {
                l: "c1*n + c2*n",
                r: "(c1+c2)*n"
            },
            // Joining constants
            {
                l: "c1*n + n",
                r: "(c1+1)*n"
            },
            // Joining constants
            {
                l: "c1*n - c2*n",
                r: "(c1-c2)*n"
            },
            // Joining constants
            {
                l: "c1*n - n",
                r: "(c1-1)*n"
            },
            // Joining constants
            {
                l: "v/c",
                r: "(1/c)*v"
            },
            // variable/constant (new!)
            {
                l: "v/-c",
                r: "-(1/c)*v"
            },
            // variable/constant (new!)
            {
                l: "-v*-c",
                r: "c*v"
            },
            // Inversion constant and variable 1
            {
                l: "-v*c",
                r: "-c*v"
            },
            // Inversion constant and variable 2
            {
                l: "v*-c",
                r: "-c*v"
            },
            // Inversion constant and variable 3
            {
                l: "v*c",
                r: "c*v"
            },
            // Inversion constant and variable 4
            {
                l: "-(-n1*n2)",
                r: "(n1*n2)"
            },
            // Unary propagation
            {
                l: "-(n1*n2)",
                r: "(-n1*n2)"
            },
            // Unary propagation
            {
                l: "-(-n1+n2)",
                r: "(n1-n2)"
            },
            // Unary propagation
            {
                l: "-(n1+n2)",
                r: "(-n1-n2)"
            },
            // Unary propagation
            {
                l: "(n1^n2)^n3",
                r: "(n1^(n2*n3))"
            },
            // Power to Power
            {
                l: "-(-n1/n2)",
                r: "(n1/n2)"
            },
            // Division and Unary
            {
                l: "-(n1/n2)",
                r: "(-n1/n2)"
            }
        ]; // Divisao and Unary
        var rulesDistrDiv = [
            {
                l: "(n1/n2 + n3/n4)",
                r: "((n1*n4 + n3*n2)/(n2*n4))"
            },
            // Sum of fractions
            {
                l: "(n1/n2 + n3)",
                r: "((n1 + n3*n2)/n2)"
            },
            // Sum fraction with number 1
            {
                l: "(n1 + n2/n3)",
                r: "((n1*n3 + n2)/n3)"
            }
        ]; // Sum fraction with number 1
        var rulesSucDiv = [
            {
                l: "(n1/(n2/n3))",
                r: "((n1*n3)/n2)"
            },
            // Division simplification
            {
                l: "(n1/n2/n3)",
                r: "(n1/(n2*n3))"
            }
        ];
        var setRules = {}; // rules set in 4 steps.
        // All rules => infinite loop
        // setRules.allRules =oldRules.concat(rulesFirst,rulesDistrDiv,rulesSucDiv)
        setRules.firstRules = oldRules.concat(rulesFirst, rulesSucDiv); // First rule set
        setRules.distrDivRules = rulesDistrDiv; // Just distr. div. rules
        setRules.sucDivRules = rulesSucDiv; // Jus succ. div. rules
        setRules.firstRulesAgain = oldRules.concat(rulesFirst); // Last rules set without succ. div.
        // Division simplification
        // Second rule set.
        // There is no aggregate expression with parentesis, but the only variable can be scattered.
        setRules.finalRules = [
            simplifyCore,
            // simplify.rules[0]
            {
                l: "n*-n",
                r: "-n^2"
            },
            // Joining multiply with power 1
            {
                l: "n*n",
                r: "n^2"
            },
            // Joining multiply with power 2
            simplifyConstant,
            // simplify.rules[14] old 3rd index in oldRules
            {
                l: "n*-n^n1",
                r: "-n^(n1+1)"
            },
            // Joining multiply with power 3
            {
                l: "n*n^n1",
                r: "n^(n1+1)"
            },
            // Joining multiply with power 4
            {
                l: "n^n1*-n^n2",
                r: "-n^(n1+n2)"
            },
            // Joining multiply with power 5
            {
                l: "n^n1*n^n2",
                r: "n^(n1+n2)"
            },
            // Joining multiply with power 6
            {
                l: "n^n1*-n",
                r: "-n^(n1+1)"
            },
            // Joining multiply with power 7
            {
                l: "n^n1*n",
                r: "n^(n1+1)"
            },
            // Joining multiply with power 8
            {
                l: "n^n1/-n",
                r: "-n^(n1-1)"
            },
            // Joining multiply with power 8
            {
                l: "n^n1/n",
                r: "n^(n1-1)"
            },
            // Joining division with power 1
            {
                l: "n/-n^n1",
                r: "-n^(1-n1)"
            },
            // Joining division with power 2
            {
                l: "n/n^n1",
                r: "n^(1-n1)"
            },
            // Joining division with power 3
            {
                l: "n^n1/-n^n2",
                r: "n^(n1-n2)"
            },
            // Joining division with power 4
            {
                l: "n^n1/n^n2",
                r: "n^(n1-n2)"
            },
            // Joining division with power 5
            {
                l: "n1+(-n2*n3)",
                r: "n1-n2*n3"
            },
            // Solving useless parenthesis 1
            {
                l: "v*(-c)",
                r: "-c*v"
            },
            // Solving useless unary 2
            {
                l: "n1+-n2",
                r: "n1-n2"
            },
            // Solving +- together (new!)
            {
                l: "v*c",
                r: "c*v"
            },
            // inversion constant with variable
            {
                l: "(n1^n2)^n3",
                r: "(n1^(n2*n3))"
            } // Power to Power
        ];
        return setRules;
    } // End rulesRationalize
    // ---------------------------------------------------------------------------------------
    /**
   *  Expand recursively a tree node for handling with expressions with exponents
   *  (it's not for constants, symbols or functions with exponents)
   *  PS: The other parameters are internal for recursion
   *
   * Syntax:
   *
   *     expandPower(node)
   *
   * @param  {Node} node         Current expression node
   * @param  {node} parent       Parent current node inside the recursion
   * @param  (int}               Parent number of chid inside the rercursion
   *
   * @return {node}        node expression with all powers expanded.
   */ function expandPower(node, parent, indParent) {
        var tp = node.type;
        var internal = arguments.length > 1; // TRUE in internal calls
        if (tp === "OperatorNode" && node.isBinary()) {
            var does = false;
            var val;
            if (node.op === "^") // First operator: Parenthesis or UnaryMinus
            {
                if ((node.args[0].type === "ParenthesisNode" || node.args[0].type === "OperatorNode") && node.args[1].type === "ConstantNode") {
                    // Second operator: Constant
                    val = parseFloat(node.args[1].value);
                    does = val >= 2 && (0, $a246eb207aab6d09$export$a287f47fed4544b8)(val);
                }
            }
            if (does) {
                // Exponent >= 2
                // Before:
                //            operator A --> Subtree
                // parent pow
                //            constant
                //
                if (val > 2) {
                    // Exponent > 2,
                    // AFTER:  (exponent > 2)
                    //             operator A --> Subtree
                    // parent  *
                    //                 deep clone (operator A --> Subtree
                    //             pow
                    //                 constant - 1
                    //
                    var nEsqTopo = node.args[0];
                    var nDirTopo = new OperatorNode("^", "pow", [
                        node.args[0].cloneDeep(),
                        new ConstantNode(val - 1)
                    ]);
                    node = new OperatorNode("*", "multiply", [
                        nEsqTopo,
                        nDirTopo
                    ]);
                } else // Expo = 2 - no power
                // AFTER:  (exponent =  2)
                //             operator A --> Subtree
                // parent   oper
                //            deep clone (operator A --> Subtree)
                //
                node = new OperatorNode("*", "multiply", [
                    node.args[0],
                    node.args[0].cloneDeep()
                ]);
                if (internal) {
                    // Change parent references in internal recursive calls
                    if (indParent === "content") parent.content = node;
                    else parent.args[indParent] = node;
                }
            } // does
        } // binary OperatorNode
        if (tp === "ParenthesisNode") // Recursion
        expandPower(node.content, node, "content");
        else if (tp !== "ConstantNode" && tp !== "SymbolNode") for(var i = 0; i < node.args.length; i++)expandPower(node.args[i], node, i);
        if (!internal) // return the root node
        return node;
    } // End expandPower
    // ---------------------------------------------------------------------------------------
    /**
   * Auxilary function for rationalize
   * Convert near canonical polynomial in one variable in a canonical polynomial
   * with one term for each exponent in decreasing order
   *
   * Syntax:
   *
   *     polyToCanonical(node [, coefficients])
   *
   * @param  {Node | string} expr       The near canonical polynomial expression to convert in a a canonical polynomial expression
   *
   *        The string or tree expression needs to be at below syntax, with free spaces:
   *         (  (^(-)? | [+-]? )cte (*)? var (^expo)?  | cte )+
   *       Where 'var' is one variable with any valid name
   *             'cte' are real numeric constants with any value. It can be omitted if equal than 1
   *             'expo' are integers greater than 0. It can be omitted if equal than 1.
   *
   * @param  {array}   coefficients             Optional returns coefficients sorted by increased exponent
   *
   *
   * @return {node}        new node tree with one variable polynomial or string error.
   */ function polyToCanonical(node, coefficients) {
        if (coefficients === undefined) coefficients = [];
         // coefficients.
        coefficients[0] = 0; // index is the exponent
        var o = {};
        o.cte = 1;
        o.oper = "+";
        // fire: mark with * or ^ when finds * or ^ down tree, reset to "" with + and -.
        //       It is used to deduce the exponent: 1 for *, 0 for "".
        o.fire = "";
        var maxExpo = 0; // maximum exponent
        var varname = ""; // variable name
        recurPol(node, null, o);
        maxExpo = coefficients.length - 1;
        var first = true;
        var no;
        for(var i = maxExpo; i >= 0; i--){
            if (coefficients[i] === 0) continue;
            var n1 = new ConstantNode(first ? coefficients[i] : Math.abs(coefficients[i]));
            var op = coefficients[i] < 0 ? "-" : "+";
            if (i > 0) {
                // Is not a constant without variable
                var n2 = new SymbolNode(varname);
                if (i > 1) {
                    var n3 = new ConstantNode(i);
                    n2 = new OperatorNode("^", "pow", [
                        n2,
                        n3
                    ]);
                }
                if (coefficients[i] === -1 && first) n1 = new OperatorNode("-", "unaryMinus", [
                    n2
                ]);
                else if (Math.abs(coefficients[i]) === 1) n1 = n2;
                else n1 = new OperatorNode("*", "multiply", [
                    n1,
                    n2
                ]);
            }
            if (first) no = n1;
            else if (op === "+") no = new OperatorNode("+", "add", [
                no,
                n1
            ]);
            else no = new OperatorNode("-", "subtract", [
                no,
                n1
            ]);
            first = false;
        } // for
        if (first) return new ConstantNode(0);
        else return no;
        /**
     * Recursive auxilary function inside polyToCanonical for
     * converting expression in canonical form
     *
     * Syntax:
     *
     *     recurPol(node, noPai, obj)
     *
     * @param  {Node} node        The current subpolynomial expression
     * @param  {Node | Null}  noPai   The current parent node
     * @param  {object}    obj        Object with many internal flags
     *
     * @return {}                    No return. If error, throws an exception
     */ function recurPol(node, noPai, o) {
            var tp = node.type;
            if (tp === "FunctionNode") // ***** FunctionName *****
            // No function call in polynomial expression
            throw new Error("There is an unsolved function call");
            else if (tp === "OperatorNode") {
                // ***** OperatorName *****
                if (!"+-*^".includes(node.op)) throw new Error("Operator " + node.op + " invalid");
                if (noPai !== null) {
                    // -(unary),^  : children of *,+,-
                    if ((node.fn === "unaryMinus" || node.fn === "pow") && noPai.fn !== "add" && noPai.fn !== "subtract" && noPai.fn !== "multiply") throw new Error("Invalid " + node.op + " placing");
                    // -,+,* : children of +,-
                    if ((node.fn === "subtract" || node.fn === "add" || node.fn === "multiply") && noPai.fn !== "add" && noPai.fn !== "subtract") throw new Error("Invalid " + node.op + " placing");
                    // -,+ : first child
                    if ((node.fn === "subtract" || node.fn === "add" || node.fn === "unaryMinus") && o.noFil !== 0) throw new Error("Invalid " + node.op + " placing");
                } // Has parent
                // Firers: ^,*       Old:   ^,&,-(unary): firers
                if (node.op === "^" || node.op === "*") o.fire = node.op;
                for(var _i = 0; _i < node.args.length; _i++){
                    // +,-: reset fire
                    if (node.fn === "unaryMinus") o.oper = "-";
                    if (node.op === "+" || node.fn === "subtract") {
                        o.fire = "";
                        o.cte = 1; // default if there is no constant
                        o.oper = _i === 0 ? "+" : node.op;
                    }
                    o.noFil = _i; // number of son
                    recurPol(node.args[_i], node, o);
                } // for in children
            } else if (tp === "SymbolNode") {
                // ***** SymbolName *****
                if (node.name !== varname && varname !== "") throw new Error("There is more than one variable");
                varname = node.name;
                if (noPai === null) {
                    coefficients[1] = 1;
                    return;
                }
                // ^: Symbol is First child
                if (noPai.op === "^" && o.noFil !== 0) throw new Error("In power the variable should be the first parameter");
                // *: Symbol is Second child
                if (noPai.op === "*" && o.noFil !== 1) throw new Error("In multiply the variable should be the second parameter");
                // Symbol: firers '',* => it means there is no exponent above, so it's 1 (cte * var)
                if (o.fire === "" || o.fire === "*") {
                    if (maxExpo < 1) coefficients[1] = 0;
                    coefficients[1] += o.cte * (o.oper === "+" ? 1 : -1);
                    maxExpo = Math.max(1, maxExpo);
                }
            } else if (tp === "ConstantNode") {
                var valor = parseFloat(node.value);
                if (noPai === null) {
                    coefficients[0] = valor;
                    return;
                }
                if (noPai.op === "^") {
                    // cte: second  child of power
                    if (o.noFil !== 1) throw new Error("Constant cannot be powered");
                    if (!(0, $a246eb207aab6d09$export$a287f47fed4544b8)(valor) || valor <= 0) throw new Error("Non-integer exponent is not allowed");
                    for(var _i2 = maxExpo + 1; _i2 < valor; _i2++)coefficients[_i2] = 0;
                    if (valor > maxExpo) coefficients[valor] = 0;
                    coefficients[valor] += o.cte * (o.oper === "+" ? 1 : -1);
                    maxExpo = Math.max(valor, maxExpo);
                    return;
                }
                o.cte = valor;
                // Cte: firer '' => There is no exponent and no multiplication, so the exponent is 0.
                if (o.fire === "") coefficients[0] += o.cte * (o.oper === "+" ? 1 : -1);
            } else throw new Error("Type " + tp + " is not allowed");
        } // End of recurPol
    } // End of polyToCanonical
});







var $12a7d4387caa5292$var$name = "RelationalNode";
var $12a7d4387caa5292$var$dependencies = [
    "Node"
];
var $12a7d4387caa5292$export$92a3c2dff1e32f25 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($12a7d4387caa5292$var$name, $12a7d4387caa5292$var$dependencies, (_ref)=>{
    var { Node: Node } = _ref;
    var operatorMap = {
        equal: "==",
        unequal: "!=",
        smaller: "<",
        larger: ">",
        smallerEq: "<=",
        largerEq: ">="
    };
    class RelationalNode extends Node {
        get type() {
            return $12a7d4387caa5292$var$name;
        }
        get isRelationalNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            var self = this;
            var compiled = this.params.map((p)=>p._compile(math, argNames));
            return function evalRelationalNode(scope, args, context) {
                var evalLhs;
                var evalRhs = compiled[0](scope, args, context);
                for(var i = 0; i < self.conditionals.length; i++){
                    evalLhs = evalRhs;
                    evalRhs = compiled[i + 1](scope, args, context);
                    var condFn = (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(math, self.conditionals[i]);
                    if (!condFn(evalLhs, evalRhs)) return false;
                }
                return true;
            };
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
            this.params.forEach((n, i)=>callback(n, "params[" + i + "]", this), this);
        }
        /**
     * Create a new RelationalNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {RelationalNode} Returns a transformed copy of the node
     */ map(callback) {
            return new RelationalNode(this.conditionals.slice(), this.params.map((n, i)=>this._ifNode(callback(n, "params[" + i + "]", this)), this));
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {RelationalNode}
     */ clone() {
            return new RelationalNode(this.conditionals, this.params);
        }
        /**
     * Get string representation.
     * @param {Object} options
     * @return {string} str
     */ _toString(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var precedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(this, parenthesis, options && options.implicit);
            var paramStrings = this.params.map(function(p, index) {
                var paramPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(p, parenthesis, options && options.implicit);
                return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? "(" + p.toString(options) + ")" : p.toString(options);
            });
            var ret = paramStrings[0];
            for(var i = 0; i < this.conditionals.length; i++){
                ret += " " + operatorMap[this.conditionals[i]];
                ret += " " + paramStrings[i + 1];
            }
            return ret;
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: $12a7d4387caa5292$var$name,
                conditionals: this.conditionals,
                params: this.params
            };
        }
        /**
     * Instantiate a RelationalNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "RelationalNode", "conditionals": ..., "params": ...}`,
     *     where mathjs is optional
     * @returns {RelationalNode}
     */ static fromJSON(json) {
            return new RelationalNode(json.conditionals, json.params);
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */ _toHTML(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var precedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(this, parenthesis, options && options.implicit);
            var paramStrings = this.params.map(function(p, index) {
                var paramPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(p, parenthesis, options && options.implicit);
                return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + p.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : p.toHTML(options);
            });
            var ret = paramStrings[0];
            for(var i = 0; i < this.conditionals.length; i++)ret += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(operatorMap[this.conditionals[i]]) + "</span>" + paramStrings[i + 1];
            return ret;
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */ _toTex(options) {
            var parenthesis = options && options.parenthesis ? options.parenthesis : "keep";
            var precedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(this, parenthesis, options && options.implicit);
            var paramStrings = this.params.map(function(p, index) {
                var paramPrecedence = (0, $c57e483ac23cf50e$export$94314bea1477f3d5)(p, parenthesis, options && options.implicit);
                return parenthesis === "all" || paramPrecedence !== null && paramPrecedence <= precedence ? "\\left(" + p.toTex(options) + "\right)" : p.toTex(options);
            });
            var ret = paramStrings[0];
            for(var i = 0; i < this.conditionals.length; i++)ret += (0, $a279f526ff78ebb8$export$c728a46e4168cd75)[this.conditionals[i]] + paramStrings[i + 1];
            return ret;
        }
        /**
     * A node representing a chained conditional expression, such as 'x > y > z'
     *
     * @param {String[]} conditionals
     *     An array of conditional operators used to compare the parameters
     * @param {Node[]} params
     *     The parameters that will be compared
     *
     * @constructor RelationalNode
     * @extends {Node}
     */ constructor(conditionals, params){
            super();
            if (!Array.isArray(conditionals)) throw new TypeError("Parameter conditionals must be an array");
            if (!Array.isArray(params)) throw new TypeError("Parameter params must be an array");
            if (conditionals.length !== params.length - 1) throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");
            this.conditionals = conditionals;
            this.params = params;
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(RelationalNode, "name", $12a7d4387caa5292$var$name);
    return RelationalNode;
}, {
    isClass: true,
    isNode: true
});




var $97eacd48883b17c3$var$name = "resolve";
var $97eacd48883b17c3$var$dependencies = [
    "typed",
    "parse",
    "ConstantNode",
    "FunctionNode",
    "OperatorNode",
    "ParenthesisNode"
];
var $97eacd48883b17c3$export$de059f4622c7c2ca = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($97eacd48883b17c3$var$name, $97eacd48883b17c3$var$dependencies, (_ref)=>{
    var { typed: typed, parse: parse, ConstantNode: ConstantNode, FunctionNode: FunctionNode, OperatorNode: OperatorNode, ParenthesisNode: ParenthesisNode } = _ref;
    /**
   * resolve(expr, scope) replaces variable nodes with their scoped values
   *
   * Syntax:
   *
   *     math.resolve(expr, scope)
   *
   * Examples:
   *
   *     math.resolve('x + y', {x:1, y:2})           // Node '1 + 2'
   *     math.resolve(math.parse('x+y'), {x:1, y:2}) // Node '1 + 2'
   *     math.simplify('x+y', {x:2, y: math.parse('x+x')}).toString() // "6"
   *
   * See also:
   *
   *     simplify, evaluate
   *
   * @param {Node | Node[]} node
   *     The expression tree (or trees) to be simplified
   * @param {Object} scope
   *     Scope specifying variables to be resolved
   * @return {Node | Node[]} Returns `node` with variables recursively substituted.
   * @throws {ReferenceError}
   *     If there is a cyclic dependency among the variables in `scope`,
   *     resolution is impossible and a ReferenceError is thrown.
   */ function _resolve(node, scope) {
        var within = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();
        // note `within`:
        // `within` is not documented, since it is for internal cycle
        // detection only
        if (!scope) return node;
        if ((0, $23cfe017d190638f$export$87815d550facaed9)(node)) {
            if (within.has(node.name)) {
                var variables = Array.from(within).join(", ");
                throw new ReferenceError("recursive loop of variable definitions among {".concat(variables, "}"));
            }
            var value = scope.get(node.name);
            if ((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(value)) {
                var nextWithin = new Set(within);
                nextWithin.add(node.name);
                return _resolve(value, scope, nextWithin);
            } else if (typeof value === "number") return parse(String(value));
            else if (value !== undefined) return new ConstantNode(value);
            else return node;
        } else if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(node)) {
            var args = node.args.map(function(arg) {
                return _resolve(arg, scope, within);
            });
            return new OperatorNode(node.op, node.fn, args, node.implicit);
        } else if ((0, $23cfe017d190638f$export$c55e3736c5721220)(node)) return new ParenthesisNode(_resolve(node.content, scope, within));
        else if ((0, $23cfe017d190638f$export$6ae03b16e064e6c4)(node)) {
            var _args = node.args.map(function(arg) {
                return _resolve(arg, scope, within);
            });
            return new FunctionNode(node.name, _args);
        }
        // Otherwise just recursively resolve any children (might also work
        // for some of the above special cases)
        return node.map((child)=>_resolve(child, scope, within));
    }
    return typed("resolve", {
        Node: _resolve,
        "Node, Map | null | undefined": _resolve,
        "Node, Object": (n, scope)=>_resolve(n, (0, $ec715b2ae25daaa7$export$d49c9aa30b771d59)(scope)),
        // For arrays and matrices, we map `self` rather than `_resolve`
        // because resolve is fairly expensive anyway, and this way
        // we get nice error messages if one entry in the array has wrong type.
        "Array | Matrix": typed.referToSelf((self)=>(A)=>A.map((n)=>self(n))),
        "Array | Matrix, null | undefined": typed.referToSelf((self)=>(A)=>A.map((n)=>self(n))),
        "Array, Object": typed.referTo("Array,Map", (selfAM)=>(A, scope)=>selfAM(A, (0, $ec715b2ae25daaa7$export$d49c9aa30b771d59)(scope))),
        "Matrix, Object": typed.referTo("Matrix,Map", (selfMM)=>(A, scope)=>selfMM(A, (0, $ec715b2ae25daaa7$export$d49c9aa30b771d59)(scope))),
        "Array | Matrix, Map": typed.referToSelf((self)=>(A, scope)=>A.map((n)=>self(n, scope)))
    });
});


var $cb7ee8b7cdf26845$var$name = "reviver";
var $cb7ee8b7cdf26845$var$dependencies = [
    "classes"
];
var $cb7ee8b7cdf26845$export$288f43fef560974b = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($cb7ee8b7cdf26845$var$name, $cb7ee8b7cdf26845$var$dependencies, (_ref)=>{
    var { classes: classes } = _ref;
    /**
   * Instantiate mathjs data types from their JSON representation
   * @param {string} key
   * @param {*} value
   * @returns {*} Returns the revived object
   */ return function reviver(key, value) {
        var constructor = classes[value && value.mathjs];
        if (constructor && typeof constructor.fromJSON === "function") return constructor.fromJSON(value);
        return value;
    };
});





var $8192fdf9fd28a197$var$name = "row";
var $8192fdf9fd28a197$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $8192fdf9fd28a197$export$649101a1e7f0c38d = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($8192fdf9fd28a197$var$name, $8192fdf9fd28a197$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    var row = (0, $32060d84ed5feee2$export$3442c5d213434705)({
        typed: typed,
        Index: Index,
        matrix: matrix,
        range: range
    });
    // @see: comment of row itself
    return typed("row", {
        "...any": function any(args) {
            // change last argument from zero-based to one-based
            var lastIndex = args.length - 1;
            var last = args[lastIndex];
            if ((0, $23cfe017d190638f$export$7e4aa119212bc614)(last)) args[lastIndex] = last - 1;
            try {
                return row.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});



function $1c9160f94b30cbfc$export$ce146697ef73cd8f(x) {
    return (0, $23cfe017d190638f$export$fa9d80731fd8c54b)(x) || (0, $23cfe017d190638f$export$7e624cbaab6cce94)(x) && x.isUnary() && (0, $23cfe017d190638f$export$fa9d80731fd8c54b)(x.args[0]);
}
function $1c9160f94b30cbfc$export$aef723aba12fcd3d(x) {
    if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(x)) // Basic Constant types
    return true;
    if (((0, $23cfe017d190638f$export$6ae03b16e064e6c4)(x) || (0, $23cfe017d190638f$export$7e624cbaab6cce94)(x)) && x.args.every($1c9160f94b30cbfc$export$aef723aba12fcd3d)) // Can be constant depending on arguments
    return true;
    if ((0, $23cfe017d190638f$export$c55e3736c5721220)(x) && $1c9160f94b30cbfc$export$aef723aba12fcd3d(x.content)) // Parenthesis are transparent
    return true;
    return false; // Probably missing some edge cases
}







function $499efa357773e5f9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $499efa357773e5f9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $499efa357773e5f9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1209e17e2c23a854$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $499efa357773e5f9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $499efa357773e5f9$var$name = "simplifyUtil";
var $499efa357773e5f9$var$dependencies = [
    "FunctionNode",
    "OperatorNode",
    "SymbolNode"
];
var $499efa357773e5f9$export$f2206d57cebf291a = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($499efa357773e5f9$var$name, $499efa357773e5f9$var$dependencies, (_ref)=>{
    var { FunctionNode: FunctionNode, OperatorNode: OperatorNode, SymbolNode: SymbolNode } = _ref;
    // TODO commutative/associative properties rely on the arguments
    // e.g. multiply is not commutative for matrices
    // The properties should be calculated from an argument to simplify, or possibly something in math.config
    // the other option is for typed() to specify a return type so that we can evaluate the type of arguments
    /* So that properties of an operator fit on one line: */ var T = true;
    var F = false;
    var defaultName = "defaultF";
    var defaultContext = {
        /*      */ add: {
            trivial: T,
            total: T,
            commutative: T,
            associative: T
        },
        /**/ unaryPlus: {
            trivial: T,
            total: T,
            commutative: T,
            associative: T
        },
        /* */ subtract: {
            trivial: F,
            total: T,
            commutative: F,
            associative: F
        },
        /* */ multiply: {
            trivial: T,
            total: T,
            commutative: T,
            associative: T
        },
        /*   */ divide: {
            trivial: F,
            total: T,
            commutative: F,
            associative: F
        },
        /*    */ paren: {
            trivial: T,
            total: T,
            commutative: T,
            associative: F
        },
        /* */ defaultF: {
            trivial: F,
            total: T,
            commutative: F,
            associative: F
        }
    };
    var realContext = {
        divide: {
            total: F
        },
        log: {
            total: F
        }
    };
    var positiveContext = {
        subtract: {
            total: F
        },
        abs: {
            trivial: T
        },
        log: {
            total: T
        }
    };
    function hasProperty(nodeOrName, property) {
        var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultContext;
        var name = defaultName;
        if (typeof nodeOrName === "string") name = nodeOrName;
        else if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(nodeOrName)) name = nodeOrName.fn.toString();
        else if ((0, $23cfe017d190638f$export$6ae03b16e064e6c4)(nodeOrName)) name = nodeOrName.name;
        else if ((0, $23cfe017d190638f$export$c55e3736c5721220)(nodeOrName)) name = "paren";
        if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(context, name)) {
            var properties = context[name];
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(properties, property)) return properties[property];
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(defaultContext, name)) return defaultContext[name][property];
        }
        if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(context, defaultName)) {
            var _properties = context[defaultName];
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(_properties, property)) return _properties[property];
            return defaultContext[defaultName][property];
        }
        /* name not found in context and context has no global default */ /* So use default context. */ if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(defaultContext, name)) {
            var _properties2 = defaultContext[name];
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(_properties2, property)) return _properties2[property];
        }
        return defaultContext[defaultName][property];
    }
    function isCommutative(node) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultContext;
        return hasProperty(node, "commutative", context);
    }
    function isAssociative(node) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultContext;
        return hasProperty(node, "associative", context);
    }
    /**
   * Merge the given contexts, with primary overriding secondary
   * wherever they might conflict
   */ function mergeContext(primary, secondary) {
        var merged = $499efa357773e5f9$var$_objectSpread({}, primary);
        for(var prop in secondary)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(primary, prop)) merged[prop] = $499efa357773e5f9$var$_objectSpread($499efa357773e5f9$var$_objectSpread({}, secondary[prop]), primary[prop]);
        else merged[prop] = secondary[prop];
        return merged;
    }
    /**
   * Flatten all associative operators in an expression tree.
   * Assumes parentheses have already been removed.
   */ function flatten(node, context) {
        if (!node.args || node.args.length === 0) return node;
        node.args = allChildren(node, context);
        for(var i = 0; i < node.args.length; i++)flatten(node.args[i], context);
    }
    /**
   * Get the children of a node as if it has been flattened.
   * TODO implement for FunctionNodes
   */ function allChildren(node, context) {
        var op;
        var children = [];
        var findChildren = function findChildren(node) {
            for(var i = 0; i < node.args.length; i++){
                var child = node.args[i];
                if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(child) && op === child.op) findChildren(child);
                else children.push(child);
            }
        };
        if (isAssociative(node, context)) {
            op = node.op;
            findChildren(node);
            return children;
        } else return node.args;
    }
    /**
   *  Unflatten all flattened operators to a right-heavy binary tree.
   */ function unflattenr(node, context) {
        if (!node.args || node.args.length === 0) return;
        var makeNode = createMakeNodeFunction(node);
        var l = node.args.length;
        for(var i = 0; i < l; i++)unflattenr(node.args[i], context);
        if (l > 2 && isAssociative(node, context)) {
            var curnode = node.args.pop();
            while(node.args.length > 0)curnode = makeNode([
                node.args.pop(),
                curnode
            ]);
            node.args = curnode.args;
        }
    }
    /**
   *  Unflatten all flattened operators to a left-heavy binary tree.
   */ function unflattenl(node, context) {
        if (!node.args || node.args.length === 0) return;
        var makeNode = createMakeNodeFunction(node);
        var l = node.args.length;
        for(var i = 0; i < l; i++)unflattenl(node.args[i], context);
        if (l > 2 && isAssociative(node, context)) {
            var curnode = node.args.shift();
            while(node.args.length > 0)curnode = makeNode([
                curnode,
                node.args.shift()
            ]);
            node.args = curnode.args;
        }
    }
    function createMakeNodeFunction(node) {
        if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(node)) return function(args) {
            try {
                return new OperatorNode(node.op, node.fn, args, node.implicit);
            } catch (err) {
                console.error(err);
                return [];
            }
        };
        else return function(args) {
            return new FunctionNode(new SymbolNode(node.name), args);
        };
    }
    return {
        createMakeNodeFunction: createMakeNodeFunction,
        hasProperty: hasProperty,
        isCommutative: isCommutative,
        isAssociative: isAssociative,
        mergeContext: mergeContext,
        flatten: flatten,
        allChildren: allChildren,
        unflattenr: unflattenr,
        unflattenl: unflattenl,
        defaultContext: defaultContext,
        realContext: realContext,
        positiveContext: positiveContext
    };
});




var $3dfbe01631e49847$var$name = "simplify";
var $3dfbe01631e49847$var$dependencies = [
    "config",
    "typed",
    "parse",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "isZero",
    "equal",
    "resolve",
    "simplifyConstant",
    "simplifyCore",
    "?fraction",
    "?bignumber",
    "mathWithTransform",
    "matrix",
    "AccessorNode",
    "ArrayNode",
    "ConstantNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "ParenthesisNode",
    "SymbolNode"
];
var $3dfbe01631e49847$export$5085b3a4c8276699 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($3dfbe01631e49847$var$name, $3dfbe01631e49847$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, parse: parse, add: add, subtract: subtract, multiply: multiply, divide: divide, pow: pow, isZero: isZero, equal: equal, resolve: resolve, simplifyConstant: simplifyConstant, simplifyCore: simplifyCore, fraction: fraction, bignumber: bignumber, mathWithTransform: mathWithTransform, matrix: matrix, AccessorNode: AccessorNode, ArrayNode: ArrayNode, ConstantNode: ConstantNode, FunctionNode: FunctionNode, IndexNode: IndexNode, ObjectNode: ObjectNode, OperatorNode: OperatorNode, ParenthesisNode: ParenthesisNode, SymbolNode: SymbolNode } = _ref;
    var { hasProperty: hasProperty, isCommutative: isCommutative, isAssociative: isAssociative, mergeContext: mergeContext, flatten: flatten, unflattenr: unflattenr, unflattenl: unflattenl, createMakeNodeFunction: createMakeNodeFunction, defaultContext: defaultContext, realContext: realContext, positiveContext: positiveContext } = (0, $499efa357773e5f9$export$f2206d57cebf291a)({
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    });
    /**
   * Simplify an expression tree.
   *
   * A list of rules are applied to an expression, repeating over the list until
   * no further changes are made.
   * It's possible to pass a custom set of rules to the function as second
   * argument. A rule can be specified as an object, string, or function:
   *
   *     const rules = [
   *       { l: 'n1*n3 + n2*n3', r: '(n1+n2)*n3' },
   *       'n1*n3 + n2*n3 -> (n1+n2)*n3',
   *       function (node) {
   *         // ... return a new node or return the node unchanged
   *         return node
   *       }
   *     ]
   *
   * String and object rules consist of a left and right pattern. The left is
   * used to match against the expression and the right determines what matches
   * are replaced with. The main difference between a pattern and a normal
   * expression is that variables starting with the following characters are
   * interpreted as wildcards:
   *
   * - 'n' - Matches any node [Node]
   * - 'c' - Matches a constant literal (5 or 3.2) [ConstantNode]
   * - 'cl' - Matches a constant literal; same as c [ConstantNode]
   * - 'cd' - Matches a decimal literal (5 or -3.2) [ConstantNode or unaryMinus wrapping a ConstantNode]
   * - 'ce' - Matches a constant expression (-5 or √3) [Expressions consisting of only ConstantNodes, functions, and operators]
   * - 'v' - Matches a variable; anything not matched by c (-5 or x) [Node that is not a ConstantNode]
   * - 'vl' - Matches a variable literal (x or y) [SymbolNode]
   * - 'vd' - Matches a non-decimal expression; anything not matched by cd (x or √3) [Node that is not a ConstantNode or unaryMinus that is wrapping a ConstantNode]
   * - 've' - Matches a variable expression; anything not matched by ce (x or 2x) [Expressions that contain a SymbolNode or other non-constant term]
   *
   * The default list of rules is exposed on the function as `simplify.rules`
   * and can be used as a basis to built a set of custom rules. Note that since
   * the `simplifyCore` function is in the default list of rules, by default
   * simplify will convert any function calls in the expression that have
   * operator equivalents to their operator forms.
   *
   * To specify a rule as a string, separate the left and right pattern by '->'
   * When specifying a rule as an object, the following keys are meaningful:
   * - l - the left pattern
   * - r - the right pattern
   * - s - in lieu of l and r, the string form that is broken at -> to give them
   * - repeat - whether to repeat this rule until the expression stabilizes
   * - assuming - gives a context object, as in the 'context' option to
   *     simplify. Every property in the context object must match the current
   *     context in order, or else the rule will not be applied.
   * - imposeContext - gives a context object, as in the 'context' option to
   *     simplify. Any settings specified will override the incoming context
   *     for all matches of this rule.
   *
   * For more details on the theory, see:
   *
   * - [Strategies for simplifying math expressions (Stackoverflow)](https://stackoverflow.com/questions/7540227/strategies-for-simplifying-math-expressions)
   * - [Symbolic computation - Simplification (Wikipedia)](https://en.wikipedia.org/wiki/Symbolic_computation#Simplification)
   *
   *  An optional `options` argument can be passed as last argument of `simplify`.
   *  Currently available options (defaults in parentheses):
   *  - `consoleDebug` (false): whether to write the expression being simplified
   *    and any changes to it, along with the rule responsible, to console
   *  - `context` (simplify.defaultContext): an object giving properties of
   *    each operator, which determine what simplifications are allowed. The
   *    currently meaningful properties are commutative, associative,
   *    total (whether the operation is defined for all arguments), and
   *    trivial (whether the operation applied to a single argument leaves
   *    that argument unchanged). The default context is very permissive and
   *    allows almost all simplifications. Only properties differing from
   *    the default need to be specified; the default context is used as a
   *    fallback. Additional contexts `simplify.realContext` and
   *    `simplify.positiveContext` are supplied to cause simplify to perform
   *    just simplifications guaranteed to preserve all values of the expression
   *    assuming all variables and subexpressions are real numbers or
   *    positive real numbers, respectively. (Note that these are in some cases
   *    more restrictive than the default context; for example, the default
   *    context will allow `x/x` to simplify to 1, whereas
   *    `simplify.realContext` will not, as `0/0` is not equal to 1.)
   *  - `exactFractions` (true): whether to try to convert all constants to
   *    exact rational numbers.
   *  - `fractionsLimit` (10000): when `exactFractions` is true, constants will
   *    be expressed as fractions only when both numerator and denominator
   *    are smaller than `fractionsLimit`.
   *
   * Syntax:
   *
   *     math.simplify(expr)
   *     math.simplify(expr, rules)
   *     math.simplify(expr, rules)
   *     math.simplify(expr, rules, scope)
   *     math.simplify(expr, rules, scope, options)
   *     math.simplify(expr, scope)
   *     math.simplify(expr, scope, options)
   *
   * Examples:
   *
   *     math.simplify('2 * 1 * x ^ (2 - 1)')      // Node "2 * x"
   *     math.simplify('2 * 3 * x', {x: 4})        // Node "24"
   *     const f = math.parse('2 * 1 * x ^ (2 - 1)')
   *     math.simplify(f)                          // Node "2 * x"
   *     math.simplify('0.4 * x', {}, {exactFractions: true})  // Node "x * 2 / 5"
   *     math.simplify('0.4 * x', {}, {exactFractions: false}) // Node "0.4 * x"
   *
   * See also:
   *
   *     simplifyCore, derivative, evaluate, parse, rationalize, resolve
   *
   * @param {Node | string} expr
   *            The expression to be simplified
   * @param {SimplifyRule[]} [rules]
   *            Optional list with custom rules
   * @param {Object} [scope] Optional scope with variables
   * @param {SimplifyOptions} [options] Optional configuration settings
   * @return {Node} Returns the simplified form of `expr`
   */ typed.addConversion({
        from: "Object",
        to: "Map",
        convert: (0, $ec715b2ae25daaa7$export$d49c9aa30b771d59)
    });
    var simplify = typed("simplify", {
        Node: _simplify,
        "Node, Map": (expr, scope)=>_simplify(expr, false, scope),
        "Node, Map, Object": (expr, scope, options)=>_simplify(expr, false, scope, options),
        "Node, Array": _simplify,
        "Node, Array, Map": _simplify,
        "Node, Array, Map, Object": _simplify
    });
    typed.removeConversion({
        from: "Object",
        to: "Map",
        convert: (0, $ec715b2ae25daaa7$export$d49c9aa30b771d59)
    });
    simplify.defaultContext = defaultContext;
    simplify.realContext = realContext;
    simplify.positiveContext = positiveContext;
    function removeParens(node) {
        return node.transform(function(node, path, parent) {
            return (0, $23cfe017d190638f$export$c55e3736c5721220)(node) ? removeParens(node.content) : node;
        });
    }
    // All constants that are allowed in rules
    var SUPPORTED_CONSTANTS = {
        true: true,
        false: true,
        e: true,
        i: true,
        Infinity: true,
        LN2: true,
        LN10: true,
        LOG2E: true,
        LOG10E: true,
        NaN: true,
        phi: true,
        pi: true,
        SQRT1_2: true,
        SQRT2: true,
        tau: true
    };
    // Array of strings, used to build the ruleSet.
    // Each l (left side) and r (right side) are parsed by
    // the expression parser into a node tree.
    // Left hand sides are matched to subtrees within the
    // expression to be parsed and replaced with the right
    // hand side.
    // TODO: Add support for constraints on constants (either in the form of a '=' expression or a callback [callback allows things like comparing symbols alphabetically])
    // To evaluate lhs constants for rhs constants, use: { l: 'c1+c2', r: 'c3', evaluate: 'c3 = c1 + c2' }. Multiple assignments are separated by ';' in block format.
    // It is possible to get into an infinite loop with conflicting rules
    simplify.rules = [
        simplifyCore,
        // { l: 'n+0', r: 'n' },     // simplifyCore
        // { l: 'n^0', r: '1' },     // simplifyCore
        // { l: '0*n', r: '0' },     // simplifyCore
        // { l: 'n/n', r: '1'},      // simplifyCore
        // { l: 'n^1', r: 'n' },     // simplifyCore
        // { l: '+n1', r:'n1' },     // simplifyCore
        // { l: 'n--n1', r:'n+n1' }, // simplifyCore
        {
            l: "log(e)",
            r: "1"
        },
        // temporary rules
        // Note initially we tend constants to the right because like-term
        // collection prefers the left, and we would rather collect nonconstants
        {
            s: "n-n1 -> n+-n1",
            // temporarily replace 'subtract' so we can further flatten the 'add' operator
            assuming: {
                subtract: {
                    total: true
                }
            }
        },
        {
            s: "n-n -> 0",
            // partial alternative when we can't always subtract
            assuming: {
                subtract: {
                    total: false
                }
            }
        },
        {
            s: "-(cl*v) -> v * (-cl)",
            // make non-constant terms positive
            assuming: {
                multiply: {
                    commutative: true
                },
                subtract: {
                    total: true
                }
            }
        },
        {
            s: "-(cl*v) -> (-cl) * v",
            // non-commutative version, part 1
            assuming: {
                multiply: {
                    commutative: false
                },
                subtract: {
                    total: true
                }
            }
        },
        {
            s: "-(v*cl) -> v * (-cl)",
            // non-commutative version, part 2
            assuming: {
                multiply: {
                    commutative: false
                },
                subtract: {
                    total: true
                }
            }
        },
        {
            l: "-(n1/n2)",
            r: "-n1/n2"
        },
        {
            l: "-v",
            r: "v * (-1)"
        },
        // finish making non-constant terms positive
        {
            l: "(n1 + n2)*(-1)",
            r: "n1*(-1) + n2*(-1)",
            repeat: true
        },
        // expand negations to achieve as much sign cancellation as possible
        {
            l: "n/n1^n2",
            r: "n*n1^-n2"
        },
        // temporarily replace 'divide' so we can further flatten the 'multiply' operator
        {
            l: "n/n1",
            r: "n*n1^-1"
        },
        {
            s: "(n1*n2)^n3 -> n1^n3 * n2^n3",
            assuming: {
                multiply: {
                    commutative: true
                }
            }
        },
        {
            s: "(n1*n2)^(-1) -> n2^(-1) * n1^(-1)",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        // expand nested exponentiation
        {
            s: "(n ^ n1) ^ n2 -> n ^ (n1 * n2)",
            assuming: {
                divide: {
                    total: true
                }
            } // 1/(1/n) = n needs 1/n to exist
        },
        // collect like factors; into a sum, only do this for nonconstants
        {
            l: " vd   * ( vd   * n1 + n2)",
            r: "vd^2       * n1 +  vd   * n2"
        },
        {
            s: " vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2",
            assuming: {
                divide: {
                    total: true
                }
            } // v*1/v = v^(1+-1) needs 1/v
        },
        {
            s: "vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2",
            assuming: {
                divide: {
                    total: true
                }
            }
        },
        {
            s: "vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2",
            assuming: {
                divide: {
                    total: true
                }
            }
        },
        {
            l: "n*n",
            r: "n^2"
        },
        {
            s: "n * n^n1 -> n^(n1+1)",
            assuming: {
                divide: {
                    total: true
                }
            } // n*1/n = n^(-1+1) needs 1/n
        },
        {
            s: "n^n1 * n^n2 -> n^(n1+n2)",
            assuming: {
                divide: {
                    total: true
                }
            } // ditto for n^2*1/n^2
        },
        // Unfortunately, to deal with more complicated cancellations, it
        // becomes necessary to simplify constants twice per pass. It's not
        // terribly expensive compared to matching rules, so this should not
        // pose a performance problem.
        simplifyConstant,
        // First: before collecting like terms
        // collect like terms
        {
            s: "n+n -> 2*n",
            assuming: {
                add: {
                    total: true
                }
            } // 2 = 1 + 1 needs to exist
        },
        {
            l: "n+-n",
            r: "0"
        },
        {
            l: "vd*n + vd",
            r: "vd*(n+1)"
        },
        // NOTE: leftmost position is special:
        {
            l: "n3*n1 + n3*n2",
            r: "n3*(n1+n2)"
        },
        // All sub-monomials tried there.
        {
            l: "n3^(-n4)*n1 +   n3  * n2",
            r: "n3^(-n4)*(n1 + n3^(n4+1) *n2)"
        },
        {
            l: "n3^(-n4)*n1 + n3^n5 * n2",
            r: "n3^(-n4)*(n1 + n3^(n4+n5)*n2)"
        },
        // noncommutative additional cases (term collection & factoring)
        {
            s: "n*vd + vd -> (n+1)*vd",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        {
            s: "vd + n*vd -> (1+n)*vd",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        {
            s: "n1*n3 + n2*n3 -> (n1+n2)*n3",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        {
            s: "n^n1 * n -> n^(n1+1)",
            assuming: {
                divide: {
                    total: true
                },
                multiply: {
                    commutative: false
                }
            }
        },
        {
            s: "n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        {
            s: "n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        {
            l: "n*cd + cd",
            r: "(n+1)*cd"
        },
        {
            s: "cd*n + cd -> cd*(n+1)",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        {
            s: "cd + cd*n -> cd*(1+n)",
            assuming: {
                multiply: {
                    commutative: false
                }
            }
        },
        simplifyConstant,
        // Second: before returning expressions to "standard form"
        // make factors positive (and undo 'make non-constant terms positive')
        {
            s: "(-n)*n1 -> -(n*n1)",
            assuming: {
                subtract: {
                    total: true
                }
            }
        },
        {
            s: "n1*(-n) -> -(n1*n)",
            // in case * non-commutative
            assuming: {
                subtract: {
                    total: true
                },
                multiply: {
                    commutative: false
                }
            }
        },
        // final ordering of constants
        {
            s: "ce+ve -> ve+ce",
            assuming: {
                add: {
                    commutative: true
                }
            },
            imposeContext: {
                add: {
                    commutative: false
                }
            }
        },
        {
            s: "vd*cd -> cd*vd",
            assuming: {
                multiply: {
                    commutative: true
                }
            },
            imposeContext: {
                multiply: {
                    commutative: false
                }
            }
        },
        // undo temporary rules
        // { l: '(-1) * n', r: '-n' }, // #811 added test which proved this is redundant
        {
            l: "n+-n1",
            r: "n-n1"
        },
        // undo replace 'subtract'
        {
            l: "n+-(n1)",
            r: "n-(n1)"
        },
        {
            s: "n*(n1^-1) -> n/n1",
            // undo replace 'divide'; for * commutative
            assuming: {
                multiply: {
                    commutative: true
                }
            } // o.w. / not conventional
        },
        {
            s: "n*n1^-n2 -> n/n1^n2",
            assuming: {
                multiply: {
                    commutative: true
                }
            } // o.w. / not conventional
        },
        {
            s: "n^-1 -> 1/n",
            assuming: {
                multiply: {
                    commutative: true
                }
            } // o.w. / not conventional
        },
        {
            l: "n^1",
            r: "n"
        },
        // can be produced by power cancellation
        {
            s: "n*(n1/n2) -> (n*n1)/n2",
            // '*' before '/'
            assuming: {
                multiply: {
                    associative: true
                }
            }
        },
        {
            s: "n-(n1+n2) -> n-n1-n2",
            // '-' before '+'
            assuming: {
                addition: {
                    associative: true,
                    commutative: true
                }
            }
        },
        // { l: '(n1/n2)/n3', r: 'n1/(n2*n3)' },
        // { l: '(n*n1)/(n*n2)', r: 'n1/n2' },
        // simplifyConstant can leave an extra factor of 1, which can always
        // be eliminated, since the identity always commutes
        {
            l: "1*n",
            r: "n",
            imposeContext: {
                multiply: {
                    commutative: true
                }
            }
        },
        {
            s: "n1/(n2/n3) -> (n1*n3)/n2",
            assuming: {
                multiply: {
                    associative: true
                }
            }
        },
        {
            l: "n1/(-n2)",
            r: "-n1/n2"
        }
    ];
    /**
   * Takes any rule object as allowed by the specification in simplify
   * and puts it in a standard form used by applyRule
   */ function _canonicalizeRule(ruleObject, context) {
        var newRule = {};
        if (ruleObject.s) {
            var lr = ruleObject.s.split("->");
            if (lr.length === 2) {
                newRule.l = lr[0];
                newRule.r = lr[1];
            } else throw SyntaxError("Could not parse rule: " + ruleObject.s);
        } else {
            newRule.l = ruleObject.l;
            newRule.r = ruleObject.r;
        }
        newRule.l = removeParens(parse(newRule.l));
        newRule.r = removeParens(parse(newRule.r));
        for (var prop of [
            "imposeContext",
            "repeat",
            "assuming"
        ])if (prop in ruleObject) newRule[prop] = ruleObject[prop];
        if (ruleObject.evaluate) newRule.evaluate = parse(ruleObject.evaluate);
        if (isAssociative(newRule.l, context)) {
            var nonCommutative = !isCommutative(newRule.l, context);
            var leftExpandsym;
            // Gen. the LHS placeholder used in this NC-context specific expansion rules
            if (nonCommutative) leftExpandsym = _getExpandPlaceholderSymbol();
            var makeNode = createMakeNodeFunction(newRule.l);
            var expandsym = _getExpandPlaceholderSymbol();
            newRule.expanded = {};
            newRule.expanded.l = makeNode([
                newRule.l,
                expandsym
            ]);
            // Push the expandsym into the deepest possible branch.
            // This helps to match the newRule against nodes returned from getSplits() later on.
            flatten(newRule.expanded.l, context);
            unflattenr(newRule.expanded.l, context);
            newRule.expanded.r = makeNode([
                newRule.r,
                expandsym
            ]);
            // In and for a non-commutative context, attempting with yet additional expansion rules makes
            // way for more matches cases of multi-arg expressions; such that associative rules (such as
            // 'n*n -> n^2') can be applied to exprs. such as 'a * b * b' and 'a * b * b * a'.
            if (nonCommutative) {
                // 'Non-commutative' 1: LHS (placeholder) only
                newRule.expandedNC1 = {};
                newRule.expandedNC1.l = makeNode([
                    leftExpandsym,
                    newRule.l
                ]);
                newRule.expandedNC1.r = makeNode([
                    leftExpandsym,
                    newRule.r
                ]);
                // 'Non-commutative' 2: farmost LHS and RHS placeholders
                newRule.expandedNC2 = {};
                newRule.expandedNC2.l = makeNode([
                    leftExpandsym,
                    newRule.expanded.l
                ]);
                newRule.expandedNC2.r = makeNode([
                    leftExpandsym,
                    newRule.expanded.r
                ]);
            }
        }
        return newRule;
    }
    /**
   * Parse the string array of rules into nodes
   *
   * Example syntax for rules:
   *
   * Position constants to the left in a product:
   * { l: 'n1 * c1', r: 'c1 * n1' }
   * n1 is any Node, and c1 is a ConstantNode.
   *
   * Apply difference of squares formula:
   * { l: '(n1 - n2) * (n1 + n2)', r: 'n1^2 - n2^2' }
   * n1, n2 mean any Node.
   *
   * Short hand notation:
   * 'n1 * c1 -> c1 * n1'
   */ function _buildRules(rules, context) {
        // Array of rules to be used to simplify expressions
        var ruleSet = [];
        for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var newRule = void 0;
            var ruleType = typeof rule;
            switch(ruleType){
                case "string":
                    rule = {
                        s: rule
                    };
                /* falls through */ case "object":
                    newRule = _canonicalizeRule(rule, context);
                    break;
                case "function":
                    newRule = rule;
                    break;
                default:
                    throw TypeError("Unsupported type of rule: " + ruleType);
            }
            // console.log('Adding rule: ' + rules[i])
            // console.log(newRule)
            ruleSet.push(newRule);
        }
        return ruleSet;
    }
    var _lastsym = 0;
    function _getExpandPlaceholderSymbol() {
        return new SymbolNode("_p" + _lastsym++);
    }
    function _simplify(expr, rules) {
        var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $ec715b2ae25daaa7$export$89a4bcaf5b4d37d2)();
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var debug = options.consoleDebug;
        rules = _buildRules(rules || simplify.rules, options.context);
        var res = resolve(expr, scope);
        res = removeParens(res);
        var visited = {};
        var str = res.toString({
            parenthesis: "all"
        });
        while(!visited[str]){
            visited[str] = true;
            _lastsym = 0; // counter for placeholder symbols
            var laststr = str;
            if (debug) console.log("Working on: ", str);
            for(var i = 0; i < rules.length; i++){
                var rulestr = "";
                if (typeof rules[i] === "function") {
                    res = rules[i](res, options);
                    if (debug) rulestr = rules[i].name;
                } else {
                    flatten(res, options.context);
                    res = applyRule(res, rules[i], options.context);
                    if (debug) rulestr = "".concat(rules[i].l.toString(), " -> ").concat(rules[i].r.toString());
                }
                if (debug) {
                    var newstr = res.toString({
                        parenthesis: "all"
                    });
                    if (newstr !== laststr) {
                        console.log("Applying", rulestr, "produced", newstr);
                        laststr = newstr;
                    }
                }
                /* Use left-heavy binary tree internally,
         * since custom rule functions may expect it
         */ unflattenl(res, options.context);
            }
            str = res.toString({
                parenthesis: "all"
            });
        }
        return res;
    }
    function mapRule(nodes, rule, context) {
        var resNodes = nodes;
        if (nodes) for(var i = 0; i < nodes.length; ++i){
            var newNode = applyRule(nodes[i], rule, context);
            if (newNode !== nodes[i]) {
                if (resNodes === nodes) resNodes = nodes.slice();
                resNodes[i] = newNode;
            }
        }
        return resNodes;
    }
    /**
   * Returns a simplfied form of node, or the original node if no simplification was possible.
   *
   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param  {Object | Function} rule
   * @param  {Object} context -- information about assumed properties of operators
   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} The simplified form of `expr`, or the original node if no simplification was possible.
   */ function applyRule(node, rule, context) {
        //    console.log('Entering applyRule("', rule.l.toString({parenthesis:'all'}), '->', rule.r.toString({parenthesis:'all'}), '",', node.toString({parenthesis:'all'}),')')
        // check that the assumptions for this rule are satisfied by the current
        // context:
        if (rule.assuming) {
            for(var symbol in rule.assuming)for(var property in rule.assuming[symbol]){
                if (hasProperty(symbol, property, context) !== rule.assuming[symbol][property]) return node;
            }
        }
        var mergedContext = mergeContext(rule.imposeContext, context);
        // Do not clone node unless we find a match
        var res = node;
        // First replace our child nodes with their simplified versions
        // If a child could not be simplified, applying the rule to it
        // will have no effect since the node is returned unchanged
        if (res instanceof OperatorNode || res instanceof FunctionNode) {
            var newArgs = mapRule(res.args, rule, context);
            if (newArgs !== res.args) {
                res = res.clone();
                res.args = newArgs;
            }
        } else if (res instanceof ParenthesisNode) {
            if (res.content) {
                var newContent = applyRule(res.content, rule, context);
                if (newContent !== res.content) res = new ParenthesisNode(newContent);
            }
        } else if (res instanceof ArrayNode) {
            var newItems = mapRule(res.items, rule, context);
            if (newItems !== res.items) res = new ArrayNode(newItems);
        } else if (res instanceof AccessorNode) {
            var newObj = res.object;
            if (res.object) newObj = applyRule(res.object, rule, context);
            var newIndex = res.index;
            if (res.index) newIndex = applyRule(res.index, rule, context);
            if (newObj !== res.object || newIndex !== res.index) res = new AccessorNode(newObj, newIndex);
        } else if (res instanceof IndexNode) {
            var newDims = mapRule(res.dimensions, rule, context);
            if (newDims !== res.dimensions) res = new IndexNode(newDims);
        } else if (res instanceof ObjectNode) {
            var changed = false;
            var newProps = {};
            for(var prop in res.properties){
                newProps[prop] = applyRule(res.properties[prop], rule, context);
                if (newProps[prop] !== res.properties[prop]) changed = true;
            }
            if (changed) res = new ObjectNode(newProps);
        }
        // Try to match a rule against this node
        var repl = rule.r;
        var matches = _ruleMatch(rule.l, res, mergedContext)[0];
        // If the rule is associative operator, we can try matching it while allowing additional terms.
        // This allows us to match rules like 'n+n' to the expression '(1+x)+x' or even 'x+1+x' if the operator is commutative.
        if (!matches && rule.expanded) {
            repl = rule.expanded.r;
            matches = _ruleMatch(rule.expanded.l, res, mergedContext)[0];
        }
        // Additional, non-commutative context expansion-rules
        if (!matches && rule.expandedNC1) {
            repl = rule.expandedNC1.r;
            matches = _ruleMatch(rule.expandedNC1.l, res, mergedContext)[0];
            if (!matches) {
                // Existence of NC1 implies NC2
                repl = rule.expandedNC2.r;
                matches = _ruleMatch(rule.expandedNC2.l, res, mergedContext)[0];
            }
        }
        if (matches) {
            // const before = res.toString({parenthesis: 'all'})
            // Create a new node by cloning the rhs of the matched rule
            // we keep any implicit multiplication state if relevant
            var implicit = res.implicit;
            res = repl.clone();
            if (implicit && "implicit" in repl) res.implicit = true;
            // Replace placeholders with their respective nodes without traversing deeper into the replaced nodes
            res = res.transform(function(node) {
                if (node.isSymbolNode && (0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(matches.placeholders, node.name)) return matches.placeholders[node.name].clone();
                else return node;
            });
        // const after = res.toString({parenthesis: 'all'})
        // console.log('Simplified ' + before + ' to ' + after)
        }
        if (rule.repeat && res !== node) res = applyRule(res, rule, context);
        return res;
    }
    /**
   * Get (binary) combinations of a flattened binary node
   * e.g. +(node1, node2, node3) -> [
   *        +(node1,  +(node2, node3)),
   *        +(node2,  +(node1, node3)),
   *        +(node3,  +(node1, node2))]
   *
   */ function getSplits(node, context) {
        var res = [];
        var right, rightArgs;
        var makeNode = createMakeNodeFunction(node);
        if (isCommutative(node, context)) for(var i = 0; i < node.args.length; i++){
            rightArgs = node.args.slice(0);
            rightArgs.splice(i, 1);
            right = rightArgs.length === 1 ? rightArgs[0] : makeNode(rightArgs);
            res.push(makeNode([
                node.args[i],
                right
            ]));
        }
        else // Keep order, but try all parenthesizations
        for(var _i = 1; _i < node.args.length; _i++){
            var left = node.args[0];
            if (_i > 1) left = makeNode(node.args.slice(0, _i));
            rightArgs = node.args.slice(_i);
            right = rightArgs.length === 1 ? rightArgs[0] : makeNode(rightArgs);
            res.push(makeNode([
                left,
                right
            ]));
        }
        return res;
    }
    /**
   * Returns the set union of two match-placeholders or null if there is a conflict.
   */ function mergeMatch(match1, match2) {
        var res = {
            placeholders: {}
        };
        // Some matches may not have placeholders; this is OK
        if (!match1.placeholders && !match2.placeholders) return res;
        else if (!match1.placeholders) return match2;
        else if (!match2.placeholders) return match1;
        // Placeholders with the same key must match exactly
        for(var key in match1.placeholders)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(match1.placeholders, key)) {
            res.placeholders[key] = match1.placeholders[key];
            if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(match2.placeholders, key)) {
                if (!_exactMatch(match1.placeholders[key], match2.placeholders[key])) return null;
            }
        }
        for(var _key in match2.placeholders)if ((0, $46a94b3d1146edd8$export$5a15a386532a5ea4)(match2.placeholders, _key)) res.placeholders[_key] = match2.placeholders[_key];
        return res;
    }
    /**
   * Combine two lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
   * Each list represents matches found in one child of a node.
   */ function combineChildMatches(list1, list2) {
        var res = [];
        if (list1.length === 0 || list2.length === 0) return res;
        var merged;
        for(var i1 = 0; i1 < list1.length; i1++)for(var i2 = 0; i2 < list2.length; i2++){
            merged = mergeMatch(list1[i1], list2[i2]);
            if (merged) res.push(merged);
        }
        return res;
    }
    /**
   * Combine multiple lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
   * Each list represents matches found in one child of a node.
   * Returns a list of unique matches.
   */ function mergeChildMatches(childMatches) {
        if (childMatches.length === 0) return childMatches;
        var sets = childMatches.reduce(combineChildMatches);
        var uniqueSets = [];
        var unique = {};
        for(var i = 0; i < sets.length; i++){
            var s = JSON.stringify(sets[i]);
            if (!unique[s]) {
                unique[s] = true;
                uniqueSets.push(sets[i]);
            }
        }
        return uniqueSets;
    }
    /**
   * Determines whether node matches rule.
   *
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} rule
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
   * @param {Object} context -- provides assumed properties of operators
   * @param {Boolean} isSplit -- whether we are in process of splitting an
   *                    n-ary operator node into possible binary combinations.
   *                    Defaults to false.
   * @return {Object} Information about the match, if it exists.
   */ function _ruleMatch(rule, node, context, isSplit) {
        //    console.log('Entering _ruleMatch(' + JSON.stringify(rule) + ', ' + JSON.stringify(node) + ')')
        //    console.log('rule = ' + rule)
        //    console.log('node = ' + node)
        //    console.log('Entering _ruleMatch(', rule.toString({parenthesis:'all'}), ', ', node.toString({parenthesis:'all'}), ', ', context, ')')
        var res = [
            {
                placeholders: {}
            }
        ];
        if (rule instanceof OperatorNode && node instanceof OperatorNode || rule instanceof FunctionNode && node instanceof FunctionNode) {
            // If the rule is an OperatorNode or a FunctionNode, then node must match exactly
            if (rule instanceof OperatorNode) {
                if (rule.op !== node.op || rule.fn !== node.fn) return [];
            } else if (rule instanceof FunctionNode) {
                if (rule.name !== node.name) return [];
            }
            // rule and node match. Search the children of rule and node.
            if (node.args.length === 1 && rule.args.length === 1 || !isAssociative(node, context) && node.args.length === rule.args.length || isSplit) {
                // Expect non-associative operators to match exactly,
                // except in any order if operator is commutative
                var childMatches = [];
                for(var i = 0; i < rule.args.length; i++){
                    var childMatch = _ruleMatch(rule.args[i], node.args[i], context);
                    if (childMatch.length === 0) break;
                    // The child matched, so add the information returned from the child to our result
                    childMatches.push(childMatch);
                }
                if (childMatches.length !== rule.args.length) {
                    if (!isCommutative(node, context) || // exact match in order needed
                    rule.args.length === 1) // nothing to commute
                    return [];
                    if (rule.args.length > 2) /* Need to generate all permutations and try them.
             * It's a bit complicated, and unlikely to come up since there
             * are very few ternary or higher operators. So punt for now.
             */ throw new Error("permuting >2 commutative non-associative rule arguments not yet implemented");
                    /* Exactly two arguments, try them reversed */ var leftMatch = _ruleMatch(rule.args[0], node.args[1], context);
                    if (leftMatch.length === 0) return [];
                    var rightMatch = _ruleMatch(rule.args[1], node.args[0], context);
                    if (rightMatch.length === 0) return [];
                    childMatches = [
                        leftMatch,
                        rightMatch
                    ];
                }
                res = mergeChildMatches(childMatches);
            } else if (node.args.length >= 2 && rule.args.length === 2) {
                // node is flattened, rule is not
                // Associative operators/functions can be split in different ways so we check if the rule
                // matches for each of them and return their union.
                var splits = getSplits(node, context);
                var splitMatches = [];
                for(var _i2 = 0; _i2 < splits.length; _i2++){
                    var matchSet = _ruleMatch(rule, splits[_i2], context, true); // recursing at the same tree depth here
                    splitMatches = splitMatches.concat(matchSet);
                }
                return splitMatches;
            } else if (rule.args.length > 2) throw Error("Unexpected non-binary associative function: " + rule.toString());
            else // Incorrect number of arguments in rule and node, so no match
            return [];
        } else if (rule instanceof SymbolNode) {
            // If the rule is a SymbolNode, then it carries a special meaning
            // according to the first one or two characters of the symbol node name.
            // These meanings are expalined in the documentation for simplify()
            if (rule.name.length === 0) throw new Error("Symbol in rule has 0 length...!?");
            if (SUPPORTED_CONSTANTS[rule.name]) {
                // built-in constant must match exactly
                if (rule.name !== node.name) return [];
            } else // wildcards are composed of up to two alphabetic or underscore characters
            switch(rule.name[1] >= "a" && rule.name[1] <= "z" ? rule.name.substring(0, 2) : rule.name[0]){
                case "n":
                case "_p":
                    // rule matches _anything_, so assign this node to the rule.name placeholder
                    // Assign node to the rule.name placeholder.
                    // Our parent will check for matches among placeholders.
                    res[0].placeholders[rule.name] = node;
                    break;
                case "c":
                case "cl":
                    // rule matches a ConstantNode
                    if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(node)) res[0].placeholders[rule.name] = node;
                    else // mis-match: rule does not encompass current node
                    return [];
                    break;
                case "v":
                    // rule matches anything other than a ConstantNode
                    if (!(0, $23cfe017d190638f$export$fa9d80731fd8c54b)(node)) res[0].placeholders[rule.name] = node;
                    else // mis-match: rule does not encompass current node
                    return [];
                    break;
                case "vl":
                    // rule matches VariableNode
                    if ((0, $23cfe017d190638f$export$87815d550facaed9)(node)) res[0].placeholders[rule.name] = node;
                    else // mis-match: rule does not encompass current node
                    return [];
                    break;
                case "cd":
                    // rule matches a ConstantNode or unaryMinus-wrapped ConstantNode
                    if ((0, $1c9160f94b30cbfc$export$ce146697ef73cd8f)(node)) res[0].placeholders[rule.name] = node;
                    else // mis-match: rule does not encompass current node
                    return [];
                    break;
                case "vd":
                    // rule matches anything other than a ConstantNode or unaryMinus-wrapped ConstantNode
                    if (!(0, $1c9160f94b30cbfc$export$ce146697ef73cd8f)(node)) res[0].placeholders[rule.name] = node;
                    else // mis-match: rule does not encompass current node
                    return [];
                    break;
                case "ce":
                    // rule matches expressions that have a constant value
                    if ((0, $1c9160f94b30cbfc$export$aef723aba12fcd3d)(node)) res[0].placeholders[rule.name] = node;
                    else // mis-match: rule does not encompass current node
                    return [];
                    break;
                case "ve":
                    // rule matches expressions that do not have a constant value
                    if (!(0, $1c9160f94b30cbfc$export$aef723aba12fcd3d)(node)) res[0].placeholders[rule.name] = node;
                    else // mis-match: rule does not encompass current node
                    return [];
                    break;
                default:
                    throw new Error("Invalid symbol in rule: " + rule.name);
            }
        } else if (rule instanceof ConstantNode) {
            // Literal constant must match exactly
            if (!equal(rule.value, node.value)) return [];
        } else // Some other node was encountered which we aren't prepared for, so no match
        return [];
        // It's a match!
        // console.log('_ruleMatch(' + rule.toString() + ', ' + node.toString() + ') found a match')
        return res;
    }
    /**
   * Determines whether p and q (and all their children nodes) are identical.
   *
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} p
   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} q
   * @return {Object} Information about the match, if it exists.
   */ function _exactMatch(p, q) {
        if (p instanceof ConstantNode && q instanceof ConstantNode) {
            if (!equal(p.value, q.value)) return false;
        } else if (p instanceof SymbolNode && q instanceof SymbolNode) {
            if (p.name !== q.name) return false;
        } else if (p instanceof OperatorNode && q instanceof OperatorNode || p instanceof FunctionNode && q instanceof FunctionNode) {
            if (p instanceof OperatorNode) {
                if (p.op !== q.op || p.fn !== q.fn) return false;
            } else if (p instanceof FunctionNode) {
                if (p.name !== q.name) return false;
            }
            if (p.args.length !== q.args.length) return false;
            for(var i = 0; i < p.args.length; i++){
                if (!_exactMatch(p.args[i], q.args[i])) return false;
            }
        } else return false;
        return true;
    }
    return simplify;
});






var $9fe33ce7120f4f3d$var$name = "simplifyConstant";
var $9fe33ce7120f4f3d$var$dependencies = [
    "typed",
    "config",
    "mathWithTransform",
    "matrix",
    "?fraction",
    "?bignumber",
    "AccessorNode",
    "ArrayNode",
    "ConstantNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "SymbolNode"
];
var $9fe33ce7120f4f3d$export$d72b8f0d2b277ae2 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($9fe33ce7120f4f3d$var$name, $9fe33ce7120f4f3d$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, mathWithTransform: mathWithTransform, matrix: matrix, fraction: fraction, bignumber: bignumber, AccessorNode: AccessorNode, ArrayNode: ArrayNode, ConstantNode: ConstantNode, FunctionNode: FunctionNode, IndexNode: IndexNode, ObjectNode: ObjectNode, OperatorNode: OperatorNode, SymbolNode: SymbolNode } = _ref;
    var { isCommutative: isCommutative, isAssociative: isAssociative, allChildren: allChildren, createMakeNodeFunction: createMakeNodeFunction } = (0, $499efa357773e5f9$export$f2206d57cebf291a)({
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    });
    /**
   * simplifyConstant() takes a mathjs expression (either a Node representing
   * a parse tree or a string which it parses to produce a node), and replaces
   * any subexpression of it consisting entirely of constants with the computed
   * value of that subexpression.
   *
   * Syntax:
   *
   *     math.simplifyConstant(expr)
   *     math.simplifyConstant(expr, options)
   *
   * Examples:
   *
   *     math.simplifyConstant('x + 4*3/6')  // Node "x + 2"
   *     math.simplifyConstant('z cos(0)')   // Node "z 1"
   *     math.simplifyConstant('(5.2 + 1.08)t', {exactFractions: false})  // Node "6.28 t"
   *
   * See also:
   *
   *     simplify, simplifyCore, resolve, derivative
   *
   * @param {Node | string} node
   *     The expression to be simplified
   * @param {Object} options
   *     Simplification options, as per simplify()
   * @return {Node} Returns expression with constant subexpressions evaluated
   */ var simplifyConstant = typed("simplifyConstant", {
        Node: (node)=>_ensureNode(foldFraction(node, {})),
        "Node, Object": function NodeObject(expr, options) {
            return _ensureNode(foldFraction(expr, options));
        }
    });
    function _removeFractions(thing) {
        if ((0, $23cfe017d190638f$export$e312cb8a8e5e7c34)(thing)) return thing.valueOf();
        if (thing instanceof Array) return thing.map(_removeFractions);
        if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(thing)) return matrix(_removeFractions(thing.valueOf()));
        return thing;
    }
    function _eval(fnname, args, options) {
        try {
            return mathWithTransform[fnname].apply(null, args);
        } catch (ignore) {
            // sometimes the implicit type conversion causes the evaluation to fail, so we'll try again after removing Fractions
            args = args.map(_removeFractions);
            return _toNumber(mathWithTransform[fnname].apply(null, args), options);
        }
    }
    var _toNode = typed({
        Fraction: _fractionToNode,
        number: function number(n) {
            if (n < 0) return unaryMinusNode(new ConstantNode(-n));
            return new ConstantNode(n);
        },
        BigNumber: function BigNumber(n) {
            if (n < 0) return unaryMinusNode(new ConstantNode(-n));
            return new ConstantNode(n); // old parameters: (n.toString(), 'number')
        },
        bigint: function bigint(n) {
            if (n < 0n) return unaryMinusNode(new ConstantNode(-n));
            return new ConstantNode(n);
        },
        Complex: function Complex(s) {
            throw new Error("Cannot convert Complex number to Node");
        },
        string: function string(s) {
            return new ConstantNode(s);
        },
        Matrix: function Matrix(m) {
            return new ArrayNode(m.valueOf().map((e)=>_toNode(e)));
        }
    });
    function _ensureNode(thing) {
        if ((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(thing)) return thing;
        return _toNode(thing);
    }
    // convert a number to a fraction only if it can be expressed exactly,
    // and when both numerator and denominator are small enough
    function _exactFraction(n, options) {
        var exactFractions = options && options.exactFractions !== false;
        if (exactFractions && isFinite(n) && fraction) {
            var f = fraction(n);
            var fractionsLimit = options && typeof options.fractionsLimit === "number" ? options.fractionsLimit : Infinity; // no limit by default
            if (f.valueOf() === n && f.n < fractionsLimit && f.d < fractionsLimit) return f;
        }
        return n;
    }
    // Convert numbers to a preferred number type in preference order: Fraction, number, Complex
    // BigNumbers are left alone
    var _toNumber = typed({
        "string, Object": function stringObject(s, options) {
            var numericType = (0, $a246eb207aab6d09$export$28199db5a610a1ee)(s, config);
            if (numericType === "BigNumber") {
                if (bignumber === undefined) (0, $ba7e85df6c2910bf$export$f0829713dc162a8)();
                return bignumber(s);
            } else if (numericType === "bigint") return BigInt(s);
            else if (numericType === "Fraction") {
                if (fraction === undefined) (0, $ba7e85df6c2910bf$export$9978fd42ef220ba0)();
                return fraction(s);
            } else {
                var n = parseFloat(s);
                return _exactFraction(n, options);
            }
        },
        "Fraction, Object": function FractionObject(s, options) {
            return s;
        },
        // we don't need options here
        "BigNumber, Object": function BigNumberObject(s, options) {
            return s;
        },
        // we don't need options here
        "number, Object": function numberObject(s, options) {
            return _exactFraction(s, options);
        },
        "bigint, Object": function bigintObject(s, options) {
            return s;
        },
        "Complex, Object": function ComplexObject(s, options) {
            if (s.im !== 0) return s;
            return _exactFraction(s.re, options);
        },
        "Matrix, Object": function MatrixObject(s, options) {
            return matrix(_exactFraction(s.valueOf()));
        },
        "Array, Object": function ArrayObject(s, options) {
            return s.map(_exactFraction);
        }
    });
    function unaryMinusNode(n) {
        return new OperatorNode("-", "unaryMinus", [
            n
        ]);
    }
    function _fractionToNode(f) {
        var n;
        var vn = f.s * f.n;
        if (vn < 0) n = new OperatorNode("-", "unaryMinus", [
            new ConstantNode(-vn)
        ]);
        else n = new ConstantNode(vn);
        if (f.d === 1) return n;
        return new OperatorNode("/", "divide", [
            n,
            new ConstantNode(f.d)
        ]);
    }
    /* Handles constant indexing of ArrayNodes, matrices, and ObjectNodes */ function _foldAccessor(obj, index, options) {
        if (!(0, $23cfe017d190638f$export$ff90979121a6cabc)(index)) // don't know what to do with that...
        return new AccessorNode(_ensureNode(obj), _ensureNode(index));
        if ((0, $23cfe017d190638f$export$440fa93dcf2757a3)(obj) || (0, $23cfe017d190638f$export$b22160e0a14f87b7)(obj)) {
            var remainingDims = Array.from(index.dimensions);
            /* We will resolve constant indices one at a time, looking
       * just in the first or second dimensions because (a) arrays
       * of more than two dimensions are likely rare, and (b) pulling
       * out the third or higher dimension would be pretty intricate.
       * The price is that we miss simplifying [..3d array][x,y,1]
       */ while(remainingDims.length > 0){
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(remainingDims[0]) && typeof remainingDims[0].value !== "string") {
                    var first = _toNumber(remainingDims.shift().value, options);
                    if ((0, $23cfe017d190638f$export$440fa93dcf2757a3)(obj)) obj = obj.items[first - 1];
                    else {
                        // matrix
                        obj = obj.valueOf()[first - 1];
                        if (obj instanceof Array) obj = matrix(obj);
                    }
                } else if (remainingDims.length > 1 && (0, $23cfe017d190638f$export$fa9d80731fd8c54b)(remainingDims[1]) && typeof remainingDims[1].value !== "string") {
                    var second = _toNumber(remainingDims[1].value, options);
                    var tryItems = [];
                    var fromItems = (0, $23cfe017d190638f$export$440fa93dcf2757a3)(obj) ? obj.items : obj.valueOf();
                    for (var item of fromItems){
                        if ((0, $23cfe017d190638f$export$440fa93dcf2757a3)(item)) tryItems.push(item.items[second - 1]);
                        else if ((0, $23cfe017d190638f$export$b22160e0a14f87b7)(obj)) tryItems.push(item[second - 1]);
                        else break;
                    }
                    if (tryItems.length === fromItems.length) {
                        if ((0, $23cfe017d190638f$export$440fa93dcf2757a3)(obj)) obj = new ArrayNode(tryItems);
                        else // matrix
                        obj = matrix(tryItems);
                        remainingDims.splice(1, 1);
                    } else break;
                } else break;
            }
            if (remainingDims.length === index.dimensions.length) /* No successful constant indexing */ return new AccessorNode(_ensureNode(obj), index);
            if (remainingDims.length > 0) {
                /* Indexed some but not all dimensions */ index = new IndexNode(remainingDims);
                return new AccessorNode(_ensureNode(obj), index);
            }
            /* All dimensions were constant, access completely resolved */ return obj;
        }
        if ((0, $23cfe017d190638f$export$3f18867a334658e9)(obj) && index.dimensions.length === 1 && (0, $23cfe017d190638f$export$fa9d80731fd8c54b)(index.dimensions[0])) {
            var key = index.dimensions[0].value;
            if (key in obj.properties) return obj.properties[key];
            return new ConstantNode(); // undefined
        }
        /* Don't know how to index this sort of obj, at least not with this index */ return new AccessorNode(_ensureNode(obj), index);
    }
    /*
   * Create a binary tree from a list of Fractions and Nodes.
   * Tries to fold Fractions by evaluating them until the first Node in the list is hit, so
   * `args` should be sorted to have the Fractions at the start (if the operator is commutative).
   * @param args - list of Fractions and Nodes
   * @param fn - evaluator for the binary operation evaluator that accepts two Fractions
   * @param makeNode - creates a binary OperatorNode/FunctionNode from a list of child Nodes
   * if args.length is 1, returns args[0]
   * @return - Either a Node representing a binary expression or Fraction
   */ function foldOp(fn, args, makeNode, options) {
        var first = args.shift();
        // In the following reduction, sofar always has one of the three following
        // forms: [NODE], [CONSTANT], or [NODE, CONSTANT]
        var reduction = args.reduce((sofar, next)=>{
            if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(next)) {
                var last = sofar.pop();
                if ((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(last)) return [
                    last,
                    next
                ];
                // Two constants in a row, try to fold them into one
                try {
                    sofar.push(_eval(fn, [
                        last,
                        next
                    ], options));
                    return sofar;
                } catch (ignoreandcontinue) {
                    sofar.push(last);
                // fall through to Node case
                }
            }
            // Encountered a Node, or failed folding --
            // collapse everything so far into a single tree:
            sofar.push(_ensureNode(sofar.pop()));
            var newtree = sofar.length === 1 ? sofar[0] : makeNode(sofar);
            return [
                makeNode([
                    newtree,
                    _ensureNode(next)
                ])
            ];
        }, [
            first
        ]);
        if (reduction.length === 1) return reduction[0];
        // Might end up with a tree and a constant at the end:
        return makeNode([
            reduction[0],
            _toNode(reduction[1])
        ]);
    }
    // destroys the original node and returns a folded one
    function foldFraction(node, options) {
        switch(node.type){
            case "SymbolNode":
                return node;
            case "ConstantNode":
                switch(typeof node.value){
                    case "number":
                        return _toNumber(node.value, options);
                    case "bigint":
                        return _toNumber(node.value, options);
                    case "string":
                        return node.value;
                    default:
                        if (!isNaN(node.value)) return _toNumber(node.value, options);
                }
                return node;
            case "FunctionNode":
                if (mathWithTransform[node.name] && mathWithTransform[node.name].rawArgs) return node;
                // Process operators as OperatorNode
                var operatorFunctions = [
                    "add",
                    "multiply"
                ];
                if (!operatorFunctions.includes(node.name)) {
                    var args = node.args.map((arg)=>foldFraction(arg, options));
                    // If all args are numbers
                    if (!args.some((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee))) try {
                        return _eval(node.name, args, options);
                    } catch (ignoreandcontinue) {}
                    // Size of a matrix does not depend on entries
                    if (node.name === "size" && args.length === 1 && (0, $23cfe017d190638f$export$440fa93dcf2757a3)(args[0])) {
                        var sz = [];
                        var section = args[0];
                        while((0, $23cfe017d190638f$export$440fa93dcf2757a3)(section)){
                            sz.push(section.items.length);
                            section = section.items[0];
                        }
                        return matrix(sz);
                    }
                    // Convert all args to nodes and construct a symbolic function call
                    return new FunctionNode(node.name, args.map(_ensureNode));
                }
            /* falls through */ case "OperatorNode":
                var fn = node.fn.toString();
                var _args;
                var res;
                var makeNode = createMakeNodeFunction(node);
                if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(node) && node.isUnary()) {
                    _args = [
                        foldFraction(node.args[0], options)
                    ];
                    if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(_args[0])) res = _eval(fn, _args, options);
                    else res = makeNode(_args);
                } else if (isAssociative(node, options.context)) {
                    _args = allChildren(node, options.context);
                    _args = _args.map((arg)=>foldFraction(arg, options));
                    if (isCommutative(fn, options.context)) {
                        // commutative binary operator
                        var consts = [];
                        var vars = [];
                        for(var i = 0; i < _args.length; i++)if (!(0, $23cfe017d190638f$export$8ee0fc9ee280b4ee)(_args[i])) consts.push(_args[i]);
                        else vars.push(_args[i]);
                        if (consts.length > 1) {
                            res = foldOp(fn, consts, makeNode, options);
                            vars.unshift(res);
                            res = foldOp(fn, vars, makeNode, options);
                        } else // we won't change the children order since it's not neccessary
                        res = foldOp(fn, _args, makeNode, options);
                    } else // non-commutative binary operator
                    res = foldOp(fn, _args, makeNode, options);
                } else {
                    // non-associative binary operator
                    _args = node.args.map((arg)=>foldFraction(arg, options));
                    res = foldOp(fn, _args, makeNode, options);
                }
                return res;
            case "ParenthesisNode":
                // remove the uneccessary parenthesis
                return foldFraction(node.content, options);
            case "AccessorNode":
                return _foldAccessor(foldFraction(node.object, options), foldFraction(node.index, options), options);
            case "ArrayNode":
                var foldItems = node.items.map((item)=>foldFraction(item, options));
                if (foldItems.some((0, $23cfe017d190638f$export$8ee0fc9ee280b4ee))) return new ArrayNode(foldItems.map(_ensureNode));
                /* All literals -- return a Matrix so we can operate on it */ return matrix(foldItems);
            case "IndexNode":
                return new IndexNode(node.dimensions.map((n)=>simplifyConstant(n, options)));
            case "ObjectNode":
                var foldProps = {};
                for(var prop in node.properties)foldProps[prop] = simplifyConstant(node.properties[prop], options);
                return new ObjectNode(foldProps);
            case "AssignmentNode":
            /* falls through */ case "BlockNode":
            /* falls through */ case "FunctionAssignmentNode":
            /* falls through */ case "RangeNode":
            /* falls through */ case "ConditionalNode":
            /* falls through */ default:
                throw new Error("Unimplemented node type in simplifyConstant: ".concat(node.type));
        }
    }
    return simplifyConstant;
});





var $1324636a9c0ebbd5$var$name = "simplifyCore";
var $1324636a9c0ebbd5$var$dependencies = [
    "typed",
    "parse",
    "equal",
    "isZero",
    "add",
    "subtract",
    "multiply",
    "divide",
    "pow",
    "AccessorNode",
    "ArrayNode",
    "ConstantNode",
    "FunctionNode",
    "IndexNode",
    "ObjectNode",
    "OperatorNode",
    "ParenthesisNode",
    "SymbolNode"
];
var $1324636a9c0ebbd5$export$c3d7d520703291df = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($1324636a9c0ebbd5$var$name, $1324636a9c0ebbd5$var$dependencies, (_ref)=>{
    var { typed: typed, parse: parse, equal: equal, isZero: isZero, add: add, subtract: subtract, multiply: multiply, divide: divide, pow: pow, AccessorNode: AccessorNode, ArrayNode: ArrayNode, ConstantNode: ConstantNode, FunctionNode: FunctionNode, IndexNode: IndexNode, ObjectNode: ObjectNode, OperatorNode: OperatorNode, ParenthesisNode: ParenthesisNode, SymbolNode: SymbolNode } = _ref;
    var node0 = new ConstantNode(0);
    var node1 = new ConstantNode(1);
    var nodeT = new ConstantNode(true);
    var nodeF = new ConstantNode(false);
    // test if a node will always have a boolean value (true/false)
    // not sure if this list is complete
    function isAlwaysBoolean(node) {
        return (0, $23cfe017d190638f$export$7e624cbaab6cce94)(node) && [
            "and",
            "not",
            "or"
        ].includes(node.op);
    }
    var { hasProperty: hasProperty, isCommutative: isCommutative } = (0, $499efa357773e5f9$export$f2206d57cebf291a)({
        FunctionNode: FunctionNode,
        OperatorNode: OperatorNode,
        SymbolNode: SymbolNode
    });
    /**
   * simplifyCore() performs single pass simplification suitable for
   * applications requiring ultimate performance. To roughly summarize,
   * it handles cases along the lines of simplifyConstant() but where
   * knowledge of a single argument is sufficient to determine the value.
   * In contrast, simplify() extends simplifyCore() with additional passes
   * to provide deeper simplification (such as gathering like terms).
   *
   * Specifically, simplifyCore:
   *
   * * Converts all function calls with operator equivalents to their
   *   operator forms.
   * * Removes operators or function calls that are guaranteed to have no
   *   effect (such as unary '+').
   * * Removes double unary '-', '~', and 'not'
   * * Eliminates addition/subtraction of 0 and multiplication/division/powers
   *   by 1 or 0.
   * * Converts addition of a negation into subtraction.
   * * Eliminates logical operations with constant true or false leading
   *   arguments.
   * * Puts constants on the left of a product, if multiplication is
   *   considered commutative by the options (which is the default)
   *
   * Syntax:
   *
   *     math.simplifyCore(expr)
   *     math.simplifyCore(expr, options)
   *
   * Examples:
   *
   *     const f = math.parse('2 * 1 * x ^ (1 - 0)')
   *     math.simplifyCore(f)                          // Node "2 * x"
   *     math.simplify('2 * 1 * x ^ (1 - 0)', [math.simplifyCore]) // Node "2 * x"
   *
   * See also:
   *
   *     simplify, simplifyConstant, resolve, derivative
   *
   * @param {Node | string} node
   *     The expression to be simplified
   * @param {Object} options
   *     Simplification options, as per simplify()
   * @return {Node} Returns expression with basic simplifications applied
   */ function _simplifyCore(nodeToSimplify) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var context = options ? options.context : undefined;
        if (hasProperty(nodeToSimplify, "trivial", context)) {
            // This node does nothing if it has only one argument, so if so,
            // return that argument simplified
            if ((0, $23cfe017d190638f$export$6ae03b16e064e6c4)(nodeToSimplify) && nodeToSimplify.args.length === 1) return _simplifyCore(nodeToSimplify.args[0], options);
            // For other node types, we try the generic methods
            var simpChild = false;
            var childCount = 0;
            nodeToSimplify.forEach((c)=>{
                ++childCount;
                if (childCount === 1) simpChild = _simplifyCore(c, options);
            });
            if (childCount === 1) return simpChild;
        }
        var node = nodeToSimplify;
        if ((0, $23cfe017d190638f$export$6ae03b16e064e6c4)(node)) {
            var op = (0, $c57e483ac23cf50e$export$b6e51e32101e2448)(node.name);
            if (op) {
                // Replace FunctionNode with a new OperatorNode
                if (node.args.length > 2 && hasProperty(node, "associative", context)) // unflatten into binary operations since that's what simplifyCore handles
                while(node.args.length > 2){
                    var last = node.args.pop();
                    var seclast = node.args.pop();
                    node.args.push(new OperatorNode(op, node.name, [
                        last,
                        seclast
                    ]));
                }
                node = new OperatorNode(op, node.name, node.args);
            } else return new FunctionNode(_simplifyCore(node.fn), node.args.map((n)=>_simplifyCore(n, options)));
        }
        if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(node) && node.isUnary()) {
            var a0 = _simplifyCore(node.args[0], options);
            if (node.op === "~") {
                // bitwise not
                if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(a0) && a0.isUnary() && a0.op === "~") return a0.args[0];
            }
            if (node.op === "not") // logical not
            {
                if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(a0) && a0.isUnary() && a0.op === "not") {
                    // Has the effect of turning the argument into a boolean
                    // So can only eliminate the double negation if
                    // the inside is already boolean
                    if (isAlwaysBoolean(a0.args[0])) return a0.args[0];
                }
            }
            var finish = true;
            if (node.op === "-") // unary minus
            {
                if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(a0)) {
                    if (a0.isBinary() && a0.fn === "subtract") {
                        node = new OperatorNode("-", "subtract", [
                            a0.args[1],
                            a0.args[0]
                        ]);
                        finish = false; // continue to process the new binary node
                    }
                    if (a0.isUnary() && a0.op === "-") return a0.args[0];
                }
            }
            if (finish) return new OperatorNode(node.op, node.fn, [
                a0
            ]);
        }
        if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(node) && node.isBinary()) {
            var _a = _simplifyCore(node.args[0], options);
            var a1 = _simplifyCore(node.args[1], options);
            if (node.op === "+") {
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(_a) && isZero(_a.value)) return a1;
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(a1) && isZero(a1.value)) return _a;
                if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(a1) && a1.isUnary() && a1.op === "-") {
                    a1 = a1.args[0];
                    node = new OperatorNode("-", "subtract", [
                        _a,
                        a1
                    ]);
                }
            }
            if (node.op === "-") {
                if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(a1) && a1.isUnary() && a1.op === "-") return _simplifyCore(new OperatorNode("+", "add", [
                    _a,
                    a1.args[0]
                ]), options);
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(_a) && isZero(_a.value)) return _simplifyCore(new OperatorNode("-", "unaryMinus", [
                    a1
                ]));
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(a1) && isZero(a1.value)) return _a;
                return new OperatorNode(node.op, node.fn, [
                    _a,
                    a1
                ]);
            }
            if (node.op === "*") {
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(_a)) {
                    if (isZero(_a.value)) return node0;
                    else if (equal(_a.value, 1)) return a1;
                }
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(a1)) {
                    if (isZero(a1.value)) return node0;
                    else if (equal(a1.value, 1)) return _a;
                    if (isCommutative(node, context)) return new OperatorNode(node.op, node.fn, [
                        a1,
                        _a
                    ], node.implicit); // constants on left
                }
                return new OperatorNode(node.op, node.fn, [
                    _a,
                    a1
                ], node.implicit);
            }
            if (node.op === "/") {
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(_a) && isZero(_a.value)) return node0;
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(a1) && equal(a1.value, 1)) return _a;
                return new OperatorNode(node.op, node.fn, [
                    _a,
                    a1
                ]);
            }
            if (node.op === "^") {
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(a1)) {
                    if (isZero(a1.value)) return node1;
                    else if (equal(a1.value, 1)) return _a;
                }
            }
            if (node.op === "and") {
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(_a)) {
                    if (_a.value) {
                        if (isAlwaysBoolean(a1)) return a1;
                        if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(a1)) return a1.value ? nodeT : nodeF;
                    } else return nodeF;
                }
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(a1)) {
                    if (a1.value) {
                        if (isAlwaysBoolean(_a)) return _a;
                    } else return nodeF;
                }
            }
            if (node.op === "or") {
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(_a)) {
                    if (_a.value) return nodeT;
                    else {
                        if (isAlwaysBoolean(a1)) return a1;
                    }
                }
                if ((0, $23cfe017d190638f$export$fa9d80731fd8c54b)(a1)) {
                    if (a1.value) return nodeT;
                    else {
                        if (isAlwaysBoolean(_a)) return _a;
                    }
                }
            }
            return new OperatorNode(node.op, node.fn, [
                _a,
                a1
            ]);
        }
        if ((0, $23cfe017d190638f$export$7e624cbaab6cce94)(node)) return new OperatorNode(node.op, node.fn, node.args.map((a)=>_simplifyCore(a, options)));
        if ((0, $23cfe017d190638f$export$440fa93dcf2757a3)(node)) return new ArrayNode(node.items.map((n)=>_simplifyCore(n, options)));
        if ((0, $23cfe017d190638f$export$f88fb19d6b9ee5cb)(node)) return new AccessorNode(_simplifyCore(node.object, options), _simplifyCore(node.index, options));
        if ((0, $23cfe017d190638f$export$ff90979121a6cabc)(node)) return new IndexNode(node.dimensions.map((n)=>_simplifyCore(n, options)));
        if ((0, $23cfe017d190638f$export$3f18867a334658e9)(node)) {
            var newProps = {};
            for(var prop in node.properties)newProps[prop] = _simplifyCore(node.properties[prop], options);
            return new ObjectNode(newProps);
        }
        // cannot simplify
        return node;
    }
    return typed($1324636a9c0ebbd5$var$name, {
        Node: _simplifyCore,
        "Node,Object": _simplifyCore
    });
});





var $ddfc1ae9257eb661$var$name = "std";
var $ddfc1ae9257eb661$var$dependencies = [
    "typed",
    "map",
    "sqrt",
    "variance"
];
var $ddfc1ae9257eb661$export$ef5049c11f391200 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($ddfc1ae9257eb661$var$name, $ddfc1ae9257eb661$var$dependencies, (_ref)=>{
    var { typed: typed, map: map, sqrt: sqrt, variance: variance } = _ref;
    var std = (0, $76f34cb06b4782d2$export$d3f0a8dda5df7afd)({
        typed: typed,
        map: map,
        sqrt: sqrt,
        variance: variance
    });
    return typed("std", {
        "...any": function any(args) {
            args = (0, $43b0d4e2cc26d017$export$75974926bb7e1bd6)(args);
            try {
                return std.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});




var $51e138bb40beeb47$var$name = "subset";
var $51e138bb40beeb47$var$dependencies = [
    "typed",
    "matrix",
    "zeros",
    "add"
];
var $51e138bb40beeb47$export$3dd4e26b0ef52fd5 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($51e138bb40beeb47$var$name, $51e138bb40beeb47$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, zeros: zeros, add: add } = _ref;
    var subset = (0, $11b312cf9e6477c6$export$d8c56e74d683bb33)({
        typed: typed,
        matrix: matrix,
        zeros: zeros,
        add: add
    });
    /**
   * Attach a transform function to math.subset
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */ return typed("subset", {
        "...any": function any(args) {
            try {
                return subset.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});





/**
 * Attach a transform function to math.sum
 * Adds a property transform containing the transform function.
 *
 * This transform changed the last `dim` parameter of function sum
 * from one-based to zero based
 */ var $a2d32751a4017581$var$name = "sum";
var $a2d32751a4017581$var$dependencies = [
    "typed",
    "config",
    "add",
    "numeric"
];
var $a2d32751a4017581$export$1b9b65ea533d42ec = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a2d32751a4017581$var$name, $a2d32751a4017581$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, add: add, numeric: numeric } = _ref;
    var sum = (0, $31556c126aadddbc$export$14d444d810bc35b5)({
        typed: typed,
        config: config,
        add: add,
        numeric: numeric
    });
    return typed($a2d32751a4017581$var$name, {
        "...any": function any(args) {
            args = (0, $43b0d4e2cc26d017$export$75974926bb7e1bd6)(args);
            try {
                return sum.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});



var $a130db95b86d5d6c$var$name = "symbolicEqual";
var $a130db95b86d5d6c$var$dependencies = [
    "parse",
    "simplify",
    "typed",
    "OperatorNode"
];
var $a130db95b86d5d6c$export$ac8cd7544d2e68af = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($a130db95b86d5d6c$var$name, $a130db95b86d5d6c$var$dependencies, (_ref)=>{
    var { parse: parse, simplify: simplify, typed: typed, OperatorNode: OperatorNode } = _ref;
    /**
   * Attempts to determine if two expressions are symbolically equal, i.e.
   * one is the result of valid algebraic manipulations on the other.
   * Currently, this simply checks if the difference of the two expressions
   * simplifies down to 0. So there are two important caveats:
   * 1. whether two expressions are symbolically equal depends on the
   *     manipulations allowed. Therefore, this function takes an optional
   *     third argument, which are the options that control the behavior
   *     as documented for the `simplify()` function.
   * 2. it is in general intractable to find the minimal simplification of
   *     an arbitrarily complicated expression. So while a `true` value
   *     of `symbolicEqual` ensures that the two expressions can be manipulated
   *     to match each other, a `false` value does not absolutely rule this out.
   *
   * Syntax:
   *
   *     math.symbolicEqual(expr1, expr2)
   *     math.symbolicEqual(expr1, expr2, options)
   *
   * Examples:
   *
   *     math.symbolicEqual('x*y', 'y*x') // Returns true
   *     math.symbolicEqual('x*y', 'y*x', {context: {multiply: {commutative: false}}}) // Returns false
   *     math.symbolicEqual('x/y', '(y*x^(-1))^(-1)') // Returns true
   *     math.symbolicEqual('abs(x)','x') // Returns false
   *     math.symbolicEqual('abs(x)','x', simplify.positiveContext) // Returns true
   *
   * See also:
   *
   *     simplify, evaluate
   *
   * @param {Node|string} expr1  The first expression to compare
   * @param {Node|string} expr2  The second expression to compare
   * @param {Object} [options] Optional option object, passed to simplify
   * @returns {boolean}
   *     Returns true if a valid manipulation making the expressions equal
   *     is found.
   */ function _symbolicEqual(e1, e2) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var diff = new OperatorNode("-", "subtract", [
            e1,
            e2
        ]);
        var simplified = simplify(diff, {}, options);
        return (0, $23cfe017d190638f$export$fa9d80731fd8c54b)(simplified) && !simplified.value;
    }
    return typed($a130db95b86d5d6c$var$name, {
        "Node, Node": _symbolicEqual,
        "Node, Node, Object": _symbolicEqual
    });
});





var $52640b20f04b52ac$var$name = "SymbolNode";
var $52640b20f04b52ac$var$dependencies = [
    "math",
    "?Unit",
    "Node"
];
var $52640b20f04b52ac$export$b9e0005fc35ab4ee = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($52640b20f04b52ac$var$name, $52640b20f04b52ac$var$dependencies, (_ref)=>{
    var { math: math, Unit: Unit, Node: Node } = _ref;
    /**
   * Check whether some name is a valueless unit like "inch".
   * @param {string} name
   * @return {boolean}
   */ function isValuelessUnit(name) {
        return Unit ? Unit.isValuelessUnit(name) : false;
    }
    class SymbolNode extends Node {
        get type() {
            return "SymbolNode";
        }
        get isSymbolNode() {
            return true;
        }
        /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */ _compile(math, argNames) {
            var name = this.name;
            if (argNames[name] === true) // this is a FunctionAssignment argument
            // (like an x when inside the expression of a function
            // assignment `f(x) = ...`)
            return function(scope, args, context) {
                return (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(args, name);
            };
            else if (name in math) return function(scope, args, context) {
                return scope.has(name) ? scope.get(name) : (0, $f59a31bcbbaa9e5a$export$87a87648a1961976)(math, name);
            };
            else {
                var isUnit = isValuelessUnit(name);
                return function(scope, args, context) {
                    return scope.has(name) ? scope.get(name) : isUnit ? new Unit(null, name) : SymbolNode.onUndefinedSymbol(name);
                };
            }
        }
        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */ forEach(callback) {
        // nothing to do, we don't have any children
        }
        /**
     * Create a new SymbolNode with children produced by the given callback.
     * Trivial since a SymbolNode has no children
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {SymbolNode} Returns a clone of the node
     */ map(callback) {
            return this.clone();
        }
        /**
     * Throws an error 'Undefined symbol {name}'
     * @param {string} name
     */ static onUndefinedSymbol(name) {
            throw new Error("Undefined symbol " + name);
        }
        /**
     * Create a clone of this node, a shallow copy
     * @return {SymbolNode}
     */ clone() {
            return new SymbolNode(this.name);
        }
        /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toString(options) {
            return this.name;
        }
        /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toHTML(options) {
            var name = (0, $1b038b7ade911d0e$export$4e7f196112fea3c5)(this.name);
            if (name === "true" || name === "false") return '<span class="math-symbol math-boolean">' + name + "</span>";
            else if (name === "i") return '<span class="math-symbol math-imaginary-symbol">' + name + "</span>";
            else if (name === "Infinity") return '<span class="math-symbol math-infinity-symbol">' + name + "</span>";
            else if (name === "NaN") return '<span class="math-symbol math-nan-symbol">' + name + "</span>";
            else if (name === "null") return '<span class="math-symbol math-null-symbol">' + name + "</span>";
            else if (name === "undefined") return '<span class="math-symbol math-undefined-symbol">' + name + "</span>";
            return '<span class="math-symbol">' + name + "</span>";
        }
        /**
     * Get a JSON representation of the node
     * @returns {Object}
     */ toJSON() {
            return {
                mathjs: "SymbolNode",
                name: this.name
            };
        }
        /**
     * Instantiate a SymbolNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "SymbolNode", name: "x"}`,
     *                       where mathjs is optional
     * @returns {SymbolNode}
     */ static fromJSON(json) {
            return new SymbolNode(json.name);
        }
        /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     * @override
     */ _toTex(options) {
            var isUnit = false;
            if (typeof math[this.name] === "undefined" && isValuelessUnit(this.name)) isUnit = true;
            var symbol = (0, $a279f526ff78ebb8$export$358d3bb1a752ff)(this.name, isUnit);
            if (symbol[0] === "\\") // no space needed if the symbol starts with '\'
            return symbol;
            // the space prevents symbols from breaking stuff like '\cdot'
            // if it's written right before the symbol
            return " " + symbol;
        }
        /**
     * @constructor SymbolNode
     * @extends {Node}
     * A symbol node can hold and resolve a symbol
     * @param {string} name
     * @extends {Node}
     */ constructor(name){
            super();
            // validate input
            if (typeof name !== "string") throw new TypeError('String expected for parameter "name"');
            this.name = name;
        }
    }
    return SymbolNode;
}, {
    isClass: true,
    isNode: true
});





var $0f925a7f89daa7c9$var$name = "variance";
var $0f925a7f89daa7c9$var$dependencies = [
    "typed",
    "add",
    "subtract",
    "multiply",
    "divide",
    "apply",
    "isNaN"
];
var $0f925a7f89daa7c9$export$8ab5ca08ecd18ef3 = /* #__PURE__ */ (0, $a690df4b5d23d55b$export$e9008f2713103c6c)($0f925a7f89daa7c9$var$name, $0f925a7f89daa7c9$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, subtract: subtract, multiply: multiply, divide: divide, apply: apply, isNaN: isNaN } = _ref;
    var variance = (0, $97b420845d05c5d5$export$b989221824390fb)({
        typed: typed,
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide,
        apply: apply,
        isNaN: isNaN
    });
    return typed($0f925a7f89daa7c9$var$name, {
        "...any": function any(args) {
            args = (0, $43b0d4e2cc26d017$export$75974926bb7e1bd6)(args);
            try {
                return variance.apply(null, args);
            } catch (err) {
                throw (0, $9792df5d0777eb88$export$1b927030cd80a31b)(err);
            }
        }
    });
}, {
    isTransformFunction: true
});




var $643045f4d8893607$var$math = {}; // NOT pure!
var $643045f4d8893607$var$mathWithTransform = {}; // NOT pure!
var $643045f4d8893607$var$classes = {}; // NOT pure!
var $643045f4d8893607$export$85c928794f8d04d4 = (0, $715716079f2326b7$export$270e7ba5936d3c48)({
    mathWithTransform: $643045f4d8893607$var$mathWithTransform
});
var $643045f4d8893607$export$b70fa93b5fbdd997 = (0, $3166ae3469ea536e$export$385a7f4e27f173c4)({
    Node: $643045f4d8893607$export$85c928794f8d04d4
});
var $643045f4d8893607$export$cd498840ad265e90 = (0, $8867bbe30748af52$export$aa95756bacab93d)({
    Node: $643045f4d8893607$export$85c928794f8d04d4
});
var $643045f4d8893607$export$dbdb6279b6a3bac9 = (0, $64021b24de3dfb3e$export$9bf5d3d4ef922b0c)({
    Node: $643045f4d8893607$export$85c928794f8d04d4
});
var $643045f4d8893607$export$a4d9a8de1ded3461 = (0, $12a7d4387caa5292$export$92a3c2dff1e32f25)({
    Node: $643045f4d8893607$export$85c928794f8d04d4
});
var $643045f4d8893607$export$97d96bf9b84874d5 = (0, $a0b5f232970dc845$export$c4666c772dc9bece)({
    Node: $643045f4d8893607$export$85c928794f8d04d4
});
var $643045f4d8893607$export$ec7b1e3e36733ff3 = (0, $2988b61d80f6fa92$export$850df8ca0896c9ef)({
    Node: $643045f4d8893607$export$85c928794f8d04d4,
    ResultSet: $209b60385dcf2884$export$aebd5179ff543a90
});
var $643045f4d8893607$export$8e402c64e6081013 = (0, $c3c30838c78cb182$export$401636051e48ab09)({
    Node: $643045f4d8893607$export$85c928794f8d04d4
});
var $643045f4d8893607$export$3166e8715d58cf9a = (0, $45e3119513fd120b$export$70fc17189bb5117e)({
    Node: $643045f4d8893607$export$85c928794f8d04d4
});
var $643045f4d8893607$export$d0e9917d83c120a0 = (0, $de26fa0fce424851$export$fb6d9b21e29b8d46)({
    Node: $643045f4d8893607$export$85c928794f8d04d4
});
var $643045f4d8893607$export$63698c10df99509c = (0, $cb7ee8b7cdf26845$export$288f43fef560974b)({
    classes: $643045f4d8893607$var$classes
});
var $643045f4d8893607$export$f18d5acc27d70423 = (0, $3a4f492ee0d3ca45$export$1aeed9ab2df4999f)({
    math: $643045f4d8893607$var$math,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$446a68c3fb943f17 = (0, $0fee188404352d0b$export$fd037c04876b4924)({
    Node: $643045f4d8893607$export$85c928794f8d04d4,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$e08e3b67e392101e = (0, $0049980c99ed0f79$export$3ffb1c732bc8392d)({
    Chain: $643045f4d8893607$export$f18d5acc27d70423,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$929eaad981940a63 = (0, $8058fec22ef027de$export$883b7fdc0499e9f0)({
    Node: $643045f4d8893607$export$85c928794f8d04d4,
    size: $209b60385dcf2884$export$346677f925de839c
});
var $643045f4d8893607$export$c3248ebc7ade74c5 = (0, $cbdb93e4bf22ecad$export$a21116b1766eb74)({
    Node: $643045f4d8893607$export$85c928794f8d04d4,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71
});
var $643045f4d8893607$export$a144098e31f7b52f = (0, $a878721819780eba$export$1461ecd49f170d54)({
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    Node: $643045f4d8893607$export$85c928794f8d04d4,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71
});
var $643045f4d8893607$export$93b6424aaa42dda7 = (0, $52640b20f04b52ac$export$b9e0005fc35ab4ee)({
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    Node: $643045f4d8893607$export$85c928794f8d04d4,
    math: $643045f4d8893607$var$math
});
var $643045f4d8893607$export$f2972be796679c12 = (0, $39afce01eb92a424$export$d03e7338a74cdf4c)({
    Node: $643045f4d8893607$export$85c928794f8d04d4,
    SymbolNode: $643045f4d8893607$export$93b6424aaa42dda7,
    math: $643045f4d8893607$var$math
});
var $643045f4d8893607$export$98e6a39c04603d36 = (0, $22451ab470938039$export$fef7a8850e50b7)({
    AccessorNode: $643045f4d8893607$export$c3248ebc7ade74c5,
    ArrayNode: $643045f4d8893607$export$97d96bf9b84874d5,
    AssignmentNode: $643045f4d8893607$export$a144098e31f7b52f,
    BlockNode: $643045f4d8893607$export$ec7b1e3e36733ff3,
    ConditionalNode: $643045f4d8893607$export$8e402c64e6081013,
    ConstantNode: $643045f4d8893607$export$3166e8715d58cf9a,
    FunctionAssignmentNode: $643045f4d8893607$export$446a68c3fb943f17,
    FunctionNode: $643045f4d8893607$export$f2972be796679c12,
    IndexNode: $643045f4d8893607$export$929eaad981940a63,
    ObjectNode: $643045f4d8893607$export$b70fa93b5fbdd997,
    OperatorNode: $643045f4d8893607$export$cd498840ad265e90,
    ParenthesisNode: $643045f4d8893607$export$dbdb6279b6a3bac9,
    RangeNode: $643045f4d8893607$export$d0e9917d83c120a0,
    RelationalNode: $643045f4d8893607$export$a4d9a8de1ded3461,
    SymbolNode: $643045f4d8893607$export$93b6424aaa42dda7,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$f7ad0328861e2f03 = (0, $97eacd48883b17c3$export$de059f4622c7c2ca)({
    ConstantNode: $643045f4d8893607$export$3166e8715d58cf9a,
    FunctionNode: $643045f4d8893607$export$f2972be796679c12,
    OperatorNode: $643045f4d8893607$export$cd498840ad265e90,
    ParenthesisNode: $643045f4d8893607$export$dbdb6279b6a3bac9,
    parse: $643045f4d8893607$export$98e6a39c04603d36,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$56b094f5057dd94c = (0, $9fe33ce7120f4f3d$export$d72b8f0d2b277ae2)({
    bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
    fraction: $209b60385dcf2884$export$7f34ce79760854f7,
    AccessorNode: $643045f4d8893607$export$c3248ebc7ade74c5,
    ArrayNode: $643045f4d8893607$export$97d96bf9b84874d5,
    ConstantNode: $643045f4d8893607$export$3166e8715d58cf9a,
    FunctionNode: $643045f4d8893607$export$f2972be796679c12,
    IndexNode: $643045f4d8893607$export$929eaad981940a63,
    ObjectNode: $643045f4d8893607$export$b70fa93b5fbdd997,
    OperatorNode: $643045f4d8893607$export$cd498840ad265e90,
    SymbolNode: $643045f4d8893607$export$93b6424aaa42dda7,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    mathWithTransform: $643045f4d8893607$var$mathWithTransform,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$ef7acd7185315e22 = (0, $0a0482ee1e2bb1a2$export$6c15201c8dbd106f)({
    parse: $643045f4d8893607$export$98e6a39c04603d36,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$ddd27c5929ee7e34 = (0, $1324636a9c0ebbd5$export$c3d7d520703291df)({
    AccessorNode: $643045f4d8893607$export$c3248ebc7ade74c5,
    ArrayNode: $643045f4d8893607$export$97d96bf9b84874d5,
    ConstantNode: $643045f4d8893607$export$3166e8715d58cf9a,
    FunctionNode: $643045f4d8893607$export$f2972be796679c12,
    IndexNode: $643045f4d8893607$export$929eaad981940a63,
    ObjectNode: $643045f4d8893607$export$b70fa93b5fbdd997,
    OperatorNode: $643045f4d8893607$export$cd498840ad265e90,
    ParenthesisNode: $643045f4d8893607$export$dbdb6279b6a3bac9,
    SymbolNode: $643045f4d8893607$export$93b6424aaa42dda7,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    isZero: $209b60385dcf2884$export$c46ec7d82fb1f602,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    parse: $643045f4d8893607$export$98e6a39c04603d36,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$fef61f332f2c0afc = (0, $59cf63bca65202ff$export$4f825d0ade64f616)({
    parse: $643045f4d8893607$export$98e6a39c04603d36,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$1be7516c0280bee8 = (0, $bf30539058880d96$export$704346eb22eef29)({
    evaluate: $643045f4d8893607$export$fef61f332f2c0afc
});
var $643045f4d8893607$export$7acfa6ed01010e37 = (0, $382dc69211195f35$export$17c8a99aaef91654)({
    evaluate: $643045f4d8893607$export$fef61f332f2c0afc
});
var $643045f4d8893607$export$798b53621063651 = (0, $3dfbe01631e49847$export$5085b3a4c8276699)({
    bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
    fraction: $209b60385dcf2884$export$7f34ce79760854f7,
    AccessorNode: $643045f4d8893607$export$c3248ebc7ade74c5,
    ArrayNode: $643045f4d8893607$export$97d96bf9b84874d5,
    ConstantNode: $643045f4d8893607$export$3166e8715d58cf9a,
    FunctionNode: $643045f4d8893607$export$f2972be796679c12,
    IndexNode: $643045f4d8893607$export$929eaad981940a63,
    ObjectNode: $643045f4d8893607$export$b70fa93b5fbdd997,
    OperatorNode: $643045f4d8893607$export$cd498840ad265e90,
    ParenthesisNode: $643045f4d8893607$export$dbdb6279b6a3bac9,
    SymbolNode: $643045f4d8893607$export$93b6424aaa42dda7,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    isZero: $209b60385dcf2884$export$c46ec7d82fb1f602,
    mathWithTransform: $643045f4d8893607$var$mathWithTransform,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    parse: $643045f4d8893607$export$98e6a39c04603d36,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    resolve: $643045f4d8893607$export$f7ad0328861e2f03,
    simplifyConstant: $643045f4d8893607$export$56b094f5057dd94c,
    simplifyCore: $643045f4d8893607$export$ddd27c5929ee7e34,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$31543a561a829288 = (0, $a130db95b86d5d6c$export$ac8cd7544d2e68af)({
    OperatorNode: $643045f4d8893607$export$cd498840ad265e90,
    parse: $643045f4d8893607$export$98e6a39c04603d36,
    simplify: $643045f4d8893607$export$798b53621063651,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$c30bea1139d4d8ed = (0, $a921f5472e44b7b2$export$38658a33c7766170)({
    parse: $643045f4d8893607$export$98e6a39c04603d36,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$8f49e4af10703ce3 = (0, $fcf874745ae18340$export$88a1156fad04455f)({
    Parser: $643045f4d8893607$export$7acfa6ed01010e37,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$725d762cc154d53 = (0, $c072013d25c4273c$export$abd0968f5b11b2a8)({
    bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
    fraction: $209b60385dcf2884$export$7f34ce79760854f7,
    AccessorNode: $643045f4d8893607$export$c3248ebc7ade74c5,
    ArrayNode: $643045f4d8893607$export$97d96bf9b84874d5,
    ConstantNode: $643045f4d8893607$export$3166e8715d58cf9a,
    FunctionNode: $643045f4d8893607$export$f2972be796679c12,
    IndexNode: $643045f4d8893607$export$929eaad981940a63,
    ObjectNode: $643045f4d8893607$export$b70fa93b5fbdd997,
    OperatorNode: $643045f4d8893607$export$cd498840ad265e90,
    ParenthesisNode: $643045f4d8893607$export$dbdb6279b6a3bac9,
    SymbolNode: $643045f4d8893607$export$93b6424aaa42dda7,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    isZero: $209b60385dcf2884$export$c46ec7d82fb1f602,
    mathWithTransform: $643045f4d8893607$var$mathWithTransform,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    parse: $643045f4d8893607$export$98e6a39c04603d36,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    simplify: $643045f4d8893607$export$798b53621063651,
    simplifyConstant: $643045f4d8893607$export$56b094f5057dd94c,
    simplifyCore: $643045f4d8893607$export$ddd27c5929ee7e34,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$42645bbd8ddfc464 = (0, $85667ebfd6fe4be4$export$d1d6fcabea5d55e0)({
    ConstantNode: $643045f4d8893607$export$3166e8715d58cf9a,
    FunctionNode: $643045f4d8893607$export$f2972be796679c12,
    OperatorNode: $643045f4d8893607$export$cd498840ad265e90,
    ParenthesisNode: $643045f4d8893607$export$dbdb6279b6a3bac9,
    SymbolNode: $643045f4d8893607$export$93b6424aaa42dda7,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    isZero: $209b60385dcf2884$export$c46ec7d82fb1f602,
    numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
    parse: $643045f4d8893607$export$98e6a39c04603d36,
    simplify: $643045f4d8893607$export$798b53621063651,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
var $643045f4d8893607$export$34512e3b2db52a4e = (0, $b802e3b500458322$export$cbe80567b8b3b8ac)({
    Help: $643045f4d8893607$export$1be7516c0280bee8,
    mathWithTransform: $643045f4d8893607$var$mathWithTransform,
    typed: $209b60385dcf2884$export$519f616c41a1c711
});
(0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))($643045f4d8893607$var$math, {
    e: $209b60385dcf2884$export$f1e1789686576879,
    false: (0, $209b60385dcf2884$export$f650004d56f90c2a),
    fineStructure: $209b60385dcf2884$export$5c15dd8d2782cbd0,
    i: $209b60385dcf2884$export$23f2a1d2818174ef,
    Infinity: (0, $209b60385dcf2884$export$20607595d292e7d3),
    LN10: $209b60385dcf2884$export$c44341d65988fdd6,
    LOG10E: $209b60385dcf2884$export$5ed2c057bd191c66,
    NaN: (0, $209b60385dcf2884$export$14edd9ca775dcd61),
    null: (0, $209b60385dcf2884$export$a2cbb38cda512d16),
    phi: $209b60385dcf2884$export$324943737027944a,
    SQRT1_2: $209b60385dcf2884$export$83247d8be11c091e,
    sackurTetrode: $209b60385dcf2884$export$a7100dcd4c5af6d4,
    tau: $209b60385dcf2884$export$a4b4b4d4d776fe92,
    true: (0, $209b60385dcf2884$export$93f71dfe5e50cd3e),
    "E": (0, $209b60385dcf2884$export$f1e1789686576879),
    version: $209b60385dcf2884$export$83d89fbfd8236492,
    efimovFactor: $209b60385dcf2884$export$9ea6550edaaee998,
    LN2: $209b60385dcf2884$export$578b45ddcdefa518,
    pi: $209b60385dcf2884$export$18c7bea995a110f,
    replacer: $209b60385dcf2884$export$b644b65666fe0c18,
    reviver: $643045f4d8893607$export$63698c10df99509c,
    SQRT2: $209b60385dcf2884$export$3681641e15b6e2c3,
    typed: $209b60385dcf2884$export$519f616c41a1c711,
    "PI": (0, $209b60385dcf2884$export$18c7bea995a110f),
    weakMixingAngle: $209b60385dcf2884$export$857d2e3e2bc524d0,
    abs: $209b60385dcf2884$export$2335f513bbd82c6d,
    acos: $209b60385dcf2884$export$fd6306be3fde5b04,
    acot: $209b60385dcf2884$export$4919a578c4aafd3,
    acsc: $209b60385dcf2884$export$43298db932064b4a,
    addScalar: $209b60385dcf2884$export$2b7b095c4f443355,
    arg: $209b60385dcf2884$export$d8da458ed75e15b,
    asech: $209b60385dcf2884$export$3aaf4e522be48075,
    asinh: $209b60385dcf2884$export$839d8a01b6af4fc0,
    atan: $209b60385dcf2884$export$628dc4eed22b0fbd,
    atanh: $209b60385dcf2884$export$21ea955025ceb08b,
    bigint: $209b60385dcf2884$export$a0f65b52274bcc00,
    bitNot: $209b60385dcf2884$export$aabc449fa5b5f4c0,
    boolean: $209b60385dcf2884$export$4a21f16c33752377,
    clone: $209b60385dcf2884$export$9cd59f9826255e47,
    combinations: $209b60385dcf2884$export$bdfcf4c6b5766439,
    complex: $209b60385dcf2884$export$83a0e34f1302825b,
    conj: $209b60385dcf2884$export$fb254c661fe9c0db,
    cos: $209b60385dcf2884$export$50d414a77b60d802,
    cot: $209b60385dcf2884$export$ef569ec50496610c,
    csc: $209b60385dcf2884$export$a830b5ed334924be,
    cube: $209b60385dcf2884$export$2b0340f6c7dec49a,
    equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
    erf: $209b60385dcf2884$export$d3896f355fc09423,
    exp: $209b60385dcf2884$export$b310ec824aaee37f,
    expm1: $209b60385dcf2884$export$b6c0a80d46d3391d,
    filter: $209b60385dcf2884$export$3dea766d36a8935f,
    forEach: $209b60385dcf2884$export$4b80e395e36b5a56,
    format: $209b60385dcf2884$export$d9468344d3651243,
    getMatrixDataType: $209b60385dcf2884$export$42c7d1d712906e32,
    hex: $209b60385dcf2884$export$834dfc94dde4b3d8,
    im: $209b60385dcf2884$export$5fc500b917996661,
    isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
    isNegative: $209b60385dcf2884$export$d0909a4f38b5c4d0,
    isPositive: $209b60385dcf2884$export$7e69d4236fcc3b19,
    isZero: $209b60385dcf2884$export$c46ec7d82fb1f602,
    LOG2E: $209b60385dcf2884$export$8c2c65adacba8d14,
    lgamma: $209b60385dcf2884$export$3daae2744d8ce460,
    log10: $209b60385dcf2884$export$75e08744a3ff8516,
    log2: $209b60385dcf2884$export$b9fae0bba9d9094d,
    map: $209b60385dcf2884$export$871de8747c9eaa88,
    multiplyScalar: $209b60385dcf2884$export$c697bed75648cdb7,
    not: $209b60385dcf2884$export$6003a5f097c73977,
    number: $209b60385dcf2884$export$98e628dec113755e,
    oct: $209b60385dcf2884$export$8d9f5ae1af806929,
    pickRandom: $209b60385dcf2884$export$2e015b6955893291,
    print: $209b60385dcf2884$export$c2d084dc44961371,
    random: $209b60385dcf2884$export$4385e60b38654f68,
    re: $209b60385dcf2884$export$b1f1627d659a651,
    sec: $209b60385dcf2884$export$e17a63917e2ebf0f,
    sign: $209b60385dcf2884$export$c5552dfdbc7cec71,
    sin: $209b60385dcf2884$export$5de3937cb4b592ed,
    splitUnit: $209b60385dcf2884$export$dd67294014106b35,
    square: $209b60385dcf2884$export$dd4f28cef696bc7d,
    string: $209b60385dcf2884$export$22b082955e083ec3,
    subtractScalar: $209b60385dcf2884$export$fdebd7f5d4c6e658,
    tan: $209b60385dcf2884$export$fcdd3b0b3246a325,
    typeOf: $209b60385dcf2884$export$f5bbd400c2f4426f,
    acosh: $209b60385dcf2884$export$b26caf0f29211d08,
    acsch: $209b60385dcf2884$export$eafdb403a25900df,
    apply: $209b60385dcf2884$export$5635d7ef4b8fee1c,
    asec: $209b60385dcf2884$export$ec42f46098b24bb4,
    bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
    chain: $643045f4d8893607$export$e08e3b67e392101e,
    combinationsWithRep: $209b60385dcf2884$export$f297162cf5d656b2,
    cosh: $209b60385dcf2884$export$2e2fd1ad24e4d350,
    csch: $209b60385dcf2884$export$ca7427e8bf42a21b,
    isNaN: $209b60385dcf2884$export$c9f5652083b8129d,
    isPrime: $209b60385dcf2884$export$8676dd5fabd5ee34,
    randomInt: $209b60385dcf2884$export$3c5f89dae98e900b,
    sech: $209b60385dcf2884$export$becbc39f348ea65e,
    sinh: $209b60385dcf2884$export$545004b505d7c555,
    sparse: $209b60385dcf2884$export$b6b7e189aa5d134c,
    sqrt: $209b60385dcf2884$export$eba8049fb5020b81,
    tanh: $209b60385dcf2884$export$7128670e45beef9a,
    unaryMinus: $209b60385dcf2884$export$6cd304851a69e08,
    acoth: $209b60385dcf2884$export$6faaac9ab79fd3a4,
    bin: $209b60385dcf2884$export$f03e751d9cddb7a,
    coth: $209b60385dcf2884$export$fe7b8a3b046ac25b,
    fraction: $209b60385dcf2884$export$7f34ce79760854f7,
    isNumeric: $209b60385dcf2884$export$e90fb89750dba83f,
    matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
    matrixFromFunction: $209b60385dcf2884$export$7860df605315d572,
    mode: $209b60385dcf2884$export$549ff81930776885,
    numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
    prod: $209b60385dcf2884$export$5e143010dea16c85,
    reshape: $209b60385dcf2884$export$9eaad88cf88cee2b,
    size: $209b60385dcf2884$export$346677f925de839c,
    squeeze: $209b60385dcf2884$export$889c931173b77c2f,
    transpose: $209b60385dcf2884$export$9cb09a71b7d66923,
    xgcd: $209b60385dcf2884$export$6ba103b0465fe6cc,
    zeros: $209b60385dcf2884$export$4445a00dafa2633b,
    asin: $209b60385dcf2884$export$41726bdb1fc63f,
    cbrt: $209b60385dcf2884$export$841fc4d5a1480b85,
    concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
    count: $209b60385dcf2884$export$85b9a36db797e02b,
    ctranspose: $209b60385dcf2884$export$eb6ad7870b1d0b0b,
    diag: $209b60385dcf2884$export$c042e7c2f59bc046,
    divideScalar: $209b60385dcf2884$export$67275f837d70084d,
    dotDivide: $209b60385dcf2884$export$c74f132961c51406,
    equal: $209b60385dcf2884$export$411ce8e5a71e3069,
    flatten: $209b60385dcf2884$export$bffa455ba8c619a6,
    hasNumericValue: $209b60385dcf2884$export$f6fc628e09f3ff5d,
    identity: $209b60385dcf2884$export$f0954fd7d5368655,
    kron: $209b60385dcf2884$export$44f32dfde3d58545,
    largerEq: $209b60385dcf2884$export$72693dfc692346df,
    leftShift: $209b60385dcf2884$export$48901d58d322262f,
    lsolve: $209b60385dcf2884$export$be3b83cc1aa539e4,
    matrixFromColumns: $209b60385dcf2884$export$e8999e227859a482,
    nthRoot: $209b60385dcf2884$export$cc5da69d359d7991,
    ones: $209b60385dcf2884$export$21041dee6b8001b0,
    qr: $209b60385dcf2884$export$7c27fb47516129d9,
    resize: $209b60385dcf2884$export$4380c87abf28fdf,
    rightArithShift: $209b60385dcf2884$export$a1da16976d3a5f68,
    round: $209b60385dcf2884$export$2077e0241d6afd3c,
    smaller: $209b60385dcf2884$export$3f732695c1493aec,
    subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
    to: $209b60385dcf2884$export$2c618a4308a30424,
    unaryPlus: $209b60385dcf2884$export$df8c837ae5df4ce4,
    usolve: $209b60385dcf2884$export$41828460570e21eb,
    xor: $209b60385dcf2884$export$6444ef5cd411280c,
    add: $209b60385dcf2884$export$e16d8520af44a096,
    atan2: $209b60385dcf2884$export$b8b770ee6a0d9760,
    bitAnd: $209b60385dcf2884$export$a74ff8d3fdef72fc,
    bitOr: $209b60385dcf2884$export$361eb278cc70bacf,
    bitXor: $209b60385dcf2884$export$bfcff4501301c191,
    catalan: $209b60385dcf2884$export$d8807a6c0487483a,
    compare: $209b60385dcf2884$export$398604a469f7de9a,
    compareText: $209b60385dcf2884$export$2da9287da10b19e2,
    cumsum: $209b60385dcf2884$export$71990b1e1c4912fe,
    deepEqual: $209b60385dcf2884$export$9cb4719e2e525b7a,
    diff: $209b60385dcf2884$export$a37e3c603d7117e5,
    distance: $209b60385dcf2884$export$9f17032d917177de,
    dot: $209b60385dcf2884$export$94132a0e348806d4,
    equalText: $209b60385dcf2884$export$5bc21f656fb5d284,
    floor: $209b60385dcf2884$export$a3fe094919f356fd,
    gcd: $209b60385dcf2884$export$f81847884871263e,
    hypot: $209b60385dcf2884$export$f95c7888b62f8e9a,
    larger: $209b60385dcf2884$export$a94a7414fa942aea,
    log: $209b60385dcf2884$export$bef1f36f5486a6a3,
    lsolveAll: $209b60385dcf2884$export$de5c6af4003ef448,
    matrixFromRows: $209b60385dcf2884$export$f4f4b934de52d430,
    min: $209b60385dcf2884$export$96ec731ed4dcb222,
    mod: $209b60385dcf2884$export$842a2cf37af977e1,
    multiply: $209b60385dcf2884$export$2060d2db72cce88f,
    nthRoots: $209b60385dcf2884$export$adb173527af10aca,
    or: $209b60385dcf2884$export$252bb8b3bbdf6749,
    partitionSelect: $209b60385dcf2884$export$54d1e322cf7aa273,
    rightLogShift: $209b60385dcf2884$export$502f8a5a1147da,
    slu: $209b60385dcf2884$export$95c7459688ef4e3a,
    subset: $209b60385dcf2884$export$e06bd7b1ab877a71,
    sum: $209b60385dcf2884$export$8a63f25cc62965f1,
    trace: $209b60385dcf2884$export$357889f174732d38,
    usolveAll: $209b60385dcf2884$export$c8a1cf0e83678d9,
    zpk2tf: $209b60385dcf2884$export$e4d83a2347bfd199,
    ceil: $209b60385dcf2884$export$803ce6b71a0a94b2,
    compareNatural: $209b60385dcf2884$export$762e84baec56595d,
    composition: $209b60385dcf2884$export$fd2cf6bce05a0b18,
    cross: $209b60385dcf2884$export$bb646b20bb93d339,
    det: $209b60385dcf2884$export$d063d65fed97e7fa,
    dotMultiply: $209b60385dcf2884$export$c6d93afbf4ee8afc,
    fix: $209b60385dcf2884$export$d838837eb5b184e3,
    index: $209b60385dcf2884$export$b610b8812bbcded9,
    intersect: $209b60385dcf2884$export$1f4807a235930d45,
    invmod: $209b60385dcf2884$export$5c1ba7f73c917315,
    lcm: $209b60385dcf2884$export$f686d97e407ec4ef,
    log1p: $209b60385dcf2884$export$144dcf16adfb9698,
    max: $209b60385dcf2884$export$8960430cfd85939f,
    setCartesian: $209b60385dcf2884$export$dcac7a71ff10ad82,
    setDistinct: $209b60385dcf2884$export$ec60221e756bab15,
    setIsSubset: $209b60385dcf2884$export$ca5251f59a067f9a,
    setPowerset: $209b60385dcf2884$export$f6ce4c11993e56f2,
    smallerEq: $209b60385dcf2884$export$8d38c87f33a93d98,
    sort: $209b60385dcf2884$export$97db5808d8f88186,
    unequal: $209b60385dcf2884$export$b20c1c5fa0c7dd75,
    and: $209b60385dcf2884$export$21c0ac7fe1cef1b8,
    range: $209b60385dcf2884$export$d02631cccf789723,
    row: $209b60385dcf2884$export$120ff0929b202a6d,
    setDifference: $209b60385dcf2884$export$8bd517cc5b3722f7,
    setMultiplicity: $209b60385dcf2884$export$8bb4a52260216736,
    setSymDifference: $209b60385dcf2884$export$a7eac91d5496c35b,
    column: $209b60385dcf2884$export$4e0c71f277ca26b3,
    inv: $209b60385dcf2884$export$c02accee9f2b6a8f,
    lup: $209b60385dcf2884$export$91d2d01a33a1e6f8,
    pinv: $209b60385dcf2884$export$5cde0f23b96c7c61,
    pow: $209b60385dcf2884$export$9c297f60e22e3389,
    setIntersect: $209b60385dcf2884$export$9404cfefeb010e68,
    setUnion: $209b60385dcf2884$export$667066422fa0af46,
    sqrtm: $209b60385dcf2884$export$17c7cd2216e18593,
    vacuumImpedance: $209b60385dcf2884$export$4b15dbe639ad9539,
    wienDisplacement: $209b60385dcf2884$export$2bcc1e96766dec50,
    atomicMass: $209b60385dcf2884$export$11b531e5540c3ca4,
    bohrMagneton: $209b60385dcf2884$export$c779781d69f736e8,
    boltzmann: $209b60385dcf2884$export$f727e86dcab4e2c6,
    conductanceQuantum: $209b60385dcf2884$export$6eafe330bdda8c71,
    coulomb: $209b60385dcf2884$export$2f2e110dac549211,
    deuteronMass: $209b60385dcf2884$export$80bf07f129ad1319,
    dotPow: $209b60385dcf2884$export$ef3b15136279c2ab,
    electricConstant: $209b60385dcf2884$export$11ff82822f958f25,
    elementaryCharge: $209b60385dcf2884$export$199cdfec7f52c877,
    expm: $209b60385dcf2884$export$d9bacaa51f70e8e,
    faraday: $209b60385dcf2884$export$7130fbae042d5c0f,
    fft: $209b60385dcf2884$export$a535ef183b6128fa,
    gamma: $209b60385dcf2884$export$a7ebe8cc6aaf8d37,
    gravitationConstant: $209b60385dcf2884$export$d9cccfa50756330b,
    hartreeEnergy: $209b60385dcf2884$export$37b0dd3693d47685,
    ifft: $209b60385dcf2884$export$776649b0bf8ce1fd,
    klitzing: $209b60385dcf2884$export$10054c6b64de12f5,
    loschmidt: $209b60385dcf2884$export$9eedba962d6a1c01,
    magneticConstant: $209b60385dcf2884$export$ba3f3691dd1c5a7,
    molarMass: $209b60385dcf2884$export$6d4ff429f3f89356,
    molarPlanckConstant: $209b60385dcf2884$export$dacf4a2cf8881dff,
    neutronMass: $209b60385dcf2884$export$ba7a41eda790cc15,
    nuclearMagneton: $209b60385dcf2884$export$7274fb1d27d1cd19,
    planckCharge: $209b60385dcf2884$export$9b1b4e5bc980cec6,
    planckLength: $209b60385dcf2884$export$c20ab336465d7d5e,
    planckTemperature: $209b60385dcf2884$export$5a85cd1a26c2cced,
    protonMass: $209b60385dcf2884$export$1c88a737209eb089,
    quantumOfCirculation: $209b60385dcf2884$export$5d88bfa2004001d3,
    reducedPlanckConstant: $209b60385dcf2884$export$963167ae5579ea00,
    rydberg: $209b60385dcf2884$export$683732ab8f5759dc,
    secondRadiation: $209b60385dcf2884$export$1f7c42a78c01e4f9,
    speedOfLight: $209b60385dcf2884$export$5d66ae3b3e8fce48,
    stefanBoltzmann: $209b60385dcf2884$export$f63e81544c3d56ef,
    thomsonCrossSection: $209b60385dcf2884$export$93039724ea765a8e,
    avogadro: $209b60385dcf2884$export$1236f2451dbdfd63,
    bohrRadius: $209b60385dcf2884$export$5a57f82afcc3edeb,
    createUnit: $209b60385dcf2884$export$aab44654646f3ccc,
    divide: $209b60385dcf2884$export$cd007d971a5a2143,
    electronMass: $209b60385dcf2884$export$c00fb43e712bef2c,
    factorial: $209b60385dcf2884$export$329ce89a99f0e343,
    firstRadiation: $209b60385dcf2884$export$f83f3c3b84952e0b,
    gravity: $209b60385dcf2884$export$bfb00cec0048377d,
    inverseConductanceQuantum: $209b60385dcf2884$export$f060c4f0aa5bef89,
    lusolve: $209b60385dcf2884$export$fccc724a69f253a,
    magneticFluxQuantum: $209b60385dcf2884$export$699e2a89b148c5ee,
    molarMassC12: $209b60385dcf2884$export$9589ebe123df8f2e,
    multinomial: $209b60385dcf2884$export$f4d580f3101a1c7e,
    parse: $643045f4d8893607$export$98e6a39c04603d36,
    permutations: $209b60385dcf2884$export$4567adbe5dd91621,
    planckMass: $209b60385dcf2884$export$5ce790af25e5ac75,
    polynomialRoot: $209b60385dcf2884$export$a543de521896982d,
    resolve: $643045f4d8893607$export$f7ad0328861e2f03,
    setSize: $209b60385dcf2884$export$1c70a6cc12bc0366,
    simplifyConstant: $643045f4d8893607$export$56b094f5057dd94c,
    solveODE: $209b60385dcf2884$export$877a84c9618ec845,
    stirlingS2: $209b60385dcf2884$export$a5abae3de3985f2f,
    unit: $209b60385dcf2884$export$523c0b569236b342,
    bellNumbers: $209b60385dcf2884$export$bb522a71cda46a13,
    compile: $643045f4d8893607$export$ef7acd7185315e22,
    eigs: $209b60385dcf2884$export$e822b38c59ee8a2a,
    fermiCoupling: $209b60385dcf2884$export$84a9a66802fec40,
    gasConstant: $209b60385dcf2884$export$a614e1ad972260a9,
    kldivergence: $209b60385dcf2884$export$a9fffb6ae6e33dcc,
    mean: $209b60385dcf2884$export$1ce691f85baaa52,
    molarVolume: $209b60385dcf2884$export$863459416408c428,
    planckConstant: $209b60385dcf2884$export$cbd33810258dab2e,
    quantileSeq: $209b60385dcf2884$export$ff63ee916cadcfe,
    simplifyCore: $643045f4d8893607$export$ddd27c5929ee7e34,
    variance: $209b60385dcf2884$export$9b77da0927470c3d,
    classicalElectronRadius: $209b60385dcf2884$export$f48a0c6b8cc21601,
    evaluate: $643045f4d8893607$export$fef61f332f2c0afc,
    median: $209b60385dcf2884$export$9c490b34b2f16a34,
    simplify: $643045f4d8893607$export$798b53621063651,
    symbolicEqual: $643045f4d8893607$export$31543a561a829288,
    corr: $209b60385dcf2884$export$962a8812c08af262,
    freqz: $209b60385dcf2884$export$d343cdcf8054100e,
    leafCount: $643045f4d8893607$export$c30bea1139d4d8ed,
    mad: $209b60385dcf2884$export$b14ea41a64d6efa6,
    parser: $643045f4d8893607$export$8f49e4af10703ce3,
    rationalize: $643045f4d8893607$export$725d762cc154d53,
    std: $209b60385dcf2884$export$b14c5e819cb6c927,
    zeta: $209b60385dcf2884$export$327d565dd49bd5b0,
    derivative: $643045f4d8893607$export$42645bbd8ddfc464,
    norm: $209b60385dcf2884$export$1991ecd29cc92c6b,
    rotationMatrix: $209b60385dcf2884$export$52ded331ee8b28e8,
    help: $643045f4d8893607$export$34512e3b2db52a4e,
    planckTime: $209b60385dcf2884$export$85aaf319784a5b0,
    schur: $209b60385dcf2884$export$c81e2c0e8b1065f5,
    rotate: $209b60385dcf2884$export$bb628a54ab399bc9,
    sylvester: $209b60385dcf2884$export$7f6dd94c0096067a,
    lyap: $209b60385dcf2884$export$462de2f2fa40b84,
    config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20
});
(0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))($643045f4d8893607$var$mathWithTransform, $643045f4d8893607$var$math, {
    filter: (0, $0e6efe9bf30d97e6$export$a53d7aa4a2c1e7e3)({
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    forEach: (0, $7a1b9a29380f7b7f$export$342aa09106704265)({
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    map: (0, $9e9793b56cfe2208$export$5ae33143d676d4d4)({
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    apply: (0, $effd660edd3438e3$export$1c2b553a3b99e)({
        isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    or: (0, $c9f5900e99415d04$export$fa061a00743ba4b9)({
        DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
        concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
        equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
        matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    and: (0, $745940dcea7aa6ce$export$6164f7c7c2c93691)({
        add: $209b60385dcf2884$export$e16d8520af44a096,
        concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
        equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
        matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
        not: $209b60385dcf2884$export$6003a5f097c73977,
        typed: $209b60385dcf2884$export$519f616c41a1c711,
        zeros: $209b60385dcf2884$export$4445a00dafa2633b
    }),
    concat: (0, $d1a32cb9dd365d16$export$3571c61ed942e965)({
        isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
        matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    max: (0, $c2d39629260f7044$export$cb806a795cec8077)({
        config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
        larger: $209b60385dcf2884$export$a94a7414fa942aea,
        numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    print: (0, $1925a6f6b0f193d2$export$368cdeada54b4479)({
        add: $209b60385dcf2884$export$e16d8520af44a096,
        matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
        typed: $209b60385dcf2884$export$519f616c41a1c711,
        zeros: $209b60385dcf2884$export$4445a00dafa2633b
    }),
    bitAnd: (0, $abef36f6ac0c4e01$export$64a08704539c8e93)({
        add: $209b60385dcf2884$export$e16d8520af44a096,
        concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
        equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
        matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
        not: $209b60385dcf2884$export$6003a5f097c73977,
        typed: $209b60385dcf2884$export$519f616c41a1c711,
        zeros: $209b60385dcf2884$export$4445a00dafa2633b
    }),
    diff: (0, $0e008be10e4f54a4$export$829cfcec5c5f4a9d)({
        bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
        matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
        number: $209b60385dcf2884$export$98e628dec113755e,
        subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    min: (0, $86d37de1ab9e5b6c$export$e6239917a808c35d)({
        config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
        numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
        smaller: $209b60385dcf2884$export$3f732695c1493aec,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    subset: (0, $51e138bb40beeb47$export$3dd4e26b0ef52fd5)({
        add: $209b60385dcf2884$export$e16d8520af44a096,
        matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
        typed: $209b60385dcf2884$export$519f616c41a1c711,
        zeros: $209b60385dcf2884$export$4445a00dafa2633b
    }),
    bitOr: (0, $9bda4f34af0f54cd$export$d2f720394cc4e68)({
        DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
        concat: $209b60385dcf2884$export$ee1b3e54f0441b22,
        equalScalar: $209b60385dcf2884$export$943761f5c9c3f156,
        matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    cumsum: (0, $0be9d7e7644706d7$export$3052aed7543acf3e)({
        add: $209b60385dcf2884$export$e16d8520af44a096,
        typed: $209b60385dcf2884$export$519f616c41a1c711,
        unaryPlus: $209b60385dcf2884$export$df8c837ae5df4ce4
    }),
    index: (0, $f0c30b6863882d36$export$f20e87a60dbfc89e)({
        Index: $209b60385dcf2884$export$cf17b003b6192af3,
        getMatrixDataType: $209b60385dcf2884$export$42c7d1d712906e32
    }),
    sum: (0, $a2d32751a4017581$export$1b9b65ea533d42ec)({
        add: $209b60385dcf2884$export$e16d8520af44a096,
        config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
        numeric: $209b60385dcf2884$export$b7a508fa8dae59fc,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    range: (0, $20714f3d27f9f19d$export$af4628cd15bbfbf2)({
        bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
        matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
        add: $209b60385dcf2884$export$e16d8520af44a096,
        config: $51a6b35cfb657a1d$export$e506a1d27d1eaa20,
        isPositive: $209b60385dcf2884$export$7e69d4236fcc3b19,
        larger: $209b60385dcf2884$export$a94a7414fa942aea,
        largerEq: $209b60385dcf2884$export$72693dfc692346df,
        smaller: $209b60385dcf2884$export$3f732695c1493aec,
        smallerEq: $209b60385dcf2884$export$8d38c87f33a93d98,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    row: (0, $8192fdf9fd28a197$export$649101a1e7f0c38d)({
        Index: $209b60385dcf2884$export$cf17b003b6192af3,
        matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
        range: $209b60385dcf2884$export$d02631cccf789723,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    column: (0, $cbf04e10412fb5e9$export$cb052a3b92a960e)({
        Index: $209b60385dcf2884$export$cf17b003b6192af3,
        matrix: $209b60385dcf2884$export$9bdad1ae37d738e0,
        range: $209b60385dcf2884$export$d02631cccf789723,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    mean: (0, $fca18124272cdcac$export$caaba12fb8f94b67)({
        add: $209b60385dcf2884$export$e16d8520af44a096,
        divide: $209b60385dcf2884$export$cd007d971a5a2143,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    quantileSeq: (0, $e329f13ccfcae0bd$export$b649bff65b5ade9f)({
        add: $209b60385dcf2884$export$e16d8520af44a096,
        bignumber: $209b60385dcf2884$export$8576f72eb7f14a7e,
        compare: $209b60385dcf2884$export$398604a469f7de9a,
        divide: $209b60385dcf2884$export$cd007d971a5a2143,
        isInteger: $209b60385dcf2884$export$a287f47fed4544b8,
        larger: $209b60385dcf2884$export$a94a7414fa942aea,
        multiply: $209b60385dcf2884$export$2060d2db72cce88f,
        partitionSelect: $209b60385dcf2884$export$54d1e322cf7aa273,
        smaller: $209b60385dcf2884$export$3f732695c1493aec,
        smallerEq: $209b60385dcf2884$export$8d38c87f33a93d98,
        subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    variance: (0, $0f925a7f89daa7c9$export$8ab5ca08ecd18ef3)({
        add: $209b60385dcf2884$export$e16d8520af44a096,
        apply: $209b60385dcf2884$export$5635d7ef4b8fee1c,
        divide: $209b60385dcf2884$export$cd007d971a5a2143,
        isNaN: $209b60385dcf2884$export$c9f5652083b8129d,
        multiply: $209b60385dcf2884$export$2060d2db72cce88f,
        subtract: $209b60385dcf2884$export$4e2d2ead65e5f7e3,
        typed: $209b60385dcf2884$export$519f616c41a1c711
    }),
    std: (0, $ddfc1ae9257eb661$export$ef5049c11f391200)({
        map: $209b60385dcf2884$export$871de8747c9eaa88,
        sqrt: $209b60385dcf2884$export$eba8049fb5020b81,
        typed: $209b60385dcf2884$export$519f616c41a1c711,
        variance: $209b60385dcf2884$export$9b77da0927470c3d
    })
});
(0, (/*@__PURE__*/$parcel$interopDefault($139b6f51775b1fe4$exports)))($643045f4d8893607$var$classes, {
    BigNumber: $209b60385dcf2884$export$d97aa349ed20696,
    Complex: $209b60385dcf2884$export$50ceb3fb9926e63e,
    Fraction: $209b60385dcf2884$export$b336c2702c498be5,
    Matrix: $209b60385dcf2884$export$5b12bf1653c0dd85,
    Node: $643045f4d8893607$export$85c928794f8d04d4,
    ObjectNode: $643045f4d8893607$export$b70fa93b5fbdd997,
    OperatorNode: $643045f4d8893607$export$cd498840ad265e90,
    ParenthesisNode: $643045f4d8893607$export$dbdb6279b6a3bac9,
    Range: $209b60385dcf2884$export$9a58ef0d7ad3278c,
    RelationalNode: $643045f4d8893607$export$a4d9a8de1ded3461,
    ResultSet: $209b60385dcf2884$export$aebd5179ff543a90,
    ArrayNode: $643045f4d8893607$export$97d96bf9b84874d5,
    BlockNode: $643045f4d8893607$export$ec7b1e3e36733ff3,
    ConditionalNode: $643045f4d8893607$export$8e402c64e6081013,
    ConstantNode: $643045f4d8893607$export$3166e8715d58cf9a,
    DenseMatrix: $209b60385dcf2884$export$97f0d27b48f120e8,
    RangeNode: $643045f4d8893607$export$d0e9917d83c120a0,
    Chain: $643045f4d8893607$export$f18d5acc27d70423,
    FunctionAssignmentNode: $643045f4d8893607$export$446a68c3fb943f17,
    SparseMatrix: $209b60385dcf2884$export$de9b2b7556879848,
    IndexNode: $643045f4d8893607$export$929eaad981940a63,
    ImmutableDenseMatrix: $209b60385dcf2884$export$66fe727d7ec8c7b9,
    Index: $209b60385dcf2884$export$cf17b003b6192af3,
    AccessorNode: $643045f4d8893607$export$c3248ebc7ade74c5,
    AssignmentNode: $643045f4d8893607$export$a144098e31f7b52f,
    FibonacciHeap: $209b60385dcf2884$export$dd5bb73729f20aa3,
    Spa: $209b60385dcf2884$export$6d4069f4b64f7492,
    Unit: $209b60385dcf2884$export$1d8b9ae22d404866,
    SymbolNode: $643045f4d8893607$export$93b6424aaa42dda7,
    FunctionNode: $643045f4d8893607$export$f2972be796679c12,
    Help: $643045f4d8893607$export$1be7516c0280bee8,
    Parser: $643045f4d8893607$export$7acfa6ed01010e37
});
$643045f4d8893607$export$f18d5acc27d70423.createProxy($643045f4d8893607$var$math);


class $a99e08c1609d4b55$export$3b8d474557874a1e extends (0, $db239e2e31b1c306$export$eddf153237ef6277) {
    async answer(app, answer) {
        super.answer(app, answer);
        const product = await app.model.metadata.getProductId();
        const attempt = await app.model.metadata.getAttempt();
        const current = app.current.get();
        const content = await app.content.get(current).catch(()=>undefined);
        const meta = await app.content.meta(current);
        if (content) {
            const item = content?.id ?? meta.id;
            const correct = this.isCorrect(content, answer);
            const userdata = app.userdata.set(current, item, {
                answer: answer,
                status: answer ? correct ? "correct" : "incorrect" : "unanswered"
            });
            await app.model.item.setUserData(product, attempt, item, userdata);
        }
    }
    isCorrect(content, answer) {
        switch(content.type){
            case "multiplechoice":
                return answer == content.multiplechoice.answers.filter((ans)=>ans.correct)[0]?.name;
            case "multiplecorrect":
                return JSON.stringify(answer) == JSON.stringify(content.multiplecorrect.answers.filter((ans)=>ans.correct).map((ans)=>ans.name));
            case "constructedresponse":
                return !!answer.length;
            case "numeric":
                if (answer && content.numeric.answers.minimum && content.numeric.answers.maximum) return this.compareNumeric(content.numeric.answers.minimum.text, content.numeric.answers.minimum.value, answer) <= 0 && this.compareNumeric(content.numeric.answers.maximum.text, content.numeric.answers.maximum.value, answer) >= 0;
                else if (answer && content.numeric.answers.number) return this.compareNumeric(content.numeric.answers.number.text, content.numeric.answers.number.value, answer) === 0;
                return false;
            case "cloze":
            case "matching":
            case "sorting":
                return false;
            default:
                return false;
        }
    }
    compareNumeric(referenceText, referenceValue, compareText) {
        try {
            return $209b60385dcf2884$export$398604a469f7de9a($643045f4d8893607$export$fef61f332f2c0afc(referenceText), $643045f4d8893607$export$fef61f332f2c0afc(compareText));
        } catch (ex) {
            try {
                return $209b60385dcf2884$export$398604a469f7de9a(referenceValue, $643045f4d8893607$export$fef61f332f2c0afc(compareText));
            } catch (ex) {
                try {
                    return $209b60385dcf2884$export$398604a469f7de9a(referenceValue, compareText.replace(/[^\-.0-9\/]/g, ""));
                } catch (ex) {
                    console.warn("Could not parse", compareText);
                }
            }
        }
    }
    // @ts-ignore
    finish(app) {
        app.view.item.displayFinishing("loading");
        Promise.all([
            app.model.metadata.getProductId(),
            app.model.metadata.getAttempt(),
            app.timer.total()
        ]).then((record)=>({
                product: record[0],
                attempt: record[1],
                total_time: record[2]
            })).then((record)=>app.model.item.setFinished(record.product, record.attempt, record.total_time)).then((url)=>{
            app.view.item.displayResults(url);
        }).catch(()=>{
            app.view.item.displayFinishing("error");
        });
    }
}





class $5d94f0f04b5d2e2d$export$defd2b73bdd36873 extends (0, $edbffc7b79aebee8$export$2e2bcd8739ae039) {
    _parse(item) {
        const annotations = super._parse(item);
        if (typeof item.status !== "undefined") annotations.status = item.status;
        return annotations;
    }
}


class $d516bb3554ca57c9$export$2e2bcd8739ae039 extends (0, $a0c9b220ddd06428$export$2e2bcd8739ae039) {
    static constructOverviewApp(config) {
        return (0, $3c237bc8bd3226d6$export$c85113c9ba9db03f).constructOverview($d516bb3554ca57c9$export$2e2bcd8739ae039.datasource, $d516bb3554ca57c9$export$2e2bcd8739ae039.frontend, config, undefined, {
            init: new (0, $40f3565d01dd64b1$export$77580565d3ff4cbb)()
        }, undefined, {
            userdata: new (0, $5d94f0f04b5d2e2d$export$defd2b73bdd36873)()
        });
    }
    static constructTestApp(config) {
        return (0, $3c237bc8bd3226d6$export$c85113c9ba9db03f).constructTest($d516bb3554ca57c9$export$2e2bcd8739ae039.datasource, $d516bb3554ca57c9$export$2e2bcd8739ae039.frontend, config, undefined, {
            navigation: new (0, $01753c71d857c973$export$1a1d58c8841abf19)(),
            test: new (0, $a99e08c1609d4b55$export$3b8d474557874a1e)()
        }, [
            new (0, $04d13c77c75288cb$export$71a1be2b328386f9)(),
            new (0, $6c5ea64a53f7b285$export$fb0e2bdfb5996585)(),
            new (0, $8da735eaf28ee314$export$308f1fc0e74d6ae5)(false)
        ], {
            userdata: new (0, $5d94f0f04b5d2e2d$export$defd2b73bdd36873)()
        });
    }
    static constructReviewApp(config) {
        return (0, $3c237bc8bd3226d6$export$c85113c9ba9db03f).constructReview($d516bb3554ca57c9$export$2e2bcd8739ae039.datasource, $d516bb3554ca57c9$export$2e2bcd8739ae039.frontend, config, undefined, {
            navigation: new (0, $01753c71d857c973$export$1a1d58c8841abf19)()
        }, [
            new (0, $04d13c77c75288cb$export$71a1be2b328386f9)(),
            new (0, $1eb607fce263f7a8$export$91bdca39ca9a95b7)(),
            new (0, $8da735eaf28ee314$export$308f1fc0e74d6ae5)(true)
        ], {
            userdata: new (0, $5d94f0f04b5d2e2d$export$defd2b73bdd36873)()
        });
    }
}
$d516bb3554ca57c9$export$2e2bcd8739ae039.datasource = new (0, $4a0dde927eab9818$export$a8f4da67ea307958)();
$d516bb3554ca57c9$export$2e2bcd8739ae039.frontend = new (0, $1526029269962be5$export$1de448726d519c91)();


window.Elibrary = (0, $d516bb3554ca57c9$export$2e2bcd8739ae039);
document.addEventListener("DOMContentLoaded", ()=>{
    const questionCollapse = document.querySelector(".question-list-wrap");
    if (questionCollapse) {
        questionCollapse.addEventListener("show.bs.collapse", (e)=>{
            const icon = document.querySelector(".question-collapser i");
            icon.classList.replace("fa-plus", "fa-minus");
        });
        questionCollapse.addEventListener("hide.bs.collapse", (e)=>{
            const icon = document.querySelector(".question-collapser i");
            icon.classList.replace("fa-minus", "fa-plus");
        });
    }
});
document.addEventListener("DOMContentLoaded", ()=>{
    const mobile_detect = document.querySelector("#mobile-detect");
    const is_mobile = mobile_detect ? getComputedStyle(mobile_detect).display === "none" : null;
    if (is_mobile) {
        document.querySelector(".filter-list.collapse").classList.remove("show");
        jQuery(".filter-list.collapse").collapse("hide");
        document.querySelector(".filter-collapser i").classList.replace("fa-minus", "fa-plus");
        document.querySelector(".question-list-wrap").classList.remove("show");
        jQuery(".question-list-wrap").collapse("hide");
        document.querySelector(".question-collapser i").classList.replace("fa-minus", "fa-plus");
    }
});

})();
//# sourceMappingURL=practicequestion.js.map
